export const loheQurani = [
  {
    text: "الم",
    translation: "Alif Lam Meem",
  },
  {
    text: "الر",
    translation: "Alif Lam Ra",
  },
  {
    text: "المر",
    translation: "Alif Lam Meem Ra",
  },
  {
    text: "المص",
    translation: "Alif Lam Meem Sad",
  },
  {
    text: "كهيعص",
    translation: "Kaf Ha Ya Ain Sad",
  },
  {
    text: "طه",
    translation: "Ta Ha",
  },
  {
    text: "طسم",
    translation: "Ta Seen Meem",
  },
  {
    text: "طس",
    translation: "Ta Seen",
  },
  {
    text: "يس",
    translation: "Ya Seen",
  },
  {
    text: "ص",
    translation: "Sad",
  },
  {
    text: "حم",
    translation: "Ha Meem",
  },
  {
    text: "عسق",
    translation: "Ain Seen Qaf",
  },
  {
    text: "ق",
    translation: "Qaf",
  },
  {
    text: "ن",
    translation: "Noon",
  },
];

export const surahNameArray = [
  {
    name: "",
    text: "أَعُو۟ذُ بِٱللَّهِ مِنَ ٱلشَّيۡطَٰنِ ٱلرَّجِيمِ",
    translation: "I seek refuge with Allah from the accursed Shaytan (Satan).",
    surahId: -1,
  },
  {
    name: "",
    text: "بِسۡمِ ٱللَّهِ ٱلرَّحۡمَٰنِ ٱلرَّحِيمِ",
    translation:
      "In the name of Allah, the Entirely Merciful, the Especially Merciful",
    surahId: 0,
  },
  {
    name: "الفاتحة",
    text: "ٱلۡحَمۡدُ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation: "[All] praise is [due] to Allah, Lord of the worlds",
    surahId: 1,
  },
  {
    name: "البقرة",
    text: "الٓمٓ ذَٰلِكَ ٱلۡكِتَٰبُ لَا رَيۡبَۛ فِيهِۛ هُدٗى لِّلۡمُتَّقِينَ",
    translation:
      "Alif, Lam, Meem,This is the Book about which there is no doubt, a guidance for those conscious of Allah", //Here we are skipping ALif Lam Meem Tranlation as it is already spoken from Lohe Qurani Array
    surahId: 2,
  },
  {
    name: "آل عمران",
    text: "الٓمٓ ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ٱلۡحَيُّ ٱلۡقَيُّومُ",
    translation:
      "Allah - there is no deity except Him, the Ever-Living, the Sustainer of existence",
    surahId: 3,
  },
  {
    name: "النساء",
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُواْ رَبَّكُمُ ٱلَّذِي خَلَقَكُم مِّن نَّفۡسٖ وَٰحِدَةٖ",
    translation: "O mankind, fear your Lord, who created you from one soul",
    surahId: 4,
  },
  {
    name: "المائدة",
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ أَوۡفُواْ بِٱلۡعُقُودِۚ",
    translation: "O you who have believed, fulfill [all] contracts.",
    surahId: 5,
  },
  {
    name: "الأنعام",
    text: "ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَجَعَلَ ٱلظُّلُمَٰتِ وَٱلنُّورَۖ",
    translation:
      "[All] praise is [due] to Allah, who created the heavens and the earth and made the darkness and the light.",
    surahId: 6,
  },
  {
    name: "الأعراف",
    text: "الٓمٓصٓ كِتَٰبٌ أُنزِلَ إِلَيۡكَ فَلَا يَكُن فِي صَدۡرِكَ حَرَجٞ مِّنۡهُ لِتُنذِرَ بِهِۦ وَذِكۡرَىٰ لِلۡمُؤۡمِنِينَ",
    translation:
      "Alif, Lam, Meem, Sad,[This is] a Book revealed to you, [O Muhammad] - so let there not be in your breast distress therefrom - that you may warn thereby and as a reminder to the believers",
    surahId: 7,
  },
  {
    name: "الأنفال",
    text: "يَسۡـَٔلُونَكَ عَنِ ٱلۡأَنفَالِۖ قُلِ ٱلۡأَنفَالُ لِلَّهِ وَٱلرَّسُولِۖ فَٱتَّقُواْ ٱللَّهَ وَأَصۡلِحُواْ ذَاتَ بَيۡنِكُمۡۖ وَأَطِيعُواْ ٱللَّهَ وَرَسُولَهُۥٓ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      'They ask you, [O Muhammad], about the bounties [of war]. Say, "The [decision concerning] bounties is for Allah and the Messenger." So fear Allah and amend that which is between you and obey Allah and His Messenger, if you should be believers',
    surahId: 8,
  },
  {
    name: "التوبة",
    text: "بَرَآءَةٞ مِّنَ ٱللَّهِ وَرَسُولِهِۦٓ إِلَى ٱلَّذِينَ عَٰهَدتُّم مِّنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "[This is a declaration of] disassociation, from Allah and His Messenger, to those with whom you had made a treaty among the polytheists",
    surahId: 9,
  },
  {
    name: "يونس",
    text: "الٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡحَكِيمِ",
    translation: "Alif, Lam, Ra. These are the verses of the wise Book",
    surahId: 10,
  },
  {
    name: "هود",
    text: "الٓرۚ كِتَٰبٌ أُحۡكِمَتۡ ءَايَٰتُهُۥ ثُمَّ فُصِّلَتۡ مِن لَّدُنۡ حَكِيمٍ خَبِيرٍ",
    translation:
      "Alif, Lam, Ra. [This is] a Book whose verses are perfected and then presented in detail from [one who is] Wise and Acquainted",
    surahId: 11,
  },
  {
    name: "يوسف",
    text: "الٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡمُبِينِ",
    translation: "Alif, Lam, Ra. These are the verses of the clear Book",
    surahId: 12,
  },
  {
    name: "الرعد",
    text: "الٓمٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِۗ ",
    translation: "Alif, Lam, Meem, Ra. These are the verses of the Book;",
    surahId: 13,
  },
  {
    name: "ابراهيم",
    text: "الٓرۚ كِتَٰبٌ أَنزَلۡنَٰهُ إِلَيۡكَ لِتُخۡرِجَ ٱلنَّاسَ مِنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ بِإِذۡنِ رَبِّهِمۡ إِلَىٰ صِرَٰطِ ٱلۡعَزِيزِ ٱلۡحَمِيدِ",
    translation:
      "Alif, Lam, Ra. [This is] a Book which We have revealed to you, [O Muhammad], that you might bring mankind out of darknesses into the light by permission of their Lord - to the path of the Exalted in Might, the Praiseworthy",
    surahId: 14,
  },
  {
    name: "الحجر",
    text: "الٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ وَقُرۡءَانٖ مُّبِينٖ",
    translation:
      "Alif, Lam, Ra. These are the verses of the Book and a clear Qur'an",
    surahId: 15,
  },
  {
    name: "النحل",
    text: "أَتَىٰٓ أَمۡرُ ٱللَّهِ فَلَا تَسۡتَعۡجِلُوهُۚ سُبۡحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      "The command of Allah is coming, so be not impatient for it. Exalted is He and high above what they associate with Him",
    surahId: 16,
  },
  {
    name: "الإسراء",
    text: "سُبۡحَٰنَ ٱلَّذِيٓ أَسۡرَىٰ بِعَبۡدِهِۦ لَيۡلٗا مِّنَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِ إِلَى ٱلۡمَسۡجِدِ ٱلۡأَقۡصَا",
    translation:
      "Exalted is He who took His Servant by night from al-Masjid al-Haram to al-Masjid al-Aqsa,",
    surahId: 17,
  },
  {
    name: "الكهف",
    text: "ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِيٓ أَنزَلَ عَلَىٰ عَبۡدِهِ ٱلۡكِتَٰبَ وَلَمۡ يَجۡعَل لَّهُۥ عِوَجَاۜ",
    translation:
      "[All] praise is [due] to Allah, who has sent down upon His Servant the Book and has not made therein any deviance",
    surahId: 18,
  },
  {
    name: "مريم",
    text: "كٓهيعٓصٓ ذِكۡرُ رَحۡمَتِ رَبِّكَ عَبۡدَهُۥ زَكَرِيَّآ",
    translation:
      "Kaf, Ha, Ya, 'Ayn, Sad, [This is] a mention of the mercy of your Lord to His servant Zechariah",
    surahId: 19,
  },
  {
    name: "طه",
    text: "طه مَآ أَنزَلۡنَا عَلَيۡكَ ٱلۡقُرۡءَانَ لِتَشۡقَىٰٓ",
    translation:
      "Ta, Ha, We have not sent down to you the Qur'an that you be distressed",
    surahId: 20,
  },
  {
    name: "الأنبياء",
    text: "ٱقۡتَرَبَ لِلنَّاسِ حِسَابُهُمۡ وَهُمۡ فِي غَفۡلَةٖ مُّعۡرِضُونَ",
    translation:
      "[The time of] their account has approached for the people, while they are in heedlessness turning away",
    surahId: 21,
  },
  {
    name: "الحج",
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُواْ رَبَّكُمۡۚ إِنَّ زَلۡزَلَةَ ٱلسَّاعَةِ شَيۡءٌ عَظِيمٞ",
    translation:
      "O mankind, fear your Lord. Indeed, the convulsion of the [final] Hour is a terrible thing",
    surahId: 22,
  },
  {
    name: "المؤمنون",
    text: "قَدۡ أَفۡلَحَ ٱلۡمُؤۡمِنُونَ",
    translation: "Certainly will the believers have succeeded",
    surahId: 23,
  },
  {
    name: "النور",
    text: "سُورَةٌ أَنزَلۡنَٰهَا وَفَرَضۡنَٰهَا وَأَنزَلۡنَا فِيهَآ ءَايَٰتِۭ بَيِّنَٰتٖ لَّعَلَّكُمۡ تَذَكَّرُونَ",
    translation:
      "[This is] a surah which We have sent down and made [that within it] obligatory and revealed therein verses of clear evidence that you might remember",
    surahId: 24,
  },
  {
    name: "الفرقان",
    text: "تَبَارَكَ ٱلَّذِي نَزَّلَ ٱلۡفُرۡقَانَ عَلَىٰ عَبۡدِهِۦ لِيَكُونَ لِلۡعَٰلَمِينَ نَذِيرًا",
    translation:
      "Blessed is He who sent down the Criterion upon His Servant that he may be to the worlds a warner",
    surahId: 25,
  },
  {
    name: "الشعراء",
    text: "طسٓمٓ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡمُبِينِ لَعَلَّكَ بَٰخِعٞ نَّفۡسَكَ أَلَّا يَكُونُواْ مُؤۡمِنِينَ",
    translation: "Ta, Seen, Meem,These are the verses of the clear Book",
    surahId: 26,
  },
  {
    name: "النمل",
    text: "طسٓۚ تِلۡكَ ءَايَٰتُ ٱلۡقُرۡءَانِ وَكِتَابٖ مُّبِينٍ",
    translation:
      "Ta, Seen. These are the verses of the Qur'an and a clear Book",
    surahId: 27,
  },
  {
    name: "القصص",
    text: "طسٓمٓ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡمُبِينِ نَتۡلُواْ عَلَيۡكَ مِن نَّبَإِ",
    translation:
      "Ta, Seen, Meem. These are the verses of the clear Book, We recite to you from the news",
    surahId: 28,
  },
  {
    name: "العنكبوت",
    text: "الٓمٓ أَحَسِبَ ٱلنَّاسُ أَن يُتۡرَكُوٓاْ أَن يَقُولُوٓاْ ءَامَنَّا وَهُمۡ لَا يُفۡتَنُونَ",
    translation:
      'Alif, Lam, Meem. Do the people think that they will be left to say, "We believe" and they will not be tried',
    surahId: 29,
  },
  {
    name: "الروم",
    text: "الٓمٓ غُلِبَتِ ٱلرُّومُ",
    translation: "Alif, Lam, Meem. The Byzantines have been defeated",
    surahId: 30,
  },
  {
    name: "لقمان",
    text: "الٓمٓ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡحَكِيمِ",
    translation: "Alif, Lam, Meem, These are verses of the wise Book",
    surahId: 31,
  },
  {
    name: "السجدة",
    text: "الٓمٓ تَنزِيلُ ٱلۡكِتَٰبِ لَا رَيۡبَ فِيهِ مِن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "Alif, Lam, Meem, [This is] the revelation of the Book about which there is no doubt from the Lord of the worlds",
    surahId: 32,
  },
  {
    name: "الأحزاب",
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ ٱتَّقِ ٱللَّهَ وَلَا تُطِعِ ٱلۡكَٰفِرِينَ وَٱلۡمُنَٰفِقِينَۚ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمٗا",
    translation:
      "O Prophet, fear Allah and do not obey the disbelievers and the hypocrites. Indeed, Allah is ever Knowing and Wise",
    surahId: 33,
  },
  {
    name: "سبإ",
    text: "ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ وَلَهُ ٱلۡحَمۡدُ فِي ٱلۡأٓخِرَةِۚ وَهُوَ ٱلۡحَكِيمُ ٱلۡخَبِيرُ",
    translation:
      "[All] praise is [due] to Allah, to whom belongs whatever is in the heavens and whatever is in the earth, and to Him belongs [all] praise in the Hereafter. And He is the Wise, the Acquainted",
    surahId: 34,
  },
  {
    name: "فاطر",
    text: "ٱلۡحَمۡدُ لِلَّهِ فَاطِرِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ جَاعِلِ ٱلۡمَلَـٰٓئِكَةِ رُسُلًا أُوْلِيٓ أَجۡنِحَةٖ مَّثۡنَىٰ وَثُلَٰثَ وَرُبَٰعَۚ يَزِيدُ فِي ٱلۡخَلۡقِ مَا يَشَآءُۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "[All] praise is [due] to Allah, Creator of the heavens and the earth, [who] made the angels messengers having wings, two or three or four. He increases in creation what He wills. Indeed, Allah is over all things competent",
    surahId: 35,
  },
  {
    name: "يس",
    text: "يسٓ وَٱلۡقُرۡءَانِ ٱلۡحَكِيمِ إِنَّكَ لَمِنَ ٱلۡمُرۡسَلِينَ",
    translation:
      "Ya, Seen, By the wise Qur'an, Indeed you, [O Muhammad], are from among the messengers",
    surahId: 36,
  },
  {
    name: "الصافات",
    text: "وَٱلصَّـٰٓفَّـٰتِ صَفّٗا",
    translation: "By those [angels] lined up in rows",
    surahId: 37,
  },
  {
    name: "ص",
    text: "صٓۚ وَٱلۡقُرۡءَانِ ذِي ٱلذِّكۡرِ",
    translation: "Sad. By the Qur'an containing reminder",
    surahId: 38,
  },
  {
    name: "الزمر",
    text: "تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ",
    translation:
      "The revelation of the Qur'an is from Allah, the Exalted in Might, the Wise",
    surahId: 39,
  },
  {
    name: "غافر",
    text: "حمٓ تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡعَلِيمِ",
    translation:
      "Ha, Meem, The revelation of the Book is from Allah, the Exalted in Might, the Knowing",
    surahId: 40,
  },
  {
    name: "فصلت",
    text: "حمٓ تَنزِيلٞ مِّنَ ٱلرَّحۡمَٰنِ ٱلرَّحِيمِ",
    translation:
      "Ha, Meem, [This is] a revelation from the Entirely Merciful, the Especially Merciful",
    surahId: 41,
  },
  {
    name: "الشورى",
    text: "حمٓ عٓسٓقٓ",
    translation: "Ha, Meem, Ayn, Seen, Qaf",
    surahId: 42,
  },
  {
    name: "الزخرف",
    text: "حمٓ وَٱلۡكِتَٰبِ ٱلۡمُبِينِ إِنَّا جَعَلۡنَٰهُ قُرۡءَٰنًا عَرَبِيّٗا لَّعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      "Ha, Meem, By the clear Book, Indeed, We have made it an Arabic Qur'an that you might understand",
    surahId: 43,
  },
  {
    name: "الدخان",
    text: "حمٓ وَٱلۡكِتَٰبِ ٱلۡمُبِينِ إِنَّآ أَنزَلۡنَٰهُ فِي لَيۡلَةٖ مُّبَٰرَكَةٍۚ إِنَّا كُنَّا مُنذِرِينَ",
    translation:
      "Ha, Meem, By the clear Book, Indeed, We sent it down during a blessed night. Indeed, We were to warn [mankind]",
    surahId: 44,
  },
  {
    name: "الجاثية",
    text: "حمٓ تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ إِنَّ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ لَأٓيَٰتٖ لِّلۡمُؤۡمِنِينَ",
    translation:
      "Ha, Meem, The revelation of the Book is from Allah, the Exalted in Might, the Wise, Indeed, within the heavens and earth are signs for the believers",
    surahId: 45,
  },
  {
    name: "الأحقاف",
    text: "حمٓ تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ مَا خَلَقۡنَا ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَآ إِلَّا بِٱلۡحَقِّ وَأَجَلٖ مُّسَمّٗىۚ",
    translation:
      "Ha, Meem, The revelation of the Book is from Allah, the Exalted in Might, the Wise, We did not create the heavens and earth and what is between them except in truth and [for] a specified term.",
    surahId: 46,
  },
  {
    name: "محمد",
    text: "ٱلَّذِينَ كَفَرُواْ وَصَدُّواْ عَن سَبِيلِ ٱللَّهِ أَضَلَّ أَعۡمَٰلَهُمۡ",
    translation:
      "Those who disbelieve and avert [people] from the way of Allah - He will waste their deeds",
    surahId: 47,
  },
  {
    name: "الفتح",
    text: "إِنَّا فَتَحۡنَا لَكَ فَتۡحٗا مُّبِينٗا",
    translation: "Indeed, We have given you, [O Muhammad], a clear conquest",
    surahId: 48,
  },
  {
    name: "الحجرات",
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تُقَدِّمُواْ بَيۡنَ يَدَيِ ٱللَّهِ وَرَسُولِهِۦۖ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٞ",
    translation:
      "O you who have believed, do not put [yourselves] before Allah and His Messenger but fear Allah. Indeed, Allah is Hearing and Knowing",
    surahId: 49,
  },
  {
    name: "ق",
    text: "قٓۚ وَٱلۡقُرۡءَانِ ٱلۡمَجِيدِ",
    translation: "Qaf. By the honored Qur'an",
    surahId: 50,
  },
  {
    name: "الذاريات",
    text: "وَٱلذَّـٰرِيَٰتِ ذَرۡوٗا",
    translation: "By those [winds] scattering [dust] dispersing",
    surahId: 51,
  },
  {
    name: "الطور",
    text: "وَٱلطُّورِوَكِتَٰبٖ مَّسۡطُورٖ",
    translation: "By the mount, And [by] a Book inscribed",
    surahId: 52,
  },
  {
    name: "النجم",
    text: "وَٱلنَّجۡمِ إِذَا هَوَىٰ",
    translation: "By the star when it descends",
    surahId: 53,
  },
  {
    name: "القمر",
    text: "ٱقۡتَرَبَتِ ٱلسَّاعَةُ وَٱنشَقَّ ٱلۡقَمَرُ",
    translation: "The Hour has come near, and the moon has split [in two]",
    surahId: 54,
  },
  {
    name: "الرحمن",
    text: "ٱلرَّحۡمَٰنُ عَلَّمَ ٱلۡقُرۡءَانَ خَلَقَ ٱلۡإِنسَٰنَ عَلَّمَهُ ٱلۡبَيَانَ",
    translation: "The Most Merciful, Taught the Qur'an",
    surahId: 55,
  },
  {
    name: "الواقعة",
    text: "إِذَا وَقَعَتِ ٱلۡوَاقِعَةُ لَيۡسَ لِوَقۡعَتِهَا كَاذِبَةٌ",
    translation: "When the Occurrence occurs",
    surahId: 56,
  },
  {
    name: "الحديد",
    text: "سَبَّحَ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Whatever is in the heavens and earth exalts Allah, and He is the Exalted in Might, the Wise",
    surahId: 57,
  },
  {
    name: "المجادلة",
    text: "قَدۡ سَمِعَ ٱللَّهُ قَوۡلَ ٱلَّتِي تُجَٰدِلُكَ فِي زَوۡجِهَا وَتَشۡتَكِيٓ إِلَى ٱللَّهِ وَٱللَّهُ يَسۡمَعُ تَحَاوُرَكُمَآۚ إِنَّ ٱللَّهَ سَمِيعُۢ بَصِيرٌ",
    translation:
      "Certainly has Allah heard the speech of the one who argues with you, [O Muhammad], concerning her husband and directs her complaint to Allah. And Allah hears your dialogue; indeed, Allah is Hearing and Seeing",
    surahId: 58,
  },
  {
    name: "الحشر",
    text: "سَبَّحَ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Whatever is in the heavens and whatever is on the earth exalts Allah, and He is the Exalted in Might, the Wise",
    surahId: 59,
  },
  {
    name: "الممتحنة",
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّخِذُواْ عَدُوِّي وَعَدُوَّكُمۡ أَوۡلِيَآءَ تُلۡقُونَ إِلَيۡهِم بِٱلۡمَوَدَّةِ وَقَدۡ كَفَرُواْ بِمَا جَآءَكُم مِّنَ ٱلۡحَقِّ يُخۡرِجُونَ ٱلرَّسُولَ وَإِيَّاكُمۡ أَن تُؤۡمِنُواْ بِٱللَّهِ رَبِّكُمۡ إِن كُنتُمۡ خَرَجۡتُمۡ جِهَٰدٗا فِي سَبِيلِي وَٱبۡتِغَآءَ مَرۡضَاتِيۚ تُسِرُّونَ إِلَيۡهِم بِٱلۡمَوَدَّةِ وَأَنَا۠ أَعۡلَمُ بِمَآ أَخۡفَيۡتُمۡ وَمَآ أَعۡلَنتُمۡۚ وَمَن يَفۡعَلۡهُ مِنكُمۡ فَقَدۡ ضَلَّ سَوَآءَ ٱلسَّبِيلِ",
    translation:
      "O you who have believed, do not take My enemies and your enemies as allies, extending to them affection while they have disbelieved in what came to you of the truth, having driven out the Prophet and yourselves [only] because you believe in Allah, your Lord. If you have come out for jihad in My cause and seeking means to My approval, [take them not as friends]. You confide to them affection, but I am most knowing of what you have concealed and what you have declared. And whoever does it among you has certainly strayed from the soundness of the way",
    surahId: 60,
  },
  {
    name: "الصف",
    text: "سَبَّحَ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Whatever is in the heavens and whatever is on the earth exalts Allah, and He is the Exalted in Might, the Wise",
    surahId: 61,
  },
  {
    name: "الجمعة",
    text: "يُسَبِّحُ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ ٱلۡمَلِكِ ٱلۡقُدُّوسِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ",
    translation:
      "Whatever is in the heavens and whatever is on the earth is exalting Allah, the Sovereign, the Pure, the Exalted in Might, the Wise",
    surahId: 62,
  },
  {
    name: "المنافقون",
    text: "إِذَا جَآءَكَ ٱلۡمُنَٰفِقُونَ قَالُواْ نَشۡهَدُ إِنَّكَ لَرَسُولُ ٱللَّهِۗ وَٱللَّهُ يَعۡلَمُ إِنَّكَ لَرَسُولُهُۥ وَٱللَّهُ يَشۡهَدُ إِنَّ ٱلۡمُنَٰفِقِينَ لَكَٰذِبُونَ",
    translation:
      'When the hypocrites come to you, [O Muhammad], they say, "We testify that you are the Messenger of Allah." And Allah knows that you are His Messenger, and Allah testifies that the hypocrites are liars',
    surahId: 63,
  },
  {
    name: "التغابن",
    text: "يُسَبِّحُ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ لَهُ ٱلۡمُلۡكُ وَلَهُ ٱلۡحَمۡدُۖ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "Whatever is in the heavens and whatever is on the earth is exalting Allah. To Him belongs dominion, and to Him belongs [all] praise, and He is over all things competent",
    surahId: 64,
  },
  {
    name: "الطلاق",
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ إِذَا طَلَّقۡتُمُ ٱلنِّسَآءَ فَطَلِّقُوهُنَّ لِعِدَّتِهِنَّ وَأَحۡصُواْ ٱلۡعِدَّةَۖ وَٱتَّقُواْ ٱللَّهَ رَبَّكُمۡۖ لَا تُخۡرِجُوهُنَّ مِنۢ بُيُوتِهِنَّ وَلَا يَخۡرُجۡنَ إِلَّآ أَن يَأۡتِينَ بِفَٰحِشَةٖ مُّبَيِّنَةٖۚ وَتِلۡكَ حُدُودُ ٱللَّهِۚ وَمَن يَتَعَدَّ حُدُودَ ٱللَّهِ فَقَدۡ ظَلَمَ نَفۡسَهُۥۚ لَا تَدۡرِي لَعَلَّ ٱللَّهَ يُحۡدِثُ بَعۡدَ ذَٰلِكَ أَمۡرٗا",
    translation:
      "O Prophet, when you [Muslims] divorce women, divorce them for [the commencement of] their waiting period and keep count of the waiting period, and fear Allah, your Lord. Do not turn them out of their [husbands'] houses, nor should they [themselves] leave [during that period] unless they are committing a clear immorality. And those are the limits [set by] Allah. And whoever transgresses the limits of Allah has certainly wronged himself. You know not; perhaps Allah will bring about after that a [different] matter",
    surahId: 65,
  },
  {
    name: "التحريم",
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ لِمَ تُحَرِّمُ مَآ أَحَلَّ ٱللَّهُ لَكَۖ تَبۡتَغِي مَرۡضَاتَ أَزۡوَٰجِكَۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "O Prophet, why do you prohibit [yourself from] what Allah has made lawful for you, seeking the approval of your wives? And Allah is Forgiving and Merciful",
    surahId: 66,
  },
  {
    name: "الملك",
    text: "تَبَٰرَكَ ٱلَّذِي بِيَدِهِ ٱلۡمُلۡكُ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "Blessed is He in whose hand is dominion, and He is over all things competent",
    surahId: 67,
  },
  {
    name: "القلم",
    text: "نٓۚ وَٱلۡقَلَمِ وَمَا يَسۡطُرُونَ",
    translation: "Nun. By the pen and what they inscribe",
    surahId: 68,
  },
  {
    name: "الحاقة",
    text: "ٱلۡحَآقَّةُ",
    translation: "The Inevitable Reality",
    surahId: 69,
  },
  {
    name: "المعارج",
    text: "سَأَلَ سَآئِلُۢ بِعَذَابٖ وَاقِعٖ",
    translation: "A supplicant asked for a punishment bound to happen",
    surahId: 70,
  },
  {
    name: "نوح",
    text: "إِنَّآ أَرۡسَلۡنَا نُوحًا إِلَىٰ قَوۡمِهِۦٓ أَنۡ أَنذِرۡ قَوۡمَكَ مِن قَبۡلِ أَن يَأۡتِيَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      'Indeed, We sent Noah to his people, [saying], "Warn your people before there comes to them a painful punishment',
    surahId: 71,
  },
  {
    name: "الجن",
    text: "قُلۡ أُوحِيَ إِلَيَّ أَنَّهُ ٱسۡتَمَعَ نَفَرٞ مِّنَ ٱلۡجِنِّ فَقَالُوٓاْ إِنَّا سَمِعۡنَا قُرۡءَانًا عَجَبٗا",
    translation:
      "Say, [O Muhammad], \"It has been revealed to me that a group of the jinn listened and said, 'Indeed, we have heard an amazing Qur'an",
    surahId: 72,
  },
  {
    name: "المزمل",
    text: "يَـٰٓأَيُّهَا ٱلۡمُزَّمِّلُ",
    translation: "O you who wraps himself [in clothing]",
    surahId: 73,
  },
  {
    name: "المدثر",
    text: "يَـٰٓأَيُّهَا ٱلۡمُدَّثِّرُ",
    translation: "O you who covers himself [with a garment]",
    surahId: 74,
  },
  {
    name: "القيامة",
    text: "لَآ أُقۡسِمُ بِيَوۡمِ ٱلۡقِيَٰمَةِ",
    translation: "I swear by the Day of Resurrection",
    surahId: 75,
  },
  {
    name: "الانسان",
    text: "هَلۡ أَتَىٰ عَلَى ٱلۡإِنسَٰنِ حِينٞ مِّنَ ٱلدَّهۡرِ لَمۡ يَكُن شَيۡـٔٗا مَّذۡكُورًا",
    translation:
      "Has there [not] come upon man a period of time when he was not a thing [even] mentioned",
    surahId: 76,
  },
  {
    name: "المرسلات",
    text: "وَٱلۡمُرۡسَلَٰتِ عُرۡفٗا",
    translation: "By those [winds] sent forth in gusts",
    surahId: 77,
  },
  {
    name: "النبإ",
    text: "عَمَّ يَتَسَآءَلُونَ",
    translation: "About what are they asking one another",
    surahId: 78,
  },
  {
    name: "النازعات",
    text: "وَٱلنَّـٰزِعَٰتِ غَرۡقٗا",
    translation: "By those [angels] who extract with violence",
    surahId: 79,
  },
  {
    name: "عبس",
    text: "عَبَسَ وَتَوَلَّىٰٓ",
    translation: "The Prophet frowned and turned away",
    surahId: 80,
  },
  {
    name: "التكوير",
    text: "إِذَا ٱلشَّمۡسُ كُوِّرَتۡ",
    translation: "When the sun is wrapped up [in darkness]",
    surahId: 81,
  },
  {
    name: "الإنفطار",
    text: "إِذَا ٱلسَّمَآءُ ٱنفَطَرَتۡ",
    translation: "When the sky breaks apart",
    surahId: 82,
  },
  {
    name: "المطففين",
    text: "وَيۡلٞ لِّلۡمُطَفِّفِينَ ٱلَّذِينَ إِذَا ٱكۡتَالُواْ عَلَى ٱلنَّاسِ يَسۡتَوۡفُونَ",
    translation:
      "Woe to those who give less [than due],Who, when they take a measure from people, take in full",
    surahId: 83,
  },
  {
    name: "الإنشقاق",
    text: "إِذَا ٱلسَّمَآءُ ٱنشَقَّتۡ",
    translation: "When the sky has split [open]",
    surahId: 84,
  },
  {
    name: "البروج",
    text: "وَٱلسَّمَآءِ ذَاتِ ٱلۡبُرُوجِ",
    translation: "By the sky containing great stars",
    surahId: 85,
  },
  {
    name: "الطارق",
    text: "وَٱلسَّمَآءِ وَٱلطَّارِقِ",
    translation: "By the sky and the night comer",
    surahId: 86,
  },
  {
    name: "الأعلى",
    text: "سَبِّحِ ٱسۡمَ رَبِّكَ ٱلۡأَعۡلَى",
    translation: "Exalt the name of your Lord, the Most High",
    surahId: 87,
  },
  {
    name: "الغاشية",
    text: "هَلۡ أَتَىٰكَ حَدِيثُ ٱلۡغَٰشِيَةِ",
    translation: "Has there reached you the report of the Overwhelming [event]",
    surahId: 88,
  },
  {
    name: "الفجر",
    text: "وَٱلۡفَجۡرِوَلَيَالٍ عَشۡرٖ",
    translation: "By the dawn, And [by] ten nights",
    surahId: 89,
  },
  {
    name: "البلد",
    text: "لَآ أُقۡسِمُ بِهَٰذَا ٱلۡبَلَدِ",
    translation: "I swear by this city, Makkah",
    surahId: 90,
  },
  {
    name: "الشمس",
    text: "وَٱلشَّمۡسِ وَضُحَىٰهَا",
    translation: "By the sun and its brightness",
    surahId: 91,
  },
  {
    name: "الليل",
    text: "وَٱلَّيۡلِ إِذَا يَغۡشَىٰ",
    translation: "By the night when it covers",
    surahId: 92,
  },
  {
    name: "الضحى",
    text: "وَٱلضُّحَىٰ",
    translation: "By the morning brightness",
    surahId: 93,
  },
  {
    name: "الشرح",
    text: "أَلَمۡ نَشۡرَحۡ لَكَ صَدۡرَكَ",
    translation: "Did We not expand for you, [O Muhammad], your breast",
    surahId: 94,
  },
  {
    name: "التين",
    text: "وَٱلتِّينِ وَٱلزَّيۡتُونِ",
    translation: "By the fig and the olive",
    surahId: 95,
  },
  {
    name: "العلق",
    text: "ٱقۡرَأۡ بِٱسۡمِ رَبِّكَ ٱلَّذِي خَلَقَ",
    translation: "Recite in the name of your Lord who created",
    surahId: 96,
  },
  {
    name: "القدر",
    text: "إِنَّآ أَنزَلۡنَٰهُ فِي لَيۡلَةِ ٱلۡقَدۡرِ",
    translation: "Indeed, We sent the Qur'an down during the Night of Decree",
    surahId: 97,
  },
  {
    name: "البينة",
    text: "لَمۡ يَكُنِ ٱلَّذِينَ كَفَرُواْ مِنۡ أَهۡلِ ٱلۡكِتَٰبِ وَٱلۡمُشۡرِكِينَ مُنفَكِّينَ حَتَّىٰ تَأۡتِيَهُمُ ٱلۡبَيِّنَةُ",
    translation:
      "Those who disbelieved among the People of the Scripture and the polytheists were not to be parted [from misbelief] until there came to them clear evidence",
    surahId: 98,
  },
  {
    name: "الزلزلة",
    text: "إِذَا زُلۡزِلَتِ ٱلۡأَرۡضُ زِلۡزَالَهَا",
    translation: "When the earth is shaken with its [final] earthquake",
    surahId: 99,
  },
  {
    name: "العاديات",
    text: "وَٱلۡعَٰدِيَٰتِ ضَبۡحٗا",
    translation: "By the racers, panting",
    surahId: 100,
  },
  {
    name: "القارعة",
    text: "ٱلۡقَارِعَة مَا ٱلۡقَارِعَةُ وَمَآ أَدۡرَىٰكَ مَا ٱلۡقَارِعَةُ وَمَآ أَدۡرَىٰكَ مَا ٱلۡقَارِعَةُ",
    translation:
      "The Striking Calamity. What is the Striking Calamity.And what can make you know what is the Striking Calamity ",
    surahId: 101,
  },
  {
    name: "التكاثر",
    text: "أَلۡهَىٰكُمُ ٱلتَّكَاثُرُ حَتَّىٰ زُرۡتُمُ ٱلۡمَقَابِرَ",
    translation:
      "Competition in [worldly] increase diverts you, Until you visit the graveyards",
    surahId: 102,
  },
  {
    name: "الهمزة",
    text: "وَٱلۡعَصۡرِ إِنَّ ٱلۡإِنسَٰنَ لَفِي خُسۡرٍ",
    translation: "By time, Indeed, mankind is in loss",
    surahId: 103,
  },
  {
    name: "الهمزة",
    text: "وَيۡلٞ لِّكُلِّ هُمَزَةٖ لُّمَزَةٍ",
    translation: "Woe to every scorner and mocker",
    surahId: 104,
  },
  {
    name: "الفيل",
    text: "أَلَمۡ تَرَ كَيۡفَ فَعَلَ رَبُّكَ بِأَصۡحَٰبِ ٱلۡفِيلِ",
    translation:
      "Have you not considered, [O Muhammad], how your Lord dealt with the companions of the elephant",
    surahId: 105,
  },
  {
    name: "قريش",
    text: "لِإِيلَٰفِ قُرَيۡشٍ إِۦلَٰفِهِمۡ رِحۡلَةَ ٱلشِّتَآءِ وَٱلصَّيۡفِ",
    translation:
      "For the accustomed security of the Quraysh, Their accustomed security [in] the caravan of winter and summer",
    surahId: 106,
  },
  {
    name: "الماعون",
    text: "أَرَءَيۡتَ ٱلَّذِي يُكَذِّبُ بِٱلدِّينِ",
    translation: "Have you seen the one who denies the Recompense",
    surahId: 107,
  },
  {
    name: "الكوثر",
    text: "إِنَّآ أَعۡطَيۡنَٰكَ ٱلۡكَوۡثَرَ فَصَلِّ لِرَبِّكَ وَٱنۡحَرۡ",
    translation: "Indeed, We have granted you, [O Muhammad], al-Kawthar.So pray to your Lord and sacrifice [to Him alone]",
    surahId: 108,
  },
  {
    name: "الكافرون",
    text: "قُلۡ يَـٰٓأَيُّهَا ٱلۡكَٰفِرُونَ لَآ أَعۡبُدُ مَا تَعۡبُدُونَ",
    translation: 'Say, "O disbelievers',
    surahId: 109,
  },
  {
    name: "النصر",
    text: "إِذَا جَآءَ نَصۡرُ ٱللَّهِ وَٱلۡفَتۡحُ",
    translation: "When the victory of Allah has come and the conquest",
    surahId: 110,
  },
  {
    name: "المسد",
    text: "تَبَّتۡ يَدَآ أَبِي لَهَبٖ وَتَبَّ",
    translation: "May the hands of Abu Lahab be ruined, and ruined is he",
    surahId: 111,
  },
  {
    name: "الإخلاص",
    text: "قُلۡ هُوَ ٱللَّهُ أَحَدٌ",
    translation: 'Say, "He is Allah, [who is] One',
    surahId: 112,
  },
  {
    name: "الفلق",
    text: "قُلۡ أَعُوذُ بِرَبِّ ٱلۡفَلَقِ",
    translation: 'Say, "I seek refuge in the Lord of daybreak',
    surahId: 113,
  },
  {
    name: "الناس",
    text: "قُلۡ أَعُوذُ بِرَبِّ ٱلنَّاسِ",
    translation: 'Say, "I seek refuge in the Lord of mankind',
    surahId: 114,
  },
];

export let dataForWholeQuranSearchAbleFormat = [
  {
    verseId: 0,
    name: "الفاتحة",
    surahId: 1,
    text: "ٱلۡحَمۡدُ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation: "[All] praise is [due] to Allah, Lord of the worlds",
    normalizedText: "الحمد لله رب العلمين",
  },
  {
    verseId: 1,
    name: "الفاتحة",
    surahId: 1,
    text: "ٱلرَّحۡمَٰنِ ٱلرَّحِيمِ",
    translation: "The Entirely Merciful, the Especially Merciful",
    normalizedText: "الرحمن الرحيم",
  },
  {
    verseId: 2,
    name: "الفاتحة",
    surahId: 1,
    text: "مَٰلِكِ يَوۡمِ ٱلدِّينِ",
    translation: "Sovereign of the Day of Recompense",
    normalizedText: "ملك يوم الدين",
  },
  {
    verseId: 3,
    name: "الفاتحة",
    surahId: 1,
    text: "إِيَّاكَ نَعۡبُدُ وَإِيَّاكَ نَسۡتَعِينُ",
    translation: "It is You we worship and You we ask for help",
    normalizedText: "اياك نعبد واياك نستعين",
  },
  {
    verseId: 4,
    name: "الفاتحة",
    surahId: 1,
    text: "ٱهۡدِنَا ٱلصِّرَٰطَ ٱلۡمُسۡتَقِيمَ",
    translation: "Guide us to the straight path",
    normalizedText: "اهدنا الصرط المستقيم",
  },
  {
    verseId: 5,
    name: "الفاتحة",
    surahId: 1,
    text: "صِرَٰطَ ٱلَّذِينَ أَنۡعَمۡتَ عَلَيۡهِمۡ غَيۡرِ ٱلۡمَغۡضُوبِ عَلَيۡهِمۡ وَلَا ٱلضَّآلِّينَ",
    translation:
      "The path of those upon whom You have bestowed favor, not of those who have evoked [Your] anger or of those who are astray",
    normalizedText: "صرط الذين انعمت عليهم غير المغضوب عليهم ولا الضالين",
  },
  {
    verseId: 0,
    name: "البقرة",
    surahId: 2,
    text: "الٓمٓ",
    translation: "Alif, Lam, Meem",
    normalizedText: "الم",
  },
  {
    verseId: 1,
    name: "البقرة",
    surahId: 2,
    text: "ذَٰلِكَ ٱلۡكِتَٰبُ لَا رَيۡبَۛ فِيهِۛ هُدٗى لِّلۡمُتَّقِينَ",
    translation:
      "This is the Book about which there is no doubt, a guidance for those conscious of Allah",
    normalizedText: "ذلك الكتب لا ريب فيه هدى للمتقين",
  },
  {
    verseId: 2,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ يُؤۡمِنُونَ بِٱلۡغَيۡبِ وَيُقِيمُونَ ٱلصَّلَوٰةَ وَمِمَّا رَزَقۡنَٰهُمۡ يُنفِقُونَ",
    translation:
      "Who believe in the unseen, establish prayer, and spend out of what We have provided for them",
    normalizedText: "الذين يامنون بالغيب ويقيمون الصلوة ومما رزقنهم ينفقون",
  },
  {
    verseId: 3,
    name: "البقرة",
    surahId: 2,
    text: "وَٱلَّذِينَ يُؤۡمِنُونَ بِمَآ أُنزِلَ إِلَيۡكَ وَمَآ أُنزِلَ مِن قَبۡلِكَ وَبِٱلۡأٓخِرَةِ هُمۡ يُوقِنُونَ",
    translation:
      "And who believe in what has been revealed to you, [O Muhammad], and what was revealed before you, and of the Hereafter they are certain [in faith]",
    normalizedText:
      "والذين يامنون بما انزل اليك وما انزل من قبلك وبالاخرة هم يوقنون",
  },
  {
    verseId: 4,
    name: "البقرة",
    surahId: 2,
    text: "أُوْلَـٰٓئِكَ عَلَىٰ هُدٗى مِّن رَّبِّهِمۡۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "Those are upon [right] guidance from their Lord, and it is those who are the successful",
    normalizedText: "اولاك على هدى من ربهم واولاك هم المفلحون",
  },
  {
    verseId: 5,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ سَوَآءٌ عَلَيۡهِمۡ ءَأَنذَرۡتَهُمۡ أَمۡ لَمۡ تُنذِرۡهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "Indeed, those who disbelieve - it is all the same for them whether you warn them or do not warn them - they will not believe",
    normalizedText: "ان الذين كفروا سواء عليهم ءانذرتهم ام لم تنذرهم لا يامنون",
  },
  {
    verseId: 6,
    name: "البقرة",
    surahId: 2,
    text: "خَتَمَ ٱللَّهُ عَلَىٰ قُلُوبِهِمۡ وَعَلَىٰ سَمۡعِهِمۡۖ وَعَلَىٰٓ أَبۡصَٰرِهِمۡ غِشَٰوَةٞۖ وَلَهُمۡ عَذَابٌ عَظِيمٞ",
    translation:
      "Allah has set a seal upon their hearts and upon their hearing, and over their vision is a veil. And for them is a great punishment",
    normalizedText:
      "ختم الله على قلوبهم وعلى سمعهم وعلى ابصرهم غشوة ولهم عذاب عظيم",
  },
  {
    verseId: 7,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنَ ٱلنَّاسِ مَن يَقُولُ ءَامَنَّا بِٱللَّهِ وَبِٱلۡيَوۡمِ ٱلۡأٓخِرِ وَمَا هُم بِمُؤۡمِنِينَ",
    translation:
      'And of the people are some who say, "We believe in Allah and the Last Day," but they are not believers',
    normalizedText:
      "ومن الناس من يقول ءامنا بالله وباليوم الاخر وما هم بمامنين",
  },
  {
    verseId: 8,
    name: "البقرة",
    surahId: 2,
    text: "يُخَٰدِعُونَ ٱللَّهَ وَٱلَّذِينَ ءَامَنُواْ وَمَا يَخۡدَعُونَ إِلَّآ أَنفُسَهُمۡ وَمَا يَشۡعُرُونَ",
    translation:
      "They [think to] deceive Allah and those who believe, but they deceive not except themselves and perceive [it] not",
    normalizedText:
      "يخدعون الله والذين ءامنوا وما يخدعون الا انفسهم وما يشعرون",
  },
  {
    verseId: 9,
    name: "البقرة",
    surahId: 2,
    text: "فِي قُلُوبِهِم مَّرَضٞ فَزَادَهُمُ ٱللَّهُ مَرَضٗاۖ وَلَهُمۡ عَذَابٌ أَلِيمُۢ بِمَا كَانُواْ يَكۡذِبُونَ",
    translation:
      "In their hearts is disease, so Allah has increased their disease; and for them is a painful punishment because they [habitually] used to lie",
    normalizedText:
      "في قلوبهم مرض فزادهم الله مرضا ولهم عذاب اليم بما كانوا يكذبون",
  },
  {
    verseId: 10,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا قِيلَ لَهُمۡ لَا تُفۡسِدُواْ فِي ٱلۡأَرۡضِ قَالُوٓاْ إِنَّمَا نَحۡنُ مُصۡلِحُونَ",
    translation:
      'And when it is said to them, "Do not cause corruption on the earth," they say, "We are but reformers',
    normalizedText: "واذا قيل لهم لا تفسدوا في الارض قالوا انما نحن مصلحون",
  },
  {
    verseId: 11,
    name: "البقرة",
    surahId: 2,
    text: "أَلَآ إِنَّهُمۡ هُمُ ٱلۡمُفۡسِدُونَ وَلَٰكِن لَّا يَشۡعُرُونَ",
    translation:
      "Unquestionably, it is they who are the corrupters, but they perceive [it] not",
    normalizedText: "الا انهم هم المفسدون ولكن لا يشعرون",
  },
  {
    verseId: 12,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا قِيلَ لَهُمۡ ءَامِنُواْ كَمَآ ءَامَنَ ٱلنَّاسُ قَالُوٓاْ أَنُؤۡمِنُ كَمَآ ءَامَنَ ٱلسُّفَهَآءُۗ أَلَآ إِنَّهُمۡ هُمُ ٱلسُّفَهَآءُ وَلَٰكِن لَّا يَعۡلَمُونَ",
    translation:
      'And when it is said to them, "Believe as the people have believed," they say, "Should we believe as the foolish have believed?" Unquestionably, it is they who are the foolish, but they know [it] not',
    normalizedText:
      "واذا قيل لهم ءامنوا كما ءامن الناس قالوا انامن كما ءامن السفهاء الا انهم هم السفهاء ولكن لا يعلمون",
  },
  {
    verseId: 13,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا لَقُواْ ٱلَّذِينَ ءَامَنُواْ قَالُوٓاْ ءَامَنَّا وَإِذَا خَلَوۡاْ إِلَىٰ شَيَٰطِينِهِمۡ قَالُوٓاْ إِنَّا مَعَكُمۡ إِنَّمَا نَحۡنُ مُسۡتَهۡزِءُونَ",
    translation:
      'And when they meet those who believe, they say, "We believe"; but when they are alone with their evil ones, they say, "Indeed, we are with you; we were only mockers',
    normalizedText:
      "واذا لقوا الذين ءامنوا قالوا ءامنا واذا خلوا الى شيطينهم قالوا انا معكم انما نحن مستهزءون",
  },
  {
    verseId: 14,
    name: "البقرة",
    surahId: 2,
    text: "ٱللَّهُ يَسۡتَهۡزِئُ بِهِمۡ وَيَمُدُّهُمۡ فِي طُغۡيَٰنِهِمۡ يَعۡمَهُونَ",
    translation:
      "[But] Allah mocks them and prolongs them in their transgression [while] they wander blindly",
    normalizedText: "الله يستهزا بهم ويمدهم في طغينهم يعمهون",
  },
  {
    verseId: 15,
    name: "البقرة",
    surahId: 2,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ ٱشۡتَرَوُاْ ٱلضَّلَٰلَةَ بِٱلۡهُدَىٰ فَمَا رَبِحَت تِّجَٰرَتُهُمۡ وَمَا كَانُواْ مُهۡتَدِينَ",
    translation:
      "Those are the ones who have purchased error [in exchange] for guidance, so their transaction has brought no profit, nor were they guided",
    normalizedText:
      "اولاك الذين اشتروا الضللة بالهدى فما ربحت تجرتهم وما كانوا مهتدين",
  },
  {
    verseId: 16,
    name: "البقرة",
    surahId: 2,
    text: "مَثَلُهُمۡ كَمَثَلِ ٱلَّذِي ٱسۡتَوۡقَدَ نَارٗا فَلَمَّآ أَضَآءَتۡ مَا حَوۡلَهُۥ ذَهَبَ ٱللَّهُ بِنُورِهِمۡ وَتَرَكَهُمۡ فِي ظُلُمَٰتٖ لَّا يُبۡصِرُونَ",
    translation:
      "Their example is that of one who kindled a fire, but when it illuminated what was around him, Allah took away their light and left them in darkness [so] they could not see",
    normalizedText:
      "مثلهم كمثل الذي استوقد نارا فلما اضاءت ما حوله ذهب الله بنورهم وتركهم في ظلمت لا يبصرون",
  },
  {
    verseId: 17,
    name: "البقرة",
    surahId: 2,
    text: "صُمُّۢ بُكۡمٌ عُمۡيٞ فَهُمۡ لَا يَرۡجِعُونَ",
    translation:
      "Deaf, dumb and blind - so they will not return [to the right path]",
    normalizedText: "صم بكم عمي فهم لا يرجعون",
  },
  {
    verseId: 18,
    name: "البقرة",
    surahId: 2,
    text: "أَوۡ كَصَيِّبٖ مِّنَ ٱلسَّمَآءِ فِيهِ ظُلُمَٰتٞ وَرَعۡدٞ وَبَرۡقٞ يَجۡعَلُونَ أَصَٰبِعَهُمۡ فِيٓ ءَاذَانِهِم مِّنَ ٱلصَّوَٰعِقِ حَذَرَ ٱلۡمَوۡتِۚ وَٱللَّهُ مُحِيطُۢ بِٱلۡكَٰفِرِينَ",
    translation:
      "Or [it is] like a rainstorm from the sky within which is darkness, thunder and lightning. They put their fingers in their ears against the thunderclaps in dread of death. But Allah is encompassing of the disbelievers",
    normalizedText:
      "او كصيب من السماء فيه ظلمت ورعد وبرق يجعلون اصبعهم في ءاذانهم من الصوعق حذر الموت والله محيط بالكفرين",
  },
  {
    verseId: 19,
    name: "البقرة",
    surahId: 2,
    text: "يَكَادُ ٱلۡبَرۡقُ يَخۡطَفُ أَبۡصَٰرَهُمۡۖ كُلَّمَآ أَضَآءَ لَهُم مَّشَوۡاْ فِيهِ وَإِذَآ أَظۡلَمَ عَلَيۡهِمۡ قَامُواْۚ وَلَوۡ شَآءَ ٱللَّهُ لَذَهَبَ بِسَمۡعِهِمۡ وَأَبۡصَٰرِهِمۡۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "The lightning almost snatches away their sight. Every time it lights [the way] for them, they walk therein; but when darkness comes over them, they stand [still]. And if Allah had willed, He could have taken away their hearing and their sight. Indeed, Allah is over all things competent",
    normalizedText:
      "يكاد البرق يخطف ابصرهم كلما اضاء لهم مشوا فيه واذا اظلم عليهم قاموا ولو شاء الله لذهب بسمعهم وابصرهم ان الله على كل شيء قدير",
  },
  {
    verseId: 20,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ٱعۡبُدُواْ رَبَّكُمُ ٱلَّذِي خَلَقَكُمۡ وَٱلَّذِينَ مِن قَبۡلِكُمۡ لَعَلَّكُمۡ تَتَّقُونَ",
    translation:
      "O mankind, worship your Lord, who created you and those before you, that you may become righteous",
    normalizedText:
      "يايها الناس اعبدوا ربكم الذي خلقكم والذين من قبلكم لعلكم تتقون",
  },
  {
    verseId: 21,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِي جَعَلَ لَكُمُ ٱلۡأَرۡضَ فِرَٰشٗا وَٱلسَّمَآءَ بِنَآءٗ وَأَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَأَخۡرَجَ بِهِۦ مِنَ ٱلثَّمَرَٰتِ رِزۡقٗا لَّكُمۡۖ فَلَا تَجۡعَلُواْ لِلَّهِ أَندَادٗا وَأَنتُمۡ تَعۡلَمُونَ",
    translation:
      "[He] who made for you the earth a bed [spread out] and the sky a ceiling and sent down from the sky, rain and brought forth thereby fruits as provision for you. So do not attribute to Allah equals while you know [that there is nothing similar to Him]",
    normalizedText:
      "الذي جعل لكم الارض فرشا والسماء بناء وانزل من السماء ماء فاخرج به من الثمرت رزقا لكم فلا تجعلوا لله اندادا وانتم تعلمون",
  },
  {
    verseId: 22,
    name: "البقرة",
    surahId: 2,
    text: "وَإِن كُنتُمۡ فِي رَيۡبٖ مِّمَّا نَزَّلۡنَا عَلَىٰ عَبۡدِنَا فَأۡتُواْ بِسُورَةٖ مِّن مِّثۡلِهِۦ وَٱدۡعُواْ شُهَدَآءَكُم مِّن دُونِ ٱللَّهِ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      "And if you are in doubt about what We have sent down upon Our Servant [Muhammad], then produce a surah the like thereof and call upon your witnesses other than Allah, if you should be truthful",
    normalizedText:
      "وان كنتم في ريب مما نزلنا على عبدنا فاتوا بسورة من مثله وادعوا شهداءكم من دون الله ان كنتم صدقين",
  },
  {
    verseId: 23,
    name: "البقرة",
    surahId: 2,
    text: "فَإِن لَّمۡ تَفۡعَلُواْ وَلَن تَفۡعَلُواْ فَٱتَّقُواْ ٱلنَّارَ ٱلَّتِي وَقُودُهَا ٱلنَّاسُ وَٱلۡحِجَارَةُۖ أُعِدَّتۡ لِلۡكَٰفِرِينَ",
    translation:
      "But if you do not - and you will never be able to - then fear the Fire, whose fuel is men and stones, prepared for the disbelievers",
    normalizedText:
      "فان لم تفعلوا ولن تفعلوا فاتقوا النار التي وقودها الناس والحجارة اعدت للكفرين",
  },
  {
    verseId: 24,
    name: "البقرة",
    surahId: 2,
    text: "وَبَشِّرِ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ أَنَّ لَهُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۖ كُلَّمَا رُزِقُواْ مِنۡهَا مِن ثَمَرَةٖ رِّزۡقٗا قَالُواْ هَٰذَا ٱلَّذِي رُزِقۡنَا مِن قَبۡلُۖ وَأُتُواْ بِهِۦ مُتَشَٰبِهٗاۖ وَلَهُمۡ فِيهَآ أَزۡوَٰجٞ مُّطَهَّرَةٞۖ وَهُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      'And give good tidings to those who believe and do righteous deeds that they will have gardens [in Paradise] beneath which rivers flow. Whenever they are provided with a provision of fruit therefrom, they will say, "This is what we were provided with before." And it is given to them in likeness. And they will have therein purified spouses, and they will abide therein eternally',
    normalizedText:
      "وبشر الذين ءامنوا وعملوا الصلحت ان لهم جنت تجري من تحتها الانهر كلما رزقوا منها من ثمرة رزقا قالوا هذا الذي رزقنا من قبل واتوا به متشبها ولهم فيها ازوج مطهرة وهم فيها خلدون",
  },
  {
    verseId: 25,
    name: "البقرة",
    surahId: 2,
    text: "۞إِنَّ ٱللَّهَ لَا يَسۡتَحۡيِۦٓ أَن يَضۡرِبَ مَثَلٗا مَّا بَعُوضَةٗ فَمَا فَوۡقَهَاۚ فَأَمَّا ٱلَّذِينَ ءَامَنُواْ فَيَعۡلَمُونَ أَنَّهُ ٱلۡحَقُّ مِن رَّبِّهِمۡۖ وَأَمَّا ٱلَّذِينَ كَفَرُواْ فَيَقُولُونَ مَاذَآ أَرَادَ ٱللَّهُ بِهَٰذَا مَثَلٗاۘ يُضِلُّ بِهِۦ كَثِيرٗا وَيَهۡدِي بِهِۦ كَثِيرٗاۚ وَمَا يُضِلُّ بِهِۦٓ إِلَّا ٱلۡفَٰسِقِينَ",
    translation:
      'Indeed, Allah is not timid to present an example - that of a mosquito or what is smaller than it. And those who have believed know that it is the truth from their Lord. But as for those who disbelieve, they say, "What did Allah intend by this as an example?" He misleads many thereby and guides many thereby. And He misleads not except the defiantly disobedient',
    normalizedText:
      "۞ان الله لا يستحي ان يضرب مثلا ما بعوضة فما فوقها فاما الذين ءامنوا فيعلمون انه الحق من ربهم واما الذين كفروا فيقولون ماذا اراد الله بهذا مثلا يضل به كثيرا ويهدي به كثيرا وما يضل به الا الفسقين",
  },
  {
    verseId: 26,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ يَنقُضُونَ عَهۡدَ ٱللَّهِ مِنۢ بَعۡدِ مِيثَٰقِهِۦ وَيَقۡطَعُونَ مَآ أَمَرَ ٱللَّهُ بِهِۦٓ أَن يُوصَلَ وَيُفۡسِدُونَ فِي ٱلۡأَرۡضِۚ أُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "Who break the covenant of Allah after contracting it and sever that which Allah has ordered to be joined and cause corruption on earth. It is those who are the losers",
    normalizedText:
      "الذين ينقضون عهد الله من بعد ميثقه ويقطعون ما امر الله به ان يوصل ويفسدون في الارض اولاك هم الخسرون",
  },
  {
    verseId: 27,
    name: "البقرة",
    surahId: 2,
    text: "كَيۡفَ تَكۡفُرُونَ بِٱللَّهِ وَكُنتُمۡ أَمۡوَٰتٗا فَأَحۡيَٰكُمۡۖ ثُمَّ يُمِيتُكُمۡ ثُمَّ يُحۡيِيكُمۡ ثُمَّ إِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "How can you disbelieve in Allah when you were lifeless and He brought you to life; then He will cause you to die, then He will bring you [back] to life, and then to Him you will be returned",
    normalizedText:
      "كيف تكفرون بالله وكنتم اموتا فاحيكم ثم يميتكم ثم يحييكم ثم اليه ترجعون",
  },
  {
    verseId: 28,
    name: "البقرة",
    surahId: 2,
    text: "هُوَ ٱلَّذِي خَلَقَ لَكُم مَّا فِي ٱلۡأَرۡضِ جَمِيعٗا ثُمَّ ٱسۡتَوَىٰٓ إِلَى ٱلسَّمَآءِ فَسَوَّىٰهُنَّ سَبۡعَ سَمَٰوَٰتٖۚ وَهُوَ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "It is He who created for you all of that which is on the earth. Then He directed Himself to the heaven, [His being above all creation], and made them seven heavens, and He is Knowing of all things",
    normalizedText:
      "هو الذي خلق لكم ما في الارض جميعا ثم استوى الى السماء فسوىهن سبع سموت وهو بكل شيء عليم",
  },
  {
    verseId: 29,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قَالَ رَبُّكَ لِلۡمَلَـٰٓئِكَةِ إِنِّي جَاعِلٞ فِي ٱلۡأَرۡضِ خَلِيفَةٗۖ قَالُوٓاْ أَتَجۡعَلُ فِيهَا مَن يُفۡسِدُ فِيهَا وَيَسۡفِكُ ٱلدِّمَآءَ وَنَحۡنُ نُسَبِّحُ بِحَمۡدِكَ وَنُقَدِّسُ لَكَۖ قَالَ إِنِّيٓ أَعۡلَمُ مَا لَا تَعۡلَمُونَ",
    translation:
      'And [mention, O Muhammad], when your Lord said to the angels, "Indeed, I will make upon the earth a successive authority." They said, "Will You place upon it one who causes corruption therein and sheds blood, while we declare Your praise and sanctify You?" Allah said, "Indeed, I know that which you do not know',
    normalizedText:
      "واذ قال ربك للملاكة اني جاعل في الارض خليفة قالوا اتجعل فيها من يفسد فيها ويسفك الدماء ونحن نسبح بحمدك ونقدس لك قال اني اعلم ما لا تعلمون",
  },
  {
    verseId: 30,
    name: "البقرة",
    surahId: 2,
    text: "وَعَلَّمَ ءَادَمَ ٱلۡأَسۡمَآءَ كُلَّهَا ثُمَّ عَرَضَهُمۡ عَلَى ٱلۡمَلَـٰٓئِكَةِ فَقَالَ أَنۢبِـُٔونِي بِأَسۡمَآءِ هَـٰٓؤُلَآءِ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And He taught Adam the names - all of them. Then He showed them to the angels and said, "Inform Me of the names of these, if you are truthful',
    normalizedText:
      "وعلم ءادم الاسماء كلها ثم عرضهم على الملاكة فقال انبوني باسماء هالاء ان كنتم صدقين",
  },
  {
    verseId: 31,
    name: "البقرة",
    surahId: 2,
    text: "قَالُواْ سُبۡحَٰنَكَ لَا عِلۡمَ لَنَآ إِلَّا مَا عَلَّمۡتَنَآۖ إِنَّكَ أَنتَ ٱلۡعَلِيمُ ٱلۡحَكِيمُ",
    translation:
      'They said, "Exalted are You; we have no knowledge except what You have taught us. Indeed, it is You who is the Knowing, the Wise',
    normalizedText:
      "قالوا سبحنك لا علم لنا الا ما علمتنا انك انت العليم الحكيم",
  },
  {
    verseId: 32,
    name: "البقرة",
    surahId: 2,
    text: "قَالَ يَـٰٓـَٔادَمُ أَنۢبِئۡهُم بِأَسۡمَآئِهِمۡۖ فَلَمَّآ أَنۢبَأَهُم بِأَسۡمَآئِهِمۡ قَالَ أَلَمۡ أَقُل لَّكُمۡ إِنِّيٓ أَعۡلَمُ غَيۡبَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَأَعۡلَمُ مَا تُبۡدُونَ وَمَا كُنتُمۡ تَكۡتُمُونَ",
    translation:
      'He said, "O Adam, inform them of their names." And when he had informed them of their names, He said, "Did I not tell you that I know the unseen [aspects] of the heavens and the earth? And I know what you reveal and what you have concealed',
    normalizedText:
      "قال يادم انباهم باسمااهم فلما انباهم باسمااهم قال الم اقل لكم اني اعلم غيب السموت والارض واعلم ما تبدون وما كنتم تكتمون",
  },
  {
    verseId: 33,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قُلۡنَا لِلۡمَلَـٰٓئِكَةِ ٱسۡجُدُواْ لِأٓدَمَ فَسَجَدُوٓاْ إِلَّآ إِبۡلِيسَ أَبَىٰ وَٱسۡتَكۡبَرَ وَكَانَ مِنَ ٱلۡكَٰفِرِينَ",
    translation:
      'And [mention] when We said to the angels, "Prostrate before Adam"; so they prostrated, except for Iblees. He refused and was arrogant and became of the disbelievers',
    normalizedText:
      "واذ قلنا للملاكة اسجدوا لادم فسجدوا الا ابليس ابى واستكبر وكان من الكفرين",
  },
  {
    verseId: 34,
    name: "البقرة",
    surahId: 2,
    text: "وَقُلۡنَا يَـٰٓـَٔادَمُ ٱسۡكُنۡ أَنتَ وَزَوۡجُكَ ٱلۡجَنَّةَ وَكُلَا مِنۡهَا رَغَدًا حَيۡثُ شِئۡتُمَا وَلَا تَقۡرَبَا هَٰذِهِ ٱلشَّجَرَةَ فَتَكُونَا مِنَ ٱلظَّـٰلِمِينَ",
    translation:
      'And We said, "O Adam, dwell, you and your wife, in Paradise and eat therefrom in [ease and] abundance from wherever you will. But do not approach this tree, lest you be among the wrongdoers',
    normalizedText:
      "وقلنا يادم اسكن انت وزوجك الجنة وكلا منها رغدا حيث شاتما ولا تقربا هذه الشجرة فتكونا من الظلمين",
  },
  {
    verseId: 35,
    name: "البقرة",
    surahId: 2,
    text: "فَأَزَلَّهُمَا ٱلشَّيۡطَٰنُ عَنۡهَا فَأَخۡرَجَهُمَا مِمَّا كَانَا فِيهِۖ وَقُلۡنَا ٱهۡبِطُواْ بَعۡضُكُمۡ لِبَعۡضٍ عَدُوّٞۖ وَلَكُمۡ فِي ٱلۡأَرۡضِ مُسۡتَقَرّٞ وَمَتَٰعٌ إِلَىٰ حِينٖ",
    translation:
      'But Satan caused them to slip out of it and removed them from that [condition] in which they had been. And We said, "Go down, [all of you], as enemies to one another, and you will have upon the earth a place of settlement and provision for a time',
    normalizedText:
      "فازلهما الشيطن عنها فاخرجهما مما كانا فيه وقلنا اهبطوا بعضكم لبعض عدو ولكم في الارض مستقر ومتع الى حين",
  },
  {
    verseId: 36,
    name: "البقرة",
    surahId: 2,
    text: "فَتَلَقَّىٰٓ ءَادَمُ مِن رَّبِّهِۦ كَلِمَٰتٖ فَتَابَ عَلَيۡهِۚ إِنَّهُۥ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ",
    translation:
      "Then Adam received from his Lord [some] words, and He accepted his repentance. Indeed, it is He who is the Accepting of repentance, the Merciful",
    normalizedText: "فتلقى ءادم من ربه كلمت فتاب عليه انه هو التواب الرحيم",
  },
  {
    verseId: 37,
    name: "البقرة",
    surahId: 2,
    text: "قُلۡنَا ٱهۡبِطُواْ مِنۡهَا جَمِيعٗاۖ فَإِمَّا يَأۡتِيَنَّكُم مِّنِّي هُدٗى فَمَن تَبِعَ هُدَايَ فَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      'We said, "Go down from it, all of you. And when guidance comes to you from Me, whoever follows My guidance - there will be no fear concerning them, nor will they grieve',
    normalizedText:
      "قلنا اهبطوا منها جميعا فاما ياتينكم مني هدى فمن تبع هداي فلا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 38,
    name: "البقرة",
    surahId: 2,
    text: "وَٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِـَٔايَٰتِنَآ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "And those who disbelieve and deny Our signs - those will be companions of the Fire; they will abide therein eternally",
    normalizedText: "والذين كفروا وكذبوا بايتنا اولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 39,
    name: "البقرة",
    surahId: 2,
    text: "يَٰبَنِيٓ إِسۡرَـٰٓءِيلَ ٱذۡكُرُواْ نِعۡمَتِيَ ٱلَّتِيٓ أَنۡعَمۡتُ عَلَيۡكُمۡ وَأَوۡفُواْ بِعَهۡدِيٓ أُوفِ بِعَهۡدِكُمۡ وَإِيَّـٰيَ فَٱرۡهَبُونِ",
    translation:
      "O Children of Israel, remember My favor which I have bestowed upon you and fulfill My covenant [upon you] that I will fulfill your covenant [from Me], and be afraid of [only] Me",
    normalizedText:
      "يبني اسرءيل اذكروا نعمتي التي انعمت عليكم واوفوا بعهدي اوف بعهدكم وايي فارهبون",
  },
  {
    verseId: 40,
    name: "البقرة",
    surahId: 2,
    text: "وَءَامِنُواْ بِمَآ أَنزَلۡتُ مُصَدِّقٗا لِّمَا مَعَكُمۡ وَلَا تَكُونُوٓاْ أَوَّلَ كَافِرِۭ بِهِۦۖ وَلَا تَشۡتَرُواْ بِـَٔايَٰتِي ثَمَنٗا قَلِيلٗا وَإِيَّـٰيَ فَٱتَّقُونِ",
    translation:
      "And believe in what I have sent down confirming that which is [already] with you, and be not the first to disbelieve in it. And do not exchange My signs for a small price, and fear [only] Me",
    normalizedText:
      "وءامنوا بما انزلت مصدقا لما معكم ولا تكونوا اول كافر به ولا تشتروا بايتي ثمنا قليلا وايي فاتقون",
  },
  {
    verseId: 41,
    name: "البقرة",
    surahId: 2,
    text: "وَلَا تَلۡبِسُواْ ٱلۡحَقَّ بِٱلۡبَٰطِلِ وَتَكۡتُمُواْ ٱلۡحَقَّ وَأَنتُمۡ تَعۡلَمُونَ",
    translation:
      "And do not mix the truth with falsehood or conceal the truth while you know [it]",
    normalizedText: "ولا تلبسوا الحق بالبطل وتكتموا الحق وانتم تعلمون",
  },
  {
    verseId: 42,
    name: "البقرة",
    surahId: 2,
    text: "وَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَ وَٱرۡكَعُواْ مَعَ ٱلرَّـٰكِعِينَ",
    translation:
      "And establish prayer and give zakah and bow with those who bow [in worship and obedience]",
    normalizedText: "واقيموا الصلوة وءاتوا الزكوة واركعوا مع الركعين",
  },
  {
    verseId: 43,
    name: "البقرة",
    surahId: 2,
    text: "۞أَتَأۡمُرُونَ ٱلنَّاسَ بِٱلۡبِرِّ وَتَنسَوۡنَ أَنفُسَكُمۡ وَأَنتُمۡ تَتۡلُونَ ٱلۡكِتَٰبَۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "Do you order righteousness of the people and forget yourselves while you recite the Scripture? Then will you not reason",
    normalizedText:
      "۞اتامرون الناس بالبر وتنسون انفسكم وانتم تتلون الكتب افلا تعقلون",
  },
  {
    verseId: 44,
    name: "البقرة",
    surahId: 2,
    text: "وَٱسۡتَعِينُواْ بِٱلصَّبۡرِ وَٱلصَّلَوٰةِۚ وَإِنَّهَا لَكَبِيرَةٌ إِلَّا عَلَى ٱلۡخَٰشِعِينَ",
    translation:
      "And seek help through patience and prayer, and indeed, it is difficult except for the humbly submissive [to Allah]",
    normalizedText: "واستعينوا بالصبر والصلوة وانها لكبيرة الا على الخشعين",
  },
  {
    verseId: 45,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ يَظُنُّونَ أَنَّهُم مُّلَٰقُواْ رَبِّهِمۡ وَأَنَّهُمۡ إِلَيۡهِ رَٰجِعُونَ",
    translation:
      "Who are certain that they will meet their Lord and that they will return to Him",
    normalizedText: "الذين يظنون انهم ملقوا ربهم وانهم اليه رجعون",
  },
  {
    verseId: 46,
    name: "البقرة",
    surahId: 2,
    text: "يَٰبَنِيٓ إِسۡرَـٰٓءِيلَ ٱذۡكُرُواْ نِعۡمَتِيَ ٱلَّتِيٓ أَنۡعَمۡتُ عَلَيۡكُمۡ وَأَنِّي فَضَّلۡتُكُمۡ عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      "O Children of Israel, remember My favor that I have bestowed upon you and that I preferred you over the worlds",
    normalizedText:
      "يبني اسرءيل اذكروا نعمتي التي انعمت عليكم واني فضلتكم على العلمين",
  },
  {
    verseId: 47,
    name: "البقرة",
    surahId: 2,
    text: "وَٱتَّقُواْ يَوۡمٗا لَّا تَجۡزِي نَفۡسٌ عَن نَّفۡسٖ شَيۡـٔٗا وَلَا يُقۡبَلُ مِنۡهَا شَفَٰعَةٞ وَلَا يُؤۡخَذُ مِنۡهَا عَدۡلٞ وَلَا هُمۡ يُنصَرُونَ",
    translation:
      "And fear a Day when no soul will suffice for another soul at all, nor will intercession be accepted from it, nor will compensation be taken from it, nor will they be aided",
    normalizedText:
      "واتقوا يوما لا تجزي نفس عن نفس شيا ولا يقبل منها شفعة ولا ياخذ منها عدل ولا هم ينصرون",
  },
  {
    verseId: 48,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ نَجَّيۡنَٰكُم مِّنۡ ءَالِ فِرۡعَوۡنَ يَسُومُونَكُمۡ سُوٓءَ ٱلۡعَذَابِ يُذَبِّحُونَ أَبۡنَآءَكُمۡ وَيَسۡتَحۡيُونَ نِسَآءَكُمۡۚ وَفِي ذَٰلِكُم بَلَآءٞ مِّن رَّبِّكُمۡ عَظِيمٞ",
    translation:
      "And [recall] when We saved your forefathers from the people of Pharaoh, who afflicted you with the worst torment, slaughtering your [newborn] sons and keeping your females alive. And in that was a great trial from your Lord",
    normalizedText:
      "واذ نجينكم من ءال فرعون يسومونكم سوء العذاب يذبحون ابناءكم ويستحيون نساءكم وفي ذلكم بلاء من ربكم عظيم",
  },
  {
    verseId: 49,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ فَرَقۡنَا بِكُمُ ٱلۡبَحۡرَ فَأَنجَيۡنَٰكُمۡ وَأَغۡرَقۡنَآ ءَالَ فِرۡعَوۡنَ وَأَنتُمۡ تَنظُرُونَ",
    translation:
      "And [recall] when We parted the sea for you and saved you and drowned the people of Pharaoh while you were looking on",
    normalizedText:
      "واذ فرقنا بكم البحر فانجينكم واغرقنا ءال فرعون وانتم تنظرون",
  },
  {
    verseId: 50,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ وَٰعَدۡنَا مُوسَىٰٓ أَرۡبَعِينَ لَيۡلَةٗ ثُمَّ ٱتَّخَذۡتُمُ ٱلۡعِجۡلَ مِنۢ بَعۡدِهِۦ وَأَنتُمۡ ظَٰلِمُونَ",
    translation:
      "And [recall] when We made an appointment with Moses for forty nights. Then you took [for worship] the calf after him, while you were wrongdoers",
    normalizedText:
      "واذ وعدنا موسى اربعين ليلة ثم اتخذتم العجل من بعده وانتم ظلمون",
  },
  {
    verseId: 51,
    name: "البقرة",
    surahId: 2,
    text: "ثُمَّ عَفَوۡنَا عَنكُم مِّنۢ بَعۡدِ ذَٰلِكَ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "Then We forgave you after that so perhaps you would be grateful",
    normalizedText: "ثم عفونا عنكم من بعد ذلك لعلكم تشكرون",
  },
  {
    verseId: 52,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ وَٱلۡفُرۡقَانَ لَعَلَّكُمۡ تَهۡتَدُونَ",
    translation:
      "And [recall] when We gave Moses the Scripture and criterion that perhaps you would be guided",
    normalizedText: "واذ ءاتينا موسى الكتب والفرقان لعلكم تهتدون",
  },
  {
    verseId: 53,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قَالَ مُوسَىٰ لِقَوۡمِهِۦ يَٰقَوۡمِ إِنَّكُمۡ ظَلَمۡتُمۡ أَنفُسَكُم بِٱتِّخَاذِكُمُ ٱلۡعِجۡلَ فَتُوبُوٓاْ إِلَىٰ بَارِئِكُمۡ فَٱقۡتُلُوٓاْ أَنفُسَكُمۡ ذَٰلِكُمۡ خَيۡرٞ لَّكُمۡ عِندَ بَارِئِكُمۡ فَتَابَ عَلَيۡكُمۡۚ إِنَّهُۥ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ",
    translation:
      'And [recall] when Moses said to his people, "O my people, indeed you have wronged yourselves by your taking of the calf [for worship]. So repent to your Creator and kill yourselves. That is best for [all of] you in the sight of your Creator." Then He accepted your repentance; indeed, He is the Accepting of repentance, the Merciful',
    normalizedText:
      "واذ قال موسى لقومه يقوم انكم ظلمتم انفسكم باتخاذكم العجل فتوبوا الى باراكم فاقتلوا انفسكم ذلكم خير لكم عند باراكم فتاب عليكم انه هو التواب الرحيم",
  },
  {
    verseId: 54,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قُلۡتُمۡ يَٰمُوسَىٰ لَن نُّؤۡمِنَ لَكَ حَتَّىٰ نَرَى ٱللَّهَ جَهۡرَةٗ فَأَخَذَتۡكُمُ ٱلصَّـٰعِقَةُ وَأَنتُمۡ تَنظُرُونَ",
    translation:
      'And [recall] when you said, "O Moses, we will never believe you until we see Allah outright"; so the thunderbolt took you while you were looking on',
    normalizedText:
      "واذ قلتم يموسى لن نامن لك حتى نرى الله جهرة فاخذتكم الصعقة وانتم تنظرون",
  },
  {
    verseId: 55,
    name: "البقرة",
    surahId: 2,
    text: "ثُمَّ بَعَثۡنَٰكُم مِّنۢ بَعۡدِ مَوۡتِكُمۡ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "Then We revived you after your death that perhaps you would be grateful",
    normalizedText: "ثم بعثنكم من بعد موتكم لعلكم تشكرون",
  },
  {
    verseId: 56,
    name: "البقرة",
    surahId: 2,
    text: "وَظَلَّلۡنَا عَلَيۡكُمُ ٱلۡغَمَامَ وَأَنزَلۡنَا عَلَيۡكُمُ ٱلۡمَنَّ وَٱلسَّلۡوَىٰۖ كُلُواْ مِن طَيِّبَٰتِ مَا رَزَقۡنَٰكُمۡۚ وَمَا ظَلَمُونَا وَلَٰكِن كَانُوٓاْ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      'And We shaded you with clouds and sent down to you manna and quails, [saying], "Eat from the good things with which We have provided you." And they wronged Us not - but they were [only] wronging themselves',
    normalizedText:
      "وظللنا عليكم الغمام وانزلنا عليكم المن والسلوى كلوا من طيبت ما رزقنكم وما ظلمونا ولكن كانوا انفسهم يظلمون",
  },
  {
    verseId: 57,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قُلۡنَا ٱدۡخُلُواْ هَٰذِهِ ٱلۡقَرۡيَةَ فَكُلُواْ مِنۡهَا حَيۡثُ شِئۡتُمۡ رَغَدٗا وَٱدۡخُلُواْ ٱلۡبَابَ سُجَّدٗا وَقُولُواْ حِطَّةٞ نَّغۡفِرۡ لَكُمۡ خَطَٰيَٰكُمۡۚ وَسَنَزِيدُ ٱلۡمُحۡسِنِينَ",
    translation: `And [recall] when We said, "Enter this city and eat from it wherever you will in [ease and] abundance, and enter the gate bowing humbly and say, 'Relieve us of our burdens.' We will [then] forgive your sins for you, and We will increase the doers of good [in goodness and reward]`,
    normalizedText:
      "واذ قلنا ادخلوا هذه القرية فكلوا منها حيث شاتم رغدا وادخلوا الباب سجدا وقولوا حطة نغفر لكم خطيكم وسنزيد المحسنين",
  },
  {
    verseId: 58,
    name: "البقرة",
    surahId: 2,
    text: "فَبَدَّلَ ٱلَّذِينَ ظَلَمُواْ قَوۡلًا غَيۡرَ ٱلَّذِي قِيلَ لَهُمۡ فَأَنزَلۡنَا عَلَى ٱلَّذِينَ ظَلَمُواْ رِجۡزٗا مِّنَ ٱلسَّمَآءِ بِمَا كَانُواْ يَفۡسُقُونَ",
    translation:
      "But those who wronged changed [those words] to a statement other than that which had been said to them, so We sent down upon those who wronged a punishment from the sky because they were defiantly disobeying",
    normalizedText:
      "فبدل الذين ظلموا قولا غير الذي قيل لهم فانزلنا على الذين ظلموا رجزا من السماء بما كانوا يفسقون",
  },
  {
    verseId: 59,
    name: "البقرة",
    surahId: 2,
    text: "۞وَإِذِ ٱسۡتَسۡقَىٰ مُوسَىٰ لِقَوۡمِهِۦ فَقُلۡنَا ٱضۡرِب بِّعَصَاكَ ٱلۡحَجَرَۖ فَٱنفَجَرَتۡ مِنۡهُ ٱثۡنَتَا عَشۡرَةَ عَيۡنٗاۖ قَدۡ عَلِمَ كُلُّ أُنَاسٖ مَّشۡرَبَهُمۡۖ كُلُواْ وَٱشۡرَبُواْ مِن رِّزۡقِ ٱللَّهِ وَلَا تَعۡثَوۡاْ فِي ٱلۡأَرۡضِ مُفۡسِدِينَ",
    translation:
      'And [recall] when Moses prayed for water for his people, so We said, "Strike with your staff the stone." And there gushed forth from it twelve springs, and every people knew its watering place. "Eat and drink from the provision of Allah, and do not commit abuse on the earth, spreading corruption',
    normalizedText:
      "۞واذ استسقى موسى لقومه فقلنا اضرب بعصاك الحجر فانفجرت منه اثنتا عشرة عينا قد علم كل اناس مشربهم كلوا واشربوا من رزق الله ولا تعثوا في الارض مفسدين",
  },
  {
    verseId: 60,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قُلۡتُمۡ يَٰمُوسَىٰ لَن نَّصۡبِرَ عَلَىٰ طَعَامٖ وَٰحِدٖ فَٱدۡعُ لَنَا رَبَّكَ يُخۡرِجۡ لَنَا مِمَّا تُنۢبِتُ ٱلۡأَرۡضُ مِنۢ بَقۡلِهَا وَقِثَّآئِهَا وَفُومِهَا وَعَدَسِهَا وَبَصَلِهَاۖ قَالَ أَتَسۡتَبۡدِلُونَ ٱلَّذِي هُوَ أَدۡنَىٰ بِٱلَّذِي هُوَ خَيۡرٌۚ ٱهۡبِطُواْ مِصۡرٗا فَإِنَّ لَكُم مَّا سَأَلۡتُمۡۗ وَضُرِبَتۡ عَلَيۡهِمُ ٱلذِّلَّةُ وَٱلۡمَسۡكَنَةُ وَبَآءُو بِغَضَبٖ مِّنَ ٱللَّهِۚ ذَٰلِكَ بِأَنَّهُمۡ كَانُواْ يَكۡفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَيَقۡتُلُونَ ٱلنَّبِيِّـۧنَ بِغَيۡرِ ٱلۡحَقِّۚ ذَٰلِكَ بِمَا عَصَواْ وَّكَانُواْ يَعۡتَدُونَ",
    translation:
      'And [recall] when you said, "O Moses, we can never endure one [kind of] food. So call upon your Lord to bring forth for us from the earth its green herbs and its cucumbers and its garlic and its lentils and its onions." [Moses] said, "Would you exchange what is better for what is less? Go into [any] settlement and indeed, you will have what you have asked." And they were covered with humiliation and poverty and returned with anger from Allah [upon them]. That was because they [repeatedly] disbelieved in the signs of Allah and killed the prophets without right. That was because they disobeyed and were [habitually] transgressing',
    normalizedText:
      "واذ قلتم يموسى لن نصبر على طعام وحد فادع لنا ربك يخرج لنا مما تنبت الارض من بقلها وقثااها وفومها وعدسها وبصلها قال اتستبدلون الذي هو ادنى بالذي هو خير اهبطوا مصرا فان لكم ما سالتم وضربت عليهم الذلة والمسكنة وباءو بغضب من الله ذلك بانهم كانوا يكفرون بايت الله ويقتلون النبين بغير الحق ذلك بما عصوا وكانوا يعتدون",
  },
  {
    verseId: 61,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَٱلَّذِينَ هَادُواْ وَٱلنَّصَٰرَىٰ وَٱلصَّـٰبِـِٔينَ مَنۡ ءَامَنَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَعَمِلَ صَٰلِحٗا فَلَهُمۡ أَجۡرُهُمۡ عِندَ رَبِّهِمۡ وَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Indeed, those who believed and those who were Jews or Christians or Sabeans [before Prophet Muhammad] - those [among them] who believed in Allah and the Last Day and did righteousness - will have their reward with their Lord, and no fear will there be concerning them, nor will they grieve",
    normalizedText:
      "ان الذين ءامنوا والذين هادوا والنصرى والصبين من ءامن بالله واليوم الاخر وعمل صلحا فلهم اجرهم عند ربهم ولا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 62,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ أَخَذۡنَا مِيثَٰقَكُمۡ وَرَفَعۡنَا فَوۡقَكُمُ ٱلطُّورَ خُذُواْ مَآ ءَاتَيۡنَٰكُم بِقُوَّةٖ وَٱذۡكُرُواْ مَا فِيهِ لَعَلَّكُمۡ تَتَّقُونَ",
    translation:
      'And [recall] when We took your covenant, [O Children of Israel, to abide by the Torah] and We raised over you the mount, [saying], "Take what We have given you with determination and remember what is in it that perhaps you may become righteous',
    normalizedText:
      "واذ اخذنا ميثقكم ورفعنا فوقكم الطور خذوا ما ءاتينكم بقوة واذكروا ما فيه لعلكم تتقون",
  },
  {
    verseId: 63,
    name: "البقرة",
    surahId: 2,
    text: "ثُمَّ تَوَلَّيۡتُم مِّنۢ بَعۡدِ ذَٰلِكَۖ فَلَوۡلَا فَضۡلُ ٱللَّهِ عَلَيۡكُمۡ وَرَحۡمَتُهُۥ لَكُنتُم مِّنَ ٱلۡخَٰسِرِينَ",
    translation:
      "Then you turned away after that. And if not for the favor of Allah upon you and His mercy, you would have been among the losers",
    normalizedText:
      "ثم توليتم من بعد ذلك فلولا فضل الله عليكم ورحمته لكنتم من الخسرين",
  },
  {
    verseId: 64,
    name: "البقرة",
    surahId: 2,
    text: "وَلَقَدۡ عَلِمۡتُمُ ٱلَّذِينَ ٱعۡتَدَوۡاْ مِنكُمۡ فِي ٱلسَّبۡتِ فَقُلۡنَا لَهُمۡ كُونُواْ قِرَدَةً خَٰسِـِٔينَ",
    translation:
      'And you had already known about those who transgressed among you concerning the sabbath, and We said to them, "Be apes, despised',
    normalizedText:
      "ولقد علمتم الذين اعتدوا منكم في السبت فقلنا لهم كونوا قردة خسين",
  },
  {
    verseId: 65,
    name: "البقرة",
    surahId: 2,
    text: "فَجَعَلۡنَٰهَا نَكَٰلٗا لِّمَا بَيۡنَ يَدَيۡهَا وَمَا خَلۡفَهَا وَمَوۡعِظَةٗ لِّلۡمُتَّقِينَ",
    translation:
      "And We made it a deterrent punishment for those who were present and those who succeeded [them] and a lesson for those who fear Allah",
    normalizedText: "فجعلنها نكلا لما بين يديها وما خلفها وموعظة للمتقين",
  },
  {
    verseId: 66,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قَالَ مُوسَىٰ لِقَوۡمِهِۦٓ إِنَّ ٱللَّهَ يَأۡمُرُكُمۡ أَن تَذۡبَحُواْ بَقَرَةٗۖ قَالُوٓاْ أَتَتَّخِذُنَا هُزُوٗاۖ قَالَ أَعُوذُ بِٱللَّهِ أَنۡ أَكُونَ مِنَ ٱلۡجَٰهِلِينَ",
    translation:
      'And [recall] when Moses said to his people, "Indeed, Allah commands you to slaughter a cow." They said, "Do you take us in ridicule?" He said, "I seek refuge in Allah from being among the ignorant',
    normalizedText:
      "واذ قال موسى لقومه ان الله يامركم ان تذبحوا بقرة قالوا اتتخذنا هزوا قال اعوذ بالله ان اكون من الجهلين",
  },
  {
    verseId: 67,
    name: "البقرة",
    surahId: 2,
    text: "قَالُواْ ٱدۡعُ لَنَا رَبَّكَ يُبَيِّن لَّنَا مَا هِيَۚ قَالَ إِنَّهُۥ يَقُولُ إِنَّهَا بَقَرَةٞ لَّا فَارِضٞ وَلَا بِكۡرٌ عَوَانُۢ بَيۡنَ ذَٰلِكَۖ فَٱفۡعَلُواْ مَا تُؤۡمَرُونَ",
    translation: `They said, "Call upon your Lord to make clear to us what it is." [Moses] said, "[Allah] says, 'It is a cow which is neither old nor virgin, but median between that,' so do what you are commanded`,
    normalizedText:
      "قالوا ادع لنا ربك يبين لنا ما هي قال انه يقول انها بقرة لا فارض ولا بكر عوان بين ذلك فافعلوا ما تامرون",
  },
  {
    verseId: 68,
    name: "البقرة",
    surahId: 2,
    text: "قَالُواْ ٱدۡعُ لَنَا رَبَّكَ يُبَيِّن لَّنَا مَا لَوۡنُهَاۚ قَالَ إِنَّهُۥ يَقُولُ إِنَّهَا بَقَرَةٞ صَفۡرَآءُ فَاقِعٞ لَّوۡنُهَا تَسُرُّ ٱلنَّـٰظِرِينَ",
    translation: `They said, "Call upon your Lord to show us what is her color." He said, "He says, 'It is a yellow cow, bright in color - pleasing to the observers`,
    normalizedText:
      "قالوا ادع لنا ربك يبين لنا ما لونها قال انه يقول انها بقرة صفراء فاقع لونها تسر النظرين",
  },
  {
    verseId: 69,
    name: "البقرة",
    surahId: 2,
    text: "قَالُواْ ٱدۡعُ لَنَا رَبَّكَ يُبَيِّن لَّنَا مَا هِيَ إِنَّ ٱلۡبَقَرَ تَشَٰبَهَ عَلَيۡنَا وَإِنَّآ إِن شَآءَ ٱللَّهُ لَمُهۡتَدُونَ",
    translation:
      'They said, "Call upon your Lord to make clear to us what it is. Indeed, [all] cows look alike to us. And indeed we, if Allah wills, will be guided',
    normalizedText:
      "قالوا ادع لنا ربك يبين لنا ما هي ان البقر تشبه علينا وانا ان شاء الله لمهتدون",
  },
  {
    verseId: 70,
    name: "البقرة",
    surahId: 2,
    text: "قَالَ إِنَّهُۥ يَقُولُ إِنَّهَا بَقَرَةٞ لَّا ذَلُولٞ تُثِيرُ ٱلۡأَرۡضَ وَلَا تَسۡقِي ٱلۡحَرۡثَ مُسَلَّمَةٞ لَّا شِيَةَ فِيهَاۚ قَالُواْ ٱلۡـَٰٔنَ جِئۡتَ بِٱلۡحَقِّۚ فَذَبَحُوهَا وَمَا كَادُواْ يَفۡعَلُونَ",
    translation: `He said, "He says, 'It is a cow neither trained to plow the earth nor to irrigate the field, one free from fault with no spot upon her.' " They said, "Now you have come with the truth." So they slaughtered her, but they could hardly do it`,
    normalizedText:
      "قال انه يقول انها بقرة لا ذلول تثير الارض ولا تسقي الحرث مسلمة لا شية فيها قالوا الن جات بالحق فذبحوها وما كادوا يفعلون",
  },
  {
    verseId: 71,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قَتَلۡتُمۡ نَفۡسٗا فَٱدَّـٰرَ ٰٔتُمۡ فِيهَاۖ وَٱللَّهُ مُخۡرِجٞ مَّا كُنتُمۡ تَكۡتُمُونَ",
    translation:
      "And [recall] when you slew a man and disputed over it, but Allah was to bring out that which you were concealing",
    normalizedText: "واذ قتلتم نفسا فادر تم فيها والله مخرج ما كنتم تكتمون",
  },
  {
    verseId: 72,
    name: "البقرة",
    surahId: 2,
    text: "فَقُلۡنَا ٱضۡرِبُوهُ بِبَعۡضِهَاۚ كَذَٰلِكَ يُحۡيِ ٱللَّهُ ٱلۡمَوۡتَىٰ وَيُرِيكُمۡ ءَايَٰتِهِۦ لَعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      'So, We said, "Strike the slain man with part of it." Thus does Allah bring the dead to life, and He shows you His signs that you might reason',
    normalizedText:
      "فقلنا اضربوه ببعضها كذلك يحي الله الموتى ويريكم ءايته لعلكم تعقلون",
  },
  {
    verseId: 73,
    name: "البقرة",
    surahId: 2,
    text: "ثُمَّ قَسَتۡ قُلُوبُكُم مِّنۢ بَعۡدِ ذَٰلِكَ فَهِيَ كَٱلۡحِجَارَةِ أَوۡ أَشَدُّ قَسۡوَةٗۚ وَإِنَّ مِنَ ٱلۡحِجَارَةِ لَمَا يَتَفَجَّرُ مِنۡهُ ٱلۡأَنۡهَٰرُۚ وَإِنَّ مِنۡهَا لَمَا يَشَّقَّقُ فَيَخۡرُجُ مِنۡهُ ٱلۡمَآءُۚ وَإِنَّ مِنۡهَا لَمَا يَهۡبِطُ مِنۡ خَشۡيَةِ ٱللَّهِۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ",
    translation:
      "Then your hearts became hardened after that, being like stones or even harder. For indeed, there are stones from which rivers burst forth, and there are some of them that split open and water comes out, and there are some of them that fall down for fear of Allah. And Allah is not unaware of what you do",
    normalizedText:
      "ثم قست قلوبكم من بعد ذلك فهي كالحجارة او اشد قسوة وان من الحجارة لما يتفجر منه الانهر وان منها لما يشقق فيخرج منه الماء وان منها لما يهبط من خشية الله وما الله بغفل عما تعملون",
  },
  {
    verseId: 74,
    name: "البقرة",
    surahId: 2,
    text: "۞أَفَتَطۡمَعُونَ أَن يُؤۡمِنُواْ لَكُمۡ وَقَدۡ كَانَ فَرِيقٞ مِّنۡهُمۡ يَسۡمَعُونَ كَلَٰمَ ٱللَّهِ ثُمَّ يُحَرِّفُونَهُۥ مِنۢ بَعۡدِ مَا عَقَلُوهُ وَهُمۡ يَعۡلَمُونَ",
    translation:
      "Do you covet [the hope, O believers], that they would believe for you while a party of them used to hear the words of Allah and then distort the Torah after they had understood it while they were knowing",
    normalizedText:
      "۞افتطمعون ان يامنوا لكم وقد كان فريق منهم يسمعون كلم الله ثم يحرفونه من بعد ما عقلوه وهم يعلمون",
  },
  {
    verseId: 75,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا لَقُواْ ٱلَّذِينَ ءَامَنُواْ قَالُوٓاْ ءَامَنَّا وَإِذَا خَلَا بَعۡضُهُمۡ إِلَىٰ بَعۡضٖ قَالُوٓاْ أَتُحَدِّثُونَهُم بِمَا فَتَحَ ٱللَّهُ عَلَيۡكُمۡ لِيُحَآجُّوكُم بِهِۦ عِندَ رَبِّكُمۡۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      'And when they meet those who believe, they say, "We have believed"; but when they are alone with one another, they say, "Do you talk to them about what Allah has revealed to you so they can argue with you about it before your Lord?" Then will you not reason',
    normalizedText:
      "واذا لقوا الذين ءامنوا قالوا ءامنا واذا خلا بعضهم الى بعض قالوا اتحدثونهم بما فتح الله عليكم ليحاجوكم به عند ربكم افلا تعقلون",
  },
  {
    verseId: 76,
    name: "البقرة",
    surahId: 2,
    text: "أَوَلَا يَعۡلَمُونَ أَنَّ ٱللَّهَ يَعۡلَمُ مَا يُسِرُّونَ وَمَا يُعۡلِنُونَ",
    translation:
      "But do they not know that Allah knows what they conceal and what they declare",
    normalizedText: "اولا يعلمون ان الله يعلم ما يسرون وما يعلنون",
  },
  {
    verseId: 77,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنۡهُمۡ أُمِّيُّونَ لَا يَعۡلَمُونَ ٱلۡكِتَٰبَ إِلَّآ أَمَانِيَّ وَإِنۡ هُمۡ إِلَّا يَظُنُّونَ",
    translation:
      "And among them are unlettered ones who do not know the Scripture except in wishful thinking, but they are only assuming",
    normalizedText: "ومنهم اميون لا يعلمون الكتب الا اماني وان هم الا يظنون",
  },
  {
    verseId: 78,
    name: "البقرة",
    surahId: 2,
    text: "فَوَيۡلٞ لِّلَّذِينَ يَكۡتُبُونَ ٱلۡكِتَٰبَ بِأَيۡدِيهِمۡ ثُمَّ يَقُولُونَ هَٰذَا مِنۡ عِندِ ٱللَّهِ لِيَشۡتَرُواْ بِهِۦ ثَمَنٗا قَلِيلٗاۖ فَوَيۡلٞ لَّهُم مِّمَّا كَتَبَتۡ أَيۡدِيهِمۡ وَوَيۡلٞ لَّهُم مِّمَّا يَكۡسِبُونَ",
    translation:
      'So woe to those who write the "scripture" with their own hands, then say, "This is from Allah," in order to exchange it for a small price. Woe to them for what their hands have written and woe to them for what they earn',
    normalizedText:
      "فويل للذين يكتبون الكتب بايديهم ثم يقولون هذا من عند الله ليشتروا به ثمنا قليلا فويل لهم مما كتبت ايديهم وويل لهم مما يكسبون",
  },
  {
    verseId: 79,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالُواْ لَن تَمَسَّنَا ٱلنَّارُ إِلَّآ أَيَّامٗا مَّعۡدُودَةٗۚ قُلۡ أَتَّخَذۡتُمۡ عِندَ ٱللَّهِ عَهۡدٗا فَلَن يُخۡلِفَ ٱللَّهُ عَهۡدَهُۥٓۖ أَمۡ تَقُولُونَ عَلَى ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      'And they say, "Never will the Fire touch us, except for a few days." Say, "Have you taken a covenant with Allah? For Allah will never break His covenant. Or do you say about Allah that which you do not know',
    normalizedText:
      "وقالوا لن تمسنا النار الا اياما معدودة قل اتخذتم عند الله عهدا فلن يخلف الله عهده ام تقولون على الله ما لا تعلمون",
  },
  {
    verseId: 80,
    name: "البقرة",
    surahId: 2,
    text: "بَلَىٰۚ مَن كَسَبَ سَيِّئَةٗ وَأَحَٰطَتۡ بِهِۦ خَطِيٓـَٔتُهُۥ فَأُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "Yes, whoever earns evil and his sin has encompassed him - those are the companions of the Fire; they will abide therein eternally",
    normalizedText:
      "بلى من كسب سياة واحطت به خطيته فاولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 81,
    name: "البقرة",
    surahId: 2,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَنَّةِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "But they who believe and do righteous deeds - those are the companions of Paradise; they will abide therein eternally",
    normalizedText:
      "والذين ءامنوا وعملوا الصلحت اولاك اصحب الجنة هم فيها خلدون",
  },
  {
    verseId: 82,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ أَخَذۡنَا مِيثَٰقَ بَنِيٓ إِسۡرَـٰٓءِيلَ لَا تَعۡبُدُونَ إِلَّا ٱللَّهَ وَبِٱلۡوَٰلِدَيۡنِ إِحۡسَانٗا وَذِي ٱلۡقُرۡبَىٰ وَٱلۡيَتَٰمَىٰ وَٱلۡمَسَٰكِينِ وَقُولُواْ لِلنَّاسِ حُسۡنٗا وَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَ ثُمَّ تَوَلَّيۡتُمۡ إِلَّا قَلِيلٗا مِّنكُمۡ وَأَنتُم مُّعۡرِضُونَ",
    translation:
      'And [recall] when We took the covenant from the Children of Israel, [enjoining upon them], "Do not worship except Allah; and to parents do good and to relatives, orphans, and the needy. And speak to people good [words] and establish prayer and give zakah." Then you turned away, except a few of you, and you were refusing',
    normalizedText:
      "واذ اخذنا ميثق بني اسرءيل لا تعبدون الا الله وبالولدين احسانا وذي القربى واليتمى والمسكين وقولوا للناس حسنا واقيموا الصلوة وءاتوا الزكوة ثم توليتم الا قليلا منكم وانتم معرضون",
  },
  {
    verseId: 83,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ أَخَذۡنَا مِيثَٰقَكُمۡ لَا تَسۡفِكُونَ دِمَآءَكُمۡ وَلَا تُخۡرِجُونَ أَنفُسَكُم مِّن دِيَٰرِكُمۡ ثُمَّ أَقۡرَرۡتُمۡ وَأَنتُمۡ تَشۡهَدُونَ",
    translation: `And [recall] when We took your covenant, [saying], "Do not shed each other's blood or evict one another from your homes." Then you acknowledged [this] while you were witnessing`,
    normalizedText:
      "واذ اخذنا ميثقكم لا تسفكون دماءكم ولا تخرجون انفسكم من ديركم ثم اقررتم وانتم تشهدون",
  },
  {
    verseId: 84,
    name: "البقرة",
    surahId: 2,
    text: "ثُمَّ أَنتُمۡ هَـٰٓؤُلَآءِ تَقۡتُلُونَ أَنفُسَكُمۡ وَتُخۡرِجُونَ فَرِيقٗا مِّنكُم مِّن دِيَٰرِهِمۡ تَظَٰهَرُونَ عَلَيۡهِم بِٱلۡإِثۡمِ وَٱلۡعُدۡوَٰنِ وَإِن يَأۡتُوكُمۡ أُسَٰرَىٰ تُفَٰدُوهُمۡ وَهُوَ مُحَرَّمٌ عَلَيۡكُمۡ إِخۡرَاجُهُمۡۚ أَفَتُؤۡمِنُونَ بِبَعۡضِ ٱلۡكِتَٰبِ وَتَكۡفُرُونَ بِبَعۡضٖۚ فَمَا جَزَآءُ مَن يَفۡعَلُ ذَٰلِكَ مِنكُمۡ إِلَّا خِزۡيٞ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَيَوۡمَ ٱلۡقِيَٰمَةِ يُرَدُّونَ إِلَىٰٓ أَشَدِّ ٱلۡعَذَابِۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ",
    translation:
      "Then, you are those [same ones who are] killing one another and evicting a party of your people from their homes, cooperating against them in sin and aggression. And if they come to you as captives, you ransom them, although their eviction was forbidden to you. So do you believe in part of the Scripture and disbelieve in part? Then what is the recompense for those who do that among you except disgrace in worldly life; and on the Day of Resurrection they will be sent back to the severest of punishment. And Allah is not unaware of what you do",
    normalizedText:
      "ثم انتم هالاء تقتلون انفسكم وتخرجون فريقا منكم من ديرهم تظهرون عليهم بالاثم والعدون وان ياتوكم اسرى تفدوهم وهو محرم عليكم اخراجهم افتامنون ببعض الكتب وتكفرون ببعض فما جزاء من يفعل ذلك منكم الا خزي في الحيوة الدنيا ويوم القيمة يردون الى اشد العذاب وما الله بغفل عما تعملون",
  },
  {
    verseId: 85,
    name: "البقرة",
    surahId: 2,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ ٱشۡتَرَوُاْ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا بِٱلۡأٓخِرَةِۖ فَلَا يُخَفَّفُ عَنۡهُمُ ٱلۡعَذَابُ وَلَا هُمۡ يُنصَرُونَ",
    translation:
      "Those are the ones who have bought the life of this world [in exchange] for the Hereafter, so the punishment will not be lightened for them, nor will they be aided",
    normalizedText:
      "اولاك الذين اشتروا الحيوة الدنيا بالاخرة فلا يخفف عنهم العذاب ولا هم ينصرون",
  },
  {
    verseId: 86,
    name: "البقرة",
    surahId: 2,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ وَقَفَّيۡنَا مِنۢ بَعۡدِهِۦ بِٱلرُّسُلِۖ وَءَاتَيۡنَا عِيسَى ٱبۡنَ مَرۡيَمَ ٱلۡبَيِّنَٰتِ وَأَيَّدۡنَٰهُ بِرُوحِ ٱلۡقُدُسِۗ أَفَكُلَّمَا جَآءَكُمۡ رَسُولُۢ بِمَا لَا تَهۡوَىٰٓ أَنفُسُكُمُ ٱسۡتَكۡبَرۡتُمۡ فَفَرِيقٗا كَذَّبۡتُمۡ وَفَرِيقٗا تَقۡتُلُونَ",
    translation:
      "And We did certainly give Moses the Torah and followed up after him with messengers. And We gave Jesus, the son of Mary, clear proofs and supported him with the Pure Spirit. But is it [not] that every time a messenger came to you, [O Children of Israel], with what your souls did not desire, you were arrogant? And a party [of messengers] you denied and another party you killed",
    normalizedText:
      "ولقد ءاتينا موسى الكتب وقفينا من بعده بالرسل وءاتينا عيسى ابن مريم البينت وايدنه بروح القدس افكلما جاءكم رسول بما لا تهوى انفسكم استكبرتم ففريقا كذبتم وفريقا تقتلون",
  },
  {
    verseId: 87,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالُواْ قُلُوبُنَا غُلۡفُۢۚ بَل لَّعَنَهُمُ ٱللَّهُ بِكُفۡرِهِمۡ فَقَلِيلٗا مَّا يُؤۡمِنُونَ",
    translation:
      'And they said, "Our hearts are wrapped." But, [in fact], Allah has cursed them for their disbelief, so little is it that they believe',
    normalizedText: "وقالوا قلوبنا غلف بل لعنهم الله بكفرهم فقليلا ما يامنون",
  },
  {
    verseId: 88,
    name: "البقرة",
    surahId: 2,
    text: "وَلَمَّا جَآءَهُمۡ كِتَٰبٞ مِّنۡ عِندِ ٱللَّهِ مُصَدِّقٞ لِّمَا مَعَهُمۡ وَكَانُواْ مِن قَبۡلُ يَسۡتَفۡتِحُونَ عَلَى ٱلَّذِينَ كَفَرُواْ فَلَمَّا جَآءَهُم مَّا عَرَفُواْ كَفَرُواْ بِهِۦۚ فَلَعۡنَةُ ٱللَّهِ عَلَى ٱلۡكَٰفِرِينَ",
    translation:
      "And when there came to them a Book from Allah confirming that which was with them - although before they used to pray for victory against those who disbelieved - but [then] when there came to them that which they recognized, they disbelieved in it; so the curse of Allah will be upon the disbelievers",
    normalizedText:
      "ولما جاءهم كتب من عند الله مصدق لما معهم وكانوا من قبل يستفتحون على الذين كفروا فلما جاءهم ما عرفوا كفروا به فلعنة الله على الكفرين",
  },
  {
    verseId: 89,
    name: "البقرة",
    surahId: 2,
    text: "بِئۡسَمَا ٱشۡتَرَوۡاْ بِهِۦٓ أَنفُسَهُمۡ أَن يَكۡفُرُواْ بِمَآ أَنزَلَ ٱللَّهُ بَغۡيًا أَن يُنَزِّلَ ٱللَّهُ مِن فَضۡلِهِۦ عَلَىٰ مَن يَشَآءُ مِنۡ عِبَادِهِۦۖ فَبَآءُو بِغَضَبٍ عَلَىٰ غَضَبٖۚ وَلِلۡكَٰفِرِينَ عَذَابٞ مُّهِينٞ",
    translation:
      "How wretched is that for which they sold themselves - that they would disbelieve in what Allah has revealed through [their] outrage that Allah would send down His favor upon whom He wills from among His servants. So they returned having [earned] wrath upon wrath. And for the disbelievers is a humiliating punishment",
    normalizedText:
      "باسما اشتروا به انفسهم ان يكفروا بما انزل الله بغيا ان ينزل الله من فضله على من يشاء من عباده فباءو بغضب على غضب وللكفرين عذاب مهين",
  },
  {
    verseId: 90,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا قِيلَ لَهُمۡ ءَامِنُواْ بِمَآ أَنزَلَ ٱللَّهُ قَالُواْ نُؤۡمِنُ بِمَآ أُنزِلَ عَلَيۡنَا وَيَكۡفُرُونَ بِمَا وَرَآءَهُۥ وَهُوَ ٱلۡحَقُّ مُصَدِّقٗا لِّمَا مَعَهُمۡۗ قُلۡ فَلِمَ تَقۡتُلُونَ أَنۢبِيَآءَ ٱللَّهِ مِن قَبۡلُ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      'And when it is said to them, "Believe in what Allah has revealed," they say, "We believe [only] in what was revealed to us." And they disbelieve in what came after it, while it is the truth confirming that which is with them. Say, "Then why did you kill the prophets of Allah before, if you are [indeed] believers',
    normalizedText:
      "واذا قيل لهم ءامنوا بما انزل الله قالوا نامن بما انزل علينا ويكفرون بما وراءه وهو الحق مصدقا لما معهم قل فلم تقتلون انبياء الله من قبل ان كنتم مامنين",
  },
  {
    verseId: 91,
    name: "البقرة",
    surahId: 2,
    text: "۞وَلَقَدۡ جَآءَكُم مُّوسَىٰ بِٱلۡبَيِّنَٰتِ ثُمَّ ٱتَّخَذۡتُمُ ٱلۡعِجۡلَ مِنۢ بَعۡدِهِۦ وَأَنتُمۡ ظَٰلِمُونَ",
    translation:
      "And Moses had certainly brought you clear proofs. Then you took the calf [in worship] after that, while you were wrongdoers",
    normalizedText:
      "۞ولقد جاءكم موسى بالبينت ثم اتخذتم العجل من بعده وانتم ظلمون",
  },
  {
    verseId: 92,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ أَخَذۡنَا مِيثَٰقَكُمۡ وَرَفَعۡنَا فَوۡقَكُمُ ٱلطُّورَ خُذُواْ مَآ ءَاتَيۡنَٰكُم بِقُوَّةٖ وَٱسۡمَعُواْۖ قَالُواْ سَمِعۡنَا وَعَصَيۡنَا وَأُشۡرِبُواْ فِي قُلُوبِهِمُ ٱلۡعِجۡلَ بِكُفۡرِهِمۡۚ قُلۡ بِئۡسَمَا يَأۡمُرُكُم بِهِۦٓ إِيمَٰنُكُمۡ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      'And [recall] when We took your covenant and raised over you the mount, [saying], "Take what We have given you with determination and listen." They said [instead], "We hear and disobey." And their hearts absorbed [the worship of] the calf because of their disbelief. Say, "How wretched is that which your faith enjoins upon you, if you should be believers',
    normalizedText:
      "واذ اخذنا ميثقكم ورفعنا فوقكم الطور خذوا ما ءاتينكم بقوة واسمعوا قالوا سمعنا وعصينا واشربوا في قلوبهم العجل بكفرهم قل باسما يامركم به ايمنكم ان كنتم مامنين",
  },
  {
    verseId: 93,
    name: "البقرة",
    surahId: 2,
    text: "قُلۡ إِن كَانَتۡ لَكُمُ ٱلدَّارُ ٱلۡأٓخِرَةُ عِندَ ٱللَّهِ خَالِصَةٗ مِّن دُونِ ٱلنَّاسِ فَتَمَنَّوُاْ ٱلۡمَوۡتَ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Say, [O Muhammad], "If the home of the Hereafter with Allah is for you alone and not the [other] people, then wish for death, if you should be truthful',
    normalizedText:
      "قل ان كانت لكم الدار الاخرة عند الله خالصة من دون الناس فتمنوا الموت ان كنتم صدقين",
  },
  {
    verseId: 94,
    name: "البقرة",
    surahId: 2,
    text: "وَلَن يَتَمَنَّوۡهُ أَبَدَۢا بِمَا قَدَّمَتۡ أَيۡدِيهِمۡۚ وَٱللَّهُ عَلِيمُۢ بِٱلظَّـٰلِمِينَ",
    translation:
      "But they will never wish for it, ever, because of what their hands have put forth. And Allah is Knowing of the wrongdoers",
    normalizedText: "ولن يتمنوه ابدا بما قدمت ايديهم والله عليم بالظلمين",
  },
  {
    verseId: 95,
    name: "البقرة",
    surahId: 2,
    text: "وَلَتَجِدَنَّهُمۡ أَحۡرَصَ ٱلنَّاسِ عَلَىٰ حَيَوٰةٖ وَمِنَ ٱلَّذِينَ أَشۡرَكُواْۚ يَوَدُّ أَحَدُهُمۡ لَوۡ يُعَمَّرُ أَلۡفَ سَنَةٖ وَمَا هُوَ بِمُزَحۡزِحِهِۦ مِنَ ٱلۡعَذَابِ أَن يُعَمَّرَۗ وَٱللَّهُ بَصِيرُۢ بِمَا يَعۡمَلُونَ",
    translation:
      "And you will surely find them the most greedy of people for life - [even] more than those who associate others with Allah. One of them wishes that he could be granted life a thousand years, but it would not remove him in the least from the [coming] punishment that he should be granted life. And Allah is Seeing of what they do",
    normalizedText:
      "ولتجدنهم احرص الناس على حيوة ومن الذين اشركوا يود احدهم لو يعمر الف سنة وما هو بمزحزحه من العذاب ان يعمر والله بصير بما يعملون",
  },
  {
    verseId: 96,
    name: "البقرة",
    surahId: 2,
    text: "قُلۡ مَن كَانَ عَدُوّٗا لِّـجِبۡرِيلَ فَإِنَّهُۥ نَزَّلَهُۥ عَلَىٰ قَلۡبِكَ بِإِذۡنِ ٱللَّهِ مُصَدِّقٗا لِّمَا بَيۡنَ يَدَيۡهِ وَهُدٗى وَبُشۡرَىٰ لِلۡمُؤۡمِنِينَ",
    translation: `Say, "Whoever is an enemy to Gabriel - it is [none but] he who has brought the Qur'an down upon your heart, [O Muhammad], by permission of Allah, confirming that which was before it and as guidance and good tidings for the believers`,
    normalizedText:
      "قل من كان عدوا لجبريل فانه نزله على قلبك باذن الله مصدقا لما بين يديه وهدى وبشرى للمامنين",
  },
  {
    verseId: 97,
    name: "البقرة",
    surahId: 2,
    text: "مَن كَانَ عَدُوّٗا لِّلَّهِ وَمَلَـٰٓئِكَتِهِۦ وَرُسُلِهِۦ وَجِبۡرِيلَ وَمِيكَىٰلَ فَإِنَّ ٱللَّهَ عَدُوّٞ لِّلۡكَٰفِرِينَ",
    translation:
      "Whoever is an enemy to Allah and His angels and His messengers and Gabriel and Michael - then indeed, Allah is an enemy to the disbelievers",
    normalizedText:
      "من كان عدوا لله وملاكته ورسله وجبريل وميكىل فان الله عدو للكفرين",
  },
  {
    verseId: 98,
    name: "البقرة",
    surahId: 2,
    text: "وَلَقَدۡ أَنزَلۡنَآ إِلَيۡكَ ءَايَٰتِۭ بَيِّنَٰتٖۖ وَمَا يَكۡفُرُ بِهَآ إِلَّا ٱلۡفَٰسِقُونَ",
    translation:
      "And We have certainly revealed to you verses [which are] clear proofs, and no one would deny them except the defiantly disobedient",
    normalizedText: "ولقد انزلنا اليك ءايت بينت وما يكفر بها الا الفسقون",
  },
  {
    verseId: 99,
    name: "البقرة",
    surahId: 2,
    text: "أَوَكُلَّمَا عَٰهَدُواْ عَهۡدٗا نَّبَذَهُۥ فَرِيقٞ مِّنۡهُمۚ بَلۡ أَكۡثَرُهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "Is it not [true] that every time they took a covenant a party of them threw it away? But, [in fact], most of them do not believe",
    normalizedText: "اوكلما عهدوا عهدا نبذه فريق منهم بل اكثرهم لا يامنون",
  },
  {
    verseId: 100,
    name: "البقرة",
    surahId: 2,
    text: "وَلَمَّا جَآءَهُمۡ رَسُولٞ مِّنۡ عِندِ ٱللَّهِ مُصَدِّقٞ لِّمَا مَعَهُمۡ نَبَذَ فَرِيقٞ مِّنَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ كِتَٰبَ ٱللَّهِ وَرَآءَ ظُهُورِهِمۡ كَأَنَّهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "And when a messenger from Allah came to them confirming that which was with them, a party of those who had been given the Scripture threw the Scripture of Allah behind their backs as if they did not know [what it contained]",
    normalizedText:
      "ولما جاءهم رسول من عند الله مصدق لما معهم نبذ فريق من الذين اوتوا الكتب كتب الله وراء ظهورهم كانهم لا يعلمون",
  },
  {
    verseId: 101,
    name: "البقرة",
    surahId: 2,
    text: "وَٱتَّبَعُواْ مَا تَتۡلُواْ ٱلشَّيَٰطِينُ عَلَىٰ مُلۡكِ سُلَيۡمَٰنَۖ وَمَا كَفَرَ سُلَيۡمَٰنُ وَلَٰكِنَّ ٱلشَّيَٰطِينَ كَفَرُواْ يُعَلِّمُونَ ٱلنَّاسَ ٱلسِّحۡرَ وَمَآ أُنزِلَ عَلَى ٱلۡمَلَكَيۡنِ بِبَابِلَ هَٰرُوتَ وَمَٰرُوتَۚ وَمَا يُعَلِّمَانِ مِنۡ أَحَدٍ حَتَّىٰ يَقُولَآ إِنَّمَا نَحۡنُ فِتۡنَةٞ فَلَا تَكۡفُرۡۖ فَيَتَعَلَّمُونَ مِنۡهُمَا مَا يُفَرِّقُونَ بِهِۦ بَيۡنَ ٱلۡمَرۡءِ وَزَوۡجِهِۦۚ وَمَا هُم بِضَآرِّينَ بِهِۦ مِنۡ أَحَدٍ إِلَّا بِإِذۡنِ ٱللَّهِۚ وَيَتَعَلَّمُونَ مَا يَضُرُّهُمۡ وَلَا يَنفَعُهُمۡۚ وَلَقَدۡ عَلِمُواْ لَمَنِ ٱشۡتَرَىٰهُ مَا لَهُۥ فِي ٱلۡأٓخِرَةِ مِنۡ خَلَٰقٖۚ وَلَبِئۡسَ مَا شَرَوۡاْ بِهِۦٓ أَنفُسَهُمۡۚ لَوۡ كَانُواْ يَعۡلَمُونَ",
    translation:
      'And they followed [instead] what the devils had recited during the reign of Solomon. It was not Solomon who disbelieved, but the devils disbelieved, teaching people magic and that which was revealed to the two angels at Babylon, Harut and Marut. But the two angels do not teach anyone unless they say, "We are a trial, so do not disbelieve [by practicing magic]." And [yet] they learn from them that by which they cause separation between a man and his wife. But they do not harm anyone through it except by permission of Allah. And the people learn what harms them and does not benefit them. But the Children of Israel certainly knew that whoever purchased the magic would not have in the Hereafter any share. And wretched is that for which they sold themselves, if they only knew',
    normalizedText:
      "واتبعوا ما تتلوا الشيطين على ملك سليمن وما كفر سليمن ولكن الشيطين كفروا يعلمون الناس السحر وما انزل على الملكين ببابل هروت ومروت وما يعلمان من احد حتى يقولا انما نحن فتنة فلا تكفر فيتعلمون منهما ما يفرقون به بين المرء وزوجه وما هم بضارين به من احد الا باذن الله ويتعلمون ما يضرهم ولا ينفعهم ولقد علموا لمن اشترىه ما له في الاخرة من خلق ولباس ما شروا به انفسهم لو كانوا يعلمون",
  },
  {
    verseId: 102,
    name: "البقرة",
    surahId: 2,
    text: "وَلَوۡ أَنَّهُمۡ ءَامَنُواْ وَٱتَّقَوۡاْ لَمَثُوبَةٞ مِّنۡ عِندِ ٱللَّهِ خَيۡرٞۚ لَّوۡ كَانُواْ يَعۡلَمُونَ",
    translation:
      "And if they had believed and feared Allah, then the reward from Allah would have been [far] better, if they only knew",
    normalizedText:
      "ولو انهم ءامنوا واتقوا لمثوبة من عند الله خير لو كانوا يعلمون",
  },
  {
    verseId: 103,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَقُولُواْ رَٰعِنَا وَقُولُواْ ٱنظُرۡنَا وَٱسۡمَعُواْۗ وَلِلۡكَٰفِرِينَ عَذَابٌ أَلِيمٞ",
    translation: `O you who have believed, say not [to Allah 's Messenger], "Ra'ina" but say, "Unthurna" and listen. And for the disbelievers is a painful punishment`,
    normalizedText:
      "يايها الذين ءامنوا لا تقولوا رعنا وقولوا انظرنا واسمعوا وللكفرين عذاب اليم",
  },
  {
    verseId: 104,
    name: "البقرة",
    surahId: 2,
    text: "مَّا يَوَدُّ ٱلَّذِينَ كَفَرُواْ مِنۡ أَهۡلِ ٱلۡكِتَٰبِ وَلَا ٱلۡمُشۡرِكِينَ أَن يُنَزَّلَ عَلَيۡكُم مِّنۡ خَيۡرٖ مِّن رَّبِّكُمۡۚ وَٱللَّهُ يَخۡتَصُّ بِرَحۡمَتِهِۦ مَن يَشَآءُۚ وَٱللَّهُ ذُو ٱلۡفَضۡلِ ٱلۡعَظِيمِ",
    translation:
      "Neither those who disbelieve from the People of the Scripture nor the polytheists wish that any good should be sent down to you from your Lord. But Allah selects for His mercy whom He wills, and Allah is the possessor of great bounty",
    normalizedText:
      "ما يود الذين كفروا من اهل الكتب ولا المشركين ان ينزل عليكم من خير من ربكم والله يختص برحمته من يشاء والله ذو الفضل العظيم",
  },
  {
    verseId: 105,
    name: "البقرة",
    surahId: 2,
    text: "۞مَا نَنسَخۡ مِنۡ ءَايَةٍ أَوۡ نُنسِهَا نَأۡتِ بِخَيۡرٖ مِّنۡهَآ أَوۡ مِثۡلِهَآۗ أَلَمۡ تَعۡلَمۡ أَنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "We do not abrogate a verse or cause it to be forgotten except that We bring forth [one] better than it or similar to it. Do you not know that Allah is over all things competent",
    normalizedText:
      "۞ما ننسخ من ءاية او ننسها نات بخير منها او مثلها الم تعلم ان الله على كل شيء قدير",
  },
  {
    verseId: 106,
    name: "البقرة",
    surahId: 2,
    text: "أَلَمۡ تَعۡلَمۡ أَنَّ ٱللَّهَ لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۗ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِيّٖ وَلَا نَصِيرٍ",
    translation:
      "Do you not know that to Allah belongs the dominion of the heavens and the earth and [that] you have not besides Allah any protector or any helper",
    normalizedText:
      "الم تعلم ان الله له ملك السموت والارض وما لكم من دون الله من ولي ولا نصير",
  },
  {
    verseId: 107,
    name: "البقرة",
    surahId: 2,
    text: "أَمۡ تُرِيدُونَ أَن تَسۡـَٔلُواْ رَسُولَكُمۡ كَمَا سُئِلَ مُوسَىٰ مِن قَبۡلُۗ وَمَن يَتَبَدَّلِ ٱلۡكُفۡرَ بِٱلۡإِيمَٰنِ فَقَدۡ ضَلَّ سَوَآءَ ٱلسَّبِيلِ",
    translation:
      "Or do you intend to ask your Messenger as Moses was asked before? And whoever exchanges faith for disbelief has certainly strayed from the soundness of the way",
    normalizedText:
      "ام تريدون ان تسلوا رسولكم كما سال موسى من قبل ومن يتبدل الكفر بالايمن فقد ضل سواء السبيل",
  },
  {
    verseId: 108,
    name: "البقرة",
    surahId: 2,
    text: "وَدَّ كَثِيرٞ مِّنۡ أَهۡلِ ٱلۡكِتَٰبِ لَوۡ يَرُدُّونَكُم مِّنۢ بَعۡدِ إِيمَٰنِكُمۡ كُفَّارًا حَسَدٗا مِّنۡ عِندِ أَنفُسِهِم مِّنۢ بَعۡدِ مَا تَبَيَّنَ لَهُمُ ٱلۡحَقُّۖ فَٱعۡفُواْ وَٱصۡفَحُواْ حَتَّىٰ يَأۡتِيَ ٱللَّهُ بِأَمۡرِهِۦٓۗ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "Many of the People of the Scripture wish they could turn you back to disbelief after you have believed, out of envy from themselves [even] after the truth has become clear to them. So pardon and overlook until Allah delivers His command. Indeed, Allah is over all things competent",
    normalizedText:
      "ود كثير من اهل الكتب لو يردونكم من بعد ايمنكم كفارا حسدا من عند انفسهم من بعد ما تبين لهم الحق فاعفوا واصفحوا حتى ياتي الله بامره ان الله على كل شيء قدير",
  },
  {
    verseId: 109,
    name: "البقرة",
    surahId: 2,
    text: "وَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَۚ وَمَا تُقَدِّمُواْ لِأَنفُسِكُم مِّنۡ خَيۡرٖ تَجِدُوهُ عِندَ ٱللَّهِۗ إِنَّ ٱللَّهَ بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      "And establish prayer and give zakah, and whatever good you put forward for yourselves - you will find it with Allah. Indeed, Allah of what you do, is Seeing",
    normalizedText:
      "واقيموا الصلوة وءاتوا الزكوة وما تقدموا لانفسكم من خير تجدوه عند الله ان الله بما تعملون بصير",
  },
  {
    verseId: 110,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالُواْ لَن يَدۡخُلَ ٱلۡجَنَّةَ إِلَّا مَن كَانَ هُودًا أَوۡ نَصَٰرَىٰۗ تِلۡكَ أَمَانِيُّهُمۡۗ قُلۡ هَاتُواْ بُرۡهَٰنَكُمۡ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "None will enter Paradise except one who is a Jew or a Christian." That is [merely] their wishful thinking, Say, "Produce your proof, if you should be truthful',
    normalizedText:
      "وقالوا لن يدخل الجنة الا من كان هودا او نصرى تلك امانيهم قل هاتوا برهنكم ان كنتم صدقين",
  },
  {
    verseId: 111,
    name: "البقرة",
    surahId: 2,
    text: "بَلَىٰۚ مَنۡ أَسۡلَمَ وَجۡهَهُۥ لِلَّهِ وَهُوَ مُحۡسِنٞ فَلَهُۥٓ أَجۡرُهُۥ عِندَ رَبِّهِۦ وَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Yes [on the contrary], whoever submits his face in Islam to Allah while being a doer of good will have his reward with his Lord. And no fear will there be concerning them, nor will they grieve",
    normalizedText:
      "بلى من اسلم وجهه لله وهو محسن فله اجره عند ربه ولا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 112,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالَتِ ٱلۡيَهُودُ لَيۡسَتِ ٱلنَّصَٰرَىٰ عَلَىٰ شَيۡءٖ وَقَالَتِ ٱلنَّصَٰرَىٰ لَيۡسَتِ ٱلۡيَهُودُ عَلَىٰ شَيۡءٖ وَهُمۡ يَتۡلُونَ ٱلۡكِتَٰبَۗ كَذَٰلِكَ قَالَ ٱلَّذِينَ لَا يَعۡلَمُونَ مِثۡلَ قَوۡلِهِمۡۚ فَٱللَّهُ يَحۡكُمُ بَيۡنَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ فِيمَا كَانُواْ فِيهِ يَخۡتَلِفُونَ",
    translation:
      'The Jews say "The Christians have nothing [true] to stand on," and the Christians say, "The Jews have nothing to stand on," although they [both] recite the Scripture. Thus the polytheists speak the same as their words. But Allah will judge between them on the Day of Resurrection concerning that over which they used to differ',
    normalizedText:
      "وقالت اليهود ليست النصرى على شيء وقالت النصرى ليست اليهود على شيء وهم يتلون الكتب كذلك قال الذين لا يعلمون مثل قولهم فالله يحكم بينهم يوم القيمة فيما كانوا فيه يختلفون",
  },
  {
    verseId: 113,
    name: "البقرة",
    surahId: 2,
    text: "وَمَنۡ أَظۡلَمُ مِمَّن مَّنَعَ مَسَٰجِدَ ٱللَّهِ أَن يُذۡكَرَ فِيهَا ٱسۡمُهُۥ وَسَعَىٰ فِي خَرَابِهَآۚ أُوْلَـٰٓئِكَ مَا كَانَ لَهُمۡ أَن يَدۡخُلُوهَآ إِلَّا خَآئِفِينَۚ لَهُمۡ فِي ٱلدُّنۡيَا خِزۡيٞ وَلَهُمۡ فِي ٱلۡأٓخِرَةِ عَذَابٌ عَظِيمٞ",
    translation:
      "And who are more unjust than those who prevent the name of Allah from being mentioned in His mosques and strive toward their destruction. It is not for them to enter them except in fear. For them in this world is disgrace, and they will have in the Hereafter a great punishment",
    normalizedText:
      "ومن اظلم ممن منع مسجد الله ان يذكر فيها اسمه وسعى في خرابها اولاك ما كان لهم ان يدخلوها الا خاافين لهم في الدنيا خزي ولهم في الاخرة عذاب عظيم",
  },
  {
    verseId: 114,
    name: "البقرة",
    surahId: 2,
    text: "وَلِلَّهِ ٱلۡمَشۡرِقُ وَٱلۡمَغۡرِبُۚ فَأَيۡنَمَا تُوَلُّواْ فَثَمَّ وَجۡهُ ٱللَّهِۚ إِنَّ ٱللَّهَ وَٰسِعٌ عَلِيمٞ",
    translation:
      "And to Allah belongs the east and the west. So wherever you [might] turn, there is the Face of Allah. Indeed, Allah is all-Encompassing and Knowing",
    normalizedText:
      "ولله المشرق والمغرب فاينما تولوا فثم وجه الله ان الله وسع عليم",
  },
  {
    verseId: 115,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالُواْ ٱتَّخَذَ ٱللَّهُ وَلَدٗاۗ سُبۡحَٰنَهُۥۖ بَل لَّهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ كُلّٞ لَّهُۥ قَٰنِتُونَ",
    translation:
      'They say, "Allah has taken a son." Exalted is He! Rather, to Him belongs whatever is in the heavens and the earth. All are devoutly obedient to Him',
    normalizedText:
      "وقالوا اتخذ الله ولدا سبحنه بل له ما في السموت والارض كل له قنتون",
  },
  {
    verseId: 116,
    name: "البقرة",
    surahId: 2,
    text: "بَدِيعُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ وَإِذَا قَضَىٰٓ أَمۡرٗا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ",
    translation:
      'Originator of the heavens and the earth. When He decrees a matter, He only says to it, "Be," and it is',
    normalizedText: "بديع السموت والارض واذا قضى امرا فانما يقول له كن فيكون",
  },
  {
    verseId: 117,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالَ ٱلَّذِينَ لَا يَعۡلَمُونَ لَوۡلَا يُكَلِّمُنَا ٱللَّهُ أَوۡ تَأۡتِينَآ ءَايَةٞۗ كَذَٰلِكَ قَالَ ٱلَّذِينَ مِن قَبۡلِهِم مِّثۡلَ قَوۡلِهِمۡۘ تَشَٰبَهَتۡ قُلُوبُهُمۡۗ قَدۡ بَيَّنَّا ٱلۡأٓيَٰتِ لِقَوۡمٖ يُوقِنُونَ",
    translation:
      'Those who do not know say, "Why does Allah not speak to us or there come to us a sign?" Thus spoke those before them like their words. Their hearts resemble each other. We have shown clearly the signs to a people who are certain [in faith]',
    normalizedText:
      "وقال الذين لا يعلمون لولا يكلمنا الله او تاتينا ءاية كذلك قال الذين من قبلهم مثل قولهم تشبهت قلوبهم قد بينا الايت لقوم يوقنون",
  },
  {
    verseId: 118,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّآ أَرۡسَلۡنَٰكَ بِٱلۡحَقِّ بَشِيرٗا وَنَذِيرٗاۖ وَلَا تُسۡـَٔلُ عَنۡ أَصۡحَٰبِ ٱلۡجَحِيمِ",
    translation:
      "Indeed, We have sent you, [O Muhammad], with the truth as a bringer of good tidings and a warner, and you will not be asked about the companions of Hellfire",
    normalizedText: "انا ارسلنك بالحق بشيرا ونذيرا ولا تسل عن اصحب الجحيم",
  },
  {
    verseId: 119,
    name: "البقرة",
    surahId: 2,
    text: "وَلَن تَرۡضَىٰ عَنكَ ٱلۡيَهُودُ وَلَا ٱلنَّصَٰرَىٰ حَتَّىٰ تَتَّبِعَ مِلَّتَهُمۡۗ قُلۡ إِنَّ هُدَى ٱللَّهِ هُوَ ٱلۡهُدَىٰۗ وَلَئِنِ ٱتَّبَعۡتَ أَهۡوَآءَهُم بَعۡدَ ٱلَّذِي جَآءَكَ مِنَ ٱلۡعِلۡمِ مَا لَكَ مِنَ ٱللَّهِ مِن وَلِيّٖ وَلَا نَصِيرٍ",
    translation:
      'And never will the Jews or the Christians approve of you until you follow their religion. Say, "Indeed, the guidance of Allah is the [only] guidance." If you were to follow their desires after what has come to you of knowledge, you would have against Allah no protector or helper',
    normalizedText:
      "ولن ترضى عنك اليهود ولا النصرى حتى تتبع ملتهم قل ان هدى الله هو الهدى ولان اتبعت اهواءهم بعد الذي جاءك من العلم ما لك من الله من ولي ولا نصير",
  },
  {
    verseId: 120,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ يَتۡلُونَهُۥ حَقَّ تِلَاوَتِهِۦٓ أُوْلَـٰٓئِكَ يُؤۡمِنُونَ بِهِۦۗ وَمَن يَكۡفُرۡ بِهِۦ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "Those to whom We have given the Book recite it with its true recital. They [are the ones who] believe in it. And whoever disbelieves in it - it is they who are the losers",
    normalizedText:
      "الذين ءاتينهم الكتب يتلونه حق تلاوته اولاك يامنون به ومن يكفر به فاولاك هم الخسرون",
  },
  {
    verseId: 121,
    name: "البقرة",
    surahId: 2,
    text: "يَٰبَنِيٓ إِسۡرَـٰٓءِيلَ ٱذۡكُرُواْ نِعۡمَتِيَ ٱلَّتِيٓ أَنۡعَمۡتُ عَلَيۡكُمۡ وَأَنِّي فَضَّلۡتُكُمۡ عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      "O Children of Israel, remember My favor which I have bestowed upon you and that I preferred you over the worlds",
    normalizedText:
      "يبني اسرءيل اذكروا نعمتي التي انعمت عليكم واني فضلتكم على العلمين",
  },
  {
    verseId: 122,
    name: "البقرة",
    surahId: 2,
    text: "وَٱتَّقُواْ يَوۡمٗا لَّا تَجۡزِي نَفۡسٌ عَن نَّفۡسٖ شَيۡـٔٗا وَلَا يُقۡبَلُ مِنۡهَا عَدۡلٞ وَلَا تَنفَعُهَا شَفَٰعَةٞ وَلَا هُمۡ يُنصَرُونَ",
    translation:
      "And fear a Day when no soul will suffice for another soul at all, and no compensation will be accepted from it, nor will any intercession benefit it, nor will they be aided",
    normalizedText:
      "واتقوا يوما لا تجزي نفس عن نفس شيا ولا يقبل منها عدل ولا تنفعها شفعة ولا هم ينصرون",
  },
  {
    verseId: 123,
    name: "البقرة",
    surahId: 2,
    text: "۞وَإِذِ ٱبۡتَلَىٰٓ إِبۡرَٰهِـۧمَ رَبُّهُۥ بِكَلِمَٰتٖ فَأَتَمَّهُنَّۖ قَالَ إِنِّي جَاعِلُكَ لِلنَّاسِ إِمَامٗاۖ قَالَ وَمِن ذُرِّيَّتِيۖ قَالَ لَا يَنَالُ عَهۡدِي ٱلظَّـٰلِمِينَ",
    translation:
      'And [mention, O Muhammad], when Abraham was tried by his Lord with commands and he fulfilled them. [Allah] said, "Indeed, I will make you a leader for the people." [Abraham] said, "And of my descendants?" [Allah] said, "My covenant does not include the wrongdoers',
    normalizedText:
      "۞واذ ابتلى ابرهم ربه بكلمت فاتمهن قال اني جاعلك للناس اماما قال ومن ذريتي قال لا ينال عهدي الظلمين",
  },
  {
    verseId: 124,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ جَعَلۡنَا ٱلۡبَيۡتَ مَثَابَةٗ لِّلنَّاسِ وَأَمۡنٗا وَٱتَّخِذُواْ مِن مَّقَامِ إِبۡرَٰهِـۧمَ مُصَلّٗىۖ وَعَهِدۡنَآ إِلَىٰٓ إِبۡرَٰهِـۧمَ وَإِسۡمَٰعِيلَ أَن طَهِّرَا بَيۡتِيَ لِلطَّآئِفِينَ وَٱلۡعَٰكِفِينَ وَٱلرُّكَّعِ ٱلسُّجُودِ",
    translation:
      'And [mention] when We made the House a place of return for the people and [a place of] security. And take, [O believers], from the standing place of Abraham a place of prayer. And We charged Abraham and Ishmael, [saying], "Purify My House for those who perform Tawaf and those who are staying [there] for worship and those who bow and prostrate [in prayer]',
    normalizedText:
      "واذ جعلنا البيت مثابة للناس وامنا واتخذوا من مقام ابرهم مصلى وعهدنا الى ابرهم واسمعيل ان طهرا بيتي للطاافين والعكفين والركع السجود",
  },
  {
    verseId: 125,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قَالَ إِبۡرَٰهِـۧمُ رَبِّ ٱجۡعَلۡ هَٰذَا بَلَدًا ءَامِنٗا وَٱرۡزُقۡ أَهۡلَهُۥ مِنَ ٱلثَّمَرَٰتِ مَنۡ ءَامَنَ مِنۡهُم بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِۚ قَالَ وَمَن كَفَرَ فَأُمَتِّعُهُۥ قَلِيلٗا ثُمَّ أَضۡطَرُّهُۥٓ إِلَىٰ عَذَابِ ٱلنَّارِۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      'And [mention] when Abraham said, "My Lord, make this a secure city and provide its people with fruits - whoever of them believes in Allah and the Last Day." [Allah] said. "And whoever disbelieves - I will grant him enjoyment for a little; then I will force him to the punishment of the Fire, and wretched is the destination',
    normalizedText:
      "واذ قال ابرهم رب اجعل هذا بلدا ءامنا وارزق اهله من الثمرت من ءامن منهم بالله واليوم الاخر قال ومن كفر فامتعه قليلا ثم اضطره الى عذاب النار وباس المصير",
  },
  {
    verseId: 126,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ يَرۡفَعُ إِبۡرَٰهِـۧمُ ٱلۡقَوَاعِدَ مِنَ ٱلۡبَيۡتِ وَإِسۡمَٰعِيلُ رَبَّنَا تَقَبَّلۡ مِنَّآۖ إِنَّكَ أَنتَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      'And [mention] when Abraham was raising the foundations of the House and [with him] Ishmael, [saying], "Our Lord, accept [this] from us. Indeed You are the Hearing, the Knowing',
    normalizedText:
      "واذ يرفع ابرهم القواعد من البيت واسمعيل ربنا تقبل منا انك انت السميع العليم",
  },
  {
    verseId: 127,
    name: "البقرة",
    surahId: 2,
    text: "رَبَّنَا وَٱجۡعَلۡنَا مُسۡلِمَيۡنِ لَكَ وَمِن ذُرِّيَّتِنَآ أُمَّةٗ مُّسۡلِمَةٗ لَّكَ وَأَرِنَا مَنَاسِكَنَا وَتُبۡ عَلَيۡنَآۖ إِنَّكَ أَنتَ ٱلتَّوَّابُ ٱلرَّحِيمُ",
    translation:
      "Our Lord, and make us Muslims [in submission] to You and from our descendants a Muslim nation [in submission] to You. And show us our rites and accept our repentance. Indeed, You are the Accepting of repentance, the Merciful",
    normalizedText:
      "ربنا واجعلنا مسلمين لك ومن ذريتنا امة مسلمة لك وارنا مناسكنا وتب علينا انك انت التواب الرحيم",
  },
  {
    verseId: 128,
    name: "البقرة",
    surahId: 2,
    text: "رَبَّنَا وَٱبۡعَثۡ فِيهِمۡ رَسُولٗا مِّنۡهُمۡ يَتۡلُواْ عَلَيۡهِمۡ ءَايَٰتِكَ وَيُعَلِّمُهُمُ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَيُزَكِّيهِمۡۖ إِنَّكَ أَنتَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Our Lord, and send among them a messenger from themselves who will recite to them Your verses and teach them the Book and wisdom and purify them. Indeed, You are the Exalted in Might, the Wise",
    normalizedText:
      "ربنا وابعث فيهم رسولا منهم يتلوا عليهم ءايتك ويعلمهم الكتب والحكمة ويزكيهم انك انت العزيز الحكيم",
  },
  {
    verseId: 129,
    name: "البقرة",
    surahId: 2,
    text: "وَمَن يَرۡغَبُ عَن مِّلَّةِ إِبۡرَٰهِـۧمَ إِلَّا مَن سَفِهَ نَفۡسَهُۥۚ وَلَقَدِ ٱصۡطَفَيۡنَٰهُ فِي ٱلدُّنۡيَاۖ وَإِنَّهُۥ فِي ٱلۡأٓخِرَةِ لَمِنَ ٱلصَّـٰلِحِينَ",
    translation:
      "And who would be averse to the religion of Abraham except one who makes a fool of himself. And We had chosen him in this world, and indeed he, in the Hereafter, will be among the righteous",
    normalizedText:
      "ومن يرغب عن ملة ابرهم الا من سفه نفسه ولقد اصطفينه في الدنيا وانه في الاخرة لمن الصلحين",
  },
  {
    verseId: 130,
    name: "البقرة",
    surahId: 2,
    text: "إِذۡ قَالَ لَهُۥ رَبُّهُۥٓ أَسۡلِمۡۖ قَالَ أَسۡلَمۡتُ لِرَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'When his Lord said to him, "Submit", he said "I have submitted [in Islam] to the Lord of the worlds',
    normalizedText: "اذ قال له ربه اسلم قال اسلمت لرب العلمين",
  },
  {
    verseId: 131,
    name: "البقرة",
    surahId: 2,
    text: "وَوَصَّىٰ بِهَآ إِبۡرَٰهِـۧمُ بَنِيهِ وَيَعۡقُوبُ يَٰبَنِيَّ إِنَّ ٱللَّهَ ٱصۡطَفَىٰ لَكُمُ ٱلدِّينَ فَلَا تَمُوتُنَّ إِلَّا وَأَنتُم مُّسۡلِمُونَ",
    translation:
      'And Abraham instructed his sons [to do the same] and [so did] Jacob, [saying], "O my sons, indeed Allah has chosen for you this religion, so do not die except while you are Muslims',
    normalizedText:
      "ووصى بها ابرهم بنيه ويعقوب يبني ان الله اصطفى لكم الدين فلا تموتن الا وانتم مسلمون",
  },
  {
    verseId: 132,
    name: "البقرة",
    surahId: 2,
    text: "أَمۡ كُنتُمۡ شُهَدَآءَ إِذۡ حَضَرَ يَعۡقُوبَ ٱلۡمَوۡتُ إِذۡ قَالَ لِبَنِيهِ مَا تَعۡبُدُونَ مِنۢ بَعۡدِيۖ قَالُواْ نَعۡبُدُ إِلَٰهَكَ وَإِلَٰهَ ءَابَآئِكَ إِبۡرَٰهِـۧمَ وَإِسۡمَٰعِيلَ وَإِسۡحَٰقَ إِلَٰهٗا وَٰحِدٗا وَنَحۡنُ لَهُۥ مُسۡلِمُونَ",
    translation:
      'Or were you witnesses when death approached Jacob, when he said to his sons, "What will you worship after me?" They said, "We will worship your God and the God of your fathers, Abraham and Ishmael and Isaac - one God. And we are Muslims [in submission] to Him',
    normalizedText:
      "ام كنتم شهداء اذ حضر يعقوب الموت اذ قال لبنيه ما تعبدون من بعدي قالوا نعبد الهك واله ءابااك ابرهم واسمعيل واسحق الها وحدا ونحن له مسلمون",
  },
  {
    verseId: 133,
    name: "البقرة",
    surahId: 2,
    text: "تِلۡكَ أُمَّةٞ قَدۡ خَلَتۡۖ لَهَا مَا كَسَبَتۡ وَلَكُم مَّا كَسَبۡتُمۡۖ وَلَا تُسۡـَٔلُونَ عَمَّا كَانُواْ يَعۡمَلُونَ",
    translation:
      "That was a nation which has passed on. It will have [the consequence of] what it earned, and you will have what you have earned. And you will not be asked about what they used to do",
    normalizedText:
      "تلك امة قد خلت لها ما كسبت ولكم ما كسبتم ولا تسلون عما كانوا يعملون",
  },
  {
    verseId: 134,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالُواْ كُونُواْ هُودًا أَوۡ نَصَٰرَىٰ تَهۡتَدُواْۗ قُلۡ بَلۡ مِلَّةَ إِبۡرَٰهِـۧمَ حَنِيفٗاۖ وَمَا كَانَ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      'They say, "Be Jews or Christians [so] you will be guided." Say, "Rather, [we follow] the religion of Abraham, inclining toward truth, and he was not of the polytheists',
    normalizedText:
      "وقالوا كونوا هودا او نصرى تهتدوا قل بل ملة ابرهم حنيفا وما كان من المشركين",
  },
  {
    verseId: 135,
    name: "البقرة",
    surahId: 2,
    text: "قُولُوٓاْ ءَامَنَّا بِٱللَّهِ وَمَآ أُنزِلَ إِلَيۡنَا وَمَآ أُنزِلَ إِلَىٰٓ إِبۡرَٰهِـۧمَ وَإِسۡمَٰعِيلَ وَإِسۡحَٰقَ وَيَعۡقُوبَ وَٱلۡأَسۡبَاطِ وَمَآ أُوتِيَ مُوسَىٰ وَعِيسَىٰ وَمَآ أُوتِيَ ٱلنَّبِيُّونَ مِن رَّبِّهِمۡ لَا نُفَرِّقُ بَيۡنَ أَحَدٖ مِّنۡهُمۡ وَنَحۡنُ لَهُۥ مُسۡلِمُونَ",
    translation:
      'Say, [O believers], "We have believed in Allah and what has been revealed to us and what has been revealed to Abraham and Ishmael and Isaac and Jacob and the Descendants and what was given to Moses and Jesus and what was given to the prophets from their Lord. We make no distinction between any of them, and we are Muslims [in submission] to Him',
    normalizedText:
      "قولوا ءامنا بالله وما انزل الينا وما انزل الى ابرهم واسمعيل واسحق ويعقوب والاسباط وما اوتي موسى وعيسى وما اوتي النبيون من ربهم لا نفرق بين احد منهم ونحن له مسلمون",
  },
  {
    verseId: 136,
    name: "البقرة",
    surahId: 2,
    text: "فَإِنۡ ءَامَنُواْ بِمِثۡلِ مَآ ءَامَنتُم بِهِۦ فَقَدِ ٱهۡتَدَواْۖ وَّإِن تَوَلَّوۡاْ فَإِنَّمَا هُمۡ فِي شِقَاقٖۖ فَسَيَكۡفِيكَهُمُ ٱللَّهُۚ وَهُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "So if they believe in the same as you believe in, then they have been [rightly] guided; but if they turn away, they are only in dissension, and Allah will be sufficient for you against them. And He is the Hearing, the Knowing",
    normalizedText:
      "فان ءامنوا بمثل ما ءامنتم به فقد اهتدوا وان تولوا فانما هم في شقاق فسيكفيكهم الله وهو السميع العليم",
  },
  {
    verseId: 137,
    name: "البقرة",
    surahId: 2,
    text: "صِبۡغَةَ ٱللَّهِ وَمَنۡ أَحۡسَنُ مِنَ ٱللَّهِ صِبۡغَةٗۖ وَنَحۡنُ لَهُۥ عَٰبِدُونَ",
    translation:
      '[And say, "Ours is] the religion of Allah. And who is better than Allah in [ordaining] religion? And we are worshippers of Him',
    normalizedText: "صبغة الله ومن احسن من الله صبغة ونحن له عبدون",
  },
  {
    verseId: 138,
    name: "البقرة",
    surahId: 2,
    text: "قُلۡ أَتُحَآجُّونَنَا فِي ٱللَّهِ وَهُوَ رَبُّنَا وَرَبُّكُمۡ وَلَنَآ أَعۡمَٰلُنَا وَلَكُمۡ أَعۡمَٰلُكُمۡ وَنَحۡنُ لَهُۥ مُخۡلِصُونَ",
    translation:
      'Say, [O Muhammad], "Do you argue with us about Allah while He is our Lord and your Lord? For us are our deeds, and for you are your deeds. And we are sincere [in deed and intention] to Him',
    normalizedText:
      "قل اتحاجوننا في الله وهو ربنا وربكم ولنا اعملنا ولكم اعملكم ونحن له مخلصون",
  },
  {
    verseId: 139,
    name: "البقرة",
    surahId: 2,
    text: "أَمۡ تَقُولُونَ إِنَّ إِبۡرَٰهِـۧمَ وَإِسۡمَٰعِيلَ وَإِسۡحَٰقَ وَيَعۡقُوبَ وَٱلۡأَسۡبَاطَ كَانُواْ هُودًا أَوۡ نَصَٰرَىٰۗ قُلۡ ءَأَنتُمۡ أَعۡلَمُ أَمِ ٱللَّهُۗ وَمَنۡ أَظۡلَمُ مِمَّن كَتَمَ شَهَٰدَةً عِندَهُۥ مِنَ ٱللَّهِۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ",
    translation:
      'Or do you say that Abraham and Ishmael and Isaac and Jacob and the Descendants were Jews or Christians? Say, "Are you more knowing or is Allah?" And who is more unjust than one who conceals a testimony he has from Allah? And Allah is not unaware of what you do',
    normalizedText:
      "ام تقولون ان ابرهم واسمعيل واسحق ويعقوب والاسباط كانوا هودا او نصرى قل ءانتم اعلم ام الله ومن اظلم ممن كتم شهدة عنده من الله وما الله بغفل عما تعملون",
  },
  {
    verseId: 140,
    name: "البقرة",
    surahId: 2,
    text: "تِلۡكَ أُمَّةٞ قَدۡ خَلَتۡۖ لَهَا مَا كَسَبَتۡ وَلَكُم مَّا كَسَبۡتُمۡۖ وَلَا تُسۡـَٔلُونَ عَمَّا كَانُواْ يَعۡمَلُونَ",
    translation:
      "That is a nation which has passed on. It will have [the consequence of] what it earned, and you will have what you have earned. And you will not be asked about what they used to do",
    normalizedText:
      "تلك امة قد خلت لها ما كسبت ولكم ما كسبتم ولا تسلون عما كانوا يعملون",
  },
  {
    verseId: 141,
    name: "البقرة",
    surahId: 2,
    text: "۞سَيَقُولُ ٱلسُّفَهَآءُ مِنَ ٱلنَّاسِ مَا وَلَّىٰهُمۡ عَن قِبۡلَتِهِمُ ٱلَّتِي كَانُواْ عَلَيۡهَاۚ قُل لِّلَّهِ ٱلۡمَشۡرِقُ وَٱلۡمَغۡرِبُۚ يَهۡدِي مَن يَشَآءُ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      'The foolish among the people will say, "What has turned them away from their qiblah, which they used to face?" Say, "To Allah belongs the east and the west. He guides whom He wills to a straight path',
    normalizedText:
      "۞سيقول السفهاء من الناس ما ولىهم عن قبلتهم التي كانوا عليها قل لله المشرق والمغرب يهدي من يشاء الى صرط مستقيم",
  },
  {
    verseId: 142,
    name: "البقرة",
    surahId: 2,
    text: "وَكَذَٰلِكَ جَعَلۡنَٰكُمۡ أُمَّةٗ وَسَطٗا لِّتَكُونُواْ شُهَدَآءَ عَلَى ٱلنَّاسِ وَيَكُونَ ٱلرَّسُولُ عَلَيۡكُمۡ شَهِيدٗاۗ وَمَا جَعَلۡنَا ٱلۡقِبۡلَةَ ٱلَّتِي كُنتَ عَلَيۡهَآ إِلَّا لِنَعۡلَمَ مَن يَتَّبِعُ ٱلرَّسُولَ مِمَّن يَنقَلِبُ عَلَىٰ عَقِبَيۡهِۚ وَإِن كَانَتۡ لَكَبِيرَةً إِلَّا عَلَى ٱلَّذِينَ هَدَى ٱللَّهُۗ وَمَا كَانَ ٱللَّهُ لِيُضِيعَ إِيمَٰنَكُمۡۚ إِنَّ ٱللَّهَ بِٱلنَّاسِ لَرَءُوفٞ رَّحِيمٞ",
    translation:
      "And thus we have made you a just community that you will be witnesses over the people and the Messenger will be a witness over you. And We did not make the qiblah which you used to face except that We might make evident who would follow the Messenger from who would turn back on his heels. And indeed, it is difficult except for those whom Allah has guided. And never would Allah have caused you to lose your faith. Indeed Allah is, to the people, Kind and Merciful",
    normalizedText:
      "وكذلك جعلنكم امة وسطا لتكونوا شهداء على الناس ويكون الرسول عليكم شهيدا وما جعلنا القبلة التي كنت عليها الا لنعلم من يتبع الرسول ممن ينقلب على عقبيه وان كانت لكبيرة الا على الذين هدى الله وما كان الله ليضيع ايمنكم ان الله بالناس لرءوف رحيم",
  },
  {
    verseId: 143,
    name: "البقرة",
    surahId: 2,
    text: "قَدۡ نَرَىٰ تَقَلُّبَ وَجۡهِكَ فِي ٱلسَّمَآءِۖ فَلَنُوَلِّيَنَّكَ قِبۡلَةٗ تَرۡضَىٰهَاۚ فَوَلِّ وَجۡهَكَ شَطۡرَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِۚ وَحَيۡثُ مَا كُنتُمۡ فَوَلُّواْ وُجُوهَكُمۡ شَطۡرَهُۥۗ وَإِنَّ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ لَيَعۡلَمُونَ أَنَّهُ ٱلۡحَقُّ مِن رَّبِّهِمۡۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا يَعۡمَلُونَ",
    translation:
      "We have certainly seen the turning of your face, [O Muhammad], toward the heaven, and We will surely turn you to a qiblah with which you will be pleased. So turn your face toward al-Masjid al-Haram. And wherever you [believers] are, turn your faces toward it [in prayer]. Indeed, those who have been given the Scripture well know that it is the truth from their Lord. And Allah is not unaware of what they do",
    normalizedText:
      "قد نرى تقلب وجهك في السماء فلنولينك قبلة ترضىها فول وجهك شطر المسجد الحرام وحيث ما كنتم فولوا وجوهكم شطره وان الذين اوتوا الكتب ليعلمون انه الحق من ربهم وما الله بغفل عما يعملون",
  },
  {
    verseId: 144,
    name: "البقرة",
    surahId: 2,
    text: "وَلَئِنۡ أَتَيۡتَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ بِكُلِّ ءَايَةٖ مَّا تَبِعُواْ قِبۡلَتَكَۚ وَمَآ أَنتَ بِتَابِعٖ قِبۡلَتَهُمۡۚ وَمَا بَعۡضُهُم بِتَابِعٖ قِبۡلَةَ بَعۡضٖۚ وَلَئِنِ ٱتَّبَعۡتَ أَهۡوَآءَهُم مِّنۢ بَعۡدِ مَا جَآءَكَ مِنَ ٱلۡعِلۡمِ إِنَّكَ إِذٗا لَّمِنَ ٱلظَّـٰلِمِينَ",
    translation:
      "And if you brought to those who were given the Scripture every sign, they would not follow your qiblah. Nor will you be a follower of their qiblah. Nor would they be followers of one another's qiblah. So if you were to follow their desires after what has come to you of knowledge, indeed, you would then be among the wrongdoers",
    normalizedText:
      "ولان اتيت الذين اوتوا الكتب بكل ءاية ما تبعوا قبلتك وما انت بتابع قبلتهم وما بعضهم بتابع قبلة بعض ولان اتبعت اهواءهم من بعد ما جاءك من العلم انك اذا لمن الظلمين",
  },
  {
    verseId: 145,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ يَعۡرِفُونَهُۥ كَمَا يَعۡرِفُونَ أَبۡنَآءَهُمۡۖ وَإِنَّ فَرِيقٗا مِّنۡهُمۡ لَيَكۡتُمُونَ ٱلۡحَقَّ وَهُمۡ يَعۡلَمُونَ",
    translation:
      "Those to whom We gave the Scripture know him as they know their own sons. But indeed, a party of them conceal the truth while they know [it]",
    normalizedText:
      "الذين ءاتينهم الكتب يعرفونه كما يعرفون ابناءهم وان فريقا منهم ليكتمون الحق وهم يعلمون",
  },
  {
    verseId: 146,
    name: "البقرة",
    surahId: 2,
    text: "ٱلۡحَقُّ مِن رَّبِّكَ فَلَا تَكُونَنَّ مِنَ ٱلۡمُمۡتَرِينَ",
    translation: "The truth is from your Lord, so never be among the doubters",
    normalizedText: "الحق من ربك فلا تكونن من الممترين",
  },
  {
    verseId: 147,
    name: "البقرة",
    surahId: 2,
    text: "وَلِكُلّٖ وِجۡهَةٌ هُوَ مُوَلِّيهَاۖ فَٱسۡتَبِقُواْ ٱلۡخَيۡرَٰتِۚ أَيۡنَ مَا تَكُونُواْ يَأۡتِ بِكُمُ ٱللَّهُ جَمِيعًاۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "For each [religious following] is a direction toward which it faces. So race to [all that is] good. Wherever you may be, Allah will bring you forth [for judgement] all together. Indeed, Allah is over all things competent",
    normalizedText:
      "ولكل وجهة هو موليها فاستبقوا الخيرت اين ما تكونوا يات بكم الله جميعا ان الله على كل شيء قدير",
  },
  {
    verseId: 148,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنۡ حَيۡثُ خَرَجۡتَ فَوَلِّ وَجۡهَكَ شَطۡرَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِۖ وَإِنَّهُۥ لَلۡحَقُّ مِن رَّبِّكَۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ",
    translation:
      "So from wherever you go out [for prayer, O Muhammad] turn your face toward al- Masjid al-Haram, and indeed, it is the truth from your Lord. And Allah is not unaware of what you do",
    normalizedText:
      "ومن حيث خرجت فول وجهك شطر المسجد الحرام وانه للحق من ربك وما الله بغفل عما تعملون",
  },
  {
    verseId: 149,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنۡ حَيۡثُ خَرَجۡتَ فَوَلِّ وَجۡهَكَ شَطۡرَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِۚ وَحَيۡثُ مَا كُنتُمۡ فَوَلُّواْ وُجُوهَكُمۡ شَطۡرَهُۥ لِئَلَّا يَكُونَ لِلنَّاسِ عَلَيۡكُمۡ حُجَّةٌ إِلَّا ٱلَّذِينَ ظَلَمُواْ مِنۡهُمۡ فَلَا تَخۡشَوۡهُمۡ وَٱخۡشَوۡنِي وَلِأُتِمَّ نِعۡمَتِي عَلَيۡكُمۡ وَلَعَلَّكُمۡ تَهۡتَدُونَ",
    translation:
      "And from wherever you go out [for prayer], turn your face toward al-Masjid al-Haram. And wherever you [believers] may be, turn your faces toward it in order that the people will not have any argument against you, except for those of them who commit wrong; so fear them not but fear Me. And [it is] so I may complete My favor upon you and that you may be guided",
    normalizedText:
      "ومن حيث خرجت فول وجهك شطر المسجد الحرام وحيث ما كنتم فولوا وجوهكم شطره لالا يكون للناس عليكم حجة الا الذين ظلموا منهم فلا تخشوهم واخشوني ولاتم نعمتي عليكم ولعلكم تهتدون",
  },
  {
    verseId: 150,
    name: "البقرة",
    surahId: 2,
    text: "كَمَآ أَرۡسَلۡنَا فِيكُمۡ رَسُولٗا مِّنكُمۡ يَتۡلُواْ عَلَيۡكُمۡ ءَايَٰتِنَا وَيُزَكِّيكُمۡ وَيُعَلِّمُكُمُ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَيُعَلِّمُكُم مَّا لَمۡ تَكُونُواْ تَعۡلَمُونَ",
    translation:
      "Just as We have sent among you a messenger from yourselves reciting to you Our verses and purifying you and teaching you the Book and wisdom and teaching you that which you did not know",
    normalizedText:
      "كما ارسلنا فيكم رسولا منكم يتلوا عليكم ءايتنا ويزكيكم ويعلمكم الكتب والحكمة ويعلمكم ما لم تكونوا تعلمون",
  },
  {
    verseId: 151,
    name: "البقرة",
    surahId: 2,
    text: "فَٱذۡكُرُونِيٓ أَذۡكُرۡكُمۡ وَٱشۡكُرُواْ لِي وَلَا تَكۡفُرُونِ",
    translation:
      "So remember Me; I will remember you. And be grateful to Me and do not deny Me",
    normalizedText: "فاذكروني اذكركم واشكروا لي ولا تكفرون",
  },
  {
    verseId: 152,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱسۡتَعِينُواْ بِٱلصَّبۡرِ وَٱلصَّلَوٰةِۚ إِنَّ ٱللَّهَ مَعَ ٱلصَّـٰبِرِينَ",
    translation:
      "O you who have believed, seek help through patience and prayer. Indeed, Allah is with the patient",
    normalizedText:
      "يايها الذين ءامنوا استعينوا بالصبر والصلوة ان الله مع الصبرين",
  },
  {
    verseId: 153,
    name: "البقرة",
    surahId: 2,
    text: "وَلَا تَقُولُواْ لِمَن يُقۡتَلُ فِي سَبِيلِ ٱللَّهِ أَمۡوَٰتُۢۚ بَلۡ أَحۡيَآءٞ وَلَٰكِن لَّا تَشۡعُرُونَ",
    translation:
      'And do not say about those who are killed in the way of Allah, "They are dead." Rather, they are alive, but you perceive [it] not',
    normalizedText:
      "ولا تقولوا لمن يقتل في سبيل الله اموت بل احياء ولكن لا تشعرون",
  },
  {
    verseId: 154,
    name: "البقرة",
    surahId: 2,
    text: "وَلَنَبۡلُوَنَّكُم بِشَيۡءٖ مِّنَ ٱلۡخَوۡفِ وَٱلۡجُوعِ وَنَقۡصٖ مِّنَ ٱلۡأَمۡوَٰلِ وَٱلۡأَنفُسِ وَٱلثَّمَرَٰتِۗ وَبَشِّرِ ٱلصَّـٰبِرِينَ",
    translation:
      "And We will surely test you with something of fear and hunger and a loss of wealth and lives and fruits, but give good tidings to the patient",
    normalizedText:
      "ولنبلونكم بشيء من الخوف والجوع ونقص من الامول والانفس والثمرت وبشر الصبرين",
  },
  {
    verseId: 155,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ إِذَآ أَصَٰبَتۡهُم مُّصِيبَةٞ قَالُوٓاْ إِنَّا لِلَّهِ وَإِنَّآ إِلَيۡهِ رَٰجِعُونَ",
    translation:
      'Who, when disaster strikes them, say, "Indeed we belong to Allah, and indeed to Him we will return',
    normalizedText: "الذين اذا اصبتهم مصيبة قالوا انا لله وانا اليه رجعون",
  },
  {
    verseId: 156,
    name: "البقرة",
    surahId: 2,
    text: "أُوْلَـٰٓئِكَ عَلَيۡهِمۡ صَلَوَٰتٞ مِّن رَّبِّهِمۡ وَرَحۡمَةٞۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُهۡتَدُونَ",
    translation:
      "Those are the ones upon whom are blessings from their Lord and mercy. And it is those who are the [rightly] guided",
    normalizedText: "اولاك عليهم صلوت من ربهم ورحمة واولاك هم المهتدون",
  },
  {
    verseId: 157,
    name: "البقرة",
    surahId: 2,
    text: "۞إِنَّ ٱلصَّفَا وَٱلۡمَرۡوَةَ مِن شَعَآئِرِ ٱللَّهِۖ فَمَنۡ حَجَّ ٱلۡبَيۡتَ أَوِ ٱعۡتَمَرَ فَلَا جُنَاحَ عَلَيۡهِ أَن يَطَّوَّفَ بِهِمَاۚ وَمَن تَطَوَّعَ خَيۡرٗا فَإِنَّ ٱللَّهَ شَاكِرٌ عَلِيمٌ",
    translation:
      "Indeed, as-Safa and al-Marwah are among the symbols of Allah. So whoever makes Hajj to the House or performs 'umrah - there is no blame upon him for walking between them. And whoever volunteers good - then indeed, Allah is appreciative and Knowing",
    normalizedText:
      "۞ان الصفا والمروة من شعاار الله فمن حج البيت او اعتمر فلا جناح عليه ان يطوف بهما ومن تطوع خيرا فان الله شاكر عليم",
  },
  {
    verseId: 158,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ ٱلَّذِينَ يَكۡتُمُونَ مَآ أَنزَلۡنَا مِنَ ٱلۡبَيِّنَٰتِ وَٱلۡهُدَىٰ مِنۢ بَعۡدِ مَا بَيَّنَّـٰهُ لِلنَّاسِ فِي ٱلۡكِتَٰبِ أُوْلَـٰٓئِكَ يَلۡعَنُهُمُ ٱللَّهُ وَيَلۡعَنُهُمُ ٱللَّـٰعِنُونَ",
    translation:
      "Indeed, those who conceal what We sent down of clear proofs and guidance after We made it clear for the people in the Scripture - those are cursed by Allah and cursed by those who curse",
    normalizedText:
      "ان الذين يكتمون ما انزلنا من البينت والهدى من بعد ما بينه للناس في الكتب اولاك يلعنهم الله ويلعنهم اللعنون",
  },
  {
    verseId: 159,
    name: "البقرة",
    surahId: 2,
    text: "إِلَّا ٱلَّذِينَ تَابُواْ وَأَصۡلَحُواْ وَبَيَّنُواْ فَأُوْلَـٰٓئِكَ أَتُوبُ عَلَيۡهِمۡ وَأَنَا ٱلتَّوَّابُ ٱلرَّحِيمُ",
    translation:
      "Except for those who repent and correct themselves and make evident [what they concealed]. Those - I will accept their repentance, and I am the Accepting of repentance, the Merciful",
    normalizedText:
      "الا الذين تابوا واصلحوا وبينوا فاولاك اتوب عليهم وانا التواب الرحيم",
  },
  {
    verseId: 160,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ وَمَاتُواْ وَهُمۡ كُفَّارٌ أُوْلَـٰٓئِكَ عَلَيۡهِمۡ لَعۡنَةُ ٱللَّهِ وَٱلۡمَلَـٰٓئِكَةِ وَٱلنَّاسِ أَجۡمَعِينَ",
    translation:
      "Indeed, those who disbelieve and die while they are disbelievers - upon them will be the curse of Allah and of the angels and the people, all together",
    normalizedText:
      "ان الذين كفروا وماتوا وهم كفار اولاك عليهم لعنة الله والملاكة والناس اجمعين",
  },
  {
    verseId: 161,
    name: "البقرة",
    surahId: 2,
    text: "خَٰلِدِينَ فِيهَا لَا يُخَفَّفُ عَنۡهُمُ ٱلۡعَذَابُ وَلَا هُمۡ يُنظَرُونَ",
    translation:
      "Abiding eternally therein. The punishment will not be lightened for them, nor will they be reprieved",
    normalizedText: "خلدين فيها لا يخفف عنهم العذاب ولا هم ينظرون",
  },
  {
    verseId: 162,
    name: "البقرة",
    surahId: 2,
    text: "وَإِلَٰهُكُمۡ إِلَٰهٞ وَٰحِدٞۖ لَّآ إِلَٰهَ إِلَّا هُوَ ٱلرَّحۡمَٰنُ ٱلرَّحِيمُ",
    translation:
      "And your god is one God. There is no deity [worthy of worship] except Him, the Entirely Merciful, the Especially Merciful",
    normalizedText: "والهكم اله وحد لا اله الا هو الرحمن الرحيم",
  },
  {
    verseId: 163,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ فِي خَلۡقِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَٱخۡتِلَٰفِ ٱلَّيۡلِ وَٱلنَّهَارِ وَٱلۡفُلۡكِ ٱلَّتِي تَجۡرِي فِي ٱلۡبَحۡرِ بِمَا يَنفَعُ ٱلنَّاسَ وَمَآ أَنزَلَ ٱللَّهُ مِنَ ٱلسَّمَآءِ مِن مَّآءٖ فَأَحۡيَا بِهِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَا وَبَثَّ فِيهَا مِن كُلِّ دَآبَّةٖ وَتَصۡرِيفِ ٱلرِّيَٰحِ وَٱلسَّحَابِ ٱلۡمُسَخَّرِ بَيۡنَ ٱلسَّمَآءِ وَٱلۡأَرۡضِ لَأٓيَٰتٖ لِّقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "Indeed, in the creation of the heavens and earth, and the alternation of the night and the day, and the [great] ships which sail through the sea with that which benefits people, and what Allah has sent down from the heavens of rain, giving life thereby to the earth after its lifelessness and dispersing therein every [kind of] moving creature, and [His] directing of the winds and the clouds controlled between the heaven and the earth are signs for a people who use reason",
    normalizedText:
      "ان في خلق السموت والارض واختلف اليل والنهار والفلك التي تجري في البحر بما ينفع الناس وما انزل الله من السماء من ماء فاحيا به الارض بعد موتها وبث فيها من كل دابة وتصريف الريح والسحاب المسخر بين السماء والارض لايت لقوم يعقلون",
  },
  {
    verseId: 164,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنَ ٱلنَّاسِ مَن يَتَّخِذُ مِن دُونِ ٱللَّهِ أَندَادٗا يُحِبُّونَهُمۡ كَحُبِّ ٱللَّهِۖ وَٱلَّذِينَ ءَامَنُوٓاْ أَشَدُّ حُبّٗا لِّلَّهِۗ وَلَوۡ يَرَى ٱلَّذِينَ ظَلَمُوٓاْ إِذۡ يَرَوۡنَ ٱلۡعَذَابَ أَنَّ ٱلۡقُوَّةَ لِلَّهِ جَمِيعٗا وَأَنَّ ٱللَّهَ شَدِيدُ ٱلۡعَذَابِ",
    translation:
      "And [yet], among the people are those who take other than Allah as equals [to Him]. They love them as they [should] love Allah. But those who believe are stronger in love for Allah. And if only they who have wronged would consider [that] when they see the punishment, [they will be certain] that all power belongs to Allah and that Allah is severe in punishment",
    normalizedText:
      "ومن الناس من يتخذ من دون الله اندادا يحبونهم كحب الله والذين ءامنوا اشد حبا لله ولو يرى الذين ظلموا اذ يرون العذاب ان القوة لله جميعا وان الله شديد العذاب",
  },
  {
    verseId: 165,
    name: "البقرة",
    surahId: 2,
    text: "إِذۡ تَبَرَّأَ ٱلَّذِينَ ٱتُّبِعُواْ مِنَ ٱلَّذِينَ ٱتَّبَعُواْ وَرَأَوُاْ ٱلۡعَذَابَ وَتَقَطَّعَتۡ بِهِمُ ٱلۡأَسۡبَابُ",
    translation:
      "[And they should consider that] when those who have been followed disassociate themselves from those who followed [them], and they [all] see the punishment, and cut off from them are the ties [of relationship]",
    normalizedText:
      "اذ تبرا الذين اتبعوا من الذين اتبعوا وراوا العذاب وتقطعت بهم الاسباب",
  },
  {
    verseId: 166,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالَ ٱلَّذِينَ ٱتَّبَعُواْ لَوۡ أَنَّ لَنَا كَرَّةٗ فَنَتَبَرَّأَ مِنۡهُمۡ كَمَا تَبَرَّءُواْ مِنَّاۗ كَذَٰلِكَ يُرِيهِمُ ٱللَّهُ أَعۡمَٰلَهُمۡ حَسَرَٰتٍ عَلَيۡهِمۡۖ وَمَا هُم بِخَٰرِجِينَ مِنَ ٱلنَّارِ",
    translation:
      'Those who followed will say, "If only we had another turn [at worldly life] so we could disassociate ourselves from them as they have disassociated themselves from us." Thus will Allah show them their deeds as regrets upon them. And they are never to emerge from the Fire',
    normalizedText:
      "وقال الذين اتبعوا لو ان لنا كرة فنتبرا منهم كما تبرءوا منا كذلك يريهم الله اعملهم حسرت عليهم وما هم بخرجين من النار",
  },
  {
    verseId: 167,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ كُلُواْ مِمَّا فِي ٱلۡأَرۡضِ حَلَٰلٗا طَيِّبٗا وَلَا تَتَّبِعُواْ خُطُوَٰتِ ٱلشَّيۡطَٰنِۚ إِنَّهُۥ لَكُمۡ عَدُوّٞ مُّبِينٌ",
    translation:
      "O mankind, eat from whatever is on earth [that is] lawful and good and do not follow the footsteps of Satan. Indeed, he is to you a clear enemy",
    normalizedText:
      "يايها الناس كلوا مما في الارض حللا طيبا ولا تتبعوا خطوت الشيطن انه لكم عدو مبين",
  },
  {
    verseId: 168,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّمَا يَأۡمُرُكُم بِٱلسُّوٓءِ وَٱلۡفَحۡشَآءِ وَأَن تَقُولُواْ عَلَى ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      "He only orders you to evil and immorality and to say about Allah what you do not know",
    normalizedText:
      "انما يامركم بالسوء والفحشاء وان تقولوا على الله ما لا تعلمون",
  },
  {
    verseId: 169,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا قِيلَ لَهُمُ ٱتَّبِعُواْ مَآ أَنزَلَ ٱللَّهُ قَالُواْ بَلۡ نَتَّبِعُ مَآ أَلۡفَيۡنَا عَلَيۡهِ ءَابَآءَنَآۚ أَوَلَوۡ كَانَ ءَابَآؤُهُمۡ لَا يَعۡقِلُونَ شَيۡـٔٗا وَلَا يَهۡتَدُونَ",
    translation:
      'And when it is said to them, "Follow what Allah has revealed," they say, "Rather, we will follow that which we found our fathers doing." Even though their fathers understood nothing, nor were they guided',
    normalizedText:
      "واذا قيل لهم اتبعوا ما انزل الله قالوا بل نتبع ما الفينا عليه ءاباءنا اولو كان ءابااهم لا يعقلون شيا ولا يهتدون",
  },
  {
    verseId: 170,
    name: "البقرة",
    surahId: 2,
    text: "وَمَثَلُ ٱلَّذِينَ كَفَرُواْ كَمَثَلِ ٱلَّذِي يَنۡعِقُ بِمَا لَا يَسۡمَعُ إِلَّا دُعَآءٗ وَنِدَآءٗۚ صُمُّۢ بُكۡمٌ عُمۡيٞ فَهُمۡ لَا يَعۡقِلُونَ",
    translation:
      "The example of those who disbelieve is like that of one who shouts at what hears nothing but calls and cries cattle or sheep - deaf, dumb and blind, so they do not understand",
    normalizedText:
      "ومثل الذين كفروا كمثل الذي ينعق بما لا يسمع الا دعاء ونداء صم بكم عمي فهم لا يعقلون",
  },
  {
    verseId: 171,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ كُلُواْ مِن طَيِّبَٰتِ مَا رَزَقۡنَٰكُمۡ وَٱشۡكُرُواْ لِلَّهِ إِن كُنتُمۡ إِيَّاهُ تَعۡبُدُونَ",
    translation:
      "O you who have believed, eat from the good things which We have provided for you and be grateful to Allah if it is [indeed] Him that you worship",
    normalizedText:
      "يايها الذين ءامنوا كلوا من طيبت ما رزقنكم واشكروا لله ان كنتم اياه تعبدون",
  },
  {
    verseId: 172,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّمَا حَرَّمَ عَلَيۡكُمُ ٱلۡمَيۡتَةَ وَٱلدَّمَ وَلَحۡمَ ٱلۡخِنزِيرِ وَمَآ أُهِلَّ بِهِۦ لِغَيۡرِ ٱللَّهِۖ فَمَنِ ٱضۡطُرَّ غَيۡرَ بَاغٖ وَلَا عَادٖ فَلَآ إِثۡمَ عَلَيۡهِۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٌ",
    translation:
      "He has only forbidden to you dead animals, blood, the flesh of swine, and that which has been dedicated to other than Allah. But whoever is forced [by necessity], neither desiring [it] nor transgressing [its limit], there is no sin upon him. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "انما حرم عليكم الميتة والدم ولحم الخنزير وما اهل به لغير الله فمن اضطر غير باغ ولا عاد فلا اثم عليه ان الله غفور رحيم",
  },
  {
    verseId: 173,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ ٱلَّذِينَ يَكۡتُمُونَ مَآ أَنزَلَ ٱللَّهُ مِنَ ٱلۡكِتَٰبِ وَيَشۡتَرُونَ بِهِۦ ثَمَنٗا قَلِيلًا أُوْلَـٰٓئِكَ مَا يَأۡكُلُونَ فِي بُطُونِهِمۡ إِلَّا ٱلنَّارَ وَلَا يُكَلِّمُهُمُ ٱللَّهُ يَوۡمَ ٱلۡقِيَٰمَةِ وَلَا يُزَكِّيهِمۡ وَلَهُمۡ عَذَابٌ أَلِيمٌ",
    translation:
      "Indeed, they who conceal what Allah has sent down of the Book and exchange it for a small price - those consume not into their bellies except the Fire. And Allah will not speak to them on the Day of Resurrection, nor will He purify them. And they will have a painful punishment",
    normalizedText:
      "ان الذين يكتمون ما انزل الله من الكتب ويشترون به ثمنا قليلا اولاك ما ياكلون في بطونهم الا النار ولا يكلمهم الله يوم القيمة ولا يزكيهم ولهم عذاب اليم",
  },
  {
    verseId: 174,
    name: "البقرة",
    surahId: 2,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ ٱشۡتَرَوُاْ ٱلضَّلَٰلَةَ بِٱلۡهُدَىٰ وَٱلۡعَذَابَ بِٱلۡمَغۡفِرَةِۚ فَمَآ أَصۡبَرَهُمۡ عَلَى ٱلنَّارِ",
    translation:
      "Those are the ones who have exchanged guidance for error and forgiveness for punishment. How patient they are in pursuit of the Fire",
    normalizedText:
      "اولاك الذين اشتروا الضللة بالهدى والعذاب بالمغفرة فما اصبرهم على النار",
  },
  {
    verseId: 175,
    name: "البقرة",
    surahId: 2,
    text: "ذَٰلِكَ بِأَنَّ ٱللَّهَ نَزَّلَ ٱلۡكِتَٰبَ بِٱلۡحَقِّۗ وَإِنَّ ٱلَّذِينَ ٱخۡتَلَفُواْ فِي ٱلۡكِتَٰبِ لَفِي شِقَاقِۭ بَعِيدٖ",
    translation:
      "That is [deserved by them] because Allah has sent down the Book in truth. And indeed, those who differ over the Book are in extreme dissension",
    normalizedText:
      "ذلك بان الله نزل الكتب بالحق وان الذين اختلفوا في الكتب لفي شقاق بعيد",
  },
  {
    verseId: 176,
    name: "البقرة",
    surahId: 2,
    text: "۞لَّيۡسَ ٱلۡبِرَّ أَن تُوَلُّواْ وُجُوهَكُمۡ قِبَلَ ٱلۡمَشۡرِقِ وَٱلۡمَغۡرِبِ وَلَٰكِنَّ ٱلۡبِرَّ مَنۡ ءَامَنَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَٱلۡمَلَـٰٓئِكَةِ وَٱلۡكِتَٰبِ وَٱلنَّبِيِّـۧنَ وَءَاتَى ٱلۡمَالَ عَلَىٰ حُبِّهِۦ ذَوِي ٱلۡقُرۡبَىٰ وَٱلۡيَتَٰمَىٰ وَٱلۡمَسَٰكِينَ وَٱبۡنَ ٱلسَّبِيلِ وَٱلسَّآئِلِينَ وَفِي ٱلرِّقَابِ وَأَقَامَ ٱلصَّلَوٰةَ وَءَاتَى ٱلزَّكَوٰةَ وَٱلۡمُوفُونَ بِعَهۡدِهِمۡ إِذَا عَٰهَدُواْۖ وَٱلصَّـٰبِرِينَ فِي ٱلۡبَأۡسَآءِ وَٱلضَّرَّآءِ وَحِينَ ٱلۡبَأۡسِۗ أُوْلَـٰٓئِكَ ٱلَّذِينَ صَدَقُواْۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُتَّقُونَ",
    translation:
      "Righteousness is not that you turn your faces toward the east or the west, but [true] righteousness is [in] one who believes in Allah, the Last Day, the angels, the Book, and the prophets and gives wealth, in spite of love for it, to relatives, orphans, the needy, the traveler, those who ask [for help], and for freeing slaves; [and who] establishes prayer and gives zakah; [those who] fulfill their promise when they promise; and [those who] are patient in poverty and hardship and during battle. Those are the ones who have been true, and it is those who are the righteous",
    normalizedText:
      "۞ليس البر ان تولوا وجوهكم قبل المشرق والمغرب ولكن البر من ءامن بالله واليوم الاخر والملاكة والكتب والنبين وءاتى المال على حبه ذوي القربى واليتمى والمسكين وابن السبيل والساالين وفي الرقاب واقام الصلوة وءاتى الزكوة والموفون بعهدهم اذا عهدوا والصبرين في الباساء والضراء وحين الباس اولاك الذين صدقوا واولاك هم المتقون",
  },
  {
    verseId: 177,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ كُتِبَ عَلَيۡكُمُ ٱلۡقِصَاصُ فِي ٱلۡقَتۡلَىۖ ٱلۡحُرُّ بِٱلۡحُرِّ وَٱلۡعَبۡدُ بِٱلۡعَبۡدِ وَٱلۡأُنثَىٰ بِٱلۡأُنثَىٰۚ فَمَنۡ عُفِيَ لَهُۥ مِنۡ أَخِيهِ شَيۡءٞ فَٱتِّبَاعُۢ بِٱلۡمَعۡرُوفِ وَأَدَآءٌ إِلَيۡهِ بِإِحۡسَٰنٖۗ ذَٰلِكَ تَخۡفِيفٞ مِّن رَّبِّكُمۡ وَرَحۡمَةٞۗ فَمَنِ ٱعۡتَدَىٰ بَعۡدَ ذَٰلِكَ فَلَهُۥ عَذَابٌ أَلِيمٞ",
    translation:
      "O you who have believed, prescribed for you is legal retribution for those murdered - the free for the free, the slave for the slave, and the female for the female. But whoever overlooks from his brother anything, then there should be a suitable follow-up and payment to him with good conduct. This is an alleviation from your Lord and a mercy. But whoever transgresses after that will have a painful punishment",
    normalizedText:
      "يايها الذين ءامنوا كتب عليكم القصاص في القتلى الحر بالحر والعبد بالعبد والانثى بالانثى فمن عفي له من اخيه شيء فاتباع بالمعروف واداء اليه باحسن ذلك تخفيف من ربكم ورحمة فمن اعتدى بعد ذلك فله عذاب اليم",
  },
  {
    verseId: 178,
    name: "البقرة",
    surahId: 2,
    text: "وَلَكُمۡ فِي ٱلۡقِصَاصِ حَيَوٰةٞ يَـٰٓأُوْلِي ٱلۡأَلۡبَٰبِ لَعَلَّكُمۡ تَتَّقُونَ",
    translation:
      "And there is for you in legal retribution [saving of] life, O you [people] of understanding, that you may become righteous",
    normalizedText: "ولكم في القصاص حيوة ياولي الالبب لعلكم تتقون",
  },
  {
    verseId: 179,
    name: "البقرة",
    surahId: 2,
    text: "كُتِبَ عَلَيۡكُمۡ إِذَا حَضَرَ أَحَدَكُمُ ٱلۡمَوۡتُ إِن تَرَكَ خَيۡرًا ٱلۡوَصِيَّةُ لِلۡوَٰلِدَيۡنِ وَٱلۡأَقۡرَبِينَ بِٱلۡمَعۡرُوفِۖ حَقًّا عَلَى ٱلۡمُتَّقِينَ",
    translation:
      "Prescribed for you when death approaches [any] one of you if he leaves wealth [is that he should make] a bequest for the parents and near relatives according to what is acceptable - a duty upon the righteous",
    normalizedText:
      "كتب عليكم اذا حضر احدكم الموت ان ترك خيرا الوصية للولدين والاقربين بالمعروف حقا على المتقين",
  },
  {
    verseId: 180,
    name: "البقرة",
    surahId: 2,
    text: "فَمَنۢ بَدَّلَهُۥ بَعۡدَ مَا سَمِعَهُۥ فَإِنَّمَآ إِثۡمُهُۥ عَلَى ٱلَّذِينَ يُبَدِّلُونَهُۥٓۚ إِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٞ",
    translation:
      "Then whoever alters the bequest after he has heard it - the sin is only upon those who have altered it. Indeed, Allah is Hearing and Knowing",
    normalizedText:
      "فمن بدله بعد ما سمعه فانما اثمه على الذين يبدلونه ان الله سميع عليم",
  },
  {
    verseId: 181,
    name: "البقرة",
    surahId: 2,
    text: "فَمَنۡ خَافَ مِن مُّوصٖ جَنَفًا أَوۡ إِثۡمٗا فَأَصۡلَحَ بَيۡنَهُمۡ فَلَآ إِثۡمَ عَلَيۡهِۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "But if one fears from the bequeather [some] error or sin and corrects that which is between them, there is no sin upon him. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "فمن خاف من موص جنفا او اثما فاصلح بينهم فلا اثم عليه ان الله غفور رحيم",
  },
  {
    verseId: 182,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ كُتِبَ عَلَيۡكُمُ ٱلصِّيَامُ كَمَا كُتِبَ عَلَى ٱلَّذِينَ مِن قَبۡلِكُمۡ لَعَلَّكُمۡ تَتَّقُونَ",
    translation:
      "O you who have believed, decreed upon you is fasting as it was decreed upon those before you that you may become righteous",
    normalizedText:
      "يايها الذين ءامنوا كتب عليكم الصيام كما كتب على الذين من قبلكم لعلكم تتقون",
  },
  {
    verseId: 183,
    name: "البقرة",
    surahId: 2,
    text: "أَيَّامٗا مَّعۡدُودَٰتٖۚ فَمَن كَانَ مِنكُم مَّرِيضًا أَوۡ عَلَىٰ سَفَرٖ فَعِدَّةٞ مِّنۡ أَيَّامٍ أُخَرَۚ وَعَلَى ٱلَّذِينَ يُطِيقُونَهُۥ فِدۡيَةٞ طَعَامُ مِسۡكِينٖۖ فَمَن تَطَوَّعَ خَيۡرٗا فَهُوَ خَيۡرٞ لَّهُۥۚ وَأَن تَصُومُواْ خَيۡرٞ لَّكُمۡ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "[Fasting for] a limited number of days. So whoever among you is ill or on a journey [during them] - then an equal number of days [are to be made up]. And upon those who are able [to fast, but with hardship] - a ransom [as substitute] of feeding a poor person [each day]. And whoever volunteers excess - it is better for him. But to fast is best for you, if you only knew",
    normalizedText:
      "اياما معدودت فمن كان منكم مريضا او على سفر فعدة من ايام اخر وعلى الذين يطيقونه فدية طعام مسكين فمن تطوع خيرا فهو خير له وان تصوموا خير لكم ان كنتم تعلمون",
  },
  {
    verseId: 184,
    name: "البقرة",
    surahId: 2,
    text: "شَهۡرُ رَمَضَانَ ٱلَّذِيٓ أُنزِلَ فِيهِ ٱلۡقُرۡءَانُ هُدٗى لِّلنَّاسِ وَبَيِّنَٰتٖ مِّنَ ٱلۡهُدَىٰ وَٱلۡفُرۡقَانِۚ فَمَن شَهِدَ مِنكُمُ ٱلشَّهۡرَ فَلۡيَصُمۡهُۖ وَمَن كَانَ مَرِيضًا أَوۡ عَلَىٰ سَفَرٖ فَعِدَّةٞ مِّنۡ أَيَّامٍ أُخَرَۗ يُرِيدُ ٱللَّهُ بِكُمُ ٱلۡيُسۡرَ وَلَا يُرِيدُ بِكُمُ ٱلۡعُسۡرَ وَلِتُكۡمِلُواْ ٱلۡعِدَّةَ وَلِتُكَبِّرُواْ ٱللَّهَ عَلَىٰ مَا هَدَىٰكُمۡ وَلَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "The month of Ramadhan [is that] in which was revealed the Qur'an, a guidance for the people and clear proofs of guidance and criterion. So whoever sights [the new moon of] the month, let him fast it; and whoever is ill or on a journey - then an equal number of other days. Allah intends for you ease and does not intend for you hardship and [wants] for you to complete the period and to glorify Allah for that [to] which He has guided you; and perhaps you will be grateful",
    normalizedText:
      "شهر رمضان الذي انزل فيه القرءان هدى للناس وبينت من الهدى والفرقان فمن شهد منكم الشهر فليصمه ومن كان مريضا او على سفر فعدة من ايام اخر يريد الله بكم اليسر ولا يريد بكم العسر ولتكملوا العدة ولتكبروا الله على ما هدىكم ولعلكم تشكرون",
  },
  {
    verseId: 185,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا سَأَلَكَ عِبَادِي عَنِّي فَإِنِّي قَرِيبٌۖ أُجِيبُ دَعۡوَةَ ٱلدَّاعِ إِذَا دَعَانِۖ فَلۡيَسۡتَجِيبُواْ لِي وَلۡيُؤۡمِنُواْ بِي لَعَلَّهُمۡ يَرۡشُدُونَ",
    translation:
      "And when My servants ask you, [O Muhammad], concerning Me - indeed I am near. I respond to the invocation of the supplicant when he calls upon Me. So let them respond to Me [by obedience] and believe in Me that they may be [rightly] guided",
    normalizedText:
      "واذا سالك عبادي عني فاني قريب اجيب دعوة الداع اذا دعان فليستجيبوا لي وليامنوا بي لعلهم يرشدون",
  },
  {
    verseId: 186,
    name: "البقرة",
    surahId: 2,
    text: "أُحِلَّ لَكُمۡ لَيۡلَةَ ٱلصِّيَامِ ٱلرَّفَثُ إِلَىٰ نِسَآئِكُمۡۚ هُنَّ لِبَاسٞ لَّكُمۡ وَأَنتُمۡ لِبَاسٞ لَّهُنَّۗ عَلِمَ ٱللَّهُ أَنَّكُمۡ كُنتُمۡ تَخۡتَانُونَ أَنفُسَكُمۡ فَتَابَ عَلَيۡكُمۡ وَعَفَا عَنكُمۡۖ فَٱلۡـَٰٔنَ بَٰشِرُوهُنَّ وَٱبۡتَغُواْ مَا كَتَبَ ٱللَّهُ لَكُمۡۚ وَكُلُواْ وَٱشۡرَبُواْ حَتَّىٰ يَتَبَيَّنَ لَكُمُ ٱلۡخَيۡطُ ٱلۡأَبۡيَضُ مِنَ ٱلۡخَيۡطِ ٱلۡأَسۡوَدِ مِنَ ٱلۡفَجۡرِۖ ثُمَّ أَتِمُّواْ ٱلصِّيَامَ إِلَى ٱلَّيۡلِۚ وَلَا تُبَٰشِرُوهُنَّ وَأَنتُمۡ عَٰكِفُونَ فِي ٱلۡمَسَٰجِدِۗ تِلۡكَ حُدُودُ ٱللَّهِ فَلَا تَقۡرَبُوهَاۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ ءَايَٰتِهِۦ لِلنَّاسِ لَعَلَّهُمۡ يَتَّقُونَ",
    translation:
      "It has been made permissible for you the night preceding fasting to go to your wives [for sexual relations]. They are clothing for you and you are clothing for them. Allah knows that you used to deceive yourselves, so He accepted your repentance and forgave you. So now, have relations with them and seek that which Allah has decreed for you. And eat and drink until the white thread of dawn becomes distinct to you from the black thread [of night]. Then complete the fast until the sunset. And do not have relations with them as long as you are staying for worship in the mosques. These are the limits [set by] Allah, so do not approach them. Thus does Allah make clear His ordinances to the people that they may become righteous",
    normalizedText:
      "احل لكم ليلة الصيام الرفث الى نسااكم هن لباس لكم وانتم لباس لهن علم الله انكم كنتم تختانون انفسكم فتاب عليكم وعفا عنكم فالن بشروهن وابتغوا ما كتب الله لكم وكلوا واشربوا حتى يتبين لكم الخيط الابيض من الخيط الاسود من الفجر ثم اتموا الصيام الى اليل ولا تبشروهن وانتم عكفون في المسجد تلك حدود الله فلا تقربوها كذلك يبين الله ءايته للناس لعلهم يتقون",
  },
  {
    verseId: 187,
    name: "البقرة",
    surahId: 2,
    text: "وَلَا تَأۡكُلُوٓاْ أَمۡوَٰلَكُم بَيۡنَكُم بِٱلۡبَٰطِلِ وَتُدۡلُواْ بِهَآ إِلَى ٱلۡحُكَّامِ لِتَأۡكُلُواْ فَرِيقٗا مِّنۡ أَمۡوَٰلِ ٱلنَّاسِ بِٱلۡإِثۡمِ وَأَنتُمۡ تَعۡلَمُونَ",
    translation:
      "And do not consume one another's wealth unjustly or send it [in bribery] to the rulers in order that [they might aid] you [to] consume a portion of the wealth of the people in sin, while you know [it is unlawful]",
    normalizedText:
      "ولا تاكلوا امولكم بينكم بالبطل وتدلوا بها الى الحكام لتاكلوا فريقا من امول الناس بالاثم وانتم تعلمون",
  },
  {
    verseId: 188,
    name: "البقرة",
    surahId: 2,
    text: "۞يَسۡـَٔلُونَكَ عَنِ ٱلۡأَهِلَّةِۖ قُلۡ هِيَ مَوَٰقِيتُ لِلنَّاسِ وَٱلۡحَجِّۗ وَلَيۡسَ ٱلۡبِرُّ بِأَن تَأۡتُواْ ٱلۡبُيُوتَ مِن ظُهُورِهَا وَلَٰكِنَّ ٱلۡبِرَّ مَنِ ٱتَّقَىٰۗ وَأۡتُواْ ٱلۡبُيُوتَ مِنۡ أَبۡوَٰبِهَاۚ وَٱتَّقُواْ ٱللَّهَ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      'They ask you, [O Muhammad], about the new moons. Say, "They are measurements of time for the people and for Hajj." And it is not righteousness to enter houses from the back, but righteousness is [in] one who fears Allah. And enter houses from their doors. And fear Allah that you may succeed',
    normalizedText:
      "۞يسلونك عن الاهلة قل هي موقيت للناس والحج وليس البر بان تاتوا البيوت من ظهورها ولكن البر من اتقى واتوا البيوت من ابوبها واتقوا الله لعلكم تفلحون",
  },
  {
    verseId: 189,
    name: "البقرة",
    surahId: 2,
    text: "وَقَٰتِلُواْ فِي سَبِيلِ ٱللَّهِ ٱلَّذِينَ يُقَٰتِلُونَكُمۡ وَلَا تَعۡتَدُوٓاْۚ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلۡمُعۡتَدِينَ",
    translation:
      "Fight in the way of Allah those who fight you but do not transgress. Indeed. Allah does not like transgressors",
    normalizedText:
      "وقتلوا في سبيل الله الذين يقتلونكم ولا تعتدوا ان الله لا يحب المعتدين",
  },
  {
    verseId: 190,
    name: "البقرة",
    surahId: 2,
    text: "وَٱقۡتُلُوهُمۡ حَيۡثُ ثَقِفۡتُمُوهُمۡ وَأَخۡرِجُوهُم مِّنۡ حَيۡثُ أَخۡرَجُوكُمۡۚ وَٱلۡفِتۡنَةُ أَشَدُّ مِنَ ٱلۡقَتۡلِۚ وَلَا تُقَٰتِلُوهُمۡ عِندَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِ حَتَّىٰ يُقَٰتِلُوكُمۡ فِيهِۖ فَإِن قَٰتَلُوكُمۡ فَٱقۡتُلُوهُمۡۗ كَذَٰلِكَ جَزَآءُ ٱلۡكَٰفِرِينَ",
    translation:
      "And kill them wherever you overtake them and expel them from wherever they have expelled you, and fitnah is worse than killing. And do not fight them at al-Masjid al- Haram until they fight you there. But if they fight you, then kill them. Such is the recompense of the disbelievers",
    normalizedText:
      "واقتلوهم حيث ثقفتموهم واخرجوهم من حيث اخرجوكم والفتنة اشد من القتل ولا تقتلوهم عند المسجد الحرام حتى يقتلوكم فيه فان قتلوكم فاقتلوهم كذلك جزاء الكفرين",
  },
  {
    verseId: 191,
    name: "البقرة",
    surahId: 2,
    text: "فَإِنِ ٱنتَهَوۡاْ فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "And if they cease, then indeed, Allah is Forgiving and Merciful",
    normalizedText: "فان انتهوا فان الله غفور رحيم",
  },
  {
    verseId: 192,
    name: "البقرة",
    surahId: 2,
    text: "وَقَٰتِلُوهُمۡ حَتَّىٰ لَا تَكُونَ فِتۡنَةٞ وَيَكُونَ ٱلدِّينُ لِلَّهِۖ فَإِنِ ٱنتَهَوۡاْ فَلَا عُدۡوَٰنَ إِلَّا عَلَى ٱلظَّـٰلِمِينَ",
    translation:
      "Fight them until there is no [more] fitnah and [until] worship is [acknowledged to be] for Allah. But if they cease, then there is to be no aggression except against the oppressors",
    normalizedText:
      "وقتلوهم حتى لا تكون فتنة ويكون الدين لله فان انتهوا فلا عدون الا على الظلمين",
  },
  {
    verseId: 193,
    name: "البقرة",
    surahId: 2,
    text: "ٱلشَّهۡرُ ٱلۡحَرَامُ بِٱلشَّهۡرِ ٱلۡحَرَامِ وَٱلۡحُرُمَٰتُ قِصَاصٞۚ فَمَنِ ٱعۡتَدَىٰ عَلَيۡكُمۡ فَٱعۡتَدُواْ عَلَيۡهِ بِمِثۡلِ مَا ٱعۡتَدَىٰ عَلَيۡكُمۡۚ وَٱتَّقُواْ ٱللَّهَ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ مَعَ ٱلۡمُتَّقِينَ",
    translation:
      "[Fighting in] the sacred month is for [aggression committed in] the sacred month, and for [all] violations is legal retribution. So whoever has assaulted you, then assault him in the same way that he has assaulted you. And fear Allah and know that Allah is with those who fear Him",
    normalizedText:
      "الشهر الحرام بالشهر الحرام والحرمت قصاص فمن اعتدى عليكم فاعتدوا عليه بمثل ما اعتدى عليكم واتقوا الله واعلموا ان الله مع المتقين",
  },
  {
    verseId: 194,
    name: "البقرة",
    surahId: 2,
    text: "وَأَنفِقُواْ فِي سَبِيلِ ٱللَّهِ وَلَا تُلۡقُواْ بِأَيۡدِيكُمۡ إِلَى ٱلتَّهۡلُكَةِ وَأَحۡسِنُوٓاْۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُحۡسِنِينَ",
    translation:
      "And spend in the way of Allah and do not throw [yourselves] with your [own] hands into destruction [by refraining]. And do good; indeed, Allah loves the doers of good",
    normalizedText:
      "وانفقوا في سبيل الله ولا تلقوا بايديكم الى التهلكة واحسنوا ان الله يحب المحسنين",
  },
  {
    verseId: 195,
    name: "البقرة",
    surahId: 2,
    text: "وَأَتِمُّواْ ٱلۡحَجَّ وَٱلۡعُمۡرَةَ لِلَّهِۚ فَإِنۡ أُحۡصِرۡتُمۡ فَمَا ٱسۡتَيۡسَرَ مِنَ ٱلۡهَدۡيِۖ وَلَا تَحۡلِقُواْ رُءُوسَكُمۡ حَتَّىٰ يَبۡلُغَ ٱلۡهَدۡيُ مَحِلَّهُۥۚ فَمَن كَانَ مِنكُم مَّرِيضًا أَوۡ بِهِۦٓ أَذٗى مِّن رَّأۡسِهِۦ فَفِدۡيَةٞ مِّن صِيَامٍ أَوۡ صَدَقَةٍ أَوۡ نُسُكٖۚ فَإِذَآ أَمِنتُمۡ فَمَن تَمَتَّعَ بِٱلۡعُمۡرَةِ إِلَى ٱلۡحَجِّ فَمَا ٱسۡتَيۡسَرَ مِنَ ٱلۡهَدۡيِۚ فَمَن لَّمۡ يَجِدۡ فَصِيَامُ ثَلَٰثَةِ أَيَّامٖ فِي ٱلۡحَجِّ وَسَبۡعَةٍ إِذَا رَجَعۡتُمۡۗ تِلۡكَ عَشَرَةٞ كَامِلَةٞۗ ذَٰلِكَ لِمَن لَّمۡ يَكُنۡ أَهۡلُهُۥ حَاضِرِي ٱلۡمَسۡجِدِ ٱلۡحَرَامِۚ وَٱتَّقُواْ ٱللَّهَ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "And complete the Hajj and 'umrah for Allah. But if you are prevented, then [offer] what can be obtained with ease of sacrificial animals. And do not shave your heads until the sacrificial animal has reached its place of slaughter. And whoever among you is ill or has an ailment of the head [making shaving necessary must offer] a ransom of fasting [three days] or charity or sacrifice. And when you are secure, then whoever performs 'umrah [during the Hajj months] followed by Hajj [offers] what can be obtained with ease of sacrificial animals. And whoever cannot find [or afford such an animal] - then a fast of three days during Hajj and of seven when you have returned [home]. Those are ten complete [days]. This is for those whose family is not in the area of al-Masjid al-Haram. And fear Allah and know that Allah is severe in penalty",
    normalizedText:
      "واتموا الحج والعمرة لله فان احصرتم فما استيسر من الهدي ولا تحلقوا رءوسكم حتى يبلغ الهدي محله فمن كان منكم مريضا او به اذى من راسه ففدية من صيام او صدقة او نسك فاذا امنتم فمن تمتع بالعمرة الى الحج فما استيسر من الهدي فمن لم يجد فصيام ثلثة ايام في الحج وسبعة اذا رجعتم تلك عشرة كاملة ذلك لمن لم يكن اهله حاضري المسجد الحرام واتقوا الله واعلموا ان الله شديد العقاب",
  },
  {
    verseId: 196,
    name: "البقرة",
    surahId: 2,
    text: "ٱلۡحَجُّ أَشۡهُرٞ مَّعۡلُومَٰتٞۚ فَمَن فَرَضَ فِيهِنَّ ٱلۡحَجَّ فَلَا رَفَثَ وَلَا فُسُوقَ وَلَا جِدَالَ فِي ٱلۡحَجِّۗ وَمَا تَفۡعَلُواْ مِنۡ خَيۡرٖ يَعۡلَمۡهُ ٱللَّهُۗ وَتَزَوَّدُواْ فَإِنَّ خَيۡرَ ٱلزَّادِ ٱلتَّقۡوَىٰۖ وَٱتَّقُونِ يَـٰٓأُوْلِي ٱلۡأَلۡبَٰبِ",
    translation:
      "Hajj is [during] well-known months, so whoever has made Hajj obligatory upon himself therein [by entering the state of ihram], there is [to be for him] no sexual relations and no disobedience and no disputing during Hajj. And whatever good you do - Allah knows it. And take provisions, but indeed, the best provision is fear of Allah. And fear Me, O you of understanding",
    normalizedText:
      "الحج اشهر معلومت فمن فرض فيهن الحج فلا رفث ولا فسوق ولا جدال في الحج وما تفعلوا من خير يعلمه الله وتزودوا فان خير الزاد التقوى واتقون ياولي الالبب",
  },
  {
    verseId: 197,
    name: "البقرة",
    surahId: 2,
    text: "لَيۡسَ عَلَيۡكُمۡ جُنَاحٌ أَن تَبۡتَغُواْ فَضۡلٗا مِّن رَّبِّكُمۡۚ فَإِذَآ أَفَضۡتُم مِّنۡ عَرَفَٰتٖ فَٱذۡكُرُواْ ٱللَّهَ عِندَ ٱلۡمَشۡعَرِ ٱلۡحَرَامِۖ وَٱذۡكُرُوهُ كَمَا هَدَىٰكُمۡ وَإِن كُنتُم مِّن قَبۡلِهِۦ لَمِنَ ٱلضَّآلِّينَ",
    translation:
      "There is no blame upon you for seeking bounty from your Lord [during Hajj]. But when you depart from 'Arafat, remember Allah at al- Mash'ar al-Haram. And remember Him, as He has guided you, for indeed, you were before that among those astray",
    normalizedText:
      "ليس عليكم جناح ان تبتغوا فضلا من ربكم فاذا افضتم من عرفت فاذكروا الله عند المشعر الحرام واذكروه كما هدىكم وان كنتم من قبله لمن الضالين",
  },
  {
    verseId: 198,
    name: "البقرة",
    surahId: 2,
    text: "ثُمَّ أَفِيضُواْ مِنۡ حَيۡثُ أَفَاضَ ٱلنَّاسُ وَٱسۡتَغۡفِرُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "Then depart from the place from where [all] the people depart and ask forgiveness of Allah. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "ثم افيضوا من حيث افاض الناس واستغفروا الله ان الله غفور رحيم",
  },
  {
    verseId: 199,
    name: "البقرة",
    surahId: 2,
    text: "فَإِذَا قَضَيۡتُم مَّنَٰسِكَكُمۡ فَٱذۡكُرُواْ ٱللَّهَ كَذِكۡرِكُمۡ ءَابَآءَكُمۡ أَوۡ أَشَدَّ ذِكۡرٗاۗ فَمِنَ ٱلنَّاسِ مَن يَقُولُ رَبَّنَآ ءَاتِنَا فِي ٱلدُّنۡيَا وَمَا لَهُۥ فِي ٱلۡأٓخِرَةِ مِنۡ خَلَٰقٖ",
    translation:
      'And when you have completed your rites, remember Allah like your [previous] remembrance of your fathers or with [much] greater remembrance. And among the people is he who says, "Our Lord, give us in this world," and he will have in the Hereafter no share',
    normalizedText:
      "فاذا قضيتم منسككم فاذكروا الله كذكركم ءاباءكم او اشد ذكرا فمن الناس من يقول ربنا ءاتنا في الدنيا وما له في الاخرة من خلق",
  },
  {
    verseId: 200,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنۡهُم مَّن يَقُولُ رَبَّنَآ ءَاتِنَا فِي ٱلدُّنۡيَا حَسَنَةٗ وَفِي ٱلۡأٓخِرَةِ حَسَنَةٗ وَقِنَا عَذَابَ ٱلنَّارِ",
    translation:
      'But among them is he who says, "Our Lord, give us in this world [that which is] good and in the Hereafter [that which is] good and protect us from the punishment of the Fire',
    normalizedText:
      "ومنهم من يقول ربنا ءاتنا في الدنيا حسنة وفي الاخرة حسنة وقنا عذاب النار",
  },
  {
    verseId: 201,
    name: "البقرة",
    surahId: 2,
    text: "أُوْلَـٰٓئِكَ لَهُمۡ نَصِيبٞ مِّمَّا كَسَبُواْۚ وَٱللَّهُ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      "Those will have a share of what they have earned, and Allah is swift in account",
    normalizedText: "اولاك لهم نصيب مما كسبوا والله سريع الحساب",
  },
  {
    verseId: 202,
    name: "البقرة",
    surahId: 2,
    text: "۞وَٱذۡكُرُواْ ٱللَّهَ فِيٓ أَيَّامٖ مَّعۡدُودَٰتٖۚ فَمَن تَعَجَّلَ فِي يَوۡمَيۡنِ فَلَآ إِثۡمَ عَلَيۡهِ وَمَن تَأَخَّرَ فَلَآ إِثۡمَ عَلَيۡهِۖ لِمَنِ ٱتَّقَىٰۗ وَٱتَّقُواْ ٱللَّهَ وَٱعۡلَمُوٓاْ أَنَّكُمۡ إِلَيۡهِ تُحۡشَرُونَ",
    translation:
      "And remember Allah during [specific] numbered days. Then whoever hastens [his departure] in two days - there is no sin upon him; and whoever delays [until the third] - there is no sin upon him - for him who fears Allah. And fear Allah and know that unto Him you will be gathered",
    normalizedText:
      "۞واذكروا الله في ايام معدودت فمن تعجل في يومين فلا اثم عليه ومن تاخر فلا اثم عليه لمن اتقى واتقوا الله واعلموا انكم اليه تحشرون",
  },
  {
    verseId: 203,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنَ ٱلنَّاسِ مَن يُعۡجِبُكَ قَوۡلُهُۥ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَيُشۡهِدُ ٱللَّهَ عَلَىٰ مَا فِي قَلۡبِهِۦ وَهُوَ أَلَدُّ ٱلۡخِصَامِ",
    translation:
      "And of the people is he whose speech pleases you in worldly life, and he calls Allah to witness as to what is in his heart, yet he is the fiercest of opponents",
    normalizedText:
      "ومن الناس من يعجبك قوله في الحيوة الدنيا ويشهد الله على ما في قلبه وهو الد الخصام",
  },
  {
    verseId: 204,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا تَوَلَّىٰ سَعَىٰ فِي ٱلۡأَرۡضِ لِيُفۡسِدَ فِيهَا وَيُهۡلِكَ ٱلۡحَرۡثَ وَٱلنَّسۡلَۚ وَٱللَّهُ لَا يُحِبُّ ٱلۡفَسَادَ",
    translation:
      "And when he goes away, he strives throughout the land to cause corruption therein and destroy crops and animals. And Allah does not like corruption",
    normalizedText:
      "واذا تولى سعى في الارض ليفسد فيها ويهلك الحرث والنسل والله لا يحب الفساد",
  },
  {
    verseId: 205,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا قِيلَ لَهُ ٱتَّقِ ٱللَّهَ أَخَذَتۡهُ ٱلۡعِزَّةُ بِٱلۡإِثۡمِۚ فَحَسۡبُهُۥ جَهَنَّمُۖ وَلَبِئۡسَ ٱلۡمِهَادُ",
    translation:
      'And when it is said to him, "Fear Allah," pride in the sin takes hold of him. Sufficient for him is Hellfire, and how wretched is the resting place',
    normalizedText:
      "واذا قيل له اتق الله اخذته العزة بالاثم فحسبه جهنم ولباس المهاد",
  },
  {
    verseId: 206,
    name: "البقرة",
    surahId: 2,
    text: "وَمِنَ ٱلنَّاسِ مَن يَشۡرِي نَفۡسَهُ ٱبۡتِغَآءَ مَرۡضَاتِ ٱللَّهِۚ وَٱللَّهُ رَءُوفُۢ بِٱلۡعِبَادِ",
    translation:
      "And of the people is he who sells himself, seeking means to the approval of Allah. And Allah is kind to [His] servants",
    normalizedText:
      "ومن الناس من يشري نفسه ابتغاء مرضات الله والله رءوف بالعباد",
  },
  {
    verseId: 207,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱدۡخُلُواْ فِي ٱلسِّلۡمِ كَآفَّةٗ وَلَا تَتَّبِعُواْ خُطُوَٰتِ ٱلشَّيۡطَٰنِۚ إِنَّهُۥ لَكُمۡ عَدُوّٞ مُّبِينٞ",
    translation:
      "O you who have believed, enter into Islam completely [and perfectly] and do not follow the footsteps of Satan. Indeed, he is to you a clear enemy",
    normalizedText:
      "يايها الذين ءامنوا ادخلوا في السلم كافة ولا تتبعوا خطوت الشيطن انه لكم عدو مبين",
  },
  {
    verseId: 208,
    name: "البقرة",
    surahId: 2,
    text: "فَإِن زَلَلۡتُم مِّنۢ بَعۡدِ مَا جَآءَتۡكُمُ ٱلۡبَيِّنَٰتُ فَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌ",
    translation:
      "But if you deviate after clear proofs have come to you, then know that Allah is Exalted in Might and Wise",
    normalizedText:
      "فان زللتم من بعد ما جاءتكم البينت فاعلموا ان الله عزيز حكيم",
  },
  {
    verseId: 209,
    name: "البقرة",
    surahId: 2,
    text: "هَلۡ يَنظُرُونَ إِلَّآ أَن يَأۡتِيَهُمُ ٱللَّهُ فِي ظُلَلٖ مِّنَ ٱلۡغَمَامِ وَٱلۡمَلَـٰٓئِكَةُ وَقُضِيَ ٱلۡأَمۡرُۚ وَإِلَى ٱللَّهِ تُرۡجَعُ ٱلۡأُمُورُ",
    translation:
      "Do they await but that Allah should come to them in covers of clouds and the angels [as well] and the matter is [then] decided? And to Allah [all] matters are returned",
    normalizedText:
      "هل ينظرون الا ان ياتيهم الله في ظلل من الغمام والملاكة وقضي الامر والى الله ترجع الامور",
  },
  {
    verseId: 210,
    name: "البقرة",
    surahId: 2,
    text: "سَلۡ بَنِيٓ إِسۡرَـٰٓءِيلَ كَمۡ ءَاتَيۡنَٰهُم مِّنۡ ءَايَةِۭ بَيِّنَةٖۗ وَمَن يُبَدِّلۡ نِعۡمَةَ ٱللَّهِ مِنۢ بَعۡدِ مَا جَآءَتۡهُ فَإِنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "Ask the Children of Israel how many a sign of evidence We have given them. And whoever exchanges the favor of Allah [for disbelief] after it has come to him - then indeed, Allah is severe in penalty",
    normalizedText:
      "سل بني اسرءيل كم ءاتينهم من ءاية بينة ومن يبدل نعمة الله من بعد ما جاءته فان الله شديد العقاب",
  },
  {
    verseId: 211,
    name: "البقرة",
    surahId: 2,
    text: "زُيِّنَ لِلَّذِينَ كَفَرُواْ ٱلۡحَيَوٰةُ ٱلدُّنۡيَا وَيَسۡخَرُونَ مِنَ ٱلَّذِينَ ءَامَنُواْۘ وَٱلَّذِينَ ٱتَّقَوۡاْ فَوۡقَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِۗ وَٱللَّهُ يَرۡزُقُ مَن يَشَآءُ بِغَيۡرِ حِسَابٖ",
    translation:
      "Beautified for those who disbelieve is the life of this world, and they ridicule those who believe. But those who fear Allah are above them on the Day of Resurrection. And Allah gives provision to whom He wills without account",
    normalizedText:
      "زين للذين كفروا الحيوة الدنيا ويسخرون من الذين ءامنوا والذين اتقوا فوقهم يوم القيمة والله يرزق من يشاء بغير حساب",
  },
  {
    verseId: 212,
    name: "البقرة",
    surahId: 2,
    text: "كَانَ ٱلنَّاسُ أُمَّةٗ وَٰحِدَةٗ فَبَعَثَ ٱللَّهُ ٱلنَّبِيِّـۧنَ مُبَشِّرِينَ وَمُنذِرِينَ وَأَنزَلَ مَعَهُمُ ٱلۡكِتَٰبَ بِٱلۡحَقِّ لِيَحۡكُمَ بَيۡنَ ٱلنَّاسِ فِيمَا ٱخۡتَلَفُواْ فِيهِۚ وَمَا ٱخۡتَلَفَ فِيهِ إِلَّا ٱلَّذِينَ أُوتُوهُ مِنۢ بَعۡدِ مَا جَآءَتۡهُمُ ٱلۡبَيِّنَٰتُ بَغۡيَۢا بَيۡنَهُمۡۖ فَهَدَى ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ لِمَا ٱخۡتَلَفُواْ فِيهِ مِنَ ٱلۡحَقِّ بِإِذۡنِهِۦۗ وَٱللَّهُ يَهۡدِي مَن يَشَآءُ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٍ",
    translation:
      "Mankind was [of] one religion [before their deviation]; then Allah sent the prophets as bringers of good tidings and warners and sent down with them the Scripture in truth to judge between the people concerning that in which they differed. And none differed over the Scripture except those who were given it - after the clear proofs came to them - out of jealous animosity among themselves. And Allah guided those who believed to the truth concerning that over which they had differed, by His permission. And Allah guides whom He wills to a straight path",
    normalizedText:
      "كان الناس امة وحدة فبعث الله النبين مبشرين ومنذرين وانزل معهم الكتب بالحق ليحكم بين الناس فيما اختلفوا فيه وما اختلف فيه الا الذين اوتوه من بعد ما جاءتهم البينت بغيا بينهم فهدى الله الذين ءامنوا لما اختلفوا فيه من الحق باذنه والله يهدي من يشاء الى صرط مستقيم",
  },
  {
    verseId: 213,
    name: "البقرة",
    surahId: 2,
    text: "أَمۡ حَسِبۡتُمۡ أَن تَدۡخُلُواْ ٱلۡجَنَّةَ وَلَمَّا يَأۡتِكُم مَّثَلُ ٱلَّذِينَ خَلَوۡاْ مِن قَبۡلِكُمۖ مَّسَّتۡهُمُ ٱلۡبَأۡسَآءُ وَٱلضَّرَّآءُ وَزُلۡزِلُواْ حَتَّىٰ يَقُولَ ٱلرَّسُولُ وَٱلَّذِينَ ءَامَنُواْ مَعَهُۥ مَتَىٰ نَصۡرُ ٱللَّهِۗ أَلَآ إِنَّ نَصۡرَ ٱللَّهِ قَرِيبٞ",
    translation:
      'Or do you think that you will enter Paradise while such [trial] has not yet come to you as came to those who passed on before you? They were touched by poverty and hardship and were shaken until [even their] messenger and those who believed with him said, "When is the help of Allah?" Unquestionably, the help of Allah is near',
    normalizedText:
      "ام حسبتم ان تدخلوا الجنة ولما ياتكم مثل الذين خلوا من قبلكم مستهم الباساء والضراء وزلزلوا حتى يقول الرسول والذين ءامنوا معه متى نصر الله الا ان نصر الله قريب",
  },
  {
    verseId: 214,
    name: "البقرة",
    surahId: 2,
    text: "يَسۡـَٔلُونَكَ مَاذَا يُنفِقُونَۖ قُلۡ مَآ أَنفَقۡتُم مِّنۡ خَيۡرٖ فَلِلۡوَٰلِدَيۡنِ وَٱلۡأَقۡرَبِينَ وَٱلۡيَتَٰمَىٰ وَٱلۡمَسَٰكِينِ وَٱبۡنِ ٱلسَّبِيلِۗ وَمَا تَفۡعَلُواْ مِنۡ خَيۡرٖ فَإِنَّ ٱللَّهَ بِهِۦ عَلِيمٞ",
    translation:
      'They ask you, [O Muhammad], what they should spend. Say, "Whatever you spend of good is [to be] for parents and relatives and orphans and the needy and the traveler. And whatever you do of good - indeed, Allah is Knowing of it',
    normalizedText:
      "يسلونك ماذا ينفقون قل ما انفقتم من خير فللولدين والاقربين واليتمى والمسكين وابن السبيل وما تفعلوا من خير فان الله به عليم",
  },
  {
    verseId: 215,
    name: "البقرة",
    surahId: 2,
    text: "كُتِبَ عَلَيۡكُمُ ٱلۡقِتَالُ وَهُوَ كُرۡهٞ لَّكُمۡۖ وَعَسَىٰٓ أَن تَكۡرَهُواْ شَيۡـٔٗا وَهُوَ خَيۡرٞ لَّكُمۡۖ وَعَسَىٰٓ أَن تُحِبُّواْ شَيۡـٔٗا وَهُوَ شَرّٞ لَّكُمۡۚ وَٱللَّهُ يَعۡلَمُ وَأَنتُمۡ لَا تَعۡلَمُونَ",
    translation:
      "Fighting has been enjoined upon you while it is hateful to you. But perhaps you hate a thing and it is good for you; and perhaps you love a thing and it is bad for you. And Allah Knows, while you know not",
    normalizedText:
      "كتب عليكم القتال وهو كره لكم وعسى ان تكرهوا شيا وهو خير لكم وعسى ان تحبوا شيا وهو شر لكم والله يعلم وانتم لا تعلمون",
  },
  {
    verseId: 216,
    name: "البقرة",
    surahId: 2,
    text: "يَسۡـَٔلُونَكَ عَنِ ٱلشَّهۡرِ ٱلۡحَرَامِ قِتَالٖ فِيهِۖ قُلۡ قِتَالٞ فِيهِ كَبِيرٞۚ وَصَدٌّ عَن سَبِيلِ ٱللَّهِ وَكُفۡرُۢ بِهِۦ وَٱلۡمَسۡجِدِ ٱلۡحَرَامِ وَإِخۡرَاجُ أَهۡلِهِۦ مِنۡهُ أَكۡبَرُ عِندَ ٱللَّهِۚ وَٱلۡفِتۡنَةُ أَكۡبَرُ مِنَ ٱلۡقَتۡلِۗ وَلَا يَزَالُونَ يُقَٰتِلُونَكُمۡ حَتَّىٰ يَرُدُّوكُمۡ عَن دِينِكُمۡ إِنِ ٱسۡتَطَٰعُواْۚ وَمَن يَرۡتَدِدۡ مِنكُمۡ عَن دِينِهِۦ فَيَمُتۡ وَهُوَ كَافِرٞ فَأُوْلَـٰٓئِكَ حَبِطَتۡ أَعۡمَٰلُهُمۡ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِۖ وَأُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      'They ask you about the sacred month - about fighting therein. Say, "Fighting therein is great [sin], but averting [people] from the way of Allah and disbelief in Him and [preventing access to] al-Masjid al-Haram and the expulsion of its people therefrom are greater [evil] in the sight of Allah. And fitnah is greater than killing." And they will continue to fight you until they turn you back from your religion if they are able. And whoever of you reverts from his religion [to disbelief] and dies while he is a disbeliever - for those, their deeds have become worthless in this world and the Hereafter, and those are the companions of the Fire, they will abide therein eternally',
    normalizedText:
      "يسلونك عن الشهر الحرام قتال فيه قل قتال فيه كبير وصد عن سبيل الله وكفر به والمسجد الحرام واخراج اهله منه اكبر عند الله والفتنة اكبر من القتل ولا يزالون يقتلونكم حتى يردوكم عن دينكم ان استطعوا ومن يرتدد منكم عن دينه فيمت وهو كافر فاولاك حبطت اعملهم في الدنيا والاخرة واولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 217,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَٱلَّذِينَ هَاجَرُواْ وَجَٰهَدُواْ فِي سَبِيلِ ٱللَّهِ أُوْلَـٰٓئِكَ يَرۡجُونَ رَحۡمَتَ ٱللَّهِۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "Indeed, those who have believed and those who have emigrated and fought in the cause of Allah - those expect the mercy of Allah. And Allah is Forgiving and Merciful",
    normalizedText:
      "ان الذين ءامنوا والذين هاجروا وجهدوا في سبيل الله اولاك يرجون رحمت الله والله غفور رحيم",
  },
  {
    verseId: 218,
    name: "البقرة",
    surahId: 2,
    text: "۞يَسۡـَٔلُونَكَ عَنِ ٱلۡخَمۡرِ وَٱلۡمَيۡسِرِۖ قُلۡ فِيهِمَآ إِثۡمٞ كَبِيرٞ وَمَنَٰفِعُ لِلنَّاسِ وَإِثۡمُهُمَآ أَكۡبَرُ مِن نَّفۡعِهِمَاۗ وَيَسۡـَٔلُونَكَ مَاذَا يُنفِقُونَۖ قُلِ ٱلۡعَفۡوَۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلۡأٓيَٰتِ لَعَلَّكُمۡ تَتَفَكَّرُونَ",
    translation:
      'They ask you about wine and gambling. Say, "In them is great sin and [yet, some] benefit for people. But their sin is greater than their benefit." And they ask you what they should spend. Say, "The excess [beyond needs]." Thus Allah makes clear to you the verses [of revelation] that you might give thought',
    normalizedText:
      "۞يسلونك عن الخمر والميسر قل فيهما اثم كبير ومنفع للناس واثمهما اكبر من نفعهما ويسلونك ماذا ينفقون قل العفو كذلك يبين الله لكم الايت لعلكم تتفكرون",
  },
  {
    verseId: 219,
    name: "البقرة",
    surahId: 2,
    text: "فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِۗ وَيَسۡـَٔلُونَكَ عَنِ ٱلۡيَتَٰمَىٰۖ قُلۡ إِصۡلَاحٞ لَّهُمۡ خَيۡرٞۖ وَإِن تُخَالِطُوهُمۡ فَإِخۡوَٰنُكُمۡۚ وَٱللَّهُ يَعۡلَمُ ٱلۡمُفۡسِدَ مِنَ ٱلۡمُصۡلِحِۚ وَلَوۡ شَآءَ ٱللَّهُ لَأَعۡنَتَكُمۡۚ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٞ",
    translation:
      'To this world and the Hereafter. And they ask you about orphans. Say, "Improvement for them is best. And if you mix your affairs with theirs - they are your brothers. And Allah knows the corrupter from the amender. And if Allah had willed, He could have put you in difficulty. Indeed, Allah is Exalted in Might and Wise',
    normalizedText:
      "في الدنيا والاخرة ويسلونك عن اليتمى قل اصلاح لهم خير وان تخالطوهم فاخونكم والله يعلم المفسد من المصلح ولو شاء الله لاعنتكم ان الله عزيز حكيم",
  },
  {
    verseId: 220,
    name: "البقرة",
    surahId: 2,
    text: "وَلَا تَنكِحُواْ ٱلۡمُشۡرِكَٰتِ حَتَّىٰ يُؤۡمِنَّۚ وَلَأَمَةٞ مُّؤۡمِنَةٌ خَيۡرٞ مِّن مُّشۡرِكَةٖ وَلَوۡ أَعۡجَبَتۡكُمۡۗ وَلَا تُنكِحُواْ ٱلۡمُشۡرِكِينَ حَتَّىٰ يُؤۡمِنُواْۚ وَلَعَبۡدٞ مُّؤۡمِنٌ خَيۡرٞ مِّن مُّشۡرِكٖ وَلَوۡ أَعۡجَبَكُمۡۗ أُوْلَـٰٓئِكَ يَدۡعُونَ إِلَى ٱلنَّارِۖ وَٱللَّهُ يَدۡعُوٓاْ إِلَى ٱلۡجَنَّةِ وَٱلۡمَغۡفِرَةِ بِإِذۡنِهِۦۖ وَيُبَيِّنُ ءَايَٰتِهِۦ لِلنَّاسِ لَعَلَّهُمۡ يَتَذَكَّرُونَ",
    translation:
      "And do not marry polytheistic women until they believe. And a believing slave woman is better than a polytheist, even though she might please you. And do not marry polytheistic men [to your women] until they believe. And a believing slave is better than a polytheist, even though he might please you. Those invite [you] to the Fire, but Allah invites to Paradise and to forgiveness, by His permission. And He makes clear His verses to the people that perhaps they may remember",
    normalizedText:
      "ولا تنكحوا المشركت حتى يامن ولامة مامنة خير من مشركة ولو اعجبتكم ولا تنكحوا المشركين حتى يامنوا ولعبد مامن خير من مشرك ولو اعجبكم اولاك يدعون الى النار والله يدعوا الى الجنة والمغفرة باذنه ويبين ءايته للناس لعلهم يتذكرون",
  },
  {
    verseId: 221,
    name: "البقرة",
    surahId: 2,
    text: "وَيَسۡـَٔلُونَكَ عَنِ ٱلۡمَحِيضِۖ قُلۡ هُوَ أَذٗى فَٱعۡتَزِلُواْ ٱلنِّسَآءَ فِي ٱلۡمَحِيضِ وَلَا تَقۡرَبُوهُنَّ حَتَّىٰ يَطۡهُرۡنَۖ فَإِذَا تَطَهَّرۡنَ فَأۡتُوهُنَّ مِنۡ حَيۡثُ أَمَرَكُمُ ٱللَّهُۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلتَّوَّـٰبِينَ وَيُحِبُّ ٱلۡمُتَطَهِّرِينَ",
    translation:
      'And they ask you about menstruation. Say, "It is harm, so keep away from wives during menstruation. And do not approach them until they are pure. And when they have purified themselves, then come to them from where Allah has ordained for you. Indeed, Allah loves those who are constantly repentant and loves those who purify themselves',
    normalizedText:
      "ويسلونك عن المحيض قل هو اذى فاعتزلوا النساء في المحيض ولا تقربوهن حتى يطهرن فاذا تطهرن فاتوهن من حيث امركم الله ان الله يحب التوبين ويحب المتطهرين",
  },
  {
    verseId: 222,
    name: "البقرة",
    surahId: 2,
    text: "نِسَآؤُكُمۡ حَرۡثٞ لَّكُمۡ فَأۡتُواْ حَرۡثَكُمۡ أَنَّىٰ شِئۡتُمۡۖ وَقَدِّمُواْ لِأَنفُسِكُمۡۚ وَٱتَّقُواْ ٱللَّهَ وَٱعۡلَمُوٓاْ أَنَّكُم مُّلَٰقُوهُۗ وَبَشِّرِ ٱلۡمُؤۡمِنِينَ",
    translation:
      "Your wives are a place of sowing of seed for you, so come to your place of cultivation however you wish and put forth [righteousness] for yourselves. And fear Allah and know that you will meet Him. And give good tidings to the believers",
    normalizedText:
      "نسااكم حرث لكم فاتوا حرثكم انى شاتم وقدموا لانفسكم واتقوا الله واعلموا انكم ملقوه وبشر المامنين",
  },
  {
    verseId: 223,
    name: "البقرة",
    surahId: 2,
    text: "وَلَا تَجۡعَلُواْ ٱللَّهَ عُرۡضَةٗ لِّأَيۡمَٰنِكُمۡ أَن تَبَرُّواْ وَتَتَّقُواْ وَتُصۡلِحُواْ بَيۡنَ ٱلنَّاسِۚ وَٱللَّهُ سَمِيعٌ عَلِيمٞ",
    translation:
      "And do not make [your oath by] Allah an excuse against being righteous and fearing Allah and making peace among people. And Allah is Hearing and Knowing",
    normalizedText:
      "ولا تجعلوا الله عرضة لايمنكم ان تبروا وتتقوا وتصلحوا بين الناس والله سميع عليم",
  },
  {
    verseId: 224,
    name: "البقرة",
    surahId: 2,
    text: "لَّا يُؤَاخِذُكُمُ ٱللَّهُ بِٱللَّغۡوِ فِيٓ أَيۡمَٰنِكُمۡ وَلَٰكِن يُؤَاخِذُكُم بِمَا كَسَبَتۡ قُلُوبُكُمۡۗ وَٱللَّهُ غَفُورٌ حَلِيمٞ",
    translation:
      "Allah does not impose blame upon you for what is unintentional in your oaths, but He imposes blame upon you for what your hearts have earned. And Allah is Forgiving and Forbearing",
    normalizedText:
      "لا يااخذكم الله باللغو في ايمنكم ولكن يااخذكم بما كسبت قلوبكم والله غفور حليم",
  },
  {
    verseId: 225,
    name: "البقرة",
    surahId: 2,
    text: "لِّلَّذِينَ يُؤۡلُونَ مِن نِّسَآئِهِمۡ تَرَبُّصُ أَرۡبَعَةِ أَشۡهُرٖۖ فَإِن فَآءُو فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "For those who swear not to have sexual relations with their wives is a waiting time of four months, but if they return [to normal relations] - then indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "للذين يالون من نسااهم تربص اربعة اشهر فان فاءو فان الله غفور رحيم",
  },
  {
    verseId: 226,
    name: "البقرة",
    surahId: 2,
    text: "وَإِنۡ عَزَمُواْ ٱلطَّلَٰقَ فَإِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٞ",
    translation:
      "And if they decide on divorce - then indeed, Allah is Hearing and Knowing",
    normalizedText: "وان عزموا الطلق فان الله سميع عليم",
  },
  {
    verseId: 227,
    name: "البقرة",
    surahId: 2,
    text: "وَٱلۡمُطَلَّقَٰتُ يَتَرَبَّصۡنَ بِأَنفُسِهِنَّ ثَلَٰثَةَ قُرُوٓءٖۚ وَلَا يَحِلُّ لَهُنَّ أَن يَكۡتُمۡنَ مَا خَلَقَ ٱللَّهُ فِيٓ أَرۡحَامِهِنَّ إِن كُنَّ يُؤۡمِنَّ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِۚ وَبُعُولَتُهُنَّ أَحَقُّ بِرَدِّهِنَّ فِي ذَٰلِكَ إِنۡ أَرَادُوٓاْ إِصۡلَٰحٗاۚ وَلَهُنَّ مِثۡلُ ٱلَّذِي عَلَيۡهِنَّ بِٱلۡمَعۡرُوفِۚ وَلِلرِّجَالِ عَلَيۡهِنَّ دَرَجَةٞۗ وَٱللَّهُ عَزِيزٌ حَكِيمٌ",
    translation:
      "Divorced women remain in waiting for three periods, and it is not lawful for them to conceal what Allah has created in their wombs if they believe in Allah and the Last Day. And their husbands have more right to take them back in this [period] if they want reconciliation. And due to the wives is similar to what is expected of them, according to what is reasonable. But the men have a degree over them [in responsibility and authority]. And Allah is Exalted in Might and Wise",
    normalizedText:
      "والمطلقت يتربصن بانفسهن ثلثة قروء ولا يحل لهن ان يكتمن ما خلق الله في ارحامهن ان كن يامن بالله واليوم الاخر وبعولتهن احق بردهن في ذلك ان ارادوا اصلحا ولهن مثل الذي عليهن بالمعروف وللرجال عليهن درجة والله عزيز حكيم",
  },
  {
    verseId: 228,
    name: "البقرة",
    surahId: 2,
    text: "ٱلطَّلَٰقُ مَرَّتَانِۖ فَإِمۡسَاكُۢ بِمَعۡرُوفٍ أَوۡ تَسۡرِيحُۢ بِإِحۡسَٰنٖۗ وَلَا يَحِلُّ لَكُمۡ أَن تَأۡخُذُواْ مِمَّآ ءَاتَيۡتُمُوهُنَّ شَيۡـًٔا إِلَّآ أَن يَخَافَآ أَلَّا يُقِيمَا حُدُودَ ٱللَّهِۖ فَإِنۡ خِفۡتُمۡ أَلَّا يُقِيمَا حُدُودَ ٱللَّهِ فَلَا جُنَاحَ عَلَيۡهِمَا فِيمَا ٱفۡتَدَتۡ بِهِۦۗ تِلۡكَ حُدُودُ ٱللَّهِ فَلَا تَعۡتَدُوهَاۚ وَمَن يَتَعَدَّ حُدُودَ ٱللَّهِ فَأُوْلَـٰٓئِكَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "Divorce is twice. Then, either keep [her] in an acceptable manner or release [her] with good treatment. And it is not lawful for you to take anything of what you have given them unless both fear that they will not be able to keep [within] the limits of Allah. But if you fear that they will not keep [within] the limits of Allah, then there is no blame upon either of them concerning that by which she ransoms herself. These are the limits of Allah, so do not transgress them. And whoever transgresses the limits of Allah - it is those who are the wrongdoers",
    normalizedText:
      "الطلق مرتان فامساك بمعروف او تسريح باحسن ولا يحل لكم ان تاخذوا مما ءاتيتموهن شيا الا ان يخافا الا يقيما حدود الله فان خفتم الا يقيما حدود الله فلا جناح عليهما فيما افتدت به تلك حدود الله فلا تعتدوها ومن يتعد حدود الله فاولاك هم الظلمون",
  },
  {
    verseId: 229,
    name: "البقرة",
    surahId: 2,
    text: "فَإِن طَلَّقَهَا فَلَا تَحِلُّ لَهُۥ مِنۢ بَعۡدُ حَتَّىٰ تَنكِحَ زَوۡجًا غَيۡرَهُۥۗ فَإِن طَلَّقَهَا فَلَا جُنَاحَ عَلَيۡهِمَآ أَن يَتَرَاجَعَآ إِن ظَنَّآ أَن يُقِيمَا حُدُودَ ٱللَّهِۗ وَتِلۡكَ حُدُودُ ٱللَّهِ يُبَيِّنُهَا لِقَوۡمٖ يَعۡلَمُونَ",
    translation:
      "And if he has divorced her [for the third time], then she is not lawful to him afterward until [after] she marries a husband other than him. And if the latter husband divorces her [or dies], there is no blame upon the woman and her former husband for returning to each other if they think that they can keep [within] the limits of Allah. These are the limits of Allah, which He makes clear to a people who know",
    normalizedText:
      "فان طلقها فلا تحل له من بعد حتى تنكح زوجا غيره فان طلقها فلا جناح عليهما ان يتراجعا ان ظنا ان يقيما حدود الله وتلك حدود الله يبينها لقوم يعلمون",
  },
  {
    verseId: 230,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا طَلَّقۡتُمُ ٱلنِّسَآءَ فَبَلَغۡنَ أَجَلَهُنَّ فَأَمۡسِكُوهُنَّ بِمَعۡرُوفٍ أَوۡ سَرِّحُوهُنَّ بِمَعۡرُوفٖۚ وَلَا تُمۡسِكُوهُنَّ ضِرَارٗا لِّتَعۡتَدُواْۚ وَمَن يَفۡعَلۡ ذَٰلِكَ فَقَدۡ ظَلَمَ نَفۡسَهُۥۚ وَلَا تَتَّخِذُوٓاْ ءَايَٰتِ ٱللَّهِ هُزُوٗاۚ وَٱذۡكُرُواْ نِعۡمَتَ ٱللَّهِ عَلَيۡكُمۡ وَمَآ أَنزَلَ عَلَيۡكُم مِّنَ ٱلۡكِتَٰبِ وَٱلۡحِكۡمَةِ يَعِظُكُم بِهِۦۚ وَٱتَّقُواْ ٱللَّهَ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "And when you divorce women and they have [nearly] fulfilled their term, either retain them according to acceptable terms or release them according to acceptable terms, and do not keep them, intending harm, to transgress [against them]. And whoever does that has certainly wronged himself. And do not take the verses of Allah in jest. And remember the favor of Allah upon you and what has been revealed to you of the Book and wisdom by which He instructs you. And fear Allah and know that Allah is Knowing of all things",
    normalizedText:
      "واذا طلقتم النساء فبلغن اجلهن فامسكوهن بمعروف او سرحوهن بمعروف ولا تمسكوهن ضرارا لتعتدوا ومن يفعل ذلك فقد ظلم نفسه ولا تتخذوا ءايت الله هزوا واذكروا نعمت الله عليكم وما انزل عليكم من الكتب والحكمة يعظكم به واتقوا الله واعلموا ان الله بكل شيء عليم",
  },
  {
    verseId: 231,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذَا طَلَّقۡتُمُ ٱلنِّسَآءَ فَبَلَغۡنَ أَجَلَهُنَّ فَلَا تَعۡضُلُوهُنَّ أَن يَنكِحۡنَ أَزۡوَٰجَهُنَّ إِذَا تَرَٰضَوۡاْ بَيۡنَهُم بِٱلۡمَعۡرُوفِۗ ذَٰلِكَ يُوعَظُ بِهِۦ مَن كَانَ مِنكُمۡ يُؤۡمِنُ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِۗ ذَٰلِكُمۡ أَزۡكَىٰ لَكُمۡ وَأَطۡهَرُۚ وَٱللَّهُ يَعۡلَمُ وَأَنتُمۡ لَا تَعۡلَمُونَ",
    translation:
      "And when you divorce women and they have fulfilled their term, do not prevent them from remarrying their [former] husbands if they agree among themselves on an acceptable basis. That is instructed to whoever of you believes in Allah and the Last Day. That is better for you and purer, and Allah knows and you know not",
    normalizedText:
      "واذا طلقتم النساء فبلغن اجلهن فلا تعضلوهن ان ينكحن ازوجهن اذا ترضوا بينهم بالمعروف ذلك يوعظ به من كان منكم يامن بالله واليوم الاخر ذلكم ازكى لكم واطهر والله يعلم وانتم لا تعلمون",
  },
  {
    verseId: 232,
    name: "البقرة",
    surahId: 2,
    text: "۞وَٱلۡوَٰلِدَٰتُ يُرۡضِعۡنَ أَوۡلَٰدَهُنَّ حَوۡلَيۡنِ كَامِلَيۡنِۖ لِمَنۡ أَرَادَ أَن يُتِمَّ ٱلرَّضَاعَةَۚ وَعَلَى ٱلۡمَوۡلُودِ لَهُۥ رِزۡقُهُنَّ وَكِسۡوَتُهُنَّ بِٱلۡمَعۡرُوفِۚ لَا تُكَلَّفُ نَفۡسٌ إِلَّا وُسۡعَهَاۚ لَا تُضَآرَّ وَٰلِدَةُۢ بِوَلَدِهَا وَلَا مَوۡلُودٞ لَّهُۥ بِوَلَدِهِۦۚ وَعَلَى ٱلۡوَارِثِ مِثۡلُ ذَٰلِكَۗ فَإِنۡ أَرَادَا فِصَالًا عَن تَرَاضٖ مِّنۡهُمَا وَتَشَاوُرٖ فَلَا جُنَاحَ عَلَيۡهِمَاۗ وَإِنۡ أَرَدتُّمۡ أَن تَسۡتَرۡضِعُوٓاْ أَوۡلَٰدَكُمۡ فَلَا جُنَاحَ عَلَيۡكُمۡ إِذَا سَلَّمۡتُم مَّآ ءَاتَيۡتُم بِٱلۡمَعۡرُوفِۗ وَٱتَّقُواْ ٱللَّهَ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      "Mothers may breastfeed their children two complete years for whoever wishes to complete the nursing [period]. Upon the father is the mothers' provision and their clothing according to what is acceptable. No person is charged with more than his capacity. No mother should be harmed through her child, and no father through his child. And upon the [father's] heir is [a duty] like that [of the father]. And if they both desire weaning through mutual consent from both of them and consultation, there is no blame upon either of them. And if you wish to have your children nursed by a substitute, there is no blame upon you as long as you give payment according to what is acceptable. And fear Allah and know that Allah is Seeing of what you do",
    normalizedText:
      "۞والولدت يرضعن اولدهن حولين كاملين لمن اراد ان يتم الرضاعة وعلى المولود له رزقهن وكسوتهن بالمعروف لا تكلف نفس الا وسعها لا تضار ولدة بولدها ولا مولود له بولده وعلى الوارث مثل ذلك فان ارادا فصالا عن تراض منهما وتشاور فلا جناح عليهما وان اردتم ان تسترضعوا اولدكم فلا جناح عليكم اذا سلمتم ما ءاتيتم بالمعروف واتقوا الله واعلموا ان الله بما تعملون بصير",
  },
  {
    verseId: 233,
    name: "البقرة",
    surahId: 2,
    text: "وَٱلَّذِينَ يُتَوَفَّوۡنَ مِنكُمۡ وَيَذَرُونَ أَزۡوَٰجٗا يَتَرَبَّصۡنَ بِأَنفُسِهِنَّ أَرۡبَعَةَ أَشۡهُرٖ وَعَشۡرٗاۖ فَإِذَا بَلَغۡنَ أَجَلَهُنَّ فَلَا جُنَاحَ عَلَيۡكُمۡ فِيمَا فَعَلۡنَ فِيٓ أَنفُسِهِنَّ بِٱلۡمَعۡرُوفِۗ وَٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      "And those who are taken in death among you and leave wives behind - they, [the wives, shall] wait four months and ten [days]. And when they have fulfilled their term, then there is no blame upon you for what they do with themselves in an acceptable manner. And Allah is [fully] Acquainted with what you do",
    normalizedText:
      "والذين يتوفون منكم ويذرون ازوجا يتربصن بانفسهن اربعة اشهر وعشرا فاذا بلغن اجلهن فلا جناح عليكم فيما فعلن في انفسهن بالمعروف والله بما تعملون خبير",
  },
  {
    verseId: 234,
    name: "البقرة",
    surahId: 2,
    text: "وَلَا جُنَاحَ عَلَيۡكُمۡ فِيمَا عَرَّضۡتُم بِهِۦ مِنۡ خِطۡبَةِ ٱلنِّسَآءِ أَوۡ أَكۡنَنتُمۡ فِيٓ أَنفُسِكُمۡۚ عَلِمَ ٱللَّهُ أَنَّكُمۡ سَتَذۡكُرُونَهُنَّ وَلَٰكِن لَّا تُوَاعِدُوهُنَّ سِرًّا إِلَّآ أَن تَقُولُواْ قَوۡلٗا مَّعۡرُوفٗاۚ وَلَا تَعۡزِمُواْ عُقۡدَةَ ٱلنِّكَاحِ حَتَّىٰ يَبۡلُغَ ٱلۡكِتَٰبُ أَجَلَهُۥۚ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ يَعۡلَمُ مَا فِيٓ أَنفُسِكُمۡ فَٱحۡذَرُوهُۚ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ غَفُورٌ حَلِيمٞ",
    translation:
      "There is no blame upon you for that to which you [indirectly] allude concerning a proposal to women or for what you conceal within yourselves. Allah knows that you will have them in mind. But do not promise them secretly except for saying a proper saying. And do not determine to undertake a marriage contract until the decreed period reaches its end. And know that Allah knows what is within yourselves, so beware of Him. And know that Allah is Forgiving and Forbearing",
    normalizedText:
      "ولا جناح عليكم فيما عرضتم به من خطبة النساء او اكننتم في انفسكم علم الله انكم ستذكرونهن ولكن لا تواعدوهن سرا الا ان تقولوا قولا معروفا ولا تعزموا عقدة النكاح حتى يبلغ الكتب اجله واعلموا ان الله يعلم ما في انفسكم فاحذروه واعلموا ان الله غفور حليم",
  },
  {
    verseId: 235,
    name: "البقرة",
    surahId: 2,
    text: "لَّا جُنَاحَ عَلَيۡكُمۡ إِن طَلَّقۡتُمُ ٱلنِّسَآءَ مَا لَمۡ تَمَسُّوهُنَّ أَوۡ تَفۡرِضُواْ لَهُنَّ فَرِيضَةٗۚ وَمَتِّعُوهُنَّ عَلَى ٱلۡمُوسِعِ قَدَرُهُۥ وَعَلَى ٱلۡمُقۡتِرِ قَدَرُهُۥ مَتَٰعَۢا بِٱلۡمَعۡرُوفِۖ حَقًّا عَلَى ٱلۡمُحۡسِنِينَ",
    translation:
      "There is no blame upon you if you divorce women you have not touched nor specified for them an obligation. But give them [a gift of] compensation - the wealthy according to his capability and the poor according to his capability - a provision according to what is acceptable, a duty upon the doers of good",
    normalizedText:
      "لا جناح عليكم ان طلقتم النساء ما لم تمسوهن او تفرضوا لهن فريضة ومتعوهن على الموسع قدره وعلى المقتر قدره متعا بالمعروف حقا على المحسنين",
  },
  {
    verseId: 236,
    name: "البقرة",
    surahId: 2,
    text: "وَإِن طَلَّقۡتُمُوهُنَّ مِن قَبۡلِ أَن تَمَسُّوهُنَّ وَقَدۡ فَرَضۡتُمۡ لَهُنَّ فَرِيضَةٗ فَنِصۡفُ مَا فَرَضۡتُمۡ إِلَّآ أَن يَعۡفُونَ أَوۡ يَعۡفُوَاْ ٱلَّذِي بِيَدِهِۦ عُقۡدَةُ ٱلنِّكَاحِۚ وَأَن تَعۡفُوٓاْ أَقۡرَبُ لِلتَّقۡوَىٰۚ وَلَا تَنسَوُاْ ٱلۡفَضۡلَ بَيۡنَكُمۡۚ إِنَّ ٱللَّهَ بِمَا تَعۡمَلُونَ بَصِيرٌ",
    translation:
      "And if you divorce them before you have touched them and you have already specified for them an obligation, then [give] half of what you specified - unless they forego the right or the one in whose hand is the marriage contract foregoes it. And to forego it is nearer to righteousness. And do not forget graciousness between you. Indeed Allah, of whatever you do, is Seeing",
    normalizedText:
      "وان طلقتموهن من قبل ان تمسوهن وقد فرضتم لهن فريضة فنصف ما فرضتم الا ان يعفون او يعفوا الذي بيده عقدة النكاح وان تعفوا اقرب للتقوى ولا تنسوا الفضل بينكم ان الله بما تعملون بصير",
  },
  {
    verseId: 237,
    name: "البقرة",
    surahId: 2,
    text: "حَٰفِظُواْ عَلَى ٱلصَّلَوَٰتِ وَٱلصَّلَوٰةِ ٱلۡوُسۡطَىٰ وَقُومُواْ لِلَّهِ قَٰنِتِينَ",
    translation:
      "Maintain with care the [obligatory] prayers and [in particular] the middle prayer and stand before Allah, devoutly obedient",
    normalizedText: "حفظوا على الصلوت والصلوة الوسطى وقوموا لله قنتين",
  },
  {
    verseId: 238,
    name: "البقرة",
    surahId: 2,
    text: "فَإِنۡ خِفۡتُمۡ فَرِجَالًا أَوۡ رُكۡبَانٗاۖ فَإِذَآ أَمِنتُمۡ فَٱذۡكُرُواْ ٱللَّهَ كَمَا عَلَّمَكُم مَّا لَمۡ تَكُونُواْ تَعۡلَمُونَ",
    translation:
      "And if you fear [an enemy, then pray] on foot or riding. But when you are secure, then remember Allah [in prayer], as He has taught you that which you did not [previously] know",
    normalizedText:
      "فان خفتم فرجالا او ركبانا فاذا امنتم فاذكروا الله كما علمكم ما لم تكونوا تعلمون",
  },
  {
    verseId: 239,
    name: "البقرة",
    surahId: 2,
    text: "وَٱلَّذِينَ يُتَوَفَّوۡنَ مِنكُمۡ وَيَذَرُونَ أَزۡوَٰجٗا وَصِيَّةٗ لِّأَزۡوَٰجِهِم مَّتَٰعًا إِلَى ٱلۡحَوۡلِ غَيۡرَ إِخۡرَاجٖۚ فَإِنۡ خَرَجۡنَ فَلَا جُنَاحَ عَلَيۡكُمۡ فِي مَا فَعَلۡنَ فِيٓ أَنفُسِهِنَّ مِن مَّعۡرُوفٖۗ وَٱللَّهُ عَزِيزٌ حَكِيمٞ",
    translation:
      "And those who are taken in death among you and leave wives behind - for their wives is a bequest: maintenance for one year without turning [them] out. But if they leave [of their own accord], then there is no blame upon you for what they do with themselves in an acceptable way. And Allah is Exalted in Might and Wise",
    normalizedText:
      "والذين يتوفون منكم ويذرون ازوجا وصية لازوجهم متعا الى الحول غير اخراج فان خرجن فلا جناح عليكم في ما فعلن في انفسهن من معروف والله عزيز حكيم",
  },
  {
    verseId: 240,
    name: "البقرة",
    surahId: 2,
    text: "وَلِلۡمُطَلَّقَٰتِ مَتَٰعُۢ بِٱلۡمَعۡرُوفِۖ حَقًّا عَلَى ٱلۡمُتَّقِينَ",
    translation:
      "And for divorced women is a provision according to what is acceptable - a duty upon the righteous",
    normalizedText: "وللمطلقت متع بالمعروف حقا على المتقين",
  },
  {
    verseId: 241,
    name: "البقرة",
    surahId: 2,
    text: "كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمۡ ءَايَٰتِهِۦ لَعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      "Thus does Allah make clear to you His verses that you might use reason",
    normalizedText: "كذلك يبين الله لكم ءايته لعلكم تعقلون",
  },
  {
    verseId: 242,
    name: "البقرة",
    surahId: 2,
    text: "۞أَلَمۡ تَرَ إِلَى ٱلَّذِينَ خَرَجُواْ مِن دِيَٰرِهِمۡ وَهُمۡ أُلُوفٌ حَذَرَ ٱلۡمَوۡتِ فَقَالَ لَهُمُ ٱللَّهُ مُوتُواْ ثُمَّ أَحۡيَٰهُمۡۚ إِنَّ ٱللَّهَ لَذُو فَضۡلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَشۡكُرُونَ",
    translation:
      'Have you not considered those who left their homes in many thousands, fearing death? Allah said to them, "Die"; then He restored them to life. And Allah is full of bounty to the people, but most of the people do not show gratitude',
    normalizedText:
      "۞الم تر الى الذين خرجوا من ديرهم وهم الوف حذر الموت فقال لهم الله موتوا ثم احيهم ان الله لذو فضل على الناس ولكن اكثر الناس لا يشكرون",
  },
  {
    verseId: 243,
    name: "البقرة",
    surahId: 2,
    text: "وَقَٰتِلُواْ فِي سَبِيلِ ٱللَّهِ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ سَمِيعٌ عَلِيمٞ",
    translation:
      "And fight in the cause of Allah and know that Allah is Hearing and Knowing",
    normalizedText: "وقتلوا في سبيل الله واعلموا ان الله سميع عليم",
  },
  {
    verseId: 244,
    name: "البقرة",
    surahId: 2,
    text: "مَّن ذَا ٱلَّذِي يُقۡرِضُ ٱللَّهَ قَرۡضًا حَسَنٗا فَيُضَٰعِفَهُۥ لَهُۥٓ أَضۡعَافٗا كَثِيرَةٗۚ وَٱللَّهُ يَقۡبِضُ وَيَبۡصُۜطُ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "Who is it that would loan Allah a goodly loan so He may multiply it for him many times over? And it is Allah who withholds and grants abundance, and to Him you will be returned",
    normalizedText:
      "من ذا الذي يقرض الله قرضا حسنا فيضعفه له اضعافا كثيرة والله يقبض ويبصط واليه ترجعون",
  },
  {
    verseId: 245,
    name: "البقرة",
    surahId: 2,
    text: "أَلَمۡ تَرَ إِلَى ٱلۡمَلَإِ مِنۢ بَنِيٓ إِسۡرَـٰٓءِيلَ مِنۢ بَعۡدِ مُوسَىٰٓ إِذۡ قَالُواْ لِنَبِيّٖ لَّهُمُ ٱبۡعَثۡ لَنَا مَلِكٗا نُّقَٰتِلۡ فِي سَبِيلِ ٱللَّهِۖ قَالَ هَلۡ عَسَيۡتُمۡ إِن كُتِبَ عَلَيۡكُمُ ٱلۡقِتَالُ أَلَّا تُقَٰتِلُواْۖ قَالُواْ وَمَا لَنَآ أَلَّا نُقَٰتِلَ فِي سَبِيلِ ٱللَّهِ وَقَدۡ أُخۡرِجۡنَا مِن دِيَٰرِنَا وَأَبۡنَآئِنَاۖ فَلَمَّا كُتِبَ عَلَيۡهِمُ ٱلۡقِتَالُ تَوَلَّوۡاْ إِلَّا قَلِيلٗا مِّنۡهُمۡۚ وَٱللَّهُ عَلِيمُۢ بِٱلظَّـٰلِمِينَ",
    translation:
      'Have you not considered the assembly of the Children of Israel after [the time of] Moses when they said to a prophet of theirs, "Send to us a king, and we will fight in the way of Allah "? He said, "Would you perhaps refrain from fighting if fighting was prescribed for you?" They said, "And why should we not fight in the cause of Allah when we have been driven out from our homes and from our children?" But when fighting was prescribed for them, they turned away, except for a few of them. And Allah is Knowing of the wrongdoers',
    normalizedText:
      "الم تر الى الملا من بني اسرءيل من بعد موسى اذ قالوا لنبي لهم ابعث لنا ملكا نقتل في سبيل الله قال هل عسيتم ان كتب عليكم القتال الا تقتلوا قالوا وما لنا الا نقتل في سبيل الله وقد اخرجنا من ديرنا وابناانا فلما كتب عليهم القتال تولوا الا قليلا منهم والله عليم بالظلمين",
  },
  {
    verseId: 246,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالَ لَهُمۡ نَبِيُّهُمۡ إِنَّ ٱللَّهَ قَدۡ بَعَثَ لَكُمۡ طَالُوتَ مَلِكٗاۚ قَالُوٓاْ أَنَّىٰ يَكُونُ لَهُ ٱلۡمُلۡكُ عَلَيۡنَا وَنَحۡنُ أَحَقُّ بِٱلۡمُلۡكِ مِنۡهُ وَلَمۡ يُؤۡتَ سَعَةٗ مِّنَ ٱلۡمَالِۚ قَالَ إِنَّ ٱللَّهَ ٱصۡطَفَىٰهُ عَلَيۡكُمۡ وَزَادَهُۥ بَسۡطَةٗ فِي ٱلۡعِلۡمِ وَٱلۡجِسۡمِۖ وَٱللَّهُ يُؤۡتِي مُلۡكَهُۥ مَن يَشَآءُۚ وَٱللَّهُ وَٰسِعٌ عَلِيمٞ",
    translation:
      'And their prophet said to them, "Indeed, Allah has sent to you Saul as a king." They said, "How can he have kingship over us while we are more worthy of kingship than him and he has not been given any measure of wealth?" He said, "Indeed, Allah has chosen him over you and has increased him abundantly in knowledge and stature. And Allah gives His sovereignty to whom He wills. And Allah is all-Encompassing [in favor] and Knowing',
    normalizedText:
      "وقال لهم نبيهم ان الله قد بعث لكم طالوت ملكا قالوا انى يكون له الملك علينا ونحن احق بالملك منه ولم يات سعة من المال قال ان الله اصطفىه عليكم وزاده بسطة في العلم والجسم والله ياتي ملكه من يشاء والله وسع عليم",
  },
  {
    verseId: 247,
    name: "البقرة",
    surahId: 2,
    text: "وَقَالَ لَهُمۡ نَبِيُّهُمۡ إِنَّ ءَايَةَ مُلۡكِهِۦٓ أَن يَأۡتِيَكُمُ ٱلتَّابُوتُ فِيهِ سَكِينَةٞ مِّن رَّبِّكُمۡ وَبَقِيَّةٞ مِّمَّا تَرَكَ ءَالُ مُوسَىٰ وَءَالُ هَٰرُونَ تَحۡمِلُهُ ٱلۡمَلَـٰٓئِكَةُۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لَّكُمۡ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      'And their prophet said to them, "Indeed, a sign of his kingship is that the chest will come to you in which is assurance from your Lord and a remnant of what the family of Moses and the family of Aaron had left, carried by the angels. Indeed in that is a sign for you, if you are believers',
    normalizedText:
      "وقال لهم نبيهم ان ءاية ملكه ان ياتيكم التابوت فيه سكينة من ربكم وبقية مما ترك ءال موسى وءال هرون تحمله الملاكة ان في ذلك لاية لكم ان كنتم مامنين",
  },
  {
    verseId: 248,
    name: "البقرة",
    surahId: 2,
    text: "فَلَمَّا فَصَلَ طَالُوتُ بِٱلۡجُنُودِ قَالَ إِنَّ ٱللَّهَ مُبۡتَلِيكُم بِنَهَرٖ فَمَن شَرِبَ مِنۡهُ فَلَيۡسَ مِنِّي وَمَن لَّمۡ يَطۡعَمۡهُ فَإِنَّهُۥ مِنِّيٓ إِلَّا مَنِ ٱغۡتَرَفَ غُرۡفَةَۢ بِيَدِهِۦۚ فَشَرِبُواْ مِنۡهُ إِلَّا قَلِيلٗا مِّنۡهُمۡۚ فَلَمَّا جَاوَزَهُۥ هُوَ وَٱلَّذِينَ ءَامَنُواْ مَعَهُۥ قَالُواْ لَا طَاقَةَ لَنَا ٱلۡيَوۡمَ بِجَالُوتَ وَجُنُودِهِۦۚ قَالَ ٱلَّذِينَ يَظُنُّونَ أَنَّهُم مُّلَٰقُواْ ٱللَّهِ كَم مِّن فِئَةٖ قَلِيلَةٍ غَلَبَتۡ فِئَةٗ كَثِيرَةَۢ بِإِذۡنِ ٱللَّهِۗ وَٱللَّهُ مَعَ ٱلصَّـٰبِرِينَ",
    translation:
      'And when Saul went forth with the soldiers, he said, "Indeed, Allah will be testing you with a river. So whoever drinks from it is not of me, and whoever does not taste it is indeed of me, excepting one who takes [from it] in the hollow of his hand." But they drank from it, except a [very] few of them. Then when he had crossed it along with those who believed with him, they said, "There is no power for us today against Goliath and his soldiers." But those who were certain that they would meet Allah said, "How many a small company has overcome a large company by permission of Allah. And Allah is with the patient',
    normalizedText:
      "فلما فصل طالوت بالجنود قال ان الله مبتليكم بنهر فمن شرب منه فليس مني ومن لم يطعمه فانه مني الا من اغترف غرفة بيده فشربوا منه الا قليلا منهم فلما جاوزه هو والذين ءامنوا معه قالوا لا طاقة لنا اليوم بجالوت وجنوده قال الذين يظنون انهم ملقوا الله كم من فاة قليلة غلبت فاة كثيرة باذن الله والله مع الصبرين",
  },
  {
    verseId: 249,
    name: "البقرة",
    surahId: 2,
    text: "وَلَمَّا بَرَزُواْ لِجَالُوتَ وَجُنُودِهِۦ قَالُواْ رَبَّنَآ أَفۡرِغۡ عَلَيۡنَا صَبۡرٗا وَثَبِّتۡ أَقۡدَامَنَا وَٱنصُرۡنَا عَلَى ٱلۡقَوۡمِ ٱلۡكَٰفِرِينَ",
    translation:
      'And when they went forth to [face] Goliath and his soldiers, they said, "Our Lord, pour upon us patience and plant firmly our feet and give us victory over the disbelieving people',
    normalizedText:
      "ولما برزوا لجالوت وجنوده قالوا ربنا افرغ علينا صبرا وثبت اقدامنا وانصرنا على القوم الكفرين",
  },
  {
    verseId: 250,
    name: "البقرة",
    surahId: 2,
    text: "فَهَزَمُوهُم بِإِذۡنِ ٱللَّهِ وَقَتَلَ دَاوُۥدُ جَالُوتَ وَءَاتَىٰهُ ٱللَّهُ ٱلۡمُلۡكَ وَٱلۡحِكۡمَةَ وَعَلَّمَهُۥ مِمَّا يَشَآءُۗ وَلَوۡلَا دَفۡعُ ٱللَّهِ ٱلنَّاسَ بَعۡضَهُم بِبَعۡضٖ لَّفَسَدَتِ ٱلۡأَرۡضُ وَلَٰكِنَّ ٱللَّهَ ذُو فَضۡلٍ عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      "So they defeated them by permission of Allah, and David killed Goliath, and Allah gave him the kingship and prophethood and taught him from that which He willed. And if it were not for Allah checking [some] people by means of others, the earth would have been corrupted, but Allah is full of bounty to the worlds",
    normalizedText:
      "فهزموهم باذن الله وقتل داود جالوت وءاتىه الله الملك والحكمة وعلمه مما يشاء ولولا دفع الله الناس بعضهم ببعض لفسدت الارض ولكن الله ذو فضل على العلمين",
  },
  {
    verseId: 251,
    name: "البقرة",
    surahId: 2,
    text: "تِلۡكَ ءَايَٰتُ ٱللَّهِ نَتۡلُوهَا عَلَيۡكَ بِٱلۡحَقِّۚ وَإِنَّكَ لَمِنَ ٱلۡمُرۡسَلِينَ",
    translation:
      "These are the verses of Allah which We recite to you, [O Muhammad], in truth. And indeed, you are from among the messengers",
    normalizedText: "تلك ءايت الله نتلوها عليك بالحق وانك لمن المرسلين",
  },
  {
    verseId: 252,
    name: "البقرة",
    surahId: 2,
    text: "۞تِلۡكَ ٱلرُّسُلُ فَضَّلۡنَا بَعۡضَهُمۡ عَلَىٰ بَعۡضٖۘ مِّنۡهُم مَّن كَلَّمَ ٱللَّهُۖ وَرَفَعَ بَعۡضَهُمۡ دَرَجَٰتٖۚ وَءَاتَيۡنَا عِيسَى ٱبۡنَ مَرۡيَمَ ٱلۡبَيِّنَٰتِ وَأَيَّدۡنَٰهُ بِرُوحِ ٱلۡقُدُسِۗ وَلَوۡ شَآءَ ٱللَّهُ مَا ٱقۡتَتَلَ ٱلَّذِينَ مِنۢ بَعۡدِهِم مِّنۢ بَعۡدِ مَا جَآءَتۡهُمُ ٱلۡبَيِّنَٰتُ وَلَٰكِنِ ٱخۡتَلَفُواْ فَمِنۡهُم مَّنۡ ءَامَنَ وَمِنۡهُم مَّن كَفَرَۚ وَلَوۡ شَآءَ ٱللَّهُ مَا ٱقۡتَتَلُواْ وَلَٰكِنَّ ٱللَّهَ يَفۡعَلُ مَا يُرِيدُ",
    translation:
      "Those messengers - some of them We caused to exceed others. Among them were those to whom Allah spoke, and He raised some of them in degree. And We gave Jesus, the Son of Mary, clear proofs, and We supported him with the Pure Spirit. If Allah had willed, those [generations] succeeding them would not have fought each other after the clear proofs had come to them. But they differed, and some of them believed and some of them disbelieved. And if Allah had willed, they would not have fought each other, but Allah does what He intends",
    normalizedText:
      "۞تلك الرسل فضلنا بعضهم على بعض منهم من كلم الله ورفع بعضهم درجت وءاتينا عيسى ابن مريم البينت وايدنه بروح القدس ولو شاء الله ما اقتتل الذين من بعدهم من بعد ما جاءتهم البينت ولكن اختلفوا فمنهم من ءامن ومنهم من كفر ولو شاء الله ما اقتتلوا ولكن الله يفعل ما يريد",
  },
  {
    verseId: 253,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ أَنفِقُواْ مِمَّا رَزَقۡنَٰكُم مِّن قَبۡلِ أَن يَأۡتِيَ يَوۡمٞ لَّا بَيۡعٞ فِيهِ وَلَا خُلَّةٞ وَلَا شَفَٰعَةٞۗ وَٱلۡكَٰفِرُونَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "O you who have believed, spend from that which We have provided for you before there comes a Day in which there is no exchange and no friendship and no intercession. And the disbelievers - they are the wrongdoers",
    normalizedText:
      "يايها الذين ءامنوا انفقوا مما رزقنكم من قبل ان ياتي يوم لا بيع فيه ولا خلة ولا شفعة والكفرون هم الظلمون",
  },
  {
    verseId: 254,
    name: "البقرة",
    surahId: 2,
    text: "ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ٱلۡحَيُّ ٱلۡقَيُّومُۚ لَا تَأۡخُذُهُۥ سِنَةٞ وَلَا نَوۡمٞۚ لَّهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۗ مَن ذَا ٱلَّذِي يَشۡفَعُ عِندَهُۥٓ إِلَّا بِإِذۡنِهِۦۚ يَعۡلَمُ مَا بَيۡنَ أَيۡدِيهِمۡ وَمَا خَلۡفَهُمۡۖ وَلَا يُحِيطُونَ بِشَيۡءٖ مِّنۡ عِلۡمِهِۦٓ إِلَّا بِمَا شَآءَۚ وَسِعَ كُرۡسِيُّهُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَۖ وَلَا يَـُٔودُهُۥ حِفۡظُهُمَاۚ وَهُوَ ٱلۡعَلِيُّ ٱلۡعَظِيمُ",
    translation:
      "Allah - there is no deity except Him, the Ever-Living, the Sustainer of [all] existence. Neither drowsiness overtakes Him nor sleep. To Him belongs whatever is in the heavens and whatever is on the earth. Who is it that can intercede with Him except by His permission? He knows what is [presently] before them and what will be after them, and they encompass not a thing of His knowledge except for what He wills. His Kursi extends over the heavens and the earth, and their preservation tires Him not. And He is the Most High, the Most Great",
    normalizedText:
      "الله لا اله الا هو الحي القيوم لا تاخذه سنة ولا نوم له ما في السموت وما في الارض من ذا الذي يشفع عنده الا باذنه يعلم ما بين ايديهم وما خلفهم ولا يحيطون بشيء من علمه الا بما شاء وسع كرسيه السموت والارض ولا يوده حفظهما وهو العلي العظيم",
  },
  {
    verseId: 255,
    name: "البقرة",
    surahId: 2,
    text: "لَآ إِكۡرَاهَ فِي ٱلدِّينِۖ قَد تَّبَيَّنَ ٱلرُّشۡدُ مِنَ ٱلۡغَيِّۚ فَمَن يَكۡفُرۡ بِٱلطَّـٰغُوتِ وَيُؤۡمِنۢ بِٱللَّهِ فَقَدِ ٱسۡتَمۡسَكَ بِٱلۡعُرۡوَةِ ٱلۡوُثۡقَىٰ لَا ٱنفِصَامَ لَهَاۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ",
    translation:
      "There shall be no compulsion in [acceptance of] the religion. The right course has become clear from the wrong. So whoever disbelieves in Taghut and believes in Allah has grasped the most trustworthy handhold with no break in it. And Allah is Hearing and Knowing",
    normalizedText:
      "لا اكراه في الدين قد تبين الرشد من الغي فمن يكفر بالطغوت ويامن بالله فقد استمسك بالعروة الوثقى لا انفصام لها والله سميع عليم",
  },
  {
    verseId: 256,
    name: "البقرة",
    surahId: 2,
    text: "ٱللَّهُ وَلِيُّ ٱلَّذِينَ ءَامَنُواْ يُخۡرِجُهُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِۖ وَٱلَّذِينَ كَفَرُوٓاْ أَوۡلِيَآؤُهُمُ ٱلطَّـٰغُوتُ يُخۡرِجُونَهُم مِّنَ ٱلنُّورِ إِلَى ٱلظُّلُمَٰتِۗ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "Allah is the ally of those who believe. He brings them out from darknesses into the light. And those who disbelieve - their allies are Taghut. They take them out of the light into darknesses. Those are the companions of the Fire; they will abide eternally therein",
    normalizedText:
      "الله ولي الذين ءامنوا يخرجهم من الظلمت الى النور والذين كفروا اوليااهم الطغوت يخرجونهم من النور الى الظلمت اولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 257,
    name: "البقرة",
    surahId: 2,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِي حَآجَّ إِبۡرَٰهِـۧمَ فِي رَبِّهِۦٓ أَنۡ ءَاتَىٰهُ ٱللَّهُ ٱلۡمُلۡكَ إِذۡ قَالَ إِبۡرَٰهِـۧمُ رَبِّيَ ٱلَّذِي يُحۡيِۦ وَيُمِيتُ قَالَ أَنَا۠ أُحۡيِۦ وَأُمِيتُۖ قَالَ إِبۡرَٰهِـۧمُ فَإِنَّ ٱللَّهَ يَأۡتِي بِٱلشَّمۡسِ مِنَ ٱلۡمَشۡرِقِ فَأۡتِ بِهَا مِنَ ٱلۡمَغۡرِبِ فَبُهِتَ ٱلَّذِي كَفَرَۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      'Have you not considered the one who argued with Abraham about his Lord [merely] because Allah had given him kingship? When Abraham said, "My Lord is the one who gives life and causes death," he said, "I give life and cause death." Abraham said, "Indeed, Allah brings up the sun from the east, so bring it up from the west." So the disbeliever was overwhelmed [by astonishment], and Allah does not guide the wrongdoing people',
    normalizedText:
      "الم تر الى الذي حاج ابرهم في ربه ان ءاتىه الله الملك اذ قال ابرهم ربي الذي يحي ويميت قال انا احي واميت قال ابرهم فان الله ياتي بالشمس من المشرق فات بها من المغرب فبهت الذي كفر والله لا يهدي القوم الظلمين",
  },
  {
    verseId: 258,
    name: "البقرة",
    surahId: 2,
    text: "أَوۡ كَٱلَّذِي مَرَّ عَلَىٰ قَرۡيَةٖ وَهِيَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا قَالَ أَنَّىٰ يُحۡيِۦ هَٰذِهِ ٱللَّهُ بَعۡدَ مَوۡتِهَاۖ فَأَمَاتَهُ ٱللَّهُ مِاْئَةَ عَامٖ ثُمَّ بَعَثَهُۥۖ قَالَ كَمۡ لَبِثۡتَۖ قَالَ لَبِثۡتُ يَوۡمًا أَوۡ بَعۡضَ يَوۡمٖۖ قَالَ بَل لَّبِثۡتَ مِاْئَةَ عَامٖ فَٱنظُرۡ إِلَىٰ طَعَامِكَ وَشَرَابِكَ لَمۡ يَتَسَنَّهۡۖ وَٱنظُرۡ إِلَىٰ حِمَارِكَ وَلِنَجۡعَلَكَ ءَايَةٗ لِّلنَّاسِۖ وَٱنظُرۡ إِلَى ٱلۡعِظَامِ كَيۡفَ نُنشِزُهَا ثُمَّ نَكۡسُوهَا لَحۡمٗاۚ فَلَمَّا تَبَيَّنَ لَهُۥ قَالَ أَعۡلَمُ أَنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'Or [consider such an example] as the one who passed by a township which had fallen into ruin. He said, "How will Allah bring this to life after its death?" So Allah caused him to die for a hundred years; then He revived him. He said, "How long have you remained?" The man said, "I have remained a day or part of a day." He said, "Rather, you have remained one hundred years. Look at your food and your drink; it has not changed with time. And look at your donkey; and We will make you a sign for the people. And look at the bones [of this donkey] - how We raise them and then We cover them with flesh." And when it became clear to him, he said, "I know that Allah is over all things competent',
    normalizedText:
      "او كالذي مر على قرية وهي خاوية على عروشها قال انى يحي هذه الله بعد موتها فاماته الله مااة عام ثم بعثه قال كم لبثت قال لبثت يوما او بعض يوم قال بل لبثت مااة عام فانظر الى طعامك وشرابك لم يتسنه وانظر الى حمارك ولنجعلك ءاية للناس وانظر الى العظام كيف ننشزها ثم نكسوها لحما فلما تبين له قال اعلم ان الله على كل شيء قدير",
  },
  {
    verseId: 259,
    name: "البقرة",
    surahId: 2,
    text: "وَإِذۡ قَالَ إِبۡرَٰهِـۧمُ رَبِّ أَرِنِي كَيۡفَ تُحۡيِ ٱلۡمَوۡتَىٰۖ قَالَ أَوَلَمۡ تُؤۡمِنۖ قَالَ بَلَىٰ وَلَٰكِن لِّيَطۡمَئِنَّ قَلۡبِيۖ قَالَ فَخُذۡ أَرۡبَعَةٗ مِّنَ ٱلطَّيۡرِ فَصُرۡهُنَّ إِلَيۡكَ ثُمَّ ٱجۡعَلۡ عَلَىٰ كُلِّ جَبَلٖ مِّنۡهُنَّ جُزۡءٗا ثُمَّ ٱدۡعُهُنَّ يَأۡتِينَكَ سَعۡيٗاۚ وَٱعۡلَمۡ أَنَّ ٱللَّهَ عَزِيزٌ حَكِيمٞ",
    translation:
      'And [mention] when Abraham said, "My Lord, show me how You give life to the dead." [Allah] said, "Have you not believed?" He said, "Yes, but [I ask] only that my heart may be satisfied." [Allah] said, "Take four birds and commit them to yourself. Then [after slaughtering them] put on each hill a portion of them; then call them - they will come [flying] to you in haste. And know that Allah is Exalted in Might and Wise',
    normalizedText:
      "واذ قال ابرهم رب ارني كيف تحي الموتى قال اولم تامن قال بلى ولكن ليطمان قلبي قال فخذ اربعة من الطير فصرهن اليك ثم اجعل على كل جبل منهن جزءا ثم ادعهن ياتينك سعيا واعلم ان الله عزيز حكيم",
  },
  {
    verseId: 260,
    name: "البقرة",
    surahId: 2,
    text: "مَّثَلُ ٱلَّذِينَ يُنفِقُونَ أَمۡوَٰلَهُمۡ فِي سَبِيلِ ٱللَّهِ كَمَثَلِ حَبَّةٍ أَنۢبَتَتۡ سَبۡعَ سَنَابِلَ فِي كُلِّ سُنۢبُلَةٖ مِّاْئَةُ حَبَّةٖۗ وَٱللَّهُ يُضَٰعِفُ لِمَن يَشَآءُۚ وَٱللَّهُ وَٰسِعٌ عَلِيمٌ",
    translation:
      "The example of those who spend their wealth in the way of Allah is like a seed [of grain] which grows seven spikes; in each spike is a hundred grains. And Allah multiplies [His reward] for whom He wills. And Allah is all-Encompassing and Knowing",
    normalizedText:
      "مثل الذين ينفقون امولهم في سبيل الله كمثل حبة انبتت سبع سنابل في كل سنبلة مااة حبة والله يضعف لمن يشاء والله وسع عليم",
  },
  {
    verseId: 261,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ يُنفِقُونَ أَمۡوَٰلَهُمۡ فِي سَبِيلِ ٱللَّهِ ثُمَّ لَا يُتۡبِعُونَ مَآ أَنفَقُواْ مَنّٗا وَلَآ أَذٗى لَّهُمۡ أَجۡرُهُمۡ عِندَ رَبِّهِمۡ وَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Those who spend their wealth in the way of Allah and then do not follow up what they have spent with reminders [of it] or [other] injury will have their reward with their Lord, and there will be no fear concerning them, nor will they grieve",
    normalizedText:
      "الذين ينفقون امولهم في سبيل الله ثم لا يتبعون ما انفقوا منا ولا اذى لهم اجرهم عند ربهم ولا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 262,
    name: "البقرة",
    surahId: 2,
    text: "۞قَوۡلٞ مَّعۡرُوفٞ وَمَغۡفِرَةٌ خَيۡرٞ مِّن صَدَقَةٖ يَتۡبَعُهَآ أَذٗىۗ وَٱللَّهُ غَنِيٌّ حَلِيمٞ",
    translation:
      "Kind speech and forgiveness are better than charity followed by injury. And Allah is Free of need and Forbearing",
    normalizedText: "۞قول معروف ومغفرة خير من صدقة يتبعها اذى والله غني حليم",
  },
  {
    verseId: 263,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تُبۡطِلُواْ صَدَقَٰتِكُم بِٱلۡمَنِّ وَٱلۡأَذَىٰ كَٱلَّذِي يُنفِقُ مَالَهُۥ رِئَآءَ ٱلنَّاسِ وَلَا يُؤۡمِنُ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِۖ فَمَثَلُهُۥ كَمَثَلِ صَفۡوَانٍ عَلَيۡهِ تُرَابٞ فَأَصَابَهُۥ وَابِلٞ فَتَرَكَهُۥ صَلۡدٗاۖ لَّا يَقۡدِرُونَ عَلَىٰ شَيۡءٖ مِّمَّا كَسَبُواْۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡكَٰفِرِينَ",
    translation:
      "O you who have believed, do not invalidate your charities with reminders or injury as does one who spends his wealth [only] to be seen by the people and does not believe in Allah and the Last Day. His example is like that of a [large] smooth stone upon which is dust and is hit by a downpour that leaves it bare. They are unable [to keep] anything of what they have earned. And Allah does not guide the disbelieving people",
    normalizedText:
      "يايها الذين ءامنوا لا تبطلوا صدقتكم بالمن والاذى كالذي ينفق ماله رااء الناس ولا يامن بالله واليوم الاخر فمثله كمثل صفوان عليه تراب فاصابه وابل فتركه صلدا لا يقدرون على شيء مما كسبوا والله لا يهدي القوم الكفرين",
  },
  {
    verseId: 264,
    name: "البقرة",
    surahId: 2,
    text: "وَمَثَلُ ٱلَّذِينَ يُنفِقُونَ أَمۡوَٰلَهُمُ ٱبۡتِغَآءَ مَرۡضَاتِ ٱللَّهِ وَتَثۡبِيتٗا مِّنۡ أَنفُسِهِمۡ كَمَثَلِ جَنَّةِۭ بِرَبۡوَةٍ أَصَابَهَا وَابِلٞ فَـَٔاتَتۡ أُكُلَهَا ضِعۡفَيۡنِ فَإِن لَّمۡ يُصِبۡهَا وَابِلٞ فَطَلّٞۗ وَٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرٌ",
    translation:
      "And the example of those who spend their wealth seeking means to the approval of Allah and assuring [reward for] themselves is like a garden on high ground which is hit by a downpour - so it yields its fruits in double. And [even] if it is not hit by a downpour, then a drizzle [is sufficient]. And Allah, of what you do, is Seeing",
    normalizedText:
      "ومثل الذين ينفقون امولهم ابتغاء مرضات الله وتثبيتا من انفسهم كمثل جنة بربوة اصابها وابل فاتت اكلها ضعفين فان لم يصبها وابل فطل والله بما تعملون بصير",
  },
  {
    verseId: 265,
    name: "البقرة",
    surahId: 2,
    text: "أَيَوَدُّ أَحَدُكُمۡ أَن تَكُونَ لَهُۥ جَنَّةٞ مِّن نَّخِيلٖ وَأَعۡنَابٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ لَهُۥ فِيهَا مِن كُلِّ ٱلثَّمَرَٰتِ وَأَصَابَهُ ٱلۡكِبَرُ وَلَهُۥ ذُرِّيَّةٞ ضُعَفَآءُ فَأَصَابَهَآ إِعۡصَارٞ فِيهِ نَارٞ فَٱحۡتَرَقَتۡۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلۡأٓيَٰتِ لَعَلَّكُمۡ تَتَفَكَّرُونَ",
    translation:
      "Would one of you like to have a garden of palm trees and grapevines underneath which rivers flow in which he has from every fruit? But he is afflicted with old age and has weak offspring, and it is hit by a whirlwind containing fire and is burned. Thus does Allah make clear to you [His] verses that you might give thought",
    normalizedText:
      "ايود احدكم ان تكون له جنة من نخيل واعناب تجري من تحتها الانهر له فيها من كل الثمرت واصابه الكبر وله ذرية ضعفاء فاصابها اعصار فيه نار فاحترقت كذلك يبين الله لكم الايت لعلكم تتفكرون",
  },
  {
    verseId: 266,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ أَنفِقُواْ مِن طَيِّبَٰتِ مَا كَسَبۡتُمۡ وَمِمَّآ أَخۡرَجۡنَا لَكُم مِّنَ ٱلۡأَرۡضِۖ وَلَا تَيَمَّمُواْ ٱلۡخَبِيثَ مِنۡهُ تُنفِقُونَ وَلَسۡتُم بِـَٔاخِذِيهِ إِلَّآ أَن تُغۡمِضُواْ فِيهِۚ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ غَنِيٌّ حَمِيدٌ",
    translation:
      "O you who have believed, spend from the good things which you have earned and from that which We have produced for you from the earth. And do not aim toward the defective therefrom, spending [from that] while you would not take it [yourself] except with closed eyes. And know that Allah is Free of need and Praiseworthy",
    normalizedText:
      "يايها الذين ءامنوا انفقوا من طيبت ما كسبتم ومما اخرجنا لكم من الارض ولا تيمموا الخبيث منه تنفقون ولستم باخذيه الا ان تغمضوا فيه واعلموا ان الله غني حميد",
  },
  {
    verseId: 267,
    name: "البقرة",
    surahId: 2,
    text: "ٱلشَّيۡطَٰنُ يَعِدُكُمُ ٱلۡفَقۡرَ وَيَأۡمُرُكُم بِٱلۡفَحۡشَآءِۖ وَٱللَّهُ يَعِدُكُم مَّغۡفِرَةٗ مِّنۡهُ وَفَضۡلٗاۗ وَٱللَّهُ وَٰسِعٌ عَلِيمٞ",
    translation:
      "Satan threatens you with poverty and orders you to immorality, while Allah promises you forgiveness from Him and bounty. And Allah is all-Encompassing and Knowing",
    normalizedText:
      "الشيطن يعدكم الفقر ويامركم بالفحشاء والله يعدكم مغفرة منه وفضلا والله وسع عليم",
  },
  {
    verseId: 268,
    name: "البقرة",
    surahId: 2,
    text: "يُؤۡتِي ٱلۡحِكۡمَةَ مَن يَشَآءُۚ وَمَن يُؤۡتَ ٱلۡحِكۡمَةَ فَقَدۡ أُوتِيَ خَيۡرٗا كَثِيرٗاۗ وَمَا يَذَّكَّرُ إِلَّآ أُوْلُواْ ٱلۡأَلۡبَٰبِ",
    translation:
      "He gives wisdom to whom He wills, and whoever has been given wisdom has certainly been given much good. And none will remember except those of understanding",
    normalizedText:
      "ياتي الحكمة من يشاء ومن يات الحكمة فقد اوتي خيرا كثيرا وما يذكر الا اولوا الالبب",
  },
  {
    verseId: 269,
    name: "البقرة",
    surahId: 2,
    text: "وَمَآ أَنفَقۡتُم مِّن نَّفَقَةٍ أَوۡ نَذَرۡتُم مِّن نَّذۡرٖ فَإِنَّ ٱللَّهَ يَعۡلَمُهُۥۗ وَمَا لِلظَّـٰلِمِينَ مِنۡ أَنصَارٍ",
    translation:
      "And whatever you spend of expenditures or make of vows - indeed, Allah knows of it. And for the wrongdoers there are no helpers",
    normalizedText:
      "وما انفقتم من نفقة او نذرتم من نذر فان الله يعلمه وما للظلمين من انصار",
  },
  {
    verseId: 270,
    name: "البقرة",
    surahId: 2,
    text: "إِن تُبۡدُواْ ٱلصَّدَقَٰتِ فَنِعِمَّا هِيَۖ وَإِن تُخۡفُوهَا وَتُؤۡتُوهَا ٱلۡفُقَرَآءَ فَهُوَ خَيۡرٞ لَّكُمۡۚ وَيُكَفِّرُ عَنكُم مِّن سَيِّـَٔاتِكُمۡۗ وَٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      "If you disclose your charitable expenditures, they are good; but if you conceal them and give them to the poor, it is better for you, and He will remove from you some of your misdeeds [thereby]. And Allah, with what you do, is [fully] Acquainted",
    normalizedText:
      "ان تبدوا الصدقت فنعما هي وان تخفوها وتاتوها الفقراء فهو خير لكم ويكفر عنكم من سياتكم والله بما تعملون خبير",
  },
  {
    verseId: 271,
    name: "البقرة",
    surahId: 2,
    text: "۞لَّيۡسَ عَلَيۡكَ هُدَىٰهُمۡ وَلَٰكِنَّ ٱللَّهَ يَهۡدِي مَن يَشَآءُۗ وَمَا تُنفِقُواْ مِنۡ خَيۡرٖ فَلِأَنفُسِكُمۡۚ وَمَا تُنفِقُونَ إِلَّا ٱبۡتِغَآءَ وَجۡهِ ٱللَّهِۚ وَمَا تُنفِقُواْ مِنۡ خَيۡرٖ يُوَفَّ إِلَيۡكُمۡ وَأَنتُمۡ لَا تُظۡلَمُونَ",
    translation:
      "Not upon you, [O Muhammad], is [responsibility for] their guidance, but Allah guides whom He wills. And whatever good you [believers] spend is for yourselves, and you do not spend except seeking the countenance of Allah. And whatever you spend of good - it will be fully repaid to you, and you will not be wronged",
    normalizedText:
      "۞ليس عليك هدىهم ولكن الله يهدي من يشاء وما تنفقوا من خير فلانفسكم وما تنفقون الا ابتغاء وجه الله وما تنفقوا من خير يوف اليكم وانتم لا تظلمون",
  },
  {
    verseId: 272,
    name: "البقرة",
    surahId: 2,
    text: "لِلۡفُقَرَآءِ ٱلَّذِينَ أُحۡصِرُواْ فِي سَبِيلِ ٱللَّهِ لَا يَسۡتَطِيعُونَ ضَرۡبٗا فِي ٱلۡأَرۡضِ يَحۡسَبُهُمُ ٱلۡجَاهِلُ أَغۡنِيَآءَ مِنَ ٱلتَّعَفُّفِ تَعۡرِفُهُم بِسِيمَٰهُمۡ لَا يَسۡـَٔلُونَ ٱلنَّاسَ إِلۡحَافٗاۗ وَمَا تُنفِقُواْ مِنۡ خَيۡرٖ فَإِنَّ ٱللَّهَ بِهِۦ عَلِيمٌ",
    translation:
      "[Charity is] for the poor who have been restricted for the cause of Allah, unable to move about in the land. An ignorant [person] would think them self-sufficient because of their restraint, but you will know them by their [characteristic] sign. They do not ask people persistently [or at all]. And whatever you spend of good - indeed, Allah is Knowing of it",
    normalizedText:
      "للفقراء الذين احصروا في سبيل الله لا يستطيعون ضربا في الارض يحسبهم الجاهل اغنياء من التعفف تعرفهم بسيمهم لا يسلون الناس الحافا وما تنفقوا من خير فان الله به عليم",
  },
  {
    verseId: 273,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ يُنفِقُونَ أَمۡوَٰلَهُم بِٱلَّيۡلِ وَٱلنَّهَارِ سِرّٗا وَعَلَانِيَةٗ فَلَهُمۡ أَجۡرُهُمۡ عِندَ رَبِّهِمۡ وَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Those who spend their wealth [in Allah 's way] by night and by day, secretly and publicly - they will have their reward with their Lord. And no fear will there be concerning them, nor will they grieve",
    normalizedText:
      "الذين ينفقون امولهم باليل والنهار سرا وعلانية فلهم اجرهم عند ربهم ولا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 274,
    name: "البقرة",
    surahId: 2,
    text: "ٱلَّذِينَ يَأۡكُلُونَ ٱلرِّبَوٰاْ لَا يَقُومُونَ إِلَّا كَمَا يَقُومُ ٱلَّذِي يَتَخَبَّطُهُ ٱلشَّيۡطَٰنُ مِنَ ٱلۡمَسِّۚ ذَٰلِكَ بِأَنَّهُمۡ قَالُوٓاْ إِنَّمَا ٱلۡبَيۡعُ مِثۡلُ ٱلرِّبَوٰاْۗ وَأَحَلَّ ٱللَّهُ ٱلۡبَيۡعَ وَحَرَّمَ ٱلرِّبَوٰاْۚ فَمَن جَآءَهُۥ مَوۡعِظَةٞ مِّن رَّبِّهِۦ فَٱنتَهَىٰ فَلَهُۥ مَا سَلَفَ وَأَمۡرُهُۥٓ إِلَى ٱللَّهِۖ وَمَنۡ عَادَ فَأُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      'Those who consume interest cannot stand [on the Day of Resurrection] except as one stands who is being beaten by Satan into insanity. That is because they say, "Trade is [just] like interest." But Allah has permitted trade and has forbidden interest. So whoever has received an admonition from his Lord and desists may have what is past, and his affair rests with Allah. But whoever returns to [dealing in interest or usury] - those are the companions of the Fire; they will abide eternally therein',
    normalizedText:
      "الذين ياكلون الربوا لا يقومون الا كما يقوم الذي يتخبطه الشيطن من المس ذلك بانهم قالوا انما البيع مثل الربوا واحل الله البيع وحرم الربوا فمن جاءه موعظة من ربه فانتهى فله ما سلف وامره الى الله ومن عاد فاولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 275,
    name: "البقرة",
    surahId: 2,
    text: "يَمۡحَقُ ٱللَّهُ ٱلرِّبَوٰاْ وَيُرۡبِي ٱلصَّدَقَٰتِۗ وَٱللَّهُ لَا يُحِبُّ كُلَّ كَفَّارٍ أَثِيمٍ",
    translation:
      "Allah destroys interest and gives increase for charities. And Allah does not like every sinning disbeliever",
    normalizedText: "يمحق الله الربوا ويربي الصدقت والله لا يحب كل كفار اثيم",
  },
  {
    verseId: 276,
    name: "البقرة",
    surahId: 2,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَأَقَامُواْ ٱلصَّلَوٰةَ وَءَاتَوُاْ ٱلزَّكَوٰةَ لَهُمۡ أَجۡرُهُمۡ عِندَ رَبِّهِمۡ وَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Indeed, those who believe and do righteous deeds and establish prayer and give zakah will have their reward with their Lord, and there will be no fear concerning them, nor will they grieve",
    normalizedText:
      "ان الذين ءامنوا وعملوا الصلحت واقاموا الصلوة وءاتوا الزكوة لهم اجرهم عند ربهم ولا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 277,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ ٱللَّهَ وَذَرُواْ مَا بَقِيَ مِنَ ٱلرِّبَوٰٓاْ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "O you who have believed, fear Allah and give up what remains [due to you] of interest, if you should be believers",
    normalizedText:
      "يايها الذين ءامنوا اتقوا الله وذروا ما بقي من الربوا ان كنتم مامنين",
  },
  {
    verseId: 278,
    name: "البقرة",
    surahId: 2,
    text: "فَإِن لَّمۡ تَفۡعَلُواْ فَأۡذَنُواْ بِحَرۡبٖ مِّنَ ٱللَّهِ وَرَسُولِهِۦۖ وَإِن تُبۡتُمۡ فَلَكُمۡ رُءُوسُ أَمۡوَٰلِكُمۡ لَا تَظۡلِمُونَ وَلَا تُظۡلَمُونَ",
    translation:
      "And if you do not, then be informed of a war [against you] from Allah and His Messenger. But if you repent, you may have your principal - [thus] you do no wrong, nor are you wronged",
    normalizedText:
      "فان لم تفعلوا فاذنوا بحرب من الله ورسوله وان تبتم فلكم رءوس امولكم لا تظلمون ولا تظلمون",
  },
  {
    verseId: 279,
    name: "البقرة",
    surahId: 2,
    text: "وَإِن كَانَ ذُو عُسۡرَةٖ فَنَظِرَةٌ إِلَىٰ مَيۡسَرَةٖۚ وَأَن تَصَدَّقُواْ خَيۡرٞ لَّكُمۡ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "And if someone is in hardship, then [let there be] postponement until [a time of] ease. But if you give [from your right as] charity, then it is better for you, if you only knew",
    normalizedText:
      "وان كان ذو عسرة فنظرة الى ميسرة وان تصدقوا خير لكم ان كنتم تعلمون",
  },
  {
    verseId: 280,
    name: "البقرة",
    surahId: 2,
    text: "وَٱتَّقُواْ يَوۡمٗا تُرۡجَعُونَ فِيهِ إِلَى ٱللَّهِۖ ثُمَّ تُوَفَّىٰ كُلُّ نَفۡسٖ مَّا كَسَبَتۡ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "And fear a Day when you will be returned to Allah. Then every soul will be compensated for what it earned, and they will not be treated unjustly",
    normalizedText:
      "واتقوا يوما ترجعون فيه الى الله ثم توفى كل نفس ما كسبت وهم لا يظلمون",
  },
  {
    verseId: 281,
    name: "البقرة",
    surahId: 2,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا تَدَايَنتُم بِدَيۡنٍ إِلَىٰٓ أَجَلٖ مُّسَمّٗى فَٱكۡتُبُوهُۚ وَلۡيَكۡتُب بَّيۡنَكُمۡ كَاتِبُۢ بِٱلۡعَدۡلِۚ وَلَا يَأۡبَ كَاتِبٌ أَن يَكۡتُبَ كَمَا عَلَّمَهُ ٱللَّهُۚ فَلۡيَكۡتُبۡ وَلۡيُمۡلِلِ ٱلَّذِي عَلَيۡهِ ٱلۡحَقُّ وَلۡيَتَّقِ ٱللَّهَ رَبَّهُۥ وَلَا يَبۡخَسۡ مِنۡهُ شَيۡـٔٗاۚ فَإِن كَانَ ٱلَّذِي عَلَيۡهِ ٱلۡحَقُّ سَفِيهًا أَوۡ ضَعِيفًا أَوۡ لَا يَسۡتَطِيعُ أَن يُمِلَّ هُوَ فَلۡيُمۡلِلۡ وَلِيُّهُۥ بِٱلۡعَدۡلِۚ وَٱسۡتَشۡهِدُواْ شَهِيدَيۡنِ مِن رِّجَالِكُمۡۖ فَإِن لَّمۡ يَكُونَا رَجُلَيۡنِ فَرَجُلٞ وَٱمۡرَأَتَانِ مِمَّن تَرۡضَوۡنَ مِنَ ٱلشُّهَدَآءِ أَن تَضِلَّ إِحۡدَىٰهُمَا فَتُذَكِّرَ إِحۡدَىٰهُمَا ٱلۡأُخۡرَىٰۚ وَلَا يَأۡبَ ٱلشُّهَدَآءُ إِذَا مَا دُعُواْۚ وَلَا تَسۡـَٔمُوٓاْ أَن تَكۡتُبُوهُ صَغِيرًا أَوۡ كَبِيرًا إِلَىٰٓ أَجَلِهِۦۚ ذَٰلِكُمۡ أَقۡسَطُ عِندَ ٱللَّهِ وَأَقۡوَمُ لِلشَّهَٰدَةِ وَأَدۡنَىٰٓ أَلَّا تَرۡتَابُوٓاْ إِلَّآ أَن تَكُونَ تِجَٰرَةً حَاضِرَةٗ تُدِيرُونَهَا بَيۡنَكُمۡ فَلَيۡسَ عَلَيۡكُمۡ جُنَاحٌ أَلَّا تَكۡتُبُوهَاۗ وَأَشۡهِدُوٓاْ إِذَا تَبَايَعۡتُمۡۚ وَلَا يُضَآرَّ كَاتِبٞ وَلَا شَهِيدٞۚ وَإِن تَفۡعَلُواْ فَإِنَّهُۥ فُسُوقُۢ بِكُمۡۗ وَٱتَّقُواْ ٱللَّهَۖ وَيُعَلِّمُكُمُ ٱللَّهُۗ وَٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "O you who have believed, when you contract a debt for a specified term, write it down. And let a scribe write [it] between you in justice. Let no scribe refuse to write as Allah has taught him. So let him write and let the one who has the obligation dictate. And let him fear Allah, his Lord, and not leave anything out of it. But if the one who has the obligation is of limited understanding or weak or unable to dictate himself, then let his guardian dictate in justice. And bring to witness two witnesses from among your men. And if there are not two men [available], then a man and two women from those whom you accept as witnesses - so that if one of the women errs, then the other can remind her. And let not the witnesses refuse when they are called upon. And do not be [too] weary to write it, whether it is small or large, for its [specified] term. That is more just in the sight of Allah and stronger as evidence and more likely to prevent doubt between you, except when it is an immediate transaction which you conduct among yourselves. For [then] there is no blame upon you if you do not write it. And take witnesses when you conclude a contract. Let no scribe be harmed or any witness. For if you do so, indeed, it is [grave] disobedience in you. And fear Allah. And Allah teaches you. And Allah is Knowing of all things",
    normalizedText:
      "يايها الذين ءامنوا اذا تداينتم بدين الى اجل مسمى فاكتبوه وليكتب بينكم كاتب بالعدل ولا ياب كاتب ان يكتب كما علمه الله فليكتب وليملل الذي عليه الحق وليتق الله ربه ولا يبخس منه شيا فان كان الذي عليه الحق سفيها او ضعيفا او لا يستطيع ان يمل هو فليملل وليه بالعدل واستشهدوا شهيدين من رجالكم فان لم يكونا رجلين فرجل وامراتان ممن ترضون من الشهداء ان تضل احدىهما فتذكر احدىهما الاخرى ولا ياب الشهداء اذا ما دعوا ولا تسموا ان تكتبوه صغيرا او كبيرا الى اجله ذلكم اقسط عند الله واقوم للشهدة وادنى الا ترتابوا الا ان تكون تجرة حاضرة تديرونها بينكم فليس عليكم جناح الا تكتبوها واشهدوا اذا تبايعتم ولا يضار كاتب ولا شهيد وان تفعلوا فانه فسوق بكم واتقوا الله ويعلمكم الله والله بكل شيء عليم",
  },
  {
    verseId: 282,
    name: "البقرة",
    surahId: 2,
    text: "۞وَإِن كُنتُمۡ عَلَىٰ سَفَرٖ وَلَمۡ تَجِدُواْ كَاتِبٗا فَرِهَٰنٞ مَّقۡبُوضَةٞۖ فَإِنۡ أَمِنَ بَعۡضُكُم بَعۡضٗا فَلۡيُؤَدِّ ٱلَّذِي ٱؤۡتُمِنَ أَمَٰنَتَهُۥ وَلۡيَتَّقِ ٱللَّهَ رَبَّهُۥۗ وَلَا تَكۡتُمُواْ ٱلشَّهَٰدَةَۚ وَمَن يَكۡتُمۡهَا فَإِنَّهُۥٓ ءَاثِمٞ قَلۡبُهُۥۗ وَٱللَّهُ بِمَا تَعۡمَلُونَ عَلِيمٞ",
    translation:
      "And if you are on a journey and cannot find a scribe, then a security deposit [should be] taken. And if one of you entrusts another, then let him who is entrusted discharge his trust [faithfully] and let him fear Allah, his Lord. And do not conceal testimony, for whoever conceals it - his heart is indeed sinful, and Allah is Knowing of what you do",
    normalizedText:
      "۞وان كنتم على سفر ولم تجدوا كاتبا فرهن مقبوضة فان امن بعضكم بعضا فلياد الذي ااتمن امنته وليتق الله ربه ولا تكتموا الشهدة ومن يكتمها فانه ءاثم قلبه والله بما تعملون عليم",
  },
  {
    verseId: 283,
    name: "البقرة",
    surahId: 2,
    text: "لِّلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۗ وَإِن تُبۡدُواْ مَا فِيٓ أَنفُسِكُمۡ أَوۡ تُخۡفُوهُ يُحَاسِبۡكُم بِهِ ٱللَّهُۖ فَيَغۡفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُۗ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "To Allah belongs whatever is in the heavens and whatever is in the earth. Whether you show what is within yourselves or conceal it, Allah will bring you to account for it. Then He will forgive whom He wills and punish whom He wills, and Allah is over all things competent",
    normalizedText:
      "لله ما في السموت وما في الارض وان تبدوا ما في انفسكم او تخفوه يحاسبكم به الله فيغفر لمن يشاء ويعذب من يشاء والله على كل شيء قدير",
  },
  {
    verseId: 284,
    name: "البقرة",
    surahId: 2,
    text: "ءَامَنَ ٱلرَّسُولُ بِمَآ أُنزِلَ إِلَيۡهِ مِن رَّبِّهِۦ وَٱلۡمُؤۡمِنُونَۚ كُلٌّ ءَامَنَ بِٱللَّهِ وَمَلَـٰٓئِكَتِهِۦ وَكُتُبِهِۦ وَرُسُلِهِۦ لَا نُفَرِّقُ بَيۡنَ أَحَدٖ مِّن رُّسُلِهِۦۚ وَقَالُواْ سَمِعۡنَا وَأَطَعۡنَاۖ غُفۡرَانَكَ رَبَّنَا وَإِلَيۡكَ ٱلۡمَصِيرُ",
    translation:
      'The Messenger has believed in what was revealed to him from his Lord, and [so have] the believers. All of them have believed in Allah and His angels and His books and His messengers, [saying], "We make no distinction between any of His messengers." And they say, "We hear and we obey. [We seek] Your forgiveness, our Lord, and to You is the [final] destination',
    normalizedText:
      "ءامن الرسول بما انزل اليه من ربه والمامنون كل ءامن بالله وملاكته وكتبه ورسله لا نفرق بين احد من رسله وقالوا سمعنا واطعنا غفرانك ربنا واليك المصير",
  },
  {
    verseId: 285,
    name: "البقرة",
    surahId: 2,
    text: "لَا يُكَلِّفُ ٱللَّهُ نَفۡسًا إِلَّا وُسۡعَهَاۚ لَهَا مَا كَسَبَتۡ وَعَلَيۡهَا مَا ٱكۡتَسَبَتۡۗ رَبَّنَا لَا تُؤَاخِذۡنَآ إِن نَّسِينَآ أَوۡ أَخۡطَأۡنَاۚ رَبَّنَا وَلَا تَحۡمِلۡ عَلَيۡنَآ إِصۡرٗا كَمَا حَمَلۡتَهُۥ عَلَى ٱلَّذِينَ مِن قَبۡلِنَاۚ رَبَّنَا وَلَا تُحَمِّلۡنَا مَا لَا طَاقَةَ لَنَا بِهِۦۖ وَٱعۡفُ عَنَّا وَٱغۡفِرۡ لَنَا وَٱرۡحَمۡنَآۚ أَنتَ مَوۡلَىٰنَا فَٱنصُرۡنَا عَلَى ٱلۡقَوۡمِ ٱلۡكَٰفِرِينَ",
    translation:
      'Allah does not charge a soul except [with that within] its capacity. It will have [the consequence of] what [good] it has gained, and it will bear [the consequence of] what [evil] it has earned. "Our Lord, do not impose blame upon us if we have forgotten or erred. Our Lord, and lay not upon us a burden like that which You laid upon those before us. Our Lord, and burden us not with that which we have no ability to bear. And pardon us; and forgive us; and have mercy upon us. You are our protector, so give us victory over the disbelieving people',
    normalizedText:
      "لا يكلف الله نفسا الا وسعها لها ما كسبت وعليها ما اكتسبت ربنا لا تااخذنا ان نسينا او اخطانا ربنا ولا تحمل علينا اصرا كما حملته على الذين من قبلنا ربنا ولا تحملنا ما لا طاقة لنا به واعف عنا واغفر لنا وارحمنا انت مولىنا فانصرنا على القوم الكفرين",
  },
  {
    verseId: 0,
    name: "آل عمران",
    surahId: 3,
    text: "الٓمٓ",
    translation: "Alif, Lam, Meem",
    normalizedText: "الم",
  },
  {
    verseId: 1,
    name: "آل عمران",
    surahId: 3,
    text: "ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ٱلۡحَيُّ ٱلۡقَيُّومُ",
    translation:
      "Allah - there is no deity except Him, the Ever-Living, the Sustainer of existence",
    normalizedText: "الله لا اله الا هو الحي القيوم",
  },
  {
    verseId: 2,
    name: "آل عمران",
    surahId: 3,
    text: "نَزَّلَ عَلَيۡكَ ٱلۡكِتَٰبَ بِٱلۡحَقِّ مُصَدِّقٗا لِّمَا بَيۡنَ يَدَيۡهِ وَأَنزَلَ ٱلتَّوۡرَىٰةَ وَٱلۡإِنجِيلَ",
    translation:
      "He has sent down upon you, [O Muhammad], the Book in truth, confirming what was before it. And He revealed the Torah and the Gospel",
    normalizedText:
      "نزل عليك الكتب بالحق مصدقا لما بين يديه وانزل التورىة والانجيل",
  },
  {
    verseId: 3,
    name: "آل عمران",
    surahId: 3,
    text: "مِن قَبۡلُ هُدٗى لِّلنَّاسِ وَأَنزَلَ ٱلۡفُرۡقَانَۗ إِنَّ ٱلَّذِينَ كَفَرُواْ بِـَٔايَٰتِ ٱللَّهِ لَهُمۡ عَذَابٞ شَدِيدٞۗ وَٱللَّهُ عَزِيزٞ ذُو ٱنتِقَامٍ",
    translation:
      "Before, as guidance for the people. And He revealed the Qur'an. Indeed, those who disbelieve in the verses of Allah will have a severe punishment, and Allah is exalted in Might, the Owner of Retribution",
    normalizedText:
      "من قبل هدى للناس وانزل الفرقان ان الذين كفروا بايت الله لهم عذاب شديد والله عزيز ذو انتقام",
  },
  {
    verseId: 4,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱللَّهَ لَا يَخۡفَىٰ عَلَيۡهِ شَيۡءٞ فِي ٱلۡأَرۡضِ وَلَا فِي ٱلسَّمَآءِ",
    translation:
      "Indeed, from Allah nothing is hidden in the earth nor in the heaven",
    normalizedText: "ان الله لا يخفى عليه شيء في الارض ولا في السماء",
  },
  {
    verseId: 5,
    name: "آل عمران",
    surahId: 3,
    text: "هُوَ ٱلَّذِي يُصَوِّرُكُمۡ فِي ٱلۡأَرۡحَامِ كَيۡفَ يَشَآءُۚ لَآ إِلَٰهَ إِلَّا هُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "It is He who forms you in the wombs however He wills. There is no deity except Him, the Exalted in Might, the Wise",
    normalizedText:
      "هو الذي يصوركم في الارحام كيف يشاء لا اله الا هو العزيز الحكيم",
  },
  {
    verseId: 6,
    name: "آل عمران",
    surahId: 3,
    text: "هُوَ ٱلَّذِيٓ أَنزَلَ عَلَيۡكَ ٱلۡكِتَٰبَ مِنۡهُ ءَايَٰتٞ مُّحۡكَمَٰتٌ هُنَّ أُمُّ ٱلۡكِتَٰبِ وَأُخَرُ مُتَشَٰبِهَٰتٞۖ فَأَمَّا ٱلَّذِينَ فِي قُلُوبِهِمۡ زَيۡغٞ فَيَتَّبِعُونَ مَا تَشَٰبَهَ مِنۡهُ ٱبۡتِغَآءَ ٱلۡفِتۡنَةِ وَٱبۡتِغَآءَ تَأۡوِيلِهِۦۖ وَمَا يَعۡلَمُ تَأۡوِيلَهُۥٓ إِلَّا ٱللَّهُۗ وَٱلرَّـٰسِخُونَ فِي ٱلۡعِلۡمِ يَقُولُونَ ءَامَنَّا بِهِۦ كُلّٞ مِّنۡ عِندِ رَبِّنَاۗ وَمَا يَذَّكَّرُ إِلَّآ أُوْلُواْ ٱلۡأَلۡبَٰبِ",
    translation:
      'It is He who has sent down to you, [O Muhammad], the Book; in it are verses [that are] precise - they are the foundation of the Book - and others unspecific. As for those in whose hearts is deviation [from truth], they will follow that of it which is unspecific, seeking discord and seeking an interpretation [suitable to them]. And no one knows its [true] interpretation except Allah. But those firm in knowledge say, "We believe in it. All [of it] is from our Lord." And no one will be reminded except those of understanding',
    normalizedText:
      "هو الذي انزل عليك الكتب منه ءايت محكمت هن ام الكتب واخر متشبهت فاما الذين في قلوبهم زيغ فيتبعون ما تشبه منه ابتغاء الفتنة وابتغاء تاويله وما يعلم تاويله الا الله والرسخون في العلم يقولون ءامنا به كل من عند ربنا وما يذكر الا اولوا الالبب",
  },
  {
    verseId: 7,
    name: "آل عمران",
    surahId: 3,
    text: "رَبَّنَا لَا تُزِغۡ قُلُوبَنَا بَعۡدَ إِذۡ هَدَيۡتَنَا وَهَبۡ لَنَا مِن لَّدُنكَ رَحۡمَةًۚ إِنَّكَ أَنتَ ٱلۡوَهَّابُ",
    translation:
      '[Who say], "Our Lord, let not our hearts deviate after You have guided us and grant us from Yourself mercy. Indeed, You are the Bestower',
    normalizedText:
      "ربنا لا تزغ قلوبنا بعد اذ هديتنا وهب لنا من لدنك رحمة انك انت الوهاب",
  },
  {
    verseId: 8,
    name: "آل عمران",
    surahId: 3,
    text: "رَبَّنَآ إِنَّكَ جَامِعُ ٱلنَّاسِ لِيَوۡمٖ لَّا رَيۡبَ فِيهِۚ إِنَّ ٱللَّهَ لَا يُخۡلِفُ ٱلۡمِيعَادَ",
    translation:
      "Our Lord, surely You will gather the people for a Day about which there is no doubt. Indeed, Allah does not fail in His promise",
    normalizedText:
      "ربنا انك جامع الناس ليوم لا ريب فيه ان الله لا يخلف الميعاد",
  },
  {
    verseId: 9,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ لَن تُغۡنِيَ عَنۡهُمۡ أَمۡوَٰلُهُمۡ وَلَآ أَوۡلَٰدُهُم مِّنَ ٱللَّهِ شَيۡـٔٗاۖ وَأُوْلَـٰٓئِكَ هُمۡ وَقُودُ ٱلنَّارِ",
    translation:
      "Indeed, those who disbelieve - never will their wealth or their children avail them against Allah at all. And it is they who are fuel for the Fire",
    normalizedText:
      "ان الذين كفروا لن تغني عنهم امولهم ولا اولدهم من الله شيا واولاك هم وقود النار",
  },
  {
    verseId: 10,
    name: "آل عمران",
    surahId: 3,
    text: "كَدَأۡبِ ءَالِ فِرۡعَوۡنَ وَٱلَّذِينَ مِن قَبۡلِهِمۡۚ كَذَّبُواْ بِـَٔايَٰتِنَا فَأَخَذَهُمُ ٱللَّهُ بِذُنُوبِهِمۡۗ وَٱللَّهُ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "[Theirs is] like the custom of the people of Pharaoh and those before them. They denied Our signs, so Allah seized them for their sins. And Allah is severe in penalty",
    normalizedText:
      "كداب ءال فرعون والذين من قبلهم كذبوا بايتنا فاخذهم الله بذنوبهم والله شديد العقاب",
  },
  {
    verseId: 11,
    name: "آل عمران",
    surahId: 3,
    text: "قُل لِّلَّذِينَ كَفَرُواْ سَتُغۡلَبُونَ وَتُحۡشَرُونَ إِلَىٰ جَهَنَّمَۖ وَبِئۡسَ ٱلۡمِهَادُ",
    translation:
      'Say to those who disbelieve, "You will be overcome and gathered together to Hell, and wretched is the resting place',
    normalizedText: "قل للذين كفروا ستغلبون وتحشرون الى جهنم وباس المهاد",
  },
  {
    verseId: 12,
    name: "آل عمران",
    surahId: 3,
    text: "قَدۡ كَانَ لَكُمۡ ءَايَةٞ فِي فِئَتَيۡنِ ٱلۡتَقَتَاۖ فِئَةٞ تُقَٰتِلُ فِي سَبِيلِ ٱللَّهِ وَأُخۡرَىٰ كَافِرَةٞ يَرَوۡنَهُم مِّثۡلَيۡهِمۡ رَأۡيَ ٱلۡعَيۡنِۚ وَٱللَّهُ يُؤَيِّدُ بِنَصۡرِهِۦ مَن يَشَآءُۚ إِنَّ فِي ذَٰلِكَ لَعِبۡرَةٗ لِّأُوْلِي ٱلۡأَبۡصَٰرِ",
    translation:
      "Already there has been for you a sign in the two armies which met - one fighting in the cause of Allah and another of disbelievers. They saw them [to be] twice their [own] number by [their] eyesight. But Allah supports with His victory whom He wills. Indeed in that is a lesson for those of vision",
    normalizedText:
      "قد كان لكم ءاية في فاتين التقتا فاة تقتل في سبيل الله واخرى كافرة يرونهم مثليهم راي العين والله يايد بنصره من يشاء ان في ذلك لعبرة لاولي الابصر",
  },
  {
    verseId: 13,
    name: "آل عمران",
    surahId: 3,
    text: "زُيِّنَ لِلنَّاسِ حُبُّ ٱلشَّهَوَٰتِ مِنَ ٱلنِّسَآءِ وَٱلۡبَنِينَ وَٱلۡقَنَٰطِيرِ ٱلۡمُقَنطَرَةِ مِنَ ٱلذَّهَبِ وَٱلۡفِضَّةِ وَٱلۡخَيۡلِ ٱلۡمُسَوَّمَةِ وَٱلۡأَنۡعَٰمِ وَٱلۡحَرۡثِۗ ذَٰلِكَ مَتَٰعُ ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَٱللَّهُ عِندَهُۥ حُسۡنُ ٱلۡمَـَٔابِ",
    translation:
      "Beautified for people is the love of that which they desire - of women and sons, heaped-up sums of gold and silver, fine branded horses, and cattle and tilled land. That is the enjoyment of worldly life, but Allah has with Him the best return",
    normalizedText:
      "زين للناس حب الشهوت من النساء والبنين والقنطير المقنطرة من الذهب والفضة والخيل المسومة والانعم والحرث ذلك متع الحيوة الدنيا والله عنده حسن الماب",
  },
  {
    verseId: 14,
    name: "آل عمران",
    surahId: 3,
    text: "۞قُلۡ أَؤُنَبِّئُكُم بِخَيۡرٖ مِّن ذَٰلِكُمۡۖ لِلَّذِينَ ٱتَّقَوۡاْ عِندَ رَبِّهِمۡ جَنَّـٰتٞ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَا وَأَزۡوَٰجٞ مُّطَهَّرَةٞ وَرِضۡوَٰنٞ مِّنَ ٱللَّهِۗ وَٱللَّهُ بَصِيرُۢ بِٱلۡعِبَادِ",
    translation:
      'Say, "Shall I inform you of [something] better than that? For those who fear Allah will be gardens in the presence of their Lord beneath which rivers flow, wherein they abide eternally, and purified spouses and approval from Allah. And Allah is Seeing of [His] servants',
    normalizedText:
      "۞قل اانباكم بخير من ذلكم للذين اتقوا عند ربهم جنت تجري من تحتها الانهر خلدين فيها وازوج مطهرة ورضون من الله والله بصير بالعباد",
  },
  {
    verseId: 15,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلَّذِينَ يَقُولُونَ رَبَّنَآ إِنَّنَآ ءَامَنَّا فَٱغۡفِرۡ لَنَا ذُنُوبَنَا وَقِنَا عَذَابَ ٱلنَّارِ",
    translation:
      'Those who say, "Our Lord, indeed we have believed, so forgive us our sins and protect us from the punishment of the Fire',
    normalizedText:
      "الذين يقولون ربنا اننا ءامنا فاغفر لنا ذنوبنا وقنا عذاب النار",
  },
  {
    verseId: 16,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلصَّـٰبِرِينَ وَٱلصَّـٰدِقِينَ وَٱلۡقَٰنِتِينَ وَٱلۡمُنفِقِينَ وَٱلۡمُسۡتَغۡفِرِينَ بِٱلۡأَسۡحَارِ",
    translation:
      "The patient, the true, the obedient, those who spend [in the way of Allah], and those who seek forgiveness before dawn",
    normalizedText: "الصبرين والصدقين والقنتين والمنفقين والمستغفرين بالاسحار",
  },
  {
    verseId: 17,
    name: "آل عمران",
    surahId: 3,
    text: "شَهِدَ ٱللَّهُ أَنَّهُۥ لَآ إِلَٰهَ إِلَّا هُوَ وَٱلۡمَلَـٰٓئِكَةُ وَأُوْلُواْ ٱلۡعِلۡمِ قَآئِمَۢا بِٱلۡقِسۡطِۚ لَآ إِلَٰهَ إِلَّا هُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Allah witnesses that there is no deity except Him, and [so do] the angels and those of knowledge - [that He is] maintaining [creation] in justice. There is no deity except Him, the Exalted in Might, the Wise",
    normalizedText:
      "شهد الله انه لا اله الا هو والملاكة واولوا العلم قااما بالقسط لا اله الا هو العزيز الحكيم",
  },
  {
    verseId: 18,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلدِّينَ عِندَ ٱللَّهِ ٱلۡإِسۡلَٰمُۗ وَمَا ٱخۡتَلَفَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ إِلَّا مِنۢ بَعۡدِ مَا جَآءَهُمُ ٱلۡعِلۡمُ بَغۡيَۢا بَيۡنَهُمۡۗ وَمَن يَكۡفُرۡ بِـَٔايَٰتِ ٱللَّهِ فَإِنَّ ٱللَّهَ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      "Indeed, the religion in the sight of Allah is Islam. And those who were given the Scripture did not differ except after knowledge had come to them - out of jealous animosity between themselves. And whoever disbelieves in the verses of Allah, then indeed, Allah is swift in [taking] account",
    normalizedText:
      "ان الدين عند الله الاسلم وما اختلف الذين اوتوا الكتب الا من بعد ما جاءهم العلم بغيا بينهم ومن يكفر بايت الله فان الله سريع الحساب",
  },
  {
    verseId: 19,
    name: "آل عمران",
    surahId: 3,
    text: "فَإِنۡ حَآجُّوكَ فَقُلۡ أَسۡلَمۡتُ وَجۡهِيَ لِلَّهِ وَمَنِ ٱتَّبَعَنِۗ وَقُل لِّلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ وَٱلۡأُمِّيِّـۧنَ ءَأَسۡلَمۡتُمۡۚ فَإِنۡ أَسۡلَمُواْ فَقَدِ ٱهۡتَدَواْۖ وَّإِن تَوَلَّوۡاْ فَإِنَّمَا عَلَيۡكَ ٱلۡبَلَٰغُۗ وَٱللَّهُ بَصِيرُۢ بِٱلۡعِبَادِ",
    translation:
      'So if they argue with you, say, "I have submitted myself to Allah [in Islam], and [so have] those who follow me." And say to those who were given the Scripture and [to] the unlearned, "Have you submitted yourselves?" And if they submit [in Islam], they are rightly guided; but if they turn away - then upon you is only the [duty of] notification. And Allah is Seeing of [His] servants',
    normalizedText:
      "فان حاجوك فقل اسلمت وجهي لله ومن اتبعن وقل للذين اوتوا الكتب والامين ءاسلمتم فان اسلموا فقد اهتدوا وان تولوا فانما عليك البلغ والله بصير بالعباد",
  },
  {
    verseId: 20,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ يَكۡفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَيَقۡتُلُونَ ٱلنَّبِيِّـۧنَ بِغَيۡرِ حَقّٖ وَيَقۡتُلُونَ ٱلَّذِينَ يَأۡمُرُونَ بِٱلۡقِسۡطِ مِنَ ٱلنَّاسِ فَبَشِّرۡهُم بِعَذَابٍ أَلِيمٍ",
    translation:
      "Those who disbelieve in the signs of Allah and kill the prophets without right and kill those who order justice from among the people - give them tidings of a painful punishment",
    normalizedText:
      "ان الذين يكفرون بايت الله ويقتلون النبين بغير حق ويقتلون الذين يامرون بالقسط من الناس فبشرهم بعذاب اليم",
  },
  {
    verseId: 21,
    name: "آل عمران",
    surahId: 3,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ حَبِطَتۡ أَعۡمَٰلُهُمۡ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِ وَمَا لَهُم مِّن نَّـٰصِرِينَ",
    translation:
      "They are the ones whose deeds have become worthless in this world and the Hereafter, and for them there will be no helpers",
    normalizedText:
      "اولاك الذين حبطت اعملهم في الدنيا والاخرة وما لهم من نصرين",
  },
  {
    verseId: 22,
    name: "آل عمران",
    surahId: 3,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ أُوتُواْ نَصِيبٗا مِّنَ ٱلۡكِتَٰبِ يُدۡعَوۡنَ إِلَىٰ كِتَٰبِ ٱللَّهِ لِيَحۡكُمَ بَيۡنَهُمۡ ثُمَّ يَتَوَلَّىٰ فَرِيقٞ مِّنۡهُمۡ وَهُم مُّعۡرِضُونَ",
    translation:
      "Do you not consider, [O Muhammad], those who were given a portion of the Scripture? They are invited to the Scripture of Allah that it should arbitrate between them; then a party of them turns away, and they are refusing",
    normalizedText:
      "الم تر الى الذين اوتوا نصيبا من الكتب يدعون الى كتب الله ليحكم بينهم ثم يتولى فريق منهم وهم معرضون",
  },
  {
    verseId: 23,
    name: "آل عمران",
    surahId: 3,
    text: "ذَٰلِكَ بِأَنَّهُمۡ قَالُواْ لَن تَمَسَّنَا ٱلنَّارُ إِلَّآ أَيَّامٗا مَّعۡدُودَٰتٖۖ وَغَرَّهُمۡ فِي دِينِهِم مَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      'That is because they say, "Never will the Fire touch us except for [a few] numbered days," and [because] they were deluded in their religion by what they were inventing',
    normalizedText:
      "ذلك بانهم قالوا لن تمسنا النار الا اياما معدودت وغرهم في دينهم ما كانوا يفترون",
  },
  {
    verseId: 24,
    name: "آل عمران",
    surahId: 3,
    text: "فَكَيۡفَ إِذَا جَمَعۡنَٰهُمۡ لِيَوۡمٖ لَّا رَيۡبَ فِيهِ وَوُفِّيَتۡ كُلُّ نَفۡسٖ مَّا كَسَبَتۡ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "So how will it be when We assemble them for a Day about which there is no doubt? And each soul will be compensated [in full for] what it earned, and they will not be wronged",
    normalizedText:
      "فكيف اذا جمعنهم ليوم لا ريب فيه ووفيت كل نفس ما كسبت وهم لا يظلمون",
  },
  {
    verseId: 25,
    name: "آل عمران",
    surahId: 3,
    text: "قُلِ ٱللَّهُمَّ مَٰلِكَ ٱلۡمُلۡكِ تُؤۡتِي ٱلۡمُلۡكَ مَن تَشَآءُ وَتَنزِعُ ٱلۡمُلۡكَ مِمَّن تَشَآءُ وَتُعِزُّ مَن تَشَآءُ وَتُذِلُّ مَن تَشَآءُۖ بِيَدِكَ ٱلۡخَيۡرُۖ إِنَّكَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'Say, "O Allah, Owner of Sovereignty, You give sovereignty to whom You will and You take sovereignty away from whom You will. You honor whom You will and You humble whom You will. In Your hand is [all] good. Indeed, You are over all things competent',
    normalizedText:
      "قل اللهم ملك الملك تاتي الملك من تشاء وتنزع الملك ممن تشاء وتعز من تشاء وتذل من تشاء بيدك الخير انك على كل شيء قدير",
  },
  {
    verseId: 26,
    name: "آل عمران",
    surahId: 3,
    text: "تُولِجُ ٱلَّيۡلَ فِي ٱلنَّهَارِ وَتُولِجُ ٱلنَّهَارَ فِي ٱلَّيۡلِۖ وَتُخۡرِجُ ٱلۡحَيَّ مِنَ ٱلۡمَيِّتِ وَتُخۡرِجُ ٱلۡمَيِّتَ مِنَ ٱلۡحَيِّۖ وَتَرۡزُقُ مَن تَشَآءُ بِغَيۡرِ حِسَابٖ",
    translation:
      "You cause the night to enter the day, and You cause the day to enter the night; and You bring the living out of the dead, and You bring the dead out of the living. And You give provision to whom You will without account",
    normalizedText:
      "تولج اليل في النهار وتولج النهار في اليل وتخرج الحي من الميت وتخرج الميت من الحي وترزق من تشاء بغير حساب",
  },
  {
    verseId: 27,
    name: "آل عمران",
    surahId: 3,
    text: "لَّا يَتَّخِذِ ٱلۡمُؤۡمِنُونَ ٱلۡكَٰفِرِينَ أَوۡلِيَآءَ مِن دُونِ ٱلۡمُؤۡمِنِينَۖ وَمَن يَفۡعَلۡ ذَٰلِكَ فَلَيۡسَ مِنَ ٱللَّهِ فِي شَيۡءٍ إِلَّآ أَن تَتَّقُواْ مِنۡهُمۡ تُقَىٰةٗۗ وَيُحَذِّرُكُمُ ٱللَّهُ نَفۡسَهُۥۗ وَإِلَى ٱللَّهِ ٱلۡمَصِيرُ",
    translation:
      "Let not believers take disbelievers as allies rather than believers. And whoever [of you] does that has nothing with Allah, except when taking precaution against them in prudence. And Allah warns you of Himself, and to Allah is the [final] destination",
    normalizedText:
      "لا يتخذ المامنون الكفرين اولياء من دون المامنين ومن يفعل ذلك فليس من الله في شيء الا ان تتقوا منهم تقىة ويحذركم الله نفسه والى الله المصير",
  },
  {
    verseId: 28,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ إِن تُخۡفُواْ مَا فِي صُدُورِكُمۡ أَوۡ تُبۡدُوهُ يَعۡلَمۡهُ ٱللَّهُۗ وَيَعۡلَمُ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۗ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'Say, "Whether you conceal what is in your breasts or reveal it, Allah knows it. And He knows that which is in the heavens and that which is on the earth. And Allah is over all things competent',
    normalizedText:
      "قل ان تخفوا ما في صدوركم او تبدوه يعلمه الله ويعلم ما في السموت وما في الارض والله على كل شيء قدير",
  },
  {
    verseId: 29,
    name: "آل عمران",
    surahId: 3,
    text: "يَوۡمَ تَجِدُ كُلُّ نَفۡسٖ مَّا عَمِلَتۡ مِنۡ خَيۡرٖ مُّحۡضَرٗا وَمَا عَمِلَتۡ مِن سُوٓءٖ تَوَدُّ لَوۡ أَنَّ بَيۡنَهَا وَبَيۡنَهُۥٓ أَمَدَۢا بَعِيدٗاۗ وَيُحَذِّرُكُمُ ٱللَّهُ نَفۡسَهُۥۗ وَٱللَّهُ رَءُوفُۢ بِٱلۡعِبَادِ",
    translation:
      "The Day every soul will find what it has done of good present [before it] and what it has done of evil, it will wish that between itself and that [evil] was a great distance. And Allah warns you of Himself, and Allah is Kind to [His] servants",
    normalizedText:
      "يوم تجد كل نفس ما عملت من خير محضرا وما عملت من سوء تود لو ان بينها وبينه امدا بعيدا ويحذركم الله نفسه والله رءوف بالعباد",
  },
  {
    verseId: 30,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ إِن كُنتُمۡ تُحِبُّونَ ٱللَّهَ فَٱتَّبِعُونِي يُحۡبِبۡكُمُ ٱللَّهُ وَيَغۡفِرۡ لَكُمۡ ذُنُوبَكُمۡۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      'Say, [O Muhammad], "If you should love Allah, then follow me, [so] Allah will love you and forgive you your sins. And Allah is Forgiving and Merciful',
    normalizedText:
      "قل ان كنتم تحبون الله فاتبعوني يحببكم الله ويغفر لكم ذنوبكم والله غفور رحيم",
  },
  {
    verseId: 31,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ أَطِيعُواْ ٱللَّهَ وَٱلرَّسُولَۖ فَإِن تَوَلَّوۡاْ فَإِنَّ ٱللَّهَ لَا يُحِبُّ ٱلۡكَٰفِرِينَ",
    translation:
      'Say, "Obey Allah and the Messenger." But if they turn away - then indeed, Allah does not like the disbelievers',
    normalizedText: "قل اطيعوا الله والرسول فان تولوا فان الله لا يحب الكفرين",
  },
  {
    verseId: 32,
    name: "آل عمران",
    surahId: 3,
    text: "۞إِنَّ ٱللَّهَ ٱصۡطَفَىٰٓ ءَادَمَ وَنُوحٗا وَءَالَ إِبۡرَٰهِيمَ وَءَالَ عِمۡرَٰنَ عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      "Indeed, Allah chose Adam and Noah and the family of Abraham and the family of 'Imran over the worlds",
    normalizedText:
      "۞ان الله اصطفى ءادم ونوحا وءال ابرهيم وءال عمرن على العلمين",
  },
  {
    verseId: 33,
    name: "آل عمران",
    surahId: 3,
    text: "ذُرِّيَّةَۢ بَعۡضُهَا مِنۢ بَعۡضٖۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ",
    translation:
      "Descendants, some of them from others. And Allah is Hearing and Knowing",
    normalizedText: "ذرية بعضها من بعض والله سميع عليم",
  },
  {
    verseId: 34,
    name: "آل عمران",
    surahId: 3,
    text: "إِذۡ قَالَتِ ٱمۡرَأَتُ عِمۡرَٰنَ رَبِّ إِنِّي نَذَرۡتُ لَكَ مَا فِي بَطۡنِي مُحَرَّرٗا فَتَقَبَّلۡ مِنِّيٓۖ إِنَّكَ أَنتَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation: `[Mention, O Muhammad], when the wife of 'Imran said, "My Lord, indeed I have pledged to You what is in my womb, consecrated [for Your service], so accept this from me. Indeed, You are the Hearing, the Knowing`,
    normalizedText:
      "اذ قالت امرات عمرن رب اني نذرت لك ما في بطني محررا فتقبل مني انك انت السميع العليم",
  },
  {
    verseId: 35,
    name: "آل عمران",
    surahId: 3,
    text: "فَلَمَّا وَضَعَتۡهَا قَالَتۡ رَبِّ إِنِّي وَضَعۡتُهَآ أُنثَىٰ وَٱللَّهُ أَعۡلَمُ بِمَا وَضَعَتۡ وَلَيۡسَ ٱلذَّكَرُ كَٱلۡأُنثَىٰۖ وَإِنِّي سَمَّيۡتُهَا مَرۡيَمَ وَإِنِّيٓ أُعِيذُهَا بِكَ وَذُرِّيَّتَهَا مِنَ ٱلشَّيۡطَٰنِ ٱلرَّجِيمِ",
    translation:
      'But when she delivered her, she said, "My Lord, I have delivered a female." And Allah was most knowing of what she delivered, "And the male is not like the female. And I have named her Mary, and I seek refuge for her in You and [for] her descendants from Satan, the expelled [from the mercy of Allah]',
    normalizedText:
      "فلما وضعتها قالت رب اني وضعتها انثى والله اعلم بما وضعت وليس الذكر كالانثى واني سميتها مريم واني اعيذها بك وذريتها من الشيطن الرجيم",
  },
  {
    verseId: 36,
    name: "آل عمران",
    surahId: 3,
    text: "فَتَقَبَّلَهَا رَبُّهَا بِقَبُولٍ حَسَنٖ وَأَنۢبَتَهَا نَبَاتًا حَسَنٗا وَكَفَّلَهَا زَكَرِيَّاۖ كُلَّمَا دَخَلَ عَلَيۡهَا زَكَرِيَّا ٱلۡمِحۡرَابَ وَجَدَ عِندَهَا رِزۡقٗاۖ قَالَ يَٰمَرۡيَمُ أَنَّىٰ لَكِ هَٰذَاۖ قَالَتۡ هُوَ مِنۡ عِندِ ٱللَّهِۖ إِنَّ ٱللَّهَ يَرۡزُقُ مَن يَشَآءُ بِغَيۡرِ حِسَابٍ",
    translation:
      'So her Lord accepted her with good acceptance and caused her to grow in a good manner and put her in the care of Zechariah. Every time Zechariah entered upon her in the prayer chamber, he found with her provision. He said, "O Mary, from where is this [coming] to you?" She said, "It is from Allah. Indeed, Allah provides for whom He wills without account',
    normalizedText:
      "فتقبلها ربها بقبول حسن وانبتها نباتا حسنا وكفلها زكريا كلما دخل عليها زكريا المحراب وجد عندها رزقا قال يمريم انى لك هذا قالت هو من عند الله ان الله يرزق من يشاء بغير حساب",
  },
  {
    verseId: 37,
    name: "آل عمران",
    surahId: 3,
    text: "هُنَالِكَ دَعَا زَكَرِيَّا رَبَّهُۥۖ قَالَ رَبِّ هَبۡ لِي مِن لَّدُنكَ ذُرِّيَّةٗ طَيِّبَةًۖ إِنَّكَ سَمِيعُ ٱلدُّعَآءِ",
    translation:
      'At that, Zechariah called upon his Lord, saying, "My Lord, grant me from Yourself a good offspring. Indeed, You are the Hearer of supplication',
    normalizedText:
      "هنالك دعا زكريا ربه قال رب هب لي من لدنك ذرية طيبة انك سميع الدعاء",
  },
  {
    verseId: 38,
    name: "آل عمران",
    surahId: 3,
    text: "فَنَادَتۡهُ ٱلۡمَلَـٰٓئِكَةُ وَهُوَ قَآئِمٞ يُصَلِّي فِي ٱلۡمِحۡرَابِ أَنَّ ٱللَّهَ يُبَشِّرُكَ بِيَحۡيَىٰ مُصَدِّقَۢا بِكَلِمَةٖ مِّنَ ٱللَّهِ وَسَيِّدٗا وَحَصُورٗا وَنَبِيّٗا مِّنَ ٱلصَّـٰلِحِينَ",
    translation:
      'So the angels called him while he was standing in prayer in the chamber, "Indeed, Allah gives you good tidings of John, confirming a word from Allah and [who will be] honorable, abstaining [from women], and a prophet from among the righteous',
    normalizedText:
      "فنادته الملاكة وهو قاام يصلي في المحراب ان الله يبشرك بيحيى مصدقا بكلمة من الله وسيدا وحصورا ونبيا من الصلحين",
  },
  {
    verseId: 39,
    name: "آل عمران",
    surahId: 3,
    text: "قَالَ رَبِّ أَنَّىٰ يَكُونُ لِي غُلَٰمٞ وَقَدۡ بَلَغَنِيَ ٱلۡكِبَرُ وَٱمۡرَأَتِي عَاقِرٞۖ قَالَ كَذَٰلِكَ ٱللَّهُ يَفۡعَلُ مَا يَشَآءُ",
    translation:
      'He said, "My Lord, how will I have a boy when I have reached old age and my wife is barren?" The angel said, "Such is Allah; He does what He wills',
    normalizedText:
      "قال رب انى يكون لي غلم وقد بلغني الكبر وامراتي عاقر قال كذلك الله يفعل ما يشاء",
  },
  {
    verseId: 40,
    name: "آل عمران",
    surahId: 3,
    text: "قَالَ رَبِّ ٱجۡعَل لِّيٓ ءَايَةٗۖ قَالَ ءَايَتُكَ أَلَّا تُكَلِّمَ ٱلنَّاسَ ثَلَٰثَةَ أَيَّامٍ إِلَّا رَمۡزٗاۗ وَٱذۡكُر رَّبَّكَ كَثِيرٗا وَسَبِّحۡ بِٱلۡعَشِيِّ وَٱلۡإِبۡكَٰرِ",
    translation:
      'He said, "My Lord, make for me a sign." He Said, "Your sign is that you will not [be able to] speak to the people for three days except by gesture. And remember your Lord much and exalt [Him with praise] in the evening and the morning',
    normalizedText:
      "قال رب اجعل لي ءاية قال ءايتك الا تكلم الناس ثلثة ايام الا رمزا واذكر ربك كثيرا وسبح بالعشي والابكر",
  },
  {
    verseId: 41,
    name: "آل عمران",
    surahId: 3,
    text: "وَإِذۡ قَالَتِ ٱلۡمَلَـٰٓئِكَةُ يَٰمَرۡيَمُ إِنَّ ٱللَّهَ ٱصۡطَفَىٰكِ وَطَهَّرَكِ وَٱصۡطَفَىٰكِ عَلَىٰ نِسَآءِ ٱلۡعَٰلَمِينَ",
    translation:
      'And [mention] when the angels said, "O Mary, indeed Allah has chosen you and purified you and chosen you above the women of the worlds',
    normalizedText:
      "واذ قالت الملاكة يمريم ان الله اصطفىك وطهرك واصطفىك على نساء العلمين",
  },
  {
    verseId: 42,
    name: "آل عمران",
    surahId: 3,
    text: "يَٰمَرۡيَمُ ٱقۡنُتِي لِرَبِّكِ وَٱسۡجُدِي وَٱرۡكَعِي مَعَ ٱلرَّـٰكِعِينَ",
    translation:
      "O Mary, be devoutly obedient to your Lord and prostrate and bow with those who bow [in prayer]",
    normalizedText: "يمريم اقنتي لربك واسجدي واركعي مع الركعين",
  },
  {
    verseId: 43,
    name: "آل عمران",
    surahId: 3,
    text: "ذَٰلِكَ مِنۡ أَنۢبَآءِ ٱلۡغَيۡبِ نُوحِيهِ إِلَيۡكَۚ وَمَا كُنتَ لَدَيۡهِمۡ إِذۡ يُلۡقُونَ أَقۡلَٰمَهُمۡ أَيُّهُمۡ يَكۡفُلُ مَرۡيَمَ وَمَا كُنتَ لَدَيۡهِمۡ إِذۡ يَخۡتَصِمُونَ",
    translation:
      "That is from the news of the unseen which We reveal to you, [O Muhammad]. And you were not with them when they cast their pens as to which of them should be responsible for Mary. Nor were you with them when they disputed",
    normalizedText:
      "ذلك من انباء الغيب نوحيه اليك وما كنت لديهم اذ يلقون اقلمهم ايهم يكفل مريم وما كنت لديهم اذ يختصمون",
  },
  {
    verseId: 44,
    name: "آل عمران",
    surahId: 3,
    text: "إِذۡ قَالَتِ ٱلۡمَلَـٰٓئِكَةُ يَٰمَرۡيَمُ إِنَّ ٱللَّهَ يُبَشِّرُكِ بِكَلِمَةٖ مِّنۡهُ ٱسۡمُهُ ٱلۡمَسِيحُ عِيسَى ٱبۡنُ مَرۡيَمَ وَجِيهٗا فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِ وَمِنَ ٱلۡمُقَرَّبِينَ",
    translation:
      '[And mention] when the angels said, "O Mary, indeed Allah gives you good tidings of a word from Him, whose name will be the Messiah, Jesus, the son of Mary - distinguished in this world and the Hereafter and among those brought near [to Allah]',
    normalizedText:
      "اذ قالت الملاكة يمريم ان الله يبشرك بكلمة منه اسمه المسيح عيسى ابن مريم وجيها في الدنيا والاخرة ومن المقربين",
  },
  {
    verseId: 45,
    name: "آل عمران",
    surahId: 3,
    text: "وَيُكَلِّمُ ٱلنَّاسَ فِي ٱلۡمَهۡدِ وَكَهۡلٗا وَمِنَ ٱلصَّـٰلِحِينَ",
    translation:
      "He will speak to the people in the cradle and in maturity and will be of the righteous",
    normalizedText: "ويكلم الناس في المهد وكهلا ومن الصلحين",
  },
  {
    verseId: 46,
    name: "آل عمران",
    surahId: 3,
    text: "قَالَتۡ رَبِّ أَنَّىٰ يَكُونُ لِي وَلَدٞ وَلَمۡ يَمۡسَسۡنِي بَشَرٞۖ قَالَ كَذَٰلِكِ ٱللَّهُ يَخۡلُقُ مَا يَشَآءُۚ إِذَا قَضَىٰٓ أَمۡرٗا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ",
    translation: `She said, "My Lord, how will I have a child when no man has touched me?" [The angel] said, "Such is Allah; He creates what He wills. When He decrees a matter, He only says to it, 'Be,' and it is`,
    normalizedText:
      "قالت رب انى يكون لي ولد ولم يمسسني بشر قال كذلك الله يخلق ما يشاء اذا قضى امرا فانما يقول له كن فيكون",
  },
  {
    verseId: 47,
    name: "آل عمران",
    surahId: 3,
    text: "وَيُعَلِّمُهُ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَٱلتَّوۡرَىٰةَ وَٱلۡإِنجِيلَ",
    translation:
      "And He will teach him writing and wisdom and the Torah and the Gospel",
    normalizedText: "ويعلمه الكتب والحكمة والتورىة والانجيل",
  },
  {
    verseId: 48,
    name: "آل عمران",
    surahId: 3,
    text: "وَرَسُولًا إِلَىٰ بَنِيٓ إِسۡرَـٰٓءِيلَ أَنِّي قَدۡ جِئۡتُكُم بِـَٔايَةٖ مِّن رَّبِّكُمۡ أَنِّيٓ أَخۡلُقُ لَكُم مِّنَ ٱلطِّينِ كَهَيۡـَٔةِ ٱلطَّيۡرِ فَأَنفُخُ فِيهِ فَيَكُونُ طَيۡرَۢا بِإِذۡنِ ٱللَّهِۖ وَأُبۡرِئُ ٱلۡأَكۡمَهَ وَٱلۡأَبۡرَصَ وَأُحۡيِ ٱلۡمَوۡتَىٰ بِإِذۡنِ ٱللَّهِۖ وَأُنَبِّئُكُم بِمَا تَأۡكُلُونَ وَمَا تَدَّخِرُونَ فِي بُيُوتِكُمۡۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لَّكُمۡ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "And [make him] a messenger to the Children of Israel, [who will say], 'Indeed I have come to you with a sign from your Lord in that I design for you from clay [that which is] like the form of a bird, then I breathe into it and it becomes a bird by permission of Allah. And I cure the blind and the leper, and I give life to the dead - by permission of Allah. And I inform you of what you eat and what you store in your houses. Indeed in that is a sign for you, if you are believers",
    normalizedText:
      "ورسولا الى بني اسرءيل اني قد جاتكم باية من ربكم اني اخلق لكم من الطين كهية الطير فانفخ فيه فيكون طيرا باذن الله وابرا الاكمه والابرص واحي الموتى باذن الله وانباكم بما تاكلون وما تدخرون في بيوتكم ان في ذلك لاية لكم ان كنتم مامنين",
  },
  {
    verseId: 49,
    name: "آل عمران",
    surahId: 3,
    text: "وَمُصَدِّقٗا لِّمَا بَيۡنَ يَدَيَّ مِنَ ٱلتَّوۡرَىٰةِ وَلِأُحِلَّ لَكُم بَعۡضَ ٱلَّذِي حُرِّمَ عَلَيۡكُمۡۚ وَجِئۡتُكُم بِـَٔايَةٖ مِّن رَّبِّكُمۡ فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation:
      "And [I have come] confirming what was before me of the Torah and to make lawful for you some of what was forbidden to you. And I have come to you with a sign from your Lord, so fear Allah and obey me",
    normalizedText:
      "ومصدقا لما بين يدي من التورىة ولاحل لكم بعض الذي حرم عليكم وجاتكم باية من ربكم فاتقوا الله واطيعون",
  },
  {
    verseId: 50,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱللَّهَ رَبِّي وَرَبُّكُمۡ فَٱعۡبُدُوهُۚ هَٰذَا صِرَٰطٞ مُّسۡتَقِيمٞ",
    translation:
      "Indeed, Allah is my Lord and your Lord, so worship Him. That is the straight path",
    normalizedText: "ان الله ربي وربكم فاعبدوه هذا صرط مستقيم",
  },
  {
    verseId: 51,
    name: "آل عمران",
    surahId: 3,
    text: "۞فَلَمَّآ أَحَسَّ عِيسَىٰ مِنۡهُمُ ٱلۡكُفۡرَ قَالَ مَنۡ أَنصَارِيٓ إِلَى ٱللَّهِۖ قَالَ ٱلۡحَوَارِيُّونَ نَحۡنُ أَنصَارُ ٱللَّهِ ءَامَنَّا بِٱللَّهِ وَٱشۡهَدۡ بِأَنَّا مُسۡلِمُونَ",
    translation:
      'But when Jesus felt [persistence in] disbelief from them, he said, "Who are my supporters for [the cause of] Allah?" The disciples said, "We are supporters for Allah. We have believed in Allah and testify that we are Muslims [submitting to Him]',
    normalizedText:
      "۞فلما احس عيسى منهم الكفر قال من انصاري الى الله قال الحواريون نحن انصار الله ءامنا بالله واشهد بانا مسلمون",
  },
  {
    verseId: 52,
    name: "آل عمران",
    surahId: 3,
    text: "رَبَّنَآ ءَامَنَّا بِمَآ أَنزَلۡتَ وَٱتَّبَعۡنَا ٱلرَّسُولَ فَٱكۡتُبۡنَا مَعَ ٱلشَّـٰهِدِينَ",
    translation:
      "Our Lord, we have believed in what You revealed and have followed the messenger Jesus, so register us among the witnesses [to truth]",
    normalizedText: "ربنا ءامنا بما انزلت واتبعنا الرسول فاكتبنا مع الشهدين",
  },
  {
    verseId: 53,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَكَرُواْ وَمَكَرَ ٱللَّهُۖ وَٱللَّهُ خَيۡرُ ٱلۡمَٰكِرِينَ",
    translation:
      "And the disbelievers planned, but Allah planned. And Allah is the best of planners",
    normalizedText: "ومكروا ومكر الله والله خير المكرين",
  },
  {
    verseId: 54,
    name: "آل عمران",
    surahId: 3,
    text: "إِذۡ قَالَ ٱللَّهُ يَٰعِيسَىٰٓ إِنِّي مُتَوَفِّيكَ وَرَافِعُكَ إِلَيَّ وَمُطَهِّرُكَ مِنَ ٱلَّذِينَ كَفَرُواْ وَجَاعِلُ ٱلَّذِينَ ٱتَّبَعُوكَ فَوۡقَ ٱلَّذِينَ كَفَرُوٓاْ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِۖ ثُمَّ إِلَيَّ مَرۡجِعُكُمۡ فَأَحۡكُمُ بَيۡنَكُمۡ فِيمَا كُنتُمۡ فِيهِ تَخۡتَلِفُونَ",
    translation:
      '[Mention] when Allah said, "O Jesus, indeed I will take you and raise you to Myself and purify you from those who disbelieve and make those who follow you [in submission to Allah alone] superior to those who disbelieve until the Day of Resurrection. Then to Me is your return, and I will judge between you concerning that in which you used to differ',
    normalizedText:
      "اذ قال الله يعيسى اني متوفيك ورافعك الي ومطهرك من الذين كفروا وجاعل الذين اتبعوك فوق الذين كفروا الى يوم القيمة ثم الي مرجعكم فاحكم بينكم فيما كنتم فيه تختلفون",
  },
  {
    verseId: 55,
    name: "آل عمران",
    surahId: 3,
    text: "فَأَمَّا ٱلَّذِينَ كَفَرُواْ فَأُعَذِّبُهُمۡ عَذَابٗا شَدِيدٗا فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِ وَمَا لَهُم مِّن نَّـٰصِرِينَ",
    translation:
      "And as for those who disbelieved, I will punish them with a severe punishment in this world and the Hereafter, and they will have no helpers",
    normalizedText:
      "فاما الذين كفروا فاعذبهم عذابا شديدا في الدنيا والاخرة وما لهم من نصرين",
  },
  {
    verseId: 56,
    name: "آل عمران",
    surahId: 3,
    text: "وَأَمَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فَيُوَفِّيهِمۡ أُجُورَهُمۡۗ وَٱللَّهُ لَا يُحِبُّ ٱلظَّـٰلِمِينَ",
    translation:
      "But as for those who believed and did righteous deeds, He will give them in full their rewards, and Allah does not like the wrongdoers",
    normalizedText:
      "واما الذين ءامنوا وعملوا الصلحت فيوفيهم اجورهم والله لا يحب الظلمين",
  },
  {
    verseId: 57,
    name: "آل عمران",
    surahId: 3,
    text: "ذَٰلِكَ نَتۡلُوهُ عَلَيۡكَ مِنَ ٱلۡأٓيَٰتِ وَٱلذِّكۡرِ ٱلۡحَكِيمِ",
    translation:
      "This is what We recite to you, [O Muhammad], of [Our] verses and the precise [and wise] message",
    normalizedText: "ذلك نتلوه عليك من الايت والذكر الحكيم",
  },
  {
    verseId: 58,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ مَثَلَ عِيسَىٰ عِندَ ٱللَّهِ كَمَثَلِ ءَادَمَۖ خَلَقَهُۥ مِن تُرَابٖ ثُمَّ قَالَ لَهُۥ كُن فَيَكُونُ",
    translation:
      'Indeed, the example of Jesus to Allah is like that of Adam. He created Him from dust; then He said to him, "Be," and he was',
    normalizedText:
      "ان مثل عيسى عند الله كمثل ءادم خلقه من تراب ثم قال له كن فيكون",
  },
  {
    verseId: 59,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلۡحَقُّ مِن رَّبِّكَ فَلَا تَكُن مِّنَ ٱلۡمُمۡتَرِينَ",
    translation: "The truth is from your Lord, so do not be among the doubters",
    normalizedText: "الحق من ربك فلا تكن من الممترين",
  },
  {
    verseId: 60,
    name: "آل عمران",
    surahId: 3,
    text: "فَمَنۡ حَآجَّكَ فِيهِ مِنۢ بَعۡدِ مَا جَآءَكَ مِنَ ٱلۡعِلۡمِ فَقُلۡ تَعَالَوۡاْ نَدۡعُ أَبۡنَآءَنَا وَأَبۡنَآءَكُمۡ وَنِسَآءَنَا وَنِسَآءَكُمۡ وَأَنفُسَنَا وَأَنفُسَكُمۡ ثُمَّ نَبۡتَهِلۡ فَنَجۡعَل لَّعۡنَتَ ٱللَّهِ عَلَى ٱلۡكَٰذِبِينَ",
    translation:
      'Then whoever argues with you about it after [this] knowledge has come to you - say, "Come, let us call our sons and your sons, our women and your women, ourselves and yourselves, then supplicate earnestly [together] and invoke the curse of Allah upon the liars [among us]',
    normalizedText:
      "فمن حاجك فيه من بعد ما جاءك من العلم فقل تعالوا ندع ابناءنا وابناءكم ونساءنا ونساءكم وانفسنا وانفسكم ثم نبتهل فنجعل لعنت الله على الكذبين",
  },
  {
    verseId: 61,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ هَٰذَا لَهُوَ ٱلۡقَصَصُ ٱلۡحَقُّۚ وَمَا مِنۡ إِلَٰهٍ إِلَّا ٱللَّهُۚ وَإِنَّ ٱللَّهَ لَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Indeed, this is the true narration. And there is no deity except Allah. And indeed, Allah is the Exalted in Might, the Wise",
    normalizedText:
      "ان هذا لهو القصص الحق وما من اله الا الله وان الله لهو العزيز الحكيم",
  },
  {
    verseId: 62,
    name: "آل عمران",
    surahId: 3,
    text: "فَإِن تَوَلَّوۡاْ فَإِنَّ ٱللَّهَ عَلِيمُۢ بِٱلۡمُفۡسِدِينَ",
    translation:
      "But if they turn away, then indeed - Allah is Knowing of the corrupters",
    normalizedText: "فان تولوا فان الله عليم بالمفسدين",
  },
  {
    verseId: 63,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ تَعَالَوۡاْ إِلَىٰ كَلِمَةٖ سَوَآءِۭ بَيۡنَنَا وَبَيۡنَكُمۡ أَلَّا نَعۡبُدَ إِلَّا ٱللَّهَ وَلَا نُشۡرِكَ بِهِۦ شَيۡـٔٗا وَلَا يَتَّخِذَ بَعۡضُنَا بَعۡضًا أَرۡبَابٗا مِّن دُونِ ٱللَّهِۚ فَإِن تَوَلَّوۡاْ فَقُولُواْ ٱشۡهَدُواْ بِأَنَّا مُسۡلِمُونَ",
    translation:
      'Say, "O People of the Scripture, come to a word that is equitable between us and you - that we will not worship except Allah and not associate anything with Him and not take one another as lords instead of Allah." But if they turn away, then say, "Bear witness that we are Muslims [submitting to Him]',
    normalizedText:
      "قل ياهل الكتب تعالوا الى كلمة سواء بيننا وبينكم الا نعبد الا الله ولا نشرك به شيا ولا يتخذ بعضنا بعضا اربابا من دون الله فان تولوا فقولوا اشهدوا بانا مسلمون",
  },
  {
    verseId: 64,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لِمَ تُحَآجُّونَ فِيٓ إِبۡرَٰهِيمَ وَمَآ أُنزِلَتِ ٱلتَّوۡرَىٰةُ وَٱلۡإِنجِيلُ إِلَّا مِنۢ بَعۡدِهِۦٓۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "O People of the Scripture, why do you argue about Abraham while the Torah and the Gospel were not revealed until after him? Then will you not reason",
    normalizedText:
      "ياهل الكتب لم تحاجون في ابرهيم وما انزلت التورىة والانجيل الا من بعده افلا تعقلون",
  },
  {
    verseId: 65,
    name: "آل عمران",
    surahId: 3,
    text: "هَـٰٓأَنتُمۡ هَـٰٓؤُلَآءِ حَٰجَجۡتُمۡ فِيمَا لَكُم بِهِۦ عِلۡمٞ فَلِمَ تُحَآجُّونَ فِيمَا لَيۡسَ لَكُم بِهِۦ عِلۡمٞۚ وَٱللَّهُ يَعۡلَمُ وَأَنتُمۡ لَا تَعۡلَمُونَ",
    translation:
      "Here you are - those who have argued about that of which you have [some] knowledge, but why do you argue about that of which you have no knowledge? And Allah knows, while you know not",
    normalizedText:
      "هانتم هالاء حججتم فيما لكم به علم فلم تحاجون فيما ليس لكم به علم والله يعلم وانتم لا تعلمون",
  },
  {
    verseId: 66,
    name: "آل عمران",
    surahId: 3,
    text: "مَا كَانَ إِبۡرَٰهِيمُ يَهُودِيّٗا وَلَا نَصۡرَانِيّٗا وَلَٰكِن كَانَ حَنِيفٗا مُّسۡلِمٗا وَمَا كَانَ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "Abraham was neither a Jew nor a Christian, but he was one inclining toward truth, a Muslim [submitting to Allah]. And he was not of the polytheists",
    normalizedText:
      "ما كان ابرهيم يهوديا ولا نصرانيا ولكن كان حنيفا مسلما وما كان من المشركين",
  },
  {
    verseId: 67,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ أَوۡلَى ٱلنَّاسِ بِإِبۡرَٰهِيمَ لَلَّذِينَ ٱتَّبَعُوهُ وَهَٰذَا ٱلنَّبِيُّ وَٱلَّذِينَ ءَامَنُواْۗ وَٱللَّهُ وَلِيُّ ٱلۡمُؤۡمِنِينَ",
    translation:
      "Indeed, the most worthy of Abraham among the people are those who followed him [in submission to Allah] and this prophet, and those who believe [in his message]. And Allah is the ally of the believers",
    normalizedText:
      "ان اولى الناس بابرهيم للذين اتبعوه وهذا النبي والذين ءامنوا والله ولي المامنين",
  },
  {
    verseId: 68,
    name: "آل عمران",
    surahId: 3,
    text: "وَدَّت طَّآئِفَةٞ مِّنۡ أَهۡلِ ٱلۡكِتَٰبِ لَوۡ يُضِلُّونَكُمۡ وَمَا يُضِلُّونَ إِلَّآ أَنفُسَهُمۡ وَمَا يَشۡعُرُونَ",
    translation:
      "A faction of the people of the Scripture wish they could mislead you. But they do not mislead except themselves, and they perceive [it] not",
    normalizedText:
      "ودت طاافة من اهل الكتب لو يضلونكم وما يضلون الا انفسهم وما يشعرون",
  },
  {
    verseId: 69,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لِمَ تَكۡفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَأَنتُمۡ تَشۡهَدُونَ",
    translation:
      "O People of the Scripture, why do you disbelieve in the verses of Allah while you witness [to their truth]",
    normalizedText: "ياهل الكتب لم تكفرون بايت الله وانتم تشهدون",
  },
  {
    verseId: 70,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لِمَ تَلۡبِسُونَ ٱلۡحَقَّ بِٱلۡبَٰطِلِ وَتَكۡتُمُونَ ٱلۡحَقَّ وَأَنتُمۡ تَعۡلَمُونَ",
    translation:
      "O People of the Scripture, why do you confuse the truth with falsehood and conceal the truth while you know [it]",
    normalizedText:
      "ياهل الكتب لم تلبسون الحق بالبطل وتكتمون الحق وانتم تعلمون",
  },
  {
    verseId: 71,
    name: "آل عمران",
    surahId: 3,
    text: "وَقَالَت طَّآئِفَةٞ مِّنۡ أَهۡلِ ٱلۡكِتَٰبِ ءَامِنُواْ بِٱلَّذِيٓ أُنزِلَ عَلَى ٱلَّذِينَ ءَامَنُواْ وَجۡهَ ٱلنَّهَارِ وَٱكۡفُرُوٓاْ ءَاخِرَهُۥ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      'And a faction of the People of the Scripture say [to each other], "Believe in that which was revealed to the believers at the beginning of the day and reject it at its end that perhaps they will abandon their religion',
    normalizedText:
      "وقالت طاافة من اهل الكتب ءامنوا بالذي انزل على الذين ءامنوا وجه النهار واكفروا ءاخره لعلهم يرجعون",
  },
  {
    verseId: 72,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا تُؤۡمِنُوٓاْ إِلَّا لِمَن تَبِعَ دِينَكُمۡ قُلۡ إِنَّ ٱلۡهُدَىٰ هُدَى ٱللَّهِ أَن يُؤۡتَىٰٓ أَحَدٞ مِّثۡلَ مَآ أُوتِيتُمۡ أَوۡ يُحَآجُّوكُمۡ عِندَ رَبِّكُمۡۗ قُلۡ إِنَّ ٱلۡفَضۡلَ بِيَدِ ٱللَّهِ يُؤۡتِيهِ مَن يَشَآءُۗ وَٱللَّهُ وَٰسِعٌ عَلِيمٞ",
    translation:
      'And do not trust except those who follow your religion." Say, "Indeed, the [true] guidance is the guidance of Allah. [Do you fear] lest someone be given [knowledge] like you were given or that they would [thereby] argue with you before your Lord?" Say, "Indeed, [all] bounty is in the hand of Allah - He grants it to whom He wills. And Allah is all-Encompassing and Wise',
    normalizedText:
      "ولا تامنوا الا لمن تبع دينكم قل ان الهدى هدى الله ان ياتى احد مثل ما اوتيتم او يحاجوكم عند ربكم قل ان الفضل بيد الله ياتيه من يشاء والله وسع عليم",
  },
  {
    verseId: 73,
    name: "آل عمران",
    surahId: 3,
    text: "يَخۡتَصُّ بِرَحۡمَتِهِۦ مَن يَشَآءُۗ وَٱللَّهُ ذُو ٱلۡفَضۡلِ ٱلۡعَظِيمِ",
    translation:
      "He selects for His mercy whom He wills. And Allah is the possessor of great bounty",
    normalizedText: "يختص برحمته من يشاء والله ذو الفضل العظيم",
  },
  {
    verseId: 74,
    name: "آل عمران",
    surahId: 3,
    text: "۞وَمِنۡ أَهۡلِ ٱلۡكِتَٰبِ مَنۡ إِن تَأۡمَنۡهُ بِقِنطَارٖ يُؤَدِّهِۦٓ إِلَيۡكَ وَمِنۡهُم مَّنۡ إِن تَأۡمَنۡهُ بِدِينَارٖ لَّا يُؤَدِّهِۦٓ إِلَيۡكَ إِلَّا مَا دُمۡتَ عَلَيۡهِ قَآئِمٗاۗ ذَٰلِكَ بِأَنَّهُمۡ قَالُواْ لَيۡسَ عَلَيۡنَا فِي ٱلۡأُمِّيِّـۧنَ سَبِيلٞ وَيَقُولُونَ عَلَى ٱللَّهِ ٱلۡكَذِبَ وَهُمۡ يَعۡلَمُونَ",
    translation:
      'And among the People of the Scripture is he who, if you entrust him with a great amount [of wealth], he will return it to you. And among them is he who, if you entrust him with a [single] silver coin, he will not return it to you unless you are constantly standing over him [demanding it]. That is because they say, "There is no blame upon us concerning the unlearned." And they speak untruth about Allah while they know [it]',
    normalizedText:
      "۞ومن اهل الكتب من ان تامنه بقنطار ياده اليك ومنهم من ان تامنه بدينار لا ياده اليك الا ما دمت عليه قااما ذلك بانهم قالوا ليس علينا في الامين سبيل ويقولون على الله الكذب وهم يعلمون",
  },
  {
    verseId: 75,
    name: "آل عمران",
    surahId: 3,
    text: "بَلَىٰۚ مَنۡ أَوۡفَىٰ بِعَهۡدِهِۦ وَٱتَّقَىٰ فَإِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُتَّقِينَ",
    translation:
      "But yes, whoever fulfills his commitment and fears Allah - then indeed, Allah loves those who fear Him",
    normalizedText: "بلى من اوفى بعهده واتقى فان الله يحب المتقين",
  },
  {
    verseId: 76,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ يَشۡتَرُونَ بِعَهۡدِ ٱللَّهِ وَأَيۡمَٰنِهِمۡ ثَمَنٗا قَلِيلًا أُوْلَـٰٓئِكَ لَا خَلَٰقَ لَهُمۡ فِي ٱلۡأٓخِرَةِ وَلَا يُكَلِّمُهُمُ ٱللَّهُ وَلَا يَنظُرُ إِلَيۡهِمۡ يَوۡمَ ٱلۡقِيَٰمَةِ وَلَا يُزَكِّيهِمۡ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "Indeed, those who exchange the covenant of Allah and their [own] oaths for a small price will have no share in the Hereafter, and Allah will not speak to them or look at them on the Day of Resurrection, nor will He purify them; and they will have a painful punishment",
    normalizedText:
      "ان الذين يشترون بعهد الله وايمنهم ثمنا قليلا اولاك لا خلق لهم في الاخرة ولا يكلمهم الله ولا ينظر اليهم يوم القيمة ولا يزكيهم ولهم عذاب اليم",
  },
  {
    verseId: 77,
    name: "آل عمران",
    surahId: 3,
    text: "وَإِنَّ مِنۡهُمۡ لَفَرِيقٗا يَلۡوُۥنَ أَلۡسِنَتَهُم بِٱلۡكِتَٰبِ لِتَحۡسَبُوهُ مِنَ ٱلۡكِتَٰبِ وَمَا هُوَ مِنَ ٱلۡكِتَٰبِ وَيَقُولُونَ هُوَ مِنۡ عِندِ ٱللَّهِ وَمَا هُوَ مِنۡ عِندِ ٱللَّهِۖ وَيَقُولُونَ عَلَى ٱللَّهِ ٱلۡكَذِبَ وَهُمۡ يَعۡلَمُونَ",
    translation:
      'And indeed, there is among them a party who alter the Scripture with their tongues so you may think it is from the Scripture, but it is not from the Scripture. And they say, "This is from Allah," but it is not from Allah. And they speak untruth about Allah while they know',
    normalizedText:
      "وان منهم لفريقا يلون السنتهم بالكتب لتحسبوه من الكتب وما هو من الكتب ويقولون هو من عند الله وما هو من عند الله ويقولون على الله الكذب وهم يعلمون",
  },
  {
    verseId: 78,
    name: "آل عمران",
    surahId: 3,
    text: "مَا كَانَ لِبَشَرٍ أَن يُؤۡتِيَهُ ٱللَّهُ ٱلۡكِتَٰبَ وَٱلۡحُكۡمَ وَٱلنُّبُوَّةَ ثُمَّ يَقُولَ لِلنَّاسِ كُونُواْ عِبَادٗا لِّي مِن دُونِ ٱللَّهِ وَلَٰكِن كُونُواْ رَبَّـٰنِيِّـۧنَ بِمَا كُنتُمۡ تُعَلِّمُونَ ٱلۡكِتَٰبَ وَبِمَا كُنتُمۡ تَدۡرُسُونَ",
    translation:
      'It is not for a human [prophet] that Allah should give him the Scripture and authority and prophethood and then he would say to the people, "Be servants to me rather than Allah," but [instead, he would say], "Be pious scholars of the Lord because of what you have taught of the Scripture and because of what you have studied',
    normalizedText:
      "ما كان لبشر ان ياتيه الله الكتب والحكم والنبوة ثم يقول للناس كونوا عبادا لي من دون الله ولكن كونوا ربنين بما كنتم تعلمون الكتب وبما كنتم تدرسون",
  },
  {
    verseId: 79,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا يَأۡمُرَكُمۡ أَن تَتَّخِذُواْ ٱلۡمَلَـٰٓئِكَةَ وَٱلنَّبِيِّـۧنَ أَرۡبَابًاۚ أَيَأۡمُرُكُم بِٱلۡكُفۡرِ بَعۡدَ إِذۡ أَنتُم مُّسۡلِمُونَ",
    translation:
      "Nor could he order you to take the angels and prophets as lords. Would he order you to disbelief after you had been Muslims",
    normalizedText:
      "ولا يامركم ان تتخذوا الملاكة والنبين اربابا ايامركم بالكفر بعد اذ انتم مسلمون",
  },
  {
    verseId: 80,
    name: "آل عمران",
    surahId: 3,
    text: "وَإِذۡ أَخَذَ ٱللَّهُ مِيثَٰقَ ٱلنَّبِيِّـۧنَ لَمَآ ءَاتَيۡتُكُم مِّن كِتَٰبٖ وَحِكۡمَةٖ ثُمَّ جَآءَكُمۡ رَسُولٞ مُّصَدِّقٞ لِّمَا مَعَكُمۡ لَتُؤۡمِنُنَّ بِهِۦ وَلَتَنصُرُنَّهُۥۚ قَالَ ءَأَقۡرَرۡتُمۡ وَأَخَذۡتُمۡ عَلَىٰ ذَٰلِكُمۡ إِصۡرِيۖ قَالُوٓاْ أَقۡرَرۡنَاۚ قَالَ فَٱشۡهَدُواْ وَأَنَا۠ مَعَكُم مِّنَ ٱلشَّـٰهِدِينَ",
    translation:
      'And [recall, O People of the Scripture], when Allah took the covenant of the prophets, [saying], "Whatever I give you of the Scripture and wisdom and then there comes to you a messenger confirming what is with you, you [must] believe in him and support him." [Allah] said, "Have you acknowledged and taken upon that My commitment?" They said, "We have acknowledged it." He said, "Then bear witness, and I am with you among the witnesses',
    normalizedText:
      "واذ اخذ الله ميثق النبين لما ءاتيتكم من كتب وحكمة ثم جاءكم رسول مصدق لما معكم لتامنن به ولتنصرنه قال ءاقررتم واخذتم على ذلكم اصري قالوا اقررنا قال فاشهدوا وانا معكم من الشهدين",
  },
  {
    verseId: 81,
    name: "آل عمران",
    surahId: 3,
    text: "فَمَن تَوَلَّىٰ بَعۡدَ ذَٰلِكَ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡفَٰسِقُونَ",
    translation:
      "And whoever turned away after that - they were the defiantly disobedient",
    normalizedText: "فمن تولى بعد ذلك فاولاك هم الفسقون",
  },
  {
    verseId: 82,
    name: "آل عمران",
    surahId: 3,
    text: "أَفَغَيۡرَ دِينِ ٱللَّهِ يَبۡغُونَ وَلَهُۥٓ أَسۡلَمَ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ طَوۡعٗا وَكَرۡهٗا وَإِلَيۡهِ يُرۡجَعُونَ",
    translation:
      "So is it other than the religion of Allah they desire, while to Him have submitted [all] those within the heavens and earth, willingly or by compulsion, and to Him they will be returned",
    normalizedText:
      "افغير دين الله يبغون وله اسلم من في السموت والارض طوعا وكرها واليه يرجعون",
  },
  {
    verseId: 83,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ ءَامَنَّا بِٱللَّهِ وَمَآ أُنزِلَ عَلَيۡنَا وَمَآ أُنزِلَ عَلَىٰٓ إِبۡرَٰهِيمَ وَإِسۡمَٰعِيلَ وَإِسۡحَٰقَ وَيَعۡقُوبَ وَٱلۡأَسۡبَاطِ وَمَآ أُوتِيَ مُوسَىٰ وَعِيسَىٰ وَٱلنَّبِيُّونَ مِن رَّبِّهِمۡ لَا نُفَرِّقُ بَيۡنَ أَحَدٖ مِّنۡهُمۡ وَنَحۡنُ لَهُۥ مُسۡلِمُونَ",
    translation:
      'Say, "We have believed in Allah and in what was revealed to us and what was revealed to Abraham, Ishmael, Isaac, Jacob, and the Descendants, and in what was given to Moses and Jesus and to the prophets from their Lord. We make no distinction between any of them, and we are Muslims [submitting] to Him',
    normalizedText:
      "قل ءامنا بالله وما انزل علينا وما انزل على ابرهيم واسمعيل واسحق ويعقوب والاسباط وما اوتي موسى وعيسى والنبيون من ربهم لا نفرق بين احد منهم ونحن له مسلمون",
  },
  {
    verseId: 84,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَن يَبۡتَغِ غَيۡرَ ٱلۡإِسۡلَٰمِ دِينٗا فَلَن يُقۡبَلَ مِنۡهُ وَهُوَ فِي ٱلۡأٓخِرَةِ مِنَ ٱلۡخَٰسِرِينَ",
    translation:
      "And whoever desires other than Islam as religion - never will it be accepted from him, and he, in the Hereafter, will be among the losers",
    normalizedText:
      "ومن يبتغ غير الاسلم دينا فلن يقبل منه وهو في الاخرة من الخسرين",
  },
  {
    verseId: 85,
    name: "آل عمران",
    surahId: 3,
    text: "كَيۡفَ يَهۡدِي ٱللَّهُ قَوۡمٗا كَفَرُواْ بَعۡدَ إِيمَٰنِهِمۡ وَشَهِدُوٓاْ أَنَّ ٱلرَّسُولَ حَقّٞ وَجَآءَهُمُ ٱلۡبَيِّنَٰتُۚ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      "How shall Allah guide a people who disbelieved after their belief and had witnessed that the Messenger is true and clear signs had come to them? And Allah does not guide the wrongdoing people",
    normalizedText:
      "كيف يهدي الله قوما كفروا بعد ايمنهم وشهدوا ان الرسول حق وجاءهم البينت والله لا يهدي القوم الظلمين",
  },
  {
    verseId: 86,
    name: "آل عمران",
    surahId: 3,
    text: "أُوْلَـٰٓئِكَ جَزَآؤُهُمۡ أَنَّ عَلَيۡهِمۡ لَعۡنَةَ ٱللَّهِ وَٱلۡمَلَـٰٓئِكَةِ وَٱلنَّاسِ أَجۡمَعِينَ",
    translation:
      "Those - their recompense will be that upon them is the curse of Allah and the angels and the people, all together",
    normalizedText: "اولاك جزااهم ان عليهم لعنة الله والملاكة والناس اجمعين",
  },
  {
    verseId: 87,
    name: "آل عمران",
    surahId: 3,
    text: "خَٰلِدِينَ فِيهَا لَا يُخَفَّفُ عَنۡهُمُ ٱلۡعَذَابُ وَلَا هُمۡ يُنظَرُونَ",
    translation:
      "Abiding eternally therein. The punishment will not be lightened for them, nor will they be reprieved",
    normalizedText: "خلدين فيها لا يخفف عنهم العذاب ولا هم ينظرون",
  },
  {
    verseId: 88,
    name: "آل عمران",
    surahId: 3,
    text: "إِلَّا ٱلَّذِينَ تَابُواْ مِنۢ بَعۡدِ ذَٰلِكَ وَأَصۡلَحُواْ فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٌ",
    translation:
      "Except for those who repent after that and correct themselves. For indeed, Allah is Forgiving and Merciful",
    normalizedText: "الا الذين تابوا من بعد ذلك واصلحوا فان الله غفور رحيم",
  },
  {
    verseId: 89,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ بَعۡدَ إِيمَٰنِهِمۡ ثُمَّ ٱزۡدَادُواْ كُفۡرٗا لَّن تُقۡبَلَ تَوۡبَتُهُمۡ وَأُوْلَـٰٓئِكَ هُمُ ٱلضَّآلُّونَ",
    translation:
      "Indeed, those who reject the message after their belief and then increase in disbelief - never will their [claimed] repentance be accepted, and they are the ones astray",
    normalizedText:
      "ان الذين كفروا بعد ايمنهم ثم ازدادوا كفرا لن تقبل توبتهم واولاك هم الضالون",
  },
  {
    verseId: 90,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ وَمَاتُواْ وَهُمۡ كُفَّارٞ فَلَن يُقۡبَلَ مِنۡ أَحَدِهِم مِّلۡءُ ٱلۡأَرۡضِ ذَهَبٗا وَلَوِ ٱفۡتَدَىٰ بِهِۦٓۗ أُوْلَـٰٓئِكَ لَهُمۡ عَذَابٌ أَلِيمٞ وَمَا لَهُم مِّن نَّـٰصِرِينَ",
    translation:
      "Indeed, those who disbelieve and die while they are disbelievers - never would the [whole] capacity of the earth in gold be accepted from one of them if he would [seek to] ransom himself with it. For those there will be a painful punishment, and they will have no helpers",
    normalizedText:
      "ان الذين كفروا وماتوا وهم كفار فلن يقبل من احدهم ملء الارض ذهبا ولو افتدى به اولاك لهم عذاب اليم وما لهم من نصرين",
  },
  {
    verseId: 91,
    name: "آل عمران",
    surahId: 3,
    text: "لَن تَنَالُواْ ٱلۡبِرَّ حَتَّىٰ تُنفِقُواْ مِمَّا تُحِبُّونَۚ وَمَا تُنفِقُواْ مِن شَيۡءٖ فَإِنَّ ٱللَّهَ بِهِۦ عَلِيمٞ",
    translation:
      "Never will you attain the good [reward] until you spend [in the way of Allah] from that which you love. And whatever you spend - indeed, Allah is Knowing of it",
    normalizedText:
      "لن تنالوا البر حتى تنفقوا مما تحبون وما تنفقوا من شيء فان الله به عليم",
  },
  {
    verseId: 92,
    name: "آل عمران",
    surahId: 3,
    text: "۞كُلُّ ٱلطَّعَامِ كَانَ حِلّٗا لِّبَنِيٓ إِسۡرَـٰٓءِيلَ إِلَّا مَا حَرَّمَ إِسۡرَـٰٓءِيلُ عَلَىٰ نَفۡسِهِۦ مِن قَبۡلِ أَن تُنَزَّلَ ٱلتَّوۡرَىٰةُۚ قُلۡ فَأۡتُواْ بِٱلتَّوۡرَىٰةِ فَٱتۡلُوهَآ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'All food was lawful to the Children of Israel except what Israel had made unlawful to himself before the Torah was revealed. Say, [O Muhammad], "So bring the Torah and recite it, if you should be truthful',
    normalizedText:
      "۞كل الطعام كان حلا لبني اسرءيل الا ما حرم اسرءيل على نفسه من قبل ان تنزل التورىة قل فاتوا بالتورىة فاتلوها ان كنتم صدقين",
  },
  {
    verseId: 93,
    name: "آل عمران",
    surahId: 3,
    text: "فَمَنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ ٱلۡكَذِبَ مِنۢ بَعۡدِ ذَٰلِكَ فَأُوْلَـٰٓئِكَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "And whoever invents about Allah untruth after that - then those are [truly] the wrongdoers",
    normalizedText: "فمن افترى على الله الكذب من بعد ذلك فاولاك هم الظلمون",
  },
  {
    verseId: 94,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ صَدَقَ ٱللَّهُۗ فَٱتَّبِعُواْ مِلَّةَ إِبۡرَٰهِيمَ حَنِيفٗاۖ وَمَا كَانَ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      'Say, "Allah has told the truth. So follow the religion of Abraham, inclining toward truth; and he was not of the polytheists',
    normalizedText: "قل صدق الله فاتبعوا ملة ابرهيم حنيفا وما كان من المشركين",
  },
  {
    verseId: 95,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ أَوَّلَ بَيۡتٖ وُضِعَ لِلنَّاسِ لَلَّذِي بِبَكَّةَ مُبَارَكٗا وَهُدٗى لِّلۡعَٰلَمِينَ",
    translation:
      "Indeed, the first House [of worship] established for mankind was that at Makkah - blessed and a guidance for the worlds",
    normalizedText: "ان اول بيت وضع للناس للذي ببكة مباركا وهدى للعلمين",
  },
  {
    verseId: 96,
    name: "آل عمران",
    surahId: 3,
    text: "فِيهِ ءَايَٰتُۢ بَيِّنَٰتٞ مَّقَامُ إِبۡرَٰهِيمَۖ وَمَن دَخَلَهُۥ كَانَ ءَامِنٗاۗ وَلِلَّهِ عَلَى ٱلنَّاسِ حِجُّ ٱلۡبَيۡتِ مَنِ ٱسۡتَطَاعَ إِلَيۡهِ سَبِيلٗاۚ وَمَن كَفَرَ فَإِنَّ ٱللَّهَ غَنِيٌّ عَنِ ٱلۡعَٰلَمِينَ",
    translation:
      "In it are clear signs [such as] the standing place of Abraham. And whoever enters it shall be safe. And [due] to Allah from the people is a pilgrimage to the House - for whoever is able to find thereto a way. But whoever disbelieves - then indeed, Allah is free from need of the worlds",
    normalizedText:
      "فيه ءايت بينت مقام ابرهيم ومن دخله كان ءامنا ولله على الناس حج البيت من استطاع اليه سبيلا ومن كفر فان الله غني عن العلمين",
  },
  {
    verseId: 97,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لِمَ تَكۡفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَٱللَّهُ شَهِيدٌ عَلَىٰ مَا تَعۡمَلُونَ",
    translation:
      'Say, "O People of the Scripture, why do you disbelieve in the verses of Allah while Allah is Witness over what you do',
    normalizedText:
      "قل ياهل الكتب لم تكفرون بايت الله والله شهيد على ما تعملون",
  },
  {
    verseId: 98,
    name: "آل عمران",
    surahId: 3,
    text: "قُلۡ يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لِمَ تَصُدُّونَ عَن سَبِيلِ ٱللَّهِ مَنۡ ءَامَنَ تَبۡغُونَهَا عِوَجٗا وَأَنتُمۡ شُهَدَآءُۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ",
    translation:
      'Say, "O People of the Scripture, why do you avert from the way of Allah those who believe, seeking to make it [seem] deviant, while you are witnesses [to the truth]? And Allah is not unaware of what you do',
    normalizedText:
      "قل ياهل الكتب لم تصدون عن سبيل الله من ءامن تبغونها عوجا وانتم شهداء وما الله بغفل عما تعملون",
  },
  {
    verseId: 99,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِن تُطِيعُواْ فَرِيقٗا مِّنَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ يَرُدُّوكُم بَعۡدَ إِيمَٰنِكُمۡ كَٰفِرِينَ",
    translation:
      "O you who have believed, if you obey a party of those who were given the Scripture, they would turn you back, after your belief, [to being] unbelievers",
    normalizedText:
      "يايها الذين ءامنوا ان تطيعوا فريقا من الذين اوتوا الكتب يردوكم بعد ايمنكم كفرين",
  },
  {
    verseId: 100,
    name: "آل عمران",
    surahId: 3,
    text: "وَكَيۡفَ تَكۡفُرُونَ وَأَنتُمۡ تُتۡلَىٰ عَلَيۡكُمۡ ءَايَٰتُ ٱللَّهِ وَفِيكُمۡ رَسُولُهُۥۗ وَمَن يَعۡتَصِم بِٱللَّهِ فَقَدۡ هُدِيَ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "And how could you disbelieve while to you are being recited the verses of Allah and among you is His Messenger? And whoever holds firmly to Allah has [indeed] been guided to a straight path",
    normalizedText:
      "وكيف تكفرون وانتم تتلى عليكم ءايت الله وفيكم رسوله ومن يعتصم بالله فقد هدي الى صرط مستقيم",
  },
  {
    verseId: 101,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ ٱللَّهَ حَقَّ تُقَاتِهِۦ وَلَا تَمُوتُنَّ إِلَّا وَأَنتُم مُّسۡلِمُونَ",
    translation:
      "O you who have believed, fear Allah as He should be feared and do not die except as Muslims [in submission to Him]",
    normalizedText:
      "يايها الذين ءامنوا اتقوا الله حق تقاته ولا تموتن الا وانتم مسلمون",
  },
  {
    verseId: 102,
    name: "آل عمران",
    surahId: 3,
    text: "وَٱعۡتَصِمُواْ بِحَبۡلِ ٱللَّهِ جَمِيعٗا وَلَا تَفَرَّقُواْۚ وَٱذۡكُرُواْ نِعۡمَتَ ٱللَّهِ عَلَيۡكُمۡ إِذۡ كُنتُمۡ أَعۡدَآءٗ فَأَلَّفَ بَيۡنَ قُلُوبِكُمۡ فَأَصۡبَحۡتُم بِنِعۡمَتِهِۦٓ إِخۡوَٰنٗا وَكُنتُمۡ عَلَىٰ شَفَا حُفۡرَةٖ مِّنَ ٱلنَّارِ فَأَنقَذَكُم مِّنۡهَاۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمۡ ءَايَٰتِهِۦ لَعَلَّكُمۡ تَهۡتَدُونَ",
    translation:
      "And hold firmly to the rope of Allah all together and do not become divided. And remember the favor of Allah upon you - when you were enemies and He brought your hearts together and you became, by His favor, brothers. And you were on the edge of a pit of the Fire, and He saved you from it. Thus does Allah make clear to you His verses that you may be guided",
    normalizedText:
      "واعتصموا بحبل الله جميعا ولا تفرقوا واذكروا نعمت الله عليكم اذ كنتم اعداء فالف بين قلوبكم فاصبحتم بنعمته اخونا وكنتم على شفا حفرة من النار فانقذكم منها كذلك يبين الله لكم ءايته لعلكم تهتدون",
  },
  {
    verseId: 103,
    name: "آل عمران",
    surahId: 3,
    text: "وَلۡتَكُن مِّنكُمۡ أُمَّةٞ يَدۡعُونَ إِلَى ٱلۡخَيۡرِ وَيَأۡمُرُونَ بِٱلۡمَعۡرُوفِ وَيَنۡهَوۡنَ عَنِ ٱلۡمُنكَرِۚ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "And let there be [arising] from you a nation inviting to [all that is] good, enjoining what is right and forbidding what is wrong, and those will be the successful",
    normalizedText:
      "ولتكن منكم امة يدعون الى الخير ويامرون بالمعروف وينهون عن المنكر واولاك هم المفلحون",
  },
  {
    verseId: 104,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا تَكُونُواْ كَٱلَّذِينَ تَفَرَّقُواْ وَٱخۡتَلَفُواْ مِنۢ بَعۡدِ مَا جَآءَهُمُ ٱلۡبَيِّنَٰتُۚ وَأُوْلَـٰٓئِكَ لَهُمۡ عَذَابٌ عَظِيمٞ",
    translation:
      "And do not be like the ones who became divided and differed after the clear proofs had come to them. And those will have a great punishment",
    normalizedText:
      "ولا تكونوا كالذين تفرقوا واختلفوا من بعد ما جاءهم البينت واولاك لهم عذاب عظيم",
  },
  {
    verseId: 105,
    name: "آل عمران",
    surahId: 3,
    text: "يَوۡمَ تَبۡيَضُّ وُجُوهٞ وَتَسۡوَدُّ وُجُوهٞۚ فَأَمَّا ٱلَّذِينَ ٱسۡوَدَّتۡ وُجُوهُهُمۡ أَكَفَرۡتُم بَعۡدَ إِيمَٰنِكُمۡ فَذُوقُواْ ٱلۡعَذَابَ بِمَا كُنتُمۡ تَكۡفُرُونَ",
    translation:
      'On the Day [some] faces will turn white and [some] faces will turn black. As for those whose faces turn black, [to them it will be said], "Did you disbelieve after your belief? Then taste the punishment for what you used to reject',
    normalizedText:
      "يوم تبيض وجوه وتسود وجوه فاما الذين اسودت وجوههم اكفرتم بعد ايمنكم فذوقوا العذاب بما كنتم تكفرون",
  },
  {
    verseId: 106,
    name: "آل عمران",
    surahId: 3,
    text: "وَأَمَّا ٱلَّذِينَ ٱبۡيَضَّتۡ وُجُوهُهُمۡ فَفِي رَحۡمَةِ ٱللَّهِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "But as for those whose faces will turn white, [they will be] within the mercy of Allah. They will abide therein eternally",
    normalizedText: "واما الذين ابيضت وجوههم ففي رحمة الله هم فيها خلدون",
  },
  {
    verseId: 107,
    name: "آل عمران",
    surahId: 3,
    text: "تِلۡكَ ءَايَٰتُ ٱللَّهِ نَتۡلُوهَا عَلَيۡكَ بِٱلۡحَقِّۗ وَمَا ٱللَّهُ يُرِيدُ ظُلۡمٗا لِّلۡعَٰلَمِينَ",
    translation:
      "These are the verses of Allah. We recite them to you, [O Muhammad], in truth; and Allah wants no injustice to the worlds",
    normalizedText:
      "تلك ءايت الله نتلوها عليك بالحق وما الله يريد ظلما للعلمين",
  },
  {
    verseId: 108,
    name: "آل عمران",
    surahId: 3,
    text: "وَلِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ وَإِلَى ٱللَّهِ تُرۡجَعُ ٱلۡأُمُورُ",
    translation:
      "To Allah belongs whatever is in the heavens and whatever is on the earth. And to Allah will [all] matters be returned",
    normalizedText: "ولله ما في السموت وما في الارض والى الله ترجع الامور",
  },
  {
    verseId: 109,
    name: "آل عمران",
    surahId: 3,
    text: "كُنتُمۡ خَيۡرَ أُمَّةٍ أُخۡرِجَتۡ لِلنَّاسِ تَأۡمُرُونَ بِٱلۡمَعۡرُوفِ وَتَنۡهَوۡنَ عَنِ ٱلۡمُنكَرِ وَتُؤۡمِنُونَ بِٱللَّهِۗ وَلَوۡ ءَامَنَ أَهۡلُ ٱلۡكِتَٰبِ لَكَانَ خَيۡرٗا لَّهُمۚ مِّنۡهُمُ ٱلۡمُؤۡمِنُونَ وَأَكۡثَرُهُمُ ٱلۡفَٰسِقُونَ",
    translation:
      "You are the best nation produced [as an example] for mankind. You enjoin what is right and forbid what is wrong and believe in Allah. If only the People of the Scripture had believed, it would have been better for them. Among them are believers, but most of them are defiantly disobedient",
    normalizedText:
      "كنتم خير امة اخرجت للناس تامرون بالمعروف وتنهون عن المنكر وتامنون بالله ولو ءامن اهل الكتب لكان خيرا لهم منهم المامنون واكثرهم الفسقون",
  },
  {
    verseId: 110,
    name: "آل عمران",
    surahId: 3,
    text: "لَن يَضُرُّوكُمۡ إِلَّآ أَذٗىۖ وَإِن يُقَٰتِلُوكُمۡ يُوَلُّوكُمُ ٱلۡأَدۡبَارَ ثُمَّ لَا يُنصَرُونَ",
    translation:
      "They will not harm you except for [some] annoyance. And if they fight you, they will show you their backs; then they will not be aided",
    normalizedText: "لن يضروكم الا اذى وان يقتلوكم يولوكم الادبار ثم لا ينصرون",
  },
  {
    verseId: 111,
    name: "آل عمران",
    surahId: 3,
    text: "ضُرِبَتۡ عَلَيۡهِمُ ٱلذِّلَّةُ أَيۡنَ مَا ثُقِفُوٓاْ إِلَّا بِحَبۡلٖ مِّنَ ٱللَّهِ وَحَبۡلٖ مِّنَ ٱلنَّاسِ وَبَآءُو بِغَضَبٖ مِّنَ ٱللَّهِ وَضُرِبَتۡ عَلَيۡهِمُ ٱلۡمَسۡكَنَةُۚ ذَٰلِكَ بِأَنَّهُمۡ كَانُواْ يَكۡفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَيَقۡتُلُونَ ٱلۡأَنۢبِيَآءَ بِغَيۡرِ حَقّٖۚ ذَٰلِكَ بِمَا عَصَواْ وَّكَانُواْ يَعۡتَدُونَ",
    translation:
      "They have been put under humiliation [by Allah] wherever they are overtaken, except for a covenant from Allah and a rope from the Muslims. And they have drawn upon themselves anger from Allah and have been put under destitution. That is because they disbelieved in the verses of Allah and killed the prophets without right. That is because they disobeyed and [habitually] transgressed",
    normalizedText:
      "ضربت عليهم الذلة اين ما ثقفوا الا بحبل من الله وحبل من الناس وباءو بغضب من الله وضربت عليهم المسكنة ذلك بانهم كانوا يكفرون بايت الله ويقتلون الانبياء بغير حق ذلك بما عصوا وكانوا يعتدون",
  },
  {
    verseId: 112,
    name: "آل عمران",
    surahId: 3,
    text: "۞لَيۡسُواْ سَوَآءٗۗ مِّنۡ أَهۡلِ ٱلۡكِتَٰبِ أُمَّةٞ قَآئِمَةٞ يَتۡلُونَ ءَايَٰتِ ٱللَّهِ ءَانَآءَ ٱلَّيۡلِ وَهُمۡ يَسۡجُدُونَ",
    translation:
      "They are not [all] the same; among the People of the Scripture is a community standing [in obedience], reciting the verses of Allah during periods of the night and prostrating [in prayer]",
    normalizedText:
      "۞ليسوا سواء من اهل الكتب امة قاامة يتلون ءايت الله ءاناء اليل وهم يسجدون",
  },
  {
    verseId: 113,
    name: "آل عمران",
    surahId: 3,
    text: "يُؤۡمِنُونَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَيَأۡمُرُونَ بِٱلۡمَعۡرُوفِ وَيَنۡهَوۡنَ عَنِ ٱلۡمُنكَرِ وَيُسَٰرِعُونَ فِي ٱلۡخَيۡرَٰتِۖ وَأُوْلَـٰٓئِكَ مِنَ ٱلصَّـٰلِحِينَ",
    translation:
      "They believe in Allah and the Last Day, and they enjoin what is right and forbid what is wrong and hasten to good deeds. And those are among the righteous",
    normalizedText:
      "يامنون بالله واليوم الاخر ويامرون بالمعروف وينهون عن المنكر ويسرعون في الخيرت واولاك من الصلحين",
  },
  {
    verseId: 114,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَا يَفۡعَلُواْ مِنۡ خَيۡرٖ فَلَن يُكۡفَرُوهُۗ وَٱللَّهُ عَلِيمُۢ بِٱلۡمُتَّقِينَ",
    translation:
      "And whatever good they do - never will it be removed from them. And Allah is Knowing of the righteous",
    normalizedText: "وما يفعلوا من خير فلن يكفروه والله عليم بالمتقين",
  },
  {
    verseId: 115,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ لَن تُغۡنِيَ عَنۡهُمۡ أَمۡوَٰلُهُمۡ وَلَآ أَوۡلَٰدُهُم مِّنَ ٱللَّهِ شَيۡـٔٗاۖ وَأُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "Indeed, those who disbelieve - never will their wealth or their children avail them against Allah at all, and those are the companions of the Fire; they will abide therein eternally",
    normalizedText:
      "ان الذين كفروا لن تغني عنهم امولهم ولا اولدهم من الله شيا واولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 116,
    name: "آل عمران",
    surahId: 3,
    text: "مَثَلُ مَا يُنفِقُونَ فِي هَٰذِهِ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا كَمَثَلِ رِيحٖ فِيهَا صِرٌّ أَصَابَتۡ حَرۡثَ قَوۡمٖ ظَلَمُوٓاْ أَنفُسَهُمۡ فَأَهۡلَكَتۡهُۚ وَمَا ظَلَمَهُمُ ٱللَّهُ وَلَٰكِنۡ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      "The example of what they spend in this worldly life is like that of a wind containing frost which strikes the harvest of a people who have wronged themselves and destroys it. And Allah has not wronged them, but they wrong themselves",
    normalizedText:
      "مثل ما ينفقون في هذه الحيوة الدنيا كمثل ريح فيها صر اصابت حرث قوم ظلموا انفسهم فاهلكته وما ظلمهم الله ولكن انفسهم يظلمون",
  },
  {
    verseId: 117,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّخِذُواْ بِطَانَةٗ مِّن دُونِكُمۡ لَا يَأۡلُونَكُمۡ خَبَالٗا وَدُّواْ مَا عَنِتُّمۡ قَدۡ بَدَتِ ٱلۡبَغۡضَآءُ مِنۡ أَفۡوَٰهِهِمۡ وَمَا تُخۡفِي صُدُورُهُمۡ أَكۡبَرُۚ قَدۡ بَيَّنَّا لَكُمُ ٱلۡأٓيَٰتِۖ إِن كُنتُمۡ تَعۡقِلُونَ",
    translation:
      "O you who have believed, do not take as intimates those other than yourselves, for they will not spare you [any] ruin. They wish you would have hardship. Hatred has already appeared from their mouths, and what their breasts conceal is greater. We have certainly made clear to you the signs, if you will use reason",
    normalizedText:
      "يايها الذين ءامنوا لا تتخذوا بطانة من دونكم لا يالونكم خبالا ودوا ما عنتم قد بدت البغضاء من افوههم وما تخفي صدورهم اكبر قد بينا لكم الايت ان كنتم تعقلون",
  },
  {
    verseId: 118,
    name: "آل عمران",
    surahId: 3,
    text: "هَـٰٓأَنتُمۡ أُوْلَآءِ تُحِبُّونَهُمۡ وَلَا يُحِبُّونَكُمۡ وَتُؤۡمِنُونَ بِٱلۡكِتَٰبِ كُلِّهِۦ وَإِذَا لَقُوكُمۡ قَالُوٓاْ ءَامَنَّا وَإِذَا خَلَوۡاْ عَضُّواْ عَلَيۡكُمُ ٱلۡأَنَامِلَ مِنَ ٱلۡغَيۡظِۚ قُلۡ مُوتُواْ بِغَيۡظِكُمۡۗ إِنَّ ٱللَّهَ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      'Here you are loving them but they are not loving you, while you believe in the Scripture - all of it. And when they meet you, they say, "We believe." But when they are alone, they bite their fingertips at you in rage. Say, "Die in your rage. Indeed, Allah is Knowing of that within the breasts',
    normalizedText:
      "هانتم اولاء تحبونهم ولا يحبونكم وتامنون بالكتب كله واذا لقوكم قالوا ءامنا واذا خلوا عضوا عليكم الانامل من الغيظ قل موتوا بغيظكم ان الله عليم بذات الصدور",
  },
  {
    verseId: 119,
    name: "آل عمران",
    surahId: 3,
    text: "إِن تَمۡسَسۡكُمۡ حَسَنَةٞ تَسُؤۡهُمۡ وَإِن تُصِبۡكُمۡ سَيِّئَةٞ يَفۡرَحُواْ بِهَاۖ وَإِن تَصۡبِرُواْ وَتَتَّقُواْ لَا يَضُرُّكُمۡ كَيۡدُهُمۡ شَيۡـًٔاۗ إِنَّ ٱللَّهَ بِمَا يَعۡمَلُونَ مُحِيطٞ",
    translation:
      "If good touches you, it distresses them; but if harm strikes you, they rejoice at it. And if you are patient and fear Allah, their plot will not harm you at all. Indeed, Allah is encompassing of what they do",
    normalizedText:
      "ان تمسسكم حسنة تساهم وان تصبكم سياة يفرحوا بها وان تصبروا وتتقوا لا يضركم كيدهم شيا ان الله بما يعملون محيط",
  },
  {
    verseId: 120,
    name: "آل عمران",
    surahId: 3,
    text: "وَإِذۡ غَدَوۡتَ مِنۡ أَهۡلِكَ تُبَوِّئُ ٱلۡمُؤۡمِنِينَ مَقَٰعِدَ لِلۡقِتَالِۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ",
    translation:
      "And [remember] when you, [O Muhammad], left your family in the morning to post the believers at their stations for the battle [of Uhud] - and Allah is Hearing and Knowing",
    normalizedText:
      "واذ غدوت من اهلك تبوا المامنين مقعد للقتال والله سميع عليم",
  },
  {
    verseId: 121,
    name: "آل عمران",
    surahId: 3,
    text: "إِذۡ هَمَّت طَّآئِفَتَانِ مِنكُمۡ أَن تَفۡشَلَا وَٱللَّهُ وَلِيُّهُمَاۗ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُؤۡمِنُونَ",
    translation:
      "When two parties among you were about to lose courage, but Allah was their ally; and upon Allah the believers should rely",
    normalizedText:
      "اذ همت طاافتان منكم ان تفشلا والله وليهما وعلى الله فليتوكل المامنون",
  },
  {
    verseId: 122,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَقَدۡ نَصَرَكُمُ ٱللَّهُ بِبَدۡرٖ وَأَنتُمۡ أَذِلَّةٞۖ فَٱتَّقُواْ ٱللَّهَ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And already had Allah given you victory at [the battle of] Badr while you were few in number. Then fear Allah; perhaps you will be grateful",
    normalizedText: "ولقد نصركم الله ببدر وانتم اذلة فاتقوا الله لعلكم تشكرون",
  },
  {
    verseId: 123,
    name: "آل عمران",
    surahId: 3,
    text: "إِذۡ تَقُولُ لِلۡمُؤۡمِنِينَ أَلَن يَكۡفِيَكُمۡ أَن يُمِدَّكُمۡ رَبُّكُم بِثَلَٰثَةِ ءَالَٰفٖ مِّنَ ٱلۡمَلَـٰٓئِكَةِ مُنزَلِينَ",
    translation:
      '[Remember] when you said to the believers, "Is it not sufficient for you that your Lord should reinforce you with three thousand angels sent down',
    normalizedText:
      "اذ تقول للمامنين الن يكفيكم ان يمدكم ربكم بثلثة ءالف من الملاكة منزلين",
  },
  {
    verseId: 124,
    name: "آل عمران",
    surahId: 3,
    text: "بَلَىٰٓۚ إِن تَصۡبِرُواْ وَتَتَّقُواْ وَيَأۡتُوكُم مِّن فَوۡرِهِمۡ هَٰذَا يُمۡدِدۡكُمۡ رَبُّكُم بِخَمۡسَةِ ءَالَٰفٖ مِّنَ ٱلۡمَلَـٰٓئِكَةِ مُسَوِّمِينَ",
    translation:
      "Yes, if you remain patient and conscious of Allah and the enemy come upon you [attacking] in rage, your Lord will reinforce you with five thousand angels having marks [of distinction]",
    normalizedText:
      "بلى ان تصبروا وتتقوا وياتوكم من فورهم هذا يمددكم ربكم بخمسة ءالف من الملاكة مسومين",
  },
  {
    verseId: 125,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَا جَعَلَهُ ٱللَّهُ إِلَّا بُشۡرَىٰ لَكُمۡ وَلِتَطۡمَئِنَّ قُلُوبُكُم بِهِۦۗ وَمَا ٱلنَّصۡرُ إِلَّا مِنۡ عِندِ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ",
    translation:
      "And Allah made it not except as [a sign of] good tidings for you and to reassure your hearts thereby. And victory is not except from Allah, the Exalted in Might, the Wise",
    normalizedText:
      "وما جعله الله الا بشرى لكم ولتطمان قلوبكم به وما النصر الا من عند الله العزيز الحكيم",
  },
  {
    verseId: 126,
    name: "آل عمران",
    surahId: 3,
    text: "لِيَقۡطَعَ طَرَفٗا مِّنَ ٱلَّذِينَ كَفَرُوٓاْ أَوۡ يَكۡبِتَهُمۡ فَيَنقَلِبُواْ خَآئِبِينَ",
    translation:
      "That He might cut down a section of the disbelievers or suppress them so that they turn back disappointed",
    normalizedText: "ليقطع طرفا من الذين كفروا او يكبتهم فينقلبوا خاابين",
  },
  {
    verseId: 127,
    name: "آل عمران",
    surahId: 3,
    text: "لَيۡسَ لَكَ مِنَ ٱلۡأَمۡرِ شَيۡءٌ أَوۡ يَتُوبَ عَلَيۡهِمۡ أَوۡ يُعَذِّبَهُمۡ فَإِنَّهُمۡ ظَٰلِمُونَ",
    translation:
      "Not for you, [O Muhammad, but for Allah], is the decision whether He should [cut them down] or forgive them or punish them, for indeed, they are wrongdoers",
    normalizedText: "ليس لك من الامر شيء او يتوب عليهم او يعذبهم فانهم ظلمون",
  },
  {
    verseId: 128,
    name: "آل عمران",
    surahId: 3,
    text: "وَلِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ يَغۡفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "And to Allah belongs whatever is in the heavens and whatever is on the earth. He forgives whom He wills and punishes whom He wills. And Allah is Forgiving and Merciful",
    normalizedText:
      "ولله ما في السموت وما في الارض يغفر لمن يشاء ويعذب من يشاء والله غفور رحيم",
  },
  {
    verseId: 129,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَأۡكُلُواْ ٱلرِّبَوٰٓاْ أَضۡعَٰفٗا مُّضَٰعَفَةٗۖ وَٱتَّقُواْ ٱللَّهَ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "O you who have believed, do not consume usury, doubled and multiplied, but fear Allah that you may be successful",
    normalizedText:
      "يايها الذين ءامنوا لا تاكلوا الربوا اضعفا مضعفة واتقوا الله لعلكم تفلحون",
  },
  {
    verseId: 130,
    name: "آل عمران",
    surahId: 3,
    text: "وَٱتَّقُواْ ٱلنَّارَ ٱلَّتِيٓ أُعِدَّتۡ لِلۡكَٰفِرِينَ",
    translation:
      "And fear the Fire, which has been prepared for the disbelievers",
    normalizedText: "واتقوا النار التي اعدت للكفرين",
  },
  {
    verseId: 131,
    name: "آل عمران",
    surahId: 3,
    text: "وَأَطِيعُواْ ٱللَّهَ وَٱلرَّسُولَ لَعَلَّكُمۡ تُرۡحَمُونَ",
    translation: "And obey Allah and the Messenger that you may obtain mercy",
    normalizedText: "واطيعوا الله والرسول لعلكم ترحمون",
  },
  {
    verseId: 132,
    name: "آل عمران",
    surahId: 3,
    text: "۞وَسَارِعُوٓاْ إِلَىٰ مَغۡفِرَةٖ مِّن رَّبِّكُمۡ وَجَنَّةٍ عَرۡضُهَا ٱلسَّمَٰوَٰتُ وَٱلۡأَرۡضُ أُعِدَّتۡ لِلۡمُتَّقِينَ",
    translation:
      "And hasten to forgiveness from your Lord and a garden as wide as the heavens and earth, prepared for the righteous",
    normalizedText:
      "۞وسارعوا الى مغفرة من ربكم وجنة عرضها السموت والارض اعدت للمتقين",
  },
  {
    verseId: 133,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلَّذِينَ يُنفِقُونَ فِي ٱلسَّرَّآءِ وَٱلضَّرَّآءِ وَٱلۡكَٰظِمِينَ ٱلۡغَيۡظَ وَٱلۡعَافِينَ عَنِ ٱلنَّاسِۗ وَٱللَّهُ يُحِبُّ ٱلۡمُحۡسِنِينَ",
    translation:
      "Who spend [in the cause of Allah] during ease and hardship and who restrain anger and who pardon the people - and Allah loves the doers of good",
    normalizedText:
      "الذين ينفقون في السراء والضراء والكظمين الغيظ والعافين عن الناس والله يحب المحسنين",
  },
  {
    verseId: 134,
    name: "آل عمران",
    surahId: 3,
    text: "وَٱلَّذِينَ إِذَا فَعَلُواْ فَٰحِشَةً أَوۡ ظَلَمُوٓاْ أَنفُسَهُمۡ ذَكَرُواْ ٱللَّهَ فَٱسۡتَغۡفَرُواْ لِذُنُوبِهِمۡ وَمَن يَغۡفِرُ ٱلذُّنُوبَ إِلَّا ٱللَّهُ وَلَمۡ يُصِرُّواْ عَلَىٰ مَا فَعَلُواْ وَهُمۡ يَعۡلَمُونَ",
    translation:
      "And those who, when they commit an immorality or wrong themselves [by transgression], remember Allah and seek forgiveness for their sins - and who can forgive sins except Allah? - and [who] do not persist in what they have done while they know",
    normalizedText:
      "والذين اذا فعلوا فحشة او ظلموا انفسهم ذكروا الله فاستغفروا لذنوبهم ومن يغفر الذنوب الا الله ولم يصروا على ما فعلوا وهم يعلمون",
  },
  {
    verseId: 135,
    name: "آل عمران",
    surahId: 3,
    text: "أُوْلَـٰٓئِكَ جَزَآؤُهُم مَّغۡفِرَةٞ مِّن رَّبِّهِمۡ وَجَنَّـٰتٞ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ وَنِعۡمَ أَجۡرُ ٱلۡعَٰمِلِينَ",
    translation:
      "Those - their reward is forgiveness from their Lord and gardens beneath which rivers flow [in Paradise], wherein they will abide eternally; and excellent is the reward of the [righteous] workers",
    normalizedText:
      "اولاك جزااهم مغفرة من ربهم وجنت تجري من تحتها الانهر خلدين فيها ونعم اجر العملين",
  },
  {
    verseId: 136,
    name: "آل عمران",
    surahId: 3,
    text: "قَدۡ خَلَتۡ مِن قَبۡلِكُمۡ سُنَنٞ فَسِيرُواْ فِي ٱلۡأَرۡضِ فَٱنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُكَذِّبِينَ",
    translation:
      "Similar situations [as yours] have passed on before you, so proceed throughout the earth and observe how was the end of those who denied",
    normalizedText:
      "قد خلت من قبلكم سنن فسيروا في الارض فانظروا كيف كان عقبة المكذبين",
  },
  {
    verseId: 137,
    name: "آل عمران",
    surahId: 3,
    text: "هَٰذَا بَيَانٞ لِّلنَّاسِ وَهُدٗى وَمَوۡعِظَةٞ لِّلۡمُتَّقِينَ",
    translation:
      "This [Qur'an] is a clear statement to [all] the people and a guidance and instruction for those conscious of Allah",
    normalizedText: "هذا بيان للناس وهدى وموعظة للمتقين",
  },
  {
    verseId: 138,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا تَهِنُواْ وَلَا تَحۡزَنُواْ وَأَنتُمُ ٱلۡأَعۡلَوۡنَ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "So do not weaken and do not grieve, and you will be superior if you are [true] believers",
    normalizedText: "ولا تهنوا ولا تحزنوا وانتم الاعلون ان كنتم مامنين",
  },
  {
    verseId: 139,
    name: "آل عمران",
    surahId: 3,
    text: "إِن يَمۡسَسۡكُمۡ قَرۡحٞ فَقَدۡ مَسَّ ٱلۡقَوۡمَ قَرۡحٞ مِّثۡلُهُۥۚ وَتِلۡكَ ٱلۡأَيَّامُ نُدَاوِلُهَا بَيۡنَ ٱلنَّاسِ وَلِيَعۡلَمَ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ وَيَتَّخِذَ مِنكُمۡ شُهَدَآءَۗ وَٱللَّهُ لَا يُحِبُّ ٱلظَّـٰلِمِينَ",
    translation:
      "If a wound should touch you - there has already touched the [opposing] people a wound similar to it. And these days [of varying conditions] We alternate among the people so that Allah may make evident those who believe and [may] take to Himself from among you martyrs - and Allah does not like the wrongdoers",
    normalizedText:
      "ان يمسسكم قرح فقد مس القوم قرح مثله وتلك الايام نداولها بين الناس وليعلم الله الذين ءامنوا ويتخذ منكم شهداء والله لا يحب الظلمين",
  },
  {
    verseId: 140,
    name: "آل عمران",
    surahId: 3,
    text: "وَلِيُمَحِّصَ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ وَيَمۡحَقَ ٱلۡكَٰفِرِينَ",
    translation:
      "And that Allah may purify the believers [through trials] and destroy the disbelievers",
    normalizedText: "وليمحص الله الذين ءامنوا ويمحق الكفرين",
  },
  {
    verseId: 141,
    name: "آل عمران",
    surahId: 3,
    text: "أَمۡ حَسِبۡتُمۡ أَن تَدۡخُلُواْ ٱلۡجَنَّةَ وَلَمَّا يَعۡلَمِ ٱللَّهُ ٱلَّذِينَ جَٰهَدُواْ مِنكُمۡ وَيَعۡلَمَ ٱلصَّـٰبِرِينَ",
    translation:
      "Or do you think that you will enter Paradise while Allah has not yet made evident those of you who fight in His cause and made evident those who are steadfast",
    normalizedText:
      "ام حسبتم ان تدخلوا الجنة ولما يعلم الله الذين جهدوا منكم ويعلم الصبرين",
  },
  {
    verseId: 142,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَقَدۡ كُنتُمۡ تَمَنَّوۡنَ ٱلۡمَوۡتَ مِن قَبۡلِ أَن تَلۡقَوۡهُ فَقَدۡ رَأَيۡتُمُوهُ وَأَنتُمۡ تَنظُرُونَ",
    translation:
      "And you had certainly wished for martyrdom before you encountered it, and you have [now] seen it [before you] while you were looking on",
    normalizedText:
      "ولقد كنتم تمنون الموت من قبل ان تلقوه فقد رايتموه وانتم تنظرون",
  },
  {
    verseId: 143,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَا مُحَمَّدٌ إِلَّا رَسُولٞ قَدۡ خَلَتۡ مِن قَبۡلِهِ ٱلرُّسُلُۚ أَفَإِيْن مَّاتَ أَوۡ قُتِلَ ٱنقَلَبۡتُمۡ عَلَىٰٓ أَعۡقَٰبِكُمۡۚ وَمَن يَنقَلِبۡ عَلَىٰ عَقِبَيۡهِ فَلَن يَضُرَّ ٱللَّهَ شَيۡـٔٗاۚ وَسَيَجۡزِي ٱللَّهُ ٱلشَّـٰكِرِينَ",
    translation:
      "Muhammad is not but a messenger. [Other] messengers have passed on before him. So if he was to die or be killed, would you turn back on your heels [to unbelief]? And he who turns back on his heels will never harm Allah at all; but Allah will reward the grateful",
    normalizedText:
      "وما محمد الا رسول قد خلت من قبله الرسل افاين مات او قتل انقلبتم على اعقبكم ومن ينقلب على عقبيه فلن يضر الله شيا وسيجزي الله الشكرين",
  },
  {
    verseId: 144,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَا كَانَ لِنَفۡسٍ أَن تَمُوتَ إِلَّا بِإِذۡنِ ٱللَّهِ كِتَٰبٗا مُّؤَجَّلٗاۗ وَمَن يُرِدۡ ثَوَابَ ٱلدُّنۡيَا نُؤۡتِهِۦ مِنۡهَا وَمَن يُرِدۡ ثَوَابَ ٱلۡأٓخِرَةِ نُؤۡتِهِۦ مِنۡهَاۚ وَسَنَجۡزِي ٱلشَّـٰكِرِينَ",
    translation:
      "And it is not [possible] for one to die except by permission of Allah at a decree determined. And whoever desires the reward of this world - We will give him thereof; and whoever desires the reward of the Hereafter - We will give him thereof. And we will reward the grateful",
    normalizedText:
      "وما كان لنفس ان تموت الا باذن الله كتبا ماجلا ومن يرد ثواب الدنيا ناته منها ومن يرد ثواب الاخرة ناته منها وسنجزي الشكرين",
  },
  {
    verseId: 145,
    name: "آل عمران",
    surahId: 3,
    text: "وَكَأَيِّن مِّن نَّبِيّٖ قَٰتَلَ مَعَهُۥ رِبِّيُّونَ كَثِيرٞ فَمَا وَهَنُواْ لِمَآ أَصَابَهُمۡ فِي سَبِيلِ ٱللَّهِ وَمَا ضَعُفُواْ وَمَا ٱسۡتَكَانُواْۗ وَٱللَّهُ يُحِبُّ ٱلصَّـٰبِرِينَ",
    translation:
      "And how many a prophet [fought and] with him fought many religious scholars. But they never lost assurance due to what afflicted them in the cause of Allah, nor did they weaken or submit. And Allah loves the steadfast",
    normalizedText:
      "وكاين من نبي قتل معه ربيون كثير فما وهنوا لما اصابهم في سبيل الله وما ضعفوا وما استكانوا والله يحب الصبرين",
  },
  {
    verseId: 146,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَا كَانَ قَوۡلَهُمۡ إِلَّآ أَن قَالُواْ رَبَّنَا ٱغۡفِرۡ لَنَا ذُنُوبَنَا وَإِسۡرَافَنَا فِيٓ أَمۡرِنَا وَثَبِّتۡ أَقۡدَامَنَا وَٱنصُرۡنَا عَلَى ٱلۡقَوۡمِ ٱلۡكَٰفِرِينَ",
    translation:
      'And their words were not but that they said, "Our Lord, forgive us our sins and the excess [committed] in our affairs and plant firmly our feet and give us victory over the disbelieving people',
    normalizedText:
      "وما كان قولهم الا ان قالوا ربنا اغفر لنا ذنوبنا واسرافنا في امرنا وثبت اقدامنا وانصرنا على القوم الكفرين",
  },
  {
    verseId: 147,
    name: "آل عمران",
    surahId: 3,
    text: "فَـَٔاتَىٰهُمُ ٱللَّهُ ثَوَابَ ٱلدُّنۡيَا وَحُسۡنَ ثَوَابِ ٱلۡأٓخِرَةِۗ وَٱللَّهُ يُحِبُّ ٱلۡمُحۡسِنِينَ",
    translation:
      "So Allah gave them the reward of this world and the good reward of the Hereafter. And Allah loves the doers of good",
    normalizedText:
      "فاتىهم الله ثواب الدنيا وحسن ثواب الاخرة والله يحب المحسنين",
  },
  {
    verseId: 148,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِن تُطِيعُواْ ٱلَّذِينَ كَفَرُواْ يَرُدُّوكُمۡ عَلَىٰٓ أَعۡقَٰبِكُمۡ فَتَنقَلِبُواْ خَٰسِرِينَ",
    translation:
      "O you who have believed, if you obey those who disbelieve, they will turn you back on your heels, and you will [then] become losers",
    normalizedText:
      "يايها الذين ءامنوا ان تطيعوا الذين كفروا يردوكم على اعقبكم فتنقلبوا خسرين",
  },
  {
    verseId: 149,
    name: "آل عمران",
    surahId: 3,
    text: "بَلِ ٱللَّهُ مَوۡلَىٰكُمۡۖ وَهُوَ خَيۡرُ ٱلنَّـٰصِرِينَ",
    translation: "But Allah is your protector, and He is the best of helpers",
    normalizedText: "بل الله مولىكم وهو خير النصرين",
  },
  {
    verseId: 150,
    name: "آل عمران",
    surahId: 3,
    text: "سَنُلۡقِي فِي قُلُوبِ ٱلَّذِينَ كَفَرُواْ ٱلرُّعۡبَ بِمَآ أَشۡرَكُواْ بِٱللَّهِ مَا لَمۡ يُنَزِّلۡ بِهِۦ سُلۡطَٰنٗاۖ وَمَأۡوَىٰهُمُ ٱلنَّارُۖ وَبِئۡسَ مَثۡوَى ٱلظَّـٰلِمِينَ",
    translation:
      "We will cast terror into the hearts of those who disbelieve for what they have associated with Allah of which He had not sent down [any] authority. And their refuge will be the Fire, and wretched is the residence of the wrongdoers",
    normalizedText:
      "سنلقي في قلوب الذين كفروا الرعب بما اشركوا بالله ما لم ينزل به سلطنا وماوىهم النار وباس مثوى الظلمين",
  },
  {
    verseId: 151,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَقَدۡ صَدَقَكُمُ ٱللَّهُ وَعۡدَهُۥٓ إِذۡ تَحُسُّونَهُم بِإِذۡنِهِۦۖ حَتَّىٰٓ إِذَا فَشِلۡتُمۡ وَتَنَٰزَعۡتُمۡ فِي ٱلۡأَمۡرِ وَعَصَيۡتُم مِّنۢ بَعۡدِ مَآ أَرَىٰكُم مَّا تُحِبُّونَۚ مِنكُم مَّن يُرِيدُ ٱلدُّنۡيَا وَمِنكُم مَّن يُرِيدُ ٱلۡأٓخِرَةَۚ ثُمَّ صَرَفَكُمۡ عَنۡهُمۡ لِيَبۡتَلِيَكُمۡۖ وَلَقَدۡ عَفَا عَنكُمۡۗ وَٱللَّهُ ذُو فَضۡلٍ عَلَى ٱلۡمُؤۡمِنِينَ",
    translation:
      "And Allah had certainly fulfilled His promise to you when you were killing the enemy by His permission until [the time] when you lost courage and fell to disputing about the order [given by the Prophet] and disobeyed after He had shown you that which you love. Among you are some who desire this world, and among you are some who desire the Hereafter. Then he turned you back from them [defeated] that He might test you. And He has already forgiven you, and Allah is the possessor of bounty for the believers",
    normalizedText:
      "ولقد صدقكم الله وعده اذ تحسونهم باذنه حتى اذا فشلتم وتنزعتم في الامر وعصيتم من بعد ما ارىكم ما تحبون منكم من يريد الدنيا ومنكم من يريد الاخرة ثم صرفكم عنهم ليبتليكم ولقد عفا عنكم والله ذو فضل على المامنين",
  },
  {
    verseId: 152,
    name: "آل عمران",
    surahId: 3,
    text: "۞إِذۡ تُصۡعِدُونَ وَلَا تَلۡوُۥنَ عَلَىٰٓ أَحَدٖ وَٱلرَّسُولُ يَدۡعُوكُمۡ فِيٓ أُخۡرَىٰكُمۡ فَأَثَٰبَكُمۡ غَمَّۢا بِغَمّٖ لِّكَيۡلَا تَحۡزَنُواْ عَلَىٰ مَا فَاتَكُمۡ وَلَا مَآ أَصَٰبَكُمۡۗ وَٱللَّهُ خَبِيرُۢ بِمَا تَعۡمَلُونَ",
    translation:
      "[Remember] when you [fled and] climbed [the mountain] without looking aside at anyone while the Messenger was calling you from behind. So Allah repaid you with distress upon distress so you would not grieve for that which had escaped you [of victory and spoils of war] or [for] that which had befallen you [of injury and death]. And Allah is [fully] Acquainted with what you do",
    normalizedText:
      "۞اذ تصعدون ولا تلون على احد والرسول يدعوكم في اخرىكم فاثبكم غما بغم لكيلا تحزنوا على ما فاتكم ولا ما اصبكم والله خبير بما تعملون",
  },
  {
    verseId: 153,
    name: "آل عمران",
    surahId: 3,
    text: "ثُمَّ أَنزَلَ عَلَيۡكُم مِّنۢ بَعۡدِ ٱلۡغَمِّ أَمَنَةٗ نُّعَاسٗا يَغۡشَىٰ طَآئِفَةٗ مِّنكُمۡۖ وَطَآئِفَةٞ قَدۡ أَهَمَّتۡهُمۡ أَنفُسُهُمۡ يَظُنُّونَ بِٱللَّهِ غَيۡرَ ٱلۡحَقِّ ظَنَّ ٱلۡجَٰهِلِيَّةِۖ يَقُولُونَ هَل لَّنَا مِنَ ٱلۡأَمۡرِ مِن شَيۡءٖۗ قُلۡ إِنَّ ٱلۡأَمۡرَ كُلَّهُۥ لِلَّهِۗ يُخۡفُونَ فِيٓ أَنفُسِهِم مَّا لَا يُبۡدُونَ لَكَۖ يَقُولُونَ لَوۡ كَانَ لَنَا مِنَ ٱلۡأَمۡرِ شَيۡءٞ مَّا قُتِلۡنَا هَٰهُنَاۗ قُل لَّوۡ كُنتُمۡ فِي بُيُوتِكُمۡ لَبَرَزَ ٱلَّذِينَ كُتِبَ عَلَيۡهِمُ ٱلۡقَتۡلُ إِلَىٰ مَضَاجِعِهِمۡۖ وَلِيَبۡتَلِيَ ٱللَّهُ مَا فِي صُدُورِكُمۡ وَلِيُمَحِّصَ مَا فِي قُلُوبِكُمۡۚ وَٱللَّهُ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      'Then after distress, He sent down upon you security [in the form of] drowsiness, overcoming a faction of you, while another faction worried about themselves, thinking of Allah other than the truth - the thought of ignorance, saying, "Is there anything for us [to have done] in this matter?" Say, "Indeed, the matter belongs completely to Allah." They conceal within themselves what they will not reveal to you. They say, "If there was anything we could have done in the matter, some of us would not have been killed right here." Say, "Even if you had been inside your houses, those decreed to be killed would have come out to their death beds." [It was] so that Allah might test what is in your breasts and purify what is in your hearts. And Allah is Knowing of that within the breasts',
    normalizedText:
      "ثم انزل عليكم من بعد الغم امنة نعاسا يغشى طاافة منكم وطاافة قد اهمتهم انفسهم يظنون بالله غير الحق ظن الجهلية يقولون هل لنا من الامر من شيء قل ان الامر كله لله يخفون في انفسهم ما لا يبدون لك يقولون لو كان لنا من الامر شيء ما قتلنا ههنا قل لو كنتم في بيوتكم لبرز الذين كتب عليهم القتل الى مضاجعهم وليبتلي الله ما في صدوركم وليمحص ما في قلوبكم والله عليم بذات الصدور",
  },
  {
    verseId: 154,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ تَوَلَّوۡاْ مِنكُمۡ يَوۡمَ ٱلۡتَقَى ٱلۡجَمۡعَانِ إِنَّمَا ٱسۡتَزَلَّهُمُ ٱلشَّيۡطَٰنُ بِبَعۡضِ مَا كَسَبُواْۖ وَلَقَدۡ عَفَا ٱللَّهُ عَنۡهُمۡۗ إِنَّ ٱللَّهَ غَفُورٌ حَلِيمٞ",
    translation:
      "Indeed, those of you who turned back on the day the two armies met, it was Satan who caused them to slip because of some [blame] they had earned. But Allah has already forgiven them. Indeed, Allah is Forgiving and Forbearing",
    normalizedText:
      "ان الذين تولوا منكم يوم التقى الجمعان انما استزلهم الشيطن ببعض ما كسبوا ولقد عفا الله عنهم ان الله غفور حليم",
  },
  {
    verseId: 155,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَكُونُواْ كَٱلَّذِينَ كَفَرُواْ وَقَالُواْ لِإِخۡوَٰنِهِمۡ إِذَا ضَرَبُواْ فِي ٱلۡأَرۡضِ أَوۡ كَانُواْ غُزّٗى لَّوۡ كَانُواْ عِندَنَا مَا مَاتُواْ وَمَا قُتِلُواْ لِيَجۡعَلَ ٱللَّهُ ذَٰلِكَ حَسۡرَةٗ فِي قُلُوبِهِمۡۗ وَٱللَّهُ يُحۡيِۦ وَيُمِيتُۗ وَٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      'O you who have believed, do not be like those who disbelieved and said about their brothers when they traveled through the land or went out to fight, "If they had been with us, they would not have died or have been killed," so Allah makes that [misconception] a regret within their hearts. And it is Allah who gives life and causes death, and Allah is Seeing of what you do',
    normalizedText:
      "يايها الذين ءامنوا لا تكونوا كالذين كفروا وقالوا لاخونهم اذا ضربوا في الارض او كانوا غزى لو كانوا عندنا ما ماتوا وما قتلوا ليجعل الله ذلك حسرة في قلوبهم والله يحي ويميت والله بما تعملون بصير",
  },
  {
    verseId: 156,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَئِن قُتِلۡتُمۡ فِي سَبِيلِ ٱللَّهِ أَوۡ مُتُّمۡ لَمَغۡفِرَةٞ مِّنَ ٱللَّهِ وَرَحۡمَةٌ خَيۡرٞ مِّمَّا يَجۡمَعُونَ",
    translation:
      "And if you are killed in the cause of Allah or die - then forgiveness from Allah and mercy are better than whatever they accumulate [in this world]",
    normalizedText:
      "ولان قتلتم في سبيل الله او متم لمغفرة من الله ورحمة خير مما يجمعون",
  },
  {
    verseId: 157,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَئِن مُّتُّمۡ أَوۡ قُتِلۡتُمۡ لَإِلَى ٱللَّهِ تُحۡشَرُونَ",
    translation:
      "And whether you die or are killed, unto Allah you will be gathered",
    normalizedText: "ولان متم او قتلتم لالى الله تحشرون",
  },
  {
    verseId: 158,
    name: "آل عمران",
    surahId: 3,
    text: "فَبِمَا رَحۡمَةٖ مِّنَ ٱللَّهِ لِنتَ لَهُمۡۖ وَلَوۡ كُنتَ فَظًّا غَلِيظَ ٱلۡقَلۡبِ لَٱنفَضُّواْ مِنۡ حَوۡلِكَۖ فَٱعۡفُ عَنۡهُمۡ وَٱسۡتَغۡفِرۡ لَهُمۡ وَشَاوِرۡهُمۡ فِي ٱلۡأَمۡرِۖ فَإِذَا عَزَمۡتَ فَتَوَكَّلۡ عَلَى ٱللَّهِۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُتَوَكِّلِينَ",
    translation:
      "So by mercy from Allah, [O Muhammad], you were lenient with them. And if you had been rude [in speech] and harsh in heart, they would have disbanded from about you. So pardon them and ask forgiveness for them and consult them in the matter. And when you have decided, then rely upon Allah. Indeed, Allah loves those who rely [upon Him]",
    normalizedText:
      "فبما رحمة من الله لنت لهم ولو كنت فظا غليظ القلب لانفضوا من حولك فاعف عنهم واستغفر لهم وشاورهم في الامر فاذا عزمت فتوكل على الله ان الله يحب المتوكلين",
  },
  {
    verseId: 159,
    name: "آل عمران",
    surahId: 3,
    text: "إِن يَنصُرۡكُمُ ٱللَّهُ فَلَا غَالِبَ لَكُمۡۖ وَإِن يَخۡذُلۡكُمۡ فَمَن ذَا ٱلَّذِي يَنصُرُكُم مِّنۢ بَعۡدِهِۦۗ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُؤۡمِنُونَ",
    translation:
      "If Allah should aid you, no one can overcome you; but if He should forsake you, who is there that can aid you after Him? And upon Allah let the believers rely",
    normalizedText:
      "ان ينصركم الله فلا غالب لكم وان يخذلكم فمن ذا الذي ينصركم من بعده وعلى الله فليتوكل المامنون",
  },
  {
    verseId: 160,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَا كَانَ لِنَبِيٍّ أَن يَغُلَّۚ وَمَن يَغۡلُلۡ يَأۡتِ بِمَا غَلَّ يَوۡمَ ٱلۡقِيَٰمَةِۚ ثُمَّ تُوَفَّىٰ كُلُّ نَفۡسٖ مَّا كَسَبَتۡ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "It is not [attributable] to any prophet that he would act unfaithfully [in regard to war booty]. And whoever betrays, [taking unlawfully], will come with what he took on the Day of Resurrection. Then will every soul be [fully] compensated for what it earned, and they will not be wronged",
    normalizedText:
      "وما كان لنبي ان يغل ومن يغلل يات بما غل يوم القيمة ثم توفى كل نفس ما كسبت وهم لا يظلمون",
  },
  {
    verseId: 161,
    name: "آل عمران",
    surahId: 3,
    text: "أَفَمَنِ ٱتَّبَعَ رِضۡوَٰنَ ٱللَّهِ كَمَنۢ بَآءَ بِسَخَطٖ مِّنَ ٱللَّهِ وَمَأۡوَىٰهُ جَهَنَّمُۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "So is one who pursues the pleasure of Allah like one who brings upon himself the anger of Allah and whose refuge is Hell? And wretched is the destination",
    normalizedText:
      "افمن اتبع رضون الله كمن باء بسخط من الله وماوىه جهنم وباس المصير",
  },
  {
    verseId: 162,
    name: "آل عمران",
    surahId: 3,
    text: "هُمۡ دَرَجَٰتٌ عِندَ ٱللَّهِۗ وَٱللَّهُ بَصِيرُۢ بِمَا يَعۡمَلُونَ",
    translation:
      "They are [varying] degrees in the sight of Allah, and Allah is Seeing of whatever they do",
    normalizedText: "هم درجت عند الله والله بصير بما يعملون",
  },
  {
    verseId: 163,
    name: "آل عمران",
    surahId: 3,
    text: "لَقَدۡ مَنَّ ٱللَّهُ عَلَى ٱلۡمُؤۡمِنِينَ إِذۡ بَعَثَ فِيهِمۡ رَسُولٗا مِّنۡ أَنفُسِهِمۡ يَتۡلُواْ عَلَيۡهِمۡ ءَايَٰتِهِۦ وَيُزَكِّيهِمۡ وَيُعَلِّمُهُمُ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَإِن كَانُواْ مِن قَبۡلُ لَفِي ضَلَٰلٖ مُّبِينٍ",
    translation:
      "Certainly did Allah confer [great] favor upon the believers when He sent among them a Messenger from themselves, reciting to them His verses and purifying them and teaching them the Book and wisdom, although they had been before in manifest error",
    normalizedText:
      "لقد من الله على المامنين اذ بعث فيهم رسولا من انفسهم يتلوا عليهم ءايته ويزكيهم ويعلمهم الكتب والحكمة وان كانوا من قبل لفي ضلل مبين",
  },
  {
    verseId: 164,
    name: "آل عمران",
    surahId: 3,
    text: "أَوَلَمَّآ أَصَٰبَتۡكُم مُّصِيبَةٞ قَدۡ أَصَبۡتُم مِّثۡلَيۡهَا قُلۡتُمۡ أَنَّىٰ هَٰذَاۖ قُلۡ هُوَ مِنۡ عِندِ أَنفُسِكُمۡۗ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'Why [is it that] when a [single] disaster struck you [on the day of Uhud], although you had struck [the enemy in the battle of Badr] with one twice as great, you said, "From where is this?" Say, "It is from yourselves." Indeed, Allah is over all things competent',
    normalizedText:
      "اولما اصبتكم مصيبة قد اصبتم مثليها قلتم انى هذا قل هو من عند انفسكم ان الله على كل شيء قدير",
  },
  {
    verseId: 165,
    name: "آل عمران",
    surahId: 3,
    text: "وَمَآ أَصَٰبَكُمۡ يَوۡمَ ٱلۡتَقَى ٱلۡجَمۡعَانِ فَبِإِذۡنِ ٱللَّهِ وَلِيَعۡلَمَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "And what struck you on the day the two armies met was by permission of Allah that He might make evident the [true] believers",
    normalizedText: "وما اصبكم يوم التقى الجمعان فباذن الله وليعلم المامنين",
  },
  {
    verseId: 166,
    name: "آل عمران",
    surahId: 3,
    text: "وَلِيَعۡلَمَ ٱلَّذِينَ نَافَقُواْۚ وَقِيلَ لَهُمۡ تَعَالَوۡاْ قَٰتِلُواْ فِي سَبِيلِ ٱللَّهِ أَوِ ٱدۡفَعُواْۖ قَالُواْ لَوۡ نَعۡلَمُ قِتَالٗا لَّٱتَّبَعۡنَٰكُمۡۗ هُمۡ لِلۡكُفۡرِ يَوۡمَئِذٍ أَقۡرَبُ مِنۡهُمۡ لِلۡإِيمَٰنِۚ يَقُولُونَ بِأَفۡوَٰهِهِم مَّا لَيۡسَ فِي قُلُوبِهِمۡۚ وَٱللَّهُ أَعۡلَمُ بِمَا يَكۡتُمُونَ",
    translation:
      'And that He might make evident those who are hypocrites. For it was said to them, "Come, fight in the way of Allah or [at least] defend." They said, "If we had known [there would be] fighting, we would have followed you." They were nearer to disbelief that day than to faith, saying with their mouths what was not in their hearts. And Allah is most Knowing of what they conceal',
    normalizedText:
      "وليعلم الذين نافقوا وقيل لهم تعالوا قتلوا في سبيل الله او ادفعوا قالوا لو نعلم قتالا لاتبعنكم هم للكفر يوماذ اقرب منهم للايمن يقولون بافوههم ما ليس في قلوبهم والله اعلم بما يكتمون",
  },
  {
    verseId: 167,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلَّذِينَ قَالُواْ لِإِخۡوَٰنِهِمۡ وَقَعَدُواْ لَوۡ أَطَاعُونَا مَا قُتِلُواْۗ قُلۡ فَٱدۡرَءُواْ عَنۡ أَنفُسِكُمُ ٱلۡمَوۡتَ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Those who said about their brothers while sitting [at home], "If they had obeyed us, they would not have been killed." Say, "Then prevent death from yourselves, if you should be truthful',
    normalizedText:
      "الذين قالوا لاخونهم وقعدوا لو اطاعونا ما قتلوا قل فادرءوا عن انفسكم الموت ان كنتم صدقين",
  },
  {
    verseId: 168,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا تَحۡسَبَنَّ ٱلَّذِينَ قُتِلُواْ فِي سَبِيلِ ٱللَّهِ أَمۡوَٰتَۢاۚ بَلۡ أَحۡيَآءٌ عِندَ رَبِّهِمۡ يُرۡزَقُونَ",
    translation:
      "And never think of those who have been killed in the cause of Allah as dead. Rather, they are alive with their Lord, receiving provision",
    normalizedText:
      "ولا تحسبن الذين قتلوا في سبيل الله اموتا بل احياء عند ربهم يرزقون",
  },
  {
    verseId: 169,
    name: "آل عمران",
    surahId: 3,
    text: "فَرِحِينَ بِمَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضۡلِهِۦ وَيَسۡتَبۡشِرُونَ بِٱلَّذِينَ لَمۡ يَلۡحَقُواْ بِهِم مِّنۡ خَلۡفِهِمۡ أَلَّا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Rejoicing in what Allah has bestowed upon them of His bounty, and they receive good tidings about those [to be martyred] after them who have not yet joined them - that there will be no fear concerning them, nor will they grieve",
    normalizedText:
      "فرحين بما ءاتىهم الله من فضله ويستبشرون بالذين لم يلحقوا بهم من خلفهم الا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 170,
    name: "آل عمران",
    surahId: 3,
    text: "۞يَسۡتَبۡشِرُونَ بِنِعۡمَةٖ مِّنَ ٱللَّهِ وَفَضۡلٖ وَأَنَّ ٱللَّهَ لَا يُضِيعُ أَجۡرَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "They receive good tidings of favor from Allah and bounty and [of the fact] that Allah does not allow the reward of believers to be lost",
    normalizedText:
      "۞يستبشرون بنعمة من الله وفضل وان الله لا يضيع اجر المامنين",
  },
  {
    verseId: 171,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلَّذِينَ ٱسۡتَجَابُواْ لِلَّهِ وَٱلرَّسُولِ مِنۢ بَعۡدِ مَآ أَصَابَهُمُ ٱلۡقَرۡحُۚ لِلَّذِينَ أَحۡسَنُواْ مِنۡهُمۡ وَٱتَّقَوۡاْ أَجۡرٌ عَظِيمٌ",
    translation:
      "Those [believers] who responded to Allah and the Messenger after injury had struck them. For those who did good among them and feared Allah is a great reward",
    normalizedText:
      "الذين استجابوا لله والرسول من بعد ما اصابهم القرح للذين احسنوا منهم واتقوا اجر عظيم",
  },
  {
    verseId: 172,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلَّذِينَ قَالَ لَهُمُ ٱلنَّاسُ إِنَّ ٱلنَّاسَ قَدۡ جَمَعُواْ لَكُمۡ فَٱخۡشَوۡهُمۡ فَزَادَهُمۡ إِيمَٰنٗا وَقَالُواْ حَسۡبُنَا ٱللَّهُ وَنِعۡمَ ٱلۡوَكِيلُ",
    translation:
      'Those to whom hypocrites said, "Indeed, the people have gathered against you, so fear them." But it [merely] increased them in faith, and they said, "Sufficient for us is Allah, and [He is] the best Disposer of affairs',
    normalizedText:
      "الذين قال لهم الناس ان الناس قد جمعوا لكم فاخشوهم فزادهم ايمنا وقالوا حسبنا الله ونعم الوكيل",
  },
  {
    verseId: 173,
    name: "آل عمران",
    surahId: 3,
    text: "فَٱنقَلَبُواْ بِنِعۡمَةٖ مِّنَ ٱللَّهِ وَفَضۡلٖ لَّمۡ يَمۡسَسۡهُمۡ سُوٓءٞ وَٱتَّبَعُواْ رِضۡوَٰنَ ٱللَّهِۗ وَٱللَّهُ ذُو فَضۡلٍ عَظِيمٍ",
    translation:
      "So they returned with favor from Allah and bounty, no harm having touched them. And they pursued the pleasure of Allah, and Allah is the possessor of great bounty",
    normalizedText:
      "فانقلبوا بنعمة من الله وفضل لم يمسسهم سوء واتبعوا رضون الله والله ذو فضل عظيم",
  },
  {
    verseId: 174,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّمَا ذَٰلِكُمُ ٱلشَّيۡطَٰنُ يُخَوِّفُ أَوۡلِيَآءَهُۥ فَلَا تَخَافُوهُمۡ وَخَافُونِ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "That is only Satan who frightens [you] of his supporters. So fear them not, but fear Me, if you are [indeed] believers",
    normalizedText:
      "انما ذلكم الشيطن يخوف اولياءه فلا تخافوهم وخافون ان كنتم مامنين",
  },
  {
    verseId: 175,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا يَحۡزُنكَ ٱلَّذِينَ يُسَٰرِعُونَ فِي ٱلۡكُفۡرِۚ إِنَّهُمۡ لَن يَضُرُّواْ ٱللَّهَ شَيۡـٔٗاۚ يُرِيدُ ٱللَّهُ أَلَّا يَجۡعَلَ لَهُمۡ حَظّٗا فِي ٱلۡأٓخِرَةِۖ وَلَهُمۡ عَذَابٌ عَظِيمٌ",
    translation:
      "And do not be grieved, [O Muhammad], by those who hasten into disbelief. Indeed, they will never harm Allah at all. Allah intends that He should give them no share in the Hereafter, and for them is a great punishment",
    normalizedText:
      "ولا يحزنك الذين يسرعون في الكفر انهم لن يضروا الله شيا يريد الله الا يجعل لهم حظا في الاخرة ولهم عذاب عظيم",
  },
  {
    verseId: 176,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ ٱلَّذِينَ ٱشۡتَرَوُاْ ٱلۡكُفۡرَ بِٱلۡإِيمَٰنِ لَن يَضُرُّواْ ٱللَّهَ شَيۡـٔٗاۖ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "Indeed, those who purchase disbelief [in exchange] for faith - never will they harm Allah at all, and for them is a painful punishment",
    normalizedText:
      "ان الذين اشتروا الكفر بالايمن لن يضروا الله شيا ولهم عذاب اليم",
  },
  {
    verseId: 177,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا يَحۡسَبَنَّ ٱلَّذِينَ كَفَرُوٓاْ أَنَّمَا نُمۡلِي لَهُمۡ خَيۡرٞ لِّأَنفُسِهِمۡۚ إِنَّمَا نُمۡلِي لَهُمۡ لِيَزۡدَادُوٓاْ إِثۡمٗاۖ وَلَهُمۡ عَذَابٞ مُّهِينٞ",
    translation:
      "And let not those who disbelieve ever think that [because] We extend their time [of enjoyment] it is better for them. We only extend it for them so that they may increase in sin, and for them is a humiliating punishment",
    normalizedText:
      "ولا يحسبن الذين كفروا انما نملي لهم خير لانفسهم انما نملي لهم ليزدادوا اثما ولهم عذاب مهين",
  },
  {
    verseId: 178,
    name: "آل عمران",
    surahId: 3,
    text: "مَّا كَانَ ٱللَّهُ لِيَذَرَ ٱلۡمُؤۡمِنِينَ عَلَىٰ مَآ أَنتُمۡ عَلَيۡهِ حَتَّىٰ يَمِيزَ ٱلۡخَبِيثَ مِنَ ٱلطَّيِّبِۗ وَمَا كَانَ ٱللَّهُ لِيُطۡلِعَكُمۡ عَلَى ٱلۡغَيۡبِ وَلَٰكِنَّ ٱللَّهَ يَجۡتَبِي مِن رُّسُلِهِۦ مَن يَشَآءُۖ فَـَٔامِنُواْ بِٱللَّهِ وَرُسُلِهِۦۚ وَإِن تُؤۡمِنُواْ وَتَتَّقُواْ فَلَكُمۡ أَجۡرٌ عَظِيمٞ",
    translation:
      "Allah would not leave the believers in that [state] you are in [presently] until He separates the evil from the good. Nor would Allah reveal to you the unseen. But [instead], Allah chooses of His messengers whom He wills, so believe in Allah and His messengers. And if you believe and fear Him, then for you is a great reward",
    normalizedText:
      "ما كان الله ليذر المامنين على ما انتم عليه حتى يميز الخبيث من الطيب وما كان الله ليطلعكم على الغيب ولكن الله يجتبي من رسله من يشاء فامنوا بالله ورسله وان تامنوا وتتقوا فلكم اجر عظيم",
  },
  {
    verseId: 179,
    name: "آل عمران",
    surahId: 3,
    text: "وَلَا يَحۡسَبَنَّ ٱلَّذِينَ يَبۡخَلُونَ بِمَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضۡلِهِۦ هُوَ خَيۡرٗا لَّهُمۖ بَلۡ هُوَ شَرّٞ لَّهُمۡۖ سَيُطَوَّقُونَ مَا بَخِلُواْ بِهِۦ يَوۡمَ ٱلۡقِيَٰمَةِۗ وَلِلَّهِ مِيرَٰثُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۗ وَٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      "And let not those who [greedily] withhold what Allah has given them of His bounty ever think that it is better for them. Rather, it is worse for them. Their necks will be encircled by what they withheld on the Day of Resurrection. And to Allah belongs the heritage of the heavens and the earth. And Allah, with what you do, is [fully] Acquainted",
    normalizedText:
      "ولا يحسبن الذين يبخلون بما ءاتىهم الله من فضله هو خيرا لهم بل هو شر لهم سيطوقون ما بخلوا به يوم القيمة ولله ميرث السموت والارض والله بما تعملون خبير",
  },
  {
    verseId: 180,
    name: "آل عمران",
    surahId: 3,
    text: "لَّقَدۡ سَمِعَ ٱللَّهُ قَوۡلَ ٱلَّذِينَ قَالُوٓاْ إِنَّ ٱللَّهَ فَقِيرٞ وَنَحۡنُ أَغۡنِيَآءُۘ سَنَكۡتُبُ مَا قَالُواْ وَقَتۡلَهُمُ ٱلۡأَنۢبِيَآءَ بِغَيۡرِ حَقّٖ وَنَقُولُ ذُوقُواْ عَذَابَ ٱلۡحَرِيقِ",
    translation:
      'Allah has certainly heard the statement of those [Jews] who said, "Indeed, Allah is poor, while we are rich." We will record what they said and their killing of the prophets without right and will say, "Taste the punishment of the Burning Fire',
    normalizedText:
      "لقد سمع الله قول الذين قالوا ان الله فقير ونحن اغنياء سنكتب ما قالوا وقتلهم الانبياء بغير حق ونقول ذوقوا عذاب الحريق",
  },
  {
    verseId: 181,
    name: "آل عمران",
    surahId: 3,
    text: "ذَٰلِكَ بِمَا قَدَّمَتۡ أَيۡدِيكُمۡ وَأَنَّ ٱللَّهَ لَيۡسَ بِظَلَّامٖ لِّلۡعَبِيدِ",
    translation:
      "That is for what your hands have put forth and because Allah is not ever unjust to [His] servants",
    normalizedText: "ذلك بما قدمت ايديكم وان الله ليس بظلام للعبيد",
  },
  {
    verseId: 182,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلَّذِينَ قَالُوٓاْ إِنَّ ٱللَّهَ عَهِدَ إِلَيۡنَآ أَلَّا نُؤۡمِنَ لِرَسُولٍ حَتَّىٰ يَأۡتِيَنَا بِقُرۡبَانٖ تَأۡكُلُهُ ٱلنَّارُۗ قُلۡ قَدۡ جَآءَكُمۡ رُسُلٞ مِّن قَبۡلِي بِٱلۡبَيِّنَٰتِ وَبِٱلَّذِي قُلۡتُمۡ فَلِمَ قَتَلۡتُمُوهُمۡ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      '[They are] those who said, "Indeed, Allah has taken our promise not to believe any messenger until he brings us an offering which fire [from heaven] will consume." Say, "There have already come to you messengers before me with clear proofs and [even] that of which you speak. So why did you kill them, if you should be truthful',
    normalizedText:
      "الذين قالوا ان الله عهد الينا الا نامن لرسول حتى ياتينا بقربان تاكله النار قل قد جاءكم رسل من قبلي بالبينت وبالذي قلتم فلم قتلتموهم ان كنتم صدقين",
  },
  {
    verseId: 183,
    name: "آل عمران",
    surahId: 3,
    text: "فَإِن كَذَّبُوكَ فَقَدۡ كُذِّبَ رُسُلٞ مِّن قَبۡلِكَ جَآءُو بِٱلۡبَيِّنَٰتِ وَٱلزُّبُرِ وَٱلۡكِتَٰبِ ٱلۡمُنِيرِ",
    translation:
      "Then if they deny you, [O Muhammad] - so were messengers denied before you, who brought clear proofs and written ordinances and the enlightening Scripture",
    normalizedText:
      "فان كذبوك فقد كذب رسل من قبلك جاءو بالبينت والزبر والكتب المنير",
  },
  {
    verseId: 184,
    name: "آل عمران",
    surahId: 3,
    text: "كُلُّ نَفۡسٖ ذَآئِقَةُ ٱلۡمَوۡتِۗ وَإِنَّمَا تُوَفَّوۡنَ أُجُورَكُمۡ يَوۡمَ ٱلۡقِيَٰمَةِۖ فَمَن زُحۡزِحَ عَنِ ٱلنَّارِ وَأُدۡخِلَ ٱلۡجَنَّةَ فَقَدۡ فَازَۗ وَمَا ٱلۡحَيَوٰةُ ٱلدُّنۡيَآ إِلَّا مَتَٰعُ ٱلۡغُرُورِ",
    translation:
      "Every soul will taste death, and you will only be given your [full] compensation on the Day of Resurrection. So he who is drawn away from the Fire and admitted to Paradise has attained [his desire]. And what is the life of this world except the enjoyment of delusion",
    normalizedText:
      "كل نفس ذااقة الموت وانما توفون اجوركم يوم القيمة فمن زحزح عن النار وادخل الجنة فقد فاز وما الحيوة الدنيا الا متع الغرور",
  },
  {
    verseId: 185,
    name: "آل عمران",
    surahId: 3,
    text: "۞لَتُبۡلَوُنَّ فِيٓ أَمۡوَٰلِكُمۡ وَأَنفُسِكُمۡ وَلَتَسۡمَعُنَّ مِنَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ مِن قَبۡلِكُمۡ وَمِنَ ٱلَّذِينَ أَشۡرَكُوٓاْ أَذٗى كَثِيرٗاۚ وَإِن تَصۡبِرُواْ وَتَتَّقُواْ فَإِنَّ ذَٰلِكَ مِنۡ عَزۡمِ ٱلۡأُمُورِ",
    translation:
      "You will surely be tested in your possessions and in yourselves. And you will surely hear from those who were given the Scripture before you and from those who associate others with Allah much abuse. But if you are patient and fear Allah - indeed, that is of the matters [worthy] of determination",
    normalizedText:
      "۞لتبلون في امولكم وانفسكم ولتسمعن من الذين اوتوا الكتب من قبلكم ومن الذين اشركوا اذى كثيرا وان تصبروا وتتقوا فان ذلك من عزم الامور",
  },
  {
    verseId: 186,
    name: "آل عمران",
    surahId: 3,
    text: "وَإِذۡ أَخَذَ ٱللَّهُ مِيثَٰقَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ لَتُبَيِّنُنَّهُۥ لِلنَّاسِ وَلَا تَكۡتُمُونَهُۥ فَنَبَذُوهُ وَرَآءَ ظُهُورِهِمۡ وَٱشۡتَرَوۡاْ بِهِۦ ثَمَنٗا قَلِيلٗاۖ فَبِئۡسَ مَا يَشۡتَرُونَ",
    translation:
      'And [mention, O Muhammad], when Allah took a covenant from those who were given the Scripture, [saying], "You must make it clear to the people and not conceal it." But they threw it away behind their backs and exchanged it for a small price. And wretched is that which they purchased',
    normalizedText:
      "واذ اخذ الله ميثق الذين اوتوا الكتب لتبيننه للناس ولا تكتمونه فنبذوه وراء ظهورهم واشتروا به ثمنا قليلا فباس ما يشترون",
  },
  {
    verseId: 187,
    name: "آل عمران",
    surahId: 3,
    text: "لَا تَحۡسَبَنَّ ٱلَّذِينَ يَفۡرَحُونَ بِمَآ أَتَواْ وَّيُحِبُّونَ أَن يُحۡمَدُواْ بِمَا لَمۡ يَفۡعَلُواْ فَلَا تَحۡسَبَنَّهُم بِمَفَازَةٖ مِّنَ ٱلۡعَذَابِۖ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "And never think that those who rejoice in what they have perpetrated and like to be praised for what they did not do - never think them [to be] in safety from the punishment, and for them is a painful punishment",
    normalizedText:
      "لا تحسبن الذين يفرحون بما اتوا ويحبون ان يحمدوا بما لم يفعلوا فلا تحسبنهم بمفازة من العذاب ولهم عذاب اليم",
  },
  {
    verseId: 188,
    name: "آل عمران",
    surahId: 3,
    text: "وَلِلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۗ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "And to Allah belongs the dominion of the heavens and the earth, and Allah is over all things competent",
    normalizedText: "ولله ملك السموت والارض والله على كل شيء قدير",
  },
  {
    verseId: 189,
    name: "آل عمران",
    surahId: 3,
    text: "إِنَّ فِي خَلۡقِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَٱخۡتِلَٰفِ ٱلَّيۡلِ وَٱلنَّهَارِ لَأٓيَٰتٖ لِّأُوْلِي ٱلۡأَلۡبَٰبِ",
    translation:
      "Indeed, in the creation of the heavens and the earth and the alternation of the night and the day are signs for those of understanding",
    normalizedText:
      "ان في خلق السموت والارض واختلف اليل والنهار لايت لاولي الالبب",
  },
  {
    verseId: 190,
    name: "آل عمران",
    surahId: 3,
    text: "ٱلَّذِينَ يَذۡكُرُونَ ٱللَّهَ قِيَٰمٗا وَقُعُودٗا وَعَلَىٰ جُنُوبِهِمۡ وَيَتَفَكَّرُونَ فِي خَلۡقِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ رَبَّنَا مَا خَلَقۡتَ هَٰذَا بَٰطِلٗا سُبۡحَٰنَكَ فَقِنَا عَذَابَ ٱلنَّارِ",
    translation:
      'Who remember Allah while standing or sitting or [lying] on their sides and give thought to the creation of the heavens and the earth, [saying], "Our Lord, You did not create this aimlessly; exalted are You [above such a thing]; then protect us from the punishment of the Fire',
    normalizedText:
      "الذين يذكرون الله قيما وقعودا وعلى جنوبهم ويتفكرون في خلق السموت والارض ربنا ما خلقت هذا بطلا سبحنك فقنا عذاب النار",
  },
  {
    verseId: 191,
    name: "آل عمران",
    surahId: 3,
    text: "رَبَّنَآ إِنَّكَ مَن تُدۡخِلِ ٱلنَّارَ فَقَدۡ أَخۡزَيۡتَهُۥۖ وَمَا لِلظَّـٰلِمِينَ مِنۡ أَنصَارٖ",
    translation:
      "Our Lord, indeed whoever You admit to the Fire - You have disgraced him, and for the wrongdoers there are no helpers",
    normalizedText: "ربنا انك من تدخل النار فقد اخزيته وما للظلمين من انصار",
  },
  {
    verseId: 192,
    name: "آل عمران",
    surahId: 3,
    text: "رَّبَّنَآ إِنَّنَا سَمِعۡنَا مُنَادِيٗا يُنَادِي لِلۡإِيمَٰنِ أَنۡ ءَامِنُواْ بِرَبِّكُمۡ فَـَٔامَنَّاۚ رَبَّنَا فَٱغۡفِرۡ لَنَا ذُنُوبَنَا وَكَفِّرۡ عَنَّا سَيِّـَٔاتِنَا وَتَوَفَّنَا مَعَ ٱلۡأَبۡرَارِ",
    translation:
      "Our Lord, indeed we have heard a caller calling to faith, [saying], 'Believe in your Lord,' and we have believed. Our Lord, so forgive us our sins and remove from us our misdeeds and cause us to die with the righteous",
    normalizedText:
      "ربنا اننا سمعنا مناديا ينادي للايمن ان ءامنوا بربكم فامنا ربنا فاغفر لنا ذنوبنا وكفر عنا سياتنا وتوفنا مع الابرار",
  },
  {
    verseId: 193,
    name: "آل عمران",
    surahId: 3,
    text: "رَبَّنَا وَءَاتِنَا مَا وَعَدتَّنَا عَلَىٰ رُسُلِكَ وَلَا تُخۡزِنَا يَوۡمَ ٱلۡقِيَٰمَةِۖ إِنَّكَ لَا تُخۡلِفُ ٱلۡمِيعَادَ",
    translation:
      "Our Lord, and grant us what You promised us through Your messengers and do not disgrace us on the Day of Resurrection. Indeed, You do not fail in [Your] promise",
    normalizedText:
      "ربنا وءاتنا ما وعدتنا على رسلك ولا تخزنا يوم القيمة انك لا تخلف الميعاد",
  },
  {
    verseId: 194,
    name: "آل عمران",
    surahId: 3,
    text: "فَٱسۡتَجَابَ لَهُمۡ رَبُّهُمۡ أَنِّي لَآ أُضِيعُ عَمَلَ عَٰمِلٖ مِّنكُم مِّن ذَكَرٍ أَوۡ أُنثَىٰۖ بَعۡضُكُم مِّنۢ بَعۡضٖۖ فَٱلَّذِينَ هَاجَرُواْ وَأُخۡرِجُواْ مِن دِيَٰرِهِمۡ وَأُوذُواْ فِي سَبِيلِي وَقَٰتَلُواْ وَقُتِلُواْ لَأُكَفِّرَنَّ عَنۡهُمۡ سَيِّـَٔاتِهِمۡ وَلَأُدۡخِلَنَّهُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ ثَوَابٗا مِّنۡ عِندِ ٱللَّهِۚ وَٱللَّهُ عِندَهُۥ حُسۡنُ ٱلثَّوَابِ",
    translation:
      'And their Lord responded to them, "Never will I allow to be lost the work of [any] worker among you, whether male or female; you are of one another. So those who emigrated or were evicted from their homes or were harmed in My cause or fought or were killed - I will surely remove from them their misdeeds, and I will surely admit them to gardens beneath which rivers flow as reward from Allah, and Allah has with Him the best reward',
    normalizedText:
      "فاستجاب لهم ربهم اني لا اضيع عمل عمل منكم من ذكر او انثى بعضكم من بعض فالذين هاجروا واخرجوا من ديرهم واوذوا في سبيلي وقتلوا وقتلوا لاكفرن عنهم سياتهم ولادخلنهم جنت تجري من تحتها الانهر ثوابا من عند الله والله عنده حسن الثواب",
  },
  {
    verseId: 195,
    name: "آل عمران",
    surahId: 3,
    text: "لَا يَغُرَّنَّكَ تَقَلُّبُ ٱلَّذِينَ كَفَرُواْ فِي ٱلۡبِلَٰدِ",
    translation:
      "Be not deceived by the [uninhibited] movement of the disbelievers throughout the land",
    normalizedText: "لا يغرنك تقلب الذين كفروا في البلد",
  },
  {
    verseId: 196,
    name: "آل عمران",
    surahId: 3,
    text: "مَتَٰعٞ قَلِيلٞ ثُمَّ مَأۡوَىٰهُمۡ جَهَنَّمُۖ وَبِئۡسَ ٱلۡمِهَادُ",
    translation:
      "[It is but] a small enjoyment; then their [final] refuge is Hell, and wretched is the resting place",
    normalizedText: "متع قليل ثم ماوىهم جهنم وباس المهاد",
  },
  {
    verseId: 197,
    name: "آل عمران",
    surahId: 3,
    text: "لَٰكِنِ ٱلَّذِينَ ٱتَّقَوۡاْ رَبَّهُمۡ لَهُمۡ جَنَّـٰتٞ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَا نُزُلٗا مِّنۡ عِندِ ٱللَّهِۗ وَمَا عِندَ ٱللَّهِ خَيۡرٞ لِّلۡأَبۡرَارِ",
    translation:
      "But those who feared their Lord will have gardens beneath which rivers flow, abiding eternally therein, as accommodation from Allah. And that which is with Allah is best for the righteous",
    normalizedText:
      "لكن الذين اتقوا ربهم لهم جنت تجري من تحتها الانهر خلدين فيها نزلا من عند الله وما عند الله خير للابرار",
  },
  {
    verseId: 198,
    name: "آل عمران",
    surahId: 3,
    text: "وَإِنَّ مِنۡ أَهۡلِ ٱلۡكِتَٰبِ لَمَن يُؤۡمِنُ بِٱللَّهِ وَمَآ أُنزِلَ إِلَيۡكُمۡ وَمَآ أُنزِلَ إِلَيۡهِمۡ خَٰشِعِينَ لِلَّهِ لَا يَشۡتَرُونَ بِـَٔايَٰتِ ٱللَّهِ ثَمَنٗا قَلِيلًاۚ أُوْلَـٰٓئِكَ لَهُمۡ أَجۡرُهُمۡ عِندَ رَبِّهِمۡۗ إِنَّ ٱللَّهَ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      "And indeed, among the People of the Scripture are those who believe in Allah and what was revealed to you and what was revealed to them, [being] humbly submissive to Allah. They do not exchange the verses of Allah for a small price. Those will have their reward with their Lord. Indeed, Allah is swift in account",
    normalizedText:
      "وان من اهل الكتب لمن يامن بالله وما انزل اليكم وما انزل اليهم خشعين لله لا يشترون بايت الله ثمنا قليلا اولاك لهم اجرهم عند ربهم ان الله سريع الحساب",
  },
  {
    verseId: 199,
    name: "آل عمران",
    surahId: 3,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱصۡبِرُواْ وَصَابِرُواْ وَرَابِطُواْ وَٱتَّقُواْ ٱللَّهَ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "O you who have believed, persevere and endure and remain stationed and fear Allah that you may be successful",
    normalizedText:
      "يايها الذين ءامنوا اصبروا وصابروا ورابطوا واتقوا الله لعلكم تفلحون",
  },
  {
    verseId: 0,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُواْ رَبَّكُمُ ٱلَّذِي خَلَقَكُم مِّن نَّفۡسٖ وَٰحِدَةٖ وَخَلَقَ مِنۡهَا زَوۡجَهَا وَبَثَّ مِنۡهُمَا رِجَالٗا كَثِيرٗا وَنِسَآءٗۚ وَٱتَّقُواْ ٱللَّهَ ٱلَّذِي تَسَآءَلُونَ بِهِۦ وَٱلۡأَرۡحَامَۚ إِنَّ ٱللَّهَ كَانَ عَلَيۡكُمۡ رَقِيبٗا",
    translation:
      "O mankind, fear your Lord, who created you from one soul and created from it its mate and dispersed from both of them many men and women. And fear Allah, through whom you ask one another, and the wombs. Indeed Allah is ever, over you, an Observer",
    normalizedText:
      "يايها الناس اتقوا ربكم الذي خلقكم من نفس وحدة وخلق منها زوجها وبث منهما رجالا كثيرا ونساء واتقوا الله الذي تساءلون به والارحام ان الله كان عليكم رقيبا",
  },
  {
    verseId: 1,
    name: "النساء",
    surahId: 4,
    text: "وَءَاتُواْ ٱلۡيَتَٰمَىٰٓ أَمۡوَٰلَهُمۡۖ وَلَا تَتَبَدَّلُواْ ٱلۡخَبِيثَ بِٱلطَّيِّبِۖ وَلَا تَأۡكُلُوٓاْ أَمۡوَٰلَهُمۡ إِلَىٰٓ أَمۡوَٰلِكُمۡۚ إِنَّهُۥ كَانَ حُوبٗا كَبِيرٗا",
    translation:
      "And give to the orphans their properties and do not substitute the defective [of your own] for the good [of theirs]. And do not consume their properties into your own. Indeed, that is ever a great sin",
    normalizedText:
      "وءاتوا اليتمى امولهم ولا تتبدلوا الخبيث بالطيب ولا تاكلوا امولهم الى امولكم انه كان حوبا كبيرا",
  },
  {
    verseId: 2,
    name: "النساء",
    surahId: 4,
    text: "وَإِنۡ خِفۡتُمۡ أَلَّا تُقۡسِطُواْ فِي ٱلۡيَتَٰمَىٰ فَٱنكِحُواْ مَا طَابَ لَكُم مِّنَ ٱلنِّسَآءِ مَثۡنَىٰ وَثُلَٰثَ وَرُبَٰعَۖ فَإِنۡ خِفۡتُمۡ أَلَّا تَعۡدِلُواْ فَوَٰحِدَةً أَوۡ مَا مَلَكَتۡ أَيۡمَٰنُكُمۡۚ ذَٰلِكَ أَدۡنَىٰٓ أَلَّا تَعُولُواْ",
    translation:
      "And if you fear that you will not deal justly with the orphan girls, then marry those that please you of [other] women, two or three or four. But if you fear that you will not be just, then [marry only] one or those your right hand possesses. That is more suitable that you may not incline [to injustice]",
    normalizedText:
      "وان خفتم الا تقسطوا في اليتمى فانكحوا ما طاب لكم من النساء مثنى وثلث وربع فان خفتم الا تعدلوا فوحدة او ما ملكت ايمنكم ذلك ادنى الا تعولوا",
  },
  {
    verseId: 3,
    name: "النساء",
    surahId: 4,
    text: "وَءَاتُواْ ٱلنِّسَآءَ صَدُقَٰتِهِنَّ نِحۡلَةٗۚ فَإِن طِبۡنَ لَكُمۡ عَن شَيۡءٖ مِّنۡهُ نَفۡسٗا فَكُلُوهُ هَنِيٓـٔٗا مَّرِيٓـٔٗا",
    translation:
      "And give the women [upon marriage] their [bridal] gifts graciously. But if they give up willingly to you anything of it, then take it in satisfaction and ease",
    normalizedText:
      "وءاتوا النساء صدقتهن نحلة فان طبن لكم عن شيء منه نفسا فكلوه هنيا مريا",
  },
  {
    verseId: 4,
    name: "النساء",
    surahId: 4,
    text: "وَلَا تُؤۡتُواْ ٱلسُّفَهَآءَ أَمۡوَٰلَكُمُ ٱلَّتِي جَعَلَ ٱللَّهُ لَكُمۡ قِيَٰمٗا وَٱرۡزُقُوهُمۡ فِيهَا وَٱكۡسُوهُمۡ وَقُولُواْ لَهُمۡ قَوۡلٗا مَّعۡرُوفٗا",
    translation:
      "And do not give the weak-minded your property, which Allah has made a means of sustenance for you, but provide for them with it and clothe them and speak to them words of appropriate kindness",
    normalizedText:
      "ولا تاتوا السفهاء امولكم التي جعل الله لكم قيما وارزقوهم فيها واكسوهم وقولوا لهم قولا معروفا",
  },
  {
    verseId: 5,
    name: "النساء",
    surahId: 4,
    text: "وَٱبۡتَلُواْ ٱلۡيَتَٰمَىٰ حَتَّىٰٓ إِذَا بَلَغُواْ ٱلنِّكَاحَ فَإِنۡ ءَانَسۡتُم مِّنۡهُمۡ رُشۡدٗا فَٱدۡفَعُوٓاْ إِلَيۡهِمۡ أَمۡوَٰلَهُمۡۖ وَلَا تَأۡكُلُوهَآ إِسۡرَافٗا وَبِدَارًا أَن يَكۡبَرُواْۚ وَمَن كَانَ غَنِيّٗا فَلۡيَسۡتَعۡفِفۡۖ وَمَن كَانَ فَقِيرٗا فَلۡيَأۡكُلۡ بِٱلۡمَعۡرُوفِۚ فَإِذَا دَفَعۡتُمۡ إِلَيۡهِمۡ أَمۡوَٰلَهُمۡ فَأَشۡهِدُواْ عَلَيۡهِمۡۚ وَكَفَىٰ بِٱللَّهِ حَسِيبٗا",
    translation:
      "And test the orphans [in their abilities] until they reach marriageable age. Then if you perceive in them sound judgement, release their property to them. And do not consume it excessively and quickly, [anticipating] that they will grow up. And whoever, [when acting as guardian], is self-sufficient should refrain [from taking a fee]; and whoever is poor - let him take according to what is acceptable. Then when you release their property to them, bring witnesses upon them. And sufficient is Allah as Accountant",
    normalizedText:
      "وابتلوا اليتمى حتى اذا بلغوا النكاح فان ءانستم منهم رشدا فادفعوا اليهم امولهم ولا تاكلوها اسرافا وبدارا ان يكبروا ومن كان غنيا فليستعفف ومن كان فقيرا فلياكل بالمعروف فاذا دفعتم اليهم امولهم فاشهدوا عليهم وكفى بالله حسيبا",
  },
  {
    verseId: 6,
    name: "النساء",
    surahId: 4,
    text: "لِّلرِّجَالِ نَصِيبٞ مِّمَّا تَرَكَ ٱلۡوَٰلِدَانِ وَٱلۡأَقۡرَبُونَ وَلِلنِّسَآءِ نَصِيبٞ مِّمَّا تَرَكَ ٱلۡوَٰلِدَانِ وَٱلۡأَقۡرَبُونَ مِمَّا قَلَّ مِنۡهُ أَوۡ كَثُرَۚ نَصِيبٗا مَّفۡرُوضٗا",
    translation:
      "For men is a share of what the parents and close relatives leave, and for women is a share of what the parents and close relatives leave, be it little or much - an obligatory share",
    normalizedText:
      "للرجال نصيب مما ترك الولدان والاقربون وللنساء نصيب مما ترك الولدان والاقربون مما قل منه او كثر نصيبا مفروضا",
  },
  {
    verseId: 7,
    name: "النساء",
    surahId: 4,
    text: "وَإِذَا حَضَرَ ٱلۡقِسۡمَةَ أُوْلُواْ ٱلۡقُرۡبَىٰ وَٱلۡيَتَٰمَىٰ وَٱلۡمَسَٰكِينُ فَٱرۡزُقُوهُم مِّنۡهُ وَقُولُواْ لَهُمۡ قَوۡلٗا مَّعۡرُوفٗا",
    translation:
      "And when [other] relatives and orphans and the needy are present at the [time of] division, then provide for them [something] out of the estate and speak to them words of appropriate kindness",
    normalizedText:
      "واذا حضر القسمة اولوا القربى واليتمى والمسكين فارزقوهم منه وقولوا لهم قولا معروفا",
  },
  {
    verseId: 8,
    name: "النساء",
    surahId: 4,
    text: "وَلۡيَخۡشَ ٱلَّذِينَ لَوۡ تَرَكُواْ مِنۡ خَلۡفِهِمۡ ذُرِّيَّةٗ ضِعَٰفًا خَافُواْ عَلَيۡهِمۡ فَلۡيَتَّقُواْ ٱللَّهَ وَلۡيَقُولُواْ قَوۡلٗا سَدِيدًا",
    translation:
      "And let those [executors and guardians] fear [injustice] as if they [themselves] had left weak offspring behind and feared for them. So let them fear Allah and speak words of appropriate justice",
    normalizedText:
      "وليخش الذين لو تركوا من خلفهم ذرية ضعفا خافوا عليهم فليتقوا الله وليقولوا قولا سديدا",
  },
  {
    verseId: 9,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلَّذِينَ يَأۡكُلُونَ أَمۡوَٰلَ ٱلۡيَتَٰمَىٰ ظُلۡمًا إِنَّمَا يَأۡكُلُونَ فِي بُطُونِهِمۡ نَارٗاۖ وَسَيَصۡلَوۡنَ سَعِيرٗا",
    translation:
      "Indeed, those who devour the property of orphans unjustly are only consuming into their bellies fire. And they will be burned in a Blaze",
    normalizedText:
      "ان الذين ياكلون امول اليتمى ظلما انما ياكلون في بطونهم نارا وسيصلون سعيرا",
  },
  {
    verseId: 10,
    name: "النساء",
    surahId: 4,
    text: "يُوصِيكُمُ ٱللَّهُ فِيٓ أَوۡلَٰدِكُمۡۖ لِلذَّكَرِ مِثۡلُ حَظِّ ٱلۡأُنثَيَيۡنِۚ فَإِن كُنَّ نِسَآءٗ فَوۡقَ ٱثۡنَتَيۡنِ فَلَهُنَّ ثُلُثَا مَا تَرَكَۖ وَإِن كَانَتۡ وَٰحِدَةٗ فَلَهَا ٱلنِّصۡفُۚ وَلِأَبَوَيۡهِ لِكُلِّ وَٰحِدٖ مِّنۡهُمَا ٱلسُّدُسُ مِمَّا تَرَكَ إِن كَانَ لَهُۥ وَلَدٞۚ فَإِن لَّمۡ يَكُن لَّهُۥ وَلَدٞ وَوَرِثَهُۥٓ أَبَوَاهُ فَلِأُمِّهِ ٱلثُّلُثُۚ فَإِن كَانَ لَهُۥٓ إِخۡوَةٞ فَلِأُمِّهِ ٱلسُّدُسُۚ مِنۢ بَعۡدِ وَصِيَّةٖ يُوصِي بِهَآ أَوۡ دَيۡنٍۗ ءَابَآؤُكُمۡ وَأَبۡنَآؤُكُمۡ لَا تَدۡرُونَ أَيُّهُمۡ أَقۡرَبُ لَكُمۡ نَفۡعٗاۚ فَرِيضَةٗ مِّنَ ٱللَّهِۗ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمٗا",
    translation:
      "Allah instructs you concerning your children: for the male, what is equal to the share of two females. But if there are [only] daughters, two or more, for them is two thirds of one's estate. And if there is only one, for her is half. And for one's parents, to each one of them is a sixth of his estate if he left children. But if he had no children and the parents [alone] inherit from him, then for his mother is one third. And if he had brothers [or sisters], for his mother is a sixth, after any bequest he [may have] made or debt. Your parents or your children - you know not which of them are nearest to you in benefit. [These shares are] an obligation [imposed] by Allah. Indeed, Allah is ever Knowing and Wise",
    normalizedText:
      "يوصيكم الله في اولدكم للذكر مثل حظ الانثيين فان كن نساء فوق اثنتين فلهن ثلثا ما ترك وان كانت وحدة فلها النصف ولابويه لكل وحد منهما السدس مما ترك ان كان له ولد فان لم يكن له ولد وورثه ابواه فلامه الثلث فان كان له اخوة فلامه السدس من بعد وصية يوصي بها او دين ءابااكم وابنااكم لا تدرون ايهم اقرب لكم نفعا فريضة من الله ان الله كان عليما حكيما",
  },
  {
    verseId: 11,
    name: "النساء",
    surahId: 4,
    text: "۞وَلَكُمۡ نِصۡفُ مَا تَرَكَ أَزۡوَٰجُكُمۡ إِن لَّمۡ يَكُن لَّهُنَّ وَلَدٞۚ فَإِن كَانَ لَهُنَّ وَلَدٞ فَلَكُمُ ٱلرُّبُعُ مِمَّا تَرَكۡنَۚ مِنۢ بَعۡدِ وَصِيَّةٖ يُوصِينَ بِهَآ أَوۡ دَيۡنٖۚ وَلَهُنَّ ٱلرُّبُعُ مِمَّا تَرَكۡتُمۡ إِن لَّمۡ يَكُن لَّكُمۡ وَلَدٞۚ فَإِن كَانَ لَكُمۡ وَلَدٞ فَلَهُنَّ ٱلثُّمُنُ مِمَّا تَرَكۡتُمۚ مِّنۢ بَعۡدِ وَصِيَّةٖ تُوصُونَ بِهَآ أَوۡ دَيۡنٖۗ وَإِن كَانَ رَجُلٞ يُورَثُ كَلَٰلَةً أَوِ ٱمۡرَأَةٞ وَلَهُۥٓ أَخٌ أَوۡ أُخۡتٞ فَلِكُلِّ وَٰحِدٖ مِّنۡهُمَا ٱلسُّدُسُۚ فَإِن كَانُوٓاْ أَكۡثَرَ مِن ذَٰلِكَ فَهُمۡ شُرَكَآءُ فِي ٱلثُّلُثِۚ مِنۢ بَعۡدِ وَصِيَّةٖ يُوصَىٰ بِهَآ أَوۡ دَيۡنٍ غَيۡرَ مُضَآرّٖۚ وَصِيَّةٗ مِّنَ ٱللَّهِۗ وَٱللَّهُ عَلِيمٌ حَلِيمٞ",
    translation:
      "And for you is half of what your wives leave if they have no child. But if they have a child, for you is one fourth of what they leave, after any bequest they [may have] made or debt. And for the wives is one fourth if you leave no child. But if you leave a child, then for them is an eighth of what you leave, after any bequest you [may have] made or debt. And if a man or woman leaves neither ascendants nor descendants but has a brother or a sister, then for each one of them is a sixth. But if they are more than two, they share a third, after any bequest which was made or debt, as long as there is no detriment [caused]. [This is] an ordinance from Allah, and Allah is Knowing and Forbearing",
    normalizedText:
      "۞ولكم نصف ما ترك ازوجكم ان لم يكن لهن ولد فان كان لهن ولد فلكم الربع مما تركن من بعد وصية يوصين بها او دين ولهن الربع مما تركتم ان لم يكن لكم ولد فان كان لكم ولد فلهن الثمن مما تركتم من بعد وصية توصون بها او دين وان كان رجل يورث كللة او امراة وله اخ او اخت فلكل وحد منهما السدس فان كانوا اكثر من ذلك فهم شركاء في الثلث من بعد وصية يوصى بها او دين غير مضار وصية من الله والله عليم حليم",
  },
  {
    verseId: 12,
    name: "النساء",
    surahId: 4,
    text: "تِلۡكَ حُدُودُ ٱللَّهِۚ وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ يُدۡخِلۡهُ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ وَذَٰلِكَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "These are the limits [set by] Allah, and whoever obeys Allah and His Messenger will be admitted by Him to gardens [in Paradise] under which rivers flow, abiding eternally therein; and that is the great attainment",
    normalizedText:
      "تلك حدود الله ومن يطع الله ورسوله يدخله جنت تجري من تحتها الانهر خلدين فيها وذلك الفوز العظيم",
  },
  {
    verseId: 13,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يَعۡصِ ٱللَّهَ وَرَسُولَهُۥ وَيَتَعَدَّ حُدُودَهُۥ يُدۡخِلۡهُ نَارًا خَٰلِدٗا فِيهَا وَلَهُۥ عَذَابٞ مُّهِينٞ",
    translation:
      "And whoever disobeys Allah and His Messenger and transgresses His limits - He will put him into the Fire to abide eternally therein, and he will have a humiliating punishment",
    normalizedText:
      "ومن يعص الله ورسوله ويتعد حدوده يدخله نارا خلدا فيها وله عذاب مهين",
  },
  {
    verseId: 14,
    name: "النساء",
    surahId: 4,
    text: "وَٱلَّـٰتِي يَأۡتِينَ ٱلۡفَٰحِشَةَ مِن نِّسَآئِكُمۡ فَٱسۡتَشۡهِدُواْ عَلَيۡهِنَّ أَرۡبَعَةٗ مِّنكُمۡۖ فَإِن شَهِدُواْ فَأَمۡسِكُوهُنَّ فِي ٱلۡبُيُوتِ حَتَّىٰ يَتَوَفَّىٰهُنَّ ٱلۡمَوۡتُ أَوۡ يَجۡعَلَ ٱللَّهُ لَهُنَّ سَبِيلٗا",
    translation:
      "Those who commit unlawful sexual intercourse of your women - bring against them four [witnesses] from among you. And if they testify, confine the guilty women to houses until death takes them or Allah ordains for them [another] way",
    normalizedText:
      "والتي ياتين الفحشة من نسااكم فاستشهدوا عليهن اربعة منكم فان شهدوا فامسكوهن في البيوت حتى يتوفىهن الموت او يجعل الله لهن سبيلا",
  },
  {
    verseId: 15,
    name: "النساء",
    surahId: 4,
    text: "وَٱلَّذَانِ يَأۡتِيَٰنِهَا مِنكُمۡ فَـَٔاذُوهُمَاۖ فَإِن تَابَا وَأَصۡلَحَا فَأَعۡرِضُواْ عَنۡهُمَآۗ إِنَّ ٱللَّهَ كَانَ تَوَّابٗا رَّحِيمًا",
    translation:
      "And the two who commit it among you, dishonor them both. But if they repent and correct themselves, leave them alone. Indeed, Allah is ever Accepting of repentance and Merciful",
    normalizedText:
      "والذان ياتينها منكم فاذوهما فان تابا واصلحا فاعرضوا عنهما ان الله كان توابا رحيما",
  },
  {
    verseId: 16,
    name: "النساء",
    surahId: 4,
    text: "إِنَّمَا ٱلتَّوۡبَةُ عَلَى ٱللَّهِ لِلَّذِينَ يَعۡمَلُونَ ٱلسُّوٓءَ بِجَهَٰلَةٖ ثُمَّ يَتُوبُونَ مِن قَرِيبٖ فَأُوْلَـٰٓئِكَ يَتُوبُ ٱللَّهُ عَلَيۡهِمۡۗ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمٗا",
    translation:
      "The repentance accepted by Allah is only for those who do wrong in ignorance [or carelessness] and then repent soon after. It is those to whom Allah will turn in forgiveness, and Allah is ever Knowing and Wise",
    normalizedText:
      "انما التوبة على الله للذين يعملون السوء بجهلة ثم يتوبون من قريب فاولاك يتوب الله عليهم وكان الله عليما حكيما",
  },
  {
    verseId: 17,
    name: "النساء",
    surahId: 4,
    text: "وَلَيۡسَتِ ٱلتَّوۡبَةُ لِلَّذِينَ يَعۡمَلُونَ ٱلسَّيِّـَٔاتِ حَتَّىٰٓ إِذَا حَضَرَ أَحَدَهُمُ ٱلۡمَوۡتُ قَالَ إِنِّي تُبۡتُ ٱلۡـَٰٔنَ وَلَا ٱلَّذِينَ يَمُوتُونَ وَهُمۡ كُفَّارٌۚ أُوْلَـٰٓئِكَ أَعۡتَدۡنَا لَهُمۡ عَذَابًا أَلِيمٗا",
    translation:
      'But repentance is not [accepted] of those who [continue to] do evil deeds up until, when death comes to one of them, he says, "Indeed, I have repented now," or of those who die while they are disbelievers. For them We have prepared a painful punishment',
    normalizedText:
      "وليست التوبة للذين يعملون السيات حتى اذا حضر احدهم الموت قال اني تبت الن ولا الذين يموتون وهم كفار اولاك اعتدنا لهم عذابا اليما",
  },
  {
    verseId: 18,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا يَحِلُّ لَكُمۡ أَن تَرِثُواْ ٱلنِّسَآءَ كَرۡهٗاۖ وَلَا تَعۡضُلُوهُنَّ لِتَذۡهَبُواْ بِبَعۡضِ مَآ ءَاتَيۡتُمُوهُنَّ إِلَّآ أَن يَأۡتِينَ بِفَٰحِشَةٖ مُّبَيِّنَةٖۚ وَعَاشِرُوهُنَّ بِٱلۡمَعۡرُوفِۚ فَإِن كَرِهۡتُمُوهُنَّ فَعَسَىٰٓ أَن تَكۡرَهُواْ شَيۡـٔٗا وَيَجۡعَلَ ٱللَّهُ فِيهِ خَيۡرٗا كَثِيرٗا",
    translation:
      "O you who have believed, it is not lawful for you to inherit women by compulsion. And do not make difficulties for them in order to take [back] part of what you gave them unless they commit a clear immorality. And live with them in kindness. For if you dislike them - perhaps you dislike a thing and Allah makes therein much good",
    normalizedText:
      "يايها الذين ءامنوا لا يحل لكم ان ترثوا النساء كرها ولا تعضلوهن لتذهبوا ببعض ما ءاتيتموهن الا ان ياتين بفحشة مبينة وعاشروهن بالمعروف فان كرهتموهن فعسى ان تكرهوا شيا ويجعل الله فيه خيرا كثيرا",
  },
  {
    verseId: 19,
    name: "النساء",
    surahId: 4,
    text: "وَإِنۡ أَرَدتُّمُ ٱسۡتِبۡدَالَ زَوۡجٖ مَّكَانَ زَوۡجٖ وَءَاتَيۡتُمۡ إِحۡدَىٰهُنَّ قِنطَارٗا فَلَا تَأۡخُذُواْ مِنۡهُ شَيۡـًٔاۚ أَتَأۡخُذُونَهُۥ بُهۡتَٰنٗا وَإِثۡمٗا مُّبِينٗا",
    translation:
      "But if you want to replace one wife with another and you have given one of them a great amount [in gifts], do not take [back] from it anything. Would you take it in injustice and manifest sin",
    normalizedText:
      "وان اردتم استبدال زوج مكان زوج وءاتيتم احدىهن قنطارا فلا تاخذوا منه شيا اتاخذونه بهتنا واثما مبينا",
  },
  {
    verseId: 20,
    name: "النساء",
    surahId: 4,
    text: "وَكَيۡفَ تَأۡخُذُونَهُۥ وَقَدۡ أَفۡضَىٰ بَعۡضُكُمۡ إِلَىٰ بَعۡضٖ وَأَخَذۡنَ مِنكُم مِّيثَٰقًا غَلِيظٗا",
    translation:
      "And how could you take it while you have gone in unto each other and they have taken from you a solemn covenant",
    normalizedText:
      "وكيف تاخذونه وقد افضى بعضكم الى بعض واخذن منكم ميثقا غليظا",
  },
  {
    verseId: 21,
    name: "النساء",
    surahId: 4,
    text: "وَلَا تَنكِحُواْ مَا نَكَحَ ءَابَآؤُكُم مِّنَ ٱلنِّسَآءِ إِلَّا مَا قَدۡ سَلَفَۚ إِنَّهُۥ كَانَ فَٰحِشَةٗ وَمَقۡتٗا وَسَآءَ سَبِيلًا",
    translation:
      "And do not marry those [women] whom your fathers married, except what has already occurred. Indeed, it was an immorality and hateful [to Allah] and was evil as a way",
    normalizedText:
      "ولا تنكحوا ما نكح ءابااكم من النساء الا ما قد سلف انه كان فحشة ومقتا وساء سبيلا",
  },
  {
    verseId: 22,
    name: "النساء",
    surahId: 4,
    text: "حُرِّمَتۡ عَلَيۡكُمۡ أُمَّهَٰتُكُمۡ وَبَنَاتُكُمۡ وَأَخَوَٰتُكُمۡ وَعَمَّـٰتُكُمۡ وَخَٰلَٰتُكُمۡ وَبَنَاتُ ٱلۡأَخِ وَبَنَاتُ ٱلۡأُخۡتِ وَأُمَّهَٰتُكُمُ ٱلَّـٰتِيٓ أَرۡضَعۡنَكُمۡ وَأَخَوَٰتُكُم مِّنَ ٱلرَّضَٰعَةِ وَأُمَّهَٰتُ نِسَآئِكُمۡ وَرَبَـٰٓئِبُكُمُ ٱلَّـٰتِي فِي حُجُورِكُم مِّن نِّسَآئِكُمُ ٱلَّـٰتِي دَخَلۡتُم بِهِنَّ فَإِن لَّمۡ تَكُونُواْ دَخَلۡتُم بِهِنَّ فَلَا جُنَاحَ عَلَيۡكُمۡ وَحَلَـٰٓئِلُ أَبۡنَآئِكُمُ ٱلَّذِينَ مِنۡ أَصۡلَٰبِكُمۡ وَأَن تَجۡمَعُواْ بَيۡنَ ٱلۡأُخۡتَيۡنِ إِلَّا مَا قَدۡ سَلَفَۗ إِنَّ ٱللَّهَ كَانَ غَفُورٗا رَّحِيمٗا",
    translation:
      "Prohibited to you [for marriage] are your mothers, your daughters, your sisters, your father's sisters, your mother's sisters, your brother's daughters, your sister's daughters, your [milk] mothers who nursed you, your sisters through nursing, your wives' mothers, and your step-daughters under your guardianship [born] of your wives unto whom you have gone in. But if you have not gone in unto them, there is no sin upon you. And [also prohibited are] the wives of your sons who are from your [own] loins, and that you take [in marriage] two sisters simultaneously, except for what has already occurred. Indeed, Allah is ever Forgiving and Merciful",
    normalizedText:
      "حرمت عليكم امهتكم وبناتكم واخوتكم وعمتكم وخلتكم وبنات الاخ وبنات الاخت وامهتكم التي ارضعنكم واخوتكم من الرضعة وامهت نسااكم وربابكم التي في حجوركم من نسااكم التي دخلتم بهن فان لم تكونوا دخلتم بهن فلا جناح عليكم وحلال ابنااكم الذين من اصلبكم وان تجمعوا بين الاختين الا ما قد سلف ان الله كان غفورا رحيما",
  },
  {
    verseId: 23,
    name: "النساء",
    surahId: 4,
    text: "۞وَٱلۡمُحۡصَنَٰتُ مِنَ ٱلنِّسَآءِ إِلَّا مَا مَلَكَتۡ أَيۡمَٰنُكُمۡۖ كِتَٰبَ ٱللَّهِ عَلَيۡكُمۡۚ وَأُحِلَّ لَكُم مَّا وَرَآءَ ذَٰلِكُمۡ أَن تَبۡتَغُواْ بِأَمۡوَٰلِكُم مُّحۡصِنِينَ غَيۡرَ مُسَٰفِحِينَۚ فَمَا ٱسۡتَمۡتَعۡتُم بِهِۦ مِنۡهُنَّ فَـَٔاتُوهُنَّ أُجُورَهُنَّ فَرِيضَةٗۚ وَلَا جُنَاحَ عَلَيۡكُمۡ فِيمَا تَرَٰضَيۡتُم بِهِۦ مِنۢ بَعۡدِ ٱلۡفَرِيضَةِۚ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمٗا",
    translation:
      "And [also prohibited to you are all] married women except those your right hands possess. [This is] the decree of Allah upon you. And lawful to you are [all others] beyond these, [provided] that you seek them [in marriage] with [gifts from] your property, desiring chastity, not unlawful sexual intercourse. So for whatever you enjoy [of marriage] from them, give them their due compensation as an obligation. And there is no blame upon you for what you mutually agree to beyond the obligation. Indeed, Allah is ever Knowing and Wise",
    normalizedText:
      "۞والمحصنت من النساء الا ما ملكت ايمنكم كتب الله عليكم واحل لكم ما وراء ذلكم ان تبتغوا بامولكم محصنين غير مسفحين فما استمتعتم به منهن فاتوهن اجورهن فريضة ولا جناح عليكم فيما ترضيتم به من بعد الفريضة ان الله كان عليما حكيما",
  },
  {
    verseId: 24,
    name: "النساء",
    surahId: 4,
    text: "وَمَن لَّمۡ يَسۡتَطِعۡ مِنكُمۡ طَوۡلًا أَن يَنكِحَ ٱلۡمُحۡصَنَٰتِ ٱلۡمُؤۡمِنَٰتِ فَمِن مَّا مَلَكَتۡ أَيۡمَٰنُكُم مِّن فَتَيَٰتِكُمُ ٱلۡمُؤۡمِنَٰتِۚ وَٱللَّهُ أَعۡلَمُ بِإِيمَٰنِكُمۚ بَعۡضُكُم مِّنۢ بَعۡضٖۚ فَٱنكِحُوهُنَّ بِإِذۡنِ أَهۡلِهِنَّ وَءَاتُوهُنَّ أُجُورَهُنَّ بِٱلۡمَعۡرُوفِ مُحۡصَنَٰتٍ غَيۡرَ مُسَٰفِحَٰتٖ وَلَا مُتَّخِذَٰتِ أَخۡدَانٖۚ فَإِذَآ أُحۡصِنَّ فَإِنۡ أَتَيۡنَ بِفَٰحِشَةٖ فَعَلَيۡهِنَّ نِصۡفُ مَا عَلَى ٱلۡمُحۡصَنَٰتِ مِنَ ٱلۡعَذَابِۚ ذَٰلِكَ لِمَنۡ خَشِيَ ٱلۡعَنَتَ مِنكُمۡۚ وَأَن تَصۡبِرُواْ خَيۡرٞ لَّكُمۡۗ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "And whoever among you cannot [find] the means to marry free, believing women, then [he may marry] from those whom your right hands possess of believing slave girls. And Allah is most knowing about your faith. You [believers] are of one another. So marry them with the permission of their people and give them their due compensation according to what is acceptable. [They should be] chaste, neither [of] those who commit unlawful intercourse randomly nor those who take [secret] lovers. But once they are sheltered in marriage, if they should commit adultery, then for them is half the punishment for free [unmarried] women. This [allowance] is for him among you who fears sin, but to be patient is better for you. And Allah is Forgiving and Merciful",
    normalizedText:
      "ومن لم يستطع منكم طولا ان ينكح المحصنت المامنت فمن ما ملكت ايمنكم من فتيتكم المامنت والله اعلم بايمنكم بعضكم من بعض فانكحوهن باذن اهلهن وءاتوهن اجورهن بالمعروف محصنت غير مسفحت ولا متخذت اخدان فاذا احصن فان اتين بفحشة فعليهن نصف ما على المحصنت من العذاب ذلك لمن خشي العنت منكم وان تصبروا خير لكم والله غفور رحيم",
  },
  {
    verseId: 25,
    name: "النساء",
    surahId: 4,
    text: "يُرِيدُ ٱللَّهُ لِيُبَيِّنَ لَكُمۡ وَيَهۡدِيَكُمۡ سُنَنَ ٱلَّذِينَ مِن قَبۡلِكُمۡ وَيَتُوبَ عَلَيۡكُمۡۗ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "Allah wants to make clear to you [the lawful from the unlawful] and guide you to the [good] practices of those before you and to accept your repentance. And Allah is Knowing and Wise",
    normalizedText:
      "يريد الله ليبين لكم ويهديكم سنن الذين من قبلكم ويتوب عليكم والله عليم حكيم",
  },
  {
    verseId: 26,
    name: "النساء",
    surahId: 4,
    text: "وَٱللَّهُ يُرِيدُ أَن يَتُوبَ عَلَيۡكُمۡ وَيُرِيدُ ٱلَّذِينَ يَتَّبِعُونَ ٱلشَّهَوَٰتِ أَن تَمِيلُواْ مَيۡلًا عَظِيمٗا",
    translation:
      "Allah wants to accept your repentance, but those who follow [their] passions want you to digress [into] a great deviation",
    normalizedText:
      "والله يريد ان يتوب عليكم ويريد الذين يتبعون الشهوت ان تميلوا ميلا عظيما",
  },
  {
    verseId: 27,
    name: "النساء",
    surahId: 4,
    text: "يُرِيدُ ٱللَّهُ أَن يُخَفِّفَ عَنكُمۡۚ وَخُلِقَ ٱلۡإِنسَٰنُ ضَعِيفٗا",
    translation:
      "And Allah wants to lighten for you [your difficulties]; and mankind was created weak",
    normalizedText: "يريد الله ان يخفف عنكم وخلق الانسن ضعيفا",
  },
  {
    verseId: 28,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَأۡكُلُوٓاْ أَمۡوَٰلَكُم بَيۡنَكُم بِٱلۡبَٰطِلِ إِلَّآ أَن تَكُونَ تِجَٰرَةً عَن تَرَاضٖ مِّنكُمۡۚ وَلَا تَقۡتُلُوٓاْ أَنفُسَكُمۡۚ إِنَّ ٱللَّهَ كَانَ بِكُمۡ رَحِيمٗا",
    translation:
      "O you who have believed, do not consume one another's wealth unjustly but only [in lawful] business by mutual consent. And do not kill yourselves [or one another]. Indeed, Allah is to you ever Merciful",
    normalizedText:
      "يايها الذين ءامنوا لا تاكلوا امولكم بينكم بالبطل الا ان تكون تجرة عن تراض منكم ولا تقتلوا انفسكم ان الله كان بكم رحيما",
  },
  {
    verseId: 29,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يَفۡعَلۡ ذَٰلِكَ عُدۡوَٰنٗا وَظُلۡمٗا فَسَوۡفَ نُصۡلِيهِ نَارٗاۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرًا",
    translation:
      "And whoever does that in aggression and injustice - then We will drive him into a Fire. And that, for Allah, is [always] easy",
    normalizedText:
      "ومن يفعل ذلك عدونا وظلما فسوف نصليه نارا وكان ذلك على الله يسيرا",
  },
  {
    verseId: 30,
    name: "النساء",
    surahId: 4,
    text: "إِن تَجۡتَنِبُواْ كَبَآئِرَ مَا تُنۡهَوۡنَ عَنۡهُ نُكَفِّرۡ عَنكُمۡ سَيِّـَٔاتِكُمۡ وَنُدۡخِلۡكُم مُّدۡخَلٗا كَرِيمٗا",
    translation:
      "If you avoid the major sins which you are forbidden, We will remove from you your lesser sins and admit you to a noble entrance [into Paradise]",
    normalizedText:
      "ان تجتنبوا كباار ما تنهون عنه نكفر عنكم سياتكم وندخلكم مدخلا كريما",
  },
  {
    verseId: 31,
    name: "النساء",
    surahId: 4,
    text: "وَلَا تَتَمَنَّوۡاْ مَا فَضَّلَ ٱللَّهُ بِهِۦ بَعۡضَكُمۡ عَلَىٰ بَعۡضٖۚ لِّلرِّجَالِ نَصِيبٞ مِّمَّا ٱكۡتَسَبُواْۖ وَلِلنِّسَآءِ نَصِيبٞ مِّمَّا ٱكۡتَسَبۡنَۚ وَسۡـَٔلُواْ ٱللَّهَ مِن فَضۡلِهِۦٓۚ إِنَّ ٱللَّهَ كَانَ بِكُلِّ شَيۡءٍ عَلِيمٗا",
    translation:
      "And do not wish for that by which Allah has made some of you exceed others. For men is a share of what they have earned, and for women is a share of what they have earned. And ask Allah of his bounty. Indeed Allah is ever, of all things, Knowing",
    normalizedText:
      "ولا تتمنوا ما فضل الله به بعضكم على بعض للرجال نصيب مما اكتسبوا وللنساء نصيب مما اكتسبن وسلوا الله من فضله ان الله كان بكل شيء عليما",
  },
  {
    verseId: 32,
    name: "النساء",
    surahId: 4,
    text: "وَلِكُلّٖ جَعَلۡنَا مَوَٰلِيَ مِمَّا تَرَكَ ٱلۡوَٰلِدَانِ وَٱلۡأَقۡرَبُونَۚ وَٱلَّذِينَ عَقَدَتۡ أَيۡمَٰنُكُمۡ فَـَٔاتُوهُمۡ نَصِيبَهُمۡۚ إِنَّ ٱللَّهَ كَانَ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدًا",
    translation:
      "And for all, We have made heirs to what is left by parents and relatives. And to those whom your oaths have bound [to you] - give them their share. Indeed Allah is ever, over all things, a Witness",
    normalizedText:
      "ولكل جعلنا مولي مما ترك الولدان والاقربون والذين عقدت ايمنكم فاتوهم نصيبهم ان الله كان على كل شيء شهيدا",
  },
  {
    verseId: 33,
    name: "النساء",
    surahId: 4,
    text: "ٱلرِّجَالُ قَوَّـٰمُونَ عَلَى ٱلنِّسَآءِ بِمَا فَضَّلَ ٱللَّهُ بَعۡضَهُمۡ عَلَىٰ بَعۡضٖ وَبِمَآ أَنفَقُواْ مِنۡ أَمۡوَٰلِهِمۡۚ فَٱلصَّـٰلِحَٰتُ قَٰنِتَٰتٌ حَٰفِظَٰتٞ لِّلۡغَيۡبِ بِمَا حَفِظَ ٱللَّهُۚ وَٱلَّـٰتِي تَخَافُونَ نُشُوزَهُنَّ فَعِظُوهُنَّ وَٱهۡجُرُوهُنَّ فِي ٱلۡمَضَاجِعِ وَٱضۡرِبُوهُنَّۖ فَإِنۡ أَطَعۡنَكُمۡ فَلَا تَبۡغُواْ عَلَيۡهِنَّ سَبِيلًاۗ إِنَّ ٱللَّهَ كَانَ عَلِيّٗا كَبِيرٗا",
    translation:
      "Men are in charge of women by [right of] what Allah has given one over the other and what they spend [for maintenance] from their wealth. So righteous women are devoutly obedient, guarding in [the husband's] absence what Allah would have them guard. But those [wives] from whom you fear arrogance - [first] advise them; [then if they persist], forsake them in bed; and [finally], strike them. But if they obey you [once more], seek no means against them. Indeed, Allah is ever Exalted and Grand",
    normalizedText:
      "الرجال قومون على النساء بما فضل الله بعضهم على بعض وبما انفقوا من امولهم فالصلحت قنتت حفظت للغيب بما حفظ الله والتي تخافون نشوزهن فعظوهن واهجروهن في المضاجع واضربوهن فان اطعنكم فلا تبغوا عليهن سبيلا ان الله كان عليا كبيرا",
  },
  {
    verseId: 34,
    name: "النساء",
    surahId: 4,
    text: "وَإِنۡ خِفۡتُمۡ شِقَاقَ بَيۡنِهِمَا فَٱبۡعَثُواْ حَكَمٗا مِّنۡ أَهۡلِهِۦ وَحَكَمٗا مِّنۡ أَهۡلِهَآ إِن يُرِيدَآ إِصۡلَٰحٗا يُوَفِّقِ ٱللَّهُ بَيۡنَهُمَآۗ إِنَّ ٱللَّهَ كَانَ عَلِيمًا خَبِيرٗا",
    translation:
      "And if you fear dissension between the two, send an arbitrator from his people and an arbitrator from her people. If they both desire reconciliation, Allah will cause it between them. Indeed, Allah is ever Knowing and Acquainted [with all things]",
    normalizedText:
      "وان خفتم شقاق بينهما فابعثوا حكما من اهله وحكما من اهلها ان يريدا اصلحا يوفق الله بينهما ان الله كان عليما خبيرا",
  },
  {
    verseId: 35,
    name: "النساء",
    surahId: 4,
    text: "۞وَٱعۡبُدُواْ ٱللَّهَ وَلَا تُشۡرِكُواْ بِهِۦ شَيۡـٔٗاۖ وَبِٱلۡوَٰلِدَيۡنِ إِحۡسَٰنٗا وَبِذِي ٱلۡقُرۡبَىٰ وَٱلۡيَتَٰمَىٰ وَٱلۡمَسَٰكِينِ وَٱلۡجَارِ ذِي ٱلۡقُرۡبَىٰ وَٱلۡجَارِ ٱلۡجُنُبِ وَٱلصَّاحِبِ بِٱلۡجَنۢبِ وَٱبۡنِ ٱلسَّبِيلِ وَمَا مَلَكَتۡ أَيۡمَٰنُكُمۡۗ إِنَّ ٱللَّهَ لَا يُحِبُّ مَن كَانَ مُخۡتَالٗا فَخُورًا",
    translation:
      "Worship Allah and associate nothing with Him, and to parents do good, and to relatives, orphans, the needy, the near neighbor, the neighbor farther away, the companion at your side, the traveler, and those whom your right hands possess. Indeed, Allah does not like those who are self-deluding and boastful",
    normalizedText:
      "۞واعبدوا الله ولا تشركوا به شيا وبالولدين احسنا وبذي القربى واليتمى والمسكين والجار ذي القربى والجار الجنب والصاحب بالجنب وابن السبيل وما ملكت ايمنكم ان الله لا يحب من كان مختالا فخورا",
  },
  {
    verseId: 36,
    name: "النساء",
    surahId: 4,
    text: "ٱلَّذِينَ يَبۡخَلُونَ وَيَأۡمُرُونَ ٱلنَّاسَ بِٱلۡبُخۡلِ وَيَكۡتُمُونَ مَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضۡلِهِۦۗ وَأَعۡتَدۡنَا لِلۡكَٰفِرِينَ عَذَابٗا مُّهِينٗا",
    translation:
      "Who are stingy and enjoin upon [other] people stinginess and conceal what Allah has given them of His bounty - and We have prepared for the disbelievers a humiliating punishment",
    normalizedText:
      "الذين يبخلون ويامرون الناس بالبخل ويكتمون ما ءاتىهم الله من فضله واعتدنا للكفرين عذابا مهينا",
  },
  {
    verseId: 37,
    name: "النساء",
    surahId: 4,
    text: "وَٱلَّذِينَ يُنفِقُونَ أَمۡوَٰلَهُمۡ رِئَآءَ ٱلنَّاسِ وَلَا يُؤۡمِنُونَ بِٱللَّهِ وَلَا بِٱلۡيَوۡمِ ٱلۡأٓخِرِۗ وَمَن يَكُنِ ٱلشَّيۡطَٰنُ لَهُۥ قَرِينٗا فَسَآءَ قَرِينٗا",
    translation:
      "And [also] those who spend of their wealth to be seen by the people and believe not in Allah nor in the Last Day. And he to whom Satan is a companion - then evil is he as a companion",
    normalizedText:
      "والذين ينفقون امولهم رااء الناس ولا يامنون بالله ولا باليوم الاخر ومن يكن الشيطن له قرينا فساء قرينا",
  },
  {
    verseId: 38,
    name: "النساء",
    surahId: 4,
    text: "وَمَاذَا عَلَيۡهِمۡ لَوۡ ءَامَنُواْ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَأَنفَقُواْ مِمَّا رَزَقَهُمُ ٱللَّهُۚ وَكَانَ ٱللَّهُ بِهِمۡ عَلِيمًا",
    translation:
      "And what [harm would come] upon them if they believed in Allah and the Last Day and spent out of what Allah provided for them? And Allah is ever, about them, Knowing",
    normalizedText:
      "وماذا عليهم لو ءامنوا بالله واليوم الاخر وانفقوا مما رزقهم الله وكان الله بهم عليما",
  },
  {
    verseId: 39,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱللَّهَ لَا يَظۡلِمُ مِثۡقَالَ ذَرَّةٖۖ وَإِن تَكُ حَسَنَةٗ يُضَٰعِفۡهَا وَيُؤۡتِ مِن لَّدُنۡهُ أَجۡرًا عَظِيمٗا",
    translation:
      "Indeed, Allah does not do injustice, [even] as much as an atom's weight; while if there is a good deed, He multiplies it and gives from Himself a great reward",
    normalizedText:
      "ان الله لا يظلم مثقال ذرة وان تك حسنة يضعفها ويات من لدنه اجرا عظيما",
  },
  {
    verseId: 40,
    name: "النساء",
    surahId: 4,
    text: "فَكَيۡفَ إِذَا جِئۡنَا مِن كُلِّ أُمَّةِۭ بِشَهِيدٖ وَجِئۡنَا بِكَ عَلَىٰ هَـٰٓؤُلَآءِ شَهِيدٗا",
    translation:
      "So how [will it be] when We bring from every nation a witness and we bring you, [O Muhammad] against these [people] as a witness",
    normalizedText: "فكيف اذا جانا من كل امة بشهيد وجانا بك على هالاء شهيدا",
  },
  {
    verseId: 41,
    name: "النساء",
    surahId: 4,
    text: "يَوۡمَئِذٖ يَوَدُّ ٱلَّذِينَ كَفَرُواْ وَعَصَوُاْ ٱلرَّسُولَ لَوۡ تُسَوَّىٰ بِهِمُ ٱلۡأَرۡضُ وَلَا يَكۡتُمُونَ ٱللَّهَ حَدِيثٗا",
    translation:
      "That Day, those who disbelieved and disobeyed the Messenger will wish they could be covered by the earth. And they will not conceal from Allah a [single] statement",
    normalizedText:
      "يوماذ يود الذين كفروا وعصوا الرسول لو تسوى بهم الارض ولا يكتمون الله حديثا",
  },
  {
    verseId: 42,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَقۡرَبُواْ ٱلصَّلَوٰةَ وَأَنتُمۡ سُكَٰرَىٰ حَتَّىٰ تَعۡلَمُواْ مَا تَقُولُونَ وَلَا جُنُبًا إِلَّا عَابِرِي سَبِيلٍ حَتَّىٰ تَغۡتَسِلُواْۚ وَإِن كُنتُم مَّرۡضَىٰٓ أَوۡ عَلَىٰ سَفَرٍ أَوۡ جَآءَ أَحَدٞ مِّنكُم مِّنَ ٱلۡغَآئِطِ أَوۡ لَٰمَسۡتُمُ ٱلنِّسَآءَ فَلَمۡ تَجِدُواْ مَآءٗ فَتَيَمَّمُواْ صَعِيدٗا طَيِّبٗا فَٱمۡسَحُواْ بِوُجُوهِكُمۡ وَأَيۡدِيكُمۡۗ إِنَّ ٱللَّهَ كَانَ عَفُوًّا غَفُورًا",
    translation:
      "O you who have believed, do not approach prayer while you are intoxicated until you know what you are saying or in a state of janabah, except those passing through [a place of prayer], until you have washed [your whole body]. And if you are ill or on a journey or one of you comes from the place of relieving himself or you have contacted women and find no water, then seek clean earth and wipe over your faces and your hands [with it]. Indeed, Allah is ever Pardoning and Forgiving",
    normalizedText:
      "يايها الذين ءامنوا لا تقربوا الصلوة وانتم سكرى حتى تعلموا ما تقولون ولا جنبا الا عابري سبيل حتى تغتسلوا وان كنتم مرضى او على سفر او جاء احد منكم من الغااط او لمستم النساء فلم تجدوا ماء فتيمموا صعيدا طيبا فامسحوا بوجوهكم وايديكم ان الله كان عفوا غفورا",
  },
  {
    verseId: 43,
    name: "النساء",
    surahId: 4,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ أُوتُواْ نَصِيبٗا مِّنَ ٱلۡكِتَٰبِ يَشۡتَرُونَ ٱلضَّلَٰلَةَ وَيُرِيدُونَ أَن تَضِلُّواْ ٱلسَّبِيلَ",
    translation:
      "Have you not seen those who were given a portion of the Scripture, purchasing error [in exchange for it] and wishing you would lose the way",
    normalizedText:
      "الم تر الى الذين اوتوا نصيبا من الكتب يشترون الضللة ويريدون ان تضلوا السبيل",
  },
  {
    verseId: 44,
    name: "النساء",
    surahId: 4,
    text: "وَٱللَّهُ أَعۡلَمُ بِأَعۡدَآئِكُمۡۚ وَكَفَىٰ بِٱللَّهِ وَلِيّٗا وَكَفَىٰ بِٱللَّهِ نَصِيرٗا",
    translation:
      "And Allah is most knowing of your enemies; and sufficient is Allah as an ally, and sufficient is Allah as a helper",
    normalizedText: "والله اعلم باعدااكم وكفى بالله وليا وكفى بالله نصيرا",
  },
  {
    verseId: 45,
    name: "النساء",
    surahId: 4,
    text: "مِّنَ ٱلَّذِينَ هَادُواْ يُحَرِّفُونَ ٱلۡكَلِمَ عَن مَّوَاضِعِهِۦ وَيَقُولُونَ سَمِعۡنَا وَعَصَيۡنَا وَٱسۡمَعۡ غَيۡرَ مُسۡمَعٖ وَرَٰعِنَا لَيَّۢا بِأَلۡسِنَتِهِمۡ وَطَعۡنٗا فِي ٱلدِّينِۚ وَلَوۡ أَنَّهُمۡ قَالُواْ سَمِعۡنَا وَأَطَعۡنَا وَٱسۡمَعۡ وَٱنظُرۡنَا لَكَانَ خَيۡرٗا لَّهُمۡ وَأَقۡوَمَ وَلَٰكِن لَّعَنَهُمُ ٱللَّهُ بِكُفۡرِهِمۡ فَلَا يُؤۡمِنُونَ إِلَّا قَلِيلٗا",
    translation: `Among the Jews are those who distort words from their [proper] usages and say, "We hear and disobey" and "Hear but be not heard" and "Ra'ina," twisting their tongues and defaming the religion. And if they had said [instead], "We hear and obey" and "Wait for us [to understand]," it would have been better for them and more suitable. But Allah has cursed them for their disbelief, so they believe not, except for a few`,
    normalizedText:
      "من الذين هادوا يحرفون الكلم عن مواضعه ويقولون سمعنا وعصينا واسمع غير مسمع ورعنا ليا بالسنتهم وطعنا في الدين ولو انهم قالوا سمعنا واطعنا واسمع وانظرنا لكان خيرا لهم واقوم ولكن لعنهم الله بكفرهم فلا يامنون الا قليلا",
  },
  {
    verseId: 46,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ ءَامِنُواْ بِمَا نَزَّلۡنَا مُصَدِّقٗا لِّمَا مَعَكُم مِّن قَبۡلِ أَن نَّطۡمِسَ وُجُوهٗا فَنَرُدَّهَا عَلَىٰٓ أَدۡبَارِهَآ أَوۡ نَلۡعَنَهُمۡ كَمَا لَعَنَّآ أَصۡحَٰبَ ٱلسَّبۡتِۚ وَكَانَ أَمۡرُ ٱللَّهِ مَفۡعُولًا",
    translation:
      "O you who were given the Scripture, believe in what We have sent down [to Muhammad], confirming that which is with you, before We obliterate faces and turn them toward their backs or curse them as We cursed the sabbath-breakers. And ever is the decree of Allah accomplished",
    normalizedText:
      "يايها الذين اوتوا الكتب ءامنوا بما نزلنا مصدقا لما معكم من قبل ان نطمس وجوها فنردها على ادبارها او نلعنهم كما لعنا اصحب السبت وكان امر الله مفعولا",
  },
  {
    verseId: 47,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱللَّهَ لَا يَغۡفِرُ أَن يُشۡرَكَ بِهِۦ وَيَغۡفِرُ مَا دُونَ ذَٰلِكَ لِمَن يَشَآءُۚ وَمَن يُشۡرِكۡ بِٱللَّهِ فَقَدِ ٱفۡتَرَىٰٓ إِثۡمًا عَظِيمًا",
    translation:
      "Indeed, Allah does not forgive association with Him, but He forgives what is less than that for whom He wills. And he who associates others with Allah has certainly fabricated a tremendous sin",
    normalizedText:
      "ان الله لا يغفر ان يشرك به ويغفر ما دون ذلك لمن يشاء ومن يشرك بالله فقد افترى اثما عظيما",
  },
  {
    verseId: 48,
    name: "النساء",
    surahId: 4,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ يُزَكُّونَ أَنفُسَهُمۚ بَلِ ٱللَّهُ يُزَكِّي مَن يَشَآءُ وَلَا يُظۡلَمُونَ فَتِيلًا",
    translation:
      "Have you not seen those who claim themselves to be pure? Rather, Allah purifies whom He wills, and injustice is not done to them, [even] as much as a thread [inside a date seed]",
    normalizedText:
      "الم تر الى الذين يزكون انفسهم بل الله يزكي من يشاء ولا يظلمون فتيلا",
  },
  {
    verseId: 49,
    name: "النساء",
    surahId: 4,
    text: "ٱنظُرۡ كَيۡفَ يَفۡتَرُونَ عَلَى ٱللَّهِ ٱلۡكَذِبَۖ وَكَفَىٰ بِهِۦٓ إِثۡمٗا مُّبِينًا",
    translation:
      "Look how they invent about Allah untruth, and sufficient is that as a manifest sin",
    normalizedText: "انظر كيف يفترون على الله الكذب وكفى به اثما مبينا",
  },
  {
    verseId: 50,
    name: "النساء",
    surahId: 4,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ أُوتُواْ نَصِيبٗا مِّنَ ٱلۡكِتَٰبِ يُؤۡمِنُونَ بِٱلۡجِبۡتِ وَٱلطَّـٰغُوتِ وَيَقُولُونَ لِلَّذِينَ كَفَرُواْ هَـٰٓؤُلَآءِ أَهۡدَىٰ مِنَ ٱلَّذِينَ ءَامَنُواْ سَبِيلًا",
    translation:
      'Have you not seen those who were given a portion of the Scripture, who believe in superstition and false objects of worship and say about the disbelievers, "These are better guided than the believers as to the way',
    normalizedText:
      "الم تر الى الذين اوتوا نصيبا من الكتب يامنون بالجبت والطغوت ويقولون للذين كفروا هالاء اهدى من الذين ءامنوا سبيلا",
  },
  {
    verseId: 51,
    name: "النساء",
    surahId: 4,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ لَعَنَهُمُ ٱللَّهُۖ وَمَن يَلۡعَنِ ٱللَّهُ فَلَن تَجِدَ لَهُۥ نَصِيرًا",
    translation:
      "Those are the ones whom Allah has cursed; and he whom Allah curses - never will you find for him a helper",
    normalizedText: "اولاك الذين لعنهم الله ومن يلعن الله فلن تجد له نصيرا",
  },
  {
    verseId: 52,
    name: "النساء",
    surahId: 4,
    text: "أَمۡ لَهُمۡ نَصِيبٞ مِّنَ ٱلۡمُلۡكِ فَإِذٗا لَّا يُؤۡتُونَ ٱلنَّاسَ نَقِيرًا",
    translation:
      "Or have they a share of dominion? Then [if that were so], they would not give the people [even as much as] the speck on a date seed",
    normalizedText: "ام لهم نصيب من الملك فاذا لا ياتون الناس نقيرا",
  },
  {
    verseId: 53,
    name: "النساء",
    surahId: 4,
    text: "أَمۡ يَحۡسُدُونَ ٱلنَّاسَ عَلَىٰ مَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضۡلِهِۦۖ فَقَدۡ ءَاتَيۡنَآ ءَالَ إِبۡرَٰهِيمَ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَءَاتَيۡنَٰهُم مُّلۡكًا عَظِيمٗا",
    translation:
      "Or do they envy people for what Allah has given them of His bounty? But we had already given the family of Abraham the Scripture and wisdom and conferred upon them a great kingdom",
    normalizedText:
      "ام يحسدون الناس على ما ءاتىهم الله من فضله فقد ءاتينا ءال ابرهيم الكتب والحكمة وءاتينهم ملكا عظيما",
  },
  {
    verseId: 54,
    name: "النساء",
    surahId: 4,
    text: "فَمِنۡهُم مَّنۡ ءَامَنَ بِهِۦ وَمِنۡهُم مَّن صَدَّ عَنۡهُۚ وَكَفَىٰ بِجَهَنَّمَ سَعِيرًا",
    translation:
      "And some among them believed in it, and some among them were averse to it. And sufficient is Hell as a blaze",
    normalizedText: "فمنهم من ءامن به ومنهم من صد عنه وكفى بجهنم سعيرا",
  },
  {
    verseId: 55,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ بِـَٔايَٰتِنَا سَوۡفَ نُصۡلِيهِمۡ نَارٗا كُلَّمَا نَضِجَتۡ جُلُودُهُم بَدَّلۡنَٰهُمۡ جُلُودًا غَيۡرَهَا لِيَذُوقُواْ ٱلۡعَذَابَۗ إِنَّ ٱللَّهَ كَانَ عَزِيزًا حَكِيمٗا",
    translation:
      "Indeed, those who disbelieve in Our verses - We will drive them into a Fire. Every time their skins are roasted through We will replace them with other skins so they may taste the punishment. Indeed, Allah is ever Exalted in Might and Wise",
    normalizedText:
      "ان الذين كفروا بايتنا سوف نصليهم نارا كلما نضجت جلودهم بدلنهم جلودا غيرها ليذوقوا العذاب ان الله كان عزيزا حكيما",
  },
  {
    verseId: 56,
    name: "النساء",
    surahId: 4,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ سَنُدۡخِلُهُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدٗاۖ لَّهُمۡ فِيهَآ أَزۡوَٰجٞ مُّطَهَّرَةٞۖ وَنُدۡخِلُهُمۡ ظِلّٗا ظَلِيلًا",
    translation:
      "But those who believe and do righteous deeds - We will admit them to gardens beneath which rivers flow, wherein they abide forever. For them therein are purified spouses, and We will admit them to deepening shade",
    normalizedText:
      "والذين ءامنوا وعملوا الصلحت سندخلهم جنت تجري من تحتها الانهر خلدين فيها ابدا لهم فيها ازوج مطهرة وندخلهم ظلا ظليلا",
  },
  {
    verseId: 57,
    name: "النساء",
    surahId: 4,
    text: "۞إِنَّ ٱللَّهَ يَأۡمُرُكُمۡ أَن تُؤَدُّواْ ٱلۡأَمَٰنَٰتِ إِلَىٰٓ أَهۡلِهَا وَإِذَا حَكَمۡتُم بَيۡنَ ٱلنَّاسِ أَن تَحۡكُمُواْ بِٱلۡعَدۡلِۚ إِنَّ ٱللَّهَ نِعِمَّا يَعِظُكُم بِهِۦٓۗ إِنَّ ٱللَّهَ كَانَ سَمِيعَۢا بَصِيرٗا",
    translation:
      "Indeed, Allah commands you to render trusts to whom they are due and when you judge between people to judge with justice. Excellent is that which Allah instructs you. Indeed, Allah is ever Hearing and Seeing",
    normalizedText:
      "۞ان الله يامركم ان تادوا الامنت الى اهلها واذا حكمتم بين الناس ان تحكموا بالعدل ان الله نعما يعظكم به ان الله كان سميعا بصيرا",
  },
  {
    verseId: 58,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ أَطِيعُواْ ٱللَّهَ وَأَطِيعُواْ ٱلرَّسُولَ وَأُوْلِي ٱلۡأَمۡرِ مِنكُمۡۖ فَإِن تَنَٰزَعۡتُمۡ فِي شَيۡءٖ فَرُدُّوهُ إِلَى ٱللَّهِ وَٱلرَّسُولِ إِن كُنتُمۡ تُؤۡمِنُونَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِۚ ذَٰلِكَ خَيۡرٞ وَأَحۡسَنُ تَأۡوِيلًا",
    translation:
      "O you who have believed, obey Allah and obey the Messenger and those in authority among you. And if you disagree over anything, refer it to Allah and the Messenger, if you should believe in Allah and the Last Day. That is the best [way] and best in result",
    normalizedText:
      "يايها الذين ءامنوا اطيعوا الله واطيعوا الرسول واولي الامر منكم فان تنزعتم في شيء فردوه الى الله والرسول ان كنتم تامنون بالله واليوم الاخر ذلك خير واحسن تاويلا",
  },
  {
    verseId: 59,
    name: "النساء",
    surahId: 4,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ يَزۡعُمُونَ أَنَّهُمۡ ءَامَنُواْ بِمَآ أُنزِلَ إِلَيۡكَ وَمَآ أُنزِلَ مِن قَبۡلِكَ يُرِيدُونَ أَن يَتَحَاكَمُوٓاْ إِلَى ٱلطَّـٰغُوتِ وَقَدۡ أُمِرُوٓاْ أَن يَكۡفُرُواْ بِهِۦۖ وَيُرِيدُ ٱلشَّيۡطَٰنُ أَن يُضِلَّهُمۡ ضَلَٰلَۢا بَعِيدٗا",
    translation:
      "Have you not seen those who claim to have believed in what was revealed to you, [O Muhammad], and what was revealed before you? They wish to refer legislation to Taghut, while they were commanded to reject it; and Satan wishes to lead them far astray",
    normalizedText:
      "الم تر الى الذين يزعمون انهم ءامنوا بما انزل اليك وما انزل من قبلك يريدون ان يتحاكموا الى الطغوت وقد امروا ان يكفروا به ويريد الشيطن ان يضلهم ضللا بعيدا",
  },
  {
    verseId: 60,
    name: "النساء",
    surahId: 4,
    text: "وَإِذَا قِيلَ لَهُمۡ تَعَالَوۡاْ إِلَىٰ مَآ أَنزَلَ ٱللَّهُ وَإِلَى ٱلرَّسُولِ رَأَيۡتَ ٱلۡمُنَٰفِقِينَ يَصُدُّونَ عَنكَ صُدُودٗا",
    translation:
      'And when it is said to them, "Come to what Allah has revealed and to the Messenger," you see the hypocrites turning away from you in aversion',
    normalizedText:
      "واذا قيل لهم تعالوا الى ما انزل الله والى الرسول رايت المنفقين يصدون عنك صدودا",
  },
  {
    verseId: 61,
    name: "النساء",
    surahId: 4,
    text: "فَكَيۡفَ إِذَآ أَصَٰبَتۡهُم مُّصِيبَةُۢ بِمَا قَدَّمَتۡ أَيۡدِيهِمۡ ثُمَّ جَآءُوكَ يَحۡلِفُونَ بِٱللَّهِ إِنۡ أَرَدۡنَآ إِلَّآ إِحۡسَٰنٗا وَتَوۡفِيقًا",
    translation:
      'So how [will it be] when disaster strikes them because of what their hands have put forth and then they come to you swearing by Allah, "We intended nothing but good conduct and accommodation',
    normalizedText:
      "فكيف اذا اصبتهم مصيبة بما قدمت ايديهم ثم جاءوك يحلفون بالله ان اردنا الا احسنا وتوفيقا",
  },
  {
    verseId: 62,
    name: "النساء",
    surahId: 4,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ يَعۡلَمُ ٱللَّهُ مَا فِي قُلُوبِهِمۡ فَأَعۡرِضۡ عَنۡهُمۡ وَعِظۡهُمۡ وَقُل لَّهُمۡ فِيٓ أَنفُسِهِمۡ قَوۡلَۢا بَلِيغٗا",
    translation:
      "Those are the ones of whom Allah knows what is in their hearts, so turn away from them but admonish them and speak to them a far-reaching word",
    normalizedText:
      "اولاك الذين يعلم الله ما في قلوبهم فاعرض عنهم وعظهم وقل لهم في انفسهم قولا بليغا",
  },
  {
    verseId: 63,
    name: "النساء",
    surahId: 4,
    text: "وَمَآ أَرۡسَلۡنَا مِن رَّسُولٍ إِلَّا لِيُطَاعَ بِإِذۡنِ ٱللَّهِۚ وَلَوۡ أَنَّهُمۡ إِذ ظَّلَمُوٓاْ أَنفُسَهُمۡ جَآءُوكَ فَٱسۡتَغۡفَرُواْ ٱللَّهَ وَٱسۡتَغۡفَرَ لَهُمُ ٱلرَّسُولُ لَوَجَدُواْ ٱللَّهَ تَوَّابٗا رَّحِيمٗا",
    translation:
      "And We did not send any messenger except to be obeyed by permission of Allah. And if, when they wronged themselves, they had come to you, [O Muhammad], and asked forgiveness of Allah and the Messenger had asked forgiveness for them, they would have found Allah Accepting of repentance and Merciful",
    normalizedText:
      "وما ارسلنا من رسول الا ليطاع باذن الله ولو انهم اذ ظلموا انفسهم جاءوك فاستغفروا الله واستغفر لهم الرسول لوجدوا الله توابا رحيما",
  },
  {
    verseId: 64,
    name: "النساء",
    surahId: 4,
    text: "فَلَا وَرَبِّكَ لَا يُؤۡمِنُونَ حَتَّىٰ يُحَكِّمُوكَ فِيمَا شَجَرَ بَيۡنَهُمۡ ثُمَّ لَا يَجِدُواْ فِيٓ أَنفُسِهِمۡ حَرَجٗا مِّمَّا قَضَيۡتَ وَيُسَلِّمُواْ تَسۡلِيمٗا",
    translation:
      "But no, by your Lord, they will not [truly] believe until they make you, [O Muhammad], judge concerning that over which they dispute among themselves and then find within themselves no discomfort from what you have judged and submit in [full, willing] submission",
    normalizedText:
      "فلا وربك لا يامنون حتى يحكموك فيما شجر بينهم ثم لا يجدوا في انفسهم حرجا مما قضيت ويسلموا تسليما",
  },
  {
    verseId: 65,
    name: "النساء",
    surahId: 4,
    text: "وَلَوۡ أَنَّا كَتَبۡنَا عَلَيۡهِمۡ أَنِ ٱقۡتُلُوٓاْ أَنفُسَكُمۡ أَوِ ٱخۡرُجُواْ مِن دِيَٰرِكُم مَّا فَعَلُوهُ إِلَّا قَلِيلٞ مِّنۡهُمۡۖ وَلَوۡ أَنَّهُمۡ فَعَلُواْ مَا يُوعَظُونَ بِهِۦ لَكَانَ خَيۡرٗا لَّهُمۡ وَأَشَدَّ تَثۡبِيتٗا",
    translation:
      'And if We had decreed upon them, "Kill yourselves" or "Leave your homes," they would not have done it, except for a few of them. But if they had done what they were instructed, it would have been better for them and a firmer position [for them in faith]',
    normalizedText:
      "ولو انا كتبنا عليهم ان اقتلوا انفسكم او اخرجوا من ديركم ما فعلوه الا قليل منهم ولو انهم فعلوا ما يوعظون به لكان خيرا لهم واشد تثبيتا",
  },
  {
    verseId: 66,
    name: "النساء",
    surahId: 4,
    text: "وَإِذٗا لَّأٓتَيۡنَٰهُم مِّن لَّدُنَّآ أَجۡرًا عَظِيمٗا",
    translation: "And then We would have given them from Us a great reward",
    normalizedText: "واذا لاتينهم من لدنا اجرا عظيما",
  },
  {
    verseId: 67,
    name: "النساء",
    surahId: 4,
    text: "وَلَهَدَيۡنَٰهُمۡ صِرَٰطٗا مُّسۡتَقِيمٗا",
    translation: "And We would have guided them to a straight path",
    normalizedText: "ولهدينهم صرطا مستقيما",
  },
  {
    verseId: 68,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يُطِعِ ٱللَّهَ وَٱلرَّسُولَ فَأُوْلَـٰٓئِكَ مَعَ ٱلَّذِينَ أَنۡعَمَ ٱللَّهُ عَلَيۡهِم مِّنَ ٱلنَّبِيِّـۧنَ وَٱلصِّدِّيقِينَ وَٱلشُّهَدَآءِ وَٱلصَّـٰلِحِينَۚ وَحَسُنَ أُوْلَـٰٓئِكَ رَفِيقٗا",
    translation:
      "And whoever obeys Allah and the Messenger - those will be with the ones upon whom Allah has bestowed favor of the prophets, the steadfast affirmers of truth, the martyrs and the righteous. And excellent are those as companions",
    normalizedText:
      "ومن يطع الله والرسول فاولاك مع الذين انعم الله عليهم من النبين والصديقين والشهداء والصلحين وحسن اولاك رفيقا",
  },
  {
    verseId: 69,
    name: "النساء",
    surahId: 4,
    text: "ذَٰلِكَ ٱلۡفَضۡلُ مِنَ ٱللَّهِۚ وَكَفَىٰ بِٱللَّهِ عَلِيمٗا",
    translation:
      "That is the bounty from Allah, and sufficient is Allah as Knower",
    normalizedText: "ذلك الفضل من الله وكفى بالله عليما",
  },
  {
    verseId: 70,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ خُذُواْ حِذۡرَكُمۡ فَٱنفِرُواْ ثُبَاتٍ أَوِ ٱنفِرُواْ جَمِيعٗا",
    translation:
      "O you who have believed, take your precaution and [either] go forth in companies or go forth all together",
    normalizedText:
      "يايها الذين ءامنوا خذوا حذركم فانفروا ثبات او انفروا جميعا",
  },
  {
    verseId: 71,
    name: "النساء",
    surahId: 4,
    text: "وَإِنَّ مِنكُمۡ لَمَن لَّيُبَطِّئَنَّ فَإِنۡ أَصَٰبَتۡكُم مُّصِيبَةٞ قَالَ قَدۡ أَنۡعَمَ ٱللَّهُ عَلَيَّ إِذۡ لَمۡ أَكُن مَّعَهُمۡ شَهِيدٗا",
    translation:
      'And indeed, there is among you he who lingers behind; and if disaster strikes you, he says, "Allah has favored me in that I was not present with them',
    normalizedText:
      "وان منكم لمن ليبطان فان اصبتكم مصيبة قال قد انعم الله علي اذ لم اكن معهم شهيدا",
  },
  {
    verseId: 72,
    name: "النساء",
    surahId: 4,
    text: "وَلَئِنۡ أَصَٰبَكُمۡ فَضۡلٞ مِّنَ ٱللَّهِ لَيَقُولَنَّ كَأَن لَّمۡ تَكُنۢ بَيۡنَكُمۡ وَبَيۡنَهُۥ مَوَدَّةٞ يَٰلَيۡتَنِي كُنتُ مَعَهُمۡ فَأَفُوزَ فَوۡزًا عَظِيمٗا",
    translation:
      'But if bounty comes to you from Allah, he will surely say, as if there had never been between you and him any affection. "Oh, I wish I had been with them so I could have attained a great attainment',
    normalizedText:
      "ولان اصبكم فضل من الله ليقولن كان لم تكن بينكم وبينه مودة يليتني كنت معهم فافوز فوزا عظيما",
  },
  {
    verseId: 73,
    name: "النساء",
    surahId: 4,
    text: "۞فَلۡيُقَٰتِلۡ فِي سَبِيلِ ٱللَّهِ ٱلَّذِينَ يَشۡرُونَ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا بِٱلۡأٓخِرَةِۚ وَمَن يُقَٰتِلۡ فِي سَبِيلِ ٱللَّهِ فَيُقۡتَلۡ أَوۡ يَغۡلِبۡ فَسَوۡفَ نُؤۡتِيهِ أَجۡرًا عَظِيمٗا",
    translation:
      "So let those fight in the cause of Allah who sell the life of this world for the Hereafter. And he who fights in the cause of Allah and is killed or achieves victory - We will bestow upon him a great reward",
    normalizedText:
      "۞فليقتل في سبيل الله الذين يشرون الحيوة الدنيا بالاخرة ومن يقتل في سبيل الله فيقتل او يغلب فسوف ناتيه اجرا عظيما",
  },
  {
    verseId: 74,
    name: "النساء",
    surahId: 4,
    text: "وَمَا لَكُمۡ لَا تُقَٰتِلُونَ فِي سَبِيلِ ٱللَّهِ وَٱلۡمُسۡتَضۡعَفِينَ مِنَ ٱلرِّجَالِ وَٱلنِّسَآءِ وَٱلۡوِلۡدَٰنِ ٱلَّذِينَ يَقُولُونَ رَبَّنَآ أَخۡرِجۡنَا مِنۡ هَٰذِهِ ٱلۡقَرۡيَةِ ٱلظَّالِمِ أَهۡلُهَا وَٱجۡعَل لَّنَا مِن لَّدُنكَ وَلِيّٗا وَٱجۡعَل لَّنَا مِن لَّدُنكَ نَصِيرًا",
    translation:
      'And what is [the matter] with you that you fight not in the cause of Allah and [for] the oppressed among men, women, and children who say, "Our Lord, take us out of this city of oppressive people and appoint for us from Yourself a protector and appoint for us from Yourself a helper',
    normalizedText:
      "وما لكم لا تقتلون في سبيل الله والمستضعفين من الرجال والنساء والولدن الذين يقولون ربنا اخرجنا من هذه القرية الظالم اهلها واجعل لنا من لدنك وليا واجعل لنا من لدنك نصيرا",
  },
  {
    verseId: 75,
    name: "النساء",
    surahId: 4,
    text: "ٱلَّذِينَ ءَامَنُواْ يُقَٰتِلُونَ فِي سَبِيلِ ٱللَّهِۖ وَٱلَّذِينَ كَفَرُواْ يُقَٰتِلُونَ فِي سَبِيلِ ٱلطَّـٰغُوتِ فَقَٰتِلُوٓاْ أَوۡلِيَآءَ ٱلشَّيۡطَٰنِۖ إِنَّ كَيۡدَ ٱلشَّيۡطَٰنِ كَانَ ضَعِيفًا",
    translation:
      "Those who believe fight in the cause of Allah, and those who disbelieve fight in the cause of Taghut. So fight against the allies of Satan. Indeed, the plot of Satan has ever been weak",
    normalizedText:
      "الذين ءامنوا يقتلون في سبيل الله والذين كفروا يقتلون في سبيل الطغوت فقتلوا اولياء الشيطن ان كيد الشيطن كان ضعيفا",
  },
  {
    verseId: 76,
    name: "النساء",
    surahId: 4,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ قِيلَ لَهُمۡ كُفُّوٓاْ أَيۡدِيَكُمۡ وَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَ فَلَمَّا كُتِبَ عَلَيۡهِمُ ٱلۡقِتَالُ إِذَا فَرِيقٞ مِّنۡهُمۡ يَخۡشَوۡنَ ٱلنَّاسَ كَخَشۡيَةِ ٱللَّهِ أَوۡ أَشَدَّ خَشۡيَةٗۚ وَقَالُواْ رَبَّنَا لِمَ كَتَبۡتَ عَلَيۡنَا ٱلۡقِتَالَ لَوۡلَآ أَخَّرۡتَنَآ إِلَىٰٓ أَجَلٖ قَرِيبٖۗ قُلۡ مَتَٰعُ ٱلدُّنۡيَا قَلِيلٞ وَٱلۡأٓخِرَةُ خَيۡرٞ لِّمَنِ ٱتَّقَىٰ وَلَا تُظۡلَمُونَ فَتِيلًا",
    translation:
      'Have you not seen those who were told, "Restrain your hands [from fighting] and establish prayer and give zakah"? But then when fighting was ordained for them, at once a party of them feared men as they fear Allah or with [even] greater fear. They said, "Our Lord, why have You decreed upon us fighting? If only You had postponed [it for] us for a short time." Say, The enjoyment of this world is little, and the Hereafter is better for he who fears Allah. And injustice will not be done to you, [even] as much as a thread [inside a date seed]',
    normalizedText:
      "الم تر الى الذين قيل لهم كفوا ايديكم واقيموا الصلوة وءاتوا الزكوة فلما كتب عليهم القتال اذا فريق منهم يخشون الناس كخشية الله او اشد خشية وقالوا ربنا لم كتبت علينا القتال لولا اخرتنا الى اجل قريب قل متع الدنيا قليل والاخرة خير لمن اتقى ولا تظلمون فتيلا",
  },
  {
    verseId: 77,
    name: "النساء",
    surahId: 4,
    text: "أَيۡنَمَا تَكُونُواْ يُدۡرِككُّمُ ٱلۡمَوۡتُ وَلَوۡ كُنتُمۡ فِي بُرُوجٖ مُّشَيَّدَةٖۗ وَإِن تُصِبۡهُمۡ حَسَنَةٞ يَقُولُواْ هَٰذِهِۦ مِنۡ عِندِ ٱللَّهِۖ وَإِن تُصِبۡهُمۡ سَيِّئَةٞ يَقُولُواْ هَٰذِهِۦ مِنۡ عِندِكَۚ قُلۡ كُلّٞ مِّنۡ عِندِ ٱللَّهِۖ فَمَالِ هَـٰٓؤُلَآءِ ٱلۡقَوۡمِ لَا يَكَادُونَ يَفۡقَهُونَ حَدِيثٗا",
    translation:
      'Wherever you may be, death will overtake you, even if you should be within towers of lofty construction. But if good comes to them, they say, "This is from Allah "; and if evil befalls them, they say, "This is from you." Say, "All [things] are from Allah." So what is [the matter] with those people that they can hardly understand any statement',
    normalizedText:
      "اينما تكونوا يدرككم الموت ولو كنتم في بروج مشيدة وان تصبهم حسنة يقولوا هذه من عند الله وان تصبهم سياة يقولوا هذه من عندك قل كل من عند الله فمال هالاء القوم لا يكادون يفقهون حديثا",
  },
  {
    verseId: 78,
    name: "النساء",
    surahId: 4,
    text: "مَّآ أَصَابَكَ مِنۡ حَسَنَةٖ فَمِنَ ٱللَّهِۖ وَمَآ أَصَابَكَ مِن سَيِّئَةٖ فَمِن نَّفۡسِكَۚ وَأَرۡسَلۡنَٰكَ لِلنَّاسِ رَسُولٗاۚ وَكَفَىٰ بِٱللَّهِ شَهِيدٗا",
    translation:
      "What comes to you of good is from Allah, but what comes to you of evil, [O man], is from yourself. And We have sent you, [O Muhammad], to the people as a messenger, and sufficient is Allah as Witness",
    normalizedText:
      "ما اصابك من حسنة فمن الله وما اصابك من سياة فمن نفسك وارسلنك للناس رسولا وكفى بالله شهيدا",
  },
  {
    verseId: 79,
    name: "النساء",
    surahId: 4,
    text: "مَّن يُطِعِ ٱلرَّسُولَ فَقَدۡ أَطَاعَ ٱللَّهَۖ وَمَن تَوَلَّىٰ فَمَآ أَرۡسَلۡنَٰكَ عَلَيۡهِمۡ حَفِيظٗا",
    translation:
      "He who obeys the Messenger has obeyed Allah; but those who turn away - We have not sent you over them as a guardian",
    normalizedText:
      "من يطع الرسول فقد اطاع الله ومن تولى فما ارسلنك عليهم حفيظا",
  },
  {
    verseId: 80,
    name: "النساء",
    surahId: 4,
    text: "وَيَقُولُونَ طَاعَةٞ فَإِذَا بَرَزُواْ مِنۡ عِندِكَ بَيَّتَ طَآئِفَةٞ مِّنۡهُمۡ غَيۡرَ ٱلَّذِي تَقُولُۖ وَٱللَّهُ يَكۡتُبُ مَا يُبَيِّتُونَۖ فَأَعۡرِضۡ عَنۡهُمۡ وَتَوَكَّلۡ عَلَى ٱللَّهِۚ وَكَفَىٰ بِٱللَّهِ وَكِيلًا",
    translation:
      'And they say, "[We pledge] obedience." But when they leave you, a group of them spend the night determining to do other than what you say. But Allah records what they plan by night. So leave them alone and rely upon Allah. And sufficient is Allah as Disposer of affairs',
    normalizedText:
      "ويقولون طاعة فاذا برزوا من عندك بيت طاافة منهم غير الذي تقول والله يكتب ما يبيتون فاعرض عنهم وتوكل على الله وكفى بالله وكيلا",
  },
  {
    verseId: 81,
    name: "النساء",
    surahId: 4,
    text: "أَفَلَا يَتَدَبَّرُونَ ٱلۡقُرۡءَانَۚ وَلَوۡ كَانَ مِنۡ عِندِ غَيۡرِ ٱللَّهِ لَوَجَدُواْ فِيهِ ٱخۡتِلَٰفٗا كَثِيرٗا",
    translation:
      "Then do they not reflect upon the Qur'an? If it had been from [any] other than Allah, they would have found within it much contradiction",
    normalizedText:
      "افلا يتدبرون القرءان ولو كان من عند غير الله لوجدوا فيه اختلفا كثيرا",
  },
  {
    verseId: 82,
    name: "النساء",
    surahId: 4,
    text: "وَإِذَا جَآءَهُمۡ أَمۡرٞ مِّنَ ٱلۡأَمۡنِ أَوِ ٱلۡخَوۡفِ أَذَاعُواْ بِهِۦۖ وَلَوۡ رَدُّوهُ إِلَى ٱلرَّسُولِ وَإِلَىٰٓ أُوْلِي ٱلۡأَمۡرِ مِنۡهُمۡ لَعَلِمَهُ ٱلَّذِينَ يَسۡتَنۢبِطُونَهُۥ مِنۡهُمۡۗ وَلَوۡلَا فَضۡلُ ٱللَّهِ عَلَيۡكُمۡ وَرَحۡمَتُهُۥ لَٱتَّبَعۡتُمُ ٱلشَّيۡطَٰنَ إِلَّا قَلِيلٗا",
    translation:
      "And when there comes to them information about [public] security or fear, they spread it around. But if they had referred it back to the Messenger or to those of authority among them, then the ones who [can] draw correct conclusions from it would have known about it. And if not for the favor of Allah upon you and His mercy, you would have followed Satan, except for a few",
    normalizedText:
      "واذا جاءهم امر من الامن او الخوف اذاعوا به ولو ردوه الى الرسول والى اولي الامر منهم لعلمه الذين يستنبطونه منهم ولولا فضل الله عليكم ورحمته لاتبعتم الشيطن الا قليلا",
  },
  {
    verseId: 83,
    name: "النساء",
    surahId: 4,
    text: "فَقَٰتِلۡ فِي سَبِيلِ ٱللَّهِ لَا تُكَلَّفُ إِلَّا نَفۡسَكَۚ وَحَرِّضِ ٱلۡمُؤۡمِنِينَۖ عَسَى ٱللَّهُ أَن يَكُفَّ بَأۡسَ ٱلَّذِينَ كَفَرُواْۚ وَٱللَّهُ أَشَدُّ بَأۡسٗا وَأَشَدُّ تَنكِيلٗا",
    translation:
      "So fight, [O Muhammad], in the cause of Allah; you are not held responsible except for yourself. And encourage the believers [to join you] that perhaps Allah will restrain the [military] might of those who disbelieve. And Allah is greater in might and stronger in [exemplary] punishment",
    normalizedText:
      "فقتل في سبيل الله لا تكلف الا نفسك وحرض المامنين عسى الله ان يكف باس الذين كفروا والله اشد باسا واشد تنكيلا",
  },
  {
    verseId: 84,
    name: "النساء",
    surahId: 4,
    text: "مَّن يَشۡفَعۡ شَفَٰعَةً حَسَنَةٗ يَكُن لَّهُۥ نَصِيبٞ مِّنۡهَاۖ وَمَن يَشۡفَعۡ شَفَٰعَةٗ سَيِّئَةٗ يَكُن لَّهُۥ كِفۡلٞ مِّنۡهَاۗ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ مُّقِيتٗا",
    translation:
      "Whoever intercedes for a good cause will have a reward therefrom; and whoever intercedes for an evil cause will have a burden therefrom. And ever is Allah, over all things, a Keeper",
    normalizedText:
      "من يشفع شفعة حسنة يكن له نصيب منها ومن يشفع شفعة سياة يكن له كفل منها وكان الله على كل شيء مقيتا",
  },
  {
    verseId: 85,
    name: "النساء",
    surahId: 4,
    text: "وَإِذَا حُيِّيتُم بِتَحِيَّةٖ فَحَيُّواْ بِأَحۡسَنَ مِنۡهَآ أَوۡ رُدُّوهَآۗ إِنَّ ٱللَّهَ كَانَ عَلَىٰ كُلِّ شَيۡءٍ حَسِيبًا",
    translation:
      "And when you are greeted with a greeting, greet [in return] with one better than it or [at least] return it [in a like manner]. Indeed, Allah is ever, over all things, an Accountant",
    normalizedText:
      "واذا حييتم بتحية فحيوا باحسن منها او ردوها ان الله كان على كل شيء حسيبا",
  },
  {
    verseId: 86,
    name: "النساء",
    surahId: 4,
    text: "ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَۚ لَيَجۡمَعَنَّكُمۡ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ لَا رَيۡبَ فِيهِۗ وَمَنۡ أَصۡدَقُ مِنَ ٱللَّهِ حَدِيثٗا",
    translation:
      "Allah - there is no deity except Him. He will surely assemble you for [account on] the Day of Resurrection, about which there is no doubt. And who is more truthful than Allah in statement",
    normalizedText:
      "الله لا اله الا هو ليجمعنكم الى يوم القيمة لا ريب فيه ومن اصدق من الله حديثا",
  },
  {
    verseId: 87,
    name: "النساء",
    surahId: 4,
    text: "۞فَمَا لَكُمۡ فِي ٱلۡمُنَٰفِقِينَ فِئَتَيۡنِ وَٱللَّهُ أَرۡكَسَهُم بِمَا كَسَبُوٓاْۚ أَتُرِيدُونَ أَن تَهۡدُواْ مَنۡ أَضَلَّ ٱللَّهُۖ وَمَن يُضۡلِلِ ٱللَّهُ فَلَن تَجِدَ لَهُۥ سَبِيلٗا",
    translation:
      "What is [the matter] with you [that you are] two groups concerning the hypocrites, while Allah has made them fall back [into error and disbelief] for what they earned. Do you wish to guide those whom Allah has sent astray? And he whom Allah sends astray - never will you find for him a way [of guidance]",
    normalizedText:
      "۞فما لكم في المنفقين فاتين والله اركسهم بما كسبوا اتريدون ان تهدوا من اضل الله ومن يضلل الله فلن تجد له سبيلا",
  },
  {
    verseId: 88,
    name: "النساء",
    surahId: 4,
    text: "وَدُّواْ لَوۡ تَكۡفُرُونَ كَمَا كَفَرُواْ فَتَكُونُونَ سَوَآءٗۖ فَلَا تَتَّخِذُواْ مِنۡهُمۡ أَوۡلِيَآءَ حَتَّىٰ يُهَاجِرُواْ فِي سَبِيلِ ٱللَّهِۚ فَإِن تَوَلَّوۡاْ فَخُذُوهُمۡ وَٱقۡتُلُوهُمۡ حَيۡثُ وَجَدتُّمُوهُمۡۖ وَلَا تَتَّخِذُواْ مِنۡهُمۡ وَلِيّٗا وَلَا نَصِيرًا",
    translation:
      "They wish you would disbelieve as they disbelieved so you would be alike. So do not take from among them allies until they emigrate for the cause of Allah. But if they turn away, then seize them and kill them wherever you find them and take not from among them any ally or helper",
    normalizedText:
      "ودوا لو تكفرون كما كفروا فتكونون سواء فلا تتخذوا منهم اولياء حتى يهاجروا في سبيل الله فان تولوا فخذوهم واقتلوهم حيث وجدتموهم ولا تتخذوا منهم وليا ولا نصيرا",
  },
  {
    verseId: 89,
    name: "النساء",
    surahId: 4,
    text: "إِلَّا ٱلَّذِينَ يَصِلُونَ إِلَىٰ قَوۡمِۭ بَيۡنَكُمۡ وَبَيۡنَهُم مِّيثَٰقٌ أَوۡ جَآءُوكُمۡ حَصِرَتۡ صُدُورُهُمۡ أَن يُقَٰتِلُوكُمۡ أَوۡ يُقَٰتِلُواْ قَوۡمَهُمۡۚ وَلَوۡ شَآءَ ٱللَّهُ لَسَلَّطَهُمۡ عَلَيۡكُمۡ فَلَقَٰتَلُوكُمۡۚ فَإِنِ ٱعۡتَزَلُوكُمۡ فَلَمۡ يُقَٰتِلُوكُمۡ وَأَلۡقَوۡاْ إِلَيۡكُمُ ٱلسَّلَمَ فَمَا جَعَلَ ٱللَّهُ لَكُمۡ عَلَيۡهِمۡ سَبِيلٗا",
    translation:
      "Except for those who take refuge with a people between yourselves and whom is a treaty or those who come to you, their hearts strained at [the prospect of] fighting you or fighting their own people. And if Allah had willed, He could have given them power over you, and they would have fought you. So if they remove themselves from you and do not fight you and offer you peace, then Allah has not made for you a cause [for fighting] against them",
    normalizedText:
      "الا الذين يصلون الى قوم بينكم وبينهم ميثق او جاءوكم حصرت صدورهم ان يقتلوكم او يقتلوا قومهم ولو شاء الله لسلطهم عليكم فلقتلوكم فان اعتزلوكم فلم يقتلوكم والقوا اليكم السلم فما جعل الله لكم عليهم سبيلا",
  },
  {
    verseId: 90,
    name: "النساء",
    surahId: 4,
    text: "سَتَجِدُونَ ءَاخَرِينَ يُرِيدُونَ أَن يَأۡمَنُوكُمۡ وَيَأۡمَنُواْ قَوۡمَهُمۡ كُلَّ مَا رُدُّوٓاْ إِلَى ٱلۡفِتۡنَةِ أُرۡكِسُواْ فِيهَاۚ فَإِن لَّمۡ يَعۡتَزِلُوكُمۡ وَيُلۡقُوٓاْ إِلَيۡكُمُ ٱلسَّلَمَ وَيَكُفُّوٓاْ أَيۡدِيَهُمۡ فَخُذُوهُمۡ وَٱقۡتُلُوهُمۡ حَيۡثُ ثَقِفۡتُمُوهُمۡۚ وَأُوْلَـٰٓئِكُمۡ جَعَلۡنَا لَكُمۡ عَلَيۡهِمۡ سُلۡطَٰنٗا مُّبِينٗا",
    translation:
      "You will find others who wish to obtain security from you and [to] obtain security from their people. Every time they are returned to [the influence of] disbelief, they fall back into it. So if they do not withdraw from you or offer you peace or restrain their hands, then seize them and kill them wherever you overtake them. And those - We have made for you against them a clear authorization",
    normalizedText:
      "ستجدون ءاخرين يريدون ان يامنوكم ويامنوا قومهم كل ما ردوا الى الفتنة اركسوا فيها فان لم يعتزلوكم ويلقوا اليكم السلم ويكفوا ايديهم فخذوهم واقتلوهم حيث ثقفتموهم واولاكم جعلنا لكم عليهم سلطنا مبينا",
  },
  {
    verseId: 91,
    name: "النساء",
    surahId: 4,
    text: "وَمَا كَانَ لِمُؤۡمِنٍ أَن يَقۡتُلَ مُؤۡمِنًا إِلَّا خَطَـٔٗاۚ وَمَن قَتَلَ مُؤۡمِنًا خَطَـٔٗا فَتَحۡرِيرُ رَقَبَةٖ مُّؤۡمِنَةٖ وَدِيَةٞ مُّسَلَّمَةٌ إِلَىٰٓ أَهۡلِهِۦٓ إِلَّآ أَن يَصَّدَّقُواْۚ فَإِن كَانَ مِن قَوۡمٍ عَدُوّٖ لَّكُمۡ وَهُوَ مُؤۡمِنٞ فَتَحۡرِيرُ رَقَبَةٖ مُّؤۡمِنَةٖۖ وَإِن كَانَ مِن قَوۡمِۭ بَيۡنَكُمۡ وَبَيۡنَهُم مِّيثَٰقٞ فَدِيَةٞ مُّسَلَّمَةٌ إِلَىٰٓ أَهۡلِهِۦ وَتَحۡرِيرُ رَقَبَةٖ مُّؤۡمِنَةٖۖ فَمَن لَّمۡ يَجِدۡ فَصِيَامُ شَهۡرَيۡنِ مُتَتَابِعَيۡنِ تَوۡبَةٗ مِّنَ ٱللَّهِۗ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمٗا",
    translation:
      "And never is it for a believer to kill a believer except by mistake. And whoever kills a believer by mistake - then the freeing of a believing slave and a compensation payment presented to the deceased's family [is required] unless they give [up their right as] charity. But if the deceased was from a people at war with you and he was a believer - then [only] the freeing of a believing slave; and if he was from a people with whom you have a treaty - then a compensation payment presented to his family and the freeing of a believing slave. And whoever does not find [one or cannot afford to buy one] - then [instead], a fast for two months consecutively, [seeking] acceptance of repentance from Allah. And Allah is ever Knowing and Wise",
    normalizedText:
      "وما كان لمامن ان يقتل مامنا الا خطا ومن قتل مامنا خطا فتحرير رقبة مامنة ودية مسلمة الى اهله الا ان يصدقوا فان كان من قوم عدو لكم وهو مامن فتحرير رقبة مامنة وان كان من قوم بينكم وبينهم ميثق فدية مسلمة الى اهله وتحرير رقبة مامنة فمن لم يجد فصيام شهرين متتابعين توبة من الله وكان الله عليما حكيما",
  },
  {
    verseId: 92,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يَقۡتُلۡ مُؤۡمِنٗا مُّتَعَمِّدٗا فَجَزَآؤُهُۥ جَهَنَّمُ خَٰلِدٗا فِيهَا وَغَضِبَ ٱللَّهُ عَلَيۡهِ وَلَعَنَهُۥ وَأَعَدَّ لَهُۥ عَذَابًا عَظِيمٗا",
    translation:
      "But whoever kills a believer intentionally - his recompense is Hell, wherein he will abide eternally, and Allah has become angry with him and has cursed him and has prepared for him a great punishment",
    normalizedText:
      "ومن يقتل مامنا متعمدا فجزااه جهنم خلدا فيها وغضب الله عليه ولعنه واعد له عذابا عظيما",
  },
  {
    verseId: 93,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا ضَرَبۡتُمۡ فِي سَبِيلِ ٱللَّهِ فَتَبَيَّنُواْ وَلَا تَقُولُواْ لِمَنۡ أَلۡقَىٰٓ إِلَيۡكُمُ ٱلسَّلَٰمَ لَسۡتَ مُؤۡمِنٗا تَبۡتَغُونَ عَرَضَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا فَعِندَ ٱللَّهِ مَغَانِمُ كَثِيرَةٞۚ كَذَٰلِكَ كُنتُم مِّن قَبۡلُ فَمَنَّ ٱللَّهُ عَلَيۡكُمۡ فَتَبَيَّنُوٓاْۚ إِنَّ ٱللَّهَ كَانَ بِمَا تَعۡمَلُونَ خَبِيرٗا",
    translation:
      'O you who have believed, when you go forth [to fight] in the cause of Allah, investigate; and do not say to one who gives you [a greeting of] peace "You are not a believer," aspiring for the goods of worldly life; for with Allah are many acquisitions. You [yourselves] were like that before; then Allah conferred His favor upon you, so investigate. Indeed Allah is ever, with what you do, Acquainted',
    normalizedText:
      "يايها الذين ءامنوا اذا ضربتم في سبيل الله فتبينوا ولا تقولوا لمن القى اليكم السلم لست مامنا تبتغون عرض الحيوة الدنيا فعند الله مغانم كثيرة كذلك كنتم من قبل فمن الله عليكم فتبينوا ان الله كان بما تعملون خبيرا",
  },
  {
    verseId: 94,
    name: "النساء",
    surahId: 4,
    text: "لَّا يَسۡتَوِي ٱلۡقَٰعِدُونَ مِنَ ٱلۡمُؤۡمِنِينَ غَيۡرُ أُوْلِي ٱلضَّرَرِ وَٱلۡمُجَٰهِدُونَ فِي سَبِيلِ ٱللَّهِ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡۚ فَضَّلَ ٱللَّهُ ٱلۡمُجَٰهِدِينَ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡ عَلَى ٱلۡقَٰعِدِينَ دَرَجَةٗۚ وَكُلّٗا وَعَدَ ٱللَّهُ ٱلۡحُسۡنَىٰۚ وَفَضَّلَ ٱللَّهُ ٱلۡمُجَٰهِدِينَ عَلَى ٱلۡقَٰعِدِينَ أَجۡرًا عَظِيمٗا",
    translation:
      "Not equal are those believers remaining [at home] - other than the disabled - and the mujahideen, [who strive and fight] in the cause of Allah with their wealth and their lives. Allah has preferred the mujahideen through their wealth and their lives over those who remain [behind], by degrees. And to both Allah has promised the best [reward]. But Allah has preferred the mujahideen over those who remain [behind] with a great reward",
    normalizedText:
      "لا يستوي القعدون من المامنين غير اولي الضرر والمجهدون في سبيل الله بامولهم وانفسهم فضل الله المجهدين بامولهم وانفسهم على القعدين درجة وكلا وعد الله الحسنى وفضل الله المجهدين على القعدين اجرا عظيما",
  },
  {
    verseId: 95,
    name: "النساء",
    surahId: 4,
    text: "دَرَجَٰتٖ مِّنۡهُ وَمَغۡفِرَةٗ وَرَحۡمَةٗۚ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمًا",
    translation:
      "Degrees [of high position] from Him and forgiveness and mercy. And Allah is ever Forgiving and Merciful",
    normalizedText: "درجت منه ومغفرة ورحمة وكان الله غفورا رحيما",
  },
  {
    verseId: 96,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلَّذِينَ تَوَفَّىٰهُمُ ٱلۡمَلَـٰٓئِكَةُ ظَالِمِيٓ أَنفُسِهِمۡ قَالُواْ فِيمَ كُنتُمۡۖ قَالُواْ كُنَّا مُسۡتَضۡعَفِينَ فِي ٱلۡأَرۡضِۚ قَالُوٓاْ أَلَمۡ تَكُنۡ أَرۡضُ ٱللَّهِ وَٰسِعَةٗ فَتُهَاجِرُواْ فِيهَاۚ فَأُوْلَـٰٓئِكَ مَأۡوَىٰهُمۡ جَهَنَّمُۖ وَسَآءَتۡ مَصِيرًا",
    translation:
      'Indeed, those whom the angels take [in death] while wronging themselves - [the angels] will say, "In what [condition] were you?" They will say, "We were oppressed in the land." The angels will say, "Was not the earth of Allah spacious [enough] for you to emigrate therein?" For those, their refuge is Hell - and evil it is as a destination',
    normalizedText:
      "ان الذين توفىهم الملاكة ظالمي انفسهم قالوا فيم كنتم قالوا كنا مستضعفين في الارض قالوا الم تكن ارض الله وسعة فتهاجروا فيها فاولاك ماوىهم جهنم وساءت مصيرا",
  },
  {
    verseId: 97,
    name: "النساء",
    surahId: 4,
    text: "إِلَّا ٱلۡمُسۡتَضۡعَفِينَ مِنَ ٱلرِّجَالِ وَٱلنِّسَآءِ وَٱلۡوِلۡدَٰنِ لَا يَسۡتَطِيعُونَ حِيلَةٗ وَلَا يَهۡتَدُونَ سَبِيلٗا",
    translation:
      "Except for the oppressed among men, women and children who cannot devise a plan nor are they directed to a way",
    normalizedText:
      "الا المستضعفين من الرجال والنساء والولدن لا يستطيعون حيلة ولا يهتدون سبيلا",
  },
  {
    verseId: 98,
    name: "النساء",
    surahId: 4,
    text: "فَأُوْلَـٰٓئِكَ عَسَى ٱللَّهُ أَن يَعۡفُوَ عَنۡهُمۡۚ وَكَانَ ٱللَّهُ عَفُوًّا غَفُورٗا",
    translation:
      "For those it is expected that Allah will pardon them, and Allah is ever Pardoning and Forgiving",
    normalizedText: "فاولاك عسى الله ان يعفو عنهم وكان الله عفوا غفورا",
  },
  {
    verseId: 99,
    name: "النساء",
    surahId: 4,
    text: "۞وَمَن يُهَاجِرۡ فِي سَبِيلِ ٱللَّهِ يَجِدۡ فِي ٱلۡأَرۡضِ مُرَٰغَمٗا كَثِيرٗا وَسَعَةٗۚ وَمَن يَخۡرُجۡ مِنۢ بَيۡتِهِۦ مُهَاجِرًا إِلَى ٱللَّهِ وَرَسُولِهِۦ ثُمَّ يُدۡرِكۡهُ ٱلۡمَوۡتُ فَقَدۡ وَقَعَ أَجۡرُهُۥ عَلَى ٱللَّهِۗ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمٗا",
    translation:
      "And whoever emigrates for the cause of Allah will find on the earth many [alternative] locations and abundance. And whoever leaves his home as an emigrant to Allah and His Messenger and then death overtakes him - his reward has already become incumbent upon Allah. And Allah is ever Forgiving and Merciful",
    normalizedText:
      "۞ومن يهاجر في سبيل الله يجد في الارض مرغما كثيرا وسعة ومن يخرج من بيته مهاجرا الى الله ورسوله ثم يدركه الموت فقد وقع اجره على الله وكان الله غفورا رحيما",
  },
  {
    verseId: 100,
    name: "النساء",
    surahId: 4,
    text: "وَإِذَا ضَرَبۡتُمۡ فِي ٱلۡأَرۡضِ فَلَيۡسَ عَلَيۡكُمۡ جُنَاحٌ أَن تَقۡصُرُواْ مِنَ ٱلصَّلَوٰةِ إِنۡ خِفۡتُمۡ أَن يَفۡتِنَكُمُ ٱلَّذِينَ كَفَرُوٓاْۚ إِنَّ ٱلۡكَٰفِرِينَ كَانُواْ لَكُمۡ عَدُوّٗا مُّبِينٗا",
    translation:
      "And when you travel throughout the land, there is no blame upon you for shortening the prayer, [especially] if you fear that those who disbelieve may disrupt [or attack] you. Indeed, the disbelievers are ever to you a clear enemy",
    normalizedText:
      "واذا ضربتم في الارض فليس عليكم جناح ان تقصروا من الصلوة ان خفتم ان يفتنكم الذين كفروا ان الكفرين كانوا لكم عدوا مبينا",
  },
  {
    verseId: 101,
    name: "النساء",
    surahId: 4,
    text: "وَإِذَا كُنتَ فِيهِمۡ فَأَقَمۡتَ لَهُمُ ٱلصَّلَوٰةَ فَلۡتَقُمۡ طَآئِفَةٞ مِّنۡهُم مَّعَكَ وَلۡيَأۡخُذُوٓاْ أَسۡلِحَتَهُمۡۖ فَإِذَا سَجَدُواْ فَلۡيَكُونُواْ مِن وَرَآئِكُمۡ وَلۡتَأۡتِ طَآئِفَةٌ أُخۡرَىٰ لَمۡ يُصَلُّواْ فَلۡيُصَلُّواْ مَعَكَ وَلۡيَأۡخُذُواْ حِذۡرَهُمۡ وَأَسۡلِحَتَهُمۡۗ وَدَّ ٱلَّذِينَ كَفَرُواْ لَوۡ تَغۡفُلُونَ عَنۡ أَسۡلِحَتِكُمۡ وَأَمۡتِعَتِكُمۡ فَيَمِيلُونَ عَلَيۡكُم مَّيۡلَةٗ وَٰحِدَةٗۚ وَلَا جُنَاحَ عَلَيۡكُمۡ إِن كَانَ بِكُمۡ أَذٗى مِّن مَّطَرٍ أَوۡ كُنتُم مَّرۡضَىٰٓ أَن تَضَعُوٓاْ أَسۡلِحَتَكُمۡۖ وَخُذُواْ حِذۡرَكُمۡۗ إِنَّ ٱللَّهَ أَعَدَّ لِلۡكَٰفِرِينَ عَذَابٗا مُّهِينٗا",
    translation:
      "And when you are among them and lead them in prayer, let a group of them stand [in prayer] with you and let them carry their arms. And when they have prostrated, let them be [in position] behind you and have the other group come forward which has not [yet] prayed and let them pray with you, taking precaution and carrying their arms. Those who disbelieve wish that you would neglect your weapons and your baggage so they could come down upon you in one [single] attack. But there is no blame upon you, if you are troubled by rain or are ill, for putting down your arms, but take precaution. Indeed, Allah has prepared for the disbelievers a humiliating punishment",
    normalizedText:
      "واذا كنت فيهم فاقمت لهم الصلوة فلتقم طاافة منهم معك ولياخذوا اسلحتهم فاذا سجدوا فليكونوا من ورااكم ولتات طاافة اخرى لم يصلوا فليصلوا معك ولياخذوا حذرهم واسلحتهم ود الذين كفروا لو تغفلون عن اسلحتكم وامتعتكم فيميلون عليكم ميلة وحدة ولا جناح عليكم ان كان بكم اذى من مطر او كنتم مرضى ان تضعوا اسلحتكم وخذوا حذركم ان الله اعد للكفرين عذابا مهينا",
  },
  {
    verseId: 102,
    name: "النساء",
    surahId: 4,
    text: "فَإِذَا قَضَيۡتُمُ ٱلصَّلَوٰةَ فَٱذۡكُرُواْ ٱللَّهَ قِيَٰمٗا وَقُعُودٗا وَعَلَىٰ جُنُوبِكُمۡۚ فَإِذَا ٱطۡمَأۡنَنتُمۡ فَأَقِيمُواْ ٱلصَّلَوٰةَۚ إِنَّ ٱلصَّلَوٰةَ كَانَتۡ عَلَى ٱلۡمُؤۡمِنِينَ كِتَٰبٗا مَّوۡقُوتٗا",
    translation:
      "And when you have completed the prayer, remember Allah standing, sitting, or [lying] on your sides. But when you become secure, re-establish [regular] prayer. Indeed, prayer has been decreed upon the believers a decree of specified times",
    normalizedText:
      "فاذا قضيتم الصلوة فاذكروا الله قيما وقعودا وعلى جنوبكم فاذا اطماننتم فاقيموا الصلوة ان الصلوة كانت على المامنين كتبا موقوتا",
  },
  {
    verseId: 103,
    name: "النساء",
    surahId: 4,
    text: "وَلَا تَهِنُواْ فِي ٱبۡتِغَآءِ ٱلۡقَوۡمِۖ إِن تَكُونُواْ تَأۡلَمُونَ فَإِنَّهُمۡ يَأۡلَمُونَ كَمَا تَأۡلَمُونَۖ وَتَرۡجُونَ مِنَ ٱللَّهِ مَا لَا يَرۡجُونَۗ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمًا",
    translation:
      "And do not weaken in pursuit of the enemy. If you should be suffering - so are they suffering as you are suffering, but you expect from Allah that which they expect not. And Allah is ever Knowing and Wise",
    normalizedText:
      "ولا تهنوا في ابتغاء القوم ان تكونوا تالمون فانهم يالمون كما تالمون وترجون من الله ما لا يرجون وكان الله عليما حكيما",
  },
  {
    verseId: 104,
    name: "النساء",
    surahId: 4,
    text: "إِنَّآ أَنزَلۡنَآ إِلَيۡكَ ٱلۡكِتَٰبَ بِٱلۡحَقِّ لِتَحۡكُمَ بَيۡنَ ٱلنَّاسِ بِمَآ أَرَىٰكَ ٱللَّهُۚ وَلَا تَكُن لِّلۡخَآئِنِينَ خَصِيمٗا",
    translation:
      "Indeed, We have revealed to you, [O Muhammad], the Book in truth so you may judge between the people by that which Allah has shown you. And do not be for the deceitful an advocate",
    normalizedText:
      "انا انزلنا اليك الكتب بالحق لتحكم بين الناس بما ارىك الله ولا تكن للخاانين خصيما",
  },
  {
    verseId: 105,
    name: "النساء",
    surahId: 4,
    text: "وَٱسۡتَغۡفِرِ ٱللَّهَۖ إِنَّ ٱللَّهَ كَانَ غَفُورٗا رَّحِيمٗا",
    translation:
      "And seek forgiveness of Allah. Indeed, Allah is ever Forgiving and Merciful",
    normalizedText: "واستغفر الله ان الله كان غفورا رحيما",
  },
  {
    verseId: 106,
    name: "النساء",
    surahId: 4,
    text: "وَلَا تُجَٰدِلۡ عَنِ ٱلَّذِينَ يَخۡتَانُونَ أَنفُسَهُمۡۚ إِنَّ ٱللَّهَ لَا يُحِبُّ مَن كَانَ خَوَّانًا أَثِيمٗا",
    translation:
      "And do not argue on behalf of those who deceive themselves. Indeed, Allah loves not one who is a habitually sinful deceiver",
    normalizedText:
      "ولا تجدل عن الذين يختانون انفسهم ان الله لا يحب من كان خوانا اثيما",
  },
  {
    verseId: 107,
    name: "النساء",
    surahId: 4,
    text: "يَسۡتَخۡفُونَ مِنَ ٱلنَّاسِ وَلَا يَسۡتَخۡفُونَ مِنَ ٱللَّهِ وَهُوَ مَعَهُمۡ إِذۡ يُبَيِّتُونَ مَا لَا يَرۡضَىٰ مِنَ ٱلۡقَوۡلِۚ وَكَانَ ٱللَّهُ بِمَا يَعۡمَلُونَ مُحِيطًا",
    translation:
      "They conceal [their evil intentions and deeds] from the people, but they cannot conceal [them] from Allah, and He is with them [in His knowledge] when they spend the night in such as He does not accept of speech. And ever is Allah, of what they do, encompassing",
    normalizedText:
      "يستخفون من الناس ولا يستخفون من الله وهو معهم اذ يبيتون ما لا يرضى من القول وكان الله بما يعملون محيطا",
  },
  {
    verseId: 108,
    name: "النساء",
    surahId: 4,
    text: "هَـٰٓأَنتُمۡ هَـٰٓؤُلَآءِ جَٰدَلۡتُمۡ عَنۡهُمۡ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا فَمَن يُجَٰدِلُ ٱللَّهَ عَنۡهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ أَم مَّن يَكُونُ عَلَيۡهِمۡ وَكِيلٗا",
    translation:
      "Here you are - those who argue on their behalf in [this] worldly life - but who will argue with Allah for them on the Day of Resurrection, or who will [then] be their representative",
    normalizedText:
      "هانتم هالاء جدلتم عنهم في الحيوة الدنيا فمن يجدل الله عنهم يوم القيمة ام من يكون عليهم وكيلا",
  },
  {
    verseId: 109,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يَعۡمَلۡ سُوٓءًا أَوۡ يَظۡلِمۡ نَفۡسَهُۥ ثُمَّ يَسۡتَغۡفِرِ ٱللَّهَ يَجِدِ ٱللَّهَ غَفُورٗا رَّحِيمٗا",
    translation:
      "And whoever does a wrong or wrongs himself but then seeks forgiveness of Allah will find Allah Forgiving and Merciful",
    normalizedText:
      "ومن يعمل سوءا او يظلم نفسه ثم يستغفر الله يجد الله غفورا رحيما",
  },
  {
    verseId: 110,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يَكۡسِبۡ إِثۡمٗا فَإِنَّمَا يَكۡسِبُهُۥ عَلَىٰ نَفۡسِهِۦۚ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمٗا",
    translation:
      "And whoever commits a sin only earns it against himself. And Allah is ever Knowing and Wise",
    normalizedText: "ومن يكسب اثما فانما يكسبه على نفسه وكان الله عليما حكيما",
  },
  {
    verseId: 111,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يَكۡسِبۡ خَطِيٓـَٔةً أَوۡ إِثۡمٗا ثُمَّ يَرۡمِ بِهِۦ بَرِيٓـٔٗا فَقَدِ ٱحۡتَمَلَ بُهۡتَٰنٗا وَإِثۡمٗا مُّبِينٗا",
    translation:
      "But whoever earns an offense or a sin and then blames it on an innocent [person] has taken upon himself a slander and manifest sin",
    normalizedText:
      "ومن يكسب خطية او اثما ثم يرم به بريا فقد احتمل بهتنا واثما مبينا",
  },
  {
    verseId: 112,
    name: "النساء",
    surahId: 4,
    text: "وَلَوۡلَا فَضۡلُ ٱللَّهِ عَلَيۡكَ وَرَحۡمَتُهُۥ لَهَمَّت طَّآئِفَةٞ مِّنۡهُمۡ أَن يُضِلُّوكَ وَمَا يُضِلُّونَ إِلَّآ أَنفُسَهُمۡۖ وَمَا يَضُرُّونَكَ مِن شَيۡءٖۚ وَأَنزَلَ ٱللَّهُ عَلَيۡكَ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَعَلَّمَكَ مَا لَمۡ تَكُن تَعۡلَمُۚ وَكَانَ فَضۡلُ ٱللَّهِ عَلَيۡكَ عَظِيمٗا",
    translation:
      "And if it was not for the favor of Allah upon you, [O Muhammad], and His mercy, a group of them would have determined to mislead you. But they do not mislead except themselves, and they will not harm you at all. And Allah has revealed to you the Book and wisdom and has taught you that which you did not know. And ever has the favor of Allah upon you been great",
    normalizedText:
      "ولولا فضل الله عليك ورحمته لهمت طاافة منهم ان يضلوك وما يضلون الا انفسهم وما يضرونك من شيء وانزل الله عليك الكتب والحكمة وعلمك ما لم تكن تعلم وكان فضل الله عليك عظيما",
  },
  {
    verseId: 113,
    name: "النساء",
    surahId: 4,
    text: "۞لَّا خَيۡرَ فِي كَثِيرٖ مِّن نَّجۡوَىٰهُمۡ إِلَّا مَنۡ أَمَرَ بِصَدَقَةٍ أَوۡ مَعۡرُوفٍ أَوۡ إِصۡلَٰحِۭ بَيۡنَ ٱلنَّاسِۚ وَمَن يَفۡعَلۡ ذَٰلِكَ ٱبۡتِغَآءَ مَرۡضَاتِ ٱللَّهِ فَسَوۡفَ نُؤۡتِيهِ أَجۡرًا عَظِيمٗا",
    translation:
      "No good is there in much of their private conversation, except for those who enjoin charity or that which is right or conciliation between people. And whoever does that seeking means to the approval of Allah - then We are going to give him a great reward",
    normalizedText:
      "۞لا خير في كثير من نجوىهم الا من امر بصدقة او معروف او اصلح بين الناس ومن يفعل ذلك ابتغاء مرضات الله فسوف ناتيه اجرا عظيما",
  },
  {
    verseId: 114,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يُشَاقِقِ ٱلرَّسُولَ مِنۢ بَعۡدِ مَا تَبَيَّنَ لَهُ ٱلۡهُدَىٰ وَيَتَّبِعۡ غَيۡرَ سَبِيلِ ٱلۡمُؤۡمِنِينَ نُوَلِّهِۦ مَا تَوَلَّىٰ وَنُصۡلِهِۦ جَهَنَّمَۖ وَسَآءَتۡ مَصِيرًا",
    translation:
      "And whoever opposes the Messenger after guidance has become clear to him and follows other than the way of the believers - We will give him what he has taken and drive him into Hell, and evil it is as a destination",
    normalizedText:
      "ومن يشاقق الرسول من بعد ما تبين له الهدى ويتبع غير سبيل المامنين نوله ما تولى ونصله جهنم وساءت مصيرا",
  },
  {
    verseId: 115,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱللَّهَ لَا يَغۡفِرُ أَن يُشۡرَكَ بِهِۦ وَيَغۡفِرُ مَا دُونَ ذَٰلِكَ لِمَن يَشَآءُۚ وَمَن يُشۡرِكۡ بِٱللَّهِ فَقَدۡ ضَلَّ ضَلَٰلَۢا بَعِيدًا",
    translation:
      "Indeed, Allah does not forgive association with Him, but He forgives what is less than that for whom He wills. And he who associates others with Allah has certainly gone far astray",
    normalizedText:
      "ان الله لا يغفر ان يشرك به ويغفر ما دون ذلك لمن يشاء ومن يشرك بالله فقد ضل ضللا بعيدا",
  },
  {
    verseId: 116,
    name: "النساء",
    surahId: 4,
    text: "إِن يَدۡعُونَ مِن دُونِهِۦٓ إِلَّآ إِنَٰثٗا وَإِن يَدۡعُونَ إِلَّا شَيۡطَٰنٗا مَّرِيدٗا",
    translation:
      "They call upon instead of Him none but female [deities], and they [actually] call upon none but a rebellious Satan",
    normalizedText: "ان يدعون من دونه الا انثا وان يدعون الا شيطنا مريدا",
  },
  {
    verseId: 117,
    name: "النساء",
    surahId: 4,
    text: "لَّعَنَهُ ٱللَّهُۘ وَقَالَ لَأَتَّخِذَنَّ مِنۡ عِبَادِكَ نَصِيبٗا مَّفۡرُوضٗا",
    translation:
      'Whom Allah has cursed. For he had said, "I will surely take from among Your servants a specific portion',
    normalizedText: "لعنه الله وقال لاتخذن من عبادك نصيبا مفروضا",
  },
  {
    verseId: 118,
    name: "النساء",
    surahId: 4,
    text: "وَلَأُضِلَّنَّهُمۡ وَلَأُمَنِّيَنَّهُمۡ وَلَأٓمُرَنَّهُمۡ فَلَيُبَتِّكُنَّ ءَاذَانَ ٱلۡأَنۡعَٰمِ وَلَأٓمُرَنَّهُمۡ فَلَيُغَيِّرُنَّ خَلۡقَ ٱللَّهِۚ وَمَن يَتَّخِذِ ٱلشَّيۡطَٰنَ وَلِيّٗا مِّن دُونِ ٱللَّهِ فَقَدۡ خَسِرَ خُسۡرَانٗا مُّبِينٗا",
    translation:
      'And I will mislead them, and I will arouse in them [sinful] desires, and I will command them so they will slit the ears of cattle, and I will command them so they will change the creation of Allah." And whoever takes Satan as an ally instead of Allah has certainly sustained a clear loss',
    normalizedText:
      "ولاضلنهم ولامنينهم ولامرنهم فليبتكن ءاذان الانعم ولامرنهم فليغيرن خلق الله ومن يتخذ الشيطن وليا من دون الله فقد خسر خسرانا مبينا",
  },
  {
    verseId: 119,
    name: "النساء",
    surahId: 4,
    text: "يَعِدُهُمۡ وَيُمَنِّيهِمۡۖ وَمَا يَعِدُهُمُ ٱلشَّيۡطَٰنُ إِلَّا غُرُورًا",
    translation:
      "Satan promises them and arouses desire in them. But Satan does not promise them except delusion",
    normalizedText: "يعدهم ويمنيهم وما يعدهم الشيطن الا غرورا",
  },
  {
    verseId: 120,
    name: "النساء",
    surahId: 4,
    text: "أُوْلَـٰٓئِكَ مَأۡوَىٰهُمۡ جَهَنَّمُ وَلَا يَجِدُونَ عَنۡهَا مَحِيصٗا",
    translation:
      "The refuge of those will be Hell, and they will not find from it an escape",
    normalizedText: "اولاك ماوىهم جهنم ولا يجدون عنها محيصا",
  },
  {
    verseId: 121,
    name: "النساء",
    surahId: 4,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ سَنُدۡخِلُهُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدٗاۖ وَعۡدَ ٱللَّهِ حَقّٗاۚ وَمَنۡ أَصۡدَقُ مِنَ ٱللَّهِ قِيلٗا",
    translation:
      "But the ones who believe and do righteous deeds - We will admit them to gardens beneath which rivers flow, wherein they will abide forever. [It is] the promise of Allah, [which is] truth, and who is more truthful than Allah in statement",
    normalizedText:
      "والذين ءامنوا وعملوا الصلحت سندخلهم جنت تجري من تحتها الانهر خلدين فيها ابدا وعد الله حقا ومن اصدق من الله قيلا",
  },
  {
    verseId: 122,
    name: "النساء",
    surahId: 4,
    text: "لَّيۡسَ بِأَمَانِيِّكُمۡ وَلَآ أَمَانِيِّ أَهۡلِ ٱلۡكِتَٰبِۗ مَن يَعۡمَلۡ سُوٓءٗا يُجۡزَ بِهِۦ وَلَا يَجِدۡ لَهُۥ مِن دُونِ ٱللَّهِ وَلِيّٗا وَلَا نَصِيرٗا",
    translation:
      "Paradise is not [obtained] by your wishful thinking nor by that of the People of the Scripture. Whoever does a wrong will be recompensed for it, and he will not find besides Allah a protector or a helper",
    normalizedText:
      "ليس بامانيكم ولا اماني اهل الكتب من يعمل سوءا يجز به ولا يجد له من دون الله وليا ولا نصيرا",
  },
  {
    verseId: 123,
    name: "النساء",
    surahId: 4,
    text: "وَمَن يَعۡمَلۡ مِنَ ٱلصَّـٰلِحَٰتِ مِن ذَكَرٍ أَوۡ أُنثَىٰ وَهُوَ مُؤۡمِنٞ فَأُوْلَـٰٓئِكَ يَدۡخُلُونَ ٱلۡجَنَّةَ وَلَا يُظۡلَمُونَ نَقِيرٗا",
    translation:
      "And whoever does righteous deeds, whether male or female, while being a believer - those will enter Paradise and will not be wronged, [even as much as] the speck on a date seed",
    normalizedText:
      "ومن يعمل من الصلحت من ذكر او انثى وهو مامن فاولاك يدخلون الجنة ولا يظلمون نقيرا",
  },
  {
    verseId: 124,
    name: "النساء",
    surahId: 4,
    text: "وَمَنۡ أَحۡسَنُ دِينٗا مِّمَّنۡ أَسۡلَمَ وَجۡهَهُۥ لِلَّهِ وَهُوَ مُحۡسِنٞ وَٱتَّبَعَ مِلَّةَ إِبۡرَٰهِيمَ حَنِيفٗاۗ وَٱتَّخَذَ ٱللَّهُ إِبۡرَٰهِيمَ خَلِيلٗا",
    translation:
      "And who is better in religion than one who submits himself to Allah while being a doer of good and follows the religion of Abraham, inclining toward truth? And Allah took Abraham as an intimate friend",
    normalizedText:
      "ومن احسن دينا ممن اسلم وجهه لله وهو محسن واتبع ملة ابرهيم حنيفا واتخذ الله ابرهيم خليلا",
  },
  {
    verseId: 125,
    name: "النساء",
    surahId: 4,
    text: "وَلِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ وَكَانَ ٱللَّهُ بِكُلِّ شَيۡءٖ مُّحِيطٗا",
    translation:
      "And to Allah belongs whatever is in the heavens and whatever is on the earth. And ever is Allah, of all things, encompassing",
    normalizedText: "ولله ما في السموت وما في الارض وكان الله بكل شيء محيطا",
  },
  {
    verseId: 126,
    name: "النساء",
    surahId: 4,
    text: "وَيَسۡتَفۡتُونَكَ فِي ٱلنِّسَآءِۖ قُلِ ٱللَّهُ يُفۡتِيكُمۡ فِيهِنَّ وَمَا يُتۡلَىٰ عَلَيۡكُمۡ فِي ٱلۡكِتَٰبِ فِي يَتَٰمَى ٱلنِّسَآءِ ٱلَّـٰتِي لَا تُؤۡتُونَهُنَّ مَا كُتِبَ لَهُنَّ وَتَرۡغَبُونَ أَن تَنكِحُوهُنَّ وَٱلۡمُسۡتَضۡعَفِينَ مِنَ ٱلۡوِلۡدَٰنِ وَأَن تَقُومُواْ لِلۡيَتَٰمَىٰ بِٱلۡقِسۡطِۚ وَمَا تَفۡعَلُواْ مِنۡ خَيۡرٖ فَإِنَّ ٱللَّهَ كَانَ بِهِۦ عَلِيمٗا",
    translation:
      'And they request from you, [O Muhammad], a [legal] ruling concerning women. Say, "Allah gives you a ruling about them and [about] what has been recited to you in the Book concerning the orphan girls to whom you do not give what is decreed for them - and [yet] you desire to marry them - and concerning the oppressed among children and that you maintain for orphans [their rights] in justice." And whatever you do of good - indeed, Allah is ever Knowing of it',
    normalizedText:
      "ويستفتونك في النساء قل الله يفتيكم فيهن وما يتلى عليكم في الكتب في يتمى النساء التي لا تاتونهن ما كتب لهن وترغبون ان تنكحوهن والمستضعفين من الولدن وان تقوموا لليتمى بالقسط وما تفعلوا من خير فان الله كان به عليما",
  },
  {
    verseId: 127,
    name: "النساء",
    surahId: 4,
    text: "وَإِنِ ٱمۡرَأَةٌ خَافَتۡ مِنۢ بَعۡلِهَا نُشُوزًا أَوۡ إِعۡرَاضٗا فَلَا جُنَاحَ عَلَيۡهِمَآ أَن يُصۡلِحَا بَيۡنَهُمَا صُلۡحٗاۚ وَٱلصُّلۡحُ خَيۡرٞۗ وَأُحۡضِرَتِ ٱلۡأَنفُسُ ٱلشُّحَّۚ وَإِن تُحۡسِنُواْ وَتَتَّقُواْ فَإِنَّ ٱللَّهَ كَانَ بِمَا تَعۡمَلُونَ خَبِيرٗا",
    translation:
      "And if a woman fears from her husband contempt or evasion, there is no sin upon them if they make terms of settlement between them - and settlement is best. And present in [human] souls is stinginess. But if you do good and fear Allah - then indeed Allah is ever, with what you do, Acquainted",
    normalizedText:
      "وان امراة خافت من بعلها نشوزا او اعراضا فلا جناح عليهما ان يصلحا بينهما صلحا والصلح خير واحضرت الانفس الشح وان تحسنوا وتتقوا فان الله كان بما تعملون خبيرا",
  },
  {
    verseId: 128,
    name: "النساء",
    surahId: 4,
    text: "وَلَن تَسۡتَطِيعُوٓاْ أَن تَعۡدِلُواْ بَيۡنَ ٱلنِّسَآءِ وَلَوۡ حَرَصۡتُمۡۖ فَلَا تَمِيلُواْ كُلَّ ٱلۡمَيۡلِ فَتَذَرُوهَا كَٱلۡمُعَلَّقَةِۚ وَإِن تُصۡلِحُواْ وَتَتَّقُواْ فَإِنَّ ٱللَّهَ كَانَ غَفُورٗا رَّحِيمٗا",
    translation:
      "And you will never be able to be equal [in feeling] between wives, even if you should strive [to do so]. So do not incline completely [toward one] and leave another hanging. And if you amend [your affairs] and fear Allah - then indeed, Allah is ever Forgiving and Merciful",
    normalizedText:
      "ولن تستطيعوا ان تعدلوا بين النساء ولو حرصتم فلا تميلوا كل الميل فتذروها كالمعلقة وان تصلحوا وتتقوا فان الله كان غفورا رحيما",
  },
  {
    verseId: 129,
    name: "النساء",
    surahId: 4,
    text: "وَإِن يَتَفَرَّقَا يُغۡنِ ٱللَّهُ كُلّٗا مِّن سَعَتِهِۦۚ وَكَانَ ٱللَّهُ وَٰسِعًا حَكِيمٗا",
    translation:
      "But if they separate [by divorce], Allah will enrich each [of them] from His abundance. And ever is Allah Encompassing and Wise",
    normalizedText: "وان يتفرقا يغن الله كلا من سعته وكان الله وسعا حكيما",
  },
  {
    verseId: 130,
    name: "النساء",
    surahId: 4,
    text: "وَلِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۗ وَلَقَدۡ وَصَّيۡنَا ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ مِن قَبۡلِكُمۡ وَإِيَّاكُمۡ أَنِ ٱتَّقُواْ ٱللَّهَۚ وَإِن تَكۡفُرُواْ فَإِنَّ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ وَكَانَ ٱللَّهُ غَنِيًّا حَمِيدٗا",
    translation:
      "And to Allah belongs whatever is in the heavens and whatever is on the earth. And We have instructed those who were given the Scripture before you and yourselves to fear Allah. But if you disbelieve - then to Allah belongs whatever is in the heavens and whatever is on the earth. And ever is Allah Free of need and Praiseworthy",
    normalizedText:
      "ولله ما في السموت وما في الارض ولقد وصينا الذين اوتوا الكتب من قبلكم واياكم ان اتقوا الله وان تكفروا فان لله ما في السموت وما في الارض وكان الله غنيا حميدا",
  },
  {
    verseId: 131,
    name: "النساء",
    surahId: 4,
    text: "وَلِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ وَكَفَىٰ بِٱللَّهِ وَكِيلًا",
    translation:
      "And to Allah belongs whatever is in the heavens and whatever is on the earth. And sufficient is Allah as Disposer of affairs",
    normalizedText: "ولله ما في السموت وما في الارض وكفى بالله وكيلا",
  },
  {
    verseId: 132,
    name: "النساء",
    surahId: 4,
    text: "إِن يَشَأۡ يُذۡهِبۡكُمۡ أَيُّهَا ٱلنَّاسُ وَيَأۡتِ بِـَٔاخَرِينَۚ وَكَانَ ٱللَّهُ عَلَىٰ ذَٰلِكَ قَدِيرٗا",
    translation:
      "If He wills, He can do away with you, O people, and bring others [in your place]. And ever is Allah competent to do that",
    normalizedText:
      "ان يشا يذهبكم ايها الناس ويات باخرين وكان الله على ذلك قديرا",
  },
  {
    verseId: 133,
    name: "النساء",
    surahId: 4,
    text: "مَّن كَانَ يُرِيدُ ثَوَابَ ٱلدُّنۡيَا فَعِندَ ٱللَّهِ ثَوَابُ ٱلدُّنۡيَا وَٱلۡأٓخِرَةِۚ وَكَانَ ٱللَّهُ سَمِيعَۢا بَصِيرٗا",
    translation:
      "Whoever desires the reward of this world - then with Allah is the reward of this world and the Hereafter. And ever is Allah Hearing and Seeing",
    normalizedText:
      "من كان يريد ثواب الدنيا فعند الله ثواب الدنيا والاخرة وكان الله سميعا بصيرا",
  },
  {
    verseId: 134,
    name: "النساء",
    surahId: 4,
    text: "۞يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ كُونُواْ قَوَّـٰمِينَ بِٱلۡقِسۡطِ شُهَدَآءَ لِلَّهِ وَلَوۡ عَلَىٰٓ أَنفُسِكُمۡ أَوِ ٱلۡوَٰلِدَيۡنِ وَٱلۡأَقۡرَبِينَۚ إِن يَكُنۡ غَنِيًّا أَوۡ فَقِيرٗا فَٱللَّهُ أَوۡلَىٰ بِهِمَاۖ فَلَا تَتَّبِعُواْ ٱلۡهَوَىٰٓ أَن تَعۡدِلُواْۚ وَإِن تَلۡوُۥٓاْ أَوۡ تُعۡرِضُواْ فَإِنَّ ٱللَّهَ كَانَ بِمَا تَعۡمَلُونَ خَبِيرٗا",
    translation:
      "O you who have believed, be persistently standing firm in justice, witnesses for Allah, even if it be against yourselves or parents and relatives. Whether one is rich or poor, Allah is more worthy of both. So follow not [personal] inclination, lest you not be just. And if you distort [your testimony] or refuse [to give it], then indeed Allah is ever, with what you do, Acquainted",
    normalizedText:
      "۞يايها الذين ءامنوا كونوا قومين بالقسط شهداء لله ولو على انفسكم او الولدين والاقربين ان يكن غنيا او فقيرا فالله اولى بهما فلا تتبعوا الهوى ان تعدلوا وان تلوا او تعرضوا فان الله كان بما تعملون خبيرا",
  },
  {
    verseId: 135,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ ءَامِنُواْ بِٱللَّهِ وَرَسُولِهِۦ وَٱلۡكِتَٰبِ ٱلَّذِي نَزَّلَ عَلَىٰ رَسُولِهِۦ وَٱلۡكِتَٰبِ ٱلَّذِيٓ أَنزَلَ مِن قَبۡلُۚ وَمَن يَكۡفُرۡ بِٱللَّهِ وَمَلَـٰٓئِكَتِهِۦ وَكُتُبِهِۦ وَرُسُلِهِۦ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ فَقَدۡ ضَلَّ ضَلَٰلَۢا بَعِيدًا",
    translation:
      "O you who have believed, believe in Allah and His Messenger and the Book that He sent down upon His Messenger and the Scripture which He sent down before. And whoever disbelieves in Allah, His angels, His books, His messengers, and the Last Day has certainly gone far astray",
    normalizedText:
      "يايها الذين ءامنوا ءامنوا بالله ورسوله والكتب الذي نزل على رسوله والكتب الذي انزل من قبل ومن يكفر بالله وملاكته وكتبه ورسله واليوم الاخر فقد ضل ضللا بعيدا",
  },
  {
    verseId: 136,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ ثُمَّ كَفَرُواْ ثُمَّ ءَامَنُواْ ثُمَّ كَفَرُواْ ثُمَّ ٱزۡدَادُواْ كُفۡرٗا لَّمۡ يَكُنِ ٱللَّهُ لِيَغۡفِرَ لَهُمۡ وَلَا لِيَهۡدِيَهُمۡ سَبِيلَۢا",
    translation:
      "Indeed, those who have believed then disbelieved, then believed, then disbelieved, and then increased in disbelief - never will Allah forgive them, nor will He guide them to a way",
    normalizedText:
      "ان الذين ءامنوا ثم كفروا ثم ءامنوا ثم كفروا ثم ازدادوا كفرا لم يكن الله ليغفر لهم ولا ليهديهم سبيلا",
  },
  {
    verseId: 137,
    name: "النساء",
    surahId: 4,
    text: "بَشِّرِ ٱلۡمُنَٰفِقِينَ بِأَنَّ لَهُمۡ عَذَابًا أَلِيمًا",
    translation:
      "Give tidings to the hypocrites that there is for them a painful punishment",
    normalizedText: "بشر المنفقين بان لهم عذابا اليما",
  },
  {
    verseId: 138,
    name: "النساء",
    surahId: 4,
    text: "ٱلَّذِينَ يَتَّخِذُونَ ٱلۡكَٰفِرِينَ أَوۡلِيَآءَ مِن دُونِ ٱلۡمُؤۡمِنِينَۚ أَيَبۡتَغُونَ عِندَهُمُ ٱلۡعِزَّةَ فَإِنَّ ٱلۡعِزَّةَ لِلَّهِ جَمِيعٗا",
    translation:
      "Those who take disbelievers as allies instead of the believers. Do they seek with them honor [through power]? But indeed, honor belongs to Allah entirely",
    normalizedText:
      "الذين يتخذون الكفرين اولياء من دون المامنين ايبتغون عندهم العزة فان العزة لله جميعا",
  },
  {
    verseId: 139,
    name: "النساء",
    surahId: 4,
    text: "وَقَدۡ نَزَّلَ عَلَيۡكُمۡ فِي ٱلۡكِتَٰبِ أَنۡ إِذَا سَمِعۡتُمۡ ءَايَٰتِ ٱللَّهِ يُكۡفَرُ بِهَا وَيُسۡتَهۡزَأُ بِهَا فَلَا تَقۡعُدُواْ مَعَهُمۡ حَتَّىٰ يَخُوضُواْ فِي حَدِيثٍ غَيۡرِهِۦٓ إِنَّكُمۡ إِذٗا مِّثۡلُهُمۡۗ إِنَّ ٱللَّهَ جَامِعُ ٱلۡمُنَٰفِقِينَ وَٱلۡكَٰفِرِينَ فِي جَهَنَّمَ جَمِيعًا",
    translation:
      "And it has already come down to you in the Book that when you hear the verses of Allah [recited], they are denied [by them] and ridiculed; so do not sit with them until they enter into another conversation. Indeed, you would then be like them. Indeed Allah will gather the hypocrites and disbelievers in Hell all together",
    normalizedText:
      "وقد نزل عليكم في الكتب ان اذا سمعتم ءايت الله يكفر بها ويستهزا بها فلا تقعدوا معهم حتى يخوضوا في حديث غيره انكم اذا مثلهم ان الله جامع المنفقين والكفرين في جهنم جميعا",
  },
  {
    verseId: 140,
    name: "النساء",
    surahId: 4,
    text: "ٱلَّذِينَ يَتَرَبَّصُونَ بِكُمۡ فَإِن كَانَ لَكُمۡ فَتۡحٞ مِّنَ ٱللَّهِ قَالُوٓاْ أَلَمۡ نَكُن مَّعَكُمۡ وَإِن كَانَ لِلۡكَٰفِرِينَ نَصِيبٞ قَالُوٓاْ أَلَمۡ نَسۡتَحۡوِذۡ عَلَيۡكُمۡ وَنَمۡنَعۡكُم مِّنَ ٱلۡمُؤۡمِنِينَۚ فَٱللَّهُ يَحۡكُمُ بَيۡنَكُمۡ يَوۡمَ ٱلۡقِيَٰمَةِۚ وَلَن يَجۡعَلَ ٱللَّهُ لِلۡكَٰفِرِينَ عَلَى ٱلۡمُؤۡمِنِينَ سَبِيلًا",
    translation:
      'Those who wait [and watch] you. Then if you gain a victory from Allah, they say, "Were we not with you?" But if the disbelievers have a success, they say [to them], "Did we not gain the advantage over you, but we protected you from the believers?" Allah will judge between [all of] you on the Day of Resurrection, and never will Allah give the disbelievers over the believers a way [to overcome them]',
    normalizedText:
      "الذين يتربصون بكم فان كان لكم فتح من الله قالوا الم نكن معكم وان كان للكفرين نصيب قالوا الم نستحوذ عليكم ونمنعكم من المامنين فالله يحكم بينكم يوم القيمة ولن يجعل الله للكفرين على المامنين سبيلا",
  },
  {
    verseId: 141,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلۡمُنَٰفِقِينَ يُخَٰدِعُونَ ٱللَّهَ وَهُوَ خَٰدِعُهُمۡ وَإِذَا قَامُوٓاْ إِلَى ٱلصَّلَوٰةِ قَامُواْ كُسَالَىٰ يُرَآءُونَ ٱلنَّاسَ وَلَا يَذۡكُرُونَ ٱللَّهَ إِلَّا قَلِيلٗا",
    translation:
      "Indeed, the hypocrites [think to] deceive Allah, but He is deceiving them. And when they stand for prayer, they stand lazily, showing [themselves to] the people and not remembering Allah except a little",
    normalizedText:
      "ان المنفقين يخدعون الله وهو خدعهم واذا قاموا الى الصلوة قاموا كسالى يراءون الناس ولا يذكرون الله الا قليلا",
  },
  {
    verseId: 142,
    name: "النساء",
    surahId: 4,
    text: "مُّذَبۡذَبِينَ بَيۡنَ ذَٰلِكَ لَآ إِلَىٰ هَـٰٓؤُلَآءِ وَلَآ إِلَىٰ هَـٰٓؤُلَآءِۚ وَمَن يُضۡلِلِ ٱللَّهُ فَلَن تَجِدَ لَهُۥ سَبِيلٗا",
    translation:
      "Wavering between them, [belonging] neither to the believers nor to the disbelievers. And whoever Allah leaves astray - never will you find for him a way",
    normalizedText:
      "مذبذبين بين ذلك لا الى هالاء ولا الى هالاء ومن يضلل الله فلن تجد له سبيلا",
  },
  {
    verseId: 143,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّخِذُواْ ٱلۡكَٰفِرِينَ أَوۡلِيَآءَ مِن دُونِ ٱلۡمُؤۡمِنِينَۚ أَتُرِيدُونَ أَن تَجۡعَلُواْ لِلَّهِ عَلَيۡكُمۡ سُلۡطَٰنٗا مُّبِينًا",
    translation:
      "O you who have believed, do not take the disbelievers as allies instead of the believers. Do you wish to give Allah against yourselves a clear case",
    normalizedText:
      "يايها الذين ءامنوا لا تتخذوا الكفرين اولياء من دون المامنين اتريدون ان تجعلوا لله عليكم سلطنا مبينا",
  },
  {
    verseId: 144,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلۡمُنَٰفِقِينَ فِي ٱلدَّرۡكِ ٱلۡأَسۡفَلِ مِنَ ٱلنَّارِ وَلَن تَجِدَ لَهُمۡ نَصِيرًا",
    translation:
      "Indeed, the hypocrites will be in the lowest depths of the Fire - and never will you find for them a helper",
    normalizedText: "ان المنفقين في الدرك الاسفل من النار ولن تجد لهم نصيرا",
  },
  {
    verseId: 145,
    name: "النساء",
    surahId: 4,
    text: "إِلَّا ٱلَّذِينَ تَابُواْ وَأَصۡلَحُواْ وَٱعۡتَصَمُواْ بِٱللَّهِ وَأَخۡلَصُواْ دِينَهُمۡ لِلَّهِ فَأُوْلَـٰٓئِكَ مَعَ ٱلۡمُؤۡمِنِينَۖ وَسَوۡفَ يُؤۡتِ ٱللَّهُ ٱلۡمُؤۡمِنِينَ أَجۡرًا عَظِيمٗا",
    translation:
      "Except for those who repent, correct themselves, hold fast to Allah, and are sincere in their religion for Allah, for those will be with the believers. And Allah is going to give the believers a great reward",
    normalizedText:
      "الا الذين تابوا واصلحوا واعتصموا بالله واخلصوا دينهم لله فاولاك مع المامنين وسوف يات الله المامنين اجرا عظيما",
  },
  {
    verseId: 146,
    name: "النساء",
    surahId: 4,
    text: "مَّا يَفۡعَلُ ٱللَّهُ بِعَذَابِكُمۡ إِن شَكَرۡتُمۡ وَءَامَنتُمۡۚ وَكَانَ ٱللَّهُ شَاكِرًا عَلِيمٗا",
    translation:
      "What would Allah do with your punishment if you are grateful and believe? And ever is Allah Appreciative and Knowing",
    normalizedText:
      "ما يفعل الله بعذابكم ان شكرتم وءامنتم وكان الله شاكرا عليما",
  },
  {
    verseId: 147,
    name: "النساء",
    surahId: 4,
    text: "۞لَّا يُحِبُّ ٱللَّهُ ٱلۡجَهۡرَ بِٱلسُّوٓءِ مِنَ ٱلۡقَوۡلِ إِلَّا مَن ظُلِمَۚ وَكَانَ ٱللَّهُ سَمِيعًا عَلِيمًا",
    translation:
      "Allah does not like the public mention of evil except by one who has been wronged. And ever is Allah Hearing and Knowing",
    normalizedText:
      "۞لا يحب الله الجهر بالسوء من القول الا من ظلم وكان الله سميعا عليما",
  },
  {
    verseId: 148,
    name: "النساء",
    surahId: 4,
    text: "إِن تُبۡدُواْ خَيۡرًا أَوۡ تُخۡفُوهُ أَوۡ تَعۡفُواْ عَن سُوٓءٖ فَإِنَّ ٱللَّهَ كَانَ عَفُوّٗا قَدِيرًا",
    translation:
      "If [instead] you show [some] good or conceal it or pardon an offense - indeed, Allah is ever Pardoning and Competent",
    normalizedText:
      "ان تبدوا خيرا او تخفوه او تعفوا عن سوء فان الله كان عفوا قديرا",
  },
  {
    verseId: 149,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلَّذِينَ يَكۡفُرُونَ بِٱللَّهِ وَرُسُلِهِۦ وَيُرِيدُونَ أَن يُفَرِّقُواْ بَيۡنَ ٱللَّهِ وَرُسُلِهِۦ وَيَقُولُونَ نُؤۡمِنُ بِبَعۡضٖ وَنَكۡفُرُ بِبَعۡضٖ وَيُرِيدُونَ أَن يَتَّخِذُواْ بَيۡنَ ذَٰلِكَ سَبِيلًا",
    translation:
      'Indeed, those who disbelieve in Allah and His messengers and wish to discriminate between Allah and His messengers and say, "We believe in some and disbelieve in others," and wish to adopt a way in between',
    normalizedText:
      "ان الذين يكفرون بالله ورسله ويريدون ان يفرقوا بين الله ورسله ويقولون نامن ببعض ونكفر ببعض ويريدون ان يتخذوا بين ذلك سبيلا",
  },
  {
    verseId: 150,
    name: "النساء",
    surahId: 4,
    text: "أُوْلَـٰٓئِكَ هُمُ ٱلۡكَٰفِرُونَ حَقّٗاۚ وَأَعۡتَدۡنَا لِلۡكَٰفِرِينَ عَذَابٗا مُّهِينٗا",
    translation:
      "Those are the disbelievers, truly. And We have prepared for the disbelievers a humiliating punishment",
    normalizedText: "اولاك هم الكفرون حقا واعتدنا للكفرين عذابا مهينا",
  },
  {
    verseId: 151,
    name: "النساء",
    surahId: 4,
    text: "وَٱلَّذِينَ ءَامَنُواْ بِٱللَّهِ وَرُسُلِهِۦ وَلَمۡ يُفَرِّقُواْ بَيۡنَ أَحَدٖ مِّنۡهُمۡ أُوْلَـٰٓئِكَ سَوۡفَ يُؤۡتِيهِمۡ أُجُورَهُمۡۚ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمٗا",
    translation:
      "But they who believe in Allah and His messengers and do not discriminate between any of them - to those He is going to give their rewards. And ever is Allah Forgiving and Merciful",
    normalizedText:
      "والذين ءامنوا بالله ورسله ولم يفرقوا بين احد منهم اولاك سوف ياتيهم اجورهم وكان الله غفورا رحيما",
  },
  {
    verseId: 152,
    name: "النساء",
    surahId: 4,
    text: "يَسۡـَٔلُكَ أَهۡلُ ٱلۡكِتَٰبِ أَن تُنَزِّلَ عَلَيۡهِمۡ كِتَٰبٗا مِّنَ ٱلسَّمَآءِۚ فَقَدۡ سَأَلُواْ مُوسَىٰٓ أَكۡبَرَ مِن ذَٰلِكَ فَقَالُوٓاْ أَرِنَا ٱللَّهَ جَهۡرَةٗ فَأَخَذَتۡهُمُ ٱلصَّـٰعِقَةُ بِظُلۡمِهِمۡۚ ثُمَّ ٱتَّخَذُواْ ٱلۡعِجۡلَ مِنۢ بَعۡدِ مَا جَآءَتۡهُمُ ٱلۡبَيِّنَٰتُ فَعَفَوۡنَا عَن ذَٰلِكَۚ وَءَاتَيۡنَا مُوسَىٰ سُلۡطَٰنٗا مُّبِينٗا",
    translation:
      'The People of the Scripture ask you to bring down to them a book from the heaven. But they had asked of Moses [even] greater than that and said, "Show us Allah outright," so the thunderbolt struck them for their wrongdoing. Then they took the calf [for worship] after clear evidences had come to them, and We pardoned that. And We gave Moses a clear authority',
    normalizedText:
      "يسلك اهل الكتب ان تنزل عليهم كتبا من السماء فقد سالوا موسى اكبر من ذلك فقالوا ارنا الله جهرة فاخذتهم الصعقة بظلمهم ثم اتخذوا العجل من بعد ما جاءتهم البينت فعفونا عن ذلك وءاتينا موسى سلطنا مبينا",
  },
  {
    verseId: 153,
    name: "النساء",
    surahId: 4,
    text: "وَرَفَعۡنَا فَوۡقَهُمُ ٱلطُّورَ بِمِيثَٰقِهِمۡ وَقُلۡنَا لَهُمُ ٱدۡخُلُواْ ٱلۡبَابَ سُجَّدٗا وَقُلۡنَا لَهُمۡ لَا تَعۡدُواْ فِي ٱلسَّبۡتِ وَأَخَذۡنَا مِنۡهُم مِّيثَٰقًا غَلِيظٗا",
    translation:
      'And We raised over them the mount for [refusal of] their covenant; and We said to them, "Enter the gate bowing humbly", and We said to them, "Do not transgress on the sabbath", and We took from them a solemn covenant',
    normalizedText:
      "ورفعنا فوقهم الطور بميثقهم وقلنا لهم ادخلوا الباب سجدا وقلنا لهم لا تعدوا في السبت واخذنا منهم ميثقا غليظا",
  },
  {
    verseId: 154,
    name: "النساء",
    surahId: 4,
    text: "فَبِمَا نَقۡضِهِم مِّيثَٰقَهُمۡ وَكُفۡرِهِم بِـَٔايَٰتِ ٱللَّهِ وَقَتۡلِهِمُ ٱلۡأَنۢبِيَآءَ بِغَيۡرِ حَقّٖ وَقَوۡلِهِمۡ قُلُوبُنَا غُلۡفُۢۚ بَلۡ طَبَعَ ٱللَّهُ عَلَيۡهَا بِكُفۡرِهِمۡ فَلَا يُؤۡمِنُونَ إِلَّا قَلِيلٗا",
    translation:
      'And [We cursed them] for their breaking of the covenant and their disbelief in the signs of Allah and their killing of the prophets without right and their saying, "Our hearts are wrapped". Rather, Allah has sealed them because of their disbelief, so they believe not, except for a few',
    normalizedText:
      "فبما نقضهم ميثقهم وكفرهم بايت الله وقتلهم الانبياء بغير حق وقولهم قلوبنا غلف بل طبع الله عليها بكفرهم فلا يامنون الا قليلا",
  },
  {
    verseId: 155,
    name: "النساء",
    surahId: 4,
    text: "وَبِكُفۡرِهِمۡ وَقَوۡلِهِمۡ عَلَىٰ مَرۡيَمَ بُهۡتَٰنًا عَظِيمٗا",
    translation:
      "And [We cursed them] for their disbelief and their saying against Mary a great slander",
    normalizedText: "وبكفرهم وقولهم على مريم بهتنا عظيما",
  },
  {
    verseId: 156,
    name: "النساء",
    surahId: 4,
    text: "وَقَوۡلِهِمۡ إِنَّا قَتَلۡنَا ٱلۡمَسِيحَ عِيسَى ٱبۡنَ مَرۡيَمَ رَسُولَ ٱللَّهِ وَمَا قَتَلُوهُ وَمَا صَلَبُوهُ وَلَٰكِن شُبِّهَ لَهُمۡۚ وَإِنَّ ٱلَّذِينَ ٱخۡتَلَفُواْ فِيهِ لَفِي شَكّٖ مِّنۡهُۚ مَا لَهُم بِهِۦ مِنۡ عِلۡمٍ إِلَّا ٱتِّبَاعَ ٱلظَّنِّۚ وَمَا قَتَلُوهُ يَقِينَۢا",
    translation:
      'And [for] their saying, "Indeed, we have killed the Messiah, Jesus, the son of Mary, the messenger of Allah." And they did not kill him, nor did they crucify him; but [another] was made to resemble him to them. And indeed, those who differ over it are in doubt about it. They have no knowledge of it except the following of assumption. And they did not kill him, for certain',
    normalizedText:
      "وقولهم انا قتلنا المسيح عيسى ابن مريم رسول الله وما قتلوه وما صلبوه ولكن شبه لهم وان الذين اختلفوا فيه لفي شك منه ما لهم به من علم الا اتباع الظن وما قتلوه يقينا",
  },
  {
    verseId: 157,
    name: "النساء",
    surahId: 4,
    text: "بَل رَّفَعَهُ ٱللَّهُ إِلَيۡهِۚ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمٗا",
    translation:
      "Rather, Allah raised him to Himself. And ever is Allah Exalted in Might and Wise",
    normalizedText: "بل رفعه الله اليه وكان الله عزيزا حكيما",
  },
  {
    verseId: 158,
    name: "النساء",
    surahId: 4,
    text: "وَإِن مِّنۡ أَهۡلِ ٱلۡكِتَٰبِ إِلَّا لَيُؤۡمِنَنَّ بِهِۦ قَبۡلَ مَوۡتِهِۦۖ وَيَوۡمَ ٱلۡقِيَٰمَةِ يَكُونُ عَلَيۡهِمۡ شَهِيدٗا",
    translation:
      "And there is none from the People of the Scripture but that he will surely believe in Jesus before his death. And on the Day of Resurrection he will be against them a witness",
    normalizedText:
      "وان من اهل الكتب الا ليامنن به قبل موته ويوم القيمة يكون عليهم شهيدا",
  },
  {
    verseId: 159,
    name: "النساء",
    surahId: 4,
    text: "فَبِظُلۡمٖ مِّنَ ٱلَّذِينَ هَادُواْ حَرَّمۡنَا عَلَيۡهِمۡ طَيِّبَٰتٍ أُحِلَّتۡ لَهُمۡ وَبِصَدِّهِمۡ عَن سَبِيلِ ٱللَّهِ كَثِيرٗا",
    translation:
      "For wrongdoing on the part of the Jews, We made unlawful for them [certain] good foods which had been lawful to them, and for their averting from the way of Allah many [people]",
    normalizedText:
      "فبظلم من الذين هادوا حرمنا عليهم طيبت احلت لهم وبصدهم عن سبيل الله كثيرا",
  },
  {
    verseId: 160,
    name: "النساء",
    surahId: 4,
    text: "وَأَخۡذِهِمُ ٱلرِّبَوٰاْ وَقَدۡ نُهُواْ عَنۡهُ وَأَكۡلِهِمۡ أَمۡوَٰلَ ٱلنَّاسِ بِٱلۡبَٰطِلِۚ وَأَعۡتَدۡنَا لِلۡكَٰفِرِينَ مِنۡهُمۡ عَذَابًا أَلِيمٗا",
    translation:
      "And [for] their taking of usury while they had been forbidden from it, and their consuming of the people's wealth unjustly. And we have prepared for the disbelievers among them a painful punishment",
    normalizedText:
      "واخذهم الربوا وقد نهوا عنه واكلهم امول الناس بالبطل واعتدنا للكفرين منهم عذابا اليما",
  },
  {
    verseId: 161,
    name: "النساء",
    surahId: 4,
    text: "لَّـٰكِنِ ٱلرَّـٰسِخُونَ فِي ٱلۡعِلۡمِ مِنۡهُمۡ وَٱلۡمُؤۡمِنُونَ يُؤۡمِنُونَ بِمَآ أُنزِلَ إِلَيۡكَ وَمَآ أُنزِلَ مِن قَبۡلِكَۚ وَٱلۡمُقِيمِينَ ٱلصَّلَوٰةَۚ وَٱلۡمُؤۡتُونَ ٱلزَّكَوٰةَ وَٱلۡمُؤۡمِنُونَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ أُوْلَـٰٓئِكَ سَنُؤۡتِيهِمۡ أَجۡرًا عَظِيمًا",
    translation:
      "But those firm in knowledge among them and the believers believe in what has been revealed to you, [O Muhammad], and what was revealed before you. And the establishers of prayer [especially] and the givers of zakah and the believers in Allah and the Last Day - those We will give a great reward",
    normalizedText:
      "لكن الرسخون في العلم منهم والمامنون يامنون بما انزل اليك وما انزل من قبلك والمقيمين الصلوة والماتون الزكوة والمامنون بالله واليوم الاخر اولاك سناتيهم اجرا عظيما",
  },
  {
    verseId: 162,
    name: "النساء",
    surahId: 4,
    text: "۞إِنَّآ أَوۡحَيۡنَآ إِلَيۡكَ كَمَآ أَوۡحَيۡنَآ إِلَىٰ نُوحٖ وَٱلنَّبِيِّـۧنَ مِنۢ بَعۡدِهِۦۚ وَأَوۡحَيۡنَآ إِلَىٰٓ إِبۡرَٰهِيمَ وَإِسۡمَٰعِيلَ وَإِسۡحَٰقَ وَيَعۡقُوبَ وَٱلۡأَسۡبَاطِ وَعِيسَىٰ وَأَيُّوبَ وَيُونُسَ وَهَٰرُونَ وَسُلَيۡمَٰنَۚ وَءَاتَيۡنَا دَاوُۥدَ زَبُورٗا",
    translation:
      "Indeed, We have revealed to you, [O Muhammad], as We revealed to Noah and the prophets after him. And we revealed to Abraham, Ishmael, Isaac, Jacob, the Descendants, Jesus, Job, Jonah, Aaron, and Solomon, and to David We gave the book [of Psalms]",
    normalizedText:
      "۞انا اوحينا اليك كما اوحينا الى نوح والنبين من بعده واوحينا الى ابرهيم واسمعيل واسحق ويعقوب والاسباط وعيسى وايوب ويونس وهرون وسليمن وءاتينا داود زبورا",
  },
  {
    verseId: 163,
    name: "النساء",
    surahId: 4,
    text: "وَرُسُلٗا قَدۡ قَصَصۡنَٰهُمۡ عَلَيۡكَ مِن قَبۡلُ وَرُسُلٗا لَّمۡ نَقۡصُصۡهُمۡ عَلَيۡكَۚ وَكَلَّمَ ٱللَّهُ مُوسَىٰ تَكۡلِيمٗا",
    translation:
      "And [We sent] messengers about whom We have related [their stories] to you before and messengers about whom We have not related to you. And Allah spoke to Moses with [direct] speech",
    normalizedText:
      "ورسلا قد قصصنهم عليك من قبل ورسلا لم نقصصهم عليك وكلم الله موسى تكليما",
  },
  {
    verseId: 164,
    name: "النساء",
    surahId: 4,
    text: "رُّسُلٗا مُّبَشِّرِينَ وَمُنذِرِينَ لِئَلَّا يَكُونَ لِلنَّاسِ عَلَى ٱللَّهِ حُجَّةُۢ بَعۡدَ ٱلرُّسُلِۚ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمٗا",
    translation:
      "[We sent] messengers as bringers of good tidings and warners so that mankind will have no argument against Allah after the messengers. And ever is Allah Exalted in Might and Wise",
    normalizedText:
      "رسلا مبشرين ومنذرين لالا يكون للناس على الله حجة بعد الرسل وكان الله عزيزا حكيما",
  },
  {
    verseId: 165,
    name: "النساء",
    surahId: 4,
    text: "لَّـٰكِنِ ٱللَّهُ يَشۡهَدُ بِمَآ أَنزَلَ إِلَيۡكَۖ أَنزَلَهُۥ بِعِلۡمِهِۦۖ وَٱلۡمَلَـٰٓئِكَةُ يَشۡهَدُونَۚ وَكَفَىٰ بِٱللَّهِ شَهِيدًا",
    translation:
      "But Allah bears witness to that which He has revealed to you. He has sent it down with His knowledge, and the angels bear witness [as well]. And sufficient is Allah as Witness",
    normalizedText:
      "لكن الله يشهد بما انزل اليك انزله بعلمه والملاكة يشهدون وكفى بالله شهيدا",
  },
  {
    verseId: 166,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ وَصَدُّواْ عَن سَبِيلِ ٱللَّهِ قَدۡ ضَلُّواْ ضَلَٰلَۢا بَعِيدًا",
    translation:
      "Indeed, those who disbelieve and avert [people] from the way of Allah have certainly gone far astray",
    normalizedText: "ان الذين كفروا وصدوا عن سبيل الله قد ضلوا ضللا بعيدا",
  },
  {
    verseId: 167,
    name: "النساء",
    surahId: 4,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ وَظَلَمُواْ لَمۡ يَكُنِ ٱللَّهُ لِيَغۡفِرَ لَهُمۡ وَلَا لِيَهۡدِيَهُمۡ طَرِيقًا",
    translation:
      "Indeed, those who disbelieve and commit wrong [or injustice] - never will Allah forgive them, nor will He guide them to a path",
    normalizedText:
      "ان الذين كفروا وظلموا لم يكن الله ليغفر لهم ولا ليهديهم طريقا",
  },
  {
    verseId: 168,
    name: "النساء",
    surahId: 4,
    text: "إِلَّا طَرِيقَ جَهَنَّمَ خَٰلِدِينَ فِيهَآ أَبَدٗاۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٗا",
    translation:
      "Except the path of Hell; they will abide therein forever. And that, for Allah, is [always] easy",
    normalizedText: "الا طريق جهنم خلدين فيها ابدا وكان ذلك على الله يسيرا",
  },
  {
    verseId: 169,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ قَدۡ جَآءَكُمُ ٱلرَّسُولُ بِٱلۡحَقِّ مِن رَّبِّكُمۡ فَـَٔامِنُواْ خَيۡرٗا لَّكُمۡۚ وَإِن تَكۡفُرُواْ فَإِنَّ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمٗا",
    translation:
      "O Mankind, the Messenger has come to you with the truth from your Lord, so believe; it is better for you. But if you disbelieve - then indeed, to Allah belongs whatever is in the heavens and earth. And ever is Allah Knowing and Wise",
    normalizedText:
      "يايها الناس قد جاءكم الرسول بالحق من ربكم فامنوا خيرا لكم وان تكفروا فان لله ما في السموت والارض وكان الله عليما حكيما",
  },
  {
    verseId: 170,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لَا تَغۡلُواْ فِي دِينِكُمۡ وَلَا تَقُولُواْ عَلَى ٱللَّهِ إِلَّا ٱلۡحَقَّۚ إِنَّمَا ٱلۡمَسِيحُ عِيسَى ٱبۡنُ مَرۡيَمَ رَسُولُ ٱللَّهِ وَكَلِمَتُهُۥٓ أَلۡقَىٰهَآ إِلَىٰ مَرۡيَمَ وَرُوحٞ مِّنۡهُۖ فَـَٔامِنُواْ بِٱللَّهِ وَرُسُلِهِۦۖ وَلَا تَقُولُواْ ثَلَٰثَةٌۚ ٱنتَهُواْ خَيۡرٗا لَّكُمۡۚ إِنَّمَا ٱللَّهُ إِلَٰهٞ وَٰحِدٞۖ سُبۡحَٰنَهُۥٓ أَن يَكُونَ لَهُۥ وَلَدٞۘ لَّهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۗ وَكَفَىٰ بِٱللَّهِ وَكِيلٗا",
    translation:
      'O People of the Scripture, do not commit excess in your religion or say about Allah except the truth. The Messiah, Jesus, the son of Mary, was but a messenger of Allah and His word which He directed to Mary and a soul [created at a command] from Him. So believe in Allah and His messengers. And do not say, "Three"; desist - it is better for you. Indeed, Allah is but one God. Exalted is He above having a son. To Him belongs whatever is in the heavens and whatever is on the earth. And sufficient is Allah as Disposer of affairs',
    normalizedText:
      "ياهل الكتب لا تغلوا في دينكم ولا تقولوا على الله الا الحق انما المسيح عيسى ابن مريم رسول الله وكلمته القىها الى مريم وروح منه فامنوا بالله ورسله ولا تقولوا ثلثة انتهوا خيرا لكم انما الله اله وحد سبحنه ان يكون له ولد له ما في السموت وما في الارض وكفى بالله وكيلا",
  },
  {
    verseId: 171,
    name: "النساء",
    surahId: 4,
    text: "لَّن يَسۡتَنكِفَ ٱلۡمَسِيحُ أَن يَكُونَ عَبۡدٗا لِّلَّهِ وَلَا ٱلۡمَلَـٰٓئِكَةُ ٱلۡمُقَرَّبُونَۚ وَمَن يَسۡتَنكِفۡ عَنۡ عِبَادَتِهِۦ وَيَسۡتَكۡبِرۡ فَسَيَحۡشُرُهُمۡ إِلَيۡهِ جَمِيعٗا",
    translation:
      "Never would the Messiah disdain to be a servant of Allah, nor would the angels near [to Him]. And whoever disdains His worship and is arrogant - He will gather them to Himself all together",
    normalizedText:
      "لن يستنكف المسيح ان يكون عبدا لله ولا الملاكة المقربون ومن يستنكف عن عبادته ويستكبر فسيحشرهم اليه جميعا",
  },
  {
    verseId: 172,
    name: "النساء",
    surahId: 4,
    text: "فَأَمَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فَيُوَفِّيهِمۡ أُجُورَهُمۡ وَيَزِيدُهُم مِّن فَضۡلِهِۦۖ وَأَمَّا ٱلَّذِينَ ٱسۡتَنكَفُواْ وَٱسۡتَكۡبَرُواْ فَيُعَذِّبُهُمۡ عَذَابًا أَلِيمٗا وَلَا يَجِدُونَ لَهُم مِّن دُونِ ٱللَّهِ وَلِيّٗا وَلَا نَصِيرٗا",
    translation:
      "And as for those who believed and did righteous deeds, He will give them in full their rewards and grant them extra from His bounty. But as for those who disdained and were arrogant, He will punish them with a painful punishment, and they will not find for themselves besides Allah any protector or helper",
    normalizedText:
      "فاما الذين ءامنوا وعملوا الصلحت فيوفيهم اجورهم ويزيدهم من فضله واما الذين استنكفوا واستكبروا فيعذبهم عذابا اليما ولا يجدون لهم من دون الله وليا ولا نصيرا",
  },
  {
    verseId: 173,
    name: "النساء",
    surahId: 4,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ قَدۡ جَآءَكُم بُرۡهَٰنٞ مِّن رَّبِّكُمۡ وَأَنزَلۡنَآ إِلَيۡكُمۡ نُورٗا مُّبِينٗا",
    translation:
      "O mankind, there has come to you a conclusive proof from your Lord, and We have sent down to you a clear light",
    normalizedText:
      "يايها الناس قد جاءكم برهن من ربكم وانزلنا اليكم نورا مبينا",
  },
  {
    verseId: 174,
    name: "النساء",
    surahId: 4,
    text: "فَأَمَّا ٱلَّذِينَ ءَامَنُواْ بِٱللَّهِ وَٱعۡتَصَمُواْ بِهِۦ فَسَيُدۡخِلُهُمۡ فِي رَحۡمَةٖ مِّنۡهُ وَفَضۡلٖ وَيَهۡدِيهِمۡ إِلَيۡهِ صِرَٰطٗا مُّسۡتَقِيمٗا",
    translation:
      "So those who believe in Allah and hold fast to Him - He will admit them to mercy from Himself and bounty and guide them to Himself on a straight path",
    normalizedText:
      "فاما الذين ءامنوا بالله واعتصموا به فسيدخلهم في رحمة منه وفضل ويهديهم اليه صرطا مستقيما",
  },
  {
    verseId: 175,
    name: "النساء",
    surahId: 4,
    text: "يَسۡتَفۡتُونَكَ قُلِ ٱللَّهُ يُفۡتِيكُمۡ فِي ٱلۡكَلَٰلَةِۚ إِنِ ٱمۡرُؤٌاْ هَلَكَ لَيۡسَ لَهُۥ وَلَدٞ وَلَهُۥٓ أُخۡتٞ فَلَهَا نِصۡفُ مَا تَرَكَۚ وَهُوَ يَرِثُهَآ إِن لَّمۡ يَكُن لَّهَا وَلَدٞۚ فَإِن كَانَتَا ٱثۡنَتَيۡنِ فَلَهُمَا ٱلثُّلُثَانِ مِمَّا تَرَكَۚ وَإِن كَانُوٓاْ إِخۡوَةٗ رِّجَالٗا وَنِسَآءٗ فَلِلذَّكَرِ مِثۡلُ حَظِّ ٱلۡأُنثَيَيۡنِۗ يُبَيِّنُ ٱللَّهُ لَكُمۡ أَن تَضِلُّواْۗ وَٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمُۢ",
    translation:
      'They request from you a [legal] ruling. Say, "Allah gives you a ruling concerning one having neither descendants nor ascendants [as heirs]." If a man dies, leaving no child but [only] a sister, she will have half of what he left. And he inherits from her if she [dies and] has no child. But if there are two sisters [or more], they will have two-thirds of what he left. If there are both brothers and sisters, the male will have the share of two females. Allah makes clear to you [His law], lest you go astray. And Allah is Knowing of all things',
    normalizedText:
      "يستفتونك قل الله يفتيكم في الكللة ان امراا هلك ليس له ولد وله اخت فلها نصف ما ترك وهو يرثها ان لم يكن لها ولد فان كانتا اثنتين فلهما الثلثان مما ترك وان كانوا اخوة رجالا ونساء فللذكر مثل حظ الانثيين يبين الله لكم ان تضلوا والله بكل شيء عليم",
  },
  {
    verseId: 0,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ أَوۡفُواْ بِٱلۡعُقُودِۚ أُحِلَّتۡ لَكُم بَهِيمَةُ ٱلۡأَنۡعَٰمِ إِلَّا مَا يُتۡلَىٰ عَلَيۡكُمۡ غَيۡرَ مُحِلِّي ٱلصَّيۡدِ وَأَنتُمۡ حُرُمٌۗ إِنَّ ٱللَّهَ يَحۡكُمُ مَا يُرِيدُ",
    translation:
      "O you who have believed, fulfill [all] contracts. Lawful for you are the animals of grazing livestock except for that which is recited to you [in this Qur'an] - hunting not being permitted while you are in the state of ihram. Indeed, Allah ordains what He intends",
    normalizedText:
      "يايها الذين ءامنوا اوفوا بالعقود احلت لكم بهيمة الانعم الا ما يتلى عليكم غير محلي الصيد وانتم حرم ان الله يحكم ما يريد",
  },
  {
    verseId: 1,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تُحِلُّواْ شَعَـٰٓئِرَ ٱللَّهِ وَلَا ٱلشَّهۡرَ ٱلۡحَرَامَ وَلَا ٱلۡهَدۡيَ وَلَا ٱلۡقَلَـٰٓئِدَ وَلَآ ءَآمِّينَ ٱلۡبَيۡتَ ٱلۡحَرَامَ يَبۡتَغُونَ فَضۡلٗا مِّن رَّبِّهِمۡ وَرِضۡوَٰنٗاۚ وَإِذَا حَلَلۡتُمۡ فَٱصۡطَادُواْۚ وَلَا يَجۡرِمَنَّكُمۡ شَنَـَٔانُ قَوۡمٍ أَن صَدُّوكُمۡ عَنِ ٱلۡمَسۡجِدِ ٱلۡحَرَامِ أَن تَعۡتَدُواْۘ وَتَعَاوَنُواْ عَلَى ٱلۡبِرِّ وَٱلتَّقۡوَىٰۖ وَلَا تَعَاوَنُواْ عَلَى ٱلۡإِثۡمِ وَٱلۡعُدۡوَٰنِۚ وَٱتَّقُواْ ٱللَّهَۖ إِنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "O you who have believed, do not violate the rites of Allah or [the sanctity of] the sacred month or [neglect the marking of] the sacrificial animals and garlanding [them] or [violate the safety of] those coming to the Sacred House seeking bounty from their Lord and [His] approval. But when you come out of ihram, then [you may] hunt. And do not let the hatred of a people for having obstructed you from al-Masjid al-Haram lead you to transgress. And cooperate in righteousness and piety, but do not cooperate in sin and aggression. And fear Allah; indeed, Allah is severe in penalty",
    normalizedText:
      "يايها الذين ءامنوا لا تحلوا شعار الله ولا الشهر الحرام ولا الهدي ولا القلاد ولا ءامين البيت الحرام يبتغون فضلا من ربهم ورضونا واذا حللتم فاصطادوا ولا يجرمنكم شنان قوم ان صدوكم عن المسجد الحرام ان تعتدوا وتعاونوا على البر والتقوى ولا تعاونوا على الاثم والعدون واتقوا الله ان الله شديد العقاب",
  },
  {
    verseId: 2,
    name: "المائدة",
    surahId: 5,
    text: "حُرِّمَتۡ عَلَيۡكُمُ ٱلۡمَيۡتَةُ وَٱلدَّمُ وَلَحۡمُ ٱلۡخِنزِيرِ وَمَآ أُهِلَّ لِغَيۡرِ ٱللَّهِ بِهِۦ وَٱلۡمُنۡخَنِقَةُ وَٱلۡمَوۡقُوذَةُ وَٱلۡمُتَرَدِّيَةُ وَٱلنَّطِيحَةُ وَمَآ أَكَلَ ٱلسَّبُعُ إِلَّا مَا ذَكَّيۡتُمۡ وَمَا ذُبِحَ عَلَى ٱلنُّصُبِ وَأَن تَسۡتَقۡسِمُواْ بِٱلۡأَزۡلَٰمِۚ ذَٰلِكُمۡ فِسۡقٌۗ ٱلۡيَوۡمَ يَئِسَ ٱلَّذِينَ كَفَرُواْ مِن دِينِكُمۡ فَلَا تَخۡشَوۡهُمۡ وَٱخۡشَوۡنِۚ ٱلۡيَوۡمَ أَكۡمَلۡتُ لَكُمۡ دِينَكُمۡ وَأَتۡمَمۡتُ عَلَيۡكُمۡ نِعۡمَتِي وَرَضِيتُ لَكُمُ ٱلۡإِسۡلَٰمَ دِينٗاۚ فَمَنِ ٱضۡطُرَّ فِي مَخۡمَصَةٍ غَيۡرَ مُتَجَانِفٖ لِّإِثۡمٖ فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "Prohibited to you are dead animals, blood, the flesh of swine, and that which has been dedicated to other than Allah, and [those animals] killed by strangling or by a violent blow or by a head-long fall or by the goring of horns, and those from which a wild animal has eaten, except what you [are able to] slaughter [before its death], and those which are sacrificed on stone altars, and [prohibited is] that you seek decision through divining arrows. That is grave disobedience. This day those who disbelieve have despaired of [defeating] your religion; so fear them not, but fear Me. This day I have perfected for you your religion and completed My favor upon you and have approved for you Islam as religion. But whoever is forced by severe hunger with no inclination to sin - then indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "حرمت عليكم الميتة والدم ولحم الخنزير وما اهل لغير الله به والمنخنقة والموقوذة والمتردية والنطيحة وما اكل السبع الا ما ذكيتم وما ذبح على النصب وان تستقسموا بالازلم ذلكم فسق اليوم ياس الذين كفروا من دينكم فلا تخشوهم واخشون اليوم اكملت لكم دينكم واتممت عليكم نعمتي ورضيت لكم الاسلم دينا فمن اضطر في مخمصة غير متجانف لاثم فان الله غفور رحيم",
  },
  {
    verseId: 3,
    name: "المائدة",
    surahId: 5,
    text: "يَسۡـَٔلُونَكَ مَاذَآ أُحِلَّ لَهُمۡۖ قُلۡ أُحِلَّ لَكُمُ ٱلطَّيِّبَٰتُ وَمَا عَلَّمۡتُم مِّنَ ٱلۡجَوَارِحِ مُكَلِّبِينَ تُعَلِّمُونَهُنَّ مِمَّا عَلَّمَكُمُ ٱللَّهُۖ فَكُلُواْ مِمَّآ أَمۡسَكۡنَ عَلَيۡكُمۡ وَٱذۡكُرُواْ ٱسۡمَ ٱللَّهِ عَلَيۡهِۖ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      'They ask you, [O Muhammad], what has been made lawful for them. Say, "Lawful for you are [all] good foods and [game caught by] what you have trained of hunting animals which you train as Allah has taught you. So eat of what they catch for you, and mention the name of Allah upon it, and fear Allah." Indeed, Allah is swift in account',
    normalizedText:
      "يسلونك ماذا احل لهم قل احل لكم الطيبت وما علمتم من الجوارح مكلبين تعلمونهن مما علمكم الله فكلوا مما امسكن عليكم واذكروا اسم الله عليه واتقوا الله ان الله سريع الحساب",
  },
  {
    verseId: 4,
    name: "المائدة",
    surahId: 5,
    text: "ٱلۡيَوۡمَ أُحِلَّ لَكُمُ ٱلطَّيِّبَٰتُۖ وَطَعَامُ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ حِلّٞ لَّكُمۡ وَطَعَامُكُمۡ حِلّٞ لَّهُمۡۖ وَٱلۡمُحۡصَنَٰتُ مِنَ ٱلۡمُؤۡمِنَٰتِ وَٱلۡمُحۡصَنَٰتُ مِنَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ مِن قَبۡلِكُمۡ إِذَآ ءَاتَيۡتُمُوهُنَّ أُجُورَهُنَّ مُحۡصِنِينَ غَيۡرَ مُسَٰفِحِينَ وَلَا مُتَّخِذِيٓ أَخۡدَانٖۗ وَمَن يَكۡفُرۡ بِٱلۡإِيمَٰنِ فَقَدۡ حَبِطَ عَمَلُهُۥ وَهُوَ فِي ٱلۡأٓخِرَةِ مِنَ ٱلۡخَٰسِرِينَ",
    translation:
      "This day [all] good foods have been made lawful, and the food of those who were given the Scripture is lawful for you and your food is lawful for them. And [lawful in marriage are] chaste women from among the believers and chaste women from among those who were given the Scripture before you, when you have given them their due compensation, desiring chastity, not unlawful sexual intercourse or taking [secret] lovers. And whoever denies the faith - his work has become worthless, and he, in the Hereafter, will be among the losers",
    normalizedText:
      "اليوم احل لكم الطيبت وطعام الذين اوتوا الكتب حل لكم وطعامكم حل لهم والمحصنت من المامنت والمحصنت من الذين اوتوا الكتب من قبلكم اذا ءاتيتموهن اجورهن محصنين غير مسفحين ولا متخذي اخدان ومن يكفر بالايمن فقد حبط عمله وهو في الاخرة من الخسرين",
  },
  {
    verseId: 5,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا قُمۡتُمۡ إِلَى ٱلصَّلَوٰةِ فَٱغۡسِلُواْ وُجُوهَكُمۡ وَأَيۡدِيَكُمۡ إِلَى ٱلۡمَرَافِقِ وَٱمۡسَحُواْ بِرُءُوسِكُمۡ وَأَرۡجُلَكُمۡ إِلَى ٱلۡكَعۡبَيۡنِۚ وَإِن كُنتُمۡ جُنُبٗا فَٱطَّهَّرُواْۚ وَإِن كُنتُم مَّرۡضَىٰٓ أَوۡ عَلَىٰ سَفَرٍ أَوۡ جَآءَ أَحَدٞ مِّنكُم مِّنَ ٱلۡغَآئِطِ أَوۡ لَٰمَسۡتُمُ ٱلنِّسَآءَ فَلَمۡ تَجِدُواْ مَآءٗ فَتَيَمَّمُواْ صَعِيدٗا طَيِّبٗا فَٱمۡسَحُواْ بِوُجُوهِكُمۡ وَأَيۡدِيكُم مِّنۡهُۚ مَا يُرِيدُ ٱللَّهُ لِيَجۡعَلَ عَلَيۡكُم مِّنۡ حَرَجٖ وَلَٰكِن يُرِيدُ لِيُطَهِّرَكُمۡ وَلِيُتِمَّ نِعۡمَتَهُۥ عَلَيۡكُمۡ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "O you who have believed, when you rise to [perform] prayer, wash your faces and your forearms to the elbows and wipe over your heads and wash your feet to the ankles. And if you are in a state of janabah, then purify yourselves. But if you are ill or on a journey or one of you comes from the place of relieving himself or you have contacted women and do not find water, then seek clean earth and wipe over your faces and hands with it. Allah does not intend to make difficulty for you, but He intends to purify you and complete His favor upon you that you may be grateful",
    normalizedText:
      "يايها الذين ءامنوا اذا قمتم الى الصلوة فاغسلوا وجوهكم وايديكم الى المرافق وامسحوا برءوسكم وارجلكم الى الكعبين وان كنتم جنبا فاطهروا وان كنتم مرضى او على سفر او جاء احد منكم من الغااط او لمستم النساء فلم تجدوا ماء فتيمموا صعيدا طيبا فامسحوا بوجوهكم وايديكم منه ما يريد الله ليجعل عليكم من حرج ولكن يريد ليطهركم وليتم نعمته عليكم لعلكم تشكرون",
  },
  {
    verseId: 6,
    name: "المائدة",
    surahId: 5,
    text: "وَٱذۡكُرُواْ نِعۡمَةَ ٱللَّهِ عَلَيۡكُمۡ وَمِيثَٰقَهُ ٱلَّذِي وَاثَقَكُم بِهِۦٓ إِذۡ قُلۡتُمۡ سَمِعۡنَا وَأَطَعۡنَاۖ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      'And remember the favor of Allah upon you and His covenant with which He bound you when you said, "We hear and we obey"; and fear Allah. Indeed, Allah is Knowing of that within the breasts',
    normalizedText:
      "واذكروا نعمة الله عليكم وميثقه الذي واثقكم به اذ قلتم سمعنا واطعنا واتقوا الله ان الله عليم بذات الصدور",
  },
  {
    verseId: 7,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ كُونُواْ قَوَّـٰمِينَ لِلَّهِ شُهَدَآءَ بِٱلۡقِسۡطِۖ وَلَا يَجۡرِمَنَّكُمۡ شَنَـَٔانُ قَوۡمٍ عَلَىٰٓ أَلَّا تَعۡدِلُواْۚ ٱعۡدِلُواْ هُوَ أَقۡرَبُ لِلتَّقۡوَىٰۖ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ خَبِيرُۢ بِمَا تَعۡمَلُونَ",
    translation:
      "O you who have believed, be persistently standing firm for Allah, witnesses in justice, and do not let the hatred of a people prevent you from being just. Be just; that is nearer to righteousness. And fear Allah; indeed, Allah is Acquainted with what you do",
    normalizedText:
      "يايها الذين ءامنوا كونوا قومين لله شهداء بالقسط ولا يجرمنكم شنان قوم على الا تعدلوا اعدلوا هو اقرب للتقوى واتقوا الله ان الله خبير بما تعملون",
  },
  {
    verseId: 8,
    name: "المائدة",
    surahId: 5,
    text: "وَعَدَ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَهُم مَّغۡفِرَةٞ وَأَجۡرٌ عَظِيمٞ",
    translation:
      "Allah has promised those who believe and do righteous deeds [that] for them there is forgiveness and great reward",
    normalizedText: "وعد الله الذين ءامنوا وعملوا الصلحت لهم مغفرة واجر عظيم",
  },
  {
    verseId: 9,
    name: "المائدة",
    surahId: 5,
    text: "وَٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِـَٔايَٰتِنَآ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَحِيمِ",
    translation:
      "But those who disbelieve and deny Our signs - those are the companions of Hellfire",
    normalizedText: "والذين كفروا وكذبوا بايتنا اولاك اصحب الجحيم",
  },
  {
    verseId: 10,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱذۡكُرُواْ نِعۡمَتَ ٱللَّهِ عَلَيۡكُمۡ إِذۡ هَمَّ قَوۡمٌ أَن يَبۡسُطُوٓاْ إِلَيۡكُمۡ أَيۡدِيَهُمۡ فَكَفَّ أَيۡدِيَهُمۡ عَنكُمۡۖ وَٱتَّقُواْ ٱللَّهَۚ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُؤۡمِنُونَ",
    translation:
      "O you who have believed, remember the favor of Allah upon you when a people determined to extend their hands [in aggression] against you, but He withheld their hands from you; and fear Allah. And upon Allah let the believers rely",
    normalizedText:
      "يايها الذين ءامنوا اذكروا نعمت الله عليكم اذ هم قوم ان يبسطوا اليكم ايديهم فكف ايديهم عنكم واتقوا الله وعلى الله فليتوكل المامنون",
  },
  {
    verseId: 11,
    name: "المائدة",
    surahId: 5,
    text: "۞وَلَقَدۡ أَخَذَ ٱللَّهُ مِيثَٰقَ بَنِيٓ إِسۡرَـٰٓءِيلَ وَبَعَثۡنَا مِنۡهُمُ ٱثۡنَيۡ عَشَرَ نَقِيبٗاۖ وَقَالَ ٱللَّهُ إِنِّي مَعَكُمۡۖ لَئِنۡ أَقَمۡتُمُ ٱلصَّلَوٰةَ وَءَاتَيۡتُمُ ٱلزَّكَوٰةَ وَءَامَنتُم بِرُسُلِي وَعَزَّرۡتُمُوهُمۡ وَأَقۡرَضۡتُمُ ٱللَّهَ قَرۡضًا حَسَنٗا لَّأُكَفِّرَنَّ عَنكُمۡ سَيِّـَٔاتِكُمۡ وَلَأُدۡخِلَنَّكُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۚ فَمَن كَفَرَ بَعۡدَ ذَٰلِكَ مِنكُمۡ فَقَدۡ ضَلَّ سَوَآءَ ٱلسَّبِيلِ",
    translation:
      'And Allah had already taken a covenant from the Children of Israel, and We delegated from among them twelve leaders. And Allah said, "I am with you. If you establish prayer and give zakah and believe in My messengers and support them and loan Allah a goodly loan, I will surely remove from you your misdeeds and admit you to gardens beneath which rivers flow. But whoever of you disbelieves after that has certainly strayed from the soundness of the way',
    normalizedText:
      "۞ولقد اخذ الله ميثق بني اسرءيل وبعثنا منهم اثني عشر نقيبا وقال الله اني معكم لان اقمتم الصلوة وءاتيتم الزكوة وءامنتم برسلي وعزرتموهم واقرضتم الله قرضا حسنا لاكفرن عنكم سياتكم ولادخلنكم جنت تجري من تحتها الانهر فمن كفر بعد ذلك منكم فقد ضل سواء السبيل",
  },
  {
    verseId: 12,
    name: "المائدة",
    surahId: 5,
    text: "فَبِمَا نَقۡضِهِم مِّيثَٰقَهُمۡ لَعَنَّـٰهُمۡ وَجَعَلۡنَا قُلُوبَهُمۡ قَٰسِيَةٗۖ يُحَرِّفُونَ ٱلۡكَلِمَ عَن مَّوَاضِعِهِۦ وَنَسُواْ حَظّٗا مِّمَّا ذُكِّرُواْ بِهِۦۚ وَلَا تَزَالُ تَطَّلِعُ عَلَىٰ خَآئِنَةٖ مِّنۡهُمۡ إِلَّا قَلِيلٗا مِّنۡهُمۡۖ فَٱعۡفُ عَنۡهُمۡ وَٱصۡفَحۡۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُحۡسِنِينَ",
    translation:
      "So for their breaking of the covenant We cursed them and made their hearts hard. They distort words from their [proper] usages and have forgotten a portion of that of which they were reminded. And you will still observe deceit among them, except a few of them. But pardon them and overlook [their misdeeds]. Indeed, Allah loves the doers of good",
    normalizedText:
      "فبما نقضهم ميثقهم لعنهم وجعلنا قلوبهم قسية يحرفون الكلم عن مواضعه ونسوا حظا مما ذكروا به ولا تزال تطلع على خاانة منهم الا قليلا منهم فاعف عنهم واصفح ان الله يحب المحسنين",
  },
  {
    verseId: 13,
    name: "المائدة",
    surahId: 5,
    text: "وَمِنَ ٱلَّذِينَ قَالُوٓاْ إِنَّا نَصَٰرَىٰٓ أَخَذۡنَا مِيثَٰقَهُمۡ فَنَسُواْ حَظّٗا مِّمَّا ذُكِّرُواْ بِهِۦ فَأَغۡرَيۡنَا بَيۡنَهُمُ ٱلۡعَدَاوَةَ وَٱلۡبَغۡضَآءَ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِۚ وَسَوۡفَ يُنَبِّئُهُمُ ٱللَّهُ بِمَا كَانُواْ يَصۡنَعُونَ",
    translation:
      'And from those who say, "We are Christians" We took their covenant; but they forgot a portion of that of which they were reminded. So We caused among them animosity and hatred until the Day of Resurrection. And Allah is going to inform them about what they used to do',
    normalizedText:
      "ومن الذين قالوا انا نصرى اخذنا ميثقهم فنسوا حظا مما ذكروا به فاغرينا بينهم العداوة والبغضاء الى يوم القيمة وسوف ينباهم الله بما كانوا يصنعون",
  },
  {
    verseId: 14,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ قَدۡ جَآءَكُمۡ رَسُولُنَا يُبَيِّنُ لَكُمۡ كَثِيرٗا مِّمَّا كُنتُمۡ تُخۡفُونَ مِنَ ٱلۡكِتَٰبِ وَيَعۡفُواْ عَن كَثِيرٖۚ قَدۡ جَآءَكُم مِّنَ ٱللَّهِ نُورٞ وَكِتَٰبٞ مُّبِينٞ",
    translation:
      "O People of the Scripture, there has come to you Our Messenger making clear to you much of what you used to conceal of the Scripture and overlooking much. There has come to you from Allah a light and a clear Book",
    normalizedText:
      "ياهل الكتب قد جاءكم رسولنا يبين لكم كثيرا مما كنتم تخفون من الكتب ويعفوا عن كثير قد جاءكم من الله نور وكتب مبين",
  },
  {
    verseId: 15,
    name: "المائدة",
    surahId: 5,
    text: "يَهۡدِي بِهِ ٱللَّهُ مَنِ ٱتَّبَعَ رِضۡوَٰنَهُۥ سُبُلَ ٱلسَّلَٰمِ وَيُخۡرِجُهُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ بِإِذۡنِهِۦ وَيَهۡدِيهِمۡ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "By which Allah guides those who pursue His pleasure to the ways of peace and brings them out from darknesses into the light, by His permission, and guides them to a straight path",
    normalizedText:
      "يهدي به الله من اتبع رضونه سبل السلم ويخرجهم من الظلمت الى النور باذنه ويهديهم الى صرط مستقيم",
  },
  {
    verseId: 16,
    name: "المائدة",
    surahId: 5,
    text: "لَّقَدۡ كَفَرَ ٱلَّذِينَ قَالُوٓاْ إِنَّ ٱللَّهَ هُوَ ٱلۡمَسِيحُ ٱبۡنُ مَرۡيَمَۚ قُلۡ فَمَن يَمۡلِكُ مِنَ ٱللَّهِ شَيۡـًٔا إِنۡ أَرَادَ أَن يُهۡلِكَ ٱلۡمَسِيحَ ٱبۡنَ مَرۡيَمَ وَأُمَّهُۥ وَمَن فِي ٱلۡأَرۡضِ جَمِيعٗاۗ وَلِلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَاۚ يَخۡلُقُ مَا يَشَآءُۚ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'They have certainly disbelieved who say that Allah is Christ, the son of Mary. Say, "Then who could prevent Allah at all if He had intended to destroy Christ, the son of Mary, or his mother or everyone on the earth?" And to Allah belongs the dominion of the heavens and the earth and whatever is between them. He creates what He wills, and Allah is over all things competent',
    normalizedText:
      "لقد كفر الذين قالوا ان الله هو المسيح ابن مريم قل فمن يملك من الله شيا ان اراد ان يهلك المسيح ابن مريم وامه ومن في الارض جميعا ولله ملك السموت والارض وما بينهما يخلق ما يشاء والله على كل شيء قدير",
  },
  {
    verseId: 17,
    name: "المائدة",
    surahId: 5,
    text: "وَقَالَتِ ٱلۡيَهُودُ وَٱلنَّصَٰرَىٰ نَحۡنُ أَبۡنَـٰٓؤُاْ ٱللَّهِ وَأَحِبَّـٰٓؤُهُۥۚ قُلۡ فَلِمَ يُعَذِّبُكُم بِذُنُوبِكُمۖ بَلۡ أَنتُم بَشَرٞ مِّمَّنۡ خَلَقَۚ يَغۡفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُۚ وَلِلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَاۖ وَإِلَيۡهِ ٱلۡمَصِيرُ",
    translation:
      'But the Jews and the Christians say, "We are the children of Allah and His beloved." Say, "Then why does He punish you for your sins?" Rather, you are human beings from among those He has created. He forgives whom He wills, and He punishes whom He wills. And to Allah belongs the dominion of the heavens and the earth and whatever is between them, and to Him is the [final] destination',
    normalizedText:
      "وقالت اليهود والنصرى نحن ابناا الله واحباه قل فلم يعذبكم بذنوبكم بل انتم بشر ممن خلق يغفر لمن يشاء ويعذب من يشاء ولله ملك السموت والارض وما بينهما واليه المصير",
  },
  {
    verseId: 18,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ قَدۡ جَآءَكُمۡ رَسُولُنَا يُبَيِّنُ لَكُمۡ عَلَىٰ فَتۡرَةٖ مِّنَ ٱلرُّسُلِ أَن تَقُولُواْ مَا جَآءَنَا مِنۢ بَشِيرٖ وَلَا نَذِيرٖۖ فَقَدۡ جَآءَكُم بَشِيرٞ وَنَذِيرٞۗ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'O People of the Scripture, there has come to you Our Messenger to make clear to you [the religion] after a period [of suspension] of messengers, lest you say, "There came not to us any bringer of good tidings or a warner." But there has come to you a bringer of good tidings and a warner. And Allah is over all things competent',
    normalizedText:
      "ياهل الكتب قد جاءكم رسولنا يبين لكم على فترة من الرسل ان تقولوا ما جاءنا من بشير ولا نذير فقد جاءكم بشير ونذير والله على كل شيء قدير",
  },
  {
    verseId: 19,
    name: "المائدة",
    surahId: 5,
    text: "وَإِذۡ قَالَ مُوسَىٰ لِقَوۡمِهِۦ يَٰقَوۡمِ ٱذۡكُرُواْ نِعۡمَةَ ٱللَّهِ عَلَيۡكُمۡ إِذۡ جَعَلَ فِيكُمۡ أَنۢبِيَآءَ وَجَعَلَكُم مُّلُوكٗا وَءَاتَىٰكُم مَّا لَمۡ يُؤۡتِ أَحَدٗا مِّنَ ٱلۡعَٰلَمِينَ",
    translation:
      'And [mention, O Muhammad], when Moses said to his people, "O my people, remember the favor of Allah upon you when He appointed among you prophets and made you possessors and gave you that which He had not given anyone among the worlds',
    normalizedText:
      "واذ قال موسى لقومه يقوم اذكروا نعمة الله عليكم اذ جعل فيكم انبياء وجعلكم ملوكا وءاتىكم ما لم يات احدا من العلمين",
  },
  {
    verseId: 20,
    name: "المائدة",
    surahId: 5,
    text: "يَٰقَوۡمِ ٱدۡخُلُواْ ٱلۡأَرۡضَ ٱلۡمُقَدَّسَةَ ٱلَّتِي كَتَبَ ٱللَّهُ لَكُمۡ وَلَا تَرۡتَدُّواْ عَلَىٰٓ أَدۡبَارِكُمۡ فَتَنقَلِبُواْ خَٰسِرِينَ",
    translation:
      "O my people, enter the Holy Land which Allah has assigned to you and do not turn back [from fighting in Allah 's cause] and [thus] become losers",
    normalizedText:
      "يقوم ادخلوا الارض المقدسة التي كتب الله لكم ولا ترتدوا على ادباركم فتنقلبوا خسرين",
  },
  {
    verseId: 21,
    name: "المائدة",
    surahId: 5,
    text: "قَالُواْ يَٰمُوسَىٰٓ إِنَّ فِيهَا قَوۡمٗا جَبَّارِينَ وَإِنَّا لَن نَّدۡخُلَهَا حَتَّىٰ يَخۡرُجُواْ مِنۡهَا فَإِن يَخۡرُجُواْ مِنۡهَا فَإِنَّا دَٰخِلُونَ",
    translation:
      'They said, "O Moses, indeed within it is a people of tyrannical strength, and indeed, we will never enter it until they leave it; but if they leave it, then we will enter',
    normalizedText:
      "قالوا يموسى ان فيها قوما جبارين وانا لن ندخلها حتى يخرجوا منها فان يخرجوا منها فانا دخلون",
  },
  {
    verseId: 22,
    name: "المائدة",
    surahId: 5,
    text: "قَالَ رَجُلَانِ مِنَ ٱلَّذِينَ يَخَافُونَ أَنۡعَمَ ٱللَّهُ عَلَيۡهِمَا ٱدۡخُلُواْ عَلَيۡهِمُ ٱلۡبَابَ فَإِذَا دَخَلۡتُمُوهُ فَإِنَّكُمۡ غَٰلِبُونَۚ وَعَلَى ٱللَّهِ فَتَوَكَّلُوٓاْ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      'Said two men from those who feared [to disobey] upon whom Allah had bestowed favor, "Enter upon them through the gate, for when you have entered it, you will be predominant. And upon Allah rely, if you should be believers',
    normalizedText:
      "قال رجلان من الذين يخافون انعم الله عليهما ادخلوا عليهم الباب فاذا دخلتموه فانكم غلبون وعلى الله فتوكلوا ان كنتم مامنين",
  },
  {
    verseId: 23,
    name: "المائدة",
    surahId: 5,
    text: "قَالُواْ يَٰمُوسَىٰٓ إِنَّا لَن نَّدۡخُلَهَآ أَبَدٗا مَّا دَامُواْ فِيهَا فَٱذۡهَبۡ أَنتَ وَرَبُّكَ فَقَٰتِلَآ إِنَّا هَٰهُنَا قَٰعِدُونَ",
    translation:
      'They said, "O Moses, indeed we will not enter it, ever, as long as they are within it; so go, you and your Lord, and fight. Indeed, we are remaining right here',
    normalizedText:
      "قالوا يموسى انا لن ندخلها ابدا ما داموا فيها فاذهب انت وربك فقتلا انا ههنا قعدون",
  },
  {
    verseId: 24,
    name: "المائدة",
    surahId: 5,
    text: "قَالَ رَبِّ إِنِّي لَآ أَمۡلِكُ إِلَّا نَفۡسِي وَأَخِيۖ فَٱفۡرُقۡ بَيۡنَنَا وَبَيۡنَ ٱلۡقَوۡمِ ٱلۡفَٰسِقِينَ",
    translation:
      '[Moses] said, "My Lord, indeed I do not possess except myself and my brother, so part us from the defiantly disobedient people',
    normalizedText:
      "قال رب اني لا املك الا نفسي واخي فافرق بيننا وبين القوم الفسقين",
  },
  {
    verseId: 25,
    name: "المائدة",
    surahId: 5,
    text: "قَالَ فَإِنَّهَا مُحَرَّمَةٌ عَلَيۡهِمۡۛ أَرۡبَعِينَ سَنَةٗۛ يَتِيهُونَ فِي ٱلۡأَرۡضِۚ فَلَا تَأۡسَ عَلَى ٱلۡقَوۡمِ ٱلۡفَٰسِقِينَ",
    translation:
      '[Allah] said, "Then indeed, it is forbidden to them for forty years [in which] they will wander throughout the land. So do not grieve over the defiantly disobedient people',
    normalizedText:
      "قال فانها محرمة عليهم اربعين سنة يتيهون في الارض فلا تاس على القوم الفسقين",
  },
  {
    verseId: 26,
    name: "المائدة",
    surahId: 5,
    text: "۞وَٱتۡلُ عَلَيۡهِمۡ نَبَأَ ٱبۡنَيۡ ءَادَمَ بِٱلۡحَقِّ إِذۡ قَرَّبَا قُرۡبَانٗا فَتُقُبِّلَ مِنۡ أَحَدِهِمَا وَلَمۡ يُتَقَبَّلۡ مِنَ ٱلۡأٓخَرِ قَالَ لَأَقۡتُلَنَّكَۖ قَالَ إِنَّمَا يَتَقَبَّلُ ٱللَّهُ مِنَ ٱلۡمُتَّقِينَ",
    translation: `And recite to them the story of Adam's two sons, in truth, when they both offered a sacrifice [to Allah], and it was accepted from one of them but was not accepted from the other. Said [the latter], "I will surely kill you." Said [the former], "Indeed, Allah only accepts from the righteous [who fear Him]`,
    normalizedText:
      "۞واتل عليهم نبا ابني ءادم بالحق اذ قربا قربانا فتقبل من احدهما ولم يتقبل من الاخر قال لاقتلنك قال انما يتقبل الله من المتقين",
  },
  {
    verseId: 27,
    name: "المائدة",
    surahId: 5,
    text: "لَئِنۢ بَسَطتَ إِلَيَّ يَدَكَ لِتَقۡتُلَنِي مَآ أَنَا۠ بِبَاسِطٖ يَدِيَ إِلَيۡكَ لِأَقۡتُلَكَۖ إِنِّيٓ أَخَافُ ٱللَّهَ رَبَّ ٱلۡعَٰلَمِينَ",
    translation:
      "If you should raise your hand against me to kill me - I shall not raise my hand against you to kill you. Indeed, I fear Allah, Lord of the worlds",
    normalizedText:
      "لان بسطت الي يدك لتقتلني ما انا بباسط يدي اليك لاقتلك اني اخاف الله رب العلمين",
  },
  {
    verseId: 28,
    name: "المائدة",
    surahId: 5,
    text: "إِنِّيٓ أُرِيدُ أَن تَبُوٓأَ بِإِثۡمِي وَإِثۡمِكَ فَتَكُونَ مِنۡ أَصۡحَٰبِ ٱلنَّارِۚ وَذَٰلِكَ جَزَـٰٓؤُاْ ٱلظَّـٰلِمِينَ",
    translation:
      "Indeed I want you to obtain [thereby] my sin and your sin so you will be among the companions of the Fire. And that is the recompense of wrongdoers",
    normalizedText:
      "اني اريد ان تبوا باثمي واثمك فتكون من اصحب النار وذلك جزاا الظلمين",
  },
  {
    verseId: 29,
    name: "المائدة",
    surahId: 5,
    text: "فَطَوَّعَتۡ لَهُۥ نَفۡسُهُۥ قَتۡلَ أَخِيهِ فَقَتَلَهُۥ فَأَصۡبَحَ مِنَ ٱلۡخَٰسِرِينَ",
    translation:
      "And his soul permitted to him the murder of his brother, so he killed him and became among the losers",
    normalizedText: "فطوعت له نفسه قتل اخيه فقتله فاصبح من الخسرين",
  },
  {
    verseId: 30,
    name: "المائدة",
    surahId: 5,
    text: "فَبَعَثَ ٱللَّهُ غُرَابٗا يَبۡحَثُ فِي ٱلۡأَرۡضِ لِيُرِيَهُۥ كَيۡفَ يُوَٰرِي سَوۡءَةَ أَخِيهِۚ قَالَ يَٰوَيۡلَتَىٰٓ أَعَجَزۡتُ أَنۡ أَكُونَ مِثۡلَ هَٰذَا ٱلۡغُرَابِ فَأُوَٰرِيَ سَوۡءَةَ أَخِيۖ فَأَصۡبَحَ مِنَ ٱلنَّـٰدِمِينَ",
    translation:
      'Then Allah sent a crow searching in the ground to show him how to hide the disgrace of his brother. He said, "O woe to me! Have I failed to be like this crow and hide the body of my brother?" And he became of the regretful',
    normalizedText:
      "فبعث الله غرابا يبحث في الارض ليريه كيف يوري سوءة اخيه قال يويلتى اعجزت ان اكون مثل هذا الغراب فاوري سوءة اخي فاصبح من الندمين",
  },
  {
    verseId: 31,
    name: "المائدة",
    surahId: 5,
    text: "مِنۡ أَجۡلِ ذَٰلِكَ كَتَبۡنَا عَلَىٰ بَنِيٓ إِسۡرَـٰٓءِيلَ أَنَّهُۥ مَن قَتَلَ نَفۡسَۢا بِغَيۡرِ نَفۡسٍ أَوۡ فَسَادٖ فِي ٱلۡأَرۡضِ فَكَأَنَّمَا قَتَلَ ٱلنَّاسَ جَمِيعٗا وَمَنۡ أَحۡيَاهَا فَكَأَنَّمَآ أَحۡيَا ٱلنَّاسَ جَمِيعٗاۚ وَلَقَدۡ جَآءَتۡهُمۡ رُسُلُنَا بِٱلۡبَيِّنَٰتِ ثُمَّ إِنَّ كَثِيرٗا مِّنۡهُم بَعۡدَ ذَٰلِكَ فِي ٱلۡأَرۡضِ لَمُسۡرِفُونَ",
    translation:
      "Because of that, We decreed upon the Children of Israel that whoever kills a soul unless for a soul or for corruption [done] in the land - it is as if he had slain mankind entirely. And whoever saves one - it is as if he had saved mankind entirely. And our messengers had certainly come to them with clear proofs. Then indeed many of them, [even] after that, throughout the land, were transgressors",
    normalizedText:
      "من اجل ذلك كتبنا على بني اسرءيل انه من قتل نفسا بغير نفس او فساد في الارض فكانما قتل الناس جميعا ومن احياها فكانما احيا الناس جميعا ولقد جاءتهم رسلنا بالبينت ثم ان كثيرا منهم بعد ذلك في الارض لمسرفون",
  },
  {
    verseId: 32,
    name: "المائدة",
    surahId: 5,
    text: "إِنَّمَا جَزَـٰٓؤُاْ ٱلَّذِينَ يُحَارِبُونَ ٱللَّهَ وَرَسُولَهُۥ وَيَسۡعَوۡنَ فِي ٱلۡأَرۡضِ فَسَادًا أَن يُقَتَّلُوٓاْ أَوۡ يُصَلَّبُوٓاْ أَوۡ تُقَطَّعَ أَيۡدِيهِمۡ وَأَرۡجُلُهُم مِّنۡ خِلَٰفٍ أَوۡ يُنفَوۡاْ مِنَ ٱلۡأَرۡضِۚ ذَٰلِكَ لَهُمۡ خِزۡيٞ فِي ٱلدُّنۡيَاۖ وَلَهُمۡ فِي ٱلۡأٓخِرَةِ عَذَابٌ عَظِيمٌ",
    translation:
      "Indeed, the penalty for those who wage war against Allah and His Messenger and strive upon earth [to cause] corruption is none but that they be killed or crucified or that their hands and feet be cut off from opposite sides or that they be exiled from the land. That is for them a disgrace in this world; and for them in the Hereafter is a great punishment",
    normalizedText:
      "انما جزاا الذين يحاربون الله ورسوله ويسعون في الارض فسادا ان يقتلوا او يصلبوا او تقطع ايديهم وارجلهم من خلف او ينفوا من الارض ذلك لهم خزي في الدنيا ولهم في الاخرة عذاب عظيم",
  },
  {
    verseId: 33,
    name: "المائدة",
    surahId: 5,
    text: "إِلَّا ٱلَّذِينَ تَابُواْ مِن قَبۡلِ أَن تَقۡدِرُواْ عَلَيۡهِمۡۖ فَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "Except for those who return [repenting] before you apprehend them. And know that Allah is Forgiving and Merciful",
    normalizedText:
      "الا الذين تابوا من قبل ان تقدروا عليهم فاعلموا ان الله غفور رحيم",
  },
  {
    verseId: 34,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ ٱللَّهَ وَٱبۡتَغُوٓاْ إِلَيۡهِ ٱلۡوَسِيلَةَ وَجَٰهِدُواْ فِي سَبِيلِهِۦ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "O you who have believed, fear Allah and seek the means [of nearness] to Him and strive in His cause that you may succeed",
    normalizedText:
      "يايها الذين ءامنوا اتقوا الله وابتغوا اليه الوسيلة وجهدوا في سبيله لعلكم تفلحون",
  },
  {
    verseId: 35,
    name: "المائدة",
    surahId: 5,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ لَوۡ أَنَّ لَهُم مَّا فِي ٱلۡأَرۡضِ جَمِيعٗا وَمِثۡلَهُۥ مَعَهُۥ لِيَفۡتَدُواْ بِهِۦ مِنۡ عَذَابِ يَوۡمِ ٱلۡقِيَٰمَةِ مَا تُقُبِّلَ مِنۡهُمۡۖ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "Indeed, those who disbelieve - if they should have all that is in the earth and the like of it with it by which to ransom themselves from the punishment of the Day of Resurrection, it will not be accepted from them, and for them is a painful punishment",
    normalizedText:
      "ان الذين كفروا لو ان لهم ما في الارض جميعا ومثله معه ليفتدوا به من عذاب يوم القيمة ما تقبل منهم ولهم عذاب اليم",
  },
  {
    verseId: 36,
    name: "المائدة",
    surahId: 5,
    text: "يُرِيدُونَ أَن يَخۡرُجُواْ مِنَ ٱلنَّارِ وَمَا هُم بِخَٰرِجِينَ مِنۡهَاۖ وَلَهُمۡ عَذَابٞ مُّقِيمٞ",
    translation:
      "They will wish to get out of the Fire, but never are they to emerge therefrom, and for them is an enduring punishment",
    normalizedText:
      "يريدون ان يخرجوا من النار وما هم بخرجين منها ولهم عذاب مقيم",
  },
  {
    verseId: 37,
    name: "المائدة",
    surahId: 5,
    text: "وَٱلسَّارِقُ وَٱلسَّارِقَةُ فَٱقۡطَعُوٓاْ أَيۡدِيَهُمَا جَزَآءَۢ بِمَا كَسَبَا نَكَٰلٗا مِّنَ ٱللَّهِۗ وَٱللَّهُ عَزِيزٌ حَكِيمٞ",
    translation:
      "[As for] the thief, the male and the female, amputate their hands in recompense for what they committed as a deterrent [punishment] from Allah. And Allah is Exalted in Might and Wise",
    normalizedText:
      "والسارق والسارقة فاقطعوا ايديهما جزاء بما كسبا نكلا من الله والله عزيز حكيم",
  },
  {
    verseId: 38,
    name: "المائدة",
    surahId: 5,
    text: "فَمَن تَابَ مِنۢ بَعۡدِ ظُلۡمِهِۦ وَأَصۡلَحَ فَإِنَّ ٱللَّهَ يَتُوبُ عَلَيۡهِۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٌ",
    translation:
      "But whoever repents after his wrongdoing and reforms, indeed, Allah will turn to him in forgiveness. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "فمن تاب من بعد ظلمه واصلح فان الله يتوب عليه ان الله غفور رحيم",
  },
  {
    verseId: 39,
    name: "المائدة",
    surahId: 5,
    text: "أَلَمۡ تَعۡلَمۡ أَنَّ ٱللَّهَ لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ يُعَذِّبُ مَن يَشَآءُ وَيَغۡفِرُ لِمَن يَشَآءُۗ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "Do you not know that to Allah belongs the dominion of the heavens and the earth? He punishes whom He wills and forgives whom He wills, and Allah is over all things competent",
    normalizedText:
      "الم تعلم ان الله له ملك السموت والارض يعذب من يشاء ويغفر لمن يشاء والله على كل شيء قدير",
  },
  {
    verseId: 40,
    name: "المائدة",
    surahId: 5,
    text: "۞يَـٰٓأَيُّهَا ٱلرَّسُولُ لَا يَحۡزُنكَ ٱلَّذِينَ يُسَٰرِعُونَ فِي ٱلۡكُفۡرِ مِنَ ٱلَّذِينَ قَالُوٓاْ ءَامَنَّا بِأَفۡوَٰهِهِمۡ وَلَمۡ تُؤۡمِن قُلُوبُهُمۡۛ وَمِنَ ٱلَّذِينَ هَادُواْۛ سَمَّـٰعُونَ لِلۡكَذِبِ سَمَّـٰعُونَ لِقَوۡمٍ ءَاخَرِينَ لَمۡ يَأۡتُوكَۖ يُحَرِّفُونَ ٱلۡكَلِمَ مِنۢ بَعۡدِ مَوَاضِعِهِۦۖ يَقُولُونَ إِنۡ أُوتِيتُمۡ هَٰذَا فَخُذُوهُ وَإِن لَّمۡ تُؤۡتَوۡهُ فَٱحۡذَرُواْۚ وَمَن يُرِدِ ٱللَّهُ فِتۡنَتَهُۥ فَلَن تَمۡلِكَ لَهُۥ مِنَ ٱللَّهِ شَيۡـًٔاۚ أُوْلَـٰٓئِكَ ٱلَّذِينَ لَمۡ يُرِدِ ٱللَّهُ أَن يُطَهِّرَ قُلُوبَهُمۡۚ لَهُمۡ فِي ٱلدُّنۡيَا خِزۡيٞۖ وَلَهُمۡ فِي ٱلۡأٓخِرَةِ عَذَابٌ عَظِيمٞ",
    translation:
      'O Messenger, let them not grieve you who hasten into disbelief of those who say, "We believe" with their mouths, but their hearts believe not, and from among the Jews. [They are] avid listeners to falsehood, listening to another people who have not come to you. They distort words beyond their [proper] usages, saying "If you are given this, take it; but if you are not given it, then beware." But he for whom Allah intends fitnah - never will you possess [power to do] for him a thing against Allah. Those are the ones for whom Allah does not intend to purify their hearts. For them in this world is disgrace, and for them in the Hereafter is a great punishment',
    normalizedText:
      "۞يايها الرسول لا يحزنك الذين يسرعون في الكفر من الذين قالوا ءامنا بافوههم ولم تامن قلوبهم ومن الذين هادوا سمعون للكذب سمعون لقوم ءاخرين لم ياتوك يحرفون الكلم من بعد مواضعه يقولون ان اوتيتم هذا فخذوه وان لم تاتوه فاحذروا ومن يرد الله فتنته فلن تملك له من الله شيا اولاك الذين لم يرد الله ان يطهر قلوبهم لهم في الدنيا خزي ولهم في الاخرة عذاب عظيم",
  },
  {
    verseId: 41,
    name: "المائدة",
    surahId: 5,
    text: "سَمَّـٰعُونَ لِلۡكَذِبِ أَكَّـٰلُونَ لِلسُّحۡتِۚ فَإِن جَآءُوكَ فَٱحۡكُم بَيۡنَهُمۡ أَوۡ أَعۡرِضۡ عَنۡهُمۡۖ وَإِن تُعۡرِضۡ عَنۡهُمۡ فَلَن يَضُرُّوكَ شَيۡـٔٗاۖ وَإِنۡ حَكَمۡتَ فَٱحۡكُم بَيۡنَهُم بِٱلۡقِسۡطِۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُقۡسِطِينَ",
    translation:
      "[They are] avid listeners to falsehood, devourers of [what is] unlawful. So if they come to you, [O Muhammad], judge between them or turn away from them. And if you turn away from them - never will they harm you at all. And if you judge, judge between them with justice. Indeed, Allah loves those who act justly",
    normalizedText:
      "سمعون للكذب اكلون للسحت فان جاءوك فاحكم بينهم او اعرض عنهم وان تعرض عنهم فلن يضروك شيا وان حكمت فاحكم بينهم بالقسط ان الله يحب المقسطين",
  },
  {
    verseId: 42,
    name: "المائدة",
    surahId: 5,
    text: "وَكَيۡفَ يُحَكِّمُونَكَ وَعِندَهُمُ ٱلتَّوۡرَىٰةُ فِيهَا حُكۡمُ ٱللَّهِ ثُمَّ يَتَوَلَّوۡنَ مِنۢ بَعۡدِ ذَٰلِكَۚ وَمَآ أُوْلَـٰٓئِكَ بِٱلۡمُؤۡمِنِينَ",
    translation:
      "But how is it that they come to you for judgement while they have the Torah, in which is the judgement of Allah? Then they turn away, [even] after that; but those are not [in fact] believers",
    normalizedText:
      "وكيف يحكمونك وعندهم التورىة فيها حكم الله ثم يتولون من بعد ذلك وما اولاك بالمامنين",
  },
  {
    verseId: 43,
    name: "المائدة",
    surahId: 5,
    text: "إِنَّآ أَنزَلۡنَا ٱلتَّوۡرَىٰةَ فِيهَا هُدٗى وَنُورٞۚ يَحۡكُمُ بِهَا ٱلنَّبِيُّونَ ٱلَّذِينَ أَسۡلَمُواْ لِلَّذِينَ هَادُواْ وَٱلرَّبَّـٰنِيُّونَ وَٱلۡأَحۡبَارُ بِمَا ٱسۡتُحۡفِظُواْ مِن كِتَٰبِ ٱللَّهِ وَكَانُواْ عَلَيۡهِ شُهَدَآءَۚ فَلَا تَخۡشَوُاْ ٱلنَّاسَ وَٱخۡشَوۡنِ وَلَا تَشۡتَرُواْ بِـَٔايَٰتِي ثَمَنٗا قَلِيلٗاۚ وَمَن لَّمۡ يَحۡكُم بِمَآ أَنزَلَ ٱللَّهُ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡكَٰفِرُونَ",
    translation:
      "Indeed, We sent down the Torah, in which was guidance and light. The prophets who submitted [to Allah] judged by it for the Jews, as did the rabbis and scholars by that with which they were entrusted of the Scripture of Allah, and they were witnesses thereto. So do not fear the people but fear Me, and do not exchange My verses for a small price. And whoever does not judge by what Allah has revealed - then it is those who are the disbelievers",
    normalizedText:
      "انا انزلنا التورىة فيها هدى ونور يحكم بها النبيون الذين اسلموا للذين هادوا والربنيون والاحبار بما استحفظوا من كتب الله وكانوا عليه شهداء فلا تخشوا الناس واخشون ولا تشتروا بايتي ثمنا قليلا ومن لم يحكم بما انزل الله فاولاك هم الكفرون",
  },
  {
    verseId: 44,
    name: "المائدة",
    surahId: 5,
    text: "وَكَتَبۡنَا عَلَيۡهِمۡ فِيهَآ أَنَّ ٱلنَّفۡسَ بِٱلنَّفۡسِ وَٱلۡعَيۡنَ بِٱلۡعَيۡنِ وَٱلۡأَنفَ بِٱلۡأَنفِ وَٱلۡأُذُنَ بِٱلۡأُذُنِ وَٱلسِّنَّ بِٱلسِّنِّ وَٱلۡجُرُوحَ قِصَاصٞۚ فَمَن تَصَدَّقَ بِهِۦ فَهُوَ كَفَّارَةٞ لَّهُۥۚ وَمَن لَّمۡ يَحۡكُم بِمَآ أَنزَلَ ٱللَّهُ فَأُوْلَـٰٓئِكَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "And We ordained for them therein a life for a life, an eye for an eye, a nose for a nose, an ear for an ear, a tooth for a tooth, and for wounds is legal retribution. But whoever gives [up his right as] charity, it is an expiation for him. And whoever does not judge by what Allah has revealed - then it is those who are the wrongdoers",
    normalizedText:
      "وكتبنا عليهم فيها ان النفس بالنفس والعين بالعين والانف بالانف والاذن بالاذن والسن بالسن والجروح قصاص فمن تصدق به فهو كفارة له ومن لم يحكم بما انزل الله فاولاك هم الظلمون",
  },
  {
    verseId: 45,
    name: "المائدة",
    surahId: 5,
    text: "وَقَفَّيۡنَا عَلَىٰٓ ءَاثَٰرِهِم بِعِيسَى ٱبۡنِ مَرۡيَمَ مُصَدِّقٗا لِّمَا بَيۡنَ يَدَيۡهِ مِنَ ٱلتَّوۡرَىٰةِۖ وَءَاتَيۡنَٰهُ ٱلۡإِنجِيلَ فِيهِ هُدٗى وَنُورٞ وَمُصَدِّقٗا لِّمَا بَيۡنَ يَدَيۡهِ مِنَ ٱلتَّوۡرَىٰةِ وَهُدٗى وَمَوۡعِظَةٗ لِّلۡمُتَّقِينَ",
    translation:
      "And We sent, following in their footsteps, Jesus, the son of Mary, confirming that which came before him in the Torah; and We gave him the Gospel, in which was guidance and light and confirming that which preceded it of the Torah as guidance and instruction for the righteous",
    normalizedText:
      "وقفينا على ءاثرهم بعيسى ابن مريم مصدقا لما بين يديه من التورىة وءاتينه الانجيل فيه هدى ونور ومصدقا لما بين يديه من التورىة وهدى وموعظة للمتقين",
  },
  {
    verseId: 46,
    name: "المائدة",
    surahId: 5,
    text: "وَلۡيَحۡكُمۡ أَهۡلُ ٱلۡإِنجِيلِ بِمَآ أَنزَلَ ٱللَّهُ فِيهِۚ وَمَن لَّمۡ يَحۡكُم بِمَآ أَنزَلَ ٱللَّهُ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡفَٰسِقُونَ",
    translation:
      "And let the People of the Gospel judge by what Allah has revealed therein. And whoever does not judge by what Allah has revealed - then it is those who are the defiantly disobedient",
    normalizedText:
      "وليحكم اهل الانجيل بما انزل الله فيه ومن لم يحكم بما انزل الله فاولاك هم الفسقون",
  },
  {
    verseId: 47,
    name: "المائدة",
    surahId: 5,
    text: "وَأَنزَلۡنَآ إِلَيۡكَ ٱلۡكِتَٰبَ بِٱلۡحَقِّ مُصَدِّقٗا لِّمَا بَيۡنَ يَدَيۡهِ مِنَ ٱلۡكِتَٰبِ وَمُهَيۡمِنًا عَلَيۡهِۖ فَٱحۡكُم بَيۡنَهُم بِمَآ أَنزَلَ ٱللَّهُۖ وَلَا تَتَّبِعۡ أَهۡوَآءَهُمۡ عَمَّا جَآءَكَ مِنَ ٱلۡحَقِّۚ لِكُلّٖ جَعَلۡنَا مِنكُمۡ شِرۡعَةٗ وَمِنۡهَاجٗاۚ وَلَوۡ شَآءَ ٱللَّهُ لَجَعَلَكُمۡ أُمَّةٗ وَٰحِدَةٗ وَلَٰكِن لِّيَبۡلُوَكُمۡ فِي مَآ ءَاتَىٰكُمۡۖ فَٱسۡتَبِقُواْ ٱلۡخَيۡرَٰتِۚ إِلَى ٱللَّهِ مَرۡجِعُكُمۡ جَمِيعٗا فَيُنَبِّئُكُم بِمَا كُنتُمۡ فِيهِ تَخۡتَلِفُونَ",
    translation:
      "And We have revealed to you, [O Muhammad], the Book in truth, confirming that which preceded it of the Scripture and as a criterion over it. So judge between them by what Allah has revealed and do not follow their inclinations away from what has come to you of the truth. To each of you We prescribed a law and a method. Had Allah willed, He would have made you one nation [united in religion], but [He intended] to test you in what He has given you; so race to [all that is] good. To Allah is your return all together, and He will [then] inform you concerning that over which you used to differ",
    normalizedText:
      "وانزلنا اليك الكتب بالحق مصدقا لما بين يديه من الكتب ومهيمنا عليه فاحكم بينهم بما انزل الله ولا تتبع اهواءهم عما جاءك من الحق لكل جعلنا منكم شرعة ومنهاجا ولو شاء الله لجعلكم امة وحدة ولكن ليبلوكم في ما ءاتىكم فاستبقوا الخيرت الى الله مرجعكم جميعا فينباكم بما كنتم فيه تختلفون",
  },
  {
    verseId: 48,
    name: "المائدة",
    surahId: 5,
    text: "وَأَنِ ٱحۡكُم بَيۡنَهُم بِمَآ أَنزَلَ ٱللَّهُ وَلَا تَتَّبِعۡ أَهۡوَآءَهُمۡ وَٱحۡذَرۡهُمۡ أَن يَفۡتِنُوكَ عَنۢ بَعۡضِ مَآ أَنزَلَ ٱللَّهُ إِلَيۡكَۖ فَإِن تَوَلَّوۡاْ فَٱعۡلَمۡ أَنَّمَا يُرِيدُ ٱللَّهُ أَن يُصِيبَهُم بِبَعۡضِ ذُنُوبِهِمۡۗ وَإِنَّ كَثِيرٗا مِّنَ ٱلنَّاسِ لَفَٰسِقُونَ",
    translation:
      "And judge, [O Muhammad], between them by what Allah has revealed and do not follow their inclinations and beware of them, lest they tempt you away from some of what Allah has revealed to you. And if they turn away - then know that Allah only intends to afflict them with some of their [own] sins. And indeed, many among the people are defiantly disobedient",
    normalizedText:
      "وان احكم بينهم بما انزل الله ولا تتبع اهواءهم واحذرهم ان يفتنوك عن بعض ما انزل الله اليك فان تولوا فاعلم انما يريد الله ان يصيبهم ببعض ذنوبهم وان كثيرا من الناس لفسقون",
  },
  {
    verseId: 49,
    name: "المائدة",
    surahId: 5,
    text: "أَفَحُكۡمَ ٱلۡجَٰهِلِيَّةِ يَبۡغُونَۚ وَمَنۡ أَحۡسَنُ مِنَ ٱللَّهِ حُكۡمٗا لِّقَوۡمٖ يُوقِنُونَ",
    translation:
      "Then is it the judgement of [the time of] ignorance they desire? But who is better than Allah in judgement for a people who are certain [in faith]",
    normalizedText: "افحكم الجهلية يبغون ومن احسن من الله حكما لقوم يوقنون",
  },
  {
    verseId: 50,
    name: "المائدة",
    surahId: 5,
    text: "۞يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّخِذُواْ ٱلۡيَهُودَ وَٱلنَّصَٰرَىٰٓ أَوۡلِيَآءَۘ بَعۡضُهُمۡ أَوۡلِيَآءُ بَعۡضٖۚ وَمَن يَتَوَلَّهُم مِّنكُمۡ فَإِنَّهُۥ مِنۡهُمۡۗ إِنَّ ٱللَّهَ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      "O you who have believed, do not take the Jews and the Christians as allies. They are [in fact] allies of one another. And whoever is an ally to them among you - then indeed, he is [one] of them. Indeed, Allah guides not the wrongdoing people",
    normalizedText:
      "۞يايها الذين ءامنوا لا تتخذوا اليهود والنصرى اولياء بعضهم اولياء بعض ومن يتولهم منكم فانه منهم ان الله لا يهدي القوم الظلمين",
  },
  {
    verseId: 51,
    name: "المائدة",
    surahId: 5,
    text: "فَتَرَى ٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٞ يُسَٰرِعُونَ فِيهِمۡ يَقُولُونَ نَخۡشَىٰٓ أَن تُصِيبَنَا دَآئِرَةٞۚ فَعَسَى ٱللَّهُ أَن يَأۡتِيَ بِٱلۡفَتۡحِ أَوۡ أَمۡرٖ مِّنۡ عِندِهِۦ فَيُصۡبِحُواْ عَلَىٰ مَآ أَسَرُّواْ فِيٓ أَنفُسِهِمۡ نَٰدِمِينَ",
    translation:
      'So you see those in whose hearts is disease hastening into [association with] them, saying, "We are afraid a misfortune may strike us." But perhaps Allah will bring conquest or a decision from Him, and they will become, over what they have been concealing within themselves, regretful',
    normalizedText:
      "فترى الذين في قلوبهم مرض يسرعون فيهم يقولون نخشى ان تصيبنا داارة فعسى الله ان ياتي بالفتح او امر من عنده فيصبحوا على ما اسروا في انفسهم ندمين",
  },
  {
    verseId: 52,
    name: "المائدة",
    surahId: 5,
    text: "وَيَقُولُ ٱلَّذِينَ ءَامَنُوٓاْ أَهَـٰٓؤُلَآءِ ٱلَّذِينَ أَقۡسَمُواْ بِٱللَّهِ جَهۡدَ أَيۡمَٰنِهِمۡ إِنَّهُمۡ لَمَعَكُمۡۚ حَبِطَتۡ أَعۡمَٰلُهُمۡ فَأَصۡبَحُواْ خَٰسِرِينَ",
    translation:
      'And those who believe will say, "Are these the ones who swore by Allah their strongest oaths that indeed they were with you?" Their deeds have become worthless, and they have become losers',
    normalizedText:
      "ويقول الذين ءامنوا اهالاء الذين اقسموا بالله جهد ايمنهم انهم لمعكم حبطت اعملهم فاصبحوا خسرين",
  },
  {
    verseId: 53,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ مَن يَرۡتَدَّ مِنكُمۡ عَن دِينِهِۦ فَسَوۡفَ يَأۡتِي ٱللَّهُ بِقَوۡمٖ يُحِبُّهُمۡ وَيُحِبُّونَهُۥٓ أَذِلَّةٍ عَلَى ٱلۡمُؤۡمِنِينَ أَعِزَّةٍ عَلَى ٱلۡكَٰفِرِينَ يُجَٰهِدُونَ فِي سَبِيلِ ٱللَّهِ وَلَا يَخَافُونَ لَوۡمَةَ لَآئِمٖۚ ذَٰلِكَ فَضۡلُ ٱللَّهِ يُؤۡتِيهِ مَن يَشَآءُۚ وَٱللَّهُ وَٰسِعٌ عَلِيمٌ",
    translation:
      "O you who have believed, whoever of you should revert from his religion - Allah will bring forth [in place of them] a people He will love and who will love Him [who are] humble toward the believers, powerful against the disbelievers; they strive in the cause of Allah and do not fear the blame of a critic. That is the favor of Allah; He bestows it upon whom He wills. And Allah is all-Encompassing and Knowing",
    normalizedText:
      "يايها الذين ءامنوا من يرتد منكم عن دينه فسوف ياتي الله بقوم يحبهم ويحبونه اذلة على المامنين اعزة على الكفرين يجهدون في سبيل الله ولا يخافون لومة لاام ذلك فضل الله ياتيه من يشاء والله وسع عليم",
  },
  {
    verseId: 54,
    name: "المائدة",
    surahId: 5,
    text: "إِنَّمَا وَلِيُّكُمُ ٱللَّهُ وَرَسُولُهُۥ وَٱلَّذِينَ ءَامَنُواْ ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤۡتُونَ ٱلزَّكَوٰةَ وَهُمۡ رَٰكِعُونَ",
    translation:
      "Your ally is none but Allah and [therefore] His Messenger and those who have believed - those who establish prayer and give zakah, and they bow [in worship]",
    normalizedText:
      "انما وليكم الله ورسوله والذين ءامنوا الذين يقيمون الصلوة وياتون الزكوة وهم ركعون",
  },
  {
    verseId: 55,
    name: "المائدة",
    surahId: 5,
    text: "وَمَن يَتَوَلَّ ٱللَّهَ وَرَسُولَهُۥ وَٱلَّذِينَ ءَامَنُواْ فَإِنَّ حِزۡبَ ٱللَّهِ هُمُ ٱلۡغَٰلِبُونَ",
    translation:
      "And whoever is an ally of Allah and His Messenger and those who have believed - indeed, the party of Allah - they will be the predominant",
    normalizedText:
      "ومن يتول الله ورسوله والذين ءامنوا فان حزب الله هم الغلبون",
  },
  {
    verseId: 56,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّخِذُواْ ٱلَّذِينَ ٱتَّخَذُواْ دِينَكُمۡ هُزُوٗا وَلَعِبٗا مِّنَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ مِن قَبۡلِكُمۡ وَٱلۡكُفَّارَ أَوۡلِيَآءَۚ وَٱتَّقُواْ ٱللَّهَ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "O you who have believed, take not those who have taken your religion in ridicule and amusement among the ones who were given the Scripture before you nor the disbelievers as allies. And fear Allah, if you should [truly] be believers",
    normalizedText:
      "يايها الذين ءامنوا لا تتخذوا الذين اتخذوا دينكم هزوا ولعبا من الذين اوتوا الكتب من قبلكم والكفار اولياء واتقوا الله ان كنتم مامنين",
  },
  {
    verseId: 57,
    name: "المائدة",
    surahId: 5,
    text: "وَإِذَا نَادَيۡتُمۡ إِلَى ٱلصَّلَوٰةِ ٱتَّخَذُوهَا هُزُوٗا وَلَعِبٗاۚ ذَٰلِكَ بِأَنَّهُمۡ قَوۡمٞ لَّا يَعۡقِلُونَ",
    translation:
      "And when you call to prayer, they take it in ridicule and amusement. That is because they are a people who do not use reason",
    normalizedText:
      "واذا ناديتم الى الصلوة اتخذوها هزوا ولعبا ذلك بانهم قوم لا يعقلون",
  },
  {
    verseId: 58,
    name: "المائدة",
    surahId: 5,
    text: "قُلۡ يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ هَلۡ تَنقِمُونَ مِنَّآ إِلَّآ أَنۡ ءَامَنَّا بِٱللَّهِ وَمَآ أُنزِلَ إِلَيۡنَا وَمَآ أُنزِلَ مِن قَبۡلُ وَأَنَّ أَكۡثَرَكُمۡ فَٰسِقُونَ",
    translation:
      'Say, "O People of the Scripture, do you resent us except [for the fact] that we have believed in Allah and what was revealed to us and what was revealed before and because most of you are defiantly disobedient',
    normalizedText:
      "قل ياهل الكتب هل تنقمون منا الا ان ءامنا بالله وما انزل الينا وما انزل من قبل وان اكثركم فسقون",
  },
  {
    verseId: 59,
    name: "المائدة",
    surahId: 5,
    text: "قُلۡ هَلۡ أُنَبِّئُكُم بِشَرّٖ مِّن ذَٰلِكَ مَثُوبَةً عِندَ ٱللَّهِۚ مَن لَّعَنَهُ ٱللَّهُ وَغَضِبَ عَلَيۡهِ وَجَعَلَ مِنۡهُمُ ٱلۡقِرَدَةَ وَٱلۡخَنَازِيرَ وَعَبَدَ ٱلطَّـٰغُوتَۚ أُوْلَـٰٓئِكَ شَرّٞ مَّكَانٗا وَأَضَلُّ عَن سَوَآءِ ٱلسَّبِيلِ",
    translation:
      'Say, "Shall I inform you of [what is] worse than that as penalty from Allah? [It is that of] those whom Allah has cursed and with whom He became angry and made of them apes and pigs and slaves of Taghut. Those are worse in position and further astray from the sound way',
    normalizedText:
      "قل هل انباكم بشر من ذلك مثوبة عند الله من لعنه الله وغضب عليه وجعل منهم القردة والخنازير وعبد الطغوت اولاك شر مكانا واضل عن سواء السبيل",
  },
  {
    verseId: 60,
    name: "المائدة",
    surahId: 5,
    text: "وَإِذَا جَآءُوكُمۡ قَالُوٓاْ ءَامَنَّا وَقَد دَّخَلُواْ بِٱلۡكُفۡرِ وَهُمۡ قَدۡ خَرَجُواْ بِهِۦۚ وَٱللَّهُ أَعۡلَمُ بِمَا كَانُواْ يَكۡتُمُونَ",
    translation:
      'And when they come to you, they say, "We believe." But they have entered with disbelief [in their hearts], and they have certainly left with it. And Allah is most knowing of what they were concealing',
    normalizedText:
      "واذا جاءوكم قالوا ءامنا وقد دخلوا بالكفر وهم قد خرجوا به والله اعلم بما كانوا يكتمون",
  },
  {
    verseId: 61,
    name: "المائدة",
    surahId: 5,
    text: "وَتَرَىٰ كَثِيرٗا مِّنۡهُمۡ يُسَٰرِعُونَ فِي ٱلۡإِثۡمِ وَٱلۡعُدۡوَٰنِ وَأَكۡلِهِمُ ٱلسُّحۡتَۚ لَبِئۡسَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "And you see many of them hastening into sin and aggression and the devouring of [what is] unlawful. How wretched is what they have been doing",
    normalizedText:
      "وترى كثيرا منهم يسرعون في الاثم والعدون واكلهم السحت لباس ما كانوا يعملون",
  },
  {
    verseId: 62,
    name: "المائدة",
    surahId: 5,
    text: "لَوۡلَا يَنۡهَىٰهُمُ ٱلرَّبَّـٰنِيُّونَ وَٱلۡأَحۡبَارُ عَن قَوۡلِهِمُ ٱلۡإِثۡمَ وَأَكۡلِهِمُ ٱلسُّحۡتَۚ لَبِئۡسَ مَا كَانُواْ يَصۡنَعُونَ",
    translation:
      "Why do the rabbis and religious scholars not forbid them from saying what is sinful and devouring what is unlawful? How wretched is what they have been practicing",
    normalizedText:
      "لولا ينهىهم الربنيون والاحبار عن قولهم الاثم واكلهم السحت لباس ما كانوا يصنعون",
  },
  {
    verseId: 63,
    name: "المائدة",
    surahId: 5,
    text: "وَقَالَتِ ٱلۡيَهُودُ يَدُ ٱللَّهِ مَغۡلُولَةٌۚ غُلَّتۡ أَيۡدِيهِمۡ وَلُعِنُواْ بِمَا قَالُواْۘ بَلۡ يَدَاهُ مَبۡسُوطَتَانِ يُنفِقُ كَيۡفَ يَشَآءُۚ وَلَيَزِيدَنَّ كَثِيرٗا مِّنۡهُم مَّآ أُنزِلَ إِلَيۡكَ مِن رَّبِّكَ طُغۡيَٰنٗا وَكُفۡرٗاۚ وَأَلۡقَيۡنَا بَيۡنَهُمُ ٱلۡعَدَٰوَةَ وَٱلۡبَغۡضَآءَ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِۚ كُلَّمَآ أَوۡقَدُواْ نَارٗا لِّلۡحَرۡبِ أَطۡفَأَهَا ٱللَّهُۚ وَيَسۡعَوۡنَ فِي ٱلۡأَرۡضِ فَسَادٗاۚ وَٱللَّهُ لَا يُحِبُّ ٱلۡمُفۡسِدِينَ",
    translation:
      'And the Jews say, "The hand of Allah is chained." Chained are their hands, and cursed are they for what they say. Rather, both His hands are extended; He spends however He wills. And that which has been revealed to you from your Lord will surely increase many of them in transgression and disbelief. And We have cast among them animosity and hatred until the Day of Resurrection. Every time they kindled the fire of war [against you], Allah extinguished it. And they strive throughout the land [causing] corruption, and Allah does not like corrupters',
    normalizedText:
      "وقالت اليهود يد الله مغلولة غلت ايديهم ولعنوا بما قالوا بل يداه مبسوطتان ينفق كيف يشاء وليزيدن كثيرا منهم ما انزل اليك من ربك طغينا وكفرا والقينا بينهم العدوة والبغضاء الى يوم القيمة كلما اوقدوا نارا للحرب اطفاها الله ويسعون في الارض فسادا والله لا يحب المفسدين",
  },
  {
    verseId: 64,
    name: "المائدة",
    surahId: 5,
    text: "وَلَوۡ أَنَّ أَهۡلَ ٱلۡكِتَٰبِ ءَامَنُواْ وَٱتَّقَوۡاْ لَكَفَّرۡنَا عَنۡهُمۡ سَيِّـَٔاتِهِمۡ وَلَأَدۡخَلۡنَٰهُمۡ جَنَّـٰتِ ٱلنَّعِيمِ",
    translation:
      "And if only the People of the Scripture had believed and feared Allah, We would have removed from them their misdeeds and admitted them to Gardens of Pleasure",
    normalizedText:
      "ولو ان اهل الكتب ءامنوا واتقوا لكفرنا عنهم سياتهم ولادخلنهم جنت النعيم",
  },
  {
    verseId: 65,
    name: "المائدة",
    surahId: 5,
    text: "وَلَوۡ أَنَّهُمۡ أَقَامُواْ ٱلتَّوۡرَىٰةَ وَٱلۡإِنجِيلَ وَمَآ أُنزِلَ إِلَيۡهِم مِّن رَّبِّهِمۡ لَأَكَلُواْ مِن فَوۡقِهِمۡ وَمِن تَحۡتِ أَرۡجُلِهِمۚ مِّنۡهُمۡ أُمَّةٞ مُّقۡتَصِدَةٞۖ وَكَثِيرٞ مِّنۡهُمۡ سَآءَ مَا يَعۡمَلُونَ",
    translation:
      "And if only they upheld [the law of] the Torah, the Gospel, and what has been revealed to them from their Lord, they would have consumed [provision] from above them and from beneath their feet. Among them are a moderate community, but many of them - evil is that which they do",
    normalizedText:
      "ولو انهم اقاموا التورىة والانجيل وما انزل اليهم من ربهم لاكلوا من فوقهم ومن تحت ارجلهم منهم امة مقتصدة وكثير منهم ساء ما يعملون",
  },
  {
    verseId: 66,
    name: "المائدة",
    surahId: 5,
    text: "۞يَـٰٓأَيُّهَا ٱلرَّسُولُ بَلِّغۡ مَآ أُنزِلَ إِلَيۡكَ مِن رَّبِّكَۖ وَإِن لَّمۡ تَفۡعَلۡ فَمَا بَلَّغۡتَ رِسَالَتَهُۥۚ وَٱللَّهُ يَعۡصِمُكَ مِنَ ٱلنَّاسِۗ إِنَّ ٱللَّهَ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡكَٰفِرِينَ",
    translation:
      "O Messenger, announce that which has been revealed to you from your Lord, and if you do not, then you have not conveyed His message. And Allah will protect you from the people. Indeed, Allah does not guide the disbelieving people",
    normalizedText:
      "۞يايها الرسول بلغ ما انزل اليك من ربك وان لم تفعل فما بلغت رسالته والله يعصمك من الناس ان الله لا يهدي القوم الكفرين",
  },
  {
    verseId: 67,
    name: "المائدة",
    surahId: 5,
    text: "قُلۡ يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لَسۡتُمۡ عَلَىٰ شَيۡءٍ حَتَّىٰ تُقِيمُواْ ٱلتَّوۡرَىٰةَ وَٱلۡإِنجِيلَ وَمَآ أُنزِلَ إِلَيۡكُم مِّن رَّبِّكُمۡۗ وَلَيَزِيدَنَّ كَثِيرٗا مِّنۡهُم مَّآ أُنزِلَ إِلَيۡكَ مِن رَّبِّكَ طُغۡيَٰنٗا وَكُفۡرٗاۖ فَلَا تَأۡسَ عَلَى ٱلۡقَوۡمِ ٱلۡكَٰفِرِينَ",
    translation:
      'Say, "O People of the Scripture, you are [standing] on nothing until you uphold [the law of] the Torah, the Gospel, and what has been revealed to you from your Lord." And that which has been revealed to you from your Lord will surely increase many of them in transgression and disbelief. So do not grieve over the disbelieving people',
    normalizedText:
      "قل ياهل الكتب لستم على شيء حتى تقيموا التورىة والانجيل وما انزل اليكم من ربكم وليزيدن كثيرا منهم ما انزل اليك من ربك طغينا وكفرا فلا تاس على القوم الكفرين",
  },
  {
    verseId: 68,
    name: "المائدة",
    surahId: 5,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَٱلَّذِينَ هَادُواْ وَٱلصَّـٰبِـُٔونَ وَٱلنَّصَٰرَىٰ مَنۡ ءَامَنَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَعَمِلَ صَٰلِحٗا فَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Indeed, those who have believed [in Prophet Muhammad] and those [before Him] who were Jews or Sabeans or Christians - those [among them] who believed in Allah and the Last Day and did righteousness - no fear will there be concerning them, nor will they grieve",
    normalizedText:
      "ان الذين ءامنوا والذين هادوا والصبون والنصرى من ءامن بالله واليوم الاخر وعمل صلحا فلا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 69,
    name: "المائدة",
    surahId: 5,
    text: "لَقَدۡ أَخَذۡنَا مِيثَٰقَ بَنِيٓ إِسۡرَـٰٓءِيلَ وَأَرۡسَلۡنَآ إِلَيۡهِمۡ رُسُلٗاۖ كُلَّمَا جَآءَهُمۡ رَسُولُۢ بِمَا لَا تَهۡوَىٰٓ أَنفُسُهُمۡ فَرِيقٗا كَذَّبُواْ وَفَرِيقٗا يَقۡتُلُونَ",
    translation:
      "We had already taken the covenant of the Children of Israel and had sent to them messengers. Whenever there came to them a messenger with what their souls did not desire, a party [of messengers] they denied, and another party they killed",
    normalizedText:
      "لقد اخذنا ميثق بني اسرءيل وارسلنا اليهم رسلا كلما جاءهم رسول بما لا تهوى انفسهم فريقا كذبوا وفريقا يقتلون",
  },
  {
    verseId: 70,
    name: "المائدة",
    surahId: 5,
    text: "وَحَسِبُوٓاْ أَلَّا تَكُونَ فِتۡنَةٞ فَعَمُواْ وَصَمُّواْ ثُمَّ تَابَ ٱللَّهُ عَلَيۡهِمۡ ثُمَّ عَمُواْ وَصَمُّواْ كَثِيرٞ مِّنۡهُمۡۚ وَٱللَّهُ بَصِيرُۢ بِمَا يَعۡمَلُونَ",
    translation:
      "And they thought there would be no [resulting] punishment, so they became blind and deaf. Then Allah turned to them in forgiveness; then [again] many of them became blind and deaf. And Allah is Seeing of what they do",
    normalizedText:
      "وحسبوا الا تكون فتنة فعموا وصموا ثم تاب الله عليهم ثم عموا وصموا كثير منهم والله بصير بما يعملون",
  },
  {
    verseId: 71,
    name: "المائدة",
    surahId: 5,
    text: "لَقَدۡ كَفَرَ ٱلَّذِينَ قَالُوٓاْ إِنَّ ٱللَّهَ هُوَ ٱلۡمَسِيحُ ٱبۡنُ مَرۡيَمَۖ وَقَالَ ٱلۡمَسِيحُ يَٰبَنِيٓ إِسۡرَـٰٓءِيلَ ٱعۡبُدُواْ ٱللَّهَ رَبِّي وَرَبَّكُمۡۖ إِنَّهُۥ مَن يُشۡرِكۡ بِٱللَّهِ فَقَدۡ حَرَّمَ ٱللَّهُ عَلَيۡهِ ٱلۡجَنَّةَ وَمَأۡوَىٰهُ ٱلنَّارُۖ وَمَا لِلظَّـٰلِمِينَ مِنۡ أَنصَارٖ",
    translation:
      'They have certainly disbelieved who say, "Allah is the Messiah, the son of Mary" while the Messiah has said, "O Children of Israel, worship Allah, my Lord and your Lord." Indeed, he who associates others with Allah - Allah has forbidden him Paradise, and his refuge is the Fire. And there are not for the wrongdoers any helpers',
    normalizedText:
      "لقد كفر الذين قالوا ان الله هو المسيح ابن مريم وقال المسيح يبني اسرءيل اعبدوا الله ربي وربكم انه من يشرك بالله فقد حرم الله عليه الجنة وماوىه النار وما للظلمين من انصار",
  },
  {
    verseId: 72,
    name: "المائدة",
    surahId: 5,
    text: "لَّقَدۡ كَفَرَ ٱلَّذِينَ قَالُوٓاْ إِنَّ ٱللَّهَ ثَالِثُ ثَلَٰثَةٖۘ وَمَا مِنۡ إِلَٰهٍ إِلَّآ إِلَٰهٞ وَٰحِدٞۚ وَإِن لَّمۡ يَنتَهُواْ عَمَّا يَقُولُونَ لَيَمَسَّنَّ ٱلَّذِينَ كَفَرُواْ مِنۡهُمۡ عَذَابٌ أَلِيمٌ",
    translation:
      'They have certainly disbelieved who say, "Allah is the third of three." And there is no god except one God. And if they do not desist from what they are saying, there will surely afflict the disbelievers among them a painful punishment',
    normalizedText:
      "لقد كفر الذين قالوا ان الله ثالث ثلثة وما من اله الا اله وحد وان لم ينتهوا عما يقولون ليمسن الذين كفروا منهم عذاب اليم",
  },
  {
    verseId: 73,
    name: "المائدة",
    surahId: 5,
    text: "أَفَلَا يَتُوبُونَ إِلَى ٱللَّهِ وَيَسۡتَغۡفِرُونَهُۥۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "So will they not repent to Allah and seek His forgiveness? And Allah is Forgiving and Merciful",
    normalizedText: "افلا يتوبون الى الله ويستغفرونه والله غفور رحيم",
  },
  {
    verseId: 74,
    name: "المائدة",
    surahId: 5,
    text: "مَّا ٱلۡمَسِيحُ ٱبۡنُ مَرۡيَمَ إِلَّا رَسُولٞ قَدۡ خَلَتۡ مِن قَبۡلِهِ ٱلرُّسُلُ وَأُمُّهُۥ صِدِّيقَةٞۖ كَانَا يَأۡكُلَانِ ٱلطَّعَامَۗ ٱنظُرۡ كَيۡفَ نُبَيِّنُ لَهُمُ ٱلۡأٓيَٰتِ ثُمَّ ٱنظُرۡ أَنَّىٰ يُؤۡفَكُونَ",
    translation:
      "The Messiah, son of Mary, was not but a messenger; [other] messengers have passed on before him. And his mother was a supporter of truth. They both used to eat food. Look how We make clear to them the signs; then look how they are deluded",
    normalizedText:
      "ما المسيح ابن مريم الا رسول قد خلت من قبله الرسل وامه صديقة كانا ياكلان الطعام انظر كيف نبين لهم الايت ثم انظر انى يافكون",
  },
  {
    verseId: 75,
    name: "المائدة",
    surahId: 5,
    text: "قُلۡ أَتَعۡبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَمۡلِكُ لَكُمۡ ضَرّٗا وَلَا نَفۡعٗاۚ وَٱللَّهُ هُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      'Say, "Do you worship besides Allah that which holds for you no [power of] harm or benefit while it is Allah who is the Hearing, the Knowing',
    normalizedText:
      "قل اتعبدون من دون الله ما لا يملك لكم ضرا ولا نفعا والله هو السميع العليم",
  },
  {
    verseId: 76,
    name: "المائدة",
    surahId: 5,
    text: "قُلۡ يَـٰٓأَهۡلَ ٱلۡكِتَٰبِ لَا تَغۡلُواْ فِي دِينِكُمۡ غَيۡرَ ٱلۡحَقِّ وَلَا تَتَّبِعُوٓاْ أَهۡوَآءَ قَوۡمٖ قَدۡ ضَلُّواْ مِن قَبۡلُ وَأَضَلُّواْ كَثِيرٗا وَضَلُّواْ عَن سَوَآءِ ٱلسَّبِيلِ",
    translation:
      'Say, "O People of the Scripture, do not exceed limits in your religion beyond the truth and do not follow the inclinations of a people who had gone astray before and misled many and have strayed from the soundness of the way',
    normalizedText:
      "قل ياهل الكتب لا تغلوا في دينكم غير الحق ولا تتبعوا اهواء قوم قد ضلوا من قبل واضلوا كثيرا وضلوا عن سواء السبيل",
  },
  {
    verseId: 77,
    name: "المائدة",
    surahId: 5,
    text: "لُعِنَ ٱلَّذِينَ كَفَرُواْ مِنۢ بَنِيٓ إِسۡرَـٰٓءِيلَ عَلَىٰ لِسَانِ دَاوُۥدَ وَعِيسَى ٱبۡنِ مَرۡيَمَۚ ذَٰلِكَ بِمَا عَصَواْ وَّكَانُواْ يَعۡتَدُونَ",
    translation:
      "Cursed were those who disbelieved among the Children of Israel by the tongue of David and of Jesus, the son of Mary. That was because they disobeyed and [habitually] transgressed",
    normalizedText:
      "لعن الذين كفروا من بني اسرءيل على لسان داود وعيسى ابن مريم ذلك بما عصوا وكانوا يعتدون",
  },
  {
    verseId: 78,
    name: "المائدة",
    surahId: 5,
    text: "كَانُواْ لَا يَتَنَاهَوۡنَ عَن مُّنكَرٖ فَعَلُوهُۚ لَبِئۡسَ مَا كَانُواْ يَفۡعَلُونَ",
    translation:
      "They used not to prevent one another from wrongdoing that they did. How wretched was that which they were doing",
    normalizedText: "كانوا لا يتناهون عن منكر فعلوه لباس ما كانوا يفعلون",
  },
  {
    verseId: 79,
    name: "المائدة",
    surahId: 5,
    text: "تَرَىٰ كَثِيرٗا مِّنۡهُمۡ يَتَوَلَّوۡنَ ٱلَّذِينَ كَفَرُواْۚ لَبِئۡسَ مَا قَدَّمَتۡ لَهُمۡ أَنفُسُهُمۡ أَن سَخِطَ ٱللَّهُ عَلَيۡهِمۡ وَفِي ٱلۡعَذَابِ هُمۡ خَٰلِدُونَ",
    translation:
      "You see many of them becoming allies of those who disbelieved. How wretched is that which they have put forth for themselves in that Allah has become angry with them, and in the punishment they will abide eternally",
    normalizedText:
      "ترى كثيرا منهم يتولون الذين كفروا لباس ما قدمت لهم انفسهم ان سخط الله عليهم وفي العذاب هم خلدون",
  },
  {
    verseId: 80,
    name: "المائدة",
    surahId: 5,
    text: "وَلَوۡ كَانُواْ يُؤۡمِنُونَ بِٱللَّهِ وَٱلنَّبِيِّ وَمَآ أُنزِلَ إِلَيۡهِ مَا ٱتَّخَذُوهُمۡ أَوۡلِيَآءَ وَلَٰكِنَّ كَثِيرٗا مِّنۡهُمۡ فَٰسِقُونَ",
    translation:
      "And if they had believed in Allah and the Prophet and in what was revealed to him, they would not have taken them as allies; but many of them are defiantly disobedient",
    normalizedText:
      "ولو كانوا يامنون بالله والنبي وما انزل اليه ما اتخذوهم اولياء ولكن كثيرا منهم فسقون",
  },
  {
    verseId: 81,
    name: "المائدة",
    surahId: 5,
    text: "۞لَتَجِدَنَّ أَشَدَّ ٱلنَّاسِ عَدَٰوَةٗ لِّلَّذِينَ ءَامَنُواْ ٱلۡيَهُودَ وَٱلَّذِينَ أَشۡرَكُواْۖ وَلَتَجِدَنَّ أَقۡرَبَهُم مَّوَدَّةٗ لِّلَّذِينَ ءَامَنُواْ ٱلَّذِينَ قَالُوٓاْ إِنَّا نَصَٰرَىٰۚ ذَٰلِكَ بِأَنَّ مِنۡهُمۡ قِسِّيسِينَ وَرُهۡبَانٗا وَأَنَّهُمۡ لَا يَسۡتَكۡبِرُونَ",
    translation:
      'You will surely find the most intense of the people in animosity toward the believers [to be] the Jews and those who associate others with Allah; and you will find the nearest of them in affection to the believers those who say, "We are Christians." That is because among them are priests and monks and because they are not arrogant',
    normalizedText:
      "۞لتجدن اشد الناس عدوة للذين ءامنوا اليهود والذين اشركوا ولتجدن اقربهم مودة للذين ءامنوا الذين قالوا انا نصرى ذلك بان منهم قسيسين ورهبانا وانهم لا يستكبرون",
  },
  {
    verseId: 82,
    name: "المائدة",
    surahId: 5,
    text: "وَإِذَا سَمِعُواْ مَآ أُنزِلَ إِلَى ٱلرَّسُولِ تَرَىٰٓ أَعۡيُنَهُمۡ تَفِيضُ مِنَ ٱلدَّمۡعِ مِمَّا عَرَفُواْ مِنَ ٱلۡحَقِّۖ يَقُولُونَ رَبَّنَآ ءَامَنَّا فَٱكۡتُبۡنَا مَعَ ٱلشَّـٰهِدِينَ",
    translation:
      'And when they hear what has been revealed to the Messenger, you see their eyes overflowing with tears because of what they have recognized of the truth. They say, "Our Lord, we have believed, so register us among the witnesses',
    normalizedText:
      "واذا سمعوا ما انزل الى الرسول ترى اعينهم تفيض من الدمع مما عرفوا من الحق يقولون ربنا ءامنا فاكتبنا مع الشهدين",
  },
  {
    verseId: 83,
    name: "المائدة",
    surahId: 5,
    text: "وَمَا لَنَا لَا نُؤۡمِنُ بِٱللَّهِ وَمَا جَآءَنَا مِنَ ٱلۡحَقِّ وَنَطۡمَعُ أَن يُدۡخِلَنَا رَبُّنَا مَعَ ٱلۡقَوۡمِ ٱلصَّـٰلِحِينَ",
    translation:
      "And why should we not believe in Allah and what has come to us of the truth? And we aspire that our Lord will admit us [to Paradise] with the righteous people",
    normalizedText:
      "وما لنا لا نامن بالله وما جاءنا من الحق ونطمع ان يدخلنا ربنا مع القوم الصلحين",
  },
  {
    verseId: 84,
    name: "المائدة",
    surahId: 5,
    text: "فَأَثَٰبَهُمُ ٱللَّهُ بِمَا قَالُواْ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ وَذَٰلِكَ جَزَآءُ ٱلۡمُحۡسِنِينَ",
    translation:
      "So Allah rewarded them for what they said with gardens [in Paradise] beneath which rivers flow, wherein they abide eternally. And that is the reward of doers of good",
    normalizedText:
      "فاثبهم الله بما قالوا جنت تجري من تحتها الانهر خلدين فيها وذلك جزاء المحسنين",
  },
  {
    verseId: 85,
    name: "المائدة",
    surahId: 5,
    text: "وَٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِـَٔايَٰتِنَآ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَحِيمِ",
    translation:
      "But those who disbelieved and denied Our signs - they are the companions of Hellfire",
    normalizedText: "والذين كفروا وكذبوا بايتنا اولاك اصحب الجحيم",
  },
  {
    verseId: 86,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تُحَرِّمُواْ طَيِّبَٰتِ مَآ أَحَلَّ ٱللَّهُ لَكُمۡ وَلَا تَعۡتَدُوٓاْۚ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلۡمُعۡتَدِينَ",
    translation:
      "O you who have believed, do not prohibit the good things which Allah has made lawful to you and do not transgress. Indeed, Allah does not like transgressors",
    normalizedText:
      "يايها الذين ءامنوا لا تحرموا طيبت ما احل الله لكم ولا تعتدوا ان الله لا يحب المعتدين",
  },
  {
    verseId: 87,
    name: "المائدة",
    surahId: 5,
    text: "وَكُلُواْ مِمَّا رَزَقَكُمُ ٱللَّهُ حَلَٰلٗا طَيِّبٗاۚ وَٱتَّقُواْ ٱللَّهَ ٱلَّذِيٓ أَنتُم بِهِۦ مُؤۡمِنُونَ",
    translation:
      "And eat of what Allah has provided for you [which is] lawful and good. And fear Allah, in whom you are believers",
    normalizedText:
      "وكلوا مما رزقكم الله حللا طيبا واتقوا الله الذي انتم به مامنون",
  },
  {
    verseId: 88,
    name: "المائدة",
    surahId: 5,
    text: "لَا يُؤَاخِذُكُمُ ٱللَّهُ بِٱللَّغۡوِ فِيٓ أَيۡمَٰنِكُمۡ وَلَٰكِن يُؤَاخِذُكُم بِمَا عَقَّدتُّمُ ٱلۡأَيۡمَٰنَۖ فَكَفَّـٰرَتُهُۥٓ إِطۡعَامُ عَشَرَةِ مَسَٰكِينَ مِنۡ أَوۡسَطِ مَا تُطۡعِمُونَ أَهۡلِيكُمۡ أَوۡ كِسۡوَتُهُمۡ أَوۡ تَحۡرِيرُ رَقَبَةٖۖ فَمَن لَّمۡ يَجِدۡ فَصِيَامُ ثَلَٰثَةِ أَيَّامٖۚ ذَٰلِكَ كَفَّـٰرَةُ أَيۡمَٰنِكُمۡ إِذَا حَلَفۡتُمۡۚ وَٱحۡفَظُوٓاْ أَيۡمَٰنَكُمۡۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمۡ ءَايَٰتِهِۦ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "Allah will not impose blame upon you for what is meaningless in your oaths, but He will impose blame upon you for [breaking] what you intended of oaths. So its expiation is the feeding of ten needy people from the average of that which you feed your [own] families or clothing them or the freeing of a slave. But whoever cannot find [or afford it] - then a fast of three days [is required]. That is the expiation for oaths when you have sworn. But guard your oaths. Thus does Allah make clear to you His verses that you may be grateful",
    normalizedText:
      "لا يااخذكم الله باللغو في ايمنكم ولكن يااخذكم بما عقدتم الايمن فكفرته اطعام عشرة مسكين من اوسط ما تطعمون اهليكم او كسوتهم او تحرير رقبة فمن لم يجد فصيام ثلثة ايام ذلك كفرة ايمنكم اذا حلفتم واحفظوا ايمنكم كذلك يبين الله لكم ءايته لعلكم تشكرون",
  },
  {
    verseId: 89,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِنَّمَا ٱلۡخَمۡرُ وَٱلۡمَيۡسِرُ وَٱلۡأَنصَابُ وَٱلۡأَزۡلَٰمُ رِجۡسٞ مِّنۡ عَمَلِ ٱلشَّيۡطَٰنِ فَٱجۡتَنِبُوهُ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "O you who have believed, indeed, intoxicants, gambling, [sacrificing on] stone alters [to other than Allah], and divining arrows are but defilement from the work of Satan, so avoid it that you may be successful",
    normalizedText:
      "يايها الذين ءامنوا انما الخمر والميسر والانصاب والازلم رجس من عمل الشيطن فاجتنبوه لعلكم تفلحون",
  },
  {
    verseId: 90,
    name: "المائدة",
    surahId: 5,
    text: "إِنَّمَا يُرِيدُ ٱلشَّيۡطَٰنُ أَن يُوقِعَ بَيۡنَكُمُ ٱلۡعَدَٰوَةَ وَٱلۡبَغۡضَآءَ فِي ٱلۡخَمۡرِ وَٱلۡمَيۡسِرِ وَيَصُدَّكُمۡ عَن ذِكۡرِ ٱللَّهِ وَعَنِ ٱلصَّلَوٰةِۖ فَهَلۡ أَنتُم مُّنتَهُونَ",
    translation:
      "Satan only wants to cause between you animosity and hatred through intoxicants and gambling and to avert you from the remembrance of Allah and from prayer. So will you not desist",
    normalizedText:
      "انما يريد الشيطن ان يوقع بينكم العدوة والبغضاء في الخمر والميسر ويصدكم عن ذكر الله وعن الصلوة فهل انتم منتهون",
  },
  {
    verseId: 91,
    name: "المائدة",
    surahId: 5,
    text: "وَأَطِيعُواْ ٱللَّهَ وَأَطِيعُواْ ٱلرَّسُولَ وَٱحۡذَرُواْۚ فَإِن تَوَلَّيۡتُمۡ فَٱعۡلَمُوٓاْ أَنَّمَا عَلَىٰ رَسُولِنَا ٱلۡبَلَٰغُ ٱلۡمُبِينُ",
    translation:
      "And obey Allah and obey the Messenger and beware. And if you turn away - then know that upon Our Messenger is only [the responsibility for] clear notification",
    normalizedText:
      "واطيعوا الله واطيعوا الرسول واحذروا فان توليتم فاعلموا انما على رسولنا البلغ المبين",
  },
  {
    verseId: 92,
    name: "المائدة",
    surahId: 5,
    text: "لَيۡسَ عَلَى ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ جُنَاحٞ فِيمَا طَعِمُوٓاْ إِذَا مَا ٱتَّقَواْ وَّءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ ثُمَّ ٱتَّقَواْ وَّءَامَنُواْ ثُمَّ ٱتَّقَواْ وَّأَحۡسَنُواْۚ وَٱللَّهُ يُحِبُّ ٱلۡمُحۡسِنِينَ",
    translation:
      "There is not upon those who believe and do righteousness [any] blame concerning what they have eaten [in the past] if they [now] fear Allah and believe and do righteous deeds, and then fear Allah and believe, and then fear Allah and do good; and Allah loves the doers of good",
    normalizedText:
      "ليس على الذين ءامنوا وعملوا الصلحت جناح فيما طعموا اذا ما اتقوا وءامنوا وعملوا الصلحت ثم اتقوا وءامنوا ثم اتقوا واحسنوا والله يحب المحسنين",
  },
  {
    verseId: 93,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَيَبۡلُوَنَّكُمُ ٱللَّهُ بِشَيۡءٖ مِّنَ ٱلصَّيۡدِ تَنَالُهُۥٓ أَيۡدِيكُمۡ وَرِمَاحُكُمۡ لِيَعۡلَمَ ٱللَّهُ مَن يَخَافُهُۥ بِٱلۡغَيۡبِۚ فَمَنِ ٱعۡتَدَىٰ بَعۡدَ ذَٰلِكَ فَلَهُۥ عَذَابٌ أَلِيمٞ",
    translation:
      "O you who have believed, Allah will surely test you through something of the game that your hands and spears [can] reach, that Allah may make evident those who fear Him unseen. And whoever transgresses after that - for him is a painful punishment",
    normalizedText:
      "يايها الذين ءامنوا ليبلونكم الله بشيء من الصيد تناله ايديكم ورماحكم ليعلم الله من يخافه بالغيب فمن اعتدى بعد ذلك فله عذاب اليم",
  },
  {
    verseId: 94,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَقۡتُلُواْ ٱلصَّيۡدَ وَأَنتُمۡ حُرُمٞۚ وَمَن قَتَلَهُۥ مِنكُم مُّتَعَمِّدٗا فَجَزَآءٞ مِّثۡلُ مَا قَتَلَ مِنَ ٱلنَّعَمِ يَحۡكُمُ بِهِۦ ذَوَا عَدۡلٖ مِّنكُمۡ هَدۡيَۢا بَٰلِغَ ٱلۡكَعۡبَةِ أَوۡ كَفَّـٰرَةٞ طَعَامُ مَسَٰكِينَ أَوۡ عَدۡلُ ذَٰلِكَ صِيَامٗا لِّيَذُوقَ وَبَالَ أَمۡرِهِۦۗ عَفَا ٱللَّهُ عَمَّا سَلَفَۚ وَمَنۡ عَادَ فَيَنتَقِمُ ٱللَّهُ مِنۡهُۚ وَٱللَّهُ عَزِيزٞ ذُو ٱنتِقَامٍ",
    translation:
      "O you who have believed, do not kill game while you are in the state of ihram. And whoever of you kills it intentionally - the penalty is an equivalent from sacrificial animals to what he killed, as judged by two just men among you as an offering [to Allah] delivered to the Ka'bah, or an expiation: the feeding of needy people or the equivalent of that in fasting, that he may taste the consequence of his deed. Allah has pardoned what is past; but whoever returns [to violation], then Allah will take retribution from him. And Allah is Exalted in Might and Owner of Retribution",
    normalizedText:
      "يايها الذين ءامنوا لا تقتلوا الصيد وانتم حرم ومن قتله منكم متعمدا فجزاء مثل ما قتل من النعم يحكم به ذوا عدل منكم هديا بلغ الكعبة او كفرة طعام مسكين او عدل ذلك صياما ليذوق وبال امره عفا الله عما سلف ومن عاد فينتقم الله منه والله عزيز ذو انتقام",
  },
  {
    verseId: 95,
    name: "المائدة",
    surahId: 5,
    text: "أُحِلَّ لَكُمۡ صَيۡدُ ٱلۡبَحۡرِ وَطَعَامُهُۥ مَتَٰعٗا لَّكُمۡ وَلِلسَّيَّارَةِۖ وَحُرِّمَ عَلَيۡكُمۡ صَيۡدُ ٱلۡبَرِّ مَا دُمۡتُمۡ حُرُمٗاۗ وَٱتَّقُواْ ٱللَّهَ ٱلَّذِيٓ إِلَيۡهِ تُحۡشَرُونَ",
    translation:
      "Lawful to you is game from the sea and its food as provision for you and the travelers, but forbidden to you is game from the land as long as you are in the state of ihram. And fear Allah to whom you will be gathered",
    normalizedText:
      "احل لكم صيد البحر وطعامه متعا لكم وللسيارة وحرم عليكم صيد البر ما دمتم حرما واتقوا الله الذي اليه تحشرون",
  },
  {
    verseId: 96,
    name: "المائدة",
    surahId: 5,
    text: "۞جَعَلَ ٱللَّهُ ٱلۡكَعۡبَةَ ٱلۡبَيۡتَ ٱلۡحَرَامَ قِيَٰمٗا لِّلنَّاسِ وَٱلشَّهۡرَ ٱلۡحَرَامَ وَٱلۡهَدۡيَ وَٱلۡقَلَـٰٓئِدَۚ ذَٰلِكَ لِتَعۡلَمُوٓاْ أَنَّ ٱللَّهَ يَعۡلَمُ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ وَأَنَّ ٱللَّهَ بِكُلِّ شَيۡءٍ عَلِيمٌ",
    translation:
      "Allah has made the Ka'bah, the Sacred House, standing for the people and [has sanctified] the sacred months and the sacrificial animals and the garlands [by which they are identified]. That is so you may know that Allah knows what is in the heavens and what is in the earth and that Allah is Knowing of all things",
    normalizedText:
      "۞جعل الله الكعبة البيت الحرام قيما للناس والشهر الحرام والهدي والقلاد ذلك لتعلموا ان الله يعلم ما في السموت وما في الارض وان الله بكل شيء عليم",
  },
  {
    verseId: 97,
    name: "المائدة",
    surahId: 5,
    text: "ٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ وَأَنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "Know that Allah is severe in penalty and that Allah is Forgiving and Merciful",
    normalizedText: "اعلموا ان الله شديد العقاب وان الله غفور رحيم",
  },
  {
    verseId: 98,
    name: "المائدة",
    surahId: 5,
    text: "مَّا عَلَى ٱلرَّسُولِ إِلَّا ٱلۡبَلَٰغُۗ وَٱللَّهُ يَعۡلَمُ مَا تُبۡدُونَ وَمَا تَكۡتُمُونَ",
    translation:
      "Not upon the Messenger is [responsibility] except [for] notification. And Allah knows whatever you reveal and whatever you conceal",
    normalizedText: "ما على الرسول الا البلغ والله يعلم ما تبدون وما تكتمون",
  },
  {
    verseId: 99,
    name: "المائدة",
    surahId: 5,
    text: "قُل لَّا يَسۡتَوِي ٱلۡخَبِيثُ وَٱلطَّيِّبُ وَلَوۡ أَعۡجَبَكَ كَثۡرَةُ ٱلۡخَبِيثِۚ فَٱتَّقُواْ ٱللَّهَ يَـٰٓأُوْلِي ٱلۡأَلۡبَٰبِ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      'Say, "Not equal are the evil and the good, although the abundance of evil might impress you." So fear Allah, O you of understanding, that you may be successful',
    normalizedText:
      "قل لا يستوي الخبيث والطيب ولو اعجبك كثرة الخبيث فاتقوا الله ياولي الالبب لعلكم تفلحون",
  },
  {
    verseId: 100,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَسۡـَٔلُواْ عَنۡ أَشۡيَآءَ إِن تُبۡدَ لَكُمۡ تَسُؤۡكُمۡ وَإِن تَسۡـَٔلُواْ عَنۡهَا حِينَ يُنَزَّلُ ٱلۡقُرۡءَانُ تُبۡدَ لَكُمۡ عَفَا ٱللَّهُ عَنۡهَاۗ وَٱللَّهُ غَفُورٌ حَلِيمٞ",
    translation:
      "O you who have believed, do not ask about things which, if they are shown to you, will distress you. But if you ask about them while the Qur'an is being revealed, they will be shown to you. Allah has pardoned that which is past; and Allah is Forgiving and Forbearing",
    normalizedText:
      "يايها الذين ءامنوا لا تسلوا عن اشياء ان تبد لكم تساكم وان تسلوا عنها حين ينزل القرءان تبد لكم عفا الله عنها والله غفور حليم",
  },
  {
    verseId: 101,
    name: "المائدة",
    surahId: 5,
    text: "قَدۡ سَأَلَهَا قَوۡمٞ مِّن قَبۡلِكُمۡ ثُمَّ أَصۡبَحُواْ بِهَا كَٰفِرِينَ",
    translation:
      "A people asked such [questions] before you; then they became thereby disbelievers",
    normalizedText: "قد سالها قوم من قبلكم ثم اصبحوا بها كفرين",
  },
  {
    verseId: 102,
    name: "المائدة",
    surahId: 5,
    text: "مَا جَعَلَ ٱللَّهُ مِنۢ بَحِيرَةٖ وَلَا سَآئِبَةٖ وَلَا وَصِيلَةٖ وَلَا حَامٖ وَلَٰكِنَّ ٱلَّذِينَ كَفَرُواْ يَفۡتَرُونَ عَلَى ٱللَّهِ ٱلۡكَذِبَۖ وَأَكۡثَرُهُمۡ لَا يَعۡقِلُونَ",
    translation:
      "Allah has not appointed [such innovations as] bahirah or sa'ibah or wasilah or ham. But those who disbelieve invent falsehood about Allah, and most of them do not reason",
    normalizedText:
      "ما جعل الله من بحيرة ولا ساابة ولا وصيلة ولا حام ولكن الذين كفروا يفترون على الله الكذب واكثرهم لا يعقلون",
  },
  {
    verseId: 103,
    name: "المائدة",
    surahId: 5,
    text: "وَإِذَا قِيلَ لَهُمۡ تَعَالَوۡاْ إِلَىٰ مَآ أَنزَلَ ٱللَّهُ وَإِلَى ٱلرَّسُولِ قَالُواْ حَسۡبُنَا مَا وَجَدۡنَا عَلَيۡهِ ءَابَآءَنَآۚ أَوَلَوۡ كَانَ ءَابَآؤُهُمۡ لَا يَعۡلَمُونَ شَيۡـٔٗا وَلَا يَهۡتَدُونَ",
    translation:
      'And when it is said to them, "Come to what Allah has revealed and to the Messenger," they say, "Sufficient for us is that upon which we found our fathers." Even though their fathers knew nothing, nor were they guided',
    normalizedText:
      "واذا قيل لهم تعالوا الى ما انزل الله والى الرسول قالوا حسبنا ما وجدنا عليه ءاباءنا اولو كان ءابااهم لا يعلمون شيا ولا يهتدون",
  },
  {
    verseId: 104,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ عَلَيۡكُمۡ أَنفُسَكُمۡۖ لَا يَضُرُّكُم مَّن ضَلَّ إِذَا ٱهۡتَدَيۡتُمۡۚ إِلَى ٱللَّهِ مَرۡجِعُكُمۡ جَمِيعٗا فَيُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "O you who have believed, upon you is [responsibility for] yourselves. Those who have gone astray will not harm you when you have been guided. To Allah is you return all together; then He will inform you of what you used to do",
    normalizedText:
      "يايها الذين ءامنوا عليكم انفسكم لا يضركم من ضل اذا اهتديتم الى الله مرجعكم جميعا فينباكم بما كنتم تعملون",
  },
  {
    verseId: 105,
    name: "المائدة",
    surahId: 5,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ شَهَٰدَةُ بَيۡنِكُمۡ إِذَا حَضَرَ أَحَدَكُمُ ٱلۡمَوۡتُ حِينَ ٱلۡوَصِيَّةِ ٱثۡنَانِ ذَوَا عَدۡلٖ مِّنكُمۡ أَوۡ ءَاخَرَانِ مِنۡ غَيۡرِكُمۡ إِنۡ أَنتُمۡ ضَرَبۡتُمۡ فِي ٱلۡأَرۡضِ فَأَصَٰبَتۡكُم مُّصِيبَةُ ٱلۡمَوۡتِۚ تَحۡبِسُونَهُمَا مِنۢ بَعۡدِ ٱلصَّلَوٰةِ فَيُقۡسِمَانِ بِٱللَّهِ إِنِ ٱرۡتَبۡتُمۡ لَا نَشۡتَرِي بِهِۦ ثَمَنٗا وَلَوۡ كَانَ ذَا قُرۡبَىٰ وَلَا نَكۡتُمُ شَهَٰدَةَ ٱللَّهِ إِنَّآ إِذٗا لَّمِنَ ٱلۡأٓثِمِينَ",
    translation:
      'O you who have believed, testimony [should be taken] among you when death approaches one of you at the time of bequest - [that of] two just men from among you or two others from outside if you are traveling through the land and the disaster of death should strike you. Detain them after the prayer and let them both swear by Allah if you doubt [their testimony, saying], "We will not exchange our oath for a price, even if he should be a near relative, and we will not withhold the testimony of Allah. Indeed, we would then be of the sinful',
    normalizedText:
      "يايها الذين ءامنوا شهدة بينكم اذا حضر احدكم الموت حين الوصية اثنان ذوا عدل منكم او ءاخران من غيركم ان انتم ضربتم في الارض فاصبتكم مصيبة الموت تحبسونهما من بعد الصلوة فيقسمان بالله ان ارتبتم لا نشتري به ثمنا ولو كان ذا قربى ولا نكتم شهدة الله انا اذا لمن الاثمين",
  },
  {
    verseId: 106,
    name: "المائدة",
    surahId: 5,
    text: "فَإِنۡ عُثِرَ عَلَىٰٓ أَنَّهُمَا ٱسۡتَحَقَّآ إِثۡمٗا فَـَٔاخَرَانِ يَقُومَانِ مَقَامَهُمَا مِنَ ٱلَّذِينَ ٱسۡتَحَقَّ عَلَيۡهِمُ ٱلۡأَوۡلَيَٰنِ فَيُقۡسِمَانِ بِٱللَّهِ لَشَهَٰدَتُنَآ أَحَقُّ مِن شَهَٰدَتِهِمَا وَمَا ٱعۡتَدَيۡنَآ إِنَّآ إِذٗا لَّمِنَ ٱلظَّـٰلِمِينَ",
    translation:
      'But if it is found that those two were guilty of perjury, let two others stand in their place [who are] foremost [in claim] from those who have a lawful right. And let them swear by Allah, "Our testimony is truer than their testimony, and we have not transgressed. Indeed, we would then be of the wrongdoers',
    normalizedText:
      "فان عثر على انهما استحقا اثما فاخران يقومان مقامهما من الذين استحق عليهم الاولين فيقسمان بالله لشهدتنا احق من شهدتهما وما اعتدينا انا اذا لمن الظلمين",
  },
  {
    verseId: 107,
    name: "المائدة",
    surahId: 5,
    text: "ذَٰلِكَ أَدۡنَىٰٓ أَن يَأۡتُواْ بِٱلشَّهَٰدَةِ عَلَىٰ وَجۡهِهَآ أَوۡ يَخَافُوٓاْ أَن تُرَدَّ أَيۡمَٰنُۢ بَعۡدَ أَيۡمَٰنِهِمۡۗ وَٱتَّقُواْ ٱللَّهَ وَٱسۡمَعُواْۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡفَٰسِقِينَ",
    translation:
      "That is more likely that they will give testimony according to its [true] objective, or [at least] they would fear that [other] oaths might be taken after their oaths. And fear Allah and listen; and Allah does not guide the defiantly disobedient people",
    normalizedText:
      "ذلك ادنى ان ياتوا بالشهدة على وجهها او يخافوا ان ترد ايمن بعد ايمنهم واتقوا الله واسمعوا والله لا يهدي القوم الفسقين",
  },
  {
    verseId: 108,
    name: "المائدة",
    surahId: 5,
    text: "۞يَوۡمَ يَجۡمَعُ ٱللَّهُ ٱلرُّسُلَ فَيَقُولُ مَاذَآ أُجِبۡتُمۡۖ قَالُواْ لَا عِلۡمَ لَنَآۖ إِنَّكَ أَنتَ عَلَّـٰمُ ٱلۡغُيُوبِ",
    translation:
      '[Be warned of] the Day when Allah will assemble the messengers and say, "What was the response you received?" They will say, "We have no knowledge. Indeed, it is You who is Knower of the unseen',
    normalizedText:
      "۞يوم يجمع الله الرسل فيقول ماذا اجبتم قالوا لا علم لنا انك انت علم الغيوب",
  },
  {
    verseId: 109,
    name: "المائدة",
    surahId: 5,
    text: "إِذۡ قَالَ ٱللَّهُ يَٰعِيسَى ٱبۡنَ مَرۡيَمَ ٱذۡكُرۡ نِعۡمَتِي عَلَيۡكَ وَعَلَىٰ وَٰلِدَتِكَ إِذۡ أَيَّدتُّكَ بِرُوحِ ٱلۡقُدُسِ تُكَلِّمُ ٱلنَّاسَ فِي ٱلۡمَهۡدِ وَكَهۡلٗاۖ وَإِذۡ عَلَّمۡتُكَ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَٱلتَّوۡرَىٰةَ وَٱلۡإِنجِيلَۖ وَإِذۡ تَخۡلُقُ مِنَ ٱلطِّينِ كَهَيۡـَٔةِ ٱلطَّيۡرِ بِإِذۡنِي فَتَنفُخُ فِيهَا فَتَكُونُ طَيۡرَۢا بِإِذۡنِيۖ وَتُبۡرِئُ ٱلۡأَكۡمَهَ وَٱلۡأَبۡرَصَ بِإِذۡنِيۖ وَإِذۡ تُخۡرِجُ ٱلۡمَوۡتَىٰ بِإِذۡنِيۖ وَإِذۡ كَفَفۡتُ بَنِيٓ إِسۡرَـٰٓءِيلَ عَنكَ إِذۡ جِئۡتَهُم بِٱلۡبَيِّنَٰتِ فَقَالَ ٱلَّذِينَ كَفَرُواْ مِنۡهُمۡ إِنۡ هَٰذَآ إِلَّا سِحۡرٞ مُّبِينٞ",
    translation:
      '[The Day] when Allah will say, "O Jesus, Son of Mary, remember My favor upon you and upon your mother when I supported you with the Pure Spirit and you spoke to the people in the cradle and in maturity; and [remember] when I taught you writing and wisdom and the Torah and the Gospel; and when you designed from clay [what was] like the form of a bird with My permission, then you breathed into it, and it became a bird with My permission; and you healed the blind and the leper with My permission; and when you brought forth the dead with My permission; and when I restrained the Children of Israel from [killing] you when you came to them with clear proofs and those who disbelieved among them said, "This is not but obvious magic',
    normalizedText:
      "اذ قال الله يعيسى ابن مريم اذكر نعمتي عليك وعلى ولدتك اذ ايدتك بروح القدس تكلم الناس في المهد وكهلا واذ علمتك الكتب والحكمة والتورىة والانجيل واذ تخلق من الطين كهية الطير باذني فتنفخ فيها فتكون طيرا باذني وتبرا الاكمه والابرص باذني واذ تخرج الموتى باذني واذ كففت بني اسرءيل عنك اذ جاتهم بالبينت فقال الذين كفروا منهم ان هذا الا سحر مبين",
  },
  {
    verseId: 110,
    name: "المائدة",
    surahId: 5,
    text: "وَإِذۡ أَوۡحَيۡتُ إِلَى ٱلۡحَوَارِيِّـۧنَ أَنۡ ءَامِنُواْ بِي وَبِرَسُولِي قَالُوٓاْ ءَامَنَّا وَٱشۡهَدۡ بِأَنَّنَا مُسۡلِمُونَ",
    translation:
      'And [remember] when I inspired to the disciples, "Believe in Me and in My messenger Jesus." They said, "We have believed, so bear witness that indeed we are Muslims [in submission to Allah]',
    normalizedText:
      "واذ اوحيت الى الحوارين ان ءامنوا بي وبرسولي قالوا ءامنا واشهد باننا مسلمون",
  },
  {
    verseId: 111,
    name: "المائدة",
    surahId: 5,
    text: "إِذۡ قَالَ ٱلۡحَوَارِيُّونَ يَٰعِيسَى ٱبۡنَ مَرۡيَمَ هَلۡ يَسۡتَطِيعُ رَبُّكَ أَن يُنَزِّلَ عَلَيۡنَا مَآئِدَةٗ مِّنَ ٱلسَّمَآءِۖ قَالَ ٱتَّقُواْ ٱللَّهَ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      '[And remember] when the disciples said, "O Jesus, Son of Mary, can your Lord send down to us a table [spread with food] from the heaven? [Jesus] said," Fear Allah, if you should be believers',
    normalizedText:
      "اذ قال الحواريون يعيسى ابن مريم هل يستطيع ربك ان ينزل علينا ماادة من السماء قال اتقوا الله ان كنتم مامنين",
  },
  {
    verseId: 112,
    name: "المائدة",
    surahId: 5,
    text: "قَالُواْ نُرِيدُ أَن نَّأۡكُلَ مِنۡهَا وَتَطۡمَئِنَّ قُلُوبُنَا وَنَعۡلَمَ أَن قَدۡ صَدَقۡتَنَا وَنَكُونَ عَلَيۡهَا مِنَ ٱلشَّـٰهِدِينَ",
    translation:
      'They said, "We wish to eat from it and let our hearts be reassured and know that you have been truthful to us and be among its witnesses',
    normalizedText:
      "قالوا نريد ان ناكل منها وتطمان قلوبنا ونعلم ان قد صدقتنا ونكون عليها من الشهدين",
  },
  {
    verseId: 113,
    name: "المائدة",
    surahId: 5,
    text: "قَالَ عِيسَى ٱبۡنُ مَرۡيَمَ ٱللَّهُمَّ رَبَّنَآ أَنزِلۡ عَلَيۡنَا مَآئِدَةٗ مِّنَ ٱلسَّمَآءِ تَكُونُ لَنَا عِيدٗا لِّأَوَّلِنَا وَءَاخِرِنَا وَءَايَةٗ مِّنكَۖ وَٱرۡزُقۡنَا وَأَنتَ خَيۡرُ ٱلرَّـٰزِقِينَ",
    translation:
      'Said Jesus, the son of Mary, "O Allah, our Lord, send down to us a table [spread with food] from the heaven to be for us a festival for the first of us and the last of us and a sign from You. And provide for us, and You are the best of providers',
    normalizedText:
      "قال عيسى ابن مريم اللهم ربنا انزل علينا ماادة من السماء تكون لنا عيدا لاولنا وءاخرنا وءاية منك وارزقنا وانت خير الرزقين",
  },
  {
    verseId: 114,
    name: "المائدة",
    surahId: 5,
    text: "قَالَ ٱللَّهُ إِنِّي مُنَزِّلُهَا عَلَيۡكُمۡۖ فَمَن يَكۡفُرۡ بَعۡدُ مِنكُمۡ فَإِنِّيٓ أُعَذِّبُهُۥ عَذَابٗا لَّآ أُعَذِّبُهُۥٓ أَحَدٗا مِّنَ ٱلۡعَٰلَمِينَ",
    translation:
      'Allah said, "Indeed, I will sent it down to you, but whoever disbelieves afterwards from among you - then indeed will I punish him with a punishment by which I have not punished anyone among the worlds',
    normalizedText:
      "قال الله اني منزلها عليكم فمن يكفر بعد منكم فاني اعذبه عذابا لا اعذبه احدا من العلمين",
  },
  {
    verseId: 115,
    name: "المائدة",
    surahId: 5,
    text: "وَإِذۡ قَالَ ٱللَّهُ يَٰعِيسَى ٱبۡنَ مَرۡيَمَ ءَأَنتَ قُلۡتَ لِلنَّاسِ ٱتَّخِذُونِي وَأُمِّيَ إِلَٰهَيۡنِ مِن دُونِ ٱللَّهِۖ قَالَ سُبۡحَٰنَكَ مَا يَكُونُ لِيٓ أَنۡ أَقُولَ مَا لَيۡسَ لِي بِحَقٍّۚ إِن كُنتُ قُلۡتُهُۥ فَقَدۡ عَلِمۡتَهُۥۚ تَعۡلَمُ مَا فِي نَفۡسِي وَلَآ أَعۡلَمُ مَا فِي نَفۡسِكَۚ إِنَّكَ أَنتَ عَلَّـٰمُ ٱلۡغُيُوبِ",
    translation: `And [beware the Day] when Allah will say, "O Jesus, Son of Mary, did you say to the people, 'Take me and my mother as deities besides Allah?'" He will say, "Exalted are You! It was not for me to say that to which I have no right. If I had said it, You would have known it. You know what is within myself, and I do not know what is within Yourself. Indeed, it is You who is Knower of the unseen`,
    normalizedText:
      "واذ قال الله يعيسى ابن مريم ءانت قلت للناس اتخذوني وامي الهين من دون الله قال سبحنك ما يكون لي ان اقول ما ليس لي بحق ان كنت قلته فقد علمته تعلم ما في نفسي ولا اعلم ما في نفسك انك انت علم الغيوب",
  },
  {
    verseId: 116,
    name: "المائدة",
    surahId: 5,
    text: "مَا قُلۡتُ لَهُمۡ إِلَّا مَآ أَمَرۡتَنِي بِهِۦٓ أَنِ ٱعۡبُدُواْ ٱللَّهَ رَبِّي وَرَبَّكُمۡۚ وَكُنتُ عَلَيۡهِمۡ شَهِيدٗا مَّا دُمۡتُ فِيهِمۡۖ فَلَمَّا تَوَفَّيۡتَنِي كُنتَ أَنتَ ٱلرَّقِيبَ عَلَيۡهِمۡۚ وَأَنتَ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدٌ",
    translation:
      "I said not to them except what You commanded me - to worship Allah, my Lord and your Lord. And I was a witness over them as long as I was among them; but when You took me up, You were the Observer over them, and You are, over all things, Witness",
    normalizedText:
      "ما قلت لهم الا ما امرتني به ان اعبدوا الله ربي وربكم وكنت عليهم شهيدا ما دمت فيهم فلما توفيتني كنت انت الرقيب عليهم وانت على كل شيء شهيد",
  },
  {
    verseId: 117,
    name: "المائدة",
    surahId: 5,
    text: "إِن تُعَذِّبۡهُمۡ فَإِنَّهُمۡ عِبَادُكَۖ وَإِن تَغۡفِرۡ لَهُمۡ فَإِنَّكَ أَنتَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "If You should punish them - indeed they are Your servants; but if You forgive them - indeed it is You who is the Exalted in Might, the Wise",
    normalizedText: "ان تعذبهم فانهم عبادك وان تغفر لهم فانك انت العزيز الحكيم",
  },
  {
    verseId: 118,
    name: "المائدة",
    surahId: 5,
    text: "قَالَ ٱللَّهُ هَٰذَا يَوۡمُ يَنفَعُ ٱلصَّـٰدِقِينَ صِدۡقُهُمۡۚ لَهُمۡ جَنَّـٰتٞ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدٗاۖ رَّضِيَ ٱللَّهُ عَنۡهُمۡ وَرَضُواْ عَنۡهُۚ ذَٰلِكَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      'Allah will say, "This is the Day when the truthful will benefit from their truthfulness." For them are gardens [in Paradise] beneath which rivers flow, wherein they will abide forever, Allah being pleased with them, and they with Him. That is the great attainment',
    normalizedText:
      "قال الله هذا يوم ينفع الصدقين صدقهم لهم جنت تجري من تحتها الانهر خلدين فيها ابدا رضي الله عنهم ورضوا عنه ذلك الفوز العظيم",
  },
  {
    verseId: 119,
    name: "المائدة",
    surahId: 5,
    text: "لِلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا فِيهِنَّۚ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرُۢ",
    translation:
      "To Allah belongs the dominion of the heavens and the earth and whatever is within them. And He is over all things competent",
    normalizedText: "لله ملك السموت والارض وما فيهن وهو على كل شيء قدير",
  },
  {
    verseId: 0,
    name: "الأنعام",
    surahId: 6,
    text: "ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَجَعَلَ ٱلظُّلُمَٰتِ وَٱلنُّورَۖ ثُمَّ ٱلَّذِينَ كَفَرُواْ بِرَبِّهِمۡ يَعۡدِلُونَ",
    translation:
      "[All] praise is [due] to Allah, who created the heavens and the earth and made the darkness and the light. Then those who disbelieve equate [others] with their Lord",
    normalizedText:
      "الحمد لله الذي خلق السموت والارض وجعل الظلمت والنور ثم الذين كفروا بربهم يعدلون",
  },
  {
    verseId: 1,
    name: "الأنعام",
    surahId: 6,
    text: "هُوَ ٱلَّذِي خَلَقَكُم مِّن طِينٖ ثُمَّ قَضَىٰٓ أَجَلٗاۖ وَأَجَلٞ مُّسَمًّى عِندَهُۥۖ ثُمَّ أَنتُمۡ تَمۡتَرُونَ",
    translation:
      "It is He who created you from clay and then decreed a term and a specified time [known] to Him; then [still] you are in dispute",
    normalizedText:
      "هو الذي خلقكم من طين ثم قضى اجلا واجل مسمى عنده ثم انتم تمترون",
  },
  {
    verseId: 2,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱللَّهُ فِي ٱلسَّمَٰوَٰتِ وَفِي ٱلۡأَرۡضِ يَعۡلَمُ سِرَّكُمۡ وَجَهۡرَكُمۡ وَيَعۡلَمُ مَا تَكۡسِبُونَ",
    translation:
      "And He is Allah, [the only deity] in the heavens and the earth. He knows your secret and what you make public, and He knows that which you earn",
    normalizedText:
      "وهو الله في السموت وفي الارض يعلم سركم وجهركم ويعلم ما تكسبون",
  },
  {
    verseId: 3,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَا تَأۡتِيهِم مِّنۡ ءَايَةٖ مِّنۡ ءَايَٰتِ رَبِّهِمۡ إِلَّا كَانُواْ عَنۡهَا مُعۡرِضِينَ",
    translation:
      "And no sign comes to them from the signs of their Lord except that they turn away therefrom",
    normalizedText: "وما تاتيهم من ءاية من ءايت ربهم الا كانوا عنها معرضين",
  },
  {
    verseId: 4,
    name: "الأنعام",
    surahId: 6,
    text: "فَقَدۡ كَذَّبُواْ بِٱلۡحَقِّ لَمَّا جَآءَهُمۡ فَسَوۡفَ يَأۡتِيهِمۡ أَنۢبَـٰٓؤُاْ مَا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "For they had denied the truth when it came to them, but there is going to reach them the news of what they used to ridicule",
    normalizedText:
      "فقد كذبوا بالحق لما جاءهم فسوف ياتيهم انباا ما كانوا به يستهزءون",
  },
  {
    verseId: 5,
    name: "الأنعام",
    surahId: 6,
    text: "أَلَمۡ يَرَوۡاْ كَمۡ أَهۡلَكۡنَا مِن قَبۡلِهِم مِّن قَرۡنٖ مَّكَّنَّـٰهُمۡ فِي ٱلۡأَرۡضِ مَا لَمۡ نُمَكِّن لَّكُمۡ وَأَرۡسَلۡنَا ٱلسَّمَآءَ عَلَيۡهِم مِّدۡرَارٗا وَجَعَلۡنَا ٱلۡأَنۡهَٰرَ تَجۡرِي مِن تَحۡتِهِمۡ فَأَهۡلَكۡنَٰهُم بِذُنُوبِهِمۡ وَأَنشَأۡنَا مِنۢ بَعۡدِهِمۡ قَرۡنًا ءَاخَرِينَ",
    translation:
      "Have they not seen how many generations We destroyed before them which We had established upon the earth as We have not established you? And We sent [rain from] the sky upon them in showers and made rivers flow beneath them; then We destroyed them for their sins and brought forth after them a generation of others",
    normalizedText:
      "الم يروا كم اهلكنا من قبلهم من قرن مكنهم في الارض ما لم نمكن لكم وارسلنا السماء عليهم مدرارا وجعلنا الانهر تجري من تحتهم فاهلكنهم بذنوبهم وانشانا من بعدهم قرنا ءاخرين",
  },
  {
    verseId: 6,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَوۡ نَزَّلۡنَا عَلَيۡكَ كِتَٰبٗا فِي قِرۡطَاسٖ فَلَمَسُوهُ بِأَيۡدِيهِمۡ لَقَالَ ٱلَّذِينَ كَفَرُوٓاْ إِنۡ هَٰذَآ إِلَّا سِحۡرٞ مُّبِينٞ",
    translation:
      'And even if We had sent down to you, [O Muhammad], a written scripture on a page and they touched it with their hands, the disbelievers would say, "This is not but obvious magic',
    normalizedText:
      "ولو نزلنا عليك كتبا في قرطاس فلمسوه بايديهم لقال الذين كفروا ان هذا الا سحر مبين",
  },
  {
    verseId: 7,
    name: "الأنعام",
    surahId: 6,
    text: "وَقَالُواْ لَوۡلَآ أُنزِلَ عَلَيۡهِ مَلَكٞۖ وَلَوۡ أَنزَلۡنَا مَلَكٗا لَّقُضِيَ ٱلۡأَمۡرُ ثُمَّ لَا يُنظَرُونَ",
    translation:
      'And they say, "Why was there not sent down to him an angel?" But if We had sent down an angel, the matter would have been decided; then they would not be reprieved',
    normalizedText:
      "وقالوا لولا انزل عليه ملك ولو انزلنا ملكا لقضي الامر ثم لا ينظرون",
  },
  {
    verseId: 8,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَوۡ جَعَلۡنَٰهُ مَلَكٗا لَّجَعَلۡنَٰهُ رَجُلٗا وَلَلَبَسۡنَا عَلَيۡهِم مَّا يَلۡبِسُونَ",
    translation:
      "And if We had made him an angel, We would have made him [appear as] a man, and We would have covered them with that in which they cover themselves",
    normalizedText: "ولو جعلنه ملكا لجعلنه رجلا وللبسنا عليهم ما يلبسون",
  },
  {
    verseId: 9,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَقَدِ ٱسۡتُهۡزِئَ بِرُسُلٖ مِّن قَبۡلِكَ فَحَاقَ بِٱلَّذِينَ سَخِرُواْ مِنۡهُم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "And already were messengers ridiculed before you, but those who mocked them were enveloped by that which they used to ridicule",
    normalizedText:
      "ولقد استهزا برسل من قبلك فحاق بالذين سخروا منهم ما كانوا به يستهزءون",
  },
  {
    verseId: 10,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ سِيرُواْ فِي ٱلۡأَرۡضِ ثُمَّ ٱنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُكَذِّبِينَ",
    translation:
      'Say, "Travel through the land; then observe how was the end of the deniers',
    normalizedText: "قل سيروا في الارض ثم انظروا كيف كان عقبة المكذبين",
  },
  {
    verseId: 11,
    name: "الأنعام",
    surahId: 6,
    text: "قُل لِّمَن مَّا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ قُل لِّلَّهِۚ كَتَبَ عَلَىٰ نَفۡسِهِ ٱلرَّحۡمَةَۚ لَيَجۡمَعَنَّكُمۡ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ لَا رَيۡبَ فِيهِۚ ٱلَّذِينَ خَسِرُوٓاْ أَنفُسَهُمۡ فَهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      'Say, "To whom belongs whatever is in the heavens and earth?" Say, "To Allah." He has decreed upon Himself mercy. He will surely assemble you for the Day of Resurrection, about which there is no doubt. Those who will lose themselves [that Day] do not believe',
    normalizedText:
      "قل لمن ما في السموت والارض قل لله كتب على نفسه الرحمة ليجمعنكم الى يوم القيمة لا ريب فيه الذين خسروا انفسهم فهم لا يامنون",
  },
  {
    verseId: 12,
    name: "الأنعام",
    surahId: 6,
    text: "۞وَلَهُۥ مَا سَكَنَ فِي ٱلَّيۡلِ وَٱلنَّهَارِۚ وَهُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "And to Him belongs that which reposes by night and by day, and He is the Hearing, the Knowing",
    normalizedText: "۞وله ما سكن في اليل والنهار وهو السميع العليم",
  },
  {
    verseId: 13,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ أَغَيۡرَ ٱللَّهِ أَتَّخِذُ وَلِيّٗا فَاطِرِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَهُوَ يُطۡعِمُ وَلَا يُطۡعَمُۗ قُلۡ إِنِّيٓ أُمِرۡتُ أَنۡ أَكُونَ أَوَّلَ مَنۡ أَسۡلَمَۖ وَلَا تَكُونَنَّ مِنَ ٱلۡمُشۡرِكِينَ",
    translation: `Say, "Is it other than Allah I should take as a protector, Creator of the heavens and the earth, while it is He who feeds and is not fed?" Say, [O Muhammad], "Indeed, I have been commanded to be the first [among you] who submit [to Allah] and [was commanded], 'Do not ever be of the polytheists`,
    normalizedText:
      "قل اغير الله اتخذ وليا فاطر السموت والارض وهو يطعم ولا يطعم قل اني امرت ان اكون اول من اسلم ولا تكونن من المشركين",
  },
  {
    verseId: 14,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ إِنِّيٓ أَخَافُ إِنۡ عَصَيۡتُ رَبِّي عَذَابَ يَوۡمٍ عَظِيمٖ",
    translation:
      'Say, "Indeed I fear, if I should disobey my Lord, the punishment of a tremendous Day',
    normalizedText: "قل اني اخاف ان عصيت ربي عذاب يوم عظيم",
  },
  {
    verseId: 15,
    name: "الأنعام",
    surahId: 6,
    text: "مَّن يُصۡرَفۡ عَنۡهُ يَوۡمَئِذٖ فَقَدۡ رَحِمَهُۥۚ وَذَٰلِكَ ٱلۡفَوۡزُ ٱلۡمُبِينُ",
    translation:
      "He from whom it is averted that Day - [Allah] has granted him mercy. And that is the clear attainment",
    normalizedText: "من يصرف عنه يوماذ فقد رحمه وذلك الفوز المبين",
  },
  {
    verseId: 16,
    name: "الأنعام",
    surahId: 6,
    text: "وَإِن يَمۡسَسۡكَ ٱللَّهُ بِضُرّٖ فَلَا كَاشِفَ لَهُۥٓ إِلَّا هُوَۖ وَإِن يَمۡسَسۡكَ بِخَيۡرٖ فَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "And if Allah should touch you with adversity, there is no remover of it except Him. And if He touches you with good - then He is over all things competent",
    normalizedText:
      "وان يمسسك الله بضر فلا كاشف له الا هو وان يمسسك بخير فهو على كل شيء قدير",
  },
  {
    verseId: 17,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلۡقَاهِرُ فَوۡقَ عِبَادِهِۦۚ وَهُوَ ٱلۡحَكِيمُ ٱلۡخَبِيرُ",
    translation:
      "And He is the subjugator over His servants. And He is the Wise, the Acquainted [with all]",
    normalizedText: "وهو القاهر فوق عباده وهو الحكيم الخبير",
  },
  {
    verseId: 18,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ أَيُّ شَيۡءٍ أَكۡبَرُ شَهَٰدَةٗۖ قُلِ ٱللَّهُۖ شَهِيدُۢ بَيۡنِي وَبَيۡنَكُمۡۚ وَأُوحِيَ إِلَيَّ هَٰذَا ٱلۡقُرۡءَانُ لِأُنذِرَكُم بِهِۦ وَمَنۢ بَلَغَۚ أَئِنَّكُمۡ لَتَشۡهَدُونَ أَنَّ مَعَ ٱللَّهِ ءَالِهَةً أُخۡرَىٰۚ قُل لَّآ أَشۡهَدُۚ قُلۡ إِنَّمَا هُوَ إِلَٰهٞ وَٰحِدٞ وَإِنَّنِي بَرِيٓءٞ مِّمَّا تُشۡرِكُونَ",
    translation: `Say, "What thing is greatest in testimony?" Say, "Allah is witness between me and you. And this Qur'an was revealed to me that I may warn you thereby and whomever it reaches. Do you [truly] testify that with Allah there are other deities?" Say, "I will not testify [with you]." Say, "Indeed, He is but one God, and indeed, I am free of what you associate [with Him]`,
    normalizedText:
      "قل اي شيء اكبر شهدة قل الله شهيد بيني وبينكم واوحي الي هذا القرءان لانذركم به ومن بلغ اانكم لتشهدون ان مع الله ءالهة اخرى قل لا اشهد قل انما هو اله وحد وانني بريء مما تشركون",
  },
  {
    verseId: 19,
    name: "الأنعام",
    surahId: 6,
    text: "ٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ يَعۡرِفُونَهُۥ كَمَا يَعۡرِفُونَ أَبۡنَآءَهُمُۘ ٱلَّذِينَ خَسِرُوٓاْ أَنفُسَهُمۡ فَهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "Those to whom We have given the Scripture recognize it as they recognize their [own] sons. Those who will lose themselves [in the Hereafter] do not believe",
    normalizedText:
      "الذين ءاتينهم الكتب يعرفونه كما يعرفون ابناءهم الذين خسروا انفسهم فهم لا يامنون",
  },
  {
    verseId: 20,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوۡ كَذَّبَ بِـَٔايَٰتِهِۦٓۚ إِنَّهُۥ لَا يُفۡلِحُ ٱلظَّـٰلِمُونَ",
    translation:
      "And who is more unjust than one who invents about Allah a lie or denies His verses? Indeed, the wrongdoers will not succeed",
    normalizedText:
      "ومن اظلم ممن افترى على الله كذبا او كذب بايته انه لا يفلح الظلمون",
  },
  {
    verseId: 21,
    name: "الأنعام",
    surahId: 6,
    text: "وَيَوۡمَ نَحۡشُرُهُمۡ جَمِيعٗا ثُمَّ نَقُولُ لِلَّذِينَ أَشۡرَكُوٓاْ أَيۡنَ شُرَكَآؤُكُمُ ٱلَّذِينَ كُنتُمۡ تَزۡعُمُونَ",
    translation: `And [mention, O Muhammad], the Day We will gather them all together; then We will say to those who associated others with Allah, "Where are your 'partners' that you used to claim [with Him]`,
    normalizedText:
      "ويوم نحشرهم جميعا ثم نقول للذين اشركوا اين شركااكم الذين كنتم تزعمون",
  },
  {
    verseId: 22,
    name: "الأنعام",
    surahId: 6,
    text: "ثُمَّ لَمۡ تَكُن فِتۡنَتُهُمۡ إِلَّآ أَن قَالُواْ وَٱللَّهِ رَبِّنَا مَا كُنَّا مُشۡرِكِينَ",
    translation:
      'Then there will be no [excuse upon] examination except they will say, "By Allah, our Lord, we were not those who associated',
    normalizedText: "ثم لم تكن فتنتهم الا ان قالوا والله ربنا ما كنا مشركين",
  },
  {
    verseId: 23,
    name: "الأنعام",
    surahId: 6,
    text: "ٱنظُرۡ كَيۡفَ كَذَبُواْ عَلَىٰٓ أَنفُسِهِمۡۚ وَضَلَّ عَنۡهُم مَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      "See how they will lie about themselves. And lost from them will be what they used to invent",
    normalizedText: "انظر كيف كذبوا على انفسهم وضل عنهم ما كانوا يفترون",
  },
  {
    verseId: 24,
    name: "الأنعام",
    surahId: 6,
    text: "وَمِنۡهُم مَّن يَسۡتَمِعُ إِلَيۡكَۖ وَجَعَلۡنَا عَلَىٰ قُلُوبِهِمۡ أَكِنَّةً أَن يَفۡقَهُوهُ وَفِيٓ ءَاذَانِهِمۡ وَقۡرٗاۚ وَإِن يَرَوۡاْ كُلَّ ءَايَةٖ لَّا يُؤۡمِنُواْ بِهَاۖ حَتَّىٰٓ إِذَا جَآءُوكَ يُجَٰدِلُونَكَ يَقُولُ ٱلَّذِينَ كَفَرُوٓاْ إِنۡ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      'And among them are those who listen to you, but We have placed over their hearts coverings, lest they understand it, and in their ears deafness. And if they should see every sign, they will not believe in it. Even when they come to you arguing with you, those who disbelieve say, "This is not but legends of the former peoples',
    normalizedText:
      "ومنهم من يستمع اليك وجعلنا على قلوبهم اكنة ان يفقهوه وفي ءاذانهم وقرا وان يروا كل ءاية لا يامنوا بها حتى اذا جاءوك يجدلونك يقول الذين كفروا ان هذا الا اسطير الاولين",
  },
  {
    verseId: 25,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُمۡ يَنۡهَوۡنَ عَنۡهُ وَيَنۡـَٔوۡنَ عَنۡهُۖ وَإِن يُهۡلِكُونَ إِلَّآ أَنفُسَهُمۡ وَمَا يَشۡعُرُونَ",
    translation:
      "And they prevent [others] from him and are [themselves] remote from him. And they do not destroy except themselves, but they perceive [it] not",
    normalizedText: "وهم ينهون عنه وينون عنه وان يهلكون الا انفسهم وما يشعرون",
  },
  {
    verseId: 26,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَوۡ تَرَىٰٓ إِذۡ وُقِفُواْ عَلَى ٱلنَّارِ فَقَالُواْ يَٰلَيۡتَنَا نُرَدُّ وَلَا نُكَذِّبَ بِـَٔايَٰتِ رَبِّنَا وَنَكُونَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      'If you could but see when they are made to stand before the Fire and will say, "Oh, would that we could be returned [to life on earth] and not deny the signs of our Lord and be among the believers',
    normalizedText:
      "ولو ترى اذ وقفوا على النار فقالوا يليتنا نرد ولا نكذب بايت ربنا ونكون من المامنين",
  },
  {
    verseId: 27,
    name: "الأنعام",
    surahId: 6,
    text: "بَلۡ بَدَا لَهُم مَّا كَانُواْ يُخۡفُونَ مِن قَبۡلُۖ وَلَوۡ رُدُّواْ لَعَادُواْ لِمَا نُهُواْ عَنۡهُ وَإِنَّهُمۡ لَكَٰذِبُونَ",
    translation:
      "But what they concealed before has [now] appeared to them. And even if they were returned, they would return to that which they were forbidden; and indeed, they are liars",
    normalizedText:
      "بل بدا لهم ما كانوا يخفون من قبل ولو ردوا لعادوا لما نهوا عنه وانهم لكذبون",
  },
  {
    verseId: 28,
    name: "الأنعام",
    surahId: 6,
    text: "وَقَالُوٓاْ إِنۡ هِيَ إِلَّا حَيَاتُنَا ٱلدُّنۡيَا وَمَا نَحۡنُ بِمَبۡعُوثِينَ",
    translation:
      'And they say, "There is none but our worldly life, and we will not be resurrected',
    normalizedText: "وقالوا ان هي الا حياتنا الدنيا وما نحن بمبعوثين",
  },
  {
    verseId: 29,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَوۡ تَرَىٰٓ إِذۡ وُقِفُواْ عَلَىٰ رَبِّهِمۡۚ قَالَ أَلَيۡسَ هَٰذَا بِٱلۡحَقِّۚ قَالُواْ بَلَىٰ وَرَبِّنَاۚ قَالَ فَذُوقُواْ ٱلۡعَذَابَ بِمَا كُنتُمۡ تَكۡفُرُونَ",
    translation:
      'If you could but see when they will be made to stand before their Lord. He will say, "Is this not the truth?" They will say, "Yes, by our Lord." He will [then] say, "So taste the punishment because you used to disbelieve',
    normalizedText:
      "ولو ترى اذ وقفوا على ربهم قال اليس هذا بالحق قالوا بلى وربنا قال فذوقوا العذاب بما كنتم تكفرون",
  },
  {
    verseId: 30,
    name: "الأنعام",
    surahId: 6,
    text: "قَدۡ خَسِرَ ٱلَّذِينَ كَذَّبُواْ بِلِقَآءِ ٱللَّهِۖ حَتَّىٰٓ إِذَا جَآءَتۡهُمُ ٱلسَّاعَةُ بَغۡتَةٗ قَالُواْ يَٰحَسۡرَتَنَا عَلَىٰ مَا فَرَّطۡنَا فِيهَا وَهُمۡ يَحۡمِلُونَ أَوۡزَارَهُمۡ عَلَىٰ ظُهُورِهِمۡۚ أَلَا سَآءَ مَا يَزِرُونَ",
    translation:
      'Those will have lost who deny the meeting with Allah, until when the Hour [of resurrection] comes upon them unexpectedly, they will say, "Oh, [how great is] our regret over what we neglected concerning it," while they bear their burdens on their backs. Unquestionably, evil is that which they bear',
    normalizedText:
      "قد خسر الذين كذبوا بلقاء الله حتى اذا جاءتهم الساعة بغتة قالوا يحسرتنا على ما فرطنا فيها وهم يحملون اوزارهم على ظهورهم الا ساء ما يزرون",
  },
  {
    verseId: 31,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَا ٱلۡحَيَوٰةُ ٱلدُّنۡيَآ إِلَّا لَعِبٞ وَلَهۡوٞۖ وَلَلدَّارُ ٱلۡأٓخِرَةُ خَيۡرٞ لِّلَّذِينَ يَتَّقُونَۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "And the worldly life is not but amusement and diversion; but the home of the Hereafter is best for those who fear Allah, so will you not reason",
    normalizedText:
      "وما الحيوة الدنيا الا لعب ولهو وللدار الاخرة خير للذين يتقون افلا تعقلون",
  },
  {
    verseId: 32,
    name: "الأنعام",
    surahId: 6,
    text: "قَدۡ نَعۡلَمُ إِنَّهُۥ لَيَحۡزُنُكَ ٱلَّذِي يَقُولُونَۖ فَإِنَّهُمۡ لَا يُكَذِّبُونَكَ وَلَٰكِنَّ ٱلظَّـٰلِمِينَ بِـَٔايَٰتِ ٱللَّهِ يَجۡحَدُونَ",
    translation:
      "We know that you, [O Muhammad], are saddened by what they say. And indeed, they do not call you untruthful, but it is the verses of Allah that the wrongdoers reject",
    normalizedText:
      "قد نعلم انه ليحزنك الذي يقولون فانهم لا يكذبونك ولكن الظلمين بايت الله يجحدون",
  },
  {
    verseId: 33,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَقَدۡ كُذِّبَتۡ رُسُلٞ مِّن قَبۡلِكَ فَصَبَرُواْ عَلَىٰ مَا كُذِّبُواْ وَأُوذُواْ حَتَّىٰٓ أَتَىٰهُمۡ نَصۡرُنَاۚ وَلَا مُبَدِّلَ لِكَلِمَٰتِ ٱللَّهِۚ وَلَقَدۡ جَآءَكَ مِن نَّبَإِيْ ٱلۡمُرۡسَلِينَ",
    translation:
      "And certainly were messengers denied before you, but they were patient over [the effects of] denial, and they were harmed until Our victory came to them. And none can alter the words of Allah. And there has certainly come to you some information about the [previous] messengers",
    normalizedText:
      "ولقد كذبت رسل من قبلك فصبروا على ما كذبوا واوذوا حتى اتىهم نصرنا ولا مبدل لكلمت الله ولقد جاءك من نباي المرسلين",
  },
  {
    verseId: 34,
    name: "الأنعام",
    surahId: 6,
    text: "وَإِن كَانَ كَبُرَ عَلَيۡكَ إِعۡرَاضُهُمۡ فَإِنِ ٱسۡتَطَعۡتَ أَن تَبۡتَغِيَ نَفَقٗا فِي ٱلۡأَرۡضِ أَوۡ سُلَّمٗا فِي ٱلسَّمَآءِ فَتَأۡتِيَهُم بِـَٔايَةٖۚ وَلَوۡ شَآءَ ٱللَّهُ لَجَمَعَهُمۡ عَلَى ٱلۡهُدَىٰۚ فَلَا تَكُونَنَّ مِنَ ٱلۡجَٰهِلِينَ",
    translation:
      "And if their evasion is difficult for you, then if you are able to seek a tunnel into the earth or a stairway into the sky to bring them a sign, [then do so]. But if Allah had willed, He would have united them upon guidance. So never be of the ignorant",
    normalizedText:
      "وان كان كبر عليك اعراضهم فان استطعت ان تبتغي نفقا في الارض او سلما في السماء فتاتيهم باية ولو شاء الله لجمعهم على الهدى فلا تكونن من الجهلين",
  },
  {
    verseId: 35,
    name: "الأنعام",
    surahId: 6,
    text: "۞إِنَّمَا يَسۡتَجِيبُ ٱلَّذِينَ يَسۡمَعُونَۘ وَٱلۡمَوۡتَىٰ يَبۡعَثُهُمُ ٱللَّهُ ثُمَّ إِلَيۡهِ يُرۡجَعُونَ",
    translation:
      "Only those who hear will respond. But the dead - Allah will resurrect them; then to Him they will be returned",
    normalizedText:
      "۞انما يستجيب الذين يسمعون والموتى يبعثهم الله ثم اليه يرجعون",
  },
  {
    verseId: 36,
    name: "الأنعام",
    surahId: 6,
    text: "وَقَالُواْ لَوۡلَا نُزِّلَ عَلَيۡهِ ءَايَةٞ مِّن رَّبِّهِۦۚ قُلۡ إِنَّ ٱللَّهَ قَادِرٌ عَلَىٰٓ أَن يُنَزِّلَ ءَايَةٗ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      'And they say, "Why has a sign not been sent down to him from his Lord?" Say, "Indeed, Allah is Able to send down a sign, but most of them do not know',
    normalizedText:
      "وقالوا لولا نزل عليه ءاية من ربه قل ان الله قادر على ان ينزل ءاية ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 37,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَا مِن دَآبَّةٖ فِي ٱلۡأَرۡضِ وَلَا طَـٰٓئِرٖ يَطِيرُ بِجَنَاحَيۡهِ إِلَّآ أُمَمٌ أَمۡثَالُكُمۚ مَّا فَرَّطۡنَا فِي ٱلۡكِتَٰبِ مِن شَيۡءٖۚ ثُمَّ إِلَىٰ رَبِّهِمۡ يُحۡشَرُونَ",
    translation:
      "And there is no creature on [or within] the earth or bird that flies with its wings except [that they are] communities like you. We have not neglected in the Register a thing. Then unto their Lord they will be gathered",
    normalizedText:
      "وما من دابة في الارض ولا طار يطير بجناحيه الا امم امثالكم ما فرطنا في الكتب من شيء ثم الى ربهم يحشرون",
  },
  {
    verseId: 38,
    name: "الأنعام",
    surahId: 6,
    text: "وَٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا صُمّٞ وَبُكۡمٞ فِي ٱلظُّلُمَٰتِۗ مَن يَشَإِ ٱللَّهُ يُضۡلِلۡهُ وَمَن يَشَأۡ يَجۡعَلۡهُ عَلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "But those who deny Our verses are deaf and dumb within darknesses. Whomever Allah wills - He leaves astray; and whomever He wills - He puts him on a straight path",
    normalizedText:
      "والذين كذبوا بايتنا صم وبكم في الظلمت من يشا الله يضلله ومن يشا يجعله على صرط مستقيم",
  },
  {
    verseId: 39,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ أَرَءَيۡتَكُمۡ إِنۡ أَتَىٰكُمۡ عَذَابُ ٱللَّهِ أَوۡ أَتَتۡكُمُ ٱلسَّاعَةُ أَغَيۡرَ ٱللَّهِ تَدۡعُونَ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Say, "Have you considered: if there came to you the punishment of Allah or there came to you the Hour - is it other than Allah you would invoke, if you should be truthful',
    normalizedText:
      "قل ارءيتكم ان اتىكم عذاب الله او اتتكم الساعة اغير الله تدعون ان كنتم صدقين",
  },
  {
    verseId: 40,
    name: "الأنعام",
    surahId: 6,
    text: "بَلۡ إِيَّاهُ تَدۡعُونَ فَيَكۡشِفُ مَا تَدۡعُونَ إِلَيۡهِ إِن شَآءَ وَتَنسَوۡنَ مَا تُشۡرِكُونَ",
    translation:
      "No, it is Him [alone] you would invoke, and He would remove that for which you invoked Him if He willed, and you would forget what you associate [with Him]",
    normalizedText: "بل اياه تدعون فيكشف ما تدعون اليه ان شاء وتنسون ما تشركون",
  },
  {
    verseId: 41,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَقَدۡ أَرۡسَلۡنَآ إِلَىٰٓ أُمَمٖ مِّن قَبۡلِكَ فَأَخَذۡنَٰهُم بِٱلۡبَأۡسَآءِ وَٱلضَّرَّآءِ لَعَلَّهُمۡ يَتَضَرَّعُونَ",
    translation:
      "And We have already sent [messengers] to nations before you, [O Muhammad]; then We seized them with poverty and hardship that perhaps they might humble themselves [to Us]",
    normalizedText:
      "ولقد ارسلنا الى امم من قبلك فاخذنهم بالباساء والضراء لعلهم يتضرعون",
  },
  {
    verseId: 42,
    name: "الأنعام",
    surahId: 6,
    text: "فَلَوۡلَآ إِذۡ جَآءَهُم بَأۡسُنَا تَضَرَّعُواْ وَلَٰكِن قَسَتۡ قُلُوبُهُمۡ وَزَيَّنَ لَهُمُ ٱلشَّيۡطَٰنُ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Then why, when Our punishment came to them, did they not humble themselves? But their hearts became hardened, and Satan made attractive to them that which they were doing",
    normalizedText:
      "فلولا اذ جاءهم باسنا تضرعوا ولكن قست قلوبهم وزين لهم الشيطن ما كانوا يعملون",
  },
  {
    verseId: 43,
    name: "الأنعام",
    surahId: 6,
    text: "فَلَمَّا نَسُواْ مَا ذُكِّرُواْ بِهِۦ فَتَحۡنَا عَلَيۡهِمۡ أَبۡوَٰبَ كُلِّ شَيۡءٍ حَتَّىٰٓ إِذَا فَرِحُواْ بِمَآ أُوتُوٓاْ أَخَذۡنَٰهُم بَغۡتَةٗ فَإِذَا هُم مُّبۡلِسُونَ",
    translation:
      "So when they forgot that by which they had been reminded, We opened to them the doors of every [good] thing until, when they rejoiced in that which they were given, We seized them suddenly, and they were [then] in despair",
    normalizedText:
      "فلما نسوا ما ذكروا به فتحنا عليهم ابوب كل شيء حتى اذا فرحوا بما اوتوا اخذنهم بغتة فاذا هم مبلسون",
  },
  {
    verseId: 44,
    name: "الأنعام",
    surahId: 6,
    text: "فَقُطِعَ دَابِرُ ٱلۡقَوۡمِ ٱلَّذِينَ ظَلَمُواْۚ وَٱلۡحَمۡدُ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "So the people that committed wrong were eliminated. And praise to Allah, Lord of the worlds",
    normalizedText: "فقطع دابر القوم الذين ظلموا والحمد لله رب العلمين",
  },
  {
    verseId: 45,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ أَرَءَيۡتُمۡ إِنۡ أَخَذَ ٱللَّهُ سَمۡعَكُمۡ وَأَبۡصَٰرَكُمۡ وَخَتَمَ عَلَىٰ قُلُوبِكُم مَّنۡ إِلَٰهٌ غَيۡرُ ٱللَّهِ يَأۡتِيكُم بِهِۗ ٱنظُرۡ كَيۡفَ نُصَرِّفُ ٱلۡأٓيَٰتِ ثُمَّ هُمۡ يَصۡدِفُونَ",
    translation:
      'Say, "Have you considered: if Allah should take away your hearing and your sight and set a seal upon your hearts, which deity other than Allah could bring them [back] to you?" Look how we diversify the verses; then they [still] turn away',
    normalizedText:
      "قل ارءيتم ان اخذ الله سمعكم وابصركم وختم على قلوبكم من اله غير الله ياتيكم به انظر كيف نصرف الايت ثم هم يصدفون",
  },
  {
    verseId: 46,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ أَرَءَيۡتَكُمۡ إِنۡ أَتَىٰكُمۡ عَذَابُ ٱللَّهِ بَغۡتَةً أَوۡ جَهۡرَةً هَلۡ يُهۡلَكُ إِلَّا ٱلۡقَوۡمُ ٱلظَّـٰلِمُونَ",
    translation:
      'Say, "Have you considered: if the punishment of Allah should come to you unexpectedly or manifestly, will any be destroyed but the wrongdoing people',
    normalizedText:
      "قل ارءيتكم ان اتىكم عذاب الله بغتة او جهرة هل يهلك الا القوم الظلمون",
  },
  {
    verseId: 47,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَا نُرۡسِلُ ٱلۡمُرۡسَلِينَ إِلَّا مُبَشِّرِينَ وَمُنذِرِينَۖ فَمَنۡ ءَامَنَ وَأَصۡلَحَ فَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "And We send not the messengers except as bringers of good tidings and warners. So whoever believes and reforms - there will be no fear concerning them, nor will they grieve",
    normalizedText:
      "وما نرسل المرسلين الا مبشرين ومنذرين فمن ءامن واصلح فلا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 48,
    name: "الأنعام",
    surahId: 6,
    text: "وَٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا يَمَسُّهُمُ ٱلۡعَذَابُ بِمَا كَانُواْ يَفۡسُقُونَ",
    translation:
      "But those who deny Our verses - the punishment will touch them for their defiant disobedience",
    normalizedText: "والذين كذبوا بايتنا يمسهم العذاب بما كانوا يفسقون",
  },
  {
    verseId: 49,
    name: "الأنعام",
    surahId: 6,
    text: "قُل لَّآ أَقُولُ لَكُمۡ عِندِي خَزَآئِنُ ٱللَّهِ وَلَآ أَعۡلَمُ ٱلۡغَيۡبَ وَلَآ أَقُولُ لَكُمۡ إِنِّي مَلَكٌۖ إِنۡ أَتَّبِعُ إِلَّا مَا يُوحَىٰٓ إِلَيَّۚ قُلۡ هَلۡ يَسۡتَوِي ٱلۡأَعۡمَىٰ وَٱلۡبَصِيرُۚ أَفَلَا تَتَفَكَّرُونَ",
    translation:
      'Say, [O Muhammad], "I do not tell you that I have the depositories [containing the provision] of Allah or that I know the unseen, nor do I tell you that I am an angel. I only follow what is revealed to me." Say, "Is the blind equivalent to the seeing? Then will you not give thought',
    normalizedText:
      "قل لا اقول لكم عندي خزاان الله ولا اعلم الغيب ولا اقول لكم اني ملك ان اتبع الا ما يوحى الي قل هل يستوي الاعمى والبصير افلا تتفكرون",
  },
  {
    verseId: 50,
    name: "الأنعام",
    surahId: 6,
    text: "وَأَنذِرۡ بِهِ ٱلَّذِينَ يَخَافُونَ أَن يُحۡشَرُوٓاْ إِلَىٰ رَبِّهِمۡ لَيۡسَ لَهُم مِّن دُونِهِۦ وَلِيّٞ وَلَا شَفِيعٞ لَّعَلَّهُمۡ يَتَّقُونَ",
    translation:
      "And warn by the Qur'an those who fear that they will be gathered before their Lord - for them besides Him will be no protector and no intercessor - that they might become righteous",
    normalizedText:
      "وانذر به الذين يخافون ان يحشروا الى ربهم ليس لهم من دونه ولي ولا شفيع لعلهم يتقون",
  },
  {
    verseId: 51,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَا تَطۡرُدِ ٱلَّذِينَ يَدۡعُونَ رَبَّهُم بِٱلۡغَدَوٰةِ وَٱلۡعَشِيِّ يُرِيدُونَ وَجۡهَهُۥۖ مَا عَلَيۡكَ مِنۡ حِسَابِهِم مِّن شَيۡءٖ وَمَا مِنۡ حِسَابِكَ عَلَيۡهِم مِّن شَيۡءٖ فَتَطۡرُدَهُمۡ فَتَكُونَ مِنَ ٱلظَّـٰلِمِينَ",
    translation:
      "And do not send away those who call upon their Lord morning and afternoon, seeking His countenance. Not upon you is anything of their account and not upon them is anything of your account. So were you to send them away, you would [then] be of the wrongdoers",
    normalizedText:
      "ولا تطرد الذين يدعون ربهم بالغدوة والعشي يريدون وجهه ما عليك من حسابهم من شيء وما من حسابك عليهم من شيء فتطردهم فتكون من الظلمين",
  },
  {
    verseId: 52,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ فَتَنَّا بَعۡضَهُم بِبَعۡضٖ لِّيَقُولُوٓاْ أَهَـٰٓؤُلَآءِ مَنَّ ٱللَّهُ عَلَيۡهِم مِّنۢ بَيۡنِنَآۗ أَلَيۡسَ ٱللَّهُ بِأَعۡلَمَ بِٱلشَّـٰكِرِينَ",
    translation:
      'And thus We have tried some of them through others that the disbelievers might say, "Is it these whom Allah has favored among us?" Is not Allah most knowing of those who are grateful',
    normalizedText:
      "وكذلك فتنا بعضهم ببعض ليقولوا اهالاء من الله عليهم من بيننا اليس الله باعلم بالشكرين",
  },
  {
    verseId: 53,
    name: "الأنعام",
    surahId: 6,
    text: "وَإِذَا جَآءَكَ ٱلَّذِينَ يُؤۡمِنُونَ بِـَٔايَٰتِنَا فَقُلۡ سَلَٰمٌ عَلَيۡكُمۡۖ كَتَبَ رَبُّكُمۡ عَلَىٰ نَفۡسِهِ ٱلرَّحۡمَةَ أَنَّهُۥ مَنۡ عَمِلَ مِنكُمۡ سُوٓءَۢا بِجَهَٰلَةٖ ثُمَّ تَابَ مِنۢ بَعۡدِهِۦ وَأَصۡلَحَ فَأَنَّهُۥ غَفُورٞ رَّحِيمٞ",
    translation:
      'And when those come to you who believe in Our verses, say, "Peace be upon you. Your Lord has decreed upon Himself mercy: that any of you who does wrong out of ignorance and then repents after that and corrects himself - indeed, He is Forgiving and Merciful',
    normalizedText:
      "واذا جاءك الذين يامنون بايتنا فقل سلم عليكم كتب ربكم على نفسه الرحمة انه من عمل منكم سوءا بجهلة ثم تاب من بعده واصلح فانه غفور رحيم",
  },
  {
    verseId: 54,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ نُفَصِّلُ ٱلۡأٓيَٰتِ وَلِتَسۡتَبِينَ سَبِيلُ ٱلۡمُجۡرِمِينَ",
    translation:
      "And thus do We detail the verses, and [thus] the way of the criminals will become evident",
    normalizedText: "وكذلك نفصل الايت ولتستبين سبيل المجرمين",
  },
  {
    verseId: 55,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ إِنِّي نُهِيتُ أَنۡ أَعۡبُدَ ٱلَّذِينَ تَدۡعُونَ مِن دُونِ ٱللَّهِۚ قُل لَّآ أَتَّبِعُ أَهۡوَآءَكُمۡ قَدۡ ضَلَلۡتُ إِذٗا وَمَآ أَنَا۠ مِنَ ٱلۡمُهۡتَدِينَ",
    translation:
      'Say, "Indeed, I have been forbidden to worship those you invoke besides Allah." Say, "I will not follow your desires, for I would then have gone astray, and I would not be of the [rightly] guided',
    normalizedText:
      "قل اني نهيت ان اعبد الذين تدعون من دون الله قل لا اتبع اهواءكم قد ضللت اذا وما انا من المهتدين",
  },
  {
    verseId: 56,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ إِنِّي عَلَىٰ بَيِّنَةٖ مِّن رَّبِّي وَكَذَّبۡتُم بِهِۦۚ مَا عِندِي مَا تَسۡتَعۡجِلُونَ بِهِۦٓۚ إِنِ ٱلۡحُكۡمُ إِلَّا لِلَّهِۖ يَقُصُّ ٱلۡحَقَّۖ وَهُوَ خَيۡرُ ٱلۡفَٰصِلِينَ",
    translation:
      'Say, "Indeed, I am on clear evidence from my Lord, and you have denied it. I do not have that for which you are impatient. The decision is only for Allah. He relates the truth, and He is the best of deciders',
    normalizedText:
      "قل اني على بينة من ربي وكذبتم به ما عندي ما تستعجلون به ان الحكم الا لله يقص الحق وهو خير الفصلين",
  },
  {
    verseId: 57,
    name: "الأنعام",
    surahId: 6,
    text: "قُل لَّوۡ أَنَّ عِندِي مَا تَسۡتَعۡجِلُونَ بِهِۦ لَقُضِيَ ٱلۡأَمۡرُ بَيۡنِي وَبَيۡنَكُمۡۗ وَٱللَّهُ أَعۡلَمُ بِٱلظَّـٰلِمِينَ",
    translation:
      'Say, "If I had that for which you are impatient, the matter would have been decided between me and you, but Allah is most knowing of the wrongdoers',
    normalizedText:
      "قل لو ان عندي ما تستعجلون به لقضي الامر بيني وبينكم والله اعلم بالظلمين",
  },
  {
    verseId: 58,
    name: "الأنعام",
    surahId: 6,
    text: "۞وَعِندَهُۥ مَفَاتِحُ ٱلۡغَيۡبِ لَا يَعۡلَمُهَآ إِلَّا هُوَۚ وَيَعۡلَمُ مَا فِي ٱلۡبَرِّ وَٱلۡبَحۡرِۚ وَمَا تَسۡقُطُ مِن وَرَقَةٍ إِلَّا يَعۡلَمُهَا وَلَا حَبَّةٖ فِي ظُلُمَٰتِ ٱلۡأَرۡضِ وَلَا رَطۡبٖ وَلَا يَابِسٍ إِلَّا فِي كِتَٰبٖ مُّبِينٖ",
    translation:
      "And with Him are the keys of the unseen; none knows them except Him. And He knows what is on the land and in the sea. Not a leaf falls but that He knows it. And no grain is there within the darknesses of the earth and no moist or dry [thing] but that it is [written] in a clear record",
    normalizedText:
      "۞وعنده مفاتح الغيب لا يعلمها الا هو ويعلم ما في البر والبحر وما تسقط من ورقة الا يعلمها ولا حبة في ظلمت الارض ولا رطب ولا يابس الا في كتب مبين",
  },
  {
    verseId: 59,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلَّذِي يَتَوَفَّىٰكُم بِٱلَّيۡلِ وَيَعۡلَمُ مَا جَرَحۡتُم بِٱلنَّهَارِ ثُمَّ يَبۡعَثُكُمۡ فِيهِ لِيُقۡضَىٰٓ أَجَلٞ مُّسَمّٗىۖ ثُمَّ إِلَيۡهِ مَرۡجِعُكُمۡ ثُمَّ يُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "And it is He who takes your souls by night and knows what you have committed by day. Then He revives you therein that a specified term may be fulfilled. Then to Him will be your return; then He will inform you about what you used to do",
    normalizedText:
      "وهو الذي يتوفىكم باليل ويعلم ما جرحتم بالنهار ثم يبعثكم فيه ليقضى اجل مسمى ثم اليه مرجعكم ثم ينباكم بما كنتم تعملون",
  },
  {
    verseId: 60,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلۡقَاهِرُ فَوۡقَ عِبَادِهِۦۖ وَيُرۡسِلُ عَلَيۡكُمۡ حَفَظَةً حَتَّىٰٓ إِذَا جَآءَ أَحَدَكُمُ ٱلۡمَوۡتُ تَوَفَّتۡهُ رُسُلُنَا وَهُمۡ لَا يُفَرِّطُونَ",
    translation:
      "And He is the subjugator over His servants, and He sends over you guardian-angels until, when death comes to one of you, Our messengers take him, and they do not fail [in their duties]",
    normalizedText:
      "وهو القاهر فوق عباده ويرسل عليكم حفظة حتى اذا جاء احدكم الموت توفته رسلنا وهم لا يفرطون",
  },
  {
    verseId: 61,
    name: "الأنعام",
    surahId: 6,
    text: "ثُمَّ رُدُّوٓاْ إِلَى ٱللَّهِ مَوۡلَىٰهُمُ ٱلۡحَقِّۚ أَلَا لَهُ ٱلۡحُكۡمُ وَهُوَ أَسۡرَعُ ٱلۡحَٰسِبِينَ",
    translation:
      "Then they His servants are returned to Allah, their true Lord. Unquestionably, His is the judgement, and He is the swiftest of accountants",
    normalizedText:
      "ثم ردوا الى الله مولىهم الحق الا له الحكم وهو اسرع الحسبين",
  },
  {
    verseId: 62,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ مَن يُنَجِّيكُم مِّن ظُلُمَٰتِ ٱلۡبَرِّ وَٱلۡبَحۡرِ تَدۡعُونَهُۥ تَضَرُّعٗا وَخُفۡيَةٗ لَّئِنۡ أَنجَىٰنَا مِنۡ هَٰذِهِۦ لَنَكُونَنَّ مِنَ ٱلشَّـٰكِرِينَ",
    translation: `Say, "Who rescues you from the darknesses of the land and sea [when] you call upon Him imploring [aloud] and privately, 'If He should save us from this [crisis], we will surely be among the thankful`,
    normalizedText:
      "قل من ينجيكم من ظلمت البر والبحر تدعونه تضرعا وخفية لان انجىنا من هذه لنكونن من الشكرين",
  },
  {
    verseId: 63,
    name: "الأنعام",
    surahId: 6,
    text: "قُلِ ٱللَّهُ يُنَجِّيكُم مِّنۡهَا وَمِن كُلِّ كَرۡبٖ ثُمَّ أَنتُمۡ تُشۡرِكُونَ",
    translation:
      'Say, "It is Allah who saves you from it and from every distress; then you [still] associate others with Him',
    normalizedText: "قل الله ينجيكم منها ومن كل كرب ثم انتم تشركون",
  },
  {
    verseId: 64,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ هُوَ ٱلۡقَادِرُ عَلَىٰٓ أَن يَبۡعَثَ عَلَيۡكُمۡ عَذَابٗا مِّن فَوۡقِكُمۡ أَوۡ مِن تَحۡتِ أَرۡجُلِكُمۡ أَوۡ يَلۡبِسَكُمۡ شِيَعٗا وَيُذِيقَ بَعۡضَكُم بَأۡسَ بَعۡضٍۗ ٱنظُرۡ كَيۡفَ نُصَرِّفُ ٱلۡأٓيَٰتِ لَعَلَّهُمۡ يَفۡقَهُونَ",
    translation:
      'Say, "He is the [one] Able to send upon you affliction from above you or from beneath your feet or to confuse you [so you become] sects and make you taste the violence of one another." Look how We diversify the signs that they might understand',
    normalizedText:
      "قل هو القادر على ان يبعث عليكم عذابا من فوقكم او من تحت ارجلكم او يلبسكم شيعا ويذيق بعضكم باس بعض انظر كيف نصرف الايت لعلهم يفقهون",
  },
  {
    verseId: 65,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَّبَ بِهِۦ قَوۡمُكَ وَهُوَ ٱلۡحَقُّۚ قُل لَّسۡتُ عَلَيۡكُم بِوَكِيلٖ",
    translation:
      'But your people have denied it while it is the truth. Say, "I am not over you a manager',
    normalizedText: "وكذب به قومك وهو الحق قل لست عليكم بوكيل",
  },
  {
    verseId: 66,
    name: "الأنعام",
    surahId: 6,
    text: "لِّكُلِّ نَبَإٖ مُّسۡتَقَرّٞۚ وَسَوۡفَ تَعۡلَمُونَ",
    translation: "For every happening is a finality; and you are going to know",
    normalizedText: "لكل نبا مستقر وسوف تعلمون",
  },
  {
    verseId: 67,
    name: "الأنعام",
    surahId: 6,
    text: "وَإِذَا رَأَيۡتَ ٱلَّذِينَ يَخُوضُونَ فِيٓ ءَايَٰتِنَا فَأَعۡرِضۡ عَنۡهُمۡ حَتَّىٰ يَخُوضُواْ فِي حَدِيثٍ غَيۡرِهِۦۚ وَإِمَّا يُنسِيَنَّكَ ٱلشَّيۡطَٰنُ فَلَا تَقۡعُدۡ بَعۡدَ ٱلذِّكۡرَىٰ مَعَ ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      "And when you see those who engage in [offensive] discourse concerning Our verses, then turn away from them until they enter into another conversation. And if Satan should cause you to forget, then do not remain after the reminder with the wrongdoing people",
    normalizedText:
      "واذا رايت الذين يخوضون في ءايتنا فاعرض عنهم حتى يخوضوا في حديث غيره واما ينسينك الشيطن فلا تقعد بعد الذكرى مع القوم الظلمين",
  },
  {
    verseId: 68,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَا عَلَى ٱلَّذِينَ يَتَّقُونَ مِنۡ حِسَابِهِم مِّن شَيۡءٖ وَلَٰكِن ذِكۡرَىٰ لَعَلَّهُمۡ يَتَّقُونَ",
    translation:
      "And those who fear Allah are not held accountable for the disbelievers at all, but [only for] a reminder - that perhaps they will fear Him",
    normalizedText:
      "وما على الذين يتقون من حسابهم من شيء ولكن ذكرى لعلهم يتقون",
  },
  {
    verseId: 69,
    name: "الأنعام",
    surahId: 6,
    text: "وَذَرِ ٱلَّذِينَ ٱتَّخَذُواْ دِينَهُمۡ لَعِبٗا وَلَهۡوٗا وَغَرَّتۡهُمُ ٱلۡحَيَوٰةُ ٱلدُّنۡيَاۚ وَذَكِّرۡ بِهِۦٓ أَن تُبۡسَلَ نَفۡسُۢ بِمَا كَسَبَتۡ لَيۡسَ لَهَا مِن دُونِ ٱللَّهِ وَلِيّٞ وَلَا شَفِيعٞ وَإِن تَعۡدِلۡ كُلَّ عَدۡلٖ لَّا يُؤۡخَذۡ مِنۡهَآۗ أُوْلَـٰٓئِكَ ٱلَّذِينَ أُبۡسِلُواْ بِمَا كَسَبُواْۖ لَهُمۡ شَرَابٞ مِّنۡ حَمِيمٖ وَعَذَابٌ أَلِيمُۢ بِمَا كَانُواْ يَكۡفُرُونَ",
    translation:
      "And leave those who take their religion as amusement and diversion and whom the worldly life has deluded. But remind with the Qur'an, lest a soul be given up to destruction for what it earned; it will have other than Allah no protector and no intercessor. And if it should offer every compensation, it would not be taken from it. Those are the ones who are given to destruction for what they have earned. For them will be a drink of scalding water and a painful punishment because they used to disbelieve",
    normalizedText:
      "وذر الذين اتخذوا دينهم لعبا ولهوا وغرتهم الحيوة الدنيا وذكر به ان تبسل نفس بما كسبت ليس لها من دون الله ولي ولا شفيع وان تعدل كل عدل لا ياخذ منها اولاك الذين ابسلوا بما كسبوا لهم شراب من حميم وعذاب اليم بما كانوا يكفرون",
  },
  {
    verseId: 70,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ أَنَدۡعُواْ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُنَا وَلَا يَضُرُّنَا وَنُرَدُّ عَلَىٰٓ أَعۡقَابِنَا بَعۡدَ إِذۡ هَدَىٰنَا ٱللَّهُ كَٱلَّذِي ٱسۡتَهۡوَتۡهُ ٱلشَّيَٰطِينُ فِي ٱلۡأَرۡضِ حَيۡرَانَ لَهُۥٓ أَصۡحَٰبٞ يَدۡعُونَهُۥٓ إِلَى ٱلۡهُدَى ٱئۡتِنَاۗ قُلۡ إِنَّ هُدَى ٱللَّهِ هُوَ ٱلۡهُدَىٰۖ وَأُمِرۡنَا لِنُسۡلِمَ لِرَبِّ ٱلۡعَٰلَمِينَ",
    translation: `Say, "Shall we invoke instead of Allah that which neither benefits us nor harms us and be turned back on our heels after Allah has guided us? [We would then be] like one whom the devils enticed [to wander] upon the earth confused, [while] he has companions inviting him to guidance, [calling], 'Come to us.' " Say, "Indeed, the guidance of Allah is the [only] guidance; and we have been commanded to submit to the Lord of the worlds`,
    normalizedText:
      "قل اندعوا من دون الله ما لا ينفعنا ولا يضرنا ونرد على اعقابنا بعد اذ هدىنا الله كالذي استهوته الشيطين في الارض حيران له اصحب يدعونه الى الهدى ااتنا قل ان هدى الله هو الهدى وامرنا لنسلم لرب العلمين",
  },
  {
    verseId: 71,
    name: "الأنعام",
    surahId: 6,
    text: "وَأَنۡ أَقِيمُواْ ٱلصَّلَوٰةَ وَٱتَّقُوهُۚ وَهُوَ ٱلَّذِيٓ إِلَيۡهِ تُحۡشَرُونَ",
    translation:
      'And to establish prayer and fear Him." And it is He to whom you will be gathered',
    normalizedText: "وان اقيموا الصلوة واتقوه وهو الذي اليه تحشرون",
  },
  {
    verseId: 72,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِٱلۡحَقِّۖ وَيَوۡمَ يَقُولُ كُن فَيَكُونُۚ قَوۡلُهُ ٱلۡحَقُّۚ وَلَهُ ٱلۡمُلۡكُ يَوۡمَ يُنفَخُ فِي ٱلصُّورِۚ عَٰلِمُ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِۚ وَهُوَ ٱلۡحَكِيمُ ٱلۡخَبِيرُ",
    translation:
      'And it is He who created the heavens and earth in truth. And the day He says, "Be," and it is, His word is the truth. And His is the dominion [on] the Day the Horn is blown. [He is] Knower of the unseen and the witnessed; and He is the Wise, the Acquainted',
    normalizedText:
      "وهو الذي خلق السموت والارض بالحق ويوم يقول كن فيكون قوله الحق وله الملك يوم ينفخ في الصور علم الغيب والشهدة وهو الحكيم الخبير",
  },
  {
    verseId: 73,
    name: "الأنعام",
    surahId: 6,
    text: "۞وَإِذۡ قَالَ إِبۡرَٰهِيمُ لِأَبِيهِ ءَازَرَ أَتَتَّخِذُ أَصۡنَامًا ءَالِهَةً إِنِّيٓ أَرَىٰكَ وَقَوۡمَكَ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      'And [mention, O Muhammad], when Abraham said to his father Azar, "Do you take idols as deities? Indeed, I see you and your people to be in manifest error',
    normalizedText:
      "۞واذ قال ابرهيم لابيه ءازر اتتخذ اصناما ءالهة اني ارىك وقومك في ضلل مبين",
  },
  {
    verseId: 74,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ نُرِيٓ إِبۡرَٰهِيمَ مَلَكُوتَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَلِيَكُونَ مِنَ ٱلۡمُوقِنِينَ",
    translation:
      "And thus did We show Abraham the realm of the heavens and the earth that he would be among the certain [in faith]",
    normalizedText: "وكذلك نري ابرهيم ملكوت السموت والارض وليكون من الموقنين",
  },
  {
    verseId: 75,
    name: "الأنعام",
    surahId: 6,
    text: "فَلَمَّا جَنَّ عَلَيۡهِ ٱلَّيۡلُ رَءَا كَوۡكَبٗاۖ قَالَ هَٰذَا رَبِّيۖ فَلَمَّآ أَفَلَ قَالَ لَآ أُحِبُّ ٱلۡأٓفِلِينَ",
    translation:
      'So when the night covered him [with darkness], he saw a star. He said, "This is my lord." But when it set, he said, "I like not those that disappear',
    normalizedText:
      "فلما جن عليه اليل رءا كوكبا قال هذا ربي فلما افل قال لا احب الافلين",
  },
  {
    verseId: 76,
    name: "الأنعام",
    surahId: 6,
    text: "فَلَمَّا رَءَا ٱلۡقَمَرَ بَازِغٗا قَالَ هَٰذَا رَبِّيۖ فَلَمَّآ أَفَلَ قَالَ لَئِن لَّمۡ يَهۡدِنِي رَبِّي لَأَكُونَنَّ مِنَ ٱلۡقَوۡمِ ٱلضَّآلِّينَ",
    translation:
      'And when he saw the moon rising, he said, "This is my lord." But when it set, he said, "Unless my Lord guides me, I will surely be among the people gone astray',
    normalizedText:
      "فلما رءا القمر بازغا قال هذا ربي فلما افل قال لان لم يهدني ربي لاكونن من القوم الضالين",
  },
  {
    verseId: 77,
    name: "الأنعام",
    surahId: 6,
    text: "فَلَمَّا رَءَا ٱلشَّمۡسَ بَازِغَةٗ قَالَ هَٰذَا رَبِّي هَٰذَآ أَكۡبَرُۖ فَلَمَّآ أَفَلَتۡ قَالَ يَٰقَوۡمِ إِنِّي بَرِيٓءٞ مِّمَّا تُشۡرِكُونَ",
    translation:
      'And when he saw the sun rising, he said, "This is my lord; this is greater." But when it set, he said, "O my people, indeed I am free from what you associate with Allah',
    normalizedText:
      "فلما رءا الشمس بازغة قال هذا ربي هذا اكبر فلما افلت قال يقوم اني بريء مما تشركون",
  },
  {
    verseId: 78,
    name: "الأنعام",
    surahId: 6,
    text: "إِنِّي وَجَّهۡتُ وَجۡهِيَ لِلَّذِي فَطَرَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ حَنِيفٗاۖ وَمَآ أَنَا۠ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "Indeed, I have turned my face toward He who created the heavens and the earth, inclining toward truth, and I am not of those who associate others with Allah",
    normalizedText:
      "اني وجهت وجهي للذي فطر السموت والارض حنيفا وما انا من المشركين",
  },
  {
    verseId: 79,
    name: "الأنعام",
    surahId: 6,
    text: "وَحَآجَّهُۥ قَوۡمُهُۥۚ قَالَ أَتُحَـٰٓجُّوٓنِّي فِي ٱللَّهِ وَقَدۡ هَدَىٰنِۚ وَلَآ أَخَافُ مَا تُشۡرِكُونَ بِهِۦٓ إِلَّآ أَن يَشَآءَ رَبِّي شَيۡـٔٗاۚ وَسِعَ رَبِّي كُلَّ شَيۡءٍ عِلۡمًاۚ أَفَلَا تَتَذَكَّرُونَ",
    translation:
      'And his people argued with him. He said, "Do you argue with me concerning Allah while He has guided me? And I fear not what you associate with Him [and will not be harmed] unless my Lord should will something. My Lord encompasses all things in knowledge; then will you not remember',
    normalizedText:
      "وحاجه قومه قال اتحجوني في الله وقد هدىن ولا اخاف ما تشركون به الا ان يشاء ربي شيا وسع ربي كل شيء علما افلا تتذكرون",
  },
  {
    verseId: 80,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَيۡفَ أَخَافُ مَآ أَشۡرَكۡتُمۡ وَلَا تَخَافُونَ أَنَّكُمۡ أَشۡرَكۡتُم بِٱللَّهِ مَا لَمۡ يُنَزِّلۡ بِهِۦ عَلَيۡكُمۡ سُلۡطَٰنٗاۚ فَأَيُّ ٱلۡفَرِيقَيۡنِ أَحَقُّ بِٱلۡأَمۡنِۖ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "And how should I fear what you associate while you do not fear that you have associated with Allah that for which He has not sent down to you any authority? So which of the two parties has more right to security, if you should know",
    normalizedText:
      "وكيف اخاف ما اشركتم ولا تخافون انكم اشركتم بالله ما لم ينزل به عليكم سلطنا فاي الفريقين احق بالامن ان كنتم تعلمون",
  },
  {
    verseId: 81,
    name: "الأنعام",
    surahId: 6,
    text: "ٱلَّذِينَ ءَامَنُواْ وَلَمۡ يَلۡبِسُوٓاْ إِيمَٰنَهُم بِظُلۡمٍ أُوْلَـٰٓئِكَ لَهُمُ ٱلۡأَمۡنُ وَهُم مُّهۡتَدُونَ",
    translation:
      "They who believe and do not mix their belief with injustice - those will have security, and they are [rightly] guided",
    normalizedText:
      "الذين ءامنوا ولم يلبسوا ايمنهم بظلم اولاك لهم الامن وهم مهتدون",
  },
  {
    verseId: 82,
    name: "الأنعام",
    surahId: 6,
    text: "وَتِلۡكَ حُجَّتُنَآ ءَاتَيۡنَٰهَآ إِبۡرَٰهِيمَ عَلَىٰ قَوۡمِهِۦۚ نَرۡفَعُ دَرَجَٰتٖ مَّن نَّشَآءُۗ إِنَّ رَبَّكَ حَكِيمٌ عَلِيمٞ",
    translation:
      "And that was Our [conclusive] argument which We gave Abraham against his people. We raise by degrees whom We will. Indeed, your Lord is Wise and Knowing",
    normalizedText:
      "وتلك حجتنا ءاتينها ابرهيم على قومه نرفع درجت من نشاء ان ربك حكيم عليم",
  },
  {
    verseId: 83,
    name: "الأنعام",
    surahId: 6,
    text: "وَوَهَبۡنَا لَهُۥٓ إِسۡحَٰقَ وَيَعۡقُوبَۚ كُلًّا هَدَيۡنَاۚ وَنُوحًا هَدَيۡنَا مِن قَبۡلُۖ وَمِن ذُرِّيَّتِهِۦ دَاوُۥدَ وَسُلَيۡمَٰنَ وَأَيُّوبَ وَيُوسُفَ وَمُوسَىٰ وَهَٰرُونَۚ وَكَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation:
      "And We gave to Abraham, Isaac and Jacob - all [of them] We guided. And Noah, We guided before; and among his descendants, David and Solomon and Job and Joseph and Moses and Aaron. Thus do We reward the doers of good",
    normalizedText:
      "ووهبنا له اسحق ويعقوب كلا هدينا ونوحا هدينا من قبل ومن ذريته داود وسليمن وايوب ويوسف وموسى وهرون وكذلك نجزي المحسنين",
  },
  {
    verseId: 84,
    name: "الأنعام",
    surahId: 6,
    text: "وَزَكَرِيَّا وَيَحۡيَىٰ وَعِيسَىٰ وَإِلۡيَاسَۖ كُلّٞ مِّنَ ٱلصَّـٰلِحِينَ",
    translation:
      "And Zechariah and John and Jesus and Elias - and all were of the righteous",
    normalizedText: "وزكريا ويحيى وعيسى والياس كل من الصلحين",
  },
  {
    verseId: 85,
    name: "الأنعام",
    surahId: 6,
    text: "وَإِسۡمَٰعِيلَ وَٱلۡيَسَعَ وَيُونُسَ وَلُوطٗاۚ وَكُلّٗا فَضَّلۡنَا عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      "And Ishmael and Elisha and Jonah and Lot - and all [of them] We preferred over the worlds",
    normalizedText: "واسمعيل واليسع ويونس ولوطا وكلا فضلنا على العلمين",
  },
  {
    verseId: 86,
    name: "الأنعام",
    surahId: 6,
    text: "وَمِنۡ ءَابَآئِهِمۡ وَذُرِّيَّـٰتِهِمۡ وَإِخۡوَٰنِهِمۡۖ وَٱجۡتَبَيۡنَٰهُمۡ وَهَدَيۡنَٰهُمۡ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "And [some] among their fathers and their descendants and their brothers - and We chose them and We guided them to a straight path",
    normalizedText:
      "ومن ءابااهم وذريتهم واخونهم واجتبينهم وهدينهم الى صرط مستقيم",
  },
  {
    verseId: 87,
    name: "الأنعام",
    surahId: 6,
    text: "ذَٰلِكَ هُدَى ٱللَّهِ يَهۡدِي بِهِۦ مَن يَشَآءُ مِنۡ عِبَادِهِۦۚ وَلَوۡ أَشۡرَكُواْ لَحَبِطَ عَنۡهُم مَّا كَانُواْ يَعۡمَلُونَ",
    translation:
      "That is the guidance of Allah by which He guides whomever He wills of His servants. But if they had associated others with Allah, then worthless for them would be whatever they were doing",
    normalizedText:
      "ذلك هدى الله يهدي به من يشاء من عباده ولو اشركوا لحبط عنهم ما كانوا يعملون",
  },
  {
    verseId: 88,
    name: "الأنعام",
    surahId: 6,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ وَٱلۡحُكۡمَ وَٱلنُّبُوَّةَۚ فَإِن يَكۡفُرۡ بِهَا هَـٰٓؤُلَآءِ فَقَدۡ وَكَّلۡنَا بِهَا قَوۡمٗا لَّيۡسُواْ بِهَا بِكَٰفِرِينَ",
    translation:
      "Those are the ones to whom We gave the Scripture and authority and prophethood. But if the disbelievers deny it, then We have entrusted it to a people who are not therein disbelievers",
    normalizedText:
      "اولاك الذين ءاتينهم الكتب والحكم والنبوة فان يكفر بها هالاء فقد وكلنا بها قوما ليسوا بها بكفرين",
  },
  {
    verseId: 89,
    name: "الأنعام",
    surahId: 6,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ هَدَى ٱللَّهُۖ فَبِهُدَىٰهُمُ ٱقۡتَدِهۡۗ قُل لَّآ أَسۡـَٔلُكُمۡ عَلَيۡهِ أَجۡرًاۖ إِنۡ هُوَ إِلَّا ذِكۡرَىٰ لِلۡعَٰلَمِينَ",
    translation:
      'Those are the ones whom Allah has guided, so from their guidance take an example. Say, "I ask of you for this message no payment. It is not but a reminder for the worlds',
    normalizedText:
      "اولاك الذين هدى الله فبهدىهم اقتده قل لا اسلكم عليه اجرا ان هو الا ذكرى للعلمين",
  },
  {
    verseId: 90,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَا قَدَرُواْ ٱللَّهَ حَقَّ قَدۡرِهِۦٓ إِذۡ قَالُواْ مَآ أَنزَلَ ٱللَّهُ عَلَىٰ بَشَرٖ مِّن شَيۡءٖۗ قُلۡ مَنۡ أَنزَلَ ٱلۡكِتَٰبَ ٱلَّذِي جَآءَ بِهِۦ مُوسَىٰ نُورٗا وَهُدٗى لِّلنَّاسِۖ تَجۡعَلُونَهُۥ قَرَاطِيسَ تُبۡدُونَهَا وَتُخۡفُونَ كَثِيرٗاۖ وَعُلِّمۡتُم مَّا لَمۡ تَعۡلَمُوٓاْ أَنتُمۡ وَلَآ ءَابَآؤُكُمۡۖ قُلِ ٱللَّهُۖ ثُمَّ ذَرۡهُمۡ فِي خَوۡضِهِمۡ يَلۡعَبُونَ",
    translation:
      'And they did not appraise Allah with true appraisal when they said, "Allah did not reveal to a human being anything." Say, "Who revealed the Scripture that Moses brought as light and guidance to the people? You [Jews] make it into pages, disclosing [some of] it and concealing much. And you were taught that which you knew not - neither you nor your fathers." Say, "Allah [revealed it]." Then leave them in their [empty] discourse, amusing themselves',
    normalizedText:
      "وما قدروا الله حق قدره اذ قالوا ما انزل الله على بشر من شيء قل من انزل الكتب الذي جاء به موسى نورا وهدى للناس تجعلونه قراطيس تبدونها وتخفون كثيرا وعلمتم ما لم تعلموا انتم ولا ءابااكم قل الله ثم ذرهم في خوضهم يلعبون",
  },
  {
    verseId: 91,
    name: "الأنعام",
    surahId: 6,
    text: "وَهَٰذَا كِتَٰبٌ أَنزَلۡنَٰهُ مُبَارَكٞ مُّصَدِّقُ ٱلَّذِي بَيۡنَ يَدَيۡهِ وَلِتُنذِرَ أُمَّ ٱلۡقُرَىٰ وَمَنۡ حَوۡلَهَاۚ وَٱلَّذِينَ يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ يُؤۡمِنُونَ بِهِۦۖ وَهُمۡ عَلَىٰ صَلَاتِهِمۡ يُحَافِظُونَ",
    translation:
      "And this is a Book which We have sent down, blessed and confirming what was before it, that you may warn the Mother of Cities and those around it. Those who believe in the Hereafter believe in it, and they are maintaining their prayers",
    normalizedText:
      "وهذا كتب انزلنه مبارك مصدق الذي بين يديه ولتنذر ام القرى ومن حولها والذين يامنون بالاخرة يامنون به وهم على صلاتهم يحافظون",
  },
  {
    verseId: 92,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوۡ قَالَ أُوحِيَ إِلَيَّ وَلَمۡ يُوحَ إِلَيۡهِ شَيۡءٞ وَمَن قَالَ سَأُنزِلُ مِثۡلَ مَآ أَنزَلَ ٱللَّهُۗ وَلَوۡ تَرَىٰٓ إِذِ ٱلظَّـٰلِمُونَ فِي غَمَرَٰتِ ٱلۡمَوۡتِ وَٱلۡمَلَـٰٓئِكَةُ بَاسِطُوٓاْ أَيۡدِيهِمۡ أَخۡرِجُوٓاْ أَنفُسَكُمُۖ ٱلۡيَوۡمَ تُجۡزَوۡنَ عَذَابَ ٱلۡهُونِ بِمَا كُنتُمۡ تَقُولُونَ عَلَى ٱللَّهِ غَيۡرَ ٱلۡحَقِّ وَكُنتُمۡ عَنۡ ءَايَٰتِهِۦ تَسۡتَكۡبِرُونَ",
    translation:
      'And who is more unjust than one who invents a lie about Allah or says, "It has been inspired to me," while nothing has been inspired to him, and one who says, "I will reveal [something] like what Allah revealed." And if you could but see when the wrongdoers are in the overwhelming pangs of death while the angels extend their hands, [saying], "Discharge your souls! Today you will be awarded the punishment of [extreme] humiliation for what you used to say against Allah other than the truth and [that] you were, toward His verses, being arrogant',
    normalizedText:
      "ومن اظلم ممن افترى على الله كذبا او قال اوحي الي ولم يوح اليه شيء ومن قال سانزل مثل ما انزل الله ولو ترى اذ الظلمون في غمرت الموت والملاكة باسطوا ايديهم اخرجوا انفسكم اليوم تجزون عذاب الهون بما كنتم تقولون على الله غير الحق وكنتم عن ءايته تستكبرون",
  },
  {
    verseId: 93,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَقَدۡ جِئۡتُمُونَا فُرَٰدَىٰ كَمَا خَلَقۡنَٰكُمۡ أَوَّلَ مَرَّةٖ وَتَرَكۡتُم مَّا خَوَّلۡنَٰكُمۡ وَرَآءَ ظُهُورِكُمۡۖ وَمَا نَرَىٰ مَعَكُمۡ شُفَعَآءَكُمُ ٱلَّذِينَ زَعَمۡتُمۡ أَنَّهُمۡ فِيكُمۡ شُرَكَـٰٓؤُاْۚ لَقَد تَّقَطَّعَ بَيۡنَكُمۡ وَضَلَّ عَنكُم مَّا كُنتُمۡ تَزۡعُمُونَ",
    translation: `[It will be said to them], "And you have certainly come to Us alone as We created you the first time, and you have left whatever We bestowed upon you behind you. And We do not see with you your 'intercessors' which you claimed that they were among you associates [of Allah]. It has [all] been severed between you, and lost from you is what you used to claim`,
    normalizedText:
      "ولقد جاتمونا فردى كما خلقنكم اول مرة وتركتم ما خولنكم وراء ظهوركم وما نرى معكم شفعاءكم الذين زعمتم انهم فيكم شركاا لقد تقطع بينكم وضل عنكم ما كنتم تزعمون",
  },
  {
    verseId: 94,
    name: "الأنعام",
    surahId: 6,
    text: "۞إِنَّ ٱللَّهَ فَالِقُ ٱلۡحَبِّ وَٱلنَّوَىٰۖ يُخۡرِجُ ٱلۡحَيَّ مِنَ ٱلۡمَيِّتِ وَمُخۡرِجُ ٱلۡمَيِّتِ مِنَ ٱلۡحَيِّۚ ذَٰلِكُمُ ٱللَّهُۖ فَأَنَّىٰ تُؤۡفَكُونَ",
    translation:
      "Indeed, Allah is the cleaver of grain and date seeds. He brings the living out of the dead and brings the dead out of the living. That is Allah; so how are you deluded",
    normalizedText:
      "۞ان الله فالق الحب والنوى يخرج الحي من الميت ومخرج الميت من الحي ذلكم الله فانى تافكون",
  },
  {
    verseId: 95,
    name: "الأنعام",
    surahId: 6,
    text: "فَالِقُ ٱلۡإِصۡبَاحِ وَجَعَلَ ٱلَّيۡلَ سَكَنٗا وَٱلشَّمۡسَ وَٱلۡقَمَرَ حُسۡبَانٗاۚ ذَٰلِكَ تَقۡدِيرُ ٱلۡعَزِيزِ ٱلۡعَلِيمِ",
    translation:
      "[He is] the cleaver of daybreak and has made the night for rest and the sun and moon for calculation. That is the determination of the Exalted in Might, the Knowing",
    normalizedText:
      "فالق الاصباح وجعل اليل سكنا والشمس والقمر حسبانا ذلك تقدير العزيز العليم",
  },
  {
    verseId: 96,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلَّذِي جَعَلَ لَكُمُ ٱلنُّجُومَ لِتَهۡتَدُواْ بِهَا فِي ظُلُمَٰتِ ٱلۡبَرِّ وَٱلۡبَحۡرِۗ قَدۡ فَصَّلۡنَا ٱلۡأٓيَٰتِ لِقَوۡمٖ يَعۡلَمُونَ",
    translation:
      "And it is He who placed for you the stars that you may be guided by them through the darknesses of the land and sea. We have detailed the signs for a people who know",
    normalizedText:
      "وهو الذي جعل لكم النجوم لتهتدوا بها في ظلمت البر والبحر قد فصلنا الايت لقوم يعلمون",
  },
  {
    verseId: 97,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلَّذِيٓ أَنشَأَكُم مِّن نَّفۡسٖ وَٰحِدَةٖ فَمُسۡتَقَرّٞ وَمُسۡتَوۡدَعٞۗ قَدۡ فَصَّلۡنَا ٱلۡأٓيَٰتِ لِقَوۡمٖ يَفۡقَهُونَ",
    translation:
      "And it is He who produced you from one soul and [gave you] a place of dwelling and of storage. We have detailed the signs for a people who understand",
    normalizedText:
      "وهو الذي انشاكم من نفس وحدة فمستقر ومستودع قد فصلنا الايت لقوم يفقهون",
  },
  {
    verseId: 98,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلَّذِيٓ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَأَخۡرَجۡنَا بِهِۦ نَبَاتَ كُلِّ شَيۡءٖ فَأَخۡرَجۡنَا مِنۡهُ خَضِرٗا نُّخۡرِجُ مِنۡهُ حَبّٗا مُّتَرَاكِبٗا وَمِنَ ٱلنَّخۡلِ مِن طَلۡعِهَا قِنۡوَانٞ دَانِيَةٞ وَجَنَّـٰتٖ مِّنۡ أَعۡنَابٖ وَٱلزَّيۡتُونَ وَٱلرُّمَّانَ مُشۡتَبِهٗا وَغَيۡرَ مُتَشَٰبِهٍۗ ٱنظُرُوٓاْ إِلَىٰ ثَمَرِهِۦٓ إِذَآ أَثۡمَرَ وَيَنۡعِهِۦٓۚ إِنَّ فِي ذَٰلِكُمۡ لَأٓيَٰتٖ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "And it is He who sends down rain from the sky, and We produce thereby the growth of all things. We produce from it greenery from which We produce grains arranged in layers. And from the palm trees - of its emerging fruit are clusters hanging low. And [We produce] gardens of grapevines and olives and pomegranates, similar yet varied. Look at [each of] its fruit when it yields and [at] its ripening. Indeed in that are signs for a people who believe",
    normalizedText:
      "وهو الذي انزل من السماء ماء فاخرجنا به نبات كل شيء فاخرجنا منه خضرا نخرج منه حبا متراكبا ومن النخل من طلعها قنوان دانية وجنت من اعناب والزيتون والرمان مشتبها وغير متشبه انظروا الى ثمره اذا اثمر وينعه ان في ذلكم لايت لقوم يامنون",
  },
  {
    verseId: 99,
    name: "الأنعام",
    surahId: 6,
    text: "وَجَعَلُواْ لِلَّهِ شُرَكَآءَ ٱلۡجِنَّ وَخَلَقَهُمۡۖ وَخَرَقُواْ لَهُۥ بَنِينَ وَبَنَٰتِۭ بِغَيۡرِ عِلۡمٖۚ سُبۡحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يَصِفُونَ",
    translation:
      "But they have attributed to Allah partners - the jinn, while He has created them - and have fabricated for Him sons and daughters. Exalted is He and high above what they describe",
    normalizedText:
      "وجعلوا لله شركاء الجن وخلقهم وخرقوا له بنين وبنت بغير علم سبحنه وتعلى عما يصفون",
  },
  {
    verseId: 100,
    name: "الأنعام",
    surahId: 6,
    text: "بَدِيعُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ أَنَّىٰ يَكُونُ لَهُۥ وَلَدٞ وَلَمۡ تَكُن لَّهُۥ صَٰحِبَةٞۖ وَخَلَقَ كُلَّ شَيۡءٖۖ وَهُوَ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "[He is] Originator of the heavens and the earth. How could He have a son when He does not have a companion and He created all things? And He is, of all things, Knowing",
    normalizedText:
      "بديع السموت والارض انى يكون له ولد ولم تكن له صحبة وخلق كل شيء وهو بكل شيء عليم",
  },
  {
    verseId: 101,
    name: "الأنعام",
    surahId: 6,
    text: "ذَٰلِكُمُ ٱللَّهُ رَبُّكُمۡۖ لَآ إِلَٰهَ إِلَّا هُوَۖ خَٰلِقُ كُلِّ شَيۡءٖ فَٱعۡبُدُوهُۚ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ وَكِيلٞ",
    translation:
      "That is Allah, your Lord; there is no deity except Him, the Creator of all things, so worship Him. And He is Disposer of all things",
    normalizedText:
      "ذلكم الله ربكم لا اله الا هو خلق كل شيء فاعبدوه وهو على كل شيء وكيل",
  },
  {
    verseId: 102,
    name: "الأنعام",
    surahId: 6,
    text: "لَّا تُدۡرِكُهُ ٱلۡأَبۡصَٰرُ وَهُوَ يُدۡرِكُ ٱلۡأَبۡصَٰرَۖ وَهُوَ ٱللَّطِيفُ ٱلۡخَبِيرُ",
    translation:
      "Vision perceives Him not, but He perceives [all] vision; and He is the Subtle, the Acquainted",
    normalizedText: "لا تدركه الابصر وهو يدرك الابصر وهو اللطيف الخبير",
  },
  {
    verseId: 103,
    name: "الأنعام",
    surahId: 6,
    text: "قَدۡ جَآءَكُم بَصَآئِرُ مِن رَّبِّكُمۡۖ فَمَنۡ أَبۡصَرَ فَلِنَفۡسِهِۦۖ وَمَنۡ عَمِيَ فَعَلَيۡهَاۚ وَمَآ أَنَا۠ عَلَيۡكُم بِحَفِيظٖ",
    translation:
      'There has come to you enlightenment from your Lord. So whoever will see does so for [the benefit of] his soul, and whoever is blind [does harm] against it. And [say], "I am not a guardian over you',
    normalizedText:
      "قد جاءكم بصاار من ربكم فمن ابصر فلنفسه ومن عمي فعليها وما انا عليكم بحفيظ",
  },
  {
    verseId: 104,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ نُصَرِّفُ ٱلۡأٓيَٰتِ وَلِيَقُولُواْ دَرَسۡتَ وَلِنُبَيِّنَهُۥ لِقَوۡمٖ يَعۡلَمُونَ",
    translation: `And thus do We diversify the verses so the disbelievers will say, "You have studied," and so We may make the Qur'an clear for a people who know`,
    normalizedText: "وكذلك نصرف الايت وليقولوا درست ولنبينه لقوم يعلمون",
  },
  {
    verseId: 105,
    name: "الأنعام",
    surahId: 6,
    text: "ٱتَّبِعۡ مَآ أُوحِيَ إِلَيۡكَ مِن رَّبِّكَۖ لَآ إِلَٰهَ إِلَّا هُوَۖ وَأَعۡرِضۡ عَنِ ٱلۡمُشۡرِكِينَ",
    translation:
      "Follow, [O Muhammad], what has been revealed to you from your Lord - there is no deity except Him - and turn away from those who associate others with Allah",
    normalizedText: "اتبع ما اوحي اليك من ربك لا اله الا هو واعرض عن المشركين",
  },
  {
    verseId: 106,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَوۡ شَآءَ ٱللَّهُ مَآ أَشۡرَكُواْۗ وَمَا جَعَلۡنَٰكَ عَلَيۡهِمۡ حَفِيظٗاۖ وَمَآ أَنتَ عَلَيۡهِم بِوَكِيلٖ",
    translation:
      "But if Allah had willed, they would not have associated. And We have not appointed you over them as a guardian, nor are you a manager over them",
    normalizedText:
      "ولو شاء الله ما اشركوا وما جعلنك عليهم حفيظا وما انت عليهم بوكيل",
  },
  {
    verseId: 107,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَا تَسُبُّواْ ٱلَّذِينَ يَدۡعُونَ مِن دُونِ ٱللَّهِ فَيَسُبُّواْ ٱللَّهَ عَدۡوَۢا بِغَيۡرِ عِلۡمٖۗ كَذَٰلِكَ زَيَّنَّا لِكُلِّ أُمَّةٍ عَمَلَهُمۡ ثُمَّ إِلَىٰ رَبِّهِم مَّرۡجِعُهُمۡ فَيُنَبِّئُهُم بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "And do not insult those they invoke other than Allah, lest they insult Allah in enmity without knowledge. Thus We have made pleasing to every community their deeds. Then to their Lord is their return, and He will inform them about what they used to do",
    normalizedText:
      "ولا تسبوا الذين يدعون من دون الله فيسبوا الله عدوا بغير علم كذلك زينا لكل امة عملهم ثم الى ربهم مرجعهم فينباهم بما كانوا يعملون",
  },
  {
    verseId: 108,
    name: "الأنعام",
    surahId: 6,
    text: "وَأَقۡسَمُواْ بِٱللَّهِ جَهۡدَ أَيۡمَٰنِهِمۡ لَئِن جَآءَتۡهُمۡ ءَايَةٞ لَّيُؤۡمِنُنَّ بِهَاۚ قُلۡ إِنَّمَا ٱلۡأٓيَٰتُ عِندَ ٱللَّهِۖ وَمَا يُشۡعِرُكُمۡ أَنَّهَآ إِذَا جَآءَتۡ لَا يُؤۡمِنُونَ",
    translation:
      'And they swear by Allah their strongest oaths that if a sign came to them, they would surely believe in it. Say, "The signs are only with Allah." And what will make you perceive that even if a sign came, they would not believe',
    normalizedText:
      "واقسموا بالله جهد ايمنهم لان جاءتهم ءاية ليامنن بها قل انما الايت عند الله وما يشعركم انها اذا جاءت لا يامنون",
  },
  {
    verseId: 109,
    name: "الأنعام",
    surahId: 6,
    text: "وَنُقَلِّبُ أَفۡـِٔدَتَهُمۡ وَأَبۡصَٰرَهُمۡ كَمَا لَمۡ يُؤۡمِنُواْ بِهِۦٓ أَوَّلَ مَرَّةٖ وَنَذَرُهُمۡ فِي طُغۡيَٰنِهِمۡ يَعۡمَهُونَ",
    translation:
      "And We will turn away their hearts and their eyes just as they refused to believe in it the first time. And We will leave them in their transgression, wandering blindly",
    normalizedText:
      "ونقلب افدتهم وابصرهم كما لم يامنوا به اول مرة ونذرهم في طغينهم يعمهون",
  },
  {
    verseId: 110,
    name: "الأنعام",
    surahId: 6,
    text: "۞وَلَوۡ أَنَّنَا نَزَّلۡنَآ إِلَيۡهِمُ ٱلۡمَلَـٰٓئِكَةَ وَكَلَّمَهُمُ ٱلۡمَوۡتَىٰ وَحَشَرۡنَا عَلَيۡهِمۡ كُلَّ شَيۡءٖ قُبُلٗا مَّا كَانُواْ لِيُؤۡمِنُوٓاْ إِلَّآ أَن يَشَآءَ ٱللَّهُ وَلَٰكِنَّ أَكۡثَرَهُمۡ يَجۡهَلُونَ",
    translation:
      "And even if We had sent down to them the angels [with the message] and the dead spoke to them [of it] and We gathered together every [created] thing in front of them, they would not believe unless Allah should will. But most of them, [of that], are ignorant",
    normalizedText:
      "۞ولو اننا نزلنا اليهم الملاكة وكلمهم الموتى وحشرنا عليهم كل شيء قبلا ما كانوا ليامنوا الا ان يشاء الله ولكن اكثرهم يجهلون",
  },
  {
    verseId: 111,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ جَعَلۡنَا لِكُلِّ نَبِيٍّ عَدُوّٗا شَيَٰطِينَ ٱلۡإِنسِ وَٱلۡجِنِّ يُوحِي بَعۡضُهُمۡ إِلَىٰ بَعۡضٖ زُخۡرُفَ ٱلۡقَوۡلِ غُرُورٗاۚ وَلَوۡ شَآءَ رَبُّكَ مَا فَعَلُوهُۖ فَذَرۡهُمۡ وَمَا يَفۡتَرُونَ",
    translation:
      "And thus We have made for every prophet an enemy - devils from mankind and jinn, inspiring to one another decorative speech in delusion. But if your Lord had willed, they would not have done it, so leave them and that which they invent",
    normalizedText:
      "وكذلك جعلنا لكل نبي عدوا شيطين الانس والجن يوحي بعضهم الى بعض زخرف القول غرورا ولو شاء ربك ما فعلوه فذرهم وما يفترون",
  },
  {
    verseId: 112,
    name: "الأنعام",
    surahId: 6,
    text: "وَلِتَصۡغَىٰٓ إِلَيۡهِ أَفۡـِٔدَةُ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ وَلِيَرۡضَوۡهُ وَلِيَقۡتَرِفُواْ مَا هُم مُّقۡتَرِفُونَ",
    translation:
      "And [it is] so the hearts of those who disbelieve in the Hereafter will incline toward it and that they will be satisfied with it and that they will commit that which they are committing",
    normalizedText:
      "ولتصغى اليه افدة الذين لا يامنون بالاخرة وليرضوه وليقترفوا ما هم مقترفون",
  },
  {
    verseId: 113,
    name: "الأنعام",
    surahId: 6,
    text: "أَفَغَيۡرَ ٱللَّهِ أَبۡتَغِي حَكَمٗا وَهُوَ ٱلَّذِيٓ أَنزَلَ إِلَيۡكُمُ ٱلۡكِتَٰبَ مُفَصَّلٗاۚ وَٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ يَعۡلَمُونَ أَنَّهُۥ مُنَزَّلٞ مِّن رَّبِّكَ بِٱلۡحَقِّۖ فَلَا تَكُونَنَّ مِنَ ٱلۡمُمۡتَرِينَ",
    translation:
      '[Say], "Then is it other than Allah I should seek as judge while it is He who has revealed to you the Book explained in detail?" And those to whom We [previously] gave the Scripture know that it is sent down from your Lord in truth, so never be among the doubters',
    normalizedText:
      "افغير الله ابتغي حكما وهو الذي انزل اليكم الكتب مفصلا والذين ءاتينهم الكتب يعلمون انه منزل من ربك بالحق فلا تكونن من الممترين",
  },
  {
    verseId: 114,
    name: "الأنعام",
    surahId: 6,
    text: "وَتَمَّتۡ كَلِمَتُ رَبِّكَ صِدۡقٗا وَعَدۡلٗاۚ لَّا مُبَدِّلَ لِكَلِمَٰتِهِۦۚ وَهُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "And the word of your Lord has been fulfilled in truth and in justice. None can alter His words, and He is the Hearing, the Knowing",
    normalizedText: "وتمت كلمت ربك صدقا وعدلا لا مبدل لكلمته وهو السميع العليم",
  },
  {
    verseId: 115,
    name: "الأنعام",
    surahId: 6,
    text: "وَإِن تُطِعۡ أَكۡثَرَ مَن فِي ٱلۡأَرۡضِ يُضِلُّوكَ عَن سَبِيلِ ٱللَّهِۚ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَإِنۡ هُمۡ إِلَّا يَخۡرُصُونَ",
    translation:
      "And if you obey most of those upon the earth, they will mislead you from the way of Allah. They follow not except assumption, and they are not but falsifying",
    normalizedText:
      "وان تطع اكثر من في الارض يضلوك عن سبيل الله ان يتبعون الا الظن وان هم الا يخرصون",
  },
  {
    verseId: 116,
    name: "الأنعام",
    surahId: 6,
    text: "إِنَّ رَبَّكَ هُوَ أَعۡلَمُ مَن يَضِلُّ عَن سَبِيلِهِۦۖ وَهُوَ أَعۡلَمُ بِٱلۡمُهۡتَدِينَ",
    translation:
      "Indeed, your Lord is most knowing of who strays from His way, and He is most knowing of the [rightly] guided",
    normalizedText: "ان ربك هو اعلم من يضل عن سبيله وهو اعلم بالمهتدين",
  },
  {
    verseId: 117,
    name: "الأنعام",
    surahId: 6,
    text: "فَكُلُواْ مِمَّا ذُكِرَ ٱسۡمُ ٱللَّهِ عَلَيۡهِ إِن كُنتُم بِـَٔايَٰتِهِۦ مُؤۡمِنِينَ",
    translation:
      "So eat of that [meat] upon which the name of Allah has been mentioned, if you are believers in His verses",
    normalizedText: "فكلوا مما ذكر اسم الله عليه ان كنتم بايته مامنين",
  },
  {
    verseId: 118,
    name: "الأنعام",
    surahId: 6,
    text: "وَمَا لَكُمۡ أَلَّا تَأۡكُلُواْ مِمَّا ذُكِرَ ٱسۡمُ ٱللَّهِ عَلَيۡهِ وَقَدۡ فَصَّلَ لَكُم مَّا حَرَّمَ عَلَيۡكُمۡ إِلَّا مَا ٱضۡطُرِرۡتُمۡ إِلَيۡهِۗ وَإِنَّ كَثِيرٗا لَّيُضِلُّونَ بِأَهۡوَآئِهِم بِغَيۡرِ عِلۡمٍۚ إِنَّ رَبَّكَ هُوَ أَعۡلَمُ بِٱلۡمُعۡتَدِينَ",
    translation:
      "And why should you not eat of that upon which the name of Allah has been mentioned while He has explained in detail to you what He has forbidden you, excepting that to which you are compelled. And indeed do many lead [others] astray through their [own] inclinations without knowledge. Indeed, your Lord - He is most knowing of the transgressors",
    normalizedText:
      "وما لكم الا تاكلوا مما ذكر اسم الله عليه وقد فصل لكم ما حرم عليكم الا ما اضطررتم اليه وان كثيرا ليضلون باهوااهم بغير علم ان ربك هو اعلم بالمعتدين",
  },
  {
    verseId: 119,
    name: "الأنعام",
    surahId: 6,
    text: "وَذَرُواْ ظَٰهِرَ ٱلۡإِثۡمِ وَبَاطِنَهُۥٓۚ إِنَّ ٱلَّذِينَ يَكۡسِبُونَ ٱلۡإِثۡمَ سَيُجۡزَوۡنَ بِمَا كَانُواْ يَقۡتَرِفُونَ",
    translation:
      "And leave what is apparent of sin and what is concealed thereof. Indeed, those who earn [blame for] sin will be recompensed for that which they used to commit",
    normalizedText:
      "وذروا ظهر الاثم وباطنه ان الذين يكسبون الاثم سيجزون بما كانوا يقترفون",
  },
  {
    verseId: 120,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَا تَأۡكُلُواْ مِمَّا لَمۡ يُذۡكَرِ ٱسۡمُ ٱللَّهِ عَلَيۡهِ وَإِنَّهُۥ لَفِسۡقٞۗ وَإِنَّ ٱلشَّيَٰطِينَ لَيُوحُونَ إِلَىٰٓ أَوۡلِيَآئِهِمۡ لِيُجَٰدِلُوكُمۡۖ وَإِنۡ أَطَعۡتُمُوهُمۡ إِنَّكُمۡ لَمُشۡرِكُونَ",
    translation:
      "And do not eat of that upon which the name of Allah has not been mentioned, for indeed, it is grave disobedience. And indeed do the devils inspire their allies [among men] to dispute with you. And if you were to obey them, indeed, you would be associators [of others with Him]",
    normalizedText:
      "ولا تاكلوا مما لم يذكر اسم الله عليه وانه لفسق وان الشيطين ليوحون الى اوليااهم ليجدلوكم وان اطعتموهم انكم لمشركون",
  },
  {
    verseId: 121,
    name: "الأنعام",
    surahId: 6,
    text: "أَوَمَن كَانَ مَيۡتٗا فَأَحۡيَيۡنَٰهُ وَجَعَلۡنَا لَهُۥ نُورٗا يَمۡشِي بِهِۦ فِي ٱلنَّاسِ كَمَن مَّثَلُهُۥ فِي ٱلظُّلُمَٰتِ لَيۡسَ بِخَارِجٖ مِّنۡهَاۚ كَذَٰلِكَ زُيِّنَ لِلۡكَٰفِرِينَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "And is one who was dead and We gave him life and made for him light by which to walk among the people like one who is in darkness, never to emerge therefrom? Thus it has been made pleasing to the disbelievers that which they were doing",
    normalizedText:
      "اومن كان ميتا فاحيينه وجعلنا له نورا يمشي به في الناس كمن مثله في الظلمت ليس بخارج منها كذلك زين للكفرين ما كانوا يعملون",
  },
  {
    verseId: 122,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ جَعَلۡنَا فِي كُلِّ قَرۡيَةٍ أَكَٰبِرَ مُجۡرِمِيهَا لِيَمۡكُرُواْ فِيهَاۖ وَمَا يَمۡكُرُونَ إِلَّا بِأَنفُسِهِمۡ وَمَا يَشۡعُرُونَ",
    translation:
      "And thus We have placed within every city the greatest of its criminals to conspire therein. But they conspire not except against themselves, and they perceive [it] not",
    normalizedText:
      "وكذلك جعلنا في كل قرية اكبر مجرميها ليمكروا فيها وما يمكرون الا بانفسهم وما يشعرون",
  },
  {
    verseId: 123,
    name: "الأنعام",
    surahId: 6,
    text: "وَإِذَا جَآءَتۡهُمۡ ءَايَةٞ قَالُواْ لَن نُّؤۡمِنَ حَتَّىٰ نُؤۡتَىٰ مِثۡلَ مَآ أُوتِيَ رُسُلُ ٱللَّهِۘ ٱللَّهُ أَعۡلَمُ حَيۡثُ يَجۡعَلُ رِسَالَتَهُۥۗ سَيُصِيبُ ٱلَّذِينَ أَجۡرَمُواْ صَغَارٌ عِندَ ٱللَّهِ وَعَذَابٞ شَدِيدُۢ بِمَا كَانُواْ يَمۡكُرُونَ",
    translation:
      'And when a sign comes to them, they say, "Never will we believe until we are given like that which was given to the messengers of Allah." Allah is most knowing of where He places His message. There will afflict those who committed crimes debasement before Allah and severe punishment for what they used to conspire',
    normalizedText:
      "واذا جاءتهم ءاية قالوا لن نامن حتى ناتى مثل ما اوتي رسل الله الله اعلم حيث يجعل رسالته سيصيب الذين اجرموا صغار عند الله وعذاب شديد بما كانوا يمكرون",
  },
  {
    verseId: 124,
    name: "الأنعام",
    surahId: 6,
    text: "فَمَن يُرِدِ ٱللَّهُ أَن يَهۡدِيَهُۥ يَشۡرَحۡ صَدۡرَهُۥ لِلۡإِسۡلَٰمِۖ وَمَن يُرِدۡ أَن يُضِلَّهُۥ يَجۡعَلۡ صَدۡرَهُۥ ضَيِّقًا حَرَجٗا كَأَنَّمَا يَصَّعَّدُ فِي ٱلسَّمَآءِۚ كَذَٰلِكَ يَجۡعَلُ ٱللَّهُ ٱلرِّجۡسَ عَلَى ٱلَّذِينَ لَا يُؤۡمِنُونَ",
    translation:
      "So whoever Allah wants to guide - He expands his breast to [contain] Islam; and whoever He wants to misguide - He makes his breast tight and constricted as though he were climbing into the sky. Thus does Allah place defilement upon those who do not believe",
    normalizedText:
      "فمن يرد الله ان يهديه يشرح صدره للاسلم ومن يرد ان يضله يجعل صدره ضيقا حرجا كانما يصعد في السماء كذلك يجعل الله الرجس على الذين لا يامنون",
  },
  {
    verseId: 125,
    name: "الأنعام",
    surahId: 6,
    text: "وَهَٰذَا صِرَٰطُ رَبِّكَ مُسۡتَقِيمٗاۗ قَدۡ فَصَّلۡنَا ٱلۡأٓيَٰتِ لِقَوۡمٖ يَذَّكَّرُونَ",
    translation:
      "And this is the path of your Lord, [leading] straight. We have detailed the verses for a people who remember",
    normalizedText: "وهذا صرط ربك مستقيما قد فصلنا الايت لقوم يذكرون",
  },
  {
    verseId: 126,
    name: "الأنعام",
    surahId: 6,
    text: "۞لَهُمۡ دَارُ ٱلسَّلَٰمِ عِندَ رَبِّهِمۡۖ وَهُوَ وَلِيُّهُم بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "For them will be the Home of Peace with their Lord. And He will be their protecting friend because of what they used to do",
    normalizedText: "۞لهم دار السلم عند ربهم وهو وليهم بما كانوا يعملون",
  },
  {
    verseId: 127,
    name: "الأنعام",
    surahId: 6,
    text: "وَيَوۡمَ يَحۡشُرُهُمۡ جَمِيعٗا يَٰمَعۡشَرَ ٱلۡجِنِّ قَدِ ٱسۡتَكۡثَرۡتُم مِّنَ ٱلۡإِنسِۖ وَقَالَ أَوۡلِيَآؤُهُم مِّنَ ٱلۡإِنسِ رَبَّنَا ٱسۡتَمۡتَعَ بَعۡضُنَا بِبَعۡضٖ وَبَلَغۡنَآ أَجَلَنَا ٱلَّذِيٓ أَجَّلۡتَ لَنَاۚ قَالَ ٱلنَّارُ مَثۡوَىٰكُمۡ خَٰلِدِينَ فِيهَآ إِلَّا مَا شَآءَ ٱللَّهُۚ إِنَّ رَبَّكَ حَكِيمٌ عَلِيمٞ",
    translation:
      'And [mention, O Muhammad], the Day when He will gather them together [and say], "O company of jinn, you have [misled] many of mankind." And their allies among mankind will say, "Our Lord, some of us made use of others, and we have [now] reached our term, which you appointed for us." He will say, "The Fire is your residence, wherein you will abide eternally, except for what Allah wills. Indeed, your Lord is Wise and Knowing',
    normalizedText:
      "ويوم يحشرهم جميعا يمعشر الجن قد استكثرتم من الانس وقال اوليااهم من الانس ربنا استمتع بعضنا ببعض وبلغنا اجلنا الذي اجلت لنا قال النار مثوىكم خلدين فيها الا ما شاء الله ان ربك حكيم عليم",
  },
  {
    verseId: 128,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ نُوَلِّي بَعۡضَ ٱلظَّـٰلِمِينَ بَعۡضَۢا بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "And thus will We make some of the wrongdoers allies of others for what they used to earn",
    normalizedText: "وكذلك نولي بعض الظلمين بعضا بما كانوا يكسبون",
  },
  {
    verseId: 129,
    name: "الأنعام",
    surahId: 6,
    text: "يَٰمَعۡشَرَ ٱلۡجِنِّ وَٱلۡإِنسِ أَلَمۡ يَأۡتِكُمۡ رُسُلٞ مِّنكُمۡ يَقُصُّونَ عَلَيۡكُمۡ ءَايَٰتِي وَيُنذِرُونَكُمۡ لِقَآءَ يَوۡمِكُمۡ هَٰذَاۚ قَالُواْ شَهِدۡنَا عَلَىٰٓ أَنفُسِنَاۖ وَغَرَّتۡهُمُ ٱلۡحَيَوٰةُ ٱلدُّنۡيَا وَشَهِدُواْ عَلَىٰٓ أَنفُسِهِمۡ أَنَّهُمۡ كَانُواْ كَٰفِرِينَ",
    translation:
      'O company of jinn and mankind, did there not come to you messengers from among you, relating to you My verses and warning you of the meeting of this Day of yours?" They will say, "We bear witness against ourselves"; and the worldly life had deluded them, and they will bear witness against themselves that they were disbelievers',
    normalizedText:
      "يمعشر الجن والانس الم ياتكم رسل منكم يقصون عليكم ءايتي وينذرونكم لقاء يومكم هذا قالوا شهدنا على انفسنا وغرتهم الحيوة الدنيا وشهدوا على انفسهم انهم كانوا كفرين",
  },
  {
    verseId: 130,
    name: "الأنعام",
    surahId: 6,
    text: "ذَٰلِكَ أَن لَّمۡ يَكُن رَّبُّكَ مُهۡلِكَ ٱلۡقُرَىٰ بِظُلۡمٖ وَأَهۡلُهَا غَٰفِلُونَ",
    translation:
      "That is because your Lord would not destroy the cities for wrongdoing while their people were unaware",
    normalizedText: "ذلك ان لم يكن ربك مهلك القرى بظلم واهلها غفلون",
  },
  {
    verseId: 131,
    name: "الأنعام",
    surahId: 6,
    text: "وَلِكُلّٖ دَرَجَٰتٞ مِّمَّا عَمِلُواْۚ وَمَا رَبُّكَ بِغَٰفِلٍ عَمَّا يَعۡمَلُونَ",
    translation:
      "And for all are degrees from what they have done. And your Lord is not unaware of what they do",
    normalizedText: "ولكل درجت مما عملوا وما ربك بغفل عما يعملون",
  },
  {
    verseId: 132,
    name: "الأنعام",
    surahId: 6,
    text: "وَرَبُّكَ ٱلۡغَنِيُّ ذُو ٱلرَّحۡمَةِۚ إِن يَشَأۡ يُذۡهِبۡكُمۡ وَيَسۡتَخۡلِفۡ مِنۢ بَعۡدِكُم مَّا يَشَآءُ كَمَآ أَنشَأَكُم مِّن ذُرِّيَّةِ قَوۡمٍ ءَاخَرِينَ",
    translation:
      "And your Lord is the Free of need, the possessor of mercy. If He wills, he can do away with you and give succession after you to whomever He wills, just as He produced you from the descendants of another people",
    normalizedText:
      "وربك الغني ذو الرحمة ان يشا يذهبكم ويستخلف من بعدكم ما يشاء كما انشاكم من ذرية قوم ءاخرين",
  },
  {
    verseId: 133,
    name: "الأنعام",
    surahId: 6,
    text: "إِنَّ مَا تُوعَدُونَ لَأٓتٖۖ وَمَآ أَنتُم بِمُعۡجِزِينَ",
    translation:
      "Indeed, what you are promised is coming, and you will not cause failure [to Allah]",
    normalizedText: "ان ما توعدون لات وما انتم بمعجزين",
  },
  {
    verseId: 134,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ يَٰقَوۡمِ ٱعۡمَلُواْ عَلَىٰ مَكَانَتِكُمۡ إِنِّي عَامِلٞۖ فَسَوۡفَ تَعۡلَمُونَ مَن تَكُونُ لَهُۥ عَٰقِبَةُ ٱلدَّارِۚ إِنَّهُۥ لَا يُفۡلِحُ ٱلظَّـٰلِمُونَ",
    translation:
      'Say, "O my people, work according to your position; [for] indeed, I am working. And you are going to know who will have succession in the home. Indeed, the wrongdoers will not succeed',
    normalizedText:
      "قل يقوم اعملوا على مكانتكم اني عامل فسوف تعلمون من تكون له عقبة الدار انه لا يفلح الظلمون",
  },
  {
    verseId: 135,
    name: "الأنعام",
    surahId: 6,
    text: "وَجَعَلُواْ لِلَّهِ مِمَّا ذَرَأَ مِنَ ٱلۡحَرۡثِ وَٱلۡأَنۡعَٰمِ نَصِيبٗا فَقَالُواْ هَٰذَا لِلَّهِ بِزَعۡمِهِمۡ وَهَٰذَا لِشُرَكَآئِنَاۖ فَمَا كَانَ لِشُرَكَآئِهِمۡ فَلَا يَصِلُ إِلَى ٱللَّهِۖ وَمَا كَانَ لِلَّهِ فَهُوَ يَصِلُ إِلَىٰ شُرَكَآئِهِمۡۗ سَآءَ مَا يَحۡكُمُونَ",
    translation:
      'And the polytheists assign to Allah from that which He created of crops and livestock a share and say, "This is for Allah," by their claim, "and this is for our partners [associated with Him]." But what is for their "partners" does not reach Allah, while what is for Allah - this reaches their "partners." Evil is that which they rule',
    normalizedText:
      "وجعلوا لله مما ذرا من الحرث والانعم نصيبا فقالوا هذا لله بزعمهم وهذا لشركاانا فما كان لشركااهم فلا يصل الى الله وما كان لله فهو يصل الى شركااهم ساء ما يحكمون",
  },
  {
    verseId: 136,
    name: "الأنعام",
    surahId: 6,
    text: "وَكَذَٰلِكَ زَيَّنَ لِكَثِيرٖ مِّنَ ٱلۡمُشۡرِكِينَ قَتۡلَ أَوۡلَٰدِهِمۡ شُرَكَآؤُهُمۡ لِيُرۡدُوهُمۡ وَلِيَلۡبِسُواْ عَلَيۡهِمۡ دِينَهُمۡۖ وَلَوۡ شَآءَ ٱللَّهُ مَا فَعَلُوهُۖ فَذَرۡهُمۡ وَمَا يَفۡتَرُونَ",
    translation:
      "And likewise, to many of the polytheists their partners have made [to seem] pleasing the killing of their children in order to bring about their destruction and to cover them with confusion in their religion. And if Allah had willed, they would not have done so. So leave them and that which they invent",
    normalizedText:
      "وكذلك زين لكثير من المشركين قتل اولدهم شركااهم ليردوهم وليلبسوا عليهم دينهم ولو شاء الله ما فعلوه فذرهم وما يفترون",
  },
  {
    verseId: 137,
    name: "الأنعام",
    surahId: 6,
    text: "وَقَالُواْ هَٰذِهِۦٓ أَنۡعَٰمٞ وَحَرۡثٌ حِجۡرٞ لَّا يَطۡعَمُهَآ إِلَّا مَن نَّشَآءُ بِزَعۡمِهِمۡ وَأَنۡعَٰمٌ حُرِّمَتۡ ظُهُورُهَا وَأَنۡعَٰمٞ لَّا يَذۡكُرُونَ ٱسۡمَ ٱللَّهِ عَلَيۡهَا ٱفۡتِرَآءً عَلَيۡهِۚ سَيَجۡزِيهِم بِمَا كَانُواْ يَفۡتَرُونَ",
    translation:
      'And they say, "These animals and crops are forbidden; no one may eat from them except whom we will," by their claim. And there are those [camels] whose backs are forbidden [by them] and those upon which the name of Allah is not mentioned - [all of this] an invention of untruth about Him. He will punish them for what they were inventing',
    normalizedText:
      "وقالوا هذه انعم وحرث حجر لا يطعمها الا من نشاء بزعمهم وانعم حرمت ظهورها وانعم لا يذكرون اسم الله عليها افتراء عليه سيجزيهم بما كانوا يفترون",
  },
  {
    verseId: 138,
    name: "الأنعام",
    surahId: 6,
    text: "وَقَالُواْ مَا فِي بُطُونِ هَٰذِهِ ٱلۡأَنۡعَٰمِ خَالِصَةٞ لِّذُكُورِنَا وَمُحَرَّمٌ عَلَىٰٓ أَزۡوَٰجِنَاۖ وَإِن يَكُن مَّيۡتَةٗ فَهُمۡ فِيهِ شُرَكَآءُۚ سَيَجۡزِيهِمۡ وَصۡفَهُمۡۚ إِنَّهُۥ حَكِيمٌ عَلِيمٞ",
    translation:
      'And they say, "What is in the bellies of these animals is exclusively for our males and forbidden to our females. But if it is [born] dead, then all of them have shares therein." He will punish them for their description. Indeed, He is Wise and Knowing',
    normalizedText:
      "وقالوا ما في بطون هذه الانعم خالصة لذكورنا ومحرم على ازوجنا وان يكن ميتة فهم فيه شركاء سيجزيهم وصفهم انه حكيم عليم",
  },
  {
    verseId: 139,
    name: "الأنعام",
    surahId: 6,
    text: "قَدۡ خَسِرَ ٱلَّذِينَ قَتَلُوٓاْ أَوۡلَٰدَهُمۡ سَفَهَۢا بِغَيۡرِ عِلۡمٖ وَحَرَّمُواْ مَا رَزَقَهُمُ ٱللَّهُ ٱفۡتِرَآءً عَلَى ٱللَّهِۚ قَدۡ ضَلُّواْ وَمَا كَانُواْ مُهۡتَدِينَ",
    translation:
      "Those will have lost who killed their children in foolishness without knowledge and prohibited what Allah had provided for them, inventing untruth about Allah. They have gone astray and were not [rightly] guided",
    normalizedText:
      "قد خسر الذين قتلوا اولدهم سفها بغير علم وحرموا ما رزقهم الله افتراء على الله قد ضلوا وما كانوا مهتدين",
  },
  {
    verseId: 140,
    name: "الأنعام",
    surahId: 6,
    text: "۞وَهُوَ ٱلَّذِيٓ أَنشَأَ جَنَّـٰتٖ مَّعۡرُوشَٰتٖ وَغَيۡرَ مَعۡرُوشَٰتٖ وَٱلنَّخۡلَ وَٱلزَّرۡعَ مُخۡتَلِفًا أُكُلُهُۥ وَٱلزَّيۡتُونَ وَٱلرُّمَّانَ مُتَشَٰبِهٗا وَغَيۡرَ مُتَشَٰبِهٖۚ كُلُواْ مِن ثَمَرِهِۦٓ إِذَآ أَثۡمَرَ وَءَاتُواْ حَقَّهُۥ يَوۡمَ حَصَادِهِۦۖ وَلَا تُسۡرِفُوٓاْۚ إِنَّهُۥ لَا يُحِبُّ ٱلۡمُسۡرِفِينَ",
    translation:
      "And He it is who causes gardens to grow, [both] trellised and untrellised, and palm trees and crops of different [kinds of] food and olives and pomegranates, similar and dissimilar. Eat of [each of] its fruit when it yields and give its due [zakah] on the day of its harvest. And be not excessive. Indeed, He does not like those who commit excess",
    normalizedText:
      "۞وهو الذي انشا جنت معروشت وغير معروشت والنخل والزرع مختلفا اكله والزيتون والرمان متشبها وغير متشبه كلوا من ثمره اذا اثمر وءاتوا حقه يوم حصاده ولا تسرفوا انه لا يحب المسرفين",
  },
  {
    verseId: 141,
    name: "الأنعام",
    surahId: 6,
    text: "وَمِنَ ٱلۡأَنۡعَٰمِ حَمُولَةٗ وَفَرۡشٗاۚ كُلُواْ مِمَّا رَزَقَكُمُ ٱللَّهُ وَلَا تَتَّبِعُواْ خُطُوَٰتِ ٱلشَّيۡطَٰنِۚ إِنَّهُۥ لَكُمۡ عَدُوّٞ مُّبِينٞ",
    translation:
      "And of the grazing livestock are carriers [of burdens] and those [too] small. Eat of what Allah has provided for you and do not follow the footsteps of Satan. Indeed, he is to you a clear enemy",
    normalizedText:
      "ومن الانعم حمولة وفرشا كلوا مما رزقكم الله ولا تتبعوا خطوت الشيطن انه لكم عدو مبين",
  },
  {
    verseId: 142,
    name: "الأنعام",
    surahId: 6,
    text: "ثَمَٰنِيَةَ أَزۡوَٰجٖۖ مِّنَ ٱلضَّأۡنِ ٱثۡنَيۡنِ وَمِنَ ٱلۡمَعۡزِ ٱثۡنَيۡنِۗ قُلۡ ءَآلذَّكَرَيۡنِ حَرَّمَ أَمِ ٱلۡأُنثَيَيۡنِ أَمَّا ٱشۡتَمَلَتۡ عَلَيۡهِ أَرۡحَامُ ٱلۡأُنثَيَيۡنِۖ نَبِّـُٔونِي بِعِلۡمٍ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      '[They are] eight mates - of the sheep, two and of the goats, two. Say, "Is it the two males He has forbidden or the two females or that which the wombs of the two females contain? Inform me with knowledge, if you should be truthful',
    normalizedText:
      "ثمنية ازوج من الضان اثنين ومن المعز اثنين قل ءالذكرين حرم ام الانثيين اما اشتملت عليه ارحام الانثيين نبوني بعلم ان كنتم صدقين",
  },
  {
    verseId: 143,
    name: "الأنعام",
    surahId: 6,
    text: "وَمِنَ ٱلۡإِبِلِ ٱثۡنَيۡنِ وَمِنَ ٱلۡبَقَرِ ٱثۡنَيۡنِۗ قُلۡ ءَآلذَّكَرَيۡنِ حَرَّمَ أَمِ ٱلۡأُنثَيَيۡنِ أَمَّا ٱشۡتَمَلَتۡ عَلَيۡهِ أَرۡحَامُ ٱلۡأُنثَيَيۡنِۖ أَمۡ كُنتُمۡ شُهَدَآءَ إِذۡ وَصَّىٰكُمُ ٱللَّهُ بِهَٰذَاۚ فَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبٗا لِّيُضِلَّ ٱلنَّاسَ بِغَيۡرِ عِلۡمٍۚ إِنَّ ٱللَّهَ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      'And of the camels, two and of the cattle, two. Say, "Is it the two males He has forbidden or the two females or that which the wombs of the two females contain? Or were you witnesses when Allah charged you with this? Then who is more unjust than one who invents a lie about Allah to mislead the people by [something] other than knowledge? Indeed, Allah does not guide the wrongdoing people',
    normalizedText:
      "ومن الابل اثنين ومن البقر اثنين قل ءالذكرين حرم ام الانثيين اما اشتملت عليه ارحام الانثيين ام كنتم شهداء اذ وصىكم الله بهذا فمن اظلم ممن افترى على الله كذبا ليضل الناس بغير علم ان الله لا يهدي القوم الظلمين",
  },
  {
    verseId: 144,
    name: "الأنعام",
    surahId: 6,
    text: "قُل لَّآ أَجِدُ فِي مَآ أُوحِيَ إِلَيَّ مُحَرَّمًا عَلَىٰ طَاعِمٖ يَطۡعَمُهُۥٓ إِلَّآ أَن يَكُونَ مَيۡتَةً أَوۡ دَمٗا مَّسۡفُوحًا أَوۡ لَحۡمَ خِنزِيرٖ فَإِنَّهُۥ رِجۡسٌ أَوۡ فِسۡقًا أُهِلَّ لِغَيۡرِ ٱللَّهِ بِهِۦۚ فَمَنِ ٱضۡطُرَّ غَيۡرَ بَاغٖ وَلَا عَادٖ فَإِنَّ رَبَّكَ غَفُورٞ رَّحِيمٞ",
    translation:
      'Say, "I do not find within that which was revealed to me [anything] forbidden to one who would eat it unless it be a dead animal or blood spilled out or the flesh of swine - for indeed, it is impure - or it be [that slaughtered in] disobedience, dedicated to other than Allah. But whoever is forced [by necessity], neither desiring [it] nor transgressing [its limit], then indeed, your Lord is Forgiving and Merciful',
    normalizedText:
      "قل لا اجد في ما اوحي الي محرما على طاعم يطعمه الا ان يكون ميتة او دما مسفوحا او لحم خنزير فانه رجس او فسقا اهل لغير الله به فمن اضطر غير باغ ولا عاد فان ربك غفور رحيم",
  },
  {
    verseId: 145,
    name: "الأنعام",
    surahId: 6,
    text: "وَعَلَى ٱلَّذِينَ هَادُواْ حَرَّمۡنَا كُلَّ ذِي ظُفُرٖۖ وَمِنَ ٱلۡبَقَرِ وَٱلۡغَنَمِ حَرَّمۡنَا عَلَيۡهِمۡ شُحُومَهُمَآ إِلَّا مَا حَمَلَتۡ ظُهُورُهُمَآ أَوِ ٱلۡحَوَايَآ أَوۡ مَا ٱخۡتَلَطَ بِعَظۡمٖۚ ذَٰلِكَ جَزَيۡنَٰهُم بِبَغۡيِهِمۡۖ وَإِنَّا لَصَٰدِقُونَ",
    translation:
      "And to those who are Jews We prohibited every animal of uncloven hoof; and of the cattle and the sheep We prohibited to them their fat, except what adheres to their backs or the entrails or what is joined with bone. [By] that We repaid them for their injustice. And indeed, We are truthful",
    normalizedText:
      "وعلى الذين هادوا حرمنا كل ذي ظفر ومن البقر والغنم حرمنا عليهم شحومهما الا ما حملت ظهورهما او الحوايا او ما اختلط بعظم ذلك جزينهم ببغيهم وانا لصدقون",
  },
  {
    verseId: 146,
    name: "الأنعام",
    surahId: 6,
    text: "فَإِن كَذَّبُوكَ فَقُل رَّبُّكُمۡ ذُو رَحۡمَةٖ وَٰسِعَةٖ وَلَا يُرَدُّ بَأۡسُهُۥ عَنِ ٱلۡقَوۡمِ ٱلۡمُجۡرِمِينَ",
    translation:
      'So if they deny you, [O Muhammad], say, "Your Lord is the possessor of vast mercy; but His punishment cannot be repelled from the people who are criminals',
    normalizedText:
      "فان كذبوك فقل ربكم ذو رحمة وسعة ولا يرد باسه عن القوم المجرمين",
  },
  {
    verseId: 147,
    name: "الأنعام",
    surahId: 6,
    text: "سَيَقُولُ ٱلَّذِينَ أَشۡرَكُواْ لَوۡ شَآءَ ٱللَّهُ مَآ أَشۡرَكۡنَا وَلَآ ءَابَآؤُنَا وَلَا حَرَّمۡنَا مِن شَيۡءٖۚ كَذَٰلِكَ كَذَّبَ ٱلَّذِينَ مِن قَبۡلِهِمۡ حَتَّىٰ ذَاقُواْ بَأۡسَنَاۗ قُلۡ هَلۡ عِندَكُم مِّنۡ عِلۡمٖ فَتُخۡرِجُوهُ لَنَآۖ إِن تَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَإِنۡ أَنتُمۡ إِلَّا تَخۡرُصُونَ",
    translation:
      'Those who associated with Allah will say, "If Allah had willed, we would not have associated [anything] and neither would our fathers, nor would we have prohibited anything." Likewise did those before deny until they tasted Our punishment. Say, "Do you have any knowledge that you can produce for us? You follow not except assumption, and you are not but falsifying',
    normalizedText:
      "سيقول الذين اشركوا لو شاء الله ما اشركنا ولا ءاباانا ولا حرمنا من شيء كذلك كذب الذين من قبلهم حتى ذاقوا باسنا قل هل عندكم من علم فتخرجوه لنا ان تتبعون الا الظن وان انتم الا تخرصون",
  },
  {
    verseId: 148,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ فَلِلَّهِ ٱلۡحُجَّةُ ٱلۡبَٰلِغَةُۖ فَلَوۡ شَآءَ لَهَدَىٰكُمۡ أَجۡمَعِينَ",
    translation:
      'Say, "With Allah is the far-reaching argument. If He had willed, He would have guided you all',
    normalizedText: "قل فلله الحجة البلغة فلو شاء لهدىكم اجمعين",
  },
  {
    verseId: 149,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ هَلُمَّ شُهَدَآءَكُمُ ٱلَّذِينَ يَشۡهَدُونَ أَنَّ ٱللَّهَ حَرَّمَ هَٰذَاۖ فَإِن شَهِدُواْ فَلَا تَشۡهَدۡ مَعَهُمۡۚ وَلَا تَتَّبِعۡ أَهۡوَآءَ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا وَٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ وَهُم بِرَبِّهِمۡ يَعۡدِلُونَ",
    translation:
      'Say, [O Muhammad], "Bring forward your witnesses who will testify that Allah has prohibited this." And if they testify, do not testify with them. And do not follow the desires of those who deny Our verses and those who do not believe in the Hereafter, while they equate [others] with their Lord',
    normalizedText:
      "قل هلم شهداءكم الذين يشهدون ان الله حرم هذا فان شهدوا فلا تشهد معهم ولا تتبع اهواء الذين كذبوا بايتنا والذين لا يامنون بالاخرة وهم بربهم يعدلون",
  },
  {
    verseId: 150,
    name: "الأنعام",
    surahId: 6,
    text: "۞قُلۡ تَعَالَوۡاْ أَتۡلُ مَا حَرَّمَ رَبُّكُمۡ عَلَيۡكُمۡۖ أَلَّا تُشۡرِكُواْ بِهِۦ شَيۡـٔٗاۖ وَبِٱلۡوَٰلِدَيۡنِ إِحۡسَٰنٗاۖ وَلَا تَقۡتُلُوٓاْ أَوۡلَٰدَكُم مِّنۡ إِمۡلَٰقٖ نَّحۡنُ نَرۡزُقُكُمۡ وَإِيَّاهُمۡۖ وَلَا تَقۡرَبُواْ ٱلۡفَوَٰحِشَ مَا ظَهَرَ مِنۡهَا وَمَا بَطَنَۖ وَلَا تَقۡتُلُواْ ٱلنَّفۡسَ ٱلَّتِي حَرَّمَ ٱللَّهُ إِلَّا بِٱلۡحَقِّۚ ذَٰلِكُمۡ وَصَّىٰكُم بِهِۦ لَعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      'Say, "Come, I will recite what your Lord has prohibited to you. [He commands] that you not associate anything with Him, and to parents, good treatment, and do not kill your children out of poverty; We will provide for you and them. And do not approach immoralities - what is apparent of them and what is concealed. And do not kill the soul which Allah has forbidden [to be killed] except by [legal] right. This has He instructed you that you may use reason',
    normalizedText:
      "۞قل تعالوا اتل ما حرم ربكم عليكم الا تشركوا به شيا وبالولدين احسنا ولا تقتلوا اولدكم من املق نحن نرزقكم واياهم ولا تقربوا الفوحش ما ظهر منها وما بطن ولا تقتلوا النفس التي حرم الله الا بالحق ذلكم وصىكم به لعلكم تعقلون",
  },
  {
    verseId: 151,
    name: "الأنعام",
    surahId: 6,
    text: "وَلَا تَقۡرَبُواْ مَالَ ٱلۡيَتِيمِ إِلَّا بِٱلَّتِي هِيَ أَحۡسَنُ حَتَّىٰ يَبۡلُغَ أَشُدَّهُۥۚ وَأَوۡفُواْ ٱلۡكَيۡلَ وَٱلۡمِيزَانَ بِٱلۡقِسۡطِۖ لَا نُكَلِّفُ نَفۡسًا إِلَّا وُسۡعَهَاۖ وَإِذَا قُلۡتُمۡ فَٱعۡدِلُواْ وَلَوۡ كَانَ ذَا قُرۡبَىٰۖ وَبِعَهۡدِ ٱللَّهِ أَوۡفُواْۚ ذَٰلِكُمۡ وَصَّىٰكُم بِهِۦ لَعَلَّكُمۡ تَذَكَّرُونَ",
    translation:
      "And do not approach the orphan's property except in a way that is best until he reaches maturity. And give full measure and weight in justice. We do not charge any soul except [with that within] its capacity. And when you testify, be just, even if [it concerns] a near relative. And the covenant of Allah fulfill. This has He instructed you that you may remember",
    normalizedText:
      "ولا تقربوا مال اليتيم الا بالتي هي احسن حتى يبلغ اشده واوفوا الكيل والميزان بالقسط لا نكلف نفسا الا وسعها واذا قلتم فاعدلوا ولو كان ذا قربى وبعهد الله اوفوا ذلكم وصىكم به لعلكم تذكرون",
  },
  {
    verseId: 152,
    name: "الأنعام",
    surahId: 6,
    text: "وَأَنَّ هَٰذَا صِرَٰطِي مُسۡتَقِيمٗا فَٱتَّبِعُوهُۖ وَلَا تَتَّبِعُواْ ٱلسُّبُلَ فَتَفَرَّقَ بِكُمۡ عَن سَبِيلِهِۦۚ ذَٰلِكُمۡ وَصَّىٰكُم بِهِۦ لَعَلَّكُمۡ تَتَّقُونَ",
    translation:
      "And, [moreover], this is My path, which is straight, so follow it; and do not follow [other] ways, for you will be separated from His way. This has He instructed you that you may become righteous",
    normalizedText:
      "وان هذا صرطي مستقيما فاتبعوه ولا تتبعوا السبل فتفرق بكم عن سبيله ذلكم وصىكم به لعلكم تتقون",
  },
  {
    verseId: 153,
    name: "الأنعام",
    surahId: 6,
    text: "ثُمَّ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ تَمَامًا عَلَى ٱلَّذِيٓ أَحۡسَنَ وَتَفۡصِيلٗا لِّكُلِّ شَيۡءٖ وَهُدٗى وَرَحۡمَةٗ لَّعَلَّهُم بِلِقَآءِ رَبِّهِمۡ يُؤۡمِنُونَ",
    translation:
      "Then We gave Moses the Scripture, making complete [Our favor] upon the one who did good and as a detailed explanation of all things and as guidance and mercy that perhaps in [the matter of] the meeting with their Lord they would believe",
    normalizedText:
      "ثم ءاتينا موسى الكتب تماما على الذي احسن وتفصيلا لكل شيء وهدى ورحمة لعلهم بلقاء ربهم يامنون",
  },
  {
    verseId: 154,
    name: "الأنعام",
    surahId: 6,
    text: "وَهَٰذَا كِتَٰبٌ أَنزَلۡنَٰهُ مُبَارَكٞ فَٱتَّبِعُوهُ وَٱتَّقُواْ لَعَلَّكُمۡ تُرۡحَمُونَ",
    translation:
      "And this [Qur'an] is a Book We have revealed [which is] blessed, so follow it and fear Allah that you may receive mercy",
    normalizedText: "وهذا كتب انزلنه مبارك فاتبعوه واتقوا لعلكم ترحمون",
  },
  {
    verseId: 155,
    name: "الأنعام",
    surahId: 6,
    text: "أَن تَقُولُوٓاْ إِنَّمَآ أُنزِلَ ٱلۡكِتَٰبُ عَلَىٰ طَآئِفَتَيۡنِ مِن قَبۡلِنَا وَإِن كُنَّا عَن دِرَاسَتِهِمۡ لَغَٰفِلِينَ",
    translation:
      '[We revealed it] lest you say, "The Scripture was only sent down to two groups before us, but we were of their study unaware',
    normalizedText:
      "ان تقولوا انما انزل الكتب على طاافتين من قبلنا وان كنا عن دراستهم لغفلين",
  },
  {
    verseId: 156,
    name: "الأنعام",
    surahId: 6,
    text: "أَوۡ تَقُولُواْ لَوۡ أَنَّآ أُنزِلَ عَلَيۡنَا ٱلۡكِتَٰبُ لَكُنَّآ أَهۡدَىٰ مِنۡهُمۡۚ فَقَدۡ جَآءَكُم بَيِّنَةٞ مِّن رَّبِّكُمۡ وَهُدٗى وَرَحۡمَةٞۚ فَمَنۡ أَظۡلَمُ مِمَّن كَذَّبَ بِـَٔايَٰتِ ٱللَّهِ وَصَدَفَ عَنۡهَاۗ سَنَجۡزِي ٱلَّذِينَ يَصۡدِفُونَ عَنۡ ءَايَٰتِنَا سُوٓءَ ٱلۡعَذَابِ بِمَا كَانُواْ يَصۡدِفُونَ",
    translation:
      'Or lest you say, "If only the Scripture had been revealed to us, we would have been better guided than they." So there has [now] come to you a clear evidence from your Lord and a guidance and mercy. Then who is more unjust than one who denies the verses of Allah and turns away from them? We will recompense those who turn away from Our verses with the worst of punishment for their having turned away',
    normalizedText:
      "او تقولوا لو انا انزل علينا الكتب لكنا اهدى منهم فقد جاءكم بينة من ربكم وهدى ورحمة فمن اظلم ممن كذب بايت الله وصدف عنها سنجزي الذين يصدفون عن ءايتنا سوء العذاب بما كانوا يصدفون",
  },
  {
    verseId: 157,
    name: "الأنعام",
    surahId: 6,
    text: "هَلۡ يَنظُرُونَ إِلَّآ أَن تَأۡتِيَهُمُ ٱلۡمَلَـٰٓئِكَةُ أَوۡ يَأۡتِيَ رَبُّكَ أَوۡ يَأۡتِيَ بَعۡضُ ءَايَٰتِ رَبِّكَۗ يَوۡمَ يَأۡتِي بَعۡضُ ءَايَٰتِ رَبِّكَ لَا يَنفَعُ نَفۡسًا إِيمَٰنُهَا لَمۡ تَكُنۡ ءَامَنَتۡ مِن قَبۡلُ أَوۡ كَسَبَتۡ فِيٓ إِيمَٰنِهَا خَيۡرٗاۗ قُلِ ٱنتَظِرُوٓاْ إِنَّا مُنتَظِرُونَ",
    translation:
      'Do they [then] wait for anything except that the angels should come to them or your Lord should come or that there come some of the signs of your Lord? The Day that some of the signs of your Lord will come no soul will benefit from its faith as long as it had not believed before or had earned through its faith some good. Say, "Wait. Indeed, we [also] are waiting',
    normalizedText:
      "هل ينظرون الا ان تاتيهم الملاكة او ياتي ربك او ياتي بعض ءايت ربك يوم ياتي بعض ءايت ربك لا ينفع نفسا ايمنها لم تكن ءامنت من قبل او كسبت في ايمنها خيرا قل انتظروا انا منتظرون",
  },
  {
    verseId: 158,
    name: "الأنعام",
    surahId: 6,
    text: "إِنَّ ٱلَّذِينَ فَرَّقُواْ دِينَهُمۡ وَكَانُواْ شِيَعٗا لَّسۡتَ مِنۡهُمۡ فِي شَيۡءٍۚ إِنَّمَآ أَمۡرُهُمۡ إِلَى ٱللَّهِ ثُمَّ يُنَبِّئُهُم بِمَا كَانُواْ يَفۡعَلُونَ",
    translation:
      "Indeed, those who have divided their religion and become sects - you, [O Muhammad], are not [associated] with them in anything. Their affair is only [left] to Allah; then He will inform them about what they used to do",
    normalizedText:
      "ان الذين فرقوا دينهم وكانوا شيعا لست منهم في شيء انما امرهم الى الله ثم ينباهم بما كانوا يفعلون",
  },
  {
    verseId: 159,
    name: "الأنعام",
    surahId: 6,
    text: "مَن جَآءَ بِٱلۡحَسَنَةِ فَلَهُۥ عَشۡرُ أَمۡثَالِهَاۖ وَمَن جَآءَ بِٱلسَّيِّئَةِ فَلَا يُجۡزَىٰٓ إِلَّا مِثۡلَهَا وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "Whoever comes [on the Day of Judgement] with a good deed will have ten times the like thereof [to his credit], and whoever comes with an evil deed will not be recompensed except the like thereof; and they will not be wronged",
    normalizedText:
      "من جاء بالحسنة فله عشر امثالها ومن جاء بالسياة فلا يجزى الا مثلها وهم لا يظلمون",
  },
  {
    verseId: 160,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ إِنَّنِي هَدَىٰنِي رَبِّيٓ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ دِينٗا قِيَمٗا مِّلَّةَ إِبۡرَٰهِيمَ حَنِيفٗاۚ وَمَا كَانَ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      'Say, "Indeed, my Lord has guided me to a straight path - a correct religion - the way of Abraham, inclining toward truth. And he was not among those who associated others with Allah',
    normalizedText:
      "قل انني هدىني ربي الى صرط مستقيم دينا قيما ملة ابرهيم حنيفا وما كان من المشركين",
  },
  {
    verseId: 161,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ إِنَّ صَلَاتِي وَنُسُكِي وَمَحۡيَايَ وَمَمَاتِي لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'Say, "Indeed, my prayer, my rites of sacrifice, my living and my dying are for Allah, Lord of the worlds',
    normalizedText: "قل ان صلاتي ونسكي ومحياي ومماتي لله رب العلمين",
  },
  {
    verseId: 162,
    name: "الأنعام",
    surahId: 6,
    text: "لَا شَرِيكَ لَهُۥۖ وَبِذَٰلِكَ أُمِرۡتُ وَأَنَا۠ أَوَّلُ ٱلۡمُسۡلِمِينَ",
    translation:
      "No partner has He. And this I have been commanded, and I am the first [among you] of the Muslims",
    normalizedText: "لا شريك له وبذلك امرت وانا اول المسلمين",
  },
  {
    verseId: 163,
    name: "الأنعام",
    surahId: 6,
    text: "قُلۡ أَغَيۡرَ ٱللَّهِ أَبۡغِي رَبّٗا وَهُوَ رَبُّ كُلِّ شَيۡءٖۚ وَلَا تَكۡسِبُ كُلُّ نَفۡسٍ إِلَّا عَلَيۡهَاۚ وَلَا تَزِرُ وَازِرَةٞ وِزۡرَ أُخۡرَىٰۚ ثُمَّ إِلَىٰ رَبِّكُم مَّرۡجِعُكُمۡ فَيُنَبِّئُكُم بِمَا كُنتُمۡ فِيهِ تَخۡتَلِفُونَ",
    translation:
      'Say, "Is it other than Allah I should desire as a lord while He is the Lord of all things? And every soul earns not [blame] except against itself, and no bearer of burdens will bear the burden of another. Then to your Lord is your return, and He will inform you concerning that over which you used to differ',
    normalizedText:
      "قل اغير الله ابغي ربا وهو رب كل شيء ولا تكسب كل نفس الا عليها ولا تزر وازرة وزر اخرى ثم الى ربكم مرجعكم فينباكم بما كنتم فيه تختلفون",
  },
  {
    verseId: 164,
    name: "الأنعام",
    surahId: 6,
    text: "وَهُوَ ٱلَّذِي جَعَلَكُمۡ خَلَـٰٓئِفَ ٱلۡأَرۡضِ وَرَفَعَ بَعۡضَكُمۡ فَوۡقَ بَعۡضٖ دَرَجَٰتٖ لِّيَبۡلُوَكُمۡ فِي مَآ ءَاتَىٰكُمۡۗ إِنَّ رَبَّكَ سَرِيعُ ٱلۡعِقَابِ وَإِنَّهُۥ لَغَفُورٞ رَّحِيمُۢ",
    translation:
      "And it is He who has made you successors upon the earth and has raised some of you above others in degrees [of rank] that He may try you through what He has given you. Indeed, your Lord is swift in penalty; but indeed, He is Forgiving and Merciful",
    normalizedText:
      "وهو الذي جعلكم خلاف الارض ورفع بعضكم فوق بعض درجت ليبلوكم في ما ءاتىكم ان ربك سريع العقاب وانه لغفور رحيم",
  },
  {
    verseId: 0,
    name: "الأعراف",
    surahId: 7,
    text: "الٓمٓصٓ",
    translation: "Alif, Lam, Meem, Sad",
    normalizedText: "المص",
  },
  {
    verseId: 1,
    name: "الأعراف",
    surahId: 7,
    text: "كِتَٰبٌ أُنزِلَ إِلَيۡكَ فَلَا يَكُن فِي صَدۡرِكَ حَرَجٞ مِّنۡهُ لِتُنذِرَ بِهِۦ وَذِكۡرَىٰ لِلۡمُؤۡمِنِينَ",
    translation:
      "[This is] a Book revealed to you, [O Muhammad] - so let there not be in your breast distress therefrom - that you may warn thereby and as a reminder to the believers",
    normalizedText:
      "كتب انزل اليك فلا يكن في صدرك حرج منه لتنذر به وذكرى للمامنين",
  },
  {
    verseId: 2,
    name: "الأعراف",
    surahId: 7,
    text: "ٱتَّبِعُواْ مَآ أُنزِلَ إِلَيۡكُم مِّن رَّبِّكُمۡ وَلَا تَتَّبِعُواْ مِن دُونِهِۦٓ أَوۡلِيَآءَۗ قَلِيلٗا مَّا تَذَكَّرُونَ",
    translation:
      "Follow, [O mankind], what has been revealed to you from your Lord and do not follow other than Him any allies. Little do you remember",
    normalizedText:
      "اتبعوا ما انزل اليكم من ربكم ولا تتبعوا من دونه اولياء قليلا ما تذكرون",
  },
  {
    verseId: 3,
    name: "الأعراف",
    surahId: 7,
    text: "وَكَم مِّن قَرۡيَةٍ أَهۡلَكۡنَٰهَا فَجَآءَهَا بَأۡسُنَا بَيَٰتًا أَوۡ هُمۡ قَآئِلُونَ",
    translation:
      "And how many cities have We destroyed, and Our punishment came to them at night or while they were sleeping at noon",
    normalizedText: "وكم من قرية اهلكنها فجاءها باسنا بيتا او هم قاالون",
  },
  {
    verseId: 4,
    name: "الأعراف",
    surahId: 7,
    text: "فَمَا كَانَ دَعۡوَىٰهُمۡ إِذۡ جَآءَهُم بَأۡسُنَآ إِلَّآ أَن قَالُوٓاْ إِنَّا كُنَّا ظَٰلِمِينَ",
    translation:
      'And their declaration when Our punishment came to them was only that they said, "Indeed, we were wrongdoers',
    normalizedText: "فما كان دعوىهم اذ جاءهم باسنا الا ان قالوا انا كنا ظلمين",
  },
  {
    verseId: 5,
    name: "الأعراف",
    surahId: 7,
    text: "فَلَنَسۡـَٔلَنَّ ٱلَّذِينَ أُرۡسِلَ إِلَيۡهِمۡ وَلَنَسۡـَٔلَنَّ ٱلۡمُرۡسَلِينَ",
    translation:
      "Then We will surely question those to whom [a message] was sent, and We will surely question the messengers",
    normalizedText: "فلنسلن الذين ارسل اليهم ولنسلن المرسلين",
  },
  {
    verseId: 6,
    name: "الأعراف",
    surahId: 7,
    text: "فَلَنَقُصَّنَّ عَلَيۡهِم بِعِلۡمٖۖ وَمَا كُنَّا غَآئِبِينَ",
    translation:
      "Then We will surely relate [their deeds] to them with knowledge, and We were not [at all] absent",
    normalizedText: "فلنقصن عليهم بعلم وما كنا غاابين",
  },
  {
    verseId: 7,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلۡوَزۡنُ يَوۡمَئِذٍ ٱلۡحَقُّۚ فَمَن ثَقُلَتۡ مَوَٰزِينُهُۥ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "And the weighing [of deeds] that Day will be the truth. So those whose scales are heavy - it is they who will be the successful",
    normalizedText: "والوزن يوماذ الحق فمن ثقلت موزينه فاولاك هم المفلحون",
  },
  {
    verseId: 8,
    name: "الأعراف",
    surahId: 7,
    text: "وَمَنۡ خَفَّتۡ مَوَٰزِينُهُۥ فَأُوْلَـٰٓئِكَ ٱلَّذِينَ خَسِرُوٓاْ أَنفُسَهُم بِمَا كَانُواْ بِـَٔايَٰتِنَا يَظۡلِمُونَ",
    translation:
      "And those whose scales are light - they are the ones who will lose themselves for what injustice they were doing toward Our verses",
    normalizedText:
      "ومن خفت موزينه فاولاك الذين خسروا انفسهم بما كانوا بايتنا يظلمون",
  },
  {
    verseId: 9,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَقَدۡ مَكَّنَّـٰكُمۡ فِي ٱلۡأَرۡضِ وَجَعَلۡنَا لَكُمۡ فِيهَا مَعَٰيِشَۗ قَلِيلٗا مَّا تَشۡكُرُونَ",
    translation:
      "And We have certainly established you upon the earth and made for you therein ways of livelihood. Little are you grateful",
    normalizedText: "ولقد مكنكم في الارض وجعلنا لكم فيها معيش قليلا ما تشكرون",
  },
  {
    verseId: 10,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَقَدۡ خَلَقۡنَٰكُمۡ ثُمَّ صَوَّرۡنَٰكُمۡ ثُمَّ قُلۡنَا لِلۡمَلَـٰٓئِكَةِ ٱسۡجُدُواْ لِأٓدَمَ فَسَجَدُوٓاْ إِلَّآ إِبۡلِيسَ لَمۡ يَكُن مِّنَ ٱلسَّـٰجِدِينَ",
    translation:
      'And We have certainly created you, [O Mankind], and given you [human] form. Then We said to the angels, "Prostrate to Adam"; so they prostrated, except for Iblees. He was not of those who prostrated',
    normalizedText:
      "ولقد خلقنكم ثم صورنكم ثم قلنا للملاكة اسجدوا لادم فسجدوا الا ابليس لم يكن من السجدين",
  },
  {
    verseId: 11,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ مَا مَنَعَكَ أَلَّا تَسۡجُدَ إِذۡ أَمَرۡتُكَۖ قَالَ أَنَا۠ خَيۡرٞ مِّنۡهُ خَلَقۡتَنِي مِن نَّارٖ وَخَلَقۡتَهُۥ مِن طِينٖ",
    translation:
      '[Allah] said, "What prevented you from prostrating when I commanded you?" [Satan] said, "I am better than him. You created me from fire and created him from clay',
    normalizedText:
      "قال ما منعك الا تسجد اذ امرتك قال انا خير منه خلقتني من نار وخلقته من طين",
  },
  {
    verseId: 12,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ فَٱهۡبِطۡ مِنۡهَا فَمَا يَكُونُ لَكَ أَن تَتَكَبَّرَ فِيهَا فَٱخۡرُجۡ إِنَّكَ مِنَ ٱلصَّـٰغِرِينَ",
    translation:
      '[Allah] said, "Descend from Paradise, for it is not for you to be arrogant therein. So get out; indeed, you are of the debased',
    normalizedText:
      "قال فاهبط منها فما يكون لك ان تتكبر فيها فاخرج انك من الصغرين",
  },
  {
    verseId: 13,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ أَنظِرۡنِيٓ إِلَىٰ يَوۡمِ يُبۡعَثُونَ",
    translation:
      '[Satan] said, "Reprieve me until the Day they are resurrected',
    normalizedText: "قال انظرني الى يوم يبعثون",
  },
  {
    verseId: 14,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ إِنَّكَ مِنَ ٱلۡمُنظَرِينَ",
    translation: '[Allah] said, "Indeed, you are of those reprieved',
    normalizedText: "قال انك من المنظرين",
  },
  {
    verseId: 15,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ فَبِمَآ أَغۡوَيۡتَنِي لَأَقۡعُدَنَّ لَهُمۡ صِرَٰطَكَ ٱلۡمُسۡتَقِيمَ",
    translation:
      '[Satan] said, "Because You have put me in error, I will surely sit in wait for them on Your straight path',
    normalizedText: "قال فبما اغويتني لاقعدن لهم صرطك المستقيم",
  },
  {
    verseId: 16,
    name: "الأعراف",
    surahId: 7,
    text: "ثُمَّ لَأٓتِيَنَّهُم مِّنۢ بَيۡنِ أَيۡدِيهِمۡ وَمِنۡ خَلۡفِهِمۡ وَعَنۡ أَيۡمَٰنِهِمۡ وَعَن شَمَآئِلِهِمۡۖ وَلَا تَجِدُ أَكۡثَرَهُمۡ شَٰكِرِينَ",
    translation:
      "Then I will come to them from before them and from behind them and on their right and on their left, and You will not find most of them grateful [to You]",
    normalizedText:
      "ثم لاتينهم من بين ايديهم ومن خلفهم وعن ايمنهم وعن شماالهم ولا تجد اكثرهم شكرين",
  },
  {
    verseId: 17,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱخۡرُجۡ مِنۡهَا مَذۡءُومٗا مَّدۡحُورٗاۖ لَّمَن تَبِعَكَ مِنۡهُمۡ لَأَمۡلَأَنَّ جَهَنَّمَ مِنكُمۡ أَجۡمَعِينَ",
    translation:
      '[Allah] said, "Get out of Paradise, reproached and expelled. Whoever follows you among them - I will surely fill Hell with you, all together',
    normalizedText:
      "قال اخرج منها مذءوما مدحورا لمن تبعك منهم لاملان جهنم منكم اجمعين",
  },
  {
    verseId: 18,
    name: "الأعراف",
    surahId: 7,
    text: "وَيَـٰٓـَٔادَمُ ٱسۡكُنۡ أَنتَ وَزَوۡجُكَ ٱلۡجَنَّةَ فَكُلَا مِنۡ حَيۡثُ شِئۡتُمَا وَلَا تَقۡرَبَا هَٰذِهِ ٱلشَّجَرَةَ فَتَكُونَا مِنَ ٱلظَّـٰلِمِينَ",
    translation:
      'And "O Adam, dwell, you and your wife, in Paradise and eat from wherever you will but do not approach this tree, lest you be among the wrongdoers',
    normalizedText:
      "ويادم اسكن انت وزوجك الجنة فكلا من حيث شاتما ولا تقربا هذه الشجرة فتكونا من الظلمين",
  },
  {
    verseId: 19,
    name: "الأعراف",
    surahId: 7,
    text: "فَوَسۡوَسَ لَهُمَا ٱلشَّيۡطَٰنُ لِيُبۡدِيَ لَهُمَا مَا وُۥرِيَ عَنۡهُمَا مِن سَوۡءَٰتِهِمَا وَقَالَ مَا نَهَىٰكُمَا رَبُّكُمَا عَنۡ هَٰذِهِ ٱلشَّجَرَةِ إِلَّآ أَن تَكُونَا مَلَكَيۡنِ أَوۡ تَكُونَا مِنَ ٱلۡخَٰلِدِينَ",
    translation:
      'But Satan whispered to them to make apparent to them that which was concealed from them of their private parts. He said, "Your Lord did not forbid you this tree except that you become angels or become of the immortal',
    normalizedText:
      "فوسوس لهما الشيطن ليبدي لهما ما وري عنهما من سوءتهما وقال ما نهىكما ربكما عن هذه الشجرة الا ان تكونا ملكين او تكونا من الخلدين",
  },
  {
    verseId: 20,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَاسَمَهُمَآ إِنِّي لَكُمَا لَمِنَ ٱلنَّـٰصِحِينَ",
    translation:
      'And he swore [by Allah] to them, "Indeed, I am to you from among the sincere advisors',
    normalizedText: "وقاسمهما اني لكما لمن النصحين",
  },
  {
    verseId: 21,
    name: "الأعراف",
    surahId: 7,
    text: "فَدَلَّىٰهُمَا بِغُرُورٖۚ فَلَمَّا ذَاقَا ٱلشَّجَرَةَ بَدَتۡ لَهُمَا سَوۡءَٰتُهُمَا وَطَفِقَا يَخۡصِفَانِ عَلَيۡهِمَا مِن وَرَقِ ٱلۡجَنَّةِۖ وَنَادَىٰهُمَا رَبُّهُمَآ أَلَمۡ أَنۡهَكُمَا عَن تِلۡكُمَا ٱلشَّجَرَةِ وَأَقُل لَّكُمَآ إِنَّ ٱلشَّيۡطَٰنَ لَكُمَا عَدُوّٞ مُّبِينٞ",
    translation:
      'So he made them fall, through deception. And when they tasted of the tree, their private parts became apparent to them, and they began to fasten together over themselves from the leaves of Paradise. And their Lord called to them, "Did I not forbid you from that tree and tell you that Satan is to you a clear enemy',
    normalizedText:
      "فدلىهما بغرور فلما ذاقا الشجرة بدت لهما سوءتهما وطفقا يخصفان عليهما من ورق الجنة ونادىهما ربهما الم انهكما عن تلكما الشجرة واقل لكما ان الشيطن لكما عدو مبين",
  },
  {
    verseId: 22,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَا رَبَّنَا ظَلَمۡنَآ أَنفُسَنَا وَإِن لَّمۡ تَغۡفِرۡ لَنَا وَتَرۡحَمۡنَا لَنَكُونَنَّ مِنَ ٱلۡخَٰسِرِينَ",
    translation:
      'They said, "Our Lord, we have wronged ourselves, and if You do not forgive us and have mercy upon us, we will surely be among the losers',
    normalizedText:
      "قالا ربنا ظلمنا انفسنا وان لم تغفر لنا وترحمنا لنكونن من الخسرين",
  },
  {
    verseId: 23,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱهۡبِطُواْ بَعۡضُكُمۡ لِبَعۡضٍ عَدُوّٞۖ وَلَكُمۡ فِي ٱلۡأَرۡضِ مُسۡتَقَرّٞ وَمَتَٰعٌ إِلَىٰ حِينٖ",
    translation:
      '[Allah] said, "Descend, being to one another enemies. And for you on the earth is a place of settlement and enjoyment for a time',
    normalizedText:
      "قال اهبطوا بعضكم لبعض عدو ولكم في الارض مستقر ومتع الى حين",
  },
  {
    verseId: 24,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ فِيهَا تَحۡيَوۡنَ وَفِيهَا تَمُوتُونَ وَمِنۡهَا تُخۡرَجُونَ",
    translation:
      'He said, "Therein you will live, and therein you will die, and from it you will be brought forth',
    normalizedText: "قال فيها تحيون وفيها تموتون ومنها تخرجون",
  },
  {
    verseId: 25,
    name: "الأعراف",
    surahId: 7,
    text: "يَٰبَنِيٓ ءَادَمَ قَدۡ أَنزَلۡنَا عَلَيۡكُمۡ لِبَاسٗا يُوَٰرِي سَوۡءَٰتِكُمۡ وَرِيشٗاۖ وَلِبَاسُ ٱلتَّقۡوَىٰ ذَٰلِكَ خَيۡرٞۚ ذَٰلِكَ مِنۡ ءَايَٰتِ ٱللَّهِ لَعَلَّهُمۡ يَذَّكَّرُونَ",
    translation:
      "O children of Adam, We have bestowed upon you clothing to conceal your private parts and as adornment. But the clothing of righteousness - that is best. That is from the signs of Allah that perhaps they will remember",
    normalizedText:
      "يبني ءادم قد انزلنا عليكم لباسا يوري سوءتكم وريشا ولباس التقوى ذلك خير ذلك من ءايت الله لعلهم يذكرون",
  },
  {
    verseId: 26,
    name: "الأعراف",
    surahId: 7,
    text: "يَٰبَنِيٓ ءَادَمَ لَا يَفۡتِنَنَّكُمُ ٱلشَّيۡطَٰنُ كَمَآ أَخۡرَجَ أَبَوَيۡكُم مِّنَ ٱلۡجَنَّةِ يَنزِعُ عَنۡهُمَا لِبَاسَهُمَا لِيُرِيَهُمَا سَوۡءَٰتِهِمَآۚ إِنَّهُۥ يَرَىٰكُمۡ هُوَ وَقَبِيلُهُۥ مِنۡ حَيۡثُ لَا تَرَوۡنَهُمۡۗ إِنَّا جَعَلۡنَا ٱلشَّيَٰطِينَ أَوۡلِيَآءَ لِلَّذِينَ لَا يُؤۡمِنُونَ",
    translation:
      "O children of Adam, let not Satan tempt you as he removed your parents from Paradise, stripping them of their clothing to show them their private parts. Indeed, he sees you, he and his tribe, from where you do not see them. Indeed, We have made the devils allies to those who do not believe",
    normalizedText:
      "يبني ءادم لا يفتننكم الشيطن كما اخرج ابويكم من الجنة ينزع عنهما لباسهما ليريهما سوءتهما انه يرىكم هو وقبيله من حيث لا ترونهم انا جعلنا الشيطين اولياء للذين لا يامنون",
  },
  {
    verseId: 27,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذَا فَعَلُواْ فَٰحِشَةٗ قَالُواْ وَجَدۡنَا عَلَيۡهَآ ءَابَآءَنَا وَٱللَّهُ أَمَرَنَا بِهَاۗ قُلۡ إِنَّ ٱللَّهَ لَا يَأۡمُرُ بِٱلۡفَحۡشَآءِۖ أَتَقُولُونَ عَلَى ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      'And when they commit an immorality, they say, "We found our fathers doing it, and Allah has ordered us to do it." Say, "Indeed, Allah does not order immorality. Do you say about Allah that which you do not know',
    normalizedText:
      "واذا فعلوا فحشة قالوا وجدنا عليها ءاباءنا والله امرنا بها قل ان الله لا يامر بالفحشاء اتقولون على الله ما لا تعلمون",
  },
  {
    verseId: 28,
    name: "الأعراف",
    surahId: 7,
    text: "قُلۡ أَمَرَ رَبِّي بِٱلۡقِسۡطِۖ وَأَقِيمُواْ وُجُوهَكُمۡ عِندَ كُلِّ مَسۡجِدٖ وَٱدۡعُوهُ مُخۡلِصِينَ لَهُ ٱلدِّينَۚ كَمَا بَدَأَكُمۡ تَعُودُونَ",
    translation:
      'Say, [O Muhammad], "My Lord has ordered justice and that you maintain yourselves [in worship of Him] at every place [or time] of prostration, and invoke Him, sincere to Him in religion." Just as He originated you, you will return [to life]',
    normalizedText:
      "قل امر ربي بالقسط واقيموا وجوهكم عند كل مسجد وادعوه مخلصين له الدين كما بداكم تعودون",
  },
  {
    verseId: 29,
    name: "الأعراف",
    surahId: 7,
    text: "فَرِيقًا هَدَىٰ وَفَرِيقًا حَقَّ عَلَيۡهِمُ ٱلضَّلَٰلَةُۚ إِنَّهُمُ ٱتَّخَذُواْ ٱلشَّيَٰطِينَ أَوۡلِيَآءَ مِن دُونِ ٱللَّهِ وَيَحۡسَبُونَ أَنَّهُم مُّهۡتَدُونَ",
    translation:
      "A group [of you] He guided, and a group deserved [to be in] error. Indeed, they had taken the devils as allies instead of Allah while they thought that they were guided",
    normalizedText:
      "فريقا هدى وفريقا حق عليهم الضللة انهم اتخذوا الشيطين اولياء من دون الله ويحسبون انهم مهتدون",
  },
  {
    verseId: 30,
    name: "الأعراف",
    surahId: 7,
    text: "۞يَٰبَنِيٓ ءَادَمَ خُذُواْ زِينَتَكُمۡ عِندَ كُلِّ مَسۡجِدٖ وَكُلُواْ وَٱشۡرَبُواْ وَلَا تُسۡرِفُوٓاْۚ إِنَّهُۥ لَا يُحِبُّ ٱلۡمُسۡرِفِينَ",
    translation:
      "O children of Adam, take your adornment at every masjid, and eat and drink, but be not excessive. Indeed, He likes not those who commit excess",
    normalizedText:
      "۞يبني ءادم خذوا زينتكم عند كل مسجد وكلوا واشربوا ولا تسرفوا انه لا يحب المسرفين",
  },
  {
    verseId: 31,
    name: "الأعراف",
    surahId: 7,
    text: "قُلۡ مَنۡ حَرَّمَ زِينَةَ ٱللَّهِ ٱلَّتِيٓ أَخۡرَجَ لِعِبَادِهِۦ وَٱلطَّيِّبَٰتِ مِنَ ٱلرِّزۡقِۚ قُلۡ هِيَ لِلَّذِينَ ءَامَنُواْ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا خَالِصَةٗ يَوۡمَ ٱلۡقِيَٰمَةِۗ كَذَٰلِكَ نُفَصِّلُ ٱلۡأٓيَٰتِ لِقَوۡمٖ يَعۡلَمُونَ",
    translation:
      'Say, "Who has forbidden the adornment of Allah which He has produced for His servants and the good [lawful] things of provision?" Say, "They are for those who believe during the worldly life [but] exclusively for them on the Day of Resurrection." Thus do We detail the verses for a people who know',
    normalizedText:
      "قل من حرم زينة الله التي اخرج لعباده والطيبت من الرزق قل هي للذين ءامنوا في الحيوة الدنيا خالصة يوم القيمة كذلك نفصل الايت لقوم يعلمون",
  },
  {
    verseId: 32,
    name: "الأعراف",
    surahId: 7,
    text: "قُلۡ إِنَّمَا حَرَّمَ رَبِّيَ ٱلۡفَوَٰحِشَ مَا ظَهَرَ مِنۡهَا وَمَا بَطَنَ وَٱلۡإِثۡمَ وَٱلۡبَغۡيَ بِغَيۡرِ ٱلۡحَقِّ وَأَن تُشۡرِكُواْ بِٱللَّهِ مَا لَمۡ يُنَزِّلۡ بِهِۦ سُلۡطَٰنٗا وَأَن تَقُولُواْ عَلَى ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      'Say, "My Lord has only forbidden immoralities - what is apparent of them and what is concealed - and sin, and oppression without right, and that you associate with Allah that for which He has not sent down authority, and that you say about Allah that which you do not know',
    normalizedText:
      "قل انما حرم ربي الفوحش ما ظهر منها وما بطن والاثم والبغي بغير الحق وان تشركوا بالله ما لم ينزل به سلطنا وان تقولوا على الله ما لا تعلمون",
  },
  {
    verseId: 33,
    name: "الأعراف",
    surahId: 7,
    text: "وَلِكُلِّ أُمَّةٍ أَجَلٞۖ فَإِذَا جَآءَ أَجَلُهُمۡ لَا يَسۡتَأۡخِرُونَ سَاعَةٗ وَلَا يَسۡتَقۡدِمُونَ",
    translation:
      "And for every nation is a [specified] term. So when their time has come, they will not remain behind an hour, nor will they precede [it]",
    normalizedText: "ولكل امة اجل فاذا جاء اجلهم لا يستاخرون ساعة ولا يستقدمون",
  },
  {
    verseId: 34,
    name: "الأعراف",
    surahId: 7,
    text: "يَٰبَنِيٓ ءَادَمَ إِمَّا يَأۡتِيَنَّكُمۡ رُسُلٞ مِّنكُمۡ يَقُصُّونَ عَلَيۡكُمۡ ءَايَٰتِي فَمَنِ ٱتَّقَىٰ وَأَصۡلَحَ فَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "O children of Adam, if there come to you messengers from among you relating to you My verses, then whoever fears Allah and reforms - there will be no fear concerning them, nor will they grieve",
    normalizedText:
      "يبني ءادم اما ياتينكم رسل منكم يقصون عليكم ءايتي فمن اتقى واصلح فلا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 35,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا وَٱسۡتَكۡبَرُواْ عَنۡهَآ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "But the ones who deny Our verses and are arrogant toward them - those are the companions of the Fire; they will abide therein eternally",
    normalizedText:
      "والذين كذبوا بايتنا واستكبروا عنها اولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 36,
    name: "الأعراف",
    surahId: 7,
    text: "فَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوۡ كَذَّبَ بِـَٔايَٰتِهِۦٓۚ أُوْلَـٰٓئِكَ يَنَالُهُمۡ نَصِيبُهُم مِّنَ ٱلۡكِتَٰبِۖ حَتَّىٰٓ إِذَا جَآءَتۡهُمۡ رُسُلُنَا يَتَوَفَّوۡنَهُمۡ قَالُوٓاْ أَيۡنَ مَا كُنتُمۡ تَدۡعُونَ مِن دُونِ ٱللَّهِۖ قَالُواْ ضَلُّواْ عَنَّا وَشَهِدُواْ عَلَىٰٓ أَنفُسِهِمۡ أَنَّهُمۡ كَانُواْ كَٰفِرِينَ",
    translation:
      'And who is more unjust than one who invents about Allah a lie or denies His verses? Those will attain their portion of the decree until when Our messengers come to them to take them in death, they will say, "Where are those you used to invoke besides Allah?" They will say, "They have departed from us," and will bear witness against themselves that they were disbelievers',
    normalizedText:
      "فمن اظلم ممن افترى على الله كذبا او كذب بايته اولاك ينالهم نصيبهم من الكتب حتى اذا جاءتهم رسلنا يتوفونهم قالوا اين ما كنتم تدعون من دون الله قالوا ضلوا عنا وشهدوا على انفسهم انهم كانوا كفرين",
  },
  {
    verseId: 37,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱدۡخُلُواْ فِيٓ أُمَمٖ قَدۡ خَلَتۡ مِن قَبۡلِكُم مِّنَ ٱلۡجِنِّ وَٱلۡإِنسِ فِي ٱلنَّارِۖ كُلَّمَا دَخَلَتۡ أُمَّةٞ لَّعَنَتۡ أُخۡتَهَاۖ حَتَّىٰٓ إِذَا ٱدَّارَكُواْ فِيهَا جَمِيعٗا قَالَتۡ أُخۡرَىٰهُمۡ لِأُولَىٰهُمۡ رَبَّنَا هَـٰٓؤُلَآءِ أَضَلُّونَا فَـَٔاتِهِمۡ عَذَابٗا ضِعۡفٗا مِّنَ ٱلنَّارِۖ قَالَ لِكُلّٖ ضِعۡفٞ وَلَٰكِن لَّا تَعۡلَمُونَ",
    translation:
      '[Allah] will say, "Enter among nations which had passed on before you of jinn and mankind into the Fire." Every time a nation enters, it will curse its sister until, when they have all overtaken one another therein, the last of them will say about the first of them "Our Lord, these had misled us, so give them a double punishment of the Fire. He will say, "For each is double, but you do not know',
    normalizedText:
      "قال ادخلوا في امم قد خلت من قبلكم من الجن والانس في النار كلما دخلت امة لعنت اختها حتى اذا اداركوا فيها جميعا قالت اخرىهم لاولىهم ربنا هالاء اضلونا فاتهم عذابا ضعفا من النار قال لكل ضعف ولكن لا تعلمون",
  },
  {
    verseId: 38,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَالَتۡ أُولَىٰهُمۡ لِأُخۡرَىٰهُمۡ فَمَا كَانَ لَكُمۡ عَلَيۡنَا مِن فَضۡلٖ فَذُوقُواْ ٱلۡعَذَابَ بِمَا كُنتُمۡ تَكۡسِبُونَ",
    translation:
      'And the first of them will say to the last of them, "Then you had not any favor over us, so taste the punishment for what you used to earn',
    normalizedText:
      "وقالت اولىهم لاخرىهم فما كان لكم علينا من فضل فذوقوا العذاب بما كنتم تكسبون",
  },
  {
    verseId: 39,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا وَٱسۡتَكۡبَرُواْ عَنۡهَا لَا تُفَتَّحُ لَهُمۡ أَبۡوَٰبُ ٱلسَّمَآءِ وَلَا يَدۡخُلُونَ ٱلۡجَنَّةَ حَتَّىٰ يَلِجَ ٱلۡجَمَلُ فِي سَمِّ ٱلۡخِيَاطِۚ وَكَذَٰلِكَ نَجۡزِي ٱلۡمُجۡرِمِينَ",
    translation:
      "Indeed, those who deny Our verses and are arrogant toward them - the gates of Heaven will not be opened for them, nor will they enter Paradise until a camel enters into the eye of a needle. And thus do We recompense the criminals",
    normalizedText:
      "ان الذين كذبوا بايتنا واستكبروا عنها لا تفتح لهم ابوب السماء ولا يدخلون الجنة حتى يلج الجمل في سم الخياط وكذلك نجزي المجرمين",
  },
  {
    verseId: 40,
    name: "الأعراف",
    surahId: 7,
    text: "لَهُم مِّن جَهَنَّمَ مِهَادٞ وَمِن فَوۡقِهِمۡ غَوَاشٖۚ وَكَذَٰلِكَ نَجۡزِي ٱلظَّـٰلِمِينَ",
    translation:
      "They will have from Hell a bed and over them coverings [of fire]. And thus do We recompense the wrongdoers",
    normalizedText: "لهم من جهنم مهاد ومن فوقهم غواش وكذلك نجزي الظلمين",
  },
  {
    verseId: 41,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَا نُكَلِّفُ نَفۡسًا إِلَّا وُسۡعَهَآ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَنَّةِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "But those who believed and did righteous deeds - We charge no soul except [within] its capacity. Those are the companions of Paradise; they will abide therein eternally",
    normalizedText:
      "والذين ءامنوا وعملوا الصلحت لا نكلف نفسا الا وسعها اولاك اصحب الجنة هم فيها خلدون",
  },
  {
    verseId: 42,
    name: "الأعراف",
    surahId: 7,
    text: "وَنَزَعۡنَا مَا فِي صُدُورِهِم مِّنۡ غِلّٖ تَجۡرِي مِن تَحۡتِهِمُ ٱلۡأَنۡهَٰرُۖ وَقَالُواْ ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي هَدَىٰنَا لِهَٰذَا وَمَا كُنَّا لِنَهۡتَدِيَ لَوۡلَآ أَنۡ هَدَىٰنَا ٱللَّهُۖ لَقَدۡ جَآءَتۡ رُسُلُ رَبِّنَا بِٱلۡحَقِّۖ وَنُودُوٓاْ أَن تِلۡكُمُ ٱلۡجَنَّةُ أُورِثۡتُمُوهَا بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'And We will have removed whatever is within their breasts of resentment, [while] flowing beneath them are rivers. And they will say, "Praise to Allah, who has guided us to this; and we would never have been guided if Allah had not guided us. Certainly the messengers of our Lord had come with the truth." And they will be called, "This is Paradise, which you have been made to inherit for what you used to do',
    normalizedText:
      "ونزعنا ما في صدورهم من غل تجري من تحتهم الانهر وقالوا الحمد لله الذي هدىنا لهذا وما كنا لنهتدي لولا ان هدىنا الله لقد جاءت رسل ربنا بالحق ونودوا ان تلكم الجنة اورثتموها بما كنتم تعملون",
  },
  {
    verseId: 43,
    name: "الأعراف",
    surahId: 7,
    text: "وَنَادَىٰٓ أَصۡحَٰبُ ٱلۡجَنَّةِ أَصۡحَٰبَ ٱلنَّارِ أَن قَدۡ وَجَدۡنَا مَا وَعَدَنَا رَبُّنَا حَقّٗا فَهَلۡ وَجَدتُّم مَّا وَعَدَ رَبُّكُمۡ حَقّٗاۖ قَالُواْ نَعَمۡۚ فَأَذَّنَ مُؤَذِّنُۢ بَيۡنَهُمۡ أَن لَّعۡنَةُ ٱللَّهِ عَلَى ٱلظَّـٰلِمِينَ",
    translation:
      'And the companions of Paradise will call out to the companions of the Fire, "We have already found what our Lord promised us to be true. Have you found what your Lord promised to be true?" They will say, "Yes." Then an announcer will announce among them, "The curse of Allah shall be upon the wrongdoers',
    normalizedText:
      "ونادى اصحب الجنة اصحب النار ان قد وجدنا ما وعدنا ربنا حقا فهل وجدتم ما وعد ربكم حقا قالوا نعم فاذن ماذن بينهم ان لعنة الله على الظلمين",
  },
  {
    verseId: 44,
    name: "الأعراف",
    surahId: 7,
    text: "ٱلَّذِينَ يَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَيَبۡغُونَهَا عِوَجٗا وَهُم بِٱلۡأٓخِرَةِ كَٰفِرُونَ",
    translation:
      "Who averted [people] from the way of Allah and sought to make it [seem] deviant while they were, concerning the Hereafter, disbelievers",
    normalizedText: "الذين يصدون عن سبيل الله ويبغونها عوجا وهم بالاخرة كفرون",
  },
  {
    verseId: 45,
    name: "الأعراف",
    surahId: 7,
    text: "وَبَيۡنَهُمَا حِجَابٞۚ وَعَلَى ٱلۡأَعۡرَافِ رِجَالٞ يَعۡرِفُونَ كُلَّۢا بِسِيمَىٰهُمۡۚ وَنَادَوۡاْ أَصۡحَٰبَ ٱلۡجَنَّةِ أَن سَلَٰمٌ عَلَيۡكُمۡۚ لَمۡ يَدۡخُلُوهَا وَهُمۡ يَطۡمَعُونَ",
    translation:
      'And between them will be a partition, and on [its] elevations are men who recognize all by their mark. And they call out to the companions of Paradise, "Peace be upon you." They have not [yet] entered it, but they long intensely',
    normalizedText:
      "وبينهما حجاب وعلى الاعراف رجال يعرفون كلا بسيمىهم ونادوا اصحب الجنة ان سلم عليكم لم يدخلوها وهم يطمعون",
  },
  {
    verseId: 46,
    name: "الأعراف",
    surahId: 7,
    text: "۞وَإِذَا صُرِفَتۡ أَبۡصَٰرُهُمۡ تِلۡقَآءَ أَصۡحَٰبِ ٱلنَّارِ قَالُواْ رَبَّنَا لَا تَجۡعَلۡنَا مَعَ ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      'And when their eyes are turned toward the companions of the Fire, they say, "Our Lord, do not place us with the wrongdoing people',
    normalizedText:
      "۞واذا صرفت ابصرهم تلقاء اصحب النار قالوا ربنا لا تجعلنا مع القوم الظلمين",
  },
  {
    verseId: 47,
    name: "الأعراف",
    surahId: 7,
    text: "وَنَادَىٰٓ أَصۡحَٰبُ ٱلۡأَعۡرَافِ رِجَالٗا يَعۡرِفُونَهُم بِسِيمَىٰهُمۡ قَالُواْ مَآ أَغۡنَىٰ عَنكُمۡ جَمۡعُكُمۡ وَمَا كُنتُمۡ تَسۡتَكۡبِرُونَ",
    translation:
      'And the companions of the Elevations will call to men [within Hell] whom they recognize by their mark, saying, "Of no avail to you was your gathering and [the fact] that you were arrogant',
    normalizedText:
      "ونادى اصحب الاعراف رجالا يعرفونهم بسيمىهم قالوا ما اغنى عنكم جمعكم وما كنتم تستكبرون",
  },
  {
    verseId: 48,
    name: "الأعراف",
    surahId: 7,
    text: "أَهَـٰٓؤُلَآءِ ٱلَّذِينَ أَقۡسَمۡتُمۡ لَا يَنَالُهُمُ ٱللَّهُ بِرَحۡمَةٍۚ ٱدۡخُلُواْ ٱلۡجَنَّةَ لَا خَوۡفٌ عَلَيۡكُمۡ وَلَآ أَنتُمۡ تَحۡزَنُونَ",
    translation:
      '[Allah will say], "Are these the ones whom you [inhabitants of Hell] swore that Allah would never offer them mercy? Enter Paradise, [O People of the Elevations]. No fear will there be concerning you, nor will you grieve',
    normalizedText:
      "اهالاء الذين اقسمتم لا ينالهم الله برحمة ادخلوا الجنة لا خوف عليكم ولا انتم تحزنون",
  },
  {
    verseId: 49,
    name: "الأعراف",
    surahId: 7,
    text: "وَنَادَىٰٓ أَصۡحَٰبُ ٱلنَّارِ أَصۡحَٰبَ ٱلۡجَنَّةِ أَنۡ أَفِيضُواْ عَلَيۡنَا مِنَ ٱلۡمَآءِ أَوۡ مِمَّا رَزَقَكُمُ ٱللَّهُۚ قَالُوٓاْ إِنَّ ٱللَّهَ حَرَّمَهُمَا عَلَى ٱلۡكَٰفِرِينَ",
    translation:
      'And the companions of the Fire will call to the companions of Paradise, "Pour upon us some water or from whatever Allah has provided you." They will say, "Indeed, Allah has forbidden them both to the disbelievers',
    normalizedText:
      "ونادى اصحب النار اصحب الجنة ان افيضوا علينا من الماء او مما رزقكم الله قالوا ان الله حرمهما على الكفرين",
  },
  {
    verseId: 50,
    name: "الأعراف",
    surahId: 7,
    text: "ٱلَّذِينَ ٱتَّخَذُواْ دِينَهُمۡ لَهۡوٗا وَلَعِبٗا وَغَرَّتۡهُمُ ٱلۡحَيَوٰةُ ٱلدُّنۡيَاۚ فَٱلۡيَوۡمَ نَنسَىٰهُمۡ كَمَا نَسُواْ لِقَآءَ يَوۡمِهِمۡ هَٰذَا وَمَا كَانُواْ بِـَٔايَٰتِنَا يَجۡحَدُونَ",
    translation:
      'Who took their religion as distraction and amusement and whom the worldly life deluded." So today We will forget them just as they forgot the meeting of this Day of theirs and for having rejected Our verses',
    normalizedText:
      "الذين اتخذوا دينهم لهوا ولعبا وغرتهم الحيوة الدنيا فاليوم ننسىهم كما نسوا لقاء يومهم هذا وما كانوا بايتنا يجحدون",
  },
  {
    verseId: 51,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَقَدۡ جِئۡنَٰهُم بِكِتَٰبٖ فَصَّلۡنَٰهُ عَلَىٰ عِلۡمٍ هُدٗى وَرَحۡمَةٗ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "And We had certainly brought them a Book which We detailed by knowledge - as guidance and mercy to a people who believe",
    normalizedText: "ولقد جانهم بكتب فصلنه على علم هدى ورحمة لقوم يامنون",
  },
  {
    verseId: 52,
    name: "الأعراف",
    surahId: 7,
    text: "هَلۡ يَنظُرُونَ إِلَّا تَأۡوِيلَهُۥۚ يَوۡمَ يَأۡتِي تَأۡوِيلُهُۥ يَقُولُ ٱلَّذِينَ نَسُوهُ مِن قَبۡلُ قَدۡ جَآءَتۡ رُسُلُ رَبِّنَا بِٱلۡحَقِّ فَهَل لَّنَا مِن شُفَعَآءَ فَيَشۡفَعُواْ لَنَآ أَوۡ نُرَدُّ فَنَعۡمَلَ غَيۡرَ ٱلَّذِي كُنَّا نَعۡمَلُۚ قَدۡ خَسِرُوٓاْ أَنفُسَهُمۡ وَضَلَّ عَنۡهُم مَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      'Do they await except its result? The Day its result comes those who had ignored it before will say, "The messengers of our Lord had come with the truth, so are there [now] any intercessors to intercede for us or could we be sent back to do other than we used to do?" They will have lost themselves, and lost from them is what they used to invent',
    normalizedText:
      "هل ينظرون الا تاويله يوم ياتي تاويله يقول الذين نسوه من قبل قد جاءت رسل ربنا بالحق فهل لنا من شفعاء فيشفعوا لنا او نرد فنعمل غير الذي كنا نعمل قد خسروا انفسهم وضل عنهم ما كانوا يفترون",
  },
  {
    verseId: 53,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ رَبَّكُمُ ٱللَّهُ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ فِي سِتَّةِ أَيَّامٖ ثُمَّ ٱسۡتَوَىٰ عَلَى ٱلۡعَرۡشِۖ يُغۡشِي ٱلَّيۡلَ ٱلنَّهَارَ يَطۡلُبُهُۥ حَثِيثٗا وَٱلشَّمۡسَ وَٱلۡقَمَرَ وَٱلنُّجُومَ مُسَخَّرَٰتِۭ بِأَمۡرِهِۦٓۗ أَلَا لَهُ ٱلۡخَلۡقُ وَٱلۡأَمۡرُۗ تَبَارَكَ ٱللَّهُ رَبُّ ٱلۡعَٰلَمِينَ",
    translation:
      "Indeed, your Lord is Allah, who created the heavens and earth in six days and then established Himself above the Throne. He covers the night with the day, [another night] chasing it rapidly; and [He created] the sun, the moon, and the stars, subjected by His command. Unquestionably, His is the creation and the command; blessed is Allah, Lord of the worlds",
    normalizedText:
      "ان ربكم الله الذي خلق السموت والارض في ستة ايام ثم استوى على العرش يغشي اليل النهار يطلبه حثيثا والشمس والقمر والنجوم مسخرت بامره الا له الخلق والامر تبارك الله رب العلمين",
  },
  {
    verseId: 54,
    name: "الأعراف",
    surahId: 7,
    text: "ٱدۡعُواْ رَبَّكُمۡ تَضَرُّعٗا وَخُفۡيَةًۚ إِنَّهُۥ لَا يُحِبُّ ٱلۡمُعۡتَدِينَ",
    translation:
      "Call upon your Lord in humility and privately; indeed, He does not like transgressors",
    normalizedText: "ادعوا ربكم تضرعا وخفية انه لا يحب المعتدين",
  },
  {
    verseId: 55,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَا تُفۡسِدُواْ فِي ٱلۡأَرۡضِ بَعۡدَ إِصۡلَٰحِهَا وَٱدۡعُوهُ خَوۡفٗا وَطَمَعًاۚ إِنَّ رَحۡمَتَ ٱللَّهِ قَرِيبٞ مِّنَ ٱلۡمُحۡسِنِينَ",
    translation:
      "And cause not corruption upon the earth after its reformation. And invoke Him in fear and aspiration. Indeed, the mercy of Allah is near to the doers of good",
    normalizedText:
      "ولا تفسدوا في الارض بعد اصلحها وادعوه خوفا وطمعا ان رحمت الله قريب من المحسنين",
  },
  {
    verseId: 56,
    name: "الأعراف",
    surahId: 7,
    text: "وَهُوَ ٱلَّذِي يُرۡسِلُ ٱلرِّيَٰحَ بُشۡرَۢا بَيۡنَ يَدَيۡ رَحۡمَتِهِۦۖ حَتَّىٰٓ إِذَآ أَقَلَّتۡ سَحَابٗا ثِقَالٗا سُقۡنَٰهُ لِبَلَدٖ مَّيِّتٖ فَأَنزَلۡنَا بِهِ ٱلۡمَآءَ فَأَخۡرَجۡنَا بِهِۦ مِن كُلِّ ٱلثَّمَرَٰتِۚ كَذَٰلِكَ نُخۡرِجُ ٱلۡمَوۡتَىٰ لَعَلَّكُمۡ تَذَكَّرُونَ",
    translation:
      "And it is He who sends the winds as good tidings before His mercy until, when they have carried heavy rainclouds, We drive them to a dead land and We send down rain therein and bring forth thereby [some] of all the fruits. Thus will We bring forth the dead; perhaps you may be reminded",
    normalizedText:
      "وهو الذي يرسل الريح بشرا بين يدي رحمته حتى اذا اقلت سحابا ثقالا سقنه لبلد ميت فانزلنا به الماء فاخرجنا به من كل الثمرت كذلك نخرج الموتى لعلكم تذكرون",
  },
  {
    verseId: 57,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلۡبَلَدُ ٱلطَّيِّبُ يَخۡرُجُ نَبَاتُهُۥ بِإِذۡنِ رَبِّهِۦۖ وَٱلَّذِي خَبُثَ لَا يَخۡرُجُ إِلَّا نَكِدٗاۚ كَذَٰلِكَ نُصَرِّفُ ٱلۡأٓيَٰتِ لِقَوۡمٖ يَشۡكُرُونَ",
    translation:
      "And the good land - its vegetation emerges by permission of its Lord; but that which is bad - nothing emerges except sparsely, with difficulty. Thus do We diversify the signs for a people who are grateful",
    normalizedText:
      "والبلد الطيب يخرج نباته باذن ربه والذي خبث لا يخرج الا نكدا كذلك نصرف الايت لقوم يشكرون",
  },
  {
    verseId: 58,
    name: "الأعراف",
    surahId: 7,
    text: "لَقَدۡ أَرۡسَلۡنَا نُوحًا إِلَىٰ قَوۡمِهِۦ فَقَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥٓ إِنِّيٓ أَخَافُ عَلَيۡكُمۡ عَذَابَ يَوۡمٍ عَظِيمٖ",
    translation:
      'We had certainly sent Noah to his people, and he said, "O my people, worship Allah; you have no deity other than Him. Indeed, I fear for you the punishment of a tremendous Day',
    normalizedText:
      "لقد ارسلنا نوحا الى قومه فقال يقوم اعبدوا الله ما لكم من اله غيره اني اخاف عليكم عذاب يوم عظيم",
  },
  {
    verseId: 59,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱلۡمَلَأُ مِن قَوۡمِهِۦٓ إِنَّا لَنَرَىٰكَ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      'Said the eminent among his people, "Indeed, we see you in clear error',
    normalizedText: "قال الملا من قومه انا لنرىك في ضلل مبين",
  },
  {
    verseId: 60,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ يَٰقَوۡمِ لَيۡسَ بِي ضَلَٰلَةٞ وَلَٰكِنِّي رَسُولٞ مِّن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation:
      '[Noah] said, "O my people, there is not error in me, but I am a messenger from the Lord of the worlds',
    normalizedText: "قال يقوم ليس بي ضللة ولكني رسول من رب العلمين",
  },
  {
    verseId: 61,
    name: "الأعراف",
    surahId: 7,
    text: "أُبَلِّغُكُمۡ رِسَٰلَٰتِ رَبِّي وَأَنصَحُ لَكُمۡ وَأَعۡلَمُ مِنَ ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      "I convey to you the messages of my Lord and advise you; and I know from Allah what you do not know",
    normalizedText: "ابلغكم رسلت ربي وانصح لكم واعلم من الله ما لا تعلمون",
  },
  {
    verseId: 62,
    name: "الأعراف",
    surahId: 7,
    text: "أَوَعَجِبۡتُمۡ أَن جَآءَكُمۡ ذِكۡرٞ مِّن رَّبِّكُمۡ عَلَىٰ رَجُلٖ مِّنكُمۡ لِيُنذِرَكُمۡ وَلِتَتَّقُواْ وَلَعَلَّكُمۡ تُرۡحَمُونَ",
    translation:
      "Then do you wonder that there has come to you a reminder from your Lord through a man from among you, that he may warn you and that you may fear Allah so you might receive mercy",
    normalizedText:
      "اوعجبتم ان جاءكم ذكر من ربكم على رجل منكم لينذركم ولتتقوا ولعلكم ترحمون",
  },
  {
    verseId: 63,
    name: "الأعراف",
    surahId: 7,
    text: "فَكَذَّبُوهُ فَأَنجَيۡنَٰهُ وَٱلَّذِينَ مَعَهُۥ فِي ٱلۡفُلۡكِ وَأَغۡرَقۡنَا ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَآۚ إِنَّهُمۡ كَانُواْ قَوۡمًا عَمِينَ",
    translation:
      "But they denied him, so We saved him and those who were with him in the ship. And We drowned those who denied Our signs. Indeed, they were a blind people",
    normalizedText:
      "فكذبوه فانجينه والذين معه في الفلك واغرقنا الذين كذبوا بايتنا انهم كانوا قوما عمين",
  },
  {
    verseId: 64,
    name: "الأعراف",
    surahId: 7,
    text: "۞وَإِلَىٰ عَادٍ أَخَاهُمۡ هُودٗاۚ قَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥٓۚ أَفَلَا تَتَّقُونَ",
    translation: `And to the 'Aad [We sent] their brother Hud. He said, "O my people, worship Allah; you have no deity other than Him. Then will you not fear Him`,
    normalizedText:
      "۞والى عاد اخاهم هودا قال يقوم اعبدوا الله ما لكم من اله غيره افلا تتقون",
  },
  {
    verseId: 65,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱلۡمَلَأُ ٱلَّذِينَ كَفَرُواْ مِن قَوۡمِهِۦٓ إِنَّا لَنَرَىٰكَ فِي سَفَاهَةٖ وَإِنَّا لَنَظُنُّكَ مِنَ ٱلۡكَٰذِبِينَ",
    translation:
      'Said the eminent ones who disbelieved among his people, "Indeed, we see you in foolishness, and indeed, we think you are of the liars',
    normalizedText:
      "قال الملا الذين كفروا من قومه انا لنرىك في سفاهة وانا لنظنك من الكذبين",
  },
  {
    verseId: 66,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ يَٰقَوۡمِ لَيۡسَ بِي سَفَاهَةٞ وَلَٰكِنِّي رَسُولٞ مِّن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation:
      '[Hud] said, "O my people, there is not foolishness in me, but I am a messenger from the Lord of the worlds',
    normalizedText: "قال يقوم ليس بي سفاهة ولكني رسول من رب العلمين",
  },
  {
    verseId: 67,
    name: "الأعراف",
    surahId: 7,
    text: "أُبَلِّغُكُمۡ رِسَٰلَٰتِ رَبِّي وَأَنَا۠ لَكُمۡ نَاصِحٌ أَمِينٌ",
    translation:
      "I convey to you the messages of my Lord, and I am to you a trustworthy adviser",
    normalizedText: "ابلغكم رسلت ربي وانا لكم ناصح امين",
  },
  {
    verseId: 68,
    name: "الأعراف",
    surahId: 7,
    text: "أَوَعَجِبۡتُمۡ أَن جَآءَكُمۡ ذِكۡرٞ مِّن رَّبِّكُمۡ عَلَىٰ رَجُلٖ مِّنكُمۡ لِيُنذِرَكُمۡۚ وَٱذۡكُرُوٓاْ إِذۡ جَعَلَكُمۡ خُلَفَآءَ مِنۢ بَعۡدِ قَوۡمِ نُوحٖ وَزَادَكُمۡ فِي ٱلۡخَلۡقِ بَصۜۡطَةٗۖ فَٱذۡكُرُوٓاْ ءَالَآءَ ٱللَّهِ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "Then do you wonder that there has come to you a reminder from your Lord through a man from among you, that he may warn you? And remember when He made you successors after the people of Noah and increased you in stature extensively. So remember the favors of Allah that you might succeed",
    normalizedText:
      "اوعجبتم ان جاءكم ذكر من ربكم على رجل منكم لينذركم واذكروا اذ جعلكم خلفاء من بعد قوم نوح وزادكم في الخلق بصطة فاذكروا ءالاء الله لعلكم تفلحون",
  },
  {
    verseId: 69,
    name: "الأعراف",
    surahId: 7,
    text: "قَالُوٓاْ أَجِئۡتَنَا لِنَعۡبُدَ ٱللَّهَ وَحۡدَهُۥ وَنَذَرَ مَا كَانَ يَعۡبُدُ ءَابَآؤُنَا فَأۡتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      'They said, "Have you come to us that we should worship Allah alone and leave what our fathers have worshipped? Then bring us what you promise us, if you should be of the truthful',
    normalizedText:
      "قالوا اجاتنا لنعبد الله وحده ونذر ما كان يعبد ءاباانا فاتنا بما تعدنا ان كنت من الصدقين",
  },
  {
    verseId: 70,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ قَدۡ وَقَعَ عَلَيۡكُم مِّن رَّبِّكُمۡ رِجۡسٞ وَغَضَبٌۖ أَتُجَٰدِلُونَنِي فِيٓ أَسۡمَآءٖ سَمَّيۡتُمُوهَآ أَنتُمۡ وَءَابَآؤُكُم مَّا نَزَّلَ ٱللَّهُ بِهَا مِن سُلۡطَٰنٖۚ فَٱنتَظِرُوٓاْ إِنِّي مَعَكُم مِّنَ ٱلۡمُنتَظِرِينَ",
    translation:
      '[Hud] said, "Already have defilement and anger fallen upon you from your Lord. Do you dispute with me concerning [mere] names you have named them, you and your fathers, for which Allah has not sent down any authority? Then wait; indeed, I am with you among those who wait',
    normalizedText:
      "قال قد وقع عليكم من ربكم رجس وغضب اتجدلونني في اسماء سميتموها انتم وءابااكم ما نزل الله بها من سلطن فانتظروا اني معكم من المنتظرين",
  },
  {
    verseId: 71,
    name: "الأعراف",
    surahId: 7,
    text: "فَأَنجَيۡنَٰهُ وَٱلَّذِينَ مَعَهُۥ بِرَحۡمَةٖ مِّنَّا وَقَطَعۡنَا دَابِرَ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَاۖ وَمَا كَانُواْ مُؤۡمِنِينَ",
    translation:
      "So We saved him and those with him by mercy from Us. And We eliminated those who denied Our signs, and they were not [at all] believers",
    normalizedText:
      "فانجينه والذين معه برحمة منا وقطعنا دابر الذين كذبوا بايتنا وما كانوا مامنين",
  },
  {
    verseId: 72,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِلَىٰ ثَمُودَ أَخَاهُمۡ صَٰلِحٗاۚ قَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥۖ قَدۡ جَآءَتۡكُم بَيِّنَةٞ مِّن رَّبِّكُمۡۖ هَٰذِهِۦ نَاقَةُ ٱللَّهِ لَكُمۡ ءَايَةٗۖ فَذَرُوهَا تَأۡكُلۡ فِيٓ أَرۡضِ ٱللَّهِۖ وَلَا تَمَسُّوهَا بِسُوٓءٖ فَيَأۡخُذَكُمۡ عَذَابٌ أَلِيمٞ",
    translation: `And to the Thamud [We sent] their brother Salih. He said, "O my people, worship Allah; you have no deity other than Him. There has come to you clear evidence from your Lord. This is the she-camel of Allah [sent] to you as a sign. So leave her to eat within Allah 's land and do not touch her with harm, lest there seize you a painful punishment`,
    normalizedText:
      "والى ثمود اخاهم صلحا قال يقوم اعبدوا الله ما لكم من اله غيره قد جاءتكم بينة من ربكم هذه ناقة الله لكم ءاية فذروها تاكل في ارض الله ولا تمسوها بسوء فياخذكم عذاب اليم",
  },
  {
    verseId: 73,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱذۡكُرُوٓاْ إِذۡ جَعَلَكُمۡ خُلَفَآءَ مِنۢ بَعۡدِ عَادٖ وَبَوَّأَكُمۡ فِي ٱلۡأَرۡضِ تَتَّخِذُونَ مِن سُهُولِهَا قُصُورٗا وَتَنۡحِتُونَ ٱلۡجِبَالَ بُيُوتٗاۖ فَٱذۡكُرُوٓاْ ءَالَآءَ ٱللَّهِ وَلَا تَعۡثَوۡاْ فِي ٱلۡأَرۡضِ مُفۡسِدِينَ",
    translation:
      "And remember when He made you successors after the 'Aad and settled you in the land, [and] you take for yourselves palaces from its plains and carve from the mountains, homes. Then remember the favors of Allah and do not commit abuse on the earth, spreading corruption",
    normalizedText:
      "واذكروا اذ جعلكم خلفاء من بعد عاد وبواكم في الارض تتخذون من سهولها قصورا وتنحتون الجبال بيوتا فاذكروا ءالاء الله ولا تعثوا في الارض مفسدين",
  },
  {
    verseId: 74,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱلۡمَلَأُ ٱلَّذِينَ ٱسۡتَكۡبَرُواْ مِن قَوۡمِهِۦ لِلَّذِينَ ٱسۡتُضۡعِفُواْ لِمَنۡ ءَامَنَ مِنۡهُمۡ أَتَعۡلَمُونَ أَنَّ صَٰلِحٗا مُّرۡسَلٞ مِّن رَّبِّهِۦۚ قَالُوٓاْ إِنَّا بِمَآ أُرۡسِلَ بِهِۦ مُؤۡمِنُونَ",
    translation:
      'Said the eminent ones who were arrogant among his people to those who were oppressed - to those who believed among them, "Do you [actually] know that Salih is sent from his Lord?" They said, "Indeed we, in that with which he was sent, are believers',
    normalizedText:
      "قال الملا الذين استكبروا من قومه للذين استضعفوا لمن ءامن منهم اتعلمون ان صلحا مرسل من ربه قالوا انا بما ارسل به مامنون",
  },
  {
    verseId: 75,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱلَّذِينَ ٱسۡتَكۡبَرُوٓاْ إِنَّا بِٱلَّذِيٓ ءَامَنتُم بِهِۦ كَٰفِرُونَ",
    translation:
      'Said those who were arrogant, "Indeed we, in that which you have believed, are disbelievers',
    normalizedText: "قال الذين استكبروا انا بالذي ءامنتم به كفرون",
  },
  {
    verseId: 76,
    name: "الأعراف",
    surahId: 7,
    text: "فَعَقَرُواْ ٱلنَّاقَةَ وَعَتَوۡاْ عَنۡ أَمۡرِ رَبِّهِمۡ وَقَالُواْ يَٰصَٰلِحُ ٱئۡتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلۡمُرۡسَلِينَ",
    translation:
      'So they hamstrung the she-camel and were insolent toward the command of their Lord and said, "O Salih, bring us what you promise us, if you should be of the messengers',
    normalizedText:
      "فعقروا الناقة وعتوا عن امر ربهم وقالوا يصلح ااتنا بما تعدنا ان كنت من المرسلين",
  },
  {
    verseId: 77,
    name: "الأعراف",
    surahId: 7,
    text: "فَأَخَذَتۡهُمُ ٱلرَّجۡفَةُ فَأَصۡبَحُواْ فِي دَارِهِمۡ جَٰثِمِينَ",
    translation:
      "So the earthquake seized them, and they became within their home [corpses] fallen prone",
    normalizedText: "فاخذتهم الرجفة فاصبحوا في دارهم جثمين",
  },
  {
    verseId: 78,
    name: "الأعراف",
    surahId: 7,
    text: "فَتَوَلَّىٰ عَنۡهُمۡ وَقَالَ يَٰقَوۡمِ لَقَدۡ أَبۡلَغۡتُكُمۡ رِسَالَةَ رَبِّي وَنَصَحۡتُ لَكُمۡ وَلَٰكِن لَّا تُحِبُّونَ ٱلنَّـٰصِحِينَ",
    translation:
      'And he turned away from them and said, "O my people, I had certainly conveyed to you the message of my Lord and advised you, but you do not like advisors',
    normalizedText:
      "فتولى عنهم وقال يقوم لقد ابلغتكم رسالة ربي ونصحت لكم ولكن لا تحبون النصحين",
  },
  {
    verseId: 79,
    name: "الأعراف",
    surahId: 7,
    text: "وَلُوطًا إِذۡ قَالَ لِقَوۡمِهِۦٓ أَتَأۡتُونَ ٱلۡفَٰحِشَةَ مَا سَبَقَكُم بِهَا مِنۡ أَحَدٖ مِّنَ ٱلۡعَٰلَمِينَ",
    translation:
      'And [We had sent] Lot when he said to his people, "Do you commit such immorality as no one has preceded you with from among the worlds',
    normalizedText:
      "ولوطا اذ قال لقومه اتاتون الفحشة ما سبقكم بها من احد من العلمين",
  },
  {
    verseId: 80,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّكُمۡ لَتَأۡتُونَ ٱلرِّجَالَ شَهۡوَةٗ مِّن دُونِ ٱلنِّسَآءِۚ بَلۡ أَنتُمۡ قَوۡمٞ مُّسۡرِفُونَ",
    translation:
      "Indeed, you approach men with desire, instead of women. Rather, you are a transgressing people",
    normalizedText: "انكم لتاتون الرجال شهوة من دون النساء بل انتم قوم مسرفون",
  },
  {
    verseId: 81,
    name: "الأعراف",
    surahId: 7,
    text: "وَمَا كَانَ جَوَابَ قَوۡمِهِۦٓ إِلَّآ أَن قَالُوٓاْ أَخۡرِجُوهُم مِّن قَرۡيَتِكُمۡۖ إِنَّهُمۡ أُنَاسٞ يَتَطَهَّرُونَ",
    translation:
      'But the answer of his people was only that they said, "Evict them from your city! Indeed, they are men who keep themselves pure',
    normalizedText:
      "وما كان جواب قومه الا ان قالوا اخرجوهم من قريتكم انهم اناس يتطهرون",
  },
  {
    verseId: 82,
    name: "الأعراف",
    surahId: 7,
    text: "فَأَنجَيۡنَٰهُ وَأَهۡلَهُۥٓ إِلَّا ٱمۡرَأَتَهُۥ كَانَتۡ مِنَ ٱلۡغَٰبِرِينَ",
    translation:
      "So We saved him and his family, except for his wife; she was of those who remained [with the evildoers]",
    normalizedText: "فانجينه واهله الا امراته كانت من الغبرين",
  },
  {
    verseId: 83,
    name: "الأعراف",
    surahId: 7,
    text: "وَأَمۡطَرۡنَا عَلَيۡهِم مَّطَرٗاۖ فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُجۡرِمِينَ",
    translation:
      "And We rained upon them a rain [of stones]. Then see how was the end of the criminals",
    normalizedText: "وامطرنا عليهم مطرا فانظر كيف كان عقبة المجرمين",
  },
  {
    verseId: 84,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِلَىٰ مَدۡيَنَ أَخَاهُمۡ شُعَيۡبٗاۚ قَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥۖ قَدۡ جَآءَتۡكُم بَيِّنَةٞ مِّن رَّبِّكُمۡۖ فَأَوۡفُواْ ٱلۡكَيۡلَ وَٱلۡمِيزَانَ وَلَا تَبۡخَسُواْ ٱلنَّاسَ أَشۡيَآءَهُمۡ وَلَا تُفۡسِدُواْ فِي ٱلۡأَرۡضِ بَعۡدَ إِصۡلَٰحِهَاۚ ذَٰلِكُمۡ خَيۡرٞ لَّكُمۡ إِن كُنتُم مُّؤۡمِنِينَ",
    translation: `And to [the people of] Madyan [We sent] their brother Shu'ayb. He said, "O my people, worship Allah; you have no deity other than Him. There has come to you clear evidence from your Lord. So fulfill the measure and weight and do not deprive people of their due and cause not corruption upon the earth after its reformation. That is better for you, if you should be believers`,
    normalizedText:
      "والى مدين اخاهم شعيبا قال يقوم اعبدوا الله ما لكم من اله غيره قد جاءتكم بينة من ربكم فاوفوا الكيل والميزان ولا تبخسوا الناس اشياءهم ولا تفسدوا في الارض بعد اصلحها ذلكم خير لكم ان كنتم مامنين",
  },
  {
    verseId: 85,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَا تَقۡعُدُواْ بِكُلِّ صِرَٰطٖ تُوعِدُونَ وَتَصُدُّونَ عَن سَبِيلِ ٱللَّهِ مَنۡ ءَامَنَ بِهِۦ وَتَبۡغُونَهَا عِوَجٗاۚ وَٱذۡكُرُوٓاْ إِذۡ كُنتُمۡ قَلِيلٗا فَكَثَّرَكُمۡۖ وَٱنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُفۡسِدِينَ",
    translation:
      "And do not sit on every path, threatening and averting from the way of Allah those who believe in Him, seeking to make it [seem] deviant. And remember when you were few and He increased you. And see how was the end of the corrupters",
    normalizedText:
      "ولا تقعدوا بكل صرط توعدون وتصدون عن سبيل الله من ءامن به وتبغونها عوجا واذكروا اذ كنتم قليلا فكثركم وانظروا كيف كان عقبة المفسدين",
  },
  {
    verseId: 86,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِن كَانَ طَآئِفَةٞ مِّنكُمۡ ءَامَنُواْ بِٱلَّذِيٓ أُرۡسِلۡتُ بِهِۦ وَطَآئِفَةٞ لَّمۡ يُؤۡمِنُواْ فَٱصۡبِرُواْ حَتَّىٰ يَحۡكُمَ ٱللَّهُ بَيۡنَنَاۚ وَهُوَ خَيۡرُ ٱلۡحَٰكِمِينَ",
    translation:
      "And if there should be a group among you who has believed in that with which I have been sent and a group that has not believed, then be patient until Allah judges between us. And He is the best of judges",
    normalizedText:
      "وان كان طاافة منكم ءامنوا بالذي ارسلت به وطاافة لم يامنوا فاصبروا حتى يحكم الله بيننا وهو خير الحكمين",
  },
  {
    verseId: 87,
    name: "الأعراف",
    surahId: 7,
    text: "۞قَالَ ٱلۡمَلَأُ ٱلَّذِينَ ٱسۡتَكۡبَرُواْ مِن قَوۡمِهِۦ لَنُخۡرِجَنَّكَ يَٰشُعَيۡبُ وَٱلَّذِينَ ءَامَنُواْ مَعَكَ مِن قَرۡيَتِنَآ أَوۡ لَتَعُودُنَّ فِي مِلَّتِنَاۚ قَالَ أَوَلَوۡ كُنَّا كَٰرِهِينَ",
    translation: `Said the eminent ones who were arrogant among his people, "We will surely evict you, O Shu'ayb, and those who have believed with you from our city, or you must return to our religion." He said, "Even if we were unwilling`,
    normalizedText:
      "۞قال الملا الذين استكبروا من قومه لنخرجنك يشعيب والذين ءامنوا معك من قريتنا او لتعودن في ملتنا قال اولو كنا كرهين",
  },
  {
    verseId: 88,
    name: "الأعراف",
    surahId: 7,
    text: "قَدِ ٱفۡتَرَيۡنَا عَلَى ٱللَّهِ كَذِبًا إِنۡ عُدۡنَا فِي مِلَّتِكُم بَعۡدَ إِذۡ نَجَّىٰنَا ٱللَّهُ مِنۡهَاۚ وَمَا يَكُونُ لَنَآ أَن نَّعُودَ فِيهَآ إِلَّآ أَن يَشَآءَ ٱللَّهُ رَبُّنَاۚ وَسِعَ رَبُّنَا كُلَّ شَيۡءٍ عِلۡمًاۚ عَلَى ٱللَّهِ تَوَكَّلۡنَاۚ رَبَّنَا ٱفۡتَحۡ بَيۡنَنَا وَبَيۡنَ قَوۡمِنَا بِٱلۡحَقِّ وَأَنتَ خَيۡرُ ٱلۡفَٰتِحِينَ",
    translation:
      "We would have invented against Allah a lie if we returned to your religion after Allah had saved us from it. And it is not for us to return to it except that Allah, our Lord, should will. Our Lord has encompassed all things in knowledge. Upon Allah we have relied. Our Lord, decide between us and our people in truth, and You are the best of those who give decision",
    normalizedText:
      "قد افترينا على الله كذبا ان عدنا في ملتكم بعد اذ نجىنا الله منها وما يكون لنا ان نعود فيها الا ان يشاء الله ربنا وسع ربنا كل شيء علما على الله توكلنا ربنا افتح بيننا وبين قومنا بالحق وانت خير الفتحين",
  },
  {
    verseId: 89,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَالَ ٱلۡمَلَأُ ٱلَّذِينَ كَفَرُواْ مِن قَوۡمِهِۦ لَئِنِ ٱتَّبَعۡتُمۡ شُعَيۡبًا إِنَّكُمۡ إِذٗا لَّخَٰسِرُونَ",
    translation: `Said the eminent ones who disbelieved among his people, "If you should follow Shu'ayb, indeed, you would then be losers`,
    normalizedText:
      "وقال الملا الذين كفروا من قومه لان اتبعتم شعيبا انكم اذا لخسرون",
  },
  {
    verseId: 90,
    name: "الأعراف",
    surahId: 7,
    text: "فَأَخَذَتۡهُمُ ٱلرَّجۡفَةُ فَأَصۡبَحُواْ فِي دَارِهِمۡ جَٰثِمِينَ",
    translation:
      "So the earthquake seized them, and they became within their home [corpses] fallen prone",
    normalizedText: "فاخذتهم الرجفة فاصبحوا في دارهم جثمين",
  },
  {
    verseId: 91,
    name: "الأعراف",
    surahId: 7,
    text: "ٱلَّذِينَ كَذَّبُواْ شُعَيۡبٗا كَأَن لَّمۡ يَغۡنَوۡاْ فِيهَاۚ ٱلَّذِينَ كَذَّبُواْ شُعَيۡبٗا كَانُواْ هُمُ ٱلۡخَٰسِرِينَ",
    translation:
      "Those who denied Shu'ayb - it was as though they had never resided there. Those who denied Shu'ayb - it was they who were the losers",
    normalizedText:
      "الذين كذبوا شعيبا كان لم يغنوا فيها الذين كذبوا شعيبا كانوا هم الخسرين",
  },
  {
    verseId: 92,
    name: "الأعراف",
    surahId: 7,
    text: "فَتَوَلَّىٰ عَنۡهُمۡ وَقَالَ يَٰقَوۡمِ لَقَدۡ أَبۡلَغۡتُكُمۡ رِسَٰلَٰتِ رَبِّي وَنَصَحۡتُ لَكُمۡۖ فَكَيۡفَ ءَاسَىٰ عَلَىٰ قَوۡمٖ كَٰفِرِينَ",
    translation:
      'And he turned away from them and said, "O my people, I had certainly conveyed to you the messages of my Lord and advised you, so how could I grieve for a disbelieving people',
    normalizedText:
      "فتولى عنهم وقال يقوم لقد ابلغتكم رسلت ربي ونصحت لكم فكيف ءاسى على قوم كفرين",
  },
  {
    verseId: 93,
    name: "الأعراف",
    surahId: 7,
    text: "وَمَآ أَرۡسَلۡنَا فِي قَرۡيَةٖ مِّن نَّبِيٍّ إِلَّآ أَخَذۡنَآ أَهۡلَهَا بِٱلۡبَأۡسَآءِ وَٱلضَّرَّآءِ لَعَلَّهُمۡ يَضَّرَّعُونَ",
    translation:
      "And We sent to no city a prophet [who was denied] except that We seized its people with poverty and hardship that they might humble themselves [to Allah]",
    normalizedText:
      "وما ارسلنا في قرية من نبي الا اخذنا اهلها بالباساء والضراء لعلهم يضرعون",
  },
  {
    verseId: 94,
    name: "الأعراف",
    surahId: 7,
    text: "ثُمَّ بَدَّلۡنَا مَكَانَ ٱلسَّيِّئَةِ ٱلۡحَسَنَةَ حَتَّىٰ عَفَواْ وَّقَالُواْ قَدۡ مَسَّ ءَابَآءَنَا ٱلضَّرَّآءُ وَٱلسَّرَّآءُ فَأَخَذۡنَٰهُم بَغۡتَةٗ وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      'Then We exchanged in place of the bad [condition], good, until they increased [and prospered] and said, "Our fathers [also] were touched with hardship and ease." So We seized them suddenly while they did not perceive',
    normalizedText:
      "ثم بدلنا مكان السياة الحسنة حتى عفوا وقالوا قد مس ءاباءنا الضراء والسراء فاخذنهم بغتة وهم لا يشعرون",
  },
  {
    verseId: 95,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَوۡ أَنَّ أَهۡلَ ٱلۡقُرَىٰٓ ءَامَنُواْ وَٱتَّقَوۡاْ لَفَتَحۡنَا عَلَيۡهِم بَرَكَٰتٖ مِّنَ ٱلسَّمَآءِ وَٱلۡأَرۡضِ وَلَٰكِن كَذَّبُواْ فَأَخَذۡنَٰهُم بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "And if only the people of the cities had believed and feared Allah, We would have opened upon them blessings from the heaven and the earth; but they denied [the messengers], so We seized them for what they were earning",
    normalizedText:
      "ولو ان اهل القرى ءامنوا واتقوا لفتحنا عليهم بركت من السماء والارض ولكن كذبوا فاخذنهم بما كانوا يكسبون",
  },
  {
    verseId: 96,
    name: "الأعراف",
    surahId: 7,
    text: "أَفَأَمِنَ أَهۡلُ ٱلۡقُرَىٰٓ أَن يَأۡتِيَهُم بَأۡسُنَا بَيَٰتٗا وَهُمۡ نَآئِمُونَ",
    translation:
      "Then, did the people of the cities feel secure from Our punishment coming to them at night while they were asleep",
    normalizedText: "افامن اهل القرى ان ياتيهم باسنا بيتا وهم ناامون",
  },
  {
    verseId: 97,
    name: "الأعراف",
    surahId: 7,
    text: "أَوَأَمِنَ أَهۡلُ ٱلۡقُرَىٰٓ أَن يَأۡتِيَهُم بَأۡسُنَا ضُحٗى وَهُمۡ يَلۡعَبُونَ",
    translation:
      "Or did the people of the cities feel secure from Our punishment coming to them in the morning while they were at play",
    normalizedText: "اوامن اهل القرى ان ياتيهم باسنا ضحى وهم يلعبون",
  },
  {
    verseId: 98,
    name: "الأعراف",
    surahId: 7,
    text: "أَفَأَمِنُواْ مَكۡرَ ٱللَّهِۚ فَلَا يَأۡمَنُ مَكۡرَ ٱللَّهِ إِلَّا ٱلۡقَوۡمُ ٱلۡخَٰسِرُونَ",
    translation:
      "Then did they feel secure from the plan of Allah? But no one feels secure from the plan of Allah except the losing people",
    normalizedText: "افامنوا مكر الله فلا يامن مكر الله الا القوم الخسرون",
  },
  {
    verseId: 99,
    name: "الأعراف",
    surahId: 7,
    text: "أَوَلَمۡ يَهۡدِ لِلَّذِينَ يَرِثُونَ ٱلۡأَرۡضَ مِنۢ بَعۡدِ أَهۡلِهَآ أَن لَّوۡ نَشَآءُ أَصَبۡنَٰهُم بِذُنُوبِهِمۡۚ وَنَطۡبَعُ عَلَىٰ قُلُوبِهِمۡ فَهُمۡ لَا يَسۡمَعُونَ",
    translation:
      "Has it not become clear to those who inherited the earth after its [previous] people that if We willed, We could afflict them for their sins? But We seal over their hearts so they do not hear",
    normalizedText:
      "اولم يهد للذين يرثون الارض من بعد اهلها ان لو نشاء اصبنهم بذنوبهم ونطبع على قلوبهم فهم لا يسمعون",
  },
  {
    verseId: 100,
    name: "الأعراف",
    surahId: 7,
    text: "تِلۡكَ ٱلۡقُرَىٰ نَقُصُّ عَلَيۡكَ مِنۡ أَنۢبَآئِهَاۚ وَلَقَدۡ جَآءَتۡهُمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِ فَمَا كَانُواْ لِيُؤۡمِنُواْ بِمَا كَذَّبُواْ مِن قَبۡلُۚ كَذَٰلِكَ يَطۡبَعُ ٱللَّهُ عَلَىٰ قُلُوبِ ٱلۡكَٰفِرِينَ",
    translation:
      "Those cities - We relate to you, [O Muhammad], some of their news. And certainly did their messengers come to them with clear proofs, but they were not to believe in that which they had denied before. Thus does Allah seal over the hearts of the disbelievers",
    normalizedText:
      "تلك القرى نقص عليك من انبااها ولقد جاءتهم رسلهم بالبينت فما كانوا ليامنوا بما كذبوا من قبل كذلك يطبع الله على قلوب الكفرين",
  },
  {
    verseId: 101,
    name: "الأعراف",
    surahId: 7,
    text: "وَمَا وَجَدۡنَا لِأَكۡثَرِهِم مِّنۡ عَهۡدٖۖ وَإِن وَجَدۡنَآ أَكۡثَرَهُمۡ لَفَٰسِقِينَ",
    translation:
      "And We did not find for most of them any covenant; but indeed, We found most of them defiantly disobedient",
    normalizedText: "وما وجدنا لاكثرهم من عهد وان وجدنا اكثرهم لفسقين",
  },
  {
    verseId: 102,
    name: "الأعراف",
    surahId: 7,
    text: "ثُمَّ بَعَثۡنَا مِنۢ بَعۡدِهِم مُّوسَىٰ بِـَٔايَٰتِنَآ إِلَىٰ فِرۡعَوۡنَ وَمَلَإِيْهِۦ فَظَلَمُواْ بِهَاۖ فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُفۡسِدِينَ",
    translation:
      "Then We sent after them Moses with Our signs to Pharaoh and his establishment, but they were unjust toward them. So see how was the end of the corrupters",
    normalizedText:
      "ثم بعثنا من بعدهم موسى بايتنا الى فرعون وملايه فظلموا بها فانظر كيف كان عقبة المفسدين",
  },
  {
    verseId: 103,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَالَ مُوسَىٰ يَٰفِرۡعَوۡنُ إِنِّي رَسُولٞ مِّن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'And Moses said, "O Pharaoh, I am a messenger from the Lord of the worlds',
    normalizedText: "وقال موسى يفرعون اني رسول من رب العلمين",
  },
  {
    verseId: 104,
    name: "الأعراف",
    surahId: 7,
    text: "حَقِيقٌ عَلَىٰٓ أَن لَّآ أَقُولَ عَلَى ٱللَّهِ إِلَّا ٱلۡحَقَّۚ قَدۡ جِئۡتُكُم بِبَيِّنَةٖ مِّن رَّبِّكُمۡ فَأَرۡسِلۡ مَعِيَ بَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation:
      "[Who is] obligated not to say about Allah except the truth. I have come to you with clear evidence from your Lord, so send with me the Children of Israel",
    normalizedText:
      "حقيق على ان لا اقول على الله الا الحق قد جاتكم ببينة من ربكم فارسل معي بني اسرءيل",
  },
  {
    verseId: 105,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ إِن كُنتَ جِئۡتَ بِـَٔايَةٖ فَأۡتِ بِهَآ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      '[Pharaoh] said, "If you have come with a sign, then bring it forth, if you should be of the truthful',
    normalizedText: "قال ان كنت جات باية فات بها ان كنت من الصدقين",
  },
  {
    verseId: 106,
    name: "الأعراف",
    surahId: 7,
    text: "فَأَلۡقَىٰ عَصَاهُ فَإِذَا هِيَ ثُعۡبَانٞ مُّبِينٞ",
    translation:
      "So Moses threw his staff, and suddenly it was a serpent, manifest",
    normalizedText: "فالقى عصاه فاذا هي ثعبان مبين",
  },
  {
    verseId: 107,
    name: "الأعراف",
    surahId: 7,
    text: "وَنَزَعَ يَدَهُۥ فَإِذَا هِيَ بَيۡضَآءُ لِلنَّـٰظِرِينَ",
    translation:
      "And he drew out his hand; thereupon it was white [with radiance] for the observers",
    normalizedText: "ونزع يده فاذا هي بيضاء للنظرين",
  },
  {
    verseId: 108,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ ٱلۡمَلَأُ مِن قَوۡمِ فِرۡعَوۡنَ إِنَّ هَٰذَا لَسَٰحِرٌ عَلِيمٞ",
    translation:
      'Said the eminent among the people of Pharaoh, "Indeed, this is a learned magician',
    normalizedText: "قال الملا من قوم فرعون ان هذا لسحر عليم",
  },
  {
    verseId: 109,
    name: "الأعراف",
    surahId: 7,
    text: "يُرِيدُ أَن يُخۡرِجَكُم مِّنۡ أَرۡضِكُمۡۖ فَمَاذَا تَأۡمُرُونَ",
    translation:
      "Who wants to expel you from your land [through magic], so what do you instruct",
    normalizedText: "يريد ان يخرجكم من ارضكم فماذا تامرون",
  },
  {
    verseId: 110,
    name: "الأعراف",
    surahId: 7,
    text: "قَالُوٓاْ أَرۡجِهۡ وَأَخَاهُ وَأَرۡسِلۡ فِي ٱلۡمَدَآئِنِ حَٰشِرِينَ",
    translation:
      'They said, "Postpone [the matter of] him and his brother and send among the cities gatherers',
    normalizedText: "قالوا ارجه واخاه وارسل في المداان حشرين",
  },
  {
    verseId: 111,
    name: "الأعراف",
    surahId: 7,
    text: "يَأۡتُوكَ بِكُلِّ سَٰحِرٍ عَلِيمٖ",
    translation: "Who will bring you every learned magician",
    normalizedText: "ياتوك بكل سحر عليم",
  },
  {
    verseId: 112,
    name: "الأعراف",
    surahId: 7,
    text: "وَجَآءَ ٱلسَّحَرَةُ فِرۡعَوۡنَ قَالُوٓاْ إِنَّ لَنَا لَأَجۡرًا إِن كُنَّا نَحۡنُ ٱلۡغَٰلِبِينَ",
    translation:
      'And the magicians came to Pharaoh. They said, "Indeed for us is a reward if we are the predominant',
    normalizedText: "وجاء السحرة فرعون قالوا ان لنا لاجرا ان كنا نحن الغلبين",
  },
  {
    verseId: 113,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ نَعَمۡ وَإِنَّكُمۡ لَمِنَ ٱلۡمُقَرَّبِينَ",
    translation:
      'He said, "Yes, and, [moreover], you will be among those made near [to me]',
    normalizedText: "قال نعم وانكم لمن المقربين",
  },
  {
    verseId: 114,
    name: "الأعراف",
    surahId: 7,
    text: "قَالُواْ يَٰمُوسَىٰٓ إِمَّآ أَن تُلۡقِيَ وَإِمَّآ أَن نَّكُونَ نَحۡنُ ٱلۡمُلۡقِينَ",
    translation:
      'They said, "O Moses, either you throw [your staff], or we will be the ones to throw [first]',
    normalizedText: "قالوا يموسى اما ان تلقي واما ان نكون نحن الملقين",
  },
  {
    verseId: 115,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ أَلۡقُواْۖ فَلَمَّآ أَلۡقَوۡاْ سَحَرُوٓاْ أَعۡيُنَ ٱلنَّاسِ وَٱسۡتَرۡهَبُوهُمۡ وَجَآءُو بِسِحۡرٍ عَظِيمٖ",
    translation:
      'He said, "Throw," and when they threw, they bewitched the eyes of the people and struck terror into them, and they presented a great [feat of] magic',
    normalizedText:
      "قال القوا فلما القوا سحروا اعين الناس واسترهبوهم وجاءو بسحر عظيم",
  },
  {
    verseId: 116,
    name: "الأعراف",
    surahId: 7,
    text: "۞وَأَوۡحَيۡنَآ إِلَىٰ مُوسَىٰٓ أَنۡ أَلۡقِ عَصَاكَۖ فَإِذَا هِيَ تَلۡقَفُ مَا يَأۡفِكُونَ",
    translation:
      'And We inspired to Moses, "Throw your staff," and at once it devoured what they were falsifying',
    normalizedText: "۞واوحينا الى موسى ان الق عصاك فاذا هي تلقف ما يافكون",
  },
  {
    verseId: 117,
    name: "الأعراف",
    surahId: 7,
    text: "فَوَقَعَ ٱلۡحَقُّ وَبَطَلَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "So the truth was established, and abolished was what they were doing",
    normalizedText: "فوقع الحق وبطل ما كانوا يعملون",
  },
  {
    verseId: 118,
    name: "الأعراف",
    surahId: 7,
    text: "فَغُلِبُواْ هُنَالِكَ وَٱنقَلَبُواْ صَٰغِرِينَ",
    translation:
      "And Pharaoh and his people were overcome right there and became debased",
    normalizedText: "فغلبوا هنالك وانقلبوا صغرين",
  },
  {
    verseId: 119,
    name: "الأعراف",
    surahId: 7,
    text: "وَأُلۡقِيَ ٱلسَّحَرَةُ سَٰجِدِينَ",
    translation: "And the magicians fell down in prostration [to Allah]",
    normalizedText: "والقي السحرة سجدين",
  },
  {
    verseId: 120,
    name: "الأعراف",
    surahId: 7,
    text: "قَالُوٓاْ ءَامَنَّا بِرَبِّ ٱلۡعَٰلَمِينَ",
    translation: 'They said, "We have believed in the Lord of the worlds',
    normalizedText: "قالوا ءامنا برب العلمين",
  },
  {
    verseId: 121,
    name: "الأعراف",
    surahId: 7,
    text: "رَبِّ مُوسَىٰ وَهَٰرُونَ",
    translation: "The Lord of Moses and Aaron",
    normalizedText: "رب موسى وهرون",
  },
  {
    verseId: 122,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ فِرۡعَوۡنُ ءَامَنتُم بِهِۦ قَبۡلَ أَنۡ ءَاذَنَ لَكُمۡۖ إِنَّ هَٰذَا لَمَكۡرٞ مَّكَرۡتُمُوهُ فِي ٱلۡمَدِينَةِ لِتُخۡرِجُواْ مِنۡهَآ أَهۡلَهَاۖ فَسَوۡفَ تَعۡلَمُونَ",
    translation:
      'Said Pharaoh, "You believed in him before I gave you permission. Indeed, this is a conspiracy which you conspired in the city to expel therefrom its people. But you are going to know',
    normalizedText:
      "قال فرعون ءامنتم به قبل ان ءاذن لكم ان هذا لمكر مكرتموه في المدينة لتخرجوا منها اهلها فسوف تعلمون",
  },
  {
    verseId: 123,
    name: "الأعراف",
    surahId: 7,
    text: "لَأُقَطِّعَنَّ أَيۡدِيَكُمۡ وَأَرۡجُلَكُم مِّنۡ خِلَٰفٖ ثُمَّ لَأُصَلِّبَنَّكُمۡ أَجۡمَعِينَ",
    translation:
      "I will surely cut off your hands and your feet on opposite sides; then I will surely crucify you all",
    normalizedText: "لاقطعن ايديكم وارجلكم من خلف ثم لاصلبنكم اجمعين",
  },
  {
    verseId: 124,
    name: "الأعراف",
    surahId: 7,
    text: "قَالُوٓاْ إِنَّآ إِلَىٰ رَبِّنَا مُنقَلِبُونَ",
    translation: 'They said, "Indeed, to our Lord we will return',
    normalizedText: "قالوا انا الى ربنا منقلبون",
  },
  {
    verseId: 125,
    name: "الأعراف",
    surahId: 7,
    text: "وَمَا تَنقِمُ مِنَّآ إِلَّآ أَنۡ ءَامَنَّا بِـَٔايَٰتِ رَبِّنَا لَمَّا جَآءَتۡنَاۚ رَبَّنَآ أَفۡرِغۡ عَلَيۡنَا صَبۡرٗا وَتَوَفَّنَا مُسۡلِمِينَ",
    translation:
      "And you do not resent us except because we believed in the signs of our Lord when they came to us. Our Lord, pour upon us patience and let us die as Muslims [in submission to You]",
    normalizedText:
      "وما تنقم منا الا ان ءامنا بايت ربنا لما جاءتنا ربنا افرغ علينا صبرا وتوفنا مسلمين",
  },
  {
    verseId: 126,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَالَ ٱلۡمَلَأُ مِن قَوۡمِ فِرۡعَوۡنَ أَتَذَرُ مُوسَىٰ وَقَوۡمَهُۥ لِيُفۡسِدُواْ فِي ٱلۡأَرۡضِ وَيَذَرَكَ وَءَالِهَتَكَۚ قَالَ سَنُقَتِّلُ أَبۡنَآءَهُمۡ وَنَسۡتَحۡيِۦ نِسَآءَهُمۡ وَإِنَّا فَوۡقَهُمۡ قَٰهِرُونَ",
    translation:
      'And the eminent among the people of Pharaoh said," Will you leave Moses and his people to cause corruption in the land and abandon you and your gods?" [Pharaoh] said, "We will kill their sons and keep their women alive; and indeed, we are subjugators over them',
    normalizedText:
      "وقال الملا من قوم فرعون اتذر موسى وقومه ليفسدوا في الارض ويذرك وءالهتك قال سنقتل ابناءهم ونستحي نساءهم وانا فوقهم قهرون",
  },
  {
    verseId: 127,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ مُوسَىٰ لِقَوۡمِهِ ٱسۡتَعِينُواْ بِٱللَّهِ وَٱصۡبِرُوٓاْۖ إِنَّ ٱلۡأَرۡضَ لِلَّهِ يُورِثُهَا مَن يَشَآءُ مِنۡ عِبَادِهِۦۖ وَٱلۡعَٰقِبَةُ لِلۡمُتَّقِينَ",
    translation:
      'Said Moses to his people, "Seek help through Allah and be patient. Indeed, the earth belongs to Allah. He causes to inherit it whom He wills of His servants. And the [best] outcome is for the righteous',
    normalizedText:
      "قال موسى لقومه استعينوا بالله واصبروا ان الارض لله يورثها من يشاء من عباده والعقبة للمتقين",
  },
  {
    verseId: 128,
    name: "الأعراف",
    surahId: 7,
    text: "قَالُوٓاْ أُوذِينَا مِن قَبۡلِ أَن تَأۡتِيَنَا وَمِنۢ بَعۡدِ مَا جِئۡتَنَاۚ قَالَ عَسَىٰ رَبُّكُمۡ أَن يُهۡلِكَ عَدُوَّكُمۡ وَيَسۡتَخۡلِفَكُمۡ فِي ٱلۡأَرۡضِ فَيَنظُرَ كَيۡفَ تَعۡمَلُونَ",
    translation:
      'They said, "We have been harmed before you came to us and after you have come to us." He said, "Perhaps your Lord will destroy your enemy and grant you succession in the land and see how you will do',
    normalizedText:
      "قالوا اوذينا من قبل ان تاتينا ومن بعد ما جاتنا قال عسى ربكم ان يهلك عدوكم ويستخلفكم في الارض فينظر كيف تعملون",
  },
  {
    verseId: 129,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَقَدۡ أَخَذۡنَآ ءَالَ فِرۡعَوۡنَ بِٱلسِّنِينَ وَنَقۡصٖ مِّنَ ٱلثَّمَرَٰتِ لَعَلَّهُمۡ يَذَّكَّرُونَ",
    translation:
      "And We certainly seized the people of Pharaoh with years of famine and a deficiency in fruits that perhaps they would be reminded",
    normalizedText: "ولقد اخذنا ءال فرعون بالسنين ونقص من الثمرت لعلهم يذكرون",
  },
  {
    verseId: 130,
    name: "الأعراف",
    surahId: 7,
    text: "فَإِذَا جَآءَتۡهُمُ ٱلۡحَسَنَةُ قَالُواْ لَنَا هَٰذِهِۦۖ وَإِن تُصِبۡهُمۡ سَيِّئَةٞ يَطَّيَّرُواْ بِمُوسَىٰ وَمَن مَّعَهُۥٓۗ أَلَآ إِنَّمَا طَـٰٓئِرُهُمۡ عِندَ ٱللَّهِ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      'But when good came to them, they said, "This is ours [by right]." And if a bad [condition] struck them, they saw an evil omen in Moses and those with him. Unquestionably, their fortune is with Allah, but most of them do not know',
    normalizedText:
      "فاذا جاءتهم الحسنة قالوا لنا هذه وان تصبهم سياة يطيروا بموسى ومن معه الا انما طارهم عند الله ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 131,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَالُواْ مَهۡمَا تَأۡتِنَا بِهِۦ مِنۡ ءَايَةٖ لِّتَسۡحَرَنَا بِهَا فَمَا نَحۡنُ لَكَ بِمُؤۡمِنِينَ",
    translation:
      'And they said, "No matter what sign you bring us with which to bewitch us, we will not be believers in you',
    normalizedText:
      "وقالوا مهما تاتنا به من ءاية لتسحرنا بها فما نحن لك بمامنين",
  },
  {
    verseId: 132,
    name: "الأعراف",
    surahId: 7,
    text: "فَأَرۡسَلۡنَا عَلَيۡهِمُ ٱلطُّوفَانَ وَٱلۡجَرَادَ وَٱلۡقُمَّلَ وَٱلضَّفَادِعَ وَٱلدَّمَ ءَايَٰتٖ مُّفَصَّلَٰتٖ فَٱسۡتَكۡبَرُواْ وَكَانُواْ قَوۡمٗا مُّجۡرِمِينَ",
    translation:
      "So We sent upon them the flood and locusts and lice and frogs and blood as distinct signs, but they were arrogant and were a criminal people",
    normalizedText:
      "فارسلنا عليهم الطوفان والجراد والقمل والضفادع والدم ءايت مفصلت فاستكبروا وكانوا قوما مجرمين",
  },
  {
    verseId: 133,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَمَّا وَقَعَ عَلَيۡهِمُ ٱلرِّجۡزُ قَالُواْ يَٰمُوسَى ٱدۡعُ لَنَا رَبَّكَ بِمَا عَهِدَ عِندَكَۖ لَئِن كَشَفۡتَ عَنَّا ٱلرِّجۡزَ لَنُؤۡمِنَنَّ لَكَ وَلَنُرۡسِلَنَّ مَعَكَ بَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation:
      'And when the punishment descended upon them, they said, "O Moses, invoke for us your Lord by what He has promised you. If you [can] remove the punishment from us, we will surely believe you, and we will send with you the Children of Israel',
    normalizedText:
      "ولما وقع عليهم الرجز قالوا يموسى ادع لنا ربك بما عهد عندك لان كشفت عنا الرجز لنامنن لك ولنرسلن معك بني اسرءيل",
  },
  {
    verseId: 134,
    name: "الأعراف",
    surahId: 7,
    text: "فَلَمَّا كَشَفۡنَا عَنۡهُمُ ٱلرِّجۡزَ إِلَىٰٓ أَجَلٍ هُم بَٰلِغُوهُ إِذَا هُمۡ يَنكُثُونَ",
    translation:
      "But when We removed the punishment from them until a term which they were to reach, then at once they broke their word",
    normalizedText: "فلما كشفنا عنهم الرجز الى اجل هم بلغوه اذا هم ينكثون",
  },
  {
    verseId: 135,
    name: "الأعراف",
    surahId: 7,
    text: "فَٱنتَقَمۡنَا مِنۡهُمۡ فَأَغۡرَقۡنَٰهُمۡ فِي ٱلۡيَمِّ بِأَنَّهُمۡ كَذَّبُواْ بِـَٔايَٰتِنَا وَكَانُواْ عَنۡهَا غَٰفِلِينَ",
    translation:
      "So We took retribution from them, and We drowned them in the sea because they denied Our signs and were heedless of them",
    normalizedText:
      "فانتقمنا منهم فاغرقنهم في اليم بانهم كذبوا بايتنا وكانوا عنها غفلين",
  },
  {
    verseId: 136,
    name: "الأعراف",
    surahId: 7,
    text: "وَأَوۡرَثۡنَا ٱلۡقَوۡمَ ٱلَّذِينَ كَانُواْ يُسۡتَضۡعَفُونَ مَشَٰرِقَ ٱلۡأَرۡضِ وَمَغَٰرِبَهَا ٱلَّتِي بَٰرَكۡنَا فِيهَاۖ وَتَمَّتۡ كَلِمَتُ رَبِّكَ ٱلۡحُسۡنَىٰ عَلَىٰ بَنِيٓ إِسۡرَـٰٓءِيلَ بِمَا صَبَرُواْۖ وَدَمَّرۡنَا مَا كَانَ يَصۡنَعُ فِرۡعَوۡنُ وَقَوۡمُهُۥ وَمَا كَانُواْ يَعۡرِشُونَ",
    translation:
      "And We caused the people who had been oppressed to inherit the eastern regions of the land and the western ones, which We had blessed. And the good word of your Lord was fulfilled for the Children of Israel because of what they had patiently endured. And We destroyed [all] that Pharaoh and his people were producing and what they had been building",
    normalizedText:
      "واورثنا القوم الذين كانوا يستضعفون مشرق الارض ومغربها التي بركنا فيها وتمت كلمت ربك الحسنى على بني اسرءيل بما صبروا ودمرنا ما كان يصنع فرعون وقومه وما كانوا يعرشون",
  },
  {
    verseId: 137,
    name: "الأعراف",
    surahId: 7,
    text: "وَجَٰوَزۡنَا بِبَنِيٓ إِسۡرَـٰٓءِيلَ ٱلۡبَحۡرَ فَأَتَوۡاْ عَلَىٰ قَوۡمٖ يَعۡكُفُونَ عَلَىٰٓ أَصۡنَامٖ لَّهُمۡۚ قَالُواْ يَٰمُوسَى ٱجۡعَل لَّنَآ إِلَٰهٗا كَمَا لَهُمۡ ءَالِهَةٞۚ قَالَ إِنَّكُمۡ قَوۡمٞ تَجۡهَلُونَ",
    translation:
      'And We took the Children of Israel across the sea; then they came upon a people intent in devotion to [some] idols of theirs. They said, "O Moses, make for us a god just as they have gods." He said, "Indeed, you are a people behaving ignorantly',
    normalizedText:
      "وجوزنا ببني اسرءيل البحر فاتوا على قوم يعكفون على اصنام لهم قالوا يموسى اجعل لنا الها كما لهم ءالهة قال انكم قوم تجهلون",
  },
  {
    verseId: 138,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ هَـٰٓؤُلَآءِ مُتَبَّرٞ مَّا هُمۡ فِيهِ وَبَٰطِلٞ مَّا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Indeed, those [worshippers] - destroyed is that in which they are [engaged], and worthless is whatever they were doing",
    normalizedText: "ان هالاء متبر ما هم فيه وبطل ما كانوا يعملون",
  },
  {
    verseId: 139,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ أَغَيۡرَ ٱللَّهِ أَبۡغِيكُمۡ إِلَٰهٗا وَهُوَ فَضَّلَكُمۡ عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      'He said, "Is it other than Allah I should desire for you as a god while He has preferred you over the worlds',
    normalizedText: "قال اغير الله ابغيكم الها وهو فضلكم على العلمين",
  },
  {
    verseId: 140,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذۡ أَنجَيۡنَٰكُم مِّنۡ ءَالِ فِرۡعَوۡنَ يَسُومُونَكُمۡ سُوٓءَ ٱلۡعَذَابِ يُقَتِّلُونَ أَبۡنَآءَكُمۡ وَيَسۡتَحۡيُونَ نِسَآءَكُمۡۚ وَفِي ذَٰلِكُم بَلَآءٞ مِّن رَّبِّكُمۡ عَظِيمٞ",
    translation:
      "And [recall, O Children of Israel], when We saved you from the people of Pharaoh, [who were] afflicting you with the worst torment - killing your sons and keeping your women alive. And in that was a great trial from your Lord",
    normalizedText:
      "واذ انجينكم من ءال فرعون يسومونكم سوء العذاب يقتلون ابناءكم ويستحيون نساءكم وفي ذلكم بلاء من ربكم عظيم",
  },
  {
    verseId: 141,
    name: "الأعراف",
    surahId: 7,
    text: "۞وَوَٰعَدۡنَا مُوسَىٰ ثَلَٰثِينَ لَيۡلَةٗ وَأَتۡمَمۡنَٰهَا بِعَشۡرٖ فَتَمَّ مِيقَٰتُ رَبِّهِۦٓ أَرۡبَعِينَ لَيۡلَةٗۚ وَقَالَ مُوسَىٰ لِأَخِيهِ هَٰرُونَ ٱخۡلُفۡنِي فِي قَوۡمِي وَأَصۡلِحۡ وَلَا تَتَّبِعۡ سَبِيلَ ٱلۡمُفۡسِدِينَ",
    translation:
      'And We made an appointment with Moses for thirty nights and perfected them by [the addition of] ten; so the term of his Lord was completed as forty nights. And Moses said to his brother Aaron, "Take my place among my people, do right [by them], and do not follow the way of the corrupters',
    normalizedText:
      "۞ووعدنا موسى ثلثين ليلة واتممنها بعشر فتم ميقت ربه اربعين ليلة وقال موسى لاخيه هرون اخلفني في قومي واصلح ولا تتبع سبيل المفسدين",
  },
  {
    verseId: 142,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَمَّا جَآءَ مُوسَىٰ لِمِيقَٰتِنَا وَكَلَّمَهُۥ رَبُّهُۥ قَالَ رَبِّ أَرِنِيٓ أَنظُرۡ إِلَيۡكَۚ قَالَ لَن تَرَىٰنِي وَلَٰكِنِ ٱنظُرۡ إِلَى ٱلۡجَبَلِ فَإِنِ ٱسۡتَقَرَّ مَكَانَهُۥ فَسَوۡفَ تَرَىٰنِيۚ فَلَمَّا تَجَلَّىٰ رَبُّهُۥ لِلۡجَبَلِ جَعَلَهُۥ دَكّٗا وَخَرَّ مُوسَىٰ صَعِقٗاۚ فَلَمَّآ أَفَاقَ قَالَ سُبۡحَٰنَكَ تُبۡتُ إِلَيۡكَ وَأَنَا۠ أَوَّلُ ٱلۡمُؤۡمِنِينَ",
    translation:
      'And when Moses arrived at Our appointed time and his Lord spoke to him, he said, "My Lord, show me [Yourself] that I may look at You." [Allah] said, "You will not see Me, but look at the mountain; if it should remain in place, then you will see Me." But when his Lord appeared to the mountain, He rendered it level, and Moses fell unconscious. And when he awoke, he said, "Exalted are You! I have repented to You, and I am the first of the believers',
    normalizedText:
      "ولما جاء موسى لميقتنا وكلمه ربه قال رب ارني انظر اليك قال لن ترىني ولكن انظر الى الجبل فان استقر مكانه فسوف ترىني فلما تجلى ربه للجبل جعله دكا وخر موسى صعقا فلما افاق قال سبحنك تبت اليك وانا اول المامنين",
  },
  {
    verseId: 143,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ يَٰمُوسَىٰٓ إِنِّي ٱصۡطَفَيۡتُكَ عَلَى ٱلنَّاسِ بِرِسَٰلَٰتِي وَبِكَلَٰمِي فَخُذۡ مَآ ءَاتَيۡتُكَ وَكُن مِّنَ ٱلشَّـٰكِرِينَ",
    translation:
      '[Allah] said, "O Moses, I have chosen you over the people with My messages and My words [to you]. So take what I have given you and be among the grateful',
    normalizedText:
      "قال يموسى اني اصطفيتك على الناس برسلتي وبكلمي فخذ ما ءاتيتك وكن من الشكرين",
  },
  {
    verseId: 144,
    name: "الأعراف",
    surahId: 7,
    text: "وَكَتَبۡنَا لَهُۥ فِي ٱلۡأَلۡوَاحِ مِن كُلِّ شَيۡءٖ مَّوۡعِظَةٗ وَتَفۡصِيلٗا لِّكُلِّ شَيۡءٖ فَخُذۡهَا بِقُوَّةٖ وَأۡمُرۡ قَوۡمَكَ يَأۡخُذُواْ بِأَحۡسَنِهَاۚ سَأُوْرِيكُمۡ دَارَ ٱلۡفَٰسِقِينَ",
    translation:
      'And We wrote for him on the tablets [something] of all things - instruction and explanation for all things, [saying], "Take them with determination and order your people to take the best of it. I will show you the home of the defiantly disobedient',
    normalizedText:
      "وكتبنا له في الالواح من كل شيء موعظة وتفصيلا لكل شيء فخذها بقوة وامر قومك ياخذوا باحسنها ساوريكم دار الفسقين",
  },
  {
    verseId: 145,
    name: "الأعراف",
    surahId: 7,
    text: "سَأَصۡرِفُ عَنۡ ءَايَٰتِيَ ٱلَّذِينَ يَتَكَبَّرُونَ فِي ٱلۡأَرۡضِ بِغَيۡرِ ٱلۡحَقِّ وَإِن يَرَوۡاْ كُلَّ ءَايَةٖ لَّا يُؤۡمِنُواْ بِهَا وَإِن يَرَوۡاْ سَبِيلَ ٱلرُّشۡدِ لَا يَتَّخِذُوهُ سَبِيلٗا وَإِن يَرَوۡاْ سَبِيلَ ٱلۡغَيِّ يَتَّخِذُوهُ سَبِيلٗاۚ ذَٰلِكَ بِأَنَّهُمۡ كَذَّبُواْ بِـَٔايَٰتِنَا وَكَانُواْ عَنۡهَا غَٰفِلِينَ",
    translation:
      "I will turn away from My signs those who are arrogant upon the earth without right; and if they should see every sign, they will not believe in it. And if they see the way of consciousness, they will not adopt it as a way; but if they see the way of error, they will adopt it as a way. That is because they have denied Our signs and they were heedless of them",
    normalizedText:
      "ساصرف عن ءايتي الذين يتكبرون في الارض بغير الحق وان يروا كل ءاية لا يامنوا بها وان يروا سبيل الرشد لا يتخذوه سبيلا وان يروا سبيل الغي يتخذوه سبيلا ذلك بانهم كذبوا بايتنا وكانوا عنها غفلين",
  },
  {
    verseId: 146,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا وَلِقَآءِ ٱلۡأٓخِرَةِ حَبِطَتۡ أَعۡمَٰلُهُمۡۚ هَلۡ يُجۡزَوۡنَ إِلَّا مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Those who denied Our signs and the meeting of the Hereafter - their deeds have become worthless. Are they recompensed except for what they used to do",
    normalizedText:
      "والذين كذبوا بايتنا ولقاء الاخرة حبطت اعملهم هل يجزون الا ما كانوا يعملون",
  },
  {
    verseId: 147,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱتَّخَذَ قَوۡمُ مُوسَىٰ مِنۢ بَعۡدِهِۦ مِنۡ حُلِيِّهِمۡ عِجۡلٗا جَسَدٗا لَّهُۥ خُوَارٌۚ أَلَمۡ يَرَوۡاْ أَنَّهُۥ لَا يُكَلِّمُهُمۡ وَلَا يَهۡدِيهِمۡ سَبِيلًاۘ ٱتَّخَذُوهُ وَكَانُواْ ظَٰلِمِينَ",
    translation:
      "And the people of Moses made, after [his departure], from their ornaments a calf - an image having a lowing sound. Did they not see that it could neither speak to them nor guide them to a way? They took it [for worship], and they were wrongdoers",
    normalizedText:
      "واتخذ قوم موسى من بعده من حليهم عجلا جسدا له خوار الم يروا انه لا يكلمهم ولا يهديهم سبيلا اتخذوه وكانوا ظلمين",
  },
  {
    verseId: 148,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَمَّا سُقِطَ فِيٓ أَيۡدِيهِمۡ وَرَأَوۡاْ أَنَّهُمۡ قَدۡ ضَلُّواْ قَالُواْ لَئِن لَّمۡ يَرۡحَمۡنَا رَبُّنَا وَيَغۡفِرۡ لَنَا لَنَكُونَنَّ مِنَ ٱلۡخَٰسِرِينَ",
    translation:
      'And when regret overcame them and they saw that they had gone astray, they said, "If our Lord does not have mercy upon us and forgive us, we will surely be among the losers',
    normalizedText:
      "ولما سقط في ايديهم وراوا انهم قد ضلوا قالوا لان لم يرحمنا ربنا ويغفر لنا لنكونن من الخسرين",
  },
  {
    verseId: 149,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَمَّا رَجَعَ مُوسَىٰٓ إِلَىٰ قَوۡمِهِۦ غَضۡبَٰنَ أَسِفٗا قَالَ بِئۡسَمَا خَلَفۡتُمُونِي مِنۢ بَعۡدِيٓۖ أَعَجِلۡتُمۡ أَمۡرَ رَبِّكُمۡۖ وَأَلۡقَى ٱلۡأَلۡوَاحَ وَأَخَذَ بِرَأۡسِ أَخِيهِ يَجُرُّهُۥٓ إِلَيۡهِۚ قَالَ ٱبۡنَ أُمَّ إِنَّ ٱلۡقَوۡمَ ٱسۡتَضۡعَفُونِي وَكَادُواْ يَقۡتُلُونَنِي فَلَا تُشۡمِتۡ بِيَ ٱلۡأَعۡدَآءَ وَلَا تَجۡعَلۡنِي مَعَ ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      'And when Moses returned to his people, angry and grieved, he said, "How wretched is that by which you have replaced me after [my departure]. Were you impatient over the matter of your Lord?" And he threw down the tablets and seized his brother by [the hair of] his head, pulling him toward him. [Aaron] said, "O son of my mother, indeed the people oppressed me and were about to kill me, so let not the enemies rejoice over me and do not place me among the wrongdoing people',
    normalizedText:
      "ولما رجع موسى الى قومه غضبن اسفا قال باسما خلفتموني من بعدي اعجلتم امر ربكم والقى الالواح واخذ براس اخيه يجره اليه قال ابن ام ان القوم استضعفوني وكادوا يقتلونني فلا تشمت بي الاعداء ولا تجعلني مع القوم الظلمين",
  },
  {
    verseId: 150,
    name: "الأعراف",
    surahId: 7,
    text: "قَالَ رَبِّ ٱغۡفِرۡ لِي وَلِأَخِي وَأَدۡخِلۡنَا فِي رَحۡمَتِكَۖ وَأَنتَ أَرۡحَمُ ٱلرَّـٰحِمِينَ",
    translation:
      '[Moses] said, "My Lord, forgive me and my brother and admit us into Your mercy, for You are the most merciful of the merciful',
    normalizedText: "قال رب اغفر لي ولاخي وادخلنا في رحمتك وانت ارحم الرحمين",
  },
  {
    verseId: 151,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ ٱلَّذِينَ ٱتَّخَذُواْ ٱلۡعِجۡلَ سَيَنَالُهُمۡ غَضَبٞ مِّن رَّبِّهِمۡ وَذِلَّةٞ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۚ وَكَذَٰلِكَ نَجۡزِي ٱلۡمُفۡتَرِينَ",
    translation:
      "Indeed, those who took the calf [for worship] will obtain anger from their Lord and humiliation in the life of this world, and thus do We recompense the inventors [of falsehood]",
    normalizedText:
      "ان الذين اتخذوا العجل سينالهم غضب من ربهم وذلة في الحيوة الدنيا وكذلك نجزي المفترين",
  },
  {
    verseId: 152,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلَّذِينَ عَمِلُواْ ٱلسَّيِّـَٔاتِ ثُمَّ تَابُواْ مِنۢ بَعۡدِهَا وَءَامَنُوٓاْ إِنَّ رَبَّكَ مِنۢ بَعۡدِهَا لَغَفُورٞ رَّحِيمٞ",
    translation:
      "But those who committed misdeeds and then repented after them and believed - indeed your Lord, thereafter, is Forgiving and Merciful",
    normalizedText:
      "والذين عملوا السيات ثم تابوا من بعدها وءامنوا ان ربك من بعدها لغفور رحيم",
  },
  {
    verseId: 153,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَمَّا سَكَتَ عَن مُّوسَى ٱلۡغَضَبُ أَخَذَ ٱلۡأَلۡوَاحَۖ وَفِي نُسۡخَتِهَا هُدٗى وَرَحۡمَةٞ لِّلَّذِينَ هُمۡ لِرَبِّهِمۡ يَرۡهَبُونَ",
    translation:
      "And when the anger subsided in Moses, he took up the tablets; and in their inscription was guidance and mercy for those who are fearful of their Lord",
    normalizedText:
      "ولما سكت عن موسى الغضب اخذ الالواح وفي نسختها هدى ورحمة للذين هم لربهم يرهبون",
  },
  {
    verseId: 154,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱخۡتَارَ مُوسَىٰ قَوۡمَهُۥ سَبۡعِينَ رَجُلٗا لِّمِيقَٰتِنَاۖ فَلَمَّآ أَخَذَتۡهُمُ ٱلرَّجۡفَةُ قَالَ رَبِّ لَوۡ شِئۡتَ أَهۡلَكۡتَهُم مِّن قَبۡلُ وَإِيَّـٰيَۖ أَتُهۡلِكُنَا بِمَا فَعَلَ ٱلسُّفَهَآءُ مِنَّآۖ إِنۡ هِيَ إِلَّا فِتۡنَتُكَ تُضِلُّ بِهَا مَن تَشَآءُ وَتَهۡدِي مَن تَشَآءُۖ أَنتَ وَلِيُّنَا فَٱغۡفِرۡ لَنَا وَٱرۡحَمۡنَاۖ وَأَنتَ خَيۡرُ ٱلۡغَٰفِرِينَ",
    translation:
      'And Moses chose from his people seventy men for Our appointment. And when the earthquake seized them, he said, "My Lord, if You had willed, You could have destroyed them before and me [as well]. Would You destroy us for what the foolish among us have done? This is not but Your trial by which You send astray whom You will and guide whom You will. You are our Protector, so forgive us and have mercy upon us; and You are the best of forgivers',
    normalizedText:
      "واختار موسى قومه سبعين رجلا لميقتنا فلما اخذتهم الرجفة قال رب لو شات اهلكتهم من قبل وايي اتهلكنا بما فعل السفهاء منا ان هي الا فتنتك تضل بها من تشاء وتهدي من تشاء انت ولينا فاغفر لنا وارحمنا وانت خير الغفرين",
  },
  {
    verseId: 155,
    name: "الأعراف",
    surahId: 7,
    text: "۞وَٱكۡتُبۡ لَنَا فِي هَٰذِهِ ٱلدُّنۡيَا حَسَنَةٗ وَفِي ٱلۡأٓخِرَةِ إِنَّا هُدۡنَآ إِلَيۡكَۚ قَالَ عَذَابِيٓ أُصِيبُ بِهِۦ مَنۡ أَشَآءُۖ وَرَحۡمَتِي وَسِعَتۡ كُلَّ شَيۡءٖۚ فَسَأَكۡتُبُهَا لِلَّذِينَ يَتَّقُونَ وَيُؤۡتُونَ ٱلزَّكَوٰةَ وَٱلَّذِينَ هُم بِـَٔايَٰتِنَا يُؤۡمِنُونَ",
    translation:
      'And decree for us in this world [that which is] good and [also] in the Hereafter; indeed, we have turned back to You." [Allah] said, "My punishment - I afflict with it whom I will, but My mercy encompasses all things." So I will decree it [especially] for those who fear Me and give zakah and those who believe in Our verses',
    normalizedText:
      "۞واكتب لنا في هذه الدنيا حسنة وفي الاخرة انا هدنا اليك قال عذابي اصيب به من اشاء ورحمتي وسعت كل شيء فساكتبها للذين يتقون وياتون الزكوة والذين هم بايتنا يامنون",
  },
  {
    verseId: 156,
    name: "الأعراف",
    surahId: 7,
    text: "ٱلَّذِينَ يَتَّبِعُونَ ٱلرَّسُولَ ٱلنَّبِيَّ ٱلۡأُمِّيَّ ٱلَّذِي يَجِدُونَهُۥ مَكۡتُوبًا عِندَهُمۡ فِي ٱلتَّوۡرَىٰةِ وَٱلۡإِنجِيلِ يَأۡمُرُهُم بِٱلۡمَعۡرُوفِ وَيَنۡهَىٰهُمۡ عَنِ ٱلۡمُنكَرِ وَيُحِلُّ لَهُمُ ٱلطَّيِّبَٰتِ وَيُحَرِّمُ عَلَيۡهِمُ ٱلۡخَبَـٰٓئِثَ وَيَضَعُ عَنۡهُمۡ إِصۡرَهُمۡ وَٱلۡأَغۡلَٰلَ ٱلَّتِي كَانَتۡ عَلَيۡهِمۡۚ فَٱلَّذِينَ ءَامَنُواْ بِهِۦ وَعَزَّرُوهُ وَنَصَرُوهُ وَٱتَّبَعُواْ ٱلنُّورَ ٱلَّذِيٓ أُنزِلَ مَعَهُۥٓ أُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "Those who follow the Messenger, the unlettered prophet, whom they find written in what they have of the Torah and the Gospel, who enjoins upon them what is right and forbids them what is wrong and makes lawful for them the good things and prohibits for them the evil and relieves them of their burden and the shackles which were upon them. So they who have believed in him, honored him, supported him and followed the light which was sent down with him - it is those who will be the successful",
    normalizedText:
      "الذين يتبعون الرسول النبي الامي الذي يجدونه مكتوبا عندهم في التورىة والانجيل يامرهم بالمعروف وينهىهم عن المنكر ويحل لهم الطيبت ويحرم عليهم الخباث ويضع عنهم اصرهم والاغلل التي كانت عليهم فالذين ءامنوا به وعزروه ونصروه واتبعوا النور الذي انزل معه اولاك هم المفلحون",
  },
  {
    verseId: 157,
    name: "الأعراف",
    surahId: 7,
    text: "قُلۡ يَـٰٓأَيُّهَا ٱلنَّاسُ إِنِّي رَسُولُ ٱللَّهِ إِلَيۡكُمۡ جَمِيعًا ٱلَّذِي لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ لَآ إِلَٰهَ إِلَّا هُوَ يُحۡيِۦ وَيُمِيتُۖ فَـَٔامِنُواْ بِٱللَّهِ وَرَسُولِهِ ٱلنَّبِيِّ ٱلۡأُمِّيِّ ٱلَّذِي يُؤۡمِنُ بِٱللَّهِ وَكَلِمَٰتِهِۦ وَٱتَّبِعُوهُ لَعَلَّكُمۡ تَهۡتَدُونَ",
    translation:
      'Say, [O Muhammad], "O mankind, indeed I am the Messenger of Allah to you all, [from Him] to whom belongs the dominion of the heavens and the earth. There is no deity except Him; He gives life and causes death." So believe in Allah and His Messenger, the unlettered prophet, who believes in Allah and His words, and follow him that you may be guided',
    normalizedText:
      "قل يايها الناس اني رسول الله اليكم جميعا الذي له ملك السموت والارض لا اله الا هو يحي ويميت فامنوا بالله ورسوله النبي الامي الذي يامن بالله وكلمته واتبعوه لعلكم تهتدون",
  },
  {
    verseId: 158,
    name: "الأعراف",
    surahId: 7,
    text: "وَمِن قَوۡمِ مُوسَىٰٓ أُمَّةٞ يَهۡدُونَ بِٱلۡحَقِّ وَبِهِۦ يَعۡدِلُونَ",
    translation:
      "And among the people of Moses is a community which guides by truth and by it establishes justice",
    normalizedText: "ومن قوم موسى امة يهدون بالحق وبه يعدلون",
  },
  {
    verseId: 159,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَطَّعۡنَٰهُمُ ٱثۡنَتَيۡ عَشۡرَةَ أَسۡبَاطًا أُمَمٗاۚ وَأَوۡحَيۡنَآ إِلَىٰ مُوسَىٰٓ إِذِ ٱسۡتَسۡقَىٰهُ قَوۡمُهُۥٓ أَنِ ٱضۡرِب بِّعَصَاكَ ٱلۡحَجَرَۖ فَٱنۢبَجَسَتۡ مِنۡهُ ٱثۡنَتَا عَشۡرَةَ عَيۡنٗاۖ قَدۡ عَلِمَ كُلُّ أُنَاسٖ مَّشۡرَبَهُمۡۚ وَظَلَّلۡنَا عَلَيۡهِمُ ٱلۡغَمَٰمَ وَأَنزَلۡنَا عَلَيۡهِمُ ٱلۡمَنَّ وَٱلسَّلۡوَىٰۖ كُلُواْ مِن طَيِّبَٰتِ مَا رَزَقۡنَٰكُمۡۚ وَمَا ظَلَمُونَا وَلَٰكِن كَانُوٓاْ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      'And We divided them into twelve descendant tribes [as distinct] nations. And We inspired to Moses when his people implored him for water, "Strike with your staff the stone," and there gushed forth from it twelve springs. Every people knew its watering place. And We shaded them with clouds and sent down upon them manna and quails, [saying], "Eat from the good things with which We have provided you." And they wronged Us not, but they were [only] wronging themselves',
    normalizedText:
      "وقطعنهم اثنتي عشرة اسباطا امما واوحينا الى موسى اذ استسقىه قومه ان اضرب بعصاك الحجر فانبجست منه اثنتا عشرة عينا قد علم كل اناس مشربهم وظللنا عليهم الغمم وانزلنا عليهم المن والسلوى كلوا من طيبت ما رزقنكم وما ظلمونا ولكن كانوا انفسهم يظلمون",
  },
  {
    verseId: 160,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذۡ قِيلَ لَهُمُ ٱسۡكُنُواْ هَٰذِهِ ٱلۡقَرۡيَةَ وَكُلُواْ مِنۡهَا حَيۡثُ شِئۡتُمۡ وَقُولُواْ حِطَّةٞ وَٱدۡخُلُواْ ٱلۡبَابَ سُجَّدٗا نَّغۡفِرۡ لَكُمۡ خَطِيٓـَٰٔتِكُمۡۚ سَنَزِيدُ ٱلۡمُحۡسِنِينَ",
    translation: `And [mention, O Muhammad], when it was said to them, "Dwell in this city and eat from it wherever you will and say, 'Relieve us of our burdens,' and enter the gate bowing humbly; We will [then] forgive you your sins. We will increase the doers of good [in goodness and reward]`,
    normalizedText:
      "واذ قيل لهم اسكنوا هذه القرية وكلوا منها حيث شاتم وقولوا حطة وادخلوا الباب سجدا نغفر لكم خطيتكم سنزيد المحسنين",
  },
  {
    verseId: 161,
    name: "الأعراف",
    surahId: 7,
    text: "فَبَدَّلَ ٱلَّذِينَ ظَلَمُواْ مِنۡهُمۡ قَوۡلًا غَيۡرَ ٱلَّذِي قِيلَ لَهُمۡ فَأَرۡسَلۡنَا عَلَيۡهِمۡ رِجۡزٗا مِّنَ ٱلسَّمَآءِ بِمَا كَانُواْ يَظۡلِمُونَ",
    translation:
      "But those who wronged among them changed [the words] to a statement other than that which had been said to them. So We sent upon them a punishment from the sky for the wrong that they were doing",
    normalizedText:
      "فبدل الذين ظلموا منهم قولا غير الذي قيل لهم فارسلنا عليهم رجزا من السماء بما كانوا يظلمون",
  },
  {
    verseId: 162,
    name: "الأعراف",
    surahId: 7,
    text: "وَسۡـَٔلۡهُمۡ عَنِ ٱلۡقَرۡيَةِ ٱلَّتِي كَانَتۡ حَاضِرَةَ ٱلۡبَحۡرِ إِذۡ يَعۡدُونَ فِي ٱلسَّبۡتِ إِذۡ تَأۡتِيهِمۡ حِيتَانُهُمۡ يَوۡمَ سَبۡتِهِمۡ شُرَّعٗا وَيَوۡمَ لَا يَسۡبِتُونَ لَا تَأۡتِيهِمۡۚ كَذَٰلِكَ نَبۡلُوهُم بِمَا كَانُواْ يَفۡسُقُونَ",
    translation:
      "And ask them about the town that was by the sea - when they transgressed in [the matter of] the sabbath - when their fish came to them openly on their sabbath day, and the day they had no sabbath they did not come to them. Thus did We give them trial because they were defiantly disobedient",
    normalizedText:
      "وسلهم عن القرية التي كانت حاضرة البحر اذ يعدون في السبت اذ تاتيهم حيتانهم يوم سبتهم شرعا ويوم لا يسبتون لا تاتيهم كذلك نبلوهم بما كانوا يفسقون",
  },
  {
    verseId: 163,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذۡ قَالَتۡ أُمَّةٞ مِّنۡهُمۡ لِمَ تَعِظُونَ قَوۡمًا ٱللَّهُ مُهۡلِكُهُمۡ أَوۡ مُعَذِّبُهُمۡ عَذَابٗا شَدِيدٗاۖ قَالُواْ مَعۡذِرَةً إِلَىٰ رَبِّكُمۡ وَلَعَلَّهُمۡ يَتَّقُونَ",
    translation:
      'And when a community among them said, "Why do you advise [or warn] a people whom Allah is [about] to destroy or to punish with a severe punishment?" they [the advisors] said, "To be absolved before your Lord and perhaps they may fear Him',
    normalizedText:
      "واذ قالت امة منهم لم تعظون قوما الله مهلكهم او معذبهم عذابا شديدا قالوا معذرة الى ربكم ولعلهم يتقون",
  },
  {
    verseId: 164,
    name: "الأعراف",
    surahId: 7,
    text: "فَلَمَّا نَسُواْ مَا ذُكِّرُواْ بِهِۦٓ أَنجَيۡنَا ٱلَّذِينَ يَنۡهَوۡنَ عَنِ ٱلسُّوٓءِ وَأَخَذۡنَا ٱلَّذِينَ ظَلَمُواْ بِعَذَابِۭ بَـِٔيسِۭ بِمَا كَانُواْ يَفۡسُقُونَ",
    translation:
      "And when they forgot that by which they had been reminded, We saved those who had forbidden evil and seized those who wronged, with a wretched punishment, because they were defiantly disobeying",
    normalizedText:
      "فلما نسوا ما ذكروا به انجينا الذين ينهون عن السوء واخذنا الذين ظلموا بعذاب بيس بما كانوا يفسقون",
  },
  {
    verseId: 165,
    name: "الأعراف",
    surahId: 7,
    text: "فَلَمَّا عَتَوۡاْ عَن مَّا نُهُواْ عَنۡهُ قُلۡنَا لَهُمۡ كُونُواْ قِرَدَةً خَٰسِـِٔينَ",
    translation:
      'So when they were insolent about that which they had been forbidden, We said to them, "Be apes, despised',
    normalizedText: "فلما عتوا عن ما نهوا عنه قلنا لهم كونوا قردة خسين",
  },
  {
    verseId: 166,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذۡ تَأَذَّنَ رَبُّكَ لَيَبۡعَثَنَّ عَلَيۡهِمۡ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ مَن يَسُومُهُمۡ سُوٓءَ ٱلۡعَذَابِۗ إِنَّ رَبَّكَ لَسَرِيعُ ٱلۡعِقَابِ وَإِنَّهُۥ لَغَفُورٞ رَّحِيمٞ",
    translation:
      "And [mention] when your Lord declared that He would surely [continue to] send upon them until the Day of Resurrection those who would afflict them with the worst torment. Indeed, your Lord is swift in penalty; but indeed, He is Forgiving and Merciful",
    normalizedText:
      "واذ تاذن ربك ليبعثن عليهم الى يوم القيمة من يسومهم سوء العذاب ان ربك لسريع العقاب وانه لغفور رحيم",
  },
  {
    verseId: 167,
    name: "الأعراف",
    surahId: 7,
    text: "وَقَطَّعۡنَٰهُمۡ فِي ٱلۡأَرۡضِ أُمَمٗاۖ مِّنۡهُمُ ٱلصَّـٰلِحُونَ وَمِنۡهُمۡ دُونَ ذَٰلِكَۖ وَبَلَوۡنَٰهُم بِٱلۡحَسَنَٰتِ وَٱلسَّيِّـَٔاتِ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      "And We divided them throughout the earth into nations. Of them some were righteous, and of them some were otherwise. And We tested them with good [times] and bad that perhaps they would return [to obedience]",
    normalizedText:
      "وقطعنهم في الارض امما منهم الصلحون ومنهم دون ذلك وبلونهم بالحسنت والسيات لعلهم يرجعون",
  },
  {
    verseId: 168,
    name: "الأعراف",
    surahId: 7,
    text: "فَخَلَفَ مِنۢ بَعۡدِهِمۡ خَلۡفٞ وَرِثُواْ ٱلۡكِتَٰبَ يَأۡخُذُونَ عَرَضَ هَٰذَا ٱلۡأَدۡنَىٰ وَيَقُولُونَ سَيُغۡفَرُ لَنَا وَإِن يَأۡتِهِمۡ عَرَضٞ مِّثۡلُهُۥ يَأۡخُذُوهُۚ أَلَمۡ يُؤۡخَذۡ عَلَيۡهِم مِّيثَٰقُ ٱلۡكِتَٰبِ أَن لَّا يَقُولُواْ عَلَى ٱللَّهِ إِلَّا ٱلۡحَقَّ وَدَرَسُواْ مَا فِيهِۗ وَٱلدَّارُ ٱلۡأٓخِرَةُ خَيۡرٞ لِّلَّذِينَ يَتَّقُونَۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      'And there followed them successors who inherited the Scripture [while] taking the commodities of this lower life and saying, "It will be forgiven for us." And if an offer like it comes to them, they will [again] take it. Was not the covenant of the Scripture taken from them that they would not say about Allah except the truth, and they studied what was in it? And the home of the Hereafter is better for those who fear Allah, so will you not use reason',
    normalizedText:
      "فخلف من بعدهم خلف ورثوا الكتب ياخذون عرض هذا الادنى ويقولون سيغفر لنا وان ياتهم عرض مثله ياخذوه الم ياخذ عليهم ميثق الكتب ان لا يقولوا على الله الا الحق ودرسوا ما فيه والدار الاخرة خير للذين يتقون افلا تعقلون",
  },
  {
    verseId: 169,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلَّذِينَ يُمَسِّكُونَ بِٱلۡكِتَٰبِ وَأَقَامُواْ ٱلصَّلَوٰةَ إِنَّا لَا نُضِيعُ أَجۡرَ ٱلۡمُصۡلِحِينَ",
    translation:
      "But those who hold fast to the Book and establish prayer - indeed, We will not allow to be lost the reward of the reformers",
    normalizedText:
      "والذين يمسكون بالكتب واقاموا الصلوة انا لا نضيع اجر المصلحين",
  },
  {
    verseId: 170,
    name: "الأعراف",
    surahId: 7,
    text: "۞وَإِذۡ نَتَقۡنَا ٱلۡجَبَلَ فَوۡقَهُمۡ كَأَنَّهُۥ ظُلَّةٞ وَظَنُّوٓاْ أَنَّهُۥ وَاقِعُۢ بِهِمۡ خُذُواْ مَآ ءَاتَيۡنَٰكُم بِقُوَّةٖ وَٱذۡكُرُواْ مَا فِيهِ لَعَلَّكُمۡ تَتَّقُونَ",
    translation:
      'And [mention] when We raised the mountain above them as if it was a dark cloud and they were certain that it would fall upon them, [and Allah said], "Take what We have given you with determination and remember what is in it that you might fear Allah',
    normalizedText:
      "۞واذ نتقنا الجبل فوقهم كانه ظلة وظنوا انه واقع بهم خذوا ما ءاتينكم بقوة واذكروا ما فيه لعلكم تتقون",
  },
  {
    verseId: 171,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذۡ أَخَذَ رَبُّكَ مِنۢ بَنِيٓ ءَادَمَ مِن ظُهُورِهِمۡ ذُرِّيَّتَهُمۡ وَأَشۡهَدَهُمۡ عَلَىٰٓ أَنفُسِهِمۡ أَلَسۡتُ بِرَبِّكُمۡۖ قَالُواْ بَلَىٰ شَهِدۡنَآۚ أَن تَقُولُواْ يَوۡمَ ٱلۡقِيَٰمَةِ إِنَّا كُنَّا عَنۡ هَٰذَا غَٰفِلِينَ",
    translation:
      'And [mention] when your Lord took from the children of Adam - from their loins - their descendants and made them testify of themselves, [saying to them], "Am I not your Lord?" They said, "Yes, we have testified." [This] - lest you should say on the day of Resurrection, "Indeed, we were of this unaware',
    normalizedText:
      "واذ اخذ ربك من بني ءادم من ظهورهم ذريتهم واشهدهم على انفسهم الست بربكم قالوا بلى شهدنا ان تقولوا يوم القيمة انا كنا عن هذا غفلين",
  },
  {
    verseId: 172,
    name: "الأعراف",
    surahId: 7,
    text: "أَوۡ تَقُولُوٓاْ إِنَّمَآ أَشۡرَكَ ءَابَآؤُنَا مِن قَبۡلُ وَكُنَّا ذُرِّيَّةٗ مِّنۢ بَعۡدِهِمۡۖ أَفَتُهۡلِكُنَا بِمَا فَعَلَ ٱلۡمُبۡطِلُونَ",
    translation:
      'Or [lest] you say, "It was only that our fathers associated [others in worship] with Allah before, and we were but descendants after them. Then would You destroy us for what the falsifiers have done',
    normalizedText:
      "او تقولوا انما اشرك ءاباانا من قبل وكنا ذرية من بعدهم افتهلكنا بما فعل المبطلون",
  },
  {
    verseId: 173,
    name: "الأعراف",
    surahId: 7,
    text: "وَكَذَٰلِكَ نُفَصِّلُ ٱلۡأٓيَٰتِ وَلَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      "And thus do We [explain in] detail the verses, and perhaps they will return",
    normalizedText: "وكذلك نفصل الايت ولعلهم يرجعون",
  },
  {
    verseId: 174,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱتۡلُ عَلَيۡهِمۡ نَبَأَ ٱلَّذِيٓ ءَاتَيۡنَٰهُ ءَايَٰتِنَا فَٱنسَلَخَ مِنۡهَا فَأَتۡبَعَهُ ٱلشَّيۡطَٰنُ فَكَانَ مِنَ ٱلۡغَاوِينَ",
    translation:
      "And recite to them, [O Muhammad], the news of him to whom we gave [knowledge of] Our signs, but he detached himself from them; so Satan pursued him, and he became of the deviators",
    normalizedText:
      "واتل عليهم نبا الذي ءاتينه ءايتنا فانسلخ منها فاتبعه الشيطن فكان من الغاوين",
  },
  {
    verseId: 175,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَوۡ شِئۡنَا لَرَفَعۡنَٰهُ بِهَا وَلَٰكِنَّهُۥٓ أَخۡلَدَ إِلَى ٱلۡأَرۡضِ وَٱتَّبَعَ هَوَىٰهُۚ فَمَثَلُهُۥ كَمَثَلِ ٱلۡكَلۡبِ إِن تَحۡمِلۡ عَلَيۡهِ يَلۡهَثۡ أَوۡ تَتۡرُكۡهُ يَلۡهَثۚ ذَّـٰلِكَ مَثَلُ ٱلۡقَوۡمِ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَاۚ فَٱقۡصُصِ ٱلۡقَصَصَ لَعَلَّهُمۡ يَتَفَكَّرُونَ",
    translation:
      "And if We had willed, we could have elevated him thereby, but he adhered [instead] to the earth and followed his own desire. So his example is like that of the dog: if you chase him, he pants, or if you leave him, he [still] pants. That is the example of the people who denied Our signs. So relate the stories that perhaps they will give thought",
    normalizedText:
      "ولو شانا لرفعنه بها ولكنه اخلد الى الارض واتبع هوىه فمثله كمثل الكلب ان تحمل عليه يلهث او تتركه يلهث ذلك مثل القوم الذين كذبوا بايتنا فاقصص القصص لعلهم يتفكرون",
  },
  {
    verseId: 176,
    name: "الأعراف",
    surahId: 7,
    text: "سَآءَ مَثَلًا ٱلۡقَوۡمُ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا وَأَنفُسَهُمۡ كَانُواْ يَظۡلِمُونَ",
    translation:
      "How evil an example [is that of] the people who denied Our signs and used to wrong themselves",
    normalizedText: "ساء مثلا القوم الذين كذبوا بايتنا وانفسهم كانوا يظلمون",
  },
  {
    verseId: 177,
    name: "الأعراف",
    surahId: 7,
    text: "مَن يَهۡدِ ٱللَّهُ فَهُوَ ٱلۡمُهۡتَدِيۖ وَمَن يُضۡلِلۡ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "Whoever Allah guides - he is the [rightly] guided; and whoever He sends astray - it is those who are the losers",
    normalizedText: "من يهد الله فهو المهتدي ومن يضلل فاولاك هم الخسرون",
  },
  {
    verseId: 178,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَقَدۡ ذَرَأۡنَا لِجَهَنَّمَ كَثِيرٗا مِّنَ ٱلۡجِنِّ وَٱلۡإِنسِۖ لَهُمۡ قُلُوبٞ لَّا يَفۡقَهُونَ بِهَا وَلَهُمۡ أَعۡيُنٞ لَّا يُبۡصِرُونَ بِهَا وَلَهُمۡ ءَاذَانٞ لَّا يَسۡمَعُونَ بِهَآۚ أُوْلَـٰٓئِكَ كَٱلۡأَنۡعَٰمِ بَلۡ هُمۡ أَضَلُّۚ أُوْلَـٰٓئِكَ هُمُ ٱلۡغَٰفِلُونَ",
    translation:
      "And We have certainly created for Hell many of the jinn and mankind. They have hearts with which they do not understand, they have eyes with which they do not see, and they have ears with which they do not hear. Those are like livestock; rather, they are more astray. It is they who are the heedless",
    normalizedText:
      "ولقد ذرانا لجهنم كثيرا من الجن والانس لهم قلوب لا يفقهون بها ولهم اعين لا يبصرون بها ولهم ءاذان لا يسمعون بها اولاك كالانعم بل هم اضل اولاك هم الغفلون",
  },
  {
    verseId: 179,
    name: "الأعراف",
    surahId: 7,
    text: "وَلِلَّهِ ٱلۡأَسۡمَآءُ ٱلۡحُسۡنَىٰ فَٱدۡعُوهُ بِهَاۖ وَذَرُواْ ٱلَّذِينَ يُلۡحِدُونَ فِيٓ أَسۡمَـٰٓئِهِۦۚ سَيُجۡزَوۡنَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "And to Allah belong the best names, so invoke Him by them. And leave [the company of] those who practice deviation concerning His names. They will be recompensed for what they have been doing",
    normalizedText:
      "ولله الاسماء الحسنى فادعوه بها وذروا الذين يلحدون في اسماه سيجزون ما كانوا يعملون",
  },
  {
    verseId: 180,
    name: "الأعراف",
    surahId: 7,
    text: "وَمِمَّنۡ خَلَقۡنَآ أُمَّةٞ يَهۡدُونَ بِٱلۡحَقِّ وَبِهِۦ يَعۡدِلُونَ",
    translation:
      "And among those We created is a community which guides by truth and thereby establishes justice",
    normalizedText: "وممن خلقنا امة يهدون بالحق وبه يعدلون",
  },
  {
    verseId: 181,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا سَنَسۡتَدۡرِجُهُم مِّنۡ حَيۡثُ لَا يَعۡلَمُونَ",
    translation:
      "But those who deny Our signs - We will progressively lead them [to destruction] from where they do not know",
    normalizedText: "والذين كذبوا بايتنا سنستدرجهم من حيث لا يعلمون",
  },
  {
    verseId: 182,
    name: "الأعراف",
    surahId: 7,
    text: "وَأُمۡلِي لَهُمۡۚ إِنَّ كَيۡدِي مَتِينٌ",
    translation: "And I will give them time. Indeed, my plan is firm",
    normalizedText: "واملي لهم ان كيدي متين",
  },
  {
    verseId: 183,
    name: "الأعراف",
    surahId: 7,
    text: "أَوَلَمۡ يَتَفَكَّرُواْۗ مَا بِصَاحِبِهِم مِّن جِنَّةٍۚ إِنۡ هُوَ إِلَّا نَذِيرٞ مُّبِينٌ",
    translation:
      "Then do they not give thought? There is in their companion [Muhammad] no madness. He is not but a clear warner",
    normalizedText: "اولم يتفكروا ما بصاحبهم من جنة ان هو الا نذير مبين",
  },
  {
    verseId: 184,
    name: "الأعراف",
    surahId: 7,
    text: "أَوَلَمۡ يَنظُرُواْ فِي مَلَكُوتِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا خَلَقَ ٱللَّهُ مِن شَيۡءٖ وَأَنۡ عَسَىٰٓ أَن يَكُونَ قَدِ ٱقۡتَرَبَ أَجَلُهُمۡۖ فَبِأَيِّ حَدِيثِۭ بَعۡدَهُۥ يُؤۡمِنُونَ",
    translation:
      "Do they not look into the realm of the heavens and the earth and everything that Allah has created and [think] that perhaps their appointed time has come near? So in what statement hereafter will they believe",
    normalizedText:
      "اولم ينظروا في ملكوت السموت والارض وما خلق الله من شيء وان عسى ان يكون قد اقترب اجلهم فباي حديث بعده يامنون",
  },
  {
    verseId: 185,
    name: "الأعراف",
    surahId: 7,
    text: "مَن يُضۡلِلِ ٱللَّهُ فَلَا هَادِيَ لَهُۥۚ وَيَذَرُهُمۡ فِي طُغۡيَٰنِهِمۡ يَعۡمَهُونَ",
    translation:
      "Whoever Allah sends astray - there is no guide for him. And He leaves them in their transgression, wandering blindly",
    normalizedText: "من يضلل الله فلا هادي له ويذرهم في طغينهم يعمهون",
  },
  {
    verseId: 186,
    name: "الأعراف",
    surahId: 7,
    text: "يَسۡـَٔلُونَكَ عَنِ ٱلسَّاعَةِ أَيَّانَ مُرۡسَىٰهَاۖ قُلۡ إِنَّمَا عِلۡمُهَا عِندَ رَبِّيۖ لَا يُجَلِّيهَا لِوَقۡتِهَآ إِلَّا هُوَۚ ثَقُلَتۡ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ لَا تَأۡتِيكُمۡ إِلَّا بَغۡتَةٗۗ يَسۡـَٔلُونَكَ كَأَنَّكَ حَفِيٌّ عَنۡهَاۖ قُلۡ إِنَّمَا عِلۡمُهَا عِندَ ٱللَّهِ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      'They ask you, [O Muhammad], about the Hour: when is its arrival? Say, "Its knowledge is only with my Lord. None will reveal its time except Him. It lays heavily upon the heavens and the earth. It will not come upon you except unexpectedly." They ask you as if you are familiar with it. Say, "Its knowledge is only with Allah, but most of the people do not know',
    normalizedText:
      "يسلونك عن الساعة ايان مرسىها قل انما علمها عند ربي لا يجليها لوقتها الا هو ثقلت في السموت والارض لا تاتيكم الا بغتة يسلونك كانك حفي عنها قل انما علمها عند الله ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 187,
    name: "الأعراف",
    surahId: 7,
    text: "قُل لَّآ أَمۡلِكُ لِنَفۡسِي نَفۡعٗا وَلَا ضَرًّا إِلَّا مَا شَآءَ ٱللَّهُۚ وَلَوۡ كُنتُ أَعۡلَمُ ٱلۡغَيۡبَ لَٱسۡتَكۡثَرۡتُ مِنَ ٱلۡخَيۡرِ وَمَا مَسَّنِيَ ٱلسُّوٓءُۚ إِنۡ أَنَا۠ إِلَّا نَذِيرٞ وَبَشِيرٞ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      'Say, "I hold not for myself [the power of] benefit or harm, except what Allah has willed. And if I knew the unseen, I could have acquired much wealth, and no harm would have touched me. I am not except a warner and a bringer of good tidings to a people who believe',
    normalizedText:
      "قل لا املك لنفسي نفعا ولا ضرا الا ما شاء الله ولو كنت اعلم الغيب لاستكثرت من الخير وما مسني السوء ان انا الا نذير وبشير لقوم يامنون",
  },
  {
    verseId: 188,
    name: "الأعراف",
    surahId: 7,
    text: "۞هُوَ ٱلَّذِي خَلَقَكُم مِّن نَّفۡسٖ وَٰحِدَةٖ وَجَعَلَ مِنۡهَا زَوۡجَهَا لِيَسۡكُنَ إِلَيۡهَاۖ فَلَمَّا تَغَشَّىٰهَا حَمَلَتۡ حَمۡلًا خَفِيفٗا فَمَرَّتۡ بِهِۦۖ فَلَمَّآ أَثۡقَلَت دَّعَوَا ٱللَّهَ رَبَّهُمَا لَئِنۡ ءَاتَيۡتَنَا صَٰلِحٗا لَّنَكُونَنَّ مِنَ ٱلشَّـٰكِرِينَ",
    translation:
      'It is He who created you from one soul and created from it its mate that he might dwell in security with her. And when he covers her, she carries a light burden and continues therein. And when it becomes heavy, they both invoke Allah, their Lord, "If You should give us a good [child], we will surely be among the grateful',
    normalizedText:
      "۞هو الذي خلقكم من نفس وحدة وجعل منها زوجها ليسكن اليها فلما تغشىها حملت حملا خفيفا فمرت به فلما اثقلت دعوا الله ربهما لان ءاتيتنا صلحا لنكونن من الشكرين",
  },
  {
    verseId: 189,
    name: "الأعراف",
    surahId: 7,
    text: "فَلَمَّآ ءَاتَىٰهُمَا صَٰلِحٗا جَعَلَا لَهُۥ شُرَكَآءَ فِيمَآ ءَاتَىٰهُمَاۚ فَتَعَٰلَى ٱللَّهُ عَمَّا يُشۡرِكُونَ",
    translation:
      "But when He gives them a good [child], they ascribe partners to Him concerning that which He has given them. Exalted is Allah above what they associate with Him",
    normalizedText:
      "فلما ءاتىهما صلحا جعلا له شركاء فيما ءاتىهما فتعلى الله عما يشركون",
  },
  {
    verseId: 190,
    name: "الأعراف",
    surahId: 7,
    text: "أَيُشۡرِكُونَ مَا لَا يَخۡلُقُ شَيۡـٔٗا وَهُمۡ يُخۡلَقُونَ",
    translation:
      "Do they associate with Him those who create nothing and they are [themselves] created",
    normalizedText: "ايشركون ما لا يخلق شيا وهم يخلقون",
  },
  {
    verseId: 191,
    name: "الأعراف",
    surahId: 7,
    text: "وَلَا يَسۡتَطِيعُونَ لَهُمۡ نَصۡرٗا وَلَآ أَنفُسَهُمۡ يَنصُرُونَ",
    translation:
      "And the false deities are unable to [give] them help, nor can they help themselves",
    normalizedText: "ولا يستطيعون لهم نصرا ولا انفسهم ينصرون",
  },
  {
    verseId: 192,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِن تَدۡعُوهُمۡ إِلَى ٱلۡهُدَىٰ لَا يَتَّبِعُوكُمۡۚ سَوَآءٌ عَلَيۡكُمۡ أَدَعَوۡتُمُوهُمۡ أَمۡ أَنتُمۡ صَٰمِتُونَ",
    translation:
      "And if you [believers] invite them to guidance, they will not follow you. It is all the same for you whether you invite them or you are silent",
    normalizedText:
      "وان تدعوهم الى الهدى لا يتبعوكم سواء عليكم ادعوتموهم ام انتم صمتون",
  },
  {
    verseId: 193,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ ٱلَّذِينَ تَدۡعُونَ مِن دُونِ ٱللَّهِ عِبَادٌ أَمۡثَالُكُمۡۖ فَٱدۡعُوهُمۡ فَلۡيَسۡتَجِيبُواْ لَكُمۡ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      "Indeed, those you [polytheists] call upon besides Allah are servants like you. So call upon them and let them respond to you, if you should be truthful",
    normalizedText:
      "ان الذين تدعون من دون الله عباد امثالكم فادعوهم فليستجيبوا لكم ان كنتم صدقين",
  },
  {
    verseId: 194,
    name: "الأعراف",
    surahId: 7,
    text: "أَلَهُمۡ أَرۡجُلٞ يَمۡشُونَ بِهَآۖ أَمۡ لَهُمۡ أَيۡدٖ يَبۡطِشُونَ بِهَآۖ أَمۡ لَهُمۡ أَعۡيُنٞ يُبۡصِرُونَ بِهَآۖ أَمۡ لَهُمۡ ءَاذَانٞ يَسۡمَعُونَ بِهَاۗ قُلِ ٱدۡعُواْ شُرَكَآءَكُمۡ ثُمَّ كِيدُونِ فَلَا تُنظِرُونِ",
    translation: `Do they have feet by which they walk? Or do they have hands by which they strike? Or do they have eyes by which they see? Or do they have ears by which they hear? Say, [O Muhammad], "Call your 'partners' and then conspire against me and give me no respite`,
    normalizedText:
      "الهم ارجل يمشون بها ام لهم ايد يبطشون بها ام لهم اعين يبصرون بها ام لهم ءاذان يسمعون بها قل ادعوا شركاءكم ثم كيدون فلا تنظرون",
  },
  {
    verseId: 195,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ وَلِـِّۧيَ ٱللَّهُ ٱلَّذِي نَزَّلَ ٱلۡكِتَٰبَۖ وَهُوَ يَتَوَلَّى ٱلصَّـٰلِحِينَ",
    translation:
      "Indeed, my protector is Allah, who has sent down the Book; and He is an ally to the righteous",
    normalizedText: "ان ولي الله الذي نزل الكتب وهو يتولى الصلحين",
  },
  {
    verseId: 196,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱلَّذِينَ تَدۡعُونَ مِن دُونِهِۦ لَا يَسۡتَطِيعُونَ نَصۡرَكُمۡ وَلَآ أَنفُسَهُمۡ يَنصُرُونَ",
    translation:
      "And those you call upon besides Him are unable to help you, nor can they help themselves",
    normalizedText: "والذين تدعون من دونه لا يستطيعون نصركم ولا انفسهم ينصرون",
  },
  {
    verseId: 197,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِن تَدۡعُوهُمۡ إِلَى ٱلۡهُدَىٰ لَا يَسۡمَعُواْۖ وَتَرَىٰهُمۡ يَنظُرُونَ إِلَيۡكَ وَهُمۡ لَا يُبۡصِرُونَ",
    translation:
      "And if you invite them to guidance, they do not hear; and you see them looking at you while they do not see",
    normalizedText:
      "وان تدعوهم الى الهدى لا يسمعوا وترىهم ينظرون اليك وهم لا يبصرون",
  },
  {
    verseId: 198,
    name: "الأعراف",
    surahId: 7,
    text: "خُذِ ٱلۡعَفۡوَ وَأۡمُرۡ بِٱلۡعُرۡفِ وَأَعۡرِضۡ عَنِ ٱلۡجَٰهِلِينَ",
    translation:
      "Take what is given freely, enjoin what is good, and turn away from the ignorant",
    normalizedText: "خذ العفو وامر بالعرف واعرض عن الجهلين",
  },
  {
    verseId: 199,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِمَّا يَنزَغَنَّكَ مِنَ ٱلشَّيۡطَٰنِ نَزۡغٞ فَٱسۡتَعِذۡ بِٱللَّهِۚ إِنَّهُۥ سَمِيعٌ عَلِيمٌ",
    translation:
      "And if an evil suggestion comes to you from Satan, then seek refuge in Allah. Indeed, He is Hearing and Knowing",
    normalizedText: "واما ينزغنك من الشيطن نزغ فاستعذ بالله انه سميع عليم",
  },
  {
    verseId: 200,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ ٱلَّذِينَ ٱتَّقَوۡاْ إِذَا مَسَّهُمۡ طَـٰٓئِفٞ مِّنَ ٱلشَّيۡطَٰنِ تَذَكَّرُواْ فَإِذَا هُم مُّبۡصِرُونَ",
    translation:
      "Indeed, those who fear Allah - when an impulse touches them from Satan, they remember [Him] and at once they have insight",
    normalizedText:
      "ان الذين اتقوا اذا مسهم طاف من الشيطن تذكروا فاذا هم مبصرون",
  },
  {
    verseId: 201,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِخۡوَٰنُهُمۡ يَمُدُّونَهُمۡ فِي ٱلۡغَيِّ ثُمَّ لَا يُقۡصِرُونَ",
    translation:
      "But their brothers - the devils increase them in error; then they do not stop short",
    normalizedText: "واخونهم يمدونهم في الغي ثم لا يقصرون",
  },
  {
    verseId: 202,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذَا لَمۡ تَأۡتِهِم بِـَٔايَةٖ قَالُواْ لَوۡلَا ٱجۡتَبَيۡتَهَاۚ قُلۡ إِنَّمَآ أَتَّبِعُ مَا يُوحَىٰٓ إِلَيَّ مِن رَّبِّيۚ هَٰذَا بَصَآئِرُ مِن رَّبِّكُمۡ وَهُدٗى وَرَحۡمَةٞ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation: `And when you, [O Muhammad], do not bring them a sign, they say, "Why have you not contrived it?" Say, "I only follow what is revealed to me from my Lord. This [Qur'an] is enlightenment from your Lord and guidance and mercy for a people who believe`,
    normalizedText:
      "واذا لم تاتهم باية قالوا لولا اجتبيتها قل انما اتبع ما يوحى الي من ربي هذا بصاار من ربكم وهدى ورحمة لقوم يامنون",
  },
  {
    verseId: 203,
    name: "الأعراف",
    surahId: 7,
    text: "وَإِذَا قُرِئَ ٱلۡقُرۡءَانُ فَٱسۡتَمِعُواْ لَهُۥ وَأَنصِتُواْ لَعَلَّكُمۡ تُرۡحَمُونَ",
    translation:
      "So when the Qur'an is recited, then listen to it and pay attention that you may receive mercy",
    normalizedText: "واذا قرا القرءان فاستمعوا له وانصتوا لعلكم ترحمون",
  },
  {
    verseId: 204,
    name: "الأعراف",
    surahId: 7,
    text: "وَٱذۡكُر رَّبَّكَ فِي نَفۡسِكَ تَضَرُّعٗا وَخِيفَةٗ وَدُونَ ٱلۡجَهۡرِ مِنَ ٱلۡقَوۡلِ بِٱلۡغُدُوِّ وَٱلۡأٓصَالِ وَلَا تَكُن مِّنَ ٱلۡغَٰفِلِينَ",
    translation:
      "And remember your Lord within yourself in humility and in fear without being apparent in speech - in the mornings and the evenings. And do not be among the heedless",
    normalizedText:
      "واذكر ربك في نفسك تضرعا وخيفة ودون الجهر من القول بالغدو والاصال ولا تكن من الغفلين",
  },
  {
    verseId: 205,
    name: "الأعراف",
    surahId: 7,
    text: "إِنَّ ٱلَّذِينَ عِندَ رَبِّكَ لَا يَسۡتَكۡبِرُونَ عَنۡ عِبَادَتِهِۦ وَيُسَبِّحُونَهُۥ وَلَهُۥ يَسۡجُدُونَۤ۩",
    translation:
      "Indeed, those who are near your Lord are not prevented by arrogance from His worship, and they exalt Him, and to Him they prostrate",
    normalizedText:
      "ان الذين عند ربك لا يستكبرون عن عبادته ويسبحونه وله يسجدون۩",
  },
  {
    verseId: 0,
    name: "الأنفال",
    surahId: 8,
    text: "يَسۡـَٔلُونَكَ عَنِ ٱلۡأَنفَالِۖ قُلِ ٱلۡأَنفَالُ لِلَّهِ وَٱلرَّسُولِۖ فَٱتَّقُواْ ٱللَّهَ وَأَصۡلِحُواْ ذَاتَ بَيۡنِكُمۡۖ وَأَطِيعُواْ ٱللَّهَ وَرَسُولَهُۥٓ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      'They ask you, [O Muhammad], about the bounties [of war]. Say, "The [decision concerning] bounties is for Allah and the Messenger." So fear Allah and amend that which is between you and obey Allah and His Messenger, if you should be believers',
    normalizedText:
      "يسلونك عن الانفال قل الانفال لله والرسول فاتقوا الله واصلحوا ذات بينكم واطيعوا الله ورسوله ان كنتم مامنين",
  },
  {
    verseId: 1,
    name: "الأنفال",
    surahId: 8,
    text: "إِنَّمَا ٱلۡمُؤۡمِنُونَ ٱلَّذِينَ إِذَا ذُكِرَ ٱللَّهُ وَجِلَتۡ قُلُوبُهُمۡ وَإِذَا تُلِيَتۡ عَلَيۡهِمۡ ءَايَٰتُهُۥ زَادَتۡهُمۡ إِيمَٰنٗا وَعَلَىٰ رَبِّهِمۡ يَتَوَكَّلُونَ",
    translation:
      "The believers are only those who, when Allah is mentioned, their hearts become fearful, and when His verses are recited to them, it increases them in faith; and upon their Lord they rely",
    normalizedText:
      "انما المامنون الذين اذا ذكر الله وجلت قلوبهم واذا تليت عليهم ءايته زادتهم ايمنا وعلى ربهم يتوكلون",
  },
  {
    verseId: 2,
    name: "الأنفال",
    surahId: 8,
    text: "ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَمِمَّا رَزَقۡنَٰهُمۡ يُنفِقُونَ",
    translation:
      "The ones who establish prayer, and from what We have provided them, they spend",
    normalizedText: "الذين يقيمون الصلوة ومما رزقنهم ينفقون",
  },
  {
    verseId: 3,
    name: "الأنفال",
    surahId: 8,
    text: "أُوْلَـٰٓئِكَ هُمُ ٱلۡمُؤۡمِنُونَ حَقّٗاۚ لَّهُمۡ دَرَجَٰتٌ عِندَ رَبِّهِمۡ وَمَغۡفِرَةٞ وَرِزۡقٞ كَرِيمٞ",
    translation:
      "Those are the believers, truly. For them are degrees [of high position] with their Lord and forgiveness and noble provision",
    normalizedText: "اولاك هم المامنون حقا لهم درجت عند ربهم ومغفرة ورزق كريم",
  },
  {
    verseId: 4,
    name: "الأنفال",
    surahId: 8,
    text: "كَمَآ أَخۡرَجَكَ رَبُّكَ مِنۢ بَيۡتِكَ بِٱلۡحَقِّ وَإِنَّ فَرِيقٗا مِّنَ ٱلۡمُؤۡمِنِينَ لَكَٰرِهُونَ",
    translation:
      "[It is] just as when your Lord brought you out of your home [for the battle of Badr] in truth, while indeed, a party among the believers were unwilling",
    normalizedText: "كما اخرجك ربك من بيتك بالحق وان فريقا من المامنين لكرهون",
  },
  {
    verseId: 5,
    name: "الأنفال",
    surahId: 8,
    text: "يُجَٰدِلُونَكَ فِي ٱلۡحَقِّ بَعۡدَ مَا تَبَيَّنَ كَأَنَّمَا يُسَاقُونَ إِلَى ٱلۡمَوۡتِ وَهُمۡ يَنظُرُونَ",
    translation:
      "Arguing with you concerning the truth after it had become clear, as if they were being driven toward death while they were looking on",
    normalizedText:
      "يجدلونك في الحق بعد ما تبين كانما يساقون الى الموت وهم ينظرون",
  },
  {
    verseId: 6,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِذۡ يَعِدُكُمُ ٱللَّهُ إِحۡدَى ٱلطَّآئِفَتَيۡنِ أَنَّهَا لَكُمۡ وَتَوَدُّونَ أَنَّ غَيۡرَ ذَاتِ ٱلشَّوۡكَةِ تَكُونُ لَكُمۡ وَيُرِيدُ ٱللَّهُ أَن يُحِقَّ ٱلۡحَقَّ بِكَلِمَٰتِهِۦ وَيَقۡطَعَ دَابِرَ ٱلۡكَٰفِرِينَ",
    translation:
      "[Remember, O believers], when Allah promised you one of the two groups - that it would be yours - and you wished that the unarmed one would be yours. But Allah intended to establish the truth by His words and to eliminate the disbelievers",
    normalizedText:
      "واذ يعدكم الله احدى الطاافتين انها لكم وتودون ان غير ذات الشوكة تكون لكم ويريد الله ان يحق الحق بكلمته ويقطع دابر الكفرين",
  },
  {
    verseId: 7,
    name: "الأنفال",
    surahId: 8,
    text: "لِيُحِقَّ ٱلۡحَقَّ وَيُبۡطِلَ ٱلۡبَٰطِلَ وَلَوۡ كَرِهَ ٱلۡمُجۡرِمُونَ",
    translation:
      "That He should establish the truth and abolish falsehood, even if the criminals disliked it",
    normalizedText: "ليحق الحق ويبطل البطل ولو كره المجرمون",
  },
  {
    verseId: 8,
    name: "الأنفال",
    surahId: 8,
    text: "إِذۡ تَسۡتَغِيثُونَ رَبَّكُمۡ فَٱسۡتَجَابَ لَكُمۡ أَنِّي مُمِدُّكُم بِأَلۡفٖ مِّنَ ٱلۡمَلَـٰٓئِكَةِ مُرۡدِفِينَ",
    translation:
      '[Remember] when you asked help of your Lord, and He answered you, "Indeed, I will reinforce you with a thousand from the angels, following one another',
    normalizedText:
      "اذ تستغيثون ربكم فاستجاب لكم اني ممدكم بالف من الملاكة مردفين",
  },
  {
    verseId: 9,
    name: "الأنفال",
    surahId: 8,
    text: "وَمَا جَعَلَهُ ٱللَّهُ إِلَّا بُشۡرَىٰ وَلِتَطۡمَئِنَّ بِهِۦ قُلُوبُكُمۡۚ وَمَا ٱلنَّصۡرُ إِلَّا مِنۡ عِندِ ٱللَّهِۚ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌ",
    translation:
      "And Allah made it not but good tidings and so that your hearts would be assured thereby. And victory is not but from Allah. Indeed, Allah is Exalted in Might and Wise",
    normalizedText:
      "وما جعله الله الا بشرى ولتطمان به قلوبكم وما النصر الا من عند الله ان الله عزيز حكيم",
  },
  {
    verseId: 10,
    name: "الأنفال",
    surahId: 8,
    text: "إِذۡ يُغَشِّيكُمُ ٱلنُّعَاسَ أَمَنَةٗ مِّنۡهُ وَيُنَزِّلُ عَلَيۡكُم مِّنَ ٱلسَّمَآءِ مَآءٗ لِّيُطَهِّرَكُم بِهِۦ وَيُذۡهِبَ عَنكُمۡ رِجۡزَ ٱلشَّيۡطَٰنِ وَلِيَرۡبِطَ عَلَىٰ قُلُوبِكُمۡ وَيُثَبِّتَ بِهِ ٱلۡأَقۡدَامَ",
    translation:
      "[Remember] when He overwhelmed you with drowsiness [giving] security from Him and sent down upon you from the sky, rain by which to purify you and remove from you the evil [suggestions] of Satan and to make steadfast your hearts and plant firmly thereby your feet",
    normalizedText:
      "اذ يغشيكم النعاس امنة منه وينزل عليكم من السماء ماء ليطهركم به ويذهب عنكم رجز الشيطن وليربط على قلوبكم ويثبت به الاقدام",
  },
  {
    verseId: 11,
    name: "الأنفال",
    surahId: 8,
    text: "إِذۡ يُوحِي رَبُّكَ إِلَى ٱلۡمَلَـٰٓئِكَةِ أَنِّي مَعَكُمۡ فَثَبِّتُواْ ٱلَّذِينَ ءَامَنُواْۚ سَأُلۡقِي فِي قُلُوبِ ٱلَّذِينَ كَفَرُواْ ٱلرُّعۡبَ فَٱضۡرِبُواْ فَوۡقَ ٱلۡأَعۡنَاقِ وَٱضۡرِبُواْ مِنۡهُمۡ كُلَّ بَنَانٖ",
    translation:
      '[Remember] when your Lord inspired to the angels, "I am with you, so strengthen those who have believed. I will cast terror into the hearts of those who disbelieved, so strike [them] upon the necks and strike from them every fingertip',
    normalizedText:
      "اذ يوحي ربك الى الملاكة اني معكم فثبتوا الذين ءامنوا سالقي في قلوب الذين كفروا الرعب فاضربوا فوق الاعناق واضربوا منهم كل بنان",
  },
  {
    verseId: 12,
    name: "الأنفال",
    surahId: 8,
    text: "ذَٰلِكَ بِأَنَّهُمۡ شَآقُّواْ ٱللَّهَ وَرَسُولَهُۥۚ وَمَن يُشَاقِقِ ٱللَّهَ وَرَسُولَهُۥ فَإِنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "That is because they opposed Allah and His Messenger. And whoever opposes Allah and His Messenger - indeed, Allah is severe in penalty",
    normalizedText:
      "ذلك بانهم شاقوا الله ورسوله ومن يشاقق الله ورسوله فان الله شديد العقاب",
  },
  {
    verseId: 13,
    name: "الأنفال",
    surahId: 8,
    text: "ذَٰلِكُمۡ فَذُوقُوهُ وَأَنَّ لِلۡكَٰفِرِينَ عَذَابَ ٱلنَّارِ",
    translation:
      'That [is yours], so taste it." And indeed for the disbelievers is the punishment of the Fire',
    normalizedText: "ذلكم فذوقوه وان للكفرين عذاب النار",
  },
  {
    verseId: 14,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا لَقِيتُمُ ٱلَّذِينَ كَفَرُواْ زَحۡفٗا فَلَا تُوَلُّوهُمُ ٱلۡأَدۡبَارَ",
    translation:
      "O you who have believed, when you meet those who disbelieve advancing [for battle], do not turn to them your backs [in flight]",
    normalizedText:
      "يايها الذين ءامنوا اذا لقيتم الذين كفروا زحفا فلا تولوهم الادبار",
  },
  {
    verseId: 15,
    name: "الأنفال",
    surahId: 8,
    text: "وَمَن يُوَلِّهِمۡ يَوۡمَئِذٖ دُبُرَهُۥٓ إِلَّا مُتَحَرِّفٗا لِّقِتَالٍ أَوۡ مُتَحَيِّزًا إِلَىٰ فِئَةٖ فَقَدۡ بَآءَ بِغَضَبٖ مِّنَ ٱللَّهِ وَمَأۡوَىٰهُ جَهَنَّمُۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "And whoever turns his back to them on such a day, unless swerving [as a strategy] for war or joining [another] company, has certainly returned with anger [upon him] from Allah, and his refuge is Hell - and wretched is the destination",
    normalizedText:
      "ومن يولهم يوماذ دبره الا متحرفا لقتال او متحيزا الى فاة فقد باء بغضب من الله وماوىه جهنم وباس المصير",
  },
  {
    verseId: 16,
    name: "الأنفال",
    surahId: 8,
    text: "فَلَمۡ تَقۡتُلُوهُمۡ وَلَٰكِنَّ ٱللَّهَ قَتَلَهُمۡۚ وَمَا رَمَيۡتَ إِذۡ رَمَيۡتَ وَلَٰكِنَّ ٱللَّهَ رَمَىٰ وَلِيُبۡلِيَ ٱلۡمُؤۡمِنِينَ مِنۡهُ بَلَآءً حَسَنًاۚ إِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٞ",
    translation:
      "And you did not kill them, but it was Allah who killed them. And you threw not, [O Muhammad], when you threw, but it was Allah who threw that He might test the believers with a good test. Indeed, Allah is Hearing and Knowing",
    normalizedText:
      "فلم تقتلوهم ولكن الله قتلهم وما رميت اذ رميت ولكن الله رمى وليبلي المامنين منه بلاء حسنا ان الله سميع عليم",
  },
  {
    verseId: 17,
    name: "الأنفال",
    surahId: 8,
    text: "ذَٰلِكُمۡ وَأَنَّ ٱللَّهَ مُوهِنُ كَيۡدِ ٱلۡكَٰفِرِينَ",
    translation:
      "That [is so], and [also] that Allah will weaken the plot of the disbelievers",
    normalizedText: "ذلكم وان الله موهن كيد الكفرين",
  },
  {
    verseId: 18,
    name: "الأنفال",
    surahId: 8,
    text: "إِن تَسۡتَفۡتِحُواْ فَقَدۡ جَآءَكُمُ ٱلۡفَتۡحُۖ وَإِن تَنتَهُواْ فَهُوَ خَيۡرٞ لَّكُمۡۖ وَإِن تَعُودُواْ نَعُدۡ وَلَن تُغۡنِيَ عَنكُمۡ فِئَتُكُمۡ شَيۡـٔٗا وَلَوۡ كَثُرَتۡ وَأَنَّ ٱللَّهَ مَعَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "If you [disbelievers] seek the victory - the defeat has come to you. And if you desist [from hostilities], it is best for you; but if you return [to war], We will return, and never will you be availed by your [large] company at all, even if it should increase; and [that is] because Allah is with the believers",
    normalizedText:
      "ان تستفتحوا فقد جاءكم الفتح وان تنتهوا فهو خير لكم وان تعودوا نعد ولن تغني عنكم فاتكم شيا ولو كثرت وان الله مع المامنين",
  },
  {
    verseId: 19,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ أَطِيعُواْ ٱللَّهَ وَرَسُولَهُۥ وَلَا تَوَلَّوۡاْ عَنۡهُ وَأَنتُمۡ تَسۡمَعُونَ",
    translation:
      "O you who have believed, obey Allah and His Messenger and do not turn from him while you hear [his order]",
    normalizedText:
      "يايها الذين ءامنوا اطيعوا الله ورسوله ولا تولوا عنه وانتم تسمعون",
  },
  {
    verseId: 20,
    name: "الأنفال",
    surahId: 8,
    text: "وَلَا تَكُونُواْ كَٱلَّذِينَ قَالُواْ سَمِعۡنَا وَهُمۡ لَا يَسۡمَعُونَ",
    translation:
      'And do not be like those who say, "We have heard," while they do not hear',
    normalizedText: "ولا تكونوا كالذين قالوا سمعنا وهم لا يسمعون",
  },
  {
    verseId: 21,
    name: "الأنفال",
    surahId: 8,
    text: "۞إِنَّ شَرَّ ٱلدَّوَآبِّ عِندَ ٱللَّهِ ٱلصُّمُّ ٱلۡبُكۡمُ ٱلَّذِينَ لَا يَعۡقِلُونَ",
    translation:
      "Indeed, the worst of living creatures in the sight of Allah are the deaf and dumb who do not use reason",
    normalizedText: "۞ان شر الدواب عند الله الصم البكم الذين لا يعقلون",
  },
  {
    verseId: 22,
    name: "الأنفال",
    surahId: 8,
    text: "وَلَوۡ عَلِمَ ٱللَّهُ فِيهِمۡ خَيۡرٗا لَّأَسۡمَعَهُمۡۖ وَلَوۡ أَسۡمَعَهُمۡ لَتَوَلَّواْ وَّهُم مُّعۡرِضُونَ",
    translation:
      "Had Allah known any good in them, He would have made them hear. And if He had made them hear, they would [still] have turned away, while they were refusing",
    normalizedText:
      "ولو علم الله فيهم خيرا لاسمعهم ولو اسمعهم لتولوا وهم معرضون",
  },
  {
    verseId: 23,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱسۡتَجِيبُواْ لِلَّهِ وَلِلرَّسُولِ إِذَا دَعَاكُمۡ لِمَا يُحۡيِيكُمۡۖ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ يَحُولُ بَيۡنَ ٱلۡمَرۡءِ وَقَلۡبِهِۦ وَأَنَّهُۥٓ إِلَيۡهِ تُحۡشَرُونَ",
    translation:
      "O you who have believed, respond to Allah and to the Messenger when he calls you to that which gives you life. And know that Allah intervenes between a man and his heart and that to Him you will be gathered",
    normalizedText:
      "يايها الذين ءامنوا استجيبوا لله وللرسول اذا دعاكم لما يحييكم واعلموا ان الله يحول بين المرء وقلبه وانه اليه تحشرون",
  },
  {
    verseId: 24,
    name: "الأنفال",
    surahId: 8,
    text: "وَٱتَّقُواْ فِتۡنَةٗ لَّا تُصِيبَنَّ ٱلَّذِينَ ظَلَمُواْ مِنكُمۡ خَآصَّةٗۖ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "And fear a trial which will not strike those who have wronged among you exclusively, and know that Allah is severe in penalty",
    normalizedText:
      "واتقوا فتنة لا تصيبن الذين ظلموا منكم خاصة واعلموا ان الله شديد العقاب",
  },
  {
    verseId: 25,
    name: "الأنفال",
    surahId: 8,
    text: "وَٱذۡكُرُوٓاْ إِذۡ أَنتُمۡ قَلِيلٞ مُّسۡتَضۡعَفُونَ فِي ٱلۡأَرۡضِ تَخَافُونَ أَن يَتَخَطَّفَكُمُ ٱلنَّاسُ فَـَٔاوَىٰكُمۡ وَأَيَّدَكُم بِنَصۡرِهِۦ وَرَزَقَكُم مِّنَ ٱلطَّيِّبَٰتِ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And remember when you were few and oppressed in the land, fearing that people might abduct you, but He sheltered you, supported you with His victory, and provided you with good things - that you might be grateful",
    normalizedText:
      "واذكروا اذ انتم قليل مستضعفون في الارض تخافون ان يتخطفكم الناس فاوىكم وايدكم بنصره ورزقكم من الطيبت لعلكم تشكرون",
  },
  {
    verseId: 26,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَخُونُواْ ٱللَّهَ وَٱلرَّسُولَ وَتَخُونُوٓاْ أَمَٰنَٰتِكُمۡ وَأَنتُمۡ تَعۡلَمُونَ",
    translation:
      "O you who have believed, do not betray Allah and the Messenger or betray your trusts while you know [the consequence]",
    normalizedText:
      "يايها الذين ءامنوا لا تخونوا الله والرسول وتخونوا امنتكم وانتم تعلمون",
  },
  {
    verseId: 27,
    name: "الأنفال",
    surahId: 8,
    text: "وَٱعۡلَمُوٓاْ أَنَّمَآ أَمۡوَٰلُكُمۡ وَأَوۡلَٰدُكُمۡ فِتۡنَةٞ وَأَنَّ ٱللَّهَ عِندَهُۥٓ أَجۡرٌ عَظِيمٞ",
    translation:
      "And know that your properties and your children are but a trial and that Allah has with Him a great reward",
    normalizedText: "واعلموا انما امولكم واولدكم فتنة وان الله عنده اجر عظيم",
  },
  {
    verseId: 28,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِن تَتَّقُواْ ٱللَّهَ يَجۡعَل لَّكُمۡ فُرۡقَانٗا وَيُكَفِّرۡ عَنكُمۡ سَيِّـَٔاتِكُمۡ وَيَغۡفِرۡ لَكُمۡۗ وَٱللَّهُ ذُو ٱلۡفَضۡلِ ٱلۡعَظِيمِ",
    translation:
      "O you who have believed, if you fear Allah, He will grant you a criterion and will remove from you your misdeeds and forgive you. And Allah is the possessor of great bounty",
    normalizedText:
      "يايها الذين ءامنوا ان تتقوا الله يجعل لكم فرقانا ويكفر عنكم سياتكم ويغفر لكم والله ذو الفضل العظيم",
  },
  {
    verseId: 29,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِذۡ يَمۡكُرُ بِكَ ٱلَّذِينَ كَفَرُواْ لِيُثۡبِتُوكَ أَوۡ يَقۡتُلُوكَ أَوۡ يُخۡرِجُوكَۚ وَيَمۡكُرُونَ وَيَمۡكُرُ ٱللَّهُۖ وَٱللَّهُ خَيۡرُ ٱلۡمَٰكِرِينَ",
    translation:
      "And [remember, O Muhammad], when those who disbelieved plotted against you to restrain you or kill you or evict you [from Makkah]. But they plan, and Allah plans. And Allah is the best of planners",
    normalizedText:
      "واذ يمكر بك الذين كفروا ليثبتوك او يقتلوك او يخرجوك ويمكرون ويمكر الله والله خير المكرين",
  },
  {
    verseId: 30,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَٰتُنَا قَالُواْ قَدۡ سَمِعۡنَا لَوۡ نَشَآءُ لَقُلۡنَا مِثۡلَ هَٰذَآ إِنۡ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      'And when Our verses are recited to them, they say, "We have heard. If we willed, we could say [something] like this. This is not but legends of the former peoples',
    normalizedText:
      "واذا تتلى عليهم ءايتنا قالوا قد سمعنا لو نشاء لقلنا مثل هذا ان هذا الا اسطير الاولين",
  },
  {
    verseId: 31,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِذۡ قَالُواْ ٱللَّهُمَّ إِن كَانَ هَٰذَا هُوَ ٱلۡحَقَّ مِنۡ عِندِكَ فَأَمۡطِرۡ عَلَيۡنَا حِجَارَةٗ مِّنَ ٱلسَّمَآءِ أَوِ ٱئۡتِنَا بِعَذَابٍ أَلِيمٖ",
    translation:
      'And [remember] when they said, "O Allah, if this should be the truth from You, then rain down upon us stones from the sky or bring us a painful punishment',
    normalizedText:
      "واذ قالوا اللهم ان كان هذا هو الحق من عندك فامطر علينا حجارة من السماء او ااتنا بعذاب اليم",
  },
  {
    verseId: 32,
    name: "الأنفال",
    surahId: 8,
    text: "وَمَا كَانَ ٱللَّهُ لِيُعَذِّبَهُمۡ وَأَنتَ فِيهِمۡۚ وَمَا كَانَ ٱللَّهُ مُعَذِّبَهُمۡ وَهُمۡ يَسۡتَغۡفِرُونَ",
    translation:
      "But Allah would not punish them while you, [O Muhammad], are among them, and Allah would not punish them while they seek forgiveness",
    normalizedText:
      "وما كان الله ليعذبهم وانت فيهم وما كان الله معذبهم وهم يستغفرون",
  },
  {
    verseId: 33,
    name: "الأنفال",
    surahId: 8,
    text: "وَمَا لَهُمۡ أَلَّا يُعَذِّبَهُمُ ٱللَّهُ وَهُمۡ يَصُدُّونَ عَنِ ٱلۡمَسۡجِدِ ٱلۡحَرَامِ وَمَا كَانُوٓاْ أَوۡلِيَآءَهُۥٓۚ إِنۡ أَوۡلِيَآؤُهُۥٓ إِلَّا ٱلۡمُتَّقُونَ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "But why should Allah not punish them while they obstruct [people] from al-Masjid al- Haram and they were not [fit to be] its guardians? Its [true] guardians are not but the righteous, but most of them do not know",
    normalizedText:
      "وما لهم الا يعذبهم الله وهم يصدون عن المسجد الحرام وما كانوا اولياءه ان اوليااه الا المتقون ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 34,
    name: "الأنفال",
    surahId: 8,
    text: "وَمَا كَانَ صَلَاتُهُمۡ عِندَ ٱلۡبَيۡتِ إِلَّا مُكَآءٗ وَتَصۡدِيَةٗۚ فَذُوقُواْ ٱلۡعَذَابَ بِمَا كُنتُمۡ تَكۡفُرُونَ",
    translation:
      "And their prayer at the House was not except whistling and handclapping. So taste the punishment for what you disbelieved",
    normalizedText:
      "وما كان صلاتهم عند البيت الا مكاء وتصدية فذوقوا العذاب بما كنتم تكفرون",
  },
  {
    verseId: 35,
    name: "الأنفال",
    surahId: 8,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ يُنفِقُونَ أَمۡوَٰلَهُمۡ لِيَصُدُّواْ عَن سَبِيلِ ٱللَّهِۚ فَسَيُنفِقُونَهَا ثُمَّ تَكُونُ عَلَيۡهِمۡ حَسۡرَةٗ ثُمَّ يُغۡلَبُونَۗ وَٱلَّذِينَ كَفَرُوٓاْ إِلَىٰ جَهَنَّمَ يُحۡشَرُونَ",
    translation:
      "Indeed, those who disbelieve spend their wealth to avert [people] from the way of Allah. So they will spend it; then it will be for them a [source of] regret; then they will be overcome. And those who have disbelieved - unto Hell they will be gathered",
    normalizedText:
      "ان الذين كفروا ينفقون امولهم ليصدوا عن سبيل الله فسينفقونها ثم تكون عليهم حسرة ثم يغلبون والذين كفروا الى جهنم يحشرون",
  },
  {
    verseId: 36,
    name: "الأنفال",
    surahId: 8,
    text: "لِيَمِيزَ ٱللَّهُ ٱلۡخَبِيثَ مِنَ ٱلطَّيِّبِ وَيَجۡعَلَ ٱلۡخَبِيثَ بَعۡضَهُۥ عَلَىٰ بَعۡضٖ فَيَرۡكُمَهُۥ جَمِيعٗا فَيَجۡعَلَهُۥ فِي جَهَنَّمَۚ أُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "[This is] so that Allah may distinguish the wicked from the good and place the wicked some of them upon others and heap them all together and put them into Hell. It is those who are the losers",
    normalizedText:
      "ليميز الله الخبيث من الطيب ويجعل الخبيث بعضه على بعض فيركمه جميعا فيجعله في جهنم اولاك هم الخسرون",
  },
  {
    verseId: 37,
    name: "الأنفال",
    surahId: 8,
    text: "قُل لِّلَّذِينَ كَفَرُوٓاْ إِن يَنتَهُواْ يُغۡفَرۡ لَهُم مَّا قَدۡ سَلَفَ وَإِن يَعُودُواْ فَقَدۡ مَضَتۡ سُنَّتُ ٱلۡأَوَّلِينَ",
    translation:
      "Say to those who have disbelieved [that] if they cease, what has previously occurred will be forgiven for them. But if they return [to hostility] - then the precedent of the former [rebellious] peoples has already taken place",
    normalizedText:
      "قل للذين كفروا ان ينتهوا يغفر لهم ما قد سلف وان يعودوا فقد مضت سنت الاولين",
  },
  {
    verseId: 38,
    name: "الأنفال",
    surahId: 8,
    text: "وَقَٰتِلُوهُمۡ حَتَّىٰ لَا تَكُونَ فِتۡنَةٞ وَيَكُونَ ٱلدِّينُ كُلُّهُۥ لِلَّهِۚ فَإِنِ ٱنتَهَوۡاْ فَإِنَّ ٱللَّهَ بِمَا يَعۡمَلُونَ بَصِيرٞ",
    translation:
      "And fight them until there is no fitnah and [until] the religion, all of it, is for Allah. And if they cease - then indeed, Allah is Seeing of what they do",
    normalizedText:
      "وقتلوهم حتى لا تكون فتنة ويكون الدين كله لله فان انتهوا فان الله بما يعملون بصير",
  },
  {
    verseId: 39,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِن تَوَلَّوۡاْ فَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ مَوۡلَىٰكُمۡۚ نِعۡمَ ٱلۡمَوۡلَىٰ وَنِعۡمَ ٱلنَّصِيرُ",
    translation:
      "But if they turn away - then know that Allah is your protector. Excellent is the protector, and Excellent is the helper",
    normalizedText: "وان تولوا فاعلموا ان الله مولىكم نعم المولى ونعم النصير",
  },
  {
    verseId: 40,
    name: "الأنفال",
    surahId: 8,
    text: "۞وَٱعۡلَمُوٓاْ أَنَّمَا غَنِمۡتُم مِّن شَيۡءٖ فَأَنَّ لِلَّهِ خُمُسَهُۥ وَلِلرَّسُولِ وَلِذِي ٱلۡقُرۡبَىٰ وَٱلۡيَتَٰمَىٰ وَٱلۡمَسَٰكِينِ وَٱبۡنِ ٱلسَّبِيلِ إِن كُنتُمۡ ءَامَنتُم بِٱللَّهِ وَمَآ أَنزَلۡنَا عَلَىٰ عَبۡدِنَا يَوۡمَ ٱلۡفُرۡقَانِ يَوۡمَ ٱلۡتَقَى ٱلۡجَمۡعَانِۗ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "And know that anything you obtain of war booty - then indeed, for Allah is one fifth of it and for the Messenger and for [his] near relatives and the orphans, the needy, and the [stranded] traveler, if you have believed in Allah and in that which We sent down to Our Servant on the day of criterion - the day when the two armies met. And Allah, over all things, is competent",
    normalizedText:
      "۞واعلموا انما غنمتم من شيء فان لله خمسه وللرسول ولذي القربى واليتمى والمسكين وابن السبيل ان كنتم ءامنتم بالله وما انزلنا على عبدنا يوم الفرقان يوم التقى الجمعان والله على كل شيء قدير",
  },
  {
    verseId: 41,
    name: "الأنفال",
    surahId: 8,
    text: "إِذۡ أَنتُم بِٱلۡعُدۡوَةِ ٱلدُّنۡيَا وَهُم بِٱلۡعُدۡوَةِ ٱلۡقُصۡوَىٰ وَٱلرَّكۡبُ أَسۡفَلَ مِنكُمۡۚ وَلَوۡ تَوَاعَدتُّمۡ لَٱخۡتَلَفۡتُمۡ فِي ٱلۡمِيعَٰدِ وَلَٰكِن لِّيَقۡضِيَ ٱللَّهُ أَمۡرٗا كَانَ مَفۡعُولٗا لِّيَهۡلِكَ مَنۡ هَلَكَ عَنۢ بَيِّنَةٖ وَيَحۡيَىٰ مَنۡ حَيَّ عَنۢ بَيِّنَةٖۗ وَإِنَّ ٱللَّهَ لَسَمِيعٌ عَلِيمٌ",
    translation:
      "[Remember] when you were on the near side of the valley, and they were on the farther side, and the caravan was lower [in position] than you. If you had made an appointment [to meet], you would have missed the appointment. But [it was] so that Allah might accomplish a matter already destined - that those who perished [through disbelief] would perish upon evidence and those who lived [in faith] would live upon evidence; and indeed, Allah is Hearing and Knowing",
    normalizedText:
      "اذ انتم بالعدوة الدنيا وهم بالعدوة القصوى والركب اسفل منكم ولو تواعدتم لاختلفتم في الميعد ولكن ليقضي الله امرا كان مفعولا ليهلك من هلك عن بينة ويحيى من حي عن بينة وان الله لسميع عليم",
  },
  {
    verseId: 42,
    name: "الأنفال",
    surahId: 8,
    text: "إِذۡ يُرِيكَهُمُ ٱللَّهُ فِي مَنَامِكَ قَلِيلٗاۖ وَلَوۡ أَرَىٰكَهُمۡ كَثِيرٗا لَّفَشِلۡتُمۡ وَلَتَنَٰزَعۡتُمۡ فِي ٱلۡأَمۡرِ وَلَٰكِنَّ ٱللَّهَ سَلَّمَۚ إِنَّهُۥ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "[Remember, O Muhammad], when Allah showed them to you in your dream as few; and if He had shown them to you as many, you [believers] would have lost courage and would have disputed in the matter [of whether to fight], but Allah saved [you from that]. Indeed, He is Knowing of that within the breasts",
    normalizedText:
      "اذ يريكهم الله في منامك قليلا ولو ارىكهم كثيرا لفشلتم ولتنزعتم في الامر ولكن الله سلم انه عليم بذات الصدور",
  },
  {
    verseId: 43,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِذۡ يُرِيكُمُوهُمۡ إِذِ ٱلۡتَقَيۡتُمۡ فِيٓ أَعۡيُنِكُمۡ قَلِيلٗا وَيُقَلِّلُكُمۡ فِيٓ أَعۡيُنِهِمۡ لِيَقۡضِيَ ٱللَّهُ أَمۡرٗا كَانَ مَفۡعُولٗاۗ وَإِلَى ٱللَّهِ تُرۡجَعُ ٱلۡأُمُورُ",
    translation:
      "And [remember] when He showed them to you, when you met, as few in your eyes, and He made you [appear] as few in their eyes so that Allah might accomplish a matter already destined. And to Allah are [all] matters returned",
    normalizedText:
      "واذ يريكموهم اذ التقيتم في اعينكم قليلا ويقللكم في اعينهم ليقضي الله امرا كان مفعولا والى الله ترجع الامور",
  },
  {
    verseId: 44,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا لَقِيتُمۡ فِئَةٗ فَٱثۡبُتُواْ وَٱذۡكُرُواْ ٱللَّهَ كَثِيرٗا لَّعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "O you who have believed, when you encounter a company [from the enemy forces], stand firm and remember Allah much that you may be successful",
    normalizedText:
      "يايها الذين ءامنوا اذا لقيتم فاة فاثبتوا واذكروا الله كثيرا لعلكم تفلحون",
  },
  {
    verseId: 45,
    name: "الأنفال",
    surahId: 8,
    text: "وَأَطِيعُواْ ٱللَّهَ وَرَسُولَهُۥ وَلَا تَنَٰزَعُواْ فَتَفۡشَلُواْ وَتَذۡهَبَ رِيحُكُمۡۖ وَٱصۡبِرُوٓاْۚ إِنَّ ٱللَّهَ مَعَ ٱلصَّـٰبِرِينَ",
    translation:
      "And obey Allah and His Messenger, and do not dispute and [thus] lose courage and [then] your strength would depart; and be patient. Indeed, Allah is with the patient",
    normalizedText:
      "واطيعوا الله ورسوله ولا تنزعوا فتفشلوا وتذهب ريحكم واصبروا ان الله مع الصبرين",
  },
  {
    verseId: 46,
    name: "الأنفال",
    surahId: 8,
    text: "وَلَا تَكُونُواْ كَٱلَّذِينَ خَرَجُواْ مِن دِيَٰرِهِم بَطَرٗا وَرِئَآءَ ٱلنَّاسِ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِۚ وَٱللَّهُ بِمَا يَعۡمَلُونَ مُحِيطٞ",
    translation:
      "And do not be like those who came forth from their homes insolently and to be seen by people and avert [them] from the way of Allah. And Allah is encompassing of what they do",
    normalizedText:
      "ولا تكونوا كالذين خرجوا من ديرهم بطرا ورااء الناس ويصدون عن سبيل الله والله بما يعملون محيط",
  },
  {
    verseId: 47,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِذۡ زَيَّنَ لَهُمُ ٱلشَّيۡطَٰنُ أَعۡمَٰلَهُمۡ وَقَالَ لَا غَالِبَ لَكُمُ ٱلۡيَوۡمَ مِنَ ٱلنَّاسِ وَإِنِّي جَارٞ لَّكُمۡۖ فَلَمَّا تَرَآءَتِ ٱلۡفِئَتَانِ نَكَصَ عَلَىٰ عَقِبَيۡهِ وَقَالَ إِنِّي بَرِيٓءٞ مِّنكُمۡ إِنِّيٓ أَرَىٰ مَا لَا تَرَوۡنَ إِنِّيٓ أَخَافُ ٱللَّهَۚ وَٱللَّهُ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      'And [remember] when Satan made their deeds pleasing to them and said, "No one can overcome you today from among the people, and indeed, I am your protector." But when the two armies sighted each other, he turned on his heels and said, "Indeed, I am disassociated from you. Indeed, I see what you do not see; indeed I fear Allah. And Allah is severe in penalty',
    normalizedText:
      "واذ زين لهم الشيطن اعملهم وقال لا غالب لكم اليوم من الناس واني جار لكم فلما تراءت الفاتان نكص على عقبيه وقال اني بريء منكم اني ارى ما لا ترون اني اخاف الله والله شديد العقاب",
  },
  {
    verseId: 48,
    name: "الأنفال",
    surahId: 8,
    text: "إِذۡ يَقُولُ ٱلۡمُنَٰفِقُونَ وَٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٌ غَرَّ هَـٰٓؤُلَآءِ دِينُهُمۡۗ وَمَن يَتَوَكَّلۡ عَلَى ٱللَّهِ فَإِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٞ",
    translation:
      '[Remember] when the hypocrites and those in whose hearts was disease said, "Their religion has deluded those [Muslims]." But whoever relies upon Allah - then indeed, Allah is Exalted in Might and Wise',
    normalizedText:
      "اذ يقول المنفقون والذين في قلوبهم مرض غر هالاء دينهم ومن يتوكل على الله فان الله عزيز حكيم",
  },
  {
    verseId: 49,
    name: "الأنفال",
    surahId: 8,
    text: "وَلَوۡ تَرَىٰٓ إِذۡ يَتَوَفَّى ٱلَّذِينَ كَفَرُواْ ٱلۡمَلَـٰٓئِكَةُ يَضۡرِبُونَ وُجُوهَهُمۡ وَأَدۡبَٰرَهُمۡ وَذُوقُواْ عَذَابَ ٱلۡحَرِيقِ",
    translation:
      'And if you could but see when the angels take the souls of those who disbelieved... They are striking their faces and their backs and [saying], "Taste the punishment of the Burning Fire',
    normalizedText:
      "ولو ترى اذ يتوفى الذين كفروا الملاكة يضربون وجوههم وادبرهم وذوقوا عذاب الحريق",
  },
  {
    verseId: 50,
    name: "الأنفال",
    surahId: 8,
    text: "ذَٰلِكَ بِمَا قَدَّمَتۡ أَيۡدِيكُمۡ وَأَنَّ ٱللَّهَ لَيۡسَ بِظَلَّـٰمٖ لِّلۡعَبِيدِ",
    translation:
      "That is for what your hands have put forth [of evil] and because Allah is not ever unjust to His servants",
    normalizedText: "ذلك بما قدمت ايديكم وان الله ليس بظلم للعبيد",
  },
  {
    verseId: 51,
    name: "الأنفال",
    surahId: 8,
    text: "كَدَأۡبِ ءَالِ فِرۡعَوۡنَ وَٱلَّذِينَ مِن قَبۡلِهِمۡۚ كَفَرُواْ بِـَٔايَٰتِ ٱللَّهِ فَأَخَذَهُمُ ٱللَّهُ بِذُنُوبِهِمۡۚ إِنَّ ٱللَّهَ قَوِيّٞ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "[Theirs is] like the custom of the people of Pharaoh and of those before them. They disbelieved in the signs of Allah, so Allah seized them for their sins. Indeed, Allah is Powerful and severe in penalty",
    normalizedText:
      "كداب ءال فرعون والذين من قبلهم كفروا بايت الله فاخذهم الله بذنوبهم ان الله قوي شديد العقاب",
  },
  {
    verseId: 52,
    name: "الأنفال",
    surahId: 8,
    text: "ذَٰلِكَ بِأَنَّ ٱللَّهَ لَمۡ يَكُ مُغَيِّرٗا نِّعۡمَةً أَنۡعَمَهَا عَلَىٰ قَوۡمٍ حَتَّىٰ يُغَيِّرُواْ مَا بِأَنفُسِهِمۡ وَأَنَّ ٱللَّهَ سَمِيعٌ عَلِيمٞ",
    translation:
      "That is because Allah would not change a favor which He had bestowed upon a people until they change what is within themselves. And indeed, Allah is Hearing and Knowing",
    normalizedText:
      "ذلك بان الله لم يك مغيرا نعمة انعمها على قوم حتى يغيروا ما بانفسهم وان الله سميع عليم",
  },
  {
    verseId: 53,
    name: "الأنفال",
    surahId: 8,
    text: "كَدَأۡبِ ءَالِ فِرۡعَوۡنَ وَٱلَّذِينَ مِن قَبۡلِهِمۡۚ كَذَّبُواْ بِـَٔايَٰتِ رَبِّهِمۡ فَأَهۡلَكۡنَٰهُم بِذُنُوبِهِمۡ وَأَغۡرَقۡنَآ ءَالَ فِرۡعَوۡنَۚ وَكُلّٞ كَانُواْ ظَٰلِمِينَ",
    translation:
      "[Theirs is] like the custom of the people of Pharaoh and of those before them. They denied the signs of their Lord, so We destroyed them for their sins, and We drowned the people of Pharaoh. And all [of them] were wrongdoers",
    normalizedText:
      "كداب ءال فرعون والذين من قبلهم كذبوا بايت ربهم فاهلكنهم بذنوبهم واغرقنا ءال فرعون وكل كانوا ظلمين",
  },
  {
    verseId: 54,
    name: "الأنفال",
    surahId: 8,
    text: "إِنَّ شَرَّ ٱلدَّوَآبِّ عِندَ ٱللَّهِ ٱلَّذِينَ كَفَرُواْ فَهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "Indeed, the worst of living creatures in the sight of Allah are those who have disbelieved, and they will not [ever] believe",
    normalizedText: "ان شر الدواب عند الله الذين كفروا فهم لا يامنون",
  },
  {
    verseId: 55,
    name: "الأنفال",
    surahId: 8,
    text: "ٱلَّذِينَ عَٰهَدتَّ مِنۡهُمۡ ثُمَّ يَنقُضُونَ عَهۡدَهُمۡ فِي كُلِّ مَرَّةٖ وَهُمۡ لَا يَتَّقُونَ",
    translation:
      "The ones with whom you made a treaty but then they break their pledge every time, and they do not fear Allah",
    normalizedText: "الذين عهدت منهم ثم ينقضون عهدهم في كل مرة وهم لا يتقون",
  },
  {
    verseId: 56,
    name: "الأنفال",
    surahId: 8,
    text: "فَإِمَّا تَثۡقَفَنَّهُمۡ فِي ٱلۡحَرۡبِ فَشَرِّدۡ بِهِم مَّنۡ خَلۡفَهُمۡ لَعَلَّهُمۡ يَذَّكَّرُونَ",
    translation:
      "So if you, [O Muhammad], gain dominance over them in war, disperse by [means of] them those behind them that perhaps they will be reminded",
    normalizedText: "فاما تثقفنهم في الحرب فشرد بهم من خلفهم لعلهم يذكرون",
  },
  {
    verseId: 57,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِمَّا تَخَافَنَّ مِن قَوۡمٍ خِيَانَةٗ فَٱنۢبِذۡ إِلَيۡهِمۡ عَلَىٰ سَوَآءٍۚ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلۡخَآئِنِينَ",
    translation:
      "If you [have reason to] fear from a people betrayal, throw [their treaty] back to them, [putting you] on equal terms. Indeed, Allah does not like traitors",
    normalizedText:
      "واما تخافن من قوم خيانة فانبذ اليهم على سواء ان الله لا يحب الخاانين",
  },
  {
    verseId: 58,
    name: "الأنفال",
    surahId: 8,
    text: "وَلَا يَحۡسَبَنَّ ٱلَّذِينَ كَفَرُواْ سَبَقُوٓاْۚ إِنَّهُمۡ لَا يُعۡجِزُونَ",
    translation:
      "And let not those who disbelieve think they will escape. Indeed, they will not cause failure [to Allah]",
    normalizedText: "ولا يحسبن الذين كفروا سبقوا انهم لا يعجزون",
  },
  {
    verseId: 59,
    name: "الأنفال",
    surahId: 8,
    text: "وَأَعِدُّواْ لَهُم مَّا ٱسۡتَطَعۡتُم مِّن قُوَّةٖ وَمِن رِّبَاطِ ٱلۡخَيۡلِ تُرۡهِبُونَ بِهِۦ عَدُوَّ ٱللَّهِ وَعَدُوَّكُمۡ وَءَاخَرِينَ مِن دُونِهِمۡ لَا تَعۡلَمُونَهُمُ ٱللَّهُ يَعۡلَمُهُمۡۚ وَمَا تُنفِقُواْ مِن شَيۡءٖ فِي سَبِيلِ ٱللَّهِ يُوَفَّ إِلَيۡكُمۡ وَأَنتُمۡ لَا تُظۡلَمُونَ",
    translation:
      "And prepare against them whatever you are able of power and of steeds of war by which you may terrify the enemy of Allah and your enemy and others besides them whom you do not know [but] whom Allah knows. And whatever you spend in the cause of Allah will be fully repaid to you, and you will not be wronged",
    normalizedText:
      "واعدوا لهم ما استطعتم من قوة ومن رباط الخيل ترهبون به عدو الله وعدوكم وءاخرين من دونهم لا تعلمونهم الله يعلمهم وما تنفقوا من شيء في سبيل الله يوف اليكم وانتم لا تظلمون",
  },
  {
    verseId: 60,
    name: "الأنفال",
    surahId: 8,
    text: "۞وَإِن جَنَحُواْ لِلسَّلۡمِ فَٱجۡنَحۡ لَهَا وَتَوَكَّلۡ عَلَى ٱللَّهِۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "And if they incline to peace, then incline to it [also] and rely upon Allah. Indeed, it is He who is the Hearing, the Knowing",
    normalizedText:
      "۞وان جنحوا للسلم فاجنح لها وتوكل على الله انه هو السميع العليم",
  },
  {
    verseId: 61,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِن يُرِيدُوٓاْ أَن يَخۡدَعُوكَ فَإِنَّ حَسۡبَكَ ٱللَّهُۚ هُوَ ٱلَّذِيٓ أَيَّدَكَ بِنَصۡرِهِۦ وَبِٱلۡمُؤۡمِنِينَ",
    translation:
      "But if they intend to deceive you - then sufficient for you is Allah. It is He who supported you with His help and with the believers",
    normalizedText:
      "وان يريدوا ان يخدعوك فان حسبك الله هو الذي ايدك بنصره وبالمامنين",
  },
  {
    verseId: 62,
    name: "الأنفال",
    surahId: 8,
    text: "وَأَلَّفَ بَيۡنَ قُلُوبِهِمۡۚ لَوۡ أَنفَقۡتَ مَا فِي ٱلۡأَرۡضِ جَمِيعٗا مَّآ أَلَّفۡتَ بَيۡنَ قُلُوبِهِمۡ وَلَٰكِنَّ ٱللَّهَ أَلَّفَ بَيۡنَهُمۡۚ إِنَّهُۥ عَزِيزٌ حَكِيمٞ",
    translation:
      "And brought together their hearts. If you had spent all that is in the earth, you could not have brought their hearts together; but Allah brought them together. Indeed, He is Exalted in Might and Wise",
    normalizedText:
      "والف بين قلوبهم لو انفقت ما في الارض جميعا ما الفت بين قلوبهم ولكن الله الف بينهم انه عزيز حكيم",
  },
  {
    verseId: 63,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ حَسۡبُكَ ٱللَّهُ وَمَنِ ٱتَّبَعَكَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "O Prophet, sufficient for you is Allah and for whoever follows you of the believers",
    normalizedText: "يايها النبي حسبك الله ومن اتبعك من المامنين",
  },
  {
    verseId: 64,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ حَرِّضِ ٱلۡمُؤۡمِنِينَ عَلَى ٱلۡقِتَالِۚ إِن يَكُن مِّنكُمۡ عِشۡرُونَ صَٰبِرُونَ يَغۡلِبُواْ مِاْئَتَيۡنِۚ وَإِن يَكُن مِّنكُم مِّاْئَةٞ يَغۡلِبُوٓاْ أَلۡفٗا مِّنَ ٱلَّذِينَ كَفَرُواْ بِأَنَّهُمۡ قَوۡمٞ لَّا يَفۡقَهُونَ",
    translation:
      "O Prophet, urge the believers to battle. If there are among you twenty [who are] steadfast, they will overcome two hundred. And if there are among you one hundred [who are] steadfast, they will overcome a thousand of those who have disbelieved because they are a people who do not understand",
    normalizedText:
      "يايها النبي حرض المامنين على القتال ان يكن منكم عشرون صبرون يغلبوا مااتين وان يكن منكم مااة يغلبوا الفا من الذين كفروا بانهم قوم لا يفقهون",
  },
  {
    verseId: 65,
    name: "الأنفال",
    surahId: 8,
    text: "ٱلۡـَٰٔنَ خَفَّفَ ٱللَّهُ عَنكُمۡ وَعَلِمَ أَنَّ فِيكُمۡ ضَعۡفٗاۚ فَإِن يَكُن مِّنكُم مِّاْئَةٞ صَابِرَةٞ يَغۡلِبُواْ مِاْئَتَيۡنِۚ وَإِن يَكُن مِّنكُمۡ أَلۡفٞ يَغۡلِبُوٓاْ أَلۡفَيۡنِ بِإِذۡنِ ٱللَّهِۗ وَٱللَّهُ مَعَ ٱلصَّـٰبِرِينَ",
    translation:
      "Now, Allah has lightened [the hardship] for you, and He knows that among you is weakness. So if there are from you one hundred [who are] steadfast, they will overcome two hundred. And if there are among you a thousand, they will overcome two thousand by permission of Allah. And Allah is with the steadfast",
    normalizedText:
      "الن خفف الله عنكم وعلم ان فيكم ضعفا فان يكن منكم مااة صابرة يغلبوا مااتين وان يكن منكم الف يغلبوا الفين باذن الله والله مع الصبرين",
  },
  {
    verseId: 66,
    name: "الأنفال",
    surahId: 8,
    text: "مَا كَانَ لِنَبِيٍّ أَن يَكُونَ لَهُۥٓ أَسۡرَىٰ حَتَّىٰ يُثۡخِنَ فِي ٱلۡأَرۡضِۚ تُرِيدُونَ عَرَضَ ٱلدُّنۡيَا وَٱللَّهُ يُرِيدُ ٱلۡأٓخِرَةَۗ وَٱللَّهُ عَزِيزٌ حَكِيمٞ",
    translation:
      "It is not for a prophet to have captives [of war] until he inflicts a massacre [upon Allah 's enemies] in the land. Some Muslims desire the commodities of this world, but Allah desires [for you] the Hereafter. And Allah is Exalted in Might and Wise",
    normalizedText:
      "ما كان لنبي ان يكون له اسرى حتى يثخن في الارض تريدون عرض الدنيا والله يريد الاخرة والله عزيز حكيم",
  },
  {
    verseId: 67,
    name: "الأنفال",
    surahId: 8,
    text: "لَّوۡلَا كِتَٰبٞ مِّنَ ٱللَّهِ سَبَقَ لَمَسَّكُمۡ فِيمَآ أَخَذۡتُمۡ عَذَابٌ عَظِيمٞ",
    translation:
      "If not for a decree from Allah that preceded, you would have been touched for what you took by a great punishment",
    normalizedText: "لولا كتب من الله سبق لمسكم فيما اخذتم عذاب عظيم",
  },
  {
    verseId: 68,
    name: "الأنفال",
    surahId: 8,
    text: "فَكُلُواْ مِمَّا غَنِمۡتُمۡ حَلَٰلٗا طَيِّبٗاۚ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "So consume what you have taken of war booty [as being] lawful and good, and fear Allah. Indeed, Allah is Forgiving and Merciful",
    normalizedText: "فكلوا مما غنمتم حللا طيبا واتقوا الله ان الله غفور رحيم",
  },
  {
    verseId: 69,
    name: "الأنفال",
    surahId: 8,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ قُل لِّمَن فِيٓ أَيۡدِيكُم مِّنَ ٱلۡأَسۡرَىٰٓ إِن يَعۡلَمِ ٱللَّهُ فِي قُلُوبِكُمۡ خَيۡرٗا يُؤۡتِكُمۡ خَيۡرٗا مِّمَّآ أُخِذَ مِنكُمۡ وَيَغۡفِرۡ لَكُمۡۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      'O Prophet, say to whoever is in your hands of the captives, "If Allah knows [any] good in your hearts, He will give you [something] better than what was taken from you, and He will forgive you; and Allah is Forgiving and Merciful',
    normalizedText:
      "يايها النبي قل لمن في ايديكم من الاسرى ان يعلم الله في قلوبكم خيرا ياتكم خيرا مما اخذ منكم ويغفر لكم والله غفور رحيم",
  },
  {
    verseId: 70,
    name: "الأنفال",
    surahId: 8,
    text: "وَإِن يُرِيدُواْ خِيَانَتَكَ فَقَدۡ خَانُواْ ٱللَّهَ مِن قَبۡلُ فَأَمۡكَنَ مِنۡهُمۡۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌ",
    translation:
      "But if they intend to betray you - then they have already betrayed Allah before, and He empowered [you] over them. And Allah is Knowing and Wise",
    normalizedText:
      "وان يريدوا خيانتك فقد خانوا الله من قبل فامكن منهم والله عليم حكيم",
  },
  {
    verseId: 71,
    name: "الأنفال",
    surahId: 8,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَهَاجَرُواْ وَجَٰهَدُواْ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡ فِي سَبِيلِ ٱللَّهِ وَٱلَّذِينَ ءَاوَواْ وَّنَصَرُوٓاْ أُوْلَـٰٓئِكَ بَعۡضُهُمۡ أَوۡلِيَآءُ بَعۡضٖۚ وَٱلَّذِينَ ءَامَنُواْ وَلَمۡ يُهَاجِرُواْ مَا لَكُم مِّن وَلَٰيَتِهِم مِّن شَيۡءٍ حَتَّىٰ يُهَاجِرُواْۚ وَإِنِ ٱسۡتَنصَرُوكُمۡ فِي ٱلدِّينِ فَعَلَيۡكُمُ ٱلنَّصۡرُ إِلَّا عَلَىٰ قَوۡمِۭ بَيۡنَكُمۡ وَبَيۡنَهُم مِّيثَٰقٞۗ وَٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      "Indeed, those who have believed and emigrated and fought with their wealth and lives in the cause of Allah and those who gave shelter and aided - they are allies of one another. But those who believed and did not emigrate - for you there is no guardianship of them until they emigrate. And if they seek help of you for the religion, then you must help, except against a people between yourselves and whom is a treaty. And Allah is Seeing of what you do",
    normalizedText:
      "ان الذين ءامنوا وهاجروا وجهدوا بامولهم وانفسهم في سبيل الله والذين ءاووا ونصروا اولاك بعضهم اولياء بعض والذين ءامنوا ولم يهاجروا ما لكم من وليتهم من شيء حتى يهاجروا وان استنصروكم في الدين فعليكم النصر الا على قوم بينكم وبينهم ميثق والله بما تعملون بصير",
  },
  {
    verseId: 72,
    name: "الأنفال",
    surahId: 8,
    text: "وَٱلَّذِينَ كَفَرُواْ بَعۡضُهُمۡ أَوۡلِيَآءُ بَعۡضٍۚ إِلَّا تَفۡعَلُوهُ تَكُن فِتۡنَةٞ فِي ٱلۡأَرۡضِ وَفَسَادٞ كَبِيرٞ",
    translation:
      "And those who disbelieved are allies of one another. If you do not do so, there will be fitnah on earth and great corruption",
    normalizedText:
      "والذين كفروا بعضهم اولياء بعض الا تفعلوه تكن فتنة في الارض وفساد كبير",
  },
  {
    verseId: 73,
    name: "الأنفال",
    surahId: 8,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَهَاجَرُواْ وَجَٰهَدُواْ فِي سَبِيلِ ٱللَّهِ وَٱلَّذِينَ ءَاوَواْ وَّنَصَرُوٓاْ أُوْلَـٰٓئِكَ هُمُ ٱلۡمُؤۡمِنُونَ حَقّٗاۚ لَّهُم مَّغۡفِرَةٞ وَرِزۡقٞ كَرِيمٞ",
    translation:
      "But those who have believed and emigrated and fought in the cause of Allah and those who gave shelter and aided - it is they who are the believers, truly. For them is forgiveness and noble provision",
    normalizedText:
      "والذين ءامنوا وهاجروا وجهدوا في سبيل الله والذين ءاووا ونصروا اولاك هم المامنون حقا لهم مغفرة ورزق كريم",
  },
  {
    verseId: 74,
    name: "الأنفال",
    surahId: 8,
    text: "وَٱلَّذِينَ ءَامَنُواْ مِنۢ بَعۡدُ وَهَاجَرُواْ وَجَٰهَدُواْ مَعَكُمۡ فَأُوْلَـٰٓئِكَ مِنكُمۡۚ وَأُوْلُواْ ٱلۡأَرۡحَامِ بَعۡضُهُمۡ أَوۡلَىٰ بِبَعۡضٖ فِي كِتَٰبِ ٱللَّهِۚ إِنَّ ٱللَّهَ بِكُلِّ شَيۡءٍ عَلِيمُۢ",
    translation:
      "And those who believed after [the initial emigration] and emigrated and fought with you - they are of you. But those of [blood] relationship are more entitled [to inheritance] in the decree of Allah. Indeed, Allah is Knowing of all things",
    normalizedText:
      "والذين ءامنوا من بعد وهاجروا وجهدوا معكم فاولاك منكم واولوا الارحام بعضهم اولى ببعض في كتب الله ان الله بكل شيء عليم",
  },
  {
    verseId: 0,
    name: "التوبة",
    surahId: 9,
    text: "بَرَآءَةٞ مِّنَ ٱللَّهِ وَرَسُولِهِۦٓ إِلَى ٱلَّذِينَ عَٰهَدتُّم مِّنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "[This is a declaration of] disassociation, from Allah and His Messenger, to those with whom you had made a treaty among the polytheists",
    normalizedText: "براءة من الله ورسوله الى الذين عهدتم من المشركين",
  },
  {
    verseId: 1,
    name: "التوبة",
    surahId: 9,
    text: "فَسِيحُواْ فِي ٱلۡأَرۡضِ أَرۡبَعَةَ أَشۡهُرٖ وَٱعۡلَمُوٓاْ أَنَّكُمۡ غَيۡرُ مُعۡجِزِي ٱللَّهِ وَأَنَّ ٱللَّهَ مُخۡزِي ٱلۡكَٰفِرِينَ",
    translation:
      "So travel freely, [O disbelievers], throughout the land [during] four months but know that you cannot cause failure to Allah and that Allah will disgrace the disbelievers",
    normalizedText:
      "فسيحوا في الارض اربعة اشهر واعلموا انكم غير معجزي الله وان الله مخزي الكفرين",
  },
  {
    verseId: 2,
    name: "التوبة",
    surahId: 9,
    text: "وَأَذَٰنٞ مِّنَ ٱللَّهِ وَرَسُولِهِۦٓ إِلَى ٱلنَّاسِ يَوۡمَ ٱلۡحَجِّ ٱلۡأَكۡبَرِ أَنَّ ٱللَّهَ بَرِيٓءٞ مِّنَ ٱلۡمُشۡرِكِينَ وَرَسُولُهُۥۚ فَإِن تُبۡتُمۡ فَهُوَ خَيۡرٞ لَّكُمۡۖ وَإِن تَوَلَّيۡتُمۡ فَٱعۡلَمُوٓاْ أَنَّكُمۡ غَيۡرُ مُعۡجِزِي ٱللَّهِۗ وَبَشِّرِ ٱلَّذِينَ كَفَرُواْ بِعَذَابٍ أَلِيمٍ",
    translation:
      "And [it is] an announcement from Allah and His Messenger to the people on the day of the greater pilgrimage that Allah is disassociated from the disbelievers, and [so is] His Messenger. So if you repent, that is best for you; but if you turn away - then know that you will not cause failure to Allah. And give tidings to those who disbelieve of a painful punishment",
    normalizedText:
      "واذن من الله ورسوله الى الناس يوم الحج الاكبر ان الله بريء من المشركين ورسوله فان تبتم فهو خير لكم وان توليتم فاعلموا انكم غير معجزي الله وبشر الذين كفروا بعذاب اليم",
  },
  {
    verseId: 3,
    name: "التوبة",
    surahId: 9,
    text: "إِلَّا ٱلَّذِينَ عَٰهَدتُّم مِّنَ ٱلۡمُشۡرِكِينَ ثُمَّ لَمۡ يَنقُصُوكُمۡ شَيۡـٔٗا وَلَمۡ يُظَٰهِرُواْ عَلَيۡكُمۡ أَحَدٗا فَأَتِمُّوٓاْ إِلَيۡهِمۡ عَهۡدَهُمۡ إِلَىٰ مُدَّتِهِمۡۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُتَّقِينَ",
    translation:
      "Excepted are those with whom you made a treaty among the polytheists and then they have not been deficient toward you in anything or supported anyone against you; so complete for them their treaty until their term [has ended]. Indeed, Allah loves the righteous [who fear Him]",
    normalizedText:
      "الا الذين عهدتم من المشركين ثم لم ينقصوكم شيا ولم يظهروا عليكم احدا فاتموا اليهم عهدهم الى مدتهم ان الله يحب المتقين",
  },
  {
    verseId: 4,
    name: "التوبة",
    surahId: 9,
    text: "فَإِذَا ٱنسَلَخَ ٱلۡأَشۡهُرُ ٱلۡحُرُمُ فَٱقۡتُلُواْ ٱلۡمُشۡرِكِينَ حَيۡثُ وَجَدتُّمُوهُمۡ وَخُذُوهُمۡ وَٱحۡصُرُوهُمۡ وَٱقۡعُدُواْ لَهُمۡ كُلَّ مَرۡصَدٖۚ فَإِن تَابُواْ وَأَقَامُواْ ٱلصَّلَوٰةَ وَءَاتَوُاْ ٱلزَّكَوٰةَ فَخَلُّواْ سَبِيلَهُمۡۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "And when the sacred months have passed, then kill the polytheists wherever you find them and capture them and besiege them and sit in wait for them at every place of ambush. But if they should repent, establish prayer, and give zakah, let them [go] on their way. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "فاذا انسلخ الاشهر الحرم فاقتلوا المشركين حيث وجدتموهم وخذوهم واحصروهم واقعدوا لهم كل مرصد فان تابوا واقاموا الصلوة وءاتوا الزكوة فخلوا سبيلهم ان الله غفور رحيم",
  },
  {
    verseId: 5,
    name: "التوبة",
    surahId: 9,
    text: "وَإِنۡ أَحَدٞ مِّنَ ٱلۡمُشۡرِكِينَ ٱسۡتَجَارَكَ فَأَجِرۡهُ حَتَّىٰ يَسۡمَعَ كَلَٰمَ ٱللَّهِ ثُمَّ أَبۡلِغۡهُ مَأۡمَنَهُۥۚ ذَٰلِكَ بِأَنَّهُمۡ قَوۡمٞ لَّا يَعۡلَمُونَ",
    translation:
      "And if any one of the polytheists seeks your protection, then grant him protection so that he may hear the words of Allah. Then deliver him to his place of safety. That is because they are a people who do not know",
    normalizedText:
      "وان احد من المشركين استجارك فاجره حتى يسمع كلم الله ثم ابلغه مامنه ذلك بانهم قوم لا يعلمون",
  },
  {
    verseId: 6,
    name: "التوبة",
    surahId: 9,
    text: "كَيۡفَ يَكُونُ لِلۡمُشۡرِكِينَ عَهۡدٌ عِندَ ٱللَّهِ وَعِندَ رَسُولِهِۦٓ إِلَّا ٱلَّذِينَ عَٰهَدتُّمۡ عِندَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِۖ فَمَا ٱسۡتَقَٰمُواْ لَكُمۡ فَٱسۡتَقِيمُواْ لَهُمۡۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُتَّقِينَ",
    translation:
      "How can there be for the polytheists a treaty in the sight of Allah and with His Messenger, except for those with whom you made a treaty at al-Masjid al-Haram? So as long as they are upright toward you, be upright toward them. Indeed, Allah loves the righteous [who fear Him]",
    normalizedText:
      "كيف يكون للمشركين عهد عند الله وعند رسوله الا الذين عهدتم عند المسجد الحرام فما استقموا لكم فاستقيموا لهم ان الله يحب المتقين",
  },
  {
    verseId: 7,
    name: "التوبة",
    surahId: 9,
    text: "كَيۡفَ وَإِن يَظۡهَرُواْ عَلَيۡكُمۡ لَا يَرۡقُبُواْ فِيكُمۡ إِلّٗا وَلَا ذِمَّةٗۚ يُرۡضُونَكُم بِأَفۡوَٰهِهِمۡ وَتَأۡبَىٰ قُلُوبُهُمۡ وَأَكۡثَرُهُمۡ فَٰسِقُونَ",
    translation:
      "How [can there be a treaty] while, if they gain dominance over you, they do not observe concerning you any pact of kinship or covenant of protection? They satisfy you with their mouths, but their hearts refuse [compliance], and most of them are defiantly disobedient",
    normalizedText:
      "كيف وان يظهروا عليكم لا يرقبوا فيكم الا ولا ذمة يرضونكم بافوههم وتابى قلوبهم واكثرهم فسقون",
  },
  {
    verseId: 8,
    name: "التوبة",
    surahId: 9,
    text: "ٱشۡتَرَوۡاْ بِـَٔايَٰتِ ٱللَّهِ ثَمَنٗا قَلِيلٗا فَصَدُّواْ عَن سَبِيلِهِۦٓۚ إِنَّهُمۡ سَآءَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "They have exchanged the signs of Allah for a small price and averted [people] from His way. Indeed, it was evil that they were doing",
    normalizedText:
      "اشتروا بايت الله ثمنا قليلا فصدوا عن سبيله انهم ساء ما كانوا يعملون",
  },
  {
    verseId: 9,
    name: "التوبة",
    surahId: 9,
    text: "لَا يَرۡقُبُونَ فِي مُؤۡمِنٍ إِلّٗا وَلَا ذِمَّةٗۚ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُعۡتَدُونَ",
    translation:
      "They do not observe toward a believer any pact of kinship or covenant of protection. And it is they who are the transgressors",
    normalizedText: "لا يرقبون في مامن الا ولا ذمة واولاك هم المعتدون",
  },
  {
    verseId: 10,
    name: "التوبة",
    surahId: 9,
    text: "فَإِن تَابُواْ وَأَقَامُواْ ٱلصَّلَوٰةَ وَءَاتَوُاْ ٱلزَّكَوٰةَ فَإِخۡوَٰنُكُمۡ فِي ٱلدِّينِۗ وَنُفَصِّلُ ٱلۡأٓيَٰتِ لِقَوۡمٖ يَعۡلَمُونَ",
    translation:
      "But if they repent, establish prayer, and give zakah, then they are your brothers in religion; and We detail the verses for a people who know",
    normalizedText:
      "فان تابوا واقاموا الصلوة وءاتوا الزكوة فاخونكم في الدين ونفصل الايت لقوم يعلمون",
  },
  {
    verseId: 11,
    name: "التوبة",
    surahId: 9,
    text: "وَإِن نَّكَثُوٓاْ أَيۡمَٰنَهُم مِّنۢ بَعۡدِ عَهۡدِهِمۡ وَطَعَنُواْ فِي دِينِكُمۡ فَقَٰتِلُوٓاْ أَئِمَّةَ ٱلۡكُفۡرِ إِنَّهُمۡ لَآ أَيۡمَٰنَ لَهُمۡ لَعَلَّهُمۡ يَنتَهُونَ",
    translation:
      "And if they break their oaths after their treaty and defame your religion, then fight the leaders of disbelief, for indeed, there are no oaths [sacred] to them; [fight them that] they might cease",
    normalizedText:
      "وان نكثوا ايمنهم من بعد عهدهم وطعنوا في دينكم فقتلوا اامة الكفر انهم لا ايمن لهم لعلهم ينتهون",
  },
  {
    verseId: 12,
    name: "التوبة",
    surahId: 9,
    text: "أَلَا تُقَٰتِلُونَ قَوۡمٗا نَّكَثُوٓاْ أَيۡمَٰنَهُمۡ وَهَمُّواْ بِإِخۡرَاجِ ٱلرَّسُولِ وَهُم بَدَءُوكُمۡ أَوَّلَ مَرَّةٍۚ أَتَخۡشَوۡنَهُمۡۚ فَٱللَّهُ أَحَقُّ أَن تَخۡشَوۡهُ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "Would you not fight a people who broke their oaths and determined to expel the Messenger, and they had begun [the attack upon] you the first time? Do you fear them? But Allah has more right that you should fear Him, if you are [truly] believers",
    normalizedText:
      "الا تقتلون قوما نكثوا ايمنهم وهموا باخراج الرسول وهم بدءوكم اول مرة اتخشونهم فالله احق ان تخشوه ان كنتم مامنين",
  },
  {
    verseId: 13,
    name: "التوبة",
    surahId: 9,
    text: "قَٰتِلُوهُمۡ يُعَذِّبۡهُمُ ٱللَّهُ بِأَيۡدِيكُمۡ وَيُخۡزِهِمۡ وَيَنصُرۡكُمۡ عَلَيۡهِمۡ وَيَشۡفِ صُدُورَ قَوۡمٖ مُّؤۡمِنِينَ",
    translation:
      "Fight them; Allah will punish them by your hands and will disgrace them and give you victory over them and satisfy the breasts of a believing people",
    normalizedText:
      "قتلوهم يعذبهم الله بايديكم ويخزهم وينصركم عليهم ويشف صدور قوم مامنين",
  },
  {
    verseId: 14,
    name: "التوبة",
    surahId: 9,
    text: "وَيُذۡهِبۡ غَيۡظَ قُلُوبِهِمۡۗ وَيَتُوبُ ٱللَّهُ عَلَىٰ مَن يَشَآءُۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌ",
    translation:
      "And remove the fury in the believers' hearts. And Allah turns in forgiveness to whom He wills; and Allah is Knowing and Wise",
    normalizedText: "ويذهب غيظ قلوبهم ويتوب الله على من يشاء والله عليم حكيم",
  },
  {
    verseId: 15,
    name: "التوبة",
    surahId: 9,
    text: "أَمۡ حَسِبۡتُمۡ أَن تُتۡرَكُواْ وَلَمَّا يَعۡلَمِ ٱللَّهُ ٱلَّذِينَ جَٰهَدُواْ مِنكُمۡ وَلَمۡ يَتَّخِذُواْ مِن دُونِ ٱللَّهِ وَلَا رَسُولِهِۦ وَلَا ٱلۡمُؤۡمِنِينَ وَلِيجَةٗۚ وَٱللَّهُ خَبِيرُۢ بِمَا تَعۡمَلُونَ",
    translation:
      "Do you think that you will be left [as you are] while Allah has not yet made evident those among you who strive [for His cause] and do not take other than Allah, His Messenger and the believers as intimates? And Allah is Acquainted with what you do",
    normalizedText:
      "ام حسبتم ان تتركوا ولما يعلم الله الذين جهدوا منكم ولم يتخذوا من دون الله ولا رسوله ولا المامنين وليجة والله خبير بما تعملون",
  },
  {
    verseId: 16,
    name: "التوبة",
    surahId: 9,
    text: "مَا كَانَ لِلۡمُشۡرِكِينَ أَن يَعۡمُرُواْ مَسَٰجِدَ ٱللَّهِ شَٰهِدِينَ عَلَىٰٓ أَنفُسِهِم بِٱلۡكُفۡرِۚ أُوْلَـٰٓئِكَ حَبِطَتۡ أَعۡمَٰلُهُمۡ وَفِي ٱلنَّارِ هُمۡ خَٰلِدُونَ",
    translation:
      "It is not for the polytheists to maintain the mosques of Allah [while] witnessing against themselves with disbelief. [For] those, their deeds have become worthless, and in the Fire they will abide eternally",
    normalizedText:
      "ما كان للمشركين ان يعمروا مسجد الله شهدين على انفسهم بالكفر اولاك حبطت اعملهم وفي النار هم خلدون",
  },
  {
    verseId: 17,
    name: "التوبة",
    surahId: 9,
    text: "إِنَّمَا يَعۡمُرُ مَسَٰجِدَ ٱللَّهِ مَنۡ ءَامَنَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَأَقَامَ ٱلصَّلَوٰةَ وَءَاتَى ٱلزَّكَوٰةَ وَلَمۡ يَخۡشَ إِلَّا ٱللَّهَۖ فَعَسَىٰٓ أُوْلَـٰٓئِكَ أَن يَكُونُواْ مِنَ ٱلۡمُهۡتَدِينَ",
    translation:
      "The mosques of Allah are only to be maintained by those who believe in Allah and the Last Day and establish prayer and give zakah and do not fear except Allah, for it is expected that those will be of the [rightly] guided",
    normalizedText:
      "انما يعمر مسجد الله من ءامن بالله واليوم الاخر واقام الصلوة وءاتى الزكوة ولم يخش الا الله فعسى اولاك ان يكونوا من المهتدين",
  },
  {
    verseId: 18,
    name: "التوبة",
    surahId: 9,
    text: "۞أَجَعَلۡتُمۡ سِقَايَةَ ٱلۡحَآجِّ وَعِمَارَةَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِ كَمَنۡ ءَامَنَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَجَٰهَدَ فِي سَبِيلِ ٱللَّهِۚ لَا يَسۡتَوُۥنَ عِندَ ٱللَّهِۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      "Have you made the providing of water for the pilgrim and the maintenance of al-Masjid al-Haram equal to [the deeds of] one who believes in Allah and the Last Day and strives in the cause of Allah? They are not equal in the sight of Allah. And Allah does not guide the wrongdoing people",
    normalizedText:
      "۞اجعلتم سقاية الحاج وعمارة المسجد الحرام كمن ءامن بالله واليوم الاخر وجهد في سبيل الله لا يستون عند الله والله لا يهدي القوم الظلمين",
  },
  {
    verseId: 19,
    name: "التوبة",
    surahId: 9,
    text: "ٱلَّذِينَ ءَامَنُواْ وَهَاجَرُواْ وَجَٰهَدُواْ فِي سَبِيلِ ٱللَّهِ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡ أَعۡظَمُ دَرَجَةً عِندَ ٱللَّهِۚ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡفَآئِزُونَ",
    translation:
      "The ones who have believed, emigrated and striven in the cause of Allah with their wealth and their lives are greater in rank in the sight of Allah. And it is those who are the attainers [of success]",
    normalizedText:
      "الذين ءامنوا وهاجروا وجهدوا في سبيل الله بامولهم وانفسهم اعظم درجة عند الله واولاك هم الفاازون",
  },
  {
    verseId: 20,
    name: "التوبة",
    surahId: 9,
    text: "يُبَشِّرُهُمۡ رَبُّهُم بِرَحۡمَةٖ مِّنۡهُ وَرِضۡوَٰنٖ وَجَنَّـٰتٖ لَّهُمۡ فِيهَا نَعِيمٞ مُّقِيمٌ",
    translation:
      "Their Lord gives them good tidings of mercy from Him and approval and of gardens for them wherein is enduring pleasure",
    normalizedText: "يبشرهم ربهم برحمة منه ورضون وجنت لهم فيها نعيم مقيم",
  },
  {
    verseId: 21,
    name: "التوبة",
    surahId: 9,
    text: "خَٰلِدِينَ فِيهَآ أَبَدًاۚ إِنَّ ٱللَّهَ عِندَهُۥٓ أَجۡرٌ عَظِيمٞ",
    translation:
      "[They will be] abiding therein forever. Indeed, Allah has with Him a great reward",
    normalizedText: "خلدين فيها ابدا ان الله عنده اجر عظيم",
  },
  {
    verseId: 22,
    name: "التوبة",
    surahId: 9,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّخِذُوٓاْ ءَابَآءَكُمۡ وَإِخۡوَٰنَكُمۡ أَوۡلِيَآءَ إِنِ ٱسۡتَحَبُّواْ ٱلۡكُفۡرَ عَلَى ٱلۡإِيمَٰنِۚ وَمَن يَتَوَلَّهُم مِّنكُمۡ فَأُوْلَـٰٓئِكَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "O you who have believed, do not take your fathers or your brothers as allies if they have preferred disbelief over belief. And whoever does so among you - then it is those who are the wrongdoers",
    normalizedText:
      "يايها الذين ءامنوا لا تتخذوا ءاباءكم واخونكم اولياء ان استحبوا الكفر على الايمن ومن يتولهم منكم فاولاك هم الظلمون",
  },
  {
    verseId: 23,
    name: "التوبة",
    surahId: 9,
    text: "قُلۡ إِن كَانَ ءَابَآؤُكُمۡ وَأَبۡنَآؤُكُمۡ وَإِخۡوَٰنُكُمۡ وَأَزۡوَٰجُكُمۡ وَعَشِيرَتُكُمۡ وَأَمۡوَٰلٌ ٱقۡتَرَفۡتُمُوهَا وَتِجَٰرَةٞ تَخۡشَوۡنَ كَسَادَهَا وَمَسَٰكِنُ تَرۡضَوۡنَهَآ أَحَبَّ إِلَيۡكُم مِّنَ ٱللَّهِ وَرَسُولِهِۦ وَجِهَادٖ فِي سَبِيلِهِۦ فَتَرَبَّصُواْ حَتَّىٰ يَأۡتِيَ ٱللَّهُ بِأَمۡرِهِۦۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡفَٰسِقِينَ",
    translation:
      'Say, [O Muhammad], "If your fathers, your sons, your brothers, your wives, your relatives, wealth which you have obtained, commerce wherein you fear decline, and dwellings with which you are pleased are more beloved to you than Allah and His Messenger and jihad in His cause, then wait until Allah executes His command. And Allah does not guide the defiantly disobedient people',
    normalizedText:
      "قل ان كان ءابااكم وابنااكم واخونكم وازوجكم وعشيرتكم وامول اقترفتموها وتجرة تخشون كسادها ومسكن ترضونها احب اليكم من الله ورسوله وجهاد في سبيله فتربصوا حتى ياتي الله بامره والله لا يهدي القوم الفسقين",
  },
  {
    verseId: 24,
    name: "التوبة",
    surahId: 9,
    text: "لَقَدۡ نَصَرَكُمُ ٱللَّهُ فِي مَوَاطِنَ كَثِيرَةٖ وَيَوۡمَ حُنَيۡنٍ إِذۡ أَعۡجَبَتۡكُمۡ كَثۡرَتُكُمۡ فَلَمۡ تُغۡنِ عَنكُمۡ شَيۡـٔٗا وَضَاقَتۡ عَلَيۡكُمُ ٱلۡأَرۡضُ بِمَا رَحُبَتۡ ثُمَّ وَلَّيۡتُم مُّدۡبِرِينَ",
    translation:
      "Allah has already given you victory in many regions and [even] on the day of Hunayn, when your great number pleased you, but it did not avail you at all, and the earth was confining for you with its vastness; then you turned back, fleeing",
    normalizedText:
      "لقد نصركم الله في مواطن كثيرة ويوم حنين اذ اعجبتكم كثرتكم فلم تغن عنكم شيا وضاقت عليكم الارض بما رحبت ثم وليتم مدبرين",
  },
  {
    verseId: 25,
    name: "التوبة",
    surahId: 9,
    text: "ثُمَّ أَنزَلَ ٱللَّهُ سَكِينَتَهُۥ عَلَىٰ رَسُولِهِۦ وَعَلَى ٱلۡمُؤۡمِنِينَ وَأَنزَلَ جُنُودٗا لَّمۡ تَرَوۡهَا وَعَذَّبَ ٱلَّذِينَ كَفَرُواْۚ وَذَٰلِكَ جَزَآءُ ٱلۡكَٰفِرِينَ",
    translation:
      "Then Allah sent down His tranquillity upon His Messenger and upon the believers and sent down soldiers angels whom you did not see and punished those who disbelieved. And that is the recompense of the disbelievers",
    normalizedText:
      "ثم انزل الله سكينته على رسوله وعلى المامنين وانزل جنودا لم تروها وعذب الذين كفروا وذلك جزاء الكفرين",
  },
  {
    verseId: 26,
    name: "التوبة",
    surahId: 9,
    text: "ثُمَّ يَتُوبُ ٱللَّهُ مِنۢ بَعۡدِ ذَٰلِكَ عَلَىٰ مَن يَشَآءُۗ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "Then Allah will accept repentance after that for whom He wills; and Allah is Forgiving and Merciful",
    normalizedText: "ثم يتوب الله من بعد ذلك على من يشاء والله غفور رحيم",
  },
  {
    verseId: 27,
    name: "التوبة",
    surahId: 9,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِنَّمَا ٱلۡمُشۡرِكُونَ نَجَسٞ فَلَا يَقۡرَبُواْ ٱلۡمَسۡجِدَ ٱلۡحَرَامَ بَعۡدَ عَامِهِمۡ هَٰذَاۚ وَإِنۡ خِفۡتُمۡ عَيۡلَةٗ فَسَوۡفَ يُغۡنِيكُمُ ٱللَّهُ مِن فَضۡلِهِۦٓ إِن شَآءَۚ إِنَّ ٱللَّهَ عَلِيمٌ حَكِيمٞ",
    translation:
      "O you who have believed, indeed the polytheists are unclean, so let them not approach al-Masjid al-Haram after this, their [final] year. And if you fear privation, Allah will enrich you from His bounty if He wills. Indeed, Allah is Knowing and Wise",
    normalizedText:
      "يايها الذين ءامنوا انما المشركون نجس فلا يقربوا المسجد الحرام بعد عامهم هذا وان خفتم عيلة فسوف يغنيكم الله من فضله ان شاء ان الله عليم حكيم",
  },
  {
    verseId: 28,
    name: "التوبة",
    surahId: 9,
    text: "قَٰتِلُواْ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱللَّهِ وَلَا بِٱلۡيَوۡمِ ٱلۡأٓخِرِ وَلَا يُحَرِّمُونَ مَا حَرَّمَ ٱللَّهُ وَرَسُولُهُۥ وَلَا يَدِينُونَ دِينَ ٱلۡحَقِّ مِنَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ حَتَّىٰ يُعۡطُواْ ٱلۡجِزۡيَةَ عَن يَدٖ وَهُمۡ صَٰغِرُونَ",
    translation:
      "Fight those who do not believe in Allah or in the Last Day and who do not consider unlawful what Allah and His Messenger have made unlawful and who do not adopt the religion of truth from those who were given the Scripture - [fight] until they give the jizyah willingly while they are humbled",
    normalizedText:
      "قتلوا الذين لا يامنون بالله ولا باليوم الاخر ولا يحرمون ما حرم الله ورسوله ولا يدينون دين الحق من الذين اوتوا الكتب حتى يعطوا الجزية عن يد وهم صغرون",
  },
  {
    verseId: 29,
    name: "التوبة",
    surahId: 9,
    text: "وَقَالَتِ ٱلۡيَهُودُ عُزَيۡرٌ ٱبۡنُ ٱللَّهِ وَقَالَتِ ٱلنَّصَٰرَى ٱلۡمَسِيحُ ٱبۡنُ ٱللَّهِۖ ذَٰلِكَ قَوۡلُهُم بِأَفۡوَٰهِهِمۡۖ يُضَٰهِـُٔونَ قَوۡلَ ٱلَّذِينَ كَفَرُواْ مِن قَبۡلُۚ قَٰتَلَهُمُ ٱللَّهُۖ أَنَّىٰ يُؤۡفَكُونَ",
    translation:
      'The Jews say, "Ezra is the son of Allah "; and the Christians say, "The Messiah is the son of Allah." That is their statement from their mouths; they imitate the saying of those who disbelieved [before them]. May Allah destroy them; how are they deluded',
    normalizedText:
      "وقالت اليهود عزير ابن الله وقالت النصرى المسيح ابن الله ذلك قولهم بافوههم يضهون قول الذين كفروا من قبل قتلهم الله انى يافكون",
  },
  {
    verseId: 30,
    name: "التوبة",
    surahId: 9,
    text: "ٱتَّخَذُوٓاْ أَحۡبَارَهُمۡ وَرُهۡبَٰنَهُمۡ أَرۡبَابٗا مِّن دُونِ ٱللَّهِ وَٱلۡمَسِيحَ ٱبۡنَ مَرۡيَمَ وَمَآ أُمِرُوٓاْ إِلَّا لِيَعۡبُدُوٓاْ إِلَٰهٗا وَٰحِدٗاۖ لَّآ إِلَٰهَ إِلَّا هُوَۚ سُبۡحَٰنَهُۥ عَمَّا يُشۡرِكُونَ",
    translation:
      "They have taken their scholars and monks as lords besides Allah, and [also] the Messiah, the son of Mary. And they were not commanded except to worship one God; there is no deity except Him. Exalted is He above whatever they associate with Him",
    normalizedText:
      "اتخذوا احبارهم ورهبنهم اربابا من دون الله والمسيح ابن مريم وما امروا الا ليعبدوا الها وحدا لا اله الا هو سبحنه عما يشركون",
  },
  {
    verseId: 31,
    name: "التوبة",
    surahId: 9,
    text: "يُرِيدُونَ أَن يُطۡفِـُٔواْ نُورَ ٱللَّهِ بِأَفۡوَٰهِهِمۡ وَيَأۡبَى ٱللَّهُ إِلَّآ أَن يُتِمَّ نُورَهُۥ وَلَوۡ كَرِهَ ٱلۡكَٰفِرُونَ",
    translation:
      "They want to extinguish the light of Allah with their mouths, but Allah refuses except to perfect His light, although the disbelievers dislike it",
    normalizedText:
      "يريدون ان يطفوا نور الله بافوههم ويابى الله الا ان يتم نوره ولو كره الكفرون",
  },
  {
    verseId: 32,
    name: "التوبة",
    surahId: 9,
    text: "هُوَ ٱلَّذِيٓ أَرۡسَلَ رَسُولَهُۥ بِٱلۡهُدَىٰ وَدِينِ ٱلۡحَقِّ لِيُظۡهِرَهُۥ عَلَى ٱلدِّينِ كُلِّهِۦ وَلَوۡ كَرِهَ ٱلۡمُشۡرِكُونَ",
    translation:
      "It is He who has sent His Messenger with guidance and the religion of truth to manifest it over all religion, although they who associate others with Allah dislike it",
    normalizedText:
      "هو الذي ارسل رسوله بالهدى ودين الحق ليظهره على الدين كله ولو كره المشركون",
  },
  {
    verseId: 33,
    name: "التوبة",
    surahId: 9,
    text: "۞يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِنَّ كَثِيرٗا مِّنَ ٱلۡأَحۡبَارِ وَٱلرُّهۡبَانِ لَيَأۡكُلُونَ أَمۡوَٰلَ ٱلنَّاسِ بِٱلۡبَٰطِلِ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِۗ وَٱلَّذِينَ يَكۡنِزُونَ ٱلذَّهَبَ وَٱلۡفِضَّةَ وَلَا يُنفِقُونَهَا فِي سَبِيلِ ٱللَّهِ فَبَشِّرۡهُم بِعَذَابٍ أَلِيمٖ",
    translation:
      "O you who have believed, indeed many of the scholars and the monks devour the wealth of people unjustly and avert [them] from the way of Allah. And those who hoard gold and silver and spend it not in the way of Allah - give them tidings of a painful punishment",
    normalizedText:
      "۞يايها الذين ءامنوا ان كثيرا من الاحبار والرهبان لياكلون امول الناس بالبطل ويصدون عن سبيل الله والذين يكنزون الذهب والفضة ولا ينفقونها في سبيل الله فبشرهم بعذاب اليم",
  },
  {
    verseId: 34,
    name: "التوبة",
    surahId: 9,
    text: "يَوۡمَ يُحۡمَىٰ عَلَيۡهَا فِي نَارِ جَهَنَّمَ فَتُكۡوَىٰ بِهَا جِبَاهُهُمۡ وَجُنُوبُهُمۡ وَظُهُورُهُمۡۖ هَٰذَا مَا كَنَزۡتُمۡ لِأَنفُسِكُمۡ فَذُوقُواْ مَا كُنتُمۡ تَكۡنِزُونَ",
    translation:
      'The Day when it will be heated in the fire of Hell and seared therewith will be their foreheads, their flanks, and their backs, [it will be said], "This is what you hoarded for yourselves, so taste what you used to hoard',
    normalizedText:
      "يوم يحمى عليها في نار جهنم فتكوى بها جباههم وجنوبهم وظهورهم هذا ما كنزتم لانفسكم فذوقوا ما كنتم تكنزون",
  },
  {
    verseId: 35,
    name: "التوبة",
    surahId: 9,
    text: "إِنَّ عِدَّةَ ٱلشُّهُورِ عِندَ ٱللَّهِ ٱثۡنَا عَشَرَ شَهۡرٗا فِي كِتَٰبِ ٱللَّهِ يَوۡمَ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ مِنۡهَآ أَرۡبَعَةٌ حُرُمٞۚ ذَٰلِكَ ٱلدِّينُ ٱلۡقَيِّمُۚ فَلَا تَظۡلِمُواْ فِيهِنَّ أَنفُسَكُمۡۚ وَقَٰتِلُواْ ٱلۡمُشۡرِكِينَ كَآفَّةٗ كَمَا يُقَٰتِلُونَكُمۡ كَآفَّةٗۚ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ مَعَ ٱلۡمُتَّقِينَ",
    translation:
      "Indeed, the number of months with Allah is twelve [lunar] months in the register of Allah [from] the day He created the heavens and the earth; of these, four are sacred. That is the correct religion, so do not wrong yourselves during them. And fight against the disbelievers collectively as they fight against you collectively. And know that Allah is with the righteous [who fear Him]",
    normalizedText:
      "ان عدة الشهور عند الله اثنا عشر شهرا في كتب الله يوم خلق السموت والارض منها اربعة حرم ذلك الدين القيم فلا تظلموا فيهن انفسكم وقتلوا المشركين كافة كما يقتلونكم كافة واعلموا ان الله مع المتقين",
  },
  {
    verseId: 36,
    name: "التوبة",
    surahId: 9,
    text: "إِنَّمَا ٱلنَّسِيٓءُ زِيَادَةٞ فِي ٱلۡكُفۡرِۖ يُضَلُّ بِهِ ٱلَّذِينَ كَفَرُواْ يُحِلُّونَهُۥ عَامٗا وَيُحَرِّمُونَهُۥ عَامٗا لِّيُوَاطِـُٔواْ عِدَّةَ مَا حَرَّمَ ٱللَّهُ فَيُحِلُّواْ مَا حَرَّمَ ٱللَّهُۚ زُيِّنَ لَهُمۡ سُوٓءُ أَعۡمَٰلِهِمۡۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡكَٰفِرِينَ",
    translation:
      "Indeed, the postponing [of restriction within sacred months] is an increase in disbelief by which those who have disbelieved are led [further] astray. They make it lawful one year and unlawful another year to correspond to the number made unlawful by Allah and [thus] make lawful what Allah has made unlawful. Made pleasing to them is the evil of their deeds; and Allah does not guide the disbelieving people",
    normalizedText:
      "انما النسيء زيادة في الكفر يضل به الذين كفروا يحلونه عاما ويحرمونه عاما ليواطوا عدة ما حرم الله فيحلوا ما حرم الله زين لهم سوء اعملهم والله لا يهدي القوم الكفرين",
  },
  {
    verseId: 37,
    name: "التوبة",
    surahId: 9,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ مَا لَكُمۡ إِذَا قِيلَ لَكُمُ ٱنفِرُواْ فِي سَبِيلِ ٱللَّهِ ٱثَّاقَلۡتُمۡ إِلَى ٱلۡأَرۡضِۚ أَرَضِيتُم بِٱلۡحَيَوٰةِ ٱلدُّنۡيَا مِنَ ٱلۡأٓخِرَةِۚ فَمَا مَتَٰعُ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا فِي ٱلۡأٓخِرَةِ إِلَّا قَلِيلٌ",
    translation:
      "O you who have believed, what is [the matter] with you that, when you are told to go forth in the cause of Allah, you adhere heavily to the earth? Are you satisfied with the life of this world rather than the Hereafter? But what is the enjoyment of worldly life compared to the Hereafter except a [very] little",
    normalizedText:
      "يايها الذين ءامنوا ما لكم اذا قيل لكم انفروا في سبيل الله اثاقلتم الى الارض ارضيتم بالحيوة الدنيا من الاخرة فما متع الحيوة الدنيا في الاخرة الا قليل",
  },
  {
    verseId: 38,
    name: "التوبة",
    surahId: 9,
    text: "إِلَّا تَنفِرُواْ يُعَذِّبۡكُمۡ عَذَابًا أَلِيمٗا وَيَسۡتَبۡدِلۡ قَوۡمًا غَيۡرَكُمۡ وَلَا تَضُرُّوهُ شَيۡـٔٗاۗ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "If you do not go forth, He will punish you with a painful punishment and will replace you with another people, and you will not harm Him at all. And Allah is over all things competent",
    normalizedText:
      "الا تنفروا يعذبكم عذابا اليما ويستبدل قوما غيركم ولا تضروه شيا والله على كل شيء قدير",
  },
  {
    verseId: 39,
    name: "التوبة",
    surahId: 9,
    text: "إِلَّا تَنصُرُوهُ فَقَدۡ نَصَرَهُ ٱللَّهُ إِذۡ أَخۡرَجَهُ ٱلَّذِينَ كَفَرُواْ ثَانِيَ ٱثۡنَيۡنِ إِذۡ هُمَا فِي ٱلۡغَارِ إِذۡ يَقُولُ لِصَٰحِبِهِۦ لَا تَحۡزَنۡ إِنَّ ٱللَّهَ مَعَنَاۖ فَأَنزَلَ ٱللَّهُ سَكِينَتَهُۥ عَلَيۡهِ وَأَيَّدَهُۥ بِجُنُودٖ لَّمۡ تَرَوۡهَا وَجَعَلَ كَلِمَةَ ٱلَّذِينَ كَفَرُواْ ٱلسُّفۡلَىٰۗ وَكَلِمَةُ ٱللَّهِ هِيَ ٱلۡعُلۡيَاۗ وَٱللَّهُ عَزِيزٌ حَكِيمٌ",
    translation:
      'If you do not aid the Prophet - Allah has already aided him when those who disbelieved had driven him out [of Makkah] as one of two, when they were in the cave and he said to his companion, "Do not grieve; indeed Allah is with us." And Allah sent down his tranquillity upon him and supported him with angels you did not see and made the word of those who disbelieved the lowest, while the word of Allah - that is the highest. And Allah is Exalted in Might and Wise',
    normalizedText:
      "الا تنصروه فقد نصره الله اذ اخرجه الذين كفروا ثاني اثنين اذ هما في الغار اذ يقول لصحبه لا تحزن ان الله معنا فانزل الله سكينته عليه وايده بجنود لم تروها وجعل كلمة الذين كفروا السفلى وكلمة الله هي العليا والله عزيز حكيم",
  },
  {
    verseId: 40,
    name: "التوبة",
    surahId: 9,
    text: "ٱنفِرُواْ خِفَافٗا وَثِقَالٗا وَجَٰهِدُواْ بِأَمۡوَٰلِكُمۡ وَأَنفُسِكُمۡ فِي سَبِيلِ ٱللَّهِۚ ذَٰلِكُمۡ خَيۡرٞ لَّكُمۡ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "Go forth, whether light or heavy, and strive with your wealth and your lives in the cause of Allah. That is better for you, if you only knew",
    normalizedText:
      "انفروا خفافا وثقالا وجهدوا بامولكم وانفسكم في سبيل الله ذلكم خير لكم ان كنتم تعلمون",
  },
  {
    verseId: 41,
    name: "التوبة",
    surahId: 9,
    text: "لَوۡ كَانَ عَرَضٗا قَرِيبٗا وَسَفَرٗا قَاصِدٗا لَّٱتَّبَعُوكَ وَلَٰكِنۢ بَعُدَتۡ عَلَيۡهِمُ ٱلشُّقَّةُۚ وَسَيَحۡلِفُونَ بِٱللَّهِ لَوِ ٱسۡتَطَعۡنَا لَخَرَجۡنَا مَعَكُمۡ يُهۡلِكُونَ أَنفُسَهُمۡ وَٱللَّهُ يَعۡلَمُ إِنَّهُمۡ لَكَٰذِبُونَ",
    translation:
      'Had it been an easy gain and a moderate trip, the hypocrites would have followed you, but distant to them was the journey. And they will swear by Allah, "If we were able, we would have gone forth with you," destroying themselves [through false oaths], and Allah knows that indeed they are liars',
    normalizedText:
      "لو كان عرضا قريبا وسفرا قاصدا لاتبعوك ولكن بعدت عليهم الشقة وسيحلفون بالله لو استطعنا لخرجنا معكم يهلكون انفسهم والله يعلم انهم لكذبون",
  },
  {
    verseId: 42,
    name: "التوبة",
    surahId: 9,
    text: "عَفَا ٱللَّهُ عَنكَ لِمَ أَذِنتَ لَهُمۡ حَتَّىٰ يَتَبَيَّنَ لَكَ ٱلَّذِينَ صَدَقُواْ وَتَعۡلَمَ ٱلۡكَٰذِبِينَ",
    translation:
      "May Allah pardon you, [O Muhammad]; why did you give them permission [to remain behind]? [You should not have] until it was evident to you who were truthful and you knew [who were] the liars",
    normalizedText:
      "عفا الله عنك لم اذنت لهم حتى يتبين لك الذين صدقوا وتعلم الكذبين",
  },
  {
    verseId: 43,
    name: "التوبة",
    surahId: 9,
    text: "لَا يَسۡتَـٔۡذِنُكَ ٱلَّذِينَ يُؤۡمِنُونَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ أَن يُجَٰهِدُواْ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡۗ وَٱللَّهُ عَلِيمُۢ بِٱلۡمُتَّقِينَ",
    translation:
      "Those who believe in Allah and the Last Day would not ask permission of you to be excused from striving with their wealth and their lives. And Allah is Knowing of those who fear Him",
    normalizedText:
      "لا يستذنك الذين يامنون بالله واليوم الاخر ان يجهدوا بامولهم وانفسهم والله عليم بالمتقين",
  },
  {
    verseId: 44,
    name: "التوبة",
    surahId: 9,
    text: "إِنَّمَا يَسۡتَـٔۡذِنُكَ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَٱرۡتَابَتۡ قُلُوبُهُمۡ فَهُمۡ فِي رَيۡبِهِمۡ يَتَرَدَّدُونَ",
    translation:
      "Only those would ask permission of you who do not believe in Allah and the Last Day and whose hearts have doubted, and they, in their doubt, are hesitating",
    normalizedText:
      "انما يستذنك الذين لا يامنون بالله واليوم الاخر وارتابت قلوبهم فهم في ريبهم يترددون",
  },
  {
    verseId: 45,
    name: "التوبة",
    surahId: 9,
    text: "۞وَلَوۡ أَرَادُواْ ٱلۡخُرُوجَ لَأَعَدُّواْ لَهُۥ عُدَّةٗ وَلَٰكِن كَرِهَ ٱللَّهُ ٱنۢبِعَاثَهُمۡ فَثَبَّطَهُمۡ وَقِيلَ ٱقۡعُدُواْ مَعَ ٱلۡقَٰعِدِينَ",
    translation:
      'And if they had intended to go forth, they would have prepared for it [some] preparation. But Allah disliked their being sent, so He kept them back, and they were told, "Remain [behind] with those who remain',
    normalizedText:
      "۞ولو ارادوا الخروج لاعدوا له عدة ولكن كره الله انبعاثهم فثبطهم وقيل اقعدوا مع القعدين",
  },
  {
    verseId: 46,
    name: "التوبة",
    surahId: 9,
    text: "لَوۡ خَرَجُواْ فِيكُم مَّا زَادُوكُمۡ إِلَّا خَبَالٗا وَلَأَوۡضَعُواْ خِلَٰلَكُمۡ يَبۡغُونَكُمُ ٱلۡفِتۡنَةَ وَفِيكُمۡ سَمَّـٰعُونَ لَهُمۡۗ وَٱللَّهُ عَلِيمُۢ بِٱلظَّـٰلِمِينَ",
    translation:
      "Had they gone forth with you, they would not have increased you except in confusion, and they would have been active among you, seeking [to cause] you fitnah. And among you are avid listeners to them. And Allah is Knowing of the wrongdoers",
    normalizedText:
      "لو خرجوا فيكم ما زادوكم الا خبالا ولاوضعوا خللكم يبغونكم الفتنة وفيكم سمعون لهم والله عليم بالظلمين",
  },
  {
    verseId: 47,
    name: "التوبة",
    surahId: 9,
    text: "لَقَدِ ٱبۡتَغَوُاْ ٱلۡفِتۡنَةَ مِن قَبۡلُ وَقَلَّبُواْ لَكَ ٱلۡأُمُورَ حَتَّىٰ جَآءَ ٱلۡحَقُّ وَظَهَرَ أَمۡرُ ٱللَّهِ وَهُمۡ كَٰرِهُونَ",
    translation:
      "They had already desired dissension before and had upset matters for you until the truth came and the ordinance of Allah appeared, while they were averse",
    normalizedText:
      "لقد ابتغوا الفتنة من قبل وقلبوا لك الامور حتى جاء الحق وظهر امر الله وهم كرهون",
  },
  {
    verseId: 48,
    name: "التوبة",
    surahId: 9,
    text: "وَمِنۡهُم مَّن يَقُولُ ٱئۡذَن لِّي وَلَا تَفۡتِنِّيٓۚ أَلَا فِي ٱلۡفِتۡنَةِ سَقَطُواْۗ وَإِنَّ جَهَنَّمَ لَمُحِيطَةُۢ بِٱلۡكَٰفِرِينَ",
    translation:
      'And among them is he who says, "Permit me [to remain at home] and do not put me to trial." Unquestionably, into trial they have fallen. And indeed, Hell will encompass the disbelievers',
    normalizedText:
      "ومنهم من يقول ااذن لي ولا تفتني الا في الفتنة سقطوا وان جهنم لمحيطة بالكفرين",
  },
  {
    verseId: 49,
    name: "التوبة",
    surahId: 9,
    text: "إِن تُصِبۡكَ حَسَنَةٞ تَسُؤۡهُمۡۖ وَإِن تُصِبۡكَ مُصِيبَةٞ يَقُولُواْ قَدۡ أَخَذۡنَآ أَمۡرَنَا مِن قَبۡلُ وَيَتَوَلَّواْ وَّهُمۡ فَرِحُونَ",
    translation:
      'If good befalls you, it distresses them; but if disaster strikes you, they say, "We took our matter [in hand] before," and turn away while they are rejoicing',
    normalizedText:
      "ان تصبك حسنة تساهم وان تصبك مصيبة يقولوا قد اخذنا امرنا من قبل ويتولوا وهم فرحون",
  },
  {
    verseId: 50,
    name: "التوبة",
    surahId: 9,
    text: "قُل لَّن يُصِيبَنَآ إِلَّا مَا كَتَبَ ٱللَّهُ لَنَا هُوَ مَوۡلَىٰنَاۚ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُؤۡمِنُونَ",
    translation:
      'Say, "Never will we be struck except by what Allah has decreed for us; He is our protector." And upon Allah let the believers rely',
    normalizedText:
      "قل لن يصيبنا الا ما كتب الله لنا هو مولىنا وعلى الله فليتوكل المامنون",
  },
  {
    verseId: 51,
    name: "التوبة",
    surahId: 9,
    text: "قُلۡ هَلۡ تَرَبَّصُونَ بِنَآ إِلَّآ إِحۡدَى ٱلۡحُسۡنَيَيۡنِۖ وَنَحۡنُ نَتَرَبَّصُ بِكُمۡ أَن يُصِيبَكُمُ ٱللَّهُ بِعَذَابٖ مِّنۡ عِندِهِۦٓ أَوۡ بِأَيۡدِينَاۖ فَتَرَبَّصُوٓاْ إِنَّا مَعَكُم مُّتَرَبِّصُونَ",
    translation:
      'Say, "Do you await for us except one of the two best things while we await for you that Allah will afflict you with punishment from Himself or at our hands? So wait; indeed we, along with you, are waiting',
    normalizedText:
      "قل هل تربصون بنا الا احدى الحسنيين ونحن نتربص بكم ان يصيبكم الله بعذاب من عنده او بايدينا فتربصوا انا معكم متربصون",
  },
  {
    verseId: 52,
    name: "التوبة",
    surahId: 9,
    text: "قُلۡ أَنفِقُواْ طَوۡعًا أَوۡ كَرۡهٗا لَّن يُتَقَبَّلَ مِنكُمۡ إِنَّكُمۡ كُنتُمۡ قَوۡمٗا فَٰسِقِينَ",
    translation:
      'Say, "Spend willingly or unwillingly; never will it be accepted from you. Indeed, you have been a defiantly disobedient people',
    normalizedText: "قل انفقوا طوعا او كرها لن يتقبل منكم انكم كنتم قوما فسقين",
  },
  {
    verseId: 53,
    name: "التوبة",
    surahId: 9,
    text: "وَمَا مَنَعَهُمۡ أَن تُقۡبَلَ مِنۡهُمۡ نَفَقَٰتُهُمۡ إِلَّآ أَنَّهُمۡ كَفَرُواْ بِٱللَّهِ وَبِرَسُولِهِۦ وَلَا يَأۡتُونَ ٱلصَّلَوٰةَ إِلَّا وَهُمۡ كُسَالَىٰ وَلَا يُنفِقُونَ إِلَّا وَهُمۡ كَٰرِهُونَ",
    translation:
      "And what prevents their expenditures from being accepted from them but that they have disbelieved in Allah and in His Messenger and that they come not to prayer except while they are lazy and that they do not spend except while they are unwilling",
    normalizedText:
      "وما منعهم ان تقبل منهم نفقتهم الا انهم كفروا بالله وبرسوله ولا ياتون الصلوة الا وهم كسالى ولا ينفقون الا وهم كرهون",
  },
  {
    verseId: 54,
    name: "التوبة",
    surahId: 9,
    text: "فَلَا تُعۡجِبۡكَ أَمۡوَٰلُهُمۡ وَلَآ أَوۡلَٰدُهُمۡۚ إِنَّمَا يُرِيدُ ٱللَّهُ لِيُعَذِّبَهُم بِهَا فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَتَزۡهَقَ أَنفُسُهُمۡ وَهُمۡ كَٰفِرُونَ",
    translation:
      "So let not their wealth or their children impress you. Allah only intends to punish them through them in worldly life and that their souls should depart [at death] while they are disbelievers",
    normalizedText:
      "فلا تعجبك امولهم ولا اولدهم انما يريد الله ليعذبهم بها في الحيوة الدنيا وتزهق انفسهم وهم كفرون",
  },
  {
    verseId: 55,
    name: "التوبة",
    surahId: 9,
    text: "وَيَحۡلِفُونَ بِٱللَّهِ إِنَّهُمۡ لَمِنكُمۡ وَمَا هُم مِّنكُمۡ وَلَٰكِنَّهُمۡ قَوۡمٞ يَفۡرَقُونَ",
    translation:
      "And they swear by Allah that they are from among you while they are not from among you; but they are a people who are afraid",
    normalizedText: "ويحلفون بالله انهم لمنكم وما هم منكم ولكنهم قوم يفرقون",
  },
  {
    verseId: 56,
    name: "التوبة",
    surahId: 9,
    text: "لَوۡ يَجِدُونَ مَلۡجَـًٔا أَوۡ مَغَٰرَٰتٍ أَوۡ مُدَّخَلٗا لَّوَلَّوۡاْ إِلَيۡهِ وَهُمۡ يَجۡمَحُونَ",
    translation:
      "If they could find a refuge or some caves or any place to enter [and hide], they would turn to it while they run heedlessly",
    normalizedText: "لو يجدون ملجا او مغرت او مدخلا لولوا اليه وهم يجمحون",
  },
  {
    verseId: 57,
    name: "التوبة",
    surahId: 9,
    text: "وَمِنۡهُم مَّن يَلۡمِزُكَ فِي ٱلصَّدَقَٰتِ فَإِنۡ أُعۡطُواْ مِنۡهَا رَضُواْ وَإِن لَّمۡ يُعۡطَوۡاْ مِنۡهَآ إِذَا هُمۡ يَسۡخَطُونَ",
    translation:
      "And among them are some who criticize you concerning the [distribution of] charities. If they are given from them, they approve; but if they are not given from them, at once they become angry",
    normalizedText:
      "ومنهم من يلمزك في الصدقت فان اعطوا منها رضوا وان لم يعطوا منها اذا هم يسخطون",
  },
  {
    verseId: 58,
    name: "التوبة",
    surahId: 9,
    text: "وَلَوۡ أَنَّهُمۡ رَضُواْ مَآ ءَاتَىٰهُمُ ٱللَّهُ وَرَسُولُهُۥ وَقَالُواْ حَسۡبُنَا ٱللَّهُ سَيُؤۡتِينَا ٱللَّهُ مِن فَضۡلِهِۦ وَرَسُولُهُۥٓ إِنَّآ إِلَى ٱللَّهِ رَٰغِبُونَ",
    translation:
      'If only they had been satisfied with what Allah and His Messenger gave them and said, "Sufficient for us is Allah; Allah will give us of His bounty, and [so will] His Messenger; indeed, we are desirous toward Allah," [it would have been better for them]',
    normalizedText:
      "ولو انهم رضوا ما ءاتىهم الله ورسوله وقالوا حسبنا الله سياتينا الله من فضله ورسوله انا الى الله رغبون",
  },
  {
    verseId: 59,
    name: "التوبة",
    surahId: 9,
    text: "۞إِنَّمَا ٱلصَّدَقَٰتُ لِلۡفُقَرَآءِ وَٱلۡمَسَٰكِينِ وَٱلۡعَٰمِلِينَ عَلَيۡهَا وَٱلۡمُؤَلَّفَةِ قُلُوبُهُمۡ وَفِي ٱلرِّقَابِ وَٱلۡغَٰرِمِينَ وَفِي سَبِيلِ ٱللَّهِ وَٱبۡنِ ٱلسَّبِيلِۖ فَرِيضَةٗ مِّنَ ٱللَّهِۗ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "Zakah expenditures are only for the poor and for the needy and for those employed to collect [zakah] and for bringing hearts together [for Islam] and for freeing captives [or slaves] and for those in debt and for the cause of Allah and for the [stranded] traveler - an obligation [imposed] by Allah. And Allah is Knowing and Wise",
    normalizedText:
      "۞انما الصدقت للفقراء والمسكين والعملين عليها والمالفة قلوبهم وفي الرقاب والغرمين وفي سبيل الله وابن السبيل فريضة من الله والله عليم حكيم",
  },
  {
    verseId: 60,
    name: "التوبة",
    surahId: 9,
    text: "وَمِنۡهُمُ ٱلَّذِينَ يُؤۡذُونَ ٱلنَّبِيَّ وَيَقُولُونَ هُوَ أُذُنٞۚ قُلۡ أُذُنُ خَيۡرٖ لَّكُمۡ يُؤۡمِنُ بِٱللَّهِ وَيُؤۡمِنُ لِلۡمُؤۡمِنِينَ وَرَحۡمَةٞ لِّلَّذِينَ ءَامَنُواْ مِنكُمۡۚ وَٱلَّذِينَ يُؤۡذُونَ رَسُولَ ٱللَّهِ لَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      'And among them are those who abuse the Prophet and say, "He is an ear." Say, "[It is] an ear of goodness for you that believes in Allah and believes the believers and [is] a mercy to those who believe among you." And those who abuse the Messenger of Allah - for them is a painful punishment',
    normalizedText:
      "ومنهم الذين ياذون النبي ويقولون هو اذن قل اذن خير لكم يامن بالله ويامن للمامنين ورحمة للذين ءامنوا منكم والذين ياذون رسول الله لهم عذاب اليم",
  },
  {
    verseId: 61,
    name: "التوبة",
    surahId: 9,
    text: "يَحۡلِفُونَ بِٱللَّهِ لَكُمۡ لِيُرۡضُوكُمۡ وَٱللَّهُ وَرَسُولُهُۥٓ أَحَقُّ أَن يُرۡضُوهُ إِن كَانُواْ مُؤۡمِنِينَ",
    translation:
      "They swear by Allah to you [Muslims] to satisfy you. But Allah and His Messenger are more worthy for them to satisfy, if they should be believers",
    normalizedText:
      "يحلفون بالله لكم ليرضوكم والله ورسوله احق ان يرضوه ان كانوا مامنين",
  },
  {
    verseId: 62,
    name: "التوبة",
    surahId: 9,
    text: "أَلَمۡ يَعۡلَمُوٓاْ أَنَّهُۥ مَن يُحَادِدِ ٱللَّهَ وَرَسُولَهُۥ فَأَنَّ لَهُۥ نَارَ جَهَنَّمَ خَٰلِدٗا فِيهَاۚ ذَٰلِكَ ٱلۡخِزۡيُ ٱلۡعَظِيمُ",
    translation:
      "Do they not know that whoever opposes Allah and His Messenger - that for him is the fire of Hell, wherein he will abide eternally? That is the great disgrace",
    normalizedText:
      "الم يعلموا انه من يحادد الله ورسوله فان له نار جهنم خلدا فيها ذلك الخزي العظيم",
  },
  {
    verseId: 63,
    name: "التوبة",
    surahId: 9,
    text: "يَحۡذَرُ ٱلۡمُنَٰفِقُونَ أَن تُنَزَّلَ عَلَيۡهِمۡ سُورَةٞ تُنَبِّئُهُم بِمَا فِي قُلُوبِهِمۡۚ قُلِ ٱسۡتَهۡزِءُوٓاْ إِنَّ ٱللَّهَ مُخۡرِجٞ مَّا تَحۡذَرُونَ",
    translation:
      'They hypocrites are apprehensive lest a surah be revealed about them, informing them of what is in their hearts. Say, "Mock [as you wish]; indeed, Allah will expose that which you fear',
    normalizedText:
      "يحذر المنفقون ان تنزل عليهم سورة تنباهم بما في قلوبهم قل استهزءوا ان الله مخرج ما تحذرون",
  },
  {
    verseId: 64,
    name: "التوبة",
    surahId: 9,
    text: "وَلَئِن سَأَلۡتَهُمۡ لَيَقُولُنَّ إِنَّمَا كُنَّا نَخُوضُ وَنَلۡعَبُۚ قُلۡ أَبِٱللَّهِ وَءَايَٰتِهِۦ وَرَسُولِهِۦ كُنتُمۡ تَسۡتَهۡزِءُونَ",
    translation:
      'And if you ask them, they will surely say, "We were only conversing and playing." Say, "Is it Allah and His verses and His Messenger that you were mocking',
    normalizedText:
      "ولان سالتهم ليقولن انما كنا نخوض ونلعب قل ابالله وءايته ورسوله كنتم تستهزءون",
  },
  {
    verseId: 65,
    name: "التوبة",
    surahId: 9,
    text: "لَا تَعۡتَذِرُواْ قَدۡ كَفَرۡتُم بَعۡدَ إِيمَٰنِكُمۡۚ إِن نَّعۡفُ عَن طَآئِفَةٖ مِّنكُمۡ نُعَذِّبۡ طَآئِفَةَۢ بِأَنَّهُمۡ كَانُواْ مُجۡرِمِينَ",
    translation:
      "Make no excuse; you have disbelieved after your belief. If We pardon one faction of you - We will punish another faction because they were criminals",
    normalizedText:
      "لا تعتذروا قد كفرتم بعد ايمنكم ان نعف عن طاافة منكم نعذب طاافة بانهم كانوا مجرمين",
  },
  {
    verseId: 66,
    name: "التوبة",
    surahId: 9,
    text: "ٱلۡمُنَٰفِقُونَ وَٱلۡمُنَٰفِقَٰتُ بَعۡضُهُم مِّنۢ بَعۡضٖۚ يَأۡمُرُونَ بِٱلۡمُنكَرِ وَيَنۡهَوۡنَ عَنِ ٱلۡمَعۡرُوفِ وَيَقۡبِضُونَ أَيۡدِيَهُمۡۚ نَسُواْ ٱللَّهَ فَنَسِيَهُمۡۚ إِنَّ ٱلۡمُنَٰفِقِينَ هُمُ ٱلۡفَٰسِقُونَ",
    translation:
      "The hypocrite men and hypocrite women are of one another. They enjoin what is wrong and forbid what is right and close their hands. They have forgotten Allah, so He has forgotten them [accordingly]. Indeed, the hypocrites - it is they who are the defiantly disobedient",
    normalizedText:
      "المنفقون والمنفقت بعضهم من بعض يامرون بالمنكر وينهون عن المعروف ويقبضون ايديهم نسوا الله فنسيهم ان المنفقين هم الفسقون",
  },
  {
    verseId: 67,
    name: "التوبة",
    surahId: 9,
    text: "وَعَدَ ٱللَّهُ ٱلۡمُنَٰفِقِينَ وَٱلۡمُنَٰفِقَٰتِ وَٱلۡكُفَّارَ نَارَ جَهَنَّمَ خَٰلِدِينَ فِيهَاۚ هِيَ حَسۡبُهُمۡۚ وَلَعَنَهُمُ ٱللَّهُۖ وَلَهُمۡ عَذَابٞ مُّقِيمٞ",
    translation:
      "Allah has promised the hypocrite men and hypocrite women and the disbelievers the fire of Hell, wherein they will abide eternally. It is sufficient for them. And Allah has cursed them, and for them is an enduring punishment",
    normalizedText:
      "وعد الله المنفقين والمنفقت والكفار نار جهنم خلدين فيها هي حسبهم ولعنهم الله ولهم عذاب مقيم",
  },
  {
    verseId: 68,
    name: "التوبة",
    surahId: 9,
    text: "كَٱلَّذِينَ مِن قَبۡلِكُمۡ كَانُوٓاْ أَشَدَّ مِنكُمۡ قُوَّةٗ وَأَكۡثَرَ أَمۡوَٰلٗا وَأَوۡلَٰدٗا فَٱسۡتَمۡتَعُواْ بِخَلَٰقِهِمۡ فَٱسۡتَمۡتَعۡتُم بِخَلَٰقِكُمۡ كَمَا ٱسۡتَمۡتَعَ ٱلَّذِينَ مِن قَبۡلِكُم بِخَلَٰقِهِمۡ وَخُضۡتُمۡ كَٱلَّذِي خَاضُوٓاْۚ أُوْلَـٰٓئِكَ حَبِطَتۡ أَعۡمَٰلُهُمۡ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "[You disbelievers are] like those before you; they were stronger than you in power and more abundant in wealth and children. They enjoyed their portion [of worldly enjoyment], and you have enjoyed your portion as those before you enjoyed their portion, and you have engaged [in vanities] like that in which they engaged. [It is] those whose deeds have become worthless in this world and in the Hereafter, and it is they who are the losers",
    normalizedText:
      "كالذين من قبلكم كانوا اشد منكم قوة واكثر امولا واولدا فاستمتعوا بخلقهم فاستمتعتم بخلقكم كما استمتع الذين من قبلكم بخلقهم وخضتم كالذي خاضوا اولاك حبطت اعملهم في الدنيا والاخرة واولاك هم الخسرون",
  },
  {
    verseId: 69,
    name: "التوبة",
    surahId: 9,
    text: "أَلَمۡ يَأۡتِهِمۡ نَبَأُ ٱلَّذِينَ مِن قَبۡلِهِمۡ قَوۡمِ نُوحٖ وَعَادٖ وَثَمُودَ وَقَوۡمِ إِبۡرَٰهِيمَ وَأَصۡحَٰبِ مَدۡيَنَ وَٱلۡمُؤۡتَفِكَٰتِۚ أَتَتۡهُمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِۖ فَمَا كَانَ ٱللَّهُ لِيَظۡلِمَهُمۡ وَلَٰكِن كَانُوٓاْ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      "Has there not reached them the news of those before them - the people of Noah and [the tribes of] 'Aad and Thamud and the people of Abraham and the companions of Madyan and the towns overturned? Their messengers came to them with clear proofs. And Allah would never have wronged them, but they were wronging themselves",
    normalizedText:
      "الم ياتهم نبا الذين من قبلهم قوم نوح وعاد وثمود وقوم ابرهيم واصحب مدين والماتفكت اتتهم رسلهم بالبينت فما كان الله ليظلمهم ولكن كانوا انفسهم يظلمون",
  },
  {
    verseId: 70,
    name: "التوبة",
    surahId: 9,
    text: "وَٱلۡمُؤۡمِنُونَ وَٱلۡمُؤۡمِنَٰتُ بَعۡضُهُمۡ أَوۡلِيَآءُ بَعۡضٖۚ يَأۡمُرُونَ بِٱلۡمَعۡرُوفِ وَيَنۡهَوۡنَ عَنِ ٱلۡمُنكَرِ وَيُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤۡتُونَ ٱلزَّكَوٰةَ وَيُطِيعُونَ ٱللَّهَ وَرَسُولَهُۥٓۚ أُوْلَـٰٓئِكَ سَيَرۡحَمُهُمُ ٱللَّهُۗ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٞ",
    translation:
      "The believing men and believing women are allies of one another. They enjoin what is right and forbid what is wrong and establish prayer and give zakah and obey Allah and His Messenger. Those - Allah will have mercy upon them. Indeed, Allah is Exalted in Might and Wise",
    normalizedText:
      "والمامنون والمامنت بعضهم اولياء بعض يامرون بالمعروف وينهون عن المنكر ويقيمون الصلوة وياتون الزكوة ويطيعون الله ورسوله اولاك سيرحمهم الله ان الله عزيز حكيم",
  },
  {
    verseId: 71,
    name: "التوبة",
    surahId: 9,
    text: "وَعَدَ ٱللَّهُ ٱلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَا وَمَسَٰكِنَ طَيِّبَةٗ فِي جَنَّـٰتِ عَدۡنٖۚ وَرِضۡوَٰنٞ مِّنَ ٱللَّهِ أَكۡبَرُۚ ذَٰلِكَ هُوَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "Allah has promised the believing men and believing women gardens beneath which rivers flow, wherein they abide eternally, and pleasant dwellings in gardens of perpetual residence; but approval from Allah is greater. It is that which is the great attainment",
    normalizedText:
      "وعد الله المامنين والمامنت جنت تجري من تحتها الانهر خلدين فيها ومسكن طيبة في جنت عدن ورضون من الله اكبر ذلك هو الفوز العظيم",
  },
  {
    verseId: 72,
    name: "التوبة",
    surahId: 9,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ جَٰهِدِ ٱلۡكُفَّارَ وَٱلۡمُنَٰفِقِينَ وَٱغۡلُظۡ عَلَيۡهِمۡۚ وَمَأۡوَىٰهُمۡ جَهَنَّمُۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "O Prophet, fight against the disbelievers and the hypocrites and be harsh upon them. And their refuge is Hell, and wretched is the destination",
    normalizedText:
      "يايها النبي جهد الكفار والمنفقين واغلظ عليهم وماوىهم جهنم وباس المصير",
  },
  {
    verseId: 73,
    name: "التوبة",
    surahId: 9,
    text: "يَحۡلِفُونَ بِٱللَّهِ مَا قَالُواْ وَلَقَدۡ قَالُواْ كَلِمَةَ ٱلۡكُفۡرِ وَكَفَرُواْ بَعۡدَ إِسۡلَٰمِهِمۡ وَهَمُّواْ بِمَا لَمۡ يَنَالُواْۚ وَمَا نَقَمُوٓاْ إِلَّآ أَنۡ أَغۡنَىٰهُمُ ٱللَّهُ وَرَسُولُهُۥ مِن فَضۡلِهِۦۚ فَإِن يَتُوبُواْ يَكُ خَيۡرٗا لَّهُمۡۖ وَإِن يَتَوَلَّوۡاْ يُعَذِّبۡهُمُ ٱللَّهُ عَذَابًا أَلِيمٗا فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِۚ وَمَا لَهُمۡ فِي ٱلۡأَرۡضِ مِن وَلِيّٖ وَلَا نَصِيرٖ",
    translation:
      "They swear by Allah that they did not say [anything against the Prophet] while they had said the word of disbelief and disbelieved after their [pretense of] Islam and planned that which they were not to attain. And they were not resentful except [for the fact] that Allah and His Messenger had enriched them of His bounty. So if they repent, it is better for them; but if they turn away, Allah will punish them with a painful punishment in this world and the Hereafter. And there will not be for them on earth any protector or helper",
    normalizedText:
      "يحلفون بالله ما قالوا ولقد قالوا كلمة الكفر وكفروا بعد اسلمهم وهموا بما لم ينالوا وما نقموا الا ان اغنىهم الله ورسوله من فضله فان يتوبوا يك خيرا لهم وان يتولوا يعذبهم الله عذابا اليما في الدنيا والاخرة وما لهم في الارض من ولي ولا نصير",
  },
  {
    verseId: 74,
    name: "التوبة",
    surahId: 9,
    text: "۞وَمِنۡهُم مَّنۡ عَٰهَدَ ٱللَّهَ لَئِنۡ ءَاتَىٰنَا مِن فَضۡلِهِۦ لَنَصَّدَّقَنَّ وَلَنَكُونَنَّ مِنَ ٱلصَّـٰلِحِينَ",
    translation:
      'And among them are those who made a covenant with Allah, [saying], "If He should give us from His bounty, we will surely spend in charity, and we will surely be among the righteous',
    normalizedText:
      "۞ومنهم من عهد الله لان ءاتىنا من فضله لنصدقن ولنكونن من الصلحين",
  },
  {
    verseId: 75,
    name: "التوبة",
    surahId: 9,
    text: "فَلَمَّآ ءَاتَىٰهُم مِّن فَضۡلِهِۦ بَخِلُواْ بِهِۦ وَتَوَلَّواْ وَّهُم مُّعۡرِضُونَ",
    translation:
      "But when he gave them from His bounty, they were stingy with it and turned away while they refused",
    normalizedText: "فلما ءاتىهم من فضله بخلوا به وتولوا وهم معرضون",
  },
  {
    verseId: 76,
    name: "التوبة",
    surahId: 9,
    text: "فَأَعۡقَبَهُمۡ نِفَاقٗا فِي قُلُوبِهِمۡ إِلَىٰ يَوۡمِ يَلۡقَوۡنَهُۥ بِمَآ أَخۡلَفُواْ ٱللَّهَ مَا وَعَدُوهُ وَبِمَا كَانُواْ يَكۡذِبُونَ",
    translation:
      "So He penalized them with hypocrisy in their hearts until the Day they will meet Him - because they failed Allah in what they promised Him and because they [habitually] used to lie",
    normalizedText:
      "فاعقبهم نفاقا في قلوبهم الى يوم يلقونه بما اخلفوا الله ما وعدوه وبما كانوا يكذبون",
  },
  {
    verseId: 77,
    name: "التوبة",
    surahId: 9,
    text: "أَلَمۡ يَعۡلَمُوٓاْ أَنَّ ٱللَّهَ يَعۡلَمُ سِرَّهُمۡ وَنَجۡوَىٰهُمۡ وَأَنَّ ٱللَّهَ عَلَّـٰمُ ٱلۡغُيُوبِ",
    translation:
      "Did they not know that Allah knows their secrets and their private conversations and that Allah is the Knower of the unseen",
    normalizedText: "الم يعلموا ان الله يعلم سرهم ونجوىهم وان الله علم الغيوب",
  },
  {
    verseId: 78,
    name: "التوبة",
    surahId: 9,
    text: "ٱلَّذِينَ يَلۡمِزُونَ ٱلۡمُطَّوِّعِينَ مِنَ ٱلۡمُؤۡمِنِينَ فِي ٱلصَّدَقَٰتِ وَٱلَّذِينَ لَا يَجِدُونَ إِلَّا جُهۡدَهُمۡ فَيَسۡخَرُونَ مِنۡهُمۡ سَخِرَ ٱللَّهُ مِنۡهُمۡ وَلَهُمۡ عَذَابٌ أَلِيمٌ",
    translation:
      "Those who criticize the contributors among the believers concerning [their] charities and [criticize] the ones who find nothing [to spend] except their effort, so they ridicule them - Allah will ridicule them, and they will have a painful punishment",
    normalizedText:
      "الذين يلمزون المطوعين من المامنين في الصدقت والذين لا يجدون الا جهدهم فيسخرون منهم سخر الله منهم ولهم عذاب اليم",
  },
  {
    verseId: 79,
    name: "التوبة",
    surahId: 9,
    text: "ٱسۡتَغۡفِرۡ لَهُمۡ أَوۡ لَا تَسۡتَغۡفِرۡ لَهُمۡ إِن تَسۡتَغۡفِرۡ لَهُمۡ سَبۡعِينَ مَرَّةٗ فَلَن يَغۡفِرَ ٱللَّهُ لَهُمۡۚ ذَٰلِكَ بِأَنَّهُمۡ كَفَرُواْ بِٱللَّهِ وَرَسُولِهِۦۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡفَٰسِقِينَ",
    translation:
      "Ask forgiveness for them, [O Muhammad], or do not ask forgiveness for them. If you should ask forgiveness for them seventy times - never will Allah forgive them. That is because they disbelieved in Allah and His Messenger, and Allah does not guide the defiantly disobedient people",
    normalizedText:
      "استغفر لهم او لا تستغفر لهم ان تستغفر لهم سبعين مرة فلن يغفر الله لهم ذلك بانهم كفروا بالله ورسوله والله لا يهدي القوم الفسقين",
  },
  {
    verseId: 80,
    name: "التوبة",
    surahId: 9,
    text: "فَرِحَ ٱلۡمُخَلَّفُونَ بِمَقۡعَدِهِمۡ خِلَٰفَ رَسُولِ ٱللَّهِ وَكَرِهُوٓاْ أَن يُجَٰهِدُواْ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡ فِي سَبِيلِ ٱللَّهِ وَقَالُواْ لَا تَنفِرُواْ فِي ٱلۡحَرِّۗ قُلۡ نَارُ جَهَنَّمَ أَشَدُّ حَرّٗاۚ لَّوۡ كَانُواْ يَفۡقَهُونَ",
    translation:
      'Those who remained behind rejoiced in their staying [at home] after [the departure of] the Messenger of Allah and disliked to strive with their wealth and their lives in the cause of Allah and said, "Do not go forth in the heat." Say, "The fire of Hell is more intensive in heat" - if they would but understand',
    normalizedText:
      "فرح المخلفون بمقعدهم خلف رسول الله وكرهوا ان يجهدوا بامولهم وانفسهم في سبيل الله وقالوا لا تنفروا في الحر قل نار جهنم اشد حرا لو كانوا يفقهون",
  },
  {
    verseId: 81,
    name: "التوبة",
    surahId: 9,
    text: "فَلۡيَضۡحَكُواْ قَلِيلٗا وَلۡيَبۡكُواْ كَثِيرٗا جَزَآءَۢ بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "So let them laugh a little and [then] weep much as recompense for what they used to earn",
    normalizedText: "فليضحكوا قليلا وليبكوا كثيرا جزاء بما كانوا يكسبون",
  },
  {
    verseId: 82,
    name: "التوبة",
    surahId: 9,
    text: "فَإِن رَّجَعَكَ ٱللَّهُ إِلَىٰ طَآئِفَةٖ مِّنۡهُمۡ فَٱسۡتَـٔۡذَنُوكَ لِلۡخُرُوجِ فَقُل لَّن تَخۡرُجُواْ مَعِيَ أَبَدٗا وَلَن تُقَٰتِلُواْ مَعِيَ عَدُوًّاۖ إِنَّكُمۡ رَضِيتُم بِٱلۡقُعُودِ أَوَّلَ مَرَّةٖ فَٱقۡعُدُواْ مَعَ ٱلۡخَٰلِفِينَ",
    translation:
      'If Allah should return you to a faction of them [after the expedition] and then they ask your permission to go out [to battle], say, "You will not go out with me, ever, and you will never fight with me an enemy. Indeed, you were satisfied with sitting [at home] the first time, so sit [now] with those who stay behind',
    normalizedText:
      "فان رجعك الله الى طاافة منهم فاستذنوك للخروج فقل لن تخرجوا معي ابدا ولن تقتلوا معي عدوا انكم رضيتم بالقعود اول مرة فاقعدوا مع الخلفين",
  },
  {
    verseId: 83,
    name: "التوبة",
    surahId: 9,
    text: "وَلَا تُصَلِّ عَلَىٰٓ أَحَدٖ مِّنۡهُم مَّاتَ أَبَدٗا وَلَا تَقُمۡ عَلَىٰ قَبۡرِهِۦٓۖ إِنَّهُمۡ كَفَرُواْ بِٱللَّهِ وَرَسُولِهِۦ وَمَاتُواْ وَهُمۡ فَٰسِقُونَ",
    translation:
      "And do not pray [the funeral prayer, O Muhammad], over any of them who has died - ever - or stand at his grave. Indeed, they disbelieved in Allah and His Messenger and died while they were defiantly disobedient",
    normalizedText:
      "ولا تصل على احد منهم مات ابدا ولا تقم على قبره انهم كفروا بالله ورسوله وماتوا وهم فسقون",
  },
  {
    verseId: 84,
    name: "التوبة",
    surahId: 9,
    text: "وَلَا تُعۡجِبۡكَ أَمۡوَٰلُهُمۡ وَأَوۡلَٰدُهُمۡۚ إِنَّمَا يُرِيدُ ٱللَّهُ أَن يُعَذِّبَهُم بِهَا فِي ٱلدُّنۡيَا وَتَزۡهَقَ أَنفُسُهُمۡ وَهُمۡ كَٰفِرُونَ",
    translation:
      "And let not their wealth and their children impress you. Allah only intends to punish them through them in this world and that their souls should depart [at death] while they are disbelievers",
    normalizedText:
      "ولا تعجبك امولهم واولدهم انما يريد الله ان يعذبهم بها في الدنيا وتزهق انفسهم وهم كفرون",
  },
  {
    verseId: 85,
    name: "التوبة",
    surahId: 9,
    text: "وَإِذَآ أُنزِلَتۡ سُورَةٌ أَنۡ ءَامِنُواْ بِٱللَّهِ وَجَٰهِدُواْ مَعَ رَسُولِهِ ٱسۡتَـٔۡذَنَكَ أُوْلُواْ ٱلطَّوۡلِ مِنۡهُمۡ وَقَالُواْ ذَرۡنَا نَكُن مَّعَ ٱلۡقَٰعِدِينَ",
    translation:
      'And when a surah was revealed [enjoining them] to believe in Allah and to fight with His Messenger, those of wealth among them asked your permission [to stay back] and said, "Leave us to be with them who sit [at home]',
    normalizedText:
      "واذا انزلت سورة ان ءامنوا بالله وجهدوا مع رسوله استذنك اولوا الطول منهم وقالوا ذرنا نكن مع القعدين",
  },
  {
    verseId: 86,
    name: "التوبة",
    surahId: 9,
    text: "رَضُواْ بِأَن يَكُونُواْ مَعَ ٱلۡخَوَالِفِ وَطُبِعَ عَلَىٰ قُلُوبِهِمۡ فَهُمۡ لَا يَفۡقَهُونَ",
    translation:
      "They were satisfied to be with those who stay behind, and their hearts were sealed over, so they do not understand",
    normalizedText: "رضوا بان يكونوا مع الخوالف وطبع على قلوبهم فهم لا يفقهون",
  },
  {
    verseId: 87,
    name: "التوبة",
    surahId: 9,
    text: "لَٰكِنِ ٱلرَّسُولُ وَٱلَّذِينَ ءَامَنُواْ مَعَهُۥ جَٰهَدُواْ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡۚ وَأُوْلَـٰٓئِكَ لَهُمُ ٱلۡخَيۡرَٰتُۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "But the Messenger and those who believed with him fought with their wealth and their lives. Those will have [all that is] good, and it is those who are the successful",
    normalizedText:
      "لكن الرسول والذين ءامنوا معه جهدوا بامولهم وانفسهم واولاك لهم الخيرت واولاك هم المفلحون",
  },
  {
    verseId: 88,
    name: "التوبة",
    surahId: 9,
    text: "أَعَدَّ ٱللَّهُ لَهُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ ذَٰلِكَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "Allah has prepared for them gardens beneath which rivers flow, wherein they will abide eternally. That is the great attainment",
    normalizedText:
      "اعد الله لهم جنت تجري من تحتها الانهر خلدين فيها ذلك الفوز العظيم",
  },
  {
    verseId: 89,
    name: "التوبة",
    surahId: 9,
    text: "وَجَآءَ ٱلۡمُعَذِّرُونَ مِنَ ٱلۡأَعۡرَابِ لِيُؤۡذَنَ لَهُمۡ وَقَعَدَ ٱلَّذِينَ كَذَبُواْ ٱللَّهَ وَرَسُولَهُۥۚ سَيُصِيبُ ٱلَّذِينَ كَفَرُواْ مِنۡهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "And those with excuses among the bedouins came to be permitted [to remain], and they who had lied to Allah and His Messenger sat [at home]. There will strike those who disbelieved among them a painful punishment",
    normalizedText:
      "وجاء المعذرون من الاعراب لياذن لهم وقعد الذين كذبوا الله ورسوله سيصيب الذين كفروا منهم عذاب اليم",
  },
  {
    verseId: 90,
    name: "التوبة",
    surahId: 9,
    text: "لَّيۡسَ عَلَى ٱلضُّعَفَآءِ وَلَا عَلَى ٱلۡمَرۡضَىٰ وَلَا عَلَى ٱلَّذِينَ لَا يَجِدُونَ مَا يُنفِقُونَ حَرَجٌ إِذَا نَصَحُواْ لِلَّهِ وَرَسُولِهِۦۚ مَا عَلَى ٱلۡمُحۡسِنِينَ مِن سَبِيلٖۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "There is not upon the weak or upon the ill or upon those who do not find anything to spend any discomfort when they are sincere to Allah and His Messenger. There is not upon the doers of good any cause [for blame]. And Allah is Forgiving and Merciful",
    normalizedText:
      "ليس على الضعفاء ولا على المرضى ولا على الذين لا يجدون ما ينفقون حرج اذا نصحوا لله ورسوله ما على المحسنين من سبيل والله غفور رحيم",
  },
  {
    verseId: 91,
    name: "التوبة",
    surahId: 9,
    text: "وَلَا عَلَى ٱلَّذِينَ إِذَا مَآ أَتَوۡكَ لِتَحۡمِلَهُمۡ قُلۡتَ لَآ أَجِدُ مَآ أَحۡمِلُكُمۡ عَلَيۡهِ تَوَلَّواْ وَّأَعۡيُنُهُمۡ تَفِيضُ مِنَ ٱلدَّمۡعِ حَزَنًا أَلَّا يَجِدُواْ مَا يُنفِقُونَ",
    translation:
      'Nor [is there blame] upon those who, when they came to you that you might give them mounts, you said, "I can find nothing for you to ride upon." They turned back while their eyes overflowed with tears out of grief that they could not find something to spend [for the cause of Allah]',
    normalizedText:
      "ولا على الذين اذا ما اتوك لتحملهم قلت لا اجد ما احملكم عليه تولوا واعينهم تفيض من الدمع حزنا الا يجدوا ما ينفقون",
  },
  {
    verseId: 92,
    name: "التوبة",
    surahId: 9,
    text: "۞إِنَّمَا ٱلسَّبِيلُ عَلَى ٱلَّذِينَ يَسۡتَـٔۡذِنُونَكَ وَهُمۡ أَغۡنِيَآءُۚ رَضُواْ بِأَن يَكُونُواْ مَعَ ٱلۡخَوَالِفِ وَطَبَعَ ٱللَّهُ عَلَىٰ قُلُوبِهِمۡ فَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "The cause [for blame] is only upon those who ask permission of you while they are rich. They are satisfied to be with those who stay behind, and Allah has sealed over their hearts, so they do not know",
    normalizedText:
      "۞انما السبيل على الذين يستذنونك وهم اغنياء رضوا بان يكونوا مع الخوالف وطبع الله على قلوبهم فهم لا يعلمون",
  },
  {
    verseId: 93,
    name: "التوبة",
    surahId: 9,
    text: "يَعۡتَذِرُونَ إِلَيۡكُمۡ إِذَا رَجَعۡتُمۡ إِلَيۡهِمۡۚ قُل لَّا تَعۡتَذِرُواْ لَن نُّؤۡمِنَ لَكُمۡ قَدۡ نَبَّأَنَا ٱللَّهُ مِنۡ أَخۡبَارِكُمۡۚ وَسَيَرَى ٱللَّهُ عَمَلَكُمۡ وَرَسُولُهُۥ ثُمَّ تُرَدُّونَ إِلَىٰ عَٰلِمِ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ فَيُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'They will make excuses to you when you have returned to them. Say, "Make no excuse - never will we believe you. Allah has already informed us of your news. And Allah will observe your deeds, and [so will] His Messenger; then you will be taken back to the Knower of the unseen and the witnessed, and He will inform you of what you used to do',
    normalizedText:
      "يعتذرون اليكم اذا رجعتم اليهم قل لا تعتذروا لن نامن لكم قد نبانا الله من اخباركم وسيرى الله عملكم ورسوله ثم تردون الى علم الغيب والشهدة فينباكم بما كنتم تعملون",
  },
  {
    verseId: 94,
    name: "التوبة",
    surahId: 9,
    text: "سَيَحۡلِفُونَ بِٱللَّهِ لَكُمۡ إِذَا ٱنقَلَبۡتُمۡ إِلَيۡهِمۡ لِتُعۡرِضُواْ عَنۡهُمۡۖ فَأَعۡرِضُواْ عَنۡهُمۡۖ إِنَّهُمۡ رِجۡسٞۖ وَمَأۡوَىٰهُمۡ جَهَنَّمُ جَزَآءَۢ بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "They will swear by Allah to you when you return to them that you would leave them alone. So leave them alone; indeed they are evil; and their refuge is Hell as recompense for what they had been earning",
    normalizedText:
      "سيحلفون بالله لكم اذا انقلبتم اليهم لتعرضوا عنهم فاعرضوا عنهم انهم رجس وماوىهم جهنم جزاء بما كانوا يكسبون",
  },
  {
    verseId: 95,
    name: "التوبة",
    surahId: 9,
    text: "يَحۡلِفُونَ لَكُمۡ لِتَرۡضَوۡاْ عَنۡهُمۡۖ فَإِن تَرۡضَوۡاْ عَنۡهُمۡ فَإِنَّ ٱللَّهَ لَا يَرۡضَىٰ عَنِ ٱلۡقَوۡمِ ٱلۡفَٰسِقِينَ",
    translation:
      "They swear to you so that you might be satisfied with them. But if you should be satisfied with them - indeed, Allah is not satisfied with a defiantly disobedient people",
    normalizedText:
      "يحلفون لكم لترضوا عنهم فان ترضوا عنهم فان الله لا يرضى عن القوم الفسقين",
  },
  {
    verseId: 96,
    name: "التوبة",
    surahId: 9,
    text: "ٱلۡأَعۡرَابُ أَشَدُّ كُفۡرٗا وَنِفَاقٗا وَأَجۡدَرُ أَلَّا يَعۡلَمُواْ حُدُودَ مَآ أَنزَلَ ٱللَّهُ عَلَىٰ رَسُولِهِۦۗ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "The bedouins are stronger in disbelief and hypocrisy and more likely not to know the limits of what [laws] Allah has revealed to His Messenger. And Allah is Knowing and Wise",
    normalizedText:
      "الاعراب اشد كفرا ونفاقا واجدر الا يعلموا حدود ما انزل الله على رسوله والله عليم حكيم",
  },
  {
    verseId: 97,
    name: "التوبة",
    surahId: 9,
    text: "وَمِنَ ٱلۡأَعۡرَابِ مَن يَتَّخِذُ مَا يُنفِقُ مَغۡرَمٗا وَيَتَرَبَّصُ بِكُمُ ٱلدَّوَآئِرَۚ عَلَيۡهِمۡ دَآئِرَةُ ٱلسَّوۡءِۗ وَٱللَّهُ سَمِيعٌ عَلِيمٞ",
    translation:
      "And among the bedouins are some who consider what they spend as a loss and await for you turns of misfortune. Upon them will be a misfortune of evil. And Allah is Hearing and Knowing",
    normalizedText:
      "ومن الاعراب من يتخذ ما ينفق مغرما ويتربص بكم الدواار عليهم داارة السوء والله سميع عليم",
  },
  {
    verseId: 98,
    name: "التوبة",
    surahId: 9,
    text: "وَمِنَ ٱلۡأَعۡرَابِ مَن يُؤۡمِنُ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ وَيَتَّخِذُ مَا يُنفِقُ قُرُبَٰتٍ عِندَ ٱللَّهِ وَصَلَوَٰتِ ٱلرَّسُولِۚ أَلَآ إِنَّهَا قُرۡبَةٞ لَّهُمۡۚ سَيُدۡخِلُهُمُ ٱللَّهُ فِي رَحۡمَتِهِۦٓۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "But among the bedouins are some who believe in Allah and the Last Day and consider what they spend as means of nearness to Allah and of [obtaining] invocations of the Messenger. Unquestionably, it is a means of nearness for them. Allah will admit them to His mercy. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "ومن الاعراب من يامن بالله واليوم الاخر ويتخذ ما ينفق قربت عند الله وصلوت الرسول الا انها قربة لهم سيدخلهم الله في رحمته ان الله غفور رحيم",
  },
  {
    verseId: 99,
    name: "التوبة",
    surahId: 9,
    text: "وَٱلسَّـٰبِقُونَ ٱلۡأَوَّلُونَ مِنَ ٱلۡمُهَٰجِرِينَ وَٱلۡأَنصَارِ وَٱلَّذِينَ ٱتَّبَعُوهُم بِإِحۡسَٰنٖ رَّضِيَ ٱللَّهُ عَنۡهُمۡ وَرَضُواْ عَنۡهُ وَأَعَدَّ لَهُمۡ جَنَّـٰتٖ تَجۡرِي تَحۡتَهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدٗاۚ ذَٰلِكَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "And the first forerunners [in the faith] among the Muhajireen and the Ansar and those who followed them with good conduct - Allah is pleased with them and they are pleased with Him, and He has prepared for them gardens beneath which rivers flow, wherein they will abide forever. That is the great attainment",
    normalizedText:
      "والسبقون الاولون من المهجرين والانصار والذين اتبعوهم باحسن رضي الله عنهم ورضوا عنه واعد لهم جنت تجري تحتها الانهر خلدين فيها ابدا ذلك الفوز العظيم",
  },
  {
    verseId: 100,
    name: "التوبة",
    surahId: 9,
    text: "وَمِمَّنۡ حَوۡلَكُم مِّنَ ٱلۡأَعۡرَابِ مُنَٰفِقُونَۖ وَمِنۡ أَهۡلِ ٱلۡمَدِينَةِ مَرَدُواْ عَلَى ٱلنِّفَاقِ لَا تَعۡلَمُهُمۡۖ نَحۡنُ نَعۡلَمُهُمۡۚ سَنُعَذِّبُهُم مَّرَّتَيۡنِ ثُمَّ يُرَدُّونَ إِلَىٰ عَذَابٍ عَظِيمٖ",
    translation:
      "And among those around you of the bedouins are hypocrites, and [also] from the people of Madinah. They have become accustomed to hypocrisy. You, [O Muhammad], do not know them, [but] We know them. We will punish them twice [in this world]; then they will be returned to a great punishment",
    normalizedText:
      "وممن حولكم من الاعراب منفقون ومن اهل المدينة مردوا على النفاق لا تعلمهم نحن نعلمهم سنعذبهم مرتين ثم يردون الى عذاب عظيم",
  },
  {
    verseId: 101,
    name: "التوبة",
    surahId: 9,
    text: "وَءَاخَرُونَ ٱعۡتَرَفُواْ بِذُنُوبِهِمۡ خَلَطُواْ عَمَلٗا صَٰلِحٗا وَءَاخَرَ سَيِّئًا عَسَى ٱللَّهُ أَن يَتُوبَ عَلَيۡهِمۡۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٌ",
    translation:
      "And [there are] others who have acknowledged their sins. They had mixed a righteous deed with another that was bad. Perhaps Allah will turn to them in forgiveness. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "وءاخرون اعترفوا بذنوبهم خلطوا عملا صلحا وءاخر سياا عسى الله ان يتوب عليهم ان الله غفور رحيم",
  },
  {
    verseId: 102,
    name: "التوبة",
    surahId: 9,
    text: "خُذۡ مِنۡ أَمۡوَٰلِهِمۡ صَدَقَةٗ تُطَهِّرُهُمۡ وَتُزَكِّيهِم بِهَا وَصَلِّ عَلَيۡهِمۡۖ إِنَّ صَلَوٰتَكَ سَكَنٞ لَّهُمۡۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ",
    translation:
      "Take, [O, Muhammad], from their wealth a charity by which you purify them and cause them increase, and invoke [Allah 's blessings] upon them. Indeed, your invocations are reassurance for them. And Allah is Hearing and Knowing",
    normalizedText:
      "خذ من امولهم صدقة تطهرهم وتزكيهم بها وصل عليهم ان صلوتك سكن لهم والله سميع عليم",
  },
  {
    verseId: 103,
    name: "التوبة",
    surahId: 9,
    text: "أَلَمۡ يَعۡلَمُوٓاْ أَنَّ ٱللَّهَ هُوَ يَقۡبَلُ ٱلتَّوۡبَةَ عَنۡ عِبَادِهِۦ وَيَأۡخُذُ ٱلصَّدَقَٰتِ وَأَنَّ ٱللَّهَ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ",
    translation:
      "Do they not know that it is Allah who accepts repentance from His servants and receives charities and that it is Allah who is the Accepting of repentance, the Merciful",
    normalizedText:
      "الم يعلموا ان الله هو يقبل التوبة عن عباده وياخذ الصدقت وان الله هو التواب الرحيم",
  },
  {
    verseId: 104,
    name: "التوبة",
    surahId: 9,
    text: "وَقُلِ ٱعۡمَلُواْ فَسَيَرَى ٱللَّهُ عَمَلَكُمۡ وَرَسُولُهُۥ وَٱلۡمُؤۡمِنُونَۖ وَسَتُرَدُّونَ إِلَىٰ عَٰلِمِ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ فَيُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'And say, "Do [as you will], for Allah will see your deeds, and [so, will] His Messenger and the believers. And you will be returned to the Knower of the unseen and the witnessed, and He will inform you of what you used to do',
    normalizedText:
      "وقل اعملوا فسيرى الله عملكم ورسوله والمامنون وستردون الى علم الغيب والشهدة فينباكم بما كنتم تعملون",
  },
  {
    verseId: 105,
    name: "التوبة",
    surahId: 9,
    text: "وَءَاخَرُونَ مُرۡجَوۡنَ لِأَمۡرِ ٱللَّهِ إِمَّا يُعَذِّبُهُمۡ وَإِمَّا يَتُوبُ عَلَيۡهِمۡۗ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "And [there are] others deferred until the command of Allah - whether He will punish them or whether He will forgive them. And Allah is Knowing and Wise",
    normalizedText:
      "وءاخرون مرجون لامر الله اما يعذبهم واما يتوب عليهم والله عليم حكيم",
  },
  {
    verseId: 106,
    name: "التوبة",
    surahId: 9,
    text: "وَٱلَّذِينَ ٱتَّخَذُواْ مَسۡجِدٗا ضِرَارٗا وَكُفۡرٗا وَتَفۡرِيقَۢا بَيۡنَ ٱلۡمُؤۡمِنِينَ وَإِرۡصَادٗا لِّمَنۡ حَارَبَ ٱللَّهَ وَرَسُولَهُۥ مِن قَبۡلُۚ وَلَيَحۡلِفُنَّ إِنۡ أَرَدۡنَآ إِلَّا ٱلۡحُسۡنَىٰۖ وَٱللَّهُ يَشۡهَدُ إِنَّهُمۡ لَكَٰذِبُونَ",
    translation:
      'And [there are] those [hypocrites] who took for themselves a mosque for causing harm and disbelief and division among the believers and as a station for whoever had warred against Allah and His Messenger before. And they will surely swear, "We intended only the best." And Allah testifies that indeed they are liars',
    normalizedText:
      "والذين اتخذوا مسجدا ضرارا وكفرا وتفريقا بين المامنين وارصادا لمن حارب الله ورسوله من قبل وليحلفن ان اردنا الا الحسنى والله يشهد انهم لكذبون",
  },
  {
    verseId: 107,
    name: "التوبة",
    surahId: 9,
    text: "لَا تَقُمۡ فِيهِ أَبَدٗاۚ لَّمَسۡجِدٌ أُسِّسَ عَلَى ٱلتَّقۡوَىٰ مِنۡ أَوَّلِ يَوۡمٍ أَحَقُّ أَن تَقُومَ فِيهِۚ فِيهِ رِجَالٞ يُحِبُّونَ أَن يَتَطَهَّرُواْۚ وَٱللَّهُ يُحِبُّ ٱلۡمُطَّهِّرِينَ",
    translation:
      "Do not stand [for prayer] within it - ever. A mosque founded on righteousness from the first day is more worthy for you to stand in. Within it are men who love to purify themselves; and Allah loves those who purify themselves",
    normalizedText:
      "لا تقم فيه ابدا لمسجد اسس على التقوى من اول يوم احق ان تقوم فيه فيه رجال يحبون ان يتطهروا والله يحب المطهرين",
  },
  {
    verseId: 108,
    name: "التوبة",
    surahId: 9,
    text: "أَفَمَنۡ أَسَّسَ بُنۡيَٰنَهُۥ عَلَىٰ تَقۡوَىٰ مِنَ ٱللَّهِ وَرِضۡوَٰنٍ خَيۡرٌ أَم مَّنۡ أَسَّسَ بُنۡيَٰنَهُۥ عَلَىٰ شَفَا جُرُفٍ هَارٖ فَٱنۡهَارَ بِهِۦ فِي نَارِ جَهَنَّمَۗ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      "Then is one who laid the foundation of his building on righteousness [with fear] from Allah and [seeking] His approval better or one who laid the foundation of his building on the edge of a bank about to collapse, so it collapsed with him into the fire of Hell? And Allah does not guide the wrongdoing people",
    normalizedText:
      "افمن اسس بنينه على تقوى من الله ورضون خير ام من اسس بنينه على شفا جرف هار فانهار به في نار جهنم والله لا يهدي القوم الظلمين",
  },
  {
    verseId: 109,
    name: "التوبة",
    surahId: 9,
    text: "لَا يَزَالُ بُنۡيَٰنُهُمُ ٱلَّذِي بَنَوۡاْ رِيبَةٗ فِي قُلُوبِهِمۡ إِلَّآ أَن تَقَطَّعَ قُلُوبُهُمۡۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌ",
    translation:
      "Their building which they built will not cease to be a [cause of] skepticism in their hearts until their hearts are stopped. And Allah is Knowing and Wise",
    normalizedText:
      "لا يزال بنينهم الذي بنوا ريبة في قلوبهم الا ان تقطع قلوبهم والله عليم حكيم",
  },
  {
    verseId: 110,
    name: "التوبة",
    surahId: 9,
    text: "۞إِنَّ ٱللَّهَ ٱشۡتَرَىٰ مِنَ ٱلۡمُؤۡمِنِينَ أَنفُسَهُمۡ وَأَمۡوَٰلَهُم بِأَنَّ لَهُمُ ٱلۡجَنَّةَۚ يُقَٰتِلُونَ فِي سَبِيلِ ٱللَّهِ فَيَقۡتُلُونَ وَيُقۡتَلُونَۖ وَعۡدًا عَلَيۡهِ حَقّٗا فِي ٱلتَّوۡرَىٰةِ وَٱلۡإِنجِيلِ وَٱلۡقُرۡءَانِۚ وَمَنۡ أَوۡفَىٰ بِعَهۡدِهِۦ مِنَ ٱللَّهِۚ فَٱسۡتَبۡشِرُواْ بِبَيۡعِكُمُ ٱلَّذِي بَايَعۡتُم بِهِۦۚ وَذَٰلِكَ هُوَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "Indeed, Allah has purchased from the believers their lives and their properties [in exchange] for that they will have Paradise. They fight in the cause of Allah, so they kill and are killed. [It is] a true promise [binding] upon Him in the Torah and the Gospel and the Qur'an. And who is truer to his covenant than Allah? So rejoice in your transaction which you have contracted. And it is that which is the great attainment",
    normalizedText:
      "۞ان الله اشترى من المامنين انفسهم وامولهم بان لهم الجنة يقتلون في سبيل الله فيقتلون ويقتلون وعدا عليه حقا في التورىة والانجيل والقرءان ومن اوفى بعهده من الله فاستبشروا ببيعكم الذي بايعتم به وذلك هو الفوز العظيم",
  },
  {
    verseId: 111,
    name: "التوبة",
    surahId: 9,
    text: "ٱلتَّـٰٓئِبُونَ ٱلۡعَٰبِدُونَ ٱلۡحَٰمِدُونَ ٱلسَّـٰٓئِحُونَ ٱلرَّـٰكِعُونَ ٱلسَّـٰجِدُونَ ٱلۡأٓمِرُونَ بِٱلۡمَعۡرُوفِ وَٱلنَّاهُونَ عَنِ ٱلۡمُنكَرِ وَٱلۡحَٰفِظُونَ لِحُدُودِ ٱللَّهِۗ وَبَشِّرِ ٱلۡمُؤۡمِنِينَ",
    translation:
      "[Such believers are] the repentant, the worshippers, the praisers [of Allah], the travelers [for His cause], those who bow and prostrate [in prayer], those who enjoin what is right and forbid what is wrong, and those who observe the limits [set by] Allah. And give good tidings to the believers",
    normalizedText:
      "التابون العبدون الحمدون الساحون الركعون السجدون الامرون بالمعروف والناهون عن المنكر والحفظون لحدود الله وبشر المامنين",
  },
  {
    verseId: 112,
    name: "التوبة",
    surahId: 9,
    text: "مَا كَانَ لِلنَّبِيِّ وَٱلَّذِينَ ءَامَنُوٓاْ أَن يَسۡتَغۡفِرُواْ لِلۡمُشۡرِكِينَ وَلَوۡ كَانُوٓاْ أُوْلِي قُرۡبَىٰ مِنۢ بَعۡدِ مَا تَبَيَّنَ لَهُمۡ أَنَّهُمۡ أَصۡحَٰبُ ٱلۡجَحِيمِ",
    translation:
      "It is not for the Prophet and those who have believed to ask forgiveness for the polytheists, even if they were relatives, after it has become clear to them that they are companions of Hellfire",
    normalizedText:
      "ما كان للنبي والذين ءامنوا ان يستغفروا للمشركين ولو كانوا اولي قربى من بعد ما تبين لهم انهم اصحب الجحيم",
  },
  {
    verseId: 113,
    name: "التوبة",
    surahId: 9,
    text: "وَمَا كَانَ ٱسۡتِغۡفَارُ إِبۡرَٰهِيمَ لِأَبِيهِ إِلَّا عَن مَّوۡعِدَةٖ وَعَدَهَآ إِيَّاهُ فَلَمَّا تَبَيَّنَ لَهُۥٓ أَنَّهُۥ عَدُوّٞ لِّلَّهِ تَبَرَّأَ مِنۡهُۚ إِنَّ إِبۡرَٰهِيمَ لَأَوَّـٰهٌ حَلِيمٞ",
    translation:
      "And the request of forgiveness of Abraham for his father was only because of a promise he had made to him. But when it became apparent to Abraham that his father was an enemy to Allah, he disassociated himself from him. Indeed was Abraham compassionate and patient",
    normalizedText:
      "وما كان استغفار ابرهيم لابيه الا عن موعدة وعدها اياه فلما تبين له انه عدو لله تبرا منه ان ابرهيم لاوه حليم",
  },
  {
    verseId: 114,
    name: "التوبة",
    surahId: 9,
    text: "وَمَا كَانَ ٱللَّهُ لِيُضِلَّ قَوۡمَۢا بَعۡدَ إِذۡ هَدَىٰهُمۡ حَتَّىٰ يُبَيِّنَ لَهُم مَّا يَتَّقُونَۚ إِنَّ ٱللَّهَ بِكُلِّ شَيۡءٍ عَلِيمٌ",
    translation:
      "And Allah would not let a people stray after He has guided them until He makes clear to them what they should avoid. Indeed, Allah is Knowing of all things",
    normalizedText:
      "وما كان الله ليضل قوما بعد اذ هدىهم حتى يبين لهم ما يتقون ان الله بكل شيء عليم",
  },
  {
    verseId: 115,
    name: "التوبة",
    surahId: 9,
    text: "إِنَّ ٱللَّهَ لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ يُحۡيِۦ وَيُمِيتُۚ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِيّٖ وَلَا نَصِيرٖ",
    translation:
      "Indeed, to Allah belongs the dominion of the heavens and the earth; He gives life and causes death. And you have not besides Allah any protector or any helper",
    normalizedText:
      "ان الله له ملك السموت والارض يحي ويميت وما لكم من دون الله من ولي ولا نصير",
  },
  {
    verseId: 116,
    name: "التوبة",
    surahId: 9,
    text: "لَّقَد تَّابَ ٱللَّهُ عَلَى ٱلنَّبِيِّ وَٱلۡمُهَٰجِرِينَ وَٱلۡأَنصَارِ ٱلَّذِينَ ٱتَّبَعُوهُ فِي سَاعَةِ ٱلۡعُسۡرَةِ مِنۢ بَعۡدِ مَا كَادَ يَزِيغُ قُلُوبُ فَرِيقٖ مِّنۡهُمۡ ثُمَّ تَابَ عَلَيۡهِمۡۚ إِنَّهُۥ بِهِمۡ رَءُوفٞ رَّحِيمٞ",
    translation:
      "Allah has already forgiven the Prophet and the Muhajireen and the Ansar who followed him in the hour of difficulty after the hearts of a party of them had almost inclined [to doubt], and then He forgave them. Indeed, He was to them Kind and Merciful",
    normalizedText:
      "لقد تاب الله على النبي والمهجرين والانصار الذين اتبعوه في ساعة العسرة من بعد ما كاد يزيغ قلوب فريق منهم ثم تاب عليهم انه بهم رءوف رحيم",
  },
  {
    verseId: 117,
    name: "التوبة",
    surahId: 9,
    text: "وَعَلَى ٱلثَّلَٰثَةِ ٱلَّذِينَ خُلِّفُواْ حَتَّىٰٓ إِذَا ضَاقَتۡ عَلَيۡهِمُ ٱلۡأَرۡضُ بِمَا رَحُبَتۡ وَضَاقَتۡ عَلَيۡهِمۡ أَنفُسُهُمۡ وَظَنُّوٓاْ أَن لَّا مَلۡجَأَ مِنَ ٱللَّهِ إِلَّآ إِلَيۡهِ ثُمَّ تَابَ عَلَيۡهِمۡ لِيَتُوبُوٓاْۚ إِنَّ ٱللَّهَ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ",
    translation:
      "And [He also forgave] the three who were left behind [and regretted their error] to the point that the earth closed in on them in spite of its vastness and their souls confined them and they were certain that there is no refuge from Allah except in Him. Then He turned to them so they could repent. Indeed, Allah is the Accepting of repentance, the Merciful",
    normalizedText:
      "وعلى الثلثة الذين خلفوا حتى اذا ضاقت عليهم الارض بما رحبت وضاقت عليهم انفسهم وظنوا ان لا ملجا من الله الا اليه ثم تاب عليهم ليتوبوا ان الله هو التواب الرحيم",
  },
  {
    verseId: 118,
    name: "التوبة",
    surahId: 9,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ ٱللَّهَ وَكُونُواْ مَعَ ٱلصَّـٰدِقِينَ",
    translation:
      "O you who have believed, fear Allah and be with those who are true",
    normalizedText: "يايها الذين ءامنوا اتقوا الله وكونوا مع الصدقين",
  },
  {
    verseId: 119,
    name: "التوبة",
    surahId: 9,
    text: "مَا كَانَ لِأَهۡلِ ٱلۡمَدِينَةِ وَمَنۡ حَوۡلَهُم مِّنَ ٱلۡأَعۡرَابِ أَن يَتَخَلَّفُواْ عَن رَّسُولِ ٱللَّهِ وَلَا يَرۡغَبُواْ بِأَنفُسِهِمۡ عَن نَّفۡسِهِۦۚ ذَٰلِكَ بِأَنَّهُمۡ لَا يُصِيبُهُمۡ ظَمَأٞ وَلَا نَصَبٞ وَلَا مَخۡمَصَةٞ فِي سَبِيلِ ٱللَّهِ وَلَا يَطَـُٔونَ مَوۡطِئٗا يَغِيظُ ٱلۡكُفَّارَ وَلَا يَنَالُونَ مِنۡ عَدُوّٖ نَّيۡلًا إِلَّا كُتِبَ لَهُم بِهِۦ عَمَلٞ صَٰلِحٌۚ إِنَّ ٱللَّهَ لَا يُضِيعُ أَجۡرَ ٱلۡمُحۡسِنِينَ",
    translation:
      "It was not [proper] for the people of Madinah and those surrounding them of the bedouins that they remain behind after [the departure of] the Messenger of Allah or that they prefer themselves over his self. That is because they are not afflicted by thirst or fatigue or hunger in the cause of Allah, nor do they tread on any ground that enrages the disbelievers, nor do they inflict upon an enemy any infliction but that is registered for them as a righteous deed. Indeed, Allah does not allow to be lost the reward of the doers of good",
    normalizedText:
      "ما كان لاهل المدينة ومن حولهم من الاعراب ان يتخلفوا عن رسول الله ولا يرغبوا بانفسهم عن نفسه ذلك بانهم لا يصيبهم ظما ولا نصب ولا مخمصة في سبيل الله ولا يطون موطاا يغيظ الكفار ولا ينالون من عدو نيلا الا كتب لهم به عمل صلح ان الله لا يضيع اجر المحسنين",
  },
  {
    verseId: 120,
    name: "التوبة",
    surahId: 9,
    text: "وَلَا يُنفِقُونَ نَفَقَةٗ صَغِيرَةٗ وَلَا كَبِيرَةٗ وَلَا يَقۡطَعُونَ وَادِيًا إِلَّا كُتِبَ لَهُمۡ لِيَجۡزِيَهُمُ ٱللَّهُ أَحۡسَنَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Nor do they spend an expenditure, small or large, or cross a valley but that it is registered for them that Allah may reward them for the best of what they were doing",
    normalizedText:
      "ولا ينفقون نفقة صغيرة ولا كبيرة ولا يقطعون واديا الا كتب لهم ليجزيهم الله احسن ما كانوا يعملون",
  },
  {
    verseId: 121,
    name: "التوبة",
    surahId: 9,
    text: "۞وَمَا كَانَ ٱلۡمُؤۡمِنُونَ لِيَنفِرُواْ كَآفَّةٗۚ فَلَوۡلَا نَفَرَ مِن كُلِّ فِرۡقَةٖ مِّنۡهُمۡ طَآئِفَةٞ لِّيَتَفَقَّهُواْ فِي ٱلدِّينِ وَلِيُنذِرُواْ قَوۡمَهُمۡ إِذَا رَجَعُوٓاْ إِلَيۡهِمۡ لَعَلَّهُمۡ يَحۡذَرُونَ",
    translation:
      "And it is not for the believers to go forth [to battle] all at once. For there should separate from every division of them a group [remaining] to obtain understanding in the religion and warn their people when they return to them that they might be cautious",
    normalizedText:
      "۞وما كان المامنون لينفروا كافة فلولا نفر من كل فرقة منهم طاافة ليتفقهوا في الدين ولينذروا قومهم اذا رجعوا اليهم لعلهم يحذرون",
  },
  {
    verseId: 122,
    name: "التوبة",
    surahId: 9,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ قَٰتِلُواْ ٱلَّذِينَ يَلُونَكُم مِّنَ ٱلۡكُفَّارِ وَلۡيَجِدُواْ فِيكُمۡ غِلۡظَةٗۚ وَٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ مَعَ ٱلۡمُتَّقِينَ",
    translation:
      "O you who have believed, fight those adjacent to you of the disbelievers and let them find in you harshness. And know that Allah is with the righteous",
    normalizedText:
      "يايها الذين ءامنوا قتلوا الذين يلونكم من الكفار وليجدوا فيكم غلظة واعلموا ان الله مع المتقين",
  },
  {
    verseId: 123,
    name: "التوبة",
    surahId: 9,
    text: "وَإِذَا مَآ أُنزِلَتۡ سُورَةٞ فَمِنۡهُم مَّن يَقُولُ أَيُّكُمۡ زَادَتۡهُ هَٰذِهِۦٓ إِيمَٰنٗاۚ فَأَمَّا ٱلَّذِينَ ءَامَنُواْ فَزَادَتۡهُمۡ إِيمَٰنٗا وَهُمۡ يَسۡتَبۡشِرُونَ",
    translation:
      'And whenever a surah is revealed, there are among the hypocrites those who say, "Which of you has this increased faith?" As for those who believed, it has increased them in faith, while they are rejoicing',
    normalizedText:
      "واذا ما انزلت سورة فمنهم من يقول ايكم زادته هذه ايمنا فاما الذين ءامنوا فزادتهم ايمنا وهم يستبشرون",
  },
  {
    verseId: 124,
    name: "التوبة",
    surahId: 9,
    text: "وَأَمَّا ٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٞ فَزَادَتۡهُمۡ رِجۡسًا إِلَىٰ رِجۡسِهِمۡ وَمَاتُواْ وَهُمۡ كَٰفِرُونَ",
    translation:
      "But as for those in whose hearts is disease, it has [only] increased them in evil [in addition] to their evil. And they will have died while they are disbelievers",
    normalizedText:
      "واما الذين في قلوبهم مرض فزادتهم رجسا الى رجسهم وماتوا وهم كفرون",
  },
  {
    verseId: 125,
    name: "التوبة",
    surahId: 9,
    text: "أَوَلَا يَرَوۡنَ أَنَّهُمۡ يُفۡتَنُونَ فِي كُلِّ عَامٖ مَّرَّةً أَوۡ مَرَّتَيۡنِ ثُمَّ لَا يَتُوبُونَ وَلَا هُمۡ يَذَّكَّرُونَ",
    translation:
      "Do they not see that they are tried every year once or twice but then they do not repent nor do they remember",
    normalizedText:
      "اولا يرون انهم يفتنون في كل عام مرة او مرتين ثم لا يتوبون ولا هم يذكرون",
  },
  {
    verseId: 126,
    name: "التوبة",
    surahId: 9,
    text: "وَإِذَا مَآ أُنزِلَتۡ سُورَةٞ نَّظَرَ بَعۡضُهُمۡ إِلَىٰ بَعۡضٍ هَلۡ يَرَىٰكُم مِّنۡ أَحَدٖ ثُمَّ ٱنصَرَفُواْۚ صَرَفَ ٱللَّهُ قُلُوبَهُم بِأَنَّهُمۡ قَوۡمٞ لَّا يَفۡقَهُونَ",
    translation:
      'And whenever a surah is revealed, they look at each other, [saying], "Does anyone see you?" and then they dismiss themselves. Allah has dismissed their hearts because they are a people who do not understand',
    normalizedText:
      "واذا ما انزلت سورة نظر بعضهم الى بعض هل يرىكم من احد ثم انصرفوا صرف الله قلوبهم بانهم قوم لا يفقهون",
  },
  {
    verseId: 127,
    name: "التوبة",
    surahId: 9,
    text: "لَقَدۡ جَآءَكُمۡ رَسُولٞ مِّنۡ أَنفُسِكُمۡ عَزِيزٌ عَلَيۡهِ مَا عَنِتُّمۡ حَرِيصٌ عَلَيۡكُم بِٱلۡمُؤۡمِنِينَ رَءُوفٞ رَّحِيمٞ",
    translation:
      "There has certainly come to you a Messenger from among yourselves. Grievous to him is what you suffer; [he is] concerned over you and to the believers is kind and merciful",
    normalizedText:
      "لقد جاءكم رسول من انفسكم عزيز عليه ما عنتم حريص عليكم بالمامنين رءوف رحيم",
  },
  {
    verseId: 128,
    name: "التوبة",
    surahId: 9,
    text: "فَإِن تَوَلَّوۡاْ فَقُلۡ حَسۡبِيَ ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَۖ عَلَيۡهِ تَوَكَّلۡتُۖ وَهُوَ رَبُّ ٱلۡعَرۡشِ ٱلۡعَظِيمِ",
    translation:
      'But if they turn away, [O Muhammad], say, "Sufficient for me is Allah; there is no deity except Him. On Him I have relied, and He is the Lord of the Great Throne',
    normalizedText:
      "فان تولوا فقل حسبي الله لا اله الا هو عليه توكلت وهو رب العرش العظيم",
  },
  {
    verseId: 0,
    name: "يونس",
    surahId: 10,
    text: "الٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡحَكِيمِ",
    translation: "Alif, Lam, Ra. These are the verses of the wise Book",
    normalizedText: "الر تلك ءايت الكتب الحكيم",
  },
  {
    verseId: 1,
    name: "يونس",
    surahId: 10,
    text: "أَكَانَ لِلنَّاسِ عَجَبًا أَنۡ أَوۡحَيۡنَآ إِلَىٰ رَجُلٖ مِّنۡهُمۡ أَنۡ أَنذِرِ ٱلنَّاسَ وَبَشِّرِ ٱلَّذِينَ ءَامَنُوٓاْ أَنَّ لَهُمۡ قَدَمَ صِدۡقٍ عِندَ رَبِّهِمۡۗ قَالَ ٱلۡكَٰفِرُونَ إِنَّ هَٰذَا لَسَٰحِرٞ مُّبِينٌ",
    translation:
      'Have the people been amazed that We revealed [revelation] to a man from among them, [saying], "Warn mankind and give good tidings to those who believe that they will have a [firm] precedence of honor with their Lord"? [But] the disbelievers say, "Indeed, this is an obvious magician',
    normalizedText:
      "اكان للناس عجبا ان اوحينا الى رجل منهم ان انذر الناس وبشر الذين ءامنوا ان لهم قدم صدق عند ربهم قال الكفرون ان هذا لسحر مبين",
  },
  {
    verseId: 2,
    name: "يونس",
    surahId: 10,
    text: "إِنَّ رَبَّكُمُ ٱللَّهُ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ فِي سِتَّةِ أَيَّامٖ ثُمَّ ٱسۡتَوَىٰ عَلَى ٱلۡعَرۡشِۖ يُدَبِّرُ ٱلۡأَمۡرَۖ مَا مِن شَفِيعٍ إِلَّا مِنۢ بَعۡدِ إِذۡنِهِۦۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمۡ فَٱعۡبُدُوهُۚ أَفَلَا تَذَكَّرُونَ",
    translation:
      "Indeed, your Lord is Allah, who created the heavens and the earth in six days and then established Himself above the Throne, arranging the matter [of His creation]. There is no intercessor except after His permission. That is Allah, your Lord, so worship Him. Then will you not remember",
    normalizedText:
      "ان ربكم الله الذي خلق السموت والارض في ستة ايام ثم استوى على العرش يدبر الامر ما من شفيع الا من بعد اذنه ذلكم الله ربكم فاعبدوه افلا تذكرون",
  },
  {
    verseId: 3,
    name: "يونس",
    surahId: 10,
    text: "إِلَيۡهِ مَرۡجِعُكُمۡ جَمِيعٗاۖ وَعۡدَ ٱللَّهِ حَقًّاۚ إِنَّهُۥ يَبۡدَؤُاْ ٱلۡخَلۡقَ ثُمَّ يُعِيدُهُۥ لِيَجۡزِيَ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ بِٱلۡقِسۡطِۚ وَٱلَّذِينَ كَفَرُواْ لَهُمۡ شَرَابٞ مِّنۡ حَمِيمٖ وَعَذَابٌ أَلِيمُۢ بِمَا كَانُواْ يَكۡفُرُونَ",
    translation:
      "To Him is your return all together. [It is] the promise of Allah [which is] truth. Indeed, He begins the [process of] creation and then repeats it that He may reward those who have believed and done righteous deeds, in justice. But those who disbelieved will have a drink of scalding water and a painful punishment for what they used to deny",
    normalizedText:
      "اليه مرجعكم جميعا وعد الله حقا انه يبداا الخلق ثم يعيده ليجزي الذين ءامنوا وعملوا الصلحت بالقسط والذين كفروا لهم شراب من حميم وعذاب اليم بما كانوا يكفرون",
  },
  {
    verseId: 4,
    name: "يونس",
    surahId: 10,
    text: "هُوَ ٱلَّذِي جَعَلَ ٱلشَّمۡسَ ضِيَآءٗ وَٱلۡقَمَرَ نُورٗا وَقَدَّرَهُۥ مَنَازِلَ لِتَعۡلَمُواْ عَدَدَ ٱلسِّنِينَ وَٱلۡحِسَابَۚ مَا خَلَقَ ٱللَّهُ ذَٰلِكَ إِلَّا بِٱلۡحَقِّۚ يُفَصِّلُ ٱلۡأٓيَٰتِ لِقَوۡمٖ يَعۡلَمُونَ",
    translation:
      "It is He who made the sun a shining light and the moon a derived light and determined for it phases - that you may know the number of years and account [of time]. Allah has not created this except in truth. He details the signs for a people who know",
    normalizedText:
      "هو الذي جعل الشمس ضياء والقمر نورا وقدره منازل لتعلموا عدد السنين والحساب ما خلق الله ذلك الا بالحق يفصل الايت لقوم يعلمون",
  },
  {
    verseId: 5,
    name: "يونس",
    surahId: 10,
    text: "إِنَّ فِي ٱخۡتِلَٰفِ ٱلَّيۡلِ وَٱلنَّهَارِ وَمَا خَلَقَ ٱللَّهُ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ لَأٓيَٰتٖ لِّقَوۡمٖ يَتَّقُونَ",
    translation:
      "Indeed, in the alternation of the night and the day and [in] what Allah has created in the heavens and the earth are signs for a people who fear Allah",
    normalizedText:
      "ان في اختلف اليل والنهار وما خلق الله في السموت والارض لايت لقوم يتقون",
  },
  {
    verseId: 6,
    name: "يونس",
    surahId: 10,
    text: "إِنَّ ٱلَّذِينَ لَا يَرۡجُونَ لِقَآءَنَا وَرَضُواْ بِٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَٱطۡمَأَنُّواْ بِهَا وَٱلَّذِينَ هُمۡ عَنۡ ءَايَٰتِنَا غَٰفِلُونَ",
    translation:
      "Indeed, those who do not expect the meeting with Us and are satisfied with the life of this world and feel secure therein and those who are heedless of Our signs",
    normalizedText:
      "ان الذين لا يرجون لقاءنا ورضوا بالحيوة الدنيا واطمانوا بها والذين هم عن ءايتنا غفلون",
  },
  {
    verseId: 7,
    name: "يونس",
    surahId: 10,
    text: "أُوْلَـٰٓئِكَ مَأۡوَىٰهُمُ ٱلنَّارُ بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "For those their refuge will be the Fire because of what they used to earn",
    normalizedText: "اولاك ماوىهم النار بما كانوا يكسبون",
  },
  {
    verseId: 8,
    name: "يونس",
    surahId: 10,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ يَهۡدِيهِمۡ رَبُّهُم بِإِيمَٰنِهِمۡۖ تَجۡرِي مِن تَحۡتِهِمُ ٱلۡأَنۡهَٰرُ فِي جَنَّـٰتِ ٱلنَّعِيمِ",
    translation:
      "Indeed, those who have believed and done righteous deeds - their Lord will guide them because of their faith. Beneath them rivers will flow in the Gardens of Pleasure",
    normalizedText:
      "ان الذين ءامنوا وعملوا الصلحت يهديهم ربهم بايمنهم تجري من تحتهم الانهر في جنت النعيم",
  },
  {
    verseId: 9,
    name: "يونس",
    surahId: 10,
    text: "دَعۡوَىٰهُمۡ فِيهَا سُبۡحَٰنَكَ ٱللَّهُمَّ وَتَحِيَّتُهُمۡ فِيهَا سَلَٰمٞۚ وَءَاخِرُ دَعۡوَىٰهُمۡ أَنِ ٱلۡحَمۡدُ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'Their call therein will be, "Exalted are You, O Allah," and their greeting therein will be, "Peace." And the last of their call will be, "Praise to Allah, Lord of the worlds',
    normalizedText:
      "دعوىهم فيها سبحنك اللهم وتحيتهم فيها سلم وءاخر دعوىهم ان الحمد لله رب العلمين",
  },
  {
    verseId: 10,
    name: "يونس",
    surahId: 10,
    text: "۞وَلَوۡ يُعَجِّلُ ٱللَّهُ لِلنَّاسِ ٱلشَّرَّ ٱسۡتِعۡجَالَهُم بِٱلۡخَيۡرِ لَقُضِيَ إِلَيۡهِمۡ أَجَلُهُمۡۖ فَنَذَرُ ٱلَّذِينَ لَا يَرۡجُونَ لِقَآءَنَا فِي طُغۡيَٰنِهِمۡ يَعۡمَهُونَ",
    translation:
      "And if Allah was to hasten for the people the evil [they invoke] as He hastens for them the good, their term would have been ended for them. But We leave the ones who do not expect the meeting with Us, in their transgression, wandering blindly",
    normalizedText:
      "۞ولو يعجل الله للناس الشر استعجالهم بالخير لقضي اليهم اجلهم فنذر الذين لا يرجون لقاءنا في طغينهم يعمهون",
  },
  {
    verseId: 11,
    name: "يونس",
    surahId: 10,
    text: "وَإِذَا مَسَّ ٱلۡإِنسَٰنَ ٱلضُّرُّ دَعَانَا لِجَنۢبِهِۦٓ أَوۡ قَاعِدًا أَوۡ قَآئِمٗا فَلَمَّا كَشَفۡنَا عَنۡهُ ضُرَّهُۥ مَرَّ كَأَن لَّمۡ يَدۡعُنَآ إِلَىٰ ضُرّٖ مَّسَّهُۥۚ كَذَٰلِكَ زُيِّنَ لِلۡمُسۡرِفِينَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "And when affliction touches man, he calls upon Us, whether lying on his side or sitting or standing; but when We remove from him his affliction, he continues [in disobedience] as if he had never called upon Us to [remove] an affliction that touched him. Thus is made pleasing to the transgressors that which they have been doing",
    normalizedText:
      "واذا مس الانسن الضر دعانا لجنبه او قاعدا او قااما فلما كشفنا عنه ضره مر كان لم يدعنا الى ضر مسه كذلك زين للمسرفين ما كانوا يعملون",
  },
  {
    verseId: 12,
    name: "يونس",
    surahId: 10,
    text: "وَلَقَدۡ أَهۡلَكۡنَا ٱلۡقُرُونَ مِن قَبۡلِكُمۡ لَمَّا ظَلَمُواْ وَجَآءَتۡهُمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِ وَمَا كَانُواْ لِيُؤۡمِنُواْۚ كَذَٰلِكَ نَجۡزِي ٱلۡقَوۡمَ ٱلۡمُجۡرِمِينَ",
    translation:
      "And We had already destroyed generations before you when they wronged, and their messengers had come to them with clear proofs, but they were not to believe. Thus do We recompense the criminal people",
    normalizedText:
      "ولقد اهلكنا القرون من قبلكم لما ظلموا وجاءتهم رسلهم بالبينت وما كانوا ليامنوا كذلك نجزي القوم المجرمين",
  },
  {
    verseId: 13,
    name: "يونس",
    surahId: 10,
    text: "ثُمَّ جَعَلۡنَٰكُمۡ خَلَـٰٓئِفَ فِي ٱلۡأَرۡضِ مِنۢ بَعۡدِهِمۡ لِنَنظُرَ كَيۡفَ تَعۡمَلُونَ",
    translation:
      "Then We made you successors in the land after them so that We may observe how you will do",
    normalizedText: "ثم جعلنكم خلاف في الارض من بعدهم لننظر كيف تعملون",
  },
  {
    verseId: 14,
    name: "يونس",
    surahId: 10,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَاتُنَا بَيِّنَٰتٖ قَالَ ٱلَّذِينَ لَا يَرۡجُونَ لِقَآءَنَا ٱئۡتِ بِقُرۡءَانٍ غَيۡرِ هَٰذَآ أَوۡ بَدِّلۡهُۚ قُلۡ مَا يَكُونُ لِيٓ أَنۡ أُبَدِّلَهُۥ مِن تِلۡقَآيِٕ نَفۡسِيٓۖ إِنۡ أَتَّبِعُ إِلَّا مَا يُوحَىٰٓ إِلَيَّۖ إِنِّيٓ أَخَافُ إِنۡ عَصَيۡتُ رَبِّي عَذَابَ يَوۡمٍ عَظِيمٖ",
    translation: `And when Our verses are recited to them as clear evidences, those who do not expect the meeting with Us say, "Bring us a Qur'an other than this or change it." Say, [O Muhammad], "It is not for me to change it on my own accord. I only follow what is revealed to me. Indeed I fear, if I should disobey my Lord, the punishment of a tremendous Day`,
    normalizedText:
      "واذا تتلى عليهم ءاياتنا بينت قال الذين لا يرجون لقاءنا اات بقرءان غير هذا او بدله قل ما يكون لي ان ابدله من تلقاي نفسي ان اتبع الا ما يوحى الي اني اخاف ان عصيت ربي عذاب يوم عظيم",
  },
  {
    verseId: 15,
    name: "يونس",
    surahId: 10,
    text: "قُل لَّوۡ شَآءَ ٱللَّهُ مَا تَلَوۡتُهُۥ عَلَيۡكُمۡ وَلَآ أَدۡرَىٰكُم بِهِۦۖ فَقَدۡ لَبِثۡتُ فِيكُمۡ عُمُرٗا مِّن قَبۡلِهِۦٓۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      'Say, "If Allah had willed, I would not have recited it to you, nor would He have made it known to you, for I had remained among you a lifetime before it. Then will you not reason',
    normalizedText:
      "قل لو شاء الله ما تلوته عليكم ولا ادرىكم به فقد لبثت فيكم عمرا من قبله افلا تعقلون",
  },
  {
    verseId: 16,
    name: "يونس",
    surahId: 10,
    text: "فَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوۡ كَذَّبَ بِـَٔايَٰتِهِۦٓۚ إِنَّهُۥ لَا يُفۡلِحُ ٱلۡمُجۡرِمُونَ",
    translation:
      "So who is more unjust than he who invents a lie about Allah or denies His signs? Indeed, the criminals will not succeed",
    normalizedText:
      "فمن اظلم ممن افترى على الله كذبا او كذب بايته انه لا يفلح المجرمون",
  },
  {
    verseId: 17,
    name: "يونس",
    surahId: 10,
    text: "وَيَعۡبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَضُرُّهُمۡ وَلَا يَنفَعُهُمۡ وَيَقُولُونَ هَـٰٓؤُلَآءِ شُفَعَـٰٓؤُنَا عِندَ ٱللَّهِۚ قُلۡ أَتُنَبِّـُٔونَ ٱللَّهَ بِمَا لَا يَعۡلَمُ فِي ٱلسَّمَٰوَٰتِ وَلَا فِي ٱلۡأَرۡضِۚ سُبۡحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      'And they worship other than Allah that which neither harms them nor benefits them, and they say, "These are our intercessors with Allah " Say, "Do you inform Allah of something He does not know in the heavens or on the earth?" Exalted is He and high above what they associate with Him',
    normalizedText:
      "ويعبدون من دون الله ما لا يضرهم ولا ينفعهم ويقولون هالاء شفعانا عند الله قل اتنبون الله بما لا يعلم في السموت ولا في الارض سبحنه وتعلى عما يشركون",
  },
  {
    verseId: 18,
    name: "يونس",
    surahId: 10,
    text: "وَمَا كَانَ ٱلنَّاسُ إِلَّآ أُمَّةٗ وَٰحِدَةٗ فَٱخۡتَلَفُواْۚ وَلَوۡلَا كَلِمَةٞ سَبَقَتۡ مِن رَّبِّكَ لَقُضِيَ بَيۡنَهُمۡ فِيمَا فِيهِ يَخۡتَلِفُونَ",
    translation:
      "And mankind was not but one community [united in religion], but [then] they differed. And if not for a word that preceded from your Lord, it would have been judged between them [immediately] concerning that over which they differ",
    normalizedText:
      "وما كان الناس الا امة وحدة فاختلفوا ولولا كلمة سبقت من ربك لقضي بينهم فيما فيه يختلفون",
  },
  {
    verseId: 19,
    name: "يونس",
    surahId: 10,
    text: "وَيَقُولُونَ لَوۡلَآ أُنزِلَ عَلَيۡهِ ءَايَةٞ مِّن رَّبِّهِۦۖ فَقُلۡ إِنَّمَا ٱلۡغَيۡبُ لِلَّهِ فَٱنتَظِرُوٓاْ إِنِّي مَعَكُم مِّنَ ٱلۡمُنتَظِرِينَ",
    translation:
      'And they say, "Why is a sign not sent down to him from his Lord?" So say, "The unseen is only for Allah [to administer], so wait; indeed, I am with you among those who wait',
    normalizedText:
      "ويقولون لولا انزل عليه ءاية من ربه فقل انما الغيب لله فانتظروا اني معكم من المنتظرين",
  },
  {
    verseId: 20,
    name: "يونس",
    surahId: 10,
    text: "وَإِذَآ أَذَقۡنَا ٱلنَّاسَ رَحۡمَةٗ مِّنۢ بَعۡدِ ضَرَّآءَ مَسَّتۡهُمۡ إِذَا لَهُم مَّكۡرٞ فِيٓ ءَايَاتِنَاۚ قُلِ ٱللَّهُ أَسۡرَعُ مَكۡرًاۚ إِنَّ رُسُلَنَا يَكۡتُبُونَ مَا تَمۡكُرُونَ",
    translation:
      'And when We give the people a taste of mercy after adversity has touched them, at once they conspire against Our verses. Say, "Allah is swifter in strategy." Indeed, Our messengers record that which you conspire',
    normalizedText:
      "واذا اذقنا الناس رحمة من بعد ضراء مستهم اذا لهم مكر في ءاياتنا قل الله اسرع مكرا ان رسلنا يكتبون ما تمكرون",
  },
  {
    verseId: 21,
    name: "يونس",
    surahId: 10,
    text: "هُوَ ٱلَّذِي يُسَيِّرُكُمۡ فِي ٱلۡبَرِّ وَٱلۡبَحۡرِۖ حَتَّىٰٓ إِذَا كُنتُمۡ فِي ٱلۡفُلۡكِ وَجَرَيۡنَ بِهِم بِرِيحٖ طَيِّبَةٖ وَفَرِحُواْ بِهَا جَآءَتۡهَا رِيحٌ عَاصِفٞ وَجَآءَهُمُ ٱلۡمَوۡجُ مِن كُلِّ مَكَانٖ وَظَنُّوٓاْ أَنَّهُمۡ أُحِيطَ بِهِمۡ دَعَوُاْ ٱللَّهَ مُخۡلِصِينَ لَهُ ٱلدِّينَ لَئِنۡ أَنجَيۡتَنَا مِنۡ هَٰذِهِۦ لَنَكُونَنَّ مِنَ ٱلشَّـٰكِرِينَ",
    translation:
      'It is He who enables you to travel on land and sea until, when you are in ships and they sail with them by a good wind and they rejoice therein, there comes a storm wind and the waves come upon them from everywhere and they assume that they are surrounded, supplicating Allah, sincere to Him in religion, "If You should save us from this, we will surely be among the thankful',
    normalizedText:
      "هو الذي يسيركم في البر والبحر حتى اذا كنتم في الفلك وجرين بهم بريح طيبة وفرحوا بها جاءتها ريح عاصف وجاءهم الموج من كل مكان وظنوا انهم احيط بهم دعوا الله مخلصين له الدين لان انجيتنا من هذه لنكونن من الشكرين",
  },
  {
    verseId: 22,
    name: "يونس",
    surahId: 10,
    text: "فَلَمَّآ أَنجَىٰهُمۡ إِذَا هُمۡ يَبۡغُونَ فِي ٱلۡأَرۡضِ بِغَيۡرِ ٱلۡحَقِّۗ يَـٰٓأَيُّهَا ٱلنَّاسُ إِنَّمَا بَغۡيُكُمۡ عَلَىٰٓ أَنفُسِكُمۖ مَّتَٰعَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ ثُمَّ إِلَيۡنَا مَرۡجِعُكُمۡ فَنُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "But when He saves them, at once they commit injustice upon the earth without right. O mankind, your injustice is only against yourselves, [being merely] the enjoyment of worldly life. Then to Us is your return, and We will inform you of what you used to do",
    normalizedText:
      "فلما انجىهم اذا هم يبغون في الارض بغير الحق يايها الناس انما بغيكم على انفسكم متع الحيوة الدنيا ثم الينا مرجعكم فننباكم بما كنتم تعملون",
  },
  {
    verseId: 23,
    name: "يونس",
    surahId: 10,
    text: "إِنَّمَا مَثَلُ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا كَمَآءٍ أَنزَلۡنَٰهُ مِنَ ٱلسَّمَآءِ فَٱخۡتَلَطَ بِهِۦ نَبَاتُ ٱلۡأَرۡضِ مِمَّا يَأۡكُلُ ٱلنَّاسُ وَٱلۡأَنۡعَٰمُ حَتَّىٰٓ إِذَآ أَخَذَتِ ٱلۡأَرۡضُ زُخۡرُفَهَا وَٱزَّيَّنَتۡ وَظَنَّ أَهۡلُهَآ أَنَّهُمۡ قَٰدِرُونَ عَلَيۡهَآ أَتَىٰهَآ أَمۡرُنَا لَيۡلًا أَوۡ نَهَارٗا فَجَعَلۡنَٰهَا حَصِيدٗا كَأَن لَّمۡ تَغۡنَ بِٱلۡأَمۡسِۚ كَذَٰلِكَ نُفَصِّلُ ٱلۡأٓيَٰتِ لِقَوۡمٖ يَتَفَكَّرُونَ",
    translation:
      "The example of [this] worldly life is but like rain which We have sent down from the sky that the plants of the earth absorb - [those] from which men and livestock eat - until, when the earth has taken on its adornment and is beautified and its people suppose that they have capability over it, there comes to it Our command by night or by day, and We make it as a harvest, as if it had not flourished yesterday. Thus do We explain in detail the signs for a people who give thought",
    normalizedText:
      "انما مثل الحيوة الدنيا كماء انزلنه من السماء فاختلط به نبات الارض مما ياكل الناس والانعم حتى اذا اخذت الارض زخرفها وازينت وظن اهلها انهم قدرون عليها اتىها امرنا ليلا او نهارا فجعلنها حصيدا كان لم تغن بالامس كذلك نفصل الايت لقوم يتفكرون",
  },
  {
    verseId: 24,
    name: "يونس",
    surahId: 10,
    text: "وَٱللَّهُ يَدۡعُوٓاْ إِلَىٰ دَارِ ٱلسَّلَٰمِ وَيَهۡدِي مَن يَشَآءُ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "And Allah invites to the Home of Peace and guides whom He wills to a straight path",
    normalizedText: "والله يدعوا الى دار السلم ويهدي من يشاء الى صرط مستقيم",
  },
  {
    verseId: 25,
    name: "يونس",
    surahId: 10,
    text: "۞لِّلَّذِينَ أَحۡسَنُواْ ٱلۡحُسۡنَىٰ وَزِيَادَةٞۖ وَلَا يَرۡهَقُ وُجُوهَهُمۡ قَتَرٞ وَلَا ذِلَّةٌۚ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَنَّةِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "For them who have done good is the best [reward] and extra. No darkness will cover their faces, nor humiliation. Those are companions of Paradise; they will abide therein eternally",
    normalizedText:
      "۞للذين احسنوا الحسنى وزيادة ولا يرهق وجوههم قتر ولا ذلة اولاك اصحب الجنة هم فيها خلدون",
  },
  {
    verseId: 26,
    name: "يونس",
    surahId: 10,
    text: "وَٱلَّذِينَ كَسَبُواْ ٱلسَّيِّـَٔاتِ جَزَآءُ سَيِّئَةِۭ بِمِثۡلِهَا وَتَرۡهَقُهُمۡ ذِلَّةٞۖ مَّا لَهُم مِّنَ ٱللَّهِ مِنۡ عَاصِمٖۖ كَأَنَّمَآ أُغۡشِيَتۡ وُجُوهُهُمۡ قِطَعٗا مِّنَ ٱلَّيۡلِ مُظۡلِمًاۚ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "But they who have earned [blame for] evil doings - the recompense of an evil deed is its equivalent, and humiliation will cover them. They will have from Allah no protector. It will be as if their faces are covered with pieces of the night - so dark [are they]. Those are the companions of the Fire; they will abide therein eternally",
    normalizedText:
      "والذين كسبوا السيات جزاء سياة بمثلها وترهقهم ذلة ما لهم من الله من عاصم كانما اغشيت وجوههم قطعا من اليل مظلما اولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 27,
    name: "يونس",
    surahId: 10,
    text: "وَيَوۡمَ نَحۡشُرُهُمۡ جَمِيعٗا ثُمَّ نَقُولُ لِلَّذِينَ أَشۡرَكُواْ مَكَانَكُمۡ أَنتُمۡ وَشُرَكَآؤُكُمۡۚ فَزَيَّلۡنَا بَيۡنَهُمۡۖ وَقَالَ شُرَكَآؤُهُم مَّا كُنتُمۡ إِيَّانَا تَعۡبُدُونَ",
    translation: `And [mention, O Muhammad], the Day We will gather them all together - then We will say to those who associated others with Allah, "[Remain in] your place, you and your 'partners.' " Then We will separate them, and their "partners" will say, "You did not used to worship us`,
    normalizedText:
      "ويوم نحشرهم جميعا ثم نقول للذين اشركوا مكانكم انتم وشركااكم فزيلنا بينهم وقال شركااهم ما كنتم ايانا تعبدون",
  },
  {
    verseId: 28,
    name: "يونس",
    surahId: 10,
    text: "فَكَفَىٰ بِٱللَّهِ شَهِيدَۢا بَيۡنَنَا وَبَيۡنَكُمۡ إِن كُنَّا عَنۡ عِبَادَتِكُمۡ لَغَٰفِلِينَ",
    translation:
      "And sufficient is Allah as a witness between us and you that we were of your worship unaware",
    normalizedText: "فكفى بالله شهيدا بيننا وبينكم ان كنا عن عبادتكم لغفلين",
  },
  {
    verseId: 29,
    name: "يونس",
    surahId: 10,
    text: "هُنَالِكَ تَبۡلُواْ كُلُّ نَفۡسٖ مَّآ أَسۡلَفَتۡۚ وَرُدُّوٓاْ إِلَى ٱللَّهِ مَوۡلَىٰهُمُ ٱلۡحَقِّۖ وَضَلَّ عَنۡهُم مَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      "There, [on that Day], every soul will be put to trial for what it did previously, and they will be returned to Allah, their master, the Truth, and lost from them is whatever they used to invent",
    normalizedText:
      "هنالك تبلوا كل نفس ما اسلفت وردوا الى الله مولىهم الحق وضل عنهم ما كانوا يفترون",
  },
  {
    verseId: 30,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ مَن يَرۡزُقُكُم مِّنَ ٱلسَّمَآءِ وَٱلۡأَرۡضِ أَمَّن يَمۡلِكُ ٱلسَّمۡعَ وَٱلۡأَبۡصَٰرَ وَمَن يُخۡرِجُ ٱلۡحَيَّ مِنَ ٱلۡمَيِّتِ وَيُخۡرِجُ ٱلۡمَيِّتَ مِنَ ٱلۡحَيِّ وَمَن يُدَبِّرُ ٱلۡأَمۡرَۚ فَسَيَقُولُونَ ٱللَّهُۚ فَقُلۡ أَفَلَا تَتَّقُونَ",
    translation:
      'Say, "Who provides for you from the heaven and the earth? Or who controls hearing and sight and who brings the living out of the dead and brings the dead out of the living and who arranges [every] matter?" They will say, "Allah," so say, "Then will you not fear Him',
    normalizedText:
      "قل من يرزقكم من السماء والارض امن يملك السمع والابصر ومن يخرج الحي من الميت ويخرج الميت من الحي ومن يدبر الامر فسيقولون الله فقل افلا تتقون",
  },
  {
    verseId: 31,
    name: "يونس",
    surahId: 10,
    text: "فَذَٰلِكُمُ ٱللَّهُ رَبُّكُمُ ٱلۡحَقُّۖ فَمَاذَا بَعۡدَ ٱلۡحَقِّ إِلَّا ٱلضَّلَٰلُۖ فَأَنَّىٰ تُصۡرَفُونَ",
    translation:
      "For that is Allah, your Lord, the Truth. And what can be beyond truth except error? So how are you averted",
    normalizedText: "فذلكم الله ربكم الحق فماذا بعد الحق الا الضلل فانى تصرفون",
  },
  {
    verseId: 32,
    name: "يونس",
    surahId: 10,
    text: "كَذَٰلِكَ حَقَّتۡ كَلِمَتُ رَبِّكَ عَلَى ٱلَّذِينَ فَسَقُوٓاْ أَنَّهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "Thus the word of your Lord has come into effect upon those who defiantly disobeyed - that they will not believe",
    normalizedText: "كذلك حقت كلمت ربك على الذين فسقوا انهم لا يامنون",
  },
  {
    verseId: 33,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ هَلۡ مِن شُرَكَآئِكُم مَّن يَبۡدَؤُاْ ٱلۡخَلۡقَ ثُمَّ يُعِيدُهُۥۚ قُلِ ٱللَّهُ يَبۡدَؤُاْ ٱلۡخَلۡقَ ثُمَّ يُعِيدُهُۥۖ فَأَنَّىٰ تُؤۡفَكُونَ",
    translation: `Say, "Are there of your 'partners' any who begins creation and then repeats it?" Say, "Allah begins creation and then repeats it, so how are you deluded`,
    normalizedText:
      "قل هل من شركااكم من يبداا الخلق ثم يعيده قل الله يبداا الخلق ثم يعيده فانى تافكون",
  },
  {
    verseId: 34,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ هَلۡ مِن شُرَكَآئِكُم مَّن يَهۡدِيٓ إِلَى ٱلۡحَقِّۚ قُلِ ٱللَّهُ يَهۡدِي لِلۡحَقِّۗ أَفَمَن يَهۡدِيٓ إِلَى ٱلۡحَقِّ أَحَقُّ أَن يُتَّبَعَ أَمَّن لَّا يَهِدِّيٓ إِلَّآ أَن يُهۡدَىٰۖ فَمَا لَكُمۡ كَيۡفَ تَحۡكُمُونَ",
    translation: `Say, "Are there of your 'partners' any who guides to the truth?" Say, "Allah guides to the truth. So is He who guides to the truth more worthy to be followed or he who guides not unless he is guided? Then what is [wrong] with you - how do you judge`,
    normalizedText:
      "قل هل من شركااكم من يهدي الى الحق قل الله يهدي للحق افمن يهدي الى الحق احق ان يتبع امن لا يهدي الا ان يهدى فما لكم كيف تحكمون",
  },
  {
    verseId: 35,
    name: "يونس",
    surahId: 10,
    text: "وَمَا يَتَّبِعُ أَكۡثَرُهُمۡ إِلَّا ظَنًّاۚ إِنَّ ٱلظَّنَّ لَا يُغۡنِي مِنَ ٱلۡحَقِّ شَيۡـًٔاۚ إِنَّ ٱللَّهَ عَلِيمُۢ بِمَا يَفۡعَلُونَ",
    translation:
      "And most of them follow not except assumption. Indeed, assumption avails not against the truth at all. Indeed, Allah is Knowing of what they do",
    normalizedText:
      "وما يتبع اكثرهم الا ظنا ان الظن لا يغني من الحق شيا ان الله عليم بما يفعلون",
  },
  {
    verseId: 36,
    name: "يونس",
    surahId: 10,
    text: "وَمَا كَانَ هَٰذَا ٱلۡقُرۡءَانُ أَن يُفۡتَرَىٰ مِن دُونِ ٱللَّهِ وَلَٰكِن تَصۡدِيقَ ٱلَّذِي بَيۡنَ يَدَيۡهِ وَتَفۡصِيلَ ٱلۡكِتَٰبِ لَا رَيۡبَ فِيهِ مِن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "And it was not [possible] for this Qur'an to be produced by other than Allah, but [it is] a confirmation of what was before it and a detailed explanation of the [former] Scripture, about which there is no doubt, from the Lord of the worlds",
    normalizedText:
      "وما كان هذا القرءان ان يفترى من دون الله ولكن تصديق الذي بين يديه وتفصيل الكتب لا ريب فيه من رب العلمين",
  },
  {
    verseId: 37,
    name: "يونس",
    surahId: 10,
    text: "أَمۡ يَقُولُونَ ٱفۡتَرَىٰهُۖ قُلۡ فَأۡتُواْ بِسُورَةٖ مِّثۡلِهِۦ وَٱدۡعُواْ مَنِ ٱسۡتَطَعۡتُم مِّن دُونِ ٱللَّهِ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Or do they say [about the Prophet], "He invented it?" Say, "Then bring forth a surah like it and call upon [for assistance] whomever you can besides Allah, if you should be truthful',
    normalizedText:
      "ام يقولون افترىه قل فاتوا بسورة مثله وادعوا من استطعتم من دون الله ان كنتم صدقين",
  },
  {
    verseId: 38,
    name: "يونس",
    surahId: 10,
    text: "بَلۡ كَذَّبُواْ بِمَا لَمۡ يُحِيطُواْ بِعِلۡمِهِۦ وَلَمَّا يَأۡتِهِمۡ تَأۡوِيلُهُۥۚ كَذَٰلِكَ كَذَّبَ ٱلَّذِينَ مِن قَبۡلِهِمۡۖ فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلظَّـٰلِمِينَ",
    translation:
      "Rather, they have denied that which they encompass not in knowledge and whose interpretation has not yet come to them. Thus did those before them deny. Then observe how was the end of the wrongdoers",
    normalizedText:
      "بل كذبوا بما لم يحيطوا بعلمه ولما ياتهم تاويله كذلك كذب الذين من قبلهم فانظر كيف كان عقبة الظلمين",
  },
  {
    verseId: 39,
    name: "يونس",
    surahId: 10,
    text: "وَمِنۡهُم مَّن يُؤۡمِنُ بِهِۦ وَمِنۡهُم مَّن لَّا يُؤۡمِنُ بِهِۦۚ وَرَبُّكَ أَعۡلَمُ بِٱلۡمُفۡسِدِينَ",
    translation:
      "And of them are those who believe in it, and of them are those who do not believe in it. And your Lord is most knowing of the corrupters",
    normalizedText: "ومنهم من يامن به ومنهم من لا يامن به وربك اعلم بالمفسدين",
  },
  {
    verseId: 40,
    name: "يونس",
    surahId: 10,
    text: "وَإِن كَذَّبُوكَ فَقُل لِّي عَمَلِي وَلَكُمۡ عَمَلُكُمۡۖ أَنتُم بَرِيٓـُٔونَ مِمَّآ أَعۡمَلُ وَأَنَا۠ بَرِيٓءٞ مِّمَّا تَعۡمَلُونَ",
    translation:
      'And if they deny you, [O Muhammad], then say, "For me are my deeds, and for you are your deeds. You are disassociated from what I do, and I am disassociated from what you do',
    normalizedText:
      "وان كذبوك فقل لي عملي ولكم عملكم انتم بريون مما اعمل وانا بريء مما تعملون",
  },
  {
    verseId: 41,
    name: "يونس",
    surahId: 10,
    text: "وَمِنۡهُم مَّن يَسۡتَمِعُونَ إِلَيۡكَۚ أَفَأَنتَ تُسۡمِعُ ٱلصُّمَّ وَلَوۡ كَانُواْ لَا يَعۡقِلُونَ",
    translation:
      "And among them are those who listen to you. But can you cause the deaf to hear, although they will not use reason",
    normalizedText: "ومنهم من يستمعون اليك افانت تسمع الصم ولو كانوا لا يعقلون",
  },
  {
    verseId: 42,
    name: "يونس",
    surahId: 10,
    text: "وَمِنۡهُم مَّن يَنظُرُ إِلَيۡكَۚ أَفَأَنتَ تَهۡدِي ٱلۡعُمۡيَ وَلَوۡ كَانُواْ لَا يُبۡصِرُونَ",
    translation:
      "And among them are those who look at you. But can you guide the blind although they will not [attempt to] see",
    normalizedText: "ومنهم من ينظر اليك افانت تهدي العمي ولو كانوا لا يبصرون",
  },
  {
    verseId: 43,
    name: "يونس",
    surahId: 10,
    text: "إِنَّ ٱللَّهَ لَا يَظۡلِمُ ٱلنَّاسَ شَيۡـٔٗا وَلَٰكِنَّ ٱلنَّاسَ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      "Indeed, Allah does not wrong the people at all, but it is the people who are wronging themselves",
    normalizedText: "ان الله لا يظلم الناس شيا ولكن الناس انفسهم يظلمون",
  },
  {
    verseId: 44,
    name: "يونس",
    surahId: 10,
    text: "وَيَوۡمَ يَحۡشُرُهُمۡ كَأَن لَّمۡ يَلۡبَثُوٓاْ إِلَّا سَاعَةٗ مِّنَ ٱلنَّهَارِ يَتَعَارَفُونَ بَيۡنَهُمۡۚ قَدۡ خَسِرَ ٱلَّذِينَ كَذَّبُواْ بِلِقَآءِ ٱللَّهِ وَمَا كَانُواْ مُهۡتَدِينَ",
    translation:
      "And on the Day when He will gather them, [it will be] as if they had not remained [in the world] but an hour of the day, [and] they will know each other. Those will have lost who denied the meeting with Allah and were not guided",
    normalizedText:
      "ويوم يحشرهم كان لم يلبثوا الا ساعة من النهار يتعارفون بينهم قد خسر الذين كذبوا بلقاء الله وما كانوا مهتدين",
  },
  {
    verseId: 45,
    name: "يونس",
    surahId: 10,
    text: "وَإِمَّا نُرِيَنَّكَ بَعۡضَ ٱلَّذِي نَعِدُهُمۡ أَوۡ نَتَوَفَّيَنَّكَ فَإِلَيۡنَا مَرۡجِعُهُمۡ ثُمَّ ٱللَّهُ شَهِيدٌ عَلَىٰ مَا يَفۡعَلُونَ",
    translation:
      "And whether We show you some of what We promise them, [O Muhammad], or We take you in death, to Us is their return; then, [either way], Allah is a witness concerning what they are doing",
    normalizedText:
      "واما نرينك بعض الذي نعدهم او نتوفينك فالينا مرجعهم ثم الله شهيد على ما يفعلون",
  },
  {
    verseId: 46,
    name: "يونس",
    surahId: 10,
    text: "وَلِكُلِّ أُمَّةٖ رَّسُولٞۖ فَإِذَا جَآءَ رَسُولُهُمۡ قُضِيَ بَيۡنَهُم بِٱلۡقِسۡطِ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "And for every nation is a messenger. So when their messenger comes, it will be judged between them in justice, and they will not be wronged",
    normalizedText:
      "ولكل امة رسول فاذا جاء رسولهم قضي بينهم بالقسط وهم لا يظلمون",
  },
  {
    verseId: 47,
    name: "يونس",
    surahId: 10,
    text: "وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلۡوَعۡدُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "When is [the fulfillment of] this promise, if you should be truthful',
    normalizedText: "ويقولون متى هذا الوعد ان كنتم صدقين",
  },
  {
    verseId: 48,
    name: "يونس",
    surahId: 10,
    text: "قُل لَّآ أَمۡلِكُ لِنَفۡسِي ضَرّٗا وَلَا نَفۡعًا إِلَّا مَا شَآءَ ٱللَّهُۗ لِكُلِّ أُمَّةٍ أَجَلٌۚ إِذَا جَآءَ أَجَلُهُمۡ فَلَا يَسۡتَـٔۡخِرُونَ سَاعَةٗ وَلَا يَسۡتَقۡدِمُونَ",
    translation:
      'Say, "I possess not for myself any harm or benefit except what Allah should will. For every nation is a [specified] term. When their time has come, then they will not remain behind an hour, nor will they precede [it]',
    normalizedText:
      "قل لا املك لنفسي ضرا ولا نفعا الا ما شاء الله لكل امة اجل اذا جاء اجلهم فلا يستخرون ساعة ولا يستقدمون",
  },
  {
    verseId: 49,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ أَرَءَيۡتُمۡ إِنۡ أَتَىٰكُمۡ عَذَابُهُۥ بَيَٰتًا أَوۡ نَهَارٗا مَّاذَا يَسۡتَعۡجِلُ مِنۡهُ ٱلۡمُجۡرِمُونَ",
    translation:
      'Say, "Have you considered: if His punishment should come to you by night or by day - for which [aspect] of it would the criminals be impatient',
    normalizedText:
      "قل ارءيتم ان اتىكم عذابه بيتا او نهارا ماذا يستعجل منه المجرمون",
  },
  {
    verseId: 50,
    name: "يونس",
    surahId: 10,
    text: "أَثُمَّ إِذَا مَا وَقَعَ ءَامَنتُم بِهِۦٓۚ ءَآلۡـَٰٔنَ وَقَدۡ كُنتُم بِهِۦ تَسۡتَعۡجِلُونَ",
    translation:
      "Then is it that when it has [actually] occurred you will believe in it? Now? And you were [once] for it impatient",
    normalizedText: "اثم اذا ما وقع ءامنتم به ءالن وقد كنتم به تستعجلون",
  },
  {
    verseId: 51,
    name: "يونس",
    surahId: 10,
    text: "ثُمَّ قِيلَ لِلَّذِينَ ظَلَمُواْ ذُوقُواْ عَذَابَ ٱلۡخُلۡدِ هَلۡ تُجۡزَوۡنَ إِلَّا بِمَا كُنتُمۡ تَكۡسِبُونَ",
    translation:
      'Then it will be said to those who had wronged, "Taste the punishment of eternity; are you being recompensed except for what you used to earn',
    normalizedText:
      "ثم قيل للذين ظلموا ذوقوا عذاب الخلد هل تجزون الا بما كنتم تكسبون",
  },
  {
    verseId: 52,
    name: "يونس",
    surahId: 10,
    text: "۞وَيَسۡتَنۢبِـُٔونَكَ أَحَقٌّ هُوَۖ قُلۡ إِي وَرَبِّيٓ إِنَّهُۥ لَحَقّٞۖ وَمَآ أَنتُم بِمُعۡجِزِينَ",
    translation:
      'And they ask information of you, [O Muhammad], "Is it true?" Say, "Yes, by my Lord. Indeed, it is truth; and you will not cause failure [to Allah]',
    normalizedText: "۞ويستنبونك احق هو قل اي وربي انه لحق وما انتم بمعجزين",
  },
  {
    verseId: 53,
    name: "يونس",
    surahId: 10,
    text: "وَلَوۡ أَنَّ لِكُلِّ نَفۡسٖ ظَلَمَتۡ مَا فِي ٱلۡأَرۡضِ لَٱفۡتَدَتۡ بِهِۦۗ وَأَسَرُّواْ ٱلنَّدَامَةَ لَمَّا رَأَوُاْ ٱلۡعَذَابَۖ وَقُضِيَ بَيۡنَهُم بِٱلۡقِسۡطِ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "And if each soul that wronged had everything on earth, it would offer it in ransom. And they will confide regret when they see the punishment; and they will be judged in justice, and they will not be wronged",
    normalizedText:
      "ولو ان لكل نفس ظلمت ما في الارض لافتدت به واسروا الندامة لما راوا العذاب وقضي بينهم بالقسط وهم لا يظلمون",
  },
  {
    verseId: 54,
    name: "يونس",
    surahId: 10,
    text: "أَلَآ إِنَّ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۗ أَلَآ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "Unquestionably, to Allah belongs whatever is in the heavens and the earth. Unquestionably, the promise of Allah is truth, but most of them do not know",
    normalizedText:
      "الا ان لله ما في السموت والارض الا ان وعد الله حق ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 55,
    name: "يونس",
    surahId: 10,
    text: "هُوَ يُحۡيِۦ وَيُمِيتُ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "He gives life and causes death, and to Him you will be returned",
    normalizedText: "هو يحي ويميت واليه ترجعون",
  },
  {
    verseId: 56,
    name: "يونس",
    surahId: 10,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ قَدۡ جَآءَتۡكُم مَّوۡعِظَةٞ مِّن رَّبِّكُمۡ وَشِفَآءٞ لِّمَا فِي ٱلصُّدُورِ وَهُدٗى وَرَحۡمَةٞ لِّلۡمُؤۡمِنِينَ",
    translation:
      "O mankind, there has to come to you instruction from your Lord and healing for what is in the breasts and guidance and mercy for the believers",
    normalizedText:
      "يايها الناس قد جاءتكم موعظة من ربكم وشفاء لما في الصدور وهدى ورحمة للمامنين",
  },
  {
    verseId: 57,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ بِفَضۡلِ ٱللَّهِ وَبِرَحۡمَتِهِۦ فَبِذَٰلِكَ فَلۡيَفۡرَحُواْ هُوَ خَيۡرٞ مِّمَّا يَجۡمَعُونَ",
    translation:
      'Say, "In the bounty of Allah and in His mercy - in that let them rejoice; it is better than what they accumulate',
    normalizedText: "قل بفضل الله وبرحمته فبذلك فليفرحوا هو خير مما يجمعون",
  },
  {
    verseId: 58,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ أَرَءَيۡتُم مَّآ أَنزَلَ ٱللَّهُ لَكُم مِّن رِّزۡقٖ فَجَعَلۡتُم مِّنۡهُ حَرَامٗا وَحَلَٰلٗا قُلۡ ءَآللَّهُ أَذِنَ لَكُمۡۖ أَمۡ عَلَى ٱللَّهِ تَفۡتَرُونَ",
    translation:
      'Say, "Have you seen what Allah has sent down to you of provision of which you have made [some] lawful and [some] unlawful?" Say, "Has Allah permitted you [to do so], or do you invent [something] about Allah',
    normalizedText:
      "قل ارءيتم ما انزل الله لكم من رزق فجعلتم منه حراما وحللا قل ءالله اذن لكم ام على الله تفترون",
  },
  {
    verseId: 59,
    name: "يونس",
    surahId: 10,
    text: "وَمَا ظَنُّ ٱلَّذِينَ يَفۡتَرُونَ عَلَى ٱللَّهِ ٱلۡكَذِبَ يَوۡمَ ٱلۡقِيَٰمَةِۗ إِنَّ ٱللَّهَ لَذُو فَضۡلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَشۡكُرُونَ",
    translation:
      "And what will be the supposition of those who invent falsehood about Allah on the Day of Resurrection? Indeed, Allah is full of bounty to the people, but most of them are not grateful",
    normalizedText:
      "وما ظن الذين يفترون على الله الكذب يوم القيمة ان الله لذو فضل على الناس ولكن اكثرهم لا يشكرون",
  },
  {
    verseId: 60,
    name: "يونس",
    surahId: 10,
    text: "وَمَا تَكُونُ فِي شَأۡنٖ وَمَا تَتۡلُواْ مِنۡهُ مِن قُرۡءَانٖ وَلَا تَعۡمَلُونَ مِنۡ عَمَلٍ إِلَّا كُنَّا عَلَيۡكُمۡ شُهُودًا إِذۡ تُفِيضُونَ فِيهِۚ وَمَا يَعۡزُبُ عَن رَّبِّكَ مِن مِّثۡقَالِ ذَرَّةٖ فِي ٱلۡأَرۡضِ وَلَا فِي ٱلسَّمَآءِ وَلَآ أَصۡغَرَ مِن ذَٰلِكَ وَلَآ أَكۡبَرَ إِلَّا فِي كِتَٰبٖ مُّبِينٍ",
    translation:
      "And, [O Muhammad], you are not [engaged] in any matter or recite any of the Qur'an and you [people] do not do any deed except that We are witness over you when you are involved in it. And not absent from your Lord is any [part] of an atom's weight within the earth or within the heaven or [anything] smaller than that or greater but that it is in a clear register",
    normalizedText:
      "وما تكون في شان وما تتلوا منه من قرءان ولا تعملون من عمل الا كنا عليكم شهودا اذ تفيضون فيه وما يعزب عن ربك من مثقال ذرة في الارض ولا في السماء ولا اصغر من ذلك ولا اكبر الا في كتب مبين",
  },
  {
    verseId: 61,
    name: "يونس",
    surahId: 10,
    text: "أَلَآ إِنَّ أَوۡلِيَآءَ ٱللَّهِ لَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "Unquestionably, [for] the allies of Allah there will be no fear concerning them, nor will they grieve",
    normalizedText: "الا ان اولياء الله لا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 62,
    name: "يونس",
    surahId: 10,
    text: "ٱلَّذِينَ ءَامَنُواْ وَكَانُواْ يَتَّقُونَ",
    translation: "Those who believed and were fearing Allah",
    normalizedText: "الذين ءامنوا وكانوا يتقون",
  },
  {
    verseId: 63,
    name: "يونس",
    surahId: 10,
    text: "لَهُمُ ٱلۡبُشۡرَىٰ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَفِي ٱلۡأٓخِرَةِۚ لَا تَبۡدِيلَ لِكَلِمَٰتِ ٱللَّهِۚ ذَٰلِكَ هُوَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "For them are good tidings in the worldly life and in the Hereafter. No change is there in the words of Allah. That is what is the great attainment",
    normalizedText:
      "لهم البشرى في الحيوة الدنيا وفي الاخرة لا تبديل لكلمت الله ذلك هو الفوز العظيم",
  },
  {
    verseId: 64,
    name: "يونس",
    surahId: 10,
    text: "وَلَا يَحۡزُنكَ قَوۡلُهُمۡۘ إِنَّ ٱلۡعِزَّةَ لِلَّهِ جَمِيعًاۚ هُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "And let not their speech grieve you. Indeed, honor [due to power] belongs to Allah entirely. He is the Hearing, the Knowing",
    normalizedText: "ولا يحزنك قولهم ان العزة لله جميعا هو السميع العليم",
  },
  {
    verseId: 65,
    name: "يونس",
    surahId: 10,
    text: "أَلَآ إِنَّ لِلَّهِ مَن فِي ٱلسَّمَٰوَٰتِ وَمَن فِي ٱلۡأَرۡضِۗ وَمَا يَتَّبِعُ ٱلَّذِينَ يَدۡعُونَ مِن دُونِ ٱللَّهِ شُرَكَآءَۚ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَإِنۡ هُمۡ إِلَّا يَخۡرُصُونَ",
    translation:
      'Unquestionably, to Allah belongs whoever is in the heavens and whoever is on the earth. And those who invoke other than Allah do not [actually] follow [His] "partners." They follow not except assumption, and they are not but falsifying',
    normalizedText:
      "الا ان لله من في السموت ومن في الارض وما يتبع الذين يدعون من دون الله شركاء ان يتبعون الا الظن وان هم الا يخرصون",
  },
  {
    verseId: 66,
    name: "يونس",
    surahId: 10,
    text: "هُوَ ٱلَّذِي جَعَلَ لَكُمُ ٱلَّيۡلَ لِتَسۡكُنُواْ فِيهِ وَٱلنَّهَارَ مُبۡصِرًاۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَسۡمَعُونَ",
    translation:
      "It is He who made for you the night to rest therein and the day, giving sight. Indeed in that are signs for a people who listen",
    normalizedText:
      "هو الذي جعل لكم اليل لتسكنوا فيه والنهار مبصرا ان في ذلك لايت لقوم يسمعون",
  },
  {
    verseId: 67,
    name: "يونس",
    surahId: 10,
    text: "قَالُواْ ٱتَّخَذَ ٱللَّهُ وَلَدٗاۗ سُبۡحَٰنَهُۥۖ هُوَ ٱلۡغَنِيُّۖ لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ إِنۡ عِندَكُم مِّن سُلۡطَٰنِۭ بِهَٰذَآۚ أَتَقُولُونَ عَلَى ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      'They have said, "Allah has taken a son." Exalted is He; He is the [one] Free of need. To Him belongs whatever is in the heavens and whatever is in the earth. You have no authority for this [claim]. Do you say about Allah that which you do not know',
    normalizedText:
      "قالوا اتخذ الله ولدا سبحنه هو الغني له ما في السموت وما في الارض ان عندكم من سلطن بهذا اتقولون على الله ما لا تعلمون",
  },
  {
    verseId: 68,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ إِنَّ ٱلَّذِينَ يَفۡتَرُونَ عَلَى ٱللَّهِ ٱلۡكَذِبَ لَا يُفۡلِحُونَ",
    translation:
      'Say, "Indeed, those who invent falsehood about Allah will not succeed',
    normalizedText: "قل ان الذين يفترون على الله الكذب لا يفلحون",
  },
  {
    verseId: 69,
    name: "يونس",
    surahId: 10,
    text: "مَتَٰعٞ فِي ٱلدُّنۡيَا ثُمَّ إِلَيۡنَا مَرۡجِعُهُمۡ ثُمَّ نُذِيقُهُمُ ٱلۡعَذَابَ ٱلشَّدِيدَ بِمَا كَانُواْ يَكۡفُرُونَ",
    translation:
      "[For them is brief] enjoyment in this world; then to Us is their return; then We will make them taste the severe punishment because they used to disbelieve",
    normalizedText:
      "متع في الدنيا ثم الينا مرجعهم ثم نذيقهم العذاب الشديد بما كانوا يكفرون",
  },
  {
    verseId: 70,
    name: "يونس",
    surahId: 10,
    text: "۞وَٱتۡلُ عَلَيۡهِمۡ نَبَأَ نُوحٍ إِذۡ قَالَ لِقَوۡمِهِۦ يَٰقَوۡمِ إِن كَانَ كَبُرَ عَلَيۡكُم مَّقَامِي وَتَذۡكِيرِي بِـَٔايَٰتِ ٱللَّهِ فَعَلَى ٱللَّهِ تَوَكَّلۡتُ فَأَجۡمِعُوٓاْ أَمۡرَكُمۡ وَشُرَكَآءَكُمۡ ثُمَّ لَا يَكُنۡ أَمۡرُكُمۡ عَلَيۡكُمۡ غُمَّةٗ ثُمَّ ٱقۡضُوٓاْ إِلَيَّ وَلَا تُنظِرُونِ",
    translation:
      'And recite to them the news of Noah, when he said to his people, "O my people, if my residence and my reminding of the signs of Allah has become burdensome upon you - then I have relied upon Allah. So resolve upon your plan and [call upon] your associates. Then let not your plan be obscure to you. Then carry it out upon me and do not give me respite',
    normalizedText:
      "۞واتل عليهم نبا نوح اذ قال لقومه يقوم ان كان كبر عليكم مقامي وتذكيري بايت الله فعلى الله توكلت فاجمعوا امركم وشركاءكم ثم لا يكن امركم عليكم غمة ثم اقضوا الي ولا تنظرون",
  },
  {
    verseId: 71,
    name: "يونس",
    surahId: 10,
    text: "فَإِن تَوَلَّيۡتُمۡ فَمَا سَأَلۡتُكُم مِّنۡ أَجۡرٍۖ إِنۡ أَجۡرِيَ إِلَّا عَلَى ٱللَّهِۖ وَأُمِرۡتُ أَنۡ أَكُونَ مِنَ ٱلۡمُسۡلِمِينَ",
    translation:
      "And if you turn away [from my advice] then no payment have I asked of you. My reward is only from Allah, and I have been commanded to be of the Muslims",
    normalizedText:
      "فان توليتم فما سالتكم من اجر ان اجري الا على الله وامرت ان اكون من المسلمين",
  },
  {
    verseId: 72,
    name: "يونس",
    surahId: 10,
    text: "فَكَذَّبُوهُ فَنَجَّيۡنَٰهُ وَمَن مَّعَهُۥ فِي ٱلۡفُلۡكِ وَجَعَلۡنَٰهُمۡ خَلَـٰٓئِفَ وَأَغۡرَقۡنَا ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَاۖ فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُنذَرِينَ",
    translation:
      "And they denied him, so We saved him and those with him in the ship and made them successors, and We drowned those who denied Our signs. Then see how was the end of those who were warned",
    normalizedText:
      "فكذبوه فنجينه ومن معه في الفلك وجعلنهم خلاف واغرقنا الذين كذبوا بايتنا فانظر كيف كان عقبة المنذرين",
  },
  {
    verseId: 73,
    name: "يونس",
    surahId: 10,
    text: "ثُمَّ بَعَثۡنَا مِنۢ بَعۡدِهِۦ رُسُلًا إِلَىٰ قَوۡمِهِمۡ فَجَآءُوهُم بِٱلۡبَيِّنَٰتِ فَمَا كَانُواْ لِيُؤۡمِنُواْ بِمَا كَذَّبُواْ بِهِۦ مِن قَبۡلُۚ كَذَٰلِكَ نَطۡبَعُ عَلَىٰ قُلُوبِ ٱلۡمُعۡتَدِينَ",
    translation:
      "Then We sent after him messengers to their peoples, and they came to them with clear proofs. But they were not to believe in that which they had denied before. Thus We seal over the hearts of the transgressors",
    normalizedText:
      "ثم بعثنا من بعده رسلا الى قومهم فجاءوهم بالبينت فما كانوا ليامنوا بما كذبوا به من قبل كذلك نطبع على قلوب المعتدين",
  },
  {
    verseId: 74,
    name: "يونس",
    surahId: 10,
    text: "ثُمَّ بَعَثۡنَا مِنۢ بَعۡدِهِم مُّوسَىٰ وَهَٰرُونَ إِلَىٰ فِرۡعَوۡنَ وَمَلَإِيْهِۦ بِـَٔايَٰتِنَا فَٱسۡتَكۡبَرُواْ وَكَانُواْ قَوۡمٗا مُّجۡرِمِينَ",
    translation:
      "Then We sent after them Moses and Aaron to Pharaoh and his establishment with Our signs, but they behaved arrogantly and were a criminal people",
    normalizedText:
      "ثم بعثنا من بعدهم موسى وهرون الى فرعون وملايه بايتنا فاستكبروا وكانوا قوما مجرمين",
  },
  {
    verseId: 75,
    name: "يونس",
    surahId: 10,
    text: "فَلَمَّا جَآءَهُمُ ٱلۡحَقُّ مِنۡ عِندِنَا قَالُوٓاْ إِنَّ هَٰذَا لَسِحۡرٞ مُّبِينٞ",
    translation:
      'So when there came to them the truth from Us, they said, "Indeed, this is obvious magic',
    normalizedText: "فلما جاءهم الحق من عندنا قالوا ان هذا لسحر مبين",
  },
  {
    verseId: 76,
    name: "يونس",
    surahId: 10,
    text: "قَالَ مُوسَىٰٓ أَتَقُولُونَ لِلۡحَقِّ لَمَّا جَآءَكُمۡۖ أَسِحۡرٌ هَٰذَا وَلَا يُفۡلِحُ ٱلسَّـٰحِرُونَ",
    translation:
      'Moses said, "Do you say [thus] about the truth when it has come to you? Is this magic? But magicians will not succeed',
    normalizedText: "قال موسى اتقولون للحق لما جاءكم اسحر هذا ولا يفلح السحرون",
  },
  {
    verseId: 77,
    name: "يونس",
    surahId: 10,
    text: "قَالُوٓاْ أَجِئۡتَنَا لِتَلۡفِتَنَا عَمَّا وَجَدۡنَا عَلَيۡهِ ءَابَآءَنَا وَتَكُونَ لَكُمَا ٱلۡكِبۡرِيَآءُ فِي ٱلۡأَرۡضِ وَمَا نَحۡنُ لَكُمَا بِمُؤۡمِنِينَ",
    translation:
      'They said, "Have you come to us to turn us away from that upon which we found our fathers and so that you two may have grandeur in the land? And we are not believers in you',
    normalizedText:
      "قالوا اجاتنا لتلفتنا عما وجدنا عليه ءاباءنا وتكون لكما الكبرياء في الارض وما نحن لكما بمامنين",
  },
  {
    verseId: 78,
    name: "يونس",
    surahId: 10,
    text: "وَقَالَ فِرۡعَوۡنُ ٱئۡتُونِي بِكُلِّ سَٰحِرٍ عَلِيمٖ",
    translation: 'And Pharaoh said, "Bring to me every learned magician',
    normalizedText: "وقال فرعون ااتوني بكل سحر عليم",
  },
  {
    verseId: 79,
    name: "يونس",
    surahId: 10,
    text: "فَلَمَّا جَآءَ ٱلسَّحَرَةُ قَالَ لَهُم مُّوسَىٰٓ أَلۡقُواْ مَآ أَنتُم مُّلۡقُونَ",
    translation:
      'So when the magicians came, Moses said to them, "Throw down whatever you will throw',
    normalizedText: "فلما جاء السحرة قال لهم موسى القوا ما انتم ملقون",
  },
  {
    verseId: 80,
    name: "يونس",
    surahId: 10,
    text: "فَلَمَّآ أَلۡقَوۡاْ قَالَ مُوسَىٰ مَا جِئۡتُم بِهِ ٱلسِّحۡرُۖ إِنَّ ٱللَّهَ سَيُبۡطِلُهُۥٓ إِنَّ ٱللَّهَ لَا يُصۡلِحُ عَمَلَ ٱلۡمُفۡسِدِينَ",
    translation:
      'And when they had thrown, Moses said, "What you have brought is [only] magic. Indeed, Allah will expose its worthlessness. Indeed, Allah does not amend the work of corrupters',
    normalizedText:
      "فلما القوا قال موسى ما جاتم به السحر ان الله سيبطله ان الله لا يصلح عمل المفسدين",
  },
  {
    verseId: 81,
    name: "يونس",
    surahId: 10,
    text: "وَيُحِقُّ ٱللَّهُ ٱلۡحَقَّ بِكَلِمَٰتِهِۦ وَلَوۡ كَرِهَ ٱلۡمُجۡرِمُونَ",
    translation:
      "And Allah will establish the truth by His words, even if the criminals dislike it",
    normalizedText: "ويحق الله الحق بكلمته ولو كره المجرمون",
  },
  {
    verseId: 82,
    name: "يونس",
    surahId: 10,
    text: "فَمَآ ءَامَنَ لِمُوسَىٰٓ إِلَّا ذُرِّيَّةٞ مِّن قَوۡمِهِۦ عَلَىٰ خَوۡفٖ مِّن فِرۡعَوۡنَ وَمَلَإِيْهِمۡ أَن يَفۡتِنَهُمۡۚ وَإِنَّ فِرۡعَوۡنَ لَعَالٖ فِي ٱلۡأَرۡضِ وَإِنَّهُۥ لَمِنَ ٱلۡمُسۡرِفِينَ",
    translation:
      "But no one believed Moses, except [some] youths among his people, for fear of Pharaoh and his establishment that they would persecute them. And indeed, Pharaoh was haughty within the land, and indeed, he was of the transgressors",
    normalizedText:
      "فما ءامن لموسى الا ذرية من قومه على خوف من فرعون وملايهم ان يفتنهم وان فرعون لعال في الارض وانه لمن المسرفين",
  },
  {
    verseId: 83,
    name: "يونس",
    surahId: 10,
    text: "وَقَالَ مُوسَىٰ يَٰقَوۡمِ إِن كُنتُمۡ ءَامَنتُم بِٱللَّهِ فَعَلَيۡهِ تَوَكَّلُوٓاْ إِن كُنتُم مُّسۡلِمِينَ",
    translation:
      'And Moses said, "O my people, if you have believed in Allah, then rely upon Him, if you should be Muslims',
    normalizedText:
      "وقال موسى يقوم ان كنتم ءامنتم بالله فعليه توكلوا ان كنتم مسلمين",
  },
  {
    verseId: 84,
    name: "يونس",
    surahId: 10,
    text: "فَقَالُواْ عَلَى ٱللَّهِ تَوَكَّلۡنَا رَبَّنَا لَا تَجۡعَلۡنَا فِتۡنَةٗ لِّلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      'So they said, "Upon Allah do we rely. Our Lord, make us not [objects of] trial for the wrongdoing people',
    normalizedText: "فقالوا على الله توكلنا ربنا لا تجعلنا فتنة للقوم الظلمين",
  },
  {
    verseId: 85,
    name: "يونس",
    surahId: 10,
    text: "وَنَجِّنَا بِرَحۡمَتِكَ مِنَ ٱلۡقَوۡمِ ٱلۡكَٰفِرِينَ",
    translation: "And save us by Your mercy from the disbelieving people",
    normalizedText: "ونجنا برحمتك من القوم الكفرين",
  },
  {
    verseId: 86,
    name: "يونس",
    surahId: 10,
    text: "وَأَوۡحَيۡنَآ إِلَىٰ مُوسَىٰ وَأَخِيهِ أَن تَبَوَّءَا لِقَوۡمِكُمَا بِمِصۡرَ بُيُوتٗا وَٱجۡعَلُواْ بُيُوتَكُمۡ قِبۡلَةٗ وَأَقِيمُواْ ٱلصَّلَوٰةَۗ وَبَشِّرِ ٱلۡمُؤۡمِنِينَ",
    translation:
      'And We inspired to Moses and his brother, "Settle your people in Egypt in houses and make your houses [facing the] qiblah and establish prayer and give good tidings to the believers',
    normalizedText:
      "واوحينا الى موسى واخيه ان تبوءا لقومكما بمصر بيوتا واجعلوا بيوتكم قبلة واقيموا الصلوة وبشر المامنين",
  },
  {
    verseId: 87,
    name: "يونس",
    surahId: 10,
    text: "وَقَالَ مُوسَىٰ رَبَّنَآ إِنَّكَ ءَاتَيۡتَ فِرۡعَوۡنَ وَمَلَأَهُۥ زِينَةٗ وَأَمۡوَٰلٗا فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا رَبَّنَا لِيُضِلُّواْ عَن سَبِيلِكَۖ رَبَّنَا ٱطۡمِسۡ عَلَىٰٓ أَمۡوَٰلِهِمۡ وَٱشۡدُدۡ عَلَىٰ قُلُوبِهِمۡ فَلَا يُؤۡمِنُواْ حَتَّىٰ يَرَوُاْ ٱلۡعَذَابَ ٱلۡأَلِيمَ",
    translation:
      'And Moses said, "Our Lord, indeed You have given Pharaoh and his establishment splendor and wealth in the worldly life, our Lord, that they may lead [men] astray from Your way. Our Lord, obliterate their wealth and harden their hearts so that they will not believe until they see the painful punishment',
    normalizedText:
      "وقال موسى ربنا انك ءاتيت فرعون وملاه زينة وامولا في الحيوة الدنيا ربنا ليضلوا عن سبيلك ربنا اطمس على امولهم واشدد على قلوبهم فلا يامنوا حتى يروا العذاب الاليم",
  },
  {
    verseId: 88,
    name: "يونس",
    surahId: 10,
    text: "قَالَ قَدۡ أُجِيبَت دَّعۡوَتُكُمَا فَٱسۡتَقِيمَا وَلَا تَتَّبِعَآنِّ سَبِيلَ ٱلَّذِينَ لَا يَعۡلَمُونَ",
    translation:
      '[Allah] said, "Your supplication has been answered." So remain on a right course and follow not the way of those who do not know',
    normalizedText:
      "قال قد اجيبت دعوتكما فاستقيما ولا تتبعان سبيل الذين لا يعلمون",
  },
  {
    verseId: 89,
    name: "يونس",
    surahId: 10,
    text: "۞وَجَٰوَزۡنَا بِبَنِيٓ إِسۡرَـٰٓءِيلَ ٱلۡبَحۡرَ فَأَتۡبَعَهُمۡ فِرۡعَوۡنُ وَجُنُودُهُۥ بَغۡيٗا وَعَدۡوًاۖ حَتَّىٰٓ إِذَآ أَدۡرَكَهُ ٱلۡغَرَقُ قَالَ ءَامَنتُ أَنَّهُۥ لَآ إِلَٰهَ إِلَّا ٱلَّذِيٓ ءَامَنَتۡ بِهِۦ بَنُوٓاْ إِسۡرَـٰٓءِيلَ وَأَنَا۠ مِنَ ٱلۡمُسۡلِمِينَ",
    translation:
      'And We took the Children of Israel across the sea, and Pharaoh and his soldiers pursued them in tyranny and enmity until, when drowning overtook him, he said, "I believe that there is no deity except that in whom the Children of Israel believe, and I am of the Muslims',
    normalizedText:
      "۞وجوزنا ببني اسرءيل البحر فاتبعهم فرعون وجنوده بغيا وعدوا حتى اذا ادركه الغرق قال ءامنت انه لا اله الا الذي ءامنت به بنوا اسرءيل وانا من المسلمين",
  },
  {
    verseId: 90,
    name: "يونس",
    surahId: 10,
    text: "ءَآلۡـَٰٔنَ وَقَدۡ عَصَيۡتَ قَبۡلُ وَكُنتَ مِنَ ٱلۡمُفۡسِدِينَ",
    translation:
      "Now? And you had disobeyed [Him] before and were of the corrupters",
    normalizedText: "ءالن وقد عصيت قبل وكنت من المفسدين",
  },
  {
    verseId: 91,
    name: "يونس",
    surahId: 10,
    text: "فَٱلۡيَوۡمَ نُنَجِّيكَ بِبَدَنِكَ لِتَكُونَ لِمَنۡ خَلۡفَكَ ءَايَةٗۚ وَإِنَّ كَثِيرٗا مِّنَ ٱلنَّاسِ عَنۡ ءَايَٰتِنَا لَغَٰفِلُونَ",
    translation:
      "So today We will save you in body that you may be to those who succeed you a sign. And indeed, many among the people, of Our signs, are heedless",
    normalizedText:
      "فاليوم ننجيك ببدنك لتكون لمن خلفك ءاية وان كثيرا من الناس عن ءايتنا لغفلون",
  },
  {
    verseId: 92,
    name: "يونس",
    surahId: 10,
    text: "وَلَقَدۡ بَوَّأۡنَا بَنِيٓ إِسۡرَـٰٓءِيلَ مُبَوَّأَ صِدۡقٖ وَرَزَقۡنَٰهُم مِّنَ ٱلطَّيِّبَٰتِ فَمَا ٱخۡتَلَفُواْ حَتَّىٰ جَآءَهُمُ ٱلۡعِلۡمُۚ إِنَّ رَبَّكَ يَقۡضِي بَيۡنَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ فِيمَا كَانُواْ فِيهِ يَخۡتَلِفُونَ",
    translation:
      "And We had certainty settled the Children of Israel in an agreeable settlement and provided them with good things. And they did not differ until [after] knowledge had come to them. Indeed, your Lord will judge between them on the Day of Resurrection concerning that over which they used to differ",
    normalizedText:
      "ولقد بوانا بني اسرءيل مبوا صدق ورزقنهم من الطيبت فما اختلفوا حتى جاءهم العلم ان ربك يقضي بينهم يوم القيمة فيما كانوا فيه يختلفون",
  },
  {
    verseId: 93,
    name: "يونس",
    surahId: 10,
    text: "فَإِن كُنتَ فِي شَكّٖ مِّمَّآ أَنزَلۡنَآ إِلَيۡكَ فَسۡـَٔلِ ٱلَّذِينَ يَقۡرَءُونَ ٱلۡكِتَٰبَ مِن قَبۡلِكَۚ لَقَدۡ جَآءَكَ ٱلۡحَقُّ مِن رَّبِّكَ فَلَا تَكُونَنَّ مِنَ ٱلۡمُمۡتَرِينَ",
    translation:
      "So if you are in doubt, [O Muhammad], about that which We have revealed to you, then ask those who have been reading the Scripture before you. The truth has certainly come to you from your Lord, so never be among the doubters",
    normalizedText:
      "فان كنت في شك مما انزلنا اليك فسل الذين يقرءون الكتب من قبلك لقد جاءك الحق من ربك فلا تكونن من الممترين",
  },
  {
    verseId: 94,
    name: "يونس",
    surahId: 10,
    text: "وَلَا تَكُونَنَّ مِنَ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِ ٱللَّهِ فَتَكُونَ مِنَ ٱلۡخَٰسِرِينَ",
    translation:
      "And never be of those who deny the signs of Allah and [thus] be among the losers",
    normalizedText: "ولا تكونن من الذين كذبوا بايت الله فتكون من الخسرين",
  },
  {
    verseId: 95,
    name: "يونس",
    surahId: 10,
    text: "إِنَّ ٱلَّذِينَ حَقَّتۡ عَلَيۡهِمۡ كَلِمَتُ رَبِّكَ لَا يُؤۡمِنُونَ",
    translation:
      "Indeed, those upon whom the word of your Lord has come into effect will not believe",
    normalizedText: "ان الذين حقت عليهم كلمت ربك لا يامنون",
  },
  {
    verseId: 96,
    name: "يونس",
    surahId: 10,
    text: "وَلَوۡ جَآءَتۡهُمۡ كُلُّ ءَايَةٍ حَتَّىٰ يَرَوُاْ ٱلۡعَذَابَ ٱلۡأَلِيمَ",
    translation:
      "Even if every sign should come to them, until they see the painful punishment",
    normalizedText: "ولو جاءتهم كل ءاية حتى يروا العذاب الاليم",
  },
  {
    verseId: 97,
    name: "يونس",
    surahId: 10,
    text: "فَلَوۡلَا كَانَتۡ قَرۡيَةٌ ءَامَنَتۡ فَنَفَعَهَآ إِيمَٰنُهَآ إِلَّا قَوۡمَ يُونُسَ لَمَّآ ءَامَنُواْ كَشَفۡنَا عَنۡهُمۡ عَذَابَ ٱلۡخِزۡيِ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَمَتَّعۡنَٰهُمۡ إِلَىٰ حِينٖ",
    translation:
      "Then has there not been a [single] city that believed so its faith benefited it except the people of Jonah? When they believed, We removed from them the punishment of disgrace in worldly life and gave them enjoyment for a time",
    normalizedText:
      "فلولا كانت قرية ءامنت فنفعها ايمنها الا قوم يونس لما ءامنوا كشفنا عنهم عذاب الخزي في الحيوة الدنيا ومتعنهم الى حين",
  },
  {
    verseId: 98,
    name: "يونس",
    surahId: 10,
    text: "وَلَوۡ شَآءَ رَبُّكَ لَأٓمَنَ مَن فِي ٱلۡأَرۡضِ كُلُّهُمۡ جَمِيعًاۚ أَفَأَنتَ تُكۡرِهُ ٱلنَّاسَ حَتَّىٰ يَكُونُواْ مُؤۡمِنِينَ",
    translation:
      "And had your Lord willed, those on earth would have believed - all of them entirely. Then, [O Muhammad], would you compel the people in order that they become believers",
    normalizedText:
      "ولو شاء ربك لامن من في الارض كلهم جميعا افانت تكره الناس حتى يكونوا مامنين",
  },
  {
    verseId: 99,
    name: "يونس",
    surahId: 10,
    text: "وَمَا كَانَ لِنَفۡسٍ أَن تُؤۡمِنَ إِلَّا بِإِذۡنِ ٱللَّهِۚ وَيَجۡعَلُ ٱلرِّجۡسَ عَلَى ٱلَّذِينَ لَا يَعۡقِلُونَ",
    translation:
      "And it is not for a soul to believe except by permission of Allah, and He will place defilement upon those who will not use reason",
    normalizedText:
      "وما كان لنفس ان تامن الا باذن الله ويجعل الرجس على الذين لا يعقلون",
  },
  {
    verseId: 100,
    name: "يونس",
    surahId: 10,
    text: "قُلِ ٱنظُرُواْ مَاذَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَمَا تُغۡنِي ٱلۡأٓيَٰتُ وَٱلنُّذُرُ عَن قَوۡمٖ لَّا يُؤۡمِنُونَ",
    translation:
      'Say, "Observe what is in the heavens and earth." But of no avail will be signs or warners to a people who do not believe',
    normalizedText:
      "قل انظروا ماذا في السموت والارض وما تغني الايت والنذر عن قوم لا يامنون",
  },
  {
    verseId: 101,
    name: "يونس",
    surahId: 10,
    text: "فَهَلۡ يَنتَظِرُونَ إِلَّا مِثۡلَ أَيَّامِ ٱلَّذِينَ خَلَوۡاْ مِن قَبۡلِهِمۡۚ قُلۡ فَٱنتَظِرُوٓاْ إِنِّي مَعَكُم مِّنَ ٱلۡمُنتَظِرِينَ",
    translation:
      'So do they wait except for like [what occurred in] the days of those who passed on before them? Say, "Then wait; indeed, I am with you among those who wait',
    normalizedText:
      "فهل ينتظرون الا مثل ايام الذين خلوا من قبلهم قل فانتظروا اني معكم من المنتظرين",
  },
  {
    verseId: 102,
    name: "يونس",
    surahId: 10,
    text: "ثُمَّ نُنَجِّي رُسُلَنَا وَٱلَّذِينَ ءَامَنُواْۚ كَذَٰلِكَ حَقًّا عَلَيۡنَا نُنجِ ٱلۡمُؤۡمِنِينَ",
    translation:
      "Then We will save our messengers and those who have believed. Thus, it is an obligation upon Us that We save the believers",
    normalizedText: "ثم ننجي رسلنا والذين ءامنوا كذلك حقا علينا ننج المامنين",
  },
  {
    verseId: 103,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ يَـٰٓأَيُّهَا ٱلنَّاسُ إِن كُنتُمۡ فِي شَكّٖ مِّن دِينِي فَلَآ أَعۡبُدُ ٱلَّذِينَ تَعۡبُدُونَ مِن دُونِ ٱللَّهِ وَلَٰكِنۡ أَعۡبُدُ ٱللَّهَ ٱلَّذِي يَتَوَفَّىٰكُمۡۖ وَأُمِرۡتُ أَنۡ أَكُونَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      'Say, [O Muhammad], "O people, if you are in doubt as to my religion - then I do not worship those which you worship besides Allah; but I worship Allah, who causes your death. And I have been commanded to be of the believers',
    normalizedText:
      "قل يايها الناس ان كنتم في شك من ديني فلا اعبد الذين تعبدون من دون الله ولكن اعبد الله الذي يتوفىكم وامرت ان اكون من المامنين",
  },
  {
    verseId: 104,
    name: "يونس",
    surahId: 10,
    text: "وَأَنۡ أَقِمۡ وَجۡهَكَ لِلدِّينِ حَنِيفٗا وَلَا تَكُونَنَّ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "And [commanded], 'Direct your face toward the religion, inclining to truth, and never be of those who associate others with Allah",
    normalizedText: "وان اقم وجهك للدين حنيفا ولا تكونن من المشركين",
  },
  {
    verseId: 105,
    name: "يونس",
    surahId: 10,
    text: "وَلَا تَدۡعُ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُكَ وَلَا يَضُرُّكَۖ فَإِن فَعَلۡتَ فَإِنَّكَ إِذٗا مِّنَ ٱلظَّـٰلِمِينَ",
    translation:
      "And do not invoke besides Allah that which neither benefits you nor harms you, for if you did, then indeed you would be of the wrongdoers",
    normalizedText:
      "ولا تدع من دون الله ما لا ينفعك ولا يضرك فان فعلت فانك اذا من الظلمين",
  },
  {
    verseId: 106,
    name: "يونس",
    surahId: 10,
    text: "وَإِن يَمۡسَسۡكَ ٱللَّهُ بِضُرّٖ فَلَا كَاشِفَ لَهُۥٓ إِلَّا هُوَۖ وَإِن يُرِدۡكَ بِخَيۡرٖ فَلَا رَآدَّ لِفَضۡلِهِۦۚ يُصِيبُ بِهِۦ مَن يَشَآءُ مِنۡ عِبَادِهِۦۚ وَهُوَ ٱلۡغَفُورُ ٱلرَّحِيمُ",
    translation:
      "And if Allah should touch you with adversity, there is no remover of it except Him; and if He intends for you good, then there is no repeller of His bounty. He causes it to reach whom He wills of His servants. And He is the Forgiving, the Merciful",
    normalizedText:
      "وان يمسسك الله بضر فلا كاشف له الا هو وان يردك بخير فلا راد لفضله يصيب به من يشاء من عباده وهو الغفور الرحيم",
  },
  {
    verseId: 107,
    name: "يونس",
    surahId: 10,
    text: "قُلۡ يَـٰٓأَيُّهَا ٱلنَّاسُ قَدۡ جَآءَكُمُ ٱلۡحَقُّ مِن رَّبِّكُمۡۖ فَمَنِ ٱهۡتَدَىٰ فَإِنَّمَا يَهۡتَدِي لِنَفۡسِهِۦۖ وَمَن ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيۡهَاۖ وَمَآ أَنَا۠ عَلَيۡكُم بِوَكِيلٖ",
    translation:
      'Say, "O mankind, the truth has come to you from your Lord, so whoever is guided is only guided for [the benefit of] his soul, and whoever goes astray only goes astray [in violation] against it. And I am not over you a manager',
    normalizedText:
      "قل يايها الناس قد جاءكم الحق من ربكم فمن اهتدى فانما يهتدي لنفسه ومن ضل فانما يضل عليها وما انا عليكم بوكيل",
  },
  {
    verseId: 108,
    name: "يونس",
    surahId: 10,
    text: "وَٱتَّبِعۡ مَا يُوحَىٰٓ إِلَيۡكَ وَٱصۡبِرۡ حَتَّىٰ يَحۡكُمَ ٱللَّهُۚ وَهُوَ خَيۡرُ ٱلۡحَٰكِمِينَ",
    translation:
      "And follow what is revealed to you, [O Muhammad], and be patient until Allah will judge. And He is the best of judges",
    normalizedText: "واتبع ما يوحى اليك واصبر حتى يحكم الله وهو خير الحكمين",
  },
  {
    verseId: 0,
    name: "هود",
    surahId: 11,
    text: "الٓرۚ كِتَٰبٌ أُحۡكِمَتۡ ءَايَٰتُهُۥ ثُمَّ فُصِّلَتۡ مِن لَّدُنۡ حَكِيمٍ خَبِيرٍ",
    translation:
      "Alif, Lam, Ra. [This is] a Book whose verses are perfected and then presented in detail from [one who is] Wise and Acquainted",
    normalizedText: "الر كتب احكمت ءايته ثم فصلت من لدن حكيم خبير",
  },
  {
    verseId: 1,
    name: "هود",
    surahId: 11,
    text: "أَلَّا تَعۡبُدُوٓاْ إِلَّا ٱللَّهَۚ إِنَّنِي لَكُم مِّنۡهُ نَذِيرٞ وَبَشِيرٞ",
    translation:
      '[Through a messenger, saying], "Do not worship except Allah. Indeed, I am to you from Him a warner and a bringer of good tidings',
    normalizedText: "الا تعبدوا الا الله انني لكم منه نذير وبشير",
  },
  {
    verseId: 2,
    name: "هود",
    surahId: 11,
    text: "وَأَنِ ٱسۡتَغۡفِرُواْ رَبَّكُمۡ ثُمَّ تُوبُوٓاْ إِلَيۡهِ يُمَتِّعۡكُم مَّتَٰعًا حَسَنًا إِلَىٰٓ أَجَلٖ مُّسَمّٗى وَيُؤۡتِ كُلَّ ذِي فَضۡلٖ فَضۡلَهُۥۖ وَإِن تَوَلَّوۡاْ فَإِنِّيٓ أَخَافُ عَلَيۡكُمۡ عَذَابَ يَوۡمٖ كَبِيرٍ",
    translation:
      'And [saying], "Seek forgiveness of your Lord and repent to Him, [and] He will let you enjoy a good provision for a specified term and give every doer of favor his favor. But if you turn away, then indeed, I fear for you the punishment of a great Day',
    normalizedText:
      "وان استغفروا ربكم ثم توبوا اليه يمتعكم متعا حسنا الى اجل مسمى ويات كل ذي فضل فضله وان تولوا فاني اخاف عليكم عذاب يوم كبير",
  },
  {
    verseId: 3,
    name: "هود",
    surahId: 11,
    text: "إِلَى ٱللَّهِ مَرۡجِعُكُمۡۖ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation: "To Allah is your return, and He is over all things competent",
    normalizedText: "الى الله مرجعكم وهو على كل شيء قدير",
  },
  {
    verseId: 4,
    name: "هود",
    surahId: 11,
    text: "أَلَآ إِنَّهُمۡ يَثۡنُونَ صُدُورَهُمۡ لِيَسۡتَخۡفُواْ مِنۡهُۚ أَلَا حِينَ يَسۡتَغۡشُونَ ثِيَابَهُمۡ يَعۡلَمُ مَا يُسِرُّونَ وَمَا يُعۡلِنُونَۚ إِنَّهُۥ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "Unquestionably, they the disbelievers turn away their breasts to hide themselves from Him. Unquestionably, [even] when they cover themselves in their clothing, Allah knows what they conceal and what they declare. Indeed, He is Knowing of that within the breasts",
    normalizedText:
      "الا انهم يثنون صدورهم ليستخفوا منه الا حين يستغشون ثيابهم يعلم ما يسرون وما يعلنون انه عليم بذات الصدور",
  },
  {
    verseId: 5,
    name: "هود",
    surahId: 11,
    text: "۞وَمَا مِن دَآبَّةٖ فِي ٱلۡأَرۡضِ إِلَّا عَلَى ٱللَّهِ رِزۡقُهَا وَيَعۡلَمُ مُسۡتَقَرَّهَا وَمُسۡتَوۡدَعَهَاۚ كُلّٞ فِي كِتَٰبٖ مُّبِينٖ",
    translation:
      "And there is no creature on earth but that upon Allah is its provision, and He knows its place of dwelling and place of storage. All is in a clear register",
    normalizedText:
      "۞وما من دابة في الارض الا على الله رزقها ويعلم مستقرها ومستودعها كل في كتب مبين",
  },
  {
    verseId: 6,
    name: "هود",
    surahId: 11,
    text: "وَهُوَ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ فِي سِتَّةِ أَيَّامٖ وَكَانَ عَرۡشُهُۥ عَلَى ٱلۡمَآءِ لِيَبۡلُوَكُمۡ أَيُّكُمۡ أَحۡسَنُ عَمَلٗاۗ وَلَئِن قُلۡتَ إِنَّكُم مَّبۡعُوثُونَ مِنۢ بَعۡدِ ٱلۡمَوۡتِ لَيَقُولَنَّ ٱلَّذِينَ كَفَرُوٓاْ إِنۡ هَٰذَآ إِلَّا سِحۡرٞ مُّبِينٞ",
    translation:
      'And it is He who created the heavens and the earth in six days - and His Throne had been upon water - that He might test you as to which of you is best in deed. But if you say, "Indeed, you are resurrected after death," those who disbelieve will surely say, "This is not but obvious magic',
    normalizedText:
      "وهو الذي خلق السموت والارض في ستة ايام وكان عرشه على الماء ليبلوكم ايكم احسن عملا ولان قلت انكم مبعوثون من بعد الموت ليقولن الذين كفروا ان هذا الا سحر مبين",
  },
  {
    verseId: 7,
    name: "هود",
    surahId: 11,
    text: "وَلَئِنۡ أَخَّرۡنَا عَنۡهُمُ ٱلۡعَذَابَ إِلَىٰٓ أُمَّةٖ مَّعۡدُودَةٖ لَّيَقُولُنَّ مَا يَحۡبِسُهُۥٓۗ أَلَا يَوۡمَ يَأۡتِيهِمۡ لَيۡسَ مَصۡرُوفًا عَنۡهُمۡ وَحَاقَ بِهِم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      'And if We hold back from them the punishment for a limited time, they will surely say, "What detains it?" Unquestionably, on the Day it comes to them, it will not be averted from them, and they will be enveloped by what they used to ridicule',
    normalizedText:
      "ولان اخرنا عنهم العذاب الى امة معدودة ليقولن ما يحبسه الا يوم ياتيهم ليس مصروفا عنهم وحاق بهم ما كانوا به يستهزءون",
  },
  {
    verseId: 8,
    name: "هود",
    surahId: 11,
    text: "وَلَئِنۡ أَذَقۡنَا ٱلۡإِنسَٰنَ مِنَّا رَحۡمَةٗ ثُمَّ نَزَعۡنَٰهَا مِنۡهُ إِنَّهُۥ لَيَـُٔوسٞ كَفُورٞ",
    translation:
      "And if We give man a taste of mercy from Us and then We withdraw it from him, indeed, he is despairing and ungrateful",
    normalizedText: "ولان اذقنا الانسن منا رحمة ثم نزعنها منه انه ليوس كفور",
  },
  {
    verseId: 9,
    name: "هود",
    surahId: 11,
    text: "وَلَئِنۡ أَذَقۡنَٰهُ نَعۡمَآءَ بَعۡدَ ضَرَّآءَ مَسَّتۡهُ لَيَقُولَنَّ ذَهَبَ ٱلسَّيِّـَٔاتُ عَنِّيٓۚ إِنَّهُۥ لَفَرِحٞ فَخُورٌ",
    translation:
      'But if We give him a taste of favor after hardship has touched him, he will surely say, "Bad times have left me." Indeed, he is exultant and boastful',
    normalizedText:
      "ولان اذقنه نعماء بعد ضراء مسته ليقولن ذهب السيات عني انه لفرح فخور",
  },
  {
    verseId: 10,
    name: "هود",
    surahId: 11,
    text: "إِلَّا ٱلَّذِينَ صَبَرُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ أُوْلَـٰٓئِكَ لَهُم مَّغۡفِرَةٞ وَأَجۡرٞ كَبِيرٞ",
    translation:
      "Except for those who are patient and do righteous deeds; those will have forgiveness and great reward",
    normalizedText: "الا الذين صبروا وعملوا الصلحت اولاك لهم مغفرة واجر كبير",
  },
  {
    verseId: 11,
    name: "هود",
    surahId: 11,
    text: "فَلَعَلَّكَ تَارِكُۢ بَعۡضَ مَا يُوحَىٰٓ إِلَيۡكَ وَضَآئِقُۢ بِهِۦ صَدۡرُكَ أَن يَقُولُواْ لَوۡلَآ أُنزِلَ عَلَيۡهِ كَنزٌ أَوۡ جَآءَ مَعَهُۥ مَلَكٌۚ إِنَّمَآ أَنتَ نَذِيرٞۚ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ وَكِيلٌ",
    translation:
      'Then would you possibly leave [out] some of what is revealed to you, or is your breast constrained by it because they say, "Why has there not been sent down to him a treasure or come with him an angel?" But you are only a warner. And Allah is Disposer of all things',
    normalizedText:
      "فلعلك تارك بعض ما يوحى اليك وضااق به صدرك ان يقولوا لولا انزل عليه كنز او جاء معه ملك انما انت نذير والله على كل شيء وكيل",
  },
  {
    verseId: 12,
    name: "هود",
    surahId: 11,
    text: "أَمۡ يَقُولُونَ ٱفۡتَرَىٰهُۖ قُلۡ فَأۡتُواْ بِعَشۡرِ سُوَرٖ مِّثۡلِهِۦ مُفۡتَرَيَٰتٖ وَٱدۡعُواْ مَنِ ٱسۡتَطَعۡتُم مِّن دُونِ ٱللَّهِ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Or do they say, "He invented it"? Say, "Then bring ten surahs like it that have been invented and call upon [for assistance] whomever you can besides Allah, if you should be truthful',
    normalizedText:
      "ام يقولون افترىه قل فاتوا بعشر سور مثله مفتريت وادعوا من استطعتم من دون الله ان كنتم صدقين",
  },
  {
    verseId: 13,
    name: "هود",
    surahId: 11,
    text: "فَإِلَّمۡ يَسۡتَجِيبُواْ لَكُمۡ فَٱعۡلَمُوٓاْ أَنَّمَآ أُنزِلَ بِعِلۡمِ ٱللَّهِ وَأَن لَّآ إِلَٰهَ إِلَّا هُوَۖ فَهَلۡ أَنتُم مُّسۡلِمُونَ",
    translation:
      "And if they do not respond to you - then know that the Qur'an was revealed with the knowledge of Allah and that there is no deity except Him. Then, would you [not] be Muslims",
    normalizedText:
      "فالم يستجيبوا لكم فاعلموا انما انزل بعلم الله وان لا اله الا هو فهل انتم مسلمون",
  },
  {
    verseId: 14,
    name: "هود",
    surahId: 11,
    text: "مَن كَانَ يُرِيدُ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا وَزِينَتَهَا نُوَفِّ إِلَيۡهِمۡ أَعۡمَٰلَهُمۡ فِيهَا وَهُمۡ فِيهَا لَا يُبۡخَسُونَ",
    translation:
      "Whoever desires the life of this world and its adornments - We fully repay them for their deeds therein, and they therein will not be deprived",
    normalizedText:
      "من كان يريد الحيوة الدنيا وزينتها نوف اليهم اعملهم فيها وهم فيها لا يبخسون",
  },
  {
    verseId: 15,
    name: "هود",
    surahId: 11,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ لَيۡسَ لَهُمۡ فِي ٱلۡأٓخِرَةِ إِلَّا ٱلنَّارُۖ وَحَبِطَ مَا صَنَعُواْ فِيهَا وَبَٰطِلٞ مَّا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Those are the ones for whom there is not in the Hereafter but the Fire. And lost is what they did therein, and worthless is what they used to do",
    normalizedText:
      "اولاك الذين ليس لهم في الاخرة الا النار وحبط ما صنعوا فيها وبطل ما كانوا يعملون",
  },
  {
    verseId: 16,
    name: "هود",
    surahId: 11,
    text: "أَفَمَن كَانَ عَلَىٰ بَيِّنَةٖ مِّن رَّبِّهِۦ وَيَتۡلُوهُ شَاهِدٞ مِّنۡهُ وَمِن قَبۡلِهِۦ كِتَٰبُ مُوسَىٰٓ إِمَامٗا وَرَحۡمَةًۚ أُوْلَـٰٓئِكَ يُؤۡمِنُونَ بِهِۦۚ وَمَن يَكۡفُرۡ بِهِۦ مِنَ ٱلۡأَحۡزَابِ فَٱلنَّارُ مَوۡعِدُهُۥۚ فَلَا تَكُ فِي مِرۡيَةٖ مِّنۡهُۚ إِنَّهُ ٱلۡحَقُّ مِن رَّبِّكَ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يُؤۡمِنُونَ",
    translation:
      "So is one who [stands] upon a clear evidence from his Lord [like the aforementioned]? And a witness from Him follows it, and before it was the Scripture of Moses to lead and as mercy. Those [believers in the former revelations] believe in the Qur'an. But whoever disbelieves in it from the [various] factions - the Fire is his promised destination. So be not in doubt about it. Indeed, it is the truth from your Lord, but most of the people do not believe",
    normalizedText:
      "افمن كان على بينة من ربه ويتلوه شاهد منه ومن قبله كتب موسى اماما ورحمة اولاك يامنون به ومن يكفر به من الاحزاب فالنار موعده فلا تك في مرية منه انه الحق من ربك ولكن اكثر الناس لا يامنون",
  },
  {
    verseId: 17,
    name: "هود",
    surahId: 11,
    text: "وَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبًاۚ أُوْلَـٰٓئِكَ يُعۡرَضُونَ عَلَىٰ رَبِّهِمۡ وَيَقُولُ ٱلۡأَشۡهَٰدُ هَـٰٓؤُلَآءِ ٱلَّذِينَ كَذَبُواْ عَلَىٰ رَبِّهِمۡۚ أَلَا لَعۡنَةُ ٱللَّهِ عَلَى ٱلظَّـٰلِمِينَ",
    translation:
      'And who is more unjust than he who invents a lie about Allah? Those will be presented before their Lord, and the witnesses will say, "These are the ones who lied against their Lord." Unquestionably, the curse of Allah is upon the wrongdoers',
    normalizedText:
      "ومن اظلم ممن افترى على الله كذبا اولاك يعرضون على ربهم ويقول الاشهد هالاء الذين كذبوا على ربهم الا لعنة الله على الظلمين",
  },
  {
    verseId: 18,
    name: "هود",
    surahId: 11,
    text: "ٱلَّذِينَ يَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَيَبۡغُونَهَا عِوَجٗا وَهُم بِٱلۡأٓخِرَةِ هُمۡ كَٰفِرُونَ",
    translation:
      "Who averted [people] from the way of Allah and sought to make it [seem] deviant while they, concerning the Hereafter, were disbelievers",
    normalizedText:
      "الذين يصدون عن سبيل الله ويبغونها عوجا وهم بالاخرة هم كفرون",
  },
  {
    verseId: 19,
    name: "هود",
    surahId: 11,
    text: "أُوْلَـٰٓئِكَ لَمۡ يَكُونُواْ مُعۡجِزِينَ فِي ٱلۡأَرۡضِ وَمَا كَانَ لَهُم مِّن دُونِ ٱللَّهِ مِنۡ أَوۡلِيَآءَۘ يُضَٰعَفُ لَهُمُ ٱلۡعَذَابُۚ مَا كَانُواْ يَسۡتَطِيعُونَ ٱلسَّمۡعَ وَمَا كَانُواْ يُبۡصِرُونَ",
    translation:
      "Those were not causing failure [to Allah] on earth, nor did they have besides Allah any protectors. For them the punishment will be multiplied. They were not able to hear, nor did they see",
    normalizedText:
      "اولاك لم يكونوا معجزين في الارض وما كان لهم من دون الله من اولياء يضعف لهم العذاب ما كانوا يستطيعون السمع وما كانوا يبصرون",
  },
  {
    verseId: 20,
    name: "هود",
    surahId: 11,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ خَسِرُوٓاْ أَنفُسَهُمۡ وَضَلَّ عَنۡهُم مَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      "Those are the ones who will have lost themselves, and lost from them is what they used to invent",
    normalizedText: "اولاك الذين خسروا انفسهم وضل عنهم ما كانوا يفترون",
  },
  {
    verseId: 21,
    name: "هود",
    surahId: 11,
    text: "لَا جَرَمَ أَنَّهُمۡ فِي ٱلۡأٓخِرَةِ هُمُ ٱلۡأَخۡسَرُونَ",
    translation:
      "Assuredly, it is they in the Hereafter who will be the greatest losers",
    normalizedText: "لا جرم انهم في الاخرة هم الاخسرون",
  },
  {
    verseId: 22,
    name: "هود",
    surahId: 11,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَأَخۡبَتُوٓاْ إِلَىٰ رَبِّهِمۡ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَنَّةِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "Indeed, they who have believed and done righteous deeds and humbled themselves to their Lord - those are the companions of Paradise; they will abide eternally therein",
    normalizedText:
      "ان الذين ءامنوا وعملوا الصلحت واخبتوا الى ربهم اولاك اصحب الجنة هم فيها خلدون",
  },
  {
    verseId: 23,
    name: "هود",
    surahId: 11,
    text: "۞مَثَلُ ٱلۡفَرِيقَيۡنِ كَٱلۡأَعۡمَىٰ وَٱلۡأَصَمِّ وَٱلۡبَصِيرِ وَٱلسَّمِيعِۚ هَلۡ يَسۡتَوِيَانِ مَثَلًاۚ أَفَلَا تَذَكَّرُونَ",
    translation:
      "The example of the two parties is like the blind and deaf, and the seeing and hearing. Are they equal in comparison? Then, will you not remember",
    normalizedText:
      "۞مثل الفريقين كالاعمى والاصم والبصير والسميع هل يستويان مثلا افلا تذكرون",
  },
  {
    verseId: 24,
    name: "هود",
    surahId: 11,
    text: "وَلَقَدۡ أَرۡسَلۡنَا نُوحًا إِلَىٰ قَوۡمِهِۦٓ إِنِّي لَكُمۡ نَذِيرٞ مُّبِينٌ",
    translation:
      'And We had certainly sent Noah to his people, [saying], "Indeed, I am to you a clear warner',
    normalizedText: "ولقد ارسلنا نوحا الى قومه اني لكم نذير مبين",
  },
  {
    verseId: 25,
    name: "هود",
    surahId: 11,
    text: "أَن لَّا تَعۡبُدُوٓاْ إِلَّا ٱللَّهَۖ إِنِّيٓ أَخَافُ عَلَيۡكُمۡ عَذَابَ يَوۡمٍ أَلِيمٖ",
    translation:
      "That you not worship except Allah. Indeed, I fear for you the punishment of a painful day",
    normalizedText: "ان لا تعبدوا الا الله اني اخاف عليكم عذاب يوم اليم",
  },
  {
    verseId: 26,
    name: "هود",
    surahId: 11,
    text: "فَقَالَ ٱلۡمَلَأُ ٱلَّذِينَ كَفَرُواْ مِن قَوۡمِهِۦ مَا نَرَىٰكَ إِلَّا بَشَرٗا مِّثۡلَنَا وَمَا نَرَىٰكَ ٱتَّبَعَكَ إِلَّا ٱلَّذِينَ هُمۡ أَرَاذِلُنَا بَادِيَ ٱلرَّأۡيِ وَمَا نَرَىٰ لَكُمۡ عَلَيۡنَا مِن فَضۡلِۭ بَلۡ نَظُنُّكُمۡ كَٰذِبِينَ",
    translation:
      'So the eminent among those who disbelieved from his people said, "We do not see you but as a man like ourselves, and we do not see you followed except by those who are the lowest of us [and] at first suggestion. And we do not see in you over us any merit; rather, we think you are liars',
    normalizedText:
      "فقال الملا الذين كفروا من قومه ما نرىك الا بشرا مثلنا وما نرىك اتبعك الا الذين هم اراذلنا بادي الراي وما نرى لكم علينا من فضل بل نظنكم كذبين",
  },
  {
    verseId: 27,
    name: "هود",
    surahId: 11,
    text: "قَالَ يَٰقَوۡمِ أَرَءَيۡتُمۡ إِن كُنتُ عَلَىٰ بَيِّنَةٖ مِّن رَّبِّي وَءَاتَىٰنِي رَحۡمَةٗ مِّنۡ عِندِهِۦ فَعُمِّيَتۡ عَلَيۡكُمۡ أَنُلۡزِمُكُمُوهَا وَأَنتُمۡ لَهَا كَٰرِهُونَ",
    translation:
      'He said, "O my people have you considered: if I should be upon clear evidence from my Lord while He has given me mercy from Himself but it has been made unapparent to you, should we force it upon you while you are averse to it',
    normalizedText:
      "قال يقوم ارءيتم ان كنت على بينة من ربي وءاتىني رحمة من عنده فعميت عليكم انلزمكموها وانتم لها كرهون",
  },
  {
    verseId: 28,
    name: "هود",
    surahId: 11,
    text: "وَيَٰقَوۡمِ لَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مَالًاۖ إِنۡ أَجۡرِيَ إِلَّا عَلَى ٱللَّهِۚ وَمَآ أَنَا۠ بِطَارِدِ ٱلَّذِينَ ءَامَنُوٓاْۚ إِنَّهُم مُّلَٰقُواْ رَبِّهِمۡ وَلَٰكِنِّيٓ أَرَىٰكُمۡ قَوۡمٗا تَجۡهَلُونَ",
    translation:
      "And O my people, I ask not of you for it any wealth. My reward is not but from Allah. And I am not one to drive away those who have believed. Indeed, they will meet their Lord, but I see that you are a people behaving ignorantly",
    normalizedText:
      "ويقوم لا اسلكم عليه مالا ان اجري الا على الله وما انا بطارد الذين ءامنوا انهم ملقوا ربهم ولكني ارىكم قوما تجهلون",
  },
  {
    verseId: 29,
    name: "هود",
    surahId: 11,
    text: "وَيَٰقَوۡمِ مَن يَنصُرُنِي مِنَ ٱللَّهِ إِن طَرَدتُّهُمۡۚ أَفَلَا تَذَكَّرُونَ",
    translation:
      "And O my people, who would protect me from Allah if I drove them away? Then will you not be reminded",
    normalizedText: "ويقوم من ينصرني من الله ان طردتهم افلا تذكرون",
  },
  {
    verseId: 30,
    name: "هود",
    surahId: 11,
    text: "وَلَآ أَقُولُ لَكُمۡ عِندِي خَزَآئِنُ ٱللَّهِ وَلَآ أَعۡلَمُ ٱلۡغَيۡبَ وَلَآ أَقُولُ إِنِّي مَلَكٞ وَلَآ أَقُولُ لِلَّذِينَ تَزۡدَرِيٓ أَعۡيُنُكُمۡ لَن يُؤۡتِيَهُمُ ٱللَّهُ خَيۡرًاۖ ٱللَّهُ أَعۡلَمُ بِمَا فِيٓ أَنفُسِهِمۡ إِنِّيٓ إِذٗا لَّمِنَ ٱلظَّـٰلِمِينَ",
    translation:
      "And I do not tell you that I have the depositories [containing the provision] of Allah or that I know the unseen, nor do I tell you that I am an angel, nor do I say of those upon whom your eyes look down that Allah will never grant them any good. Allah is most knowing of what is within their souls. Indeed, I would then be among the wrongdoers",
    normalizedText:
      "ولا اقول لكم عندي خزاان الله ولا اعلم الغيب ولا اقول اني ملك ولا اقول للذين تزدري اعينكم لن ياتيهم الله خيرا الله اعلم بما في انفسهم اني اذا لمن الظلمين",
  },
  {
    verseId: 31,
    name: "هود",
    surahId: 11,
    text: "قَالُواْ يَٰنُوحُ قَدۡ جَٰدَلۡتَنَا فَأَكۡثَرۡتَ جِدَٰلَنَا فَأۡتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      'They said, "O Noah, you have disputed us and been frequent in dispute of us. So bring us what you threaten us, if you should be of the truthful',
    normalizedText:
      "قالوا ينوح قد جدلتنا فاكثرت جدلنا فاتنا بما تعدنا ان كنت من الصدقين",
  },
  {
    verseId: 32,
    name: "هود",
    surahId: 11,
    text: "قَالَ إِنَّمَا يَأۡتِيكُم بِهِ ٱللَّهُ إِن شَآءَ وَمَآ أَنتُم بِمُعۡجِزِينَ",
    translation:
      'He said, "Allah will only bring it to you if He wills, and you will not cause [Him] failure',
    normalizedText: "قال انما ياتيكم به الله ان شاء وما انتم بمعجزين",
  },
  {
    verseId: 33,
    name: "هود",
    surahId: 11,
    text: "وَلَا يَنفَعُكُمۡ نُصۡحِيٓ إِنۡ أَرَدتُّ أَنۡ أَنصَحَ لَكُمۡ إِن كَانَ ٱللَّهُ يُرِيدُ أَن يُغۡوِيَكُمۡۚ هُوَ رَبُّكُمۡ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "And my advice will not benefit you - although I wished to advise you - If Allah should intend to put you in error. He is your Lord, and to Him you will be returned",
    normalizedText:
      "ولا ينفعكم نصحي ان اردت ان انصح لكم ان كان الله يريد ان يغويكم هو ربكم واليه ترجعون",
  },
  {
    verseId: 34,
    name: "هود",
    surahId: 11,
    text: "أَمۡ يَقُولُونَ ٱفۡتَرَىٰهُۖ قُلۡ إِنِ ٱفۡتَرَيۡتُهُۥ فَعَلَيَّ إِجۡرَامِي وَأَنَا۠ بَرِيٓءٞ مِّمَّا تُجۡرِمُونَ",
    translation:
      'Or do they say [about Prophet Muhammad], "He invented it"? Say, "If I have invented it, then upon me is [the consequence of] my crime; but I am innocent of what [crimes] you commit',
    normalizedText:
      "ام يقولون افترىه قل ان افتريته فعلي اجرامي وانا بريء مما تجرمون",
  },
  {
    verseId: 35,
    name: "هود",
    surahId: 11,
    text: "وَأُوحِيَ إِلَىٰ نُوحٍ أَنَّهُۥ لَن يُؤۡمِنَ مِن قَوۡمِكَ إِلَّا مَن قَدۡ ءَامَنَ فَلَا تَبۡتَئِسۡ بِمَا كَانُواْ يَفۡعَلُونَ",
    translation:
      'And it was revealed to Noah that, "No one will believe from your people except those who have already believed, so do not be distressed by what they have been doing',
    normalizedText:
      "واوحي الى نوح انه لن يامن من قومك الا من قد ءامن فلا تبتاس بما كانوا يفعلون",
  },
  {
    verseId: 36,
    name: "هود",
    surahId: 11,
    text: "وَٱصۡنَعِ ٱلۡفُلۡكَ بِأَعۡيُنِنَا وَوَحۡيِنَا وَلَا تُخَٰطِبۡنِي فِي ٱلَّذِينَ ظَلَمُوٓاْ إِنَّهُم مُّغۡرَقُونَ",
    translation:
      "And construct the ship under Our observation and Our inspiration and do not address Me concerning those who have wronged; indeed, they are [to be] drowned",
    normalizedText:
      "واصنع الفلك باعيننا ووحينا ولا تخطبني في الذين ظلموا انهم مغرقون",
  },
  {
    verseId: 37,
    name: "هود",
    surahId: 11,
    text: "وَيَصۡنَعُ ٱلۡفُلۡكَ وَكُلَّمَا مَرَّ عَلَيۡهِ مَلَأٞ مِّن قَوۡمِهِۦ سَخِرُواْ مِنۡهُۚ قَالَ إِن تَسۡخَرُواْ مِنَّا فَإِنَّا نَسۡخَرُ مِنكُمۡ كَمَا تَسۡخَرُونَ",
    translation:
      'And he constructed the ship, and whenever an assembly of the eminent of his people passed by him, they ridiculed him. He said, "If you ridicule us, then we will ridicule you just as you ridicule',
    normalizedText:
      "ويصنع الفلك وكلما مر عليه ملا من قومه سخروا منه قال ان تسخروا منا فانا نسخر منكم كما تسخرون",
  },
  {
    verseId: 38,
    name: "هود",
    surahId: 11,
    text: "فَسَوۡفَ تَعۡلَمُونَ مَن يَأۡتِيهِ عَذَابٞ يُخۡزِيهِ وَيَحِلُّ عَلَيۡهِ عَذَابٞ مُّقِيمٌ",
    translation:
      "And you are going to know who will get a punishment that will disgrace him [on earth] and upon whom will descend an enduring punishment [in the Hereafter]",
    normalizedText: "فسوف تعلمون من ياتيه عذاب يخزيه ويحل عليه عذاب مقيم",
  },
  {
    verseId: 39,
    name: "هود",
    surahId: 11,
    text: "حَتَّىٰٓ إِذَا جَآءَ أَمۡرُنَا وَفَارَ ٱلتَّنُّورُ قُلۡنَا ٱحۡمِلۡ فِيهَا مِن كُلّٖ زَوۡجَيۡنِ ٱثۡنَيۡنِ وَأَهۡلَكَ إِلَّا مَن سَبَقَ عَلَيۡهِ ٱلۡقَوۡلُ وَمَنۡ ءَامَنَۚ وَمَآ ءَامَنَ مَعَهُۥٓ إِلَّا قَلِيلٞ",
    translation:
      '[So it was], until when Our command came and the oven overflowed, We said, "Load upon the ship of each [creature] two mates and your family, except those about whom the word has preceded, and [include] whoever has believed." But none had believed with him, except a few',
    normalizedText:
      "حتى اذا جاء امرنا وفار التنور قلنا احمل فيها من كل زوجين اثنين واهلك الا من سبق عليه القول ومن ءامن وما ءامن معه الا قليل",
  },
  {
    verseId: 40,
    name: "هود",
    surahId: 11,
    text: "۞وَقَالَ ٱرۡكَبُواْ فِيهَا بِسۡمِ ٱللَّهِ مَجۡرٜىٰهَا وَمُرۡسَىٰهَآۚ إِنَّ رَبِّي لَغَفُورٞ رَّحِيمٞ",
    translation:
      'And [Noah] said, "Embark therein; in the name of Allah is its course and its anchorage. Indeed, my Lord is Forgiving and Merciful',
    normalizedText:
      "۞وقال اركبوا فيها بسم الله مجرىها ومرسىها ان ربي لغفور رحيم",
  },
  {
    verseId: 41,
    name: "هود",
    surahId: 11,
    text: "وَهِيَ تَجۡرِي بِهِمۡ فِي مَوۡجٖ كَٱلۡجِبَالِ وَنَادَىٰ نُوحٌ ٱبۡنَهُۥ وَكَانَ فِي مَعۡزِلٖ يَٰبُنَيَّ ٱرۡكَب مَّعَنَا وَلَا تَكُن مَّعَ ٱلۡكَٰفِرِينَ",
    translation:
      'And it sailed with them through waves like mountains, and Noah called to his son who was apart [from them], "O my son, come aboard with us and be not with the disbelievers',
    normalizedText:
      "وهي تجري بهم في موج كالجبال ونادى نوح ابنه وكان في معزل يبني اركب معنا ولا تكن مع الكفرين",
  },
  {
    verseId: 42,
    name: "هود",
    surahId: 11,
    text: "قَالَ سَـَٔاوِيٓ إِلَىٰ جَبَلٖ يَعۡصِمُنِي مِنَ ٱلۡمَآءِۚ قَالَ لَا عَاصِمَ ٱلۡيَوۡمَ مِنۡ أَمۡرِ ٱللَّهِ إِلَّا مَن رَّحِمَۚ وَحَالَ بَيۡنَهُمَا ٱلۡمَوۡجُ فَكَانَ مِنَ ٱلۡمُغۡرَقِينَ",
    translation:
      '[But] he said, "I will take refuge on a mountain to protect me from the water." [Noah] said, "There is no protector today from the decree of Allah, except for whom He gives mercy." And the waves came between them, and he was among the drowned',
    normalizedText:
      "قال ساوي الى جبل يعصمني من الماء قال لا عاصم اليوم من امر الله الا من رحم وحال بينهما الموج فكان من المغرقين",
  },
  {
    verseId: 43,
    name: "هود",
    surahId: 11,
    text: "وَقِيلَ يَـٰٓأَرۡضُ ٱبۡلَعِي مَآءَكِ وَيَٰسَمَآءُ أَقۡلِعِي وَغِيضَ ٱلۡمَآءُ وَقُضِيَ ٱلۡأَمۡرُ وَٱسۡتَوَتۡ عَلَى ٱلۡجُودِيِّۖ وَقِيلَ بُعۡدٗا لِّلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      'And it was said, "O earth, swallow your water, and O sky, withhold [your rain]." And the water subsided, and the matter was accomplished, and the ship came to rest on the [mountain of] Judiyy. And it was said, "Away with the wrongdoing people',
    normalizedText:
      "وقيل يارض ابلعي ماءك ويسماء اقلعي وغيض الماء وقضي الامر واستوت على الجودي وقيل بعدا للقوم الظلمين",
  },
  {
    verseId: 44,
    name: "هود",
    surahId: 11,
    text: "وَنَادَىٰ نُوحٞ رَّبَّهُۥ فَقَالَ رَبِّ إِنَّ ٱبۡنِي مِنۡ أَهۡلِي وَإِنَّ وَعۡدَكَ ٱلۡحَقُّ وَأَنتَ أَحۡكَمُ ٱلۡحَٰكِمِينَ",
    translation:
      'And Noah called to his Lord and said, "My Lord, indeed my son is of my family; and indeed, Your promise is true; and You are the most just of judges',
    normalizedText:
      "ونادى نوح ربه فقال رب ان ابني من اهلي وان وعدك الحق وانت احكم الحكمين",
  },
  {
    verseId: 45,
    name: "هود",
    surahId: 11,
    text: "قَالَ يَٰنُوحُ إِنَّهُۥ لَيۡسَ مِنۡ أَهۡلِكَۖ إِنَّهُۥ عَمَلٌ غَيۡرُ صَٰلِحٖۖ فَلَا تَسۡـَٔلۡنِ مَا لَيۡسَ لَكَ بِهِۦ عِلۡمٌۖ إِنِّيٓ أَعِظُكَ أَن تَكُونَ مِنَ ٱلۡجَٰهِلِينَ",
    translation:
      'He said, "O Noah, indeed he is not of your family; indeed, he is [one whose] work was other than righteous, so ask Me not for that about which you have no knowledge. Indeed, I advise you, lest you be among the ignorant',
    normalizedText:
      "قال ينوح انه ليس من اهلك انه عمل غير صلح فلا تسلن ما ليس لك به علم اني اعظك ان تكون من الجهلين",
  },
  {
    verseId: 46,
    name: "هود",
    surahId: 11,
    text: "قَالَ رَبِّ إِنِّيٓ أَعُوذُ بِكَ أَنۡ أَسۡـَٔلَكَ مَا لَيۡسَ لِي بِهِۦ عِلۡمٞۖ وَإِلَّا تَغۡفِرۡ لِي وَتَرۡحَمۡنِيٓ أَكُن مِّنَ ٱلۡخَٰسِرِينَ",
    translation:
      '[Noah] said, "My Lord, I seek refuge in You from asking that of which I have no knowledge. And unless You forgive me and have mercy upon me, I will be among the losers',
    normalizedText:
      "قال رب اني اعوذ بك ان اسلك ما ليس لي به علم والا تغفر لي وترحمني اكن من الخسرين",
  },
  {
    verseId: 47,
    name: "هود",
    surahId: 11,
    text: "قِيلَ يَٰنُوحُ ٱهۡبِطۡ بِسَلَٰمٖ مِّنَّا وَبَرَكَٰتٍ عَلَيۡكَ وَعَلَىٰٓ أُمَمٖ مِّمَّن مَّعَكَۚ وَأُمَمٞ سَنُمَتِّعُهُمۡ ثُمَّ يَمَسُّهُم مِّنَّا عَذَابٌ أَلِيمٞ",
    translation:
      'It was said, "O Noah, disembark in security from Us and blessings upon you and upon nations [descending] from those with you. But other nations [of them] We will grant enjoyment; then there will touch them from Us a painful punishment',
    normalizedText:
      "قيل ينوح اهبط بسلم منا وبركت عليك وعلى امم ممن معك وامم سنمتعهم ثم يمسهم منا عذاب اليم",
  },
  {
    verseId: 48,
    name: "هود",
    surahId: 11,
    text: "تِلۡكَ مِنۡ أَنۢبَآءِ ٱلۡغَيۡبِ نُوحِيهَآ إِلَيۡكَۖ مَا كُنتَ تَعۡلَمُهَآ أَنتَ وَلَا قَوۡمُكَ مِن قَبۡلِ هَٰذَاۖ فَٱصۡبِرۡۖ إِنَّ ٱلۡعَٰقِبَةَ لِلۡمُتَّقِينَ",
    translation:
      "That is from the news of the unseen which We reveal to you, [O Muhammad]. You knew it not, neither you nor your people, before this. So be patient; indeed, the [best] outcome is for the righteous",
    normalizedText:
      "تلك من انباء الغيب نوحيها اليك ما كنت تعلمها انت ولا قومك من قبل هذا فاصبر ان العقبة للمتقين",
  },
  {
    verseId: 49,
    name: "هود",
    surahId: 11,
    text: "وَإِلَىٰ عَادٍ أَخَاهُمۡ هُودٗاۚ قَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥٓۖ إِنۡ أَنتُمۡ إِلَّا مُفۡتَرُونَ",
    translation: `And to 'Aad [We sent] their brother Hud. He said, "O my people, worship Allah; you have no deity other than Him. You are not but inventors [of falsehood]`,
    normalizedText:
      "والى عاد اخاهم هودا قال يقوم اعبدوا الله ما لكم من اله غيره ان انتم الا مفترون",
  },
  {
    verseId: 50,
    name: "هود",
    surahId: 11,
    text: "يَٰقَوۡمِ لَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ أَجۡرًاۖ إِنۡ أَجۡرِيَ إِلَّا عَلَى ٱلَّذِي فَطَرَنِيٓۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "O my people, I do not ask you for it any reward. My reward is only from the one who created me. Then will you not reason",
    normalizedText:
      "يقوم لا اسلكم عليه اجرا ان اجري الا على الذي فطرني افلا تعقلون",
  },
  {
    verseId: 51,
    name: "هود",
    surahId: 11,
    text: "وَيَٰقَوۡمِ ٱسۡتَغۡفِرُواْ رَبَّكُمۡ ثُمَّ تُوبُوٓاْ إِلَيۡهِ يُرۡسِلِ ٱلسَّمَآءَ عَلَيۡكُم مِّدۡرَارٗا وَيَزِدۡكُمۡ قُوَّةً إِلَىٰ قُوَّتِكُمۡ وَلَا تَتَوَلَّوۡاْ مُجۡرِمِينَ",
    translation:
      "And O my people, ask forgiveness of your Lord and then repent to Him. He will send [rain from] the sky upon you in showers and increase you in strength [added] to your strength. And do not turn away, [being] criminals",
    normalizedText:
      "ويقوم استغفروا ربكم ثم توبوا اليه يرسل السماء عليكم مدرارا ويزدكم قوة الى قوتكم ولا تتولوا مجرمين",
  },
  {
    verseId: 52,
    name: "هود",
    surahId: 11,
    text: "قَالُواْ يَٰهُودُ مَا جِئۡتَنَا بِبَيِّنَةٖ وَمَا نَحۡنُ بِتَارِكِيٓ ءَالِهَتِنَا عَن قَوۡلِكَ وَمَا نَحۡنُ لَكَ بِمُؤۡمِنِينَ",
    translation:
      'They said, "O Hud, you have not brought us clear evidence, and we are not ones to leave our gods on your say-so. Nor are we believers in you',
    normalizedText:
      "قالوا يهود ما جاتنا ببينة وما نحن بتاركي ءالهتنا عن قولك وما نحن لك بمامنين",
  },
  {
    verseId: 53,
    name: "هود",
    surahId: 11,
    text: "إِن نَّقُولُ إِلَّا ٱعۡتَرَىٰكَ بَعۡضُ ءَالِهَتِنَا بِسُوٓءٖۗ قَالَ إِنِّيٓ أُشۡهِدُ ٱللَّهَ وَٱشۡهَدُوٓاْ أَنِّي بَرِيٓءٞ مِّمَّا تُشۡرِكُونَ",
    translation:
      'We only say that some of our gods have possessed you with evil." He said, "Indeed, I call Allah to witness, and witness [yourselves] that I am free from whatever you associate with Allah',
    normalizedText:
      "ان نقول الا اعترىك بعض ءالهتنا بسوء قال اني اشهد الله واشهدوا اني بريء مما تشركون",
  },
  {
    verseId: 54,
    name: "هود",
    surahId: 11,
    text: "مِن دُونِهِۦۖ فَكِيدُونِي جَمِيعٗا ثُمَّ لَا تُنظِرُونِ",
    translation:
      "Other than Him. So plot against me all together; then do not give me respite",
    normalizedText: "من دونه فكيدوني جميعا ثم لا تنظرون",
  },
  {
    verseId: 55,
    name: "هود",
    surahId: 11,
    text: "إِنِّي تَوَكَّلۡتُ عَلَى ٱللَّهِ رَبِّي وَرَبِّكُمۚ مَّا مِن دَآبَّةٍ إِلَّا هُوَ ءَاخِذُۢ بِنَاصِيَتِهَآۚ إِنَّ رَبِّي عَلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "Indeed, I have relied upon Allah, my Lord and your Lord. There is no creature but that He holds its forelock. Indeed, my Lord is on a path [that is] straight",
    normalizedText:
      "اني توكلت على الله ربي وربكم ما من دابة الا هو ءاخذ بناصيتها ان ربي على صرط مستقيم",
  },
  {
    verseId: 56,
    name: "هود",
    surahId: 11,
    text: "فَإِن تَوَلَّوۡاْ فَقَدۡ أَبۡلَغۡتُكُم مَّآ أُرۡسِلۡتُ بِهِۦٓ إِلَيۡكُمۡۚ وَيَسۡتَخۡلِفُ رَبِّي قَوۡمًا غَيۡرَكُمۡ وَلَا تَضُرُّونَهُۥ شَيۡـًٔاۚ إِنَّ رَبِّي عَلَىٰ كُلِّ شَيۡءٍ حَفِيظٞ",
    translation:
      'But if they turn away, [say], "I have already conveyed that with which I was sent to you. My Lord will give succession to a people other than you, and you will not harm Him at all. Indeed my Lord is, over all things, Guardian',
    normalizedText:
      "فان تولوا فقد ابلغتكم ما ارسلت به اليكم ويستخلف ربي قوما غيركم ولا تضرونه شيا ان ربي على كل شيء حفيظ",
  },
  {
    verseId: 57,
    name: "هود",
    surahId: 11,
    text: "وَلَمَّا جَآءَ أَمۡرُنَا نَجَّيۡنَا هُودٗا وَٱلَّذِينَ ءَامَنُواْ مَعَهُۥ بِرَحۡمَةٖ مِّنَّا وَنَجَّيۡنَٰهُم مِّنۡ عَذَابٍ غَلِيظٖ",
    translation:
      "And when Our command came, We saved Hud and those who believed with him, by mercy from Us; and We saved them from a harsh punishment",
    normalizedText:
      "ولما جاء امرنا نجينا هودا والذين ءامنوا معه برحمة منا ونجينهم من عذاب غليظ",
  },
  {
    verseId: 58,
    name: "هود",
    surahId: 11,
    text: "وَتِلۡكَ عَادٞۖ جَحَدُواْ بِـَٔايَٰتِ رَبِّهِمۡ وَعَصَوۡاْ رُسُلَهُۥ وَٱتَّبَعُوٓاْ أَمۡرَ كُلِّ جَبَّارٍ عَنِيدٖ",
    translation:
      "And that was 'Aad, who rejected the signs of their Lord and disobeyed His messengers and followed the order of every obstinate tyrant",
    normalizedText:
      "وتلك عاد جحدوا بايت ربهم وعصوا رسله واتبعوا امر كل جبار عنيد",
  },
  {
    verseId: 59,
    name: "هود",
    surahId: 11,
    text: "وَأُتۡبِعُواْ فِي هَٰذِهِ ٱلدُّنۡيَا لَعۡنَةٗ وَيَوۡمَ ٱلۡقِيَٰمَةِۗ أَلَآ إِنَّ عَادٗا كَفَرُواْ رَبَّهُمۡۗ أَلَا بُعۡدٗا لِّعَادٖ قَوۡمِ هُودٖ",
    translation:
      "And they were [therefore] followed in this world with a curse and [as well] on the Day of Resurrection. Unquestionably, 'Aad denied their Lord; then away with 'Aad, the people of Hud",
    normalizedText:
      "واتبعوا في هذه الدنيا لعنة ويوم القيمة الا ان عادا كفروا ربهم الا بعدا لعاد قوم هود",
  },
  {
    verseId: 60,
    name: "هود",
    surahId: 11,
    text: "۞وَإِلَىٰ ثَمُودَ أَخَاهُمۡ صَٰلِحٗاۚ قَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥۖ هُوَ أَنشَأَكُم مِّنَ ٱلۡأَرۡضِ وَٱسۡتَعۡمَرَكُمۡ فِيهَا فَٱسۡتَغۡفِرُوهُ ثُمَّ تُوبُوٓاْ إِلَيۡهِۚ إِنَّ رَبِّي قَرِيبٞ مُّجِيبٞ",
    translation:
      'And to Thamud [We sent] their brother Salih. He said, "O my people, worship Allah; you have no deity other than Him. He has produced you from the earth and settled you in it, so ask forgiveness of Him and then repent to Him. Indeed, my Lord is near and responsive',
    normalizedText:
      "۞والى ثمود اخاهم صلحا قال يقوم اعبدوا الله ما لكم من اله غيره هو انشاكم من الارض واستعمركم فيها فاستغفروه ثم توبوا اليه ان ربي قريب مجيب",
  },
  {
    verseId: 61,
    name: "هود",
    surahId: 11,
    text: "قَالُواْ يَٰصَٰلِحُ قَدۡ كُنتَ فِينَا مَرۡجُوّٗا قَبۡلَ هَٰذَآۖ أَتَنۡهَىٰنَآ أَن نَّعۡبُدَ مَا يَعۡبُدُ ءَابَآؤُنَا وَإِنَّنَا لَفِي شَكّٖ مِّمَّا تَدۡعُونَآ إِلَيۡهِ مُرِيبٖ",
    translation:
      'They said, "O Salih, you were among us a man of promise before this. Do you forbid us to worship what our fathers worshipped? And indeed we are, about that to which you invite us, in disquieting doubt',
    normalizedText:
      "قالوا يصلح قد كنت فينا مرجوا قبل هذا اتنهىنا ان نعبد ما يعبد ءاباانا واننا لفي شك مما تدعونا اليه مريب",
  },
  {
    verseId: 62,
    name: "هود",
    surahId: 11,
    text: "قَالَ يَٰقَوۡمِ أَرَءَيۡتُمۡ إِن كُنتُ عَلَىٰ بَيِّنَةٖ مِّن رَّبِّي وَءَاتَىٰنِي مِنۡهُ رَحۡمَةٗ فَمَن يَنصُرُنِي مِنَ ٱللَّهِ إِنۡ عَصَيۡتُهُۥۖ فَمَا تَزِيدُونَنِي غَيۡرَ تَخۡسِيرٖ",
    translation:
      'He said, "O my people, have you considered: if I should be upon clear evidence from my Lord and He has given me mercy from Himself, who would protect me from Allah if I disobeyed Him? So you would not increase me except in loss',
    normalizedText:
      "قال يقوم ارءيتم ان كنت على بينة من ربي وءاتىني منه رحمة فمن ينصرني من الله ان عصيته فما تزيدونني غير تخسير",
  },
  {
    verseId: 63,
    name: "هود",
    surahId: 11,
    text: "وَيَٰقَوۡمِ هَٰذِهِۦ نَاقَةُ ٱللَّهِ لَكُمۡ ءَايَةٗۖ فَذَرُوهَا تَأۡكُلۡ فِيٓ أَرۡضِ ٱللَّهِۖ وَلَا تَمَسُّوهَا بِسُوٓءٖ فَيَأۡخُذَكُمۡ عَذَابٞ قَرِيبٞ",
    translation:
      "And O my people, this is the she-camel of Allah - [she is] to you a sign. So let her feed upon Allah 's earth and do not touch her with harm, or you will be taken by an impending punishment",
    normalizedText:
      "ويقوم هذه ناقة الله لكم ءاية فذروها تاكل في ارض الله ولا تمسوها بسوء فياخذكم عذاب قريب",
  },
  {
    verseId: 64,
    name: "هود",
    surahId: 11,
    text: "فَعَقَرُوهَا فَقَالَ تَمَتَّعُواْ فِي دَارِكُمۡ ثَلَٰثَةَ أَيَّامٖۖ ذَٰلِكَ وَعۡدٌ غَيۡرُ مَكۡذُوبٖ",
    translation:
      'But they hamstrung her, so he said, "Enjoy yourselves in your homes for three days. That is a promise not to be denied',
    normalizedText: "فعقروها فقال تمتعوا في داركم ثلثة ايام ذلك وعد غير مكذوب",
  },
  {
    verseId: 65,
    name: "هود",
    surahId: 11,
    text: "فَلَمَّا جَآءَ أَمۡرُنَا نَجَّيۡنَا صَٰلِحٗا وَٱلَّذِينَ ءَامَنُواْ مَعَهُۥ بِرَحۡمَةٖ مِّنَّا وَمِنۡ خِزۡيِ يَوۡمِئِذٍۚ إِنَّ رَبَّكَ هُوَ ٱلۡقَوِيُّ ٱلۡعَزِيزُ",
    translation:
      "So when Our command came, We saved Salih and those who believed with him, by mercy from Us, and [saved them] from the disgrace of that day. Indeed, it is your Lord who is the Powerful, the Exalted in Might",
    normalizedText:
      "فلما جاء امرنا نجينا صلحا والذين ءامنوا معه برحمة منا ومن خزي يوماذ ان ربك هو القوي العزيز",
  },
  {
    verseId: 66,
    name: "هود",
    surahId: 11,
    text: "وَأَخَذَ ٱلَّذِينَ ظَلَمُواْ ٱلصَّيۡحَةُ فَأَصۡبَحُواْ فِي دِيَٰرِهِمۡ جَٰثِمِينَ",
    translation:
      "And the shriek seized those who had wronged, and they became within their homes [corpses] fallen prone",
    normalizedText: "واخذ الذين ظلموا الصيحة فاصبحوا في ديرهم جثمين",
  },
  {
    verseId: 67,
    name: "هود",
    surahId: 11,
    text: "كَأَن لَّمۡ يَغۡنَوۡاْ فِيهَآۗ أَلَآ إِنَّ ثَمُودَاْ كَفَرُواْ رَبَّهُمۡۗ أَلَا بُعۡدٗا لِّثَمُودَ",
    translation:
      "As if they had never prospered therein. Unquestionably, Thamud denied their Lord; then, away with Thamud",
    normalizedText: "كان لم يغنوا فيها الا ان ثمودا كفروا ربهم الا بعدا لثمود",
  },
  {
    verseId: 68,
    name: "هود",
    surahId: 11,
    text: "وَلَقَدۡ جَآءَتۡ رُسُلُنَآ إِبۡرَٰهِيمَ بِٱلۡبُشۡرَىٰ قَالُواْ سَلَٰمٗاۖ قَالَ سَلَٰمٞۖ فَمَا لَبِثَ أَن جَآءَ بِعِجۡلٍ حَنِيذٖ",
    translation:
      'And certainly did Our messengers come to Abraham with good tidings; they said, "Peace." He said, "Peace," and did not delay in bringing [them] a roasted calf',
    normalizedText:
      "ولقد جاءت رسلنا ابرهيم بالبشرى قالوا سلما قال سلم فما لبث ان جاء بعجل حنيذ",
  },
  {
    verseId: 69,
    name: "هود",
    surahId: 11,
    text: "فَلَمَّا رَءَآ أَيۡدِيَهُمۡ لَا تَصِلُ إِلَيۡهِ نَكِرَهُمۡ وَأَوۡجَسَ مِنۡهُمۡ خِيفَةٗۚ قَالُواْ لَا تَخَفۡ إِنَّآ أُرۡسِلۡنَآ إِلَىٰ قَوۡمِ لُوطٖ",
    translation:
      'But when he saw their hands not reaching for it, he distrusted them and felt from them apprehension. They said, "Fear not. We have been sent to the people of Lot',
    normalizedText:
      "فلما رءا ايديهم لا تصل اليه نكرهم واوجس منهم خيفة قالوا لا تخف انا ارسلنا الى قوم لوط",
  },
  {
    verseId: 70,
    name: "هود",
    surahId: 11,
    text: "وَٱمۡرَأَتُهُۥ قَآئِمَةٞ فَضَحِكَتۡ فَبَشَّرۡنَٰهَا بِإِسۡحَٰقَ وَمِن وَرَآءِ إِسۡحَٰقَ يَعۡقُوبَ",
    translation:
      "And his Wife was standing, and she smiled. Then We gave her good tidings of Isaac and after Isaac, Jacob",
    normalizedText: "وامراته قاامة فضحكت فبشرنها باسحق ومن وراء اسحق يعقوب",
  },
  {
    verseId: 71,
    name: "هود",
    surahId: 11,
    text: "قَالَتۡ يَٰوَيۡلَتَىٰٓ ءَأَلِدُ وَأَنَا۠ عَجُوزٞ وَهَٰذَا بَعۡلِي شَيۡخًاۖ إِنَّ هَٰذَا لَشَيۡءٌ عَجِيبٞ",
    translation:
      'She said, "Woe to me! Shall I give birth while I am an old woman and this, my husband, is an old man? Indeed, this is an amazing thing',
    normalizedText:
      "قالت يويلتى ءالد وانا عجوز وهذا بعلي شيخا ان هذا لشيء عجيب",
  },
  {
    verseId: 72,
    name: "هود",
    surahId: 11,
    text: "قَالُوٓاْ أَتَعۡجَبِينَ مِنۡ أَمۡرِ ٱللَّهِۖ رَحۡمَتُ ٱللَّهِ وَبَرَكَٰتُهُۥ عَلَيۡكُمۡ أَهۡلَ ٱلۡبَيۡتِۚ إِنَّهُۥ حَمِيدٞ مَّجِيدٞ",
    translation:
      'They said, "Are you amazed at the decree of Allah? May the mercy of Allah and His blessings be upon you, people of the house. Indeed, He is Praiseworthy and Honorable',
    normalizedText:
      "قالوا اتعجبين من امر الله رحمت الله وبركته عليكم اهل البيت انه حميد مجيد",
  },
  {
    verseId: 73,
    name: "هود",
    surahId: 11,
    text: "فَلَمَّا ذَهَبَ عَنۡ إِبۡرَٰهِيمَ ٱلرَّوۡعُ وَجَآءَتۡهُ ٱلۡبُشۡرَىٰ يُجَٰدِلُنَا فِي قَوۡمِ لُوطٍ",
    translation:
      "And when the fright had left Abraham and the good tidings had reached him, he began to argue with Us concerning the people of Lot",
    normalizedText: "فلما ذهب عن ابرهيم الروع وجاءته البشرى يجدلنا في قوم لوط",
  },
  {
    verseId: 74,
    name: "هود",
    surahId: 11,
    text: "إِنَّ إِبۡرَٰهِيمَ لَحَلِيمٌ أَوَّـٰهٞ مُّنِيبٞ",
    translation:
      "Indeed, Abraham was forbearing, grieving and [frequently] returning [to Allah]",
    normalizedText: "ان ابرهيم لحليم اوه منيب",
  },
  {
    verseId: 75,
    name: "هود",
    surahId: 11,
    text: "يَـٰٓإِبۡرَٰهِيمُ أَعۡرِضۡ عَنۡ هَٰذَآۖ إِنَّهُۥ قَدۡ جَآءَ أَمۡرُ رَبِّكَۖ وَإِنَّهُمۡ ءَاتِيهِمۡ عَذَابٌ غَيۡرُ مَرۡدُودٖ",
    translation:
      '[The angels said], "O Abraham, give up this [plea]. Indeed, the command of your Lord has come, and indeed, there will reach them a punishment that cannot be repelled',
    normalizedText:
      "يابرهيم اعرض عن هذا انه قد جاء امر ربك وانهم ءاتيهم عذاب غير مردود",
  },
  {
    verseId: 76,
    name: "هود",
    surahId: 11,
    text: "وَلَمَّا جَآءَتۡ رُسُلُنَا لُوطٗا سِيٓءَ بِهِمۡ وَضَاقَ بِهِمۡ ذَرۡعٗا وَقَالَ هَٰذَا يَوۡمٌ عَصِيبٞ",
    translation:
      'And when Our messengers, [the angels], came to Lot, he was anguished for them and felt for them great discomfort and said, "This is a trying day',
    normalizedText:
      "ولما جاءت رسلنا لوطا سيء بهم وضاق بهم ذرعا وقال هذا يوم عصيب",
  },
  {
    verseId: 77,
    name: "هود",
    surahId: 11,
    text: "وَجَآءَهُۥ قَوۡمُهُۥ يُهۡرَعُونَ إِلَيۡهِ وَمِن قَبۡلُ كَانُواْ يَعۡمَلُونَ ٱلسَّيِّـَٔاتِۚ قَالَ يَٰقَوۡمِ هَـٰٓؤُلَآءِ بَنَاتِي هُنَّ أَطۡهَرُ لَكُمۡۖ فَٱتَّقُواْ ٱللَّهَ وَلَا تُخۡزُونِ فِي ضَيۡفِيٓۖ أَلَيۡسَ مِنكُمۡ رَجُلٞ رَّشِيدٞ",
    translation:
      'And his people came hastening to him, and before [this] they had been doing evil deeds. He said, "O my people, these are my daughters; they are purer for you. So fear Allah and do not disgrace me concerning my guests. Is there not among you a man of reason',
    normalizedText:
      "وجاءه قومه يهرعون اليه ومن قبل كانوا يعملون السيات قال يقوم هالاء بناتي هن اطهر لكم فاتقوا الله ولا تخزون في ضيفي اليس منكم رجل رشيد",
  },
  {
    verseId: 78,
    name: "هود",
    surahId: 11,
    text: "قَالُواْ لَقَدۡ عَلِمۡتَ مَا لَنَا فِي بَنَاتِكَ مِنۡ حَقّٖ وَإِنَّكَ لَتَعۡلَمُ مَا نُرِيدُ",
    translation:
      'They said, "You have already known that we have not concerning your daughters any claim, and indeed, you know what we want',
    normalizedText: "قالوا لقد علمت ما لنا في بناتك من حق وانك لتعلم ما نريد",
  },
  {
    verseId: 79,
    name: "هود",
    surahId: 11,
    text: "قَالَ لَوۡ أَنَّ لِي بِكُمۡ قُوَّةً أَوۡ ءَاوِيٓ إِلَىٰ رُكۡنٖ شَدِيدٖ",
    translation:
      'He said, "If only I had against you some power or could take refuge in a strong support',
    normalizedText: "قال لو ان لي بكم قوة او ءاوي الى ركن شديد",
  },
  {
    verseId: 80,
    name: "هود",
    surahId: 11,
    text: "قَالُواْ يَٰلُوطُ إِنَّا رُسُلُ رَبِّكَ لَن يَصِلُوٓاْ إِلَيۡكَۖ فَأَسۡرِ بِأَهۡلِكَ بِقِطۡعٖ مِّنَ ٱلَّيۡلِ وَلَا يَلۡتَفِتۡ مِنكُمۡ أَحَدٌ إِلَّا ٱمۡرَأَتَكَۖ إِنَّهُۥ مُصِيبُهَا مَآ أَصَابَهُمۡۚ إِنَّ مَوۡعِدَهُمُ ٱلصُّبۡحُۚ أَلَيۡسَ ٱلصُّبۡحُ بِقَرِيبٖ",
    translation:
      'The angels said, "O Lot, indeed we are messengers of your Lord; [therefore], they will never reach you. So set out with your family during a portion of the night and let not any among you look back - except your wife; indeed, she will be struck by that which strikes them. Indeed, their appointment is [for] the morning. Is not the morning near',
    normalizedText:
      "قالوا يلوط انا رسل ربك لن يصلوا اليك فاسر باهلك بقطع من اليل ولا يلتفت منكم احد الا امراتك انه مصيبها ما اصابهم ان موعدهم الصبح اليس الصبح بقريب",
  },
  {
    verseId: 81,
    name: "هود",
    surahId: 11,
    text: "فَلَمَّا جَآءَ أَمۡرُنَا جَعَلۡنَا عَٰلِيَهَا سَافِلَهَا وَأَمۡطَرۡنَا عَلَيۡهَا حِجَارَةٗ مِّن سِجِّيلٖ مَّنضُودٖ",
    translation:
      "So when Our command came, We made the highest part [of the city] its lowest and rained upon them stones of layered hard clay, [which were]",
    normalizedText:
      "فلما جاء امرنا جعلنا عليها سافلها وامطرنا عليها حجارة من سجيل منضود",
  },
  {
    verseId: 82,
    name: "هود",
    surahId: 11,
    text: "مُّسَوَّمَةً عِندَ رَبِّكَۖ وَمَا هِيَ مِنَ ٱلظَّـٰلِمِينَ بِبَعِيدٖ",
    translation:
      "Marked from your Lord. And Allah 's punishment is not from the wrongdoers [very] far",
    normalizedText: "مسومة عند ربك وما هي من الظلمين ببعيد",
  },
  {
    verseId: 83,
    name: "هود",
    surahId: 11,
    text: "۞وَإِلَىٰ مَدۡيَنَ أَخَاهُمۡ شُعَيۡبٗاۚ قَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥۖ وَلَا تَنقُصُواْ ٱلۡمِكۡيَالَ وَٱلۡمِيزَانَۖ إِنِّيٓ أَرَىٰكُم بِخَيۡرٖ وَإِنِّيٓ أَخَافُ عَلَيۡكُمۡ عَذَابَ يَوۡمٖ مُّحِيطٖ",
    translation: `And to Madyan [We sent] their brother Shu'ayb. He said, "O my people, worship Allah; you have no deity other than Him. And do not decrease from the measure and the scale. Indeed, I see you in prosperity, but indeed, I fear for you the punishment of an all-encompassing Day`,
    normalizedText:
      "۞والى مدين اخاهم شعيبا قال يقوم اعبدوا الله ما لكم من اله غيره ولا تنقصوا المكيال والميزان اني ارىكم بخير واني اخاف عليكم عذاب يوم محيط",
  },
  {
    verseId: 84,
    name: "هود",
    surahId: 11,
    text: "وَيَٰقَوۡمِ أَوۡفُواْ ٱلۡمِكۡيَالَ وَٱلۡمِيزَانَ بِٱلۡقِسۡطِۖ وَلَا تَبۡخَسُواْ ٱلنَّاسَ أَشۡيَآءَهُمۡ وَلَا تَعۡثَوۡاْ فِي ٱلۡأَرۡضِ مُفۡسِدِينَ",
    translation:
      "And O my people, give full measure and weight in justice and do not deprive the people of their due and do not commit abuse on the earth, spreading corruption",
    normalizedText:
      "ويقوم اوفوا المكيال والميزان بالقسط ولا تبخسوا الناس اشياءهم ولا تعثوا في الارض مفسدين",
  },
  {
    verseId: 85,
    name: "هود",
    surahId: 11,
    text: "بَقِيَّتُ ٱللَّهِ خَيۡرٞ لَّكُمۡ إِن كُنتُم مُّؤۡمِنِينَۚ وَمَآ أَنَا۠ عَلَيۡكُم بِحَفِيظٖ",
    translation:
      "What remains [lawful] from Allah is best for you, if you would be believers. But I am not a guardian over you",
    normalizedText: "بقيت الله خير لكم ان كنتم مامنين وما انا عليكم بحفيظ",
  },
  {
    verseId: 86,
    name: "هود",
    surahId: 11,
    text: "قَالُواْ يَٰشُعَيۡبُ أَصَلَوٰتُكَ تَأۡمُرُكَ أَن نَّتۡرُكَ مَا يَعۡبُدُ ءَابَآؤُنَآ أَوۡ أَن نَّفۡعَلَ فِيٓ أَمۡوَٰلِنَا مَا نَشَـٰٓؤُاْۖ إِنَّكَ لَأَنتَ ٱلۡحَلِيمُ ٱلرَّشِيدُ",
    translation: `They said, "O Shu'ayb, does your prayer command you that we should leave what our fathers worship or not do with our wealth what we please? Indeed, you are the forbearing, the discerning`,
    normalizedText:
      "قالوا يشعيب اصلوتك تامرك ان نترك ما يعبد ءاباانا او ان نفعل في امولنا ما نشاا انك لانت الحليم الرشيد",
  },
  {
    verseId: 87,
    name: "هود",
    surahId: 11,
    text: "قَالَ يَٰقَوۡمِ أَرَءَيۡتُمۡ إِن كُنتُ عَلَىٰ بَيِّنَةٖ مِّن رَّبِّي وَرَزَقَنِي مِنۡهُ رِزۡقًا حَسَنٗاۚ وَمَآ أُرِيدُ أَنۡ أُخَالِفَكُمۡ إِلَىٰ مَآ أَنۡهَىٰكُمۡ عَنۡهُۚ إِنۡ أُرِيدُ إِلَّا ٱلۡإِصۡلَٰحَ مَا ٱسۡتَطَعۡتُۚ وَمَا تَوۡفِيقِيٓ إِلَّا بِٱللَّهِۚ عَلَيۡهِ تَوَكَّلۡتُ وَإِلَيۡهِ أُنِيبُ",
    translation:
      'He said, "O my people, have you considered: if I am upon clear evidence from my Lord and He has provided me with a good provision from Him...? And I do not intend to differ from you in that which I have forbidden you; I only intend reform as much as I am able. And my success is not but through Allah. Upon him I have relied, and to Him I return',
    normalizedText:
      "قال يقوم ارءيتم ان كنت على بينة من ربي ورزقني منه رزقا حسنا وما اريد ان اخالفكم الى ما انهىكم عنه ان اريد الا الاصلح ما استطعت وما توفيقي الا بالله عليه توكلت واليه انيب",
  },
  {
    verseId: 88,
    name: "هود",
    surahId: 11,
    text: "وَيَٰقَوۡمِ لَا يَجۡرِمَنَّكُمۡ شِقَاقِيٓ أَن يُصِيبَكُم مِّثۡلُ مَآ أَصَابَ قَوۡمَ نُوحٍ أَوۡ قَوۡمَ هُودٍ أَوۡ قَوۡمَ صَٰلِحٖۚ وَمَا قَوۡمُ لُوطٖ مِّنكُم بِبَعِيدٖ",
    translation:
      "And O my people, let not [your] dissension from me cause you to be struck by that similar to what struck the people of Noah or the people of Hud or the people of Salih. And the people of Lot are not from you far away",
    normalizedText:
      "ويقوم لا يجرمنكم شقاقي ان يصيبكم مثل ما اصاب قوم نوح او قوم هود او قوم صلح وما قوم لوط منكم ببعيد",
  },
  {
    verseId: 89,
    name: "هود",
    surahId: 11,
    text: "وَٱسۡتَغۡفِرُواْ رَبَّكُمۡ ثُمَّ تُوبُوٓاْ إِلَيۡهِۚ إِنَّ رَبِّي رَحِيمٞ وَدُودٞ",
    translation:
      "And ask forgiveness of your Lord and then repent to Him. Indeed, my Lord is Merciful and Affectionate",
    normalizedText: "واستغفروا ربكم ثم توبوا اليه ان ربي رحيم ودود",
  },
  {
    verseId: 90,
    name: "هود",
    surahId: 11,
    text: "قَالُواْ يَٰشُعَيۡبُ مَا نَفۡقَهُ كَثِيرٗا مِّمَّا تَقُولُ وَإِنَّا لَنَرَىٰكَ فِينَا ضَعِيفٗاۖ وَلَوۡلَا رَهۡطُكَ لَرَجَمۡنَٰكَۖ وَمَآ أَنتَ عَلَيۡنَا بِعَزِيزٖ",
    translation: `They said, "O Shu'ayb, we do not understand much of what you say, and indeed, we consider you among us as weak. And if not for your family, we would have stoned you [to death]; and you are not to us one respected`,
    normalizedText:
      "قالوا يشعيب ما نفقه كثيرا مما تقول وانا لنرىك فينا ضعيفا ولولا رهطك لرجمنك وما انت علينا بعزيز",
  },
  {
    verseId: 91,
    name: "هود",
    surahId: 11,
    text: "قَالَ يَٰقَوۡمِ أَرَهۡطِيٓ أَعَزُّ عَلَيۡكُم مِّنَ ٱللَّهِ وَٱتَّخَذۡتُمُوهُ وَرَآءَكُمۡ ظِهۡرِيًّاۖ إِنَّ رَبِّي بِمَا تَعۡمَلُونَ مُحِيطٞ",
    translation:
      'He said, "O my people, is my family more respected for power by you than Allah? But you put Him behind your backs [in neglect]. Indeed, my Lord is encompassing of what you do',
    normalizedText:
      "قال يقوم ارهطي اعز عليكم من الله واتخذتموه وراءكم ظهريا ان ربي بما تعملون محيط",
  },
  {
    verseId: 92,
    name: "هود",
    surahId: 11,
    text: "وَيَٰقَوۡمِ ٱعۡمَلُواْ عَلَىٰ مَكَانَتِكُمۡ إِنِّي عَٰمِلٞۖ سَوۡفَ تَعۡلَمُونَ مَن يَأۡتِيهِ عَذَابٞ يُخۡزِيهِ وَمَنۡ هُوَ كَٰذِبٞۖ وَٱرۡتَقِبُوٓاْ إِنِّي مَعَكُمۡ رَقِيبٞ",
    translation:
      "And O my people, work according to your position; indeed, I am working. You are going to know to whom will come a punishment that will disgrace him and who is a liar. So watch; indeed, I am with you a watcher, [awaiting the outcome]",
    normalizedText:
      "ويقوم اعملوا على مكانتكم اني عمل سوف تعلمون من ياتيه عذاب يخزيه ومن هو كذب وارتقبوا اني معكم رقيب",
  },
  {
    verseId: 93,
    name: "هود",
    surahId: 11,
    text: "وَلَمَّا جَآءَ أَمۡرُنَا نَجَّيۡنَا شُعَيۡبٗا وَٱلَّذِينَ ءَامَنُواْ مَعَهُۥ بِرَحۡمَةٖ مِّنَّا وَأَخَذَتِ ٱلَّذِينَ ظَلَمُواْ ٱلصَّيۡحَةُ فَأَصۡبَحُواْ فِي دِيَٰرِهِمۡ جَٰثِمِينَ",
    translation:
      "And when Our command came, We saved Shu'ayb and those who believed with him, by mercy from Us. And the shriek seized those who had wronged, and they became within their homes [corpses] fallen prone",
    normalizedText:
      "ولما جاء امرنا نجينا شعيبا والذين ءامنوا معه برحمة منا واخذت الذين ظلموا الصيحة فاصبحوا في ديرهم جثمين",
  },
  {
    verseId: 94,
    name: "هود",
    surahId: 11,
    text: "كَأَن لَّمۡ يَغۡنَوۡاْ فِيهَآۗ أَلَا بُعۡدٗا لِّمَدۡيَنَ كَمَا بَعِدَتۡ ثَمُودُ",
    translation:
      "As if they had never prospered therein. Then, away with Madyan as Thamud was taken away",
    normalizedText: "كان لم يغنوا فيها الا بعدا لمدين كما بعدت ثمود",
  },
  {
    verseId: 95,
    name: "هود",
    surahId: 11,
    text: "وَلَقَدۡ أَرۡسَلۡنَا مُوسَىٰ بِـَٔايَٰتِنَا وَسُلۡطَٰنٖ مُّبِينٍ",
    translation:
      "And We did certainly send Moses with Our signs and a clear authority",
    normalizedText: "ولقد ارسلنا موسى بايتنا وسلطن مبين",
  },
  {
    verseId: 96,
    name: "هود",
    surahId: 11,
    text: "إِلَىٰ فِرۡعَوۡنَ وَمَلَإِيْهِۦ فَٱتَّبَعُوٓاْ أَمۡرَ فِرۡعَوۡنَۖ وَمَآ أَمۡرُ فِرۡعَوۡنَ بِرَشِيدٖ",
    translation:
      "To Pharaoh and his establishment, but they followed the command of Pharaoh, and the command of Pharaoh was not [at all] discerning",
    normalizedText: "الى فرعون وملايه فاتبعوا امر فرعون وما امر فرعون برشيد",
  },
  {
    verseId: 97,
    name: "هود",
    surahId: 11,
    text: "يَقۡدُمُ قَوۡمَهُۥ يَوۡمَ ٱلۡقِيَٰمَةِ فَأَوۡرَدَهُمُ ٱلنَّارَۖ وَبِئۡسَ ٱلۡوِرۡدُ ٱلۡمَوۡرُودُ",
    translation:
      "He will precede his people on the Day of Resurrection and lead them into the Fire; and wretched is the place to which they are led",
    normalizedText: "يقدم قومه يوم القيمة فاوردهم النار وباس الورد المورود",
  },
  {
    verseId: 98,
    name: "هود",
    surahId: 11,
    text: "وَأُتۡبِعُواْ فِي هَٰذِهِۦ لَعۡنَةٗ وَيَوۡمَ ٱلۡقِيَٰمَةِۚ بِئۡسَ ٱلرِّفۡدُ ٱلۡمَرۡفُودُ",
    translation:
      "And they were followed in this [world] with a curse and on the Day of Resurrection. And wretched is the gift which is given",
    normalizedText: "واتبعوا في هذه لعنة ويوم القيمة باس الرفد المرفود",
  },
  {
    verseId: 99,
    name: "هود",
    surahId: 11,
    text: "ذَٰلِكَ مِنۡ أَنۢبَآءِ ٱلۡقُرَىٰ نَقُصُّهُۥ عَلَيۡكَۖ مِنۡهَا قَآئِمٞ وَحَصِيدٞ",
    translation:
      "That is from the news of the cities, which We relate to you; of them, some are [still] standing and some are [as] a harvest [mowed down]",
    normalizedText: "ذلك من انباء القرى نقصه عليك منها قاام وحصيد",
  },
  {
    verseId: 100,
    name: "هود",
    surahId: 11,
    text: "وَمَا ظَلَمۡنَٰهُمۡ وَلَٰكِن ظَلَمُوٓاْ أَنفُسَهُمۡۖ فَمَآ أَغۡنَتۡ عَنۡهُمۡ ءَالِهَتُهُمُ ٱلَّتِي يَدۡعُونَ مِن دُونِ ٱللَّهِ مِن شَيۡءٖ لَّمَّا جَآءَ أَمۡرُ رَبِّكَۖ وَمَا زَادُوهُمۡ غَيۡرَ تَتۡبِيبٖ",
    translation:
      "And We did not wrong them, but they wronged themselves. And they were not availed at all by their gods which they invoked other than Allah when there came the command of your Lord. And they did not increase them in other than ruin",
    normalizedText:
      "وما ظلمنهم ولكن ظلموا انفسهم فما اغنت عنهم ءالهتهم التي يدعون من دون الله من شيء لما جاء امر ربك وما زادوهم غير تتبيب",
  },
  {
    verseId: 101,
    name: "هود",
    surahId: 11,
    text: "وَكَذَٰلِكَ أَخۡذُ رَبِّكَ إِذَآ أَخَذَ ٱلۡقُرَىٰ وَهِيَ ظَٰلِمَةٌۚ إِنَّ أَخۡذَهُۥٓ أَلِيمٞ شَدِيدٌ",
    translation:
      "And thus is the seizure of your Lord when He seizes the cities while they are committing wrong. Indeed, His seizure is painful and severe",
    normalizedText: "وكذلك اخذ ربك اذا اخذ القرى وهي ظلمة ان اخذه اليم شديد",
  },
  {
    verseId: 102,
    name: "هود",
    surahId: 11,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّمَنۡ خَافَ عَذَابَ ٱلۡأٓخِرَةِۚ ذَٰلِكَ يَوۡمٞ مَّجۡمُوعٞ لَّهُ ٱلنَّاسُ وَذَٰلِكَ يَوۡمٞ مَّشۡهُودٞ",
    translation:
      "Indeed in that is a sign for those who fear the punishment of the Hereafter. That is a Day for which the people will be collected, and that is a Day [which will be] witnessed",
    normalizedText:
      "ان في ذلك لاية لمن خاف عذاب الاخرة ذلك يوم مجموع له الناس وذلك يوم مشهود",
  },
  {
    verseId: 103,
    name: "هود",
    surahId: 11,
    text: "وَمَا نُؤَخِّرُهُۥٓ إِلَّا لِأَجَلٖ مَّعۡدُودٖ",
    translation: "And We do not delay it except for a limited term",
    normalizedText: "وما ناخره الا لاجل معدود",
  },
  {
    verseId: 104,
    name: "هود",
    surahId: 11,
    text: "يَوۡمَ يَأۡتِ لَا تَكَلَّمُ نَفۡسٌ إِلَّا بِإِذۡنِهِۦۚ فَمِنۡهُمۡ شَقِيّٞ وَسَعِيدٞ",
    translation:
      "The Day it comes no soul will speak except by His permission. And among them will be the wretched and the prosperous",
    normalizedText: "يوم يات لا تكلم نفس الا باذنه فمنهم شقي وسعيد",
  },
  {
    verseId: 105,
    name: "هود",
    surahId: 11,
    text: "فَأَمَّا ٱلَّذِينَ شَقُواْ فَفِي ٱلنَّارِ لَهُمۡ فِيهَا زَفِيرٞ وَشَهِيقٌ",
    translation:
      "As for those who were [destined to be] wretched, they will be in the Fire. For them therein is [violent] exhaling and inhaling",
    normalizedText: "فاما الذين شقوا ففي النار لهم فيها زفير وشهيق",
  },
  {
    verseId: 106,
    name: "هود",
    surahId: 11,
    text: "خَٰلِدِينَ فِيهَا مَا دَامَتِ ٱلسَّمَٰوَٰتُ وَٱلۡأَرۡضُ إِلَّا مَا شَآءَ رَبُّكَۚ إِنَّ رَبَّكَ فَعَّالٞ لِّمَا يُرِيدُ",
    translation:
      "[They will be] abiding therein as long as the heavens and the earth endure, except what your Lord should will. Indeed, your Lord is an effecter of what He intends",
    normalizedText:
      "خلدين فيها ما دامت السموت والارض الا ما شاء ربك ان ربك فعال لما يريد",
  },
  {
    verseId: 107,
    name: "هود",
    surahId: 11,
    text: "۞وَأَمَّا ٱلَّذِينَ سُعِدُواْ فَفِي ٱلۡجَنَّةِ خَٰلِدِينَ فِيهَا مَا دَامَتِ ٱلسَّمَٰوَٰتُ وَٱلۡأَرۡضُ إِلَّا مَا شَآءَ رَبُّكَۖ عَطَآءً غَيۡرَ مَجۡذُوذٖ",
    translation:
      "And as for those who were [destined to be] prosperous, they will be in Paradise, abiding therein as long as the heavens and the earth endure, except what your Lord should will - a bestowal uninterrupted",
    normalizedText:
      "۞واما الذين سعدوا ففي الجنة خلدين فيها ما دامت السموت والارض الا ما شاء ربك عطاء غير مجذوذ",
  },
  {
    verseId: 108,
    name: "هود",
    surahId: 11,
    text: "فَلَا تَكُ فِي مِرۡيَةٖ مِّمَّا يَعۡبُدُ هَـٰٓؤُلَآءِۚ مَا يَعۡبُدُونَ إِلَّا كَمَا يَعۡبُدُ ءَابَآؤُهُم مِّن قَبۡلُۚ وَإِنَّا لَمُوَفُّوهُمۡ نَصِيبَهُمۡ غَيۡرَ مَنقُوصٖ",
    translation:
      "So do not be in doubt, [O Muhammad], as to what these [polytheists] are worshipping. They worship not except as their fathers worshipped before. And indeed, We will give them their share undiminished",
    normalizedText:
      "فلا تك في مرية مما يعبد هالاء ما يعبدون الا كما يعبد ءابااهم من قبل وانا لموفوهم نصيبهم غير منقوص",
  },
  {
    verseId: 109,
    name: "هود",
    surahId: 11,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ فَٱخۡتُلِفَ فِيهِۚ وَلَوۡلَا كَلِمَةٞ سَبَقَتۡ مِن رَّبِّكَ لَقُضِيَ بَيۡنَهُمۡۚ وَإِنَّهُمۡ لَفِي شَكّٖ مِّنۡهُ مُرِيبٖ",
    translation:
      "And We had certainly given Moses the Scripture, but it came under disagreement. And if not for a word that preceded from your Lord, it would have been judged between them. And indeed they are, concerning the Qur'an, in disquieting doubt",
    normalizedText:
      "ولقد ءاتينا موسى الكتب فاختلف فيه ولولا كلمة سبقت من ربك لقضي بينهم وانهم لفي شك منه مريب",
  },
  {
    verseId: 110,
    name: "هود",
    surahId: 11,
    text: "وَإِنَّ كُلّٗا لَّمَّا لَيُوَفِّيَنَّهُمۡ رَبُّكَ أَعۡمَٰلَهُمۡۚ إِنَّهُۥ بِمَا يَعۡمَلُونَ خَبِيرٞ",
    translation:
      "And indeed, each [of the believers and disbelievers] - your Lord will fully compensate them for their deeds. Indeed, He is Acquainted with what they do",
    normalizedText: "وان كلا لما ليوفينهم ربك اعملهم انه بما يعملون خبير",
  },
  {
    verseId: 111,
    name: "هود",
    surahId: 11,
    text: "فَٱسۡتَقِمۡ كَمَآ أُمِرۡتَ وَمَن تَابَ مَعَكَ وَلَا تَطۡغَوۡاْۚ إِنَّهُۥ بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      "So remain on a right course as you have been commanded, [you] and those who have turned back with you [to Allah], and do not transgress. Indeed, He is Seeing of what you do",
    normalizedText: "فاستقم كما امرت ومن تاب معك ولا تطغوا انه بما تعملون بصير",
  },
  {
    verseId: 112,
    name: "هود",
    surahId: 11,
    text: "وَلَا تَرۡكَنُوٓاْ إِلَى ٱلَّذِينَ ظَلَمُواْ فَتَمَسَّكُمُ ٱلنَّارُ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِنۡ أَوۡلِيَآءَ ثُمَّ لَا تُنصَرُونَ",
    translation:
      "And do not incline toward those who do wrong, lest you be touched by the Fire, and you would not have other than Allah any protectors; then you would not be helped",
    normalizedText:
      "ولا تركنوا الى الذين ظلموا فتمسكم النار وما لكم من دون الله من اولياء ثم لا تنصرون",
  },
  {
    verseId: 113,
    name: "هود",
    surahId: 11,
    text: "وَأَقِمِ ٱلصَّلَوٰةَ طَرَفَيِ ٱلنَّهَارِ وَزُلَفٗا مِّنَ ٱلَّيۡلِۚ إِنَّ ٱلۡحَسَنَٰتِ يُذۡهِبۡنَ ٱلسَّيِّـَٔاتِۚ ذَٰلِكَ ذِكۡرَىٰ لِلذَّـٰكِرِينَ",
    translation:
      "And establish prayer at the two ends of the day and at the approach of the night. Indeed, good deeds do away with misdeeds. That is a reminder for those who remember",
    normalizedText:
      "واقم الصلوة طرفي النهار وزلفا من اليل ان الحسنت يذهبن السيات ذلك ذكرى للذكرين",
  },
  {
    verseId: 114,
    name: "هود",
    surahId: 11,
    text: "وَٱصۡبِرۡ فَإِنَّ ٱللَّهَ لَا يُضِيعُ أَجۡرَ ٱلۡمُحۡسِنِينَ",
    translation:
      "And be patient, for indeed, Allah does not allow to be lost the reward of those who do good",
    normalizedText: "واصبر فان الله لا يضيع اجر المحسنين",
  },
  {
    verseId: 115,
    name: "هود",
    surahId: 11,
    text: "فَلَوۡلَا كَانَ مِنَ ٱلۡقُرُونِ مِن قَبۡلِكُمۡ أُوْلُواْ بَقِيَّةٖ يَنۡهَوۡنَ عَنِ ٱلۡفَسَادِ فِي ٱلۡأَرۡضِ إِلَّا قَلِيلٗا مِّمَّنۡ أَنجَيۡنَا مِنۡهُمۡۗ وَٱتَّبَعَ ٱلَّذِينَ ظَلَمُواْ مَآ أُتۡرِفُواْ فِيهِ وَكَانُواْ مُجۡرِمِينَ",
    translation:
      "So why were there not among the generations before you those of enduring discrimination forbidding corruption on earth - except a few of those We saved from among them? But those who wronged pursued what luxury they were given therein, and they were criminals",
    normalizedText:
      "فلولا كان من القرون من قبلكم اولوا بقية ينهون عن الفساد في الارض الا قليلا ممن انجينا منهم واتبع الذين ظلموا ما اترفوا فيه وكانوا مجرمين",
  },
  {
    verseId: 116,
    name: "هود",
    surahId: 11,
    text: "وَمَا كَانَ رَبُّكَ لِيُهۡلِكَ ٱلۡقُرَىٰ بِظُلۡمٖ وَأَهۡلُهَا مُصۡلِحُونَ",
    translation:
      "And your Lord would not have destroyed the cities unjustly while their people were reformers",
    normalizedText: "وما كان ربك ليهلك القرى بظلم واهلها مصلحون",
  },
  {
    verseId: 117,
    name: "هود",
    surahId: 11,
    text: "وَلَوۡ شَآءَ رَبُّكَ لَجَعَلَ ٱلنَّاسَ أُمَّةٗ وَٰحِدَةٗۖ وَلَا يَزَالُونَ مُخۡتَلِفِينَ",
    translation:
      "And if your Lord had willed, He could have made mankind one community; but they will not cease to differ",
    normalizedText: "ولو شاء ربك لجعل الناس امة وحدة ولا يزالون مختلفين",
  },
  {
    verseId: 118,
    name: "هود",
    surahId: 11,
    text: "إِلَّا مَن رَّحِمَ رَبُّكَۚ وَلِذَٰلِكَ خَلَقَهُمۡۗ وَتَمَّتۡ كَلِمَةُ رَبِّكَ لَأَمۡلَأَنَّ جَهَنَّمَ مِنَ ٱلۡجِنَّةِ وَٱلنَّاسِ أَجۡمَعِينَ",
    translation:
      'Except whom your Lord has given mercy, and for that He created them. But the word of your Lord is to be fulfilled that, "I will surely fill Hell with jinn and men all together',
    normalizedText:
      "الا من رحم ربك ولذلك خلقهم وتمت كلمة ربك لاملان جهنم من الجنة والناس اجمعين",
  },
  {
    verseId: 119,
    name: "هود",
    surahId: 11,
    text: "وَكُلّٗا نَّقُصُّ عَلَيۡكَ مِنۡ أَنۢبَآءِ ٱلرُّسُلِ مَا نُثَبِّتُ بِهِۦ فُؤَادَكَۚ وَجَآءَكَ فِي هَٰذِهِ ٱلۡحَقُّ وَمَوۡعِظَةٞ وَذِكۡرَىٰ لِلۡمُؤۡمِنِينَ",
    translation:
      "And each [story] We relate to you from the news of the messengers is that by which We make firm your heart. And there has come to you, in this, the truth and an instruction and a reminder for the believers",
    normalizedText:
      "وكلا نقص عليك من انباء الرسل ما نثبت به فاادك وجاءك في هذه الحق وموعظة وذكرى للمامنين",
  },
  {
    verseId: 120,
    name: "هود",
    surahId: 11,
    text: "وَقُل لِّلَّذِينَ لَا يُؤۡمِنُونَ ٱعۡمَلُواْ عَلَىٰ مَكَانَتِكُمۡ إِنَّا عَٰمِلُونَ",
    translation:
      'And say to those who do not believe, "Work according to your position; indeed, we are working',
    normalizedText: "وقل للذين لا يامنون اعملوا على مكانتكم انا عملون",
  },
  {
    verseId: 121,
    name: "هود",
    surahId: 11,
    text: "وَٱنتَظِرُوٓاْ إِنَّا مُنتَظِرُونَ",
    translation: "And wait, indeed, we are waiting",
    normalizedText: "وانتظروا انا منتظرون",
  },
  {
    verseId: 122,
    name: "هود",
    surahId: 11,
    text: "وَلِلَّهِ غَيۡبُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَإِلَيۡهِ يُرۡجَعُ ٱلۡأَمۡرُ كُلُّهُۥ فَٱعۡبُدۡهُ وَتَوَكَّلۡ عَلَيۡهِۚ وَمَا رَبُّكَ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ",
    translation:
      "And to Allah belong the unseen [aspects] of the heavens and the earth and to Him will be returned the matter, all of it, so worship Him and rely upon Him. And your Lord is not unaware of that which you do",
    normalizedText:
      "ولله غيب السموت والارض واليه يرجع الامر كله فاعبده وتوكل عليه وما ربك بغفل عما تعملون",
  },
  {
    verseId: 0,
    name: "يوسف",
    surahId: 12,
    text: "الٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡمُبِينِ",
    translation: "Alif, Lam, Ra. These are the verses of the clear Book",
    normalizedText: "الر تلك ءايت الكتب المبين",
  },
  {
    verseId: 1,
    name: "يوسف",
    surahId: 12,
    text: "إِنَّآ أَنزَلۡنَٰهُ قُرۡءَٰنًا عَرَبِيّٗا لَّعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      "Indeed, We have sent it down as an Arabic Qur'an that you might understand",
    normalizedText: "انا انزلنه قرءنا عربيا لعلكم تعقلون",
  },
  {
    verseId: 2,
    name: "يوسف",
    surahId: 12,
    text: "نَحۡنُ نَقُصُّ عَلَيۡكَ أَحۡسَنَ ٱلۡقَصَصِ بِمَآ أَوۡحَيۡنَآ إِلَيۡكَ هَٰذَا ٱلۡقُرۡءَانَ وَإِن كُنتَ مِن قَبۡلِهِۦ لَمِنَ ٱلۡغَٰفِلِينَ",
    translation:
      "We relate to you, [O Muhammad], the best of stories in what We have revealed to you of this Qur'an although you were, before it, among the unaware",
    normalizedText:
      "نحن نقص عليك احسن القصص بما اوحينا اليك هذا القرءان وان كنت من قبله لمن الغفلين",
  },
  {
    verseId: 3,
    name: "يوسف",
    surahId: 12,
    text: "إِذۡ قَالَ يُوسُفُ لِأَبِيهِ يَـٰٓأَبَتِ إِنِّي رَأَيۡتُ أَحَدَ عَشَرَ كَوۡكَبٗا وَٱلشَّمۡسَ وَٱلۡقَمَرَ رَأَيۡتُهُمۡ لِي سَٰجِدِينَ",
    translation:
      '[Of these stories mention] when Joseph said to his father, "O my father, indeed I have seen [in a dream] eleven stars and the sun and the moon; I saw them prostrating to me',
    normalizedText:
      "اذ قال يوسف لابيه يابت اني رايت احد عشر كوكبا والشمس والقمر رايتهم لي سجدين",
  },
  {
    verseId: 4,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ يَٰبُنَيَّ لَا تَقۡصُصۡ رُءۡيَاكَ عَلَىٰٓ إِخۡوَتِكَ فَيَكِيدُواْ لَكَ كَيۡدًاۖ إِنَّ ٱلشَّيۡطَٰنَ لِلۡإِنسَٰنِ عَدُوّٞ مُّبِينٞ",
    translation:
      'He said, "O my son, do not relate your vision to your brothers or they will contrive against you a plan. Indeed Satan, to man, is a manifest enemy',
    normalizedText:
      "قال يبني لا تقصص رءياك على اخوتك فيكيدوا لك كيدا ان الشيطن للانسن عدو مبين",
  },
  {
    verseId: 5,
    name: "يوسف",
    surahId: 12,
    text: "وَكَذَٰلِكَ يَجۡتَبِيكَ رَبُّكَ وَيُعَلِّمُكَ مِن تَأۡوِيلِ ٱلۡأَحَادِيثِ وَيُتِمُّ نِعۡمَتَهُۥ عَلَيۡكَ وَعَلَىٰٓ ءَالِ يَعۡقُوبَ كَمَآ أَتَمَّهَا عَلَىٰٓ أَبَوَيۡكَ مِن قَبۡلُ إِبۡرَٰهِيمَ وَإِسۡحَٰقَۚ إِنَّ رَبَّكَ عَلِيمٌ حَكِيمٞ",
    translation:
      "And thus will your Lord choose you and teach you the interpretation of narratives and complete His favor upon you and upon the family of Jacob, as He completed it upon your fathers before, Abraham and Isaac. Indeed, your Lord is Knowing and Wise",
    normalizedText:
      "وكذلك يجتبيك ربك ويعلمك من تاويل الاحاديث ويتم نعمته عليك وعلى ءال يعقوب كما اتمها على ابويك من قبل ابرهيم واسحق ان ربك عليم حكيم",
  },
  {
    verseId: 6,
    name: "يوسف",
    surahId: 12,
    text: "۞لَّقَدۡ كَانَ فِي يُوسُفَ وَإِخۡوَتِهِۦٓ ءَايَٰتٞ لِّلسَّآئِلِينَ",
    translation:
      "Certainly were there in Joseph and his brothers signs for those who ask",
    normalizedText: "۞لقد كان في يوسف واخوته ءايت للساالين",
  },
  {
    verseId: 7,
    name: "يوسف",
    surahId: 12,
    text: "إِذۡ قَالُواْ لَيُوسُفُ وَأَخُوهُ أَحَبُّ إِلَىٰٓ أَبِينَا مِنَّا وَنَحۡنُ عُصۡبَةٌ إِنَّ أَبَانَا لَفِي ضَلَٰلٖ مُّبِينٍ",
    translation:
      'When they said, "Joseph and his brother are more beloved to our father than we, while we are a clan. Indeed, our father is in clear error',
    normalizedText:
      "اذ قالوا ليوسف واخوه احب الى ابينا منا ونحن عصبة ان ابانا لفي ضلل مبين",
  },
  {
    verseId: 8,
    name: "يوسف",
    surahId: 12,
    text: "ٱقۡتُلُواْ يُوسُفَ أَوِ ٱطۡرَحُوهُ أَرۡضٗا يَخۡلُ لَكُمۡ وَجۡهُ أَبِيكُمۡ وَتَكُونُواْ مِنۢ بَعۡدِهِۦ قَوۡمٗا صَٰلِحِينَ",
    translation:
      "Kill Joseph or cast him out to [another] land; the countenance of your father will [then] be only for you, and you will be after that a righteous people",
    normalizedText:
      "اقتلوا يوسف او اطرحوه ارضا يخل لكم وجه ابيكم وتكونوا من بعده قوما صلحين",
  },
  {
    verseId: 9,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ قَآئِلٞ مِّنۡهُمۡ لَا تَقۡتُلُواْ يُوسُفَ وَأَلۡقُوهُ فِي غَيَٰبَتِ ٱلۡجُبِّ يَلۡتَقِطۡهُ بَعۡضُ ٱلسَّيَّارَةِ إِن كُنتُمۡ فَٰعِلِينَ",
    translation:
      'Said a speaker among them, "Do not kill Joseph but throw him into the bottom of the well; some travelers will pick him up - if you would do [something]',
    normalizedText:
      "قال قاال منهم لا تقتلوا يوسف والقوه في غيبت الجب يلتقطه بعض السيارة ان كنتم فعلين",
  },
  {
    verseId: 10,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ يَـٰٓأَبَانَا مَا لَكَ لَا تَأۡمَ۬نَّا عَلَىٰ يُوسُفَ وَإِنَّا لَهُۥ لَنَٰصِحُونَ",
    translation:
      'They said, "O our father, why do you not entrust us with Joseph while indeed, we are to him sincere counselors',
    normalizedText: "قالوا يابانا ما لك لا تامنا على يوسف وانا له لنصحون",
  },
  {
    verseId: 11,
    name: "يوسف",
    surahId: 12,
    text: "أَرۡسِلۡهُ مَعَنَا غَدٗا يَرۡتَعۡ وَيَلۡعَبۡ وَإِنَّا لَهُۥ لَحَٰفِظُونَ",
    translation:
      "Send him with us tomorrow that he may eat well and play. And indeed, we will be his guardians",
    normalizedText: "ارسله معنا غدا يرتع ويلعب وانا له لحفظون",
  },
  {
    verseId: 12,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ إِنِّي لَيَحۡزُنُنِيٓ أَن تَذۡهَبُواْ بِهِۦ وَأَخَافُ أَن يَأۡكُلَهُ ٱلذِّئۡبُ وَأَنتُمۡ عَنۡهُ غَٰفِلُونَ",
    translation:
      '[Jacob] said, "Indeed, it saddens me that you should take him, and I fear that a wolf would eat him while you are of him unaware',
    normalizedText:
      "قال اني ليحزنني ان تذهبوا به واخاف ان ياكله الذاب وانتم عنه غفلون",
  },
  {
    verseId: 13,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ لَئِنۡ أَكَلَهُ ٱلذِّئۡبُ وَنَحۡنُ عُصۡبَةٌ إِنَّآ إِذٗا لَّخَٰسِرُونَ",
    translation:
      'They said, "If a wolf should eat him while we are a [strong] clan, indeed, we would then be losers',
    normalizedText: "قالوا لان اكله الذاب ونحن عصبة انا اذا لخسرون",
  },
  {
    verseId: 14,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا ذَهَبُواْ بِهِۦ وَأَجۡمَعُوٓاْ أَن يَجۡعَلُوهُ فِي غَيَٰبَتِ ٱلۡجُبِّۚ وَأَوۡحَيۡنَآ إِلَيۡهِ لَتُنَبِّئَنَّهُم بِأَمۡرِهِمۡ هَٰذَا وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      'So when they took him [out] and agreed to put him into the bottom of the well... But We inspired to him, "You will surely inform them [someday] about this affair of theirs while they do not perceive [your identity]',
    normalizedText:
      "فلما ذهبوا به واجمعوا ان يجعلوه في غيبت الجب واوحينا اليه لتنبانهم بامرهم هذا وهم لا يشعرون",
  },
  {
    verseId: 15,
    name: "يوسف",
    surahId: 12,
    text: "وَجَآءُوٓ أَبَاهُمۡ عِشَآءٗ يَبۡكُونَ",
    translation: "And they came to their father at night, weeping",
    normalizedText: "وجاءو اباهم عشاء يبكون",
  },
  {
    verseId: 16,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ يَـٰٓأَبَانَآ إِنَّا ذَهَبۡنَا نَسۡتَبِقُ وَتَرَكۡنَا يُوسُفَ عِندَ مَتَٰعِنَا فَأَكَلَهُ ٱلذِّئۡبُۖ وَمَآ أَنتَ بِمُؤۡمِنٖ لَّنَا وَلَوۡ كُنَّا صَٰدِقِينَ",
    translation:
      'They said, "O our father, indeed we went racing each other and left Joseph with our possessions, and a wolf ate him. But you would not believe us, even if we were truthful',
    normalizedText:
      "قالوا يابانا انا ذهبنا نستبق وتركنا يوسف عند متعنا فاكله الذاب وما انت بمامن لنا ولو كنا صدقين",
  },
  {
    verseId: 17,
    name: "يوسف",
    surahId: 12,
    text: "وَجَآءُو عَلَىٰ قَمِيصِهِۦ بِدَمٖ كَذِبٖۚ قَالَ بَلۡ سَوَّلَتۡ لَكُمۡ أَنفُسُكُمۡ أَمۡرٗاۖ فَصَبۡرٞ جَمِيلٞۖ وَٱللَّهُ ٱلۡمُسۡتَعَانُ عَلَىٰ مَا تَصِفُونَ",
    translation:
      'And they brought upon his shirt false blood. [Jacob] said, "Rather, your souls have enticed you to something, so patience is most fitting. And Allah is the one sought for help against that which you describe',
    normalizedText:
      "وجاءو على قميصه بدم كذب قال بل سولت لكم انفسكم امرا فصبر جميل والله المستعان على ما تصفون",
  },
  {
    verseId: 18,
    name: "يوسف",
    surahId: 12,
    text: "وَجَآءَتۡ سَيَّارَةٞ فَأَرۡسَلُواْ وَارِدَهُمۡ فَأَدۡلَىٰ دَلۡوَهُۥۖ قَالَ يَٰبُشۡرَىٰ هَٰذَا غُلَٰمٞۚ وَأَسَرُّوهُ بِضَٰعَةٗۚ وَٱللَّهُ عَلِيمُۢ بِمَا يَعۡمَلُونَ",
    translation:
      'And there came a company of travelers; then they sent their water drawer, and he let down his bucket. He said, "Good news! Here is a boy." And they concealed him, [taking him] as merchandise; and Allah was knowing of what they did',
    normalizedText:
      "وجاءت سيارة فارسلوا واردهم فادلى دلوه قال يبشرى هذا غلم واسروه بضعة والله عليم بما يعملون",
  },
  {
    verseId: 19,
    name: "يوسف",
    surahId: 12,
    text: "وَشَرَوۡهُ بِثَمَنِۭ بَخۡسٖ دَرَٰهِمَ مَعۡدُودَةٖ وَكَانُواْ فِيهِ مِنَ ٱلزَّـٰهِدِينَ",
    translation:
      "And they sold him for a reduced price - a few dirhams - and they were, concerning him, of those content with little",
    normalizedText: "وشروه بثمن بخس درهم معدودة وكانوا فيه من الزهدين",
  },
  {
    verseId: 20,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ ٱلَّذِي ٱشۡتَرَىٰهُ مِن مِّصۡرَ لِٱمۡرَأَتِهِۦٓ أَكۡرِمِي مَثۡوَىٰهُ عَسَىٰٓ أَن يَنفَعَنَآ أَوۡ نَتَّخِذَهُۥ وَلَدٗاۚ وَكَذَٰلِكَ مَكَّنَّا لِيُوسُفَ فِي ٱلۡأَرۡضِ وَلِنُعَلِّمَهُۥ مِن تَأۡوِيلِ ٱلۡأَحَادِيثِۚ وَٱللَّهُ غَالِبٌ عَلَىٰٓ أَمۡرِهِۦ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      'And the one from Egypt who bought him said to his wife, "Make his residence comfortable. Perhaps he will benefit us, or we will adopt him as a son." And thus, We established Joseph in the land that We might teach him the interpretation of events. And Allah is predominant over His affair, but most of the people do not know',
    normalizedText:
      "وقال الذي اشترىه من مصر لامراته اكرمي مثوىه عسى ان ينفعنا او نتخذه ولدا وكذلك مكنا ليوسف في الارض ولنعلمه من تاويل الاحاديث والله غالب على امره ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 21,
    name: "يوسف",
    surahId: 12,
    text: "وَلَمَّا بَلَغَ أَشُدَّهُۥٓ ءَاتَيۡنَٰهُ حُكۡمٗا وَعِلۡمٗاۚ وَكَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation:
      "And when Joseph reached maturity, We gave him judgment and knowledge. And thus We reward the doers of good",
    normalizedText: "ولما بلغ اشده ءاتينه حكما وعلما وكذلك نجزي المحسنين",
  },
  {
    verseId: 22,
    name: "يوسف",
    surahId: 12,
    text: "وَرَٰوَدَتۡهُ ٱلَّتِي هُوَ فِي بَيۡتِهَا عَن نَّفۡسِهِۦ وَغَلَّقَتِ ٱلۡأَبۡوَٰبَ وَقَالَتۡ هَيۡتَ لَكَۚ قَالَ مَعَاذَ ٱللَّهِۖ إِنَّهُۥ رَبِّيٓ أَحۡسَنَ مَثۡوَايَۖ إِنَّهُۥ لَا يُفۡلِحُ ٱلظَّـٰلِمُونَ",
    translation:
      'And she, in whose house he was, sought to seduce him. She closed the doors and said, "Come, you." He said, "[I seek] the refuge of Allah. Indeed, he is my master, who has made good my residence. Indeed, wrongdoers will not succeed',
    normalizedText:
      "ورودته التي هو في بيتها عن نفسه وغلقت الابوب وقالت هيت لك قال معاذ الله انه ربي احسن مثواي انه لا يفلح الظلمون",
  },
  {
    verseId: 23,
    name: "يوسف",
    surahId: 12,
    text: "وَلَقَدۡ هَمَّتۡ بِهِۦۖ وَهَمَّ بِهَا لَوۡلَآ أَن رَّءَا بُرۡهَٰنَ رَبِّهِۦۚ كَذَٰلِكَ لِنَصۡرِفَ عَنۡهُ ٱلسُّوٓءَ وَٱلۡفَحۡشَآءَۚ إِنَّهُۥ مِنۡ عِبَادِنَا ٱلۡمُخۡلَصِينَ",
    translation:
      "And she certainly determined [to seduce] him, and he would have inclined to her had he not seen the proof of his Lord. And thus [it was] that We should avert from him evil and immorality. Indeed, he was of Our chosen servants",
    normalizedText:
      "ولقد همت به وهم بها لولا ان رءا برهن ربه كذلك لنصرف عنه السوء والفحشاء انه من عبادنا المخلصين",
  },
  {
    verseId: 24,
    name: "يوسف",
    surahId: 12,
    text: "وَٱسۡتَبَقَا ٱلۡبَابَ وَقَدَّتۡ قَمِيصَهُۥ مِن دُبُرٖ وَأَلۡفَيَا سَيِّدَهَا لَدَا ٱلۡبَابِۚ قَالَتۡ مَا جَزَآءُ مَنۡ أَرَادَ بِأَهۡلِكَ سُوٓءًا إِلَّآ أَن يُسۡجَنَ أَوۡ عَذَابٌ أَلِيمٞ",
    translation:
      'And they both raced to the door, and she tore his shirt from the back, and they found her husband at the door. She said, "What is the recompense of one who intended evil for your wife but that he be imprisoned or a painful punishment',
    normalizedText:
      "واستبقا الباب وقدت قميصه من دبر والفيا سيدها لدا الباب قالت ما جزاء من اراد باهلك سوءا الا ان يسجن او عذاب اليم",
  },
  {
    verseId: 25,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ هِيَ رَٰوَدَتۡنِي عَن نَّفۡسِيۚ وَشَهِدَ شَاهِدٞ مِّنۡ أَهۡلِهَآ إِن كَانَ قَمِيصُهُۥ قُدَّ مِن قُبُلٖ فَصَدَقَتۡ وَهُوَ مِنَ ٱلۡكَٰذِبِينَ",
    translation:
      '[Joseph] said, "It was she who sought to seduce me." And a witness from her family testified. "If his shirt is torn from the front, then she has told the truth, and he is of the liars',
    normalizedText:
      "قال هي رودتني عن نفسي وشهد شاهد من اهلها ان كان قميصه قد من قبل فصدقت وهو من الكذبين",
  },
  {
    verseId: 26,
    name: "يوسف",
    surahId: 12,
    text: "وَإِن كَانَ قَمِيصُهُۥ قُدَّ مِن دُبُرٖ فَكَذَبَتۡ وَهُوَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      "But if his shirt is torn from the back, then she has lied, and he is of the truthful",
    normalizedText: "وان كان قميصه قد من دبر فكذبت وهو من الصدقين",
  },
  {
    verseId: 27,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا رَءَا قَمِيصَهُۥ قُدَّ مِن دُبُرٖ قَالَ إِنَّهُۥ مِن كَيۡدِكُنَّۖ إِنَّ كَيۡدَكُنَّ عَظِيمٞ",
    translation: `So when her husband saw his shirt torn from the back, he said, "Indeed, it is of the women's plan. Indeed, your plan is great`,
    normalizedText: "فلما رءا قميصه قد من دبر قال انه من كيدكن ان كيدكن عظيم",
  },
  {
    verseId: 28,
    name: "يوسف",
    surahId: 12,
    text: "يُوسُفُ أَعۡرِضۡ عَنۡ هَٰذَاۚ وَٱسۡتَغۡفِرِي لِذَنۢبِكِۖ إِنَّكِ كُنتِ مِنَ ٱلۡخَاطِـِٔينَ",
    translation:
      "Joseph, ignore this. And, [my wife], ask forgiveness for your sin. Indeed, you were of the sinful",
    normalizedText: "يوسف اعرض عن هذا واستغفري لذنبك انك كنت من الخاطين",
  },
  {
    verseId: 29,
    name: "يوسف",
    surahId: 12,
    text: "۞وَقَالَ نِسۡوَةٞ فِي ٱلۡمَدِينَةِ ٱمۡرَأَتُ ٱلۡعَزِيزِ تُرَٰوِدُ فَتَىٰهَا عَن نَّفۡسِهِۦۖ قَدۡ شَغَفَهَا حُبًّاۖ إِنَّا لَنَرَىٰهَا فِي ضَلَٰلٖ مُّبِينٖ",
    translation: `And women in the city said, "The wife of al-'Azeez is seeking to seduce her slave boy; he has impassioned her with love. Indeed, we see her [to be] in clear error`,
    normalizedText:
      "۞وقال نسوة في المدينة امرات العزيز ترود فتىها عن نفسه قد شغفها حبا انا لنرىها في ضلل مبين",
  },
  {
    verseId: 30,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا سَمِعَتۡ بِمَكۡرِهِنَّ أَرۡسَلَتۡ إِلَيۡهِنَّ وَأَعۡتَدَتۡ لَهُنَّ مُتَّكَـٔٗا وَءَاتَتۡ كُلَّ وَٰحِدَةٖ مِّنۡهُنَّ سِكِّينٗا وَقَالَتِ ٱخۡرُجۡ عَلَيۡهِنَّۖ فَلَمَّا رَأَيۡنَهُۥٓ أَكۡبَرۡنَهُۥ وَقَطَّعۡنَ أَيۡدِيَهُنَّ وَقُلۡنَ حَٰشَ لِلَّهِ مَا هَٰذَا بَشَرًا إِنۡ هَٰذَآ إِلَّا مَلَكٞ كَرِيمٞ",
    translation:
      'So when she heard of their scheming, she sent for them and prepared for them a banquet and gave each one of them a knife and said [to Joseph], "Come out before them." And when they saw him, they greatly admired him and cut their hands and said, "Perfect is Allah! This is not a man; this is none but a noble angel',
    normalizedText:
      "فلما سمعت بمكرهن ارسلت اليهن واعتدت لهن متكا وءاتت كل وحدة منهن سكينا وقالت اخرج عليهن فلما راينه اكبرنه وقطعن ايديهن وقلن حش لله ما هذا بشرا ان هذا الا ملك كريم",
  },
  {
    verseId: 31,
    name: "يوسف",
    surahId: 12,
    text: "قَالَتۡ فَذَٰلِكُنَّ ٱلَّذِي لُمۡتُنَّنِي فِيهِۖ وَلَقَدۡ رَٰوَدتُّهُۥ عَن نَّفۡسِهِۦ فَٱسۡتَعۡصَمَۖ وَلَئِن لَّمۡ يَفۡعَلۡ مَآ ءَامُرُهُۥ لَيُسۡجَنَنَّ وَلَيَكُونٗا مِّنَ ٱلصَّـٰغِرِينَ",
    translation:
      'She said, "That is the one about whom you blamed me. And I certainly sought to seduce him, but he firmly refused; and if he will not do what I order him, he will surely be imprisoned and will be of those debased',
    normalizedText:
      "قالت فذلكن الذي لمتنني فيه ولقد رودته عن نفسه فاستعصم ولان لم يفعل ما ءامره ليسجنن وليكونا من الصغرين",
  },
  {
    verseId: 32,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ رَبِّ ٱلسِّجۡنُ أَحَبُّ إِلَيَّ مِمَّا يَدۡعُونَنِيٓ إِلَيۡهِۖ وَإِلَّا تَصۡرِفۡ عَنِّي كَيۡدَهُنَّ أَصۡبُ إِلَيۡهِنَّ وَأَكُن مِّنَ ٱلۡجَٰهِلِينَ",
    translation:
      'He said, "My Lord, prison is more to my liking than that to which they invite me. And if You do not avert from me their plan, I might incline toward them and [thus] be of the ignorant',
    normalizedText:
      "قال رب السجن احب الي مما يدعونني اليه والا تصرف عني كيدهن اصب اليهن واكن من الجهلين",
  },
  {
    verseId: 33,
    name: "يوسف",
    surahId: 12,
    text: "فَٱسۡتَجَابَ لَهُۥ رَبُّهُۥ فَصَرَفَ عَنۡهُ كَيۡدَهُنَّۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "So his Lord responded to him and averted from him their plan. Indeed, He is the Hearing, the Knowing",
    normalizedText: "فاستجاب له ربه فصرف عنه كيدهن انه هو السميع العليم",
  },
  {
    verseId: 34,
    name: "يوسف",
    surahId: 12,
    text: "ثُمَّ بَدَا لَهُم مِّنۢ بَعۡدِ مَا رَأَوُاْ ٱلۡأٓيَٰتِ لَيَسۡجُنُنَّهُۥ حَتَّىٰ حِينٖ",
    translation:
      "Then it appeared to them after they had seen the signs that al-'Azeez should surely imprison him for a time",
    normalizedText: "ثم بدا لهم من بعد ما راوا الايت ليسجننه حتى حين",
  },
  {
    verseId: 35,
    name: "يوسف",
    surahId: 12,
    text: "وَدَخَلَ مَعَهُ ٱلسِّجۡنَ فَتَيَانِۖ قَالَ أَحَدُهُمَآ إِنِّيٓ أَرَىٰنِيٓ أَعۡصِرُ خَمۡرٗاۖ وَقَالَ ٱلۡأٓخَرُ إِنِّيٓ أَرَىٰنِيٓ أَحۡمِلُ فَوۡقَ رَأۡسِي خُبۡزٗا تَأۡكُلُ ٱلطَّيۡرُ مِنۡهُۖ نَبِّئۡنَا بِتَأۡوِيلِهِۦٓۖ إِنَّا نَرَىٰكَ مِنَ ٱلۡمُحۡسِنِينَ",
    translation:
      'And there entered the prison with him two young men. One of them said, "Indeed, I have seen myself [in a dream] pressing wine." The other said, "Indeed, I have seen myself carrying upon my head [some] bread, from which the birds were eating. Inform us of its interpretation; indeed, we see you to be of those who do good',
    normalizedText:
      "ودخل معه السجن فتيان قال احدهما اني ارىني اعصر خمرا وقال الاخر اني ارىني احمل فوق راسي خبزا تاكل الطير منه نبانا بتاويله انا نرىك من المحسنين",
  },
  {
    verseId: 36,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ لَا يَأۡتِيكُمَا طَعَامٞ تُرۡزَقَانِهِۦٓ إِلَّا نَبَّأۡتُكُمَا بِتَأۡوِيلِهِۦ قَبۡلَ أَن يَأۡتِيَكُمَاۚ ذَٰلِكُمَا مِمَّا عَلَّمَنِي رَبِّيٓۚ إِنِّي تَرَكۡتُ مِلَّةَ قَوۡمٖ لَّا يُؤۡمِنُونَ بِٱللَّهِ وَهُم بِٱلۡأٓخِرَةِ هُمۡ كَٰفِرُونَ",
    translation:
      'He said, "You will not receive food that is provided to you except that I will inform you of its interpretation before it comes to you. That is from what my Lord has taught me. Indeed, I have left the religion of a people who do not believe in Allah, and they, in the Hereafter, are disbelievers',
    normalizedText:
      "قال لا ياتيكما طعام ترزقانه الا نباتكما بتاويله قبل ان ياتيكما ذلكما مما علمني ربي اني تركت ملة قوم لا يامنون بالله وهم بالاخرة هم كفرون",
  },
  {
    verseId: 37,
    name: "يوسف",
    surahId: 12,
    text: "وَٱتَّبَعۡتُ مِلَّةَ ءَابَآءِيٓ إِبۡرَٰهِيمَ وَإِسۡحَٰقَ وَيَعۡقُوبَۚ مَا كَانَ لَنَآ أَن نُّشۡرِكَ بِٱللَّهِ مِن شَيۡءٖۚ ذَٰلِكَ مِن فَضۡلِ ٱللَّهِ عَلَيۡنَا وَعَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَشۡكُرُونَ",
    translation:
      "And I have followed the religion of my fathers, Abraham, Isaac and Jacob. And it was not for us to associate anything with Allah. That is from the favor of Allah upon us and upon the people, but most of the people are not grateful",
    normalizedText:
      "واتبعت ملة ءاباءي ابرهيم واسحق ويعقوب ما كان لنا ان نشرك بالله من شيء ذلك من فضل الله علينا وعلى الناس ولكن اكثر الناس لا يشكرون",
  },
  {
    verseId: 38,
    name: "يوسف",
    surahId: 12,
    text: "يَٰصَٰحِبَيِ ٱلسِّجۡنِ ءَأَرۡبَابٞ مُّتَفَرِّقُونَ خَيۡرٌ أَمِ ٱللَّهُ ٱلۡوَٰحِدُ ٱلۡقَهَّارُ",
    translation:
      "O [my] two companions of prison, are separate lords better or Allah, the One, the Prevailing",
    normalizedText: "يصحبي السجن ءارباب متفرقون خير ام الله الوحد القهار",
  },
  {
    verseId: 39,
    name: "يوسف",
    surahId: 12,
    text: "مَا تَعۡبُدُونَ مِن دُونِهِۦٓ إِلَّآ أَسۡمَآءٗ سَمَّيۡتُمُوهَآ أَنتُمۡ وَءَابَآؤُكُم مَّآ أَنزَلَ ٱللَّهُ بِهَا مِن سُلۡطَٰنٍۚ إِنِ ٱلۡحُكۡمُ إِلَّا لِلَّهِ أَمَرَ أَلَّا تَعۡبُدُوٓاْ إِلَّآ إِيَّاهُۚ ذَٰلِكَ ٱلدِّينُ ٱلۡقَيِّمُ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      "You worship not besides Him except [mere] names you have named them, you and your fathers, for which Allah has sent down no authority. Legislation is not but for Allah. He has commanded that you worship not except Him. That is the correct religion, but most of the people do not know",
    normalizedText:
      "ما تعبدون من دونه الا اسماء سميتموها انتم وءابااكم ما انزل الله بها من سلطن ان الحكم الا لله امر الا تعبدوا الا اياه ذلك الدين القيم ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 40,
    name: "يوسف",
    surahId: 12,
    text: "يَٰصَٰحِبَيِ ٱلسِّجۡنِ أَمَّآ أَحَدُكُمَا فَيَسۡقِي رَبَّهُۥ خَمۡرٗاۖ وَأَمَّا ٱلۡأٓخَرُ فَيُصۡلَبُ فَتَأۡكُلُ ٱلطَّيۡرُ مِن رَّأۡسِهِۦۚ قُضِيَ ٱلۡأَمۡرُ ٱلَّذِي فِيهِ تَسۡتَفۡتِيَانِ",
    translation:
      "O two companions of prison, as for one of you, he will give drink to his master of wine; but as for the other, he will be crucified, and the birds will eat from his head. The matter has been decreed about which you both inquire",
    normalizedText:
      "يصحبي السجن اما احدكما فيسقي ربه خمرا واما الاخر فيصلب فتاكل الطير من راسه قضي الامر الذي فيه تستفتيان",
  },
  {
    verseId: 41,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ لِلَّذِي ظَنَّ أَنَّهُۥ نَاجٖ مِّنۡهُمَا ٱذۡكُرۡنِي عِندَ رَبِّكَ فَأَنسَىٰهُ ٱلشَّيۡطَٰنُ ذِكۡرَ رَبِّهِۦ فَلَبِثَ فِي ٱلسِّجۡنِ بِضۡعَ سِنِينَ",
    translation:
      'And he said to the one whom he knew would go free, "Mention me before your master." But Satan made him forget the mention [to] his master, and Joseph remained in prison several years',
    normalizedText:
      "وقال للذي ظن انه ناج منهما اذكرني عند ربك فانسىه الشيطن ذكر ربه فلبث في السجن بضع سنين",
  },
  {
    verseId: 42,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ ٱلۡمَلِكُ إِنِّيٓ أَرَىٰ سَبۡعَ بَقَرَٰتٖ سِمَانٖ يَأۡكُلُهُنَّ سَبۡعٌ عِجَافٞ وَسَبۡعَ سُنۢبُلَٰتٍ خُضۡرٖ وَأُخَرَ يَابِسَٰتٖۖ يَـٰٓأَيُّهَا ٱلۡمَلَأُ أَفۡتُونِي فِي رُءۡيَٰيَ إِن كُنتُمۡ لِلرُّءۡيَا تَعۡبُرُونَ",
    translation:
      'And [subsequently] the king said, "Indeed, I have seen [in a dream] seven fat cows being eaten by seven [that were] lean, and seven green spikes [of grain] and others [that were] dry. O eminent ones, explain to me my vision, if you should interpret visions',
    normalizedText:
      "وقال الملك اني ارى سبع بقرت سمان ياكلهن سبع عجاف وسبع سنبلت خضر واخر يابست يايها الملا افتوني في رءيي ان كنتم للرءيا تعبرون",
  },
  {
    verseId: 43,
    name: "يوسف",
    surahId: 12,
    text: "قَالُوٓاْ أَضۡغَٰثُ أَحۡلَٰمٖۖ وَمَا نَحۡنُ بِتَأۡوِيلِ ٱلۡأَحۡلَٰمِ بِعَٰلِمِينَ",
    translation:
      'They said, "[It is but] a mixture of false dreams, and we are not learned in the interpretation of dreams',
    normalizedText: "قالوا اضغث احلم وما نحن بتاويل الاحلم بعلمين",
  },
  {
    verseId: 44,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ ٱلَّذِي نَجَا مِنۡهُمَا وَٱدَّكَرَ بَعۡدَ أُمَّةٍ أَنَا۠ أُنَبِّئُكُم بِتَأۡوِيلِهِۦ فَأَرۡسِلُونِ",
    translation:
      'But the one who was freed and remembered after a time said, "I will inform you of its interpretation, so send me forth',
    normalizedText:
      "وقال الذي نجا منهما وادكر بعد امة انا انباكم بتاويله فارسلون",
  },
  {
    verseId: 45,
    name: "يوسف",
    surahId: 12,
    text: "يُوسُفُ أَيُّهَا ٱلصِّدِّيقُ أَفۡتِنَا فِي سَبۡعِ بَقَرَٰتٖ سِمَانٖ يَأۡكُلُهُنَّ سَبۡعٌ عِجَافٞ وَسَبۡعِ سُنۢبُلَٰتٍ خُضۡرٖ وَأُخَرَ يَابِسَٰتٖ لَّعَلِّيٓ أَرۡجِعُ إِلَى ٱلنَّاسِ لَعَلَّهُمۡ يَعۡلَمُونَ",
    translation:
      '[He said], "Joseph, O man of truth, explain to us about seven fat cows eaten by seven [that were] lean, and seven green spikes [of grain] and others [that were] dry - that I may return to the people; perhaps they will know [about you]',
    normalizedText:
      "يوسف ايها الصديق افتنا في سبع بقرت سمان ياكلهن سبع عجاف وسبع سنبلت خضر واخر يابست لعلي ارجع الى الناس لعلهم يعلمون",
  },
  {
    verseId: 46,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ تَزۡرَعُونَ سَبۡعَ سِنِينَ دَأَبٗا فَمَا حَصَدتُّمۡ فَذَرُوهُ فِي سُنۢبُلِهِۦٓ إِلَّا قَلِيلٗا مِّمَّا تَأۡكُلُونَ",
    translation:
      '[Joseph] said, "You will plant for seven years consecutively; and what you harvest leave in its spikes, except a little from which you will eat',
    normalizedText:
      "قال تزرعون سبع سنين دابا فما حصدتم فذروه في سنبله الا قليلا مما تاكلون",
  },
  {
    verseId: 47,
    name: "يوسف",
    surahId: 12,
    text: "ثُمَّ يَأۡتِي مِنۢ بَعۡدِ ذَٰلِكَ سَبۡعٞ شِدَادٞ يَأۡكُلۡنَ مَا قَدَّمۡتُمۡ لَهُنَّ إِلَّا قَلِيلٗا مِّمَّا تُحۡصِنُونَ",
    translation:
      "Then will come after that seven difficult [years] which will consume what you saved for them, except a little from which you will store",
    normalizedText:
      "ثم ياتي من بعد ذلك سبع شداد ياكلن ما قدمتم لهن الا قليلا مما تحصنون",
  },
  {
    verseId: 48,
    name: "يوسف",
    surahId: 12,
    text: "ثُمَّ يَأۡتِي مِنۢ بَعۡدِ ذَٰلِكَ عَامٞ فِيهِ يُغَاثُ ٱلنَّاسُ وَفِيهِ يَعۡصِرُونَ",
    translation:
      "Then will come after that a year in which the people will be given rain and in which they will press [olives and grapes]",
    normalizedText: "ثم ياتي من بعد ذلك عام فيه يغاث الناس وفيه يعصرون",
  },
  {
    verseId: 49,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ ٱلۡمَلِكُ ٱئۡتُونِي بِهِۦۖ فَلَمَّا جَآءَهُ ٱلرَّسُولُ قَالَ ٱرۡجِعۡ إِلَىٰ رَبِّكَ فَسۡـَٔلۡهُ مَا بَالُ ٱلنِّسۡوَةِ ٱلَّـٰتِي قَطَّعۡنَ أَيۡدِيَهُنَّۚ إِنَّ رَبِّي بِكَيۡدِهِنَّ عَلِيمٞ",
    translation:
      'And the king said, "Bring him to me." But when the messenger came to him, [Joseph] said, "Return to your master and ask him what is the case of the women who cut their hands. Indeed, my Lord is Knowing of their plan',
    normalizedText:
      "وقال الملك ااتوني به فلما جاءه الرسول قال ارجع الى ربك فسله ما بال النسوة التي قطعن ايديهن ان ربي بكيدهن عليم",
  },
  {
    verseId: 50,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ مَا خَطۡبُكُنَّ إِذۡ رَٰوَدتُّنَّ يُوسُفَ عَن نَّفۡسِهِۦۚ قُلۡنَ حَٰشَ لِلَّهِ مَا عَلِمۡنَا عَلَيۡهِ مِن سُوٓءٖۚ قَالَتِ ٱمۡرَأَتُ ٱلۡعَزِيزِ ٱلۡـَٰٔنَ حَصۡحَصَ ٱلۡحَقُّ أَنَا۠ رَٰوَدتُّهُۥ عَن نَّفۡسِهِۦ وَإِنَّهُۥ لَمِنَ ٱلصَّـٰدِقِينَ",
    translation: `Said [the king to the women], "What was your condition when you sought to seduce Joseph?" They said, "Perfect is Allah! We know about him no evil." The wife of al-'Azeez said, "Now the truth has become evident. It was I who sought to seduce him, and indeed, he is of the truthful`,
    normalizedText:
      "قال ما خطبكن اذ رودتن يوسف عن نفسه قلن حش لله ما علمنا عليه من سوء قالت امرات العزيز الن حصحص الحق انا رودته عن نفسه وانه لمن الصدقين",
  },
  {
    verseId: 51,
    name: "يوسف",
    surahId: 12,
    text: "ذَٰلِكَ لِيَعۡلَمَ أَنِّي لَمۡ أَخُنۡهُ بِٱلۡغَيۡبِ وَأَنَّ ٱللَّهَ لَا يَهۡدِي كَيۡدَ ٱلۡخَآئِنِينَ",
    translation:
      "That is so al-'Azeez will know that I did not betray him in [his] absence and that Allah does not guide the plan of betrayers",
    normalizedText:
      "ذلك ليعلم اني لم اخنه بالغيب وان الله لا يهدي كيد الخاانين",
  },
  {
    verseId: 52,
    name: "يوسف",
    surahId: 12,
    text: "۞وَمَآ أُبَرِّئُ نَفۡسِيٓۚ إِنَّ ٱلنَّفۡسَ لَأَمَّارَةُۢ بِٱلسُّوٓءِ إِلَّا مَا رَحِمَ رَبِّيٓۚ إِنَّ رَبِّي غَفُورٞ رَّحِيمٞ",
    translation:
      "And I do not acquit myself. Indeed, the soul is a persistent enjoiner of evil, except those upon which my Lord has mercy. Indeed, my Lord is Forgiving and Merciful",
    normalizedText:
      "۞وما ابرا نفسي ان النفس لامارة بالسوء الا ما رحم ربي ان ربي غفور رحيم",
  },
  {
    verseId: 53,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ ٱلۡمَلِكُ ٱئۡتُونِي بِهِۦٓ أَسۡتَخۡلِصۡهُ لِنَفۡسِيۖ فَلَمَّا كَلَّمَهُۥ قَالَ إِنَّكَ ٱلۡيَوۡمَ لَدَيۡنَا مَكِينٌ أَمِينٞ",
    translation:
      'And the king said, "Bring him to me; I will appoint him exclusively for myself." And when he spoke to him, he said, "Indeed, you are today established [in position] and trusted',
    normalizedText:
      "وقال الملك ااتوني به استخلصه لنفسي فلما كلمه قال انك اليوم لدينا مكين امين",
  },
  {
    verseId: 54,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ ٱجۡعَلۡنِي عَلَىٰ خَزَآئِنِ ٱلۡأَرۡضِۖ إِنِّي حَفِيظٌ عَلِيمٞ",
    translation:
      '[Joseph] said, "Appoint me over the storehouses of the land. Indeed, I will be a knowing guardian',
    normalizedText: "قال اجعلني على خزاان الارض اني حفيظ عليم",
  },
  {
    verseId: 55,
    name: "يوسف",
    surahId: 12,
    text: "وَكَذَٰلِكَ مَكَّنَّا لِيُوسُفَ فِي ٱلۡأَرۡضِ يَتَبَوَّأُ مِنۡهَا حَيۡثُ يَشَآءُۚ نُصِيبُ بِرَحۡمَتِنَا مَن نَّشَآءُۖ وَلَا نُضِيعُ أَجۡرَ ٱلۡمُحۡسِنِينَ",
    translation:
      "And thus We established Joseph in the land to settle therein wherever he willed. We touch with Our mercy whom We will, and We do not allow to be lost the reward of those who do good",
    normalizedText:
      "وكذلك مكنا ليوسف في الارض يتبوا منها حيث يشاء نصيب برحمتنا من نشاء ولا نضيع اجر المحسنين",
  },
  {
    verseId: 56,
    name: "يوسف",
    surahId: 12,
    text: "وَلَأَجۡرُ ٱلۡأٓخِرَةِ خَيۡرٞ لِّلَّذِينَ ءَامَنُواْ وَكَانُواْ يَتَّقُونَ",
    translation:
      "And the reward of the Hereafter is better for those who believed and were fearing Allah",
    normalizedText: "ولاجر الاخرة خير للذين ءامنوا وكانوا يتقون",
  },
  {
    verseId: 57,
    name: "يوسف",
    surahId: 12,
    text: "وَجَآءَ إِخۡوَةُ يُوسُفَ فَدَخَلُواْ عَلَيۡهِ فَعَرَفَهُمۡ وَهُمۡ لَهُۥ مُنكِرُونَ",
    translation:
      "And the brothers of Joseph came [seeking food], and they entered upon him; and he recognized them, but he was to them unknown",
    normalizedText: "وجاء اخوة يوسف فدخلوا عليه فعرفهم وهم له منكرون",
  },
  {
    verseId: 58,
    name: "يوسف",
    surahId: 12,
    text: "وَلَمَّا جَهَّزَهُم بِجَهَازِهِمۡ قَالَ ٱئۡتُونِي بِأَخٖ لَّكُم مِّنۡ أَبِيكُمۡۚ أَلَا تَرَوۡنَ أَنِّيٓ أُوفِي ٱلۡكَيۡلَ وَأَنَا۠ خَيۡرُ ٱلۡمُنزِلِينَ",
    translation:
      'And when he had furnished them with their supplies, he said, "Bring me a brother of yours from your father. Do not you see that I give full measure and that I am the best of accommodators',
    normalizedText:
      "ولما جهزهم بجهازهم قال ااتوني باخ لكم من ابيكم الا ترون اني اوفي الكيل وانا خير المنزلين",
  },
  {
    verseId: 59,
    name: "يوسف",
    surahId: 12,
    text: "فَإِن لَّمۡ تَأۡتُونِي بِهِۦ فَلَا كَيۡلَ لَكُمۡ عِندِي وَلَا تَقۡرَبُونِ",
    translation:
      "But if you do not bring him to me, no measure will there be [hereafter] for you from me, nor will you approach me",
    normalizedText: "فان لم تاتوني به فلا كيل لكم عندي ولا تقربون",
  },
  {
    verseId: 60,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ سَنُرَٰوِدُ عَنۡهُ أَبَاهُ وَإِنَّا لَفَٰعِلُونَ",
    translation:
      'They said, "We will attempt to dissuade his father from [keeping] him, and indeed, we will do [it]',
    normalizedText: "قالوا سنرود عنه اباه وانا لفعلون",
  },
  {
    verseId: 61,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ لِفِتۡيَٰنِهِ ٱجۡعَلُواْ بِضَٰعَتَهُمۡ فِي رِحَالِهِمۡ لَعَلَّهُمۡ يَعۡرِفُونَهَآ إِذَا ٱنقَلَبُوٓاْ إِلَىٰٓ أَهۡلِهِمۡ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      'And [Joseph] said to his servants, "Put their merchandise into their saddlebags so they might recognize it when they have gone back to their people that perhaps they will [again] return',
    normalizedText:
      "وقال لفتينه اجعلوا بضعتهم في رحالهم لعلهم يعرفونها اذا انقلبوا الى اهلهم لعلهم يرجعون",
  },
  {
    verseId: 62,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا رَجَعُوٓاْ إِلَىٰٓ أَبِيهِمۡ قَالُواْ يَـٰٓأَبَانَا مُنِعَ مِنَّا ٱلۡكَيۡلُ فَأَرۡسِلۡ مَعَنَآ أَخَانَا نَكۡتَلۡ وَإِنَّا لَهُۥ لَحَٰفِظُونَ",
    translation:
      'So when they returned to their father, they said, "O our father, [further] measure has been denied to us, so send with us our brother [that] we will be given measure. And indeed, we will be his guardians',
    normalizedText:
      "فلما رجعوا الى ابيهم قالوا يابانا منع منا الكيل فارسل معنا اخانا نكتل وانا له لحفظون",
  },
  {
    verseId: 63,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ هَلۡ ءَامَنُكُمۡ عَلَيۡهِ إِلَّا كَمَآ أَمِنتُكُمۡ عَلَىٰٓ أَخِيهِ مِن قَبۡلُ فَٱللَّهُ خَيۡرٌ حَٰفِظٗاۖ وَهُوَ أَرۡحَمُ ٱلرَّـٰحِمِينَ",
    translation:
      'He said, "Should I entrust you with him except [under coercion] as I entrusted you with his brother before? But Allah is the best guardian, and He is the most merciful of the merciful',
    normalizedText:
      "قال هل ءامنكم عليه الا كما امنتكم على اخيه من قبل فالله خير حفظا وهو ارحم الرحمين",
  },
  {
    verseId: 64,
    name: "يوسف",
    surahId: 12,
    text: "وَلَمَّا فَتَحُواْ مَتَٰعَهُمۡ وَجَدُواْ بِضَٰعَتَهُمۡ رُدَّتۡ إِلَيۡهِمۡۖ قَالُواْ يَـٰٓأَبَانَا مَا نَبۡغِيۖ هَٰذِهِۦ بِضَٰعَتُنَا رُدَّتۡ إِلَيۡنَاۖ وَنَمِيرُ أَهۡلَنَا وَنَحۡفَظُ أَخَانَا وَنَزۡدَادُ كَيۡلَ بَعِيرٖۖ ذَٰلِكَ كَيۡلٞ يَسِيرٞ",
    translation: `And when they opened their baggage, they found their merchandise returned to them. They said, "O our father, what [more] could we desire? This is our merchandise returned to us. And we will obtain supplies for our family and protect our brother and obtain an increase of a camel's load; that is an easy measurement`,
    normalizedText:
      "ولما فتحوا متعهم وجدوا بضعتهم ردت اليهم قالوا يابانا ما نبغي هذه بضعتنا ردت الينا ونمير اهلنا ونحفظ اخانا ونزداد كيل بعير ذلك كيل يسير",
  },
  {
    verseId: 65,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ لَنۡ أُرۡسِلَهُۥ مَعَكُمۡ حَتَّىٰ تُؤۡتُونِ مَوۡثِقٗا مِّنَ ٱللَّهِ لَتَأۡتُنَّنِي بِهِۦٓ إِلَّآ أَن يُحَاطَ بِكُمۡۖ فَلَمَّآ ءَاتَوۡهُ مَوۡثِقَهُمۡ قَالَ ٱللَّهُ عَلَىٰ مَا نَقُولُ وَكِيلٞ",
    translation:
      '[Jacob] said, "Never will I send him with you until you give me a promise by Allah that you will bring him [back] to me, unless you should be surrounded by enemies." And when they had given their promise, he said, "Allah, over what we say, is Witness',
    normalizedText:
      "قال لن ارسله معكم حتى تاتون موثقا من الله لتاتنني به الا ان يحاط بكم فلما ءاتوه موثقهم قال الله على ما نقول وكيل",
  },
  {
    verseId: 66,
    name: "يوسف",
    surahId: 12,
    text: "وَقَالَ يَٰبَنِيَّ لَا تَدۡخُلُواْ مِنۢ بَابٖ وَٰحِدٖ وَٱدۡخُلُواْ مِنۡ أَبۡوَٰبٖ مُّتَفَرِّقَةٖۖ وَمَآ أُغۡنِي عَنكُم مِّنَ ٱللَّهِ مِن شَيۡءٍۖ إِنِ ٱلۡحُكۡمُ إِلَّا لِلَّهِۖ عَلَيۡهِ تَوَكَّلۡتُۖ وَعَلَيۡهِ فَلۡيَتَوَكَّلِ ٱلۡمُتَوَكِّلُونَ",
    translation:
      'And he said, "O my sons, do not enter from one gate but enter from different gates; and I cannot avail you against [the decree of] Allah at all. The decision is only for Allah; upon Him I have relied, and upon Him let those who would rely [indeed] rely',
    normalizedText:
      "وقال يبني لا تدخلوا من باب وحد وادخلوا من ابوب متفرقة وما اغني عنكم من الله من شيء ان الحكم الا لله عليه توكلت وعليه فليتوكل المتوكلون",
  },
  {
    verseId: 67,
    name: "يوسف",
    surahId: 12,
    text: "وَلَمَّا دَخَلُواْ مِنۡ حَيۡثُ أَمَرَهُمۡ أَبُوهُم مَّا كَانَ يُغۡنِي عَنۡهُم مِّنَ ٱللَّهِ مِن شَيۡءٍ إِلَّا حَاجَةٗ فِي نَفۡسِ يَعۡقُوبَ قَضَىٰهَاۚ وَإِنَّهُۥ لَذُو عِلۡمٖ لِّمَا عَلَّمۡنَٰهُ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      "And when they entered from where their father had ordered them, it did not avail them against Allah at all except [it was] a need within the soul of Jacob, which he satisfied. And indeed, he was a possessor of knowledge because of what We had taught him, but most of the people do not know",
    normalizedText:
      "ولما دخلوا من حيث امرهم ابوهم ما كان يغني عنهم من الله من شيء الا حاجة في نفس يعقوب قضىها وانه لذو علم لما علمنه ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 68,
    name: "يوسف",
    surahId: 12,
    text: "وَلَمَّا دَخَلُواْ عَلَىٰ يُوسُفَ ءَاوَىٰٓ إِلَيۡهِ أَخَاهُۖ قَالَ إِنِّيٓ أَنَا۠ أَخُوكَ فَلَا تَبۡتَئِسۡ بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      'And when they entered upon Joseph, he took his brother to himself; he said, "Indeed, I am your brother, so do not despair over what they used to do [to me]',
    normalizedText:
      "ولما دخلوا على يوسف ءاوى اليه اخاه قال اني انا اخوك فلا تبتاس بما كانوا يعملون",
  },
  {
    verseId: 69,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا جَهَّزَهُم بِجَهَازِهِمۡ جَعَلَ ٱلسِّقَايَةَ فِي رَحۡلِ أَخِيهِ ثُمَّ أَذَّنَ مُؤَذِّنٌ أَيَّتُهَا ٱلۡعِيرُ إِنَّكُمۡ لَسَٰرِقُونَ",
    translation:
      'So when he had furnished them with their supplies, he put the [gold measuring] bowl into the bag of his brother. Then an announcer called out, "O caravan, indeed you are thieves',
    normalizedText:
      "فلما جهزهم بجهازهم جعل السقاية في رحل اخيه ثم اذن ماذن ايتها العير انكم لسرقون",
  },
  {
    verseId: 70,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ وَأَقۡبَلُواْ عَلَيۡهِم مَّاذَا تَفۡقِدُونَ",
    translation:
      'They said while approaching them, "What is it you are missing',
    normalizedText: "قالوا واقبلوا عليهم ماذا تفقدون",
  },
  {
    verseId: 71,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ نَفۡقِدُ صُوَاعَ ٱلۡمَلِكِ وَلِمَن جَآءَ بِهِۦ حِمۡلُ بَعِيرٖ وَأَنَا۠ بِهِۦ زَعِيمٞ",
    translation: `They said, "We are missing the measure of the king. And for he who produces it is [the reward of] a camel's load, and I am responsible for it`,
    normalizedText: "قالوا نفقد صواع الملك ولمن جاء به حمل بعير وانا به زعيم",
  },
  {
    verseId: 72,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ تَٱللَّهِ لَقَدۡ عَلِمۡتُم مَّا جِئۡنَا لِنُفۡسِدَ فِي ٱلۡأَرۡضِ وَمَا كُنَّا سَٰرِقِينَ",
    translation:
      'They said, "By Allah, you have certainly known that we did not come to cause corruption in the land, and we have not been thieves',
    normalizedText:
      "قالوا تالله لقد علمتم ما جانا لنفسد في الارض وما كنا سرقين",
  },
  {
    verseId: 73,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ فَمَا جَزَـٰٓؤُهُۥٓ إِن كُنتُمۡ كَٰذِبِينَ",
    translation:
      'The accusers said, "Then what would be its recompense if you should be liars',
    normalizedText: "قالوا فما جزاه ان كنتم كذبين",
  },
  {
    verseId: 74,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ جَزَـٰٓؤُهُۥ مَن وُجِدَ فِي رَحۡلِهِۦ فَهُوَ جَزَـٰٓؤُهُۥۚ كَذَٰلِكَ نَجۡزِي ٱلظَّـٰلِمِينَ",
    translation:
      '[The brothers] said, "Its recompense is that he in whose bag it is found - he [himself] will be its recompense. Thus do we recompense the wrongdoers',
    normalizedText: "قالوا جزاه من وجد في رحله فهو جزاه كذلك نجزي الظلمين",
  },
  {
    verseId: 75,
    name: "يوسف",
    surahId: 12,
    text: "فَبَدَأَ بِأَوۡعِيَتِهِمۡ قَبۡلَ وِعَآءِ أَخِيهِ ثُمَّ ٱسۡتَخۡرَجَهَا مِن وِعَآءِ أَخِيهِۚ كَذَٰلِكَ كِدۡنَا لِيُوسُفَۖ مَا كَانَ لِيَأۡخُذَ أَخَاهُ فِي دِينِ ٱلۡمَلِكِ إِلَّآ أَن يَشَآءَ ٱللَّهُۚ نَرۡفَعُ دَرَجَٰتٖ مَّن نَّشَآءُۗ وَفَوۡقَ كُلِّ ذِي عِلۡمٍ عَلِيمٞ",
    translation:
      "So he began [the search] with their bags before the bag of his brother; then he extracted it from the bag of his brother. Thus did We plan for Joseph. He could not have taken his brother within the religion of the king except that Allah willed. We raise in degrees whom We will, but over every possessor of knowledge is one [more] knowing",
    normalizedText:
      "فبدا باوعيتهم قبل وعاء اخيه ثم استخرجها من وعاء اخيه كذلك كدنا ليوسف ما كان لياخذ اخاه في دين الملك الا ان يشاء الله نرفع درجت من نشاء وفوق كل ذي علم عليم",
  },
  {
    verseId: 76,
    name: "يوسف",
    surahId: 12,
    text: "۞قَالُوٓاْ إِن يَسۡرِقۡ فَقَدۡ سَرَقَ أَخٞ لَّهُۥ مِن قَبۡلُۚ فَأَسَرَّهَا يُوسُفُ فِي نَفۡسِهِۦ وَلَمۡ يُبۡدِهَا لَهُمۡۚ قَالَ أَنتُمۡ شَرّٞ مَّكَانٗاۖ وَٱللَّهُ أَعۡلَمُ بِمَا تَصِفُونَ",
    translation:
      'They said, "If he steals - a brother of his has stolen before." But Joseph kept it within himself and did not reveal it to them. He said, "You are worse in position, and Allah is most knowing of what you describe',
    normalizedText:
      "۞قالوا ان يسرق فقد سرق اخ له من قبل فاسرها يوسف في نفسه ولم يبدها لهم قال انتم شر مكانا والله اعلم بما تصفون",
  },
  {
    verseId: 77,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ يَـٰٓأَيُّهَا ٱلۡعَزِيزُ إِنَّ لَهُۥٓ أَبٗا شَيۡخٗا كَبِيرٗا فَخُذۡ أَحَدَنَا مَكَانَهُۥٓۖ إِنَّا نَرَىٰكَ مِنَ ٱلۡمُحۡسِنِينَ",
    translation: `They said, "O 'Azeez, indeed he has a father [who is] an old man, so take one of us in place of him. Indeed, we see you as a doer of good`,
    normalizedText:
      "قالوا يايها العزيز ان له ابا شيخا كبيرا فخذ احدنا مكانه انا نرىك من المحسنين",
  },
  {
    verseId: 78,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ مَعَاذَ ٱللَّهِ أَن نَّأۡخُذَ إِلَّا مَن وَجَدۡنَا مَتَٰعَنَا عِندَهُۥٓ إِنَّآ إِذٗا لَّظَٰلِمُونَ",
    translation:
      'He said, "[I seek] the refuge of Allah [to prevent] that we take except him with whom we found our possession. Indeed, we would then be unjust',
    normalizedText:
      "قال معاذ الله ان ناخذ الا من وجدنا متعنا عنده انا اذا لظلمون",
  },
  {
    verseId: 79,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا ٱسۡتَيۡـَٔسُواْ مِنۡهُ خَلَصُواْ نَجِيّٗاۖ قَالَ كَبِيرُهُمۡ أَلَمۡ تَعۡلَمُوٓاْ أَنَّ أَبَاكُمۡ قَدۡ أَخَذَ عَلَيۡكُم مَّوۡثِقٗا مِّنَ ٱللَّهِ وَمِن قَبۡلُ مَا فَرَّطتُمۡ فِي يُوسُفَۖ فَلَنۡ أَبۡرَحَ ٱلۡأَرۡضَ حَتَّىٰ يَأۡذَنَ لِيٓ أَبِيٓ أَوۡ يَحۡكُمَ ٱللَّهُ لِيۖ وَهُوَ خَيۡرُ ٱلۡحَٰكِمِينَ",
    translation:
      'So when they had despaired of him, they secluded themselves in private consultation. The eldest of them said, "Do you not know that your father has taken upon you an oath by Allah and [that] before you failed in [your duty to] Joseph? So I will never leave [this] land until my father permits me or Allah decides for me, and He is the best of judges',
    normalizedText:
      "فلما استيسوا منه خلصوا نجيا قال كبيرهم الم تعلموا ان اباكم قد اخذ عليكم موثقا من الله ومن قبل ما فرطتم في يوسف فلن ابرح الارض حتى ياذن لي ابي او يحكم الله لي وهو خير الحكمين",
  },
  {
    verseId: 80,
    name: "يوسف",
    surahId: 12,
    text: "ٱرۡجِعُوٓاْ إِلَىٰٓ أَبِيكُمۡ فَقُولُواْ يَـٰٓأَبَانَآ إِنَّ ٱبۡنَكَ سَرَقَ وَمَا شَهِدۡنَآ إِلَّا بِمَا عَلِمۡنَا وَمَا كُنَّا لِلۡغَيۡبِ حَٰفِظِينَ",
    translation:
      'Return to your father and say, "O our father, indeed your son has stolen, and we did not testify except to what we knew. And we were not witnesses of the unseen',
    normalizedText:
      "ارجعوا الى ابيكم فقولوا يابانا ان ابنك سرق وما شهدنا الا بما علمنا وما كنا للغيب حفظين",
  },
  {
    verseId: 81,
    name: "يوسف",
    surahId: 12,
    text: "وَسۡـَٔلِ ٱلۡقَرۡيَةَ ٱلَّتِي كُنَّا فِيهَا وَٱلۡعِيرَ ٱلَّتِيٓ أَقۡبَلۡنَا فِيهَاۖ وَإِنَّا لَصَٰدِقُونَ",
    translation:
      "And ask the city in which we were and the caravan in which we came - and indeed, we are truthful",
    normalizedText:
      "وسل القرية التي كنا فيها والعير التي اقبلنا فيها وانا لصدقون",
  },
  {
    verseId: 82,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ بَلۡ سَوَّلَتۡ لَكُمۡ أَنفُسُكُمۡ أَمۡرٗاۖ فَصَبۡرٞ جَمِيلٌۖ عَسَى ٱللَّهُ أَن يَأۡتِيَنِي بِهِمۡ جَمِيعًاۚ إِنَّهُۥ هُوَ ٱلۡعَلِيمُ ٱلۡحَكِيمُ",
    translation:
      '[Jacob] said, "Rather, your souls have enticed you to something, so patience is most fitting. Perhaps Allah will bring them to me all together. Indeed it is He who is the Knowing, the Wise',
    normalizedText:
      "قال بل سولت لكم انفسكم امرا فصبر جميل عسى الله ان ياتيني بهم جميعا انه هو العليم الحكيم",
  },
  {
    verseId: 83,
    name: "يوسف",
    surahId: 12,
    text: "وَتَوَلَّىٰ عَنۡهُمۡ وَقَالَ يَـٰٓأَسَفَىٰ عَلَىٰ يُوسُفَ وَٱبۡيَضَّتۡ عَيۡنَاهُ مِنَ ٱلۡحُزۡنِ فَهُوَ كَظِيمٞ",
    translation:
      'And he turned away from them and said, "Oh, my sorrow over Joseph," and his eyes became white from grief, for he was [of that] a suppressor',
    normalizedText:
      "وتولى عنهم وقال ياسفى على يوسف وابيضت عيناه من الحزن فهو كظيم",
  },
  {
    verseId: 84,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ تَٱللَّهِ تَفۡتَؤُاْ تَذۡكُرُ يُوسُفَ حَتَّىٰ تَكُونَ حَرَضًا أَوۡ تَكُونَ مِنَ ٱلۡهَٰلِكِينَ",
    translation:
      'They said, "By Allah, you will not cease remembering Joseph until you become fatally ill or become of those who perish',
    normalizedText:
      "قالوا تالله تفتاا تذكر يوسف حتى تكون حرضا او تكون من الهلكين",
  },
  {
    verseId: 85,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ إِنَّمَآ أَشۡكُواْ بَثِّي وَحُزۡنِيٓ إِلَى ٱللَّهِ وَأَعۡلَمُ مِنَ ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      'He said, "I only complain of my suffering and my grief to Allah, and I know from Allah that which you do not know',
    normalizedText:
      "قال انما اشكوا بثي وحزني الى الله واعلم من الله ما لا تعلمون",
  },
  {
    verseId: 86,
    name: "يوسف",
    surahId: 12,
    text: "يَٰبَنِيَّ ٱذۡهَبُواْ فَتَحَسَّسُواْ مِن يُوسُفَ وَأَخِيهِ وَلَا تَاْيۡـَٔسُواْ مِن رَّوۡحِ ٱللَّهِۖ إِنَّهُۥ لَا يَاْيۡـَٔسُ مِن رَّوۡحِ ٱللَّهِ إِلَّا ٱلۡقَوۡمُ ٱلۡكَٰفِرُونَ",
    translation:
      "O my sons, go and find out about Joseph and his brother and despair not of relief from Allah. Indeed, no one despairs of relief from Allah except the disbelieving people",
    normalizedText:
      "يبني اذهبوا فتحسسوا من يوسف واخيه ولا تايسوا من روح الله انه لا يايس من روح الله الا القوم الكفرون",
  },
  {
    verseId: 87,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا دَخَلُواْ عَلَيۡهِ قَالُواْ يَـٰٓأَيُّهَا ٱلۡعَزِيزُ مَسَّنَا وَأَهۡلَنَا ٱلضُّرُّ وَجِئۡنَا بِبِضَٰعَةٖ مُّزۡجَىٰةٖ فَأَوۡفِ لَنَا ٱلۡكَيۡلَ وَتَصَدَّقۡ عَلَيۡنَآۖ إِنَّ ٱللَّهَ يَجۡزِي ٱلۡمُتَصَدِّقِينَ",
    translation: `So when they entered upon Joseph, they said, "O 'Azeez, adversity has touched us and our family, and we have come with goods poor in quality, but give us full measure and be charitable to us. Indeed, Allah rewards the charitable`,
    normalizedText:
      "فلما دخلوا عليه قالوا يايها العزيز مسنا واهلنا الضر وجانا ببضعة مزجىة فاوف لنا الكيل وتصدق علينا ان الله يجزي المتصدقين",
  },
  {
    verseId: 88,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ هَلۡ عَلِمۡتُم مَّا فَعَلۡتُم بِيُوسُفَ وَأَخِيهِ إِذۡ أَنتُمۡ جَٰهِلُونَ",
    translation:
      'He said, "Do you know what you did with Joseph and his brother when you were ignorant',
    normalizedText: "قال هل علمتم ما فعلتم بيوسف واخيه اذ انتم جهلون",
  },
  {
    verseId: 89,
    name: "يوسف",
    surahId: 12,
    text: "قَالُوٓاْ أَءِنَّكَ لَأَنتَ يُوسُفُۖ قَالَ أَنَا۠ يُوسُفُ وَهَٰذَآ أَخِيۖ قَدۡ مَنَّ ٱللَّهُ عَلَيۡنَآۖ إِنَّهُۥ مَن يَتَّقِ وَيَصۡبِرۡ فَإِنَّ ٱللَّهَ لَا يُضِيعُ أَجۡرَ ٱلۡمُحۡسِنِينَ",
    translation:
      'They said, "Are you indeed Joseph?" He said "I am Joseph, and this is my brother. Allah has certainly favored us. Indeed, he who fears Allah and is patient, then indeed, Allah does not allow to be lost the reward of those who do good',
    normalizedText:
      "قالوا اءنك لانت يوسف قال انا يوسف وهذا اخي قد من الله علينا انه من يتق ويصبر فان الله لا يضيع اجر المحسنين",
  },
  {
    verseId: 90,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ تَٱللَّهِ لَقَدۡ ءَاثَرَكَ ٱللَّهُ عَلَيۡنَا وَإِن كُنَّا لَخَٰطِـِٔينَ",
    translation:
      'They said, "By Allah, certainly has Allah preferred you over us, and indeed, we have been sinners',
    normalizedText: "قالوا تالله لقد ءاثرك الله علينا وان كنا لخطين",
  },
  {
    verseId: 91,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ لَا تَثۡرِيبَ عَلَيۡكُمُ ٱلۡيَوۡمَۖ يَغۡفِرُ ٱللَّهُ لَكُمۡۖ وَهُوَ أَرۡحَمُ ٱلرَّـٰحِمِينَ",
    translation:
      'He said, "No blame will there be upon you today. Allah will forgive you; and He is the most merciful of the merciful',
    normalizedText: "قال لا تثريب عليكم اليوم يغفر الله لكم وهو ارحم الرحمين",
  },
  {
    verseId: 92,
    name: "يوسف",
    surahId: 12,
    text: "ٱذۡهَبُواْ بِقَمِيصِي هَٰذَا فَأَلۡقُوهُ عَلَىٰ وَجۡهِ أَبِي يَأۡتِ بَصِيرٗا وَأۡتُونِي بِأَهۡلِكُمۡ أَجۡمَعِينَ",
    translation:
      "Take this, my shirt, and cast it over the face of my father; he will become seeing. And bring me your family, all together",
    normalizedText:
      "اذهبوا بقميصي هذا فالقوه على وجه ابي يات بصيرا واتوني باهلكم اجمعين",
  },
  {
    verseId: 93,
    name: "يوسف",
    surahId: 12,
    text: "وَلَمَّا فَصَلَتِ ٱلۡعِيرُ قَالَ أَبُوهُمۡ إِنِّي لَأَجِدُ رِيحَ يُوسُفَۖ لَوۡلَآ أَن تُفَنِّدُونِ",
    translation:
      'And when the caravan departed [from Egypt], their father said, "Indeed, I find the smell of Joseph [and would say that he was alive] if you did not think me weakened in mind',
    normalizedText:
      "ولما فصلت العير قال ابوهم اني لاجد ريح يوسف لولا ان تفندون",
  },
  {
    verseId: 94,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ تَٱللَّهِ إِنَّكَ لَفِي ضَلَٰلِكَ ٱلۡقَدِيمِ",
    translation:
      'They said, "By Allah, indeed you are in your [same] old error',
    normalizedText: "قالوا تالله انك لفي ضللك القديم",
  },
  {
    verseId: 95,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّآ أَن جَآءَ ٱلۡبَشِيرُ أَلۡقَىٰهُ عَلَىٰ وَجۡهِهِۦ فَٱرۡتَدَّ بَصِيرٗاۖ قَالَ أَلَمۡ أَقُل لَّكُمۡ إِنِّيٓ أَعۡلَمُ مِنَ ٱللَّهِ مَا لَا تَعۡلَمُونَ",
    translation:
      'And when the bearer of good tidings arrived, he cast it over his face, and he returned [once again] seeing. He said, "Did I not tell you that I know from Allah that which you do not know',
    normalizedText:
      "فلما ان جاء البشير القىه على وجهه فارتد بصيرا قال الم اقل لكم اني اعلم من الله ما لا تعلمون",
  },
  {
    verseId: 96,
    name: "يوسف",
    surahId: 12,
    text: "قَالُواْ يَـٰٓأَبَانَا ٱسۡتَغۡفِرۡ لَنَا ذُنُوبَنَآ إِنَّا كُنَّا خَٰطِـِٔينَ",
    translation:
      'They said, "O our father, ask for us forgiveness of our sins; indeed, we have been sinners',
    normalizedText: "قالوا يابانا استغفر لنا ذنوبنا انا كنا خطين",
  },
  {
    verseId: 97,
    name: "يوسف",
    surahId: 12,
    text: "قَالَ سَوۡفَ أَسۡتَغۡفِرُ لَكُمۡ رَبِّيٓۖ إِنَّهُۥ هُوَ ٱلۡغَفُورُ ٱلرَّحِيمُ",
    translation:
      'He said, "I will ask forgiveness for you from my Lord. Indeed, it is He who is the Forgiving, the Merciful',
    normalizedText: "قال سوف استغفر لكم ربي انه هو الغفور الرحيم",
  },
  {
    verseId: 98,
    name: "يوسف",
    surahId: 12,
    text: "فَلَمَّا دَخَلُواْ عَلَىٰ يُوسُفَ ءَاوَىٰٓ إِلَيۡهِ أَبَوَيۡهِ وَقَالَ ٱدۡخُلُواْ مِصۡرَ إِن شَآءَ ٱللَّهُ ءَامِنِينَ",
    translation:
      'And when they entered upon Joseph, he took his parents to himself and said, "Enter Egypt, Allah willing, safe [and secure]',
    normalizedText:
      "فلما دخلوا على يوسف ءاوى اليه ابويه وقال ادخلوا مصر ان شاء الله ءامنين",
  },
  {
    verseId: 99,
    name: "يوسف",
    surahId: 12,
    text: "وَرَفَعَ أَبَوَيۡهِ عَلَى ٱلۡعَرۡشِ وَخَرُّواْ لَهُۥ سُجَّدٗاۖ وَقَالَ يَـٰٓأَبَتِ هَٰذَا تَأۡوِيلُ رُءۡيَٰيَ مِن قَبۡلُ قَدۡ جَعَلَهَا رَبِّي حَقّٗاۖ وَقَدۡ أَحۡسَنَ بِيٓ إِذۡ أَخۡرَجَنِي مِنَ ٱلسِّجۡنِ وَجَآءَ بِكُم مِّنَ ٱلۡبَدۡوِ مِنۢ بَعۡدِ أَن نَّزَغَ ٱلشَّيۡطَٰنُ بَيۡنِي وَبَيۡنَ إِخۡوَتِيٓۚ إِنَّ رَبِّي لَطِيفٞ لِّمَا يَشَآءُۚ إِنَّهُۥ هُوَ ٱلۡعَلِيمُ ٱلۡحَكِيمُ",
    translation:
      'And he raised his parents upon the throne, and they bowed to him in prostration. And he said, "O my father, this is the explanation of my vision of before. My Lord has made it reality. And He was certainly good to me when He took me out of prison and brought you [here] from bedouin life after Satan had induced [estrangement] between me and my brothers. Indeed, my Lord is Subtle in what He wills. Indeed, it is He who is the Knowing, the Wise',
    normalizedText:
      "ورفع ابويه على العرش وخروا له سجدا وقال يابت هذا تاويل رءيي من قبل قد جعلها ربي حقا وقد احسن بي اذ اخرجني من السجن وجاء بكم من البدو من بعد ان نزغ الشيطن بيني وبين اخوتي ان ربي لطيف لما يشاء انه هو العليم الحكيم",
  },
  {
    verseId: 100,
    name: "يوسف",
    surahId: 12,
    text: "۞رَبِّ قَدۡ ءَاتَيۡتَنِي مِنَ ٱلۡمُلۡكِ وَعَلَّمۡتَنِي مِن تَأۡوِيلِ ٱلۡأَحَادِيثِۚ فَاطِرَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ أَنتَ وَلِيِّۦ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِۖ تَوَفَّنِي مُسۡلِمٗا وَأَلۡحِقۡنِي بِٱلصَّـٰلِحِينَ",
    translation:
      "My Lord, You have given me [something] of sovereignty and taught me of the interpretation of dreams. Creator of the heavens and earth, You are my protector in this world and in the Hereafter. Cause me to die a Muslim and join me with the righteous",
    normalizedText:
      "۞رب قد ءاتيتني من الملك وعلمتني من تاويل الاحاديث فاطر السموت والارض انت ولي في الدنيا والاخرة توفني مسلما والحقني بالصلحين",
  },
  {
    verseId: 101,
    name: "يوسف",
    surahId: 12,
    text: "ذَٰلِكَ مِنۡ أَنۢبَآءِ ٱلۡغَيۡبِ نُوحِيهِ إِلَيۡكَۖ وَمَا كُنتَ لَدَيۡهِمۡ إِذۡ أَجۡمَعُوٓاْ أَمۡرَهُمۡ وَهُمۡ يَمۡكُرُونَ",
    translation:
      "That is from the news of the unseen which We reveal, [O Muhammad], to you. And you were not with them when they put together their plan while they conspired",
    normalizedText:
      "ذلك من انباء الغيب نوحيه اليك وما كنت لديهم اذ اجمعوا امرهم وهم يمكرون",
  },
  {
    verseId: 102,
    name: "يوسف",
    surahId: 12,
    text: "وَمَآ أَكۡثَرُ ٱلنَّاسِ وَلَوۡ حَرَصۡتَ بِمُؤۡمِنِينَ",
    translation:
      "And most of the people, although you strive [for it], are not believers",
    normalizedText: "وما اكثر الناس ولو حرصت بمامنين",
  },
  {
    verseId: 103,
    name: "يوسف",
    surahId: 12,
    text: "وَمَا تَسۡـَٔلُهُمۡ عَلَيۡهِ مِنۡ أَجۡرٍۚ إِنۡ هُوَ إِلَّا ذِكۡرٞ لِّلۡعَٰلَمِينَ",
    translation:
      "And you do not ask of them for it any payment. It is not except a reminder to the worlds",
    normalizedText: "وما تسلهم عليه من اجر ان هو الا ذكر للعلمين",
  },
  {
    verseId: 104,
    name: "يوسف",
    surahId: 12,
    text: "وَكَأَيِّن مِّنۡ ءَايَةٖ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ يَمُرُّونَ عَلَيۡهَا وَهُمۡ عَنۡهَا مُعۡرِضُونَ",
    translation:
      "And how many a sign within the heavens and earth do they pass over while they, therefrom, are turning away",
    normalizedText:
      "وكاين من ءاية في السموت والارض يمرون عليها وهم عنها معرضون",
  },
  {
    verseId: 105,
    name: "يوسف",
    surahId: 12,
    text: "وَمَا يُؤۡمِنُ أَكۡثَرُهُم بِٱللَّهِ إِلَّا وَهُم مُّشۡرِكُونَ",
    translation:
      "And most of them believe not in Allah except while they associate others with Him",
    normalizedText: "وما يامن اكثرهم بالله الا وهم مشركون",
  },
  {
    verseId: 106,
    name: "يوسف",
    surahId: 12,
    text: "أَفَأَمِنُوٓاْ أَن تَأۡتِيَهُمۡ غَٰشِيَةٞ مِّنۡ عَذَابِ ٱللَّهِ أَوۡ تَأۡتِيَهُمُ ٱلسَّاعَةُ بَغۡتَةٗ وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      "Then do they feel secure that there will not come to them an overwhelming [aspect] of the punishment of Allah or that the Hour will not come upon them suddenly while they do not perceive",
    normalizedText:
      "افامنوا ان تاتيهم غشية من عذاب الله او تاتيهم الساعة بغتة وهم لا يشعرون",
  },
  {
    verseId: 107,
    name: "يوسف",
    surahId: 12,
    text: "قُلۡ هَٰذِهِۦ سَبِيلِيٓ أَدۡعُوٓاْ إِلَى ٱللَّهِۚ عَلَىٰ بَصِيرَةٍ أَنَا۠ وَمَنِ ٱتَّبَعَنِيۖ وَسُبۡحَٰنَ ٱللَّهِ وَمَآ أَنَا۠ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      'Say, "This is my way; I invite to Allah with insight, I and those who follow me. And exalted is Allah; and I am not of those who associate others with Him',
    normalizedText:
      "قل هذه سبيلي ادعوا الى الله على بصيرة انا ومن اتبعني وسبحن الله وما انا من المشركين",
  },
  {
    verseId: 108,
    name: "يوسف",
    surahId: 12,
    text: "وَمَآ أَرۡسَلۡنَا مِن قَبۡلِكَ إِلَّا رِجَالٗا نُّوحِيٓ إِلَيۡهِم مِّنۡ أَهۡلِ ٱلۡقُرَىٰٓۗ أَفَلَمۡ يَسِيرُواْ فِي ٱلۡأَرۡضِ فَيَنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبۡلِهِمۡۗ وَلَدَارُ ٱلۡأٓخِرَةِ خَيۡرٞ لِّلَّذِينَ ٱتَّقَوۡاْۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "And We sent not before you [as messengers] except men to whom We revealed from among the people of cities. So have they not traveled through the earth and observed how was the end of those before them? And the home of the Hereafter is best for those who fear Allah; then will you not reason",
    normalizedText:
      "وما ارسلنا من قبلك الا رجالا نوحي اليهم من اهل القرى افلم يسيروا في الارض فينظروا كيف كان عقبة الذين من قبلهم ولدار الاخرة خير للذين اتقوا افلا تعقلون",
  },
  {
    verseId: 109,
    name: "يوسف",
    surahId: 12,
    text: "حَتَّىٰٓ إِذَا ٱسۡتَيۡـَٔسَ ٱلرُّسُلُ وَظَنُّوٓاْ أَنَّهُمۡ قَدۡ كُذِبُواْ جَآءَهُمۡ نَصۡرُنَا فَنُجِّيَ مَن نَّشَآءُۖ وَلَا يُرَدُّ بَأۡسُنَا عَنِ ٱلۡقَوۡمِ ٱلۡمُجۡرِمِينَ",
    translation:
      "[They continued] until, when the messengers despaired and were certain that they had been denied, there came to them Our victory, and whoever We willed was saved. And Our punishment cannot be repelled from the people who are criminals",
    normalizedText:
      "حتى اذا استيس الرسل وظنوا انهم قد كذبوا جاءهم نصرنا فنجي من نشاء ولا يرد باسنا عن القوم المجرمين",
  },
  {
    verseId: 110,
    name: "يوسف",
    surahId: 12,
    text: "لَقَدۡ كَانَ فِي قَصَصِهِمۡ عِبۡرَةٞ لِّأُوْلِي ٱلۡأَلۡبَٰبِۗ مَا كَانَ حَدِيثٗا يُفۡتَرَىٰ وَلَٰكِن تَصۡدِيقَ ٱلَّذِي بَيۡنَ يَدَيۡهِ وَتَفۡصِيلَ كُلِّ شَيۡءٖ وَهُدٗى وَرَحۡمَةٗ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "There was certainly in their stories a lesson for those of understanding. Never was the Qur'an a narration invented, but a confirmation of what was before it and a detailed explanation of all things and guidance and mercy for a people who believe",
    normalizedText:
      "لقد كان في قصصهم عبرة لاولي الالبب ما كان حديثا يفترى ولكن تصديق الذي بين يديه وتفصيل كل شيء وهدى ورحمة لقوم يامنون",
  },
  {
    verseId: 0,
    name: "الرعد",
    surahId: 13,
    text: "الٓمٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِۗ وَٱلَّذِيٓ أُنزِلَ إِلَيۡكَ مِن رَّبِّكَ ٱلۡحَقُّ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يُؤۡمِنُونَ",
    translation:
      "Alif, Lam, Meem, Ra. These are the verses of the Book; and what has been revealed to you from your Lord is the truth, but most of the people do not believe",
    normalizedText:
      "المر تلك ءايت الكتب والذي انزل اليك من ربك الحق ولكن اكثر الناس لا يامنون",
  },
  {
    verseId: 1,
    name: "الرعد",
    surahId: 13,
    text: "ٱللَّهُ ٱلَّذِي رَفَعَ ٱلسَّمَٰوَٰتِ بِغَيۡرِ عَمَدٖ تَرَوۡنَهَاۖ ثُمَّ ٱسۡتَوَىٰ عَلَى ٱلۡعَرۡشِۖ وَسَخَّرَ ٱلشَّمۡسَ وَٱلۡقَمَرَۖ كُلّٞ يَجۡرِي لِأَجَلٖ مُّسَمّٗىۚ يُدَبِّرُ ٱلۡأَمۡرَ يُفَصِّلُ ٱلۡأٓيَٰتِ لَعَلَّكُم بِلِقَآءِ رَبِّكُمۡ تُوقِنُونَ",
    translation:
      "It is Allah who erected the heavens without pillars that you [can] see; then He established Himself above the Throne and made subject the sun and the moon, each running [its course] for a specified term. He arranges [each] matter; He details the signs that you may, of the meeting with your Lord, be certain",
    normalizedText:
      "الله الذي رفع السموت بغير عمد ترونها ثم استوى على العرش وسخر الشمس والقمر كل يجري لاجل مسمى يدبر الامر يفصل الايت لعلكم بلقاء ربكم توقنون",
  },
  {
    verseId: 2,
    name: "الرعد",
    surahId: 13,
    text: "وَهُوَ ٱلَّذِي مَدَّ ٱلۡأَرۡضَ وَجَعَلَ فِيهَا رَوَٰسِيَ وَأَنۡهَٰرٗاۖ وَمِن كُلِّ ٱلثَّمَرَٰتِ جَعَلَ فِيهَا زَوۡجَيۡنِ ٱثۡنَيۡنِۖ يُغۡشِي ٱلَّيۡلَ ٱلنَّهَارَۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَتَفَكَّرُونَ",
    translation:
      "And it is He who spread the earth and placed therein firmly set mountains and rivers; and from all of the fruits He made therein two mates; He causes the night to cover the day. Indeed in that are signs for a people who give thought",
    normalizedText:
      "وهو الذي مد الارض وجعل فيها روسي وانهرا ومن كل الثمرت جعل فيها زوجين اثنين يغشي اليل النهار ان في ذلك لايت لقوم يتفكرون",
  },
  {
    verseId: 3,
    name: "الرعد",
    surahId: 13,
    text: "وَفِي ٱلۡأَرۡضِ قِطَعٞ مُّتَجَٰوِرَٰتٞ وَجَنَّـٰتٞ مِّنۡ أَعۡنَٰبٖ وَزَرۡعٞ وَنَخِيلٞ صِنۡوَانٞ وَغَيۡرُ صِنۡوَانٖ يُسۡقَىٰ بِمَآءٖ وَٰحِدٖ وَنُفَضِّلُ بَعۡضَهَا عَلَىٰ بَعۡضٖ فِي ٱلۡأُكُلِۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "And within the land are neighboring plots and gardens of grapevines and crops and palm trees, [growing] several from a root or otherwise, watered with one water; but We make some of them exceed others in [quality of] fruit. Indeed in that are signs for a people who reason",
    normalizedText:
      "وفي الارض قطع متجورت وجنت من اعنب وزرع ونخيل صنوان وغير صنوان يسقى بماء وحد ونفضل بعضها على بعض في الاكل ان في ذلك لايت لقوم يعقلون",
  },
  {
    verseId: 4,
    name: "الرعد",
    surahId: 13,
    text: "۞وَإِن تَعۡجَبۡ فَعَجَبٞ قَوۡلُهُمۡ أَءِذَا كُنَّا تُرَٰبًا أَءِنَّا لَفِي خَلۡقٖ جَدِيدٍۗ أُوْلَـٰٓئِكَ ٱلَّذِينَ كَفَرُواْ بِرَبِّهِمۡۖ وَأُوْلَـٰٓئِكَ ٱلۡأَغۡلَٰلُ فِيٓ أَعۡنَاقِهِمۡۖ وَأُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      'And if you are astonished, [O Muhammad] - then astonishing is their saying, "When we are dust, will we indeed be [brought] into a new creation?" Those are the ones who have disbelieved in their Lord, and those will have shackles upon their necks, and those are the companions of the Fire; they will abide therein eternally',
    normalizedText:
      "۞وان تعجب فعجب قولهم اءذا كنا تربا اءنا لفي خلق جديد اولاك الذين كفروا بربهم واولاك الاغلل في اعناقهم واولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 5,
    name: "الرعد",
    surahId: 13,
    text: "وَيَسۡتَعۡجِلُونَكَ بِٱلسَّيِّئَةِ قَبۡلَ ٱلۡحَسَنَةِ وَقَدۡ خَلَتۡ مِن قَبۡلِهِمُ ٱلۡمَثُلَٰتُۗ وَإِنَّ رَبَّكَ لَذُو مَغۡفِرَةٖ لِّلنَّاسِ عَلَىٰ ظُلۡمِهِمۡۖ وَإِنَّ رَبَّكَ لَشَدِيدُ ٱلۡعِقَابِ",
    translation:
      "They impatiently urge you to bring about evil before good, while there has already occurred before them similar punishments [to what they demand]. And indeed, your Lord is full of forgiveness for the people despite their wrongdoing, and indeed, your Lord is severe in penalty",
    normalizedText:
      "ويستعجلونك بالسياة قبل الحسنة وقد خلت من قبلهم المثلت وان ربك لذو مغفرة للناس على ظلمهم وان ربك لشديد العقاب",
  },
  {
    verseId: 6,
    name: "الرعد",
    surahId: 13,
    text: "وَيَقُولُ ٱلَّذِينَ كَفَرُواْ لَوۡلَآ أُنزِلَ عَلَيۡهِ ءَايَةٞ مِّن رَّبِّهِۦٓۗ إِنَّمَآ أَنتَ مُنذِرٞۖ وَلِكُلِّ قَوۡمٍ هَادٍ",
    translation:
      'And those who disbelieved say, "Why has a sign not been sent down to him from his Lord?" You are only a warner, and for every people is a guide',
    normalizedText:
      "ويقول الذين كفروا لولا انزل عليه ءاية من ربه انما انت منذر ولكل قوم هاد",
  },
  {
    verseId: 7,
    name: "الرعد",
    surahId: 13,
    text: "ٱللَّهُ يَعۡلَمُ مَا تَحۡمِلُ كُلُّ أُنثَىٰ وَمَا تَغِيضُ ٱلۡأَرۡحَامُ وَمَا تَزۡدَادُۚ وَكُلُّ شَيۡءٍ عِندَهُۥ بِمِقۡدَارٍ",
    translation:
      "Allah knows what every female carries and what the wombs lose [prematurely] or exceed. And everything with Him is by due measure",
    normalizedText:
      "الله يعلم ما تحمل كل انثى وما تغيض الارحام وما تزداد وكل شيء عنده بمقدار",
  },
  {
    verseId: 8,
    name: "الرعد",
    surahId: 13,
    text: "عَٰلِمُ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ ٱلۡكَبِيرُ ٱلۡمُتَعَالِ",
    translation:
      "[He is] Knower of the unseen and the witnessed, the Grand, the Exalted",
    normalizedText: "علم الغيب والشهدة الكبير المتعال",
  },
  {
    verseId: 9,
    name: "الرعد",
    surahId: 13,
    text: "سَوَآءٞ مِّنكُم مَّنۡ أَسَرَّ ٱلۡقَوۡلَ وَمَن جَهَرَ بِهِۦ وَمَنۡ هُوَ مُسۡتَخۡفِۭ بِٱلَّيۡلِ وَسَارِبُۢ بِٱلنَّهَارِ",
    translation:
      "It is the same [to Him] concerning you whether one conceals [his] speech or one publicizes it and whether one is hidden by night or conspicuous [among others] by day",
    normalizedText:
      "سواء منكم من اسر القول ومن جهر به ومن هو مستخف باليل وسارب بالنهار",
  },
  {
    verseId: 10,
    name: "الرعد",
    surahId: 13,
    text: "لَهُۥ مُعَقِّبَٰتٞ مِّنۢ بَيۡنِ يَدَيۡهِ وَمِنۡ خَلۡفِهِۦ يَحۡفَظُونَهُۥ مِنۡ أَمۡرِ ٱللَّهِۗ إِنَّ ٱللَّهَ لَا يُغَيِّرُ مَا بِقَوۡمٍ حَتَّىٰ يُغَيِّرُواْ مَا بِأَنفُسِهِمۡۗ وَإِذَآ أَرَادَ ٱللَّهُ بِقَوۡمٖ سُوٓءٗا فَلَا مَرَدَّ لَهُۥۚ وَمَا لَهُم مِّن دُونِهِۦ مِن وَالٍ",
    translation:
      "For each one are successive [angels] before and behind him who protect him by the decree of Allah. Indeed, Allah will not change the condition of a people until they change what is in themselves. And when Allah intends for a people ill, there is no repelling it. And there is not for them besides Him any patron",
    normalizedText:
      "له معقبت من بين يديه ومن خلفه يحفظونه من امر الله ان الله لا يغير ما بقوم حتى يغيروا ما بانفسهم واذا اراد الله بقوم سوءا فلا مرد له وما لهم من دونه من وال",
  },
  {
    verseId: 11,
    name: "الرعد",
    surahId: 13,
    text: "هُوَ ٱلَّذِي يُرِيكُمُ ٱلۡبَرۡقَ خَوۡفٗا وَطَمَعٗا وَيُنشِئُ ٱلسَّحَابَ ٱلثِّقَالَ",
    translation:
      "It is He who shows you lightening, [causing] fear and aspiration, and generates the heavy clouds",
    normalizedText: "هو الذي يريكم البرق خوفا وطمعا وينشا السحاب الثقال",
  },
  {
    verseId: 12,
    name: "الرعد",
    surahId: 13,
    text: "وَيُسَبِّحُ ٱلرَّعۡدُ بِحَمۡدِهِۦ وَٱلۡمَلَـٰٓئِكَةُ مِنۡ خِيفَتِهِۦ وَيُرۡسِلُ ٱلصَّوَٰعِقَ فَيُصِيبُ بِهَا مَن يَشَآءُ وَهُمۡ يُجَٰدِلُونَ فِي ٱللَّهِ وَهُوَ شَدِيدُ ٱلۡمِحَالِ",
    translation:
      "And the thunder exalts [Allah] with praise of Him - and the angels [as well] from fear of Him - and He sends thunderbolts and strikes therewith whom He wills while they dispute about Allah; and He is severe in assault",
    normalizedText:
      "ويسبح الرعد بحمده والملاكة من خيفته ويرسل الصوعق فيصيب بها من يشاء وهم يجدلون في الله وهو شديد المحال",
  },
  {
    verseId: 13,
    name: "الرعد",
    surahId: 13,
    text: "لَهُۥ دَعۡوَةُ ٱلۡحَقِّۚ وَٱلَّذِينَ يَدۡعُونَ مِن دُونِهِۦ لَا يَسۡتَجِيبُونَ لَهُم بِشَيۡءٍ إِلَّا كَبَٰسِطِ كَفَّيۡهِ إِلَى ٱلۡمَآءِ لِيَبۡلُغَ فَاهُ وَمَا هُوَ بِبَٰلِغِهِۦۚ وَمَا دُعَآءُ ٱلۡكَٰفِرِينَ إِلَّا فِي ضَلَٰلٖ",
    translation:
      "To Him [alone] is the supplication of truth. And those they call upon besides Him do not respond to them with a thing, except as one who stretches his hands toward water [from afar, calling it] to reach his mouth, but it will not reach it [thus]. And the supplication of the disbelievers is not but in error [i.e. futility]",
    normalizedText:
      "له دعوة الحق والذين يدعون من دونه لا يستجيبون لهم بشيء الا كبسط كفيه الى الماء ليبلغ فاه وما هو ببلغه وما دعاء الكفرين الا في ضلل",
  },
  {
    verseId: 14,
    name: "الرعد",
    surahId: 13,
    text: "وَلِلَّهِۤ يَسۡجُدُۤ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ طَوۡعٗا وَكَرۡهٗا وَظِلَٰلُهُم بِٱلۡغُدُوِّ وَٱلۡأٓصَالِ۩",
    translation:
      "And to Allah prostrates whoever is within the heavens and the earth, willingly or by compulsion, and their shadows [as well] in the mornings and the afternoons",
    normalizedText:
      "ولله يسجد من في السموت والارض طوعا وكرها وظللهم بالغدو والاصال۩",
  },
  {
    verseId: 15,
    name: "الرعد",
    surahId: 13,
    text: "قُلۡ مَن رَّبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ قُلِ ٱللَّهُۚ قُلۡ أَفَٱتَّخَذۡتُم مِّن دُونِهِۦٓ أَوۡلِيَآءَ لَا يَمۡلِكُونَ لِأَنفُسِهِمۡ نَفۡعٗا وَلَا ضَرّٗاۚ قُلۡ هَلۡ يَسۡتَوِي ٱلۡأَعۡمَىٰ وَٱلۡبَصِيرُ أَمۡ هَلۡ تَسۡتَوِي ٱلظُّلُمَٰتُ وَٱلنُّورُۗ أَمۡ جَعَلُواْ لِلَّهِ شُرَكَآءَ خَلَقُواْ كَخَلۡقِهِۦ فَتَشَٰبَهَ ٱلۡخَلۡقُ عَلَيۡهِمۡۚ قُلِ ٱللَّهُ خَٰلِقُ كُلِّ شَيۡءٖ وَهُوَ ٱلۡوَٰحِدُ ٱلۡقَهَّـٰرُ",
    translation:
      'Say, "Who is Lord of the heavens and earth?" Say, "Allah." Say, "Have you then taken besides Him allies not possessing [even] for themselves any benefit or any harm?" Say, "Is the blind equivalent to the seeing? Or is darkness equivalent to light? Or have they attributed to Allah partners who created like His creation so that the creation [of each] seemed similar to them?" Say, "Allah is the Creator of all things, and He is the One, the Prevailing',
    normalizedText:
      "قل من رب السموت والارض قل الله قل افاتخذتم من دونه اولياء لا يملكون لانفسهم نفعا ولا ضرا قل هل يستوي الاعمى والبصير ام هل تستوي الظلمت والنور ام جعلوا لله شركاء خلقوا كخلقه فتشبه الخلق عليهم قل الله خلق كل شيء وهو الوحد القهر",
  },
  {
    verseId: 16,
    name: "الرعد",
    surahId: 13,
    text: "أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَسَالَتۡ أَوۡدِيَةُۢ بِقَدَرِهَا فَٱحۡتَمَلَ ٱلسَّيۡلُ زَبَدٗا رَّابِيٗاۖ وَمِمَّا يُوقِدُونَ عَلَيۡهِ فِي ٱلنَّارِ ٱبۡتِغَآءَ حِلۡيَةٍ أَوۡ مَتَٰعٖ زَبَدٞ مِّثۡلُهُۥۚ كَذَٰلِكَ يَضۡرِبُ ٱللَّهُ ٱلۡحَقَّ وَٱلۡبَٰطِلَۚ فَأَمَّا ٱلزَّبَدُ فَيَذۡهَبُ جُفَآءٗۖ وَأَمَّا مَا يَنفَعُ ٱلنَّاسَ فَيَمۡكُثُ فِي ٱلۡأَرۡضِۚ كَذَٰلِكَ يَضۡرِبُ ٱللَّهُ ٱلۡأَمۡثَالَ",
    translation:
      "He sends down from the sky, rain, and valleys flow according to their capacity, and the torrent carries a rising foam. And from that [ore] which they heat in the fire, desiring adornments and utensils, is a foam like it. Thus Allah presents [the example of] truth and falsehood. As for the foam, it vanishes, [being] cast off; but as for that which benefits the people, it remains on the earth. Thus does Allah present examples",
    normalizedText:
      "انزل من السماء ماء فسالت اودية بقدرها فاحتمل السيل زبدا رابيا ومما يوقدون عليه في النار ابتغاء حلية او متع زبد مثله كذلك يضرب الله الحق والبطل فاما الزبد فيذهب جفاء واما ما ينفع الناس فيمكث في الارض كذلك يضرب الله الامثال",
  },
  {
    verseId: 17,
    name: "الرعد",
    surahId: 13,
    text: "لِلَّذِينَ ٱسۡتَجَابُواْ لِرَبِّهِمُ ٱلۡحُسۡنَىٰۚ وَٱلَّذِينَ لَمۡ يَسۡتَجِيبُواْ لَهُۥ لَوۡ أَنَّ لَهُم مَّا فِي ٱلۡأَرۡضِ جَمِيعٗا وَمِثۡلَهُۥ مَعَهُۥ لَٱفۡتَدَوۡاْ بِهِۦٓۚ أُوْلَـٰٓئِكَ لَهُمۡ سُوٓءُ ٱلۡحِسَابِ وَمَأۡوَىٰهُمۡ جَهَنَّمُۖ وَبِئۡسَ ٱلۡمِهَادُ",
    translation:
      "For those who have responded to their Lord is the best [reward], but those who did not respond to Him - if they had all that is in the earth entirely and the like of it with it, they would [attempt to] ransom themselves thereby. Those will have the worst account, and their refuge is Hell, and wretched is the resting place",
    normalizedText:
      "للذين استجابوا لربهم الحسنى والذين لم يستجيبوا له لو ان لهم ما في الارض جميعا ومثله معه لافتدوا به اولاك لهم سوء الحساب وماوىهم جهنم وباس المهاد",
  },
  {
    verseId: 18,
    name: "الرعد",
    surahId: 13,
    text: "۞أَفَمَن يَعۡلَمُ أَنَّمَآ أُنزِلَ إِلَيۡكَ مِن رَّبِّكَ ٱلۡحَقُّ كَمَنۡ هُوَ أَعۡمَىٰٓۚ إِنَّمَا يَتَذَكَّرُ أُوْلُواْ ٱلۡأَلۡبَٰبِ",
    translation:
      "Then is he who knows that what has been revealed to you from your Lord is the truth like one who is blind? They will only be reminded who are people of understanding",
    normalizedText:
      "۞افمن يعلم انما انزل اليك من ربك الحق كمن هو اعمى انما يتذكر اولوا الالبب",
  },
  {
    verseId: 19,
    name: "الرعد",
    surahId: 13,
    text: "ٱلَّذِينَ يُوفُونَ بِعَهۡدِ ٱللَّهِ وَلَا يَنقُضُونَ ٱلۡمِيثَٰقَ",
    translation:
      "Those who fulfill the covenant of Allah and do not break the contract",
    normalizedText: "الذين يوفون بعهد الله ولا ينقضون الميثق",
  },
  {
    verseId: 20,
    name: "الرعد",
    surahId: 13,
    text: "وَٱلَّذِينَ يَصِلُونَ مَآ أَمَرَ ٱللَّهُ بِهِۦٓ أَن يُوصَلَ وَيَخۡشَوۡنَ رَبَّهُمۡ وَيَخَافُونَ سُوٓءَ ٱلۡحِسَابِ",
    translation:
      "And those who join that which Allah has ordered to be joined and fear their Lord and are afraid of the evil of [their] account",
    normalizedText:
      "والذين يصلون ما امر الله به ان يوصل ويخشون ربهم ويخافون سوء الحساب",
  },
  {
    verseId: 21,
    name: "الرعد",
    surahId: 13,
    text: "وَٱلَّذِينَ صَبَرُواْ ٱبۡتِغَآءَ وَجۡهِ رَبِّهِمۡ وَأَقَامُواْ ٱلصَّلَوٰةَ وَأَنفَقُواْ مِمَّا رَزَقۡنَٰهُمۡ سِرّٗا وَعَلَانِيَةٗ وَيَدۡرَءُونَ بِٱلۡحَسَنَةِ ٱلسَّيِّئَةَ أُوْلَـٰٓئِكَ لَهُمۡ عُقۡبَى ٱلدَّارِ",
    translation:
      "And those who are patient, seeking the countenance of their Lord, and establish prayer and spend from what We have provided for them secretly and publicly and prevent evil with good - those will have the good consequence of [this] home",
    normalizedText:
      "والذين صبروا ابتغاء وجه ربهم واقاموا الصلوة وانفقوا مما رزقنهم سرا وعلانية ويدرءون بالحسنة السياة اولاك لهم عقبى الدار",
  },
  {
    verseId: 22,
    name: "الرعد",
    surahId: 13,
    text: "جَنَّـٰتُ عَدۡنٖ يَدۡخُلُونَهَا وَمَن صَلَحَ مِنۡ ءَابَآئِهِمۡ وَأَزۡوَٰجِهِمۡ وَذُرِّيَّـٰتِهِمۡۖ وَٱلۡمَلَـٰٓئِكَةُ يَدۡخُلُونَ عَلَيۡهِم مِّن كُلِّ بَابٖ",
    translation:
      "Gardens of perpetual residence; they will enter them with whoever were righteous among their fathers, their spouses and their descendants. And the angels will enter upon them from every gate, [saying]",
    normalizedText:
      "جنت عدن يدخلونها ومن صلح من ءابااهم وازوجهم وذريتهم والملاكة يدخلون عليهم من كل باب",
  },
  {
    verseId: 23,
    name: "الرعد",
    surahId: 13,
    text: "سَلَٰمٌ عَلَيۡكُم بِمَا صَبَرۡتُمۡۚ فَنِعۡمَ عُقۡبَى ٱلدَّارِ",
    translation:
      "Peace be upon you for what you patiently endured. And excellent is the final home",
    normalizedText: "سلم عليكم بما صبرتم فنعم عقبى الدار",
  },
  {
    verseId: 24,
    name: "الرعد",
    surahId: 13,
    text: "وَٱلَّذِينَ يَنقُضُونَ عَهۡدَ ٱللَّهِ مِنۢ بَعۡدِ مِيثَٰقِهِۦ وَيَقۡطَعُونَ مَآ أَمَرَ ٱللَّهُ بِهِۦٓ أَن يُوصَلَ وَيُفۡسِدُونَ فِي ٱلۡأَرۡضِ أُوْلَـٰٓئِكَ لَهُمُ ٱللَّعۡنَةُ وَلَهُمۡ سُوٓءُ ٱلدَّارِ",
    translation:
      "But those who break the covenant of Allah after contracting it and sever that which Allah has ordered to be joined and spread corruption on earth - for them is the curse, and they will have the worst home",
    normalizedText:
      "والذين ينقضون عهد الله من بعد ميثقه ويقطعون ما امر الله به ان يوصل ويفسدون في الارض اولاك لهم اللعنة ولهم سوء الدار",
  },
  {
    verseId: 25,
    name: "الرعد",
    surahId: 13,
    text: "ٱللَّهُ يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ وَيَقۡدِرُۚ وَفَرِحُواْ بِٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَمَا ٱلۡحَيَوٰةُ ٱلدُّنۡيَا فِي ٱلۡأٓخِرَةِ إِلَّا مَتَٰعٞ",
    translation:
      "Allah extends provision for whom He wills and restricts [it]. And they rejoice in the worldly life, while the worldly life is not, compared to the Hereafter, except [brief] enjoyment",
    normalizedText:
      "الله يبسط الرزق لمن يشاء ويقدر وفرحوا بالحيوة الدنيا وما الحيوة الدنيا في الاخرة الا متع",
  },
  {
    verseId: 26,
    name: "الرعد",
    surahId: 13,
    text: "وَيَقُولُ ٱلَّذِينَ كَفَرُواْ لَوۡلَآ أُنزِلَ عَلَيۡهِ ءَايَةٞ مِّن رَّبِّهِۦۚ قُلۡ إِنَّ ٱللَّهَ يُضِلُّ مَن يَشَآءُ وَيَهۡدِيٓ إِلَيۡهِ مَنۡ أَنَابَ",
    translation:
      'And those who disbelieved say, "Why has a sign not been sent down to him from his Lord?" Say, [O Muhammad], "Indeed, Allah leaves astray whom He wills and guides to Himself whoever turns back [to Him]',
    normalizedText:
      "ويقول الذين كفروا لولا انزل عليه ءاية من ربه قل ان الله يضل من يشاء ويهدي اليه من اناب",
  },
  {
    verseId: 27,
    name: "الرعد",
    surahId: 13,
    text: "ٱلَّذِينَ ءَامَنُواْ وَتَطۡمَئِنُّ قُلُوبُهُم بِذِكۡرِ ٱللَّهِۗ أَلَا بِذِكۡرِ ٱللَّهِ تَطۡمَئِنُّ ٱلۡقُلُوبُ",
    translation:
      "Those who have believed and whose hearts are assured by the remembrance of Allah. Unquestionably, by the remembrance of Allah hearts are assured",
    normalizedText:
      "الذين ءامنوا وتطمان قلوبهم بذكر الله الا بذكر الله تطمان القلوب",
  },
  {
    verseId: 28,
    name: "الرعد",
    surahId: 13,
    text: "ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ طُوبَىٰ لَهُمۡ وَحُسۡنُ مَـَٔابٖ",
    translation:
      "Those who have believed and done righteous deeds - a good state is theirs and a good return",
    normalizedText: "الذين ءامنوا وعملوا الصلحت طوبى لهم وحسن ماب",
  },
  {
    verseId: 29,
    name: "الرعد",
    surahId: 13,
    text: "كَذَٰلِكَ أَرۡسَلۡنَٰكَ فِيٓ أُمَّةٖ قَدۡ خَلَتۡ مِن قَبۡلِهَآ أُمَمٞ لِّتَتۡلُوَاْ عَلَيۡهِمُ ٱلَّذِيٓ أَوۡحَيۡنَآ إِلَيۡكَ وَهُمۡ يَكۡفُرُونَ بِٱلرَّحۡمَٰنِۚ قُلۡ هُوَ رَبِّي لَآ إِلَٰهَ إِلَّا هُوَ عَلَيۡهِ تَوَكَّلۡتُ وَإِلَيۡهِ مَتَابِ",
    translation:
      'Thus have We sent you to a community before which [other] communities have passed on so you might recite to them that which We revealed to you, while they disbelieve in the Most Merciful. Say, "He is my Lord; there is no deity except Him. Upon Him I rely, and to Him is my return',
    normalizedText:
      "كذلك ارسلنك في امة قد خلت من قبلها امم لتتلوا عليهم الذي اوحينا اليك وهم يكفرون بالرحمن قل هو ربي لا اله الا هو عليه توكلت واليه متاب",
  },
  {
    verseId: 30,
    name: "الرعد",
    surahId: 13,
    text: "وَلَوۡ أَنَّ قُرۡءَانٗا سُيِّرَتۡ بِهِ ٱلۡجِبَالُ أَوۡ قُطِّعَتۡ بِهِ ٱلۡأَرۡضُ أَوۡ كُلِّمَ بِهِ ٱلۡمَوۡتَىٰۗ بَل لِّلَّهِ ٱلۡأَمۡرُ جَمِيعًاۗ أَفَلَمۡ يَاْيۡـَٔسِ ٱلَّذِينَ ءَامَنُوٓاْ أَن لَّوۡ يَشَآءُ ٱللَّهُ لَهَدَى ٱلنَّاسَ جَمِيعٗاۗ وَلَا يَزَالُ ٱلَّذِينَ كَفَرُواْ تُصِيبُهُم بِمَا صَنَعُواْ قَارِعَةٌ أَوۡ تَحُلُّ قَرِيبٗا مِّن دَارِهِمۡ حَتَّىٰ يَأۡتِيَ وَعۡدُ ٱللَّهِۚ إِنَّ ٱللَّهَ لَا يُخۡلِفُ ٱلۡمِيعَادَ",
    translation:
      "And if there was any qur'an by which the mountains would be removed or the earth would be broken apart or the dead would be made to speak, [it would be this Qur'an], but to Allah belongs the affair entirely. Then have those who believed not accepted that had Allah willed, He would have guided the people, all of them? And those who disbelieve do not cease to be struck, for what they have done, by calamity - or it will descend near their home - until there comes the promise of Allah. Indeed, Allah does not fail in [His] promise",
    normalizedText:
      "ولو ان قرءانا سيرت به الجبال او قطعت به الارض او كلم به الموتى بل لله الامر جميعا افلم يايس الذين ءامنوا ان لو يشاء الله لهدى الناس جميعا ولا يزال الذين كفروا تصيبهم بما صنعوا قارعة او تحل قريبا من دارهم حتى ياتي وعد الله ان الله لا يخلف الميعاد",
  },
  {
    verseId: 31,
    name: "الرعد",
    surahId: 13,
    text: "وَلَقَدِ ٱسۡتُهۡزِئَ بِرُسُلٖ مِّن قَبۡلِكَ فَأَمۡلَيۡتُ لِلَّذِينَ كَفَرُواْ ثُمَّ أَخَذۡتُهُمۡۖ فَكَيۡفَ كَانَ عِقَابِ",
    translation:
      "And already were [other] messengers ridiculed before you, and I extended the time of those who disbelieved; then I seized them, and how [terrible] was My penalty",
    normalizedText:
      "ولقد استهزا برسل من قبلك فامليت للذين كفروا ثم اخذتهم فكيف كان عقاب",
  },
  {
    verseId: 32,
    name: "الرعد",
    surahId: 13,
    text: "أَفَمَنۡ هُوَ قَآئِمٌ عَلَىٰ كُلِّ نَفۡسِۭ بِمَا كَسَبَتۡۗ وَجَعَلُواْ لِلَّهِ شُرَكَآءَ قُلۡ سَمُّوهُمۡۚ أَمۡ تُنَبِّـُٔونَهُۥ بِمَا لَا يَعۡلَمُ فِي ٱلۡأَرۡضِ أَم بِظَٰهِرٖ مِّنَ ٱلۡقَوۡلِۗ بَلۡ زُيِّنَ لِلَّذِينَ كَفَرُواْ مَكۡرُهُمۡ وَصُدُّواْ عَنِ ٱلسَّبِيلِۗ وَمَن يُضۡلِلِ ٱللَّهُ فَمَا لَهُۥ مِنۡ هَادٖ",
    translation:
      'Then is He who is a maintainer of every soul, [knowing] what it has earned, [like any other]? But to Allah they have attributed partners. Say, "Name them. Or do you inform Him of that which He knows not upon the earth or of what is apparent of speech?" Rather, their [own] plan has been made attractive to those who disbelieve, and they have been averted from the way. And whomever Allah leaves astray - there will be for him no guide',
    normalizedText:
      "افمن هو قاام على كل نفس بما كسبت وجعلوا لله شركاء قل سموهم ام تنبونه بما لا يعلم في الارض ام بظهر من القول بل زين للذين كفروا مكرهم وصدوا عن السبيل ومن يضلل الله فما له من هاد",
  },
  {
    verseId: 33,
    name: "الرعد",
    surahId: 13,
    text: "لَّهُمۡ عَذَابٞ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَلَعَذَابُ ٱلۡأٓخِرَةِ أَشَقُّۖ وَمَا لَهُم مِّنَ ٱللَّهِ مِن وَاقٖ",
    translation:
      "For them will be punishment in the life of [this] world, and the punishment of the Hereafter is more severe. And they will not have from Allah any protector",
    normalizedText:
      "لهم عذاب في الحيوة الدنيا ولعذاب الاخرة اشق وما لهم من الله من واق",
  },
  {
    verseId: 34,
    name: "الرعد",
    surahId: 13,
    text: "۞مَّثَلُ ٱلۡجَنَّةِ ٱلَّتِي وُعِدَ ٱلۡمُتَّقُونَۖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۖ أُكُلُهَا دَآئِمٞ وَظِلُّهَاۚ تِلۡكَ عُقۡبَى ٱلَّذِينَ ٱتَّقَواْۚ وَّعُقۡبَى ٱلۡكَٰفِرِينَ ٱلنَّارُ",
    translation:
      "The example of Paradise, which the righteous have been promised, is [that] beneath it rivers flow. Its fruit is lasting, and its shade. That is the consequence for the righteous, and the consequence for the disbelievers is the Fire",
    normalizedText:
      "۞مثل الجنة التي وعد المتقون تجري من تحتها الانهر اكلها داام وظلها تلك عقبى الذين اتقوا وعقبى الكفرين النار",
  },
  {
    verseId: 35,
    name: "الرعد",
    surahId: 13,
    text: "وَٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ يَفۡرَحُونَ بِمَآ أُنزِلَ إِلَيۡكَۖ وَمِنَ ٱلۡأَحۡزَابِ مَن يُنكِرُ بَعۡضَهُۥۚ قُلۡ إِنَّمَآ أُمِرۡتُ أَنۡ أَعۡبُدَ ٱللَّهَ وَلَآ أُشۡرِكَ بِهِۦٓۚ إِلَيۡهِ أَدۡعُواْ وَإِلَيۡهِ مَـَٔابِ",
    translation:
      'And [the believers among] those to whom We have given the [previous] Scripture rejoice at what has been revealed to you, [O Muhammad], but among the [opposing] factions are those who deny part of it. Say, "I have only been commanded to worship Allah and not associate [anything] with Him. To Him I invite, and to Him is my return',
    normalizedText:
      "والذين ءاتينهم الكتب يفرحون بما انزل اليك ومن الاحزاب من ينكر بعضه قل انما امرت ان اعبد الله ولا اشرك به اليه ادعوا واليه ماب",
  },
  {
    verseId: 36,
    name: "الرعد",
    surahId: 13,
    text: "وَكَذَٰلِكَ أَنزَلۡنَٰهُ حُكۡمًا عَرَبِيّٗاۚ وَلَئِنِ ٱتَّبَعۡتَ أَهۡوَآءَهُم بَعۡدَ مَا جَآءَكَ مِنَ ٱلۡعِلۡمِ مَا لَكَ مِنَ ٱللَّهِ مِن وَلِيّٖ وَلَا وَاقٖ",
    translation:
      "And thus We have revealed it as an Arabic legislation. And if you should follow their inclinations after what has come to you of knowledge, you would not have against Allah any ally or any protector",
    normalizedText:
      "وكذلك انزلنه حكما عربيا ولان اتبعت اهواءهم بعد ما جاءك من العلم ما لك من الله من ولي ولا واق",
  },
  {
    verseId: 37,
    name: "الرعد",
    surahId: 13,
    text: "وَلَقَدۡ أَرۡسَلۡنَا رُسُلٗا مِّن قَبۡلِكَ وَجَعَلۡنَا لَهُمۡ أَزۡوَٰجٗا وَذُرِّيَّةٗۚ وَمَا كَانَ لِرَسُولٍ أَن يَأۡتِيَ بِـَٔايَةٍ إِلَّا بِإِذۡنِ ٱللَّهِۗ لِكُلِّ أَجَلٖ كِتَابٞ",
    translation:
      "And We have already sent messengers before you and assigned to them wives and descendants. And it was not for a messenger to come with a sign except by permission of Allah. For every term is a decree",
    normalizedText:
      "ولقد ارسلنا رسلا من قبلك وجعلنا لهم ازوجا وذرية وما كان لرسول ان ياتي باية الا باذن الله لكل اجل كتاب",
  },
  {
    verseId: 38,
    name: "الرعد",
    surahId: 13,
    text: "يَمۡحُواْ ٱللَّهُ مَا يَشَآءُ وَيُثۡبِتُۖ وَعِندَهُۥٓ أُمُّ ٱلۡكِتَٰبِ",
    translation:
      "Allah eliminates what He wills or confirms, and with Him is the Mother of the Book",
    normalizedText: "يمحوا الله ما يشاء ويثبت وعنده ام الكتب",
  },
  {
    verseId: 39,
    name: "الرعد",
    surahId: 13,
    text: "وَإِن مَّا نُرِيَنَّكَ بَعۡضَ ٱلَّذِي نَعِدُهُمۡ أَوۡ نَتَوَفَّيَنَّكَ فَإِنَّمَا عَلَيۡكَ ٱلۡبَلَٰغُ وَعَلَيۡنَا ٱلۡحِسَابُ",
    translation:
      "And whether We show you part of what We promise them or take you in death, upon you is only the [duty of] notification, and upon Us is the account",
    normalizedText:
      "وان ما نرينك بعض الذي نعدهم او نتوفينك فانما عليك البلغ وعلينا الحساب",
  },
  {
    verseId: 40,
    name: "الرعد",
    surahId: 13,
    text: "أَوَلَمۡ يَرَوۡاْ أَنَّا نَأۡتِي ٱلۡأَرۡضَ نَنقُصُهَا مِنۡ أَطۡرَافِهَاۚ وَٱللَّهُ يَحۡكُمُ لَا مُعَقِّبَ لِحُكۡمِهِۦۚ وَهُوَ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      "Have they not seen that We set upon the land, reducing it from its borders? And Allah decides; there is no adjuster of His decision. And He is swift in account",
    normalizedText:
      "اولم يروا انا ناتي الارض ننقصها من اطرافها والله يحكم لا معقب لحكمه وهو سريع الحساب",
  },
  {
    verseId: 41,
    name: "الرعد",
    surahId: 13,
    text: "وَقَدۡ مَكَرَ ٱلَّذِينَ مِن قَبۡلِهِمۡ فَلِلَّهِ ٱلۡمَكۡرُ جَمِيعٗاۖ يَعۡلَمُ مَا تَكۡسِبُ كُلُّ نَفۡسٖۗ وَسَيَعۡلَمُ ٱلۡكُفَّـٰرُ لِمَنۡ عُقۡبَى ٱلدَّارِ",
    translation:
      "And those before them had plotted, but to Allah belongs the plan entirely. He knows what every soul earns, and the disbelievers will know for whom is the final home",
    normalizedText:
      "وقد مكر الذين من قبلهم فلله المكر جميعا يعلم ما تكسب كل نفس وسيعلم الكفر لمن عقبى الدار",
  },
  {
    verseId: 42,
    name: "الرعد",
    surahId: 13,
    text: "وَيَقُولُ ٱلَّذِينَ كَفَرُواْ لَسۡتَ مُرۡسَلٗاۚ قُلۡ كَفَىٰ بِٱللَّهِ شَهِيدَۢا بَيۡنِي وَبَيۡنَكُمۡ وَمَنۡ عِندَهُۥ عِلۡمُ ٱلۡكِتَٰبِ",
    translation:
      'And those who have disbelieved say, "You are not a messenger." Say, [O Muhammad], "Sufficient is Allah as Witness between me and you, and [the witness of] whoever has knowledge of the Scripture',
    normalizedText:
      "ويقول الذين كفروا لست مرسلا قل كفى بالله شهيدا بيني وبينكم ومن عنده علم الكتب",
  },
  {
    verseId: 0,
    name: "ابراهيم",
    surahId: 14,
    text: "الٓرۚ كِتَٰبٌ أَنزَلۡنَٰهُ إِلَيۡكَ لِتُخۡرِجَ ٱلنَّاسَ مِنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ بِإِذۡنِ رَبِّهِمۡ إِلَىٰ صِرَٰطِ ٱلۡعَزِيزِ ٱلۡحَمِيدِ",
    translation:
      "Alif, Lam, Ra. [This is] a Book which We have revealed to you, [O Muhammad], that you might bring mankind out of darknesses into the light by permission of their Lord - to the path of the Exalted in Might, the Praiseworthy",
    normalizedText:
      "الر كتب انزلنه اليك لتخرج الناس من الظلمت الى النور باذن ربهم الى صرط العزيز الحميد",
  },
  {
    verseId: 1,
    name: "ابراهيم",
    surahId: 14,
    text: "ٱللَّهِ ٱلَّذِي لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۗ وَوَيۡلٞ لِّلۡكَٰفِرِينَ مِنۡ عَذَابٖ شَدِيدٍ",
    translation:
      "Allah, to whom belongs whatever is in the heavens and whatever is on the earth. And woe to the disbelievers from a severe punishment",
    normalizedText:
      "الله الذي له ما في السموت وما في الارض وويل للكفرين من عذاب شديد",
  },
  {
    verseId: 2,
    name: "ابراهيم",
    surahId: 14,
    text: "ٱلَّذِينَ يَسۡتَحِبُّونَ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا عَلَى ٱلۡأٓخِرَةِ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَيَبۡغُونَهَا عِوَجًاۚ أُوْلَـٰٓئِكَ فِي ضَلَٰلِۭ بَعِيدٖ",
    translation:
      "The ones who prefer the worldly life over the Hereafter and avert [people] from the way of Allah, seeking to make it (seem) deviant. Those are in extreme error",
    normalizedText:
      "الذين يستحبون الحيوة الدنيا على الاخرة ويصدون عن سبيل الله ويبغونها عوجا اولاك في ضلل بعيد",
  },
  {
    verseId: 3,
    name: "ابراهيم",
    surahId: 14,
    text: "وَمَآ أَرۡسَلۡنَا مِن رَّسُولٍ إِلَّا بِلِسَانِ قَوۡمِهِۦ لِيُبَيِّنَ لَهُمۡۖ فَيُضِلُّ ٱللَّهُ مَن يَشَآءُ وَيَهۡدِي مَن يَشَآءُۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "And We did not send any messenger except [speaking] in the language of his people to state clearly for them, and Allah sends astray [thereby] whom He wills and guides whom He wills. And He is the Exalted in Might, the Wise",
    normalizedText:
      "وما ارسلنا من رسول الا بلسان قومه ليبين لهم فيضل الله من يشاء ويهدي من يشاء وهو العزيز الحكيم",
  },
  {
    verseId: 4,
    name: "ابراهيم",
    surahId: 14,
    text: "وَلَقَدۡ أَرۡسَلۡنَا مُوسَىٰ بِـَٔايَٰتِنَآ أَنۡ أَخۡرِجۡ قَوۡمَكَ مِنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ وَذَكِّرۡهُم بِأَيَّىٰمِ ٱللَّهِۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّكُلِّ صَبَّارٖ شَكُورٖ",
    translation:
      'And We certainly sent Moses with Our signs, [saying], "Bring out your people from darknesses into the light and remind them of the days of Allah." Indeed in that are signs for everyone patient and grateful',
    normalizedText:
      "ولقد ارسلنا موسى بايتنا ان اخرج قومك من الظلمت الى النور وذكرهم بايىم الله ان في ذلك لايت لكل صبار شكور",
  },
  {
    verseId: 5,
    name: "ابراهيم",
    surahId: 14,
    text: "وَإِذۡ قَالَ مُوسَىٰ لِقَوۡمِهِ ٱذۡكُرُواْ نِعۡمَةَ ٱللَّهِ عَلَيۡكُمۡ إِذۡ أَنجَىٰكُم مِّنۡ ءَالِ فِرۡعَوۡنَ يَسُومُونَكُمۡ سُوٓءَ ٱلۡعَذَابِ وَيُذَبِّحُونَ أَبۡنَآءَكُمۡ وَيَسۡتَحۡيُونَ نِسَآءَكُمۡۚ وَفِي ذَٰلِكُم بَلَآءٞ مِّن رَّبِّكُمۡ عَظِيمٞ",
    translation:
      'And [recall, O Children of Israel], when Moses said to His people, "Remember the favor of Allah upon you when He saved you from the people of Pharaoh, who were afflicting you with the worst torment and were slaughtering your [newborn] sons and keeping your females alive. And in that was a great trial from your Lord',
    normalizedText:
      "واذ قال موسى لقومه اذكروا نعمة الله عليكم اذ انجىكم من ءال فرعون يسومونكم سوء العذاب ويذبحون ابناءكم ويستحيون نساءكم وفي ذلكم بلاء من ربكم عظيم",
  },
  {
    verseId: 6,
    name: "ابراهيم",
    surahId: 14,
    text: "وَإِذۡ تَأَذَّنَ رَبُّكُمۡ لَئِن شَكَرۡتُمۡ لَأَزِيدَنَّكُمۡۖ وَلَئِن كَفَرۡتُمۡ إِنَّ عَذَابِي لَشَدِيدٞ",
    translation:
      "And [remember] when your Lord proclaimed, 'If you are grateful, I will surely increase you [in favor]; but if you deny, indeed, My punishment is severe",
    normalizedText:
      "واذ تاذن ربكم لان شكرتم لازيدنكم ولان كفرتم ان عذابي لشديد",
  },
  {
    verseId: 7,
    name: "ابراهيم",
    surahId: 14,
    text: "وَقَالَ مُوسَىٰٓ إِن تَكۡفُرُوٓاْ أَنتُمۡ وَمَن فِي ٱلۡأَرۡضِ جَمِيعٗا فَإِنَّ ٱللَّهَ لَغَنِيٌّ حَمِيدٌ",
    translation:
      'And Moses said, "If you should disbelieve, you and whoever is on the earth entirely - indeed, Allah is Free of need and Praiseworthy',
    normalizedText:
      "وقال موسى ان تكفروا انتم ومن في الارض جميعا فان الله لغني حميد",
  },
  {
    verseId: 8,
    name: "ابراهيم",
    surahId: 14,
    text: "أَلَمۡ يَأۡتِكُمۡ نَبَؤُاْ ٱلَّذِينَ مِن قَبۡلِكُمۡ قَوۡمِ نُوحٖ وَعَادٖ وَثَمُودَ وَٱلَّذِينَ مِنۢ بَعۡدِهِمۡ لَا يَعۡلَمُهُمۡ إِلَّا ٱللَّهُۚ جَآءَتۡهُمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِ فَرَدُّوٓاْ أَيۡدِيَهُمۡ فِيٓ أَفۡوَٰهِهِمۡ وَقَالُوٓاْ إِنَّا كَفَرۡنَا بِمَآ أُرۡسِلۡتُم بِهِۦ وَإِنَّا لَفِي شَكّٖ مِّمَّا تَدۡعُونَنَآ إِلَيۡهِ مُرِيبٖ",
    translation: `Has there not reached you the news of those before you - the people of Noah and 'Aad and Thamud and those after them? No one knows them but Allah. Their messengers brought them clear proofs, but they returned their hands to their mouths and said, "Indeed, we disbelieve in that with which you have been sent, and indeed we are, about that to which you invite us, in disquieting doubt`,
    normalizedText:
      "الم ياتكم نباا الذين من قبلكم قوم نوح وعاد وثمود والذين من بعدهم لا يعلمهم الا الله جاءتهم رسلهم بالبينت فردوا ايديهم في افوههم وقالوا انا كفرنا بما ارسلتم به وانا لفي شك مما تدعوننا اليه مريب",
  },
  {
    verseId: 9,
    name: "ابراهيم",
    surahId: 14,
    text: "۞قَالَتۡ رُسُلُهُمۡ أَفِي ٱللَّهِ شَكّٞ فَاطِرِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ يَدۡعُوكُمۡ لِيَغۡفِرَ لَكُم مِّن ذُنُوبِكُمۡ وَيُؤَخِّرَكُمۡ إِلَىٰٓ أَجَلٖ مُّسَمّٗىۚ قَالُوٓاْ إِنۡ أَنتُمۡ إِلَّا بَشَرٞ مِّثۡلُنَا تُرِيدُونَ أَن تَصُدُّونَا عَمَّا كَانَ يَعۡبُدُ ءَابَآؤُنَا فَأۡتُونَا بِسُلۡطَٰنٖ مُّبِينٖ",
    translation:
      'Their messengers said, "Can there be doubt about Allah, Creator of the heavens and earth? He invites you that He may forgive you of your sins, and He delays your death for a specified term." They said, "You are not but men like us who wish to avert us from what our fathers were worshipping. So bring us a clear authority',
    normalizedText:
      "۞قالت رسلهم افي الله شك فاطر السموت والارض يدعوكم ليغفر لكم من ذنوبكم وياخركم الى اجل مسمى قالوا ان انتم الا بشر مثلنا تريدون ان تصدونا عما كان يعبد ءاباانا فاتونا بسلطن مبين",
  },
  {
    verseId: 10,
    name: "ابراهيم",
    surahId: 14,
    text: "قَالَتۡ لَهُمۡ رُسُلُهُمۡ إِن نَّحۡنُ إِلَّا بَشَرٞ مِّثۡلُكُمۡ وَلَٰكِنَّ ٱللَّهَ يَمُنُّ عَلَىٰ مَن يَشَآءُ مِنۡ عِبَادِهِۦۖ وَمَا كَانَ لَنَآ أَن نَّأۡتِيَكُم بِسُلۡطَٰنٍ إِلَّا بِإِذۡنِ ٱللَّهِۚ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُؤۡمِنُونَ",
    translation:
      'Their messengers said to them, "We are only men like you, but Allah confers favor upon whom He wills of His servants. It has never been for us to bring you evidence except by permission of Allah. And upon Allah let the believers rely',
    normalizedText:
      "قالت لهم رسلهم ان نحن الا بشر مثلكم ولكن الله يمن على من يشاء من عباده وما كان لنا ان ناتيكم بسلطن الا باذن الله وعلى الله فليتوكل المامنون",
  },
  {
    verseId: 11,
    name: "ابراهيم",
    surahId: 14,
    text: "وَمَا لَنَآ أَلَّا نَتَوَكَّلَ عَلَى ٱللَّهِ وَقَدۡ هَدَىٰنَا سُبُلَنَاۚ وَلَنَصۡبِرَنَّ عَلَىٰ مَآ ءَاذَيۡتُمُونَاۚ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُتَوَكِّلُونَ",
    translation:
      "And why should we not rely upon Allah while He has guided us to our [good] ways. And we will surely be patient against whatever harm you should cause us. And upon Allah let those who would rely [indeed] rely",
    normalizedText:
      "وما لنا الا نتوكل على الله وقد هدىنا سبلنا ولنصبرن على ما ءاذيتمونا وعلى الله فليتوكل المتوكلون",
  },
  {
    verseId: 12,
    name: "ابراهيم",
    surahId: 14,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ لِرُسُلِهِمۡ لَنُخۡرِجَنَّكُم مِّنۡ أَرۡضِنَآ أَوۡ لَتَعُودُنَّ فِي مِلَّتِنَاۖ فَأَوۡحَىٰٓ إِلَيۡهِمۡ رَبُّهُمۡ لَنُهۡلِكَنَّ ٱلظَّـٰلِمِينَ",
    translation:
      'And those who disbelieved said to their messengers, "We will surely drive you out of our land, or you must return to our religion." So their Lord inspired to them, "We will surely destroy the wrongdoers',
    normalizedText:
      "وقال الذين كفروا لرسلهم لنخرجنكم من ارضنا او لتعودن في ملتنا فاوحى اليهم ربهم لنهلكن الظلمين",
  },
  {
    verseId: 13,
    name: "ابراهيم",
    surahId: 14,
    text: "وَلَنُسۡكِنَنَّكُمُ ٱلۡأَرۡضَ مِنۢ بَعۡدِهِمۡۚ ذَٰلِكَ لِمَنۡ خَافَ مَقَامِي وَخَافَ وَعِيدِ",
    translation:
      "And We will surely cause you to dwell in the land after them. That is for he who fears My position and fears My threat",
    normalizedText: "ولنسكننكم الارض من بعدهم ذلك لمن خاف مقامي وخاف وعيد",
  },
  {
    verseId: 14,
    name: "ابراهيم",
    surahId: 14,
    text: "وَٱسۡتَفۡتَحُواْ وَخَابَ كُلُّ جَبَّارٍ عَنِيدٖ",
    translation:
      "And they requested victory from Allah, and disappointed, [therefore], was every obstinate tyrant",
    normalizedText: "واستفتحوا وخاب كل جبار عنيد",
  },
  {
    verseId: 15,
    name: "ابراهيم",
    surahId: 14,
    text: "مِّن وَرَآئِهِۦ جَهَنَّمُ وَيُسۡقَىٰ مِن مَّآءٖ صَدِيدٖ",
    translation:
      "Before him is Hell, and he will be given a drink of purulent water",
    normalizedText: "من ورااه جهنم ويسقى من ماء صديد",
  },
  {
    verseId: 16,
    name: "ابراهيم",
    surahId: 14,
    text: "يَتَجَرَّعُهُۥ وَلَا يَكَادُ يُسِيغُهُۥ وَيَأۡتِيهِ ٱلۡمَوۡتُ مِن كُلِّ مَكَانٖ وَمَا هُوَ بِمَيِّتٖۖ وَمِن وَرَآئِهِۦ عَذَابٌ غَلِيظٞ",
    translation:
      "He will gulp it but will hardly [be able to] swallow it. And death will come to him from everywhere, but he is not to die. And before him is a massive punishment",
    normalizedText:
      "يتجرعه ولا يكاد يسيغه وياتيه الموت من كل مكان وما هو بميت ومن ورااه عذاب غليظ",
  },
  {
    verseId: 17,
    name: "ابراهيم",
    surahId: 14,
    text: "مَّثَلُ ٱلَّذِينَ كَفَرُواْ بِرَبِّهِمۡۖ أَعۡمَٰلُهُمۡ كَرَمَادٍ ٱشۡتَدَّتۡ بِهِ ٱلرِّيحُ فِي يَوۡمٍ عَاصِفٖۖ لَّا يَقۡدِرُونَ مِمَّا كَسَبُواْ عَلَىٰ شَيۡءٖۚ ذَٰلِكَ هُوَ ٱلضَّلَٰلُ ٱلۡبَعِيدُ",
    translation:
      "The example of those who disbelieve in their Lord is [that] their deeds are like ashes which the wind blows forcefully on a stormy day; they are unable [to keep] from what they earned a [single] thing. That is what is extreme error",
    normalizedText:
      "مثل الذين كفروا بربهم اعملهم كرماد اشتدت به الريح في يوم عاصف لا يقدرون مما كسبوا على شيء ذلك هو الضلل البعيد",
  },
  {
    verseId: 18,
    name: "ابراهيم",
    surahId: 14,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِٱلۡحَقِّۚ إِن يَشَأۡ يُذۡهِبۡكُمۡ وَيَأۡتِ بِخَلۡقٖ جَدِيدٖ",
    translation:
      "Have you not seen that Allah created the heavens and the earth in truth? If He wills, He can do away with you and produce a new creation",
    normalizedText:
      "الم تر ان الله خلق السموت والارض بالحق ان يشا يذهبكم ويات بخلق جديد",
  },
  {
    verseId: 19,
    name: "ابراهيم",
    surahId: 14,
    text: "وَمَا ذَٰلِكَ عَلَى ٱللَّهِ بِعَزِيزٖ",
    translation: "And that is not difficult for Allah",
    normalizedText: "وما ذلك على الله بعزيز",
  },
  {
    verseId: 20,
    name: "ابراهيم",
    surahId: 14,
    text: "وَبَرَزُواْ لِلَّهِ جَمِيعٗا فَقَالَ ٱلضُّعَفَـٰٓؤُاْ لِلَّذِينَ ٱسۡتَكۡبَرُوٓاْ إِنَّا كُنَّا لَكُمۡ تَبَعٗا فَهَلۡ أَنتُم مُّغۡنُونَ عَنَّا مِنۡ عَذَابِ ٱللَّهِ مِن شَيۡءٖۚ قَالُواْ لَوۡ هَدَىٰنَا ٱللَّهُ لَهَدَيۡنَٰكُمۡۖ سَوَآءٌ عَلَيۡنَآ أَجَزِعۡنَآ أَمۡ صَبَرۡنَا مَا لَنَا مِن مَّحِيصٖ",
    translation:
      'And they will come out [for judgement] before Allah all together, and the weak will say to those who were arrogant, "Indeed, we were your followers, so can you avail us anything against the punishment of Allah?" They will say, "If Allah had guided us, we would have guided you. It is all the same for us whether we show intolerance or are patient: there is for us no place of escape',
    normalizedText:
      "وبرزوا لله جميعا فقال الضعفاا للذين استكبروا انا كنا لكم تبعا فهل انتم مغنون عنا من عذاب الله من شيء قالوا لو هدىنا الله لهدينكم سواء علينا اجزعنا ام صبرنا ما لنا من محيص",
  },
  {
    verseId: 21,
    name: "ابراهيم",
    surahId: 14,
    text: "وَقَالَ ٱلشَّيۡطَٰنُ لَمَّا قُضِيَ ٱلۡأَمۡرُ إِنَّ ٱللَّهَ وَعَدَكُمۡ وَعۡدَ ٱلۡحَقِّ وَوَعَدتُّكُمۡ فَأَخۡلَفۡتُكُمۡۖ وَمَا كَانَ لِيَ عَلَيۡكُم مِّن سُلۡطَٰنٍ إِلَّآ أَن دَعَوۡتُكُمۡ فَٱسۡتَجَبۡتُمۡ لِيۖ فَلَا تَلُومُونِي وَلُومُوٓاْ أَنفُسَكُمۖ مَّآ أَنَا۠ بِمُصۡرِخِكُمۡ وَمَآ أَنتُم بِمُصۡرِخِيَّ إِنِّي كَفَرۡتُ بِمَآ أَشۡرَكۡتُمُونِ مِن قَبۡلُۗ إِنَّ ٱلظَّـٰلِمِينَ لَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      'And Satan will say when the matter has been concluded, "Indeed, Allah had promised you the promise of truth. And I promised you, but I betrayed you. But I had no authority over you except that I invited you, and you responded to me. So do not blame me; but blame yourselves. I cannot be called to your aid, nor can you be called to my aid. Indeed, I deny your association of me [with Allah] before. Indeed, for the wrongdoers is a painful punishment',
    normalizedText:
      "وقال الشيطن لما قضي الامر ان الله وعدكم وعد الحق ووعدتكم فاخلفتكم وما كان لي عليكم من سلطن الا ان دعوتكم فاستجبتم لي فلا تلوموني ولوموا انفسكم ما انا بمصرخكم وما انتم بمصرخي اني كفرت بما اشركتمون من قبل ان الظلمين لهم عذاب اليم",
  },
  {
    verseId: 22,
    name: "ابراهيم",
    surahId: 14,
    text: "وَأُدۡخِلَ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَا بِإِذۡنِ رَبِّهِمۡۖ تَحِيَّتُهُمۡ فِيهَا سَلَٰمٌ",
    translation:
      'And those who believed and did righteous deeds will be admitted to gardens beneath which rivers flow, abiding eternally therein by permission of their Lord; and their greeting therein will be, "Peace',
    normalizedText:
      "وادخل الذين ءامنوا وعملوا الصلحت جنت تجري من تحتها الانهر خلدين فيها باذن ربهم تحيتهم فيها سلم",
  },
  {
    verseId: 23,
    name: "ابراهيم",
    surahId: 14,
    text: "أَلَمۡ تَرَ كَيۡفَ ضَرَبَ ٱللَّهُ مَثَلٗا كَلِمَةٗ طَيِّبَةٗ كَشَجَرَةٖ طَيِّبَةٍ أَصۡلُهَا ثَابِتٞ وَفَرۡعُهَا فِي ٱلسَّمَآءِ",
    translation:
      "Have you not considered how Allah presents an example, [making] a good word like a good tree, whose root is firmly fixed and its branches [high] in the sky",
    normalizedText:
      "الم تر كيف ضرب الله مثلا كلمة طيبة كشجرة طيبة اصلها ثابت وفرعها في السماء",
  },
  {
    verseId: 24,
    name: "ابراهيم",
    surahId: 14,
    text: "تُؤۡتِيٓ أُكُلَهَا كُلَّ حِينِۭ بِإِذۡنِ رَبِّهَاۗ وَيَضۡرِبُ ٱللَّهُ ٱلۡأَمۡثَالَ لِلنَّاسِ لَعَلَّهُمۡ يَتَذَكَّرُونَ",
    translation:
      "It produces its fruit all the time, by permission of its Lord. And Allah presents examples for the people that perhaps they will be reminded",
    normalizedText:
      "تاتي اكلها كل حين باذن ربها ويضرب الله الامثال للناس لعلهم يتذكرون",
  },
  {
    verseId: 25,
    name: "ابراهيم",
    surahId: 14,
    text: "وَمَثَلُ كَلِمَةٍ خَبِيثَةٖ كَشَجَرَةٍ خَبِيثَةٍ ٱجۡتُثَّتۡ مِن فَوۡقِ ٱلۡأَرۡضِ مَا لَهَا مِن قَرَارٖ",
    translation:
      "And the example of a bad word is like a bad tree, uprooted from the surface of the earth, not having any stability",
    normalizedText:
      "ومثل كلمة خبيثة كشجرة خبيثة اجتثت من فوق الارض ما لها من قرار",
  },
  {
    verseId: 26,
    name: "ابراهيم",
    surahId: 14,
    text: "يُثَبِّتُ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ بِٱلۡقَوۡلِ ٱلثَّابِتِ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَفِي ٱلۡأٓخِرَةِۖ وَيُضِلُّ ٱللَّهُ ٱلظَّـٰلِمِينَۚ وَيَفۡعَلُ ٱللَّهُ مَا يَشَآءُ",
    translation:
      "Allah keeps firm those who believe, with the firm word, in worldly life and in the Hereafter. And Allah sends astray the wrongdoers. And Allah does what He wills",
    normalizedText:
      "يثبت الله الذين ءامنوا بالقول الثابت في الحيوة الدنيا وفي الاخرة ويضل الله الظلمين ويفعل الله ما يشاء",
  },
  {
    verseId: 27,
    name: "ابراهيم",
    surahId: 14,
    text: "۞أَلَمۡ تَرَ إِلَى ٱلَّذِينَ بَدَّلُواْ نِعۡمَتَ ٱللَّهِ كُفۡرٗا وَأَحَلُّواْ قَوۡمَهُمۡ دَارَ ٱلۡبَوَارِ",
    translation:
      "Have you not considered those who exchanged the favor of Allah for disbelief and settled their people [in] the home of ruin",
    normalizedText:
      "۞الم تر الى الذين بدلوا نعمت الله كفرا واحلوا قومهم دار البوار",
  },
  {
    verseId: 28,
    name: "ابراهيم",
    surahId: 14,
    text: "جَهَنَّمَ يَصۡلَوۡنَهَاۖ وَبِئۡسَ ٱلۡقَرَارُ",
    translation:
      "[It is] Hell, which they will [enter to] burn, and wretched is the settlement",
    normalizedText: "جهنم يصلونها وباس القرار",
  },
  {
    verseId: 29,
    name: "ابراهيم",
    surahId: 14,
    text: "وَجَعَلُواْ لِلَّهِ أَندَادٗا لِّيُضِلُّواْ عَن سَبِيلِهِۦۗ قُلۡ تَمَتَّعُواْ فَإِنَّ مَصِيرَكُمۡ إِلَى ٱلنَّارِ",
    translation:
      'And they have attributed to Allah equals to mislead [people] from His way. Say, "Enjoy yourselves, for indeed, your destination is the Fire',
    normalizedText:
      "وجعلوا لله اندادا ليضلوا عن سبيله قل تمتعوا فان مصيركم الى النار",
  },
  {
    verseId: 30,
    name: "ابراهيم",
    surahId: 14,
    text: "قُل لِّعِبَادِيَ ٱلَّذِينَ ءَامَنُواْ يُقِيمُواْ ٱلصَّلَوٰةَ وَيُنفِقُواْ مِمَّا رَزَقۡنَٰهُمۡ سِرّٗا وَعَلَانِيَةٗ مِّن قَبۡلِ أَن يَأۡتِيَ يَوۡمٞ لَّا بَيۡعٞ فِيهِ وَلَا خِلَٰلٌ",
    translation:
      "[O Muhammad], tell My servants who have believed to establish prayer and spend from what We have provided them, secretly and publicly, before a Day comes in which there will be no exchange, nor any friendships",
    normalizedText:
      "قل لعبادي الذين ءامنوا يقيموا الصلوة وينفقوا مما رزقنهم سرا وعلانية من قبل ان ياتي يوم لا بيع فيه ولا خلل",
  },
  {
    verseId: 31,
    name: "ابراهيم",
    surahId: 14,
    text: "ٱللَّهُ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَأَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَأَخۡرَجَ بِهِۦ مِنَ ٱلثَّمَرَٰتِ رِزۡقٗا لَّكُمۡۖ وَسَخَّرَ لَكُمُ ٱلۡفُلۡكَ لِتَجۡرِيَ فِي ٱلۡبَحۡرِ بِأَمۡرِهِۦۖ وَسَخَّرَ لَكُمُ ٱلۡأَنۡهَٰرَ",
    translation:
      "It is Allah who created the heavens and the earth and sent down rain from the sky and produced thereby some fruits as provision for you and subjected for you the ships to sail through the sea by His command and subjected for you the rivers",
    normalizedText:
      "الله الذي خلق السموت والارض وانزل من السماء ماء فاخرج به من الثمرت رزقا لكم وسخر لكم الفلك لتجري في البحر بامره وسخر لكم الانهر",
  },
  {
    verseId: 32,
    name: "ابراهيم",
    surahId: 14,
    text: "وَسَخَّرَ لَكُمُ ٱلشَّمۡسَ وَٱلۡقَمَرَ دَآئِبَيۡنِۖ وَسَخَّرَ لَكُمُ ٱلَّيۡلَ وَٱلنَّهَارَ",
    translation:
      "And He subjected for you the sun and the moon, continuous [in orbit], and subjected for you the night and the day",
    normalizedText: "وسخر لكم الشمس والقمر داابين وسخر لكم اليل والنهار",
  },
  {
    verseId: 33,
    name: "ابراهيم",
    surahId: 14,
    text: "وَءَاتَىٰكُم مِّن كُلِّ مَا سَأَلۡتُمُوهُۚ وَإِن تَعُدُّواْ نِعۡمَتَ ٱللَّهِ لَا تُحۡصُوهَآۗ إِنَّ ٱلۡإِنسَٰنَ لَظَلُومٞ كَفَّارٞ",
    translation:
      "And He gave you from all you asked of Him. And if you should count the favor of Allah, you could not enumerate them. Indeed, mankind is [generally] most unjust and ungrateful",
    normalizedText:
      "وءاتىكم من كل ما سالتموه وان تعدوا نعمت الله لا تحصوها ان الانسن لظلوم كفار",
  },
  {
    verseId: 34,
    name: "ابراهيم",
    surahId: 14,
    text: "وَإِذۡ قَالَ إِبۡرَٰهِيمُ رَبِّ ٱجۡعَلۡ هَٰذَا ٱلۡبَلَدَ ءَامِنٗا وَٱجۡنُبۡنِي وَبَنِيَّ أَن نَّعۡبُدَ ٱلۡأَصۡنَامَ",
    translation:
      'And [mention, O Muhammad], when Abraham said, "My Lord, make this city [Makkah] secure and keep me and my sons away from worshipping idols',
    normalizedText:
      "واذ قال ابرهيم رب اجعل هذا البلد ءامنا واجنبني وبني ان نعبد الاصنام",
  },
  {
    verseId: 35,
    name: "ابراهيم",
    surahId: 14,
    text: "رَبِّ إِنَّهُنَّ أَضۡلَلۡنَ كَثِيرٗا مِّنَ ٱلنَّاسِۖ فَمَن تَبِعَنِي فَإِنَّهُۥ مِنِّيۖ وَمَنۡ عَصَانِي فَإِنَّكَ غَفُورٞ رَّحِيمٞ",
    translation:
      "My Lord, indeed they have led astray many among the people. So whoever follows me - then he is of me; and whoever disobeys me - indeed, You are [yet] Forgiving and Merciful",
    normalizedText:
      "رب انهن اضللن كثيرا من الناس فمن تبعني فانه مني ومن عصاني فانك غفور رحيم",
  },
  {
    verseId: 36,
    name: "ابراهيم",
    surahId: 14,
    text: "رَّبَّنَآ إِنِّيٓ أَسۡكَنتُ مِن ذُرِّيَّتِي بِوَادٍ غَيۡرِ ذِي زَرۡعٍ عِندَ بَيۡتِكَ ٱلۡمُحَرَّمِ رَبَّنَا لِيُقِيمُواْ ٱلصَّلَوٰةَ فَٱجۡعَلۡ أَفۡـِٔدَةٗ مِّنَ ٱلنَّاسِ تَهۡوِيٓ إِلَيۡهِمۡ وَٱرۡزُقۡهُم مِّنَ ٱلثَّمَرَٰتِ لَعَلَّهُمۡ يَشۡكُرُونَ",
    translation:
      "Our Lord, I have settled some of my descendants in an uncultivated valley near Your sacred House, our Lord, that they may establish prayer. So make hearts among the people incline toward them and provide for them from the fruits that they might be grateful",
    normalizedText:
      "ربنا اني اسكنت من ذريتي بواد غير ذي زرع عند بيتك المحرم ربنا ليقيموا الصلوة فاجعل افدة من الناس تهوي اليهم وارزقهم من الثمرت لعلهم يشكرون",
  },
  {
    verseId: 37,
    name: "ابراهيم",
    surahId: 14,
    text: "رَبَّنَآ إِنَّكَ تَعۡلَمُ مَا نُخۡفِي وَمَا نُعۡلِنُۗ وَمَا يَخۡفَىٰ عَلَى ٱللَّهِ مِن شَيۡءٖ فِي ٱلۡأَرۡضِ وَلَا فِي ٱلسَّمَآءِ",
    translation:
      "Our Lord, indeed You know what we conceal and what we declare, and nothing is hidden from Allah on the earth or in the heaven",
    normalizedText:
      "ربنا انك تعلم ما نخفي وما نعلن وما يخفى على الله من شيء في الارض ولا في السماء",
  },
  {
    verseId: 38,
    name: "ابراهيم",
    surahId: 14,
    text: "ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي وَهَبَ لِي عَلَى ٱلۡكِبَرِ إِسۡمَٰعِيلَ وَإِسۡحَٰقَۚ إِنَّ رَبِّي لَسَمِيعُ ٱلدُّعَآءِ",
    translation:
      "Praise to Allah, who has granted to me in old age Ishmael and Isaac. Indeed, my Lord is the Hearer of supplication",
    normalizedText:
      "الحمد لله الذي وهب لي على الكبر اسمعيل واسحق ان ربي لسميع الدعاء",
  },
  {
    verseId: 39,
    name: "ابراهيم",
    surahId: 14,
    text: "رَبِّ ٱجۡعَلۡنِي مُقِيمَ ٱلصَّلَوٰةِ وَمِن ذُرِّيَّتِيۚ رَبَّنَا وَتَقَبَّلۡ دُعَآءِ",
    translation:
      "My Lord, make me an establisher of prayer, and [many] from my descendants. Our Lord, and accept my supplication",
    normalizedText: "رب اجعلني مقيم الصلوة ومن ذريتي ربنا وتقبل دعاء",
  },
  {
    verseId: 40,
    name: "ابراهيم",
    surahId: 14,
    text: "رَبَّنَا ٱغۡفِرۡ لِي وَلِوَٰلِدَيَّ وَلِلۡمُؤۡمِنِينَ يَوۡمَ يَقُومُ ٱلۡحِسَابُ",
    translation:
      "Our Lord, forgive me and my parents and the believers the Day the account is established",
    normalizedText: "ربنا اغفر لي ولولدي وللمامنين يوم يقوم الحساب",
  },
  {
    verseId: 41,
    name: "ابراهيم",
    surahId: 14,
    text: "وَلَا تَحۡسَبَنَّ ٱللَّهَ غَٰفِلًا عَمَّا يَعۡمَلُ ٱلظَّـٰلِمُونَۚ إِنَّمَا يُؤَخِّرُهُمۡ لِيَوۡمٖ تَشۡخَصُ فِيهِ ٱلۡأَبۡصَٰرُ",
    translation:
      "And never think that Allah is unaware of what the wrongdoers do. He only delays them for a Day when eyes will stare [in horror]",
    normalizedText:
      "ولا تحسبن الله غفلا عما يعمل الظلمون انما ياخرهم ليوم تشخص فيه الابصر",
  },
  {
    verseId: 42,
    name: "ابراهيم",
    surahId: 14,
    text: "مُهۡطِعِينَ مُقۡنِعِي رُءُوسِهِمۡ لَا يَرۡتَدُّ إِلَيۡهِمۡ طَرۡفُهُمۡۖ وَأَفۡـِٔدَتُهُمۡ هَوَآءٞ",
    translation:
      "Racing ahead, their heads raised up, their glance does not come back to them, and their hearts are void",
    normalizedText: "مهطعين مقنعي رءوسهم لا يرتد اليهم طرفهم وافدتهم هواء",
  },
  {
    verseId: 43,
    name: "ابراهيم",
    surahId: 14,
    text: "وَأَنذِرِ ٱلنَّاسَ يَوۡمَ يَأۡتِيهِمُ ٱلۡعَذَابُ فَيَقُولُ ٱلَّذِينَ ظَلَمُواْ رَبَّنَآ أَخِّرۡنَآ إِلَىٰٓ أَجَلٖ قَرِيبٖ نُّجِبۡ دَعۡوَتَكَ وَنَتَّبِعِ ٱلرُّسُلَۗ أَوَلَمۡ تَكُونُوٓاْ أَقۡسَمۡتُم مِّن قَبۡلُ مَا لَكُم مِّن زَوَالٖ",
    translation:
      'And, [O Muhammad], warn the people of a Day when the punishment will come to them and those who did wrong will say, "Our Lord, delay us for a short term; we will answer Your call and follow the messengers." [But it will be said], "Had you not sworn, before, that for you there would be no cessation',
    normalizedText:
      "وانذر الناس يوم ياتيهم العذاب فيقول الذين ظلموا ربنا اخرنا الى اجل قريب نجب دعوتك ونتبع الرسل اولم تكونوا اقسمتم من قبل ما لكم من زوال",
  },
  {
    verseId: 44,
    name: "ابراهيم",
    surahId: 14,
    text: "وَسَكَنتُمۡ فِي مَسَٰكِنِ ٱلَّذِينَ ظَلَمُوٓاْ أَنفُسَهُمۡ وَتَبَيَّنَ لَكُمۡ كَيۡفَ فَعَلۡنَا بِهِمۡ وَضَرَبۡنَا لَكُمُ ٱلۡأَمۡثَالَ",
    translation:
      "And you lived among the dwellings of those who wronged themselves, and it had become clear to you how We dealt with them. And We presented for you [many] examples",
    normalizedText:
      "وسكنتم في مسكن الذين ظلموا انفسهم وتبين لكم كيف فعلنا بهم وضربنا لكم الامثال",
  },
  {
    verseId: 45,
    name: "ابراهيم",
    surahId: 14,
    text: "وَقَدۡ مَكَرُواْ مَكۡرَهُمۡ وَعِندَ ٱللَّهِ مَكۡرُهُمۡ وَإِن كَانَ مَكۡرُهُمۡ لِتَزُولَ مِنۡهُ ٱلۡجِبَالُ",
    translation:
      "And they had planned their plan, but with Allah is [recorded] their plan, even if their plan had been [sufficient] to do away with the mountains",
    normalizedText:
      "وقد مكروا مكرهم وعند الله مكرهم وان كان مكرهم لتزول منه الجبال",
  },
  {
    verseId: 46,
    name: "ابراهيم",
    surahId: 14,
    text: "فَلَا تَحۡسَبَنَّ ٱللَّهَ مُخۡلِفَ وَعۡدِهِۦ رُسُلَهُۥٓۚ إِنَّ ٱللَّهَ عَزِيزٞ ذُو ٱنتِقَامٖ",
    translation:
      "So never think that Allah will fail in His promise to His messengers. Indeed, Allah is Exalted in Might and Owner of Retribution",
    normalizedText: "فلا تحسبن الله مخلف وعده رسله ان الله عزيز ذو انتقام",
  },
  {
    verseId: 47,
    name: "ابراهيم",
    surahId: 14,
    text: "يَوۡمَ تُبَدَّلُ ٱلۡأَرۡضُ غَيۡرَ ٱلۡأَرۡضِ وَٱلسَّمَٰوَٰتُۖ وَبَرَزُواْ لِلَّهِ ٱلۡوَٰحِدِ ٱلۡقَهَّارِ",
    translation:
      "[It will be] on the Day the earth will be replaced by another earth, and the heavens [as well], and all creatures will come out before Allah, the One, the Prevailing",
    normalizedText: "يوم تبدل الارض غير الارض والسموت وبرزوا لله الوحد القهار",
  },
  {
    verseId: 48,
    name: "ابراهيم",
    surahId: 14,
    text: "وَتَرَى ٱلۡمُجۡرِمِينَ يَوۡمَئِذٖ مُّقَرَّنِينَ فِي ٱلۡأَصۡفَادِ",
    translation:
      "And you will see the criminals that Day bound together in shackles",
    normalizedText: "وترى المجرمين يوماذ مقرنين في الاصفاد",
  },
  {
    verseId: 49,
    name: "ابراهيم",
    surahId: 14,
    text: "سَرَابِيلُهُم مِّن قَطِرَانٖ وَتَغۡشَىٰ وُجُوهَهُمُ ٱلنَّارُ",
    translation:
      "Their garments of liquid pitch and their faces covered by the Fire",
    normalizedText: "سرابيلهم من قطران وتغشى وجوههم النار",
  },
  {
    verseId: 50,
    name: "ابراهيم",
    surahId: 14,
    text: "لِيَجۡزِيَ ٱللَّهُ كُلَّ نَفۡسٖ مَّا كَسَبَتۡۚ إِنَّ ٱللَّهَ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      "So that Allah will recompense every soul for what it earned. Indeed, Allah is swift in account",
    normalizedText: "ليجزي الله كل نفس ما كسبت ان الله سريع الحساب",
  },
  {
    verseId: 51,
    name: "ابراهيم",
    surahId: 14,
    text: "هَٰذَا بَلَٰغٞ لِّلنَّاسِ وَلِيُنذَرُواْ بِهِۦ وَلِيَعۡلَمُوٓاْ أَنَّمَا هُوَ إِلَٰهٞ وَٰحِدٞ وَلِيَذَّكَّرَ أُوْلُواْ ٱلۡأَلۡبَٰبِ",
    translation:
      "This [Qur'an] is notification for the people that they may be warned thereby and that they may know that He is but one God and that those of understanding will be reminded",
    normalizedText:
      "هذا بلغ للناس ولينذروا به وليعلموا انما هو اله وحد وليذكر اولوا الالبب",
  },
  {
    verseId: 0,
    name: "الحجر",
    surahId: 15,
    text: "الٓرۚ تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ وَقُرۡءَانٖ مُّبِينٖ",
    translation:
      "Alif, Lam, Ra. These are the verses of the Book and a clear Qur'an",
    normalizedText: "الر تلك ءايت الكتب وقرءان مبين",
  },
  {
    verseId: 1,
    name: "الحجر",
    surahId: 15,
    text: "رُّبَمَا يَوَدُّ ٱلَّذِينَ كَفَرُواْ لَوۡ كَانُواْ مُسۡلِمِينَ",
    translation:
      "Perhaps those who disbelieve will wish that they had been Muslims",
    normalizedText: "ربما يود الذين كفروا لو كانوا مسلمين",
  },
  {
    verseId: 2,
    name: "الحجر",
    surahId: 15,
    text: "ذَرۡهُمۡ يَأۡكُلُواْ وَيَتَمَتَّعُواْ وَيُلۡهِهِمُ ٱلۡأَمَلُۖ فَسَوۡفَ يَعۡلَمُونَ",
    translation:
      "Let them eat and enjoy themselves and be diverted by [false] hope, for they are going to know",
    normalizedText: "ذرهم ياكلوا ويتمتعوا ويلههم الامل فسوف يعلمون",
  },
  {
    verseId: 3,
    name: "الحجر",
    surahId: 15,
    text: "وَمَآ أَهۡلَكۡنَا مِن قَرۡيَةٍ إِلَّا وَلَهَا كِتَابٞ مَّعۡلُومٞ",
    translation:
      "And We did not destroy any city but that for it was a known decree",
    normalizedText: "وما اهلكنا من قرية الا ولها كتاب معلوم",
  },
  {
    verseId: 4,
    name: "الحجر",
    surahId: 15,
    text: "مَّا تَسۡبِقُ مِنۡ أُمَّةٍ أَجَلَهَا وَمَا يَسۡتَـٔۡخِرُونَ",
    translation:
      "No nation will precede its term, nor will they remain thereafter",
    normalizedText: "ما تسبق من امة اجلها وما يستخرون",
  },
  {
    verseId: 5,
    name: "الحجر",
    surahId: 15,
    text: "وَقَالُواْ يَـٰٓأَيُّهَا ٱلَّذِي نُزِّلَ عَلَيۡهِ ٱلذِّكۡرُ إِنَّكَ لَمَجۡنُونٞ",
    translation:
      'And they say, "O you upon whom the message has been sent down, indeed you are mad',
    normalizedText: "وقالوا يايها الذي نزل عليه الذكر انك لمجنون",
  },
  {
    verseId: 6,
    name: "الحجر",
    surahId: 15,
    text: "لَّوۡمَا تَأۡتِينَا بِٱلۡمَلَـٰٓئِكَةِ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      "Why do you not bring us the angels, if you should be among the truthful",
    normalizedText: "لوما تاتينا بالملاكة ان كنت من الصدقين",
  },
  {
    verseId: 7,
    name: "الحجر",
    surahId: 15,
    text: "مَا نُنَزِّلُ ٱلۡمَلَـٰٓئِكَةَ إِلَّا بِٱلۡحَقِّ وَمَا كَانُوٓاْ إِذٗا مُّنظَرِينَ",
    translation:
      "We do not send down the angels except with truth; and the disbelievers would not then be reprieved",
    normalizedText: "ما ننزل الملاكة الا بالحق وما كانوا اذا منظرين",
  },
  {
    verseId: 8,
    name: "الحجر",
    surahId: 15,
    text: "إِنَّا نَحۡنُ نَزَّلۡنَا ٱلذِّكۡرَ وَإِنَّا لَهُۥ لَحَٰفِظُونَ",
    translation:
      "Indeed, it is We who sent down the Qur'an and indeed, We will be its guardian",
    normalizedText: "انا نحن نزلنا الذكر وانا له لحفظون",
  },
  {
    verseId: 9,
    name: "الحجر",
    surahId: 15,
    text: "وَلَقَدۡ أَرۡسَلۡنَا مِن قَبۡلِكَ فِي شِيَعِ ٱلۡأَوَّلِينَ",
    translation:
      "And We had certainly sent [messengers] before you, [O Muhammad], among the sects of the former peoples",
    normalizedText: "ولقد ارسلنا من قبلك في شيع الاولين",
  },
  {
    verseId: 10,
    name: "الحجر",
    surahId: 15,
    text: "وَمَا يَأۡتِيهِم مِّن رَّسُولٍ إِلَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "And no messenger would come to them except that they ridiculed him",
    normalizedText: "وما ياتيهم من رسول الا كانوا به يستهزءون",
  },
  {
    verseId: 11,
    name: "الحجر",
    surahId: 15,
    text: "كَذَٰلِكَ نَسۡلُكُهُۥ فِي قُلُوبِ ٱلۡمُجۡرِمِينَ",
    translation: "Thus do We insert denial into the hearts of the criminals",
    normalizedText: "كذلك نسلكه في قلوب المجرمين",
  },
  {
    verseId: 12,
    name: "الحجر",
    surahId: 15,
    text: "لَا يُؤۡمِنُونَ بِهِۦ وَقَدۡ خَلَتۡ سُنَّةُ ٱلۡأَوَّلِينَ",
    translation:
      "They will not believe in it, while there has already occurred the precedent of the former peoples",
    normalizedText: "لا يامنون به وقد خلت سنة الاولين",
  },
  {
    verseId: 13,
    name: "الحجر",
    surahId: 15,
    text: "وَلَوۡ فَتَحۡنَا عَلَيۡهِم بَابٗا مِّنَ ٱلسَّمَآءِ فَظَلُّواْ فِيهِ يَعۡرُجُونَ",
    translation:
      "And [even] if We opened to them a gate from the heaven and they continued therein to ascend",
    normalizedText: "ولو فتحنا عليهم بابا من السماء فظلوا فيه يعرجون",
  },
  {
    verseId: 14,
    name: "الحجر",
    surahId: 15,
    text: "لَقَالُوٓاْ إِنَّمَا سُكِّرَتۡ أَبۡصَٰرُنَا بَلۡ نَحۡنُ قَوۡمٞ مَّسۡحُورُونَ",
    translation:
      'They would say, "Our eyes have only been dazzled. Rather, we are a people affected by magic',
    normalizedText: "لقالوا انما سكرت ابصرنا بل نحن قوم مسحورون",
  },
  {
    verseId: 15,
    name: "الحجر",
    surahId: 15,
    text: "وَلَقَدۡ جَعَلۡنَا فِي ٱلسَّمَآءِ بُرُوجٗا وَزَيَّنَّـٰهَا لِلنَّـٰظِرِينَ",
    translation:
      "And We have placed within the heaven great stars and have beautified it for the observers",
    normalizedText: "ولقد جعلنا في السماء بروجا وزينها للنظرين",
  },
  {
    verseId: 16,
    name: "الحجر",
    surahId: 15,
    text: "وَحَفِظۡنَٰهَا مِن كُلِّ شَيۡطَٰنٖ رَّجِيمٍ",
    translation:
      "And We have protected it from every devil expelled [from the mercy of Allah]",
    normalizedText: "وحفظنها من كل شيطن رجيم",
  },
  {
    verseId: 17,
    name: "الحجر",
    surahId: 15,
    text: "إِلَّا مَنِ ٱسۡتَرَقَ ٱلسَّمۡعَ فَأَتۡبَعَهُۥ شِهَابٞ مُّبِينٞ",
    translation:
      "Except one who steals a hearing and is pursued by a clear burning flame",
    normalizedText: "الا من استرق السمع فاتبعه شهاب مبين",
  },
  {
    verseId: 18,
    name: "الحجر",
    surahId: 15,
    text: "وَٱلۡأَرۡضَ مَدَدۡنَٰهَا وَأَلۡقَيۡنَا فِيهَا رَوَٰسِيَ وَأَنۢبَتۡنَا فِيهَا مِن كُلِّ شَيۡءٖ مَّوۡزُونٖ",
    translation:
      "And the earth - We have spread it and cast therein firmly set mountains and caused to grow therein [something] of every well-balanced thing",
    normalizedText:
      "والارض مددنها والقينا فيها روسي وانبتنا فيها من كل شيء موزون",
  },
  {
    verseId: 19,
    name: "الحجر",
    surahId: 15,
    text: "وَجَعَلۡنَا لَكُمۡ فِيهَا مَعَٰيِشَ وَمَن لَّسۡتُمۡ لَهُۥ بِرَٰزِقِينَ",
    translation:
      "And We have made for you therein means of living and [for] those for whom you are not providers",
    normalizedText: "وجعلنا لكم فيها معيش ومن لستم له برزقين",
  },
  {
    verseId: 20,
    name: "الحجر",
    surahId: 15,
    text: "وَإِن مِّن شَيۡءٍ إِلَّا عِندَنَا خَزَآئِنُهُۥ وَمَا نُنَزِّلُهُۥٓ إِلَّا بِقَدَرٖ مَّعۡلُومٖ",
    translation:
      "And there is not a thing but that with Us are its depositories, and We do not send it down except according to a known measure",
    normalizedText: "وان من شيء الا عندنا خزاانه وما ننزله الا بقدر معلوم",
  },
  {
    verseId: 21,
    name: "الحجر",
    surahId: 15,
    text: "وَأَرۡسَلۡنَا ٱلرِّيَٰحَ لَوَٰقِحَ فَأَنزَلۡنَا مِنَ ٱلسَّمَآءِ مَآءٗ فَأَسۡقَيۡنَٰكُمُوهُ وَمَآ أَنتُمۡ لَهُۥ بِخَٰزِنِينَ",
    translation:
      "And We have sent the fertilizing winds and sent down water from the sky and given you drink from it. And you are not its retainers",
    normalizedText:
      "وارسلنا الريح لوقح فانزلنا من السماء ماء فاسقينكموه وما انتم له بخزنين",
  },
  {
    verseId: 22,
    name: "الحجر",
    surahId: 15,
    text: "وَإِنَّا لَنَحۡنُ نُحۡيِۦ وَنُمِيتُ وَنَحۡنُ ٱلۡوَٰرِثُونَ",
    translation:
      "And indeed, it is We who give life and cause death, and We are the Inheritor",
    normalizedText: "وانا لنحن نحي ونميت ونحن الورثون",
  },
  {
    verseId: 23,
    name: "الحجر",
    surahId: 15,
    text: "وَلَقَدۡ عَلِمۡنَا ٱلۡمُسۡتَقۡدِمِينَ مِنكُمۡ وَلَقَدۡ عَلِمۡنَا ٱلۡمُسۡتَـٔۡخِرِينَ",
    translation:
      "And We have already known the preceding [generations] among you, and We have already known the later [ones to come]",
    normalizedText: "ولقد علمنا المستقدمين منكم ولقد علمنا المستخرين",
  },
  {
    verseId: 24,
    name: "الحجر",
    surahId: 15,
    text: "وَإِنَّ رَبَّكَ هُوَ يَحۡشُرُهُمۡۚ إِنَّهُۥ حَكِيمٌ عَلِيمٞ",
    translation:
      "And indeed, your Lord will gather them; indeed, He is Wise and Knowing",
    normalizedText: "وان ربك هو يحشرهم انه حكيم عليم",
  },
  {
    verseId: 25,
    name: "الحجر",
    surahId: 15,
    text: "وَلَقَدۡ خَلَقۡنَا ٱلۡإِنسَٰنَ مِن صَلۡصَٰلٖ مِّنۡ حَمَإٖ مَّسۡنُونٖ",
    translation:
      "And We did certainly create man out of clay from an altered black mud",
    normalizedText: "ولقد خلقنا الانسن من صلصل من حما مسنون",
  },
  {
    verseId: 26,
    name: "الحجر",
    surahId: 15,
    text: "وَٱلۡجَآنَّ خَلَقۡنَٰهُ مِن قَبۡلُ مِن نَّارِ ٱلسَّمُومِ",
    translation: "And the jinn We created before from scorching fire",
    normalizedText: "والجان خلقنه من قبل من نار السموم",
  },
  {
    verseId: 27,
    name: "الحجر",
    surahId: 15,
    text: "وَإِذۡ قَالَ رَبُّكَ لِلۡمَلَـٰٓئِكَةِ إِنِّي خَٰلِقُۢ بَشَرٗا مِّن صَلۡصَٰلٖ مِّنۡ حَمَإٖ مَّسۡنُونٖ",
    translation:
      'And [mention, O Muhammad], when your Lord said to the angels, "I will create a human being out of clay from an altered black mud',
    normalizedText: "واذ قال ربك للملاكة اني خلق بشرا من صلصل من حما مسنون",
  },
  {
    verseId: 28,
    name: "الحجر",
    surahId: 15,
    text: "فَإِذَا سَوَّيۡتُهُۥ وَنَفَخۡتُ فِيهِ مِن رُّوحِي فَقَعُواْ لَهُۥ سَٰجِدِينَ",
    translation:
      "And when I have proportioned him and breathed into him of My [created] soul, then fall down to him in prostration",
    normalizedText: "فاذا سويته ونفخت فيه من روحي فقعوا له سجدين",
  },
  {
    verseId: 29,
    name: "الحجر",
    surahId: 15,
    text: "فَسَجَدَ ٱلۡمَلَـٰٓئِكَةُ كُلُّهُمۡ أَجۡمَعُونَ",
    translation: "So the angels prostrated - all of them entirely",
    normalizedText: "فسجد الملاكة كلهم اجمعون",
  },
  {
    verseId: 30,
    name: "الحجر",
    surahId: 15,
    text: "إِلَّآ إِبۡلِيسَ أَبَىٰٓ أَن يَكُونَ مَعَ ٱلسَّـٰجِدِينَ",
    translation: "Except Iblees, he refused to be with those who prostrated",
    normalizedText: "الا ابليس ابى ان يكون مع السجدين",
  },
  {
    verseId: 31,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ يَـٰٓإِبۡلِيسُ مَا لَكَ أَلَّا تَكُونَ مَعَ ٱلسَّـٰجِدِينَ",
    translation:
      "[Allah] said, O Iblees, what is [the matter] with you that you are not with those who prostrate",
    normalizedText: "قال يابليس ما لك الا تكون مع السجدين",
  },
  {
    verseId: 32,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ لَمۡ أَكُن لِّأَسۡجُدَ لِبَشَرٍ خَلَقۡتَهُۥ مِن صَلۡصَٰلٖ مِّنۡ حَمَإٖ مَّسۡنُونٖ",
    translation:
      'He said, "Never would I prostrate to a human whom You created out of clay from an altered black mud',
    normalizedText: "قال لم اكن لاسجد لبشر خلقته من صلصل من حما مسنون",
  },
  {
    verseId: 33,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ فَٱخۡرُجۡ مِنۡهَا فَإِنَّكَ رَجِيمٞ",
    translation:
      '[Allah] said, "Then get out of it, for indeed, you are expelled',
    normalizedText: "قال فاخرج منها فانك رجيم",
  },
  {
    verseId: 34,
    name: "الحجر",
    surahId: 15,
    text: "وَإِنَّ عَلَيۡكَ ٱللَّعۡنَةَ إِلَىٰ يَوۡمِ ٱلدِّينِ",
    translation:
      "And indeed, upon you is the curse until the Day of Recompense",
    normalizedText: "وان عليك اللعنة الى يوم الدين",
  },
  {
    verseId: 35,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ رَبِّ فَأَنظِرۡنِيٓ إِلَىٰ يَوۡمِ يُبۡعَثُونَ",
    translation:
      'He said, "My Lord, then reprieve me until the Day they are resurrected',
    normalizedText: "قال رب فانظرني الى يوم يبعثون",
  },
  {
    verseId: 36,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ فَإِنَّكَ مِنَ ٱلۡمُنظَرِينَ",
    translation: '[Allah] said, "So indeed, you are of those reprieved',
    normalizedText: "قال فانك من المنظرين",
  },
  {
    verseId: 37,
    name: "الحجر",
    surahId: 15,
    text: "إِلَىٰ يَوۡمِ ٱلۡوَقۡتِ ٱلۡمَعۡلُومِ",
    translation: "Until the Day of the time well-known",
    normalizedText: "الى يوم الوقت المعلوم",
  },
  {
    verseId: 38,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ رَبِّ بِمَآ أَغۡوَيۡتَنِي لَأُزَيِّنَنَّ لَهُمۡ فِي ٱلۡأَرۡضِ وَلَأُغۡوِيَنَّهُمۡ أَجۡمَعِينَ",
    translation:
      '[Iblees] said, "My Lord, because You have put me in error, I will surely make [disobedience] attractive to them on earth, and I will mislead them all',
    normalizedText: "قال رب بما اغويتني لازينن لهم في الارض ولاغوينهم اجمعين",
  },
  {
    verseId: 39,
    name: "الحجر",
    surahId: 15,
    text: "إِلَّا عِبَادَكَ مِنۡهُمُ ٱلۡمُخۡلَصِينَ",
    translation: "Except, among them, Your chosen servants",
    normalizedText: "الا عبادك منهم المخلصين",
  },
  {
    verseId: 40,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ هَٰذَا صِرَٰطٌ عَلَيَّ مُسۡتَقِيمٌ",
    translation:
      '[Allah] said, "This is a path [of return] to Me [that is] straight',
    normalizedText: "قال هذا صرط علي مستقيم",
  },
  {
    verseId: 41,
    name: "الحجر",
    surahId: 15,
    text: "إِنَّ عِبَادِي لَيۡسَ لَكَ عَلَيۡهِمۡ سُلۡطَٰنٌ إِلَّا مَنِ ٱتَّبَعَكَ مِنَ ٱلۡغَاوِينَ",
    translation:
      "Indeed, My servants - no authority will you have over them, except those who follow you of the deviators",
    normalizedText: "ان عبادي ليس لك عليهم سلطن الا من اتبعك من الغاوين",
  },
  {
    verseId: 42,
    name: "الحجر",
    surahId: 15,
    text: "وَإِنَّ جَهَنَّمَ لَمَوۡعِدُهُمۡ أَجۡمَعِينَ",
    translation: "And indeed, Hell is the promised place for them all",
    normalizedText: "وان جهنم لموعدهم اجمعين",
  },
  {
    verseId: 43,
    name: "الحجر",
    surahId: 15,
    text: "لَهَا سَبۡعَةُ أَبۡوَٰبٖ لِّكُلِّ بَابٖ مِّنۡهُمۡ جُزۡءٞ مَّقۡسُومٌ",
    translation:
      "It has seven gates; for every gate is of them a portion designated",
    normalizedText: "لها سبعة ابوب لكل باب منهم جزء مقسوم",
  },
  {
    verseId: 44,
    name: "الحجر",
    surahId: 15,
    text: "إِنَّ ٱلۡمُتَّقِينَ فِي جَنَّـٰتٖ وَعُيُونٍ",
    translation: "Indeed, the righteous will be within gardens and springs",
    normalizedText: "ان المتقين في جنت وعيون",
  },
  {
    verseId: 45,
    name: "الحجر",
    surahId: 15,
    text: "ٱدۡخُلُوهَا بِسَلَٰمٍ ءَامِنِينَ",
    translation: '[Having been told], "Enter it in peace, safe [and secure]',
    normalizedText: "ادخلوها بسلم ءامنين",
  },
  {
    verseId: 46,
    name: "الحجر",
    surahId: 15,
    text: "وَنَزَعۡنَا مَا فِي صُدُورِهِم مِّنۡ غِلٍّ إِخۡوَٰنًا عَلَىٰ سُرُرٖ مُّتَقَٰبِلِينَ",
    translation:
      "And We will remove whatever is in their breasts of resentment, [so they will be] brothers, on thrones facing each other",
    normalizedText: "ونزعنا ما في صدورهم من غل اخونا على سرر متقبلين",
  },
  {
    verseId: 47,
    name: "الحجر",
    surahId: 15,
    text: "لَا يَمَسُّهُمۡ فِيهَا نَصَبٞ وَمَا هُم مِّنۡهَا بِمُخۡرَجِينَ",
    translation:
      "No fatigue will touch them therein, nor from it will they [ever] be removed",
    normalizedText: "لا يمسهم فيها نصب وما هم منها بمخرجين",
  },
  {
    verseId: 48,
    name: "الحجر",
    surahId: 15,
    text: "۞نَبِّئۡ عِبَادِيٓ أَنِّيٓ أَنَا ٱلۡغَفُورُ ٱلرَّحِيمُ",
    translation:
      "[O Muhammad], inform My servants that it is I who am the Forgiving, the Merciful",
    normalizedText: "۞نبا عبادي اني انا الغفور الرحيم",
  },
  {
    verseId: 49,
    name: "الحجر",
    surahId: 15,
    text: "وَأَنَّ عَذَابِي هُوَ ٱلۡعَذَابُ ٱلۡأَلِيمُ",
    translation: "And that it is My punishment which is the painful punishment",
    normalizedText: "وان عذابي هو العذاب الاليم",
  },
  {
    verseId: 50,
    name: "الحجر",
    surahId: 15,
    text: "وَنَبِّئۡهُمۡ عَن ضَيۡفِ إِبۡرَٰهِيمَ",
    translation: "And inform them about the guests of Abraham",
    normalizedText: "ونباهم عن ضيف ابرهيم",
  },
  {
    verseId: 51,
    name: "الحجر",
    surahId: 15,
    text: "إِذۡ دَخَلُواْ عَلَيۡهِ فَقَالُواْ سَلَٰمٗا قَالَ إِنَّا مِنكُمۡ وَجِلُونَ",
    translation:
      'When they entered upon him and said, "Peace." [Abraham] said, "Indeed, we are fearful of you',
    normalizedText: "اذ دخلوا عليه فقالوا سلما قال انا منكم وجلون",
  },
  {
    verseId: 52,
    name: "الحجر",
    surahId: 15,
    text: "قَالُواْ لَا تَوۡجَلۡ إِنَّا نُبَشِّرُكَ بِغُلَٰمٍ عَلِيمٖ",
    translation:
      '[The angels] said, "Fear not. Indeed, we give you good tidings of a learned boy',
    normalizedText: "قالوا لا توجل انا نبشرك بغلم عليم",
  },
  {
    verseId: 53,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ أَبَشَّرۡتُمُونِي عَلَىٰٓ أَن مَّسَّنِيَ ٱلۡكِبَرُ فَبِمَ تُبَشِّرُونَ",
    translation:
      'He said, "Have you given me good tidings although old age has come upon me? Then of what [wonder] do you inform',
    normalizedText: "قال ابشرتموني على ان مسني الكبر فبم تبشرون",
  },
  {
    verseId: 54,
    name: "الحجر",
    surahId: 15,
    text: "قَالُواْ بَشَّرۡنَٰكَ بِٱلۡحَقِّ فَلَا تَكُن مِّنَ ٱلۡقَٰنِطِينَ",
    translation:
      'They said, "We have given you good tidings in truth, so do not be of the despairing',
    normalizedText: "قالوا بشرنك بالحق فلا تكن من القنطين",
  },
  {
    verseId: 55,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ وَمَن يَقۡنَطُ مِن رَّحۡمَةِ رَبِّهِۦٓ إِلَّا ٱلضَّآلُّونَ",
    translation:
      'He said, "And who despairs of the mercy of his Lord except for those astray',
    normalizedText: "قال ومن يقنط من رحمة ربه الا الضالون",
  },
  {
    verseId: 56,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ فَمَا خَطۡبُكُمۡ أَيُّهَا ٱلۡمُرۡسَلُونَ",
    translation:
      '[Abraham] said, "Then what is your business [here], O messengers',
    normalizedText: "قال فما خطبكم ايها المرسلون",
  },
  {
    verseId: 57,
    name: "الحجر",
    surahId: 15,
    text: "قَالُوٓاْ إِنَّآ أُرۡسِلۡنَآ إِلَىٰ قَوۡمٖ مُّجۡرِمِينَ",
    translation:
      'They said, "Indeed, we have been sent to a people of criminals',
    normalizedText: "قالوا انا ارسلنا الى قوم مجرمين",
  },
  {
    verseId: 58,
    name: "الحجر",
    surahId: 15,
    text: "إِلَّآ ءَالَ لُوطٍ إِنَّا لَمُنَجُّوهُمۡ أَجۡمَعِينَ",
    translation: "Except the family of Lot; indeed, we will save them all",
    normalizedText: "الا ءال لوط انا لمنجوهم اجمعين",
  },
  {
    verseId: 59,
    name: "الحجر",
    surahId: 15,
    text: "إِلَّا ٱمۡرَأَتَهُۥ قَدَّرۡنَآ إِنَّهَا لَمِنَ ٱلۡغَٰبِرِينَ",
    translation:
      'Except his wife." Allah decreed that she is of those who remain behind',
    normalizedText: "الا امراته قدرنا انها لمن الغبرين",
  },
  {
    verseId: 60,
    name: "الحجر",
    surahId: 15,
    text: "فَلَمَّا جَآءَ ءَالَ لُوطٍ ٱلۡمُرۡسَلُونَ",
    translation: "And when the messengers came to the family of Lot",
    normalizedText: "فلما جاء ءال لوط المرسلون",
  },
  {
    verseId: 61,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ إِنَّكُمۡ قَوۡمٞ مُّنكَرُونَ",
    translation: 'He said, "Indeed, you are people unknown',
    normalizedText: "قال انكم قوم منكرون",
  },
  {
    verseId: 62,
    name: "الحجر",
    surahId: 15,
    text: "قَالُواْ بَلۡ جِئۡنَٰكَ بِمَا كَانُواْ فِيهِ يَمۡتَرُونَ",
    translation:
      'They said, "But we have come to you with that about which they were disputing',
    normalizedText: "قالوا بل جانك بما كانوا فيه يمترون",
  },
  {
    verseId: 63,
    name: "الحجر",
    surahId: 15,
    text: "وَأَتَيۡنَٰكَ بِٱلۡحَقِّ وَإِنَّا لَصَٰدِقُونَ",
    translation:
      "And we have come to you with truth, and indeed, we are truthful",
    normalizedText: "واتينك بالحق وانا لصدقون",
  },
  {
    verseId: 64,
    name: "الحجر",
    surahId: 15,
    text: "فَأَسۡرِ بِأَهۡلِكَ بِقِطۡعٖ مِّنَ ٱلَّيۡلِ وَٱتَّبِعۡ أَدۡبَٰرَهُمۡ وَلَا يَلۡتَفِتۡ مِنكُمۡ أَحَدٞ وَٱمۡضُواْ حَيۡثُ تُؤۡمَرُونَ",
    translation:
      "So set out with your family during a portion of the night and follow behind them and let not anyone among you look back and continue on to where you are commanded",
    normalizedText:
      "فاسر باهلك بقطع من اليل واتبع ادبرهم ولا يلتفت منكم احد وامضوا حيث تامرون",
  },
  {
    verseId: 65,
    name: "الحجر",
    surahId: 15,
    text: "وَقَضَيۡنَآ إِلَيۡهِ ذَٰلِكَ ٱلۡأَمۡرَ أَنَّ دَابِرَ هَـٰٓؤُلَآءِ مَقۡطُوعٞ مُّصۡبِحِينَ",
    translation:
      "And We conveyed to him [the decree] of that matter: that those [sinners] would be eliminated by early morning",
    normalizedText: "وقضينا اليه ذلك الامر ان دابر هالاء مقطوع مصبحين",
  },
  {
    verseId: 66,
    name: "الحجر",
    surahId: 15,
    text: "وَجَآءَ أَهۡلُ ٱلۡمَدِينَةِ يَسۡتَبۡشِرُونَ",
    translation: "And the people of the city came rejoicing",
    normalizedText: "وجاء اهل المدينة يستبشرون",
  },
  {
    verseId: 67,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ إِنَّ هَـٰٓؤُلَآءِ ضَيۡفِي فَلَا تَفۡضَحُونِ",
    translation: '[Lot] said, "Indeed, these are my guests, so do not shame me',
    normalizedText: "قال ان هالاء ضيفي فلا تفضحون",
  },
  {
    verseId: 68,
    name: "الحجر",
    surahId: 15,
    text: "وَٱتَّقُواْ ٱللَّهَ وَلَا تُخۡزُونِ",
    translation: "And fear Allah and do not disgrace me",
    normalizedText: "واتقوا الله ولا تخزون",
  },
  {
    verseId: 69,
    name: "الحجر",
    surahId: 15,
    text: "قَالُوٓاْ أَوَلَمۡ نَنۡهَكَ عَنِ ٱلۡعَٰلَمِينَ",
    translation:
      'They said, "Have we not forbidden you from [protecting] people',
    normalizedText: "قالوا اولم ننهك عن العلمين",
  },
  {
    verseId: 70,
    name: "الحجر",
    surahId: 15,
    text: "قَالَ هَـٰٓؤُلَآءِ بَنَاتِيٓ إِن كُنتُمۡ فَٰعِلِينَ",
    translation:
      '[Lot] said, "These are my daughters - if you would be doers [of lawful marriage]',
    normalizedText: "قال هالاء بناتي ان كنتم فعلين",
  },
  {
    verseId: 71,
    name: "الحجر",
    surahId: 15,
    text: "لَعَمۡرُكَ إِنَّهُمۡ لَفِي سَكۡرَتِهِمۡ يَعۡمَهُونَ",
    translation:
      "By your life, [O Muhammad], indeed they were, in their intoxication, wandering blindly",
    normalizedText: "لعمرك انهم لفي سكرتهم يعمهون",
  },
  {
    verseId: 72,
    name: "الحجر",
    surahId: 15,
    text: "فَأَخَذَتۡهُمُ ٱلصَّيۡحَةُ مُشۡرِقِينَ",
    translation: "So the shriek seized them at sunrise",
    normalizedText: "فاخذتهم الصيحة مشرقين",
  },
  {
    verseId: 73,
    name: "الحجر",
    surahId: 15,
    text: "فَجَعَلۡنَا عَٰلِيَهَا سَافِلَهَا وَأَمۡطَرۡنَا عَلَيۡهِمۡ حِجَارَةٗ مِّن سِجِّيلٍ",
    translation:
      "And We made the highest part [of the city] its lowest and rained upon them stones of hard clay",
    normalizedText: "فجعلنا عليها سافلها وامطرنا عليهم حجارة من سجيل",
  },
  {
    verseId: 74,
    name: "الحجر",
    surahId: 15,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّلۡمُتَوَسِّمِينَ",
    translation: "Indeed in that are signs for those who discern",
    normalizedText: "ان في ذلك لايت للمتوسمين",
  },
  {
    verseId: 75,
    name: "الحجر",
    surahId: 15,
    text: "وَإِنَّهَا لَبِسَبِيلٖ مُّقِيمٍ",
    translation:
      "And indeed, those cities are [situated] on an established road",
    normalizedText: "وانها لبسبيل مقيم",
  },
  {
    verseId: 76,
    name: "الحجر",
    surahId: 15,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّلۡمُؤۡمِنِينَ",
    translation: "Indeed in that is a sign for the believers",
    normalizedText: "ان في ذلك لاية للمامنين",
  },
  {
    verseId: 77,
    name: "الحجر",
    surahId: 15,
    text: "وَإِن كَانَ أَصۡحَٰبُ ٱلۡأَيۡكَةِ لَظَٰلِمِينَ",
    translation: "And the companions of the thicket were [also] wrongdoers",
    normalizedText: "وان كان اصحب الايكة لظلمين",
  },
  {
    verseId: 78,
    name: "الحجر",
    surahId: 15,
    text: "فَٱنتَقَمۡنَا مِنۡهُمۡ وَإِنَّهُمَا لَبِإِمَامٖ مُّبِينٖ",
    translation:
      "So We took retribution from them, and indeed, both [cities] are on a clear highway",
    normalizedText: "فانتقمنا منهم وانهما لبامام مبين",
  },
  {
    verseId: 79,
    name: "الحجر",
    surahId: 15,
    text: "وَلَقَدۡ كَذَّبَ أَصۡحَٰبُ ٱلۡحِجۡرِ ٱلۡمُرۡسَلِينَ",
    translation:
      "And certainly did the companions of Thamud deny the messengers",
    normalizedText: "ولقد كذب اصحب الحجر المرسلين",
  },
  {
    verseId: 80,
    name: "الحجر",
    surahId: 15,
    text: "وَءَاتَيۡنَٰهُمۡ ءَايَٰتِنَا فَكَانُواْ عَنۡهَا مُعۡرِضِينَ",
    translation:
      "And We gave them Our signs, but from them they were turning away",
    normalizedText: "وءاتينهم ءايتنا فكانوا عنها معرضين",
  },
  {
    verseId: 81,
    name: "الحجر",
    surahId: 15,
    text: "وَكَانُواْ يَنۡحِتُونَ مِنَ ٱلۡجِبَالِ بُيُوتًا ءَامِنِينَ",
    translation:
      "And they used to carve from the mountains, houses, feeling secure",
    normalizedText: "وكانوا ينحتون من الجبال بيوتا ءامنين",
  },
  {
    verseId: 82,
    name: "الحجر",
    surahId: 15,
    text: "فَأَخَذَتۡهُمُ ٱلصَّيۡحَةُ مُصۡبِحِينَ",
    translation: "But the shriek seized them at early morning",
    normalizedText: "فاخذتهم الصيحة مصبحين",
  },
  {
    verseId: 83,
    name: "الحجر",
    surahId: 15,
    text: "فَمَآ أَغۡنَىٰ عَنۡهُم مَّا كَانُواْ يَكۡسِبُونَ",
    translation: "So nothing availed them [from] what they used to earn",
    normalizedText: "فما اغنى عنهم ما كانوا يكسبون",
  },
  {
    verseId: 84,
    name: "الحجر",
    surahId: 15,
    text: "وَمَا خَلَقۡنَا ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَآ إِلَّا بِٱلۡحَقِّۗ وَإِنَّ ٱلسَّاعَةَ لَأٓتِيَةٞۖ فَٱصۡفَحِ ٱلصَّفۡحَ ٱلۡجَمِيلَ",
    translation:
      "And We have not created the heavens and earth and that between them except in truth. And indeed, the Hour is coming; so forgive with gracious forgiveness",
    normalizedText:
      "وما خلقنا السموت والارض وما بينهما الا بالحق وان الساعة لاتية فاصفح الصفح الجميل",
  },
  {
    verseId: 85,
    name: "الحجر",
    surahId: 15,
    text: "إِنَّ رَبَّكَ هُوَ ٱلۡخَلَّـٰقُ ٱلۡعَلِيمُ",
    translation: "Indeed, your Lord - He is the Knowing Creator",
    normalizedText: "ان ربك هو الخلق العليم",
  },
  {
    verseId: 86,
    name: "الحجر",
    surahId: 15,
    text: "وَلَقَدۡ ءَاتَيۡنَٰكَ سَبۡعٗا مِّنَ ٱلۡمَثَانِي وَٱلۡقُرۡءَانَ ٱلۡعَظِيمَ",
    translation:
      "And We have certainly given you, [O Muhammad], seven of the often repeated [verses] and the great Qur'an",
    normalizedText: "ولقد ءاتينك سبعا من المثاني والقرءان العظيم",
  },
  {
    verseId: 87,
    name: "الحجر",
    surahId: 15,
    text: "لَا تَمُدَّنَّ عَيۡنَيۡكَ إِلَىٰ مَا مَتَّعۡنَا بِهِۦٓ أَزۡوَٰجٗا مِّنۡهُمۡ وَلَا تَحۡزَنۡ عَلَيۡهِمۡ وَٱخۡفِضۡ جَنَاحَكَ لِلۡمُؤۡمِنِينَ",
    translation:
      "Do not extend your eyes toward that by which We have given enjoyment to [certain] categories of the disbelievers, and do not grieve over them. And lower your wing to the believers",
    normalizedText:
      "لا تمدن عينيك الى ما متعنا به ازوجا منهم ولا تحزن عليهم واخفض جناحك للمامنين",
  },
  {
    verseId: 88,
    name: "الحجر",
    surahId: 15,
    text: "وَقُلۡ إِنِّيٓ أَنَا ٱلنَّذِيرُ ٱلۡمُبِينُ",
    translation: 'And say, "Indeed, I am the clear warner',
    normalizedText: "وقل اني انا النذير المبين",
  },
  {
    verseId: 89,
    name: "الحجر",
    surahId: 15,
    text: "كَمَآ أَنزَلۡنَا عَلَى ٱلۡمُقۡتَسِمِينَ",
    translation: "Just as We had revealed [scriptures] to the separators",
    normalizedText: "كما انزلنا على المقتسمين",
  },
  {
    verseId: 90,
    name: "الحجر",
    surahId: 15,
    text: "ٱلَّذِينَ جَعَلُواْ ٱلۡقُرۡءَانَ عِضِينَ",
    translation: "Who have made the Qur'an into portions",
    normalizedText: "الذين جعلوا القرءان عضين",
  },
  {
    verseId: 91,
    name: "الحجر",
    surahId: 15,
    text: "فَوَرَبِّكَ لَنَسۡـَٔلَنَّهُمۡ أَجۡمَعِينَ",
    translation: "So by your Lord, We will surely question them all",
    normalizedText: "فوربك لنسلنهم اجمعين",
  },
  {
    verseId: 92,
    name: "الحجر",
    surahId: 15,
    text: "عَمَّا كَانُواْ يَعۡمَلُونَ",
    translation: "About what they used to do",
    normalizedText: "عما كانوا يعملون",
  },
  {
    verseId: 93,
    name: "الحجر",
    surahId: 15,
    text: "فَٱصۡدَعۡ بِمَا تُؤۡمَرُ وَأَعۡرِضۡ عَنِ ٱلۡمُشۡرِكِينَ",
    translation:
      "Then declare what you are commanded and turn away from the polytheists",
    normalizedText: "فاصدع بما تامر واعرض عن المشركين",
  },
  {
    verseId: 94,
    name: "الحجر",
    surahId: 15,
    text: "إِنَّا كَفَيۡنَٰكَ ٱلۡمُسۡتَهۡزِءِينَ",
    translation: "Indeed, We are sufficient for you against the mockers",
    normalizedText: "انا كفينك المستهزءين",
  },
  {
    verseId: 95,
    name: "الحجر",
    surahId: 15,
    text: "ٱلَّذِينَ يَجۡعَلُونَ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَۚ فَسَوۡفَ يَعۡلَمُونَ",
    translation:
      "Who make [equal] with Allah another deity. But they are going to know",
    normalizedText: "الذين يجعلون مع الله الها ءاخر فسوف يعلمون",
  },
  {
    verseId: 96,
    name: "الحجر",
    surahId: 15,
    text: "وَلَقَدۡ نَعۡلَمُ أَنَّكَ يَضِيقُ صَدۡرُكَ بِمَا يَقُولُونَ",
    translation:
      "And We already know that your breast is constrained by what they say",
    normalizedText: "ولقد نعلم انك يضيق صدرك بما يقولون",
  },
  {
    verseId: 97,
    name: "الحجر",
    surahId: 15,
    text: "فَسَبِّحۡ بِحَمۡدِ رَبِّكَ وَكُن مِّنَ ٱلسَّـٰجِدِينَ",
    translation:
      "So exalt [Allah] with praise of your Lord and be of those who prostrate [to Him]",
    normalizedText: "فسبح بحمد ربك وكن من السجدين",
  },
  {
    verseId: 98,
    name: "الحجر",
    surahId: 15,
    text: "وَٱعۡبُدۡ رَبَّكَ حَتَّىٰ يَأۡتِيَكَ ٱلۡيَقِينُ",
    translation:
      "And worship your Lord until there comes to you the certainty (death)",
    normalizedText: "واعبد ربك حتى ياتيك اليقين",
  },
  {
    verseId: 0,
    name: "النحل",
    surahId: 16,
    text: "أَتَىٰٓ أَمۡرُ ٱللَّهِ فَلَا تَسۡتَعۡجِلُوهُۚ سُبۡحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      "The command of Allah is coming, so be not impatient for it. Exalted is He and high above what they associate with Him",
    normalizedText: "اتى امر الله فلا تستعجلوه سبحنه وتعلى عما يشركون",
  },
  {
    verseId: 1,
    name: "النحل",
    surahId: 16,
    text: "يُنَزِّلُ ٱلۡمَلَـٰٓئِكَةَ بِٱلرُّوحِ مِنۡ أَمۡرِهِۦ عَلَىٰ مَن يَشَآءُ مِنۡ عِبَادِهِۦٓ أَنۡ أَنذِرُوٓاْ أَنَّهُۥ لَآ إِلَٰهَ إِلَّآ أَنَا۠ فَٱتَّقُونِ",
    translation:
      'He sends down the angels, with the inspiration of His command, upon whom He wills of His servants, [telling them], "Warn that there is no deity except Me; so fear Me',
    normalizedText:
      "ينزل الملاكة بالروح من امره على من يشاء من عباده ان انذروا انه لا اله الا انا فاتقون",
  },
  {
    verseId: 2,
    name: "النحل",
    surahId: 16,
    text: "خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِٱلۡحَقِّۚ تَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      "He created the heavens and earth in truth. High is He above what they associate with Him",
    normalizedText: "خلق السموت والارض بالحق تعلى عما يشركون",
  },
  {
    verseId: 3,
    name: "النحل",
    surahId: 16,
    text: "خَلَقَ ٱلۡإِنسَٰنَ مِن نُّطۡفَةٖ فَإِذَا هُوَ خَصِيمٞ مُّبِينٞ",
    translation:
      "He created man from a sperm-drop; then at once, he is a clear adversary",
    normalizedText: "خلق الانسن من نطفة فاذا هو خصيم مبين",
  },
  {
    verseId: 4,
    name: "النحل",
    surahId: 16,
    text: "وَٱلۡأَنۡعَٰمَ خَلَقَهَاۖ لَكُمۡ فِيهَا دِفۡءٞ وَمَنَٰفِعُ وَمِنۡهَا تَأۡكُلُونَ",
    translation:
      "And the grazing livestock He has created for you; in them is warmth and [numerous] benefits, and from them you eat",
    normalizedText: "والانعم خلقها لكم فيها دفء ومنفع ومنها تاكلون",
  },
  {
    verseId: 5,
    name: "النحل",
    surahId: 16,
    text: "وَلَكُمۡ فِيهَا جَمَالٌ حِينَ تُرِيحُونَ وَحِينَ تَسۡرَحُونَ",
    translation:
      "And for you in them is [the enjoyment of] beauty when you bring them in [for the evening] and when you send them out [to pasture]",
    normalizedText: "ولكم فيها جمال حين تريحون وحين تسرحون",
  },
  {
    verseId: 6,
    name: "النحل",
    surahId: 16,
    text: "وَتَحۡمِلُ أَثۡقَالَكُمۡ إِلَىٰ بَلَدٖ لَّمۡ تَكُونُواْ بَٰلِغِيهِ إِلَّا بِشِقِّ ٱلۡأَنفُسِۚ إِنَّ رَبَّكُمۡ لَرَءُوفٞ رَّحِيمٞ",
    translation:
      "And they carry your loads to a land you could not have reached except with difficulty to yourselves. Indeed, your Lord is Kind and Merciful",
    normalizedText:
      "وتحمل اثقالكم الى بلد لم تكونوا بلغيه الا بشق الانفس ان ربكم لرءوف رحيم",
  },
  {
    verseId: 7,
    name: "النحل",
    surahId: 16,
    text: "وَٱلۡخَيۡلَ وَٱلۡبِغَالَ وَٱلۡحَمِيرَ لِتَرۡكَبُوهَا وَزِينَةٗۚ وَيَخۡلُقُ مَا لَا تَعۡلَمُونَ",
    translation:
      "And [He created] the horses, mules and donkeys for you to ride and [as] adornment. And He creates that which you do not know",
    normalizedText: "والخيل والبغال والحمير لتركبوها وزينة ويخلق ما لا تعلمون",
  },
  {
    verseId: 8,
    name: "النحل",
    surahId: 16,
    text: "وَعَلَى ٱللَّهِ قَصۡدُ ٱلسَّبِيلِ وَمِنۡهَا جَآئِرٞۚ وَلَوۡ شَآءَ لَهَدَىٰكُمۡ أَجۡمَعِينَ",
    translation:
      "And upon Allah is the direction of the [right] way, and among the various paths are those deviating. And if He willed, He could have guided you all",
    normalizedText: "وعلى الله قصد السبيل ومنها جاار ولو شاء لهدىكم اجمعين",
  },
  {
    verseId: 9,
    name: "النحل",
    surahId: 16,
    text: "هُوَ ٱلَّذِيٓ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗۖ لَّكُم مِّنۡهُ شَرَابٞ وَمِنۡهُ شَجَرٞ فِيهِ تُسِيمُونَ",
    translation:
      "It is He who sends down rain from the sky; from it is drink and from it is foliage in which you pasture [animals]",
    normalizedText:
      "هو الذي انزل من السماء ماء لكم منه شراب ومنه شجر فيه تسيمون",
  },
  {
    verseId: 10,
    name: "النحل",
    surahId: 16,
    text: "يُنۢبِتُ لَكُم بِهِ ٱلزَّرۡعَ وَٱلزَّيۡتُونَ وَٱلنَّخِيلَ وَٱلۡأَعۡنَٰبَ وَمِن كُلِّ ٱلثَّمَرَٰتِۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّقَوۡمٖ يَتَفَكَّرُونَ",
    translation:
      "He causes to grow for you thereby the crops, olives, palm trees, grapevines, and from all the fruits. Indeed in that is a sign for a people who give thought",
    normalizedText:
      "ينبت لكم به الزرع والزيتون والنخيل والاعنب ومن كل الثمرت ان في ذلك لاية لقوم يتفكرون",
  },
  {
    verseId: 11,
    name: "النحل",
    surahId: 16,
    text: "وَسَخَّرَ لَكُمُ ٱلَّيۡلَ وَٱلنَّهَارَ وَٱلشَّمۡسَ وَٱلۡقَمَرَۖ وَٱلنُّجُومُ مُسَخَّرَٰتُۢ بِأَمۡرِهِۦٓۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "And He has subjected for you the night and day and the sun and moon, and the stars are subjected by His command. Indeed in that are signs for a people who reason",
    normalizedText:
      "وسخر لكم اليل والنهار والشمس والقمر والنجوم مسخرت بامره ان في ذلك لايت لقوم يعقلون",
  },
  {
    verseId: 12,
    name: "النحل",
    surahId: 16,
    text: "وَمَا ذَرَأَ لَكُمۡ فِي ٱلۡأَرۡضِ مُخۡتَلِفًا أَلۡوَٰنُهُۥٓۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّقَوۡمٖ يَذَّكَّرُونَ",
    translation:
      "And [He has subjected] whatever He multiplied for you on the earth of varying colors. Indeed in that is a sign for a people who remember",
    normalizedText:
      "وما ذرا لكم في الارض مختلفا الونه ان في ذلك لاية لقوم يذكرون",
  },
  {
    verseId: 13,
    name: "النحل",
    surahId: 16,
    text: "وَهُوَ ٱلَّذِي سَخَّرَ ٱلۡبَحۡرَ لِتَأۡكُلُواْ مِنۡهُ لَحۡمٗا طَرِيّٗا وَتَسۡتَخۡرِجُواْ مِنۡهُ حِلۡيَةٗ تَلۡبَسُونَهَاۖ وَتَرَى ٱلۡفُلۡكَ مَوَاخِرَ فِيهِ وَلِتَبۡتَغُواْ مِن فَضۡلِهِۦ وَلَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And it is He who subjected the sea for you to eat from it tender meat and to extract from it ornaments which you wear. And you see the ships plowing through it, and [He subjected it] that you may seek of His bounty; and perhaps you will be grateful",
    normalizedText:
      "وهو الذي سخر البحر لتاكلوا منه لحما طريا وتستخرجوا منه حلية تلبسونها وترى الفلك مواخر فيه ولتبتغوا من فضله ولعلكم تشكرون",
  },
  {
    verseId: 14,
    name: "النحل",
    surahId: 16,
    text: "وَأَلۡقَىٰ فِي ٱلۡأَرۡضِ رَوَٰسِيَ أَن تَمِيدَ بِكُمۡ وَأَنۡهَٰرٗا وَسُبُلٗا لَّعَلَّكُمۡ تَهۡتَدُونَ",
    translation:
      "And He has cast into the earth firmly set mountains, lest it shift with you, and [made] rivers and roads, that you may be guided",
    normalizedText: "والقى في الارض روسي ان تميد بكم وانهرا وسبلا لعلكم تهتدون",
  },
  {
    verseId: 15,
    name: "النحل",
    surahId: 16,
    text: "وَعَلَٰمَٰتٖۚ وَبِٱلنَّجۡمِ هُمۡ يَهۡتَدُونَ",
    translation: "And landmarks. And by the stars they are [also] guided",
    normalizedText: "وعلمت وبالنجم هم يهتدون",
  },
  {
    verseId: 16,
    name: "النحل",
    surahId: 16,
    text: "أَفَمَن يَخۡلُقُ كَمَن لَّا يَخۡلُقُۚ أَفَلَا تَذَكَّرُونَ",
    translation:
      "Then is He who creates like one who does not create? So will you not be reminded",
    normalizedText: "افمن يخلق كمن لا يخلق افلا تذكرون",
  },
  {
    verseId: 17,
    name: "النحل",
    surahId: 16,
    text: "وَإِن تَعُدُّواْ نِعۡمَةَ ٱللَّهِ لَا تُحۡصُوهَآۗ إِنَّ ٱللَّهَ لَغَفُورٞ رَّحِيمٞ",
    translation:
      "And if you should count the favors of Allah, you could not enumerate them. Indeed, Allah is Forgiving and Merciful",
    normalizedText: "وان تعدوا نعمة الله لا تحصوها ان الله لغفور رحيم",
  },
  {
    verseId: 18,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ يَعۡلَمُ مَا تُسِرُّونَ وَمَا تُعۡلِنُونَ",
    translation: "And Allah knows what you conceal and what you declare",
    normalizedText: "والله يعلم ما تسرون وما تعلنون",
  },
  {
    verseId: 19,
    name: "النحل",
    surahId: 16,
    text: "وَٱلَّذِينَ يَدۡعُونَ مِن دُونِ ٱللَّهِ لَا يَخۡلُقُونَ شَيۡـٔٗا وَهُمۡ يُخۡلَقُونَ",
    translation:
      "And those they invoke other than Allah create nothing, and they [themselves] are created",
    normalizedText: "والذين يدعون من دون الله لا يخلقون شيا وهم يخلقون",
  },
  {
    verseId: 20,
    name: "النحل",
    surahId: 16,
    text: "أَمۡوَٰتٌ غَيۡرُ أَحۡيَآءٖۖ وَمَا يَشۡعُرُونَ أَيَّانَ يُبۡعَثُونَ",
    translation:
      "They are, [in fact], dead, not alive, and they do not perceive when they will be resurrected",
    normalizedText: "اموت غير احياء وما يشعرون ايان يبعثون",
  },
  {
    verseId: 21,
    name: "النحل",
    surahId: 16,
    text: "إِلَٰهُكُمۡ إِلَٰهٞ وَٰحِدٞۚ فَٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ قُلُوبُهُم مُّنكِرَةٞ وَهُم مُّسۡتَكۡبِرُونَ",
    translation:
      "Your god is one God. But those who do not believe in the Hereafter - their hearts are disapproving, and they are arrogant",
    normalizedText:
      "الهكم اله وحد فالذين لا يامنون بالاخرة قلوبهم منكرة وهم مستكبرون",
  },
  {
    verseId: 22,
    name: "النحل",
    surahId: 16,
    text: "لَا جَرَمَ أَنَّ ٱللَّهَ يَعۡلَمُ مَا يُسِرُّونَ وَمَا يُعۡلِنُونَۚ إِنَّهُۥ لَا يُحِبُّ ٱلۡمُسۡتَكۡبِرِينَ",
    translation:
      "Assuredly, Allah knows what they conceal and what they declare. Indeed, He does not like the arrogant",
    normalizedText:
      "لا جرم ان الله يعلم ما يسرون وما يعلنون انه لا يحب المستكبرين",
  },
  {
    verseId: 23,
    name: "النحل",
    surahId: 16,
    text: "وَإِذَا قِيلَ لَهُم مَّاذَآ أَنزَلَ رَبُّكُمۡ قَالُوٓاْ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      'And when it is said to them, "What has your Lord sent down?" They say, "Legends of the former peoples',
    normalizedText: "واذا قيل لهم ماذا انزل ربكم قالوا اسطير الاولين",
  },
  {
    verseId: 24,
    name: "النحل",
    surahId: 16,
    text: "لِيَحۡمِلُوٓاْ أَوۡزَارَهُمۡ كَامِلَةٗ يَوۡمَ ٱلۡقِيَٰمَةِ وَمِنۡ أَوۡزَارِ ٱلَّذِينَ يُضِلُّونَهُم بِغَيۡرِ عِلۡمٍۗ أَلَا سَآءَ مَا يَزِرُونَ",
    translation:
      "That they may bear their own burdens in full on the Day of Resurrection and some of the burdens of those whom they misguide without knowledge. Unquestionably, evil is that which they bear",
    normalizedText:
      "ليحملوا اوزارهم كاملة يوم القيمة ومن اوزار الذين يضلونهم بغير علم الا ساء ما يزرون",
  },
  {
    verseId: 25,
    name: "النحل",
    surahId: 16,
    text: "قَدۡ مَكَرَ ٱلَّذِينَ مِن قَبۡلِهِمۡ فَأَتَى ٱللَّهُ بُنۡيَٰنَهُم مِّنَ ٱلۡقَوَاعِدِ فَخَرَّ عَلَيۡهِمُ ٱلسَّقۡفُ مِن فَوۡقِهِمۡ وَأَتَىٰهُمُ ٱلۡعَذَابُ مِنۡ حَيۡثُ لَا يَشۡعُرُونَ",
    translation:
      "Those before them had already plotted, but Allah came at their building from the foundations, so the roof fell upon them from above them, and the punishment came to them from where they did not perceive",
    normalizedText:
      "قد مكر الذين من قبلهم فاتى الله بنينهم من القواعد فخر عليهم السقف من فوقهم واتىهم العذاب من حيث لا يشعرون",
  },
  {
    verseId: 26,
    name: "النحل",
    surahId: 16,
    text: "ثُمَّ يَوۡمَ ٱلۡقِيَٰمَةِ يُخۡزِيهِمۡ وَيَقُولُ أَيۡنَ شُرَكَآءِيَ ٱلَّذِينَ كُنتُمۡ تُشَـٰٓقُّونَ فِيهِمۡۚ قَالَ ٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ إِنَّ ٱلۡخِزۡيَ ٱلۡيَوۡمَ وَٱلسُّوٓءَ عَلَى ٱلۡكَٰفِرِينَ",
    translation: `Then on the Day of Resurrection He will disgrace them and say, "Where are My 'partners' for whom you used to oppose [the believers]?" Those who were given knowledge will say, "Indeed disgrace, this Day, and evil are upon the disbelievers`,
    normalizedText:
      "ثم يوم القيمة يخزيهم ويقول اين شركاءي الذين كنتم تشقون فيهم قال الذين اوتوا العلم ان الخزي اليوم والسوء على الكفرين",
  },
  {
    verseId: 27,
    name: "النحل",
    surahId: 16,
    text: "ٱلَّذِينَ تَتَوَفَّىٰهُمُ ٱلۡمَلَـٰٓئِكَةُ ظَالِمِيٓ أَنفُسِهِمۡۖ فَأَلۡقَوُاْ ٱلسَّلَمَ مَا كُنَّا نَعۡمَلُ مِن سُوٓءِۭۚ بَلَىٰٓۚ إِنَّ ٱللَّهَ عَلِيمُۢ بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'The ones whom the angels take in death [while] wronging themselves, and [who] then offer submission, [saying], "We were not doing any evil." But, yes! Indeed, Allah is Knowing of what you used to do',
    normalizedText:
      "الذين تتوفىهم الملاكة ظالمي انفسهم فالقوا السلم ما كنا نعمل من سوء بلى ان الله عليم بما كنتم تعملون",
  },
  {
    verseId: 28,
    name: "النحل",
    surahId: 16,
    text: "فَٱدۡخُلُوٓاْ أَبۡوَٰبَ جَهَنَّمَ خَٰلِدِينَ فِيهَاۖ فَلَبِئۡسَ مَثۡوَى ٱلۡمُتَكَبِّرِينَ",
    translation:
      "So enter the gates of Hell to abide eternally therein, and how wretched is the residence of the arrogant",
    normalizedText: "فادخلوا ابوب جهنم خلدين فيها فلباس مثوى المتكبرين",
  },
  {
    verseId: 29,
    name: "النحل",
    surahId: 16,
    text: "۞وَقِيلَ لِلَّذِينَ ٱتَّقَوۡاْ مَاذَآ أَنزَلَ رَبُّكُمۡۚ قَالُواْ خَيۡرٗاۗ لِّلَّذِينَ أَحۡسَنُواْ فِي هَٰذِهِ ٱلدُّنۡيَا حَسَنَةٞۚ وَلَدَارُ ٱلۡأٓخِرَةِ خَيۡرٞۚ وَلَنِعۡمَ دَارُ ٱلۡمُتَّقِينَ",
    translation:
      'And it will be said to those who feared Allah, "What did your Lord send down?" They will say, "[That which is] good." For those who do good in this world is good; and the home of the Hereafter is better. And how excellent is the home of the righteous',
    normalizedText:
      "۞وقيل للذين اتقوا ماذا انزل ربكم قالوا خيرا للذين احسنوا في هذه الدنيا حسنة ولدار الاخرة خير ولنعم دار المتقين",
  },
  {
    verseId: 30,
    name: "النحل",
    surahId: 16,
    text: "جَنَّـٰتُ عَدۡنٖ يَدۡخُلُونَهَا تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۖ لَهُمۡ فِيهَا مَا يَشَآءُونَۚ كَذَٰلِكَ يَجۡزِي ٱللَّهُ ٱلۡمُتَّقِينَ",
    translation:
      "Gardens of perpetual residence, which they will enter, beneath which rivers flow. They will have therein whatever they wish. Thus does Allah reward the righteous",
    normalizedText:
      "جنت عدن يدخلونها تجري من تحتها الانهر لهم فيها ما يشاءون كذلك يجزي الله المتقين",
  },
  {
    verseId: 31,
    name: "النحل",
    surahId: 16,
    text: "ٱلَّذِينَ تَتَوَفَّىٰهُمُ ٱلۡمَلَـٰٓئِكَةُ طَيِّبِينَ يَقُولُونَ سَلَٰمٌ عَلَيۡكُمُ ٱدۡخُلُواْ ٱلۡجَنَّةَ بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'The ones whom the angels take in death, [being] good and pure; [the angels] will say, "Peace be upon you. Enter Paradise for what you used to do',
    normalizedText:
      "الذين تتوفىهم الملاكة طيبين يقولون سلم عليكم ادخلوا الجنة بما كنتم تعملون",
  },
  {
    verseId: 32,
    name: "النحل",
    surahId: 16,
    text: "هَلۡ يَنظُرُونَ إِلَّآ أَن تَأۡتِيَهُمُ ٱلۡمَلَـٰٓئِكَةُ أَوۡ يَأۡتِيَ أَمۡرُ رَبِّكَۚ كَذَٰلِكَ فَعَلَ ٱلَّذِينَ مِن قَبۡلِهِمۡۚ وَمَا ظَلَمَهُمُ ٱللَّهُ وَلَٰكِن كَانُوٓاْ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      "Do the disbelievers await [anything] except that the angels should come to them or there comes the command of your Lord? Thus did those do before them. And Allah wronged them not, but they had been wronging themselves",
    normalizedText:
      "هل ينظرون الا ان تاتيهم الملاكة او ياتي امر ربك كذلك فعل الذين من قبلهم وما ظلمهم الله ولكن كانوا انفسهم يظلمون",
  },
  {
    verseId: 33,
    name: "النحل",
    surahId: 16,
    text: "فَأَصَابَهُمۡ سَيِّـَٔاتُ مَا عَمِلُواْ وَحَاقَ بِهِم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "So they were struck by the evil consequences of what they did and were enveloped by what they used to ridicule",
    normalizedText: "فاصابهم سيات ما عملوا وحاق بهم ما كانوا به يستهزءون",
  },
  {
    verseId: 34,
    name: "النحل",
    surahId: 16,
    text: "وَقَالَ ٱلَّذِينَ أَشۡرَكُواْ لَوۡ شَآءَ ٱللَّهُ مَا عَبَدۡنَا مِن دُونِهِۦ مِن شَيۡءٖ نَّحۡنُ وَلَآ ءَابَآؤُنَا وَلَا حَرَّمۡنَا مِن دُونِهِۦ مِن شَيۡءٖۚ كَذَٰلِكَ فَعَلَ ٱلَّذِينَ مِن قَبۡلِهِمۡۚ فَهَلۡ عَلَى ٱلرُّسُلِ إِلَّا ٱلۡبَلَٰغُ ٱلۡمُبِينُ",
    translation:
      'And those who associate others with Allah say, "If Allah had willed, we would not have worshipped anything other than Him, neither we nor our fathers, nor would we have forbidden anything through other than Him." Thus did those do before them. So is there upon the messengers except [the duty of] clear notification',
    normalizedText:
      "وقال الذين اشركوا لو شاء الله ما عبدنا من دونه من شيء نحن ولا ءاباانا ولا حرمنا من دونه من شيء كذلك فعل الذين من قبلهم فهل على الرسل الا البلغ المبين",
  },
  {
    verseId: 35,
    name: "النحل",
    surahId: 16,
    text: "وَلَقَدۡ بَعَثۡنَا فِي كُلِّ أُمَّةٖ رَّسُولًا أَنِ ٱعۡبُدُواْ ٱللَّهَ وَٱجۡتَنِبُواْ ٱلطَّـٰغُوتَۖ فَمِنۡهُم مَّنۡ هَدَى ٱللَّهُ وَمِنۡهُم مَّنۡ حَقَّتۡ عَلَيۡهِ ٱلضَّلَٰلَةُۚ فَسِيرُواْ فِي ٱلۡأَرۡضِ فَٱنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُكَذِّبِينَ",
    translation:
      'And We certainly sent into every nation a messenger, [saying], "Worship Allah and avoid Taghut." And among them were those whom Allah guided, and among them were those upon whom error was [deservedly] decreed. So proceed through the earth and observe how was the end of the deniers',
    normalizedText:
      "ولقد بعثنا في كل امة رسولا ان اعبدوا الله واجتنبوا الطغوت فمنهم من هدى الله ومنهم من حقت عليه الضللة فسيروا في الارض فانظروا كيف كان عقبة المكذبين",
  },
  {
    verseId: 36,
    name: "النحل",
    surahId: 16,
    text: "إِن تَحۡرِصۡ عَلَىٰ هُدَىٰهُمۡ فَإِنَّ ٱللَّهَ لَا يَهۡدِي مَن يُضِلُّۖ وَمَا لَهُم مِّن نَّـٰصِرِينَ",
    translation:
      "[Even] if you should strive for their guidance, [O Muhammad], indeed, Allah does not guide those He sends astray, and they will have no helpers",
    normalizedText:
      "ان تحرص على هدىهم فان الله لا يهدي من يضل وما لهم من نصرين",
  },
  {
    verseId: 37,
    name: "النحل",
    surahId: 16,
    text: "وَأَقۡسَمُواْ بِٱللَّهِ جَهۡدَ أَيۡمَٰنِهِمۡ لَا يَبۡعَثُ ٱللَّهُ مَن يَمُوتُۚ بَلَىٰ وَعۡدًا عَلَيۡهِ حَقّٗا وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      "And they swear by Allah their strongest oaths [that] Allah will not resurrect one who dies. But yes - [it is] a true promise [binding] upon Him, but most of the people do not know",
    normalizedText:
      "واقسموا بالله جهد ايمنهم لا يبعث الله من يموت بلى وعدا عليه حقا ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 38,
    name: "النحل",
    surahId: 16,
    text: "لِيُبَيِّنَ لَهُمُ ٱلَّذِي يَخۡتَلِفُونَ فِيهِ وَلِيَعۡلَمَ ٱلَّذِينَ كَفَرُوٓاْ أَنَّهُمۡ كَانُواْ كَٰذِبِينَ",
    translation:
      "[It is] so He will make clear to them [the truth of] that wherein they differ and so those who have disbelieved may know that they were liars",
    normalizedText:
      "ليبين لهم الذي يختلفون فيه وليعلم الذين كفروا انهم كانوا كذبين",
  },
  {
    verseId: 39,
    name: "النحل",
    surahId: 16,
    text: "إِنَّمَا قَوۡلُنَا لِشَيۡءٍ إِذَآ أَرَدۡنَٰهُ أَن نَّقُولَ لَهُۥ كُن فَيَكُونُ",
    translation:
      'Indeed, Our word to a thing when We intend it is but that We say to it, "Be," and it is',
    normalizedText: "انما قولنا لشيء اذا اردنه ان نقول له كن فيكون",
  },
  {
    verseId: 40,
    name: "النحل",
    surahId: 16,
    text: "وَٱلَّذِينَ هَاجَرُواْ فِي ٱللَّهِ مِنۢ بَعۡدِ مَا ظُلِمُواْ لَنُبَوِّئَنَّهُمۡ فِي ٱلدُّنۡيَا حَسَنَةٗۖ وَلَأَجۡرُ ٱلۡأٓخِرَةِ أَكۡبَرُۚ لَوۡ كَانُواْ يَعۡلَمُونَ",
    translation:
      "And those who emigrated for [the cause of] Allah after they had been wronged - We will surely settle them in this world in a good place; but the reward of the Hereafter is greater, if only they could know",
    normalizedText:
      "والذين هاجروا في الله من بعد ما ظلموا لنبوانهم في الدنيا حسنة ولاجر الاخرة اكبر لو كانوا يعلمون",
  },
  {
    verseId: 41,
    name: "النحل",
    surahId: 16,
    text: "ٱلَّذِينَ صَبَرُواْ وَعَلَىٰ رَبِّهِمۡ يَتَوَكَّلُونَ",
    translation:
      "[They are] those who endured patiently and upon their Lord relied",
    normalizedText: "الذين صبروا وعلى ربهم يتوكلون",
  },
  {
    verseId: 42,
    name: "النحل",
    surahId: 16,
    text: "وَمَآ أَرۡسَلۡنَا مِن قَبۡلِكَ إِلَّا رِجَالٗا نُّوحِيٓ إِلَيۡهِمۡۖ فَسۡـَٔلُوٓاْ أَهۡلَ ٱلذِّكۡرِ إِن كُنتُمۡ لَا تَعۡلَمُونَ",
    translation:
      "And We sent not before you except men to whom We revealed [Our message]. So ask the people of the message if you do not know",
    normalizedText:
      "وما ارسلنا من قبلك الا رجالا نوحي اليهم فسلوا اهل الذكر ان كنتم لا تعلمون",
  },
  {
    verseId: 43,
    name: "النحل",
    surahId: 16,
    text: "بِٱلۡبَيِّنَٰتِ وَٱلزُّبُرِۗ وَأَنزَلۡنَآ إِلَيۡكَ ٱلذِّكۡرَ لِتُبَيِّنَ لِلنَّاسِ مَا نُزِّلَ إِلَيۡهِمۡ وَلَعَلَّهُمۡ يَتَفَكَّرُونَ",
    translation:
      "[We sent them] with clear proofs and written ordinances. And We revealed to you the message that you may make clear to the people what was sent down to them and that they might give thought",
    normalizedText:
      "بالبينت والزبر وانزلنا اليك الذكر لتبين للناس ما نزل اليهم ولعلهم يتفكرون",
  },
  {
    verseId: 44,
    name: "النحل",
    surahId: 16,
    text: "أَفَأَمِنَ ٱلَّذِينَ مَكَرُواْ ٱلسَّيِّـَٔاتِ أَن يَخۡسِفَ ٱللَّهُ بِهِمُ ٱلۡأَرۡضَ أَوۡ يَأۡتِيَهُمُ ٱلۡعَذَابُ مِنۡ حَيۡثُ لَا يَشۡعُرُونَ",
    translation:
      "Then, do those who have planned evil deeds feel secure that Allah will not cause the earth to swallow them or that the punishment will not come upon them from where they do not perceive",
    normalizedText:
      "افامن الذين مكروا السيات ان يخسف الله بهم الارض او ياتيهم العذاب من حيث لا يشعرون",
  },
  {
    verseId: 45,
    name: "النحل",
    surahId: 16,
    text: "أَوۡ يَأۡخُذَهُمۡ فِي تَقَلُّبِهِمۡ فَمَا هُم بِمُعۡجِزِينَ",
    translation:
      "Or that He would not seize them during their [usual] activity, and they could not cause failure",
    normalizedText: "او ياخذهم في تقلبهم فما هم بمعجزين",
  },
  {
    verseId: 46,
    name: "النحل",
    surahId: 16,
    text: "أَوۡ يَأۡخُذَهُمۡ عَلَىٰ تَخَوُّفٖ فَإِنَّ رَبَّكُمۡ لَرَءُوفٞ رَّحِيمٌ",
    translation:
      "Or that He would not seize them gradually [in a state of dread]? But indeed, your Lord is Kind and Merciful",
    normalizedText: "او ياخذهم على تخوف فان ربكم لرءوف رحيم",
  },
  {
    verseId: 47,
    name: "النحل",
    surahId: 16,
    text: "أَوَلَمۡ يَرَوۡاْ إِلَىٰ مَا خَلَقَ ٱللَّهُ مِن شَيۡءٖ يَتَفَيَّؤُاْ ظِلَٰلُهُۥ عَنِ ٱلۡيَمِينِ وَٱلشَّمَآئِلِ سُجَّدٗا لِّلَّهِ وَهُمۡ دَٰخِرُونَ",
    translation:
      "Have they not considered what things Allah has created? Their shadows incline to the right and to the left, prostrating to Allah, while they are humble",
    normalizedText:
      "اولم يروا الى ما خلق الله من شيء يتفياا ظلله عن اليمين والشماال سجدا لله وهم دخرون",
  },
  {
    verseId: 48,
    name: "النحل",
    surahId: 16,
    text: "وَلِلَّهِۤ يَسۡجُدُۤ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ مِن دَآبَّةٖ وَٱلۡمَلَـٰٓئِكَةُ وَهُمۡ لَا يَسۡتَكۡبِرُونَ",
    translation:
      "And to Allah prostrates whatever is in the heavens and whatever is on the earth of creatures, and the angels [as well], and they are not arrogant",
    normalizedText:
      "ولله يسجد ما في السموت وما في الارض من دابة والملاكة وهم لا يستكبرون",
  },
  {
    verseId: 49,
    name: "النحل",
    surahId: 16,
    text: "يَخَافُونَ رَبَّهُم مِّن فَوۡقِهِمۡ وَيَفۡعَلُونَ مَا يُؤۡمَرُونَ۩",
    translation:
      "They fear their Lord above them, and they do what they are commanded",
    normalizedText: "يخافون ربهم من فوقهم ويفعلون ما يامرون۩",
  },
  {
    verseId: 50,
    name: "النحل",
    surahId: 16,
    text: "۞وَقَالَ ٱللَّهُ لَا تَتَّخِذُوٓاْ إِلَٰهَيۡنِ ٱثۡنَيۡنِۖ إِنَّمَا هُوَ إِلَٰهٞ وَٰحِدٞ فَإِيَّـٰيَ فَٱرۡهَبُونِ",
    translation:
      'And Allah has said, "Do not take for yourselves two deities. He is but one God, so fear only Me',
    normalizedText:
      "۞وقال الله لا تتخذوا الهين اثنين انما هو اله وحد فايي فارهبون",
  },
  {
    verseId: 51,
    name: "النحل",
    surahId: 16,
    text: "وَلَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَلَهُ ٱلدِّينُ وَاصِبًاۚ أَفَغَيۡرَ ٱللَّهِ تَتَّقُونَ",
    translation:
      "And to Him belongs whatever is in the heavens and the earth, and to Him is [due] worship constantly. Then is it other than Allah that you fear",
    normalizedText: "وله ما في السموت والارض وله الدين واصبا افغير الله تتقون",
  },
  {
    verseId: 52,
    name: "النحل",
    surahId: 16,
    text: "وَمَا بِكُم مِّن نِّعۡمَةٖ فَمِنَ ٱللَّهِۖ ثُمَّ إِذَا مَسَّكُمُ ٱلضُّرُّ فَإِلَيۡهِ تَجۡـَٔرُونَ",
    translation:
      "And whatever you have of favor - it is from Allah. Then when adversity touches you, to Him you cry for help",
    normalizedText: "وما بكم من نعمة فمن الله ثم اذا مسكم الضر فاليه تجرون",
  },
  {
    verseId: 53,
    name: "النحل",
    surahId: 16,
    text: "ثُمَّ إِذَا كَشَفَ ٱلضُّرَّ عَنكُمۡ إِذَا فَرِيقٞ مِّنكُم بِرَبِّهِمۡ يُشۡرِكُونَ",
    translation:
      "Then when He removes the adversity from you, at once a party of you associates others with their Lord",
    normalizedText: "ثم اذا كشف الضر عنكم اذا فريق منكم بربهم يشركون",
  },
  {
    verseId: 54,
    name: "النحل",
    surahId: 16,
    text: "لِيَكۡفُرُواْ بِمَآ ءَاتَيۡنَٰهُمۡۚ فَتَمَتَّعُواْ فَسَوۡفَ تَعۡلَمُونَ",
    translation:
      "So they will deny what We have given them. Then enjoy yourselves, for you are going to know",
    normalizedText: "ليكفروا بما ءاتينهم فتمتعوا فسوف تعلمون",
  },
  {
    verseId: 55,
    name: "النحل",
    surahId: 16,
    text: "وَيَجۡعَلُونَ لِمَا لَا يَعۡلَمُونَ نَصِيبٗا مِّمَّا رَزَقۡنَٰهُمۡۗ تَٱللَّهِ لَتُسۡـَٔلُنَّ عَمَّا كُنتُمۡ تَفۡتَرُونَ",
    translation:
      "And they assign to what they do not know a portion of that which We have provided them. By Allah, you will surely be questioned about what you used to invent",
    normalizedText:
      "ويجعلون لما لا يعلمون نصيبا مما رزقنهم تالله لتسلن عما كنتم تفترون",
  },
  {
    verseId: 56,
    name: "النحل",
    surahId: 16,
    text: "وَيَجۡعَلُونَ لِلَّهِ ٱلۡبَنَٰتِ سُبۡحَٰنَهُۥ وَلَهُم مَّا يَشۡتَهُونَ",
    translation:
      "And they attribute to Allah daughters - exalted is He - and for them is what they desire",
    normalizedText: "ويجعلون لله البنت سبحنه ولهم ما يشتهون",
  },
  {
    verseId: 57,
    name: "النحل",
    surahId: 16,
    text: "وَإِذَا بُشِّرَ أَحَدُهُم بِٱلۡأُنثَىٰ ظَلَّ وَجۡهُهُۥ مُسۡوَدّٗا وَهُوَ كَظِيمٞ",
    translation:
      "And when one of them is informed of [the birth of] a female, his face becomes dark, and he suppresses grief",
    normalizedText: "واذا بشر احدهم بالانثى ظل وجهه مسودا وهو كظيم",
  },
  {
    verseId: 58,
    name: "النحل",
    surahId: 16,
    text: "يَتَوَٰرَىٰ مِنَ ٱلۡقَوۡمِ مِن سُوٓءِ مَا بُشِّرَ بِهِۦٓۚ أَيُمۡسِكُهُۥ عَلَىٰ هُونٍ أَمۡ يَدُسُّهُۥ فِي ٱلتُّرَابِۗ أَلَا سَآءَ مَا يَحۡكُمُونَ",
    translation:
      "He hides himself from the people because of the ill of which he has been informed. Should he keep it in humiliation or bury it in the ground? Unquestionably, evil is what they decide",
    normalizedText:
      "يتورى من القوم من سوء ما بشر به ايمسكه على هون ام يدسه في التراب الا ساء ما يحكمون",
  },
  {
    verseId: 59,
    name: "النحل",
    surahId: 16,
    text: "لِلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ مَثَلُ ٱلسَّوۡءِۖ وَلِلَّهِ ٱلۡمَثَلُ ٱلۡأَعۡلَىٰۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "For those who do not believe in the Hereafter is the description of evil; and for Allah is the highest attribute. And He is Exalted in Might, the Wise",
    normalizedText:
      "للذين لا يامنون بالاخرة مثل السوء ولله المثل الاعلى وهو العزيز الحكيم",
  },
  {
    verseId: 60,
    name: "النحل",
    surahId: 16,
    text: "وَلَوۡ يُؤَاخِذُ ٱللَّهُ ٱلنَّاسَ بِظُلۡمِهِم مَّا تَرَكَ عَلَيۡهَا مِن دَآبَّةٖ وَلَٰكِن يُؤَخِّرُهُمۡ إِلَىٰٓ أَجَلٖ مُّسَمّٗىۖ فَإِذَا جَآءَ أَجَلُهُمۡ لَا يَسۡتَـٔۡخِرُونَ سَاعَةٗ وَلَا يَسۡتَقۡدِمُونَ",
    translation:
      "And if Allah were to impose blame on the people for their wrongdoing, He would not have left upon the earth any creature, but He defers them for a specified term. And when their term has come, they will not remain behind an hour, nor will they precede [it]",
    normalizedText:
      "ولو يااخذ الله الناس بظلمهم ما ترك عليها من دابة ولكن ياخرهم الى اجل مسمى فاذا جاء اجلهم لا يستخرون ساعة ولا يستقدمون",
  },
  {
    verseId: 61,
    name: "النحل",
    surahId: 16,
    text: "وَيَجۡعَلُونَ لِلَّهِ مَا يَكۡرَهُونَۚ وَتَصِفُ أَلۡسِنَتُهُمُ ٱلۡكَذِبَ أَنَّ لَهُمُ ٱلۡحُسۡنَىٰۚ لَا جَرَمَ أَنَّ لَهُمُ ٱلنَّارَ وَأَنَّهُم مُّفۡرَطُونَ",
    translation:
      "And they attribute to Allah that which they dislike, and their tongues assert the lie that they will have the best [from Him]. Assuredly, they will have the Fire, and they will be [therein] neglected",
    normalizedText:
      "ويجعلون لله ما يكرهون وتصف السنتهم الكذب ان لهم الحسنى لا جرم ان لهم النار وانهم مفرطون",
  },
  {
    verseId: 62,
    name: "النحل",
    surahId: 16,
    text: "تَٱللَّهِ لَقَدۡ أَرۡسَلۡنَآ إِلَىٰٓ أُمَمٖ مِّن قَبۡلِكَ فَزَيَّنَ لَهُمُ ٱلشَّيۡطَٰنُ أَعۡمَٰلَهُمۡ فَهُوَ وَلِيُّهُمُ ٱلۡيَوۡمَ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "By Allah, We did certainly send [messengers] to nations before you, but Satan made their deeds attractive to them. And he is the disbelievers' ally today [as well], and they will have a painful punishment",
    normalizedText:
      "تالله لقد ارسلنا الى امم من قبلك فزين لهم الشيطن اعملهم فهو وليهم اليوم ولهم عذاب اليم",
  },
  {
    verseId: 63,
    name: "النحل",
    surahId: 16,
    text: "وَمَآ أَنزَلۡنَا عَلَيۡكَ ٱلۡكِتَٰبَ إِلَّا لِتُبَيِّنَ لَهُمُ ٱلَّذِي ٱخۡتَلَفُواْ فِيهِ وَهُدٗى وَرَحۡمَةٗ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "And We have not revealed to you the Book, [O Muhammad], except for you to make clear to them that wherein they have differed and as guidance and mercy for a people who believe",
    normalizedText:
      "وما انزلنا عليك الكتب الا لتبين لهم الذي اختلفوا فيه وهدى ورحمة لقوم يامنون",
  },
  {
    verseId: 64,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَأَحۡيَا بِهِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَآۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّقَوۡمٖ يَسۡمَعُونَ",
    translation:
      "And Allah has sent down rain from the sky and given life thereby to the earth after its lifelessness. Indeed in that is a sign for a people who listen",
    normalizedText:
      "والله انزل من السماء ماء فاحيا به الارض بعد موتها ان في ذلك لاية لقوم يسمعون",
  },
  {
    verseId: 65,
    name: "النحل",
    surahId: 16,
    text: "وَإِنَّ لَكُمۡ فِي ٱلۡأَنۡعَٰمِ لَعِبۡرَةٗۖ نُّسۡقِيكُم مِّمَّا فِي بُطُونِهِۦ مِنۢ بَيۡنِ فَرۡثٖ وَدَمٖ لَّبَنًا خَالِصٗا سَآئِغٗا لِّلشَّـٰرِبِينَ",
    translation:
      "And indeed, for you in grazing livestock is a lesson. We give you drink from what is in their bellies - between excretion and blood - pure milk, palatable to drinkers",
    normalizedText:
      "وان لكم في الانعم لعبرة نسقيكم مما في بطونه من بين فرث ودم لبنا خالصا سااغا للشربين",
  },
  {
    verseId: 66,
    name: "النحل",
    surahId: 16,
    text: "وَمِن ثَمَرَٰتِ ٱلنَّخِيلِ وَٱلۡأَعۡنَٰبِ تَتَّخِذُونَ مِنۡهُ سَكَرٗا وَرِزۡقًا حَسَنًاۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "And from the fruits of the palm trees and grapevines you take intoxicant and good provision. Indeed in that is a sign for a people who reason",
    normalizedText:
      "ومن ثمرت النخيل والاعنب تتخذون منه سكرا ورزقا حسنا ان في ذلك لاية لقوم يعقلون",
  },
  {
    verseId: 67,
    name: "النحل",
    surahId: 16,
    text: "وَأَوۡحَىٰ رَبُّكَ إِلَى ٱلنَّحۡلِ أَنِ ٱتَّخِذِي مِنَ ٱلۡجِبَالِ بُيُوتٗا وَمِنَ ٱلشَّجَرِ وَمِمَّا يَعۡرِشُونَ",
    translation:
      'And your Lord inspired to the bee, "Take for yourself among the mountains, houses, and among the trees and [in] that which they construct',
    normalizedText:
      "واوحى ربك الى النحل ان اتخذي من الجبال بيوتا ومن الشجر ومما يعرشون",
  },
  {
    verseId: 68,
    name: "النحل",
    surahId: 16,
    text: "ثُمَّ كُلِي مِن كُلِّ ٱلثَّمَرَٰتِ فَٱسۡلُكِي سُبُلَ رَبِّكِ ذُلُلٗاۚ يَخۡرُجُ مِنۢ بُطُونِهَا شَرَابٞ مُّخۡتَلِفٌ أَلۡوَٰنُهُۥ فِيهِ شِفَآءٞ لِّلنَّاسِۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّقَوۡمٖ يَتَفَكَّرُونَ",
    translation:
      'Then eat from all the fruits and follow the ways of your Lord laid down [for you]." There emerges from their bellies a drink, varying in colors, in which there is healing for people. Indeed in that is a sign for a people who give thought',
    normalizedText:
      "ثم كلي من كل الثمرت فاسلكي سبل ربك ذللا يخرج من بطونها شراب مختلف الونه فيه شفاء للناس ان في ذلك لاية لقوم يتفكرون",
  },
  {
    verseId: 69,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ خَلَقَكُمۡ ثُمَّ يَتَوَفَّىٰكُمۡۚ وَمِنكُم مَّن يُرَدُّ إِلَىٰٓ أَرۡذَلِ ٱلۡعُمُرِ لِكَيۡ لَا يَعۡلَمَ بَعۡدَ عِلۡمٖ شَيۡـًٔاۚ إِنَّ ٱللَّهَ عَلِيمٞ قَدِيرٞ",
    translation:
      "And Allah created you; then He will take you in death. And among you is he who is reversed to the most decrepit [old] age so that he will not know, after [having had] knowledge, a thing. Indeed, Allah is Knowing and Competent",
    normalizedText:
      "والله خلقكم ثم يتوفىكم ومنكم من يرد الى ارذل العمر لكي لا يعلم بعد علم شيا ان الله عليم قدير",
  },
  {
    verseId: 70,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ فَضَّلَ بَعۡضَكُمۡ عَلَىٰ بَعۡضٖ فِي ٱلرِّزۡقِۚ فَمَا ٱلَّذِينَ فُضِّلُواْ بِرَآدِّي رِزۡقِهِمۡ عَلَىٰ مَا مَلَكَتۡ أَيۡمَٰنُهُمۡ فَهُمۡ فِيهِ سَوَآءٌۚ أَفَبِنِعۡمَةِ ٱللَّهِ يَجۡحَدُونَ",
    translation:
      "And Allah has favored some of you over others in provision. But those who were favored would not hand over their provision to those whom their right hands possess so they would be equal to them therein. Then is it the favor of Allah they reject",
    normalizedText:
      "والله فضل بعضكم على بعض في الرزق فما الذين فضلوا برادي رزقهم على ما ملكت ايمنهم فهم فيه سواء افبنعمة الله يجحدون",
  },
  {
    verseId: 71,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ جَعَلَ لَكُم مِّنۡ أَنفُسِكُمۡ أَزۡوَٰجٗا وَجَعَلَ لَكُم مِّنۡ أَزۡوَٰجِكُم بَنِينَ وَحَفَدَةٗ وَرَزَقَكُم مِّنَ ٱلطَّيِّبَٰتِۚ أَفَبِٱلۡبَٰطِلِ يُؤۡمِنُونَ وَبِنِعۡمَتِ ٱللَّهِ هُمۡ يَكۡفُرُونَ",
    translation:
      "And Allah has made for you from yourselves mates and has made for you from your mates sons and grandchildren and has provided for you from the good things. Then in falsehood do they believe and in the favor of Allah they disbelieve",
    normalizedText:
      "والله جعل لكم من انفسكم ازوجا وجعل لكم من ازوجكم بنين وحفدة ورزقكم من الطيبت افبالبطل يامنون وبنعمت الله هم يكفرون",
  },
  {
    verseId: 72,
    name: "النحل",
    surahId: 16,
    text: "وَيَعۡبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَمۡلِكُ لَهُمۡ رِزۡقٗا مِّنَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ شَيۡـٔٗا وَلَا يَسۡتَطِيعُونَ",
    translation:
      "And they worship besides Allah that which does not possess for them [the power of] provision from the heavens and the earth at all, and [in fact], they are unable",
    normalizedText:
      "ويعبدون من دون الله ما لا يملك لهم رزقا من السموت والارض شيا ولا يستطيعون",
  },
  {
    verseId: 73,
    name: "النحل",
    surahId: 16,
    text: "فَلَا تَضۡرِبُواْ لِلَّهِ ٱلۡأَمۡثَالَۚ إِنَّ ٱللَّهَ يَعۡلَمُ وَأَنتُمۡ لَا تَعۡلَمُونَ",
    translation:
      "So do not assert similarities to Allah. Indeed, Allah knows and you do not know",
    normalizedText: "فلا تضربوا لله الامثال ان الله يعلم وانتم لا تعلمون",
  },
  {
    verseId: 74,
    name: "النحل",
    surahId: 16,
    text: "۞ضَرَبَ ٱللَّهُ مَثَلًا عَبۡدٗا مَّمۡلُوكٗا لَّا يَقۡدِرُ عَلَىٰ شَيۡءٖ وَمَن رَّزَقۡنَٰهُ مِنَّا رِزۡقًا حَسَنٗا فَهُوَ يُنفِقُ مِنۡهُ سِرّٗا وَجَهۡرًاۖ هَلۡ يَسۡتَوُۥنَۚ ٱلۡحَمۡدُ لِلَّهِۚ بَلۡ أَكۡثَرُهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "Allah presents an example: a slave [who is] owned and unable to do a thing and he to whom We have provided from Us good provision, so he spends from it secretly and publicly. Can they be equal? Praise to Allah! But most of them do not know",
    normalizedText:
      "۞ضرب الله مثلا عبدا مملوكا لا يقدر على شيء ومن رزقنه منا رزقا حسنا فهو ينفق منه سرا وجهرا هل يستون الحمد لله بل اكثرهم لا يعلمون",
  },
  {
    verseId: 75,
    name: "النحل",
    surahId: 16,
    text: "وَضَرَبَ ٱللَّهُ مَثَلٗا رَّجُلَيۡنِ أَحَدُهُمَآ أَبۡكَمُ لَا يَقۡدِرُ عَلَىٰ شَيۡءٖ وَهُوَ كَلٌّ عَلَىٰ مَوۡلَىٰهُ أَيۡنَمَا يُوَجِّههُّ لَا يَأۡتِ بِخَيۡرٍ هَلۡ يَسۡتَوِي هُوَ وَمَن يَأۡمُرُ بِٱلۡعَدۡلِ وَهُوَ عَلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "And Allah presents an example of two men, one of them dumb and unable to do a thing, while he is a burden to his guardian. Wherever he directs him, he brings no good. Is he equal to one who commands justice, while he is on a straight path",
    normalizedText:
      "وضرب الله مثلا رجلين احدهما ابكم لا يقدر على شيء وهو كل على مولىه اينما يوجهه لا يات بخير هل يستوي هو ومن يامر بالعدل وهو على صرط مستقيم",
  },
  {
    verseId: 76,
    name: "النحل",
    surahId: 16,
    text: "وَلِلَّهِ غَيۡبُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَمَآ أَمۡرُ ٱلسَّاعَةِ إِلَّا كَلَمۡحِ ٱلۡبَصَرِ أَوۡ هُوَ أَقۡرَبُۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "And to Allah belongs the unseen [aspects] of the heavens and the earth. And the command for the Hour is not but as a glance of the eye or even nearer. Indeed, Allah is over all things competent",
    normalizedText:
      "ولله غيب السموت والارض وما امر الساعة الا كلمح البصر او هو اقرب ان الله على كل شيء قدير",
  },
  {
    verseId: 77,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ أَخۡرَجَكُم مِّنۢ بُطُونِ أُمَّهَٰتِكُمۡ لَا تَعۡلَمُونَ شَيۡـٔٗا وَجَعَلَ لَكُمُ ٱلسَّمۡعَ وَٱلۡأَبۡصَٰرَ وَٱلۡأَفۡـِٔدَةَ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And Allah has extracted you from the wombs of your mothers not knowing a thing, and He made for you hearing and vision and intellect that perhaps you would be grateful",
    normalizedText:
      "والله اخرجكم من بطون امهتكم لا تعلمون شيا وجعل لكم السمع والابصر والافدة لعلكم تشكرون",
  },
  {
    verseId: 78,
    name: "النحل",
    surahId: 16,
    text: "أَلَمۡ يَرَوۡاْ إِلَى ٱلطَّيۡرِ مُسَخَّرَٰتٖ فِي جَوِّ ٱلسَّمَآءِ مَا يُمۡسِكُهُنَّ إِلَّا ٱللَّهُۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "Do they not see the birds controlled in the atmosphere of the sky? None holds them up except Allah. Indeed in that are signs for a people who believe",
    normalizedText:
      "الم يروا الى الطير مسخرت في جو السماء ما يمسكهن الا الله ان في ذلك لايت لقوم يامنون",
  },
  {
    verseId: 79,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ جَعَلَ لَكُم مِّنۢ بُيُوتِكُمۡ سَكَنٗا وَجَعَلَ لَكُم مِّن جُلُودِ ٱلۡأَنۡعَٰمِ بُيُوتٗا تَسۡتَخِفُّونَهَا يَوۡمَ ظَعۡنِكُمۡ وَيَوۡمَ إِقَامَتِكُمۡ وَمِنۡ أَصۡوَافِهَا وَأَوۡبَارِهَا وَأَشۡعَارِهَآ أَثَٰثٗا وَمَتَٰعًا إِلَىٰ حِينٖ",
    translation:
      "And Allah has made for you from your homes a place of rest and made for you from the hides of the animals tents which you find light on your day of travel and your day of encampment; and from their wool, fur and hair is furnishing and enjoyment for a time",
    normalizedText:
      "والله جعل لكم من بيوتكم سكنا وجعل لكم من جلود الانعم بيوتا تستخفونها يوم ظعنكم ويوم اقامتكم ومن اصوافها واوبارها واشعارها اثثا ومتعا الى حين",
  },
  {
    verseId: 80,
    name: "النحل",
    surahId: 16,
    text: "وَٱللَّهُ جَعَلَ لَكُم مِّمَّا خَلَقَ ظِلَٰلٗا وَجَعَلَ لَكُم مِّنَ ٱلۡجِبَالِ أَكۡنَٰنٗا وَجَعَلَ لَكُمۡ سَرَٰبِيلَ تَقِيكُمُ ٱلۡحَرَّ وَسَرَٰبِيلَ تَقِيكُم بَأۡسَكُمۡۚ كَذَٰلِكَ يُتِمُّ نِعۡمَتَهُۥ عَلَيۡكُمۡ لَعَلَّكُمۡ تُسۡلِمُونَ",
    translation:
      "And Allah has made for you, from that which He has created, shadows and has made for you from the mountains, shelters and has made for you garments which protect you from the heat and garments which protect you from your [enemy in] battle. Thus does He complete His favor upon you that you might submit [to Him]",
    normalizedText:
      "والله جعل لكم مما خلق ظللا وجعل لكم من الجبال اكننا وجعل لكم سربيل تقيكم الحر وسربيل تقيكم باسكم كذلك يتم نعمته عليكم لعلكم تسلمون",
  },
  {
    verseId: 81,
    name: "النحل",
    surahId: 16,
    text: "فَإِن تَوَلَّوۡاْ فَإِنَّمَا عَلَيۡكَ ٱلۡبَلَٰغُ ٱلۡمُبِينُ",
    translation:
      "But if they turn away, [O Muhammad] - then only upon you is [responsibility for] clear notification",
    normalizedText: "فان تولوا فانما عليك البلغ المبين",
  },
  {
    verseId: 82,
    name: "النحل",
    surahId: 16,
    text: "يَعۡرِفُونَ نِعۡمَتَ ٱللَّهِ ثُمَّ يُنكِرُونَهَا وَأَكۡثَرُهُمُ ٱلۡكَٰفِرُونَ",
    translation:
      "They recognize the favor of Allah; then they deny it. And most of them are disbelievers",
    normalizedText: "يعرفون نعمت الله ثم ينكرونها واكثرهم الكفرون",
  },
  {
    verseId: 83,
    name: "النحل",
    surahId: 16,
    text: "وَيَوۡمَ نَبۡعَثُ مِن كُلِّ أُمَّةٖ شَهِيدٗا ثُمَّ لَا يُؤۡذَنُ لِلَّذِينَ كَفَرُواْ وَلَا هُمۡ يُسۡتَعۡتَبُونَ",
    translation:
      "And [mention] the Day when We will resurrect from every nation a witness. Then it will not be permitted to the disbelievers [to apologize or make excuses], nor will they be asked to appease [Allah]",
    normalizedText:
      "ويوم نبعث من كل امة شهيدا ثم لا ياذن للذين كفروا ولا هم يستعتبون",
  },
  {
    verseId: 84,
    name: "النحل",
    surahId: 16,
    text: "وَإِذَا رَءَا ٱلَّذِينَ ظَلَمُواْ ٱلۡعَذَابَ فَلَا يُخَفَّفُ عَنۡهُمۡ وَلَا هُمۡ يُنظَرُونَ",
    translation:
      "And when those who wronged see the punishment, it will not be lightened for them, nor will they be reprieved",
    normalizedText: "واذا رءا الذين ظلموا العذاب فلا يخفف عنهم ولا هم ينظرون",
  },
  {
    verseId: 85,
    name: "النحل",
    surahId: 16,
    text: "وَإِذَا رَءَا ٱلَّذِينَ أَشۡرَكُواْ شُرَكَآءَهُمۡ قَالُواْ رَبَّنَا هَـٰٓؤُلَآءِ شُرَكَآؤُنَا ٱلَّذِينَ كُنَّا نَدۡعُواْ مِن دُونِكَۖ فَأَلۡقَوۡاْ إِلَيۡهِمُ ٱلۡقَوۡلَ إِنَّكُمۡ لَكَٰذِبُونَ",
    translation:
      'And when those who associated others with Allah see their "partners," they will say," Our Lord, these are our partners [to You] whom we used to invoke besides You." But they will throw at them the statement, "Indeed, you are liars',
    normalizedText:
      "واذا رءا الذين اشركوا شركاءهم قالوا ربنا هالاء شركاانا الذين كنا ندعوا من دونك فالقوا اليهم القول انكم لكذبون",
  },
  {
    verseId: 86,
    name: "النحل",
    surahId: 16,
    text: "وَأَلۡقَوۡاْ إِلَى ٱللَّهِ يَوۡمَئِذٍ ٱلسَّلَمَۖ وَضَلَّ عَنۡهُم مَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      "And they will impart to Allah that Day [their] submission, and lost from them is what they used to invent",
    normalizedText: "والقوا الى الله يوماذ السلم وضل عنهم ما كانوا يفترون",
  },
  {
    verseId: 87,
    name: "النحل",
    surahId: 16,
    text: "ٱلَّذِينَ كَفَرُواْ وَصَدُّواْ عَن سَبِيلِ ٱللَّهِ زِدۡنَٰهُمۡ عَذَابٗا فَوۡقَ ٱلۡعَذَابِ بِمَا كَانُواْ يُفۡسِدُونَ",
    translation:
      "Those who disbelieved and averted [others] from the way of Allah - We will increase them in punishment over [their] punishment for what corruption they were causing",
    normalizedText:
      "الذين كفروا وصدوا عن سبيل الله زدنهم عذابا فوق العذاب بما كانوا يفسدون",
  },
  {
    verseId: 88,
    name: "النحل",
    surahId: 16,
    text: "وَيَوۡمَ نَبۡعَثُ فِي كُلِّ أُمَّةٖ شَهِيدًا عَلَيۡهِم مِّنۡ أَنفُسِهِمۡۖ وَجِئۡنَا بِكَ شَهِيدًا عَلَىٰ هَـٰٓؤُلَآءِۚ وَنَزَّلۡنَا عَلَيۡكَ ٱلۡكِتَٰبَ تِبۡيَٰنٗا لِّكُلِّ شَيۡءٖ وَهُدٗى وَرَحۡمَةٗ وَبُشۡرَىٰ لِلۡمُسۡلِمِينَ",
    translation:
      "And [mention] the Day when We will resurrect among every nation a witness over them from themselves. And We will bring you, [O Muhammad], as a witness over your nation. And We have sent down to you the Book as clarification for all things and as guidance and mercy and good tidings for the Muslims",
    normalizedText:
      "ويوم نبعث في كل امة شهيدا عليهم من انفسهم وجانا بك شهيدا على هالاء ونزلنا عليك الكتب تبينا لكل شيء وهدى ورحمة وبشرى للمسلمين",
  },
  {
    verseId: 89,
    name: "النحل",
    surahId: 16,
    text: "۞إِنَّ ٱللَّهَ يَأۡمُرُ بِٱلۡعَدۡلِ وَٱلۡإِحۡسَٰنِ وَإِيتَآيِٕ ذِي ٱلۡقُرۡبَىٰ وَيَنۡهَىٰ عَنِ ٱلۡفَحۡشَآءِ وَٱلۡمُنكَرِ وَٱلۡبَغۡيِۚ يَعِظُكُمۡ لَعَلَّكُمۡ تَذَكَّرُونَ",
    translation:
      "Indeed, Allah orders justice and good conduct and giving to relatives and forbids immorality and bad conduct and oppression. He admonishes you that perhaps you will be reminded",
    normalizedText:
      "۞ان الله يامر بالعدل والاحسن وايتاي ذي القربى وينهى عن الفحشاء والمنكر والبغي يعظكم لعلكم تذكرون",
  },
  {
    verseId: 90,
    name: "النحل",
    surahId: 16,
    text: "وَأَوۡفُواْ بِعَهۡدِ ٱللَّهِ إِذَا عَٰهَدتُّمۡ وَلَا تَنقُضُواْ ٱلۡأَيۡمَٰنَ بَعۡدَ تَوۡكِيدِهَا وَقَدۡ جَعَلۡتُمُ ٱللَّهَ عَلَيۡكُمۡ كَفِيلًاۚ إِنَّ ٱللَّهَ يَعۡلَمُ مَا تَفۡعَلُونَ",
    translation:
      "And fulfill the covenant of Allah when you have taken it, [O believers], and do not break oaths after their confirmation while you have made Allah, over you, a witness. Indeed, Allah knows what you do",
    normalizedText:
      "واوفوا بعهد الله اذا عهدتم ولا تنقضوا الايمن بعد توكيدها وقد جعلتم الله عليكم كفيلا ان الله يعلم ما تفعلون",
  },
  {
    verseId: 91,
    name: "النحل",
    surahId: 16,
    text: "وَلَا تَكُونُواْ كَٱلَّتِي نَقَضَتۡ غَزۡلَهَا مِنۢ بَعۡدِ قُوَّةٍ أَنكَٰثٗا تَتَّخِذُونَ أَيۡمَٰنَكُمۡ دَخَلَۢا بَيۡنَكُمۡ أَن تَكُونَ أُمَّةٌ هِيَ أَرۡبَىٰ مِنۡ أُمَّةٍۚ إِنَّمَا يَبۡلُوكُمُ ٱللَّهُ بِهِۦۚ وَلَيُبَيِّنَنَّ لَكُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ مَا كُنتُمۡ فِيهِ تَخۡتَلِفُونَ",
    translation:
      "And do not be like she who untwisted her spun thread after it was strong [by] taking your oaths as [means of] deceit between you because one community is more plentiful [in number or wealth] than another community. Allah only tries you thereby. And He will surely make clear to you on the Day of Resurrection that over which you used to differ",
    normalizedText:
      "ولا تكونوا كالتي نقضت غزلها من بعد قوة انكثا تتخذون ايمنكم دخلا بينكم ان تكون امة هي اربى من امة انما يبلوكم الله به وليبينن لكم يوم القيمة ما كنتم فيه تختلفون",
  },
  {
    verseId: 92,
    name: "النحل",
    surahId: 16,
    text: "وَلَوۡ شَآءَ ٱللَّهُ لَجَعَلَكُمۡ أُمَّةٗ وَٰحِدَةٗ وَلَٰكِن يُضِلُّ مَن يَشَآءُ وَيَهۡدِي مَن يَشَآءُۚ وَلَتُسۡـَٔلُنَّ عَمَّا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "And if Allah had willed, He could have made you [of] one religion, but He causes to stray whom He wills and guides whom He wills. And you will surely be questioned about what you used to do",
    normalizedText:
      "ولو شاء الله لجعلكم امة وحدة ولكن يضل من يشاء ويهدي من يشاء ولتسلن عما كنتم تعملون",
  },
  {
    verseId: 93,
    name: "النحل",
    surahId: 16,
    text: "وَلَا تَتَّخِذُوٓاْ أَيۡمَٰنَكُمۡ دَخَلَۢا بَيۡنَكُمۡ فَتَزِلَّ قَدَمُۢ بَعۡدَ ثُبُوتِهَا وَتَذُوقُواْ ٱلسُّوٓءَ بِمَا صَدَدتُّمۡ عَن سَبِيلِ ٱللَّهِ وَلَكُمۡ عَذَابٌ عَظِيمٞ",
    translation:
      "And do not take your oaths as [means of] deceit between you, lest a foot slip after it was [once] firm, and you would taste evil [in this world] for what [people] you diverted from the way of Allah, and you would have [in the Hereafter] a great punishment",
    normalizedText:
      "ولا تتخذوا ايمنكم دخلا بينكم فتزل قدم بعد ثبوتها وتذوقوا السوء بما صددتم عن سبيل الله ولكم عذاب عظيم",
  },
  {
    verseId: 94,
    name: "النحل",
    surahId: 16,
    text: "وَلَا تَشۡتَرُواْ بِعَهۡدِ ٱللَّهِ ثَمَنٗا قَلِيلًاۚ إِنَّمَا عِندَ ٱللَّهِ هُوَ خَيۡرٞ لَّكُمۡ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "And do not exchange the covenant of Allah for a small price. Indeed, what is with Allah is best for you, if only you could know",
    normalizedText:
      "ولا تشتروا بعهد الله ثمنا قليلا انما عند الله هو خير لكم ان كنتم تعلمون",
  },
  {
    verseId: 95,
    name: "النحل",
    surahId: 16,
    text: "مَا عِندَكُمۡ يَنفَدُ وَمَا عِندَ ٱللَّهِ بَاقٖۗ وَلَنَجۡزِيَنَّ ٱلَّذِينَ صَبَرُوٓاْ أَجۡرَهُم بِأَحۡسَنِ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Whatever you have will end, but what Allah has is lasting. And We will surely give those who were patient their reward according to the best of what they used to do",
    normalizedText:
      "ما عندكم ينفد وما عند الله باق ولنجزين الذين صبروا اجرهم باحسن ما كانوا يعملون",
  },
  {
    verseId: 96,
    name: "النحل",
    surahId: 16,
    text: "مَنۡ عَمِلَ صَٰلِحٗا مِّن ذَكَرٍ أَوۡ أُنثَىٰ وَهُوَ مُؤۡمِنٞ فَلَنُحۡيِيَنَّهُۥ حَيَوٰةٗ طَيِّبَةٗۖ وَلَنَجۡزِيَنَّهُمۡ أَجۡرَهُم بِأَحۡسَنِ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Whoever does righteousness, whether male or female, while he is a believer - We will surely cause him to live a good life, and We will surely give them their reward [in the Hereafter] according to the best of what they used to do",
    normalizedText:
      "من عمل صلحا من ذكر او انثى وهو مامن فلنحيينه حيوة طيبة ولنجزينهم اجرهم باحسن ما كانوا يعملون",
  },
  {
    verseId: 97,
    name: "النحل",
    surahId: 16,
    text: "فَإِذَا قَرَأۡتَ ٱلۡقُرۡءَانَ فَٱسۡتَعِذۡ بِٱللَّهِ مِنَ ٱلشَّيۡطَٰنِ ٱلرَّجِيمِ",
    translation:
      "So when you recite the Qur'an, [first] seek refuge in Allah from Satan, the expelled [from His mercy]",
    normalizedText: "فاذا قرات القرءان فاستعذ بالله من الشيطن الرجيم",
  },
  {
    verseId: 98,
    name: "النحل",
    surahId: 16,
    text: "إِنَّهُۥ لَيۡسَ لَهُۥ سُلۡطَٰنٌ عَلَى ٱلَّذِينَ ءَامَنُواْ وَعَلَىٰ رَبِّهِمۡ يَتَوَكَّلُونَ",
    translation:
      "Indeed, there is for him no authority over those who have believed and rely upon their Lord",
    normalizedText: "انه ليس له سلطن على الذين ءامنوا وعلى ربهم يتوكلون",
  },
  {
    verseId: 99,
    name: "النحل",
    surahId: 16,
    text: "إِنَّمَا سُلۡطَٰنُهُۥ عَلَى ٱلَّذِينَ يَتَوَلَّوۡنَهُۥ وَٱلَّذِينَ هُم بِهِۦ مُشۡرِكُونَ",
    translation:
      "His authority is only over those who take him as an ally and those who through him associate others with Allah",
    normalizedText: "انما سلطنه على الذين يتولونه والذين هم به مشركون",
  },
  {
    verseId: 100,
    name: "النحل",
    surahId: 16,
    text: "وَإِذَا بَدَّلۡنَآ ءَايَةٗ مَّكَانَ ءَايَةٖ وَٱللَّهُ أَعۡلَمُ بِمَا يُنَزِّلُ قَالُوٓاْ إِنَّمَآ أَنتَ مُفۡتَرِۭۚ بَلۡ أَكۡثَرُهُمۡ لَا يَعۡلَمُونَ",
    translation:
      'And when We substitute a verse in place of a verse - and Allah is most knowing of what He sends down - they say, "You, [O Muhammad], are but an inventor [of lies]." But most of them do not know',
    normalizedText:
      "واذا بدلنا ءاية مكان ءاية والله اعلم بما ينزل قالوا انما انت مفتر بل اكثرهم لا يعلمون",
  },
  {
    verseId: 101,
    name: "النحل",
    surahId: 16,
    text: "قُلۡ نَزَّلَهُۥ رُوحُ ٱلۡقُدُسِ مِن رَّبِّكَ بِٱلۡحَقِّ لِيُثَبِّتَ ٱلَّذِينَ ءَامَنُواْ وَهُدٗى وَبُشۡرَىٰ لِلۡمُسۡلِمِينَ",
    translation:
      'Say, [O Muhammad], "The Pure Spirit has brought it down from your Lord in truth to make firm those who believe and as guidance and good tidings to the Muslims',
    normalizedText:
      "قل نزله روح القدس من ربك بالحق ليثبت الذين ءامنوا وهدى وبشرى للمسلمين",
  },
  {
    verseId: 102,
    name: "النحل",
    surahId: 16,
    text: "وَلَقَدۡ نَعۡلَمُ أَنَّهُمۡ يَقُولُونَ إِنَّمَا يُعَلِّمُهُۥ بَشَرٞۗ لِّسَانُ ٱلَّذِي يُلۡحِدُونَ إِلَيۡهِ أَعۡجَمِيّٞ وَهَٰذَا لِسَانٌ عَرَبِيّٞ مُّبِينٌ",
    translation: `And We certainly know that they say, "It is only a human being who teaches the Prophet." The tongue of the one they refer to is foreign, and this Qur'an is [in] a clear Arabic language`,
    normalizedText:
      "ولقد نعلم انهم يقولون انما يعلمه بشر لسان الذي يلحدون اليه اعجمي وهذا لسان عربي مبين",
  },
  {
    verseId: 103,
    name: "النحل",
    surahId: 16,
    text: "إِنَّ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِـَٔايَٰتِ ٱللَّهِ لَا يَهۡدِيهِمُ ٱللَّهُ وَلَهُمۡ عَذَابٌ أَلِيمٌ",
    translation:
      "Indeed, those who do not believe in the verses of Allah - Allah will not guide them, and for them is a painful punishment",
    normalizedText:
      "ان الذين لا يامنون بايت الله لا يهديهم الله ولهم عذاب اليم",
  },
  {
    verseId: 104,
    name: "النحل",
    surahId: 16,
    text: "إِنَّمَا يَفۡتَرِي ٱلۡكَذِبَ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِـَٔايَٰتِ ٱللَّهِۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡكَٰذِبُونَ",
    translation:
      "They only invent falsehood who do not believe in the verses of Allah, and it is those who are the liars",
    normalizedText:
      "انما يفتري الكذب الذين لا يامنون بايت الله واولاك هم الكذبون",
  },
  {
    verseId: 105,
    name: "النحل",
    surahId: 16,
    text: "مَن كَفَرَ بِٱللَّهِ مِنۢ بَعۡدِ إِيمَٰنِهِۦٓ إِلَّا مَنۡ أُكۡرِهَ وَقَلۡبُهُۥ مُطۡمَئِنُّۢ بِٱلۡإِيمَٰنِ وَلَٰكِن مَّن شَرَحَ بِٱلۡكُفۡرِ صَدۡرٗا فَعَلَيۡهِمۡ غَضَبٞ مِّنَ ٱللَّهِ وَلَهُمۡ عَذَابٌ عَظِيمٞ",
    translation:
      "Whoever disbelieves in Allah after his belief... except for one who is forced [to renounce his religion] while his heart is secure in faith. But those who [willingly] open their breasts to disbelief, upon them is wrath from Allah, and for them is a great punishment",
    normalizedText:
      "من كفر بالله من بعد ايمنه الا من اكره وقلبه مطمان بالايمن ولكن من شرح بالكفر صدرا فعليهم غضب من الله ولهم عذاب عظيم",
  },
  {
    verseId: 106,
    name: "النحل",
    surahId: 16,
    text: "ذَٰلِكَ بِأَنَّهُمُ ٱسۡتَحَبُّواْ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا عَلَى ٱلۡأٓخِرَةِ وَأَنَّ ٱللَّهَ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡكَٰفِرِينَ",
    translation:
      "That is because they preferred the worldly life over the Hereafter and that Allah does not guide the disbelieving people",
    normalizedText:
      "ذلك بانهم استحبوا الحيوة الدنيا على الاخرة وان الله لا يهدي القوم الكفرين",
  },
  {
    verseId: 107,
    name: "النحل",
    surahId: 16,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ طَبَعَ ٱللَّهُ عَلَىٰ قُلُوبِهِمۡ وَسَمۡعِهِمۡ وَأَبۡصَٰرِهِمۡۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡغَٰفِلُونَ",
    translation:
      "Those are the ones over whose hearts and hearing and vision Allah has sealed, and it is those who are the heedless",
    normalizedText:
      "اولاك الذين طبع الله على قلوبهم وسمعهم وابصرهم واولاك هم الغفلون",
  },
  {
    verseId: 108,
    name: "النحل",
    surahId: 16,
    text: "لَا جَرَمَ أَنَّهُمۡ فِي ٱلۡأٓخِرَةِ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "Assuredly, it is they, in the Hereafter, who will be the losers",
    normalizedText: "لا جرم انهم في الاخرة هم الخسرون",
  },
  {
    verseId: 109,
    name: "النحل",
    surahId: 16,
    text: "ثُمَّ إِنَّ رَبَّكَ لِلَّذِينَ هَاجَرُواْ مِنۢ بَعۡدِ مَا فُتِنُواْ ثُمَّ جَٰهَدُواْ وَصَبَرُوٓاْ إِنَّ رَبَّكَ مِنۢ بَعۡدِهَا لَغَفُورٞ رَّحِيمٞ",
    translation:
      "Then, indeed your Lord, to those who emigrated after they had been compelled [to renounce their religion] and thereafter fought [for the cause of Allah] and were patient - indeed, your Lord, after that, is Forgiving and Merciful",
    normalizedText:
      "ثم ان ربك للذين هاجروا من بعد ما فتنوا ثم جهدوا وصبروا ان ربك من بعدها لغفور رحيم",
  },
  {
    verseId: 110,
    name: "النحل",
    surahId: 16,
    text: "۞يَوۡمَ تَأۡتِي كُلُّ نَفۡسٖ تُجَٰدِلُ عَن نَّفۡسِهَا وَتُوَفَّىٰ كُلُّ نَفۡسٖ مَّا عَمِلَتۡ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "On the Day when every soul will come disputing for itself, and every soul will be fully compensated for what it did, and they will not be wronged",
    normalizedText:
      "۞يوم تاتي كل نفس تجدل عن نفسها وتوفى كل نفس ما عملت وهم لا يظلمون",
  },
  {
    verseId: 111,
    name: "النحل",
    surahId: 16,
    text: "وَضَرَبَ ٱللَّهُ مَثَلٗا قَرۡيَةٗ كَانَتۡ ءَامِنَةٗ مُّطۡمَئِنَّةٗ يَأۡتِيهَا رِزۡقُهَا رَغَدٗا مِّن كُلِّ مَكَانٖ فَكَفَرَتۡ بِأَنۡعُمِ ٱللَّهِ فَأَذَٰقَهَا ٱللَّهُ لِبَاسَ ٱلۡجُوعِ وَٱلۡخَوۡفِ بِمَا كَانُواْ يَصۡنَعُونَ",
    translation:
      "And Allah presents an example: a city which was safe and secure, its provision coming to it in abundance from every location, but it denied the favors of Allah. So Allah made it taste the envelopment of hunger and fear for what they had been doing",
    normalizedText:
      "وضرب الله مثلا قرية كانت ءامنة مطمانة ياتيها رزقها رغدا من كل مكان فكفرت بانعم الله فاذقها الله لباس الجوع والخوف بما كانوا يصنعون",
  },
  {
    verseId: 112,
    name: "النحل",
    surahId: 16,
    text: "وَلَقَدۡ جَآءَهُمۡ رَسُولٞ مِّنۡهُمۡ فَكَذَّبُوهُ فَأَخَذَهُمُ ٱلۡعَذَابُ وَهُمۡ ظَٰلِمُونَ",
    translation:
      "And there had certainly come to them a Messenger from among themselves, but they denied him; so punishment overtook them while they were wrongdoers",
    normalizedText: "ولقد جاءهم رسول منهم فكذبوه فاخذهم العذاب وهم ظلمون",
  },
  {
    verseId: 113,
    name: "النحل",
    surahId: 16,
    text: "فَكُلُواْ مِمَّا رَزَقَكُمُ ٱللَّهُ حَلَٰلٗا طَيِّبٗا وَٱشۡكُرُواْ نِعۡمَتَ ٱللَّهِ إِن كُنتُمۡ إِيَّاهُ تَعۡبُدُونَ",
    translation:
      "Then eat of what Allah has provided for you [which is] lawful and good. And be grateful for the favor of Allah, if it is [indeed] Him that you worship",
    normalizedText:
      "فكلوا مما رزقكم الله حللا طيبا واشكروا نعمت الله ان كنتم اياه تعبدون",
  },
  {
    verseId: 114,
    name: "النحل",
    surahId: 16,
    text: "إِنَّمَا حَرَّمَ عَلَيۡكُمُ ٱلۡمَيۡتَةَ وَٱلدَّمَ وَلَحۡمَ ٱلۡخِنزِيرِ وَمَآ أُهِلَّ لِغَيۡرِ ٱللَّهِ بِهِۦۖ فَمَنِ ٱضۡطُرَّ غَيۡرَ بَاغٖ وَلَا عَادٖ فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "He has only forbidden to you dead animals, blood, the flesh of swine, and that which has been dedicated to other than Allah. But whoever is forced [by necessity], neither desiring [it] nor transgressing [its limit] - then indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "انما حرم عليكم الميتة والدم ولحم الخنزير وما اهل لغير الله به فمن اضطر غير باغ ولا عاد فان الله غفور رحيم",
  },
  {
    verseId: 115,
    name: "النحل",
    surahId: 16,
    text: "وَلَا تَقُولُواْ لِمَا تَصِفُ أَلۡسِنَتُكُمُ ٱلۡكَذِبَ هَٰذَا حَلَٰلٞ وَهَٰذَا حَرَامٞ لِّتَفۡتَرُواْ عَلَى ٱللَّهِ ٱلۡكَذِبَۚ إِنَّ ٱلَّذِينَ يَفۡتَرُونَ عَلَى ٱللَّهِ ٱلۡكَذِبَ لَا يُفۡلِحُونَ",
    translation:
      'And do not say about what your tongues assert of untruth, "This is lawful and this is unlawful," to invent falsehood about Allah. Indeed, those who invent falsehood about Allah will not succeed',
    normalizedText:
      "ولا تقولوا لما تصف السنتكم الكذب هذا حلل وهذا حرام لتفتروا على الله الكذب ان الذين يفترون على الله الكذب لا يفلحون",
  },
  {
    verseId: 116,
    name: "النحل",
    surahId: 16,
    text: "مَتَٰعٞ قَلِيلٞ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "[It is but] a brief enjoyment, and they will have a painful punishment",
    normalizedText: "متع قليل ولهم عذاب اليم",
  },
  {
    verseId: 117,
    name: "النحل",
    surahId: 16,
    text: "وَعَلَى ٱلَّذِينَ هَادُواْ حَرَّمۡنَا مَا قَصَصۡنَا عَلَيۡكَ مِن قَبۡلُۖ وَمَا ظَلَمۡنَٰهُمۡ وَلَٰكِن كَانُوٓاْ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      "And to those who are Jews We have prohibited that which We related to you before. And We did not wrong them [thereby], but they were wronging themselves",
    normalizedText:
      "وعلى الذين هادوا حرمنا ما قصصنا عليك من قبل وما ظلمنهم ولكن كانوا انفسهم يظلمون",
  },
  {
    verseId: 118,
    name: "النحل",
    surahId: 16,
    text: "ثُمَّ إِنَّ رَبَّكَ لِلَّذِينَ عَمِلُواْ ٱلسُّوٓءَ بِجَهَٰلَةٖ ثُمَّ تَابُواْ مِنۢ بَعۡدِ ذَٰلِكَ وَأَصۡلَحُوٓاْ إِنَّ رَبَّكَ مِنۢ بَعۡدِهَا لَغَفُورٞ رَّحِيمٌ",
    translation:
      "Then, indeed your Lord, to those who have done wrong out of ignorance and then repent after that and correct themselves - indeed, your Lord, thereafter, is Forgiving and Merciful",
    normalizedText:
      "ثم ان ربك للذين عملوا السوء بجهلة ثم تابوا من بعد ذلك واصلحوا ان ربك من بعدها لغفور رحيم",
  },
  {
    verseId: 119,
    name: "النحل",
    surahId: 16,
    text: "إِنَّ إِبۡرَٰهِيمَ كَانَ أُمَّةٗ قَانِتٗا لِّلَّهِ حَنِيفٗا وَلَمۡ يَكُ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "Indeed, Abraham was a [comprehensive] leader, devoutly obedient to Allah, inclining toward truth, and he was not of those who associate others with Allah",
    normalizedText: "ان ابرهيم كان امة قانتا لله حنيفا ولم يك من المشركين",
  },
  {
    verseId: 120,
    name: "النحل",
    surahId: 16,
    text: "شَاكِرٗا لِّأَنۡعُمِهِۚ ٱجۡتَبَىٰهُ وَهَدَىٰهُ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "[He was] grateful for His favors. Allah chose him and guided him to a straight path",
    normalizedText: "شاكرا لانعمه اجتبىه وهدىه الى صرط مستقيم",
  },
  {
    verseId: 121,
    name: "النحل",
    surahId: 16,
    text: "وَءَاتَيۡنَٰهُ فِي ٱلدُّنۡيَا حَسَنَةٗۖ وَإِنَّهُۥ فِي ٱلۡأٓخِرَةِ لَمِنَ ٱلصَّـٰلِحِينَ",
    translation:
      "And We gave him good in this world, and indeed, in the Hereafter he will be among the righteous",
    normalizedText: "وءاتينه في الدنيا حسنة وانه في الاخرة لمن الصلحين",
  },
  {
    verseId: 122,
    name: "النحل",
    surahId: 16,
    text: "ثُمَّ أَوۡحَيۡنَآ إِلَيۡكَ أَنِ ٱتَّبِعۡ مِلَّةَ إِبۡرَٰهِيمَ حَنِيفٗاۖ وَمَا كَانَ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "Then We revealed to you, [O Muhammad], to follow the religion of Abraham, inclining toward truth; and he was not of those who associate with Allah",
    normalizedText:
      "ثم اوحينا اليك ان اتبع ملة ابرهيم حنيفا وما كان من المشركين",
  },
  {
    verseId: 123,
    name: "النحل",
    surahId: 16,
    text: "إِنَّمَا جُعِلَ ٱلسَّبۡتُ عَلَى ٱلَّذِينَ ٱخۡتَلَفُواْ فِيهِۚ وَإِنَّ رَبَّكَ لَيَحۡكُمُ بَيۡنَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ فِيمَا كَانُواْ فِيهِ يَخۡتَلِفُونَ",
    translation:
      "The sabbath was only appointed for those who differed over it. And indeed, your Lord will judge between them on the Day of Resurrection concerning that over which they used to differ",
    normalizedText:
      "انما جعل السبت على الذين اختلفوا فيه وان ربك ليحكم بينهم يوم القيمة فيما كانوا فيه يختلفون",
  },
  {
    verseId: 124,
    name: "النحل",
    surahId: 16,
    text: "ٱدۡعُ إِلَىٰ سَبِيلِ رَبِّكَ بِٱلۡحِكۡمَةِ وَٱلۡمَوۡعِظَةِ ٱلۡحَسَنَةِۖ وَجَٰدِلۡهُم بِٱلَّتِي هِيَ أَحۡسَنُۚ إِنَّ رَبَّكَ هُوَ أَعۡلَمُ بِمَن ضَلَّ عَن سَبِيلِهِۦ وَهُوَ أَعۡلَمُ بِٱلۡمُهۡتَدِينَ",
    translation:
      "Invite to the way of your Lord with wisdom and good instruction, and argue with them in a way that is best. Indeed, your Lord is most knowing of who has strayed from His way, and He is most knowing of who is [rightly] guided",
    normalizedText:
      "ادع الى سبيل ربك بالحكمة والموعظة الحسنة وجدلهم بالتي هي احسن ان ربك هو اعلم بمن ضل عن سبيله وهو اعلم بالمهتدين",
  },
  {
    verseId: 125,
    name: "النحل",
    surahId: 16,
    text: "وَإِنۡ عَاقَبۡتُمۡ فَعَاقِبُواْ بِمِثۡلِ مَا عُوقِبۡتُم بِهِۦۖ وَلَئِن صَبَرۡتُمۡ لَهُوَ خَيۡرٞ لِّلصَّـٰبِرِينَ",
    translation:
      "And if you punish [an enemy, O believers], punish with an equivalent of that with which you were harmed. But if you are patient - it is better for those who are patient",
    normalizedText:
      "وان عاقبتم فعاقبوا بمثل ما عوقبتم به ولان صبرتم لهو خير للصبرين",
  },
  {
    verseId: 126,
    name: "النحل",
    surahId: 16,
    text: "وَٱصۡبِرۡ وَمَا صَبۡرُكَ إِلَّا بِٱللَّهِۚ وَلَا تَحۡزَنۡ عَلَيۡهِمۡ وَلَا تَكُ فِي ضَيۡقٖ مِّمَّا يَمۡكُرُونَ",
    translation:
      "And be patient, [O Muhammad], and your patience is not but through Allah. And do not grieve over them and do not be in distress over what they conspire",
    normalizedText:
      "واصبر وما صبرك الا بالله ولا تحزن عليهم ولا تك في ضيق مما يمكرون",
  },
  {
    verseId: 127,
    name: "النحل",
    surahId: 16,
    text: "إِنَّ ٱللَّهَ مَعَ ٱلَّذِينَ ٱتَّقَواْ وَّٱلَّذِينَ هُم مُّحۡسِنُونَ",
    translation:
      "Indeed, Allah is with those who fear Him and those who are doers of good",
    normalizedText: "ان الله مع الذين اتقوا والذين هم محسنون",
  },
  {
    verseId: 0,
    name: "الإسراء",
    surahId: 17,
    text: "سُبۡحَٰنَ ٱلَّذِيٓ أَسۡرَىٰ بِعَبۡدِهِۦ لَيۡلٗا مِّنَ ٱلۡمَسۡجِدِ ٱلۡحَرَامِ إِلَى ٱلۡمَسۡجِدِ ٱلۡأَقۡصَا ٱلَّذِي بَٰرَكۡنَا حَوۡلَهُۥ لِنُرِيَهُۥ مِنۡ ءَايَٰتِنَآۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلۡبَصِيرُ",
    translation:
      "Exalted is He who took His Servant by night from al-Masjid al-Haram to al-Masjid al-Aqsa, whose surroundings We have blessed, to show him of Our signs. Indeed, He is the Hearing, the Seeing",
    normalizedText:
      "سبحن الذي اسرى بعبده ليلا من المسجد الحرام الى المسجد الاقصا الذي بركنا حوله لنريه من ءايتنا انه هو السميع البصير",
  },
  {
    verseId: 1,
    name: "الإسراء",
    surahId: 17,
    text: "وَءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ وَجَعَلۡنَٰهُ هُدٗى لِّبَنِيٓ إِسۡرَـٰٓءِيلَ أَلَّا تَتَّخِذُواْ مِن دُونِي وَكِيلٗا",
    translation:
      "And We gave Moses the Scripture and made it a guidance for the Children of Israel that you not take other than Me as Disposer of affairs",
    normalizedText:
      "وءاتينا موسى الكتب وجعلنه هدى لبني اسرءيل الا تتخذوا من دوني وكيلا",
  },
  {
    verseId: 2,
    name: "الإسراء",
    surahId: 17,
    text: "ذُرِّيَّةَ مَنۡ حَمَلۡنَا مَعَ نُوحٍۚ إِنَّهُۥ كَانَ عَبۡدٗا شَكُورٗا",
    translation:
      "O descendants of those We carried [in the ship] with Noah. Indeed, he was a grateful servant",
    normalizedText: "ذرية من حملنا مع نوح انه كان عبدا شكورا",
  },
  {
    verseId: 3,
    name: "الإسراء",
    surahId: 17,
    text: "وَقَضَيۡنَآ إِلَىٰ بَنِيٓ إِسۡرَـٰٓءِيلَ فِي ٱلۡكِتَٰبِ لَتُفۡسِدُنَّ فِي ٱلۡأَرۡضِ مَرَّتَيۡنِ وَلَتَعۡلُنَّ عُلُوّٗا كَبِيرٗا",
    translation:
      'And We conveyed to the Children of Israel in the Scripture that, "You will surely cause corruption on the earth twice, and you will surely reach [a degree of] great haughtiness',
    normalizedText:
      "وقضينا الى بني اسرءيل في الكتب لتفسدن في الارض مرتين ولتعلن علوا كبيرا",
  },
  {
    verseId: 4,
    name: "الإسراء",
    surahId: 17,
    text: "فَإِذَا جَآءَ وَعۡدُ أُولَىٰهُمَا بَعَثۡنَا عَلَيۡكُمۡ عِبَادٗا لَّنَآ أُوْلِي بَأۡسٖ شَدِيدٖ فَجَاسُواْ خِلَٰلَ ٱلدِّيَارِۚ وَكَانَ وَعۡدٗا مَّفۡعُولٗا",
    translation:
      "So when the [time of] promise came for the first of them, We sent against you servants of Ours - those of great military might, and they probed [even] into the homes, and it was a promise fulfilled",
    normalizedText:
      "فاذا جاء وعد اولىهما بعثنا عليكم عبادا لنا اولي باس شديد فجاسوا خلل الديار وكان وعدا مفعولا",
  },
  {
    verseId: 5,
    name: "الإسراء",
    surahId: 17,
    text: "ثُمَّ رَدَدۡنَا لَكُمُ ٱلۡكَرَّةَ عَلَيۡهِمۡ وَأَمۡدَدۡنَٰكُم بِأَمۡوَٰلٖ وَبَنِينَ وَجَعَلۡنَٰكُمۡ أَكۡثَرَ نَفِيرًا",
    translation:
      "Then We gave back to you a return victory over them. And We reinforced you with wealth and sons and made you more numerous in manpower",
    normalizedText:
      "ثم رددنا لكم الكرة عليهم وامددنكم بامول وبنين وجعلنكم اكثر نفيرا",
  },
  {
    verseId: 6,
    name: "الإسراء",
    surahId: 17,
    text: "إِنۡ أَحۡسَنتُمۡ أَحۡسَنتُمۡ لِأَنفُسِكُمۡۖ وَإِنۡ أَسَأۡتُمۡ فَلَهَاۚ فَإِذَا جَآءَ وَعۡدُ ٱلۡأٓخِرَةِ لِيَسُـُٔواْ وُجُوهَكُمۡ وَلِيَدۡخُلُواْ ٱلۡمَسۡجِدَ كَمَا دَخَلُوهُ أَوَّلَ مَرَّةٖ وَلِيُتَبِّرُواْ مَا عَلَوۡاْ تَتۡبِيرًا",
    translation:
      '[And said], "If you do good, you do good for yourselves; and if you do evil, [you do it] to yourselves." Then when the final promise came, [We sent your enemies] to sadden your faces and to enter the temple in Jerusalem, as they entered it the first time, and to destroy what they had taken over with [total] destruction',
    normalizedText:
      "ان احسنتم احسنتم لانفسكم وان اساتم فلها فاذا جاء وعد الاخرة ليسوا وجوهكم وليدخلوا المسجد كما دخلوه اول مرة وليتبروا ما علوا تتبيرا",
  },
  {
    verseId: 7,
    name: "الإسراء",
    surahId: 17,
    text: "عَسَىٰ رَبُّكُمۡ أَن يَرۡحَمَكُمۡۚ وَإِنۡ عُدتُّمۡ عُدۡنَاۚ وَجَعَلۡنَا جَهَنَّمَ لِلۡكَٰفِرِينَ حَصِيرًا",
    translation:
      '[Then Allah said], "It is expected, [if you repent], that your Lord will have mercy upon you. But if you return [to sin], We will return [to punishment]. And We have made Hell, for the disbelievers, a prison-bed',
    normalizedText:
      "عسى ربكم ان يرحمكم وان عدتم عدنا وجعلنا جهنم للكفرين حصيرا",
  },
  {
    verseId: 8,
    name: "الإسراء",
    surahId: 17,
    text: "إِنَّ هَٰذَا ٱلۡقُرۡءَانَ يَهۡدِي لِلَّتِي هِيَ أَقۡوَمُ وَيُبَشِّرُ ٱلۡمُؤۡمِنِينَ ٱلَّذِينَ يَعۡمَلُونَ ٱلصَّـٰلِحَٰتِ أَنَّ لَهُمۡ أَجۡرٗا كَبِيرٗا",
    translation:
      "Indeed, this Qur'an guides to that which is most suitable and gives good tidings to the believers who do righteous deeds that they will have a great reward",
    normalizedText:
      "ان هذا القرءان يهدي للتي هي اقوم ويبشر المامنين الذين يعملون الصلحت ان لهم اجرا كبيرا",
  },
  {
    verseId: 9,
    name: "الإسراء",
    surahId: 17,
    text: "وَأَنَّ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ أَعۡتَدۡنَا لَهُمۡ عَذَابًا أَلِيمٗا",
    translation:
      "And that those who do not believe in the Hereafter - We have prepared for them a painful punishment",
    normalizedText: "وان الذين لا يامنون بالاخرة اعتدنا لهم عذابا اليما",
  },
  {
    verseId: 10,
    name: "الإسراء",
    surahId: 17,
    text: "وَيَدۡعُ ٱلۡإِنسَٰنُ بِٱلشَّرِّ دُعَآءَهُۥ بِٱلۡخَيۡرِۖ وَكَانَ ٱلۡإِنسَٰنُ عَجُولٗا",
    translation:
      "And man supplicates for evil as he supplicates for good, and man is ever hasty",
    normalizedText: "ويدع الانسن بالشر دعاءه بالخير وكان الانسن عجولا",
  },
  {
    verseId: 11,
    name: "الإسراء",
    surahId: 17,
    text: "وَجَعَلۡنَا ٱلَّيۡلَ وَٱلنَّهَارَ ءَايَتَيۡنِۖ فَمَحَوۡنَآ ءَايَةَ ٱلَّيۡلِ وَجَعَلۡنَآ ءَايَةَ ٱلنَّهَارِ مُبۡصِرَةٗ لِّتَبۡتَغُواْ فَضۡلٗا مِّن رَّبِّكُمۡ وَلِتَعۡلَمُواْ عَدَدَ ٱلسِّنِينَ وَٱلۡحِسَابَۚ وَكُلَّ شَيۡءٖ فَصَّلۡنَٰهُ تَفۡصِيلٗا",
    translation:
      "And We have made the night and day two signs, and We erased the sign of the night and made the sign of the day visible that you may seek bounty from your Lord and may know the number of years and the account [of time]. And everything We have set out in detail",
    normalizedText:
      "وجعلنا اليل والنهار ءايتين فمحونا ءاية اليل وجعلنا ءاية النهار مبصرة لتبتغوا فضلا من ربكم ولتعلموا عدد السنين والحساب وكل شيء فصلنه تفصيلا",
  },
  {
    verseId: 12,
    name: "الإسراء",
    surahId: 17,
    text: "وَكُلَّ إِنسَٰنٍ أَلۡزَمۡنَٰهُ طَـٰٓئِرَهُۥ فِي عُنُقِهِۦۖ وَنُخۡرِجُ لَهُۥ يَوۡمَ ٱلۡقِيَٰمَةِ كِتَٰبٗا يَلۡقَىٰهُ مَنشُورًا",
    translation:
      "And [for] every person We have imposed his fate upon his neck, and We will produce for him on the Day of Resurrection a record which he will encounter spread open",
    normalizedText:
      "وكل انسن الزمنه طاره في عنقه ونخرج له يوم القيمة كتبا يلقىه منشورا",
  },
  {
    verseId: 13,
    name: "الإسراء",
    surahId: 17,
    text: "ٱقۡرَأۡ كِتَٰبَكَ كَفَىٰ بِنَفۡسِكَ ٱلۡيَوۡمَ عَلَيۡكَ حَسِيبٗا",
    translation:
      '[It will be said], "Read your record. Sufficient is yourself against you this Day as accountant',
    normalizedText: "اقرا كتبك كفى بنفسك اليوم عليك حسيبا",
  },
  {
    verseId: 14,
    name: "الإسراء",
    surahId: 17,
    text: "مَّنِ ٱهۡتَدَىٰ فَإِنَّمَا يَهۡتَدِي لِنَفۡسِهِۦۖ وَمَن ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيۡهَاۚ وَلَا تَزِرُ وَازِرَةٞ وِزۡرَ أُخۡرَىٰۗ وَمَا كُنَّا مُعَذِّبِينَ حَتَّىٰ نَبۡعَثَ رَسُولٗا",
    translation:
      "Whoever is guided is only guided for [the benefit of] his soul. And whoever errs only errs against it. And no bearer of burdens will bear the burden of another. And never would We punish until We sent a messenger",
    normalizedText:
      "من اهتدى فانما يهتدي لنفسه ومن ضل فانما يضل عليها ولا تزر وازرة وزر اخرى وما كنا معذبين حتى نبعث رسولا",
  },
  {
    verseId: 15,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِذَآ أَرَدۡنَآ أَن نُّهۡلِكَ قَرۡيَةً أَمَرۡنَا مُتۡرَفِيهَا فَفَسَقُواْ فِيهَا فَحَقَّ عَلَيۡهَا ٱلۡقَوۡلُ فَدَمَّرۡنَٰهَا تَدۡمِيرٗا",
    translation:
      "And when We intend to destroy a city, We command its affluent but they defiantly disobey therein; so the word comes into effect upon it, and We destroy it with [complete] destruction",
    normalizedText:
      "واذا اردنا ان نهلك قرية امرنا مترفيها ففسقوا فيها فحق عليها القول فدمرنها تدميرا",
  },
  {
    verseId: 16,
    name: "الإسراء",
    surahId: 17,
    text: "وَكَمۡ أَهۡلَكۡنَا مِنَ ٱلۡقُرُونِ مِنۢ بَعۡدِ نُوحٖۗ وَكَفَىٰ بِرَبِّكَ بِذُنُوبِ عِبَادِهِۦ خَبِيرَۢا بَصِيرٗا",
    translation:
      "And how many have We destroyed from the generations after Noah. And sufficient is your Lord, concerning the sins of His servants, as Acquainted and Seeing",
    normalizedText:
      "وكم اهلكنا من القرون من بعد نوح وكفى بربك بذنوب عباده خبيرا بصيرا",
  },
  {
    verseId: 17,
    name: "الإسراء",
    surahId: 17,
    text: "مَّن كَانَ يُرِيدُ ٱلۡعَاجِلَةَ عَجَّلۡنَا لَهُۥ فِيهَا مَا نَشَآءُ لِمَن نُّرِيدُ ثُمَّ جَعَلۡنَا لَهُۥ جَهَنَّمَ يَصۡلَىٰهَا مَذۡمُومٗا مَّدۡحُورٗا",
    translation:
      "Whoever should desire the immediate - We hasten for him from it what We will to whom We intend. Then We have made for him Hell, which he will [enter to] burn, censured and banished",
    normalizedText:
      "من كان يريد العاجلة عجلنا له فيها ما نشاء لمن نريد ثم جعلنا له جهنم يصلىها مذموما مدحورا",
  },
  {
    verseId: 18,
    name: "الإسراء",
    surahId: 17,
    text: "وَمَنۡ أَرَادَ ٱلۡأٓخِرَةَ وَسَعَىٰ لَهَا سَعۡيَهَا وَهُوَ مُؤۡمِنٞ فَأُوْلَـٰٓئِكَ كَانَ سَعۡيُهُم مَّشۡكُورٗا",
    translation:
      "But whoever desires the Hereafter and exerts the effort due to it while he is a believer - it is those whose effort is ever appreciated [by Allah]",
    normalizedText:
      "ومن اراد الاخرة وسعى لها سعيها وهو مامن فاولاك كان سعيهم مشكورا",
  },
  {
    verseId: 19,
    name: "الإسراء",
    surahId: 17,
    text: "كُلّٗا نُّمِدُّ هَـٰٓؤُلَآءِ وَهَـٰٓؤُلَآءِ مِنۡ عَطَآءِ رَبِّكَۚ وَمَا كَانَ عَطَآءُ رَبِّكَ مَحۡظُورًا",
    translation:
      "To each [category] We extend - to these and to those - from the gift of your Lord. And never has the gift of your Lord been restricted",
    normalizedText: "كلا نمد هالاء وهالاء من عطاء ربك وما كان عطاء ربك محظورا",
  },
  {
    verseId: 20,
    name: "الإسراء",
    surahId: 17,
    text: "ٱنظُرۡ كَيۡفَ فَضَّلۡنَا بَعۡضَهُمۡ عَلَىٰ بَعۡضٖۚ وَلَلۡأٓخِرَةُ أَكۡبَرُ دَرَجَٰتٖ وَأَكۡبَرُ تَفۡضِيلٗا",
    translation:
      "Look how We have favored [in provision] some of them over others. But the Hereafter is greater in degrees [of difference] and greater in distinction",
    normalizedText:
      "انظر كيف فضلنا بعضهم على بعض وللاخرة اكبر درجت واكبر تفضيلا",
  },
  {
    verseId: 21,
    name: "الإسراء",
    surahId: 17,
    text: "لَّا تَجۡعَلۡ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَتَقۡعُدَ مَذۡمُومٗا مَّخۡذُولٗا",
    translation:
      "Do not make [as equal] with Allah another deity and [thereby] become censured and forsaken",
    normalizedText: "لا تجعل مع الله الها ءاخر فتقعد مذموما مخذولا",
  },
  {
    verseId: 22,
    name: "الإسراء",
    surahId: 17,
    text: "۞وَقَضَىٰ رَبُّكَ أَلَّا تَعۡبُدُوٓاْ إِلَّآ إِيَّاهُ وَبِٱلۡوَٰلِدَيۡنِ إِحۡسَٰنًاۚ إِمَّا يَبۡلُغَنَّ عِندَكَ ٱلۡكِبَرَ أَحَدُهُمَآ أَوۡ كِلَاهُمَا فَلَا تَقُل لَّهُمَآ أُفّٖ وَلَا تَنۡهَرۡهُمَا وَقُل لَّهُمَا قَوۡلٗا كَرِيمٗا",
    translation:
      'And your Lord has decreed that you not worship except Him, and to parents, good treatment. Whether one or both of them reach old age [while] with you, say not to them [so much as], "uff," and do not repel them but speak to them a noble word',
    normalizedText:
      "۞وقضى ربك الا تعبدوا الا اياه وبالولدين احسنا اما يبلغن عندك الكبر احدهما او كلاهما فلا تقل لهما اف ولا تنهرهما وقل لهما قولا كريما",
  },
  {
    verseId: 23,
    name: "الإسراء",
    surahId: 17,
    text: "وَٱخۡفِضۡ لَهُمَا جَنَاحَ ٱلذُّلِّ مِنَ ٱلرَّحۡمَةِ وَقُل رَّبِّ ٱرۡحَمۡهُمَا كَمَا رَبَّيَانِي صَغِيرٗا",
    translation:
      'And lower to them the wing of humility out of mercy and say, "My Lord, have mercy upon them as they brought me up [when I was] small',
    normalizedText:
      "واخفض لهما جناح الذل من الرحمة وقل رب ارحمهما كما ربياني صغيرا",
  },
  {
    verseId: 24,
    name: "الإسراء",
    surahId: 17,
    text: "رَّبُّكُمۡ أَعۡلَمُ بِمَا فِي نُفُوسِكُمۡۚ إِن تَكُونُواْ صَٰلِحِينَ فَإِنَّهُۥ كَانَ لِلۡأَوَّـٰبِينَ غَفُورٗا",
    translation:
      "Your Lord is most knowing of what is within yourselves. If you should be righteous [in intention] - then indeed He is ever, to the often returning [to Him], Forgiving",
    normalizedText:
      "ربكم اعلم بما في نفوسكم ان تكونوا صلحين فانه كان للاوبين غفورا",
  },
  {
    verseId: 25,
    name: "الإسراء",
    surahId: 17,
    text: "وَءَاتِ ذَا ٱلۡقُرۡبَىٰ حَقَّهُۥ وَٱلۡمِسۡكِينَ وَٱبۡنَ ٱلسَّبِيلِ وَلَا تُبَذِّرۡ تَبۡذِيرًا",
    translation:
      "And give the relative his right, and [also] the poor and the traveler, and do not spend wastefully",
    normalizedText: "وءات ذا القربى حقه والمسكين وابن السبيل ولا تبذر تبذيرا",
  },
  {
    verseId: 26,
    name: "الإسراء",
    surahId: 17,
    text: "إِنَّ ٱلۡمُبَذِّرِينَ كَانُوٓاْ إِخۡوَٰنَ ٱلشَّيَٰطِينِۖ وَكَانَ ٱلشَّيۡطَٰنُ لِرَبِّهِۦ كَفُورٗا",
    translation:
      "Indeed, the wasteful are brothers of the devils, and ever has Satan been to his Lord ungrateful",
    normalizedText: "ان المبذرين كانوا اخون الشيطين وكان الشيطن لربه كفورا",
  },
  {
    verseId: 27,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِمَّا تُعۡرِضَنَّ عَنۡهُمُ ٱبۡتِغَآءَ رَحۡمَةٖ مِّن رَّبِّكَ تَرۡجُوهَا فَقُل لَّهُمۡ قَوۡلٗا مَّيۡسُورٗا",
    translation:
      "And if you [must] turn away from the needy awaiting mercy from your Lord which you expect, then speak to them a gentle word",
    normalizedText:
      "واما تعرضن عنهم ابتغاء رحمة من ربك ترجوها فقل لهم قولا ميسورا",
  },
  {
    verseId: 28,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَا تَجۡعَلۡ يَدَكَ مَغۡلُولَةً إِلَىٰ عُنُقِكَ وَلَا تَبۡسُطۡهَا كُلَّ ٱلۡبَسۡطِ فَتَقۡعُدَ مَلُومٗا مَّحۡسُورًا",
    translation:
      "And do not make your hand [as] chained to your neck or extend it completely and [thereby] become blamed and insolvent",
    normalizedText:
      "ولا تجعل يدك مغلولة الى عنقك ولا تبسطها كل البسط فتقعد ملوما محسورا",
  },
  {
    verseId: 29,
    name: "الإسراء",
    surahId: 17,
    text: "إِنَّ رَبَّكَ يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ وَيَقۡدِرُۚ إِنَّهُۥ كَانَ بِعِبَادِهِۦ خَبِيرَۢا بَصِيرٗا",
    translation:
      "Indeed, your Lord extends provision for whom He wills and restricts [it]. Indeed He is ever, concerning His servants, Acquainted and Seeing",
    normalizedText:
      "ان ربك يبسط الرزق لمن يشاء ويقدر انه كان بعباده خبيرا بصيرا",
  },
  {
    verseId: 30,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَا تَقۡتُلُوٓاْ أَوۡلَٰدَكُمۡ خَشۡيَةَ إِمۡلَٰقٖۖ نَّحۡنُ نَرۡزُقُهُمۡ وَإِيَّاكُمۡۚ إِنَّ قَتۡلَهُمۡ كَانَ خِطۡـٔٗا كَبِيرٗا",
    translation:
      "And do not kill your children for fear of poverty. We provide for them and for you. Indeed, their killing is ever a great sin",
    normalizedText:
      "ولا تقتلوا اولدكم خشية املق نحن نرزقهم واياكم ان قتلهم كان خطا كبيرا",
  },
  {
    verseId: 31,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَا تَقۡرَبُواْ ٱلزِّنَىٰٓۖ إِنَّهُۥ كَانَ فَٰحِشَةٗ وَسَآءَ سَبِيلٗا",
    translation:
      "And do not approach unlawful sexual intercourse. Indeed, it is ever an immorality and is evil as a way",
    normalizedText: "ولا تقربوا الزنى انه كان فحشة وساء سبيلا",
  },
  {
    verseId: 32,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَا تَقۡتُلُواْ ٱلنَّفۡسَ ٱلَّتِي حَرَّمَ ٱللَّهُ إِلَّا بِٱلۡحَقِّۗ وَمَن قُتِلَ مَظۡلُومٗا فَقَدۡ جَعَلۡنَا لِوَلِيِّهِۦ سُلۡطَٰنٗا فَلَا يُسۡرِف فِّي ٱلۡقَتۡلِۖ إِنَّهُۥ كَانَ مَنصُورٗا",
    translation:
      "And do not kill the soul which Allah has forbidden, except by right. And whoever is killed unjustly - We have given his heir authority, but let him not exceed limits in [the matter of] taking life. Indeed, he has been supported [by the law]",
    normalizedText:
      "ولا تقتلوا النفس التي حرم الله الا بالحق ومن قتل مظلوما فقد جعلنا لوليه سلطنا فلا يسرف في القتل انه كان منصورا",
  },
  {
    verseId: 33,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَا تَقۡرَبُواْ مَالَ ٱلۡيَتِيمِ إِلَّا بِٱلَّتِي هِيَ أَحۡسَنُ حَتَّىٰ يَبۡلُغَ أَشُدَّهُۥۚ وَأَوۡفُواْ بِٱلۡعَهۡدِۖ إِنَّ ٱلۡعَهۡدَ كَانَ مَسۡـُٔولٗا",
    translation:
      "And do not approach the property of an orphan, except in the way that is best, until he reaches maturity. And fulfill [every] commitment. Indeed, the commitment is ever [that about which one will be] questioned",
    normalizedText:
      "ولا تقربوا مال اليتيم الا بالتي هي احسن حتى يبلغ اشده واوفوا بالعهد ان العهد كان مسولا",
  },
  {
    verseId: 34,
    name: "الإسراء",
    surahId: 17,
    text: "وَأَوۡفُواْ ٱلۡكَيۡلَ إِذَا كِلۡتُمۡ وَزِنُواْ بِٱلۡقِسۡطَاسِ ٱلۡمُسۡتَقِيمِۚ ذَٰلِكَ خَيۡرٞ وَأَحۡسَنُ تَأۡوِيلٗا",
    translation:
      "And give full measure when you measure, and weigh with an even balance. That is the best [way] and best in result",
    normalizedText:
      "واوفوا الكيل اذا كلتم وزنوا بالقسطاس المستقيم ذلك خير واحسن تاويلا",
  },
  {
    verseId: 35,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَا تَقۡفُ مَا لَيۡسَ لَكَ بِهِۦ عِلۡمٌۚ إِنَّ ٱلسَّمۡعَ وَٱلۡبَصَرَ وَٱلۡفُؤَادَ كُلُّ أُوْلَـٰٓئِكَ كَانَ عَنۡهُ مَسۡـُٔولٗا",
    translation:
      "And do not pursue that of which you have no knowledge. Indeed, the hearing, the sight and the heart - about all those [one] will be questioned",
    normalizedText:
      "ولا تقف ما ليس لك به علم ان السمع والبصر والفااد كل اولاك كان عنه مسولا",
  },
  {
    verseId: 36,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَا تَمۡشِ فِي ٱلۡأَرۡضِ مَرَحًاۖ إِنَّكَ لَن تَخۡرِقَ ٱلۡأَرۡضَ وَلَن تَبۡلُغَ ٱلۡجِبَالَ طُولٗا",
    translation:
      "And do not walk upon the earth exultantly. Indeed, you will never tear the earth [apart], and you will never reach the mountains in height",
    normalizedText:
      "ولا تمش في الارض مرحا انك لن تخرق الارض ولن تبلغ الجبال طولا",
  },
  {
    verseId: 37,
    name: "الإسراء",
    surahId: 17,
    text: "كُلُّ ذَٰلِكَ كَانَ سَيِّئُهُۥ عِندَ رَبِّكَ مَكۡرُوهٗا",
    translation:
      "All that - its evil is ever, in the sight of your Lord, detested",
    normalizedText: "كل ذلك كان سياه عند ربك مكروها",
  },
  {
    verseId: 38,
    name: "الإسراء",
    surahId: 17,
    text: "ذَٰلِكَ مِمَّآ أَوۡحَىٰٓ إِلَيۡكَ رَبُّكَ مِنَ ٱلۡحِكۡمَةِۗ وَلَا تَجۡعَلۡ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَتُلۡقَىٰ فِي جَهَنَّمَ مَلُومٗا مَّدۡحُورًا",
    translation:
      "That is from what your Lord has revealed to you, [O Muhammad], of wisdom. And, [O mankind], do not make [as equal] with Allah another deity, lest you be thrown into Hell, blamed and banished",
    normalizedText:
      "ذلك مما اوحى اليك ربك من الحكمة ولا تجعل مع الله الها ءاخر فتلقى في جهنم ملوما مدحورا",
  },
  {
    verseId: 39,
    name: "الإسراء",
    surahId: 17,
    text: "أَفَأَصۡفَىٰكُمۡ رَبُّكُم بِٱلۡبَنِينَ وَٱتَّخَذَ مِنَ ٱلۡمَلَـٰٓئِكَةِ إِنَٰثًاۚ إِنَّكُمۡ لَتَقُولُونَ قَوۡلًا عَظِيمٗا",
    translation:
      "Then, has your Lord chosen you for [having] sons and taken from among the angels daughters? Indeed, you say a grave saying",
    normalizedText:
      "افاصفىكم ربكم بالبنين واتخذ من الملاكة انثا انكم لتقولون قولا عظيما",
  },
  {
    verseId: 40,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَقَدۡ صَرَّفۡنَا فِي هَٰذَا ٱلۡقُرۡءَانِ لِيَذَّكَّرُواْ وَمَا يَزِيدُهُمۡ إِلَّا نُفُورٗا",
    translation:
      "And We have certainly diversified [the contents] in this Qur'an that mankind may be reminded, but it does not increase the disbelievers except in aversion",
    normalizedText: "ولقد صرفنا في هذا القرءان ليذكروا وما يزيدهم الا نفورا",
  },
  {
    verseId: 41,
    name: "الإسراء",
    surahId: 17,
    text: "قُل لَّوۡ كَانَ مَعَهُۥٓ ءَالِهَةٞ كَمَا يَقُولُونَ إِذٗا لَّٱبۡتَغَوۡاْ إِلَىٰ ذِي ٱلۡعَرۡشِ سَبِيلٗا",
    translation:
      'Say, [O Muhammad], "If there had been with Him [other] gods, as they say, then they [each] would have sought to the Owner of the Throne a way',
    normalizedText:
      "قل لو كان معه ءالهة كما يقولون اذا لابتغوا الى ذي العرش سبيلا",
  },
  {
    verseId: 42,
    name: "الإسراء",
    surahId: 17,
    text: "سُبۡحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يَقُولُونَ عُلُوّٗا كَبِيرٗا",
    translation:
      "Exalted is He and high above what they say by great sublimity",
    normalizedText: "سبحنه وتعلى عما يقولون علوا كبيرا",
  },
  {
    verseId: 43,
    name: "الإسراء",
    surahId: 17,
    text: "تُسَبِّحُ لَهُ ٱلسَّمَٰوَٰتُ ٱلسَّبۡعُ وَٱلۡأَرۡضُ وَمَن فِيهِنَّۚ وَإِن مِّن شَيۡءٍ إِلَّا يُسَبِّحُ بِحَمۡدِهِۦ وَلَٰكِن لَّا تَفۡقَهُونَ تَسۡبِيحَهُمۡۚ إِنَّهُۥ كَانَ حَلِيمًا غَفُورٗا",
    translation:
      "The seven heavens and the earth and whatever is in them exalt Him. And there is not a thing except that it exalts [Allah] by His praise, but you do not understand their [way of] exalting. Indeed, He is ever Forbearing and Forgiving",
    normalizedText:
      "تسبح له السموت السبع والارض ومن فيهن وان من شيء الا يسبح بحمده ولكن لا تفقهون تسبيحهم انه كان حليما غفورا",
  },
  {
    verseId: 44,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِذَا قَرَأۡتَ ٱلۡقُرۡءَانَ جَعَلۡنَا بَيۡنَكَ وَبَيۡنَ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ حِجَابٗا مَّسۡتُورٗا",
    translation:
      "And when you recite the Qur'an, We put between you and those who do not believe in the Hereafter a concealed partition",
    normalizedText:
      "واذا قرات القرءان جعلنا بينك وبين الذين لا يامنون بالاخرة حجابا مستورا",
  },
  {
    verseId: 45,
    name: "الإسراء",
    surahId: 17,
    text: "وَجَعَلۡنَا عَلَىٰ قُلُوبِهِمۡ أَكِنَّةً أَن يَفۡقَهُوهُ وَفِيٓ ءَاذَانِهِمۡ وَقۡرٗاۚ وَإِذَا ذَكَرۡتَ رَبَّكَ فِي ٱلۡقُرۡءَانِ وَحۡدَهُۥ وَلَّوۡاْ عَلَىٰٓ أَدۡبَٰرِهِمۡ نُفُورٗا",
    translation:
      "And We have placed over their hearts coverings, lest they understand it, and in their ears deafness. And when you mention your Lord alone in the Qur'an, they turn back in aversion",
    normalizedText:
      "وجعلنا على قلوبهم اكنة ان يفقهوه وفي ءاذانهم وقرا واذا ذكرت ربك في القرءان وحده ولوا على ادبرهم نفورا",
  },
  {
    verseId: 46,
    name: "الإسراء",
    surahId: 17,
    text: "نَّحۡنُ أَعۡلَمُ بِمَا يَسۡتَمِعُونَ بِهِۦٓ إِذۡ يَسۡتَمِعُونَ إِلَيۡكَ وَإِذۡ هُمۡ نَجۡوَىٰٓ إِذۡ يَقُولُ ٱلظَّـٰلِمُونَ إِن تَتَّبِعُونَ إِلَّا رَجُلٗا مَّسۡحُورًا",
    translation:
      'We are most knowing of how they listen to it when they listen to you and [of] when they are in private conversation, when the wrongdoers say, "You follow not but a man affected by magic',
    normalizedText:
      "نحن اعلم بما يستمعون به اذ يستمعون اليك واذ هم نجوى اذ يقول الظلمون ان تتبعون الا رجلا مسحورا",
  },
  {
    verseId: 47,
    name: "الإسراء",
    surahId: 17,
    text: "ٱنظُرۡ كَيۡفَ ضَرَبُواْ لَكَ ٱلۡأَمۡثَالَ فَضَلُّواْ فَلَا يَسۡتَطِيعُونَ سَبِيلٗا",
    translation:
      "Look how they strike for you comparisons; but they have strayed, so they cannot [find] a way",
    normalizedText: "انظر كيف ضربوا لك الامثال فضلوا فلا يستطيعون سبيلا",
  },
  {
    verseId: 48,
    name: "الإسراء",
    surahId: 17,
    text: "وَقَالُوٓاْ أَءِذَا كُنَّا عِظَٰمٗا وَرُفَٰتًا أَءِنَّا لَمَبۡعُوثُونَ خَلۡقٗا جَدِيدٗا",
    translation:
      'And they say, "When we are bones and crumbled particles, will we [truly] be resurrected as a new creation',
    normalizedText: "وقالوا اءذا كنا عظما ورفتا اءنا لمبعوثون خلقا جديدا",
  },
  {
    verseId: 49,
    name: "الإسراء",
    surahId: 17,
    text: "۞قُلۡ كُونُواْ حِجَارَةً أَوۡ حَدِيدًا",
    translation: 'Say, "Be you stones or iron',
    normalizedText: "۞قل كونوا حجارة او حديدا",
  },
  {
    verseId: 50,
    name: "الإسراء",
    surahId: 17,
    text: "أَوۡ خَلۡقٗا مِّمَّا يَكۡبُرُ فِي صُدُورِكُمۡۚ فَسَيَقُولُونَ مَن يُعِيدُنَاۖ قُلِ ٱلَّذِي فَطَرَكُمۡ أَوَّلَ مَرَّةٖۚ فَسَيُنۡغِضُونَ إِلَيۡكَ رُءُوسَهُمۡ وَيَقُولُونَ مَتَىٰ هُوَۖ قُلۡ عَسَىٰٓ أَن يَكُونَ قَرِيبٗا",
    translation:
      'Or [any] creation of that which is great within your breasts." And they will say, "Who will restore us?" Say, "He who brought you forth the first time." Then they will nod their heads toward you and say, "When is that?" Say, "Perhaps it will be soon',
    normalizedText:
      "او خلقا مما يكبر في صدوركم فسيقولون من يعيدنا قل الذي فطركم اول مرة فسينغضون اليك رءوسهم ويقولون متى هو قل عسى ان يكون قريبا",
  },
  {
    verseId: 51,
    name: "الإسراء",
    surahId: 17,
    text: "يَوۡمَ يَدۡعُوكُمۡ فَتَسۡتَجِيبُونَ بِحَمۡدِهِۦ وَتَظُنُّونَ إِن لَّبِثۡتُمۡ إِلَّا قَلِيلٗا",
    translation:
      "On the Day He will call you and you will respond with praise of Him and think that you had not remained [in the world] except for a little",
    normalizedText: "يوم يدعوكم فتستجيبون بحمده وتظنون ان لبثتم الا قليلا",
  },
  {
    verseId: 52,
    name: "الإسراء",
    surahId: 17,
    text: "وَقُل لِّعِبَادِي يَقُولُواْ ٱلَّتِي هِيَ أَحۡسَنُۚ إِنَّ ٱلشَّيۡطَٰنَ يَنزَغُ بَيۡنَهُمۡۚ إِنَّ ٱلشَّيۡطَٰنَ كَانَ لِلۡإِنسَٰنِ عَدُوّٗا مُّبِينٗا",
    translation:
      "And tell My servants to say that which is best. Indeed, Satan induces [dissension] among them. Indeed Satan is ever, to mankind, a clear enemy",
    normalizedText:
      "وقل لعبادي يقولوا التي هي احسن ان الشيطن ينزغ بينهم ان الشيطن كان للانسن عدوا مبينا",
  },
  {
    verseId: 53,
    name: "الإسراء",
    surahId: 17,
    text: "رَّبُّكُمۡ أَعۡلَمُ بِكُمۡۖ إِن يَشَأۡ يَرۡحَمۡكُمۡ أَوۡ إِن يَشَأۡ يُعَذِّبۡكُمۡۚ وَمَآ أَرۡسَلۡنَٰكَ عَلَيۡهِمۡ وَكِيلٗا",
    translation:
      "Your Lord is most knowing of you. If He wills, He will have mercy upon you; or if He wills, He will punish you. And We have not sent you, [O Muhammad], over them as a manager",
    normalizedText:
      "ربكم اعلم بكم ان يشا يرحمكم او ان يشا يعذبكم وما ارسلنك عليهم وكيلا",
  },
  {
    verseId: 54,
    name: "الإسراء",
    surahId: 17,
    text: "وَرَبُّكَ أَعۡلَمُ بِمَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۗ وَلَقَدۡ فَضَّلۡنَا بَعۡضَ ٱلنَّبِيِّـۧنَ عَلَىٰ بَعۡضٖۖ وَءَاتَيۡنَا دَاوُۥدَ زَبُورٗا",
    translation:
      "And your Lord is most knowing of whoever is in the heavens and the earth. And We have made some of the prophets exceed others [in various ways], and to David We gave the book [of Psalms]",
    normalizedText:
      "وربك اعلم بمن في السموت والارض ولقد فضلنا بعض النبين على بعض وءاتينا داود زبورا",
  },
  {
    verseId: 55,
    name: "الإسراء",
    surahId: 17,
    text: "قُلِ ٱدۡعُواْ ٱلَّذِينَ زَعَمۡتُم مِّن دُونِهِۦ فَلَا يَمۡلِكُونَ كَشۡفَ ٱلضُّرِّ عَنكُمۡ وَلَا تَحۡوِيلًا",
    translation:
      'Say, "Invoke those you have claimed [as gods] besides Him, for they do not possess the [ability for] removal of adversity from you or [for its] transfer [to someone else]',
    normalizedText:
      "قل ادعوا الذين زعمتم من دونه فلا يملكون كشف الضر عنكم ولا تحويلا",
  },
  {
    verseId: 56,
    name: "الإسراء",
    surahId: 17,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ يَدۡعُونَ يَبۡتَغُونَ إِلَىٰ رَبِّهِمُ ٱلۡوَسِيلَةَ أَيُّهُمۡ أَقۡرَبُ وَيَرۡجُونَ رَحۡمَتَهُۥ وَيَخَافُونَ عَذَابَهُۥٓۚ إِنَّ عَذَابَ رَبِّكَ كَانَ مَحۡذُورٗا",
    translation:
      "Those whom they invoke seek means of access to their Lord, [striving as to] which of them would be nearest, and they hope for His mercy and fear His punishment. Indeed, the punishment of your Lord is ever feared",
    normalizedText:
      "اولاك الذين يدعون يبتغون الى ربهم الوسيلة ايهم اقرب ويرجون رحمته ويخافون عذابه ان عذاب ربك كان محذورا",
  },
  {
    verseId: 57,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِن مِّن قَرۡيَةٍ إِلَّا نَحۡنُ مُهۡلِكُوهَا قَبۡلَ يَوۡمِ ٱلۡقِيَٰمَةِ أَوۡ مُعَذِّبُوهَا عَذَابٗا شَدِيدٗاۚ كَانَ ذَٰلِكَ فِي ٱلۡكِتَٰبِ مَسۡطُورٗا",
    translation:
      "And there is no city but that We will destroy it before the Day of Resurrection or punish it with a severe punishment. That has ever been in the Register inscribed",
    normalizedText:
      "وان من قرية الا نحن مهلكوها قبل يوم القيمة او معذبوها عذابا شديدا كان ذلك في الكتب مسطورا",
  },
  {
    verseId: 58,
    name: "الإسراء",
    surahId: 17,
    text: "وَمَا مَنَعَنَآ أَن نُّرۡسِلَ بِٱلۡأٓيَٰتِ إِلَّآ أَن كَذَّبَ بِهَا ٱلۡأَوَّلُونَۚ وَءَاتَيۡنَا ثَمُودَ ٱلنَّاقَةَ مُبۡصِرَةٗ فَظَلَمُواْ بِهَاۚ وَمَا نُرۡسِلُ بِٱلۡأٓيَٰتِ إِلَّا تَخۡوِيفٗا",
    translation:
      "And nothing has prevented Us from sending signs except that the former peoples denied them. And We gave Thamud the she-camel as a visible sign, but they wronged her. And We send not the signs except as a warning",
    normalizedText:
      "وما منعنا ان نرسل بالايت الا ان كذب بها الاولون وءاتينا ثمود الناقة مبصرة فظلموا بها وما نرسل بالايت الا تخويفا",
  },
  {
    verseId: 59,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِذۡ قُلۡنَا لَكَ إِنَّ رَبَّكَ أَحَاطَ بِٱلنَّاسِۚ وَمَا جَعَلۡنَا ٱلرُّءۡيَا ٱلَّتِيٓ أَرَيۡنَٰكَ إِلَّا فِتۡنَةٗ لِّلنَّاسِ وَٱلشَّجَرَةَ ٱلۡمَلۡعُونَةَ فِي ٱلۡقُرۡءَانِۚ وَنُخَوِّفُهُمۡ فَمَا يَزِيدُهُمۡ إِلَّا طُغۡيَٰنٗا كَبِيرٗا",
    translation: `And [remember, O Muhammad], when We told you, "Indeed, your Lord has encompassed the people." And We did not make the sight which We showed you except as a trial for the people, as was the accursed tree [mentioned] in the Qur'an. And We threaten them, but it increases them not except in great transgression`,
    normalizedText:
      "واذ قلنا لك ان ربك احاط بالناس وما جعلنا الرءيا التي ارينك الا فتنة للناس والشجرة الملعونة في القرءان ونخوفهم فما يزيدهم الا طغينا كبيرا",
  },
  {
    verseId: 60,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِذۡ قُلۡنَا لِلۡمَلَـٰٓئِكَةِ ٱسۡجُدُواْ لِأٓدَمَ فَسَجَدُوٓاْ إِلَّآ إِبۡلِيسَ قَالَ ءَأَسۡجُدُ لِمَنۡ خَلَقۡتَ طِينٗا",
    translation:
      'And [mention] when We said to the angles, "Prostrate to Adam," and they prostrated, except for Iblees. He said, "Should I prostrate to one You created from clay',
    normalizedText:
      "واذ قلنا للملاكة اسجدوا لادم فسجدوا الا ابليس قال ءاسجد لمن خلقت طينا",
  },
  {
    verseId: 61,
    name: "الإسراء",
    surahId: 17,
    text: "قَالَ أَرَءَيۡتَكَ هَٰذَا ٱلَّذِي كَرَّمۡتَ عَلَيَّ لَئِنۡ أَخَّرۡتَنِ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ لَأَحۡتَنِكَنَّ ذُرِّيَّتَهُۥٓ إِلَّا قَلِيلٗا",
    translation:
      '[Iblees] said, "Do You see this one whom You have honored above me? If You delay me until the Day of Resurrection, I will surely destroy his descendants, except for a few',
    normalizedText:
      "قال ارءيتك هذا الذي كرمت علي لان اخرتن الى يوم القيمة لاحتنكن ذريته الا قليلا",
  },
  {
    verseId: 62,
    name: "الإسراء",
    surahId: 17,
    text: "قَالَ ٱذۡهَبۡ فَمَن تَبِعَكَ مِنۡهُمۡ فَإِنَّ جَهَنَّمَ جَزَآؤُكُمۡ جَزَآءٗ مَّوۡفُورٗا",
    translation:
      '[Allah] said, "Go, for whoever of them follows you, indeed Hell will be the recompense of you - an ample recompense',
    normalizedText: "قال اذهب فمن تبعك منهم فان جهنم جزااكم جزاء موفورا",
  },
  {
    verseId: 63,
    name: "الإسراء",
    surahId: 17,
    text: "وَٱسۡتَفۡزِزۡ مَنِ ٱسۡتَطَعۡتَ مِنۡهُم بِصَوۡتِكَ وَأَجۡلِبۡ عَلَيۡهِم بِخَيۡلِكَ وَرَجِلِكَ وَشَارِكۡهُمۡ فِي ٱلۡأَمۡوَٰلِ وَٱلۡأَوۡلَٰدِ وَعِدۡهُمۡۚ وَمَا يَعِدُهُمُ ٱلشَّيۡطَٰنُ إِلَّا غُرُورًا",
    translation:
      'And incite [to senselessness] whoever you can among them with your voice and assault them with your horses and foot soldiers and become a partner in their wealth and their children and promise them." But Satan does not promise them except delusion',
    normalizedText:
      "واستفزز من استطعت منهم بصوتك واجلب عليهم بخيلك ورجلك وشاركهم في الامول والاولد وعدهم وما يعدهم الشيطن الا غرورا",
  },
  {
    verseId: 64,
    name: "الإسراء",
    surahId: 17,
    text: "إِنَّ عِبَادِي لَيۡسَ لَكَ عَلَيۡهِمۡ سُلۡطَٰنٞۚ وَكَفَىٰ بِرَبِّكَ وَكِيلٗا",
    translation:
      "Indeed, over My [believing] servants there is for you no authority. And sufficient is your Lord as Disposer of affairs",
    normalizedText: "ان عبادي ليس لك عليهم سلطن وكفى بربك وكيلا",
  },
  {
    verseId: 65,
    name: "الإسراء",
    surahId: 17,
    text: "رَّبُّكُمُ ٱلَّذِي يُزۡجِي لَكُمُ ٱلۡفُلۡكَ فِي ٱلۡبَحۡرِ لِتَبۡتَغُواْ مِن فَضۡلِهِۦٓۚ إِنَّهُۥ كَانَ بِكُمۡ رَحِيمٗا",
    translation:
      "It is your Lord who drives the ship for you through the sea that you may seek of His bounty. Indeed, He is ever, to you, Merciful",
    normalizedText:
      "ربكم الذي يزجي لكم الفلك في البحر لتبتغوا من فضله انه كان بكم رحيما",
  },
  {
    verseId: 66,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِذَا مَسَّكُمُ ٱلضُّرُّ فِي ٱلۡبَحۡرِ ضَلَّ مَن تَدۡعُونَ إِلَّآ إِيَّاهُۖ فَلَمَّا نَجَّىٰكُمۡ إِلَى ٱلۡبَرِّ أَعۡرَضۡتُمۡۚ وَكَانَ ٱلۡإِنسَٰنُ كَفُورًا",
    translation:
      "And when adversity touches you at sea, lost are [all] those you invoke except for Him. But when He delivers you to the land, you turn away [from Him]. And ever is man ungrateful",
    normalizedText:
      "واذا مسكم الضر في البحر ضل من تدعون الا اياه فلما نجىكم الى البر اعرضتم وكان الانسن كفورا",
  },
  {
    verseId: 67,
    name: "الإسراء",
    surahId: 17,
    text: "أَفَأَمِنتُمۡ أَن يَخۡسِفَ بِكُمۡ جَانِبَ ٱلۡبَرِّ أَوۡ يُرۡسِلَ عَلَيۡكُمۡ حَاصِبٗا ثُمَّ لَا تَجِدُواْ لَكُمۡ وَكِيلًا",
    translation:
      "Then do you feel secure that [instead] He will not cause a part of the land to swallow you or send against you a storm of stones? Then you would not find for yourselves an advocate",
    normalizedText:
      "افامنتم ان يخسف بكم جانب البر او يرسل عليكم حاصبا ثم لا تجدوا لكم وكيلا",
  },
  {
    verseId: 68,
    name: "الإسراء",
    surahId: 17,
    text: "أَمۡ أَمِنتُمۡ أَن يُعِيدَكُمۡ فِيهِ تَارَةً أُخۡرَىٰ فَيُرۡسِلَ عَلَيۡكُمۡ قَاصِفٗا مِّنَ ٱلرِّيحِ فَيُغۡرِقَكُم بِمَا كَفَرۡتُمۡ ثُمَّ لَا تَجِدُواْ لَكُمۡ عَلَيۡنَا بِهِۦ تَبِيعٗا",
    translation:
      "Or do you feel secure that He will not send you back into the sea another time and send upon you a hurricane of wind and drown you for what you denied? Then you would not find for yourselves against Us an avenger",
    normalizedText:
      "ام امنتم ان يعيدكم فيه تارة اخرى فيرسل عليكم قاصفا من الريح فيغرقكم بما كفرتم ثم لا تجدوا لكم علينا به تبيعا",
  },
  {
    verseId: 69,
    name: "الإسراء",
    surahId: 17,
    text: "۞وَلَقَدۡ كَرَّمۡنَا بَنِيٓ ءَادَمَ وَحَمَلۡنَٰهُمۡ فِي ٱلۡبَرِّ وَٱلۡبَحۡرِ وَرَزَقۡنَٰهُم مِّنَ ٱلطَّيِّبَٰتِ وَفَضَّلۡنَٰهُمۡ عَلَىٰ كَثِيرٖ مِّمَّنۡ خَلَقۡنَا تَفۡضِيلٗا",
    translation:
      "And We have certainly honored the children of Adam and carried them on the land and sea and provided for them of the good things and preferred them over much of what We have created, with [definite] preference",
    normalizedText:
      "۞ولقد كرمنا بني ءادم وحملنهم في البر والبحر ورزقنهم من الطيبت وفضلنهم على كثير ممن خلقنا تفضيلا",
  },
  {
    verseId: 70,
    name: "الإسراء",
    surahId: 17,
    text: "يَوۡمَ نَدۡعُواْ كُلَّ أُنَاسِۭ بِإِمَٰمِهِمۡۖ فَمَنۡ أُوتِيَ كِتَٰبَهُۥ بِيَمِينِهِۦ فَأُوْلَـٰٓئِكَ يَقۡرَءُونَ كِتَٰبَهُمۡ وَلَا يُظۡلَمُونَ فَتِيلٗا",
    translation:
      "[Mention, O Muhammad], the Day We will call forth every people with their record [of deeds]. Then whoever is given his record in his right hand - those will read their records, and injustice will not be done to them, [even] as much as a thread [inside the date seed]",
    normalizedText:
      "يوم ندعوا كل اناس باممهم فمن اوتي كتبه بيمينه فاولاك يقرءون كتبهم ولا يظلمون فتيلا",
  },
  {
    verseId: 71,
    name: "الإسراء",
    surahId: 17,
    text: "وَمَن كَانَ فِي هَٰذِهِۦٓ أَعۡمَىٰ فَهُوَ فِي ٱلۡأٓخِرَةِ أَعۡمَىٰ وَأَضَلُّ سَبِيلٗا",
    translation:
      "And whoever is blind in this [life] will be blind in the Hereafter and more astray in way",
    normalizedText: "ومن كان في هذه اعمى فهو في الاخرة اعمى واضل سبيلا",
  },
  {
    verseId: 72,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِن كَادُواْ لَيَفۡتِنُونَكَ عَنِ ٱلَّذِيٓ أَوۡحَيۡنَآ إِلَيۡكَ لِتَفۡتَرِيَ عَلَيۡنَا غَيۡرَهُۥۖ وَإِذٗا لَّٱتَّخَذُوكَ خَلِيلٗا",
    translation:
      "And indeed, they were about to tempt you away from that which We revealed to you in order to [make] you invent about Us something else; and then they would have taken you as a friend",
    normalizedText:
      "وان كادوا ليفتنونك عن الذي اوحينا اليك لتفتري علينا غيره واذا لاتخذوك خليلا",
  },
  {
    verseId: 73,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَوۡلَآ أَن ثَبَّتۡنَٰكَ لَقَدۡ كِدتَّ تَرۡكَنُ إِلَيۡهِمۡ شَيۡـٔٗا قَلِيلًا",
    translation:
      "And if We had not strengthened you, you would have almost inclined to them a little",
    normalizedText: "ولولا ان ثبتنك لقد كدت تركن اليهم شيا قليلا",
  },
  {
    verseId: 74,
    name: "الإسراء",
    surahId: 17,
    text: "إِذٗا لَّأَذَقۡنَٰكَ ضِعۡفَ ٱلۡحَيَوٰةِ وَضِعۡفَ ٱلۡمَمَاتِ ثُمَّ لَا تَجِدُ لَكَ عَلَيۡنَا نَصِيرٗا",
    translation:
      "Then [if you had], We would have made you taste double [punishment in] life and double [after] death. Then you would not find for yourself against Us a helper",
    normalizedText:
      "اذا لاذقنك ضعف الحيوة وضعف الممات ثم لا تجد لك علينا نصيرا",
  },
  {
    verseId: 75,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِن كَادُواْ لَيَسۡتَفِزُّونَكَ مِنَ ٱلۡأَرۡضِ لِيُخۡرِجُوكَ مِنۡهَاۖ وَإِذٗا لَّا يَلۡبَثُونَ خِلَٰفَكَ إِلَّا قَلِيلٗا",
    translation:
      "And indeed, they were about to drive you from the land to evict you therefrom. And then [when they do], they will not remain [there] after you, except for a little",
    normalizedText:
      "وان كادوا ليستفزونك من الارض ليخرجوك منها واذا لا يلبثون خلفك الا قليلا",
  },
  {
    verseId: 76,
    name: "الإسراء",
    surahId: 17,
    text: "سُنَّةَ مَن قَدۡ أَرۡسَلۡنَا قَبۡلَكَ مِن رُّسُلِنَاۖ وَلَا تَجِدُ لِسُنَّتِنَا تَحۡوِيلًا",
    translation:
      "[That is Our] established way for those We had sent before you of Our messengers; and you will not find in Our way any alteration",
    normalizedText: "سنة من قد ارسلنا قبلك من رسلنا ولا تجد لسنتنا تحويلا",
  },
  {
    verseId: 77,
    name: "الإسراء",
    surahId: 17,
    text: "أَقِمِ ٱلصَّلَوٰةَ لِدُلُوكِ ٱلشَّمۡسِ إِلَىٰ غَسَقِ ٱلَّيۡلِ وَقُرۡءَانَ ٱلۡفَجۡرِۖ إِنَّ قُرۡءَانَ ٱلۡفَجۡرِ كَانَ مَشۡهُودٗا",
    translation:
      "Establish prayer at the decline of the sun [from its meridian] until the darkness of the night and [also] the Qur'an of dawn. Indeed, the recitation of dawn is ever witnessed",
    normalizedText:
      "اقم الصلوة لدلوك الشمس الى غسق اليل وقرءان الفجر ان قرءان الفجر كان مشهودا",
  },
  {
    verseId: 78,
    name: "الإسراء",
    surahId: 17,
    text: "وَمِنَ ٱلَّيۡلِ فَتَهَجَّدۡ بِهِۦ نَافِلَةٗ لَّكَ عَسَىٰٓ أَن يَبۡعَثَكَ رَبُّكَ مَقَامٗا مَّحۡمُودٗا",
    translation:
      "And from [part of] the night, pray with it as additional [worship] for you; it is expected that your Lord will resurrect you to a praised station",
    normalizedText: "ومن اليل فتهجد به نافلة لك عسى ان يبعثك ربك مقاما محمودا",
  },
  {
    verseId: 79,
    name: "الإسراء",
    surahId: 17,
    text: "وَقُل رَّبِّ أَدۡخِلۡنِي مُدۡخَلَ صِدۡقٖ وَأَخۡرِجۡنِي مُخۡرَجَ صِدۡقٖ وَٱجۡعَل لِّي مِن لَّدُنكَ سُلۡطَٰنٗا نَّصِيرٗا",
    translation:
      'And say, "My Lord, cause me to enter a sound entrance and to exit a sound exit and grant me from Yourself a supporting authority',
    normalizedText:
      "وقل رب ادخلني مدخل صدق واخرجني مخرج صدق واجعل لي من لدنك سلطنا نصيرا",
  },
  {
    verseId: 80,
    name: "الإسراء",
    surahId: 17,
    text: "وَقُلۡ جَآءَ ٱلۡحَقُّ وَزَهَقَ ٱلۡبَٰطِلُۚ إِنَّ ٱلۡبَٰطِلَ كَانَ زَهُوقٗا",
    translation:
      'And say, "Truth has come, and falsehood has departed. Indeed is falsehood, [by nature], ever bound to depart',
    normalizedText: "وقل جاء الحق وزهق البطل ان البطل كان زهوقا",
  },
  {
    verseId: 81,
    name: "الإسراء",
    surahId: 17,
    text: "وَنُنَزِّلُ مِنَ ٱلۡقُرۡءَانِ مَا هُوَ شِفَآءٞ وَرَحۡمَةٞ لِّلۡمُؤۡمِنِينَ وَلَا يَزِيدُ ٱلظَّـٰلِمِينَ إِلَّا خَسَارٗا",
    translation:
      "And We send down of the Qur'an that which is healing and mercy for the believers, but it does not increase the wrongdoers except in loss",
    normalizedText:
      "وننزل من القرءان ما هو شفاء ورحمة للمامنين ولا يزيد الظلمين الا خسارا",
  },
  {
    verseId: 82,
    name: "الإسراء",
    surahId: 17,
    text: "وَإِذَآ أَنۡعَمۡنَا عَلَى ٱلۡإِنسَٰنِ أَعۡرَضَ وَنَـَٔا بِجَانِبِهِۦ وَإِذَا مَسَّهُ ٱلشَّرُّ كَانَ يَـُٔوسٗا",
    translation:
      "And when We bestow favor upon the disbeliever, he turns away and distances himself; and when evil touches him, he is ever despairing",
    normalizedText:
      "واذا انعمنا على الانسن اعرض ونا بجانبه واذا مسه الشر كان يوسا",
  },
  {
    verseId: 83,
    name: "الإسراء",
    surahId: 17,
    text: "قُلۡ كُلّٞ يَعۡمَلُ عَلَىٰ شَاكِلَتِهِۦ فَرَبُّكُمۡ أَعۡلَمُ بِمَنۡ هُوَ أَهۡدَىٰ سَبِيلٗا",
    translation:
      'Say, "Each works according to his manner, but your Lord is most knowing of who is best guided in way',
    normalizedText: "قل كل يعمل على شاكلته فربكم اعلم بمن هو اهدى سبيلا",
  },
  {
    verseId: 84,
    name: "الإسراء",
    surahId: 17,
    text: "وَيَسۡـَٔلُونَكَ عَنِ ٱلرُّوحِۖ قُلِ ٱلرُّوحُ مِنۡ أَمۡرِ رَبِّي وَمَآ أُوتِيتُم مِّنَ ٱلۡعِلۡمِ إِلَّا قَلِيلٗا",
    translation:
      'And they ask you, [O Muhammad], about the soul. Say, "The soul is of the affair of my Lord. And mankind have not been given of knowledge except a little',
    normalizedText:
      "ويسلونك عن الروح قل الروح من امر ربي وما اوتيتم من العلم الا قليلا",
  },
  {
    verseId: 85,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَئِن شِئۡنَا لَنَذۡهَبَنَّ بِٱلَّذِيٓ أَوۡحَيۡنَآ إِلَيۡكَ ثُمَّ لَا تَجِدُ لَكَ بِهِۦ عَلَيۡنَا وَكِيلًا",
    translation:
      "And if We willed, We could surely do away with that which We revealed to you. Then you would not find for yourself concerning it an advocate against Us",
    normalizedText:
      "ولان شانا لنذهبن بالذي اوحينا اليك ثم لا تجد لك به علينا وكيلا",
  },
  {
    verseId: 86,
    name: "الإسراء",
    surahId: 17,
    text: "إِلَّا رَحۡمَةٗ مِّن رَّبِّكَۚ إِنَّ فَضۡلَهُۥ كَانَ عَلَيۡكَ كَبِيرٗا",
    translation:
      "Except [We have left it with you] as a mercy from your Lord. Indeed, His favor upon you has ever been great",
    normalizedText: "الا رحمة من ربك ان فضله كان عليك كبيرا",
  },
  {
    verseId: 87,
    name: "الإسراء",
    surahId: 17,
    text: "قُل لَّئِنِ ٱجۡتَمَعَتِ ٱلۡإِنسُ وَٱلۡجِنُّ عَلَىٰٓ أَن يَأۡتُواْ بِمِثۡلِ هَٰذَا ٱلۡقُرۡءَانِ لَا يَأۡتُونَ بِمِثۡلِهِۦ وَلَوۡ كَانَ بَعۡضُهُمۡ لِبَعۡضٖ ظَهِيرٗا",
    translation: `Say, "If mankind and the jinn gathered in order to produce the like of this Qur'an, they could not produce the like of it, even if they were to each other assistants`,
    normalizedText:
      "قل لان اجتمعت الانس والجن على ان ياتوا بمثل هذا القرءان لا ياتون بمثله ولو كان بعضهم لبعض ظهيرا",
  },
  {
    verseId: 88,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَقَدۡ صَرَّفۡنَا لِلنَّاسِ فِي هَٰذَا ٱلۡقُرۡءَانِ مِن كُلِّ مَثَلٖ فَأَبَىٰٓ أَكۡثَرُ ٱلنَّاسِ إِلَّا كُفُورٗا",
    translation:
      "And We have certainly diversified for the people in this Qur'an from every [kind] of example, but most of the people refused [anything] except disbelief",
    normalizedText:
      "ولقد صرفنا للناس في هذا القرءان من كل مثل فابى اكثر الناس الا كفورا",
  },
  {
    verseId: 89,
    name: "الإسراء",
    surahId: 17,
    text: "وَقَالُواْ لَن نُّؤۡمِنَ لَكَ حَتَّىٰ تَفۡجُرَ لَنَا مِنَ ٱلۡأَرۡضِ يَنۢبُوعًا",
    translation:
      'And they say, "We will not believe you until you break open for us from the ground a spring',
    normalizedText: "وقالوا لن نامن لك حتى تفجر لنا من الارض ينبوعا",
  },
  {
    verseId: 90,
    name: "الإسراء",
    surahId: 17,
    text: "أَوۡ تَكُونَ لَكَ جَنَّةٞ مِّن نَّخِيلٖ وَعِنَبٖ فَتُفَجِّرَ ٱلۡأَنۡهَٰرَ خِلَٰلَهَا تَفۡجِيرًا",
    translation:
      "Or [until] you have a garden of palm tress and grapes and make rivers gush forth within them in force [and abundance]",
    normalizedText: "او تكون لك جنة من نخيل وعنب فتفجر الانهر خللها تفجيرا",
  },
  {
    verseId: 91,
    name: "الإسراء",
    surahId: 17,
    text: "أَوۡ تُسۡقِطَ ٱلسَّمَآءَ كَمَا زَعَمۡتَ عَلَيۡنَا كِسَفًا أَوۡ تَأۡتِيَ بِٱللَّهِ وَٱلۡمَلَـٰٓئِكَةِ قَبِيلًا",
    translation:
      "Or you make the heaven fall upon us in fragments as you have claimed or you bring Allah and the angels before [us]",
    normalizedText:
      "او تسقط السماء كما زعمت علينا كسفا او تاتي بالله والملاكة قبيلا",
  },
  {
    verseId: 92,
    name: "الإسراء",
    surahId: 17,
    text: "أَوۡ يَكُونَ لَكَ بَيۡتٞ مِّن زُخۡرُفٍ أَوۡ تَرۡقَىٰ فِي ٱلسَّمَآءِ وَلَن نُّؤۡمِنَ لِرُقِيِّكَ حَتَّىٰ تُنَزِّلَ عَلَيۡنَا كِتَٰبٗا نَّقۡرَؤُهُۥۗ قُلۡ سُبۡحَانَ رَبِّي هَلۡ كُنتُ إِلَّا بَشَرٗا رَّسُولٗا",
    translation:
      'Or you have a house of gold or you ascend into the sky. And [even then], we will not believe in your ascension until you bring down to us a book we may read." Say, "Exalted is my Lord! Was I ever but a human messenger',
    normalizedText:
      "او يكون لك بيت من زخرف او ترقى في السماء ولن نامن لرقيك حتى تنزل علينا كتبا نقراه قل سبحان ربي هل كنت الا بشرا رسولا",
  },
  {
    verseId: 93,
    name: "الإسراء",
    surahId: 17,
    text: "وَمَا مَنَعَ ٱلنَّاسَ أَن يُؤۡمِنُوٓاْ إِذۡ جَآءَهُمُ ٱلۡهُدَىٰٓ إِلَّآ أَن قَالُوٓاْ أَبَعَثَ ٱللَّهُ بَشَرٗا رَّسُولٗا",
    translation:
      'And what prevented the people from believing when guidance came to them except that they said, "Has Allah sent a human messenger',
    normalizedText:
      "وما منع الناس ان يامنوا اذ جاءهم الهدى الا ان قالوا ابعث الله بشرا رسولا",
  },
  {
    verseId: 94,
    name: "الإسراء",
    surahId: 17,
    text: "قُل لَّوۡ كَانَ فِي ٱلۡأَرۡضِ مَلَـٰٓئِكَةٞ يَمۡشُونَ مُطۡمَئِنِّينَ لَنَزَّلۡنَا عَلَيۡهِم مِّنَ ٱلسَّمَآءِ مَلَكٗا رَّسُولٗا",
    translation:
      'Say, "If there were upon the earth angels walking securely, We would have sent down to them from the heaven an angel [as a] messenger',
    normalizedText:
      "قل لو كان في الارض ملاكة يمشون مطمانين لنزلنا عليهم من السماء ملكا رسولا",
  },
  {
    verseId: 95,
    name: "الإسراء",
    surahId: 17,
    text: "قُلۡ كَفَىٰ بِٱللَّهِ شَهِيدَۢا بَيۡنِي وَبَيۡنَكُمۡۚ إِنَّهُۥ كَانَ بِعِبَادِهِۦ خَبِيرَۢا بَصِيرٗا",
    translation:
      'Say, "Sufficient is Allah as Witness between me and you. Indeed he is ever, concerning His servants, Acquainted and Seeing',
    normalizedText: "قل كفى بالله شهيدا بيني وبينكم انه كان بعباده خبيرا بصيرا",
  },
  {
    verseId: 96,
    name: "الإسراء",
    surahId: 17,
    text: "وَمَن يَهۡدِ ٱللَّهُ فَهُوَ ٱلۡمُهۡتَدِۖ وَمَن يُضۡلِلۡ فَلَن تَجِدَ لَهُمۡ أَوۡلِيَآءَ مِن دُونِهِۦۖ وَنَحۡشُرُهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ عَلَىٰ وُجُوهِهِمۡ عُمۡيٗا وَبُكۡمٗا وَصُمّٗاۖ مَّأۡوَىٰهُمۡ جَهَنَّمُۖ كُلَّمَا خَبَتۡ زِدۡنَٰهُمۡ سَعِيرٗا",
    translation:
      "And whoever Allah guides - he is the [rightly] guided; and whoever He sends astray - you will never find for them protectors besides Him, and We will gather them on the Day of Resurrection [fallen] on their faces - blind, dumb and deaf. Their refuge is Hell; every time it subsides We increase them in blazing fire",
    normalizedText:
      "ومن يهد الله فهو المهتد ومن يضلل فلن تجد لهم اولياء من دونه ونحشرهم يوم القيمة على وجوههم عميا وبكما وصما ماوىهم جهنم كلما خبت زدنهم سعيرا",
  },
  {
    verseId: 97,
    name: "الإسراء",
    surahId: 17,
    text: "ذَٰلِكَ جَزَآؤُهُم بِأَنَّهُمۡ كَفَرُواْ بِـَٔايَٰتِنَا وَقَالُوٓاْ أَءِذَا كُنَّا عِظَٰمٗا وَرُفَٰتًا أَءِنَّا لَمَبۡعُوثُونَ خَلۡقٗا جَدِيدًا",
    translation:
      'That is their recompense because they disbelieved in Our verses and said, "When we are bones and crumbled particles, will we [truly] be resurrected [in] a new creation',
    normalizedText:
      "ذلك جزااهم بانهم كفروا بايتنا وقالوا اءذا كنا عظما ورفتا اءنا لمبعوثون خلقا جديدا",
  },
  {
    verseId: 98,
    name: "الإسراء",
    surahId: 17,
    text: "۞أَوَلَمۡ يَرَوۡاْ أَنَّ ٱللَّهَ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ قَادِرٌ عَلَىٰٓ أَن يَخۡلُقَ مِثۡلَهُمۡ وَجَعَلَ لَهُمۡ أَجَلٗا لَّا رَيۡبَ فِيهِ فَأَبَى ٱلظَّـٰلِمُونَ إِلَّا كُفُورٗا",
    translation:
      "Do they not see that Allah, who created the heavens and earth, is [the one] Able to create the likes of them? And He has appointed for them a term, about which there is no doubt. But the wrongdoers refuse [anything] except disbelief",
    normalizedText:
      "۞اولم يروا ان الله الذي خلق السموت والارض قادر على ان يخلق مثلهم وجعل لهم اجلا لا ريب فيه فابى الظلمون الا كفورا",
  },
  {
    verseId: 99,
    name: "الإسراء",
    surahId: 17,
    text: "قُل لَّوۡ أَنتُمۡ تَمۡلِكُونَ خَزَآئِنَ رَحۡمَةِ رَبِّيٓ إِذٗا لَّأَمۡسَكۡتُمۡ خَشۡيَةَ ٱلۡإِنفَاقِۚ وَكَانَ ٱلۡإِنسَٰنُ قَتُورٗا",
    translation:
      'Say [to them], "If you possessed the depositories of the mercy of my Lord, then you would withhold out of fear of spending." And ever has man been stingy',
    normalizedText:
      "قل لو انتم تملكون خزاان رحمة ربي اذا لامسكتم خشية الانفاق وكان الانسن قتورا",
  },
  {
    verseId: 100,
    name: "الإسراء",
    surahId: 17,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَىٰ تِسۡعَ ءَايَٰتِۭ بَيِّنَٰتٖۖ فَسۡـَٔلۡ بَنِيٓ إِسۡرَـٰٓءِيلَ إِذۡ جَآءَهُمۡ فَقَالَ لَهُۥ فِرۡعَوۡنُ إِنِّي لَأَظُنُّكَ يَٰمُوسَىٰ مَسۡحُورٗا",
    translation:
      'And We had certainly given Moses nine evident signs, so ask the Children of Israel [about] when he came to them and Pharaoh said to him, "Indeed I think, O Moses, that you are affected by magic',
    normalizedText:
      "ولقد ءاتينا موسى تسع ءايت بينت فسل بني اسرءيل اذ جاءهم فقال له فرعون اني لاظنك يموسى مسحورا",
  },
  {
    verseId: 101,
    name: "الإسراء",
    surahId: 17,
    text: "قَالَ لَقَدۡ عَلِمۡتَ مَآ أَنزَلَ هَـٰٓؤُلَآءِ إِلَّا رَبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ بَصَآئِرَ وَإِنِّي لَأَظُنُّكَ يَٰفِرۡعَوۡنُ مَثۡبُورٗا",
    translation:
      '[Moses] said, "You have already known that none has sent down these [signs] except the Lord of the heavens and the earth as evidence, and indeed I think, O Pharaoh, that you are destroyed',
    normalizedText:
      "قال لقد علمت ما انزل هالاء الا رب السموت والارض بصاار واني لاظنك يفرعون مثبورا",
  },
  {
    verseId: 102,
    name: "الإسراء",
    surahId: 17,
    text: "فَأَرَادَ أَن يَسۡتَفِزَّهُم مِّنَ ٱلۡأَرۡضِ فَأَغۡرَقۡنَٰهُ وَمَن مَّعَهُۥ جَمِيعٗا",
    translation:
      "So he intended to drive them from the land, but We drowned him and those with him all together",
    normalizedText: "فاراد ان يستفزهم من الارض فاغرقنه ومن معه جميعا",
  },
  {
    verseId: 103,
    name: "الإسراء",
    surahId: 17,
    text: "وَقُلۡنَا مِنۢ بَعۡدِهِۦ لِبَنِيٓ إِسۡرَـٰٓءِيلَ ٱسۡكُنُواْ ٱلۡأَرۡضَ فَإِذَا جَآءَ وَعۡدُ ٱلۡأٓخِرَةِ جِئۡنَا بِكُمۡ لَفِيفٗا",
    translation:
      'And We said after Pharaoh to the Children of Israel, "Dwell in the land, and when there comes the promise of the Hereafter, We will bring you forth in [one] gathering',
    normalizedText:
      "وقلنا من بعده لبني اسرءيل اسكنوا الارض فاذا جاء وعد الاخرة جانا بكم لفيفا",
  },
  {
    verseId: 104,
    name: "الإسراء",
    surahId: 17,
    text: "وَبِٱلۡحَقِّ أَنزَلۡنَٰهُ وَبِٱلۡحَقِّ نَزَلَۗ وَمَآ أَرۡسَلۡنَٰكَ إِلَّا مُبَشِّرٗا وَنَذِيرٗا",
    translation:
      "And with the truth We have sent the Qur'an down, and with the truth it has descended. And We have not sent you, [O Muhammad], except as a bringer of good tidings and a warner",
    normalizedText: "وبالحق انزلنه وبالحق نزل وما ارسلنك الا مبشرا ونذيرا",
  },
  {
    verseId: 105,
    name: "الإسراء",
    surahId: 17,
    text: "وَقُرۡءَانٗا فَرَقۡنَٰهُ لِتَقۡرَأَهُۥ عَلَى ٱلنَّاسِ عَلَىٰ مُكۡثٖ وَنَزَّلۡنَٰهُ تَنزِيلٗا",
    translation:
      "And [it is] a Qur'an which We have separated [by intervals] that you might recite it to the people over a prolonged period. And We have sent it down progressively",
    normalizedText: "وقرءانا فرقنه لتقراه على الناس على مكث ونزلنه تنزيلا",
  },
  {
    verseId: 106,
    name: "الإسراء",
    surahId: 17,
    text: "قُلۡ ءَامِنُواْ بِهِۦٓ أَوۡ لَا تُؤۡمِنُوٓاْۚ إِنَّ ٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ مِن قَبۡلِهِۦٓ إِذَا يُتۡلَىٰ عَلَيۡهِمۡ يَخِرُّونَۤ لِلۡأَذۡقَانِۤ سُجَّدٗاۤ",
    translation:
      'Say, "Believe in it or do not believe. Indeed, those who were given knowledge before it - when it is recited to them, they fall upon their faces in prostration',
    normalizedText:
      "قل ءامنوا به او لا تامنوا ان الذين اوتوا العلم من قبله اذا يتلى عليهم يخرون للاذقان سجدا",
  },
  {
    verseId: 107,
    name: "الإسراء",
    surahId: 17,
    text: "وَيَقُولُونَ سُبۡحَٰنَ رَبِّنَآ إِن كَانَ وَعۡدُ رَبِّنَا لَمَفۡعُولٗا",
    translation:
      'And they say, "Exalted is our Lord! Indeed, the promise of our Lord has been fulfilled',
    normalizedText: "ويقولون سبحن ربنا ان كان وعد ربنا لمفعولا",
  },
  {
    verseId: 108,
    name: "الإسراء",
    surahId: 17,
    text: "وَيَخِرُّونَ لِلۡأَذۡقَانِ يَبۡكُونَ وَيَزِيدُهُمۡ خُشُوعٗا۩",
    translation:
      "And they fall upon their faces weeping, and the Qur'an increases them in humble submission",
    normalizedText: "ويخرون للاذقان يبكون ويزيدهم خشوعا۩",
  },
  {
    verseId: 109,
    name: "الإسراء",
    surahId: 17,
    text: "قُلِ ٱدۡعُواْ ٱللَّهَ أَوِ ٱدۡعُواْ ٱلرَّحۡمَٰنَۖ أَيّٗا مَّا تَدۡعُواْ فَلَهُ ٱلۡأَسۡمَآءُ ٱلۡحُسۡنَىٰۚ وَلَا تَجۡهَرۡ بِصَلَاتِكَ وَلَا تُخَافِتۡ بِهَا وَٱبۡتَغِ بَيۡنَ ذَٰلِكَ سَبِيلٗا",
    translation:
      'Say, "Call upon Allah or call upon the Most Merciful. Whichever [name] you call - to Him belong the best names." And do not recite [too] loudly in your prayer or [too] quietly but seek between that an [intermediate] way',
    normalizedText:
      "قل ادعوا الله او ادعوا الرحمن ايا ما تدعوا فله الاسماء الحسنى ولا تجهر بصلاتك ولا تخافت بها وابتغ بين ذلك سبيلا",
  },
  {
    verseId: 110,
    name: "الإسراء",
    surahId: 17,
    text: "وَقُلِ ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي لَمۡ يَتَّخِذۡ وَلَدٗا وَلَمۡ يَكُن لَّهُۥ شَرِيكٞ فِي ٱلۡمُلۡكِ وَلَمۡ يَكُن لَّهُۥ وَلِيّٞ مِّنَ ٱلذُّلِّۖ وَكَبِّرۡهُ تَكۡبِيرَۢا",
    translation:
      'And say, "Praise to Allah, who has not taken a son and has had no partner in [His] dominion and has no [need of a] protector out of weakness; and glorify Him with [great] glorification',
    normalizedText:
      "وقل الحمد لله الذي لم يتخذ ولدا ولم يكن له شريك في الملك ولم يكن له ولي من الذل وكبره تكبيرا",
  },
  {
    verseId: 0,
    name: "الكهف",
    surahId: 18,
    text: "ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِيٓ أَنزَلَ عَلَىٰ عَبۡدِهِ ٱلۡكِتَٰبَ وَلَمۡ يَجۡعَل لَّهُۥ عِوَجَاۜ",
    translation:
      "[All] praise is [due] to Allah, who has sent down upon His Servant the Book and has not made therein any deviance",
    normalizedText: "الحمد لله الذي انزل على عبده الكتب ولم يجعل له عوجا",
  },
  {
    verseId: 1,
    name: "الكهف",
    surahId: 18,
    text: "قَيِّمٗا لِّيُنذِرَ بَأۡسٗا شَدِيدٗا مِّن لَّدُنۡهُ وَيُبَشِّرَ ٱلۡمُؤۡمِنِينَ ٱلَّذِينَ يَعۡمَلُونَ ٱلصَّـٰلِحَٰتِ أَنَّ لَهُمۡ أَجۡرًا حَسَنٗا",
    translation:
      "[He has made it] straight, to warn of severe punishment from Him and to give good tidings to the believers who do righteous deeds that they will have a good reward",
    normalizedText:
      "قيما لينذر باسا شديدا من لدنه ويبشر المامنين الذين يعملون الصلحت ان لهم اجرا حسنا",
  },
  {
    verseId: 2,
    name: "الكهف",
    surahId: 18,
    text: "مَّـٰكِثِينَ فِيهِ أَبَدٗا",
    translation: "In which they will remain forever",
    normalizedText: "مكثين فيه ابدا",
  },
  {
    verseId: 3,
    name: "الكهف",
    surahId: 18,
    text: "وَيُنذِرَ ٱلَّذِينَ قَالُواْ ٱتَّخَذَ ٱللَّهُ وَلَدٗا",
    translation: 'And to warn those who say, "Allah has taken a son',
    normalizedText: "وينذر الذين قالوا اتخذ الله ولدا",
  },
  {
    verseId: 4,
    name: "الكهف",
    surahId: 18,
    text: "مَّا لَهُم بِهِۦ مِنۡ عِلۡمٖ وَلَا لِأٓبَآئِهِمۡۚ كَبُرَتۡ كَلِمَةٗ تَخۡرُجُ مِنۡ أَفۡوَٰهِهِمۡۚ إِن يَقُولُونَ إِلَّا كَذِبٗا",
    translation:
      "They have no knowledge of it, nor had their fathers. Grave is the word that comes out of their mouths; they speak not except a lie",
    normalizedText:
      "ما لهم به من علم ولا لابااهم كبرت كلمة تخرج من افوههم ان يقولون الا كذبا",
  },
  {
    verseId: 5,
    name: "الكهف",
    surahId: 18,
    text: "فَلَعَلَّكَ بَٰخِعٞ نَّفۡسَكَ عَلَىٰٓ ءَاثَٰرِهِمۡ إِن لَّمۡ يُؤۡمِنُواْ بِهَٰذَا ٱلۡحَدِيثِ أَسَفًا",
    translation:
      "Then perhaps you would kill yourself through grief over them, [O Muhammad], if they do not believe in this message, [and] out of sorrow",
    normalizedText: "فلعلك بخع نفسك على ءاثرهم ان لم يامنوا بهذا الحديث اسفا",
  },
  {
    verseId: 6,
    name: "الكهف",
    surahId: 18,
    text: "إِنَّا جَعَلۡنَا مَا عَلَى ٱلۡأَرۡضِ زِينَةٗ لَّهَا لِنَبۡلُوَهُمۡ أَيُّهُمۡ أَحۡسَنُ عَمَلٗا",
    translation:
      "Indeed, We have made that which is on the earth adornment for it that We may test them [as to] which of them is best in deed",
    normalizedText: "انا جعلنا ما على الارض زينة لها لنبلوهم ايهم احسن عملا",
  },
  {
    verseId: 7,
    name: "الكهف",
    surahId: 18,
    text: "وَإِنَّا لَجَٰعِلُونَ مَا عَلَيۡهَا صَعِيدٗا جُرُزًا",
    translation:
      "And indeed, We will make that which is upon it [into] a barren ground",
    normalizedText: "وانا لجعلون ما عليها صعيدا جرزا",
  },
  {
    verseId: 8,
    name: "الكهف",
    surahId: 18,
    text: "أَمۡ حَسِبۡتَ أَنَّ أَصۡحَٰبَ ٱلۡكَهۡفِ وَٱلرَّقِيمِ كَانُواْ مِنۡ ءَايَٰتِنَا عَجَبًا",
    translation:
      "Or have you thought that the companions of the cave and the inscription were, among Our signs, a wonder",
    normalizedText: "ام حسبت ان اصحب الكهف والرقيم كانوا من ءايتنا عجبا",
  },
  {
    verseId: 9,
    name: "الكهف",
    surahId: 18,
    text: "إِذۡ أَوَى ٱلۡفِتۡيَةُ إِلَى ٱلۡكَهۡفِ فَقَالُواْ رَبَّنَآ ءَاتِنَا مِن لَّدُنكَ رَحۡمَةٗ وَهَيِّئۡ لَنَا مِنۡ أَمۡرِنَا رَشَدٗا",
    translation:
      '[Mention] when the youths retreated to the cave and said, "Our Lord, grant us from Yourself mercy and prepare for us from our affair right guidance',
    normalizedText:
      "اذ اوى الفتية الى الكهف فقالوا ربنا ءاتنا من لدنك رحمة وهيا لنا من امرنا رشدا",
  },
  {
    verseId: 10,
    name: "الكهف",
    surahId: 18,
    text: "فَضَرَبۡنَا عَلَىٰٓ ءَاذَانِهِمۡ فِي ٱلۡكَهۡفِ سِنِينَ عَدَدٗا",
    translation:
      "So We cast [a cover of sleep] over their ears within the cave for a number of years",
    normalizedText: "فضربنا على ءاذانهم في الكهف سنين عددا",
  },
  {
    verseId: 11,
    name: "الكهف",
    surahId: 18,
    text: "ثُمَّ بَعَثۡنَٰهُمۡ لِنَعۡلَمَ أَيُّ ٱلۡحِزۡبَيۡنِ أَحۡصَىٰ لِمَا لَبِثُوٓاْ أَمَدٗا",
    translation:
      "Then We awakened them that We might show which of the two factions was most precise in calculating what [extent] they had remained in time",
    normalizedText: "ثم بعثنهم لنعلم اي الحزبين احصى لما لبثوا امدا",
  },
  {
    verseId: 12,
    name: "الكهف",
    surahId: 18,
    text: "نَّحۡنُ نَقُصُّ عَلَيۡكَ نَبَأَهُم بِٱلۡحَقِّۚ إِنَّهُمۡ فِتۡيَةٌ ءَامَنُواْ بِرَبِّهِمۡ وَزِدۡنَٰهُمۡ هُدٗى",
    translation:
      "It is We who relate to you, [O Muhammad], their story in truth. Indeed, they were youths who believed in their Lord, and We increased them in guidance",
    normalizedText:
      "نحن نقص عليك نباهم بالحق انهم فتية ءامنوا بربهم وزدنهم هدى",
  },
  {
    verseId: 13,
    name: "الكهف",
    surahId: 18,
    text: "وَرَبَطۡنَا عَلَىٰ قُلُوبِهِمۡ إِذۡ قَامُواْ فَقَالُواْ رَبُّنَا رَبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ لَن نَّدۡعُوَاْ مِن دُونِهِۦٓ إِلَٰهٗاۖ لَّقَدۡ قُلۡنَآ إِذٗا شَطَطًا",
    translation:
      'And We made firm their hearts when they stood up and said, "Our Lord is the Lord of the heavens and the earth. Never will we invoke besides Him any deity. We would have certainly spoken, then, an excessive transgression',
    normalizedText:
      "وربطنا على قلوبهم اذ قاموا فقالوا ربنا رب السموت والارض لن ندعوا من دونه الها لقد قلنا اذا شططا",
  },
  {
    verseId: 14,
    name: "الكهف",
    surahId: 18,
    text: "هَـٰٓؤُلَآءِ قَوۡمُنَا ٱتَّخَذُواْ مِن دُونِهِۦٓ ءَالِهَةٗۖ لَّوۡلَا يَأۡتُونَ عَلَيۡهِم بِسُلۡطَٰنِۭ بَيِّنٖۖ فَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبٗا",
    translation:
      "These, our people, have taken besides Him deities. Why do they not bring for [worship of] them a clear authority? And who is more unjust than one who invents about Allah a lie",
    normalizedText:
      "هالاء قومنا اتخذوا من دونه ءالهة لولا ياتون عليهم بسلطن بين فمن اظلم ممن افترى على الله كذبا",
  },
  {
    verseId: 15,
    name: "الكهف",
    surahId: 18,
    text: "وَإِذِ ٱعۡتَزَلۡتُمُوهُمۡ وَمَا يَعۡبُدُونَ إِلَّا ٱللَّهَ فَأۡوُۥٓاْ إِلَى ٱلۡكَهۡفِ يَنشُرۡ لَكُمۡ رَبُّكُم مِّن رَّحۡمَتِهِۦ وَيُهَيِّئۡ لَكُم مِّنۡ أَمۡرِكُم مِّرۡفَقٗا",
    translation:
      '[The youths said to one another], "And when you have withdrawn from them and that which they worship other than Allah, retreat to the cave. Your Lord will spread out for you of His mercy and will prepare for you from your affair facility',
    normalizedText:
      "واذ اعتزلتموهم وما يعبدون الا الله فاوا الى الكهف ينشر لكم ربكم من رحمته ويهيا لكم من امركم مرفقا",
  },
  {
    verseId: 16,
    name: "الكهف",
    surahId: 18,
    text: "۞وَتَرَى ٱلشَّمۡسَ إِذَا طَلَعَت تَّزَٰوَرُ عَن كَهۡفِهِمۡ ذَاتَ ٱلۡيَمِينِ وَإِذَا غَرَبَت تَّقۡرِضُهُمۡ ذَاتَ ٱلشِّمَالِ وَهُمۡ فِي فَجۡوَةٖ مِّنۡهُۚ ذَٰلِكَ مِنۡ ءَايَٰتِ ٱللَّهِۗ مَن يَهۡدِ ٱللَّهُ فَهُوَ ٱلۡمُهۡتَدِۖ وَمَن يُضۡلِلۡ فَلَن تَجِدَ لَهُۥ وَلِيّٗا مُّرۡشِدٗا",
    translation:
      "And [had you been present], you would see the sun when it rose, inclining away from their cave on the right, and when it set, passing away from them on the left, while they were [laying] within an open space thereof. That was from the signs of Allah. He whom Allah guides is the [rightly] guided, but he whom He leaves astray - never will you find for him a protecting guide",
    normalizedText:
      "۞وترى الشمس اذا طلعت تزور عن كهفهم ذات اليمين واذا غربت تقرضهم ذات الشمال وهم في فجوة منه ذلك من ءايت الله من يهد الله فهو المهتد ومن يضلل فلن تجد له وليا مرشدا",
  },
  {
    verseId: 17,
    name: "الكهف",
    surahId: 18,
    text: "وَتَحۡسَبُهُمۡ أَيۡقَاظٗا وَهُمۡ رُقُودٞۚ وَنُقَلِّبُهُمۡ ذَاتَ ٱلۡيَمِينِ وَذَاتَ ٱلشِّمَالِۖ وَكَلۡبُهُم بَٰسِطٞ ذِرَاعَيۡهِ بِٱلۡوَصِيدِۚ لَوِ ٱطَّلَعۡتَ عَلَيۡهِمۡ لَوَلَّيۡتَ مِنۡهُمۡ فِرَارٗا وَلَمُلِئۡتَ مِنۡهُمۡ رُعۡبٗا",
    translation:
      "And you would think them awake, while they were asleep. And We turned them to the right and to the left, while their dog stretched his forelegs at the entrance. If you had looked at them, you would have turned from them in flight and been filled by them with terror",
    normalizedText:
      "وتحسبهم ايقاظا وهم رقود ونقلبهم ذات اليمين وذات الشمال وكلبهم بسط ذراعيه بالوصيد لو اطلعت عليهم لوليت منهم فرارا ولملات منهم رعبا",
  },
  {
    verseId: 18,
    name: "الكهف",
    surahId: 18,
    text: "وَكَذَٰلِكَ بَعَثۡنَٰهُمۡ لِيَتَسَآءَلُواْ بَيۡنَهُمۡۚ قَالَ قَآئِلٞ مِّنۡهُمۡ كَمۡ لَبِثۡتُمۡۖ قَالُواْ لَبِثۡنَا يَوۡمًا أَوۡ بَعۡضَ يَوۡمٖۚ قَالُواْ رَبُّكُمۡ أَعۡلَمُ بِمَا لَبِثۡتُمۡ فَٱبۡعَثُوٓاْ أَحَدَكُم بِوَرِقِكُمۡ هَٰذِهِۦٓ إِلَى ٱلۡمَدِينَةِ فَلۡيَنظُرۡ أَيُّهَآ أَزۡكَىٰ طَعَامٗا فَلۡيَأۡتِكُم بِرِزۡقٖ مِّنۡهُ وَلۡيَتَلَطَّفۡ وَلَا يُشۡعِرَنَّ بِكُمۡ أَحَدًا",
    translation:
      'And similarly, We awakened them that they might question one another. Said a speaker from among them, "How long have you remained [here]?" They said, "We have remained a day or part of a day." They said, "Your Lord is most knowing of how long you remained. So send one of you with this silver coin of yours to the city and let him look to which is the best of food and bring you provision from it and let him be cautious. And let no one be aware of you',
    normalizedText:
      "وكذلك بعثنهم ليتساءلوا بينهم قال قاال منهم كم لبثتم قالوا لبثنا يوما او بعض يوم قالوا ربكم اعلم بما لبثتم فابعثوا احدكم بورقكم هذه الى المدينة فلينظر ايها ازكى طعاما فلياتكم برزق منه وليتلطف ولا يشعرن بكم احدا",
  },
  {
    verseId: 19,
    name: "الكهف",
    surahId: 18,
    text: "إِنَّهُمۡ إِن يَظۡهَرُواْ عَلَيۡكُمۡ يَرۡجُمُوكُمۡ أَوۡ يُعِيدُوكُمۡ فِي مِلَّتِهِمۡ وَلَن تُفۡلِحُوٓاْ إِذًا أَبَدٗا",
    translation:
      "Indeed, if they come to know of you, they will stone you or return you to their religion. And never would you succeed, then - ever",
    normalizedText:
      "انهم ان يظهروا عليكم يرجموكم او يعيدوكم في ملتهم ولن تفلحوا اذا ابدا",
  },
  {
    verseId: 20,
    name: "الكهف",
    surahId: 18,
    text: "وَكَذَٰلِكَ أَعۡثَرۡنَا عَلَيۡهِمۡ لِيَعۡلَمُوٓاْ أَنَّ وَعۡدَ ٱللَّهِ حَقّٞ وَأَنَّ ٱلسَّاعَةَ لَا رَيۡبَ فِيهَآ إِذۡ يَتَنَٰزَعُونَ بَيۡنَهُمۡ أَمۡرَهُمۡۖ فَقَالُواْ ٱبۡنُواْ عَلَيۡهِم بُنۡيَٰنٗاۖ رَّبُّهُمۡ أَعۡلَمُ بِهِمۡۚ قَالَ ٱلَّذِينَ غَلَبُواْ عَلَىٰٓ أَمۡرِهِمۡ لَنَتَّخِذَنَّ عَلَيۡهِم مَّسۡجِدٗا",
    translation:
      'And similarly, We caused them to be found that they [who found them] would know that the promise of Allah is truth and that of the Hour there is no doubt. [That was] when they disputed among themselves about their affair and [then] said, "Construct over them a structure. Their Lord is most knowing about them." Said those who prevailed in the matter, "We will surely take [for ourselves] over them a masjid',
    normalizedText:
      "وكذلك اعثرنا عليهم ليعلموا ان وعد الله حق وان الساعة لا ريب فيها اذ يتنزعون بينهم امرهم فقالوا ابنوا عليهم بنينا ربهم اعلم بهم قال الذين غلبوا على امرهم لنتخذن عليهم مسجدا",
  },
  {
    verseId: 21,
    name: "الكهف",
    surahId: 18,
    text: "سَيَقُولُونَ ثَلَٰثَةٞ رَّابِعُهُمۡ كَلۡبُهُمۡ وَيَقُولُونَ خَمۡسَةٞ سَادِسُهُمۡ كَلۡبُهُمۡ رَجۡمَۢا بِٱلۡغَيۡبِۖ وَيَقُولُونَ سَبۡعَةٞ وَثَامِنُهُمۡ كَلۡبُهُمۡۚ قُل رَّبِّيٓ أَعۡلَمُ بِعِدَّتِهِم مَّا يَعۡلَمُهُمۡ إِلَّا قَلِيلٞۗ فَلَا تُمَارِ فِيهِمۡ إِلَّا مِرَآءٗ ظَٰهِرٗا وَلَا تَسۡتَفۡتِ فِيهِم مِّنۡهُمۡ أَحَدٗا",
    translation:
      'They will say there were three, the fourth of them being their dog; and they will say there were five, the sixth of them being their dog - guessing at the unseen; and they will say there were seven, and the eighth of them was their dog. Say, [O Muhammad], "My Lord is most knowing of their number. None knows them except a few. So do not argue about them except with an obvious argument and do not inquire about them among [the speculators] from anyone',
    normalizedText:
      "سيقولون ثلثة رابعهم كلبهم ويقولون خمسة سادسهم كلبهم رجما بالغيب ويقولون سبعة وثامنهم كلبهم قل ربي اعلم بعدتهم ما يعلمهم الا قليل فلا تمار فيهم الا مراء ظهرا ولا تستفت فيهم منهم احدا",
  },
  {
    verseId: 22,
    name: "الكهف",
    surahId: 18,
    text: "وَلَا تَقُولَنَّ لِشَاْيۡءٍ إِنِّي فَاعِلٞ ذَٰلِكَ غَدًا",
    translation: 'And never say of anything, "Indeed, I will do that tomorrow',
    normalizedText: "ولا تقولن لشايء اني فاعل ذلك غدا",
  },
  {
    verseId: 23,
    name: "الكهف",
    surahId: 18,
    text: "إِلَّآ أَن يَشَآءَ ٱللَّهُۚ وَٱذۡكُر رَّبَّكَ إِذَا نَسِيتَ وَقُلۡ عَسَىٰٓ أَن يَهۡدِيَنِ رَبِّي لِأَقۡرَبَ مِنۡ هَٰذَا رَشَدٗا",
    translation:
      'Except [when adding], "If Allah wills." And remember your Lord when you forget [it] and say, "Perhaps my Lord will guide me to what is nearer than this to right conduct',
    normalizedText:
      "الا ان يشاء الله واذكر ربك اذا نسيت وقل عسى ان يهدين ربي لاقرب من هذا رشدا",
  },
  {
    verseId: 24,
    name: "الكهف",
    surahId: 18,
    text: "وَلَبِثُواْ فِي كَهۡفِهِمۡ ثَلَٰثَ مِاْئَةٖ سِنِينَ وَٱزۡدَادُواْ تِسۡعٗا",
    translation:
      "And they remained in their cave for three hundred years and exceeded by nine",
    normalizedText: "ولبثوا في كهفهم ثلث مااة سنين وازدادوا تسعا",
  },
  {
    verseId: 25,
    name: "الكهف",
    surahId: 18,
    text: "قُلِ ٱللَّهُ أَعۡلَمُ بِمَا لَبِثُواْۖ لَهُۥ غَيۡبُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ أَبۡصِرۡ بِهِۦ وَأَسۡمِعۡۚ مَا لَهُم مِّن دُونِهِۦ مِن وَلِيّٖ وَلَا يُشۡرِكُ فِي حُكۡمِهِۦٓ أَحَدٗا",
    translation:
      'Say, "Allah is most knowing of how long they remained. He has [knowledge of] the unseen [aspects] of the heavens and the earth. How Seeing is He and how Hearing! They have not besides Him any protector, and He shares not His legislation with anyone',
    normalizedText:
      "قل الله اعلم بما لبثوا له غيب السموت والارض ابصر به واسمع ما لهم من دونه من ولي ولا يشرك في حكمه احدا",
  },
  {
    verseId: 26,
    name: "الكهف",
    surahId: 18,
    text: "وَٱتۡلُ مَآ أُوحِيَ إِلَيۡكَ مِن كِتَابِ رَبِّكَۖ لَا مُبَدِّلَ لِكَلِمَٰتِهِۦ وَلَن تَجِدَ مِن دُونِهِۦ مُلۡتَحَدٗا",
    translation:
      "And recite, [O Muhammad], what has been revealed to you of the Book of your Lord. There is no changer of His words, and never will you find in other than Him a refuge",
    normalizedText:
      "واتل ما اوحي اليك من كتاب ربك لا مبدل لكلمته ولن تجد من دونه ملتحدا",
  },
  {
    verseId: 27,
    name: "الكهف",
    surahId: 18,
    text: "وَٱصۡبِرۡ نَفۡسَكَ مَعَ ٱلَّذِينَ يَدۡعُونَ رَبَّهُم بِٱلۡغَدَوٰةِ وَٱلۡعَشِيِّ يُرِيدُونَ وَجۡهَهُۥۖ وَلَا تَعۡدُ عَيۡنَاكَ عَنۡهُمۡ تُرِيدُ زِينَةَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَلَا تُطِعۡ مَنۡ أَغۡفَلۡنَا قَلۡبَهُۥ عَن ذِكۡرِنَا وَٱتَّبَعَ هَوَىٰهُ وَكَانَ أَمۡرُهُۥ فُرُطٗا",
    translation:
      "And keep yourself patient [by being] with those who call upon their Lord in the morning and the evening, seeking His countenance. And let not your eyes pass beyond them, desiring adornments of the worldly life, and do not obey one whose heart We have made heedless of Our remembrance and who follows his desire and whose affair is ever [in] neglect",
    normalizedText:
      "واصبر نفسك مع الذين يدعون ربهم بالغدوة والعشي يريدون وجهه ولا تعد عيناك عنهم تريد زينة الحيوة الدنيا ولا تطع من اغفلنا قلبه عن ذكرنا واتبع هوىه وكان امره فرطا",
  },
  {
    verseId: 28,
    name: "الكهف",
    surahId: 18,
    text: "وَقُلِ ٱلۡحَقُّ مِن رَّبِّكُمۡۖ فَمَن شَآءَ فَلۡيُؤۡمِن وَمَن شَآءَ فَلۡيَكۡفُرۡۚ إِنَّآ أَعۡتَدۡنَا لِلظَّـٰلِمِينَ نَارًا أَحَاطَ بِهِمۡ سُرَادِقُهَاۚ وَإِن يَسۡتَغِيثُواْ يُغَاثُواْ بِمَآءٖ كَٱلۡمُهۡلِ يَشۡوِي ٱلۡوُجُوهَۚ بِئۡسَ ٱلشَّرَابُ وَسَآءَتۡ مُرۡتَفَقًا",
    translation:
      'And say, "The truth is from your Lord, so whoever wills - let him believe; and whoever wills - let him disbelieve." Indeed, We have prepared for the wrongdoers a fire whose walls will surround them. And if they call for relief, they will be relieved with water like murky oil, which scalds [their] faces. Wretched is the drink, and evil is the resting place',
    normalizedText:
      "وقل الحق من ربكم فمن شاء فليامن ومن شاء فليكفر انا اعتدنا للظلمين نارا احاط بهم سرادقها وان يستغيثوا يغاثوا بماء كالمهل يشوي الوجوه باس الشراب وساءت مرتفقا",
  },
  {
    verseId: 29,
    name: "الكهف",
    surahId: 18,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ إِنَّا لَا نُضِيعُ أَجۡرَ مَنۡ أَحۡسَنَ عَمَلًا",
    translation:
      "Indeed, those who have believed and done righteous deeds - indeed, We will not allow to be lost the reward of any who did well in deeds",
    normalizedText:
      "ان الذين ءامنوا وعملوا الصلحت انا لا نضيع اجر من احسن عملا",
  },
  {
    verseId: 30,
    name: "الكهف",
    surahId: 18,
    text: "أُوْلَـٰٓئِكَ لَهُمۡ جَنَّـٰتُ عَدۡنٖ تَجۡرِي مِن تَحۡتِهِمُ ٱلۡأَنۡهَٰرُ يُحَلَّوۡنَ فِيهَا مِنۡ أَسَاوِرَ مِن ذَهَبٖ وَيَلۡبَسُونَ ثِيَابًا خُضۡرٗا مِّن سُندُسٖ وَإِسۡتَبۡرَقٖ مُّتَّكِـِٔينَ فِيهَا عَلَى ٱلۡأَرَآئِكِۚ نِعۡمَ ٱلثَّوَابُ وَحَسُنَتۡ مُرۡتَفَقٗا",
    translation:
      "Those will have gardens of perpetual residence; beneath them rivers will flow. They will be adorned therein with bracelets of gold and will wear green garments of fine silk and brocade, reclining therein on adorned couches. Excellent is the reward, and good is the resting place",
    normalizedText:
      "اولاك لهم جنت عدن تجري من تحتهم الانهر يحلون فيها من اساور من ذهب ويلبسون ثيابا خضرا من سندس واستبرق متكين فيها على الارااك نعم الثواب وحسنت مرتفقا",
  },
  {
    verseId: 31,
    name: "الكهف",
    surahId: 18,
    text: "۞وَٱضۡرِبۡ لَهُم مَّثَلٗا رَّجُلَيۡنِ جَعَلۡنَا لِأَحَدِهِمَا جَنَّتَيۡنِ مِنۡ أَعۡنَٰبٖ وَحَفَفۡنَٰهُمَا بِنَخۡلٖ وَجَعَلۡنَا بَيۡنَهُمَا زَرۡعٗا",
    translation:
      "And present to them an example of two men: We granted to one of them two gardens of grapevines, and We bordered them with palm trees and placed between them [fields of] crops",
    normalizedText:
      "۞واضرب لهم مثلا رجلين جعلنا لاحدهما جنتين من اعنب وحففنهما بنخل وجعلنا بينهما زرعا",
  },
  {
    verseId: 32,
    name: "الكهف",
    surahId: 18,
    text: "كِلۡتَا ٱلۡجَنَّتَيۡنِ ءَاتَتۡ أُكُلَهَا وَلَمۡ تَظۡلِم مِّنۡهُ شَيۡـٔٗاۚ وَفَجَّرۡنَا خِلَٰلَهُمَا نَهَرٗا",
    translation:
      "Each of the two gardens produced its fruit and did not fall short thereof in anything. And We caused to gush forth within them a river",
    normalizedText:
      "كلتا الجنتين ءاتت اكلها ولم تظلم منه شيا وفجرنا خللهما نهرا",
  },
  {
    verseId: 33,
    name: "الكهف",
    surahId: 18,
    text: "وَكَانَ لَهُۥ ثَمَرٞ فَقَالَ لِصَٰحِبِهِۦ وَهُوَ يُحَاوِرُهُۥٓ أَنَا۠ أَكۡثَرُ مِنكَ مَالٗا وَأَعَزُّ نَفَرٗا",
    translation:
      'And he had fruit, so he said to his companion while he was conversing with him, "I am greater than you in wealth and mightier in [numbers of] men',
    normalizedText:
      "وكان له ثمر فقال لصحبه وهو يحاوره انا اكثر منك مالا واعز نفرا",
  },
  {
    verseId: 34,
    name: "الكهف",
    surahId: 18,
    text: "وَدَخَلَ جَنَّتَهُۥ وَهُوَ ظَالِمٞ لِّنَفۡسِهِۦ قَالَ مَآ أَظُنُّ أَن تَبِيدَ هَٰذِهِۦٓ أَبَدٗا",
    translation:
      'And he entered his garden while he was unjust to himself. He said, "I do not think that this will perish - ever',
    normalizedText: "ودخل جنته وهو ظالم لنفسه قال ما اظن ان تبيد هذه ابدا",
  },
  {
    verseId: 35,
    name: "الكهف",
    surahId: 18,
    text: "وَمَآ أَظُنُّ ٱلسَّاعَةَ قَآئِمَةٗ وَلَئِن رُّدِدتُّ إِلَىٰ رَبِّي لَأَجِدَنَّ خَيۡرٗا مِّنۡهَا مُنقَلَبٗا",
    translation:
      "And I do not think the Hour will occur. And even if I should be brought back to my Lord, I will surely find better than this as a return",
    normalizedText:
      "وما اظن الساعة قاامة ولان رددت الى ربي لاجدن خيرا منها منقلبا",
  },
  {
    verseId: 36,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ لَهُۥ صَاحِبُهُۥ وَهُوَ يُحَاوِرُهُۥٓ أَكَفَرۡتَ بِٱلَّذِي خَلَقَكَ مِن تُرَابٖ ثُمَّ مِن نُّطۡفَةٖ ثُمَّ سَوَّىٰكَ رَجُلٗا",
    translation:
      'His companion said to him while he was conversing with him, "Have you disbelieved in He who created you from dust and then from a sperm-drop and then proportioned you [as] a man',
    normalizedText:
      "قال له صاحبه وهو يحاوره اكفرت بالذي خلقك من تراب ثم من نطفة ثم سوىك رجلا",
  },
  {
    verseId: 37,
    name: "الكهف",
    surahId: 18,
    text: "لَّـٰكِنَّا۠ هُوَ ٱللَّهُ رَبِّي وَلَآ أُشۡرِكُ بِرَبِّيٓ أَحَدٗا",
    translation:
      "But as for me, He is Allah, my Lord, and I do not associate with my Lord anyone",
    normalizedText: "لكنا هو الله ربي ولا اشرك بربي احدا",
  },
  {
    verseId: 38,
    name: "الكهف",
    surahId: 18,
    text: "وَلَوۡلَآ إِذۡ دَخَلۡتَ جَنَّتَكَ قُلۡتَ مَا شَآءَ ٱللَّهُ لَا قُوَّةَ إِلَّا بِٱللَّهِۚ إِن تَرَنِ أَنَا۠ أَقَلَّ مِنكَ مَالٗا وَوَلَدٗا",
    translation:
      "And why did you, when you entered your garden, not say, 'What Allah willed [has occurred]; there is no power except in Allah '? Although you see me less than you in wealth and children",
    normalizedText:
      "ولولا اذ دخلت جنتك قلت ما شاء الله لا قوة الا بالله ان ترن انا اقل منك مالا وولدا",
  },
  {
    verseId: 39,
    name: "الكهف",
    surahId: 18,
    text: "فَعَسَىٰ رَبِّيٓ أَن يُؤۡتِيَنِ خَيۡرٗا مِّن جَنَّتِكَ وَيُرۡسِلَ عَلَيۡهَا حُسۡبَانٗا مِّنَ ٱلسَّمَآءِ فَتُصۡبِحَ صَعِيدٗا زَلَقًا",
    translation:
      "It may be that my Lord will give me [something] better than your garden and will send upon it a calamity from the sky, and it will become a smooth, dusty ground",
    normalizedText:
      "فعسى ربي ان ياتين خيرا من جنتك ويرسل عليها حسبانا من السماء فتصبح صعيدا زلقا",
  },
  {
    verseId: 40,
    name: "الكهف",
    surahId: 18,
    text: "أَوۡ يُصۡبِحَ مَآؤُهَا غَوۡرٗا فَلَن تَسۡتَطِيعَ لَهُۥ طَلَبٗا",
    translation:
      "Or its water will become sunken [into the earth], so you would never be able to seek it",
    normalizedText: "او يصبح مااها غورا فلن تستطيع له طلبا",
  },
  {
    verseId: 41,
    name: "الكهف",
    surahId: 18,
    text: "وَأُحِيطَ بِثَمَرِهِۦ فَأَصۡبَحَ يُقَلِّبُ كَفَّيۡهِ عَلَىٰ مَآ أَنفَقَ فِيهَا وَهِيَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا وَيَقُولُ يَٰلَيۡتَنِي لَمۡ أُشۡرِكۡ بِرَبِّيٓ أَحَدٗا",
    translation:
      'And his fruits were encompassed [by ruin], so he began to turn his hands about [in dismay] over what he had spent on it, while it had collapsed upon its trellises, and said, "Oh, I wish I had not associated with my Lord anyone',
    normalizedText:
      "واحيط بثمره فاصبح يقلب كفيه على ما انفق فيها وهي خاوية على عروشها ويقول يليتني لم اشرك بربي احدا",
  },
  {
    verseId: 42,
    name: "الكهف",
    surahId: 18,
    text: "وَلَمۡ تَكُن لَّهُۥ فِئَةٞ يَنصُرُونَهُۥ مِن دُونِ ٱللَّهِ وَمَا كَانَ مُنتَصِرًا",
    translation:
      "And there was for him no company to aid him other than Allah, nor could he defend himself",
    normalizedText: "ولم تكن له فاة ينصرونه من دون الله وما كان منتصرا",
  },
  {
    verseId: 43,
    name: "الكهف",
    surahId: 18,
    text: "هُنَالِكَ ٱلۡوَلَٰيَةُ لِلَّهِ ٱلۡحَقِّۚ هُوَ خَيۡرٞ ثَوَابٗا وَخَيۡرٌ عُقۡبٗا",
    translation:
      "There the authority is [completely] for Allah, the Truth. He is best in reward and best in outcome",
    normalizedText: "هنالك الولية لله الحق هو خير ثوابا وخير عقبا",
  },
  {
    verseId: 44,
    name: "الكهف",
    surahId: 18,
    text: "وَٱضۡرِبۡ لَهُم مَّثَلَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا كَمَآءٍ أَنزَلۡنَٰهُ مِنَ ٱلسَّمَآءِ فَٱخۡتَلَطَ بِهِۦ نَبَاتُ ٱلۡأَرۡضِ فَأَصۡبَحَ هَشِيمٗا تَذۡرُوهُ ٱلرِّيَٰحُۗ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ مُّقۡتَدِرًا",
    translation:
      "And present to them the example of the life of this world, [its being] like rain which We send down from the sky, and the vegetation of the earth mingles with it and [then] it becomes dry remnants, scattered by the winds. And Allah is ever, over all things, Perfect in Ability",
    normalizedText:
      "واضرب لهم مثل الحيوة الدنيا كماء انزلنه من السماء فاختلط به نبات الارض فاصبح هشيما تذروه الريح وكان الله على كل شيء مقتدرا",
  },
  {
    verseId: 45,
    name: "الكهف",
    surahId: 18,
    text: "ٱلۡمَالُ وَٱلۡبَنُونَ زِينَةُ ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَٱلۡبَٰقِيَٰتُ ٱلصَّـٰلِحَٰتُ خَيۡرٌ عِندَ رَبِّكَ ثَوَابٗا وَخَيۡرٌ أَمَلٗا",
    translation:
      "Wealth and children are [but] adornment of the worldly life. But the enduring good deeds are better to your Lord for reward and better for [one's] hope",
    normalizedText:
      "المال والبنون زينة الحيوة الدنيا والبقيت الصلحت خير عند ربك ثوابا وخير املا",
  },
  {
    verseId: 46,
    name: "الكهف",
    surahId: 18,
    text: "وَيَوۡمَ نُسَيِّرُ ٱلۡجِبَالَ وَتَرَى ٱلۡأَرۡضَ بَارِزَةٗ وَحَشَرۡنَٰهُمۡ فَلَمۡ نُغَادِرۡ مِنۡهُمۡ أَحَدٗا",
    translation:
      "And [warn of] the Day when We will remove the mountains and you will see the earth prominent, and We will gather them and not leave behind from them anyone",
    normalizedText:
      "ويوم نسير الجبال وترى الارض بارزة وحشرنهم فلم نغادر منهم احدا",
  },
  {
    verseId: 47,
    name: "الكهف",
    surahId: 18,
    text: "وَعُرِضُواْ عَلَىٰ رَبِّكَ صَفّٗا لَّقَدۡ جِئۡتُمُونَا كَمَا خَلَقۡنَٰكُمۡ أَوَّلَ مَرَّةِۭۚ بَلۡ زَعَمۡتُمۡ أَلَّن نَّجۡعَلَ لَكُم مَّوۡعِدٗا",
    translation:
      'And they will be presented before your Lord in rows, [and He will say], "You have certainly come to Us just as We created you the first time. But you claimed that We would never make for you an appointment',
    normalizedText:
      "وعرضوا على ربك صفا لقد جاتمونا كما خلقنكم اول مرة بل زعمتم الن نجعل لكم موعدا",
  },
  {
    verseId: 48,
    name: "الكهف",
    surahId: 18,
    text: "وَوُضِعَ ٱلۡكِتَٰبُ فَتَرَى ٱلۡمُجۡرِمِينَ مُشۡفِقِينَ مِمَّا فِيهِ وَيَقُولُونَ يَٰوَيۡلَتَنَا مَالِ هَٰذَا ٱلۡكِتَٰبِ لَا يُغَادِرُ صَغِيرَةٗ وَلَا كَبِيرَةً إِلَّآ أَحۡصَىٰهَاۚ وَوَجَدُواْ مَا عَمِلُواْ حَاضِرٗاۗ وَلَا يَظۡلِمُ رَبُّكَ أَحَدٗا",
    translation:
      'And the record [of deeds] will be placed [open], and you will see the criminals fearful of that within it, and they will say, "Oh, woe to us! What is this book that leaves nothing small or great except that it has enumerated it?" And they will find what they did present [before them]. And your Lord does injustice to no one',
    normalizedText:
      "ووضع الكتب فترى المجرمين مشفقين مما فيه ويقولون يويلتنا مال هذا الكتب لا يغادر صغيرة ولا كبيرة الا احصىها ووجدوا ما عملوا حاضرا ولا يظلم ربك احدا",
  },
  {
    verseId: 49,
    name: "الكهف",
    surahId: 18,
    text: "وَإِذۡ قُلۡنَا لِلۡمَلَـٰٓئِكَةِ ٱسۡجُدُواْ لِأٓدَمَ فَسَجَدُوٓاْ إِلَّآ إِبۡلِيسَ كَانَ مِنَ ٱلۡجِنِّ فَفَسَقَ عَنۡ أَمۡرِ رَبِّهِۦٓۗ أَفَتَتَّخِذُونَهُۥ وَذُرِّيَّتَهُۥٓ أَوۡلِيَآءَ مِن دُونِي وَهُمۡ لَكُمۡ عَدُوُّۢۚ بِئۡسَ لِلظَّـٰلِمِينَ بَدَلٗا",
    translation:
      'And [mention] when We said to the angels, "Prostrate to Adam," and they prostrated, except for Iblees. He was of the jinn and departed from the command of his Lord. Then will you take him and his descendants as allies other than Me while they are enemies to you? Wretched it is for the wrongdoers as an exchange',
    normalizedText:
      "واذ قلنا للملاكة اسجدوا لادم فسجدوا الا ابليس كان من الجن ففسق عن امر ربه افتتخذونه وذريته اولياء من دوني وهم لكم عدو باس للظلمين بدلا",
  },
  {
    verseId: 50,
    name: "الكهف",
    surahId: 18,
    text: "۞مَّآ أَشۡهَدتُّهُمۡ خَلۡقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَلَا خَلۡقَ أَنفُسِهِمۡ وَمَا كُنتُ مُتَّخِذَ ٱلۡمُضِلِّينَ عَضُدٗا",
    translation:
      "I did not make them witness to the creation of the heavens and the earth or to the creation of themselves, and I would not have taken the misguiders as assistants",
    normalizedText:
      "۞ما اشهدتهم خلق السموت والارض ولا خلق انفسهم وما كنت متخذ المضلين عضدا",
  },
  {
    verseId: 51,
    name: "الكهف",
    surahId: 18,
    text: "وَيَوۡمَ يَقُولُ نَادُواْ شُرَكَآءِيَ ٱلَّذِينَ زَعَمۡتُمۡ فَدَعَوۡهُمۡ فَلَمۡ يَسۡتَجِيبُواْ لَهُمۡ وَجَعَلۡنَا بَيۡنَهُم مَّوۡبِقٗا",
    translation: `And [warn of] the Day when He will say, "Call 'My partners' whom you claimed," and they will invoke them, but they will not respond to them. And We will put between them [a valley of] destruction`,
    normalizedText:
      "ويوم يقول نادوا شركاءي الذين زعمتم فدعوهم فلم يستجيبوا لهم وجعلنا بينهم موبقا",
  },
  {
    verseId: 52,
    name: "الكهف",
    surahId: 18,
    text: "وَرَءَا ٱلۡمُجۡرِمُونَ ٱلنَّارَ فَظَنُّوٓاْ أَنَّهُم مُّوَاقِعُوهَا وَلَمۡ يَجِدُواْ عَنۡهَا مَصۡرِفٗا",
    translation:
      "And the criminals will see the Fire and will be certain that they are to fall therein. And they will not find from it a way elsewhere",
    normalizedText:
      "ورءا المجرمون النار فظنوا انهم مواقعوها ولم يجدوا عنها مصرفا",
  },
  {
    verseId: 53,
    name: "الكهف",
    surahId: 18,
    text: "وَلَقَدۡ صَرَّفۡنَا فِي هَٰذَا ٱلۡقُرۡءَانِ لِلنَّاسِ مِن كُلِّ مَثَلٖۚ وَكَانَ ٱلۡإِنسَٰنُ أَكۡثَرَ شَيۡءٖ جَدَلٗا",
    translation:
      "And We have certainly diversified in this Qur'an for the people from every [kind of] example; but man has ever been, most of anything, [prone to] dispute",
    normalizedText:
      "ولقد صرفنا في هذا القرءان للناس من كل مثل وكان الانسن اكثر شيء جدلا",
  },
  {
    verseId: 54,
    name: "الكهف",
    surahId: 18,
    text: "وَمَا مَنَعَ ٱلنَّاسَ أَن يُؤۡمِنُوٓاْ إِذۡ جَآءَهُمُ ٱلۡهُدَىٰ وَيَسۡتَغۡفِرُواْ رَبَّهُمۡ إِلَّآ أَن تَأۡتِيَهُمۡ سُنَّةُ ٱلۡأَوَّلِينَ أَوۡ يَأۡتِيَهُمُ ٱلۡعَذَابُ قُبُلٗا",
    translation:
      "And nothing has prevented the people from believing when guidance came to them and from asking forgiveness of their Lord except that there [must] befall them the [accustomed] precedent of the former peoples or that the punishment should come [directly] before them",
    normalizedText:
      "وما منع الناس ان يامنوا اذ جاءهم الهدى ويستغفروا ربهم الا ان تاتيهم سنة الاولين او ياتيهم العذاب قبلا",
  },
  {
    verseId: 55,
    name: "الكهف",
    surahId: 18,
    text: "وَمَا نُرۡسِلُ ٱلۡمُرۡسَلِينَ إِلَّا مُبَشِّرِينَ وَمُنذِرِينَۚ وَيُجَٰدِلُ ٱلَّذِينَ كَفَرُواْ بِٱلۡبَٰطِلِ لِيُدۡحِضُواْ بِهِ ٱلۡحَقَّۖ وَٱتَّخَذُوٓاْ ءَايَٰتِي وَمَآ أُنذِرُواْ هُزُوٗا",
    translation:
      "And We send not the messengers except as bringers of good tidings and warners. And those who disbelieve dispute by [using] falsehood to [attempt to] invalidate thereby the truth and have taken My verses, and that of which they are warned, in ridicule",
    normalizedText:
      "وما نرسل المرسلين الا مبشرين ومنذرين ويجدل الذين كفروا بالبطل ليدحضوا به الحق واتخذوا ءايتي وما انذروا هزوا",
  },
  {
    verseId: 56,
    name: "الكهف",
    surahId: 18,
    text: "وَمَنۡ أَظۡلَمُ مِمَّن ذُكِّرَ بِـَٔايَٰتِ رَبِّهِۦ فَأَعۡرَضَ عَنۡهَا وَنَسِيَ مَا قَدَّمَتۡ يَدَاهُۚ إِنَّا جَعَلۡنَا عَلَىٰ قُلُوبِهِمۡ أَكِنَّةً أَن يَفۡقَهُوهُ وَفِيٓ ءَاذَانِهِمۡ وَقۡرٗاۖ وَإِن تَدۡعُهُمۡ إِلَى ٱلۡهُدَىٰ فَلَن يَهۡتَدُوٓاْ إِذًا أَبَدٗا",
    translation:
      "And who is more unjust than one who is reminded of the verses of his Lord but turns away from them and forgets what his hands have put forth? Indeed, We have placed over their hearts coverings, lest they understand it, and in their ears deafness. And if you invite them to guidance - they will never be guided, then - ever",
    normalizedText:
      "ومن اظلم ممن ذكر بايت ربه فاعرض عنها ونسي ما قدمت يداه انا جعلنا على قلوبهم اكنة ان يفقهوه وفي ءاذانهم وقرا وان تدعهم الى الهدى فلن يهتدوا اذا ابدا",
  },
  {
    verseId: 57,
    name: "الكهف",
    surahId: 18,
    text: "وَرَبُّكَ ٱلۡغَفُورُ ذُو ٱلرَّحۡمَةِۖ لَوۡ يُؤَاخِذُهُم بِمَا كَسَبُواْ لَعَجَّلَ لَهُمُ ٱلۡعَذَابَۚ بَل لَّهُم مَّوۡعِدٞ لَّن يَجِدُواْ مِن دُونِهِۦ مَوۡئِلٗا",
    translation:
      "And your Lord is the Forgiving, full of mercy. If He were to impose blame upon them for what they earned, He would have hastened for them the punishment. Rather, for them is an appointment from which they will never find an escape",
    normalizedText:
      "وربك الغفور ذو الرحمة لو يااخذهم بما كسبوا لعجل لهم العذاب بل لهم موعد لن يجدوا من دونه موالا",
  },
  {
    verseId: 58,
    name: "الكهف",
    surahId: 18,
    text: "وَتِلۡكَ ٱلۡقُرَىٰٓ أَهۡلَكۡنَٰهُمۡ لَمَّا ظَلَمُواْ وَجَعَلۡنَا لِمَهۡلِكِهِم مَّوۡعِدٗا",
    translation:
      "And those cities - We destroyed them when they wronged, and We made for their destruction an appointed time",
    normalizedText: "وتلك القرى اهلكنهم لما ظلموا وجعلنا لمهلكهم موعدا",
  },
  {
    verseId: 59,
    name: "الكهف",
    surahId: 18,
    text: "وَإِذۡ قَالَ مُوسَىٰ لِفَتَىٰهُ لَآ أَبۡرَحُ حَتَّىٰٓ أَبۡلُغَ مَجۡمَعَ ٱلۡبَحۡرَيۡنِ أَوۡ أَمۡضِيَ حُقُبٗا",
    translation:
      'And [mention] when Moses said to his servant, "I will not cease [traveling] until I reach the junction of the two seas or continue for a long period',
    normalizedText:
      "واذ قال موسى لفتىه لا ابرح حتى ابلغ مجمع البحرين او امضي حقبا",
  },
  {
    verseId: 60,
    name: "الكهف",
    surahId: 18,
    text: "فَلَمَّا بَلَغَا مَجۡمَعَ بَيۡنِهِمَا نَسِيَا حُوتَهُمَا فَٱتَّخَذَ سَبِيلَهُۥ فِي ٱلۡبَحۡرِ سَرَبٗا",
    translation:
      "But when they reached the junction between them, they forgot their fish, and it took its course into the sea, slipping away",
    normalizedText:
      "فلما بلغا مجمع بينهما نسيا حوتهما فاتخذ سبيله في البحر سربا",
  },
  {
    verseId: 61,
    name: "الكهف",
    surahId: 18,
    text: "فَلَمَّا جَاوَزَا قَالَ لِفَتَىٰهُ ءَاتِنَا غَدَآءَنَا لَقَدۡ لَقِينَا مِن سَفَرِنَا هَٰذَا نَصَبٗا",
    translation:
      'So when they had passed beyond it, [Moses] said to his boy, "Bring us our morning meal. We have certainly suffered in this, our journey, [much] fatigue',
    normalizedText:
      "فلما جاوزا قال لفتىه ءاتنا غداءنا لقد لقينا من سفرنا هذا نصبا",
  },
  {
    verseId: 62,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ أَرَءَيۡتَ إِذۡ أَوَيۡنَآ إِلَى ٱلصَّخۡرَةِ فَإِنِّي نَسِيتُ ٱلۡحُوتَ وَمَآ أَنسَىٰنِيهُ إِلَّا ٱلشَّيۡطَٰنُ أَنۡ أَذۡكُرَهُۥۚ وَٱتَّخَذَ سَبِيلَهُۥ فِي ٱلۡبَحۡرِ عَجَبٗا",
    translation:
      'He said, "Did you see when we retired to the rock? Indeed, I forgot [there] the fish. And none made me forget it except Satan - that I should mention it. And it took its course into the sea amazingly',
    normalizedText:
      "قال ارءيت اذ اوينا الى الصخرة فاني نسيت الحوت وما انسىنيه الا الشيطن ان اذكره واتخذ سبيله في البحر عجبا",
  },
  {
    verseId: 63,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ ذَٰلِكَ مَا كُنَّا نَبۡغِۚ فَٱرۡتَدَّا عَلَىٰٓ ءَاثَارِهِمَا قَصَصٗا",
    translation:
      '[Moses] said, "That is what we were seeking." So they returned, following their footprints',
    normalizedText: "قال ذلك ما كنا نبغ فارتدا على ءاثارهما قصصا",
  },
  {
    verseId: 64,
    name: "الكهف",
    surahId: 18,
    text: "فَوَجَدَا عَبۡدٗا مِّنۡ عِبَادِنَآ ءَاتَيۡنَٰهُ رَحۡمَةٗ مِّنۡ عِندِنَا وَعَلَّمۡنَٰهُ مِن لَّدُنَّا عِلۡمٗا",
    translation:
      "And they found a servant from among Our servants to whom we had given mercy from us and had taught him from Us a [certain] knowledge",
    normalizedText:
      "فوجدا عبدا من عبادنا ءاتينه رحمة من عندنا وعلمنه من لدنا علما",
  },
  {
    verseId: 65,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ لَهُۥ مُوسَىٰ هَلۡ أَتَّبِعُكَ عَلَىٰٓ أَن تُعَلِّمَنِ مِمَّا عُلِّمۡتَ رُشۡدٗا",
    translation:
      'Moses said to him, "May I follow you on [the condition] that you teach me from what you have been taught of sound judgement',
    normalizedText: "قال له موسى هل اتبعك على ان تعلمن مما علمت رشدا",
  },
  {
    verseId: 66,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ إِنَّكَ لَن تَسۡتَطِيعَ مَعِيَ صَبۡرٗا",
    translation:
      'He said, "Indeed, with me you will never be able to have patience',
    normalizedText: "قال انك لن تستطيع معي صبرا",
  },
  {
    verseId: 67,
    name: "الكهف",
    surahId: 18,
    text: "وَكَيۡفَ تَصۡبِرُ عَلَىٰ مَا لَمۡ تُحِطۡ بِهِۦ خُبۡرٗا",
    translation:
      "And how can you have patience for what you do not encompass in knowledge",
    normalizedText: "وكيف تصبر على ما لم تحط به خبرا",
  },
  {
    verseId: 68,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ سَتَجِدُنِيٓ إِن شَآءَ ٱللَّهُ صَابِرٗا وَلَآ أَعۡصِي لَكَ أَمۡرٗا",
    translation:
      '[Moses] said, "You will find me, if Allah wills, patient, and I will not disobey you in [any] order',
    normalizedText: "قال ستجدني ان شاء الله صابرا ولا اعصي لك امرا",
  },
  {
    verseId: 69,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ فَإِنِ ٱتَّبَعۡتَنِي فَلَا تَسۡـَٔلۡنِي عَن شَيۡءٍ حَتَّىٰٓ أُحۡدِثَ لَكَ مِنۡهُ ذِكۡرٗا",
    translation:
      'He said, "Then if you follow me, do not ask me about anything until I make to you about it mention',
    normalizedText: "قال فان اتبعتني فلا تسلني عن شيء حتى احدث لك منه ذكرا",
  },
  {
    verseId: 70,
    name: "الكهف",
    surahId: 18,
    text: "فَٱنطَلَقَا حَتَّىٰٓ إِذَا رَكِبَا فِي ٱلسَّفِينَةِ خَرَقَهَاۖ قَالَ أَخَرَقۡتَهَا لِتُغۡرِقَ أَهۡلَهَا لَقَدۡ جِئۡتَ شَيۡـًٔا إِمۡرٗا",
    translation:
      'So they set out, until when they had embarked on the ship, al-Khidh r tore it open. [Moses] said, "Have you torn it open to drown its people? You have certainly done a grave thing',
    normalizedText:
      "فانطلقا حتى اذا ركبا في السفينة خرقها قال اخرقتها لتغرق اهلها لقد جات شيا امرا",
  },
  {
    verseId: 71,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ أَلَمۡ أَقُلۡ إِنَّكَ لَن تَسۡتَطِيعَ مَعِيَ صَبۡرٗا",
    translation:
      '[Al-Khidh r] said, "Did I not say that with me you would never be able to have patience',
    normalizedText: "قال الم اقل انك لن تستطيع معي صبرا",
  },
  {
    verseId: 72,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ لَا تُؤَاخِذۡنِي بِمَا نَسِيتُ وَلَا تُرۡهِقۡنِي مِنۡ أَمۡرِي عُسۡرٗا",
    translation:
      '[Moses] said, "Do not blame me for what I forgot and do not cover me in my matter with difficulty',
    normalizedText: "قال لا تااخذني بما نسيت ولا ترهقني من امري عسرا",
  },
  {
    verseId: 73,
    name: "الكهف",
    surahId: 18,
    text: "فَٱنطَلَقَا حَتَّىٰٓ إِذَا لَقِيَا غُلَٰمٗا فَقَتَلَهُۥ قَالَ أَقَتَلۡتَ نَفۡسٗا زَكِيَّةَۢ بِغَيۡرِ نَفۡسٖ لَّقَدۡ جِئۡتَ شَيۡـٔٗا نُّكۡرٗا",
    translation:
      'So they set out, until when they met a boy, al-Khidh r killed him. [Moses] said, "Have you killed a pure soul for other than [having killed] a soul? You have certainly done a deplorable thing',
    normalizedText:
      "فانطلقا حتى اذا لقيا غلما فقتله قال اقتلت نفسا زكية بغير نفس لقد جات شيا نكرا",
  },
  {
    verseId: 74,
    name: "الكهف",
    surahId: 18,
    text: "۞قَالَ أَلَمۡ أَقُل لَّكَ إِنَّكَ لَن تَسۡتَطِيعَ مَعِيَ صَبۡرٗا",
    translation:
      '[Al-Khidh r] said, "Did I not tell you that with me you would never be able to have patience',
    normalizedText: "۞قال الم اقل لك انك لن تستطيع معي صبرا",
  },
  {
    verseId: 75,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ إِن سَأَلۡتُكَ عَن شَيۡءِۭ بَعۡدَهَا فَلَا تُصَٰحِبۡنِيۖ قَدۡ بَلَغۡتَ مِن لَّدُنِّي عُذۡرٗا",
    translation:
      '[Moses] said, "If I should ask you about anything after this, then do not keep me as a companion. You have obtained from me an excuse',
    normalizedText: "قال ان سالتك عن شيء بعدها فلا تصحبني قد بلغت من لدني عذرا",
  },
  {
    verseId: 76,
    name: "الكهف",
    surahId: 18,
    text: "فَٱنطَلَقَا حَتَّىٰٓ إِذَآ أَتَيَآ أَهۡلَ قَرۡيَةٍ ٱسۡتَطۡعَمَآ أَهۡلَهَا فَأَبَوۡاْ أَن يُضَيِّفُوهُمَا فَوَجَدَا فِيهَا جِدَارٗا يُرِيدُ أَن يَنقَضَّ فَأَقَامَهُۥۖ قَالَ لَوۡ شِئۡتَ لَتَّخَذۡتَ عَلَيۡهِ أَجۡرٗا",
    translation:
      'So they set out, until when they came to the people of a town, they asked its people for food, but they refused to offer them hospitality. And they found therein a wall about to collapse, so al-Khidh r restored it. [Moses] said, "If you wished, you could have taken for it a payment',
    normalizedText:
      "فانطلقا حتى اذا اتيا اهل قرية استطعما اهلها فابوا ان يضيفوهما فوجدا فيها جدارا يريد ان ينقض فاقامه قال لو شات لتخذت عليه اجرا",
  },
  {
    verseId: 77,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ هَٰذَا فِرَاقُ بَيۡنِي وَبَيۡنِكَۚ سَأُنَبِّئُكَ بِتَأۡوِيلِ مَا لَمۡ تَسۡتَطِع عَّلَيۡهِ صَبۡرًا",
    translation:
      '[Al-Khidh r] said, "This is parting between me and you. I will inform you of the interpretation of that about which you could not have patience',
    normalizedText:
      "قال هذا فراق بيني وبينك سانباك بتاويل ما لم تستطع عليه صبرا",
  },
  {
    verseId: 78,
    name: "الكهف",
    surahId: 18,
    text: "أَمَّا ٱلسَّفِينَةُ فَكَانَتۡ لِمَسَٰكِينَ يَعۡمَلُونَ فِي ٱلۡبَحۡرِ فَأَرَدتُّ أَنۡ أَعِيبَهَا وَكَانَ وَرَآءَهُم مَّلِكٞ يَأۡخُذُ كُلَّ سَفِينَةٍ غَصۡبٗا",
    translation:
      "As for the ship, it belonged to poor people working at sea. So I intended to cause defect in it as there was after them a king who seized every [good] ship by force",
    normalizedText:
      "اما السفينة فكانت لمسكين يعملون في البحر فاردت ان اعيبها وكان وراءهم ملك ياخذ كل سفينة غصبا",
  },
  {
    verseId: 79,
    name: "الكهف",
    surahId: 18,
    text: "وَأَمَّا ٱلۡغُلَٰمُ فَكَانَ أَبَوَاهُ مُؤۡمِنَيۡنِ فَخَشِينَآ أَن يُرۡهِقَهُمَا طُغۡيَٰنٗا وَكُفۡرٗا",
    translation:
      "And as for the boy, his parents were believers, and we feared that he would overburden them by transgression and disbelief",
    normalizedText:
      "واما الغلم فكان ابواه مامنين فخشينا ان يرهقهما طغينا وكفرا",
  },
  {
    verseId: 80,
    name: "الكهف",
    surahId: 18,
    text: "فَأَرَدۡنَآ أَن يُبۡدِلَهُمَا رَبُّهُمَا خَيۡرٗا مِّنۡهُ زَكَوٰةٗ وَأَقۡرَبَ رُحۡمٗا",
    translation:
      "So we intended that their Lord should substitute for them one better than him in purity and nearer to mercy",
    normalizedText: "فاردنا ان يبدلهما ربهما خيرا منه زكوة واقرب رحما",
  },
  {
    verseId: 81,
    name: "الكهف",
    surahId: 18,
    text: "وَأَمَّا ٱلۡجِدَارُ فَكَانَ لِغُلَٰمَيۡنِ يَتِيمَيۡنِ فِي ٱلۡمَدِينَةِ وَكَانَ تَحۡتَهُۥ كَنزٞ لَّهُمَا وَكَانَ أَبُوهُمَا صَٰلِحٗا فَأَرَادَ رَبُّكَ أَن يَبۡلُغَآ أَشُدَّهُمَا وَيَسۡتَخۡرِجَا كَنزَهُمَا رَحۡمَةٗ مِّن رَّبِّكَۚ وَمَا فَعَلۡتُهُۥ عَنۡ أَمۡرِيۚ ذَٰلِكَ تَأۡوِيلُ مَا لَمۡ تَسۡطِع عَّلَيۡهِ صَبۡرٗا",
    translation:
      "And as for the wall, it belonged to two orphan boys in the city, and there was beneath it a treasure for them, and their father had been righteous. So your Lord intended that they reach maturity and extract their treasure, as a mercy from your Lord. And I did it not of my own accord. That is the interpretation of that about which you could not have patience",
    normalizedText:
      "واما الجدار فكان لغلمين يتيمين في المدينة وكان تحته كنز لهما وكان ابوهما صلحا فاراد ربك ان يبلغا اشدهما ويستخرجا كنزهما رحمة من ربك وما فعلته عن امري ذلك تاويل ما لم تسطع عليه صبرا",
  },
  {
    verseId: 82,
    name: "الكهف",
    surahId: 18,
    text: "وَيَسۡـَٔلُونَكَ عَن ذِي ٱلۡقَرۡنَيۡنِۖ قُلۡ سَأَتۡلُواْ عَلَيۡكُم مِّنۡهُ ذِكۡرًا",
    translation:
      'And they ask you, [O Muhammad], about Dhul-Qarnayn. Say, "I will recite to you about him a report',
    normalizedText: "ويسلونك عن ذي القرنين قل ساتلوا عليكم منه ذكرا",
  },
  {
    verseId: 83,
    name: "الكهف",
    surahId: 18,
    text: "إِنَّا مَكَّنَّا لَهُۥ فِي ٱلۡأَرۡضِ وَءَاتَيۡنَٰهُ مِن كُلِّ شَيۡءٖ سَبَبٗا",
    translation:
      "Indeed We established him upon the earth, and We gave him to everything a way",
    normalizedText: "انا مكنا له في الارض وءاتينه من كل شيء سببا",
  },
  {
    verseId: 84,
    name: "الكهف",
    surahId: 18,
    text: "فَأَتۡبَعَ سَبَبًا",
    translation: "So he followed a way",
    normalizedText: "فاتبع سببا",
  },
  {
    verseId: 85,
    name: "الكهف",
    surahId: 18,
    text: "حَتَّىٰٓ إِذَا بَلَغَ مَغۡرِبَ ٱلشَّمۡسِ وَجَدَهَا تَغۡرُبُ فِي عَيۡنٍ حَمِئَةٖ وَوَجَدَ عِندَهَا قَوۡمٗاۖ قُلۡنَا يَٰذَا ٱلۡقَرۡنَيۡنِ إِمَّآ أَن تُعَذِّبَ وَإِمَّآ أَن تَتَّخِذَ فِيهِمۡ حُسۡنٗا",
    translation:
      'Until, when he reached the setting of the sun, he found it [as if] setting in a spring of dark mud, and he found near it a people. Allah said, "O Dhul-Qarnayn, either you punish [them] or else adopt among them [a way of] goodness',
    normalizedText:
      "حتى اذا بلغ مغرب الشمس وجدها تغرب في عين حماة ووجد عندها قوما قلنا يذا القرنين اما ان تعذب واما ان تتخذ فيهم حسنا",
  },
  {
    verseId: 86,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ أَمَّا مَن ظَلَمَ فَسَوۡفَ نُعَذِّبُهُۥ ثُمَّ يُرَدُّ إِلَىٰ رَبِّهِۦ فَيُعَذِّبُهُۥ عَذَابٗا نُّكۡرٗا",
    translation:
      'He said, "As for one who wrongs, we will punish him. Then he will be returned to his Lord, and He will punish him with a terrible punishment',
    normalizedText:
      "قال اما من ظلم فسوف نعذبه ثم يرد الى ربه فيعذبه عذابا نكرا",
  },
  {
    verseId: 87,
    name: "الكهف",
    surahId: 18,
    text: "وَأَمَّا مَنۡ ءَامَنَ وَعَمِلَ صَٰلِحٗا فَلَهُۥ جَزَآءً ٱلۡحُسۡنَىٰۖ وَسَنَقُولُ لَهُۥ مِنۡ أَمۡرِنَا يُسۡرٗا",
    translation:
      "But as for one who believes and does righteousness, he will have a reward of Paradise, and we will speak to him from our command with ease",
    normalizedText:
      "واما من ءامن وعمل صلحا فله جزاء الحسنى وسنقول له من امرنا يسرا",
  },
  {
    verseId: 88,
    name: "الكهف",
    surahId: 18,
    text: "ثُمَّ أَتۡبَعَ سَبَبًا",
    translation: "Then he followed a way",
    normalizedText: "ثم اتبع سببا",
  },
  {
    verseId: 89,
    name: "الكهف",
    surahId: 18,
    text: "حَتَّىٰٓ إِذَا بَلَغَ مَطۡلِعَ ٱلشَّمۡسِ وَجَدَهَا تَطۡلُعُ عَلَىٰ قَوۡمٖ لَّمۡ نَجۡعَل لَّهُم مِّن دُونِهَا سِتۡرٗا",
    translation:
      "Until, when he came to the rising of the sun, he found it rising on a people for whom We had not made against it any shield",
    normalizedText:
      "حتى اذا بلغ مطلع الشمس وجدها تطلع على قوم لم نجعل لهم من دونها سترا",
  },
  {
    verseId: 90,
    name: "الكهف",
    surahId: 18,
    text: "كَذَٰلِكَۖ وَقَدۡ أَحَطۡنَا بِمَا لَدَيۡهِ خُبۡرٗا",
    translation: "Thus. And We had encompassed [all] that he had in knowledge",
    normalizedText: "كذلك وقد احطنا بما لديه خبرا",
  },
  {
    verseId: 91,
    name: "الكهف",
    surahId: 18,
    text: "ثُمَّ أَتۡبَعَ سَبَبًا",
    translation: "Then he followed a way",
    normalizedText: "ثم اتبع سببا",
  },
  {
    verseId: 92,
    name: "الكهف",
    surahId: 18,
    text: "حَتَّىٰٓ إِذَا بَلَغَ بَيۡنَ ٱلسَّدَّيۡنِ وَجَدَ مِن دُونِهِمَا قَوۡمٗا لَّا يَكَادُونَ يَفۡقَهُونَ قَوۡلٗا",
    translation:
      "Until, when he reached [a pass] between two mountains, he found beside them a people who could hardly understand [his] speech",
    normalizedText:
      "حتى اذا بلغ بين السدين وجد من دونهما قوما لا يكادون يفقهون قولا",
  },
  {
    verseId: 93,
    name: "الكهف",
    surahId: 18,
    text: "قَالُواْ يَٰذَا ٱلۡقَرۡنَيۡنِ إِنَّ يَأۡجُوجَ وَمَأۡجُوجَ مُفۡسِدُونَ فِي ٱلۡأَرۡضِ فَهَلۡ نَجۡعَلُ لَكَ خَرۡجًا عَلَىٰٓ أَن تَجۡعَلَ بَيۡنَنَا وَبَيۡنَهُمۡ سَدّٗا",
    translation:
      'They said, "O Dhul-Qarnayn, indeed Gog and Magog are [great] corrupters in the land. So may we assign for you an expenditure that you might make between us and them a barrier',
    normalizedText:
      "قالوا يذا القرنين ان ياجوج وماجوج مفسدون في الارض فهل نجعل لك خرجا على ان تجعل بيننا وبينهم سدا",
  },
  {
    verseId: 94,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ مَا مَكَّنِّي فِيهِ رَبِّي خَيۡرٞ فَأَعِينُونِي بِقُوَّةٍ أَجۡعَلۡ بَيۡنَكُمۡ وَبَيۡنَهُمۡ رَدۡمًا",
    translation:
      'He said, "That in which my Lord has established me is better [than what you offer], but assist me with strength; I will make between you and them a dam',
    normalizedText:
      "قال ما مكني فيه ربي خير فاعينوني بقوة اجعل بينكم وبينهم ردما",
  },
  {
    verseId: 95,
    name: "الكهف",
    surahId: 18,
    text: "ءَاتُونِي زُبَرَ ٱلۡحَدِيدِۖ حَتَّىٰٓ إِذَا سَاوَىٰ بَيۡنَ ٱلصَّدَفَيۡنِ قَالَ ٱنفُخُواْۖ حَتَّىٰٓ إِذَا جَعَلَهُۥ نَارٗا قَالَ ءَاتُونِيٓ أُفۡرِغۡ عَلَيۡهِ قِطۡرٗا",
    translation:
      'Bring me sheets of iron" - until, when he had leveled [them] between the two mountain walls, he said, "Blow [with bellows]," until when he had made it [like] fire, he said, "Bring me, that I may pour over it molten copper',
    normalizedText:
      "ءاتوني زبر الحديد حتى اذا ساوى بين الصدفين قال انفخوا حتى اذا جعله نارا قال ءاتوني افرغ عليه قطرا",
  },
  {
    verseId: 96,
    name: "الكهف",
    surahId: 18,
    text: "فَمَا ٱسۡطَٰعُوٓاْ أَن يَظۡهَرُوهُ وَمَا ٱسۡتَطَٰعُواْ لَهُۥ نَقۡبٗا",
    translation:
      "So Gog and Magog were unable to pass over it, nor were they able [to effect] in it any penetration",
    normalizedText: "فما اسطعوا ان يظهروه وما استطعوا له نقبا",
  },
  {
    verseId: 97,
    name: "الكهف",
    surahId: 18,
    text: "قَالَ هَٰذَا رَحۡمَةٞ مِّن رَّبِّيۖ فَإِذَا جَآءَ وَعۡدُ رَبِّي جَعَلَهُۥ دَكَّآءَۖ وَكَانَ وَعۡدُ رَبِّي حَقّٗا",
    translation:
      '[Dhul-Qarnayn] said, "This is a mercy from my Lord; but when the promise of my Lord comes, He will make it level, and ever is the promise of my Lord true',
    normalizedText:
      "قال هذا رحمة من ربي فاذا جاء وعد ربي جعله دكاء وكان وعد ربي حقا",
  },
  {
    verseId: 98,
    name: "الكهف",
    surahId: 18,
    text: "۞وَتَرَكۡنَا بَعۡضَهُمۡ يَوۡمَئِذٖ يَمُوجُ فِي بَعۡضٖۖ وَنُفِخَ فِي ٱلصُّورِ فَجَمَعۡنَٰهُمۡ جَمۡعٗا",
    translation:
      "And We will leave them that day surging over each other, and [then] the Horn will be blown, and We will assemble them in [one] assembly",
    normalizedText:
      "۞وتركنا بعضهم يوماذ يموج في بعض ونفخ في الصور فجمعنهم جمعا",
  },
  {
    verseId: 99,
    name: "الكهف",
    surahId: 18,
    text: "وَعَرَضۡنَا جَهَنَّمَ يَوۡمَئِذٖ لِّلۡكَٰفِرِينَ عَرۡضًا",
    translation:
      "And We will present Hell that Day to the Disbelievers, on display",
    normalizedText: "وعرضنا جهنم يوماذ للكفرين عرضا",
  },
  {
    verseId: 100,
    name: "الكهف",
    surahId: 18,
    text: "ٱلَّذِينَ كَانَتۡ أَعۡيُنُهُمۡ فِي غِطَآءٍ عَن ذِكۡرِي وَكَانُواْ لَا يَسۡتَطِيعُونَ سَمۡعًا",
    translation:
      "Those whose eyes had been within a cover [removed] from My remembrance, and they were not able to hear",
    normalizedText: "الذين كانت اعينهم في غطاء عن ذكري وكانوا لا يستطيعون سمعا",
  },
  {
    verseId: 101,
    name: "الكهف",
    surahId: 18,
    text: "أَفَحَسِبَ ٱلَّذِينَ كَفَرُوٓاْ أَن يَتَّخِذُواْ عِبَادِي مِن دُونِيٓ أَوۡلِيَآءَۚ إِنَّآ أَعۡتَدۡنَا جَهَنَّمَ لِلۡكَٰفِرِينَ نُزُلٗا",
    translation:
      "Then do those who disbelieve think that they can take My servants instead of Me as allies? Indeed, We have prepared Hell for the disbelievers as a lodging",
    normalizedText:
      "افحسب الذين كفروا ان يتخذوا عبادي من دوني اولياء انا اعتدنا جهنم للكفرين نزلا",
  },
  {
    verseId: 102,
    name: "الكهف",
    surahId: 18,
    text: "قُلۡ هَلۡ نُنَبِّئُكُم بِٱلۡأَخۡسَرِينَ أَعۡمَٰلًا",
    translation:
      'Say, [O Muhammad], "Shall we [believers] inform you of the greatest losers as to [their] deeds',
    normalizedText: "قل هل ننباكم بالاخسرين اعملا",
  },
  {
    verseId: 103,
    name: "الكهف",
    surahId: 18,
    text: "ٱلَّذِينَ ضَلَّ سَعۡيُهُمۡ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَهُمۡ يَحۡسَبُونَ أَنَّهُمۡ يُحۡسِنُونَ صُنۡعًا",
    translation:
      "[They are] those whose effort is lost in worldly life, while they think that they are doing well in work",
    normalizedText:
      "الذين ضل سعيهم في الحيوة الدنيا وهم يحسبون انهم يحسنون صنعا",
  },
  {
    verseId: 104,
    name: "الكهف",
    surahId: 18,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ كَفَرُواْ بِـَٔايَٰتِ رَبِّهِمۡ وَلِقَآئِهِۦ فَحَبِطَتۡ أَعۡمَٰلُهُمۡ فَلَا نُقِيمُ لَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ وَزۡنٗا",
    translation:
      "Those are the ones who disbelieve in the verses of their Lord and in [their] meeting Him, so their deeds have become worthless; and We will not assign to them on the Day of Resurrection any importance",
    normalizedText:
      "اولاك الذين كفروا بايت ربهم ولقااه فحبطت اعملهم فلا نقيم لهم يوم القيمة وزنا",
  },
  {
    verseId: 105,
    name: "الكهف",
    surahId: 18,
    text: "ذَٰلِكَ جَزَآؤُهُمۡ جَهَنَّمُ بِمَا كَفَرُواْ وَٱتَّخَذُوٓاْ ءَايَٰتِي وَرُسُلِي هُزُوًا",
    translation:
      "That is their recompense - Hell - for what they denied and [because] they took My signs and My messengers in ridicule",
    normalizedText: "ذلك جزااهم جهنم بما كفروا واتخذوا ءايتي ورسلي هزوا",
  },
  {
    verseId: 106,
    name: "الكهف",
    surahId: 18,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ كَانَتۡ لَهُمۡ جَنَّـٰتُ ٱلۡفِرۡدَوۡسِ نُزُلًا",
    translation:
      "Indeed, those who have believed and done righteous deeds - they will have the Gardens of Paradise as a lodging",
    normalizedText: "ان الذين ءامنوا وعملوا الصلحت كانت لهم جنت الفردوس نزلا",
  },
  {
    verseId: 107,
    name: "الكهف",
    surahId: 18,
    text: "خَٰلِدِينَ فِيهَا لَا يَبۡغُونَ عَنۡهَا حِوَلٗا",
    translation:
      "Wherein they abide eternally. They will not desire from it any transfer",
    normalizedText: "خلدين فيها لا يبغون عنها حولا",
  },
  {
    verseId: 108,
    name: "الكهف",
    surahId: 18,
    text: "قُل لَّوۡ كَانَ ٱلۡبَحۡرُ مِدَادٗا لِّكَلِمَٰتِ رَبِّي لَنَفِدَ ٱلۡبَحۡرُ قَبۡلَ أَن تَنفَدَ كَلِمَٰتُ رَبِّي وَلَوۡ جِئۡنَا بِمِثۡلِهِۦ مَدَدٗا",
    translation:
      'Say, "If the sea were ink for [writing] the words of my Lord, the sea would be exhausted before the words of my Lord were exhausted, even if We brought the like of it as a supplement',
    normalizedText:
      "قل لو كان البحر مدادا لكلمت ربي لنفد البحر قبل ان تنفد كلمت ربي ولو جانا بمثله مددا",
  },
  {
    verseId: 109,
    name: "الكهف",
    surahId: 18,
    text: "قُلۡ إِنَّمَآ أَنَا۠ بَشَرٞ مِّثۡلُكُمۡ يُوحَىٰٓ إِلَيَّ أَنَّمَآ إِلَٰهُكُمۡ إِلَٰهٞ وَٰحِدٞۖ فَمَن كَانَ يَرۡجُواْ لِقَآءَ رَبِّهِۦ فَلۡيَعۡمَلۡ عَمَلٗا صَٰلِحٗا وَلَا يُشۡرِكۡ بِعِبَادَةِ رَبِّهِۦٓ أَحَدَۢا",
    translation:
      'Say, "I am only a man like you, to whom has been revealed that your god is one God. So whoever would hope for the meeting with his Lord - let him do righteous work and not associate in the worship of his Lord anyone',
    normalizedText:
      "قل انما انا بشر مثلكم يوحى الي انما الهكم اله وحد فمن كان يرجوا لقاء ربه فليعمل عملا صلحا ولا يشرك بعبادة ربه احدا",
  },
  {
    verseId: 0,
    name: "مريم",
    surahId: 19,
    text: "كٓهيعٓصٓ",
    translation: "Kaf, Ha, Ya, 'Ayn, Sad",
    normalizedText: "كهيعص",
  },
  {
    verseId: 1,
    name: "مريم",
    surahId: 19,
    text: "ذِكۡرُ رَحۡمَتِ رَبِّكَ عَبۡدَهُۥ زَكَرِيَّآ",
    translation:
      "[This is] a mention of the mercy of your Lord to His servant Zechariah",
    normalizedText: "ذكر رحمت ربك عبده زكريا",
  },
  {
    verseId: 2,
    name: "مريم",
    surahId: 19,
    text: "إِذۡ نَادَىٰ رَبَّهُۥ نِدَآءً خَفِيّٗا",
    translation: "When he called to his Lord a private supplication",
    normalizedText: "اذ نادى ربه نداء خفيا",
  },
  {
    verseId: 3,
    name: "مريم",
    surahId: 19,
    text: "قَالَ رَبِّ إِنِّي وَهَنَ ٱلۡعَظۡمُ مِنِّي وَٱشۡتَعَلَ ٱلرَّأۡسُ شَيۡبٗا وَلَمۡ أَكُنۢ بِدُعَآئِكَ رَبِّ شَقِيّٗا",
    translation:
      'He said, "My Lord, indeed my bones have weakened, and my head has filled with white, and never have I been in my supplication to You, my Lord, unhappy',
    normalizedText:
      "قال رب اني وهن العظم مني واشتعل الراس شيبا ولم اكن بدعااك رب شقيا",
  },
  {
    verseId: 4,
    name: "مريم",
    surahId: 19,
    text: "وَإِنِّي خِفۡتُ ٱلۡمَوَٰلِيَ مِن وَرَآءِي وَكَانَتِ ٱمۡرَأَتِي عَاقِرٗا فَهَبۡ لِي مِن لَّدُنكَ وَلِيّٗا",
    translation:
      "And indeed, I fear the successors after me, and my wife has been barren, so give me from Yourself an heir",
    normalizedText:
      "واني خفت المولي من وراءي وكانت امراتي عاقرا فهب لي من لدنك وليا",
  },
  {
    verseId: 5,
    name: "مريم",
    surahId: 19,
    text: "يَرِثُنِي وَيَرِثُ مِنۡ ءَالِ يَعۡقُوبَۖ وَٱجۡعَلۡهُ رَبِّ رَضِيّٗا",
    translation:
      "Who will inherit me and inherit from the family of Jacob. And make him, my Lord, pleasing [to You]",
    normalizedText: "يرثني ويرث من ءال يعقوب واجعله رب رضيا",
  },
  {
    verseId: 6,
    name: "مريم",
    surahId: 19,
    text: "يَٰزَكَرِيَّآ إِنَّا نُبَشِّرُكَ بِغُلَٰمٍ ٱسۡمُهُۥ يَحۡيَىٰ لَمۡ نَجۡعَل لَّهُۥ مِن قَبۡلُ سَمِيّٗا",
    translation:
      '[He was told], "O Zechariah, indeed We give you good tidings of a boy whose name will be John. We have not assigned to any before [this] name',
    normalizedText: "يزكريا انا نبشرك بغلم اسمه يحيى لم نجعل له من قبل سميا",
  },
  {
    verseId: 7,
    name: "مريم",
    surahId: 19,
    text: "قَالَ رَبِّ أَنَّىٰ يَكُونُ لِي غُلَٰمٞ وَكَانَتِ ٱمۡرَأَتِي عَاقِرٗا وَقَدۡ بَلَغۡتُ مِنَ ٱلۡكِبَرِ عِتِيّٗا",
    translation:
      'He said, "My Lord, how will I have a boy when my wife has been barren and I have reached extreme old age',
    normalizedText:
      "قال رب انى يكون لي غلم وكانت امراتي عاقرا وقد بلغت من الكبر عتيا",
  },
  {
    verseId: 8,
    name: "مريم",
    surahId: 19,
    text: "قَالَ كَذَٰلِكَ قَالَ رَبُّكَ هُوَ عَلَيَّ هَيِّنٞ وَقَدۡ خَلَقۡتُكَ مِن قَبۡلُ وَلَمۡ تَكُ شَيۡـٔٗا",
    translation: `[An angel] said, "Thus [it will be]; your Lord says, 'It is easy for Me, for I created you before, while you were nothing`,
    normalizedText: "قال كذلك قال ربك هو علي هين وقد خلقتك من قبل ولم تك شيا",
  },
  {
    verseId: 9,
    name: "مريم",
    surahId: 19,
    text: "قَالَ رَبِّ ٱجۡعَل لِّيٓ ءَايَةٗۖ قَالَ ءَايَتُكَ أَلَّا تُكَلِّمَ ٱلنَّاسَ ثَلَٰثَ لَيَالٖ سَوِيّٗا",
    translation:
      '[Zechariah] said, "My Lord, make for me a sign." He said, "Your sign is that you will not speak to the people for three nights, [being] sound',
    normalizedText:
      "قال رب اجعل لي ءاية قال ءايتك الا تكلم الناس ثلث ليال سويا",
  },
  {
    verseId: 10,
    name: "مريم",
    surahId: 19,
    text: "فَخَرَجَ عَلَىٰ قَوۡمِهِۦ مِنَ ٱلۡمِحۡرَابِ فَأَوۡحَىٰٓ إِلَيۡهِمۡ أَن سَبِّحُواْ بُكۡرَةٗ وَعَشِيّٗا",
    translation:
      "So he came out to his people from the prayer chamber and signaled to them to exalt [Allah] in the morning and afternoon",
    normalizedText: "فخرج على قومه من المحراب فاوحى اليهم ان سبحوا بكرة وعشيا",
  },
  {
    verseId: 11,
    name: "مريم",
    surahId: 19,
    text: "يَٰيَحۡيَىٰ خُذِ ٱلۡكِتَٰبَ بِقُوَّةٖۖ وَءَاتَيۡنَٰهُ ٱلۡحُكۡمَ صَبِيّٗا",
    translation:
      '[Allah] said, "O John, take the Scripture with determination." And We gave him judgement [while yet] a boy',
    normalizedText: "ييحيى خذ الكتب بقوة وءاتينه الحكم صبيا",
  },
  {
    verseId: 12,
    name: "مريم",
    surahId: 19,
    text: "وَحَنَانٗا مِّن لَّدُنَّا وَزَكَوٰةٗۖ وَكَانَ تَقِيّٗا",
    translation:
      "And affection from Us and purity, and he was fearing of Allah",
    normalizedText: "وحنانا من لدنا وزكوة وكان تقيا",
  },
  {
    verseId: 13,
    name: "مريم",
    surahId: 19,
    text: "وَبَرَّۢا بِوَٰلِدَيۡهِ وَلَمۡ يَكُن جَبَّارًا عَصِيّٗا",
    translation:
      "And dutiful to his parents, and he was not a disobedient tyrant",
    normalizedText: "وبرا بولديه ولم يكن جبارا عصيا",
  },
  {
    verseId: 14,
    name: "مريم",
    surahId: 19,
    text: "وَسَلَٰمٌ عَلَيۡهِ يَوۡمَ وُلِدَ وَيَوۡمَ يَمُوتُ وَيَوۡمَ يُبۡعَثُ حَيّٗا",
    translation:
      "And peace be upon him the day he was born and the day he dies and the day he is raised alive",
    normalizedText: "وسلم عليه يوم ولد ويوم يموت ويوم يبعث حيا",
  },
  {
    verseId: 15,
    name: "مريم",
    surahId: 19,
    text: "وَٱذۡكُرۡ فِي ٱلۡكِتَٰبِ مَرۡيَمَ إِذِ ٱنتَبَذَتۡ مِنۡ أَهۡلِهَا مَكَانٗا شَرۡقِيّٗا",
    translation:
      "And mention, [O Muhammad], in the Book [the story of] Mary, when she withdrew from her family to a place toward the east",
    normalizedText: "واذكر في الكتب مريم اذ انتبذت من اهلها مكانا شرقيا",
  },
  {
    verseId: 16,
    name: "مريم",
    surahId: 19,
    text: "فَٱتَّخَذَتۡ مِن دُونِهِمۡ حِجَابٗا فَأَرۡسَلۡنَآ إِلَيۡهَا رُوحَنَا فَتَمَثَّلَ لَهَا بَشَرٗا سَوِيّٗا",
    translation:
      "And she took, in seclusion from them, a screen. Then We sent to her Our Angel, and he represented himself to her as a well-proportioned man",
    normalizedText:
      "فاتخذت من دونهم حجابا فارسلنا اليها روحنا فتمثل لها بشرا سويا",
  },
  {
    verseId: 17,
    name: "مريم",
    surahId: 19,
    text: "قَالَتۡ إِنِّيٓ أَعُوذُ بِٱلرَّحۡمَٰنِ مِنكَ إِن كُنتَ تَقِيّٗا",
    translation:
      'She said, "Indeed, I seek refuge in the Most Merciful from you, [so leave me], if you should be fearing of Allah',
    normalizedText: "قالت اني اعوذ بالرحمن منك ان كنت تقيا",
  },
  {
    verseId: 18,
    name: "مريم",
    surahId: 19,
    text: "قَالَ إِنَّمَآ أَنَا۠ رَسُولُ رَبِّكِ لِأَهَبَ لَكِ غُلَٰمٗا زَكِيّٗا",
    translation:
      'He said, "I am only the messenger of your Lord to give you [news of] a pure boy',
    normalizedText: "قال انما انا رسول ربك لاهب لك غلما زكيا",
  },
  {
    verseId: 19,
    name: "مريم",
    surahId: 19,
    text: "قَالَتۡ أَنَّىٰ يَكُونُ لِي غُلَٰمٞ وَلَمۡ يَمۡسَسۡنِي بَشَرٞ وَلَمۡ أَكُ بَغِيّٗا",
    translation:
      'She said, "How can I have a boy while no man has touched me and I have not been unchaste',
    normalizedText: "قالت انى يكون لي غلم ولم يمسسني بشر ولم اك بغيا",
  },
  {
    verseId: 20,
    name: "مريم",
    surahId: 19,
    text: "قَالَ كَذَٰلِكِ قَالَ رَبُّكِ هُوَ عَلَيَّ هَيِّنٞۖ وَلِنَجۡعَلَهُۥٓ ءَايَةٗ لِّلنَّاسِ وَرَحۡمَةٗ مِّنَّاۚ وَكَانَ أَمۡرٗا مَّقۡضِيّٗا",
    translation: `He said, "Thus [it will be]; your Lord says, 'It is easy for Me, and We will make him a sign to the people and a mercy from Us. And it is a matter [already] decreed`,
    normalizedText:
      "قال كذلك قال ربك هو علي هين ولنجعله ءاية للناس ورحمة منا وكان امرا مقضيا",
  },
  {
    verseId: 21,
    name: "مريم",
    surahId: 19,
    text: "۞فَحَمَلَتۡهُ فَٱنتَبَذَتۡ بِهِۦ مَكَانٗا قَصِيّٗا",
    translation:
      "So she conceived him, and she withdrew with him to a remote place",
    normalizedText: "۞فحملته فانتبذت به مكانا قصيا",
  },
  {
    verseId: 22,
    name: "مريم",
    surahId: 19,
    text: "فَأَجَآءَهَا ٱلۡمَخَاضُ إِلَىٰ جِذۡعِ ٱلنَّخۡلَةِ قَالَتۡ يَٰلَيۡتَنِي مِتُّ قَبۡلَ هَٰذَا وَكُنتُ نَسۡيٗا مَّنسِيّٗا",
    translation:
      'And the pains of childbirth drove her to the trunk of a palm tree. She said, "Oh, I wish I had died before this and was in oblivion, forgotten',
    normalizedText:
      "فاجاءها المخاض الى جذع النخلة قالت يليتني مت قبل هذا وكنت نسيا منسيا",
  },
  {
    verseId: 23,
    name: "مريم",
    surahId: 19,
    text: "فَنَادَىٰهَا مِن تَحۡتِهَآ أَلَّا تَحۡزَنِي قَدۡ جَعَلَ رَبُّكِ تَحۡتَكِ سَرِيّٗا",
    translation:
      'But he called her from below her, "Do not grieve; your Lord has provided beneath you a stream',
    normalizedText: "فنادىها من تحتها الا تحزني قد جعل ربك تحتك سريا",
  },
  {
    verseId: 24,
    name: "مريم",
    surahId: 19,
    text: "وَهُزِّيٓ إِلَيۡكِ بِجِذۡعِ ٱلنَّخۡلَةِ تُسَٰقِطۡ عَلَيۡكِ رُطَبٗا جَنِيّٗا",
    translation:
      "And shake toward you the trunk of the palm tree; it will drop upon you ripe, fresh dates",
    normalizedText: "وهزي اليك بجذع النخلة تسقط عليك رطبا جنيا",
  },
  {
    verseId: 25,
    name: "مريم",
    surahId: 19,
    text: "فَكُلِي وَٱشۡرَبِي وَقَرِّي عَيۡنٗاۖ فَإِمَّا تَرَيِنَّ مِنَ ٱلۡبَشَرِ أَحَدٗا فَقُولِيٓ إِنِّي نَذَرۡتُ لِلرَّحۡمَٰنِ صَوۡمٗا فَلَنۡ أُكَلِّمَ ٱلۡيَوۡمَ إِنسِيّٗا",
    translation:
      "So eat and drink and be contented. And if you see from among humanity anyone, say, 'Indeed, I have vowed to the Most Merciful abstention, so I will not speak today to [any] man",
    normalizedText:
      "فكلي واشربي وقري عينا فاما ترين من البشر احدا فقولي اني نذرت للرحمن صوما فلن اكلم اليوم انسيا",
  },
  {
    verseId: 26,
    name: "مريم",
    surahId: 19,
    text: "فَأَتَتۡ بِهِۦ قَوۡمَهَا تَحۡمِلُهُۥۖ قَالُواْ يَٰمَرۡيَمُ لَقَدۡ جِئۡتِ شَيۡـٔٗا فَرِيّٗا",
    translation:
      'Then she brought him to her people, carrying him. They said, "O Mary, you have certainly done a thing unprecedented',
    normalizedText: "فاتت به قومها تحمله قالوا يمريم لقد جات شيا فريا",
  },
  {
    verseId: 27,
    name: "مريم",
    surahId: 19,
    text: "يَـٰٓأُخۡتَ هَٰرُونَ مَا كَانَ أَبُوكِ ٱمۡرَأَ سَوۡءٖ وَمَا كَانَتۡ أُمُّكِ بَغِيّٗا",
    translation:
      "O sister of Aaron, your father was not a man of evil, nor was your mother unchaste",
    normalizedText: "ياخت هرون ما كان ابوك امرا سوء وما كانت امك بغيا",
  },
  {
    verseId: 28,
    name: "مريم",
    surahId: 19,
    text: "فَأَشَارَتۡ إِلَيۡهِۖ قَالُواْ كَيۡفَ نُكَلِّمُ مَن كَانَ فِي ٱلۡمَهۡدِ صَبِيّٗا",
    translation:
      'So she pointed to him. They said, "How can we speak to one who is in the cradle a child',
    normalizedText: "فاشارت اليه قالوا كيف نكلم من كان في المهد صبيا",
  },
  {
    verseId: 29,
    name: "مريم",
    surahId: 19,
    text: "قَالَ إِنِّي عَبۡدُ ٱللَّهِ ءَاتَىٰنِيَ ٱلۡكِتَٰبَ وَجَعَلَنِي نَبِيّٗا",
    translation:
      '[Jesus] said, "Indeed, I am the servant of Allah. He has given me the Scripture and made me a prophet',
    normalizedText: "قال اني عبد الله ءاتىني الكتب وجعلني نبيا",
  },
  {
    verseId: 30,
    name: "مريم",
    surahId: 19,
    text: "وَجَعَلَنِي مُبَارَكًا أَيۡنَ مَا كُنتُ وَأَوۡصَٰنِي بِٱلصَّلَوٰةِ وَٱلزَّكَوٰةِ مَا دُمۡتُ حَيّٗا",
    translation:
      "And He has made me blessed wherever I am and has enjoined upon me prayer and zakah as long as I remain alive",
    normalizedText:
      "وجعلني مباركا اين ما كنت واوصني بالصلوة والزكوة ما دمت حيا",
  },
  {
    verseId: 31,
    name: "مريم",
    surahId: 19,
    text: "وَبَرَّۢا بِوَٰلِدَتِي وَلَمۡ يَجۡعَلۡنِي جَبَّارٗا شَقِيّٗا",
    translation:
      "And [made me] dutiful to my mother, and He has not made me a wretched tyrant",
    normalizedText: "وبرا بولدتي ولم يجعلني جبارا شقيا",
  },
  {
    verseId: 32,
    name: "مريم",
    surahId: 19,
    text: "وَٱلسَّلَٰمُ عَلَيَّ يَوۡمَ وُلِدتُّ وَيَوۡمَ أَمُوتُ وَيَوۡمَ أُبۡعَثُ حَيّٗا",
    translation:
      "And peace is on me the day I was born and the day I will die and the day I am raised alive",
    normalizedText: "والسلم علي يوم ولدت ويوم اموت ويوم ابعث حيا",
  },
  {
    verseId: 33,
    name: "مريم",
    surahId: 19,
    text: "ذَٰلِكَ عِيسَى ٱبۡنُ مَرۡيَمَۖ قَوۡلَ ٱلۡحَقِّ ٱلَّذِي فِيهِ يَمۡتَرُونَ",
    translation:
      "That is Jesus, the son of Mary - the word of truth about which they are in dispute",
    normalizedText: "ذلك عيسى ابن مريم قول الحق الذي فيه يمترون",
  },
  {
    verseId: 34,
    name: "مريم",
    surahId: 19,
    text: "مَا كَانَ لِلَّهِ أَن يَتَّخِذَ مِن وَلَدٖۖ سُبۡحَٰنَهُۥٓۚ إِذَا قَضَىٰٓ أَمۡرٗا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ",
    translation:
      'It is not [befitting] for Allah to take a son; exalted is He! When He decrees an affair, He only says to it, "Be," and it is',
    normalizedText:
      "ما كان لله ان يتخذ من ولد سبحنه اذا قضى امرا فانما يقول له كن فيكون",
  },
  {
    verseId: 35,
    name: "مريم",
    surahId: 19,
    text: "وَإِنَّ ٱللَّهَ رَبِّي وَرَبُّكُمۡ فَٱعۡبُدُوهُۚ هَٰذَا صِرَٰطٞ مُّسۡتَقِيمٞ",
    translation:
      '[Jesus said], "And indeed, Allah is my Lord and your Lord, so worship Him. That is a straight path',
    normalizedText: "وان الله ربي وربكم فاعبدوه هذا صرط مستقيم",
  },
  {
    verseId: 36,
    name: "مريم",
    surahId: 19,
    text: "فَٱخۡتَلَفَ ٱلۡأَحۡزَابُ مِنۢ بَيۡنِهِمۡۖ فَوَيۡلٞ لِّلَّذِينَ كَفَرُواْ مِن مَّشۡهَدِ يَوۡمٍ عَظِيمٍ",
    translation:
      "Then the factions differed [concerning Jesus] from among them, so woe to those who disbelieved - from the scene of a tremendous Day",
    normalizedText: "فاختلف الاحزاب من بينهم فويل للذين كفروا من مشهد يوم عظيم",
  },
  {
    verseId: 37,
    name: "مريم",
    surahId: 19,
    text: "أَسۡمِعۡ بِهِمۡ وَأَبۡصِرۡ يَوۡمَ يَأۡتُونَنَا لَٰكِنِ ٱلظَّـٰلِمُونَ ٱلۡيَوۡمَ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      "How [clearly] they will hear and see the Day they come to Us, but the wrongdoers today are in clear error",
    normalizedText: "اسمع بهم وابصر يوم ياتوننا لكن الظلمون اليوم في ضلل مبين",
  },
  {
    verseId: 38,
    name: "مريم",
    surahId: 19,
    text: "وَأَنذِرۡهُمۡ يَوۡمَ ٱلۡحَسۡرَةِ إِذۡ قُضِيَ ٱلۡأَمۡرُ وَهُمۡ فِي غَفۡلَةٖ وَهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "And warn them, [O Muhammad], of the Day of Regret, when the matter will be concluded; and [yet], they are in [a state of] heedlessness, and they do not believe",
    normalizedText: "وانذرهم يوم الحسرة اذ قضي الامر وهم في غفلة وهم لا يامنون",
  },
  {
    verseId: 39,
    name: "مريم",
    surahId: 19,
    text: "إِنَّا نَحۡنُ نَرِثُ ٱلۡأَرۡضَ وَمَنۡ عَلَيۡهَا وَإِلَيۡنَا يُرۡجَعُونَ",
    translation:
      "Indeed, it is We who will inherit the earth and whoever is on it, and to Us they will be returned",
    normalizedText: "انا نحن نرث الارض ومن عليها والينا يرجعون",
  },
  {
    verseId: 40,
    name: "مريم",
    surahId: 19,
    text: "وَٱذۡكُرۡ فِي ٱلۡكِتَٰبِ إِبۡرَٰهِيمَۚ إِنَّهُۥ كَانَ صِدِّيقٗا نَّبِيًّا",
    translation:
      "And mention in the Book [the story of] Abraham. Indeed, he was a man of truth and a prophet",
    normalizedText: "واذكر في الكتب ابرهيم انه كان صديقا نبيا",
  },
  {
    verseId: 41,
    name: "مريم",
    surahId: 19,
    text: "إِذۡ قَالَ لِأَبِيهِ يَـٰٓأَبَتِ لِمَ تَعۡبُدُ مَا لَا يَسۡمَعُ وَلَا يُبۡصِرُ وَلَا يُغۡنِي عَنكَ شَيۡـٔٗا",
    translation:
      '[Mention] when he said to his father, "O my father, why do you worship that which does not hear and does not see and will not benefit you at all',
    normalizedText:
      "اذ قال لابيه يابت لم تعبد ما لا يسمع ولا يبصر ولا يغني عنك شيا",
  },
  {
    verseId: 42,
    name: "مريم",
    surahId: 19,
    text: "يَـٰٓأَبَتِ إِنِّي قَدۡ جَآءَنِي مِنَ ٱلۡعِلۡمِ مَا لَمۡ يَأۡتِكَ فَٱتَّبِعۡنِيٓ أَهۡدِكَ صِرَٰطٗا سَوِيّٗا",
    translation:
      "O my father, indeed there has come to me of knowledge that which has not come to you, so follow me; I will guide you to an even path",
    normalizedText:
      "يابت اني قد جاءني من العلم ما لم ياتك فاتبعني اهدك صرطا سويا",
  },
  {
    verseId: 43,
    name: "مريم",
    surahId: 19,
    text: "يَـٰٓأَبَتِ لَا تَعۡبُدِ ٱلشَّيۡطَٰنَۖ إِنَّ ٱلشَّيۡطَٰنَ كَانَ لِلرَّحۡمَٰنِ عَصِيّٗا",
    translation:
      "O my father, do not worship Satan. Indeed Satan has ever been, to the Most Merciful, disobedient",
    normalizedText: "يابت لا تعبد الشيطن ان الشيطن كان للرحمن عصيا",
  },
  {
    verseId: 44,
    name: "مريم",
    surahId: 19,
    text: "يَـٰٓأَبَتِ إِنِّيٓ أَخَافُ أَن يَمَسَّكَ عَذَابٞ مِّنَ ٱلرَّحۡمَٰنِ فَتَكُونَ لِلشَّيۡطَٰنِ وَلِيّٗا",
    translation:
      "O my father, indeed I fear that there will touch you a punishment from the Most Merciful so you would be to Satan a companion [in Hellfire]",
    normalizedText: "يابت اني اخاف ان يمسك عذاب من الرحمن فتكون للشيطن وليا",
  },
  {
    verseId: 45,
    name: "مريم",
    surahId: 19,
    text: "قَالَ أَرَاغِبٌ أَنتَ عَنۡ ءَالِهَتِي يَـٰٓإِبۡرَٰهِيمُۖ لَئِن لَّمۡ تَنتَهِ لَأَرۡجُمَنَّكَۖ وَٱهۡجُرۡنِي مَلِيّٗا",
    translation:
      '[His father] said, "Have you no desire for my gods, O Abraham? If you do not desist, I will surely stone you, so avoid me a prolonged time',
    normalizedText:
      "قال اراغب انت عن ءالهتي يابرهيم لان لم تنته لارجمنك واهجرني مليا",
  },
  {
    verseId: 46,
    name: "مريم",
    surahId: 19,
    text: "قَالَ سَلَٰمٌ عَلَيۡكَۖ سَأَسۡتَغۡفِرُ لَكَ رَبِّيٓۖ إِنَّهُۥ كَانَ بِي حَفِيّٗا",
    translation:
      '[Abraham] said, "Peace will be upon you. I will ask forgiveness for you of my Lord. Indeed, He is ever gracious to me',
    normalizedText: "قال سلم عليك ساستغفر لك ربي انه كان بي حفيا",
  },
  {
    verseId: 47,
    name: "مريم",
    surahId: 19,
    text: "وَأَعۡتَزِلُكُمۡ وَمَا تَدۡعُونَ مِن دُونِ ٱللَّهِ وَأَدۡعُواْ رَبِّي عَسَىٰٓ أَلَّآ أَكُونَ بِدُعَآءِ رَبِّي شَقِيّٗا",
    translation:
      "And I will leave you and those you invoke other than Allah and will invoke my Lord. I expect that I will not be in invocation to my Lord unhappy",
    normalizedText:
      "واعتزلكم وما تدعون من دون الله وادعوا ربي عسى الا اكون بدعاء ربي شقيا",
  },
  {
    verseId: 48,
    name: "مريم",
    surahId: 19,
    text: "فَلَمَّا ٱعۡتَزَلَهُمۡ وَمَا يَعۡبُدُونَ مِن دُونِ ٱللَّهِ وَهَبۡنَا لَهُۥٓ إِسۡحَٰقَ وَيَعۡقُوبَۖ وَكُلّٗا جَعَلۡنَا نَبِيّٗا",
    translation:
      "So when he had left them and those they worshipped other than Allah, We gave him Isaac and Jacob, and each [of them] We made a prophet",
    normalizedText:
      "فلما اعتزلهم وما يعبدون من دون الله وهبنا له اسحق ويعقوب وكلا جعلنا نبيا",
  },
  {
    verseId: 49,
    name: "مريم",
    surahId: 19,
    text: "وَوَهَبۡنَا لَهُم مِّن رَّحۡمَتِنَا وَجَعَلۡنَا لَهُمۡ لِسَانَ صِدۡقٍ عَلِيّٗا",
    translation:
      "And We gave them of Our mercy, and we made for them a reputation of high honor",
    normalizedText: "ووهبنا لهم من رحمتنا وجعلنا لهم لسان صدق عليا",
  },
  {
    verseId: 50,
    name: "مريم",
    surahId: 19,
    text: "وَٱذۡكُرۡ فِي ٱلۡكِتَٰبِ مُوسَىٰٓۚ إِنَّهُۥ كَانَ مُخۡلَصٗا وَكَانَ رَسُولٗا نَّبِيّٗا",
    translation:
      "And mention in the Book, Moses. Indeed, he was chosen, and he was a messenger and a prophet",
    normalizedText: "واذكر في الكتب موسى انه كان مخلصا وكان رسولا نبيا",
  },
  {
    verseId: 51,
    name: "مريم",
    surahId: 19,
    text: "وَنَٰدَيۡنَٰهُ مِن جَانِبِ ٱلطُّورِ ٱلۡأَيۡمَنِ وَقَرَّبۡنَٰهُ نَجِيّٗا",
    translation:
      "And We called him from the side of the mount at [his] right and brought him near, confiding [to him]",
    normalizedText: "وندينه من جانب الطور الايمن وقربنه نجيا",
  },
  {
    verseId: 52,
    name: "مريم",
    surahId: 19,
    text: "وَوَهَبۡنَا لَهُۥ مِن رَّحۡمَتِنَآ أَخَاهُ هَٰرُونَ نَبِيّٗا",
    translation:
      "And We gave him out of Our mercy his brother Aaron as a prophet",
    normalizedText: "ووهبنا له من رحمتنا اخاه هرون نبيا",
  },
  {
    verseId: 53,
    name: "مريم",
    surahId: 19,
    text: "وَٱذۡكُرۡ فِي ٱلۡكِتَٰبِ إِسۡمَٰعِيلَۚ إِنَّهُۥ كَانَ صَادِقَ ٱلۡوَعۡدِ وَكَانَ رَسُولٗا نَّبِيّٗا",
    translation:
      "And mention in the Book, Ishmael. Indeed, he was true to his promise, and he was a messenger and a prophet",
    normalizedText: "واذكر في الكتب اسمعيل انه كان صادق الوعد وكان رسولا نبيا",
  },
  {
    verseId: 54,
    name: "مريم",
    surahId: 19,
    text: "وَكَانَ يَأۡمُرُ أَهۡلَهُۥ بِٱلصَّلَوٰةِ وَٱلزَّكَوٰةِ وَكَانَ عِندَ رَبِّهِۦ مَرۡضِيّٗا",
    translation:
      "And he used to enjoin on his people prayer and zakah and was to his Lord pleasing",
    normalizedText: "وكان يامر اهله بالصلوة والزكوة وكان عند ربه مرضيا",
  },
  {
    verseId: 55,
    name: "مريم",
    surahId: 19,
    text: "وَٱذۡكُرۡ فِي ٱلۡكِتَٰبِ إِدۡرِيسَۚ إِنَّهُۥ كَانَ صِدِّيقٗا نَّبِيّٗا",
    translation:
      "And mention in the Book, Idrees. Indeed, he was a man of truth and a prophet",
    normalizedText: "واذكر في الكتب ادريس انه كان صديقا نبيا",
  },
  {
    verseId: 56,
    name: "مريم",
    surahId: 19,
    text: "وَرَفَعۡنَٰهُ مَكَانًا عَلِيًّا",
    translation: "And We raised him to a high station",
    normalizedText: "ورفعنه مكانا عليا",
  },
  {
    verseId: 57,
    name: "مريم",
    surahId: 19,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ أَنۡعَمَ ٱللَّهُ عَلَيۡهِم مِّنَ ٱلنَّبِيِّـۧنَ مِن ذُرِّيَّةِ ءَادَمَ وَمِمَّنۡ حَمَلۡنَا مَعَ نُوحٖ وَمِن ذُرِّيَّةِ إِبۡرَٰهِيمَ وَإِسۡرَـٰٓءِيلَ وَمِمَّنۡ هَدَيۡنَا وَٱجۡتَبَيۡنَآۚ إِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَٰتُ ٱلرَّحۡمَٰنِ خَرُّواْۤ سُجَّدٗاۤ وَبُكِيّٗا۩",
    translation:
      "Those were the ones upon whom Allah bestowed favor from among the prophets of the descendants of Adam and of those We carried [in the ship] with Noah, and of the descendants of Abraham and Israel, and of those whom We guided and chose. When the verses of the Most Merciful were recited to them, they fell in prostration and weeping",
    normalizedText:
      "اولاك الذين انعم الله عليهم من النبين من ذرية ءادم وممن حملنا مع نوح ومن ذرية ابرهيم واسرءيل وممن هدينا واجتبينا اذا تتلى عليهم ءايت الرحمن خروا سجدا وبكيا۩",
  },
  {
    verseId: 58,
    name: "مريم",
    surahId: 19,
    text: "۞فَخَلَفَ مِنۢ بَعۡدِهِمۡ خَلۡفٌ أَضَاعُواْ ٱلصَّلَوٰةَ وَٱتَّبَعُواْ ٱلشَّهَوَٰتِۖ فَسَوۡفَ يَلۡقَوۡنَ غَيًّا",
    translation:
      "But there came after them successors who neglected prayer and pursued desires; so they are going to meet evil",
    normalizedText:
      "۞فخلف من بعدهم خلف اضاعوا الصلوة واتبعوا الشهوت فسوف يلقون غيا",
  },
  {
    verseId: 59,
    name: "مريم",
    surahId: 19,
    text: "إِلَّا مَن تَابَ وَءَامَنَ وَعَمِلَ صَٰلِحٗا فَأُوْلَـٰٓئِكَ يَدۡخُلُونَ ٱلۡجَنَّةَ وَلَا يُظۡلَمُونَ شَيۡـٔٗا",
    translation:
      "Except those who repent, believe and do righteousness; for those will enter Paradise and will not be wronged at all",
    normalizedText:
      "الا من تاب وءامن وعمل صلحا فاولاك يدخلون الجنة ولا يظلمون شيا",
  },
  {
    verseId: 60,
    name: "مريم",
    surahId: 19,
    text: "جَنَّـٰتِ عَدۡنٍ ٱلَّتِي وَعَدَ ٱلرَّحۡمَٰنُ عِبَادَهُۥ بِٱلۡغَيۡبِۚ إِنَّهُۥ كَانَ وَعۡدُهُۥ مَأۡتِيّٗا",
    translation:
      "[Therein are] gardens of perpetual residence which the Most Merciful has promised His servants in the unseen. Indeed, His promise has ever been coming",
    normalizedText: "جنت عدن التي وعد الرحمن عباده بالغيب انه كان وعده ماتيا",
  },
  {
    verseId: 61,
    name: "مريم",
    surahId: 19,
    text: "لَّا يَسۡمَعُونَ فِيهَا لَغۡوًا إِلَّا سَلَٰمٗاۖ وَلَهُمۡ رِزۡقُهُمۡ فِيهَا بُكۡرَةٗ وَعَشِيّٗا",
    translation:
      "They will not hear therein any ill speech - only [greetings of] peace - and they will have their provision therein, morning and afternoon",
    normalizedText: "لا يسمعون فيها لغوا الا سلما ولهم رزقهم فيها بكرة وعشيا",
  },
  {
    verseId: 62,
    name: "مريم",
    surahId: 19,
    text: "تِلۡكَ ٱلۡجَنَّةُ ٱلَّتِي نُورِثُ مِنۡ عِبَادِنَا مَن كَانَ تَقِيّٗا",
    translation:
      "That is Paradise, which We give as inheritance to those of Our servants who were fearing of Allah",
    normalizedText: "تلك الجنة التي نورث من عبادنا من كان تقيا",
  },
  {
    verseId: 63,
    name: "مريم",
    surahId: 19,
    text: "وَمَا نَتَنَزَّلُ إِلَّا بِأَمۡرِ رَبِّكَۖ لَهُۥ مَا بَيۡنَ أَيۡدِينَا وَمَا خَلۡفَنَا وَمَا بَيۡنَ ذَٰلِكَۚ وَمَا كَانَ رَبُّكَ نَسِيّٗا",
    translation:
      '[Gabriel said], "And we [angels] descend not except by the order of your Lord. To Him belongs that before us and that behind us and what is in between. And never is your Lord forgetful',
    normalizedText:
      "وما نتنزل الا بامر ربك له ما بين ايدينا وما خلفنا وما بين ذلك وما كان ربك نسيا",
  },
  {
    verseId: 64,
    name: "مريم",
    surahId: 19,
    text: "رَّبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَا فَٱعۡبُدۡهُ وَٱصۡطَبِرۡ لِعِبَٰدَتِهِۦۚ هَلۡ تَعۡلَمُ لَهُۥ سَمِيّٗا",
    translation:
      "Lord of the heavens and the earth and whatever is between them - so worship Him and have patience for His worship. Do you know of any similarity to Him",
    normalizedText:
      "رب السموت والارض وما بينهما فاعبده واصطبر لعبدته هل تعلم له سميا",
  },
  {
    verseId: 65,
    name: "مريم",
    surahId: 19,
    text: "وَيَقُولُ ٱلۡإِنسَٰنُ أَءِذَا مَا مِتُّ لَسَوۡفَ أُخۡرَجُ حَيًّا",
    translation:
      'And the disbeliever says, "When I have died, am I going to be brought forth alive',
    normalizedText: "ويقول الانسن اءذا ما مت لسوف اخرج حيا",
  },
  {
    verseId: 66,
    name: "مريم",
    surahId: 19,
    text: "أَوَلَا يَذۡكُرُ ٱلۡإِنسَٰنُ أَنَّا خَلَقۡنَٰهُ مِن قَبۡلُ وَلَمۡ يَكُ شَيۡـٔٗا",
    translation:
      "Does man not remember that We created him before, while he was nothing",
    normalizedText: "اولا يذكر الانسن انا خلقنه من قبل ولم يك شيا",
  },
  {
    verseId: 67,
    name: "مريم",
    surahId: 19,
    text: "فَوَرَبِّكَ لَنَحۡشُرَنَّهُمۡ وَٱلشَّيَٰطِينَ ثُمَّ لَنُحۡضِرَنَّهُمۡ حَوۡلَ جَهَنَّمَ جِثِيّٗا",
    translation:
      "So by your Lord, We will surely gather them and the devils; then We will bring them to be present around Hell upon their knees",
    normalizedText: "فوربك لنحشرنهم والشيطين ثم لنحضرنهم حول جهنم جثيا",
  },
  {
    verseId: 68,
    name: "مريم",
    surahId: 19,
    text: "ثُمَّ لَنَنزِعَنَّ مِن كُلِّ شِيعَةٍ أَيُّهُمۡ أَشَدُّ عَلَى ٱلرَّحۡمَٰنِ عِتِيّٗا",
    translation:
      "Then We will surely extract from every sect those of them who were worst against the Most Merciful in insolence",
    normalizedText: "ثم لننزعن من كل شيعة ايهم اشد على الرحمن عتيا",
  },
  {
    verseId: 69,
    name: "مريم",
    surahId: 19,
    text: "ثُمَّ لَنَحۡنُ أَعۡلَمُ بِٱلَّذِينَ هُمۡ أَوۡلَىٰ بِهَا صِلِيّٗا",
    translation:
      "Then, surely it is We who are most knowing of those most worthy of burning therein",
    normalizedText: "ثم لنحن اعلم بالذين هم اولى بها صليا",
  },
  {
    verseId: 70,
    name: "مريم",
    surahId: 19,
    text: "وَإِن مِّنكُمۡ إِلَّا وَارِدُهَاۚ كَانَ عَلَىٰ رَبِّكَ حَتۡمٗا مَّقۡضِيّٗا",
    translation:
      "And there is none of you except he will come to it. This is upon your Lord an inevitability decreed",
    normalizedText: "وان منكم الا واردها كان على ربك حتما مقضيا",
  },
  {
    verseId: 71,
    name: "مريم",
    surahId: 19,
    text: "ثُمَّ نُنَجِّي ٱلَّذِينَ ٱتَّقَواْ وَّنَذَرُ ٱلظَّـٰلِمِينَ فِيهَا جِثِيّٗا",
    translation:
      "Then We will save those who feared Allah and leave the wrongdoers within it, on their knees",
    normalizedText: "ثم ننجي الذين اتقوا ونذر الظلمين فيها جثيا",
  },
  {
    verseId: 72,
    name: "مريم",
    surahId: 19,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَٰتُنَا بَيِّنَٰتٖ قَالَ ٱلَّذِينَ كَفَرُواْ لِلَّذِينَ ءَامَنُوٓاْ أَيُّ ٱلۡفَرِيقَيۡنِ خَيۡرٞ مَّقَامٗا وَأَحۡسَنُ نَدِيّٗا",
    translation:
      'And when Our verses are recited to them as clear evidences, those who disbelieve say to those who believe, "Which of [our] two parties is best in position and best in association',
    normalizedText:
      "واذا تتلى عليهم ءايتنا بينت قال الذين كفروا للذين ءامنوا اي الفريقين خير مقاما واحسن نديا",
  },
  {
    verseId: 73,
    name: "مريم",
    surahId: 19,
    text: "وَكَمۡ أَهۡلَكۡنَا قَبۡلَهُم مِّن قَرۡنٍ هُمۡ أَحۡسَنُ أَثَٰثٗا وَرِءۡيٗا",
    translation:
      "And how many a generation have We destroyed before them who were better in possessions and [outward] appearance",
    normalizedText: "وكم اهلكنا قبلهم من قرن هم احسن اثثا ورءيا",
  },
  {
    verseId: 74,
    name: "مريم",
    surahId: 19,
    text: "قُلۡ مَن كَانَ فِي ٱلضَّلَٰلَةِ فَلۡيَمۡدُدۡ لَهُ ٱلرَّحۡمَٰنُ مَدًّاۚ حَتَّىٰٓ إِذَا رَأَوۡاْ مَا يُوعَدُونَ إِمَّا ٱلۡعَذَابَ وَإِمَّا ٱلسَّاعَةَ فَسَيَعۡلَمُونَ مَنۡ هُوَ شَرّٞ مَّكَانٗا وَأَضۡعَفُ جُندٗا",
    translation:
      'Say, "Whoever is in error - let the Most Merciful extend for him an extension [in wealth and time] until, when they see that which they were promised - either punishment [in this world] or the Hour [of resurrection] - they will come to know who is worst in position and weaker in soldiers',
    normalizedText:
      "قل من كان في الضللة فليمدد له الرحمن مدا حتى اذا راوا ما يوعدون اما العذاب واما الساعة فسيعلمون من هو شر مكانا واضعف جندا",
  },
  {
    verseId: 75,
    name: "مريم",
    surahId: 19,
    text: "وَيَزِيدُ ٱللَّهُ ٱلَّذِينَ ٱهۡتَدَوۡاْ هُدٗىۗ وَٱلۡبَٰقِيَٰتُ ٱلصَّـٰلِحَٰتُ خَيۡرٌ عِندَ رَبِّكَ ثَوَابٗا وَخَيۡرٞ مَّرَدًّا",
    translation:
      "And Allah increases those who were guided, in guidance, and the enduring good deeds are better to your Lord for reward and better for recourse",
    normalizedText:
      "ويزيد الله الذين اهتدوا هدى والبقيت الصلحت خير عند ربك ثوابا وخير مردا",
  },
  {
    verseId: 76,
    name: "مريم",
    surahId: 19,
    text: "أَفَرَءَيۡتَ ٱلَّذِي كَفَرَ بِـَٔايَٰتِنَا وَقَالَ لَأُوتَيَنَّ مَالٗا وَوَلَدًا",
    translation:
      'Then, have you seen he who disbelieved in Our verses and said, "I will surely be given wealth and children [in the next life]',
    normalizedText: "افرءيت الذي كفر بايتنا وقال لاوتين مالا وولدا",
  },
  {
    verseId: 77,
    name: "مريم",
    surahId: 19,
    text: "أَطَّلَعَ ٱلۡغَيۡبَ أَمِ ٱتَّخَذَ عِندَ ٱلرَّحۡمَٰنِ عَهۡدٗا",
    translation:
      "Has he looked into the unseen, or has he taken from the Most Merciful a promise",
    normalizedText: "اطلع الغيب ام اتخذ عند الرحمن عهدا",
  },
  {
    verseId: 78,
    name: "مريم",
    surahId: 19,
    text: "كَلَّاۚ سَنَكۡتُبُ مَا يَقُولُ وَنَمُدُّ لَهُۥ مِنَ ٱلۡعَذَابِ مَدّٗا",
    translation:
      "No! We will record what he says and extend for him from the punishment extensively",
    normalizedText: "كلا سنكتب ما يقول ونمد له من العذاب مدا",
  },
  {
    verseId: 79,
    name: "مريم",
    surahId: 19,
    text: "وَنَرِثُهُۥ مَا يَقُولُ وَيَأۡتِينَا فَرۡدٗا",
    translation:
      "And We will inherit him [in] what he mentions, and he will come to Us alone",
    normalizedText: "ونرثه ما يقول وياتينا فردا",
  },
  {
    verseId: 80,
    name: "مريم",
    surahId: 19,
    text: "وَٱتَّخَذُواْ مِن دُونِ ٱللَّهِ ءَالِهَةٗ لِّيَكُونُواْ لَهُمۡ عِزّٗا",
    translation:
      "And they have taken besides Allah [false] deities that they would be for them [a source of] honor",
    normalizedText: "واتخذوا من دون الله ءالهة ليكونوا لهم عزا",
  },
  {
    verseId: 81,
    name: "مريم",
    surahId: 19,
    text: "كَلَّاۚ سَيَكۡفُرُونَ بِعِبَادَتِهِمۡ وَيَكُونُونَ عَلَيۡهِمۡ ضِدًّا",
    translation:
      'No! Those "gods" will deny their worship of them and will be against them opponents [on the Day of Judgement]',
    normalizedText: "كلا سيكفرون بعبادتهم ويكونون عليهم ضدا",
  },
  {
    verseId: 82,
    name: "مريم",
    surahId: 19,
    text: "أَلَمۡ تَرَ أَنَّآ أَرۡسَلۡنَا ٱلشَّيَٰطِينَ عَلَى ٱلۡكَٰفِرِينَ تَؤُزُّهُمۡ أَزّٗا",
    translation:
      "Do you not see that We have sent the devils upon the disbelievers, inciting them to [evil] with [constant] incitement",
    normalizedText: "الم تر انا ارسلنا الشيطين على الكفرين تازهم ازا",
  },
  {
    verseId: 83,
    name: "مريم",
    surahId: 19,
    text: "فَلَا تَعۡجَلۡ عَلَيۡهِمۡۖ إِنَّمَا نَعُدُّ لَهُمۡ عَدّٗا",
    translation:
      "So be not impatient over them. We only count out to them a [limited] number",
    normalizedText: "فلا تعجل عليهم انما نعد لهم عدا",
  },
  {
    verseId: 84,
    name: "مريم",
    surahId: 19,
    text: "يَوۡمَ نَحۡشُرُ ٱلۡمُتَّقِينَ إِلَى ٱلرَّحۡمَٰنِ وَفۡدٗا",
    translation:
      "On the Day We will gather the righteous to the Most Merciful as a delegation",
    normalizedText: "يوم نحشر المتقين الى الرحمن وفدا",
  },
  {
    verseId: 85,
    name: "مريم",
    surahId: 19,
    text: "وَنَسُوقُ ٱلۡمُجۡرِمِينَ إِلَىٰ جَهَنَّمَ وِرۡدٗا",
    translation: "And will drive the criminals to Hell in thirst",
    normalizedText: "ونسوق المجرمين الى جهنم وردا",
  },
  {
    verseId: 86,
    name: "مريم",
    surahId: 19,
    text: "لَّا يَمۡلِكُونَ ٱلشَّفَٰعَةَ إِلَّا مَنِ ٱتَّخَذَ عِندَ ٱلرَّحۡمَٰنِ عَهۡدٗا",
    translation:
      "None will have [power of] intercession except he who had taken from the Most Merciful a covenant",
    normalizedText: "لا يملكون الشفعة الا من اتخذ عند الرحمن عهدا",
  },
  {
    verseId: 87,
    name: "مريم",
    surahId: 19,
    text: "وَقَالُواْ ٱتَّخَذَ ٱلرَّحۡمَٰنُ وَلَدٗا",
    translation:
      'And they say, "The Most Merciful has taken [for Himself] a son',
    normalizedText: "وقالوا اتخذ الرحمن ولدا",
  },
  {
    verseId: 88,
    name: "مريم",
    surahId: 19,
    text: "لَّقَدۡ جِئۡتُمۡ شَيۡـًٔا إِدّٗا",
    translation: "You have done an atrocious thing",
    normalizedText: "لقد جاتم شيا ادا",
  },
  {
    verseId: 89,
    name: "مريم",
    surahId: 19,
    text: "تَكَادُ ٱلسَّمَٰوَٰتُ يَتَفَطَّرۡنَ مِنۡهُ وَتَنشَقُّ ٱلۡأَرۡضُ وَتَخِرُّ ٱلۡجِبَالُ هَدًّا",
    translation:
      "The heavens almost rupture therefrom and the earth splits open and the mountains collapse in devastation",
    normalizedText: "تكاد السموت يتفطرن منه وتنشق الارض وتخر الجبال هدا",
  },
  {
    verseId: 90,
    name: "مريم",
    surahId: 19,
    text: "أَن دَعَوۡاْ لِلرَّحۡمَٰنِ وَلَدٗا",
    translation: "That they attribute to the Most Merciful a son",
    normalizedText: "ان دعوا للرحمن ولدا",
  },
  {
    verseId: 91,
    name: "مريم",
    surahId: 19,
    text: "وَمَا يَنۢبَغِي لِلرَّحۡمَٰنِ أَن يَتَّخِذَ وَلَدًا",
    translation:
      "And it is not appropriate for the Most Merciful that He should take a son",
    normalizedText: "وما ينبغي للرحمن ان يتخذ ولدا",
  },
  {
    verseId: 92,
    name: "مريم",
    surahId: 19,
    text: "إِن كُلُّ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ إِلَّآ ءَاتِي ٱلرَّحۡمَٰنِ عَبۡدٗا",
    translation:
      "There is no one in the heavens and earth but that he comes to the Most Merciful as a servant",
    normalizedText: "ان كل من في السموت والارض الا ءاتي الرحمن عبدا",
  },
  {
    verseId: 93,
    name: "مريم",
    surahId: 19,
    text: "لَّقَدۡ أَحۡصَىٰهُمۡ وَعَدَّهُمۡ عَدّٗا",
    translation: "He has enumerated them and counted them a [full] counting",
    normalizedText: "لقد احصىهم وعدهم عدا",
  },
  {
    verseId: 94,
    name: "مريم",
    surahId: 19,
    text: "وَكُلُّهُمۡ ءَاتِيهِ يَوۡمَ ٱلۡقِيَٰمَةِ فَرۡدًا",
    translation:
      "And all of them are coming to Him on the Day of Resurrection alone",
    normalizedText: "وكلهم ءاتيه يوم القيمة فردا",
  },
  {
    verseId: 95,
    name: "مريم",
    surahId: 19,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ سَيَجۡعَلُ لَهُمُ ٱلرَّحۡمَٰنُ وُدّٗا",
    translation:
      "Indeed, those who have believed and done righteous deeds - the Most Merciful will appoint for them affection",
    normalizedText: "ان الذين ءامنوا وعملوا الصلحت سيجعل لهم الرحمن ودا",
  },
  {
    verseId: 96,
    name: "مريم",
    surahId: 19,
    text: "فَإِنَّمَا يَسَّرۡنَٰهُ بِلِسَانِكَ لِتُبَشِّرَ بِهِ ٱلۡمُتَّقِينَ وَتُنذِرَ بِهِۦ قَوۡمٗا لُّدّٗا",
    translation:
      "So, [O Muhammad], We have only made Qur'an easy in the Arabic language that you may give good tidings thereby to the righteous and warn thereby a hostile people",
    normalizedText: "فانما يسرنه بلسانك لتبشر به المتقين وتنذر به قوما لدا",
  },
  {
    verseId: 97,
    name: "مريم",
    surahId: 19,
    text: "وَكَمۡ أَهۡلَكۡنَا قَبۡلَهُم مِّن قَرۡنٍ هَلۡ تُحِسُّ مِنۡهُم مِّنۡ أَحَدٍ أَوۡ تَسۡمَعُ لَهُمۡ رِكۡزَۢا",
    translation:
      "And how many have We destroyed before them of generations? Do you perceive of them anyone or hear from them a sound",
    normalizedText:
      "وكم اهلكنا قبلهم من قرن هل تحس منهم من احد او تسمع لهم ركزا",
  },
  {
    verseId: 0,
    name: "طه",
    surahId: 20,
    text: "طه",
    translation: "Ta, Ha",
    normalizedText: "طه",
  },
  {
    verseId: 1,
    name: "طه",
    surahId: 20,
    text: "مَآ أَنزَلۡنَا عَلَيۡكَ ٱلۡقُرۡءَانَ لِتَشۡقَىٰٓ",
    translation:
      "We have not sent down to you the Qur'an that you be distressed",
    normalizedText: "ما انزلنا عليك القرءان لتشقى",
  },
  {
    verseId: 2,
    name: "طه",
    surahId: 20,
    text: "إِلَّا تَذۡكِرَةٗ لِّمَن يَخۡشَىٰ",
    translation: "But only as a reminder for those who fear [Allah]",
    normalizedText: "الا تذكرة لمن يخشى",
  },
  {
    verseId: 3,
    name: "طه",
    surahId: 20,
    text: "تَنزِيلٗا مِّمَّنۡ خَلَقَ ٱلۡأَرۡضَ وَٱلسَّمَٰوَٰتِ ٱلۡعُلَى",
    translation:
      "A revelation from He who created the earth and highest heavens",
    normalizedText: "تنزيلا ممن خلق الارض والسموت العلى",
  },
  {
    verseId: 4,
    name: "طه",
    surahId: 20,
    text: "ٱلرَّحۡمَٰنُ عَلَى ٱلۡعَرۡشِ ٱسۡتَوَىٰ",
    translation: "The Most Merciful [who is] above the Throne established",
    normalizedText: "الرحمن على العرش استوى",
  },
  {
    verseId: 5,
    name: "طه",
    surahId: 20,
    text: "لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ وَمَا بَيۡنَهُمَا وَمَا تَحۡتَ ٱلثَّرَىٰ",
    translation:
      "To Him belongs what is in the heavens and what is on the earth and what is between them and what is under the soil",
    normalizedText: "له ما في السموت وما في الارض وما بينهما وما تحت الثرى",
  },
  {
    verseId: 6,
    name: "طه",
    surahId: 20,
    text: "وَإِن تَجۡهَرۡ بِٱلۡقَوۡلِ فَإِنَّهُۥ يَعۡلَمُ ٱلسِّرَّ وَأَخۡفَى",
    translation:
      "And if you speak aloud - then indeed, He knows the secret and what is [even] more hidden",
    normalizedText: "وان تجهر بالقول فانه يعلم السر واخفى",
  },
  {
    verseId: 7,
    name: "طه",
    surahId: 20,
    text: "ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَۖ لَهُ ٱلۡأَسۡمَآءُ ٱلۡحُسۡنَىٰ",
    translation:
      "Allah - there is no deity except Him. To Him belong the best names",
    normalizedText: "الله لا اله الا هو له الاسماء الحسنى",
  },
  {
    verseId: 8,
    name: "طه",
    surahId: 20,
    text: "وَهَلۡ أَتَىٰكَ حَدِيثُ مُوسَىٰٓ",
    translation: "And has the story of Moses reached you",
    normalizedText: "وهل اتىك حديث موسى",
  },
  {
    verseId: 9,
    name: "طه",
    surahId: 20,
    text: "إِذۡ رَءَا نَارٗا فَقَالَ لِأَهۡلِهِ ٱمۡكُثُوٓاْ إِنِّيٓ ءَانَسۡتُ نَارٗا لَّعَلِّيٓ ءَاتِيكُم مِّنۡهَا بِقَبَسٍ أَوۡ أَجِدُ عَلَى ٱلنَّارِ هُدٗى",
    translation:
      'When he saw a fire and said to his family, "Stay here; indeed, I have perceived a fire; perhaps I can bring you a torch or find at the fire some guidance',
    normalizedText:
      "اذ رءا نارا فقال لاهله امكثوا اني ءانست نارا لعلي ءاتيكم منها بقبس او اجد على النار هدى",
  },
  {
    verseId: 10,
    name: "طه",
    surahId: 20,
    text: "فَلَمَّآ أَتَىٰهَا نُودِيَ يَٰمُوسَىٰٓ",
    translation: 'And when he came to it, he was called, "O Moses',
    normalizedText: "فلما اتىها نودي يموسى",
  },
  {
    verseId: 11,
    name: "طه",
    surahId: 20,
    text: "إِنِّيٓ أَنَا۠ رَبُّكَ فَٱخۡلَعۡ نَعۡلَيۡكَ إِنَّكَ بِٱلۡوَادِ ٱلۡمُقَدَّسِ طُوٗى",
    translation:
      "Indeed, I am your Lord, so remove your sandals. Indeed, you are in the sacred valley of Tuwa",
    normalizedText: "اني انا ربك فاخلع نعليك انك بالواد المقدس طوى",
  },
  {
    verseId: 12,
    name: "طه",
    surahId: 20,
    text: "وَأَنَا ٱخۡتَرۡتُكَ فَٱسۡتَمِعۡ لِمَا يُوحَىٰٓ",
    translation:
      "And I have chosen you, so listen to what is revealed [to you]",
    normalizedText: "وانا اخترتك فاستمع لما يوحى",
  },
  {
    verseId: 13,
    name: "طه",
    surahId: 20,
    text: "إِنَّنِيٓ أَنَا ٱللَّهُ لَآ إِلَٰهَ إِلَّآ أَنَا۠ فَٱعۡبُدۡنِي وَأَقِمِ ٱلصَّلَوٰةَ لِذِكۡرِيٓ",
    translation:
      "Indeed, I am Allah. There is no deity except Me, so worship Me and establish prayer for My remembrance",
    normalizedText: "انني انا الله لا اله الا انا فاعبدني واقم الصلوة لذكري",
  },
  {
    verseId: 14,
    name: "طه",
    surahId: 20,
    text: "إِنَّ ٱلسَّاعَةَ ءَاتِيَةٌ أَكَادُ أُخۡفِيهَا لِتُجۡزَىٰ كُلُّ نَفۡسِۭ بِمَا تَسۡعَىٰ",
    translation:
      "Indeed, the Hour is coming - I almost conceal it - so that every soul may be recompensed according to that for which it strives",
    normalizedText: "ان الساعة ءاتية اكاد اخفيها لتجزى كل نفس بما تسعى",
  },
  {
    verseId: 15,
    name: "طه",
    surahId: 20,
    text: "فَلَا يَصُدَّنَّكَ عَنۡهَا مَن لَّا يُؤۡمِنُ بِهَا وَٱتَّبَعَ هَوَىٰهُ فَتَرۡدَىٰ",
    translation:
      "So do not let one avert you from it who does not believe in it and follows his desire, for you [then] would perish",
    normalizedText: "فلا يصدنك عنها من لا يامن بها واتبع هوىه فتردى",
  },
  {
    verseId: 16,
    name: "طه",
    surahId: 20,
    text: "وَمَا تِلۡكَ بِيَمِينِكَ يَٰمُوسَىٰ",
    translation: "And what is that in your right hand, O Moses",
    normalizedText: "وما تلك بيمينك يموسى",
  },
  {
    verseId: 17,
    name: "طه",
    surahId: 20,
    text: "قَالَ هِيَ عَصَايَ أَتَوَكَّؤُاْ عَلَيۡهَا وَأَهُشُّ بِهَا عَلَىٰ غَنَمِي وَلِيَ فِيهَا مَـَٔارِبُ أُخۡرَىٰ",
    translation:
      'He said, "It is my staff; I lean upon it, and I bring down leaves for my sheep and I have therein other uses',
    normalizedText:
      "قال هي عصاي اتوكاا عليها واهش بها على غنمي ولي فيها مارب اخرى",
  },
  {
    verseId: 18,
    name: "طه",
    surahId: 20,
    text: "قَالَ أَلۡقِهَا يَٰمُوسَىٰ",
    translation: '[Allah] said, "Throw it down, O Moses',
    normalizedText: "قال القها يموسى",
  },
  {
    verseId: 19,
    name: "طه",
    surahId: 20,
    text: "فَأَلۡقَىٰهَا فَإِذَا هِيَ حَيَّةٞ تَسۡعَىٰ",
    translation:
      "So he threw it down, and thereupon it was a snake, moving swiftly",
    normalizedText: "فالقىها فاذا هي حية تسعى",
  },
  {
    verseId: 20,
    name: "طه",
    surahId: 20,
    text: "قَالَ خُذۡهَا وَلَا تَخَفۡۖ سَنُعِيدُهَا سِيرَتَهَا ٱلۡأُولَىٰ",
    translation:
      '[Allah] said, "Seize it and fear not; We will return it to its former condition',
    normalizedText: "قال خذها ولا تخف سنعيدها سيرتها الاولى",
  },
  {
    verseId: 21,
    name: "طه",
    surahId: 20,
    text: "وَٱضۡمُمۡ يَدَكَ إِلَىٰ جَنَاحِكَ تَخۡرُجۡ بَيۡضَآءَ مِنۡ غَيۡرِ سُوٓءٍ ءَايَةً أُخۡرَىٰ",
    translation:
      "And draw in your hand to your side; it will come out white without disease - another sign",
    normalizedText: "واضمم يدك الى جناحك تخرج بيضاء من غير سوء ءاية اخرى",
  },
  {
    verseId: 22,
    name: "طه",
    surahId: 20,
    text: "لِنُرِيَكَ مِنۡ ءَايَٰتِنَا ٱلۡكُبۡرَى",
    translation: "That We may show you [some] of Our greater signs",
    normalizedText: "لنريك من ءايتنا الكبرى",
  },
  {
    verseId: 23,
    name: "طه",
    surahId: 20,
    text: "ٱذۡهَبۡ إِلَىٰ فِرۡعَوۡنَ إِنَّهُۥ طَغَىٰ",
    translation: "Go to Pharaoh. Indeed, he has transgressed",
    normalizedText: "اذهب الى فرعون انه طغى",
  },
  {
    verseId: 24,
    name: "طه",
    surahId: 20,
    text: "قَالَ رَبِّ ٱشۡرَحۡ لِي صَدۡرِي",
    translation:
      '[Moses] said, "My Lord, expand for me my breast [with assurance]',
    normalizedText: "قال رب اشرح لي صدري",
  },
  {
    verseId: 25,
    name: "طه",
    surahId: 20,
    text: "وَيَسِّرۡ لِيٓ أَمۡرِي",
    translation: "And ease for me my task",
    normalizedText: "ويسر لي امري",
  },
  {
    verseId: 26,
    name: "طه",
    surahId: 20,
    text: "وَٱحۡلُلۡ عُقۡدَةٗ مِّن لِّسَانِي",
    translation: "And untie the knot from my tongue",
    normalizedText: "واحلل عقدة من لساني",
  },
  {
    verseId: 27,
    name: "طه",
    surahId: 20,
    text: "يَفۡقَهُواْ قَوۡلِي",
    translation: "That they may understand my speech",
    normalizedText: "يفقهوا قولي",
  },
  {
    verseId: 28,
    name: "طه",
    surahId: 20,
    text: "وَٱجۡعَل لِّي وَزِيرٗا مِّنۡ أَهۡلِي",
    translation: "And appoint for me a minister from my family",
    normalizedText: "واجعل لي وزيرا من اهلي",
  },
  {
    verseId: 29,
    name: "طه",
    surahId: 20,
    text: "هَٰرُونَ أَخِي",
    translation: "Aaron, my brother",
    normalizedText: "هرون اخي",
  },
  {
    verseId: 30,
    name: "طه",
    surahId: 20,
    text: "ٱشۡدُدۡ بِهِۦٓ أَزۡرِي",
    translation: "Increase through him my strength",
    normalizedText: "اشدد به ازري",
  },
  {
    verseId: 31,
    name: "طه",
    surahId: 20,
    text: "وَأَشۡرِكۡهُ فِيٓ أَمۡرِي",
    translation: "And let him share my task",
    normalizedText: "واشركه في امري",
  },
  {
    verseId: 32,
    name: "طه",
    surahId: 20,
    text: "كَيۡ نُسَبِّحَكَ كَثِيرٗا",
    translation: "That we may exalt You much",
    normalizedText: "كي نسبحك كثيرا",
  },
  {
    verseId: 33,
    name: "طه",
    surahId: 20,
    text: "وَنَذۡكُرَكَ كَثِيرًا",
    translation: "And remember You much",
    normalizedText: "ونذكرك كثيرا",
  },
  {
    verseId: 34,
    name: "طه",
    surahId: 20,
    text: "إِنَّكَ كُنتَ بِنَا بَصِيرٗا",
    translation: "Indeed, You are of us ever Seeing",
    normalizedText: "انك كنت بنا بصيرا",
  },
  {
    verseId: 35,
    name: "طه",
    surahId: 20,
    text: "قَالَ قَدۡ أُوتِيتَ سُؤۡلَكَ يَٰمُوسَىٰ",
    translation: '[Allah] said, "You have been granted your request, O Moses',
    normalizedText: "قال قد اوتيت سالك يموسى",
  },
  {
    verseId: 36,
    name: "طه",
    surahId: 20,
    text: "وَلَقَدۡ مَنَنَّا عَلَيۡكَ مَرَّةً أُخۡرَىٰٓ",
    translation: "And We had already conferred favor upon you another time",
    normalizedText: "ولقد مننا عليك مرة اخرى",
  },
  {
    verseId: 37,
    name: "طه",
    surahId: 20,
    text: "إِذۡ أَوۡحَيۡنَآ إِلَىٰٓ أُمِّكَ مَا يُوحَىٰٓ",
    translation: "When We inspired to your mother what We inspired",
    normalizedText: "اذ اوحينا الى امك ما يوحى",
  },
  {
    verseId: 38,
    name: "طه",
    surahId: 20,
    text: "أَنِ ٱقۡذِفِيهِ فِي ٱلتَّابُوتِ فَٱقۡذِفِيهِ فِي ٱلۡيَمِّ فَلۡيُلۡقِهِ ٱلۡيَمُّ بِٱلسَّاحِلِ يَأۡخُذۡهُ عَدُوّٞ لِّي وَعَدُوّٞ لَّهُۥۚ وَأَلۡقَيۡتُ عَلَيۡكَ مَحَبَّةٗ مِّنِّي وَلِتُصۡنَعَ عَلَىٰ عَيۡنِيٓ",
    translation:
      "[Saying], 'Cast him into the chest and cast it into the river, and the river will throw it onto the bank; there will take him an enemy to Me and an enemy to him.' And I bestowed upon you love from Me that you would be brought up under My eye",
    normalizedText:
      "ان اقذفيه في التابوت فاقذفيه في اليم فليلقه اليم بالساحل ياخذه عدو لي وعدو له والقيت عليك محبة مني ولتصنع على عيني",
  },
  {
    verseId: 39,
    name: "طه",
    surahId: 20,
    text: "إِذۡ تَمۡشِيٓ أُخۡتُكَ فَتَقُولُ هَلۡ أَدُلُّكُمۡ عَلَىٰ مَن يَكۡفُلُهُۥۖ فَرَجَعۡنَٰكَ إِلَىٰٓ أُمِّكَ كَيۡ تَقَرَّ عَيۡنُهَا وَلَا تَحۡزَنَۚ وَقَتَلۡتَ نَفۡسٗا فَنَجَّيۡنَٰكَ مِنَ ٱلۡغَمِّ وَفَتَنَّـٰكَ فُتُونٗاۚ فَلَبِثۡتَ سِنِينَ فِيٓ أَهۡلِ مَدۡيَنَ ثُمَّ جِئۡتَ عَلَىٰ قَدَرٖ يَٰمُوسَىٰ",
    translation:
      "[And We favored you] when your sister went and said, 'Shall I direct you to someone who will be responsible for him?' So We restored you to your mother that she might be content and not grieve. And you killed someone, but We saved you from retaliation and tried you with a [severe] trial. And you remained [some] years among the people of Madyan. Then you came [here] at the decreed time, O Moses",
    normalizedText:
      "اذ تمشي اختك فتقول هل ادلكم على من يكفله فرجعنك الى امك كي تقر عينها ولا تحزن وقتلت نفسا فنجينك من الغم وفتنك فتونا فلبثت سنين في اهل مدين ثم جات على قدر يموسى",
  },
  {
    verseId: 40,
    name: "طه",
    surahId: 20,
    text: "وَٱصۡطَنَعۡتُكَ لِنَفۡسِي",
    translation: "And I produced you for Myself",
    normalizedText: "واصطنعتك لنفسي",
  },
  {
    verseId: 41,
    name: "طه",
    surahId: 20,
    text: "ٱذۡهَبۡ أَنتَ وَأَخُوكَ بِـَٔايَٰتِي وَلَا تَنِيَا فِي ذِكۡرِي",
    translation:
      "Go, you and your brother, with My signs and do not slacken in My remembrance",
    normalizedText: "اذهب انت واخوك بايتي ولا تنيا في ذكري",
  },
  {
    verseId: 42,
    name: "طه",
    surahId: 20,
    text: "ٱذۡهَبَآ إِلَىٰ فِرۡعَوۡنَ إِنَّهُۥ طَغَىٰ",
    translation: "Go, both of you, to Pharaoh. Indeed, he has transgressed",
    normalizedText: "اذهبا الى فرعون انه طغى",
  },
  {
    verseId: 43,
    name: "طه",
    surahId: 20,
    text: "فَقُولَا لَهُۥ قَوۡلٗا لَّيِّنٗا لَّعَلَّهُۥ يَتَذَكَّرُ أَوۡ يَخۡشَىٰ",
    translation:
      "And speak to him with gentle speech that perhaps he may be reminded or fear [Allah]",
    normalizedText: "فقولا له قولا لينا لعله يتذكر او يخشى",
  },
  {
    verseId: 44,
    name: "طه",
    surahId: 20,
    text: "قَالَا رَبَّنَآ إِنَّنَا نَخَافُ أَن يَفۡرُطَ عَلَيۡنَآ أَوۡ أَن يَطۡغَىٰ",
    translation:
      'They said, "Our Lord, indeed we are afraid that he will hasten [punishment] against us or that he will transgress',
    normalizedText: "قالا ربنا اننا نخاف ان يفرط علينا او ان يطغى",
  },
  {
    verseId: 45,
    name: "طه",
    surahId: 20,
    text: "قَالَ لَا تَخَافَآۖ إِنَّنِي مَعَكُمَآ أَسۡمَعُ وَأَرَىٰ",
    translation:
      '[Allah] said, "Fear not. Indeed, I am with you both; I hear and I see',
    normalizedText: "قال لا تخافا انني معكما اسمع وارى",
  },
  {
    verseId: 46,
    name: "طه",
    surahId: 20,
    text: "فَأۡتِيَاهُ فَقُولَآ إِنَّا رَسُولَا رَبِّكَ فَأَرۡسِلۡ مَعَنَا بَنِيٓ إِسۡرَـٰٓءِيلَ وَلَا تُعَذِّبۡهُمۡۖ قَدۡ جِئۡنَٰكَ بِـَٔايَةٖ مِّن رَّبِّكَۖ وَٱلسَّلَٰمُ عَلَىٰ مَنِ ٱتَّبَعَ ٱلۡهُدَىٰٓ",
    translation:
      "So go to him and say, 'Indeed, we are messengers of your Lord, so send with us the Children of Israel and do not torment them. We have come to you with a sign from your Lord. And peace will be upon he who follows the guidance",
    normalizedText:
      "فاتياه فقولا انا رسولا ربك فارسل معنا بني اسرءيل ولا تعذبهم قد جانك باية من ربك والسلم على من اتبع الهدى",
  },
  {
    verseId: 47,
    name: "طه",
    surahId: 20,
    text: "إِنَّا قَدۡ أُوحِيَ إِلَيۡنَآ أَنَّ ٱلۡعَذَابَ عَلَىٰ مَن كَذَّبَ وَتَوَلَّىٰ",
    translation:
      "Indeed, it has been revealed to us that the punishment will be upon whoever denies and turns away",
    normalizedText: "انا قد اوحي الينا ان العذاب على من كذب وتولى",
  },
  {
    verseId: 48,
    name: "طه",
    surahId: 20,
    text: "قَالَ فَمَن رَّبُّكُمَا يَٰمُوسَىٰ",
    translation: '[Pharaoh] said, "So who is the Lord of you two, O Moses',
    normalizedText: "قال فمن ربكما يموسى",
  },
  {
    verseId: 49,
    name: "طه",
    surahId: 20,
    text: "قَالَ رَبُّنَا ٱلَّذِيٓ أَعۡطَىٰ كُلَّ شَيۡءٍ خَلۡقَهُۥ ثُمَّ هَدَىٰ",
    translation:
      'He said, "Our Lord is He who gave each thing its form and then guided [it]',
    normalizedText: "قال ربنا الذي اعطى كل شيء خلقه ثم هدى",
  },
  {
    verseId: 50,
    name: "طه",
    surahId: 20,
    text: "قَالَ فَمَا بَالُ ٱلۡقُرُونِ ٱلۡأُولَىٰ",
    translation:
      '[Pharaoh] said, "Then what is the case of the former generations',
    normalizedText: "قال فما بال القرون الاولى",
  },
  {
    verseId: 51,
    name: "طه",
    surahId: 20,
    text: "قَالَ عِلۡمُهَا عِندَ رَبِّي فِي كِتَٰبٖۖ لَّا يَضِلُّ رَبِّي وَلَا يَنسَى",
    translation:
      '[Moses] said, "The knowledge thereof is with my Lord in a record. My Lord neither errs nor forgets',
    normalizedText: "قال علمها عند ربي في كتب لا يضل ربي ولا ينسى",
  },
  {
    verseId: 52,
    name: "طه",
    surahId: 20,
    text: "ٱلَّذِي جَعَلَ لَكُمُ ٱلۡأَرۡضَ مَهۡدٗا وَسَلَكَ لَكُمۡ فِيهَا سُبُلٗا وَأَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَأَخۡرَجۡنَا بِهِۦٓ أَزۡوَٰجٗا مِّن نَّبَاتٖ شَتَّىٰ",
    translation:
      "[It is He] who has made for you the earth as a bed [spread out] and inserted therein for you roadways and sent down from the sky, rain and produced thereby categories of various plants",
    normalizedText:
      "الذي جعل لكم الارض مهدا وسلك لكم فيها سبلا وانزل من السماء ماء فاخرجنا به ازوجا من نبات شتى",
  },
  {
    verseId: 53,
    name: "طه",
    surahId: 20,
    text: "كُلُواْ وَٱرۡعَوۡاْ أَنۡعَٰمَكُمۡۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّأُوْلِي ٱلنُّهَىٰ",
    translation:
      "Eat [therefrom] and pasture your livestock. Indeed, in that are signs for those of intelligence",
    normalizedText: "كلوا وارعوا انعمكم ان في ذلك لايت لاولي النهى",
  },
  {
    verseId: 54,
    name: "طه",
    surahId: 20,
    text: "۞مِنۡهَا خَلَقۡنَٰكُمۡ وَفِيهَا نُعِيدُكُمۡ وَمِنۡهَا نُخۡرِجُكُمۡ تَارَةً أُخۡرَىٰ",
    translation:
      "From the earth We created you, and into it We will return you, and from it We will extract you another time",
    normalizedText: "۞منها خلقنكم وفيها نعيدكم ومنها نخرجكم تارة اخرى",
  },
  {
    verseId: 55,
    name: "طه",
    surahId: 20,
    text: "وَلَقَدۡ أَرَيۡنَٰهُ ءَايَٰتِنَا كُلَّهَا فَكَذَّبَ وَأَبَىٰ",
    translation:
      "And We certainly showed Pharaoh Our signs - all of them - but he denied and refused",
    normalizedText: "ولقد ارينه ءايتنا كلها فكذب وابى",
  },
  {
    verseId: 56,
    name: "طه",
    surahId: 20,
    text: "قَالَ أَجِئۡتَنَا لِتُخۡرِجَنَا مِنۡ أَرۡضِنَا بِسِحۡرِكَ يَٰمُوسَىٰ",
    translation:
      'He said, "Have you come to us to drive us out of our land with your magic, O Moses',
    normalizedText: "قال اجاتنا لتخرجنا من ارضنا بسحرك يموسى",
  },
  {
    verseId: 57,
    name: "طه",
    surahId: 20,
    text: "فَلَنَأۡتِيَنَّكَ بِسِحۡرٖ مِّثۡلِهِۦ فَٱجۡعَلۡ بَيۡنَنَا وَبَيۡنَكَ مَوۡعِدٗا لَّا نُخۡلِفُهُۥ نَحۡنُ وَلَآ أَنتَ مَكَانٗا سُوٗى",
    translation:
      "Then we will surely bring you magic like it, so make between us and you an appointment, which we will not fail to keep and neither will you, in a place assigned",
    normalizedText:
      "فلناتينك بسحر مثله فاجعل بيننا وبينك موعدا لا نخلفه نحن ولا انت مكانا سوى",
  },
  {
    verseId: 58,
    name: "طه",
    surahId: 20,
    text: "قَالَ مَوۡعِدُكُمۡ يَوۡمُ ٱلزِّينَةِ وَأَن يُحۡشَرَ ٱلنَّاسُ ضُحٗى",
    translation:
      '[Moses] said, "Your appointment is on the day of the festival when the people assemble at mid-morning',
    normalizedText: "قال موعدكم يوم الزينة وان يحشر الناس ضحى",
  },
  {
    verseId: 59,
    name: "طه",
    surahId: 20,
    text: "فَتَوَلَّىٰ فِرۡعَوۡنُ فَجَمَعَ كَيۡدَهُۥ ثُمَّ أَتَىٰ",
    translation:
      "So Pharaoh went away, put together his plan, and then came [to Moses]",
    normalizedText: "فتولى فرعون فجمع كيده ثم اتى",
  },
  {
    verseId: 60,
    name: "طه",
    surahId: 20,
    text: "قَالَ لَهُم مُّوسَىٰ وَيۡلَكُمۡ لَا تَفۡتَرُواْ عَلَى ٱللَّهِ كَذِبٗا فَيُسۡحِتَكُم بِعَذَابٖۖ وَقَدۡ خَابَ مَنِ ٱفۡتَرَىٰ",
    translation:
      'Moses said to the magicians summoned by Pharaoh, "Woe to you! Do not invent a lie against Allah or He will exterminate you with a punishment; and he has failed who invents [such falsehood]',
    normalizedText:
      "قال لهم موسى ويلكم لا تفتروا على الله كذبا فيسحتكم بعذاب وقد خاب من افترى",
  },
  {
    verseId: 61,
    name: "طه",
    surahId: 20,
    text: "فَتَنَٰزَعُوٓاْ أَمۡرَهُم بَيۡنَهُمۡ وَأَسَرُّواْ ٱلنَّجۡوَىٰ",
    translation:
      "So they disputed over their affair among themselves and concealed their private conversation",
    normalizedText: "فتنزعوا امرهم بينهم واسروا النجوى",
  },
  {
    verseId: 62,
    name: "طه",
    surahId: 20,
    text: "قَالُوٓاْ إِنۡ هَٰذَٰنِ لَسَٰحِرَٰنِ يُرِيدَانِ أَن يُخۡرِجَاكُم مِّنۡ أَرۡضِكُم بِسِحۡرِهِمَا وَيَذۡهَبَا بِطَرِيقَتِكُمُ ٱلۡمُثۡلَىٰ",
    translation:
      'They said, "Indeed, these are two magicians who want to drive you out of your land with their magic and do away with your most exemplary way',
    normalizedText:
      "قالوا ان هذن لسحرن يريدان ان يخرجاكم من ارضكم بسحرهما ويذهبا بطريقتكم المثلى",
  },
  {
    verseId: 63,
    name: "طه",
    surahId: 20,
    text: "فَأَجۡمِعُواْ كَيۡدَكُمۡ ثُمَّ ٱئۡتُواْ صَفّٗاۚ وَقَدۡ أَفۡلَحَ ٱلۡيَوۡمَ مَنِ ٱسۡتَعۡلَىٰ",
    translation:
      "So resolve upon your plan and then come [forward] in line. And he has succeeded today who overcomes",
    normalizedText: "فاجمعوا كيدكم ثم ااتوا صفا وقد افلح اليوم من استعلى",
  },
  {
    verseId: 64,
    name: "طه",
    surahId: 20,
    text: "قَالُواْ يَٰمُوسَىٰٓ إِمَّآ أَن تُلۡقِيَ وَإِمَّآ أَن نَّكُونَ أَوَّلَ مَنۡ أَلۡقَىٰ",
    translation:
      'They said, "O Moses, either you throw or we will be the first to throw',
    normalizedText: "قالوا يموسى اما ان تلقي واما ان نكون اول من القى",
  },
  {
    verseId: 65,
    name: "طه",
    surahId: 20,
    text: "قَالَ بَلۡ أَلۡقُواْۖ فَإِذَا حِبَالُهُمۡ وَعِصِيُّهُمۡ يُخَيَّلُ إِلَيۡهِ مِن سِحۡرِهِمۡ أَنَّهَا تَسۡعَىٰ",
    translation:
      'He said, "Rather, you throw." And suddenly their ropes and staffs seemed to him from their magic that they were moving [like snakes]',
    normalizedText:
      "قال بل القوا فاذا حبالهم وعصيهم يخيل اليه من سحرهم انها تسعى",
  },
  {
    verseId: 66,
    name: "طه",
    surahId: 20,
    text: "فَأَوۡجَسَ فِي نَفۡسِهِۦ خِيفَةٗ مُّوسَىٰ",
    translation: "And he sensed within himself apprehension, did Moses",
    normalizedText: "فاوجس في نفسه خيفة موسى",
  },
  {
    verseId: 67,
    name: "طه",
    surahId: 20,
    text: "قُلۡنَا لَا تَخَفۡ إِنَّكَ أَنتَ ٱلۡأَعۡلَىٰ",
    translation: 'Allah said, "Fear not. Indeed, it is you who are superior',
    normalizedText: "قلنا لا تخف انك انت الاعلى",
  },
  {
    verseId: 68,
    name: "طه",
    surahId: 20,
    text: "وَأَلۡقِ مَا فِي يَمِينِكَ تَلۡقَفۡ مَا صَنَعُوٓاْۖ إِنَّمَا صَنَعُواْ كَيۡدُ سَٰحِرٖۖ وَلَا يُفۡلِحُ ٱلسَّاحِرُ حَيۡثُ أَتَىٰ",
    translation:
      "And throw what is in your right hand; it will swallow up what they have crafted. What they have crafted is but the trick of a magician, and the magician will not succeed wherever he is",
    normalizedText:
      "والق ما في يمينك تلقف ما صنعوا انما صنعوا كيد سحر ولا يفلح الساحر حيث اتى",
  },
  {
    verseId: 69,
    name: "طه",
    surahId: 20,
    text: "فَأُلۡقِيَ ٱلسَّحَرَةُ سُجَّدٗا قَالُوٓاْ ءَامَنَّا بِرَبِّ هَٰرُونَ وَمُوسَىٰ",
    translation:
      'So the magicians fell down in prostration. They said, "We have believed in the Lord of Aaron and Moses',
    normalizedText: "فالقي السحرة سجدا قالوا ءامنا برب هرون وموسى",
  },
  {
    verseId: 70,
    name: "طه",
    surahId: 20,
    text: "قَالَ ءَامَنتُمۡ لَهُۥ قَبۡلَ أَنۡ ءَاذَنَ لَكُمۡۖ إِنَّهُۥ لَكَبِيرُكُمُ ٱلَّذِي عَلَّمَكُمُ ٱلسِّحۡرَۖ فَلَأُقَطِّعَنَّ أَيۡدِيَكُمۡ وَأَرۡجُلَكُم مِّنۡ خِلَٰفٖ وَلَأُصَلِّبَنَّكُمۡ فِي جُذُوعِ ٱلنَّخۡلِ وَلَتَعۡلَمُنَّ أَيُّنَآ أَشَدُّ عَذَابٗا وَأَبۡقَىٰ",
    translation:
      '[Pharaoh] said, "You believed him before I gave you permission. Indeed, he is your leader who has taught you magic. So I will surely cut off your hands and your feet on opposite sides, and I will crucify you on the trunks of palm trees, and you will surely know which of us is more severe in [giving] punishment and more enduring',
    normalizedText:
      "قال ءامنتم له قبل ان ءاذن لكم انه لكبيركم الذي علمكم السحر فلاقطعن ايديكم وارجلكم من خلف ولاصلبنكم في جذوع النخل ولتعلمن اينا اشد عذابا وابقى",
  },
  {
    verseId: 71,
    name: "طه",
    surahId: 20,
    text: "قَالُواْ لَن نُّؤۡثِرَكَ عَلَىٰ مَا جَآءَنَا مِنَ ٱلۡبَيِّنَٰتِ وَٱلَّذِي فَطَرَنَاۖ فَٱقۡضِ مَآ أَنتَ قَاضٍۖ إِنَّمَا تَقۡضِي هَٰذِهِ ٱلۡحَيَوٰةَ ٱلدُّنۡيَآ",
    translation:
      'They said, "Never will we prefer you over what has come to us of clear proofs and [over] He who created us. So decree whatever you are to decree. You can only decree for this worldly life',
    normalizedText:
      "قالوا لن ناثرك على ما جاءنا من البينت والذي فطرنا فاقض ما انت قاض انما تقضي هذه الحيوة الدنيا",
  },
  {
    verseId: 72,
    name: "طه",
    surahId: 20,
    text: "إِنَّآ ءَامَنَّا بِرَبِّنَا لِيَغۡفِرَ لَنَا خَطَٰيَٰنَا وَمَآ أَكۡرَهۡتَنَا عَلَيۡهِ مِنَ ٱلسِّحۡرِۗ وَٱللَّهُ خَيۡرٞ وَأَبۡقَىٰٓ",
    translation:
      "Indeed, we have believed in our Lord that He may forgive us our sins and what you compelled us [to do] of magic. And Allah is better and more enduring",
    normalizedText:
      "انا ءامنا بربنا ليغفر لنا خطينا وما اكرهتنا عليه من السحر والله خير وابقى",
  },
  {
    verseId: 73,
    name: "طه",
    surahId: 20,
    text: "إِنَّهُۥ مَن يَأۡتِ رَبَّهُۥ مُجۡرِمٗا فَإِنَّ لَهُۥ جَهَنَّمَ لَا يَمُوتُ فِيهَا وَلَا يَحۡيَىٰ",
    translation:
      "Indeed, whoever comes to his Lord as a criminal - indeed, for him is Hell; he will neither die therein nor live",
    normalizedText: "انه من يات ربه مجرما فان له جهنم لا يموت فيها ولا يحيى",
  },
  {
    verseId: 74,
    name: "طه",
    surahId: 20,
    text: "وَمَن يَأۡتِهِۦ مُؤۡمِنٗا قَدۡ عَمِلَ ٱلصَّـٰلِحَٰتِ فَأُوْلَـٰٓئِكَ لَهُمُ ٱلدَّرَجَٰتُ ٱلۡعُلَىٰ",
    translation:
      "But whoever comes to Him as a believer having done righteous deeds - for those will be the highest degrees [in position]",
    normalizedText: "ومن ياته مامنا قد عمل الصلحت فاولاك لهم الدرجت العلى",
  },
  {
    verseId: 75,
    name: "طه",
    surahId: 20,
    text: "جَنَّـٰتُ عَدۡنٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ وَذَٰلِكَ جَزَآءُ مَن تَزَكَّىٰ",
    translation:
      "Gardens of perpetual residence beneath which rivers flow, wherein they abide eternally. And that is the reward of one who purifies himself",
    normalizedText: "جنت عدن تجري من تحتها الانهر خلدين فيها وذلك جزاء من تزكى",
  },
  {
    verseId: 76,
    name: "طه",
    surahId: 20,
    text: "وَلَقَدۡ أَوۡحَيۡنَآ إِلَىٰ مُوسَىٰٓ أَنۡ أَسۡرِ بِعِبَادِي فَٱضۡرِبۡ لَهُمۡ طَرِيقٗا فِي ٱلۡبَحۡرِ يَبَسٗا لَّا تَخَٰفُ دَرَكٗا وَلَا تَخۡشَىٰ",
    translation:
      'And We had inspired to Moses, "Travel by night with My servants and strike for them a dry path through the sea; you will not fear being overtaken [by Pharaoh] nor be afraid [of drowning]',
    normalizedText:
      "ولقد اوحينا الى موسى ان اسر بعبادي فاضرب لهم طريقا في البحر يبسا لا تخف دركا ولا تخشى",
  },
  {
    verseId: 77,
    name: "طه",
    surahId: 20,
    text: "فَأَتۡبَعَهُمۡ فِرۡعَوۡنُ بِجُنُودِهِۦ فَغَشِيَهُم مِّنَ ٱلۡيَمِّ مَا غَشِيَهُمۡ",
    translation:
      "So Pharaoh pursued them with his soldiers, and there covered them from the sea that which covered them",
    normalizedText: "فاتبعهم فرعون بجنوده فغشيهم من اليم ما غشيهم",
  },
  {
    verseId: 78,
    name: "طه",
    surahId: 20,
    text: "وَأَضَلَّ فِرۡعَوۡنُ قَوۡمَهُۥ وَمَا هَدَىٰ",
    translation: "And Pharaoh led his people astray and did not guide [them]",
    normalizedText: "واضل فرعون قومه وما هدى",
  },
  {
    verseId: 79,
    name: "طه",
    surahId: 20,
    text: "يَٰبَنِيٓ إِسۡرَـٰٓءِيلَ قَدۡ أَنجَيۡنَٰكُم مِّنۡ عَدُوِّكُمۡ وَوَٰعَدۡنَٰكُمۡ جَانِبَ ٱلطُّورِ ٱلۡأَيۡمَنَ وَنَزَّلۡنَا عَلَيۡكُمُ ٱلۡمَنَّ وَٱلسَّلۡوَىٰ",
    translation:
      "O Children of Israel, We delivered you from your enemy, and We made an appointment with you at the right side of the mount, and We sent down to you manna and quails",
    normalizedText:
      "يبني اسرءيل قد انجينكم من عدوكم ووعدنكم جانب الطور الايمن ونزلنا عليكم المن والسلوى",
  },
  {
    verseId: 80,
    name: "طه",
    surahId: 20,
    text: "كُلُواْ مِن طَيِّبَٰتِ مَا رَزَقۡنَٰكُمۡ وَلَا تَطۡغَوۡاْ فِيهِ فَيَحِلَّ عَلَيۡكُمۡ غَضَبِيۖ وَمَن يَحۡلِلۡ عَلَيۡهِ غَضَبِي فَقَدۡ هَوَىٰ",
    translation:
      '[Saying], "Eat from the good things with which We have provided you and do not transgress [or oppress others] therein, lest My anger should descend upon you. And he upon whom My anger descends has certainly fallen',
    normalizedText:
      "كلوا من طيبت ما رزقنكم ولا تطغوا فيه فيحل عليكم غضبي ومن يحلل عليه غضبي فقد هوى",
  },
  {
    verseId: 81,
    name: "طه",
    surahId: 20,
    text: "وَإِنِّي لَغَفَّارٞ لِّمَن تَابَ وَءَامَنَ وَعَمِلَ صَٰلِحٗا ثُمَّ ٱهۡتَدَىٰ",
    translation:
      "But indeed, I am the Perpetual Forgiver of whoever repents and believes and does righteousness and then continues in guidance",
    normalizedText: "واني لغفار لمن تاب وءامن وعمل صلحا ثم اهتدى",
  },
  {
    verseId: 82,
    name: "طه",
    surahId: 20,
    text: "۞وَمَآ أَعۡجَلَكَ عَن قَوۡمِكَ يَٰمُوسَىٰ",
    translation:
      '[Allah] said, "And what made you hasten from your people, O Moses',
    normalizedText: "۞وما اعجلك عن قومك يموسى",
  },
  {
    verseId: 83,
    name: "طه",
    surahId: 20,
    text: "قَالَ هُمۡ أُوْلَآءِ عَلَىٰٓ أَثَرِي وَعَجِلۡتُ إِلَيۡكَ رَبِّ لِتَرۡضَىٰ",
    translation:
      'He said, "They are close upon my tracks, and I hastened to You, my Lord, that You be pleased',
    normalizedText: "قال هم اولاء على اثري وعجلت اليك رب لترضى",
  },
  {
    verseId: 84,
    name: "طه",
    surahId: 20,
    text: "قَالَ فَإِنَّا قَدۡ فَتَنَّا قَوۡمَكَ مِنۢ بَعۡدِكَ وَأَضَلَّهُمُ ٱلسَّامِرِيُّ",
    translation:
      '[Allah] said, "But indeed, We have tried your people after you [departed], and the Samiri has led them astray',
    normalizedText: "قال فانا قد فتنا قومك من بعدك واضلهم السامري",
  },
  {
    verseId: 85,
    name: "طه",
    surahId: 20,
    text: "فَرَجَعَ مُوسَىٰٓ إِلَىٰ قَوۡمِهِۦ غَضۡبَٰنَ أَسِفٗاۚ قَالَ يَٰقَوۡمِ أَلَمۡ يَعِدۡكُمۡ رَبُّكُمۡ وَعۡدًا حَسَنًاۚ أَفَطَالَ عَلَيۡكُمُ ٱلۡعَهۡدُ أَمۡ أَرَدتُّمۡ أَن يَحِلَّ عَلَيۡكُمۡ غَضَبٞ مِّن رَّبِّكُمۡ فَأَخۡلَفۡتُم مَّوۡعِدِي",
    translation:
      'So Moses returned to his people, angry and grieved. He said, "O my people, did your Lord not make you a good promise? Then, was the time [of its fulfillment] too long for you, or did you wish that wrath from your Lord descend upon you, so you broke your promise [of obedience] to me',
    normalizedText:
      "فرجع موسى الى قومه غضبن اسفا قال يقوم الم يعدكم ربكم وعدا حسنا افطال عليكم العهد ام اردتم ان يحل عليكم غضب من ربكم فاخلفتم موعدي",
  },
  {
    verseId: 86,
    name: "طه",
    surahId: 20,
    text: "قَالُواْ مَآ أَخۡلَفۡنَا مَوۡعِدَكَ بِمَلۡكِنَا وَلَٰكِنَّا حُمِّلۡنَآ أَوۡزَارٗا مِّن زِينَةِ ٱلۡقَوۡمِ فَقَذَفۡنَٰهَا فَكَذَٰلِكَ أَلۡقَى ٱلسَّامِرِيُّ",
    translation:
      'They said, "We did not break our promise to you by our will, but we were made to carry burdens from the ornaments of the people [of Pharaoh], so we threw them [into the fire], and thus did the Samiri throw',
    normalizedText:
      "قالوا ما اخلفنا موعدك بملكنا ولكنا حملنا اوزارا من زينة القوم فقذفنها فكذلك القى السامري",
  },
  {
    verseId: 87,
    name: "طه",
    surahId: 20,
    text: "فَأَخۡرَجَ لَهُمۡ عِجۡلٗا جَسَدٗا لَّهُۥ خُوَارٞ فَقَالُواْ هَٰذَآ إِلَٰهُكُمۡ وَإِلَٰهُ مُوسَىٰ فَنَسِيَ",
    translation:
      'And he extracted for them [the statue of] a calf which had a lowing sound, and they said, "This is your god and the god of Moses, but he forgot',
    normalizedText:
      "فاخرج لهم عجلا جسدا له خوار فقالوا هذا الهكم واله موسى فنسي",
  },
  {
    verseId: 88,
    name: "طه",
    surahId: 20,
    text: "أَفَلَا يَرَوۡنَ أَلَّا يَرۡجِعُ إِلَيۡهِمۡ قَوۡلٗا وَلَا يَمۡلِكُ لَهُمۡ ضَرّٗا وَلَا نَفۡعٗا",
    translation:
      "Did they not see that it could not return to them any speech and that it did not possess for them any harm or benefit",
    normalizedText: "افلا يرون الا يرجع اليهم قولا ولا يملك لهم ضرا ولا نفعا",
  },
  {
    verseId: 89,
    name: "طه",
    surahId: 20,
    text: "وَلَقَدۡ قَالَ لَهُمۡ هَٰرُونُ مِن قَبۡلُ يَٰقَوۡمِ إِنَّمَا فُتِنتُم بِهِۦۖ وَإِنَّ رَبَّكُمُ ٱلرَّحۡمَٰنُ فَٱتَّبِعُونِي وَأَطِيعُوٓاْ أَمۡرِي",
    translation:
      'And Aaron had already told them before [the return of Moses], "O my people, you are only being tested by it, and indeed, your Lord is the Most Merciful, so follow me and obey my order',
    normalizedText:
      "ولقد قال لهم هرون من قبل يقوم انما فتنتم به وان ربكم الرحمن فاتبعوني واطيعوا امري",
  },
  {
    verseId: 90,
    name: "طه",
    surahId: 20,
    text: "قَالُواْ لَن نَّبۡرَحَ عَلَيۡهِ عَٰكِفِينَ حَتَّىٰ يَرۡجِعَ إِلَيۡنَا مُوسَىٰ",
    translation:
      'They said, "We will never cease being devoted to the calf until Moses returns to us',
    normalizedText: "قالوا لن نبرح عليه عكفين حتى يرجع الينا موسى",
  },
  {
    verseId: 91,
    name: "طه",
    surahId: 20,
    text: "قَالَ يَٰهَٰرُونُ مَا مَنَعَكَ إِذۡ رَأَيۡتَهُمۡ ضَلُّوٓاْ",
    translation:
      '[Moses] said, "O Aaron, what prevented you, when you saw them going astray',
    normalizedText: "قال يهرون ما منعك اذ رايتهم ضلوا",
  },
  {
    verseId: 92,
    name: "طه",
    surahId: 20,
    text: "أَلَّا تَتَّبِعَنِۖ أَفَعَصَيۡتَ أَمۡرِي",
    translation: "From following me? Then have you disobeyed my order",
    normalizedText: "الا تتبعن افعصيت امري",
  },
  {
    verseId: 93,
    name: "طه",
    surahId: 20,
    text: "قَالَ يَبۡنَؤُمَّ لَا تَأۡخُذۡ بِلِحۡيَتِي وَلَا بِرَأۡسِيٓۖ إِنِّي خَشِيتُ أَن تَقُولَ فَرَّقۡتَ بَيۡنَ بَنِيٓ إِسۡرَـٰٓءِيلَ وَلَمۡ تَرۡقُبۡ قَوۡلِي",
    translation: `[Aaron] said, "O son of my mother, do not seize [me] by my beard or by my head. Indeed, I feared that you would say, 'You caused division among the Children of Israel, and you did not observe [or await] my word`,
    normalizedText:
      "قال يبنام لا تاخذ بلحيتي ولا براسي اني خشيت ان تقول فرقت بين بني اسرءيل ولم ترقب قولي",
  },
  {
    verseId: 94,
    name: "طه",
    surahId: 20,
    text: "قَالَ فَمَا خَطۡبُكَ يَٰسَٰمِرِيُّ",
    translation: '[Moses] said, "And what is your case, O Samiri',
    normalizedText: "قال فما خطبك يسمري",
  },
  {
    verseId: 95,
    name: "طه",
    surahId: 20,
    text: "قَالَ بَصُرۡتُ بِمَا لَمۡ يَبۡصُرُواْ بِهِۦ فَقَبَضۡتُ قَبۡضَةٗ مِّنۡ أَثَرِ ٱلرَّسُولِ فَنَبَذۡتُهَا وَكَذَٰلِكَ سَوَّلَتۡ لِي نَفۡسِي",
    translation:
      'He said, "I saw what they did not see, so I took a handful [of dust] from the track of the messenger and threw it, and thus did my soul entice me',
    normalizedText:
      "قال بصرت بما لم يبصروا به فقبضت قبضة من اثر الرسول فنبذتها وكذلك سولت لي نفسي",
  },
  {
    verseId: 96,
    name: "طه",
    surahId: 20,
    text: "قَالَ فَٱذۡهَبۡ فَإِنَّ لَكَ فِي ٱلۡحَيَوٰةِ أَن تَقُولَ لَا مِسَاسَۖ وَإِنَّ لَكَ مَوۡعِدٗا لَّن تُخۡلَفَهُۥۖ وَٱنظُرۡ إِلَىٰٓ إِلَٰهِكَ ٱلَّذِي ظَلۡتَ عَلَيۡهِ عَاكِفٗاۖ لَّنُحَرِّقَنَّهُۥ ثُمَّ لَنَنسِفَنَّهُۥ فِي ٱلۡيَمِّ نَسۡفًا",
    translation: `[Moses] said, "Then go. And indeed, it is [decreed] for you in [this] life to say, 'No contact.' And indeed, you have an appointment [in the Hereafter] you will not fail to keep. And look at your 'god' to which you remained devoted. We will surely burn it and blow it into the sea with a blast`,
    normalizedText:
      "قال فاذهب فان لك في الحيوة ان تقول لا مساس وان لك موعدا لن تخلفه وانظر الى الهك الذي ظلت عليه عاكفا لنحرقنه ثم لننسفنه في اليم نسفا",
  },
  {
    verseId: 97,
    name: "طه",
    surahId: 20,
    text: "إِنَّمَآ إِلَٰهُكُمُ ٱللَّهُ ٱلَّذِي لَآ إِلَٰهَ إِلَّا هُوَۚ وَسِعَ كُلَّ شَيۡءٍ عِلۡمٗا",
    translation:
      "Your god is only Allah, except for whom there is no deity. He has encompassed all things in knowledge",
    normalizedText: "انما الهكم الله الذي لا اله الا هو وسع كل شيء علما",
  },
  {
    verseId: 98,
    name: "طه",
    surahId: 20,
    text: "كَذَٰلِكَ نَقُصُّ عَلَيۡكَ مِنۡ أَنۢبَآءِ مَا قَدۡ سَبَقَۚ وَقَدۡ ءَاتَيۡنَٰكَ مِن لَّدُنَّا ذِكۡرٗا",
    translation:
      "Thus, [O Muhammad], We relate to you from the news of what has preceded. And We have certainly given you from Us the Qur'an",
    normalizedText: "كذلك نقص عليك من انباء ما قد سبق وقد ءاتينك من لدنا ذكرا",
  },
  {
    verseId: 99,
    name: "طه",
    surahId: 20,
    text: "مَّنۡ أَعۡرَضَ عَنۡهُ فَإِنَّهُۥ يَحۡمِلُ يَوۡمَ ٱلۡقِيَٰمَةِ وِزۡرًا",
    translation:
      "Whoever turns away from it - then indeed, he will bear on the Day of Resurrection a burden",
    normalizedText: "من اعرض عنه فانه يحمل يوم القيمة وزرا",
  },
  {
    verseId: 100,
    name: "طه",
    surahId: 20,
    text: "خَٰلِدِينَ فِيهِۖ وَسَآءَ لَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ حِمۡلٗا",
    translation:
      "[Abiding] eternally therein, and evil it is for them on the Day of Resurrection as a load",
    normalizedText: "خلدين فيه وساء لهم يوم القيمة حملا",
  },
  {
    verseId: 101,
    name: "طه",
    surahId: 20,
    text: "يَوۡمَ يُنفَخُ فِي ٱلصُّورِۚ وَنَحۡشُرُ ٱلۡمُجۡرِمِينَ يَوۡمَئِذٖ زُرۡقٗا",
    translation:
      "The Day the Horn will be blown. And We will gather the criminals, that Day, blue-eyed",
    normalizedText: "يوم ينفخ في الصور ونحشر المجرمين يوماذ زرقا",
  },
  {
    verseId: 102,
    name: "طه",
    surahId: 20,
    text: "يَتَخَٰفَتُونَ بَيۡنَهُمۡ إِن لَّبِثۡتُمۡ إِلَّا عَشۡرٗا",
    translation:
      'They will murmur among themselves, "You remained not but ten [days in the world]',
    normalizedText: "يتخفتون بينهم ان لبثتم الا عشرا",
  },
  {
    verseId: 103,
    name: "طه",
    surahId: 20,
    text: "نَّحۡنُ أَعۡلَمُ بِمَا يَقُولُونَ إِذۡ يَقُولُ أَمۡثَلُهُمۡ طَرِيقَةً إِن لَّبِثۡتُمۡ إِلَّا يَوۡمٗا",
    translation:
      'We are most knowing of what they say when the best of them in manner will say, "You remained not but one day',
    normalizedText:
      "نحن اعلم بما يقولون اذ يقول امثلهم طريقة ان لبثتم الا يوما",
  },
  {
    verseId: 104,
    name: "طه",
    surahId: 20,
    text: "وَيَسۡـَٔلُونَكَ عَنِ ٱلۡجِبَالِ فَقُلۡ يَنسِفُهَا رَبِّي نَسۡفٗا",
    translation:
      'And they ask you about the mountains, so say, "My Lord will blow them away with a blast',
    normalizedText: "ويسلونك عن الجبال فقل ينسفها ربي نسفا",
  },
  {
    verseId: 105,
    name: "طه",
    surahId: 20,
    text: "فَيَذَرُهَا قَاعٗا صَفۡصَفٗا",
    translation: "And He will leave the earth a level plain",
    normalizedText: "فيذرها قاعا صفصفا",
  },
  {
    verseId: 106,
    name: "طه",
    surahId: 20,
    text: "لَّا تَرَىٰ فِيهَا عِوَجٗا وَلَآ أَمۡتٗا",
    translation: "You will not see therein a depression or an elevation",
    normalizedText: "لا ترى فيها عوجا ولا امتا",
  },
  {
    verseId: 107,
    name: "طه",
    surahId: 20,
    text: "يَوۡمَئِذٖ يَتَّبِعُونَ ٱلدَّاعِيَ لَا عِوَجَ لَهُۥۖ وَخَشَعَتِ ٱلۡأَصۡوَاتُ لِلرَّحۡمَٰنِ فَلَا تَسۡمَعُ إِلَّا هَمۡسٗا",
    translation:
      "That Day, everyone will follow [the call of] the Caller [with] no deviation therefrom, and [all] voices will be stilled before the Most Merciful, so you will not hear except a whisper [of footsteps]",
    normalizedText:
      "يوماذ يتبعون الداعي لا عوج له وخشعت الاصوات للرحمن فلا تسمع الا همسا",
  },
  {
    verseId: 108,
    name: "طه",
    surahId: 20,
    text: "يَوۡمَئِذٖ لَّا تَنفَعُ ٱلشَّفَٰعَةُ إِلَّا مَنۡ أَذِنَ لَهُ ٱلرَّحۡمَٰنُ وَرَضِيَ لَهُۥ قَوۡلٗا",
    translation:
      "That Day, no intercession will benefit except [that of] one to whom the Most Merciful has given permission and has accepted his word",
    normalizedText: "يوماذ لا تنفع الشفعة الا من اذن له الرحمن ورضي له قولا",
  },
  {
    verseId: 109,
    name: "طه",
    surahId: 20,
    text: "يَعۡلَمُ مَا بَيۡنَ أَيۡدِيهِمۡ وَمَا خَلۡفَهُمۡ وَلَا يُحِيطُونَ بِهِۦ عِلۡمٗا",
    translation:
      "Allah knows what is [presently] before them and what will be after them, but they do not encompass it in knowledge",
    normalizedText: "يعلم ما بين ايديهم وما خلفهم ولا يحيطون به علما",
  },
  {
    verseId: 110,
    name: "طه",
    surahId: 20,
    text: "۞وَعَنَتِ ٱلۡوُجُوهُ لِلۡحَيِّ ٱلۡقَيُّومِۖ وَقَدۡ خَابَ مَنۡ حَمَلَ ظُلۡمٗا",
    translation:
      "And [all] faces will be humbled before the Ever-Living, the Sustainer of existence. And he will have failed who carries injustice",
    normalizedText: "۞وعنت الوجوه للحي القيوم وقد خاب من حمل ظلما",
  },
  {
    verseId: 111,
    name: "طه",
    surahId: 20,
    text: "وَمَن يَعۡمَلۡ مِنَ ٱلصَّـٰلِحَٰتِ وَهُوَ مُؤۡمِنٞ فَلَا يَخَافُ ظُلۡمٗا وَلَا هَضۡمٗا",
    translation:
      "But he who does of righteous deeds while he is a believer - he will neither fear injustice nor deprivation",
    normalizedText: "ومن يعمل من الصلحت وهو مامن فلا يخاف ظلما ولا هضما",
  },
  {
    verseId: 112,
    name: "طه",
    surahId: 20,
    text: "وَكَذَٰلِكَ أَنزَلۡنَٰهُ قُرۡءَانًا عَرَبِيّٗا وَصَرَّفۡنَا فِيهِ مِنَ ٱلۡوَعِيدِ لَعَلَّهُمۡ يَتَّقُونَ أَوۡ يُحۡدِثُ لَهُمۡ ذِكۡرٗا",
    translation:
      "And thus We have sent it down as an Arabic Qur'an and have diversified therein the warnings that perhaps they will avoid [sin] or it would cause them remembrance",
    normalizedText:
      "وكذلك انزلنه قرءانا عربيا وصرفنا فيه من الوعيد لعلهم يتقون او يحدث لهم ذكرا",
  },
  {
    verseId: 113,
    name: "طه",
    surahId: 20,
    text: "فَتَعَٰلَى ٱللَّهُ ٱلۡمَلِكُ ٱلۡحَقُّۗ وَلَا تَعۡجَلۡ بِٱلۡقُرۡءَانِ مِن قَبۡلِ أَن يُقۡضَىٰٓ إِلَيۡكَ وَحۡيُهُۥۖ وَقُل رَّبِّ زِدۡنِي عِلۡمٗا",
    translation: `So high [above all] is Allah, the Sovereign, the Truth. And, [O Muhammad], do not hasten with [recitation of] the Qur'an before its revelation is completed to you, and say, "My Lord, increase me in knowledge`,
    normalizedText:
      "فتعلى الله الملك الحق ولا تعجل بالقرءان من قبل ان يقضى اليك وحيه وقل رب زدني علما",
  },
  {
    verseId: 114,
    name: "طه",
    surahId: 20,
    text: "وَلَقَدۡ عَهِدۡنَآ إِلَىٰٓ ءَادَمَ مِن قَبۡلُ فَنَسِيَ وَلَمۡ نَجِدۡ لَهُۥ عَزۡمٗا",
    translation:
      "And We had already taken a promise from Adam before, but he forgot; and We found not in him determination",
    normalizedText: "ولقد عهدنا الى ءادم من قبل فنسي ولم نجد له عزما",
  },
  {
    verseId: 115,
    name: "طه",
    surahId: 20,
    text: "وَإِذۡ قُلۡنَا لِلۡمَلَـٰٓئِكَةِ ٱسۡجُدُواْ لِأٓدَمَ فَسَجَدُوٓاْ إِلَّآ إِبۡلِيسَ أَبَىٰ",
    translation:
      'And [mention] when We said to the angels, "Prostrate to Adam," and they prostrated, except Iblees; he refused',
    normalizedText: "واذ قلنا للملاكة اسجدوا لادم فسجدوا الا ابليس ابى",
  },
  {
    verseId: 116,
    name: "طه",
    surahId: 20,
    text: "فَقُلۡنَا يَـٰٓـَٔادَمُ إِنَّ هَٰذَا عَدُوّٞ لَّكَ وَلِزَوۡجِكَ فَلَا يُخۡرِجَنَّكُمَا مِنَ ٱلۡجَنَّةِ فَتَشۡقَىٰٓ",
    translation:
      'So We said, "O Adam, indeed this is an enemy to you and to your wife. Then let him not remove you from Paradise so you would suffer',
    normalizedText:
      "فقلنا يادم ان هذا عدو لك ولزوجك فلا يخرجنكما من الجنة فتشقى",
  },
  {
    verseId: 117,
    name: "طه",
    surahId: 20,
    text: "إِنَّ لَكَ أَلَّا تَجُوعَ فِيهَا وَلَا تَعۡرَىٰ",
    translation:
      "Indeed, it is [promised] for you not to be hungry therein or be unclothed",
    normalizedText: "ان لك الا تجوع فيها ولا تعرى",
  },
  {
    verseId: 118,
    name: "طه",
    surahId: 20,
    text: "وَأَنَّكَ لَا تَظۡمَؤُاْ فِيهَا وَلَا تَضۡحَىٰ",
    translation:
      "And indeed, you will not be thirsty therein or be hot from the sun",
    normalizedText: "وانك لا تظماا فيها ولا تضحى",
  },
  {
    verseId: 119,
    name: "طه",
    surahId: 20,
    text: "فَوَسۡوَسَ إِلَيۡهِ ٱلشَّيۡطَٰنُ قَالَ يَـٰٓـَٔادَمُ هَلۡ أَدُلُّكَ عَلَىٰ شَجَرَةِ ٱلۡخُلۡدِ وَمُلۡكٖ لَّا يَبۡلَىٰ",
    translation:
      'Then Satan whispered to him; he said, "O Adam, shall I direct you to the tree of eternity and possession that will not deteriorate',
    normalizedText:
      "فوسوس اليه الشيطن قال يادم هل ادلك على شجرة الخلد وملك لا يبلى",
  },
  {
    verseId: 120,
    name: "طه",
    surahId: 20,
    text: "فَأَكَلَا مِنۡهَا فَبَدَتۡ لَهُمَا سَوۡءَٰتُهُمَا وَطَفِقَا يَخۡصِفَانِ عَلَيۡهِمَا مِن وَرَقِ ٱلۡجَنَّةِۚ وَعَصَىٰٓ ءَادَمُ رَبَّهُۥ فَغَوَىٰ",
    translation:
      "And Adam and his wife ate of it, and their private parts became apparent to them, and they began to fasten over themselves from the leaves of Paradise. And Adam disobeyed his Lord and erred",
    normalizedText:
      "فاكلا منها فبدت لهما سوءتهما وطفقا يخصفان عليهما من ورق الجنة وعصى ءادم ربه فغوى",
  },
  {
    verseId: 121,
    name: "طه",
    surahId: 20,
    text: "ثُمَّ ٱجۡتَبَٰهُ رَبُّهُۥ فَتَابَ عَلَيۡهِ وَهَدَىٰ",
    translation:
      "Then his Lord chose him and turned to him in forgiveness and guided [him]",
    normalizedText: "ثم اجتبه ربه فتاب عليه وهدى",
  },
  {
    verseId: 122,
    name: "طه",
    surahId: 20,
    text: "قَالَ ٱهۡبِطَا مِنۡهَا جَمِيعَۢاۖ بَعۡضُكُمۡ لِبَعۡضٍ عَدُوّٞۖ فَإِمَّا يَأۡتِيَنَّكُم مِّنِّي هُدٗى فَمَنِ ٱتَّبَعَ هُدَايَ فَلَا يَضِلُّ وَلَا يَشۡقَىٰ",
    translation:
      '[Allah] said, "Descend from Paradise - all, [your descendants] being enemies to one another. And if there should come to you guidance from Me - then whoever follows My guidance will neither go astray [in the world] nor suffer [in the Hereafter]',
    normalizedText:
      "قال اهبطا منها جميعا بعضكم لبعض عدو فاما ياتينكم مني هدى فمن اتبع هداي فلا يضل ولا يشقى",
  },
  {
    verseId: 123,
    name: "طه",
    surahId: 20,
    text: "وَمَنۡ أَعۡرَضَ عَن ذِكۡرِي فَإِنَّ لَهُۥ مَعِيشَةٗ ضَنكٗا وَنَحۡشُرُهُۥ يَوۡمَ ٱلۡقِيَٰمَةِ أَعۡمَىٰ",
    translation:
      "And whoever turns away from My remembrance - indeed, he will have a depressed life, and We will gather him on the Day of Resurrection blind",
    normalizedText: "ومن اعرض عن ذكري فان له معيشة ضنكا ونحشره يوم القيمة اعمى",
  },
  {
    verseId: 124,
    name: "طه",
    surahId: 20,
    text: "قَالَ رَبِّ لِمَ حَشَرۡتَنِيٓ أَعۡمَىٰ وَقَدۡ كُنتُ بَصِيرٗا",
    translation:
      'He will say, "My Lord, why have you raised me blind while I was [once] seeing',
    normalizedText: "قال رب لم حشرتني اعمى وقد كنت بصيرا",
  },
  {
    verseId: 125,
    name: "طه",
    surahId: 20,
    text: "قَالَ كَذَٰلِكَ أَتَتۡكَ ءَايَٰتُنَا فَنَسِيتَهَاۖ وَكَذَٰلِكَ ٱلۡيَوۡمَ تُنسَىٰ",
    translation:
      '[Allah] will say, "Thus did Our signs come to you, and you forgot them; and thus will you this Day be forgotten',
    normalizedText: "قال كذلك اتتك ءايتنا فنسيتها وكذلك اليوم تنسى",
  },
  {
    verseId: 126,
    name: "طه",
    surahId: 20,
    text: "وَكَذَٰلِكَ نَجۡزِي مَنۡ أَسۡرَفَ وَلَمۡ يُؤۡمِنۢ بِـَٔايَٰتِ رَبِّهِۦۚ وَلَعَذَابُ ٱلۡأٓخِرَةِ أَشَدُّ وَأَبۡقَىٰٓ",
    translation:
      "And thus do We recompense he who transgressed and did not believe in the signs of his Lord. And the punishment of the Hereafter is more severe and more enduring",
    normalizedText:
      "وكذلك نجزي من اسرف ولم يامن بايت ربه ولعذاب الاخرة اشد وابقى",
  },
  {
    verseId: 127,
    name: "طه",
    surahId: 20,
    text: "أَفَلَمۡ يَهۡدِ لَهُمۡ كَمۡ أَهۡلَكۡنَا قَبۡلَهُم مِّنَ ٱلۡقُرُونِ يَمۡشُونَ فِي مَسَٰكِنِهِمۡۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّأُوْلِي ٱلنُّهَىٰ",
    translation:
      "Then, has it not become clear to them how many generations We destroyed before them as they walk among their dwellings? Indeed in that are signs for those of intelligence",
    normalizedText:
      "افلم يهد لهم كم اهلكنا قبلهم من القرون يمشون في مسكنهم ان في ذلك لايت لاولي النهى",
  },
  {
    verseId: 128,
    name: "طه",
    surahId: 20,
    text: "وَلَوۡلَا كَلِمَةٞ سَبَقَتۡ مِن رَّبِّكَ لَكَانَ لِزَامٗا وَأَجَلٞ مُّسَمّٗى",
    translation:
      "And if not for a word that preceded from your Lord, punishment would have been an obligation [due immediately], and [if not for] a specified term [decreed]",
    normalizedText: "ولولا كلمة سبقت من ربك لكان لزاما واجل مسمى",
  },
  {
    verseId: 129,
    name: "طه",
    surahId: 20,
    text: "فَٱصۡبِرۡ عَلَىٰ مَا يَقُولُونَ وَسَبِّحۡ بِحَمۡدِ رَبِّكَ قَبۡلَ طُلُوعِ ٱلشَّمۡسِ وَقَبۡلَ غُرُوبِهَاۖ وَمِنۡ ءَانَآيِٕ ٱلَّيۡلِ فَسَبِّحۡ وَأَطۡرَافَ ٱلنَّهَارِ لَعَلَّكَ تَرۡضَىٰ",
    translation:
      "So be patient over what they say and exalt [Allah] with praise of your Lord before the rising of the sun and before its setting; and during periods of the night [exalt Him] and at the ends of the day, that you may be satisfied",
    normalizedText:
      "فاصبر على ما يقولون وسبح بحمد ربك قبل طلوع الشمس وقبل غروبها ومن ءاناي اليل فسبح واطراف النهار لعلك ترضى",
  },
  {
    verseId: 130,
    name: "طه",
    surahId: 20,
    text: "وَلَا تَمُدَّنَّ عَيۡنَيۡكَ إِلَىٰ مَا مَتَّعۡنَا بِهِۦٓ أَزۡوَٰجٗا مِّنۡهُمۡ زَهۡرَةَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا لِنَفۡتِنَهُمۡ فِيهِۚ وَرِزۡقُ رَبِّكَ خَيۡرٞ وَأَبۡقَىٰ",
    translation:
      "And do not extend your eyes toward that by which We have given enjoyment to [some] categories of them, [its being but] the splendor of worldly life by which We test them. And the provision of your Lord is better and more enduring",
    normalizedText:
      "ولا تمدن عينيك الى ما متعنا به ازوجا منهم زهرة الحيوة الدنيا لنفتنهم فيه ورزق ربك خير وابقى",
  },
  {
    verseId: 131,
    name: "طه",
    surahId: 20,
    text: "وَأۡمُرۡ أَهۡلَكَ بِٱلصَّلَوٰةِ وَٱصۡطَبِرۡ عَلَيۡهَاۖ لَا نَسۡـَٔلُكَ رِزۡقٗاۖ نَّحۡنُ نَرۡزُقُكَۗ وَٱلۡعَٰقِبَةُ لِلتَّقۡوَىٰ",
    translation:
      "And enjoin prayer upon your family [and people] and be steadfast therein. We ask you not for provision; We provide for you, and the [best] outcome is for [those of] righteousness",
    normalizedText:
      "وامر اهلك بالصلوة واصطبر عليها لا نسلك رزقا نحن نرزقك والعقبة للتقوى",
  },
  {
    verseId: 132,
    name: "طه",
    surahId: 20,
    text: "وَقَالُواْ لَوۡلَا يَأۡتِينَا بِـَٔايَةٖ مِّن رَّبِّهِۦٓۚ أَوَلَمۡ تَأۡتِهِم بَيِّنَةُ مَا فِي ٱلصُّحُفِ ٱلۡأُولَىٰ",
    translation:
      'And they say, "Why does he not bring us a sign from his Lord?" Has there not come to them evidence of what was in the former scriptures',
    normalizedText:
      "وقالوا لولا ياتينا باية من ربه اولم تاتهم بينة ما في الصحف الاولى",
  },
  {
    verseId: 133,
    name: "طه",
    surahId: 20,
    text: "وَلَوۡ أَنَّآ أَهۡلَكۡنَٰهُم بِعَذَابٖ مِّن قَبۡلِهِۦ لَقَالُواْ رَبَّنَا لَوۡلَآ أَرۡسَلۡتَ إِلَيۡنَا رَسُولٗا فَنَتَّبِعَ ءَايَٰتِكَ مِن قَبۡلِ أَن نَّذِلَّ وَنَخۡزَىٰ",
    translation:
      'And if We had destroyed them with a punishment before him, they would have said, "Our Lord, why did You not send to us a messenger so we could have followed Your verses before we were humiliated and disgraced',
    normalizedText:
      "ولو انا اهلكنهم بعذاب من قبله لقالوا ربنا لولا ارسلت الينا رسولا فنتبع ءايتك من قبل ان نذل ونخزى",
  },
  {
    verseId: 134,
    name: "طه",
    surahId: 20,
    text: "قُلۡ كُلّٞ مُّتَرَبِّصٞ فَتَرَبَّصُواْۖ فَسَتَعۡلَمُونَ مَنۡ أَصۡحَٰبُ ٱلصِّرَٰطِ ٱلسَّوِيِّ وَمَنِ ٱهۡتَدَىٰ",
    translation:
      'Say, "Each [of us] is waiting; so wait. For you will know who are the companions of the sound path and who is guided',
    normalizedText:
      "قل كل متربص فتربصوا فستعلمون من اصحب الصرط السوي ومن اهتدى",
  },
  {
    verseId: 0,
    name: "الأنبياء",
    surahId: 21,
    text: "ٱقۡتَرَبَ لِلنَّاسِ حِسَابُهُمۡ وَهُمۡ فِي غَفۡلَةٖ مُّعۡرِضُونَ",
    translation:
      "[The time of] their account has approached for the people, while they are in heedlessness turning away",
    normalizedText: "اقترب للناس حسابهم وهم في غفلة معرضون",
  },
  {
    verseId: 1,
    name: "الأنبياء",
    surahId: 21,
    text: "مَا يَأۡتِيهِم مِّن ذِكۡرٖ مِّن رَّبِّهِم مُّحۡدَثٍ إِلَّا ٱسۡتَمَعُوهُ وَهُمۡ يَلۡعَبُونَ",
    translation:
      "No mention comes to them anew from their Lord except that they listen to it while they are at play",
    normalizedText: "ما ياتيهم من ذكر من ربهم محدث الا استمعوه وهم يلعبون",
  },
  {
    verseId: 2,
    name: "الأنبياء",
    surahId: 21,
    text: "لَاهِيَةٗ قُلُوبُهُمۡۗ وَأَسَرُّواْ ٱلنَّجۡوَى ٱلَّذِينَ ظَلَمُواْ هَلۡ هَٰذَآ إِلَّا بَشَرٞ مِّثۡلُكُمۡۖ أَفَتَأۡتُونَ ٱلسِّحۡرَ وَأَنتُمۡ تُبۡصِرُونَ",
    translation:
      'With their hearts distracted. And those who do wrong conceal their private conversation, [saying], "Is this [Prophet] except a human being like you? So would you approach magic while you are aware [of it]',
    normalizedText:
      "لاهية قلوبهم واسروا النجوى الذين ظلموا هل هذا الا بشر مثلكم افتاتون السحر وانتم تبصرون",
  },
  {
    verseId: 3,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالَ رَبِّي يَعۡلَمُ ٱلۡقَوۡلَ فِي ٱلسَّمَآءِ وَٱلۡأَرۡضِۖ وَهُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      'The Prophet said, "My Lord knows whatever is said throughout the heaven and earth, and He is the Hearing, the Knowing',
    normalizedText: "قال ربي يعلم القول في السماء والارض وهو السميع العليم",
  },
  {
    verseId: 4,
    name: "الأنبياء",
    surahId: 21,
    text: "بَلۡ قَالُوٓاْ أَضۡغَٰثُ أَحۡلَٰمِۭ بَلِ ٱفۡتَرَىٰهُ بَلۡ هُوَ شَاعِرٞ فَلۡيَأۡتِنَا بِـَٔايَةٖ كَمَآ أُرۡسِلَ ٱلۡأَوَّلُونَ",
    translation:
      'But they say, "[The revelation is but] a mixture of false dreams; rather, he has invented it; rather, he is a poet. So let him bring us a sign just as the previous [messengers] were sent [with miracles]',
    normalizedText:
      "بل قالوا اضغث احلم بل افترىه بل هو شاعر فلياتنا باية كما ارسل الاولون",
  },
  {
    verseId: 5,
    name: "الأنبياء",
    surahId: 21,
    text: "مَآ ءَامَنَتۡ قَبۡلَهُم مِّن قَرۡيَةٍ أَهۡلَكۡنَٰهَآۖ أَفَهُمۡ يُؤۡمِنُونَ",
    translation:
      "Not a [single] city which We destroyed believed before them, so will they believe",
    normalizedText: "ما ءامنت قبلهم من قرية اهلكنها افهم يامنون",
  },
  {
    verseId: 6,
    name: "الأنبياء",
    surahId: 21,
    text: "وَمَآ أَرۡسَلۡنَا قَبۡلَكَ إِلَّا رِجَالٗا نُّوحِيٓ إِلَيۡهِمۡۖ فَسۡـَٔلُوٓاْ أَهۡلَ ٱلذِّكۡرِ إِن كُنتُمۡ لَا تَعۡلَمُونَ",
    translation:
      "And We sent not before you, [O Muhammad], except men to whom We revealed [the message], so ask the people of the message if you do not know",
    normalizedText:
      "وما ارسلنا قبلك الا رجالا نوحي اليهم فسلوا اهل الذكر ان كنتم لا تعلمون",
  },
  {
    verseId: 7,
    name: "الأنبياء",
    surahId: 21,
    text: "وَمَا جَعَلۡنَٰهُمۡ جَسَدٗا لَّا يَأۡكُلُونَ ٱلطَّعَامَ وَمَا كَانُواْ خَٰلِدِينَ",
    translation:
      "And We did not make the prophets forms not eating food, nor were they immortal [on earth]",
    normalizedText: "وما جعلنهم جسدا لا ياكلون الطعام وما كانوا خلدين",
  },
  {
    verseId: 8,
    name: "الأنبياء",
    surahId: 21,
    text: "ثُمَّ صَدَقۡنَٰهُمُ ٱلۡوَعۡدَ فَأَنجَيۡنَٰهُمۡ وَمَن نَّشَآءُ وَأَهۡلَكۡنَا ٱلۡمُسۡرِفِينَ",
    translation:
      "Then We fulfilled for them the promise, and We saved them and whom We willed and destroyed the transgressors",
    normalizedText: "ثم صدقنهم الوعد فانجينهم ومن نشاء واهلكنا المسرفين",
  },
  {
    verseId: 9,
    name: "الأنبياء",
    surahId: 21,
    text: "لَقَدۡ أَنزَلۡنَآ إِلَيۡكُمۡ كِتَٰبٗا فِيهِ ذِكۡرُكُمۡۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "We have certainly sent down to you a Book in which is your mention. Then will you not reason",
    normalizedText: "لقد انزلنا اليكم كتبا فيه ذكركم افلا تعقلون",
  },
  {
    verseId: 10,
    name: "الأنبياء",
    surahId: 21,
    text: "وَكَمۡ قَصَمۡنَا مِن قَرۡيَةٖ كَانَتۡ ظَالِمَةٗ وَأَنشَأۡنَا بَعۡدَهَا قَوۡمًا ءَاخَرِينَ",
    translation:
      "And how many a city which was unjust have We shattered and produced after it another people",
    normalizedText: "وكم قصمنا من قرية كانت ظالمة وانشانا بعدها قوما ءاخرين",
  },
  {
    verseId: 11,
    name: "الأنبياء",
    surahId: 21,
    text: "فَلَمَّآ أَحَسُّواْ بَأۡسَنَآ إِذَا هُم مِّنۡهَا يَرۡكُضُونَ",
    translation:
      "And when its inhabitants perceived Our punishment, at once they fled from it",
    normalizedText: "فلما احسوا باسنا اذا هم منها يركضون",
  },
  {
    verseId: 12,
    name: "الأنبياء",
    surahId: 21,
    text: "لَا تَرۡكُضُواْ وَٱرۡجِعُوٓاْ إِلَىٰ مَآ أُتۡرِفۡتُمۡ فِيهِ وَمَسَٰكِنِكُمۡ لَعَلَّكُمۡ تُسۡـَٔلُونَ",
    translation:
      '[Some angels said], "Do not flee but return to where you were given luxury and to your homes - perhaps you will be questioned',
    normalizedText: "لا تركضوا وارجعوا الى ما اترفتم فيه ومسكنكم لعلكم تسلون",
  },
  {
    verseId: 13,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُواْ يَٰوَيۡلَنَآ إِنَّا كُنَّا ظَٰلِمِينَ",
    translation: 'They said, "O woe to us! Indeed, we were wrongdoers',
    normalizedText: "قالوا يويلنا انا كنا ظلمين",
  },
  {
    verseId: 14,
    name: "الأنبياء",
    surahId: 21,
    text: "فَمَا زَالَت تِّلۡكَ دَعۡوَىٰهُمۡ حَتَّىٰ جَعَلۡنَٰهُمۡ حَصِيدًا خَٰمِدِينَ",
    translation:
      "And that declaration of theirs did not cease until We made them [as] a harvest [mowed down], extinguished [like a fire]",
    normalizedText: "فما زالت تلك دعوىهم حتى جعلنهم حصيدا خمدين",
  },
  {
    verseId: 15,
    name: "الأنبياء",
    surahId: 21,
    text: "وَمَا خَلَقۡنَا ٱلسَّمَآءَ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَا لَٰعِبِينَ",
    translation:
      "And We did not create the heaven and earth and that between them in play",
    normalizedText: "وما خلقنا السماء والارض وما بينهما لعبين",
  },
  {
    verseId: 16,
    name: "الأنبياء",
    surahId: 21,
    text: "لَوۡ أَرَدۡنَآ أَن نَّتَّخِذَ لَهۡوٗا لَّٱتَّخَذۡنَٰهُ مِن لَّدُنَّآ إِن كُنَّا فَٰعِلِينَ",
    translation:
      "Had We intended to take a diversion, We could have taken it from [what is] with Us - if [indeed] We were to do so",
    normalizedText: "لو اردنا ان نتخذ لهوا لاتخذنه من لدنا ان كنا فعلين",
  },
  {
    verseId: 17,
    name: "الأنبياء",
    surahId: 21,
    text: "بَلۡ نَقۡذِفُ بِٱلۡحَقِّ عَلَى ٱلۡبَٰطِلِ فَيَدۡمَغُهُۥ فَإِذَا هُوَ زَاهِقٞۚ وَلَكُمُ ٱلۡوَيۡلُ مِمَّا تَصِفُونَ",
    translation:
      "Rather, We dash the truth upon falsehood, and it destroys it, and thereupon it departs. And for you is destruction from that which you describe",
    normalizedText:
      "بل نقذف بالحق على البطل فيدمغه فاذا هو زاهق ولكم الويل مما تصفون",
  },
  {
    verseId: 18,
    name: "الأنبياء",
    surahId: 21,
    text: "وَلَهُۥ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَمَنۡ عِندَهُۥ لَا يَسۡتَكۡبِرُونَ عَنۡ عِبَادَتِهِۦ وَلَا يَسۡتَحۡسِرُونَ",
    translation:
      "To Him belongs whoever is in the heavens and the earth. And those near Him are not prevented by arrogance from His worship, nor do they tire",
    normalizedText:
      "وله من في السموت والارض ومن عنده لا يستكبرون عن عبادته ولا يستحسرون",
  },
  {
    verseId: 19,
    name: "الأنبياء",
    surahId: 21,
    text: "يُسَبِّحُونَ ٱلَّيۡلَ وَٱلنَّهَارَ لَا يَفۡتُرُونَ",
    translation: "They exalt [Him] night and day [and] do not slacken",
    normalizedText: "يسبحون اليل والنهار لا يفترون",
  },
  {
    verseId: 20,
    name: "الأنبياء",
    surahId: 21,
    text: "أَمِ ٱتَّخَذُوٓاْ ءَالِهَةٗ مِّنَ ٱلۡأَرۡضِ هُمۡ يُنشِرُونَ",
    translation:
      "Or have men taken for themselves gods from the earth who resurrect [the dead]",
    normalizedText: "ام اتخذوا ءالهة من الارض هم ينشرون",
  },
  {
    verseId: 21,
    name: "الأنبياء",
    surahId: 21,
    text: "لَوۡ كَانَ فِيهِمَآ ءَالِهَةٌ إِلَّا ٱللَّهُ لَفَسَدَتَاۚ فَسُبۡحَٰنَ ٱللَّهِ رَبِّ ٱلۡعَرۡشِ عَمَّا يَصِفُونَ",
    translation:
      "Had there been within the heavens and earth gods besides Allah, they both would have been ruined. So exalted is Allah, Lord of the Throne, above what they describe",
    normalizedText:
      "لو كان فيهما ءالهة الا الله لفسدتا فسبحن الله رب العرش عما يصفون",
  },
  {
    verseId: 22,
    name: "الأنبياء",
    surahId: 21,
    text: "لَا يُسۡـَٔلُ عَمَّا يَفۡعَلُ وَهُمۡ يُسۡـَٔلُونَ",
    translation:
      "He is not questioned about what He does, but they will be questioned",
    normalizedText: "لا يسل عما يفعل وهم يسلون",
  },
  {
    verseId: 23,
    name: "الأنبياء",
    surahId: 21,
    text: "أَمِ ٱتَّخَذُواْ مِن دُونِهِۦٓ ءَالِهَةٗۖ قُلۡ هَاتُواْ بُرۡهَٰنَكُمۡۖ هَٰذَا ذِكۡرُ مَن مَّعِيَ وَذِكۡرُ مَن قَبۡلِيۚ بَلۡ أَكۡثَرُهُمۡ لَا يَعۡلَمُونَ ٱلۡحَقَّۖ فَهُم مُّعۡرِضُونَ",
    translation: `Or have they taken gods besides Him? Say, [O Muhammad], "Produce your proof. This [Qur'an] is the message for those with me and the message of those before me." But most of them do not know the truth, so they are turning away`,
    normalizedText:
      "ام اتخذوا من دونه ءالهة قل هاتوا برهنكم هذا ذكر من معي وذكر من قبلي بل اكثرهم لا يعلمون الحق فهم معرضون",
  },
  {
    verseId: 24,
    name: "الأنبياء",
    surahId: 21,
    text: "وَمَآ أَرۡسَلۡنَا مِن قَبۡلِكَ مِن رَّسُولٍ إِلَّا نُوحِيٓ إِلَيۡهِ أَنَّهُۥ لَآ إِلَٰهَ إِلَّآ أَنَا۠ فَٱعۡبُدُونِ",
    translation:
      'And We sent not before you any messenger except that We revealed to him that, "There is no deity except Me, so worship Me',
    normalizedText:
      "وما ارسلنا من قبلك من رسول الا نوحي اليه انه لا اله الا انا فاعبدون",
  },
  {
    verseId: 25,
    name: "الأنبياء",
    surahId: 21,
    text: "وَقَالُواْ ٱتَّخَذَ ٱلرَّحۡمَٰنُ وَلَدٗاۗ سُبۡحَٰنَهُۥۚ بَلۡ عِبَادٞ مُّكۡرَمُونَ",
    translation:
      'And they say, "The Most Merciful has taken a son." Exalted is He! Rather, they are [but] honored servants',
    normalizedText: "وقالوا اتخذ الرحمن ولدا سبحنه بل عباد مكرمون",
  },
  {
    verseId: 26,
    name: "الأنبياء",
    surahId: 21,
    text: "لَا يَسۡبِقُونَهُۥ بِٱلۡقَوۡلِ وَهُم بِأَمۡرِهِۦ يَعۡمَلُونَ",
    translation: "They cannot precede Him in word, and they act by His command",
    normalizedText: "لا يسبقونه بالقول وهم بامره يعملون",
  },
  {
    verseId: 27,
    name: "الأنبياء",
    surahId: 21,
    text: "يَعۡلَمُ مَا بَيۡنَ أَيۡدِيهِمۡ وَمَا خَلۡفَهُمۡ وَلَا يَشۡفَعُونَ إِلَّا لِمَنِ ٱرۡتَضَىٰ وَهُم مِّنۡ خَشۡيَتِهِۦ مُشۡفِقُونَ",
    translation:
      "He knows what is [presently] before them and what will be after them, and they cannot intercede except on behalf of one whom He approves. And they, from fear of Him, are apprehensive",
    normalizedText:
      "يعلم ما بين ايديهم وما خلفهم ولا يشفعون الا لمن ارتضى وهم من خشيته مشفقون",
  },
  {
    verseId: 28,
    name: "الأنبياء",
    surahId: 21,
    text: "۞وَمَن يَقُلۡ مِنۡهُمۡ إِنِّيٓ إِلَٰهٞ مِّن دُونِهِۦ فَذَٰلِكَ نَجۡزِيهِ جَهَنَّمَۚ كَذَٰلِكَ نَجۡزِي ٱلظَّـٰلِمِينَ",
    translation:
      'And whoever of them should say, "Indeed, I am a god besides Him"- that one We would recompense with Hell. Thus do We recompense the wrongdoers',
    normalizedText:
      "۞ومن يقل منهم اني اله من دونه فذلك نجزيه جهنم كذلك نجزي الظلمين",
  },
  {
    verseId: 29,
    name: "الأنبياء",
    surahId: 21,
    text: "أَوَلَمۡ يَرَ ٱلَّذِينَ كَفَرُوٓاْ أَنَّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ كَانَتَا رَتۡقٗا فَفَتَقۡنَٰهُمَاۖ وَجَعَلۡنَا مِنَ ٱلۡمَآءِ كُلَّ شَيۡءٍ حَيٍّۚ أَفَلَا يُؤۡمِنُونَ",
    translation:
      "Have those who disbelieved not considered that the heavens and the earth were a joined entity, and We separated them and made from water every living thing? Then will they not believe",
    normalizedText:
      "اولم ير الذين كفروا ان السموت والارض كانتا رتقا ففتقنهما وجعلنا من الماء كل شيء حي افلا يامنون",
  },
  {
    verseId: 30,
    name: "الأنبياء",
    surahId: 21,
    text: "وَجَعَلۡنَا فِي ٱلۡأَرۡضِ رَوَٰسِيَ أَن تَمِيدَ بِهِمۡ وَجَعَلۡنَا فِيهَا فِجَاجٗا سُبُلٗا لَّعَلَّهُمۡ يَهۡتَدُونَ",
    translation:
      "And We placed within the earth firmly set mountains, lest it should shift with them, and We made therein [mountain] passes [as] roads that they might be guided",
    normalizedText:
      "وجعلنا في الارض روسي ان تميد بهم وجعلنا فيها فجاجا سبلا لعلهم يهتدون",
  },
  {
    verseId: 31,
    name: "الأنبياء",
    surahId: 21,
    text: "وَجَعَلۡنَا ٱلسَّمَآءَ سَقۡفٗا مَّحۡفُوظٗاۖ وَهُمۡ عَنۡ ءَايَٰتِهَا مُعۡرِضُونَ",
    translation:
      "And We made the sky a protected ceiling, but they, from its signs, are turning away",
    normalizedText: "وجعلنا السماء سقفا محفوظا وهم عن ءايتها معرضون",
  },
  {
    verseId: 32,
    name: "الأنبياء",
    surahId: 21,
    text: "وَهُوَ ٱلَّذِي خَلَقَ ٱلَّيۡلَ وَٱلنَّهَارَ وَٱلشَّمۡسَ وَٱلۡقَمَرَۖ كُلّٞ فِي فَلَكٖ يَسۡبَحُونَ",
    translation:
      "And it is He who created the night and the day and the sun and the moon; all [heavenly bodies] in an orbit are swimming",
    normalizedText: "وهو الذي خلق اليل والنهار والشمس والقمر كل في فلك يسبحون",
  },
  {
    verseId: 33,
    name: "الأنبياء",
    surahId: 21,
    text: "وَمَا جَعَلۡنَا لِبَشَرٖ مِّن قَبۡلِكَ ٱلۡخُلۡدَۖ أَفَإِيْن مِّتَّ فَهُمُ ٱلۡخَٰلِدُونَ",
    translation:
      "And We did not grant to any man before you eternity [on earth]; so if you die - would they be eternal",
    normalizedText: "وما جعلنا لبشر من قبلك الخلد افاين مت فهم الخلدون",
  },
  {
    verseId: 34,
    name: "الأنبياء",
    surahId: 21,
    text: "كُلُّ نَفۡسٖ ذَآئِقَةُ ٱلۡمَوۡتِۗ وَنَبۡلُوكُم بِٱلشَّرِّ وَٱلۡخَيۡرِ فِتۡنَةٗۖ وَإِلَيۡنَا تُرۡجَعُونَ",
    translation:
      "Every soul will taste death. And We test you with evil and with good as trial; and to Us you will be returned",
    normalizedText:
      "كل نفس ذااقة الموت ونبلوكم بالشر والخير فتنة والينا ترجعون",
  },
  {
    verseId: 35,
    name: "الأنبياء",
    surahId: 21,
    text: "وَإِذَا رَءَاكَ ٱلَّذِينَ كَفَرُوٓاْ إِن يَتَّخِذُونَكَ إِلَّا هُزُوًا أَهَٰذَا ٱلَّذِي يَذۡكُرُ ءَالِهَتَكُمۡ وَهُم بِذِكۡرِ ٱلرَّحۡمَٰنِ هُمۡ كَٰفِرُونَ",
    translation:
      'And when those who disbelieve see you, [O Muhammad], they take you not except in ridicule, [saying], "Is this the one who insults your gods?" And they are, at the mention of the Most Merciful, disbelievers',
    normalizedText:
      "واذا رءاك الذين كفروا ان يتخذونك الا هزوا اهذا الذي يذكر ءالهتكم وهم بذكر الرحمن هم كفرون",
  },
  {
    verseId: 36,
    name: "الأنبياء",
    surahId: 21,
    text: "خُلِقَ ٱلۡإِنسَٰنُ مِنۡ عَجَلٖۚ سَأُوْرِيكُمۡ ءَايَٰتِي فَلَا تَسۡتَعۡجِلُونِ",
    translation:
      "Man was created of haste. I will show you My signs, so do not impatiently urge Me",
    normalizedText: "خلق الانسن من عجل ساوريكم ءايتي فلا تستعجلون",
  },
  {
    verseId: 37,
    name: "الأنبياء",
    surahId: 21,
    text: "وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلۡوَعۡدُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "When is this promise, if you should be truthful',
    normalizedText: "ويقولون متى هذا الوعد ان كنتم صدقين",
  },
  {
    verseId: 38,
    name: "الأنبياء",
    surahId: 21,
    text: "لَوۡ يَعۡلَمُ ٱلَّذِينَ كَفَرُواْ حِينَ لَا يَكُفُّونَ عَن وُجُوهِهِمُ ٱلنَّارَ وَلَا عَن ظُهُورِهِمۡ وَلَا هُمۡ يُنصَرُونَ",
    translation:
      "If those who disbelieved but knew the time when they will not avert the Fire from their faces or from their backs and they will not be aided",
    normalizedText:
      "لو يعلم الذين كفروا حين لا يكفون عن وجوههم النار ولا عن ظهورهم ولا هم ينصرون",
  },
  {
    verseId: 39,
    name: "الأنبياء",
    surahId: 21,
    text: "بَلۡ تَأۡتِيهِم بَغۡتَةٗ فَتَبۡهَتُهُمۡ فَلَا يَسۡتَطِيعُونَ رَدَّهَا وَلَا هُمۡ يُنظَرُونَ",
    translation:
      "Rather, it will come to them unexpectedly and bewilder them, and they will not be able to repel it, nor will they be reprieved",
    normalizedText: "بل تاتيهم بغتة فتبهتهم فلا يستطيعون ردها ولا هم ينظرون",
  },
  {
    verseId: 40,
    name: "الأنبياء",
    surahId: 21,
    text: "وَلَقَدِ ٱسۡتُهۡزِئَ بِرُسُلٖ مِّن قَبۡلِكَ فَحَاقَ بِٱلَّذِينَ سَخِرُواْ مِنۡهُم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "And already were messengers ridiculed before you, but those who mocked them were enveloped by what they used to ridicule",
    normalizedText:
      "ولقد استهزا برسل من قبلك فحاق بالذين سخروا منهم ما كانوا به يستهزءون",
  },
  {
    verseId: 41,
    name: "الأنبياء",
    surahId: 21,
    text: "قُلۡ مَن يَكۡلَؤُكُم بِٱلَّيۡلِ وَٱلنَّهَارِ مِنَ ٱلرَّحۡمَٰنِۚ بَلۡ هُمۡ عَن ذِكۡرِ رَبِّهِم مُّعۡرِضُونَ",
    translation:
      'Say, "Who can protect you at night or by day from the Most Merciful?" But they are, from the remembrance of their Lord, turning away',
    normalizedText:
      "قل من يكلاكم باليل والنهار من الرحمن بل هم عن ذكر ربهم معرضون",
  },
  {
    verseId: 42,
    name: "الأنبياء",
    surahId: 21,
    text: "أَمۡ لَهُمۡ ءَالِهَةٞ تَمۡنَعُهُم مِّن دُونِنَاۚ لَا يَسۡتَطِيعُونَ نَصۡرَ أَنفُسِهِمۡ وَلَا هُم مِّنَّا يُصۡحَبُونَ",
    translation:
      "Or do they have gods to defend them other than Us? They are unable [even] to help themselves, nor can they be protected from Us",
    normalizedText:
      "ام لهم ءالهة تمنعهم من دوننا لا يستطيعون نصر انفسهم ولا هم منا يصحبون",
  },
  {
    verseId: 43,
    name: "الأنبياء",
    surahId: 21,
    text: "بَلۡ مَتَّعۡنَا هَـٰٓؤُلَآءِ وَءَابَآءَهُمۡ حَتَّىٰ طَالَ عَلَيۡهِمُ ٱلۡعُمُرُۗ أَفَلَا يَرَوۡنَ أَنَّا نَأۡتِي ٱلۡأَرۡضَ نَنقُصُهَا مِنۡ أَطۡرَافِهَآۚ أَفَهُمُ ٱلۡغَٰلِبُونَ",
    translation:
      "But, [on the contrary], We have provided good things for these [disbelievers] and their fathers until life was prolonged for them. Then do they not see that We set upon the land, reducing it from its borders? So it is they who will overcome",
    normalizedText:
      "بل متعنا هالاء وءاباءهم حتى طال عليهم العمر افلا يرون انا ناتي الارض ننقصها من اطرافها افهم الغلبون",
  },
  {
    verseId: 44,
    name: "الأنبياء",
    surahId: 21,
    text: "قُلۡ إِنَّمَآ أُنذِرُكُم بِٱلۡوَحۡيِۚ وَلَا يَسۡمَعُ ٱلصُّمُّ ٱلدُّعَآءَ إِذَا مَا يُنذَرُونَ",
    translation:
      'Say, "I only warn you by revelation." But the deaf do not hear the call when they are warned',
    normalizedText: "قل انما انذركم بالوحي ولا يسمع الصم الدعاء اذا ما ينذرون",
  },
  {
    verseId: 45,
    name: "الأنبياء",
    surahId: 21,
    text: "وَلَئِن مَّسَّتۡهُمۡ نَفۡحَةٞ مِّنۡ عَذَابِ رَبِّكَ لَيَقُولُنَّ يَٰوَيۡلَنَآ إِنَّا كُنَّا ظَٰلِمِينَ",
    translation:
      'And if [as much as] a whiff of the punishment of your Lord should touch them, they would surely say, "O woe to us! Indeed, we have been wrongdoers',
    normalizedText: "ولان مستهم نفحة من عذاب ربك ليقولن يويلنا انا كنا ظلمين",
  },
  {
    verseId: 46,
    name: "الأنبياء",
    surahId: 21,
    text: "وَنَضَعُ ٱلۡمَوَٰزِينَ ٱلۡقِسۡطَ لِيَوۡمِ ٱلۡقِيَٰمَةِ فَلَا تُظۡلَمُ نَفۡسٞ شَيۡـٔٗاۖ وَإِن كَانَ مِثۡقَالَ حَبَّةٖ مِّنۡ خَرۡدَلٍ أَتَيۡنَا بِهَاۗ وَكَفَىٰ بِنَا حَٰسِبِينَ",
    translation:
      "And We place the scales of justice for the Day of Resurrection, so no soul will be treated unjustly at all. And if there is [even] the weight of a mustard seed, We will bring it forth. And sufficient are We as accountant",
    normalizedText:
      "ونضع الموزين القسط ليوم القيمة فلا تظلم نفس شيا وان كان مثقال حبة من خردل اتينا بها وكفى بنا حسبين",
  },
  {
    verseId: 47,
    name: "الأنبياء",
    surahId: 21,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَىٰ وَهَٰرُونَ ٱلۡفُرۡقَانَ وَضِيَآءٗ وَذِكۡرٗا لِّلۡمُتَّقِينَ",
    translation:
      "And We had already given Moses and Aaron the criterion and a light and a reminder for the righteous",
    normalizedText: "ولقد ءاتينا موسى وهرون الفرقان وضياء وذكرا للمتقين",
  },
  {
    verseId: 48,
    name: "الأنبياء",
    surahId: 21,
    text: "ٱلَّذِينَ يَخۡشَوۡنَ رَبَّهُم بِٱلۡغَيۡبِ وَهُم مِّنَ ٱلسَّاعَةِ مُشۡفِقُونَ",
    translation:
      "Who fear their Lord unseen, while they are of the Hour apprehensive",
    normalizedText: "الذين يخشون ربهم بالغيب وهم من الساعة مشفقون",
  },
  {
    verseId: 49,
    name: "الأنبياء",
    surahId: 21,
    text: "وَهَٰذَا ذِكۡرٞ مُّبَارَكٌ أَنزَلۡنَٰهُۚ أَفَأَنتُمۡ لَهُۥ مُنكِرُونَ",
    translation:
      "And this [Qur'an] is a blessed message which We have sent down. Then are you with it unacquainted",
    normalizedText: "وهذا ذكر مبارك انزلنه افانتم له منكرون",
  },
  {
    verseId: 50,
    name: "الأنبياء",
    surahId: 21,
    text: "۞وَلَقَدۡ ءَاتَيۡنَآ إِبۡرَٰهِيمَ رُشۡدَهُۥ مِن قَبۡلُ وَكُنَّا بِهِۦ عَٰلِمِينَ",
    translation:
      "And We had certainly given Abraham his sound judgement before, and We were of him well-Knowing",
    normalizedText: "۞ولقد ءاتينا ابرهيم رشده من قبل وكنا به علمين",
  },
  {
    verseId: 51,
    name: "الأنبياء",
    surahId: 21,
    text: "إِذۡ قَالَ لِأَبِيهِ وَقَوۡمِهِۦ مَا هَٰذِهِ ٱلتَّمَاثِيلُ ٱلَّتِيٓ أَنتُمۡ لَهَا عَٰكِفُونَ",
    translation:
      'When he said to his father and his people, "What are these statues to which you are devoted',
    normalizedText: "اذ قال لابيه وقومه ما هذه التماثيل التي انتم لها عكفون",
  },
  {
    verseId: 52,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُواْ وَجَدۡنَآ ءَابَآءَنَا لَهَا عَٰبِدِينَ",
    translation: 'They said, "We found our fathers worshippers of them',
    normalizedText: "قالوا وجدنا ءاباءنا لها عبدين",
  },
  {
    verseId: 53,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالَ لَقَدۡ كُنتُمۡ أَنتُمۡ وَءَابَآؤُكُمۡ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      'He said, "You were certainly, you and your fathers, in manifest error',
    normalizedText: "قال لقد كنتم انتم وءابااكم في ضلل مبين",
  },
  {
    verseId: 54,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُوٓاْ أَجِئۡتَنَا بِٱلۡحَقِّ أَمۡ أَنتَ مِنَ ٱللَّـٰعِبِينَ",
    translation:
      'They said, "Have you come to us with truth, or are you of those who jest',
    normalizedText: "قالوا اجاتنا بالحق ام انت من اللعبين",
  },
  {
    verseId: 55,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالَ بَل رَّبُّكُمۡ رَبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ ٱلَّذِي فَطَرَهُنَّ وَأَنَا۠ عَلَىٰ ذَٰلِكُم مِّنَ ٱلشَّـٰهِدِينَ",
    translation:
      'He said, "[No], rather, your Lord is the Lord of the heavens and the earth who created them, and I, to that, am of those who testify',
    normalizedText:
      "قال بل ربكم رب السموت والارض الذي فطرهن وانا على ذلكم من الشهدين",
  },
  {
    verseId: 56,
    name: "الأنبياء",
    surahId: 21,
    text: "وَتَٱللَّهِ لَأَكِيدَنَّ أَصۡنَٰمَكُم بَعۡدَ أَن تُوَلُّواْ مُدۡبِرِينَ",
    translation:
      "And [I swear] by Allah, I will surely plan against your idols after you have turned and gone away",
    normalizedText: "وتالله لاكيدن اصنمكم بعد ان تولوا مدبرين",
  },
  {
    verseId: 57,
    name: "الأنبياء",
    surahId: 21,
    text: "فَجَعَلَهُمۡ جُذَٰذًا إِلَّا كَبِيرٗا لَّهُمۡ لَعَلَّهُمۡ إِلَيۡهِ يَرۡجِعُونَ",
    translation:
      "So he made them into fragments, except a large one among them, that they might return to it [and question]",
    normalizedText: "فجعلهم جذذا الا كبيرا لهم لعلهم اليه يرجعون",
  },
  {
    verseId: 58,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُواْ مَن فَعَلَ هَٰذَا بِـَٔالِهَتِنَآ إِنَّهُۥ لَمِنَ ٱلظَّـٰلِمِينَ",
    translation:
      'They said, "Who has done this to our gods? Indeed, he is of the wrongdoers',
    normalizedText: "قالوا من فعل هذا بالهتنا انه لمن الظلمين",
  },
  {
    verseId: 59,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُواْ سَمِعۡنَا فَتٗى يَذۡكُرُهُمۡ يُقَالُ لَهُۥٓ إِبۡرَٰهِيمُ",
    translation:
      'They said, "We heard a young man mention them who is called Abraham',
    normalizedText: "قالوا سمعنا فتى يذكرهم يقال له ابرهيم",
  },
  {
    verseId: 60,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُواْ فَأۡتُواْ بِهِۦ عَلَىٰٓ أَعۡيُنِ ٱلنَّاسِ لَعَلَّهُمۡ يَشۡهَدُونَ",
    translation:
      'They said, "Then bring him before the eyes of the people that they may testify',
    normalizedText: "قالوا فاتوا به على اعين الناس لعلهم يشهدون",
  },
  {
    verseId: 61,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُوٓاْ ءَأَنتَ فَعَلۡتَ هَٰذَا بِـَٔالِهَتِنَا يَـٰٓإِبۡرَٰهِيمُ",
    translation: 'They said, "Have you done this to our gods, O Abraham',
    normalizedText: "قالوا ءانت فعلت هذا بالهتنا يابرهيم",
  },
  {
    verseId: 62,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالَ بَلۡ فَعَلَهُۥ كَبِيرُهُمۡ هَٰذَا فَسۡـَٔلُوهُمۡ إِن كَانُواْ يَنطِقُونَ",
    translation:
      'He said, "Rather, this - the largest of them - did it, so ask them, if they should [be able to] speak',
    normalizedText: "قال بل فعله كبيرهم هذا فسلوهم ان كانوا ينطقون",
  },
  {
    verseId: 63,
    name: "الأنبياء",
    surahId: 21,
    text: "فَرَجَعُوٓاْ إِلَىٰٓ أَنفُسِهِمۡ فَقَالُوٓاْ إِنَّكُمۡ أَنتُمُ ٱلظَّـٰلِمُونَ",
    translation:
      'So they returned to [blaming] themselves and said [to each other], "Indeed, you are the wrongdoers',
    normalizedText: "فرجعوا الى انفسهم فقالوا انكم انتم الظلمون",
  },
  {
    verseId: 64,
    name: "الأنبياء",
    surahId: 21,
    text: "ثُمَّ نُكِسُواْ عَلَىٰ رُءُوسِهِمۡ لَقَدۡ عَلِمۡتَ مَا هَـٰٓؤُلَآءِ يَنطِقُونَ",
    translation:
      'Then they reversed themselves, [saying], "You have already known that these do not speak',
    normalizedText: "ثم نكسوا على رءوسهم لقد علمت ما هالاء ينطقون",
  },
  {
    verseId: 65,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالَ أَفَتَعۡبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُكُمۡ شَيۡـٔٗا وَلَا يَضُرُّكُمۡ",
    translation:
      'He said, "Then do you worship instead of Allah that which does not benefit you at all or harm you',
    normalizedText: "قال افتعبدون من دون الله ما لا ينفعكم شيا ولا يضركم",
  },
  {
    verseId: 66,
    name: "الأنبياء",
    surahId: 21,
    text: "أُفّٖ لَّكُمۡ وَلِمَا تَعۡبُدُونَ مِن دُونِ ٱللَّهِۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "Uff to you and to what you worship instead of Allah. Then will you not use reason",
    normalizedText: "اف لكم ولما تعبدون من دون الله افلا تعقلون",
  },
  {
    verseId: 67,
    name: "الأنبياء",
    surahId: 21,
    text: "قَالُواْ حَرِّقُوهُ وَٱنصُرُوٓاْ ءَالِهَتَكُمۡ إِن كُنتُمۡ فَٰعِلِينَ",
    translation:
      'They said, "Burn him and support your gods - if you are to act',
    normalizedText: "قالوا حرقوه وانصروا ءالهتكم ان كنتم فعلين",
  },
  {
    verseId: 68,
    name: "الأنبياء",
    surahId: 21,
    text: "قُلۡنَا يَٰنَارُ كُونِي بَرۡدٗا وَسَلَٰمًا عَلَىٰٓ إِبۡرَٰهِيمَ",
    translation: 'Allah said, "O fire, be coolness and safety upon Abraham',
    normalizedText: "قلنا ينار كوني بردا وسلما على ابرهيم",
  },
  {
    verseId: 69,
    name: "الأنبياء",
    surahId: 21,
    text: "وَأَرَادُواْ بِهِۦ كَيۡدٗا فَجَعَلۡنَٰهُمُ ٱلۡأَخۡسَرِينَ",
    translation:
      "And they intended for him harm, but We made them the greatest losers",
    normalizedText: "وارادوا به كيدا فجعلنهم الاخسرين",
  },
  {
    verseId: 70,
    name: "الأنبياء",
    surahId: 21,
    text: "وَنَجَّيۡنَٰهُ وَلُوطًا إِلَى ٱلۡأَرۡضِ ٱلَّتِي بَٰرَكۡنَا فِيهَا لِلۡعَٰلَمِينَ",
    translation:
      "And We delivered him and Lot to the land which We had blessed for the worlds",
    normalizedText: "ونجينه ولوطا الى الارض التي بركنا فيها للعلمين",
  },
  {
    verseId: 71,
    name: "الأنبياء",
    surahId: 21,
    text: "وَوَهَبۡنَا لَهُۥٓ إِسۡحَٰقَ وَيَعۡقُوبَ نَافِلَةٗۖ وَكُلّٗا جَعَلۡنَا صَٰلِحِينَ",
    translation:
      "And We gave him Isaac and Jacob in addition, and all [of them] We made righteous",
    normalizedText: "ووهبنا له اسحق ويعقوب نافلة وكلا جعلنا صلحين",
  },
  {
    verseId: 72,
    name: "الأنبياء",
    surahId: 21,
    text: "وَجَعَلۡنَٰهُمۡ أَئِمَّةٗ يَهۡدُونَ بِأَمۡرِنَا وَأَوۡحَيۡنَآ إِلَيۡهِمۡ فِعۡلَ ٱلۡخَيۡرَٰتِ وَإِقَامَ ٱلصَّلَوٰةِ وَإِيتَآءَ ٱلزَّكَوٰةِۖ وَكَانُواْ لَنَا عَٰبِدِينَ",
    translation:
      "And We made them leaders guiding by Our command. And We inspired to them the doing of good deeds, establishment of prayer, and giving of zakah; and they were worshippers of Us",
    normalizedText:
      "وجعلنهم اامة يهدون بامرنا واوحينا اليهم فعل الخيرت واقام الصلوة وايتاء الزكوة وكانوا لنا عبدين",
  },
  {
    verseId: 73,
    name: "الأنبياء",
    surahId: 21,
    text: "وَلُوطًا ءَاتَيۡنَٰهُ حُكۡمٗا وَعِلۡمٗا وَنَجَّيۡنَٰهُ مِنَ ٱلۡقَرۡيَةِ ٱلَّتِي كَانَت تَّعۡمَلُ ٱلۡخَبَـٰٓئِثَۚ إِنَّهُمۡ كَانُواْ قَوۡمَ سَوۡءٖ فَٰسِقِينَ",
    translation:
      "And to Lot We gave judgement and knowledge, and We saved him from the city that was committing wicked deeds. Indeed, they were a people of evil, defiantly disobedient",
    normalizedText:
      "ولوطا ءاتينه حكما وعلما ونجينه من القرية التي كانت تعمل الخباث انهم كانوا قوم سوء فسقين",
  },
  {
    verseId: 74,
    name: "الأنبياء",
    surahId: 21,
    text: "وَأَدۡخَلۡنَٰهُ فِي رَحۡمَتِنَآۖ إِنَّهُۥ مِنَ ٱلصَّـٰلِحِينَ",
    translation:
      "And We admitted him into Our mercy. Indeed, he was of the righteous",
    normalizedText: "وادخلنه في رحمتنا انه من الصلحين",
  },
  {
    verseId: 75,
    name: "الأنبياء",
    surahId: 21,
    text: "وَنُوحًا إِذۡ نَادَىٰ مِن قَبۡلُ فَٱسۡتَجَبۡنَا لَهُۥ فَنَجَّيۡنَٰهُ وَأَهۡلَهُۥ مِنَ ٱلۡكَرۡبِ ٱلۡعَظِيمِ",
    translation:
      "And [mention] Noah, when he called [to Allah] before [that time], so We responded to him and saved him and his family from the great flood",
    normalizedText:
      "ونوحا اذ نادى من قبل فاستجبنا له فنجينه واهله من الكرب العظيم",
  },
  {
    verseId: 76,
    name: "الأنبياء",
    surahId: 21,
    text: "وَنَصَرۡنَٰهُ مِنَ ٱلۡقَوۡمِ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَآۚ إِنَّهُمۡ كَانُواْ قَوۡمَ سَوۡءٖ فَأَغۡرَقۡنَٰهُمۡ أَجۡمَعِينَ",
    translation:
      "And We saved him from the people who denied Our signs. Indeed, they were a people of evil, so We drowned them, all together",
    normalizedText:
      "ونصرنه من القوم الذين كذبوا بايتنا انهم كانوا قوم سوء فاغرقنهم اجمعين",
  },
  {
    verseId: 77,
    name: "الأنبياء",
    surahId: 21,
    text: "وَدَاوُۥدَ وَسُلَيۡمَٰنَ إِذۡ يَحۡكُمَانِ فِي ٱلۡحَرۡثِ إِذۡ نَفَشَتۡ فِيهِ غَنَمُ ٱلۡقَوۡمِ وَكُنَّا لِحُكۡمِهِمۡ شَٰهِدِينَ",
    translation:
      "And [mention] David and Solomon, when they judged concerning the field - when the sheep of a people overran it [at night], and We were witness to their judgement",
    normalizedText:
      "وداود وسليمن اذ يحكمان في الحرث اذ نفشت فيه غنم القوم وكنا لحكمهم شهدين",
  },
  {
    verseId: 78,
    name: "الأنبياء",
    surahId: 21,
    text: "فَفَهَّمۡنَٰهَا سُلَيۡمَٰنَۚ وَكُلًّا ءَاتَيۡنَا حُكۡمٗا وَعِلۡمٗاۚ وَسَخَّرۡنَا مَعَ دَاوُۥدَ ٱلۡجِبَالَ يُسَبِّحۡنَ وَٱلطَّيۡرَۚ وَكُنَّا فَٰعِلِينَ",
    translation:
      "And We gave understanding of the case to Solomon, and to each [of them] We gave judgement and knowledge. And We subjected the mountains to exalt [Us], along with David and [also] the birds. And We were doing [that]",
    normalizedText:
      "ففهمنها سليمن وكلا ءاتينا حكما وعلما وسخرنا مع داود الجبال يسبحن والطير وكنا فعلين",
  },
  {
    verseId: 79,
    name: "الأنبياء",
    surahId: 21,
    text: "وَعَلَّمۡنَٰهُ صَنۡعَةَ لَبُوسٖ لَّكُمۡ لِتُحۡصِنَكُم مِّنۢ بَأۡسِكُمۡۖ فَهَلۡ أَنتُمۡ شَٰكِرُونَ",
    translation:
      "And We taught him the fashioning of coats of armor to protect you from your [enemy in] battle. So will you then be grateful",
    normalizedText: "وعلمنه صنعة لبوس لكم لتحصنكم من باسكم فهل انتم شكرون",
  },
  {
    verseId: 80,
    name: "الأنبياء",
    surahId: 21,
    text: "وَلِسُلَيۡمَٰنَ ٱلرِّيحَ عَاصِفَةٗ تَجۡرِي بِأَمۡرِهِۦٓ إِلَى ٱلۡأَرۡضِ ٱلَّتِي بَٰرَكۡنَا فِيهَاۚ وَكُنَّا بِكُلِّ شَيۡءٍ عَٰلِمِينَ",
    translation:
      "And to Solomon [We subjected] the wind, blowing forcefully, proceeding by his command toward the land which We had blessed. And We are ever, of all things, Knowing",
    normalizedText:
      "ولسليمن الريح عاصفة تجري بامره الى الارض التي بركنا فيها وكنا بكل شيء علمين",
  },
  {
    verseId: 81,
    name: "الأنبياء",
    surahId: 21,
    text: "وَمِنَ ٱلشَّيَٰطِينِ مَن يَغُوصُونَ لَهُۥ وَيَعۡمَلُونَ عَمَلٗا دُونَ ذَٰلِكَۖ وَكُنَّا لَهُمۡ حَٰفِظِينَ",
    translation:
      "And of the devils were those who dived for him and did work other than that. And We were of them a guardian",
    normalizedText:
      "ومن الشيطين من يغوصون له ويعملون عملا دون ذلك وكنا لهم حفظين",
  },
  {
    verseId: 82,
    name: "الأنبياء",
    surahId: 21,
    text: "۞وَأَيُّوبَ إِذۡ نَادَىٰ رَبَّهُۥٓ أَنِّي مَسَّنِيَ ٱلضُّرُّ وَأَنتَ أَرۡحَمُ ٱلرَّـٰحِمِينَ",
    translation:
      'And [mention] Job, when he called to his Lord, "Indeed, adversity has touched me, and you are the Most Merciful of the merciful',
    normalizedText: "۞وايوب اذ نادى ربه اني مسني الضر وانت ارحم الرحمين",
  },
  {
    verseId: 83,
    name: "الأنبياء",
    surahId: 21,
    text: "فَٱسۡتَجَبۡنَا لَهُۥ فَكَشَفۡنَا مَا بِهِۦ مِن ضُرّٖۖ وَءَاتَيۡنَٰهُ أَهۡلَهُۥ وَمِثۡلَهُم مَّعَهُمۡ رَحۡمَةٗ مِّنۡ عِندِنَا وَذِكۡرَىٰ لِلۡعَٰبِدِينَ",
    translation:
      "So We responded to him and removed what afflicted him of adversity. And We gave him [back] his family and the like thereof with them as mercy from Us and a reminder for the worshippers [of Allah]",
    normalizedText:
      "فاستجبنا له فكشفنا ما به من ضر وءاتينه اهله ومثلهم معهم رحمة من عندنا وذكرى للعبدين",
  },
  {
    verseId: 84,
    name: "الأنبياء",
    surahId: 21,
    text: "وَإِسۡمَٰعِيلَ وَإِدۡرِيسَ وَذَا ٱلۡكِفۡلِۖ كُلّٞ مِّنَ ٱلصَّـٰبِرِينَ",
    translation:
      "And [mention] Ishmael and Idrees and Dhul-Kifl; all were of the patient",
    normalizedText: "واسمعيل وادريس وذا الكفل كل من الصبرين",
  },
  {
    verseId: 85,
    name: "الأنبياء",
    surahId: 21,
    text: "وَأَدۡخَلۡنَٰهُمۡ فِي رَحۡمَتِنَآۖ إِنَّهُم مِّنَ ٱلصَّـٰلِحِينَ",
    translation:
      "And We admitted them into Our mercy. Indeed, they were of the righteous",
    normalizedText: "وادخلنهم في رحمتنا انهم من الصلحين",
  },
  {
    verseId: 86,
    name: "الأنبياء",
    surahId: 21,
    text: "وَذَا ٱلنُّونِ إِذ ذَّهَبَ مُغَٰضِبٗا فَظَنَّ أَن لَّن نَّقۡدِرَ عَلَيۡهِ فَنَادَىٰ فِي ٱلظُّلُمَٰتِ أَن لَّآ إِلَٰهَ إِلَّآ أَنتَ سُبۡحَٰنَكَ إِنِّي كُنتُ مِنَ ٱلظَّـٰلِمِينَ",
    translation:
      'And [mention] the man of the fish, when he went off in anger and thought that We would not decree [anything] upon him. And he called out within the darknesses, "There is no deity except You; exalted are You. Indeed, I have been of the wrongdoers',
    normalizedText:
      "وذا النون اذ ذهب مغضبا فظن ان لن نقدر عليه فنادى في الظلمت ان لا اله الا انت سبحنك اني كنت من الظلمين",
  },
  {
    verseId: 87,
    name: "الأنبياء",
    surahId: 21,
    text: "فَٱسۡتَجَبۡنَا لَهُۥ وَنَجَّيۡنَٰهُ مِنَ ٱلۡغَمِّۚ وَكَذَٰلِكَ نُـۨجِي ٱلۡمُؤۡمِنِينَ",
    translation:
      "So We responded to him and saved him from the distress. And thus do We save the believers",
    normalizedText: "فاستجبنا له ونجينه من الغم وكذلك نجي المامنين",
  },
  {
    verseId: 88,
    name: "الأنبياء",
    surahId: 21,
    text: "وَزَكَرِيَّآ إِذۡ نَادَىٰ رَبَّهُۥ رَبِّ لَا تَذَرۡنِي فَرۡدٗا وَأَنتَ خَيۡرُ ٱلۡوَٰرِثِينَ",
    translation:
      'And [mention] Zechariah, when he called to his Lord, "My Lord, do not leave me alone [with no heir], while you are the best of inheritors',
    normalizedText: "وزكريا اذ نادى ربه رب لا تذرني فردا وانت خير الورثين",
  },
  {
    verseId: 89,
    name: "الأنبياء",
    surahId: 21,
    text: "فَٱسۡتَجَبۡنَا لَهُۥ وَوَهَبۡنَا لَهُۥ يَحۡيَىٰ وَأَصۡلَحۡنَا لَهُۥ زَوۡجَهُۥٓۚ إِنَّهُمۡ كَانُواْ يُسَٰرِعُونَ فِي ٱلۡخَيۡرَٰتِ وَيَدۡعُونَنَا رَغَبٗا وَرَهَبٗاۖ وَكَانُواْ لَنَا خَٰشِعِينَ",
    translation:
      "So We responded to him, and We gave to him John, and amended for him his wife. Indeed, they used to hasten to good deeds and supplicate Us in hope and fear, and they were to Us humbly submissive",
    normalizedText:
      "فاستجبنا له ووهبنا له يحيى واصلحنا له زوجه انهم كانوا يسرعون في الخيرت ويدعوننا رغبا ورهبا وكانوا لنا خشعين",
  },
  {
    verseId: 90,
    name: "الأنبياء",
    surahId: 21,
    text: "وَٱلَّتِيٓ أَحۡصَنَتۡ فَرۡجَهَا فَنَفَخۡنَا فِيهَا مِن رُّوحِنَا وَجَعَلۡنَٰهَا وَٱبۡنَهَآ ءَايَةٗ لِّلۡعَٰلَمِينَ",
    translation:
      "And [mention] the one who guarded her chastity, so We blew into her [garment] through Our angel [Gabriel], and We made her and her son a sign for the worlds",
    normalizedText:
      "والتي احصنت فرجها فنفخنا فيها من روحنا وجعلنها وابنها ءاية للعلمين",
  },
  {
    verseId: 91,
    name: "الأنبياء",
    surahId: 21,
    text: "إِنَّ هَٰذِهِۦٓ أُمَّتُكُمۡ أُمَّةٗ وَٰحِدَةٗ وَأَنَا۠ رَبُّكُمۡ فَٱعۡبُدُونِ",
    translation:
      "Indeed this, your religion, is one religion, and I am your Lord, so worship Me",
    normalizedText: "ان هذه امتكم امة وحدة وانا ربكم فاعبدون",
  },
  {
    verseId: 92,
    name: "الأنبياء",
    surahId: 21,
    text: "وَتَقَطَّعُوٓاْ أَمۡرَهُم بَيۡنَهُمۡۖ كُلٌّ إِلَيۡنَا رَٰجِعُونَ",
    translation:
      "And [yet] they divided their affair among themselves, [but] all to Us will return",
    normalizedText: "وتقطعوا امرهم بينهم كل الينا رجعون",
  },
  {
    verseId: 93,
    name: "الأنبياء",
    surahId: 21,
    text: "فَمَن يَعۡمَلۡ مِنَ ٱلصَّـٰلِحَٰتِ وَهُوَ مُؤۡمِنٞ فَلَا كُفۡرَانَ لِسَعۡيِهِۦ وَإِنَّا لَهُۥ كَٰتِبُونَ",
    translation:
      "So whoever does righteous deeds while he is a believer - no denial will there be for his effort, and indeed We, of it, are recorders",
    normalizedText: "فمن يعمل من الصلحت وهو مامن فلا كفران لسعيه وانا له كتبون",
  },
  {
    verseId: 94,
    name: "الأنبياء",
    surahId: 21,
    text: "وَحَرَٰمٌ عَلَىٰ قَرۡيَةٍ أَهۡلَكۡنَٰهَآ أَنَّهُمۡ لَا يَرۡجِعُونَ",
    translation:
      "And there is prohibition upon [the people of] a city which We have destroyed that they will [ever] return",
    normalizedText: "وحرم على قرية اهلكنها انهم لا يرجعون",
  },
  {
    verseId: 95,
    name: "الأنبياء",
    surahId: 21,
    text: "حَتَّىٰٓ إِذَا فُتِحَتۡ يَأۡجُوجُ وَمَأۡجُوجُ وَهُم مِّن كُلِّ حَدَبٖ يَنسِلُونَ",
    translation:
      "Until when [the dam of] Gog and Magog has been opened and they, from every elevation, descend",
    normalizedText: "حتى اذا فتحت ياجوج وماجوج وهم من كل حدب ينسلون",
  },
  {
    verseId: 96,
    name: "الأنبياء",
    surahId: 21,
    text: "وَٱقۡتَرَبَ ٱلۡوَعۡدُ ٱلۡحَقُّ فَإِذَا هِيَ شَٰخِصَةٌ أَبۡصَٰرُ ٱلَّذِينَ كَفَرُواْ يَٰوَيۡلَنَا قَدۡ كُنَّا فِي غَفۡلَةٖ مِّنۡ هَٰذَا بَلۡ كُنَّا ظَٰلِمِينَ",
    translation:
      'And [when] the true promise has approached; then suddenly the eyes of those who disbelieved will be staring [in horror, while they say], "O woe to us; we had been unmindful of this; rather, we were wrongdoers',
    normalizedText:
      "واقترب الوعد الحق فاذا هي شخصة ابصر الذين كفروا يويلنا قد كنا في غفلة من هذا بل كنا ظلمين",
  },
  {
    verseId: 97,
    name: "الأنبياء",
    surahId: 21,
    text: "إِنَّكُمۡ وَمَا تَعۡبُدُونَ مِن دُونِ ٱللَّهِ حَصَبُ جَهَنَّمَ أَنتُمۡ لَهَا وَٰرِدُونَ",
    translation:
      "Indeed, you [disbelievers] and what you worship other than Allah are the firewood of Hell. You will be coming to [enter] it",
    normalizedText: "انكم وما تعبدون من دون الله حصب جهنم انتم لها وردون",
  },
  {
    verseId: 98,
    name: "الأنبياء",
    surahId: 21,
    text: "لَوۡ كَانَ هَـٰٓؤُلَآءِ ءَالِهَةٗ مَّا وَرَدُوهَاۖ وَكُلّٞ فِيهَا خَٰلِدُونَ",
    translation:
      "Had these [false deities] been [actual] gods, they would not have come to it, but all are eternal therein",
    normalizedText: "لو كان هالاء ءالهة ما وردوها وكل فيها خلدون",
  },
  {
    verseId: 99,
    name: "الأنبياء",
    surahId: 21,
    text: "لَهُمۡ فِيهَا زَفِيرٞ وَهُمۡ فِيهَا لَا يَسۡمَعُونَ",
    translation:
      "For them therein is heavy sighing, and they therein will not hear",
    normalizedText: "لهم فيها زفير وهم فيها لا يسمعون",
  },
  {
    verseId: 100,
    name: "الأنبياء",
    surahId: 21,
    text: "إِنَّ ٱلَّذِينَ سَبَقَتۡ لَهُم مِّنَّا ٱلۡحُسۡنَىٰٓ أُوْلَـٰٓئِكَ عَنۡهَا مُبۡعَدُونَ",
    translation:
      "Indeed, those for whom the best [reward] has preceded from Us - they are from it far removed",
    normalizedText: "ان الذين سبقت لهم منا الحسنى اولاك عنها مبعدون",
  },
  {
    verseId: 101,
    name: "الأنبياء",
    surahId: 21,
    text: "لَا يَسۡمَعُونَ حَسِيسَهَاۖ وَهُمۡ فِي مَا ٱشۡتَهَتۡ أَنفُسُهُمۡ خَٰلِدُونَ",
    translation:
      "They will not hear its sound, while they are, in that which their souls desire, abiding eternally",
    normalizedText: "لا يسمعون حسيسها وهم في ما اشتهت انفسهم خلدون",
  },
  {
    verseId: 102,
    name: "الأنبياء",
    surahId: 21,
    text: "لَا يَحۡزُنُهُمُ ٱلۡفَزَعُ ٱلۡأَكۡبَرُ وَتَتَلَقَّىٰهُمُ ٱلۡمَلَـٰٓئِكَةُ هَٰذَا يَوۡمُكُمُ ٱلَّذِي كُنتُمۡ تُوعَدُونَ",
    translation:
      'They will not be grieved by the greatest terror, and the angels will meet them, [saying], "This is your Day which you have been promised',
    normalizedText:
      "لا يحزنهم الفزع الاكبر وتتلقىهم الملاكة هذا يومكم الذي كنتم توعدون",
  },
  {
    verseId: 103,
    name: "الأنبياء",
    surahId: 21,
    text: "يَوۡمَ نَطۡوِي ٱلسَّمَآءَ كَطَيِّ ٱلسِّجِلِّ لِلۡكُتُبِۚ كَمَا بَدَأۡنَآ أَوَّلَ خَلۡقٖ نُّعِيدُهُۥۚ وَعۡدًا عَلَيۡنَآۚ إِنَّا كُنَّا فَٰعِلِينَ",
    translation:
      "The Day when We will fold the heaven like the folding of a [written] sheet for the records. As We began the first creation, We will repeat it. [That is] a promise binding upon Us. Indeed, We will do it",
    normalizedText:
      "يوم نطوي السماء كطي السجل للكتب كما بدانا اول خلق نعيده وعدا علينا انا كنا فعلين",
  },
  {
    verseId: 104,
    name: "الأنبياء",
    surahId: 21,
    text: "وَلَقَدۡ كَتَبۡنَا فِي ٱلزَّبُورِ مِنۢ بَعۡدِ ٱلذِّكۡرِ أَنَّ ٱلۡأَرۡضَ يَرِثُهَا عِبَادِيَ ٱلصَّـٰلِحُونَ",
    translation:
      "And We have already written in the book [of Psalms] after the [previous] mention that the land [of Paradise] is inherited by My righteous servants",
    normalizedText:
      "ولقد كتبنا في الزبور من بعد الذكر ان الارض يرثها عبادي الصلحون",
  },
  {
    verseId: 105,
    name: "الأنبياء",
    surahId: 21,
    text: "إِنَّ فِي هَٰذَا لَبَلَٰغٗا لِّقَوۡمٍ عَٰبِدِينَ",
    translation:
      "Indeed, in this [Qur'an] is notification for a worshipping people",
    normalizedText: "ان في هذا لبلغا لقوم عبدين",
  },
  {
    verseId: 106,
    name: "الأنبياء",
    surahId: 21,
    text: "وَمَآ أَرۡسَلۡنَٰكَ إِلَّا رَحۡمَةٗ لِّلۡعَٰلَمِينَ",
    translation:
      "And We have not sent you, [O Muhammad], except as a mercy to the worlds",
    normalizedText: "وما ارسلنك الا رحمة للعلمين",
  },
  {
    verseId: 107,
    name: "الأنبياء",
    surahId: 21,
    text: "قُلۡ إِنَّمَا يُوحَىٰٓ إِلَيَّ أَنَّمَآ إِلَٰهُكُمۡ إِلَٰهٞ وَٰحِدٞۖ فَهَلۡ أَنتُم مُّسۡلِمُونَ",
    translation:
      'Say, "It is only revealed to me that your god is but one God; so will you be Muslims [in submission to Him]',
    normalizedText: "قل انما يوحى الي انما الهكم اله وحد فهل انتم مسلمون",
  },
  {
    verseId: 108,
    name: "الأنبياء",
    surahId: 21,
    text: "فَإِن تَوَلَّوۡاْ فَقُلۡ ءَاذَنتُكُمۡ عَلَىٰ سَوَآءٖۖ وَإِنۡ أَدۡرِيٓ أَقَرِيبٌ أَم بَعِيدٞ مَّا تُوعَدُونَ",
    translation:
      'But if they turn away, then say, "I have announced to [all of] you equally. And I know not whether near or far is that which you are promised',
    normalizedText:
      "فان تولوا فقل ءاذنتكم على سواء وان ادري اقريب ام بعيد ما توعدون",
  },
  {
    verseId: 109,
    name: "الأنبياء",
    surahId: 21,
    text: "إِنَّهُۥ يَعۡلَمُ ٱلۡجَهۡرَ مِنَ ٱلۡقَوۡلِ وَيَعۡلَمُ مَا تَكۡتُمُونَ",
    translation:
      "Indeed, He knows what is declared of speech, and He knows what you conceal",
    normalizedText: "انه يعلم الجهر من القول ويعلم ما تكتمون",
  },
  {
    verseId: 110,
    name: "الأنبياء",
    surahId: 21,
    text: "وَإِنۡ أَدۡرِي لَعَلَّهُۥ فِتۡنَةٞ لَّكُمۡ وَمَتَٰعٌ إِلَىٰ حِينٖ",
    translation:
      "And I know not; perhaps it is a trial for you and enjoyment for a time",
    normalizedText: "وان ادري لعله فتنة لكم ومتع الى حين",
  },
  {
    verseId: 111,
    name: "الأنبياء",
    surahId: 21,
    text: "قَٰلَ رَبِّ ٱحۡكُم بِٱلۡحَقِّۗ وَرَبُّنَا ٱلرَّحۡمَٰنُ ٱلۡمُسۡتَعَانُ عَلَىٰ مَا تَصِفُونَ",
    translation:
      '[The Prophet] has said, "My Lord, judge [between us] in truth. And our Lord is the Most Merciful, the one whose help is sought against that which you describe',
    normalizedText: "قل رب احكم بالحق وربنا الرحمن المستعان على ما تصفون",
  },
  {
    verseId: 0,
    name: "الحج",
    surahId: 22,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُواْ رَبَّكُمۡۚ إِنَّ زَلۡزَلَةَ ٱلسَّاعَةِ شَيۡءٌ عَظِيمٞ",
    translation:
      "O mankind, fear your Lord. Indeed, the convulsion of the [final] Hour is a terrible thing",
    normalizedText: "يايها الناس اتقوا ربكم ان زلزلة الساعة شيء عظيم",
  },
  {
    verseId: 1,
    name: "الحج",
    surahId: 22,
    text: "يَوۡمَ تَرَوۡنَهَا تَذۡهَلُ كُلُّ مُرۡضِعَةٍ عَمَّآ أَرۡضَعَتۡ وَتَضَعُ كُلُّ ذَاتِ حَمۡلٍ حَمۡلَهَا وَتَرَى ٱلنَّاسَ سُكَٰرَىٰ وَمَا هُم بِسُكَٰرَىٰ وَلَٰكِنَّ عَذَابَ ٱللَّهِ شَدِيدٞ",
    translation:
      "On the Day you see it every nursing mother will be distracted from that [child] she was nursing, and every pregnant woman will abort her pregnancy, and you will see the people [appearing] intoxicated while they are not intoxicated; but the punishment of Allah is severe",
    normalizedText:
      "يوم ترونها تذهل كل مرضعة عما ارضعت وتضع كل ذات حمل حملها وترى الناس سكرى وما هم بسكرى ولكن عذاب الله شديد",
  },
  {
    verseId: 2,
    name: "الحج",
    surahId: 22,
    text: "وَمِنَ ٱلنَّاسِ مَن يُجَٰدِلُ فِي ٱللَّهِ بِغَيۡرِ عِلۡمٖ وَيَتَّبِعُ كُلَّ شَيۡطَٰنٖ مَّرِيدٖ",
    translation:
      "And of the people is he who disputes about Allah without knowledge and follows every rebellious devil",
    normalizedText: "ومن الناس من يجدل في الله بغير علم ويتبع كل شيطن مريد",
  },
  {
    verseId: 3,
    name: "الحج",
    surahId: 22,
    text: "كُتِبَ عَلَيۡهِ أَنَّهُۥ مَن تَوَلَّاهُ فَأَنَّهُۥ يُضِلُّهُۥ وَيَهۡدِيهِ إِلَىٰ عَذَابِ ٱلسَّعِيرِ",
    translation:
      "It has been decreed for every devil that whoever turns to him - he will misguide him and will lead him to the punishment of the Blaze",
    normalizedText: "كتب عليه انه من تولاه فانه يضله ويهديه الى عذاب السعير",
  },
  {
    verseId: 4,
    name: "الحج",
    surahId: 22,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ إِن كُنتُمۡ فِي رَيۡبٖ مِّنَ ٱلۡبَعۡثِ فَإِنَّا خَلَقۡنَٰكُم مِّن تُرَابٖ ثُمَّ مِن نُّطۡفَةٖ ثُمَّ مِنۡ عَلَقَةٖ ثُمَّ مِن مُّضۡغَةٖ مُّخَلَّقَةٖ وَغَيۡرِ مُخَلَّقَةٖ لِّنُبَيِّنَ لَكُمۡۚ وَنُقِرُّ فِي ٱلۡأَرۡحَامِ مَا نَشَآءُ إِلَىٰٓ أَجَلٖ مُّسَمّٗى ثُمَّ نُخۡرِجُكُمۡ طِفۡلٗا ثُمَّ لِتَبۡلُغُوٓاْ أَشُدَّكُمۡۖ وَمِنكُم مَّن يُتَوَفَّىٰ وَمِنكُم مَّن يُرَدُّ إِلَىٰٓ أَرۡذَلِ ٱلۡعُمُرِ لِكَيۡلَا يَعۡلَمَ مِنۢ بَعۡدِ عِلۡمٖ شَيۡـٔٗاۚ وَتَرَى ٱلۡأَرۡضَ هَامِدَةٗ فَإِذَآ أَنزَلۡنَا عَلَيۡهَا ٱلۡمَآءَ ٱهۡتَزَّتۡ وَرَبَتۡ وَأَنۢبَتَتۡ مِن كُلِّ زَوۡجِۭ بَهِيجٖ",
    translation:
      "O People, if you should be in doubt about the Resurrection, then [consider that] indeed, We created you from dust, then from a sperm-drop, then from a clinging clot, and then from a lump of flesh, formed and unformed - that We may show you. And We settle in the wombs whom We will for a specified term, then We bring you out as a child, and then [We develop you] that you may reach your [time of] maturity. And among you is he who is taken in [early] death, and among you is he who is returned to the most decrepit [old] age so that he knows, after [once having] knowledge, nothing. And you see the earth barren, but when We send down upon it rain, it quivers and swells and grows [something] of every beautiful kind",
    normalizedText:
      "يايها الناس ان كنتم في ريب من البعث فانا خلقنكم من تراب ثم من نطفة ثم من علقة ثم من مضغة مخلقة وغير مخلقة لنبين لكم ونقر في الارحام ما نشاء الى اجل مسمى ثم نخرجكم طفلا ثم لتبلغوا اشدكم ومنكم من يتوفى ومنكم من يرد الى ارذل العمر لكيلا يعلم من بعد علم شيا وترى الارض هامدة فاذا انزلنا عليها الماء اهتزت وربت وانبتت من كل زوج بهيج",
  },
  {
    verseId: 5,
    name: "الحج",
    surahId: 22,
    text: "ذَٰلِكَ بِأَنَّ ٱللَّهَ هُوَ ٱلۡحَقُّ وَأَنَّهُۥ يُحۡيِ ٱلۡمَوۡتَىٰ وَأَنَّهُۥ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "That is because Allah is the Truth and because He gives life to the dead and because He is over all things competent",
    normalizedText: "ذلك بان الله هو الحق وانه يحي الموتى وانه على كل شيء قدير",
  },
  {
    verseId: 6,
    name: "الحج",
    surahId: 22,
    text: "وَأَنَّ ٱلسَّاعَةَ ءَاتِيَةٞ لَّا رَيۡبَ فِيهَا وَأَنَّ ٱللَّهَ يَبۡعَثُ مَن فِي ٱلۡقُبُورِ",
    translation:
      "And [that they may know] that the Hour is coming - no doubt about it - and that Allah will resurrect those in the graves",
    normalizedText: "وان الساعة ءاتية لا ريب فيها وان الله يبعث من في القبور",
  },
  {
    verseId: 7,
    name: "الحج",
    surahId: 22,
    text: "وَمِنَ ٱلنَّاسِ مَن يُجَٰدِلُ فِي ٱللَّهِ بِغَيۡرِ عِلۡمٖ وَلَا هُدٗى وَلَا كِتَٰبٖ مُّنِيرٖ",
    translation:
      "And of the people is he who disputes about Allah without knowledge or guidance or an enlightening book [from Him]",
    normalizedText: "ومن الناس من يجدل في الله بغير علم ولا هدى ولا كتب منير",
  },
  {
    verseId: 8,
    name: "الحج",
    surahId: 22,
    text: "ثَانِيَ عِطۡفِهِۦ لِيُضِلَّ عَن سَبِيلِ ٱللَّهِۖ لَهُۥ فِي ٱلدُّنۡيَا خِزۡيٞۖ وَنُذِيقُهُۥ يَوۡمَ ٱلۡقِيَٰمَةِ عَذَابَ ٱلۡحَرِيقِ",
    translation:
      "Twisting his neck [in arrogance] to mislead [people] from the way of Allah. For him in the world is disgrace, and We will make him taste on the Day of Resurrection the punishment of the Burning Fire [while it is said]",
    normalizedText:
      "ثاني عطفه ليضل عن سبيل الله له في الدنيا خزي ونذيقه يوم القيمة عذاب الحريق",
  },
  {
    verseId: 9,
    name: "الحج",
    surahId: 22,
    text: "ذَٰلِكَ بِمَا قَدَّمَتۡ يَدَاكَ وَأَنَّ ٱللَّهَ لَيۡسَ بِظَلَّـٰمٖ لِّلۡعَبِيدِ",
    translation:
      "That is for what your hands have put forth and because Allah is not ever unjust to [His] servants",
    normalizedText: "ذلك بما قدمت يداك وان الله ليس بظلم للعبيد",
  },
  {
    verseId: 10,
    name: "الحج",
    surahId: 22,
    text: "وَمِنَ ٱلنَّاسِ مَن يَعۡبُدُ ٱللَّهَ عَلَىٰ حَرۡفٖۖ فَإِنۡ أَصَابَهُۥ خَيۡرٌ ٱطۡمَأَنَّ بِهِۦۖ وَإِنۡ أَصَابَتۡهُ فِتۡنَةٌ ٱنقَلَبَ عَلَىٰ وَجۡهِهِۦ خَسِرَ ٱلدُّنۡيَا وَٱلۡأٓخِرَةَۚ ذَٰلِكَ هُوَ ٱلۡخُسۡرَانُ ٱلۡمُبِينُ",
    translation:
      "And of the people is he who worships Allah on an edge. If he is touched by good, he is reassured by it; but if he is struck by trial, he turns on his face [to the other direction]. He has lost [this] world and the Hereafter. That is what is the manifest loss",
    normalizedText:
      "ومن الناس من يعبد الله على حرف فان اصابه خير اطمان به وان اصابته فتنة انقلب على وجهه خسر الدنيا والاخرة ذلك هو الخسران المبين",
  },
  {
    verseId: 11,
    name: "الحج",
    surahId: 22,
    text: "يَدۡعُواْ مِن دُونِ ٱللَّهِ مَا لَا يَضُرُّهُۥ وَمَا لَا يَنفَعُهُۥۚ ذَٰلِكَ هُوَ ٱلضَّلَٰلُ ٱلۡبَعِيدُ",
    translation:
      "He invokes instead of Allah that which neither harms him nor benefits him. That is what is the extreme error",
    normalizedText:
      "يدعوا من دون الله ما لا يضره وما لا ينفعه ذلك هو الضلل البعيد",
  },
  {
    verseId: 12,
    name: "الحج",
    surahId: 22,
    text: "يَدۡعُواْ لَمَن ضَرُّهُۥٓ أَقۡرَبُ مِن نَّفۡعِهِۦۚ لَبِئۡسَ ٱلۡمَوۡلَىٰ وَلَبِئۡسَ ٱلۡعَشِيرُ",
    translation:
      "He invokes one whose harm is closer than his benefit - how wretched the protector and how wretched the associate",
    normalizedText: "يدعوا لمن ضره اقرب من نفعه لباس المولى ولباس العشير",
  },
  {
    verseId: 13,
    name: "الحج",
    surahId: 22,
    text: "إِنَّ ٱللَّهَ يُدۡخِلُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۚ إِنَّ ٱللَّهَ يَفۡعَلُ مَا يُرِيدُ",
    translation:
      "Indeed, Allah will admit those who believe and do righteous deeds to gardens beneath which rivers flow. Indeed, Allah does what He intends",
    normalizedText:
      "ان الله يدخل الذين ءامنوا وعملوا الصلحت جنت تجري من تحتها الانهر ان الله يفعل ما يريد",
  },
  {
    verseId: 14,
    name: "الحج",
    surahId: 22,
    text: "مَن كَانَ يَظُنُّ أَن لَّن يَنصُرَهُ ٱللَّهُ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِ فَلۡيَمۡدُدۡ بِسَبَبٍ إِلَى ٱلسَّمَآءِ ثُمَّ لۡيَقۡطَعۡ فَلۡيَنظُرۡ هَلۡ يُذۡهِبَنَّ كَيۡدُهُۥ مَا يَغِيظُ",
    translation:
      "Whoever should think that Allah will not support [Prophet Muhammad] in this world and the Hereafter - let him extend a rope to the ceiling, then cut off [his breath], and let him see: will his effort remove that which enrages [him]",
    normalizedText:
      "من كان يظن ان لن ينصره الله في الدنيا والاخرة فليمدد بسبب الى السماء ثم ليقطع فلينظر هل يذهبن كيده ما يغيظ",
  },
  {
    verseId: 15,
    name: "الحج",
    surahId: 22,
    text: "وَكَذَٰلِكَ أَنزَلۡنَٰهُ ءَايَٰتِۭ بَيِّنَٰتٖ وَأَنَّ ٱللَّهَ يَهۡدِي مَن يُرِيدُ",
    translation:
      "And thus have We sent the Qur'an down as verses of clear evidence and because Allah guides whom He intends",
    normalizedText: "وكذلك انزلنه ءايت بينت وان الله يهدي من يريد",
  },
  {
    verseId: 16,
    name: "الحج",
    surahId: 22,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَٱلَّذِينَ هَادُواْ وَٱلصَّـٰبِـِٔينَ وَٱلنَّصَٰرَىٰ وَٱلۡمَجُوسَ وَٱلَّذِينَ أَشۡرَكُوٓاْ إِنَّ ٱللَّهَ يَفۡصِلُ بَيۡنَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدٌ",
    translation:
      "Indeed, those who have believed and those who were Jews and the Sabeans and the Christians and the Magians and those who associated with Allah - Allah will judge between them on the Day of Resurrection. Indeed Allah is, over all things, Witness",
    normalizedText:
      "ان الذين ءامنوا والذين هادوا والصبين والنصرى والمجوس والذين اشركوا ان الله يفصل بينهم يوم القيمة ان الله على كل شيء شهيد",
  },
  {
    verseId: 17,
    name: "الحج",
    surahId: 22,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ يَسۡجُدُۤ لَهُۥۤ مَن فِي ٱلسَّمَٰوَٰتِ وَمَن فِي ٱلۡأَرۡضِ وَٱلشَّمۡسُ وَٱلۡقَمَرُ وَٱلنُّجُومُ وَٱلۡجِبَالُ وَٱلشَّجَرُ وَٱلدَّوَآبُّ وَكَثِيرٞ مِّنَ ٱلنَّاسِۖ وَكَثِيرٌ حَقَّ عَلَيۡهِ ٱلۡعَذَابُۗ وَمَن يُهِنِ ٱللَّهُ فَمَا لَهُۥ مِن مُّكۡرِمٍۚ إِنَّ ٱللَّهَ يَفۡعَلُ مَا يَشَآءُ۩",
    translation:
      "Do you not see that to Allah prostrates whoever is in the heavens and whoever is on the earth and the sun, the moon, the stars, the mountains, the trees, the moving creatures and many of the people? But upon many the punishment has been justified. And he whom Allah humiliates - for him there is no bestower of honor. Indeed, Allah does what He wills",
    normalizedText:
      "الم تر ان الله يسجد له من في السموت ومن في الارض والشمس والقمر والنجوم والجبال والشجر والدواب وكثير من الناس وكثير حق عليه العذاب ومن يهن الله فما له من مكرم ان الله يفعل ما يشاء۩",
  },
  {
    verseId: 18,
    name: "الحج",
    surahId: 22,
    text: "۞هَٰذَانِ خَصۡمَانِ ٱخۡتَصَمُواْ فِي رَبِّهِمۡۖ فَٱلَّذِينَ كَفَرُواْ قُطِّعَتۡ لَهُمۡ ثِيَابٞ مِّن نَّارٖ يُصَبُّ مِن فَوۡقِ رُءُوسِهِمُ ٱلۡحَمِيمُ",
    translation:
      "These are two adversaries who have disputed over their Lord. But those who disbelieved will have cut out for them garments of fire. Poured upon their heads will be scalding water",
    normalizedText:
      "۞هذان خصمان اختصموا في ربهم فالذين كفروا قطعت لهم ثياب من نار يصب من فوق رءوسهم الحميم",
  },
  {
    verseId: 19,
    name: "الحج",
    surahId: 22,
    text: "يُصۡهَرُ بِهِۦ مَا فِي بُطُونِهِمۡ وَٱلۡجُلُودُ",
    translation:
      "By which is melted that within their bellies and [their] skins",
    normalizedText: "يصهر به ما في بطونهم والجلود",
  },
  {
    verseId: 20,
    name: "الحج",
    surahId: 22,
    text: "وَلَهُم مَّقَٰمِعُ مِنۡ حَدِيدٖ",
    translation: "And for [striking] them are maces of iron",
    normalizedText: "ولهم مقمع من حديد",
  },
  {
    verseId: 21,
    name: "الحج",
    surahId: 22,
    text: "كُلَّمَآ أَرَادُوٓاْ أَن يَخۡرُجُواْ مِنۡهَا مِنۡ غَمٍّ أُعِيدُواْ فِيهَا وَذُوقُواْ عَذَابَ ٱلۡحَرِيقِ",
    translation:
      'Every time they want to get out of Hellfire from anguish, they will be returned to it, and [it will be said], "Taste the punishment of the Burning Fire',
    normalizedText:
      "كلما ارادوا ان يخرجوا منها من غم اعيدوا فيها وذوقوا عذاب الحريق",
  },
  {
    verseId: 22,
    name: "الحج",
    surahId: 22,
    text: "إِنَّ ٱللَّهَ يُدۡخِلُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ يُحَلَّوۡنَ فِيهَا مِنۡ أَسَاوِرَ مِن ذَهَبٖ وَلُؤۡلُؤٗاۖ وَلِبَاسُهُمۡ فِيهَا حَرِيرٞ",
    translation:
      "Indeed, Allah will admit those who believe and do righteous deeds to gardens beneath which rivers flow. They will be adorned therein with bracelets of gold and pearl, and their garments therein will be silk",
    normalizedText:
      "ان الله يدخل الذين ءامنوا وعملوا الصلحت جنت تجري من تحتها الانهر يحلون فيها من اساور من ذهب ولالاا ولباسهم فيها حرير",
  },
  {
    verseId: 23,
    name: "الحج",
    surahId: 22,
    text: "وَهُدُوٓاْ إِلَى ٱلطَّيِّبِ مِنَ ٱلۡقَوۡلِ وَهُدُوٓاْ إِلَىٰ صِرَٰطِ ٱلۡحَمِيدِ",
    translation:
      "And they had been guided [in worldly life] to good speech, and they were guided to the path of the Praiseworthy",
    normalizedText: "وهدوا الى الطيب من القول وهدوا الى صرط الحميد",
  },
  {
    verseId: 24,
    name: "الحج",
    surahId: 22,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَٱلۡمَسۡجِدِ ٱلۡحَرَامِ ٱلَّذِي جَعَلۡنَٰهُ لِلنَّاسِ سَوَآءً ٱلۡعَٰكِفُ فِيهِ وَٱلۡبَادِۚ وَمَن يُرِدۡ فِيهِ بِإِلۡحَادِۭ بِظُلۡمٖ نُّذِقۡهُ مِنۡ عَذَابٍ أَلِيمٖ",
    translation:
      "Indeed, those who have disbelieved and avert [people] from the way of Allah and [from] al-Masjid al-Haram, which We made for the people - equal are the resident therein and one from outside; and [also] whoever intends [a deed] therein of deviation [in religion] or wrongdoing - We will make him taste of a painful punishment",
    normalizedText:
      "ان الذين كفروا ويصدون عن سبيل الله والمسجد الحرام الذي جعلنه للناس سواء العكف فيه والباد ومن يرد فيه بالحاد بظلم نذقه من عذاب اليم",
  },
  {
    verseId: 25,
    name: "الحج",
    surahId: 22,
    text: "وَإِذۡ بَوَّأۡنَا لِإِبۡرَٰهِيمَ مَكَانَ ٱلۡبَيۡتِ أَن لَّا تُشۡرِكۡ بِي شَيۡـٔٗا وَطَهِّرۡ بَيۡتِيَ لِلطَّآئِفِينَ وَٱلۡقَآئِمِينَ وَٱلرُّكَّعِ ٱلسُّجُودِ",
    translation:
      'And [mention, O Muhammad], when We designated for Abraham the site of the House, [saying], "Do not associate anything with Me and purify My House for those who perform Tawaf and those who stand [in prayer] and those who bow and prostrate',
    normalizedText:
      "واذ بوانا لابرهيم مكان البيت ان لا تشرك بي شيا وطهر بيتي للطاافين والقاامين والركع السجود",
  },
  {
    verseId: 26,
    name: "الحج",
    surahId: 22,
    text: "وَأَذِّن فِي ٱلنَّاسِ بِٱلۡحَجِّ يَأۡتُوكَ رِجَالٗا وَعَلَىٰ كُلِّ ضَامِرٖ يَأۡتِينَ مِن كُلِّ فَجٍّ عَمِيقٖ",
    translation:
      "And proclaim to the people the Hajj [pilgrimage]; they will come to you on foot and on every lean camel; they will come from every distant pass",
    normalizedText:
      "واذن في الناس بالحج ياتوك رجالا وعلى كل ضامر ياتين من كل فج عميق",
  },
  {
    verseId: 27,
    name: "الحج",
    surahId: 22,
    text: "لِّيَشۡهَدُواْ مَنَٰفِعَ لَهُمۡ وَيَذۡكُرُواْ ٱسۡمَ ٱللَّهِ فِيٓ أَيَّامٖ مَّعۡلُومَٰتٍ عَلَىٰ مَا رَزَقَهُم مِّنۢ بَهِيمَةِ ٱلۡأَنۡعَٰمِۖ فَكُلُواْ مِنۡهَا وَأَطۡعِمُواْ ٱلۡبَآئِسَ ٱلۡفَقِيرَ",
    translation:
      "That they may witness benefits for themselves and mention the name of Allah on known days over what He has provided for them of [sacrificial] animals. So eat of them and feed the miserable and poor",
    normalizedText:
      "ليشهدوا منفع لهم ويذكروا اسم الله في ايام معلومت على ما رزقهم من بهيمة الانعم فكلوا منها واطعموا البااس الفقير",
  },
  {
    verseId: 28,
    name: "الحج",
    surahId: 22,
    text: "ثُمَّ لۡيَقۡضُواْ تَفَثَهُمۡ وَلۡيُوفُواْ نُذُورَهُمۡ وَلۡيَطَّوَّفُواْ بِٱلۡبَيۡتِ ٱلۡعَتِيقِ",
    translation:
      "Then let them end their untidiness and fulfill their vows and perform Tawaf around the ancient House",
    normalizedText: "ثم ليقضوا تفثهم وليوفوا نذورهم وليطوفوا بالبيت العتيق",
  },
  {
    verseId: 29,
    name: "الحج",
    surahId: 22,
    text: "ذَٰلِكَۖ وَمَن يُعَظِّمۡ حُرُمَٰتِ ٱللَّهِ فَهُوَ خَيۡرٞ لَّهُۥ عِندَ رَبِّهِۦۗ وَأُحِلَّتۡ لَكُمُ ٱلۡأَنۡعَٰمُ إِلَّا مَا يُتۡلَىٰ عَلَيۡكُمۡۖ فَٱجۡتَنِبُواْ ٱلرِّجۡسَ مِنَ ٱلۡأَوۡثَٰنِ وَٱجۡتَنِبُواْ قَوۡلَ ٱلزُّورِ",
    translation:
      "That [has been commanded], and whoever honors the sacred ordinances of Allah - it is best for him in the sight of his Lord. And permitted to you are the grazing livestock, except what is recited to you. So avoid the uncleanliness of idols and avoid false statement",
    normalizedText:
      "ذلك ومن يعظم حرمت الله فهو خير له عند ربه واحلت لكم الانعم الا ما يتلى عليكم فاجتنبوا الرجس من الاوثن واجتنبوا قول الزور",
  },
  {
    verseId: 30,
    name: "الحج",
    surahId: 22,
    text: "حُنَفَآءَ لِلَّهِ غَيۡرَ مُشۡرِكِينَ بِهِۦۚ وَمَن يُشۡرِكۡ بِٱللَّهِ فَكَأَنَّمَا خَرَّ مِنَ ٱلسَّمَآءِ فَتَخۡطَفُهُ ٱلطَّيۡرُ أَوۡ تَهۡوِي بِهِ ٱلرِّيحُ فِي مَكَانٖ سَحِيقٖ",
    translation:
      "Inclining [only] to Allah, not associating [anything] with Him. And he who associates with Allah - it is as though he had fallen from the sky and was snatched by the birds or the wind carried him down into a remote place",
    normalizedText:
      "حنفاء لله غير مشركين به ومن يشرك بالله فكانما خر من السماء فتخطفه الطير او تهوي به الريح في مكان سحيق",
  },
  {
    verseId: 31,
    name: "الحج",
    surahId: 22,
    text: "ذَٰلِكَۖ وَمَن يُعَظِّمۡ شَعَـٰٓئِرَ ٱللَّهِ فَإِنَّهَا مِن تَقۡوَى ٱلۡقُلُوبِ",
    translation:
      "That [is so]. And whoever honors the symbols of Allah - indeed, it is from the piety of hearts",
    normalizedText: "ذلك ومن يعظم شعار الله فانها من تقوى القلوب",
  },
  {
    verseId: 32,
    name: "الحج",
    surahId: 22,
    text: "لَكُمۡ فِيهَا مَنَٰفِعُ إِلَىٰٓ أَجَلٖ مُّسَمّٗى ثُمَّ مَحِلُّهَآ إِلَى ٱلۡبَيۡتِ ٱلۡعَتِيقِ",
    translation:
      "For you the animals marked for sacrifice are benefits for a specified term; then their place of sacrifice is at the ancient House",
    normalizedText: "لكم فيها منفع الى اجل مسمى ثم محلها الى البيت العتيق",
  },
  {
    verseId: 33,
    name: "الحج",
    surahId: 22,
    text: "وَلِكُلِّ أُمَّةٖ جَعَلۡنَا مَنسَكٗا لِّيَذۡكُرُواْ ٱسۡمَ ٱللَّهِ عَلَىٰ مَا رَزَقَهُم مِّنۢ بَهِيمَةِ ٱلۡأَنۡعَٰمِۗ فَإِلَٰهُكُمۡ إِلَٰهٞ وَٰحِدٞ فَلَهُۥٓ أَسۡلِمُواْۗ وَبَشِّرِ ٱلۡمُخۡبِتِينَ",
    translation:
      "And for all religion We have appointed a rite [of sacrifice] that they may mention the name of Allah over what He has provided for them of [sacrificial] animals. For your god is one God, so to Him submit. And, [O Muhammad], give good tidings to the humble [before their Lord]",
    normalizedText:
      "ولكل امة جعلنا منسكا ليذكروا اسم الله على ما رزقهم من بهيمة الانعم فالهكم اله وحد فله اسلموا وبشر المخبتين",
  },
  {
    verseId: 34,
    name: "الحج",
    surahId: 22,
    text: "ٱلَّذِينَ إِذَا ذُكِرَ ٱللَّهُ وَجِلَتۡ قُلُوبُهُمۡ وَٱلصَّـٰبِرِينَ عَلَىٰ مَآ أَصَابَهُمۡ وَٱلۡمُقِيمِي ٱلصَّلَوٰةِ وَمِمَّا رَزَقۡنَٰهُمۡ يُنفِقُونَ",
    translation:
      "Who, when Allah is mentioned, their hearts are fearful, and [to] the patient over what has afflicted them, and the establishers of prayer and those who spend from what We have provided them",
    normalizedText:
      "الذين اذا ذكر الله وجلت قلوبهم والصبرين على ما اصابهم والمقيمي الصلوة ومما رزقنهم ينفقون",
  },
  {
    verseId: 35,
    name: "الحج",
    surahId: 22,
    text: "وَٱلۡبُدۡنَ جَعَلۡنَٰهَا لَكُم مِّن شَعَـٰٓئِرِ ٱللَّهِ لَكُمۡ فِيهَا خَيۡرٞۖ فَٱذۡكُرُواْ ٱسۡمَ ٱللَّهِ عَلَيۡهَا صَوَآفَّۖ فَإِذَا وَجَبَتۡ جُنُوبُهَا فَكُلُواْ مِنۡهَا وَأَطۡعِمُواْ ٱلۡقَانِعَ وَٱلۡمُعۡتَرَّۚ كَذَٰلِكَ سَخَّرۡنَٰهَا لَكُمۡ لَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And the camels and cattle We have appointed for you as among the symbols of Allah; for you therein is good. So mention the name of Allah upon them when lined up [for sacrifice]; and when they are [lifeless] on their sides, then eat from them and feed the needy and the beggar. Thus have We subjected them to you that you may be grateful",
    normalizedText:
      "والبدن جعلنها لكم من شعار الله لكم فيها خير فاذكروا اسم الله عليها صواف فاذا وجبت جنوبها فكلوا منها واطعموا القانع والمعتر كذلك سخرنها لكم لعلكم تشكرون",
  },
  {
    verseId: 36,
    name: "الحج",
    surahId: 22,
    text: "لَن يَنَالَ ٱللَّهَ لُحُومُهَا وَلَا دِمَآؤُهَا وَلَٰكِن يَنَالُهُ ٱلتَّقۡوَىٰ مِنكُمۡۚ كَذَٰلِكَ سَخَّرَهَا لَكُمۡ لِتُكَبِّرُواْ ٱللَّهَ عَلَىٰ مَا هَدَىٰكُمۡۗ وَبَشِّرِ ٱلۡمُحۡسِنِينَ",
    translation:
      "Their meat will not reach Allah, nor will their blood, but what reaches Him is piety from you. Thus have We subjected them to you that you may glorify Allah for that [to] which He has guided you; and give good tidings to the doers of good",
    normalizedText:
      "لن ينال الله لحومها ولا دمااها ولكن يناله التقوى منكم كذلك سخرها لكم لتكبروا الله على ما هدىكم وبشر المحسنين",
  },
  {
    verseId: 37,
    name: "الحج",
    surahId: 22,
    text: "۞إِنَّ ٱللَّهَ يُدَٰفِعُ عَنِ ٱلَّذِينَ ءَامَنُوٓاْۗ إِنَّ ٱللَّهَ لَا يُحِبُّ كُلَّ خَوَّانٖ كَفُورٍ",
    translation:
      "Indeed, Allah defends those who have believed. Indeed, Allah does not like everyone treacherous and ungrateful",
    normalizedText: "۞ان الله يدفع عن الذين ءامنوا ان الله لا يحب كل خوان كفور",
  },
  {
    verseId: 38,
    name: "الحج",
    surahId: 22,
    text: "أُذِنَ لِلَّذِينَ يُقَٰتَلُونَ بِأَنَّهُمۡ ظُلِمُواْۚ وَإِنَّ ٱللَّهَ عَلَىٰ نَصۡرِهِمۡ لَقَدِيرٌ",
    translation:
      "Permission [to fight] has been given to those who are being fought, because they were wronged. And indeed, Allah is competent to give them victory",
    normalizedText: "اذن للذين يقتلون بانهم ظلموا وان الله على نصرهم لقدير",
  },
  {
    verseId: 39,
    name: "الحج",
    surahId: 22,
    text: "ٱلَّذِينَ أُخۡرِجُواْ مِن دِيَٰرِهِم بِغَيۡرِ حَقٍّ إِلَّآ أَن يَقُولُواْ رَبُّنَا ٱللَّهُۗ وَلَوۡلَا دَفۡعُ ٱللَّهِ ٱلنَّاسَ بَعۡضَهُم بِبَعۡضٖ لَّهُدِّمَتۡ صَوَٰمِعُ وَبِيَعٞ وَصَلَوَٰتٞ وَمَسَٰجِدُ يُذۡكَرُ فِيهَا ٱسۡمُ ٱللَّهِ كَثِيرٗاۗ وَلَيَنصُرَنَّ ٱللَّهُ مَن يَنصُرُهُۥٓۚ إِنَّ ٱللَّهَ لَقَوِيٌّ عَزِيزٌ",
    translation:
      '[They are] those who have been evicted from their homes without right - only because they say, "Our Lord is Allah." And were it not that Allah checks the people, some by means of others, there would have been demolished monasteries, churches, synagogues, and mosques in which the name of Allah is much mentioned. And Allah will surely support those who support Him. Indeed, Allah is Powerful and Exalted in Might',
    normalizedText:
      "الذين اخرجوا من ديرهم بغير حق الا ان يقولوا ربنا الله ولولا دفع الله الناس بعضهم ببعض لهدمت صومع وبيع وصلوت ومسجد يذكر فيها اسم الله كثيرا ولينصرن الله من ينصره ان الله لقوي عزيز",
  },
  {
    verseId: 40,
    name: "الحج",
    surahId: 22,
    text: "ٱلَّذِينَ إِن مَّكَّنَّـٰهُمۡ فِي ٱلۡأَرۡضِ أَقَامُواْ ٱلصَّلَوٰةَ وَءَاتَوُاْ ٱلزَّكَوٰةَ وَأَمَرُواْ بِٱلۡمَعۡرُوفِ وَنَهَوۡاْ عَنِ ٱلۡمُنكَرِۗ وَلِلَّهِ عَٰقِبَةُ ٱلۡأُمُورِ",
    translation:
      "[And they are] those who, if We give them authority in the land, establish prayer and give zakah and enjoin what is right and forbid what is wrong. And to Allah belongs the outcome of [all] matters",
    normalizedText:
      "الذين ان مكنهم في الارض اقاموا الصلوة وءاتوا الزكوة وامروا بالمعروف ونهوا عن المنكر ولله عقبة الامور",
  },
  {
    verseId: 41,
    name: "الحج",
    surahId: 22,
    text: "وَإِن يُكَذِّبُوكَ فَقَدۡ كَذَّبَتۡ قَبۡلَهُمۡ قَوۡمُ نُوحٖ وَعَادٞ وَثَمُودُ",
    translation:
      "And if they deny you, [O Muhammad] - so, before them, did the people of Noah and 'Aad and Thamud deny [their prophets]",
    normalizedText: "وان يكذبوك فقد كذبت قبلهم قوم نوح وعاد وثمود",
  },
  {
    verseId: 42,
    name: "الحج",
    surahId: 22,
    text: "وَقَوۡمُ إِبۡرَٰهِيمَ وَقَوۡمُ لُوطٖ",
    translation: "And the people of Abraham and the people of Lot",
    normalizedText: "وقوم ابرهيم وقوم لوط",
  },
  {
    verseId: 43,
    name: "الحج",
    surahId: 22,
    text: "وَأَصۡحَٰبُ مَدۡيَنَۖ وَكُذِّبَ مُوسَىٰۖ فَأَمۡلَيۡتُ لِلۡكَٰفِرِينَ ثُمَّ أَخَذۡتُهُمۡۖ فَكَيۡفَ كَانَ نَكِيرِ",
    translation:
      "And the inhabitants of Madyan. And Moses was denied, so I prolonged enjoyment for the disbelievers; then I seized them, and how [terrible] was My reproach",
    normalizedText:
      "واصحب مدين وكذب موسى فامليت للكفرين ثم اخذتهم فكيف كان نكير",
  },
  {
    verseId: 44,
    name: "الحج",
    surahId: 22,
    text: "فَكَأَيِّن مِّن قَرۡيَةٍ أَهۡلَكۡنَٰهَا وَهِيَ ظَالِمَةٞ فَهِيَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا وَبِئۡرٖ مُّعَطَّلَةٖ وَقَصۡرٖ مَّشِيدٍ",
    translation:
      "And how many a city did We destroy while it was committing wrong - so it is [now] fallen into ruin - and [how many] an abandoned well and [how many] a lofty palace",
    normalizedText:
      "فكاين من قرية اهلكنها وهي ظالمة فهي خاوية على عروشها وبار معطلة وقصر مشيد",
  },
  {
    verseId: 45,
    name: "الحج",
    surahId: 22,
    text: "أَفَلَمۡ يَسِيرُواْ فِي ٱلۡأَرۡضِ فَتَكُونَ لَهُمۡ قُلُوبٞ يَعۡقِلُونَ بِهَآ أَوۡ ءَاذَانٞ يَسۡمَعُونَ بِهَاۖ فَإِنَّهَا لَا تَعۡمَى ٱلۡأَبۡصَٰرُ وَلَٰكِن تَعۡمَى ٱلۡقُلُوبُ ٱلَّتِي فِي ٱلصُّدُورِ",
    translation:
      "So have they not traveled through the earth and have hearts by which to reason and ears by which to hear? For indeed, it is not eyes that are blinded, but blinded are the hearts which are within the breasts",
    normalizedText:
      "افلم يسيروا في الارض فتكون لهم قلوب يعقلون بها او ءاذان يسمعون بها فانها لا تعمى الابصر ولكن تعمى القلوب التي في الصدور",
  },
  {
    verseId: 46,
    name: "الحج",
    surahId: 22,
    text: "وَيَسۡتَعۡجِلُونَكَ بِٱلۡعَذَابِ وَلَن يُخۡلِفَ ٱللَّهُ وَعۡدَهُۥۚ وَإِنَّ يَوۡمًا عِندَ رَبِّكَ كَأَلۡفِ سَنَةٖ مِّمَّا تَعُدُّونَ",
    translation:
      "And they urge you to hasten the punishment. But Allah will never fail in His promise. And indeed, a day with your Lord is like a thousand years of those which you count",
    normalizedText:
      "ويستعجلونك بالعذاب ولن يخلف الله وعده وان يوما عند ربك كالف سنة مما تعدون",
  },
  {
    verseId: 47,
    name: "الحج",
    surahId: 22,
    text: "وَكَأَيِّن مِّن قَرۡيَةٍ أَمۡلَيۡتُ لَهَا وَهِيَ ظَالِمَةٞ ثُمَّ أَخَذۡتُهَا وَإِلَيَّ ٱلۡمَصِيرُ",
    translation:
      "And for how many a city did I prolong enjoyment while it was committing wrong. Then I seized it, and to Me is the [final] destination",
    normalizedText: "وكاين من قرية امليت لها وهي ظالمة ثم اخذتها والي المصير",
  },
  {
    verseId: 48,
    name: "الحج",
    surahId: 22,
    text: "قُلۡ يَـٰٓأَيُّهَا ٱلنَّاسُ إِنَّمَآ أَنَا۠ لَكُمۡ نَذِيرٞ مُّبِينٞ",
    translation: 'Say, "O people, I am only to you a clear warner',
    normalizedText: "قل يايها الناس انما انا لكم نذير مبين",
  },
  {
    verseId: 49,
    name: "الحج",
    surahId: 22,
    text: "فَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَهُم مَّغۡفِرَةٞ وَرِزۡقٞ كَرِيمٞ",
    translation:
      "And those who have believed and done righteous deeds - for them is forgiveness and noble provision",
    normalizedText: "فالذين ءامنوا وعملوا الصلحت لهم مغفرة ورزق كريم",
  },
  {
    verseId: 50,
    name: "الحج",
    surahId: 22,
    text: "وَٱلَّذِينَ سَعَوۡاْ فِيٓ ءَايَٰتِنَا مُعَٰجِزِينَ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَحِيمِ",
    translation:
      "But the ones who strove against Our verses, [seeking] to cause failure - those are the companions of Hellfire",
    normalizedText: "والذين سعوا في ءايتنا معجزين اولاك اصحب الجحيم",
  },
  {
    verseId: 51,
    name: "الحج",
    surahId: 22,
    text: "وَمَآ أَرۡسَلۡنَا مِن قَبۡلِكَ مِن رَّسُولٖ وَلَا نَبِيٍّ إِلَّآ إِذَا تَمَنَّىٰٓ أَلۡقَى ٱلشَّيۡطَٰنُ فِيٓ أُمۡنِيَّتِهِۦ فَيَنسَخُ ٱللَّهُ مَا يُلۡقِي ٱلشَّيۡطَٰنُ ثُمَّ يُحۡكِمُ ٱللَّهُ ءَايَٰتِهِۦۗ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "And We did not send before you any messenger or prophet except that when he spoke [or recited], Satan threw into it [some misunderstanding]. But Allah abolishes that which Satan throws in; then Allah makes precise His verses. And Allah is Knowing and Wise",
    normalizedText:
      "وما ارسلنا من قبلك من رسول ولا نبي الا اذا تمنى القى الشيطن في امنيته فينسخ الله ما يلقي الشيطن ثم يحكم الله ءايته والله عليم حكيم",
  },
  {
    verseId: 52,
    name: "الحج",
    surahId: 22,
    text: "لِّيَجۡعَلَ مَا يُلۡقِي ٱلشَّيۡطَٰنُ فِتۡنَةٗ لِّلَّذِينَ فِي قُلُوبِهِم مَّرَضٞ وَٱلۡقَاسِيَةِ قُلُوبُهُمۡۗ وَإِنَّ ٱلظَّـٰلِمِينَ لَفِي شِقَاقِۭ بَعِيدٖ",
    translation:
      "[That is] so He may make what Satan throws in a trial for those within whose hearts is disease and those hard of heart. And indeed, the wrongdoers are in extreme dissension",
    normalizedText:
      "ليجعل ما يلقي الشيطن فتنة للذين في قلوبهم مرض والقاسية قلوبهم وان الظلمين لفي شقاق بعيد",
  },
  {
    verseId: 53,
    name: "الحج",
    surahId: 22,
    text: "وَلِيَعۡلَمَ ٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ أَنَّهُ ٱلۡحَقُّ مِن رَّبِّكَ فَيُؤۡمِنُواْ بِهِۦ فَتُخۡبِتَ لَهُۥ قُلُوبُهُمۡۗ وَإِنَّ ٱللَّهَ لَهَادِ ٱلَّذِينَ ءَامَنُوٓاْ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "And so those who were given knowledge may know that it is the truth from your Lord and [therefore] believe in it, and their hearts humbly submit to it. And indeed is Allah the Guide of those who have believed to a straight path",
    normalizedText:
      "وليعلم الذين اوتوا العلم انه الحق من ربك فيامنوا به فتخبت له قلوبهم وان الله لهاد الذين ءامنوا الى صرط مستقيم",
  },
  {
    verseId: 54,
    name: "الحج",
    surahId: 22,
    text: "وَلَا يَزَالُ ٱلَّذِينَ كَفَرُواْ فِي مِرۡيَةٖ مِّنۡهُ حَتَّىٰ تَأۡتِيَهُمُ ٱلسَّاعَةُ بَغۡتَةً أَوۡ يَأۡتِيَهُمۡ عَذَابُ يَوۡمٍ عَقِيمٍ",
    translation:
      "But those who disbelieve will not cease to be in doubt of it until the Hour comes upon them unexpectedly or there comes to them the punishment of a barren Day",
    normalizedText:
      "ولا يزال الذين كفروا في مرية منه حتى تاتيهم الساعة بغتة او ياتيهم عذاب يوم عقيم",
  },
  {
    verseId: 55,
    name: "الحج",
    surahId: 22,
    text: "ٱلۡمُلۡكُ يَوۡمَئِذٖ لِّلَّهِ يَحۡكُمُ بَيۡنَهُمۡۚ فَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فِي جَنَّـٰتِ ٱلنَّعِيمِ",
    translation:
      "[All] sovereignty that Day is for Allah; He will judge between them. So they who believed and did righteous deeds will be in the Gardens of Pleasure",
    normalizedText:
      "الملك يوماذ لله يحكم بينهم فالذين ءامنوا وعملوا الصلحت في جنت النعيم",
  },
  {
    verseId: 56,
    name: "الحج",
    surahId: 22,
    text: "وَٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِـَٔايَٰتِنَا فَأُوْلَـٰٓئِكَ لَهُمۡ عَذَابٞ مُّهِينٞ",
    translation:
      "And they who disbelieved and denied Our signs - for those there will be a humiliating punishment",
    normalizedText: "والذين كفروا وكذبوا بايتنا فاولاك لهم عذاب مهين",
  },
  {
    verseId: 57,
    name: "الحج",
    surahId: 22,
    text: "وَٱلَّذِينَ هَاجَرُواْ فِي سَبِيلِ ٱللَّهِ ثُمَّ قُتِلُوٓاْ أَوۡ مَاتُواْ لَيَرۡزُقَنَّهُمُ ٱللَّهُ رِزۡقًا حَسَنٗاۚ وَإِنَّ ٱللَّهَ لَهُوَ خَيۡرُ ٱلرَّـٰزِقِينَ",
    translation:
      "And those who emigrated for the cause of Allah and then were killed or died - Allah will surely provide for them a good provision. And indeed, it is Allah who is the best of providers",
    normalizedText:
      "والذين هاجروا في سبيل الله ثم قتلوا او ماتوا ليرزقنهم الله رزقا حسنا وان الله لهو خير الرزقين",
  },
  {
    verseId: 58,
    name: "الحج",
    surahId: 22,
    text: "لَيُدۡخِلَنَّهُم مُّدۡخَلٗا يَرۡضَوۡنَهُۥۚ وَإِنَّ ٱللَّهَ لَعَلِيمٌ حَلِيمٞ",
    translation:
      "He will surely cause them to enter an entrance with which they will be pleased, and indeed, Allah is Knowing and Forbearing",
    normalizedText: "ليدخلنهم مدخلا يرضونه وان الله لعليم حليم",
  },
  {
    verseId: 59,
    name: "الحج",
    surahId: 22,
    text: "۞ذَٰلِكَۖ وَمَنۡ عَاقَبَ بِمِثۡلِ مَا عُوقِبَ بِهِۦ ثُمَّ بُغِيَ عَلَيۡهِ لَيَنصُرَنَّهُ ٱللَّهُۚ إِنَّ ٱللَّهَ لَعَفُوٌّ غَفُورٞ",
    translation:
      "That [is so]. And whoever responds [to injustice] with the equivalent of that with which he was harmed and then is tyrannized - Allah will surely aid him. Indeed, Allah is Pardoning and Forgiving",
    normalizedText:
      "۞ذلك ومن عاقب بمثل ما عوقب به ثم بغي عليه لينصرنه الله ان الله لعفو غفور",
  },
  {
    verseId: 60,
    name: "الحج",
    surahId: 22,
    text: "ذَٰلِكَ بِأَنَّ ٱللَّهَ يُولِجُ ٱلَّيۡلَ فِي ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِي ٱلَّيۡلِ وَأَنَّ ٱللَّهَ سَمِيعُۢ بَصِيرٞ",
    translation:
      "That is because Allah causes the night to enter the day and causes the day to enter the night and because Allah is Hearing and Seeing",
    normalizedText:
      "ذلك بان الله يولج اليل في النهار ويولج النهار في اليل وان الله سميع بصير",
  },
  {
    verseId: 61,
    name: "الحج",
    surahId: 22,
    text: "ذَٰلِكَ بِأَنَّ ٱللَّهَ هُوَ ٱلۡحَقُّ وَأَنَّ مَا يَدۡعُونَ مِن دُونِهِۦ هُوَ ٱلۡبَٰطِلُ وَأَنَّ ٱللَّهَ هُوَ ٱلۡعَلِيُّ ٱلۡكَبِيرُ",
    translation:
      "That is because Allah is the Truth, and that which they call upon other than Him is falsehood, and because Allah is the Most High, the Grand",
    normalizedText:
      "ذلك بان الله هو الحق وان ما يدعون من دونه هو البطل وان الله هو العلي الكبير",
  },
  {
    verseId: 62,
    name: "الحج",
    surahId: 22,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَتُصۡبِحُ ٱلۡأَرۡضُ مُخۡضَرَّةًۚ إِنَّ ٱللَّهَ لَطِيفٌ خَبِيرٞ",
    translation:
      "Do you not see that Allah has sent down rain from the sky and the earth becomes green? Indeed, Allah is Subtle and Acquainted",
    normalizedText:
      "الم تر ان الله انزل من السماء ماء فتصبح الارض مخضرة ان الله لطيف خبير",
  },
  {
    verseId: 63,
    name: "الحج",
    surahId: 22,
    text: "لَّهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ وَإِنَّ ٱللَّهَ لَهُوَ ٱلۡغَنِيُّ ٱلۡحَمِيدُ",
    translation:
      "To Him belongs what is in the heavens and what is on the earth. And indeed, Allah is the Free of need, the Praiseworthy",
    normalizedText: "له ما في السموت وما في الارض وان الله لهو الغني الحميد",
  },
  {
    verseId: 64,
    name: "الحج",
    surahId: 22,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ سَخَّرَ لَكُم مَّا فِي ٱلۡأَرۡضِ وَٱلۡفُلۡكَ تَجۡرِي فِي ٱلۡبَحۡرِ بِأَمۡرِهِۦ وَيُمۡسِكُ ٱلسَّمَآءَ أَن تَقَعَ عَلَى ٱلۡأَرۡضِ إِلَّا بِإِذۡنِهِۦٓۚ إِنَّ ٱللَّهَ بِٱلنَّاسِ لَرَءُوفٞ رَّحِيمٞ",
    translation:
      "Do you not see that Allah has subjected to you whatever is on the earth and the ships which run through the sea by His command? And He restrains the sky from falling upon the earth, unless by His permission. Indeed Allah, to the people, is Kind and Merciful",
    normalizedText:
      "الم تر ان الله سخر لكم ما في الارض والفلك تجري في البحر بامره ويمسك السماء ان تقع على الارض الا باذنه ان الله بالناس لرءوف رحيم",
  },
  {
    verseId: 65,
    name: "الحج",
    surahId: 22,
    text: "وَهُوَ ٱلَّذِيٓ أَحۡيَاكُمۡ ثُمَّ يُمِيتُكُمۡ ثُمَّ يُحۡيِيكُمۡۗ إِنَّ ٱلۡإِنسَٰنَ لَكَفُورٞ",
    translation:
      "And He is the one who gave you life; then He causes you to die and then will [again] give you life. Indeed, mankind is ungrateful",
    normalizedText: "وهو الذي احياكم ثم يميتكم ثم يحييكم ان الانسن لكفور",
  },
  {
    verseId: 66,
    name: "الحج",
    surahId: 22,
    text: "لِّكُلِّ أُمَّةٖ جَعَلۡنَا مَنسَكًا هُمۡ نَاسِكُوهُۖ فَلَا يُنَٰزِعُنَّكَ فِي ٱلۡأَمۡرِۚ وَٱدۡعُ إِلَىٰ رَبِّكَۖ إِنَّكَ لَعَلَىٰ هُدٗى مُّسۡتَقِيمٖ",
    translation:
      "For every religion We have appointed rites which they perform. So, [O Muhammad], let the disbelievers not contend with you over the matter but invite them to your Lord. Indeed, you are upon straight guidance",
    normalizedText:
      "لكل امة جعلنا منسكا هم ناسكوه فلا ينزعنك في الامر وادع الى ربك انك لعلى هدى مستقيم",
  },
  {
    verseId: 67,
    name: "الحج",
    surahId: 22,
    text: "وَإِن جَٰدَلُوكَ فَقُلِ ٱللَّهُ أَعۡلَمُ بِمَا تَعۡمَلُونَ",
    translation:
      'And if they dispute with you, then say, "Allah is most knowing of what you do',
    normalizedText: "وان جدلوك فقل الله اعلم بما تعملون",
  },
  {
    verseId: 68,
    name: "الحج",
    surahId: 22,
    text: "ٱللَّهُ يَحۡكُمُ بَيۡنَكُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ فِيمَا كُنتُمۡ فِيهِ تَخۡتَلِفُونَ",
    translation:
      "Allah will judge between you on the Day of Resurrection concerning that over which you used to differ",
    normalizedText: "الله يحكم بينكم يوم القيمة فيما كنتم فيه تختلفون",
  },
  {
    verseId: 69,
    name: "الحج",
    surahId: 22,
    text: "أَلَمۡ تَعۡلَمۡ أَنَّ ٱللَّهَ يَعۡلَمُ مَا فِي ٱلسَّمَآءِ وَٱلۡأَرۡضِۚ إِنَّ ذَٰلِكَ فِي كِتَٰبٍۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٞ",
    translation:
      "Do you not know that Allah knows what is in the heaven and earth? Indeed, that is in a Record. Indeed that, for Allah, is easy",
    normalizedText:
      "الم تعلم ان الله يعلم ما في السماء والارض ان ذلك في كتب ان ذلك على الله يسير",
  },
  {
    verseId: 70,
    name: "الحج",
    surahId: 22,
    text: "وَيَعۡبُدُونَ مِن دُونِ ٱللَّهِ مَا لَمۡ يُنَزِّلۡ بِهِۦ سُلۡطَٰنٗا وَمَا لَيۡسَ لَهُم بِهِۦ عِلۡمٞۗ وَمَا لِلظَّـٰلِمِينَ مِن نَّصِيرٖ",
    translation:
      "And they worship besides Allah that for which He has not sent down authority and that of which they have no knowledge. And there will not be for the wrongdoers any helper",
    normalizedText:
      "ويعبدون من دون الله ما لم ينزل به سلطنا وما ليس لهم به علم وما للظلمين من نصير",
  },
  {
    verseId: 71,
    name: "الحج",
    surahId: 22,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَٰتُنَا بَيِّنَٰتٖ تَعۡرِفُ فِي وُجُوهِ ٱلَّذِينَ كَفَرُواْ ٱلۡمُنكَرَۖ يَكَادُونَ يَسۡطُونَ بِٱلَّذِينَ يَتۡلُونَ عَلَيۡهِمۡ ءَايَٰتِنَاۗ قُلۡ أَفَأُنَبِّئُكُم بِشَرّٖ مِّن ذَٰلِكُمُۚ ٱلنَّارُ وَعَدَهَا ٱللَّهُ ٱلَّذِينَ كَفَرُواْۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      'And when Our verses are recited to them as clear evidences, you recognize in the faces of those who disbelieve disapproval. They are almost on the verge of assaulting those who recite to them Our verses. Say, "Then shall I inform you of [what is] worse than that? [It is] the Fire which Allah has promised those who disbelieve, and wretched is the destination',
    normalizedText:
      "واذا تتلى عليهم ءايتنا بينت تعرف في وجوه الذين كفروا المنكر يكادون يسطون بالذين يتلون عليهم ءايتنا قل افانباكم بشر من ذلكم النار وعدها الله الذين كفروا وباس المصير",
  },
  {
    verseId: 72,
    name: "الحج",
    surahId: 22,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ضُرِبَ مَثَلٞ فَٱسۡتَمِعُواْ لَهُۥٓۚ إِنَّ ٱلَّذِينَ تَدۡعُونَ مِن دُونِ ٱللَّهِ لَن يَخۡلُقُواْ ذُبَابٗا وَلَوِ ٱجۡتَمَعُواْ لَهُۥۖ وَإِن يَسۡلُبۡهُمُ ٱلذُّبَابُ شَيۡـٔٗا لَّا يَسۡتَنقِذُوهُ مِنۡهُۚ ضَعُفَ ٱلطَّالِبُ وَٱلۡمَطۡلُوبُ",
    translation:
      "O people, an example is presented, so listen to it. Indeed, those you invoke besides Allah will never create [as much as] a fly, even if they gathered together for that purpose. And if the fly should steal away from them a [tiny] thing, they could not recover it from him. Weak are the pursuer and pursued",
    normalizedText:
      "يايها الناس ضرب مثل فاستمعوا له ان الذين تدعون من دون الله لن يخلقوا ذبابا ولو اجتمعوا له وان يسلبهم الذباب شيا لا يستنقذوه منه ضعف الطالب والمطلوب",
  },
  {
    verseId: 73,
    name: "الحج",
    surahId: 22,
    text: "مَا قَدَرُواْ ٱللَّهَ حَقَّ قَدۡرِهِۦٓۚ إِنَّ ٱللَّهَ لَقَوِيٌّ عَزِيزٌ",
    translation:
      "They have not appraised Allah with true appraisal. Indeed, Allah is Powerful and Exalted in Might",
    normalizedText: "ما قدروا الله حق قدره ان الله لقوي عزيز",
  },
  {
    verseId: 74,
    name: "الحج",
    surahId: 22,
    text: "ٱللَّهُ يَصۡطَفِي مِنَ ٱلۡمَلَـٰٓئِكَةِ رُسُلٗا وَمِنَ ٱلنَّاسِۚ إِنَّ ٱللَّهَ سَمِيعُۢ بَصِيرٞ",
    translation:
      "Allah chooses from the angels messengers and from the people. Indeed, Allah is Hearing and Seeing",
    normalizedText: "الله يصطفي من الملاكة رسلا ومن الناس ان الله سميع بصير",
  },
  {
    verseId: 75,
    name: "الحج",
    surahId: 22,
    text: "يَعۡلَمُ مَا بَيۡنَ أَيۡدِيهِمۡ وَمَا خَلۡفَهُمۡۚ وَإِلَى ٱللَّهِ تُرۡجَعُ ٱلۡأُمُورُ",
    translation:
      "He knows what is [presently] before them and what will be after them. And to Allah will be returned [all] matters",
    normalizedText: "يعلم ما بين ايديهم وما خلفهم والى الله ترجع الامور",
  },
  {
    verseId: 76,
    name: "الحج",
    surahId: 22,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱرۡكَعُواْ وَٱسۡجُدُواْۤ وَٱعۡبُدُواْ رَبَّكُمۡ وَٱفۡعَلُواْ ٱلۡخَيۡرَ لَعَلَّكُمۡ تُفۡلِحُونَ۩",
    translation:
      "O you who have believed, bow and prostrate and worship your Lord and do good - that you may succeed",
    normalizedText:
      "يايها الذين ءامنوا اركعوا واسجدوا واعبدوا ربكم وافعلوا الخير لعلكم تفلحون۩",
  },
  {
    verseId: 77,
    name: "الحج",
    surahId: 22,
    text: "وَجَٰهِدُواْ فِي ٱللَّهِ حَقَّ جِهَادِهِۦۚ هُوَ ٱجۡتَبَىٰكُمۡ وَمَا جَعَلَ عَلَيۡكُمۡ فِي ٱلدِّينِ مِنۡ حَرَجٖۚ مِّلَّةَ أَبِيكُمۡ إِبۡرَٰهِيمَۚ هُوَ سَمَّىٰكُمُ ٱلۡمُسۡلِمِينَ مِن قَبۡلُ وَفِي هَٰذَا لِيَكُونَ ٱلرَّسُولُ شَهِيدًا عَلَيۡكُمۡ وَتَكُونُواْ شُهَدَآءَ عَلَى ٱلنَّاسِۚ فَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَ وَٱعۡتَصِمُواْ بِٱللَّهِ هُوَ مَوۡلَىٰكُمۡۖ فَنِعۡمَ ٱلۡمَوۡلَىٰ وَنِعۡمَ ٱلنَّصِيرُ",
    translation:
      'And strive for Allah with the striving due to Him. He has chosen you and has not placed upon you in the religion any difficulty. [It is] the religion of your father, Abraham. Allah named you "Muslims" before [in former scriptures] and in this [revelation] that the Messenger may be a witness over you and you may be witnesses over the people. So establish prayer and give zakah and hold fast to Allah. He is your protector; and excellent is the protector, and excellent is the helper',
    normalizedText:
      "وجهدوا في الله حق جهاده هو اجتبىكم وما جعل عليكم في الدين من حرج ملة ابيكم ابرهيم هو سمىكم المسلمين من قبل وفي هذا ليكون الرسول شهيدا عليكم وتكونوا شهداء على الناس فاقيموا الصلوة وءاتوا الزكوة واعتصموا بالله هو مولىكم فنعم المولى ونعم النصير",
  },
  {
    verseId: 0,
    name: "المؤمنون",
    surahId: 23,
    text: "قَدۡ أَفۡلَحَ ٱلۡمُؤۡمِنُونَ",
    translation: "Certainly will the believers have succeeded",
    normalizedText: "قد افلح المامنون",
  },
  {
    verseId: 1,
    name: "المؤمنون",
    surahId: 23,
    text: "ٱلَّذِينَ هُمۡ فِي صَلَاتِهِمۡ خَٰشِعُونَ",
    translation: "They who are during their prayer humbly submissive",
    normalizedText: "الذين هم في صلاتهم خشعون",
  },
  {
    verseId: 2,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ هُمۡ عَنِ ٱللَّغۡوِ مُعۡرِضُونَ",
    translation: "And they who turn away from ill speech",
    normalizedText: "والذين هم عن اللغو معرضون",
  },
  {
    verseId: 3,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ هُمۡ لِلزَّكَوٰةِ فَٰعِلُونَ",
    translation: "And they who are observant of zakah",
    normalizedText: "والذين هم للزكوة فعلون",
  },
  {
    verseId: 4,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ هُمۡ لِفُرُوجِهِمۡ حَٰفِظُونَ",
    translation: "And they who guard their private parts",
    normalizedText: "والذين هم لفروجهم حفظون",
  },
  {
    verseId: 5,
    name: "المؤمنون",
    surahId: 23,
    text: "إِلَّا عَلَىٰٓ أَزۡوَٰجِهِمۡ أَوۡ مَا مَلَكَتۡ أَيۡمَٰنُهُمۡ فَإِنَّهُمۡ غَيۡرُ مَلُومِينَ",
    translation:
      "Except from their wives or those their right hands possess, for indeed, they will not be blamed",
    normalizedText: "الا على ازوجهم او ما ملكت ايمنهم فانهم غير ملومين",
  },
  {
    verseId: 6,
    name: "المؤمنون",
    surahId: 23,
    text: "فَمَنِ ٱبۡتَغَىٰ وَرَآءَ ذَٰلِكَ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡعَادُونَ",
    translation:
      "But whoever seeks beyond that, then those are the transgressors",
    normalizedText: "فمن ابتغى وراء ذلك فاولاك هم العادون",
  },
  {
    verseId: 7,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ هُمۡ لِأَمَٰنَٰتِهِمۡ وَعَهۡدِهِمۡ رَٰعُونَ",
    translation:
      "And they who are to their trusts and their promises attentive",
    normalizedText: "والذين هم لامنتهم وعهدهم رعون",
  },
  {
    verseId: 8,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ هُمۡ عَلَىٰ صَلَوَٰتِهِمۡ يُحَافِظُونَ",
    translation: "And they who carefully maintain their prayers",
    normalizedText: "والذين هم على صلوتهم يحافظون",
  },
  {
    verseId: 9,
    name: "المؤمنون",
    surahId: 23,
    text: "أُوْلَـٰٓئِكَ هُمُ ٱلۡوَٰرِثُونَ",
    translation: "Those are the inheritors",
    normalizedText: "اولاك هم الورثون",
  },
  {
    verseId: 10,
    name: "المؤمنون",
    surahId: 23,
    text: "ٱلَّذِينَ يَرِثُونَ ٱلۡفِرۡدَوۡسَ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "Who will inherit al-Firdaus. They will abide therein eternally",
    normalizedText: "الذين يرثون الفردوس هم فيها خلدون",
  },
  {
    verseId: 11,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَقَدۡ خَلَقۡنَا ٱلۡإِنسَٰنَ مِن سُلَٰلَةٖ مِّن طِينٖ",
    translation: "And certainly did We create man from an extract of clay",
    normalizedText: "ولقد خلقنا الانسن من سللة من طين",
  },
  {
    verseId: 12,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ جَعَلۡنَٰهُ نُطۡفَةٗ فِي قَرَارٖ مَّكِينٖ",
    translation: "Then We placed him as a sperm-drop in a firm lodging",
    normalizedText: "ثم جعلنه نطفة في قرار مكين",
  },
  {
    verseId: 13,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ خَلَقۡنَا ٱلنُّطۡفَةَ عَلَقَةٗ فَخَلَقۡنَا ٱلۡعَلَقَةَ مُضۡغَةٗ فَخَلَقۡنَا ٱلۡمُضۡغَةَ عِظَٰمٗا فَكَسَوۡنَا ٱلۡعِظَٰمَ لَحۡمٗا ثُمَّ أَنشَأۡنَٰهُ خَلۡقًا ءَاخَرَۚ فَتَبَارَكَ ٱللَّهُ أَحۡسَنُ ٱلۡخَٰلِقِينَ",
    translation:
      "Then We made the sperm-drop into a clinging clot, and We made the clot into a lump [of flesh], and We made [from] the lump, bones, and We covered the bones with flesh; then We developed him into another creation. So blessed is Allah, the best of creators",
    normalizedText:
      "ثم خلقنا النطفة علقة فخلقنا العلقة مضغة فخلقنا المضغة عظما فكسونا العظم لحما ثم انشانه خلقا ءاخر فتبارك الله احسن الخلقين",
  },
  {
    verseId: 14,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ إِنَّكُم بَعۡدَ ذَٰلِكَ لَمَيِّتُونَ",
    translation: "Then indeed, after that you are to die",
    normalizedText: "ثم انكم بعد ذلك لميتون",
  },
  {
    verseId: 15,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ إِنَّكُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ تُبۡعَثُونَ",
    translation:
      "Then indeed you, on the Day of Resurrection, will be resurrected",
    normalizedText: "ثم انكم يوم القيمة تبعثون",
  },
  {
    verseId: 16,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَقَدۡ خَلَقۡنَا فَوۡقَكُمۡ سَبۡعَ طَرَآئِقَ وَمَا كُنَّا عَنِ ٱلۡخَلۡقِ غَٰفِلِينَ",
    translation:
      "And We have created above you seven layered heavens, and never have We been of [Our] creation unaware",
    normalizedText: "ولقد خلقنا فوقكم سبع طرااق وما كنا عن الخلق غفلين",
  },
  {
    verseId: 17,
    name: "المؤمنون",
    surahId: 23,
    text: "وَأَنزَلۡنَا مِنَ ٱلسَّمَآءِ مَآءَۢ بِقَدَرٖ فَأَسۡكَنَّـٰهُ فِي ٱلۡأَرۡضِۖ وَإِنَّا عَلَىٰ ذَهَابِۭ بِهِۦ لَقَٰدِرُونَ",
    translation:
      "And We have sent down rain from the sky in a measured amount and settled it in the earth. And indeed, We are Able to take it away",
    normalizedText:
      "وانزلنا من السماء ماء بقدر فاسكنه في الارض وانا على ذهاب به لقدرون",
  },
  {
    verseId: 18,
    name: "المؤمنون",
    surahId: 23,
    text: "فَأَنشَأۡنَا لَكُم بِهِۦ جَنَّـٰتٖ مِّن نَّخِيلٖ وَأَعۡنَٰبٖ لَّكُمۡ فِيهَا فَوَٰكِهُ كَثِيرَةٞ وَمِنۡهَا تَأۡكُلُونَ",
    translation:
      "And We brought forth for you thereby gardens of palm trees and grapevines in which for you are abundant fruits and from which you eat",
    normalizedText:
      "فانشانا لكم به جنت من نخيل واعنب لكم فيها فوكه كثيرة ومنها تاكلون",
  },
  {
    verseId: 19,
    name: "المؤمنون",
    surahId: 23,
    text: "وَشَجَرَةٗ تَخۡرُجُ مِن طُورِ سَيۡنَآءَ تَنۢبُتُ بِٱلدُّهۡنِ وَصِبۡغٖ لِّلۡأٓكِلِينَ",
    translation:
      "And [We brought forth] a tree issuing from Mount Sinai which produces oil and food for those who eat",
    normalizedText: "وشجرة تخرج من طور سيناء تنبت بالدهن وصبغ للاكلين",
  },
  {
    verseId: 20,
    name: "المؤمنون",
    surahId: 23,
    text: "وَإِنَّ لَكُمۡ فِي ٱلۡأَنۡعَٰمِ لَعِبۡرَةٗۖ نُّسۡقِيكُم مِّمَّا فِي بُطُونِهَا وَلَكُمۡ فِيهَا مَنَٰفِعُ كَثِيرَةٞ وَمِنۡهَا تَأۡكُلُونَ",
    translation:
      "And indeed, for you in livestock is a lesson. We give you drink from that which is in their bellies, and for you in them are numerous benefits, and from them you eat",
    normalizedText:
      "وان لكم في الانعم لعبرة نسقيكم مما في بطونها ولكم فيها منفع كثيرة ومنها تاكلون",
  },
  {
    verseId: 21,
    name: "المؤمنون",
    surahId: 23,
    text: "وَعَلَيۡهَا وَعَلَى ٱلۡفُلۡكِ تُحۡمَلُونَ",
    translation: "And upon them and on ships you are carried",
    normalizedText: "وعليها وعلى الفلك تحملون",
  },
  {
    verseId: 22,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَقَدۡ أَرۡسَلۡنَا نُوحًا إِلَىٰ قَوۡمِهِۦ فَقَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥٓۚ أَفَلَا تَتَّقُونَ",
    translation:
      'And We had certainly sent Noah to his people, and he said, "O my people, worship Allah; you have no deity other than Him; then will you not fear Him',
    normalizedText:
      "ولقد ارسلنا نوحا الى قومه فقال يقوم اعبدوا الله ما لكم من اله غيره افلا تتقون",
  },
  {
    verseId: 23,
    name: "المؤمنون",
    surahId: 23,
    text: "فَقَالَ ٱلۡمَلَؤُاْ ٱلَّذِينَ كَفَرُواْ مِن قَوۡمِهِۦ مَا هَٰذَآ إِلَّا بَشَرٞ مِّثۡلُكُمۡ يُرِيدُ أَن يَتَفَضَّلَ عَلَيۡكُمۡ وَلَوۡ شَآءَ ٱللَّهُ لَأَنزَلَ مَلَـٰٓئِكَةٗ مَّا سَمِعۡنَا بِهَٰذَا فِيٓ ءَابَآئِنَا ٱلۡأَوَّلِينَ",
    translation:
      'But the eminent among those who disbelieved from his people said, "This is not but a man like yourselves who wishes to take precedence over you; and if Allah had willed [to send a messenger], He would have sent down angels. We have not heard of this among our forefathers',
    normalizedText:
      "فقال الملاا الذين كفروا من قومه ما هذا الا بشر مثلكم يريد ان يتفضل عليكم ولو شاء الله لانزل ملاكة ما سمعنا بهذا في ءاباانا الاولين",
  },
  {
    verseId: 24,
    name: "المؤمنون",
    surahId: 23,
    text: "إِنۡ هُوَ إِلَّا رَجُلُۢ بِهِۦ جِنَّةٞ فَتَرَبَّصُواْ بِهِۦ حَتَّىٰ حِينٖ",
    translation:
      "He is not but a man possessed with madness, so wait concerning him for a time",
    normalizedText: "ان هو الا رجل به جنة فتربصوا به حتى حين",
  },
  {
    verseId: 25,
    name: "المؤمنون",
    surahId: 23,
    text: "قَالَ رَبِّ ٱنصُرۡنِي بِمَا كَذَّبُونِ",
    translation:
      '[Noah] said, "My Lord, support me because they have denied me',
    normalizedText: "قال رب انصرني بما كذبون",
  },
  {
    verseId: 26,
    name: "المؤمنون",
    surahId: 23,
    text: "فَأَوۡحَيۡنَآ إِلَيۡهِ أَنِ ٱصۡنَعِ ٱلۡفُلۡكَ بِأَعۡيُنِنَا وَوَحۡيِنَا فَإِذَا جَآءَ أَمۡرُنَا وَفَارَ ٱلتَّنُّورُ فَٱسۡلُكۡ فِيهَا مِن كُلّٖ زَوۡجَيۡنِ ٱثۡنَيۡنِ وَأَهۡلَكَ إِلَّا مَن سَبَقَ عَلَيۡهِ ٱلۡقَوۡلُ مِنۡهُمۡۖ وَلَا تُخَٰطِبۡنِي فِي ٱلَّذِينَ ظَلَمُوٓاْ إِنَّهُم مُّغۡرَقُونَ",
    translation:
      'So We inspired to him, "Construct the ship under Our observation, and Our inspiration, and when Our command comes and the oven overflows, put into the ship from each [creature] two mates and your family, except those for whom the decree [of destruction] has proceeded. And do not address Me concerning those who have wronged; indeed, they are to be drowned',
    normalizedText:
      "فاوحينا اليه ان اصنع الفلك باعيننا ووحينا فاذا جاء امرنا وفار التنور فاسلك فيها من كل زوجين اثنين واهلك الا من سبق عليه القول منهم ولا تخطبني في الذين ظلموا انهم مغرقون",
  },
  {
    verseId: 27,
    name: "المؤمنون",
    surahId: 23,
    text: "فَإِذَا ٱسۡتَوَيۡتَ أَنتَ وَمَن مَّعَكَ عَلَى ٱلۡفُلۡكِ فَقُلِ ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي نَجَّىٰنَا مِنَ ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      "And when you have boarded the ship, you and those with you, then say, 'Praise to Allah who has saved us from the wrongdoing people",
    normalizedText:
      "فاذا استويت انت ومن معك على الفلك فقل الحمد لله الذي نجىنا من القوم الظلمين",
  },
  {
    verseId: 28,
    name: "المؤمنون",
    surahId: 23,
    text: "وَقُل رَّبِّ أَنزِلۡنِي مُنزَلٗا مُّبَارَكٗا وَأَنتَ خَيۡرُ ٱلۡمُنزِلِينَ",
    translation:
      "And say, 'My Lord, let me land at a blessed landing place, and You are the best to accommodate [us]",
    normalizedText: "وقل رب انزلني منزلا مباركا وانت خير المنزلين",
  },
  {
    verseId: 29,
    name: "المؤمنون",
    surahId: 23,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ وَإِن كُنَّا لَمُبۡتَلِينَ",
    translation:
      "Indeed in that are signs, and indeed, We are ever testing [Our servants]",
    normalizedText: "ان في ذلك لايت وان كنا لمبتلين",
  },
  {
    verseId: 30,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ أَنشَأۡنَا مِنۢ بَعۡدِهِمۡ قَرۡنًا ءَاخَرِينَ",
    translation: "Then We produced after them a generation of others",
    normalizedText: "ثم انشانا من بعدهم قرنا ءاخرين",
  },
  {
    verseId: 31,
    name: "المؤمنون",
    surahId: 23,
    text: "فَأَرۡسَلۡنَا فِيهِمۡ رَسُولٗا مِّنۡهُمۡ أَنِ ٱعۡبُدُواْ ٱللَّهَ مَا لَكُم مِّنۡ إِلَٰهٍ غَيۡرُهُۥٓۚ أَفَلَا تَتَّقُونَ",
    translation:
      'And We sent among them a messenger from themselves, [saying], "Worship Allah; you have no deity other than Him; then will you not fear Him',
    normalizedText:
      "فارسلنا فيهم رسولا منهم ان اعبدوا الله ما لكم من اله غيره افلا تتقون",
  },
  {
    verseId: 32,
    name: "المؤمنون",
    surahId: 23,
    text: "وَقَالَ ٱلۡمَلَأُ مِن قَوۡمِهِ ٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِلِقَآءِ ٱلۡأٓخِرَةِ وَأَتۡرَفۡنَٰهُمۡ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا مَا هَٰذَآ إِلَّا بَشَرٞ مِّثۡلُكُمۡ يَأۡكُلُ مِمَّا تَأۡكُلُونَ مِنۡهُ وَيَشۡرَبُ مِمَّا تَشۡرَبُونَ",
    translation:
      'And the eminent among his people who disbelieved and denied the meeting of the Hereafter while We had given them luxury in the worldly life said, "This is not but a man like yourselves. He eats of that from which you eat and drinks of what you drink',
    normalizedText:
      "وقال الملا من قومه الذين كفروا وكذبوا بلقاء الاخرة واترفنهم في الحيوة الدنيا ما هذا الا بشر مثلكم ياكل مما تاكلون منه ويشرب مما تشربون",
  },
  {
    verseId: 33,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَئِنۡ أَطَعۡتُم بَشَرٗا مِّثۡلَكُمۡ إِنَّكُمۡ إِذٗا لَّخَٰسِرُونَ",
    translation:
      "And if you should obey a man like yourselves, indeed, you would then be losers",
    normalizedText: "ولان اطعتم بشرا مثلكم انكم اذا لخسرون",
  },
  {
    verseId: 34,
    name: "المؤمنون",
    surahId: 23,
    text: "أَيَعِدُكُمۡ أَنَّكُمۡ إِذَا مِتُّمۡ وَكُنتُمۡ تُرَابٗا وَعِظَٰمًا أَنَّكُم مُّخۡرَجُونَ",
    translation:
      "Does he promise you that when you have died and become dust and bones that you will be brought forth [once more]",
    normalizedText: "ايعدكم انكم اذا متم وكنتم ترابا وعظما انكم مخرجون",
  },
  {
    verseId: 35,
    name: "المؤمنون",
    surahId: 23,
    text: "۞هَيۡهَاتَ هَيۡهَاتَ لِمَا تُوعَدُونَ",
    translation: "How far, how far, is that which you are promised",
    normalizedText: "۞هيهات هيهات لما توعدون",
  },
  {
    verseId: 36,
    name: "المؤمنون",
    surahId: 23,
    text: "إِنۡ هِيَ إِلَّا حَيَاتُنَا ٱلدُّنۡيَا نَمُوتُ وَنَحۡيَا وَمَا نَحۡنُ بِمَبۡعُوثِينَ",
    translation:
      "Life is not but our worldly life - we die and live, but we will not be resurrected",
    normalizedText: "ان هي الا حياتنا الدنيا نموت ونحيا وما نحن بمبعوثين",
  },
  {
    verseId: 37,
    name: "المؤمنون",
    surahId: 23,
    text: "إِنۡ هُوَ إِلَّا رَجُلٌ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبٗا وَمَا نَحۡنُ لَهُۥ بِمُؤۡمِنِينَ",
    translation:
      "He is not but a man who has invented a lie about Allah, and we will not believe him",
    normalizedText: "ان هو الا رجل افترى على الله كذبا وما نحن له بمامنين",
  },
  {
    verseId: 38,
    name: "المؤمنون",
    surahId: 23,
    text: "قَالَ رَبِّ ٱنصُرۡنِي بِمَا كَذَّبُونِ",
    translation: 'He said, "My Lord, support me because they have denied me',
    normalizedText: "قال رب انصرني بما كذبون",
  },
  {
    verseId: 39,
    name: "المؤمنون",
    surahId: 23,
    text: "قَالَ عَمَّا قَلِيلٖ لَّيُصۡبِحُنَّ نَٰدِمِينَ",
    translation:
      '[Allah] said, "After a little, they will surely become regretful',
    normalizedText: "قال عما قليل ليصبحن ندمين",
  },
  {
    verseId: 40,
    name: "المؤمنون",
    surahId: 23,
    text: "فَأَخَذَتۡهُمُ ٱلصَّيۡحَةُ بِٱلۡحَقِّ فَجَعَلۡنَٰهُمۡ غُثَآءٗۚ فَبُعۡدٗا لِّلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      "So the shriek seized them in truth, and We made them as [plant] stubble. Then away with the wrongdoing people",
    normalizedText: "فاخذتهم الصيحة بالحق فجعلنهم غثاء فبعدا للقوم الظلمين",
  },
  {
    verseId: 41,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ أَنشَأۡنَا مِنۢ بَعۡدِهِمۡ قُرُونًا ءَاخَرِينَ",
    translation: "Then We produced after them other generations",
    normalizedText: "ثم انشانا من بعدهم قرونا ءاخرين",
  },
  {
    verseId: 42,
    name: "المؤمنون",
    surahId: 23,
    text: "مَا تَسۡبِقُ مِنۡ أُمَّةٍ أَجَلَهَا وَمَا يَسۡتَـٔۡخِرُونَ",
    translation:
      "No nation will precede its time [of termination], nor will they remain [thereafter]",
    normalizedText: "ما تسبق من امة اجلها وما يستخرون",
  },
  {
    verseId: 43,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ أَرۡسَلۡنَا رُسُلَنَا تَتۡرَاۖ كُلَّ مَا جَآءَ أُمَّةٗ رَّسُولُهَا كَذَّبُوهُۖ فَأَتۡبَعۡنَا بَعۡضَهُم بَعۡضٗا وَجَعَلۡنَٰهُمۡ أَحَادِيثَۚ فَبُعۡدٗا لِّقَوۡمٖ لَّا يُؤۡمِنُونَ",
    translation:
      "Then We sent Our messengers in succession. Every time there came to a nation its messenger, they denied him, so We made them follow one another [to destruction], and We made them narrations. So away with a people who do not believe",
    normalizedText:
      "ثم ارسلنا رسلنا تترا كل ما جاء امة رسولها كذبوه فاتبعنا بعضهم بعضا وجعلنهم احاديث فبعدا لقوم لا يامنون",
  },
  {
    verseId: 44,
    name: "المؤمنون",
    surahId: 23,
    text: "ثُمَّ أَرۡسَلۡنَا مُوسَىٰ وَأَخَاهُ هَٰرُونَ بِـَٔايَٰتِنَا وَسُلۡطَٰنٖ مُّبِينٍ",
    translation:
      "Then We sent Moses and his brother Aaron with Our signs and a clear authority",
    normalizedText: "ثم ارسلنا موسى واخاه هرون بايتنا وسلطن مبين",
  },
  {
    verseId: 45,
    name: "المؤمنون",
    surahId: 23,
    text: "إِلَىٰ فِرۡعَوۡنَ وَمَلَإِيْهِۦ فَٱسۡتَكۡبَرُواْ وَكَانُواْ قَوۡمًا عَالِينَ",
    translation:
      "To Pharaoh and his establishment, but they were arrogant and were a haughty people",
    normalizedText: "الى فرعون وملايه فاستكبروا وكانوا قوما عالين",
  },
  {
    verseId: 46,
    name: "المؤمنون",
    surahId: 23,
    text: "فَقَالُوٓاْ أَنُؤۡمِنُ لِبَشَرَيۡنِ مِثۡلِنَا وَقَوۡمُهُمَا لَنَا عَٰبِدُونَ",
    translation:
      'They said, "Should we believe two men like ourselves while their people are for us in servitude',
    normalizedText: "فقالوا انامن لبشرين مثلنا وقومهما لنا عبدون",
  },
  {
    verseId: 47,
    name: "المؤمنون",
    surahId: 23,
    text: "فَكَذَّبُوهُمَا فَكَانُواْ مِنَ ٱلۡمُهۡلَكِينَ",
    translation: "So they denied them and were of those destroyed",
    normalizedText: "فكذبوهما فكانوا من المهلكين",
  },
  {
    verseId: 48,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ لَعَلَّهُمۡ يَهۡتَدُونَ",
    translation:
      "And We certainly gave Moses the Scripture that perhaps they would be guided",
    normalizedText: "ولقد ءاتينا موسى الكتب لعلهم يهتدون",
  },
  {
    verseId: 49,
    name: "المؤمنون",
    surahId: 23,
    text: "وَجَعَلۡنَا ٱبۡنَ مَرۡيَمَ وَأُمَّهُۥٓ ءَايَةٗ وَءَاوَيۡنَٰهُمَآ إِلَىٰ رَبۡوَةٖ ذَاتِ قَرَارٖ وَمَعِينٖ",
    translation:
      "And We made the son of Mary and his mother a sign and sheltered them within a high ground having level [areas] and flowing water",
    normalizedText:
      "وجعلنا ابن مريم وامه ءاية وءاوينهما الى ربوة ذات قرار ومعين",
  },
  {
    verseId: 50,
    name: "المؤمنون",
    surahId: 23,
    text: "يَـٰٓأَيُّهَا ٱلرُّسُلُ كُلُواْ مِنَ ٱلطَّيِّبَٰتِ وَٱعۡمَلُواْ صَٰلِحًاۖ إِنِّي بِمَا تَعۡمَلُونَ عَلِيمٞ",
    translation:
      '[Allah said], "O messengers, eat from the good foods and work righteousness. Indeed, I, of what you do, am Knowing',
    normalizedText:
      "يايها الرسل كلوا من الطيبت واعملوا صلحا اني بما تعملون عليم",
  },
  {
    verseId: 51,
    name: "المؤمنون",
    surahId: 23,
    text: "وَإِنَّ هَٰذِهِۦٓ أُمَّتُكُمۡ أُمَّةٗ وَٰحِدَةٗ وَأَنَا۠ رَبُّكُمۡ فَٱتَّقُونِ",
    translation:
      "And indeed this, your religion, is one religion, and I am your Lord, so fear Me",
    normalizedText: "وان هذه امتكم امة وحدة وانا ربكم فاتقون",
  },
  {
    verseId: 52,
    name: "المؤمنون",
    surahId: 23,
    text: "فَتَقَطَّعُوٓاْ أَمۡرَهُم بَيۡنَهُمۡ زُبُرٗاۖ كُلُّ حِزۡبِۭ بِمَا لَدَيۡهِمۡ فَرِحُونَ",
    translation:
      "But the people divided their religion among them into sects - each faction, in what it has, rejoicing",
    normalizedText: "فتقطعوا امرهم بينهم زبرا كل حزب بما لديهم فرحون",
  },
  {
    verseId: 53,
    name: "المؤمنون",
    surahId: 23,
    text: "فَذَرۡهُمۡ فِي غَمۡرَتِهِمۡ حَتَّىٰ حِينٍ",
    translation: "So leave them in their confusion for a time",
    normalizedText: "فذرهم في غمرتهم حتى حين",
  },
  {
    verseId: 54,
    name: "المؤمنون",
    surahId: 23,
    text: "أَيَحۡسَبُونَ أَنَّمَا نُمِدُّهُم بِهِۦ مِن مَّالٖ وَبَنِينَ",
    translation:
      "Do they think that what We extend to them of wealth and children",
    normalizedText: "ايحسبون انما نمدهم به من مال وبنين",
  },
  {
    verseId: 55,
    name: "المؤمنون",
    surahId: 23,
    text: "نُسَارِعُ لَهُمۡ فِي ٱلۡخَيۡرَٰتِۚ بَل لَّا يَشۡعُرُونَ",
    translation:
      "Is [because] We hasten for them good things? Rather, they do not perceive",
    normalizedText: "نسارع لهم في الخيرت بل لا يشعرون",
  },
  {
    verseId: 56,
    name: "المؤمنون",
    surahId: 23,
    text: "إِنَّ ٱلَّذِينَ هُم مِّنۡ خَشۡيَةِ رَبِّهِم مُّشۡفِقُونَ",
    translation: "Indeed, they who are apprehensive from fear of their Lord",
    normalizedText: "ان الذين هم من خشية ربهم مشفقون",
  },
  {
    verseId: 57,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ هُم بِـَٔايَٰتِ رَبِّهِمۡ يُؤۡمِنُونَ",
    translation: "And they who believe in the signs of their Lord",
    normalizedText: "والذين هم بايت ربهم يامنون",
  },
  {
    verseId: 58,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ هُم بِرَبِّهِمۡ لَا يُشۡرِكُونَ",
    translation: "And they who do not associate anything with their Lord",
    normalizedText: "والذين هم بربهم لا يشركون",
  },
  {
    verseId: 59,
    name: "المؤمنون",
    surahId: 23,
    text: "وَٱلَّذِينَ يُؤۡتُونَ مَآ ءَاتَواْ وَّقُلُوبُهُمۡ وَجِلَةٌ أَنَّهُمۡ إِلَىٰ رَبِّهِمۡ رَٰجِعُونَ",
    translation:
      "And they who give what they give while their hearts are fearful because they will be returning to their Lord",
    normalizedText: "والذين ياتون ما ءاتوا وقلوبهم وجلة انهم الى ربهم رجعون",
  },
  {
    verseId: 60,
    name: "المؤمنون",
    surahId: 23,
    text: "أُوْلَـٰٓئِكَ يُسَٰرِعُونَ فِي ٱلۡخَيۡرَٰتِ وَهُمۡ لَهَا سَٰبِقُونَ",
    translation:
      "It is those who hasten to good deeds, and they outstrip [others] therein",
    normalizedText: "اولاك يسرعون في الخيرت وهم لها سبقون",
  },
  {
    verseId: 61,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَا نُكَلِّفُ نَفۡسًا إِلَّا وُسۡعَهَاۚ وَلَدَيۡنَا كِتَٰبٞ يَنطِقُ بِٱلۡحَقِّ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "And We charge no soul except [with that within] its capacity, and with Us is a record which speaks with truth; and they will not be wronged",
    normalizedText:
      "ولا نكلف نفسا الا وسعها ولدينا كتب ينطق بالحق وهم لا يظلمون",
  },
  {
    verseId: 62,
    name: "المؤمنون",
    surahId: 23,
    text: "بَلۡ قُلُوبُهُمۡ فِي غَمۡرَةٖ مِّنۡ هَٰذَا وَلَهُمۡ أَعۡمَٰلٞ مِّن دُونِ ذَٰلِكَ هُمۡ لَهَا عَٰمِلُونَ",
    translation:
      "But their hearts are covered with confusion over this, and they have [evil] deeds besides disbelief which they are doing",
    normalizedText:
      "بل قلوبهم في غمرة من هذا ولهم اعمل من دون ذلك هم لها عملون",
  },
  {
    verseId: 63,
    name: "المؤمنون",
    surahId: 23,
    text: "حَتَّىٰٓ إِذَآ أَخَذۡنَا مُتۡرَفِيهِم بِٱلۡعَذَابِ إِذَا هُمۡ يَجۡـَٔرُونَ",
    translation:
      "Until when We seize their affluent ones with punishment, at once they are crying [to Allah] for help",
    normalizedText: "حتى اذا اخذنا مترفيهم بالعذاب اذا هم يجرون",
  },
  {
    verseId: 64,
    name: "المؤمنون",
    surahId: 23,
    text: "لَا تَجۡـَٔرُواْ ٱلۡيَوۡمَۖ إِنَّكُم مِّنَّا لَا تُنصَرُونَ",
    translation: "Do not cry out today. Indeed, by Us you will not be helped",
    normalizedText: "لا تجروا اليوم انكم منا لا تنصرون",
  },
  {
    verseId: 65,
    name: "المؤمنون",
    surahId: 23,
    text: "قَدۡ كَانَتۡ ءَايَٰتِي تُتۡلَىٰ عَلَيۡكُمۡ فَكُنتُمۡ عَلَىٰٓ أَعۡقَٰبِكُمۡ تَنكِصُونَ",
    translation:
      "My verses had already been recited to you, but you were turning back on your heels",
    normalizedText: "قد كانت ءايتي تتلى عليكم فكنتم على اعقبكم تنكصون",
  },
  {
    verseId: 66,
    name: "المؤمنون",
    surahId: 23,
    text: "مُسۡتَكۡبِرِينَ بِهِۦ سَٰمِرٗا تَهۡجُرُونَ",
    translation:
      "In arrogance regarding it, conversing by night, speaking evil",
    normalizedText: "مستكبرين به سمرا تهجرون",
  },
  {
    verseId: 67,
    name: "المؤمنون",
    surahId: 23,
    text: "أَفَلَمۡ يَدَّبَّرُواْ ٱلۡقَوۡلَ أَمۡ جَآءَهُم مَّا لَمۡ يَأۡتِ ءَابَآءَهُمُ ٱلۡأَوَّلِينَ",
    translation:
      "Then have they not reflected over the Qur'an, or has there come to them that which had not come to their forefathers",
    normalizedText: "افلم يدبروا القول ام جاءهم ما لم يات ءاباءهم الاولين",
  },
  {
    verseId: 68,
    name: "المؤمنون",
    surahId: 23,
    text: "أَمۡ لَمۡ يَعۡرِفُواْ رَسُولَهُمۡ فَهُمۡ لَهُۥ مُنكِرُونَ",
    translation:
      "Or did they not know their Messenger, so they are toward him disacknowledging",
    normalizedText: "ام لم يعرفوا رسولهم فهم له منكرون",
  },
  {
    verseId: 69,
    name: "المؤمنون",
    surahId: 23,
    text: "أَمۡ يَقُولُونَ بِهِۦ جِنَّةُۢۚ بَلۡ جَآءَهُم بِٱلۡحَقِّ وَأَكۡثَرُهُمۡ لِلۡحَقِّ كَٰرِهُونَ",
    translation:
      'Or do they say, "In him is madness?" Rather, he brought them the truth, but most of them, to the truth, are averse',
    normalizedText: "ام يقولون به جنة بل جاءهم بالحق واكثرهم للحق كرهون",
  },
  {
    verseId: 70,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَوِ ٱتَّبَعَ ٱلۡحَقُّ أَهۡوَآءَهُمۡ لَفَسَدَتِ ٱلسَّمَٰوَٰتُ وَٱلۡأَرۡضُ وَمَن فِيهِنَّۚ بَلۡ أَتَيۡنَٰهُم بِذِكۡرِهِمۡ فَهُمۡ عَن ذِكۡرِهِم مُّعۡرِضُونَ",
    translation:
      "But if the Truth had followed their inclinations, the heavens and the earth and whoever is in them would have been ruined. Rather, We have brought them their message, but they, from their message, are turning away",
    normalizedText:
      "ولو اتبع الحق اهواءهم لفسدت السموت والارض ومن فيهن بل اتينهم بذكرهم فهم عن ذكرهم معرضون",
  },
  {
    verseId: 71,
    name: "المؤمنون",
    surahId: 23,
    text: "أَمۡ تَسۡـَٔلُهُمۡ خَرۡجٗا فَخَرَاجُ رَبِّكَ خَيۡرٞۖ وَهُوَ خَيۡرُ ٱلرَّـٰزِقِينَ",
    translation:
      "Or do you, [O Muhammad], ask them for payment? But the reward of your Lord is best, and He is the best of providers",
    normalizedText: "ام تسلهم خرجا فخراج ربك خير وهو خير الرزقين",
  },
  {
    verseId: 72,
    name: "المؤمنون",
    surahId: 23,
    text: "وَإِنَّكَ لَتَدۡعُوهُمۡ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation: "And indeed, you invite them to a straight path",
    normalizedText: "وانك لتدعوهم الى صرط مستقيم",
  },
  {
    verseId: 73,
    name: "المؤمنون",
    surahId: 23,
    text: "وَإِنَّ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ عَنِ ٱلصِّرَٰطِ لَنَٰكِبُونَ",
    translation:
      "But indeed, those who do not believe in the Hereafter are deviating from the path",
    normalizedText: "وان الذين لا يامنون بالاخرة عن الصرط لنكبون",
  },
  {
    verseId: 74,
    name: "المؤمنون",
    surahId: 23,
    text: "۞وَلَوۡ رَحِمۡنَٰهُمۡ وَكَشَفۡنَا مَا بِهِم مِّن ضُرّٖ لَّلَجُّواْ فِي طُغۡيَٰنِهِمۡ يَعۡمَهُونَ",
    translation:
      "And even if We gave them mercy and removed what was upon them of affliction, they would persist in their transgression, wandering blindly",
    normalizedText: "۞ولو رحمنهم وكشفنا ما بهم من ضر للجوا في طغينهم يعمهون",
  },
  {
    verseId: 75,
    name: "المؤمنون",
    surahId: 23,
    text: "وَلَقَدۡ أَخَذۡنَٰهُم بِٱلۡعَذَابِ فَمَا ٱسۡتَكَانُواْ لِرَبِّهِمۡ وَمَا يَتَضَرَّعُونَ",
    translation:
      "And We had gripped them with suffering [as a warning], but they did not yield to their Lord, nor did they humbly supplicate, [and will continue thus]",
    normalizedText: "ولقد اخذنهم بالعذاب فما استكانوا لربهم وما يتضرعون",
  },
  {
    verseId: 76,
    name: "المؤمنون",
    surahId: 23,
    text: "حَتَّىٰٓ إِذَا فَتَحۡنَا عَلَيۡهِم بَابٗا ذَا عَذَابٖ شَدِيدٍ إِذَا هُمۡ فِيهِ مُبۡلِسُونَ",
    translation:
      "Until when We have opened before them a door of severe punishment, immediately they will be therein in despair",
    normalizedText: "حتى اذا فتحنا عليهم بابا ذا عذاب شديد اذا هم فيه مبلسون",
  },
  {
    verseId: 77,
    name: "المؤمنون",
    surahId: 23,
    text: "وَهُوَ ٱلَّذِيٓ أَنشَأَ لَكُمُ ٱلسَّمۡعَ وَٱلۡأَبۡصَٰرَ وَٱلۡأَفۡـِٔدَةَۚ قَلِيلٗا مَّا تَشۡكُرُونَ",
    translation:
      "And it is He who produced for you hearing and vision and hearts; little are you grateful",
    normalizedText: "وهو الذي انشا لكم السمع والابصر والافدة قليلا ما تشكرون",
  },
  {
    verseId: 78,
    name: "المؤمنون",
    surahId: 23,
    text: "وَهُوَ ٱلَّذِي ذَرَأَكُمۡ فِي ٱلۡأَرۡضِ وَإِلَيۡهِ تُحۡشَرُونَ",
    translation:
      "And it is He who has multiplied you throughout the earth, and to Him you will be gathered",
    normalizedText: "وهو الذي ذراكم في الارض واليه تحشرون",
  },
  {
    verseId: 79,
    name: "المؤمنون",
    surahId: 23,
    text: "وَهُوَ ٱلَّذِي يُحۡيِۦ وَيُمِيتُ وَلَهُ ٱخۡتِلَٰفُ ٱلَّيۡلِ وَٱلنَّهَارِۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "And it is He who gives life and causes death, and His is the alternation of the night and the day. Then will you not reason",
    normalizedText: "وهو الذي يحي ويميت وله اختلف اليل والنهار افلا تعقلون",
  },
  {
    verseId: 80,
    name: "المؤمنون",
    surahId: 23,
    text: "بَلۡ قَالُواْ مِثۡلَ مَا قَالَ ٱلۡأَوَّلُونَ",
    translation: "Rather, they say like what the former peoples said",
    normalizedText: "بل قالوا مثل ما قال الاولون",
  },
  {
    verseId: 81,
    name: "المؤمنون",
    surahId: 23,
    text: "قَالُوٓاْ أَءِذَا مِتۡنَا وَكُنَّا تُرَابٗا وَعِظَٰمًا أَءِنَّا لَمَبۡعُوثُونَ",
    translation:
      'They said, "When we have died and become dust and bones, are we indeed to be resurrected',
    normalizedText: "قالوا اءذا متنا وكنا ترابا وعظما اءنا لمبعوثون",
  },
  {
    verseId: 82,
    name: "المؤمنون",
    surahId: 23,
    text: "لَقَدۡ وُعِدۡنَا نَحۡنُ وَءَابَآؤُنَا هَٰذَا مِن قَبۡلُ إِنۡ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      "We have been promised this, we and our forefathers, before; this is not but legends of the former peoples",
    normalizedText:
      "لقد وعدنا نحن وءاباانا هذا من قبل ان هذا الا اسطير الاولين",
  },
  {
    verseId: 83,
    name: "المؤمنون",
    surahId: 23,
    text: "قُل لِّمَنِ ٱلۡأَرۡضُ وَمَن فِيهَآ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      'Say, [O Muhammad], "To whom belongs the earth and whoever is in it, if you should know',
    normalizedText: "قل لمن الارض ومن فيها ان كنتم تعلمون",
  },
  {
    verseId: 84,
    name: "المؤمنون",
    surahId: 23,
    text: "سَيَقُولُونَ لِلَّهِۚ قُلۡ أَفَلَا تَذَكَّرُونَ",
    translation: 'They will say, "To Allah." Say, "Then will you not remember',
    normalizedText: "سيقولون لله قل افلا تذكرون",
  },
  {
    verseId: 85,
    name: "المؤمنون",
    surahId: 23,
    text: "قُلۡ مَن رَّبُّ ٱلسَّمَٰوَٰتِ ٱلسَّبۡعِ وَرَبُّ ٱلۡعَرۡشِ ٱلۡعَظِيمِ",
    translation:
      'Say, "Who is Lord of the seven heavens and Lord of the Great Throne',
    normalizedText: "قل من رب السموت السبع ورب العرش العظيم",
  },
  {
    verseId: 86,
    name: "المؤمنون",
    surahId: 23,
    text: "سَيَقُولُونَ لِلَّهِۚ قُلۡ أَفَلَا تَتَّقُونَ",
    translation:
      'They will say, "[They belong] to Allah." Say, "Then will you not fear Him',
    normalizedText: "سيقولون لله قل افلا تتقون",
  },
  {
    verseId: 87,
    name: "المؤمنون",
    surahId: 23,
    text: "قُلۡ مَنۢ بِيَدِهِۦ مَلَكُوتُ كُلِّ شَيۡءٖ وَهُوَ يُجِيرُ وَلَا يُجَارُ عَلَيۡهِ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      'Say, "In whose hand is the realm of all things - and He protects while none can protect against Him - if you should know',
    normalizedText:
      "قل من بيده ملكوت كل شيء وهو يجير ولا يجار عليه ان كنتم تعلمون",
  },
  {
    verseId: 88,
    name: "المؤمنون",
    surahId: 23,
    text: "سَيَقُولُونَ لِلَّهِۚ قُلۡ فَأَنَّىٰ تُسۡحَرُونَ",
    translation:
      'They will say, "[All belongs] to Allah." Say, "Then how are you deluded',
    normalizedText: "سيقولون لله قل فانى تسحرون",
  },
  {
    verseId: 89,
    name: "المؤمنون",
    surahId: 23,
    text: "بَلۡ أَتَيۡنَٰهُم بِٱلۡحَقِّ وَإِنَّهُمۡ لَكَٰذِبُونَ",
    translation:
      "Rather, We have brought them the truth, and indeed they are liars",
    normalizedText: "بل اتينهم بالحق وانهم لكذبون",
  },
  {
    verseId: 90,
    name: "المؤمنون",
    surahId: 23,
    text: "مَا ٱتَّخَذَ ٱللَّهُ مِن وَلَدٖ وَمَا كَانَ مَعَهُۥ مِنۡ إِلَٰهٍۚ إِذٗا لَّذَهَبَ كُلُّ إِلَٰهِۭ بِمَا خَلَقَ وَلَعَلَا بَعۡضُهُمۡ عَلَىٰ بَعۡضٖۚ سُبۡحَٰنَ ٱللَّهِ عَمَّا يَصِفُونَ",
    translation:
      "Allah has not taken any son, nor has there ever been with Him any deity. [If there had been], then each deity would have taken what it created, and some of them would have sought to overcome others. Exalted is Allah above what they describe [concerning Him]",
    normalizedText:
      "ما اتخذ الله من ولد وما كان معه من اله اذا لذهب كل اله بما خلق ولعلا بعضهم على بعض سبحن الله عما يصفون",
  },
  {
    verseId: 91,
    name: "المؤمنون",
    surahId: 23,
    text: "عَٰلِمِ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ فَتَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      "[He is] Knower of the unseen and the witnessed, so high is He above what they associate [with Him]",
    normalizedText: "علم الغيب والشهدة فتعلى عما يشركون",
  },
  {
    verseId: 92,
    name: "المؤمنون",
    surahId: 23,
    text: "قُل رَّبِّ إِمَّا تُرِيَنِّي مَا يُوعَدُونَ",
    translation:
      'Say, [O Muhammad], "My Lord, if You should show me that which they are promised',
    normalizedText: "قل رب اما تريني ما يوعدون",
  },
  {
    verseId: 93,
    name: "المؤمنون",
    surahId: 23,
    text: "رَبِّ فَلَا تَجۡعَلۡنِي فِي ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation: "My Lord, then do not place me among the wrongdoing people",
    normalizedText: "رب فلا تجعلني في القوم الظلمين",
  },
  {
    verseId: 94,
    name: "المؤمنون",
    surahId: 23,
    text: "وَإِنَّا عَلَىٰٓ أَن نُّرِيَكَ مَا نَعِدُهُمۡ لَقَٰدِرُونَ",
    translation:
      "And indeed, We are able to show you what We have promised them",
    normalizedText: "وانا على ان نريك ما نعدهم لقدرون",
  },
  {
    verseId: 95,
    name: "المؤمنون",
    surahId: 23,
    text: "ٱدۡفَعۡ بِٱلَّتِي هِيَ أَحۡسَنُ ٱلسَّيِّئَةَۚ نَحۡنُ أَعۡلَمُ بِمَا يَصِفُونَ",
    translation:
      "Repel, by [means of] what is best, [their] evil. We are most knowing of what they describe",
    normalizedText: "ادفع بالتي هي احسن السياة نحن اعلم بما يصفون",
  },
  {
    verseId: 96,
    name: "المؤمنون",
    surahId: 23,
    text: "وَقُل رَّبِّ أَعُوذُ بِكَ مِنۡ هَمَزَٰتِ ٱلشَّيَٰطِينِ",
    translation:
      'And say, "My Lord, I seek refuge in You from the incitements of the devils',
    normalizedText: "وقل رب اعوذ بك من همزت الشيطين",
  },
  {
    verseId: 97,
    name: "المؤمنون",
    surahId: 23,
    text: "وَأَعُوذُ بِكَ رَبِّ أَن يَحۡضُرُونِ",
    translation:
      "And I seek refuge in You, my Lord, lest they be present with me",
    normalizedText: "واعوذ بك رب ان يحضرون",
  },
  {
    verseId: 98,
    name: "المؤمنون",
    surahId: 23,
    text: "حَتَّىٰٓ إِذَا جَآءَ أَحَدَهُمُ ٱلۡمَوۡتُ قَالَ رَبِّ ٱرۡجِعُونِ",
    translation:
      '[For such is the state of the disbelievers], until, when death comes to one of them, he says, "My Lord, send me back',
    normalizedText: "حتى اذا جاء احدهم الموت قال رب ارجعون",
  },
  {
    verseId: 99,
    name: "المؤمنون",
    surahId: 23,
    text: "لَعَلِّيٓ أَعۡمَلُ صَٰلِحٗا فِيمَا تَرَكۡتُۚ كَلَّآۚ إِنَّهَا كَلِمَةٌ هُوَ قَآئِلُهَاۖ وَمِن وَرَآئِهِم بَرۡزَخٌ إِلَىٰ يَوۡمِ يُبۡعَثُونَ",
    translation:
      'That I might do righteousness in that which I left behind." No! It is only a word he is saying; and behind them is a barrier until the Day they are resurrected',
    normalizedText:
      "لعلي اعمل صلحا فيما تركت كلا انها كلمة هو قاالها ومن ورااهم برزخ الى يوم يبعثون",
  },
  {
    verseId: 100,
    name: "المؤمنون",
    surahId: 23,
    text: "فَإِذَا نُفِخَ فِي ٱلصُّورِ فَلَآ أَنسَابَ بَيۡنَهُمۡ يَوۡمَئِذٖ وَلَا يَتَسَآءَلُونَ",
    translation:
      "So when the Horn is blown, no relationship will there be among them that Day, nor will they ask about one another",
    normalizedText: "فاذا نفخ في الصور فلا انساب بينهم يوماذ ولا يتساءلون",
  },
  {
    verseId: 101,
    name: "المؤمنون",
    surahId: 23,
    text: "فَمَن ثَقُلَتۡ مَوَٰزِينُهُۥ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "And those whose scales are heavy [with good deeds] - it is they who are the successful",
    normalizedText: "فمن ثقلت موزينه فاولاك هم المفلحون",
  },
  {
    verseId: 102,
    name: "المؤمنون",
    surahId: 23,
    text: "وَمَنۡ خَفَّتۡ مَوَٰزِينُهُۥ فَأُوْلَـٰٓئِكَ ٱلَّذِينَ خَسِرُوٓاْ أَنفُسَهُمۡ فِي جَهَنَّمَ خَٰلِدُونَ",
    translation:
      "But those whose scales are light - those are the ones who have lost their souls, [being] in Hell, abiding eternally",
    normalizedText: "ومن خفت موزينه فاولاك الذين خسروا انفسهم في جهنم خلدون",
  },
  {
    verseId: 103,
    name: "المؤمنون",
    surahId: 23,
    text: "تَلۡفَحُ وُجُوهَهُمُ ٱلنَّارُ وَهُمۡ فِيهَا كَٰلِحُونَ",
    translation:
      "The Fire will sear their faces, and they therein will have taut smiles",
    normalizedText: "تلفح وجوههم النار وهم فيها كلحون",
  },
  {
    verseId: 104,
    name: "المؤمنون",
    surahId: 23,
    text: "أَلَمۡ تَكُنۡ ءَايَٰتِي تُتۡلَىٰ عَلَيۡكُمۡ فَكُنتُم بِهَا تُكَذِّبُونَ",
    translation:
      '[It will be said]. "Were not My verses recited to you and you used to deny them',
    normalizedText: "الم تكن ءايتي تتلى عليكم فكنتم بها تكذبون",
  },
  {
    verseId: 105,
    name: "المؤمنون",
    surahId: 23,
    text: "قَالُواْ رَبَّنَا غَلَبَتۡ عَلَيۡنَا شِقۡوَتُنَا وَكُنَّا قَوۡمٗا ضَآلِّينَ",
    translation:
      'They will say, "Our Lord, our wretchedness overcame us, and we were a people astray',
    normalizedText: "قالوا ربنا غلبت علينا شقوتنا وكنا قوما ضالين",
  },
  {
    verseId: 106,
    name: "المؤمنون",
    surahId: 23,
    text: "رَبَّنَآ أَخۡرِجۡنَا مِنۡهَا فَإِنۡ عُدۡنَا فَإِنَّا ظَٰلِمُونَ",
    translation:
      "Our Lord, remove us from it, and if we were to return [to evil], we would indeed be wrongdoers",
    normalizedText: "ربنا اخرجنا منها فان عدنا فانا ظلمون",
  },
  {
    verseId: 107,
    name: "المؤمنون",
    surahId: 23,
    text: "قَالَ ٱخۡسَـُٔواْ فِيهَا وَلَا تُكَلِّمُونِ",
    translation: 'He will say, "Remain despised therein and do not speak to Me',
    normalizedText: "قال اخسوا فيها ولا تكلمون",
  },
  {
    verseId: 108,
    name: "المؤمنون",
    surahId: 23,
    text: "إِنَّهُۥ كَانَ فَرِيقٞ مِّنۡ عِبَادِي يَقُولُونَ رَبَّنَآ ءَامَنَّا فَٱغۡفِرۡ لَنَا وَٱرۡحَمۡنَا وَأَنتَ خَيۡرُ ٱلرَّـٰحِمِينَ",
    translation:
      "Indeed, there was a party of My servants who said, 'Our Lord, we have believed, so forgive us and have mercy upon us, and You are the best of the merciful",
    normalizedText:
      "انه كان فريق من عبادي يقولون ربنا ءامنا فاغفر لنا وارحمنا وانت خير الرحمين",
  },
  {
    verseId: 109,
    name: "المؤمنون",
    surahId: 23,
    text: "فَٱتَّخَذۡتُمُوهُمۡ سِخۡرِيًّا حَتَّىٰٓ أَنسَوۡكُمۡ ذِكۡرِي وَكُنتُم مِّنۡهُمۡ تَضۡحَكُونَ",
    translation:
      "But you took them in mockery to the point that they made you forget My remembrance, and you used to laugh at them",
    normalizedText: "فاتخذتموهم سخريا حتى انسوكم ذكري وكنتم منهم تضحكون",
  },
  {
    verseId: 110,
    name: "المؤمنون",
    surahId: 23,
    text: "إِنِّي جَزَيۡتُهُمُ ٱلۡيَوۡمَ بِمَا صَبَرُوٓاْ أَنَّهُمۡ هُمُ ٱلۡفَآئِزُونَ",
    translation:
      "Indeed, I have rewarded them this Day for their patient endurance - that they are the attainers [of success]",
    normalizedText: "اني جزيتهم اليوم بما صبروا انهم هم الفاازون",
  },
  {
    verseId: 111,
    name: "المؤمنون",
    surahId: 23,
    text: "قَٰلَ كَمۡ لَبِثۡتُمۡ فِي ٱلۡأَرۡضِ عَدَدَ سِنِينَ",
    translation:
      '[Allah] will say, "How long did you remain on earth in number of years',
    normalizedText: "قل كم لبثتم في الارض عدد سنين",
  },
  {
    verseId: 112,
    name: "المؤمنون",
    surahId: 23,
    text: "قَالُواْ لَبِثۡنَا يَوۡمًا أَوۡ بَعۡضَ يَوۡمٖ فَسۡـَٔلِ ٱلۡعَآدِّينَ",
    translation:
      'They will say, "We remained a day or part of a day; ask those who enumerate',
    normalizedText: "قالوا لبثنا يوما او بعض يوم فسل العادين",
  },
  {
    verseId: 113,
    name: "المؤمنون",
    surahId: 23,
    text: "قَٰلَ إِن لَّبِثۡتُمۡ إِلَّا قَلِيلٗاۖ لَّوۡ أَنَّكُمۡ كُنتُمۡ تَعۡلَمُونَ",
    translation:
      'He will say, "You stayed not but a little - if only you had known',
    normalizedText: "قل ان لبثتم الا قليلا لو انكم كنتم تعلمون",
  },
  {
    verseId: 114,
    name: "المؤمنون",
    surahId: 23,
    text: "أَفَحَسِبۡتُمۡ أَنَّمَا خَلَقۡنَٰكُمۡ عَبَثٗا وَأَنَّكُمۡ إِلَيۡنَا لَا تُرۡجَعُونَ",
    translation:
      "Then did you think that We created you uselessly and that to Us you would not be returned",
    normalizedText: "افحسبتم انما خلقنكم عبثا وانكم الينا لا ترجعون",
  },
  {
    verseId: 115,
    name: "المؤمنون",
    surahId: 23,
    text: "فَتَعَٰلَى ٱللَّهُ ٱلۡمَلِكُ ٱلۡحَقُّۖ لَآ إِلَٰهَ إِلَّا هُوَ رَبُّ ٱلۡعَرۡشِ ٱلۡكَرِيمِ",
    translation:
      "So exalted is Allah, the Sovereign, the Truth; there is no deity except Him, Lord of the Noble Throne",
    normalizedText: "فتعلى الله الملك الحق لا اله الا هو رب العرش الكريم",
  },
  {
    verseId: 116,
    name: "المؤمنون",
    surahId: 23,
    text: "وَمَن يَدۡعُ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ لَا بُرۡهَٰنَ لَهُۥ بِهِۦ فَإِنَّمَا حِسَابُهُۥ عِندَ رَبِّهِۦٓۚ إِنَّهُۥ لَا يُفۡلِحُ ٱلۡكَٰفِرُونَ",
    translation:
      "And whoever invokes besides Allah another deity for which he has no proof - then his account is only with his Lord. Indeed, the disbelievers will not succeed",
    normalizedText:
      "ومن يدع مع الله الها ءاخر لا برهن له به فانما حسابه عند ربه انه لا يفلح الكفرون",
  },
  {
    verseId: 117,
    name: "المؤمنون",
    surahId: 23,
    text: "وَقُل رَّبِّ ٱغۡفِرۡ وَٱرۡحَمۡ وَأَنتَ خَيۡرُ ٱلرَّـٰحِمِينَ",
    translation:
      'And, [O Muhammad], say, "My Lord, forgive and have mercy, and You are the best of the merciful',
    normalizedText: "وقل رب اغفر وارحم وانت خير الرحمين",
  },
  {
    verseId: 0,
    name: "النور",
    surahId: 24,
    text: "سُورَةٌ أَنزَلۡنَٰهَا وَفَرَضۡنَٰهَا وَأَنزَلۡنَا فِيهَآ ءَايَٰتِۭ بَيِّنَٰتٖ لَّعَلَّكُمۡ تَذَكَّرُونَ",
    translation:
      "[This is] a surah which We have sent down and made [that within it] obligatory and revealed therein verses of clear evidence that you might remember",
    normalizedText: "سورة انزلنها وفرضنها وانزلنا فيها ءايت بينت لعلكم تذكرون",
  },
  {
    verseId: 1,
    name: "النور",
    surahId: 24,
    text: "ٱلزَّانِيَةُ وَٱلزَّانِي فَٱجۡلِدُواْ كُلَّ وَٰحِدٖ مِّنۡهُمَا مِاْئَةَ جَلۡدَةٖۖ وَلَا تَأۡخُذۡكُم بِهِمَا رَأۡفَةٞ فِي دِينِ ٱللَّهِ إِن كُنتُمۡ تُؤۡمِنُونَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِۖ وَلۡيَشۡهَدۡ عَذَابَهُمَا طَآئِفَةٞ مِّنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "The [unmarried] woman or [unmarried] man found guilty of sexual intercourse - lash each one of them with a hundred lashes, and do not be taken by pity for them in the religion of Allah, if you should believe in Allah and the Last Day. And let a group of the believers witness their punishment",
    normalizedText:
      "الزانية والزاني فاجلدوا كل وحد منهما مااة جلدة ولا تاخذكم بهما رافة في دين الله ان كنتم تامنون بالله واليوم الاخر وليشهد عذابهما طاافة من المامنين",
  },
  {
    verseId: 2,
    name: "النور",
    surahId: 24,
    text: "ٱلزَّانِي لَا يَنكِحُ إِلَّا زَانِيَةً أَوۡ مُشۡرِكَةٗ وَٱلزَّانِيَةُ لَا يَنكِحُهَآ إِلَّا زَانٍ أَوۡ مُشۡرِكٞۚ وَحُرِّمَ ذَٰلِكَ عَلَى ٱلۡمُؤۡمِنِينَ",
    translation:
      "The fornicator does not marry except a [female] fornicator or polytheist, and none marries her except a fornicator or a polytheist, and that has been made unlawful to the believers",
    normalizedText:
      "الزاني لا ينكح الا زانية او مشركة والزانية لا ينكحها الا زان او مشرك وحرم ذلك على المامنين",
  },
  {
    verseId: 3,
    name: "النور",
    surahId: 24,
    text: "وَٱلَّذِينَ يَرۡمُونَ ٱلۡمُحۡصَنَٰتِ ثُمَّ لَمۡ يَأۡتُواْ بِأَرۡبَعَةِ شُهَدَآءَ فَٱجۡلِدُوهُمۡ ثَمَٰنِينَ جَلۡدَةٗ وَلَا تَقۡبَلُواْ لَهُمۡ شَهَٰدَةً أَبَدٗاۚ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡفَٰسِقُونَ",
    translation:
      "And those who accuse chaste women and then do not produce four witnesses - lash them with eighty lashes and do not accept from them testimony ever after. And those are the defiantly disobedient",
    normalizedText:
      "والذين يرمون المحصنت ثم لم ياتوا باربعة شهداء فاجلدوهم ثمنين جلدة ولا تقبلوا لهم شهدة ابدا واولاك هم الفسقون",
  },
  {
    verseId: 4,
    name: "النور",
    surahId: 24,
    text: "إِلَّا ٱلَّذِينَ تَابُواْ مِنۢ بَعۡدِ ذَٰلِكَ وَأَصۡلَحُواْ فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "Except for those who repent thereafter and reform, for indeed, Allah is Forgiving and Merciful",
    normalizedText: "الا الذين تابوا من بعد ذلك واصلحوا فان الله غفور رحيم",
  },
  {
    verseId: 5,
    name: "النور",
    surahId: 24,
    text: "وَٱلَّذِينَ يَرۡمُونَ أَزۡوَٰجَهُمۡ وَلَمۡ يَكُن لَّهُمۡ شُهَدَآءُ إِلَّآ أَنفُسُهُمۡ فَشَهَٰدَةُ أَحَدِهِمۡ أَرۡبَعُ شَهَٰدَٰتِۭ بِٱللَّهِ إِنَّهُۥ لَمِنَ ٱلصَّـٰدِقِينَ",
    translation:
      "And those who accuse their wives [of adultery] and have no witnesses except themselves - then the witness of one of them [shall be] four testimonies [swearing] by Allah that indeed, he is of the truthful",
    normalizedText:
      "والذين يرمون ازوجهم ولم يكن لهم شهداء الا انفسهم فشهدة احدهم اربع شهدت بالله انه لمن الصدقين",
  },
  {
    verseId: 6,
    name: "النور",
    surahId: 24,
    text: "وَٱلۡخَٰمِسَةُ أَنَّ لَعۡنَتَ ٱللَّهِ عَلَيۡهِ إِن كَانَ مِنَ ٱلۡكَٰذِبِينَ",
    translation:
      "And the fifth [oath will be] that the curse of Allah be upon him if he should be among the liars",
    normalizedText: "والخمسة ان لعنت الله عليه ان كان من الكذبين",
  },
  {
    verseId: 7,
    name: "النور",
    surahId: 24,
    text: "وَيَدۡرَؤُاْ عَنۡهَا ٱلۡعَذَابَ أَن تَشۡهَدَ أَرۡبَعَ شَهَٰدَٰتِۭ بِٱللَّهِ إِنَّهُۥ لَمِنَ ٱلۡكَٰذِبِينَ",
    translation:
      "But it will prevent punishment from her if she gives four testimonies [swearing] by Allah that indeed, he is of the liars",
    normalizedText:
      "ويدراا عنها العذاب ان تشهد اربع شهدت بالله انه لمن الكذبين",
  },
  {
    verseId: 8,
    name: "النور",
    surahId: 24,
    text: "وَٱلۡخَٰمِسَةَ أَنَّ غَضَبَ ٱللَّهِ عَلَيۡهَآ إِن كَانَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      "And the fifth [oath will be] that the wrath of Allah be upon her if he was of the truthful",
    normalizedText: "والخمسة ان غضب الله عليها ان كان من الصدقين",
  },
  {
    verseId: 9,
    name: "النور",
    surahId: 24,
    text: "وَلَوۡلَا فَضۡلُ ٱللَّهِ عَلَيۡكُمۡ وَرَحۡمَتُهُۥ وَأَنَّ ٱللَّهَ تَوَّابٌ حَكِيمٌ",
    translation:
      "And if not for the favor of Allah upon you and His mercy... and because Allah is Accepting of repentance and Wise",
    normalizedText: "ولولا فضل الله عليكم ورحمته وان الله تواب حكيم",
  },
  {
    verseId: 10,
    name: "النور",
    surahId: 24,
    text: "إِنَّ ٱلَّذِينَ جَآءُو بِٱلۡإِفۡكِ عُصۡبَةٞ مِّنكُمۡۚ لَا تَحۡسَبُوهُ شَرّٗا لَّكُمۖ بَلۡ هُوَ خَيۡرٞ لَّكُمۡۚ لِكُلِّ ٱمۡرِيٕٖ مِّنۡهُم مَّا ٱكۡتَسَبَ مِنَ ٱلۡإِثۡمِۚ وَٱلَّذِي تَوَلَّىٰ كِبۡرَهُۥ مِنۡهُمۡ لَهُۥ عَذَابٌ عَظِيمٞ",
    translation:
      "Indeed, those who came with falsehood are a group among you. Do not think it bad for you; rather it is good for you. For every person among them is what [punishment] he has earned from the sin, and he who took upon himself the greater portion thereof - for him is a great punishment",
    normalizedText:
      "ان الذين جاءو بالافك عصبة منكم لا تحسبوه شرا لكم بل هو خير لكم لكل امري منهم ما اكتسب من الاثم والذي تولى كبره منهم له عذاب عظيم",
  },
  {
    verseId: 11,
    name: "النور",
    surahId: 24,
    text: "لَّوۡلَآ إِذۡ سَمِعۡتُمُوهُ ظَنَّ ٱلۡمُؤۡمِنُونَ وَٱلۡمُؤۡمِنَٰتُ بِأَنفُسِهِمۡ خَيۡرٗا وَقَالُواْ هَٰذَآ إِفۡكٞ مُّبِينٞ",
    translation:
      'Why, when you heard it, did not the believing men and believing women think good of one another and say, "This is an obvious falsehood',
    normalizedText:
      "لولا اذ سمعتموه ظن المامنون والمامنت بانفسهم خيرا وقالوا هذا افك مبين",
  },
  {
    verseId: 12,
    name: "النور",
    surahId: 24,
    text: "لَّوۡلَا جَآءُو عَلَيۡهِ بِأَرۡبَعَةِ شُهَدَآءَۚ فَإِذۡ لَمۡ يَأۡتُواْ بِٱلشُّهَدَآءِ فَأُوْلَـٰٓئِكَ عِندَ ٱللَّهِ هُمُ ٱلۡكَٰذِبُونَ",
    translation:
      "Why did they [who slandered] not produce for it four witnesses? And when they do not produce the witnesses, then it is they, in the sight of Allah, who are the liars",
    normalizedText:
      "لولا جاءو عليه باربعة شهداء فاذ لم ياتوا بالشهداء فاولاك عند الله هم الكذبون",
  },
  {
    verseId: 13,
    name: "النور",
    surahId: 24,
    text: "وَلَوۡلَا فَضۡلُ ٱللَّهِ عَلَيۡكُمۡ وَرَحۡمَتُهُۥ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِ لَمَسَّكُمۡ فِي مَآ أَفَضۡتُمۡ فِيهِ عَذَابٌ عَظِيمٌ",
    translation:
      "And if it had not been for the favor of Allah upon you and His mercy in this world and the Hereafter, you would have been touched for that [lie] in which you were involved by a great punishment",
    normalizedText:
      "ولولا فضل الله عليكم ورحمته في الدنيا والاخرة لمسكم في ما افضتم فيه عذاب عظيم",
  },
  {
    verseId: 14,
    name: "النور",
    surahId: 24,
    text: "إِذۡ تَلَقَّوۡنَهُۥ بِأَلۡسِنَتِكُمۡ وَتَقُولُونَ بِأَفۡوَاهِكُم مَّا لَيۡسَ لَكُم بِهِۦ عِلۡمٞ وَتَحۡسَبُونَهُۥ هَيِّنٗا وَهُوَ عِندَ ٱللَّهِ عَظِيمٞ",
    translation:
      "When you received it with your tongues and said with your mouths that of which you had no knowledge and thought it was insignificant while it was, in the sight of Allah, tremendous",
    normalizedText:
      "اذ تلقونه بالسنتكم وتقولون بافواهكم ما ليس لكم به علم وتحسبونه هينا وهو عند الله عظيم",
  },
  {
    verseId: 15,
    name: "النور",
    surahId: 24,
    text: "وَلَوۡلَآ إِذۡ سَمِعۡتُمُوهُ قُلۡتُم مَّا يَكُونُ لَنَآ أَن نَّتَكَلَّمَ بِهَٰذَا سُبۡحَٰنَكَ هَٰذَا بُهۡتَٰنٌ عَظِيمٞ",
    translation:
      'And why, when you heard it, did you not say, "It is not for us to speak of this. Exalted are You, [O Allah]; this is a great slander',
    normalizedText:
      "ولولا اذ سمعتموه قلتم ما يكون لنا ان نتكلم بهذا سبحنك هذا بهتن عظيم",
  },
  {
    verseId: 16,
    name: "النور",
    surahId: 24,
    text: "يَعِظُكُمُ ٱللَّهُ أَن تَعُودُواْ لِمِثۡلِهِۦٓ أَبَدًا إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "Allah warns you against returning to the likes of this [conduct], ever, if you should be believers",
    normalizedText: "يعظكم الله ان تعودوا لمثله ابدا ان كنتم مامنين",
  },
  {
    verseId: 17,
    name: "النور",
    surahId: 24,
    text: "وَيُبَيِّنُ ٱللَّهُ لَكُمُ ٱلۡأٓيَٰتِۚ وَٱللَّهُ عَلِيمٌ حَكِيمٌ",
    translation:
      "And Allah makes clear to you the verses, and Allah is Knowing and Wise",
    normalizedText: "ويبين الله لكم الايت والله عليم حكيم",
  },
  {
    verseId: 18,
    name: "النور",
    surahId: 24,
    text: "إِنَّ ٱلَّذِينَ يُحِبُّونَ أَن تَشِيعَ ٱلۡفَٰحِشَةُ فِي ٱلَّذِينَ ءَامَنُواْ لَهُمۡ عَذَابٌ أَلِيمٞ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِۚ وَٱللَّهُ يَعۡلَمُ وَأَنتُمۡ لَا تَعۡلَمُونَ",
    translation:
      "Indeed, those who like that immorality should be spread [or publicized] among those who have believed will have a painful punishment in this world and the Hereafter. And Allah knows and you do not know",
    normalizedText:
      "ان الذين يحبون ان تشيع الفحشة في الذين ءامنوا لهم عذاب اليم في الدنيا والاخرة والله يعلم وانتم لا تعلمون",
  },
  {
    verseId: 19,
    name: "النور",
    surahId: 24,
    text: "وَلَوۡلَا فَضۡلُ ٱللَّهِ عَلَيۡكُمۡ وَرَحۡمَتُهُۥ وَأَنَّ ٱللَّهَ رَءُوفٞ رَّحِيمٞ",
    translation:
      "And if it had not been for the favor of Allah upon you and His mercy... and because Allah is Kind and Merciful",
    normalizedText: "ولولا فضل الله عليكم ورحمته وان الله رءوف رحيم",
  },
  {
    verseId: 20,
    name: "النور",
    surahId: 24,
    text: "۞يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّبِعُواْ خُطُوَٰتِ ٱلشَّيۡطَٰنِۚ وَمَن يَتَّبِعۡ خُطُوَٰتِ ٱلشَّيۡطَٰنِ فَإِنَّهُۥ يَأۡمُرُ بِٱلۡفَحۡشَآءِ وَٱلۡمُنكَرِۚ وَلَوۡلَا فَضۡلُ ٱللَّهِ عَلَيۡكُمۡ وَرَحۡمَتُهُۥ مَا زَكَىٰ مِنكُم مِّنۡ أَحَدٍ أَبَدٗا وَلَٰكِنَّ ٱللَّهَ يُزَكِّي مَن يَشَآءُۗ وَٱللَّهُ سَمِيعٌ عَلِيمٞ",
    translation:
      "O you who have believed, do not follow the footsteps of Satan. And whoever follows the footsteps of Satan - indeed, he enjoins immorality and wrongdoing. And if not for the favor of Allah upon you and His mercy, not one of you would have been pure, ever, but Allah purifies whom He wills, and Allah is Hearing and Knowing",
    normalizedText:
      "۞يايها الذين ءامنوا لا تتبعوا خطوت الشيطن ومن يتبع خطوت الشيطن فانه يامر بالفحشاء والمنكر ولولا فضل الله عليكم ورحمته ما زكى منكم من احد ابدا ولكن الله يزكي من يشاء والله سميع عليم",
  },
  {
    verseId: 21,
    name: "النور",
    surahId: 24,
    text: "وَلَا يَأۡتَلِ أُوْلُواْ ٱلۡفَضۡلِ مِنكُمۡ وَٱلسَّعَةِ أَن يُؤۡتُوٓاْ أُوْلِي ٱلۡقُرۡبَىٰ وَٱلۡمَسَٰكِينَ وَٱلۡمُهَٰجِرِينَ فِي سَبِيلِ ٱللَّهِۖ وَلۡيَعۡفُواْ وَلۡيَصۡفَحُوٓاْۗ أَلَا تُحِبُّونَ أَن يَغۡفِرَ ٱللَّهُ لَكُمۡۚ وَٱللَّهُ غَفُورٞ رَّحِيمٌ",
    translation:
      "And let not those of virtue among you and wealth swear not to give [aid] to their relatives and the needy and the emigrants for the cause of Allah, and let them pardon and overlook. Would you not like that Allah should forgive you? And Allah is Forgiving and Merciful",
    normalizedText:
      "ولا ياتل اولوا الفضل منكم والسعة ان ياتوا اولي القربى والمسكين والمهجرين في سبيل الله وليعفوا وليصفحوا الا تحبون ان يغفر الله لكم والله غفور رحيم",
  },
  {
    verseId: 22,
    name: "النور",
    surahId: 24,
    text: "إِنَّ ٱلَّذِينَ يَرۡمُونَ ٱلۡمُحۡصَنَٰتِ ٱلۡغَٰفِلَٰتِ ٱلۡمُؤۡمِنَٰتِ لُعِنُواْ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِ وَلَهُمۡ عَذَابٌ عَظِيمٞ",
    translation:
      "Indeed, those who [falsely] accuse chaste, unaware and believing women are cursed in this world and the Hereafter; and they will have a great punishment",
    normalizedText:
      "ان الذين يرمون المحصنت الغفلت المامنت لعنوا في الدنيا والاخرة ولهم عذاب عظيم",
  },
  {
    verseId: 23,
    name: "النور",
    surahId: 24,
    text: "يَوۡمَ تَشۡهَدُ عَلَيۡهِمۡ أَلۡسِنَتُهُمۡ وَأَيۡدِيهِمۡ وَأَرۡجُلُهُم بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "On a Day when their tongues, their hands and their feet will bear witness against them as to what they used to do",
    normalizedText: "يوم تشهد عليهم السنتهم وايديهم وارجلهم بما كانوا يعملون",
  },
  {
    verseId: 24,
    name: "النور",
    surahId: 24,
    text: "يَوۡمَئِذٖ يُوَفِّيهِمُ ٱللَّهُ دِينَهُمُ ٱلۡحَقَّ وَيَعۡلَمُونَ أَنَّ ٱللَّهَ هُوَ ٱلۡحَقُّ ٱلۡمُبِينُ",
    translation:
      "That Day, Allah will pay them in full their deserved recompense, and they will know that it is Allah who is the perfect in justice",
    normalizedText:
      "يوماذ يوفيهم الله دينهم الحق ويعلمون ان الله هو الحق المبين",
  },
  {
    verseId: 25,
    name: "النور",
    surahId: 24,
    text: "ٱلۡخَبِيثَٰتُ لِلۡخَبِيثِينَ وَٱلۡخَبِيثُونَ لِلۡخَبِيثَٰتِۖ وَٱلطَّيِّبَٰتُ لِلطَّيِّبِينَ وَٱلطَّيِّبُونَ لِلطَّيِّبَٰتِۚ أُوْلَـٰٓئِكَ مُبَرَّءُونَ مِمَّا يَقُولُونَۖ لَهُم مَّغۡفِرَةٞ وَرِزۡقٞ كَرِيمٞ",
    translation:
      "Evil words are for evil men, and evil men are [subjected] to evil words. And good words are for good men, and good men are [an object] of good words. Those [good people] are declared innocent of what the slanderers say. For them is forgiveness and noble provision",
    normalizedText:
      "الخبيثت للخبيثين والخبيثون للخبيثت والطيبت للطيبين والطيبون للطيبت اولاك مبرءون مما يقولون لهم مغفرة ورزق كريم",
  },
  {
    verseId: 26,
    name: "النور",
    surahId: 24,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَدۡخُلُواْ بُيُوتًا غَيۡرَ بُيُوتِكُمۡ حَتَّىٰ تَسۡتَأۡنِسُواْ وَتُسَلِّمُواْ عَلَىٰٓ أَهۡلِهَاۚ ذَٰلِكُمۡ خَيۡرٞ لَّكُمۡ لَعَلَّكُمۡ تَذَكَّرُونَ",
    translation:
      "O you who have believed, do not enter houses other than your own houses until you ascertain welcome and greet their inhabitants. That is best for you; perhaps you will be reminded",
    normalizedText:
      "يايها الذين ءامنوا لا تدخلوا بيوتا غير بيوتكم حتى تستانسوا وتسلموا على اهلها ذلكم خير لكم لعلكم تذكرون",
  },
  {
    verseId: 27,
    name: "النور",
    surahId: 24,
    text: "فَإِن لَّمۡ تَجِدُواْ فِيهَآ أَحَدٗا فَلَا تَدۡخُلُوهَا حَتَّىٰ يُؤۡذَنَ لَكُمۡۖ وَإِن قِيلَ لَكُمُ ٱرۡجِعُواْ فَٱرۡجِعُواْۖ هُوَ أَزۡكَىٰ لَكُمۡۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ عَلِيمٞ",
    translation:
      'And if you do not find anyone therein, do not enter them until permission has been given you. And if it is said to you, "Go back," then go back; it is purer for you. And Allah is Knowing of what you do',
    normalizedText:
      "فان لم تجدوا فيها احدا فلا تدخلوها حتى ياذن لكم وان قيل لكم ارجعوا فارجعوا هو ازكى لكم والله بما تعملون عليم",
  },
  {
    verseId: 28,
    name: "النور",
    surahId: 24,
    text: "لَّيۡسَ عَلَيۡكُمۡ جُنَاحٌ أَن تَدۡخُلُواْ بُيُوتًا غَيۡرَ مَسۡكُونَةٖ فِيهَا مَتَٰعٞ لَّكُمۡۚ وَٱللَّهُ يَعۡلَمُ مَا تُبۡدُونَ وَمَا تَكۡتُمُونَ",
    translation:
      "There is no blame upon you for entering houses not inhabited in which there is convenience for you. And Allah knows what you reveal and what you conceal",
    normalizedText:
      "ليس عليكم جناح ان تدخلوا بيوتا غير مسكونة فيها متع لكم والله يعلم ما تبدون وما تكتمون",
  },
  {
    verseId: 29,
    name: "النور",
    surahId: 24,
    text: "قُل لِّلۡمُؤۡمِنِينَ يَغُضُّواْ مِنۡ أَبۡصَٰرِهِمۡ وَيَحۡفَظُواْ فُرُوجَهُمۡۚ ذَٰلِكَ أَزۡكَىٰ لَهُمۡۚ إِنَّ ٱللَّهَ خَبِيرُۢ بِمَا يَصۡنَعُونَ",
    translation:
      "Tell the believing men to reduce [some] of their vision and guard their private parts. That is purer for them. Indeed, Allah is Acquainted with what they do",
    normalizedText:
      "قل للمامنين يغضوا من ابصرهم ويحفظوا فروجهم ذلك ازكى لهم ان الله خبير بما يصنعون",
  },
  {
    verseId: 30,
    name: "النور",
    surahId: 24,
    text: "وَقُل لِّلۡمُؤۡمِنَٰتِ يَغۡضُضۡنَ مِنۡ أَبۡصَٰرِهِنَّ وَيَحۡفَظۡنَ فُرُوجَهُنَّ وَلَا يُبۡدِينَ زِينَتَهُنَّ إِلَّا مَا ظَهَرَ مِنۡهَاۖ وَلۡيَضۡرِبۡنَ بِخُمُرِهِنَّ عَلَىٰ جُيُوبِهِنَّۖ وَلَا يُبۡدِينَ زِينَتَهُنَّ إِلَّا لِبُعُولَتِهِنَّ أَوۡ ءَابَآئِهِنَّ أَوۡ ءَابَآءِ بُعُولَتِهِنَّ أَوۡ أَبۡنَآئِهِنَّ أَوۡ أَبۡنَآءِ بُعُولَتِهِنَّ أَوۡ إِخۡوَٰنِهِنَّ أَوۡ بَنِيٓ إِخۡوَٰنِهِنَّ أَوۡ بَنِيٓ أَخَوَٰتِهِنَّ أَوۡ نِسَآئِهِنَّ أَوۡ مَا مَلَكَتۡ أَيۡمَٰنُهُنَّ أَوِ ٱلتَّـٰبِعِينَ غَيۡرِ أُوْلِي ٱلۡإِرۡبَةِ مِنَ ٱلرِّجَالِ أَوِ ٱلطِّفۡلِ ٱلَّذِينَ لَمۡ يَظۡهَرُواْ عَلَىٰ عَوۡرَٰتِ ٱلنِّسَآءِۖ وَلَا يَضۡرِبۡنَ بِأَرۡجُلِهِنَّ لِيُعۡلَمَ مَا يُخۡفِينَ مِن زِينَتِهِنَّۚ وَتُوبُوٓاْ إِلَى ٱللَّهِ جَمِيعًا أَيُّهَ ٱلۡمُؤۡمِنُونَ لَعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "And tell the believing women to reduce [some] of their vision and guard their private parts and not expose their adornment except that which [necessarily] appears thereof and to wrap [a portion of] their headcovers over their chests and not expose their adornment except to their husbands, their fathers, their husbands' fathers, their sons, their husbands' sons, their brothers, their brothers' sons, their sisters' sons, their women, that which their right hands possess, or those male attendants having no physical desire, or children who are not yet aware of the private aspects of women. And let them not stamp their feet to make known what they conceal of their adornment. And turn to Allah in repentance, all of you, O believers, that you might succeed",
    normalizedText:
      "وقل للمامنت يغضضن من ابصرهن ويحفظن فروجهن ولا يبدين زينتهن الا ما ظهر منها وليضربن بخمرهن على جيوبهن ولا يبدين زينتهن الا لبعولتهن او ءابااهن او ءاباء بعولتهن او ابنااهن او ابناء بعولتهن او اخونهن او بني اخونهن او بني اخوتهن او نسااهن او ما ملكت ايمنهن او التبعين غير اولي الاربة من الرجال او الطفل الذين لم يظهروا على عورت النساء ولا يضربن بارجلهن ليعلم ما يخفين من زينتهن وتوبوا الى الله جميعا ايه المامنون لعلكم تفلحون",
  },
  {
    verseId: 31,
    name: "النور",
    surahId: 24,
    text: "وَأَنكِحُواْ ٱلۡأَيَٰمَىٰ مِنكُمۡ وَٱلصَّـٰلِحِينَ مِنۡ عِبَادِكُمۡ وَإِمَآئِكُمۡۚ إِن يَكُونُواْ فُقَرَآءَ يُغۡنِهِمُ ٱللَّهُ مِن فَضۡلِهِۦۗ وَٱللَّهُ وَٰسِعٌ عَلِيمٞ",
    translation:
      "And marry the unmarried among you and the righteous among your male slaves and female slaves. If they should be poor, Allah will enrich them from His bounty, and Allah is all-Encompassing and Knowing",
    normalizedText:
      "وانكحوا الايمى منكم والصلحين من عبادكم وامااكم ان يكونوا فقراء يغنهم الله من فضله والله وسع عليم",
  },
  {
    verseId: 32,
    name: "النور",
    surahId: 24,
    text: "وَلۡيَسۡتَعۡفِفِ ٱلَّذِينَ لَا يَجِدُونَ نِكَاحًا حَتَّىٰ يُغۡنِيَهُمُ ٱللَّهُ مِن فَضۡلِهِۦۗ وَٱلَّذِينَ يَبۡتَغُونَ ٱلۡكِتَٰبَ مِمَّا مَلَكَتۡ أَيۡمَٰنُكُمۡ فَكَاتِبُوهُمۡ إِنۡ عَلِمۡتُمۡ فِيهِمۡ خَيۡرٗاۖ وَءَاتُوهُم مِّن مَّالِ ٱللَّهِ ٱلَّذِيٓ ءَاتَىٰكُمۡۚ وَلَا تُكۡرِهُواْ فَتَيَٰتِكُمۡ عَلَى ٱلۡبِغَآءِ إِنۡ أَرَدۡنَ تَحَصُّنٗا لِّتَبۡتَغُواْ عَرَضَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۚ وَمَن يُكۡرِههُّنَّ فَإِنَّ ٱللَّهَ مِنۢ بَعۡدِ إِكۡرَٰهِهِنَّ غَفُورٞ رَّحِيمٞ",
    translation:
      "But let them who find not [the means for] marriage abstain [from sexual relations] until Allah enriches them from His bounty. And those who seek a contract [for eventual emancipation] from among whom your right hands possess - then make a contract with them if you know there is within them goodness and give them from the wealth of Allah which He has given you. And do not compel your slave girls to prostitution, if they desire chastity, to seek [thereby] the temporary interests of worldly life. And if someone should compel them, then indeed, Allah is [to them], after their compulsion, Forgiving and Merciful",
    normalizedText:
      "وليستعفف الذين لا يجدون نكاحا حتى يغنيهم الله من فضله والذين يبتغون الكتب مما ملكت ايمنكم فكاتبوهم ان علمتم فيهم خيرا وءاتوهم من مال الله الذي ءاتىكم ولا تكرهوا فتيتكم على البغاء ان اردن تحصنا لتبتغوا عرض الحيوة الدنيا ومن يكرههن فان الله من بعد اكرههن غفور رحيم",
  },
  {
    verseId: 33,
    name: "النور",
    surahId: 24,
    text: "وَلَقَدۡ أَنزَلۡنَآ إِلَيۡكُمۡ ءَايَٰتٖ مُّبَيِّنَٰتٖ وَمَثَلٗا مِّنَ ٱلَّذِينَ خَلَوۡاْ مِن قَبۡلِكُمۡ وَمَوۡعِظَةٗ لِّلۡمُتَّقِينَ",
    translation:
      "And We have certainly sent down to you distinct verses and examples from those who passed on before you and an admonition for those who fear Allah",
    normalizedText:
      "ولقد انزلنا اليكم ءايت مبينت ومثلا من الذين خلوا من قبلكم وموعظة للمتقين",
  },
  {
    verseId: 34,
    name: "النور",
    surahId: 24,
    text: "۞ٱللَّهُ نُورُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ مَثَلُ نُورِهِۦ كَمِشۡكَوٰةٖ فِيهَا مِصۡبَاحٌۖ ٱلۡمِصۡبَاحُ فِي زُجَاجَةٍۖ ٱلزُّجَاجَةُ كَأَنَّهَا كَوۡكَبٞ دُرِّيّٞ يُوقَدُ مِن شَجَرَةٖ مُّبَٰرَكَةٖ زَيۡتُونَةٖ لَّا شَرۡقِيَّةٖ وَلَا غَرۡبِيَّةٖ يَكَادُ زَيۡتُهَا يُضِيٓءُ وَلَوۡ لَمۡ تَمۡسَسۡهُ نَارٞۚ نُّورٌ عَلَىٰ نُورٖۚ يَهۡدِي ٱللَّهُ لِنُورِهِۦ مَن يَشَآءُۚ وَيَضۡرِبُ ٱللَّهُ ٱلۡأَمۡثَٰلَ لِلنَّاسِۗ وَٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "Allah is the Light of the heavens and the earth. The example of His light is like a niche within which is a lamp, the lamp is within glass, the glass as if it were a pearly [white] star lit from [the oil of] a blessed olive tree, neither of the east nor of the west, whose oil would almost glow even if untouched by fire. Light upon light. Allah guides to His light whom He wills. And Allah presents examples for the people, and Allah is Knowing of all things",
    normalizedText:
      "۞الله نور السموت والارض مثل نوره كمشكوة فيها مصباح المصباح في زجاجة الزجاجة كانها كوكب دري يوقد من شجرة مبركة زيتونة لا شرقية ولا غربية يكاد زيتها يضيء ولو لم تمسسه نار نور على نور يهدي الله لنوره من يشاء ويضرب الله الامثل للناس والله بكل شيء عليم",
  },
  {
    verseId: 35,
    name: "النور",
    surahId: 24,
    text: "فِي بُيُوتٍ أَذِنَ ٱللَّهُ أَن تُرۡفَعَ وَيُذۡكَرَ فِيهَا ٱسۡمُهُۥ يُسَبِّحُ لَهُۥ فِيهَا بِٱلۡغُدُوِّ وَٱلۡأٓصَالِ",
    translation:
      "[Such niches are] in mosques which Allah has ordered to be raised and that His name be mentioned therein; exalting Him within them in the morning and the evenings",
    normalizedText:
      "في بيوت اذن الله ان ترفع ويذكر فيها اسمه يسبح له فيها بالغدو والاصال",
  },
  {
    verseId: 36,
    name: "النور",
    surahId: 24,
    text: "رِجَالٞ لَّا تُلۡهِيهِمۡ تِجَٰرَةٞ وَلَا بَيۡعٌ عَن ذِكۡرِ ٱللَّهِ وَإِقَامِ ٱلصَّلَوٰةِ وَإِيتَآءِ ٱلزَّكَوٰةِ يَخَافُونَ يَوۡمٗا تَتَقَلَّبُ فِيهِ ٱلۡقُلُوبُ وَٱلۡأَبۡصَٰرُ",
    translation:
      "[Are] men whom neither commerce nor sale distracts from the remembrance of Allah and performance of prayer and giving of zakah. They fear a Day in which the hearts and eyes will [fearfully] turn about",
    normalizedText:
      "رجال لا تلهيهم تجرة ولا بيع عن ذكر الله واقام الصلوة وايتاء الزكوة يخافون يوما تتقلب فيه القلوب والابصر",
  },
  {
    verseId: 37,
    name: "النور",
    surahId: 24,
    text: "لِيَجۡزِيَهُمُ ٱللَّهُ أَحۡسَنَ مَا عَمِلُواْ وَيَزِيدَهُم مِّن فَضۡلِهِۦۗ وَٱللَّهُ يَرۡزُقُ مَن يَشَآءُ بِغَيۡرِ حِسَابٖ",
    translation:
      "That Allah may reward them [according to] the best of what they did and increase them from His bounty. And Allah gives provision to whom He wills without account",
    normalizedText:
      "ليجزيهم الله احسن ما عملوا ويزيدهم من فضله والله يرزق من يشاء بغير حساب",
  },
  {
    verseId: 38,
    name: "النور",
    surahId: 24,
    text: "وَٱلَّذِينَ كَفَرُوٓاْ أَعۡمَٰلُهُمۡ كَسَرَابِۭ بِقِيعَةٖ يَحۡسَبُهُ ٱلظَّمۡـَٔانُ مَآءً حَتَّىٰٓ إِذَا جَآءَهُۥ لَمۡ يَجِدۡهُ شَيۡـٔٗا وَوَجَدَ ٱللَّهَ عِندَهُۥ فَوَفَّىٰهُ حِسَابَهُۥۗ وَٱللَّهُ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      "But those who disbelieved - their deeds are like a mirage in a lowland which a thirsty one thinks is water until, when he comes to it, he finds it is nothing but finds Allah before Him, and He will pay him in full his due; and Allah is swift in account",
    normalizedText:
      "والذين كفروا اعملهم كسراب بقيعة يحسبه الظمان ماء حتى اذا جاءه لم يجده شيا ووجد الله عنده فوفىه حسابه والله سريع الحساب",
  },
  {
    verseId: 39,
    name: "النور",
    surahId: 24,
    text: "أَوۡ كَظُلُمَٰتٖ فِي بَحۡرٖ لُّجِّيّٖ يَغۡشَىٰهُ مَوۡجٞ مِّن فَوۡقِهِۦ مَوۡجٞ مِّن فَوۡقِهِۦ سَحَابٞۚ ظُلُمَٰتُۢ بَعۡضُهَا فَوۡقَ بَعۡضٍ إِذَآ أَخۡرَجَ يَدَهُۥ لَمۡ يَكَدۡ يَرَىٰهَاۗ وَمَن لَّمۡ يَجۡعَلِ ٱللَّهُ لَهُۥ نُورٗا فَمَا لَهُۥ مِن نُّورٍ",
    translation:
      "Or [they are] like darknesses within an unfathomable sea which is covered by waves, upon which are waves, over which are clouds - darknesses, some of them upon others. When one puts out his hand [therein], he can hardly see it. And he to whom Allah has not granted light - for him there is no light",
    normalizedText:
      "او كظلمت في بحر لجي يغشىه موج من فوقه موج من فوقه سحاب ظلمت بعضها فوق بعض اذا اخرج يده لم يكد يرىها ومن لم يجعل الله له نورا فما له من نور",
  },
  {
    verseId: 40,
    name: "النور",
    surahId: 24,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ يُسَبِّحُ لَهُۥ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَٱلطَّيۡرُ صَـٰٓفَّـٰتٖۖ كُلّٞ قَدۡ عَلِمَ صَلَاتَهُۥ وَتَسۡبِيحَهُۥۗ وَٱللَّهُ عَلِيمُۢ بِمَا يَفۡعَلُونَ",
    translation:
      "Do you not see that Allah is exalted by whomever is within the heavens and the earth and [by] the birds with wings spread [in flight]? Each [of them] has known his [means of] prayer and exalting [Him], and Allah is Knowing of what they do",
    normalizedText:
      "الم تر ان الله يسبح له من في السموت والارض والطير صفت كل قد علم صلاته وتسبيحه والله عليم بما يفعلون",
  },
  {
    verseId: 41,
    name: "النور",
    surahId: 24,
    text: "وَلِلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ وَإِلَى ٱللَّهِ ٱلۡمَصِيرُ",
    translation:
      "And to Allah belongs the dominion of the heavens and the earth, and to Allah is the destination",
    normalizedText: "ولله ملك السموت والارض والى الله المصير",
  },
  {
    verseId: 42,
    name: "النور",
    surahId: 24,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ يُزۡجِي سَحَابٗا ثُمَّ يُؤَلِّفُ بَيۡنَهُۥ ثُمَّ يَجۡعَلُهُۥ رُكَامٗا فَتَرَى ٱلۡوَدۡقَ يَخۡرُجُ مِنۡ خِلَٰلِهِۦ وَيُنَزِّلُ مِنَ ٱلسَّمَآءِ مِن جِبَالٖ فِيهَا مِنۢ بَرَدٖ فَيُصِيبُ بِهِۦ مَن يَشَآءُ وَيَصۡرِفُهُۥ عَن مَّن يَشَآءُۖ يَكَادُ سَنَا بَرۡقِهِۦ يَذۡهَبُ بِٱلۡأَبۡصَٰرِ",
    translation:
      "Do you not see that Allah drives clouds? Then He brings them together, then He makes them into a mass, and you see the rain emerge from within it. And He sends down from the sky, mountains [of clouds] within which is hail, and He strikes with it whom He wills and averts it from whom He wills. The flash of its lightening almost takes away the eyesight",
    normalizedText:
      "الم تر ان الله يزجي سحابا ثم يالف بينه ثم يجعله ركاما فترى الودق يخرج من خلله وينزل من السماء من جبال فيها من برد فيصيب به من يشاء ويصرفه عن من يشاء يكاد سنا برقه يذهب بالابصر",
  },
  {
    verseId: 43,
    name: "النور",
    surahId: 24,
    text: "يُقَلِّبُ ٱللَّهُ ٱلَّيۡلَ وَٱلنَّهَارَۚ إِنَّ فِي ذَٰلِكَ لَعِبۡرَةٗ لِّأُوْلِي ٱلۡأَبۡصَٰرِ",
    translation:
      "Allah alternates the night and the day. Indeed in that is a lesson for those who have vision",
    normalizedText: "يقلب الله اليل والنهار ان في ذلك لعبرة لاولي الابصر",
  },
  {
    verseId: 44,
    name: "النور",
    surahId: 24,
    text: "وَٱللَّهُ خَلَقَ كُلَّ دَآبَّةٖ مِّن مَّآءٖۖ فَمِنۡهُم مَّن يَمۡشِي عَلَىٰ بَطۡنِهِۦ وَمِنۡهُم مَّن يَمۡشِي عَلَىٰ رِجۡلَيۡنِ وَمِنۡهُم مَّن يَمۡشِي عَلَىٰٓ أَرۡبَعٖۚ يَخۡلُقُ ٱللَّهُ مَا يَشَآءُۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "Allah has created every [living] creature from water. And of them are those that move on their bellies, and of them are those that walk on two legs, and of them are those that walk on four. Allah creates what He wills. Indeed, Allah is over all things competent",
    normalizedText:
      "والله خلق كل دابة من ماء فمنهم من يمشي على بطنه ومنهم من يمشي على رجلين ومنهم من يمشي على اربع يخلق الله ما يشاء ان الله على كل شيء قدير",
  },
  {
    verseId: 45,
    name: "النور",
    surahId: 24,
    text: "لَّقَدۡ أَنزَلۡنَآ ءَايَٰتٖ مُّبَيِّنَٰتٖۚ وَٱللَّهُ يَهۡدِي مَن يَشَآءُ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "We have certainly sent down distinct verses. And Allah guides whom He wills to a straight path",
    normalizedText: "لقد انزلنا ءايت مبينت والله يهدي من يشاء الى صرط مستقيم",
  },
  {
    verseId: 46,
    name: "النور",
    surahId: 24,
    text: "وَيَقُولُونَ ءَامَنَّا بِٱللَّهِ وَبِٱلرَّسُولِ وَأَطَعۡنَا ثُمَّ يَتَوَلَّىٰ فَرِيقٞ مِّنۡهُم مِّنۢ بَعۡدِ ذَٰلِكَۚ وَمَآ أُوْلَـٰٓئِكَ بِٱلۡمُؤۡمِنِينَ",
    translation:
      'But the hypocrites say, "We have believed in Allah and in the Messenger, and we obey"; then a party of them turns away after that. And those are not believers',
    normalizedText:
      "ويقولون ءامنا بالله وبالرسول واطعنا ثم يتولى فريق منهم من بعد ذلك وما اولاك بالمامنين",
  },
  {
    verseId: 47,
    name: "النور",
    surahId: 24,
    text: "وَإِذَا دُعُوٓاْ إِلَى ٱللَّهِ وَرَسُولِهِۦ لِيَحۡكُمَ بَيۡنَهُمۡ إِذَا فَرِيقٞ مِّنۡهُم مُّعۡرِضُونَ",
    translation:
      "And when they are called to [the words of] Allah and His Messenger to judge between them, at once a party of them turns aside [in refusal]",
    normalizedText:
      "واذا دعوا الى الله ورسوله ليحكم بينهم اذا فريق منهم معرضون",
  },
  {
    verseId: 48,
    name: "النور",
    surahId: 24,
    text: "وَإِن يَكُن لَّهُمُ ٱلۡحَقُّ يَأۡتُوٓاْ إِلَيۡهِ مُذۡعِنِينَ",
    translation:
      "But if the right is theirs, they come to him in prompt obedience",
    normalizedText: "وان يكن لهم الحق ياتوا اليه مذعنين",
  },
  {
    verseId: 49,
    name: "النور",
    surahId: 24,
    text: "أَفِي قُلُوبِهِم مَّرَضٌ أَمِ ٱرۡتَابُوٓاْ أَمۡ يَخَافُونَ أَن يَحِيفَ ٱللَّهُ عَلَيۡهِمۡ وَرَسُولُهُۥۚ بَلۡ أُوْلَـٰٓئِكَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "Is there disease in their hearts? Or have they doubted? Or do they fear that Allah will be unjust to them, or His Messenger? Rather, it is they who are the wrongdoers",
    normalizedText:
      "افي قلوبهم مرض ام ارتابوا ام يخافون ان يحيف الله عليهم ورسوله بل اولاك هم الظلمون",
  },
  {
    verseId: 50,
    name: "النور",
    surahId: 24,
    text: "إِنَّمَا كَانَ قَوۡلَ ٱلۡمُؤۡمِنِينَ إِذَا دُعُوٓاْ إِلَى ٱللَّهِ وَرَسُولِهِۦ لِيَحۡكُمَ بَيۡنَهُمۡ أَن يَقُولُواْ سَمِعۡنَا وَأَطَعۡنَاۚ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      'The only statement of the [true] believers when they are called to Allah and His Messenger to judge between them is that they say, "We hear and we obey." And those are the successful',
    normalizedText:
      "انما كان قول المامنين اذا دعوا الى الله ورسوله ليحكم بينهم ان يقولوا سمعنا واطعنا واولاك هم المفلحون",
  },
  {
    verseId: 51,
    name: "النور",
    surahId: 24,
    text: "وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ وَيَخۡشَ ٱللَّهَ وَيَتَّقۡهِ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡفَآئِزُونَ",
    translation:
      "And whoever obeys Allah and His Messenger and fears Allah and is conscious of Him - it is those who are the attainers",
    normalizedText: "ومن يطع الله ورسوله ويخش الله ويتقه فاولاك هم الفاازون",
  },
  {
    verseId: 52,
    name: "النور",
    surahId: 24,
    text: "۞وَأَقۡسَمُواْ بِٱللَّهِ جَهۡدَ أَيۡمَٰنِهِمۡ لَئِنۡ أَمَرۡتَهُمۡ لَيَخۡرُجُنَّۖ قُل لَّا تُقۡسِمُواْۖ طَاعَةٞ مَّعۡرُوفَةٌۚ إِنَّ ٱللَّهَ خَبِيرُۢ بِمَا تَعۡمَلُونَ",
    translation: `And they swear by Allah their strongest oaths that if you ordered them, they would go forth [in Allah 's cause]. Say, "Do not swear. [Such] obedience is known. Indeed, Allah is Acquainted with that which you do`,
    normalizedText:
      "۞واقسموا بالله جهد ايمنهم لان امرتهم ليخرجن قل لا تقسموا طاعة معروفة ان الله خبير بما تعملون",
  },
  {
    verseId: 53,
    name: "النور",
    surahId: 24,
    text: "قُلۡ أَطِيعُواْ ٱللَّهَ وَأَطِيعُواْ ٱلرَّسُولَۖ فَإِن تَوَلَّوۡاْ فَإِنَّمَا عَلَيۡهِ مَا حُمِّلَ وَعَلَيۡكُم مَّا حُمِّلۡتُمۡۖ وَإِن تُطِيعُوهُ تَهۡتَدُواْۚ وَمَا عَلَى ٱلرَّسُولِ إِلَّا ٱلۡبَلَٰغُ ٱلۡمُبِينُ",
    translation:
      'Say, "Obey Allah and obey the Messenger; but if you turn away - then upon him is only that [duty] with which he has been charged, and upon you is that with which you have been charged. And if you obey him, you will be [rightly] guided. And there is not upon the Messenger except the [responsibility for] clear notification',
    normalizedText:
      "قل اطيعوا الله واطيعوا الرسول فان تولوا فانما عليه ما حمل وعليكم ما حملتم وان تطيعوه تهتدوا وما على الرسول الا البلغ المبين",
  },
  {
    verseId: 54,
    name: "النور",
    surahId: 24,
    text: "وَعَدَ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ مِنكُمۡ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَيَسۡتَخۡلِفَنَّهُمۡ فِي ٱلۡأَرۡضِ كَمَا ٱسۡتَخۡلَفَ ٱلَّذِينَ مِن قَبۡلِهِمۡ وَلَيُمَكِّنَنَّ لَهُمۡ دِينَهُمُ ٱلَّذِي ٱرۡتَضَىٰ لَهُمۡ وَلَيُبَدِّلَنَّهُم مِّنۢ بَعۡدِ خَوۡفِهِمۡ أَمۡنٗاۚ يَعۡبُدُونَنِي لَا يُشۡرِكُونَ بِي شَيۡـٔٗاۚ وَمَن كَفَرَ بَعۡدَ ذَٰلِكَ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡفَٰسِقُونَ",
    translation:
      "Allah has promised those who have believed among you and done righteous deeds that He will surely grant them succession [to authority] upon the earth just as He granted it to those before them and that He will surely establish for them [therein] their religion which He has preferred for them and that He will surely substitute for them, after their fear, security, [for] they worship Me, not associating anything with Me. But whoever disbelieves after that - then those are the defiantly disobedient",
    normalizedText:
      "وعد الله الذين ءامنوا منكم وعملوا الصلحت ليستخلفنهم في الارض كما استخلف الذين من قبلهم وليمكنن لهم دينهم الذي ارتضى لهم وليبدلنهم من بعد خوفهم امنا يعبدونني لا يشركون بي شيا ومن كفر بعد ذلك فاولاك هم الفسقون",
  },
  {
    verseId: 55,
    name: "النور",
    surahId: 24,
    text: "وَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَ وَأَطِيعُواْ ٱلرَّسُولَ لَعَلَّكُمۡ تُرۡحَمُونَ",
    translation:
      "And establish prayer and give zakah and obey the Messenger - that you may receive mercy",
    normalizedText: "واقيموا الصلوة وءاتوا الزكوة واطيعوا الرسول لعلكم ترحمون",
  },
  {
    verseId: 56,
    name: "النور",
    surahId: 24,
    text: "لَا تَحۡسَبَنَّ ٱلَّذِينَ كَفَرُواْ مُعۡجِزِينَ فِي ٱلۡأَرۡضِۚ وَمَأۡوَىٰهُمُ ٱلنَّارُۖ وَلَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "Never think that the disbelievers are causing failure [to Allah] upon the earth. Their refuge will be the Fire - and how wretched the destination",
    normalizedText:
      "لا تحسبن الذين كفروا معجزين في الارض وماوىهم النار ولباس المصير",
  },
  {
    verseId: 57,
    name: "النور",
    surahId: 24,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لِيَسۡتَـٔۡذِنكُمُ ٱلَّذِينَ مَلَكَتۡ أَيۡمَٰنُكُمۡ وَٱلَّذِينَ لَمۡ يَبۡلُغُواْ ٱلۡحُلُمَ مِنكُمۡ ثَلَٰثَ مَرَّـٰتٖۚ مِّن قَبۡلِ صَلَوٰةِ ٱلۡفَجۡرِ وَحِينَ تَضَعُونَ ثِيَابَكُم مِّنَ ٱلظَّهِيرَةِ وَمِنۢ بَعۡدِ صَلَوٰةِ ٱلۡعِشَآءِۚ ثَلَٰثُ عَوۡرَٰتٖ لَّكُمۡۚ لَيۡسَ عَلَيۡكُمۡ وَلَا عَلَيۡهِمۡ جُنَاحُۢ بَعۡدَهُنَّۚ طَوَّـٰفُونَ عَلَيۡكُم بَعۡضُكُمۡ عَلَىٰ بَعۡضٖۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلۡأٓيَٰتِۗ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "O you who have believed, let those whom your right hands possess and those who have not [yet] reached puberty among you ask permission of you [before entering] at three times: before the dawn prayer and when you put aside your clothing [for rest] at noon and after the night prayer. [These are] three times of privacy for you. There is no blame upon you nor upon them beyond these [periods], for they continually circulate among you - some of you, among others. Thus does Allah make clear to you the verses; and Allah is Knowing and Wise",
    normalizedText:
      "يايها الذين ءامنوا ليستذنكم الذين ملكت ايمنكم والذين لم يبلغوا الحلم منكم ثلث مرت من قبل صلوة الفجر وحين تضعون ثيابكم من الظهيرة ومن بعد صلوة العشاء ثلث عورت لكم ليس عليكم ولا عليهم جناح بعدهن طوفون عليكم بعضكم على بعض كذلك يبين الله لكم الايت والله عليم حكيم",
  },
  {
    verseId: 58,
    name: "النور",
    surahId: 24,
    text: "وَإِذَا بَلَغَ ٱلۡأَطۡفَٰلُ مِنكُمُ ٱلۡحُلُمَ فَلۡيَسۡتَـٔۡذِنُواْ كَمَا ٱسۡتَـٔۡذَنَ ٱلَّذِينَ مِن قَبۡلِهِمۡۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمۡ ءَايَٰتِهِۦۗ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "And when the children among you reach puberty, let them ask permission [at all times] as those before them have done. Thus does Allah make clear to you His verses; and Allah is Knowing and Wise",
    normalizedText:
      "واذا بلغ الاطفل منكم الحلم فليستذنوا كما استذن الذين من قبلهم كذلك يبين الله لكم ءايته والله عليم حكيم",
  },
  {
    verseId: 59,
    name: "النور",
    surahId: 24,
    text: "وَٱلۡقَوَٰعِدُ مِنَ ٱلنِّسَآءِ ٱلَّـٰتِي لَا يَرۡجُونَ نِكَاحٗا فَلَيۡسَ عَلَيۡهِنَّ جُنَاحٌ أَن يَضَعۡنَ ثِيَابَهُنَّ غَيۡرَ مُتَبَرِّجَٰتِۭ بِزِينَةٖۖ وَأَن يَسۡتَعۡفِفۡنَ خَيۡرٞ لَّهُنَّۗ وَٱللَّهُ سَمِيعٌ عَلِيمٞ",
    translation:
      "And women of post-menstrual age who have no desire for marriage - there is no blame upon them for putting aside their outer garments [but] not displaying adornment. But to modestly refrain [from that] is better for them. And Allah is Hearing and Knowing",
    normalizedText:
      "والقوعد من النساء التي لا يرجون نكاحا فليس عليهن جناح ان يضعن ثيابهن غير متبرجت بزينة وان يستعففن خير لهن والله سميع عليم",
  },
  {
    verseId: 60,
    name: "النور",
    surahId: 24,
    text: "لَّيۡسَ عَلَى ٱلۡأَعۡمَىٰ حَرَجٞ وَلَا عَلَى ٱلۡأَعۡرَجِ حَرَجٞ وَلَا عَلَى ٱلۡمَرِيضِ حَرَجٞ وَلَا عَلَىٰٓ أَنفُسِكُمۡ أَن تَأۡكُلُواْ مِنۢ بُيُوتِكُمۡ أَوۡ بُيُوتِ ءَابَآئِكُمۡ أَوۡ بُيُوتِ أُمَّهَٰتِكُمۡ أَوۡ بُيُوتِ إِخۡوَٰنِكُمۡ أَوۡ بُيُوتِ أَخَوَٰتِكُمۡ أَوۡ بُيُوتِ أَعۡمَٰمِكُمۡ أَوۡ بُيُوتِ عَمَّـٰتِكُمۡ أَوۡ بُيُوتِ أَخۡوَٰلِكُمۡ أَوۡ بُيُوتِ خَٰلَٰتِكُمۡ أَوۡ مَا مَلَكۡتُم مَّفَاتِحَهُۥٓ أَوۡ صَدِيقِكُمۡۚ لَيۡسَ عَلَيۡكُمۡ جُنَاحٌ أَن تَأۡكُلُواْ جَمِيعًا أَوۡ أَشۡتَاتٗاۚ فَإِذَا دَخَلۡتُم بُيُوتٗا فَسَلِّمُواْ عَلَىٰٓ أَنفُسِكُمۡ تَحِيَّةٗ مِّنۡ عِندِ ٱللَّهِ مُبَٰرَكَةٗ طَيِّبَةٗۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلۡأٓيَٰتِ لَعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      "There is not upon the blind [any] constraint nor upon the lame constraint nor upon the ill constraint nor upon yourselves when you eat from your [own] houses or the houses of your fathers or the houses of your mothers or the houses of your brothers or the houses of your sisters or the houses of your father's brothers or the houses of your father's sisters or the houses of your mother's brothers or the houses of your mother's sisters or [from houses] whose keys you possess or [from the house] of your friend. There is no blame upon you whether you eat together or separately. But when you enter houses, give greetings of peace upon each other - a greeting from Allah, blessed and good. Thus does Allah make clear to you the verses [of ordinance] that you may understand",
    normalizedText:
      "ليس على الاعمى حرج ولا على الاعرج حرج ولا على المريض حرج ولا على انفسكم ان تاكلوا من بيوتكم او بيوت ءابااكم او بيوت امهتكم او بيوت اخونكم او بيوت اخوتكم او بيوت اعممكم او بيوت عمتكم او بيوت اخولكم او بيوت خلتكم او ما ملكتم مفاتحه او صديقكم ليس عليكم جناح ان تاكلوا جميعا او اشتاتا فاذا دخلتم بيوتا فسلموا على انفسكم تحية من عند الله مبركة طيبة كذلك يبين الله لكم الايت لعلكم تعقلون",
  },
  {
    verseId: 61,
    name: "النور",
    surahId: 24,
    text: "إِنَّمَا ٱلۡمُؤۡمِنُونَ ٱلَّذِينَ ءَامَنُواْ بِٱللَّهِ وَرَسُولِهِۦ وَإِذَا كَانُواْ مَعَهُۥ عَلَىٰٓ أَمۡرٖ جَامِعٖ لَّمۡ يَذۡهَبُواْ حَتَّىٰ يَسۡتَـٔۡذِنُوهُۚ إِنَّ ٱلَّذِينَ يَسۡتَـٔۡذِنُونَكَ أُوْلَـٰٓئِكَ ٱلَّذِينَ يُؤۡمِنُونَ بِٱللَّهِ وَرَسُولِهِۦۚ فَإِذَا ٱسۡتَـٔۡذَنُوكَ لِبَعۡضِ شَأۡنِهِمۡ فَأۡذَن لِّمَن شِئۡتَ مِنۡهُمۡ وَٱسۡتَغۡفِرۡ لَهُمُ ٱللَّهَۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "The believers are only those who believe in Allah and His Messenger and, when they are [meeting] with him for a matter of common interest, do not depart until they have asked his permission. Indeed, those who ask your permission, [O Muhammad] - those are the ones who believe in Allah and His Messenger. So when they ask your permission for something of their affairs, then give permission to whom you will among them and ask forgiveness for them of Allah. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "انما المامنون الذين ءامنوا بالله ورسوله واذا كانوا معه على امر جامع لم يذهبوا حتى يستذنوه ان الذين يستذنونك اولاك الذين يامنون بالله ورسوله فاذا استذنوك لبعض شانهم فاذن لمن شات منهم واستغفر لهم الله ان الله غفور رحيم",
  },
  {
    verseId: 62,
    name: "النور",
    surahId: 24,
    text: "لَّا تَجۡعَلُواْ دُعَآءَ ٱلرَّسُولِ بَيۡنَكُمۡ كَدُعَآءِ بَعۡضِكُم بَعۡضٗاۚ قَدۡ يَعۡلَمُ ٱللَّهُ ٱلَّذِينَ يَتَسَلَّلُونَ مِنكُمۡ لِوَاذٗاۚ فَلۡيَحۡذَرِ ٱلَّذِينَ يُخَالِفُونَ عَنۡ أَمۡرِهِۦٓ أَن تُصِيبَهُمۡ فِتۡنَةٌ أَوۡ يُصِيبَهُمۡ عَذَابٌ أَلِيمٌ",
    translation:
      "Do not make [your] calling of the Messenger among yourselves as the call of one of you to another. Already Allah knows those of you who slip away, concealed by others. So let those beware who dissent from the Prophet's order, lest fitnah strike them or a painful punishment",
    normalizedText:
      "لا تجعلوا دعاء الرسول بينكم كدعاء بعضكم بعضا قد يعلم الله الذين يتسللون منكم لواذا فليحذر الذين يخالفون عن امره ان تصيبهم فتنة او يصيبهم عذاب اليم",
  },
  {
    verseId: 63,
    name: "النور",
    surahId: 24,
    text: "أَلَآ إِنَّ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ قَدۡ يَعۡلَمُ مَآ أَنتُمۡ عَلَيۡهِ وَيَوۡمَ يُرۡجَعُونَ إِلَيۡهِ فَيُنَبِّئُهُم بِمَا عَمِلُواْۗ وَٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمُۢ",
    translation:
      "Unquestionably, to Allah belongs whatever is in the heavens and earth. Already He knows that upon which you [stand] and [knows] the Day when they will be returned to Him and He will inform them of what they have done. And Allah is Knowing of all things",
    normalizedText:
      "الا ان لله ما في السموت والارض قد يعلم ما انتم عليه ويوم يرجعون اليه فينباهم بما عملوا والله بكل شيء عليم",
  },
  {
    verseId: 0,
    name: "الفرقان",
    surahId: 25,
    text: "تَبَارَكَ ٱلَّذِي نَزَّلَ ٱلۡفُرۡقَانَ عَلَىٰ عَبۡدِهِۦ لِيَكُونَ لِلۡعَٰلَمِينَ نَذِيرًا",
    translation:
      "Blessed is He who sent down the Criterion upon His Servant that he may be to the worlds a warner",
    normalizedText: "تبارك الذي نزل الفرقان على عبده ليكون للعلمين نذيرا",
  },
  {
    verseId: 1,
    name: "الفرقان",
    surahId: 25,
    text: "ٱلَّذِي لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَلَمۡ يَتَّخِذۡ وَلَدٗا وَلَمۡ يَكُن لَّهُۥ شَرِيكٞ فِي ٱلۡمُلۡكِ وَخَلَقَ كُلَّ شَيۡءٖ فَقَدَّرَهُۥ تَقۡدِيرٗا",
    translation:
      "He to whom belongs the dominion of the heavens and the earth and who has not taken a son and has not had a partner in dominion and has created each thing and determined it with [precise] determination",
    normalizedText:
      "الذي له ملك السموت والارض ولم يتخذ ولدا ولم يكن له شريك في الملك وخلق كل شيء فقدره تقديرا",
  },
  {
    verseId: 2,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱتَّخَذُواْ مِن دُونِهِۦٓ ءَالِهَةٗ لَّا يَخۡلُقُونَ شَيۡـٔٗا وَهُمۡ يُخۡلَقُونَ وَلَا يَمۡلِكُونَ لِأَنفُسِهِمۡ ضَرّٗا وَلَا نَفۡعٗا وَلَا يَمۡلِكُونَ مَوۡتٗا وَلَا حَيَوٰةٗ وَلَا نُشُورٗا",
    translation:
      "But they have taken besides Him gods which create nothing, while they are created, and possess not for themselves any harm or benefit and possess not [power to cause] death or life or resurrection",
    normalizedText:
      "واتخذوا من دونه ءالهة لا يخلقون شيا وهم يخلقون ولا يملكون لانفسهم ضرا ولا نفعا ولا يملكون موتا ولا حيوة ولا نشورا",
  },
  {
    verseId: 3,
    name: "الفرقان",
    surahId: 25,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُوٓاْ إِنۡ هَٰذَآ إِلَّآ إِفۡكٌ ٱفۡتَرَىٰهُ وَأَعَانَهُۥ عَلَيۡهِ قَوۡمٌ ءَاخَرُونَۖ فَقَدۡ جَآءُو ظُلۡمٗا وَزُورٗا",
    translation: `And those who disbelieve say, "This [Qur'an] is not except a falsehood he invented, and another people assisted him in it." But they have committed an injustice and a lie`,
    normalizedText:
      "وقال الذين كفروا ان هذا الا افك افترىه واعانه عليه قوم ءاخرون فقد جاءو ظلما وزورا",
  },
  {
    verseId: 4,
    name: "الفرقان",
    surahId: 25,
    text: "وَقَالُوٓاْ أَسَٰطِيرُ ٱلۡأَوَّلِينَ ٱكۡتَتَبَهَا فَهِيَ تُمۡلَىٰ عَلَيۡهِ بُكۡرَةٗ وَأَصِيلٗا",
    translation:
      'And they say, "Legends of the former peoples which he has written down, and they are dictated to him morning and afternoon',
    normalizedText: "وقالوا اسطير الاولين اكتتبها فهي تملى عليه بكرة واصيلا",
  },
  {
    verseId: 5,
    name: "الفرقان",
    surahId: 25,
    text: "قُلۡ أَنزَلَهُ ٱلَّذِي يَعۡلَمُ ٱلسِّرَّ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ إِنَّهُۥ كَانَ غَفُورٗا رَّحِيمٗا",
    translation:
      'Say, [O Muhammad], "It has been revealed by He who knows [every] secret within the heavens and the earth. Indeed, He is ever Forgiving and Merciful',
    normalizedText:
      "قل انزله الذي يعلم السر في السموت والارض انه كان غفورا رحيما",
  },
  {
    verseId: 6,
    name: "الفرقان",
    surahId: 25,
    text: "وَقَالُواْ مَالِ هَٰذَا ٱلرَّسُولِ يَأۡكُلُ ٱلطَّعَامَ وَيَمۡشِي فِي ٱلۡأَسۡوَاقِ لَوۡلَآ أُنزِلَ إِلَيۡهِ مَلَكٞ فَيَكُونَ مَعَهُۥ نَذِيرًا",
    translation:
      'And they say, "What is this messenger that eats food and walks in the markets? Why was there not sent down to him an angel so he would be with him a warner',
    normalizedText:
      "وقالوا مال هذا الرسول ياكل الطعام ويمشي في الاسواق لولا انزل اليه ملك فيكون معه نذيرا",
  },
  {
    verseId: 7,
    name: "الفرقان",
    surahId: 25,
    text: "أَوۡ يُلۡقَىٰٓ إِلَيۡهِ كَنزٌ أَوۡ تَكُونُ لَهُۥ جَنَّةٞ يَأۡكُلُ مِنۡهَاۚ وَقَالَ ٱلظَّـٰلِمُونَ إِن تَتَّبِعُونَ إِلَّا رَجُلٗا مَّسۡحُورًا",
    translation:
      'Or [why is not] a treasure presented to him [from heaven], or does he [not] have a garden from which he eats?" And the wrongdoers say, "You follow not but a man affected by magic',
    normalizedText:
      "او يلقى اليه كنز او تكون له جنة ياكل منها وقال الظلمون ان تتبعون الا رجلا مسحورا",
  },
  {
    verseId: 8,
    name: "الفرقان",
    surahId: 25,
    text: "ٱنظُرۡ كَيۡفَ ضَرَبُواْ لَكَ ٱلۡأَمۡثَٰلَ فَضَلُّواْ فَلَا يَسۡتَطِيعُونَ سَبِيلٗا",
    translation:
      "Look how they strike for you comparisons; but they have strayed, so they cannot [find] a way",
    normalizedText: "انظر كيف ضربوا لك الامثل فضلوا فلا يستطيعون سبيلا",
  },
  {
    verseId: 9,
    name: "الفرقان",
    surahId: 25,
    text: "تَبَارَكَ ٱلَّذِيٓ إِن شَآءَ جَعَلَ لَكَ خَيۡرٗا مِّن ذَٰلِكَ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ وَيَجۡعَل لَّكَ قُصُورَۢا",
    translation:
      "Blessed is He who, if He willed, could have made for you [something] better than that - gardens beneath which rivers flow - and could make for you palaces",
    normalizedText:
      "تبارك الذي ان شاء جعل لك خيرا من ذلك جنت تجري من تحتها الانهر ويجعل لك قصورا",
  },
  {
    verseId: 10,
    name: "الفرقان",
    surahId: 25,
    text: "بَلۡ كَذَّبُواْ بِٱلسَّاعَةِۖ وَأَعۡتَدۡنَا لِمَن كَذَّبَ بِٱلسَّاعَةِ سَعِيرًا",
    translation:
      "But they have denied the Hour, and We have prepared for those who deny the Hour a Blaze",
    normalizedText: "بل كذبوا بالساعة واعتدنا لمن كذب بالساعة سعيرا",
  },
  {
    verseId: 11,
    name: "الفرقان",
    surahId: 25,
    text: "إِذَا رَأَتۡهُم مِّن مَّكَانِۭ بَعِيدٖ سَمِعُواْ لَهَا تَغَيُّظٗا وَزَفِيرٗا",
    translation:
      "When the Hellfire sees them from a distant place, they will hear its fury and roaring",
    normalizedText: "اذا راتهم من مكان بعيد سمعوا لها تغيظا وزفيرا",
  },
  {
    verseId: 12,
    name: "الفرقان",
    surahId: 25,
    text: "وَإِذَآ أُلۡقُواْ مِنۡهَا مَكَانٗا ضَيِّقٗا مُّقَرَّنِينَ دَعَوۡاْ هُنَالِكَ ثُبُورٗا",
    translation:
      "And when they are thrown into a narrow place therein bound in chains, they will cry out thereupon for destruction",
    normalizedText: "واذا القوا منها مكانا ضيقا مقرنين دعوا هنالك ثبورا",
  },
  {
    verseId: 13,
    name: "الفرقان",
    surahId: 25,
    text: "لَّا تَدۡعُواْ ٱلۡيَوۡمَ ثُبُورٗا وَٰحِدٗا وَٱدۡعُواْ ثُبُورٗا كَثِيرٗا",
    translation:
      '[They will be told], "Do not cry this Day for one destruction but cry for much destruction',
    normalizedText: "لا تدعوا اليوم ثبورا وحدا وادعوا ثبورا كثيرا",
  },
  {
    verseId: 14,
    name: "الفرقان",
    surahId: 25,
    text: "قُلۡ أَذَٰلِكَ خَيۡرٌ أَمۡ جَنَّةُ ٱلۡخُلۡدِ ٱلَّتِي وُعِدَ ٱلۡمُتَّقُونَۚ كَانَتۡ لَهُمۡ جَزَآءٗ وَمَصِيرٗا",
    translation:
      'Say, "Is that better or the Garden of Eternity which is promised to the righteous? It will be for them a reward and destination',
    normalizedText:
      "قل اذلك خير ام جنة الخلد التي وعد المتقون كانت لهم جزاء ومصيرا",
  },
  {
    verseId: 15,
    name: "الفرقان",
    surahId: 25,
    text: "لَّهُمۡ فِيهَا مَا يَشَآءُونَ خَٰلِدِينَۚ كَانَ عَلَىٰ رَبِّكَ وَعۡدٗا مَّسۡـُٔولٗا",
    translation:
      "For them therein is whatever they wish, [while] abiding eternally. It is ever upon your Lord a promise [worthy to be] requested",
    normalizedText: "لهم فيها ما يشاءون خلدين كان على ربك وعدا مسولا",
  },
  {
    verseId: 16,
    name: "الفرقان",
    surahId: 25,
    text: "وَيَوۡمَ يَحۡشُرُهُمۡ وَمَا يَعۡبُدُونَ مِن دُونِ ٱللَّهِ فَيَقُولُ ءَأَنتُمۡ أَضۡلَلۡتُمۡ عِبَادِي هَـٰٓؤُلَآءِ أَمۡ هُمۡ ضَلُّواْ ٱلسَّبِيلَ",
    translation:
      'And [mention] the Day He will gather them and that which they worship besides Allah and will say, "Did you mislead these, My servants, or did they [themselves] stray from the way',
    normalizedText:
      "ويوم يحشرهم وما يعبدون من دون الله فيقول ءانتم اضللتم عبادي هالاء ام هم ضلوا السبيل",
  },
  {
    verseId: 17,
    name: "الفرقان",
    surahId: 25,
    text: "قَالُواْ سُبۡحَٰنَكَ مَا كَانَ يَنۢبَغِي لَنَآ أَن نَّتَّخِذَ مِن دُونِكَ مِنۡ أَوۡلِيَآءَ وَلَٰكِن مَّتَّعۡتَهُمۡ وَءَابَآءَهُمۡ حَتَّىٰ نَسُواْ ٱلذِّكۡرَ وَكَانُواْ قَوۡمَۢا بُورٗا",
    translation:
      'They will say, "Exalted are You! It was not for us to take besides You any allies. But You provided comforts for them and their fathers until they forgot the message and became a people ruined',
    normalizedText:
      "قالوا سبحنك ما كان ينبغي لنا ان نتخذ من دونك من اولياء ولكن متعتهم وءاباءهم حتى نسوا الذكر وكانوا قوما بورا",
  },
  {
    verseId: 18,
    name: "الفرقان",
    surahId: 25,
    text: "فَقَدۡ كَذَّبُوكُم بِمَا تَقُولُونَ فَمَا تَسۡتَطِيعُونَ صَرۡفٗا وَلَا نَصۡرٗاۚ وَمَن يَظۡلِم مِّنكُمۡ نُذِقۡهُ عَذَابٗا كَبِيرٗا",
    translation:
      "So they will deny you, [disbelievers], in what you say, and you cannot avert [punishment] or [find] help. And whoever commits injustice among you - We will make him taste a great punishment",
    normalizedText:
      "فقد كذبوكم بما تقولون فما تستطيعون صرفا ولا نصرا ومن يظلم منكم نذقه عذابا كبيرا",
  },
  {
    verseId: 19,
    name: "الفرقان",
    surahId: 25,
    text: "وَمَآ أَرۡسَلۡنَا قَبۡلَكَ مِنَ ٱلۡمُرۡسَلِينَ إِلَّآ إِنَّهُمۡ لَيَأۡكُلُونَ ٱلطَّعَامَ وَيَمۡشُونَ فِي ٱلۡأَسۡوَاقِۗ وَجَعَلۡنَا بَعۡضَكُمۡ لِبَعۡضٖ فِتۡنَةً أَتَصۡبِرُونَۗ وَكَانَ رَبُّكَ بَصِيرٗا",
    translation:
      "And We did not send before you, [O Muhammad], any of the messengers except that they ate food and walked in the markets. And We have made some of you [people] as trial for others - will you have patience? And ever is your Lord, Seeing",
    normalizedText:
      "وما ارسلنا قبلك من المرسلين الا انهم لياكلون الطعام ويمشون في الاسواق وجعلنا بعضكم لبعض فتنة اتصبرون وكان ربك بصيرا",
  },
  {
    verseId: 20,
    name: "الفرقان",
    surahId: 25,
    text: "۞وَقَالَ ٱلَّذِينَ لَا يَرۡجُونَ لِقَآءَنَا لَوۡلَآ أُنزِلَ عَلَيۡنَا ٱلۡمَلَـٰٓئِكَةُ أَوۡ نَرَىٰ رَبَّنَاۗ لَقَدِ ٱسۡتَكۡبَرُواْ فِيٓ أَنفُسِهِمۡ وَعَتَوۡ عُتُوّٗا كَبِيرٗا",
    translation:
      'And those who do not expect the meeting with Us say, "Why were not angels sent down to us, or [why] do we [not] see our Lord?" They have certainly become arrogant within themselves and [become] insolent with great insolence',
    normalizedText:
      "۞وقال الذين لا يرجون لقاءنا لولا انزل علينا الملاكة او نرى ربنا لقد استكبروا في انفسهم وعتو عتوا كبيرا",
  },
  {
    verseId: 21,
    name: "الفرقان",
    surahId: 25,
    text: "يَوۡمَ يَرَوۡنَ ٱلۡمَلَـٰٓئِكَةَ لَا بُشۡرَىٰ يَوۡمَئِذٖ لِّلۡمُجۡرِمِينَ وَيَقُولُونَ حِجۡرٗا مَّحۡجُورٗا",
    translation:
      'The day they see the angels - no good tidings will there be that day for the criminals, and [the angels] will say, "Prevented and inaccessible',
    normalizedText:
      "يوم يرون الملاكة لا بشرى يوماذ للمجرمين ويقولون حجرا محجورا",
  },
  {
    verseId: 22,
    name: "الفرقان",
    surahId: 25,
    text: "وَقَدِمۡنَآ إِلَىٰ مَا عَمِلُواْ مِنۡ عَمَلٖ فَجَعَلۡنَٰهُ هَبَآءٗ مَّنثُورًا",
    translation:
      "And We will regard what they have done of deeds and make them as dust dispersed",
    normalizedText: "وقدمنا الى ما عملوا من عمل فجعلنه هباء منثورا",
  },
  {
    verseId: 23,
    name: "الفرقان",
    surahId: 25,
    text: "أَصۡحَٰبُ ٱلۡجَنَّةِ يَوۡمَئِذٍ خَيۡرٞ مُّسۡتَقَرّٗا وَأَحۡسَنُ مَقِيلٗا",
    translation:
      "The companions of Paradise, that Day, are [in] a better settlement and better resting place",
    normalizedText: "اصحب الجنة يوماذ خير مستقرا واحسن مقيلا",
  },
  {
    verseId: 24,
    name: "الفرقان",
    surahId: 25,
    text: "وَيَوۡمَ تَشَقَّقُ ٱلسَّمَآءُ بِٱلۡغَمَٰمِ وَنُزِّلَ ٱلۡمَلَـٰٓئِكَةُ تَنزِيلًا",
    translation:
      "And [mention] the Day when the heaven will split open with [emerging] clouds, and the angels will be sent down in successive descent",
    normalizedText: "ويوم تشقق السماء بالغمم ونزل الملاكة تنزيلا",
  },
  {
    verseId: 25,
    name: "الفرقان",
    surahId: 25,
    text: "ٱلۡمُلۡكُ يَوۡمَئِذٍ ٱلۡحَقُّ لِلرَّحۡمَٰنِۚ وَكَانَ يَوۡمًا عَلَى ٱلۡكَٰفِرِينَ عَسِيرٗا",
    translation:
      "True sovereignty, that Day, is for the Most Merciful. And it will be upon the disbelievers a difficult Day",
    normalizedText: "الملك يوماذ الحق للرحمن وكان يوما على الكفرين عسيرا",
  },
  {
    verseId: 26,
    name: "الفرقان",
    surahId: 25,
    text: "وَيَوۡمَ يَعَضُّ ٱلظَّالِمُ عَلَىٰ يَدَيۡهِ يَقُولُ يَٰلَيۡتَنِي ٱتَّخَذۡتُ مَعَ ٱلرَّسُولِ سَبِيلٗا",
    translation:
      'And the Day the wrongdoer will bite on his hands [in regret] he will say, "Oh, I wish I had taken with the Messenger a way',
    normalizedText:
      "ويوم يعض الظالم على يديه يقول يليتني اتخذت مع الرسول سبيلا",
  },
  {
    verseId: 27,
    name: "الفرقان",
    surahId: 25,
    text: "يَٰوَيۡلَتَىٰ لَيۡتَنِي لَمۡ أَتَّخِذۡ فُلَانًا خَلِيلٗا",
    translation: "Oh, woe to me! I wish I had not taken that one as a friend",
    normalizedText: "يويلتى ليتني لم اتخذ فلانا خليلا",
  },
  {
    verseId: 28,
    name: "الفرقان",
    surahId: 25,
    text: "لَّقَدۡ أَضَلَّنِي عَنِ ٱلذِّكۡرِ بَعۡدَ إِذۡ جَآءَنِيۗ وَكَانَ ٱلشَّيۡطَٰنُ لِلۡإِنسَٰنِ خَذُولٗا",
    translation:
      "He led me away from the remembrance after it had come to me. And ever is Satan, to man, a deserter",
    normalizedText: "لقد اضلني عن الذكر بعد اذ جاءني وكان الشيطن للانسن خذولا",
  },
  {
    verseId: 29,
    name: "الفرقان",
    surahId: 25,
    text: "وَقَالَ ٱلرَّسُولُ يَٰرَبِّ إِنَّ قَوۡمِي ٱتَّخَذُواْ هَٰذَا ٱلۡقُرۡءَانَ مَهۡجُورٗا",
    translation: `And the Messenger has said, "O my Lord, indeed my people have taken this Qur'an as [a thing] abandoned`,
    normalizedText: "وقال الرسول يرب ان قومي اتخذوا هذا القرءان مهجورا",
  },
  {
    verseId: 30,
    name: "الفرقان",
    surahId: 25,
    text: "وَكَذَٰلِكَ جَعَلۡنَا لِكُلِّ نَبِيٍّ عَدُوّٗا مِّنَ ٱلۡمُجۡرِمِينَۗ وَكَفَىٰ بِرَبِّكَ هَادِيٗا وَنَصِيرٗا",
    translation:
      "And thus have We made for every prophet an enemy from among the criminals. But sufficient is your Lord as a guide and a helper",
    normalizedText:
      "وكذلك جعلنا لكل نبي عدوا من المجرمين وكفى بربك هاديا ونصيرا",
  },
  {
    verseId: 31,
    name: "الفرقان",
    surahId: 25,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ لَوۡلَا نُزِّلَ عَلَيۡهِ ٱلۡقُرۡءَانُ جُمۡلَةٗ وَٰحِدَةٗۚ كَذَٰلِكَ لِنُثَبِّتَ بِهِۦ فُؤَادَكَۖ وَرَتَّلۡنَٰهُ تَرۡتِيلٗا",
    translation: `And those who disbelieve say, "Why was the Qur'an not revealed to him all at once?" Thus [it is] that We may strengthen thereby your heart. And We have spaced it distinctly`,
    normalizedText:
      "وقال الذين كفروا لولا نزل عليه القرءان جملة وحدة كذلك لنثبت به فاادك ورتلنه ترتيلا",
  },
  {
    verseId: 32,
    name: "الفرقان",
    surahId: 25,
    text: "وَلَا يَأۡتُونَكَ بِمَثَلٍ إِلَّا جِئۡنَٰكَ بِٱلۡحَقِّ وَأَحۡسَنَ تَفۡسِيرًا",
    translation:
      "And they do not come to you with an argument except that We bring you the truth and the best explanation",
    normalizedText: "ولا ياتونك بمثل الا جانك بالحق واحسن تفسيرا",
  },
  {
    verseId: 33,
    name: "الفرقان",
    surahId: 25,
    text: "ٱلَّذِينَ يُحۡشَرُونَ عَلَىٰ وُجُوهِهِمۡ إِلَىٰ جَهَنَّمَ أُوْلَـٰٓئِكَ شَرّٞ مَّكَانٗا وَأَضَلُّ سَبِيلٗا",
    translation:
      "The ones who are gathered on their faces to Hell - those are the worst in position and farthest astray in [their] way",
    normalizedText:
      "الذين يحشرون على وجوههم الى جهنم اولاك شر مكانا واضل سبيلا",
  },
  {
    verseId: 34,
    name: "الفرقان",
    surahId: 25,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ وَجَعَلۡنَا مَعَهُۥٓ أَخَاهُ هَٰرُونَ وَزِيرٗا",
    translation:
      "And We had certainly given Moses the Scripture and appointed with him his brother Aaron as an assistant",
    normalizedText: "ولقد ءاتينا موسى الكتب وجعلنا معه اخاه هرون وزيرا",
  },
  {
    verseId: 35,
    name: "الفرقان",
    surahId: 25,
    text: "فَقُلۡنَا ٱذۡهَبَآ إِلَى ٱلۡقَوۡمِ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِنَا فَدَمَّرۡنَٰهُمۡ تَدۡمِيرٗا",
    translation:
      'And We said, "Go both of you to the people who have denied Our signs." Then We destroyed them with [complete] destruction',
    normalizedText: "فقلنا اذهبا الى القوم الذين كذبوا بايتنا فدمرنهم تدميرا",
  },
  {
    verseId: 36,
    name: "الفرقان",
    surahId: 25,
    text: "وَقَوۡمَ نُوحٖ لَّمَّا كَذَّبُواْ ٱلرُّسُلَ أَغۡرَقۡنَٰهُمۡ وَجَعَلۡنَٰهُمۡ لِلنَّاسِ ءَايَةٗۖ وَأَعۡتَدۡنَا لِلظَّـٰلِمِينَ عَذَابًا أَلِيمٗا",
    translation:
      "And the people of Noah - when they denied the messengers, We drowned them, and We made them for mankind a sign. And We have prepared for the wrongdoers a painful punishment",
    normalizedText:
      "وقوم نوح لما كذبوا الرسل اغرقنهم وجعلنهم للناس ءاية واعتدنا للظلمين عذابا اليما",
  },
  {
    verseId: 37,
    name: "الفرقان",
    surahId: 25,
    text: "وَعَادٗا وَثَمُودَاْ وَأَصۡحَٰبَ ٱلرَّسِّ وَقُرُونَۢا بَيۡنَ ذَٰلِكَ كَثِيرٗا",
    translation:
      "And [We destroyed] 'Aad and Thamud and the companions of the well and many generations between them",
    normalizedText: "وعادا وثمودا واصحب الرس وقرونا بين ذلك كثيرا",
  },
  {
    verseId: 38,
    name: "الفرقان",
    surahId: 25,
    text: "وَكُلّٗا ضَرَبۡنَا لَهُ ٱلۡأَمۡثَٰلَۖ وَكُلّٗا تَبَّرۡنَا تَتۡبِيرٗا",
    translation:
      "And for each We presented examples [as warnings], and each We destroyed with [total] destruction",
    normalizedText: "وكلا ضربنا له الامثل وكلا تبرنا تتبيرا",
  },
  {
    verseId: 39,
    name: "الفرقان",
    surahId: 25,
    text: "وَلَقَدۡ أَتَوۡاْ عَلَى ٱلۡقَرۡيَةِ ٱلَّتِيٓ أُمۡطِرَتۡ مَطَرَ ٱلسَّوۡءِۚ أَفَلَمۡ يَكُونُواْ يَرَوۡنَهَاۚ بَلۡ كَانُواْ لَا يَرۡجُونَ نُشُورٗا",
    translation:
      "And they have already come upon the town which was showered with a rain of evil. So have they not seen it? But they are not expecting resurrection",
    normalizedText:
      "ولقد اتوا على القرية التي امطرت مطر السوء افلم يكونوا يرونها بل كانوا لا يرجون نشورا",
  },
  {
    verseId: 40,
    name: "الفرقان",
    surahId: 25,
    text: "وَإِذَا رَأَوۡكَ إِن يَتَّخِذُونَكَ إِلَّا هُزُوًا أَهَٰذَا ٱلَّذِي بَعَثَ ٱللَّهُ رَسُولًا",
    translation:
      'And when they see you, [O Muhammad], they take you not except in ridicule, [saying], "Is this the one whom Allah has sent as a messenger',
    normalizedText: "واذا راوك ان يتخذونك الا هزوا اهذا الذي بعث الله رسولا",
  },
  {
    verseId: 41,
    name: "الفرقان",
    surahId: 25,
    text: "إِن كَادَ لَيُضِلُّنَا عَنۡ ءَالِهَتِنَا لَوۡلَآ أَن صَبَرۡنَا عَلَيۡهَاۚ وَسَوۡفَ يَعۡلَمُونَ حِينَ يَرَوۡنَ ٱلۡعَذَابَ مَنۡ أَضَلُّ سَبِيلًا",
    translation:
      'He almost would have misled us from our gods had we not been steadfast in [worship of] them." But they are going to know, when they see the punishment, who is farthest astray in [his] way',
    normalizedText:
      "ان كاد ليضلنا عن ءالهتنا لولا ان صبرنا عليها وسوف يعلمون حين يرون العذاب من اضل سبيلا",
  },
  {
    verseId: 42,
    name: "الفرقان",
    surahId: 25,
    text: "أَرَءَيۡتَ مَنِ ٱتَّخَذَ إِلَٰهَهُۥ هَوَىٰهُ أَفَأَنتَ تَكُونُ عَلَيۡهِ وَكِيلًا",
    translation:
      "Have you seen the one who takes as his god his own desire? Then would you be responsible for him",
    normalizedText: "ارءيت من اتخذ الهه هوىه افانت تكون عليه وكيلا",
  },
  {
    verseId: 43,
    name: "الفرقان",
    surahId: 25,
    text: "أَمۡ تَحۡسَبُ أَنَّ أَكۡثَرَهُمۡ يَسۡمَعُونَ أَوۡ يَعۡقِلُونَۚ إِنۡ هُمۡ إِلَّا كَٱلۡأَنۡعَٰمِ بَلۡ هُمۡ أَضَلُّ سَبِيلًا",
    translation:
      "Or do you think that most of them hear or reason? They are not except like livestock. Rather, they are [even] more astray in [their] way",
    normalizedText:
      "ام تحسب ان اكثرهم يسمعون او يعقلون ان هم الا كالانعم بل هم اضل سبيلا",
  },
  {
    verseId: 44,
    name: "الفرقان",
    surahId: 25,
    text: "أَلَمۡ تَرَ إِلَىٰ رَبِّكَ كَيۡفَ مَدَّ ٱلظِّلَّ وَلَوۡ شَآءَ لَجَعَلَهُۥ سَاكِنٗا ثُمَّ جَعَلۡنَا ٱلشَّمۡسَ عَلَيۡهِ دَلِيلٗا",
    translation:
      "Have you not considered your Lord - how He extends the shadow, and if He willed, He could have made it stationary? Then We made the sun for it an indication",
    normalizedText:
      "الم تر الى ربك كيف مد الظل ولو شاء لجعله ساكنا ثم جعلنا الشمس عليه دليلا",
  },
  {
    verseId: 45,
    name: "الفرقان",
    surahId: 25,
    text: "ثُمَّ قَبَضۡنَٰهُ إِلَيۡنَا قَبۡضٗا يَسِيرٗا",
    translation: "Then We hold it in hand for a brief grasp",
    normalizedText: "ثم قبضنه الينا قبضا يسيرا",
  },
  {
    verseId: 46,
    name: "الفرقان",
    surahId: 25,
    text: "وَهُوَ ٱلَّذِي جَعَلَ لَكُمُ ٱلَّيۡلَ لِبَاسٗا وَٱلنَّوۡمَ سُبَاتٗا وَجَعَلَ ٱلنَّهَارَ نُشُورٗا",
    translation:
      "And it is He who has made the night for you as clothing and sleep [a means for] rest and has made the day a resurrection",
    normalizedText:
      "وهو الذي جعل لكم اليل لباسا والنوم سباتا وجعل النهار نشورا",
  },
  {
    verseId: 47,
    name: "الفرقان",
    surahId: 25,
    text: "وَهُوَ ٱلَّذِيٓ أَرۡسَلَ ٱلرِّيَٰحَ بُشۡرَۢا بَيۡنَ يَدَيۡ رَحۡمَتِهِۦۚ وَأَنزَلۡنَا مِنَ ٱلسَّمَآءِ مَآءٗ طَهُورٗا",
    translation:
      "And it is He who sends the winds as good tidings before His mercy, and We send down from the sky pure water",
    normalizedText:
      "وهو الذي ارسل الريح بشرا بين يدي رحمته وانزلنا من السماء ماء طهورا",
  },
  {
    verseId: 48,
    name: "الفرقان",
    surahId: 25,
    text: "لِّنُحۡـِۧيَ بِهِۦ بَلۡدَةٗ مَّيۡتٗا وَنُسۡقِيَهُۥ مِمَّا خَلَقۡنَآ أَنۡعَٰمٗا وَأَنَاسِيَّ كَثِيرٗا",
    translation:
      "That We may bring to life thereby a dead land and give it as drink to those We created of numerous livestock and men",
    normalizedText: "لنحي به بلدة ميتا ونسقيه مما خلقنا انعما واناسي كثيرا",
  },
  {
    verseId: 49,
    name: "الفرقان",
    surahId: 25,
    text: "وَلَقَدۡ صَرَّفۡنَٰهُ بَيۡنَهُمۡ لِيَذَّكَّرُواْ فَأَبَىٰٓ أَكۡثَرُ ٱلنَّاسِ إِلَّا كُفُورٗا",
    translation:
      "And We have certainly distributed it among them that they might be reminded, but most of the people refuse except disbelief",
    normalizedText: "ولقد صرفنه بينهم ليذكروا فابى اكثر الناس الا كفورا",
  },
  {
    verseId: 50,
    name: "الفرقان",
    surahId: 25,
    text: "وَلَوۡ شِئۡنَا لَبَعَثۡنَا فِي كُلِّ قَرۡيَةٖ نَّذِيرٗا",
    translation:
      "And if We had willed, We could have sent into every city a warner",
    normalizedText: "ولو شانا لبعثنا في كل قرية نذيرا",
  },
  {
    verseId: 51,
    name: "الفرقان",
    surahId: 25,
    text: "فَلَا تُطِعِ ٱلۡكَٰفِرِينَ وَجَٰهِدۡهُم بِهِۦ جِهَادٗا كَبِيرٗا",
    translation:
      "So do not obey the disbelievers, and strive against them with the Qur'an a great striving",
    normalizedText: "فلا تطع الكفرين وجهدهم به جهادا كبيرا",
  },
  {
    verseId: 52,
    name: "الفرقان",
    surahId: 25,
    text: "۞وَهُوَ ٱلَّذِي مَرَجَ ٱلۡبَحۡرَيۡنِ هَٰذَا عَذۡبٞ فُرَاتٞ وَهَٰذَا مِلۡحٌ أُجَاجٞ وَجَعَلَ بَيۡنَهُمَا بَرۡزَخٗا وَحِجۡرٗا مَّحۡجُورٗا",
    translation:
      "And it is He who has released [simultaneously] the two seas, one fresh and sweet and one salty and bitter, and He placed between them a barrier and prohibiting partition",
    normalizedText:
      "۞وهو الذي مرج البحرين هذا عذب فرات وهذا ملح اجاج وجعل بينهما برزخا وحجرا محجورا",
  },
  {
    verseId: 53,
    name: "الفرقان",
    surahId: 25,
    text: "وَهُوَ ٱلَّذِي خَلَقَ مِنَ ٱلۡمَآءِ بَشَرٗا فَجَعَلَهُۥ نَسَبٗا وَصِهۡرٗاۗ وَكَانَ رَبُّكَ قَدِيرٗا",
    translation:
      "And it is He who has created from water a human being and made him [a relative by] lineage and marriage. And ever is your Lord competent [concerning creation]",
    normalizedText:
      "وهو الذي خلق من الماء بشرا فجعله نسبا وصهرا وكان ربك قديرا",
  },
  {
    verseId: 54,
    name: "الفرقان",
    surahId: 25,
    text: "وَيَعۡبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُهُمۡ وَلَا يَضُرُّهُمۡۗ وَكَانَ ٱلۡكَافِرُ عَلَىٰ رَبِّهِۦ ظَهِيرٗا",
    translation:
      "But they worship rather than Allah that which does not benefit them or harm them, and the disbeliever is ever, against his Lord, an assistant [to Satan]",
    normalizedText:
      "ويعبدون من دون الله ما لا ينفعهم ولا يضرهم وكان الكافر على ربه ظهيرا",
  },
  {
    verseId: 55,
    name: "الفرقان",
    surahId: 25,
    text: "وَمَآ أَرۡسَلۡنَٰكَ إِلَّا مُبَشِّرٗا وَنَذِيرٗا",
    translation:
      "And We have not sent you, [O Muhammad], except as a bringer of good tidings and a warner",
    normalizedText: "وما ارسلنك الا مبشرا ونذيرا",
  },
  {
    verseId: 56,
    name: "الفرقان",
    surahId: 25,
    text: "قُلۡ مَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مِنۡ أَجۡرٍ إِلَّا مَن شَآءَ أَن يَتَّخِذَ إِلَىٰ رَبِّهِۦ سَبِيلٗا",
    translation:
      'Say, "I do not ask of you for it any payment - only that whoever wills might take to his Lord a way',
    normalizedText: "قل ما اسلكم عليه من اجر الا من شاء ان يتخذ الى ربه سبيلا",
  },
  {
    verseId: 57,
    name: "الفرقان",
    surahId: 25,
    text: "وَتَوَكَّلۡ عَلَى ٱلۡحَيِّ ٱلَّذِي لَا يَمُوتُ وَسَبِّحۡ بِحَمۡدِهِۦۚ وَكَفَىٰ بِهِۦ بِذُنُوبِ عِبَادِهِۦ خَبِيرًا",
    translation:
      "And rely upon the Ever-Living who does not die, and exalt [Allah] with His praise. And sufficient is He to be, with the sins of His servants, Acquainted",
    normalizedText:
      "وتوكل على الحي الذي لا يموت وسبح بحمده وكفى به بذنوب عباده خبيرا",
  },
  {
    verseId: 58,
    name: "الفرقان",
    surahId: 25,
    text: "ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَا فِي سِتَّةِ أَيَّامٖ ثُمَّ ٱسۡتَوَىٰ عَلَى ٱلۡعَرۡشِۖ ٱلرَّحۡمَٰنُ فَسۡـَٔلۡ بِهِۦ خَبِيرٗا",
    translation:
      "He who created the heavens and the earth and what is between them in six days and then established Himself above the Throne - the Most Merciful, so ask about Him one well informed",
    normalizedText:
      "الذي خلق السموت والارض وما بينهما في ستة ايام ثم استوى على العرش الرحمن فسل به خبيرا",
  },
  {
    verseId: 59,
    name: "الفرقان",
    surahId: 25,
    text: "وَإِذَا قِيلَ لَهُمُ ٱسۡجُدُواْۤ لِلرَّحۡمَٰنِ قَالُواْ وَمَا ٱلرَّحۡمَٰنُ أَنَسۡجُدُ لِمَا تَأۡمُرُنَا وَزَادَهُمۡ نُفُورٗا۩",
    translation:
      'And when it is said to them, "Prostrate to the Most Merciful," they say, "And what is the Most Merciful? Should we prostrate to that which you order us?" And it increases them in aversion',
    normalizedText:
      "واذا قيل لهم اسجدوا للرحمن قالوا وما الرحمن انسجد لما تامرنا وزادهم نفورا۩",
  },
  {
    verseId: 60,
    name: "الفرقان",
    surahId: 25,
    text: "تَبَارَكَ ٱلَّذِي جَعَلَ فِي ٱلسَّمَآءِ بُرُوجٗا وَجَعَلَ فِيهَا سِرَٰجٗا وَقَمَرٗا مُّنِيرٗا",
    translation:
      "Blessed is He who has placed in the sky great stars and placed therein a [burning] lamp and luminous moon",
    normalizedText: "تبارك الذي جعل في السماء بروجا وجعل فيها سرجا وقمرا منيرا",
  },
  {
    verseId: 61,
    name: "الفرقان",
    surahId: 25,
    text: "وَهُوَ ٱلَّذِي جَعَلَ ٱلَّيۡلَ وَٱلنَّهَارَ خِلۡفَةٗ لِّمَنۡ أَرَادَ أَن يَذَّكَّرَ أَوۡ أَرَادَ شُكُورٗا",
    translation:
      "And it is He who has made the night and the day in succession for whoever desires to remember or desires gratitude",
    normalizedText:
      "وهو الذي جعل اليل والنهار خلفة لمن اراد ان يذكر او اراد شكورا",
  },
  {
    verseId: 62,
    name: "الفرقان",
    surahId: 25,
    text: "وَعِبَادُ ٱلرَّحۡمَٰنِ ٱلَّذِينَ يَمۡشُونَ عَلَى ٱلۡأَرۡضِ هَوۡنٗا وَإِذَا خَاطَبَهُمُ ٱلۡجَٰهِلُونَ قَالُواْ سَلَٰمٗا",
    translation:
      "And the servants of the Most Merciful are those who walk upon the earth easily, and when the ignorant address them [harshly], they say [words of] peace",
    normalizedText:
      "وعباد الرحمن الذين يمشون على الارض هونا واذا خاطبهم الجهلون قالوا سلما",
  },
  {
    verseId: 63,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱلَّذِينَ يَبِيتُونَ لِرَبِّهِمۡ سُجَّدٗا وَقِيَٰمٗا",
    translation:
      "And those who spend [part of] the night to their Lord prostrating and standing [in prayer]",
    normalizedText: "والذين يبيتون لربهم سجدا وقيما",
  },
  {
    verseId: 64,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱلَّذِينَ يَقُولُونَ رَبَّنَا ٱصۡرِفۡ عَنَّا عَذَابَ جَهَنَّمَۖ إِنَّ عَذَابَهَا كَانَ غَرَامًا",
    translation:
      'And those who say, "Our Lord, avert from us the punishment of Hell. Indeed, its punishment is ever adhering',
    normalizedText: "والذين يقولون ربنا اصرف عنا عذاب جهنم ان عذابها كان غراما",
  },
  {
    verseId: 65,
    name: "الفرقان",
    surahId: 25,
    text: "إِنَّهَا سَآءَتۡ مُسۡتَقَرّٗا وَمُقَامٗا",
    translation: "Indeed, it is evil as a settlement and residence",
    normalizedText: "انها ساءت مستقرا ومقاما",
  },
  {
    verseId: 66,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱلَّذِينَ إِذَآ أَنفَقُواْ لَمۡ يُسۡرِفُواْ وَلَمۡ يَقۡتُرُواْ وَكَانَ بَيۡنَ ذَٰلِكَ قَوَامٗا",
    translation:
      "And [they are] those who, when they spend, do so not excessively or sparingly but are ever, between that, [justly] moderate",
    normalizedText: "والذين اذا انفقوا لم يسرفوا ولم يقتروا وكان بين ذلك قواما",
  },
  {
    verseId: 67,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱلَّذِينَ لَا يَدۡعُونَ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ وَلَا يَقۡتُلُونَ ٱلنَّفۡسَ ٱلَّتِي حَرَّمَ ٱللَّهُ إِلَّا بِٱلۡحَقِّ وَلَا يَزۡنُونَۚ وَمَن يَفۡعَلۡ ذَٰلِكَ يَلۡقَ أَثَامٗا",
    translation:
      "And those who do not invoke with Allah another deity or kill the soul which Allah has forbidden [to be killed], except by right, and do not commit unlawful sexual intercourse. And whoever should do that will meet a penalty",
    normalizedText:
      "والذين لا يدعون مع الله الها ءاخر ولا يقتلون النفس التي حرم الله الا بالحق ولا يزنون ومن يفعل ذلك يلق اثاما",
  },
  {
    verseId: 68,
    name: "الفرقان",
    surahId: 25,
    text: "يُضَٰعَفۡ لَهُ ٱلۡعَذَابُ يَوۡمَ ٱلۡقِيَٰمَةِ وَيَخۡلُدۡ فِيهِۦ مُهَانًا",
    translation:
      "Multiplied for him is the punishment on the Day of Resurrection, and he will abide therein humiliated",
    normalizedText: "يضعف له العذاب يوم القيمة ويخلد فيه مهانا",
  },
  {
    verseId: 69,
    name: "الفرقان",
    surahId: 25,
    text: "إِلَّا مَن تَابَ وَءَامَنَ وَعَمِلَ عَمَلٗا صَٰلِحٗا فَأُوْلَـٰٓئِكَ يُبَدِّلُ ٱللَّهُ سَيِّـَٔاتِهِمۡ حَسَنَٰتٖۗ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمٗا",
    translation:
      "Except for those who repent, believe and do righteous work. For them Allah will replace their evil deeds with good. And ever is Allah Forgiving and Merciful",
    normalizedText:
      "الا من تاب وءامن وعمل عملا صلحا فاولاك يبدل الله سياتهم حسنت وكان الله غفورا رحيما",
  },
  {
    verseId: 70,
    name: "الفرقان",
    surahId: 25,
    text: "وَمَن تَابَ وَعَمِلَ صَٰلِحٗا فَإِنَّهُۥ يَتُوبُ إِلَى ٱللَّهِ مَتَابٗا",
    translation:
      "And he who repents and does righteousness does indeed turn to Allah with [accepted] repentance",
    normalizedText: "ومن تاب وعمل صلحا فانه يتوب الى الله متابا",
  },
  {
    verseId: 71,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱلَّذِينَ لَا يَشۡهَدُونَ ٱلزُّورَ وَإِذَا مَرُّواْ بِٱللَّغۡوِ مَرُّواْ كِرَامٗا",
    translation:
      "And [they are] those who do not testify to falsehood, and when they pass near ill speech, they pass by with dignity",
    normalizedText: "والذين لا يشهدون الزور واذا مروا باللغو مروا كراما",
  },
  {
    verseId: 72,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱلَّذِينَ إِذَا ذُكِّرُواْ بِـَٔايَٰتِ رَبِّهِمۡ لَمۡ يَخِرُّواْ عَلَيۡهَا صُمّٗا وَعُمۡيَانٗا",
    translation:
      "And those who, when reminded of the verses of their Lord, do not fall upon them deaf and blind",
    normalizedText: "والذين اذا ذكروا بايت ربهم لم يخروا عليها صما وعميانا",
  },
  {
    verseId: 73,
    name: "الفرقان",
    surahId: 25,
    text: "وَٱلَّذِينَ يَقُولُونَ رَبَّنَا هَبۡ لَنَا مِنۡ أَزۡوَٰجِنَا وَذُرِّيَّـٰتِنَا قُرَّةَ أَعۡيُنٖ وَٱجۡعَلۡنَا لِلۡمُتَّقِينَ إِمَامًا",
    translation:
      'And those who say, "Our Lord, grant us from among our wives and offspring comfort to our eyes and make us an example for the righteous',
    normalizedText:
      "والذين يقولون ربنا هب لنا من ازوجنا وذريتنا قرة اعين واجعلنا للمتقين اماما",
  },
  {
    verseId: 74,
    name: "الفرقان",
    surahId: 25,
    text: "أُوْلَـٰٓئِكَ يُجۡزَوۡنَ ٱلۡغُرۡفَةَ بِمَا صَبَرُواْ وَيُلَقَّوۡنَ فِيهَا تَحِيَّةٗ وَسَلَٰمًا",
    translation:
      "Those will be awarded the Chamber for what they patiently endured, and they will be received therein with greetings and [words of] peace",
    normalizedText: "اولاك يجزون الغرفة بما صبروا ويلقون فيها تحية وسلما",
  },
  {
    verseId: 75,
    name: "الفرقان",
    surahId: 25,
    text: "خَٰلِدِينَ فِيهَاۚ حَسُنَتۡ مُسۡتَقَرّٗا وَمُقَامٗا",
    translation:
      "Abiding eternally therein. Good is the settlement and residence",
    normalizedText: "خلدين فيها حسنت مستقرا ومقاما",
  },
  {
    verseId: 76,
    name: "الفرقان",
    surahId: 25,
    text: "قُلۡ مَا يَعۡبَؤُاْ بِكُمۡ رَبِّي لَوۡلَا دُعَآؤُكُمۡۖ فَقَدۡ كَذَّبۡتُمۡ فَسَوۡفَ يَكُونُ لِزَامَۢا",
    translation:
      'Say, "What would my Lord care for you if not for your supplication?" For you [disbelievers] have denied, so your denial is going to be adherent',
    normalizedText: "قل ما يعباا بكم ربي لولا دعااكم فقد كذبتم فسوف يكون لزاما",
  },
  {
    verseId: 0,
    name: "الشعراء",
    surahId: 26,
    text: "طسٓمٓ",
    translation: "Ta, Seen, Meem",
    normalizedText: "طسم",
  },
  {
    verseId: 1,
    name: "الشعراء",
    surahId: 26,
    text: "تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡمُبِينِ",
    translation: "These are the verses of the clear Book",
    normalizedText: "تلك ءايت الكتب المبين",
  },
  {
    verseId: 2,
    name: "الشعراء",
    surahId: 26,
    text: "لَعَلَّكَ بَٰخِعٞ نَّفۡسَكَ أَلَّا يَكُونُواْ مُؤۡمِنِينَ",
    translation:
      "Perhaps, [O Muhammad], you would kill yourself with grief that they will not be believers",
    normalizedText: "لعلك بخع نفسك الا يكونوا مامنين",
  },
  {
    verseId: 3,
    name: "الشعراء",
    surahId: 26,
    text: "إِن نَّشَأۡ نُنَزِّلۡ عَلَيۡهِم مِّنَ ٱلسَّمَآءِ ءَايَةٗ فَظَلَّتۡ أَعۡنَٰقُهُمۡ لَهَا خَٰضِعِينَ",
    translation:
      "If We willed, We could send down to them from the sky a sign for which their necks would remain humbled",
    normalizedText: "ان نشا ننزل عليهم من السماء ءاية فظلت اعنقهم لها خضعين",
  },
  {
    verseId: 4,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَا يَأۡتِيهِم مِّن ذِكۡرٖ مِّنَ ٱلرَّحۡمَٰنِ مُحۡدَثٍ إِلَّا كَانُواْ عَنۡهُ مُعۡرِضِينَ",
    translation:
      "And no revelation comes to them anew from the Most Merciful except that they turn away from it",
    normalizedText: "وما ياتيهم من ذكر من الرحمن محدث الا كانوا عنه معرضين",
  },
  {
    verseId: 5,
    name: "الشعراء",
    surahId: 26,
    text: "فَقَدۡ كَذَّبُواْ فَسَيَأۡتِيهِمۡ أَنۢبَـٰٓؤُاْ مَا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "For they have already denied, but there will come to them the news of that which they used to ridicule",
    normalizedText: "فقد كذبوا فسياتيهم انباا ما كانوا به يستهزءون",
  },
  {
    verseId: 6,
    name: "الشعراء",
    surahId: 26,
    text: "أَوَلَمۡ يَرَوۡاْ إِلَى ٱلۡأَرۡضِ كَمۡ أَنۢبَتۡنَا فِيهَا مِن كُلِّ زَوۡجٖ كَرِيمٍ",
    translation:
      "Did they not look at the earth - how much We have produced therein from every noble kind",
    normalizedText: "اولم يروا الى الارض كم انبتنا فيها من كل زوج كريم",
  },
  {
    verseId: 7,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 8,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 9,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِذۡ نَادَىٰ رَبُّكَ مُوسَىٰٓ أَنِ ٱئۡتِ ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      'And [mention] when your Lord called Moses, [saying], "Go to the wrongdoing people',
    normalizedText: "واذ نادى ربك موسى ان اات القوم الظلمين",
  },
  {
    verseId: 10,
    name: "الشعراء",
    surahId: 26,
    text: "قَوۡمَ فِرۡعَوۡنَۚ أَلَا يَتَّقُونَ",
    translation: "The people of Pharaoh. Will they not fear Allah",
    normalizedText: "قوم فرعون الا يتقون",
  },
  {
    verseId: 11,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ رَبِّ إِنِّيٓ أَخَافُ أَن يُكَذِّبُونِ",
    translation: 'He said, "My Lord, indeed I fear that they will deny me',
    normalizedText: "قال رب اني اخاف ان يكذبون",
  },
  {
    verseId: 12,
    name: "الشعراء",
    surahId: 26,
    text: "وَيَضِيقُ صَدۡرِي وَلَا يَنطَلِقُ لِسَانِي فَأَرۡسِلۡ إِلَىٰ هَٰرُونَ",
    translation:
      "And that my breast will tighten and my tongue will not be fluent, so send for Aaron",
    normalizedText: "ويضيق صدري ولا ينطلق لساني فارسل الى هرون",
  },
  {
    verseId: 13,
    name: "الشعراء",
    surahId: 26,
    text: "وَلَهُمۡ عَلَيَّ ذَنۢبٞ فَأَخَافُ أَن يَقۡتُلُونِ",
    translation:
      "And they have upon me a [claim due to] sin, so I fear that they will kill me",
    normalizedText: "ولهم علي ذنب فاخاف ان يقتلون",
  },
  {
    verseId: 14,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ كَلَّاۖ فَٱذۡهَبَا بِـَٔايَٰتِنَآۖ إِنَّا مَعَكُم مُّسۡتَمِعُونَ",
    translation:
      '[Allah] said, "No. Go both of you with Our signs; indeed, We are with you, listening',
    normalizedText: "قال كلا فاذهبا بايتنا انا معكم مستمعون",
  },
  {
    verseId: 15,
    name: "الشعراء",
    surahId: 26,
    text: "فَأۡتِيَا فِرۡعَوۡنَ فَقُولَآ إِنَّا رَسُولُ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "Go to Pharaoh and say, 'We are the messengers of the Lord of the worlds",
    normalizedText: "فاتيا فرعون فقولا انا رسول رب العلمين",
  },
  {
    verseId: 16,
    name: "الشعراء",
    surahId: 26,
    text: "أَنۡ أَرۡسِلۡ مَعَنَا بَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation: '[Commanded to say], "Send with us the Children of Israel',
    normalizedText: "ان ارسل معنا بني اسرءيل",
  },
  {
    verseId: 17,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ أَلَمۡ نُرَبِّكَ فِينَا وَلِيدٗا وَلَبِثۡتَ فِينَا مِنۡ عُمُرِكَ سِنِينَ",
    translation:
      '[Pharaoh] said, "Did we not raise you among us as a child, and you remained among us for years of your life',
    normalizedText: "قال الم نربك فينا وليدا ولبثت فينا من عمرك سنين",
  },
  {
    verseId: 18,
    name: "الشعراء",
    surahId: 26,
    text: "وَفَعَلۡتَ فَعۡلَتَكَ ٱلَّتِي فَعَلۡتَ وَأَنتَ مِنَ ٱلۡكَٰفِرِينَ",
    translation:
      "And [then] you did your deed which you did, and you were of the ungrateful",
    normalizedText: "وفعلت فعلتك التي فعلت وانت من الكفرين",
  },
  {
    verseId: 19,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ فَعَلۡتُهَآ إِذٗا وَأَنَا۠ مِنَ ٱلضَّآلِّينَ",
    translation: '[Moses] said, "I did it, then, while I was of those astray',
    normalizedText: "قال فعلتها اذا وانا من الضالين",
  },
  {
    verseId: 20,
    name: "الشعراء",
    surahId: 26,
    text: "فَفَرَرۡتُ مِنكُمۡ لَمَّا خِفۡتُكُمۡ فَوَهَبَ لِي رَبِّي حُكۡمٗا وَجَعَلَنِي مِنَ ٱلۡمُرۡسَلِينَ",
    translation:
      "So I fled from you when I feared you. Then my Lord granted me wisdom and prophethood and appointed me [as one] of the messengers",
    normalizedText: "ففررت منكم لما خفتكم فوهب لي ربي حكما وجعلني من المرسلين",
  },
  {
    verseId: 21,
    name: "الشعراء",
    surahId: 26,
    text: "وَتِلۡكَ نِعۡمَةٞ تَمُنُّهَا عَلَيَّ أَنۡ عَبَّدتَّ بَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation:
      "And is this a favor of which you remind me - that you have enslaved the Children of Israel",
    normalizedText: "وتلك نعمة تمنها علي ان عبدت بني اسرءيل",
  },
  {
    verseId: 22,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ فِرۡعَوۡنُ وَمَا رَبُّ ٱلۡعَٰلَمِينَ",
    translation: 'Said Pharaoh, "And what is the Lord of the worlds',
    normalizedText: "قال فرعون وما رب العلمين",
  },
  {
    verseId: 23,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ رَبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَآۖ إِن كُنتُم مُّوقِنِينَ",
    translation:
      '[Moses] said, "The Lord of the heavens and earth and that between them, if you should be convinced',
    normalizedText: "قال رب السموت والارض وما بينهما ان كنتم موقنين",
  },
  {
    verseId: 24,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ لِمَنۡ حَوۡلَهُۥٓ أَلَا تَسۡتَمِعُونَ",
    translation: '[Pharaoh] said to those around him, "Do you not hear',
    normalizedText: "قال لمن حوله الا تستمعون",
  },
  {
    verseId: 25,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ رَبُّكُمۡ وَرَبُّ ءَابَآئِكُمُ ٱلۡأَوَّلِينَ",
    translation:
      '[Moses] said, "Your Lord and the Lord of your first forefathers',
    normalizedText: "قال ربكم ورب ءابااكم الاولين",
  },
  {
    verseId: 26,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ إِنَّ رَسُولَكُمُ ٱلَّذِيٓ أُرۡسِلَ إِلَيۡكُمۡ لَمَجۡنُونٞ",
    translation: `[Pharaoh] said, "Indeed, your 'messenger' who has been sent to you is mad`,
    normalizedText: "قال ان رسولكم الذي ارسل اليكم لمجنون",
  },
  {
    verseId: 27,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ رَبُّ ٱلۡمَشۡرِقِ وَٱلۡمَغۡرِبِ وَمَا بَيۡنَهُمَآۖ إِن كُنتُمۡ تَعۡقِلُونَ",
    translation:
      '[Moses] said, "Lord of the east and the west and that between them, if you were to reason',
    normalizedText: "قال رب المشرق والمغرب وما بينهما ان كنتم تعقلون",
  },
  {
    verseId: 28,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ لَئِنِ ٱتَّخَذۡتَ إِلَٰهًا غَيۡرِي لَأَجۡعَلَنَّكَ مِنَ ٱلۡمَسۡجُونِينَ",
    translation:
      '[Pharaoh] said, "If you take a god other than me, I will surely place you among those imprisoned',
    normalizedText: "قال لان اتخذت الها غيري لاجعلنك من المسجونين",
  },
  {
    verseId: 29,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ أَوَلَوۡ جِئۡتُكَ بِشَيۡءٖ مُّبِينٖ",
    translation: '[Moses] said, "Even if I brought you proof manifest',
    normalizedText: "قال اولو جاتك بشيء مبين",
  },
  {
    verseId: 30,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ فَأۡتِ بِهِۦٓ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      '[Pharaoh] said, "Then bring it, if you should be of the truthful',
    normalizedText: "قال فات به ان كنت من الصدقين",
  },
  {
    verseId: 31,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَلۡقَىٰ عَصَاهُ فَإِذَا هِيَ ثُعۡبَانٞ مُّبِينٞ",
    translation:
      "So [Moses] threw his staff, and suddenly it was a serpent manifest",
    normalizedText: "فالقى عصاه فاذا هي ثعبان مبين",
  },
  {
    verseId: 32,
    name: "الشعراء",
    surahId: 26,
    text: "وَنَزَعَ يَدَهُۥ فَإِذَا هِيَ بَيۡضَآءُ لِلنَّـٰظِرِينَ",
    translation:
      "And he drew out his hand; thereupon it was white for the observers",
    normalizedText: "ونزع يده فاذا هي بيضاء للنظرين",
  },
  {
    verseId: 33,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ لِلۡمَلَإِ حَوۡلَهُۥٓ إِنَّ هَٰذَا لَسَٰحِرٌ عَلِيمٞ",
    translation:
      '[Pharaoh] said to the eminent ones around him, "Indeed, this is a learned magician',
    normalizedText: "قال للملا حوله ان هذا لسحر عليم",
  },
  {
    verseId: 34,
    name: "الشعراء",
    surahId: 26,
    text: "يُرِيدُ أَن يُخۡرِجَكُم مِّنۡ أَرۡضِكُم بِسِحۡرِهِۦ فَمَاذَا تَأۡمُرُونَ",
    translation:
      "He wants to drive you out of your land by his magic, so what do you advise",
    normalizedText: "يريد ان يخرجكم من ارضكم بسحره فماذا تامرون",
  },
  {
    verseId: 35,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُوٓاْ أَرۡجِهۡ وَأَخَاهُ وَٱبۡعَثۡ فِي ٱلۡمَدَآئِنِ حَٰشِرِينَ",
    translation:
      'They said, "Postpone [the matter of] him and his brother and send among the cities gatherers',
    normalizedText: "قالوا ارجه واخاه وابعث في المداان حشرين",
  },
  {
    verseId: 36,
    name: "الشعراء",
    surahId: 26,
    text: "يَأۡتُوكَ بِكُلِّ سَحَّارٍ عَلِيمٖ",
    translation: "Who will bring you every learned, skilled magician",
    normalizedText: "ياتوك بكل سحار عليم",
  },
  {
    verseId: 37,
    name: "الشعراء",
    surahId: 26,
    text: "فَجُمِعَ ٱلسَّحَرَةُ لِمِيقَٰتِ يَوۡمٖ مَّعۡلُومٖ",
    translation:
      "So the magicians were assembled for the appointment of a well-known day",
    normalizedText: "فجمع السحرة لميقت يوم معلوم",
  },
  {
    verseId: 38,
    name: "الشعراء",
    surahId: 26,
    text: "وَقِيلَ لِلنَّاسِ هَلۡ أَنتُم مُّجۡتَمِعُونَ",
    translation: 'And it was said to the people, "Will you congregate',
    normalizedText: "وقيل للناس هل انتم مجتمعون",
  },
  {
    verseId: 39,
    name: "الشعراء",
    surahId: 26,
    text: "لَعَلَّنَا نَتَّبِعُ ٱلسَّحَرَةَ إِن كَانُواْ هُمُ ٱلۡغَٰلِبِينَ",
    translation:
      "That we might follow the magicians if they are the predominant",
    normalizedText: "لعلنا نتبع السحرة ان كانوا هم الغلبين",
  },
  {
    verseId: 40,
    name: "الشعراء",
    surahId: 26,
    text: "فَلَمَّا جَآءَ ٱلسَّحَرَةُ قَالُواْ لِفِرۡعَوۡنَ أَئِنَّ لَنَا لَأَجۡرًا إِن كُنَّا نَحۡنُ ٱلۡغَٰلِبِينَ",
    translation:
      'And when the magicians arrived, they said to Pharaoh, "Is there indeed for us a reward if we are the predominant',
    normalizedText:
      "فلما جاء السحرة قالوا لفرعون اان لنا لاجرا ان كنا نحن الغلبين",
  },
  {
    verseId: 41,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ نَعَمۡ وَإِنَّكُمۡ إِذٗا لَّمِنَ ٱلۡمُقَرَّبِينَ",
    translation:
      'He said, "Yes, and indeed, you will then be of those near [to me]',
    normalizedText: "قال نعم وانكم اذا لمن المقربين",
  },
  {
    verseId: 42,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ لَهُم مُّوسَىٰٓ أَلۡقُواْ مَآ أَنتُم مُّلۡقُونَ",
    translation: 'Moses said to them, "Throw whatever you will throw',
    normalizedText: "قال لهم موسى القوا ما انتم ملقون",
  },
  {
    verseId: 43,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَلۡقَوۡاْ حِبَالَهُمۡ وَعِصِيَّهُمۡ وَقَالُواْ بِعِزَّةِ فِرۡعَوۡنَ إِنَّا لَنَحۡنُ ٱلۡغَٰلِبُونَ",
    translation:
      'So they threw their ropes and their staffs and said, "By the might of Pharaoh, indeed it is we who are predominant',
    normalizedText: "فالقوا حبالهم وعصيهم وقالوا بعزة فرعون انا لنحن الغلبون",
  },
  {
    verseId: 44,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَلۡقَىٰ مُوسَىٰ عَصَاهُ فَإِذَا هِيَ تَلۡقَفُ مَا يَأۡفِكُونَ",
    translation:
      "Then Moses threw his staff, and at once it devoured what they falsified",
    normalizedText: "فالقى موسى عصاه فاذا هي تلقف ما يافكون",
  },
  {
    verseId: 45,
    name: "الشعراء",
    surahId: 26,
    text: "فَأُلۡقِيَ ٱلسَّحَرَةُ سَٰجِدِينَ",
    translation: "So the magicians fell down in prostration [to Allah]",
    normalizedText: "فالقي السحرة سجدين",
  },
  {
    verseId: 46,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُوٓاْ ءَامَنَّا بِرَبِّ ٱلۡعَٰلَمِينَ",
    translation: 'They said, "We have believed in the Lord of the worlds',
    normalizedText: "قالوا ءامنا برب العلمين",
  },
  {
    verseId: 47,
    name: "الشعراء",
    surahId: 26,
    text: "رَبِّ مُوسَىٰ وَهَٰرُونَ",
    translation: "The Lord of Moses and Aaron",
    normalizedText: "رب موسى وهرون",
  },
  {
    verseId: 48,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ ءَامَنتُمۡ لَهُۥ قَبۡلَ أَنۡ ءَاذَنَ لَكُمۡۖ إِنَّهُۥ لَكَبِيرُكُمُ ٱلَّذِي عَلَّمَكُمُ ٱلسِّحۡرَ فَلَسَوۡفَ تَعۡلَمُونَۚ لَأُقَطِّعَنَّ أَيۡدِيَكُمۡ وَأَرۡجُلَكُم مِّنۡ خِلَٰفٖ وَلَأُصَلِّبَنَّكُمۡ أَجۡمَعِينَ",
    translation:
      '[Pharaoh] said, "You believed Moses before I gave you permission. Indeed, he is your leader who has taught you magic, but you are going to know. I will surely cut off your hands and your feet on opposite sides, and I will surely crucify you all',
    normalizedText:
      "قال ءامنتم له قبل ان ءاذن لكم انه لكبيركم الذي علمكم السحر فلسوف تعلمون لاقطعن ايديكم وارجلكم من خلف ولاصلبنكم اجمعين",
  },
  {
    verseId: 49,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُواْ لَا ضَيۡرَۖ إِنَّآ إِلَىٰ رَبِّنَا مُنقَلِبُونَ",
    translation: 'They said, "No harm. Indeed, to our Lord we will return',
    normalizedText: "قالوا لا ضير انا الى ربنا منقلبون",
  },
  {
    verseId: 50,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّا نَطۡمَعُ أَن يَغۡفِرَ لَنَا رَبُّنَا خَطَٰيَٰنَآ أَن كُنَّآ أَوَّلَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "Indeed, we aspire that our Lord will forgive us our sins because we were the first of the believers",
    normalizedText: "انا نطمع ان يغفر لنا ربنا خطينا ان كنا اول المامنين",
  },
  {
    verseId: 51,
    name: "الشعراء",
    surahId: 26,
    text: "۞وَأَوۡحَيۡنَآ إِلَىٰ مُوسَىٰٓ أَنۡ أَسۡرِ بِعِبَادِيٓ إِنَّكُم مُّتَّبَعُونَ",
    translation:
      'And We inspired to Moses, "Travel by night with My servants; indeed, you will be pursued',
    normalizedText: "۞واوحينا الى موسى ان اسر بعبادي انكم متبعون",
  },
  {
    verseId: 52,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَرۡسَلَ فِرۡعَوۡنُ فِي ٱلۡمَدَآئِنِ حَٰشِرِينَ",
    translation: "Then Pharaoh sent among the cities gatherers",
    normalizedText: "فارسل فرعون في المداان حشرين",
  },
  {
    verseId: 53,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّ هَـٰٓؤُلَآءِ لَشِرۡذِمَةٞ قَلِيلُونَ",
    translation: '[And said], "Indeed, those are but a small band',
    normalizedText: "ان هالاء لشرذمة قليلون",
  },
  {
    verseId: 54,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّهُمۡ لَنَا لَغَآئِظُونَ",
    translation: "And indeed, they are enraging us",
    normalizedText: "وانهم لنا لغااظون",
  },
  {
    verseId: 55,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّا لَجَمِيعٌ حَٰذِرُونَ",
    translation: "And indeed, we are a cautious society",
    normalizedText: "وانا لجميع حذرون",
  },
  {
    verseId: 56,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَخۡرَجۡنَٰهُم مِّن جَنَّـٰتٖ وَعُيُونٖ",
    translation: "So We removed them from gardens and springs",
    normalizedText: "فاخرجنهم من جنت وعيون",
  },
  {
    verseId: 57,
    name: "الشعراء",
    surahId: 26,
    text: "وَكُنُوزٖ وَمَقَامٖ كَرِيمٖ",
    translation: "And treasures and honorable station",
    normalizedText: "وكنوز ومقام كريم",
  },
  {
    verseId: 58,
    name: "الشعراء",
    surahId: 26,
    text: "كَذَٰلِكَۖ وَأَوۡرَثۡنَٰهَا بَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation: "Thus. And We caused to inherit it the Children of Israel",
    normalizedText: "كذلك واورثنها بني اسرءيل",
  },
  {
    verseId: 59,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَتۡبَعُوهُم مُّشۡرِقِينَ",
    translation: "So they pursued them at sunrise",
    normalizedText: "فاتبعوهم مشرقين",
  },
  {
    verseId: 60,
    name: "الشعراء",
    surahId: 26,
    text: "فَلَمَّا تَرَـٰٓءَا ٱلۡجَمۡعَانِ قَالَ أَصۡحَٰبُ مُوسَىٰٓ إِنَّا لَمُدۡرَكُونَ",
    translation:
      'And when the two companies saw one another, the companions of Moses said, "Indeed, we are to be overtaken',
    normalizedText: "فلما ترءا الجمعان قال اصحب موسى انا لمدركون",
  },
  {
    verseId: 61,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ كَلَّآۖ إِنَّ مَعِيَ رَبِّي سَيَهۡدِينِ",
    translation:
      '[Moses] said, "No! Indeed, with me is my Lord; He will guide me',
    normalizedText: "قال كلا ان معي ربي سيهدين",
  },
  {
    verseId: 62,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَوۡحَيۡنَآ إِلَىٰ مُوسَىٰٓ أَنِ ٱضۡرِب بِّعَصَاكَ ٱلۡبَحۡرَۖ فَٱنفَلَقَ فَكَانَ كُلُّ فِرۡقٖ كَٱلطَّوۡدِ ٱلۡعَظِيمِ",
    translation:
      'Then We inspired to Moses, "Strike with your staff the sea," and it parted, and each portion was like a great towering mountain',
    normalizedText:
      "فاوحينا الى موسى ان اضرب بعصاك البحر فانفلق فكان كل فرق كالطود العظيم",
  },
  {
    verseId: 63,
    name: "الشعراء",
    surahId: 26,
    text: "وَأَزۡلَفۡنَا ثَمَّ ٱلۡأٓخَرِينَ",
    translation: "And We advanced thereto the pursuers",
    normalizedText: "وازلفنا ثم الاخرين",
  },
  {
    verseId: 64,
    name: "الشعراء",
    surahId: 26,
    text: "وَأَنجَيۡنَا مُوسَىٰ وَمَن مَّعَهُۥٓ أَجۡمَعِينَ",
    translation: "And We saved Moses and those with him, all together",
    normalizedText: "وانجينا موسى ومن معه اجمعين",
  },
  {
    verseId: 65,
    name: "الشعراء",
    surahId: 26,
    text: "ثُمَّ أَغۡرَقۡنَا ٱلۡأٓخَرِينَ",
    translation: "Then We drowned the others",
    normalizedText: "ثم اغرقنا الاخرين",
  },
  {
    verseId: 66,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 67,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 68,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱتۡلُ عَلَيۡهِمۡ نَبَأَ إِبۡرَٰهِيمَ",
    translation: "And recite to them the news of Abraham",
    normalizedText: "واتل عليهم نبا ابرهيم",
  },
  {
    verseId: 69,
    name: "الشعراء",
    surahId: 26,
    text: "إِذۡ قَالَ لِأَبِيهِ وَقَوۡمِهِۦ مَا تَعۡبُدُونَ",
    translation:
      'When he said to his father and his people, "What do you worship',
    normalizedText: "اذ قال لابيه وقومه ما تعبدون",
  },
  {
    verseId: 70,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُواْ نَعۡبُدُ أَصۡنَامٗا فَنَظَلُّ لَهَا عَٰكِفِينَ",
    translation: 'They said, "We worship idols and remain to them devoted',
    normalizedText: "قالوا نعبد اصناما فنظل لها عكفين",
  },
  {
    verseId: 71,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ هَلۡ يَسۡمَعُونَكُمۡ إِذۡ تَدۡعُونَ",
    translation: 'He said, "Do they hear you when you supplicate',
    normalizedText: "قال هل يسمعونكم اذ تدعون",
  },
  {
    verseId: 72,
    name: "الشعراء",
    surahId: 26,
    text: "أَوۡ يَنفَعُونَكُمۡ أَوۡ يَضُرُّونَ",
    translation: "Or do they benefit you, or do they harm",
    normalizedText: "او ينفعونكم او يضرون",
  },
  {
    verseId: 73,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُواْ بَلۡ وَجَدۡنَآ ءَابَآءَنَا كَذَٰلِكَ يَفۡعَلُونَ",
    translation: 'They said, "But we found our fathers doing thus',
    normalizedText: "قالوا بل وجدنا ءاباءنا كذلك يفعلون",
  },
  {
    verseId: 74,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ أَفَرَءَيۡتُم مَّا كُنتُمۡ تَعۡبُدُونَ",
    translation: 'He said, "Then do you see what you have been worshipping',
    normalizedText: "قال افرءيتم ما كنتم تعبدون",
  },
  {
    verseId: 75,
    name: "الشعراء",
    surahId: 26,
    text: "أَنتُمۡ وَءَابَآؤُكُمُ ٱلۡأَقۡدَمُونَ",
    translation: "You and your ancient forefathers",
    normalizedText: "انتم وءابااكم الاقدمون",
  },
  {
    verseId: 76,
    name: "الشعراء",
    surahId: 26,
    text: "فَإِنَّهُمۡ عَدُوّٞ لِّيٓ إِلَّا رَبَّ ٱلۡعَٰلَمِينَ",
    translation:
      "Indeed, they are enemies to me, except the Lord of the worlds",
    normalizedText: "فانهم عدو لي الا رب العلمين",
  },
  {
    verseId: 77,
    name: "الشعراء",
    surahId: 26,
    text: "ٱلَّذِي خَلَقَنِي فَهُوَ يَهۡدِينِ",
    translation: "Who created me, and He [it is who] guides me",
    normalizedText: "الذي خلقني فهو يهدين",
  },
  {
    verseId: 78,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱلَّذِي هُوَ يُطۡعِمُنِي وَيَسۡقِينِ",
    translation: "And it is He who feeds me and gives me drink",
    normalizedText: "والذي هو يطعمني ويسقين",
  },
  {
    verseId: 79,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِذَا مَرِضۡتُ فَهُوَ يَشۡفِينِ",
    translation: "And when I am ill, it is He who cures me",
    normalizedText: "واذا مرضت فهو يشفين",
  },
  {
    verseId: 80,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱلَّذِي يُمِيتُنِي ثُمَّ يُحۡيِينِ",
    translation: "And who will cause me to die and then bring me to life",
    normalizedText: "والذي يميتني ثم يحيين",
  },
  {
    verseId: 81,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱلَّذِيٓ أَطۡمَعُ أَن يَغۡفِرَ لِي خَطِيٓـَٔتِي يَوۡمَ ٱلدِّينِ",
    translation:
      "And who I aspire that He will forgive me my sin on the Day of Recompense",
    normalizedText: "والذي اطمع ان يغفر لي خطيتي يوم الدين",
  },
  {
    verseId: 82,
    name: "الشعراء",
    surahId: 26,
    text: "رَبِّ هَبۡ لِي حُكۡمٗا وَأَلۡحِقۡنِي بِٱلصَّـٰلِحِينَ",
    translation:
      '[And he said], "My Lord, grant me authority and join me with the righteous',
    normalizedText: "رب هب لي حكما والحقني بالصلحين",
  },
  {
    verseId: 83,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱجۡعَل لِّي لِسَانَ صِدۡقٖ فِي ٱلۡأٓخِرِينَ",
    translation: "And grant me a reputation of honor among later generations",
    normalizedText: "واجعل لي لسان صدق في الاخرين",
  },
  {
    verseId: 84,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱجۡعَلۡنِي مِن وَرَثَةِ جَنَّةِ ٱلنَّعِيمِ",
    translation: "And place me among the inheritors of the Garden of Pleasure",
    normalizedText: "واجعلني من ورثة جنة النعيم",
  },
  {
    verseId: 85,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱغۡفِرۡ لِأَبِيٓ إِنَّهُۥ كَانَ مِنَ ٱلضَّآلِّينَ",
    translation: "And forgive my father. Indeed, he has been of those astray",
    normalizedText: "واغفر لابي انه كان من الضالين",
  },
  {
    verseId: 86,
    name: "الشعراء",
    surahId: 26,
    text: "وَلَا تُخۡزِنِي يَوۡمَ يُبۡعَثُونَ",
    translation: "And do not disgrace me on the Day they are [all] resurrected",
    normalizedText: "ولا تخزني يوم يبعثون",
  },
  {
    verseId: 87,
    name: "الشعراء",
    surahId: 26,
    text: "يَوۡمَ لَا يَنفَعُ مَالٞ وَلَا بَنُونَ",
    translation:
      "The Day when there will not benefit [anyone] wealth or children",
    normalizedText: "يوم لا ينفع مال ولا بنون",
  },
  {
    verseId: 88,
    name: "الشعراء",
    surahId: 26,
    text: "إِلَّا مَنۡ أَتَى ٱللَّهَ بِقَلۡبٖ سَلِيمٖ",
    translation: "But only one who comes to Allah with a sound heart",
    normalizedText: "الا من اتى الله بقلب سليم",
  },
  {
    verseId: 89,
    name: "الشعراء",
    surahId: 26,
    text: "وَأُزۡلِفَتِ ٱلۡجَنَّةُ لِلۡمُتَّقِينَ",
    translation:
      "And Paradise will be brought near [that Day] to the righteous",
    normalizedText: "وازلفت الجنة للمتقين",
  },
  {
    verseId: 90,
    name: "الشعراء",
    surahId: 26,
    text: "وَبُرِّزَتِ ٱلۡجَحِيمُ لِلۡغَاوِينَ",
    translation: "And Hellfire will be brought forth for the deviators",
    normalizedText: "وبرزت الجحيم للغاوين",
  },
  {
    verseId: 91,
    name: "الشعراء",
    surahId: 26,
    text: "وَقِيلَ لَهُمۡ أَيۡنَ مَا كُنتُمۡ تَعۡبُدُونَ",
    translation:
      'And it will be said to them, "Where are those you used to worship',
    normalizedText: "وقيل لهم اين ما كنتم تعبدون",
  },
  {
    verseId: 92,
    name: "الشعراء",
    surahId: 26,
    text: "مِن دُونِ ٱللَّهِ هَلۡ يَنصُرُونَكُمۡ أَوۡ يَنتَصِرُونَ",
    translation: "Other than Allah? Can they help you or help themselves",
    normalizedText: "من دون الله هل ينصرونكم او ينتصرون",
  },
  {
    verseId: 93,
    name: "الشعراء",
    surahId: 26,
    text: "فَكُبۡكِبُواْ فِيهَا هُمۡ وَٱلۡغَاوُۥنَ",
    translation:
      "So they will be overturned into Hellfire, they and the deviators",
    normalizedText: "فكبكبوا فيها هم والغاون",
  },
  {
    verseId: 94,
    name: "الشعراء",
    surahId: 26,
    text: "وَجُنُودُ إِبۡلِيسَ أَجۡمَعُونَ",
    translation: "And the soldiers of Iblees, all together",
    normalizedText: "وجنود ابليس اجمعون",
  },
  {
    verseId: 95,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُواْ وَهُمۡ فِيهَا يَخۡتَصِمُونَ",
    translation: "They will say while they dispute therein",
    normalizedText: "قالوا وهم فيها يختصمون",
  },
  {
    verseId: 96,
    name: "الشعراء",
    surahId: 26,
    text: "تَٱللَّهِ إِن كُنَّا لَفِي ضَلَٰلٖ مُّبِينٍ",
    translation: "By Allah, we were indeed in manifest error",
    normalizedText: "تالله ان كنا لفي ضلل مبين",
  },
  {
    verseId: 97,
    name: "الشعراء",
    surahId: 26,
    text: "إِذۡ نُسَوِّيكُم بِرَبِّ ٱلۡعَٰلَمِينَ",
    translation: "When we equated you with the Lord of the worlds",
    normalizedText: "اذ نسويكم برب العلمين",
  },
  {
    verseId: 98,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَضَلَّنَآ إِلَّا ٱلۡمُجۡرِمُونَ",
    translation: "And no one misguided us except the criminals",
    normalizedText: "وما اضلنا الا المجرمون",
  },
  {
    verseId: 99,
    name: "الشعراء",
    surahId: 26,
    text: "فَمَا لَنَا مِن شَٰفِعِينَ",
    translation: "So now we have no intercessors",
    normalizedText: "فما لنا من شفعين",
  },
  {
    verseId: 100,
    name: "الشعراء",
    surahId: 26,
    text: "وَلَا صَدِيقٍ حَمِيمٖ",
    translation: "And not a devoted friend",
    normalizedText: "ولا صديق حميم",
  },
  {
    verseId: 101,
    name: "الشعراء",
    surahId: 26,
    text: "فَلَوۡ أَنَّ لَنَا كَرَّةٗ فَنَكُونَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "Then if we only had a return [to the world] and could be of the believers",
    normalizedText: "فلو ان لنا كرة فنكون من المامنين",
  },
  {
    verseId: 102,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 103,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 104,
    name: "الشعراء",
    surahId: 26,
    text: "كَذَّبَتۡ قَوۡمُ نُوحٍ ٱلۡمُرۡسَلِينَ",
    translation: "The people of Noah denied the messengers",
    normalizedText: "كذبت قوم نوح المرسلين",
  },
  {
    verseId: 105,
    name: "الشعراء",
    surahId: 26,
    text: "إِذۡ قَالَ لَهُمۡ أَخُوهُمۡ نُوحٌ أَلَا تَتَّقُونَ",
    translation:
      'When their brother Noah said to them, "Will you not fear Allah',
    normalizedText: "اذ قال لهم اخوهم نوح الا تتقون",
  },
  {
    verseId: 106,
    name: "الشعراء",
    surahId: 26,
    text: "إِنِّي لَكُمۡ رَسُولٌ أَمِينٞ",
    translation: "Indeed, I am to you a trustworthy messenger",
    normalizedText: "اني لكم رسول امين",
  },
  {
    verseId: 107,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 108,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مِنۡ أَجۡرٍۖ إِنۡ أَجۡرِيَ إِلَّا عَلَىٰ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "And I do not ask you for it any payment. My payment is only from the Lord of the worlds",
    normalizedText: "وما اسلكم عليه من اجر ان اجري الا على رب العلمين",
  },
  {
    verseId: 109,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 110,
    name: "الشعراء",
    surahId: 26,
    text: "۞قَالُوٓاْ أَنُؤۡمِنُ لَكَ وَٱتَّبَعَكَ ٱلۡأَرۡذَلُونَ",
    translation:
      'They said, "Should we believe you while you are followed by the lowest [class of people]',
    normalizedText: "۞قالوا انامن لك واتبعك الارذلون",
  },
  {
    verseId: 111,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ وَمَا عِلۡمِي بِمَا كَانُواْ يَعۡمَلُونَ",
    translation: 'He said, "And what is my knowledge of what they used to do',
    normalizedText: "قال وما علمي بما كانوا يعملون",
  },
  {
    verseId: 112,
    name: "الشعراء",
    surahId: 26,
    text: "إِنۡ حِسَابُهُمۡ إِلَّا عَلَىٰ رَبِّيۖ لَوۡ تَشۡعُرُونَ",
    translation: "Their account is only upon my Lord, if you [could] perceive",
    normalizedText: "ان حسابهم الا على ربي لو تشعرون",
  },
  {
    verseId: 113,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَنَا۠ بِطَارِدِ ٱلۡمُؤۡمِنِينَ",
    translation: "And I am not one to drive away the believers",
    normalizedText: "وما انا بطارد المامنين",
  },
  {
    verseId: 114,
    name: "الشعراء",
    surahId: 26,
    text: "إِنۡ أَنَا۠ إِلَّا نَذِيرٞ مُّبِينٞ",
    translation: "I am only a clear warner",
    normalizedText: "ان انا الا نذير مبين",
  },
  {
    verseId: 115,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُواْ لَئِن لَّمۡ تَنتَهِ يَٰنُوحُ لَتَكُونَنَّ مِنَ ٱلۡمَرۡجُومِينَ",
    translation:
      'They said, "If you do not desist, O Noah, you will surely be of those who are stoned',
    normalizedText: "قالوا لان لم تنته ينوح لتكونن من المرجومين",
  },
  {
    verseId: 116,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ رَبِّ إِنَّ قَوۡمِي كَذَّبُونِ",
    translation: 'He said, "My Lord, indeed my people have denied me',
    normalizedText: "قال رب ان قومي كذبون",
  },
  {
    verseId: 117,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱفۡتَحۡ بَيۡنِي وَبَيۡنَهُمۡ فَتۡحٗا وَنَجِّنِي وَمَن مَّعِيَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "Then judge between me and them with decisive judgement and save me and those with me of the believers",
    normalizedText: "فافتح بيني وبينهم فتحا ونجني ومن معي من المامنين",
  },
  {
    verseId: 118,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَنجَيۡنَٰهُ وَمَن مَّعَهُۥ فِي ٱلۡفُلۡكِ ٱلۡمَشۡحُونِ",
    translation: "So We saved him and those with him in the laden ship",
    normalizedText: "فانجينه ومن معه في الفلك المشحون",
  },
  {
    verseId: 119,
    name: "الشعراء",
    surahId: 26,
    text: "ثُمَّ أَغۡرَقۡنَا بَعۡدُ ٱلۡبَاقِينَ",
    translation: "Then We drowned thereafter the remaining ones",
    normalizedText: "ثم اغرقنا بعد الباقين",
  },
  {
    verseId: 120,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 121,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 122,
    name: "الشعراء",
    surahId: 26,
    text: "كَذَّبَتۡ عَادٌ ٱلۡمُرۡسَلِينَ",
    translation: "Aad denied the messengers",
    normalizedText: "كذبت عاد المرسلين",
  },
  {
    verseId: 123,
    name: "الشعراء",
    surahId: 26,
    text: "إِذۡ قَالَ لَهُمۡ أَخُوهُمۡ هُودٌ أَلَا تَتَّقُونَ",
    translation:
      'When their brother Hud said to them, "Will you not fear Allah',
    normalizedText: "اذ قال لهم اخوهم هود الا تتقون",
  },
  {
    verseId: 124,
    name: "الشعراء",
    surahId: 26,
    text: "إِنِّي لَكُمۡ رَسُولٌ أَمِينٞ",
    translation: "Indeed, I am to you a trustworthy messenger",
    normalizedText: "اني لكم رسول امين",
  },
  {
    verseId: 125,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 126,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مِنۡ أَجۡرٍۖ إِنۡ أَجۡرِيَ إِلَّا عَلَىٰ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "And I do not ask you for it any payment. My payment is only from the Lord of the worlds",
    normalizedText: "وما اسلكم عليه من اجر ان اجري الا على رب العلمين",
  },
  {
    verseId: 127,
    name: "الشعراء",
    surahId: 26,
    text: "أَتَبۡنُونَ بِكُلِّ رِيعٍ ءَايَةٗ تَعۡبَثُونَ",
    translation:
      "Do you construct on every elevation a sign, amusing yourselves",
    normalizedText: "اتبنون بكل ريع ءاية تعبثون",
  },
  {
    verseId: 128,
    name: "الشعراء",
    surahId: 26,
    text: "وَتَتَّخِذُونَ مَصَانِعَ لَعَلَّكُمۡ تَخۡلُدُونَ",
    translation:
      "And take for yourselves palaces and fortresses that you might abide eternally",
    normalizedText: "وتتخذون مصانع لعلكم تخلدون",
  },
  {
    verseId: 129,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِذَا بَطَشۡتُم بَطَشۡتُمۡ جَبَّارِينَ",
    translation: "And when you strike, you strike as tyrants",
    normalizedText: "واذا بطشتم بطشتم جبارين",
  },
  {
    verseId: 130,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 131,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱتَّقُواْ ٱلَّذِيٓ أَمَدَّكُم بِمَا تَعۡلَمُونَ",
    translation: "And fear He who provided you with that which you know",
    normalizedText: "واتقوا الذي امدكم بما تعلمون",
  },
  {
    verseId: 132,
    name: "الشعراء",
    surahId: 26,
    text: "أَمَدَّكُم بِأَنۡعَٰمٖ وَبَنِينَ",
    translation: "Provided you with grazing livestock and children",
    normalizedText: "امدكم بانعم وبنين",
  },
  {
    verseId: 133,
    name: "الشعراء",
    surahId: 26,
    text: "وَجَنَّـٰتٖ وَعُيُونٍ",
    translation: "And gardens and springs",
    normalizedText: "وجنت وعيون",
  },
  {
    verseId: 134,
    name: "الشعراء",
    surahId: 26,
    text: "إِنِّيٓ أَخَافُ عَلَيۡكُمۡ عَذَابَ يَوۡمٍ عَظِيمٖ",
    translation: "Indeed, I fear for you the punishment of a terrible day",
    normalizedText: "اني اخاف عليكم عذاب يوم عظيم",
  },
  {
    verseId: 135,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُواْ سَوَآءٌ عَلَيۡنَآ أَوَعَظۡتَ أَمۡ لَمۡ تَكُن مِّنَ ٱلۡوَٰعِظِينَ",
    translation:
      'They said, "It is all the same to us whether you advise or are not of the advisors',
    normalizedText: "قالوا سواء علينا اوعظت ام لم تكن من الوعظين",
  },
  {
    verseId: 136,
    name: "الشعراء",
    surahId: 26,
    text: "إِنۡ هَٰذَآ إِلَّا خُلُقُ ٱلۡأَوَّلِينَ",
    translation: "This is not but the custom of the former peoples",
    normalizedText: "ان هذا الا خلق الاولين",
  },
  {
    verseId: 137,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَا نَحۡنُ بِمُعَذَّبِينَ",
    translation: "And we are not to be punished",
    normalizedText: "وما نحن بمعذبين",
  },
  {
    verseId: 138,
    name: "الشعراء",
    surahId: 26,
    text: "فَكَذَّبُوهُ فَأَهۡلَكۡنَٰهُمۡۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "And they denied him, so We destroyed them. Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "فكذبوه فاهلكنهم ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 139,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 140,
    name: "الشعراء",
    surahId: 26,
    text: "كَذَّبَتۡ ثَمُودُ ٱلۡمُرۡسَلِينَ",
    translation: "Thamud denied the messengers",
    normalizedText: "كذبت ثمود المرسلين",
  },
  {
    verseId: 141,
    name: "الشعراء",
    surahId: 26,
    text: "إِذۡ قَالَ لَهُمۡ أَخُوهُمۡ صَٰلِحٌ أَلَا تَتَّقُونَ",
    translation:
      'When their brother Salih said to them, "Will you not fear Allah',
    normalizedText: "اذ قال لهم اخوهم صلح الا تتقون",
  },
  {
    verseId: 142,
    name: "الشعراء",
    surahId: 26,
    text: "إِنِّي لَكُمۡ رَسُولٌ أَمِينٞ",
    translation: "Indeed, I am to you a trustworthy messenger",
    normalizedText: "اني لكم رسول امين",
  },
  {
    verseId: 143,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 144,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مِنۡ أَجۡرٍۖ إِنۡ أَجۡرِيَ إِلَّا عَلَىٰ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "And I do not ask you for it any payment. My payment is only from the Lord of the worlds",
    normalizedText: "وما اسلكم عليه من اجر ان اجري الا على رب العلمين",
  },
  {
    verseId: 145,
    name: "الشعراء",
    surahId: 26,
    text: "أَتُتۡرَكُونَ فِي مَا هَٰهُنَآ ءَامِنِينَ",
    translation: "Will you be left in what is here, secure [from death]",
    normalizedText: "اتتركون في ما ههنا ءامنين",
  },
  {
    verseId: 146,
    name: "الشعراء",
    surahId: 26,
    text: "فِي جَنَّـٰتٖ وَعُيُونٖ",
    translation: "Within gardens and springs",
    normalizedText: "في جنت وعيون",
  },
  {
    verseId: 147,
    name: "الشعراء",
    surahId: 26,
    text: "وَزُرُوعٖ وَنَخۡلٖ طَلۡعُهَا هَضِيمٞ",
    translation: "And fields of crops and palm trees with softened fruit",
    normalizedText: "وزروع ونخل طلعها هضيم",
  },
  {
    verseId: 148,
    name: "الشعراء",
    surahId: 26,
    text: "وَتَنۡحِتُونَ مِنَ ٱلۡجِبَالِ بُيُوتٗا فَٰرِهِينَ",
    translation: "And you carve out of the mountains, homes, with skill",
    normalizedText: "وتنحتون من الجبال بيوتا فرهين",
  },
  {
    verseId: 149,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 150,
    name: "الشعراء",
    surahId: 26,
    text: "وَلَا تُطِيعُوٓاْ أَمۡرَ ٱلۡمُسۡرِفِينَ",
    translation: "And do not obey the order of the transgressors",
    normalizedText: "ولا تطيعوا امر المسرفين",
  },
  {
    verseId: 151,
    name: "الشعراء",
    surahId: 26,
    text: "ٱلَّذِينَ يُفۡسِدُونَ فِي ٱلۡأَرۡضِ وَلَا يُصۡلِحُونَ",
    translation: "Who cause corruption in the land and do not amend",
    normalizedText: "الذين يفسدون في الارض ولا يصلحون",
  },
  {
    verseId: 152,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُوٓاْ إِنَّمَآ أَنتَ مِنَ ٱلۡمُسَحَّرِينَ",
    translation: 'They said, "You are only of those affected by magic',
    normalizedText: "قالوا انما انت من المسحرين",
  },
  {
    verseId: 153,
    name: "الشعراء",
    surahId: 26,
    text: "مَآ أَنتَ إِلَّا بَشَرٞ مِّثۡلُنَا فَأۡتِ بِـَٔايَةٍ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      "You are but a man like ourselves, so bring a sign, if you should be of the truthful",
    normalizedText: "ما انت الا بشر مثلنا فات باية ان كنت من الصدقين",
  },
  {
    verseId: 154,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ هَٰذِهِۦ نَاقَةٞ لَّهَا شِرۡبٞ وَلَكُمۡ شِرۡبُ يَوۡمٖ مَّعۡلُومٖ",
    translation:
      'He said, "This is a she-camel. For her is a [time of] drink, and for you is a [time of] drink, [each] on a known day',
    normalizedText: "قال هذه ناقة لها شرب ولكم شرب يوم معلوم",
  },
  {
    verseId: 155,
    name: "الشعراء",
    surahId: 26,
    text: "وَلَا تَمَسُّوهَا بِسُوٓءٖ فَيَأۡخُذَكُمۡ عَذَابُ يَوۡمٍ عَظِيمٖ",
    translation:
      "And do not touch her with harm, lest you be seized by the punishment of a terrible day",
    normalizedText: "ولا تمسوها بسوء فياخذكم عذاب يوم عظيم",
  },
  {
    verseId: 156,
    name: "الشعراء",
    surahId: 26,
    text: "فَعَقَرُوهَا فَأَصۡبَحُواْ نَٰدِمِينَ",
    translation: "But they hamstrung her and so became regretful",
    normalizedText: "فعقروها فاصبحوا ندمين",
  },
  {
    verseId: 157,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَخَذَهُمُ ٱلۡعَذَابُۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "And the punishment seized them. Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "فاخذهم العذاب ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 158,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 159,
    name: "الشعراء",
    surahId: 26,
    text: "كَذَّبَتۡ قَوۡمُ لُوطٍ ٱلۡمُرۡسَلِينَ",
    translation: "The people of Lot denied the messengers",
    normalizedText: "كذبت قوم لوط المرسلين",
  },
  {
    verseId: 160,
    name: "الشعراء",
    surahId: 26,
    text: "إِذۡ قَالَ لَهُمۡ أَخُوهُمۡ لُوطٌ أَلَا تَتَّقُونَ",
    translation:
      'When their brother Lot said to them, "Will you not fear Allah',
    normalizedText: "اذ قال لهم اخوهم لوط الا تتقون",
  },
  {
    verseId: 161,
    name: "الشعراء",
    surahId: 26,
    text: "إِنِّي لَكُمۡ رَسُولٌ أَمِينٞ",
    translation: "Indeed, I am to you a trustworthy messenger",
    normalizedText: "اني لكم رسول امين",
  },
  {
    verseId: 162,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 163,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مِنۡ أَجۡرٍۖ إِنۡ أَجۡرِيَ إِلَّا عَلَىٰ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "And I do not ask you for it any payment. My payment is only from the Lord of the worlds",
    normalizedText: "وما اسلكم عليه من اجر ان اجري الا على رب العلمين",
  },
  {
    verseId: 164,
    name: "الشعراء",
    surahId: 26,
    text: "أَتَأۡتُونَ ٱلذُّكۡرَانَ مِنَ ٱلۡعَٰلَمِينَ",
    translation: "Do you approach males among the worlds",
    normalizedText: "اتاتون الذكران من العلمين",
  },
  {
    verseId: 165,
    name: "الشعراء",
    surahId: 26,
    text: "وَتَذَرُونَ مَا خَلَقَ لَكُمۡ رَبُّكُم مِّنۡ أَزۡوَٰجِكُمۚ بَلۡ أَنتُمۡ قَوۡمٌ عَادُونَ",
    translation:
      "And leave what your Lord has created for you as mates? But you are a people transgressing",
    normalizedText: "وتذرون ما خلق لكم ربكم من ازوجكم بل انتم قوم عادون",
  },
  {
    verseId: 166,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُواْ لَئِن لَّمۡ تَنتَهِ يَٰلُوطُ لَتَكُونَنَّ مِنَ ٱلۡمُخۡرَجِينَ",
    translation:
      'They said, "If you do not desist, O Lot, you will surely be of those evicted',
    normalizedText: "قالوا لان لم تنته يلوط لتكونن من المخرجين",
  },
  {
    verseId: 167,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ إِنِّي لِعَمَلِكُم مِّنَ ٱلۡقَالِينَ",
    translation:
      'He said, "Indeed, I am, toward your deed, of those who detest [it]',
    normalizedText: "قال اني لعملكم من القالين",
  },
  {
    verseId: 168,
    name: "الشعراء",
    surahId: 26,
    text: "رَبِّ نَجِّنِي وَأَهۡلِي مِمَّا يَعۡمَلُونَ",
    translation:
      "My Lord, save me and my family from [the consequence of] what they do",
    normalizedText: "رب نجني واهلي مما يعملون",
  },
  {
    verseId: 169,
    name: "الشعراء",
    surahId: 26,
    text: "فَنَجَّيۡنَٰهُ وَأَهۡلَهُۥٓ أَجۡمَعِينَ",
    translation: "So We saved him and his family, all",
    normalizedText: "فنجينه واهله اجمعين",
  },
  {
    verseId: 170,
    name: "الشعراء",
    surahId: 26,
    text: "إِلَّا عَجُوزٗا فِي ٱلۡغَٰبِرِينَ",
    translation: "Except an old woman among those who remained behind",
    normalizedText: "الا عجوزا في الغبرين",
  },
  {
    verseId: 171,
    name: "الشعراء",
    surahId: 26,
    text: "ثُمَّ دَمَّرۡنَا ٱلۡأٓخَرِينَ",
    translation: "Then We destroyed the others",
    normalizedText: "ثم دمرنا الاخرين",
  },
  {
    verseId: 172,
    name: "الشعراء",
    surahId: 26,
    text: "وَأَمۡطَرۡنَا عَلَيۡهِم مَّطَرٗاۖ فَسَآءَ مَطَرُ ٱلۡمُنذَرِينَ",
    translation:
      "And We rained upon them a rain [of stones], and evil was the rain of those who were warned",
    normalizedText: "وامطرنا عليهم مطرا فساء مطر المنذرين",
  },
  {
    verseId: 173,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 174,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 175,
    name: "الشعراء",
    surahId: 26,
    text: "كَذَّبَ أَصۡحَٰبُ لۡـَٔيۡكَةِ ٱلۡمُرۡسَلِينَ",
    translation: "The companions of the thicket denied the messengers",
    normalizedText: "كذب اصحب ليكة المرسلين",
  },
  {
    verseId: 176,
    name: "الشعراء",
    surahId: 26,
    text: "إِذۡ قَالَ لَهُمۡ شُعَيۡبٌ أَلَا تَتَّقُونَ",
    translation: `When Shu'ayb said to them, "Will you not fear Allah`,
    normalizedText: "اذ قال لهم شعيب الا تتقون",
  },
  {
    verseId: 177,
    name: "الشعراء",
    surahId: 26,
    text: "إِنِّي لَكُمۡ رَسُولٌ أَمِينٞ",
    translation: "Indeed, I am to you a trustworthy messenger",
    normalizedText: "اني لكم رسول امين",
  },
  {
    verseId: 178,
    name: "الشعراء",
    surahId: 26,
    text: "فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation: "So fear Allah and obey me",
    normalizedText: "فاتقوا الله واطيعون",
  },
  {
    verseId: 179,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مِنۡ أَجۡرٍۖ إِنۡ أَجۡرِيَ إِلَّا عَلَىٰ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "And I do not ask you for it any payment. My payment is only from the Lord of the worlds",
    normalizedText: "وما اسلكم عليه من اجر ان اجري الا على رب العلمين",
  },
  {
    verseId: 180,
    name: "الشعراء",
    surahId: 26,
    text: "۞أَوۡفُواْ ٱلۡكَيۡلَ وَلَا تَكُونُواْ مِنَ ٱلۡمُخۡسِرِينَ",
    translation: "Give full measure and do not be of those who cause loss",
    normalizedText: "۞اوفوا الكيل ولا تكونوا من المخسرين",
  },
  {
    verseId: 181,
    name: "الشعراء",
    surahId: 26,
    text: "وَزِنُواْ بِٱلۡقِسۡطَاسِ ٱلۡمُسۡتَقِيمِ",
    translation: "And weigh with an even balance",
    normalizedText: "وزنوا بالقسطاس المستقيم",
  },
  {
    verseId: 182,
    name: "الشعراء",
    surahId: 26,
    text: "وَلَا تَبۡخَسُواْ ٱلنَّاسَ أَشۡيَآءَهُمۡ وَلَا تَعۡثَوۡاْ فِي ٱلۡأَرۡضِ مُفۡسِدِينَ",
    translation:
      "And do not deprive people of their due and do not commit abuse on earth, spreading corruption",
    normalizedText: "ولا تبخسوا الناس اشياءهم ولا تعثوا في الارض مفسدين",
  },
  {
    verseId: 183,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱتَّقُواْ ٱلَّذِي خَلَقَكُمۡ وَٱلۡجِبِلَّةَ ٱلۡأَوَّلِينَ",
    translation: "And fear He who created you and the former creation",
    normalizedText: "واتقوا الذي خلقكم والجبلة الاولين",
  },
  {
    verseId: 184,
    name: "الشعراء",
    surahId: 26,
    text: "قَالُوٓاْ إِنَّمَآ أَنتَ مِنَ ٱلۡمُسَحَّرِينَ",
    translation: 'They said, "You are only of those affected by magic',
    normalizedText: "قالوا انما انت من المسحرين",
  },
  {
    verseId: 185,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَنتَ إِلَّا بَشَرٞ مِّثۡلُنَا وَإِن نَّظُنُّكَ لَمِنَ ٱلۡكَٰذِبِينَ",
    translation:
      "You are but a man like ourselves, and indeed, we think you are among the liars",
    normalizedText: "وما انت الا بشر مثلنا وان نظنك لمن الكذبين",
  },
  {
    verseId: 186,
    name: "الشعراء",
    surahId: 26,
    text: "فَأَسۡقِطۡ عَلَيۡنَا كِسَفٗا مِّنَ ٱلسَّمَآءِ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      "So cause to fall upon us fragments of the sky, if you should be of the truthful",
    normalizedText: "فاسقط علينا كسفا من السماء ان كنت من الصدقين",
  },
  {
    verseId: 187,
    name: "الشعراء",
    surahId: 26,
    text: "قَالَ رَبِّيٓ أَعۡلَمُ بِمَا تَعۡمَلُونَ",
    translation: 'He said, "My Lord is most knowing of what you do',
    normalizedText: "قال ربي اعلم بما تعملون",
  },
  {
    verseId: 188,
    name: "الشعراء",
    surahId: 26,
    text: "فَكَذَّبُوهُ فَأَخَذَهُمۡ عَذَابُ يَوۡمِ ٱلظُّلَّةِۚ إِنَّهُۥ كَانَ عَذَابَ يَوۡمٍ عَظِيمٍ",
    translation:
      "And they denied him, so the punishment of the day of the black cloud seized them. Indeed, it was the punishment of a terrible day",
    normalizedText: "فكذبوه فاخذهم عذاب يوم الظلة انه كان عذاب يوم عظيم",
  },
  {
    verseId: 189,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّ فِي ذَٰلِكَ لَأٓيَةٗۖ وَمَا كَانَ أَكۡثَرُهُم مُّؤۡمِنِينَ",
    translation:
      "Indeed in that is a sign, but most of them were not to be believers",
    normalizedText: "ان في ذلك لاية وما كان اكثرهم مامنين",
  },
  {
    verseId: 190,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّ رَبَّكَ لَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "And indeed, your Lord - He is the Exalted in Might, the Merciful",
    normalizedText: "وان ربك لهو العزيز الرحيم",
  },
  {
    verseId: 191,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّهُۥ لَتَنزِيلُ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "And indeed, the Qur'an is the revelation of the Lord of the worlds",
    normalizedText: "وانه لتنزيل رب العلمين",
  },
  {
    verseId: 192,
    name: "الشعراء",
    surahId: 26,
    text: "نَزَلَ بِهِ ٱلرُّوحُ ٱلۡأَمِينُ",
    translation: "The Trustworthy Spirit has brought it down",
    normalizedText: "نزل به الروح الامين",
  },
  {
    verseId: 193,
    name: "الشعراء",
    surahId: 26,
    text: "عَلَىٰ قَلۡبِكَ لِتَكُونَ مِنَ ٱلۡمُنذِرِينَ",
    translation:
      "Upon your heart, [O Muhammad] - that you may be of the warners",
    normalizedText: "على قلبك لتكون من المنذرين",
  },
  {
    verseId: 194,
    name: "الشعراء",
    surahId: 26,
    text: "بِلِسَانٍ عَرَبِيّٖ مُّبِينٖ",
    translation: "In a clear Arabic language",
    normalizedText: "بلسان عربي مبين",
  },
  {
    verseId: 195,
    name: "الشعراء",
    surahId: 26,
    text: "وَإِنَّهُۥ لَفِي زُبُرِ ٱلۡأَوَّلِينَ",
    translation:
      "And indeed, it is [mentioned] in the scriptures of former peoples",
    normalizedText: "وانه لفي زبر الاولين",
  },
  {
    verseId: 196,
    name: "الشعراء",
    surahId: 26,
    text: "أَوَلَمۡ يَكُن لَّهُمۡ ءَايَةً أَن يَعۡلَمَهُۥ عُلَمَـٰٓؤُاْ بَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation:
      "And has it not been a sign to them that it is recognized by the scholars of the Children of Israel",
    normalizedText: "اولم يكن لهم ءاية ان يعلمه علماا بني اسرءيل",
  },
  {
    verseId: 197,
    name: "الشعراء",
    surahId: 26,
    text: "وَلَوۡ نَزَّلۡنَٰهُ عَلَىٰ بَعۡضِ ٱلۡأَعۡجَمِينَ",
    translation: "And even if We had revealed it to one among the foreigners",
    normalizedText: "ولو نزلنه على بعض الاعجمين",
  },
  {
    verseId: 198,
    name: "الشعراء",
    surahId: 26,
    text: "فَقَرَأَهُۥ عَلَيۡهِم مَّا كَانُواْ بِهِۦ مُؤۡمِنِينَ",
    translation:
      "And he had recited it to them [perfectly], they would [still] not have been believers in it",
    normalizedText: "فقراه عليهم ما كانوا به مامنين",
  },
  {
    verseId: 199,
    name: "الشعراء",
    surahId: 26,
    text: "كَذَٰلِكَ سَلَكۡنَٰهُ فِي قُلُوبِ ٱلۡمُجۡرِمِينَ",
    translation:
      "Thus have We inserted disbelief into the hearts of the criminals",
    normalizedText: "كذلك سلكنه في قلوب المجرمين",
  },
  {
    verseId: 200,
    name: "الشعراء",
    surahId: 26,
    text: "لَا يُؤۡمِنُونَ بِهِۦ حَتَّىٰ يَرَوُاْ ٱلۡعَذَابَ ٱلۡأَلِيمَ",
    translation:
      "They will not believe in it until they see the painful punishment",
    normalizedText: "لا يامنون به حتى يروا العذاب الاليم",
  },
  {
    verseId: 201,
    name: "الشعراء",
    surahId: 26,
    text: "فَيَأۡتِيَهُم بَغۡتَةٗ وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      "And it will come to them suddenly while they perceive [it] not",
    normalizedText: "فياتيهم بغتة وهم لا يشعرون",
  },
  {
    verseId: 202,
    name: "الشعراء",
    surahId: 26,
    text: "فَيَقُولُواْ هَلۡ نَحۡنُ مُنظَرُونَ",
    translation: 'And they will say, "May we be reprieved',
    normalizedText: "فيقولوا هل نحن منظرون",
  },
  {
    verseId: 203,
    name: "الشعراء",
    surahId: 26,
    text: "أَفَبِعَذَابِنَا يَسۡتَعۡجِلُونَ",
    translation: "So for Our punishment are they impatient",
    normalizedText: "افبعذابنا يستعجلون",
  },
  {
    verseId: 204,
    name: "الشعراء",
    surahId: 26,
    text: "أَفَرَءَيۡتَ إِن مَّتَّعۡنَٰهُمۡ سِنِينَ",
    translation: "Then have you considered if We gave them enjoyment for years",
    normalizedText: "افرءيت ان متعنهم سنين",
  },
  {
    verseId: 205,
    name: "الشعراء",
    surahId: 26,
    text: "ثُمَّ جَآءَهُم مَّا كَانُواْ يُوعَدُونَ",
    translation: "And then there came to them that which they were promised",
    normalizedText: "ثم جاءهم ما كانوا يوعدون",
  },
  {
    verseId: 206,
    name: "الشعراء",
    surahId: 26,
    text: "مَآ أَغۡنَىٰ عَنۡهُم مَّا كَانُواْ يُمَتَّعُونَ",
    translation:
      "They would not be availed by the enjoyment with which they were provided",
    normalizedText: "ما اغنى عنهم ما كانوا يمتعون",
  },
  {
    verseId: 207,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَآ أَهۡلَكۡنَا مِن قَرۡيَةٍ إِلَّا لَهَا مُنذِرُونَ",
    translation: "And We did not destroy any city except that it had warners",
    normalizedText: "وما اهلكنا من قرية الا لها منذرون",
  },
  {
    verseId: 208,
    name: "الشعراء",
    surahId: 26,
    text: "ذِكۡرَىٰ وَمَا كُنَّا ظَٰلِمِينَ",
    translation: "As a reminder; and never have We been unjust",
    normalizedText: "ذكرى وما كنا ظلمين",
  },
  {
    verseId: 209,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَا تَنَزَّلَتۡ بِهِ ٱلشَّيَٰطِينُ",
    translation: "And the devils have not brought the revelation down",
    normalizedText: "وما تنزلت به الشيطين",
  },
  {
    verseId: 210,
    name: "الشعراء",
    surahId: 26,
    text: "وَمَا يَنۢبَغِي لَهُمۡ وَمَا يَسۡتَطِيعُونَ",
    translation: "It is not allowable for them, nor would they be able",
    normalizedText: "وما ينبغي لهم وما يستطيعون",
  },
  {
    verseId: 211,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّهُمۡ عَنِ ٱلسَّمۡعِ لَمَعۡزُولُونَ",
    translation: "Indeed they, from [its] hearing, are removed",
    normalizedText: "انهم عن السمع لمعزولون",
  },
  {
    verseId: 212,
    name: "الشعراء",
    surahId: 26,
    text: "فَلَا تَدۡعُ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَتَكُونَ مِنَ ٱلۡمُعَذَّبِينَ",
    translation:
      "So do not invoke with Allah another deity and [thus] be among the punished",
    normalizedText: "فلا تدع مع الله الها ءاخر فتكون من المعذبين",
  },
  {
    verseId: 213,
    name: "الشعراء",
    surahId: 26,
    text: "وَأَنذِرۡ عَشِيرَتَكَ ٱلۡأَقۡرَبِينَ",
    translation: "And warn, [O Muhammad], your closest kindred",
    normalizedText: "وانذر عشيرتك الاقربين",
  },
  {
    verseId: 214,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱخۡفِضۡ جَنَاحَكَ لِمَنِ ٱتَّبَعَكَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation: "And lower your wing to those who follow you of the believers",
    normalizedText: "واخفض جناحك لمن اتبعك من المامنين",
  },
  {
    verseId: 215,
    name: "الشعراء",
    surahId: 26,
    text: "فَإِنۡ عَصَوۡكَ فَقُلۡ إِنِّي بَرِيٓءٞ مِّمَّا تَعۡمَلُونَ",
    translation:
      'And if they disobey you, then say, "Indeed, I am disassociated from what you are doing',
    normalizedText: "فان عصوك فقل اني بريء مما تعملون",
  },
  {
    verseId: 216,
    name: "الشعراء",
    surahId: 26,
    text: "وَتَوَكَّلۡ عَلَى ٱلۡعَزِيزِ ٱلرَّحِيمِ",
    translation: "And rely upon the Exalted in Might, the Merciful",
    normalizedText: "وتوكل على العزيز الرحيم",
  },
  {
    verseId: 217,
    name: "الشعراء",
    surahId: 26,
    text: "ٱلَّذِي يَرَىٰكَ حِينَ تَقُومُ",
    translation: "Who sees you when you arise",
    normalizedText: "الذي يرىك حين تقوم",
  },
  {
    verseId: 218,
    name: "الشعراء",
    surahId: 26,
    text: "وَتَقَلُّبَكَ فِي ٱلسَّـٰجِدِينَ",
    translation: "And your movement among those who prostrate",
    normalizedText: "وتقلبك في السجدين",
  },
  {
    verseId: 219,
    name: "الشعراء",
    surahId: 26,
    text: "إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation: "Indeed, He is the Hearing, the Knowing",
    normalizedText: "انه هو السميع العليم",
  },
  {
    verseId: 220,
    name: "الشعراء",
    surahId: 26,
    text: "هَلۡ أُنَبِّئُكُمۡ عَلَىٰ مَن تَنَزَّلُ ٱلشَّيَٰطِينُ",
    translation: "Shall I inform you upon whom the devils descend",
    normalizedText: "هل انباكم على من تنزل الشيطين",
  },
  {
    verseId: 221,
    name: "الشعراء",
    surahId: 26,
    text: "تَنَزَّلُ عَلَىٰ كُلِّ أَفَّاكٍ أَثِيمٖ",
    translation: "They descend upon every sinful liar",
    normalizedText: "تنزل على كل افاك اثيم",
  },
  {
    verseId: 222,
    name: "الشعراء",
    surahId: 26,
    text: "يُلۡقُونَ ٱلسَّمۡعَ وَأَكۡثَرُهُمۡ كَٰذِبُونَ",
    translation: "They pass on what is heard, and most of them are liars",
    normalizedText: "يلقون السمع واكثرهم كذبون",
  },
  {
    verseId: 223,
    name: "الشعراء",
    surahId: 26,
    text: "وَٱلشُّعَرَآءُ يَتَّبِعُهُمُ ٱلۡغَاوُۥنَ",
    translation: "And the poets - [only] the deviators follow them",
    normalizedText: "والشعراء يتبعهم الغاون",
  },
  {
    verseId: 224,
    name: "الشعراء",
    surahId: 26,
    text: "أَلَمۡ تَرَ أَنَّهُمۡ فِي كُلِّ وَادٖ يَهِيمُونَ",
    translation: "Do you not see that in every valley they roam",
    normalizedText: "الم تر انهم في كل واد يهيمون",
  },
  {
    verseId: 225,
    name: "الشعراء",
    surahId: 26,
    text: "وَأَنَّهُمۡ يَقُولُونَ مَا لَا يَفۡعَلُونَ",
    translation: "And that they say what they do not do",
    normalizedText: "وانهم يقولون ما لا يفعلون",
  },
  {
    verseId: 226,
    name: "الشعراء",
    surahId: 26,
    text: "إِلَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَذَكَرُواْ ٱللَّهَ كَثِيرٗا وَٱنتَصَرُواْ مِنۢ بَعۡدِ مَا ظُلِمُواْۗ وَسَيَعۡلَمُ ٱلَّذِينَ ظَلَمُوٓاْ أَيَّ مُنقَلَبٖ يَنقَلِبُونَ",
    translation:
      "Except those [poets] who believe and do righteous deeds and remember Allah often and defend [the Muslims] after they were wronged. And those who have wronged are going to know to what [kind of] return they will be returned",
    normalizedText:
      "الا الذين ءامنوا وعملوا الصلحت وذكروا الله كثيرا وانتصروا من بعد ما ظلموا وسيعلم الذين ظلموا اي منقلب ينقلبون",
  },
  {
    verseId: 0,
    name: "النمل",
    surahId: 27,
    text: "طسٓۚ تِلۡكَ ءَايَٰتُ ٱلۡقُرۡءَانِ وَكِتَابٖ مُّبِينٍ",
    translation:
      "Ta, Seen. These are the verses of the Qur'an and a clear Book",
    normalizedText: "طس تلك ءايت القرءان وكتاب مبين",
  },
  {
    verseId: 1,
    name: "النمل",
    surahId: 27,
    text: "هُدٗى وَبُشۡرَىٰ لِلۡمُؤۡمِنِينَ",
    translation: "As guidance and good tidings for the believers",
    normalizedText: "هدى وبشرى للمامنين",
  },
  {
    verseId: 2,
    name: "النمل",
    surahId: 27,
    text: "ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤۡتُونَ ٱلزَّكَوٰةَ وَهُم بِٱلۡأٓخِرَةِ هُمۡ يُوقِنُونَ",
    translation:
      "Who establish prayer and give zakah, and of the Hereafter they are certain [in faith]",
    normalizedText: "الذين يقيمون الصلوة وياتون الزكوة وهم بالاخرة هم يوقنون",
  },
  {
    verseId: 3,
    name: "النمل",
    surahId: 27,
    text: "إِنَّ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ زَيَّنَّا لَهُمۡ أَعۡمَٰلَهُمۡ فَهُمۡ يَعۡمَهُونَ",
    translation:
      "Indeed, for those who do not believe in the Hereafter, We have made pleasing to them their deeds, so they wander blindly",
    normalizedText: "ان الذين لا يامنون بالاخرة زينا لهم اعملهم فهم يعمهون",
  },
  {
    verseId: 4,
    name: "النمل",
    surahId: 27,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ لَهُمۡ سُوٓءُ ٱلۡعَذَابِ وَهُمۡ فِي ٱلۡأٓخِرَةِ هُمُ ٱلۡأَخۡسَرُونَ",
    translation:
      "Those are the ones for whom there will be the worst of punishment, and in the Hereafter they are the greatest losers",
    normalizedText: "اولاك الذين لهم سوء العذاب وهم في الاخرة هم الاخسرون",
  },
  {
    verseId: 5,
    name: "النمل",
    surahId: 27,
    text: "وَإِنَّكَ لَتُلَقَّى ٱلۡقُرۡءَانَ مِن لَّدُنۡ حَكِيمٍ عَلِيمٍ",
    translation:
      "And indeed, [O Muhammad], you receive the Qur'an from one Wise and Knowing",
    normalizedText: "وانك لتلقى القرءان من لدن حكيم عليم",
  },
  {
    verseId: 6,
    name: "النمل",
    surahId: 27,
    text: "إِذۡ قَالَ مُوسَىٰ لِأَهۡلِهِۦٓ إِنِّيٓ ءَانَسۡتُ نَارٗا سَـَٔاتِيكُم مِّنۡهَا بِخَبَرٍ أَوۡ ءَاتِيكُم بِشِهَابٖ قَبَسٖ لَّعَلَّكُمۡ تَصۡطَلُونَ",
    translation:
      '[Mention] when Moses said to his family, "Indeed, I have perceived a fire. I will bring you from there information or will bring you a burning torch that you may warm yourselves',
    normalizedText:
      "اذ قال موسى لاهله اني ءانست نارا ساتيكم منها بخبر او ءاتيكم بشهاب قبس لعلكم تصطلون",
  },
  {
    verseId: 7,
    name: "النمل",
    surahId: 27,
    text: "فَلَمَّا جَآءَهَا نُودِيَ أَنۢ بُورِكَ مَن فِي ٱلنَّارِ وَمَنۡ حَوۡلَهَا وَسُبۡحَٰنَ ٱللَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'But when he came to it, he was called, "Blessed is whoever is at the fire and whoever is around it. And exalted is Allah, Lord of the worlds',
    normalizedText:
      "فلما جاءها نودي ان بورك من في النار ومن حولها وسبحن الله رب العلمين",
  },
  {
    verseId: 8,
    name: "النمل",
    surahId: 27,
    text: "يَٰمُوسَىٰٓ إِنَّهُۥٓ أَنَا ٱللَّهُ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "O Moses, indeed it is I - Allah, the Exalted in Might, the Wise",
    normalizedText: "يموسى انه انا الله العزيز الحكيم",
  },
  {
    verseId: 9,
    name: "النمل",
    surahId: 27,
    text: "وَأَلۡقِ عَصَاكَۚ فَلَمَّا رَءَاهَا تَهۡتَزُّ كَأَنَّهَا جَآنّٞ وَلَّىٰ مُدۡبِرٗا وَلَمۡ يُعَقِّبۡۚ يَٰمُوسَىٰ لَا تَخَفۡ إِنِّي لَا يَخَافُ لَدَيَّ ٱلۡمُرۡسَلُونَ",
    translation:
      'And [he was told], "Throw down your staff." But when he saw it writhing as if it were a snake, he turned in flight and did not return. [Allah said], "O Moses, fear not. Indeed, in My presence the messengers do not fear',
    normalizedText:
      "والق عصاك فلما رءاها تهتز كانها جان ولى مدبرا ولم يعقب يموسى لا تخف اني لا يخاف لدي المرسلون",
  },
  {
    verseId: 10,
    name: "النمل",
    surahId: 27,
    text: "إِلَّا مَن ظَلَمَ ثُمَّ بَدَّلَ حُسۡنَۢا بَعۡدَ سُوٓءٖ فَإِنِّي غَفُورٞ رَّحِيمٞ",
    translation:
      "Otherwise, he who wrongs, then substitutes good after evil - indeed, I am Forgiving and Merciful",
    normalizedText: "الا من ظلم ثم بدل حسنا بعد سوء فاني غفور رحيم",
  },
  {
    verseId: 11,
    name: "النمل",
    surahId: 27,
    text: "وَأَدۡخِلۡ يَدَكَ فِي جَيۡبِكَ تَخۡرُجۡ بَيۡضَآءَ مِنۡ غَيۡرِ سُوٓءٖۖ فِي تِسۡعِ ءَايَٰتٍ إِلَىٰ فِرۡعَوۡنَ وَقَوۡمِهِۦٓۚ إِنَّهُمۡ كَانُواْ قَوۡمٗا فَٰسِقِينَ",
    translation:
      "And put your hand into the opening of your garment [at the breast]; it will come out white without disease. [These are] among the nine signs [you will take] to Pharaoh and his people. Indeed, they have been a people defiantly disobedient",
    normalizedText:
      "وادخل يدك في جيبك تخرج بيضاء من غير سوء في تسع ءايت الى فرعون وقومه انهم كانوا قوما فسقين",
  },
  {
    verseId: 12,
    name: "النمل",
    surahId: 27,
    text: "فَلَمَّا جَآءَتۡهُمۡ ءَايَٰتُنَا مُبۡصِرَةٗ قَالُواْ هَٰذَا سِحۡرٞ مُّبِينٞ",
    translation:
      'But when there came to them Our visible signs, they said, "This is obvious magic',
    normalizedText: "فلما جاءتهم ءايتنا مبصرة قالوا هذا سحر مبين",
  },
  {
    verseId: 13,
    name: "النمل",
    surahId: 27,
    text: "وَجَحَدُواْ بِهَا وَٱسۡتَيۡقَنَتۡهَآ أَنفُسُهُمۡ ظُلۡمٗا وَعُلُوّٗاۚ فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُفۡسِدِينَ",
    translation:
      "And they rejected them, while their [inner] selves were convinced thereof, out of injustice and haughtiness. So see how was the end of the corrupters",
    normalizedText:
      "وجحدوا بها واستيقنتها انفسهم ظلما وعلوا فانظر كيف كان عقبة المفسدين",
  },
  {
    verseId: 14,
    name: "النمل",
    surahId: 27,
    text: "وَلَقَدۡ ءَاتَيۡنَا دَاوُۥدَ وَسُلَيۡمَٰنَ عِلۡمٗاۖ وَقَالَا ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي فَضَّلَنَا عَلَىٰ كَثِيرٖ مِّنۡ عِبَادِهِ ٱلۡمُؤۡمِنِينَ",
    translation:
      'And We had certainly given to David and Solomon knowledge, and they said, "Praise [is due] to Allah, who has favored us over many of His believing servants',
    normalizedText:
      "ولقد ءاتينا داود وسليمن علما وقالا الحمد لله الذي فضلنا على كثير من عباده المامنين",
  },
  {
    verseId: 15,
    name: "النمل",
    surahId: 27,
    text: "وَوَرِثَ سُلَيۡمَٰنُ دَاوُۥدَۖ وَقَالَ يَـٰٓأَيُّهَا ٱلنَّاسُ عُلِّمۡنَا مَنطِقَ ٱلطَّيۡرِ وَأُوتِينَا مِن كُلِّ شَيۡءٍۖ إِنَّ هَٰذَا لَهُوَ ٱلۡفَضۡلُ ٱلۡمُبِينُ",
    translation:
      'And Solomon inherited David. He said, "O people, we have been taught the language of birds, and we have been given from all things. Indeed, this is evident bounty',
    normalizedText:
      "وورث سليمن داود وقال يايها الناس علمنا منطق الطير واوتينا من كل شيء ان هذا لهو الفضل المبين",
  },
  {
    verseId: 16,
    name: "النمل",
    surahId: 27,
    text: "وَحُشِرَ لِسُلَيۡمَٰنَ جُنُودُهُۥ مِنَ ٱلۡجِنِّ وَٱلۡإِنسِ وَٱلطَّيۡرِ فَهُمۡ يُوزَعُونَ",
    translation:
      "And gathered for Solomon were his soldiers of the jinn and men and birds, and they were [marching] in rows",
    normalizedText: "وحشر لسليمن جنوده من الجن والانس والطير فهم يوزعون",
  },
  {
    verseId: 17,
    name: "النمل",
    surahId: 27,
    text: "حَتَّىٰٓ إِذَآ أَتَوۡاْ عَلَىٰ وَادِ ٱلنَّمۡلِ قَالَتۡ نَمۡلَةٞ يَـٰٓأَيُّهَا ٱلنَّمۡلُ ٱدۡخُلُواْ مَسَٰكِنَكُمۡ لَا يَحۡطِمَنَّكُمۡ سُلَيۡمَٰنُ وَجُنُودُهُۥ وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      'Until, when they came upon the valley of the ants, an ant said, "O ants, enter your dwellings that you not be crushed by Solomon and his soldiers while they perceive not',
    normalizedText:
      "حتى اذا اتوا على واد النمل قالت نملة يايها النمل ادخلوا مسكنكم لا يحطمنكم سليمن وجنوده وهم لا يشعرون",
  },
  {
    verseId: 18,
    name: "النمل",
    surahId: 27,
    text: "فَتَبَسَّمَ ضَاحِكٗا مِّن قَوۡلِهَا وَقَالَ رَبِّ أَوۡزِعۡنِيٓ أَنۡ أَشۡكُرَ نِعۡمَتَكَ ٱلَّتِيٓ أَنۡعَمۡتَ عَلَيَّ وَعَلَىٰ وَٰلِدَيَّ وَأَنۡ أَعۡمَلَ صَٰلِحٗا تَرۡضَىٰهُ وَأَدۡخِلۡنِي بِرَحۡمَتِكَ فِي عِبَادِكَ ٱلصَّـٰلِحِينَ",
    translation:
      'So [Solomon] smiled, amused at her speech, and said, "My Lord, enable me to be grateful for Your favor which You have bestowed upon me and upon my parents and to do righteousness of which You approve. And admit me by Your mercy into [the ranks of] Your righteous servants',
    normalizedText:
      "فتبسم ضاحكا من قولها وقال رب اوزعني ان اشكر نعمتك التي انعمت علي وعلى ولدي وان اعمل صلحا ترضىه وادخلني برحمتك في عبادك الصلحين",
  },
  {
    verseId: 19,
    name: "النمل",
    surahId: 27,
    text: "وَتَفَقَّدَ ٱلطَّيۡرَ فَقَالَ مَالِيَ لَآ أَرَى ٱلۡهُدۡهُدَ أَمۡ كَانَ مِنَ ٱلۡغَآئِبِينَ",
    translation:
      'And he took attendance of the birds and said, "Why do I not see the hoopoe - or is he among the absent',
    normalizedText: "وتفقد الطير فقال مالي لا ارى الهدهد ام كان من الغاابين",
  },
  {
    verseId: 20,
    name: "النمل",
    surahId: 27,
    text: "لَأُعَذِّبَنَّهُۥ عَذَابٗا شَدِيدًا أَوۡ لَأَاْذۡبَحَنَّهُۥٓ أَوۡ لَيَأۡتِيَنِّي بِسُلۡطَٰنٖ مُّبِينٖ",
    translation:
      "I will surely punish him with a severe punishment or slaughter him unless he brings me clear authorization",
    normalizedText: "لاعذبنه عذابا شديدا او لااذبحنه او لياتيني بسلطن مبين",
  },
  {
    verseId: 21,
    name: "النمل",
    surahId: 27,
    text: "فَمَكَثَ غَيۡرَ بَعِيدٖ فَقَالَ أَحَطتُ بِمَا لَمۡ تُحِطۡ بِهِۦ وَجِئۡتُكَ مِن سَبَإِۭ بِنَبَإٖ يَقِينٍ",
    translation:
      'But the hoopoe stayed not long and said, "I have encompassed [in knowledge] that which you have not encompassed, and I have come to you from Sheba with certain news',
    normalizedText:
      "فمكث غير بعيد فقال احطت بما لم تحط به وجاتك من سبا بنبا يقين",
  },
  {
    verseId: 22,
    name: "النمل",
    surahId: 27,
    text: "إِنِّي وَجَدتُّ ٱمۡرَأَةٗ تَمۡلِكُهُمۡ وَأُوتِيَتۡ مِن كُلِّ شَيۡءٖ وَلَهَا عَرۡشٌ عَظِيمٞ",
    translation:
      "Indeed, I found [there] a woman ruling them, and she has been given of all things, and she has a great throne",
    normalizedText: "اني وجدت امراة تملكهم واوتيت من كل شيء ولها عرش عظيم",
  },
  {
    verseId: 23,
    name: "النمل",
    surahId: 27,
    text: "وَجَدتُّهَا وَقَوۡمَهَا يَسۡجُدُونَ لِلشَّمۡسِ مِن دُونِ ٱللَّهِ وَزَيَّنَ لَهُمُ ٱلشَّيۡطَٰنُ أَعۡمَٰلَهُمۡ فَصَدَّهُمۡ عَنِ ٱلسَّبِيلِ فَهُمۡ لَا يَهۡتَدُونَ",
    translation:
      "I found her and her people prostrating to the sun instead of Allah, and Satan has made their deeds pleasing to them and averted them from [His] way, so they are not guided",
    normalizedText:
      "وجدتها وقومها يسجدون للشمس من دون الله وزين لهم الشيطن اعملهم فصدهم عن السبيل فهم لا يهتدون",
  },
  {
    verseId: 24,
    name: "النمل",
    surahId: 27,
    text: "أَلَّاۤ يَسۡجُدُواْۤ لِلَّهِ ٱلَّذِي يُخۡرِجُ ٱلۡخَبۡءَ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَيَعۡلَمُ مَا تُخۡفُونَ وَمَا تُعۡلِنُونَ",
    translation:
      "[And] so they do not prostrate to Allah, who brings forth what is hidden within the heavens and the earth and knows what you conceal and what you declare",
    normalizedText:
      "الا يسجدوا لله الذي يخرج الخبء في السموت والارض ويعلم ما تخفون وما تعلنون",
  },
  {
    verseId: 25,
    name: "النمل",
    surahId: 27,
    text: "ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ رَبُّ ٱلۡعَرۡشِ ٱلۡعَظِيمِ۩",
    translation:
      "Allah - there is no deity except Him, Lord of the Great Throne",
    normalizedText: "الله لا اله الا هو رب العرش العظيم۩",
  },
  {
    verseId: 26,
    name: "النمل",
    surahId: 27,
    text: "۞قَالَ سَنَنظُرُ أَصَدَقۡتَ أَمۡ كُنتَ مِنَ ٱلۡكَٰذِبِينَ",
    translation:
      '[Solomon] said, "We will see whether you were truthful or were of the liars',
    normalizedText: "۞قال سننظر اصدقت ام كنت من الكذبين",
  },
  {
    verseId: 27,
    name: "النمل",
    surahId: 27,
    text: "ٱذۡهَب بِّكِتَٰبِي هَٰذَا فَأَلۡقِهۡ إِلَيۡهِمۡ ثُمَّ تَوَلَّ عَنۡهُمۡ فَٱنظُرۡ مَاذَا يَرۡجِعُونَ",
    translation:
      "Take this letter of mine and deliver it to them. Then leave them and see what [answer] they will return",
    normalizedText: "اذهب بكتبي هذا فالقه اليهم ثم تول عنهم فانظر ماذا يرجعون",
  },
  {
    verseId: 28,
    name: "النمل",
    surahId: 27,
    text: "قَالَتۡ يَـٰٓأَيُّهَا ٱلۡمَلَؤُاْ إِنِّيٓ أُلۡقِيَ إِلَيَّ كِتَٰبٞ كَرِيمٌ",
    translation:
      'She said, "O eminent ones, indeed, to me has been delivered a noble letter',
    normalizedText: "قالت يايها الملاا اني القي الي كتب كريم",
  },
  {
    verseId: 29,
    name: "النمل",
    surahId: 27,
    text: "إِنَّهُۥ مِن سُلَيۡمَٰنَ وَإِنَّهُۥ بِسۡمِ ٱللَّهِ ٱلرَّحۡمَٰنِ ٱلرَّحِيمِ",
    translation:
      "Indeed, it is from Solomon, and indeed, it reads: 'In the name of Allah, the Entirely Merciful, the Especially Merciful",
    normalizedText: "انه من سليمن وانه بسم الله الرحمن الرحيم",
  },
  {
    verseId: 30,
    name: "النمل",
    surahId: 27,
    text: "أَلَّا تَعۡلُواْ عَلَيَّ وَأۡتُونِي مُسۡلِمِينَ",
    translation:
      "Be not haughty with me but come to me in submission [as Muslims]",
    normalizedText: "الا تعلوا علي واتوني مسلمين",
  },
  {
    verseId: 31,
    name: "النمل",
    surahId: 27,
    text: "قَالَتۡ يَـٰٓأَيُّهَا ٱلۡمَلَؤُاْ أَفۡتُونِي فِيٓ أَمۡرِي مَا كُنتُ قَاطِعَةً أَمۡرًا حَتَّىٰ تَشۡهَدُونِ",
    translation:
      'She said, "O eminent ones, advise me in my affair. I would not decide a matter until you witness [for] me',
    normalizedText:
      "قالت يايها الملاا افتوني في امري ما كنت قاطعة امرا حتى تشهدون",
  },
  {
    verseId: 32,
    name: "النمل",
    surahId: 27,
    text: "قَالُواْ نَحۡنُ أُوْلُواْ قُوَّةٖ وَأُوْلُواْ بَأۡسٖ شَدِيدٖ وَٱلۡأَمۡرُ إِلَيۡكِ فَٱنظُرِي مَاذَا تَأۡمُرِينَ",
    translation:
      'They said, "We are men of strength and of great military might, but the command is yours, so see what you will command',
    normalizedText:
      "قالوا نحن اولوا قوة واولوا باس شديد والامر اليك فانظري ماذا تامرين",
  },
  {
    verseId: 33,
    name: "النمل",
    surahId: 27,
    text: "قَالَتۡ إِنَّ ٱلۡمُلُوكَ إِذَا دَخَلُواْ قَرۡيَةً أَفۡسَدُوهَا وَجَعَلُوٓاْ أَعِزَّةَ أَهۡلِهَآ أَذِلَّةٗۚ وَكَذَٰلِكَ يَفۡعَلُونَ",
    translation:
      'She said, "Indeed kings - when they enter a city, they ruin it and render the honored of its people humbled. And thus do they do',
    normalizedText:
      "قالت ان الملوك اذا دخلوا قرية افسدوها وجعلوا اعزة اهلها اذلة وكذلك يفعلون",
  },
  {
    verseId: 34,
    name: "النمل",
    surahId: 27,
    text: "وَإِنِّي مُرۡسِلَةٌ إِلَيۡهِم بِهَدِيَّةٖ فَنَاظِرَةُۢ بِمَ يَرۡجِعُ ٱلۡمُرۡسَلُونَ",
    translation:
      "But indeed, I will send to them a gift and see with what [reply] the messengers will return",
    normalizedText: "واني مرسلة اليهم بهدية فناظرة بم يرجع المرسلون",
  },
  {
    verseId: 35,
    name: "النمل",
    surahId: 27,
    text: "فَلَمَّا جَآءَ سُلَيۡمَٰنَ قَالَ أَتُمِدُّونَنِ بِمَالٖ فَمَآ ءَاتَىٰنِۦَ ٱللَّهُ خَيۡرٞ مِّمَّآ ءَاتَىٰكُمۚ بَلۡ أَنتُم بِهَدِيَّتِكُمۡ تَفۡرَحُونَ",
    translation:
      'So when they came to Solomon, he said, "Do you provide me with wealth? But what Allah has given me is better than what He has given you. Rather, it is you who rejoice in your gift',
    normalizedText:
      "فلما جاء سليمن قال اتمدونن بمال فما ءاتىن الله خير مما ءاتىكم بل انتم بهديتكم تفرحون",
  },
  {
    verseId: 36,
    name: "النمل",
    surahId: 27,
    text: "ٱرۡجِعۡ إِلَيۡهِمۡ فَلَنَأۡتِيَنَّهُم بِجُنُودٖ لَّا قِبَلَ لَهُم بِهَا وَلَنُخۡرِجَنَّهُم مِّنۡهَآ أَذِلَّةٗ وَهُمۡ صَٰغِرُونَ",
    translation:
      "Return to them, for we will surely come to them with soldiers that they will be powerless to encounter, and we will surely expel them therefrom in humiliation, and they will be debased",
    normalizedText:
      "ارجع اليهم فلناتينهم بجنود لا قبل لهم بها ولنخرجنهم منها اذلة وهم صغرون",
  },
  {
    verseId: 37,
    name: "النمل",
    surahId: 27,
    text: "قَالَ يَـٰٓأَيُّهَا ٱلۡمَلَؤُاْ أَيُّكُمۡ يَأۡتِينِي بِعَرۡشِهَا قَبۡلَ أَن يَأۡتُونِي مُسۡلِمِينَ",
    translation:
      '[Solomon] said, "O assembly [of jinn], which of you will bring me her throne before they come to me in submission',
    normalizedText: "قال يايها الملاا ايكم ياتيني بعرشها قبل ان ياتوني مسلمين",
  },
  {
    verseId: 38,
    name: "النمل",
    surahId: 27,
    text: "قَالَ عِفۡرِيتٞ مِّنَ ٱلۡجِنِّ أَنَا۠ ءَاتِيكَ بِهِۦ قَبۡلَ أَن تَقُومَ مِن مَّقَامِكَۖ وَإِنِّي عَلَيۡهِ لَقَوِيٌّ أَمِينٞ",
    translation:
      'A powerful one from among the jinn said, "I will bring it to you before you rise from your place, and indeed, I am for this [task] strong and trustworthy',
    normalizedText:
      "قال عفريت من الجن انا ءاتيك به قبل ان تقوم من مقامك واني عليه لقوي امين",
  },
  {
    verseId: 39,
    name: "النمل",
    surahId: 27,
    text: "قَالَ ٱلَّذِي عِندَهُۥ عِلۡمٞ مِّنَ ٱلۡكِتَٰبِ أَنَا۠ ءَاتِيكَ بِهِۦ قَبۡلَ أَن يَرۡتَدَّ إِلَيۡكَ طَرۡفُكَۚ فَلَمَّا رَءَاهُ مُسۡتَقِرًّا عِندَهُۥ قَالَ هَٰذَا مِن فَضۡلِ رَبِّي لِيَبۡلُوَنِيٓ ءَأَشۡكُرُ أَمۡ أَكۡفُرُۖ وَمَن شَكَرَ فَإِنَّمَا يَشۡكُرُ لِنَفۡسِهِۦۖ وَمَن كَفَرَ فَإِنَّ رَبِّي غَنِيّٞ كَرِيمٞ",
    translation:
      'Said one who had knowledge from the Scripture, "I will bring it to you before your glance returns to you." And when [Solomon] saw it placed before him, he said, "This is from the favor of my Lord to test me whether I will be grateful or ungrateful. And whoever is grateful - his gratitude is only for [the benefit of] himself. And whoever is ungrateful - then indeed, my Lord is Free of need and Generous',
    normalizedText:
      "قال الذي عنده علم من الكتب انا ءاتيك به قبل ان يرتد اليك طرفك فلما رءاه مستقرا عنده قال هذا من فضل ربي ليبلوني ءاشكر ام اكفر ومن شكر فانما يشكر لنفسه ومن كفر فان ربي غني كريم",
  },
  {
    verseId: 40,
    name: "النمل",
    surahId: 27,
    text: "قَالَ نَكِّرُواْ لَهَا عَرۡشَهَا نَنظُرۡ أَتَهۡتَدِيٓ أَمۡ تَكُونُ مِنَ ٱلَّذِينَ لَا يَهۡتَدُونَ",
    translation:
      'He said, "Disguise for her her throne; we will see whether she will be guided [to truth] or will be of those who is not guided',
    normalizedText:
      "قال نكروا لها عرشها ننظر اتهتدي ام تكون من الذين لا يهتدون",
  },
  {
    verseId: 41,
    name: "النمل",
    surahId: 27,
    text: "فَلَمَّا جَآءَتۡ قِيلَ أَهَٰكَذَا عَرۡشُكِۖ قَالَتۡ كَأَنَّهُۥ هُوَۚ وَأُوتِينَا ٱلۡعِلۡمَ مِن قَبۡلِهَا وَكُنَّا مُسۡلِمِينَ",
    translation:
      'So when she arrived, it was said [to her], "Is your throne like this?" She said, "[It is] as though it was it." [Solomon said], "And we were given knowledge before her, and we have been Muslims [in submission to Allah]',
    normalizedText:
      "فلما جاءت قيل اهكذا عرشك قالت كانه هو واوتينا العلم من قبلها وكنا مسلمين",
  },
  {
    verseId: 42,
    name: "النمل",
    surahId: 27,
    text: "وَصَدَّهَا مَا كَانَت تَّعۡبُدُ مِن دُونِ ٱللَّهِۖ إِنَّهَا كَانَتۡ مِن قَوۡمٖ كَٰفِرِينَ",
    translation:
      "And that which she was worshipping other than Allah had averted her [from submission to Him]. Indeed, she was from a disbelieving people",
    normalizedText: "وصدها ما كانت تعبد من دون الله انها كانت من قوم كفرين",
  },
  {
    verseId: 43,
    name: "النمل",
    surahId: 27,
    text: "قِيلَ لَهَا ٱدۡخُلِي ٱلصَّرۡحَۖ فَلَمَّا رَأَتۡهُ حَسِبَتۡهُ لُجَّةٗ وَكَشَفَتۡ عَن سَاقَيۡهَاۚ قَالَ إِنَّهُۥ صَرۡحٞ مُّمَرَّدٞ مِّن قَوَارِيرَۗ قَالَتۡ رَبِّ إِنِّي ظَلَمۡتُ نَفۡسِي وَأَسۡلَمۡتُ مَعَ سُلَيۡمَٰنَ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'She was told, "Enter the palace." But when she saw it, she thought it was a body of water and uncovered her shins [to wade through]. He said, "Indeed, it is a palace [whose floor is] made smooth with glass." She said, "My Lord, indeed I have wronged myself, and I submit with Solomon to Allah, Lord of the worlds',
    normalizedText:
      "قيل لها ادخلي الصرح فلما راته حسبته لجة وكشفت عن ساقيها قال انه صرح ممرد من قوارير قالت رب اني ظلمت نفسي واسلمت مع سليمن لله رب العلمين",
  },
  {
    verseId: 44,
    name: "النمل",
    surahId: 27,
    text: "وَلَقَدۡ أَرۡسَلۡنَآ إِلَىٰ ثَمُودَ أَخَاهُمۡ صَٰلِحًا أَنِ ٱعۡبُدُواْ ٱللَّهَ فَإِذَا هُمۡ فَرِيقَانِ يَخۡتَصِمُونَ",
    translation:
      'And We had certainly sent to Thamud their brother Salih, [saying], "Worship Allah," and at once they were two parties conflicting',
    normalizedText:
      "ولقد ارسلنا الى ثمود اخاهم صلحا ان اعبدوا الله فاذا هم فريقان يختصمون",
  },
  {
    verseId: 45,
    name: "النمل",
    surahId: 27,
    text: "قَالَ يَٰقَوۡمِ لِمَ تَسۡتَعۡجِلُونَ بِٱلسَّيِّئَةِ قَبۡلَ ٱلۡحَسَنَةِۖ لَوۡلَا تَسۡتَغۡفِرُونَ ٱللَّهَ لَعَلَّكُمۡ تُرۡحَمُونَ",
    translation:
      'He said, "O my people, why are you impatient for evil instead of good? Why do you not seek forgiveness of Allah that you may receive mercy',
    normalizedText:
      "قال يقوم لم تستعجلون بالسياة قبل الحسنة لولا تستغفرون الله لعلكم ترحمون",
  },
  {
    verseId: 46,
    name: "النمل",
    surahId: 27,
    text: "قَالُواْ ٱطَّيَّرۡنَا بِكَ وَبِمَن مَّعَكَۚ قَالَ طَـٰٓئِرُكُمۡ عِندَ ٱللَّهِۖ بَلۡ أَنتُمۡ قَوۡمٞ تُفۡتَنُونَ",
    translation:
      'They said, "We consider you a bad omen, you and those with you." He said, "Your omen is with Allah. Rather, you are a people being tested',
    normalizedText:
      "قالوا اطيرنا بك وبمن معك قال طاركم عند الله بل انتم قوم تفتنون",
  },
  {
    verseId: 47,
    name: "النمل",
    surahId: 27,
    text: "وَكَانَ فِي ٱلۡمَدِينَةِ تِسۡعَةُ رَهۡطٖ يُفۡسِدُونَ فِي ٱلۡأَرۡضِ وَلَا يُصۡلِحُونَ",
    translation:
      "And there were in the city nine family heads causing corruption in the land and not amending [its affairs]",
    normalizedText: "وكان في المدينة تسعة رهط يفسدون في الارض ولا يصلحون",
  },
  {
    verseId: 48,
    name: "النمل",
    surahId: 27,
    text: "قَالُواْ تَقَاسَمُواْ بِٱللَّهِ لَنُبَيِّتَنَّهُۥ وَأَهۡلَهُۥ ثُمَّ لَنَقُولَنَّ لِوَلِيِّهِۦ مَا شَهِدۡنَا مَهۡلِكَ أَهۡلِهِۦ وَإِنَّا لَصَٰدِقُونَ",
    translation: `They said, "Take a mutual oath by Allah that we will kill him by night, he and his family. Then we will say to his executor, 'We did not witness the destruction of his family, and indeed, we are truthful`,
    normalizedText:
      "قالوا تقاسموا بالله لنبيتنه واهله ثم لنقولن لوليه ما شهدنا مهلك اهله وانا لصدقون",
  },
  {
    verseId: 49,
    name: "النمل",
    surahId: 27,
    text: "وَمَكَرُواْ مَكۡرٗا وَمَكَرۡنَا مَكۡرٗا وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      "And they planned a plan, and We planned a plan, while they perceived not",
    normalizedText: "ومكروا مكرا ومكرنا مكرا وهم لا يشعرون",
  },
  {
    verseId: 50,
    name: "النمل",
    surahId: 27,
    text: "فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ مَكۡرِهِمۡ أَنَّا دَمَّرۡنَٰهُمۡ وَقَوۡمَهُمۡ أَجۡمَعِينَ",
    translation:
      "Then look how was the outcome of their plan - that We destroyed them and their people, all",
    normalizedText: "فانظر كيف كان عقبة مكرهم انا دمرنهم وقومهم اجمعين",
  },
  {
    verseId: 51,
    name: "النمل",
    surahId: 27,
    text: "فَتِلۡكَ بُيُوتُهُمۡ خَاوِيَةَۢ بِمَا ظَلَمُوٓاْۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّقَوۡمٖ يَعۡلَمُونَ",
    translation:
      "So those are their houses, desolate because of the wrong they had done. Indeed in that is a sign for people who know",
    normalizedText: "فتلك بيوتهم خاوية بما ظلموا ان في ذلك لاية لقوم يعلمون",
  },
  {
    verseId: 52,
    name: "النمل",
    surahId: 27,
    text: "وَأَنجَيۡنَا ٱلَّذِينَ ءَامَنُواْ وَكَانُواْ يَتَّقُونَ",
    translation: "And We saved those who believed and used to fear Allah",
    normalizedText: "وانجينا الذين ءامنوا وكانوا يتقون",
  },
  {
    verseId: 53,
    name: "النمل",
    surahId: 27,
    text: "وَلُوطًا إِذۡ قَالَ لِقَوۡمِهِۦٓ أَتَأۡتُونَ ٱلۡفَٰحِشَةَ وَأَنتُمۡ تُبۡصِرُونَ",
    translation:
      'And [mention] Lot, when he said to his people, "Do you commit immorality while you are seeing',
    normalizedText: "ولوطا اذ قال لقومه اتاتون الفحشة وانتم تبصرون",
  },
  {
    verseId: 54,
    name: "النمل",
    surahId: 27,
    text: "أَئِنَّكُمۡ لَتَأۡتُونَ ٱلرِّجَالَ شَهۡوَةٗ مِّن دُونِ ٱلنِّسَآءِۚ بَلۡ أَنتُمۡ قَوۡمٞ تَجۡهَلُونَ",
    translation:
      "Do you indeed approach men with desire instead of women? Rather, you are a people behaving ignorantly",
    normalizedText: "اانكم لتاتون الرجال شهوة من دون النساء بل انتم قوم تجهلون",
  },
  {
    verseId: 55,
    name: "النمل",
    surahId: 27,
    text: "۞فَمَا كَانَ جَوَابَ قَوۡمِهِۦٓ إِلَّآ أَن قَالُوٓاْ أَخۡرِجُوٓاْ ءَالَ لُوطٖ مِّن قَرۡيَتِكُمۡۖ إِنَّهُمۡ أُنَاسٞ يَتَطَهَّرُونَ",
    translation:
      'But the answer of his people was not except that they said, "Expel the family of Lot from your city. Indeed, they are people who keep themselves pure',
    normalizedText:
      "۞فما كان جواب قومه الا ان قالوا اخرجوا ءال لوط من قريتكم انهم اناس يتطهرون",
  },
  {
    verseId: 56,
    name: "النمل",
    surahId: 27,
    text: "فَأَنجَيۡنَٰهُ وَأَهۡلَهُۥٓ إِلَّا ٱمۡرَأَتَهُۥ قَدَّرۡنَٰهَا مِنَ ٱلۡغَٰبِرِينَ",
    translation:
      "So We saved him and his family, except for his wife; We destined her to be of those who remained behind",
    normalizedText: "فانجينه واهله الا امراته قدرنها من الغبرين",
  },
  {
    verseId: 57,
    name: "النمل",
    surahId: 27,
    text: "وَأَمۡطَرۡنَا عَلَيۡهِم مَّطَرٗاۖ فَسَآءَ مَطَرُ ٱلۡمُنذَرِينَ",
    translation:
      "And We rained upon them a rain [of stones], and evil was the rain of those who were warned",
    normalizedText: "وامطرنا عليهم مطرا فساء مطر المنذرين",
  },
  {
    verseId: 58,
    name: "النمل",
    surahId: 27,
    text: "قُلِ ٱلۡحَمۡدُ لِلَّهِ وَسَلَٰمٌ عَلَىٰ عِبَادِهِ ٱلَّذِينَ ٱصۡطَفَىٰٓۗ ءَآللَّهُ خَيۡرٌ أَمَّا يُشۡرِكُونَ",
    translation:
      'Say, [O Muhammad], "Praise be to Allah, and peace upon His servants whom He has chosen. Is Allah better or what they associate with Him',
    normalizedText:
      "قل الحمد لله وسلم على عباده الذين اصطفى ءالله خير اما يشركون",
  },
  {
    verseId: 59,
    name: "النمل",
    surahId: 27,
    text: "أَمَّنۡ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَأَنزَلَ لَكُم مِّنَ ٱلسَّمَآءِ مَآءٗ فَأَنۢبَتۡنَا بِهِۦ حَدَآئِقَ ذَاتَ بَهۡجَةٖ مَّا كَانَ لَكُمۡ أَن تُنۢبِتُواْ شَجَرَهَآۗ أَءِلَٰهٞ مَّعَ ٱللَّهِۚ بَلۡ هُمۡ قَوۡمٞ يَعۡدِلُونَ",
    translation:
      "[More precisely], is He [not best] who created the heavens and the earth and sent down for you rain from the sky, causing to grow thereby gardens of joyful beauty which you could not [otherwise] have grown the trees thereof? Is there a deity with Allah? [No], but they are a people who ascribe equals [to Him]",
    normalizedText:
      "امن خلق السموت والارض وانزل لكم من السماء ماء فانبتنا به حدااق ذات بهجة ما كان لكم ان تنبتوا شجرها اءله مع الله بل هم قوم يعدلون",
  },
  {
    verseId: 60,
    name: "النمل",
    surahId: 27,
    text: "أَمَّن جَعَلَ ٱلۡأَرۡضَ قَرَارٗا وَجَعَلَ خِلَٰلَهَآ أَنۡهَٰرٗا وَجَعَلَ لَهَا رَوَٰسِيَ وَجَعَلَ بَيۡنَ ٱلۡبَحۡرَيۡنِ حَاجِزًاۗ أَءِلَٰهٞ مَّعَ ٱللَّهِۚ بَلۡ أَكۡثَرُهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "Is He [not best] who made the earth a stable ground and placed within it rivers and made for it firmly set mountains and placed between the two seas a barrier? Is there a deity with Allah? [No], but most of them do not know",
    normalizedText:
      "امن جعل الارض قرارا وجعل خللها انهرا وجعل لها روسي وجعل بين البحرين حاجزا اءله مع الله بل اكثرهم لا يعلمون",
  },
  {
    verseId: 61,
    name: "النمل",
    surahId: 27,
    text: "أَمَّن يُجِيبُ ٱلۡمُضۡطَرَّ إِذَا دَعَاهُ وَيَكۡشِفُ ٱلسُّوٓءَ وَيَجۡعَلُكُمۡ خُلَفَآءَ ٱلۡأَرۡضِۗ أَءِلَٰهٞ مَّعَ ٱللَّهِۚ قَلِيلٗا مَّا تَذَكَّرُونَ",
    translation:
      "Is He [not best] who responds to the desperate one when he calls upon Him and removes evil and makes you inheritors of the earth? Is there a deity with Allah? Little do you remember",
    normalizedText:
      "امن يجيب المضطر اذا دعاه ويكشف السوء ويجعلكم خلفاء الارض اءله مع الله قليلا ما تذكرون",
  },
  {
    verseId: 62,
    name: "النمل",
    surahId: 27,
    text: "أَمَّن يَهۡدِيكُمۡ فِي ظُلُمَٰتِ ٱلۡبَرِّ وَٱلۡبَحۡرِ وَمَن يُرۡسِلُ ٱلرِّيَٰحَ بُشۡرَۢا بَيۡنَ يَدَيۡ رَحۡمَتِهِۦٓۗ أَءِلَٰهٞ مَّعَ ٱللَّهِۚ تَعَٰلَى ٱللَّهُ عَمَّا يُشۡرِكُونَ",
    translation:
      "Is He [not best] who guides you through the darknesses of the land and sea and who sends the winds as good tidings before His mercy? Is there a deity with Allah? High is Allah above whatever they associate with Him",
    normalizedText:
      "امن يهديكم في ظلمت البر والبحر ومن يرسل الريح بشرا بين يدي رحمته اءله مع الله تعلى الله عما يشركون",
  },
  {
    verseId: 63,
    name: "النمل",
    surahId: 27,
    text: "أَمَّن يَبۡدَؤُاْ ٱلۡخَلۡقَ ثُمَّ يُعِيدُهُۥ وَمَن يَرۡزُقُكُم مِّنَ ٱلسَّمَآءِ وَٱلۡأَرۡضِۗ أَءِلَٰهٞ مَّعَ ٱللَّهِۚ قُلۡ هَاتُواْ بُرۡهَٰنَكُمۡ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Is He [not best] who begins creation and then repeats it and who provides for you from the heaven and earth? Is there a deity with Allah? Say, "Produce your proof, if you should be truthful',
    normalizedText:
      "امن يبداا الخلق ثم يعيده ومن يرزقكم من السماء والارض اءله مع الله قل هاتوا برهنكم ان كنتم صدقين",
  },
  {
    verseId: 64,
    name: "النمل",
    surahId: 27,
    text: "قُل لَّا يَعۡلَمُ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ ٱلۡغَيۡبَ إِلَّا ٱللَّهُۚ وَمَا يَشۡعُرُونَ أَيَّانَ يُبۡعَثُونَ",
    translation:
      'Say, "None in the heavens and earth knows the unseen except Allah, and they do not perceive when they will be resurrected',
    normalizedText:
      "قل لا يعلم من في السموت والارض الغيب الا الله وما يشعرون ايان يبعثون",
  },
  {
    verseId: 65,
    name: "النمل",
    surahId: 27,
    text: "بَلِ ٱدَّـٰرَكَ عِلۡمُهُمۡ فِي ٱلۡأٓخِرَةِۚ بَلۡ هُمۡ فِي شَكّٖ مِّنۡهَاۖ بَلۡ هُم مِّنۡهَا عَمُونَ",
    translation:
      "Rather, their knowledge is arrested concerning the Hereafter. Rather, they are in doubt about it. Rather, they are, concerning it, blind",
    normalizedText: "بل ادرك علمهم في الاخرة بل هم في شك منها بل هم منها عمون",
  },
  {
    verseId: 66,
    name: "النمل",
    surahId: 27,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُوٓاْ أَءِذَا كُنَّا تُرَٰبٗا وَءَابَآؤُنَآ أَئِنَّا لَمُخۡرَجُونَ",
    translation:
      'And those who disbelieve say, "When we have become dust as well as our forefathers, will we indeed be brought out [of the graves]',
    normalizedText: "وقال الذين كفروا اءذا كنا تربا وءاباانا اانا لمخرجون",
  },
  {
    verseId: 67,
    name: "النمل",
    surahId: 27,
    text: "لَقَدۡ وُعِدۡنَا هَٰذَا نَحۡنُ وَءَابَآؤُنَا مِن قَبۡلُ إِنۡ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      "We have been promised this, we and our forefathers, before. This is not but legends of the former peoples",
    normalizedText:
      "لقد وعدنا هذا نحن وءاباانا من قبل ان هذا الا اسطير الاولين",
  },
  {
    verseId: 68,
    name: "النمل",
    surahId: 27,
    text: "قُلۡ سِيرُواْ فِي ٱلۡأَرۡضِ فَٱنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُجۡرِمِينَ",
    translation:
      'Say, [O Muhammad], "Travel through the land and observe how was the end of the criminals',
    normalizedText: "قل سيروا في الارض فانظروا كيف كان عقبة المجرمين",
  },
  {
    verseId: 69,
    name: "النمل",
    surahId: 27,
    text: "وَلَا تَحۡزَنۡ عَلَيۡهِمۡ وَلَا تَكُن فِي ضَيۡقٖ مِّمَّا يَمۡكُرُونَ",
    translation:
      "And grieve not over them or be in distress from what they conspire",
    normalizedText: "ولا تحزن عليهم ولا تكن في ضيق مما يمكرون",
  },
  {
    verseId: 70,
    name: "النمل",
    surahId: 27,
    text: "وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلۡوَعۡدُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "When is [the fulfillment of] this promise, if you should be truthful',
    normalizedText: "ويقولون متى هذا الوعد ان كنتم صدقين",
  },
  {
    verseId: 71,
    name: "النمل",
    surahId: 27,
    text: "قُلۡ عَسَىٰٓ أَن يَكُونَ رَدِفَ لَكُم بَعۡضُ ٱلَّذِي تَسۡتَعۡجِلُونَ",
    translation:
      'Say, "Perhaps it is close behind you - some of that for which you are impatient',
    normalizedText: "قل عسى ان يكون ردف لكم بعض الذي تستعجلون",
  },
  {
    verseId: 72,
    name: "النمل",
    surahId: 27,
    text: "وَإِنَّ رَبَّكَ لَذُو فَضۡلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَشۡكُرُونَ",
    translation:
      "And indeed, your Lord is full of bounty for the people, but most of them do not show gratitude",
    normalizedText: "وان ربك لذو فضل على الناس ولكن اكثرهم لا يشكرون",
  },
  {
    verseId: 73,
    name: "النمل",
    surahId: 27,
    text: "وَإِنَّ رَبَّكَ لَيَعۡلَمُ مَا تُكِنُّ صُدُورُهُمۡ وَمَا يُعۡلِنُونَ",
    translation:
      "And indeed, your Lord knows what their breasts conceal and what they declare",
    normalizedText: "وان ربك ليعلم ما تكن صدورهم وما يعلنون",
  },
  {
    verseId: 74,
    name: "النمل",
    surahId: 27,
    text: "وَمَا مِنۡ غَآئِبَةٖ فِي ٱلسَّمَآءِ وَٱلۡأَرۡضِ إِلَّا فِي كِتَٰبٖ مُّبِينٍ",
    translation:
      "And there is nothing concealed within the heaven and the earth except that it is in a clear Register",
    normalizedText: "وما من غاابة في السماء والارض الا في كتب مبين",
  },
  {
    verseId: 75,
    name: "النمل",
    surahId: 27,
    text: "إِنَّ هَٰذَا ٱلۡقُرۡءَانَ يَقُصُّ عَلَىٰ بَنِيٓ إِسۡرَـٰٓءِيلَ أَكۡثَرَ ٱلَّذِي هُمۡ فِيهِ يَخۡتَلِفُونَ",
    translation:
      "Indeed, this Qur'an relates to the Children of Israel most of that over which they disagree",
    normalizedText:
      "ان هذا القرءان يقص على بني اسرءيل اكثر الذي هم فيه يختلفون",
  },
  {
    verseId: 76,
    name: "النمل",
    surahId: 27,
    text: "وَإِنَّهُۥ لَهُدٗى وَرَحۡمَةٞ لِّلۡمُؤۡمِنِينَ",
    translation: "And indeed, it is guidance and mercy for the believers",
    normalizedText: "وانه لهدى ورحمة للمامنين",
  },
  {
    verseId: 77,
    name: "النمل",
    surahId: 27,
    text: "إِنَّ رَبَّكَ يَقۡضِي بَيۡنَهُم بِحُكۡمِهِۦۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡعَلِيمُ",
    translation:
      "Indeed, your Lord will judge between them by His [wise] judgement. And He is the Exalted in Might, the Knowing",
    normalizedText: "ان ربك يقضي بينهم بحكمه وهو العزيز العليم",
  },
  {
    verseId: 78,
    name: "النمل",
    surahId: 27,
    text: "فَتَوَكَّلۡ عَلَى ٱللَّهِۖ إِنَّكَ عَلَى ٱلۡحَقِّ ٱلۡمُبِينِ",
    translation: "So rely upon Allah; indeed, you are upon the clear truth",
    normalizedText: "فتوكل على الله انك على الحق المبين",
  },
  {
    verseId: 79,
    name: "النمل",
    surahId: 27,
    text: "إِنَّكَ لَا تُسۡمِعُ ٱلۡمَوۡتَىٰ وَلَا تُسۡمِعُ ٱلصُّمَّ ٱلدُّعَآءَ إِذَا وَلَّوۡاْ مُدۡبِرِينَ",
    translation:
      "Indeed, you will not make the dead hear, nor will you make the deaf hear the call when they have turned their backs retreating",
    normalizedText: "انك لا تسمع الموتى ولا تسمع الصم الدعاء اذا ولوا مدبرين",
  },
  {
    verseId: 80,
    name: "النمل",
    surahId: 27,
    text: "وَمَآ أَنتَ بِهَٰدِي ٱلۡعُمۡيِ عَن ضَلَٰلَتِهِمۡۖ إِن تُسۡمِعُ إِلَّا مَن يُؤۡمِنُ بِـَٔايَٰتِنَا فَهُم مُّسۡلِمُونَ",
    translation:
      "And you cannot guide the blind away from their error. You will only make hear those who believe in Our verses so they are Muslims [submitting to Allah]",
    normalizedText:
      "وما انت بهدي العمي عن ضللتهم ان تسمع الا من يامن بايتنا فهم مسلمون",
  },
  {
    verseId: 81,
    name: "النمل",
    surahId: 27,
    text: "۞وَإِذَا وَقَعَ ٱلۡقَوۡلُ عَلَيۡهِمۡ أَخۡرَجۡنَا لَهُمۡ دَآبَّةٗ مِّنَ ٱلۡأَرۡضِ تُكَلِّمُهُمۡ أَنَّ ٱلنَّاسَ كَانُواْ بِـَٔايَٰتِنَا لَا يُوقِنُونَ",
    translation:
      "And when the word befalls them, We will bring forth for them a creature from the earth speaking to them, [saying] that the people were, of Our verses, not certain [in faith]",
    normalizedText:
      "۞واذا وقع القول عليهم اخرجنا لهم دابة من الارض تكلمهم ان الناس كانوا بايتنا لا يوقنون",
  },
  {
    verseId: 82,
    name: "النمل",
    surahId: 27,
    text: "وَيَوۡمَ نَحۡشُرُ مِن كُلِّ أُمَّةٖ فَوۡجٗا مِّمَّن يُكَذِّبُ بِـَٔايَٰتِنَا فَهُمۡ يُوزَعُونَ",
    translation:
      "And [warn of] the Day when We will gather from every nation a company of those who deny Our signs, and they will be [driven] in rows",
    normalizedText: "ويوم نحشر من كل امة فوجا ممن يكذب بايتنا فهم يوزعون",
  },
  {
    verseId: 83,
    name: "النمل",
    surahId: 27,
    text: "حَتَّىٰٓ إِذَا جَآءُو قَالَ أَكَذَّبۡتُم بِـَٔايَٰتِي وَلَمۡ تُحِيطُواْ بِهَا عِلۡمًا أَمَّاذَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'Until, when they arrive [at the place of Judgement], He will say, "Did you deny My signs while you encompassed them not in knowledge, or what [was it that] you were doing',
    normalizedText:
      "حتى اذا جاءو قال اكذبتم بايتي ولم تحيطوا بها علما اماذا كنتم تعملون",
  },
  {
    verseId: 84,
    name: "النمل",
    surahId: 27,
    text: "وَوَقَعَ ٱلۡقَوۡلُ عَلَيۡهِم بِمَا ظَلَمُواْ فَهُمۡ لَا يَنطِقُونَ",
    translation:
      "And the decree will befall them for the wrong they did, and they will not [be able to] speak",
    normalizedText: "ووقع القول عليهم بما ظلموا فهم لا ينطقون",
  },
  {
    verseId: 85,
    name: "النمل",
    surahId: 27,
    text: "أَلَمۡ يَرَوۡاْ أَنَّا جَعَلۡنَا ٱلَّيۡلَ لِيَسۡكُنُواْ فِيهِ وَٱلنَّهَارَ مُبۡصِرًاۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "Do they not see that We made the night that they may rest therein and the day giving sight? Indeed in that are signs for a people who believe",
    normalizedText:
      "الم يروا انا جعلنا اليل ليسكنوا فيه والنهار مبصرا ان في ذلك لايت لقوم يامنون",
  },
  {
    verseId: 86,
    name: "النمل",
    surahId: 27,
    text: "وَيَوۡمَ يُنفَخُ فِي ٱلصُّورِ فَفَزِعَ مَن فِي ٱلسَّمَٰوَٰتِ وَمَن فِي ٱلۡأَرۡضِ إِلَّا مَن شَآءَ ٱللَّهُۚ وَكُلٌّ أَتَوۡهُ دَٰخِرِينَ",
    translation:
      "And [warn of] the Day the Horn will be blown, and whoever is in the heavens and whoever is on the earth will be terrified except whom Allah wills. And all will come to Him humbled",
    normalizedText:
      "ويوم ينفخ في الصور ففزع من في السموت ومن في الارض الا من شاء الله وكل اتوه دخرين",
  },
  {
    verseId: 87,
    name: "النمل",
    surahId: 27,
    text: "وَتَرَى ٱلۡجِبَالَ تَحۡسَبُهَا جَامِدَةٗ وَهِيَ تَمُرُّ مَرَّ ٱلسَّحَابِۚ صُنۡعَ ٱللَّهِ ٱلَّذِيٓ أَتۡقَنَ كُلَّ شَيۡءٍۚ إِنَّهُۥ خَبِيرُۢ بِمَا تَفۡعَلُونَ",
    translation:
      "And you see the mountains, thinking them rigid, while they will pass as the passing of clouds. [It is] the work of Allah, who perfected all things. Indeed, He is Acquainted with that which you do",
    normalizedText:
      "وترى الجبال تحسبها جامدة وهي تمر مر السحاب صنع الله الذي اتقن كل شيء انه خبير بما تفعلون",
  },
  {
    verseId: 88,
    name: "النمل",
    surahId: 27,
    text: "مَن جَآءَ بِٱلۡحَسَنَةِ فَلَهُۥ خَيۡرٞ مِّنۡهَا وَهُم مِّن فَزَعٖ يَوۡمَئِذٍ ءَامِنُونَ",
    translation:
      "Whoever comes [at Judgement] with a good deed will have better than it, and they, from the terror of that Day, will be safe",
    normalizedText: "من جاء بالحسنة فله خير منها وهم من فزع يوماذ ءامنون",
  },
  {
    verseId: 89,
    name: "النمل",
    surahId: 27,
    text: "وَمَن جَآءَ بِٱلسَّيِّئَةِ فَكُبَّتۡ وُجُوهُهُمۡ فِي ٱلنَّارِ هَلۡ تُجۡزَوۡنَ إِلَّا مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'And whoever comes with an evil deed - their faces will be overturned into the Fire, [and it will be said], "Are you recompensed except for what you used to do',
    normalizedText:
      "ومن جاء بالسياة فكبت وجوههم في النار هل تجزون الا ما كنتم تعملون",
  },
  {
    verseId: 90,
    name: "النمل",
    surahId: 27,
    text: "إِنَّمَآ أُمِرۡتُ أَنۡ أَعۡبُدَ رَبَّ هَٰذِهِ ٱلۡبَلۡدَةِ ٱلَّذِي حَرَّمَهَا وَلَهُۥ كُلُّ شَيۡءٖۖ وَأُمِرۡتُ أَنۡ أَكُونَ مِنَ ٱلۡمُسۡلِمِينَ",
    translation:
      '[Say, O Muhammad], "I have only been commanded to worship the Lord of this city, who made it sacred and to whom [belongs] all things. And I am commanded to be of the Muslims [those who submit to Allah]',
    normalizedText:
      "انما امرت ان اعبد رب هذه البلدة الذي حرمها وله كل شيء وامرت ان اكون من المسلمين",
  },
  {
    verseId: 91,
    name: "النمل",
    surahId: 27,
    text: "وَأَنۡ أَتۡلُوَاْ ٱلۡقُرۡءَانَۖ فَمَنِ ٱهۡتَدَىٰ فَإِنَّمَا يَهۡتَدِي لِنَفۡسِهِۦۖ وَمَن ضَلَّ فَقُلۡ إِنَّمَآ أَنَا۠ مِنَ ٱلۡمُنذِرِينَ",
    translation: `And to recite the Qur'an." And whoever is guided is only guided for [the benefit of] himself; and whoever strays - say, "I am only [one] of the warners`,
    normalizedText:
      "وان اتلوا القرءان فمن اهتدى فانما يهتدي لنفسه ومن ضل فقل انما انا من المنذرين",
  },
  {
    verseId: 92,
    name: "النمل",
    surahId: 27,
    text: "وَقُلِ ٱلۡحَمۡدُ لِلَّهِ سَيُرِيكُمۡ ءَايَٰتِهِۦ فَتَعۡرِفُونَهَاۚ وَمَا رَبُّكَ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ",
    translation:
      'And say, "[All] praise is [due] to Allah. He will show you His signs, and you will recognize them. And your Lord is not unaware of what you do',
    normalizedText:
      "وقل الحمد لله سيريكم ءايته فتعرفونها وما ربك بغفل عما تعملون",
  },
  {
    verseId: 0,
    name: "القصص",
    surahId: 28,
    text: "طسٓمٓ",
    translation: "Ta, Seen, Meem",
    normalizedText: "طسم",
  },
  {
    verseId: 1,
    name: "القصص",
    surahId: 28,
    text: "تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡمُبِينِ",
    translation: "These are the verses of the clear Book",
    normalizedText: "تلك ءايت الكتب المبين",
  },
  {
    verseId: 2,
    name: "القصص",
    surahId: 28,
    text: "نَتۡلُواْ عَلَيۡكَ مِن نَّبَإِ مُوسَىٰ وَفِرۡعَوۡنَ بِٱلۡحَقِّ لِقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "We recite to you from the news of Moses and Pharaoh in truth for a people who believe",
    normalizedText: "نتلوا عليك من نبا موسى وفرعون بالحق لقوم يامنون",
  },
  {
    verseId: 3,
    name: "القصص",
    surahId: 28,
    text: "إِنَّ فِرۡعَوۡنَ عَلَا فِي ٱلۡأَرۡضِ وَجَعَلَ أَهۡلَهَا شِيَعٗا يَسۡتَضۡعِفُ طَآئِفَةٗ مِّنۡهُمۡ يُذَبِّحُ أَبۡنَآءَهُمۡ وَيَسۡتَحۡيِۦ نِسَآءَهُمۡۚ إِنَّهُۥ كَانَ مِنَ ٱلۡمُفۡسِدِينَ",
    translation:
      "Indeed, Pharaoh exalted himself in the land and made its people into factions, oppressing a sector among them, slaughtering their [newborn] sons and keeping their females alive. Indeed, he was of the corrupters",
    normalizedText:
      "ان فرعون علا في الارض وجعل اهلها شيعا يستضعف طاافة منهم يذبح ابناءهم ويستحي نساءهم انه كان من المفسدين",
  },
  {
    verseId: 4,
    name: "القصص",
    surahId: 28,
    text: "وَنُرِيدُ أَن نَّمُنَّ عَلَى ٱلَّذِينَ ٱسۡتُضۡعِفُواْ فِي ٱلۡأَرۡضِ وَنَجۡعَلَهُمۡ أَئِمَّةٗ وَنَجۡعَلَهُمُ ٱلۡوَٰرِثِينَ",
    translation:
      "And We wanted to confer favor upon those who were oppressed in the land and make them leaders and make them inheritors",
    normalizedText:
      "ونريد ان نمن على الذين استضعفوا في الارض ونجعلهم اامة ونجعلهم الورثين",
  },
  {
    verseId: 5,
    name: "القصص",
    surahId: 28,
    text: "وَنُمَكِّنَ لَهُمۡ فِي ٱلۡأَرۡضِ وَنُرِيَ فِرۡعَوۡنَ وَهَٰمَٰنَ وَجُنُودَهُمَا مِنۡهُم مَّا كَانُواْ يَحۡذَرُونَ",
    translation:
      "And establish them in the land and show Pharaoh and [his minister] Haman and their soldiers through them that which they had feared",
    normalizedText:
      "ونمكن لهم في الارض ونري فرعون وهمن وجنودهما منهم ما كانوا يحذرون",
  },
  {
    verseId: 6,
    name: "القصص",
    surahId: 28,
    text: "وَأَوۡحَيۡنَآ إِلَىٰٓ أُمِّ مُوسَىٰٓ أَنۡ أَرۡضِعِيهِۖ فَإِذَا خِفۡتِ عَلَيۡهِ فَأَلۡقِيهِ فِي ٱلۡيَمِّ وَلَا تَخَافِي وَلَا تَحۡزَنِيٓۖ إِنَّا رَآدُّوهُ إِلَيۡكِ وَجَاعِلُوهُ مِنَ ٱلۡمُرۡسَلِينَ",
    translation:
      'And We inspired to the mother of Moses, "Suckle him; but when you fear for him, cast him into the river and do not fear and do not grieve. Indeed, We will return him to you and will make him [one] of the messengers',
    normalizedText:
      "واوحينا الى ام موسى ان ارضعيه فاذا خفت عليه فالقيه في اليم ولا تخافي ولا تحزني انا رادوه اليك وجاعلوه من المرسلين",
  },
  {
    verseId: 7,
    name: "القصص",
    surahId: 28,
    text: "فَٱلۡتَقَطَهُۥٓ ءَالُ فِرۡعَوۡنَ لِيَكُونَ لَهُمۡ عَدُوّٗا وَحَزَنًاۗ إِنَّ فِرۡعَوۡنَ وَهَٰمَٰنَ وَجُنُودَهُمَا كَانُواْ خَٰطِـِٔينَ",
    translation:
      "And the family of Pharaoh picked him up [out of the river] so that he would become to them an enemy and a [cause of] grief. Indeed, Pharaoh and Haman and their soldiers were deliberate sinners",
    normalizedText:
      "فالتقطه ءال فرعون ليكون لهم عدوا وحزنا ان فرعون وهمن وجنودهما كانوا خطين",
  },
  {
    verseId: 8,
    name: "القصص",
    surahId: 28,
    text: "وَقَالَتِ ٱمۡرَأَتُ فِرۡعَوۡنَ قُرَّتُ عَيۡنٖ لِّي وَلَكَۖ لَا تَقۡتُلُوهُ عَسَىٰٓ أَن يَنفَعَنَآ أَوۡ نَتَّخِذَهُۥ وَلَدٗا وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      'And the wife of Pharaoh said, "[He will be] a comfort of the eye for me and for you. Do not kill him; perhaps he may benefit us, or we may adopt him as a son." And they perceived not',
    normalizedText:
      "وقالت امرات فرعون قرت عين لي ولك لا تقتلوه عسى ان ينفعنا او نتخذه ولدا وهم لا يشعرون",
  },
  {
    verseId: 9,
    name: "القصص",
    surahId: 28,
    text: "وَأَصۡبَحَ فُؤَادُ أُمِّ مُوسَىٰ فَٰرِغًاۖ إِن كَادَتۡ لَتُبۡدِي بِهِۦ لَوۡلَآ أَن رَّبَطۡنَا عَلَىٰ قَلۡبِهَا لِتَكُونَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "And the heart of Moses' mother became empty [of all else]. She was about to disclose [the matter concerning] him had We not bound fast her heart that she would be of the believers",
    normalizedText:
      "واصبح فااد ام موسى فرغا ان كادت لتبدي به لولا ان ربطنا على قلبها لتكون من المامنين",
  },
  {
    verseId: 10,
    name: "القصص",
    surahId: 28,
    text: "وَقَالَتۡ لِأُخۡتِهِۦ قُصِّيهِۖ فَبَصُرَتۡ بِهِۦ عَن جُنُبٖ وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      'And she said to his sister, "Follow him"; so she watched him from a distance while they perceived not',
    normalizedText: "وقالت لاخته قصيه فبصرت به عن جنب وهم لا يشعرون",
  },
  {
    verseId: 11,
    name: "القصص",
    surahId: 28,
    text: "۞وَحَرَّمۡنَا عَلَيۡهِ ٱلۡمَرَاضِعَ مِن قَبۡلُ فَقَالَتۡ هَلۡ أَدُلُّكُمۡ عَلَىٰٓ أَهۡلِ بَيۡتٖ يَكۡفُلُونَهُۥ لَكُمۡ وَهُمۡ لَهُۥ نَٰصِحُونَ",
    translation:
      'And We had prevented from him [all] wet nurses before, so she said, "Shall I direct you to a household that will be responsible for him for you while they are to him [for his upbringing] sincere',
    normalizedText:
      "۞وحرمنا عليه المراضع من قبل فقالت هل ادلكم على اهل بيت يكفلونه لكم وهم له نصحون",
  },
  {
    verseId: 12,
    name: "القصص",
    surahId: 28,
    text: "فَرَدَدۡنَٰهُ إِلَىٰٓ أُمِّهِۦ كَيۡ تَقَرَّ عَيۡنُهَا وَلَا تَحۡزَنَ وَلِتَعۡلَمَ أَنَّ وَعۡدَ ٱللَّهِ حَقّٞ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "So We restored him to his mother that she might be content and not grieve and that she would know that the promise of Allah is true. But most of the people do not know",
    normalizedText:
      "فرددنه الى امه كي تقر عينها ولا تحزن ولتعلم ان وعد الله حق ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 13,
    name: "القصص",
    surahId: 28,
    text: "وَلَمَّا بَلَغَ أَشُدَّهُۥ وَٱسۡتَوَىٰٓ ءَاتَيۡنَٰهُ حُكۡمٗا وَعِلۡمٗاۚ وَكَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation:
      "And when he attained his full strength and was [mentally] mature, We bestowed upon him judgement and knowledge. And thus do We reward the doers of good",
    normalizedText:
      "ولما بلغ اشده واستوى ءاتينه حكما وعلما وكذلك نجزي المحسنين",
  },
  {
    verseId: 14,
    name: "القصص",
    surahId: 28,
    text: "وَدَخَلَ ٱلۡمَدِينَةَ عَلَىٰ حِينِ غَفۡلَةٖ مِّنۡ أَهۡلِهَا فَوَجَدَ فِيهَا رَجُلَيۡنِ يَقۡتَتِلَانِ هَٰذَا مِن شِيعَتِهِۦ وَهَٰذَا مِنۡ عَدُوِّهِۦۖ فَٱسۡتَغَٰثَهُ ٱلَّذِي مِن شِيعَتِهِۦ عَلَى ٱلَّذِي مِنۡ عَدُوِّهِۦ فَوَكَزَهُۥ مُوسَىٰ فَقَضَىٰ عَلَيۡهِۖ قَالَ هَٰذَا مِنۡ عَمَلِ ٱلشَّيۡطَٰنِۖ إِنَّهُۥ عَدُوّٞ مُّضِلّٞ مُّبِينٞ",
    translation:
      'And he entered the city at a time of inattention by its people and found therein two men fighting: one from his faction and one from among his enemy. And the one from his faction called for help to him against the one from his enemy, so Moses struck him and [unintentionally] killed him. [Moses] said, "This is from the work of Satan. Indeed, he is a manifest, misleading enemy',
    normalizedText:
      "ودخل المدينة على حين غفلة من اهلها فوجد فيها رجلين يقتتلان هذا من شيعته وهذا من عدوه فاستغثه الذي من شيعته على الذي من عدوه فوكزه موسى فقضى عليه قال هذا من عمل الشيطن انه عدو مضل مبين",
  },
  {
    verseId: 15,
    name: "القصص",
    surahId: 28,
    text: "قَالَ رَبِّ إِنِّي ظَلَمۡتُ نَفۡسِي فَٱغۡفِرۡ لِي فَغَفَرَ لَهُۥٓۚ إِنَّهُۥ هُوَ ٱلۡغَفُورُ ٱلرَّحِيمُ",
    translation:
      'He said, "My Lord, indeed I have wronged myself, so forgive me," and He forgave him. Indeed, He is the Forgiving, the Merciful',
    normalizedText:
      "قال رب اني ظلمت نفسي فاغفر لي فغفر له انه هو الغفور الرحيم",
  },
  {
    verseId: 16,
    name: "القصص",
    surahId: 28,
    text: "قَالَ رَبِّ بِمَآ أَنۡعَمۡتَ عَلَيَّ فَلَنۡ أَكُونَ ظَهِيرٗا لِّلۡمُجۡرِمِينَ",
    translation:
      'He said, "My Lord, for the favor You bestowed upon me, I will never be an assistant to the criminals',
    normalizedText: "قال رب بما انعمت علي فلن اكون ظهيرا للمجرمين",
  },
  {
    verseId: 17,
    name: "القصص",
    surahId: 28,
    text: "فَأَصۡبَحَ فِي ٱلۡمَدِينَةِ خَآئِفٗا يَتَرَقَّبُ فَإِذَا ٱلَّذِي ٱسۡتَنصَرَهُۥ بِٱلۡأَمۡسِ يَسۡتَصۡرِخُهُۥۚ قَالَ لَهُۥ مُوسَىٰٓ إِنَّكَ لَغَوِيّٞ مُّبِينٞ",
    translation:
      'And he became inside the city fearful and anticipating [exposure], when suddenly the one who sought his help the previous day cried out to him [once again]. Moses said to him, "Indeed, you are an evident, [persistent] deviator',
    normalizedText:
      "فاصبح في المدينة خاافا يترقب فاذا الذي استنصره بالامس يستصرخه قال له موسى انك لغوي مبين",
  },
  {
    verseId: 18,
    name: "القصص",
    surahId: 28,
    text: "فَلَمَّآ أَنۡ أَرَادَ أَن يَبۡطِشَ بِٱلَّذِي هُوَ عَدُوّٞ لَّهُمَا قَالَ يَٰمُوسَىٰٓ أَتُرِيدُ أَن تَقۡتُلَنِي كَمَا قَتَلۡتَ نَفۡسَۢا بِٱلۡأَمۡسِۖ إِن تُرِيدُ إِلَّآ أَن تَكُونَ جَبَّارٗا فِي ٱلۡأَرۡضِ وَمَا تُرِيدُ أَن تَكُونَ مِنَ ٱلۡمُصۡلِحِينَ",
    translation:
      'And when he wanted to strike the one who was an enemy to both of them, he said, "O Moses, do you intend to kill me as you killed someone yesterday? You only want to be a tyrant in the land and do not want to be of the amenders',
    normalizedText:
      "فلما ان اراد ان يبطش بالذي هو عدو لهما قال يموسى اتريد ان تقتلني كما قتلت نفسا بالامس ان تريد الا ان تكون جبارا في الارض وما تريد ان تكون من المصلحين",
  },
  {
    verseId: 19,
    name: "القصص",
    surahId: 28,
    text: "وَجَآءَ رَجُلٞ مِّنۡ أَقۡصَا ٱلۡمَدِينَةِ يَسۡعَىٰ قَالَ يَٰمُوسَىٰٓ إِنَّ ٱلۡمَلَأَ يَأۡتَمِرُونَ بِكَ لِيَقۡتُلُوكَ فَٱخۡرُجۡ إِنِّي لَكَ مِنَ ٱلنَّـٰصِحِينَ",
    translation:
      'And a man came from the farthest end of the city, running. He said, "O Moses, indeed the eminent ones are conferring over you [intending] to kill you, so leave [the city]; indeed, I am to you of the sincere advisors',
    normalizedText:
      "وجاء رجل من اقصا المدينة يسعى قال يموسى ان الملا ياتمرون بك ليقتلوك فاخرج اني لك من النصحين",
  },
  {
    verseId: 20,
    name: "القصص",
    surahId: 28,
    text: "فَخَرَجَ مِنۡهَا خَآئِفٗا يَتَرَقَّبُۖ قَالَ رَبِّ نَجِّنِي مِنَ ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      'So he left it, fearful and anticipating [apprehension]. He said, "My Lord, save me from the wrongdoing people',
    normalizedText: "فخرج منها خاافا يترقب قال رب نجني من القوم الظلمين",
  },
  {
    verseId: 21,
    name: "القصص",
    surahId: 28,
    text: "وَلَمَّا تَوَجَّهَ تِلۡقَآءَ مَدۡيَنَ قَالَ عَسَىٰ رَبِّيٓ أَن يَهۡدِيَنِي سَوَآءَ ٱلسَّبِيلِ",
    translation:
      'And when he directed himself toward Madyan, he said, "Perhaps my Lord will guide me to the sound way',
    normalizedText: "ولما توجه تلقاء مدين قال عسى ربي ان يهديني سواء السبيل",
  },
  {
    verseId: 22,
    name: "القصص",
    surahId: 28,
    text: "وَلَمَّا وَرَدَ مَآءَ مَدۡيَنَ وَجَدَ عَلَيۡهِ أُمَّةٗ مِّنَ ٱلنَّاسِ يَسۡقُونَ وَوَجَدَ مِن دُونِهِمُ ٱمۡرَأَتَيۡنِ تَذُودَانِۖ قَالَ مَا خَطۡبُكُمَاۖ قَالَتَا لَا نَسۡقِي حَتَّىٰ يُصۡدِرَ ٱلرِّعَآءُۖ وَأَبُونَا شَيۡخٞ كَبِيرٞ",
    translation:
      'And when he came to the well of Madyan, he found there a crowd of people watering [their flocks], and he found aside from them two women driving back [their flocks]. He said, "What is your circumstance?" They said, "We do not water until the shepherds dispatch [their flocks]; and our father is an old man',
    normalizedText:
      "ولما ورد ماء مدين وجد عليه امة من الناس يسقون ووجد من دونهم امراتين تذودان قال ما خطبكما قالتا لا نسقي حتى يصدر الرعاء وابونا شيخ كبير",
  },
  {
    verseId: 23,
    name: "القصص",
    surahId: 28,
    text: "فَسَقَىٰ لَهُمَا ثُمَّ تَوَلَّىٰٓ إِلَى ٱلظِّلِّ فَقَالَ رَبِّ إِنِّي لِمَآ أَنزَلۡتَ إِلَيَّ مِنۡ خَيۡرٖ فَقِيرٞ",
    translation:
      'So he watered [their flocks] for them; then he went back to the shade and said, "My Lord, indeed I am, for whatever good You would send down to me, in need',
    normalizedText:
      "فسقى لهما ثم تولى الى الظل فقال رب اني لما انزلت الي من خير فقير",
  },
  {
    verseId: 24,
    name: "القصص",
    surahId: 28,
    text: "فَجَآءَتۡهُ إِحۡدَىٰهُمَا تَمۡشِي عَلَى ٱسۡتِحۡيَآءٖ قَالَتۡ إِنَّ أَبِي يَدۡعُوكَ لِيَجۡزِيَكَ أَجۡرَ مَا سَقَيۡتَ لَنَاۚ فَلَمَّا جَآءَهُۥ وَقَصَّ عَلَيۡهِ ٱلۡقَصَصَ قَالَ لَا تَخَفۡۖ نَجَوۡتَ مِنَ ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      'Then one of the two women came to him walking with shyness. She said, "Indeed, my father invites you that he may reward you for having watered for us." So when he came to him and related to him the story, he said, "Fear not. You have escaped from the wrongdoing people',
    normalizedText:
      "فجاءته احدىهما تمشي على استحياء قالت ان ابي يدعوك ليجزيك اجر ما سقيت لنا فلما جاءه وقص عليه القصص قال لا تخف نجوت من القوم الظلمين",
  },
  {
    verseId: 25,
    name: "القصص",
    surahId: 28,
    text: "قَالَتۡ إِحۡدَىٰهُمَا يَـٰٓأَبَتِ ٱسۡتَـٔۡجِرۡهُۖ إِنَّ خَيۡرَ مَنِ ٱسۡتَـٔۡجَرۡتَ ٱلۡقَوِيُّ ٱلۡأَمِينُ",
    translation:
      'One of the women said, "O my father, hire him. Indeed, the best one you can hire is the strong and the trustworthy',
    normalizedText: "قالت احدىهما يابت استجره ان خير من استجرت القوي الامين",
  },
  {
    verseId: 26,
    name: "القصص",
    surahId: 28,
    text: "قَالَ إِنِّيٓ أُرِيدُ أَنۡ أُنكِحَكَ إِحۡدَى ٱبۡنَتَيَّ هَٰتَيۡنِ عَلَىٰٓ أَن تَأۡجُرَنِي ثَمَٰنِيَ حِجَجٖۖ فَإِنۡ أَتۡمَمۡتَ عَشۡرٗا فَمِنۡ عِندِكَۖ وَمَآ أُرِيدُ أَنۡ أَشُقَّ عَلَيۡكَۚ سَتَجِدُنِيٓ إِن شَآءَ ٱللَّهُ مِنَ ٱلصَّـٰلِحِينَ",
    translation:
      'He said, "Indeed, I wish to wed you one of these, my two daughters, on [the condition] that you serve me for eight years; but if you complete ten, it will be [as a favor] from you. And I do not wish to put you in difficulty. You will find me, if Allah wills, from among the righteous',
    normalizedText:
      "قال اني اريد ان انكحك احدى ابنتي هتين على ان تاجرني ثمني حجج فان اتممت عشرا فمن عندك وما اريد ان اشق عليك ستجدني ان شاء الله من الصلحين",
  },
  {
    verseId: 27,
    name: "القصص",
    surahId: 28,
    text: "قَالَ ذَٰلِكَ بَيۡنِي وَبَيۡنَكَۖ أَيَّمَا ٱلۡأَجَلَيۡنِ قَضَيۡتُ فَلَا عُدۡوَٰنَ عَلَيَّۖ وَٱللَّهُ عَلَىٰ مَا نَقُولُ وَكِيلٞ",
    translation:
      '[Moses] said, "That is [established] between me and you. Whichever of the two terms I complete - there is no injustice to me, and Allah, over what we say, is Witness',
    normalizedText:
      "قال ذلك بيني وبينك ايما الاجلين قضيت فلا عدون علي والله على ما نقول وكيل",
  },
  {
    verseId: 28,
    name: "القصص",
    surahId: 28,
    text: "۞فَلَمَّا قَضَىٰ مُوسَى ٱلۡأَجَلَ وَسَارَ بِأَهۡلِهِۦٓ ءَانَسَ مِن جَانِبِ ٱلطُّورِ نَارٗاۖ قَالَ لِأَهۡلِهِ ٱمۡكُثُوٓاْ إِنِّيٓ ءَانَسۡتُ نَارٗا لَّعَلِّيٓ ءَاتِيكُم مِّنۡهَا بِخَبَرٍ أَوۡ جَذۡوَةٖ مِّنَ ٱلنَّارِ لَعَلَّكُمۡ تَصۡطَلُونَ",
    translation:
      'And when Moses had completed the term and was traveling with his family, he perceived from the direction of the mount a fire. He said to his family, "Stay here; indeed, I have perceived a fire. Perhaps I will bring you from there [some] information or burning wood from the fire that you may warm yourselves',
    normalizedText:
      "۞فلما قضى موسى الاجل وسار باهله ءانس من جانب الطور نارا قال لاهله امكثوا اني ءانست نارا لعلي ءاتيكم منها بخبر او جذوة من النار لعلكم تصطلون",
  },
  {
    verseId: 29,
    name: "القصص",
    surahId: 28,
    text: "فَلَمَّآ أَتَىٰهَا نُودِيَ مِن شَٰطِيِٕ ٱلۡوَادِ ٱلۡأَيۡمَنِ فِي ٱلۡبُقۡعَةِ ٱلۡمُبَٰرَكَةِ مِنَ ٱلشَّجَرَةِ أَن يَٰمُوسَىٰٓ إِنِّيٓ أَنَا ٱللَّهُ رَبُّ ٱلۡعَٰلَمِينَ",
    translation:
      'But when he came to it, he was called from the right side of the valley in a blessed spot - from the tree, "O Moses, indeed I am Allah, Lord of the worlds',
    normalizedText:
      "فلما اتىها نودي من شطي الواد الايمن في البقعة المبركة من الشجرة ان يموسى اني انا الله رب العلمين",
  },
  {
    verseId: 30,
    name: "القصص",
    surahId: 28,
    text: "وَأَنۡ أَلۡقِ عَصَاكَۚ فَلَمَّا رَءَاهَا تَهۡتَزُّ كَأَنَّهَا جَآنّٞ وَلَّىٰ مُدۡبِرٗا وَلَمۡ يُعَقِّبۡۚ يَٰمُوسَىٰٓ أَقۡبِلۡ وَلَا تَخَفۡۖ إِنَّكَ مِنَ ٱلۡأٓمِنِينَ",
    translation:
      'And [he was told], "Throw down your staff." But when he saw it writhing as if it was a snake, he turned in flight and did not return. [Allah said], "O Moses, approach and fear not. Indeed, you are of the secure',
    normalizedText:
      "وان الق عصاك فلما رءاها تهتز كانها جان ولى مدبرا ولم يعقب يموسى اقبل ولا تخف انك من الامنين",
  },
  {
    verseId: 31,
    name: "القصص",
    surahId: 28,
    text: "ٱسۡلُكۡ يَدَكَ فِي جَيۡبِكَ تَخۡرُجۡ بَيۡضَآءَ مِنۡ غَيۡرِ سُوٓءٖ وَٱضۡمُمۡ إِلَيۡكَ جَنَاحَكَ مِنَ ٱلرَّهۡبِۖ فَذَٰنِكَ بُرۡهَٰنَانِ مِن رَّبِّكَ إِلَىٰ فِرۡعَوۡنَ وَمَلَإِيْهِۦٓۚ إِنَّهُمۡ كَانُواْ قَوۡمٗا فَٰسِقِينَ",
    translation:
      "Insert your hand into the opening of your garment; it will come out white, without disease. And draw in your arm close to you [as prevention] from fear, for those are two proofs from your Lord to Pharaoh and his establishment. Indeed, they have been a people defiantly disobedient",
    normalizedText:
      "اسلك يدك في جيبك تخرج بيضاء من غير سوء واضمم اليك جناحك من الرهب فذنك برهنان من ربك الى فرعون وملايه انهم كانوا قوما فسقين",
  },
  {
    verseId: 32,
    name: "القصص",
    surahId: 28,
    text: "قَالَ رَبِّ إِنِّي قَتَلۡتُ مِنۡهُمۡ نَفۡسٗا فَأَخَافُ أَن يَقۡتُلُونِ",
    translation:
      'He said, "My Lord, indeed, I killed from among them someone, and I fear they will kill me',
    normalizedText: "قال رب اني قتلت منهم نفسا فاخاف ان يقتلون",
  },
  {
    verseId: 33,
    name: "القصص",
    surahId: 28,
    text: "وَأَخِي هَٰرُونُ هُوَ أَفۡصَحُ مِنِّي لِسَانٗا فَأَرۡسِلۡهُ مَعِيَ رِدۡءٗا يُصَدِّقُنِيٓۖ إِنِّيٓ أَخَافُ أَن يُكَذِّبُونِ",
    translation:
      "And my brother Aaron is more fluent than me in tongue, so send him with me as support, verifying me. Indeed, I fear that they will deny me",
    normalizedText:
      "واخي هرون هو افصح مني لسانا فارسله معي ردءا يصدقني اني اخاف ان يكذبون",
  },
  {
    verseId: 34,
    name: "القصص",
    surahId: 28,
    text: "قَالَ سَنَشُدُّ عَضُدَكَ بِأَخِيكَ وَنَجۡعَلُ لَكُمَا سُلۡطَٰنٗا فَلَا يَصِلُونَ إِلَيۡكُمَا بِـَٔايَٰتِنَآۚ أَنتُمَا وَمَنِ ٱتَّبَعَكُمَا ٱلۡغَٰلِبُونَ",
    translation:
      '[Allah] said, "We will strengthen your arm through your brother and grant you both supremacy so they will not reach you. [It will be] through Our signs; you and those who follow you will be the predominant',
    normalizedText:
      "قال سنشد عضدك باخيك ونجعل لكما سلطنا فلا يصلون اليكما بايتنا انتما ومن اتبعكما الغلبون",
  },
  {
    verseId: 35,
    name: "القصص",
    surahId: 28,
    text: "فَلَمَّا جَآءَهُم مُّوسَىٰ بِـَٔايَٰتِنَا بَيِّنَٰتٖ قَالُواْ مَا هَٰذَآ إِلَّا سِحۡرٞ مُّفۡتَرٗى وَمَا سَمِعۡنَا بِهَٰذَا فِيٓ ءَابَآئِنَا ٱلۡأَوَّلِينَ",
    translation:
      'But when Moses came to them with Our signs as clear evidences, they said, "This is not except invented magic, and we have not heard of this [religion] among our forefathers',
    normalizedText:
      "فلما جاءهم موسى بايتنا بينت قالوا ما هذا الا سحر مفترى وما سمعنا بهذا في ءاباانا الاولين",
  },
  {
    verseId: 36,
    name: "القصص",
    surahId: 28,
    text: "وَقَالَ مُوسَىٰ رَبِّيٓ أَعۡلَمُ بِمَن جَآءَ بِٱلۡهُدَىٰ مِنۡ عِندِهِۦ وَمَن تَكُونُ لَهُۥ عَٰقِبَةُ ٱلدَّارِۚ إِنَّهُۥ لَا يُفۡلِحُ ٱلظَّـٰلِمُونَ",
    translation:
      'And Moses said, "My Lord is more knowing [than we or you] of who has come with guidance from Him and to whom will be succession in the home. Indeed, wrongdoers do not succeed',
    normalizedText:
      "وقال موسى ربي اعلم بمن جاء بالهدى من عنده ومن تكون له عقبة الدار انه لا يفلح الظلمون",
  },
  {
    verseId: 37,
    name: "القصص",
    surahId: 28,
    text: "وَقَالَ فِرۡعَوۡنُ يَـٰٓأَيُّهَا ٱلۡمَلَأُ مَا عَلِمۡتُ لَكُم مِّنۡ إِلَٰهٍ غَيۡرِي فَأَوۡقِدۡ لِي يَٰهَٰمَٰنُ عَلَى ٱلطِّينِ فَٱجۡعَل لِّي صَرۡحٗا لَّعَلِّيٓ أَطَّلِعُ إِلَىٰٓ إِلَٰهِ مُوسَىٰ وَإِنِّي لَأَظُنُّهُۥ مِنَ ٱلۡكَٰذِبِينَ",
    translation:
      'And Pharaoh said, "O eminent ones, I have not known you to have a god other than me. Then ignite for me, O Haman, [a fire] upon the clay and make for me a tower that I may look at the God of Moses. And indeed, I do think he is among the liars',
    normalizedText:
      "وقال فرعون يايها الملا ما علمت لكم من اله غيري فاوقد لي يهمن على الطين فاجعل لي صرحا لعلي اطلع الى اله موسى واني لاظنه من الكذبين",
  },
  {
    verseId: 38,
    name: "القصص",
    surahId: 28,
    text: "وَٱسۡتَكۡبَرَ هُوَ وَجُنُودُهُۥ فِي ٱلۡأَرۡضِ بِغَيۡرِ ٱلۡحَقِّ وَظَنُّوٓاْ أَنَّهُمۡ إِلَيۡنَا لَا يُرۡجَعُونَ",
    translation:
      "And he was arrogant, he and his soldiers, in the land, without right, and they thought that they would not be returned to Us",
    normalizedText:
      "واستكبر هو وجنوده في الارض بغير الحق وظنوا انهم الينا لا يرجعون",
  },
  {
    verseId: 39,
    name: "القصص",
    surahId: 28,
    text: "فَأَخَذۡنَٰهُ وَجُنُودَهُۥ فَنَبَذۡنَٰهُمۡ فِي ٱلۡيَمِّۖ فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلظَّـٰلِمِينَ",
    translation:
      "So We took him and his soldiers and threw them into the sea. So see how was the end of the wrongdoers",
    normalizedText: "فاخذنه وجنوده فنبذنهم في اليم فانظر كيف كان عقبة الظلمين",
  },
  {
    verseId: 40,
    name: "القصص",
    surahId: 28,
    text: "وَجَعَلۡنَٰهُمۡ أَئِمَّةٗ يَدۡعُونَ إِلَى ٱلنَّارِۖ وَيَوۡمَ ٱلۡقِيَٰمَةِ لَا يُنصَرُونَ",
    translation:
      "And We made them leaders inviting to the Fire, and on the Day of Resurrection they will not be helped",
    normalizedText: "وجعلنهم اامة يدعون الى النار ويوم القيمة لا ينصرون",
  },
  {
    verseId: 41,
    name: "القصص",
    surahId: 28,
    text: "وَأَتۡبَعۡنَٰهُمۡ فِي هَٰذِهِ ٱلدُّنۡيَا لَعۡنَةٗۖ وَيَوۡمَ ٱلۡقِيَٰمَةِ هُم مِّنَ ٱلۡمَقۡبُوحِينَ",
    translation:
      "And We caused to overtake them in this world a curse, and on the Day of Resurrection they will be of the despised",
    normalizedText: "واتبعنهم في هذه الدنيا لعنة ويوم القيمة هم من المقبوحين",
  },
  {
    verseId: 42,
    name: "القصص",
    surahId: 28,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ مِنۢ بَعۡدِ مَآ أَهۡلَكۡنَا ٱلۡقُرُونَ ٱلۡأُولَىٰ بَصَآئِرَ لِلنَّاسِ وَهُدٗى وَرَحۡمَةٗ لَّعَلَّهُمۡ يَتَذَكَّرُونَ",
    translation:
      "And We gave Moses the Scripture, after We had destroyed the former generations, as enlightenment for the people and guidance and mercy that they might be reminded",
    normalizedText:
      "ولقد ءاتينا موسى الكتب من بعد ما اهلكنا القرون الاولى بصاار للناس وهدى ورحمة لعلهم يتذكرون",
  },
  {
    verseId: 43,
    name: "القصص",
    surahId: 28,
    text: "وَمَا كُنتَ بِجَانِبِ ٱلۡغَرۡبِيِّ إِذۡ قَضَيۡنَآ إِلَىٰ مُوسَى ٱلۡأَمۡرَ وَمَا كُنتَ مِنَ ٱلشَّـٰهِدِينَ",
    translation:
      "And you, [O Muhammad], were not on the western side [of the mount] when We revealed to Moses the command, and you were not among the witnesses [to that]",
    normalizedText:
      "وما كنت بجانب الغربي اذ قضينا الى موسى الامر وما كنت من الشهدين",
  },
  {
    verseId: 44,
    name: "القصص",
    surahId: 28,
    text: "وَلَٰكِنَّآ أَنشَأۡنَا قُرُونٗا فَتَطَاوَلَ عَلَيۡهِمُ ٱلۡعُمُرُۚ وَمَا كُنتَ ثَاوِيٗا فِيٓ أَهۡلِ مَدۡيَنَ تَتۡلُواْ عَلَيۡهِمۡ ءَايَٰتِنَا وَلَٰكِنَّا كُنَّا مُرۡسِلِينَ",
    translation:
      "But We produced [many] generations [after Moses], and prolonged was their duration. And you were not a resident among the people of Madyan, reciting to them Our verses, but We were senders [of this message]",
    normalizedText:
      "ولكنا انشانا قرونا فتطاول عليهم العمر وما كنت ثاويا في اهل مدين تتلوا عليهم ءايتنا ولكنا كنا مرسلين",
  },
  {
    verseId: 45,
    name: "القصص",
    surahId: 28,
    text: "وَمَا كُنتَ بِجَانِبِ ٱلطُّورِ إِذۡ نَادَيۡنَا وَلَٰكِن رَّحۡمَةٗ مِّن رَّبِّكَ لِتُنذِرَ قَوۡمٗا مَّآ أَتَىٰهُم مِّن نَّذِيرٖ مِّن قَبۡلِكَ لَعَلَّهُمۡ يَتَذَكَّرُونَ",
    translation:
      "And you were not at the side of the mount when We called [Moses] but [were sent] as a mercy from your Lord to warn a people to whom no warner had come before you that they might be reminded",
    normalizedText:
      "وما كنت بجانب الطور اذ نادينا ولكن رحمة من ربك لتنذر قوما ما اتىهم من نذير من قبلك لعلهم يتذكرون",
  },
  {
    verseId: 46,
    name: "القصص",
    surahId: 28,
    text: "وَلَوۡلَآ أَن تُصِيبَهُم مُّصِيبَةُۢ بِمَا قَدَّمَتۡ أَيۡدِيهِمۡ فَيَقُولُواْ رَبَّنَا لَوۡلَآ أَرۡسَلۡتَ إِلَيۡنَا رَسُولٗا فَنَتَّبِعَ ءَايَٰتِكَ وَنَكُونَ مِنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      'And if not that a disaster should strike them for what their hands put forth [of sins] and they would say, "Our Lord, why did You not send us a messenger so we could have followed Your verses and been among the believers',
    normalizedText:
      "ولولا ان تصيبهم مصيبة بما قدمت ايديهم فيقولوا ربنا لولا ارسلت الينا رسولا فنتبع ءايتك ونكون من المامنين",
  },
  {
    verseId: 47,
    name: "القصص",
    surahId: 28,
    text: "فَلَمَّا جَآءَهُمُ ٱلۡحَقُّ مِنۡ عِندِنَا قَالُواْ لَوۡلَآ أُوتِيَ مِثۡلَ مَآ أُوتِيَ مُوسَىٰٓۚ أَوَلَمۡ يَكۡفُرُواْ بِمَآ أُوتِيَ مُوسَىٰ مِن قَبۡلُۖ قَالُواْ سِحۡرَانِ تَظَٰهَرَا وَقَالُوٓاْ إِنَّا بِكُلّٖ كَٰفِرُونَ",
    translation:
      'But when the truth came to them from Us, they said, "Why was he not given like that which was given to Moses?" Did they not disbelieve in that which was given to Moses before? They said, "[They are but] two works of magic supporting each other, and indeed we are, in both, disbelievers',
    normalizedText:
      "فلما جاءهم الحق من عندنا قالوا لولا اوتي مثل ما اوتي موسى اولم يكفروا بما اوتي موسى من قبل قالوا سحران تظهرا وقالوا انا بكل كفرون",
  },
  {
    verseId: 48,
    name: "القصص",
    surahId: 28,
    text: "قُلۡ فَأۡتُواْ بِكِتَٰبٖ مِّنۡ عِندِ ٱللَّهِ هُوَ أَهۡدَىٰ مِنۡهُمَآ أَتَّبِعۡهُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Say, "Then bring a scripture from Allah which is more guiding than either of them that I may follow it, if you should be truthful',
    normalizedText:
      "قل فاتوا بكتب من عند الله هو اهدى منهما اتبعه ان كنتم صدقين",
  },
  {
    verseId: 49,
    name: "القصص",
    surahId: 28,
    text: "فَإِن لَّمۡ يَسۡتَجِيبُواْ لَكَ فَٱعۡلَمۡ أَنَّمَا يَتَّبِعُونَ أَهۡوَآءَهُمۡۚ وَمَنۡ أَضَلُّ مِمَّنِ ٱتَّبَعَ هَوَىٰهُ بِغَيۡرِ هُدٗى مِّنَ ٱللَّهِۚ إِنَّ ٱللَّهَ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      "But if they do not respond to you - then know that they only follow their [own] desires. And who is more astray than one who follows his desire without guidance from Allah? Indeed, Allah does not guide the wrongdoing people",
    normalizedText:
      "فان لم يستجيبوا لك فاعلم انما يتبعون اهواءهم ومن اضل ممن اتبع هوىه بغير هدى من الله ان الله لا يهدي القوم الظلمين",
  },
  {
    verseId: 50,
    name: "القصص",
    surahId: 28,
    text: "۞وَلَقَدۡ وَصَّلۡنَا لَهُمُ ٱلۡقَوۡلَ لَعَلَّهُمۡ يَتَذَكَّرُونَ",
    translation:
      "And We have [repeatedly] conveyed to them the Qur'an that they might be reminded",
    normalizedText: "۞ولقد وصلنا لهم القول لعلهم يتذكرون",
  },
  {
    verseId: 51,
    name: "القصص",
    surahId: 28,
    text: "ٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ مِن قَبۡلِهِۦ هُم بِهِۦ يُؤۡمِنُونَ",
    translation:
      "Those to whom We gave the Scripture before it - they are believers in it",
    normalizedText: "الذين ءاتينهم الكتب من قبله هم به يامنون",
  },
  {
    verseId: 52,
    name: "القصص",
    surahId: 28,
    text: "وَإِذَا يُتۡلَىٰ عَلَيۡهِمۡ قَالُوٓاْ ءَامَنَّا بِهِۦٓ إِنَّهُ ٱلۡحَقُّ مِن رَّبِّنَآ إِنَّا كُنَّا مِن قَبۡلِهِۦ مُسۡلِمِينَ",
    translation:
      'And when it is recited to them, they say, "We have believed in it; indeed, it is the truth from our Lord. Indeed we were, [even] before it, Muslims [submitting to Allah]',
    normalizedText:
      "واذا يتلى عليهم قالوا ءامنا به انه الحق من ربنا انا كنا من قبله مسلمين",
  },
  {
    verseId: 53,
    name: "القصص",
    surahId: 28,
    text: "أُوْلَـٰٓئِكَ يُؤۡتَوۡنَ أَجۡرَهُم مَّرَّتَيۡنِ بِمَا صَبَرُواْ وَيَدۡرَءُونَ بِٱلۡحَسَنَةِ ٱلسَّيِّئَةَ وَمِمَّا رَزَقۡنَٰهُمۡ يُنفِقُونَ",
    translation:
      "Those will be given their reward twice for what they patiently endured and [because] they avert evil through good, and from what We have provided them they spend",
    normalizedText:
      "اولاك ياتون اجرهم مرتين بما صبروا ويدرءون بالحسنة السياة ومما رزقنهم ينفقون",
  },
  {
    verseId: 54,
    name: "القصص",
    surahId: 28,
    text: "وَإِذَا سَمِعُواْ ٱللَّغۡوَ أَعۡرَضُواْ عَنۡهُ وَقَالُواْ لَنَآ أَعۡمَٰلُنَا وَلَكُمۡ أَعۡمَٰلُكُمۡ سَلَٰمٌ عَلَيۡكُمۡ لَا نَبۡتَغِي ٱلۡجَٰهِلِينَ",
    translation:
      'And when they hear ill speech, they turn away from it and say, "For us are our deeds, and for you are your deeds. Peace will be upon you; we seek not the ignorant',
    normalizedText:
      "واذا سمعوا اللغو اعرضوا عنه وقالوا لنا اعملنا ولكم اعملكم سلم عليكم لا نبتغي الجهلين",
  },
  {
    verseId: 55,
    name: "القصص",
    surahId: 28,
    text: "إِنَّكَ لَا تَهۡدِي مَنۡ أَحۡبَبۡتَ وَلَٰكِنَّ ٱللَّهَ يَهۡدِي مَن يَشَآءُۚ وَهُوَ أَعۡلَمُ بِٱلۡمُهۡتَدِينَ",
    translation:
      "Indeed, [O Muhammad], you do not guide whom you like, but Allah guides whom He wills. And He is most knowing of the [rightly] guided",
    normalizedText:
      "انك لا تهدي من احببت ولكن الله يهدي من يشاء وهو اعلم بالمهتدين",
  },
  {
    verseId: 56,
    name: "القصص",
    surahId: 28,
    text: "وَقَالُوٓاْ إِن نَّتَّبِعِ ٱلۡهُدَىٰ مَعَكَ نُتَخَطَّفۡ مِنۡ أَرۡضِنَآۚ أَوَلَمۡ نُمَكِّن لَّهُمۡ حَرَمًا ءَامِنٗا يُجۡبَىٰٓ إِلَيۡهِ ثَمَرَٰتُ كُلِّ شَيۡءٖ رِّزۡقٗا مِّن لَّدُنَّا وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      'And they say, "If we were to follow the guidance with you, we would be swept from our land." Have we not established for them a safe sanctuary to which are brought the fruits of all things as provision from Us? But most of them do not know',
    normalizedText:
      "وقالوا ان نتبع الهدى معك نتخطف من ارضنا اولم نمكن لهم حرما ءامنا يجبى اليه ثمرت كل شيء رزقا من لدنا ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 57,
    name: "القصص",
    surahId: 28,
    text: "وَكَمۡ أَهۡلَكۡنَا مِن قَرۡيَةِۭ بَطِرَتۡ مَعِيشَتَهَاۖ فَتِلۡكَ مَسَٰكِنُهُمۡ لَمۡ تُسۡكَن مِّنۢ بَعۡدِهِمۡ إِلَّا قَلِيلٗاۖ وَكُنَّا نَحۡنُ ٱلۡوَٰرِثِينَ",
    translation:
      "And how many a city have We destroyed that was insolent in its [way of] living, and those are their dwellings which have not been inhabited after them except briefly. And it is We who were the inheritors",
    normalizedText:
      "وكم اهلكنا من قرية بطرت معيشتها فتلك مسكنهم لم تسكن من بعدهم الا قليلا وكنا نحن الورثين",
  },
  {
    verseId: 58,
    name: "القصص",
    surahId: 28,
    text: "وَمَا كَانَ رَبُّكَ مُهۡلِكَ ٱلۡقُرَىٰ حَتَّىٰ يَبۡعَثَ فِيٓ أُمِّهَا رَسُولٗا يَتۡلُواْ عَلَيۡهِمۡ ءَايَٰتِنَاۚ وَمَا كُنَّا مُهۡلِكِي ٱلۡقُرَىٰٓ إِلَّا وَأَهۡلُهَا ظَٰلِمُونَ",
    translation:
      "And never would your Lord have destroyed the cities until He had sent to their mother a messenger reciting to them Our verses. And We would not destroy the cities except while their people were wrongdoers",
    normalizedText:
      "وما كان ربك مهلك القرى حتى يبعث في امها رسولا يتلوا عليهم ءايتنا وما كنا مهلكي القرى الا واهلها ظلمون",
  },
  {
    verseId: 59,
    name: "القصص",
    surahId: 28,
    text: "وَمَآ أُوتِيتُم مِّن شَيۡءٖ فَمَتَٰعُ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَزِينَتُهَاۚ وَمَا عِندَ ٱللَّهِ خَيۡرٞ وَأَبۡقَىٰٓۚ أَفَلَا تَعۡقِلُونَ",
    translation:
      "And whatever thing you [people] have been given - it is [only for] the enjoyment of worldly life and its adornment. And what is with Allah is better and more lasting; so will you not use reason",
    normalizedText:
      "وما اوتيتم من شيء فمتع الحيوة الدنيا وزينتها وما عند الله خير وابقى افلا تعقلون",
  },
  {
    verseId: 60,
    name: "القصص",
    surahId: 28,
    text: "أَفَمَن وَعَدۡنَٰهُ وَعۡدًا حَسَنٗا فَهُوَ لَٰقِيهِ كَمَن مَّتَّعۡنَٰهُ مَتَٰعَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا ثُمَّ هُوَ يَوۡمَ ٱلۡقِيَٰمَةِ مِنَ ٱلۡمُحۡضَرِينَ",
    translation:
      "Then is he whom We have promised a good promise which he will obtain like he for whom We provided enjoyment of worldly life [but] then he is, on the Day of Resurrection, among those presented [for punishment in Hell]",
    normalizedText:
      "افمن وعدنه وعدا حسنا فهو لقيه كمن متعنه متع الحيوة الدنيا ثم هو يوم القيمة من المحضرين",
  },
  {
    verseId: 61,
    name: "القصص",
    surahId: 28,
    text: "وَيَوۡمَ يُنَادِيهِمۡ فَيَقُولُ أَيۡنَ شُرَكَآءِيَ ٱلَّذِينَ كُنتُمۡ تَزۡعُمُونَ",
    translation: `And [warn of] the Day He will call them and say, "Where are My 'partners' which you used to claim`,
    normalizedText: "ويوم يناديهم فيقول اين شركاءي الذين كنتم تزعمون",
  },
  {
    verseId: 62,
    name: "القصص",
    surahId: 28,
    text: "قَالَ ٱلَّذِينَ حَقَّ عَلَيۡهِمُ ٱلۡقَوۡلُ رَبَّنَا هَـٰٓؤُلَآءِ ٱلَّذِينَ أَغۡوَيۡنَآ أَغۡوَيۡنَٰهُمۡ كَمَا غَوَيۡنَاۖ تَبَرَّأۡنَآ إِلَيۡكَۖ مَا كَانُوٓاْ إِيَّانَا يَعۡبُدُونَ",
    translation:
      'Those upon whom the word will have come into effect will say, "Our Lord, these are the ones we led to error. We led them to error just as we were in error. We declare our disassociation [from them] to You. They did not used to worship us',
    normalizedText:
      "قال الذين حق عليهم القول ربنا هالاء الذين اغوينا اغوينهم كما غوينا تبرانا اليك ما كانوا ايانا يعبدون",
  },
  {
    verseId: 63,
    name: "القصص",
    surahId: 28,
    text: "وَقِيلَ ٱدۡعُواْ شُرَكَآءَكُمۡ فَدَعَوۡهُمۡ فَلَمۡ يَسۡتَجِيبُواْ لَهُمۡ وَرَأَوُاْ ٱلۡعَذَابَۚ لَوۡ أَنَّهُمۡ كَانُواْ يَهۡتَدُونَ",
    translation: `And it will be said, "Invoke your 'partners' " and they will invoke them; but they will not respond to them, and they will see the punishment. If only they had followed guidance`,
    normalizedText:
      "وقيل ادعوا شركاءكم فدعوهم فلم يستجيبوا لهم وراوا العذاب لو انهم كانوا يهتدون",
  },
  {
    verseId: 64,
    name: "القصص",
    surahId: 28,
    text: "وَيَوۡمَ يُنَادِيهِمۡ فَيَقُولُ مَاذَآ أَجَبۡتُمُ ٱلۡمُرۡسَلِينَ",
    translation:
      'And [mention] the Day He will call them and say, "What did you answer the messengers',
    normalizedText: "ويوم يناديهم فيقول ماذا اجبتم المرسلين",
  },
  {
    verseId: 65,
    name: "القصص",
    surahId: 28,
    text: "فَعَمِيَتۡ عَلَيۡهِمُ ٱلۡأَنۢبَآءُ يَوۡمَئِذٖ فَهُمۡ لَا يَتَسَآءَلُونَ",
    translation:
      "But the information will be unapparent to them that Day, so they will not [be able to] ask one another",
    normalizedText: "فعميت عليهم الانباء يوماذ فهم لا يتساءلون",
  },
  {
    verseId: 66,
    name: "القصص",
    surahId: 28,
    text: "فَأَمَّا مَن تَابَ وَءَامَنَ وَعَمِلَ صَٰلِحٗا فَعَسَىٰٓ أَن يَكُونَ مِنَ ٱلۡمُفۡلِحِينَ",
    translation:
      "But as for one who had repented, believed, and done righteousness, it is promised by Allah that he will be among the successful",
    normalizedText: "فاما من تاب وءامن وعمل صلحا فعسى ان يكون من المفلحين",
  },
  {
    verseId: 67,
    name: "القصص",
    surahId: 28,
    text: "وَرَبُّكَ يَخۡلُقُ مَا يَشَآءُ وَيَخۡتَارُۗ مَا كَانَ لَهُمُ ٱلۡخِيَرَةُۚ سُبۡحَٰنَ ٱللَّهِ وَتَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      "And your Lord creates what He wills and chooses; not for them was the choice. Exalted is Allah and high above what they associate with Him",
    normalizedText:
      "وربك يخلق ما يشاء ويختار ما كان لهم الخيرة سبحن الله وتعلى عما يشركون",
  },
  {
    verseId: 68,
    name: "القصص",
    surahId: 28,
    text: "وَرَبُّكَ يَعۡلَمُ مَا تُكِنُّ صُدُورُهُمۡ وَمَا يُعۡلِنُونَ",
    translation:
      "And your Lord knows what their breasts conceal and what they declare",
    normalizedText: "وربك يعلم ما تكن صدورهم وما يعلنون",
  },
  {
    verseId: 69,
    name: "القصص",
    surahId: 28,
    text: "وَهُوَ ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَۖ لَهُ ٱلۡحَمۡدُ فِي ٱلۡأُولَىٰ وَٱلۡأٓخِرَةِۖ وَلَهُ ٱلۡحُكۡمُ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "And He is Allah; there is no deity except Him. To Him is [due all] praise in the first [life] and the Hereafter. And His is the [final] decision, and to Him you will be returned",
    normalizedText:
      "وهو الله لا اله الا هو له الحمد في الاولى والاخرة وله الحكم واليه ترجعون",
  },
  {
    verseId: 70,
    name: "القصص",
    surahId: 28,
    text: "قُلۡ أَرَءَيۡتُمۡ إِن جَعَلَ ٱللَّهُ عَلَيۡكُمُ ٱلَّيۡلَ سَرۡمَدًا إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ مَنۡ إِلَٰهٌ غَيۡرُ ٱللَّهِ يَأۡتِيكُم بِضِيَآءٍۚ أَفَلَا تَسۡمَعُونَ",
    translation:
      'Say, "Have you considered: if Allah should make for you the night continuous until the Day of Resurrection, what deity other than Allah could bring you light? Then will you not hear',
    normalizedText:
      "قل ارءيتم ان جعل الله عليكم اليل سرمدا الى يوم القيمة من اله غير الله ياتيكم بضياء افلا تسمعون",
  },
  {
    verseId: 71,
    name: "القصص",
    surahId: 28,
    text: "قُلۡ أَرَءَيۡتُمۡ إِن جَعَلَ ٱللَّهُ عَلَيۡكُمُ ٱلنَّهَارَ سَرۡمَدًا إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ مَنۡ إِلَٰهٌ غَيۡرُ ٱللَّهِ يَأۡتِيكُم بِلَيۡلٖ تَسۡكُنُونَ فِيهِۚ أَفَلَا تُبۡصِرُونَ",
    translation:
      'Say, "Have you considered: if Allah should make for you the day continuous until the Day of Resurrection, what deity other than Allah could bring you a night in which you may rest? Then will you not see',
    normalizedText:
      "قل ارءيتم ان جعل الله عليكم النهار سرمدا الى يوم القيمة من اله غير الله ياتيكم بليل تسكنون فيه افلا تبصرون",
  },
  {
    verseId: 72,
    name: "القصص",
    surahId: 28,
    text: "وَمِن رَّحۡمَتِهِۦ جَعَلَ لَكُمُ ٱلَّيۡلَ وَٱلنَّهَارَ لِتَسۡكُنُواْ فِيهِ وَلِتَبۡتَغُواْ مِن فَضۡلِهِۦ وَلَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And out of His mercy He made for you the night and the day that you may rest therein and [by day] seek from His bounty and [that] perhaps you will be grateful",
    normalizedText:
      "ومن رحمته جعل لكم اليل والنهار لتسكنوا فيه ولتبتغوا من فضله ولعلكم تشكرون",
  },
  {
    verseId: 73,
    name: "القصص",
    surahId: 28,
    text: "وَيَوۡمَ يُنَادِيهِمۡ فَيَقُولُ أَيۡنَ شُرَكَآءِيَ ٱلَّذِينَ كُنتُمۡ تَزۡعُمُونَ",
    translation: `And [warn of] the Day He will call them and say, "Where are my 'partners' which you used to claim`,
    normalizedText: "ويوم يناديهم فيقول اين شركاءي الذين كنتم تزعمون",
  },
  {
    verseId: 74,
    name: "القصص",
    surahId: 28,
    text: "وَنَزَعۡنَا مِن كُلِّ أُمَّةٖ شَهِيدٗا فَقُلۡنَا هَاتُواْ بُرۡهَٰنَكُمۡ فَعَلِمُوٓاْ أَنَّ ٱلۡحَقَّ لِلَّهِ وَضَلَّ عَنۡهُم مَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      'And We will extract from every nation a witness and say, "Produce your proof," and they will know that the truth belongs to Allah, and lost from them is that which they used to invent',
    normalizedText:
      "ونزعنا من كل امة شهيدا فقلنا هاتوا برهنكم فعلموا ان الحق لله وضل عنهم ما كانوا يفترون",
  },
  {
    verseId: 75,
    name: "القصص",
    surahId: 28,
    text: "۞إِنَّ قَٰرُونَ كَانَ مِن قَوۡمِ مُوسَىٰ فَبَغَىٰ عَلَيۡهِمۡۖ وَءَاتَيۡنَٰهُ مِنَ ٱلۡكُنُوزِ مَآ إِنَّ مَفَاتِحَهُۥ لَتَنُوٓأُ بِٱلۡعُصۡبَةِ أُوْلِي ٱلۡقُوَّةِ إِذۡ قَالَ لَهُۥ قَوۡمُهُۥ لَا تَفۡرَحۡۖ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلۡفَرِحِينَ",
    translation:
      'Indeed, Qarun was from the people of Moses, but he tyrannized them. And We gave him of treasures whose keys would burden a band of strong men; thereupon his people said to him, "Do not exult. Indeed, Allah does not like the exultant',
    normalizedText:
      "۞ان قرون كان من قوم موسى فبغى عليهم وءاتينه من الكنوز ما ان مفاتحه لتنوا بالعصبة اولي القوة اذ قال له قومه لا تفرح ان الله لا يحب الفرحين",
  },
  {
    verseId: 76,
    name: "القصص",
    surahId: 28,
    text: "وَٱبۡتَغِ فِيمَآ ءَاتَىٰكَ ٱللَّهُ ٱلدَّارَ ٱلۡأٓخِرَةَۖ وَلَا تَنسَ نَصِيبَكَ مِنَ ٱلدُّنۡيَاۖ وَأَحۡسِن كَمَآ أَحۡسَنَ ٱللَّهُ إِلَيۡكَۖ وَلَا تَبۡغِ ٱلۡفَسَادَ فِي ٱلۡأَرۡضِۖ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلۡمُفۡسِدِينَ",
    translation:
      "But seek, through that which Allah has given you, the home of the Hereafter; and [yet], do not forget your share of the world. And do good as Allah has done good to you. And desire not corruption in the land. Indeed, Allah does not like corrupters",
    normalizedText:
      "وابتغ فيما ءاتىك الله الدار الاخرة ولا تنس نصيبك من الدنيا واحسن كما احسن الله اليك ولا تبغ الفساد في الارض ان الله لا يحب المفسدين",
  },
  {
    verseId: 77,
    name: "القصص",
    surahId: 28,
    text: "قَالَ إِنَّمَآ أُوتِيتُهُۥ عَلَىٰ عِلۡمٍ عِندِيٓۚ أَوَلَمۡ يَعۡلَمۡ أَنَّ ٱللَّهَ قَدۡ أَهۡلَكَ مِن قَبۡلِهِۦ مِنَ ٱلۡقُرُونِ مَنۡ هُوَ أَشَدُّ مِنۡهُ قُوَّةٗ وَأَكۡثَرُ جَمۡعٗاۚ وَلَا يُسۡـَٔلُ عَن ذُنُوبِهِمُ ٱلۡمُجۡرِمُونَ",
    translation:
      'He said, "I was only given it because of knowledge I have." Did he not know that Allah had destroyed before him of generations those who were greater than him in power and greater in accumulation [of wealth]? But the criminals, about their sins, will not be asked',
    normalizedText:
      "قال انما اوتيته على علم عندي اولم يعلم ان الله قد اهلك من قبله من القرون من هو اشد منه قوة واكثر جمعا ولا يسل عن ذنوبهم المجرمون",
  },
  {
    verseId: 78,
    name: "القصص",
    surahId: 28,
    text: "فَخَرَجَ عَلَىٰ قَوۡمِهِۦ فِي زِينَتِهِۦۖ قَالَ ٱلَّذِينَ يُرِيدُونَ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا يَٰلَيۡتَ لَنَا مِثۡلَ مَآ أُوتِيَ قَٰرُونُ إِنَّهُۥ لَذُو حَظٍّ عَظِيمٖ",
    translation:
      'So he came out before his people in his adornment. Those who desired the worldly life said, "Oh, would that we had like what was given to Qarun. Indeed, he is one of great fortune',
    normalizedText:
      "فخرج على قومه في زينته قال الذين يريدون الحيوة الدنيا يليت لنا مثل ما اوتي قرون انه لذو حظ عظيم",
  },
  {
    verseId: 79,
    name: "القصص",
    surahId: 28,
    text: "وَقَالَ ٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ وَيۡلَكُمۡ ثَوَابُ ٱللَّهِ خَيۡرٞ لِّمَنۡ ءَامَنَ وَعَمِلَ صَٰلِحٗاۚ وَلَا يُلَقَّىٰهَآ إِلَّا ٱلصَّـٰبِرُونَ",
    translation:
      'But those who had been given knowledge said, "Woe to you! The reward of Allah is better for he who believes and does righteousness. And none are granted it except the patient',
    normalizedText:
      "وقال الذين اوتوا العلم ويلكم ثواب الله خير لمن ءامن وعمل صلحا ولا يلقىها الا الصبرون",
  },
  {
    verseId: 80,
    name: "القصص",
    surahId: 28,
    text: "فَخَسَفۡنَا بِهِۦ وَبِدَارِهِ ٱلۡأَرۡضَ فَمَا كَانَ لَهُۥ مِن فِئَةٖ يَنصُرُونَهُۥ مِن دُونِ ٱللَّهِ وَمَا كَانَ مِنَ ٱلۡمُنتَصِرِينَ",
    translation:
      "And We caused the earth to swallow him and his home. And there was for him no company to aid him other than Allah, nor was he of those who [could] defend themselves",
    normalizedText:
      "فخسفنا به وبداره الارض فما كان له من فاة ينصرونه من دون الله وما كان من المنتصرين",
  },
  {
    verseId: 81,
    name: "القصص",
    surahId: 28,
    text: "وَأَصۡبَحَ ٱلَّذِينَ تَمَنَّوۡاْ مَكَانَهُۥ بِٱلۡأَمۡسِ يَقُولُونَ وَيۡكَأَنَّ ٱللَّهَ يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ مِنۡ عِبَادِهِۦ وَيَقۡدِرُۖ لَوۡلَآ أَن مَّنَّ ٱللَّهُ عَلَيۡنَا لَخَسَفَ بِنَاۖ وَيۡكَأَنَّهُۥ لَا يُفۡلِحُ ٱلۡكَٰفِرُونَ",
    translation:
      'And those who had wished for his position the previous day began to say, "Oh, how Allah extends provision to whom He wills of His servants and restricts it! If not that Allah had conferred favor on us, He would have caused it to swallow us. Oh, how the disbelievers do not succeed',
    normalizedText:
      "واصبح الذين تمنوا مكانه بالامس يقولون ويكان الله يبسط الرزق لمن يشاء من عباده ويقدر لولا ان من الله علينا لخسف بنا ويكانه لا يفلح الكفرون",
  },
  {
    verseId: 82,
    name: "القصص",
    surahId: 28,
    text: "تِلۡكَ ٱلدَّارُ ٱلۡأٓخِرَةُ نَجۡعَلُهَا لِلَّذِينَ لَا يُرِيدُونَ عُلُوّٗا فِي ٱلۡأَرۡضِ وَلَا فَسَادٗاۚ وَٱلۡعَٰقِبَةُ لِلۡمُتَّقِينَ",
    translation:
      "That home of the Hereafter We assign to those who do not desire exaltedness upon the earth or corruption. And the [best] outcome is for the righteous",
    normalizedText:
      "تلك الدار الاخرة نجعلها للذين لا يريدون علوا في الارض ولا فسادا والعقبة للمتقين",
  },
  {
    verseId: 83,
    name: "القصص",
    surahId: 28,
    text: "مَن جَآءَ بِٱلۡحَسَنَةِ فَلَهُۥ خَيۡرٞ مِّنۡهَاۖ وَمَن جَآءَ بِٱلسَّيِّئَةِ فَلَا يُجۡزَى ٱلَّذِينَ عَمِلُواْ ٱلسَّيِّـَٔاتِ إِلَّا مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Whoever comes [on the Day of Judgement] with a good deed will have better than it; and whoever comes with an evil deed - then those who did evil deeds will not be recompensed except [as much as] what they used to do",
    normalizedText:
      "من جاء بالحسنة فله خير منها ومن جاء بالسياة فلا يجزى الذين عملوا السيات الا ما كانوا يعملون",
  },
  {
    verseId: 84,
    name: "القصص",
    surahId: 28,
    text: "إِنَّ ٱلَّذِي فَرَضَ عَلَيۡكَ ٱلۡقُرۡءَانَ لَرَآدُّكَ إِلَىٰ مَعَادٖۚ قُل رَّبِّيٓ أَعۡلَمُ مَن جَآءَ بِٱلۡهُدَىٰ وَمَنۡ هُوَ فِي ضَلَٰلٖ مُّبِينٖ",
    translation: `Indeed, [O Muhammad], He who imposed upon you the Qur'an will take you back to a place of return. Say, "My Lord is most knowing of who brings guidance and who is in clear error`,
    normalizedText:
      "ان الذي فرض عليك القرءان لرادك الى معاد قل ربي اعلم من جاء بالهدى ومن هو في ضلل مبين",
  },
  {
    verseId: 85,
    name: "القصص",
    surahId: 28,
    text: "وَمَا كُنتَ تَرۡجُوٓاْ أَن يُلۡقَىٰٓ إِلَيۡكَ ٱلۡكِتَٰبُ إِلَّا رَحۡمَةٗ مِّن رَّبِّكَۖ فَلَا تَكُونَنَّ ظَهِيرٗا لِّلۡكَٰفِرِينَ",
    translation:
      "And you were not expecting that the Book would be conveyed to you, but [it is] a mercy from your Lord. So do not be an assistant to the disbelievers",
    normalizedText:
      "وما كنت ترجوا ان يلقى اليك الكتب الا رحمة من ربك فلا تكونن ظهيرا للكفرين",
  },
  {
    verseId: 86,
    name: "القصص",
    surahId: 28,
    text: "وَلَا يَصُدُّنَّكَ عَنۡ ءَايَٰتِ ٱللَّهِ بَعۡدَ إِذۡ أُنزِلَتۡ إِلَيۡكَۖ وَٱدۡعُ إِلَىٰ رَبِّكَۖ وَلَا تَكُونَنَّ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "And never let them avert you from the verses of Allah after they have been revealed to you. And invite [people] to your Lord. And never be of those who associate others with Allah",
    normalizedText:
      "ولا يصدنك عن ءايت الله بعد اذ انزلت اليك وادع الى ربك ولا تكونن من المشركين",
  },
  {
    verseId: 87,
    name: "القصص",
    surahId: 28,
    text: "وَلَا تَدۡعُ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَۘ لَآ إِلَٰهَ إِلَّا هُوَۚ كُلُّ شَيۡءٍ هَالِكٌ إِلَّا وَجۡهَهُۥۚ لَهُ ٱلۡحُكۡمُ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "And do not invoke with Allah another deity. There is no deity except Him. Everything will be destroyed except His Face. His is the judgement, and to Him you will be returned",
    normalizedText:
      "ولا تدع مع الله الها ءاخر لا اله الا هو كل شيء هالك الا وجهه له الحكم واليه ترجعون",
  },
  {
    verseId: 0,
    name: "العنكبوت",
    surahId: 29,
    text: "الٓمٓ",
    translation: "Alif, Lam, Meem",
    normalizedText: "الم",
  },
  {
    verseId: 1,
    name: "العنكبوت",
    surahId: 29,
    text: "أَحَسِبَ ٱلنَّاسُ أَن يُتۡرَكُوٓاْ أَن يَقُولُوٓاْ ءَامَنَّا وَهُمۡ لَا يُفۡتَنُونَ",
    translation:
      'Do the people think that they will be left to say, "We believe" and they will not be tried',
    normalizedText: "احسب الناس ان يتركوا ان يقولوا ءامنا وهم لا يفتنون",
  },
  {
    verseId: 2,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَقَدۡ فَتَنَّا ٱلَّذِينَ مِن قَبۡلِهِمۡۖ فَلَيَعۡلَمَنَّ ٱللَّهُ ٱلَّذِينَ صَدَقُواْ وَلَيَعۡلَمَنَّ ٱلۡكَٰذِبِينَ",
    translation:
      "But We have certainly tried those before them, and Allah will surely make evident those who are truthful, and He will surely make evident the liars",
    normalizedText:
      "ولقد فتنا الذين من قبلهم فليعلمن الله الذين صدقوا وليعلمن الكذبين",
  },
  {
    verseId: 3,
    name: "العنكبوت",
    surahId: 29,
    text: "أَمۡ حَسِبَ ٱلَّذِينَ يَعۡمَلُونَ ٱلسَّيِّـَٔاتِ أَن يَسۡبِقُونَاۚ سَآءَ مَا يَحۡكُمُونَ",
    translation:
      "Or do those who do evil deeds think they can outrun Us? Evil is what they judge",
    normalizedText: "ام حسب الذين يعملون السيات ان يسبقونا ساء ما يحكمون",
  },
  {
    verseId: 4,
    name: "العنكبوت",
    surahId: 29,
    text: "مَن كَانَ يَرۡجُواْ لِقَآءَ ٱللَّهِ فَإِنَّ أَجَلَ ٱللَّهِ لَأٓتٖۚ وَهُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "Whoever should hope for the meeting with Allah - indeed, the term decreed by Allah is coming. And He is the Hearing, the Knowing",
    normalizedText: "من كان يرجوا لقاء الله فان اجل الله لات وهو السميع العليم",
  },
  {
    verseId: 5,
    name: "العنكبوت",
    surahId: 29,
    text: "وَمَن جَٰهَدَ فَإِنَّمَا يُجَٰهِدُ لِنَفۡسِهِۦٓۚ إِنَّ ٱللَّهَ لَغَنِيٌّ عَنِ ٱلۡعَٰلَمِينَ",
    translation:
      "And whoever strives only strives for [the benefit of] himself. Indeed, Allah is free from need of the worlds",
    normalizedText: "ومن جهد فانما يجهد لنفسه ان الله لغني عن العلمين",
  },
  {
    verseId: 6,
    name: "العنكبوت",
    surahId: 29,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَنُكَفِّرَنَّ عَنۡهُمۡ سَيِّـَٔاتِهِمۡ وَلَنَجۡزِيَنَّهُمۡ أَحۡسَنَ ٱلَّذِي كَانُواْ يَعۡمَلُونَ",
    translation:
      "And those who believe and do righteous deeds - We will surely remove from them their misdeeds and will surely reward them according to the best of what they used to do",
    normalizedText:
      "والذين ءامنوا وعملوا الصلحت لنكفرن عنهم سياتهم ولنجزينهم احسن الذي كانوا يعملون",
  },
  {
    verseId: 7,
    name: "العنكبوت",
    surahId: 29,
    text: "وَوَصَّيۡنَا ٱلۡإِنسَٰنَ بِوَٰلِدَيۡهِ حُسۡنٗاۖ وَإِن جَٰهَدَاكَ لِتُشۡرِكَ بِي مَا لَيۡسَ لَكَ بِهِۦ عِلۡمٞ فَلَا تُطِعۡهُمَآۚ إِلَيَّ مَرۡجِعُكُمۡ فَأُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "And We have enjoined upon man goodness to parents. But if they endeavor to make you associate with Me that of which you have no knowledge, do not obey them. To Me is your return, and I will inform you about what you used to do",
    normalizedText:
      "ووصينا الانسن بولديه حسنا وان جهداك لتشرك بي ما ليس لك به علم فلا تطعهما الي مرجعكم فانباكم بما كنتم تعملون",
  },
  {
    verseId: 8,
    name: "العنكبوت",
    surahId: 29,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَنُدۡخِلَنَّهُمۡ فِي ٱلصَّـٰلِحِينَ",
    translation:
      "And those who believe and do righteous deeds - We will surely admit them among the righteous [into Paradise]",
    normalizedText: "والذين ءامنوا وعملوا الصلحت لندخلنهم في الصلحين",
  },
  {
    verseId: 9,
    name: "العنكبوت",
    surahId: 29,
    text: "وَمِنَ ٱلنَّاسِ مَن يَقُولُ ءَامَنَّا بِٱللَّهِ فَإِذَآ أُوذِيَ فِي ٱللَّهِ جَعَلَ فِتۡنَةَ ٱلنَّاسِ كَعَذَابِ ٱللَّهِۖ وَلَئِن جَآءَ نَصۡرٞ مِّن رَّبِّكَ لَيَقُولُنَّ إِنَّا كُنَّا مَعَكُمۡۚ أَوَلَيۡسَ ٱللَّهُ بِأَعۡلَمَ بِمَا فِي صُدُورِ ٱلۡعَٰلَمِينَ",
    translation:
      'And of the people are some who say, "We believe in Allah," but when one [of them] is harmed for [the cause of] Allah, they consider the trial of the people as [if it were] the punishment of Allah. But if victory comes from your Lord, they say, "Indeed, We were with you." Is not Allah most knowing of what is within the breasts of all creatures',
    normalizedText:
      "ومن الناس من يقول ءامنا بالله فاذا اوذي في الله جعل فتنة الناس كعذاب الله ولان جاء نصر من ربك ليقولن انا كنا معكم اوليس الله باعلم بما في صدور العلمين",
  },
  {
    verseId: 10,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَيَعۡلَمَنَّ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ وَلَيَعۡلَمَنَّ ٱلۡمُنَٰفِقِينَ",
    translation:
      "And Allah will surely make evident those who believe, and He will surely make evident the hypocrites",
    normalizedText: "وليعلمن الله الذين ءامنوا وليعلمن المنفقين",
  },
  {
    verseId: 11,
    name: "العنكبوت",
    surahId: 29,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ لِلَّذِينَ ءَامَنُواْ ٱتَّبِعُواْ سَبِيلَنَا وَلۡنَحۡمِلۡ خَطَٰيَٰكُمۡ وَمَا هُم بِحَٰمِلِينَ مِنۡ خَطَٰيَٰهُم مِّن شَيۡءٍۖ إِنَّهُمۡ لَكَٰذِبُونَ",
    translation:
      'And those who disbelieve say to those who believe, "Follow our way, and we will carry your sins." But they will not carry anything of their sins. Indeed, they are liars',
    normalizedText:
      "وقال الذين كفروا للذين ءامنوا اتبعوا سبيلنا ولنحمل خطيكم وما هم بحملين من خطيهم من شيء انهم لكذبون",
  },
  {
    verseId: 12,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَيَحۡمِلُنَّ أَثۡقَالَهُمۡ وَأَثۡقَالٗا مَّعَ أَثۡقَالِهِمۡۖ وَلَيُسۡـَٔلُنَّ يَوۡمَ ٱلۡقِيَٰمَةِ عَمَّا كَانُواْ يَفۡتَرُونَ",
    translation:
      "But they will surely carry their [own] burdens and [other] burdens along with their burdens, and they will surely be questioned on the Day of Resurrection about what they used to invent",
    normalizedText:
      "وليحملن اثقالهم واثقالا مع اثقالهم وليسلن يوم القيمة عما كانوا يفترون",
  },
  {
    verseId: 13,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَقَدۡ أَرۡسَلۡنَا نُوحًا إِلَىٰ قَوۡمِهِۦ فَلَبِثَ فِيهِمۡ أَلۡفَ سَنَةٍ إِلَّا خَمۡسِينَ عَامٗا فَأَخَذَهُمُ ٱلطُّوفَانُ وَهُمۡ ظَٰلِمُونَ",
    translation:
      "And We certainly sent Noah to his people, and he remained among them a thousand years minus fifty years, and the flood seized them while they were wrongdoers",
    normalizedText:
      "ولقد ارسلنا نوحا الى قومه فلبث فيهم الف سنة الا خمسين عاما فاخذهم الطوفان وهم ظلمون",
  },
  {
    verseId: 14,
    name: "العنكبوت",
    surahId: 29,
    text: "فَأَنجَيۡنَٰهُ وَأَصۡحَٰبَ ٱلسَّفِينَةِ وَجَعَلۡنَٰهَآ ءَايَةٗ لِّلۡعَٰلَمِينَ",
    translation:
      "But We saved him and the companions of the ship, and We made it a sign for the worlds",
    normalizedText: "فانجينه واصحب السفينة وجعلنها ءاية للعلمين",
  },
  {
    verseId: 15,
    name: "العنكبوت",
    surahId: 29,
    text: "وَإِبۡرَٰهِيمَ إِذۡ قَالَ لِقَوۡمِهِ ٱعۡبُدُواْ ٱللَّهَ وَٱتَّقُوهُۖ ذَٰلِكُمۡ خَيۡرٞ لَّكُمۡ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      'And [We sent] Abraham, when he said to his people, "Worship Allah and fear Him. That is best for you, if you should know',
    normalizedText:
      "وابرهيم اذ قال لقومه اعبدوا الله واتقوه ذلكم خير لكم ان كنتم تعلمون",
  },
  {
    verseId: 16,
    name: "العنكبوت",
    surahId: 29,
    text: "إِنَّمَا تَعۡبُدُونَ مِن دُونِ ٱللَّهِ أَوۡثَٰنٗا وَتَخۡلُقُونَ إِفۡكًاۚ إِنَّ ٱلَّذِينَ تَعۡبُدُونَ مِن دُونِ ٱللَّهِ لَا يَمۡلِكُونَ لَكُمۡ رِزۡقٗا فَٱبۡتَغُواْ عِندَ ٱللَّهِ ٱلرِّزۡقَ وَٱعۡبُدُوهُ وَٱشۡكُرُواْ لَهُۥٓۖ إِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "You only worship, besides Allah, idols, and you produce a falsehood. Indeed, those you worship besides Allah do not possess for you [the power of] provision. So seek from Allah provision and worship Him and be grateful to Him. To Him you will be returned",
    normalizedText:
      "انما تعبدون من دون الله اوثنا وتخلقون افكا ان الذين تعبدون من دون الله لا يملكون لكم رزقا فابتغوا عند الله الرزق واعبدوه واشكروا له اليه ترجعون",
  },
  {
    verseId: 17,
    name: "العنكبوت",
    surahId: 29,
    text: "وَإِن تُكَذِّبُواْ فَقَدۡ كَذَّبَ أُمَمٞ مِّن قَبۡلِكُمۡۖ وَمَا عَلَى ٱلرَّسُولِ إِلَّا ٱلۡبَلَٰغُ ٱلۡمُبِينُ",
    translation:
      "And if you [people] deny [the message] - already nations before you have denied. And there is not upon the Messenger except [the duty of] clear notification",
    normalizedText:
      "وان تكذبوا فقد كذب امم من قبلكم وما على الرسول الا البلغ المبين",
  },
  {
    verseId: 18,
    name: "العنكبوت",
    surahId: 29,
    text: "أَوَلَمۡ يَرَوۡاْ كَيۡفَ يُبۡدِئُ ٱللَّهُ ٱلۡخَلۡقَ ثُمَّ يُعِيدُهُۥٓۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٞ",
    translation:
      "Have they not considered how Allah begins creation and then repeats it? Indeed that, for Allah, is easy",
    normalizedText:
      "اولم يروا كيف يبدا الله الخلق ثم يعيده ان ذلك على الله يسير",
  },
  {
    verseId: 19,
    name: "العنكبوت",
    surahId: 29,
    text: "قُلۡ سِيرُواْ فِي ٱلۡأَرۡضِ فَٱنظُرُواْ كَيۡفَ بَدَأَ ٱلۡخَلۡقَۚ ثُمَّ ٱللَّهُ يُنشِئُ ٱلنَّشۡأَةَ ٱلۡأٓخِرَةَۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'Say, [O Muhammad], "Travel through the land and observe how He began creation. Then Allah will produce the final creation. Indeed Allah, over all things, is competent',
    normalizedText:
      "قل سيروا في الارض فانظروا كيف بدا الخلق ثم الله ينشا النشاة الاخرة ان الله على كل شيء قدير",
  },
  {
    verseId: 20,
    name: "العنكبوت",
    surahId: 29,
    text: "يُعَذِّبُ مَن يَشَآءُ وَيَرۡحَمُ مَن يَشَآءُۖ وَإِلَيۡهِ تُقۡلَبُونَ",
    translation:
      "He punishes whom He wills and has mercy upon whom He wills, and to Him you will be returned",
    normalizedText: "يعذب من يشاء ويرحم من يشاء واليه تقلبون",
  },
  {
    verseId: 21,
    name: "العنكبوت",
    surahId: 29,
    text: "وَمَآ أَنتُم بِمُعۡجِزِينَ فِي ٱلۡأَرۡضِ وَلَا فِي ٱلسَّمَآءِۖ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِيّٖ وَلَا نَصِيرٖ",
    translation:
      "And you will not cause failure [to Allah] upon the earth or in the heaven. And you have not other than Allah any protector or any helper",
    normalizedText:
      "وما انتم بمعجزين في الارض ولا في السماء وما لكم من دون الله من ولي ولا نصير",
  },
  {
    verseId: 22,
    name: "العنكبوت",
    surahId: 29,
    text: "وَٱلَّذِينَ كَفَرُواْ بِـَٔايَٰتِ ٱللَّهِ وَلِقَآئِهِۦٓ أُوْلَـٰٓئِكَ يَئِسُواْ مِن رَّحۡمَتِي وَأُوْلَـٰٓئِكَ لَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "And the ones who disbelieve in the signs of Allah and the meeting with Him - those have despaired of My mercy, and they will have a painful punishment",
    normalizedText:
      "والذين كفروا بايت الله ولقااه اولاك ياسوا من رحمتي واولاك لهم عذاب اليم",
  },
  {
    verseId: 23,
    name: "العنكبوت",
    surahId: 29,
    text: "فَمَا كَانَ جَوَابَ قَوۡمِهِۦٓ إِلَّآ أَن قَالُواْ ٱقۡتُلُوهُ أَوۡ حَرِّقُوهُ فَأَنجَىٰهُ ٱللَّهُ مِنَ ٱلنَّارِۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation: `And the answer of Abraham's people was not but that they said, "Kill him or burn him," but Allah saved him from the fire. Indeed in that are signs for a people who believe`,
    normalizedText:
      "فما كان جواب قومه الا ان قالوا اقتلوه او حرقوه فانجىه الله من النار ان في ذلك لايت لقوم يامنون",
  },
  {
    verseId: 24,
    name: "العنكبوت",
    surahId: 29,
    text: "وَقَالَ إِنَّمَا ٱتَّخَذۡتُم مِّن دُونِ ٱللَّهِ أَوۡثَٰنٗا مَّوَدَّةَ بَيۡنِكُمۡ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ ثُمَّ يَوۡمَ ٱلۡقِيَٰمَةِ يَكۡفُرُ بَعۡضُكُم بِبَعۡضٖ وَيَلۡعَنُ بَعۡضُكُم بَعۡضٗا وَمَأۡوَىٰكُمُ ٱلنَّارُ وَمَا لَكُم مِّن نَّـٰصِرِينَ",
    translation:
      'And [Abraham] said, "You have only taken, other than Allah, idols as [a bond of] affection among you in worldly life. Then on the Day of Resurrection you will deny one another and curse one another, and your refuge will be the Fire, and you will not have any helpers',
    normalizedText:
      "وقال انما اتخذتم من دون الله اوثنا مودة بينكم في الحيوة الدنيا ثم يوم القيمة يكفر بعضكم ببعض ويلعن بعضكم بعضا وماوىكم النار وما لكم من نصرين",
  },
  {
    verseId: 25,
    name: "العنكبوت",
    surahId: 29,
    text: "۞فَـَٔامَنَ لَهُۥ لُوطٞۘ وَقَالَ إِنِّي مُهَاجِرٌ إِلَىٰ رَبِّيٓۖ إِنَّهُۥ هُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      'And Lot believed him. [Abraham] said, "Indeed, I will emigrate to [the service of] my Lord. Indeed, He is the Exalted in Might, the Wise',
    normalizedText: "۞فامن له لوط وقال اني مهاجر الى ربي انه هو العزيز الحكيم",
  },
  {
    verseId: 26,
    name: "العنكبوت",
    surahId: 29,
    text: "وَوَهَبۡنَا لَهُۥٓ إِسۡحَٰقَ وَيَعۡقُوبَ وَجَعَلۡنَا فِي ذُرِّيَّتِهِ ٱلنُّبُوَّةَ وَٱلۡكِتَٰبَ وَءَاتَيۡنَٰهُ أَجۡرَهُۥ فِي ٱلدُّنۡيَاۖ وَإِنَّهُۥ فِي ٱلۡأٓخِرَةِ لَمِنَ ٱلصَّـٰلِحِينَ",
    translation:
      "And We gave to Him Isaac and Jacob and placed in his descendants prophethood and scripture. And We gave him his reward in this world, and indeed, he is in the Hereafter among the righteous",
    normalizedText:
      "ووهبنا له اسحق ويعقوب وجعلنا في ذريته النبوة والكتب وءاتينه اجره في الدنيا وانه في الاخرة لمن الصلحين",
  },
  {
    verseId: 27,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلُوطًا إِذۡ قَالَ لِقَوۡمِهِۦٓ إِنَّكُمۡ لَتَأۡتُونَ ٱلۡفَٰحِشَةَ مَا سَبَقَكُم بِهَا مِنۡ أَحَدٖ مِّنَ ٱلۡعَٰلَمِينَ",
    translation:
      'And [mention] Lot, when he said to his people, "Indeed, you commit such immorality as no one has preceded you with from among the worlds',
    normalizedText:
      "ولوطا اذ قال لقومه انكم لتاتون الفحشة ما سبقكم بها من احد من العلمين",
  },
  {
    verseId: 28,
    name: "العنكبوت",
    surahId: 29,
    text: "أَئِنَّكُمۡ لَتَأۡتُونَ ٱلرِّجَالَ وَتَقۡطَعُونَ ٱلسَّبِيلَ وَتَأۡتُونَ فِي نَادِيكُمُ ٱلۡمُنكَرَۖ فَمَا كَانَ جَوَابَ قَوۡمِهِۦٓ إِلَّآ أَن قَالُواْ ٱئۡتِنَا بِعَذَابِ ٱللَّهِ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      'Indeed, you approach men and obstruct the road and commit in your meetings [every] evil." And the answer of his people was not but they said, "Bring us the punishment of Allah, if you should be of the truthful',
    normalizedText:
      "اانكم لتاتون الرجال وتقطعون السبيل وتاتون في ناديكم المنكر فما كان جواب قومه الا ان قالوا ااتنا بعذاب الله ان كنت من الصدقين",
  },
  {
    verseId: 29,
    name: "العنكبوت",
    surahId: 29,
    text: "قَالَ رَبِّ ٱنصُرۡنِي عَلَى ٱلۡقَوۡمِ ٱلۡمُفۡسِدِينَ",
    translation: 'He said, "My Lord, support me against the corrupting people',
    normalizedText: "قال رب انصرني على القوم المفسدين",
  },
  {
    verseId: 30,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَمَّا جَآءَتۡ رُسُلُنَآ إِبۡرَٰهِيمَ بِٱلۡبُشۡرَىٰ قَالُوٓاْ إِنَّا مُهۡلِكُوٓاْ أَهۡلِ هَٰذِهِ ٱلۡقَرۡيَةِۖ إِنَّ أَهۡلَهَا كَانُواْ ظَٰلِمِينَ",
    translation: `And when Our messengers came to Abraham with the good tidings, they said, "Indeed, we will destroy the people of that Lot's city. Indeed, its people have been wrongdoers`,
    normalizedText:
      "ولما جاءت رسلنا ابرهيم بالبشرى قالوا انا مهلكوا اهل هذه القرية ان اهلها كانوا ظلمين",
  },
  {
    verseId: 31,
    name: "العنكبوت",
    surahId: 29,
    text: "قَالَ إِنَّ فِيهَا لُوطٗاۚ قَالُواْ نَحۡنُ أَعۡلَمُ بِمَن فِيهَاۖ لَنُنَجِّيَنَّهُۥ وَأَهۡلَهُۥٓ إِلَّا ٱمۡرَأَتَهُۥ كَانَتۡ مِنَ ٱلۡغَٰبِرِينَ",
    translation:
      '[Abraham] said, "Indeed, within it is Lot." They said, "We are more knowing of who is within it. We will surely save him and his family, except his wife. She is to be of those who remain behind',
    normalizedText:
      "قال ان فيها لوطا قالوا نحن اعلم بمن فيها لننجينه واهله الا امراته كانت من الغبرين",
  },
  {
    verseId: 32,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَمَّآ أَن جَآءَتۡ رُسُلُنَا لُوطٗا سِيٓءَ بِهِمۡ وَضَاقَ بِهِمۡ ذَرۡعٗاۖ وَقَالُواْ لَا تَخَفۡ وَلَا تَحۡزَنۡ إِنَّا مُنَجُّوكَ وَأَهۡلَكَ إِلَّا ٱمۡرَأَتَكَ كَانَتۡ مِنَ ٱلۡغَٰبِرِينَ",
    translation:
      'And when Our messengers came to Lot, he was distressed for them and felt for them great discomfort. They said, "Fear not, nor grieve. Indeed, we will save you and your family, except your wife; she is to be of those who remain behind',
    normalizedText:
      "ولما ان جاءت رسلنا لوطا سيء بهم وضاق بهم ذرعا وقالوا لا تخف ولا تحزن انا منجوك واهلك الا امراتك كانت من الغبرين",
  },
  {
    verseId: 33,
    name: "العنكبوت",
    surahId: 29,
    text: "إِنَّا مُنزِلُونَ عَلَىٰٓ أَهۡلِ هَٰذِهِ ٱلۡقَرۡيَةِ رِجۡزٗا مِّنَ ٱلسَّمَآءِ بِمَا كَانُواْ يَفۡسُقُونَ",
    translation:
      "Indeed, we will bring down on the people of this city punishment from the sky because they have been defiantly disobedient",
    normalizedText:
      "انا منزلون على اهل هذه القرية رجزا من السماء بما كانوا يفسقون",
  },
  {
    verseId: 34,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَقَد تَّرَكۡنَا مِنۡهَآ ءَايَةَۢ بَيِّنَةٗ لِّقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "And We have certainly left of it a sign as clear evidence for a people who use reason",
    normalizedText: "ولقد تركنا منها ءاية بينة لقوم يعقلون",
  },
  {
    verseId: 35,
    name: "العنكبوت",
    surahId: 29,
    text: "وَإِلَىٰ مَدۡيَنَ أَخَاهُمۡ شُعَيۡبٗا فَقَالَ يَٰقَوۡمِ ٱعۡبُدُواْ ٱللَّهَ وَٱرۡجُواْ ٱلۡيَوۡمَ ٱلۡأٓخِرَ وَلَا تَعۡثَوۡاْ فِي ٱلۡأَرۡضِ مُفۡسِدِينَ",
    translation: `And to Madyan [We sent] their brother Shu'ayb, and he said, "O my people, worship Allah and expect the Last Day and do not commit abuse on the earth, spreading corruption`,
    normalizedText:
      "والى مدين اخاهم شعيبا فقال يقوم اعبدوا الله وارجوا اليوم الاخر ولا تعثوا في الارض مفسدين",
  },
  {
    verseId: 36,
    name: "العنكبوت",
    surahId: 29,
    text: "فَكَذَّبُوهُ فَأَخَذَتۡهُمُ ٱلرَّجۡفَةُ فَأَصۡبَحُواْ فِي دَارِهِمۡ جَٰثِمِينَ",
    translation:
      "But they denied him, so the earthquake seized them, and they became within their home [corpses] fallen prone",
    normalizedText: "فكذبوه فاخذتهم الرجفة فاصبحوا في دارهم جثمين",
  },
  {
    verseId: 37,
    name: "العنكبوت",
    surahId: 29,
    text: "وَعَادٗا وَثَمُودَاْ وَقَد تَّبَيَّنَ لَكُم مِّن مَّسَٰكِنِهِمۡۖ وَزَيَّنَ لَهُمُ ٱلشَّيۡطَٰنُ أَعۡمَٰلَهُمۡ فَصَدَّهُمۡ عَنِ ٱلسَّبِيلِ وَكَانُواْ مُسۡتَبۡصِرِينَ",
    translation:
      "And [We destroyed] 'Aad and Thamud, and it has become clear to you from their [ruined] dwellings. And Satan had made pleasing to them their deeds and averted them from the path, and they were endowed with perception",
    normalizedText:
      "وعادا وثمودا وقد تبين لكم من مسكنهم وزين لهم الشيطن اعملهم فصدهم عن السبيل وكانوا مستبصرين",
  },
  {
    verseId: 38,
    name: "العنكبوت",
    surahId: 29,
    text: "وَقَٰرُونَ وَفِرۡعَوۡنَ وَهَٰمَٰنَۖ وَلَقَدۡ جَآءَهُم مُّوسَىٰ بِٱلۡبَيِّنَٰتِ فَٱسۡتَكۡبَرُواْ فِي ٱلۡأَرۡضِ وَمَا كَانُواْ سَٰبِقِينَ",
    translation:
      "And [We destroyed] Qarun and Pharaoh and Haman. And Moses had already come to them with clear evidences, and they were arrogant in the land, but they were not outrunners [of Our punishment]",
    normalizedText:
      "وقرون وفرعون وهمن ولقد جاءهم موسى بالبينت فاستكبروا في الارض وما كانوا سبقين",
  },
  {
    verseId: 39,
    name: "العنكبوت",
    surahId: 29,
    text: "فَكُلًّا أَخَذۡنَا بِذَنۢبِهِۦۖ فَمِنۡهُم مَّنۡ أَرۡسَلۡنَا عَلَيۡهِ حَاصِبٗا وَمِنۡهُم مَّنۡ أَخَذَتۡهُ ٱلصَّيۡحَةُ وَمِنۡهُم مَّنۡ خَسَفۡنَا بِهِ ٱلۡأَرۡضَ وَمِنۡهُم مَّنۡ أَغۡرَقۡنَاۚ وَمَا كَانَ ٱللَّهُ لِيَظۡلِمَهُمۡ وَلَٰكِن كَانُوٓاْ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      "So each We seized for his sin; and among them were those upon whom We sent a storm of stones, and among them were those who were seized by the blast [from the sky], and among them were those whom We caused the earth to swallow, and among them were those whom We drowned. And Allah would not have wronged them, but it was they who were wronging themselves",
    normalizedText:
      "فكلا اخذنا بذنبه فمنهم من ارسلنا عليه حاصبا ومنهم من اخذته الصيحة ومنهم من خسفنا به الارض ومنهم من اغرقنا وما كان الله ليظلمهم ولكن كانوا انفسهم يظلمون",
  },
  {
    verseId: 40,
    name: "العنكبوت",
    surahId: 29,
    text: "مَثَلُ ٱلَّذِينَ ٱتَّخَذُواْ مِن دُونِ ٱللَّهِ أَوۡلِيَآءَ كَمَثَلِ ٱلۡعَنكَبُوتِ ٱتَّخَذَتۡ بَيۡتٗاۖ وَإِنَّ أَوۡهَنَ ٱلۡبُيُوتِ لَبَيۡتُ ٱلۡعَنكَبُوتِۚ لَوۡ كَانُواْ يَعۡلَمُونَ",
    translation:
      "The example of those who take allies other than Allah is like that of the spider who takes a home. And indeed, the weakest of homes is the home of the spider, if they only knew",
    normalizedText:
      "مثل الذين اتخذوا من دون الله اولياء كمثل العنكبوت اتخذت بيتا وان اوهن البيوت لبيت العنكبوت لو كانوا يعلمون",
  },
  {
    verseId: 41,
    name: "العنكبوت",
    surahId: 29,
    text: "إِنَّ ٱللَّهَ يَعۡلَمُ مَا يَدۡعُونَ مِن دُونِهِۦ مِن شَيۡءٖۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Indeed, Allah knows whatever thing they call upon other than Him. And He is the Exalted in Might, the Wise",
    normalizedText: "ان الله يعلم ما يدعون من دونه من شيء وهو العزيز الحكيم",
  },
  {
    verseId: 42,
    name: "العنكبوت",
    surahId: 29,
    text: "وَتِلۡكَ ٱلۡأَمۡثَٰلُ نَضۡرِبُهَا لِلنَّاسِۖ وَمَا يَعۡقِلُهَآ إِلَّا ٱلۡعَٰلِمُونَ",
    translation:
      "And these examples We present to the people, but none will understand them except those of knowledge",
    normalizedText: "وتلك الامثل نضربها للناس وما يعقلها الا العلمون",
  },
  {
    verseId: 43,
    name: "العنكبوت",
    surahId: 29,
    text: "خَلَقَ ٱللَّهُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِٱلۡحَقِّۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّلۡمُؤۡمِنِينَ",
    translation:
      "Allah created the heavens and the earth in truth. Indeed in that is a sign for the believers",
    normalizedText: "خلق الله السموت والارض بالحق ان في ذلك لاية للمامنين",
  },
  {
    verseId: 44,
    name: "العنكبوت",
    surahId: 29,
    text: "ٱتۡلُ مَآ أُوحِيَ إِلَيۡكَ مِنَ ٱلۡكِتَٰبِ وَأَقِمِ ٱلصَّلَوٰةَۖ إِنَّ ٱلصَّلَوٰةَ تَنۡهَىٰ عَنِ ٱلۡفَحۡشَآءِ وَٱلۡمُنكَرِۗ وَلَذِكۡرُ ٱللَّهِ أَكۡبَرُۗ وَٱللَّهُ يَعۡلَمُ مَا تَصۡنَعُونَ",
    translation:
      "Recite, [O Muhammad], what has been revealed to you of the Book and establish prayer. Indeed, prayer prohibits immorality and wrongdoing, and the remembrance of Allah is greater. And Allah knows that which you do",
    normalizedText:
      "اتل ما اوحي اليك من الكتب واقم الصلوة ان الصلوة تنهى عن الفحشاء والمنكر ولذكر الله اكبر والله يعلم ما تصنعون",
  },
  {
    verseId: 45,
    name: "العنكبوت",
    surahId: 29,
    text: "۞وَلَا تُجَٰدِلُوٓاْ أَهۡلَ ٱلۡكِتَٰبِ إِلَّا بِٱلَّتِي هِيَ أَحۡسَنُ إِلَّا ٱلَّذِينَ ظَلَمُواْ مِنۡهُمۡۖ وَقُولُوٓاْ ءَامَنَّا بِٱلَّذِيٓ أُنزِلَ إِلَيۡنَا وَأُنزِلَ إِلَيۡكُمۡ وَإِلَٰهُنَا وَإِلَٰهُكُمۡ وَٰحِدٞ وَنَحۡنُ لَهُۥ مُسۡلِمُونَ",
    translation:
      'And do not argue with the People of the Scripture except in a way that is best, except for those who commit injustice among them, and say, "We believe in that which has been revealed to us and revealed to you. And our God and your God is one; and we are Muslims [in submission] to Him',
    normalizedText:
      "۞ولا تجدلوا اهل الكتب الا بالتي هي احسن الا الذين ظلموا منهم وقولوا ءامنا بالذي انزل الينا وانزل اليكم والهنا والهكم وحد ونحن له مسلمون",
  },
  {
    verseId: 46,
    name: "العنكبوت",
    surahId: 29,
    text: "وَكَذَٰلِكَ أَنزَلۡنَآ إِلَيۡكَ ٱلۡكِتَٰبَۚ فَٱلَّذِينَ ءَاتَيۡنَٰهُمُ ٱلۡكِتَٰبَ يُؤۡمِنُونَ بِهِۦۖ وَمِنۡ هَـٰٓؤُلَآءِ مَن يُؤۡمِنُ بِهِۦۚ وَمَا يَجۡحَدُ بِـَٔايَٰتِنَآ إِلَّا ٱلۡكَٰفِرُونَ",
    translation:
      "And thus We have sent down to you the Qur'an. And those to whom We [previously] gave the Scripture believe in it. And among these [people of Makkah] are those who believe in it. And none reject Our verses except the disbelievers",
    normalizedText:
      "وكذلك انزلنا اليك الكتب فالذين ءاتينهم الكتب يامنون به ومن هالاء من يامن به وما يجحد بايتنا الا الكفرون",
  },
  {
    verseId: 47,
    name: "العنكبوت",
    surahId: 29,
    text: "وَمَا كُنتَ تَتۡلُواْ مِن قَبۡلِهِۦ مِن كِتَٰبٖ وَلَا تَخُطُّهُۥ بِيَمِينِكَۖ إِذٗا لَّٱرۡتَابَ ٱلۡمُبۡطِلُونَ",
    translation:
      "And you did not recite before it any scripture, nor did you inscribe one with your right hand. Otherwise the falsifiers would have had [cause for] doubt",
    normalizedText:
      "وما كنت تتلوا من قبله من كتب ولا تخطه بيمينك اذا لارتاب المبطلون",
  },
  {
    verseId: 48,
    name: "العنكبوت",
    surahId: 29,
    text: "بَلۡ هُوَ ءَايَٰتُۢ بَيِّنَٰتٞ فِي صُدُورِ ٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَۚ وَمَا يَجۡحَدُ بِـَٔايَٰتِنَآ إِلَّا ٱلظَّـٰلِمُونَ",
    translation:
      "Rather, the Qur'an is distinct verses [preserved] within the breasts of those who have been given knowledge. And none reject Our verses except the wrongdoers",
    normalizedText:
      "بل هو ءايت بينت في صدور الذين اوتوا العلم وما يجحد بايتنا الا الظلمون",
  },
  {
    verseId: 49,
    name: "العنكبوت",
    surahId: 29,
    text: "وَقَالُواْ لَوۡلَآ أُنزِلَ عَلَيۡهِ ءَايَٰتٞ مِّن رَّبِّهِۦۚ قُلۡ إِنَّمَا ٱلۡأٓيَٰتُ عِندَ ٱللَّهِ وَإِنَّمَآ أَنَا۠ نَذِيرٞ مُّبِينٌ",
    translation:
      'But they say, "Why are not signs sent down to him from his Lord?" Say, "The signs are only with Allah, and I am only a clear warner',
    normalizedText:
      "وقالوا لولا انزل عليه ءايت من ربه قل انما الايت عند الله وانما انا نذير مبين",
  },
  {
    verseId: 50,
    name: "العنكبوت",
    surahId: 29,
    text: "أَوَلَمۡ يَكۡفِهِمۡ أَنَّآ أَنزَلۡنَا عَلَيۡكَ ٱلۡكِتَٰبَ يُتۡلَىٰ عَلَيۡهِمۡۚ إِنَّ فِي ذَٰلِكَ لَرَحۡمَةٗ وَذِكۡرَىٰ لِقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "And is it not sufficient for them that We revealed to you the Book which is recited to them? Indeed in that is a mercy and reminder for a people who believe",
    normalizedText:
      "اولم يكفهم انا انزلنا عليك الكتب يتلى عليهم ان في ذلك لرحمة وذكرى لقوم يامنون",
  },
  {
    verseId: 51,
    name: "العنكبوت",
    surahId: 29,
    text: "قُلۡ كَفَىٰ بِٱللَّهِ بَيۡنِي وَبَيۡنَكُمۡ شَهِيدٗاۖ يَعۡلَمُ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۗ وَٱلَّذِينَ ءَامَنُواْ بِٱلۡبَٰطِلِ وَكَفَرُواْ بِٱللَّهِ أُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      'Say, "Sufficient is Allah between me and you as Witness. He knows what is in the heavens and earth. And they who have believed in falsehood and disbelieved in Allah - it is those who are the losers',
    normalizedText:
      "قل كفى بالله بيني وبينكم شهيدا يعلم ما في السموت والارض والذين ءامنوا بالبطل وكفروا بالله اولاك هم الخسرون",
  },
  {
    verseId: 52,
    name: "العنكبوت",
    surahId: 29,
    text: "وَيَسۡتَعۡجِلُونَكَ بِٱلۡعَذَابِ وَلَوۡلَآ أَجَلٞ مُّسَمّٗى لَّجَآءَهُمُ ٱلۡعَذَابُۚ وَلَيَأۡتِيَنَّهُم بَغۡتَةٗ وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      "And they urge you to hasten the punishment. And if not for [the decree of] a specified term, punishment would have reached them. But it will surely come to them suddenly while they perceive not",
    normalizedText:
      "ويستعجلونك بالعذاب ولولا اجل مسمى لجاءهم العذاب ولياتينهم بغتة وهم لا يشعرون",
  },
  {
    verseId: 53,
    name: "العنكبوت",
    surahId: 29,
    text: "يَسۡتَعۡجِلُونَكَ بِٱلۡعَذَابِ وَإِنَّ جَهَنَّمَ لَمُحِيطَةُۢ بِٱلۡكَٰفِرِينَ",
    translation:
      "They urge you to hasten the punishment. And indeed, Hell will be encompassing of the disbelievers",
    normalizedText: "يستعجلونك بالعذاب وان جهنم لمحيطة بالكفرين",
  },
  {
    verseId: 54,
    name: "العنكبوت",
    surahId: 29,
    text: "يَوۡمَ يَغۡشَىٰهُمُ ٱلۡعَذَابُ مِن فَوۡقِهِمۡ وَمِن تَحۡتِ أَرۡجُلِهِمۡ وَيَقُولُ ذُوقُواْ مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'On the Day the punishment will cover them from above them and from below their feet and it is said, "Taste [the result of] what you used to do',
    normalizedText:
      "يوم يغشىهم العذاب من فوقهم ومن تحت ارجلهم ويقول ذوقوا ما كنتم تعملون",
  },
  {
    verseId: 55,
    name: "العنكبوت",
    surahId: 29,
    text: "يَٰعِبَادِيَ ٱلَّذِينَ ءَامَنُوٓاْ إِنَّ أَرۡضِي وَٰسِعَةٞ فَإِيَّـٰيَ فَٱعۡبُدُونِ",
    translation:
      "O My servants who have believed, indeed My earth is spacious, so worship only Me",
    normalizedText: "يعبادي الذين ءامنوا ان ارضي وسعة فايي فاعبدون",
  },
  {
    verseId: 56,
    name: "العنكبوت",
    surahId: 29,
    text: "كُلُّ نَفۡسٖ ذَآئِقَةُ ٱلۡمَوۡتِۖ ثُمَّ إِلَيۡنَا تُرۡجَعُونَ",
    translation: "Every soul will taste death. Then to Us will you be returned",
    normalizedText: "كل نفس ذااقة الموت ثم الينا ترجعون",
  },
  {
    verseId: 57,
    name: "العنكبوت",
    surahId: 29,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَنُبَوِّئَنَّهُم مِّنَ ٱلۡجَنَّةِ غُرَفٗا تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ نِعۡمَ أَجۡرُ ٱلۡعَٰمِلِينَ",
    translation:
      "And those who have believed and done righteous deeds - We will surely assign to them of Paradise [elevated] chambers beneath which rivers flow, wherein they abide eternally. Excellent is the reward of the [righteous] workers",
    normalizedText:
      "والذين ءامنوا وعملوا الصلحت لنبوانهم من الجنة غرفا تجري من تحتها الانهر خلدين فيها نعم اجر العملين",
  },
  {
    verseId: 58,
    name: "العنكبوت",
    surahId: 29,
    text: "ٱلَّذِينَ صَبَرُواْ وَعَلَىٰ رَبِّهِمۡ يَتَوَكَّلُونَ",
    translation: "Who have been patient and upon their Lord rely",
    normalizedText: "الذين صبروا وعلى ربهم يتوكلون",
  },
  {
    verseId: 59,
    name: "العنكبوت",
    surahId: 29,
    text: "وَكَأَيِّن مِّن دَآبَّةٖ لَّا تَحۡمِلُ رِزۡقَهَا ٱللَّهُ يَرۡزُقُهَا وَإِيَّاكُمۡۚ وَهُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "And how many a creature carries not its [own] provision. Allah provides for it and for you. And He is the Hearing, the Knowing",
    normalizedText:
      "وكاين من دابة لا تحمل رزقها الله يرزقها واياكم وهو السميع العليم",
  },
  {
    verseId: 60,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَئِن سَأَلۡتَهُم مَّنۡ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَسَخَّرَ ٱلشَّمۡسَ وَٱلۡقَمَرَ لَيَقُولُنَّ ٱللَّهُۖ فَأَنَّىٰ يُؤۡفَكُونَ",
    translation:
      'If you asked them, "Who created the heavens and earth and subjected the sun and the moon?" they would surely say, "Allah." Then how are they deluded',
    normalizedText:
      "ولان سالتهم من خلق السموت والارض وسخر الشمس والقمر ليقولن الله فانى يافكون",
  },
  {
    verseId: 61,
    name: "العنكبوت",
    surahId: 29,
    text: "ٱللَّهُ يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ مِنۡ عِبَادِهِۦ وَيَقۡدِرُ لَهُۥٓۚ إِنَّ ٱللَّهَ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "Allah extends provision for whom He wills of His servants and restricts for him. Indeed Allah is, of all things, Knowing",
    normalizedText:
      "الله يبسط الرزق لمن يشاء من عباده ويقدر له ان الله بكل شيء عليم",
  },
  {
    verseId: 62,
    name: "العنكبوت",
    surahId: 29,
    text: "وَلَئِن سَأَلۡتَهُم مَّن نَّزَّلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَأَحۡيَا بِهِ ٱلۡأَرۡضَ مِنۢ بَعۡدِ مَوۡتِهَا لَيَقُولُنَّ ٱللَّهُۚ قُلِ ٱلۡحَمۡدُ لِلَّهِۚ بَلۡ أَكۡثَرُهُمۡ لَا يَعۡقِلُونَ",
    translation:
      'And if you asked them, "Who sends down rain from the sky and gives life thereby to the earth after its lifelessness?" they would surely say " Allah." Say, "Praise to Allah "; but most of them do not reason',
    normalizedText:
      "ولان سالتهم من نزل من السماء ماء فاحيا به الارض من بعد موتها ليقولن الله قل الحمد لله بل اكثرهم لا يعقلون",
  },
  {
    verseId: 63,
    name: "العنكبوت",
    surahId: 29,
    text: "وَمَا هَٰذِهِ ٱلۡحَيَوٰةُ ٱلدُّنۡيَآ إِلَّا لَهۡوٞ وَلَعِبٞۚ وَإِنَّ ٱلدَّارَ ٱلۡأٓخِرَةَ لَهِيَ ٱلۡحَيَوَانُۚ لَوۡ كَانُواْ يَعۡلَمُونَ",
    translation:
      "And this worldly life is not but diversion and amusement. And indeed, the home of the Hereafter - that is the [eternal] life, if only they knew",
    normalizedText:
      "وما هذه الحيوة الدنيا الا لهو ولعب وان الدار الاخرة لهي الحيوان لو كانوا يعلمون",
  },
  {
    verseId: 64,
    name: "العنكبوت",
    surahId: 29,
    text: "فَإِذَا رَكِبُواْ فِي ٱلۡفُلۡكِ دَعَوُاْ ٱللَّهَ مُخۡلِصِينَ لَهُ ٱلدِّينَ فَلَمَّا نَجَّىٰهُمۡ إِلَى ٱلۡبَرِّ إِذَا هُمۡ يُشۡرِكُونَ",
    translation:
      "And when they board a ship, they supplicate Allah, sincere to Him in religion. But when He delivers them to the land, at once they associate others with Him",
    normalizedText:
      "فاذا ركبوا في الفلك دعوا الله مخلصين له الدين فلما نجىهم الى البر اذا هم يشركون",
  },
  {
    verseId: 65,
    name: "العنكبوت",
    surahId: 29,
    text: "لِيَكۡفُرُواْ بِمَآ ءَاتَيۡنَٰهُمۡ وَلِيَتَمَتَّعُواْۚ فَسَوۡفَ يَعۡلَمُونَ",
    translation:
      "So that they will deny what We have granted them, and they will enjoy themselves. But they are going to know",
    normalizedText: "ليكفروا بما ءاتينهم وليتمتعوا فسوف يعلمون",
  },
  {
    verseId: 66,
    name: "العنكبوت",
    surahId: 29,
    text: "أَوَلَمۡ يَرَوۡاْ أَنَّا جَعَلۡنَا حَرَمًا ءَامِنٗا وَيُتَخَطَّفُ ٱلنَّاسُ مِنۡ حَوۡلِهِمۡۚ أَفَبِٱلۡبَٰطِلِ يُؤۡمِنُونَ وَبِنِعۡمَةِ ٱللَّهِ يَكۡفُرُونَ",
    translation:
      "Have they not seen that We made [Makkah] a safe sanctuary, while people are being taken away all around them? Then in falsehood do they believe, and in the favor of Allah they disbelieve",
    normalizedText:
      "اولم يروا انا جعلنا حرما ءامنا ويتخطف الناس من حولهم افبالبطل يامنون وبنعمة الله يكفرون",
  },
  {
    verseId: 67,
    name: "العنكبوت",
    surahId: 29,
    text: "وَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوۡ كَذَّبَ بِٱلۡحَقِّ لَمَّا جَآءَهُۥٓۚ أَلَيۡسَ فِي جَهَنَّمَ مَثۡوٗى لِّلۡكَٰفِرِينَ",
    translation:
      "And who is more unjust than one who invents a lie about Allah or denies the truth when it has come to him? Is there not in Hell a [sufficient] residence for the disbelievers",
    normalizedText:
      "ومن اظلم ممن افترى على الله كذبا او كذب بالحق لما جاءه اليس في جهنم مثوى للكفرين",
  },
  {
    verseId: 68,
    name: "العنكبوت",
    surahId: 29,
    text: "وَٱلَّذِينَ جَٰهَدُواْ فِينَا لَنَهۡدِيَنَّهُمۡ سُبُلَنَاۚ وَإِنَّ ٱللَّهَ لَمَعَ ٱلۡمُحۡسِنِينَ",
    translation:
      "And those who strive for Us - We will surely guide them to Our ways. And indeed, Allah is with the doers of good",
    normalizedText: "والذين جهدوا فينا لنهدينهم سبلنا وان الله لمع المحسنين",
  },
  {
    verseId: 0,
    name: "الروم",
    surahId: 30,
    text: "الٓمٓ",
    translation: "Alif, Lam, Meem",
    normalizedText: "الم",
  },
  {
    verseId: 1,
    name: "الروم",
    surahId: 30,
    text: "غُلِبَتِ ٱلرُّومُ",
    translation: "The Byzantines have been defeated",
    normalizedText: "غلبت الروم",
  },
  {
    verseId: 2,
    name: "الروم",
    surahId: 30,
    text: "فِيٓ أَدۡنَى ٱلۡأَرۡضِ وَهُم مِّنۢ بَعۡدِ غَلَبِهِمۡ سَيَغۡلِبُونَ",
    translation:
      "In the nearest land. But they, after their defeat, will overcome",
    normalizedText: "في ادنى الارض وهم من بعد غلبهم سيغلبون",
  },
  {
    verseId: 3,
    name: "الروم",
    surahId: 30,
    text: "فِي بِضۡعِ سِنِينَۗ لِلَّهِ ٱلۡأَمۡرُ مِن قَبۡلُ وَمِنۢ بَعۡدُۚ وَيَوۡمَئِذٖ يَفۡرَحُ ٱلۡمُؤۡمِنُونَ",
    translation:
      "Within three to nine years. To Allah belongs the command before and after. And that day the believers will rejoice",
    normalizedText: "في بضع سنين لله الامر من قبل ومن بعد ويوماذ يفرح المامنون",
  },
  {
    verseId: 4,
    name: "الروم",
    surahId: 30,
    text: "بِنَصۡرِ ٱللَّهِۚ يَنصُرُ مَن يَشَآءُۖ وَهُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "In the victory of Allah. He gives victory to whom He wills, and He is the Exalted in Might, the Merciful",
    normalizedText: "بنصر الله ينصر من يشاء وهو العزيز الرحيم",
  },
  {
    verseId: 5,
    name: "الروم",
    surahId: 30,
    text: "وَعۡدَ ٱللَّهِۖ لَا يُخۡلِفُ ٱللَّهُ وَعۡدَهُۥ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      "[It is] the promise of Allah. Allah does not fail in His promise, but most of the people do not know",
    normalizedText: "وعد الله لا يخلف الله وعده ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 6,
    name: "الروم",
    surahId: 30,
    text: "يَعۡلَمُونَ ظَٰهِرٗا مِّنَ ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَهُمۡ عَنِ ٱلۡأٓخِرَةِ هُمۡ غَٰفِلُونَ",
    translation:
      "They know what is apparent of the worldly life, but they, of the Hereafter, are unaware",
    normalizedText: "يعلمون ظهرا من الحيوة الدنيا وهم عن الاخرة هم غفلون",
  },
  {
    verseId: 7,
    name: "الروم",
    surahId: 30,
    text: "أَوَلَمۡ يَتَفَكَّرُواْ فِيٓ أَنفُسِهِمۗ مَّا خَلَقَ ٱللَّهُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَآ إِلَّا بِٱلۡحَقِّ وَأَجَلٖ مُّسَمّٗىۗ وَإِنَّ كَثِيرٗا مِّنَ ٱلنَّاسِ بِلِقَآيِٕ رَبِّهِمۡ لَكَٰفِرُونَ",
    translation:
      "Do they not contemplate within themselves? Allah has not created the heavens and the earth and what is between them except in truth and for a specified term. And indeed, many of the people, in [the matter of] the meeting with their Lord, are disbelievers",
    normalizedText:
      "اولم يتفكروا في انفسهم ما خلق الله السموت والارض وما بينهما الا بالحق واجل مسمى وان كثيرا من الناس بلقاي ربهم لكفرون",
  },
  {
    verseId: 8,
    name: "الروم",
    surahId: 30,
    text: "أَوَلَمۡ يَسِيرُواْ فِي ٱلۡأَرۡضِ فَيَنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبۡلِهِمۡۚ كَانُوٓاْ أَشَدَّ مِنۡهُمۡ قُوَّةٗ وَأَثَارُواْ ٱلۡأَرۡضَ وَعَمَرُوهَآ أَكۡثَرَ مِمَّا عَمَرُوهَا وَجَآءَتۡهُمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِۖ فَمَا كَانَ ٱللَّهُ لِيَظۡلِمَهُمۡ وَلَٰكِن كَانُوٓاْ أَنفُسَهُمۡ يَظۡلِمُونَ",
    translation:
      "Have they not traveled through the earth and observed how was the end of those before them? They were greater than them in power, and they plowed the earth and built it up more than they have built it up, and their messengers came to them with clear evidences. And Allah would not ever have wronged them, but they were wronging themselves",
    normalizedText:
      "اولم يسيروا في الارض فينظروا كيف كان عقبة الذين من قبلهم كانوا اشد منهم قوة واثاروا الارض وعمروها اكثر مما عمروها وجاءتهم رسلهم بالبينت فما كان الله ليظلمهم ولكن كانوا انفسهم يظلمون",
  },
  {
    verseId: 9,
    name: "الروم",
    surahId: 30,
    text: "ثُمَّ كَانَ عَٰقِبَةَ ٱلَّذِينَ أَسَـٰٓـُٔواْ ٱلسُّوٓأَىٰٓ أَن كَذَّبُواْ بِـَٔايَٰتِ ٱللَّهِ وَكَانُواْ بِهَا يَسۡتَهۡزِءُونَ",
    translation:
      "Then the end of those who did evil was the worst [consequence] because they denied the signs of Allah and used to ridicule them",
    normalizedText:
      "ثم كان عقبة الذين اسوا السواى ان كذبوا بايت الله وكانوا بها يستهزءون",
  },
  {
    verseId: 10,
    name: "الروم",
    surahId: 30,
    text: "ٱللَّهُ يَبۡدَؤُاْ ٱلۡخَلۡقَ ثُمَّ يُعِيدُهُۥ ثُمَّ إِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "Allah begins creation; then He will repeat it; then to Him you will be returned",
    normalizedText: "الله يبداا الخلق ثم يعيده ثم اليه ترجعون",
  },
  {
    verseId: 11,
    name: "الروم",
    surahId: 30,
    text: "وَيَوۡمَ تَقُومُ ٱلسَّاعَةُ يُبۡلِسُ ٱلۡمُجۡرِمُونَ",
    translation:
      "And the Day the Hour appears the criminals will be in despair",
    normalizedText: "ويوم تقوم الساعة يبلس المجرمون",
  },
  {
    verseId: 12,
    name: "الروم",
    surahId: 30,
    text: "وَلَمۡ يَكُن لَّهُم مِّن شُرَكَآئِهِمۡ شُفَعَـٰٓؤُاْ وَكَانُواْ بِشُرَكَآئِهِمۡ كَٰفِرِينَ",
    translation:
      "And there will not be for them among their [alleged] partners any intercessors, and they will [then] be disbelievers in their partners",
    normalizedText: "ولم يكن لهم من شركااهم شفعاا وكانوا بشركااهم كفرين",
  },
  {
    verseId: 13,
    name: "الروم",
    surahId: 30,
    text: "وَيَوۡمَ تَقُومُ ٱلسَّاعَةُ يَوۡمَئِذٖ يَتَفَرَّقُونَ",
    translation:
      "And the Day the Hour appears - that Day they will become separated",
    normalizedText: "ويوم تقوم الساعة يوماذ يتفرقون",
  },
  {
    verseId: 14,
    name: "الروم",
    surahId: 30,
    text: "فَأَمَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فَهُمۡ فِي رَوۡضَةٖ يُحۡبَرُونَ",
    translation:
      "And as for those who had believed and done righteous deeds, they will be in a garden [of Paradise], delighted",
    normalizedText: "فاما الذين ءامنوا وعملوا الصلحت فهم في روضة يحبرون",
  },
  {
    verseId: 15,
    name: "الروم",
    surahId: 30,
    text: "وَأَمَّا ٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِـَٔايَٰتِنَا وَلِقَآيِٕ ٱلۡأٓخِرَةِ فَأُوْلَـٰٓئِكَ فِي ٱلۡعَذَابِ مُحۡضَرُونَ",
    translation:
      "But as for those who disbelieved and denied Our verses and the meeting of the Hereafter, those will be brought into the punishment [to remain]",
    normalizedText:
      "واما الذين كفروا وكذبوا بايتنا ولقاي الاخرة فاولاك في العذاب محضرون",
  },
  {
    verseId: 16,
    name: "الروم",
    surahId: 30,
    text: "فَسُبۡحَٰنَ ٱللَّهِ حِينَ تُمۡسُونَ وَحِينَ تُصۡبِحُونَ",
    translation:
      "So exalted is Allah when you reach the evening and when you reach the morning",
    normalizedText: "فسبحن الله حين تمسون وحين تصبحون",
  },
  {
    verseId: 17,
    name: "الروم",
    surahId: 30,
    text: "وَلَهُ ٱلۡحَمۡدُ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَعَشِيّٗا وَحِينَ تُظۡهِرُونَ",
    translation:
      "And to Him is [due all] praise throughout the heavens and the earth. And [exalted is He] at night and when you are at noon",
    normalizedText: "وله الحمد في السموت والارض وعشيا وحين تظهرون",
  },
  {
    verseId: 18,
    name: "الروم",
    surahId: 30,
    text: "يُخۡرِجُ ٱلۡحَيَّ مِنَ ٱلۡمَيِّتِ وَيُخۡرِجُ ٱلۡمَيِّتَ مِنَ ٱلۡحَيِّ وَيُحۡيِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَاۚ وَكَذَٰلِكَ تُخۡرَجُونَ",
    translation:
      "He brings the living out of the dead and brings the dead out of the living and brings to life the earth after its lifelessness. And thus will you be brought out",
    normalizedText:
      "يخرج الحي من الميت ويخرج الميت من الحي ويحي الارض بعد موتها وكذلك تخرجون",
  },
  {
    verseId: 19,
    name: "الروم",
    surahId: 30,
    text: "وَمِنۡ ءَايَٰتِهِۦٓ أَنۡ خَلَقَكُم مِّن تُرَابٖ ثُمَّ إِذَآ أَنتُم بَشَرٞ تَنتَشِرُونَ",
    translation:
      "And of His signs is that He created you from dust; then, suddenly you were human beings dispersing [throughout the earth]",
    normalizedText: "ومن ءايته ان خلقكم من تراب ثم اذا انتم بشر تنتشرون",
  },
  {
    verseId: 20,
    name: "الروم",
    surahId: 30,
    text: "وَمِنۡ ءَايَٰتِهِۦٓ أَنۡ خَلَقَ لَكُم مِّنۡ أَنفُسِكُمۡ أَزۡوَٰجٗا لِّتَسۡكُنُوٓاْ إِلَيۡهَا وَجَعَلَ بَيۡنَكُم مَّوَدَّةٗ وَرَحۡمَةًۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَتَفَكَّرُونَ",
    translation:
      "And of His signs is that He created for you from yourselves mates that you may find tranquillity in them; and He placed between you affection and mercy. Indeed in that are signs for a people who give thought",
    normalizedText:
      "ومن ءايته ان خلق لكم من انفسكم ازوجا لتسكنوا اليها وجعل بينكم مودة ورحمة ان في ذلك لايت لقوم يتفكرون",
  },
  {
    verseId: 21,
    name: "الروم",
    surahId: 30,
    text: "وَمِنۡ ءَايَٰتِهِۦ خَلۡقُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَٱخۡتِلَٰفُ أَلۡسِنَتِكُمۡ وَأَلۡوَٰنِكُمۡۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّلۡعَٰلِمِينَ",
    translation:
      "And of His signs is the creation of the heavens and the earth and the diversity of your languages and your colors. Indeed in that are signs for those of knowledge",
    normalizedText:
      "ومن ءايته خلق السموت والارض واختلف السنتكم والونكم ان في ذلك لايت للعلمين",
  },
  {
    verseId: 22,
    name: "الروم",
    surahId: 30,
    text: "وَمِنۡ ءَايَٰتِهِۦ مَنَامُكُم بِٱلَّيۡلِ وَٱلنَّهَارِ وَٱبۡتِغَآؤُكُم مِّن فَضۡلِهِۦٓۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَسۡمَعُونَ",
    translation:
      "And of His signs is your sleep by night and day and your seeking of His bounty. Indeed in that are signs for a people who listen",
    normalizedText:
      "ومن ءايته منامكم باليل والنهار وابتغااكم من فضله ان في ذلك لايت لقوم يسمعون",
  },
  {
    verseId: 23,
    name: "الروم",
    surahId: 30,
    text: "وَمِنۡ ءَايَٰتِهِۦ يُرِيكُمُ ٱلۡبَرۡقَ خَوۡفٗا وَطَمَعٗا وَيُنَزِّلُ مِنَ ٱلسَّمَآءِ مَآءٗ فَيُحۡيِۦ بِهِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَآۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "And of His signs is [that] He shows you the lightning [causing] fear and aspiration, and He sends down rain from the sky by which He brings to life the earth after its lifelessness. Indeed in that are signs for a people who use reason",
    normalizedText:
      "ومن ءايته يريكم البرق خوفا وطمعا وينزل من السماء ماء فيحي به الارض بعد موتها ان في ذلك لايت لقوم يعقلون",
  },
  {
    verseId: 24,
    name: "الروم",
    surahId: 30,
    text: "وَمِنۡ ءَايَٰتِهِۦٓ أَن تَقُومَ ٱلسَّمَآءُ وَٱلۡأَرۡضُ بِأَمۡرِهِۦۚ ثُمَّ إِذَا دَعَاكُمۡ دَعۡوَةٗ مِّنَ ٱلۡأَرۡضِ إِذَآ أَنتُمۡ تَخۡرُجُونَ",
    translation:
      "And of His signs is that the heaven and earth remain by His command. Then when He calls you with a [single] call from the earth, immediately you will come forth",
    normalizedText:
      "ومن ءايته ان تقوم السماء والارض بامره ثم اذا دعاكم دعوة من الارض اذا انتم تخرجون",
  },
  {
    verseId: 25,
    name: "الروم",
    surahId: 30,
    text: "وَلَهُۥ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ كُلّٞ لَّهُۥ قَٰنِتُونَ",
    translation:
      "And to Him belongs whoever is in the heavens and earth. All are to Him devoutly obedient",
    normalizedText: "وله من في السموت والارض كل له قنتون",
  },
  {
    verseId: 26,
    name: "الروم",
    surahId: 30,
    text: "وَهُوَ ٱلَّذِي يَبۡدَؤُاْ ٱلۡخَلۡقَ ثُمَّ يُعِيدُهُۥ وَهُوَ أَهۡوَنُ عَلَيۡهِۚ وَلَهُ ٱلۡمَثَلُ ٱلۡأَعۡلَىٰ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "And it is He who begins creation; then He repeats it, and that is [even] easier for Him. To Him belongs the highest attribute in the heavens and earth. And He is the Exalted in Might, the Wise",
    normalizedText:
      "وهو الذي يبداا الخلق ثم يعيده وهو اهون عليه وله المثل الاعلى في السموت والارض وهو العزيز الحكيم",
  },
  {
    verseId: 27,
    name: "الروم",
    surahId: 30,
    text: "ضَرَبَ لَكُم مَّثَلٗا مِّنۡ أَنفُسِكُمۡۖ هَل لَّكُم مِّن مَّا مَلَكَتۡ أَيۡمَٰنُكُم مِّن شُرَكَآءَ فِي مَا رَزَقۡنَٰكُمۡ فَأَنتُمۡ فِيهِ سَوَآءٞ تَخَافُونَهُمۡ كَخِيفَتِكُمۡ أَنفُسَكُمۡۚ كَذَٰلِكَ نُفَصِّلُ ٱلۡأٓيَٰتِ لِقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "He presents to you an example from yourselves. Do you have among those whom your right hands possess any partners in what We have provided for you so that you are equal therein [and] would fear them as your fear of one another [within a partnership]? Thus do We detail the verses for a people who use reason",
    normalizedText:
      "ضرب لكم مثلا من انفسكم هل لكم من ما ملكت ايمنكم من شركاء في ما رزقنكم فانتم فيه سواء تخافونهم كخيفتكم انفسكم كذلك نفصل الايت لقوم يعقلون",
  },
  {
    verseId: 28,
    name: "الروم",
    surahId: 30,
    text: "بَلِ ٱتَّبَعَ ٱلَّذِينَ ظَلَمُوٓاْ أَهۡوَآءَهُم بِغَيۡرِ عِلۡمٖۖ فَمَن يَهۡدِي مَنۡ أَضَلَّ ٱللَّهُۖ وَمَا لَهُم مِّن نَّـٰصِرِينَ",
    translation:
      "But those who wrong follow their [own] desires without knowledge. Then who can guide one whom Allah has sent astray? And for them there are no helpers",
    normalizedText:
      "بل اتبع الذين ظلموا اهواءهم بغير علم فمن يهدي من اضل الله وما لهم من نصرين",
  },
  {
    verseId: 29,
    name: "الروم",
    surahId: 30,
    text: "فَأَقِمۡ وَجۡهَكَ لِلدِّينِ حَنِيفٗاۚ فِطۡرَتَ ٱللَّهِ ٱلَّتِي فَطَرَ ٱلنَّاسَ عَلَيۡهَاۚ لَا تَبۡدِيلَ لِخَلۡقِ ٱللَّهِۚ ذَٰلِكَ ٱلدِّينُ ٱلۡقَيِّمُ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      "So direct your face toward the religion, inclining to truth. [Adhere to] the fitrah of Allah upon which He has created [all] people. No change should there be in the creation of Allah. That is the correct religion, but most of the people do not know",
    normalizedText:
      "فاقم وجهك للدين حنيفا فطرت الله التي فطر الناس عليها لا تبديل لخلق الله ذلك الدين القيم ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 30,
    name: "الروم",
    surahId: 30,
    text: "۞مُنِيبِينَ إِلَيۡهِ وَٱتَّقُوهُ وَأَقِيمُواْ ٱلصَّلَوٰةَ وَلَا تَكُونُواْ مِنَ ٱلۡمُشۡرِكِينَ",
    translation:
      "[Adhere to it], turning in repentance to Him, and fear Him and establish prayer and do not be of those who associate others with Allah",
    normalizedText: "۞منيبين اليه واتقوه واقيموا الصلوة ولا تكونوا من المشركين",
  },
  {
    verseId: 31,
    name: "الروم",
    surahId: 30,
    text: "مِنَ ٱلَّذِينَ فَرَّقُواْ دِينَهُمۡ وَكَانُواْ شِيَعٗاۖ كُلُّ حِزۡبِۭ بِمَا لَدَيۡهِمۡ فَرِحُونَ",
    translation:
      "[Or] of those who have divided their religion and become sects, every faction rejoicing in what it has",
    normalizedText: "من الذين فرقوا دينهم وكانوا شيعا كل حزب بما لديهم فرحون",
  },
  {
    verseId: 32,
    name: "الروم",
    surahId: 30,
    text: "وَإِذَا مَسَّ ٱلنَّاسَ ضُرّٞ دَعَوۡاْ رَبَّهُم مُّنِيبِينَ إِلَيۡهِ ثُمَّ إِذَآ أَذَاقَهُم مِّنۡهُ رَحۡمَةً إِذَا فَرِيقٞ مِّنۡهُم بِرَبِّهِمۡ يُشۡرِكُونَ",
    translation:
      "And when adversity touches the people, they call upon their Lord, turning in repentance to Him. Then when He lets them taste mercy from Him, at once a party of them associate others with their Lord",
    normalizedText:
      "واذا مس الناس ضر دعوا ربهم منيبين اليه ثم اذا اذاقهم منه رحمة اذا فريق منهم بربهم يشركون",
  },
  {
    verseId: 33,
    name: "الروم",
    surahId: 30,
    text: "لِيَكۡفُرُواْ بِمَآ ءَاتَيۡنَٰهُمۡۚ فَتَمَتَّعُواْ فَسَوۡفَ تَعۡلَمُونَ",
    translation:
      "So that they will deny what We have granted them. Then enjoy yourselves, for you are going to know",
    normalizedText: "ليكفروا بما ءاتينهم فتمتعوا فسوف تعلمون",
  },
  {
    verseId: 34,
    name: "الروم",
    surahId: 30,
    text: "أَمۡ أَنزَلۡنَا عَلَيۡهِمۡ سُلۡطَٰنٗا فَهُوَ يَتَكَلَّمُ بِمَا كَانُواْ بِهِۦ يُشۡرِكُونَ",
    translation:
      "Or have We sent down to them an authority, and it speaks of what they were associating with Him",
    normalizedText: "ام انزلنا عليهم سلطنا فهو يتكلم بما كانوا به يشركون",
  },
  {
    verseId: 35,
    name: "الروم",
    surahId: 30,
    text: "وَإِذَآ أَذَقۡنَا ٱلنَّاسَ رَحۡمَةٗ فَرِحُواْ بِهَاۖ وَإِن تُصِبۡهُمۡ سَيِّئَةُۢ بِمَا قَدَّمَتۡ أَيۡدِيهِمۡ إِذَا هُمۡ يَقۡنَطُونَ",
    translation:
      "And when We let the people taste mercy, they rejoice therein, but if evil afflicts them for what their hands have put forth, immediately they despair",
    normalizedText:
      "واذا اذقنا الناس رحمة فرحوا بها وان تصبهم سياة بما قدمت ايديهم اذا هم يقنطون",
  },
  {
    verseId: 36,
    name: "الروم",
    surahId: 30,
    text: "أَوَلَمۡ يَرَوۡاْ أَنَّ ٱللَّهَ يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ وَيَقۡدِرُۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "Do they not see that Allah extends provision for whom He wills and restricts [it]? Indeed, in that are signs for a people who believe",
    normalizedText:
      "اولم يروا ان الله يبسط الرزق لمن يشاء ويقدر ان في ذلك لايت لقوم يامنون",
  },
  {
    verseId: 37,
    name: "الروم",
    surahId: 30,
    text: "فَـَٔاتِ ذَا ٱلۡقُرۡبَىٰ حَقَّهُۥ وَٱلۡمِسۡكِينَ وَٱبۡنَ ٱلسَّبِيلِۚ ذَٰلِكَ خَيۡرٞ لِّلَّذِينَ يُرِيدُونَ وَجۡهَ ٱللَّهِۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "So give the relative his right, as well as the needy and the traveler. That is best for those who desire the countenance of Allah, and it is they who will be the successful",
    normalizedText:
      "فات ذا القربى حقه والمسكين وابن السبيل ذلك خير للذين يريدون وجه الله واولاك هم المفلحون",
  },
  {
    verseId: 38,
    name: "الروم",
    surahId: 30,
    text: "وَمَآ ءَاتَيۡتُم مِّن رِّبٗا لِّيَرۡبُوَاْ فِيٓ أَمۡوَٰلِ ٱلنَّاسِ فَلَا يَرۡبُواْ عِندَ ٱللَّهِۖ وَمَآ ءَاتَيۡتُم مِّن زَكَوٰةٖ تُرِيدُونَ وَجۡهَ ٱللَّهِ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُضۡعِفُونَ",
    translation:
      "And whatever you give for interest to increase within the wealth of people will not increase with Allah. But what you give in zakah, desiring the countenance of Allah - those are the multipliers",
    normalizedText:
      "وما ءاتيتم من ربا ليربوا في امول الناس فلا يربوا عند الله وما ءاتيتم من زكوة تريدون وجه الله فاولاك هم المضعفون",
  },
  {
    verseId: 39,
    name: "الروم",
    surahId: 30,
    text: "ٱللَّهُ ٱلَّذِي خَلَقَكُمۡ ثُمَّ رَزَقَكُمۡ ثُمَّ يُمِيتُكُمۡ ثُمَّ يُحۡيِيكُمۡۖ هَلۡ مِن شُرَكَآئِكُم مَّن يَفۡعَلُ مِن ذَٰلِكُم مِّن شَيۡءٖۚ سُبۡحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      'Allah is the one who created you, then provided for you, then will cause you to die, and then will give you life. Are there any of your "partners" who does anything of that? Exalted is He and high above what they associate with Him',
    normalizedText:
      "الله الذي خلقكم ثم رزقكم ثم يميتكم ثم يحييكم هل من شركااكم من يفعل من ذلكم من شيء سبحنه وتعلى عما يشركون",
  },
  {
    verseId: 40,
    name: "الروم",
    surahId: 30,
    text: "ظَهَرَ ٱلۡفَسَادُ فِي ٱلۡبَرِّ وَٱلۡبَحۡرِ بِمَا كَسَبَتۡ أَيۡدِي ٱلنَّاسِ لِيُذِيقَهُم بَعۡضَ ٱلَّذِي عَمِلُواْ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      "Corruption has appeared throughout the land and sea by [reason of] what the hands of people have earned so He may let them taste part of [the consequence of] what they have done that perhaps they will return [to righteousness]",
    normalizedText:
      "ظهر الفساد في البر والبحر بما كسبت ايدي الناس ليذيقهم بعض الذي عملوا لعلهم يرجعون",
  },
  {
    verseId: 41,
    name: "الروم",
    surahId: 30,
    text: "قُلۡ سِيرُواْ فِي ٱلۡأَرۡضِ فَٱنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبۡلُۚ كَانَ أَكۡثَرُهُم مُّشۡرِكِينَ",
    translation:
      'Say, [O Muhammad], "Travel through the land and observe how was the end of those before. Most of them were associators [of others with Allah]',
    normalizedText:
      "قل سيروا في الارض فانظروا كيف كان عقبة الذين من قبل كان اكثرهم مشركين",
  },
  {
    verseId: 42,
    name: "الروم",
    surahId: 30,
    text: "فَأَقِمۡ وَجۡهَكَ لِلدِّينِ ٱلۡقَيِّمِ مِن قَبۡلِ أَن يَأۡتِيَ يَوۡمٞ لَّا مَرَدَّ لَهُۥ مِنَ ٱللَّهِۖ يَوۡمَئِذٖ يَصَّدَّعُونَ",
    translation:
      "So direct your face toward the correct religion before a Day comes from Allah of which there is no repelling. That Day, they will be divided",
    normalizedText:
      "فاقم وجهك للدين القيم من قبل ان ياتي يوم لا مرد له من الله يوماذ يصدعون",
  },
  {
    verseId: 43,
    name: "الروم",
    surahId: 30,
    text: "مَن كَفَرَ فَعَلَيۡهِ كُفۡرُهُۥۖ وَمَنۡ عَمِلَ صَٰلِحٗا فَلِأَنفُسِهِمۡ يَمۡهَدُونَ",
    translation:
      "Whoever disbelieves - upon him is [the consequence of] his disbelief. And whoever does righteousness - they are for themselves preparing",
    normalizedText: "من كفر فعليه كفره ومن عمل صلحا فلانفسهم يمهدون",
  },
  {
    verseId: 44,
    name: "الروم",
    surahId: 30,
    text: "لِيَجۡزِيَ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ مِن فَضۡلِهِۦٓۚ إِنَّهُۥ لَا يُحِبُّ ٱلۡكَٰفِرِينَ",
    translation:
      "That He may reward those who have believed and done righteous deeds out of His bounty. Indeed, He does not like the disbelievers",
    normalizedText:
      "ليجزي الذين ءامنوا وعملوا الصلحت من فضله انه لا يحب الكفرين",
  },
  {
    verseId: 45,
    name: "الروم",
    surahId: 30,
    text: "وَمِنۡ ءَايَٰتِهِۦٓ أَن يُرۡسِلَ ٱلرِّيَاحَ مُبَشِّرَٰتٖ وَلِيُذِيقَكُم مِّن رَّحۡمَتِهِۦ وَلِتَجۡرِيَ ٱلۡفُلۡكُ بِأَمۡرِهِۦ وَلِتَبۡتَغُواْ مِن فَضۡلِهِۦ وَلَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And of His signs is that He sends the winds as bringers of good tidings and to let you taste His mercy and so the ships may sail at His command and so you may seek of His bounty, and perhaps you will be grateful",
    normalizedText:
      "ومن ءايته ان يرسل الرياح مبشرت وليذيقكم من رحمته ولتجري الفلك بامره ولتبتغوا من فضله ولعلكم تشكرون",
  },
  {
    verseId: 46,
    name: "الروم",
    surahId: 30,
    text: "وَلَقَدۡ أَرۡسَلۡنَا مِن قَبۡلِكَ رُسُلًا إِلَىٰ قَوۡمِهِمۡ فَجَآءُوهُم بِٱلۡبَيِّنَٰتِ فَٱنتَقَمۡنَا مِنَ ٱلَّذِينَ أَجۡرَمُواْۖ وَكَانَ حَقًّا عَلَيۡنَا نَصۡرُ ٱلۡمُؤۡمِنِينَ",
    translation:
      "And We have already sent messengers before you to their peoples, and they came to them with clear evidences; then We took retribution from those who committed crimes, and incumbent upon Us was support of the believers",
    normalizedText:
      "ولقد ارسلنا من قبلك رسلا الى قومهم فجاءوهم بالبينت فانتقمنا من الذين اجرموا وكان حقا علينا نصر المامنين",
  },
  {
    verseId: 47,
    name: "الروم",
    surahId: 30,
    text: "ٱللَّهُ ٱلَّذِي يُرۡسِلُ ٱلرِّيَٰحَ فَتُثِيرُ سَحَابٗا فَيَبۡسُطُهُۥ فِي ٱلسَّمَآءِ كَيۡفَ يَشَآءُ وَيَجۡعَلُهُۥ كِسَفٗا فَتَرَى ٱلۡوَدۡقَ يَخۡرُجُ مِنۡ خِلَٰلِهِۦۖ فَإِذَآ أَصَابَ بِهِۦ مَن يَشَآءُ مِنۡ عِبَادِهِۦٓ إِذَا هُمۡ يَسۡتَبۡشِرُونَ",
    translation:
      "It is Allah who sends the winds, and they stir the clouds and spread them in the sky however He wills, and He makes them fragments so you see the rain emerge from within them. And when He causes it to fall upon whom He wills of His servants, immediately they rejoice",
    normalizedText:
      "الله الذي يرسل الريح فتثير سحابا فيبسطه في السماء كيف يشاء ويجعله كسفا فترى الودق يخرج من خلله فاذا اصاب به من يشاء من عباده اذا هم يستبشرون",
  },
  {
    verseId: 48,
    name: "الروم",
    surahId: 30,
    text: "وَإِن كَانُواْ مِن قَبۡلِ أَن يُنَزَّلَ عَلَيۡهِم مِّن قَبۡلِهِۦ لَمُبۡلِسِينَ",
    translation:
      "Although they were, before it was sent down upon them - before that, in despair",
    normalizedText: "وان كانوا من قبل ان ينزل عليهم من قبله لمبلسين",
  },
  {
    verseId: 49,
    name: "الروم",
    surahId: 30,
    text: "فَٱنظُرۡ إِلَىٰٓ ءَاثَٰرِ رَحۡمَتِ ٱللَّهِ كَيۡفَ يُحۡيِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَآۚ إِنَّ ذَٰلِكَ لَمُحۡيِ ٱلۡمَوۡتَىٰۖ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "So observe the effects of the mercy of Allah - how He gives life to the earth after its lifelessness. Indeed, that [same one] will give life to the dead, and He is over all things competent",
    normalizedText:
      "فانظر الى ءاثر رحمت الله كيف يحي الارض بعد موتها ان ذلك لمحي الموتى وهو على كل شيء قدير",
  },
  {
    verseId: 50,
    name: "الروم",
    surahId: 30,
    text: "وَلَئِنۡ أَرۡسَلۡنَا رِيحٗا فَرَأَوۡهُ مُصۡفَرّٗا لَّظَلُّواْ مِنۢ بَعۡدِهِۦ يَكۡفُرُونَ",
    translation:
      "But if We should send a [bad] wind and they saw [their crops] turned yellow, they would remain thereafter disbelievers",
    normalizedText: "ولان ارسلنا ريحا فراوه مصفرا لظلوا من بعده يكفرون",
  },
  {
    verseId: 51,
    name: "الروم",
    surahId: 30,
    text: "فَإِنَّكَ لَا تُسۡمِعُ ٱلۡمَوۡتَىٰ وَلَا تُسۡمِعُ ٱلصُّمَّ ٱلدُّعَآءَ إِذَا وَلَّوۡاْ مُدۡبِرِينَ",
    translation:
      "So indeed, you will not make the dead hear, nor will you make the deaf hear the call when they turn their backs, retreating",
    normalizedText: "فانك لا تسمع الموتى ولا تسمع الصم الدعاء اذا ولوا مدبرين",
  },
  {
    verseId: 52,
    name: "الروم",
    surahId: 30,
    text: "وَمَآ أَنتَ بِهَٰدِ ٱلۡعُمۡيِ عَن ضَلَٰلَتِهِمۡۖ إِن تُسۡمِعُ إِلَّا مَن يُؤۡمِنُ بِـَٔايَٰتِنَا فَهُم مُّسۡلِمُونَ",
    translation:
      "And you cannot guide the blind away from their error. You will only make hear those who believe in Our verses so they are Muslims [in submission to Allah]",
    normalizedText:
      "وما انت بهد العمي عن ضللتهم ان تسمع الا من يامن بايتنا فهم مسلمون",
  },
  {
    verseId: 53,
    name: "الروم",
    surahId: 30,
    text: "۞ٱللَّهُ ٱلَّذِي خَلَقَكُم مِّن ضَعۡفٖ ثُمَّ جَعَلَ مِنۢ بَعۡدِ ضَعۡفٖ قُوَّةٗ ثُمَّ جَعَلَ مِنۢ بَعۡدِ قُوَّةٖ ضَعۡفٗا وَشَيۡبَةٗۚ يَخۡلُقُ مَا يَشَآءُۚ وَهُوَ ٱلۡعَلِيمُ ٱلۡقَدِيرُ",
    translation:
      "Allah is the one who created you from weakness, then made after weakness strength, then made after strength weakness and white hair. He creates what He wills, and He is the Knowing, the Competent",
    normalizedText:
      "۞الله الذي خلقكم من ضعف ثم جعل من بعد ضعف قوة ثم جعل من بعد قوة ضعفا وشيبة يخلق ما يشاء وهو العليم القدير",
  },
  {
    verseId: 54,
    name: "الروم",
    surahId: 30,
    text: "وَيَوۡمَ تَقُومُ ٱلسَّاعَةُ يُقۡسِمُ ٱلۡمُجۡرِمُونَ مَا لَبِثُواْ غَيۡرَ سَاعَةٖۚ كَذَٰلِكَ كَانُواْ يُؤۡفَكُونَ",
    translation:
      "And the Day the Hour appears the criminals will swear they had remained but an hour. Thus they were deluded",
    normalizedText:
      "ويوم تقوم الساعة يقسم المجرمون ما لبثوا غير ساعة كذلك كانوا يافكون",
  },
  {
    verseId: 55,
    name: "الروم",
    surahId: 30,
    text: "وَقَالَ ٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ وَٱلۡإِيمَٰنَ لَقَدۡ لَبِثۡتُمۡ فِي كِتَٰبِ ٱللَّهِ إِلَىٰ يَوۡمِ ٱلۡبَعۡثِۖ فَهَٰذَا يَوۡمُ ٱلۡبَعۡثِ وَلَٰكِنَّكُمۡ كُنتُمۡ لَا تَعۡلَمُونَ",
    translation: `But those who were given knowledge and faith will say, "You remained the extent of Allah 's decree until the Day of Resurrection, and this is the Day of Resurrection, but you did not used to know`,
    normalizedText:
      "وقال الذين اوتوا العلم والايمن لقد لبثتم في كتب الله الى يوم البعث فهذا يوم البعث ولكنكم كنتم لا تعلمون",
  },
  {
    verseId: 56,
    name: "الروم",
    surahId: 30,
    text: "فَيَوۡمَئِذٖ لَّا يَنفَعُ ٱلَّذِينَ ظَلَمُواْ مَعۡذِرَتُهُمۡ وَلَا هُمۡ يُسۡتَعۡتَبُونَ",
    translation:
      "So that Day, their excuse will not benefit those who wronged, nor will they be asked to appease [Allah]",
    normalizedText: "فيوماذ لا ينفع الذين ظلموا معذرتهم ولا هم يستعتبون",
  },
  {
    verseId: 57,
    name: "الروم",
    surahId: 30,
    text: "وَلَقَدۡ ضَرَبۡنَا لِلنَّاسِ فِي هَٰذَا ٱلۡقُرۡءَانِ مِن كُلِّ مَثَلٖۚ وَلَئِن جِئۡتَهُم بِـَٔايَةٖ لَّيَقُولَنَّ ٱلَّذِينَ كَفَرُوٓاْ إِنۡ أَنتُمۡ إِلَّا مُبۡطِلُونَ",
    translation: `And We have certainly presented to the people in this Qur'an from every [kind of] example. But, [O Muhammad], if you should bring them a sign, the disbelievers will surely say, "You [believers] are but falsifiers`,
    normalizedText:
      "ولقد ضربنا للناس في هذا القرءان من كل مثل ولان جاتهم باية ليقولن الذين كفروا ان انتم الا مبطلون",
  },
  {
    verseId: 58,
    name: "الروم",
    surahId: 30,
    text: "كَذَٰلِكَ يَطۡبَعُ ٱللَّهُ عَلَىٰ قُلُوبِ ٱلَّذِينَ لَا يَعۡلَمُونَ",
    translation: "Thus does Allah seal the hearts of those who do not know",
    normalizedText: "كذلك يطبع الله على قلوب الذين لا يعلمون",
  },
  {
    verseId: 59,
    name: "الروم",
    surahId: 30,
    text: "فَٱصۡبِرۡ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞۖ وَلَا يَسۡتَخِفَّنَّكَ ٱلَّذِينَ لَا يُوقِنُونَ",
    translation:
      "So be patient. Indeed, the promise of Allah is truth. And let them not disquiet you who are not certain [in faith]",
    normalizedText: "فاصبر ان وعد الله حق ولا يستخفنك الذين لا يوقنون",
  },
  {
    verseId: 0,
    name: "لقمان",
    surahId: 31,
    text: "الٓمٓ",
    translation: "Alif, Lam, Meem",
    normalizedText: "الم",
  },
  {
    verseId: 1,
    name: "لقمان",
    surahId: 31,
    text: "تِلۡكَ ءَايَٰتُ ٱلۡكِتَٰبِ ٱلۡحَكِيمِ",
    translation: "These are verses of the wise Book",
    normalizedText: "تلك ءايت الكتب الحكيم",
  },
  {
    verseId: 2,
    name: "لقمان",
    surahId: 31,
    text: "هُدٗى وَرَحۡمَةٗ لِّلۡمُحۡسِنِينَ",
    translation: "As guidance and mercy for the doers of good",
    normalizedText: "هدى ورحمة للمحسنين",
  },
  {
    verseId: 3,
    name: "لقمان",
    surahId: 31,
    text: "ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤۡتُونَ ٱلزَّكَوٰةَ وَهُم بِٱلۡأٓخِرَةِ هُمۡ يُوقِنُونَ",
    translation:
      "Who establish prayer and give zakah, and they, of the Hereafter, are certain [in faith]",
    normalizedText: "الذين يقيمون الصلوة وياتون الزكوة وهم بالاخرة هم يوقنون",
  },
  {
    verseId: 4,
    name: "لقمان",
    surahId: 31,
    text: "أُوْلَـٰٓئِكَ عَلَىٰ هُدٗى مِّن رَّبِّهِمۡۖ وَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "Those are on [right] guidance from their Lord, and it is those who are the successful",
    normalizedText: "اولاك على هدى من ربهم واولاك هم المفلحون",
  },
  {
    verseId: 5,
    name: "لقمان",
    surahId: 31,
    text: "وَمِنَ ٱلنَّاسِ مَن يَشۡتَرِي لَهۡوَ ٱلۡحَدِيثِ لِيُضِلَّ عَن سَبِيلِ ٱللَّهِ بِغَيۡرِ عِلۡمٖ وَيَتَّخِذَهَا هُزُوًاۚ أُوْلَـٰٓئِكَ لَهُمۡ عَذَابٞ مُّهِينٞ",
    translation:
      "And of the people is he who buys the amusement of speech to mislead [others] from the way of Allah without knowledge and who takes it in ridicule. Those will have a humiliating punishment",
    normalizedText:
      "ومن الناس من يشتري لهو الحديث ليضل عن سبيل الله بغير علم ويتخذها هزوا اولاك لهم عذاب مهين",
  },
  {
    verseId: 6,
    name: "لقمان",
    surahId: 31,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِ ءَايَٰتُنَا وَلَّىٰ مُسۡتَكۡبِرٗا كَأَن لَّمۡ يَسۡمَعۡهَا كَأَنَّ فِيٓ أُذُنَيۡهِ وَقۡرٗاۖ فَبَشِّرۡهُ بِعَذَابٍ أَلِيمٍ",
    translation:
      "And when our verses are recited to him, he turns away arrogantly as if he had not heard them, as if there was in his ears deafness. So give him tidings of a painful punishment",
    normalizedText:
      "واذا تتلى عليه ءايتنا ولى مستكبرا كان لم يسمعها كان في اذنيه وقرا فبشره بعذاب اليم",
  },
  {
    verseId: 7,
    name: "لقمان",
    surahId: 31,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَهُمۡ جَنَّـٰتُ ٱلنَّعِيمِ",
    translation:
      "Indeed, those who believe and do righteous deeds - for them are the Gardens of Pleasure",
    normalizedText: "ان الذين ءامنوا وعملوا الصلحت لهم جنت النعيم",
  },
  {
    verseId: 8,
    name: "لقمان",
    surahId: 31,
    text: "خَٰلِدِينَ فِيهَاۖ وَعۡدَ ٱللَّهِ حَقّٗاۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Wherein they abide eternally; [it is] the promise of Allah [which is] truth. And He is the Exalted in Might, the Wise",
    normalizedText: "خلدين فيها وعد الله حقا وهو العزيز الحكيم",
  },
  {
    verseId: 9,
    name: "لقمان",
    surahId: 31,
    text: "خَلَقَ ٱلسَّمَٰوَٰتِ بِغَيۡرِ عَمَدٖ تَرَوۡنَهَاۖ وَأَلۡقَىٰ فِي ٱلۡأَرۡضِ رَوَٰسِيَ أَن تَمِيدَ بِكُمۡ وَبَثَّ فِيهَا مِن كُلِّ دَآبَّةٖۚ وَأَنزَلۡنَا مِنَ ٱلسَّمَآءِ مَآءٗ فَأَنۢبَتۡنَا فِيهَا مِن كُلِّ زَوۡجٖ كَرِيمٍ",
    translation:
      "He created the heavens without pillars that you see and has cast into the earth firmly set mountains, lest it should shift with you, and dispersed therein from every creature. And We sent down rain from the sky and made grow therein [plants] of every noble kind",
    normalizedText:
      "خلق السموت بغير عمد ترونها والقى في الارض روسي ان تميد بكم وبث فيها من كل دابة وانزلنا من السماء ماء فانبتنا فيها من كل زوج كريم",
  },
  {
    verseId: 10,
    name: "لقمان",
    surahId: 31,
    text: "هَٰذَا خَلۡقُ ٱللَّهِ فَأَرُونِي مَاذَا خَلَقَ ٱلَّذِينَ مِن دُونِهِۦۚ بَلِ ٱلظَّـٰلِمُونَ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      "This is the creation of Allah. So show Me what those other than Him have created. Rather, the wrongdoers are in clear error",
    normalizedText:
      "هذا خلق الله فاروني ماذا خلق الذين من دونه بل الظلمون في ضلل مبين",
  },
  {
    verseId: 11,
    name: "لقمان",
    surahId: 31,
    text: "وَلَقَدۡ ءَاتَيۡنَا لُقۡمَٰنَ ٱلۡحِكۡمَةَ أَنِ ٱشۡكُرۡ لِلَّهِۚ وَمَن يَشۡكُرۡ فَإِنَّمَا يَشۡكُرُ لِنَفۡسِهِۦۖ وَمَن كَفَرَ فَإِنَّ ٱللَّهَ غَنِيٌّ حَمِيدٞ",
    translation:
      'And We had certainly given Luqman wisdom [and said], "Be grateful to Allah." And whoever is grateful is grateful for [the benefit of] himself. And whoever denies [His favor] - then indeed, Allah is Free of need and Praiseworthy',
    normalizedText:
      "ولقد ءاتينا لقمن الحكمة ان اشكر لله ومن يشكر فانما يشكر لنفسه ومن كفر فان الله غني حميد",
  },
  {
    verseId: 12,
    name: "لقمان",
    surahId: 31,
    text: "وَإِذۡ قَالَ لُقۡمَٰنُ لِٱبۡنِهِۦ وَهُوَ يَعِظُهُۥ يَٰبُنَيَّ لَا تُشۡرِكۡ بِٱللَّهِۖ إِنَّ ٱلشِّرۡكَ لَظُلۡمٌ عَظِيمٞ",
    translation:
      'And [mention, O Muhammad], when Luqman said to his son while he was instructing him, "O my son, do not associate [anything] with Allah. Indeed, association [with him] is great injustice',
    normalizedText:
      "واذ قال لقمن لابنه وهو يعظه يبني لا تشرك بالله ان الشرك لظلم عظيم",
  },
  {
    verseId: 13,
    name: "لقمان",
    surahId: 31,
    text: "وَوَصَّيۡنَا ٱلۡإِنسَٰنَ بِوَٰلِدَيۡهِ حَمَلَتۡهُ أُمُّهُۥ وَهۡنًا عَلَىٰ وَهۡنٖ وَفِصَٰلُهُۥ فِي عَامَيۡنِ أَنِ ٱشۡكُرۡ لِي وَلِوَٰلِدَيۡكَ إِلَيَّ ٱلۡمَصِيرُ",
    translation:
      "And We have enjoined upon man [care] for his parents. His mother carried him, [increasing her] in weakness upon weakness, and his weaning is in two years. Be grateful to Me and to your parents; to Me is the [final] destination",
    normalizedText:
      "ووصينا الانسن بولديه حملته امه وهنا على وهن وفصله في عامين ان اشكر لي ولولديك الي المصير",
  },
  {
    verseId: 14,
    name: "لقمان",
    surahId: 31,
    text: "وَإِن جَٰهَدَاكَ عَلَىٰٓ أَن تُشۡرِكَ بِي مَا لَيۡسَ لَكَ بِهِۦ عِلۡمٞ فَلَا تُطِعۡهُمَاۖ وَصَاحِبۡهُمَا فِي ٱلدُّنۡيَا مَعۡرُوفٗاۖ وَٱتَّبِعۡ سَبِيلَ مَنۡ أَنَابَ إِلَيَّۚ ثُمَّ إِلَيَّ مَرۡجِعُكُمۡ فَأُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "But if they endeavor to make you associate with Me that of which you have no knowledge, do not obey them but accompany them in [this] world with appropriate kindness and follow the way of those who turn back to Me [in repentance]. Then to Me will be your return, and I will inform you about what you used to do",
    normalizedText:
      "وان جهداك على ان تشرك بي ما ليس لك به علم فلا تطعهما وصاحبهما في الدنيا معروفا واتبع سبيل من اناب الي ثم الي مرجعكم فانباكم بما كنتم تعملون",
  },
  {
    verseId: 15,
    name: "لقمان",
    surahId: 31,
    text: "يَٰبُنَيَّ إِنَّهَآ إِن تَكُ مِثۡقَالَ حَبَّةٖ مِّنۡ خَرۡدَلٖ فَتَكُن فِي صَخۡرَةٍ أَوۡ فِي ٱلسَّمَٰوَٰتِ أَوۡ فِي ٱلۡأَرۡضِ يَأۡتِ بِهَا ٱللَّهُۚ إِنَّ ٱللَّهَ لَطِيفٌ خَبِيرٞ",
    translation:
      '[And Luqman said], "O my son, indeed if wrong should be the weight of a mustard seed and should be within a rock or [anywhere] in the heavens or in the earth, Allah will bring it forth. Indeed, Allah is Subtle and Acquainted',
    normalizedText:
      "يبني انها ان تك مثقال حبة من خردل فتكن في صخرة او في السموت او في الارض يات بها الله ان الله لطيف خبير",
  },
  {
    verseId: 16,
    name: "لقمان",
    surahId: 31,
    text: "يَٰبُنَيَّ أَقِمِ ٱلصَّلَوٰةَ وَأۡمُرۡ بِٱلۡمَعۡرُوفِ وَٱنۡهَ عَنِ ٱلۡمُنكَرِ وَٱصۡبِرۡ عَلَىٰ مَآ أَصَابَكَۖ إِنَّ ذَٰلِكَ مِنۡ عَزۡمِ ٱلۡأُمُورِ",
    translation:
      "O my son, establish prayer, enjoin what is right, forbid what is wrong, and be patient over what befalls you. Indeed, [all] that is of the matters [requiring] determination",
    normalizedText:
      "يبني اقم الصلوة وامر بالمعروف وانه عن المنكر واصبر على ما اصابك ان ذلك من عزم الامور",
  },
  {
    verseId: 17,
    name: "لقمان",
    surahId: 31,
    text: "وَلَا تُصَعِّرۡ خَدَّكَ لِلنَّاسِ وَلَا تَمۡشِ فِي ٱلۡأَرۡضِ مَرَحًاۖ إِنَّ ٱللَّهَ لَا يُحِبُّ كُلَّ مُخۡتَالٖ فَخُورٖ",
    translation:
      "And do not turn your cheek [in contempt] toward people and do not walk through the earth exultantly. Indeed, Allah does not like everyone self-deluded and boastful",
    normalizedText:
      "ولا تصعر خدك للناس ولا تمش في الارض مرحا ان الله لا يحب كل مختال فخور",
  },
  {
    verseId: 18,
    name: "لقمان",
    surahId: 31,
    text: "وَٱقۡصِدۡ فِي مَشۡيِكَ وَٱغۡضُضۡ مِن صَوۡتِكَۚ إِنَّ أَنكَرَ ٱلۡأَصۡوَٰتِ لَصَوۡتُ ٱلۡحَمِيرِ",
    translation:
      "And be moderate in your pace and lower your voice; indeed, the most disagreeable of sounds is the voice of donkeys",
    normalizedText: "واقصد في مشيك واغضض من صوتك ان انكر الاصوت لصوت الحمير",
  },
  {
    verseId: 19,
    name: "لقمان",
    surahId: 31,
    text: "أَلَمۡ تَرَوۡاْ أَنَّ ٱللَّهَ سَخَّرَ لَكُم مَّا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ وَأَسۡبَغَ عَلَيۡكُمۡ نِعَمَهُۥ ظَٰهِرَةٗ وَبَاطِنَةٗۗ وَمِنَ ٱلنَّاسِ مَن يُجَٰدِلُ فِي ٱللَّهِ بِغَيۡرِ عِلۡمٖ وَلَا هُدٗى وَلَا كِتَٰبٖ مُّنِيرٖ",
    translation:
      "Do you not see that Allah has made subject to you whatever is in the heavens and whatever is in the earth and amply bestowed upon you His favors, [both] apparent and unapparent? But of the people is he who disputes about Allah without knowledge or guidance or an enlightening Book [from Him]",
    normalizedText:
      "الم تروا ان الله سخر لكم ما في السموت وما في الارض واسبغ عليكم نعمه ظهرة وباطنة ومن الناس من يجدل في الله بغير علم ولا هدى ولا كتب منير",
  },
  {
    verseId: 20,
    name: "لقمان",
    surahId: 31,
    text: "وَإِذَا قِيلَ لَهُمُ ٱتَّبِعُواْ مَآ أَنزَلَ ٱللَّهُ قَالُواْ بَلۡ نَتَّبِعُ مَا وَجَدۡنَا عَلَيۡهِ ءَابَآءَنَآۚ أَوَلَوۡ كَانَ ٱلشَّيۡطَٰنُ يَدۡعُوهُمۡ إِلَىٰ عَذَابِ ٱلسَّعِيرِ",
    translation:
      'And when it is said to them, "Follow what Allah has revealed," they say, "Rather, we will follow that upon which we found our fathers." Even if Satan was inviting them to the punishment of the Blaze',
    normalizedText:
      "واذا قيل لهم اتبعوا ما انزل الله قالوا بل نتبع ما وجدنا عليه ءاباءنا اولو كان الشيطن يدعوهم الى عذاب السعير",
  },
  {
    verseId: 21,
    name: "لقمان",
    surahId: 31,
    text: "۞وَمَن يُسۡلِمۡ وَجۡهَهُۥٓ إِلَى ٱللَّهِ وَهُوَ مُحۡسِنٞ فَقَدِ ٱسۡتَمۡسَكَ بِٱلۡعُرۡوَةِ ٱلۡوُثۡقَىٰۗ وَإِلَى ٱللَّهِ عَٰقِبَةُ ٱلۡأُمُورِ",
    translation:
      "And whoever submits his face to Allah while he is a doer of good - then he has grasped the most trustworthy handhold. And to Allah will be the outcome of [all] matters",
    normalizedText:
      "۞ومن يسلم وجهه الى الله وهو محسن فقد استمسك بالعروة الوثقى والى الله عقبة الامور",
  },
  {
    verseId: 22,
    name: "لقمان",
    surahId: 31,
    text: "وَمَن كَفَرَ فَلَا يَحۡزُنكَ كُفۡرُهُۥٓۚ إِلَيۡنَا مَرۡجِعُهُمۡ فَنُنَبِّئُهُم بِمَا عَمِلُوٓاْۚ إِنَّ ٱللَّهَ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "And whoever has disbelieved - let not his disbelief grieve you. To Us is their return, and We will inform them of what they did. Indeed, Allah is Knowing of that within the breasts",
    normalizedText:
      "ومن كفر فلا يحزنك كفره الينا مرجعهم فننباهم بما عملوا ان الله عليم بذات الصدور",
  },
  {
    verseId: 23,
    name: "لقمان",
    surahId: 31,
    text: "نُمَتِّعُهُمۡ قَلِيلٗا ثُمَّ نَضۡطَرُّهُمۡ إِلَىٰ عَذَابٍ غَلِيظٖ",
    translation:
      "We grant them enjoyment for a little; then We will force them to a massive punishment",
    normalizedText: "نمتعهم قليلا ثم نضطرهم الى عذاب غليظ",
  },
  {
    verseId: 24,
    name: "لقمان",
    surahId: 31,
    text: "وَلَئِن سَأَلۡتَهُم مَّنۡ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ لَيَقُولُنَّ ٱللَّهُۚ قُلِ ٱلۡحَمۡدُ لِلَّهِۚ بَلۡ أَكۡثَرُهُمۡ لَا يَعۡلَمُونَ",
    translation:
      'And if you asked them, "Who created the heavens and earth?" they would surely say, "Allah." Say, "[All] praise is [due] to Allah "; but most of them do not know',
    normalizedText:
      "ولان سالتهم من خلق السموت والارض ليقولن الله قل الحمد لله بل اكثرهم لا يعلمون",
  },
  {
    verseId: 25,
    name: "لقمان",
    surahId: 31,
    text: "لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ إِنَّ ٱللَّهَ هُوَ ٱلۡغَنِيُّ ٱلۡحَمِيدُ",
    translation:
      "To Allah belongs whatever is in the heavens and earth. Indeed, Allah is the Free of need, the Praiseworthy",
    normalizedText: "لله ما في السموت والارض ان الله هو الغني الحميد",
  },
  {
    verseId: 26,
    name: "لقمان",
    surahId: 31,
    text: "وَلَوۡ أَنَّمَا فِي ٱلۡأَرۡضِ مِن شَجَرَةٍ أَقۡلَٰمٞ وَٱلۡبَحۡرُ يَمُدُّهُۥ مِنۢ بَعۡدِهِۦ سَبۡعَةُ أَبۡحُرٖ مَّا نَفِدَتۡ كَلِمَٰتُ ٱللَّهِۚ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٞ",
    translation:
      "And if whatever trees upon the earth were pens and the sea [was ink], replenished thereafter by seven [more] seas, the words of Allah would not be exhausted. Indeed, Allah is Exalted in Might and Wise",
    normalizedText:
      "ولو انما في الارض من شجرة اقلم والبحر يمده من بعده سبعة ابحر ما نفدت كلمت الله ان الله عزيز حكيم",
  },
  {
    verseId: 27,
    name: "لقمان",
    surahId: 31,
    text: "مَّا خَلۡقُكُمۡ وَلَا بَعۡثُكُمۡ إِلَّا كَنَفۡسٖ وَٰحِدَةٍۚ إِنَّ ٱللَّهَ سَمِيعُۢ بَصِيرٌ",
    translation:
      "Your creation and your resurrection will not be but as that of a single soul. Indeed, Allah is Hearing and Seeing",
    normalizedText: "ما خلقكم ولا بعثكم الا كنفس وحدة ان الله سميع بصير",
  },
  {
    verseId: 28,
    name: "لقمان",
    surahId: 31,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ يُولِجُ ٱلَّيۡلَ فِي ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِي ٱلَّيۡلِ وَسَخَّرَ ٱلشَّمۡسَ وَٱلۡقَمَرَۖ كُلّٞ يَجۡرِيٓ إِلَىٰٓ أَجَلٖ مُّسَمّٗى وَأَنَّ ٱللَّهَ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      "Do you not see that Allah causes the night to enter the day and causes the day to enter the night and has subjected the sun and the moon, each running [its course] for a specified term, and that Allah, with whatever you do, is Acquainted",
    normalizedText:
      "الم تر ان الله يولج اليل في النهار ويولج النهار في اليل وسخر الشمس والقمر كل يجري الى اجل مسمى وان الله بما تعملون خبير",
  },
  {
    verseId: 29,
    name: "لقمان",
    surahId: 31,
    text: "ذَٰلِكَ بِأَنَّ ٱللَّهَ هُوَ ٱلۡحَقُّ وَأَنَّ مَا يَدۡعُونَ مِن دُونِهِ ٱلۡبَٰطِلُ وَأَنَّ ٱللَّهَ هُوَ ٱلۡعَلِيُّ ٱلۡكَبِيرُ",
    translation:
      "That is because Allah is the Truth, and that what they call upon other than Him is falsehood, and because Allah is the Most High, the Grand",
    normalizedText:
      "ذلك بان الله هو الحق وان ما يدعون من دونه البطل وان الله هو العلي الكبير",
  },
  {
    verseId: 30,
    name: "لقمان",
    surahId: 31,
    text: "أَلَمۡ تَرَ أَنَّ ٱلۡفُلۡكَ تَجۡرِي فِي ٱلۡبَحۡرِ بِنِعۡمَتِ ٱللَّهِ لِيُرِيَكُم مِّنۡ ءَايَٰتِهِۦٓۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّكُلِّ صَبَّارٖ شَكُورٖ",
    translation:
      "Do you not see that ships sail through the sea by the favor of Allah that He may show you of His signs? Indeed in that are signs for everyone patient and grateful",
    normalizedText:
      "الم تر ان الفلك تجري في البحر بنعمت الله ليريكم من ءايته ان في ذلك لايت لكل صبار شكور",
  },
  {
    verseId: 31,
    name: "لقمان",
    surahId: 31,
    text: "وَإِذَا غَشِيَهُم مَّوۡجٞ كَٱلظُّلَلِ دَعَوُاْ ٱللَّهَ مُخۡلِصِينَ لَهُ ٱلدِّينَ فَلَمَّا نَجَّىٰهُمۡ إِلَى ٱلۡبَرِّ فَمِنۡهُم مُّقۡتَصِدٞۚ وَمَا يَجۡحَدُ بِـَٔايَٰتِنَآ إِلَّا كُلُّ خَتَّارٖ كَفُورٖ",
    translation:
      "And when waves come over them like canopies, they supplicate Allah, sincere to Him in religion. But when He delivers them to the land, there are [some] of them who are moderate [in faith]. And none rejects Our signs except everyone treacherous and ungrateful",
    normalizedText:
      "واذا غشيهم موج كالظلل دعوا الله مخلصين له الدين فلما نجىهم الى البر فمنهم مقتصد وما يجحد بايتنا الا كل ختار كفور",
  },
  {
    verseId: 32,
    name: "لقمان",
    surahId: 31,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُواْ رَبَّكُمۡ وَٱخۡشَوۡاْ يَوۡمٗا لَّا يَجۡزِي وَالِدٌ عَن وَلَدِهِۦ وَلَا مَوۡلُودٌ هُوَ جَازٍ عَن وَالِدِهِۦ شَيۡـًٔاۚ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞۖ فَلَا تَغُرَّنَّكُمُ ٱلۡحَيَوٰةُ ٱلدُّنۡيَا وَلَا يَغُرَّنَّكُم بِٱللَّهِ ٱلۡغَرُورُ",
    translation:
      "O mankind, fear your Lord and fear a Day when no father will avail his son, nor will a son avail his father at all. Indeed, the promise of Allah is truth, so let not the worldly life delude you and be not deceived about Allah by the Deceiver",
    normalizedText:
      "يايها الناس اتقوا ربكم واخشوا يوما لا يجزي والد عن ولده ولا مولود هو جاز عن والده شيا ان وعد الله حق فلا تغرنكم الحيوة الدنيا ولا يغرنكم بالله الغرور",
  },
  {
    verseId: 33,
    name: "لقمان",
    surahId: 31,
    text: "إِنَّ ٱللَّهَ عِندَهُۥ عِلۡمُ ٱلسَّاعَةِ وَيُنَزِّلُ ٱلۡغَيۡثَ وَيَعۡلَمُ مَا فِي ٱلۡأَرۡحَامِۖ وَمَا تَدۡرِي نَفۡسٞ مَّاذَا تَكۡسِبُ غَدٗاۖ وَمَا تَدۡرِي نَفۡسُۢ بِأَيِّ أَرۡضٖ تَمُوتُۚ إِنَّ ٱللَّهَ عَلِيمٌ خَبِيرُۢ",
    translation:
      "Indeed, Allah [alone] has knowledge of the Hour and sends down the rain and knows what is in the wombs. And no soul perceives what it will earn tomorrow, and no soul perceives in what land it will die. Indeed, Allah is Knowing and Acquainted",
    normalizedText:
      "ان الله عنده علم الساعة وينزل الغيث ويعلم ما في الارحام وما تدري نفس ماذا تكسب غدا وما تدري نفس باي ارض تموت ان الله عليم خبير",
  },
  {
    verseId: 0,
    name: "السجدة",
    surahId: 32,
    text: "الٓمٓ",
    translation: "Alif, Lam, Meem",
    normalizedText: "الم",
  },
  {
    verseId: 1,
    name: "السجدة",
    surahId: 32,
    text: "تَنزِيلُ ٱلۡكِتَٰبِ لَا رَيۡبَ فِيهِ مِن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "[This is] the revelation of the Book about which there is no doubt from the Lord of the worlds",
    normalizedText: "تنزيل الكتب لا ريب فيه من رب العلمين",
  },
  {
    verseId: 2,
    name: "السجدة",
    surahId: 32,
    text: "أَمۡ يَقُولُونَ ٱفۡتَرَىٰهُۚ بَلۡ هُوَ ٱلۡحَقُّ مِن رَّبِّكَ لِتُنذِرَ قَوۡمٗا مَّآ أَتَىٰهُم مِّن نَّذِيرٖ مِّن قَبۡلِكَ لَعَلَّهُمۡ يَهۡتَدُونَ",
    translation:
      'Or do they say, "He invented it"? Rather, it is the truth from your Lord, [O Muhammad], that you may warn a people to whom no warner has come before you [so] perhaps they will be guided',
    normalizedText:
      "ام يقولون افترىه بل هو الحق من ربك لتنذر قوما ما اتىهم من نذير من قبلك لعلهم يهتدون",
  },
  {
    verseId: 3,
    name: "السجدة",
    surahId: 32,
    text: "ٱللَّهُ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَا فِي سِتَّةِ أَيَّامٖ ثُمَّ ٱسۡتَوَىٰ عَلَى ٱلۡعَرۡشِۖ مَا لَكُم مِّن دُونِهِۦ مِن وَلِيّٖ وَلَا شَفِيعٍۚ أَفَلَا تَتَذَكَّرُونَ",
    translation:
      "It is Allah who created the heavens and the earth and whatever is between them in six days; then He established Himself above the Throne. You have not besides Him any protector or any intercessor; so will you not be reminded",
    normalizedText:
      "الله الذي خلق السموت والارض وما بينهما في ستة ايام ثم استوى على العرش ما لكم من دونه من ولي ولا شفيع افلا تتذكرون",
  },
  {
    verseId: 4,
    name: "السجدة",
    surahId: 32,
    text: "يُدَبِّرُ ٱلۡأَمۡرَ مِنَ ٱلسَّمَآءِ إِلَى ٱلۡأَرۡضِ ثُمَّ يَعۡرُجُ إِلَيۡهِ فِي يَوۡمٖ كَانَ مِقۡدَارُهُۥٓ أَلۡفَ سَنَةٖ مِّمَّا تَعُدُّونَ",
    translation:
      "He arranges [each] matter from the heaven to the earth; then it will ascend to Him in a Day, the extent of which is a thousand years of those which you count",
    normalizedText:
      "يدبر الامر من السماء الى الارض ثم يعرج اليه في يوم كان مقداره الف سنة مما تعدون",
  },
  {
    verseId: 5,
    name: "السجدة",
    surahId: 32,
    text: "ذَٰلِكَ عَٰلِمُ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "That is the Knower of the unseen and the witnessed, the Exalted in Might, the Merciful",
    normalizedText: "ذلك علم الغيب والشهدة العزيز الرحيم",
  },
  {
    verseId: 6,
    name: "السجدة",
    surahId: 32,
    text: "ٱلَّذِيٓ أَحۡسَنَ كُلَّ شَيۡءٍ خَلَقَهُۥۖ وَبَدَأَ خَلۡقَ ٱلۡإِنسَٰنِ مِن طِينٖ",
    translation:
      "Who perfected everything which He created and began the creation of man from clay",
    normalizedText: "الذي احسن كل شيء خلقه وبدا خلق الانسن من طين",
  },
  {
    verseId: 7,
    name: "السجدة",
    surahId: 32,
    text: "ثُمَّ جَعَلَ نَسۡلَهُۥ مِن سُلَٰلَةٖ مِّن مَّآءٖ مَّهِينٖ",
    translation:
      "Then He made his posterity out of the extract of a liquid disdained",
    normalizedText: "ثم جعل نسله من سللة من ماء مهين",
  },
  {
    verseId: 8,
    name: "السجدة",
    surahId: 32,
    text: "ثُمَّ سَوَّىٰهُ وَنَفَخَ فِيهِ مِن رُّوحِهِۦۖ وَجَعَلَ لَكُمُ ٱلسَّمۡعَ وَٱلۡأَبۡصَٰرَ وَٱلۡأَفۡـِٔدَةَۚ قَلِيلٗا مَّا تَشۡكُرُونَ",
    translation:
      "Then He proportioned him and breathed into him from His [created] soul and made for you hearing and vision and hearts; little are you grateful",
    normalizedText:
      "ثم سوىه ونفخ فيه من روحه وجعل لكم السمع والابصر والافدة قليلا ما تشكرون",
  },
  {
    verseId: 9,
    name: "السجدة",
    surahId: 32,
    text: "وَقَالُوٓاْ أَءِذَا ضَلَلۡنَا فِي ٱلۡأَرۡضِ أَءِنَّا لَفِي خَلۡقٖ جَدِيدِۭۚ بَلۡ هُم بِلِقَآءِ رَبِّهِمۡ كَٰفِرُونَ",
    translation:
      'And they say, "When we are lost within the earth, will we indeed be [recreated] in a new creation?" Rather, they are, in [the matter of] the meeting with their Lord, disbelievers',
    normalizedText:
      "وقالوا اءذا ضللنا في الارض اءنا لفي خلق جديد بل هم بلقاء ربهم كفرون",
  },
  {
    verseId: 10,
    name: "السجدة",
    surahId: 32,
    text: "۞قُلۡ يَتَوَفَّىٰكُم مَّلَكُ ٱلۡمَوۡتِ ٱلَّذِي وُكِّلَ بِكُمۡ ثُمَّ إِلَىٰ رَبِّكُمۡ تُرۡجَعُونَ",
    translation:
      'Say, "The angel of death will take you who has been entrusted with you. Then to your Lord you will be returned',
    normalizedText: "۞قل يتوفىكم ملك الموت الذي وكل بكم ثم الى ربكم ترجعون",
  },
  {
    verseId: 11,
    name: "السجدة",
    surahId: 32,
    text: "وَلَوۡ تَرَىٰٓ إِذِ ٱلۡمُجۡرِمُونَ نَاكِسُواْ رُءُوسِهِمۡ عِندَ رَبِّهِمۡ رَبَّنَآ أَبۡصَرۡنَا وَسَمِعۡنَا فَٱرۡجِعۡنَا نَعۡمَلۡ صَٰلِحًا إِنَّا مُوقِنُونَ",
    translation:
      'If you could but see when the criminals are hanging their heads before their Lord, [saying], "Our Lord, we have seen and heard, so return us [to the world]; we will work righteousness. Indeed, we are [now] certain',
    normalizedText:
      "ولو ترى اذ المجرمون ناكسوا رءوسهم عند ربهم ربنا ابصرنا وسمعنا فارجعنا نعمل صلحا انا موقنون",
  },
  {
    verseId: 12,
    name: "السجدة",
    surahId: 32,
    text: "وَلَوۡ شِئۡنَا لَأٓتَيۡنَا كُلَّ نَفۡسٍ هُدَىٰهَا وَلَٰكِنۡ حَقَّ ٱلۡقَوۡلُ مِنِّي لَأَمۡلَأَنَّ جَهَنَّمَ مِنَ ٱلۡجِنَّةِ وَٱلنَّاسِ أَجۡمَعِينَ",
    translation:
      'And if We had willed, We could have given every soul its guidance, but the word from Me will come into effect [that] "I will surely fill Hell with jinn and people all together',
    normalizedText:
      "ولو شانا لاتينا كل نفس هدىها ولكن حق القول مني لاملان جهنم من الجنة والناس اجمعين",
  },
  {
    verseId: 13,
    name: "السجدة",
    surahId: 32,
    text: "فَذُوقُواْ بِمَا نَسِيتُمۡ لِقَآءَ يَوۡمِكُمۡ هَٰذَآ إِنَّا نَسِينَٰكُمۡۖ وَذُوقُواْ عَذَابَ ٱلۡخُلۡدِ بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "So taste [punishment] because you forgot the meeting of this, your Day; indeed, We have [accordingly] forgotten you. And taste the punishment of eternity for what you used to do",
    normalizedText:
      "فذوقوا بما نسيتم لقاء يومكم هذا انا نسينكم وذوقوا عذاب الخلد بما كنتم تعملون",
  },
  {
    verseId: 14,
    name: "السجدة",
    surahId: 32,
    text: "إِنَّمَا يُؤۡمِنُ بِـَٔايَٰتِنَا ٱلَّذِينَ إِذَا ذُكِّرُواْ بِهَا خَرُّواْۤ سُجَّدٗاۤ وَسَبَّحُواْ بِحَمۡدِ رَبِّهِمۡ وَهُمۡ لَا يَسۡتَكۡبِرُونَ۩",
    translation:
      "Only those believe in Our verses who, when they are reminded by them, fall down in prostration and exalt [Allah] with praise of their Lord, and they are not arrogant",
    normalizedText:
      "انما يامن بايتنا الذين اذا ذكروا بها خروا سجدا وسبحوا بحمد ربهم وهم لا يستكبرون۩",
  },
  {
    verseId: 15,
    name: "السجدة",
    surahId: 32,
    text: "تَتَجَافَىٰ جُنُوبُهُمۡ عَنِ ٱلۡمَضَاجِعِ يَدۡعُونَ رَبَّهُمۡ خَوۡفٗا وَطَمَعٗا وَمِمَّا رَزَقۡنَٰهُمۡ يُنفِقُونَ",
    translation:
      "They arise from [their] beds; they supplicate their Lord in fear and aspiration, and from what We have provided them, they spend",
    normalizedText:
      "تتجافى جنوبهم عن المضاجع يدعون ربهم خوفا وطمعا ومما رزقنهم ينفقون",
  },
  {
    verseId: 16,
    name: "السجدة",
    surahId: 32,
    text: "فَلَا تَعۡلَمُ نَفۡسٞ مَّآ أُخۡفِيَ لَهُم مِّن قُرَّةِ أَعۡيُنٖ جَزَآءَۢ بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "And no soul knows what has been hidden for them of comfort for eyes as reward for what they used to do",
    normalizedText:
      "فلا تعلم نفس ما اخفي لهم من قرة اعين جزاء بما كانوا يعملون",
  },
  {
    verseId: 17,
    name: "السجدة",
    surahId: 32,
    text: "أَفَمَن كَانَ مُؤۡمِنٗا كَمَن كَانَ فَاسِقٗاۚ لَّا يَسۡتَوُۥنَ",
    translation:
      "Then is one who was a believer like one who was defiantly disobedient? They are not equal",
    normalizedText: "افمن كان مامنا كمن كان فاسقا لا يستون",
  },
  {
    verseId: 18,
    name: "السجدة",
    surahId: 32,
    text: "أَمَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فَلَهُمۡ جَنَّـٰتُ ٱلۡمَأۡوَىٰ نُزُلَۢا بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "As for those who believed and did righteous deeds, for them will be the Gardens of Refuge as accommodation for what they used to do",
    normalizedText:
      "اما الذين ءامنوا وعملوا الصلحت فلهم جنت الماوى نزلا بما كانوا يعملون",
  },
  {
    verseId: 19,
    name: "السجدة",
    surahId: 32,
    text: "وَأَمَّا ٱلَّذِينَ فَسَقُواْ فَمَأۡوَىٰهُمُ ٱلنَّارُۖ كُلَّمَآ أَرَادُوٓاْ أَن يَخۡرُجُواْ مِنۡهَآ أُعِيدُواْ فِيهَا وَقِيلَ لَهُمۡ ذُوقُواْ عَذَابَ ٱلنَّارِ ٱلَّذِي كُنتُم بِهِۦ تُكَذِّبُونَ",
    translation:
      'But as for those who defiantly disobeyed, their refuge is the Fire. Every time they wish to emerge from it, they will be returned to it while it is said to them, "Taste the punishment of the Fire which you used to deny',
    normalizedText:
      "واما الذين فسقوا فماوىهم النار كلما ارادوا ان يخرجوا منها اعيدوا فيها وقيل لهم ذوقوا عذاب النار الذي كنتم به تكذبون",
  },
  {
    verseId: 20,
    name: "السجدة",
    surahId: 32,
    text: "وَلَنُذِيقَنَّهُم مِّنَ ٱلۡعَذَابِ ٱلۡأَدۡنَىٰ دُونَ ٱلۡعَذَابِ ٱلۡأَكۡبَرِ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      "And we will surely let them taste the nearer punishment short of the greater punishment that perhaps they will repent",
    normalizedText: "ولنذيقنهم من العذاب الادنى دون العذاب الاكبر لعلهم يرجعون",
  },
  {
    verseId: 21,
    name: "السجدة",
    surahId: 32,
    text: "وَمَنۡ أَظۡلَمُ مِمَّن ذُكِّرَ بِـَٔايَٰتِ رَبِّهِۦ ثُمَّ أَعۡرَضَ عَنۡهَآۚ إِنَّا مِنَ ٱلۡمُجۡرِمِينَ مُنتَقِمُونَ",
    translation:
      "And who is more unjust than one who is reminded of the verses of his Lord; then he turns away from them? Indeed We, from the criminals, will take retribution",
    normalizedText:
      "ومن اظلم ممن ذكر بايت ربه ثم اعرض عنها انا من المجرمين منتقمون",
  },
  {
    verseId: 22,
    name: "السجدة",
    surahId: 32,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ فَلَا تَكُن فِي مِرۡيَةٖ مِّن لِّقَآئِهِۦۖ وَجَعَلۡنَٰهُ هُدٗى لِّبَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation:
      "And We certainly gave Moses the Scripture, so do not be in doubt over his meeting. And we made the Torah guidance for the Children of Israel",
    normalizedText:
      "ولقد ءاتينا موسى الكتب فلا تكن في مرية من لقااه وجعلنه هدى لبني اسرءيل",
  },
  {
    verseId: 23,
    name: "السجدة",
    surahId: 32,
    text: "وَجَعَلۡنَا مِنۡهُمۡ أَئِمَّةٗ يَهۡدُونَ بِأَمۡرِنَا لَمَّا صَبَرُواْۖ وَكَانُواْ بِـَٔايَٰتِنَا يُوقِنُونَ",
    translation:
      "And We made from among them leaders guiding by Our command when they were patient and [when] they were certain of Our signs",
    normalizedText:
      "وجعلنا منهم اامة يهدون بامرنا لما صبروا وكانوا بايتنا يوقنون",
  },
  {
    verseId: 24,
    name: "السجدة",
    surahId: 32,
    text: "إِنَّ رَبَّكَ هُوَ يَفۡصِلُ بَيۡنَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ فِيمَا كَانُواْ فِيهِ يَخۡتَلِفُونَ",
    translation:
      "Indeed, your Lord will judge between them on the Day of Resurrection concerning that over which they used to differ",
    normalizedText: "ان ربك هو يفصل بينهم يوم القيمة فيما كانوا فيه يختلفون",
  },
  {
    verseId: 25,
    name: "السجدة",
    surahId: 32,
    text: "أَوَلَمۡ يَهۡدِ لَهُمۡ كَمۡ أَهۡلَكۡنَا مِن قَبۡلِهِم مِّنَ ٱلۡقُرُونِ يَمۡشُونَ فِي مَسَٰكِنِهِمۡۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٍۚ أَفَلَا يَسۡمَعُونَ",
    translation:
      "Has it not become clear to them how many generations We destroyed before them, [as] they walk among their dwellings? Indeed in that are signs; then do they not hear",
    normalizedText:
      "اولم يهد لهم كم اهلكنا من قبلهم من القرون يمشون في مسكنهم ان في ذلك لايت افلا يسمعون",
  },
  {
    verseId: 26,
    name: "السجدة",
    surahId: 32,
    text: "أَوَلَمۡ يَرَوۡاْ أَنَّا نَسُوقُ ٱلۡمَآءَ إِلَى ٱلۡأَرۡضِ ٱلۡجُرُزِ فَنُخۡرِجُ بِهِۦ زَرۡعٗا تَأۡكُلُ مِنۡهُ أَنۡعَٰمُهُمۡ وَأَنفُسُهُمۡۚ أَفَلَا يُبۡصِرُونَ",
    translation:
      "Have they not seen that We drive the water [in clouds] to barren land and bring forth thereby crops from which their livestock eat and [they] themselves? Then do they not see",
    normalizedText:
      "اولم يروا انا نسوق الماء الى الارض الجرز فنخرج به زرعا تاكل منه انعمهم وانفسهم افلا يبصرون",
  },
  {
    verseId: 27,
    name: "السجدة",
    surahId: 32,
    text: "وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلۡفَتۡحُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "When will be this conquest, if you should be truthful',
    normalizedText: "ويقولون متى هذا الفتح ان كنتم صدقين",
  },
  {
    verseId: 28,
    name: "السجدة",
    surahId: 32,
    text: "قُلۡ يَوۡمَ ٱلۡفَتۡحِ لَا يَنفَعُ ٱلَّذِينَ كَفَرُوٓاْ إِيمَٰنُهُمۡ وَلَا هُمۡ يُنظَرُونَ",
    translation:
      'Say, [O Muhammad], "On the Day of Conquest the belief of those who had disbelieved will not benefit them, nor will they be reprieved',
    normalizedText: "قل يوم الفتح لا ينفع الذين كفروا ايمنهم ولا هم ينظرون",
  },
  {
    verseId: 29,
    name: "السجدة",
    surahId: 32,
    text: "فَأَعۡرِضۡ عَنۡهُمۡ وَٱنتَظِرۡ إِنَّهُم مُّنتَظِرُونَ",
    translation: "So turn away from them and wait. Indeed, they are waiting",
    normalizedText: "فاعرض عنهم وانتظر انهم منتظرون",
  },
  {
    verseId: 0,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ ٱتَّقِ ٱللَّهَ وَلَا تُطِعِ ٱلۡكَٰفِرِينَ وَٱلۡمُنَٰفِقِينَۚ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمٗا",
    translation:
      "O Prophet, fear Allah and do not obey the disbelievers and the hypocrites. Indeed, Allah is ever Knowing and Wise",
    normalizedText:
      "يايها النبي اتق الله ولا تطع الكفرين والمنفقين ان الله كان عليما حكيما",
  },
  {
    verseId: 1,
    name: "الأحزاب",
    surahId: 33,
    text: "وَٱتَّبِعۡ مَا يُوحَىٰٓ إِلَيۡكَ مِن رَّبِّكَۚ إِنَّ ٱللَّهَ كَانَ بِمَا تَعۡمَلُونَ خَبِيرٗا",
    translation:
      "And follow that which is revealed to you from your Lord. Indeed Allah is ever, with what you do, Acquainted",
    normalizedText: "واتبع ما يوحى اليك من ربك ان الله كان بما تعملون خبيرا",
  },
  {
    verseId: 2,
    name: "الأحزاب",
    surahId: 33,
    text: "وَتَوَكَّلۡ عَلَى ٱللَّهِۚ وَكَفَىٰ بِٱللَّهِ وَكِيلٗا",
    translation:
      "And rely upon Allah; and sufficient is Allah as Disposer of affairs",
    normalizedText: "وتوكل على الله وكفى بالله وكيلا",
  },
  {
    verseId: 3,
    name: "الأحزاب",
    surahId: 33,
    text: "مَّا جَعَلَ ٱللَّهُ لِرَجُلٖ مِّن قَلۡبَيۡنِ فِي جَوۡفِهِۦۚ وَمَا جَعَلَ أَزۡوَٰجَكُمُ ٱلَّـٰٓـِٔي تُظَٰهِرُونَ مِنۡهُنَّ أُمَّهَٰتِكُمۡۚ وَمَا جَعَلَ أَدۡعِيَآءَكُمۡ أَبۡنَآءَكُمۡۚ ذَٰلِكُمۡ قَوۡلُكُم بِأَفۡوَٰهِكُمۡۖ وَٱللَّهُ يَقُولُ ٱلۡحَقَّ وَهُوَ يَهۡدِي ٱلسَّبِيلَ",
    translation:
      "Allah has not made for a man two hearts in his interior. And He has not made your wives whom you declare unlawful your mothers. And he has not made your adopted sons your [true] sons. That is [merely] your saying by your mouths, but Allah says the truth, and He guides to the [right] way",
    normalizedText:
      "ما جعل الله لرجل من قلبين في جوفه وما جعل ازوجكم الي تظهرون منهن امهتكم وما جعل ادعياءكم ابناءكم ذلكم قولكم بافوهكم والله يقول الحق وهو يهدي السبيل",
  },
  {
    verseId: 4,
    name: "الأحزاب",
    surahId: 33,
    text: "ٱدۡعُوهُمۡ لِأٓبَآئِهِمۡ هُوَ أَقۡسَطُ عِندَ ٱللَّهِۚ فَإِن لَّمۡ تَعۡلَمُوٓاْ ءَابَآءَهُمۡ فَإِخۡوَٰنُكُمۡ فِي ٱلدِّينِ وَمَوَٰلِيكُمۡۚ وَلَيۡسَ عَلَيۡكُمۡ جُنَاحٞ فِيمَآ أَخۡطَأۡتُم بِهِۦ وَلَٰكِن مَّا تَعَمَّدَتۡ قُلُوبُكُمۡۚ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمًا",
    translation:
      "Call them by [the names of] their fathers; it is more just in the sight of Allah. But if you do not know their fathers - then they are [still] your brothers in religion and those entrusted to you. And there is no blame upon you for that in which you have erred but [only for] what your hearts intended. And ever is Allah Forgiving and Merciful",
    normalizedText:
      "ادعوهم لابااهم هو اقسط عند الله فان لم تعلموا ءاباءهم فاخونكم في الدين وموليكم وليس عليكم جناح فيما اخطاتم به ولكن ما تعمدت قلوبكم وكان الله غفورا رحيما",
  },
  {
    verseId: 5,
    name: "الأحزاب",
    surahId: 33,
    text: "ٱلنَّبِيُّ أَوۡلَىٰ بِٱلۡمُؤۡمِنِينَ مِنۡ أَنفُسِهِمۡۖ وَأَزۡوَٰجُهُۥٓ أُمَّهَٰتُهُمۡۗ وَأُوْلُواْ ٱلۡأَرۡحَامِ بَعۡضُهُمۡ أَوۡلَىٰ بِبَعۡضٖ فِي كِتَٰبِ ٱللَّهِ مِنَ ٱلۡمُؤۡمِنِينَ وَٱلۡمُهَٰجِرِينَ إِلَّآ أَن تَفۡعَلُوٓاْ إِلَىٰٓ أَوۡلِيَآئِكُم مَّعۡرُوفٗاۚ كَانَ ذَٰلِكَ فِي ٱلۡكِتَٰبِ مَسۡطُورٗا",
    translation:
      "The Prophet is more worthy of the believers than themselves, and his wives are [in the position of] their mothers. And those of [blood] relationship are more entitled [to inheritance] in the decree of Allah than the [other] believers and the emigrants, except that you may do to your close associates a kindness [through bequest]. That was in the Book inscribed",
    normalizedText:
      "النبي اولى بالمامنين من انفسهم وازوجه امهتهم واولوا الارحام بعضهم اولى ببعض في كتب الله من المامنين والمهجرين الا ان تفعلوا الى اوليااكم معروفا كان ذلك في الكتب مسطورا",
  },
  {
    verseId: 6,
    name: "الأحزاب",
    surahId: 33,
    text: "وَإِذۡ أَخَذۡنَا مِنَ ٱلنَّبِيِّـۧنَ مِيثَٰقَهُمۡ وَمِنكَ وَمِن نُّوحٖ وَإِبۡرَٰهِيمَ وَمُوسَىٰ وَعِيسَى ٱبۡنِ مَرۡيَمَۖ وَأَخَذۡنَا مِنۡهُم مِّيثَٰقًا غَلِيظٗا",
    translation:
      "And [mention, O Muhammad], when We took from the prophets their covenant and from you and from Noah and Abraham and Moses and Jesus, the son of Mary; and We took from them a solemn covenant",
    normalizedText:
      "واذ اخذنا من النبين ميثقهم ومنك ومن نوح وابرهيم وموسى وعيسى ابن مريم واخذنا منهم ميثقا غليظا",
  },
  {
    verseId: 7,
    name: "الأحزاب",
    surahId: 33,
    text: "لِّيَسۡـَٔلَ ٱلصَّـٰدِقِينَ عَن صِدۡقِهِمۡۚ وَأَعَدَّ لِلۡكَٰفِرِينَ عَذَابًا أَلِيمٗا",
    translation:
      "That He may question the truthful about their truth. And He has prepared for the disbelievers a painful punishment",
    normalizedText: "ليسل الصدقين عن صدقهم واعد للكفرين عذابا اليما",
  },
  {
    verseId: 8,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱذۡكُرُواْ نِعۡمَةَ ٱللَّهِ عَلَيۡكُمۡ إِذۡ جَآءَتۡكُمۡ جُنُودٞ فَأَرۡسَلۡنَا عَلَيۡهِمۡ رِيحٗا وَجُنُودٗا لَّمۡ تَرَوۡهَاۚ وَكَانَ ٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرًا",
    translation:
      "O you who have believed, remember the favor of Allah upon you when armies came to [attack] you and We sent upon them a wind and armies [of angels] you did not see. And ever is Allah, of what you do, Seeing",
    normalizedText:
      "يايها الذين ءامنوا اذكروا نعمة الله عليكم اذ جاءتكم جنود فارسلنا عليهم ريحا وجنودا لم تروها وكان الله بما تعملون بصيرا",
  },
  {
    verseId: 9,
    name: "الأحزاب",
    surahId: 33,
    text: "إِذۡ جَآءُوكُم مِّن فَوۡقِكُمۡ وَمِنۡ أَسۡفَلَ مِنكُمۡ وَإِذۡ زَاغَتِ ٱلۡأَبۡصَٰرُ وَبَلَغَتِ ٱلۡقُلُوبُ ٱلۡحَنَاجِرَ وَتَظُنُّونَ بِٱللَّهِ ٱلظُّنُونَا۠",
    translation:
      "[Remember] when they came at you from above you and from below you, and when eyes shifted [in fear], and hearts reached the throats and you assumed about Allah [various] assumptions",
    normalizedText:
      "اذ جاءوكم من فوقكم ومن اسفل منكم واذ زاغت الابصر وبلغت القلوب الحناجر وتظنون بالله الظنونا",
  },
  {
    verseId: 10,
    name: "الأحزاب",
    surahId: 33,
    text: "هُنَالِكَ ٱبۡتُلِيَ ٱلۡمُؤۡمِنُونَ وَزُلۡزِلُواْ زِلۡزَالٗا شَدِيدٗا",
    translation:
      "There the believers were tested and shaken with a severe shaking",
    normalizedText: "هنالك ابتلي المامنون وزلزلوا زلزالا شديدا",
  },
  {
    verseId: 11,
    name: "الأحزاب",
    surahId: 33,
    text: "وَإِذۡ يَقُولُ ٱلۡمُنَٰفِقُونَ وَٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٞ مَّا وَعَدَنَا ٱللَّهُ وَرَسُولُهُۥٓ إِلَّا غُرُورٗا",
    translation:
      'And [remember] when the hypocrites and those in whose hearts is disease said, "Allah and His Messenger did not promise us except delusion',
    normalizedText:
      "واذ يقول المنفقون والذين في قلوبهم مرض ما وعدنا الله ورسوله الا غرورا",
  },
  {
    verseId: 12,
    name: "الأحزاب",
    surahId: 33,
    text: "وَإِذۡ قَالَت طَّآئِفَةٞ مِّنۡهُمۡ يَـٰٓأَهۡلَ يَثۡرِبَ لَا مُقَامَ لَكُمۡ فَٱرۡجِعُواْۚ وَيَسۡتَـٔۡذِنُ فَرِيقٞ مِّنۡهُمُ ٱلنَّبِيَّ يَقُولُونَ إِنَّ بُيُوتَنَا عَوۡرَةٞ وَمَا هِيَ بِعَوۡرَةٍۖ إِن يُرِيدُونَ إِلَّا فِرَارٗا",
    translation:
      'And when a faction of them said, "O people of Yathrib, there is no stability for you [here], so return [home]." And a party of them asked permission of the Prophet, saying, "Indeed, our houses are unprotected," while they were not exposed. They did not intend except to flee',
    normalizedText:
      "واذ قالت طاافة منهم ياهل يثرب لا مقام لكم فارجعوا ويستذن فريق منهم النبي يقولون ان بيوتنا عورة وما هي بعورة ان يريدون الا فرارا",
  },
  {
    verseId: 13,
    name: "الأحزاب",
    surahId: 33,
    text: "وَلَوۡ دُخِلَتۡ عَلَيۡهِم مِّنۡ أَقۡطَارِهَا ثُمَّ سُئِلُواْ ٱلۡفِتۡنَةَ لَأٓتَوۡهَا وَمَا تَلَبَّثُواْ بِهَآ إِلَّا يَسِيرٗا",
    translation:
      "And if they had been entered upon from all its [surrounding] regions and fitnah had been demanded of them, they would have done it and not hesitated over it except briefly",
    normalizedText:
      "ولو دخلت عليهم من اقطارها ثم سالوا الفتنة لاتوها وما تلبثوا بها الا يسيرا",
  },
  {
    verseId: 14,
    name: "الأحزاب",
    surahId: 33,
    text: "وَلَقَدۡ كَانُواْ عَٰهَدُواْ ٱللَّهَ مِن قَبۡلُ لَا يُوَلُّونَ ٱلۡأَدۡبَٰرَۚ وَكَانَ عَهۡدُ ٱللَّهِ مَسۡـُٔولٗا",
    translation:
      "And they had already promised Allah before not to turn their backs and flee. And ever is the promise to Allah [that about which one will be] questioned",
    normalizedText:
      "ولقد كانوا عهدوا الله من قبل لا يولون الادبر وكان عهد الله مسولا",
  },
  {
    verseId: 15,
    name: "الأحزاب",
    surahId: 33,
    text: "قُل لَّن يَنفَعَكُمُ ٱلۡفِرَارُ إِن فَرَرۡتُم مِّنَ ٱلۡمَوۡتِ أَوِ ٱلۡقَتۡلِ وَإِذٗا لَّا تُمَتَّعُونَ إِلَّا قَلِيلٗا",
    translation:
      'Say, [O Muhammad], "Never will fleeing benefit you if you should flee from death or killing; and then [if you did], you would not be given enjoyment [of life] except for a little',
    normalizedText:
      "قل لن ينفعكم الفرار ان فررتم من الموت او القتل واذا لا تمتعون الا قليلا",
  },
  {
    verseId: 16,
    name: "الأحزاب",
    surahId: 33,
    text: "قُلۡ مَن ذَا ٱلَّذِي يَعۡصِمُكُم مِّنَ ٱللَّهِ إِنۡ أَرَادَ بِكُمۡ سُوٓءًا أَوۡ أَرَادَ بِكُمۡ رَحۡمَةٗۚ وَلَا يَجِدُونَ لَهُم مِّن دُونِ ٱللَّهِ وَلِيّٗا وَلَا نَصِيرٗا",
    translation:
      'Say, "Who is it that can protect you from Allah if He intends for you an ill or intends for you a mercy?" And they will not find for themselves besides Allah any protector or any helper',
    normalizedText:
      "قل من ذا الذي يعصمكم من الله ان اراد بكم سوءا او اراد بكم رحمة ولا يجدون لهم من دون الله وليا ولا نصيرا",
  },
  {
    verseId: 17,
    name: "الأحزاب",
    surahId: 33,
    text: "۞قَدۡ يَعۡلَمُ ٱللَّهُ ٱلۡمُعَوِّقِينَ مِنكُمۡ وَٱلۡقَآئِلِينَ لِإِخۡوَٰنِهِمۡ هَلُمَّ إِلَيۡنَاۖ وَلَا يَأۡتُونَ ٱلۡبَأۡسَ إِلَّا قَلِيلًا",
    translation:
      'Already Allah knows the hinderers among you and those [hypocrites] who say to their brothers, "Come to us," and do not go to battle, except for a few',
    normalizedText:
      "۞قد يعلم الله المعوقين منكم والقاالين لاخونهم هلم الينا ولا ياتون الباس الا قليلا",
  },
  {
    verseId: 18,
    name: "الأحزاب",
    surahId: 33,
    text: "أَشِحَّةً عَلَيۡكُمۡۖ فَإِذَا جَآءَ ٱلۡخَوۡفُ رَأَيۡتَهُمۡ يَنظُرُونَ إِلَيۡكَ تَدُورُ أَعۡيُنُهُمۡ كَٱلَّذِي يُغۡشَىٰ عَلَيۡهِ مِنَ ٱلۡمَوۡتِۖ فَإِذَا ذَهَبَ ٱلۡخَوۡفُ سَلَقُوكُم بِأَلۡسِنَةٍ حِدَادٍ أَشِحَّةً عَلَى ٱلۡخَيۡرِۚ أُوْلَـٰٓئِكَ لَمۡ يُؤۡمِنُواْ فَأَحۡبَطَ ٱللَّهُ أَعۡمَٰلَهُمۡۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٗا",
    translation:
      "Indisposed toward you. And when fear comes, you see them looking at you, their eyes revolving like one being overcome by death. But when fear departs, they lash you with sharp tongues, indisposed toward [any] good. Those have not believed, so Allah has rendered their deeds worthless, and ever is that, for Allah, easy",
    normalizedText:
      "اشحة عليكم فاذا جاء الخوف رايتهم ينظرون اليك تدور اعينهم كالذي يغشى عليه من الموت فاذا ذهب الخوف سلقوكم بالسنة حداد اشحة على الخير اولاك لم يامنوا فاحبط الله اعملهم وكان ذلك على الله يسيرا",
  },
  {
    verseId: 19,
    name: "الأحزاب",
    surahId: 33,
    text: "يَحۡسَبُونَ ٱلۡأَحۡزَابَ لَمۡ يَذۡهَبُواْۖ وَإِن يَأۡتِ ٱلۡأَحۡزَابُ يَوَدُّواْ لَوۡ أَنَّهُم بَادُونَ فِي ٱلۡأَعۡرَابِ يَسۡـَٔلُونَ عَنۡ أَنۢبَآئِكُمۡۖ وَلَوۡ كَانُواْ فِيكُم مَّا قَٰتَلُوٓاْ إِلَّا قَلِيلٗا",
    translation:
      "They think the companies have not [yet] withdrawn. And if the companies should come [again], they would wish they were in the desert among the bedouins, inquiring [from afar] about your news. And if they should be among you, they would not fight except for a little",
    normalizedText:
      "يحسبون الاحزاب لم يذهبوا وان يات الاحزاب يودوا لو انهم بادون في الاعراب يسلون عن انبااكم ولو كانوا فيكم ما قتلوا الا قليلا",
  },
  {
    verseId: 20,
    name: "الأحزاب",
    surahId: 33,
    text: "لَّقَدۡ كَانَ لَكُمۡ فِي رَسُولِ ٱللَّهِ أُسۡوَةٌ حَسَنَةٞ لِّمَن كَانَ يَرۡجُواْ ٱللَّهَ وَٱلۡيَوۡمَ ٱلۡأٓخِرَ وَذَكَرَ ٱللَّهَ كَثِيرٗا",
    translation:
      "There has certainly been for you in the Messenger of Allah an excellent pattern for anyone whose hope is in Allah and the Last Day and [who] remembers Allah often",
    normalizedText:
      "لقد كان لكم في رسول الله اسوة حسنة لمن كان يرجوا الله واليوم الاخر وذكر الله كثيرا",
  },
  {
    verseId: 21,
    name: "الأحزاب",
    surahId: 33,
    text: "وَلَمَّا رَءَا ٱلۡمُؤۡمِنُونَ ٱلۡأَحۡزَابَ قَالُواْ هَٰذَا مَا وَعَدَنَا ٱللَّهُ وَرَسُولُهُۥ وَصَدَقَ ٱللَّهُ وَرَسُولُهُۥۚ وَمَا زَادَهُمۡ إِلَّآ إِيمَٰنٗا وَتَسۡلِيمٗا",
    translation:
      'And when the believers saw the companies, they said, "This is what Allah and His Messenger had promised us, and Allah and His Messenger spoke the truth." And it increased them only in faith and acceptance',
    normalizedText:
      "ولما رءا المامنون الاحزاب قالوا هذا ما وعدنا الله ورسوله وصدق الله ورسوله وما زادهم الا ايمنا وتسليما",
  },
  {
    verseId: 22,
    name: "الأحزاب",
    surahId: 33,
    text: "مِّنَ ٱلۡمُؤۡمِنِينَ رِجَالٞ صَدَقُواْ مَا عَٰهَدُواْ ٱللَّهَ عَلَيۡهِۖ فَمِنۡهُم مَّن قَضَىٰ نَحۡبَهُۥ وَمِنۡهُم مَّن يَنتَظِرُۖ وَمَا بَدَّلُواْ تَبۡدِيلٗا",
    translation:
      "Among the believers are men true to what they promised Allah. Among them is he who has fulfilled his vow [to the death], and among them is he who awaits [his chance]. And they did not alter [the terms of their commitment] by any alteration",
    normalizedText:
      "من المامنين رجال صدقوا ما عهدوا الله عليه فمنهم من قضى نحبه ومنهم من ينتظر وما بدلوا تبديلا",
  },
  {
    verseId: 23,
    name: "الأحزاب",
    surahId: 33,
    text: "لِّيَجۡزِيَ ٱللَّهُ ٱلصَّـٰدِقِينَ بِصِدۡقِهِمۡ وَيُعَذِّبَ ٱلۡمُنَٰفِقِينَ إِن شَآءَ أَوۡ يَتُوبَ عَلَيۡهِمۡۚ إِنَّ ٱللَّهَ كَانَ غَفُورٗا رَّحِيمٗا",
    translation:
      "That Allah may reward the truthful for their truth and punish the hypocrites if He wills or accept their repentance. Indeed, Allah is ever Forgiving and Merciful",
    normalizedText:
      "ليجزي الله الصدقين بصدقهم ويعذب المنفقين ان شاء او يتوب عليهم ان الله كان غفورا رحيما",
  },
  {
    verseId: 24,
    name: "الأحزاب",
    surahId: 33,
    text: "وَرَدَّ ٱللَّهُ ٱلَّذِينَ كَفَرُواْ بِغَيۡظِهِمۡ لَمۡ يَنَالُواْ خَيۡرٗاۚ وَكَفَى ٱللَّهُ ٱلۡمُؤۡمِنِينَ ٱلۡقِتَالَۚ وَكَانَ ٱللَّهُ قَوِيًّا عَزِيزٗا",
    translation:
      "And Allah repelled those who disbelieved, in their rage, not having obtained any good. And sufficient was Allah for the believers in battle, and ever is Allah Powerful and Exalted in Might",
    normalizedText:
      "ورد الله الذين كفروا بغيظهم لم ينالوا خيرا وكفى الله المامنين القتال وكان الله قويا عزيزا",
  },
  {
    verseId: 25,
    name: "الأحزاب",
    surahId: 33,
    text: "وَأَنزَلَ ٱلَّذِينَ ظَٰهَرُوهُم مِّنۡ أَهۡلِ ٱلۡكِتَٰبِ مِن صَيَاصِيهِمۡ وَقَذَفَ فِي قُلُوبِهِمُ ٱلرُّعۡبَ فَرِيقٗا تَقۡتُلُونَ وَتَأۡسِرُونَ فَرِيقٗا",
    translation:
      "And He brought down those who supported them among the People of the Scripture from their fortresses and cast terror into their hearts [so that] a party you killed, and you took captive a party",
    normalizedText:
      "وانزل الذين ظهروهم من اهل الكتب من صياصيهم وقذف في قلوبهم الرعب فريقا تقتلون وتاسرون فريقا",
  },
  {
    verseId: 26,
    name: "الأحزاب",
    surahId: 33,
    text: "وَأَوۡرَثَكُمۡ أَرۡضَهُمۡ وَدِيَٰرَهُمۡ وَأَمۡوَٰلَهُمۡ وَأَرۡضٗا لَّمۡ تَطَـُٔوهَاۚ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٗا",
    translation:
      "And He caused you to inherit their land and their homes and their properties and a land which you have not trodden. And ever is Allah, over all things, competent",
    normalizedText:
      "واورثكم ارضهم وديرهم وامولهم وارضا لم تطوها وكان الله على كل شيء قديرا",
  },
  {
    verseId: 27,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ قُل لِّأَزۡوَٰجِكَ إِن كُنتُنَّ تُرِدۡنَ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا وَزِينَتَهَا فَتَعَالَيۡنَ أُمَتِّعۡكُنَّ وَأُسَرِّحۡكُنَّ سَرَاحٗا جَمِيلٗا",
    translation:
      'O Prophet, say to your wives, "If you should desire the worldly life and its adornment, then come, I will provide for you and give you a gracious release',
    normalizedText:
      "يايها النبي قل لازوجك ان كنتن تردن الحيوة الدنيا وزينتها فتعالين امتعكن واسرحكن سراحا جميلا",
  },
  {
    verseId: 28,
    name: "الأحزاب",
    surahId: 33,
    text: "وَإِن كُنتُنَّ تُرِدۡنَ ٱللَّهَ وَرَسُولَهُۥ وَٱلدَّارَ ٱلۡأٓخِرَةَ فَإِنَّ ٱللَّهَ أَعَدَّ لِلۡمُحۡسِنَٰتِ مِنكُنَّ أَجۡرًا عَظِيمٗا",
    translation:
      "But if you should desire Allah and His Messenger and the home of the Hereafter - then indeed, Allah has prepared for the doers of good among you a great reward",
    normalizedText:
      "وان كنتن تردن الله ورسوله والدار الاخرة فان الله اعد للمحسنت منكن اجرا عظيما",
  },
  {
    verseId: 29,
    name: "الأحزاب",
    surahId: 33,
    text: "يَٰنِسَآءَ ٱلنَّبِيِّ مَن يَأۡتِ مِنكُنَّ بِفَٰحِشَةٖ مُّبَيِّنَةٖ يُضَٰعَفۡ لَهَا ٱلۡعَذَابُ ضِعۡفَيۡنِۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٗا",
    translation:
      "O wives of the Prophet, whoever of you should commit a clear immorality - for her the punishment would be doubled two fold, and ever is that, for Allah, easy",
    normalizedText:
      "ينساء النبي من يات منكن بفحشة مبينة يضعف لها العذاب ضعفين وكان ذلك على الله يسيرا",
  },
  {
    verseId: 30,
    name: "الأحزاب",
    surahId: 33,
    text: "۞وَمَن يَقۡنُتۡ مِنكُنَّ لِلَّهِ وَرَسُولِهِۦ وَتَعۡمَلۡ صَٰلِحٗا نُّؤۡتِهَآ أَجۡرَهَا مَرَّتَيۡنِ وَأَعۡتَدۡنَا لَهَا رِزۡقٗا كَرِيمٗا",
    translation:
      "And whoever of you devoutly obeys Allah and His Messenger and does righteousness - We will give her her reward twice; and We have prepared for her a noble provision",
    normalizedText:
      "۞ومن يقنت منكن لله ورسوله وتعمل صلحا ناتها اجرها مرتين واعتدنا لها رزقا كريما",
  },
  {
    verseId: 31,
    name: "الأحزاب",
    surahId: 33,
    text: "يَٰنِسَآءَ ٱلنَّبِيِّ لَسۡتُنَّ كَأَحَدٖ مِّنَ ٱلنِّسَآءِ إِنِ ٱتَّقَيۡتُنَّۚ فَلَا تَخۡضَعۡنَ بِٱلۡقَوۡلِ فَيَطۡمَعَ ٱلَّذِي فِي قَلۡبِهِۦ مَرَضٞ وَقُلۡنَ قَوۡلٗا مَّعۡرُوفٗا",
    translation:
      "O wives of the Prophet, you are not like anyone among women. If you fear Allah, then do not be soft in speech [to men], lest he in whose heart is disease should covet, but speak with appropriate speech",
    normalizedText:
      "ينساء النبي لستن كاحد من النساء ان اتقيتن فلا تخضعن بالقول فيطمع الذي في قلبه مرض وقلن قولا معروفا",
  },
  {
    verseId: 32,
    name: "الأحزاب",
    surahId: 33,
    text: "وَقَرۡنَ فِي بُيُوتِكُنَّ وَلَا تَبَرَّجۡنَ تَبَرُّجَ ٱلۡجَٰهِلِيَّةِ ٱلۡأُولَىٰۖ وَأَقِمۡنَ ٱلصَّلَوٰةَ وَءَاتِينَ ٱلزَّكَوٰةَ وَأَطِعۡنَ ٱللَّهَ وَرَسُولَهُۥٓۚ إِنَّمَا يُرِيدُ ٱللَّهُ لِيُذۡهِبَ عَنكُمُ ٱلرِّجۡسَ أَهۡلَ ٱلۡبَيۡتِ وَيُطَهِّرَكُمۡ تَطۡهِيرٗا",
    translation:
      "And abide in your houses and do not display yourselves as [was] the display of the former times of ignorance. And establish prayer and give zakah and obey Allah and His Messenger. Allah intends only to remove from you the impurity [of sin], O people of the [Prophet's] household, and to purify you with [extensive] purification",
    normalizedText:
      "وقرن في بيوتكن ولا تبرجن تبرج الجهلية الاولى واقمن الصلوة وءاتين الزكوة واطعن الله ورسوله انما يريد الله ليذهب عنكم الرجس اهل البيت ويطهركم تطهيرا",
  },
  {
    verseId: 33,
    name: "الأحزاب",
    surahId: 33,
    text: "وَٱذۡكُرۡنَ مَا يُتۡلَىٰ فِي بُيُوتِكُنَّ مِنۡ ءَايَٰتِ ٱللَّهِ وَٱلۡحِكۡمَةِۚ إِنَّ ٱللَّهَ كَانَ لَطِيفًا خَبِيرًا",
    translation:
      "And remember what is recited in your houses of the verses of Allah and wisdom. Indeed, Allah is ever Subtle and Acquainted [with all things]",
    normalizedText:
      "واذكرن ما يتلى في بيوتكن من ءايت الله والحكمة ان الله كان لطيفا خبيرا",
  },
  {
    verseId: 34,
    name: "الأحزاب",
    surahId: 33,
    text: "إِنَّ ٱلۡمُسۡلِمِينَ وَٱلۡمُسۡلِمَٰتِ وَٱلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِ وَٱلۡقَٰنِتِينَ وَٱلۡقَٰنِتَٰتِ وَٱلصَّـٰدِقِينَ وَٱلصَّـٰدِقَٰتِ وَٱلصَّـٰبِرِينَ وَٱلصَّـٰبِرَٰتِ وَٱلۡخَٰشِعِينَ وَٱلۡخَٰشِعَٰتِ وَٱلۡمُتَصَدِّقِينَ وَٱلۡمُتَصَدِّقَٰتِ وَٱلصَّـٰٓئِمِينَ وَٱلصَّـٰٓئِمَٰتِ وَٱلۡحَٰفِظِينَ فُرُوجَهُمۡ وَٱلۡحَٰفِظَٰتِ وَٱلذَّـٰكِرِينَ ٱللَّهَ كَثِيرٗا وَٱلذَّـٰكِرَٰتِ أَعَدَّ ٱللَّهُ لَهُم مَّغۡفِرَةٗ وَأَجۡرًا عَظِيمٗا",
    translation:
      "Indeed, the Muslim men and Muslim women, the believing men and believing women, the obedient men and obedient women, the truthful men and truthful women, the patient men and patient women, the humble men and humble women, the charitable men and charitable women, the fasting men and fasting women, the men who guard their private parts and the women who do so, and the men who remember Allah often and the women who do so - for them Allah has prepared forgiveness and a great reward",
    normalizedText:
      "ان المسلمين والمسلمت والمامنين والمامنت والقنتين والقنتت والصدقين والصدقت والصبرين والصبرت والخشعين والخشعت والمتصدقين والمتصدقت والصامين والصامت والحفظين فروجهم والحفظت والذكرين الله كثيرا والذكرت اعد الله لهم مغفرة واجرا عظيما",
  },
  {
    verseId: 35,
    name: "الأحزاب",
    surahId: 33,
    text: "وَمَا كَانَ لِمُؤۡمِنٖ وَلَا مُؤۡمِنَةٍ إِذَا قَضَى ٱللَّهُ وَرَسُولُهُۥٓ أَمۡرًا أَن يَكُونَ لَهُمُ ٱلۡخِيَرَةُ مِنۡ أَمۡرِهِمۡۗ وَمَن يَعۡصِ ٱللَّهَ وَرَسُولَهُۥ فَقَدۡ ضَلَّ ضَلَٰلٗا مُّبِينٗا",
    translation:
      "It is not for a believing man or a believing woman, when Allah and His Messenger have decided a matter, that they should [thereafter] have any choice about their affair. And whoever disobeys Allah and His Messenger has certainly strayed into clear error",
    normalizedText:
      "وما كان لمامن ولا مامنة اذا قضى الله ورسوله امرا ان يكون لهم الخيرة من امرهم ومن يعص الله ورسوله فقد ضل ضللا مبينا",
  },
  {
    verseId: 36,
    name: "الأحزاب",
    surahId: 33,
    text: "وَإِذۡ تَقُولُ لِلَّذِيٓ أَنۡعَمَ ٱللَّهُ عَلَيۡهِ وَأَنۡعَمۡتَ عَلَيۡهِ أَمۡسِكۡ عَلَيۡكَ زَوۡجَكَ وَٱتَّقِ ٱللَّهَ وَتُخۡفِي فِي نَفۡسِكَ مَا ٱللَّهُ مُبۡدِيهِ وَتَخۡشَى ٱلنَّاسَ وَٱللَّهُ أَحَقُّ أَن تَخۡشَىٰهُۖ فَلَمَّا قَضَىٰ زَيۡدٞ مِّنۡهَا وَطَرٗا زَوَّجۡنَٰكَهَا لِكَيۡ لَا يَكُونَ عَلَى ٱلۡمُؤۡمِنِينَ حَرَجٞ فِيٓ أَزۡوَٰجِ أَدۡعِيَآئِهِمۡ إِذَا قَضَوۡاْ مِنۡهُنَّ وَطَرٗاۚ وَكَانَ أَمۡرُ ٱللَّهِ مَفۡعُولٗا",
    translation:
      'And [remember, O Muhammad], when you said to the one on whom Allah bestowed favor and you bestowed favor, "Keep your wife and fear Allah," while you concealed within yourself that which Allah is to disclose. And you feared the people, while Allah has more right that you fear Him. So when Zayd had no longer any need for her, We married her to you in order that there not be upon the believers any discomfort concerning the wives of their adopted sons when they no longer have need of them. And ever is the command of Allah accomplished',
    normalizedText:
      "واذ تقول للذي انعم الله عليه وانعمت عليه امسك عليك زوجك واتق الله وتخفي في نفسك ما الله مبديه وتخشى الناس والله احق ان تخشىه فلما قضى زيد منها وطرا زوجنكها لكي لا يكون على المامنين حرج في ازوج ادعيااهم اذا قضوا منهن وطرا وكان امر الله مفعولا",
  },
  {
    verseId: 37,
    name: "الأحزاب",
    surahId: 33,
    text: "مَّا كَانَ عَلَى ٱلنَّبِيِّ مِنۡ حَرَجٖ فِيمَا فَرَضَ ٱللَّهُ لَهُۥۖ سُنَّةَ ٱللَّهِ فِي ٱلَّذِينَ خَلَوۡاْ مِن قَبۡلُۚ وَكَانَ أَمۡرُ ٱللَّهِ قَدَرٗا مَّقۡدُورًا",
    translation:
      "There is not to be upon the Prophet any discomfort concerning that which Allah has imposed upon him. [This is] the established way of Allah with those [prophets] who have passed on before. And ever is the command of Allah a destiny decreed",
    normalizedText:
      "ما كان على النبي من حرج فيما فرض الله له سنة الله في الذين خلوا من قبل وكان امر الله قدرا مقدورا",
  },
  {
    verseId: 38,
    name: "الأحزاب",
    surahId: 33,
    text: "ٱلَّذِينَ يُبَلِّغُونَ رِسَٰلَٰتِ ٱللَّهِ وَيَخۡشَوۡنَهُۥ وَلَا يَخۡشَوۡنَ أَحَدًا إِلَّا ٱللَّهَۗ وَكَفَىٰ بِٱللَّهِ حَسِيبٗا",
    translation:
      "[Allah praises] those who convey the messages of Allah and fear Him and do not fear anyone but Allah. And sufficient is Allah as Accountant",
    normalizedText:
      "الذين يبلغون رسلت الله ويخشونه ولا يخشون احدا الا الله وكفى بالله حسيبا",
  },
  {
    verseId: 39,
    name: "الأحزاب",
    surahId: 33,
    text: "مَّا كَانَ مُحَمَّدٌ أَبَآ أَحَدٖ مِّن رِّجَالِكُمۡ وَلَٰكِن رَّسُولَ ٱللَّهِ وَخَاتَمَ ٱلنَّبِيِّـۧنَۗ وَكَانَ ٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمٗا",
    translation:
      "Muhammad is not the father of [any] one of your men, but [he is] the Messenger of Allah and last of the prophets. And ever is Allah, of all things, Knowing",
    normalizedText:
      "ما كان محمد ابا احد من رجالكم ولكن رسول الله وخاتم النبين وكان الله بكل شيء عليما",
  },
  {
    verseId: 40,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱذۡكُرُواْ ٱللَّهَ ذِكۡرٗا كَثِيرٗا",
    translation:
      "O you who have believed, remember Allah with much remembrance",
    normalizedText: "يايها الذين ءامنوا اذكروا الله ذكرا كثيرا",
  },
  {
    verseId: 41,
    name: "الأحزاب",
    surahId: 33,
    text: "وَسَبِّحُوهُ بُكۡرَةٗ وَأَصِيلًا",
    translation: "And exalt Him morning and afternoon",
    normalizedText: "وسبحوه بكرة واصيلا",
  },
  {
    verseId: 42,
    name: "الأحزاب",
    surahId: 33,
    text: "هُوَ ٱلَّذِي يُصَلِّي عَلَيۡكُمۡ وَمَلَـٰٓئِكَتُهُۥ لِيُخۡرِجَكُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِۚ وَكَانَ بِٱلۡمُؤۡمِنِينَ رَحِيمٗا",
    translation:
      "It is He who confers blessing upon you, and His angels [ask Him to do so] that He may bring you out from darknesses into the light. And ever is He, to the believers, Merciful",
    normalizedText:
      "هو الذي يصلي عليكم وملاكته ليخرجكم من الظلمت الى النور وكان بالمامنين رحيما",
  },
  {
    verseId: 43,
    name: "الأحزاب",
    surahId: 33,
    text: "تَحِيَّتُهُمۡ يَوۡمَ يَلۡقَوۡنَهُۥ سَلَٰمٞۚ وَأَعَدَّ لَهُمۡ أَجۡرٗا كَرِيمٗا",
    translation:
      'Their greeting the Day they meet Him will be, "Peace." And He has prepared for them a noble reward',
    normalizedText: "تحيتهم يوم يلقونه سلم واعد لهم اجرا كريما",
  },
  {
    verseId: 44,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ إِنَّآ أَرۡسَلۡنَٰكَ شَٰهِدٗا وَمُبَشِّرٗا وَنَذِيرٗا",
    translation:
      "O Prophet, indeed We have sent you as a witness and a bringer of good tidings and a warner",
    normalizedText: "يايها النبي انا ارسلنك شهدا ومبشرا ونذيرا",
  },
  {
    verseId: 45,
    name: "الأحزاب",
    surahId: 33,
    text: "وَدَاعِيًا إِلَى ٱللَّهِ بِإِذۡنِهِۦ وَسِرَاجٗا مُّنِيرٗا",
    translation:
      "And one who invites to Allah, by His permission, and an illuminating lamp",
    normalizedText: "وداعيا الى الله باذنه وسراجا منيرا",
  },
  {
    verseId: 46,
    name: "الأحزاب",
    surahId: 33,
    text: "وَبَشِّرِ ٱلۡمُؤۡمِنِينَ بِأَنَّ لَهُم مِّنَ ٱللَّهِ فَضۡلٗا كَبِيرٗا",
    translation:
      "And give good tidings to the believers that they will have from Allah great bounty",
    normalizedText: "وبشر المامنين بان لهم من الله فضلا كبيرا",
  },
  {
    verseId: 47,
    name: "الأحزاب",
    surahId: 33,
    text: "وَلَا تُطِعِ ٱلۡكَٰفِرِينَ وَٱلۡمُنَٰفِقِينَ وَدَعۡ أَذَىٰهُمۡ وَتَوَكَّلۡ عَلَى ٱللَّهِۚ وَكَفَىٰ بِٱللَّهِ وَكِيلٗا",
    translation:
      "And do not obey the disbelievers and the hypocrites but do not harm them, and rely upon Allah. And sufficient is Allah as Disposer of affairs",
    normalizedText:
      "ولا تطع الكفرين والمنفقين ودع اذىهم وتوكل على الله وكفى بالله وكيلا",
  },
  {
    verseId: 48,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا نَكَحۡتُمُ ٱلۡمُؤۡمِنَٰتِ ثُمَّ طَلَّقۡتُمُوهُنَّ مِن قَبۡلِ أَن تَمَسُّوهُنَّ فَمَا لَكُمۡ عَلَيۡهِنَّ مِنۡ عِدَّةٖ تَعۡتَدُّونَهَاۖ فَمَتِّعُوهُنَّ وَسَرِّحُوهُنَّ سَرَاحٗا جَمِيلٗا",
    translation:
      "O You who have believed, when you marry believing women and then divorce them before you have touched them, then there is not for you any waiting period to count concerning them. So provide for them and give them a gracious release",
    normalizedText:
      "يايها الذين ءامنوا اذا نكحتم المامنت ثم طلقتموهن من قبل ان تمسوهن فما لكم عليهن من عدة تعتدونها فمتعوهن وسرحوهن سراحا جميلا",
  },
  {
    verseId: 49,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ إِنَّآ أَحۡلَلۡنَا لَكَ أَزۡوَٰجَكَ ٱلَّـٰتِيٓ ءَاتَيۡتَ أُجُورَهُنَّ وَمَا مَلَكَتۡ يَمِينُكَ مِمَّآ أَفَآءَ ٱللَّهُ عَلَيۡكَ وَبَنَاتِ عَمِّكَ وَبَنَاتِ عَمَّـٰتِكَ وَبَنَاتِ خَالِكَ وَبَنَاتِ خَٰلَٰتِكَ ٱلَّـٰتِي هَاجَرۡنَ مَعَكَ وَٱمۡرَأَةٗ مُّؤۡمِنَةً إِن وَهَبَتۡ نَفۡسَهَا لِلنَّبِيِّ إِنۡ أَرَادَ ٱلنَّبِيُّ أَن يَسۡتَنكِحَهَا خَالِصَةٗ لَّكَ مِن دُونِ ٱلۡمُؤۡمِنِينَۗ قَدۡ عَلِمۡنَا مَا فَرَضۡنَا عَلَيۡهِمۡ فِيٓ أَزۡوَٰجِهِمۡ وَمَا مَلَكَتۡ أَيۡمَٰنُهُمۡ لِكَيۡلَا يَكُونَ عَلَيۡكَ حَرَجٞۗ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمٗا",
    translation:
      "O Prophet, indeed We have made lawful to you your wives to whom you have given their due compensation and those your right hand possesses from what Allah has returned to you [of captives] and the daughters of your paternal uncles and the daughters of your paternal aunts and the daughters of your maternal uncles and the daughters of your maternal aunts who emigrated with you and a believing woman if she gives herself to the Prophet [and] if the Prophet wishes to marry her, [this is] only for you, excluding the [other] believers. We certainly know what We have made obligatory upon them concerning their wives and those their right hands possess, [but this is for you] in order that there will be upon you no discomfort. And ever is Allah Forgiving and Merciful",
    normalizedText:
      "يايها النبي انا احللنا لك ازوجك التي ءاتيت اجورهن وما ملكت يمينك مما افاء الله عليك وبنات عمك وبنات عمتك وبنات خالك وبنات خلتك التي هاجرن معك وامراة مامنة ان وهبت نفسها للنبي ان اراد النبي ان يستنكحها خالصة لك من دون المامنين قد علمنا ما فرضنا عليهم في ازوجهم وما ملكت ايمنهم لكيلا يكون عليك حرج وكان الله غفورا رحيما",
  },
  {
    verseId: 50,
    name: "الأحزاب",
    surahId: 33,
    text: "۞تُرۡجِي مَن تَشَآءُ مِنۡهُنَّ وَتُـٔۡوِيٓ إِلَيۡكَ مَن تَشَآءُۖ وَمَنِ ٱبۡتَغَيۡتَ مِمَّنۡ عَزَلۡتَ فَلَا جُنَاحَ عَلَيۡكَۚ ذَٰلِكَ أَدۡنَىٰٓ أَن تَقَرَّ أَعۡيُنُهُنَّ وَلَا يَحۡزَنَّ وَيَرۡضَيۡنَ بِمَآ ءَاتَيۡتَهُنَّ كُلُّهُنَّۚ وَٱللَّهُ يَعۡلَمُ مَا فِي قُلُوبِكُمۡۚ وَكَانَ ٱللَّهُ عَلِيمًا حَلِيمٗا",
    translation:
      "You, [O Muhammad], may put aside whom you will of them or take to yourself whom you will. And any that you desire of those [wives] from whom you had [temporarily] separated - there is no blame upon you [in returning her]. That is more suitable that they should be content and not grieve and that they should be satisfied with what you have given them - all of them. And Allah knows what is in your hearts. And ever is Allah Knowing and Forbearing",
    normalizedText:
      "۞ترجي من تشاء منهن وتوي اليك من تشاء ومن ابتغيت ممن عزلت فلا جناح عليك ذلك ادنى ان تقر اعينهن ولا يحزن ويرضين بما ءاتيتهن كلهن والله يعلم ما في قلوبكم وكان الله عليما حليما",
  },
  {
    verseId: 51,
    name: "الأحزاب",
    surahId: 33,
    text: "لَّا يَحِلُّ لَكَ ٱلنِّسَآءُ مِنۢ بَعۡدُ وَلَآ أَن تَبَدَّلَ بِهِنَّ مِنۡ أَزۡوَٰجٖ وَلَوۡ أَعۡجَبَكَ حُسۡنُهُنَّ إِلَّا مَا مَلَكَتۡ يَمِينُكَۗ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ رَّقِيبٗا",
    translation:
      "Not lawful to you, [O Muhammad], are [any additional] women after [this], nor [is it] for you to exchange them for [other] wives, even if their beauty were to please you, except what your right hand possesses. And ever is Allah, over all things, an Observer",
    normalizedText:
      "لا يحل لك النساء من بعد ولا ان تبدل بهن من ازوج ولو اعجبك حسنهن الا ما ملكت يمينك وكان الله على كل شيء رقيبا",
  },
  {
    verseId: 52,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَدۡخُلُواْ بُيُوتَ ٱلنَّبِيِّ إِلَّآ أَن يُؤۡذَنَ لَكُمۡ إِلَىٰ طَعَامٍ غَيۡرَ نَٰظِرِينَ إِنَىٰهُ وَلَٰكِنۡ إِذَا دُعِيتُمۡ فَٱدۡخُلُواْ فَإِذَا طَعِمۡتُمۡ فَٱنتَشِرُواْ وَلَا مُسۡتَـٔۡنِسِينَ لِحَدِيثٍۚ إِنَّ ذَٰلِكُمۡ كَانَ يُؤۡذِي ٱلنَّبِيَّ فَيَسۡتَحۡيِۦ مِنكُمۡۖ وَٱللَّهُ لَا يَسۡتَحۡيِۦ مِنَ ٱلۡحَقِّۚ وَإِذَا سَأَلۡتُمُوهُنَّ مَتَٰعٗا فَسۡـَٔلُوهُنَّ مِن وَرَآءِ حِجَابٖۚ ذَٰلِكُمۡ أَطۡهَرُ لِقُلُوبِكُمۡ وَقُلُوبِهِنَّۚ وَمَا كَانَ لَكُمۡ أَن تُؤۡذُواْ رَسُولَ ٱللَّهِ وَلَآ أَن تَنكِحُوٓاْ أَزۡوَٰجَهُۥ مِنۢ بَعۡدِهِۦٓ أَبَدًاۚ إِنَّ ذَٰلِكُمۡ كَانَ عِندَ ٱللَّهِ عَظِيمًا",
    translation:
      "O you who have believed, do not enter the houses of the Prophet except when you are permitted for a meal, without awaiting its readiness. But when you are invited, then enter; and when you have eaten, disperse without seeking to remain for conversation. Indeed, that [behavior] was troubling the Prophet, and he is shy of [dismissing] you. But Allah is not shy of the truth. And when you ask [his wives] for something, ask them from behind a partition. That is purer for your hearts and their hearts. And it is not [conceivable or lawful] for you to harm the Messenger of Allah or to marry his wives after him, ever. Indeed, that would be in the sight of Allah an enormity",
    normalizedText:
      "يايها الذين ءامنوا لا تدخلوا بيوت النبي الا ان ياذن لكم الى طعام غير نظرين انىه ولكن اذا دعيتم فادخلوا فاذا طعمتم فانتشروا ولا مستنسين لحديث ان ذلكم كان ياذي النبي فيستحي منكم والله لا يستحي من الحق واذا سالتموهن متعا فسلوهن من وراء حجاب ذلكم اطهر لقلوبكم وقلوبهن وما كان لكم ان تاذوا رسول الله ولا ان تنكحوا ازوجه من بعده ابدا ان ذلكم كان عند الله عظيما",
  },
  {
    verseId: 53,
    name: "الأحزاب",
    surahId: 33,
    text: "إِن تُبۡدُواْ شَيۡـًٔا أَوۡ تُخۡفُوهُ فَإِنَّ ٱللَّهَ كَانَ بِكُلِّ شَيۡءٍ عَلِيمٗا",
    translation:
      "Whether you reveal a thing or conceal it, indeed Allah is ever, of all things, Knowing",
    normalizedText: "ان تبدوا شيا او تخفوه فان الله كان بكل شيء عليما",
  },
  {
    verseId: 54,
    name: "الأحزاب",
    surahId: 33,
    text: "لَّا جُنَاحَ عَلَيۡهِنَّ فِيٓ ءَابَآئِهِنَّ وَلَآ أَبۡنَآئِهِنَّ وَلَآ إِخۡوَٰنِهِنَّ وَلَآ أَبۡنَآءِ إِخۡوَٰنِهِنَّ وَلَآ أَبۡنَآءِ أَخَوَٰتِهِنَّ وَلَا نِسَآئِهِنَّ وَلَا مَا مَلَكَتۡ أَيۡمَٰنُهُنَّۗ وَٱتَّقِينَ ٱللَّهَۚ إِنَّ ٱللَّهَ كَانَ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدًا",
    translation:
      "There is no blame upon women concerning their fathers or their sons or their brothers or their brothers' sons or their sisters' sons or their women or those their right hands possess. And fear Allah. Indeed Allah is ever, over all things, Witness",
    normalizedText:
      "لا جناح عليهن في ءابااهن ولا ابنااهن ولا اخونهن ولا ابناء اخونهن ولا ابناء اخوتهن ولا نسااهن ولا ما ملكت ايمنهن واتقين الله ان الله كان على كل شيء شهيدا",
  },
  {
    verseId: 55,
    name: "الأحزاب",
    surahId: 33,
    text: "إِنَّ ٱللَّهَ وَمَلَـٰٓئِكَتَهُۥ يُصَلُّونَ عَلَى ٱلنَّبِيِّۚ يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ صَلُّواْ عَلَيۡهِ وَسَلِّمُواْ تَسۡلِيمًا",
    translation:
      "Indeed, Allah confers blessing upon the Prophet, and His angels [ask Him to do so]. O you who have believed, ask [Allah to confer] blessing upon him and ask [Allah to grant him] peace",
    normalizedText:
      "ان الله وملاكته يصلون على النبي يايها الذين ءامنوا صلوا عليه وسلموا تسليما",
  },
  {
    verseId: 56,
    name: "الأحزاب",
    surahId: 33,
    text: "إِنَّ ٱلَّذِينَ يُؤۡذُونَ ٱللَّهَ وَرَسُولَهُۥ لَعَنَهُمُ ٱللَّهُ فِي ٱلدُّنۡيَا وَٱلۡأٓخِرَةِ وَأَعَدَّ لَهُمۡ عَذَابٗا مُّهِينٗا",
    translation:
      "Indeed, those who abuse Allah and His Messenger - Allah has cursed them in this world and the Hereafter and prepared for them a humiliating punishment",
    normalizedText:
      "ان الذين ياذون الله ورسوله لعنهم الله في الدنيا والاخرة واعد لهم عذابا مهينا",
  },
  {
    verseId: 57,
    name: "الأحزاب",
    surahId: 33,
    text: "وَٱلَّذِينَ يُؤۡذُونَ ٱلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِ بِغَيۡرِ مَا ٱكۡتَسَبُواْ فَقَدِ ٱحۡتَمَلُواْ بُهۡتَٰنٗا وَإِثۡمٗا مُّبِينٗا",
    translation:
      "And those who harm believing men and believing women for [something] other than what they have earned have certainly born upon themselves a slander and manifest sin",
    normalizedText:
      "والذين ياذون المامنين والمامنت بغير ما اكتسبوا فقد احتملوا بهتنا واثما مبينا",
  },
  {
    verseId: 58,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ قُل لِّأَزۡوَٰجِكَ وَبَنَاتِكَ وَنِسَآءِ ٱلۡمُؤۡمِنِينَ يُدۡنِينَ عَلَيۡهِنَّ مِن جَلَٰبِيبِهِنَّۚ ذَٰلِكَ أَدۡنَىٰٓ أَن يُعۡرَفۡنَ فَلَا يُؤۡذَيۡنَۗ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمٗا",
    translation:
      "O Prophet, tell your wives and your daughters and the women of the believers to bring down over themselves [part] of their outer garments. That is more suitable that they will be known and not be abused. And ever is Allah Forgiving and Merciful",
    normalizedText:
      "يايها النبي قل لازوجك وبناتك ونساء المامنين يدنين عليهن من جلبيبهن ذلك ادنى ان يعرفن فلا ياذين وكان الله غفورا رحيما",
  },
  {
    verseId: 59,
    name: "الأحزاب",
    surahId: 33,
    text: "۞لَّئِن لَّمۡ يَنتَهِ ٱلۡمُنَٰفِقُونَ وَٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٞ وَٱلۡمُرۡجِفُونَ فِي ٱلۡمَدِينَةِ لَنُغۡرِيَنَّكَ بِهِمۡ ثُمَّ لَا يُجَاوِرُونَكَ فِيهَآ إِلَّا قَلِيلٗا",
    translation:
      "If the hypocrites and those in whose hearts is disease and those who spread rumors in al-Madinah do not cease, We will surely incite you against them; then they will not remain your neighbors therein except for a little",
    normalizedText:
      "۞لان لم ينته المنفقون والذين في قلوبهم مرض والمرجفون في المدينة لنغرينك بهم ثم لا يجاورونك فيها الا قليلا",
  },
  {
    verseId: 60,
    name: "الأحزاب",
    surahId: 33,
    text: "مَّلۡعُونِينَۖ أَيۡنَمَا ثُقِفُوٓاْ أُخِذُواْ وَقُتِّلُواْ تَقۡتِيلٗا",
    translation:
      "Accursed wherever they are found, [being] seized and massacred completely",
    normalizedText: "ملعونين اينما ثقفوا اخذوا وقتلوا تقتيلا",
  },
  {
    verseId: 61,
    name: "الأحزاب",
    surahId: 33,
    text: "سُنَّةَ ٱللَّهِ فِي ٱلَّذِينَ خَلَوۡاْ مِن قَبۡلُۖ وَلَن تَجِدَ لِسُنَّةِ ٱللَّهِ تَبۡدِيلٗا",
    translation:
      "[This is] the established way of Allah with those who passed on before; and you will not find in the way of Allah any change",
    normalizedText: "سنة الله في الذين خلوا من قبل ولن تجد لسنة الله تبديلا",
  },
  {
    verseId: 62,
    name: "الأحزاب",
    surahId: 33,
    text: "يَسۡـَٔلُكَ ٱلنَّاسُ عَنِ ٱلسَّاعَةِۖ قُلۡ إِنَّمَا عِلۡمُهَا عِندَ ٱللَّهِۚ وَمَا يُدۡرِيكَ لَعَلَّ ٱلسَّاعَةَ تَكُونُ قَرِيبًا",
    translation:
      'People ask you concerning the Hour. Say," Knowledge of it is only with Allah. And what may make you perceive? Perhaps the Hour is near',
    normalizedText:
      "يسلك الناس عن الساعة قل انما علمها عند الله وما يدريك لعل الساعة تكون قريبا",
  },
  {
    verseId: 63,
    name: "الأحزاب",
    surahId: 33,
    text: "إِنَّ ٱللَّهَ لَعَنَ ٱلۡكَٰفِرِينَ وَأَعَدَّ لَهُمۡ سَعِيرًا",
    translation:
      "Indeed, Allah has cursed the disbelievers and prepared for them a Blaze",
    normalizedText: "ان الله لعن الكفرين واعد لهم سعيرا",
  },
  {
    verseId: 64,
    name: "الأحزاب",
    surahId: 33,
    text: "خَٰلِدِينَ فِيهَآ أَبَدٗاۖ لَّا يَجِدُونَ وَلِيّٗا وَلَا نَصِيرٗا",
    translation:
      "Abiding therein forever, they will not find a protector or a helper",
    normalizedText: "خلدين فيها ابدا لا يجدون وليا ولا نصيرا",
  },
  {
    verseId: 65,
    name: "الأحزاب",
    surahId: 33,
    text: "يَوۡمَ تُقَلَّبُ وُجُوهُهُمۡ فِي ٱلنَّارِ يَقُولُونَ يَٰلَيۡتَنَآ أَطَعۡنَا ٱللَّهَ وَأَطَعۡنَا ٱلرَّسُولَا۠",
    translation:
      'The Day their faces will be turned about in the Fire, they will say, "How we wish we had obeyed Allah and obeyed the Messenger',
    normalizedText:
      "يوم تقلب وجوههم في النار يقولون يليتنا اطعنا الله واطعنا الرسولا",
  },
  {
    verseId: 66,
    name: "الأحزاب",
    surahId: 33,
    text: "وَقَالُواْ رَبَّنَآ إِنَّآ أَطَعۡنَا سَادَتَنَا وَكُبَرَآءَنَا فَأَضَلُّونَا ٱلسَّبِيلَا۠",
    translation:
      'And they will say, "Our Lord, indeed we obeyed our masters and our dignitaries, and they led us astray from the [right] way',
    normalizedText: "وقالوا ربنا انا اطعنا سادتنا وكبراءنا فاضلونا السبيلا",
  },
  {
    verseId: 67,
    name: "الأحزاب",
    surahId: 33,
    text: "رَبَّنَآ ءَاتِهِمۡ ضِعۡفَيۡنِ مِنَ ٱلۡعَذَابِ وَٱلۡعَنۡهُمۡ لَعۡنٗا كَبِيرٗا",
    translation:
      "Our Lord, give them double the punishment and curse them with a great curse",
    normalizedText: "ربنا ءاتهم ضعفين من العذاب والعنهم لعنا كبيرا",
  },
  {
    verseId: 68,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَكُونُواْ كَٱلَّذِينَ ءَاذَوۡاْ مُوسَىٰ فَبَرَّأَهُ ٱللَّهُ مِمَّا قَالُواْۚ وَكَانَ عِندَ ٱللَّهِ وَجِيهٗا",
    translation:
      "O you who have believed, be not like those who abused Moses; then Allah cleared him of what they said. And he, in the sight of Allah, was distinguished",
    normalizedText:
      "يايها الذين ءامنوا لا تكونوا كالذين ءاذوا موسى فبراه الله مما قالوا وكان عند الله وجيها",
  },
  {
    verseId: 69,
    name: "الأحزاب",
    surahId: 33,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ ٱللَّهَ وَقُولُواْ قَوۡلٗا سَدِيدٗا",
    translation:
      "O you who have believed, fear Allah and speak words of appropriate justice",
    normalizedText: "يايها الذين ءامنوا اتقوا الله وقولوا قولا سديدا",
  },
  {
    verseId: 70,
    name: "الأحزاب",
    surahId: 33,
    text: "يُصۡلِحۡ لَكُمۡ أَعۡمَٰلَكُمۡ وَيَغۡفِرۡ لَكُمۡ ذُنُوبَكُمۡۗ وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ فَقَدۡ فَازَ فَوۡزًا عَظِيمًا",
    translation:
      "He will [then] amend for you your deeds and forgive you your sins. And whoever obeys Allah and His Messenger has certainly attained a great attainment",
    normalizedText:
      "يصلح لكم اعملكم ويغفر لكم ذنوبكم ومن يطع الله ورسوله فقد فاز فوزا عظيما",
  },
  {
    verseId: 71,
    name: "الأحزاب",
    surahId: 33,
    text: "إِنَّا عَرَضۡنَا ٱلۡأَمَانَةَ عَلَى ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَٱلۡجِبَالِ فَأَبَيۡنَ أَن يَحۡمِلۡنَهَا وَأَشۡفَقۡنَ مِنۡهَا وَحَمَلَهَا ٱلۡإِنسَٰنُۖ إِنَّهُۥ كَانَ ظَلُومٗا جَهُولٗا",
    translation:
      "Indeed, we offered the Trust to the heavens and the earth and the mountains, and they declined to bear it and feared it; but man [undertook to] bear it. Indeed, he was unjust and ignorant",
    normalizedText:
      "انا عرضنا الامانة على السموت والارض والجبال فابين ان يحملنها واشفقن منها وحملها الانسن انه كان ظلوما جهولا",
  },
  {
    verseId: 72,
    name: "الأحزاب",
    surahId: 33,
    text: "لِّيُعَذِّبَ ٱللَّهُ ٱلۡمُنَٰفِقِينَ وَٱلۡمُنَٰفِقَٰتِ وَٱلۡمُشۡرِكِينَ وَٱلۡمُشۡرِكَٰتِ وَيَتُوبَ ٱللَّهُ عَلَى ٱلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِۗ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمَۢا",
    translation:
      "[It was] so that Allah may punish the hypocrite men and hypocrite women and the men and women who associate others with Him and that Allah may accept repentance from the believing men and believing women. And ever is Allah Forgiving and Merciful",
    normalizedText:
      "ليعذب الله المنفقين والمنفقت والمشركين والمشركت ويتوب الله على المامنين والمامنت وكان الله غفورا رحيما",
  },
  {
    verseId: 0,
    name: "سبإ",
    surahId: 34,
    text: "ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ وَلَهُ ٱلۡحَمۡدُ فِي ٱلۡأٓخِرَةِۚ وَهُوَ ٱلۡحَكِيمُ ٱلۡخَبِيرُ",
    translation:
      "[All] praise is [due] to Allah, to whom belongs whatever is in the heavens and whatever is in the earth, and to Him belongs [all] praise in the Hereafter. And He is the Wise, the Acquainted",
    normalizedText:
      "الحمد لله الذي له ما في السموت وما في الارض وله الحمد في الاخرة وهو الحكيم الخبير",
  },
  {
    verseId: 1,
    name: "سبإ",
    surahId: 34,
    text: "يَعۡلَمُ مَا يَلِجُ فِي ٱلۡأَرۡضِ وَمَا يَخۡرُجُ مِنۡهَا وَمَا يَنزِلُ مِنَ ٱلسَّمَآءِ وَمَا يَعۡرُجُ فِيهَاۚ وَهُوَ ٱلرَّحِيمُ ٱلۡغَفُورُ",
    translation:
      "He knows what penetrates into the earth and what emerges from it and what descends from the heaven and what ascends therein. And He is the Merciful, the Forgiving",
    normalizedText:
      "يعلم ما يلج في الارض وما يخرج منها وما ينزل من السماء وما يعرج فيها وهو الرحيم الغفور",
  },
  {
    verseId: 2,
    name: "سبإ",
    surahId: 34,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ لَا تَأۡتِينَا ٱلسَّاعَةُۖ قُلۡ بَلَىٰ وَرَبِّي لَتَأۡتِيَنَّكُمۡ عَٰلِمِ ٱلۡغَيۡبِۖ لَا يَعۡزُبُ عَنۡهُ مِثۡقَالُ ذَرَّةٖ فِي ٱلسَّمَٰوَٰتِ وَلَا فِي ٱلۡأَرۡضِ وَلَآ أَصۡغَرُ مِن ذَٰلِكَ وَلَآ أَكۡبَرُ إِلَّا فِي كِتَٰبٖ مُّبِينٖ",
    translation: `But those who disbelieve say, "The Hour will not come to us." Say, "Yes, by my Lord, it will surely come to you. [Allah is] the Knower of the unseen." Not absent from Him is an atom's weight within the heavens or within the earth or [what is] smaller than that or greater, except that it is in a clear register`,
    normalizedText:
      "وقال الذين كفروا لا تاتينا الساعة قل بلى وربي لتاتينكم علم الغيب لا يعزب عنه مثقال ذرة في السموت ولا في الارض ولا اصغر من ذلك ولا اكبر الا في كتب مبين",
  },
  {
    verseId: 3,
    name: "سبإ",
    surahId: 34,
    text: "لِّيَجۡزِيَ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِۚ أُوْلَـٰٓئِكَ لَهُم مَّغۡفِرَةٞ وَرِزۡقٞ كَرِيمٞ",
    translation:
      "That He may reward those who believe and do righteous deeds. Those will have forgiveness and noble provision",
    normalizedText:
      "ليجزي الذين ءامنوا وعملوا الصلحت اولاك لهم مغفرة ورزق كريم",
  },
  {
    verseId: 4,
    name: "سبإ",
    surahId: 34,
    text: "وَٱلَّذِينَ سَعَوۡ فِيٓ ءَايَٰتِنَا مُعَٰجِزِينَ أُوْلَـٰٓئِكَ لَهُمۡ عَذَابٞ مِّن رِّجۡزٍ أَلِيمٞ",
    translation:
      "But those who strive against Our verses [seeking] to cause failure - for them will be a painful punishment of foul nature",
    normalizedText: "والذين سعو في ءايتنا معجزين اولاك لهم عذاب من رجز اليم",
  },
  {
    verseId: 5,
    name: "سبإ",
    surahId: 34,
    text: "وَيَرَى ٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ ٱلَّذِيٓ أُنزِلَ إِلَيۡكَ مِن رَّبِّكَ هُوَ ٱلۡحَقَّ وَيَهۡدِيٓ إِلَىٰ صِرَٰطِ ٱلۡعَزِيزِ ٱلۡحَمِيدِ",
    translation:
      "And those who have been given knowledge see that what is revealed to you from your Lord is the truth, and it guides to the path of the Exalted in Might, the Praiseworthy",
    normalizedText:
      "ويرى الذين اوتوا العلم الذي انزل اليك من ربك هو الحق ويهدي الى صرط العزيز الحميد",
  },
  {
    verseId: 6,
    name: "سبإ",
    surahId: 34,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ هَلۡ نَدُلُّكُمۡ عَلَىٰ رَجُلٖ يُنَبِّئُكُمۡ إِذَا مُزِّقۡتُمۡ كُلَّ مُمَزَّقٍ إِنَّكُمۡ لَفِي خَلۡقٖ جَدِيدٍ",
    translation:
      'But those who disbelieve say, "Shall we direct you to a man who will inform you [that] when you have disintegrated in complete disintegration, you will [then] be [recreated] in a new creation',
    normalizedText:
      "وقال الذين كفروا هل ندلكم على رجل ينباكم اذا مزقتم كل ممزق انكم لفي خلق جديد",
  },
  {
    verseId: 7,
    name: "سبإ",
    surahId: 34,
    text: "أَفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَم بِهِۦ جِنَّةُۢۗ بَلِ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ فِي ٱلۡعَذَابِ وَٱلضَّلَٰلِ ٱلۡبَعِيدِ",
    translation:
      'Has he invented about Allah a lie or is there in him madness?" Rather, they who do not believe in the Hereafter will be in the punishment and [are in] extreme error',
    normalizedText:
      "افترى على الله كذبا ام به جنة بل الذين لا يامنون بالاخرة في العذاب والضلل البعيد",
  },
  {
    verseId: 8,
    name: "سبإ",
    surahId: 34,
    text: "أَفَلَمۡ يَرَوۡاْ إِلَىٰ مَا بَيۡنَ أَيۡدِيهِمۡ وَمَا خَلۡفَهُم مِّنَ ٱلسَّمَآءِ وَٱلۡأَرۡضِۚ إِن نَّشَأۡ نَخۡسِفۡ بِهِمُ ٱلۡأَرۡضَ أَوۡ نُسۡقِطۡ عَلَيۡهِمۡ كِسَفٗا مِّنَ ٱلسَّمَآءِۚ إِنَّ فِي ذَٰلِكَ لَأٓيَةٗ لِّكُلِّ عَبۡدٖ مُّنِيبٖ",
    translation:
      "Then, do they not look at what is before them and what is behind them of the heaven and earth? If We should will, We could cause the earth to swallow them or [could] let fall upon them fragments from the sky. Indeed in that is a sign for every servant turning back [to Allah]",
    normalizedText:
      "افلم يروا الى ما بين ايديهم وما خلفهم من السماء والارض ان نشا نخسف بهم الارض او نسقط عليهم كسفا من السماء ان في ذلك لاية لكل عبد منيب",
  },
  {
    verseId: 9,
    name: "سبإ",
    surahId: 34,
    text: "۞وَلَقَدۡ ءَاتَيۡنَا دَاوُۥدَ مِنَّا فَضۡلٗاۖ يَٰجِبَالُ أَوِّبِي مَعَهُۥ وَٱلطَّيۡرَۖ وَأَلَنَّا لَهُ ٱلۡحَدِيدَ",
    translation:
      'And We certainly gave David from Us bounty. [We said], "O mountains, repeat [Our] praises with him, and the birds [as well]." And We made pliable for him iron',
    normalizedText:
      "۞ولقد ءاتينا داود منا فضلا يجبال اوبي معه والطير والنا له الحديد",
  },
  {
    verseId: 10,
    name: "سبإ",
    surahId: 34,
    text: "أَنِ ٱعۡمَلۡ سَٰبِغَٰتٖ وَقَدِّرۡ فِي ٱلسَّرۡدِۖ وَٱعۡمَلُواْ صَٰلِحًاۖ إِنِّي بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      '[Commanding him], "Make full coats of mail and calculate [precisely] the links, and work [all of you] righteousness. Indeed I, of what you do, am Seeing',
    normalizedText:
      "ان اعمل سبغت وقدر في السرد واعملوا صلحا اني بما تعملون بصير",
  },
  {
    verseId: 11,
    name: "سبإ",
    surahId: 34,
    text: "وَلِسُلَيۡمَٰنَ ٱلرِّيحَ غُدُوُّهَا شَهۡرٞ وَرَوَاحُهَا شَهۡرٞۖ وَأَسَلۡنَا لَهُۥ عَيۡنَ ٱلۡقِطۡرِۖ وَمِنَ ٱلۡجِنِّ مَن يَعۡمَلُ بَيۡنَ يَدَيۡهِ بِإِذۡنِ رَبِّهِۦۖ وَمَن يَزِغۡ مِنۡهُمۡ عَنۡ أَمۡرِنَا نُذِقۡهُ مِنۡ عَذَابِ ٱلسَّعِيرِ",
    translation:
      "And to Solomon [We subjected] the wind - its morning [journey was that of] a month - and its afternoon [journey was that of] a month, and We made flow for him a spring of [liquid] copper. And among the jinn were those who worked for him by the permission of his Lord. And whoever deviated among them from Our command - We will make him taste of the punishment of the Blaze",
    normalizedText:
      "ولسليمن الريح غدوها شهر ورواحها شهر واسلنا له عين القطر ومن الجن من يعمل بين يديه باذن ربه ومن يزغ منهم عن امرنا نذقه من عذاب السعير",
  },
  {
    verseId: 12,
    name: "سبإ",
    surahId: 34,
    text: "يَعۡمَلُونَ لَهُۥ مَا يَشَآءُ مِن مَّحَٰرِيبَ وَتَمَٰثِيلَ وَجِفَانٖ كَٱلۡجَوَابِ وَقُدُورٖ رَّاسِيَٰتٍۚ ٱعۡمَلُوٓاْ ءَالَ دَاوُۥدَ شُكۡرٗاۚ وَقَلِيلٞ مِّنۡ عِبَادِيَ ٱلشَّكُورُ",
    translation:
      'They made for him what he willed of elevated chambers, statues, bowls like reservoirs, and stationary kettles. [We said], "Work, O family of David, in gratitude." And few of My servants are grateful',
    normalizedText:
      "يعملون له ما يشاء من محريب وتمثيل وجفان كالجواب وقدور راسيت اعملوا ءال داود شكرا وقليل من عبادي الشكور",
  },
  {
    verseId: 13,
    name: "سبإ",
    surahId: 34,
    text: "فَلَمَّا قَضَيۡنَا عَلَيۡهِ ٱلۡمَوۡتَ مَا دَلَّهُمۡ عَلَىٰ مَوۡتِهِۦٓ إِلَّا دَآبَّةُ ٱلۡأَرۡضِ تَأۡكُلُ مِنسَأَتَهُۥۖ فَلَمَّا خَرَّ تَبَيَّنَتِ ٱلۡجِنُّ أَن لَّوۡ كَانُواْ يَعۡلَمُونَ ٱلۡغَيۡبَ مَا لَبِثُواْ فِي ٱلۡعَذَابِ ٱلۡمُهِينِ",
    translation:
      "And when We decreed for Solomon death, nothing indicated to the jinn his death except a creature of the earth eating his staff. But when he fell, it became clear to the jinn that if they had known the unseen, they would not have remained in humiliating punishment",
    normalizedText:
      "فلما قضينا عليه الموت ما دلهم على موته الا دابة الارض تاكل منساته فلما خر تبينت الجن ان لو كانوا يعلمون الغيب ما لبثوا في العذاب المهين",
  },
  {
    verseId: 14,
    name: "سبإ",
    surahId: 34,
    text: "لَقَدۡ كَانَ لِسَبَإٖ فِي مَسۡكَنِهِمۡ ءَايَةٞۖ جَنَّتَانِ عَن يَمِينٖ وَشِمَالٖۖ كُلُواْ مِن رِّزۡقِ رَبِّكُمۡ وَٱشۡكُرُواْ لَهُۥۚ بَلۡدَةٞ طَيِّبَةٞ وَرَبٌّ غَفُورٞ",
    translation: `There was for [the tribe of] Saba' in their dwelling place a sign: two [fields of] gardens on the right and on the left. [They were told], "Eat from the provisions of your Lord and be grateful to Him. A good land [have you], and a forgiving Lord`,
    normalizedText:
      "لقد كان لسبا في مسكنهم ءاية جنتان عن يمين وشمال كلوا من رزق ربكم واشكروا له بلدة طيبة ورب غفور",
  },
  {
    verseId: 15,
    name: "سبإ",
    surahId: 34,
    text: "فَأَعۡرَضُواْ فَأَرۡسَلۡنَا عَلَيۡهِمۡ سَيۡلَ ٱلۡعَرِمِ وَبَدَّلۡنَٰهُم بِجَنَّتَيۡهِمۡ جَنَّتَيۡنِ ذَوَاتَيۡ أُكُلٍ خَمۡطٖ وَأَثۡلٖ وَشَيۡءٖ مِّن سِدۡرٖ قَلِيلٖ",
    translation:
      "But they turned away [refusing], so We sent upon them the flood of the dam, and We replaced their two [fields of] gardens with gardens of bitter fruit, tamarisks and something of sparse lote trees",
    normalizedText:
      "فاعرضوا فارسلنا عليهم سيل العرم وبدلنهم بجنتيهم جنتين ذواتي اكل خمط واثل وشيء من سدر قليل",
  },
  {
    verseId: 16,
    name: "سبإ",
    surahId: 34,
    text: "ذَٰلِكَ جَزَيۡنَٰهُم بِمَا كَفَرُواْۖ وَهَلۡ نُجَٰزِيٓ إِلَّا ٱلۡكَفُورَ",
    translation:
      "[By] that We repaid them because they disbelieved. And do We [thus] repay except the ungrateful",
    normalizedText: "ذلك جزينهم بما كفروا وهل نجزي الا الكفور",
  },
  {
    verseId: 17,
    name: "سبإ",
    surahId: 34,
    text: "وَجَعَلۡنَا بَيۡنَهُمۡ وَبَيۡنَ ٱلۡقُرَى ٱلَّتِي بَٰرَكۡنَا فِيهَا قُرٗى ظَٰهِرَةٗ وَقَدَّرۡنَا فِيهَا ٱلسَّيۡرَۖ سِيرُواْ فِيهَا لَيَالِيَ وَأَيَّامًا ءَامِنِينَ",
    translation:
      'And We placed between them and the cities which We had blessed [many] visible cities. And We determined between them the [distances of] journey, [saying], "Travel between them by night or day in safety',
    normalizedText:
      "وجعلنا بينهم وبين القرى التي بركنا فيها قرى ظهرة وقدرنا فيها السير سيروا فيها ليالي واياما ءامنين",
  },
  {
    verseId: 18,
    name: "سبإ",
    surahId: 34,
    text: "فَقَالُواْ رَبَّنَا بَٰعِدۡ بَيۡنَ أَسۡفَارِنَا وَظَلَمُوٓاْ أَنفُسَهُمۡ فَجَعَلۡنَٰهُمۡ أَحَادِيثَ وَمَزَّقۡنَٰهُمۡ كُلَّ مُمَزَّقٍۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّكُلِّ صَبَّارٖ شَكُورٖ",
    translation:
      'But [insolently] they said, "Our Lord, lengthen the distance between our journeys," and wronged themselves, so We made them narrations and dispersed them in total dispersion. Indeed in that are signs for everyone patient and grateful',
    normalizedText:
      "فقالوا ربنا بعد بين اسفارنا وظلموا انفسهم فجعلنهم احاديث ومزقنهم كل ممزق ان في ذلك لايت لكل صبار شكور",
  },
  {
    verseId: 19,
    name: "سبإ",
    surahId: 34,
    text: "وَلَقَدۡ صَدَّقَ عَلَيۡهِمۡ إِبۡلِيسُ ظَنَّهُۥ فَٱتَّبَعُوهُ إِلَّا فَرِيقٗا مِّنَ ٱلۡمُؤۡمِنِينَ",
    translation:
      "And Iblees had already confirmed through them his assumption, so they followed him, except for a party of believers",
    normalizedText: "ولقد صدق عليهم ابليس ظنه فاتبعوه الا فريقا من المامنين",
  },
  {
    verseId: 20,
    name: "سبإ",
    surahId: 34,
    text: "وَمَا كَانَ لَهُۥ عَلَيۡهِم مِّن سُلۡطَٰنٍ إِلَّا لِنَعۡلَمَ مَن يُؤۡمِنُ بِٱلۡأٓخِرَةِ مِمَّنۡ هُوَ مِنۡهَا فِي شَكّٖۗ وَرَبُّكَ عَلَىٰ كُلِّ شَيۡءٍ حَفِيظٞ",
    translation:
      "And he had over them no authority except [it was decreed] that We might make evident who believes in the Hereafter from who is thereof in doubt. And your Lord, over all things, is Guardian",
    normalizedText:
      "وما كان له عليهم من سلطن الا لنعلم من يامن بالاخرة ممن هو منها في شك وربك على كل شيء حفيظ",
  },
  {
    verseId: 21,
    name: "سبإ",
    surahId: 34,
    text: "قُلِ ٱدۡعُواْ ٱلَّذِينَ زَعَمۡتُم مِّن دُونِ ٱللَّهِ لَا يَمۡلِكُونَ مِثۡقَالَ ذَرَّةٖ فِي ٱلسَّمَٰوَٰتِ وَلَا فِي ٱلۡأَرۡضِ وَمَا لَهُمۡ فِيهِمَا مِن شِرۡكٖ وَمَا لَهُۥ مِنۡهُم مِّن ظَهِيرٖ",
    translation: `Say, [O Muhammad], "Invoke those you claim [as deities] besides Allah." They do not possess an atom's weight [of ability] in the heavens or on the earth, and they do not have therein any partnership [with Him], nor is there for Him from among them any assistant`,
    normalizedText:
      "قل ادعوا الذين زعمتم من دون الله لا يملكون مثقال ذرة في السموت ولا في الارض وما لهم فيهما من شرك وما له منهم من ظهير",
  },
  {
    verseId: 22,
    name: "سبإ",
    surahId: 34,
    text: "وَلَا تَنفَعُ ٱلشَّفَٰعَةُ عِندَهُۥٓ إِلَّا لِمَنۡ أَذِنَ لَهُۥۚ حَتَّىٰٓ إِذَا فُزِّعَ عَن قُلُوبِهِمۡ قَالُواْ مَاذَا قَالَ رَبُّكُمۡۖ قَالُواْ ٱلۡحَقَّۖ وَهُوَ ٱلۡعَلِيُّ ٱلۡكَبِيرُ",
    translation:
      'And intercession does not benefit with Him except for one whom He permits. [And those wait] until, when terror is removed from their hearts, they will say [to one another], "What has your Lord said?" They will say, "The truth." And He is the Most High, the Grand',
    normalizedText:
      "ولا تنفع الشفعة عنده الا لمن اذن له حتى اذا فزع عن قلوبهم قالوا ماذا قال ربكم قالوا الحق وهو العلي الكبير",
  },
  {
    verseId: 23,
    name: "سبإ",
    surahId: 34,
    text: "۞قُلۡ مَن يَرۡزُقُكُم مِّنَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ قُلِ ٱللَّهُۖ وَإِنَّآ أَوۡ إِيَّاكُمۡ لَعَلَىٰ هُدًى أَوۡ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      'Say, "Who provides for you from the heavens and the earth?" Say, "Allah. And indeed, we or you are either upon guidance or in clear error',
    normalizedText:
      "۞قل من يرزقكم من السموت والارض قل الله وانا او اياكم لعلى هدى او في ضلل مبين",
  },
  {
    verseId: 24,
    name: "سبإ",
    surahId: 34,
    text: "قُل لَّا تُسۡـَٔلُونَ عَمَّآ أَجۡرَمۡنَا وَلَا نُسۡـَٔلُ عَمَّا تَعۡمَلُونَ",
    translation:
      'Say, "You will not be asked about what we committed, and we will not be asked about what you do',
    normalizedText: "قل لا تسلون عما اجرمنا ولا نسل عما تعملون",
  },
  {
    verseId: 25,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ يَجۡمَعُ بَيۡنَنَا رَبُّنَا ثُمَّ يَفۡتَحُ بَيۡنَنَا بِٱلۡحَقِّ وَهُوَ ٱلۡفَتَّاحُ ٱلۡعَلِيمُ",
    translation:
      'Say, "Our Lord will bring us together; then He will judge between us in truth. And He is the Knowing Judge',
    normalizedText: "قل يجمع بيننا ربنا ثم يفتح بيننا بالحق وهو الفتاح العليم",
  },
  {
    verseId: 26,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ أَرُونِيَ ٱلَّذِينَ أَلۡحَقۡتُم بِهِۦ شُرَكَآءَۖ كَلَّاۚ بَلۡ هُوَ ٱللَّهُ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      'Say, "Show me those whom you have attached to Him as partners. No! Rather, He [alone] is Allah, the Exalted in Might, the Wise',
    normalizedText:
      "قل اروني الذين الحقتم به شركاء كلا بل هو الله العزيز الحكيم",
  },
  {
    verseId: 27,
    name: "سبإ",
    surahId: 34,
    text: "وَمَآ أَرۡسَلۡنَٰكَ إِلَّا كَآفَّةٗ لِّلنَّاسِ بَشِيرٗا وَنَذِيرٗا وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      "And We have not sent you except comprehensively to mankind as a bringer of good tidings and a warner. But most of the people do not know",
    normalizedText:
      "وما ارسلنك الا كافة للناس بشيرا ونذيرا ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 28,
    name: "سبإ",
    surahId: 34,
    text: "وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلۡوَعۡدُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "When is this promise, if you should be truthful',
    normalizedText: "ويقولون متى هذا الوعد ان كنتم صدقين",
  },
  {
    verseId: 29,
    name: "سبإ",
    surahId: 34,
    text: "قُل لَّكُم مِّيعَادُ يَوۡمٖ لَّا تَسۡتَـٔۡخِرُونَ عَنۡهُ سَاعَةٗ وَلَا تَسۡتَقۡدِمُونَ",
    translation:
      'Say, "For you is the appointment of a Day [when] you will not remain thereafter an hour, nor will you precede [it]',
    normalizedText: "قل لكم ميعاد يوم لا تستخرون عنه ساعة ولا تستقدمون",
  },
  {
    verseId: 30,
    name: "سبإ",
    surahId: 34,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ لَن نُّؤۡمِنَ بِهَٰذَا ٱلۡقُرۡءَانِ وَلَا بِٱلَّذِي بَيۡنَ يَدَيۡهِۗ وَلَوۡ تَرَىٰٓ إِذِ ٱلظَّـٰلِمُونَ مَوۡقُوفُونَ عِندَ رَبِّهِمۡ يَرۡجِعُ بَعۡضُهُمۡ إِلَىٰ بَعۡضٍ ٱلۡقَوۡلَ يَقُولُ ٱلَّذِينَ ٱسۡتُضۡعِفُواْ لِلَّذِينَ ٱسۡتَكۡبَرُواْ لَوۡلَآ أَنتُمۡ لَكُنَّا مُؤۡمِنِينَ",
    translation: `And those who disbelieve say, "We will never believe in this Qur'an nor in that before it." But if you could see when the wrongdoers are made to stand before their Lord, refuting each other's words... Those who were oppressed will say to those who were arrogant, "If not for you, we would have been believers`,
    normalizedText:
      "وقال الذين كفروا لن نامن بهذا القرءان ولا بالذي بين يديه ولو ترى اذ الظلمون موقوفون عند ربهم يرجع بعضهم الى بعض القول يقول الذين استضعفوا للذين استكبروا لولا انتم لكنا مامنين",
  },
  {
    verseId: 31,
    name: "سبإ",
    surahId: 34,
    text: "قَالَ ٱلَّذِينَ ٱسۡتَكۡبَرُواْ لِلَّذِينَ ٱسۡتُضۡعِفُوٓاْ أَنَحۡنُ صَدَدۡنَٰكُمۡ عَنِ ٱلۡهُدَىٰ بَعۡدَ إِذۡ جَآءَكُمۖ بَلۡ كُنتُم مُّجۡرِمِينَ",
    translation:
      'Those who were arrogant will say to those who were oppressed, "Did we avert you from guidance after it had come to you? Rather, you were criminals',
    normalizedText:
      "قال الذين استكبروا للذين استضعفوا انحن صددنكم عن الهدى بعد اذ جاءكم بل كنتم مجرمين",
  },
  {
    verseId: 32,
    name: "سبإ",
    surahId: 34,
    text: "وَقَالَ ٱلَّذِينَ ٱسۡتُضۡعِفُواْ لِلَّذِينَ ٱسۡتَكۡبَرُواْ بَلۡ مَكۡرُ ٱلَّيۡلِ وَٱلنَّهَارِ إِذۡ تَأۡمُرُونَنَآ أَن نَّكۡفُرَ بِٱللَّهِ وَنَجۡعَلَ لَهُۥٓ أَندَادٗاۚ وَأَسَرُّواْ ٱلنَّدَامَةَ لَمَّا رَأَوُاْ ٱلۡعَذَابَۚ وَجَعَلۡنَا ٱلۡأَغۡلَٰلَ فِيٓ أَعۡنَاقِ ٱلَّذِينَ كَفَرُواْۖ هَلۡ يُجۡزَوۡنَ إِلَّا مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      'Those who were oppressed will say to those who were arrogant, "Rather, [it was your] conspiracy of night and day when you were ordering us to disbelieve in Allah and attribute to Him equals." But they will [all] confide regret when they see the punishment; and We will put shackles on the necks of those who disbelieved. Will they be recompensed except for what they used to do',
    normalizedText:
      "وقال الذين استضعفوا للذين استكبروا بل مكر اليل والنهار اذ تامروننا ان نكفر بالله ونجعل له اندادا واسروا الندامة لما راوا العذاب وجعلنا الاغلل في اعناق الذين كفروا هل يجزون الا ما كانوا يعملون",
  },
  {
    verseId: 33,
    name: "سبإ",
    surahId: 34,
    text: "وَمَآ أَرۡسَلۡنَا فِي قَرۡيَةٖ مِّن نَّذِيرٍ إِلَّا قَالَ مُتۡرَفُوهَآ إِنَّا بِمَآ أُرۡسِلۡتُم بِهِۦ كَٰفِرُونَ",
    translation:
      'And We did not send into a city any warner except that its affluent said, "Indeed we, in that with which you were sent, are disbelievers',
    normalizedText:
      "وما ارسلنا في قرية من نذير الا قال مترفوها انا بما ارسلتم به كفرون",
  },
  {
    verseId: 34,
    name: "سبإ",
    surahId: 34,
    text: "وَقَالُواْ نَحۡنُ أَكۡثَرُ أَمۡوَٰلٗا وَأَوۡلَٰدٗا وَمَا نَحۡنُ بِمُعَذَّبِينَ",
    translation:
      'And they said, "We are more [than the believers] in wealth and children, and we are not to be punished',
    normalizedText: "وقالوا نحن اكثر امولا واولدا وما نحن بمعذبين",
  },
  {
    verseId: 35,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ إِنَّ رَبِّي يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ وَيَقۡدِرُ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      'Say, "Indeed, my Lord extends provision for whom He wills and restricts [it], but most of the people do not know',
    normalizedText:
      "قل ان ربي يبسط الرزق لمن يشاء ويقدر ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 36,
    name: "سبإ",
    surahId: 34,
    text: "وَمَآ أَمۡوَٰلُكُمۡ وَلَآ أَوۡلَٰدُكُم بِٱلَّتِي تُقَرِّبُكُمۡ عِندَنَا زُلۡفَىٰٓ إِلَّا مَنۡ ءَامَنَ وَعَمِلَ صَٰلِحٗا فَأُوْلَـٰٓئِكَ لَهُمۡ جَزَآءُ ٱلضِّعۡفِ بِمَا عَمِلُواْ وَهُمۡ فِي ٱلۡغُرُفَٰتِ ءَامِنُونَ",
    translation:
      "And it is not your wealth or your children that bring you nearer to Us in position, but it is [by being] one who has believed and done righteousness. For them there will be the double reward for what they did, and they will be in the upper chambers [of Paradise], safe [and secure]",
    normalizedText:
      "وما امولكم ولا اولدكم بالتي تقربكم عندنا زلفى الا من ءامن وعمل صلحا فاولاك لهم جزاء الضعف بما عملوا وهم في الغرفت ءامنون",
  },
  {
    verseId: 37,
    name: "سبإ",
    surahId: 34,
    text: "وَٱلَّذِينَ يَسۡعَوۡنَ فِيٓ ءَايَٰتِنَا مُعَٰجِزِينَ أُوْلَـٰٓئِكَ فِي ٱلۡعَذَابِ مُحۡضَرُونَ",
    translation:
      "And the ones who strive against Our verses to cause [them] failure - those will be brought into the punishment [to remain]",
    normalizedText: "والذين يسعون في ءايتنا معجزين اولاك في العذاب محضرون",
  },
  {
    verseId: 38,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ إِنَّ رَبِّي يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ مِنۡ عِبَادِهِۦ وَيَقۡدِرُ لَهُۥۚ وَمَآ أَنفَقۡتُم مِّن شَيۡءٖ فَهُوَ يُخۡلِفُهُۥۖ وَهُوَ خَيۡرُ ٱلرَّـٰزِقِينَ",
    translation:
      'Say, "Indeed, my Lord extends provision for whom He wills of His servants and restricts [it] for him. But whatever thing you spend [in His cause] - He will compensate it; and He is the best of providers',
    normalizedText:
      "قل ان ربي يبسط الرزق لمن يشاء من عباده ويقدر له وما انفقتم من شيء فهو يخلفه وهو خير الرزقين",
  },
  {
    verseId: 39,
    name: "سبإ",
    surahId: 34,
    text: "وَيَوۡمَ يَحۡشُرُهُمۡ جَمِيعٗا ثُمَّ يَقُولُ لِلۡمَلَـٰٓئِكَةِ أَهَـٰٓؤُلَآءِ إِيَّاكُمۡ كَانُواْ يَعۡبُدُونَ",
    translation:
      'And [mention] the Day when He will gather them all and then say to the angels, "Did these [people] used to worship you',
    normalizedText:
      "ويوم يحشرهم جميعا ثم يقول للملاكة اهالاء اياكم كانوا يعبدون",
  },
  {
    verseId: 40,
    name: "سبإ",
    surahId: 34,
    text: "قَالُواْ سُبۡحَٰنَكَ أَنتَ وَلِيُّنَا مِن دُونِهِمۖ بَلۡ كَانُواْ يَعۡبُدُونَ ٱلۡجِنَّۖ أَكۡثَرُهُم بِهِم مُّؤۡمِنُونَ",
    translation:
      'They will say, "Exalted are You! You, [O Allah], are our benefactor not them. Rather, they used to worship the jinn; most of them were believers in them',
    normalizedText:
      "قالوا سبحنك انت ولينا من دونهم بل كانوا يعبدون الجن اكثرهم بهم مامنون",
  },
  {
    verseId: 41,
    name: "سبإ",
    surahId: 34,
    text: "فَٱلۡيَوۡمَ لَا يَمۡلِكُ بَعۡضُكُمۡ لِبَعۡضٖ نَّفۡعٗا وَلَا ضَرّٗا وَنَقُولُ لِلَّذِينَ ظَلَمُواْ ذُوقُواْ عَذَابَ ٱلنَّارِ ٱلَّتِي كُنتُم بِهَا تُكَذِّبُونَ",
    translation:
      'But today you do not hold for one another [the power of] benefit or harm, and We will say to those who wronged, "Taste the punishment of the Fire, which you used to deny',
    normalizedText:
      "فاليوم لا يملك بعضكم لبعض نفعا ولا ضرا ونقول للذين ظلموا ذوقوا عذاب النار التي كنتم بها تكذبون",
  },
  {
    verseId: 42,
    name: "سبإ",
    surahId: 34,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَٰتُنَا بَيِّنَٰتٖ قَالُواْ مَا هَٰذَآ إِلَّا رَجُلٞ يُرِيدُ أَن يَصُدَّكُمۡ عَمَّا كَانَ يَعۡبُدُ ءَابَآؤُكُمۡ وَقَالُواْ مَا هَٰذَآ إِلَّآ إِفۡكٞ مُّفۡتَرٗىۚ وَقَالَ ٱلَّذِينَ كَفَرُواْ لِلۡحَقِّ لَمَّا جَآءَهُمۡ إِنۡ هَٰذَآ إِلَّا سِحۡرٞ مُّبِينٞ",
    translation:
      'And when our verses are recited to them as clear evidences, they say, "This is not but a man who wishes to avert you from that which your fathers were worshipping." And they say, "This is not except a lie invented." And those who disbelieve say of the truth when it has come to them, "This is not but obvious magic',
    normalizedText:
      "واذا تتلى عليهم ءايتنا بينت قالوا ما هذا الا رجل يريد ان يصدكم عما كان يعبد ءابااكم وقالوا ما هذا الا افك مفترى وقال الذين كفروا للحق لما جاءهم ان هذا الا سحر مبين",
  },
  {
    verseId: 43,
    name: "سبإ",
    surahId: 34,
    text: "وَمَآ ءَاتَيۡنَٰهُم مِّن كُتُبٖ يَدۡرُسُونَهَاۖ وَمَآ أَرۡسَلۡنَآ إِلَيۡهِمۡ قَبۡلَكَ مِن نَّذِيرٖ",
    translation:
      "And We had not given them any scriptures which they could study, and We had not sent to them before you, [O Muhammad], any warner",
    normalizedText: "وما ءاتينهم من كتب يدرسونها وما ارسلنا اليهم قبلك من نذير",
  },
  {
    verseId: 44,
    name: "سبإ",
    surahId: 34,
    text: "وَكَذَّبَ ٱلَّذِينَ مِن قَبۡلِهِمۡ وَمَا بَلَغُواْ مِعۡشَارَ مَآ ءَاتَيۡنَٰهُمۡ فَكَذَّبُواْ رُسُلِيۖ فَكَيۡفَ كَانَ نَكِيرِ",
    translation:
      "And those before them denied, and the people of Makkah have not attained a tenth of what We had given them. But the former peoples denied My messengers, so how [terrible] was My reproach",
    normalizedText:
      "وكذب الذين من قبلهم وما بلغوا معشار ما ءاتينهم فكذبوا رسلي فكيف كان نكير",
  },
  {
    verseId: 45,
    name: "سبإ",
    surahId: 34,
    text: "۞قُلۡ إِنَّمَآ أَعِظُكُم بِوَٰحِدَةٍۖ أَن تَقُومُواْ لِلَّهِ مَثۡنَىٰ وَفُرَٰدَىٰ ثُمَّ تَتَفَكَّرُواْۚ مَا بِصَاحِبِكُم مِّن جِنَّةٍۚ إِنۡ هُوَ إِلَّا نَذِيرٞ لَّكُم بَيۡنَ يَدَيۡ عَذَابٖ شَدِيدٖ",
    translation:
      'Say, "I only advise you of one [thing] - that you stand for Allah, [seeking truth] in pairs and individually, and then give thought." There is not in your companion any madness. He is only a warner to you before a severe punishment',
    normalizedText:
      "۞قل انما اعظكم بوحدة ان تقوموا لله مثنى وفردى ثم تتفكروا ما بصاحبكم من جنة ان هو الا نذير لكم بين يدي عذاب شديد",
  },
  {
    verseId: 46,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ مَا سَأَلۡتُكُم مِّنۡ أَجۡرٖ فَهُوَ لَكُمۡۖ إِنۡ أَجۡرِيَ إِلَّا عَلَى ٱللَّهِۖ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدٞ",
    translation:
      'Say, "Whatever payment I might have asked of you - it is yours. My payment is only from Allah, and He is, over all things, Witness',
    normalizedText:
      "قل ما سالتكم من اجر فهو لكم ان اجري الا على الله وهو على كل شيء شهيد",
  },
  {
    verseId: 47,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ إِنَّ رَبِّي يَقۡذِفُ بِٱلۡحَقِّ عَلَّـٰمُ ٱلۡغُيُوبِ",
    translation:
      'Say, "Indeed, my Lord projects the truth. Knower of the unseen',
    normalizedText: "قل ان ربي يقذف بالحق علم الغيوب",
  },
  {
    verseId: 48,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ جَآءَ ٱلۡحَقُّ وَمَا يُبۡدِئُ ٱلۡبَٰطِلُ وَمَا يُعِيدُ",
    translation:
      'Say, "The truth has come, and falsehood can neither begin [anything] nor repeat [it]',
    normalizedText: "قل جاء الحق وما يبدا البطل وما يعيد",
  },
  {
    verseId: 49,
    name: "سبإ",
    surahId: 34,
    text: "قُلۡ إِن ضَلَلۡتُ فَإِنَّمَآ أَضِلُّ عَلَىٰ نَفۡسِيۖ وَإِنِ ٱهۡتَدَيۡتُ فَبِمَا يُوحِيٓ إِلَيَّ رَبِّيٓۚ إِنَّهُۥ سَمِيعٞ قَرِيبٞ",
    translation:
      'Say, "If I should err, I would only err against myself. But if I am guided, it is by what my Lord reveals to me. Indeed, He is Hearing and near',
    normalizedText:
      "قل ان ضللت فانما اضل على نفسي وان اهتديت فبما يوحي الي ربي انه سميع قريب",
  },
  {
    verseId: 50,
    name: "سبإ",
    surahId: 34,
    text: "وَلَوۡ تَرَىٰٓ إِذۡ فَزِعُواْ فَلَا فَوۡتَ وَأُخِذُواْ مِن مَّكَانٖ قَرِيبٖ",
    translation:
      "And if you could see when they are terrified but there is no escape, and they will be seized from a place nearby",
    normalizedText: "ولو ترى اذ فزعوا فلا فوت واخذوا من مكان قريب",
  },
  {
    verseId: 51,
    name: "سبإ",
    surahId: 34,
    text: "وَقَالُوٓاْ ءَامَنَّا بِهِۦ وَأَنَّىٰ لَهُمُ ٱلتَّنَاوُشُ مِن مَّكَانِۭ بَعِيدٖ",
    translation:
      'And they will [then] say, "We believe in it!" But how for them will be the taking [of faith] from a place far away',
    normalizedText: "وقالوا ءامنا به وانى لهم التناوش من مكان بعيد",
  },
  {
    verseId: 52,
    name: "سبإ",
    surahId: 34,
    text: "وَقَدۡ كَفَرُواْ بِهِۦ مِن قَبۡلُۖ وَيَقۡذِفُونَ بِٱلۡغَيۡبِ مِن مَّكَانِۭ بَعِيدٖ",
    translation:
      "And they had already disbelieved in it before and would assault the unseen from a place far away",
    normalizedText: "وقد كفروا به من قبل ويقذفون بالغيب من مكان بعيد",
  },
  {
    verseId: 53,
    name: "سبإ",
    surahId: 34,
    text: "وَحِيلَ بَيۡنَهُمۡ وَبَيۡنَ مَا يَشۡتَهُونَ كَمَا فُعِلَ بِأَشۡيَاعِهِم مِّن قَبۡلُۚ إِنَّهُمۡ كَانُواْ فِي شَكّٖ مُّرِيبِۭ",
    translation:
      "And prevention will be placed between them and what they desire, as was done with their kind before. Indeed, they were in disquieting denial",
    normalizedText:
      "وحيل بينهم وبين ما يشتهون كما فعل باشياعهم من قبل انهم كانوا في شك مريب",
  },
  {
    verseId: 0,
    name: "فاطر",
    surahId: 35,
    text: "ٱلۡحَمۡدُ لِلَّهِ فَاطِرِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ جَاعِلِ ٱلۡمَلَـٰٓئِكَةِ رُسُلًا أُوْلِيٓ أَجۡنِحَةٖ مَّثۡنَىٰ وَثُلَٰثَ وَرُبَٰعَۚ يَزِيدُ فِي ٱلۡخَلۡقِ مَا يَشَآءُۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "[All] praise is [due] to Allah, Creator of the heavens and the earth, [who] made the angels messengers having wings, two or three or four. He increases in creation what He wills. Indeed, Allah is over all things competent",
    normalizedText:
      "الحمد لله فاطر السموت والارض جاعل الملاكة رسلا اولي اجنحة مثنى وثلث وربع يزيد في الخلق ما يشاء ان الله على كل شيء قدير",
  },
  {
    verseId: 1,
    name: "فاطر",
    surahId: 35,
    text: "مَّا يَفۡتَحِ ٱللَّهُ لِلنَّاسِ مِن رَّحۡمَةٖ فَلَا مُمۡسِكَ لَهَاۖ وَمَا يُمۡسِكۡ فَلَا مُرۡسِلَ لَهُۥ مِنۢ بَعۡدِهِۦۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Whatever Allah grants to people of mercy - none can withhold it; and whatever He withholds - none can release it thereafter. And He is the Exalted in Might, the Wise",
    normalizedText:
      "ما يفتح الله للناس من رحمة فلا ممسك لها وما يمسك فلا مرسل له من بعده وهو العزيز الحكيم",
  },
  {
    verseId: 2,
    name: "فاطر",
    surahId: 35,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ ٱذۡكُرُواْ نِعۡمَتَ ٱللَّهِ عَلَيۡكُمۡۚ هَلۡ مِنۡ خَٰلِقٍ غَيۡرُ ٱللَّهِ يَرۡزُقُكُم مِّنَ ٱلسَّمَآءِ وَٱلۡأَرۡضِۚ لَآ إِلَٰهَ إِلَّا هُوَۖ فَأَنَّىٰ تُؤۡفَكُونَ",
    translation:
      "O mankind, remember the favor of Allah upon you. Is there any creator other than Allah who provides for you from the heaven and earth? There is no deity except Him, so how are you deluded",
    normalizedText:
      "يايها الناس اذكروا نعمت الله عليكم هل من خلق غير الله يرزقكم من السماء والارض لا اله الا هو فانى تافكون",
  },
  {
    verseId: 3,
    name: "فاطر",
    surahId: 35,
    text: "وَإِن يُكَذِّبُوكَ فَقَدۡ كُذِّبَتۡ رُسُلٞ مِّن قَبۡلِكَۚ وَإِلَى ٱللَّهِ تُرۡجَعُ ٱلۡأُمُورُ",
    translation:
      "And if they deny you, [O Muhammad] - already were messengers denied before you. And to Allah are returned [all] matters",
    normalizedText: "وان يكذبوك فقد كذبت رسل من قبلك والى الله ترجع الامور",
  },
  {
    verseId: 4,
    name: "فاطر",
    surahId: 35,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞۖ فَلَا تَغُرَّنَّكُمُ ٱلۡحَيَوٰةُ ٱلدُّنۡيَا وَلَا يَغُرَّنَّكُم بِٱللَّهِ ٱلۡغَرُورُ",
    translation:
      "O mankind, indeed the promise of Allah is truth, so let not the worldly life delude you and be not deceived about Allah by the Deceiver",
    normalizedText:
      "يايها الناس ان وعد الله حق فلا تغرنكم الحيوة الدنيا ولا يغرنكم بالله الغرور",
  },
  {
    verseId: 5,
    name: "فاطر",
    surahId: 35,
    text: "إِنَّ ٱلشَّيۡطَٰنَ لَكُمۡ عَدُوّٞ فَٱتَّخِذُوهُ عَدُوًّاۚ إِنَّمَا يَدۡعُواْ حِزۡبَهُۥ لِيَكُونُواْ مِنۡ أَصۡحَٰبِ ٱلسَّعِيرِ",
    translation:
      "Indeed, Satan is an enemy to you; so take him as an enemy. He only invites his party to be among the companions of the Blaze",
    normalizedText:
      "ان الشيطن لكم عدو فاتخذوه عدوا انما يدعوا حزبه ليكونوا من اصحب السعير",
  },
  {
    verseId: 6,
    name: "فاطر",
    surahId: 35,
    text: "ٱلَّذِينَ كَفَرُواْ لَهُمۡ عَذَابٞ شَدِيدٞۖ وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَهُم مَّغۡفِرَةٞ وَأَجۡرٞ كَبِيرٌ",
    translation:
      "Those who disbelieve will have a severe punishment, and those who believe and do righteous deeds will have forgiveness and great reward",
    normalizedText:
      "الذين كفروا لهم عذاب شديد والذين ءامنوا وعملوا الصلحت لهم مغفرة واجر كبير",
  },
  {
    verseId: 7,
    name: "فاطر",
    surahId: 35,
    text: "أَفَمَن زُيِّنَ لَهُۥ سُوٓءُ عَمَلِهِۦ فَرَءَاهُ حَسَنٗاۖ فَإِنَّ ٱللَّهَ يُضِلُّ مَن يَشَآءُ وَيَهۡدِي مَن يَشَآءُۖ فَلَا تَذۡهَبۡ نَفۡسُكَ عَلَيۡهِمۡ حَسَرَٰتٍۚ إِنَّ ٱللَّهَ عَلِيمُۢ بِمَا يَصۡنَعُونَ",
    translation:
      "Then is one to whom the evil of his deed has been made attractive so he considers it good [like one rightly guided]? For indeed, Allah sends astray whom He wills and guides whom He wills. So do not let yourself perish over them in regret. Indeed, Allah is Knowing of what they do",
    normalizedText:
      "افمن زين له سوء عمله فرءاه حسنا فان الله يضل من يشاء ويهدي من يشاء فلا تذهب نفسك عليهم حسرت ان الله عليم بما يصنعون",
  },
  {
    verseId: 8,
    name: "فاطر",
    surahId: 35,
    text: "وَٱللَّهُ ٱلَّذِيٓ أَرۡسَلَ ٱلرِّيَٰحَ فَتُثِيرُ سَحَابٗا فَسُقۡنَٰهُ إِلَىٰ بَلَدٖ مَّيِّتٖ فَأَحۡيَيۡنَا بِهِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَاۚ كَذَٰلِكَ ٱلنُّشُورُ",
    translation:
      "And it is Allah who sends the winds, and they stir the clouds, and We drive them to a dead land and give life thereby to the earth after its lifelessness. Thus is the resurrection",
    normalizedText:
      "والله الذي ارسل الريح فتثير سحابا فسقنه الى بلد ميت فاحيينا به الارض بعد موتها كذلك النشور",
  },
  {
    verseId: 9,
    name: "فاطر",
    surahId: 35,
    text: "مَن كَانَ يُرِيدُ ٱلۡعِزَّةَ فَلِلَّهِ ٱلۡعِزَّةُ جَمِيعًاۚ إِلَيۡهِ يَصۡعَدُ ٱلۡكَلِمُ ٱلطَّيِّبُ وَٱلۡعَمَلُ ٱلصَّـٰلِحُ يَرۡفَعُهُۥۚ وَٱلَّذِينَ يَمۡكُرُونَ ٱلسَّيِّـَٔاتِ لَهُمۡ عَذَابٞ شَدِيدٞۖ وَمَكۡرُ أُوْلَـٰٓئِكَ هُوَ يَبُورُ",
    translation:
      "Whoever desires honor [through power] - then to Allah belongs all honor. To Him ascends good speech, and righteous work raises it. But they who plot evil deeds will have a severe punishment, and the plotting of those - it will perish",
    normalizedText:
      "من كان يريد العزة فلله العزة جميعا اليه يصعد الكلم الطيب والعمل الصلح يرفعه والذين يمكرون السيات لهم عذاب شديد ومكر اولاك هو يبور",
  },
  {
    verseId: 10,
    name: "فاطر",
    surahId: 35,
    text: "وَٱللَّهُ خَلَقَكُم مِّن تُرَابٖ ثُمَّ مِن نُّطۡفَةٖ ثُمَّ جَعَلَكُمۡ أَزۡوَٰجٗاۚ وَمَا تَحۡمِلُ مِنۡ أُنثَىٰ وَلَا تَضَعُ إِلَّا بِعِلۡمِهِۦۚ وَمَا يُعَمَّرُ مِن مُّعَمَّرٖ وَلَا يُنقَصُ مِنۡ عُمُرِهِۦٓ إِلَّا فِي كِتَٰبٍۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٞ",
    translation:
      "And Allah created you from dust, then from a sperm-drop; then He made you mates. And no female conceives nor does she give birth except with His knowledge. And no aged person is granted [additional] life nor is his lifespan lessened but that it is in a register. Indeed, that for Allah is easy",
    normalizedText:
      "والله خلقكم من تراب ثم من نطفة ثم جعلكم ازوجا وما تحمل من انثى ولا تضع الا بعلمه وما يعمر من معمر ولا ينقص من عمره الا في كتب ان ذلك على الله يسير",
  },
  {
    verseId: 11,
    name: "فاطر",
    surahId: 35,
    text: "وَمَا يَسۡتَوِي ٱلۡبَحۡرَانِ هَٰذَا عَذۡبٞ فُرَاتٞ سَآئِغٞ شَرَابُهُۥ وَهَٰذَا مِلۡحٌ أُجَاجٞۖ وَمِن كُلّٖ تَأۡكُلُونَ لَحۡمٗا طَرِيّٗا وَتَسۡتَخۡرِجُونَ حِلۡيَةٗ تَلۡبَسُونَهَاۖ وَتَرَى ٱلۡفُلۡكَ فِيهِ مَوَاخِرَ لِتَبۡتَغُواْ مِن فَضۡلِهِۦ وَلَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "And not alike are the two bodies of water. One is fresh and sweet, palatable for drinking, and one is salty and bitter. And from each you eat tender meat and extract ornaments which you wear, and you see the ships plowing through [them] that you might seek of His bounty; and perhaps you will be grateful",
    normalizedText:
      "وما يستوي البحران هذا عذب فرات سااغ شرابه وهذا ملح اجاج ومن كل تاكلون لحما طريا وتستخرجون حلية تلبسونها وترى الفلك فيه مواخر لتبتغوا من فضله ولعلكم تشكرون",
  },
  {
    verseId: 12,
    name: "فاطر",
    surahId: 35,
    text: "يُولِجُ ٱلَّيۡلَ فِي ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِي ٱلَّيۡلِ وَسَخَّرَ ٱلشَّمۡسَ وَٱلۡقَمَرَۖ كُلّٞ يَجۡرِي لِأَجَلٖ مُّسَمّٗىۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمۡ لَهُ ٱلۡمُلۡكُۚ وَٱلَّذِينَ تَدۡعُونَ مِن دُونِهِۦ مَا يَمۡلِكُونَ مِن قِطۡمِيرٍ",
    translation:
      "He causes the night to enter the day, and He causes the day to enter the night and has subjected the sun and the moon - each running [its course] for a specified term. That is Allah, your Lord; to Him belongs sovereignty. And those whom you invoke other than Him do not possess [as much as] the membrane of a date seed",
    normalizedText:
      "يولج اليل في النهار ويولج النهار في اليل وسخر الشمس والقمر كل يجري لاجل مسمى ذلكم الله ربكم له الملك والذين تدعون من دونه ما يملكون من قطمير",
  },
  {
    verseId: 13,
    name: "فاطر",
    surahId: 35,
    text: "إِن تَدۡعُوهُمۡ لَا يَسۡمَعُواْ دُعَآءَكُمۡ وَلَوۡ سَمِعُواْ مَا ٱسۡتَجَابُواْ لَكُمۡۖ وَيَوۡمَ ٱلۡقِيَٰمَةِ يَكۡفُرُونَ بِشِرۡكِكُمۡۚ وَلَا يُنَبِّئُكَ مِثۡلُ خَبِيرٖ",
    translation:
      "If you invoke them, they do not hear your supplication; and if they heard, they would not respond to you. And on the Day of Resurrection they will deny your association. And none can inform you like [one] Acquainted [with all matters]",
    normalizedText:
      "ان تدعوهم لا يسمعوا دعاءكم ولو سمعوا ما استجابوا لكم ويوم القيمة يكفرون بشرككم ولا ينباك مثل خبير",
  },
  {
    verseId: 14,
    name: "فاطر",
    surahId: 35,
    text: "۞يَـٰٓأَيُّهَا ٱلنَّاسُ أَنتُمُ ٱلۡفُقَرَآءُ إِلَى ٱللَّهِۖ وَٱللَّهُ هُوَ ٱلۡغَنِيُّ ٱلۡحَمِيدُ",
    translation:
      "O mankind, you are those in need of Allah, while Allah is the Free of need, the Praiseworthy",
    normalizedText: "۞يايها الناس انتم الفقراء الى الله والله هو الغني الحميد",
  },
  {
    verseId: 15,
    name: "فاطر",
    surahId: 35,
    text: "إِن يَشَأۡ يُذۡهِبۡكُمۡ وَيَأۡتِ بِخَلۡقٖ جَدِيدٖ",
    translation:
      "If He wills, He can do away with you and bring forth a new creation",
    normalizedText: "ان يشا يذهبكم ويات بخلق جديد",
  },
  {
    verseId: 16,
    name: "فاطر",
    surahId: 35,
    text: "وَمَا ذَٰلِكَ عَلَى ٱللَّهِ بِعَزِيزٖ",
    translation: "And that is for Allah not difficult",
    normalizedText: "وما ذلك على الله بعزيز",
  },
  {
    verseId: 17,
    name: "فاطر",
    surahId: 35,
    text: "وَلَا تَزِرُ وَازِرَةٞ وِزۡرَ أُخۡرَىٰۚ وَإِن تَدۡعُ مُثۡقَلَةٌ إِلَىٰ حِمۡلِهَا لَا يُحۡمَلۡ مِنۡهُ شَيۡءٞ وَلَوۡ كَانَ ذَا قُرۡبَىٰٓۗ إِنَّمَا تُنذِرُ ٱلَّذِينَ يَخۡشَوۡنَ رَبَّهُم بِٱلۡغَيۡبِ وَأَقَامُواْ ٱلصَّلَوٰةَۚ وَمَن تَزَكَّىٰ فَإِنَّمَا يَتَزَكَّىٰ لِنَفۡسِهِۦۚ وَإِلَى ٱللَّهِ ٱلۡمَصِيرُ",
    translation:
      "And no bearer of burdens will bear the burden of another. And if a heavily laden soul calls [another] to [carry some of] its load, nothing of it will be carried, even if he should be a close relative. You can only warn those who fear their Lord unseen and have established prayer. And whoever purifies himself only purifies himself for [the benefit of] his soul. And to Allah is the [final] destination",
    normalizedText:
      "ولا تزر وازرة وزر اخرى وان تدع مثقلة الى حملها لا يحمل منه شيء ولو كان ذا قربى انما تنذر الذين يخشون ربهم بالغيب واقاموا الصلوة ومن تزكى فانما يتزكى لنفسه والى الله المصير",
  },
  {
    verseId: 18,
    name: "فاطر",
    surahId: 35,
    text: "وَمَا يَسۡتَوِي ٱلۡأَعۡمَىٰ وَٱلۡبَصِيرُ",
    translation: "Not equal are the blind and the seeing",
    normalizedText: "وما يستوي الاعمى والبصير",
  },
  {
    verseId: 19,
    name: "فاطر",
    surahId: 35,
    text: "وَلَا ٱلظُّلُمَٰتُ وَلَا ٱلنُّورُ",
    translation: "Nor are the darknesses and the light",
    normalizedText: "ولا الظلمت ولا النور",
  },
  {
    verseId: 20,
    name: "فاطر",
    surahId: 35,
    text: "وَلَا ٱلظِّلُّ وَلَا ٱلۡحَرُورُ",
    translation: "Nor are the shade and the heat",
    normalizedText: "ولا الظل ولا الحرور",
  },
  {
    verseId: 21,
    name: "فاطر",
    surahId: 35,
    text: "وَمَا يَسۡتَوِي ٱلۡأَحۡيَآءُ وَلَا ٱلۡأَمۡوَٰتُۚ إِنَّ ٱللَّهَ يُسۡمِعُ مَن يَشَآءُۖ وَمَآ أَنتَ بِمُسۡمِعٖ مَّن فِي ٱلۡقُبُورِ",
    translation:
      "And not equal are the living and the dead. Indeed, Allah causes to hear whom He wills, but you cannot make hear those in the graves",
    normalizedText:
      "وما يستوي الاحياء ولا الاموت ان الله يسمع من يشاء وما انت بمسمع من في القبور",
  },
  {
    verseId: 22,
    name: "فاطر",
    surahId: 35,
    text: "إِنۡ أَنتَ إِلَّا نَذِيرٌ",
    translation: "You, [O Muhammad], are not but a warner",
    normalizedText: "ان انت الا نذير",
  },
  {
    verseId: 23,
    name: "فاطر",
    surahId: 35,
    text: "إِنَّآ أَرۡسَلۡنَٰكَ بِٱلۡحَقِّ بَشِيرٗا وَنَذِيرٗاۚ وَإِن مِّنۡ أُمَّةٍ إِلَّا خَلَا فِيهَا نَذِيرٞ",
    translation:
      "Indeed, We have sent you with the truth as a bringer of good tidings and a warner. And there was no nation but that there had passed within it a warner",
    normalizedText:
      "انا ارسلنك بالحق بشيرا ونذيرا وان من امة الا خلا فيها نذير",
  },
  {
    verseId: 24,
    name: "فاطر",
    surahId: 35,
    text: "وَإِن يُكَذِّبُوكَ فَقَدۡ كَذَّبَ ٱلَّذِينَ مِن قَبۡلِهِمۡ جَآءَتۡهُمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِ وَبِٱلزُّبُرِ وَبِٱلۡكِتَٰبِ ٱلۡمُنِيرِ",
    translation:
      "And if they deny you - then already have those before them denied. Their messengers came to them with clear proofs and written ordinances and with the enlightening Scripture",
    normalizedText:
      "وان يكذبوك فقد كذب الذين من قبلهم جاءتهم رسلهم بالبينت وبالزبر وبالكتب المنير",
  },
  {
    verseId: 25,
    name: "فاطر",
    surahId: 35,
    text: "ثُمَّ أَخَذۡتُ ٱلَّذِينَ كَفَرُواْۖ فَكَيۡفَ كَانَ نَكِيرِ",
    translation:
      "Then I seized the ones who disbelieved, and how [terrible] was My reproach",
    normalizedText: "ثم اخذت الذين كفروا فكيف كان نكير",
  },
  {
    verseId: 26,
    name: "فاطر",
    surahId: 35,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَأَخۡرَجۡنَا بِهِۦ ثَمَرَٰتٖ مُّخۡتَلِفًا أَلۡوَٰنُهَاۚ وَمِنَ ٱلۡجِبَالِ جُدَدُۢ بِيضٞ وَحُمۡرٞ مُّخۡتَلِفٌ أَلۡوَٰنُهَا وَغَرَابِيبُ سُودٞ",
    translation:
      "Do you not see that Allah sends down rain from the sky, and We produce thereby fruits of varying colors? And in the mountains are tracts, white and red of varying shades and [some] extremely black",
    normalizedText:
      "الم تر ان الله انزل من السماء ماء فاخرجنا به ثمرت مختلفا الونها ومن الجبال جدد بيض وحمر مختلف الونها وغرابيب سود",
  },
  {
    verseId: 27,
    name: "فاطر",
    surahId: 35,
    text: "وَمِنَ ٱلنَّاسِ وَٱلدَّوَآبِّ وَٱلۡأَنۡعَٰمِ مُخۡتَلِفٌ أَلۡوَٰنُهُۥ كَذَٰلِكَۗ إِنَّمَا يَخۡشَى ٱللَّهَ مِنۡ عِبَادِهِ ٱلۡعُلَمَـٰٓؤُاْۗ إِنَّ ٱللَّهَ عَزِيزٌ غَفُورٌ",
    translation:
      "And among people and moving creatures and grazing livestock are various colors similarly. Only those fear Allah, from among His servants, who have knowledge. Indeed, Allah is Exalted in Might and Forgiving",
    normalizedText:
      "ومن الناس والدواب والانعم مختلف الونه كذلك انما يخشى الله من عباده العلماا ان الله عزيز غفور",
  },
  {
    verseId: 28,
    name: "فاطر",
    surahId: 35,
    text: "إِنَّ ٱلَّذِينَ يَتۡلُونَ كِتَٰبَ ٱللَّهِ وَأَقَامُواْ ٱلصَّلَوٰةَ وَأَنفَقُواْ مِمَّا رَزَقۡنَٰهُمۡ سِرّٗا وَعَلَانِيَةٗ يَرۡجُونَ تِجَٰرَةٗ لَّن تَبُورَ",
    translation:
      "Indeed, those who recite the Book of Allah and establish prayer and spend [in His cause] out of what We have provided them, secretly and publicly, [can] expect a profit that will never perish",
    normalizedText:
      "ان الذين يتلون كتب الله واقاموا الصلوة وانفقوا مما رزقنهم سرا وعلانية يرجون تجرة لن تبور",
  },
  {
    verseId: 29,
    name: "فاطر",
    surahId: 35,
    text: "لِيُوَفِّيَهُمۡ أُجُورَهُمۡ وَيَزِيدَهُم مِّن فَضۡلِهِۦٓۚ إِنَّهُۥ غَفُورٞ شَكُورٞ",
    translation:
      "That He may give them in full their rewards and increase for them of His bounty. Indeed, He is Forgiving and Appreciative",
    normalizedText: "ليوفيهم اجورهم ويزيدهم من فضله انه غفور شكور",
  },
  {
    verseId: 30,
    name: "فاطر",
    surahId: 35,
    text: "وَٱلَّذِيٓ أَوۡحَيۡنَآ إِلَيۡكَ مِنَ ٱلۡكِتَٰبِ هُوَ ٱلۡحَقُّ مُصَدِّقٗا لِّمَا بَيۡنَ يَدَيۡهِۗ إِنَّ ٱللَّهَ بِعِبَادِهِۦ لَخَبِيرُۢ بَصِيرٞ",
    translation:
      "And that which We have revealed to you, [O Muhammad], of the Book is the truth, confirming what was before it. Indeed, Allah, of His servants, is Acquainted and Seeing",
    normalizedText:
      "والذي اوحينا اليك من الكتب هو الحق مصدقا لما بين يديه ان الله بعباده لخبير بصير",
  },
  {
    verseId: 31,
    name: "فاطر",
    surahId: 35,
    text: "ثُمَّ أَوۡرَثۡنَا ٱلۡكِتَٰبَ ٱلَّذِينَ ٱصۡطَفَيۡنَا مِنۡ عِبَادِنَاۖ فَمِنۡهُمۡ ظَالِمٞ لِّنَفۡسِهِۦ وَمِنۡهُم مُّقۡتَصِدٞ وَمِنۡهُمۡ سَابِقُۢ بِٱلۡخَيۡرَٰتِ بِإِذۡنِ ٱللَّهِۚ ذَٰلِكَ هُوَ ٱلۡفَضۡلُ ٱلۡكَبِيرُ",
    translation:
      "Then we caused to inherit the Book those We have chosen of Our servants; and among them is he who wrongs himself, and among them is he who is moderate, and among them is he who is foremost in good deeds by permission of Allah. That [inheritance] is what is the great bounty",
    normalizedText:
      "ثم اورثنا الكتب الذين اصطفينا من عبادنا فمنهم ظالم لنفسه ومنهم مقتصد ومنهم سابق بالخيرت باذن الله ذلك هو الفضل الكبير",
  },
  {
    verseId: 32,
    name: "فاطر",
    surahId: 35,
    text: "جَنَّـٰتُ عَدۡنٖ يَدۡخُلُونَهَا يُحَلَّوۡنَ فِيهَا مِنۡ أَسَاوِرَ مِن ذَهَبٖ وَلُؤۡلُؤٗاۖ وَلِبَاسُهُمۡ فِيهَا حَرِيرٞ",
    translation:
      "[For them are] gardens of perpetual residence which they will enter. They will be adorned therein with bracelets of gold and pearls, and their garments therein will be silk",
    normalizedText:
      "جنت عدن يدخلونها يحلون فيها من اساور من ذهب ولالاا ولباسهم فيها حرير",
  },
  {
    verseId: 33,
    name: "فاطر",
    surahId: 35,
    text: "وَقَالُواْ ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِيٓ أَذۡهَبَ عَنَّا ٱلۡحَزَنَۖ إِنَّ رَبَّنَا لَغَفُورٞ شَكُورٌ",
    translation:
      'And they will say, "Praise to Allah, who has removed from us [all] sorrow. Indeed, our Lord is Forgiving and Appreciative',
    normalizedText: "وقالوا الحمد لله الذي اذهب عنا الحزن ان ربنا لغفور شكور",
  },
  {
    verseId: 34,
    name: "فاطر",
    surahId: 35,
    text: "ٱلَّذِيٓ أَحَلَّنَا دَارَ ٱلۡمُقَامَةِ مِن فَضۡلِهِۦ لَا يَمَسُّنَا فِيهَا نَصَبٞ وَلَا يَمَسُّنَا فِيهَا لُغُوبٞ",
    translation:
      "He who has settled us in the home of duration out of His bounty. There touches us not in it any fatigue, and there touches us not in it weariness [of mind]",
    normalizedText:
      "الذي احلنا دار المقامة من فضله لا يمسنا فيها نصب ولا يمسنا فيها لغوب",
  },
  {
    verseId: 35,
    name: "فاطر",
    surahId: 35,
    text: "وَٱلَّذِينَ كَفَرُواْ لَهُمۡ نَارُ جَهَنَّمَ لَا يُقۡضَىٰ عَلَيۡهِمۡ فَيَمُوتُواْ وَلَا يُخَفَّفُ عَنۡهُم مِّنۡ عَذَابِهَاۚ كَذَٰلِكَ نَجۡزِي كُلَّ كَفُورٖ",
    translation:
      "And for those who disbelieve will be the fire of Hell. [Death] is not decreed for them so they may die, nor will its torment be lightened for them. Thus do we recompense every ungrateful one",
    normalizedText:
      "والذين كفروا لهم نار جهنم لا يقضى عليهم فيموتوا ولا يخفف عنهم من عذابها كذلك نجزي كل كفور",
  },
  {
    verseId: 36,
    name: "فاطر",
    surahId: 35,
    text: "وَهُمۡ يَصۡطَرِخُونَ فِيهَا رَبَّنَآ أَخۡرِجۡنَا نَعۡمَلۡ صَٰلِحًا غَيۡرَ ٱلَّذِي كُنَّا نَعۡمَلُۚ أَوَلَمۡ نُعَمِّرۡكُم مَّا يَتَذَكَّرُ فِيهِ مَن تَذَكَّرَ وَجَآءَكُمُ ٱلنَّذِيرُۖ فَذُوقُواْ فَمَا لِلظَّـٰلِمِينَ مِن نَّصِيرٍ",
    translation:
      'And they will cry out therein, "Our Lord, remove us; we will do righteousness - other than what we were doing!" But did We not grant you life enough for whoever would remember therein to remember, and the warner had come to you? So taste [the punishment], for there is not for the wrongdoers any helper',
    normalizedText:
      "وهم يصطرخون فيها ربنا اخرجنا نعمل صلحا غير الذي كنا نعمل اولم نعمركم ما يتذكر فيه من تذكر وجاءكم النذير فذوقوا فما للظلمين من نصير",
  },
  {
    verseId: 37,
    name: "فاطر",
    surahId: 35,
    text: "إِنَّ ٱللَّهَ عَٰلِمُ غَيۡبِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ إِنَّهُۥ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "Indeed, Allah is Knower of the unseen [aspects] of the heavens and earth. Indeed, He is Knowing of that within the breasts",
    normalizedText: "ان الله علم غيب السموت والارض انه عليم بذات الصدور",
  },
  {
    verseId: 38,
    name: "فاطر",
    surahId: 35,
    text: "هُوَ ٱلَّذِي جَعَلَكُمۡ خَلَـٰٓئِفَ فِي ٱلۡأَرۡضِۚ فَمَن كَفَرَ فَعَلَيۡهِ كُفۡرُهُۥۖ وَلَا يَزِيدُ ٱلۡكَٰفِرِينَ كُفۡرُهُمۡ عِندَ رَبِّهِمۡ إِلَّا مَقۡتٗاۖ وَلَا يَزِيدُ ٱلۡكَٰفِرِينَ كُفۡرُهُمۡ إِلَّا خَسَارٗا",
    translation:
      "It is He who has made you successors upon the earth. And whoever disbelieves - upon him will be [the consequence of] his disbelief. And the disbelief of the disbelievers does not increase them in the sight of their Lord except in hatred; and the disbelief of the disbelievers does not increase them except in loss",
    normalizedText:
      "هو الذي جعلكم خلاف في الارض فمن كفر فعليه كفره ولا يزيد الكفرين كفرهم عند ربهم الا مقتا ولا يزيد الكفرين كفرهم الا خسارا",
  },
  {
    verseId: 39,
    name: "فاطر",
    surahId: 35,
    text: "قُلۡ أَرَءَيۡتُمۡ شُرَكَآءَكُمُ ٱلَّذِينَ تَدۡعُونَ مِن دُونِ ٱللَّهِ أَرُونِي مَاذَا خَلَقُواْ مِنَ ٱلۡأَرۡضِ أَمۡ لَهُمۡ شِرۡكٞ فِي ٱلسَّمَٰوَٰتِ أَمۡ ءَاتَيۡنَٰهُمۡ كِتَٰبٗا فَهُمۡ عَلَىٰ بَيِّنَتٖ مِّنۡهُۚ بَلۡ إِن يَعِدُ ٱلظَّـٰلِمُونَ بَعۡضُهُم بَعۡضًا إِلَّا غُرُورًا",
    translation: `Say, "Have you considered your 'partners' whom you invoke besides Allah? Show me what they have created from the earth, or have they partnership [with Him] in the heavens? Or have We given them a book so they are [standing] on evidence therefrom? [No], rather, the wrongdoers do not promise each other except delusion`,
    normalizedText:
      "قل ارءيتم شركاءكم الذين تدعون من دون الله اروني ماذا خلقوا من الارض ام لهم شرك في السموت ام ءاتينهم كتبا فهم على بينت منه بل ان يعد الظلمون بعضهم بعضا الا غرورا",
  },
  {
    verseId: 40,
    name: "فاطر",
    surahId: 35,
    text: "۞إِنَّ ٱللَّهَ يُمۡسِكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ أَن تَزُولَاۚ وَلَئِن زَالَتَآ إِنۡ أَمۡسَكَهُمَا مِنۡ أَحَدٖ مِّنۢ بَعۡدِهِۦٓۚ إِنَّهُۥ كَانَ حَلِيمًا غَفُورٗا",
    translation:
      "Indeed, Allah holds the heavens and the earth, lest they cease. And if they should cease, no one could hold them [in place] after Him. Indeed, He is Forbearing and Forgiving",
    normalizedText:
      "۞ان الله يمسك السموت والارض ان تزولا ولان زالتا ان امسكهما من احد من بعده انه كان حليما غفورا",
  },
  {
    verseId: 41,
    name: "فاطر",
    surahId: 35,
    text: "وَأَقۡسَمُواْ بِٱللَّهِ جَهۡدَ أَيۡمَٰنِهِمۡ لَئِن جَآءَهُمۡ نَذِيرٞ لَّيَكُونُنَّ أَهۡدَىٰ مِنۡ إِحۡدَى ٱلۡأُمَمِۖ فَلَمَّا جَآءَهُمۡ نَذِيرٞ مَّا زَادَهُمۡ إِلَّا نُفُورًا",
    translation:
      "And they swore by Allah their strongest oaths that if a warner came to them, they would be more guided than [any] one of the [previous] nations. But when a warner came to them, it did not increase them except in aversion",
    normalizedText:
      "واقسموا بالله جهد ايمنهم لان جاءهم نذير ليكونن اهدى من احدى الامم فلما جاءهم نذير ما زادهم الا نفورا",
  },
  {
    verseId: 42,
    name: "فاطر",
    surahId: 35,
    text: "ٱسۡتِكۡبَارٗا فِي ٱلۡأَرۡضِ وَمَكۡرَ ٱلسَّيِّيِٕۚ وَلَا يَحِيقُ ٱلۡمَكۡرُ ٱلسَّيِّئُ إِلَّا بِأَهۡلِهِۦۚ فَهَلۡ يَنظُرُونَ إِلَّا سُنَّتَ ٱلۡأَوَّلِينَۚ فَلَن تَجِدَ لِسُنَّتِ ٱللَّهِ تَبۡدِيلٗاۖ وَلَن تَجِدَ لِسُنَّتِ ٱللَّهِ تَحۡوِيلًا",
    translation:
      "[Due to] arrogance in the land and plotting of evil; but the evil plot does not encompass except its own people. Then do they await except the way of the former peoples? But you will never find in the way of Allah any change, and you will never find in the way of Allah any alteration",
    normalizedText:
      "استكبارا في الارض ومكر السيي ولا يحيق المكر السيا الا باهله فهل ينظرون الا سنت الاولين فلن تجد لسنت الله تبديلا ولن تجد لسنت الله تحويلا",
  },
  {
    verseId: 43,
    name: "فاطر",
    surahId: 35,
    text: "أَوَلَمۡ يَسِيرُواْ فِي ٱلۡأَرۡضِ فَيَنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبۡلِهِمۡ وَكَانُوٓاْ أَشَدَّ مِنۡهُمۡ قُوَّةٗۚ وَمَا كَانَ ٱللَّهُ لِيُعۡجِزَهُۥ مِن شَيۡءٖ فِي ٱلسَّمَٰوَٰتِ وَلَا فِي ٱلۡأَرۡضِۚ إِنَّهُۥ كَانَ عَلِيمٗا قَدِيرٗا",
    translation:
      "Have they not traveled through the land and observed how was the end of those before them? And they were greater than them in power. But Allah is not to be caused failure by anything in the heavens or on the earth. Indeed, He is ever Knowing and Competent",
    normalizedText:
      "اولم يسيروا في الارض فينظروا كيف كان عقبة الذين من قبلهم وكانوا اشد منهم قوة وما كان الله ليعجزه من شيء في السموت ولا في الارض انه كان عليما قديرا",
  },
  {
    verseId: 44,
    name: "فاطر",
    surahId: 35,
    text: "وَلَوۡ يُؤَاخِذُ ٱللَّهُ ٱلنَّاسَ بِمَا كَسَبُواْ مَا تَرَكَ عَلَىٰ ظَهۡرِهَا مِن دَآبَّةٖ وَلَٰكِن يُؤَخِّرُهُمۡ إِلَىٰٓ أَجَلٖ مُّسَمّٗىۖ فَإِذَا جَآءَ أَجَلُهُمۡ فَإِنَّ ٱللَّهَ كَانَ بِعِبَادِهِۦ بَصِيرَۢا",
    translation:
      "And if Allah were to impose blame on the people for what they have earned, He would not leave upon the earth any creature. But He defers them for a specified term. And when their time comes, then indeed Allah has ever been, of His servants, Seeing",
    normalizedText:
      "ولو يااخذ الله الناس بما كسبوا ما ترك على ظهرها من دابة ولكن ياخرهم الى اجل مسمى فاذا جاء اجلهم فان الله كان بعباده بصيرا",
  },
  {
    verseId: 0,
    name: "يس",
    surahId: 36,
    text: "يسٓ",
    translation: "Ya, Seen",
    normalizedText: "يس",
  },
  {
    verseId: 1,
    name: "يس",
    surahId: 36,
    text: "وَٱلۡقُرۡءَانِ ٱلۡحَكِيمِ",
    translation: "By the wise Qur'an",
    normalizedText: "والقرءان الحكيم",
  },
  {
    verseId: 2,
    name: "يس",
    surahId: 36,
    text: "إِنَّكَ لَمِنَ ٱلۡمُرۡسَلِينَ",
    translation: "Indeed you, [O Muhammad], are from among the messengers",
    normalizedText: "انك لمن المرسلين",
  },
  {
    verseId: 3,
    name: "يس",
    surahId: 36,
    text: "عَلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation: "On a straight path",
    normalizedText: "على صرط مستقيم",
  },
  {
    verseId: 4,
    name: "يس",
    surahId: 36,
    text: "تَنزِيلَ ٱلۡعَزِيزِ ٱلرَّحِيمِ",
    translation: "[This is] a revelation of the Exalted in Might, the Merciful",
    normalizedText: "تنزيل العزيز الرحيم",
  },
  {
    verseId: 5,
    name: "يس",
    surahId: 36,
    text: "لِتُنذِرَ قَوۡمٗا مَّآ أُنذِرَ ءَابَآؤُهُمۡ فَهُمۡ غَٰفِلُونَ",
    translation:
      "That you may warn a people whose forefathers were not warned, so they are unaware",
    normalizedText: "لتنذر قوما ما انذر ءابااهم فهم غفلون",
  },
  {
    verseId: 6,
    name: "يس",
    surahId: 36,
    text: "لَقَدۡ حَقَّ ٱلۡقَوۡلُ عَلَىٰٓ أَكۡثَرِهِمۡ فَهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "Already the word has come into effect upon most of them, so they do not believe",
    normalizedText: "لقد حق القول على اكثرهم فهم لا يامنون",
  },
  {
    verseId: 7,
    name: "يس",
    surahId: 36,
    text: "إِنَّا جَعَلۡنَا فِيٓ أَعۡنَٰقِهِمۡ أَغۡلَٰلٗا فَهِيَ إِلَى ٱلۡأَذۡقَانِ فَهُم مُّقۡمَحُونَ",
    translation:
      "Indeed, We have put shackles on their necks, and they are to their chins, so they are with heads [kept] aloft",
    normalizedText: "انا جعلنا في اعنقهم اغللا فهي الى الاذقان فهم مقمحون",
  },
  {
    verseId: 8,
    name: "يس",
    surahId: 36,
    text: "وَجَعَلۡنَا مِنۢ بَيۡنِ أَيۡدِيهِمۡ سَدّٗا وَمِنۡ خَلۡفِهِمۡ سَدّٗا فَأَغۡشَيۡنَٰهُمۡ فَهُمۡ لَا يُبۡصِرُونَ",
    translation:
      "And We have put before them a barrier and behind them a barrier and covered them, so they do not see",
    normalizedText:
      "وجعلنا من بين ايديهم سدا ومن خلفهم سدا فاغشينهم فهم لا يبصرون",
  },
  {
    verseId: 9,
    name: "يس",
    surahId: 36,
    text: "وَسَوَآءٌ عَلَيۡهِمۡ ءَأَنذَرۡتَهُمۡ أَمۡ لَمۡ تُنذِرۡهُمۡ لَا يُؤۡمِنُونَ",
    translation:
      "And it is all the same for them whether you warn them or do not warn them - they will not believe",
    normalizedText: "وسواء عليهم ءانذرتهم ام لم تنذرهم لا يامنون",
  },
  {
    verseId: 10,
    name: "يس",
    surahId: 36,
    text: "إِنَّمَا تُنذِرُ مَنِ ٱتَّبَعَ ٱلذِّكۡرَ وَخَشِيَ ٱلرَّحۡمَٰنَ بِٱلۡغَيۡبِۖ فَبَشِّرۡهُ بِمَغۡفِرَةٖ وَأَجۡرٖ كَرِيمٍ",
    translation:
      "You can only warn one who follows the message and fears the Most Merciful unseen. So give him good tidings of forgiveness and noble reward",
    normalizedText:
      "انما تنذر من اتبع الذكر وخشي الرحمن بالغيب فبشره بمغفرة واجر كريم",
  },
  {
    verseId: 11,
    name: "يس",
    surahId: 36,
    text: "إِنَّا نَحۡنُ نُحۡيِ ٱلۡمَوۡتَىٰ وَنَكۡتُبُ مَا قَدَّمُواْ وَءَاثَٰرَهُمۡۚ وَكُلَّ شَيۡءٍ أَحۡصَيۡنَٰهُ فِيٓ إِمَامٖ مُّبِينٖ",
    translation:
      "Indeed, it is We who bring the dead to life and record what they have put forth and what they left behind, and all things We have enumerated in a clear register",
    normalizedText:
      "انا نحن نحي الموتى ونكتب ما قدموا وءاثرهم وكل شيء احصينه في امام مبين",
  },
  {
    verseId: 12,
    name: "يس",
    surahId: 36,
    text: "وَٱضۡرِبۡ لَهُم مَّثَلًا أَصۡحَٰبَ ٱلۡقَرۡيَةِ إِذۡ جَآءَهَا ٱلۡمُرۡسَلُونَ",
    translation:
      "And present to them an example: the people of the city, when the messengers came to it",
    normalizedText: "واضرب لهم مثلا اصحب القرية اذ جاءها المرسلون",
  },
  {
    verseId: 13,
    name: "يس",
    surahId: 36,
    text: "إِذۡ أَرۡسَلۡنَآ إِلَيۡهِمُ ٱثۡنَيۡنِ فَكَذَّبُوهُمَا فَعَزَّزۡنَا بِثَالِثٖ فَقَالُوٓاْ إِنَّآ إِلَيۡكُم مُّرۡسَلُونَ",
    translation:
      'When We sent to them two but they denied them, so We strengthened them with a third, and they said, "Indeed, we are messengers to you',
    normalizedText:
      "اذ ارسلنا اليهم اثنين فكذبوهما فعززنا بثالث فقالوا انا اليكم مرسلون",
  },
  {
    verseId: 14,
    name: "يس",
    surahId: 36,
    text: "قَالُواْ مَآ أَنتُمۡ إِلَّا بَشَرٞ مِّثۡلُنَا وَمَآ أَنزَلَ ٱلرَّحۡمَٰنُ مِن شَيۡءٍ إِنۡ أَنتُمۡ إِلَّا تَكۡذِبُونَ",
    translation:
      'They said, "You are not but human beings like us, and the Most Merciful has not revealed a thing. You are only telling lies',
    normalizedText:
      "قالوا ما انتم الا بشر مثلنا وما انزل الرحمن من شيء ان انتم الا تكذبون",
  },
  {
    verseId: 15,
    name: "يس",
    surahId: 36,
    text: "قَالُواْ رَبُّنَا يَعۡلَمُ إِنَّآ إِلَيۡكُمۡ لَمُرۡسَلُونَ",
    translation: 'They said, "Our Lord knows that we are messengers to you',
    normalizedText: "قالوا ربنا يعلم انا اليكم لمرسلون",
  },
  {
    verseId: 16,
    name: "يس",
    surahId: 36,
    text: "وَمَا عَلَيۡنَآ إِلَّا ٱلۡبَلَٰغُ ٱلۡمُبِينُ",
    translation: "And we are not responsible except for clear notification",
    normalizedText: "وما علينا الا البلغ المبين",
  },
  {
    verseId: 17,
    name: "يس",
    surahId: 36,
    text: "قَالُوٓاْ إِنَّا تَطَيَّرۡنَا بِكُمۡۖ لَئِن لَّمۡ تَنتَهُواْ لَنَرۡجُمَنَّكُمۡ وَلَيَمَسَّنَّكُم مِّنَّا عَذَابٌ أَلِيمٞ",
    translation:
      'They said, "Indeed, we consider you a bad omen. If you do not desist, we will surely stone you, and there will surely touch you, from us, a painful punishment',
    normalizedText:
      "قالوا انا تطيرنا بكم لان لم تنتهوا لنرجمنكم وليمسنكم منا عذاب اليم",
  },
  {
    verseId: 18,
    name: "يس",
    surahId: 36,
    text: "قَالُواْ طَـٰٓئِرُكُم مَّعَكُمۡ أَئِن ذُكِّرۡتُمۚ بَلۡ أَنتُمۡ قَوۡمٞ مُّسۡرِفُونَ",
    translation:
      'They said, "Your omen is with yourselves. Is it because you were reminded? Rather, you are a transgressing people',
    normalizedText: "قالوا طاركم معكم اان ذكرتم بل انتم قوم مسرفون",
  },
  {
    verseId: 19,
    name: "يس",
    surahId: 36,
    text: "وَجَآءَ مِنۡ أَقۡصَا ٱلۡمَدِينَةِ رَجُلٞ يَسۡعَىٰ قَالَ يَٰقَوۡمِ ٱتَّبِعُواْ ٱلۡمُرۡسَلِينَ",
    translation:
      'And there came from the farthest end of the city a man, running. He said, "O my people, follow the messengers',
    normalizedText: "وجاء من اقصا المدينة رجل يسعى قال يقوم اتبعوا المرسلين",
  },
  {
    verseId: 20,
    name: "يس",
    surahId: 36,
    text: "ٱتَّبِعُواْ مَن لَّا يَسۡـَٔلُكُمۡ أَجۡرٗا وَهُم مُّهۡتَدُونَ",
    translation:
      "Follow those who do not ask of you [any] payment, and they are [rightly] guided",
    normalizedText: "اتبعوا من لا يسلكم اجرا وهم مهتدون",
  },
  {
    verseId: 21,
    name: "يس",
    surahId: 36,
    text: "وَمَالِيَ لَآ أَعۡبُدُ ٱلَّذِي فَطَرَنِي وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "And why should I not worship He who created me and to whom you will be returned",
    normalizedText: "ومالي لا اعبد الذي فطرني واليه ترجعون",
  },
  {
    verseId: 22,
    name: "يس",
    surahId: 36,
    text: "ءَأَتَّخِذُ مِن دُونِهِۦٓ ءَالِهَةً إِن يُرِدۡنِ ٱلرَّحۡمَٰنُ بِضُرّٖ لَّا تُغۡنِ عَنِّي شَفَٰعَتُهُمۡ شَيۡـٔٗا وَلَا يُنقِذُونِ",
    translation:
      "Should I take other than Him [false] deities [while], if the Most Merciful intends for me some adversity, their intercession will not avail me at all, nor can they save me",
    normalizedText:
      "ءاتخذ من دونه ءالهة ان يردن الرحمن بضر لا تغن عني شفعتهم شيا ولا ينقذون",
  },
  {
    verseId: 23,
    name: "يس",
    surahId: 36,
    text: "إِنِّيٓ إِذٗا لَّفِي ضَلَٰلٖ مُّبِينٍ",
    translation: "Indeed, I would then be in manifest error",
    normalizedText: "اني اذا لفي ضلل مبين",
  },
  {
    verseId: 24,
    name: "يس",
    surahId: 36,
    text: "إِنِّيٓ ءَامَنتُ بِرَبِّكُمۡ فَٱسۡمَعُونِ",
    translation: "Indeed, I have believed in your Lord, so listen to me",
    normalizedText: "اني ءامنت بربكم فاسمعون",
  },
  {
    verseId: 25,
    name: "يس",
    surahId: 36,
    text: "قِيلَ ٱدۡخُلِ ٱلۡجَنَّةَۖ قَالَ يَٰلَيۡتَ قَوۡمِي يَعۡلَمُونَ",
    translation:
      'It was said, "Enter Paradise." He said, "I wish my people could know',
    normalizedText: "قيل ادخل الجنة قال يليت قومي يعلمون",
  },
  {
    verseId: 26,
    name: "يس",
    surahId: 36,
    text: "بِمَا غَفَرَ لِي رَبِّي وَجَعَلَنِي مِنَ ٱلۡمُكۡرَمِينَ",
    translation:
      "Of how my Lord has forgiven me and placed me among the honored",
    normalizedText: "بما غفر لي ربي وجعلني من المكرمين",
  },
  {
    verseId: 27,
    name: "يس",
    surahId: 36,
    text: "۞وَمَآ أَنزَلۡنَا عَلَىٰ قَوۡمِهِۦ مِنۢ بَعۡدِهِۦ مِن جُندٖ مِّنَ ٱلسَّمَآءِ وَمَا كُنَّا مُنزِلِينَ",
    translation:
      "And We did not send down upon his people after him any soldiers from the heaven, nor would We have done so",
    normalizedText:
      "۞وما انزلنا على قومه من بعده من جند من السماء وما كنا منزلين",
  },
  {
    verseId: 28,
    name: "يس",
    surahId: 36,
    text: "إِن كَانَتۡ إِلَّا صَيۡحَةٗ وَٰحِدَةٗ فَإِذَا هُمۡ خَٰمِدُونَ",
    translation:
      "It was not but one shout, and immediately they were extinguished",
    normalizedText: "ان كانت الا صيحة وحدة فاذا هم خمدون",
  },
  {
    verseId: 29,
    name: "يس",
    surahId: 36,
    text: "يَٰحَسۡرَةً عَلَى ٱلۡعِبَادِۚ مَا يَأۡتِيهِم مِّن رَّسُولٍ إِلَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "How regretful for the servants. There did not come to them any messenger except that they used to ridicule him",
    normalizedText: "يحسرة على العباد ما ياتيهم من رسول الا كانوا به يستهزءون",
  },
  {
    verseId: 30,
    name: "يس",
    surahId: 36,
    text: "أَلَمۡ يَرَوۡاْ كَمۡ أَهۡلَكۡنَا قَبۡلَهُم مِّنَ ٱلۡقُرُونِ أَنَّهُمۡ إِلَيۡهِمۡ لَا يَرۡجِعُونَ",
    translation:
      "Have they not considered how many generations We destroyed before them - that they to them will not return",
    normalizedText: "الم يروا كم اهلكنا قبلهم من القرون انهم اليهم لا يرجعون",
  },
  {
    verseId: 31,
    name: "يس",
    surahId: 36,
    text: "وَإِن كُلّٞ لَّمَّا جَمِيعٞ لَّدَيۡنَا مُحۡضَرُونَ",
    translation:
      "And indeed, all of them will yet be brought present before Us",
    normalizedText: "وان كل لما جميع لدينا محضرون",
  },
  {
    verseId: 32,
    name: "يس",
    surahId: 36,
    text: "وَءَايَةٞ لَّهُمُ ٱلۡأَرۡضُ ٱلۡمَيۡتَةُ أَحۡيَيۡنَٰهَا وَأَخۡرَجۡنَا مِنۡهَا حَبّٗا فَمِنۡهُ يَأۡكُلُونَ",
    translation:
      "And a sign for them is the dead earth. We have brought it to life and brought forth from it grain, and from it they eat",
    normalizedText:
      "وءاية لهم الارض الميتة احيينها واخرجنا منها حبا فمنه ياكلون",
  },
  {
    verseId: 33,
    name: "يس",
    surahId: 36,
    text: "وَجَعَلۡنَا فِيهَا جَنَّـٰتٖ مِّن نَّخِيلٖ وَأَعۡنَٰبٖ وَفَجَّرۡنَا فِيهَا مِنَ ٱلۡعُيُونِ",
    translation:
      "And We placed therein gardens of palm trees and grapevines and caused to burst forth therefrom some springs",
    normalizedText: "وجعلنا فيها جنت من نخيل واعنب وفجرنا فيها من العيون",
  },
  {
    verseId: 34,
    name: "يس",
    surahId: 36,
    text: "لِيَأۡكُلُواْ مِن ثَمَرِهِۦ وَمَا عَمِلَتۡهُ أَيۡدِيهِمۡۚ أَفَلَا يَشۡكُرُونَ",
    translation:
      "That they may eat of His fruit. And their hands have not produced it, so will they not be grateful",
    normalizedText: "لياكلوا من ثمره وما عملته ايديهم افلا يشكرون",
  },
  {
    verseId: 35,
    name: "يس",
    surahId: 36,
    text: "سُبۡحَٰنَ ٱلَّذِي خَلَقَ ٱلۡأَزۡوَٰجَ كُلَّهَا مِمَّا تُنۢبِتُ ٱلۡأَرۡضُ وَمِنۡ أَنفُسِهِمۡ وَمِمَّا لَا يَعۡلَمُونَ",
    translation:
      "Exalted is He who created all pairs - from what the earth grows and from themselves and from that which they do not know",
    normalizedText:
      "سبحن الذي خلق الازوج كلها مما تنبت الارض ومن انفسهم ومما لا يعلمون",
  },
  {
    verseId: 36,
    name: "يس",
    surahId: 36,
    text: "وَءَايَةٞ لَّهُمُ ٱلَّيۡلُ نَسۡلَخُ مِنۡهُ ٱلنَّهَارَ فَإِذَا هُم مُّظۡلِمُونَ",
    translation:
      "And a sign for them is the night. We remove from it [the light of] day, so they are [left] in darkness",
    normalizedText: "وءاية لهم اليل نسلخ منه النهار فاذا هم مظلمون",
  },
  {
    verseId: 37,
    name: "يس",
    surahId: 36,
    text: "وَٱلشَّمۡسُ تَجۡرِي لِمُسۡتَقَرّٖ لَّهَاۚ ذَٰلِكَ تَقۡدِيرُ ٱلۡعَزِيزِ ٱلۡعَلِيمِ",
    translation:
      "And the sun runs [on course] toward its stopping point. That is the determination of the Exalted in Might, the Knowing",
    normalizedText: "والشمس تجري لمستقر لها ذلك تقدير العزيز العليم",
  },
  {
    verseId: 38,
    name: "يس",
    surahId: 36,
    text: "وَٱلۡقَمَرَ قَدَّرۡنَٰهُ مَنَازِلَ حَتَّىٰ عَادَ كَٱلۡعُرۡجُونِ ٱلۡقَدِيمِ",
    translation:
      "And the moon - We have determined for it phases, until it returns [appearing] like the old date stalk",
    normalizedText: "والقمر قدرنه منازل حتى عاد كالعرجون القديم",
  },
  {
    verseId: 39,
    name: "يس",
    surahId: 36,
    text: "لَا ٱلشَّمۡسُ يَنۢبَغِي لَهَآ أَن تُدۡرِكَ ٱلۡقَمَرَ وَلَا ٱلَّيۡلُ سَابِقُ ٱلنَّهَارِۚ وَكُلّٞ فِي فَلَكٖ يَسۡبَحُونَ",
    translation:
      "It is not allowable for the sun to reach the moon, nor does the night overtake the day, but each, in an orbit, is swimming",
    normalizedText:
      "لا الشمس ينبغي لها ان تدرك القمر ولا اليل سابق النهار وكل في فلك يسبحون",
  },
  {
    verseId: 40,
    name: "يس",
    surahId: 36,
    text: "وَءَايَةٞ لَّهُمۡ أَنَّا حَمَلۡنَا ذُرِّيَّتَهُمۡ فِي ٱلۡفُلۡكِ ٱلۡمَشۡحُونِ",
    translation:
      "And a sign for them is that We carried their forefathers in a laden ship",
    normalizedText: "وءاية لهم انا حملنا ذريتهم في الفلك المشحون",
  },
  {
    verseId: 41,
    name: "يس",
    surahId: 36,
    text: "وَخَلَقۡنَا لَهُم مِّن مِّثۡلِهِۦ مَا يَرۡكَبُونَ",
    translation:
      "And We created for them from the likes of it that which they ride",
    normalizedText: "وخلقنا لهم من مثله ما يركبون",
  },
  {
    verseId: 42,
    name: "يس",
    surahId: 36,
    text: "وَإِن نَّشَأۡ نُغۡرِقۡهُمۡ فَلَا صَرِيخَ لَهُمۡ وَلَا هُمۡ يُنقَذُونَ",
    translation:
      "And if We should will, We could drown them; then no one responding to a cry would there be for them, nor would they be saved",
    normalizedText: "وان نشا نغرقهم فلا صريخ لهم ولا هم ينقذون",
  },
  {
    verseId: 43,
    name: "يس",
    surahId: 36,
    text: "إِلَّا رَحۡمَةٗ مِّنَّا وَمَتَٰعًا إِلَىٰ حِينٖ",
    translation: "Except as a mercy from Us and provision for a time",
    normalizedText: "الا رحمة منا ومتعا الى حين",
  },
  {
    verseId: 44,
    name: "يس",
    surahId: 36,
    text: "وَإِذَا قِيلَ لَهُمُ ٱتَّقُواْ مَا بَيۡنَ أَيۡدِيكُمۡ وَمَا خَلۡفَكُمۡ لَعَلَّكُمۡ تُرۡحَمُونَ",
    translation:
      'But when it is said to them, "Beware of what is before you and what is behind you; perhaps you will receive mercy',
    normalizedText: "واذا قيل لهم اتقوا ما بين ايديكم وما خلفكم لعلكم ترحمون",
  },
  {
    verseId: 45,
    name: "يس",
    surahId: 36,
    text: "وَمَا تَأۡتِيهِم مِّنۡ ءَايَةٖ مِّنۡ ءَايَٰتِ رَبِّهِمۡ إِلَّا كَانُواْ عَنۡهَا مُعۡرِضِينَ",
    translation:
      "And no sign comes to them from the signs of their Lord except that they are from it turning away",
    normalizedText: "وما تاتيهم من ءاية من ءايت ربهم الا كانوا عنها معرضين",
  },
  {
    verseId: 46,
    name: "يس",
    surahId: 36,
    text: "وَإِذَا قِيلَ لَهُمۡ أَنفِقُواْ مِمَّا رَزَقَكُمُ ٱللَّهُ قَالَ ٱلَّذِينَ كَفَرُواْ لِلَّذِينَ ءَامَنُوٓاْ أَنُطۡعِمُ مَن لَّوۡ يَشَآءُ ٱللَّهُ أَطۡعَمَهُۥٓ إِنۡ أَنتُمۡ إِلَّا فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      'And when it is said to them, "Spend from that which Allah has provided for you," those who disbelieve say to those who believe, "Should we feed one whom, if Allah had willed, He would have fed? You are not but in clear error',
    normalizedText:
      "واذا قيل لهم انفقوا مما رزقكم الله قال الذين كفروا للذين ءامنوا انطعم من لو يشاء الله اطعمه ان انتم الا في ضلل مبين",
  },
  {
    verseId: 47,
    name: "يس",
    surahId: 36,
    text: "وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلۡوَعۡدُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "When is this promise, if you should be truthful',
    normalizedText: "ويقولون متى هذا الوعد ان كنتم صدقين",
  },
  {
    verseId: 48,
    name: "يس",
    surahId: 36,
    text: "مَا يَنظُرُونَ إِلَّا صَيۡحَةٗ وَٰحِدَةٗ تَأۡخُذُهُمۡ وَهُمۡ يَخِصِّمُونَ",
    translation:
      "They do not await except one blast which will seize them while they are disputing",
    normalizedText: "ما ينظرون الا صيحة وحدة تاخذهم وهم يخصمون",
  },
  {
    verseId: 49,
    name: "يس",
    surahId: 36,
    text: "فَلَا يَسۡتَطِيعُونَ تَوۡصِيَةٗ وَلَآ إِلَىٰٓ أَهۡلِهِمۡ يَرۡجِعُونَ",
    translation:
      "And they will not be able [to give] any instruction, nor to their people can they return",
    normalizedText: "فلا يستطيعون توصية ولا الى اهلهم يرجعون",
  },
  {
    verseId: 50,
    name: "يس",
    surahId: 36,
    text: "وَنُفِخَ فِي ٱلصُّورِ فَإِذَا هُم مِّنَ ٱلۡأَجۡدَاثِ إِلَىٰ رَبِّهِمۡ يَنسِلُونَ",
    translation:
      "And the Horn will be blown; and at once from the graves to their Lord they will hasten",
    normalizedText: "ونفخ في الصور فاذا هم من الاجداث الى ربهم ينسلون",
  },
  {
    verseId: 51,
    name: "يس",
    surahId: 36,
    text: "قَالُواْ يَٰوَيۡلَنَا مَنۢ بَعَثَنَا مِن مَّرۡقَدِنَاۜۗ هَٰذَا مَا وَعَدَ ٱلرَّحۡمَٰنُ وَصَدَقَ ٱلۡمُرۡسَلُونَ",
    translation:
      'They will say, "O woe to us! Who has raised us up from our sleeping place?" [The reply will be], "This is what the Most Merciful had promised, and the messengers told the truth',
    normalizedText:
      "قالوا يويلنا من بعثنا من مرقدنا هذا ما وعد الرحمن وصدق المرسلون",
  },
  {
    verseId: 52,
    name: "يس",
    surahId: 36,
    text: "إِن كَانَتۡ إِلَّا صَيۡحَةٗ وَٰحِدَةٗ فَإِذَا هُمۡ جَمِيعٞ لَّدَيۡنَا مُحۡضَرُونَ",
    translation:
      "It will not be but one blast, and at once they are all brought present before Us",
    normalizedText: "ان كانت الا صيحة وحدة فاذا هم جميع لدينا محضرون",
  },
  {
    verseId: 53,
    name: "يس",
    surahId: 36,
    text: "فَٱلۡيَوۡمَ لَا تُظۡلَمُ نَفۡسٞ شَيۡـٔٗا وَلَا تُجۡزَوۡنَ إِلَّا مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "So today no soul will be wronged at all, and you will not be recompensed except for what you used to do",
    normalizedText: "فاليوم لا تظلم نفس شيا ولا تجزون الا ما كنتم تعملون",
  },
  {
    verseId: 54,
    name: "يس",
    surahId: 36,
    text: "إِنَّ أَصۡحَٰبَ ٱلۡجَنَّةِ ٱلۡيَوۡمَ فِي شُغُلٖ فَٰكِهُونَ",
    translation:
      "Indeed the companions of Paradise, that Day, will be amused in [joyful] occupation",
    normalizedText: "ان اصحب الجنة اليوم في شغل فكهون",
  },
  {
    verseId: 55,
    name: "يس",
    surahId: 36,
    text: "هُمۡ وَأَزۡوَٰجُهُمۡ فِي ظِلَٰلٍ عَلَى ٱلۡأَرَآئِكِ مُتَّكِـُٔونَ",
    translation:
      "They and their spouses - in shade, reclining on adorned couches",
    normalizedText: "هم وازوجهم في ظلل على الارااك متكون",
  },
  {
    verseId: 56,
    name: "يس",
    surahId: 36,
    text: "لَهُمۡ فِيهَا فَٰكِهَةٞ وَلَهُم مَّا يَدَّعُونَ",
    translation:
      "For them therein is fruit, and for them is whatever they request [or wish]",
    normalizedText: "لهم فيها فكهة ولهم ما يدعون",
  },
  {
    verseId: 57,
    name: "يس",
    surahId: 36,
    text: "سَلَٰمٞ قَوۡلٗا مِّن رَّبّٖ رَّحِيمٖ",
    translation: '[And] "Peace," a word from a Merciful Lord',
    normalizedText: "سلم قولا من رب رحيم",
  },
  {
    verseId: 58,
    name: "يس",
    surahId: 36,
    text: "وَٱمۡتَٰزُواْ ٱلۡيَوۡمَ أَيُّهَا ٱلۡمُجۡرِمُونَ",
    translation: '[Then He will say], "But stand apart today, you criminals',
    normalizedText: "وامتزوا اليوم ايها المجرمون",
  },
  {
    verseId: 59,
    name: "يس",
    surahId: 36,
    text: "۞أَلَمۡ أَعۡهَدۡ إِلَيۡكُمۡ يَٰبَنِيٓ ءَادَمَ أَن لَّا تَعۡبُدُواْ ٱلشَّيۡطَٰنَۖ إِنَّهُۥ لَكُمۡ عَدُوّٞ مُّبِينٞ",
    translation:
      "Did I not enjoin upon you, O children of Adam, that you not worship Satan - [for] indeed, he is to you a clear enemy",
    normalizedText:
      "۞الم اعهد اليكم يبني ءادم ان لا تعبدوا الشيطن انه لكم عدو مبين",
  },
  {
    verseId: 60,
    name: "يس",
    surahId: 36,
    text: "وَأَنِ ٱعۡبُدُونِيۚ هَٰذَا صِرَٰطٞ مُّسۡتَقِيمٞ",
    translation: "And that you worship [only] Me? This is a straight path",
    normalizedText: "وان اعبدوني هذا صرط مستقيم",
  },
  {
    verseId: 61,
    name: "يس",
    surahId: 36,
    text: "وَلَقَدۡ أَضَلَّ مِنكُمۡ جِبِلّٗا كَثِيرًاۖ أَفَلَمۡ تَكُونُواْ تَعۡقِلُونَ",
    translation:
      "And he had already led astray from among you much of creation, so did you not use reason",
    normalizedText: "ولقد اضل منكم جبلا كثيرا افلم تكونوا تعقلون",
  },
  {
    verseId: 62,
    name: "يس",
    surahId: 36,
    text: "هَٰذِهِۦ جَهَنَّمُ ٱلَّتِي كُنتُمۡ تُوعَدُونَ",
    translation: "This is the Hellfire which you were promised",
    normalizedText: "هذه جهنم التي كنتم توعدون",
  },
  {
    verseId: 63,
    name: "يس",
    surahId: 36,
    text: "ٱصۡلَوۡهَا ٱلۡيَوۡمَ بِمَا كُنتُمۡ تَكۡفُرُونَ",
    translation: "[Enter to] burn therein today for what you used to deny",
    normalizedText: "اصلوها اليوم بما كنتم تكفرون",
  },
  {
    verseId: 64,
    name: "يس",
    surahId: 36,
    text: "ٱلۡيَوۡمَ نَخۡتِمُ عَلَىٰٓ أَفۡوَٰهِهِمۡ وَتُكَلِّمُنَآ أَيۡدِيهِمۡ وَتَشۡهَدُ أَرۡجُلُهُم بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "That Day, We will seal over their mouths, and their hands will speak to Us, and their feet will testify about what they used to earn",
    normalizedText:
      "اليوم نختم على افوههم وتكلمنا ايديهم وتشهد ارجلهم بما كانوا يكسبون",
  },
  {
    verseId: 65,
    name: "يس",
    surahId: 36,
    text: "وَلَوۡ نَشَآءُ لَطَمَسۡنَا عَلَىٰٓ أَعۡيُنِهِمۡ فَٱسۡتَبَقُواْ ٱلصِّرَٰطَ فَأَنَّىٰ يُبۡصِرُونَ",
    translation:
      "And if We willed, We could have obliterated their eyes, and they would race to [find] the path, and how could they see",
    normalizedText: "ولو نشاء لطمسنا على اعينهم فاستبقوا الصرط فانى يبصرون",
  },
  {
    verseId: 66,
    name: "يس",
    surahId: 36,
    text: "وَلَوۡ نَشَآءُ لَمَسَخۡنَٰهُمۡ عَلَىٰ مَكَانَتِهِمۡ فَمَا ٱسۡتَطَٰعُواْ مُضِيّٗا وَلَا يَرۡجِعُونَ",
    translation:
      "And if We willed, We could have deformed them, [paralyzing them] in their places so they would not be able to proceed, nor could they return",
    normalizedText: "ولو نشاء لمسخنهم على مكانتهم فما استطعوا مضيا ولا يرجعون",
  },
  {
    verseId: 67,
    name: "يس",
    surahId: 36,
    text: "وَمَن نُّعَمِّرۡهُ نُنَكِّسۡهُ فِي ٱلۡخَلۡقِۚ أَفَلَا يَعۡقِلُونَ",
    translation:
      "And he to whom We grant long life We reverse in creation; so will they not understand",
    normalizedText: "ومن نعمره ننكسه في الخلق افلا يعقلون",
  },
  {
    verseId: 68,
    name: "يس",
    surahId: 36,
    text: "وَمَا عَلَّمۡنَٰهُ ٱلشِّعۡرَ وَمَا يَنۢبَغِي لَهُۥٓۚ إِنۡ هُوَ إِلَّا ذِكۡرٞ وَقُرۡءَانٞ مُّبِينٞ",
    translation:
      "And We did not give Prophet Muhammad, knowledge of poetry, nor is it befitting for him. It is not but a message and a clear Qur'an",
    normalizedText: "وما علمنه الشعر وما ينبغي له ان هو الا ذكر وقرءان مبين",
  },
  {
    verseId: 69,
    name: "يس",
    surahId: 36,
    text: "لِّيُنذِرَ مَن كَانَ حَيّٗا وَيَحِقَّ ٱلۡقَوۡلُ عَلَى ٱلۡكَٰفِرِينَ",
    translation:
      "To warn whoever is alive and justify the word against the disbelievers",
    normalizedText: "لينذر من كان حيا ويحق القول على الكفرين",
  },
  {
    verseId: 70,
    name: "يس",
    surahId: 36,
    text: "أَوَلَمۡ يَرَوۡاْ أَنَّا خَلَقۡنَا لَهُم مِّمَّا عَمِلَتۡ أَيۡدِينَآ أَنۡعَٰمٗا فَهُمۡ لَهَا مَٰلِكُونَ",
    translation:
      "Do they not see that We have created for them from what Our hands have made, grazing livestock, and [then] they are their owners",
    normalizedText:
      "اولم يروا انا خلقنا لهم مما عملت ايدينا انعما فهم لها ملكون",
  },
  {
    verseId: 71,
    name: "يس",
    surahId: 36,
    text: "وَذَلَّلۡنَٰهَا لَهُمۡ فَمِنۡهَا رَكُوبُهُمۡ وَمِنۡهَا يَأۡكُلُونَ",
    translation:
      "And We have tamed them for them, so some of them they ride, and some of them they eat",
    normalizedText: "وذللنها لهم فمنها ركوبهم ومنها ياكلون",
  },
  {
    verseId: 72,
    name: "يس",
    surahId: 36,
    text: "وَلَهُمۡ فِيهَا مَنَٰفِعُ وَمَشَارِبُۚ أَفَلَا يَشۡكُرُونَ",
    translation:
      "And for them therein are [other] benefits and drinks, so will they not be grateful",
    normalizedText: "ولهم فيها منفع ومشارب افلا يشكرون",
  },
  {
    verseId: 73,
    name: "يس",
    surahId: 36,
    text: "وَٱتَّخَذُواْ مِن دُونِ ٱللَّهِ ءَالِهَةٗ لَّعَلَّهُمۡ يُنصَرُونَ",
    translation:
      "But they have taken besides Allah [false] deities that perhaps they would be helped",
    normalizedText: "واتخذوا من دون الله ءالهة لعلهم ينصرون",
  },
  {
    verseId: 74,
    name: "يس",
    surahId: 36,
    text: "لَا يَسۡتَطِيعُونَ نَصۡرَهُمۡ وَهُمۡ لَهُمۡ جُندٞ مُّحۡضَرُونَ",
    translation:
      "They are not able to help them, and they [themselves] are for them soldiers in attendance",
    normalizedText: "لا يستطيعون نصرهم وهم لهم جند محضرون",
  },
  {
    verseId: 75,
    name: "يس",
    surahId: 36,
    text: "فَلَا يَحۡزُنكَ قَوۡلُهُمۡۘ إِنَّا نَعۡلَمُ مَا يُسِرُّونَ وَمَا يُعۡلِنُونَ",
    translation:
      "So let not their speech grieve you. Indeed, We know what they conceal and what they declare",
    normalizedText: "فلا يحزنك قولهم انا نعلم ما يسرون وما يعلنون",
  },
  {
    verseId: 76,
    name: "يس",
    surahId: 36,
    text: "أَوَلَمۡ يَرَ ٱلۡإِنسَٰنُ أَنَّا خَلَقۡنَٰهُ مِن نُّطۡفَةٖ فَإِذَا هُوَ خَصِيمٞ مُّبِينٞ",
    translation:
      "Does man not consider that We created him from a [mere] sperm-drop - then at once he is a clear adversary",
    normalizedText: "اولم ير الانسن انا خلقنه من نطفة فاذا هو خصيم مبين",
  },
  {
    verseId: 77,
    name: "يس",
    surahId: 36,
    text: "وَضَرَبَ لَنَا مَثَلٗا وَنَسِيَ خَلۡقَهُۥۖ قَالَ مَن يُحۡيِ ٱلۡعِظَٰمَ وَهِيَ رَمِيمٞ",
    translation:
      'And he presents for Us an example and forgets his [own] creation. He says, "Who will give life to bones while they are disintegrated',
    normalizedText: "وضرب لنا مثلا ونسي خلقه قال من يحي العظم وهي رميم",
  },
  {
    verseId: 78,
    name: "يس",
    surahId: 36,
    text: "قُلۡ يُحۡيِيهَا ٱلَّذِيٓ أَنشَأَهَآ أَوَّلَ مَرَّةٖۖ وَهُوَ بِكُلِّ خَلۡقٍ عَلِيمٌ",
    translation:
      'Say, "He will give them life who produced them the first time; and He is, of all creation, Knowing',
    normalizedText: "قل يحييها الذي انشاها اول مرة وهو بكل خلق عليم",
  },
  {
    verseId: 79,
    name: "يس",
    surahId: 36,
    text: "ٱلَّذِي جَعَلَ لَكُم مِّنَ ٱلشَّجَرِ ٱلۡأَخۡضَرِ نَارٗا فَإِذَآ أَنتُم مِّنۡهُ تُوقِدُونَ",
    translation:
      "[It is] He who made for you from the green tree, fire, and then from it you ignite",
    normalizedText: "الذي جعل لكم من الشجر الاخضر نارا فاذا انتم منه توقدون",
  },
  {
    verseId: 80,
    name: "يس",
    surahId: 36,
    text: "أَوَلَيۡسَ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِقَٰدِرٍ عَلَىٰٓ أَن يَخۡلُقَ مِثۡلَهُمۚ بَلَىٰ وَهُوَ ٱلۡخَلَّـٰقُ ٱلۡعَلِيمُ",
    translation:
      "Is not He who created the heavens and the earth Able to create the likes of them? Yes, [it is so]; and He is the Knowing Creator",
    normalizedText:
      "اوليس الذي خلق السموت والارض بقدر على ان يخلق مثلهم بلى وهو الخلق العليم",
  },
  {
    verseId: 81,
    name: "يس",
    surahId: 36,
    text: "إِنَّمَآ أَمۡرُهُۥٓ إِذَآ أَرَادَ شَيۡـًٔا أَن يَقُولَ لَهُۥ كُن فَيَكُونُ",
    translation:
      'His command is only when He intends a thing that He says to it, "Be," and it is',
    normalizedText: "انما امره اذا اراد شيا ان يقول له كن فيكون",
  },
  {
    verseId: 82,
    name: "يس",
    surahId: 36,
    text: "فَسُبۡحَٰنَ ٱلَّذِي بِيَدِهِۦ مَلَكُوتُ كُلِّ شَيۡءٖ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "So exalted is He in whose hand is the realm of all things, and to Him you will be returned",
    normalizedText: "فسبحن الذي بيده ملكوت كل شيء واليه ترجعون",
  },
  {
    verseId: 0,
    name: "الصافات",
    surahId: 37,
    text: "وَٱلصَّـٰٓفَّـٰتِ صَفّٗا",
    translation: "By those [angels] lined up in rows",
    normalizedText: "والصفت صفا",
  },
  {
    verseId: 1,
    name: "الصافات",
    surahId: 37,
    text: "فَٱلزَّـٰجِرَٰتِ زَجۡرٗا",
    translation: "And those who drive [the clouds]",
    normalizedText: "فالزجرت زجرا",
  },
  {
    verseId: 2,
    name: "الصافات",
    surahId: 37,
    text: "فَٱلتَّـٰلِيَٰتِ ذِكۡرًا",
    translation: "And those who recite the message",
    normalizedText: "فالتليت ذكرا",
  },
  {
    verseId: 3,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّ إِلَٰهَكُمۡ لَوَٰحِدٞ",
    translation: "Indeed, your God is One",
    normalizedText: "ان الهكم لوحد",
  },
  {
    verseId: 4,
    name: "الصافات",
    surahId: 37,
    text: "رَّبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَا وَرَبُّ ٱلۡمَشَٰرِقِ",
    translation:
      "Lord of the heavens and the earth and that between them and Lord of the sunrises",
    normalizedText: "رب السموت والارض وما بينهما ورب المشرق",
  },
  {
    verseId: 5,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّا زَيَّنَّا ٱلسَّمَآءَ ٱلدُّنۡيَا بِزِينَةٍ ٱلۡكَوَاكِبِ",
    translation:
      "Indeed, We have adorned the nearest heaven with an adornment of stars",
    normalizedText: "انا زينا السماء الدنيا بزينة الكواكب",
  },
  {
    verseId: 6,
    name: "الصافات",
    surahId: 37,
    text: "وَحِفۡظٗا مِّن كُلِّ شَيۡطَٰنٖ مَّارِدٖ",
    translation: "And as protection against every rebellious devil",
    normalizedText: "وحفظا من كل شيطن مارد",
  },
  {
    verseId: 7,
    name: "الصافات",
    surahId: 37,
    text: "لَّا يَسَّمَّعُونَ إِلَى ٱلۡمَلَإِ ٱلۡأَعۡلَىٰ وَيُقۡذَفُونَ مِن كُلِّ جَانِبٖ",
    translation:
      "[So] they may not listen to the exalted assembly [of angels] and are pelted from every side",
    normalizedText: "لا يسمعون الى الملا الاعلى ويقذفون من كل جانب",
  },
  {
    verseId: 8,
    name: "الصافات",
    surahId: 37,
    text: "دُحُورٗاۖ وَلَهُمۡ عَذَابٞ وَاصِبٌ",
    translation: "Repelled; and for them is a constant punishment",
    normalizedText: "دحورا ولهم عذاب واصب",
  },
  {
    verseId: 9,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا مَنۡ خَطِفَ ٱلۡخَطۡفَةَ فَأَتۡبَعَهُۥ شِهَابٞ ثَاقِبٞ",
    translation:
      "Except one who snatches [some words] by theft, but they are pursued by a burning flame, piercing [in brightness]",
    normalizedText: "الا من خطف الخطفة فاتبعه شهاب ثاقب",
  },
  {
    verseId: 10,
    name: "الصافات",
    surahId: 37,
    text: "فَٱسۡتَفۡتِهِمۡ أَهُمۡ أَشَدُّ خَلۡقًا أَم مَّنۡ خَلَقۡنَآۚ إِنَّا خَلَقۡنَٰهُم مِّن طِينٖ لَّازِبِۭ",
    translation:
      'Then inquire of them, [O Muhammad], "Are they a stronger [or more difficult] creation or those [others] We have created?" Indeed, We created men from sticky clay',
    normalizedText: "فاستفتهم اهم اشد خلقا ام من خلقنا انا خلقنهم من طين لازب",
  },
  {
    verseId: 11,
    name: "الصافات",
    surahId: 37,
    text: "بَلۡ عَجِبۡتَ وَيَسۡخَرُونَ",
    translation: "But you wonder, while they mock",
    normalizedText: "بل عجبت ويسخرون",
  },
  {
    verseId: 12,
    name: "الصافات",
    surahId: 37,
    text: "وَإِذَا ذُكِّرُواْ لَا يَذۡكُرُونَ",
    translation: "And when they are reminded, they remember not",
    normalizedText: "واذا ذكروا لا يذكرون",
  },
  {
    verseId: 13,
    name: "الصافات",
    surahId: 37,
    text: "وَإِذَا رَأَوۡاْ ءَايَةٗ يَسۡتَسۡخِرُونَ",
    translation: "And when they see a sign, they ridicule",
    normalizedText: "واذا راوا ءاية يستسخرون",
  },
  {
    verseId: 14,
    name: "الصافات",
    surahId: 37,
    text: "وَقَالُوٓاْ إِنۡ هَٰذَآ إِلَّا سِحۡرٞ مُّبِينٌ",
    translation: 'And say, "This is not but obvious magic',
    normalizedText: "وقالوا ان هذا الا سحر مبين",
  },
  {
    verseId: 15,
    name: "الصافات",
    surahId: 37,
    text: "أَءِذَا مِتۡنَا وَكُنَّا تُرَابٗا وَعِظَٰمًا أَءِنَّا لَمَبۡعُوثُونَ",
    translation:
      "When we have died and become dust and bones, are we indeed to be resurrected",
    normalizedText: "اءذا متنا وكنا ترابا وعظما اءنا لمبعوثون",
  },
  {
    verseId: 16,
    name: "الصافات",
    surahId: 37,
    text: "أَوَءَابَآؤُنَا ٱلۡأَوَّلُونَ",
    translation: "And our forefathers [as well]",
    normalizedText: "اوءاباانا الاولون",
  },
  {
    verseId: 17,
    name: "الصافات",
    surahId: 37,
    text: "قُلۡ نَعَمۡ وَأَنتُمۡ دَٰخِرُونَ",
    translation: 'Say, "Yes, and you will be [rendered] contemptible',
    normalizedText: "قل نعم وانتم دخرون",
  },
  {
    verseId: 18,
    name: "الصافات",
    surahId: 37,
    text: "فَإِنَّمَا هِيَ زَجۡرَةٞ وَٰحِدَةٞ فَإِذَا هُمۡ يَنظُرُونَ",
    translation:
      "It will be only one shout, and at once they will be observing",
    normalizedText: "فانما هي زجرة وحدة فاذا هم ينظرون",
  },
  {
    verseId: 19,
    name: "الصافات",
    surahId: 37,
    text: "وَقَالُواْ يَٰوَيۡلَنَا هَٰذَا يَوۡمُ ٱلدِّينِ",
    translation: 'They will say, "O woe to us! This is the Day of Recompense',
    normalizedText: "وقالوا يويلنا هذا يوم الدين",
  },
  {
    verseId: 20,
    name: "الصافات",
    surahId: 37,
    text: "هَٰذَا يَوۡمُ ٱلۡفَصۡلِ ٱلَّذِي كُنتُم بِهِۦ تُكَذِّبُونَ",
    translation:
      '[They will be told], "This is the Day of Judgement which you used to deny',
    normalizedText: "هذا يوم الفصل الذي كنتم به تكذبون",
  },
  {
    verseId: 21,
    name: "الصافات",
    surahId: 37,
    text: "۞ٱحۡشُرُواْ ٱلَّذِينَ ظَلَمُواْ وَأَزۡوَٰجَهُمۡ وَمَا كَانُواْ يَعۡبُدُونَ",
    translation:
      '[The angels will be ordered], "Gather those who committed wrong, their kinds, and what they used to worship',
    normalizedText: "۞احشروا الذين ظلموا وازوجهم وما كانوا يعبدون",
  },
  {
    verseId: 22,
    name: "الصافات",
    surahId: 37,
    text: "مِن دُونِ ٱللَّهِ فَٱهۡدُوهُمۡ إِلَىٰ صِرَٰطِ ٱلۡجَحِيمِ",
    translation: "Other than Allah, and guide them to the path of Hellfire",
    normalizedText: "من دون الله فاهدوهم الى صرط الجحيم",
  },
  {
    verseId: 23,
    name: "الصافات",
    surahId: 37,
    text: "وَقِفُوهُمۡۖ إِنَّهُم مَّسۡـُٔولُونَ",
    translation: "And stop them; indeed, they are to be questioned",
    normalizedText: "وقفوهم انهم مسولون",
  },
  {
    verseId: 24,
    name: "الصافات",
    surahId: 37,
    text: "مَا لَكُمۡ لَا تَنَاصَرُونَ",
    translation:
      '[They will be asked], "What is [wrong] with you? Why do you not help each other',
    normalizedText: "ما لكم لا تناصرون",
  },
  {
    verseId: 25,
    name: "الصافات",
    surahId: 37,
    text: "بَلۡ هُمُ ٱلۡيَوۡمَ مُسۡتَسۡلِمُونَ",
    translation: "But they, that Day, are in surrender",
    normalizedText: "بل هم اليوم مستسلمون",
  },
  {
    verseId: 26,
    name: "الصافات",
    surahId: 37,
    text: "وَأَقۡبَلَ بَعۡضُهُمۡ عَلَىٰ بَعۡضٖ يَتَسَآءَلُونَ",
    translation: "And they will approach one another blaming each other",
    normalizedText: "واقبل بعضهم على بعض يتساءلون",
  },
  {
    verseId: 27,
    name: "الصافات",
    surahId: 37,
    text: "قَالُوٓاْ إِنَّكُمۡ كُنتُمۡ تَأۡتُونَنَا عَنِ ٱلۡيَمِينِ",
    translation:
      'They will say, "Indeed, you used to come at us from the right',
    normalizedText: "قالوا انكم كنتم تاتوننا عن اليمين",
  },
  {
    verseId: 28,
    name: "الصافات",
    surahId: 37,
    text: "قَالُواْ بَل لَّمۡ تَكُونُواْ مُؤۡمِنِينَ",
    translation:
      'The oppressors will say, "Rather, you [yourselves] were not believers',
    normalizedText: "قالوا بل لم تكونوا مامنين",
  },
  {
    verseId: 29,
    name: "الصافات",
    surahId: 37,
    text: "وَمَا كَانَ لَنَا عَلَيۡكُم مِّن سُلۡطَٰنِۭۖ بَلۡ كُنتُمۡ قَوۡمٗا طَٰغِينَ",
    translation:
      "And we had over you no authority, but you were a transgressing people",
    normalizedText: "وما كان لنا عليكم من سلطن بل كنتم قوما طغين",
  },
  {
    verseId: 30,
    name: "الصافات",
    surahId: 37,
    text: "فَحَقَّ عَلَيۡنَا قَوۡلُ رَبِّنَآۖ إِنَّا لَذَآئِقُونَ",
    translation:
      "So the word of our Lord has come into effect upon us; indeed, we will taste [punishment]",
    normalizedText: "فحق علينا قول ربنا انا لذااقون",
  },
  {
    verseId: 31,
    name: "الصافات",
    surahId: 37,
    text: "فَأَغۡوَيۡنَٰكُمۡ إِنَّا كُنَّا غَٰوِينَ",
    translation: "And we led you to deviation; indeed, we were deviators",
    normalizedText: "فاغوينكم انا كنا غوين",
  },
  {
    verseId: 32,
    name: "الصافات",
    surahId: 37,
    text: "فَإِنَّهُمۡ يَوۡمَئِذٖ فِي ٱلۡعَذَابِ مُشۡتَرِكُونَ",
    translation: "So indeed they, that Day, will be sharing in the punishment",
    normalizedText: "فانهم يوماذ في العذاب مشتركون",
  },
  {
    verseId: 33,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّا كَذَٰلِكَ نَفۡعَلُ بِٱلۡمُجۡرِمِينَ",
    translation: "Indeed, that is how We deal with the criminals",
    normalizedText: "انا كذلك نفعل بالمجرمين",
  },
  {
    verseId: 34,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهُمۡ كَانُوٓاْ إِذَا قِيلَ لَهُمۡ لَآ إِلَٰهَ إِلَّا ٱللَّهُ يَسۡتَكۡبِرُونَ",
    translation:
      'Indeed they, when it was said to them, "There is no deity but Allah," were arrogant',
    normalizedText: "انهم كانوا اذا قيل لهم لا اله الا الله يستكبرون",
  },
  {
    verseId: 35,
    name: "الصافات",
    surahId: 37,
    text: "وَيَقُولُونَ أَئِنَّا لَتَارِكُوٓاْ ءَالِهَتِنَا لِشَاعِرٖ مَّجۡنُونِۭ",
    translation: 'And were saying, "Are we to leave our gods for a mad poet',
    normalizedText: "ويقولون اانا لتاركوا ءالهتنا لشاعر مجنون",
  },
  {
    verseId: 36,
    name: "الصافات",
    surahId: 37,
    text: "بَلۡ جَآءَ بِٱلۡحَقِّ وَصَدَّقَ ٱلۡمُرۡسَلِينَ",
    translation:
      "Rather, the Prophet has come with the truth and confirmed the [previous] messengers",
    normalizedText: "بل جاء بالحق وصدق المرسلين",
  },
  {
    verseId: 37,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّكُمۡ لَذَآئِقُواْ ٱلۡعَذَابِ ٱلۡأَلِيمِ",
    translation:
      "Indeed, you [disbelievers] will be tasters of the painful punishment",
    normalizedText: "انكم لذااقوا العذاب الاليم",
  },
  {
    verseId: 38,
    name: "الصافات",
    surahId: 37,
    text: "وَمَا تُجۡزَوۡنَ إِلَّا مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "And you will not be recompensed except for what you used to do",
    normalizedText: "وما تجزون الا ما كنتم تعملون",
  },
  {
    verseId: 39,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا عِبَادَ ٱللَّهِ ٱلۡمُخۡلَصِينَ",
    translation: "But not the chosen servants of Allah",
    normalizedText: "الا عباد الله المخلصين",
  },
  {
    verseId: 40,
    name: "الصافات",
    surahId: 37,
    text: "أُوْلَـٰٓئِكَ لَهُمۡ رِزۡقٞ مَّعۡلُومٞ",
    translation: "Those will have a provision determined",
    normalizedText: "اولاك لهم رزق معلوم",
  },
  {
    verseId: 41,
    name: "الصافات",
    surahId: 37,
    text: "فَوَٰكِهُ وَهُم مُّكۡرَمُونَ",
    translation: "Fruits; and they will be honored",
    normalizedText: "فوكه وهم مكرمون",
  },
  {
    verseId: 42,
    name: "الصافات",
    surahId: 37,
    text: "فِي جَنَّـٰتِ ٱلنَّعِيمِ",
    translation: "In gardens of pleasure",
    normalizedText: "في جنت النعيم",
  },
  {
    verseId: 43,
    name: "الصافات",
    surahId: 37,
    text: "عَلَىٰ سُرُرٖ مُّتَقَٰبِلِينَ",
    translation: "On thrones facing one another",
    normalizedText: "على سرر متقبلين",
  },
  {
    verseId: 44,
    name: "الصافات",
    surahId: 37,
    text: "يُطَافُ عَلَيۡهِم بِكَأۡسٖ مِّن مَّعِينِۭ",
    translation:
      "There will be circulated among them a cup [of wine] from a flowing spring",
    normalizedText: "يطاف عليهم بكاس من معين",
  },
  {
    verseId: 45,
    name: "الصافات",
    surahId: 37,
    text: "بَيۡضَآءَ لَذَّةٖ لِّلشَّـٰرِبِينَ",
    translation: "White and delicious to the drinkers",
    normalizedText: "بيضاء لذة للشربين",
  },
  {
    verseId: 46,
    name: "الصافات",
    surahId: 37,
    text: "لَا فِيهَا غَوۡلٞ وَلَا هُمۡ عَنۡهَا يُنزَفُونَ",
    translation:
      "No bad effect is there in it, nor from it will they be intoxicated",
    normalizedText: "لا فيها غول ولا هم عنها ينزفون",
  },
  {
    verseId: 47,
    name: "الصافات",
    surahId: 37,
    text: "وَعِندَهُمۡ قَٰصِرَٰتُ ٱلطَّرۡفِ عِينٞ",
    translation:
      "And with them will be women limiting [their] glances, with large, [beautiful] eyes",
    normalizedText: "وعندهم قصرت الطرف عين",
  },
  {
    verseId: 48,
    name: "الصافات",
    surahId: 37,
    text: "كَأَنَّهُنَّ بَيۡضٞ مَّكۡنُونٞ",
    translation: "As if they were [delicate] eggs, well-protected",
    normalizedText: "كانهن بيض مكنون",
  },
  {
    verseId: 49,
    name: "الصافات",
    surahId: 37,
    text: "فَأَقۡبَلَ بَعۡضُهُمۡ عَلَىٰ بَعۡضٖ يَتَسَآءَلُونَ",
    translation: "And they will approach one another, inquiring of each other",
    normalizedText: "فاقبل بعضهم على بعض يتساءلون",
  },
  {
    verseId: 50,
    name: "الصافات",
    surahId: 37,
    text: "قَالَ قَآئِلٞ مِّنۡهُمۡ إِنِّي كَانَ لِي قَرِينٞ",
    translation:
      'A speaker among them will say, "Indeed, I had a companion [on earth]',
    normalizedText: "قال قاال منهم اني كان لي قرين",
  },
  {
    verseId: 51,
    name: "الصافات",
    surahId: 37,
    text: "يَقُولُ أَءِنَّكَ لَمِنَ ٱلۡمُصَدِّقِينَ",
    translation: "Who would say, 'Are you indeed of those who believe",
    normalizedText: "يقول اءنك لمن المصدقين",
  },
  {
    verseId: 52,
    name: "الصافات",
    surahId: 37,
    text: "أَءِذَا مِتۡنَا وَكُنَّا تُرَابٗا وَعِظَٰمًا أَءِنَّا لَمَدِينُونَ",
    translation:
      "That when we have died and become dust and bones, we will indeed be recompensed",
    normalizedText: "اءذا متنا وكنا ترابا وعظما اءنا لمدينون",
  },
  {
    verseId: 53,
    name: "الصافات",
    surahId: 37,
    text: "قَالَ هَلۡ أَنتُم مُّطَّلِعُونَ",
    translation: 'He will say, "Would you [care to] look',
    normalizedText: "قال هل انتم مطلعون",
  },
  {
    verseId: 54,
    name: "الصافات",
    surahId: 37,
    text: "فَٱطَّلَعَ فَرَءَاهُ فِي سَوَآءِ ٱلۡجَحِيمِ",
    translation: "And he will look and see him in the midst of the Hellfire",
    normalizedText: "فاطلع فرءاه في سواء الجحيم",
  },
  {
    verseId: 55,
    name: "الصافات",
    surahId: 37,
    text: "قَالَ تَٱللَّهِ إِن كِدتَّ لَتُرۡدِينِ",
    translation: 'He will say, "By Allah, you almost ruined me',
    normalizedText: "قال تالله ان كدت لتردين",
  },
  {
    verseId: 56,
    name: "الصافات",
    surahId: 37,
    text: "وَلَوۡلَا نِعۡمَةُ رَبِّي لَكُنتُ مِنَ ٱلۡمُحۡضَرِينَ",
    translation:
      "If not for the favor of my Lord, I would have been of those brought in [to Hell]",
    normalizedText: "ولولا نعمة ربي لكنت من المحضرين",
  },
  {
    verseId: 57,
    name: "الصافات",
    surahId: 37,
    text: "أَفَمَا نَحۡنُ بِمَيِّتِينَ",
    translation: "Then, are we not to die",
    normalizedText: "افما نحن بميتين",
  },
  {
    verseId: 58,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا مَوۡتَتَنَا ٱلۡأُولَىٰ وَمَا نَحۡنُ بِمُعَذَّبِينَ",
    translation: "Except for our first death, and we will not be punished",
    normalizedText: "الا موتتنا الاولى وما نحن بمعذبين",
  },
  {
    verseId: 59,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّ هَٰذَا لَهُوَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation: "Indeed, this is the great attainment",
    normalizedText: "ان هذا لهو الفوز العظيم",
  },
  {
    verseId: 60,
    name: "الصافات",
    surahId: 37,
    text: "لِمِثۡلِ هَٰذَا فَلۡيَعۡمَلِ ٱلۡعَٰمِلُونَ",
    translation: "For the like of this let the workers [on earth] work",
    normalizedText: "لمثل هذا فليعمل العملون",
  },
  {
    verseId: 61,
    name: "الصافات",
    surahId: 37,
    text: "أَذَٰلِكَ خَيۡرٞ نُّزُلًا أَمۡ شَجَرَةُ ٱلزَّقُّومِ",
    translation: "Is Paradise a better accommodation or the tree of zaqqum",
    normalizedText: "اذلك خير نزلا ام شجرة الزقوم",
  },
  {
    verseId: 62,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّا جَعَلۡنَٰهَا فِتۡنَةٗ لِّلظَّـٰلِمِينَ",
    translation: "Indeed, We have made it a torment for the wrongdoers",
    normalizedText: "انا جعلنها فتنة للظلمين",
  },
  {
    verseId: 63,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهَا شَجَرَةٞ تَخۡرُجُ فِيٓ أَصۡلِ ٱلۡجَحِيمِ",
    translation: "Indeed, it is a tree issuing from the bottom of the Hellfire",
    normalizedText: "انها شجرة تخرج في اصل الجحيم",
  },
  {
    verseId: 64,
    name: "الصافات",
    surahId: 37,
    text: "طَلۡعُهَا كَأَنَّهُۥ رُءُوسُ ٱلشَّيَٰطِينِ",
    translation: "Its emerging fruit as if it was heads of the devils",
    normalizedText: "طلعها كانه رءوس الشيطين",
  },
  {
    verseId: 65,
    name: "الصافات",
    surahId: 37,
    text: "فَإِنَّهُمۡ لَأٓكِلُونَ مِنۡهَا فَمَالِـُٔونَ مِنۡهَا ٱلۡبُطُونَ",
    translation:
      "And indeed, they will eat from it and fill with it their bellies",
    normalizedText: "فانهم لاكلون منها فمالون منها البطون",
  },
  {
    verseId: 66,
    name: "الصافات",
    surahId: 37,
    text: "ثُمَّ إِنَّ لَهُمۡ عَلَيۡهَا لَشَوۡبٗا مِّنۡ حَمِيمٖ",
    translation:
      "Then indeed, they will have after it a mixture of scalding water",
    normalizedText: "ثم ان لهم عليها لشوبا من حميم",
  },
  {
    verseId: 67,
    name: "الصافات",
    surahId: 37,
    text: "ثُمَّ إِنَّ مَرۡجِعَهُمۡ لَإِلَى ٱلۡجَحِيمِ",
    translation: "Then indeed, their return will be to the Hellfire",
    normalizedText: "ثم ان مرجعهم لالى الجحيم",
  },
  {
    verseId: 68,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهُمۡ أَلۡفَوۡاْ ءَابَآءَهُمۡ ضَآلِّينَ",
    translation: "Indeed they found their fathers astray",
    normalizedText: "انهم الفوا ءاباءهم ضالين",
  },
  {
    verseId: 69,
    name: "الصافات",
    surahId: 37,
    text: "فَهُمۡ عَلَىٰٓ ءَاثَٰرِهِمۡ يُهۡرَعُونَ",
    translation: "So they hastened [to follow] in their footsteps",
    normalizedText: "فهم على ءاثرهم يهرعون",
  },
  {
    verseId: 70,
    name: "الصافات",
    surahId: 37,
    text: "وَلَقَدۡ ضَلَّ قَبۡلَهُمۡ أَكۡثَرُ ٱلۡأَوَّلِينَ",
    translation:
      "And there had already strayed before them most of the former peoples",
    normalizedText: "ولقد ضل قبلهم اكثر الاولين",
  },
  {
    verseId: 71,
    name: "الصافات",
    surahId: 37,
    text: "وَلَقَدۡ أَرۡسَلۡنَا فِيهِم مُّنذِرِينَ",
    translation: "And We had already sent among them warners",
    normalizedText: "ولقد ارسلنا فيهم منذرين",
  },
  {
    verseId: 72,
    name: "الصافات",
    surahId: 37,
    text: "فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُنذَرِينَ",
    translation: "Then look how was the end of those who were warned",
    normalizedText: "فانظر كيف كان عقبة المنذرين",
  },
  {
    verseId: 73,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا عِبَادَ ٱللَّهِ ٱلۡمُخۡلَصِينَ",
    translation: "But not the chosen servants of Allah",
    normalizedText: "الا عباد الله المخلصين",
  },
  {
    verseId: 74,
    name: "الصافات",
    surahId: 37,
    text: "وَلَقَدۡ نَادَىٰنَا نُوحٞ فَلَنِعۡمَ ٱلۡمُجِيبُونَ",
    translation:
      "And Noah had certainly called Us, and [We are] the best of responders",
    normalizedText: "ولقد نادىنا نوح فلنعم المجيبون",
  },
  {
    verseId: 75,
    name: "الصافات",
    surahId: 37,
    text: "وَنَجَّيۡنَٰهُ وَأَهۡلَهُۥ مِنَ ٱلۡكَرۡبِ ٱلۡعَظِيمِ",
    translation: "And We saved him and his family from the great affliction",
    normalizedText: "ونجينه واهله من الكرب العظيم",
  },
  {
    verseId: 76,
    name: "الصافات",
    surahId: 37,
    text: "وَجَعَلۡنَا ذُرِّيَّتَهُۥ هُمُ ٱلۡبَاقِينَ",
    translation: "And We made his descendants those remaining [on the earth]",
    normalizedText: "وجعلنا ذريته هم الباقين",
  },
  {
    verseId: 77,
    name: "الصافات",
    surahId: 37,
    text: "وَتَرَكۡنَا عَلَيۡهِ فِي ٱلۡأٓخِرِينَ",
    translation: "And left for him [favorable mention] among later generations",
    normalizedText: "وتركنا عليه في الاخرين",
  },
  {
    verseId: 78,
    name: "الصافات",
    surahId: 37,
    text: "سَلَٰمٌ عَلَىٰ نُوحٖ فِي ٱلۡعَٰلَمِينَ",
    translation: "Peace upon Noah among the worlds",
    normalizedText: "سلم على نوح في العلمين",
  },
  {
    verseId: 79,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّا كَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation: "Indeed, We thus reward the doers of good",
    normalizedText: "انا كذلك نجزي المحسنين",
  },
  {
    verseId: 80,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهُۥ مِنۡ عِبَادِنَا ٱلۡمُؤۡمِنِينَ",
    translation: "Indeed, he was of Our believing servants",
    normalizedText: "انه من عبادنا المامنين",
  },
  {
    verseId: 81,
    name: "الصافات",
    surahId: 37,
    text: "ثُمَّ أَغۡرَقۡنَا ٱلۡأٓخَرِينَ",
    translation: "Then We drowned the disbelievers",
    normalizedText: "ثم اغرقنا الاخرين",
  },
  {
    verseId: 82,
    name: "الصافات",
    surahId: 37,
    text: "۞وَإِنَّ مِن شِيعَتِهِۦ لَإِبۡرَٰهِيمَ",
    translation: "And indeed, among his kind was Abraham",
    normalizedText: "۞وان من شيعته لابرهيم",
  },
  {
    verseId: 83,
    name: "الصافات",
    surahId: 37,
    text: "إِذۡ جَآءَ رَبَّهُۥ بِقَلۡبٖ سَلِيمٍ",
    translation: "When he came to his Lord with a sound heart",
    normalizedText: "اذ جاء ربه بقلب سليم",
  },
  {
    verseId: 84,
    name: "الصافات",
    surahId: 37,
    text: "إِذۡ قَالَ لِأَبِيهِ وَقَوۡمِهِۦ مَاذَا تَعۡبُدُونَ",
    translation:
      '[And] when he said to his father and his people, "What do you worship',
    normalizedText: "اذ قال لابيه وقومه ماذا تعبدون",
  },
  {
    verseId: 85,
    name: "الصافات",
    surahId: 37,
    text: "أَئِفۡكًا ءَالِهَةٗ دُونَ ٱللَّهِ تُرِيدُونَ",
    translation: "Is it falsehood [as] gods other than Allah you desire",
    normalizedText: "اافكا ءالهة دون الله تريدون",
  },
  {
    verseId: 86,
    name: "الصافات",
    surahId: 37,
    text: "فَمَا ظَنُّكُم بِرَبِّ ٱلۡعَٰلَمِينَ",
    translation: "Then what is your thought about the Lord of the worlds",
    normalizedText: "فما ظنكم برب العلمين",
  },
  {
    verseId: 87,
    name: "الصافات",
    surahId: 37,
    text: "فَنَظَرَ نَظۡرَةٗ فِي ٱلنُّجُومِ",
    translation: "And he cast a look at the stars",
    normalizedText: "فنظر نظرة في النجوم",
  },
  {
    verseId: 88,
    name: "الصافات",
    surahId: 37,
    text: "فَقَالَ إِنِّي سَقِيمٞ",
    translation: 'And said, "Indeed, I am [about to be] ill',
    normalizedText: "فقال اني سقيم",
  },
  {
    verseId: 89,
    name: "الصافات",
    surahId: 37,
    text: "فَتَوَلَّوۡاْ عَنۡهُ مُدۡبِرِينَ",
    translation: "So they turned away from him, departing",
    normalizedText: "فتولوا عنه مدبرين",
  },
  {
    verseId: 90,
    name: "الصافات",
    surahId: 37,
    text: "فَرَاغَ إِلَىٰٓ ءَالِهَتِهِمۡ فَقَالَ أَلَا تَأۡكُلُونَ",
    translation: 'Then he turned to their gods and said, "Do you not eat',
    normalizedText: "فراغ الى ءالهتهم فقال الا تاكلون",
  },
  {
    verseId: 91,
    name: "الصافات",
    surahId: 37,
    text: "مَا لَكُمۡ لَا تَنطِقُونَ",
    translation: "What is [wrong] with you that you do not speak",
    normalizedText: "ما لكم لا تنطقون",
  },
  {
    verseId: 92,
    name: "الصافات",
    surahId: 37,
    text: "فَرَاغَ عَلَيۡهِمۡ ضَرۡبَۢا بِٱلۡيَمِينِ",
    translation: "And he turned upon them a blow with [his] right hand",
    normalizedText: "فراغ عليهم ضربا باليمين",
  },
  {
    verseId: 93,
    name: "الصافات",
    surahId: 37,
    text: "فَأَقۡبَلُوٓاْ إِلَيۡهِ يَزِفُّونَ",
    translation: "Then the people came toward him, hastening",
    normalizedText: "فاقبلوا اليه يزفون",
  },
  {
    verseId: 94,
    name: "الصافات",
    surahId: 37,
    text: "قَالَ أَتَعۡبُدُونَ مَا تَنۡحِتُونَ",
    translation: 'He said, "Do you worship that which you [yourselves] carve',
    normalizedText: "قال اتعبدون ما تنحتون",
  },
  {
    verseId: 95,
    name: "الصافات",
    surahId: 37,
    text: "وَٱللَّهُ خَلَقَكُمۡ وَمَا تَعۡمَلُونَ",
    translation: "While Allah created you and that which you do",
    normalizedText: "والله خلقكم وما تعملون",
  },
  {
    verseId: 96,
    name: "الصافات",
    surahId: 37,
    text: "قَالُواْ ٱبۡنُواْ لَهُۥ بُنۡيَٰنٗا فَأَلۡقُوهُ فِي ٱلۡجَحِيمِ",
    translation:
      'They said, "Construct for him a furnace and throw him into the burning fire',
    normalizedText: "قالوا ابنوا له بنينا فالقوه في الجحيم",
  },
  {
    verseId: 97,
    name: "الصافات",
    surahId: 37,
    text: "فَأَرَادُواْ بِهِۦ كَيۡدٗا فَجَعَلۡنَٰهُمُ ٱلۡأَسۡفَلِينَ",
    translation:
      "And they intended for him a plan, but We made them the most debased",
    normalizedText: "فارادوا به كيدا فجعلنهم الاسفلين",
  },
  {
    verseId: 98,
    name: "الصافات",
    surahId: 37,
    text: "وَقَالَ إِنِّي ذَاهِبٌ إِلَىٰ رَبِّي سَيَهۡدِينِ",
    translation:
      'And [then] he said, "Indeed, I will go to [where I am ordered by] my Lord; He will guide me',
    normalizedText: "وقال اني ذاهب الى ربي سيهدين",
  },
  {
    verseId: 99,
    name: "الصافات",
    surahId: 37,
    text: "رَبِّ هَبۡ لِي مِنَ ٱلصَّـٰلِحِينَ",
    translation: "My Lord, grant me [a child] from among the righteous",
    normalizedText: "رب هب لي من الصلحين",
  },
  {
    verseId: 100,
    name: "الصافات",
    surahId: 37,
    text: "فَبَشَّرۡنَٰهُ بِغُلَٰمٍ حَلِيمٖ",
    translation: "So We gave him good tidings of a forbearing boy",
    normalizedText: "فبشرنه بغلم حليم",
  },
  {
    verseId: 101,
    name: "الصافات",
    surahId: 37,
    text: "فَلَمَّا بَلَغَ مَعَهُ ٱلسَّعۡيَ قَالَ يَٰبُنَيَّ إِنِّيٓ أَرَىٰ فِي ٱلۡمَنَامِ أَنِّيٓ أَذۡبَحُكَ فَٱنظُرۡ مَاذَا تَرَىٰۚ قَالَ يَـٰٓأَبَتِ ٱفۡعَلۡ مَا تُؤۡمَرُۖ سَتَجِدُنِيٓ إِن شَآءَ ٱللَّهُ مِنَ ٱلصَّـٰبِرِينَ",
    translation:
      'And when he reached with him [the age of] exertion, he said, "O my son, indeed I have seen in a dream that I [must] sacrifice you, so see what you think." He said, "O my father, do as you are commanded. You will find me, if Allah wills, of the steadfast',
    normalizedText:
      "فلما بلغ معه السعي قال يبني اني ارى في المنام اني اذبحك فانظر ماذا ترى قال يابت افعل ما تامر ستجدني ان شاء الله من الصبرين",
  },
  {
    verseId: 102,
    name: "الصافات",
    surahId: 37,
    text: "فَلَمَّآ أَسۡلَمَا وَتَلَّهُۥ لِلۡجَبِينِ",
    translation:
      "And when they had both submitted and he put him down upon his forehead",
    normalizedText: "فلما اسلما وتله للجبين",
  },
  {
    verseId: 103,
    name: "الصافات",
    surahId: 37,
    text: "وَنَٰدَيۡنَٰهُ أَن يَـٰٓإِبۡرَٰهِيمُ",
    translation: 'We called to him, "O Abraham',
    normalizedText: "وندينه ان يابرهيم",
  },
  {
    verseId: 104,
    name: "الصافات",
    surahId: 37,
    text: "قَدۡ صَدَّقۡتَ ٱلرُّءۡيَآۚ إِنَّا كَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation:
      'You have fulfilled the vision." Indeed, We thus reward the doers of good',
    normalizedText: "قد صدقت الرءيا انا كذلك نجزي المحسنين",
  },
  {
    verseId: 105,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّ هَٰذَا لَهُوَ ٱلۡبَلَـٰٓؤُاْ ٱلۡمُبِينُ",
    translation: "Indeed, this was the clear trial",
    normalizedText: "ان هذا لهو البلاا المبين",
  },
  {
    verseId: 106,
    name: "الصافات",
    surahId: 37,
    text: "وَفَدَيۡنَٰهُ بِذِبۡحٍ عَظِيمٖ",
    translation: "And We ransomed him with a great sacrifice",
    normalizedText: "وفدينه بذبح عظيم",
  },
  {
    verseId: 107,
    name: "الصافات",
    surahId: 37,
    text: "وَتَرَكۡنَا عَلَيۡهِ فِي ٱلۡأٓخِرِينَ",
    translation:
      "And We left for him [favorable mention] among later generations",
    normalizedText: "وتركنا عليه في الاخرين",
  },
  {
    verseId: 108,
    name: "الصافات",
    surahId: 37,
    text: "سَلَٰمٌ عَلَىٰٓ إِبۡرَٰهِيمَ",
    translation: "Peace upon Abraham",
    normalizedText: "سلم على ابرهيم",
  },
  {
    verseId: 109,
    name: "الصافات",
    surahId: 37,
    text: "كَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation: "Indeed, We thus reward the doers of good",
    normalizedText: "كذلك نجزي المحسنين",
  },
  {
    verseId: 110,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهُۥ مِنۡ عِبَادِنَا ٱلۡمُؤۡمِنِينَ",
    translation: "Indeed, he was of Our believing servants",
    normalizedText: "انه من عبادنا المامنين",
  },
  {
    verseId: 111,
    name: "الصافات",
    surahId: 37,
    text: "وَبَشَّرۡنَٰهُ بِإِسۡحَٰقَ نَبِيّٗا مِّنَ ٱلصَّـٰلِحِينَ",
    translation:
      "And We gave him good tidings of Isaac, a prophet from among the righteous",
    normalizedText: "وبشرنه باسحق نبيا من الصلحين",
  },
  {
    verseId: 112,
    name: "الصافات",
    surahId: 37,
    text: "وَبَٰرَكۡنَا عَلَيۡهِ وَعَلَىٰٓ إِسۡحَٰقَۚ وَمِن ذُرِّيَّتِهِمَا مُحۡسِنٞ وَظَالِمٞ لِّنَفۡسِهِۦ مُبِينٞ",
    translation:
      "And We blessed him and Isaac. But among their descendants is the doer of good and the clearly unjust to himself",
    normalizedText: "وبركنا عليه وعلى اسحق ومن ذريتهما محسن وظالم لنفسه مبين",
  },
  {
    verseId: 113,
    name: "الصافات",
    surahId: 37,
    text: "وَلَقَدۡ مَنَنَّا عَلَىٰ مُوسَىٰ وَهَٰرُونَ",
    translation: "And We did certainly confer favor upon Moses and Aaron",
    normalizedText: "ولقد مننا على موسى وهرون",
  },
  {
    verseId: 114,
    name: "الصافات",
    surahId: 37,
    text: "وَنَجَّيۡنَٰهُمَا وَقَوۡمَهُمَا مِنَ ٱلۡكَرۡبِ ٱلۡعَظِيمِ",
    translation: "And We saved them and their people from the great affliction",
    normalizedText: "ونجينهما وقومهما من الكرب العظيم",
  },
  {
    verseId: 115,
    name: "الصافات",
    surahId: 37,
    text: "وَنَصَرۡنَٰهُمۡ فَكَانُواْ هُمُ ٱلۡغَٰلِبِينَ",
    translation: "And We supported them so it was they who overcame",
    normalizedText: "ونصرنهم فكانوا هم الغلبين",
  },
  {
    verseId: 116,
    name: "الصافات",
    surahId: 37,
    text: "وَءَاتَيۡنَٰهُمَا ٱلۡكِتَٰبَ ٱلۡمُسۡتَبِينَ",
    translation: "And We gave them the explicit Scripture",
    normalizedText: "وءاتينهما الكتب المستبين",
  },
  {
    verseId: 117,
    name: "الصافات",
    surahId: 37,
    text: "وَهَدَيۡنَٰهُمَا ٱلصِّرَٰطَ ٱلۡمُسۡتَقِيمَ",
    translation: "And We guided them on the straight path",
    normalizedText: "وهدينهما الصرط المستقيم",
  },
  {
    verseId: 118,
    name: "الصافات",
    surahId: 37,
    text: "وَتَرَكۡنَا عَلَيۡهِمَا فِي ٱلۡأٓخِرِينَ",
    translation:
      "And We left for them [favorable mention] among later generations",
    normalizedText: "وتركنا عليهما في الاخرين",
  },
  {
    verseId: 119,
    name: "الصافات",
    surahId: 37,
    text: "سَلَٰمٌ عَلَىٰ مُوسَىٰ وَهَٰرُونَ",
    translation: "Peace upon Moses and Aaron",
    normalizedText: "سلم على موسى وهرون",
  },
  {
    verseId: 120,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّا كَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation: "Indeed, We thus reward the doers of good",
    normalizedText: "انا كذلك نجزي المحسنين",
  },
  {
    verseId: 121,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهُمَا مِنۡ عِبَادِنَا ٱلۡمُؤۡمِنِينَ",
    translation: "Indeed, they were of Our believing servants",
    normalizedText: "انهما من عبادنا المامنين",
  },
  {
    verseId: 122,
    name: "الصافات",
    surahId: 37,
    text: "وَإِنَّ إِلۡيَاسَ لَمِنَ ٱلۡمُرۡسَلِينَ",
    translation: "And indeed, Elias was from among the messengers",
    normalizedText: "وان الياس لمن المرسلين",
  },
  {
    verseId: 123,
    name: "الصافات",
    surahId: 37,
    text: "إِذۡ قَالَ لِقَوۡمِهِۦٓ أَلَا تَتَّقُونَ",
    translation: 'When he said to his people, "Will you not fear Allah',
    normalizedText: "اذ قال لقومه الا تتقون",
  },
  {
    verseId: 124,
    name: "الصافات",
    surahId: 37,
    text: "أَتَدۡعُونَ بَعۡلٗا وَتَذَرُونَ أَحۡسَنَ ٱلۡخَٰلِقِينَ",
    translation: "Do you call upon Ba'l and leave the best of creators",
    normalizedText: "اتدعون بعلا وتذرون احسن الخلقين",
  },
  {
    verseId: 125,
    name: "الصافات",
    surahId: 37,
    text: "ٱللَّهَ رَبَّكُمۡ وَرَبَّ ءَابَآئِكُمُ ٱلۡأَوَّلِينَ",
    translation: "Allah, your Lord and the Lord of your first forefathers",
    normalizedText: "الله ربكم ورب ءابااكم الاولين",
  },
  {
    verseId: 126,
    name: "الصافات",
    surahId: 37,
    text: "فَكَذَّبُوهُ فَإِنَّهُمۡ لَمُحۡضَرُونَ",
    translation:
      "And they denied him, so indeed, they will be brought [for punishment]",
    normalizedText: "فكذبوه فانهم لمحضرون",
  },
  {
    verseId: 127,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا عِبَادَ ٱللَّهِ ٱلۡمُخۡلَصِينَ",
    translation: "Except the chosen servants of Allah",
    normalizedText: "الا عباد الله المخلصين",
  },
  {
    verseId: 128,
    name: "الصافات",
    surahId: 37,
    text: "وَتَرَكۡنَا عَلَيۡهِ فِي ٱلۡأٓخِرِينَ",
    translation:
      "And We left for him [favorable mention] among later generations",
    normalizedText: "وتركنا عليه في الاخرين",
  },
  {
    verseId: 129,
    name: "الصافات",
    surahId: 37,
    text: "سَلَٰمٌ عَلَىٰٓ إِلۡ يَاسِينَ",
    translation: "Peace upon Elias",
    normalizedText: "سلم على ال ياسين",
  },
  {
    verseId: 130,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّا كَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation: "Indeed, We thus reward the doers of good",
    normalizedText: "انا كذلك نجزي المحسنين",
  },
  {
    verseId: 131,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهُۥ مِنۡ عِبَادِنَا ٱلۡمُؤۡمِنِينَ",
    translation: "Indeed, he was of Our believing servants",
    normalizedText: "انه من عبادنا المامنين",
  },
  {
    verseId: 132,
    name: "الصافات",
    surahId: 37,
    text: "وَإِنَّ لُوطٗا لَّمِنَ ٱلۡمُرۡسَلِينَ",
    translation: "And indeed, Lot was among the messengers",
    normalizedText: "وان لوطا لمن المرسلين",
  },
  {
    verseId: 133,
    name: "الصافات",
    surahId: 37,
    text: "إِذۡ نَجَّيۡنَٰهُ وَأَهۡلَهُۥٓ أَجۡمَعِينَ",
    translation: "[So mention] when We saved him and his family, all",
    normalizedText: "اذ نجينه واهله اجمعين",
  },
  {
    verseId: 134,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا عَجُوزٗا فِي ٱلۡغَٰبِرِينَ",
    translation:
      "Except his wife among those who remained [with the evildoers]",
    normalizedText: "الا عجوزا في الغبرين",
  },
  {
    verseId: 135,
    name: "الصافات",
    surahId: 37,
    text: "ثُمَّ دَمَّرۡنَا ٱلۡأٓخَرِينَ",
    translation: "Then We destroyed the others",
    normalizedText: "ثم دمرنا الاخرين",
  },
  {
    verseId: 136,
    name: "الصافات",
    surahId: 37,
    text: "وَإِنَّكُمۡ لَتَمُرُّونَ عَلَيۡهِم مُّصۡبِحِينَ",
    translation: "And indeed, you pass by them in the morning",
    normalizedText: "وانكم لتمرون عليهم مصبحين",
  },
  {
    verseId: 137,
    name: "الصافات",
    surahId: 37,
    text: "وَبِٱلَّيۡلِۚ أَفَلَا تَعۡقِلُونَ",
    translation: "And at night. Then will you not use reason",
    normalizedText: "وباليل افلا تعقلون",
  },
  {
    verseId: 138,
    name: "الصافات",
    surahId: 37,
    text: "وَإِنَّ يُونُسَ لَمِنَ ٱلۡمُرۡسَلِينَ",
    translation: "And indeed, Jonah was among the messengers",
    normalizedText: "وان يونس لمن المرسلين",
  },
  {
    verseId: 139,
    name: "الصافات",
    surahId: 37,
    text: "إِذۡ أَبَقَ إِلَى ٱلۡفُلۡكِ ٱلۡمَشۡحُونِ",
    translation: "[Mention] when he ran away to the laden ship",
    normalizedText: "اذ ابق الى الفلك المشحون",
  },
  {
    verseId: 140,
    name: "الصافات",
    surahId: 37,
    text: "فَسَاهَمَ فَكَانَ مِنَ ٱلۡمُدۡحَضِينَ",
    translation: "And he drew lots and was among the losers",
    normalizedText: "فساهم فكان من المدحضين",
  },
  {
    verseId: 141,
    name: "الصافات",
    surahId: 37,
    text: "فَٱلۡتَقَمَهُ ٱلۡحُوتُ وَهُوَ مُلِيمٞ",
    translation: "Then the fish swallowed him, while he was blameworthy",
    normalizedText: "فالتقمه الحوت وهو مليم",
  },
  {
    verseId: 142,
    name: "الصافات",
    surahId: 37,
    text: "فَلَوۡلَآ أَنَّهُۥ كَانَ مِنَ ٱلۡمُسَبِّحِينَ",
    translation: "And had he not been of those who exalt Allah",
    normalizedText: "فلولا انه كان من المسبحين",
  },
  {
    verseId: 143,
    name: "الصافات",
    surahId: 37,
    text: "لَلَبِثَ فِي بَطۡنِهِۦٓ إِلَىٰ يَوۡمِ يُبۡعَثُونَ",
    translation:
      "He would have remained inside its belly until the Day they are resurrected",
    normalizedText: "للبث في بطنه الى يوم يبعثون",
  },
  {
    verseId: 144,
    name: "الصافات",
    surahId: 37,
    text: "۞فَنَبَذۡنَٰهُ بِٱلۡعَرَآءِ وَهُوَ سَقِيمٞ",
    translation: "But We threw him onto the open shore while he was ill",
    normalizedText: "۞فنبذنه بالعراء وهو سقيم",
  },
  {
    verseId: 145,
    name: "الصافات",
    surahId: 37,
    text: "وَأَنۢبَتۡنَا عَلَيۡهِ شَجَرَةٗ مِّن يَقۡطِينٖ",
    translation: "And We caused to grow over him a gourd vine",
    normalizedText: "وانبتنا عليه شجرة من يقطين",
  },
  {
    verseId: 146,
    name: "الصافات",
    surahId: 37,
    text: "وَأَرۡسَلۡنَٰهُ إِلَىٰ مِاْئَةِ أَلۡفٍ أَوۡ يَزِيدُونَ",
    translation:
      "And We sent him to [his people of] a hundred thousand or more",
    normalizedText: "وارسلنه الى مااة الف او يزيدون",
  },
  {
    verseId: 147,
    name: "الصافات",
    surahId: 37,
    text: "فَـَٔامَنُواْ فَمَتَّعۡنَٰهُمۡ إِلَىٰ حِينٖ",
    translation:
      "And they believed, so We gave them enjoyment [of life] for a time",
    normalizedText: "فامنوا فمتعنهم الى حين",
  },
  {
    verseId: 148,
    name: "الصافات",
    surahId: 37,
    text: "فَٱسۡتَفۡتِهِمۡ أَلِرَبِّكَ ٱلۡبَنَاتُ وَلَهُمُ ٱلۡبَنُونَ",
    translation:
      'So inquire of them, [O Muhammad], "Does your Lord have daughters while they have sons',
    normalizedText: "فاستفتهم الربك البنات ولهم البنون",
  },
  {
    verseId: 149,
    name: "الصافات",
    surahId: 37,
    text: "أَمۡ خَلَقۡنَا ٱلۡمَلَـٰٓئِكَةَ إِنَٰثٗا وَهُمۡ شَٰهِدُونَ",
    translation:
      "Or did We create the angels as females while they were witnesses",
    normalizedText: "ام خلقنا الملاكة انثا وهم شهدون",
  },
  {
    verseId: 150,
    name: "الصافات",
    surahId: 37,
    text: "أَلَآ إِنَّهُم مِّنۡ إِفۡكِهِمۡ لَيَقُولُونَ",
    translation:
      "Unquestionably, it is out of their [invented] falsehood that they say",
    normalizedText: "الا انهم من افكهم ليقولون",
  },
  {
    verseId: 151,
    name: "الصافات",
    surahId: 37,
    text: "وَلَدَ ٱللَّهُ وَإِنَّهُمۡ لَكَٰذِبُونَ",
    translation: 'Allah has begotten," and indeed, they are liars',
    normalizedText: "ولد الله وانهم لكذبون",
  },
  {
    verseId: 152,
    name: "الصافات",
    surahId: 37,
    text: "أَصۡطَفَى ٱلۡبَنَاتِ عَلَى ٱلۡبَنِينَ",
    translation: "Has He chosen daughters over sons",
    normalizedText: "اصطفى البنات على البنين",
  },
  {
    verseId: 153,
    name: "الصافات",
    surahId: 37,
    text: "مَا لَكُمۡ كَيۡفَ تَحۡكُمُونَ",
    translation: "What is [wrong] with you? How do you make judgement",
    normalizedText: "ما لكم كيف تحكمون",
  },
  {
    verseId: 154,
    name: "الصافات",
    surahId: 37,
    text: "أَفَلَا تَذَكَّرُونَ",
    translation: "Then will you not be reminded",
    normalizedText: "افلا تذكرون",
  },
  {
    verseId: 155,
    name: "الصافات",
    surahId: 37,
    text: "أَمۡ لَكُمۡ سُلۡطَٰنٞ مُّبِينٞ",
    translation: "Or do you have a clear authority",
    normalizedText: "ام لكم سلطن مبين",
  },
  {
    verseId: 156,
    name: "الصافات",
    surahId: 37,
    text: "فَأۡتُواْ بِكِتَٰبِكُمۡ إِن كُنتُمۡ صَٰدِقِينَ",
    translation: "Then produce your scripture, if you should be truthful",
    normalizedText: "فاتوا بكتبكم ان كنتم صدقين",
  },
  {
    verseId: 157,
    name: "الصافات",
    surahId: 37,
    text: "وَجَعَلُواْ بَيۡنَهُۥ وَبَيۡنَ ٱلۡجِنَّةِ نَسَبٗاۚ وَلَقَدۡ عَلِمَتِ ٱلۡجِنَّةُ إِنَّهُمۡ لَمُحۡضَرُونَ",
    translation:
      "And they have claimed between Him and the jinn a lineage, but the jinn have already known that they [who made such claims] will be brought to [punishment]",
    normalizedText: "وجعلوا بينه وبين الجنة نسبا ولقد علمت الجنة انهم لمحضرون",
  },
  {
    verseId: 158,
    name: "الصافات",
    surahId: 37,
    text: "سُبۡحَٰنَ ٱللَّهِ عَمَّا يَصِفُونَ",
    translation: "Exalted is Allah above what they describe",
    normalizedText: "سبحن الله عما يصفون",
  },
  {
    verseId: 159,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا عِبَادَ ٱللَّهِ ٱلۡمُخۡلَصِينَ",
    translation:
      "Except the chosen servants of Allah [who do not share in that sin]",
    normalizedText: "الا عباد الله المخلصين",
  },
  {
    verseId: 160,
    name: "الصافات",
    surahId: 37,
    text: "فَإِنَّكُمۡ وَمَا تَعۡبُدُونَ",
    translation: "So indeed, you [disbelievers] and whatever you worship",
    normalizedText: "فانكم وما تعبدون",
  },
  {
    verseId: 161,
    name: "الصافات",
    surahId: 37,
    text: "مَآ أَنتُمۡ عَلَيۡهِ بِفَٰتِنِينَ",
    translation: "You cannot tempt [anyone] away from Him",
    normalizedText: "ما انتم عليه بفتنين",
  },
  {
    verseId: 162,
    name: "الصافات",
    surahId: 37,
    text: "إِلَّا مَنۡ هُوَ صَالِ ٱلۡجَحِيمِ",
    translation: "Except he who is to [enter and] burn in the Hellfire",
    normalizedText: "الا من هو صال الجحيم",
  },
  {
    verseId: 163,
    name: "الصافات",
    surahId: 37,
    text: "وَمَامِنَّآ إِلَّا لَهُۥ مَقَامٞ مَّعۡلُومٞ",
    translation:
      '[The angels say], "There is not among us any except that he has a known position',
    normalizedText: "ومامنا الا له مقام معلوم",
  },
  {
    verseId: 164,
    name: "الصافات",
    surahId: 37,
    text: "وَإِنَّا لَنَحۡنُ ٱلصَّآفُّونَ",
    translation: "And indeed, we are those who line up [for prayer]",
    normalizedText: "وانا لنحن الصافون",
  },
  {
    verseId: 165,
    name: "الصافات",
    surahId: 37,
    text: "وَإِنَّا لَنَحۡنُ ٱلۡمُسَبِّحُونَ",
    translation: "And indeed, we are those who exalt Allah",
    normalizedText: "وانا لنحن المسبحون",
  },
  {
    verseId: 166,
    name: "الصافات",
    surahId: 37,
    text: "وَإِن كَانُواْ لَيَقُولُونَ",
    translation: "And indeed, the disbelievers used to say",
    normalizedText: "وان كانوا ليقولون",
  },
  {
    verseId: 167,
    name: "الصافات",
    surahId: 37,
    text: "لَوۡ أَنَّ عِندَنَا ذِكۡرٗا مِّنَ ٱلۡأَوَّلِينَ",
    translation: "If we had a message from [those of] the former peoples",
    normalizedText: "لو ان عندنا ذكرا من الاولين",
  },
  {
    verseId: 168,
    name: "الصافات",
    surahId: 37,
    text: "لَكُنَّا عِبَادَ ٱللَّهِ ٱلۡمُخۡلَصِينَ",
    translation: "We would have been the chosen servants of Allah",
    normalizedText: "لكنا عباد الله المخلصين",
  },
  {
    verseId: 169,
    name: "الصافات",
    surahId: 37,
    text: "فَكَفَرُواْ بِهِۦۖ فَسَوۡفَ يَعۡلَمُونَ",
    translation: "But they disbelieved in it, so they are going to know",
    normalizedText: "فكفروا به فسوف يعلمون",
  },
  {
    verseId: 170,
    name: "الصافات",
    surahId: 37,
    text: "وَلَقَدۡ سَبَقَتۡ كَلِمَتُنَا لِعِبَادِنَا ٱلۡمُرۡسَلِينَ",
    translation:
      "And Our word has already preceded for Our servants, the messengers",
    normalizedText: "ولقد سبقت كلمتنا لعبادنا المرسلين",
  },
  {
    verseId: 171,
    name: "الصافات",
    surahId: 37,
    text: "إِنَّهُمۡ لَهُمُ ٱلۡمَنصُورُونَ",
    translation: "[That] indeed, they would be those given victory",
    normalizedText: "انهم لهم المنصورون",
  },
  {
    verseId: 172,
    name: "الصافات",
    surahId: 37,
    text: "وَإِنَّ جُندَنَا لَهُمُ ٱلۡغَٰلِبُونَ",
    translation: "And [that] indeed, Our soldiers will be those who overcome",
    normalizedText: "وان جندنا لهم الغلبون",
  },
  {
    verseId: 173,
    name: "الصافات",
    surahId: 37,
    text: "فَتَوَلَّ عَنۡهُمۡ حَتَّىٰ حِينٖ",
    translation: "So, [O Muhammad], leave them for a time",
    normalizedText: "فتول عنهم حتى حين",
  },
  {
    verseId: 174,
    name: "الصافات",
    surahId: 37,
    text: "وَأَبۡصِرۡهُمۡ فَسَوۡفَ يُبۡصِرُونَ",
    translation: "And see [what will befall] them, for they are going to see",
    normalizedText: "وابصرهم فسوف يبصرون",
  },
  {
    verseId: 175,
    name: "الصافات",
    surahId: 37,
    text: "أَفَبِعَذَابِنَا يَسۡتَعۡجِلُونَ",
    translation: "Then for Our punishment are they impatient",
    normalizedText: "افبعذابنا يستعجلون",
  },
  {
    verseId: 176,
    name: "الصافات",
    surahId: 37,
    text: "فَإِذَا نَزَلَ بِسَاحَتِهِمۡ فَسَآءَ صَبَاحُ ٱلۡمُنذَرِينَ",
    translation:
      "But when it descends in their territory, then evil is the morning of those who were warned",
    normalizedText: "فاذا نزل بساحتهم فساء صباح المنذرين",
  },
  {
    verseId: 177,
    name: "الصافات",
    surahId: 37,
    text: "وَتَوَلَّ عَنۡهُمۡ حَتَّىٰ حِينٖ",
    translation: "And leave them for a time",
    normalizedText: "وتول عنهم حتى حين",
  },
  {
    verseId: 178,
    name: "الصافات",
    surahId: 37,
    text: "وَأَبۡصِرۡ فَسَوۡفَ يُبۡصِرُونَ",
    translation: "And see, for they are going to see",
    normalizedText: "وابصر فسوف يبصرون",
  },
  {
    verseId: 179,
    name: "الصافات",
    surahId: 37,
    text: "سُبۡحَٰنَ رَبِّكَ رَبِّ ٱلۡعِزَّةِ عَمَّا يَصِفُونَ",
    translation:
      "Exalted is your Lord, the Lord of might, above what they describe",
    normalizedText: "سبحن ربك رب العزة عما يصفون",
  },
  {
    verseId: 180,
    name: "الصافات",
    surahId: 37,
    text: "وَسَلَٰمٌ عَلَى ٱلۡمُرۡسَلِينَ",
    translation: "And peace upon the messengers",
    normalizedText: "وسلم على المرسلين",
  },
  {
    verseId: 181,
    name: "الصافات",
    surahId: 37,
    text: "وَٱلۡحَمۡدُ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation: "And praise to Allah, Lord of the worlds",
    normalizedText: "والحمد لله رب العلمين",
  },
  {
    verseId: 0,
    name: "ص",
    surahId: 38,
    text: "صٓۚ وَٱلۡقُرۡءَانِ ذِي ٱلذِّكۡرِ",
    translation: "Sad. By the Qur'an containing reminder",
    normalizedText: "ص والقرءان ذي الذكر",
  },
  {
    verseId: 1,
    name: "ص",
    surahId: 38,
    text: "بَلِ ٱلَّذِينَ كَفَرُواْ فِي عِزَّةٖ وَشِقَاقٖ",
    translation: "But those who disbelieve are in pride and dissension",
    normalizedText: "بل الذين كفروا في عزة وشقاق",
  },
  {
    verseId: 2,
    name: "ص",
    surahId: 38,
    text: "كَمۡ أَهۡلَكۡنَا مِن قَبۡلِهِم مِّن قَرۡنٖ فَنَادَواْ وَّلَاتَ حِينَ مَنَاصٖ",
    translation:
      "How many a generation have We destroyed before them, and they [then] called out; but it was not a time for escape",
    normalizedText: "كم اهلكنا من قبلهم من قرن فنادوا ولات حين مناص",
  },
  {
    verseId: 3,
    name: "ص",
    surahId: 38,
    text: "وَعَجِبُوٓاْ أَن جَآءَهُم مُّنذِرٞ مِّنۡهُمۡۖ وَقَالَ ٱلۡكَٰفِرُونَ هَٰذَا سَٰحِرٞ كَذَّابٌ",
    translation:
      'And they wonder that there has come to them a warner from among themselves. And the disbelievers say, "This is a magician and a liar',
    normalizedText: "وعجبوا ان جاءهم منذر منهم وقال الكفرون هذا سحر كذاب",
  },
  {
    verseId: 4,
    name: "ص",
    surahId: 38,
    text: "أَجَعَلَ ٱلۡأٓلِهَةَ إِلَٰهٗا وَٰحِدًاۖ إِنَّ هَٰذَا لَشَيۡءٌ عُجَابٞ",
    translation:
      "Has he made the gods [only] one God? Indeed, this is a curious thing",
    normalizedText: "اجعل الالهة الها وحدا ان هذا لشيء عجاب",
  },
  {
    verseId: 5,
    name: "ص",
    surahId: 38,
    text: "وَٱنطَلَقَ ٱلۡمَلَأُ مِنۡهُمۡ أَنِ ٱمۡشُواْ وَٱصۡبِرُواْ عَلَىٰٓ ءَالِهَتِكُمۡۖ إِنَّ هَٰذَا لَشَيۡءٞ يُرَادُ",
    translation:
      'And the eminent among them went forth, [saying], "Continue, and be patient over [the defense of] your gods. Indeed, this is a thing intended',
    normalizedText:
      "وانطلق الملا منهم ان امشوا واصبروا على ءالهتكم ان هذا لشيء يراد",
  },
  {
    verseId: 6,
    name: "ص",
    surahId: 38,
    text: "مَا سَمِعۡنَا بِهَٰذَا فِي ٱلۡمِلَّةِ ٱلۡأٓخِرَةِ إِنۡ هَٰذَآ إِلَّا ٱخۡتِلَٰقٌ",
    translation:
      "We have not heard of this in the latest religion. This is not but a fabrication",
    normalizedText: "ما سمعنا بهذا في الملة الاخرة ان هذا الا اختلق",
  },
  {
    verseId: 7,
    name: "ص",
    surahId: 38,
    text: "أَءُنزِلَ عَلَيۡهِ ٱلذِّكۡرُ مِنۢ بَيۡنِنَاۚ بَلۡ هُمۡ فِي شَكّٖ مِّن ذِكۡرِيۚ بَل لَّمَّا يَذُوقُواْ عَذَابِ",
    translation:
      'Has the message been revealed to him out of [all of] us?" Rather, they are in doubt about My message. Rather, they have not yet tasted My punishment',
    normalizedText:
      "اءنزل عليه الذكر من بيننا بل هم في شك من ذكري بل لما يذوقوا عذاب",
  },
  {
    verseId: 8,
    name: "ص",
    surahId: 38,
    text: "أَمۡ عِندَهُمۡ خَزَآئِنُ رَحۡمَةِ رَبِّكَ ٱلۡعَزِيزِ ٱلۡوَهَّابِ",
    translation:
      "Or do they have the depositories of the mercy of your Lord, the Exalted in Might, the Bestower",
    normalizedText: "ام عندهم خزاان رحمة ربك العزيز الوهاب",
  },
  {
    verseId: 9,
    name: "ص",
    surahId: 38,
    text: "أَمۡ لَهُم مُّلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَاۖ فَلۡيَرۡتَقُواْ فِي ٱلۡأَسۡبَٰبِ",
    translation:
      "Or is theirs the dominion of the heavens and the earth and what is between them? Then let them ascend through [any] ways of access",
    normalizedText: "ام لهم ملك السموت والارض وما بينهما فليرتقوا في الاسبب",
  },
  {
    verseId: 10,
    name: "ص",
    surahId: 38,
    text: "جُندٞ مَّا هُنَالِكَ مَهۡزُومٞ مِّنَ ٱلۡأَحۡزَابِ",
    translation:
      "[They are but] soldiers [who will be] defeated there among the companies [of disbelievers]",
    normalizedText: "جند ما هنالك مهزوم من الاحزاب",
  },
  {
    verseId: 11,
    name: "ص",
    surahId: 38,
    text: "كَذَّبَتۡ قَبۡلَهُمۡ قَوۡمُ نُوحٖ وَعَادٞ وَفِرۡعَوۡنُ ذُو ٱلۡأَوۡتَادِ",
    translation:
      "The people of Noah denied before them, and [the tribe of] 'Aad and Pharaoh, the owner of stakes",
    normalizedText: "كذبت قبلهم قوم نوح وعاد وفرعون ذو الاوتاد",
  },
  {
    verseId: 12,
    name: "ص",
    surahId: 38,
    text: "وَثَمُودُ وَقَوۡمُ لُوطٖ وَأَصۡحَٰبُ لۡـَٔيۡكَةِۚ أُوْلَـٰٓئِكَ ٱلۡأَحۡزَابُ",
    translation:
      "And [the tribe of] Thamud and the people of Lot and the companions of the thicket. Those are the companies",
    normalizedText: "وثمود وقوم لوط واصحب ليكة اولاك الاحزاب",
  },
  {
    verseId: 13,
    name: "ص",
    surahId: 38,
    text: "إِن كُلٌّ إِلَّا كَذَّبَ ٱلرُّسُلَ فَحَقَّ عِقَابِ",
    translation:
      "Each of them denied the messengers, so My penalty was justified",
    normalizedText: "ان كل الا كذب الرسل فحق عقاب",
  },
  {
    verseId: 14,
    name: "ص",
    surahId: 38,
    text: "وَمَا يَنظُرُ هَـٰٓؤُلَآءِ إِلَّا صَيۡحَةٗ وَٰحِدَةٗ مَّا لَهَا مِن فَوَاقٖ",
    translation:
      "And these [disbelievers] await not but one blast [of the Horn]; for it there will be no delay",
    normalizedText: "وما ينظر هالاء الا صيحة وحدة ما لها من فواق",
  },
  {
    verseId: 15,
    name: "ص",
    surahId: 38,
    text: "وَقَالُواْ رَبَّنَا عَجِّل لَّنَا قِطَّنَا قَبۡلَ يَوۡمِ ٱلۡحِسَابِ",
    translation:
      'And they say, "Our Lord, hasten for us our share [of the punishment] before the Day of Account',
    normalizedText: "وقالوا ربنا عجل لنا قطنا قبل يوم الحساب",
  },
  {
    verseId: 16,
    name: "ص",
    surahId: 38,
    text: "ٱصۡبِرۡ عَلَىٰ مَا يَقُولُونَ وَٱذۡكُرۡ عَبۡدَنَا دَاوُۥدَ ذَا ٱلۡأَيۡدِۖ إِنَّهُۥٓ أَوَّابٌ",
    translation:
      "Be patient over what they say and remember Our servant, David, the possessor of strength; indeed, he was one who repeatedly turned back [to Allah]",
    normalizedText: "اصبر على ما يقولون واذكر عبدنا داود ذا الايد انه اواب",
  },
  {
    verseId: 17,
    name: "ص",
    surahId: 38,
    text: "إِنَّا سَخَّرۡنَا ٱلۡجِبَالَ مَعَهُۥ يُسَبِّحۡنَ بِٱلۡعَشِيِّ وَٱلۡإِشۡرَاقِ",
    translation:
      "Indeed, We subjected the mountains [to praise] with him, exalting [Allah] in the [late] afternoon and [after] sunrise",
    normalizedText: "انا سخرنا الجبال معه يسبحن بالعشي والاشراق",
  },
  {
    verseId: 18,
    name: "ص",
    surahId: 38,
    text: "وَٱلطَّيۡرَ مَحۡشُورَةٗۖ كُلّٞ لَّهُۥٓ أَوَّابٞ",
    translation:
      "And the birds were assembled, all with him repeating [praises]",
    normalizedText: "والطير محشورة كل له اواب",
  },
  {
    verseId: 19,
    name: "ص",
    surahId: 38,
    text: "وَشَدَدۡنَا مُلۡكَهُۥ وَءَاتَيۡنَٰهُ ٱلۡحِكۡمَةَ وَفَصۡلَ ٱلۡخِطَابِ",
    translation:
      "And We strengthened his kingdom and gave him wisdom and discernment in speech",
    normalizedText: "وشددنا ملكه وءاتينه الحكمة وفصل الخطاب",
  },
  {
    verseId: 20,
    name: "ص",
    surahId: 38,
    text: "۞وَهَلۡ أَتَىٰكَ نَبَؤُاْ ٱلۡخَصۡمِ إِذۡ تَسَوَّرُواْ ٱلۡمِحۡرَابَ",
    translation:
      "And has there come to you the news of the adversaries, when they climbed over the wall of [his] prayer chamber",
    normalizedText: "۞وهل اتىك نباا الخصم اذ تسوروا المحراب",
  },
  {
    verseId: 21,
    name: "ص",
    surahId: 38,
    text: "إِذۡ دَخَلُواْ عَلَىٰ دَاوُۥدَ فَفَزِعَ مِنۡهُمۡۖ قَالُواْ لَا تَخَفۡۖ خَصۡمَانِ بَغَىٰ بَعۡضُنَا عَلَىٰ بَعۡضٖ فَٱحۡكُم بَيۡنَنَا بِٱلۡحَقِّ وَلَا تُشۡطِطۡ وَٱهۡدِنَآ إِلَىٰ سَوَآءِ ٱلصِّرَٰطِ",
    translation:
      'When they entered upon David and he was alarmed by them? They said, "Fear not. [We are] two adversaries, one of whom has wronged the other, so judge between us with truth and do not exceed [it] and guide us to the sound path',
    normalizedText:
      "اذ دخلوا على داود ففزع منهم قالوا لا تخف خصمان بغى بعضنا على بعض فاحكم بيننا بالحق ولا تشطط واهدنا الى سواء الصرط",
  },
  {
    verseId: 22,
    name: "ص",
    surahId: 38,
    text: "إِنَّ هَٰذَآ أَخِي لَهُۥ تِسۡعٞ وَتِسۡعُونَ نَعۡجَةٗ وَلِيَ نَعۡجَةٞ وَٰحِدَةٞ فَقَالَ أَكۡفِلۡنِيهَا وَعَزَّنِي فِي ٱلۡخِطَابِ",
    translation:
      "Indeed this, my brother, has ninety-nine ewes, and I have one ewe; so he said, 'Entrust her to me,' and he overpowered me in speech",
    normalizedText:
      "ان هذا اخي له تسع وتسعون نعجة ولي نعجة وحدة فقال اكفلنيها وعزني في الخطاب",
  },
  {
    verseId: 23,
    name: "ص",
    surahId: 38,
    text: "قَالَ لَقَدۡ ظَلَمَكَ بِسُؤَالِ نَعۡجَتِكَ إِلَىٰ نِعَاجِهِۦۖ وَإِنَّ كَثِيرٗا مِّنَ ٱلۡخُلَطَآءِ لَيَبۡغِي بَعۡضُهُمۡ عَلَىٰ بَعۡضٍ إِلَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَقَلِيلٞ مَّا هُمۡۗ وَظَنَّ دَاوُۥدُ أَنَّمَا فَتَنَّـٰهُ فَٱسۡتَغۡفَرَ رَبَّهُۥ وَخَرَّۤ رَاكِعٗاۤ وَأَنَابَ۩",
    translation:
      '[David] said, "He has certainly wronged you in demanding your ewe [in addition] to his ewes. And indeed, many associates oppress one another, except for those who believe and do righteous deeds - and few are they." And David became certain that We had tried him, and he asked forgiveness of his Lord and fell down bowing [in prostration] and turned in repentance [to Allah]',
    normalizedText:
      "قال لقد ظلمك بساال نعجتك الى نعاجه وان كثيرا من الخلطاء ليبغي بعضهم على بعض الا الذين ءامنوا وعملوا الصلحت وقليل ما هم وظن داود انما فتنه فاستغفر ربه وخر راكعا واناب۩",
  },
  {
    verseId: 24,
    name: "ص",
    surahId: 38,
    text: "فَغَفَرۡنَا لَهُۥ ذَٰلِكَۖ وَإِنَّ لَهُۥ عِندَنَا لَزُلۡفَىٰ وَحُسۡنَ مَـَٔابٖ",
    translation:
      "So We forgave him that; and indeed, for him is nearness to Us and a good place of return",
    normalizedText: "فغفرنا له ذلك وان له عندنا لزلفى وحسن ماب",
  },
  {
    verseId: 25,
    name: "ص",
    surahId: 38,
    text: "يَٰدَاوُۥدُ إِنَّا جَعَلۡنَٰكَ خَلِيفَةٗ فِي ٱلۡأَرۡضِ فَٱحۡكُم بَيۡنَ ٱلنَّاسِ بِٱلۡحَقِّ وَلَا تَتَّبِعِ ٱلۡهَوَىٰ فَيُضِلَّكَ عَن سَبِيلِ ٱللَّهِۚ إِنَّ ٱلَّذِينَ يَضِلُّونَ عَن سَبِيلِ ٱللَّهِ لَهُمۡ عَذَابٞ شَدِيدُۢ بِمَا نَسُواْ يَوۡمَ ٱلۡحِسَابِ",
    translation:
      '[We said], "O David, indeed We have made you a successor upon the earth, so judge between the people in truth and do not follow [your own] desire, as it will lead you astray from the way of Allah." Indeed, those who go astray from the way of Allah will have a severe punishment for having forgotten the Day of Account',
    normalizedText:
      "يداود انا جعلنك خليفة في الارض فاحكم بين الناس بالحق ولا تتبع الهوى فيضلك عن سبيل الله ان الذين يضلون عن سبيل الله لهم عذاب شديد بما نسوا يوم الحساب",
  },
  {
    verseId: 26,
    name: "ص",
    surahId: 38,
    text: "وَمَا خَلَقۡنَا ٱلسَّمَآءَ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَا بَٰطِلٗاۚ ذَٰلِكَ ظَنُّ ٱلَّذِينَ كَفَرُواْۚ فَوَيۡلٞ لِّلَّذِينَ كَفَرُواْ مِنَ ٱلنَّارِ",
    translation:
      "And We did not create the heaven and the earth and that between them aimlessly. That is the assumption of those who disbelieve, so woe to those who disbelieve from the Fire",
    normalizedText:
      "وما خلقنا السماء والارض وما بينهما بطلا ذلك ظن الذين كفروا فويل للذين كفروا من النار",
  },
  {
    verseId: 27,
    name: "ص",
    surahId: 38,
    text: "أَمۡ نَجۡعَلُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ كَٱلۡمُفۡسِدِينَ فِي ٱلۡأَرۡضِ أَمۡ نَجۡعَلُ ٱلۡمُتَّقِينَ كَٱلۡفُجَّارِ",
    translation:
      "Or should we treat those who believe and do righteous deeds like corrupters in the land? Or should We treat those who fear Allah like the wicked",
    normalizedText:
      "ام نجعل الذين ءامنوا وعملوا الصلحت كالمفسدين في الارض ام نجعل المتقين كالفجار",
  },
  {
    verseId: 28,
    name: "ص",
    surahId: 38,
    text: "كِتَٰبٌ أَنزَلۡنَٰهُ إِلَيۡكَ مُبَٰرَكٞ لِّيَدَّبَّرُوٓاْ ءَايَٰتِهِۦ وَلِيَتَذَكَّرَ أُوْلُواْ ٱلۡأَلۡبَٰبِ",
    translation:
      "[This is] a blessed Book which We have revealed to you, [O Muhammad], that they might reflect upon its verses and that those of understanding would be reminded",
    normalizedText: "كتب انزلنه اليك مبرك ليدبروا ءايته وليتذكر اولوا الالبب",
  },
  {
    verseId: 29,
    name: "ص",
    surahId: 38,
    text: "وَوَهَبۡنَا لِدَاوُۥدَ سُلَيۡمَٰنَۚ نِعۡمَ ٱلۡعَبۡدُ إِنَّهُۥٓ أَوَّابٌ",
    translation:
      "And to David We gave Solomon. An excellent servant, indeed he was one repeatedly turning back [to Allah]",
    normalizedText: "ووهبنا لداود سليمن نعم العبد انه اواب",
  },
  {
    verseId: 30,
    name: "ص",
    surahId: 38,
    text: "إِذۡ عُرِضَ عَلَيۡهِ بِٱلۡعَشِيِّ ٱلصَّـٰفِنَٰتُ ٱلۡجِيَادُ",
    translation:
      "[Mention] when there were exhibited before him in the afternoon the poised [standing] racehorses",
    normalizedText: "اذ عرض عليه بالعشي الصفنت الجياد",
  },
  {
    verseId: 31,
    name: "ص",
    surahId: 38,
    text: "فَقَالَ إِنِّيٓ أَحۡبَبۡتُ حُبَّ ٱلۡخَيۡرِ عَن ذِكۡرِ رَبِّي حَتَّىٰ تَوَارَتۡ بِٱلۡحِجَابِ",
    translation:
      'And he said, "Indeed, I gave preference to the love of good [things] over the remembrance of my Lord until the sun disappeared into the curtain [of darkness]',
    normalizedText: "فقال اني احببت حب الخير عن ذكر ربي حتى توارت بالحجاب",
  },
  {
    verseId: 32,
    name: "ص",
    surahId: 38,
    text: "رُدُّوهَا عَلَيَّۖ فَطَفِقَ مَسۡحَۢا بِٱلسُّوقِ وَٱلۡأَعۡنَاقِ",
    translation:
      '[He said], "Return them to me," and set about striking [their] legs and necks',
    normalizedText: "ردوها علي فطفق مسحا بالسوق والاعناق",
  },
  {
    verseId: 33,
    name: "ص",
    surahId: 38,
    text: "وَلَقَدۡ فَتَنَّا سُلَيۡمَٰنَ وَأَلۡقَيۡنَا عَلَىٰ كُرۡسِيِّهِۦ جَسَدٗا ثُمَّ أَنَابَ",
    translation:
      "And We certainly tried Solomon and placed on his throne a body; then he returned",
    normalizedText: "ولقد فتنا سليمن والقينا على كرسيه جسدا ثم اناب",
  },
  {
    verseId: 34,
    name: "ص",
    surahId: 38,
    text: "قَالَ رَبِّ ٱغۡفِرۡ لِي وَهَبۡ لِي مُلۡكٗا لَّا يَنۢبَغِي لِأَحَدٖ مِّنۢ بَعۡدِيٓۖ إِنَّكَ أَنتَ ٱلۡوَهَّابُ",
    translation:
      'He said, "My Lord, forgive me and grant me a kingdom such as will not belong to anyone after me. Indeed, You are the Bestower',
    normalizedText:
      "قال رب اغفر لي وهب لي ملكا لا ينبغي لاحد من بعدي انك انت الوهاب",
  },
  {
    verseId: 35,
    name: "ص",
    surahId: 38,
    text: "فَسَخَّرۡنَا لَهُ ٱلرِّيحَ تَجۡرِي بِأَمۡرِهِۦ رُخَآءً حَيۡثُ أَصَابَ",
    translation:
      "So We subjected to him the wind blowing by his command, gently, wherever he directed",
    normalizedText: "فسخرنا له الريح تجري بامره رخاء حيث اصاب",
  },
  {
    verseId: 36,
    name: "ص",
    surahId: 38,
    text: "وَٱلشَّيَٰطِينَ كُلَّ بَنَّآءٖ وَغَوَّاصٖ",
    translation: "And [also] the devils [of jinn] - every builder and diver",
    normalizedText: "والشيطين كل بناء وغواص",
  },
  {
    verseId: 37,
    name: "ص",
    surahId: 38,
    text: "وَءَاخَرِينَ مُقَرَّنِينَ فِي ٱلۡأَصۡفَادِ",
    translation: "And others bound together in shackles",
    normalizedText: "وءاخرين مقرنين في الاصفاد",
  },
  {
    verseId: 38,
    name: "ص",
    surahId: 38,
    text: "هَٰذَا عَطَآؤُنَا فَٱمۡنُنۡ أَوۡ أَمۡسِكۡ بِغَيۡرِ حِسَابٖ",
    translation:
      '[We said], "This is Our gift, so grant or withhold without account',
    normalizedText: "هذا عطاانا فامنن او امسك بغير حساب",
  },
  {
    verseId: 39,
    name: "ص",
    surahId: 38,
    text: "وَإِنَّ لَهُۥ عِندَنَا لَزُلۡفَىٰ وَحُسۡنَ مَـَٔابٖ",
    translation:
      "And indeed, for him is nearness to Us and a good place of return",
    normalizedText: "وان له عندنا لزلفى وحسن ماب",
  },
  {
    verseId: 40,
    name: "ص",
    surahId: 38,
    text: "وَٱذۡكُرۡ عَبۡدَنَآ أَيُّوبَ إِذۡ نَادَىٰ رَبَّهُۥٓ أَنِّي مَسَّنِيَ ٱلشَّيۡطَٰنُ بِنُصۡبٖ وَعَذَابٍ",
    translation:
      'And remember Our servant Job, when he called to his Lord, "Indeed, Satan has touched me with hardship and torment',
    normalizedText: "واذكر عبدنا ايوب اذ نادى ربه اني مسني الشيطن بنصب وعذاب",
  },
  {
    verseId: 41,
    name: "ص",
    surahId: 38,
    text: "ٱرۡكُضۡ بِرِجۡلِكَۖ هَٰذَا مُغۡتَسَلُۢ بَارِدٞ وَشَرَابٞ",
    translation:
      '[So he was told], "Strike [the ground] with your foot; this is a [spring for] a cool bath and drink',
    normalizedText: "اركض برجلك هذا مغتسل بارد وشراب",
  },
  {
    verseId: 42,
    name: "ص",
    surahId: 38,
    text: "وَوَهَبۡنَا لَهُۥٓ أَهۡلَهُۥ وَمِثۡلَهُم مَّعَهُمۡ رَحۡمَةٗ مِّنَّا وَذِكۡرَىٰ لِأُوْلِي ٱلۡأَلۡبَٰبِ",
    translation:
      "And We granted him his family and a like [number] with them as mercy from Us and a reminder for those of understanding",
    normalizedText: "ووهبنا له اهله ومثلهم معهم رحمة منا وذكرى لاولي الالبب",
  },
  {
    verseId: 43,
    name: "ص",
    surahId: 38,
    text: "وَخُذۡ بِيَدِكَ ضِغۡثٗا فَٱضۡرِب بِّهِۦ وَلَا تَحۡنَثۡۗ إِنَّا وَجَدۡنَٰهُ صَابِرٗاۚ نِّعۡمَ ٱلۡعَبۡدُ إِنَّهُۥٓ أَوَّابٞ",
    translation:
      '[We said], "And take in your hand a bunch [of grass] and strike with it and do not break your oath." Indeed, We found him patient, an excellent servant. Indeed, he was one repeatedly turning back [to Allah]',
    normalizedText:
      "وخذ بيدك ضغثا فاضرب به ولا تحنث انا وجدنه صابرا نعم العبد انه اواب",
  },
  {
    verseId: 44,
    name: "ص",
    surahId: 38,
    text: "وَٱذۡكُرۡ عِبَٰدَنَآ إِبۡرَٰهِيمَ وَإِسۡحَٰقَ وَيَعۡقُوبَ أُوْلِي ٱلۡأَيۡدِي وَٱلۡأَبۡصَٰرِ",
    translation:
      "And remember Our servants, Abraham, Isaac and Jacob - those of strength and [religious] vision",
    normalizedText: "واذكر عبدنا ابرهيم واسحق ويعقوب اولي الايدي والابصر",
  },
  {
    verseId: 45,
    name: "ص",
    surahId: 38,
    text: "إِنَّآ أَخۡلَصۡنَٰهُم بِخَالِصَةٖ ذِكۡرَى ٱلدَّارِ",
    translation:
      "Indeed, We chose them for an exclusive quality: remembrance of the home [of the Hereafter]",
    normalizedText: "انا اخلصنهم بخالصة ذكرى الدار",
  },
  {
    verseId: 46,
    name: "ص",
    surahId: 38,
    text: "وَإِنَّهُمۡ عِندَنَا لَمِنَ ٱلۡمُصۡطَفَيۡنَ ٱلۡأَخۡيَارِ",
    translation: "And indeed they are, to Us, among the chosen and outstanding",
    normalizedText: "وانهم عندنا لمن المصطفين الاخيار",
  },
  {
    verseId: 47,
    name: "ص",
    surahId: 38,
    text: "وَٱذۡكُرۡ إِسۡمَٰعِيلَ وَٱلۡيَسَعَ وَذَا ٱلۡكِفۡلِۖ وَكُلّٞ مِّنَ ٱلۡأَخۡيَارِ",
    translation:
      "And remember Ishmael, Elisha and Dhul-Kifl, and all are among the outstanding",
    normalizedText: "واذكر اسمعيل واليسع وذا الكفل وكل من الاخيار",
  },
  {
    verseId: 48,
    name: "ص",
    surahId: 38,
    text: "هَٰذَا ذِكۡرٞۚ وَإِنَّ لِلۡمُتَّقِينَ لَحُسۡنَ مَـَٔابٖ",
    translation:
      "This is a reminder. And indeed, for the righteous is a good place of return",
    normalizedText: "هذا ذكر وان للمتقين لحسن ماب",
  },
  {
    verseId: 49,
    name: "ص",
    surahId: 38,
    text: "جَنَّـٰتِ عَدۡنٖ مُّفَتَّحَةٗ لَّهُمُ ٱلۡأَبۡوَٰبُ",
    translation:
      "Gardens of perpetual residence, whose doors will be opened to them",
    normalizedText: "جنت عدن مفتحة لهم الابوب",
  },
  {
    verseId: 50,
    name: "ص",
    surahId: 38,
    text: "مُتَّكِـِٔينَ فِيهَا يَدۡعُونَ فِيهَا بِفَٰكِهَةٖ كَثِيرَةٖ وَشَرَابٖ",
    translation:
      "Reclining within them, they will call therein for abundant fruit and drink",
    normalizedText: "متكين فيها يدعون فيها بفكهة كثيرة وشراب",
  },
  {
    verseId: 51,
    name: "ص",
    surahId: 38,
    text: "۞وَعِندَهُمۡ قَٰصِرَٰتُ ٱلطَّرۡفِ أَتۡرَابٌ",
    translation:
      "And with them will be women limiting [their] glances and of equal age",
    normalizedText: "۞وعندهم قصرت الطرف اتراب",
  },
  {
    verseId: 52,
    name: "ص",
    surahId: 38,
    text: "هَٰذَا مَا تُوعَدُونَ لِيَوۡمِ ٱلۡحِسَابِ",
    translation:
      "This is what you, [the righteous], are promised for the Day of Account",
    normalizedText: "هذا ما توعدون ليوم الحساب",
  },
  {
    verseId: 53,
    name: "ص",
    surahId: 38,
    text: "إِنَّ هَٰذَا لَرِزۡقُنَا مَا لَهُۥ مِن نَّفَادٍ",
    translation: "Indeed, this is Our provision; for it there is no depletion",
    normalizedText: "ان هذا لرزقنا ما له من نفاد",
  },
  {
    verseId: 54,
    name: "ص",
    surahId: 38,
    text: "هَٰذَاۚ وَإِنَّ لِلطَّـٰغِينَ لَشَرَّ مَـَٔابٖ",
    translation:
      "This [is so]. But indeed, for the transgressors is an evil place of return",
    normalizedText: "هذا وان للطغين لشر ماب",
  },
  {
    verseId: 55,
    name: "ص",
    surahId: 38,
    text: "جَهَنَّمَ يَصۡلَوۡنَهَا فَبِئۡسَ ٱلۡمِهَادُ",
    translation:
      "Hell, which they will [enter to] burn, and wretched is the resting place",
    normalizedText: "جهنم يصلونها فباس المهاد",
  },
  {
    verseId: 56,
    name: "ص",
    surahId: 38,
    text: "هَٰذَا فَلۡيَذُوقُوهُ حَمِيمٞ وَغَسَّاقٞ",
    translation:
      "This - so let them taste it - is scalding water and [foul] purulence",
    normalizedText: "هذا فليذوقوه حميم وغساق",
  },
  {
    verseId: 57,
    name: "ص",
    surahId: 38,
    text: "وَءَاخَرُ مِن شَكۡلِهِۦٓ أَزۡوَٰجٌ",
    translation: "And other [punishments] of its type [in various] kinds",
    normalizedText: "وءاخر من شكله ازوج",
  },
  {
    verseId: 58,
    name: "ص",
    surahId: 38,
    text: "هَٰذَا فَوۡجٞ مُّقۡتَحِمٞ مَّعَكُمۡ لَا مَرۡحَبَۢا بِهِمۡۚ إِنَّهُمۡ صَالُواْ ٱلنَّارِ",
    translation:
      '[Its inhabitants will say], "This is a company bursting in with you. No welcome for them. Indeed, they will burn in the Fire',
    normalizedText: "هذا فوج مقتحم معكم لا مرحبا بهم انهم صالوا النار",
  },
  {
    verseId: 59,
    name: "ص",
    surahId: 38,
    text: "قَالُواْ بَلۡ أَنتُمۡ لَا مَرۡحَبَۢا بِكُمۡۖ أَنتُمۡ قَدَّمۡتُمُوهُ لَنَاۖ فَبِئۡسَ ٱلۡقَرَارُ",
    translation:
      'They will say, "Nor you! No welcome for you. You, [our leaders], brought this upon us, and wretched is the settlement',
    normalizedText: "قالوا بل انتم لا مرحبا بكم انتم قدمتموه لنا فباس القرار",
  },
  {
    verseId: 60,
    name: "ص",
    surahId: 38,
    text: "قَالُواْ رَبَّنَا مَن قَدَّمَ لَنَا هَٰذَا فَزِدۡهُ عَذَابٗا ضِعۡفٗا فِي ٱلنَّارِ",
    translation:
      'They will say, "Our Lord, whoever brought this upon us - increase for him double punishment in the Fire',
    normalizedText: "قالوا ربنا من قدم لنا هذا فزده عذابا ضعفا في النار",
  },
  {
    verseId: 61,
    name: "ص",
    surahId: 38,
    text: "وَقَالُواْ مَا لَنَا لَا نَرَىٰ رِجَالٗا كُنَّا نَعُدُّهُم مِّنَ ٱلۡأَشۡرَارِ",
    translation:
      'And they will say, "Why do we not see men whom we used to count among the worst',
    normalizedText: "وقالوا ما لنا لا نرى رجالا كنا نعدهم من الاشرار",
  },
  {
    verseId: 62,
    name: "ص",
    surahId: 38,
    text: "أَتَّخَذۡنَٰهُمۡ سِخۡرِيًّا أَمۡ زَاغَتۡ عَنۡهُمُ ٱلۡأَبۡصَٰرُ",
    translation:
      "Is it [because] we took them in ridicule, or has [our] vision turned away from them",
    normalizedText: "اتخذنهم سخريا ام زاغت عنهم الابصر",
  },
  {
    verseId: 63,
    name: "ص",
    surahId: 38,
    text: "إِنَّ ذَٰلِكَ لَحَقّٞ تَخَاصُمُ أَهۡلِ ٱلنَّارِ",
    translation:
      "Indeed, that is truth - the quarreling of the people of the Fire",
    normalizedText: "ان ذلك لحق تخاصم اهل النار",
  },
  {
    verseId: 64,
    name: "ص",
    surahId: 38,
    text: "قُلۡ إِنَّمَآ أَنَا۠ مُنذِرٞۖ وَمَا مِنۡ إِلَٰهٍ إِلَّا ٱللَّهُ ٱلۡوَٰحِدُ ٱلۡقَهَّارُ",
    translation:
      'Say, [O Muhammad], "I am only a warner, and there is not any deity except Allah, the One, the Prevailing',
    normalizedText: "قل انما انا منذر وما من اله الا الله الوحد القهار",
  },
  {
    verseId: 65,
    name: "ص",
    surahId: 38,
    text: "رَبُّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَا ٱلۡعَزِيزُ ٱلۡغَفَّـٰرُ",
    translation:
      "Lord of the heavens and the earth and whatever is between them, the Exalted in Might, the Perpetual Forgiver",
    normalizedText: "رب السموت والارض وما بينهما العزيز الغفر",
  },
  {
    verseId: 66,
    name: "ص",
    surahId: 38,
    text: "قُلۡ هُوَ نَبَؤٌاْ عَظِيمٌ",
    translation: 'Say, "It is great news',
    normalizedText: "قل هو نباا عظيم",
  },
  {
    verseId: 67,
    name: "ص",
    surahId: 38,
    text: "أَنتُمۡ عَنۡهُ مُعۡرِضُونَ",
    translation: "From which you turn away",
    normalizedText: "انتم عنه معرضون",
  },
  {
    verseId: 68,
    name: "ص",
    surahId: 38,
    text: "مَا كَانَ لِيَ مِنۡ عِلۡمِۭ بِٱلۡمَلَإِ ٱلۡأَعۡلَىٰٓ إِذۡ يَخۡتَصِمُونَ",
    translation:
      "I had no knowledge of the exalted assembly [of angels] when they were disputing [the creation of Adam]",
    normalizedText: "ما كان لي من علم بالملا الاعلى اذ يختصمون",
  },
  {
    verseId: 69,
    name: "ص",
    surahId: 38,
    text: "إِن يُوحَىٰٓ إِلَيَّ إِلَّآ أَنَّمَآ أَنَا۠ نَذِيرٞ مُّبِينٌ",
    translation:
      "It has not been revealed to me except that I am a clear warner",
    normalizedText: "ان يوحى الي الا انما انا نذير مبين",
  },
  {
    verseId: 70,
    name: "ص",
    surahId: 38,
    text: "إِذۡ قَالَ رَبُّكَ لِلۡمَلَـٰٓئِكَةِ إِنِّي خَٰلِقُۢ بَشَرٗا مِّن طِينٖ",
    translation:
      '[So mention] when your Lord said to the angels, "Indeed, I am going to create a human being from clay',
    normalizedText: "اذ قال ربك للملاكة اني خلق بشرا من طين",
  },
  {
    verseId: 71,
    name: "ص",
    surahId: 38,
    text: "فَإِذَا سَوَّيۡتُهُۥ وَنَفَخۡتُ فِيهِ مِن رُّوحِي فَقَعُواْ لَهُۥ سَٰجِدِينَ",
    translation:
      "So when I have proportioned him and breathed into him of My [created] soul, then fall down to him in prostration",
    normalizedText: "فاذا سويته ونفخت فيه من روحي فقعوا له سجدين",
  },
  {
    verseId: 72,
    name: "ص",
    surahId: 38,
    text: "فَسَجَدَ ٱلۡمَلَـٰٓئِكَةُ كُلُّهُمۡ أَجۡمَعُونَ",
    translation: "So the angels prostrated - all of them entirely",
    normalizedText: "فسجد الملاكة كلهم اجمعون",
  },
  {
    verseId: 73,
    name: "ص",
    surahId: 38,
    text: "إِلَّآ إِبۡلِيسَ ٱسۡتَكۡبَرَ وَكَانَ مِنَ ٱلۡكَٰفِرِينَ",
    translation:
      "Except Iblees; he was arrogant and became among the disbelievers",
    normalizedText: "الا ابليس استكبر وكان من الكفرين",
  },
  {
    verseId: 74,
    name: "ص",
    surahId: 38,
    text: "قَالَ يَـٰٓإِبۡلِيسُ مَا مَنَعَكَ أَن تَسۡجُدَ لِمَا خَلَقۡتُ بِيَدَيَّۖ أَسۡتَكۡبَرۡتَ أَمۡ كُنتَ مِنَ ٱلۡعَالِينَ",
    translation:
      '[Allah] said, "O Iblees, what prevented you from prostrating to that which I created with My hands? Were you arrogant [then], or were you [already] among the haughty',
    normalizedText:
      "قال يابليس ما منعك ان تسجد لما خلقت بيدي استكبرت ام كنت من العالين",
  },
  {
    verseId: 75,
    name: "ص",
    surahId: 38,
    text: "قَالَ أَنَا۠ خَيۡرٞ مِّنۡهُ خَلَقۡتَنِي مِن نَّارٖ وَخَلَقۡتَهُۥ مِن طِينٖ",
    translation:
      'He said, "I am better than him. You created me from fire and created him from clay',
    normalizedText: "قال انا خير منه خلقتني من نار وخلقته من طين",
  },
  {
    verseId: 76,
    name: "ص",
    surahId: 38,
    text: "قَالَ فَٱخۡرُجۡ مِنۡهَا فَإِنَّكَ رَجِيمٞ",
    translation:
      '[Allah] said, "Then get out of Paradise, for indeed, you are expelled',
    normalizedText: "قال فاخرج منها فانك رجيم",
  },
  {
    verseId: 77,
    name: "ص",
    surahId: 38,
    text: "وَإِنَّ عَلَيۡكَ لَعۡنَتِيٓ إِلَىٰ يَوۡمِ ٱلدِّينِ",
    translation: "And indeed, upon you is My curse until the Day of Recompense",
    normalizedText: "وان عليك لعنتي الى يوم الدين",
  },
  {
    verseId: 78,
    name: "ص",
    surahId: 38,
    text: "قَالَ رَبِّ فَأَنظِرۡنِيٓ إِلَىٰ يَوۡمِ يُبۡعَثُونَ",
    translation:
      'He said, "My Lord, then reprieve me until the Day they are resurrected',
    normalizedText: "قال رب فانظرني الى يوم يبعثون",
  },
  {
    verseId: 79,
    name: "ص",
    surahId: 38,
    text: "قَالَ فَإِنَّكَ مِنَ ٱلۡمُنظَرِينَ",
    translation: '[Allah] said, "So indeed, you are of those reprieved',
    normalizedText: "قال فانك من المنظرين",
  },
  {
    verseId: 80,
    name: "ص",
    surahId: 38,
    text: "إِلَىٰ يَوۡمِ ٱلۡوَقۡتِ ٱلۡمَعۡلُومِ",
    translation: "Until the Day of the time well-known",
    normalizedText: "الى يوم الوقت المعلوم",
  },
  {
    verseId: 81,
    name: "ص",
    surahId: 38,
    text: "قَالَ فَبِعِزَّتِكَ لَأُغۡوِيَنَّهُمۡ أَجۡمَعِينَ",
    translation:
      '[Iblees] said, "By your might, I will surely mislead them all',
    normalizedText: "قال فبعزتك لاغوينهم اجمعين",
  },
  {
    verseId: 82,
    name: "ص",
    surahId: 38,
    text: "إِلَّا عِبَادَكَ مِنۡهُمُ ٱلۡمُخۡلَصِينَ",
    translation: "Except, among them, Your chosen servants",
    normalizedText: "الا عبادك منهم المخلصين",
  },
  {
    verseId: 83,
    name: "ص",
    surahId: 38,
    text: "قَالَ فَٱلۡحَقُّ وَٱلۡحَقَّ أَقُولُ",
    translation: '[Allah] said, "The truth [is My oath], and the truth I say',
    normalizedText: "قال فالحق والحق اقول",
  },
  {
    verseId: 84,
    name: "ص",
    surahId: 38,
    text: "لَأَمۡلَأَنَّ جَهَنَّمَ مِنكَ وَمِمَّن تَبِعَكَ مِنۡهُمۡ أَجۡمَعِينَ",
    translation:
      "[That] I will surely fill Hell with you and those of them that follow you all together",
    normalizedText: "لاملان جهنم منك وممن تبعك منهم اجمعين",
  },
  {
    verseId: 85,
    name: "ص",
    surahId: 38,
    text: "قُلۡ مَآ أَسۡـَٔلُكُمۡ عَلَيۡهِ مِنۡ أَجۡرٖ وَمَآ أَنَا۠ مِنَ ٱلۡمُتَكَلِّفِينَ",
    translation: `Say, [O Muhammad], "I do not ask you for the Qur'an any payment, and I am not of the pretentious`,
    normalizedText: "قل ما اسلكم عليه من اجر وما انا من المتكلفين",
  },
  {
    verseId: 86,
    name: "ص",
    surahId: 38,
    text: "إِنۡ هُوَ إِلَّا ذِكۡرٞ لِّلۡعَٰلَمِينَ",
    translation: "It is but a reminder to the worlds",
    normalizedText: "ان هو الا ذكر للعلمين",
  },
  {
    verseId: 87,
    name: "ص",
    surahId: 38,
    text: "وَلَتَعۡلَمُنَّ نَبَأَهُۥ بَعۡدَ حِينِۭ",
    translation:
      "And you will surely know [the truth of] its information after a time",
    normalizedText: "ولتعلمن نباه بعد حين",
  },
  {
    verseId: 0,
    name: "الزمر",
    surahId: 39,
    text: "تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ",
    translation:
      "The revelation of the Qur'an is from Allah, the Exalted in Might, the Wise",
    normalizedText: "تنزيل الكتب من الله العزيز الحكيم",
  },
  {
    verseId: 1,
    name: "الزمر",
    surahId: 39,
    text: "إِنَّآ أَنزَلۡنَآ إِلَيۡكَ ٱلۡكِتَٰبَ بِٱلۡحَقِّ فَٱعۡبُدِ ٱللَّهَ مُخۡلِصٗا لَّهُ ٱلدِّينَ",
    translation:
      "Indeed, We have sent down to you the Book, [O Muhammad], in truth. So worship Allah, [being] sincere to Him in religion",
    normalizedText: "انا انزلنا اليك الكتب بالحق فاعبد الله مخلصا له الدين",
  },
  {
    verseId: 2,
    name: "الزمر",
    surahId: 39,
    text: "أَلَا لِلَّهِ ٱلدِّينُ ٱلۡخَالِصُۚ وَٱلَّذِينَ ٱتَّخَذُواْ مِن دُونِهِۦٓ أَوۡلِيَآءَ مَا نَعۡبُدُهُمۡ إِلَّا لِيُقَرِّبُونَآ إِلَى ٱللَّهِ زُلۡفَىٰٓ إِنَّ ٱللَّهَ يَحۡكُمُ بَيۡنَهُمۡ فِي مَا هُمۡ فِيهِ يَخۡتَلِفُونَۗ إِنَّ ٱللَّهَ لَا يَهۡدِي مَنۡ هُوَ كَٰذِبٞ كَفَّارٞ",
    translation:
      'Unquestionably, for Allah is the pure religion. And those who take protectors besides Him [say], "We only worship them that they may bring us nearer to Allah in position." Indeed, Allah will judge between them concerning that over which they differ. Indeed, Allah does not guide he who is a liar and [confirmed] disbeliever',
    normalizedText:
      "الا لله الدين الخالص والذين اتخذوا من دونه اولياء ما نعبدهم الا ليقربونا الى الله زلفى ان الله يحكم بينهم في ما هم فيه يختلفون ان الله لا يهدي من هو كذب كفار",
  },
  {
    verseId: 3,
    name: "الزمر",
    surahId: 39,
    text: "لَّوۡ أَرَادَ ٱللَّهُ أَن يَتَّخِذَ وَلَدٗا لَّٱصۡطَفَىٰ مِمَّا يَخۡلُقُ مَا يَشَآءُۚ سُبۡحَٰنَهُۥۖ هُوَ ٱللَّهُ ٱلۡوَٰحِدُ ٱلۡقَهَّارُ",
    translation:
      "If Allah had intended to take a son, He could have chosen from what He creates whatever He willed. Exalted is He; He is Allah, the One, the Prevailing",
    normalizedText:
      "لو اراد الله ان يتخذ ولدا لاصطفى مما يخلق ما يشاء سبحنه هو الله الوحد القهار",
  },
  {
    verseId: 4,
    name: "الزمر",
    surahId: 39,
    text: "خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِٱلۡحَقِّۖ يُكَوِّرُ ٱلَّيۡلَ عَلَى ٱلنَّهَارِ وَيُكَوِّرُ ٱلنَّهَارَ عَلَى ٱلَّيۡلِۖ وَسَخَّرَ ٱلشَّمۡسَ وَٱلۡقَمَرَۖ كُلّٞ يَجۡرِي لِأَجَلٖ مُّسَمًّىۗ أَلَا هُوَ ٱلۡعَزِيزُ ٱلۡغَفَّـٰرُ",
    translation:
      "He created the heavens and earth in truth. He wraps the night over the day and wraps the day over the night and has subjected the sun and the moon, each running [its course] for a specified term. Unquestionably, He is the Exalted in Might, the Perpetual Forgiver",
    normalizedText:
      "خلق السموت والارض بالحق يكور اليل على النهار ويكور النهار على اليل وسخر الشمس والقمر كل يجري لاجل مسمى الا هو العزيز الغفر",
  },
  {
    verseId: 5,
    name: "الزمر",
    surahId: 39,
    text: "خَلَقَكُم مِّن نَّفۡسٖ وَٰحِدَةٖ ثُمَّ جَعَلَ مِنۡهَا زَوۡجَهَا وَأَنزَلَ لَكُم مِّنَ ٱلۡأَنۡعَٰمِ ثَمَٰنِيَةَ أَزۡوَٰجٖۚ يَخۡلُقُكُمۡ فِي بُطُونِ أُمَّهَٰتِكُمۡ خَلۡقٗا مِّنۢ بَعۡدِ خَلۡقٖ فِي ظُلُمَٰتٖ ثَلَٰثٖۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمۡ لَهُ ٱلۡمُلۡكُۖ لَآ إِلَٰهَ إِلَّا هُوَۖ فَأَنَّىٰ تُصۡرَفُونَ",
    translation:
      "He created you from one soul. Then He made from it its mate, and He produced for you from the grazing livestock eight mates. He creates you in the wombs of your mothers, creation after creation, within three darknesses. That is Allah, your Lord; to Him belongs dominion. There is no deity except Him, so how are you averted",
    normalizedText:
      "خلقكم من نفس وحدة ثم جعل منها زوجها وانزل لكم من الانعم ثمنية ازوج يخلقكم في بطون امهتكم خلقا من بعد خلق في ظلمت ثلث ذلكم الله ربكم له الملك لا اله الا هو فانى تصرفون",
  },
  {
    verseId: 6,
    name: "الزمر",
    surahId: 39,
    text: "إِن تَكۡفُرُواْ فَإِنَّ ٱللَّهَ غَنِيٌّ عَنكُمۡۖ وَلَا يَرۡضَىٰ لِعِبَادِهِ ٱلۡكُفۡرَۖ وَإِن تَشۡكُرُواْ يَرۡضَهُ لَكُمۡۗ وَلَا تَزِرُ وَازِرَةٞ وِزۡرَ أُخۡرَىٰۚ ثُمَّ إِلَىٰ رَبِّكُم مَّرۡجِعُكُمۡ فَيُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَۚ إِنَّهُۥ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "If you disbelieve - indeed, Allah is Free from need of you. And He does not approve for His servants disbelief. And if you are grateful, He approves it for you; and no bearer of burdens will bear the burden of another. Then to your Lord is your return, and He will inform you about what you used to do. Indeed, He is Knowing of that within the breasts",
    normalizedText:
      "ان تكفروا فان الله غني عنكم ولا يرضى لعباده الكفر وان تشكروا يرضه لكم ولا تزر وازرة وزر اخرى ثم الى ربكم مرجعكم فينباكم بما كنتم تعملون انه عليم بذات الصدور",
  },
  {
    verseId: 7,
    name: "الزمر",
    surahId: 39,
    text: "۞وَإِذَا مَسَّ ٱلۡإِنسَٰنَ ضُرّٞ دَعَا رَبَّهُۥ مُنِيبًا إِلَيۡهِ ثُمَّ إِذَا خَوَّلَهُۥ نِعۡمَةٗ مِّنۡهُ نَسِيَ مَا كَانَ يَدۡعُوٓاْ إِلَيۡهِ مِن قَبۡلُ وَجَعَلَ لِلَّهِ أَندَادٗا لِّيُضِلَّ عَن سَبِيلِهِۦۚ قُلۡ تَمَتَّعۡ بِكُفۡرِكَ قَلِيلًا إِنَّكَ مِنۡ أَصۡحَٰبِ ٱلنَّارِ",
    translation:
      'And when adversity touches man, he calls upon his Lord, turning to Him [alone]; then when He bestows on him a favor from Himself, he forgets Him whom he called upon before, and he attributes to Allah equals to mislead [people] from His way. Say, "Enjoy your disbelief for a little; indeed, you are of the companions of the Fire',
    normalizedText:
      "۞واذا مس الانسن ضر دعا ربه منيبا اليه ثم اذا خوله نعمة منه نسي ما كان يدعوا اليه من قبل وجعل لله اندادا ليضل عن سبيله قل تمتع بكفرك قليلا انك من اصحب النار",
  },
  {
    verseId: 8,
    name: "الزمر",
    surahId: 39,
    text: "أَمَّنۡ هُوَ قَٰنِتٌ ءَانَآءَ ٱلَّيۡلِ سَاجِدٗا وَقَآئِمٗا يَحۡذَرُ ٱلۡأٓخِرَةَ وَيَرۡجُواْ رَحۡمَةَ رَبِّهِۦۗ قُلۡ هَلۡ يَسۡتَوِي ٱلَّذِينَ يَعۡلَمُونَ وَٱلَّذِينَ لَا يَعۡلَمُونَۗ إِنَّمَا يَتَذَكَّرُ أُوْلُواْ ٱلۡأَلۡبَٰبِ",
    translation:
      'Is one who is devoutly obedient during periods of the night, prostrating and standing [in prayer], fearing the Hereafter and hoping for the mercy of his Lord, [like one who does not]? Say, "Are those who know equal to those who do not know?" Only they will remember [who are] people of understanding',
    normalizedText:
      "امن هو قنت ءاناء اليل ساجدا وقااما يحذر الاخرة ويرجوا رحمة ربه قل هل يستوي الذين يعلمون والذين لا يعلمون انما يتذكر اولوا الالبب",
  },
  {
    verseId: 9,
    name: "الزمر",
    surahId: 39,
    text: "قُلۡ يَٰعِبَادِ ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ رَبَّكُمۡۚ لِلَّذِينَ أَحۡسَنُواْ فِي هَٰذِهِ ٱلدُّنۡيَا حَسَنَةٞۗ وَأَرۡضُ ٱللَّهِ وَٰسِعَةٌۗ إِنَّمَا يُوَفَّى ٱلصَّـٰبِرُونَ أَجۡرَهُم بِغَيۡرِ حِسَابٖ",
    translation:
      'Say, "O My servants who have believed, fear your Lord. For those who do good in this world is good, and the earth of Allah is spacious. Indeed, the patient will be given their reward without account',
    normalizedText:
      "قل يعباد الذين ءامنوا اتقوا ربكم للذين احسنوا في هذه الدنيا حسنة وارض الله وسعة انما يوفى الصبرون اجرهم بغير حساب",
  },
  {
    verseId: 10,
    name: "الزمر",
    surahId: 39,
    text: "قُلۡ إِنِّيٓ أُمِرۡتُ أَنۡ أَعۡبُدَ ٱللَّهَ مُخۡلِصٗا لَّهُ ٱلدِّينَ",
    translation:
      'Say, [O Muhammad], "Indeed, I have been commanded to worship Allah, [being] sincere to Him in religion',
    normalizedText: "قل اني امرت ان اعبد الله مخلصا له الدين",
  },
  {
    verseId: 11,
    name: "الزمر",
    surahId: 39,
    text: "وَأُمِرۡتُ لِأَنۡ أَكُونَ أَوَّلَ ٱلۡمُسۡلِمِينَ",
    translation:
      "And I have been commanded to be the first [among you] of the Muslims",
    normalizedText: "وامرت لان اكون اول المسلمين",
  },
  {
    verseId: 12,
    name: "الزمر",
    surahId: 39,
    text: "قُلۡ إِنِّيٓ أَخَافُ إِنۡ عَصَيۡتُ رَبِّي عَذَابَ يَوۡمٍ عَظِيمٖ",
    translation:
      'Say, "Indeed I fear, if I should disobey my Lord, the punishment of a tremendous Day',
    normalizedText: "قل اني اخاف ان عصيت ربي عذاب يوم عظيم",
  },
  {
    verseId: 13,
    name: "الزمر",
    surahId: 39,
    text: "قُلِ ٱللَّهَ أَعۡبُدُ مُخۡلِصٗا لَّهُۥ دِينِي",
    translation:
      'Say, "Allah [alone] do I worship, sincere to Him in my religion',
    normalizedText: "قل الله اعبد مخلصا له ديني",
  },
  {
    verseId: 14,
    name: "الزمر",
    surahId: 39,
    text: "فَٱعۡبُدُواْ مَا شِئۡتُم مِّن دُونِهِۦۗ قُلۡ إِنَّ ٱلۡخَٰسِرِينَ ٱلَّذِينَ خَسِرُوٓاْ أَنفُسَهُمۡ وَأَهۡلِيهِمۡ يَوۡمَ ٱلۡقِيَٰمَةِۗ أَلَا ذَٰلِكَ هُوَ ٱلۡخُسۡرَانُ ٱلۡمُبِينُ",
    translation:
      'So worship what you will besides Him." Say, "Indeed, the losers are the ones who will lose themselves and their families on the Day of Resurrection. Unquestionably, that is the manifest loss',
    normalizedText:
      "فاعبدوا ما شاتم من دونه قل ان الخسرين الذين خسروا انفسهم واهليهم يوم القيمة الا ذلك هو الخسران المبين",
  },
  {
    verseId: 15,
    name: "الزمر",
    surahId: 39,
    text: "لَهُم مِّن فَوۡقِهِمۡ ظُلَلٞ مِّنَ ٱلنَّارِ وَمِن تَحۡتِهِمۡ ظُلَلٞۚ ذَٰلِكَ يُخَوِّفُ ٱللَّهُ بِهِۦ عِبَادَهُۥۚ يَٰعِبَادِ فَٱتَّقُونِ",
    translation:
      "They will have canopies of fire above them and below them, canopies. By that Allah threatens His servants. O My servants, then fear Me",
    normalizedText:
      "لهم من فوقهم ظلل من النار ومن تحتهم ظلل ذلك يخوف الله به عباده يعباد فاتقون",
  },
  {
    verseId: 16,
    name: "الزمر",
    surahId: 39,
    text: "وَٱلَّذِينَ ٱجۡتَنَبُواْ ٱلطَّـٰغُوتَ أَن يَعۡبُدُوهَا وَأَنَابُوٓاْ إِلَى ٱللَّهِ لَهُمُ ٱلۡبُشۡرَىٰۚ فَبَشِّرۡ عِبَادِ",
    translation:
      "But those who have avoided Taghut, lest they worship it, and turned back to Allah - for them are good tidings. So give good tidings to My servants",
    normalizedText:
      "والذين اجتنبوا الطغوت ان يعبدوها وانابوا الى الله لهم البشرى فبشر عباد",
  },
  {
    verseId: 17,
    name: "الزمر",
    surahId: 39,
    text: "ٱلَّذِينَ يَسۡتَمِعُونَ ٱلۡقَوۡلَ فَيَتَّبِعُونَ أَحۡسَنَهُۥٓۚ أُوْلَـٰٓئِكَ ٱلَّذِينَ هَدَىٰهُمُ ٱللَّهُۖ وَأُوْلَـٰٓئِكَ هُمۡ أُوْلُواْ ٱلۡأَلۡبَٰبِ",
    translation:
      "Who listen to speech and follow the best of it. Those are the ones Allah has guided, and those are people of understanding",
    normalizedText:
      "الذين يستمعون القول فيتبعون احسنه اولاك الذين هدىهم الله واولاك هم اولوا الالبب",
  },
  {
    verseId: 18,
    name: "الزمر",
    surahId: 39,
    text: "أَفَمَنۡ حَقَّ عَلَيۡهِ كَلِمَةُ ٱلۡعَذَابِ أَفَأَنتَ تُنقِذُ مَن فِي ٱلنَّارِ",
    translation:
      "Then, is one who has deserved the decree of punishment [to be guided]? Then, can you save one who is in the Fire",
    normalizedText: "افمن حق عليه كلمة العذاب افانت تنقذ من في النار",
  },
  {
    verseId: 19,
    name: "الزمر",
    surahId: 39,
    text: "لَٰكِنِ ٱلَّذِينَ ٱتَّقَوۡاْ رَبَّهُمۡ لَهُمۡ غُرَفٞ مِّن فَوۡقِهَا غُرَفٞ مَّبۡنِيَّةٞ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۖ وَعۡدَ ٱللَّهِ لَا يُخۡلِفُ ٱللَّهُ ٱلۡمِيعَادَ",
    translation:
      "But those who have feared their Lord - for them are chambers, above them chambers built high, beneath which rivers flow. [This is] the promise of Allah. Allah does not fail in [His] promise",
    normalizedText:
      "لكن الذين اتقوا ربهم لهم غرف من فوقها غرف مبنية تجري من تحتها الانهر وعد الله لا يخلف الله الميعاد",
  },
  {
    verseId: 20,
    name: "الزمر",
    surahId: 39,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءٗ فَسَلَكَهُۥ يَنَٰبِيعَ فِي ٱلۡأَرۡضِ ثُمَّ يُخۡرِجُ بِهِۦ زَرۡعٗا مُّخۡتَلِفًا أَلۡوَٰنُهُۥ ثُمَّ يَهِيجُ فَتَرَىٰهُ مُصۡفَرّٗا ثُمَّ يَجۡعَلُهُۥ حُطَٰمًاۚ إِنَّ فِي ذَٰلِكَ لَذِكۡرَىٰ لِأُوْلِي ٱلۡأَلۡبَٰبِ",
    translation:
      "Do you not see that Allah sends down rain from the sky and makes it flow as springs [and rivers] in the earth; then He produces thereby crops of varying colors; then they dry and you see them turned yellow; then He makes them [scattered] debris. Indeed in that is a reminder for those of understanding",
    normalizedText:
      "الم تر ان الله انزل من السماء ماء فسلكه ينبيع في الارض ثم يخرج به زرعا مختلفا الونه ثم يهيج فترىه مصفرا ثم يجعله حطما ان في ذلك لذكرى لاولي الالبب",
  },
  {
    verseId: 21,
    name: "الزمر",
    surahId: 39,
    text: "أَفَمَن شَرَحَ ٱللَّهُ صَدۡرَهُۥ لِلۡإِسۡلَٰمِ فَهُوَ عَلَىٰ نُورٖ مِّن رَّبِّهِۦۚ فَوَيۡلٞ لِّلۡقَٰسِيَةِ قُلُوبُهُم مِّن ذِكۡرِ ٱللَّهِۚ أُوْلَـٰٓئِكَ فِي ضَلَٰلٖ مُّبِينٍ",
    translation:
      "So is one whose breast Allah has expanded to [accept] Islam and he is upon a light from his Lord [like one whose heart rejects it]? Then woe to those whose hearts are hardened against the remembrance of Allah. Those are in manifest error",
    normalizedText:
      "افمن شرح الله صدره للاسلم فهو على نور من ربه فويل للقسية قلوبهم من ذكر الله اولاك في ضلل مبين",
  },
  {
    verseId: 22,
    name: "الزمر",
    surahId: 39,
    text: "ٱللَّهُ نَزَّلَ أَحۡسَنَ ٱلۡحَدِيثِ كِتَٰبٗا مُّتَشَٰبِهٗا مَّثَانِيَ تَقۡشَعِرُّ مِنۡهُ جُلُودُ ٱلَّذِينَ يَخۡشَوۡنَ رَبَّهُمۡ ثُمَّ تَلِينُ جُلُودُهُمۡ وَقُلُوبُهُمۡ إِلَىٰ ذِكۡرِ ٱللَّهِۚ ذَٰلِكَ هُدَى ٱللَّهِ يَهۡدِي بِهِۦ مَن يَشَآءُۚ وَمَن يُضۡلِلِ ٱللَّهُ فَمَا لَهُۥ مِنۡ هَادٍ",
    translation:
      "Allah has sent down the best statement: a consistent Book wherein is reiteration. The skins shiver therefrom of those who fear their Lord; then their skins and their hearts relax at the remembrance of Allah. That is the guidance of Allah by which He guides whom He wills. And one whom Allah leaves astray - for him there is no guide",
    normalizedText:
      "الله نزل احسن الحديث كتبا متشبها مثاني تقشعر منه جلود الذين يخشون ربهم ثم تلين جلودهم وقلوبهم الى ذكر الله ذلك هدى الله يهدي به من يشاء ومن يضلل الله فما له من هاد",
  },
  {
    verseId: 23,
    name: "الزمر",
    surahId: 39,
    text: "أَفَمَن يَتَّقِي بِوَجۡهِهِۦ سُوٓءَ ٱلۡعَذَابِ يَوۡمَ ٱلۡقِيَٰمَةِۚ وَقِيلَ لِلظَّـٰلِمِينَ ذُوقُواْ مَا كُنتُمۡ تَكۡسِبُونَ",
    translation:
      'Then is he who will shield with his face the worst of the punishment on the Day of Resurrection [like one secure from it]? And it will be said to the wrongdoers, "Taste what you used to earn',
    normalizedText:
      "افمن يتقي بوجهه سوء العذاب يوم القيمة وقيل للظلمين ذوقوا ما كنتم تكسبون",
  },
  {
    verseId: 24,
    name: "الزمر",
    surahId: 39,
    text: "كَذَّبَ ٱلَّذِينَ مِن قَبۡلِهِمۡ فَأَتَىٰهُمُ ٱلۡعَذَابُ مِنۡ حَيۡثُ لَا يَشۡعُرُونَ",
    translation:
      "Those before them denied, and punishment came upon them from where they did not perceive",
    normalizedText: "كذب الذين من قبلهم فاتىهم العذاب من حيث لا يشعرون",
  },
  {
    verseId: 25,
    name: "الزمر",
    surahId: 39,
    text: "فَأَذَاقَهُمُ ٱللَّهُ ٱلۡخِزۡيَ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَلَعَذَابُ ٱلۡأٓخِرَةِ أَكۡبَرُۚ لَوۡ كَانُواْ يَعۡلَمُونَ",
    translation:
      "So Allah made them taste disgrace in worldly life. But the punishment of the Hereafter is greater, if they only knew",
    normalizedText:
      "فاذاقهم الله الخزي في الحيوة الدنيا ولعذاب الاخرة اكبر لو كانوا يعلمون",
  },
  {
    verseId: 26,
    name: "الزمر",
    surahId: 39,
    text: "وَلَقَدۡ ضَرَبۡنَا لِلنَّاسِ فِي هَٰذَا ٱلۡقُرۡءَانِ مِن كُلِّ مَثَلٖ لَّعَلَّهُمۡ يَتَذَكَّرُونَ",
    translation:
      "And We have certainly presented for the people in this Qur'an from every [kind of] example - that they might remember",
    normalizedText: "ولقد ضربنا للناس في هذا القرءان من كل مثل لعلهم يتذكرون",
  },
  {
    verseId: 27,
    name: "الزمر",
    surahId: 39,
    text: "قُرۡءَانًا عَرَبِيًّا غَيۡرَ ذِي عِوَجٖ لَّعَلَّهُمۡ يَتَّقُونَ",
    translation:
      "[It is] an Arabic Qur'an, without any deviance that they might become righteous",
    normalizedText: "قرءانا عربيا غير ذي عوج لعلهم يتقون",
  },
  {
    verseId: 28,
    name: "الزمر",
    surahId: 39,
    text: "ضَرَبَ ٱللَّهُ مَثَلٗا رَّجُلٗا فِيهِ شُرَكَآءُ مُتَشَٰكِسُونَ وَرَجُلٗا سَلَمٗا لِّرَجُلٍ هَلۡ يَسۡتَوِيَانِ مَثَلًاۚ ٱلۡحَمۡدُ لِلَّهِۚ بَلۡ أَكۡثَرُهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "Allah presents an example: a slave owned by quarreling partners and another belonging exclusively to one man - are they equal in comparison? Praise be to Allah! But most of them do not know",
    normalizedText:
      "ضرب الله مثلا رجلا فيه شركاء متشكسون ورجلا سلما لرجل هل يستويان مثلا الحمد لله بل اكثرهم لا يعلمون",
  },
  {
    verseId: 29,
    name: "الزمر",
    surahId: 39,
    text: "إِنَّكَ مَيِّتٞ وَإِنَّهُم مَّيِّتُونَ",
    translation: "Indeed, you are to die, and indeed, they are to die",
    normalizedText: "انك ميت وانهم ميتون",
  },
  {
    verseId: 30,
    name: "الزمر",
    surahId: 39,
    text: "ثُمَّ إِنَّكُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ عِندَ رَبِّكُمۡ تَخۡتَصِمُونَ",
    translation:
      "Then indeed you, on the Day of Resurrection, before your Lord, will dispute",
    normalizedText: "ثم انكم يوم القيمة عند ربكم تختصمون",
  },
  {
    verseId: 31,
    name: "الزمر",
    surahId: 39,
    text: "۞فَمَنۡ أَظۡلَمُ مِمَّن كَذَبَ عَلَى ٱللَّهِ وَكَذَّبَ بِٱلصِّدۡقِ إِذۡ جَآءَهُۥٓۚ أَلَيۡسَ فِي جَهَنَّمَ مَثۡوٗى لِّلۡكَٰفِرِينَ",
    translation:
      "So who is more unjust than one who lies about Allah and denies the truth when it has come to him? Is there not in Hell a residence for the disbelievers",
    normalizedText:
      "۞فمن اظلم ممن كذب على الله وكذب بالصدق اذ جاءه اليس في جهنم مثوى للكفرين",
  },
  {
    verseId: 32,
    name: "الزمر",
    surahId: 39,
    text: "وَٱلَّذِي جَآءَ بِٱلصِّدۡقِ وَصَدَّقَ بِهِۦٓ أُوْلَـٰٓئِكَ هُمُ ٱلۡمُتَّقُونَ",
    translation:
      "And the one who has brought the truth and [they who] believed in it - those are the righteous",
    normalizedText: "والذي جاء بالصدق وصدق به اولاك هم المتقون",
  },
  {
    verseId: 33,
    name: "الزمر",
    surahId: 39,
    text: "لَهُم مَّا يَشَآءُونَ عِندَ رَبِّهِمۡۚ ذَٰلِكَ جَزَآءُ ٱلۡمُحۡسِنِينَ",
    translation:
      "They will have whatever they desire with their Lord. That is the reward of the doers of good",
    normalizedText: "لهم ما يشاءون عند ربهم ذلك جزاء المحسنين",
  },
  {
    verseId: 34,
    name: "الزمر",
    surahId: 39,
    text: "لِيُكَفِّرَ ٱللَّهُ عَنۡهُمۡ أَسۡوَأَ ٱلَّذِي عَمِلُواْ وَيَجۡزِيَهُمۡ أَجۡرَهُم بِأَحۡسَنِ ٱلَّذِي كَانُواْ يَعۡمَلُونَ",
    translation:
      "That Allah may remove from them the worst of what they did and reward them their due for the best of what they used to do",
    normalizedText:
      "ليكفر الله عنهم اسوا الذي عملوا ويجزيهم اجرهم باحسن الذي كانوا يعملون",
  },
  {
    verseId: 35,
    name: "الزمر",
    surahId: 39,
    text: "أَلَيۡسَ ٱللَّهُ بِكَافٍ عَبۡدَهُۥۖ وَيُخَوِّفُونَكَ بِٱلَّذِينَ مِن دُونِهِۦۚ وَمَن يُضۡلِلِ ٱللَّهُ فَمَا لَهُۥ مِنۡ هَادٖ",
    translation:
      "Is not Allah sufficient for His Servant [Prophet Muhammad]? And [yet], they threaten you with those [they worship] other than Him. And whoever Allah leaves astray - for him there is no guide",
    normalizedText:
      "اليس الله بكاف عبده ويخوفونك بالذين من دونه ومن يضلل الله فما له من هاد",
  },
  {
    verseId: 36,
    name: "الزمر",
    surahId: 39,
    text: "وَمَن يَهۡدِ ٱللَّهُ فَمَا لَهُۥ مِن مُّضِلٍّۗ أَلَيۡسَ ٱللَّهُ بِعَزِيزٖ ذِي ٱنتِقَامٖ",
    translation:
      "And whoever Allah guides - for him there is no misleader. Is not Allah Exalted in Might and Owner of Retribution",
    normalizedText: "ومن يهد الله فما له من مضل اليس الله بعزيز ذي انتقام",
  },
  {
    verseId: 37,
    name: "الزمر",
    surahId: 39,
    text: "وَلَئِن سَأَلۡتَهُم مَّنۡ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ لَيَقُولُنَّ ٱللَّهُۚ قُلۡ أَفَرَءَيۡتُم مَّا تَدۡعُونَ مِن دُونِ ٱللَّهِ إِنۡ أَرَادَنِيَ ٱللَّهُ بِضُرٍّ هَلۡ هُنَّ كَٰشِفَٰتُ ضُرِّهِۦٓ أَوۡ أَرَادَنِي بِرَحۡمَةٍ هَلۡ هُنَّ مُمۡسِكَٰتُ رَحۡمَتِهِۦۚ قُلۡ حَسۡبِيَ ٱللَّهُۖ عَلَيۡهِ يَتَوَكَّلُ ٱلۡمُتَوَكِّلُونَ",
    translation:
      'And if you asked them, "Who created the heavens and the earth?" they would surely say, "Allah." Say, "Then have you considered what you invoke besides Allah? If Allah intended me harm, are they removers of His harm; or if He intended me mercy, are they withholders of His mercy?" Say, "Sufficient for me is Allah; upon Him [alone] rely the [wise] reliers',
    normalizedText:
      "ولان سالتهم من خلق السموت والارض ليقولن الله قل افرءيتم ما تدعون من دون الله ان ارادني الله بضر هل هن كشفت ضره او ارادني برحمة هل هن ممسكت رحمته قل حسبي الله عليه يتوكل المتوكلون",
  },
  {
    verseId: 38,
    name: "الزمر",
    surahId: 39,
    text: "قُلۡ يَٰقَوۡمِ ٱعۡمَلُواْ عَلَىٰ مَكَانَتِكُمۡ إِنِّي عَٰمِلٞۖ فَسَوۡفَ تَعۡلَمُونَ",
    translation:
      'Say, "O my people, work according to your position, [for] indeed, I am working; and you are going to know',
    normalizedText: "قل يقوم اعملوا على مكانتكم اني عمل فسوف تعلمون",
  },
  {
    verseId: 39,
    name: "الزمر",
    surahId: 39,
    text: "مَن يَأۡتِيهِ عَذَابٞ يُخۡزِيهِ وَيَحِلُّ عَلَيۡهِ عَذَابٞ مُّقِيمٌ",
    translation:
      "To whom will come a torment disgracing him and on whom will descend an enduring punishment",
    normalizedText: "من ياتيه عذاب يخزيه ويحل عليه عذاب مقيم",
  },
  {
    verseId: 40,
    name: "الزمر",
    surahId: 39,
    text: "إِنَّآ أَنزَلۡنَا عَلَيۡكَ ٱلۡكِتَٰبَ لِلنَّاسِ بِٱلۡحَقِّۖ فَمَنِ ٱهۡتَدَىٰ فَلِنَفۡسِهِۦۖ وَمَن ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيۡهَاۖ وَمَآ أَنتَ عَلَيۡهِم بِوَكِيلٍ",
    translation:
      "Indeed, We sent down to you the Book for the people in truth. So whoever is guided - it is for [the benefit of] his soul; and whoever goes astray only goes astray to its detriment. And you are not a manager over them",
    normalizedText:
      "انا انزلنا عليك الكتب للناس بالحق فمن اهتدى فلنفسه ومن ضل فانما يضل عليها وما انت عليهم بوكيل",
  },
  {
    verseId: 41,
    name: "الزمر",
    surahId: 39,
    text: "ٱللَّهُ يَتَوَفَّى ٱلۡأَنفُسَ حِينَ مَوۡتِهَا وَٱلَّتِي لَمۡ تَمُتۡ فِي مَنَامِهَاۖ فَيُمۡسِكُ ٱلَّتِي قَضَىٰ عَلَيۡهَا ٱلۡمَوۡتَ وَيُرۡسِلُ ٱلۡأُخۡرَىٰٓ إِلَىٰٓ أَجَلٖ مُّسَمًّىۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَتَفَكَّرُونَ",
    translation:
      "Allah takes the souls at the time of their death, and those that do not die [He takes] during their sleep. Then He keeps those for which He has decreed death and releases the others for a specified term. Indeed in that are signs for a people who give thought",
    normalizedText:
      "الله يتوفى الانفس حين موتها والتي لم تمت في منامها فيمسك التي قضى عليها الموت ويرسل الاخرى الى اجل مسمى ان في ذلك لايت لقوم يتفكرون",
  },
  {
    verseId: 42,
    name: "الزمر",
    surahId: 39,
    text: "أَمِ ٱتَّخَذُواْ مِن دُونِ ٱللَّهِ شُفَعَآءَۚ قُلۡ أَوَلَوۡ كَانُواْ لَا يَمۡلِكُونَ شَيۡـٔٗا وَلَا يَعۡقِلُونَ",
    translation:
      'Or have they taken other than Allah as intercessors? Say, "Even though they do not possess [power over] anything, nor do they reason',
    normalizedText:
      "ام اتخذوا من دون الله شفعاء قل اولو كانوا لا يملكون شيا ولا يعقلون",
  },
  {
    verseId: 43,
    name: "الزمر",
    surahId: 39,
    text: "قُل لِّلَّهِ ٱلشَّفَٰعَةُ جَمِيعٗاۖ لَّهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ ثُمَّ إِلَيۡهِ تُرۡجَعُونَ",
    translation:
      'Say, "To Allah belongs [the right to allow] intercession entirely. To Him belongs the dominion of the heavens and the earth. Then to Him you will be returned',
    normalizedText: "قل لله الشفعة جميعا له ملك السموت والارض ثم اليه ترجعون",
  },
  {
    verseId: 44,
    name: "الزمر",
    surahId: 39,
    text: "وَإِذَا ذُكِرَ ٱللَّهُ وَحۡدَهُ ٱشۡمَأَزَّتۡ قُلُوبُ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِۖ وَإِذَا ذُكِرَ ٱلَّذِينَ مِن دُونِهِۦٓ إِذَا هُمۡ يَسۡتَبۡشِرُونَ",
    translation:
      "And when Allah is mentioned alone, the hearts of those who do not believe in the Hereafter shrink with aversion, but when those [worshipped] other than Him are mentioned, immediately they rejoice",
    normalizedText:
      "واذا ذكر الله وحده اشمازت قلوب الذين لا يامنون بالاخرة واذا ذكر الذين من دونه اذا هم يستبشرون",
  },
  {
    verseId: 45,
    name: "الزمر",
    surahId: 39,
    text: "قُلِ ٱللَّهُمَّ فَاطِرَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ عَٰلِمَ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ أَنتَ تَحۡكُمُ بَيۡنَ عِبَادِكَ فِي مَا كَانُواْ فِيهِ يَخۡتَلِفُونَ",
    translation:
      'Say, "O Allah, Creator of the heavens and the earth, Knower of the unseen and the witnessed, You will judge between your servants concerning that over which they used to differ',
    normalizedText:
      "قل اللهم فاطر السموت والارض علم الغيب والشهدة انت تحكم بين عبادك في ما كانوا فيه يختلفون",
  },
  {
    verseId: 46,
    name: "الزمر",
    surahId: 39,
    text: "وَلَوۡ أَنَّ لِلَّذِينَ ظَلَمُواْ مَا فِي ٱلۡأَرۡضِ جَمِيعٗا وَمِثۡلَهُۥ مَعَهُۥ لَٱفۡتَدَوۡاْ بِهِۦ مِن سُوٓءِ ٱلۡعَذَابِ يَوۡمَ ٱلۡقِيَٰمَةِۚ وَبَدَا لَهُم مِّنَ ٱللَّهِ مَا لَمۡ يَكُونُواْ يَحۡتَسِبُونَ",
    translation:
      "And if those who did wrong had all that is in the earth entirely and the like of it with it, they would [attempt to] ransom themselves thereby from the worst of the punishment on the Day of Resurrection. And there will appear to them from Allah that which they had not taken into account",
    normalizedText:
      "ولو ان للذين ظلموا ما في الارض جميعا ومثله معه لافتدوا به من سوء العذاب يوم القيمة وبدا لهم من الله ما لم يكونوا يحتسبون",
  },
  {
    verseId: 47,
    name: "الزمر",
    surahId: 39,
    text: "وَبَدَا لَهُمۡ سَيِّـَٔاتُ مَا كَسَبُواْ وَحَاقَ بِهِم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "And there will appear to them the evils they had earned, and they will be enveloped by what they used to ridicule",
    normalizedText: "وبدا لهم سيات ما كسبوا وحاق بهم ما كانوا به يستهزءون",
  },
  {
    verseId: 48,
    name: "الزمر",
    surahId: 39,
    text: "فَإِذَا مَسَّ ٱلۡإِنسَٰنَ ضُرّٞ دَعَانَا ثُمَّ إِذَا خَوَّلۡنَٰهُ نِعۡمَةٗ مِّنَّا قَالَ إِنَّمَآ أُوتِيتُهُۥ عَلَىٰ عِلۡمِۭۚ بَلۡ هِيَ فِتۡنَةٞ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      'And when adversity touches man, he calls upon Us; then when We bestow on him a favor from Us, he says, "I have only been given it because of [my] knowledge." Rather, it is a trial, but most of them do not know',
    normalizedText:
      "فاذا مس الانسن ضر دعانا ثم اذا خولنه نعمة منا قال انما اوتيته على علم بل هي فتنة ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 49,
    name: "الزمر",
    surahId: 39,
    text: "قَدۡ قَالَهَا ٱلَّذِينَ مِن قَبۡلِهِمۡ فَمَآ أَغۡنَىٰ عَنۡهُم مَّا كَانُواْ يَكۡسِبُونَ",
    translation:
      "Those before them had already said it, but they were not availed by what they used to earn",
    normalizedText: "قد قالها الذين من قبلهم فما اغنى عنهم ما كانوا يكسبون",
  },
  {
    verseId: 50,
    name: "الزمر",
    surahId: 39,
    text: "فَأَصَابَهُمۡ سَيِّـَٔاتُ مَا كَسَبُواْۚ وَٱلَّذِينَ ظَلَمُواْ مِنۡ هَـٰٓؤُلَآءِ سَيُصِيبُهُمۡ سَيِّـَٔاتُ مَا كَسَبُواْ وَمَا هُم بِمُعۡجِزِينَ",
    translation:
      "And the evil consequences of what they earned struck them. And those who have wronged of these [people] will be afflicted by the evil consequences of what they earned; and they will not cause failure",
    normalizedText:
      "فاصابهم سيات ما كسبوا والذين ظلموا من هالاء سيصيبهم سيات ما كسبوا وما هم بمعجزين",
  },
  {
    verseId: 51,
    name: "الزمر",
    surahId: 39,
    text: "أَوَلَمۡ يَعۡلَمُوٓاْ أَنَّ ٱللَّهَ يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ وَيَقۡدِرُۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يُؤۡمِنُونَ",
    translation:
      "Do they not know that Allah extends provision for whom He wills and restricts [it]? Indeed in that are signs for a people who believe",
    normalizedText:
      "اولم يعلموا ان الله يبسط الرزق لمن يشاء ويقدر ان في ذلك لايت لقوم يامنون",
  },
  {
    verseId: 52,
    name: "الزمر",
    surahId: 39,
    text: "۞قُلۡ يَٰعِبَادِيَ ٱلَّذِينَ أَسۡرَفُواْ عَلَىٰٓ أَنفُسِهِمۡ لَا تَقۡنَطُواْ مِن رَّحۡمَةِ ٱللَّهِۚ إِنَّ ٱللَّهَ يَغۡفِرُ ٱلذُّنُوبَ جَمِيعًاۚ إِنَّهُۥ هُوَ ٱلۡغَفُورُ ٱلرَّحِيمُ",
    translation:
      'Say, "O My servants who have transgressed against themselves [by sinning], do not despair of the mercy of Allah. Indeed, Allah forgives all sins. Indeed, it is He who is the Forgiving, the Merciful',
    normalizedText:
      "۞قل يعبادي الذين اسرفوا على انفسهم لا تقنطوا من رحمة الله ان الله يغفر الذنوب جميعا انه هو الغفور الرحيم",
  },
  {
    verseId: 53,
    name: "الزمر",
    surahId: 39,
    text: "وَأَنِيبُوٓاْ إِلَىٰ رَبِّكُمۡ وَأَسۡلِمُواْ لَهُۥ مِن قَبۡلِ أَن يَأۡتِيَكُمُ ٱلۡعَذَابُ ثُمَّ لَا تُنصَرُونَ",
    translation:
      "And return [in repentance] to your Lord and submit to Him before the punishment comes upon you; then you will not be helped",
    normalizedText:
      "وانيبوا الى ربكم واسلموا له من قبل ان ياتيكم العذاب ثم لا تنصرون",
  },
  {
    verseId: 54,
    name: "الزمر",
    surahId: 39,
    text: "وَٱتَّبِعُوٓاْ أَحۡسَنَ مَآ أُنزِلَ إِلَيۡكُم مِّن رَّبِّكُم مِّن قَبۡلِ أَن يَأۡتِيَكُمُ ٱلۡعَذَابُ بَغۡتَةٗ وَأَنتُمۡ لَا تَشۡعُرُونَ",
    translation:
      "And follow the best of what was revealed to you from your Lord before the punishment comes upon you suddenly while you do not perceive",
    normalizedText:
      "واتبعوا احسن ما انزل اليكم من ربكم من قبل ان ياتيكم العذاب بغتة وانتم لا تشعرون",
  },
  {
    verseId: 55,
    name: "الزمر",
    surahId: 39,
    text: "أَن تَقُولَ نَفۡسٞ يَٰحَسۡرَتَىٰ عَلَىٰ مَا فَرَّطتُ فِي جَنۢبِ ٱللَّهِ وَإِن كُنتُ لَمِنَ ٱلسَّـٰخِرِينَ",
    translation:
      'Lest a soul should say, "Oh [how great is] my regret over what I neglected in regard to Allah and that I was among the mockers',
    normalizedText:
      "ان تقول نفس يحسرتى على ما فرطت في جنب الله وان كنت لمن السخرين",
  },
  {
    verseId: 56,
    name: "الزمر",
    surahId: 39,
    text: "أَوۡ تَقُولَ لَوۡ أَنَّ ٱللَّهَ هَدَىٰنِي لَكُنتُ مِنَ ٱلۡمُتَّقِينَ",
    translation:
      'Or [lest] it say, "If only Allah had guided me, I would have been among the righteous',
    normalizedText: "او تقول لو ان الله هدىني لكنت من المتقين",
  },
  {
    verseId: 57,
    name: "الزمر",
    surahId: 39,
    text: "أَوۡ تَقُولَ حِينَ تَرَى ٱلۡعَذَابَ لَوۡ أَنَّ لِي كَرَّةٗ فَأَكُونَ مِنَ ٱلۡمُحۡسِنِينَ",
    translation:
      'Or [lest] it say when it sees the punishment, "If only I had another turn so I could be among the doers of good',
    normalizedText: "او تقول حين ترى العذاب لو ان لي كرة فاكون من المحسنين",
  },
  {
    verseId: 58,
    name: "الزمر",
    surahId: 39,
    text: "بَلَىٰ قَدۡ جَآءَتۡكَ ءَايَٰتِي فَكَذَّبۡتَ بِهَا وَٱسۡتَكۡبَرۡتَ وَكُنتَ مِنَ ٱلۡكَٰفِرِينَ",
    translation:
      "But yes, there had come to you My verses, but you denied them and were arrogant, and you were among the disbelievers",
    normalizedText: "بلى قد جاءتك ءايتي فكذبت بها واستكبرت وكنت من الكفرين",
  },
  {
    verseId: 59,
    name: "الزمر",
    surahId: 39,
    text: "وَيَوۡمَ ٱلۡقِيَٰمَةِ تَرَى ٱلَّذِينَ كَذَبُواْ عَلَى ٱللَّهِ وُجُوهُهُم مُّسۡوَدَّةٌۚ أَلَيۡسَ فِي جَهَنَّمَ مَثۡوٗى لِّلۡمُتَكَبِّرِينَ",
    translation:
      "And on the Day of Resurrection you will see those who lied about Allah [with] their faces blackened. Is there not in Hell a residence for the arrogant",
    normalizedText:
      "ويوم القيمة ترى الذين كذبوا على الله وجوههم مسودة اليس في جهنم مثوى للمتكبرين",
  },
  {
    verseId: 60,
    name: "الزمر",
    surahId: 39,
    text: "وَيُنَجِّي ٱللَّهُ ٱلَّذِينَ ٱتَّقَوۡاْ بِمَفَازَتِهِمۡ لَا يَمَسُّهُمُ ٱلسُّوٓءُ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      "And Allah will save those who feared Him by their attainment; no evil will touch them, nor will they grieve",
    normalizedText:
      "وينجي الله الذين اتقوا بمفازتهم لا يمسهم السوء ولا هم يحزنون",
  },
  {
    verseId: 61,
    name: "الزمر",
    surahId: 39,
    text: "ٱللَّهُ خَٰلِقُ كُلِّ شَيۡءٖۖ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ وَكِيلٞ",
    translation:
      "Allah is the Creator of all things, and He is, over all things, Disposer of affairs",
    normalizedText: "الله خلق كل شيء وهو على كل شيء وكيل",
  },
  {
    verseId: 62,
    name: "الزمر",
    surahId: 39,
    text: "لَّهُۥ مَقَالِيدُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۗ وَٱلَّذِينَ كَفَرُواْ بِـَٔايَٰتِ ٱللَّهِ أُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "To Him belong the keys of the heavens and the earth. And they who disbelieve in the verses of Allah - it is those who are the losers",
    normalizedText:
      "له مقاليد السموت والارض والذين كفروا بايت الله اولاك هم الخسرون",
  },
  {
    verseId: 63,
    name: "الزمر",
    surahId: 39,
    text: "قُلۡ أَفَغَيۡرَ ٱللَّهِ تَأۡمُرُوٓنِّيٓ أَعۡبُدُ أَيُّهَا ٱلۡجَٰهِلُونَ",
    translation:
      'Say, [O Muhammad], "Is it other than Allah that you order me to worship, O ignorant ones',
    normalizedText: "قل افغير الله تامروني اعبد ايها الجهلون",
  },
  {
    verseId: 64,
    name: "الزمر",
    surahId: 39,
    text: "وَلَقَدۡ أُوحِيَ إِلَيۡكَ وَإِلَى ٱلَّذِينَ مِن قَبۡلِكَ لَئِنۡ أَشۡرَكۡتَ لَيَحۡبَطَنَّ عَمَلُكَ وَلَتَكُونَنَّ مِنَ ٱلۡخَٰسِرِينَ",
    translation:
      "And it was already revealed to you and to those before you that if you should associate [anything] with Allah, your work would surely become worthless, and you would surely be among the losers",
    normalizedText:
      "ولقد اوحي اليك والى الذين من قبلك لان اشركت ليحبطن عملك ولتكونن من الخسرين",
  },
  {
    verseId: 65,
    name: "الزمر",
    surahId: 39,
    text: "بَلِ ٱللَّهَ فَٱعۡبُدۡ وَكُن مِّنَ ٱلشَّـٰكِرِينَ",
    translation: "Rather, worship [only] Allah and be among the grateful",
    normalizedText: "بل الله فاعبد وكن من الشكرين",
  },
  {
    verseId: 66,
    name: "الزمر",
    surahId: 39,
    text: "وَمَا قَدَرُواْ ٱللَّهَ حَقَّ قَدۡرِهِۦ وَٱلۡأَرۡضُ جَمِيعٗا قَبۡضَتُهُۥ يَوۡمَ ٱلۡقِيَٰمَةِ وَٱلسَّمَٰوَٰتُ مَطۡوِيَّـٰتُۢ بِيَمِينِهِۦۚ سُبۡحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشۡرِكُونَ",
    translation:
      "They have not appraised Allah with true appraisal, while the earth entirely will be [within] His grip on the Day of Resurrection, and the heavens will be folded in His right hand. Exalted is He and high above what they associate with Him",
    normalizedText:
      "وما قدروا الله حق قدره والارض جميعا قبضته يوم القيمة والسموت مطويت بيمينه سبحنه وتعلى عما يشركون",
  },
  {
    verseId: 67,
    name: "الزمر",
    surahId: 39,
    text: "وَنُفِخَ فِي ٱلصُّورِ فَصَعِقَ مَن فِي ٱلسَّمَٰوَٰتِ وَمَن فِي ٱلۡأَرۡضِ إِلَّا مَن شَآءَ ٱللَّهُۖ ثُمَّ نُفِخَ فِيهِ أُخۡرَىٰ فَإِذَا هُمۡ قِيَامٞ يَنظُرُونَ",
    translation:
      "And the Horn will be blown, and whoever is in the heavens and whoever is on the earth will fall dead except whom Allah wills. Then it will be blown again, and at once they will be standing, looking on",
    normalizedText:
      "ونفخ في الصور فصعق من في السموت ومن في الارض الا من شاء الله ثم نفخ فيه اخرى فاذا هم قيام ينظرون",
  },
  {
    verseId: 68,
    name: "الزمر",
    surahId: 39,
    text: "وَأَشۡرَقَتِ ٱلۡأَرۡضُ بِنُورِ رَبِّهَا وَوُضِعَ ٱلۡكِتَٰبُ وَجِاْيٓءَ بِٱلنَّبِيِّـۧنَ وَٱلشُّهَدَآءِ وَقُضِيَ بَيۡنَهُم بِٱلۡحَقِّ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "And the earth will shine with the light of its Lord, and the record [of deeds] will be placed, and the prophets and the witnesses will be brought, and it will be judged between them in truth, and they will not be wronged",
    normalizedText:
      "واشرقت الارض بنور ربها ووضع الكتب وجايء بالنبين والشهداء وقضي بينهم بالحق وهم لا يظلمون",
  },
  {
    verseId: 69,
    name: "الزمر",
    surahId: 39,
    text: "وَوُفِّيَتۡ كُلُّ نَفۡسٖ مَّا عَمِلَتۡ وَهُوَ أَعۡلَمُ بِمَا يَفۡعَلُونَ",
    translation:
      "And every soul will be fully compensated [for] what it did; and He is most knowing of what they do",
    normalizedText: "ووفيت كل نفس ما عملت وهو اعلم بما يفعلون",
  },
  {
    verseId: 70,
    name: "الزمر",
    surahId: 39,
    text: "وَسِيقَ ٱلَّذِينَ كَفَرُوٓاْ إِلَىٰ جَهَنَّمَ زُمَرًاۖ حَتَّىٰٓ إِذَا جَآءُوهَا فُتِحَتۡ أَبۡوَٰبُهَا وَقَالَ لَهُمۡ خَزَنَتُهَآ أَلَمۡ يَأۡتِكُمۡ رُسُلٞ مِّنكُمۡ يَتۡلُونَ عَلَيۡكُمۡ ءَايَٰتِ رَبِّكُمۡ وَيُنذِرُونَكُمۡ لِقَآءَ يَوۡمِكُمۡ هَٰذَاۚ قَالُواْ بَلَىٰ وَلَٰكِنۡ حَقَّتۡ كَلِمَةُ ٱلۡعَذَابِ عَلَى ٱلۡكَٰفِرِينَ",
    translation:
      'And those who disbelieved will be driven to Hell in groups until, when they reach it, its gates are opened and its keepers will say, "Did there not come to you messengers from yourselves, reciting to you the verses of your Lord and warning you of the meeting of this Day of yours?" They will say, "Yes, but the word of punishment has come into effect upon the disbelievers',
    normalizedText:
      "وسيق الذين كفروا الى جهنم زمرا حتى اذا جاءوها فتحت ابوبها وقال لهم خزنتها الم ياتكم رسل منكم يتلون عليكم ءايت ربكم وينذرونكم لقاء يومكم هذا قالوا بلى ولكن حقت كلمة العذاب على الكفرين",
  },
  {
    verseId: 71,
    name: "الزمر",
    surahId: 39,
    text: "قِيلَ ٱدۡخُلُوٓاْ أَبۡوَٰبَ جَهَنَّمَ خَٰلِدِينَ فِيهَاۖ فَبِئۡسَ مَثۡوَى ٱلۡمُتَكَبِّرِينَ",
    translation:
      '[To them] it will be said, "Enter the gates of Hell to abide eternally therein, and wretched is the residence of the arrogant',
    normalizedText: "قيل ادخلوا ابوب جهنم خلدين فيها فباس مثوى المتكبرين",
  },
  {
    verseId: 72,
    name: "الزمر",
    surahId: 39,
    text: "وَسِيقَ ٱلَّذِينَ ٱتَّقَوۡاْ رَبَّهُمۡ إِلَى ٱلۡجَنَّةِ زُمَرًاۖ حَتَّىٰٓ إِذَا جَآءُوهَا وَفُتِحَتۡ أَبۡوَٰبُهَا وَقَالَ لَهُمۡ خَزَنَتُهَا سَلَٰمٌ عَلَيۡكُمۡ طِبۡتُمۡ فَٱدۡخُلُوهَا خَٰلِدِينَ",
    translation:
      'But those who feared their Lord will be driven to Paradise in groups until, when they reach it while its gates have been opened and its keepers say, "Peace be upon you; you have become pure; so enter it to abide eternally therein," [they will enter]',
    normalizedText:
      "وسيق الذين اتقوا ربهم الى الجنة زمرا حتى اذا جاءوها وفتحت ابوبها وقال لهم خزنتها سلم عليكم طبتم فادخلوها خلدين",
  },
  {
    verseId: 73,
    name: "الزمر",
    surahId: 39,
    text: "وَقَالُواْ ٱلۡحَمۡدُ لِلَّهِ ٱلَّذِي صَدَقَنَا وَعۡدَهُۥ وَأَوۡرَثَنَا ٱلۡأَرۡضَ نَتَبَوَّأُ مِنَ ٱلۡجَنَّةِ حَيۡثُ نَشَآءُۖ فَنِعۡمَ أَجۡرُ ٱلۡعَٰمِلِينَ",
    translation:
      'And they will say, "Praise to Allah, who has fulfilled for us His promise and made us inherit the earth [so] we may settle in Paradise wherever we will. And excellent is the reward of [righteous] workers',
    normalizedText:
      "وقالوا الحمد لله الذي صدقنا وعده واورثنا الارض نتبوا من الجنة حيث نشاء فنعم اجر العملين",
  },
  {
    verseId: 74,
    name: "الزمر",
    surahId: 39,
    text: "وَتَرَى ٱلۡمَلَـٰٓئِكَةَ حَآفِّينَ مِنۡ حَوۡلِ ٱلۡعَرۡشِ يُسَبِّحُونَ بِحَمۡدِ رَبِّهِمۡۚ وَقُضِيَ بَيۡنَهُم بِٱلۡحَقِّۚ وَقِيلَ ٱلۡحَمۡدُ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'And you will see the angels surrounding the Throne, exalting [Allah] with praise of their Lord. And it will be judged between them in truth, and it will be said, "[All] praise to Allah, Lord of the worlds',
    normalizedText:
      "وترى الملاكة حافين من حول العرش يسبحون بحمد ربهم وقضي بينهم بالحق وقيل الحمد لله رب العلمين",
  },
  {
    verseId: 0,
    name: "غافر",
    surahId: 40,
    text: "حمٓ",
    translation: "Ha, Meem",
    normalizedText: "حم",
  },
  {
    verseId: 1,
    name: "غافر",
    surahId: 40,
    text: "تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡعَلِيمِ",
    translation:
      "The revelation of the Book is from Allah, the Exalted in Might, the Knowing",
    normalizedText: "تنزيل الكتب من الله العزيز العليم",
  },
  {
    verseId: 2,
    name: "غافر",
    surahId: 40,
    text: "غَافِرِ ٱلذَّنۢبِ وَقَابِلِ ٱلتَّوۡبِ شَدِيدِ ٱلۡعِقَابِ ذِي ٱلطَّوۡلِۖ لَآ إِلَٰهَ إِلَّا هُوَۖ إِلَيۡهِ ٱلۡمَصِيرُ",
    translation:
      "The forgiver of sin, acceptor of repentance, severe in punishment, owner of abundance. There is no deity except Him; to Him is the destination",
    normalizedText:
      "غافر الذنب وقابل التوب شديد العقاب ذي الطول لا اله الا هو اليه المصير",
  },
  {
    verseId: 3,
    name: "غافر",
    surahId: 40,
    text: "مَا يُجَٰدِلُ فِيٓ ءَايَٰتِ ٱللَّهِ إِلَّا ٱلَّذِينَ كَفَرُواْ فَلَا يَغۡرُرۡكَ تَقَلُّبُهُمۡ فِي ٱلۡبِلَٰدِ",
    translation:
      "No one disputes concerning the signs of Allah except those who disbelieve, so be not deceived by their [uninhibited] movement throughout the land",
    normalizedText:
      "ما يجدل في ءايت الله الا الذين كفروا فلا يغررك تقلبهم في البلد",
  },
  {
    verseId: 4,
    name: "غافر",
    surahId: 40,
    text: "كَذَّبَتۡ قَبۡلَهُمۡ قَوۡمُ نُوحٖ وَٱلۡأَحۡزَابُ مِنۢ بَعۡدِهِمۡۖ وَهَمَّتۡ كُلُّ أُمَّةِۭ بِرَسُولِهِمۡ لِيَأۡخُذُوهُۖ وَجَٰدَلُواْ بِٱلۡبَٰطِلِ لِيُدۡحِضُواْ بِهِ ٱلۡحَقَّ فَأَخَذۡتُهُمۡۖ فَكَيۡفَ كَانَ عِقَابِ",
    translation:
      "The people of Noah denied before them and the [disbelieving] factions after them, and every nation intended [a plot] for their messenger to seize him, and they disputed by [using] falsehood to [attempt to] invalidate thereby the truth. So I seized them, and how [terrible] was My penalty",
    normalizedText:
      "كذبت قبلهم قوم نوح والاحزاب من بعدهم وهمت كل امة برسولهم لياخذوه وجدلوا بالبطل ليدحضوا به الحق فاخذتهم فكيف كان عقاب",
  },
  {
    verseId: 5,
    name: "غافر",
    surahId: 40,
    text: "وَكَذَٰلِكَ حَقَّتۡ كَلِمَتُ رَبِّكَ عَلَى ٱلَّذِينَ كَفَرُوٓاْ أَنَّهُمۡ أَصۡحَٰبُ ٱلنَّارِ",
    translation:
      "And thus has the word of your Lord come into effect upon those who disbelieved that they are companions of the Fire",
    normalizedText: "وكذلك حقت كلمت ربك على الذين كفروا انهم اصحب النار",
  },
  {
    verseId: 6,
    name: "غافر",
    surahId: 40,
    text: "ٱلَّذِينَ يَحۡمِلُونَ ٱلۡعَرۡشَ وَمَنۡ حَوۡلَهُۥ يُسَبِّحُونَ بِحَمۡدِ رَبِّهِمۡ وَيُؤۡمِنُونَ بِهِۦ وَيَسۡتَغۡفِرُونَ لِلَّذِينَ ءَامَنُواْۖ رَبَّنَا وَسِعۡتَ كُلَّ شَيۡءٖ رَّحۡمَةٗ وَعِلۡمٗا فَٱغۡفِرۡ لِلَّذِينَ تَابُواْ وَٱتَّبَعُواْ سَبِيلَكَ وَقِهِمۡ عَذَابَ ٱلۡجَحِيمِ",
    translation:
      'Those [angels] who carry the Throne and those around it exalt [Allah] with praise of their Lord and believe in Him and ask forgiveness for those who have believed, [saying], "Our Lord, You have encompassed all things in mercy and knowledge, so forgive those who have repented and followed Your way and protect them from the punishment of Hellfire',
    normalizedText:
      "الذين يحملون العرش ومن حوله يسبحون بحمد ربهم ويامنون به ويستغفرون للذين ءامنوا ربنا وسعت كل شيء رحمة وعلما فاغفر للذين تابوا واتبعوا سبيلك وقهم عذاب الجحيم",
  },
  {
    verseId: 7,
    name: "غافر",
    surahId: 40,
    text: "رَبَّنَا وَأَدۡخِلۡهُمۡ جَنَّـٰتِ عَدۡنٍ ٱلَّتِي وَعَدتَّهُمۡ وَمَن صَلَحَ مِنۡ ءَابَآئِهِمۡ وَأَزۡوَٰجِهِمۡ وَذُرِّيَّـٰتِهِمۡۚ إِنَّكَ أَنتَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Our Lord, and admit them to gardens of perpetual residence which You have promised them and whoever was righteous among their fathers, their spouses and their offspring. Indeed, it is You who is the Exalted in Might, the Wise",
    normalizedText:
      "ربنا وادخلهم جنت عدن التي وعدتهم ومن صلح من ءابااهم وازوجهم وذريتهم انك انت العزيز الحكيم",
  },
  {
    verseId: 8,
    name: "غافر",
    surahId: 40,
    text: "وَقِهِمُ ٱلسَّيِّـَٔاتِۚ وَمَن تَقِ ٱلسَّيِّـَٔاتِ يَوۡمَئِذٖ فَقَدۡ رَحِمۡتَهُۥۚ وَذَٰلِكَ هُوَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "And protect them from the evil consequences [of their deeds]. And he whom You protect from evil consequences that Day - You will have given him mercy. And that is the great attainment",
    normalizedText:
      "وقهم السيات ومن تق السيات يوماذ فقد رحمته وذلك هو الفوز العظيم",
  },
  {
    verseId: 9,
    name: "غافر",
    surahId: 40,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ يُنَادَوۡنَ لَمَقۡتُ ٱللَّهِ أَكۡبَرُ مِن مَّقۡتِكُمۡ أَنفُسَكُمۡ إِذۡ تُدۡعَوۡنَ إِلَى ٱلۡإِيمَٰنِ فَتَكۡفُرُونَ",
    translation:
      'Indeed, those who disbelieve will be addressed, "The hatred of Allah for you was [even] greater than your hatred of yourselves [this Day in Hell] when you were invited to faith, but you refused',
    normalizedText:
      "ان الذين كفروا ينادون لمقت الله اكبر من مقتكم انفسكم اذ تدعون الى الايمن فتكفرون",
  },
  {
    verseId: 10,
    name: "غافر",
    surahId: 40,
    text: "قَالُواْ رَبَّنَآ أَمَتَّنَا ٱثۡنَتَيۡنِ وَأَحۡيَيۡتَنَا ٱثۡنَتَيۡنِ فَٱعۡتَرَفۡنَا بِذُنُوبِنَا فَهَلۡ إِلَىٰ خُرُوجٖ مِّن سَبِيلٖ",
    translation:
      'They will say, "Our Lord, You made us lifeless twice and gave us life twice, and we have confessed our sins. So is there to an exit any way',
    normalizedText:
      "قالوا ربنا امتنا اثنتين واحييتنا اثنتين فاعترفنا بذنوبنا فهل الى خروج من سبيل",
  },
  {
    verseId: 11,
    name: "غافر",
    surahId: 40,
    text: "ذَٰلِكُم بِأَنَّهُۥٓ إِذَا دُعِيَ ٱللَّهُ وَحۡدَهُۥ كَفَرۡتُمۡ وَإِن يُشۡرَكۡ بِهِۦ تُؤۡمِنُواْۚ فَٱلۡحُكۡمُ لِلَّهِ ٱلۡعَلِيِّ ٱلۡكَبِيرِ",
    translation:
      '[They will be told], "That is because, when Allah was called upon alone, you disbelieved; but if others were associated with Him, you believed. So the judgement is with Allah, the Most High, the Grand',
    normalizedText:
      "ذلكم بانه اذا دعي الله وحده كفرتم وان يشرك به تامنوا فالحكم لله العلي الكبير",
  },
  {
    verseId: 12,
    name: "غافر",
    surahId: 40,
    text: "هُوَ ٱلَّذِي يُرِيكُمۡ ءَايَٰتِهِۦ وَيُنَزِّلُ لَكُم مِّنَ ٱلسَّمَآءِ رِزۡقٗاۚ وَمَا يَتَذَكَّرُ إِلَّا مَن يُنِيبُ",
    translation:
      "It is He who shows you His signs and sends down to you from the sky, provision. But none will remember except he who turns back [in repentance]",
    normalizedText:
      "هو الذي يريكم ءايته وينزل لكم من السماء رزقا وما يتذكر الا من ينيب",
  },
  {
    verseId: 13,
    name: "غافر",
    surahId: 40,
    text: "فَٱدۡعُواْ ٱللَّهَ مُخۡلِصِينَ لَهُ ٱلدِّينَ وَلَوۡ كَرِهَ ٱلۡكَٰفِرُونَ",
    translation:
      "So invoke Allah, [being] sincere to Him in religion, although the disbelievers dislike it",
    normalizedText: "فادعوا الله مخلصين له الدين ولو كره الكفرون",
  },
  {
    verseId: 14,
    name: "غافر",
    surahId: 40,
    text: "رَفِيعُ ٱلدَّرَجَٰتِ ذُو ٱلۡعَرۡشِ يُلۡقِي ٱلرُّوحَ مِنۡ أَمۡرِهِۦ عَلَىٰ مَن يَشَآءُ مِنۡ عِبَادِهِۦ لِيُنذِرَ يَوۡمَ ٱلتَّلَاقِ",
    translation:
      "[He is] the Exalted above [all] degrees, Owner of the Throne; He places the inspiration of His command upon whom He wills of His servants to warn of the Day of Meeting",
    normalizedText:
      "رفيع الدرجت ذو العرش يلقي الروح من امره على من يشاء من عباده لينذر يوم التلاق",
  },
  {
    verseId: 15,
    name: "غافر",
    surahId: 40,
    text: "يَوۡمَ هُم بَٰرِزُونَۖ لَا يَخۡفَىٰ عَلَى ٱللَّهِ مِنۡهُمۡ شَيۡءٞۚ لِّمَنِ ٱلۡمُلۡكُ ٱلۡيَوۡمَۖ لِلَّهِ ٱلۡوَٰحِدِ ٱلۡقَهَّارِ",
    translation:
      "The Day they come forth nothing concerning them will be concealed from Allah. To whom belongs [all] sovereignty this Day? To Allah, the One, the Prevailing",
    normalizedText:
      "يوم هم برزون لا يخفى على الله منهم شيء لمن الملك اليوم لله الوحد القهار",
  },
  {
    verseId: 16,
    name: "غافر",
    surahId: 40,
    text: "ٱلۡيَوۡمَ تُجۡزَىٰ كُلُّ نَفۡسِۭ بِمَا كَسَبَتۡۚ لَا ظُلۡمَ ٱلۡيَوۡمَۚ إِنَّ ٱللَّهَ سَرِيعُ ٱلۡحِسَابِ",
    translation:
      "This Day every soul will be recompensed for what it earned. No injustice today! Indeed, Allah is swift in account",
    normalizedText:
      "اليوم تجزى كل نفس بما كسبت لا ظلم اليوم ان الله سريع الحساب",
  },
  {
    verseId: 17,
    name: "غافر",
    surahId: 40,
    text: "وَأَنذِرۡهُمۡ يَوۡمَ ٱلۡأٓزِفَةِ إِذِ ٱلۡقُلُوبُ لَدَى ٱلۡحَنَاجِرِ كَٰظِمِينَۚ مَا لِلظَّـٰلِمِينَ مِنۡ حَمِيمٖ وَلَا شَفِيعٖ يُطَاعُ",
    translation:
      "And warn them, [O Muhammad], of the Approaching Day, when hearts are at the throats, filled [with distress]. For the wrongdoers there will be no devoted friend and no intercessor [who is] obeyed",
    normalizedText:
      "وانذرهم يوم الازفة اذ القلوب لدى الحناجر كظمين ما للظلمين من حميم ولا شفيع يطاع",
  },
  {
    verseId: 18,
    name: "غافر",
    surahId: 40,
    text: "يَعۡلَمُ خَآئِنَةَ ٱلۡأَعۡيُنِ وَمَا تُخۡفِي ٱلصُّدُورُ",
    translation:
      "He knows that which deceives the eyes and what the breasts conceal",
    normalizedText: "يعلم خاانة الاعين وما تخفي الصدور",
  },
  {
    verseId: 19,
    name: "غافر",
    surahId: 40,
    text: "وَٱللَّهُ يَقۡضِي بِٱلۡحَقِّۖ وَٱلَّذِينَ يَدۡعُونَ مِن دُونِهِۦ لَا يَقۡضُونَ بِشَيۡءٍۗ إِنَّ ٱللَّهَ هُوَ ٱلسَّمِيعُ ٱلۡبَصِيرُ",
    translation:
      "And Allah judges with truth, while those they invoke besides Him judge not with anything. Indeed, Allah - He is the Hearing, the Seeing",
    normalizedText:
      "والله يقضي بالحق والذين يدعون من دونه لا يقضون بشيء ان الله هو السميع البصير",
  },
  {
    verseId: 20,
    name: "غافر",
    surahId: 40,
    text: "۞أَوَلَمۡ يَسِيرُواْ فِي ٱلۡأَرۡضِ فَيَنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ كَانُواْ مِن قَبۡلِهِمۡۚ كَانُواْ هُمۡ أَشَدَّ مِنۡهُمۡ قُوَّةٗ وَءَاثَارٗا فِي ٱلۡأَرۡضِ فَأَخَذَهُمُ ٱللَّهُ بِذُنُوبِهِمۡ وَمَا كَانَ لَهُم مِّنَ ٱللَّهِ مِن وَاقٖ",
    translation:
      "Have they not traveled through the land and observed how was the end of those who were before them? They were greater than them in strength and in impression on the land, but Allah seized them for their sins. And they had not from Allah any protector",
    normalizedText:
      "۞اولم يسيروا في الارض فينظروا كيف كان عقبة الذين كانوا من قبلهم كانوا هم اشد منهم قوة وءاثارا في الارض فاخذهم الله بذنوبهم وما كان لهم من الله من واق",
  },
  {
    verseId: 21,
    name: "غافر",
    surahId: 40,
    text: "ذَٰلِكَ بِأَنَّهُمۡ كَانَت تَّأۡتِيهِمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِ فَكَفَرُواْ فَأَخَذَهُمُ ٱللَّهُۚ إِنَّهُۥ قَوِيّٞ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "That was because their messengers were coming to them with clear proofs, but they disbelieved, so Allah seized them. Indeed, He is Powerful and severe in punishment",
    normalizedText:
      "ذلك بانهم كانت تاتيهم رسلهم بالبينت فكفروا فاخذهم الله انه قوي شديد العقاب",
  },
  {
    verseId: 22,
    name: "غافر",
    surahId: 40,
    text: "وَلَقَدۡ أَرۡسَلۡنَا مُوسَىٰ بِـَٔايَٰتِنَا وَسُلۡطَٰنٖ مُّبِينٍ",
    translation:
      "And We did certainly send Moses with Our signs and a clear authority",
    normalizedText: "ولقد ارسلنا موسى بايتنا وسلطن مبين",
  },
  {
    verseId: 23,
    name: "غافر",
    surahId: 40,
    text: "إِلَىٰ فِرۡعَوۡنَ وَهَٰمَٰنَ وَقَٰرُونَ فَقَالُواْ سَٰحِرٞ كَذَّابٞ",
    translation:
      'To Pharaoh, Haman and Qarun; but they said, "[He is] a magician and a liar',
    normalizedText: "الى فرعون وهمن وقرون فقالوا سحر كذاب",
  },
  {
    verseId: 24,
    name: "غافر",
    surahId: 40,
    text: "فَلَمَّا جَآءَهُم بِٱلۡحَقِّ مِنۡ عِندِنَا قَالُواْ ٱقۡتُلُوٓاْ أَبۡنَآءَ ٱلَّذِينَ ءَامَنُواْ مَعَهُۥ وَٱسۡتَحۡيُواْ نِسَآءَهُمۡۚ وَمَا كَيۡدُ ٱلۡكَٰفِرِينَ إِلَّا فِي ضَلَٰلٖ",
    translation:
      'And when he brought them the truth from Us, they said, "Kill the sons of those who have believed with him and keep their women alive." But the plan of the disbelievers is not except in error',
    normalizedText:
      "فلما جاءهم بالحق من عندنا قالوا اقتلوا ابناء الذين ءامنوا معه واستحيوا نساءهم وما كيد الكفرين الا في ضلل",
  },
  {
    verseId: 25,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ فِرۡعَوۡنُ ذَرُونِيٓ أَقۡتُلۡ مُوسَىٰ وَلۡيَدۡعُ رَبَّهُۥٓۖ إِنِّيٓ أَخَافُ أَن يُبَدِّلَ دِينَكُمۡ أَوۡ أَن يُظۡهِرَ فِي ٱلۡأَرۡضِ ٱلۡفَسَادَ",
    translation:
      'And Pharaoh said, "Let me kill Moses and let him call upon his Lord. Indeed, I fear that he will change your religion or that he will cause corruption in the land',
    normalizedText:
      "وقال فرعون ذروني اقتل موسى وليدع ربه اني اخاف ان يبدل دينكم او ان يظهر في الارض الفساد",
  },
  {
    verseId: 26,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ مُوسَىٰٓ إِنِّي عُذۡتُ بِرَبِّي وَرَبِّكُم مِّن كُلِّ مُتَكَبِّرٖ لَّا يُؤۡمِنُ بِيَوۡمِ ٱلۡحِسَابِ",
    translation:
      'But Moses said, "Indeed, I have sought refuge in my Lord and your Lord from every arrogant one who does not believe in the Day of Account',
    normalizedText:
      "وقال موسى اني عذت بربي وربكم من كل متكبر لا يامن بيوم الحساب",
  },
  {
    verseId: 27,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ رَجُلٞ مُّؤۡمِنٞ مِّنۡ ءَالِ فِرۡعَوۡنَ يَكۡتُمُ إِيمَٰنَهُۥٓ أَتَقۡتُلُونَ رَجُلًا أَن يَقُولَ رَبِّيَ ٱللَّهُ وَقَدۡ جَآءَكُم بِٱلۡبَيِّنَٰتِ مِن رَّبِّكُمۡۖ وَإِن يَكُ كَٰذِبٗا فَعَلَيۡهِ كَذِبُهُۥۖ وَإِن يَكُ صَادِقٗا يُصِبۡكُم بَعۡضُ ٱلَّذِي يَعِدُكُمۡۖ إِنَّ ٱللَّهَ لَا يَهۡدِي مَنۡ هُوَ مُسۡرِفٞ كَذَّابٞ",
    translation: `And a believing man from the family of Pharaoh who concealed his faith said, "Do you kill a man [merely] because he says, 'My Lord is Allah' while he has brought you clear proofs from your Lord? And if he should be lying, then upon him is [the consequence of] his lie; but if he should be truthful, there will strike you some of what he promises you. Indeed, Allah does not guide one who is a transgressor and a liar`,
    normalizedText:
      "وقال رجل مامن من ءال فرعون يكتم ايمنه اتقتلون رجلا ان يقول ربي الله وقد جاءكم بالبينت من ربكم وان يك كذبا فعليه كذبه وان يك صادقا يصبكم بعض الذي يعدكم ان الله لا يهدي من هو مسرف كذاب",
  },
  {
    verseId: 28,
    name: "غافر",
    surahId: 40,
    text: "يَٰقَوۡمِ لَكُمُ ٱلۡمُلۡكُ ٱلۡيَوۡمَ ظَٰهِرِينَ فِي ٱلۡأَرۡضِ فَمَن يَنصُرُنَا مِنۢ بَأۡسِ ٱللَّهِ إِن جَآءَنَاۚ قَالَ فِرۡعَوۡنُ مَآ أُرِيكُمۡ إِلَّا مَآ أَرَىٰ وَمَآ أَهۡدِيكُمۡ إِلَّا سَبِيلَ ٱلرَّشَادِ",
    translation:
      'O my people, sovereignty is yours today, [your being] dominant in the land. But who would protect us from the punishment of Allah if it came to us?" Pharaoh said, "I do not show you except what I see, and I do not guide you except to the way of right conduct',
    normalizedText:
      "يقوم لكم الملك اليوم ظهرين في الارض فمن ينصرنا من باس الله ان جاءنا قال فرعون ما اريكم الا ما ارى وما اهديكم الا سبيل الرشاد",
  },
  {
    verseId: 29,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ ٱلَّذِيٓ ءَامَنَ يَٰقَوۡمِ إِنِّيٓ أَخَافُ عَلَيۡكُم مِّثۡلَ يَوۡمِ ٱلۡأَحۡزَابِ",
    translation:
      'And he who believed said, "O my people, indeed I fear for you [a fate] like the day of the companies',
    normalizedText: "وقال الذي ءامن يقوم اني اخاف عليكم مثل يوم الاحزاب",
  },
  {
    verseId: 30,
    name: "غافر",
    surahId: 40,
    text: "مِثۡلَ دَأۡبِ قَوۡمِ نُوحٖ وَعَادٖ وَثَمُودَ وَٱلَّذِينَ مِنۢ بَعۡدِهِمۡۚ وَمَا ٱللَّهُ يُرِيدُ ظُلۡمٗا لِّلۡعِبَادِ",
    translation:
      "Like the custom of the people of Noah and of 'Aad and Thamud and those after them. And Allah wants no injustice for [His] servants",
    normalizedText:
      "مثل داب قوم نوح وعاد وثمود والذين من بعدهم وما الله يريد ظلما للعباد",
  },
  {
    verseId: 31,
    name: "غافر",
    surahId: 40,
    text: "وَيَٰقَوۡمِ إِنِّيٓ أَخَافُ عَلَيۡكُمۡ يَوۡمَ ٱلتَّنَادِ",
    translation: "And O my people, indeed I fear for you the Day of Calling",
    normalizedText: "ويقوم اني اخاف عليكم يوم التناد",
  },
  {
    verseId: 32,
    name: "غافر",
    surahId: 40,
    text: "يَوۡمَ تُوَلُّونَ مُدۡبِرِينَ مَا لَكُم مِّنَ ٱللَّهِ مِنۡ عَاصِمٖۗ وَمَن يُضۡلِلِ ٱللَّهُ فَمَا لَهُۥ مِنۡ هَادٖ",
    translation:
      "The Day you will turn your backs fleeing; there is not for you from Allah any protector. And whoever Allah leaves astray - there is not for him any guide",
    normalizedText:
      "يوم تولون مدبرين ما لكم من الله من عاصم ومن يضلل الله فما له من هاد",
  },
  {
    verseId: 33,
    name: "غافر",
    surahId: 40,
    text: "وَلَقَدۡ جَآءَكُمۡ يُوسُفُ مِن قَبۡلُ بِٱلۡبَيِّنَٰتِ فَمَا زِلۡتُمۡ فِي شَكّٖ مِّمَّا جَآءَكُم بِهِۦۖ حَتَّىٰٓ إِذَا هَلَكَ قُلۡتُمۡ لَن يَبۡعَثَ ٱللَّهُ مِنۢ بَعۡدِهِۦ رَسُولٗاۚ كَذَٰلِكَ يُضِلُّ ٱللَّهُ مَنۡ هُوَ مُسۡرِفٞ مُّرۡتَابٌ",
    translation:
      "And Joseph had already come to you before with clear proofs, but you remained in doubt of that which he brought to you, until when he died, you said, 'Never will Allah send a messenger after him.' Thus does Allah leave astray he who is a transgressor and skeptic",
    normalizedText:
      "ولقد جاءكم يوسف من قبل بالبينت فما زلتم في شك مما جاءكم به حتى اذا هلك قلتم لن يبعث الله من بعده رسولا كذلك يضل الله من هو مسرف مرتاب",
  },
  {
    verseId: 34,
    name: "غافر",
    surahId: 40,
    text: "ٱلَّذِينَ يُجَٰدِلُونَ فِيٓ ءَايَٰتِ ٱللَّهِ بِغَيۡرِ سُلۡطَٰنٍ أَتَىٰهُمۡۖ كَبُرَ مَقۡتًا عِندَ ٱللَّهِ وَعِندَ ٱلَّذِينَ ءَامَنُواْۚ كَذَٰلِكَ يَطۡبَعُ ٱللَّهُ عَلَىٰ كُلِّ قَلۡبِ مُتَكَبِّرٖ جَبَّارٖ",
    translation:
      "Those who dispute concerning the signs of Allah without an authority having come to them - great is hatred [of them] in the sight of Allah and in the sight of those who have believed. Thus does Allah seal over every heart [belonging to] an arrogant tyrant",
    normalizedText:
      "الذين يجدلون في ءايت الله بغير سلطن اتىهم كبر مقتا عند الله وعند الذين ءامنوا كذلك يطبع الله على كل قلب متكبر جبار",
  },
  {
    verseId: 35,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ فِرۡعَوۡنُ يَٰهَٰمَٰنُ ٱبۡنِ لِي صَرۡحٗا لَّعَلِّيٓ أَبۡلُغُ ٱلۡأَسۡبَٰبَ",
    translation:
      'And Pharaoh said, "O Haman, construct for me a tower that I might reach the ways',
    normalizedText: "وقال فرعون يهمن ابن لي صرحا لعلي ابلغ الاسبب",
  },
  {
    verseId: 36,
    name: "غافر",
    surahId: 40,
    text: "أَسۡبَٰبَ ٱلسَّمَٰوَٰتِ فَأَطَّلِعَ إِلَىٰٓ إِلَٰهِ مُوسَىٰ وَإِنِّي لَأَظُنُّهُۥ كَٰذِبٗاۚ وَكَذَٰلِكَ زُيِّنَ لِفِرۡعَوۡنَ سُوٓءُ عَمَلِهِۦ وَصُدَّ عَنِ ٱلسَّبِيلِۚ وَمَا كَيۡدُ فِرۡعَوۡنَ إِلَّا فِي تَبَابٖ",
    translation:
      'The ways into the heavens - so that I may look at the deity of Moses; but indeed, I think he is a liar." And thus was made attractive to Pharaoh the evil of his deed, and he was averted from the [right] way. And the plan of Pharaoh was not except in ruin',
    normalizedText:
      "اسبب السموت فاطلع الى اله موسى واني لاظنه كذبا وكذلك زين لفرعون سوء عمله وصد عن السبيل وما كيد فرعون الا في تباب",
  },
  {
    verseId: 37,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ ٱلَّذِيٓ ءَامَنَ يَٰقَوۡمِ ٱتَّبِعُونِ أَهۡدِكُمۡ سَبِيلَ ٱلرَّشَادِ",
    translation:
      'And he who believed said, "O my people, follow me, I will guide you to the way of right conduct',
    normalizedText: "وقال الذي ءامن يقوم اتبعون اهدكم سبيل الرشاد",
  },
  {
    verseId: 38,
    name: "غافر",
    surahId: 40,
    text: "يَٰقَوۡمِ إِنَّمَا هَٰذِهِ ٱلۡحَيَوٰةُ ٱلدُّنۡيَا مَتَٰعٞ وَإِنَّ ٱلۡأٓخِرَةَ هِيَ دَارُ ٱلۡقَرَارِ",
    translation:
      "O my people, this worldly life is only [temporary] enjoyment, and indeed, the Hereafter - that is the home of [permanent] settlement",
    normalizedText: "يقوم انما هذه الحيوة الدنيا متع وان الاخرة هي دار القرار",
  },
  {
    verseId: 39,
    name: "غافر",
    surahId: 40,
    text: "مَنۡ عَمِلَ سَيِّئَةٗ فَلَا يُجۡزَىٰٓ إِلَّا مِثۡلَهَاۖ وَمَنۡ عَمِلَ صَٰلِحٗا مِّن ذَكَرٍ أَوۡ أُنثَىٰ وَهُوَ مُؤۡمِنٞ فَأُوْلَـٰٓئِكَ يَدۡخُلُونَ ٱلۡجَنَّةَ يُرۡزَقُونَ فِيهَا بِغَيۡرِ حِسَابٖ",
    translation:
      "Whoever does an evil deed will not be recompensed except by the like thereof; but whoever does righteousness, whether male or female, while he is a believer - those will enter Paradise, being given provision therein without account",
    normalizedText:
      "من عمل سياة فلا يجزى الا مثلها ومن عمل صلحا من ذكر او انثى وهو مامن فاولاك يدخلون الجنة يرزقون فيها بغير حساب",
  },
  {
    verseId: 40,
    name: "غافر",
    surahId: 40,
    text: "۞وَيَٰقَوۡمِ مَا لِيٓ أَدۡعُوكُمۡ إِلَى ٱلنَّجَوٰةِ وَتَدۡعُونَنِيٓ إِلَى ٱلنَّارِ",
    translation:
      "And O my people, how is it that I invite you to salvation while you invite me to the Fire",
    normalizedText: "۞ويقوم ما لي ادعوكم الى النجوة وتدعونني الى النار",
  },
  {
    verseId: 41,
    name: "غافر",
    surahId: 40,
    text: "تَدۡعُونَنِي لِأَكۡفُرَ بِٱللَّهِ وَأُشۡرِكَ بِهِۦ مَا لَيۡسَ لِي بِهِۦ عِلۡمٞ وَأَنَا۠ أَدۡعُوكُمۡ إِلَى ٱلۡعَزِيزِ ٱلۡغَفَّـٰرِ",
    translation:
      "You invite me to disbelieve in Allah and associate with Him that of which I have no knowledge, and I invite you to the Exalted in Might, the Perpetual Forgiver",
    normalizedText:
      "تدعونني لاكفر بالله واشرك به ما ليس لي به علم وانا ادعوكم الى العزيز الغفر",
  },
  {
    verseId: 42,
    name: "غافر",
    surahId: 40,
    text: "لَا جَرَمَ أَنَّمَا تَدۡعُونَنِيٓ إِلَيۡهِ لَيۡسَ لَهُۥ دَعۡوَةٞ فِي ٱلدُّنۡيَا وَلَا فِي ٱلۡأٓخِرَةِ وَأَنَّ مَرَدَّنَآ إِلَى ٱللَّهِ وَأَنَّ ٱلۡمُسۡرِفِينَ هُمۡ أَصۡحَٰبُ ٱلنَّارِ",
    translation:
      "Assuredly, that to which you invite me has no [response to a] supplication in this world or in the Hereafter; and indeed, our return is to Allah, and indeed, the transgressors will be companions of the Fire",
    normalizedText:
      "لا جرم انما تدعونني اليه ليس له دعوة في الدنيا ولا في الاخرة وان مردنا الى الله وان المسرفين هم اصحب النار",
  },
  {
    verseId: 43,
    name: "غافر",
    surahId: 40,
    text: "فَسَتَذۡكُرُونَ مَآ أَقُولُ لَكُمۡۚ وَأُفَوِّضُ أَمۡرِيٓ إِلَى ٱللَّهِۚ إِنَّ ٱللَّهَ بَصِيرُۢ بِٱلۡعِبَادِ",
    translation:
      "And you will remember what I [now] say to you, and I entrust my affair to Allah. Indeed, Allah is Seeing of [His] servants",
    normalizedText:
      "فستذكرون ما اقول لكم وافوض امري الى الله ان الله بصير بالعباد",
  },
  {
    verseId: 44,
    name: "غافر",
    surahId: 40,
    text: "فَوَقَىٰهُ ٱللَّهُ سَيِّـَٔاتِ مَا مَكَرُواْۖ وَحَاقَ بِـَٔالِ فِرۡعَوۡنَ سُوٓءُ ٱلۡعَذَابِ",
    translation:
      "So Allah protected him from the evils they plotted, and the people of Pharaoh were enveloped by the worst of punishment",
    normalizedText: "فوقىه الله سيات ما مكروا وحاق بال فرعون سوء العذاب",
  },
  {
    verseId: 45,
    name: "غافر",
    surahId: 40,
    text: "ٱلنَّارُ يُعۡرَضُونَ عَلَيۡهَا غُدُوّٗا وَعَشِيّٗاۚ وَيَوۡمَ تَقُومُ ٱلسَّاعَةُ أَدۡخِلُوٓاْ ءَالَ فِرۡعَوۡنَ أَشَدَّ ٱلۡعَذَابِ",
    translation:
      'The Fire, they are exposed to it morning and evening. And the Day the Hour appears [it will be said], "Make the people of Pharaoh enter the severest punishment',
    normalizedText:
      "النار يعرضون عليها غدوا وعشيا ويوم تقوم الساعة ادخلوا ءال فرعون اشد العذاب",
  },
  {
    verseId: 46,
    name: "غافر",
    surahId: 40,
    text: "وَإِذۡ يَتَحَآجُّونَ فِي ٱلنَّارِ فَيَقُولُ ٱلضُّعَفَـٰٓؤُاْ لِلَّذِينَ ٱسۡتَكۡبَرُوٓاْ إِنَّا كُنَّا لَكُمۡ تَبَعٗا فَهَلۡ أَنتُم مُّغۡنُونَ عَنَّا نَصِيبٗا مِّنَ ٱلنَّارِ",
    translation:
      'And [mention] when they will argue within the Fire, and the weak will say to those who had been arrogant, "Indeed, we were [only] your followers, so will you relieve us of a share of the Fire',
    normalizedText:
      "واذ يتحاجون في النار فيقول الضعفاا للذين استكبروا انا كنا لكم تبعا فهل انتم مغنون عنا نصيبا من النار",
  },
  {
    verseId: 47,
    name: "غافر",
    surahId: 40,
    text: "قَالَ ٱلَّذِينَ ٱسۡتَكۡبَرُوٓاْ إِنَّا كُلّٞ فِيهَآ إِنَّ ٱللَّهَ قَدۡ حَكَمَ بَيۡنَ ٱلۡعِبَادِ",
    translation:
      'Those who had been arrogant will say, "Indeed, all [of us] are in it. Indeed, Allah has judged between the servants',
    normalizedText: "قال الذين استكبروا انا كل فيها ان الله قد حكم بين العباد",
  },
  {
    verseId: 48,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ ٱلَّذِينَ فِي ٱلنَّارِ لِخَزَنَةِ جَهَنَّمَ ٱدۡعُواْ رَبَّكُمۡ يُخَفِّفۡ عَنَّا يَوۡمٗا مِّنَ ٱلۡعَذَابِ",
    translation:
      'And those in the Fire will say to the keepers of Hell, "Supplicate your Lord to lighten for us a day from the punishment',
    normalizedText:
      "وقال الذين في النار لخزنة جهنم ادعوا ربكم يخفف عنا يوما من العذاب",
  },
  {
    verseId: 49,
    name: "غافر",
    surahId: 40,
    text: "قَالُوٓاْ أَوَلَمۡ تَكُ تَأۡتِيكُمۡ رُسُلُكُم بِٱلۡبَيِّنَٰتِۖ قَالُواْ بَلَىٰۚ قَالُواْ فَٱدۡعُواْۗ وَمَا دُعَـٰٓؤُاْ ٱلۡكَٰفِرِينَ إِلَّا فِي ضَلَٰلٍ",
    translation:
      'They will say, "Did there not come to you your messengers with clear proofs?" They will say, "Yes." They will reply, "Then supplicate [yourselves], but the supplication of the disbelievers is not except in error',
    normalizedText:
      "قالوا اولم تك تاتيكم رسلكم بالبينت قالوا بلى قالوا فادعوا وما دعاا الكفرين الا في ضلل",
  },
  {
    verseId: 50,
    name: "غافر",
    surahId: 40,
    text: "إِنَّا لَنَنصُرُ رُسُلَنَا وَٱلَّذِينَ ءَامَنُواْ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَيَوۡمَ يَقُومُ ٱلۡأَشۡهَٰدُ",
    translation:
      "Indeed, We will support Our messengers and those who believe during the life of this world and on the Day when the witnesses will stand",
    normalizedText:
      "انا لننصر رسلنا والذين ءامنوا في الحيوة الدنيا ويوم يقوم الاشهد",
  },
  {
    verseId: 51,
    name: "غافر",
    surahId: 40,
    text: "يَوۡمَ لَا يَنفَعُ ٱلظَّـٰلِمِينَ مَعۡذِرَتُهُمۡۖ وَلَهُمُ ٱللَّعۡنَةُ وَلَهُمۡ سُوٓءُ ٱلدَّارِ",
    translation:
      "The Day their excuse will not benefit the wrongdoers, and they will have the curse, and they will have the worst home",
    normalizedText: "يوم لا ينفع الظلمين معذرتهم ولهم اللعنة ولهم سوء الدار",
  },
  {
    verseId: 52,
    name: "غافر",
    surahId: 40,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡهُدَىٰ وَأَوۡرَثۡنَا بَنِيٓ إِسۡرَـٰٓءِيلَ ٱلۡكِتَٰبَ",
    translation:
      "And We had certainly given Moses guidance, and We caused the Children of Israel to inherit the Scripture",
    normalizedText: "ولقد ءاتينا موسى الهدى واورثنا بني اسرءيل الكتب",
  },
  {
    verseId: 53,
    name: "غافر",
    surahId: 40,
    text: "هُدٗى وَذِكۡرَىٰ لِأُوْلِي ٱلۡأَلۡبَٰبِ",
    translation: "As guidance and a reminder for those of understanding",
    normalizedText: "هدى وذكرى لاولي الالبب",
  },
  {
    verseId: 54,
    name: "غافر",
    surahId: 40,
    text: "فَٱصۡبِرۡ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞ وَٱسۡتَغۡفِرۡ لِذَنۢبِكَ وَسَبِّحۡ بِحَمۡدِ رَبِّكَ بِٱلۡعَشِيِّ وَٱلۡإِبۡكَٰرِ",
    translation:
      "So be patient, [O Muhammad]. Indeed, the promise of Allah is truth. And ask forgiveness for your sin and exalt [Allah] with praise of your Lord in the evening and the morning",
    normalizedText:
      "فاصبر ان وعد الله حق واستغفر لذنبك وسبح بحمد ربك بالعشي والابكر",
  },
  {
    verseId: 55,
    name: "غافر",
    surahId: 40,
    text: "إِنَّ ٱلَّذِينَ يُجَٰدِلُونَ فِيٓ ءَايَٰتِ ٱللَّهِ بِغَيۡرِ سُلۡطَٰنٍ أَتَىٰهُمۡ إِن فِي صُدُورِهِمۡ إِلَّا كِبۡرٞ مَّا هُم بِبَٰلِغِيهِۚ فَٱسۡتَعِذۡ بِٱللَّهِۖ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلۡبَصِيرُ",
    translation:
      "Indeed, those who dispute concerning the signs of Allah without [any] authority having come to them - there is not within their breasts except pride, [the extent of] which they cannot reach. So seek refuge in Allah. Indeed, it is He who is the Hearing, the Seeing",
    normalizedText:
      "ان الذين يجدلون في ءايت الله بغير سلطن اتىهم ان في صدورهم الا كبر ما هم ببلغيه فاستعذ بالله انه هو السميع البصير",
  },
  {
    verseId: 56,
    name: "غافر",
    surahId: 40,
    text: "لَخَلۡقُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ أَكۡبَرُ مِنۡ خَلۡقِ ٱلنَّاسِ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      "The creation of the heavens and earth is greater than the creation of mankind, but most of the people do not know",
    normalizedText:
      "لخلق السموت والارض اكبر من خلق الناس ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 57,
    name: "غافر",
    surahId: 40,
    text: "وَمَا يَسۡتَوِي ٱلۡأَعۡمَىٰ وَٱلۡبَصِيرُ وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَلَا ٱلۡمُسِيٓءُۚ قَلِيلٗا مَّا تَتَذَكَّرُونَ",
    translation:
      "And not equal are the blind and the seeing, nor are those who believe and do righteous deeds and the evildoer. Little do you remember",
    normalizedText:
      "وما يستوي الاعمى والبصير والذين ءامنوا وعملوا الصلحت ولا المسيء قليلا ما تتذكرون",
  },
  {
    verseId: 58,
    name: "غافر",
    surahId: 40,
    text: "إِنَّ ٱلسَّاعَةَ لَأٓتِيَةٞ لَّا رَيۡبَ فِيهَا وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يُؤۡمِنُونَ",
    translation:
      "Indeed, the Hour is coming - no doubt about it - but most of the people do not believe",
    normalizedText: "ان الساعة لاتية لا ريب فيها ولكن اكثر الناس لا يامنون",
  },
  {
    verseId: 59,
    name: "غافر",
    surahId: 40,
    text: "وَقَالَ رَبُّكُمُ ٱدۡعُونِيٓ أَسۡتَجِبۡ لَكُمۡۚ إِنَّ ٱلَّذِينَ يَسۡتَكۡبِرُونَ عَنۡ عِبَادَتِي سَيَدۡخُلُونَ جَهَنَّمَ دَاخِرِينَ",
    translation:
      'And your Lord says, "Call upon Me; I will respond to you." Indeed, those who disdain My worship will enter Hell [rendered] contemptible',
    normalizedText:
      "وقال ربكم ادعوني استجب لكم ان الذين يستكبرون عن عبادتي سيدخلون جهنم داخرين",
  },
  {
    verseId: 60,
    name: "غافر",
    surahId: 40,
    text: "ٱللَّهُ ٱلَّذِي جَعَلَ لَكُمُ ٱلَّيۡلَ لِتَسۡكُنُواْ فِيهِ وَٱلنَّهَارَ مُبۡصِرًاۚ إِنَّ ٱللَّهَ لَذُو فَضۡلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَشۡكُرُونَ",
    translation:
      "It is Allah who made for you the night that you may rest therein and the day giving sight. Indeed, Allah is full of bounty to the people, but most of the people are not grateful",
    normalizedText:
      "الله الذي جعل لكم اليل لتسكنوا فيه والنهار مبصرا ان الله لذو فضل على الناس ولكن اكثر الناس لا يشكرون",
  },
  {
    verseId: 61,
    name: "غافر",
    surahId: 40,
    text: "ذَٰلِكُمُ ٱللَّهُ رَبُّكُمۡ خَٰلِقُ كُلِّ شَيۡءٖ لَّآ إِلَٰهَ إِلَّا هُوَۖ فَأَنَّىٰ تُؤۡفَكُونَ",
    translation:
      "That is Allah, your Lord, Creator of all things; there is no deity except Him, so how are you deluded",
    normalizedText: "ذلكم الله ربكم خلق كل شيء لا اله الا هو فانى تافكون",
  },
  {
    verseId: 62,
    name: "غافر",
    surahId: 40,
    text: "كَذَٰلِكَ يُؤۡفَكُ ٱلَّذِينَ كَانُواْ بِـَٔايَٰتِ ٱللَّهِ يَجۡحَدُونَ",
    translation:
      "Thus were those [before you] deluded who were rejecting the signs of Allah",
    normalizedText: "كذلك يافك الذين كانوا بايت الله يجحدون",
  },
  {
    verseId: 63,
    name: "غافر",
    surahId: 40,
    text: "ٱللَّهُ ٱلَّذِي جَعَلَ لَكُمُ ٱلۡأَرۡضَ قَرَارٗا وَٱلسَّمَآءَ بِنَآءٗ وَصَوَّرَكُمۡ فَأَحۡسَنَ صُوَرَكُمۡ وَرَزَقَكُم مِّنَ ٱلطَّيِّبَٰتِۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمۡۖ فَتَبَارَكَ ٱللَّهُ رَبُّ ٱلۡعَٰلَمِينَ",
    translation:
      "It is Allah who made for you the earth a place of settlement and the sky a ceiling and formed you and perfected your forms and provided you with good things. That is Allah, your Lord; then blessed is Allah, Lord of the worlds",
    normalizedText:
      "الله الذي جعل لكم الارض قرارا والسماء بناء وصوركم فاحسن صوركم ورزقكم من الطيبت ذلكم الله ربكم فتبارك الله رب العلمين",
  },
  {
    verseId: 64,
    name: "غافر",
    surahId: 40,
    text: "هُوَ ٱلۡحَيُّ لَآ إِلَٰهَ إِلَّا هُوَ فَٱدۡعُوهُ مُخۡلِصِينَ لَهُ ٱلدِّينَۗ ٱلۡحَمۡدُ لِلَّهِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "He is the Ever-Living; there is no deity except Him, so call upon Him, [being] sincere to Him in religion. [All] praise is [due] to Allah, Lord of the worlds",
    normalizedText:
      "هو الحي لا اله الا هو فادعوه مخلصين له الدين الحمد لله رب العلمين",
  },
  {
    verseId: 65,
    name: "غافر",
    surahId: 40,
    text: "۞قُلۡ إِنِّي نُهِيتُ أَنۡ أَعۡبُدَ ٱلَّذِينَ تَدۡعُونَ مِن دُونِ ٱللَّهِ لَمَّا جَآءَنِيَ ٱلۡبَيِّنَٰتُ مِن رَّبِّي وَأُمِرۡتُ أَنۡ أُسۡلِمَ لِرَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'Say, [O Muhammad], "Indeed, I have been forbidden to worship those you call upon besides Allah once the clear proofs have come to me from my Lord, and I have been commanded to submit to the Lord of the worlds',
    normalizedText:
      "۞قل اني نهيت ان اعبد الذين تدعون من دون الله لما جاءني البينت من ربي وامرت ان اسلم لرب العلمين",
  },
  {
    verseId: 66,
    name: "غافر",
    surahId: 40,
    text: "هُوَ ٱلَّذِي خَلَقَكُم مِّن تُرَابٖ ثُمَّ مِن نُّطۡفَةٖ ثُمَّ مِنۡ عَلَقَةٖ ثُمَّ يُخۡرِجُكُمۡ طِفۡلٗا ثُمَّ لِتَبۡلُغُوٓاْ أَشُدَّكُمۡ ثُمَّ لِتَكُونُواْ شُيُوخٗاۚ وَمِنكُم مَّن يُتَوَفَّىٰ مِن قَبۡلُۖ وَلِتَبۡلُغُوٓاْ أَجَلٗا مُّسَمّٗى وَلَعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      "It is He who created you from dust, then from a sperm-drop, then from a clinging clot; then He brings you out as a child; then [He develops you] that you reach your [time of] maturity, then [further] that you become elders. And among you is he who is taken in death before [that], so that you reach a specified term; and perhaps you will use reason",
    normalizedText:
      "هو الذي خلقكم من تراب ثم من نطفة ثم من علقة ثم يخرجكم طفلا ثم لتبلغوا اشدكم ثم لتكونوا شيوخا ومنكم من يتوفى من قبل ولتبلغوا اجلا مسمى ولعلكم تعقلون",
  },
  {
    verseId: 67,
    name: "غافر",
    surahId: 40,
    text: "هُوَ ٱلَّذِي يُحۡيِۦ وَيُمِيتُۖ فَإِذَا قَضَىٰٓ أَمۡرٗا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ",
    translation:
      'He it is who gives life and causes death; and when He decrees a matter, He but says to it, "Be," and it is',
    normalizedText: "هو الذي يحي ويميت فاذا قضى امرا فانما يقول له كن فيكون",
  },
  {
    verseId: 68,
    name: "غافر",
    surahId: 40,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ يُجَٰدِلُونَ فِيٓ ءَايَٰتِ ٱللَّهِ أَنَّىٰ يُصۡرَفُونَ",
    translation:
      "Do you not consider those who dispute concerning the signs of Allah - how are they averted",
    normalizedText: "الم تر الى الذين يجدلون في ءايت الله انى يصرفون",
  },
  {
    verseId: 69,
    name: "غافر",
    surahId: 40,
    text: "ٱلَّذِينَ كَذَّبُواْ بِٱلۡكِتَٰبِ وَبِمَآ أَرۡسَلۡنَا بِهِۦ رُسُلَنَاۖ فَسَوۡفَ يَعۡلَمُونَ",
    translation:
      "Those who deny the Book and that with which We sent Our messengers - they are going to know",
    normalizedText: "الذين كذبوا بالكتب وبما ارسلنا به رسلنا فسوف يعلمون",
  },
  {
    verseId: 70,
    name: "غافر",
    surahId: 40,
    text: "إِذِ ٱلۡأَغۡلَٰلُ فِيٓ أَعۡنَٰقِهِمۡ وَٱلسَّلَٰسِلُ يُسۡحَبُونَ",
    translation:
      "When the shackles are around their necks and the chains; they will be dragged",
    normalizedText: "اذ الاغلل في اعنقهم والسلسل يسحبون",
  },
  {
    verseId: 71,
    name: "غافر",
    surahId: 40,
    text: "فِي ٱلۡحَمِيمِ ثُمَّ فِي ٱلنَّارِ يُسۡجَرُونَ",
    translation:
      "In boiling water; then in the Fire they will be filled [with flame]",
    normalizedText: "في الحميم ثم في النار يسجرون",
  },
  {
    verseId: 72,
    name: "غافر",
    surahId: 40,
    text: "ثُمَّ قِيلَ لَهُمۡ أَيۡنَ مَا كُنتُمۡ تُشۡرِكُونَ",
    translation:
      'Then it will be said to them, "Where is that which you used to associate [with Him in worship]',
    normalizedText: "ثم قيل لهم اين ما كنتم تشركون",
  },
  {
    verseId: 73,
    name: "غافر",
    surahId: 40,
    text: "مِن دُونِ ٱللَّهِۖ قَالُواْ ضَلُّواْ عَنَّا بَل لَّمۡ نَكُن نَّدۡعُواْ مِن قَبۡلُ شَيۡـٔٗاۚ كَذَٰلِكَ يُضِلُّ ٱللَّهُ ٱلۡكَٰفِرِينَ",
    translation:
      'Other than Allah?" They will say, "They have departed from us; rather, we did not used to invoke previously anything." Thus does Allah put astray the disbelievers',
    normalizedText:
      "من دون الله قالوا ضلوا عنا بل لم نكن ندعوا من قبل شيا كذلك يضل الله الكفرين",
  },
  {
    verseId: 74,
    name: "غافر",
    surahId: 40,
    text: "ذَٰلِكُم بِمَا كُنتُمۡ تَفۡرَحُونَ فِي ٱلۡأَرۡضِ بِغَيۡرِ ٱلۡحَقِّ وَبِمَا كُنتُمۡ تَمۡرَحُونَ",
    translation:
      '[The angels will say], "That was because you used to exult upon the earth without right and you used to behave insolently',
    normalizedText: "ذلكم بما كنتم تفرحون في الارض بغير الحق وبما كنتم تمرحون",
  },
  {
    verseId: 75,
    name: "غافر",
    surahId: 40,
    text: "ٱدۡخُلُوٓاْ أَبۡوَٰبَ جَهَنَّمَ خَٰلِدِينَ فِيهَاۖ فَبِئۡسَ مَثۡوَى ٱلۡمُتَكَبِّرِينَ",
    translation:
      "Enter the gates of Hell to abide eternally therein, and wretched is the residence of the arrogant",
    normalizedText: "ادخلوا ابوب جهنم خلدين فيها فباس مثوى المتكبرين",
  },
  {
    verseId: 76,
    name: "غافر",
    surahId: 40,
    text: "فَٱصۡبِرۡ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞۚ فَإِمَّا نُرِيَنَّكَ بَعۡضَ ٱلَّذِي نَعِدُهُمۡ أَوۡ نَتَوَفَّيَنَّكَ فَإِلَيۡنَا يُرۡجَعُونَ",
    translation:
      "So be patient, [O Muhammad]; indeed, the promise of Allah is truth. And whether We show you some of what We have promised them or We take you in death, it is to Us they will be returned",
    normalizedText:
      "فاصبر ان وعد الله حق فاما نرينك بعض الذي نعدهم او نتوفينك فالينا يرجعون",
  },
  {
    verseId: 77,
    name: "غافر",
    surahId: 40,
    text: "وَلَقَدۡ أَرۡسَلۡنَا رُسُلٗا مِّن قَبۡلِكَ مِنۡهُم مَّن قَصَصۡنَا عَلَيۡكَ وَمِنۡهُم مَّن لَّمۡ نَقۡصُصۡ عَلَيۡكَۗ وَمَا كَانَ لِرَسُولٍ أَن يَأۡتِيَ بِـَٔايَةٍ إِلَّا بِإِذۡنِ ٱللَّهِۚ فَإِذَا جَآءَ أَمۡرُ ٱللَّهِ قُضِيَ بِٱلۡحَقِّ وَخَسِرَ هُنَالِكَ ٱلۡمُبۡطِلُونَ",
    translation:
      "And We have already sent messengers before you. Among them are those [whose stories] We have related to you, and among them are those [whose stories] We have not related to you. And it was not for any messenger to bring a sign [or verse] except by permission of Allah. So when the command of Allah comes, it will be concluded in truth, and the falsifiers will thereupon lose [all]",
    normalizedText:
      "ولقد ارسلنا رسلا من قبلك منهم من قصصنا عليك ومنهم من لم نقصص عليك وما كان لرسول ان ياتي باية الا باذن الله فاذا جاء امر الله قضي بالحق وخسر هنالك المبطلون",
  },
  {
    verseId: 78,
    name: "غافر",
    surahId: 40,
    text: "ٱللَّهُ ٱلَّذِي جَعَلَ لَكُمُ ٱلۡأَنۡعَٰمَ لِتَرۡكَبُواْ مِنۡهَا وَمِنۡهَا تَأۡكُلُونَ",
    translation:
      "It is Allah who made for you the grazing animals upon which you ride, and some of them you eat",
    normalizedText: "الله الذي جعل لكم الانعم لتركبوا منها ومنها تاكلون",
  },
  {
    verseId: 79,
    name: "غافر",
    surahId: 40,
    text: "وَلَكُمۡ فِيهَا مَنَٰفِعُ وَلِتَبۡلُغُواْ عَلَيۡهَا حَاجَةٗ فِي صُدُورِكُمۡ وَعَلَيۡهَا وَعَلَى ٱلۡفُلۡكِ تُحۡمَلُونَ",
    translation:
      "And for you therein are [other] benefits and that you may realize upon them a need which is in your breasts; and upon them and upon ships you are carried",
    normalizedText:
      "ولكم فيها منفع ولتبلغوا عليها حاجة في صدوركم وعليها وعلى الفلك تحملون",
  },
  {
    verseId: 80,
    name: "غافر",
    surahId: 40,
    text: "وَيُرِيكُمۡ ءَايَٰتِهِۦ فَأَيَّ ءَايَٰتِ ٱللَّهِ تُنكِرُونَ",
    translation:
      "And He shows you His signs. So which of the signs of Allah do you deny",
    normalizedText: "ويريكم ءايته فاي ءايت الله تنكرون",
  },
  {
    verseId: 81,
    name: "غافر",
    surahId: 40,
    text: "أَفَلَمۡ يَسِيرُواْ فِي ٱلۡأَرۡضِ فَيَنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبۡلِهِمۡۚ كَانُوٓاْ أَكۡثَرَ مِنۡهُمۡ وَأَشَدَّ قُوَّةٗ وَءَاثَارٗا فِي ٱلۡأَرۡضِ فَمَآ أَغۡنَىٰ عَنۡهُم مَّا كَانُواْ يَكۡسِبُونَ",
    translation:
      "Have they not traveled through the land and observed how was the end of those before them? They were more numerous than themselves and greater in strength and in impression on the land, but they were not availed by what they used to earn",
    normalizedText:
      "افلم يسيروا في الارض فينظروا كيف كان عقبة الذين من قبلهم كانوا اكثر منهم واشد قوة وءاثارا في الارض فما اغنى عنهم ما كانوا يكسبون",
  },
  {
    verseId: 82,
    name: "غافر",
    surahId: 40,
    text: "فَلَمَّا جَآءَتۡهُمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِ فَرِحُواْ بِمَا عِندَهُم مِّنَ ٱلۡعِلۡمِ وَحَاقَ بِهِم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "And when their messengers came to them with clear proofs, they [merely] rejoiced in what they had of knowledge, but they were enveloped by what they used to ridicule",
    normalizedText:
      "فلما جاءتهم رسلهم بالبينت فرحوا بما عندهم من العلم وحاق بهم ما كانوا به يستهزءون",
  },
  {
    verseId: 83,
    name: "غافر",
    surahId: 40,
    text: "فَلَمَّا رَأَوۡاْ بَأۡسَنَا قَالُوٓاْ ءَامَنَّا بِٱللَّهِ وَحۡدَهُۥ وَكَفَرۡنَا بِمَا كُنَّا بِهِۦ مُشۡرِكِينَ",
    translation:
      'And when they saw Our punishment, they said," We believe in Allah alone and disbelieve in that which we used to associate with Him',
    normalizedText:
      "فلما راوا باسنا قالوا ءامنا بالله وحده وكفرنا بما كنا به مشركين",
  },
  {
    verseId: 84,
    name: "غافر",
    surahId: 40,
    text: "فَلَمۡ يَكُ يَنفَعُهُمۡ إِيمَٰنُهُمۡ لَمَّا رَأَوۡاْ بَأۡسَنَاۖ سُنَّتَ ٱللَّهِ ٱلَّتِي قَدۡ خَلَتۡ فِي عِبَادِهِۦۖ وَخَسِرَ هُنَالِكَ ٱلۡكَٰفِرُونَ",
    translation:
      "But never did their faith benefit them once they saw Our punishment. [It is] the established way of Allah which has preceded among His servants. And the disbelievers thereupon lost [all]",
    normalizedText:
      "فلم يك ينفعهم ايمنهم لما راوا باسنا سنت الله التي قد خلت في عباده وخسر هنالك الكفرون",
  },
  {
    verseId: 0,
    name: "فصلت",
    surahId: 41,
    text: "حمٓ",
    translation: "Ha, Meem",
    normalizedText: "حم",
  },
  {
    verseId: 1,
    name: "فصلت",
    surahId: 41,
    text: "تَنزِيلٞ مِّنَ ٱلرَّحۡمَٰنِ ٱلرَّحِيمِ",
    translation:
      "[This is] a revelation from the Entirely Merciful, the Especially Merciful",
    normalizedText: "تنزيل من الرحمن الرحيم",
  },
  {
    verseId: 2,
    name: "فصلت",
    surahId: 41,
    text: "كِتَٰبٞ فُصِّلَتۡ ءَايَٰتُهُۥ قُرۡءَانًا عَرَبِيّٗا لِّقَوۡمٖ يَعۡلَمُونَ",
    translation:
      "A Book whose verses have been detailed, an Arabic Qur'an for a people who know",
    normalizedText: "كتب فصلت ءايته قرءانا عربيا لقوم يعلمون",
  },
  {
    verseId: 3,
    name: "فصلت",
    surahId: 41,
    text: "بَشِيرٗا وَنَذِيرٗا فَأَعۡرَضَ أَكۡثَرُهُمۡ فَهُمۡ لَا يَسۡمَعُونَ",
    translation:
      "As a giver of good tidings and a warner; but most of them turn away, so they do not hear",
    normalizedText: "بشيرا ونذيرا فاعرض اكثرهم فهم لا يسمعون",
  },
  {
    verseId: 4,
    name: "فصلت",
    surahId: 41,
    text: "وَقَالُواْ قُلُوبُنَا فِيٓ أَكِنَّةٖ مِّمَّا تَدۡعُونَآ إِلَيۡهِ وَفِيٓ ءَاذَانِنَا وَقۡرٞ وَمِنۢ بَيۡنِنَا وَبَيۡنِكَ حِجَابٞ فَٱعۡمَلۡ إِنَّنَا عَٰمِلُونَ",
    translation:
      'And they say, "Our hearts are within coverings from that to which you invite us, and in our ears is deafness, and between us and you is a partition, so work; indeed, we are working',
    normalizedText:
      "وقالوا قلوبنا في اكنة مما تدعونا اليه وفي ءاذاننا وقر ومن بيننا وبينك حجاب فاعمل اننا عملون",
  },
  {
    verseId: 5,
    name: "فصلت",
    surahId: 41,
    text: "قُلۡ إِنَّمَآ أَنَا۠ بَشَرٞ مِّثۡلُكُمۡ يُوحَىٰٓ إِلَيَّ أَنَّمَآ إِلَٰهُكُمۡ إِلَٰهٞ وَٰحِدٞ فَٱسۡتَقِيمُوٓاْ إِلَيۡهِ وَٱسۡتَغۡفِرُوهُۗ وَوَيۡلٞ لِّلۡمُشۡرِكِينَ",
    translation:
      'Say, O [Muhammad], "I am only a man like you to whom it has been revealed that your god is but one God; so take a straight course to Him and seek His forgiveness." And woe to those who associate others with Allah',
    normalizedText:
      "قل انما انا بشر مثلكم يوحى الي انما الهكم اله وحد فاستقيموا اليه واستغفروه وويل للمشركين",
  },
  {
    verseId: 6,
    name: "فصلت",
    surahId: 41,
    text: "ٱلَّذِينَ لَا يُؤۡتُونَ ٱلزَّكَوٰةَ وَهُم بِٱلۡأٓخِرَةِ هُمۡ كَٰفِرُونَ",
    translation:
      "Those who do not give zakah, and in the Hereafter they are disbelievers",
    normalizedText: "الذين لا ياتون الزكوة وهم بالاخرة هم كفرون",
  },
  {
    verseId: 7,
    name: "فصلت",
    surahId: 41,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَهُمۡ أَجۡرٌ غَيۡرُ مَمۡنُونٖ",
    translation:
      "Indeed, those who believe and do righteous deeds - for them is a reward uninterrupted",
    normalizedText: "ان الذين ءامنوا وعملوا الصلحت لهم اجر غير ممنون",
  },
  {
    verseId: 8,
    name: "فصلت",
    surahId: 41,
    text: "۞قُلۡ أَئِنَّكُمۡ لَتَكۡفُرُونَ بِٱلَّذِي خَلَقَ ٱلۡأَرۡضَ فِي يَوۡمَيۡنِ وَتَجۡعَلُونَ لَهُۥٓ أَندَادٗاۚ ذَٰلِكَ رَبُّ ٱلۡعَٰلَمِينَ",
    translation:
      'Say, "Do you indeed disbelieve in He who created the earth in two days and attribute to Him equals? That is the Lord of the worlds',
    normalizedText:
      "۞قل اانكم لتكفرون بالذي خلق الارض في يومين وتجعلون له اندادا ذلك رب العلمين",
  },
  {
    verseId: 9,
    name: "فصلت",
    surahId: 41,
    text: "وَجَعَلَ فِيهَا رَوَٰسِيَ مِن فَوۡقِهَا وَبَٰرَكَ فِيهَا وَقَدَّرَ فِيهَآ أَقۡوَٰتَهَا فِيٓ أَرۡبَعَةِ أَيَّامٖ سَوَآءٗ لِّلسَّآئِلِينَ",
    translation:
      "And He placed on the earth firmly set mountains over its surface, and He blessed it and determined therein its [creatures'] sustenance in four days without distinction - for [the information] of those who ask",
    normalizedText:
      "وجعل فيها روسي من فوقها وبرك فيها وقدر فيها اقوتها في اربعة ايام سواء للساالين",
  },
  {
    verseId: 10,
    name: "فصلت",
    surahId: 41,
    text: "ثُمَّ ٱسۡتَوَىٰٓ إِلَى ٱلسَّمَآءِ وَهِيَ دُخَانٞ فَقَالَ لَهَا وَلِلۡأَرۡضِ ٱئۡتِيَا طَوۡعًا أَوۡ كَرۡهٗا قَالَتَآ أَتَيۡنَا طَآئِعِينَ",
    translation:
      'Then He directed Himself to the heaven while it was smoke and said to it and to the earth, "Come [into being], willingly or by compulsion." They said, "We have come willingly',
    normalizedText:
      "ثم استوى الى السماء وهي دخان فقال لها وللارض ااتيا طوعا او كرها قالتا اتينا طااعين",
  },
  {
    verseId: 11,
    name: "فصلت",
    surahId: 41,
    text: "فَقَضَىٰهُنَّ سَبۡعَ سَمَٰوَاتٖ فِي يَوۡمَيۡنِ وَأَوۡحَىٰ فِي كُلِّ سَمَآءٍ أَمۡرَهَاۚ وَزَيَّنَّا ٱلسَّمَآءَ ٱلدُّنۡيَا بِمَصَٰبِيحَ وَحِفۡظٗاۚ ذَٰلِكَ تَقۡدِيرُ ٱلۡعَزِيزِ ٱلۡعَلِيمِ",
    translation:
      "And He completed them as seven heavens within two days and inspired in each heaven its command. And We adorned the nearest heaven with lamps and as protection. That is the determination of the Exalted in Might, the Knowing",
    normalizedText:
      "فقضىهن سبع سموات في يومين واوحى في كل سماء امرها وزينا السماء الدنيا بمصبيح وحفظا ذلك تقدير العزيز العليم",
  },
  {
    verseId: 12,
    name: "فصلت",
    surahId: 41,
    text: "فَإِنۡ أَعۡرَضُواْ فَقُلۡ أَنذَرۡتُكُمۡ صَٰعِقَةٗ مِّثۡلَ صَٰعِقَةِ عَادٖ وَثَمُودَ",
    translation: `But if they turn away, then say, "I have warned you of a thunderbolt like the thunderbolt [that struck] 'Aad and Thamud`,
    normalizedText: "فان اعرضوا فقل انذرتكم صعقة مثل صعقة عاد وثمود",
  },
  {
    verseId: 13,
    name: "فصلت",
    surahId: 41,
    text: "إِذۡ جَآءَتۡهُمُ ٱلرُّسُلُ مِنۢ بَيۡنِ أَيۡدِيهِمۡ وَمِنۡ خَلۡفِهِمۡ أَلَّا تَعۡبُدُوٓاْ إِلَّا ٱللَّهَۖ قَالُواْ لَوۡ شَآءَ رَبُّنَا لَأَنزَلَ مَلَـٰٓئِكَةٗ فَإِنَّا بِمَآ أُرۡسِلۡتُم بِهِۦ كَٰفِرُونَ",
    translation:
      '[That occurred] when the messengers had come to them before them and after them, [saying], "Worship not except Allah." They said, "If our Lord had willed, He would have sent down the angels, so indeed we, in that with which you have been sent, are disbelievers',
    normalizedText:
      "اذ جاءتهم الرسل من بين ايديهم ومن خلفهم الا تعبدوا الا الله قالوا لو شاء ربنا لانزل ملاكة فانا بما ارسلتم به كفرون",
  },
  {
    verseId: 14,
    name: "فصلت",
    surahId: 41,
    text: "فَأَمَّا عَادٞ فَٱسۡتَكۡبَرُواْ فِي ٱلۡأَرۡضِ بِغَيۡرِ ٱلۡحَقِّ وَقَالُواْ مَنۡ أَشَدُّ مِنَّا قُوَّةًۖ أَوَلَمۡ يَرَوۡاْ أَنَّ ٱللَّهَ ٱلَّذِي خَلَقَهُمۡ هُوَ أَشَدُّ مِنۡهُمۡ قُوَّةٗۖ وَكَانُواْ بِـَٔايَٰتِنَا يَجۡحَدُونَ",
    translation: `As for 'Aad, they were arrogant upon the earth without right and said, "Who is greater than us in strength?" Did they not consider that Allah who created them was greater than them in strength? But they were rejecting Our signs`,
    normalizedText:
      "فاما عاد فاستكبروا في الارض بغير الحق وقالوا من اشد منا قوة اولم يروا ان الله الذي خلقهم هو اشد منهم قوة وكانوا بايتنا يجحدون",
  },
  {
    verseId: 15,
    name: "فصلت",
    surahId: 41,
    text: "فَأَرۡسَلۡنَا عَلَيۡهِمۡ رِيحٗا صَرۡصَرٗا فِيٓ أَيَّامٖ نَّحِسَاتٖ لِّنُذِيقَهُمۡ عَذَابَ ٱلۡخِزۡيِ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَلَعَذَابُ ٱلۡأٓخِرَةِ أَخۡزَىٰۖ وَهُمۡ لَا يُنصَرُونَ",
    translation:
      "So We sent upon them a screaming wind during days of misfortune to make them taste the punishment of disgrace in the worldly life; but the punishment of the Hereafter is more disgracing, and they will not be helped",
    normalizedText:
      "فارسلنا عليهم ريحا صرصرا في ايام نحسات لنذيقهم عذاب الخزي في الحيوة الدنيا ولعذاب الاخرة اخزى وهم لا ينصرون",
  },
  {
    verseId: 16,
    name: "فصلت",
    surahId: 41,
    text: "وَأَمَّا ثَمُودُ فَهَدَيۡنَٰهُمۡ فَٱسۡتَحَبُّواْ ٱلۡعَمَىٰ عَلَى ٱلۡهُدَىٰ فَأَخَذَتۡهُمۡ صَٰعِقَةُ ٱلۡعَذَابِ ٱلۡهُونِ بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "And as for Thamud, We guided them, but they preferred blindness over guidance, so the thunderbolt of humiliating punishment seized them for what they used to earn",
    normalizedText:
      "واما ثمود فهدينهم فاستحبوا العمى على الهدى فاخذتهم صعقة العذاب الهون بما كانوا يكسبون",
  },
  {
    verseId: 17,
    name: "فصلت",
    surahId: 41,
    text: "وَنَجَّيۡنَا ٱلَّذِينَ ءَامَنُواْ وَكَانُواْ يَتَّقُونَ",
    translation: "And We saved those who believed and used to fear Allah",
    normalizedText: "ونجينا الذين ءامنوا وكانوا يتقون",
  },
  {
    verseId: 18,
    name: "فصلت",
    surahId: 41,
    text: "وَيَوۡمَ يُحۡشَرُ أَعۡدَآءُ ٱللَّهِ إِلَى ٱلنَّارِ فَهُمۡ يُوزَعُونَ",
    translation:
      "And [mention, O Muhammad], the Day when the enemies of Allah will be gathered to the Fire while they are [driven] assembled in rows",
    normalizedText: "ويوم يحشر اعداء الله الى النار فهم يوزعون",
  },
  {
    verseId: 19,
    name: "فصلت",
    surahId: 41,
    text: "حَتَّىٰٓ إِذَا مَا جَآءُوهَا شَهِدَ عَلَيۡهِمۡ سَمۡعُهُمۡ وَأَبۡصَٰرُهُمۡ وَجُلُودُهُم بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Until, when they reach it, their hearing and their eyes and their skins will testify against them of what they used to do",
    normalizedText:
      "حتى اذا ما جاءوها شهد عليهم سمعهم وابصرهم وجلودهم بما كانوا يعملون",
  },
  {
    verseId: 20,
    name: "فصلت",
    surahId: 41,
    text: "وَقَالُواْ لِجُلُودِهِمۡ لِمَ شَهِدتُّمۡ عَلَيۡنَاۖ قَالُوٓاْ أَنطَقَنَا ٱللَّهُ ٱلَّذِيٓ أَنطَقَ كُلَّ شَيۡءٖۚ وَهُوَ خَلَقَكُمۡ أَوَّلَ مَرَّةٖ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      'And they will say to their skins, "Why have you testified against us?" They will say, "We were made to speak by Allah, who has made everything speak; and He created you the first time, and to Him you are returned',
    normalizedText:
      "وقالوا لجلودهم لم شهدتم علينا قالوا انطقنا الله الذي انطق كل شيء وهو خلقكم اول مرة واليه ترجعون",
  },
  {
    verseId: 21,
    name: "فصلت",
    surahId: 41,
    text: "وَمَا كُنتُمۡ تَسۡتَتِرُونَ أَن يَشۡهَدَ عَلَيۡكُمۡ سَمۡعُكُمۡ وَلَآ أَبۡصَٰرُكُمۡ وَلَا جُلُودُكُمۡ وَلَٰكِن ظَنَنتُمۡ أَنَّ ٱللَّهَ لَا يَعۡلَمُ كَثِيرٗا مِّمَّا تَعۡمَلُونَ",
    translation:
      "And you were not covering yourselves, lest your hearing testify against you or your sight or your skins, but you assumed that Allah does not know much of what you do",
    normalizedText:
      "وما كنتم تستترون ان يشهد عليكم سمعكم ولا ابصركم ولا جلودكم ولكن ظننتم ان الله لا يعلم كثيرا مما تعملون",
  },
  {
    verseId: 22,
    name: "فصلت",
    surahId: 41,
    text: "وَذَٰلِكُمۡ ظَنُّكُمُ ٱلَّذِي ظَنَنتُم بِرَبِّكُمۡ أَرۡدَىٰكُمۡ فَأَصۡبَحۡتُم مِّنَ ٱلۡخَٰسِرِينَ",
    translation:
      "And that was your assumption which you assumed about your Lord. It has brought you to ruin, and you have become among the losers",
    normalizedText: "وذلكم ظنكم الذي ظننتم بربكم اردىكم فاصبحتم من الخسرين",
  },
  {
    verseId: 23,
    name: "فصلت",
    surahId: 41,
    text: "فَإِن يَصۡبِرُواْ فَٱلنَّارُ مَثۡوٗى لَّهُمۡۖ وَإِن يَسۡتَعۡتِبُواْ فَمَا هُم مِّنَ ٱلۡمُعۡتَبِينَ",
    translation:
      "So [even] if they are patient, the Fire is a residence for them; and if they ask to appease [Allah], they will not be of those who are allowed to appease",
    normalizedText:
      "فان يصبروا فالنار مثوى لهم وان يستعتبوا فما هم من المعتبين",
  },
  {
    verseId: 24,
    name: "فصلت",
    surahId: 41,
    text: "۞وَقَيَّضۡنَا لَهُمۡ قُرَنَآءَ فَزَيَّنُواْ لَهُم مَّا بَيۡنَ أَيۡدِيهِمۡ وَمَا خَلۡفَهُمۡ وَحَقَّ عَلَيۡهِمُ ٱلۡقَوۡلُ فِيٓ أُمَمٖ قَدۡ خَلَتۡ مِن قَبۡلِهِم مِّنَ ٱلۡجِنِّ وَٱلۡإِنسِۖ إِنَّهُمۡ كَانُواْ خَٰسِرِينَ",
    translation:
      "And We appointed for them companions who made attractive to them what was before them and what was behind them [of sin], and the word has come into effect upon them among nations which had passed on before them of jinn and men. Indeed, they [all] were losers",
    normalizedText:
      "۞وقيضنا لهم قرناء فزينوا لهم ما بين ايديهم وما خلفهم وحق عليهم القول في امم قد خلت من قبلهم من الجن والانس انهم كانوا خسرين",
  },
  {
    verseId: 25,
    name: "فصلت",
    surahId: 41,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ لَا تَسۡمَعُواْ لِهَٰذَا ٱلۡقُرۡءَانِ وَٱلۡغَوۡاْ فِيهِ لَعَلَّكُمۡ تَغۡلِبُونَ",
    translation: `And those who disbelieve say, "Do not listen to this Qur'an and speak noisily during [the recitation of] it that perhaps you will overcome`,
    normalizedText:
      "وقال الذين كفروا لا تسمعوا لهذا القرءان والغوا فيه لعلكم تغلبون",
  },
  {
    verseId: 26,
    name: "فصلت",
    surahId: 41,
    text: "فَلَنُذِيقَنَّ ٱلَّذِينَ كَفَرُواْ عَذَابٗا شَدِيدٗا وَلَنَجۡزِيَنَّهُمۡ أَسۡوَأَ ٱلَّذِي كَانُواْ يَعۡمَلُونَ",
    translation:
      "But We will surely cause those who disbelieve to taste a severe punishment, and We will surely recompense them for the worst of what they had been doing",
    normalizedText:
      "فلنذيقن الذين كفروا عذابا شديدا ولنجزينهم اسوا الذي كانوا يعملون",
  },
  {
    verseId: 27,
    name: "فصلت",
    surahId: 41,
    text: "ذَٰلِكَ جَزَآءُ أَعۡدَآءِ ٱللَّهِ ٱلنَّارُۖ لَهُمۡ فِيهَا دَارُ ٱلۡخُلۡدِ جَزَآءَۢ بِمَا كَانُواْ بِـَٔايَٰتِنَا يَجۡحَدُونَ",
    translation:
      "That is the recompense of the enemies of Allah - the Fire. For them therein is the home of eternity as recompense for what they, of Our verses, were rejecting",
    normalizedText:
      "ذلك جزاء اعداء الله النار لهم فيها دار الخلد جزاء بما كانوا بايتنا يجحدون",
  },
  {
    verseId: 28,
    name: "فصلت",
    surahId: 41,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ رَبَّنَآ أَرِنَا ٱلَّذَيۡنِ أَضَلَّانَا مِنَ ٱلۡجِنِّ وَٱلۡإِنسِ نَجۡعَلۡهُمَا تَحۡتَ أَقۡدَامِنَا لِيَكُونَا مِنَ ٱلۡأَسۡفَلِينَ",
    translation:
      'And those who disbelieved will [then] say, "Our Lord, show us those who misled us of the jinn and men [so] we may put them under our feet that they will be among the lowest',
    normalizedText:
      "وقال الذين كفروا ربنا ارنا الذين اضلانا من الجن والانس نجعلهما تحت اقدامنا ليكونا من الاسفلين",
  },
  {
    verseId: 29,
    name: "فصلت",
    surahId: 41,
    text: "إِنَّ ٱلَّذِينَ قَالُواْ رَبُّنَا ٱللَّهُ ثُمَّ ٱسۡتَقَٰمُواْ تَتَنَزَّلُ عَلَيۡهِمُ ٱلۡمَلَـٰٓئِكَةُ أَلَّا تَخَافُواْ وَلَا تَحۡزَنُواْ وَأَبۡشِرُواْ بِٱلۡجَنَّةِ ٱلَّتِي كُنتُمۡ تُوعَدُونَ",
    translation:
      'Indeed, those who have said, "Our Lord is Allah " and then remained on a right course - the angels will descend upon them, [saying], "Do not fear and do not grieve but receive good tidings of Paradise, which you were promised',
    normalizedText:
      "ان الذين قالوا ربنا الله ثم استقموا تتنزل عليهم الملاكة الا تخافوا ولا تحزنوا وابشروا بالجنة التي كنتم توعدون",
  },
  {
    verseId: 30,
    name: "فصلت",
    surahId: 41,
    text: "نَحۡنُ أَوۡلِيَآؤُكُمۡ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَا وَفِي ٱلۡأٓخِرَةِۖ وَلَكُمۡ فِيهَا مَا تَشۡتَهِيٓ أَنفُسُكُمۡ وَلَكُمۡ فِيهَا مَا تَدَّعُونَ",
    translation:
      "We [angels] were your allies in worldly life and [are so] in the Hereafter. And you will have therein whatever your souls desire, and you will have therein whatever you request [or wish]",
    normalizedText:
      "نحن اوليااكم في الحيوة الدنيا وفي الاخرة ولكم فيها ما تشتهي انفسكم ولكم فيها ما تدعون",
  },
  {
    verseId: 31,
    name: "فصلت",
    surahId: 41,
    text: "نُزُلٗا مِّنۡ غَفُورٖ رَّحِيمٖ",
    translation: "As accommodation from a [Lord who is] Forgiving and Merciful",
    normalizedText: "نزلا من غفور رحيم",
  },
  {
    verseId: 32,
    name: "فصلت",
    surahId: 41,
    text: "وَمَنۡ أَحۡسَنُ قَوۡلٗا مِّمَّن دَعَآ إِلَى ٱللَّهِ وَعَمِلَ صَٰلِحٗا وَقَالَ إِنَّنِي مِنَ ٱلۡمُسۡلِمِينَ",
    translation:
      'And who is better in speech than one who invites to Allah and does righteousness and says, "Indeed, I am of the Muslims',
    normalizedText:
      "ومن احسن قولا ممن دعا الى الله وعمل صلحا وقال انني من المسلمين",
  },
  {
    verseId: 33,
    name: "فصلت",
    surahId: 41,
    text: "وَلَا تَسۡتَوِي ٱلۡحَسَنَةُ وَلَا ٱلسَّيِّئَةُۚ ٱدۡفَعۡ بِٱلَّتِي هِيَ أَحۡسَنُ فَإِذَا ٱلَّذِي بَيۡنَكَ وَبَيۡنَهُۥ عَدَٰوَةٞ كَأَنَّهُۥ وَلِيٌّ حَمِيمٞ",
    translation:
      "And not equal are the good deed and the bad. Repel [evil] by that [deed] which is better; and thereupon the one whom between you and him is enmity [will become] as though he was a devoted friend",
    normalizedText:
      "ولا تستوي الحسنة ولا السياة ادفع بالتي هي احسن فاذا الذي بينك وبينه عدوة كانه ولي حميم",
  },
  {
    verseId: 34,
    name: "فصلت",
    surahId: 41,
    text: "وَمَا يُلَقَّىٰهَآ إِلَّا ٱلَّذِينَ صَبَرُواْ وَمَا يُلَقَّىٰهَآ إِلَّا ذُو حَظٍّ عَظِيمٖ",
    translation:
      "But none is granted it except those who are patient, and none is granted it except one having a great portion [of good]",
    normalizedText: "وما يلقىها الا الذين صبروا وما يلقىها الا ذو حظ عظيم",
  },
  {
    verseId: 35,
    name: "فصلت",
    surahId: 41,
    text: "وَإِمَّا يَنزَغَنَّكَ مِنَ ٱلشَّيۡطَٰنِ نَزۡغٞ فَٱسۡتَعِذۡ بِٱللَّهِۖ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "And if there comes to you from Satan an evil suggestion, then seek refuge in Allah. Indeed, He is the Hearing, the Knowing",
    normalizedText:
      "واما ينزغنك من الشيطن نزغ فاستعذ بالله انه هو السميع العليم",
  },
  {
    verseId: 36,
    name: "فصلت",
    surahId: 41,
    text: "وَمِنۡ ءَايَٰتِهِ ٱلَّيۡلُ وَٱلنَّهَارُ وَٱلشَّمۡسُ وَٱلۡقَمَرُۚ لَا تَسۡجُدُواْ لِلشَّمۡسِ وَلَا لِلۡقَمَرِ وَٱسۡجُدُواْۤ لِلَّهِۤ ٱلَّذِي خَلَقَهُنَّ إِن كُنتُمۡ إِيَّاهُ تَعۡبُدُونَ",
    translation:
      "And of His signs are the night and day and the sun and moon. Do not prostrate to the sun or to the moon, but prostate to Allah, who created them, if it should be Him that you worship",
    normalizedText:
      "ومن ءايته اليل والنهار والشمس والقمر لا تسجدوا للشمس ولا للقمر واسجدوا لله الذي خلقهن ان كنتم اياه تعبدون",
  },
  {
    verseId: 37,
    name: "فصلت",
    surahId: 41,
    text: "فَإِنِ ٱسۡتَكۡبَرُواْ فَٱلَّذِينَ عِندَ رَبِّكَ يُسَبِّحُونَ لَهُۥ بِٱلَّيۡلِ وَٱلنَّهَارِ وَهُمۡ لَا يَسۡـَٔمُونَ۩",
    translation:
      "But if they are arrogant - then those who are near your Lord exalt Him by night and by day, and they do not become weary",
    normalizedText:
      "فان استكبروا فالذين عند ربك يسبحون له باليل والنهار وهم لا يسمون۩",
  },
  {
    verseId: 38,
    name: "فصلت",
    surahId: 41,
    text: "وَمِنۡ ءَايَٰتِهِۦٓ أَنَّكَ تَرَى ٱلۡأَرۡضَ خَٰشِعَةٗ فَإِذَآ أَنزَلۡنَا عَلَيۡهَا ٱلۡمَآءَ ٱهۡتَزَّتۡ وَرَبَتۡۚ إِنَّ ٱلَّذِيٓ أَحۡيَاهَا لَمُحۡيِ ٱلۡمَوۡتَىٰٓۚ إِنَّهُۥ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "And of His signs is that you see the earth stilled, but when We send down upon it rain, it quivers and grows. Indeed, He who has given it life is the Giver of Life to the dead. Indeed, He is over all things competent",
    normalizedText:
      "ومن ءايته انك ترى الارض خشعة فاذا انزلنا عليها الماء اهتزت وربت ان الذي احياها لمحي الموتى انه على كل شيء قدير",
  },
  {
    verseId: 39,
    name: "فصلت",
    surahId: 41,
    text: "إِنَّ ٱلَّذِينَ يُلۡحِدُونَ فِيٓ ءَايَٰتِنَا لَا يَخۡفَوۡنَ عَلَيۡنَآۗ أَفَمَن يُلۡقَىٰ فِي ٱلنَّارِ خَيۡرٌ أَم مَّن يَأۡتِيٓ ءَامِنٗا يَوۡمَ ٱلۡقِيَٰمَةِۚ ٱعۡمَلُواْ مَا شِئۡتُمۡ إِنَّهُۥ بِمَا تَعۡمَلُونَ بَصِيرٌ",
    translation:
      "Indeed, those who inject deviation into Our verses are not concealed from Us. So, is he who is cast into the Fire better or he who comes secure on the Day of Resurrection? Do whatever you will; indeed, He is Seeing of what you do",
    normalizedText:
      "ان الذين يلحدون في ءايتنا لا يخفون علينا افمن يلقى في النار خير ام من ياتي ءامنا يوم القيمة اعملوا ما شاتم انه بما تعملون بصير",
  },
  {
    verseId: 40,
    name: "فصلت",
    surahId: 41,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ بِٱلذِّكۡرِ لَمَّا جَآءَهُمۡۖ وَإِنَّهُۥ لَكِتَٰبٌ عَزِيزٞ",
    translation:
      "Indeed, those who disbelieve in the message after it has come to them... And indeed, it is a mighty Book",
    normalizedText: "ان الذين كفروا بالذكر لما جاءهم وانه لكتب عزيز",
  },
  {
    verseId: 41,
    name: "فصلت",
    surahId: 41,
    text: "لَّا يَأۡتِيهِ ٱلۡبَٰطِلُ مِنۢ بَيۡنِ يَدَيۡهِ وَلَا مِنۡ خَلۡفِهِۦۖ تَنزِيلٞ مِّنۡ حَكِيمٍ حَمِيدٖ",
    translation:
      "Falsehood cannot approach it from before it or from behind it; [it is] a revelation from a [Lord who is] Wise and Praiseworthy",
    normalizedText: "لا ياتيه البطل من بين يديه ولا من خلفه تنزيل من حكيم حميد",
  },
  {
    verseId: 42,
    name: "فصلت",
    surahId: 41,
    text: "مَّا يُقَالُ لَكَ إِلَّا مَا قَدۡ قِيلَ لِلرُّسُلِ مِن قَبۡلِكَۚ إِنَّ رَبَّكَ لَذُو مَغۡفِرَةٖ وَذُو عِقَابٍ أَلِيمٖ",
    translation:
      "Nothing is said to you, [O Muhammad], except what was already said to the messengers before you. Indeed, your Lord is a possessor of forgiveness and a possessor of painful penalty",
    normalizedText:
      "ما يقال لك الا ما قد قيل للرسل من قبلك ان ربك لذو مغفرة وذو عقاب اليم",
  },
  {
    verseId: 43,
    name: "فصلت",
    surahId: 41,
    text: "وَلَوۡ جَعَلۡنَٰهُ قُرۡءَانًا أَعۡجَمِيّٗا لَّقَالُواْ لَوۡلَا فُصِّلَتۡ ءَايَٰتُهُۥٓۖ ءَا۬عۡجَمِيّٞ وَعَرَبِيّٞۗ قُلۡ هُوَ لِلَّذِينَ ءَامَنُواْ هُدٗى وَشِفَآءٞۚ وَٱلَّذِينَ لَا يُؤۡمِنُونَ فِيٓ ءَاذَانِهِمۡ وَقۡرٞ وَهُوَ عَلَيۡهِمۡ عَمًىۚ أُوْلَـٰٓئِكَ يُنَادَوۡنَ مِن مَّكَانِۭ بَعِيدٖ",
    translation: `And if We had made it a non-Arabic Qur'an, they would have said, "Why are its verses not explained in detail [in our language]? Is it a foreign [recitation] and an Arab [messenger]?" Say, "It is, for those who believe, a guidance and cure." And those who do not believe - in their ears is deafness, and it is upon them blindness. Those are being called from a distant place`,
    normalizedText:
      "ولو جعلنه قرءانا اعجميا لقالوا لولا فصلت ءايته ءاعجمي وعربي قل هو للذين ءامنوا هدى وشفاء والذين لا يامنون في ءاذانهم وقر وهو عليهم عمى اولاك ينادون من مكان بعيد",
  },
  {
    verseId: 44,
    name: "فصلت",
    surahId: 41,
    text: "وَلَقَدۡ ءَاتَيۡنَا مُوسَى ٱلۡكِتَٰبَ فَٱخۡتُلِفَ فِيهِۚ وَلَوۡلَا كَلِمَةٞ سَبَقَتۡ مِن رَّبِّكَ لَقُضِيَ بَيۡنَهُمۡۚ وَإِنَّهُمۡ لَفِي شَكّٖ مِّنۡهُ مُرِيبٖ",
    translation:
      "And We had already given Moses the Scripture, but it came under disagreement. And if not for a word that preceded from your Lord, it would have been concluded between them. And indeed they are, concerning the Qur'an, in disquieting doubt",
    normalizedText:
      "ولقد ءاتينا موسى الكتب فاختلف فيه ولولا كلمة سبقت من ربك لقضي بينهم وانهم لفي شك منه مريب",
  },
  {
    verseId: 45,
    name: "فصلت",
    surahId: 41,
    text: "مَّنۡ عَمِلَ صَٰلِحٗا فَلِنَفۡسِهِۦۖ وَمَنۡ أَسَآءَ فَعَلَيۡهَاۗ وَمَا رَبُّكَ بِظَلَّـٰمٖ لِّلۡعَبِيدِ",
    translation:
      "Whoever does righteousness - it is for his [own] soul; and whoever does evil [does so] against it. And your Lord is not ever unjust to [His] servants",
    normalizedText: "من عمل صلحا فلنفسه ومن اساء فعليها وما ربك بظلم للعبيد",
  },
  {
    verseId: 46,
    name: "فصلت",
    surahId: 41,
    text: "۞إِلَيۡهِ يُرَدُّ عِلۡمُ ٱلسَّاعَةِۚ وَمَا تَخۡرُجُ مِن ثَمَرَٰتٖ مِّنۡ أَكۡمَامِهَا وَمَا تَحۡمِلُ مِنۡ أُنثَىٰ وَلَا تَضَعُ إِلَّا بِعِلۡمِهِۦۚ وَيَوۡمَ يُنَادِيهِمۡ أَيۡنَ شُرَكَآءِي قَالُوٓاْ ءَاذَنَّـٰكَ مَامِنَّا مِن شَهِيدٖ",
    translation: `To him [alone] is attributed knowledge of the Hour. And fruits emerge not from their coverings nor does a female conceive or give birth except with His knowledge. And the Day He will call to them, "Where are My 'partners'?" they will say, "We announce to You that there is [no longer] among us any witness [to that]`,
    normalizedText:
      "۞اليه يرد علم الساعة وما تخرج من ثمرت من اكمامها وما تحمل من انثى ولا تضع الا بعلمه ويوم يناديهم اين شركاءي قالوا ءاذنك مامنا من شهيد",
  },
  {
    verseId: 47,
    name: "فصلت",
    surahId: 41,
    text: "وَضَلَّ عَنۡهُم مَّا كَانُواْ يَدۡعُونَ مِن قَبۡلُۖ وَظَنُّواْ مَا لَهُم مِّن مَّحِيصٖ",
    translation:
      "And lost from them will be those they were invoking before, and they will be certain that they have no place of escape",
    normalizedText: "وضل عنهم ما كانوا يدعون من قبل وظنوا ما لهم من محيص",
  },
  {
    verseId: 48,
    name: "فصلت",
    surahId: 41,
    text: "لَّا يَسۡـَٔمُ ٱلۡإِنسَٰنُ مِن دُعَآءِ ٱلۡخَيۡرِ وَإِن مَّسَّهُ ٱلشَّرُّ فَيَـُٔوسٞ قَنُوطٞ",
    translation:
      "Man is not weary of supplication for good [things], but if evil touches him, he is hopeless and despairing",
    normalizedText: "لا يسم الانسن من دعاء الخير وان مسه الشر فيوس قنوط",
  },
  {
    verseId: 49,
    name: "فصلت",
    surahId: 41,
    text: "وَلَئِنۡ أَذَقۡنَٰهُ رَحۡمَةٗ مِّنَّا مِنۢ بَعۡدِ ضَرَّآءَ مَسَّتۡهُ لَيَقُولَنَّ هَٰذَا لِي وَمَآ أَظُنُّ ٱلسَّاعَةَ قَآئِمَةٗ وَلَئِن رُّجِعۡتُ إِلَىٰ رَبِّيٓ إِنَّ لِي عِندَهُۥ لَلۡحُسۡنَىٰۚ فَلَنُنَبِّئَنَّ ٱلَّذِينَ كَفَرُواْ بِمَا عَمِلُواْ وَلَنُذِيقَنَّهُم مِّنۡ عَذَابٍ غَلِيظٖ",
    translation:
      'And if We let him taste mercy from Us after an adversity which has touched him, he will surely say, "This is [due] to me, and I do not think the Hour will occur; and [even] if I should be returned to my Lord, indeed, for me there will be with Him the best." But We will surely inform those who disbelieved about what they did, and We will surely make them taste a massive punishment',
    normalizedText:
      "ولان اذقنه رحمة منا من بعد ضراء مسته ليقولن هذا لي وما اظن الساعة قاامة ولان رجعت الى ربي ان لي عنده للحسنى فلننبان الذين كفروا بما عملوا ولنذيقنهم من عذاب غليظ",
  },
  {
    verseId: 50,
    name: "فصلت",
    surahId: 41,
    text: "وَإِذَآ أَنۡعَمۡنَا عَلَى ٱلۡإِنسَٰنِ أَعۡرَضَ وَنَـَٔا بِجَانِبِهِۦ وَإِذَا مَسَّهُ ٱلشَّرُّ فَذُو دُعَآءٍ عَرِيضٖ",
    translation:
      "And when We bestow favor upon man, he turns away and distances himself; but when evil touches him, then he is full of extensive supplication",
    normalizedText:
      "واذا انعمنا على الانسن اعرض ونا بجانبه واذا مسه الشر فذو دعاء عريض",
  },
  {
    verseId: 51,
    name: "فصلت",
    surahId: 41,
    text: "قُلۡ أَرَءَيۡتُمۡ إِن كَانَ مِنۡ عِندِ ٱللَّهِ ثُمَّ كَفَرۡتُم بِهِۦ مَنۡ أَضَلُّ مِمَّنۡ هُوَ فِي شِقَاقِۭ بَعِيدٖ",
    translation: `Say, "Have you considered: if the Qur'an is from Allah and you disbelieved in it, who would be more astray than one who is in extreme dissension`,
    normalizedText:
      "قل ارءيتم ان كان من عند الله ثم كفرتم به من اضل ممن هو في شقاق بعيد",
  },
  {
    verseId: 52,
    name: "فصلت",
    surahId: 41,
    text: "سَنُرِيهِمۡ ءَايَٰتِنَا فِي ٱلۡأٓفَاقِ وَفِيٓ أَنفُسِهِمۡ حَتَّىٰ يَتَبَيَّنَ لَهُمۡ أَنَّهُ ٱلۡحَقُّۗ أَوَلَمۡ يَكۡفِ بِرَبِّكَ أَنَّهُۥ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدٌ",
    translation:
      "We will show them Our signs in the horizons and within themselves until it becomes clear to them that it is the truth. But is it not sufficient concerning your Lord that He is, over all things, a Witness",
    normalizedText:
      "سنريهم ءايتنا في الافاق وفي انفسهم حتى يتبين لهم انه الحق اولم يكف بربك انه على كل شيء شهيد",
  },
  {
    verseId: 53,
    name: "فصلت",
    surahId: 41,
    text: "أَلَآ إِنَّهُمۡ فِي مِرۡيَةٖ مِّن لِّقَآءِ رَبِّهِمۡۗ أَلَآ إِنَّهُۥ بِكُلِّ شَيۡءٖ مُّحِيطُۢ",
    translation:
      "Unquestionably, they are in doubt about the meeting with their Lord. Unquestionably He is, of all things, encompassing",
    normalizedText: "الا انهم في مرية من لقاء ربهم الا انه بكل شيء محيط",
  },
  {
    verseId: 0,
    name: "الشورى",
    surahId: 42,
    text: "حمٓ",
    translation: "Ha, Meem",
    normalizedText: "حم",
  },
  {
    verseId: 1,
    name: "الشورى",
    surahId: 42,
    text: "عٓسٓقٓ",
    translation: "Ayn, Seen, Qaf",
    normalizedText: "عسق",
  },
  {
    verseId: 2,
    name: "الشورى",
    surahId: 42,
    text: "كَذَٰلِكَ يُوحِيٓ إِلَيۡكَ وَإِلَى ٱلَّذِينَ مِن قَبۡلِكَ ٱللَّهُ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Thus has He revealed to you, [O Muhammad], and to those before you - Allah, the Exalted in Might, the Wise",
    normalizedText: "كذلك يوحي اليك والى الذين من قبلك الله العزيز الحكيم",
  },
  {
    verseId: 3,
    name: "الشورى",
    surahId: 42,
    text: "لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَلِيُّ ٱلۡعَظِيمُ",
    translation:
      "To Him belongs whatever is in the heavens and whatever is in the earth, and He is the Most High, the Most Great",
    normalizedText: "له ما في السموت وما في الارض وهو العلي العظيم",
  },
  {
    verseId: 4,
    name: "الشورى",
    surahId: 42,
    text: "تَكَادُ ٱلسَّمَٰوَٰتُ يَتَفَطَّرۡنَ مِن فَوۡقِهِنَّۚ وَٱلۡمَلَـٰٓئِكَةُ يُسَبِّحُونَ بِحَمۡدِ رَبِّهِمۡ وَيَسۡتَغۡفِرُونَ لِمَن فِي ٱلۡأَرۡضِۗ أَلَآ إِنَّ ٱللَّهَ هُوَ ٱلۡغَفُورُ ٱلرَّحِيمُ",
    translation:
      "The heavens almost break from above them, and the angels exalt [Allah] with praise of their Lord and ask forgiveness for those on earth. Unquestionably, it is Allah who is the Forgiving, the Merciful",
    normalizedText:
      "تكاد السموت يتفطرن من فوقهن والملاكة يسبحون بحمد ربهم ويستغفرون لمن في الارض الا ان الله هو الغفور الرحيم",
  },
  {
    verseId: 5,
    name: "الشورى",
    surahId: 42,
    text: "وَٱلَّذِينَ ٱتَّخَذُواْ مِن دُونِهِۦٓ أَوۡلِيَآءَ ٱللَّهُ حَفِيظٌ عَلَيۡهِمۡ وَمَآ أَنتَ عَلَيۡهِم بِوَكِيلٖ",
    translation:
      "And those who take as allies other than Him - Allah is [yet] Guardian over them; and you, [O Muhammad], are not over them a manager",
    normalizedText:
      "والذين اتخذوا من دونه اولياء الله حفيظ عليهم وما انت عليهم بوكيل",
  },
  {
    verseId: 6,
    name: "الشورى",
    surahId: 42,
    text: "وَكَذَٰلِكَ أَوۡحَيۡنَآ إِلَيۡكَ قُرۡءَانًا عَرَبِيّٗا لِّتُنذِرَ أُمَّ ٱلۡقُرَىٰ وَمَنۡ حَوۡلَهَا وَتُنذِرَ يَوۡمَ ٱلۡجَمۡعِ لَا رَيۡبَ فِيهِۚ فَرِيقٞ فِي ٱلۡجَنَّةِ وَفَرِيقٞ فِي ٱلسَّعِيرِ",
    translation:
      "And thus We have revealed to you an Arabic Qur'an that you may warn the Mother of Cities [Makkah] and those around it and warn of the Day of Assembly, about which there is no doubt. A party will be in Paradise and a party in the Blaze",
    normalizedText:
      "وكذلك اوحينا اليك قرءانا عربيا لتنذر ام القرى ومن حولها وتنذر يوم الجمع لا ريب فيه فريق في الجنة وفريق في السعير",
  },
  {
    verseId: 7,
    name: "الشورى",
    surahId: 42,
    text: "وَلَوۡ شَآءَ ٱللَّهُ لَجَعَلَهُمۡ أُمَّةٗ وَٰحِدَةٗ وَلَٰكِن يُدۡخِلُ مَن يَشَآءُ فِي رَحۡمَتِهِۦۚ وَٱلظَّـٰلِمُونَ مَا لَهُم مِّن وَلِيّٖ وَلَا نَصِيرٍ",
    translation:
      "And if Allah willed, He could have made them [of] one religion, but He admits whom He wills into His mercy. And the wrongdoers have not any protector or helper",
    normalizedText:
      "ولو شاء الله لجعلهم امة وحدة ولكن يدخل من يشاء في رحمته والظلمون ما لهم من ولي ولا نصير",
  },
  {
    verseId: 8,
    name: "الشورى",
    surahId: 42,
    text: "أَمِ ٱتَّخَذُواْ مِن دُونِهِۦٓ أَوۡلِيَآءَۖ فَٱللَّهُ هُوَ ٱلۡوَلِيُّ وَهُوَ يُحۡيِ ٱلۡمَوۡتَىٰ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "Or have they taken protectors [or allies] besides him? But Allah - He is the Protector, and He gives life to the dead, and He is over all things competent",
    normalizedText:
      "ام اتخذوا من دونه اولياء فالله هو الولي وهو يحي الموتى وهو على كل شيء قدير",
  },
  {
    verseId: 9,
    name: "الشورى",
    surahId: 42,
    text: "وَمَا ٱخۡتَلَفۡتُمۡ فِيهِ مِن شَيۡءٖ فَحُكۡمُهُۥٓ إِلَى ٱللَّهِۚ ذَٰلِكُمُ ٱللَّهُ رَبِّي عَلَيۡهِ تَوَكَّلۡتُ وَإِلَيۡهِ أُنِيبُ",
    translation:
      'And in anything over which you disagree - its ruling is [to be referred] to Allah. [Say], "That is Allah, my Lord; upon Him I have relied, and to Him I turn back',
    normalizedText:
      "وما اختلفتم فيه من شيء فحكمه الى الله ذلكم الله ربي عليه توكلت واليه انيب",
  },
  {
    verseId: 10,
    name: "الشورى",
    surahId: 42,
    text: "فَاطِرُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ جَعَلَ لَكُم مِّنۡ أَنفُسِكُمۡ أَزۡوَٰجٗا وَمِنَ ٱلۡأَنۡعَٰمِ أَزۡوَٰجٗا يَذۡرَؤُكُمۡ فِيهِۚ لَيۡسَ كَمِثۡلِهِۦ شَيۡءٞۖ وَهُوَ ٱلسَّمِيعُ ٱلۡبَصِيرُ",
    translation:
      "[He is] Creator of the heavens and the earth. He has made for you from yourselves, mates, and among the cattle, mates; He multiplies you thereby. There is nothing like unto Him, and He is the Hearing, the Seeing",
    normalizedText:
      "فاطر السموت والارض جعل لكم من انفسكم ازوجا ومن الانعم ازوجا يذراكم فيه ليس كمثله شيء وهو السميع البصير",
  },
  {
    verseId: 11,
    name: "الشورى",
    surahId: 42,
    text: "لَهُۥ مَقَالِيدُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ يَبۡسُطُ ٱلرِّزۡقَ لِمَن يَشَآءُ وَيَقۡدِرُۚ إِنَّهُۥ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "To Him belong the keys of the heavens and the earth. He extends provision for whom He wills and restricts [it]. Indeed He is, of all things, Knowing",
    normalizedText:
      "له مقاليد السموت والارض يبسط الرزق لمن يشاء ويقدر انه بكل شيء عليم",
  },
  {
    verseId: 12,
    name: "الشورى",
    surahId: 42,
    text: "۞شَرَعَ لَكُم مِّنَ ٱلدِّينِ مَا وَصَّىٰ بِهِۦ نُوحٗا وَٱلَّذِيٓ أَوۡحَيۡنَآ إِلَيۡكَ وَمَا وَصَّيۡنَا بِهِۦٓ إِبۡرَٰهِيمَ وَمُوسَىٰ وَعِيسَىٰٓۖ أَنۡ أَقِيمُواْ ٱلدِّينَ وَلَا تَتَفَرَّقُواْ فِيهِۚ كَبُرَ عَلَى ٱلۡمُشۡرِكِينَ مَا تَدۡعُوهُمۡ إِلَيۡهِۚ ٱللَّهُ يَجۡتَبِيٓ إِلَيۡهِ مَن يَشَآءُ وَيَهۡدِيٓ إِلَيۡهِ مَن يُنِيبُ",
    translation:
      "He has ordained for you of religion what He enjoined upon Noah and that which We have revealed to you, [O Muhammad], and what We enjoined upon Abraham and Moses and Jesus - to establish the religion and not be divided therein. Difficult for those who associate others with Allah is that to which you invite them. Allah chooses for Himself whom He wills and guides to Himself whoever turns back [to Him]",
    normalizedText:
      "۞شرع لكم من الدين ما وصى به نوحا والذي اوحينا اليك وما وصينا به ابرهيم وموسى وعيسى ان اقيموا الدين ولا تتفرقوا فيه كبر على المشركين ما تدعوهم اليه الله يجتبي اليه من يشاء ويهدي اليه من ينيب",
  },
  {
    verseId: 13,
    name: "الشورى",
    surahId: 42,
    text: "وَمَا تَفَرَّقُوٓاْ إِلَّا مِنۢ بَعۡدِ مَا جَآءَهُمُ ٱلۡعِلۡمُ بَغۡيَۢا بَيۡنَهُمۡۚ وَلَوۡلَا كَلِمَةٞ سَبَقَتۡ مِن رَّبِّكَ إِلَىٰٓ أَجَلٖ مُّسَمّٗى لَّقُضِيَ بَيۡنَهُمۡۚ وَإِنَّ ٱلَّذِينَ أُورِثُواْ ٱلۡكِتَٰبَ مِنۢ بَعۡدِهِمۡ لَفِي شَكّٖ مِّنۡهُ مُرِيبٖ",
    translation:
      "And they did not become divided until after knowledge had come to them - out of jealous animosity between themselves. And if not for a word that preceded from your Lord [postponing the penalty] until a specified time, it would have been concluded between them. And indeed, those who were granted inheritance of the Scripture after them are, concerning it, in disquieting doubt",
    normalizedText:
      "وما تفرقوا الا من بعد ما جاءهم العلم بغيا بينهم ولولا كلمة سبقت من ربك الى اجل مسمى لقضي بينهم وان الذين اورثوا الكتب من بعدهم لفي شك منه مريب",
  },
  {
    verseId: 14,
    name: "الشورى",
    surahId: 42,
    text: "فَلِذَٰلِكَ فَٱدۡعُۖ وَٱسۡتَقِمۡ كَمَآ أُمِرۡتَۖ وَلَا تَتَّبِعۡ أَهۡوَآءَهُمۡۖ وَقُلۡ ءَامَنتُ بِمَآ أَنزَلَ ٱللَّهُ مِن كِتَٰبٖۖ وَأُمِرۡتُ لِأَعۡدِلَ بَيۡنَكُمُۖ ٱللَّهُ رَبُّنَا وَرَبُّكُمۡۖ لَنَآ أَعۡمَٰلُنَا وَلَكُمۡ أَعۡمَٰلُكُمۡۖ لَا حُجَّةَ بَيۡنَنَا وَبَيۡنَكُمُۖ ٱللَّهُ يَجۡمَعُ بَيۡنَنَاۖ وَإِلَيۡهِ ٱلۡمَصِيرُ",
    translation: `So to that [religion of Allah] invite, [O Muhammad], and remain on a right course as you are commanded and do not follow their inclinations but say, "I have believed in what Allah has revealed of the Qur'an, and I have been commanded to do justice among you. Allah is our Lord and your Lord. For us are our deeds, and for you your deeds. There is no [need for] argument between us and you. Allah will bring us together, and to Him is the [final] destination`,
    normalizedText:
      "فلذلك فادع واستقم كما امرت ولا تتبع اهواءهم وقل ءامنت بما انزل الله من كتب وامرت لاعدل بينكم الله ربنا وربكم لنا اعملنا ولكم اعملكم لا حجة بيننا وبينكم الله يجمع بيننا واليه المصير",
  },
  {
    verseId: 15,
    name: "الشورى",
    surahId: 42,
    text: "وَٱلَّذِينَ يُحَآجُّونَ فِي ٱللَّهِ مِنۢ بَعۡدِ مَا ٱسۡتُجِيبَ لَهُۥ حُجَّتُهُمۡ دَاحِضَةٌ عِندَ رَبِّهِمۡ وَعَلَيۡهِمۡ غَضَبٞ وَلَهُمۡ عَذَابٞ شَدِيدٌ",
    translation:
      "And those who argue concerning Allah after He has been responded to - their argument is invalid with their Lord, and upon them is [His] wrath, and for them is a severe punishment",
    normalizedText:
      "والذين يحاجون في الله من بعد ما استجيب له حجتهم داحضة عند ربهم وعليهم غضب ولهم عذاب شديد",
  },
  {
    verseId: 16,
    name: "الشورى",
    surahId: 42,
    text: "ٱللَّهُ ٱلَّذِيٓ أَنزَلَ ٱلۡكِتَٰبَ بِٱلۡحَقِّ وَٱلۡمِيزَانَۗ وَمَا يُدۡرِيكَ لَعَلَّ ٱلسَّاعَةَ قَرِيبٞ",
    translation:
      "It is Allah who has sent down the Book in truth and [also] the balance. And what will make you perceive? Perhaps the Hour is near",
    normalizedText:
      "الله الذي انزل الكتب بالحق والميزان وما يدريك لعل الساعة قريب",
  },
  {
    verseId: 17,
    name: "الشورى",
    surahId: 42,
    text: "يَسۡتَعۡجِلُ بِهَا ٱلَّذِينَ لَا يُؤۡمِنُونَ بِهَاۖ وَٱلَّذِينَ ءَامَنُواْ مُشۡفِقُونَ مِنۡهَا وَيَعۡلَمُونَ أَنَّهَا ٱلۡحَقُّۗ أَلَآ إِنَّ ٱلَّذِينَ يُمَارُونَ فِي ٱلسَّاعَةِ لَفِي ضَلَٰلِۭ بَعِيدٍ",
    translation:
      "Those who do not believe in it are impatient for it, but those who believe are fearful of it and know that it is the truth. Unquestionably, those who dispute concerning the Hour are in extreme error",
    normalizedText:
      "يستعجل بها الذين لا يامنون بها والذين ءامنوا مشفقون منها ويعلمون انها الحق الا ان الذين يمارون في الساعة لفي ضلل بعيد",
  },
  {
    verseId: 18,
    name: "الشورى",
    surahId: 42,
    text: "ٱللَّهُ لَطِيفُۢ بِعِبَادِهِۦ يَرۡزُقُ مَن يَشَآءُۖ وَهُوَ ٱلۡقَوِيُّ ٱلۡعَزِيزُ",
    translation:
      "Allah is Subtle with His servants; He gives provisions to whom He wills. And He is the Powerful, the Exalted in Might",
    normalizedText: "الله لطيف بعباده يرزق من يشاء وهو القوي العزيز",
  },
  {
    verseId: 19,
    name: "الشورى",
    surahId: 42,
    text: "مَن كَانَ يُرِيدُ حَرۡثَ ٱلۡأٓخِرَةِ نَزِدۡ لَهُۥ فِي حَرۡثِهِۦۖ وَمَن كَانَ يُرِيدُ حَرۡثَ ٱلدُّنۡيَا نُؤۡتِهِۦ مِنۡهَا وَمَا لَهُۥ فِي ٱلۡأٓخِرَةِ مِن نَّصِيبٍ",
    translation:
      "Whoever desires the harvest of the Hereafter - We increase for him in his harvest. And whoever desires the harvest of this world - We give him thereof, but there is not for him in the Hereafter any share",
    normalizedText:
      "من كان يريد حرث الاخرة نزد له في حرثه ومن كان يريد حرث الدنيا ناته منها وما له في الاخرة من نصيب",
  },
  {
    verseId: 20,
    name: "الشورى",
    surahId: 42,
    text: "أَمۡ لَهُمۡ شُرَكَـٰٓؤُاْ شَرَعُواْ لَهُم مِّنَ ٱلدِّينِ مَا لَمۡ يَأۡذَنۢ بِهِ ٱللَّهُۚ وَلَوۡلَا كَلِمَةُ ٱلۡفَصۡلِ لَقُضِيَ بَيۡنَهُمۡۗ وَإِنَّ ٱلظَّـٰلِمِينَ لَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "Or have they other deities who have ordained for them a religion to which Allah has not consented? But if not for the decisive word, it would have been concluded between them. And indeed, the wrongdoers will have a painful punishment",
    normalizedText:
      "ام لهم شركاا شرعوا لهم من الدين ما لم ياذن به الله ولولا كلمة الفصل لقضي بينهم وان الظلمين لهم عذاب اليم",
  },
  {
    verseId: 21,
    name: "الشورى",
    surahId: 42,
    text: "تَرَى ٱلظَّـٰلِمِينَ مُشۡفِقِينَ مِمَّا كَسَبُواْ وَهُوَ وَاقِعُۢ بِهِمۡۗ وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فِي رَوۡضَاتِ ٱلۡجَنَّاتِۖ لَهُم مَّا يَشَآءُونَ عِندَ رَبِّهِمۡۚ ذَٰلِكَ هُوَ ٱلۡفَضۡلُ ٱلۡكَبِيرُ",
    translation:
      "You will see the wrongdoers fearful of what they have earned, and it will [certainly] befall them. And those who have believed and done righteous deeds will be in lush regions of the gardens [in Paradise] having whatever they will in the presence of their Lord. That is what is the great bounty",
    normalizedText:
      "ترى الظلمين مشفقين مما كسبوا وهو واقع بهم والذين ءامنوا وعملوا الصلحت في روضات الجنات لهم ما يشاءون عند ربهم ذلك هو الفضل الكبير",
  },
  {
    verseId: 22,
    name: "الشورى",
    surahId: 42,
    text: "ذَٰلِكَ ٱلَّذِي يُبَشِّرُ ٱللَّهُ عِبَادَهُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِۗ قُل لَّآ أَسۡـَٔلُكُمۡ عَلَيۡهِ أَجۡرًا إِلَّا ٱلۡمَوَدَّةَ فِي ٱلۡقُرۡبَىٰۗ وَمَن يَقۡتَرِفۡ حَسَنَةٗ نَّزِدۡ لَهُۥ فِيهَا حُسۡنًاۚ إِنَّ ٱللَّهَ غَفُورٞ شَكُورٌ",
    translation:
      'It is that of which Allah gives good tidings to His servants who believe and do righteous deeds. Say, [O Muhammad], "I do not ask you for this message any payment [but] only good will through kinship." And whoever commits a good deed - We will increase for him good therein. Indeed, Allah is Forgiving and Appreciative',
    normalizedText:
      "ذلك الذي يبشر الله عباده الذين ءامنوا وعملوا الصلحت قل لا اسلكم عليه اجرا الا المودة في القربى ومن يقترف حسنة نزد له فيها حسنا ان الله غفور شكور",
  },
  {
    verseId: 23,
    name: "الشورى",
    surahId: 42,
    text: "أَمۡ يَقُولُونَ ٱفۡتَرَىٰ عَلَى ٱللَّهِ كَذِبٗاۖ فَإِن يَشَإِ ٱللَّهُ يَخۡتِمۡ عَلَىٰ قَلۡبِكَۗ وَيَمۡحُ ٱللَّهُ ٱلۡبَٰطِلَ وَيُحِقُّ ٱلۡحَقَّ بِكَلِمَٰتِهِۦٓۚ إِنَّهُۥ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      'Or do they say, "He has invented about Allah a lie"? But if Allah willed, He could seal over your heart. And Allah eliminates falsehood and establishes the truth by His words. Indeed, He is Knowing of that within the breasts',
    normalizedText:
      "ام يقولون افترى على الله كذبا فان يشا الله يختم على قلبك ويمح الله البطل ويحق الحق بكلمته انه عليم بذات الصدور",
  },
  {
    verseId: 24,
    name: "الشورى",
    surahId: 42,
    text: "وَهُوَ ٱلَّذِي يَقۡبَلُ ٱلتَّوۡبَةَ عَنۡ عِبَادِهِۦ وَيَعۡفُواْ عَنِ ٱلسَّيِّـَٔاتِ وَيَعۡلَمُ مَا تَفۡعَلُونَ",
    translation:
      "And it is He who accepts repentance from his servants and pardons misdeeds, and He knows what you do",
    normalizedText:
      "وهو الذي يقبل التوبة عن عباده ويعفوا عن السيات ويعلم ما تفعلون",
  },
  {
    verseId: 25,
    name: "الشورى",
    surahId: 42,
    text: "وَيَسۡتَجِيبُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَيَزِيدُهُم مِّن فَضۡلِهِۦۚ وَٱلۡكَٰفِرُونَ لَهُمۡ عَذَابٞ شَدِيدٞ",
    translation:
      "And He answers [the supplication of] those who have believed and done righteous deeds and increases [for] them from His bounty. But the disbelievers will have a severe punishment",
    normalizedText:
      "ويستجيب الذين ءامنوا وعملوا الصلحت ويزيدهم من فضله والكفرون لهم عذاب شديد",
  },
  {
    verseId: 26,
    name: "الشورى",
    surahId: 42,
    text: "۞وَلَوۡ بَسَطَ ٱللَّهُ ٱلرِّزۡقَ لِعِبَادِهِۦ لَبَغَوۡاْ فِي ٱلۡأَرۡضِ وَلَٰكِن يُنَزِّلُ بِقَدَرٖ مَّا يَشَآءُۚ إِنَّهُۥ بِعِبَادِهِۦ خَبِيرُۢ بَصِيرٞ",
    translation:
      "And if Allah had extended [excessively] provision for His servants, they would have committed tyranny throughout the earth. But He sends [it] down in an amount which He wills. Indeed He is, of His servants, Acquainted and Seeing",
    normalizedText:
      "۞ولو بسط الله الرزق لعباده لبغوا في الارض ولكن ينزل بقدر ما يشاء انه بعباده خبير بصير",
  },
  {
    verseId: 27,
    name: "الشورى",
    surahId: 42,
    text: "وَهُوَ ٱلَّذِي يُنَزِّلُ ٱلۡغَيۡثَ مِنۢ بَعۡدِ مَا قَنَطُواْ وَيَنشُرُ رَحۡمَتَهُۥۚ وَهُوَ ٱلۡوَلِيُّ ٱلۡحَمِيدُ",
    translation:
      "And it is He who sends down the rain after they had despaired and spreads His mercy. And He is the Protector, the Praiseworthy",
    normalizedText:
      "وهو الذي ينزل الغيث من بعد ما قنطوا وينشر رحمته وهو الولي الحميد",
  },
  {
    verseId: 28,
    name: "الشورى",
    surahId: 42,
    text: "وَمِنۡ ءَايَٰتِهِۦ خَلۡقُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَثَّ فِيهِمَا مِن دَآبَّةٖۚ وَهُوَ عَلَىٰ جَمۡعِهِمۡ إِذَا يَشَآءُ قَدِيرٞ",
    translation:
      "And of his signs is the creation of the heavens and earth and what He has dispersed throughout them of creatures. And He, for gathering them when He wills, is competent",
    normalizedText:
      "ومن ءايته خلق السموت والارض وما بث فيهما من دابة وهو على جمعهم اذا يشاء قدير",
  },
  {
    verseId: 29,
    name: "الشورى",
    surahId: 42,
    text: "وَمَآ أَصَٰبَكُم مِّن مُّصِيبَةٖ فَبِمَا كَسَبَتۡ أَيۡدِيكُمۡ وَيَعۡفُواْ عَن كَثِيرٖ",
    translation:
      "And whatever strikes you of disaster - it is for what your hands have earned; but He pardons much",
    normalizedText: "وما اصبكم من مصيبة فبما كسبت ايديكم ويعفوا عن كثير",
  },
  {
    verseId: 30,
    name: "الشورى",
    surahId: 42,
    text: "وَمَآ أَنتُم بِمُعۡجِزِينَ فِي ٱلۡأَرۡضِۖ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِيّٖ وَلَا نَصِيرٖ",
    translation:
      "And you will not cause failure [to Allah] upon the earth. And you have not besides Allah any protector or helper",
    normalizedText:
      "وما انتم بمعجزين في الارض وما لكم من دون الله من ولي ولا نصير",
  },
  {
    verseId: 31,
    name: "الشورى",
    surahId: 42,
    text: "وَمِنۡ ءَايَٰتِهِ ٱلۡجَوَارِ فِي ٱلۡبَحۡرِ كَٱلۡأَعۡلَٰمِ",
    translation: "And of His signs are the ships in the sea, like mountains",
    normalizedText: "ومن ءايته الجوار في البحر كالاعلم",
  },
  {
    verseId: 32,
    name: "الشورى",
    surahId: 42,
    text: "إِن يَشَأۡ يُسۡكِنِ ٱلرِّيحَ فَيَظۡلَلۡنَ رَوَاكِدَ عَلَىٰ ظَهۡرِهِۦٓۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّكُلِّ صَبَّارٖ شَكُورٍ",
    translation:
      "If He willed, He could still the wind, and they would remain motionless on its surface. Indeed in that are signs for everyone patient and grateful",
    normalizedText:
      "ان يشا يسكن الريح فيظللن رواكد على ظهره ان في ذلك لايت لكل صبار شكور",
  },
  {
    verseId: 33,
    name: "الشورى",
    surahId: 42,
    text: "أَوۡ يُوبِقۡهُنَّ بِمَا كَسَبُواْ وَيَعۡفُ عَن كَثِيرٖ",
    translation:
      "Or He could destroy them for what they earned; but He pardons much",
    normalizedText: "او يوبقهن بما كسبوا ويعف عن كثير",
  },
  {
    verseId: 34,
    name: "الشورى",
    surahId: 42,
    text: "وَيَعۡلَمَ ٱلَّذِينَ يُجَٰدِلُونَ فِيٓ ءَايَٰتِنَا مَا لَهُم مِّن مَّحِيصٖ",
    translation:
      "And [that is so] those who dispute concerning Our signs may know that for them there is no place of escape",
    normalizedText: "ويعلم الذين يجدلون في ءايتنا ما لهم من محيص",
  },
  {
    verseId: 35,
    name: "الشورى",
    surahId: 42,
    text: "فَمَآ أُوتِيتُم مِّن شَيۡءٖ فَمَتَٰعُ ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۚ وَمَا عِندَ ٱللَّهِ خَيۡرٞ وَأَبۡقَىٰ لِلَّذِينَ ءَامَنُواْ وَعَلَىٰ رَبِّهِمۡ يَتَوَكَّلُونَ",
    translation:
      "So whatever thing you have been given - it is but [for] enjoyment of the worldly life. But what is with Allah is better and more lasting for those who have believed and upon their Lord rely",
    normalizedText:
      "فما اوتيتم من شيء فمتع الحيوة الدنيا وما عند الله خير وابقى للذين ءامنوا وعلى ربهم يتوكلون",
  },
  {
    verseId: 36,
    name: "الشورى",
    surahId: 42,
    text: "وَٱلَّذِينَ يَجۡتَنِبُونَ كَبَـٰٓئِرَ ٱلۡإِثۡمِ وَٱلۡفَوَٰحِشَ وَإِذَا مَا غَضِبُواْ هُمۡ يَغۡفِرُونَ",
    translation:
      "And those who avoid the major sins and immoralities, and when they are angry, they forgive",
    normalizedText: "والذين يجتنبون كبار الاثم والفوحش واذا ما غضبوا هم يغفرون",
  },
  {
    verseId: 37,
    name: "الشورى",
    surahId: 42,
    text: "وَٱلَّذِينَ ٱسۡتَجَابُواْ لِرَبِّهِمۡ وَأَقَامُواْ ٱلصَّلَوٰةَ وَأَمۡرُهُمۡ شُورَىٰ بَيۡنَهُمۡ وَمِمَّا رَزَقۡنَٰهُمۡ يُنفِقُونَ",
    translation:
      "And those who have responded to their lord and established prayer and whose affair is [determined by] consultation among themselves, and from what We have provided them, they spend",
    normalizedText:
      "والذين استجابوا لربهم واقاموا الصلوة وامرهم شورى بينهم ومما رزقنهم ينفقون",
  },
  {
    verseId: 38,
    name: "الشورى",
    surahId: 42,
    text: "وَٱلَّذِينَ إِذَآ أَصَابَهُمُ ٱلۡبَغۡيُ هُمۡ يَنتَصِرُونَ",
    translation:
      "And those who, when tyranny strikes them, they defend themselves",
    normalizedText: "والذين اذا اصابهم البغي هم ينتصرون",
  },
  {
    verseId: 39,
    name: "الشورى",
    surahId: 42,
    text: "وَجَزَـٰٓؤُاْ سَيِّئَةٖ سَيِّئَةٞ مِّثۡلُهَاۖ فَمَنۡ عَفَا وَأَصۡلَحَ فَأَجۡرُهُۥ عَلَى ٱللَّهِۚ إِنَّهُۥ لَا يُحِبُّ ٱلظَّـٰلِمِينَ",
    translation:
      "And the retribution for an evil act is an evil one like it, but whoever pardons and makes reconciliation - his reward is [due] from Allah. Indeed, He does not like wrongdoers",
    normalizedText:
      "وجزاا سياة سياة مثلها فمن عفا واصلح فاجره على الله انه لا يحب الظلمين",
  },
  {
    verseId: 40,
    name: "الشورى",
    surahId: 42,
    text: "وَلَمَنِ ٱنتَصَرَ بَعۡدَ ظُلۡمِهِۦ فَأُوْلَـٰٓئِكَ مَا عَلَيۡهِم مِّن سَبِيلٍ",
    translation:
      "And whoever avenges himself after having been wronged - those have not upon them any cause [for blame]",
    normalizedText: "ولمن انتصر بعد ظلمه فاولاك ما عليهم من سبيل",
  },
  {
    verseId: 41,
    name: "الشورى",
    surahId: 42,
    text: "إِنَّمَا ٱلسَّبِيلُ عَلَى ٱلَّذِينَ يَظۡلِمُونَ ٱلنَّاسَ وَيَبۡغُونَ فِي ٱلۡأَرۡضِ بِغَيۡرِ ٱلۡحَقِّۚ أُوْلَـٰٓئِكَ لَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "The cause is only against the ones who wrong the people and tyrannize upon the earth without right. Those will have a painful punishment",
    normalizedText:
      "انما السبيل على الذين يظلمون الناس ويبغون في الارض بغير الحق اولاك لهم عذاب اليم",
  },
  {
    verseId: 42,
    name: "الشورى",
    surahId: 42,
    text: "وَلَمَن صَبَرَ وَغَفَرَ إِنَّ ذَٰلِكَ لَمِنۡ عَزۡمِ ٱلۡأُمُورِ",
    translation:
      "And whoever is patient and forgives - indeed, that is of the matters [requiring] determination",
    normalizedText: "ولمن صبر وغفر ان ذلك لمن عزم الامور",
  },
  {
    verseId: 43,
    name: "الشورى",
    surahId: 42,
    text: "وَمَن يُضۡلِلِ ٱللَّهُ فَمَا لَهُۥ مِن وَلِيّٖ مِّنۢ بَعۡدِهِۦۗ وَتَرَى ٱلظَّـٰلِمِينَ لَمَّا رَأَوُاْ ٱلۡعَذَابَ يَقُولُونَ هَلۡ إِلَىٰ مَرَدّٖ مِّن سَبِيلٖ",
    translation:
      'And he whom Allah sends astray - for him there is no protector beyond Him. And you will see the wrongdoers, when they see the punishment, saying, "Is there for return [to the former world] any way',
    normalizedText:
      "ومن يضلل الله فما له من ولي من بعده وترى الظلمين لما راوا العذاب يقولون هل الى مرد من سبيل",
  },
  {
    verseId: 44,
    name: "الشورى",
    surahId: 42,
    text: "وَتَرَىٰهُمۡ يُعۡرَضُونَ عَلَيۡهَا خَٰشِعِينَ مِنَ ٱلذُّلِّ يَنظُرُونَ مِن طَرۡفٍ خَفِيّٖۗ وَقَالَ ٱلَّذِينَ ءَامَنُوٓاْ إِنَّ ٱلۡخَٰسِرِينَ ٱلَّذِينَ خَسِرُوٓاْ أَنفُسَهُمۡ وَأَهۡلِيهِمۡ يَوۡمَ ٱلۡقِيَٰمَةِۗ أَلَآ إِنَّ ٱلظَّـٰلِمِينَ فِي عَذَابٖ مُّقِيمٖ",
    translation:
      'And you will see them being exposed to the Fire, humbled from humiliation, looking from [behind] a covert glance. And those who had believed will say, "Indeed, the [true] losers are the ones who lost themselves and their families on the Day of Resurrection. Unquestionably, the wrongdoers are in an enduring punishment',
    normalizedText:
      "وترىهم يعرضون عليها خشعين من الذل ينظرون من طرف خفي وقال الذين ءامنوا ان الخسرين الذين خسروا انفسهم واهليهم يوم القيمة الا ان الظلمين في عذاب مقيم",
  },
  {
    verseId: 45,
    name: "الشورى",
    surahId: 42,
    text: "وَمَا كَانَ لَهُم مِّنۡ أَوۡلِيَآءَ يَنصُرُونَهُم مِّن دُونِ ٱللَّهِۗ وَمَن يُضۡلِلِ ٱللَّهُ فَمَا لَهُۥ مِن سَبِيلٍ",
    translation:
      "And there will not be for them any allies to aid them other than Allah. And whoever Allah sends astray - for him there is no way",
    normalizedText:
      "وما كان لهم من اولياء ينصرونهم من دون الله ومن يضلل الله فما له من سبيل",
  },
  {
    verseId: 46,
    name: "الشورى",
    surahId: 42,
    text: "ٱسۡتَجِيبُواْ لِرَبِّكُم مِّن قَبۡلِ أَن يَأۡتِيَ يَوۡمٞ لَّا مَرَدَّ لَهُۥ مِنَ ٱللَّهِۚ مَا لَكُم مِّن مَّلۡجَإٖ يَوۡمَئِذٖ وَمَا لَكُم مِّن نَّكِيرٖ",
    translation:
      "Respond to your Lord before a Day comes from Allah of which there is no repelling. No refuge will you have that day, nor for you will there be any denial",
    normalizedText:
      "استجيبوا لربكم من قبل ان ياتي يوم لا مرد له من الله ما لكم من ملجا يوماذ وما لكم من نكير",
  },
  {
    verseId: 47,
    name: "الشورى",
    surahId: 42,
    text: "فَإِنۡ أَعۡرَضُواْ فَمَآ أَرۡسَلۡنَٰكَ عَلَيۡهِمۡ حَفِيظًاۖ إِنۡ عَلَيۡكَ إِلَّا ٱلۡبَلَٰغُۗ وَإِنَّآ إِذَآ أَذَقۡنَا ٱلۡإِنسَٰنَ مِنَّا رَحۡمَةٗ فَرِحَ بِهَاۖ وَإِن تُصِبۡهُمۡ سَيِّئَةُۢ بِمَا قَدَّمَتۡ أَيۡدِيهِمۡ فَإِنَّ ٱلۡإِنسَٰنَ كَفُورٞ",
    translation:
      "But if they turn away - then We have not sent you, [O Muhammad], over them as a guardian; upon you is only [the duty of] notification. And indeed, when We let man taste mercy from us, he rejoices in it; but if evil afflicts him for what his hands have put forth, then indeed, man is ungrateful",
    normalizedText:
      "فان اعرضوا فما ارسلنك عليهم حفيظا ان عليك الا البلغ وانا اذا اذقنا الانسن منا رحمة فرح بها وان تصبهم سياة بما قدمت ايديهم فان الانسن كفور",
  },
  {
    verseId: 48,
    name: "الشورى",
    surahId: 42,
    text: "لِّلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ يَخۡلُقُ مَا يَشَآءُۚ يَهَبُ لِمَن يَشَآءُ إِنَٰثٗا وَيَهَبُ لِمَن يَشَآءُ ٱلذُّكُورَ",
    translation:
      "To Allah belongs the dominion of the heavens and the earth; He creates what he wills. He gives to whom He wills female [children], and He gives to whom He wills males",
    normalizedText:
      "لله ملك السموت والارض يخلق ما يشاء يهب لمن يشاء انثا ويهب لمن يشاء الذكور",
  },
  {
    verseId: 49,
    name: "الشورى",
    surahId: 42,
    text: "أَوۡ يُزَوِّجُهُمۡ ذُكۡرَانٗا وَإِنَٰثٗاۖ وَيَجۡعَلُ مَن يَشَآءُ عَقِيمًاۚ إِنَّهُۥ عَلِيمٞ قَدِيرٞ",
    translation:
      "Or He makes them [both] males and females, and He renders whom He wills barren. Indeed, He is Knowing and Competent",
    normalizedText: "او يزوجهم ذكرانا وانثا ويجعل من يشاء عقيما انه عليم قدير",
  },
  {
    verseId: 50,
    name: "الشورى",
    surahId: 42,
    text: "۞وَمَا كَانَ لِبَشَرٍ أَن يُكَلِّمَهُ ٱللَّهُ إِلَّا وَحۡيًا أَوۡ مِن وَرَآيِٕ حِجَابٍ أَوۡ يُرۡسِلَ رَسُولٗا فَيُوحِيَ بِإِذۡنِهِۦ مَا يَشَآءُۚ إِنَّهُۥ عَلِيٌّ حَكِيمٞ",
    translation:
      "And it is not for any human being that Allah should speak to him except by revelation or from behind a partition or that He sends a messenger to reveal, by His permission, what He wills. Indeed, He is Most High and Wise",
    normalizedText:
      "۞وما كان لبشر ان يكلمه الله الا وحيا او من وراي حجاب او يرسل رسولا فيوحي باذنه ما يشاء انه علي حكيم",
  },
  {
    verseId: 51,
    name: "الشورى",
    surahId: 42,
    text: "وَكَذَٰلِكَ أَوۡحَيۡنَآ إِلَيۡكَ رُوحٗا مِّنۡ أَمۡرِنَاۚ مَا كُنتَ تَدۡرِي مَا ٱلۡكِتَٰبُ وَلَا ٱلۡإِيمَٰنُ وَلَٰكِن جَعَلۡنَٰهُ نُورٗا نَّهۡدِي بِهِۦ مَن نَّشَآءُ مِنۡ عِبَادِنَاۚ وَإِنَّكَ لَتَهۡدِيٓ إِلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "And thus We have revealed to you an inspiration of Our command. You did not know what is the Book or [what is] faith, but We have made it a light by which We guide whom We will of Our servants. And indeed, [O Muhammad], you guide to a straight path",
    normalizedText:
      "وكذلك اوحينا اليك روحا من امرنا ما كنت تدري ما الكتب ولا الايمن ولكن جعلنه نورا نهدي به من نشاء من عبادنا وانك لتهدي الى صرط مستقيم",
  },
  {
    verseId: 52,
    name: "الشورى",
    surahId: 42,
    text: "صِرَٰطِ ٱللَّهِ ٱلَّذِي لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۗ أَلَآ إِلَى ٱللَّهِ تَصِيرُ ٱلۡأُمُورُ",
    translation:
      "The path of Allah, to whom belongs whatever is in the heavens and whatever is on the earth. Unquestionably, to Allah do [all] matters evolve",
    normalizedText:
      "صرط الله الذي له ما في السموت وما في الارض الا الى الله تصير الامور",
  },
  {
    verseId: 0,
    name: "الزخرف",
    surahId: 43,
    text: "حمٓ",
    translation: "Ha, Meem",
    normalizedText: "حم",
  },
  {
    verseId: 1,
    name: "الزخرف",
    surahId: 43,
    text: "وَٱلۡكِتَٰبِ ٱلۡمُبِينِ",
    translation: "By the clear Book",
    normalizedText: "والكتب المبين",
  },
  {
    verseId: 2,
    name: "الزخرف",
    surahId: 43,
    text: "إِنَّا جَعَلۡنَٰهُ قُرۡءَٰنًا عَرَبِيّٗا لَّعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      "Indeed, We have made it an Arabic Qur'an that you might understand",
    normalizedText: "انا جعلنه قرءنا عربيا لعلكم تعقلون",
  },
  {
    verseId: 3,
    name: "الزخرف",
    surahId: 43,
    text: "وَإِنَّهُۥ فِيٓ أُمِّ ٱلۡكِتَٰبِ لَدَيۡنَا لَعَلِيٌّ حَكِيمٌ",
    translation:
      "And indeed it is, in the Mother of the Book with Us, exalted and full of wisdom",
    normalizedText: "وانه في ام الكتب لدينا لعلي حكيم",
  },
  {
    verseId: 4,
    name: "الزخرف",
    surahId: 43,
    text: "أَفَنَضۡرِبُ عَنكُمُ ٱلذِّكۡرَ صَفۡحًا أَن كُنتُمۡ قَوۡمٗا مُّسۡرِفِينَ",
    translation:
      "Then should We turn the message away, disregarding you, because you are a transgressing people",
    normalizedText: "افنضرب عنكم الذكر صفحا ان كنتم قوما مسرفين",
  },
  {
    verseId: 5,
    name: "الزخرف",
    surahId: 43,
    text: "وَكَمۡ أَرۡسَلۡنَا مِن نَّبِيّٖ فِي ٱلۡأَوَّلِينَ",
    translation: "And how many a prophet We sent among the former peoples",
    normalizedText: "وكم ارسلنا من نبي في الاولين",
  },
  {
    verseId: 6,
    name: "الزخرف",
    surahId: 43,
    text: "وَمَا يَأۡتِيهِم مِّن نَّبِيٍّ إِلَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "But there would not come to them a prophet except that they used to ridicule him",
    normalizedText: "وما ياتيهم من نبي الا كانوا به يستهزءون",
  },
  {
    verseId: 7,
    name: "الزخرف",
    surahId: 43,
    text: "فَأَهۡلَكۡنَآ أَشَدَّ مِنۡهُم بَطۡشٗا وَمَضَىٰ مَثَلُ ٱلۡأَوَّلِينَ",
    translation:
      "And We destroyed greater than them in [striking] power, and the example of the former peoples has preceded",
    normalizedText: "فاهلكنا اشد منهم بطشا ومضى مثل الاولين",
  },
  {
    verseId: 8,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَئِن سَأَلۡتَهُم مَّنۡ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ لَيَقُولُنَّ خَلَقَهُنَّ ٱلۡعَزِيزُ ٱلۡعَلِيمُ",
    translation:
      'And if you should ask them, "Who has created the heavens and the earth?" they would surely say, "They were created by the Exalted in Might, the Knowing',
    normalizedText:
      "ولان سالتهم من خلق السموت والارض ليقولن خلقهن العزيز العليم",
  },
  {
    verseId: 9,
    name: "الزخرف",
    surahId: 43,
    text: "ٱلَّذِي جَعَلَ لَكُمُ ٱلۡأَرۡضَ مَهۡدٗا وَجَعَلَ لَكُمۡ فِيهَا سُبُلٗا لَّعَلَّكُمۡ تَهۡتَدُونَ",
    translation:
      "[The one] who has made for you the earth a bed and made for you upon it roads that you might be guided",
    normalizedText: "الذي جعل لكم الارض مهدا وجعل لكم فيها سبلا لعلكم تهتدون",
  },
  {
    verseId: 10,
    name: "الزخرف",
    surahId: 43,
    text: "وَٱلَّذِي نَزَّلَ مِنَ ٱلسَّمَآءِ مَآءَۢ بِقَدَرٖ فَأَنشَرۡنَا بِهِۦ بَلۡدَةٗ مَّيۡتٗاۚ كَذَٰلِكَ تُخۡرَجُونَ",
    translation:
      "And who sends down rain from the sky in measured amounts, and We revive thereby a dead land - thus will you be brought forth",
    normalizedText:
      "والذي نزل من السماء ماء بقدر فانشرنا به بلدة ميتا كذلك تخرجون",
  },
  {
    verseId: 11,
    name: "الزخرف",
    surahId: 43,
    text: "وَٱلَّذِي خَلَقَ ٱلۡأَزۡوَٰجَ كُلَّهَا وَجَعَلَ لَكُم مِّنَ ٱلۡفُلۡكِ وَٱلۡأَنۡعَٰمِ مَا تَرۡكَبُونَ",
    translation:
      "And who created the species, all of them, and has made for you of ships and animals those which you mount",
    normalizedText: "والذي خلق الازوج كلها وجعل لكم من الفلك والانعم ما تركبون",
  },
  {
    verseId: 12,
    name: "الزخرف",
    surahId: 43,
    text: "لِتَسۡتَوُۥاْ عَلَىٰ ظُهُورِهِۦ ثُمَّ تَذۡكُرُواْ نِعۡمَةَ رَبِّكُمۡ إِذَا ٱسۡتَوَيۡتُمۡ عَلَيۡهِ وَتَقُولُواْ سُبۡحَٰنَ ٱلَّذِي سَخَّرَ لَنَا هَٰذَا وَمَا كُنَّا لَهُۥ مُقۡرِنِينَ",
    translation:
      'That you may settle yourselves upon their backs and then remember the favor of your Lord when you have settled upon them and say. "Exalted is He who has subjected this to us, and we could not have [otherwise] subdued it',
    normalizedText:
      "لتستوا على ظهوره ثم تذكروا نعمة ربكم اذا استويتم عليه وتقولوا سبحن الذي سخر لنا هذا وما كنا له مقرنين",
  },
  {
    verseId: 13,
    name: "الزخرف",
    surahId: 43,
    text: "وَإِنَّآ إِلَىٰ رَبِّنَا لَمُنقَلِبُونَ",
    translation: "And indeed we, to our Lord, will [surely] return",
    normalizedText: "وانا الى ربنا لمنقلبون",
  },
  {
    verseId: 14,
    name: "الزخرف",
    surahId: 43,
    text: "وَجَعَلُواْ لَهُۥ مِنۡ عِبَادِهِۦ جُزۡءًاۚ إِنَّ ٱلۡإِنسَٰنَ لَكَفُورٞ مُّبِينٌ",
    translation:
      "But they have attributed to Him from His servants a portion. Indeed, man is clearly ungrateful",
    normalizedText: "وجعلوا له من عباده جزءا ان الانسن لكفور مبين",
  },
  {
    verseId: 15,
    name: "الزخرف",
    surahId: 43,
    text: "أَمِ ٱتَّخَذَ مِمَّا يَخۡلُقُ بَنَاتٖ وَأَصۡفَىٰكُم بِٱلۡبَنِينَ",
    translation:
      "Or has He taken, out of what He has created, daughters and chosen you for [having] sons",
    normalizedText: "ام اتخذ مما يخلق بنات واصفىكم بالبنين",
  },
  {
    verseId: 16,
    name: "الزخرف",
    surahId: 43,
    text: "وَإِذَا بُشِّرَ أَحَدُهُم بِمَا ضَرَبَ لِلرَّحۡمَٰنِ مَثَلٗا ظَلَّ وَجۡهُهُۥ مُسۡوَدّٗا وَهُوَ كَظِيمٌ",
    translation:
      "And when one of them is given good tidings of that which he attributes to the Most Merciful in comparison, his face becomes dark, and he suppresses grief",
    normalizedText: "واذا بشر احدهم بما ضرب للرحمن مثلا ظل وجهه مسودا وهو كظيم",
  },
  {
    verseId: 17,
    name: "الزخرف",
    surahId: 43,
    text: "أَوَمَن يُنَشَّؤُاْ فِي ٱلۡحِلۡيَةِ وَهُوَ فِي ٱلۡخِصَامِ غَيۡرُ مُبِينٖ",
    translation:
      "So is one brought up in ornaments while being during conflict unevident [attributed to Allah]",
    normalizedText: "اومن ينشاا في الحلية وهو في الخصام غير مبين",
  },
  {
    verseId: 18,
    name: "الزخرف",
    surahId: 43,
    text: "وَجَعَلُواْ ٱلۡمَلَـٰٓئِكَةَ ٱلَّذِينَ هُمۡ عِبَٰدُ ٱلرَّحۡمَٰنِ إِنَٰثًاۚ أَشَهِدُواْ خَلۡقَهُمۡۚ سَتُكۡتَبُ شَهَٰدَتُهُمۡ وَيُسۡـَٔلُونَ",
    translation:
      "And they have made the angels, who are servants of the Most Merciful, females. Did they witness their creation? Their testimony will be recorded, and they will be questioned",
    normalizedText:
      "وجعلوا الملاكة الذين هم عبد الرحمن انثا اشهدوا خلقهم ستكتب شهدتهم ويسلون",
  },
  {
    verseId: 19,
    name: "الزخرف",
    surahId: 43,
    text: "وَقَالُواْ لَوۡ شَآءَ ٱلرَّحۡمَٰنُ مَا عَبَدۡنَٰهُمۗ مَّا لَهُم بِذَٰلِكَ مِنۡ عِلۡمٍۖ إِنۡ هُمۡ إِلَّا يَخۡرُصُونَ",
    translation:
      'And they said, "If the Most Merciful had willed, we would not have worshipped them." They have of that no knowledge. They are not but falsifying',
    normalizedText:
      "وقالوا لو شاء الرحمن ما عبدنهم ما لهم بذلك من علم ان هم الا يخرصون",
  },
  {
    verseId: 20,
    name: "الزخرف",
    surahId: 43,
    text: "أَمۡ ءَاتَيۡنَٰهُمۡ كِتَٰبٗا مِّن قَبۡلِهِۦ فَهُم بِهِۦ مُسۡتَمۡسِكُونَ",
    translation:
      "Or have We given them a book before the Qur'an to which they are adhering",
    normalizedText: "ام ءاتينهم كتبا من قبله فهم به مستمسكون",
  },
  {
    verseId: 21,
    name: "الزخرف",
    surahId: 43,
    text: "بَلۡ قَالُوٓاْ إِنَّا وَجَدۡنَآ ءَابَآءَنَا عَلَىٰٓ أُمَّةٖ وَإِنَّا عَلَىٰٓ ءَاثَٰرِهِم مُّهۡتَدُونَ",
    translation:
      'Rather, they say, "Indeed, we found our fathers upon a religion, and we are in their footsteps [rightly] guided',
    normalizedText: "بل قالوا انا وجدنا ءاباءنا على امة وانا على ءاثرهم مهتدون",
  },
  {
    verseId: 22,
    name: "الزخرف",
    surahId: 43,
    text: "وَكَذَٰلِكَ مَآ أَرۡسَلۡنَا مِن قَبۡلِكَ فِي قَرۡيَةٖ مِّن نَّذِيرٍ إِلَّا قَالَ مُتۡرَفُوهَآ إِنَّا وَجَدۡنَآ ءَابَآءَنَا عَلَىٰٓ أُمَّةٖ وَإِنَّا عَلَىٰٓ ءَاثَٰرِهِم مُّقۡتَدُونَ",
    translation:
      'And similarly, We did not send before you any warner into a city except that its affluent said, "Indeed, we found our fathers upon a religion, and we are, in their footsteps, following',
    normalizedText:
      "وكذلك ما ارسلنا من قبلك في قرية من نذير الا قال مترفوها انا وجدنا ءاباءنا على امة وانا على ءاثرهم مقتدون",
  },
  {
    verseId: 23,
    name: "الزخرف",
    surahId: 43,
    text: "۞قَٰلَ أَوَلَوۡ جِئۡتُكُم بِأَهۡدَىٰ مِمَّا وَجَدتُّمۡ عَلَيۡهِ ءَابَآءَكُمۡۖ قَالُوٓاْ إِنَّا بِمَآ أُرۡسِلۡتُم بِهِۦ كَٰفِرُونَ",
    translation:
      '[Each warner] said, "Even if I brought you better guidance than that [religion] upon which you found your fathers?" They said, "Indeed we, in that with which you were sent, are disbelievers',
    normalizedText:
      "۞قل اولو جاتكم باهدى مما وجدتم عليه ءاباءكم قالوا انا بما ارسلتم به كفرون",
  },
  {
    verseId: 24,
    name: "الزخرف",
    surahId: 43,
    text: "فَٱنتَقَمۡنَا مِنۡهُمۡۖ فَٱنظُرۡ كَيۡفَ كَانَ عَٰقِبَةُ ٱلۡمُكَذِّبِينَ",
    translation:
      "So we took retribution from them; then see how was the end of the deniers",
    normalizedText: "فانتقمنا منهم فانظر كيف كان عقبة المكذبين",
  },
  {
    verseId: 25,
    name: "الزخرف",
    surahId: 43,
    text: "وَإِذۡ قَالَ إِبۡرَٰهِيمُ لِأَبِيهِ وَقَوۡمِهِۦٓ إِنَّنِي بَرَآءٞ مِّمَّا تَعۡبُدُونَ",
    translation:
      'And [mention, O Muhammad], when Abraham said to his father and his people, "Indeed, I am disassociated from that which you worship',
    normalizedText: "واذ قال ابرهيم لابيه وقومه انني براء مما تعبدون",
  },
  {
    verseId: 26,
    name: "الزخرف",
    surahId: 43,
    text: "إِلَّا ٱلَّذِي فَطَرَنِي فَإِنَّهُۥ سَيَهۡدِينِ",
    translation: "Except for He who created me; and indeed, He will guide me",
    normalizedText: "الا الذي فطرني فانه سيهدين",
  },
  {
    verseId: 27,
    name: "الزخرف",
    surahId: 43,
    text: "وَجَعَلَهَا كَلِمَةَۢ بَاقِيَةٗ فِي عَقِبِهِۦ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      "And he made it a word remaining among his descendants that they might return [to it]",
    normalizedText: "وجعلها كلمة باقية في عقبه لعلهم يرجعون",
  },
  {
    verseId: 28,
    name: "الزخرف",
    surahId: 43,
    text: "بَلۡ مَتَّعۡتُ هَـٰٓؤُلَآءِ وَءَابَآءَهُمۡ حَتَّىٰ جَآءَهُمُ ٱلۡحَقُّ وَرَسُولٞ مُّبِينٞ",
    translation:
      "However, I gave enjoyment to these [people of Makkah] and their fathers until there came to them the truth and a clear Messenger",
    normalizedText: "بل متعت هالاء وءاباءهم حتى جاءهم الحق ورسول مبين",
  },
  {
    verseId: 29,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَمَّا جَآءَهُمُ ٱلۡحَقُّ قَالُواْ هَٰذَا سِحۡرٞ وَإِنَّا بِهِۦ كَٰفِرُونَ",
    translation:
      'But when the truth came to them, they said, "This is magic, and indeed we are, concerning it, disbelievers',
    normalizedText: "ولما جاءهم الحق قالوا هذا سحر وانا به كفرون",
  },
  {
    verseId: 30,
    name: "الزخرف",
    surahId: 43,
    text: "وَقَالُواْ لَوۡلَا نُزِّلَ هَٰذَا ٱلۡقُرۡءَانُ عَلَىٰ رَجُلٖ مِّنَ ٱلۡقَرۡيَتَيۡنِ عَظِيمٍ",
    translation: `And they said, "Why was this Qur'an not sent down upon a great man from [one of] the two cities`,
    normalizedText: "وقالوا لولا نزل هذا القرءان على رجل من القريتين عظيم",
  },
  {
    verseId: 31,
    name: "الزخرف",
    surahId: 43,
    text: "أَهُمۡ يَقۡسِمُونَ رَحۡمَتَ رَبِّكَۚ نَحۡنُ قَسَمۡنَا بَيۡنَهُم مَّعِيشَتَهُمۡ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۚ وَرَفَعۡنَا بَعۡضَهُمۡ فَوۡقَ بَعۡضٖ دَرَجَٰتٖ لِّيَتَّخِذَ بَعۡضُهُم بَعۡضٗا سُخۡرِيّٗاۗ وَرَحۡمَتُ رَبِّكَ خَيۡرٞ مِّمَّا يَجۡمَعُونَ",
    translation:
      "Do they distribute the mercy of your Lord? It is We who have apportioned among them their livelihood in the life of this world and have raised some of them above others in degrees [of rank] that they may make use of one another for service. But the mercy of your Lord is better than whatever they accumulate",
    normalizedText:
      "اهم يقسمون رحمت ربك نحن قسمنا بينهم معيشتهم في الحيوة الدنيا ورفعنا بعضهم فوق بعض درجت ليتخذ بعضهم بعضا سخريا ورحمت ربك خير مما يجمعون",
  },
  {
    verseId: 32,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَوۡلَآ أَن يَكُونَ ٱلنَّاسُ أُمَّةٗ وَٰحِدَةٗ لَّجَعَلۡنَا لِمَن يَكۡفُرُ بِٱلرَّحۡمَٰنِ لِبُيُوتِهِمۡ سُقُفٗا مِّن فِضَّةٖ وَمَعَارِجَ عَلَيۡهَا يَظۡهَرُونَ",
    translation:
      "And if it were not that the people would become one community [of disbelievers], We would have made for those who disbelieve in the Most Merciful - for their houses - ceilings and stairways of silver upon which to mount",
    normalizedText:
      "ولولا ان يكون الناس امة وحدة لجعلنا لمن يكفر بالرحمن لبيوتهم سقفا من فضة ومعارج عليها يظهرون",
  },
  {
    verseId: 33,
    name: "الزخرف",
    surahId: 43,
    text: "وَلِبُيُوتِهِمۡ أَبۡوَٰبٗا وَسُرُرًا عَلَيۡهَا يَتَّكِـُٔونَ",
    translation:
      "And for their houses - doors and couches [of silver] upon which to recline",
    normalizedText: "ولبيوتهم ابوبا وسررا عليها يتكون",
  },
  {
    verseId: 34,
    name: "الزخرف",
    surahId: 43,
    text: "وَزُخۡرُفٗاۚ وَإِن كُلُّ ذَٰلِكَ لَمَّا مَتَٰعُ ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۚ وَٱلۡأٓخِرَةُ عِندَ رَبِّكَ لِلۡمُتَّقِينَ",
    translation:
      "And gold ornament. But all that is not but the enjoyment of worldly life. And the Hereafter with your Lord is for the righteous",
    normalizedText:
      "وزخرفا وان كل ذلك لما متع الحيوة الدنيا والاخرة عند ربك للمتقين",
  },
  {
    verseId: 35,
    name: "الزخرف",
    surahId: 43,
    text: "وَمَن يَعۡشُ عَن ذِكۡرِ ٱلرَّحۡمَٰنِ نُقَيِّضۡ لَهُۥ شَيۡطَٰنٗا فَهُوَ لَهُۥ قَرِينٞ",
    translation:
      "And whoever is blinded from remembrance of the Most Merciful - We appoint for him a devil, and he is to him a companion",
    normalizedText: "ومن يعش عن ذكر الرحمن نقيض له شيطنا فهو له قرين",
  },
  {
    verseId: 36,
    name: "الزخرف",
    surahId: 43,
    text: "وَإِنَّهُمۡ لَيَصُدُّونَهُمۡ عَنِ ٱلسَّبِيلِ وَيَحۡسَبُونَ أَنَّهُم مُّهۡتَدُونَ",
    translation:
      "And indeed, the devils avert them from the way [of guidance] while they think that they are [rightly] guided",
    normalizedText: "وانهم ليصدونهم عن السبيل ويحسبون انهم مهتدون",
  },
  {
    verseId: 37,
    name: "الزخرف",
    surahId: 43,
    text: "حَتَّىٰٓ إِذَا جَآءَنَا قَالَ يَٰلَيۡتَ بَيۡنِي وَبَيۡنَكَ بُعۡدَ ٱلۡمَشۡرِقَيۡنِ فَبِئۡسَ ٱلۡقَرِينُ",
    translation:
      'Until, when he comes to Us [at Judgement], he says [to his companion], "Oh, I wish there was between me and you the distance between the east and west - how wretched a companion',
    normalizedText:
      "حتى اذا جاءنا قال يليت بيني وبينك بعد المشرقين فباس القرين",
  },
  {
    verseId: 38,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَن يَنفَعَكُمُ ٱلۡيَوۡمَ إِذ ظَّلَمۡتُمۡ أَنَّكُمۡ فِي ٱلۡعَذَابِ مُشۡتَرِكُونَ",
    translation:
      "And never will it benefit you that Day, when you have wronged, that you are [all] sharing in the punishment",
    normalizedText: "ولن ينفعكم اليوم اذ ظلمتم انكم في العذاب مشتركون",
  },
  {
    verseId: 39,
    name: "الزخرف",
    surahId: 43,
    text: "أَفَأَنتَ تُسۡمِعُ ٱلصُّمَّ أَوۡ تَهۡدِي ٱلۡعُمۡيَ وَمَن كَانَ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      "Then will you make the deaf hear, [O Muhammad], or guide the blind or he who is in clear error",
    normalizedText: "افانت تسمع الصم او تهدي العمي ومن كان في ضلل مبين",
  },
  {
    verseId: 40,
    name: "الزخرف",
    surahId: 43,
    text: "فَإِمَّا نَذۡهَبَنَّ بِكَ فَإِنَّا مِنۡهُم مُّنتَقِمُونَ",
    translation:
      "And whether [or not] We take you away [in death], indeed, We will take retribution upon them",
    normalizedText: "فاما نذهبن بك فانا منهم منتقمون",
  },
  {
    verseId: 41,
    name: "الزخرف",
    surahId: 43,
    text: "أَوۡ نُرِيَنَّكَ ٱلَّذِي وَعَدۡنَٰهُمۡ فَإِنَّا عَلَيۡهِم مُّقۡتَدِرُونَ",
    translation:
      "Or whether [or not] We show you that which We have promised them, indeed, We are Perfect in Ability",
    normalizedText: "او نرينك الذي وعدنهم فانا عليهم مقتدرون",
  },
  {
    verseId: 42,
    name: "الزخرف",
    surahId: 43,
    text: "فَٱسۡتَمۡسِكۡ بِٱلَّذِيٓ أُوحِيَ إِلَيۡكَۖ إِنَّكَ عَلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "So adhere to that which is revealed to you. Indeed, you are on a straight path",
    normalizedText: "فاستمسك بالذي اوحي اليك انك على صرط مستقيم",
  },
  {
    verseId: 43,
    name: "الزخرف",
    surahId: 43,
    text: "وَإِنَّهُۥ لَذِكۡرٞ لَّكَ وَلِقَوۡمِكَۖ وَسَوۡفَ تُسۡـَٔلُونَ",
    translation:
      "And indeed, it is a remembrance for you and your people, and you [all] are going to be questioned",
    normalizedText: "وانه لذكر لك ولقومك وسوف تسلون",
  },
  {
    verseId: 44,
    name: "الزخرف",
    surahId: 43,
    text: "وَسۡـَٔلۡ مَنۡ أَرۡسَلۡنَا مِن قَبۡلِكَ مِن رُّسُلِنَآ أَجَعَلۡنَا مِن دُونِ ٱلرَّحۡمَٰنِ ءَالِهَةٗ يُعۡبَدُونَ",
    translation:
      "And ask those We sent before you of Our messengers; have We made besides the Most Merciful deities to be worshipped",
    normalizedText:
      "وسل من ارسلنا من قبلك من رسلنا اجعلنا من دون الرحمن ءالهة يعبدون",
  },
  {
    verseId: 45,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَقَدۡ أَرۡسَلۡنَا مُوسَىٰ بِـَٔايَٰتِنَآ إِلَىٰ فِرۡعَوۡنَ وَمَلَإِيْهِۦ فَقَالَ إِنِّي رَسُولُ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      'And certainly did We send Moses with Our signs to Pharaoh and his establishment, and he said, "Indeed, I am the messenger of the Lord of the worlds',
    normalizedText:
      "ولقد ارسلنا موسى بايتنا الى فرعون وملايه فقال اني رسول رب العلمين",
  },
  {
    verseId: 46,
    name: "الزخرف",
    surahId: 43,
    text: "فَلَمَّا جَآءَهُم بِـَٔايَٰتِنَآ إِذَا هُم مِّنۡهَا يَضۡحَكُونَ",
    translation:
      "But when he brought them Our signs, at once they laughed at them",
    normalizedText: "فلما جاءهم بايتنا اذا هم منها يضحكون",
  },
  {
    verseId: 47,
    name: "الزخرف",
    surahId: 43,
    text: "وَمَا نُرِيهِم مِّنۡ ءَايَةٍ إِلَّا هِيَ أَكۡبَرُ مِنۡ أُخۡتِهَاۖ وَأَخَذۡنَٰهُم بِٱلۡعَذَابِ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      "And We showed them not a sign except that it was greater than its sister, and We seized them with affliction that perhaps they might return [to faith]",
    normalizedText:
      "وما نريهم من ءاية الا هي اكبر من اختها واخذنهم بالعذاب لعلهم يرجعون",
  },
  {
    verseId: 48,
    name: "الزخرف",
    surahId: 43,
    text: "وَقَالُواْ يَـٰٓأَيُّهَ ٱلسَّاحِرُ ٱدۡعُ لَنَا رَبَّكَ بِمَا عَهِدَ عِندَكَ إِنَّنَا لَمُهۡتَدُونَ",
    translation:
      'And they said [to Moses], "O magician, invoke for us your Lord by what He has promised you. Indeed, we will be guided',
    normalizedText: "وقالوا يايه الساحر ادع لنا ربك بما عهد عندك اننا لمهتدون",
  },
  {
    verseId: 49,
    name: "الزخرف",
    surahId: 43,
    text: "فَلَمَّا كَشَفۡنَا عَنۡهُمُ ٱلۡعَذَابَ إِذَا هُمۡ يَنكُثُونَ",
    translation:
      "But when We removed from them the affliction, at once they broke their word",
    normalizedText: "فلما كشفنا عنهم العذاب اذا هم ينكثون",
  },
  {
    verseId: 50,
    name: "الزخرف",
    surahId: 43,
    text: "وَنَادَىٰ فِرۡعَوۡنُ فِي قَوۡمِهِۦ قَالَ يَٰقَوۡمِ أَلَيۡسَ لِي مُلۡكُ مِصۡرَ وَهَٰذِهِ ٱلۡأَنۡهَٰرُ تَجۡرِي مِن تَحۡتِيٓۚ أَفَلَا تُبۡصِرُونَ",
    translation:
      'And Pharaoh called out among his people; he said, "O my people, does not the kingdom of Egypt belong to me, and these rivers flowing beneath me; then do you not see',
    normalizedText:
      "ونادى فرعون في قومه قال يقوم اليس لي ملك مصر وهذه الانهر تجري من تحتي افلا تبصرون",
  },
  {
    verseId: 51,
    name: "الزخرف",
    surahId: 43,
    text: "أَمۡ أَنَا۠ خَيۡرٞ مِّنۡ هَٰذَا ٱلَّذِي هُوَ مَهِينٞ وَلَا يَكَادُ يُبِينُ",
    translation:
      "Or am I [not] better than this one who is insignificant and hardly makes himself clear",
    normalizedText: "ام انا خير من هذا الذي هو مهين ولا يكاد يبين",
  },
  {
    verseId: 52,
    name: "الزخرف",
    surahId: 43,
    text: "فَلَوۡلَآ أُلۡقِيَ عَلَيۡهِ أَسۡوِرَةٞ مِّن ذَهَبٍ أَوۡ جَآءَ مَعَهُ ٱلۡمَلَـٰٓئِكَةُ مُقۡتَرِنِينَ",
    translation:
      "Then why have there not been placed upon him bracelets of gold or come with him the angels in conjunction",
    normalizedText: "فلولا القي عليه اسورة من ذهب او جاء معه الملاكة مقترنين",
  },
  {
    verseId: 53,
    name: "الزخرف",
    surahId: 43,
    text: "فَٱسۡتَخَفَّ قَوۡمَهُۥ فَأَطَاعُوهُۚ إِنَّهُمۡ كَانُواْ قَوۡمٗا فَٰسِقِينَ",
    translation:
      "So he bluffed his people, and they obeyed him. Indeed, they were [themselves] a people defiantly disobedient [of Allah]",
    normalizedText: "فاستخف قومه فاطاعوه انهم كانوا قوما فسقين",
  },
  {
    verseId: 54,
    name: "الزخرف",
    surahId: 43,
    text: "فَلَمَّآ ءَاسَفُونَا ٱنتَقَمۡنَا مِنۡهُمۡ فَأَغۡرَقۡنَٰهُمۡ أَجۡمَعِينَ",
    translation:
      "And when they angered Us, We took retribution from them and drowned them all",
    normalizedText: "فلما ءاسفونا انتقمنا منهم فاغرقنهم اجمعين",
  },
  {
    verseId: 55,
    name: "الزخرف",
    surahId: 43,
    text: "فَجَعَلۡنَٰهُمۡ سَلَفٗا وَمَثَلٗا لِّلۡأٓخِرِينَ",
    translation:
      "And We made them a precedent and an example for the later peoples",
    normalizedText: "فجعلنهم سلفا ومثلا للاخرين",
  },
  {
    verseId: 56,
    name: "الزخرف",
    surahId: 43,
    text: "۞وَلَمَّا ضُرِبَ ٱبۡنُ مَرۡيَمَ مَثَلًا إِذَا قَوۡمُكَ مِنۡهُ يَصِدُّونَ",
    translation:
      "And when the son of Mary was presented as an example, immediately your people laughed aloud",
    normalizedText: "۞ولما ضرب ابن مريم مثلا اذا قومك منه يصدون",
  },
  {
    verseId: 57,
    name: "الزخرف",
    surahId: 43,
    text: "وَقَالُوٓاْ ءَأَٰلِهَتُنَا خَيۡرٌ أَمۡ هُوَۚ مَا ضَرَبُوهُ لَكَ إِلَّا جَدَلَۢاۚ بَلۡ هُمۡ قَوۡمٌ خَصِمُونَ",
    translation:
      'And they said, "Are your gods better, or is he?" They did not present the comparison except for [mere] argument. But, [in fact], they are a people prone to dispute',
    normalizedText:
      "وقالوا ءالهتنا خير ام هو ما ضربوه لك الا جدلا بل هم قوم خصمون",
  },
  {
    verseId: 58,
    name: "الزخرف",
    surahId: 43,
    text: "إِنۡ هُوَ إِلَّا عَبۡدٌ أَنۡعَمۡنَا عَلَيۡهِ وَجَعَلۡنَٰهُ مَثَلٗا لِّبَنِيٓ إِسۡرَـٰٓءِيلَ",
    translation:
      "Jesus was not but a servant upon whom We bestowed favor, and We made him an example for the Children of Israel",
    normalizedText: "ان هو الا عبد انعمنا عليه وجعلنه مثلا لبني اسرءيل",
  },
  {
    verseId: 59,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَوۡ نَشَآءُ لَجَعَلۡنَا مِنكُم مَّلَـٰٓئِكَةٗ فِي ٱلۡأَرۡضِ يَخۡلُفُونَ",
    translation:
      "And if We willed, We could have made [instead] of you angels succeeding [one another] on the earth",
    normalizedText: "ولو نشاء لجعلنا منكم ملاكة في الارض يخلفون",
  },
  {
    verseId: 60,
    name: "الزخرف",
    surahId: 43,
    text: "وَإِنَّهُۥ لَعِلۡمٞ لِّلسَّاعَةِ فَلَا تَمۡتَرُنَّ بِهَا وَٱتَّبِعُونِۚ هَٰذَا صِرَٰطٞ مُّسۡتَقِيمٞ",
    translation:
      "And indeed, Jesus will be [a sign for] knowledge of the Hour, so be not in doubt of it, and follow Me. This is a straight path",
    normalizedText: "وانه لعلم للساعة فلا تمترن بها واتبعون هذا صرط مستقيم",
  },
  {
    verseId: 61,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَا يَصُدَّنَّكُمُ ٱلشَّيۡطَٰنُۖ إِنَّهُۥ لَكُمۡ عَدُوّٞ مُّبِينٞ",
    translation:
      "And never let Satan avert you. Indeed, he is to you a clear enemy",
    normalizedText: "ولا يصدنكم الشيطن انه لكم عدو مبين",
  },
  {
    verseId: 62,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَمَّا جَآءَ عِيسَىٰ بِٱلۡبَيِّنَٰتِ قَالَ قَدۡ جِئۡتُكُم بِٱلۡحِكۡمَةِ وَلِأُبَيِّنَ لَكُم بَعۡضَ ٱلَّذِي تَخۡتَلِفُونَ فِيهِۖ فَٱتَّقُواْ ٱللَّهَ وَأَطِيعُونِ",
    translation:
      'And when Jesus brought clear proofs, he said, "I have come to you with wisdom and to make clear to you some of that over which you differ, so fear Allah and obey me',
    normalizedText:
      "ولما جاء عيسى بالبينت قال قد جاتكم بالحكمة ولابين لكم بعض الذي تختلفون فيه فاتقوا الله واطيعون",
  },
  {
    verseId: 63,
    name: "الزخرف",
    surahId: 43,
    text: "إِنَّ ٱللَّهَ هُوَ رَبِّي وَرَبُّكُمۡ فَٱعۡبُدُوهُۚ هَٰذَا صِرَٰطٞ مُّسۡتَقِيمٞ",
    translation:
      "Indeed, Allah is my Lord and your Lord, so worship Him. This is a straight path",
    normalizedText: "ان الله هو ربي وربكم فاعبدوه هذا صرط مستقيم",
  },
  {
    verseId: 64,
    name: "الزخرف",
    surahId: 43,
    text: "فَٱخۡتَلَفَ ٱلۡأَحۡزَابُ مِنۢ بَيۡنِهِمۡۖ فَوَيۡلٞ لِّلَّذِينَ ظَلَمُواْ مِنۡ عَذَابِ يَوۡمٍ أَلِيمٍ",
    translation:
      "But the denominations from among them differed [and separated], so woe to those who have wronged from the punishment of a painful Day",
    normalizedText: "فاختلف الاحزاب من بينهم فويل للذين ظلموا من عذاب يوم اليم",
  },
  {
    verseId: 65,
    name: "الزخرف",
    surahId: 43,
    text: "هَلۡ يَنظُرُونَ إِلَّا ٱلسَّاعَةَ أَن تَأۡتِيَهُم بَغۡتَةٗ وَهُمۡ لَا يَشۡعُرُونَ",
    translation:
      "Are they waiting except for the Hour to come upon them suddenly while they perceive not",
    normalizedText: "هل ينظرون الا الساعة ان تاتيهم بغتة وهم لا يشعرون",
  },
  {
    verseId: 66,
    name: "الزخرف",
    surahId: 43,
    text: "ٱلۡأَخِلَّآءُ يَوۡمَئِذِۭ بَعۡضُهُمۡ لِبَعۡضٍ عَدُوٌّ إِلَّا ٱلۡمُتَّقِينَ",
    translation:
      "Close friends, that Day, will be enemies to each other, except for the righteous",
    normalizedText: "الاخلاء يوماذ بعضهم لبعض عدو الا المتقين",
  },
  {
    verseId: 67,
    name: "الزخرف",
    surahId: 43,
    text: "يَٰعِبَادِ لَا خَوۡفٌ عَلَيۡكُمُ ٱلۡيَوۡمَ وَلَآ أَنتُمۡ تَحۡزَنُونَ",
    translation:
      '[To whom Allah will say], "O My servants, no fear will there be concerning you this Day, nor will you grieve',
    normalizedText: "يعباد لا خوف عليكم اليوم ولا انتم تحزنون",
  },
  {
    verseId: 68,
    name: "الزخرف",
    surahId: 43,
    text: "ٱلَّذِينَ ءَامَنُواْ بِـَٔايَٰتِنَا وَكَانُواْ مُسۡلِمِينَ",
    translation: "[You] who believed in Our verses and were Muslims",
    normalizedText: "الذين ءامنوا بايتنا وكانوا مسلمين",
  },
  {
    verseId: 69,
    name: "الزخرف",
    surahId: 43,
    text: "ٱدۡخُلُواْ ٱلۡجَنَّةَ أَنتُمۡ وَأَزۡوَٰجُكُمۡ تُحۡبَرُونَ",
    translation: "Enter Paradise, you and your kinds, delighted",
    normalizedText: "ادخلوا الجنة انتم وازوجكم تحبرون",
  },
  {
    verseId: 70,
    name: "الزخرف",
    surahId: 43,
    text: "يُطَافُ عَلَيۡهِم بِصِحَافٖ مِّن ذَهَبٖ وَأَكۡوَابٖۖ وَفِيهَا مَا تَشۡتَهِيهِ ٱلۡأَنفُسُ وَتَلَذُّ ٱلۡأَعۡيُنُۖ وَأَنتُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "Circulated among them will be plates and vessels of gold. And therein is whatever the souls desire and [what] delights the eyes, and you will abide therein eternally",
    normalizedText:
      "يطاف عليهم بصحاف من ذهب واكواب وفيها ما تشتهيه الانفس وتلذ الاعين وانتم فيها خلدون",
  },
  {
    verseId: 71,
    name: "الزخرف",
    surahId: 43,
    text: "وَتِلۡكَ ٱلۡجَنَّةُ ٱلَّتِيٓ أُورِثۡتُمُوهَا بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "And that is Paradise which you are made to inherit for what you used to do",
    normalizedText: "وتلك الجنة التي اورثتموها بما كنتم تعملون",
  },
  {
    verseId: 72,
    name: "الزخرف",
    surahId: 43,
    text: "لَكُمۡ فِيهَا فَٰكِهَةٞ كَثِيرَةٞ مِّنۡهَا تَأۡكُلُونَ",
    translation: "For you therein is much fruit from which you will eat",
    normalizedText: "لكم فيها فكهة كثيرة منها تاكلون",
  },
  {
    verseId: 73,
    name: "الزخرف",
    surahId: 43,
    text: "إِنَّ ٱلۡمُجۡرِمِينَ فِي عَذَابِ جَهَنَّمَ خَٰلِدُونَ",
    translation:
      "Indeed, the criminals will be in the punishment of Hell, abiding eternally",
    normalizedText: "ان المجرمين في عذاب جهنم خلدون",
  },
  {
    verseId: 74,
    name: "الزخرف",
    surahId: 43,
    text: "لَا يُفَتَّرُ عَنۡهُمۡ وَهُمۡ فِيهِ مُبۡلِسُونَ",
    translation:
      "It will not be allowed to subside for them, and they, therein, are in despair",
    normalizedText: "لا يفتر عنهم وهم فيه مبلسون",
  },
  {
    verseId: 75,
    name: "الزخرف",
    surahId: 43,
    text: "وَمَا ظَلَمۡنَٰهُمۡ وَلَٰكِن كَانُواْ هُمُ ٱلظَّـٰلِمِينَ",
    translation:
      "And We did not wrong them, but it was they who were the wrongdoers",
    normalizedText: "وما ظلمنهم ولكن كانوا هم الظلمين",
  },
  {
    verseId: 76,
    name: "الزخرف",
    surahId: 43,
    text: "وَنَادَوۡاْ يَٰمَٰلِكُ لِيَقۡضِ عَلَيۡنَا رَبُّكَۖ قَالَ إِنَّكُم مَّـٰكِثُونَ",
    translation:
      'And they will call, "O Malik, let your Lord put an end to us!" He will say, "Indeed, you will remain',
    normalizedText: "ونادوا يملك ليقض علينا ربك قال انكم مكثون",
  },
  {
    verseId: 77,
    name: "الزخرف",
    surahId: 43,
    text: "لَقَدۡ جِئۡنَٰكُم بِٱلۡحَقِّ وَلَٰكِنَّ أَكۡثَرَكُمۡ لِلۡحَقِّ كَٰرِهُونَ",
    translation:
      "We had certainly brought you the truth, but most of you, to the truth, were averse",
    normalizedText: "لقد جانكم بالحق ولكن اكثركم للحق كرهون",
  },
  {
    verseId: 78,
    name: "الزخرف",
    surahId: 43,
    text: "أَمۡ أَبۡرَمُوٓاْ أَمۡرٗا فَإِنَّا مُبۡرِمُونَ",
    translation:
      "Or have they devised [some] affair? But indeed, We are devising [a plan]",
    normalizedText: "ام ابرموا امرا فانا مبرمون",
  },
  {
    verseId: 79,
    name: "الزخرف",
    surahId: 43,
    text: "أَمۡ يَحۡسَبُونَ أَنَّا لَا نَسۡمَعُ سِرَّهُمۡ وَنَجۡوَىٰهُمۚ بَلَىٰ وَرُسُلُنَا لَدَيۡهِمۡ يَكۡتُبُونَ",
    translation:
      "Or do they think that We hear not their secrets and their private conversations? Yes, [We do], and Our messengers are with them recording",
    normalizedText:
      "ام يحسبون انا لا نسمع سرهم ونجوىهم بلى ورسلنا لديهم يكتبون",
  },
  {
    verseId: 80,
    name: "الزخرف",
    surahId: 43,
    text: "قُلۡ إِن كَانَ لِلرَّحۡمَٰنِ وَلَدٞ فَأَنَا۠ أَوَّلُ ٱلۡعَٰبِدِينَ",
    translation:
      'Say, [O Muhammad], "If the Most Merciful had a son, then I would be the first of [his] worshippers',
    normalizedText: "قل ان كان للرحمن ولد فانا اول العبدين",
  },
  {
    verseId: 81,
    name: "الزخرف",
    surahId: 43,
    text: "سُبۡحَٰنَ رَبِّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ رَبِّ ٱلۡعَرۡشِ عَمَّا يَصِفُونَ",
    translation:
      "Exalted is the Lord of the heavens and the earth, Lord of the Throne, above what they describe",
    normalizedText: "سبحن رب السموت والارض رب العرش عما يصفون",
  },
  {
    verseId: 82,
    name: "الزخرف",
    surahId: 43,
    text: "فَذَرۡهُمۡ يَخُوضُواْ وَيَلۡعَبُواْ حَتَّىٰ يُلَٰقُواْ يَوۡمَهُمُ ٱلَّذِي يُوعَدُونَ",
    translation:
      "So leave them to converse vainly and amuse themselves until they meet their Day which they are promised",
    normalizedText: "فذرهم يخوضوا ويلعبوا حتى يلقوا يومهم الذي يوعدون",
  },
  {
    verseId: 83,
    name: "الزخرف",
    surahId: 43,
    text: "وَهُوَ ٱلَّذِي فِي ٱلسَّمَآءِ إِلَٰهٞ وَفِي ٱلۡأَرۡضِ إِلَٰهٞۚ وَهُوَ ٱلۡحَكِيمُ ٱلۡعَلِيمُ",
    translation:
      "And it is Allah who is [the only] deity in the heaven, and on the earth [the only] deity. And He is the Wise, the Knowing",
    normalizedText: "وهو الذي في السماء اله وفي الارض اله وهو الحكيم العليم",
  },
  {
    verseId: 84,
    name: "الزخرف",
    surahId: 43,
    text: "وَتَبَارَكَ ٱلَّذِي لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَا وَعِندَهُۥ عِلۡمُ ٱلسَّاعَةِ وَإِلَيۡهِ تُرۡجَعُونَ",
    translation:
      "And blessed is He to whom belongs the dominion of the heavens and the earth and whatever is between them and with whom is knowledge of the Hour and to whom you will be returned",
    normalizedText:
      "وتبارك الذي له ملك السموت والارض وما بينهما وعنده علم الساعة واليه ترجعون",
  },
  {
    verseId: 85,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَا يَمۡلِكُ ٱلَّذِينَ يَدۡعُونَ مِن دُونِهِ ٱلشَّفَٰعَةَ إِلَّا مَن شَهِدَ بِٱلۡحَقِّ وَهُمۡ يَعۡلَمُونَ",
    translation:
      "And those they invoke besides Him do not possess [power of] intercession; but only those who testify to the truth [can benefit], and they know",
    normalizedText:
      "ولا يملك الذين يدعون من دونه الشفعة الا من شهد بالحق وهم يعلمون",
  },
  {
    verseId: 86,
    name: "الزخرف",
    surahId: 43,
    text: "وَلَئِن سَأَلۡتَهُم مَّنۡ خَلَقَهُمۡ لَيَقُولُنَّ ٱللَّهُۖ فَأَنَّىٰ يُؤۡفَكُونَ",
    translation:
      'And if you asked them who created them, they would surely say, "Allah." So how are they deluded',
    normalizedText: "ولان سالتهم من خلقهم ليقولن الله فانى يافكون",
  },
  {
    verseId: 87,
    name: "الزخرف",
    surahId: 43,
    text: "وَقِيلِهِۦ يَٰرَبِّ إِنَّ هَـٰٓؤُلَآءِ قَوۡمٞ لَّا يُؤۡمِنُونَ",
    translation:
      'And [Allah acknowledges] his saying, "O my Lord, indeed these are a people who do not believe',
    normalizedText: "وقيله يرب ان هالاء قوم لا يامنون",
  },
  {
    verseId: 88,
    name: "الزخرف",
    surahId: 43,
    text: "فَٱصۡفَحۡ عَنۡهُمۡ وَقُلۡ سَلَٰمٞۚ فَسَوۡفَ يَعۡلَمُونَ",
    translation:
      'So turn aside from them and say, "Peace." But they are going to know',
    normalizedText: "فاصفح عنهم وقل سلم فسوف يعلمون",
  },
  {
    verseId: 0,
    name: "الدخان",
    surahId: 44,
    text: "حمٓ",
    translation: "Ha, Meem",
    normalizedText: "حم",
  },
  {
    verseId: 1,
    name: "الدخان",
    surahId: 44,
    text: "وَٱلۡكِتَٰبِ ٱلۡمُبِينِ",
    translation: "By the clear Book",
    normalizedText: "والكتب المبين",
  },
  {
    verseId: 2,
    name: "الدخان",
    surahId: 44,
    text: "إِنَّآ أَنزَلۡنَٰهُ فِي لَيۡلَةٖ مُّبَٰرَكَةٍۚ إِنَّا كُنَّا مُنذِرِينَ",
    translation:
      "Indeed, We sent it down during a blessed night. Indeed, We were to warn [mankind]",
    normalizedText: "انا انزلنه في ليلة مبركة انا كنا منذرين",
  },
  {
    verseId: 3,
    name: "الدخان",
    surahId: 44,
    text: "فِيهَا يُفۡرَقُ كُلُّ أَمۡرٍ حَكِيمٍ",
    translation: "On that night is made distinct every precise matter",
    normalizedText: "فيها يفرق كل امر حكيم",
  },
  {
    verseId: 4,
    name: "الدخان",
    surahId: 44,
    text: "أَمۡرٗا مِّنۡ عِندِنَآۚ إِنَّا كُنَّا مُرۡسِلِينَ",
    translation:
      "[Every] matter [proceeding] from Us. Indeed, We were to send [a messenger]",
    normalizedText: "امرا من عندنا انا كنا مرسلين",
  },
  {
    verseId: 5,
    name: "الدخان",
    surahId: 44,
    text: "رَحۡمَةٗ مِّن رَّبِّكَۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلۡعَلِيمُ",
    translation:
      "As mercy from your Lord. Indeed, He is the Hearing, the Knowing",
    normalizedText: "رحمة من ربك انه هو السميع العليم",
  },
  {
    verseId: 6,
    name: "الدخان",
    surahId: 44,
    text: "رَبِّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَآۖ إِن كُنتُم مُّوقِنِينَ",
    translation:
      "Lord of the heavens and the earth and that between them, if you would be certain",
    normalizedText: "رب السموت والارض وما بينهما ان كنتم موقنين",
  },
  {
    verseId: 7,
    name: "الدخان",
    surahId: 44,
    text: "لَآ إِلَٰهَ إِلَّا هُوَ يُحۡيِۦ وَيُمِيتُۖ رَبُّكُمۡ وَرَبُّ ءَابَآئِكُمُ ٱلۡأَوَّلِينَ",
    translation:
      "There is no deity except Him; He gives life and causes death. [He is] your Lord and the Lord of your first forefathers",
    normalizedText: "لا اله الا هو يحي ويميت ربكم ورب ءابااكم الاولين",
  },
  {
    verseId: 8,
    name: "الدخان",
    surahId: 44,
    text: "بَلۡ هُمۡ فِي شَكّٖ يَلۡعَبُونَ",
    translation: "But they are in doubt, amusing themselves",
    normalizedText: "بل هم في شك يلعبون",
  },
  {
    verseId: 9,
    name: "الدخان",
    surahId: 44,
    text: "فَٱرۡتَقِبۡ يَوۡمَ تَأۡتِي ٱلسَّمَآءُ بِدُخَانٖ مُّبِينٖ",
    translation:
      "Then watch for the Day when the sky will bring a visible smoke",
    normalizedText: "فارتقب يوم تاتي السماء بدخان مبين",
  },
  {
    verseId: 10,
    name: "الدخان",
    surahId: 44,
    text: "يَغۡشَى ٱلنَّاسَۖ هَٰذَا عَذَابٌ أَلِيمٞ",
    translation: "Covering the people; this is a painful torment",
    normalizedText: "يغشى الناس هذا عذاب اليم",
  },
  {
    verseId: 11,
    name: "الدخان",
    surahId: 44,
    text: "رَّبَّنَا ٱكۡشِفۡ عَنَّا ٱلۡعَذَابَ إِنَّا مُؤۡمِنُونَ",
    translation:
      '[They will say], "Our Lord, remove from us the torment; indeed, we are believers',
    normalizedText: "ربنا اكشف عنا العذاب انا مامنون",
  },
  {
    verseId: 12,
    name: "الدخان",
    surahId: 44,
    text: "أَنَّىٰ لَهُمُ ٱلذِّكۡرَىٰ وَقَدۡ جَآءَهُمۡ رَسُولٞ مُّبِينٞ",
    translation:
      "How will there be for them a reminder [at that time]? And there had come to them a clear Messenger",
    normalizedText: "انى لهم الذكرى وقد جاءهم رسول مبين",
  },
  {
    verseId: 13,
    name: "الدخان",
    surahId: 44,
    text: "ثُمَّ تَوَلَّوۡاْ عَنۡهُ وَقَالُواْ مُعَلَّمٞ مَّجۡنُونٌ",
    translation:
      'Then they turned away from him and said, "[He was] taught [and is] a madman',
    normalizedText: "ثم تولوا عنه وقالوا معلم مجنون",
  },
  {
    verseId: 14,
    name: "الدخان",
    surahId: 44,
    text: "إِنَّا كَاشِفُواْ ٱلۡعَذَابِ قَلِيلًاۚ إِنَّكُمۡ عَآئِدُونَ",
    translation:
      "Indeed, We will remove the torment for a little. Indeed, you [disbelievers] will return [to disbelief]",
    normalizedText: "انا كاشفوا العذاب قليلا انكم عاادون",
  },
  {
    verseId: 15,
    name: "الدخان",
    surahId: 44,
    text: "يَوۡمَ نَبۡطِشُ ٱلۡبَطۡشَةَ ٱلۡكُبۡرَىٰٓ إِنَّا مُنتَقِمُونَ",
    translation:
      "The Day We will strike with the greatest assault, indeed, We will take retribution",
    normalizedText: "يوم نبطش البطشة الكبرى انا منتقمون",
  },
  {
    verseId: 16,
    name: "الدخان",
    surahId: 44,
    text: "۞وَلَقَدۡ فَتَنَّا قَبۡلَهُمۡ قَوۡمَ فِرۡعَوۡنَ وَجَآءَهُمۡ رَسُولٞ كَرِيمٌ",
    translation:
      "And We had already tried before them the people of Pharaoh, and there came to them a noble messenger",
    normalizedText: "۞ولقد فتنا قبلهم قوم فرعون وجاءهم رسول كريم",
  },
  {
    verseId: 17,
    name: "الدخان",
    surahId: 44,
    text: "أَنۡ أَدُّوٓاْ إِلَيَّ عِبَادَ ٱللَّهِۖ إِنِّي لَكُمۡ رَسُولٌ أَمِينٞ",
    translation:
      '[Saying], "Render to me the servants of Allah. Indeed, I am to you a trustworthy messenger',
    normalizedText: "ان ادوا الي عباد الله اني لكم رسول امين",
  },
  {
    verseId: 18,
    name: "الدخان",
    surahId: 44,
    text: "وَأَن لَّا تَعۡلُواْ عَلَى ٱللَّهِۖ إِنِّيٓ ءَاتِيكُم بِسُلۡطَٰنٖ مُّبِينٖ",
    translation:
      'And [saying], "Be not haughty with Allah. Indeed, I have come to you with clear authority',
    normalizedText: "وان لا تعلوا على الله اني ءاتيكم بسلطن مبين",
  },
  {
    verseId: 19,
    name: "الدخان",
    surahId: 44,
    text: "وَإِنِّي عُذۡتُ بِرَبِّي وَرَبِّكُمۡ أَن تَرۡجُمُونِ",
    translation:
      "And indeed, I have sought refuge in my Lord and your Lord, lest you stone me",
    normalizedText: "واني عذت بربي وربكم ان ترجمون",
  },
  {
    verseId: 20,
    name: "الدخان",
    surahId: 44,
    text: "وَإِن لَّمۡ تُؤۡمِنُواْ لِي فَٱعۡتَزِلُونِ",
    translation: "But if you do not believe me, then leave me alone",
    normalizedText: "وان لم تامنوا لي فاعتزلون",
  },
  {
    verseId: 21,
    name: "الدخان",
    surahId: 44,
    text: "فَدَعَا رَبَّهُۥٓ أَنَّ هَـٰٓؤُلَآءِ قَوۡمٞ مُّجۡرِمُونَ",
    translation:
      "And [finally] he called to his Lord that these were a criminal people",
    normalizedText: "فدعا ربه ان هالاء قوم مجرمون",
  },
  {
    verseId: 22,
    name: "الدخان",
    surahId: 44,
    text: "فَأَسۡرِ بِعِبَادِي لَيۡلًا إِنَّكُم مُّتَّبَعُونَ",
    translation:
      '[Allah said], "Then set out with My servants by night. Indeed, you are to be pursued',
    normalizedText: "فاسر بعبادي ليلا انكم متبعون",
  },
  {
    verseId: 23,
    name: "الدخان",
    surahId: 44,
    text: "وَٱتۡرُكِ ٱلۡبَحۡرَ رَهۡوًاۖ إِنَّهُمۡ جُندٞ مُّغۡرَقُونَ",
    translation:
      "And leave the sea in stillness. Indeed, they are an army to be drowned",
    normalizedText: "واترك البحر رهوا انهم جند مغرقون",
  },
  {
    verseId: 24,
    name: "الدخان",
    surahId: 44,
    text: "كَمۡ تَرَكُواْ مِن جَنَّـٰتٖ وَعُيُونٖ",
    translation: "How much they left behind of gardens and springs",
    normalizedText: "كم تركوا من جنت وعيون",
  },
  {
    verseId: 25,
    name: "الدخان",
    surahId: 44,
    text: "وَزُرُوعٖ وَمَقَامٖ كَرِيمٖ",
    translation: "And crops and noble sites",
    normalizedText: "وزروع ومقام كريم",
  },
  {
    verseId: 26,
    name: "الدخان",
    surahId: 44,
    text: "وَنَعۡمَةٖ كَانُواْ فِيهَا فَٰكِهِينَ",
    translation: "And comfort wherein they were amused",
    normalizedText: "ونعمة كانوا فيها فكهين",
  },
  {
    verseId: 27,
    name: "الدخان",
    surahId: 44,
    text: "كَذَٰلِكَۖ وَأَوۡرَثۡنَٰهَا قَوۡمًا ءَاخَرِينَ",
    translation: "Thus. And We caused to inherit it another people",
    normalizedText: "كذلك واورثنها قوما ءاخرين",
  },
  {
    verseId: 28,
    name: "الدخان",
    surahId: 44,
    text: "فَمَا بَكَتۡ عَلَيۡهِمُ ٱلسَّمَآءُ وَٱلۡأَرۡضُ وَمَا كَانُواْ مُنظَرِينَ",
    translation:
      "And the heaven and earth wept not for them, nor were they reprieved",
    normalizedText: "فما بكت عليهم السماء والارض وما كانوا منظرين",
  },
  {
    verseId: 29,
    name: "الدخان",
    surahId: 44,
    text: "وَلَقَدۡ نَجَّيۡنَا بَنِيٓ إِسۡرَـٰٓءِيلَ مِنَ ٱلۡعَذَابِ ٱلۡمُهِينِ",
    translation:
      "And We certainly saved the Children of Israel from the humiliating torment",
    normalizedText: "ولقد نجينا بني اسرءيل من العذاب المهين",
  },
  {
    verseId: 30,
    name: "الدخان",
    surahId: 44,
    text: "مِن فِرۡعَوۡنَۚ إِنَّهُۥ كَانَ عَالِيٗا مِّنَ ٱلۡمُسۡرِفِينَ",
    translation:
      "From Pharaoh. Indeed, he was a haughty one among the transgressors",
    normalizedText: "من فرعون انه كان عاليا من المسرفين",
  },
  {
    verseId: 31,
    name: "الدخان",
    surahId: 44,
    text: "وَلَقَدِ ٱخۡتَرۡنَٰهُمۡ عَلَىٰ عِلۡمٍ عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      "And We certainly chose them by knowledge over [all] the worlds",
    normalizedText: "ولقد اخترنهم على علم على العلمين",
  },
  {
    verseId: 32,
    name: "الدخان",
    surahId: 44,
    text: "وَءَاتَيۡنَٰهُم مِّنَ ٱلۡأٓيَٰتِ مَا فِيهِ بَلَـٰٓؤٞاْ مُّبِينٌ",
    translation:
      "And We gave them of signs that in which there was a clear trial",
    normalizedText: "وءاتينهم من الايت ما فيه بلاا مبين",
  },
  {
    verseId: 33,
    name: "الدخان",
    surahId: 44,
    text: "إِنَّ هَـٰٓؤُلَآءِ لَيَقُولُونَ",
    translation: "Indeed, these [disbelievers] are saying",
    normalizedText: "ان هالاء ليقولون",
  },
  {
    verseId: 34,
    name: "الدخان",
    surahId: 44,
    text: "إِنۡ هِيَ إِلَّا مَوۡتَتُنَا ٱلۡأُولَىٰ وَمَا نَحۡنُ بِمُنشَرِينَ",
    translation:
      "There is not but our first death, and we will not be resurrected",
    normalizedText: "ان هي الا موتتنا الاولى وما نحن بمنشرين",
  },
  {
    verseId: 35,
    name: "الدخان",
    surahId: 44,
    text: "فَأۡتُواْ بِـَٔابَآئِنَآ إِن كُنتُمۡ صَٰدِقِينَ",
    translation: "Then bring [back] our forefathers, if you should be truthful",
    normalizedText: "فاتوا باباانا ان كنتم صدقين",
  },
  {
    verseId: 36,
    name: "الدخان",
    surahId: 44,
    text: "أَهُمۡ خَيۡرٌ أَمۡ قَوۡمُ تُبَّعٖ وَٱلَّذِينَ مِن قَبۡلِهِمۡ أَهۡلَكۡنَٰهُمۡۚ إِنَّهُمۡ كَانُواْ مُجۡرِمِينَ",
    translation:
      "Are they better or the people of Tubba' and those before them? We destroyed them, [for] indeed, they were criminals",
    normalizedText:
      "اهم خير ام قوم تبع والذين من قبلهم اهلكنهم انهم كانوا مجرمين",
  },
  {
    verseId: 37,
    name: "الدخان",
    surahId: 44,
    text: "وَمَا خَلَقۡنَا ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَا لَٰعِبِينَ",
    translation:
      "And We did not create the heavens and earth and that between them in play",
    normalizedText: "وما خلقنا السموت والارض وما بينهما لعبين",
  },
  {
    verseId: 38,
    name: "الدخان",
    surahId: 44,
    text: "مَا خَلَقۡنَٰهُمَآ إِلَّا بِٱلۡحَقِّ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "We did not create them except in truth, but most of them do not know",
    normalizedText: "ما خلقنهما الا بالحق ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 39,
    name: "الدخان",
    surahId: 44,
    text: "إِنَّ يَوۡمَ ٱلۡفَصۡلِ مِيقَٰتُهُمۡ أَجۡمَعِينَ",
    translation:
      "Indeed, the Day of Judgement is the appointed time for them all",
    normalizedText: "ان يوم الفصل ميقتهم اجمعين",
  },
  {
    verseId: 40,
    name: "الدخان",
    surahId: 44,
    text: "يَوۡمَ لَا يُغۡنِي مَوۡلًى عَن مَّوۡلٗى شَيۡـٔٗا وَلَا هُمۡ يُنصَرُونَ",
    translation:
      "The Day when no relation will avail a relation at all, nor will they be helped",
    normalizedText: "يوم لا يغني مولى عن مولى شيا ولا هم ينصرون",
  },
  {
    verseId: 41,
    name: "الدخان",
    surahId: 44,
    text: "إِلَّا مَن رَّحِمَ ٱللَّهُۚ إِنَّهُۥ هُوَ ٱلۡعَزِيزُ ٱلرَّحِيمُ",
    translation:
      "Except those [believers] on whom Allah has mercy. Indeed, He is the Exalted in Might, the Merciful",
    normalizedText: "الا من رحم الله انه هو العزيز الرحيم",
  },
  {
    verseId: 42,
    name: "الدخان",
    surahId: 44,
    text: "إِنَّ شَجَرَتَ ٱلزَّقُّومِ",
    translation: "Indeed, the tree of zaqqum",
    normalizedText: "ان شجرت الزقوم",
  },
  {
    verseId: 43,
    name: "الدخان",
    surahId: 44,
    text: "طَعَامُ ٱلۡأَثِيمِ",
    translation: "Is food for the sinful",
    normalizedText: "طعام الاثيم",
  },
  {
    verseId: 44,
    name: "الدخان",
    surahId: 44,
    text: "كَٱلۡمُهۡلِ يَغۡلِي فِي ٱلۡبُطُونِ",
    translation: "Like murky oil, it boils within bellies",
    normalizedText: "كالمهل يغلي في البطون",
  },
  {
    verseId: 45,
    name: "الدخان",
    surahId: 44,
    text: "كَغَلۡيِ ٱلۡحَمِيمِ",
    translation: "Like the boiling of scalding water",
    normalizedText: "كغلي الحميم",
  },
  {
    verseId: 46,
    name: "الدخان",
    surahId: 44,
    text: "خُذُوهُ فَٱعۡتِلُوهُ إِلَىٰ سَوَآءِ ٱلۡجَحِيمِ",
    translation:
      '[It will be commanded], "Seize him and drag him into the midst of the Hellfire',
    normalizedText: "خذوه فاعتلوه الى سواء الجحيم",
  },
  {
    verseId: 47,
    name: "الدخان",
    surahId: 44,
    text: "ثُمَّ صُبُّواْ فَوۡقَ رَأۡسِهِۦ مِنۡ عَذَابِ ٱلۡحَمِيمِ",
    translation: "Then pour over his head from the torment of scalding water",
    normalizedText: "ثم صبوا فوق راسه من عذاب الحميم",
  },
  {
    verseId: 48,
    name: "الدخان",
    surahId: 44,
    text: "ذُقۡ إِنَّكَ أَنتَ ٱلۡعَزِيزُ ٱلۡكَرِيمُ",
    translation:
      '[It will be said], "Taste! Indeed, you are the honored, the noble',
    normalizedText: "ذق انك انت العزيز الكريم",
  },
  {
    verseId: 49,
    name: "الدخان",
    surahId: 44,
    text: "إِنَّ هَٰذَا مَا كُنتُم بِهِۦ تَمۡتَرُونَ",
    translation: "Indeed, this is what you used to dispute",
    normalizedText: "ان هذا ما كنتم به تمترون",
  },
  {
    verseId: 50,
    name: "الدخان",
    surahId: 44,
    text: "إِنَّ ٱلۡمُتَّقِينَ فِي مَقَامٍ أَمِينٖ",
    translation: "Indeed, the righteous will be in a secure place",
    normalizedText: "ان المتقين في مقام امين",
  },
  {
    verseId: 51,
    name: "الدخان",
    surahId: 44,
    text: "فِي جَنَّـٰتٖ وَعُيُونٖ",
    translation: "Within gardens and springs",
    normalizedText: "في جنت وعيون",
  },
  {
    verseId: 52,
    name: "الدخان",
    surahId: 44,
    text: "يَلۡبَسُونَ مِن سُندُسٖ وَإِسۡتَبۡرَقٖ مُّتَقَٰبِلِينَ",
    translation:
      "Wearing [garments of] fine silk and brocade, facing each other",
    normalizedText: "يلبسون من سندس واستبرق متقبلين",
  },
  {
    verseId: 53,
    name: "الدخان",
    surahId: 44,
    text: "كَذَٰلِكَ وَزَوَّجۡنَٰهُم بِحُورٍ عِينٖ",
    translation:
      "Thus. And We will marry them to fair women with large, [beautiful] eyes",
    normalizedText: "كذلك وزوجنهم بحور عين",
  },
  {
    verseId: 54,
    name: "الدخان",
    surahId: 44,
    text: "يَدۡعُونَ فِيهَا بِكُلِّ فَٰكِهَةٍ ءَامِنِينَ",
    translation:
      "They will call therein for every [kind of] fruit - safe and secure",
    normalizedText: "يدعون فيها بكل فكهة ءامنين",
  },
  {
    verseId: 55,
    name: "الدخان",
    surahId: 44,
    text: "لَا يَذُوقُونَ فِيهَا ٱلۡمَوۡتَ إِلَّا ٱلۡمَوۡتَةَ ٱلۡأُولَىٰۖ وَوَقَىٰهُمۡ عَذَابَ ٱلۡجَحِيمِ",
    translation:
      "They will not taste death therein except the first death, and He will have protected them from the punishment of Hellfire",
    normalizedText: "لا يذوقون فيها الموت الا الموتة الاولى ووقىهم عذاب الجحيم",
  },
  {
    verseId: 56,
    name: "الدخان",
    surahId: 44,
    text: "فَضۡلٗا مِّن رَّبِّكَۚ ذَٰلِكَ هُوَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "As bounty from your Lord. That is what is the great attainment",
    normalizedText: "فضلا من ربك ذلك هو الفوز العظيم",
  },
  {
    verseId: 57,
    name: "الدخان",
    surahId: 44,
    text: "فَإِنَّمَا يَسَّرۡنَٰهُ بِلِسَانِكَ لَعَلَّهُمۡ يَتَذَكَّرُونَ",
    translation:
      "And indeed, We have eased the Qur'an in your tongue that they might be reminded",
    normalizedText: "فانما يسرنه بلسانك لعلهم يتذكرون",
  },
  {
    verseId: 58,
    name: "الدخان",
    surahId: 44,
    text: "فَٱرۡتَقِبۡ إِنَّهُم مُّرۡتَقِبُونَ",
    translation:
      "So watch, [O Muhammad]; indeed, they are watching [for your end]",
    normalizedText: "فارتقب انهم مرتقبون",
  },
  {
    verseId: 0,
    name: "الجاثية",
    surahId: 45,
    text: "حمٓ",
    translation: "Ha, Meem",
    normalizedText: "حم",
  },
  {
    verseId: 1,
    name: "الجاثية",
    surahId: 45,
    text: "تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ",
    translation:
      "The revelation of the Book is from Allah, the Exalted in Might, the Wise",
    normalizedText: "تنزيل الكتب من الله العزيز الحكيم",
  },
  {
    verseId: 2,
    name: "الجاثية",
    surahId: 45,
    text: "إِنَّ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ لَأٓيَٰتٖ لِّلۡمُؤۡمِنِينَ",
    translation:
      "Indeed, within the heavens and earth are signs for the believers",
    normalizedText: "ان في السموت والارض لايت للمامنين",
  },
  {
    verseId: 3,
    name: "الجاثية",
    surahId: 45,
    text: "وَفِي خَلۡقِكُمۡ وَمَا يَبُثُّ مِن دَآبَّةٍ ءَايَٰتٞ لِّقَوۡمٖ يُوقِنُونَ",
    translation:
      "And in the creation of yourselves and what He disperses of moving creatures are signs for people who are certain [in faith]",
    normalizedText: "وفي خلقكم وما يبث من دابة ءايت لقوم يوقنون",
  },
  {
    verseId: 4,
    name: "الجاثية",
    surahId: 45,
    text: "وَٱخۡتِلَٰفِ ٱلَّيۡلِ وَٱلنَّهَارِ وَمَآ أَنزَلَ ٱللَّهُ مِنَ ٱلسَّمَآءِ مِن رِّزۡقٖ فَأَحۡيَا بِهِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَا وَتَصۡرِيفِ ٱلرِّيَٰحِ ءَايَٰتٞ لِّقَوۡمٖ يَعۡقِلُونَ",
    translation:
      "And [in] the alternation of night and day and [in] what Allah sends down from the sky of provision and gives life thereby to the earth after its lifelessness and [in His] directing of the winds are signs for a people who reason",
    normalizedText:
      "واختلف اليل والنهار وما انزل الله من السماء من رزق فاحيا به الارض بعد موتها وتصريف الريح ءايت لقوم يعقلون",
  },
  {
    verseId: 5,
    name: "الجاثية",
    surahId: 45,
    text: "تِلۡكَ ءَايَٰتُ ٱللَّهِ نَتۡلُوهَا عَلَيۡكَ بِٱلۡحَقِّۖ فَبِأَيِّ حَدِيثِۭ بَعۡدَ ٱللَّهِ وَءَايَٰتِهِۦ يُؤۡمِنُونَ",
    translation:
      "These are the verses of Allah which We recite to you in truth. Then in what statement after Allah and His verses will they believe",
    normalizedText:
      "تلك ءايت الله نتلوها عليك بالحق فباي حديث بعد الله وءايته يامنون",
  },
  {
    verseId: 6,
    name: "الجاثية",
    surahId: 45,
    text: "وَيۡلٞ لِّكُلِّ أَفَّاكٍ أَثِيمٖ",
    translation: "Woe to every sinful liar",
    normalizedText: "ويل لكل افاك اثيم",
  },
  {
    verseId: 7,
    name: "الجاثية",
    surahId: 45,
    text: "يَسۡمَعُ ءَايَٰتِ ٱللَّهِ تُتۡلَىٰ عَلَيۡهِ ثُمَّ يُصِرُّ مُسۡتَكۡبِرٗا كَأَن لَّمۡ يَسۡمَعۡهَاۖ فَبَشِّرۡهُ بِعَذَابٍ أَلِيمٖ",
    translation:
      "Who hears the verses of Allah recited to him, then persists arrogantly as if he had not heard them. So give him tidings of a painful punishment",
    normalizedText:
      "يسمع ءايت الله تتلى عليه ثم يصر مستكبرا كان لم يسمعها فبشره بعذاب اليم",
  },
  {
    verseId: 8,
    name: "الجاثية",
    surahId: 45,
    text: "وَإِذَا عَلِمَ مِنۡ ءَايَٰتِنَا شَيۡـًٔا ٱتَّخَذَهَا هُزُوًاۚ أُوْلَـٰٓئِكَ لَهُمۡ عَذَابٞ مُّهِينٞ",
    translation:
      "And when he knows anything of Our verses, he takes them in ridicule. Those will have a humiliating punishment",
    normalizedText: "واذا علم من ءايتنا شيا اتخذها هزوا اولاك لهم عذاب مهين",
  },
  {
    verseId: 9,
    name: "الجاثية",
    surahId: 45,
    text: "مِّن وَرَآئِهِمۡ جَهَنَّمُۖ وَلَا يُغۡنِي عَنۡهُم مَّا كَسَبُواْ شَيۡـٔٗا وَلَا مَا ٱتَّخَذُواْ مِن دُونِ ٱللَّهِ أَوۡلِيَآءَۖ وَلَهُمۡ عَذَابٌ عَظِيمٌ",
    translation:
      "Before them is Hell, and what they had earned will not avail them at all nor what they had taken besides Allah as allies. And they will have a great punishment",
    normalizedText:
      "من ورااهم جهنم ولا يغني عنهم ما كسبوا شيا ولا ما اتخذوا من دون الله اولياء ولهم عذاب عظيم",
  },
  {
    verseId: 10,
    name: "الجاثية",
    surahId: 45,
    text: "هَٰذَا هُدٗىۖ وَٱلَّذِينَ كَفَرُواْ بِـَٔايَٰتِ رَبِّهِمۡ لَهُمۡ عَذَابٞ مِّن رِّجۡزٍ أَلِيمٌ",
    translation:
      "This [Qur'an] is guidance. And those who have disbelieved in the verses of their Lord will have a painful punishment of foul nature",
    normalizedText: "هذا هدى والذين كفروا بايت ربهم لهم عذاب من رجز اليم",
  },
  {
    verseId: 11,
    name: "الجاثية",
    surahId: 45,
    text: "۞ٱللَّهُ ٱلَّذِي سَخَّرَ لَكُمُ ٱلۡبَحۡرَ لِتَجۡرِيَ ٱلۡفُلۡكُ فِيهِ بِأَمۡرِهِۦ وَلِتَبۡتَغُواْ مِن فَضۡلِهِۦ وَلَعَلَّكُمۡ تَشۡكُرُونَ",
    translation:
      "It is Allah who subjected to you the sea so that ships may sail upon it by His command and that you may seek of His bounty; and perhaps you will be grateful",
    normalizedText:
      "۞الله الذي سخر لكم البحر لتجري الفلك فيه بامره ولتبتغوا من فضله ولعلكم تشكرون",
  },
  {
    verseId: 12,
    name: "الجاثية",
    surahId: 45,
    text: "وَسَخَّرَ لَكُم مَّا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ جَمِيعٗا مِّنۡهُۚ إِنَّ فِي ذَٰلِكَ لَأٓيَٰتٖ لِّقَوۡمٖ يَتَفَكَّرُونَ",
    translation:
      "And He has subjected to you whatever is in the heavens and whatever is on the earth - all from Him. Indeed in that are signs for a people who give thought",
    normalizedText:
      "وسخر لكم ما في السموت وما في الارض جميعا منه ان في ذلك لايت لقوم يتفكرون",
  },
  {
    verseId: 13,
    name: "الجاثية",
    surahId: 45,
    text: "قُل لِّلَّذِينَ ءَامَنُواْ يَغۡفِرُواْ لِلَّذِينَ لَا يَرۡجُونَ أَيَّامَ ٱللَّهِ لِيَجۡزِيَ قَوۡمَۢا بِمَا كَانُواْ يَكۡسِبُونَ",
    translation:
      "Say, [O Muhammad], to those who have believed that they [should] forgive those who expect not the days of Allah so that He may recompense a people for what they used to earn",
    normalizedText:
      "قل للذين ءامنوا يغفروا للذين لا يرجون ايام الله ليجزي قوما بما كانوا يكسبون",
  },
  {
    verseId: 14,
    name: "الجاثية",
    surahId: 45,
    text: "مَنۡ عَمِلَ صَٰلِحٗا فَلِنَفۡسِهِۦۖ وَمَنۡ أَسَآءَ فَعَلَيۡهَاۖ ثُمَّ إِلَىٰ رَبِّكُمۡ تُرۡجَعُونَ",
    translation:
      "Whoever does a good deed - it is for himself; and whoever does evil - it is against the self. Then to your Lord you will be returned",
    normalizedText: "من عمل صلحا فلنفسه ومن اساء فعليها ثم الى ربكم ترجعون",
  },
  {
    verseId: 15,
    name: "الجاثية",
    surahId: 45,
    text: "وَلَقَدۡ ءَاتَيۡنَا بَنِيٓ إِسۡرَـٰٓءِيلَ ٱلۡكِتَٰبَ وَٱلۡحُكۡمَ وَٱلنُّبُوَّةَ وَرَزَقۡنَٰهُم مِّنَ ٱلطَّيِّبَٰتِ وَفَضَّلۡنَٰهُمۡ عَلَى ٱلۡعَٰلَمِينَ",
    translation:
      "And We did certainly give the Children of Israel the Scripture and judgement and prophethood, and We provided them with good things and preferred them over the worlds",
    normalizedText:
      "ولقد ءاتينا بني اسرءيل الكتب والحكم والنبوة ورزقنهم من الطيبت وفضلنهم على العلمين",
  },
  {
    verseId: 16,
    name: "الجاثية",
    surahId: 45,
    text: "وَءَاتَيۡنَٰهُم بَيِّنَٰتٖ مِّنَ ٱلۡأَمۡرِۖ فَمَا ٱخۡتَلَفُوٓاْ إِلَّا مِنۢ بَعۡدِ مَا جَآءَهُمُ ٱلۡعِلۡمُ بَغۡيَۢا بَيۡنَهُمۡۚ إِنَّ رَبَّكَ يَقۡضِي بَيۡنَهُمۡ يَوۡمَ ٱلۡقِيَٰمَةِ فِيمَا كَانُواْ فِيهِ يَخۡتَلِفُونَ",
    translation:
      "And We gave them clear proofs of the matter [of religion]. And they did not differ except after knowledge had come to them - out of jealous animosity between themselves. Indeed, your Lord will judge between them on the Day of Resurrection concerning that over which they used to differ",
    normalizedText:
      "وءاتينهم بينت من الامر فما اختلفوا الا من بعد ما جاءهم العلم بغيا بينهم ان ربك يقضي بينهم يوم القيمة فيما كانوا فيه يختلفون",
  },
  {
    verseId: 17,
    name: "الجاثية",
    surahId: 45,
    text: "ثُمَّ جَعَلۡنَٰكَ عَلَىٰ شَرِيعَةٖ مِّنَ ٱلۡأَمۡرِ فَٱتَّبِعۡهَا وَلَا تَتَّبِعۡ أَهۡوَآءَ ٱلَّذِينَ لَا يَعۡلَمُونَ",
    translation:
      "Then We put you, [O Muhammad], on an ordained way concerning the matter [of religion]; so follow it and do not follow the inclinations of those who do not know",
    normalizedText:
      "ثم جعلنك على شريعة من الامر فاتبعها ولا تتبع اهواء الذين لا يعلمون",
  },
  {
    verseId: 18,
    name: "الجاثية",
    surahId: 45,
    text: "إِنَّهُمۡ لَن يُغۡنُواْ عَنكَ مِنَ ٱللَّهِ شَيۡـٔٗاۚ وَإِنَّ ٱلظَّـٰلِمِينَ بَعۡضُهُمۡ أَوۡلِيَآءُ بَعۡضٖۖ وَٱللَّهُ وَلِيُّ ٱلۡمُتَّقِينَ",
    translation:
      "Indeed, they will never avail you against Allah at all. And indeed, the wrongdoers are allies of one another; but Allah is the protector of the righteous",
    normalizedText:
      "انهم لن يغنوا عنك من الله شيا وان الظلمين بعضهم اولياء بعض والله ولي المتقين",
  },
  {
    verseId: 19,
    name: "الجاثية",
    surahId: 45,
    text: "هَٰذَا بَصَـٰٓئِرُ لِلنَّاسِ وَهُدٗى وَرَحۡمَةٞ لِّقَوۡمٖ يُوقِنُونَ",
    translation:
      "This [Qur'an] is enlightenment for mankind and guidance and mercy for a people who are certain [in faith]",
    normalizedText: "هذا بصار للناس وهدى ورحمة لقوم يوقنون",
  },
  {
    verseId: 20,
    name: "الجاثية",
    surahId: 45,
    text: "أَمۡ حَسِبَ ٱلَّذِينَ ٱجۡتَرَحُواْ ٱلسَّيِّـَٔاتِ أَن نَّجۡعَلَهُمۡ كَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ سَوَآءٗ مَّحۡيَاهُمۡ وَمَمَاتُهُمۡۚ سَآءَ مَا يَحۡكُمُونَ",
    translation:
      "Or do those who commit evils think We will make them like those who have believed and done righteous deeds - [make them] equal in their life and their death? Evil is that which they judge",
    normalizedText:
      "ام حسب الذين اجترحوا السيات ان نجعلهم كالذين ءامنوا وعملوا الصلحت سواء محياهم ومماتهم ساء ما يحكمون",
  },
  {
    verseId: 21,
    name: "الجاثية",
    surahId: 45,
    text: "وَخَلَقَ ٱللَّهُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِٱلۡحَقِّ وَلِتُجۡزَىٰ كُلُّ نَفۡسِۭ بِمَا كَسَبَتۡ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "And Allah created the heavens and earth in truth and so that every soul may be recompensed for what it has earned, and they will not be wronged",
    normalizedText:
      "وخلق الله السموت والارض بالحق ولتجزى كل نفس بما كسبت وهم لا يظلمون",
  },
  {
    verseId: 22,
    name: "الجاثية",
    surahId: 45,
    text: "أَفَرَءَيۡتَ مَنِ ٱتَّخَذَ إِلَٰهَهُۥ هَوَىٰهُ وَأَضَلَّهُ ٱللَّهُ عَلَىٰ عِلۡمٖ وَخَتَمَ عَلَىٰ سَمۡعِهِۦ وَقَلۡبِهِۦ وَجَعَلَ عَلَىٰ بَصَرِهِۦ غِشَٰوَةٗ فَمَن يَهۡدِيهِ مِنۢ بَعۡدِ ٱللَّهِۚ أَفَلَا تَذَكَّرُونَ",
    translation:
      "Have you seen he who has taken as his god his [own] desire, and Allah has sent him astray due to knowledge and has set a seal upon his hearing and his heart and put over his vision a veil? So who will guide him after Allah? Then will you not be reminded",
    normalizedText:
      "افرءيت من اتخذ الهه هوىه واضله الله على علم وختم على سمعه وقلبه وجعل على بصره غشوة فمن يهديه من بعد الله افلا تذكرون",
  },
  {
    verseId: 23,
    name: "الجاثية",
    surahId: 45,
    text: "وَقَالُواْ مَا هِيَ إِلَّا حَيَاتُنَا ٱلدُّنۡيَا نَمُوتُ وَنَحۡيَا وَمَا يُهۡلِكُنَآ إِلَّا ٱلدَّهۡرُۚ وَمَا لَهُم بِذَٰلِكَ مِنۡ عِلۡمٍۖ إِنۡ هُمۡ إِلَّا يَظُنُّونَ",
    translation:
      'And they say, "There is not but our worldly life; we die and live, and nothing destroys us except time." And they have of that no knowledge; they are only assuming',
    normalizedText:
      "وقالوا ما هي الا حياتنا الدنيا نموت ونحيا وما يهلكنا الا الدهر وما لهم بذلك من علم ان هم الا يظنون",
  },
  {
    verseId: 24,
    name: "الجاثية",
    surahId: 45,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَٰتُنَا بَيِّنَٰتٖ مَّا كَانَ حُجَّتَهُمۡ إِلَّآ أَن قَالُواْ ٱئۡتُواْ بِـَٔابَآئِنَآ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And when Our verses are recited to them as clear evidences, their argument is only that they say, "Bring [back] our forefathers, if you should be truthful',
    normalizedText:
      "واذا تتلى عليهم ءايتنا بينت ما كان حجتهم الا ان قالوا ااتوا باباانا ان كنتم صدقين",
  },
  {
    verseId: 25,
    name: "الجاثية",
    surahId: 45,
    text: "قُلِ ٱللَّهُ يُحۡيِيكُمۡ ثُمَّ يُمِيتُكُمۡ ثُمَّ يَجۡمَعُكُمۡ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ لَا رَيۡبَ فِيهِ وَلَٰكِنَّ أَكۡثَرَ ٱلنَّاسِ لَا يَعۡلَمُونَ",
    translation:
      'Say, "Allah causes you to live, then causes you to die; then He will assemble you for the Day of Resurrection, about which there is no doubt, but most of the people do not know',
    normalizedText:
      "قل الله يحييكم ثم يميتكم ثم يجمعكم الى يوم القيمة لا ريب فيه ولكن اكثر الناس لا يعلمون",
  },
  {
    verseId: 26,
    name: "الجاثية",
    surahId: 45,
    text: "وَلِلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَيَوۡمَ تَقُومُ ٱلسَّاعَةُ يَوۡمَئِذٖ يَخۡسَرُ ٱلۡمُبۡطِلُونَ",
    translation:
      "And to Allah belongs the dominion of the heavens and the earth. And the Day the Hour appears - that Day the falsifiers will lose",
    normalizedText:
      "ولله ملك السموت والارض ويوم تقوم الساعة يوماذ يخسر المبطلون",
  },
  {
    verseId: 27,
    name: "الجاثية",
    surahId: 45,
    text: "وَتَرَىٰ كُلَّ أُمَّةٖ جَاثِيَةٗۚ كُلُّ أُمَّةٖ تُدۡعَىٰٓ إِلَىٰ كِتَٰبِهَا ٱلۡيَوۡمَ تُجۡزَوۡنَ مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'And you will see every nation kneeling [from fear]. Every nation will be called to its record [and told], "Today you will be recompensed for what you used to do',
    normalizedText:
      "وترى كل امة جاثية كل امة تدعى الى كتبها اليوم تجزون ما كنتم تعملون",
  },
  {
    verseId: 28,
    name: "الجاثية",
    surahId: 45,
    text: "هَٰذَا كِتَٰبُنَا يَنطِقُ عَلَيۡكُم بِٱلۡحَقِّۚ إِنَّا كُنَّا نَسۡتَنسِخُ مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "This, Our record, speaks about you in truth. Indeed, We were having transcribed whatever you used to do",
    normalizedText: "هذا كتبنا ينطق عليكم بالحق انا كنا نستنسخ ما كنتم تعملون",
  },
  {
    verseId: 29,
    name: "الجاثية",
    surahId: 45,
    text: "فَأَمَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فَيُدۡخِلُهُمۡ رَبُّهُمۡ فِي رَحۡمَتِهِۦۚ ذَٰلِكَ هُوَ ٱلۡفَوۡزُ ٱلۡمُبِينُ",
    translation:
      "So as for those who believed and did righteous deeds, their Lord will admit them into His mercy. That is what is the clear attainment",
    normalizedText:
      "فاما الذين ءامنوا وعملوا الصلحت فيدخلهم ربهم في رحمته ذلك هو الفوز المبين",
  },
  {
    verseId: 30,
    name: "الجاثية",
    surahId: 45,
    text: "وَأَمَّا ٱلَّذِينَ كَفَرُوٓاْ أَفَلَمۡ تَكُنۡ ءَايَٰتِي تُتۡلَىٰ عَلَيۡكُمۡ فَٱسۡتَكۡبَرۡتُمۡ وَكُنتُمۡ قَوۡمٗا مُّجۡرِمِينَ",
    translation:
      'But as for those who disbelieved, [it will be said], "Were not Our verses recited to you, but you were arrogant and became a people of criminals',
    normalizedText:
      "واما الذين كفروا افلم تكن ءايتي تتلى عليكم فاستكبرتم وكنتم قوما مجرمين",
  },
  {
    verseId: 31,
    name: "الجاثية",
    surahId: 45,
    text: "وَإِذَا قِيلَ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞ وَٱلسَّاعَةُ لَا رَيۡبَ فِيهَا قُلۡتُم مَّا نَدۡرِي مَا ٱلسَّاعَةُ إِن نَّظُنُّ إِلَّا ظَنّٗا وَمَا نَحۡنُ بِمُسۡتَيۡقِنِينَ",
    translation:
      "And when it was said, 'Indeed, the promise of Allah is truth and the Hour [is coming] - no doubt about it,' you said, 'We know not what is the Hour. We assume only assumption, and we are not convinced",
    normalizedText:
      "واذا قيل ان وعد الله حق والساعة لا ريب فيها قلتم ما ندري ما الساعة ان نظن الا ظنا وما نحن بمستيقنين",
  },
  {
    verseId: 32,
    name: "الجاثية",
    surahId: 45,
    text: "وَبَدَا لَهُمۡ سَيِّـَٔاتُ مَا عَمِلُواْ وَحَاقَ بِهِم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "And the evil consequences of what they did will appear to them, and they will be enveloped by what they used to ridicule",
    normalizedText: "وبدا لهم سيات ما عملوا وحاق بهم ما كانوا به يستهزءون",
  },
  {
    verseId: 33,
    name: "الجاثية",
    surahId: 45,
    text: "وَقِيلَ ٱلۡيَوۡمَ نَنسَىٰكُمۡ كَمَا نَسِيتُمۡ لِقَآءَ يَوۡمِكُمۡ هَٰذَا وَمَأۡوَىٰكُمُ ٱلنَّارُ وَمَا لَكُم مِّن نَّـٰصِرِينَ",
    translation:
      'And it will be said, "Today We will forget you as you forgot the meeting of this Day of yours, and your refuge is the Fire, and for you there are no helpers',
    normalizedText:
      "وقيل اليوم ننسىكم كما نسيتم لقاء يومكم هذا وماوىكم النار وما لكم من نصرين",
  },
  {
    verseId: 34,
    name: "الجاثية",
    surahId: 45,
    text: "ذَٰلِكُم بِأَنَّكُمُ ٱتَّخَذۡتُمۡ ءَايَٰتِ ٱللَّهِ هُزُوٗا وَغَرَّتۡكُمُ ٱلۡحَيَوٰةُ ٱلدُّنۡيَاۚ فَٱلۡيَوۡمَ لَا يُخۡرَجُونَ مِنۡهَا وَلَا هُمۡ يُسۡتَعۡتَبُونَ",
    translation:
      'That is because you took the verses of Allah in ridicule, and worldly life deluded you." So that Day they will not be removed from it, nor will they be asked to appease [Allah]',
    normalizedText:
      "ذلكم بانكم اتخذتم ءايت الله هزوا وغرتكم الحيوة الدنيا فاليوم لا يخرجون منها ولا هم يستعتبون",
  },
  {
    verseId: 35,
    name: "الجاثية",
    surahId: 45,
    text: "فَلِلَّهِ ٱلۡحَمۡدُ رَبِّ ٱلسَّمَٰوَٰتِ وَرَبِّ ٱلۡأَرۡضِ رَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "Then, to Allah belongs [all] praise - Lord of the heavens and Lord of the earth, Lord of the worlds",
    normalizedText: "فلله الحمد رب السموت ورب الارض رب العلمين",
  },
  {
    verseId: 36,
    name: "الجاثية",
    surahId: 45,
    text: "وَلَهُ ٱلۡكِبۡرِيَآءُ فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "And to Him belongs [all] grandeur within the heavens and the earth, and He is the Exalted in Might, the Wise",
    normalizedText: "وله الكبرياء في السموت والارض وهو العزيز الحكيم",
  },
  {
    verseId: 0,
    name: "الأحقاف",
    surahId: 46,
    text: "حمٓ",
    translation: "Ha, Meem",
    normalizedText: "حم",
  },
  {
    verseId: 1,
    name: "الأحقاف",
    surahId: 46,
    text: "تَنزِيلُ ٱلۡكِتَٰبِ مِنَ ٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ",
    translation:
      "The revelation of the Book is from Allah, the Exalted in Might, the Wise",
    normalizedText: "تنزيل الكتب من الله العزيز الحكيم",
  },
  {
    verseId: 2,
    name: "الأحقاف",
    surahId: 46,
    text: "مَا خَلَقۡنَا ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَآ إِلَّا بِٱلۡحَقِّ وَأَجَلٖ مُّسَمّٗىۚ وَٱلَّذِينَ كَفَرُواْ عَمَّآ أُنذِرُواْ مُعۡرِضُونَ",
    translation:
      "We did not create the heavens and earth and what is between them except in truth and [for] a specified term. But those who disbelieve, from that of which they are warned, are turning away",
    normalizedText:
      "ما خلقنا السموت والارض وما بينهما الا بالحق واجل مسمى والذين كفروا عما انذروا معرضون",
  },
  {
    verseId: 3,
    name: "الأحقاف",
    surahId: 46,
    text: "قُلۡ أَرَءَيۡتُم مَّا تَدۡعُونَ مِن دُونِ ٱللَّهِ أَرُونِي مَاذَا خَلَقُواْ مِنَ ٱلۡأَرۡضِ أَمۡ لَهُمۡ شِرۡكٞ فِي ٱلسَّمَٰوَٰتِۖ ٱئۡتُونِي بِكِتَٰبٖ مِّن قَبۡلِ هَٰذَآ أَوۡ أَثَٰرَةٖ مِّنۡ عِلۡمٍ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Say, [O Muhammad], "Have you considered that which you invoke besides Allah? Show me what they have created of the earth; or did they have partnership in [creation of] the heavens? Bring me a scripture [revealed] before this or a [remaining] trace of knowledge, if you should be truthful',
    normalizedText:
      "قل ارءيتم ما تدعون من دون الله اروني ماذا خلقوا من الارض ام لهم شرك في السموت ااتوني بكتب من قبل هذا او اثرة من علم ان كنتم صدقين",
  },
  {
    verseId: 4,
    name: "الأحقاف",
    surahId: 46,
    text: "وَمَنۡ أَضَلُّ مِمَّن يَدۡعُواْ مِن دُونِ ٱللَّهِ مَن لَّا يَسۡتَجِيبُ لَهُۥٓ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ وَهُمۡ عَن دُعَآئِهِمۡ غَٰفِلُونَ",
    translation:
      "And who is more astray than he who invokes besides Allah those who will not respond to him until the Day of Resurrection, and they, of their invocation, are unaware",
    normalizedText:
      "ومن اضل ممن يدعوا من دون الله من لا يستجيب له الى يوم القيمة وهم عن دعااهم غفلون",
  },
  {
    verseId: 5,
    name: "الأحقاف",
    surahId: 46,
    text: "وَإِذَا حُشِرَ ٱلنَّاسُ كَانُواْ لَهُمۡ أَعۡدَآءٗ وَكَانُواْ بِعِبَادَتِهِمۡ كَٰفِرِينَ",
    translation:
      "And when the people are gathered [that Day], they [who were invoked] will be enemies to them, and they will be deniers of their worship",
    normalizedText: "واذا حشر الناس كانوا لهم اعداء وكانوا بعبادتهم كفرين",
  },
  {
    verseId: 6,
    name: "الأحقاف",
    surahId: 46,
    text: "وَإِذَا تُتۡلَىٰ عَلَيۡهِمۡ ءَايَٰتُنَا بَيِّنَٰتٖ قَالَ ٱلَّذِينَ كَفَرُواْ لِلۡحَقِّ لَمَّا جَآءَهُمۡ هَٰذَا سِحۡرٞ مُّبِينٌ",
    translation:
      'And when Our verses are recited to them as clear evidences, those who disbelieve say of the truth when it has come to them, "This is obvious magic',
    normalizedText:
      "واذا تتلى عليهم ءايتنا بينت قال الذين كفروا للحق لما جاءهم هذا سحر مبين",
  },
  {
    verseId: 7,
    name: "الأحقاف",
    surahId: 46,
    text: "أَمۡ يَقُولُونَ ٱفۡتَرَىٰهُۖ قُلۡ إِنِ ٱفۡتَرَيۡتُهُۥ فَلَا تَمۡلِكُونَ لِي مِنَ ٱللَّهِ شَيۡـًٔاۖ هُوَ أَعۡلَمُ بِمَا تُفِيضُونَ فِيهِۚ كَفَىٰ بِهِۦ شَهِيدَۢا بَيۡنِي وَبَيۡنَكُمۡۖ وَهُوَ ٱلۡغَفُورُ ٱلرَّحِيمُ",
    translation:
      'Or do they say, "He has invented it?" Say, "If I have invented it, you will not possess for me [the power of protection] from Allah at all. He is most knowing of that in which you are involved. Sufficient is He as Witness between me and you, and He is the Forgiving the Merciful',
    normalizedText:
      "ام يقولون افترىه قل ان افتريته فلا تملكون لي من الله شيا هو اعلم بما تفيضون فيه كفى به شهيدا بيني وبينكم وهو الغفور الرحيم",
  },
  {
    verseId: 8,
    name: "الأحقاف",
    surahId: 46,
    text: "قُلۡ مَا كُنتُ بِدۡعٗا مِّنَ ٱلرُّسُلِ وَمَآ أَدۡرِي مَا يُفۡعَلُ بِي وَلَا بِكُمۡۖ إِنۡ أَتَّبِعُ إِلَّا مَا يُوحَىٰٓ إِلَيَّ وَمَآ أَنَا۠ إِلَّا نَذِيرٞ مُّبِينٞ",
    translation:
      'Say, "I am not something original among the messengers, nor do I know what will be done with me or with you. I only follow that which is revealed to me, and I am not but a clear warner',
    normalizedText:
      "قل ما كنت بدعا من الرسل وما ادري ما يفعل بي ولا بكم ان اتبع الا ما يوحى الي وما انا الا نذير مبين",
  },
  {
    verseId: 9,
    name: "الأحقاف",
    surahId: 46,
    text: "قُلۡ أَرَءَيۡتُمۡ إِن كَانَ مِنۡ عِندِ ٱللَّهِ وَكَفَرۡتُم بِهِۦ وَشَهِدَ شَاهِدٞ مِّنۢ بَنِيٓ إِسۡرَـٰٓءِيلَ عَلَىٰ مِثۡلِهِۦ فَـَٔامَنَ وَٱسۡتَكۡبَرۡتُمۡۚ إِنَّ ٱللَّهَ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation: `Say, "Have you considered: if the Qur'an was from Allah, and you disbelieved in it while a witness from the Children of Israel has testified to something similar and believed while you were arrogant...?" Indeed, Allah does not guide the wrongdoing people`,
    normalizedText:
      "قل ارءيتم ان كان من عند الله وكفرتم به وشهد شاهد من بني اسرءيل على مثله فامن واستكبرتم ان الله لا يهدي القوم الظلمين",
  },
  {
    verseId: 10,
    name: "الأحقاف",
    surahId: 46,
    text: "وَقَالَ ٱلَّذِينَ كَفَرُواْ لِلَّذِينَ ءَامَنُواْ لَوۡ كَانَ خَيۡرٗا مَّا سَبَقُونَآ إِلَيۡهِۚ وَإِذۡ لَمۡ يَهۡتَدُواْ بِهِۦ فَسَيَقُولُونَ هَٰذَآ إِفۡكٞ قَدِيمٞ",
    translation:
      'And those who disbelieve say of those who believe, "If it had [truly] been good, they would not have preceded us to it." And when they are not guided by it, they will say, "This is an ancient falsehood',
    normalizedText:
      "وقال الذين كفروا للذين ءامنوا لو كان خيرا ما سبقونا اليه واذ لم يهتدوا به فسيقولون هذا افك قديم",
  },
  {
    verseId: 11,
    name: "الأحقاف",
    surahId: 46,
    text: "وَمِن قَبۡلِهِۦ كِتَٰبُ مُوسَىٰٓ إِمَامٗا وَرَحۡمَةٗۚ وَهَٰذَا كِتَٰبٞ مُّصَدِّقٞ لِّسَانًا عَرَبِيّٗا لِّيُنذِرَ ٱلَّذِينَ ظَلَمُواْ وَبُشۡرَىٰ لِلۡمُحۡسِنِينَ",
    translation:
      "And before it was the scripture of Moses to lead and as a mercy. And this is a confirming Book in an Arabic tongue to warn those who have wronged and as good tidings to the doers of good",
    normalizedText:
      "ومن قبله كتب موسى اماما ورحمة وهذا كتب مصدق لسانا عربيا لينذر الذين ظلموا وبشرى للمحسنين",
  },
  {
    verseId: 12,
    name: "الأحقاف",
    surahId: 46,
    text: "إِنَّ ٱلَّذِينَ قَالُواْ رَبُّنَا ٱللَّهُ ثُمَّ ٱسۡتَقَٰمُواْ فَلَا خَوۡفٌ عَلَيۡهِمۡ وَلَا هُمۡ يَحۡزَنُونَ",
    translation:
      'Indeed, those who have said, "Our Lord is Allah," and then remained on a right course - there will be no fear concerning them, nor will they grieve',
    normalizedText:
      "ان الذين قالوا ربنا الله ثم استقموا فلا خوف عليهم ولا هم يحزنون",
  },
  {
    verseId: 13,
    name: "الأحقاف",
    surahId: 46,
    text: "أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَنَّةِ خَٰلِدِينَ فِيهَا جَزَآءَۢ بِمَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Those are the companions of Paradise, abiding eternally therein as reward for what they used to do",
    normalizedText: "اولاك اصحب الجنة خلدين فيها جزاء بما كانوا يعملون",
  },
  {
    verseId: 14,
    name: "الأحقاف",
    surahId: 46,
    text: "وَوَصَّيۡنَا ٱلۡإِنسَٰنَ بِوَٰلِدَيۡهِ إِحۡسَٰنًاۖ حَمَلَتۡهُ أُمُّهُۥ كُرۡهٗا وَوَضَعَتۡهُ كُرۡهٗاۖ وَحَمۡلُهُۥ وَفِصَٰلُهُۥ ثَلَٰثُونَ شَهۡرًاۚ حَتَّىٰٓ إِذَا بَلَغَ أَشُدَّهُۥ وَبَلَغَ أَرۡبَعِينَ سَنَةٗ قَالَ رَبِّ أَوۡزِعۡنِيٓ أَنۡ أَشۡكُرَ نِعۡمَتَكَ ٱلَّتِيٓ أَنۡعَمۡتَ عَلَيَّ وَعَلَىٰ وَٰلِدَيَّ وَأَنۡ أَعۡمَلَ صَٰلِحٗا تَرۡضَىٰهُ وَأَصۡلِحۡ لِي فِي ذُرِّيَّتِيٓۖ إِنِّي تُبۡتُ إِلَيۡكَ وَإِنِّي مِنَ ٱلۡمُسۡلِمِينَ",
    translation:
      'And We have enjoined upon man, to his parents, good treatment. His mother carried him with hardship and gave birth to him with hardship, and his gestation and weaning [period] is thirty months. [He grows] until, when he reaches maturity and reaches [the age of] forty years, he says, "My Lord, enable me to be grateful for Your favor which You have bestowed upon me and upon my parents and to work righteousness of which You will approve and make righteous for me my offspring. Indeed, I have repented to You, and indeed, I am of the Muslims',
    normalizedText:
      "ووصينا الانسن بولديه احسنا حملته امه كرها ووضعته كرها وحمله وفصله ثلثون شهرا حتى اذا بلغ اشده وبلغ اربعين سنة قال رب اوزعني ان اشكر نعمتك التي انعمت علي وعلى ولدي وان اعمل صلحا ترضىه واصلح لي في ذريتي اني تبت اليك واني من المسلمين",
  },
  {
    verseId: 15,
    name: "الأحقاف",
    surahId: 46,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ نَتَقَبَّلُ عَنۡهُمۡ أَحۡسَنَ مَا عَمِلُواْ وَنَتَجَاوَزُ عَن سَيِّـَٔاتِهِمۡ فِيٓ أَصۡحَٰبِ ٱلۡجَنَّةِۖ وَعۡدَ ٱلصِّدۡقِ ٱلَّذِي كَانُواْ يُوعَدُونَ",
    translation:
      "Those are the ones from whom We will accept the best of what they did and overlook their misdeeds, [their being] among the companions of Paradise. [That is] the promise of truth which they had been promised",
    normalizedText:
      "اولاك الذين نتقبل عنهم احسن ما عملوا ونتجاوز عن سياتهم في اصحب الجنة وعد الصدق الذي كانوا يوعدون",
  },
  {
    verseId: 16,
    name: "الأحقاف",
    surahId: 46,
    text: "وَٱلَّذِي قَالَ لِوَٰلِدَيۡهِ أُفّٖ لَّكُمَآ أَتَعِدَانِنِيٓ أَنۡ أُخۡرَجَ وَقَدۡ خَلَتِ ٱلۡقُرُونُ مِن قَبۡلِي وَهُمَا يَسۡتَغِيثَانِ ٱللَّهَ وَيۡلَكَ ءَامِنۡ إِنَّ وَعۡدَ ٱللَّهِ حَقّٞ فَيَقُولُ مَا هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      'But one who says to his parents, "Uff to you; do you promise me that I will be brought forth [from the earth] when generations before me have already passed on [into oblivion]?" while they call to Allah for help [and to their son], "Woe to you! Believe! Indeed, the promise of Allah is truth." But he says, "This is not but legends of the former people',
    normalizedText:
      "والذي قال لولديه اف لكما اتعدانني ان اخرج وقد خلت القرون من قبلي وهما يستغيثان الله ويلك ءامن ان وعد الله حق فيقول ما هذا الا اسطير الاولين",
  },
  {
    verseId: 17,
    name: "الأحقاف",
    surahId: 46,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ حَقَّ عَلَيۡهِمُ ٱلۡقَوۡلُ فِيٓ أُمَمٖ قَدۡ خَلَتۡ مِن قَبۡلِهِم مِّنَ ٱلۡجِنِّ وَٱلۡإِنسِۖ إِنَّهُمۡ كَانُواْ خَٰسِرِينَ",
    translation:
      "Those are the ones upon whom the word has come into effect, [who will be] among nations which had passed on before them of jinn and men. Indeed, they [all] were losers",
    normalizedText:
      "اولاك الذين حق عليهم القول في امم قد خلت من قبلهم من الجن والانس انهم كانوا خسرين",
  },
  {
    verseId: 18,
    name: "الأحقاف",
    surahId: 46,
    text: "وَلِكُلّٖ دَرَجَٰتٞ مِّمَّا عَمِلُواْۖ وَلِيُوَفِّيَهُمۡ أَعۡمَٰلَهُمۡ وَهُمۡ لَا يُظۡلَمُونَ",
    translation:
      "And for all there are degrees [of reward and punishment] for what they have done, and [it is] so that He may fully compensate them for their deeds, and they will not be wronged",
    normalizedText: "ولكل درجت مما عملوا وليوفيهم اعملهم وهم لا يظلمون",
  },
  {
    verseId: 19,
    name: "الأحقاف",
    surahId: 46,
    text: "وَيَوۡمَ يُعۡرَضُ ٱلَّذِينَ كَفَرُواْ عَلَى ٱلنَّارِ أَذۡهَبۡتُمۡ طَيِّبَٰتِكُمۡ فِي حَيَاتِكُمُ ٱلدُّنۡيَا وَٱسۡتَمۡتَعۡتُم بِهَا فَٱلۡيَوۡمَ تُجۡزَوۡنَ عَذَابَ ٱلۡهُونِ بِمَا كُنتُمۡ تَسۡتَكۡبِرُونَ فِي ٱلۡأَرۡضِ بِغَيۡرِ ٱلۡحَقِّ وَبِمَا كُنتُمۡ تَفۡسُقُونَ",
    translation:
      'And the Day those who disbelieved are exposed to the Fire [it will be said], "You exhausted your pleasures during your worldly life and enjoyed them, so this Day you will be awarded the punishment of [extreme] humiliation because you were arrogant upon the earth without right and because you were defiantly disobedient',
    normalizedText:
      "ويوم يعرض الذين كفروا على النار اذهبتم طيبتكم في حياتكم الدنيا واستمتعتم بها فاليوم تجزون عذاب الهون بما كنتم تستكبرون في الارض بغير الحق وبما كنتم تفسقون",
  },
  {
    verseId: 20,
    name: "الأحقاف",
    surahId: 46,
    text: "۞وَٱذۡكُرۡ أَخَا عَادٍ إِذۡ أَنذَرَ قَوۡمَهُۥ بِٱلۡأَحۡقَافِ وَقَدۡ خَلَتِ ٱلنُّذُرُ مِنۢ بَيۡنِ يَدَيۡهِ وَمِنۡ خَلۡفِهِۦٓ أَلَّا تَعۡبُدُوٓاْ إِلَّا ٱللَّهَ إِنِّيٓ أَخَافُ عَلَيۡكُمۡ عَذَابَ يَوۡمٍ عَظِيمٖ",
    translation: `And mention, [O Muhammad], the brother of 'Aad, when he warned his people in the [region of] al-Ahqaf - and warners had already passed on before him and after him - [saying], "Do not worship except Allah. Indeed, I fear for you the punishment of a terrible day`,
    normalizedText:
      "۞واذكر اخا عاد اذ انذر قومه بالاحقاف وقد خلت النذر من بين يديه ومن خلفه الا تعبدوا الا الله اني اخاف عليكم عذاب يوم عظيم",
  },
  {
    verseId: 21,
    name: "الأحقاف",
    surahId: 46,
    text: "قَالُوٓاْ أَجِئۡتَنَا لِتَأۡفِكَنَا عَنۡ ءَالِهَتِنَا فَأۡتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلصَّـٰدِقِينَ",
    translation:
      'They said, "Have you come to delude us away from our gods? Then bring us what you promise us, if you should be of the truthful',
    normalizedText:
      "قالوا اجاتنا لتافكنا عن ءالهتنا فاتنا بما تعدنا ان كنت من الصدقين",
  },
  {
    verseId: 22,
    name: "الأحقاف",
    surahId: 46,
    text: "قَالَ إِنَّمَا ٱلۡعِلۡمُ عِندَ ٱللَّهِ وَأُبَلِّغُكُم مَّآ أُرۡسِلۡتُ بِهِۦ وَلَٰكِنِّيٓ أَرَىٰكُمۡ قَوۡمٗا تَجۡهَلُونَ",
    translation:
      'He said, "Knowledge [of its time] is only with Allah, and I convey to you that with which I was sent; but I see you [to be] a people behaving ignorantly',
    normalizedText:
      "قال انما العلم عند الله وابلغكم ما ارسلت به ولكني ارىكم قوما تجهلون",
  },
  {
    verseId: 23,
    name: "الأحقاف",
    surahId: 46,
    text: "فَلَمَّا رَأَوۡهُ عَارِضٗا مُّسۡتَقۡبِلَ أَوۡدِيَتِهِمۡ قَالُواْ هَٰذَا عَارِضٞ مُّمۡطِرُنَاۚ بَلۡ هُوَ مَا ٱسۡتَعۡجَلۡتُم بِهِۦۖ رِيحٞ فِيهَا عَذَابٌ أَلِيمٞ",
    translation:
      'And when they saw it as a cloud approaching their valleys, they said, "This is a cloud bringing us rain!" Rather, it is that for which you were impatient: a wind, within it a painful punishment',
    normalizedText:
      "فلما راوه عارضا مستقبل اوديتهم قالوا هذا عارض ممطرنا بل هو ما استعجلتم به ريح فيها عذاب اليم",
  },
  {
    verseId: 24,
    name: "الأحقاف",
    surahId: 46,
    text: "تُدَمِّرُ كُلَّ شَيۡءِۭ بِأَمۡرِ رَبِّهَا فَأَصۡبَحُواْ لَا يُرَىٰٓ إِلَّا مَسَٰكِنُهُمۡۚ كَذَٰلِكَ نَجۡزِي ٱلۡقَوۡمَ ٱلۡمُجۡرِمِينَ",
    translation:
      "Destroying everything by command of its Lord. And they became so that nothing was seen [of them] except their dwellings. Thus do We recompense the criminal people",
    normalizedText:
      "تدمر كل شيء بامر ربها فاصبحوا لا يرى الا مسكنهم كذلك نجزي القوم المجرمين",
  },
  {
    verseId: 25,
    name: "الأحقاف",
    surahId: 46,
    text: "وَلَقَدۡ مَكَّنَّـٰهُمۡ فِيمَآ إِن مَّكَّنَّـٰكُمۡ فِيهِ وَجَعَلۡنَا لَهُمۡ سَمۡعٗا وَأَبۡصَٰرٗا وَأَفۡـِٔدَةٗ فَمَآ أَغۡنَىٰ عَنۡهُمۡ سَمۡعُهُمۡ وَلَآ أَبۡصَٰرُهُمۡ وَلَآ أَفۡـِٔدَتُهُم مِّن شَيۡءٍ إِذۡ كَانُواْ يَجۡحَدُونَ بِـَٔايَٰتِ ٱللَّهِ وَحَاقَ بِهِم مَّا كَانُواْ بِهِۦ يَسۡتَهۡزِءُونَ",
    translation:
      "And We had certainly established them in such as We have not established you, and We made for them hearing and vision and hearts. But their hearing and vision and hearts availed them not from anything [of the punishment] when they were [continually] rejecting the signs of Allah; and they were enveloped by what they used to ridicule",
    normalizedText:
      "ولقد مكنهم فيما ان مكنكم فيه وجعلنا لهم سمعا وابصرا وافدة فما اغنى عنهم سمعهم ولا ابصرهم ولا افدتهم من شيء اذ كانوا يجحدون بايت الله وحاق بهم ما كانوا به يستهزءون",
  },
  {
    verseId: 26,
    name: "الأحقاف",
    surahId: 46,
    text: "وَلَقَدۡ أَهۡلَكۡنَا مَا حَوۡلَكُم مِّنَ ٱلۡقُرَىٰ وَصَرَّفۡنَا ٱلۡأٓيَٰتِ لَعَلَّهُمۡ يَرۡجِعُونَ",
    translation:
      "And We have already destroyed what surrounds you of [those] cities, and We have diversified the signs [or verses] that perhaps they might return [from disbelief]",
    normalizedText: "ولقد اهلكنا ما حولكم من القرى وصرفنا الايت لعلهم يرجعون",
  },
  {
    verseId: 27,
    name: "الأحقاف",
    surahId: 46,
    text: "فَلَوۡلَا نَصَرَهُمُ ٱلَّذِينَ ٱتَّخَذُواْ مِن دُونِ ٱللَّهِ قُرۡبَانًا ءَالِهَةَۢۖ بَلۡ ضَلُّواْ عَنۡهُمۡۚ وَذَٰلِكَ إِفۡكُهُمۡ وَمَا كَانُواْ يَفۡتَرُونَ",
    translation:
      "Then why did those they took besides Allah as deities by which to approach [Him] not aid them? But they had strayed from them. And that was their falsehood and what they were inventing",
    normalizedText:
      "فلولا نصرهم الذين اتخذوا من دون الله قربانا ءالهة بل ضلوا عنهم وذلك افكهم وما كانوا يفترون",
  },
  {
    verseId: 28,
    name: "الأحقاف",
    surahId: 46,
    text: "وَإِذۡ صَرَفۡنَآ إِلَيۡكَ نَفَرٗا مِّنَ ٱلۡجِنِّ يَسۡتَمِعُونَ ٱلۡقُرۡءَانَ فَلَمَّا حَضَرُوهُ قَالُوٓاْ أَنصِتُواْۖ فَلَمَّا قُضِيَ وَلَّوۡاْ إِلَىٰ قَوۡمِهِم مُّنذِرِينَ",
    translation: `And [mention, O Muhammad], when We directed to you a few of the jinn, listening to the Qur'an. And when they attended it, they said, "Listen quietly." And when it was concluded, they went back to their people as warners`,
    normalizedText:
      "واذ صرفنا اليك نفرا من الجن يستمعون القرءان فلما حضروه قالوا انصتوا فلما قضي ولوا الى قومهم منذرين",
  },
  {
    verseId: 29,
    name: "الأحقاف",
    surahId: 46,
    text: "قَالُواْ يَٰقَوۡمَنَآ إِنَّا سَمِعۡنَا كِتَٰبًا أُنزِلَ مِنۢ بَعۡدِ مُوسَىٰ مُصَدِّقٗا لِّمَا بَيۡنَ يَدَيۡهِ يَهۡدِيٓ إِلَى ٱلۡحَقِّ وَإِلَىٰ طَرِيقٖ مُّسۡتَقِيمٖ",
    translation:
      'They said, "O our people, indeed we have heard a [recited] Book revealed after Moses confirming what was before it which guides to the truth and to a straight path',
    normalizedText:
      "قالوا يقومنا انا سمعنا كتبا انزل من بعد موسى مصدقا لما بين يديه يهدي الى الحق والى طريق مستقيم",
  },
  {
    verseId: 30,
    name: "الأحقاف",
    surahId: 46,
    text: "يَٰقَوۡمَنَآ أَجِيبُواْ دَاعِيَ ٱللَّهِ وَءَامِنُواْ بِهِۦ يَغۡفِرۡ لَكُم مِّن ذُنُوبِكُمۡ وَيُجِرۡكُم مِّنۡ عَذَابٍ أَلِيمٖ",
    translation:
      "O our people, respond to the Messenger of Allah and believe in him; Allah will forgive for you your sins and protect you from a painful punishment",
    normalizedText:
      "يقومنا اجيبوا داعي الله وءامنوا به يغفر لكم من ذنوبكم ويجركم من عذاب اليم",
  },
  {
    verseId: 31,
    name: "الأحقاف",
    surahId: 46,
    text: "وَمَن لَّا يُجِبۡ دَاعِيَ ٱللَّهِ فَلَيۡسَ بِمُعۡجِزٖ فِي ٱلۡأَرۡضِ وَلَيۡسَ لَهُۥ مِن دُونِهِۦٓ أَوۡلِيَآءُۚ أُوْلَـٰٓئِكَ فِي ضَلَٰلٖ مُّبِينٍ",
    translation:
      "But he who does not respond to the Caller of Allah will not cause failure [to Him] upon earth, and he will not have besides Him any protectors. Those are in manifest error",
    normalizedText:
      "ومن لا يجب داعي الله فليس بمعجز في الارض وليس له من دونه اولياء اولاك في ضلل مبين",
  },
  {
    verseId: 32,
    name: "الأحقاف",
    surahId: 46,
    text: "أَوَلَمۡ يَرَوۡاْ أَنَّ ٱللَّهَ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَلَمۡ يَعۡيَ بِخَلۡقِهِنَّ بِقَٰدِرٍ عَلَىٰٓ أَن يُحۡـِۧيَ ٱلۡمَوۡتَىٰۚ بَلَىٰٓۚ إِنَّهُۥ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "Do they not see that Allah, who created the heavens and earth and did not fail in their creation, is able to give life to the dead? Yes. Indeed, He is over all things competent",
    normalizedText:
      "اولم يروا ان الله الذي خلق السموت والارض ولم يعي بخلقهن بقدر على ان يحي الموتى بلى انه على كل شيء قدير",
  },
  {
    verseId: 33,
    name: "الأحقاف",
    surahId: 46,
    text: "وَيَوۡمَ يُعۡرَضُ ٱلَّذِينَ كَفَرُواْ عَلَى ٱلنَّارِ أَلَيۡسَ هَٰذَا بِٱلۡحَقِّۖ قَالُواْ بَلَىٰ وَرَبِّنَاۚ قَالَ فَذُوقُواْ ٱلۡعَذَابَ بِمَا كُنتُمۡ تَكۡفُرُونَ",
    translation:
      'And the Day those who disbelieved are exposed to the Fire [it will be said], "Is this not the truth?" They will say, "Yes, by our Lord." He will say, "Then taste the punishment because you used to disbelieve',
    normalizedText:
      "ويوم يعرض الذين كفروا على النار اليس هذا بالحق قالوا بلى وربنا قال فذوقوا العذاب بما كنتم تكفرون",
  },
  {
    verseId: 34,
    name: "الأحقاف",
    surahId: 46,
    text: "فَٱصۡبِرۡ كَمَا صَبَرَ أُوْلُواْ ٱلۡعَزۡمِ مِنَ ٱلرُّسُلِ وَلَا تَسۡتَعۡجِل لَّهُمۡۚ كَأَنَّهُمۡ يَوۡمَ يَرَوۡنَ مَا يُوعَدُونَ لَمۡ يَلۡبَثُوٓاْ إِلَّا سَاعَةٗ مِّن نَّهَارِۭۚ بَلَٰغٞۚ فَهَلۡ يُهۡلَكُ إِلَّا ٱلۡقَوۡمُ ٱلۡفَٰسِقُونَ",
    translation:
      "So be patient, [O Muhammad], as were those of determination among the messengers and do not be impatient for them. It will be - on the Day they see that which they are promised - as though they had not remained [in the world] except an hour of a day. [This is] notification. And will [any] be destroyed except the defiantly disobedient people",
    normalizedText:
      "فاصبر كما صبر اولوا العزم من الرسل ولا تستعجل لهم كانهم يوم يرون ما يوعدون لم يلبثوا الا ساعة من نهار بلغ فهل يهلك الا القوم الفسقون",
  },
  {
    verseId: 0,
    name: "محمد",
    surahId: 47,
    text: "ٱلَّذِينَ كَفَرُواْ وَصَدُّواْ عَن سَبِيلِ ٱللَّهِ أَضَلَّ أَعۡمَٰلَهُمۡ",
    translation:
      "Those who disbelieve and avert [people] from the way of Allah - He will waste their deeds",
    normalizedText: "الذين كفروا وصدوا عن سبيل الله اضل اعملهم",
  },
  {
    verseId: 1,
    name: "محمد",
    surahId: 47,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَءَامَنُواْ بِمَا نُزِّلَ عَلَىٰ مُحَمَّدٖ وَهُوَ ٱلۡحَقُّ مِن رَّبِّهِمۡ كَفَّرَ عَنۡهُمۡ سَيِّـَٔاتِهِمۡ وَأَصۡلَحَ بَالَهُمۡ",
    translation:
      "And those who believe and do righteous deeds and believe in what has been sent down upon Muhammad - and it is the truth from their Lord - He will remove from them their misdeeds and amend their condition",
    normalizedText:
      "والذين ءامنوا وعملوا الصلحت وءامنوا بما نزل على محمد وهو الحق من ربهم كفر عنهم سياتهم واصلح بالهم",
  },
  {
    verseId: 2,
    name: "محمد",
    surahId: 47,
    text: "ذَٰلِكَ بِأَنَّ ٱلَّذِينَ كَفَرُواْ ٱتَّبَعُواْ ٱلۡبَٰطِلَ وَأَنَّ ٱلَّذِينَ ءَامَنُواْ ٱتَّبَعُواْ ٱلۡحَقَّ مِن رَّبِّهِمۡۚ كَذَٰلِكَ يَضۡرِبُ ٱللَّهُ لِلنَّاسِ أَمۡثَٰلَهُمۡ",
    translation:
      "That is because those who disbelieve follow falsehood, and those who believe follow the truth from their Lord. Thus does Allah present to the people their comparisons",
    normalizedText:
      "ذلك بان الذين كفروا اتبعوا البطل وان الذين ءامنوا اتبعوا الحق من ربهم كذلك يضرب الله للناس امثلهم",
  },
  {
    verseId: 3,
    name: "محمد",
    surahId: 47,
    text: "فَإِذَا لَقِيتُمُ ٱلَّذِينَ كَفَرُواْ فَضَرۡبَ ٱلرِّقَابِ حَتَّىٰٓ إِذَآ أَثۡخَنتُمُوهُمۡ فَشُدُّواْ ٱلۡوَثَاقَ فَإِمَّا مَنَّۢا بَعۡدُ وَإِمَّا فِدَآءً حَتَّىٰ تَضَعَ ٱلۡحَرۡبُ أَوۡزَارَهَاۚ ذَٰلِكَۖ وَلَوۡ يَشَآءُ ٱللَّهُ لَٱنتَصَرَ مِنۡهُمۡ وَلَٰكِن لِّيَبۡلُوَاْ بَعۡضَكُم بِبَعۡضٖۗ وَٱلَّذِينَ قُتِلُواْ فِي سَبِيلِ ٱللَّهِ فَلَن يُضِلَّ أَعۡمَٰلَهُمۡ",
    translation:
      "So when you meet those who disbelieve [in battle], strike [their] necks until, when you have inflicted slaughter upon them, then secure their bonds, and either [confer] favor afterwards or ransom [them] until the war lays down its burdens. That [is the command]. And if Allah had willed, He could have taken vengeance upon them [Himself], but [He ordered armed struggle] to test some of you by means of others. And those who are killed in the cause of Allah - never will He waste their deeds",
    normalizedText:
      "فاذا لقيتم الذين كفروا فضرب الرقاب حتى اذا اثخنتموهم فشدوا الوثاق فاما منا بعد واما فداء حتى تضع الحرب اوزارها ذلك ولو يشاء الله لانتصر منهم ولكن ليبلوا بعضكم ببعض والذين قتلوا في سبيل الله فلن يضل اعملهم",
  },
  {
    verseId: 4,
    name: "محمد",
    surahId: 47,
    text: "سَيَهۡدِيهِمۡ وَيُصۡلِحُ بَالَهُمۡ",
    translation: "He will guide them and amend their condition",
    normalizedText: "سيهديهم ويصلح بالهم",
  },
  {
    verseId: 5,
    name: "محمد",
    surahId: 47,
    text: "وَيُدۡخِلُهُمُ ٱلۡجَنَّةَ عَرَّفَهَا لَهُمۡ",
    translation: "And admit them to Paradise, which He has made known to them",
    normalizedText: "ويدخلهم الجنة عرفها لهم",
  },
  {
    verseId: 6,
    name: "محمد",
    surahId: 47,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِن تَنصُرُواْ ٱللَّهَ يَنصُرۡكُمۡ وَيُثَبِّتۡ أَقۡدَامَكُمۡ",
    translation:
      "O you who have believed, if you support Allah, He will support you and plant firmly your feet",
    normalizedText: "يايها الذين ءامنوا ان تنصروا الله ينصركم ويثبت اقدامكم",
  },
  {
    verseId: 7,
    name: "محمد",
    surahId: 47,
    text: "وَٱلَّذِينَ كَفَرُواْ فَتَعۡسٗا لَّهُمۡ وَأَضَلَّ أَعۡمَٰلَهُمۡ",
    translation:
      "But those who disbelieve - for them is misery, and He will waste their deeds",
    normalizedText: "والذين كفروا فتعسا لهم واضل اعملهم",
  },
  {
    verseId: 8,
    name: "محمد",
    surahId: 47,
    text: "ذَٰلِكَ بِأَنَّهُمۡ كَرِهُواْ مَآ أَنزَلَ ٱللَّهُ فَأَحۡبَطَ أَعۡمَٰلَهُمۡ",
    translation:
      "That is because they disliked what Allah revealed, so He rendered worthless their deeds",
    normalizedText: "ذلك بانهم كرهوا ما انزل الله فاحبط اعملهم",
  },
  {
    verseId: 9,
    name: "محمد",
    surahId: 47,
    text: "۞أَفَلَمۡ يَسِيرُواْ فِي ٱلۡأَرۡضِ فَيَنظُرُواْ كَيۡفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبۡلِهِمۡۖ دَمَّرَ ٱللَّهُ عَلَيۡهِمۡۖ وَلِلۡكَٰفِرِينَ أَمۡثَٰلُهَا",
    translation:
      "Have they not traveled through the land and seen how was the end of those before them? Allah destroyed [everything] over them, and for the disbelievers is something comparable",
    normalizedText:
      "۞افلم يسيروا في الارض فينظروا كيف كان عقبة الذين من قبلهم دمر الله عليهم وللكفرين امثلها",
  },
  {
    verseId: 10,
    name: "محمد",
    surahId: 47,
    text: "ذَٰلِكَ بِأَنَّ ٱللَّهَ مَوۡلَى ٱلَّذِينَ ءَامَنُواْ وَأَنَّ ٱلۡكَٰفِرِينَ لَا مَوۡلَىٰ لَهُمۡ",
    translation:
      "That is because Allah is the protector of those who have believed and because the disbelievers have no protector",
    normalizedText: "ذلك بان الله مولى الذين ءامنوا وان الكفرين لا مولى لهم",
  },
  {
    verseId: 11,
    name: "محمد",
    surahId: 47,
    text: "إِنَّ ٱللَّهَ يُدۡخِلُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۖ وَٱلَّذِينَ كَفَرُواْ يَتَمَتَّعُونَ وَيَأۡكُلُونَ كَمَا تَأۡكُلُ ٱلۡأَنۡعَٰمُ وَٱلنَّارُ مَثۡوٗى لَّهُمۡ",
    translation:
      "Indeed, Allah will admit those who have believed and done righteous deeds to gardens beneath which rivers flow, but those who disbelieve enjoy themselves and eat as grazing livestock eat, and the Fire will be a residence for them",
    normalizedText:
      "ان الله يدخل الذين ءامنوا وعملوا الصلحت جنت تجري من تحتها الانهر والذين كفروا يتمتعون وياكلون كما تاكل الانعم والنار مثوى لهم",
  },
  {
    verseId: 12,
    name: "محمد",
    surahId: 47,
    text: "وَكَأَيِّن مِّن قَرۡيَةٍ هِيَ أَشَدُّ قُوَّةٗ مِّن قَرۡيَتِكَ ٱلَّتِيٓ أَخۡرَجَتۡكَ أَهۡلَكۡنَٰهُمۡ فَلَا نَاصِرَ لَهُمۡ",
    translation:
      "And how many a city was stronger than your city [Makkah] which drove you out? We destroyed them; and there was no helper for them",
    normalizedText:
      "وكاين من قرية هي اشد قوة من قريتك التي اخرجتك اهلكنهم فلا ناصر لهم",
  },
  {
    verseId: 13,
    name: "محمد",
    surahId: 47,
    text: "أَفَمَن كَانَ عَلَىٰ بَيِّنَةٖ مِّن رَّبِّهِۦ كَمَن زُيِّنَ لَهُۥ سُوٓءُ عَمَلِهِۦ وَٱتَّبَعُوٓاْ أَهۡوَآءَهُم",
    translation:
      "So is he who is on clear evidence from his Lord like him to whom the evil of his work has been made attractive and they follow their [own] desires",
    normalizedText:
      "افمن كان على بينة من ربه كمن زين له سوء عمله واتبعوا اهواءهم",
  },
  {
    verseId: 14,
    name: "محمد",
    surahId: 47,
    text: "مَّثَلُ ٱلۡجَنَّةِ ٱلَّتِي وُعِدَ ٱلۡمُتَّقُونَۖ فِيهَآ أَنۡهَٰرٞ مِّن مَّآءٍ غَيۡرِ ءَاسِنٖ وَأَنۡهَٰرٞ مِّن لَّبَنٖ لَّمۡ يَتَغَيَّرۡ طَعۡمُهُۥ وَأَنۡهَٰرٞ مِّنۡ خَمۡرٖ لَّذَّةٖ لِّلشَّـٰرِبِينَ وَأَنۡهَٰرٞ مِّنۡ عَسَلٖ مُّصَفّٗىۖ وَلَهُمۡ فِيهَا مِن كُلِّ ٱلثَّمَرَٰتِ وَمَغۡفِرَةٞ مِّن رَّبِّهِمۡۖ كَمَنۡ هُوَ خَٰلِدٞ فِي ٱلنَّارِ وَسُقُواْ مَآءً حَمِيمٗا فَقَطَّعَ أَمۡعَآءَهُمۡ",
    translation:
      "Is the description of Paradise, which the righteous are promised, wherein are rivers of water unaltered, rivers of milk the taste of which never changes, rivers of wine delicious to those who drink, and rivers of purified honey, in which they will have from all [kinds of] fruits and forgiveness from their Lord, like [that of] those who abide eternally in the Fire and are given to drink scalding water that will sever their intestines",
    normalizedText:
      "مثل الجنة التي وعد المتقون فيها انهر من ماء غير ءاسن وانهر من لبن لم يتغير طعمه وانهر من خمر لذة للشربين وانهر من عسل مصفى ولهم فيها من كل الثمرت ومغفرة من ربهم كمن هو خلد في النار وسقوا ماء حميما فقطع امعاءهم",
  },
  {
    verseId: 15,
    name: "محمد",
    surahId: 47,
    text: "وَمِنۡهُم مَّن يَسۡتَمِعُ إِلَيۡكَ حَتَّىٰٓ إِذَا خَرَجُواْ مِنۡ عِندِكَ قَالُواْ لِلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ مَاذَا قَالَ ءَانِفًاۚ أُوْلَـٰٓئِكَ ٱلَّذِينَ طَبَعَ ٱللَّهُ عَلَىٰ قُلُوبِهِمۡ وَٱتَّبَعُوٓاْ أَهۡوَآءَهُمۡ",
    translation:
      'And among them, [O Muhammad], are those who listen to you, until when they depart from you, they say to those who were given knowledge, "What has he said just now?" Those are the ones of whom Allah has sealed over their hearts and who have followed their [own] desires',
    normalizedText:
      "ومنهم من يستمع اليك حتى اذا خرجوا من عندك قالوا للذين اوتوا العلم ماذا قال ءانفا اولاك الذين طبع الله على قلوبهم واتبعوا اهواءهم",
  },
  {
    verseId: 16,
    name: "محمد",
    surahId: 47,
    text: "وَٱلَّذِينَ ٱهۡتَدَوۡاْ زَادَهُمۡ هُدٗى وَءَاتَىٰهُمۡ تَقۡوَىٰهُمۡ",
    translation:
      "And those who are guided - He increases them in guidance and gives them their righteousness",
    normalizedText: "والذين اهتدوا زادهم هدى وءاتىهم تقوىهم",
  },
  {
    verseId: 17,
    name: "محمد",
    surahId: 47,
    text: "فَهَلۡ يَنظُرُونَ إِلَّا ٱلسَّاعَةَ أَن تَأۡتِيَهُم بَغۡتَةٗۖ فَقَدۡ جَآءَ أَشۡرَاطُهَاۚ فَأَنَّىٰ لَهُمۡ إِذَا جَآءَتۡهُمۡ ذِكۡرَىٰهُمۡ",
    translation:
      "Then do they await except that the Hour should come upon them unexpectedly? But already there have come [some of] its indications. Then what good to them, when it has come, will be their remembrance",
    normalizedText:
      "فهل ينظرون الا الساعة ان تاتيهم بغتة فقد جاء اشراطها فانى لهم اذا جاءتهم ذكرىهم",
  },
  {
    verseId: 18,
    name: "محمد",
    surahId: 47,
    text: "فَٱعۡلَمۡ أَنَّهُۥ لَآ إِلَٰهَ إِلَّا ٱللَّهُ وَٱسۡتَغۡفِرۡ لِذَنۢبِكَ وَلِلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِۗ وَٱللَّهُ يَعۡلَمُ مُتَقَلَّبَكُمۡ وَمَثۡوَىٰكُمۡ",
    translation:
      "So know, [O Muhammad], that there is no deity except Allah and ask forgiveness for your sin and for the believing men and believing women. And Allah knows of your movement and your resting place",
    normalizedText:
      "فاعلم انه لا اله الا الله واستغفر لذنبك وللمامنين والمامنت والله يعلم متقلبكم ومثوىكم",
  },
  {
    verseId: 19,
    name: "محمد",
    surahId: 47,
    text: "وَيَقُولُ ٱلَّذِينَ ءَامَنُواْ لَوۡلَا نُزِّلَتۡ سُورَةٞۖ فَإِذَآ أُنزِلَتۡ سُورَةٞ مُّحۡكَمَةٞ وَذُكِرَ فِيهَا ٱلۡقِتَالُ رَأَيۡتَ ٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٞ يَنظُرُونَ إِلَيۡكَ نَظَرَ ٱلۡمَغۡشِيِّ عَلَيۡهِ مِنَ ٱلۡمَوۡتِۖ فَأَوۡلَىٰ لَهُمۡ",
    translation:
      'Those who believe say, "Why has a surah not been sent down? But when a precise surah is revealed and fighting is mentioned therein, you see those in whose hearts is hypocrisy looking at you with a look of one overcome by death. And more appropriate for them [would have been]',
    normalizedText:
      "ويقول الذين ءامنوا لولا نزلت سورة فاذا انزلت سورة محكمة وذكر فيها القتال رايت الذين في قلوبهم مرض ينظرون اليك نظر المغشي عليه من الموت فاولى لهم",
  },
  {
    verseId: 20,
    name: "محمد",
    surahId: 47,
    text: "طَاعَةٞ وَقَوۡلٞ مَّعۡرُوفٞۚ فَإِذَا عَزَمَ ٱلۡأَمۡرُ فَلَوۡ صَدَقُواْ ٱللَّهَ لَكَانَ خَيۡرٗا لَّهُمۡ",
    translation:
      "Obedience and good words. And when the matter [of fighting] was determined, if they had been true to Allah, it would have been better for them",
    normalizedText:
      "طاعة وقول معروف فاذا عزم الامر فلو صدقوا الله لكان خيرا لهم",
  },
  {
    verseId: 21,
    name: "محمد",
    surahId: 47,
    text: "فَهَلۡ عَسَيۡتُمۡ إِن تَوَلَّيۡتُمۡ أَن تُفۡسِدُواْ فِي ٱلۡأَرۡضِ وَتُقَطِّعُوٓاْ أَرۡحَامَكُمۡ",
    translation:
      "So would you perhaps, if you turned away, cause corruption on earth and sever your [ties of] relationship",
    normalizedText: "فهل عسيتم ان توليتم ان تفسدوا في الارض وتقطعوا ارحامكم",
  },
  {
    verseId: 22,
    name: "محمد",
    surahId: 47,
    text: "أُوْلَـٰٓئِكَ ٱلَّذِينَ لَعَنَهُمُ ٱللَّهُ فَأَصَمَّهُمۡ وَأَعۡمَىٰٓ أَبۡصَٰرَهُمۡ",
    translation:
      "Those [who do so] are the ones that Allah has cursed, so He deafened them and blinded their vision",
    normalizedText: "اولاك الذين لعنهم الله فاصمهم واعمى ابصرهم",
  },
  {
    verseId: 23,
    name: "محمد",
    surahId: 47,
    text: "أَفَلَا يَتَدَبَّرُونَ ٱلۡقُرۡءَانَ أَمۡ عَلَىٰ قُلُوبٍ أَقۡفَالُهَآ",
    translation:
      "Then do they not reflect upon the Qur'an, or are there locks upon [their] hearts",
    normalizedText: "افلا يتدبرون القرءان ام على قلوب اقفالها",
  },
  {
    verseId: 24,
    name: "محمد",
    surahId: 47,
    text: "إِنَّ ٱلَّذِينَ ٱرۡتَدُّواْ عَلَىٰٓ أَدۡبَٰرِهِم مِّنۢ بَعۡدِ مَا تَبَيَّنَ لَهُمُ ٱلۡهُدَى ٱلشَّيۡطَٰنُ سَوَّلَ لَهُمۡ وَأَمۡلَىٰ لَهُمۡ",
    translation:
      "Indeed, those who reverted back [to disbelief] after guidance had become clear to them - Satan enticed them and prolonged hope for them",
    normalizedText:
      "ان الذين ارتدوا على ادبرهم من بعد ما تبين لهم الهدى الشيطن سول لهم واملى لهم",
  },
  {
    verseId: 25,
    name: "محمد",
    surahId: 47,
    text: "ذَٰلِكَ بِأَنَّهُمۡ قَالُواْ لِلَّذِينَ كَرِهُواْ مَا نَزَّلَ ٱللَّهُ سَنُطِيعُكُمۡ فِي بَعۡضِ ٱلۡأَمۡرِۖ وَٱللَّهُ يَعۡلَمُ إِسۡرَارَهُمۡ",
    translation:
      'That is because they said to those who disliked what Allah sent down, "We will obey you in part of the matter." And Allah knows what they conceal',
    normalizedText:
      "ذلك بانهم قالوا للذين كرهوا ما نزل الله سنطيعكم في بعض الامر والله يعلم اسرارهم",
  },
  {
    verseId: 26,
    name: "محمد",
    surahId: 47,
    text: "فَكَيۡفَ إِذَا تَوَفَّتۡهُمُ ٱلۡمَلَـٰٓئِكَةُ يَضۡرِبُونَ وُجُوهَهُمۡ وَأَدۡبَٰرَهُمۡ",
    translation:
      "Then how [will it be] when the angels take them in death, striking their faces and their backs",
    normalizedText: "فكيف اذا توفتهم الملاكة يضربون وجوههم وادبرهم",
  },
  {
    verseId: 27,
    name: "محمد",
    surahId: 47,
    text: "ذَٰلِكَ بِأَنَّهُمُ ٱتَّبَعُواْ مَآ أَسۡخَطَ ٱللَّهَ وَكَرِهُواْ رِضۡوَٰنَهُۥ فَأَحۡبَطَ أَعۡمَٰلَهُمۡ",
    translation:
      "That is because they followed what angered Allah and disliked [what earns] His pleasure, so He rendered worthless their deeds",
    normalizedText: "ذلك بانهم اتبعوا ما اسخط الله وكرهوا رضونه فاحبط اعملهم",
  },
  {
    verseId: 28,
    name: "محمد",
    surahId: 47,
    text: "أَمۡ حَسِبَ ٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٌ أَن لَّن يُخۡرِجَ ٱللَّهُ أَضۡغَٰنَهُمۡ",
    translation:
      "Or do those in whose hearts is disease think that Allah would never expose their [feelings of] hatred",
    normalizedText: "ام حسب الذين في قلوبهم مرض ان لن يخرج الله اضغنهم",
  },
  {
    verseId: 29,
    name: "محمد",
    surahId: 47,
    text: "وَلَوۡ نَشَآءُ لَأَرَيۡنَٰكَهُمۡ فَلَعَرَفۡتَهُم بِسِيمَٰهُمۡۚ وَلَتَعۡرِفَنَّهُمۡ فِي لَحۡنِ ٱلۡقَوۡلِۚ وَٱللَّهُ يَعۡلَمُ أَعۡمَٰلَكُمۡ",
    translation:
      "And if We willed, We could show them to you, and you would know them by their mark; but you will surely know them by the tone of [their] speech. And Allah knows your deeds",
    normalizedText:
      "ولو نشاء لارينكهم فلعرفتهم بسيمهم ولتعرفنهم في لحن القول والله يعلم اعملكم",
  },
  {
    verseId: 30,
    name: "محمد",
    surahId: 47,
    text: "وَلَنَبۡلُوَنَّكُمۡ حَتَّىٰ نَعۡلَمَ ٱلۡمُجَٰهِدِينَ مِنكُمۡ وَٱلصَّـٰبِرِينَ وَنَبۡلُوَاْ أَخۡبَارَكُمۡ",
    translation:
      "And We will surely test you until We make evident those who strive among you [for the cause of Allah] and the patient, and We will test your affairs",
    normalizedText: "ولنبلونكم حتى نعلم المجهدين منكم والصبرين ونبلوا اخباركم",
  },
  {
    verseId: 31,
    name: "محمد",
    surahId: 47,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ وَصَدُّواْ عَن سَبِيلِ ٱللَّهِ وَشَآقُّواْ ٱلرَّسُولَ مِنۢ بَعۡدِ مَا تَبَيَّنَ لَهُمُ ٱلۡهُدَىٰ لَن يَضُرُّواْ ٱللَّهَ شَيۡـٔٗا وَسَيُحۡبِطُ أَعۡمَٰلَهُمۡ",
    translation:
      "Indeed, those who disbelieved and averted [people] from the path of Allah and opposed the Messenger after guidance had become clear to them - never will they harm Allah at all, and He will render worthless their deeds",
    normalizedText:
      "ان الذين كفروا وصدوا عن سبيل الله وشاقوا الرسول من بعد ما تبين لهم الهدى لن يضروا الله شيا وسيحبط اعملهم",
  },
  {
    verseId: 32,
    name: "محمد",
    surahId: 47,
    text: "۞يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ أَطِيعُواْ ٱللَّهَ وَأَطِيعُواْ ٱلرَّسُولَ وَلَا تُبۡطِلُوٓاْ أَعۡمَٰلَكُمۡ",
    translation:
      "O you who have believed, obey Allah and obey the Messenger and do not invalidate your deeds",
    normalizedText:
      "۞يايها الذين ءامنوا اطيعوا الله واطيعوا الرسول ولا تبطلوا اعملكم",
  },
  {
    verseId: 33,
    name: "محمد",
    surahId: 47,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ وَصَدُّواْ عَن سَبِيلِ ٱللَّهِ ثُمَّ مَاتُواْ وَهُمۡ كُفَّارٞ فَلَن يَغۡفِرَ ٱللَّهُ لَهُمۡ",
    translation:
      "Indeed, those who disbelieved and averted [people] from the path of Allah and then died while they were disbelievers - never will Allah forgive them",
    normalizedText:
      "ان الذين كفروا وصدوا عن سبيل الله ثم ماتوا وهم كفار فلن يغفر الله لهم",
  },
  {
    verseId: 34,
    name: "محمد",
    surahId: 47,
    text: "فَلَا تَهِنُواْ وَتَدۡعُوٓاْ إِلَى ٱلسَّلۡمِ وَأَنتُمُ ٱلۡأَعۡلَوۡنَ وَٱللَّهُ مَعَكُمۡ وَلَن يَتِرَكُمۡ أَعۡمَٰلَكُمۡ",
    translation:
      "So do not weaken and call for peace while you are superior; and Allah is with you and will never deprive you of [the reward of] your deeds",
    normalizedText:
      "فلا تهنوا وتدعوا الى السلم وانتم الاعلون والله معكم ولن يتركم اعملكم",
  },
  {
    verseId: 35,
    name: "محمد",
    surahId: 47,
    text: "إِنَّمَا ٱلۡحَيَوٰةُ ٱلدُّنۡيَا لَعِبٞ وَلَهۡوٞۚ وَإِن تُؤۡمِنُواْ وَتَتَّقُواْ يُؤۡتِكُمۡ أُجُورَكُمۡ وَلَا يَسۡـَٔلۡكُمۡ أَمۡوَٰلَكُمۡ",
    translation:
      "[This] worldly life is only amusement and diversion. And if you believe and fear Allah, He will give you your rewards and not ask you for your properties",
    normalizedText:
      "انما الحيوة الدنيا لعب ولهو وان تامنوا وتتقوا ياتكم اجوركم ولا يسلكم امولكم",
  },
  {
    verseId: 36,
    name: "محمد",
    surahId: 47,
    text: "إِن يَسۡـَٔلۡكُمُوهَا فَيُحۡفِكُمۡ تَبۡخَلُواْ وَيُخۡرِجۡ أَضۡغَٰنَكُمۡ",
    translation:
      "If He should ask you for them and press you, you would withhold, and He would expose your unwillingness",
    normalizedText: "ان يسلكموها فيحفكم تبخلوا ويخرج اضغنكم",
  },
  {
    verseId: 37,
    name: "محمد",
    surahId: 47,
    text: "هَـٰٓأَنتُمۡ هَـٰٓؤُلَآءِ تُدۡعَوۡنَ لِتُنفِقُواْ فِي سَبِيلِ ٱللَّهِ فَمِنكُم مَّن يَبۡخَلُۖ وَمَن يَبۡخَلۡ فَإِنَّمَا يَبۡخَلُ عَن نَّفۡسِهِۦۚ وَٱللَّهُ ٱلۡغَنِيُّ وَأَنتُمُ ٱلۡفُقَرَآءُۚ وَإِن تَتَوَلَّوۡاْ يَسۡتَبۡدِلۡ قَوۡمًا غَيۡرَكُمۡ ثُمَّ لَا يَكُونُوٓاْ أَمۡثَٰلَكُم",
    translation:
      "Here you are - those invited to spend in the cause of Allah - but among you are those who withhold [out of greed]. And whoever withholds only withholds [benefit] from himself; and Allah is the Free of need, while you are the needy. And if you turn away, He will replace you with another people; then they will not be the likes of you",
    normalizedText:
      "هانتم هالاء تدعون لتنفقوا في سبيل الله فمنكم من يبخل ومن يبخل فانما يبخل عن نفسه والله الغني وانتم الفقراء وان تتولوا يستبدل قوما غيركم ثم لا يكونوا امثلكم",
  },
  {
    verseId: 0,
    name: "الفتح",
    surahId: 48,
    text: "إِنَّا فَتَحۡنَا لَكَ فَتۡحٗا مُّبِينٗا",
    translation: "Indeed, We have given you, [O Muhammad], a clear conquest",
    normalizedText: "انا فتحنا لك فتحا مبينا",
  },
  {
    verseId: 1,
    name: "الفتح",
    surahId: 48,
    text: "لِّيَغۡفِرَ لَكَ ٱللَّهُ مَا تَقَدَّمَ مِن ذَنۢبِكَ وَمَا تَأَخَّرَ وَيُتِمَّ نِعۡمَتَهُۥ عَلَيۡكَ وَيَهۡدِيَكَ صِرَٰطٗا مُّسۡتَقِيمٗا",
    translation:
      "That Allah may forgive for you what preceded of your sin and what will follow and complete His favor upon you and guide you to a straight path",
    normalizedText:
      "ليغفر لك الله ما تقدم من ذنبك وما تاخر ويتم نعمته عليك ويهديك صرطا مستقيما",
  },
  {
    verseId: 2,
    name: "الفتح",
    surahId: 48,
    text: "وَيَنصُرَكَ ٱللَّهُ نَصۡرًا عَزِيزًا",
    translation: "And [that] Allah may aid you with a mighty victory",
    normalizedText: "وينصرك الله نصرا عزيزا",
  },
  {
    verseId: 3,
    name: "الفتح",
    surahId: 48,
    text: "هُوَ ٱلَّذِيٓ أَنزَلَ ٱلسَّكِينَةَ فِي قُلُوبِ ٱلۡمُؤۡمِنِينَ لِيَزۡدَادُوٓاْ إِيمَٰنٗا مَّعَ إِيمَٰنِهِمۡۗ وَلِلَّهِ جُنُودُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمٗا",
    translation:
      "It is He who sent down tranquillity into the hearts of the believers that they would increase in faith along with their [present] faith. And to Allah belong the soldiers of the heavens and the earth, and ever is Allah Knowing and Wise",
    normalizedText:
      "هو الذي انزل السكينة في قلوب المامنين ليزدادوا ايمنا مع ايمنهم ولله جنود السموت والارض وكان الله عليما حكيما",
  },
  {
    verseId: 4,
    name: "الفتح",
    surahId: 48,
    text: "لِّيُدۡخِلَ ٱلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَا وَيُكَفِّرَ عَنۡهُمۡ سَيِّـَٔاتِهِمۡۚ وَكَانَ ذَٰلِكَ عِندَ ٱللَّهِ فَوۡزًا عَظِيمٗا",
    translation:
      "[And] that He may admit the believing men and the believing women to gardens beneath which rivers flow to abide therein eternally and remove from them their misdeeds - and ever is that, in the sight of Allah, a great attainment",
    normalizedText:
      "ليدخل المامنين والمامنت جنت تجري من تحتها الانهر خلدين فيها ويكفر عنهم سياتهم وكان ذلك عند الله فوزا عظيما",
  },
  {
    verseId: 5,
    name: "الفتح",
    surahId: 48,
    text: "وَيُعَذِّبَ ٱلۡمُنَٰفِقِينَ وَٱلۡمُنَٰفِقَٰتِ وَٱلۡمُشۡرِكِينَ وَٱلۡمُشۡرِكَٰتِ ٱلظَّآنِّينَ بِٱللَّهِ ظَنَّ ٱلسَّوۡءِۚ عَلَيۡهِمۡ دَآئِرَةُ ٱلسَّوۡءِۖ وَغَضِبَ ٱللَّهُ عَلَيۡهِمۡ وَلَعَنَهُمۡ وَأَعَدَّ لَهُمۡ جَهَنَّمَۖ وَسَآءَتۡ مَصِيرٗا",
    translation:
      "And [that] He may punish the hypocrite men and hypocrite women, and the polytheist men and polytheist women - those who assume about Allah an assumption of evil nature. Upon them is a misfortune of evil nature; and Allah has become angry with them and has cursed them and prepared for them Hell, and evil it is as a destination",
    normalizedText:
      "ويعذب المنفقين والمنفقت والمشركين والمشركت الظانين بالله ظن السوء عليهم داارة السوء وغضب الله عليهم ولعنهم واعد لهم جهنم وساءت مصيرا",
  },
  {
    verseId: 6,
    name: "الفتح",
    surahId: 48,
    text: "وَلِلَّهِ جُنُودُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمًا",
    translation:
      "And to Allah belong the soldiers of the heavens and the earth. And ever is Allah Exalted in Might and Wise",
    normalizedText: "ولله جنود السموت والارض وكان الله عزيزا حكيما",
  },
  {
    verseId: 7,
    name: "الفتح",
    surahId: 48,
    text: "إِنَّآ أَرۡسَلۡنَٰكَ شَٰهِدٗا وَمُبَشِّرٗا وَنَذِيرٗا",
    translation:
      "Indeed, We have sent you as a witness and a bringer of good tidings and a warner",
    normalizedText: "انا ارسلنك شهدا ومبشرا ونذيرا",
  },
  {
    verseId: 8,
    name: "الفتح",
    surahId: 48,
    text: "لِّتُؤۡمِنُواْ بِٱللَّهِ وَرَسُولِهِۦ وَتُعَزِّرُوهُ وَتُوَقِّرُوهُۚ وَتُسَبِّحُوهُ بُكۡرَةٗ وَأَصِيلًا",
    translation:
      "That you [people] may believe in Allah and His Messenger and honor him and respect the Prophet and exalt Allah morning and afternoon",
    normalizedText: "لتامنوا بالله ورسوله وتعزروه وتوقروه وتسبحوه بكرة واصيلا",
  },
  {
    verseId: 9,
    name: "الفتح",
    surahId: 48,
    text: "إِنَّ ٱلَّذِينَ يُبَايِعُونَكَ إِنَّمَا يُبَايِعُونَ ٱللَّهَ يَدُ ٱللَّهِ فَوۡقَ أَيۡدِيهِمۡۚ فَمَن نَّكَثَ فَإِنَّمَا يَنكُثُ عَلَىٰ نَفۡسِهِۦۖ وَمَنۡ أَوۡفَىٰ بِمَا عَٰهَدَ عَلَيۡهُ ٱللَّهَ فَسَيُؤۡتِيهِ أَجۡرًا عَظِيمٗا",
    translation:
      "Indeed, those who pledge allegiance to you, [O Muhammad] - they are actually pledging allegiance to Allah. The hand of Allah is over their hands. So he who breaks his word only breaks it to the detriment of himself. And he who fulfills that which he has promised Allah - He will give him a great reward",
    normalizedText:
      "ان الذين يبايعونك انما يبايعون الله يد الله فوق ايديهم فمن نكث فانما ينكث على نفسه ومن اوفى بما عهد عليه الله فسياتيه اجرا عظيما",
  },
  {
    verseId: 10,
    name: "الفتح",
    surahId: 48,
    text: "سَيَقُولُ لَكَ ٱلۡمُخَلَّفُونَ مِنَ ٱلۡأَعۡرَابِ شَغَلَتۡنَآ أَمۡوَٰلُنَا وَأَهۡلُونَا فَٱسۡتَغۡفِرۡ لَنَاۚ يَقُولُونَ بِأَلۡسِنَتِهِم مَّا لَيۡسَ فِي قُلُوبِهِمۡۚ قُلۡ فَمَن يَمۡلِكُ لَكُم مِّنَ ٱللَّهِ شَيۡـًٔا إِنۡ أَرَادَ بِكُمۡ ضَرًّا أَوۡ أَرَادَ بِكُمۡ نَفۡعَۢاۚ بَلۡ كَانَ ٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرَۢا",
    translation:
      'Those who remained behind of the bedouins will say to you, "Our properties and our families occupied us, so ask forgiveness for us." They say with their tongues what is not within their hearts. Say, "Then who could prevent Allah at all if He intended for you harm or intended for you benefit? Rather, ever is Allah, with what you do, Acquainted',
    normalizedText:
      "سيقول لك المخلفون من الاعراب شغلتنا امولنا واهلونا فاستغفر لنا يقولون بالسنتهم ما ليس في قلوبهم قل فمن يملك لكم من الله شيا ان اراد بكم ضرا او اراد بكم نفعا بل كان الله بما تعملون خبيرا",
  },
  {
    verseId: 11,
    name: "الفتح",
    surahId: 48,
    text: "بَلۡ ظَنَنتُمۡ أَن لَّن يَنقَلِبَ ٱلرَّسُولُ وَٱلۡمُؤۡمِنُونَ إِلَىٰٓ أَهۡلِيهِمۡ أَبَدٗا وَزُيِّنَ ذَٰلِكَ فِي قُلُوبِكُمۡ وَظَنَنتُمۡ ظَنَّ ٱلسَّوۡءِ وَكُنتُمۡ قَوۡمَۢا بُورٗا",
    translation:
      "But you thought that the Messenger and the believers would never return to their families, ever, and that was made pleasing in your hearts. And you assumed an assumption of evil and became a people ruined",
    normalizedText:
      "بل ظننتم ان لن ينقلب الرسول والمامنون الى اهليهم ابدا وزين ذلك في قلوبكم وظننتم ظن السوء وكنتم قوما بورا",
  },
  {
    verseId: 12,
    name: "الفتح",
    surahId: 48,
    text: "وَمَن لَّمۡ يُؤۡمِنۢ بِٱللَّهِ وَرَسُولِهِۦ فَإِنَّآ أَعۡتَدۡنَا لِلۡكَٰفِرِينَ سَعِيرٗا",
    translation:
      "And whoever has not believed in Allah and His Messenger - then indeed, We have prepared for the disbelievers a Blaze",
    normalizedText: "ومن لم يامن بالله ورسوله فانا اعتدنا للكفرين سعيرا",
  },
  {
    verseId: 13,
    name: "الفتح",
    surahId: 48,
    text: "وَلِلَّهِ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ يَغۡفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُۚ وَكَانَ ٱللَّهُ غَفُورٗا رَّحِيمٗا",
    translation:
      "And to Allah belongs the dominion of the heavens and the earth. He forgives whom He wills and punishes whom He wills. And ever is Allah Forgiving and Merciful",
    normalizedText:
      "ولله ملك السموت والارض يغفر لمن يشاء ويعذب من يشاء وكان الله غفورا رحيما",
  },
  {
    verseId: 14,
    name: "الفتح",
    surahId: 48,
    text: "سَيَقُولُ ٱلۡمُخَلَّفُونَ إِذَا ٱنطَلَقۡتُمۡ إِلَىٰ مَغَانِمَ لِتَأۡخُذُوهَا ذَرُونَا نَتَّبِعۡكُمۡۖ يُرِيدُونَ أَن يُبَدِّلُواْ كَلَٰمَ ٱللَّهِۚ قُل لَّن تَتَّبِعُونَا كَذَٰلِكُمۡ قَالَ ٱللَّهُ مِن قَبۡلُۖ فَسَيَقُولُونَ بَلۡ تَحۡسُدُونَنَاۚ بَلۡ كَانُواْ لَا يَفۡقَهُونَ إِلَّا قَلِيلٗا",
    translation:
      'Those who remained behind will say when you set out toward the war booty to take it, "Let us follow you." They wish to change the words of Allah. Say, "Never will you follow us. Thus did Allah say before." So they will say, "Rather, you envy us." But [in fact] they were not understanding except a little',
    normalizedText:
      "سيقول المخلفون اذا انطلقتم الى مغانم لتاخذوها ذرونا نتبعكم يريدون ان يبدلوا كلم الله قل لن تتبعونا كذلكم قال الله من قبل فسيقولون بل تحسدوننا بل كانوا لا يفقهون الا قليلا",
  },
  {
    verseId: 15,
    name: "الفتح",
    surahId: 48,
    text: "قُل لِّلۡمُخَلَّفِينَ مِنَ ٱلۡأَعۡرَابِ سَتُدۡعَوۡنَ إِلَىٰ قَوۡمٍ أُوْلِي بَأۡسٖ شَدِيدٖ تُقَٰتِلُونَهُمۡ أَوۡ يُسۡلِمُونَۖ فَإِن تُطِيعُواْ يُؤۡتِكُمُ ٱللَّهُ أَجۡرًا حَسَنٗاۖ وَإِن تَتَوَلَّوۡاْ كَمَا تَوَلَّيۡتُم مِّن قَبۡلُ يُعَذِّبۡكُمۡ عَذَابًا أَلِيمٗا",
    translation:
      'Say to those who remained behind of the bedouins, "You will be called to [face] a people of great military might; you may fight them, or they will submit. So if you obey, Allah will give you a good reward; but if you turn away as you turned away before, He will punish you with a painful punishment',
    normalizedText:
      "قل للمخلفين من الاعراب ستدعون الى قوم اولي باس شديد تقتلونهم او يسلمون فان تطيعوا ياتكم الله اجرا حسنا وان تتولوا كما توليتم من قبل يعذبكم عذابا اليما",
  },
  {
    verseId: 16,
    name: "الفتح",
    surahId: 48,
    text: "لَّيۡسَ عَلَى ٱلۡأَعۡمَىٰ حَرَجٞ وَلَا عَلَى ٱلۡأَعۡرَجِ حَرَجٞ وَلَا عَلَى ٱلۡمَرِيضِ حَرَجٞۗ وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ يُدۡخِلۡهُ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۖ وَمَن يَتَوَلَّ يُعَذِّبۡهُ عَذَابًا أَلِيمٗا",
    translation:
      "There is not upon the blind any guilt or upon the lame any guilt or upon the ill any guilt [for remaining behind]. And whoever obeys Allah and His Messenger - He will admit him to gardens beneath which rivers flow; but whoever turns away - He will punish him with a painful punishment",
    normalizedText:
      "ليس على الاعمى حرج ولا على الاعرج حرج ولا على المريض حرج ومن يطع الله ورسوله يدخله جنت تجري من تحتها الانهر ومن يتول يعذبه عذابا اليما",
  },
  {
    verseId: 17,
    name: "الفتح",
    surahId: 48,
    text: "۞لَّقَدۡ رَضِيَ ٱللَّهُ عَنِ ٱلۡمُؤۡمِنِينَ إِذۡ يُبَايِعُونَكَ تَحۡتَ ٱلشَّجَرَةِ فَعَلِمَ مَا فِي قُلُوبِهِمۡ فَأَنزَلَ ٱلسَّكِينَةَ عَلَيۡهِمۡ وَأَثَٰبَهُمۡ فَتۡحٗا قَرِيبٗا",
    translation:
      "Certainly was Allah pleased with the believers when they pledged allegiance to you, [O Muhammad], under the tree, and He knew what was in their hearts, so He sent down tranquillity upon them and rewarded them with an imminent conquest",
    normalizedText:
      "۞لقد رضي الله عن المامنين اذ يبايعونك تحت الشجرة فعلم ما في قلوبهم فانزل السكينة عليهم واثبهم فتحا قريبا",
  },
  {
    verseId: 18,
    name: "الفتح",
    surahId: 48,
    text: "وَمَغَانِمَ كَثِيرَةٗ يَأۡخُذُونَهَاۗ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمٗا",
    translation:
      "And much war booty which they will take. And ever is Allah Exalted in Might and Wise",
    normalizedText: "ومغانم كثيرة ياخذونها وكان الله عزيزا حكيما",
  },
  {
    verseId: 19,
    name: "الفتح",
    surahId: 48,
    text: "وَعَدَكُمُ ٱللَّهُ مَغَانِمَ كَثِيرَةٗ تَأۡخُذُونَهَا فَعَجَّلَ لَكُمۡ هَٰذِهِۦ وَكَفَّ أَيۡدِيَ ٱلنَّاسِ عَنكُمۡ وَلِتَكُونَ ءَايَةٗ لِّلۡمُؤۡمِنِينَ وَيَهۡدِيَكُمۡ صِرَٰطٗا مُّسۡتَقِيمٗا",
    translation:
      "Allah has promised you much booty that you will take [in the future] and has hastened for you this [victory] and withheld the hands of people from you - that it may be a sign for the believers and [that] He may guide you to a straight path",
    normalizedText:
      "وعدكم الله مغانم كثيرة تاخذونها فعجل لكم هذه وكف ايدي الناس عنكم ولتكون ءاية للمامنين ويهديكم صرطا مستقيما",
  },
  {
    verseId: 20,
    name: "الفتح",
    surahId: 48,
    text: "وَأُخۡرَىٰ لَمۡ تَقۡدِرُواْ عَلَيۡهَا قَدۡ أَحَاطَ ٱللَّهُ بِهَاۚ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٗا",
    translation:
      "And [He promises] other [victories] that you were [so far] unable to [realize] which Allah has already encompassed. And ever is Allah, over all things, competent",
    normalizedText:
      "واخرى لم تقدروا عليها قد احاط الله بها وكان الله على كل شيء قديرا",
  },
  {
    verseId: 21,
    name: "الفتح",
    surahId: 48,
    text: "وَلَوۡ قَٰتَلَكُمُ ٱلَّذِينَ كَفَرُواْ لَوَلَّوُاْ ٱلۡأَدۡبَٰرَ ثُمَّ لَا يَجِدُونَ وَلِيّٗا وَلَا نَصِيرٗا",
    translation:
      "And if those [Makkans] who disbelieve had fought you, they would have turned their backs [in flight]. Then they would not find a protector or a helper",
    normalizedText:
      "ولو قتلكم الذين كفروا لولوا الادبر ثم لا يجدون وليا ولا نصيرا",
  },
  {
    verseId: 22,
    name: "الفتح",
    surahId: 48,
    text: "سُنَّةَ ٱللَّهِ ٱلَّتِي قَدۡ خَلَتۡ مِن قَبۡلُۖ وَلَن تَجِدَ لِسُنَّةِ ٱللَّهِ تَبۡدِيلٗا",
    translation:
      "[This is] the established way of Allah which has occurred before. And never will you find in the way of Allah any change",
    normalizedText: "سنة الله التي قد خلت من قبل ولن تجد لسنة الله تبديلا",
  },
  {
    verseId: 23,
    name: "الفتح",
    surahId: 48,
    text: "وَهُوَ ٱلَّذِي كَفَّ أَيۡدِيَهُمۡ عَنكُمۡ وَأَيۡدِيَكُمۡ عَنۡهُم بِبَطۡنِ مَكَّةَ مِنۢ بَعۡدِ أَنۡ أَظۡفَرَكُمۡ عَلَيۡهِمۡۚ وَكَانَ ٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرًا",
    translation:
      "And it is He who withheld their hands from you and your hands from them within [the area of] Makkah after He caused you to overcome them. And ever is Allah of what you do, Seeing",
    normalizedText:
      "وهو الذي كف ايديهم عنكم وايديكم عنهم ببطن مكة من بعد ان اظفركم عليهم وكان الله بما تعملون بصيرا",
  },
  {
    verseId: 24,
    name: "الفتح",
    surahId: 48,
    text: "هُمُ ٱلَّذِينَ كَفَرُواْ وَصَدُّوكُمۡ عَنِ ٱلۡمَسۡجِدِ ٱلۡحَرَامِ وَٱلۡهَدۡيَ مَعۡكُوفًا أَن يَبۡلُغَ مَحِلَّهُۥۚ وَلَوۡلَا رِجَالٞ مُّؤۡمِنُونَ وَنِسَآءٞ مُّؤۡمِنَٰتٞ لَّمۡ تَعۡلَمُوهُمۡ أَن تَطَـُٔوهُمۡ فَتُصِيبَكُم مِّنۡهُم مَّعَرَّةُۢ بِغَيۡرِ عِلۡمٖۖ لِّيُدۡخِلَ ٱللَّهُ فِي رَحۡمَتِهِۦ مَن يَشَآءُۚ لَوۡ تَزَيَّلُواْ لَعَذَّبۡنَا ٱلَّذِينَ كَفَرُواْ مِنۡهُمۡ عَذَابًا أَلِيمًا",
    translation:
      "They are the ones who disbelieved and obstructed you from al-Masjid al-Haram while the offering was prevented from reaching its place of sacrifice. And if not for believing men and believing women whom you did not know - that you might trample them and there would befall you because of them dishonor without [your] knowledge - [you would have been permitted to enter Makkah]. [This was so] that Allah might admit to His mercy whom He willed. If they had been apart [from them], We would have punished those who disbelieved among them with painful punishment",
    normalizedText:
      "هم الذين كفروا وصدوكم عن المسجد الحرام والهدي معكوفا ان يبلغ محله ولولا رجال مامنون ونساء مامنت لم تعلموهم ان تطوهم فتصيبكم منهم معرة بغير علم ليدخل الله في رحمته من يشاء لو تزيلوا لعذبنا الذين كفروا منهم عذابا اليما",
  },
  {
    verseId: 25,
    name: "الفتح",
    surahId: 48,
    text: "إِذۡ جَعَلَ ٱلَّذِينَ كَفَرُواْ فِي قُلُوبِهِمُ ٱلۡحَمِيَّةَ حَمِيَّةَ ٱلۡجَٰهِلِيَّةِ فَأَنزَلَ ٱللَّهُ سَكِينَتَهُۥ عَلَىٰ رَسُولِهِۦ وَعَلَى ٱلۡمُؤۡمِنِينَ وَأَلۡزَمَهُمۡ كَلِمَةَ ٱلتَّقۡوَىٰ وَكَانُوٓاْ أَحَقَّ بِهَا وَأَهۡلَهَاۚ وَكَانَ ٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمٗا",
    translation:
      "When those who disbelieved had put into their hearts chauvinism - the chauvinism of the time of ignorance. But Allah sent down His tranquillity upon His Messenger and upon the believers and imposed upon them the word of righteousness, and they were more deserving of it and worthy of it. And ever is Allah, of all things, Knowing",
    normalizedText:
      "اذ جعل الذين كفروا في قلوبهم الحمية حمية الجهلية فانزل الله سكينته على رسوله وعلى المامنين والزمهم كلمة التقوى وكانوا احق بها واهلها وكان الله بكل شيء عليما",
  },
  {
    verseId: 26,
    name: "الفتح",
    surahId: 48,
    text: "لَّقَدۡ صَدَقَ ٱللَّهُ رَسُولَهُ ٱلرُّءۡيَا بِٱلۡحَقِّۖ لَتَدۡخُلُنَّ ٱلۡمَسۡجِدَ ٱلۡحَرَامَ إِن شَآءَ ٱللَّهُ ءَامِنِينَ مُحَلِّقِينَ رُءُوسَكُمۡ وَمُقَصِّرِينَ لَا تَخَافُونَۖ فَعَلِمَ مَا لَمۡ تَعۡلَمُواْ فَجَعَلَ مِن دُونِ ذَٰلِكَ فَتۡحٗا قَرِيبًا",
    translation:
      "Certainly has Allah showed to His Messenger the vision in truth. You will surely enter al-Masjid al-Haram, if Allah wills, in safety, with your heads shaved and [hair] shortened, not fearing [anyone]. He knew what you did not know and has arranged before that a conquest near [at hand]",
    normalizedText:
      "لقد صدق الله رسوله الرءيا بالحق لتدخلن المسجد الحرام ان شاء الله ءامنين محلقين رءوسكم ومقصرين لا تخافون فعلم ما لم تعلموا فجعل من دون ذلك فتحا قريبا",
  },
  {
    verseId: 27,
    name: "الفتح",
    surahId: 48,
    text: "هُوَ ٱلَّذِيٓ أَرۡسَلَ رَسُولَهُۥ بِٱلۡهُدَىٰ وَدِينِ ٱلۡحَقِّ لِيُظۡهِرَهُۥ عَلَى ٱلدِّينِ كُلِّهِۦۚ وَكَفَىٰ بِٱللَّهِ شَهِيدٗا",
    translation:
      "It is He who sent His Messenger with guidance and the religion of truth to manifest it over all religion. And sufficient is Allah as Witness",
    normalizedText:
      "هو الذي ارسل رسوله بالهدى ودين الحق ليظهره على الدين كله وكفى بالله شهيدا",
  },
  {
    verseId: 28,
    name: "الفتح",
    surahId: 48,
    text: "مُّحَمَّدٞ رَّسُولُ ٱللَّهِۚ وَٱلَّذِينَ مَعَهُۥٓ أَشِدَّآءُ عَلَى ٱلۡكُفَّارِ رُحَمَآءُ بَيۡنَهُمۡۖ تَرَىٰهُمۡ رُكَّعٗا سُجَّدٗا يَبۡتَغُونَ فَضۡلٗا مِّنَ ٱللَّهِ وَرِضۡوَٰنٗاۖ سِيمَاهُمۡ فِي وُجُوهِهِم مِّنۡ أَثَرِ ٱلسُّجُودِۚ ذَٰلِكَ مَثَلُهُمۡ فِي ٱلتَّوۡرَىٰةِۚ وَمَثَلُهُمۡ فِي ٱلۡإِنجِيلِ كَزَرۡعٍ أَخۡرَجَ شَطۡـَٔهُۥ فَـَٔازَرَهُۥ فَٱسۡتَغۡلَظَ فَٱسۡتَوَىٰ عَلَىٰ سُوقِهِۦ يُعۡجِبُ ٱلزُّرَّاعَ لِيَغِيظَ بِهِمُ ٱلۡكُفَّارَۗ وَعَدَ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ مِنۡهُم مَّغۡفِرَةٗ وَأَجۡرًا عَظِيمَۢا",
    translation:
      "Muhammad is the Messenger of Allah; and those with him are forceful against the disbelievers, merciful among themselves. You see them bowing and prostrating [in prayer], seeking bounty from Allah and [His] pleasure. Their mark is on their faces from the trace of prostration. That is their description in the Torah. And their description in the Gospel is as a plant which produces its offshoots and strengthens them so they grow firm and stand upon their stalks, delighting the sowers - so that Allah may enrage by them the disbelievers. Allah has promised those who believe and do righteous deeds among them forgiveness and a great reward",
    normalizedText:
      "محمد رسول الله والذين معه اشداء على الكفار رحماء بينهم ترىهم ركعا سجدا يبتغون فضلا من الله ورضونا سيماهم في وجوههم من اثر السجود ذلك مثلهم في التورىة ومثلهم في الانجيل كزرع اخرج شطه فازره فاستغلظ فاستوى على سوقه يعجب الزراع ليغيظ بهم الكفار وعد الله الذين ءامنوا وعملوا الصلحت منهم مغفرة واجرا عظيما",
  },
  {
    verseId: 0,
    name: "الحجرات",
    surahId: 49,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تُقَدِّمُواْ بَيۡنَ يَدَيِ ٱللَّهِ وَرَسُولِهِۦۖ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٞ",
    translation:
      "O you who have believed, do not put [yourselves] before Allah and His Messenger but fear Allah. Indeed, Allah is Hearing and Knowing",
    normalizedText:
      "يايها الذين ءامنوا لا تقدموا بين يدي الله ورسوله واتقوا الله ان الله سميع عليم",
  },
  {
    verseId: 1,
    name: "الحجرات",
    surahId: 49,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَرۡفَعُوٓاْ أَصۡوَٰتَكُمۡ فَوۡقَ صَوۡتِ ٱلنَّبِيِّ وَلَا تَجۡهَرُواْ لَهُۥ بِٱلۡقَوۡلِ كَجَهۡرِ بَعۡضِكُمۡ لِبَعۡضٍ أَن تَحۡبَطَ أَعۡمَٰلُكُمۡ وَأَنتُمۡ لَا تَشۡعُرُونَ",
    translation:
      "O you who have believed, do not raise your voices above the voice of the Prophet or be loud to him in speech like the loudness of some of you to others, lest your deeds become worthless while you perceive not",
    normalizedText:
      "يايها الذين ءامنوا لا ترفعوا اصوتكم فوق صوت النبي ولا تجهروا له بالقول كجهر بعضكم لبعض ان تحبط اعملكم وانتم لا تشعرون",
  },
  {
    verseId: 2,
    name: "الحجرات",
    surahId: 49,
    text: "إِنَّ ٱلَّذِينَ يَغُضُّونَ أَصۡوَٰتَهُمۡ عِندَ رَسُولِ ٱللَّهِ أُوْلَـٰٓئِكَ ٱلَّذِينَ ٱمۡتَحَنَ ٱللَّهُ قُلُوبَهُمۡ لِلتَّقۡوَىٰۚ لَهُم مَّغۡفِرَةٞ وَأَجۡرٌ عَظِيمٌ",
    translation:
      "Indeed, those who lower their voices before the Messenger of Allah - they are the ones whose hearts Allah has tested for righteousness. For them is forgiveness and great reward",
    normalizedText:
      "ان الذين يغضون اصوتهم عند رسول الله اولاك الذين امتحن الله قلوبهم للتقوى لهم مغفرة واجر عظيم",
  },
  {
    verseId: 3,
    name: "الحجرات",
    surahId: 49,
    text: "إِنَّ ٱلَّذِينَ يُنَادُونَكَ مِن وَرَآءِ ٱلۡحُجُرَٰتِ أَكۡثَرُهُمۡ لَا يَعۡقِلُونَ",
    translation:
      "Indeed, those who call you, [O Muhammad], from behind the chambers - most of them do not use reason",
    normalizedText: "ان الذين ينادونك من وراء الحجرت اكثرهم لا يعقلون",
  },
  {
    verseId: 4,
    name: "الحجرات",
    surahId: 49,
    text: "وَلَوۡ أَنَّهُمۡ صَبَرُواْ حَتَّىٰ تَخۡرُجَ إِلَيۡهِمۡ لَكَانَ خَيۡرٗا لَّهُمۡۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "And if they had been patient until you [could] come out to them, it would have been better for them. But Allah is Forgiving and Merciful",
    normalizedText:
      "ولو انهم صبروا حتى تخرج اليهم لكان خيرا لهم والله غفور رحيم",
  },
  {
    verseId: 5,
    name: "الحجرات",
    surahId: 49,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِن جَآءَكُمۡ فَاسِقُۢ بِنَبَإٖ فَتَبَيَّنُوٓاْ أَن تُصِيبُواْ قَوۡمَۢا بِجَهَٰلَةٖ فَتُصۡبِحُواْ عَلَىٰ مَا فَعَلۡتُمۡ نَٰدِمِينَ",
    translation:
      "O you who have believed, if there comes to you a disobedient one with information, investigate, lest you harm a people out of ignorance and become, over what you have done, regretful",
    normalizedText:
      "يايها الذين ءامنوا ان جاءكم فاسق بنبا فتبينوا ان تصيبوا قوما بجهلة فتصبحوا على ما فعلتم ندمين",
  },
  {
    verseId: 6,
    name: "الحجرات",
    surahId: 49,
    text: "وَٱعۡلَمُوٓاْ أَنَّ فِيكُمۡ رَسُولَ ٱللَّهِۚ لَوۡ يُطِيعُكُمۡ فِي كَثِيرٖ مِّنَ ٱلۡأَمۡرِ لَعَنِتُّمۡ وَلَٰكِنَّ ٱللَّهَ حَبَّبَ إِلَيۡكُمُ ٱلۡإِيمَٰنَ وَزَيَّنَهُۥ فِي قُلُوبِكُمۡ وَكَرَّهَ إِلَيۡكُمُ ٱلۡكُفۡرَ وَٱلۡفُسُوقَ وَٱلۡعِصۡيَانَۚ أُوْلَـٰٓئِكَ هُمُ ٱلرَّـٰشِدُونَ",
    translation:
      "And know that among you is the Messenger of Allah. If he were to obey you in much of the matter, you would be in difficulty, but Allah has endeared to you the faith and has made it pleasing in your hearts and has made hateful to you disbelief, defiance and disobedience. Those are the [rightly] guided",
    normalizedText:
      "واعلموا ان فيكم رسول الله لو يطيعكم في كثير من الامر لعنتم ولكن الله حبب اليكم الايمن وزينه في قلوبكم وكره اليكم الكفر والفسوق والعصيان اولاك هم الرشدون",
  },
  {
    verseId: 7,
    name: "الحجرات",
    surahId: 49,
    text: "فَضۡلٗا مِّنَ ٱللَّهِ وَنِعۡمَةٗۚ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "[It is] as bounty from Allah and favor. And Allah is Knowing and Wise",
    normalizedText: "فضلا من الله ونعمة والله عليم حكيم",
  },
  {
    verseId: 8,
    name: "الحجرات",
    surahId: 49,
    text: "وَإِن طَآئِفَتَانِ مِنَ ٱلۡمُؤۡمِنِينَ ٱقۡتَتَلُواْ فَأَصۡلِحُواْ بَيۡنَهُمَاۖ فَإِنۢ بَغَتۡ إِحۡدَىٰهُمَا عَلَى ٱلۡأُخۡرَىٰ فَقَٰتِلُواْ ٱلَّتِي تَبۡغِي حَتَّىٰ تَفِيٓءَ إِلَىٰٓ أَمۡرِ ٱللَّهِۚ فَإِن فَآءَتۡ فَأَصۡلِحُواْ بَيۡنَهُمَا بِٱلۡعَدۡلِ وَأَقۡسِطُوٓاْۖ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُقۡسِطِينَ",
    translation:
      "And if two factions among the believers should fight, then make settlement between the two. But if one of them oppresses the other, then fight against the one that oppresses until it returns to the ordinance of Allah. And if it returns, then make settlement between them in justice and act justly. Indeed, Allah loves those who act justly",
    normalizedText:
      "وان طاافتان من المامنين اقتتلوا فاصلحوا بينهما فان بغت احدىهما على الاخرى فقتلوا التي تبغي حتى تفيء الى امر الله فان فاءت فاصلحوا بينهما بالعدل واقسطوا ان الله يحب المقسطين",
  },
  {
    verseId: 9,
    name: "الحجرات",
    surahId: 49,
    text: "إِنَّمَا ٱلۡمُؤۡمِنُونَ إِخۡوَةٞ فَأَصۡلِحُواْ بَيۡنَ أَخَوَيۡكُمۡۚ وَٱتَّقُواْ ٱللَّهَ لَعَلَّكُمۡ تُرۡحَمُونَ",
    translation:
      "The believers are but brothers, so make settlement between your brothers. And fear Allah that you may receive mercy",
    normalizedText:
      "انما المامنون اخوة فاصلحوا بين اخويكم واتقوا الله لعلكم ترحمون",
  },
  {
    verseId: 10,
    name: "الحجرات",
    surahId: 49,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا يَسۡخَرۡ قَوۡمٞ مِّن قَوۡمٍ عَسَىٰٓ أَن يَكُونُواْ خَيۡرٗا مِّنۡهُمۡ وَلَا نِسَآءٞ مِّن نِّسَآءٍ عَسَىٰٓ أَن يَكُنَّ خَيۡرٗا مِّنۡهُنَّۖ وَلَا تَلۡمِزُوٓاْ أَنفُسَكُمۡ وَلَا تَنَابَزُواْ بِٱلۡأَلۡقَٰبِۖ بِئۡسَ ٱلِٱسۡمُ ٱلۡفُسُوقُ بَعۡدَ ٱلۡإِيمَٰنِۚ وَمَن لَّمۡ يَتُبۡ فَأُوْلَـٰٓئِكَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "O you who have believed, let not a people ridicule [another] people; perhaps they may be better than them; nor let women ridicule [other] women; perhaps they may be better than them. And do not insult one another and do not call each other by [offensive] nicknames. Wretched is the name of disobedience after [one's] faith. And whoever does not repent - then it is those who are the wrongdoers",
    normalizedText:
      "يايها الذين ءامنوا لا يسخر قوم من قوم عسى ان يكونوا خيرا منهم ولا نساء من نساء عسى ان يكن خيرا منهن ولا تلمزوا انفسكم ولا تنابزوا بالالقب باس الاسم الفسوق بعد الايمن ومن لم يتب فاولاك هم الظلمون",
  },
  {
    verseId: 11,
    name: "الحجرات",
    surahId: 49,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱجۡتَنِبُواْ كَثِيرٗا مِّنَ ٱلظَّنِّ إِنَّ بَعۡضَ ٱلظَّنِّ إِثۡمٞۖ وَلَا تَجَسَّسُواْ وَلَا يَغۡتَب بَّعۡضُكُم بَعۡضًاۚ أَيُحِبُّ أَحَدُكُمۡ أَن يَأۡكُلَ لَحۡمَ أَخِيهِ مَيۡتٗا فَكَرِهۡتُمُوهُۚ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ تَوَّابٞ رَّحِيمٞ",
    translation:
      "O you who have believed, avoid much [negative] assumption. Indeed, some assumption is sin. And do not spy or backbite each other. Would one of you like to eat the flesh of his brother when dead? You would detest it. And fear Allah; indeed, Allah is Accepting of repentance and Merciful",
    normalizedText:
      "يايها الذين ءامنوا اجتنبوا كثيرا من الظن ان بعض الظن اثم ولا تجسسوا ولا يغتب بعضكم بعضا ايحب احدكم ان ياكل لحم اخيه ميتا فكرهتموه واتقوا الله ان الله تواب رحيم",
  },
  {
    verseId: 12,
    name: "الحجرات",
    surahId: 49,
    text: "يَـٰٓأَيُّهَا ٱلنَّاسُ إِنَّا خَلَقۡنَٰكُم مِّن ذَكَرٖ وَأُنثَىٰ وَجَعَلۡنَٰكُمۡ شُعُوبٗا وَقَبَآئِلَ لِتَعَارَفُوٓاْۚ إِنَّ أَكۡرَمَكُمۡ عِندَ ٱللَّهِ أَتۡقَىٰكُمۡۚ إِنَّ ٱللَّهَ عَلِيمٌ خَبِيرٞ",
    translation:
      "O mankind, indeed We have created you from male and female and made you peoples and tribes that you may know one another. Indeed, the most noble of you in the sight of Allah is the most righteous of you. Indeed, Allah is Knowing and Acquainted",
    normalizedText:
      "يايها الناس انا خلقنكم من ذكر وانثى وجعلنكم شعوبا وقباال لتعارفوا ان اكرمكم عند الله اتقىكم ان الله عليم خبير",
  },
  {
    verseId: 13,
    name: "الحجرات",
    surahId: 49,
    text: "۞قَالَتِ ٱلۡأَعۡرَابُ ءَامَنَّاۖ قُل لَّمۡ تُؤۡمِنُواْ وَلَٰكِن قُولُوٓاْ أَسۡلَمۡنَا وَلَمَّا يَدۡخُلِ ٱلۡإِيمَٰنُ فِي قُلُوبِكُمۡۖ وَإِن تُطِيعُواْ ٱللَّهَ وَرَسُولَهُۥ لَا يَلِتۡكُم مِّنۡ أَعۡمَٰلِكُمۡ شَيۡـًٔاۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٌ",
    translation: `The bedouins say, "We have believed." Say, "You have not [yet] believed; but say [instead], 'We have submitted,' for faith has not yet entered your hearts. And if you obey Allah and His Messenger, He will not deprive you from your deeds of anything. Indeed, Allah is Forgiving and Merciful`,
    normalizedText:
      "۞قالت الاعراب ءامنا قل لم تامنوا ولكن قولوا اسلمنا ولما يدخل الايمن في قلوبكم وان تطيعوا الله ورسوله لا يلتكم من اعملكم شيا ان الله غفور رحيم",
  },
  {
    verseId: 14,
    name: "الحجرات",
    surahId: 49,
    text: "إِنَّمَا ٱلۡمُؤۡمِنُونَ ٱلَّذِينَ ءَامَنُواْ بِٱللَّهِ وَرَسُولِهِۦ ثُمَّ لَمۡ يَرۡتَابُواْ وَجَٰهَدُواْ بِأَمۡوَٰلِهِمۡ وَأَنفُسِهِمۡ فِي سَبِيلِ ٱللَّهِۚ أُوْلَـٰٓئِكَ هُمُ ٱلصَّـٰدِقُونَ",
    translation:
      "The believers are only the ones who have believed in Allah and His Messenger and then doubt not but strive with their properties and their lives in the cause of Allah. It is those who are the truthful",
    normalizedText:
      "انما المامنون الذين ءامنوا بالله ورسوله ثم لم يرتابوا وجهدوا بامولهم وانفسهم في سبيل الله اولاك هم الصدقون",
  },
  {
    verseId: 15,
    name: "الحجرات",
    surahId: 49,
    text: "قُلۡ أَتُعَلِّمُونَ ٱللَّهَ بِدِينِكُمۡ وَٱللَّهُ يَعۡلَمُ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۚ وَٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      'Say, "Would you acquaint Allah with your religion while Allah knows whatever is in the heavens and whatever is on the earth, and Allah is Knowing of all things',
    normalizedText:
      "قل اتعلمون الله بدينكم والله يعلم ما في السموت وما في الارض والله بكل شيء عليم",
  },
  {
    verseId: 16,
    name: "الحجرات",
    surahId: 49,
    text: "يَمُنُّونَ عَلَيۡكَ أَنۡ أَسۡلَمُواْۖ قُل لَّا تَمُنُّواْ عَلَيَّ إِسۡلَٰمَكُمۖ بَلِ ٱللَّهُ يَمُنُّ عَلَيۡكُمۡ أَنۡ هَدَىٰكُمۡ لِلۡإِيمَٰنِ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'They consider it a favor to you that they have accepted Islam. Say, "Do not consider your Islam a favor to me. Rather, Allah has conferred favor upon you that He has guided you to the faith, if you should be truthful',
    normalizedText:
      "يمنون عليك ان اسلموا قل لا تمنوا علي اسلمكم بل الله يمن عليكم ان هدىكم للايمن ان كنتم صدقين",
  },
  {
    verseId: 17,
    name: "الحجرات",
    surahId: 49,
    text: "إِنَّ ٱللَّهَ يَعۡلَمُ غَيۡبَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَٱللَّهُ بَصِيرُۢ بِمَا تَعۡمَلُونَ",
    translation:
      "Indeed, Allah knows the unseen [aspects] of the heavens and the earth. And Allah is Seeing of what you do",
    normalizedText: "ان الله يعلم غيب السموت والارض والله بصير بما تعملون",
  },
  {
    verseId: 0,
    name: "ق",
    surahId: 50,
    text: "قٓۚ وَٱلۡقُرۡءَانِ ٱلۡمَجِيدِ",
    translation: "Qaf. By the honored Qur'an",
    normalizedText: "ق والقرءان المجيد",
  },
  {
    verseId: 1,
    name: "ق",
    surahId: 50,
    text: "بَلۡ عَجِبُوٓاْ أَن جَآءَهُم مُّنذِرٞ مِّنۡهُمۡ فَقَالَ ٱلۡكَٰفِرُونَ هَٰذَا شَيۡءٌ عَجِيبٌ",
    translation:
      'But they wonder that there has come to them a warner from among themselves, and the disbelievers say, "This is an amazing thing',
    normalizedText: "بل عجبوا ان جاءهم منذر منهم فقال الكفرون هذا شيء عجيب",
  },
  {
    verseId: 2,
    name: "ق",
    surahId: 50,
    text: "أَءِذَا مِتۡنَا وَكُنَّا تُرَابٗاۖ ذَٰلِكَ رَجۡعُۢ بَعِيدٞ",
    translation:
      "When we have died and have become dust, [we will return to life]? That is a distant return",
    normalizedText: "اءذا متنا وكنا ترابا ذلك رجع بعيد",
  },
  {
    verseId: 3,
    name: "ق",
    surahId: 50,
    text: "قَدۡ عَلِمۡنَا مَا تَنقُصُ ٱلۡأَرۡضُ مِنۡهُمۡۖ وَعِندَنَا كِتَٰبٌ حَفِيظُۢ",
    translation:
      "We know what the earth diminishes of them, and with Us is a retaining record",
    normalizedText: "قد علمنا ما تنقص الارض منهم وعندنا كتب حفيظ",
  },
  {
    verseId: 4,
    name: "ق",
    surahId: 50,
    text: "بَلۡ كَذَّبُواْ بِٱلۡحَقِّ لَمَّا جَآءَهُمۡ فَهُمۡ فِيٓ أَمۡرٖ مَّرِيجٍ",
    translation:
      "But they denied the truth when it came to them, so they are in a confused condition",
    normalizedText: "بل كذبوا بالحق لما جاءهم فهم في امر مريج",
  },
  {
    verseId: 5,
    name: "ق",
    surahId: 50,
    text: "أَفَلَمۡ يَنظُرُوٓاْ إِلَى ٱلسَّمَآءِ فَوۡقَهُمۡ كَيۡفَ بَنَيۡنَٰهَا وَزَيَّنَّـٰهَا وَمَا لَهَا مِن فُرُوجٖ",
    translation:
      "Have they not looked at the heaven above them - how We structured it and adorned it and [how] it has no rifts",
    normalizedText:
      "افلم ينظروا الى السماء فوقهم كيف بنينها وزينها وما لها من فروج",
  },
  {
    verseId: 6,
    name: "ق",
    surahId: 50,
    text: "وَٱلۡأَرۡضَ مَدَدۡنَٰهَا وَأَلۡقَيۡنَا فِيهَا رَوَٰسِيَ وَأَنۢبَتۡنَا فِيهَا مِن كُلِّ زَوۡجِۭ بَهِيجٖ",
    translation:
      "And the earth - We spread it out and cast therein firmly set mountains and made grow therein [something] of every beautiful kind",
    normalizedText:
      "والارض مددنها والقينا فيها روسي وانبتنا فيها من كل زوج بهيج",
  },
  {
    verseId: 7,
    name: "ق",
    surahId: 50,
    text: "تَبۡصِرَةٗ وَذِكۡرَىٰ لِكُلِّ عَبۡدٖ مُّنِيبٖ",
    translation:
      "Giving insight and a reminder for every servant who turns [to Allah]",
    normalizedText: "تبصرة وذكرى لكل عبد منيب",
  },
  {
    verseId: 8,
    name: "ق",
    surahId: 50,
    text: "وَنَزَّلۡنَا مِنَ ٱلسَّمَآءِ مَآءٗ مُّبَٰرَكٗا فَأَنۢبَتۡنَا بِهِۦ جَنَّـٰتٖ وَحَبَّ ٱلۡحَصِيدِ",
    translation:
      "And We have sent down blessed rain from the sky and made grow thereby gardens and grain from the harvest",
    normalizedText: "ونزلنا من السماء ماء مبركا فانبتنا به جنت وحب الحصيد",
  },
  {
    verseId: 9,
    name: "ق",
    surahId: 50,
    text: "وَٱلنَّخۡلَ بَاسِقَٰتٖ لَّهَا طَلۡعٞ نَّضِيدٞ",
    translation: "And lofty palm trees having fruit arranged in layers",
    normalizedText: "والنخل باسقت لها طلع نضيد",
  },
  {
    verseId: 10,
    name: "ق",
    surahId: 50,
    text: "رِّزۡقٗا لِّلۡعِبَادِۖ وَأَحۡيَيۡنَا بِهِۦ بَلۡدَةٗ مَّيۡتٗاۚ كَذَٰلِكَ ٱلۡخُرُوجُ",
    translation:
      "As provision for the servants, and We have given life thereby to a dead land. Thus is the resurrection",
    normalizedText: "رزقا للعباد واحيينا به بلدة ميتا كذلك الخروج",
  },
  {
    verseId: 11,
    name: "ق",
    surahId: 50,
    text: "كَذَّبَتۡ قَبۡلَهُمۡ قَوۡمُ نُوحٖ وَأَصۡحَٰبُ ٱلرَّسِّ وَثَمُودُ",
    translation:
      "The people of Noah denied before them, and the companions of the well and Thamud",
    normalizedText: "كذبت قبلهم قوم نوح واصحب الرس وثمود",
  },
  {
    verseId: 12,
    name: "ق",
    surahId: 50,
    text: "وَعَادٞ وَفِرۡعَوۡنُ وَإِخۡوَٰنُ لُوطٖ",
    translation: "And 'Aad and Pharaoh and the brothers of Lot",
    normalizedText: "وعاد وفرعون واخون لوط",
  },
  {
    verseId: 13,
    name: "ق",
    surahId: 50,
    text: "وَأَصۡحَٰبُ ٱلۡأَيۡكَةِ وَقَوۡمُ تُبَّعٖۚ كُلّٞ كَذَّبَ ٱلرُّسُلَ فَحَقَّ وَعِيدِ",
    translation:
      "And the companions of the thicket and the people of Tubba'. All denied the messengers, so My threat was justly fulfilled",
    normalizedText: "واصحب الايكة وقوم تبع كل كذب الرسل فحق وعيد",
  },
  {
    verseId: 14,
    name: "ق",
    surahId: 50,
    text: "أَفَعَيِينَا بِٱلۡخَلۡقِ ٱلۡأَوَّلِۚ بَلۡ هُمۡ فِي لَبۡسٖ مِّنۡ خَلۡقٖ جَدِيدٖ",
    translation:
      "Did We fail in the first creation? But they are in confusion over a new creation",
    normalizedText: "افعيينا بالخلق الاول بل هم في لبس من خلق جديد",
  },
  {
    verseId: 15,
    name: "ق",
    surahId: 50,
    text: "وَلَقَدۡ خَلَقۡنَا ٱلۡإِنسَٰنَ وَنَعۡلَمُ مَا تُوَسۡوِسُ بِهِۦ نَفۡسُهُۥۖ وَنَحۡنُ أَقۡرَبُ إِلَيۡهِ مِنۡ حَبۡلِ ٱلۡوَرِيدِ",
    translation:
      "And We have already created man and know what his soul whispers to him, and We are closer to him than [his] jugular vein",
    normalizedText:
      "ولقد خلقنا الانسن ونعلم ما توسوس به نفسه ونحن اقرب اليه من حبل الوريد",
  },
  {
    verseId: 16,
    name: "ق",
    surahId: 50,
    text: "إِذۡ يَتَلَقَّى ٱلۡمُتَلَقِّيَانِ عَنِ ٱلۡيَمِينِ وَعَنِ ٱلشِّمَالِ قَعِيدٞ",
    translation:
      "When the two receivers receive, seated on the right and on the left",
    normalizedText: "اذ يتلقى المتلقيان عن اليمين وعن الشمال قعيد",
  },
  {
    verseId: 17,
    name: "ق",
    surahId: 50,
    text: "مَّا يَلۡفِظُ مِن قَوۡلٍ إِلَّا لَدَيۡهِ رَقِيبٌ عَتِيدٞ",
    translation:
      "Man does not utter any word except that with him is an observer prepared [to record]",
    normalizedText: "ما يلفظ من قول الا لديه رقيب عتيد",
  },
  {
    verseId: 18,
    name: "ق",
    surahId: 50,
    text: "وَجَآءَتۡ سَكۡرَةُ ٱلۡمَوۡتِ بِٱلۡحَقِّۖ ذَٰلِكَ مَا كُنتَ مِنۡهُ تَحِيدُ",
    translation:
      "And the intoxication of death will bring the truth; that is what you were trying to avoid",
    normalizedText: "وجاءت سكرة الموت بالحق ذلك ما كنت منه تحيد",
  },
  {
    verseId: 19,
    name: "ق",
    surahId: 50,
    text: "وَنُفِخَ فِي ٱلصُّورِۚ ذَٰلِكَ يَوۡمُ ٱلۡوَعِيدِ",
    translation:
      "And the Horn will be blown. That is the Day of [carrying out] the threat",
    normalizedText: "ونفخ في الصور ذلك يوم الوعيد",
  },
  {
    verseId: 20,
    name: "ق",
    surahId: 50,
    text: "وَجَآءَتۡ كُلُّ نَفۡسٖ مَّعَهَا سَآئِقٞ وَشَهِيدٞ",
    translation: "And every soul will come, with it a driver and a witness",
    normalizedText: "وجاءت كل نفس معها سااق وشهيد",
  },
  {
    verseId: 21,
    name: "ق",
    surahId: 50,
    text: "لَّقَدۡ كُنتَ فِي غَفۡلَةٖ مِّنۡ هَٰذَا فَكَشَفۡنَا عَنكَ غِطَآءَكَ فَبَصَرُكَ ٱلۡيَوۡمَ حَدِيدٞ",
    translation:
      '[It will be said], "You were certainly in unmindfulness of this, and We have removed from you your cover, so your sight, this Day, is sharp',
    normalizedText: "لقد كنت في غفلة من هذا فكشفنا عنك غطاءك فبصرك اليوم حديد",
  },
  {
    verseId: 22,
    name: "ق",
    surahId: 50,
    text: "وَقَالَ قَرِينُهُۥ هَٰذَا مَا لَدَيَّ عَتِيدٌ",
    translation:
      'And his companion, [the angel], will say, "This [record] is what is with me, prepared',
    normalizedText: "وقال قرينه هذا ما لدي عتيد",
  },
  {
    verseId: 23,
    name: "ق",
    surahId: 50,
    text: "أَلۡقِيَا فِي جَهَنَّمَ كُلَّ كَفَّارٍ عَنِيدٖ",
    translation:
      '[Allah will say], "Throw into Hell every obstinate disbeliever',
    normalizedText: "القيا في جهنم كل كفار عنيد",
  },
  {
    verseId: 24,
    name: "ق",
    surahId: 50,
    text: "مَّنَّاعٖ لِّلۡخَيۡرِ مُعۡتَدٖ مُّرِيبٍ",
    translation: "Preventer of good, aggressor, and doubter",
    normalizedText: "مناع للخير معتد مريب",
  },
  {
    verseId: 25,
    name: "ق",
    surahId: 50,
    text: "ٱلَّذِي جَعَلَ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَأَلۡقِيَاهُ فِي ٱلۡعَذَابِ ٱلشَّدِيدِ",
    translation:
      "Who made [as equal] with Allah another deity; then throw him into the severe punishment",
    normalizedText: "الذي جعل مع الله الها ءاخر فالقياه في العذاب الشديد",
  },
  {
    verseId: 26,
    name: "ق",
    surahId: 50,
    text: "۞قَالَ قَرِينُهُۥ رَبَّنَا مَآ أَطۡغَيۡتُهُۥ وَلَٰكِن كَانَ فِي ضَلَٰلِۭ بَعِيدٖ",
    translation:
      'His [devil] companion will say, "Our Lord, I did not make him transgress, but he [himself] was in extreme error',
    normalizedText: "۞قال قرينه ربنا ما اطغيته ولكن كان في ضلل بعيد",
  },
  {
    verseId: 27,
    name: "ق",
    surahId: 50,
    text: "قَالَ لَا تَخۡتَصِمُواْ لَدَيَّ وَقَدۡ قَدَّمۡتُ إِلَيۡكُم بِٱلۡوَعِيدِ",
    translation:
      '[Allah] will say, "Do not dispute before Me, while I had already presented to you the warning',
    normalizedText: "قال لا تختصموا لدي وقد قدمت اليكم بالوعيد",
  },
  {
    verseId: 28,
    name: "ق",
    surahId: 50,
    text: "مَا يُبَدَّلُ ٱلۡقَوۡلُ لَدَيَّ وَمَآ أَنَا۠ بِظَلَّـٰمٖ لِّلۡعَبِيدِ",
    translation:
      "The word will not be changed with Me, and never will I be unjust to the servants",
    normalizedText: "ما يبدل القول لدي وما انا بظلم للعبيد",
  },
  {
    verseId: 29,
    name: "ق",
    surahId: 50,
    text: "يَوۡمَ نَقُولُ لِجَهَنَّمَ هَلِ ٱمۡتَلَأۡتِ وَتَقُولُ هَلۡ مِن مَّزِيدٖ",
    translation:
      'On the Day We will say to Hell, "Have you been filled?" and it will say, "Are there some more',
    normalizedText: "يوم نقول لجهنم هل امتلات وتقول هل من مزيد",
  },
  {
    verseId: 30,
    name: "ق",
    surahId: 50,
    text: "وَأُزۡلِفَتِ ٱلۡجَنَّةُ لِلۡمُتَّقِينَ غَيۡرَ بَعِيدٍ",
    translation: "And Paradise will be brought near to the righteous, not far",
    normalizedText: "وازلفت الجنة للمتقين غير بعيد",
  },
  {
    verseId: 31,
    name: "ق",
    surahId: 50,
    text: "هَٰذَا مَا تُوعَدُونَ لِكُلِّ أَوَّابٍ حَفِيظٖ",
    translation:
      '[It will be said], "This is what you were promised - for every returner [to Allah] and keeper [of His covenant]',
    normalizedText: "هذا ما توعدون لكل اواب حفيظ",
  },
  {
    verseId: 32,
    name: "ق",
    surahId: 50,
    text: "مَّنۡ خَشِيَ ٱلرَّحۡمَٰنَ بِٱلۡغَيۡبِ وَجَآءَ بِقَلۡبٖ مُّنِيبٍ",
    translation:
      "Who feared the Most Merciful unseen and came with a heart returning [in repentance]",
    normalizedText: "من خشي الرحمن بالغيب وجاء بقلب منيب",
  },
  {
    verseId: 33,
    name: "ق",
    surahId: 50,
    text: "ٱدۡخُلُوهَا بِسَلَٰمٖۖ ذَٰلِكَ يَوۡمُ ٱلۡخُلُودِ",
    translation: "Enter it in peace. This is the Day of Eternity",
    normalizedText: "ادخلوها بسلم ذلك يوم الخلود",
  },
  {
    verseId: 34,
    name: "ق",
    surahId: 50,
    text: "لَهُم مَّا يَشَآءُونَ فِيهَا وَلَدَيۡنَا مَزِيدٞ",
    translation:
      "They will have whatever they wish therein, and with Us is more",
    normalizedText: "لهم ما يشاءون فيها ولدينا مزيد",
  },
  {
    verseId: 35,
    name: "ق",
    surahId: 50,
    text: "وَكَمۡ أَهۡلَكۡنَا قَبۡلَهُم مِّن قَرۡنٍ هُمۡ أَشَدُّ مِنۡهُم بَطۡشٗا فَنَقَّبُواْ فِي ٱلۡبِلَٰدِ هَلۡ مِن مَّحِيصٍ",
    translation:
      "And how many a generation before them did We destroy who were greater than them in [striking] power and had explored throughout the lands. Is there any place of escape",
    normalizedText:
      "وكم اهلكنا قبلهم من قرن هم اشد منهم بطشا فنقبوا في البلد هل من محيص",
  },
  {
    verseId: 36,
    name: "ق",
    surahId: 50,
    text: "إِنَّ فِي ذَٰلِكَ لَذِكۡرَىٰ لِمَن كَانَ لَهُۥ قَلۡبٌ أَوۡ أَلۡقَى ٱلسَّمۡعَ وَهُوَ شَهِيدٞ",
    translation:
      "Indeed in that is a reminder for whoever has a heart or who listens while he is present [in mind]",
    normalizedText: "ان في ذلك لذكرى لمن كان له قلب او القى السمع وهو شهيد",
  },
  {
    verseId: 37,
    name: "ق",
    surahId: 50,
    text: "وَلَقَدۡ خَلَقۡنَا ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ وَمَا بَيۡنَهُمَا فِي سِتَّةِ أَيَّامٖ وَمَا مَسَّنَا مِن لُّغُوبٖ",
    translation:
      "And We did certainly create the heavens and earth and what is between them in six days, and there touched Us no weariness",
    normalizedText:
      "ولقد خلقنا السموت والارض وما بينهما في ستة ايام وما مسنا من لغوب",
  },
  {
    verseId: 38,
    name: "ق",
    surahId: 50,
    text: "فَٱصۡبِرۡ عَلَىٰ مَا يَقُولُونَ وَسَبِّحۡ بِحَمۡدِ رَبِّكَ قَبۡلَ طُلُوعِ ٱلشَّمۡسِ وَقَبۡلَ ٱلۡغُرُوبِ",
    translation:
      "So be patient, [O Muhammad], over what they say and exalt [Allah] with praise of your Lord before the rising of the sun and before its setting",
    normalizedText:
      "فاصبر على ما يقولون وسبح بحمد ربك قبل طلوع الشمس وقبل الغروب",
  },
  {
    verseId: 39,
    name: "ق",
    surahId: 50,
    text: "وَمِنَ ٱلَّيۡلِ فَسَبِّحۡهُ وَأَدۡبَٰرَ ٱلسُّجُودِ",
    translation: "And [in part] of the night exalt Him and after prostration",
    normalizedText: "ومن اليل فسبحه وادبر السجود",
  },
  {
    verseId: 40,
    name: "ق",
    surahId: 50,
    text: "وَٱسۡتَمِعۡ يَوۡمَ يُنَادِ ٱلۡمُنَادِ مِن مَّكَانٖ قَرِيبٖ",
    translation:
      "And listen on the Day when the Caller will call out from a place that is near",
    normalizedText: "واستمع يوم يناد المناد من مكان قريب",
  },
  {
    verseId: 41,
    name: "ق",
    surahId: 50,
    text: "يَوۡمَ يَسۡمَعُونَ ٱلصَّيۡحَةَ بِٱلۡحَقِّۚ ذَٰلِكَ يَوۡمُ ٱلۡخُرُوجِ",
    translation:
      "The Day they will hear the blast [of the Horn] in truth. That is the Day of Emergence [from the graves]",
    normalizedText: "يوم يسمعون الصيحة بالحق ذلك يوم الخروج",
  },
  {
    verseId: 42,
    name: "ق",
    surahId: 50,
    text: "إِنَّا نَحۡنُ نُحۡيِۦ وَنُمِيتُ وَإِلَيۡنَا ٱلۡمَصِيرُ",
    translation:
      "Indeed, it is We who give life and cause death, and to Us is the destination",
    normalizedText: "انا نحن نحي ونميت والينا المصير",
  },
  {
    verseId: 43,
    name: "ق",
    surahId: 50,
    text: "يَوۡمَ تَشَقَّقُ ٱلۡأَرۡضُ عَنۡهُمۡ سِرَاعٗاۚ ذَٰلِكَ حَشۡرٌ عَلَيۡنَا يَسِيرٞ",
    translation:
      "On the Day the earth breaks away from them [and they emerge] rapidly; that is a gathering easy for Us",
    normalizedText: "يوم تشقق الارض عنهم سراعا ذلك حشر علينا يسير",
  },
  {
    verseId: 44,
    name: "ق",
    surahId: 50,
    text: "نَّحۡنُ أَعۡلَمُ بِمَا يَقُولُونَۖ وَمَآ أَنتَ عَلَيۡهِم بِجَبَّارٖۖ فَذَكِّرۡ بِٱلۡقُرۡءَانِ مَن يَخَافُ وَعِيدِ",
    translation:
      "We are most knowing of what they say, and you are not over them a tyrant. But remind by the Qur'an whoever fears My threat",
    normalizedText:
      "نحن اعلم بما يقولون وما انت عليهم بجبار فذكر بالقرءان من يخاف وعيد",
  },
  {
    verseId: 0,
    name: "الذاريات",
    surahId: 51,
    text: "وَٱلذَّـٰرِيَٰتِ ذَرۡوٗا",
    translation: "By those [winds] scattering [dust] dispersing",
    normalizedText: "والذريت ذروا",
  },
  {
    verseId: 1,
    name: "الذاريات",
    surahId: 51,
    text: "فَٱلۡحَٰمِلَٰتِ وِقۡرٗا",
    translation: "And those [clouds] carrying a load [of water]",
    normalizedText: "فالحملت وقرا",
  },
  {
    verseId: 2,
    name: "الذاريات",
    surahId: 51,
    text: "فَٱلۡجَٰرِيَٰتِ يُسۡرٗا",
    translation: "And those [ships] sailing with ease",
    normalizedText: "فالجريت يسرا",
  },
  {
    verseId: 3,
    name: "الذاريات",
    surahId: 51,
    text: "فَٱلۡمُقَسِّمَٰتِ أَمۡرًا",
    translation: "And those [angels] apportioning [each] matter",
    normalizedText: "فالمقسمت امرا",
  },
  {
    verseId: 4,
    name: "الذاريات",
    surahId: 51,
    text: "إِنَّمَا تُوعَدُونَ لَصَادِقٞ",
    translation: "Indeed, what you are promised is true",
    normalizedText: "انما توعدون لصادق",
  },
  {
    verseId: 5,
    name: "الذاريات",
    surahId: 51,
    text: "وَإِنَّ ٱلدِّينَ لَوَٰقِعٞ",
    translation: "And indeed, the recompense is to occur",
    normalizedText: "وان الدين لوقع",
  },
  {
    verseId: 6,
    name: "الذاريات",
    surahId: 51,
    text: "وَٱلسَّمَآءِ ذَاتِ ٱلۡحُبُكِ",
    translation: "By the heaven containing pathways",
    normalizedText: "والسماء ذات الحبك",
  },
  {
    verseId: 7,
    name: "الذاريات",
    surahId: 51,
    text: "إِنَّكُمۡ لَفِي قَوۡلٖ مُّخۡتَلِفٖ",
    translation: "Indeed, you are in differing speech",
    normalizedText: "انكم لفي قول مختلف",
  },
  {
    verseId: 8,
    name: "الذاريات",
    surahId: 51,
    text: "يُؤۡفَكُ عَنۡهُ مَنۡ أُفِكَ",
    translation: "Deluded away from the Qur'an is he who is deluded",
    normalizedText: "يافك عنه من افك",
  },
  {
    verseId: 9,
    name: "الذاريات",
    surahId: 51,
    text: "قُتِلَ ٱلۡخَرَّـٰصُونَ",
    translation: "Destroyed are the falsifiers",
    normalizedText: "قتل الخرصون",
  },
  {
    verseId: 10,
    name: "الذاريات",
    surahId: 51,
    text: "ٱلَّذِينَ هُمۡ فِي غَمۡرَةٖ سَاهُونَ",
    translation: "Who are within a flood [of confusion] and heedless",
    normalizedText: "الذين هم في غمرة ساهون",
  },
  {
    verseId: 11,
    name: "الذاريات",
    surahId: 51,
    text: "يَسۡـَٔلُونَ أَيَّانَ يَوۡمُ ٱلدِّينِ",
    translation: 'They ask, "When is the Day of Recompense',
    normalizedText: "يسلون ايان يوم الدين",
  },
  {
    verseId: 12,
    name: "الذاريات",
    surahId: 51,
    text: "يَوۡمَ هُمۡ عَلَى ٱلنَّارِ يُفۡتَنُونَ",
    translation: "[It is] the Day they will be tormented over the Fire",
    normalizedText: "يوم هم على النار يفتنون",
  },
  {
    verseId: 13,
    name: "الذاريات",
    surahId: 51,
    text: "ذُوقُواْ فِتۡنَتَكُمۡ هَٰذَا ٱلَّذِي كُنتُم بِهِۦ تَسۡتَعۡجِلُونَ",
    translation:
      '[And will be told], "Taste your torment. This is that for which you were impatient',
    normalizedText: "ذوقوا فتنتكم هذا الذي كنتم به تستعجلون",
  },
  {
    verseId: 14,
    name: "الذاريات",
    surahId: 51,
    text: "إِنَّ ٱلۡمُتَّقِينَ فِي جَنَّـٰتٖ وَعُيُونٍ",
    translation: "Indeed, the righteous will be among gardens and springs",
    normalizedText: "ان المتقين في جنت وعيون",
  },
  {
    verseId: 15,
    name: "الذاريات",
    surahId: 51,
    text: "ءَاخِذِينَ مَآ ءَاتَىٰهُمۡ رَبُّهُمۡۚ إِنَّهُمۡ كَانُواْ قَبۡلَ ذَٰلِكَ مُحۡسِنِينَ",
    translation:
      "Accepting what their Lord has given them. Indeed, they were before that doers of good",
    normalizedText: "ءاخذين ما ءاتىهم ربهم انهم كانوا قبل ذلك محسنين",
  },
  {
    verseId: 16,
    name: "الذاريات",
    surahId: 51,
    text: "كَانُواْ قَلِيلٗا مِّنَ ٱلَّيۡلِ مَا يَهۡجَعُونَ",
    translation: "They used to sleep but little of the night",
    normalizedText: "كانوا قليلا من اليل ما يهجعون",
  },
  {
    verseId: 17,
    name: "الذاريات",
    surahId: 51,
    text: "وَبِٱلۡأَسۡحَارِ هُمۡ يَسۡتَغۡفِرُونَ",
    translation: "And in the hours before dawn they would ask forgiveness",
    normalizedText: "وبالاسحار هم يستغفرون",
  },
  {
    verseId: 18,
    name: "الذاريات",
    surahId: 51,
    text: "وَفِيٓ أَمۡوَٰلِهِمۡ حَقّٞ لِّلسَّآئِلِ وَٱلۡمَحۡرُومِ",
    translation:
      "And from their properties was [given] the right of the [needy] petitioner and the deprived",
    normalizedText: "وفي امولهم حق للساال والمحروم",
  },
  {
    verseId: 19,
    name: "الذاريات",
    surahId: 51,
    text: "وَفِي ٱلۡأَرۡضِ ءَايَٰتٞ لِّلۡمُوقِنِينَ",
    translation: "And on the earth are signs for the certain [in faith]",
    normalizedText: "وفي الارض ءايت للموقنين",
  },
  {
    verseId: 20,
    name: "الذاريات",
    surahId: 51,
    text: "وَفِيٓ أَنفُسِكُمۡۚ أَفَلَا تُبۡصِرُونَ",
    translation: "And in yourselves. Then will you not see",
    normalizedText: "وفي انفسكم افلا تبصرون",
  },
  {
    verseId: 21,
    name: "الذاريات",
    surahId: 51,
    text: "وَفِي ٱلسَّمَآءِ رِزۡقُكُمۡ وَمَا تُوعَدُونَ",
    translation:
      "And in the heaven is your provision and whatever you are promised",
    normalizedText: "وفي السماء رزقكم وما توعدون",
  },
  {
    verseId: 22,
    name: "الذاريات",
    surahId: 51,
    text: "فَوَرَبِّ ٱلسَّمَآءِ وَٱلۡأَرۡضِ إِنَّهُۥ لَحَقّٞ مِّثۡلَ مَآ أَنَّكُمۡ تَنطِقُونَ",
    translation:
      "Then by the Lord of the heaven and earth, indeed, it is truth - just as [sure as] it is that you are speaking",
    normalizedText: "فورب السماء والارض انه لحق مثل ما انكم تنطقون",
  },
  {
    verseId: 23,
    name: "الذاريات",
    surahId: 51,
    text: "هَلۡ أَتَىٰكَ حَدِيثُ ضَيۡفِ إِبۡرَٰهِيمَ ٱلۡمُكۡرَمِينَ",
    translation:
      "Has there reached you the story of the honored guests of Abraham",
    normalizedText: "هل اتىك حديث ضيف ابرهيم المكرمين",
  },
  {
    verseId: 24,
    name: "الذاريات",
    surahId: 51,
    text: "إِذۡ دَخَلُواْ عَلَيۡهِ فَقَالُواْ سَلَٰمٗاۖ قَالَ سَلَٰمٞ قَوۡمٞ مُّنكَرُونَ",
    translation:
      'When they entered upon him and said, "[We greet you with] peace." He answered, "[And upon you] peace, [you are] a people unknown',
    normalizedText: "اذ دخلوا عليه فقالوا سلما قال سلم قوم منكرون",
  },
  {
    verseId: 25,
    name: "الذاريات",
    surahId: 51,
    text: "فَرَاغَ إِلَىٰٓ أَهۡلِهِۦ فَجَآءَ بِعِجۡلٖ سَمِينٖ",
    translation:
      "Then he went to his family and came with a fat [roasted] calf",
    normalizedText: "فراغ الى اهله فجاء بعجل سمين",
  },
  {
    verseId: 26,
    name: "الذاريات",
    surahId: 51,
    text: "فَقَرَّبَهُۥٓ إِلَيۡهِمۡ قَالَ أَلَا تَأۡكُلُونَ",
    translation: 'And placed it near them; he said, "Will you not eat',
    normalizedText: "فقربه اليهم قال الا تاكلون",
  },
  {
    verseId: 27,
    name: "الذاريات",
    surahId: 51,
    text: "فَأَوۡجَسَ مِنۡهُمۡ خِيفَةٗۖ قَالُواْ لَا تَخَفۡۖ وَبَشَّرُوهُ بِغُلَٰمٍ عَلِيمٖ",
    translation:
      'And he felt from them apprehension. They said, "Fear not," and gave him good tidings of a learned boy',
    normalizedText: "فاوجس منهم خيفة قالوا لا تخف وبشروه بغلم عليم",
  },
  {
    verseId: 28,
    name: "الذاريات",
    surahId: 51,
    text: "فَأَقۡبَلَتِ ٱمۡرَأَتُهُۥ فِي صَرَّةٖ فَصَكَّتۡ وَجۡهَهَا وَقَالَتۡ عَجُوزٌ عَقِيمٞ",
    translation:
      'And his wife approached with a cry [of alarm] and struck her face and said, "[I am] a barren old woman',
    normalizedText: "فاقبلت امراته في صرة فصكت وجهها وقالت عجوز عقيم",
  },
  {
    verseId: 29,
    name: "الذاريات",
    surahId: 51,
    text: "قَالُواْ كَذَٰلِكِ قَالَ رَبُّكِۖ إِنَّهُۥ هُوَ ٱلۡحَكِيمُ ٱلۡعَلِيمُ",
    translation:
      'They said, "Thus has said your Lord; indeed, He is the Wise, the Knowing',
    normalizedText: "قالوا كذلك قال ربك انه هو الحكيم العليم",
  },
  {
    verseId: 30,
    name: "الذاريات",
    surahId: 51,
    text: "۞قَالَ فَمَا خَطۡبُكُمۡ أَيُّهَا ٱلۡمُرۡسَلُونَ",
    translation:
      '[Abraham] said, "Then what is your business [here], O messengers',
    normalizedText: "۞قال فما خطبكم ايها المرسلون",
  },
  {
    verseId: 31,
    name: "الذاريات",
    surahId: 51,
    text: "قَالُوٓاْ إِنَّآ أُرۡسِلۡنَآ إِلَىٰ قَوۡمٖ مُّجۡرِمِينَ",
    translation:
      'They said, "Indeed, we have been sent to a people of criminals',
    normalizedText: "قالوا انا ارسلنا الى قوم مجرمين",
  },
  {
    verseId: 32,
    name: "الذاريات",
    surahId: 51,
    text: "لِنُرۡسِلَ عَلَيۡهِمۡ حِجَارَةٗ مِّن طِينٖ",
    translation: "To send down upon them stones of clay",
    normalizedText: "لنرسل عليهم حجارة من طين",
  },
  {
    verseId: 33,
    name: "الذاريات",
    surahId: 51,
    text: "مُّسَوَّمَةً عِندَ رَبِّكَ لِلۡمُسۡرِفِينَ",
    translation: "Marked in the presence of your Lord for the transgressors",
    normalizedText: "مسومة عند ربك للمسرفين",
  },
  {
    verseId: 34,
    name: "الذاريات",
    surahId: 51,
    text: "فَأَخۡرَجۡنَا مَن كَانَ فِيهَا مِنَ ٱلۡمُؤۡمِنِينَ",
    translation: "So We brought out whoever was in the cities of the believers",
    normalizedText: "فاخرجنا من كان فيها من المامنين",
  },
  {
    verseId: 35,
    name: "الذاريات",
    surahId: 51,
    text: "فَمَا وَجَدۡنَا فِيهَا غَيۡرَ بَيۡتٖ مِّنَ ٱلۡمُسۡلِمِينَ",
    translation:
      "And We found not within them other than a [single] house of Muslims",
    normalizedText: "فما وجدنا فيها غير بيت من المسلمين",
  },
  {
    verseId: 36,
    name: "الذاريات",
    surahId: 51,
    text: "وَتَرَكۡنَا فِيهَآ ءَايَةٗ لِّلَّذِينَ يَخَافُونَ ٱلۡعَذَابَ ٱلۡأَلِيمَ",
    translation:
      "And We left therein a sign for those who fear the painful punishment",
    normalizedText: "وتركنا فيها ءاية للذين يخافون العذاب الاليم",
  },
  {
    verseId: 37,
    name: "الذاريات",
    surahId: 51,
    text: "وَفِي مُوسَىٰٓ إِذۡ أَرۡسَلۡنَٰهُ إِلَىٰ فِرۡعَوۡنَ بِسُلۡطَٰنٖ مُّبِينٖ",
    translation:
      "And in Moses [was a sign], when We sent him to Pharaoh with clear authority",
    normalizedText: "وفي موسى اذ ارسلنه الى فرعون بسلطن مبين",
  },
  {
    verseId: 38,
    name: "الذاريات",
    surahId: 51,
    text: "فَتَوَلَّىٰ بِرُكۡنِهِۦ وَقَالَ سَٰحِرٌ أَوۡ مَجۡنُونٞ",
    translation:
      'But he turned away with his supporters and said," A magician or a madman',
    normalizedText: "فتولى بركنه وقال سحر او مجنون",
  },
  {
    verseId: 39,
    name: "الذاريات",
    surahId: 51,
    text: "فَأَخَذۡنَٰهُ وَجُنُودَهُۥ فَنَبَذۡنَٰهُمۡ فِي ٱلۡيَمِّ وَهُوَ مُلِيمٞ",
    translation:
      "So We took him and his soldiers and cast them into the sea, and he was blameworthy",
    normalizedText: "فاخذنه وجنوده فنبذنهم في اليم وهو مليم",
  },
  {
    verseId: 40,
    name: "الذاريات",
    surahId: 51,
    text: "وَفِي عَادٍ إِذۡ أَرۡسَلۡنَا عَلَيۡهِمُ ٱلرِّيحَ ٱلۡعَقِيمَ",
    translation:
      "And in 'Aad [was a sign], when We sent against them the barren wind",
    normalizedText: "وفي عاد اذ ارسلنا عليهم الريح العقيم",
  },
  {
    verseId: 41,
    name: "الذاريات",
    surahId: 51,
    text: "مَا تَذَرُ مِن شَيۡءٍ أَتَتۡ عَلَيۡهِ إِلَّا جَعَلَتۡهُ كَٱلرَّمِيمِ",
    translation:
      "It left nothing of what it came upon but that it made it like disintegrated ruins",
    normalizedText: "ما تذر من شيء اتت عليه الا جعلته كالرميم",
  },
  {
    verseId: 42,
    name: "الذاريات",
    surahId: 51,
    text: "وَفِي ثَمُودَ إِذۡ قِيلَ لَهُمۡ تَمَتَّعُواْ حَتَّىٰ حِينٖ",
    translation:
      'And in Thamud, when it was said to them, "Enjoy yourselves for a time',
    normalizedText: "وفي ثمود اذ قيل لهم تمتعوا حتى حين",
  },
  {
    verseId: 43,
    name: "الذاريات",
    surahId: 51,
    text: "فَعَتَوۡاْ عَنۡ أَمۡرِ رَبِّهِمۡ فَأَخَذَتۡهُمُ ٱلصَّـٰعِقَةُ وَهُمۡ يَنظُرُونَ",
    translation:
      "But they were insolent toward the command of their Lord, so the thunderbolt seized them while they were looking on",
    normalizedText: "فعتوا عن امر ربهم فاخذتهم الصعقة وهم ينظرون",
  },
  {
    verseId: 44,
    name: "الذاريات",
    surahId: 51,
    text: "فَمَا ٱسۡتَطَٰعُواْ مِن قِيَامٖ وَمَا كَانُواْ مُنتَصِرِينَ",
    translation:
      "And they were unable to arise, nor could they defend themselves",
    normalizedText: "فما استطعوا من قيام وما كانوا منتصرين",
  },
  {
    verseId: 45,
    name: "الذاريات",
    surahId: 51,
    text: "وَقَوۡمَ نُوحٖ مِّن قَبۡلُۖ إِنَّهُمۡ كَانُواْ قَوۡمٗا فَٰسِقِينَ",
    translation:
      "And [We destroyed] the people of Noah before; indeed, they were a people defiantly disobedient",
    normalizedText: "وقوم نوح من قبل انهم كانوا قوما فسقين",
  },
  {
    verseId: 46,
    name: "الذاريات",
    surahId: 51,
    text: "وَٱلسَّمَآءَ بَنَيۡنَٰهَا بِأَيۡيْدٖ وَإِنَّا لَمُوسِعُونَ",
    translation:
      "And the heaven We constructed with strength, and indeed, We are [its] expander",
    normalizedText: "والسماء بنينها باييد وانا لموسعون",
  },
  {
    verseId: 47,
    name: "الذاريات",
    surahId: 51,
    text: "وَٱلۡأَرۡضَ فَرَشۡنَٰهَا فَنِعۡمَ ٱلۡمَٰهِدُونَ",
    translation:
      "And the earth We have spread out, and excellent is the preparer",
    normalizedText: "والارض فرشنها فنعم المهدون",
  },
  {
    verseId: 48,
    name: "الذاريات",
    surahId: 51,
    text: "وَمِن كُلِّ شَيۡءٍ خَلَقۡنَا زَوۡجَيۡنِ لَعَلَّكُمۡ تَذَكَّرُونَ",
    translation:
      "And of all things We created two mates; perhaps you will remember",
    normalizedText: "ومن كل شيء خلقنا زوجين لعلكم تذكرون",
  },
  {
    verseId: 49,
    name: "الذاريات",
    surahId: 51,
    text: "فَفِرُّوٓاْ إِلَى ٱللَّهِۖ إِنِّي لَكُم مِّنۡهُ نَذِيرٞ مُّبِينٞ",
    translation:
      "So flee to Allah. Indeed, I am to you from Him a clear warner",
    normalizedText: "ففروا الى الله اني لكم منه نذير مبين",
  },
  {
    verseId: 50,
    name: "الذاريات",
    surahId: 51,
    text: "وَلَا تَجۡعَلُواْ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَۖ إِنِّي لَكُم مِّنۡهُ نَذِيرٞ مُّبِينٞ",
    translation:
      "And do not make [as equal] with Allah another deity. Indeed, I am to you from Him a clear warner",
    normalizedText: "ولا تجعلوا مع الله الها ءاخر اني لكم منه نذير مبين",
  },
  {
    verseId: 51,
    name: "الذاريات",
    surahId: 51,
    text: "كَذَٰلِكَ مَآ أَتَى ٱلَّذِينَ مِن قَبۡلِهِم مِّن رَّسُولٍ إِلَّا قَالُواْ سَاحِرٌ أَوۡ مَجۡنُونٌ",
    translation:
      'Similarly, there came not to those before them any messenger except that they said, "A magician or a madman',
    normalizedText:
      "كذلك ما اتى الذين من قبلهم من رسول الا قالوا ساحر او مجنون",
  },
  {
    verseId: 52,
    name: "الذاريات",
    surahId: 51,
    text: "أَتَوَاصَوۡاْ بِهِۦۚ بَلۡ هُمۡ قَوۡمٞ طَاغُونَ",
    translation:
      "Did they suggest it to them? Rather, they [themselves] are a transgressing people",
    normalizedText: "اتواصوا به بل هم قوم طاغون",
  },
  {
    verseId: 53,
    name: "الذاريات",
    surahId: 51,
    text: "فَتَوَلَّ عَنۡهُمۡ فَمَآ أَنتَ بِمَلُومٖ",
    translation: "So leave them, [O Muhammad], for you are not to be blamed",
    normalizedText: "فتول عنهم فما انت بملوم",
  },
  {
    verseId: 54,
    name: "الذاريات",
    surahId: 51,
    text: "وَذَكِّرۡ فَإِنَّ ٱلذِّكۡرَىٰ تَنفَعُ ٱلۡمُؤۡمِنِينَ",
    translation: "And remind, for indeed, the reminder benefits the believers",
    normalizedText: "وذكر فان الذكرى تنفع المامنين",
  },
  {
    verseId: 55,
    name: "الذاريات",
    surahId: 51,
    text: "وَمَا خَلَقۡتُ ٱلۡجِنَّ وَٱلۡإِنسَ إِلَّا لِيَعۡبُدُونِ",
    translation:
      "And I did not create the jinn and mankind except to worship Me",
    normalizedText: "وما خلقت الجن والانس الا ليعبدون",
  },
  {
    verseId: 56,
    name: "الذاريات",
    surahId: 51,
    text: "مَآ أُرِيدُ مِنۡهُم مِّن رِّزۡقٖ وَمَآ أُرِيدُ أَن يُطۡعِمُونِ",
    translation:
      "I do not want from them any provision, nor do I want them to feed Me",
    normalizedText: "ما اريد منهم من رزق وما اريد ان يطعمون",
  },
  {
    verseId: 57,
    name: "الذاريات",
    surahId: 51,
    text: "إِنَّ ٱللَّهَ هُوَ ٱلرَّزَّاقُ ذُو ٱلۡقُوَّةِ ٱلۡمَتِينُ",
    translation:
      "Indeed, it is Allah who is the [continual] Provider, the firm possessor of strength",
    normalizedText: "ان الله هو الرزاق ذو القوة المتين",
  },
  {
    verseId: 58,
    name: "الذاريات",
    surahId: 51,
    text: "فَإِنَّ لِلَّذِينَ ظَلَمُواْ ذَنُوبٗا مِّثۡلَ ذَنُوبِ أَصۡحَٰبِهِمۡ فَلَا يَسۡتَعۡجِلُونِ",
    translation:
      "And indeed, for those who have wronged is a portion [of punishment] like the portion of their predecessors, so let them not impatiently urge Me",
    normalizedText: "فان للذين ظلموا ذنوبا مثل ذنوب اصحبهم فلا يستعجلون",
  },
  {
    verseId: 59,
    name: "الذاريات",
    surahId: 51,
    text: "فَوَيۡلٞ لِّلَّذِينَ كَفَرُواْ مِن يَوۡمِهِمُ ٱلَّذِي يُوعَدُونَ",
    translation:
      "And woe to those who have disbelieved from their Day which they are promised",
    normalizedText: "فويل للذين كفروا من يومهم الذي يوعدون",
  },
  {
    verseId: 0,
    name: "الطور",
    surahId: 52,
    text: "وَٱلطُّورِ",
    translation: "By the mount",
    normalizedText: "والطور",
  },
  {
    verseId: 1,
    name: "الطور",
    surahId: 52,
    text: "وَكِتَٰبٖ مَّسۡطُورٖ",
    translation: "And [by] a Book inscribed",
    normalizedText: "وكتب مسطور",
  },
  {
    verseId: 2,
    name: "الطور",
    surahId: 52,
    text: "فِي رَقّٖ مَّنشُورٖ",
    translation: "In parchment spread open",
    normalizedText: "في رق منشور",
  },
  {
    verseId: 3,
    name: "الطور",
    surahId: 52,
    text: "وَٱلۡبَيۡتِ ٱلۡمَعۡمُورِ",
    translation: "And [by] the frequented House",
    normalizedText: "والبيت المعمور",
  },
  {
    verseId: 4,
    name: "الطور",
    surahId: 52,
    text: "وَٱلسَّقۡفِ ٱلۡمَرۡفُوعِ",
    translation: "And [by] the heaven raised high",
    normalizedText: "والسقف المرفوع",
  },
  {
    verseId: 5,
    name: "الطور",
    surahId: 52,
    text: "وَٱلۡبَحۡرِ ٱلۡمَسۡجُورِ",
    translation: "And [by] the sea filled [with fire]",
    normalizedText: "والبحر المسجور",
  },
  {
    verseId: 6,
    name: "الطور",
    surahId: 52,
    text: "إِنَّ عَذَابَ رَبِّكَ لَوَٰقِعٞ",
    translation: "Indeed, the punishment of your Lord will occur",
    normalizedText: "ان عذاب ربك لوقع",
  },
  {
    verseId: 7,
    name: "الطور",
    surahId: 52,
    text: "مَّا لَهُۥ مِن دَافِعٖ",
    translation: "Of it there is no preventer",
    normalizedText: "ما له من دافع",
  },
  {
    verseId: 8,
    name: "الطور",
    surahId: 52,
    text: "يَوۡمَ تَمُورُ ٱلسَّمَآءُ مَوۡرٗا",
    translation: "On the Day the heaven will sway with circular motion",
    normalizedText: "يوم تمور السماء مورا",
  },
  {
    verseId: 9,
    name: "الطور",
    surahId: 52,
    text: "وَتَسِيرُ ٱلۡجِبَالُ سَيۡرٗا",
    translation: "And the mountains will pass on, departing",
    normalizedText: "وتسير الجبال سيرا",
  },
  {
    verseId: 10,
    name: "الطور",
    surahId: 52,
    text: "فَوَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Then woe, that Day, to the deniers",
    normalizedText: "فويل يوماذ للمكذبين",
  },
  {
    verseId: 11,
    name: "الطور",
    surahId: 52,
    text: "ٱلَّذِينَ هُمۡ فِي خَوۡضٖ يَلۡعَبُونَ",
    translation: "Who are in [empty] discourse amusing themselves",
    normalizedText: "الذين هم في خوض يلعبون",
  },
  {
    verseId: 12,
    name: "الطور",
    surahId: 52,
    text: "يَوۡمَ يُدَعُّونَ إِلَىٰ نَارِ جَهَنَّمَ دَعًّا",
    translation:
      "The Day they are thrust toward the fire of Hell with a [violent] thrust, [its angels will say]",
    normalizedText: "يوم يدعون الى نار جهنم دعا",
  },
  {
    verseId: 13,
    name: "الطور",
    surahId: 52,
    text: "هَٰذِهِ ٱلنَّارُ ٱلَّتِي كُنتُم بِهَا تُكَذِّبُونَ",
    translation: "This is the Fire which you used to deny",
    normalizedText: "هذه النار التي كنتم بها تكذبون",
  },
  {
    verseId: 14,
    name: "الطور",
    surahId: 52,
    text: "أَفَسِحۡرٌ هَٰذَآ أَمۡ أَنتُمۡ لَا تُبۡصِرُونَ",
    translation: "Then is this magic, or do you not see",
    normalizedText: "افسحر هذا ام انتم لا تبصرون",
  },
  {
    verseId: 15,
    name: "الطور",
    surahId: 52,
    text: "ٱصۡلَوۡهَا فَٱصۡبِرُوٓاْ أَوۡ لَا تَصۡبِرُواْ سَوَآءٌ عَلَيۡكُمۡۖ إِنَّمَا تُجۡزَوۡنَ مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "[Enter to] burn therein; then be patient or impatient - it is all the same for you. You are only being recompensed [for] what you used to do",
    normalizedText:
      "اصلوها فاصبروا او لا تصبروا سواء عليكم انما تجزون ما كنتم تعملون",
  },
  {
    verseId: 16,
    name: "الطور",
    surahId: 52,
    text: "إِنَّ ٱلۡمُتَّقِينَ فِي جَنَّـٰتٖ وَنَعِيمٖ",
    translation: "Indeed, the righteous will be in gardens and pleasure",
    normalizedText: "ان المتقين في جنت ونعيم",
  },
  {
    verseId: 17,
    name: "الطور",
    surahId: 52,
    text: "فَٰكِهِينَ بِمَآ ءَاتَىٰهُمۡ رَبُّهُمۡ وَوَقَىٰهُمۡ رَبُّهُمۡ عَذَابَ ٱلۡجَحِيمِ",
    translation:
      "Enjoying what their Lord has given them, and their Lord protected them from the punishment of Hellfire",
    normalizedText: "فكهين بما ءاتىهم ربهم ووقىهم ربهم عذاب الجحيم",
  },
  {
    verseId: 18,
    name: "الطور",
    surahId: 52,
    text: "كُلُواْ وَٱشۡرَبُواْ هَنِيٓـَٔۢا بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      '[They will be told], "Eat and drink in satisfaction for what you used to do',
    normalizedText: "كلوا واشربوا هنيا بما كنتم تعملون",
  },
  {
    verseId: 19,
    name: "الطور",
    surahId: 52,
    text: "مُتَّكِـِٔينَ عَلَىٰ سُرُرٖ مَّصۡفُوفَةٖۖ وَزَوَّجۡنَٰهُم بِحُورٍ عِينٖ",
    translation:
      "They will be reclining on thrones lined up, and We will marry them to fair women with large, [beautiful] eyes",
    normalizedText: "متكين على سرر مصفوفة وزوجنهم بحور عين",
  },
  {
    verseId: 20,
    name: "الطور",
    surahId: 52,
    text: "وَٱلَّذِينَ ءَامَنُواْ وَٱتَّبَعَتۡهُمۡ ذُرِّيَّتُهُم بِإِيمَٰنٍ أَلۡحَقۡنَا بِهِمۡ ذُرِّيَّتَهُمۡ وَمَآ أَلَتۡنَٰهُم مِّنۡ عَمَلِهِم مِّن شَيۡءٖۚ كُلُّ ٱمۡرِيِٕۭ بِمَا كَسَبَ رَهِينٞ",
    translation:
      "And those who believed and whose descendants followed them in faith - We will join with them their descendants, and We will not deprive them of anything of their deeds. Every person, for what he earned, is retained",
    normalizedText:
      "والذين ءامنوا واتبعتهم ذريتهم بايمن الحقنا بهم ذريتهم وما التنهم من عملهم من شيء كل امري بما كسب رهين",
  },
  {
    verseId: 21,
    name: "الطور",
    surahId: 52,
    text: "وَأَمۡدَدۡنَٰهُم بِفَٰكِهَةٖ وَلَحۡمٖ مِّمَّا يَشۡتَهُونَ",
    translation:
      "And We will provide them with fruit and meat from whatever they desire",
    normalizedText: "وامددنهم بفكهة ولحم مما يشتهون",
  },
  {
    verseId: 22,
    name: "الطور",
    surahId: 52,
    text: "يَتَنَٰزَعُونَ فِيهَا كَأۡسٗا لَّا لَغۡوٞ فِيهَا وَلَا تَأۡثِيمٞ",
    translation:
      "They will exchange with one another a cup [of wine] wherein [results] no ill speech or commission of sin",
    normalizedText: "يتنزعون فيها كاسا لا لغو فيها ولا تاثيم",
  },
  {
    verseId: 23,
    name: "الطور",
    surahId: 52,
    text: "۞وَيَطُوفُ عَلَيۡهِمۡ غِلۡمَانٞ لَّهُمۡ كَأَنَّهُمۡ لُؤۡلُؤٞ مَّكۡنُونٞ",
    translation:
      "There will circulate among them [servant] boys [especially] for them, as if they were pearls well-protected",
    normalizedText: "۞ويطوف عليهم غلمان لهم كانهم لالا مكنون",
  },
  {
    verseId: 24,
    name: "الطور",
    surahId: 52,
    text: "وَأَقۡبَلَ بَعۡضُهُمۡ عَلَىٰ بَعۡضٖ يَتَسَآءَلُونَ",
    translation: "And they will approach one another, inquiring of each other",
    normalizedText: "واقبل بعضهم على بعض يتساءلون",
  },
  {
    verseId: 25,
    name: "الطور",
    surahId: 52,
    text: "قَالُوٓاْ إِنَّا كُنَّا قَبۡلُ فِيٓ أَهۡلِنَا مُشۡفِقِينَ",
    translation:
      'They will say, "Indeed, we were previously among our people fearful [of displeasing Allah]',
    normalizedText: "قالوا انا كنا قبل في اهلنا مشفقين",
  },
  {
    verseId: 26,
    name: "الطور",
    surahId: 52,
    text: "فَمَنَّ ٱللَّهُ عَلَيۡنَا وَوَقَىٰنَا عَذَابَ ٱلسَّمُومِ",
    translation:
      "So Allah conferred favor upon us and protected us from the punishment of the Scorching Fire",
    normalizedText: "فمن الله علينا ووقىنا عذاب السموم",
  },
  {
    verseId: 27,
    name: "الطور",
    surahId: 52,
    text: "إِنَّا كُنَّا مِن قَبۡلُ نَدۡعُوهُۖ إِنَّهُۥ هُوَ ٱلۡبَرُّ ٱلرَّحِيمُ",
    translation:
      "Indeed, we used to supplicate Him before. Indeed, it is He who is the Beneficent, the Merciful",
    normalizedText: "انا كنا من قبل ندعوه انه هو البر الرحيم",
  },
  {
    verseId: 28,
    name: "الطور",
    surahId: 52,
    text: "فَذَكِّرۡ فَمَآ أَنتَ بِنِعۡمَتِ رَبِّكَ بِكَاهِنٖ وَلَا مَجۡنُونٍ",
    translation:
      "So remind [O Muhammad], for you are not, by the favor of your Lord, a soothsayer or a madman",
    normalizedText: "فذكر فما انت بنعمت ربك بكاهن ولا مجنون",
  },
  {
    verseId: 29,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ يَقُولُونَ شَاعِرٞ نَّتَرَبَّصُ بِهِۦ رَيۡبَ ٱلۡمَنُونِ",
    translation:
      'Or do they say [of you], "A poet for whom we await a misfortune of time',
    normalizedText: "ام يقولون شاعر نتربص به ريب المنون",
  },
  {
    verseId: 30,
    name: "الطور",
    surahId: 52,
    text: "قُلۡ تَرَبَّصُواْ فَإِنِّي مَعَكُم مِّنَ ٱلۡمُتَرَبِّصِينَ",
    translation: 'Say, "Wait, for indeed I am, with you, among the waiters',
    normalizedText: "قل تربصوا فاني معكم من المتربصين",
  },
  {
    verseId: 31,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ تَأۡمُرُهُمۡ أَحۡلَٰمُهُم بِهَٰذَآۚ أَمۡ هُمۡ قَوۡمٞ طَاغُونَ",
    translation:
      "Or do their minds command them to [say] this, or are they a transgressing people",
    normalizedText: "ام تامرهم احلمهم بهذا ام هم قوم طاغون",
  },
  {
    verseId: 32,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ يَقُولُونَ تَقَوَّلَهُۥۚ بَل لَّا يُؤۡمِنُونَ",
    translation:
      'Or do they say, "He has made it up"? Rather, they do not believe',
    normalizedText: "ام يقولون تقوله بل لا يامنون",
  },
  {
    verseId: 33,
    name: "الطور",
    surahId: 52,
    text: "فَلۡيَأۡتُواْ بِحَدِيثٖ مِّثۡلِهِۦٓ إِن كَانُواْ صَٰدِقِينَ",
    translation:
      "Then let them produce a statement like it, if they should be truthful",
    normalizedText: "فلياتوا بحديث مثله ان كانوا صدقين",
  },
  {
    verseId: 34,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ خُلِقُواْ مِنۡ غَيۡرِ شَيۡءٍ أَمۡ هُمُ ٱلۡخَٰلِقُونَ",
    translation:
      "Or were they created by nothing, or were they the creators [of themselves]",
    normalizedText: "ام خلقوا من غير شيء ام هم الخلقون",
  },
  {
    verseId: 35,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ خَلَقُواْ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَۚ بَل لَّا يُوقِنُونَ",
    translation:
      "Or did they create the heavens and the earth? Rather, they are not certain",
    normalizedText: "ام خلقوا السموت والارض بل لا يوقنون",
  },
  {
    verseId: 36,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ عِندَهُمۡ خَزَآئِنُ رَبِّكَ أَمۡ هُمُ ٱلۡمُصَۜيۡطِرُونَ",
    translation:
      "Or have they the depositories [containing the provision] of your Lord? Or are they the controllers [of them]",
    normalizedText: "ام عندهم خزاان ربك ام هم المصيطرون",
  },
  {
    verseId: 37,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ لَهُمۡ سُلَّمٞ يَسۡتَمِعُونَ فِيهِۖ فَلۡيَأۡتِ مُسۡتَمِعُهُم بِسُلۡطَٰنٖ مُّبِينٍ",
    translation:
      "Or have they a stairway [into the heaven] upon which they listen? Then let their listener produce a clear authority",
    normalizedText: "ام لهم سلم يستمعون فيه فليات مستمعهم بسلطن مبين",
  },
  {
    verseId: 38,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ لَهُ ٱلۡبَنَٰتُ وَلَكُمُ ٱلۡبَنُونَ",
    translation: "Or has He daughters while you have sons",
    normalizedText: "ام له البنت ولكم البنون",
  },
  {
    verseId: 39,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ تَسۡـَٔلُهُمۡ أَجۡرٗا فَهُم مِّن مَّغۡرَمٖ مُّثۡقَلُونَ",
    translation:
      "Or do you, [O Muhammad], ask of them a payment, so they are by debt burdened down",
    normalizedText: "ام تسلهم اجرا فهم من مغرم مثقلون",
  },
  {
    verseId: 40,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ عِندَهُمُ ٱلۡغَيۡبُ فَهُمۡ يَكۡتُبُونَ",
    translation:
      "Or have they [knowledge of] the unseen, so they write [it] down",
    normalizedText: "ام عندهم الغيب فهم يكتبون",
  },
  {
    verseId: 41,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ يُرِيدُونَ كَيۡدٗاۖ فَٱلَّذِينَ كَفَرُواْ هُمُ ٱلۡمَكِيدُونَ",
    translation:
      "Or do they intend a plan? But those who disbelieve - they are the object of a plan",
    normalizedText: "ام يريدون كيدا فالذين كفروا هم المكيدون",
  },
  {
    verseId: 42,
    name: "الطور",
    surahId: 52,
    text: "أَمۡ لَهُمۡ إِلَٰهٌ غَيۡرُ ٱللَّهِۚ سُبۡحَٰنَ ٱللَّهِ عَمَّا يُشۡرِكُونَ",
    translation:
      "Or have they a deity other than Allah? Exalted is Allah above whatever they associate with Him",
    normalizedText: "ام لهم اله غير الله سبحن الله عما يشركون",
  },
  {
    verseId: 43,
    name: "الطور",
    surahId: 52,
    text: "وَإِن يَرَوۡاْ كِسۡفٗا مِّنَ ٱلسَّمَآءِ سَاقِطٗا يَقُولُواْ سَحَابٞ مَّرۡكُومٞ",
    translation:
      'And if they were to see a fragment from the sky falling, they would say, "[It is merely] clouds heaped up',
    normalizedText: "وان يروا كسفا من السماء ساقطا يقولوا سحاب مركوم",
  },
  {
    verseId: 44,
    name: "الطور",
    surahId: 52,
    text: "فَذَرۡهُمۡ حَتَّىٰ يُلَٰقُواْ يَوۡمَهُمُ ٱلَّذِي فِيهِ يُصۡعَقُونَ",
    translation:
      "So leave them until they meet their Day in which they will be struck insensible",
    normalizedText: "فذرهم حتى يلقوا يومهم الذي فيه يصعقون",
  },
  {
    verseId: 45,
    name: "الطور",
    surahId: 52,
    text: "يَوۡمَ لَا يُغۡنِي عَنۡهُمۡ كَيۡدُهُمۡ شَيۡـٔٗا وَلَا هُمۡ يُنصَرُونَ",
    translation:
      "The Day their plan will not avail them at all, nor will they be helped",
    normalizedText: "يوم لا يغني عنهم كيدهم شيا ولا هم ينصرون",
  },
  {
    verseId: 46,
    name: "الطور",
    surahId: 52,
    text: "وَإِنَّ لِلَّذِينَ ظَلَمُواْ عَذَابٗا دُونَ ذَٰلِكَ وَلَٰكِنَّ أَكۡثَرَهُمۡ لَا يَعۡلَمُونَ",
    translation:
      "And indeed, for those who have wronged is a punishment before that, but most of them do not know",
    normalizedText: "وان للذين ظلموا عذابا دون ذلك ولكن اكثرهم لا يعلمون",
  },
  {
    verseId: 47,
    name: "الطور",
    surahId: 52,
    text: "وَٱصۡبِرۡ لِحُكۡمِ رَبِّكَ فَإِنَّكَ بِأَعۡيُنِنَاۖ وَسَبِّحۡ بِحَمۡدِ رَبِّكَ حِينَ تَقُومُ",
    translation:
      "And be patient, [O Muhammad], for the decision of your Lord, for indeed, you are in Our eyes. And exalt [Allah] with praise of your Lord when you arise",
    normalizedText: "واصبر لحكم ربك فانك باعيننا وسبح بحمد ربك حين تقوم",
  },
  {
    verseId: 48,
    name: "الطور",
    surahId: 52,
    text: "وَمِنَ ٱلَّيۡلِ فَسَبِّحۡهُ وَإِدۡبَٰرَ ٱلنُّجُومِ",
    translation:
      "And in a part of the night exalt Him and after [the setting of] the stars",
    normalizedText: "ومن اليل فسبحه وادبر النجوم",
  },
  {
    verseId: 0,
    name: "النجم",
    surahId: 53,
    text: "وَٱلنَّجۡمِ إِذَا هَوَىٰ",
    translation: "By the star when it descends",
    normalizedText: "والنجم اذا هوى",
  },
  {
    verseId: 1,
    name: "النجم",
    surahId: 53,
    text: "مَا ضَلَّ صَاحِبُكُمۡ وَمَا غَوَىٰ",
    translation: "Your companion [Muhammad] has not strayed, nor has he erred",
    normalizedText: "ما ضل صاحبكم وما غوى",
  },
  {
    verseId: 2,
    name: "النجم",
    surahId: 53,
    text: "وَمَا يَنطِقُ عَنِ ٱلۡهَوَىٰٓ",
    translation: "Nor does he speak from [his own] inclination",
    normalizedText: "وما ينطق عن الهوى",
  },
  {
    verseId: 3,
    name: "النجم",
    surahId: 53,
    text: "إِنۡ هُوَ إِلَّا وَحۡيٞ يُوحَىٰ",
    translation: "It is not but a revelation revealed",
    normalizedText: "ان هو الا وحي يوحى",
  },
  {
    verseId: 4,
    name: "النجم",
    surahId: 53,
    text: "عَلَّمَهُۥ شَدِيدُ ٱلۡقُوَىٰ",
    translation: "Taught to him by one intense in strength",
    normalizedText: "علمه شديد القوى",
  },
  {
    verseId: 5,
    name: "النجم",
    surahId: 53,
    text: "ذُو مِرَّةٖ فَٱسۡتَوَىٰ",
    translation: "One of soundness. And he rose to [his] true form",
    normalizedText: "ذو مرة فاستوى",
  },
  {
    verseId: 6,
    name: "النجم",
    surahId: 53,
    text: "وَهُوَ بِٱلۡأُفُقِ ٱلۡأَعۡلَىٰ",
    translation: "While he was in the higher [part of the] horizon",
    normalizedText: "وهو بالافق الاعلى",
  },
  {
    verseId: 7,
    name: "النجم",
    surahId: 53,
    text: "ثُمَّ دَنَا فَتَدَلَّىٰ",
    translation: "Then he approached and descended",
    normalizedText: "ثم دنا فتدلى",
  },
  {
    verseId: 8,
    name: "النجم",
    surahId: 53,
    text: "فَكَانَ قَابَ قَوۡسَيۡنِ أَوۡ أَدۡنَىٰ",
    translation: "And was at a distance of two bow lengths or nearer",
    normalizedText: "فكان قاب قوسين او ادنى",
  },
  {
    verseId: 9,
    name: "النجم",
    surahId: 53,
    text: "فَأَوۡحَىٰٓ إِلَىٰ عَبۡدِهِۦ مَآ أَوۡحَىٰ",
    translation: "And he revealed to His Servant what he revealed",
    normalizedText: "فاوحى الى عبده ما اوحى",
  },
  {
    verseId: 10,
    name: "النجم",
    surahId: 53,
    text: "مَا كَذَبَ ٱلۡفُؤَادُ مَا رَأَىٰٓ",
    translation: "The heart did not lie [about] what it saw",
    normalizedText: "ما كذب الفااد ما راى",
  },
  {
    verseId: 11,
    name: "النجم",
    surahId: 53,
    text: "أَفَتُمَٰرُونَهُۥ عَلَىٰ مَا يَرَىٰ",
    translation: "So will you dispute with him over what he saw",
    normalizedText: "افتمرونه على ما يرى",
  },
  {
    verseId: 12,
    name: "النجم",
    surahId: 53,
    text: "وَلَقَدۡ رَءَاهُ نَزۡلَةً أُخۡرَىٰ",
    translation: "And he certainly saw him in another descent",
    normalizedText: "ولقد رءاه نزلة اخرى",
  },
  {
    verseId: 13,
    name: "النجم",
    surahId: 53,
    text: "عِندَ سِدۡرَةِ ٱلۡمُنتَهَىٰ",
    translation: "At the Lote Tree of the Utmost Boundary",
    normalizedText: "عند سدرة المنتهى",
  },
  {
    verseId: 14,
    name: "النجم",
    surahId: 53,
    text: "عِندَهَا جَنَّةُ ٱلۡمَأۡوَىٰٓ",
    translation: "Near it is the Garden of Refuge",
    normalizedText: "عندها جنة الماوى",
  },
  {
    verseId: 15,
    name: "النجم",
    surahId: 53,
    text: "إِذۡ يَغۡشَى ٱلسِّدۡرَةَ مَا يَغۡشَىٰ",
    translation: "When there covered the Lote Tree that which covered [it]",
    normalizedText: "اذ يغشى السدرة ما يغشى",
  },
  {
    verseId: 16,
    name: "النجم",
    surahId: 53,
    text: "مَا زَاغَ ٱلۡبَصَرُ وَمَا طَغَىٰ",
    translation:
      "The sight [of the Prophet] did not swerve, nor did it transgress [its limit]",
    normalizedText: "ما زاغ البصر وما طغى",
  },
  {
    verseId: 17,
    name: "النجم",
    surahId: 53,
    text: "لَقَدۡ رَأَىٰ مِنۡ ءَايَٰتِ رَبِّهِ ٱلۡكُبۡرَىٰٓ",
    translation: "He certainly saw of the greatest signs of his Lord",
    normalizedText: "لقد راى من ءايت ربه الكبرى",
  },
  {
    verseId: 18,
    name: "النجم",
    surahId: 53,
    text: "أَفَرَءَيۡتُمُ ٱللَّـٰتَ وَٱلۡعُزَّىٰ",
    translation: "So have you considered al-Lat and al-'Uzza",
    normalizedText: "افرءيتم اللت والعزى",
  },
  {
    verseId: 19,
    name: "النجم",
    surahId: 53,
    text: "وَمَنَوٰةَ ٱلثَّالِثَةَ ٱلۡأُخۡرَىٰٓ",
    translation: "And Manat, the third - the other one",
    normalizedText: "ومنوة الثالثة الاخرى",
  },
  {
    verseId: 20,
    name: "النجم",
    surahId: 53,
    text: "أَلَكُمُ ٱلذَّكَرُ وَلَهُ ٱلۡأُنثَىٰ",
    translation: "Is the male for you and for Him the female",
    normalizedText: "الكم الذكر وله الانثى",
  },
  {
    verseId: 21,
    name: "النجم",
    surahId: 53,
    text: "تِلۡكَ إِذٗا قِسۡمَةٞ ضِيزَىٰٓ",
    translation: "That, then, is an unjust division",
    normalizedText: "تلك اذا قسمة ضيزى",
  },
  {
    verseId: 22,
    name: "النجم",
    surahId: 53,
    text: "إِنۡ هِيَ إِلَّآ أَسۡمَآءٞ سَمَّيۡتُمُوهَآ أَنتُمۡ وَءَابَآؤُكُم مَّآ أَنزَلَ ٱللَّهُ بِهَا مِن سُلۡطَٰنٍۚ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَمَا تَهۡوَى ٱلۡأَنفُسُۖ وَلَقَدۡ جَآءَهُم مِّن رَّبِّهِمُ ٱلۡهُدَىٰٓ",
    translation:
      "They are not but [mere] names you have named them - you and your forefathers - for which Allah has sent down no authority. They follow not except assumption and what [their] souls desire, and there has already come to them from their Lord guidance",
    normalizedText:
      "ان هي الا اسماء سميتموها انتم وءابااكم ما انزل الله بها من سلطن ان يتبعون الا الظن وما تهوى الانفس ولقد جاءهم من ربهم الهدى",
  },
  {
    verseId: 23,
    name: "النجم",
    surahId: 53,
    text: "أَمۡ لِلۡإِنسَٰنِ مَا تَمَنَّىٰ",
    translation: "Or is there for man whatever he wishes",
    normalizedText: "ام للانسن ما تمنى",
  },
  {
    verseId: 24,
    name: "النجم",
    surahId: 53,
    text: "فَلِلَّهِ ٱلۡأٓخِرَةُ وَٱلۡأُولَىٰ",
    translation: "Rather, to Allah belongs the Hereafter and the first [life]",
    normalizedText: "فلله الاخرة والاولى",
  },
  {
    verseId: 25,
    name: "النجم",
    surahId: 53,
    text: "۞وَكَم مِّن مَّلَكٖ فِي ٱلسَّمَٰوَٰتِ لَا تُغۡنِي شَفَٰعَتُهُمۡ شَيۡـًٔا إِلَّا مِنۢ بَعۡدِ أَن يَأۡذَنَ ٱللَّهُ لِمَن يَشَآءُ وَيَرۡضَىٰٓ",
    translation:
      "And how many angels there are in the heavens whose intercession will not avail at all except [only] after Allah has permitted [it] to whom He wills and approves",
    normalizedText:
      "۞وكم من ملك في السموت لا تغني شفعتهم شيا الا من بعد ان ياذن الله لمن يشاء ويرضى",
  },
  {
    verseId: 26,
    name: "النجم",
    surahId: 53,
    text: "إِنَّ ٱلَّذِينَ لَا يُؤۡمِنُونَ بِٱلۡأٓخِرَةِ لَيُسَمُّونَ ٱلۡمَلَـٰٓئِكَةَ تَسۡمِيَةَ ٱلۡأُنثَىٰ",
    translation:
      "Indeed, those who do not believe in the Hereafter name the angels female names",
    normalizedText: "ان الذين لا يامنون بالاخرة ليسمون الملاكة تسمية الانثى",
  },
  {
    verseId: 27,
    name: "النجم",
    surahId: 53,
    text: "وَمَا لَهُم بِهِۦ مِنۡ عِلۡمٍۖ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّۖ وَإِنَّ ٱلظَّنَّ لَا يُغۡنِي مِنَ ٱلۡحَقِّ شَيۡـٔٗا",
    translation:
      "And they have thereof no knowledge. They follow not except assumption, and indeed, assumption avails not against the truth at all",
    normalizedText:
      "وما لهم به من علم ان يتبعون الا الظن وان الظن لا يغني من الحق شيا",
  },
  {
    verseId: 28,
    name: "النجم",
    surahId: 53,
    text: "فَأَعۡرِضۡ عَن مَّن تَوَلَّىٰ عَن ذِكۡرِنَا وَلَمۡ يُرِدۡ إِلَّا ٱلۡحَيَوٰةَ ٱلدُّنۡيَا",
    translation:
      "So turn away from whoever turns his back on Our message and desires not except the worldly life",
    normalizedText: "فاعرض عن من تولى عن ذكرنا ولم يرد الا الحيوة الدنيا",
  },
  {
    verseId: 29,
    name: "النجم",
    surahId: 53,
    text: "ذَٰلِكَ مَبۡلَغُهُم مِّنَ ٱلۡعِلۡمِۚ إِنَّ رَبَّكَ هُوَ أَعۡلَمُ بِمَن ضَلَّ عَن سَبِيلِهِۦ وَهُوَ أَعۡلَمُ بِمَنِ ٱهۡتَدَىٰ",
    translation:
      "That is their sum of knowledge. Indeed, your Lord is most knowing of who strays from His way, and He is most knowing of who is guided",
    normalizedText:
      "ذلك مبلغهم من العلم ان ربك هو اعلم بمن ضل عن سبيله وهو اعلم بمن اهتدى",
  },
  {
    verseId: 30,
    name: "النجم",
    surahId: 53,
    text: "وَلِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ لِيَجۡزِيَ ٱلَّذِينَ أَسَـٰٓـُٔواْ بِمَا عَمِلُواْ وَيَجۡزِيَ ٱلَّذِينَ أَحۡسَنُواْ بِٱلۡحُسۡنَى",
    translation:
      "And to Allah belongs whatever is in the heavens and whatever is in the earth - that He may recompense those who do evil with [the penalty of] what they have done and recompense those who do good with the best [reward]",
    normalizedText:
      "ولله ما في السموت وما في الارض ليجزي الذين اسوا بما عملوا ويجزي الذين احسنوا بالحسنى",
  },
  {
    verseId: 31,
    name: "النجم",
    surahId: 53,
    text: "ٱلَّذِينَ يَجۡتَنِبُونَ كَبَـٰٓئِرَ ٱلۡإِثۡمِ وَٱلۡفَوَٰحِشَ إِلَّا ٱللَّمَمَۚ إِنَّ رَبَّكَ وَٰسِعُ ٱلۡمَغۡفِرَةِۚ هُوَ أَعۡلَمُ بِكُمۡ إِذۡ أَنشَأَكُم مِّنَ ٱلۡأَرۡضِ وَإِذۡ أَنتُمۡ أَجِنَّةٞ فِي بُطُونِ أُمَّهَٰتِكُمۡۖ فَلَا تُزَكُّوٓاْ أَنفُسَكُمۡۖ هُوَ أَعۡلَمُ بِمَنِ ٱتَّقَىٰٓ",
    translation:
      "Those who avoid the major sins and immoralities, only [committing] slight ones. Indeed, your Lord is vast in forgiveness. He was most knowing of you when He produced you from the earth and when you were fetuses in the wombs of your mothers. So do not claim yourselves to be pure; He is most knowing of who fears Him",
    normalizedText:
      "الذين يجتنبون كبار الاثم والفوحش الا اللمم ان ربك وسع المغفرة هو اعلم بكم اذ انشاكم من الارض واذ انتم اجنة في بطون امهتكم فلا تزكوا انفسكم هو اعلم بمن اتقى",
  },
  {
    verseId: 32,
    name: "النجم",
    surahId: 53,
    text: "أَفَرَءَيۡتَ ٱلَّذِي تَوَلَّىٰ",
    translation: "Have you seen the one who turned away",
    normalizedText: "افرءيت الذي تولى",
  },
  {
    verseId: 33,
    name: "النجم",
    surahId: 53,
    text: "وَأَعۡطَىٰ قَلِيلٗا وَأَكۡدَىٰٓ",
    translation: "And gave a little and [then] refrained",
    normalizedText: "واعطى قليلا واكدى",
  },
  {
    verseId: 34,
    name: "النجم",
    surahId: 53,
    text: "أَعِندَهُۥ عِلۡمُ ٱلۡغَيۡبِ فَهُوَ يَرَىٰٓ",
    translation: "Does he have knowledge of the unseen, so he sees",
    normalizedText: "اعنده علم الغيب فهو يرى",
  },
  {
    verseId: 35,
    name: "النجم",
    surahId: 53,
    text: "أَمۡ لَمۡ يُنَبَّأۡ بِمَا فِي صُحُفِ مُوسَىٰ",
    translation:
      "Or has he not been informed of what was in the scriptures of Moses",
    normalizedText: "ام لم ينبا بما في صحف موسى",
  },
  {
    verseId: 36,
    name: "النجم",
    surahId: 53,
    text: "وَإِبۡرَٰهِيمَ ٱلَّذِي وَفَّىٰٓ",
    translation: "And [of] Abraham, who fulfilled [his obligations]",
    normalizedText: "وابرهيم الذي وفى",
  },
  {
    verseId: 37,
    name: "النجم",
    surahId: 53,
    text: "أَلَّا تَزِرُ وَازِرَةٞ وِزۡرَ أُخۡرَىٰ",
    translation: "That no bearer of burdens will bear the burden of another",
    normalizedText: "الا تزر وازرة وزر اخرى",
  },
  {
    verseId: 38,
    name: "النجم",
    surahId: 53,
    text: "وَأَن لَّيۡسَ لِلۡإِنسَٰنِ إِلَّا مَا سَعَىٰ",
    translation:
      "And that there is not for man except that [good] for which he strives",
    normalizedText: "وان ليس للانسن الا ما سعى",
  },
  {
    verseId: 39,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّ سَعۡيَهُۥ سَوۡفَ يُرَىٰ",
    translation: "And that his effort is going to be seen",
    normalizedText: "وان سعيه سوف يرى",
  },
  {
    verseId: 40,
    name: "النجم",
    surahId: 53,
    text: "ثُمَّ يُجۡزَىٰهُ ٱلۡجَزَآءَ ٱلۡأَوۡفَىٰ",
    translation:
      "Then he will be recompensed for it with the fullest recompense",
    normalizedText: "ثم يجزىه الجزاء الاوفى",
  },
  {
    verseId: 41,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّ إِلَىٰ رَبِّكَ ٱلۡمُنتَهَىٰ",
    translation: "And that to your Lord is the finality",
    normalizedText: "وان الى ربك المنتهى",
  },
  {
    verseId: 42,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّهُۥ هُوَ أَضۡحَكَ وَأَبۡكَىٰ",
    translation: "And that it is He who makes [one] laugh and weep",
    normalizedText: "وانه هو اضحك وابكى",
  },
  {
    verseId: 43,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّهُۥ هُوَ أَمَاتَ وَأَحۡيَا",
    translation: "And that it is He who causes death and gives life",
    normalizedText: "وانه هو امات واحيا",
  },
  {
    verseId: 44,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّهُۥ خَلَقَ ٱلزَّوۡجَيۡنِ ٱلذَّكَرَ وَٱلۡأُنثَىٰ",
    translation: "And that He creates the two mates - the male and female",
    normalizedText: "وانه خلق الزوجين الذكر والانثى",
  },
  {
    verseId: 45,
    name: "النجم",
    surahId: 53,
    text: "مِن نُّطۡفَةٍ إِذَا تُمۡنَىٰ",
    translation: "From a sperm-drop when it is emitted",
    normalizedText: "من نطفة اذا تمنى",
  },
  {
    verseId: 46,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّ عَلَيۡهِ ٱلنَّشۡأَةَ ٱلۡأُخۡرَىٰ",
    translation: "And that [incumbent] upon Him is the next creation",
    normalizedText: "وان عليه النشاة الاخرى",
  },
  {
    verseId: 47,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّهُۥ هُوَ أَغۡنَىٰ وَأَقۡنَىٰ",
    translation: "And that it is He who enriches and suffices",
    normalizedText: "وانه هو اغنى واقنى",
  },
  {
    verseId: 48,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّهُۥ هُوَ رَبُّ ٱلشِّعۡرَىٰ",
    translation: "And that it is He who is the Lord of Sirius",
    normalizedText: "وانه هو رب الشعرى",
  },
  {
    verseId: 49,
    name: "النجم",
    surahId: 53,
    text: "وَأَنَّهُۥٓ أَهۡلَكَ عَادًا ٱلۡأُولَىٰ",
    translation: "And that He destroyed the first [people of] 'Aad",
    normalizedText: "وانه اهلك عادا الاولى",
  },
  {
    verseId: 50,
    name: "النجم",
    surahId: 53,
    text: "وَثَمُودَاْ فَمَآ أَبۡقَىٰ",
    translation: "And Thamud - and He did not spare [them]",
    normalizedText: "وثمودا فما ابقى",
  },
  {
    verseId: 51,
    name: "النجم",
    surahId: 53,
    text: "وَقَوۡمَ نُوحٖ مِّن قَبۡلُۖ إِنَّهُمۡ كَانُواْ هُمۡ أَظۡلَمَ وَأَطۡغَىٰ",
    translation:
      "And the people of Noah before. Indeed, it was they who were [even] more unjust and oppressing",
    normalizedText: "وقوم نوح من قبل انهم كانوا هم اظلم واطغى",
  },
  {
    verseId: 52,
    name: "النجم",
    surahId: 53,
    text: "وَٱلۡمُؤۡتَفِكَةَ أَهۡوَىٰ",
    translation: "And the overturned towns He hurled down",
    normalizedText: "والماتفكة اهوى",
  },
  {
    verseId: 53,
    name: "النجم",
    surahId: 53,
    text: "فَغَشَّىٰهَا مَا غَشَّىٰ",
    translation: "And covered them by that which He covered",
    normalizedText: "فغشىها ما غشى",
  },
  {
    verseId: 54,
    name: "النجم",
    surahId: 53,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكَ تَتَمَارَىٰ",
    translation: "Then which of the favors of your Lord do you doubt",
    normalizedText: "فباي ءالاء ربك تتمارى",
  },
  {
    verseId: 55,
    name: "النجم",
    surahId: 53,
    text: "هَٰذَا نَذِيرٞ مِّنَ ٱلنُّذُرِ ٱلۡأُولَىٰٓ",
    translation: "This [Prophet] is a warner like the former warners",
    normalizedText: "هذا نذير من النذر الاولى",
  },
  {
    verseId: 56,
    name: "النجم",
    surahId: 53,
    text: "أَزِفَتِ ٱلۡأٓزِفَةُ",
    translation: "The Approaching Day has approached",
    normalizedText: "ازفت الازفة",
  },
  {
    verseId: 57,
    name: "النجم",
    surahId: 53,
    text: "لَيۡسَ لَهَا مِن دُونِ ٱللَّهِ كَاشِفَةٌ",
    translation: "Of it, [from those] besides Allah, there is no remover",
    normalizedText: "ليس لها من دون الله كاشفة",
  },
  {
    verseId: 58,
    name: "النجم",
    surahId: 53,
    text: "أَفَمِنۡ هَٰذَا ٱلۡحَدِيثِ تَعۡجَبُونَ",
    translation: "Then at this statement do you wonder",
    normalizedText: "افمن هذا الحديث تعجبون",
  },
  {
    verseId: 59,
    name: "النجم",
    surahId: 53,
    text: "وَتَضۡحَكُونَ وَلَا تَبۡكُونَ",
    translation: "And you laugh and do not weep",
    normalizedText: "وتضحكون ولا تبكون",
  },
  {
    verseId: 60,
    name: "النجم",
    surahId: 53,
    text: "وَأَنتُمۡ سَٰمِدُونَ",
    translation: "While you are proudly sporting",
    normalizedText: "وانتم سمدون",
  },
  {
    verseId: 61,
    name: "النجم",
    surahId: 53,
    text: "فَٱسۡجُدُواْۤ لِلَّهِۤ وَٱعۡبُدُواْ۩",
    translation: "So prostrate to Allah and worship [Him]",
    normalizedText: "فاسجدوا لله واعبدوا۩",
  },
  {
    verseId: 0,
    name: "القمر",
    surahId: 54,
    text: "ٱقۡتَرَبَتِ ٱلسَّاعَةُ وَٱنشَقَّ ٱلۡقَمَرُ",
    translation: "The Hour has come near, and the moon has split [in two]",
    normalizedText: "اقتربت الساعة وانشق القمر",
  },
  {
    verseId: 1,
    name: "القمر",
    surahId: 54,
    text: "وَإِن يَرَوۡاْ ءَايَةٗ يُعۡرِضُواْ وَيَقُولُواْ سِحۡرٞ مُّسۡتَمِرّٞ",
    translation:
      'And if they see a miracle, they turn away and say, "Passing magic',
    normalizedText: "وان يروا ءاية يعرضوا ويقولوا سحر مستمر",
  },
  {
    verseId: 2,
    name: "القمر",
    surahId: 54,
    text: "وَكَذَّبُواْ وَٱتَّبَعُوٓاْ أَهۡوَآءَهُمۡۚ وَكُلُّ أَمۡرٖ مُّسۡتَقِرّٞ",
    translation:
      "And they denied and followed their inclinations. But for every matter is a [time of] settlement",
    normalizedText: "وكذبوا واتبعوا اهواءهم وكل امر مستقر",
  },
  {
    verseId: 3,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ جَآءَهُم مِّنَ ٱلۡأَنۢبَآءِ مَا فِيهِ مُزۡدَجَرٌ",
    translation:
      "And there has already come to them of information that in which there is deterrence",
    normalizedText: "ولقد جاءهم من الانباء ما فيه مزدجر",
  },
  {
    verseId: 4,
    name: "القمر",
    surahId: 54,
    text: "حِكۡمَةُۢ بَٰلِغَةٞۖ فَمَا تُغۡنِ ٱلنُّذُرُ",
    translation: "Extensive wisdom - but warning does not avail [them]",
    normalizedText: "حكمة بلغة فما تغن النذر",
  },
  {
    verseId: 5,
    name: "القمر",
    surahId: 54,
    text: "فَتَوَلَّ عَنۡهُمۡۘ يَوۡمَ يَدۡعُ ٱلدَّاعِ إِلَىٰ شَيۡءٖ نُّكُرٍ",
    translation:
      "So leave them, [O Muhammad]. The Day the Caller calls to something forbidding",
    normalizedText: "فتول عنهم يوم يدع الداع الى شيء نكر",
  },
  {
    verseId: 6,
    name: "القمر",
    surahId: 54,
    text: "خُشَّعًا أَبۡصَٰرُهُمۡ يَخۡرُجُونَ مِنَ ٱلۡأَجۡدَاثِ كَأَنَّهُمۡ جَرَادٞ مُّنتَشِرٞ",
    translation:
      "Their eyes humbled, they will emerge from the graves as if they were locusts spreading",
    normalizedText: "خشعا ابصرهم يخرجون من الاجداث كانهم جراد منتشر",
  },
  {
    verseId: 7,
    name: "القمر",
    surahId: 54,
    text: "مُّهۡطِعِينَ إِلَى ٱلدَّاعِۖ يَقُولُ ٱلۡكَٰفِرُونَ هَٰذَا يَوۡمٌ عَسِرٞ",
    translation:
      'Racing ahead toward the Caller. The disbelievers will say, "This is a difficult Day',
    normalizedText: "مهطعين الى الداع يقول الكفرون هذا يوم عسر",
  },
  {
    verseId: 8,
    name: "القمر",
    surahId: 54,
    text: "۞كَذَّبَتۡ قَبۡلَهُمۡ قَوۡمُ نُوحٖ فَكَذَّبُواْ عَبۡدَنَا وَقَالُواْ مَجۡنُونٞ وَٱزۡدُجِرَ",
    translation:
      'The people of Noah denied before them, and they denied Our servant and said, "A madman," and he was repelled',
    normalizedText: "۞كذبت قبلهم قوم نوح فكذبوا عبدنا وقالوا مجنون وازدجر",
  },
  {
    verseId: 9,
    name: "القمر",
    surahId: 54,
    text: "فَدَعَا رَبَّهُۥٓ أَنِّي مَغۡلُوبٞ فَٱنتَصِرۡ",
    translation: 'So he invoked his Lord, "Indeed, I am overpowered, so help',
    normalizedText: "فدعا ربه اني مغلوب فانتصر",
  },
  {
    verseId: 10,
    name: "القمر",
    surahId: 54,
    text: "فَفَتَحۡنَآ أَبۡوَٰبَ ٱلسَّمَآءِ بِمَآءٖ مُّنۡهَمِرٖ",
    translation:
      "Then We opened the gates of the heaven with rain pouring down",
    normalizedText: "ففتحنا ابوب السماء بماء منهمر",
  },
  {
    verseId: 11,
    name: "القمر",
    surahId: 54,
    text: "وَفَجَّرۡنَا ٱلۡأَرۡضَ عُيُونٗا فَٱلۡتَقَى ٱلۡمَآءُ عَلَىٰٓ أَمۡرٖ قَدۡ قُدِرَ",
    translation:
      "And caused the earth to burst with springs, and the waters met for a matter already predestined",
    normalizedText: "وفجرنا الارض عيونا فالتقى الماء على امر قد قدر",
  },
  {
    verseId: 12,
    name: "القمر",
    surahId: 54,
    text: "وَحَمَلۡنَٰهُ عَلَىٰ ذَاتِ أَلۡوَٰحٖ وَدُسُرٖ",
    translation: "And We carried him on a [construction of] planks and nails",
    normalizedText: "وحملنه على ذات الوح ودسر",
  },
  {
    verseId: 13,
    name: "القمر",
    surahId: 54,
    text: "تَجۡرِي بِأَعۡيُنِنَا جَزَآءٗ لِّمَن كَانَ كُفِرَ",
    translation:
      "Sailing under Our observation as reward for he who had been denied",
    normalizedText: "تجري باعيننا جزاء لمن كان كفر",
  },
  {
    verseId: 14,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَد تَّرَكۡنَٰهَآ ءَايَةٗ فَهَلۡ مِن مُّدَّكِرٖ",
    translation: "And We left it as a sign, so is there any who will remember",
    normalizedText: "ولقد تركنها ءاية فهل من مدكر",
  },
  {
    verseId: 15,
    name: "القمر",
    surahId: 54,
    text: "فَكَيۡفَ كَانَ عَذَابِي وَنُذُرِ",
    translation: "And how [severe] were My punishment and warning",
    normalizedText: "فكيف كان عذابي ونذر",
  },
  {
    verseId: 16,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ يَسَّرۡنَا ٱلۡقُرۡءَانَ لِلذِّكۡرِ فَهَلۡ مِن مُّدَّكِرٖ",
    translation:
      "And We have certainly made the Qur'an easy for remembrance, so is there any who will remember",
    normalizedText: "ولقد يسرنا القرءان للذكر فهل من مدكر",
  },
  {
    verseId: 17,
    name: "القمر",
    surahId: 54,
    text: "كَذَّبَتۡ عَادٞ فَكَيۡفَ كَانَ عَذَابِي وَنُذُرِ",
    translation: "Aad denied; and how [severe] were My punishment and warning",
    normalizedText: "كذبت عاد فكيف كان عذابي ونذر",
  },
  {
    verseId: 18,
    name: "القمر",
    surahId: 54,
    text: "إِنَّآ أَرۡسَلۡنَا عَلَيۡهِمۡ رِيحٗا صَرۡصَرٗا فِي يَوۡمِ نَحۡسٖ مُّسۡتَمِرّٖ",
    translation:
      "Indeed, We sent upon them a screaming wind on a day of continuous misfortune",
    normalizedText: "انا ارسلنا عليهم ريحا صرصرا في يوم نحس مستمر",
  },
  {
    verseId: 19,
    name: "القمر",
    surahId: 54,
    text: "تَنزِعُ ٱلنَّاسَ كَأَنَّهُمۡ أَعۡجَازُ نَخۡلٖ مُّنقَعِرٖ",
    translation:
      "Extracting the people as if they were trunks of palm trees uprooted",
    normalizedText: "تنزع الناس كانهم اعجاز نخل منقعر",
  },
  {
    verseId: 20,
    name: "القمر",
    surahId: 54,
    text: "فَكَيۡفَ كَانَ عَذَابِي وَنُذُرِ",
    translation: "And how [severe] were My punishment and warning",
    normalizedText: "فكيف كان عذابي ونذر",
  },
  {
    verseId: 21,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ يَسَّرۡنَا ٱلۡقُرۡءَانَ لِلذِّكۡرِ فَهَلۡ مِن مُّدَّكِرٖ",
    translation:
      "And We have certainly made the Qur'an easy for remembrance, so is there any who will remember",
    normalizedText: "ولقد يسرنا القرءان للذكر فهل من مدكر",
  },
  {
    verseId: 22,
    name: "القمر",
    surahId: 54,
    text: "كَذَّبَتۡ ثَمُودُ بِٱلنُّذُرِ",
    translation: "Thamud denied the warning",
    normalizedText: "كذبت ثمود بالنذر",
  },
  {
    verseId: 23,
    name: "القمر",
    surahId: 54,
    text: "فَقَالُوٓاْ أَبَشَرٗا مِّنَّا وَٰحِدٗا نَّتَّبِعُهُۥٓ إِنَّآ إِذٗا لَّفِي ضَلَٰلٖ وَسُعُرٍ",
    translation:
      'And said, "Is it one human being among us that we should follow? Indeed, we would then be in error and madness',
    normalizedText: "فقالوا ابشرا منا وحدا نتبعه انا اذا لفي ضلل وسعر",
  },
  {
    verseId: 24,
    name: "القمر",
    surahId: 54,
    text: "أَءُلۡقِيَ ٱلذِّكۡرُ عَلَيۡهِ مِنۢ بَيۡنِنَا بَلۡ هُوَ كَذَّابٌ أَشِرٞ",
    translation:
      "Has the message been sent down upon him from among us? Rather, he is an insolent liar",
    normalizedText: "اءلقي الذكر عليه من بيننا بل هو كذاب اشر",
  },
  {
    verseId: 25,
    name: "القمر",
    surahId: 54,
    text: "سَيَعۡلَمُونَ غَدٗا مَّنِ ٱلۡكَذَّابُ ٱلۡأَشِرُ",
    translation: "They will know tomorrow who is the insolent liar",
    normalizedText: "سيعلمون غدا من الكذاب الاشر",
  },
  {
    verseId: 26,
    name: "القمر",
    surahId: 54,
    text: "إِنَّا مُرۡسِلُواْ ٱلنَّاقَةِ فِتۡنَةٗ لَّهُمۡ فَٱرۡتَقِبۡهُمۡ وَٱصۡطَبِرۡ",
    translation:
      "Indeed, We are sending the she-camel as trial for them, so watch them and be patient",
    normalizedText: "انا مرسلوا الناقة فتنة لهم فارتقبهم واصطبر",
  },
  {
    verseId: 27,
    name: "القمر",
    surahId: 54,
    text: "وَنَبِّئۡهُمۡ أَنَّ ٱلۡمَآءَ قِسۡمَةُۢ بَيۡنَهُمۡۖ كُلُّ شِرۡبٖ مُّحۡتَضَرٞ",
    translation:
      "And inform them that the water is shared between them, each [day of] drink attended [by turn]",
    normalizedText: "ونباهم ان الماء قسمة بينهم كل شرب محتضر",
  },
  {
    verseId: 28,
    name: "القمر",
    surahId: 54,
    text: "فَنَادَوۡاْ صَاحِبَهُمۡ فَتَعَاطَىٰ فَعَقَرَ",
    translation:
      "But they called their companion, and he dared and hamstrung [her]",
    normalizedText: "فنادوا صاحبهم فتعاطى فعقر",
  },
  {
    verseId: 29,
    name: "القمر",
    surahId: 54,
    text: "فَكَيۡفَ كَانَ عَذَابِي وَنُذُرِ",
    translation: "And how [severe] were My punishment and warning",
    normalizedText: "فكيف كان عذابي ونذر",
  },
  {
    verseId: 30,
    name: "القمر",
    surahId: 54,
    text: "إِنَّآ أَرۡسَلۡنَا عَلَيۡهِمۡ صَيۡحَةٗ وَٰحِدَةٗ فَكَانُواْ كَهَشِيمِ ٱلۡمُحۡتَظِرِ",
    translation:
      "Indeed, We sent upon them one blast from the sky, and they became like the dry twig fragments of an [animal] pen",
    normalizedText: "انا ارسلنا عليهم صيحة وحدة فكانوا كهشيم المحتظر",
  },
  {
    verseId: 31,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ يَسَّرۡنَا ٱلۡقُرۡءَانَ لِلذِّكۡرِ فَهَلۡ مِن مُّدَّكِرٖ",
    translation:
      "And We have certainly made the Qur'an easy for remembrance, so is there any who will remember",
    normalizedText: "ولقد يسرنا القرءان للذكر فهل من مدكر",
  },
  {
    verseId: 32,
    name: "القمر",
    surahId: 54,
    text: "كَذَّبَتۡ قَوۡمُ لُوطِۭ بِٱلنُّذُرِ",
    translation: "The people of Lot denied the warning",
    normalizedText: "كذبت قوم لوط بالنذر",
  },
  {
    verseId: 33,
    name: "القمر",
    surahId: 54,
    text: "إِنَّآ أَرۡسَلۡنَا عَلَيۡهِمۡ حَاصِبًا إِلَّآ ءَالَ لُوطٖۖ نَّجَّيۡنَٰهُم بِسَحَرٖ",
    translation:
      "Indeed, We sent upon them a storm of stones, except the family of Lot - We saved them before dawn",
    normalizedText: "انا ارسلنا عليهم حاصبا الا ءال لوط نجينهم بسحر",
  },
  {
    verseId: 34,
    name: "القمر",
    surahId: 54,
    text: "نِّعۡمَةٗ مِّنۡ عِندِنَاۚ كَذَٰلِكَ نَجۡزِي مَن شَكَرَ",
    translation: "As favor from us. Thus do We reward he who is grateful",
    normalizedText: "نعمة من عندنا كذلك نجزي من شكر",
  },
  {
    verseId: 35,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ أَنذَرَهُم بَطۡشَتَنَا فَتَمَارَوۡاْ بِٱلنُّذُرِ",
    translation:
      "And he had already warned them of Our assault, but they disputed the warning",
    normalizedText: "ولقد انذرهم بطشتنا فتماروا بالنذر",
  },
  {
    verseId: 36,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ رَٰوَدُوهُ عَن ضَيۡفِهِۦ فَطَمَسۡنَآ أَعۡيُنَهُمۡ فَذُوقُواْ عَذَابِي وَنُذُرِ",
    translation:
      'And they had demanded from him his guests, but We obliterated their eyes, [saying], "Taste My punishment and warning',
    normalizedText: "ولقد رودوه عن ضيفه فطمسنا اعينهم فذوقوا عذابي ونذر",
  },
  {
    verseId: 37,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ صَبَّحَهُم بُكۡرَةً عَذَابٞ مُّسۡتَقِرّٞ",
    translation: "And there came upon them by morning an abiding punishment",
    normalizedText: "ولقد صبحهم بكرة عذاب مستقر",
  },
  {
    verseId: 38,
    name: "القمر",
    surahId: 54,
    text: "فَذُوقُواْ عَذَابِي وَنُذُرِ",
    translation: "So taste My punishment and warning",
    normalizedText: "فذوقوا عذابي ونذر",
  },
  {
    verseId: 39,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ يَسَّرۡنَا ٱلۡقُرۡءَانَ لِلذِّكۡرِ فَهَلۡ مِن مُّدَّكِرٖ",
    translation:
      "And We have certainly made the Qur'an easy for remembrance, so is there any who will remember",
    normalizedText: "ولقد يسرنا القرءان للذكر فهل من مدكر",
  },
  {
    verseId: 40,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ جَآءَ ءَالَ فِرۡعَوۡنَ ٱلنُّذُرُ",
    translation: "And there certainly came to the people of Pharaoh warning",
    normalizedText: "ولقد جاء ءال فرعون النذر",
  },
  {
    verseId: 41,
    name: "القمر",
    surahId: 54,
    text: "كَذَّبُواْ بِـَٔايَٰتِنَا كُلِّهَا فَأَخَذۡنَٰهُمۡ أَخۡذَ عَزِيزٖ مُّقۡتَدِرٍ",
    translation:
      "They denied Our signs, all of them, so We seized them with a seizure of one Exalted in Might and Perfect in Ability",
    normalizedText: "كذبوا بايتنا كلها فاخذنهم اخذ عزيز مقتدر",
  },
  {
    verseId: 42,
    name: "القمر",
    surahId: 54,
    text: "أَكُفَّارُكُمۡ خَيۡرٞ مِّنۡ أُوْلَـٰٓئِكُمۡ أَمۡ لَكُم بَرَآءَةٞ فِي ٱلزُّبُرِ",
    translation:
      "Are your disbelievers better than those [former ones], or have you immunity in the scripture",
    normalizedText: "اكفاركم خير من اولاكم ام لكم براءة في الزبر",
  },
  {
    verseId: 43,
    name: "القمر",
    surahId: 54,
    text: "أَمۡ يَقُولُونَ نَحۡنُ جَمِيعٞ مُّنتَصِرٞ",
    translation: 'Or do they say, "We are an assembly supporting [each other]',
    normalizedText: "ام يقولون نحن جميع منتصر",
  },
  {
    verseId: 44,
    name: "القمر",
    surahId: 54,
    text: "سَيُهۡزَمُ ٱلۡجَمۡعُ وَيُوَلُّونَ ٱلدُّبُرَ",
    translation:
      "[Their] assembly will be defeated, and they will turn their backs [in retreat]",
    normalizedText: "سيهزم الجمع ويولون الدبر",
  },
  {
    verseId: 45,
    name: "القمر",
    surahId: 54,
    text: "بَلِ ٱلسَّاعَةُ مَوۡعِدُهُمۡ وَٱلسَّاعَةُ أَدۡهَىٰ وَأَمَرُّ",
    translation:
      "But the Hour is their appointment [for due punishment], and the Hour is more disastrous and more bitter",
    normalizedText: "بل الساعة موعدهم والساعة ادهى وامر",
  },
  {
    verseId: 46,
    name: "القمر",
    surahId: 54,
    text: "إِنَّ ٱلۡمُجۡرِمِينَ فِي ضَلَٰلٖ وَسُعُرٖ",
    translation: "Indeed, the criminals are in error and madness",
    normalizedText: "ان المجرمين في ضلل وسعر",
  },
  {
    verseId: 47,
    name: "القمر",
    surahId: 54,
    text: "يَوۡمَ يُسۡحَبُونَ فِي ٱلنَّارِ عَلَىٰ وُجُوهِهِمۡ ذُوقُواْ مَسَّ سَقَرَ",
    translation:
      'The Day they are dragged into the Fire on their faces [it will be said], "Taste the touch of Saqar',
    normalizedText: "يوم يسحبون في النار على وجوههم ذوقوا مس سقر",
  },
  {
    verseId: 48,
    name: "القمر",
    surahId: 54,
    text: "إِنَّا كُلَّ شَيۡءٍ خَلَقۡنَٰهُ بِقَدَرٖ",
    translation: "Indeed, all things We created with predestination",
    normalizedText: "انا كل شيء خلقنه بقدر",
  },
  {
    verseId: 49,
    name: "القمر",
    surahId: 54,
    text: "وَمَآ أَمۡرُنَآ إِلَّا وَٰحِدَةٞ كَلَمۡحِۭ بِٱلۡبَصَرِ",
    translation: "And Our command is but one, like a glance of the eye",
    normalizedText: "وما امرنا الا وحدة كلمح بالبصر",
  },
  {
    verseId: 50,
    name: "القمر",
    surahId: 54,
    text: "وَلَقَدۡ أَهۡلَكۡنَآ أَشۡيَاعَكُمۡ فَهَلۡ مِن مُّدَّكِرٖ",
    translation:
      "And We have already destroyed your kinds, so is there any who will remember",
    normalizedText: "ولقد اهلكنا اشياعكم فهل من مدكر",
  },
  {
    verseId: 51,
    name: "القمر",
    surahId: 54,
    text: "وَكُلُّ شَيۡءٖ فَعَلُوهُ فِي ٱلزُّبُرِ",
    translation: "And everything they did is in written records",
    normalizedText: "وكل شيء فعلوه في الزبر",
  },
  {
    verseId: 52,
    name: "القمر",
    surahId: 54,
    text: "وَكُلُّ صَغِيرٖ وَكَبِيرٖ مُّسۡتَطَرٌ",
    translation: "And every small and great [thing] is inscribed",
    normalizedText: "وكل صغير وكبير مستطر",
  },
  {
    verseId: 53,
    name: "القمر",
    surahId: 54,
    text: "إِنَّ ٱلۡمُتَّقِينَ فِي جَنَّـٰتٖ وَنَهَرٖ",
    translation: "Indeed, the righteous will be among gardens and rivers",
    normalizedText: "ان المتقين في جنت ونهر",
  },
  {
    verseId: 54,
    name: "القمر",
    surahId: 54,
    text: "فِي مَقۡعَدِ صِدۡقٍ عِندَ مَلِيكٖ مُّقۡتَدِرِۭ",
    translation: "In a seat of honor near a Sovereign, Perfect in Ability",
    normalizedText: "في مقعد صدق عند مليك مقتدر",
  },
  {
    verseId: 0,
    name: "الرحمن",
    surahId: 55,
    text: "ٱلرَّحۡمَٰنُ",
    translation: "The Most Merciful",
    normalizedText: "الرحمن",
  },
  {
    verseId: 1,
    name: "الرحمن",
    surahId: 55,
    text: "عَلَّمَ ٱلۡقُرۡءَانَ",
    translation: "Taught the Qur'an",
    normalizedText: "علم القرءان",
  },
  {
    verseId: 2,
    name: "الرحمن",
    surahId: 55,
    text: "خَلَقَ ٱلۡإِنسَٰنَ",
    translation: "Created man",
    normalizedText: "خلق الانسن",
  },
  {
    verseId: 3,
    name: "الرحمن",
    surahId: 55,
    text: "عَلَّمَهُ ٱلۡبَيَانَ",
    translation: "[And] taught him eloquence",
    normalizedText: "علمه البيان",
  },
  {
    verseId: 4,
    name: "الرحمن",
    surahId: 55,
    text: "ٱلشَّمۡسُ وَٱلۡقَمَرُ بِحُسۡبَانٖ",
    translation: "The sun and the moon [move] by precise calculation",
    normalizedText: "الشمس والقمر بحسبان",
  },
  {
    verseId: 5,
    name: "الرحمن",
    surahId: 55,
    text: "وَٱلنَّجۡمُ وَٱلشَّجَرُ يَسۡجُدَانِ",
    translation: "And the stars and trees prostrate",
    normalizedText: "والنجم والشجر يسجدان",
  },
  {
    verseId: 6,
    name: "الرحمن",
    surahId: 55,
    text: "وَٱلسَّمَآءَ رَفَعَهَا وَوَضَعَ ٱلۡمِيزَانَ",
    translation: "And the heaven He raised and imposed the balance",
    normalizedText: "والسماء رفعها ووضع الميزان",
  },
  {
    verseId: 7,
    name: "الرحمن",
    surahId: 55,
    text: "أَلَّا تَطۡغَوۡاْ فِي ٱلۡمِيزَانِ",
    translation: "That you not transgress within the balance",
    normalizedText: "الا تطغوا في الميزان",
  },
  {
    verseId: 8,
    name: "الرحمن",
    surahId: 55,
    text: "وَأَقِيمُواْ ٱلۡوَزۡنَ بِٱلۡقِسۡطِ وَلَا تُخۡسِرُواْ ٱلۡمِيزَانَ",
    translation:
      "And establish weight in justice and do not make deficient the balance",
    normalizedText: "واقيموا الوزن بالقسط ولا تخسروا الميزان",
  },
  {
    verseId: 9,
    name: "الرحمن",
    surahId: 55,
    text: "وَٱلۡأَرۡضَ وَضَعَهَا لِلۡأَنَامِ",
    translation: "And the earth He laid [out] for the creatures",
    normalizedText: "والارض وضعها للانام",
  },
  {
    verseId: 10,
    name: "الرحمن",
    surahId: 55,
    text: "فِيهَا فَٰكِهَةٞ وَٱلنَّخۡلُ ذَاتُ ٱلۡأَكۡمَامِ",
    translation: "Therein is fruit and palm trees having sheaths [of dates]",
    normalizedText: "فيها فكهة والنخل ذات الاكمام",
  },
  {
    verseId: 11,
    name: "الرحمن",
    surahId: 55,
    text: "وَٱلۡحَبُّ ذُو ٱلۡعَصۡفِ وَٱلرَّيۡحَانُ",
    translation: "And grain having husks and scented plants",
    normalizedText: "والحب ذو العصف والريحان",
  },
  {
    verseId: 12,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 13,
    name: "الرحمن",
    surahId: 55,
    text: "خَلَقَ ٱلۡإِنسَٰنَ مِن صَلۡصَٰلٖ كَٱلۡفَخَّارِ",
    translation: "He created man from clay like [that of] pottery",
    normalizedText: "خلق الانسن من صلصل كالفخار",
  },
  {
    verseId: 14,
    name: "الرحمن",
    surahId: 55,
    text: "وَخَلَقَ ٱلۡجَآنَّ مِن مَّارِجٖ مِّن نَّارٖ",
    translation: "And He created the jinn from a smokeless flame of fire",
    normalizedText: "وخلق الجان من مارج من نار",
  },
  {
    verseId: 15,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 16,
    name: "الرحمن",
    surahId: 55,
    text: "رَبُّ ٱلۡمَشۡرِقَيۡنِ وَرَبُّ ٱلۡمَغۡرِبَيۡنِ",
    translation: "[He is] Lord of the two sunrises and Lord of the two sunsets",
    normalizedText: "رب المشرقين ورب المغربين",
  },
  {
    verseId: 17,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 18,
    name: "الرحمن",
    surahId: 55,
    text: "مَرَجَ ٱلۡبَحۡرَيۡنِ يَلۡتَقِيَانِ",
    translation: "He released the two seas, meeting [side by side]",
    normalizedText: "مرج البحرين يلتقيان",
  },
  {
    verseId: 19,
    name: "الرحمن",
    surahId: 55,
    text: "بَيۡنَهُمَا بَرۡزَخٞ لَّا يَبۡغِيَانِ",
    translation: "Between them is a barrier [so] neither of them transgresses",
    normalizedText: "بينهما برزخ لا يبغيان",
  },
  {
    verseId: 20,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 21,
    name: "الرحمن",
    surahId: 55,
    text: "يَخۡرُجُ مِنۡهُمَا ٱللُّؤۡلُؤُ وَٱلۡمَرۡجَانُ",
    translation: "From both of them emerge pearl and coral",
    normalizedText: "يخرج منهما اللالا والمرجان",
  },
  {
    verseId: 22,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 23,
    name: "الرحمن",
    surahId: 55,
    text: "وَلَهُ ٱلۡجَوَارِ ٱلۡمُنشَـَٔاتُ فِي ٱلۡبَحۡرِ كَٱلۡأَعۡلَٰمِ",
    translation:
      "And to Him belong the ships [with sails] elevated in the sea like mountains",
    normalizedText: "وله الجوار المنشات في البحر كالاعلم",
  },
  {
    verseId: 24,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 25,
    name: "الرحمن",
    surahId: 55,
    text: "كُلُّ مَنۡ عَلَيۡهَا فَانٖ",
    translation: "Everyone upon the earth will perish",
    normalizedText: "كل من عليها فان",
  },
  {
    verseId: 26,
    name: "الرحمن",
    surahId: 55,
    text: "وَيَبۡقَىٰ وَجۡهُ رَبِّكَ ذُو ٱلۡجَلَٰلِ وَٱلۡإِكۡرَامِ",
    translation:
      "And there will remain the Face of your Lord, Owner of Majesty and Honor",
    normalizedText: "ويبقى وجه ربك ذو الجلل والاكرام",
  },
  {
    verseId: 27,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 28,
    name: "الرحمن",
    surahId: 55,
    text: "يَسۡـَٔلُهُۥ مَن فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ كُلَّ يَوۡمٍ هُوَ فِي شَأۡنٖ",
    translation:
      "Whoever is within the heavens and earth asks Him; every day He is bringing about a matter",
    normalizedText: "يسله من في السموت والارض كل يوم هو في شان",
  },
  {
    verseId: 29,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 30,
    name: "الرحمن",
    surahId: 55,
    text: "سَنَفۡرُغُ لَكُمۡ أَيُّهَ ٱلثَّقَلَانِ",
    translation: "We will attend to you, O prominent beings",
    normalizedText: "سنفرغ لكم ايه الثقلان",
  },
  {
    verseId: 31,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 32,
    name: "الرحمن",
    surahId: 55,
    text: "يَٰمَعۡشَرَ ٱلۡجِنِّ وَٱلۡإِنسِ إِنِ ٱسۡتَطَعۡتُمۡ أَن تَنفُذُواْ مِنۡ أَقۡطَارِ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ فَٱنفُذُواْۚ لَا تَنفُذُونَ إِلَّا بِسُلۡطَٰنٖ",
    translation:
      "O company of jinn and mankind, if you are able to pass beyond the regions of the heavens and the earth, then pass. You will not pass except by authority [from Allah]",
    normalizedText:
      "يمعشر الجن والانس ان استطعتم ان تنفذوا من اقطار السموت والارض فانفذوا لا تنفذون الا بسلطن",
  },
  {
    verseId: 33,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 34,
    name: "الرحمن",
    surahId: 55,
    text: "يُرۡسَلُ عَلَيۡكُمَا شُوَاظٞ مِّن نَّارٖ وَنُحَاسٞ فَلَا تَنتَصِرَانِ",
    translation:
      "There will be sent upon you a flame of fire and smoke, and you will not defend yourselves",
    normalizedText: "يرسل عليكما شواظ من نار ونحاس فلا تنتصران",
  },
  {
    verseId: 35,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 36,
    name: "الرحمن",
    surahId: 55,
    text: "فَإِذَا ٱنشَقَّتِ ٱلسَّمَآءُ فَكَانَتۡ وَرۡدَةٗ كَٱلدِّهَانِ",
    translation:
      "And when the heaven is split open and becomes rose-colored like oil",
    normalizedText: "فاذا انشقت السماء فكانت وردة كالدهان",
  },
  {
    verseId: 37,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 38,
    name: "الرحمن",
    surahId: 55,
    text: "فَيَوۡمَئِذٖ لَّا يُسۡـَٔلُ عَن ذَنۢبِهِۦٓ إِنسٞ وَلَا جَآنّٞ",
    translation:
      "Then on that Day none will be asked about his sin among men or jinn",
    normalizedText: "فيوماذ لا يسل عن ذنبه انس ولا جان",
  },
  {
    verseId: 39,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 40,
    name: "الرحمن",
    surahId: 55,
    text: "يُعۡرَفُ ٱلۡمُجۡرِمُونَ بِسِيمَٰهُمۡ فَيُؤۡخَذُ بِٱلنَّوَٰصِي وَٱلۡأَقۡدَامِ",
    translation:
      "The criminals will be known by their marks, and they will be seized by the forelocks and the feet",
    normalizedText: "يعرف المجرمون بسيمهم فياخذ بالنوصي والاقدام",
  },
  {
    verseId: 41,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 42,
    name: "الرحمن",
    surahId: 55,
    text: "هَٰذِهِۦ جَهَنَّمُ ٱلَّتِي يُكَذِّبُ بِهَا ٱلۡمُجۡرِمُونَ",
    translation: "This is Hell, which the criminals deny",
    normalizedText: "هذه جهنم التي يكذب بها المجرمون",
  },
  {
    verseId: 43,
    name: "الرحمن",
    surahId: 55,
    text: "يَطُوفُونَ بَيۡنَهَا وَبَيۡنَ حَمِيمٍ ءَانٖ",
    translation:
      "They will go around between it and scalding water, heated [to the utmost degree]",
    normalizedText: "يطوفون بينها وبين حميم ءان",
  },
  {
    verseId: 44,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 45,
    name: "الرحمن",
    surahId: 55,
    text: "وَلِمَنۡ خَافَ مَقَامَ رَبِّهِۦ جَنَّتَانِ",
    translation:
      "But for he who has feared the position of his Lord are two gardens",
    normalizedText: "ولمن خاف مقام ربه جنتان",
  },
  {
    verseId: 46,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 47,
    name: "الرحمن",
    surahId: 55,
    text: "ذَوَاتَآ أَفۡنَانٖ",
    translation: "Having [spreading] branches",
    normalizedText: "ذواتا افنان",
  },
  {
    verseId: 48,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 49,
    name: "الرحمن",
    surahId: 55,
    text: "فِيهِمَا عَيۡنَانِ تَجۡرِيَانِ",
    translation: "In both of them are two springs, flowing",
    normalizedText: "فيهما عينان تجريان",
  },
  {
    verseId: 50,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 51,
    name: "الرحمن",
    surahId: 55,
    text: "فِيهِمَا مِن كُلِّ فَٰكِهَةٖ زَوۡجَانِ",
    translation: "In both of them are of every fruit, two kinds",
    normalizedText: "فيهما من كل فكهة زوجان",
  },
  {
    verseId: 52,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 53,
    name: "الرحمن",
    surahId: 55,
    text: "مُتَّكِـِٔينَ عَلَىٰ فُرُشِۭ بَطَآئِنُهَا مِنۡ إِسۡتَبۡرَقٖۚ وَجَنَى ٱلۡجَنَّتَيۡنِ دَانٖ",
    translation:
      "[They are] reclining on beds whose linings are of silk brocade, and the fruit of the two gardens is hanging low",
    normalizedText: "متكين على فرش بطاانها من استبرق وجنى الجنتين دان",
  },
  {
    verseId: 54,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 55,
    name: "الرحمن",
    surahId: 55,
    text: "فِيهِنَّ قَٰصِرَٰتُ ٱلطَّرۡفِ لَمۡ يَطۡمِثۡهُنَّ إِنسٞ قَبۡلَهُمۡ وَلَا جَآنّٞ",
    translation:
      "In them are women limiting [their] glances, untouched before them by man or jinni",
    normalizedText: "فيهن قصرت الطرف لم يطمثهن انس قبلهم ولا جان",
  },
  {
    verseId: 56,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 57,
    name: "الرحمن",
    surahId: 55,
    text: "كَأَنَّهُنَّ ٱلۡيَاقُوتُ وَٱلۡمَرۡجَانُ",
    translation: "As if they were rubies and coral",
    normalizedText: "كانهن الياقوت والمرجان",
  },
  {
    verseId: 58,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 59,
    name: "الرحمن",
    surahId: 55,
    text: "هَلۡ جَزَآءُ ٱلۡإِحۡسَٰنِ إِلَّا ٱلۡإِحۡسَٰنُ",
    translation: "Is the reward for good [anything] but good",
    normalizedText: "هل جزاء الاحسن الا الاحسن",
  },
  {
    verseId: 60,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 61,
    name: "الرحمن",
    surahId: 55,
    text: "وَمِن دُونِهِمَا جَنَّتَانِ",
    translation: "And below them both [in excellence] are two [other] gardens",
    normalizedText: "ومن دونهما جنتان",
  },
  {
    verseId: 62,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 63,
    name: "الرحمن",
    surahId: 55,
    text: "مُدۡهَآمَّتَانِ",
    translation: "Dark green [in color]",
    normalizedText: "مدهامتان",
  },
  {
    verseId: 64,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 65,
    name: "الرحمن",
    surahId: 55,
    text: "فِيهِمَا عَيۡنَانِ نَضَّاخَتَانِ",
    translation: "In both of them are two springs, spouting",
    normalizedText: "فيهما عينان نضاختان",
  },
  {
    verseId: 66,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 67,
    name: "الرحمن",
    surahId: 55,
    text: "فِيهِمَا فَٰكِهَةٞ وَنَخۡلٞ وَرُمَّانٞ",
    translation: "In both of them are fruit and palm trees and pomegranates",
    normalizedText: "فيهما فكهة ونخل ورمان",
  },
  {
    verseId: 68,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 69,
    name: "الرحمن",
    surahId: 55,
    text: "فِيهِنَّ خَيۡرَٰتٌ حِسَانٞ",
    translation: "In them are good and beautiful women",
    normalizedText: "فيهن خيرت حسان",
  },
  {
    verseId: 70,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 71,
    name: "الرحمن",
    surahId: 55,
    text: "حُورٞ مَّقۡصُورَٰتٞ فِي ٱلۡخِيَامِ",
    translation: "Fair ones reserved in pavilions",
    normalizedText: "حور مقصورت في الخيام",
  },
  {
    verseId: 72,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 73,
    name: "الرحمن",
    surahId: 55,
    text: "لَمۡ يَطۡمِثۡهُنَّ إِنسٞ قَبۡلَهُمۡ وَلَا جَآنّٞ",
    translation: "Untouched before them by man or jinni",
    normalizedText: "لم يطمثهن انس قبلهم ولا جان",
  },
  {
    verseId: 74,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 75,
    name: "الرحمن",
    surahId: 55,
    text: "مُتَّكِـِٔينَ عَلَىٰ رَفۡرَفٍ خُضۡرٖ وَعَبۡقَرِيٍّ حِسَانٖ",
    translation: "Reclining on green cushions and beautiful fine carpets",
    normalizedText: "متكين على رفرف خضر وعبقري حسان",
  },
  {
    verseId: 76,
    name: "الرحمن",
    surahId: 55,
    text: "فَبِأَيِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ",
    translation: "So which of the favors of your Lord would you deny",
    normalizedText: "فباي ءالاء ربكما تكذبان",
  },
  {
    verseId: 77,
    name: "الرحمن",
    surahId: 55,
    text: "تَبَٰرَكَ ٱسۡمُ رَبِّكَ ذِي ٱلۡجَلَٰلِ وَٱلۡإِكۡرَامِ",
    translation: "Blessed is the name of your Lord, Owner of Majesty and Honor",
    normalizedText: "تبرك اسم ربك ذي الجلل والاكرام",
  },
  {
    verseId: 0,
    name: "الواقعة",
    surahId: 56,
    text: "إِذَا وَقَعَتِ ٱلۡوَاقِعَةُ",
    translation: "When the Occurrence occurs",
    normalizedText: "اذا وقعت الواقعة",
  },
  {
    verseId: 1,
    name: "الواقعة",
    surahId: 56,
    text: "لَيۡسَ لِوَقۡعَتِهَا كَاذِبَةٌ",
    translation: "There is, at its occurrence, no denial",
    normalizedText: "ليس لوقعتها كاذبة",
  },
  {
    verseId: 2,
    name: "الواقعة",
    surahId: 56,
    text: "خَافِضَةٞ رَّافِعَةٌ",
    translation: "It will bring down [some] and raise up [others]",
    normalizedText: "خافضة رافعة",
  },
  {
    verseId: 3,
    name: "الواقعة",
    surahId: 56,
    text: "إِذَا رُجَّتِ ٱلۡأَرۡضُ رَجّٗا",
    translation: "When the earth is shaken with convulsion",
    normalizedText: "اذا رجت الارض رجا",
  },
  {
    verseId: 4,
    name: "الواقعة",
    surahId: 56,
    text: "وَبُسَّتِ ٱلۡجِبَالُ بَسّٗا",
    translation: "And the mountains are broken down, crumbling",
    normalizedText: "وبست الجبال بسا",
  },
  {
    verseId: 5,
    name: "الواقعة",
    surahId: 56,
    text: "فَكَانَتۡ هَبَآءٗ مُّنۢبَثّٗا",
    translation: "And become dust dispersing",
    normalizedText: "فكانت هباء منبثا",
  },
  {
    verseId: 6,
    name: "الواقعة",
    surahId: 56,
    text: "وَكُنتُمۡ أَزۡوَٰجٗا ثَلَٰثَةٗ",
    translation: "And you become [of] three kinds",
    normalizedText: "وكنتم ازوجا ثلثة",
  },
  {
    verseId: 7,
    name: "الواقعة",
    surahId: 56,
    text: "فَأَصۡحَٰبُ ٱلۡمَيۡمَنَةِ مَآ أَصۡحَٰبُ ٱلۡمَيۡمَنَةِ",
    translation:
      "Then the companions of the right - what are the companions of the right",
    normalizedText: "فاصحب الميمنة ما اصحب الميمنة",
  },
  {
    verseId: 8,
    name: "الواقعة",
    surahId: 56,
    text: "وَأَصۡحَٰبُ ٱلۡمَشۡـَٔمَةِ مَآ أَصۡحَٰبُ ٱلۡمَشۡـَٔمَةِ",
    translation:
      "And the companions of the left - what are the companions of the left",
    normalizedText: "واصحب المشمة ما اصحب المشمة",
  },
  {
    verseId: 9,
    name: "الواقعة",
    surahId: 56,
    text: "وَٱلسَّـٰبِقُونَ ٱلسَّـٰبِقُونَ",
    translation: "And the forerunners, the forerunners",
    normalizedText: "والسبقون السبقون",
  },
  {
    verseId: 10,
    name: "الواقعة",
    surahId: 56,
    text: "أُوْلَـٰٓئِكَ ٱلۡمُقَرَّبُونَ",
    translation: "Those are the ones brought near [to Allah]",
    normalizedText: "اولاك المقربون",
  },
  {
    verseId: 11,
    name: "الواقعة",
    surahId: 56,
    text: "فِي جَنَّـٰتِ ٱلنَّعِيمِ",
    translation: "In the Gardens of Pleasure",
    normalizedText: "في جنت النعيم",
  },
  {
    verseId: 12,
    name: "الواقعة",
    surahId: 56,
    text: "ثُلَّةٞ مِّنَ ٱلۡأَوَّلِينَ",
    translation: "A [large] company of the former peoples",
    normalizedText: "ثلة من الاولين",
  },
  {
    verseId: 13,
    name: "الواقعة",
    surahId: 56,
    text: "وَقَلِيلٞ مِّنَ ٱلۡأٓخِرِينَ",
    translation: "And a few of the later peoples",
    normalizedText: "وقليل من الاخرين",
  },
  {
    verseId: 14,
    name: "الواقعة",
    surahId: 56,
    text: "عَلَىٰ سُرُرٖ مَّوۡضُونَةٖ",
    translation: "On thrones woven [with ornament]",
    normalizedText: "على سرر موضونة",
  },
  {
    verseId: 15,
    name: "الواقعة",
    surahId: 56,
    text: "مُّتَّكِـِٔينَ عَلَيۡهَا مُتَقَٰبِلِينَ",
    translation: "Reclining on them, facing each other",
    normalizedText: "متكين عليها متقبلين",
  },
  {
    verseId: 16,
    name: "الواقعة",
    surahId: 56,
    text: "يَطُوفُ عَلَيۡهِمۡ وِلۡدَٰنٞ مُّخَلَّدُونَ",
    translation: "There will circulate among them young boys made eternal",
    normalizedText: "يطوف عليهم ولدن مخلدون",
  },
  {
    verseId: 17,
    name: "الواقعة",
    surahId: 56,
    text: "بِأَكۡوَابٖ وَأَبَارِيقَ وَكَأۡسٖ مِّن مَّعِينٖ",
    translation:
      "With vessels, pitchers and a cup [of wine] from a flowing spring",
    normalizedText: "باكواب واباريق وكاس من معين",
  },
  {
    verseId: 18,
    name: "الواقعة",
    surahId: 56,
    text: "لَّا يُصَدَّعُونَ عَنۡهَا وَلَا يُنزِفُونَ",
    translation:
      "No headache will they have therefrom, nor will they be intoxicated",
    normalizedText: "لا يصدعون عنها ولا ينزفون",
  },
  {
    verseId: 19,
    name: "الواقعة",
    surahId: 56,
    text: "وَفَٰكِهَةٖ مِّمَّا يَتَخَيَّرُونَ",
    translation: "And fruit of what they select",
    normalizedText: "وفكهة مما يتخيرون",
  },
  {
    verseId: 20,
    name: "الواقعة",
    surahId: 56,
    text: "وَلَحۡمِ طَيۡرٖ مِّمَّا يَشۡتَهُونَ",
    translation: "And the meat of fowl, from whatever they desire",
    normalizedText: "ولحم طير مما يشتهون",
  },
  {
    verseId: 21,
    name: "الواقعة",
    surahId: 56,
    text: "وَحُورٌ عِينٞ",
    translation: "And [for them are] fair women with large, [beautiful] eyes",
    normalizedText: "وحور عين",
  },
  {
    verseId: 22,
    name: "الواقعة",
    surahId: 56,
    text: "كَأَمۡثَٰلِ ٱللُّؤۡلُوِٕ ٱلۡمَكۡنُونِ",
    translation: "The likenesses of pearls well-protected",
    normalizedText: "كامثل اللالو المكنون",
  },
  {
    verseId: 23,
    name: "الواقعة",
    surahId: 56,
    text: "جَزَآءَۢ بِمَا كَانُواْ يَعۡمَلُونَ",
    translation: "As reward for what they used to do",
    normalizedText: "جزاء بما كانوا يعملون",
  },
  {
    verseId: 24,
    name: "الواقعة",
    surahId: 56,
    text: "لَا يَسۡمَعُونَ فِيهَا لَغۡوٗا وَلَا تَأۡثِيمًا",
    translation: "They will not hear therein ill speech or commission of sin",
    normalizedText: "لا يسمعون فيها لغوا ولا تاثيما",
  },
  {
    verseId: 25,
    name: "الواقعة",
    surahId: 56,
    text: "إِلَّا قِيلٗا سَلَٰمٗا سَلَٰمٗا",
    translation: 'Only a saying: "Peace, peace',
    normalizedText: "الا قيلا سلما سلما",
  },
  {
    verseId: 26,
    name: "الواقعة",
    surahId: 56,
    text: "وَأَصۡحَٰبُ ٱلۡيَمِينِ مَآ أَصۡحَٰبُ ٱلۡيَمِينِ",
    translation:
      "The companions of the right - what are the companions of the right",
    normalizedText: "واصحب اليمين ما اصحب اليمين",
  },
  {
    verseId: 27,
    name: "الواقعة",
    surahId: 56,
    text: "فِي سِدۡرٖ مَّخۡضُودٖ",
    translation: "[They will be] among lote trees with thorns removed",
    normalizedText: "في سدر مخضود",
  },
  {
    verseId: 28,
    name: "الواقعة",
    surahId: 56,
    text: "وَطَلۡحٖ مَّنضُودٖ",
    translation: "And [banana] trees layered [with fruit]",
    normalizedText: "وطلح منضود",
  },
  {
    verseId: 29,
    name: "الواقعة",
    surahId: 56,
    text: "وَظِلّٖ مَّمۡدُودٖ",
    translation: "And shade extended",
    normalizedText: "وظل ممدود",
  },
  {
    verseId: 30,
    name: "الواقعة",
    surahId: 56,
    text: "وَمَآءٖ مَّسۡكُوبٖ",
    translation: "And water poured out",
    normalizedText: "وماء مسكوب",
  },
  {
    verseId: 31,
    name: "الواقعة",
    surahId: 56,
    text: "وَفَٰكِهَةٖ كَثِيرَةٖ",
    translation: "And fruit, abundant [and varied]",
    normalizedText: "وفكهة كثيرة",
  },
  {
    verseId: 32,
    name: "الواقعة",
    surahId: 56,
    text: "لَّا مَقۡطُوعَةٖ وَلَا مَمۡنُوعَةٖ",
    translation: "Neither limited [to season] nor forbidden",
    normalizedText: "لا مقطوعة ولا ممنوعة",
  },
  {
    verseId: 33,
    name: "الواقعة",
    surahId: 56,
    text: "وَفُرُشٖ مَّرۡفُوعَةٍ",
    translation: "And [upon] beds raised high",
    normalizedText: "وفرش مرفوعة",
  },
  {
    verseId: 34,
    name: "الواقعة",
    surahId: 56,
    text: "إِنَّآ أَنشَأۡنَٰهُنَّ إِنشَآءٗ",
    translation:
      "Indeed, We have produced the women of Paradise in a [new] creation",
    normalizedText: "انا انشانهن انشاء",
  },
  {
    verseId: 35,
    name: "الواقعة",
    surahId: 56,
    text: "فَجَعَلۡنَٰهُنَّ أَبۡكَارًا",
    translation: "And made them virgins",
    normalizedText: "فجعلنهن ابكارا",
  },
  {
    verseId: 36,
    name: "الواقعة",
    surahId: 56,
    text: "عُرُبًا أَتۡرَابٗا",
    translation: "Devoted [to their husbands] and of equal age",
    normalizedText: "عربا اترابا",
  },
  {
    verseId: 37,
    name: "الواقعة",
    surahId: 56,
    text: "لِّأَصۡحَٰبِ ٱلۡيَمِينِ",
    translation: "For the companions of the right [who are]",
    normalizedText: "لاصحب اليمين",
  },
  {
    verseId: 38,
    name: "الواقعة",
    surahId: 56,
    text: "ثُلَّةٞ مِّنَ ٱلۡأَوَّلِينَ",
    translation: "A company of the former peoples",
    normalizedText: "ثلة من الاولين",
  },
  {
    verseId: 39,
    name: "الواقعة",
    surahId: 56,
    text: "وَثُلَّةٞ مِّنَ ٱلۡأٓخِرِينَ",
    translation: "And a company of the later peoples",
    normalizedText: "وثلة من الاخرين",
  },
  {
    verseId: 40,
    name: "الواقعة",
    surahId: 56,
    text: "وَأَصۡحَٰبُ ٱلشِّمَالِ مَآ أَصۡحَٰبُ ٱلشِّمَالِ",
    translation:
      "And the companions of the left - what are the companions of the left",
    normalizedText: "واصحب الشمال ما اصحب الشمال",
  },
  {
    verseId: 41,
    name: "الواقعة",
    surahId: 56,
    text: "فِي سَمُومٖ وَحَمِيمٖ",
    translation: "[They will be] in scorching fire and scalding water",
    normalizedText: "في سموم وحميم",
  },
  {
    verseId: 42,
    name: "الواقعة",
    surahId: 56,
    text: "وَظِلّٖ مِّن يَحۡمُومٖ",
    translation: "And a shade of black smoke",
    normalizedText: "وظل من يحموم",
  },
  {
    verseId: 43,
    name: "الواقعة",
    surahId: 56,
    text: "لَّا بَارِدٖ وَلَا كَرِيمٍ",
    translation: "Neither cool nor beneficial",
    normalizedText: "لا بارد ولا كريم",
  },
  {
    verseId: 44,
    name: "الواقعة",
    surahId: 56,
    text: "إِنَّهُمۡ كَانُواْ قَبۡلَ ذَٰلِكَ مُتۡرَفِينَ",
    translation: "Indeed they were, before that, indulging in affluence",
    normalizedText: "انهم كانوا قبل ذلك مترفين",
  },
  {
    verseId: 45,
    name: "الواقعة",
    surahId: 56,
    text: "وَكَانُواْ يُصِرُّونَ عَلَى ٱلۡحِنثِ ٱلۡعَظِيمِ",
    translation: "And they used to persist in the great violation",
    normalizedText: "وكانوا يصرون على الحنث العظيم",
  },
  {
    verseId: 46,
    name: "الواقعة",
    surahId: 56,
    text: "وَكَانُواْ يَقُولُونَ أَئِذَا مِتۡنَا وَكُنَّا تُرَابٗا وَعِظَٰمًا أَءِنَّا لَمَبۡعُوثُونَ",
    translation:
      'And they used to say, "When we die and become dust and bones, are we indeed to be resurrected',
    normalizedText: "وكانوا يقولون ااذا متنا وكنا ترابا وعظما اءنا لمبعوثون",
  },
  {
    verseId: 47,
    name: "الواقعة",
    surahId: 56,
    text: "أَوَءَابَآؤُنَا ٱلۡأَوَّلُونَ",
    translation: "And our forefathers [as well]",
    normalizedText: "اوءاباانا الاولون",
  },
  {
    verseId: 48,
    name: "الواقعة",
    surahId: 56,
    text: "قُلۡ إِنَّ ٱلۡأَوَّلِينَ وَٱلۡأٓخِرِينَ",
    translation: 'Say, [O Muhammad], "Indeed, the former and the later peoples',
    normalizedText: "قل ان الاولين والاخرين",
  },
  {
    verseId: 49,
    name: "الواقعة",
    surahId: 56,
    text: "لَمَجۡمُوعُونَ إِلَىٰ مِيقَٰتِ يَوۡمٖ مَّعۡلُومٖ",
    translation:
      "Are to be gathered together for the appointment of a known Day",
    normalizedText: "لمجموعون الى ميقت يوم معلوم",
  },
  {
    verseId: 50,
    name: "الواقعة",
    surahId: 56,
    text: "ثُمَّ إِنَّكُمۡ أَيُّهَا ٱلضَّآلُّونَ ٱلۡمُكَذِّبُونَ",
    translation: "Then indeed you, O those astray [who are] deniers",
    normalizedText: "ثم انكم ايها الضالون المكذبون",
  },
  {
    verseId: 51,
    name: "الواقعة",
    surahId: 56,
    text: "لَأٓكِلُونَ مِن شَجَرٖ مِّن زَقُّومٖ",
    translation: "Will be eating from trees of zaqqum",
    normalizedText: "لاكلون من شجر من زقوم",
  },
  {
    verseId: 52,
    name: "الواقعة",
    surahId: 56,
    text: "فَمَالِـُٔونَ مِنۡهَا ٱلۡبُطُونَ",
    translation: "And filling with it your bellies",
    normalizedText: "فمالون منها البطون",
  },
  {
    verseId: 53,
    name: "الواقعة",
    surahId: 56,
    text: "فَشَٰرِبُونَ عَلَيۡهِ مِنَ ٱلۡحَمِيمِ",
    translation: "And drinking on top of it from scalding water",
    normalizedText: "فشربون عليه من الحميم",
  },
  {
    verseId: 54,
    name: "الواقعة",
    surahId: 56,
    text: "فَشَٰرِبُونَ شُرۡبَ ٱلۡهِيمِ",
    translation: "And will drink as the drinking of thirsty camels",
    normalizedText: "فشربون شرب الهيم",
  },
  {
    verseId: 55,
    name: "الواقعة",
    surahId: 56,
    text: "هَٰذَا نُزُلُهُمۡ يَوۡمَ ٱلدِّينِ",
    translation: "That is their accommodation on the Day of Recompense",
    normalizedText: "هذا نزلهم يوم الدين",
  },
  {
    verseId: 56,
    name: "الواقعة",
    surahId: 56,
    text: "نَحۡنُ خَلَقۡنَٰكُمۡ فَلَوۡلَا تُصَدِّقُونَ",
    translation: "We have created you, so why do you not believe",
    normalizedText: "نحن خلقنكم فلولا تصدقون",
  },
  {
    verseId: 57,
    name: "الواقعة",
    surahId: 56,
    text: "أَفَرَءَيۡتُم مَّا تُمۡنُونَ",
    translation: "Have you seen that which you emit",
    normalizedText: "افرءيتم ما تمنون",
  },
  {
    verseId: 58,
    name: "الواقعة",
    surahId: 56,
    text: "ءَأَنتُمۡ تَخۡلُقُونَهُۥٓ أَمۡ نَحۡنُ ٱلۡخَٰلِقُونَ",
    translation: "Is it you who creates it, or are We the Creator",
    normalizedText: "ءانتم تخلقونه ام نحن الخلقون",
  },
  {
    verseId: 59,
    name: "الواقعة",
    surahId: 56,
    text: "نَحۡنُ قَدَّرۡنَا بَيۡنَكُمُ ٱلۡمَوۡتَ وَمَا نَحۡنُ بِمَسۡبُوقِينَ",
    translation:
      "We have decreed death among you, and We are not to be outdone",
    normalizedText: "نحن قدرنا بينكم الموت وما نحن بمسبوقين",
  },
  {
    verseId: 60,
    name: "الواقعة",
    surahId: 56,
    text: "عَلَىٰٓ أَن نُّبَدِّلَ أَمۡثَٰلَكُمۡ وَنُنشِئَكُمۡ فِي مَا لَا تَعۡلَمُونَ",
    translation:
      "In that We will change your likenesses and produce you in that [form] which you do not know",
    normalizedText: "على ان نبدل امثلكم وننشاكم في ما لا تعلمون",
  },
  {
    verseId: 61,
    name: "الواقعة",
    surahId: 56,
    text: "وَلَقَدۡ عَلِمۡتُمُ ٱلنَّشۡأَةَ ٱلۡأُولَىٰ فَلَوۡلَا تَذَكَّرُونَ",
    translation:
      "And you have already known the first creation, so will you not remember",
    normalizedText: "ولقد علمتم النشاة الاولى فلولا تذكرون",
  },
  {
    verseId: 62,
    name: "الواقعة",
    surahId: 56,
    text: "أَفَرَءَيۡتُم مَّا تَحۡرُثُونَ",
    translation: "And have you seen that [seed] which you sow",
    normalizedText: "افرءيتم ما تحرثون",
  },
  {
    verseId: 63,
    name: "الواقعة",
    surahId: 56,
    text: "ءَأَنتُمۡ تَزۡرَعُونَهُۥٓ أَمۡ نَحۡنُ ٱلزَّـٰرِعُونَ",
    translation: "Is it you who makes it grow, or are We the grower",
    normalizedText: "ءانتم تزرعونه ام نحن الزرعون",
  },
  {
    verseId: 64,
    name: "الواقعة",
    surahId: 56,
    text: "لَوۡ نَشَآءُ لَجَعَلۡنَٰهُ حُطَٰمٗا فَظَلۡتُمۡ تَفَكَّهُونَ",
    translation:
      "If We willed, We could make it [dry] debris, and you would remain in wonder",
    normalizedText: "لو نشاء لجعلنه حطما فظلتم تفكهون",
  },
  {
    verseId: 65,
    name: "الواقعة",
    surahId: 56,
    text: "إِنَّا لَمُغۡرَمُونَ",
    translation: '[Saying], "Indeed, we are [now] in debt',
    normalizedText: "انا لمغرمون",
  },
  {
    verseId: 66,
    name: "الواقعة",
    surahId: 56,
    text: "بَلۡ نَحۡنُ مَحۡرُومُونَ",
    translation: "Rather, we have been deprived",
    normalizedText: "بل نحن محرومون",
  },
  {
    verseId: 67,
    name: "الواقعة",
    surahId: 56,
    text: "أَفَرَءَيۡتُمُ ٱلۡمَآءَ ٱلَّذِي تَشۡرَبُونَ",
    translation: "And have you seen the water that you drink",
    normalizedText: "افرءيتم الماء الذي تشربون",
  },
  {
    verseId: 68,
    name: "الواقعة",
    surahId: 56,
    text: "ءَأَنتُمۡ أَنزَلۡتُمُوهُ مِنَ ٱلۡمُزۡنِ أَمۡ نَحۡنُ ٱلۡمُنزِلُونَ",
    translation:
      "Is it you who brought it down from the clouds, or is it We who bring it down",
    normalizedText: "ءانتم انزلتموه من المزن ام نحن المنزلون",
  },
  {
    verseId: 69,
    name: "الواقعة",
    surahId: 56,
    text: "لَوۡ نَشَآءُ جَعَلۡنَٰهُ أُجَاجٗا فَلَوۡلَا تَشۡكُرُونَ",
    translation:
      "If We willed, We could make it bitter, so why are you not grateful",
    normalizedText: "لو نشاء جعلنه اجاجا فلولا تشكرون",
  },
  {
    verseId: 70,
    name: "الواقعة",
    surahId: 56,
    text: "أَفَرَءَيۡتُمُ ٱلنَّارَ ٱلَّتِي تُورُونَ",
    translation: "And have you seen the fire that you ignite",
    normalizedText: "افرءيتم النار التي تورون",
  },
  {
    verseId: 71,
    name: "الواقعة",
    surahId: 56,
    text: "ءَأَنتُمۡ أَنشَأۡتُمۡ شَجَرَتَهَآ أَمۡ نَحۡنُ ٱلۡمُنشِـُٔونَ",
    translation: "Is it you who produced its tree, or are We the producer",
    normalizedText: "ءانتم انشاتم شجرتها ام نحن المنشون",
  },
  {
    verseId: 72,
    name: "الواقعة",
    surahId: 56,
    text: "نَحۡنُ جَعَلۡنَٰهَا تَذۡكِرَةٗ وَمَتَٰعٗا لِّلۡمُقۡوِينَ",
    translation: "We have made it a reminder and provision for the travelers",
    normalizedText: "نحن جعلنها تذكرة ومتعا للمقوين",
  },
  {
    verseId: 73,
    name: "الواقعة",
    surahId: 56,
    text: "فَسَبِّحۡ بِٱسۡمِ رَبِّكَ ٱلۡعَظِيمِ",
    translation: "So exalt the name of your Lord, the Most Great",
    normalizedText: "فسبح باسم ربك العظيم",
  },
  {
    verseId: 74,
    name: "الواقعة",
    surahId: 56,
    text: "۞فَلَآ أُقۡسِمُ بِمَوَٰقِعِ ٱلنُّجُومِ",
    translation: "Then I swear by the setting of the stars",
    normalizedText: "۞فلا اقسم بموقع النجوم",
  },
  {
    verseId: 75,
    name: "الواقعة",
    surahId: 56,
    text: "وَإِنَّهُۥ لَقَسَمٞ لَّوۡ تَعۡلَمُونَ عَظِيمٌ",
    translation: "And indeed, it is an oath - if you could know - [most] great",
    normalizedText: "وانه لقسم لو تعلمون عظيم",
  },
  {
    verseId: 76,
    name: "الواقعة",
    surahId: 56,
    text: "إِنَّهُۥ لَقُرۡءَانٞ كَرِيمٞ",
    translation: "Indeed, it is a noble Qur'an",
    normalizedText: "انه لقرءان كريم",
  },
  {
    verseId: 77,
    name: "الواقعة",
    surahId: 56,
    text: "فِي كِتَٰبٖ مَّكۡنُونٖ",
    translation: "In a Register well-protected",
    normalizedText: "في كتب مكنون",
  },
  {
    verseId: 78,
    name: "الواقعة",
    surahId: 56,
    text: "لَّا يَمَسُّهُۥٓ إِلَّا ٱلۡمُطَهَّرُونَ",
    translation: "None touch it except the purified",
    normalizedText: "لا يمسه الا المطهرون",
  },
  {
    verseId: 79,
    name: "الواقعة",
    surahId: 56,
    text: "تَنزِيلٞ مِّن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation: "[It is] a revelation from the Lord of the worlds",
    normalizedText: "تنزيل من رب العلمين",
  },
  {
    verseId: 80,
    name: "الواقعة",
    surahId: 56,
    text: "أَفَبِهَٰذَا ٱلۡحَدِيثِ أَنتُم مُّدۡهِنُونَ",
    translation: "Then is it to this statement that you are indifferent",
    normalizedText: "افبهذا الحديث انتم مدهنون",
  },
  {
    verseId: 81,
    name: "الواقعة",
    surahId: 56,
    text: "وَتَجۡعَلُونَ رِزۡقَكُمۡ أَنَّكُمۡ تُكَذِّبُونَ",
    translation:
      "And make [the thanks for] your provision that you deny [the Provider]",
    normalizedText: "وتجعلون رزقكم انكم تكذبون",
  },
  {
    verseId: 82,
    name: "الواقعة",
    surahId: 56,
    text: "فَلَوۡلَآ إِذَا بَلَغَتِ ٱلۡحُلۡقُومَ",
    translation: "Then why, when the soul at death reaches the throat",
    normalizedText: "فلولا اذا بلغت الحلقوم",
  },
  {
    verseId: 83,
    name: "الواقعة",
    surahId: 56,
    text: "وَأَنتُمۡ حِينَئِذٖ تَنظُرُونَ",
    translation: "And you are at that time looking on",
    normalizedText: "وانتم حيناذ تنظرون",
  },
  {
    verseId: 84,
    name: "الواقعة",
    surahId: 56,
    text: "وَنَحۡنُ أَقۡرَبُ إِلَيۡهِ مِنكُمۡ وَلَٰكِن لَّا تُبۡصِرُونَ",
    translation:
      "And Our angels are nearer to him than you, but you do not see",
    normalizedText: "ونحن اقرب اليه منكم ولكن لا تبصرون",
  },
  {
    verseId: 85,
    name: "الواقعة",
    surahId: 56,
    text: "فَلَوۡلَآ إِن كُنتُمۡ غَيۡرَ مَدِينِينَ",
    translation: "Then why do you not, if you are not to be recompensed",
    normalizedText: "فلولا ان كنتم غير مدينين",
  },
  {
    verseId: 86,
    name: "الواقعة",
    surahId: 56,
    text: "تَرۡجِعُونَهَآ إِن كُنتُمۡ صَٰدِقِينَ",
    translation: "Bring it back, if you should be truthful",
    normalizedText: "ترجعونها ان كنتم صدقين",
  },
  {
    verseId: 87,
    name: "الواقعة",
    surahId: 56,
    text: "فَأَمَّآ إِن كَانَ مِنَ ٱلۡمُقَرَّبِينَ",
    translation: "And if the deceased was of those brought near to Allah",
    normalizedText: "فاما ان كان من المقربين",
  },
  {
    verseId: 88,
    name: "الواقعة",
    surahId: 56,
    text: "فَرَوۡحٞ وَرَيۡحَانٞ وَجَنَّتُ نَعِيمٖ",
    translation: "Then [for him is] rest and bounty and a garden of pleasure",
    normalizedText: "فروح وريحان وجنت نعيم",
  },
  {
    verseId: 89,
    name: "الواقعة",
    surahId: 56,
    text: "وَأَمَّآ إِن كَانَ مِنۡ أَصۡحَٰبِ ٱلۡيَمِينِ",
    translation: "And if he was of the companions of the right",
    normalizedText: "واما ان كان من اصحب اليمين",
  },
  {
    verseId: 90,
    name: "الواقعة",
    surahId: 56,
    text: "فَسَلَٰمٞ لَّكَ مِنۡ أَصۡحَٰبِ ٱلۡيَمِينِ",
    translation:
      'Then [the angels will say], "Peace for you; [you are] from the companions of the right',
    normalizedText: "فسلم لك من اصحب اليمين",
  },
  {
    verseId: 91,
    name: "الواقعة",
    surahId: 56,
    text: "وَأَمَّآ إِن كَانَ مِنَ ٱلۡمُكَذِّبِينَ ٱلضَّآلِّينَ",
    translation: "But if he was of the deniers [who were] astray",
    normalizedText: "واما ان كان من المكذبين الضالين",
  },
  {
    verseId: 92,
    name: "الواقعة",
    surahId: 56,
    text: "فَنُزُلٞ مِّنۡ حَمِيمٖ",
    translation: "Then [for him is] accommodation of scalding water",
    normalizedText: "فنزل من حميم",
  },
  {
    verseId: 93,
    name: "الواقعة",
    surahId: 56,
    text: "وَتَصۡلِيَةُ جَحِيمٍ",
    translation: "And burning in Hellfire",
    normalizedText: "وتصلية جحيم",
  },
  {
    verseId: 94,
    name: "الواقعة",
    surahId: 56,
    text: "إِنَّ هَٰذَا لَهُوَ حَقُّ ٱلۡيَقِينِ",
    translation: "Indeed, this is the true certainty",
    normalizedText: "ان هذا لهو حق اليقين",
  },
  {
    verseId: 95,
    name: "الواقعة",
    surahId: 56,
    text: "فَسَبِّحۡ بِٱسۡمِ رَبِّكَ ٱلۡعَظِيمِ",
    translation: "So exalt the name of your Lord, the Most Great",
    normalizedText: "فسبح باسم ربك العظيم",
  },
  {
    verseId: 0,
    name: "الحديد",
    surahId: 57,
    text: "سَبَّحَ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Whatever is in the heavens and earth exalts Allah, and He is the Exalted in Might, the Wise",
    normalizedText: "سبح لله ما في السموت والارض وهو العزيز الحكيم",
  },
  {
    verseId: 1,
    name: "الحديد",
    surahId: 57,
    text: "لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ يُحۡيِۦ وَيُمِيتُۖ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "His is the dominion of the heavens and earth. He gives life and causes death, and He is over all things competent",
    normalizedText: "له ملك السموت والارض يحي ويميت وهو على كل شيء قدير",
  },
  {
    verseId: 2,
    name: "الحديد",
    surahId: 57,
    text: "هُوَ ٱلۡأَوَّلُ وَٱلۡأٓخِرُ وَٱلظَّـٰهِرُ وَٱلۡبَاطِنُۖ وَهُوَ بِكُلِّ شَيۡءٍ عَلِيمٌ",
    translation:
      "He is the First and the Last, the Ascendant and the Intimate, and He is, of all things, Knowing",
    normalizedText: "هو الاول والاخر والظهر والباطن وهو بكل شيء عليم",
  },
  {
    verseId: 3,
    name: "الحديد",
    surahId: 57,
    text: "هُوَ ٱلَّذِي خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ فِي سِتَّةِ أَيَّامٖ ثُمَّ ٱسۡتَوَىٰ عَلَى ٱلۡعَرۡشِۖ يَعۡلَمُ مَا يَلِجُ فِي ٱلۡأَرۡضِ وَمَا يَخۡرُجُ مِنۡهَا وَمَا يَنزِلُ مِنَ ٱلسَّمَآءِ وَمَا يَعۡرُجُ فِيهَاۖ وَهُوَ مَعَكُمۡ أَيۡنَ مَا كُنتُمۡۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      "It is He who created the heavens and earth in six days and then established Himself above the Throne. He knows what penetrates into the earth and what emerges from it and what descends from the heaven and what ascends therein; and He is with you wherever you are. And Allah, of what you do, is Seeing",
    normalizedText:
      "هو الذي خلق السموت والارض في ستة ايام ثم استوى على العرش يعلم ما يلج في الارض وما يخرج منها وما ينزل من السماء وما يعرج فيها وهو معكم اين ما كنتم والله بما تعملون بصير",
  },
  {
    verseId: 4,
    name: "الحديد",
    surahId: 57,
    text: "لَّهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَإِلَى ٱللَّهِ تُرۡجَعُ ٱلۡأُمُورُ",
    translation:
      "His is the dominion of the heavens and earth. And to Allah are returned [all] matters",
    normalizedText: "له ملك السموت والارض والى الله ترجع الامور",
  },
  {
    verseId: 5,
    name: "الحديد",
    surahId: 57,
    text: "يُولِجُ ٱلَّيۡلَ فِي ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِي ٱلَّيۡلِۚ وَهُوَ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "He causes the night to enter the day and causes the day to enter the night, and he is Knowing of that within the breasts",
    normalizedText:
      "يولج اليل في النهار ويولج النهار في اليل وهو عليم بذات الصدور",
  },
  {
    verseId: 6,
    name: "الحديد",
    surahId: 57,
    text: "ءَامِنُواْ بِٱللَّهِ وَرَسُولِهِۦ وَأَنفِقُواْ مِمَّا جَعَلَكُم مُّسۡتَخۡلَفِينَ فِيهِۖ فَٱلَّذِينَ ءَامَنُواْ مِنكُمۡ وَأَنفَقُواْ لَهُمۡ أَجۡرٞ كَبِيرٞ",
    translation:
      "Believe in Allah and His Messenger and spend out of that in which He has made you successors. For those who have believed among you and spent, there will be a great reward",
    normalizedText:
      "ءامنوا بالله ورسوله وانفقوا مما جعلكم مستخلفين فيه فالذين ءامنوا منكم وانفقوا لهم اجر كبير",
  },
  {
    verseId: 7,
    name: "الحديد",
    surahId: 57,
    text: "وَمَا لَكُمۡ لَا تُؤۡمِنُونَ بِٱللَّهِ وَٱلرَّسُولُ يَدۡعُوكُمۡ لِتُؤۡمِنُواْ بِرَبِّكُمۡ وَقَدۡ أَخَذَ مِيثَٰقَكُمۡ إِن كُنتُم مُّؤۡمِنِينَ",
    translation:
      "And why do you not believe in Allah while the Messenger invites you to believe in your Lord and He has taken your covenant, if you should [truly] be believers",
    normalizedText:
      "وما لكم لا تامنون بالله والرسول يدعوكم لتامنوا بربكم وقد اخذ ميثقكم ان كنتم مامنين",
  },
  {
    verseId: 8,
    name: "الحديد",
    surahId: 57,
    text: "هُوَ ٱلَّذِي يُنَزِّلُ عَلَىٰ عَبۡدِهِۦٓ ءَايَٰتِۭ بَيِّنَٰتٖ لِّيُخۡرِجَكُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِۚ وَإِنَّ ٱللَّهَ بِكُمۡ لَرَءُوفٞ رَّحِيمٞ",
    translation:
      "It is He who sends down upon His Servant [Muhammad] verses of clear evidence that He may bring you out from darknesses into the light. And indeed, Allah is to you Kind and Merciful",
    normalizedText:
      "هو الذي ينزل على عبده ءايت بينت ليخرجكم من الظلمت الى النور وان الله بكم لرءوف رحيم",
  },
  {
    verseId: 9,
    name: "الحديد",
    surahId: 57,
    text: "وَمَا لَكُمۡ أَلَّا تُنفِقُواْ فِي سَبِيلِ ٱللَّهِ وَلِلَّهِ مِيرَٰثُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ لَا يَسۡتَوِي مِنكُم مَّنۡ أَنفَقَ مِن قَبۡلِ ٱلۡفَتۡحِ وَقَٰتَلَۚ أُوْلَـٰٓئِكَ أَعۡظَمُ دَرَجَةٗ مِّنَ ٱلَّذِينَ أَنفَقُواْ مِنۢ بَعۡدُ وَقَٰتَلُواْۚ وَكُلّٗا وَعَدَ ٱللَّهُ ٱلۡحُسۡنَىٰۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      "And why do you not spend in the cause of Allah while to Allah belongs the heritage of the heavens and the earth? Not equal among you are those who spent before the conquest [of Makkah] and fought [and those who did so after it]. Those are greater in degree than they who spent afterwards and fought. But to all Allah has promised the best [reward]. And Allah, with what you do, is Acquainted",
    normalizedText:
      "وما لكم الا تنفقوا في سبيل الله ولله ميرث السموت والارض لا يستوي منكم من انفق من قبل الفتح وقتل اولاك اعظم درجة من الذين انفقوا من بعد وقتلوا وكلا وعد الله الحسنى والله بما تعملون خبير",
  },
  {
    verseId: 10,
    name: "الحديد",
    surahId: 57,
    text: "مَّن ذَا ٱلَّذِي يُقۡرِضُ ٱللَّهَ قَرۡضًا حَسَنٗا فَيُضَٰعِفَهُۥ لَهُۥ وَلَهُۥٓ أَجۡرٞ كَرِيمٞ",
    translation:
      "Who is it that would loan Allah a goodly loan so He will multiply it for him and he will have a noble reward",
    normalizedText: "من ذا الذي يقرض الله قرضا حسنا فيضعفه له وله اجر كريم",
  },
  {
    verseId: 11,
    name: "الحديد",
    surahId: 57,
    text: "يَوۡمَ تَرَى ٱلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِ يَسۡعَىٰ نُورُهُم بَيۡنَ أَيۡدِيهِمۡ وَبِأَيۡمَٰنِهِمۖ بُشۡرَىٰكُمُ ٱلۡيَوۡمَ جَنَّـٰتٞ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ ذَٰلِكَ هُوَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      'On the Day you see the believing men and believing women, their light proceeding before them and on their right, [it will be said], "Your good tidings today are [of] gardens beneath which rivers flow, wherein you will abide eternally." That is what is the great attainment',
    normalizedText:
      "يوم ترى المامنين والمامنت يسعى نورهم بين ايديهم وبايمنهم بشرىكم اليوم جنت تجري من تحتها الانهر خلدين فيها ذلك هو الفوز العظيم",
  },
  {
    verseId: 12,
    name: "الحديد",
    surahId: 57,
    text: "يَوۡمَ يَقُولُ ٱلۡمُنَٰفِقُونَ وَٱلۡمُنَٰفِقَٰتُ لِلَّذِينَ ءَامَنُواْ ٱنظُرُونَا نَقۡتَبِسۡ مِن نُّورِكُمۡ قِيلَ ٱرۡجِعُواْ وَرَآءَكُمۡ فَٱلۡتَمِسُواْ نُورٗاۖ فَضُرِبَ بَيۡنَهُم بِسُورٖ لَّهُۥ بَابُۢ بَاطِنُهُۥ فِيهِ ٱلرَّحۡمَةُ وَظَٰهِرُهُۥ مِن قِبَلِهِ ٱلۡعَذَابُ",
    translation:
      'On the [same] Day the hypocrite men and hypocrite women will say to those who believed, "Wait for us that we may acquire some of your light." It will be said, "Go back behind you and seek light." And a wall will be placed between them with a door, its interior containing mercy, but on the outside of it is torment',
    normalizedText:
      "يوم يقول المنفقون والمنفقت للذين ءامنوا انظرونا نقتبس من نوركم قيل ارجعوا وراءكم فالتمسوا نورا فضرب بينهم بسور له باب باطنه فيه الرحمة وظهره من قبله العذاب",
  },
  {
    verseId: 13,
    name: "الحديد",
    surahId: 57,
    text: "يُنَادُونَهُمۡ أَلَمۡ نَكُن مَّعَكُمۡۖ قَالُواْ بَلَىٰ وَلَٰكِنَّكُمۡ فَتَنتُمۡ أَنفُسَكُمۡ وَتَرَبَّصۡتُمۡ وَٱرۡتَبۡتُمۡ وَغَرَّتۡكُمُ ٱلۡأَمَانِيُّ حَتَّىٰ جَآءَ أَمۡرُ ٱللَّهِ وَغَرَّكُم بِٱللَّهِ ٱلۡغَرُورُ",
    translation:
      'The hypocrites will call to the believers, "Were we not with you?" They will say, "Yes, but you afflicted yourselves and awaited [misfortune for us] and doubted, and wishful thinking deluded you until there came the command of Allah. And the Deceiver deceived you concerning Allah',
    normalizedText:
      "ينادونهم الم نكن معكم قالوا بلى ولكنكم فتنتم انفسكم وتربصتم وارتبتم وغرتكم الاماني حتى جاء امر الله وغركم بالله الغرور",
  },
  {
    verseId: 14,
    name: "الحديد",
    surahId: 57,
    text: "فَٱلۡيَوۡمَ لَا يُؤۡخَذُ مِنكُمۡ فِدۡيَةٞ وَلَا مِنَ ٱلَّذِينَ كَفَرُواْۚ مَأۡوَىٰكُمُ ٱلنَّارُۖ هِيَ مَوۡلَىٰكُمۡۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "So today no ransom will be taken from you or from those who disbelieved. Your refuge is the Fire. It is most worthy of you, and wretched is the destination",
    normalizedText:
      "فاليوم لا ياخذ منكم فدية ولا من الذين كفروا ماوىكم النار هي مولىكم وباس المصير",
  },
  {
    verseId: 15,
    name: "الحديد",
    surahId: 57,
    text: "۞أَلَمۡ يَأۡنِ لِلَّذِينَ ءَامَنُوٓاْ أَن تَخۡشَعَ قُلُوبُهُمۡ لِذِكۡرِ ٱللَّهِ وَمَا نَزَلَ مِنَ ٱلۡحَقِّ وَلَا يَكُونُواْ كَٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ مِن قَبۡلُ فَطَالَ عَلَيۡهِمُ ٱلۡأَمَدُ فَقَسَتۡ قُلُوبُهُمۡۖ وَكَثِيرٞ مِّنۡهُمۡ فَٰسِقُونَ",
    translation:
      "Has the time not come for those who have believed that their hearts should become humbly submissive at the remembrance of Allah and what has come down of the truth? And let them not be like those who were given the Scripture before, and a long period passed over them, so their hearts hardened; and many of them are defiantly disobedient",
    normalizedText:
      "۞الم يان للذين ءامنوا ان تخشع قلوبهم لذكر الله وما نزل من الحق ولا يكونوا كالذين اوتوا الكتب من قبل فطال عليهم الامد فقست قلوبهم وكثير منهم فسقون",
  },
  {
    verseId: 16,
    name: "الحديد",
    surahId: 57,
    text: "ٱعۡلَمُوٓاْ أَنَّ ٱللَّهَ يُحۡيِ ٱلۡأَرۡضَ بَعۡدَ مَوۡتِهَاۚ قَدۡ بَيَّنَّا لَكُمُ ٱلۡأٓيَٰتِ لَعَلَّكُمۡ تَعۡقِلُونَ",
    translation:
      "Know that Allah gives life to the earth after its lifelessness. We have made clear to you the signs; perhaps you will understand",
    normalizedText:
      "اعلموا ان الله يحي الارض بعد موتها قد بينا لكم الايت لعلكم تعقلون",
  },
  {
    verseId: 17,
    name: "الحديد",
    surahId: 57,
    text: "إِنَّ ٱلۡمُصَّدِّقِينَ وَٱلۡمُصَّدِّقَٰتِ وَأَقۡرَضُواْ ٱللَّهَ قَرۡضًا حَسَنٗا يُضَٰعَفُ لَهُمۡ وَلَهُمۡ أَجۡرٞ كَرِيمٞ",
    translation:
      "Indeed, the men who practice charity and the women who practice charity and [they who] have loaned Allah a goodly loan - it will be multiplied for them, and they will have a noble reward",
    normalizedText:
      "ان المصدقين والمصدقت واقرضوا الله قرضا حسنا يضعف لهم ولهم اجر كريم",
  },
  {
    verseId: 18,
    name: "الحديد",
    surahId: 57,
    text: "وَٱلَّذِينَ ءَامَنُواْ بِٱللَّهِ وَرُسُلِهِۦٓ أُوْلَـٰٓئِكَ هُمُ ٱلصِّدِّيقُونَۖ وَٱلشُّهَدَآءُ عِندَ رَبِّهِمۡ لَهُمۡ أَجۡرُهُمۡ وَنُورُهُمۡۖ وَٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِـَٔايَٰتِنَآ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡجَحِيمِ",
    translation:
      "And those who have believed in Allah and His messengers - those are [in the ranks of] the supporters of truth and the martyrs, with their Lord. For them is their reward and their light. But those who have disbelieved and denied Our verses - those are the companions of Hellfire",
    normalizedText:
      "والذين ءامنوا بالله ورسله اولاك هم الصديقون والشهداء عند ربهم لهم اجرهم ونورهم والذين كفروا وكذبوا بايتنا اولاك اصحب الجحيم",
  },
  {
    verseId: 19,
    name: "الحديد",
    surahId: 57,
    text: "ٱعۡلَمُوٓاْ أَنَّمَا ٱلۡحَيَوٰةُ ٱلدُّنۡيَا لَعِبٞ وَلَهۡوٞ وَزِينَةٞ وَتَفَاخُرُۢ بَيۡنَكُمۡ وَتَكَاثُرٞ فِي ٱلۡأَمۡوَٰلِ وَٱلۡأَوۡلَٰدِۖ كَمَثَلِ غَيۡثٍ أَعۡجَبَ ٱلۡكُفَّارَ نَبَاتُهُۥ ثُمَّ يَهِيجُ فَتَرَىٰهُ مُصۡفَرّٗا ثُمَّ يَكُونُ حُطَٰمٗاۖ وَفِي ٱلۡأٓخِرَةِ عَذَابٞ شَدِيدٞ وَمَغۡفِرَةٞ مِّنَ ٱللَّهِ وَرِضۡوَٰنٞۚ وَمَا ٱلۡحَيَوٰةُ ٱلدُّنۡيَآ إِلَّا مَتَٰعُ ٱلۡغُرُورِ",
    translation:
      "Know that the life of this world is but amusement and diversion and adornment and boasting to one another and competition in increase of wealth and children - like the example of a rain whose [resulting] plant growth pleases the tillers; then it dries and you see it turned yellow; then it becomes [scattered] debris. And in the Hereafter is severe punishment and forgiveness from Allah and approval. And what is the worldly life except the enjoyment of delusion",
    normalizedText:
      "اعلموا انما الحيوة الدنيا لعب ولهو وزينة وتفاخر بينكم وتكاثر في الامول والاولد كمثل غيث اعجب الكفار نباته ثم يهيج فترىه مصفرا ثم يكون حطما وفي الاخرة عذاب شديد ومغفرة من الله ورضون وما الحيوة الدنيا الا متع الغرور",
  },
  {
    verseId: 20,
    name: "الحديد",
    surahId: 57,
    text: "سَابِقُوٓاْ إِلَىٰ مَغۡفِرَةٖ مِّن رَّبِّكُمۡ وَجَنَّةٍ عَرۡضُهَا كَعَرۡضِ ٱلسَّمَآءِ وَٱلۡأَرۡضِ أُعِدَّتۡ لِلَّذِينَ ءَامَنُواْ بِٱللَّهِ وَرُسُلِهِۦۚ ذَٰلِكَ فَضۡلُ ٱللَّهِ يُؤۡتِيهِ مَن يَشَآءُۚ وَٱللَّهُ ذُو ٱلۡفَضۡلِ ٱلۡعَظِيمِ",
    translation:
      "Race toward forgiveness from your Lord and a Garden whose width is like the width of the heavens and earth, prepared for those who believed in Allah and His messengers. That is the bounty of Allah which He gives to whom He wills, and Allah is the possessor of great bounty",
    normalizedText:
      "سابقوا الى مغفرة من ربكم وجنة عرضها كعرض السماء والارض اعدت للذين ءامنوا بالله ورسله ذلك فضل الله ياتيه من يشاء والله ذو الفضل العظيم",
  },
  {
    verseId: 21,
    name: "الحديد",
    surahId: 57,
    text: "مَآ أَصَابَ مِن مُّصِيبَةٖ فِي ٱلۡأَرۡضِ وَلَا فِيٓ أَنفُسِكُمۡ إِلَّا فِي كِتَٰبٖ مِّن قَبۡلِ أَن نَّبۡرَأَهَآۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٞ",
    translation:
      "No disaster strikes upon the earth or among yourselves except that it is in a register before We bring it into being - indeed that, for Allah, is easy",
    normalizedText:
      "ما اصاب من مصيبة في الارض ولا في انفسكم الا في كتب من قبل ان نبراها ان ذلك على الله يسير",
  },
  {
    verseId: 22,
    name: "الحديد",
    surahId: 57,
    text: "لِّكَيۡلَا تَأۡسَوۡاْ عَلَىٰ مَا فَاتَكُمۡ وَلَا تَفۡرَحُواْ بِمَآ ءَاتَىٰكُمۡۗ وَٱللَّهُ لَا يُحِبُّ كُلَّ مُخۡتَالٖ فَخُورٍ",
    translation:
      "In order that you not despair over what has eluded you and not exult [in pride] over what He has given you. And Allah does not like everyone self-deluded and boastful",
    normalizedText:
      "لكيلا تاسوا على ما فاتكم ولا تفرحوا بما ءاتىكم والله لا يحب كل مختال فخور",
  },
  {
    verseId: 23,
    name: "الحديد",
    surahId: 57,
    text: "ٱلَّذِينَ يَبۡخَلُونَ وَيَأۡمُرُونَ ٱلنَّاسَ بِٱلۡبُخۡلِۗ وَمَن يَتَوَلَّ فَإِنَّ ٱللَّهَ هُوَ ٱلۡغَنِيُّ ٱلۡحَمِيدُ",
    translation:
      "[Those] who are stingy and enjoin upon people stinginess. And whoever turns away - then indeed, Allah is the Free of need, the Praiseworthy",
    normalizedText:
      "الذين يبخلون ويامرون الناس بالبخل ومن يتول فان الله هو الغني الحميد",
  },
  {
    verseId: 24,
    name: "الحديد",
    surahId: 57,
    text: "لَقَدۡ أَرۡسَلۡنَا رُسُلَنَا بِٱلۡبَيِّنَٰتِ وَأَنزَلۡنَا مَعَهُمُ ٱلۡكِتَٰبَ وَٱلۡمِيزَانَ لِيَقُومَ ٱلنَّاسُ بِٱلۡقِسۡطِۖ وَأَنزَلۡنَا ٱلۡحَدِيدَ فِيهِ بَأۡسٞ شَدِيدٞ وَمَنَٰفِعُ لِلنَّاسِ وَلِيَعۡلَمَ ٱللَّهُ مَن يَنصُرُهُۥ وَرُسُلَهُۥ بِٱلۡغَيۡبِۚ إِنَّ ٱللَّهَ قَوِيٌّ عَزِيزٞ",
    translation:
      "We have already sent Our messengers with clear evidences and sent down with them the Scripture and the balance that the people may maintain [their affairs] in justice. And We sent down iron, wherein is great military might and benefits for the people, and so that Allah may make evident those who support Him and His messengers unseen. Indeed, Allah is Powerful and Exalted in Might",
    normalizedText:
      "لقد ارسلنا رسلنا بالبينت وانزلنا معهم الكتب والميزان ليقوم الناس بالقسط وانزلنا الحديد فيه باس شديد ومنفع للناس وليعلم الله من ينصره ورسله بالغيب ان الله قوي عزيز",
  },
  {
    verseId: 25,
    name: "الحديد",
    surahId: 57,
    text: "وَلَقَدۡ أَرۡسَلۡنَا نُوحٗا وَإِبۡرَٰهِيمَ وَجَعَلۡنَا فِي ذُرِّيَّتِهِمَا ٱلنُّبُوَّةَ وَٱلۡكِتَٰبَۖ فَمِنۡهُم مُّهۡتَدٖۖ وَكَثِيرٞ مِّنۡهُمۡ فَٰسِقُونَ",
    translation:
      "And We have already sent Noah and Abraham and placed in their descendants prophethood and scripture; and among them is he who is guided, but many of them are defiantly disobedient",
    normalizedText:
      "ولقد ارسلنا نوحا وابرهيم وجعلنا في ذريتهما النبوة والكتب فمنهم مهتد وكثير منهم فسقون",
  },
  {
    verseId: 26,
    name: "الحديد",
    surahId: 57,
    text: "ثُمَّ قَفَّيۡنَا عَلَىٰٓ ءَاثَٰرِهِم بِرُسُلِنَا وَقَفَّيۡنَا بِعِيسَى ٱبۡنِ مَرۡيَمَ وَءَاتَيۡنَٰهُ ٱلۡإِنجِيلَۖ وَجَعَلۡنَا فِي قُلُوبِ ٱلَّذِينَ ٱتَّبَعُوهُ رَأۡفَةٗ وَرَحۡمَةٗۚ وَرَهۡبَانِيَّةً ٱبۡتَدَعُوهَا مَا كَتَبۡنَٰهَا عَلَيۡهِمۡ إِلَّا ٱبۡتِغَآءَ رِضۡوَٰنِ ٱللَّهِ فَمَا رَعَوۡهَا حَقَّ رِعَايَتِهَاۖ فَـَٔاتَيۡنَا ٱلَّذِينَ ءَامَنُواْ مِنۡهُمۡ أَجۡرَهُمۡۖ وَكَثِيرٞ مِّنۡهُمۡ فَٰسِقُونَ",
    translation:
      "Then We sent following their footsteps Our messengers and followed [them] with Jesus, the son of Mary, and gave him the Gospel. And We placed in the hearts of those who followed him compassion and mercy and monasticism, which they innovated; We did not prescribe it for them except [that they did so] seeking the approval of Allah. But they did not observe it with due observance. So We gave the ones who believed among them their reward, but many of them are defiantly disobedient",
    normalizedText:
      "ثم قفينا على ءاثرهم برسلنا وقفينا بعيسى ابن مريم وءاتينه الانجيل وجعلنا في قلوب الذين اتبعوه رافة ورحمة ورهبانية ابتدعوها ما كتبنها عليهم الا ابتغاء رضون الله فما رعوها حق رعايتها فاتينا الذين ءامنوا منهم اجرهم وكثير منهم فسقون",
  },
  {
    verseId: 27,
    name: "الحديد",
    surahId: 57,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ ٱللَّهَ وَءَامِنُواْ بِرَسُولِهِۦ يُؤۡتِكُمۡ كِفۡلَيۡنِ مِن رَّحۡمَتِهِۦ وَيَجۡعَل لَّكُمۡ نُورٗا تَمۡشُونَ بِهِۦ وَيَغۡفِرۡ لَكُمۡۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "O you who have believed, fear Allah and believe in His Messenger; He will [then] give you a double portion of His mercy and make for you a light by which you will walk and forgive you; and Allah is Forgiving and Merciful",
    normalizedText:
      "يايها الذين ءامنوا اتقوا الله وءامنوا برسوله ياتكم كفلين من رحمته ويجعل لكم نورا تمشون به ويغفر لكم والله غفور رحيم",
  },
  {
    verseId: 28,
    name: "الحديد",
    surahId: 57,
    text: "لِّئَلَّا يَعۡلَمَ أَهۡلُ ٱلۡكِتَٰبِ أَلَّا يَقۡدِرُونَ عَلَىٰ شَيۡءٖ مِّن فَضۡلِ ٱللَّهِ وَأَنَّ ٱلۡفَضۡلَ بِيَدِ ٱللَّهِ يُؤۡتِيهِ مَن يَشَآءُۚ وَٱللَّهُ ذُو ٱلۡفَضۡلِ ٱلۡعَظِيمِ",
    translation:
      "[This is] so that the People of the Scripture may know that they are not able [to obtain] anything from the bounty of Allah and that [all] bounty is in the hand of Allah; He gives it to whom He wills. And Allah is the possessor of great bounty",
    normalizedText:
      "لالا يعلم اهل الكتب الا يقدرون على شيء من فضل الله وان الفضل بيد الله ياتيه من يشاء والله ذو الفضل العظيم",
  },
  {
    verseId: 0,
    name: "المجادلة",
    surahId: 58,
    text: "قَدۡ سَمِعَ ٱللَّهُ قَوۡلَ ٱلَّتِي تُجَٰدِلُكَ فِي زَوۡجِهَا وَتَشۡتَكِيٓ إِلَى ٱللَّهِ وَٱللَّهُ يَسۡمَعُ تَحَاوُرَكُمَآۚ إِنَّ ٱللَّهَ سَمِيعُۢ بَصِيرٌ",
    translation:
      "Certainly has Allah heard the speech of the one who argues with you, [O Muhammad], concerning her husband and directs her complaint to Allah. And Allah hears your dialogue; indeed, Allah is Hearing and Seeing",
    normalizedText:
      "قد سمع الله قول التي تجدلك في زوجها وتشتكي الى الله والله يسمع تحاوركما ان الله سميع بصير",
  },
  {
    verseId: 1,
    name: "المجادلة",
    surahId: 58,
    text: "ٱلَّذِينَ يُظَٰهِرُونَ مِنكُم مِّن نِّسَآئِهِم مَّا هُنَّ أُمَّهَٰتِهِمۡۖ إِنۡ أُمَّهَٰتُهُمۡ إِلَّا ٱلَّـٰٓـِٔي وَلَدۡنَهُمۡۚ وَإِنَّهُمۡ لَيَقُولُونَ مُنكَرٗا مِّنَ ٱلۡقَوۡلِ وَزُورٗاۚ وَإِنَّ ٱللَّهَ لَعَفُوٌّ غَفُورٞ",
    translation:
      "Those who pronounce thihar among you [to separate] from their wives - they are not [consequently] their mothers. Their mothers are none but those who gave birth to them. And indeed, they are saying an objectionable statement and a falsehood. But indeed, Allah is Pardoning and Forgiving",
    normalizedText:
      "الذين يظهرون منكم من نسااهم ما هن امهتهم ان امهتهم الا الي ولدنهم وانهم ليقولون منكرا من القول وزورا وان الله لعفو غفور",
  },
  {
    verseId: 2,
    name: "المجادلة",
    surahId: 58,
    text: "وَٱلَّذِينَ يُظَٰهِرُونَ مِن نِّسَآئِهِمۡ ثُمَّ يَعُودُونَ لِمَا قَالُواْ فَتَحۡرِيرُ رَقَبَةٖ مِّن قَبۡلِ أَن يَتَمَآسَّاۚ ذَٰلِكُمۡ تُوعَظُونَ بِهِۦۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      "And those who pronounce thihar from their wives and then [wish to] go back on what they said - then [there must be] the freeing of a slave before they touch one another. That is what you are admonished thereby; and Allah is Acquainted with what you do",
    normalizedText:
      "والذين يظهرون من نسااهم ثم يعودون لما قالوا فتحرير رقبة من قبل ان يتماسا ذلكم توعظون به والله بما تعملون خبير",
  },
  {
    verseId: 3,
    name: "المجادلة",
    surahId: 58,
    text: "فَمَن لَّمۡ يَجِدۡ فَصِيَامُ شَهۡرَيۡنِ مُتَتَابِعَيۡنِ مِن قَبۡلِ أَن يَتَمَآسَّاۖ فَمَن لَّمۡ يَسۡتَطِعۡ فَإِطۡعَامُ سِتِّينَ مِسۡكِينٗاۚ ذَٰلِكَ لِتُؤۡمِنُواْ بِٱللَّهِ وَرَسُولِهِۦۚ وَتِلۡكَ حُدُودُ ٱللَّهِۗ وَلِلۡكَٰفِرِينَ عَذَابٌ أَلِيمٌ",
    translation:
      "And he who does not find [a slave] - then a fast for two months consecutively before they touch one another; and he who is unable - then the feeding of sixty poor persons. That is for you to believe [completely] in Allah and His Messenger; and those are the limits [set by] Allah. And for the disbelievers is a painful punishment",
    normalizedText:
      "فمن لم يجد فصيام شهرين متتابعين من قبل ان يتماسا فمن لم يستطع فاطعام ستين مسكينا ذلك لتامنوا بالله ورسوله وتلك حدود الله وللكفرين عذاب اليم",
  },
  {
    verseId: 4,
    name: "المجادلة",
    surahId: 58,
    text: "إِنَّ ٱلَّذِينَ يُحَآدُّونَ ٱللَّهَ وَرَسُولَهُۥ كُبِتُواْ كَمَا كُبِتَ ٱلَّذِينَ مِن قَبۡلِهِمۡۚ وَقَدۡ أَنزَلۡنَآ ءَايَٰتِۭ بَيِّنَٰتٖۚ وَلِلۡكَٰفِرِينَ عَذَابٞ مُّهِينٞ",
    translation:
      "Indeed, those who oppose Allah and His Messenger are abased as those before them were abased. And We have certainly sent down verses of clear evidence. And for the disbelievers is a humiliating punishment",
    normalizedText:
      "ان الذين يحادون الله ورسوله كبتوا كما كبت الذين من قبلهم وقد انزلنا ءايت بينت وللكفرين عذاب مهين",
  },
  {
    verseId: 5,
    name: "المجادلة",
    surahId: 58,
    text: "يَوۡمَ يَبۡعَثُهُمُ ٱللَّهُ جَمِيعٗا فَيُنَبِّئُهُم بِمَا عَمِلُوٓاْۚ أَحۡصَىٰهُ ٱللَّهُ وَنَسُوهُۚ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدٌ",
    translation:
      "On the Day when Allah will resurrect them all and inform them of what they did. Allah had enumerated it, while they forgot it; and Allah is, over all things, Witness",
    normalizedText:
      "يوم يبعثهم الله جميعا فينباهم بما عملوا احصىه الله ونسوه والله على كل شيء شهيد",
  },
  {
    verseId: 6,
    name: "المجادلة",
    surahId: 58,
    text: "أَلَمۡ تَرَ أَنَّ ٱللَّهَ يَعۡلَمُ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ مَا يَكُونُ مِن نَّجۡوَىٰ ثَلَٰثَةٍ إِلَّا هُوَ رَابِعُهُمۡ وَلَا خَمۡسَةٍ إِلَّا هُوَ سَادِسُهُمۡ وَلَآ أَدۡنَىٰ مِن ذَٰلِكَ وَلَآ أَكۡثَرَ إِلَّا هُوَ مَعَهُمۡ أَيۡنَ مَا كَانُواْۖ ثُمَّ يُنَبِّئُهُم بِمَا عَمِلُواْ يَوۡمَ ٱلۡقِيَٰمَةِۚ إِنَّ ٱللَّهَ بِكُلِّ شَيۡءٍ عَلِيمٌ",
    translation:
      "Have you not considered that Allah knows what is in the heavens and what is on the earth? There is in no private conversation three but that He is the fourth of them, nor are there five but that He is the sixth of them - and no less than that and no more except that He is with them [in knowledge] wherever they are. Then He will inform them of what they did, on the Day of Resurrection. Indeed Allah is, of all things, Knowing",
    normalizedText:
      "الم تر ان الله يعلم ما في السموت وما في الارض ما يكون من نجوى ثلثة الا هو رابعهم ولا خمسة الا هو سادسهم ولا ادنى من ذلك ولا اكثر الا هو معهم اين ما كانوا ثم ينباهم بما عملوا يوم القيمة ان الله بكل شيء عليم",
  },
  {
    verseId: 7,
    name: "المجادلة",
    surahId: 58,
    text: "أَلَمۡ تَرَ إِلَى ٱلَّذِينَ نُهُواْ عَنِ ٱلنَّجۡوَىٰ ثُمَّ يَعُودُونَ لِمَا نُهُواْ عَنۡهُ وَيَتَنَٰجَوۡنَ بِٱلۡإِثۡمِ وَٱلۡعُدۡوَٰنِ وَمَعۡصِيَتِ ٱلرَّسُولِۖ وَإِذَا جَآءُوكَ حَيَّوۡكَ بِمَا لَمۡ يُحَيِّكَ بِهِ ٱللَّهُ وَيَقُولُونَ فِيٓ أَنفُسِهِمۡ لَوۡلَا يُعَذِّبُنَا ٱللَّهُ بِمَا نَقُولُۚ حَسۡبُهُمۡ جَهَنَّمُ يَصۡلَوۡنَهَاۖ فَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      'Have you not considered those who were forbidden from private conversation, then they return to that which they were forbidden and converse among themselves about sin and aggression and disobedience to the Messenger? And when they come to you, they greet you with that [word] by which Allah does not greet you and say among themselves, "Why does Allah not punish us for what we say?" Sufficient for them is Hell, which they will [enter to] burn, and wretched is the destination',
    normalizedText:
      "الم تر الى الذين نهوا عن النجوى ثم يعودون لما نهوا عنه ويتنجون بالاثم والعدون ومعصيت الرسول واذا جاءوك حيوك بما لم يحيك به الله ويقولون في انفسهم لولا يعذبنا الله بما نقول حسبهم جهنم يصلونها فباس المصير",
  },
  {
    verseId: 8,
    name: "المجادلة",
    surahId: 58,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا تَنَٰجَيۡتُمۡ فَلَا تَتَنَٰجَوۡاْ بِٱلۡإِثۡمِ وَٱلۡعُدۡوَٰنِ وَمَعۡصِيَتِ ٱلرَّسُولِ وَتَنَٰجَوۡاْ بِٱلۡبِرِّ وَٱلتَّقۡوَىٰۖ وَٱتَّقُواْ ٱللَّهَ ٱلَّذِيٓ إِلَيۡهِ تُحۡشَرُونَ",
    translation:
      "O you who have believed, when you converse privately, do not converse about sin and aggression and disobedience to the Messenger but converse about righteousness and piety. And fear Allah, to whom you will be gathered",
    normalizedText:
      "يايها الذين ءامنوا اذا تنجيتم فلا تتنجوا بالاثم والعدون ومعصيت الرسول وتنجوا بالبر والتقوى واتقوا الله الذي اليه تحشرون",
  },
  {
    verseId: 9,
    name: "المجادلة",
    surahId: 58,
    text: "إِنَّمَا ٱلنَّجۡوَىٰ مِنَ ٱلشَّيۡطَٰنِ لِيَحۡزُنَ ٱلَّذِينَ ءَامَنُواْ وَلَيۡسَ بِضَآرِّهِمۡ شَيۡـًٔا إِلَّا بِإِذۡنِ ٱللَّهِۚ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُؤۡمِنُونَ",
    translation:
      "Private conversation is only from Satan that he may grieve those who have believed, but he will not harm them at all except by permission of Allah. And upon Allah let the believers rely",
    normalizedText:
      "انما النجوى من الشيطن ليحزن الذين ءامنوا وليس بضارهم شيا الا باذن الله وعلى الله فليتوكل المامنون",
  },
  {
    verseId: 10,
    name: "المجادلة",
    surahId: 58,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا قِيلَ لَكُمۡ تَفَسَّحُواْ فِي ٱلۡمَجَٰلِسِ فَٱفۡسَحُواْ يَفۡسَحِ ٱللَّهُ لَكُمۡۖ وَإِذَا قِيلَ ٱنشُزُواْ فَٱنشُزُواْ يَرۡفَعِ ٱللَّهُ ٱلَّذِينَ ءَامَنُواْ مِنكُمۡ وَٱلَّذِينَ أُوتُواْ ٱلۡعِلۡمَ دَرَجَٰتٖۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      'O you who have believed, when you are told, "Space yourselves" in assemblies, then make space; Allah will make space for you. And when you are told, "Arise," then arise; Allah will raise those who have believed among you and those who were given knowledge, by degrees. And Allah is Acquainted with what you do',
    normalizedText:
      "يايها الذين ءامنوا اذا قيل لكم تفسحوا في المجلس فافسحوا يفسح الله لكم واذا قيل انشزوا فانشزوا يرفع الله الذين ءامنوا منكم والذين اوتوا العلم درجت والله بما تعملون خبير",
  },
  {
    verseId: 11,
    name: "المجادلة",
    surahId: 58,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا نَٰجَيۡتُمُ ٱلرَّسُولَ فَقَدِّمُواْ بَيۡنَ يَدَيۡ نَجۡوَىٰكُمۡ صَدَقَةٗۚ ذَٰلِكَ خَيۡرٞ لَّكُمۡ وَأَطۡهَرُۚ فَإِن لَّمۡ تَجِدُواْ فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٌ",
    translation:
      "O you who have believed, when you [wish to] privately consult the Messenger, present before your consultation a charity. That is better for you and purer. But if you find not [the means] - then indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "يايها الذين ءامنوا اذا نجيتم الرسول فقدموا بين يدي نجوىكم صدقة ذلك خير لكم واطهر فان لم تجدوا فان الله غفور رحيم",
  },
  {
    verseId: 12,
    name: "المجادلة",
    surahId: 58,
    text: "ءَأَشۡفَقۡتُمۡ أَن تُقَدِّمُواْ بَيۡنَ يَدَيۡ نَجۡوَىٰكُمۡ صَدَقَٰتٖۚ فَإِذۡ لَمۡ تَفۡعَلُواْ وَتَابَ ٱللَّهُ عَلَيۡكُمۡ فَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَ وَأَطِيعُواْ ٱللَّهَ وَرَسُولَهُۥۚ وَٱللَّهُ خَبِيرُۢ بِمَا تَعۡمَلُونَ",
    translation:
      "Have you feared to present before your consultation charities? Then when you do not and Allah has forgiven you, then [at least] establish prayer and give zakah and obey Allah and His Messenger. And Allah is Acquainted with what you do",
    normalizedText:
      "ءاشفقتم ان تقدموا بين يدي نجوىكم صدقت فاذ لم تفعلوا وتاب الله عليكم فاقيموا الصلوة وءاتوا الزكوة واطيعوا الله ورسوله والله خبير بما تعملون",
  },
  {
    verseId: 13,
    name: "المجادلة",
    surahId: 58,
    text: "۞أَلَمۡ تَرَ إِلَى ٱلَّذِينَ تَوَلَّوۡاْ قَوۡمًا غَضِبَ ٱللَّهُ عَلَيۡهِم مَّا هُم مِّنكُمۡ وَلَا مِنۡهُمۡ وَيَحۡلِفُونَ عَلَى ٱلۡكَذِبِ وَهُمۡ يَعۡلَمُونَ",
    translation:
      "Have you not considered those who make allies of a people with whom Allah has become angry? They are neither of you nor of them, and they swear to untruth while they know [they are lying]",
    normalizedText:
      "۞الم تر الى الذين تولوا قوما غضب الله عليهم ما هم منكم ولا منهم ويحلفون على الكذب وهم يعلمون",
  },
  {
    verseId: 14,
    name: "المجادلة",
    surahId: 58,
    text: "أَعَدَّ ٱللَّهُ لَهُمۡ عَذَابٗا شَدِيدًاۖ إِنَّهُمۡ سَآءَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "Allah has prepared for them a severe punishment. Indeed, it was evil that they were doing",
    normalizedText: "اعد الله لهم عذابا شديدا انهم ساء ما كانوا يعملون",
  },
  {
    verseId: 15,
    name: "المجادلة",
    surahId: 58,
    text: "ٱتَّخَذُوٓاْ أَيۡمَٰنَهُمۡ جُنَّةٗ فَصَدُّواْ عَن سَبِيلِ ٱللَّهِ فَلَهُمۡ عَذَابٞ مُّهِينٞ",
    translation:
      "They took their [false] oaths as a cover, so they averted [people] from the way of Allah, and for them is a humiliating punishment",
    normalizedText: "اتخذوا ايمنهم جنة فصدوا عن سبيل الله فلهم عذاب مهين",
  },
  {
    verseId: 16,
    name: "المجادلة",
    surahId: 58,
    text: "لَّن تُغۡنِيَ عَنۡهُمۡ أَمۡوَٰلُهُمۡ وَلَآ أَوۡلَٰدُهُم مِّنَ ٱللَّهِ شَيۡـًٔاۚ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِۖ هُمۡ فِيهَا خَٰلِدُونَ",
    translation:
      "Never will their wealth or their children avail them against Allah at all. Those are the companions of the Fire; they will abide therein eternally",
    normalizedText:
      "لن تغني عنهم امولهم ولا اولدهم من الله شيا اولاك اصحب النار هم فيها خلدون",
  },
  {
    verseId: 17,
    name: "المجادلة",
    surahId: 58,
    text: "يَوۡمَ يَبۡعَثُهُمُ ٱللَّهُ جَمِيعٗا فَيَحۡلِفُونَ لَهُۥ كَمَا يَحۡلِفُونَ لَكُمۡ وَيَحۡسَبُونَ أَنَّهُمۡ عَلَىٰ شَيۡءٍۚ أَلَآ إِنَّهُمۡ هُمُ ٱلۡكَٰذِبُونَ",
    translation:
      "On the Day Allah will resurrect them all, and they will swear to Him as they swear to you and think that they are [standing] on something. Unquestionably, it is they who are the liars",
    normalizedText:
      "يوم يبعثهم الله جميعا فيحلفون له كما يحلفون لكم ويحسبون انهم على شيء الا انهم هم الكذبون",
  },
  {
    verseId: 18,
    name: "المجادلة",
    surahId: 58,
    text: "ٱسۡتَحۡوَذَ عَلَيۡهِمُ ٱلشَّيۡطَٰنُ فَأَنسَىٰهُمۡ ذِكۡرَ ٱللَّهِۚ أُوْلَـٰٓئِكَ حِزۡبُ ٱلشَّيۡطَٰنِۚ أَلَآ إِنَّ حِزۡبَ ٱلشَّيۡطَٰنِ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "Satan has overcome them and made them forget the remembrance of Allah. Those are the party of Satan. Unquestionably, the party of Satan - they will be the losers",
    normalizedText:
      "استحوذ عليهم الشيطن فانسىهم ذكر الله اولاك حزب الشيطن الا ان حزب الشيطن هم الخسرون",
  },
  {
    verseId: 19,
    name: "المجادلة",
    surahId: 58,
    text: "إِنَّ ٱلَّذِينَ يُحَآدُّونَ ٱللَّهَ وَرَسُولَهُۥٓ أُوْلَـٰٓئِكَ فِي ٱلۡأَذَلِّينَ",
    translation:
      "Indeed, the ones who oppose Allah and His Messenger - those will be among the most humbled",
    normalizedText: "ان الذين يحادون الله ورسوله اولاك في الاذلين",
  },
  {
    verseId: 20,
    name: "المجادلة",
    surahId: 58,
    text: "كَتَبَ ٱللَّهُ لَأَغۡلِبَنَّ أَنَا۠ وَرُسُلِيٓۚ إِنَّ ٱللَّهَ قَوِيٌّ عَزِيزٞ",
    translation:
      'Allah has written, "I will surely overcome, I and My messengers." Indeed, Allah is Powerful and Exalted in Might',
    normalizedText: "كتب الله لاغلبن انا ورسلي ان الله قوي عزيز",
  },
  {
    verseId: 21,
    name: "المجادلة",
    surahId: 58,
    text: "لَّا تَجِدُ قَوۡمٗا يُؤۡمِنُونَ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِ يُوَآدُّونَ مَنۡ حَآدَّ ٱللَّهَ وَرَسُولَهُۥ وَلَوۡ كَانُوٓاْ ءَابَآءَهُمۡ أَوۡ أَبۡنَآءَهُمۡ أَوۡ إِخۡوَٰنَهُمۡ أَوۡ عَشِيرَتَهُمۡۚ أُوْلَـٰٓئِكَ كَتَبَ فِي قُلُوبِهِمُ ٱلۡإِيمَٰنَ وَأَيَّدَهُم بِرُوحٖ مِّنۡهُۖ وَيُدۡخِلُهُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَاۚ رَضِيَ ٱللَّهُ عَنۡهُمۡ وَرَضُواْ عَنۡهُۚ أُوْلَـٰٓئِكَ حِزۡبُ ٱللَّهِۚ أَلَآ إِنَّ حِزۡبَ ٱللَّهِ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "You will not find a people who believe in Allah and the Last Day having affection for those who oppose Allah and His Messenger, even if they were their fathers or their sons or their brothers or their kindred. Those - He has decreed within their hearts faith and supported them with spirit from Him. And We will admit them to gardens beneath which rivers flow, wherein they abide eternally. Allah is pleased with them, and they are pleased with Him - those are the party of Allah. Unquestionably, the party of Allah - they are the successful",
    normalizedText:
      "لا تجد قوما يامنون بالله واليوم الاخر يوادون من حاد الله ورسوله ولو كانوا ءاباءهم او ابناءهم او اخونهم او عشيرتهم اولاك كتب في قلوبهم الايمن وايدهم بروح منه ويدخلهم جنت تجري من تحتها الانهر خلدين فيها رضي الله عنهم ورضوا عنه اولاك حزب الله الا ان حزب الله هم المفلحون",
  },
  {
    verseId: 0,
    name: "الحشر",
    surahId: 59,
    text: "سَبَّحَ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Whatever is in the heavens and whatever is on the earth exalts Allah, and He is the Exalted in Might, the Wise",
    normalizedText: "سبح لله ما في السموت وما في الارض وهو العزيز الحكيم",
  },
  {
    verseId: 1,
    name: "الحشر",
    surahId: 59,
    text: "هُوَ ٱلَّذِيٓ أَخۡرَجَ ٱلَّذِينَ كَفَرُواْ مِنۡ أَهۡلِ ٱلۡكِتَٰبِ مِن دِيَٰرِهِمۡ لِأَوَّلِ ٱلۡحَشۡرِۚ مَا ظَنَنتُمۡ أَن يَخۡرُجُواْۖ وَظَنُّوٓاْ أَنَّهُم مَّانِعَتُهُمۡ حُصُونُهُم مِّنَ ٱللَّهِ فَأَتَىٰهُمُ ٱللَّهُ مِنۡ حَيۡثُ لَمۡ يَحۡتَسِبُواْۖ وَقَذَفَ فِي قُلُوبِهِمُ ٱلرُّعۡبَۚ يُخۡرِبُونَ بُيُوتَهُم بِأَيۡدِيهِمۡ وَأَيۡدِي ٱلۡمُؤۡمِنِينَ فَٱعۡتَبِرُواْ يَـٰٓأُوْلِي ٱلۡأَبۡصَٰرِ",
    translation:
      "It is He who expelled the ones who disbelieved among the People of the Scripture from their homes at the first gathering. You did not think they would leave, and they thought that their fortresses would protect them from Allah; but [the decree of] Allah came upon them from where they had not expected, and He cast terror into their hearts [so] they destroyed their houses by their [own] hands and the hands of the believers. So take warning, O people of vision",
    normalizedText:
      "هو الذي اخرج الذين كفروا من اهل الكتب من ديرهم لاول الحشر ما ظننتم ان يخرجوا وظنوا انهم مانعتهم حصونهم من الله فاتىهم الله من حيث لم يحتسبوا وقذف في قلوبهم الرعب يخربون بيوتهم بايديهم وايدي المامنين فاعتبروا ياولي الابصر",
  },
  {
    verseId: 2,
    name: "الحشر",
    surahId: 59,
    text: "وَلَوۡلَآ أَن كَتَبَ ٱللَّهُ عَلَيۡهِمُ ٱلۡجَلَآءَ لَعَذَّبَهُمۡ فِي ٱلدُّنۡيَاۖ وَلَهُمۡ فِي ٱلۡأٓخِرَةِ عَذَابُ ٱلنَّارِ",
    translation:
      "And if not that Allah had decreed for them evacuation, He would have punished them in [this] world, and for them in the Hereafter is the punishment of the Fire",
    normalizedText:
      "ولولا ان كتب الله عليهم الجلاء لعذبهم في الدنيا ولهم في الاخرة عذاب النار",
  },
  {
    verseId: 3,
    name: "الحشر",
    surahId: 59,
    text: "ذَٰلِكَ بِأَنَّهُمۡ شَآقُّواْ ٱللَّهَ وَرَسُولَهُۥۖ وَمَن يُشَآقِّ ٱللَّهَ فَإِنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "That is because they opposed Allah and His Messenger. And whoever opposes Allah - then indeed, Allah is severe in penalty",
    normalizedText:
      "ذلك بانهم شاقوا الله ورسوله ومن يشاق الله فان الله شديد العقاب",
  },
  {
    verseId: 4,
    name: "الحشر",
    surahId: 59,
    text: "مَا قَطَعۡتُم مِّن لِّينَةٍ أَوۡ تَرَكۡتُمُوهَا قَآئِمَةً عَلَىٰٓ أُصُولِهَا فَبِإِذۡنِ ٱللَّهِ وَلِيُخۡزِيَ ٱلۡفَٰسِقِينَ",
    translation:
      "Whatever you have cut down of [their] palm trees or left standing on their trunks - it was by permission of Allah and so He would disgrace the defiantly disobedient",
    normalizedText:
      "ما قطعتم من لينة او تركتموها قاامة على اصولها فباذن الله وليخزي الفسقين",
  },
  {
    verseId: 5,
    name: "الحشر",
    surahId: 59,
    text: "وَمَآ أَفَآءَ ٱللَّهُ عَلَىٰ رَسُولِهِۦ مِنۡهُمۡ فَمَآ أَوۡجَفۡتُمۡ عَلَيۡهِ مِنۡ خَيۡلٖ وَلَا رِكَابٖ وَلَٰكِنَّ ٱللَّهَ يُسَلِّطُ رُسُلَهُۥ عَلَىٰ مَن يَشَآءُۚ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      "And what Allah restored [of property] to His Messenger from them - you did not spur for it [in an expedition] any horses or camels, but Allah gives His messengers power over whom He wills, and Allah is over all things competent",
    normalizedText:
      "وما افاء الله على رسوله منهم فما اوجفتم عليه من خيل ولا ركاب ولكن الله يسلط رسله على من يشاء والله على كل شيء قدير",
  },
  {
    verseId: 6,
    name: "الحشر",
    surahId: 59,
    text: "مَّآ أَفَآءَ ٱللَّهُ عَلَىٰ رَسُولِهِۦ مِنۡ أَهۡلِ ٱلۡقُرَىٰ فَلِلَّهِ وَلِلرَّسُولِ وَلِذِي ٱلۡقُرۡبَىٰ وَٱلۡيَتَٰمَىٰ وَٱلۡمَسَٰكِينِ وَٱبۡنِ ٱلسَّبِيلِ كَيۡ لَا يَكُونَ دُولَةَۢ بَيۡنَ ٱلۡأَغۡنِيَآءِ مِنكُمۡۚ وَمَآ ءَاتَىٰكُمُ ٱلرَّسُولُ فَخُذُوهُ وَمَا نَهَىٰكُمۡ عَنۡهُ فَٱنتَهُواْۚ وَٱتَّقُواْ ٱللَّهَۖ إِنَّ ٱللَّهَ شَدِيدُ ٱلۡعِقَابِ",
    translation:
      "And what Allah restored to His Messenger from the people of the towns - it is for Allah and for the Messenger and for [his] near relatives and orphans and the [stranded] traveler - so that it will not be a perpetual distribution among the rich from among you. And whatever the Messenger has given you - take; and what he has forbidden you - refrain from. And fear Allah; indeed, Allah is severe in penalty",
    normalizedText:
      "ما افاء الله على رسوله من اهل القرى فلله وللرسول ولذي القربى واليتمى والمسكين وابن السبيل كي لا يكون دولة بين الاغنياء منكم وما ءاتىكم الرسول فخذوه وما نهىكم عنه فانتهوا واتقوا الله ان الله شديد العقاب",
  },
  {
    verseId: 7,
    name: "الحشر",
    surahId: 59,
    text: "لِلۡفُقَرَآءِ ٱلۡمُهَٰجِرِينَ ٱلَّذِينَ أُخۡرِجُواْ مِن دِيَٰرِهِمۡ وَأَمۡوَٰلِهِمۡ يَبۡتَغُونَ فَضۡلٗا مِّنَ ٱللَّهِ وَرِضۡوَٰنٗا وَيَنصُرُونَ ٱللَّهَ وَرَسُولَهُۥٓۚ أُوْلَـٰٓئِكَ هُمُ ٱلصَّـٰدِقُونَ",
    translation:
      "For the poor emigrants who were expelled from their homes and their properties, seeking bounty from Allah and [His] approval and supporting Allah and His Messenger, [there is also a share]. Those are the truthful",
    normalizedText:
      "للفقراء المهجرين الذين اخرجوا من ديرهم وامولهم يبتغون فضلا من الله ورضونا وينصرون الله ورسوله اولاك هم الصدقون",
  },
  {
    verseId: 8,
    name: "الحشر",
    surahId: 59,
    text: "وَٱلَّذِينَ تَبَوَّءُو ٱلدَّارَ وَٱلۡإِيمَٰنَ مِن قَبۡلِهِمۡ يُحِبُّونَ مَنۡ هَاجَرَ إِلَيۡهِمۡ وَلَا يَجِدُونَ فِي صُدُورِهِمۡ حَاجَةٗ مِّمَّآ أُوتُواْ وَيُؤۡثِرُونَ عَلَىٰٓ أَنفُسِهِمۡ وَلَوۡ كَانَ بِهِمۡ خَصَاصَةٞۚ وَمَن يُوقَ شُحَّ نَفۡسِهِۦ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "And [also for] those who were settled in al-Madinah and [adopted] the faith before them. They love those who emigrated to them and find not any want in their breasts of what the emigrants were given but give [them] preference over themselves, even though they are in privation. And whoever is protected from the stinginess of his soul - it is those who will be the successful",
    normalizedText:
      "والذين تبوءو الدار والايمن من قبلهم يحبون من هاجر اليهم ولا يجدون في صدورهم حاجة مما اوتوا وياثرون على انفسهم ولو كان بهم خصاصة ومن يوق شح نفسه فاولاك هم المفلحون",
  },
  {
    verseId: 9,
    name: "الحشر",
    surahId: 59,
    text: "وَٱلَّذِينَ جَآءُو مِنۢ بَعۡدِهِمۡ يَقُولُونَ رَبَّنَا ٱغۡفِرۡ لَنَا وَلِإِخۡوَٰنِنَا ٱلَّذِينَ سَبَقُونَا بِٱلۡإِيمَٰنِ وَلَا تَجۡعَلۡ فِي قُلُوبِنَا غِلّٗا لِّلَّذِينَ ءَامَنُواْ رَبَّنَآ إِنَّكَ رَءُوفٞ رَّحِيمٌ",
    translation:
      'And [there is a share for] those who came after them, saying, "Our Lord, forgive us and our brothers who preceded us in faith and put not in our hearts [any] resentment toward those who have believed. Our Lord, indeed You are Kind and Merciful',
    normalizedText:
      "والذين جاءو من بعدهم يقولون ربنا اغفر لنا ولاخوننا الذين سبقونا بالايمن ولا تجعل في قلوبنا غلا للذين ءامنوا ربنا انك رءوف رحيم",
  },
  {
    verseId: 10,
    name: "الحشر",
    surahId: 59,
    text: "۞أَلَمۡ تَرَ إِلَى ٱلَّذِينَ نَافَقُواْ يَقُولُونَ لِإِخۡوَٰنِهِمُ ٱلَّذِينَ كَفَرُواْ مِنۡ أَهۡلِ ٱلۡكِتَٰبِ لَئِنۡ أُخۡرِجۡتُمۡ لَنَخۡرُجَنَّ مَعَكُمۡ وَلَا نُطِيعُ فِيكُمۡ أَحَدًا أَبَدٗا وَإِن قُوتِلۡتُمۡ لَنَنصُرَنَّكُمۡ وَٱللَّهُ يَشۡهَدُ إِنَّهُمۡ لَكَٰذِبُونَ",
    translation:
      'Have you not considered those who practice hypocrisy, saying to their brothers who have disbelieved among the People of the Scripture, "If you are expelled, we will surely leave with you, and we will not obey, in regard to you, anyone - ever; and if you are fought, we will surely aid you." But Allah testifies that they are liars',
    normalizedText:
      "۞الم تر الى الذين نافقوا يقولون لاخونهم الذين كفروا من اهل الكتب لان اخرجتم لنخرجن معكم ولا نطيع فيكم احدا ابدا وان قوتلتم لننصرنكم والله يشهد انهم لكذبون",
  },
  {
    verseId: 11,
    name: "الحشر",
    surahId: 59,
    text: "لَئِنۡ أُخۡرِجُواْ لَا يَخۡرُجُونَ مَعَهُمۡ وَلَئِن قُوتِلُواْ لَا يَنصُرُونَهُمۡ وَلَئِن نَّصَرُوهُمۡ لَيُوَلُّنَّ ٱلۡأَدۡبَٰرَ ثُمَّ لَا يُنصَرُونَ",
    translation:
      "If they are expelled, they will not leave with them, and if they are fought, they will not aid them. And [even] if they should aid them, they will surely turn their backs; then [thereafter] they will not be aided",
    normalizedText:
      "لان اخرجوا لا يخرجون معهم ولان قوتلوا لا ينصرونهم ولان نصروهم ليولن الادبر ثم لا ينصرون",
  },
  {
    verseId: 12,
    name: "الحشر",
    surahId: 59,
    text: "لَأَنتُمۡ أَشَدُّ رَهۡبَةٗ فِي صُدُورِهِم مِّنَ ٱللَّهِۚ ذَٰلِكَ بِأَنَّهُمۡ قَوۡمٞ لَّا يَفۡقَهُونَ",
    translation:
      "You [believers] are more fearful within their breasts than Allah. That is because they are a people who do not understand",
    normalizedText: "لانتم اشد رهبة في صدورهم من الله ذلك بانهم قوم لا يفقهون",
  },
  {
    verseId: 13,
    name: "الحشر",
    surahId: 59,
    text: "لَا يُقَٰتِلُونَكُمۡ جَمِيعًا إِلَّا فِي قُرٗى مُّحَصَّنَةٍ أَوۡ مِن وَرَآءِ جُدُرِۭۚ بَأۡسُهُم بَيۡنَهُمۡ شَدِيدٞۚ تَحۡسَبُهُمۡ جَمِيعٗا وَقُلُوبُهُمۡ شَتَّىٰۚ ذَٰلِكَ بِأَنَّهُمۡ قَوۡمٞ لَّا يَعۡقِلُونَ",
    translation:
      "They will not fight you all except within fortified cities or from behind walls. Their violence among themselves is severe. You think they are together, but their hearts are diverse. That is because they are a people who do not reason",
    normalizedText:
      "لا يقتلونكم جميعا الا في قرى محصنة او من وراء جدر باسهم بينهم شديد تحسبهم جميعا وقلوبهم شتى ذلك بانهم قوم لا يعقلون",
  },
  {
    verseId: 14,
    name: "الحشر",
    surahId: 59,
    text: "كَمَثَلِ ٱلَّذِينَ مِن قَبۡلِهِمۡ قَرِيبٗاۖ ذَاقُواْ وَبَالَ أَمۡرِهِمۡ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "[Theirs is] like the example of those shortly before them: they tasted the bad consequence of their affair, and they will have a painful punishment",
    normalizedText: "كمثل الذين من قبلهم قريبا ذاقوا وبال امرهم ولهم عذاب اليم",
  },
  {
    verseId: 15,
    name: "الحشر",
    surahId: 59,
    text: "كَمَثَلِ ٱلشَّيۡطَٰنِ إِذۡ قَالَ لِلۡإِنسَٰنِ ٱكۡفُرۡ فَلَمَّا كَفَرَ قَالَ إِنِّي بَرِيٓءٞ مِّنكَ إِنِّيٓ أَخَافُ ٱللَّهَ رَبَّ ٱلۡعَٰلَمِينَ",
    translation:
      '[The hypocrites are] like the example of Satan when he says to man, "Disbelieve." But when he disbelieves, he says, "Indeed, I am disassociated from you. Indeed, I fear Allah, Lord of the worlds',
    normalizedText:
      "كمثل الشيطن اذ قال للانسن اكفر فلما كفر قال اني بريء منك اني اخاف الله رب العلمين",
  },
  {
    verseId: 16,
    name: "الحشر",
    surahId: 59,
    text: "فَكَانَ عَٰقِبَتَهُمَآ أَنَّهُمَا فِي ٱلنَّارِ خَٰلِدَيۡنِ فِيهَاۚ وَذَٰلِكَ جَزَـٰٓؤُاْ ٱلظَّـٰلِمِينَ",
    translation:
      "So the outcome for both of them is that they will be in the Fire, abiding eternally therein. And that is the recompense of the wrong-doers",
    normalizedText: "فكان عقبتهما انهما في النار خلدين فيها وذلك جزاا الظلمين",
  },
  {
    verseId: 17,
    name: "الحشر",
    surahId: 59,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ ٱتَّقُواْ ٱللَّهَ وَلۡتَنظُرۡ نَفۡسٞ مَّا قَدَّمَتۡ لِغَدٖۖ وَٱتَّقُواْ ٱللَّهَۚ إِنَّ ٱللَّهَ خَبِيرُۢ بِمَا تَعۡمَلُونَ",
    translation:
      "O you who have believed, fear Allah. And let every soul look to what it has put forth for tomorrow - and fear Allah. Indeed, Allah is Acquainted with what you do",
    normalizedText:
      "يايها الذين ءامنوا اتقوا الله ولتنظر نفس ما قدمت لغد واتقوا الله ان الله خبير بما تعملون",
  },
  {
    verseId: 18,
    name: "الحشر",
    surahId: 59,
    text: "وَلَا تَكُونُواْ كَٱلَّذِينَ نَسُواْ ٱللَّهَ فَأَنسَىٰهُمۡ أَنفُسَهُمۡۚ أُوْلَـٰٓئِكَ هُمُ ٱلۡفَٰسِقُونَ",
    translation:
      "And be not like those who forgot Allah, so He made them forget themselves. Those are the defiantly disobedient",
    normalizedText:
      "ولا تكونوا كالذين نسوا الله فانسىهم انفسهم اولاك هم الفسقون",
  },
  {
    verseId: 19,
    name: "الحشر",
    surahId: 59,
    text: "لَا يَسۡتَوِيٓ أَصۡحَٰبُ ٱلنَّارِ وَأَصۡحَٰبُ ٱلۡجَنَّةِۚ أَصۡحَٰبُ ٱلۡجَنَّةِ هُمُ ٱلۡفَآئِزُونَ",
    translation:
      "Not equal are the companions of the Fire and the companions of Paradise. The companions of Paradise - they are the attainers [of success]",
    normalizedText: "لا يستوي اصحب النار واصحب الجنة اصحب الجنة هم الفاازون",
  },
  {
    verseId: 20,
    name: "الحشر",
    surahId: 59,
    text: "لَوۡ أَنزَلۡنَا هَٰذَا ٱلۡقُرۡءَانَ عَلَىٰ جَبَلٖ لَّرَأَيۡتَهُۥ خَٰشِعٗا مُّتَصَدِّعٗا مِّنۡ خَشۡيَةِ ٱللَّهِۚ وَتِلۡكَ ٱلۡأَمۡثَٰلُ نَضۡرِبُهَا لِلنَّاسِ لَعَلَّهُمۡ يَتَفَكَّرُونَ",
    translation:
      "If We had sent down this Qur'an upon a mountain, you would have seen it humbled and coming apart from fear of Allah. And these examples We present to the people that perhaps they will give thought",
    normalizedText:
      "لو انزلنا هذا القرءان على جبل لرايته خشعا متصدعا من خشية الله وتلك الامثل نضربها للناس لعلهم يتفكرون",
  },
  {
    verseId: 21,
    name: "الحشر",
    surahId: 59,
    text: "هُوَ ٱللَّهُ ٱلَّذِي لَآ إِلَٰهَ إِلَّا هُوَۖ عَٰلِمُ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِۖ هُوَ ٱلرَّحۡمَٰنُ ٱلرَّحِيمُ",
    translation:
      "He is Allah, other than whom there is no deity, Knower of the unseen and the witnessed. He is the Entirely Merciful, the Especially Merciful",
    normalizedText:
      "هو الله الذي لا اله الا هو علم الغيب والشهدة هو الرحمن الرحيم",
  },
  {
    verseId: 22,
    name: "الحشر",
    surahId: 59,
    text: "هُوَ ٱللَّهُ ٱلَّذِي لَآ إِلَٰهَ إِلَّا هُوَ ٱلۡمَلِكُ ٱلۡقُدُّوسُ ٱلسَّلَٰمُ ٱلۡمُؤۡمِنُ ٱلۡمُهَيۡمِنُ ٱلۡعَزِيزُ ٱلۡجَبَّارُ ٱلۡمُتَكَبِّرُۚ سُبۡحَٰنَ ٱللَّهِ عَمَّا يُشۡرِكُونَ",
    translation:
      "He is Allah, other than whom there is no deity, the Sovereign, the Pure, the Perfection, the Bestower of Faith, the Overseer, the Exalted in Might, the Compeller, the Superior. Exalted is Allah above whatever they associate with Him",
    normalizedText:
      "هو الله الذي لا اله الا هو الملك القدوس السلم المامن المهيمن العزيز الجبار المتكبر سبحن الله عما يشركون",
  },
  {
    verseId: 23,
    name: "الحشر",
    surahId: 59,
    text: "هُوَ ٱللَّهُ ٱلۡخَٰلِقُ ٱلۡبَارِئُ ٱلۡمُصَوِّرُۖ لَهُ ٱلۡأَسۡمَآءُ ٱلۡحُسۡنَىٰۚ يُسَبِّحُ لَهُۥ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "He is Allah, the Creator, the Inventor, the Fashioner; to Him belong the best names. Whatever is in the heavens and earth is exalting Him. And He is the Exalted in Might, the Wise",
    normalizedText:
      "هو الله الخلق البارا المصور له الاسماء الحسنى يسبح له ما في السموت والارض وهو العزيز الحكيم",
  },
  {
    verseId: 0,
    name: "الممتحنة",
    surahId: 60,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَّخِذُواْ عَدُوِّي وَعَدُوَّكُمۡ أَوۡلِيَآءَ تُلۡقُونَ إِلَيۡهِم بِٱلۡمَوَدَّةِ وَقَدۡ كَفَرُواْ بِمَا جَآءَكُم مِّنَ ٱلۡحَقِّ يُخۡرِجُونَ ٱلرَّسُولَ وَإِيَّاكُمۡ أَن تُؤۡمِنُواْ بِٱللَّهِ رَبِّكُمۡ إِن كُنتُمۡ خَرَجۡتُمۡ جِهَٰدٗا فِي سَبِيلِي وَٱبۡتِغَآءَ مَرۡضَاتِيۚ تُسِرُّونَ إِلَيۡهِم بِٱلۡمَوَدَّةِ وَأَنَا۠ أَعۡلَمُ بِمَآ أَخۡفَيۡتُمۡ وَمَآ أَعۡلَنتُمۡۚ وَمَن يَفۡعَلۡهُ مِنكُمۡ فَقَدۡ ضَلَّ سَوَآءَ ٱلسَّبِيلِ",
    translation:
      "O you who have believed, do not take My enemies and your enemies as allies, extending to them affection while they have disbelieved in what came to you of the truth, having driven out the Prophet and yourselves [only] because you believe in Allah, your Lord. If you have come out for jihad in My cause and seeking means to My approval, [take them not as friends]. You confide to them affection, but I am most knowing of what you have concealed and what you have declared. And whoever does it among you has certainly strayed from the soundness of the way",
    normalizedText:
      "يايها الذين ءامنوا لا تتخذوا عدوي وعدوكم اولياء تلقون اليهم بالمودة وقد كفروا بما جاءكم من الحق يخرجون الرسول واياكم ان تامنوا بالله ربكم ان كنتم خرجتم جهدا في سبيلي وابتغاء مرضاتي تسرون اليهم بالمودة وانا اعلم بما اخفيتم وما اعلنتم ومن يفعله منكم فقد ضل سواء السبيل",
  },
  {
    verseId: 1,
    name: "الممتحنة",
    surahId: 60,
    text: "إِن يَثۡقَفُوكُمۡ يَكُونُواْ لَكُمۡ أَعۡدَآءٗ وَيَبۡسُطُوٓاْ إِلَيۡكُمۡ أَيۡدِيَهُمۡ وَأَلۡسِنَتَهُم بِٱلسُّوٓءِ وَوَدُّواْ لَوۡ تَكۡفُرُونَ",
    translation:
      "If they gain dominance over you, they would be to you as enemies and extend against you their hands and their tongues with evil, and they wish you would disbelieve",
    normalizedText:
      "ان يثقفوكم يكونوا لكم اعداء ويبسطوا اليكم ايديهم والسنتهم بالسوء وودوا لو تكفرون",
  },
  {
    verseId: 2,
    name: "الممتحنة",
    surahId: 60,
    text: "لَن تَنفَعَكُمۡ أَرۡحَامُكُمۡ وَلَآ أَوۡلَٰدُكُمۡۚ يَوۡمَ ٱلۡقِيَٰمَةِ يَفۡصِلُ بَيۡنَكُمۡۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرٞ",
    translation:
      "Never will your relatives or your children benefit you; the Day of Resurrection He will judge between you. And Allah, of what you do, is Seeing",
    normalizedText:
      "لن تنفعكم ارحامكم ولا اولدكم يوم القيمة يفصل بينكم والله بما تعملون بصير",
  },
  {
    verseId: 3,
    name: "الممتحنة",
    surahId: 60,
    text: "قَدۡ كَانَتۡ لَكُمۡ أُسۡوَةٌ حَسَنَةٞ فِيٓ إِبۡرَٰهِيمَ وَٱلَّذِينَ مَعَهُۥٓ إِذۡ قَالُواْ لِقَوۡمِهِمۡ إِنَّا بُرَءَـٰٓؤُاْ مِنكُمۡ وَمِمَّا تَعۡبُدُونَ مِن دُونِ ٱللَّهِ كَفَرۡنَا بِكُمۡ وَبَدَا بَيۡنَنَا وَبَيۡنَكُمُ ٱلۡعَدَٰوَةُ وَٱلۡبَغۡضَآءُ أَبَدًا حَتَّىٰ تُؤۡمِنُواْ بِٱللَّهِ وَحۡدَهُۥٓ إِلَّا قَوۡلَ إِبۡرَٰهِيمَ لِأَبِيهِ لَأَسۡتَغۡفِرَنَّ لَكَ وَمَآ أَمۡلِكُ لَكَ مِنَ ٱللَّهِ مِن شَيۡءٖۖ رَّبَّنَا عَلَيۡكَ تَوَكَّلۡنَا وَإِلَيۡكَ أَنَبۡنَا وَإِلَيۡكَ ٱلۡمَصِيرُ",
    translation:
      'There has already been for you an excellent pattern in Abraham and those with him, when they said to their people, "Indeed, we are disassociated from you and from whatever you worship other than Allah. We have denied you, and there has appeared between us and you animosity and hatred forever until you believe in Allah alone" except for the saying of Abraham to his father, "I will surely ask forgiveness for you, but I have not [power to do] for you anything against Allah. Our Lord, upon You we have relied, and to You we have returned, and to You is the destination',
    normalizedText:
      "قد كانت لكم اسوة حسنة في ابرهيم والذين معه اذ قالوا لقومهم انا برءاا منكم ومما تعبدون من دون الله كفرنا بكم وبدا بيننا وبينكم العدوة والبغضاء ابدا حتى تامنوا بالله وحده الا قول ابرهيم لابيه لاستغفرن لك وما املك لك من الله من شيء ربنا عليك توكلنا واليك انبنا واليك المصير",
  },
  {
    verseId: 4,
    name: "الممتحنة",
    surahId: 60,
    text: "رَبَّنَا لَا تَجۡعَلۡنَا فِتۡنَةٗ لِّلَّذِينَ كَفَرُواْ وَٱغۡفِرۡ لَنَا رَبَّنَآۖ إِنَّكَ أَنتَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Our Lord, make us not [objects of] torment for the disbelievers and forgive us, our Lord. Indeed, it is You who is the Exalted in Might, the Wise",
    normalizedText:
      "ربنا لا تجعلنا فتنة للذين كفروا واغفر لنا ربنا انك انت العزيز الحكيم",
  },
  {
    verseId: 5,
    name: "الممتحنة",
    surahId: 60,
    text: "لَقَدۡ كَانَ لَكُمۡ فِيهِمۡ أُسۡوَةٌ حَسَنَةٞ لِّمَن كَانَ يَرۡجُواْ ٱللَّهَ وَٱلۡيَوۡمَ ٱلۡأٓخِرَۚ وَمَن يَتَوَلَّ فَإِنَّ ٱللَّهَ هُوَ ٱلۡغَنِيُّ ٱلۡحَمِيدُ",
    translation:
      "There has certainly been for you in them an excellent pattern for anyone whose hope is in Allah and the Last Day. And whoever turns away - then indeed, Allah is the Free of need, the Praiseworthy",
    normalizedText:
      "لقد كان لكم فيهم اسوة حسنة لمن كان يرجوا الله واليوم الاخر ومن يتول فان الله هو الغني الحميد",
  },
  {
    verseId: 6,
    name: "الممتحنة",
    surahId: 60,
    text: "۞عَسَى ٱللَّهُ أَن يَجۡعَلَ بَيۡنَكُمۡ وَبَيۡنَ ٱلَّذِينَ عَادَيۡتُم مِّنۡهُم مَّوَدَّةٗۚ وَٱللَّهُ قَدِيرٞۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "Perhaps Allah will put, between you and those to whom you have been enemies among them, affection. And Allah is competent, and Allah is Forgiving and Merciful",
    normalizedText:
      "۞عسى الله ان يجعل بينكم وبين الذين عاديتم منهم مودة والله قدير والله غفور رحيم",
  },
  {
    verseId: 7,
    name: "الممتحنة",
    surahId: 60,
    text: "لَّا يَنۡهَىٰكُمُ ٱللَّهُ عَنِ ٱلَّذِينَ لَمۡ يُقَٰتِلُوكُمۡ فِي ٱلدِّينِ وَلَمۡ يُخۡرِجُوكُم مِّن دِيَٰرِكُمۡ أَن تَبَرُّوهُمۡ وَتُقۡسِطُوٓاْ إِلَيۡهِمۡۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلۡمُقۡسِطِينَ",
    translation:
      "Allah does not forbid you from those who do not fight you because of religion and do not expel you from your homes - from being righteous toward them and acting justly toward them. Indeed, Allah loves those who act justly",
    normalizedText:
      "لا ينهىكم الله عن الذين لم يقتلوكم في الدين ولم يخرجوكم من ديركم ان تبروهم وتقسطوا اليهم ان الله يحب المقسطين",
  },
  {
    verseId: 8,
    name: "الممتحنة",
    surahId: 60,
    text: "إِنَّمَا يَنۡهَىٰكُمُ ٱللَّهُ عَنِ ٱلَّذِينَ قَٰتَلُوكُمۡ فِي ٱلدِّينِ وَأَخۡرَجُوكُم مِّن دِيَٰرِكُمۡ وَظَٰهَرُواْ عَلَىٰٓ إِخۡرَاجِكُمۡ أَن تَوَلَّوۡهُمۡۚ وَمَن يَتَوَلَّهُمۡ فَأُوْلَـٰٓئِكَ هُمُ ٱلظَّـٰلِمُونَ",
    translation:
      "Allah only forbids you from those who fight you because of religion and expel you from your homes and aid in your expulsion - [forbids] that you make allies of them. And whoever makes allies of them, then it is those who are the wrongdoers",
    normalizedText:
      "انما ينهىكم الله عن الذين قتلوكم في الدين واخرجوكم من ديركم وظهروا على اخراجكم ان تولوهم ومن يتولهم فاولاك هم الظلمون",
  },
  {
    verseId: 9,
    name: "الممتحنة",
    surahId: 60,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا جَآءَكُمُ ٱلۡمُؤۡمِنَٰتُ مُهَٰجِرَٰتٖ فَٱمۡتَحِنُوهُنَّۖ ٱللَّهُ أَعۡلَمُ بِإِيمَٰنِهِنَّۖ فَإِنۡ عَلِمۡتُمُوهُنَّ مُؤۡمِنَٰتٖ فَلَا تَرۡجِعُوهُنَّ إِلَى ٱلۡكُفَّارِۖ لَا هُنَّ حِلّٞ لَّهُمۡ وَلَا هُمۡ يَحِلُّونَ لَهُنَّۖ وَءَاتُوهُم مَّآ أَنفَقُواْۚ وَلَا جُنَاحَ عَلَيۡكُمۡ أَن تَنكِحُوهُنَّ إِذَآ ءَاتَيۡتُمُوهُنَّ أُجُورَهُنَّۚ وَلَا تُمۡسِكُواْ بِعِصَمِ ٱلۡكَوَافِرِ وَسۡـَٔلُواْ مَآ أَنفَقۡتُمۡ وَلۡيَسۡـَٔلُواْ مَآ أَنفَقُواْۚ ذَٰلِكُمۡ حُكۡمُ ٱللَّهِ يَحۡكُمُ بَيۡنَكُمۡۖ وَٱللَّهُ عَلِيمٌ حَكِيمٞ",
    translation:
      "O you who have believed, when the believing women come to you as emigrants, examine them. Allah is most knowing as to their faith. And if you know them to be believers, then do not return them to the disbelievers; they are not lawful [wives] for them, nor are they lawful [husbands] for them. But give the disbelievers what they have spent. And there is no blame upon you if you marry them when you have given them their due compensation. And hold not to marriage bonds with disbelieving women, but ask for what you have spent and let them ask for what they have spent. That is the judgement of Allah; He judges between you. And Allah is Knowing and Wise",
    normalizedText:
      "يايها الذين ءامنوا اذا جاءكم المامنت مهجرت فامتحنوهن الله اعلم بايمنهن فان علمتموهن مامنت فلا ترجعوهن الى الكفار لا هن حل لهم ولا هم يحلون لهن وءاتوهم ما انفقوا ولا جناح عليكم ان تنكحوهن اذا ءاتيتموهن اجورهن ولا تمسكوا بعصم الكوافر وسلوا ما انفقتم وليسلوا ما انفقوا ذلكم حكم الله يحكم بينكم والله عليم حكيم",
  },
  {
    verseId: 10,
    name: "الممتحنة",
    surahId: 60,
    text: "وَإِن فَاتَكُمۡ شَيۡءٞ مِّنۡ أَزۡوَٰجِكُمۡ إِلَى ٱلۡكُفَّارِ فَعَاقَبۡتُمۡ فَـَٔاتُواْ ٱلَّذِينَ ذَهَبَتۡ أَزۡوَٰجُهُم مِّثۡلَ مَآ أَنفَقُواْۚ وَٱتَّقُواْ ٱللَّهَ ٱلَّذِيٓ أَنتُم بِهِۦ مُؤۡمِنُونَ",
    translation:
      "And if you have lost any of your wives to the disbelievers and you subsequently obtain [something], then give those whose wives have gone the equivalent of what they had spent. And fear Allah, in whom you are believers",
    normalizedText:
      "وان فاتكم شيء من ازوجكم الى الكفار فعاقبتم فاتوا الذين ذهبت ازوجهم مثل ما انفقوا واتقوا الله الذي انتم به مامنون",
  },
  {
    verseId: 11,
    name: "الممتحنة",
    surahId: 60,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ إِذَا جَآءَكَ ٱلۡمُؤۡمِنَٰتُ يُبَايِعۡنَكَ عَلَىٰٓ أَن لَّا يُشۡرِكۡنَ بِٱللَّهِ شَيۡـٔٗا وَلَا يَسۡرِقۡنَ وَلَا يَزۡنِينَ وَلَا يَقۡتُلۡنَ أَوۡلَٰدَهُنَّ وَلَا يَأۡتِينَ بِبُهۡتَٰنٖ يَفۡتَرِينَهُۥ بَيۡنَ أَيۡدِيهِنَّ وَأَرۡجُلِهِنَّ وَلَا يَعۡصِينَكَ فِي مَعۡرُوفٖ فَبَايِعۡهُنَّ وَٱسۡتَغۡفِرۡ لَهُنَّ ٱللَّهَۚ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٞ",
    translation:
      "O Prophet, when the believing women come to you pledging to you that they will not associate anything with Allah, nor will they steal, nor will they commit unlawful sexual intercourse, nor will they kill their children, nor will they bring forth a slander they have invented between their arms and legs, nor will they disobey you in what is right - then accept their pledge and ask forgiveness for them of Allah. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "يايها النبي اذا جاءك المامنت يبايعنك على ان لا يشركن بالله شيا ولا يسرقن ولا يزنين ولا يقتلن اولدهن ولا ياتين ببهتن يفترينه بين ايديهن وارجلهن ولا يعصينك في معروف فبايعهن واستغفر لهن الله ان الله غفور رحيم",
  },
  {
    verseId: 12,
    name: "الممتحنة",
    surahId: 60,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تَتَوَلَّوۡاْ قَوۡمًا غَضِبَ ٱللَّهُ عَلَيۡهِمۡ قَدۡ يَئِسُواْ مِنَ ٱلۡأٓخِرَةِ كَمَا يَئِسَ ٱلۡكُفَّارُ مِنۡ أَصۡحَٰبِ ٱلۡقُبُورِ",
    translation:
      "O you who have believed, do not make allies of a people with whom Allah has become angry. They have despaired of [reward in] the Hereafter just as the disbelievers have despaired of [meeting] the inhabitants of the graves",
    normalizedText:
      "يايها الذين ءامنوا لا تتولوا قوما غضب الله عليهم قد ياسوا من الاخرة كما ياس الكفار من اصحب القبور",
  },
  {
    verseId: 0,
    name: "الصف",
    surahId: 61,
    text: "سَبَّحَ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Whatever is in the heavens and whatever is on the earth exalts Allah, and He is the Exalted in Might, the Wise",
    normalizedText: "سبح لله ما في السموت وما في الارض وهو العزيز الحكيم",
  },
  {
    verseId: 1,
    name: "الصف",
    surahId: 61,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لِمَ تَقُولُونَ مَا لَا تَفۡعَلُونَ",
    translation: "O you who have believed, why do you say what you do not do",
    normalizedText: "يايها الذين ءامنوا لم تقولون ما لا تفعلون",
  },
  {
    verseId: 2,
    name: "الصف",
    surahId: 61,
    text: "كَبُرَ مَقۡتًا عِندَ ٱللَّهِ أَن تَقُولُواْ مَا لَا تَفۡعَلُونَ",
    translation:
      "Great is hatred in the sight of Allah that you say what you do not do",
    normalizedText: "كبر مقتا عند الله ان تقولوا ما لا تفعلون",
  },
  {
    verseId: 3,
    name: "الصف",
    surahId: 61,
    text: "إِنَّ ٱللَّهَ يُحِبُّ ٱلَّذِينَ يُقَٰتِلُونَ فِي سَبِيلِهِۦ صَفّٗا كَأَنَّهُم بُنۡيَٰنٞ مَّرۡصُوصٞ",
    translation:
      "Indeed, Allah loves those who fight in His cause in a row as though they are a [single] structure joined firmly",
    normalizedText: "ان الله يحب الذين يقتلون في سبيله صفا كانهم بنين مرصوص",
  },
  {
    verseId: 4,
    name: "الصف",
    surahId: 61,
    text: "وَإِذۡ قَالَ مُوسَىٰ لِقَوۡمِهِۦ يَٰقَوۡمِ لِمَ تُؤۡذُونَنِي وَقَد تَّعۡلَمُونَ أَنِّي رَسُولُ ٱللَّهِ إِلَيۡكُمۡۖ فَلَمَّا زَاغُوٓاْ أَزَاغَ ٱللَّهُ قُلُوبَهُمۡۚ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡفَٰسِقِينَ",
    translation:
      'And [mention, O Muhammad], when Moses said to his people, "O my people, why do you harm me while you certainly know that I am the messenger of Allah to you?" And when they deviated, Allah caused their hearts to deviate. And Allah does not guide the defiantly disobedient people',
    normalizedText:
      "واذ قال موسى لقومه يقوم لم تاذونني وقد تعلمون اني رسول الله اليكم فلما زاغوا ازاغ الله قلوبهم والله لا يهدي القوم الفسقين",
  },
  {
    verseId: 5,
    name: "الصف",
    surahId: 61,
    text: "وَإِذۡ قَالَ عِيسَى ٱبۡنُ مَرۡيَمَ يَٰبَنِيٓ إِسۡرَـٰٓءِيلَ إِنِّي رَسُولُ ٱللَّهِ إِلَيۡكُم مُّصَدِّقٗا لِّمَا بَيۡنَ يَدَيَّ مِنَ ٱلتَّوۡرَىٰةِ وَمُبَشِّرَۢا بِرَسُولٖ يَأۡتِي مِنۢ بَعۡدِي ٱسۡمُهُۥٓ أَحۡمَدُۖ فَلَمَّا جَآءَهُم بِٱلۡبَيِّنَٰتِ قَالُواْ هَٰذَا سِحۡرٞ مُّبِينٞ",
    translation:
      'And [mention] when Jesus, the son of Mary, said, "O children of Israel, indeed I am the messenger of Allah to you confirming what came before me of the Torah and bringing good tidings of a messenger to come after me, whose name is Ahmad." But when he came to them with clear evidences, they said, "This is obvious magic',
    normalizedText:
      "واذ قال عيسى ابن مريم يبني اسرءيل اني رسول الله اليكم مصدقا لما بين يدي من التورىة ومبشرا برسول ياتي من بعدي اسمه احمد فلما جاءهم بالبينت قالوا هذا سحر مبين",
  },
  {
    verseId: 6,
    name: "الصف",
    surahId: 61,
    text: "وَمَنۡ أَظۡلَمُ مِمَّنِ ٱفۡتَرَىٰ عَلَى ٱللَّهِ ٱلۡكَذِبَ وَهُوَ يُدۡعَىٰٓ إِلَى ٱلۡإِسۡلَٰمِۚ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      "And who is more unjust than one who invents about Allah untruth while he is being invited to Islam. And Allah does not guide the wrongdoing people",
    normalizedText:
      "ومن اظلم ممن افترى على الله الكذب وهو يدعى الى الاسلم والله لا يهدي القوم الظلمين",
  },
  {
    verseId: 7,
    name: "الصف",
    surahId: 61,
    text: "يُرِيدُونَ لِيُطۡفِـُٔواْ نُورَ ٱللَّهِ بِأَفۡوَٰهِهِمۡ وَٱللَّهُ مُتِمُّ نُورِهِۦ وَلَوۡ كَرِهَ ٱلۡكَٰفِرُونَ",
    translation:
      "They want to extinguish the light of Allah with their mouths, but Allah will perfect His light, although the disbelievers dislike it",
    normalizedText:
      "يريدون ليطفوا نور الله بافوههم والله متم نوره ولو كره الكفرون",
  },
  {
    verseId: 8,
    name: "الصف",
    surahId: 61,
    text: "هُوَ ٱلَّذِيٓ أَرۡسَلَ رَسُولَهُۥ بِٱلۡهُدَىٰ وَدِينِ ٱلۡحَقِّ لِيُظۡهِرَهُۥ عَلَى ٱلدِّينِ كُلِّهِۦ وَلَوۡ كَرِهَ ٱلۡمُشۡرِكُونَ",
    translation:
      "It is He who sent His Messenger with guidance and the religion of truth to manifest it over all religion, although those who associate others with Allah dislike it",
    normalizedText:
      "هو الذي ارسل رسوله بالهدى ودين الحق ليظهره على الدين كله ولو كره المشركون",
  },
  {
    verseId: 9,
    name: "الصف",
    surahId: 61,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ هَلۡ أَدُلُّكُمۡ عَلَىٰ تِجَٰرَةٖ تُنجِيكُم مِّنۡ عَذَابٍ أَلِيمٖ",
    translation:
      "O you who have believed, shall I guide you to a transaction that will save you from a painful punishment",
    normalizedText: "يايها الذين ءامنوا هل ادلكم على تجرة تنجيكم من عذاب اليم",
  },
  {
    verseId: 10,
    name: "الصف",
    surahId: 61,
    text: "تُؤۡمِنُونَ بِٱللَّهِ وَرَسُولِهِۦ وَتُجَٰهِدُونَ فِي سَبِيلِ ٱللَّهِ بِأَمۡوَٰلِكُمۡ وَأَنفُسِكُمۡۚ ذَٰلِكُمۡ خَيۡرٞ لَّكُمۡ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "[It is that] you believe in Allah and His Messenger and strive in the cause of Allah with your wealth and your lives. That is best for you, if you should know",
    normalizedText:
      "تامنون بالله ورسوله وتجهدون في سبيل الله بامولكم وانفسكم ذلكم خير لكم ان كنتم تعلمون",
  },
  {
    verseId: 11,
    name: "الصف",
    surahId: 61,
    text: "يَغۡفِرۡ لَكُمۡ ذُنُوبَكُمۡ وَيُدۡخِلۡكُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ وَمَسَٰكِنَ طَيِّبَةٗ فِي جَنَّـٰتِ عَدۡنٖۚ ذَٰلِكَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "He will forgive for you your sins and admit you to gardens beneath which rivers flow and pleasant dwellings in gardens of perpetual residence. That is the great attainment",
    normalizedText:
      "يغفر لكم ذنوبكم ويدخلكم جنت تجري من تحتها الانهر ومسكن طيبة في جنت عدن ذلك الفوز العظيم",
  },
  {
    verseId: 12,
    name: "الصف",
    surahId: 61,
    text: "وَأُخۡرَىٰ تُحِبُّونَهَاۖ نَصۡرٞ مِّنَ ٱللَّهِ وَفَتۡحٞ قَرِيبٞۗ وَبَشِّرِ ٱلۡمُؤۡمِنِينَ",
    translation:
      "And [you will obtain] another [favor] that you love - victory from Allah and an imminent conquest; and give good tidings to the believers",
    normalizedText: "واخرى تحبونها نصر من الله وفتح قريب وبشر المامنين",
  },
  {
    verseId: 13,
    name: "الصف",
    surahId: 61,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ كُونُوٓاْ أَنصَارَ ٱللَّهِ كَمَا قَالَ عِيسَى ٱبۡنُ مَرۡيَمَ لِلۡحَوَارِيِّـۧنَ مَنۡ أَنصَارِيٓ إِلَى ٱللَّهِۖ قَالَ ٱلۡحَوَارِيُّونَ نَحۡنُ أَنصَارُ ٱللَّهِۖ فَـَٔامَنَت طَّآئِفَةٞ مِّنۢ بَنِيٓ إِسۡرَـٰٓءِيلَ وَكَفَرَت طَّآئِفَةٞۖ فَأَيَّدۡنَا ٱلَّذِينَ ءَامَنُواْ عَلَىٰ عَدُوِّهِمۡ فَأَصۡبَحُواْ ظَٰهِرِينَ",
    translation:
      'O you who have believed, be supporters of Allah, as when Jesus, the son of Mary, said to the disciples, "Who are my supporters for Allah?" The disciples said, "We are supporters of Allah." And a faction of the Children of Israel believed and a faction disbelieved. So We supported those who believed against their enemy, and they became dominant',
    normalizedText:
      "يايها الذين ءامنوا كونوا انصار الله كما قال عيسى ابن مريم للحوارين من انصاري الى الله قال الحواريون نحن انصار الله فامنت طاافة من بني اسرءيل وكفرت طاافة فايدنا الذين ءامنوا على عدوهم فاصبحوا ظهرين",
  },
  {
    verseId: 0,
    name: "الجمعة",
    surahId: 62,
    text: "يُسَبِّحُ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِ ٱلۡمَلِكِ ٱلۡقُدُّوسِ ٱلۡعَزِيزِ ٱلۡحَكِيمِ",
    translation:
      "Whatever is in the heavens and whatever is on the earth is exalting Allah, the Sovereign, the Pure, the Exalted in Might, the Wise",
    normalizedText:
      "يسبح لله ما في السموت وما في الارض الملك القدوس العزيز الحكيم",
  },
  {
    verseId: 1,
    name: "الجمعة",
    surahId: 62,
    text: "هُوَ ٱلَّذِي بَعَثَ فِي ٱلۡأُمِّيِّـۧنَ رَسُولٗا مِّنۡهُمۡ يَتۡلُواْ عَلَيۡهِمۡ ءَايَٰتِهِۦ وَيُزَكِّيهِمۡ وَيُعَلِّمُهُمُ ٱلۡكِتَٰبَ وَٱلۡحِكۡمَةَ وَإِن كَانُواْ مِن قَبۡلُ لَفِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      "It is He who has sent among the unlettered a Messenger from themselves reciting to them His verses and purifying them and teaching them the Book and wisdom - although they were before in clear error",
    normalizedText:
      "هو الذي بعث في الامين رسولا منهم يتلوا عليهم ءايته ويزكيهم ويعلمهم الكتب والحكمة وان كانوا من قبل لفي ضلل مبين",
  },
  {
    verseId: 2,
    name: "الجمعة",
    surahId: 62,
    text: "وَءَاخَرِينَ مِنۡهُمۡ لَمَّا يَلۡحَقُواْ بِهِمۡۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "And [to] others of them who have not yet joined them. And He is the Exalted in Might, the Wise",
    normalizedText: "وءاخرين منهم لما يلحقوا بهم وهو العزيز الحكيم",
  },
  {
    verseId: 3,
    name: "الجمعة",
    surahId: 62,
    text: "ذَٰلِكَ فَضۡلُ ٱللَّهِ يُؤۡتِيهِ مَن يَشَآءُۚ وَٱللَّهُ ذُو ٱلۡفَضۡلِ ٱلۡعَظِيمِ",
    translation:
      "That is the bounty of Allah, which He gives to whom He wills, and Allah is the possessor of great bounty",
    normalizedText: "ذلك فضل الله ياتيه من يشاء والله ذو الفضل العظيم",
  },
  {
    verseId: 4,
    name: "الجمعة",
    surahId: 62,
    text: "مَثَلُ ٱلَّذِينَ حُمِّلُواْ ٱلتَّوۡرَىٰةَ ثُمَّ لَمۡ يَحۡمِلُوهَا كَمَثَلِ ٱلۡحِمَارِ يَحۡمِلُ أَسۡفَارَۢاۚ بِئۡسَ مَثَلُ ٱلۡقَوۡمِ ٱلَّذِينَ كَذَّبُواْ بِـَٔايَٰتِ ٱللَّهِۚ وَٱللَّهُ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلظَّـٰلِمِينَ",
    translation:
      "The example of those who were entrusted with the Torah and then did not take it on is like that of a donkey who carries volumes [of books]. Wretched is the example of the people who deny the signs of Allah. And Allah does not guide the wrongdoing people",
    normalizedText:
      "مثل الذين حملوا التورىة ثم لم يحملوها كمثل الحمار يحمل اسفارا باس مثل القوم الذين كذبوا بايت الله والله لا يهدي القوم الظلمين",
  },
  {
    verseId: 5,
    name: "الجمعة",
    surahId: 62,
    text: "قُلۡ يَـٰٓأَيُّهَا ٱلَّذِينَ هَادُوٓاْ إِن زَعَمۡتُمۡ أَنَّكُمۡ أَوۡلِيَآءُ لِلَّهِ مِن دُونِ ٱلنَّاسِ فَتَمَنَّوُاْ ٱلۡمَوۡتَ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'Say, "O you who are Jews, if you claim that you are allies of Allah, excluding the [other] people, then wish for death, if you should be truthful',
    normalizedText:
      "قل يايها الذين هادوا ان زعمتم انكم اولياء لله من دون الناس فتمنوا الموت ان كنتم صدقين",
  },
  {
    verseId: 6,
    name: "الجمعة",
    surahId: 62,
    text: "وَلَا يَتَمَنَّوۡنَهُۥٓ أَبَدَۢا بِمَا قَدَّمَتۡ أَيۡدِيهِمۡۚ وَٱللَّهُ عَلِيمُۢ بِٱلظَّـٰلِمِينَ",
    translation:
      "But they will not wish for it, ever, because of what their hands have put forth. And Allah is Knowing of the wrongdoers",
    normalizedText: "ولا يتمنونه ابدا بما قدمت ايديهم والله عليم بالظلمين",
  },
  {
    verseId: 7,
    name: "الجمعة",
    surahId: 62,
    text: "قُلۡ إِنَّ ٱلۡمَوۡتَ ٱلَّذِي تَفِرُّونَ مِنۡهُ فَإِنَّهُۥ مُلَٰقِيكُمۡۖ ثُمَّ تُرَدُّونَ إِلَىٰ عَٰلِمِ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ فَيُنَبِّئُكُم بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      'Say, "Indeed, the death from which you flee - indeed, it will meet you. Then you will be returned to the Knower of the unseen and the witnessed, and He will inform you about what you used to do',
    normalizedText:
      "قل ان الموت الذي تفرون منه فانه ملقيكم ثم تردون الى علم الغيب والشهدة فينباكم بما كنتم تعملون",
  },
  {
    verseId: 8,
    name: "الجمعة",
    surahId: 62,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِذَا نُودِيَ لِلصَّلَوٰةِ مِن يَوۡمِ ٱلۡجُمُعَةِ فَٱسۡعَوۡاْ إِلَىٰ ذِكۡرِ ٱللَّهِ وَذَرُواْ ٱلۡبَيۡعَۚ ذَٰلِكُمۡ خَيۡرٞ لَّكُمۡ إِن كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "O you who have believed, when [the adhan] is called for the prayer on the day of Jumu'ah [Friday], then proceed to the remembrance of Allah and leave trade. That is better for you, if you only knew",
    normalizedText:
      "يايها الذين ءامنوا اذا نودي للصلوة من يوم الجمعة فاسعوا الى ذكر الله وذروا البيع ذلكم خير لكم ان كنتم تعلمون",
  },
  {
    verseId: 9,
    name: "الجمعة",
    surahId: 62,
    text: "فَإِذَا قُضِيَتِ ٱلصَّلَوٰةُ فَٱنتَشِرُواْ فِي ٱلۡأَرۡضِ وَٱبۡتَغُواْ مِن فَضۡلِ ٱللَّهِ وَٱذۡكُرُواْ ٱللَّهَ كَثِيرٗا لَّعَلَّكُمۡ تُفۡلِحُونَ",
    translation:
      "And when the prayer has been concluded, disperse within the land and seek from the bounty of Allah, and remember Allah often that you may succeed",
    normalizedText:
      "فاذا قضيت الصلوة فانتشروا في الارض وابتغوا من فضل الله واذكروا الله كثيرا لعلكم تفلحون",
  },
  {
    verseId: 10,
    name: "الجمعة",
    surahId: 62,
    text: "وَإِذَا رَأَوۡاْ تِجَٰرَةً أَوۡ لَهۡوًا ٱنفَضُّوٓاْ إِلَيۡهَا وَتَرَكُوكَ قَآئِمٗاۚ قُلۡ مَا عِندَ ٱللَّهِ خَيۡرٞ مِّنَ ٱللَّهۡوِ وَمِنَ ٱلتِّجَٰرَةِۚ وَٱللَّهُ خَيۡرُ ٱلرَّـٰزِقِينَ",
    translation:
      'But when they saw a transaction or a diversion, [O Muhammad], they rushed to it and left you standing. Say, "What is with Allah is better than diversion and than a transaction, and Allah is the best of providers',
    normalizedText:
      "واذا راوا تجرة او لهوا انفضوا اليها وتركوك قااما قل ما عند الله خير من اللهو ومن التجرة والله خير الرزقين",
  },
  {
    verseId: 0,
    name: "المنافقون",
    surahId: 63,
    text: "إِذَا جَآءَكَ ٱلۡمُنَٰفِقُونَ قَالُواْ نَشۡهَدُ إِنَّكَ لَرَسُولُ ٱللَّهِۗ وَٱللَّهُ يَعۡلَمُ إِنَّكَ لَرَسُولُهُۥ وَٱللَّهُ يَشۡهَدُ إِنَّ ٱلۡمُنَٰفِقِينَ لَكَٰذِبُونَ",
    translation:
      'When the hypocrites come to you, [O Muhammad], they say, "We testify that you are the Messenger of Allah." And Allah knows that you are His Messenger, and Allah testifies that the hypocrites are liars',
    normalizedText:
      "اذا جاءك المنفقون قالوا نشهد انك لرسول الله والله يعلم انك لرسوله والله يشهد ان المنفقين لكذبون",
  },
  {
    verseId: 1,
    name: "المنافقون",
    surahId: 63,
    text: "ٱتَّخَذُوٓاْ أَيۡمَٰنَهُمۡ جُنَّةٗ فَصَدُّواْ عَن سَبِيلِ ٱللَّهِۚ إِنَّهُمۡ سَآءَ مَا كَانُواْ يَعۡمَلُونَ",
    translation:
      "They have taken their oaths as a cover, so they averted [people] from the way of Allah. Indeed, it was evil that they were doing",
    normalizedText:
      "اتخذوا ايمنهم جنة فصدوا عن سبيل الله انهم ساء ما كانوا يعملون",
  },
  {
    verseId: 2,
    name: "المنافقون",
    surahId: 63,
    text: "ذَٰلِكَ بِأَنَّهُمۡ ءَامَنُواْ ثُمَّ كَفَرُواْ فَطُبِعَ عَلَىٰ قُلُوبِهِمۡ فَهُمۡ لَا يَفۡقَهُونَ",
    translation:
      "That is because they believed, and then they disbelieved; so their hearts were sealed over, and they do not understand",
    normalizedText: "ذلك بانهم ءامنوا ثم كفروا فطبع على قلوبهم فهم لا يفقهون",
  },
  {
    verseId: 3,
    name: "المنافقون",
    surahId: 63,
    text: "۞وَإِذَا رَأَيۡتَهُمۡ تُعۡجِبُكَ أَجۡسَامُهُمۡۖ وَإِن يَقُولُواْ تَسۡمَعۡ لِقَوۡلِهِمۡۖ كَأَنَّهُمۡ خُشُبٞ مُّسَنَّدَةٞۖ يَحۡسَبُونَ كُلَّ صَيۡحَةٍ عَلَيۡهِمۡۚ هُمُ ٱلۡعَدُوُّ فَٱحۡذَرۡهُمۡۚ قَٰتَلَهُمُ ٱللَّهُۖ أَنَّىٰ يُؤۡفَكُونَ",
    translation:
      "And when you see them, their forms please you, and if they speak, you listen to their speech. [They are] as if they were pieces of wood propped up - they think that every shout is against them. They are the enemy, so beware of them. May Allah destroy them; how are they deluded",
    normalizedText:
      "۞واذا رايتهم تعجبك اجسامهم وان يقولوا تسمع لقولهم كانهم خشب مسندة يحسبون كل صيحة عليهم هم العدو فاحذرهم قتلهم الله انى يافكون",
  },
  {
    verseId: 4,
    name: "المنافقون",
    surahId: 63,
    text: "وَإِذَا قِيلَ لَهُمۡ تَعَالَوۡاْ يَسۡتَغۡفِرۡ لَكُمۡ رَسُولُ ٱللَّهِ لَوَّوۡاْ رُءُوسَهُمۡ وَرَأَيۡتَهُمۡ يَصُدُّونَ وَهُم مُّسۡتَكۡبِرُونَ",
    translation:
      'And when it is said to them, "Come, the Messenger of Allah will ask forgiveness for you," they turn their heads aside and you see them evading while they are arrogant',
    normalizedText:
      "واذا قيل لهم تعالوا يستغفر لكم رسول الله لووا رءوسهم ورايتهم يصدون وهم مستكبرون",
  },
  {
    verseId: 5,
    name: "المنافقون",
    surahId: 63,
    text: "سَوَآءٌ عَلَيۡهِمۡ أَسۡتَغۡفَرۡتَ لَهُمۡ أَمۡ لَمۡ تَسۡتَغۡفِرۡ لَهُمۡ لَن يَغۡفِرَ ٱللَّهُ لَهُمۡۚ إِنَّ ٱللَّهَ لَا يَهۡدِي ٱلۡقَوۡمَ ٱلۡفَٰسِقِينَ",
    translation:
      "It is all the same for them whether you ask forgiveness for them or do not ask forgiveness for them; never will Allah forgive them. Indeed, Allah does not guide the defiantly disobedient people",
    normalizedText:
      "سواء عليهم استغفرت لهم ام لم تستغفر لهم لن يغفر الله لهم ان الله لا يهدي القوم الفسقين",
  },
  {
    verseId: 6,
    name: "المنافقون",
    surahId: 63,
    text: "هُمُ ٱلَّذِينَ يَقُولُونَ لَا تُنفِقُواْ عَلَىٰ مَنۡ عِندَ رَسُولِ ٱللَّهِ حَتَّىٰ يَنفَضُّواْۗ وَلِلَّهِ خَزَآئِنُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَلَٰكِنَّ ٱلۡمُنَٰفِقِينَ لَا يَفۡقَهُونَ",
    translation:
      'They are the ones who say, "Do not spend on those who are with the Messenger of Allah until they disband." And to Allah belongs the depositories of the heavens and the earth, but the hypocrites do not understand',
    normalizedText:
      "هم الذين يقولون لا تنفقوا على من عند رسول الله حتى ينفضوا ولله خزاان السموت والارض ولكن المنفقين لا يفقهون",
  },
  {
    verseId: 7,
    name: "المنافقون",
    surahId: 63,
    text: "يَقُولُونَ لَئِن رَّجَعۡنَآ إِلَى ٱلۡمَدِينَةِ لَيُخۡرِجَنَّ ٱلۡأَعَزُّ مِنۡهَا ٱلۡأَذَلَّۚ وَلِلَّهِ ٱلۡعِزَّةُ وَلِرَسُولِهِۦ وَلِلۡمُؤۡمِنِينَ وَلَٰكِنَّ ٱلۡمُنَٰفِقِينَ لَا يَعۡلَمُونَ",
    translation:
      'They say, "If we return to al-Madinah, the more honored [for power] will surely expel therefrom the more humble." And to Allah belongs [all] honor, and to His Messenger, and to the believers, but the hypocrites do not know',
    normalizedText:
      "يقولون لان رجعنا الى المدينة ليخرجن الاعز منها الاذل ولله العزة ولرسوله وللمامنين ولكن المنفقين لا يعلمون",
  },
  {
    verseId: 8,
    name: "المنافقون",
    surahId: 63,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ لَا تُلۡهِكُمۡ أَمۡوَٰلُكُمۡ وَلَآ أَوۡلَٰدُكُمۡ عَن ذِكۡرِ ٱللَّهِۚ وَمَن يَفۡعَلۡ ذَٰلِكَ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡخَٰسِرُونَ",
    translation:
      "O you who have believed, let not your wealth and your children divert you from remembrance of Allah. And whoever does that - then those are the losers",
    normalizedText:
      "يايها الذين ءامنوا لا تلهكم امولكم ولا اولدكم عن ذكر الله ومن يفعل ذلك فاولاك هم الخسرون",
  },
  {
    verseId: 9,
    name: "المنافقون",
    surahId: 63,
    text: "وَأَنفِقُواْ مِن مَّا رَزَقۡنَٰكُم مِّن قَبۡلِ أَن يَأۡتِيَ أَحَدَكُمُ ٱلۡمَوۡتُ فَيَقُولَ رَبِّ لَوۡلَآ أَخَّرۡتَنِيٓ إِلَىٰٓ أَجَلٖ قَرِيبٖ فَأَصَّدَّقَ وَأَكُن مِّنَ ٱلصَّـٰلِحِينَ",
    translation:
      'And spend [in the way of Allah] from what We have provided you before death approaches one of you and he says, "My Lord, if only You would delay me for a brief term so I would give charity and be among the righteous',
    normalizedText:
      "وانفقوا من ما رزقنكم من قبل ان ياتي احدكم الموت فيقول رب لولا اخرتني الى اجل قريب فاصدق واكن من الصلحين",
  },
  {
    verseId: 10,
    name: "المنافقون",
    surahId: 63,
    text: "وَلَن يُؤَخِّرَ ٱللَّهُ نَفۡسًا إِذَا جَآءَ أَجَلُهَاۚ وَٱللَّهُ خَبِيرُۢ بِمَا تَعۡمَلُونَ",
    translation:
      "But never will Allah delay a soul when its time has come. And Allah is Acquainted with what you do",
    normalizedText: "ولن ياخر الله نفسا اذا جاء اجلها والله خبير بما تعملون",
  },
  {
    verseId: 0,
    name: "التغابن",
    surahId: 64,
    text: "يُسَبِّحُ لِلَّهِ مَا فِي ٱلسَّمَٰوَٰتِ وَمَا فِي ٱلۡأَرۡضِۖ لَهُ ٱلۡمُلۡكُ وَلَهُ ٱلۡحَمۡدُۖ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "Whatever is in the heavens and whatever is on the earth is exalting Allah. To Him belongs dominion, and to Him belongs [all] praise, and He is over all things competent",
    normalizedText:
      "يسبح لله ما في السموت وما في الارض له الملك وله الحمد وهو على كل شيء قدير",
  },
  {
    verseId: 1,
    name: "التغابن",
    surahId: 64,
    text: "هُوَ ٱلَّذِي خَلَقَكُمۡ فَمِنكُمۡ كَافِرٞ وَمِنكُم مُّؤۡمِنٞۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ بَصِيرٌ",
    translation:
      "It is He who created you, and among you is the disbeliever, and among you is the believer. And Allah, of what you do, is Seeing",
    normalizedText: "هو الذي خلقكم فمنكم كافر ومنكم مامن والله بما تعملون بصير",
  },
  {
    verseId: 2,
    name: "التغابن",
    surahId: 64,
    text: "خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضَ بِٱلۡحَقِّ وَصَوَّرَكُمۡ فَأَحۡسَنَ صُوَرَكُمۡۖ وَإِلَيۡهِ ٱلۡمَصِيرُ",
    translation:
      "He created the heavens and earth in truth and formed you and perfected your forms; and to Him is the [final] destination",
    normalizedText: "خلق السموت والارض بالحق وصوركم فاحسن صوركم واليه المصير",
  },
  {
    verseId: 3,
    name: "التغابن",
    surahId: 64,
    text: "يَعۡلَمُ مَا فِي ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَيَعۡلَمُ مَا تُسِرُّونَ وَمَا تُعۡلِنُونَۚ وَٱللَّهُ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "He knows what is within the heavens and earth and knows what you conceal and what you declare. And Allah is Knowing of that within the breasts",
    normalizedText:
      "يعلم ما في السموت والارض ويعلم ما تسرون وما تعلنون والله عليم بذات الصدور",
  },
  {
    verseId: 4,
    name: "التغابن",
    surahId: 64,
    text: "أَلَمۡ يَأۡتِكُمۡ نَبَؤُاْ ٱلَّذِينَ كَفَرُواْ مِن قَبۡلُ فَذَاقُواْ وَبَالَ أَمۡرِهِمۡ وَلَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      "Has there not come to you the news of those who disbelieved before? So they tasted the bad consequence of their affair, and they will have a painful punishment",
    normalizedText:
      "الم ياتكم نباا الذين كفروا من قبل فذاقوا وبال امرهم ولهم عذاب اليم",
  },
  {
    verseId: 5,
    name: "التغابن",
    surahId: 64,
    text: "ذَٰلِكَ بِأَنَّهُۥ كَانَت تَّأۡتِيهِمۡ رُسُلُهُم بِٱلۡبَيِّنَٰتِ فَقَالُوٓاْ أَبَشَرٞ يَهۡدُونَنَا فَكَفَرُواْ وَتَوَلَّواْۖ وَّٱسۡتَغۡنَى ٱللَّهُۚ وَٱللَّهُ غَنِيٌّ حَمِيدٞ",
    translation:
      'That is because their messengers used to come to them with clear evidences, but they said, "Shall human beings guide us?" and disbelieved and turned away. And Allah dispensed [with them]; and Allah is Free of need and Praiseworthy',
    normalizedText:
      "ذلك بانه كانت تاتيهم رسلهم بالبينت فقالوا ابشر يهدوننا فكفروا وتولوا واستغنى الله والله غني حميد",
  },
  {
    verseId: 6,
    name: "التغابن",
    surahId: 64,
    text: "زَعَمَ ٱلَّذِينَ كَفَرُوٓاْ أَن لَّن يُبۡعَثُواْۚ قُلۡ بَلَىٰ وَرَبِّي لَتُبۡعَثُنَّ ثُمَّ لَتُنَبَّؤُنَّ بِمَا عَمِلۡتُمۡۚ وَذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٞ",
    translation:
      'Those who disbelieve have claimed that they will never be resurrected. Say, "Yes, by my Lord, you will surely be resurrected; then you will surely be informed of what you did. And that, for Allah, is easy',
    normalizedText:
      "زعم الذين كفروا ان لن يبعثوا قل بلى وربي لتبعثن ثم لتنبان بما عملتم وذلك على الله يسير",
  },
  {
    verseId: 7,
    name: "التغابن",
    surahId: 64,
    text: "فَـَٔامِنُواْ بِٱللَّهِ وَرَسُولِهِۦ وَٱلنُّورِ ٱلَّذِيٓ أَنزَلۡنَاۚ وَٱللَّهُ بِمَا تَعۡمَلُونَ خَبِيرٞ",
    translation:
      "So believe in Allah and His Messenger and the Qur'an which We have sent down. And Allah is Acquainted with what you do",
    normalizedText:
      "فامنوا بالله ورسوله والنور الذي انزلنا والله بما تعملون خبير",
  },
  {
    verseId: 8,
    name: "التغابن",
    surahId: 64,
    text: "يَوۡمَ يَجۡمَعُكُمۡ لِيَوۡمِ ٱلۡجَمۡعِۖ ذَٰلِكَ يَوۡمُ ٱلتَّغَابُنِۗ وَمَن يُؤۡمِنۢ بِٱللَّهِ وَيَعۡمَلۡ صَٰلِحٗا يُكَفِّرۡ عَنۡهُ سَيِّـَٔاتِهِۦ وَيُدۡخِلۡهُ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدٗاۚ ذَٰلِكَ ٱلۡفَوۡزُ ٱلۡعَظِيمُ",
    translation:
      "The Day He will assemble you for the Day of Assembly - that is the Day of Deprivation. And whoever believes in Allah and does righteousness - He will remove from him his misdeeds and admit him to gardens beneath which rivers flow, wherein they will abide forever. That is the great attainment",
    normalizedText:
      "يوم يجمعكم ليوم الجمع ذلك يوم التغابن ومن يامن بالله ويعمل صلحا يكفر عنه سياته ويدخله جنت تجري من تحتها الانهر خلدين فيها ابدا ذلك الفوز العظيم",
  },
  {
    verseId: 9,
    name: "التغابن",
    surahId: 64,
    text: "وَٱلَّذِينَ كَفَرُواْ وَكَذَّبُواْ بِـَٔايَٰتِنَآ أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلنَّارِ خَٰلِدِينَ فِيهَاۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "But the ones who disbelieved and denied Our verses - those are the companions of the Fire, abiding eternally therein; and wretched is the destination",
    normalizedText:
      "والذين كفروا وكذبوا بايتنا اولاك اصحب النار خلدين فيها وباس المصير",
  },
  {
    verseId: 10,
    name: "التغابن",
    surahId: 64,
    text: "مَآ أَصَابَ مِن مُّصِيبَةٍ إِلَّا بِإِذۡنِ ٱللَّهِۗ وَمَن يُؤۡمِنۢ بِٱللَّهِ يَهۡدِ قَلۡبَهُۥۚ وَٱللَّهُ بِكُلِّ شَيۡءٍ عَلِيمٞ",
    translation:
      "No disaster strikes except by permission of Allah. And whoever believes in Allah - He will guide his heart. And Allah is Knowing of all things",
    normalizedText:
      "ما اصاب من مصيبة الا باذن الله ومن يامن بالله يهد قلبه والله بكل شيء عليم",
  },
  {
    verseId: 11,
    name: "التغابن",
    surahId: 64,
    text: "وَأَطِيعُواْ ٱللَّهَ وَأَطِيعُواْ ٱلرَّسُولَۚ فَإِن تَوَلَّيۡتُمۡ فَإِنَّمَا عَلَىٰ رَسُولِنَا ٱلۡبَلَٰغُ ٱلۡمُبِينُ",
    translation:
      "And obey Allah and obey the Messenger; but if you turn away - then upon Our Messenger is only [the duty of] clear notification",
    normalizedText:
      "واطيعوا الله واطيعوا الرسول فان توليتم فانما على رسولنا البلغ المبين",
  },
  {
    verseId: 12,
    name: "التغابن",
    surahId: 64,
    text: "ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَۚ وَعَلَى ٱللَّهِ فَلۡيَتَوَكَّلِ ٱلۡمُؤۡمِنُونَ",
    translation:
      "Allah - there is no deity except Him. And upon Allah let the believers rely",
    normalizedText: "الله لا اله الا هو وعلى الله فليتوكل المامنون",
  },
  {
    verseId: 13,
    name: "التغابن",
    surahId: 64,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓاْ إِنَّ مِنۡ أَزۡوَٰجِكُمۡ وَأَوۡلَٰدِكُمۡ عَدُوّٗا لَّكُمۡ فَٱحۡذَرُوهُمۡۚ وَإِن تَعۡفُواْ وَتَصۡفَحُواْ وَتَغۡفِرُواْ فَإِنَّ ٱللَّهَ غَفُورٞ رَّحِيمٌ",
    translation:
      "O you who have believed, indeed, among your wives and your children are enemies to you, so beware of them. But if you pardon and overlook and forgive - then indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "يايها الذين ءامنوا ان من ازوجكم واولدكم عدوا لكم فاحذروهم وان تعفوا وتصفحوا وتغفروا فان الله غفور رحيم",
  },
  {
    verseId: 14,
    name: "التغابن",
    surahId: 64,
    text: "إِنَّمَآ أَمۡوَٰلُكُمۡ وَأَوۡلَٰدُكُمۡ فِتۡنَةٞۚ وَٱللَّهُ عِندَهُۥٓ أَجۡرٌ عَظِيمٞ",
    translation:
      "Your wealth and your children are but a trial, and Allah has with Him a great reward",
    normalizedText: "انما امولكم واولدكم فتنة والله عنده اجر عظيم",
  },
  {
    verseId: 15,
    name: "التغابن",
    surahId: 64,
    text: "فَٱتَّقُواْ ٱللَّهَ مَا ٱسۡتَطَعۡتُمۡ وَٱسۡمَعُواْ وَأَطِيعُواْ وَأَنفِقُواْ خَيۡرٗا لِّأَنفُسِكُمۡۗ وَمَن يُوقَ شُحَّ نَفۡسِهِۦ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡمُفۡلِحُونَ",
    translation:
      "So fear Allah as much as you are able and listen and obey and spend [in the way of Allah]; it is better for your selves. And whoever is protected from the stinginess of his soul - it is those who will be the successful",
    normalizedText:
      "فاتقوا الله ما استطعتم واسمعوا واطيعوا وانفقوا خيرا لانفسكم ومن يوق شح نفسه فاولاك هم المفلحون",
  },
  {
    verseId: 16,
    name: "التغابن",
    surahId: 64,
    text: "إِن تُقۡرِضُواْ ٱللَّهَ قَرۡضًا حَسَنٗا يُضَٰعِفۡهُ لَكُمۡ وَيَغۡفِرۡ لَكُمۡۚ وَٱللَّهُ شَكُورٌ حَلِيمٌ",
    translation:
      "If you loan Allah a goodly loan, He will multiply it for you and forgive you. And Allah is Most Appreciative and Forbearing",
    normalizedText:
      "ان تقرضوا الله قرضا حسنا يضعفه لكم ويغفر لكم والله شكور حليم",
  },
  {
    verseId: 17,
    name: "التغابن",
    surahId: 64,
    text: "عَٰلِمُ ٱلۡغَيۡبِ وَٱلشَّهَٰدَةِ ٱلۡعَزِيزُ ٱلۡحَكِيمُ",
    translation:
      "Knower of the unseen and the witnessed, the Exalted in Might, the Wise",
    normalizedText: "علم الغيب والشهدة العزيز الحكيم",
  },
  {
    verseId: 0,
    name: "الطلاق",
    surahId: 65,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ إِذَا طَلَّقۡتُمُ ٱلنِّسَآءَ فَطَلِّقُوهُنَّ لِعِدَّتِهِنَّ وَأَحۡصُواْ ٱلۡعِدَّةَۖ وَٱتَّقُواْ ٱللَّهَ رَبَّكُمۡۖ لَا تُخۡرِجُوهُنَّ مِنۢ بُيُوتِهِنَّ وَلَا يَخۡرُجۡنَ إِلَّآ أَن يَأۡتِينَ بِفَٰحِشَةٖ مُّبَيِّنَةٖۚ وَتِلۡكَ حُدُودُ ٱللَّهِۚ وَمَن يَتَعَدَّ حُدُودَ ٱللَّهِ فَقَدۡ ظَلَمَ نَفۡسَهُۥۚ لَا تَدۡرِي لَعَلَّ ٱللَّهَ يُحۡدِثُ بَعۡدَ ذَٰلِكَ أَمۡرٗا",
    translation:
      "O Prophet, when you [Muslims] divorce women, divorce them for [the commencement of] their waiting period and keep count of the waiting period, and fear Allah, your Lord. Do not turn them out of their [husbands'] houses, nor should they [themselves] leave [during that period] unless they are committing a clear immorality. And those are the limits [set by] Allah. And whoever transgresses the limits of Allah has certainly wronged himself. You know not; perhaps Allah will bring about after that a [different] matter",
    normalizedText:
      "يايها النبي اذا طلقتم النساء فطلقوهن لعدتهن واحصوا العدة واتقوا الله ربكم لا تخرجوهن من بيوتهن ولا يخرجن الا ان ياتين بفحشة مبينة وتلك حدود الله ومن يتعد حدود الله فقد ظلم نفسه لا تدري لعل الله يحدث بعد ذلك امرا",
  },
  {
    verseId: 1,
    name: "الطلاق",
    surahId: 65,
    text: "فَإِذَا بَلَغۡنَ أَجَلَهُنَّ فَأَمۡسِكُوهُنَّ بِمَعۡرُوفٍ أَوۡ فَارِقُوهُنَّ بِمَعۡرُوفٖ وَأَشۡهِدُواْ ذَوَيۡ عَدۡلٖ مِّنكُمۡ وَأَقِيمُواْ ٱلشَّهَٰدَةَ لِلَّهِۚ ذَٰلِكُمۡ يُوعَظُ بِهِۦ مَن كَانَ يُؤۡمِنُ بِٱللَّهِ وَٱلۡيَوۡمِ ٱلۡأٓخِرِۚ وَمَن يَتَّقِ ٱللَّهَ يَجۡعَل لَّهُۥ مَخۡرَجٗا",
    translation:
      "And when they have [nearly] fulfilled their term, either retain them according to acceptable terms or part with them according to acceptable terms. And bring to witness two just men from among you and establish the testimony for [the acceptance of] Allah. That is instructed to whoever should believe in Allah and the Last day. And whoever fears Allah - He will make for him a way out",
    normalizedText:
      "فاذا بلغن اجلهن فامسكوهن بمعروف او فارقوهن بمعروف واشهدوا ذوي عدل منكم واقيموا الشهدة لله ذلكم يوعظ به من كان يامن بالله واليوم الاخر ومن يتق الله يجعل له مخرجا",
  },
  {
    verseId: 2,
    name: "الطلاق",
    surahId: 65,
    text: "وَيَرۡزُقۡهُ مِنۡ حَيۡثُ لَا يَحۡتَسِبُۚ وَمَن يَتَوَكَّلۡ عَلَى ٱللَّهِ فَهُوَ حَسۡبُهُۥٓۚ إِنَّ ٱللَّهَ بَٰلِغُ أَمۡرِهِۦۚ قَدۡ جَعَلَ ٱللَّهُ لِكُلِّ شَيۡءٖ قَدۡرٗا",
    translation:
      "And will provide for him from where he does not expect. And whoever relies upon Allah - then He is sufficient for him. Indeed, Allah will accomplish His purpose. Allah has already set for everything a [decreed] extent",
    normalizedText:
      "ويرزقه من حيث لا يحتسب ومن يتوكل على الله فهو حسبه ان الله بلغ امره قد جعل الله لكل شيء قدرا",
  },
  {
    verseId: 3,
    name: "الطلاق",
    surahId: 65,
    text: "وَٱلَّـٰٓـِٔي يَئِسۡنَ مِنَ ٱلۡمَحِيضِ مِن نِّسَآئِكُمۡ إِنِ ٱرۡتَبۡتُمۡ فَعِدَّتُهُنَّ ثَلَٰثَةُ أَشۡهُرٖ وَٱلَّـٰٓـِٔي لَمۡ يَحِضۡنَۚ وَأُوْلَٰتُ ٱلۡأَحۡمَالِ أَجَلُهُنَّ أَن يَضَعۡنَ حَمۡلَهُنَّۚ وَمَن يَتَّقِ ٱللَّهَ يَجۡعَل لَّهُۥ مِنۡ أَمۡرِهِۦ يُسۡرٗا",
    translation:
      "And those who no longer expect menstruation among your women - if you doubt, then their period is three months, and [also for] those who have not menstruated. And for those who are pregnant, their term is until they give birth. And whoever fears Allah - He will make for him of his matter ease",
    normalizedText:
      "والي ياسن من المحيض من نسااكم ان ارتبتم فعدتهن ثلثة اشهر والي لم يحضن واولت الاحمال اجلهن ان يضعن حملهن ومن يتق الله يجعل له من امره يسرا",
  },
  {
    verseId: 4,
    name: "الطلاق",
    surahId: 65,
    text: "ذَٰلِكَ أَمۡرُ ٱللَّهِ أَنزَلَهُۥٓ إِلَيۡكُمۡۚ وَمَن يَتَّقِ ٱللَّهَ يُكَفِّرۡ عَنۡهُ سَيِّـَٔاتِهِۦ وَيُعۡظِمۡ لَهُۥٓ أَجۡرًا",
    translation:
      "That is the command of Allah, which He has sent down to you; and whoever fears Allah - He will remove for him his misdeeds and make great for him his reward",
    normalizedText:
      "ذلك امر الله انزله اليكم ومن يتق الله يكفر عنه سياته ويعظم له اجرا",
  },
  {
    verseId: 5,
    name: "الطلاق",
    surahId: 65,
    text: "أَسۡكِنُوهُنَّ مِنۡ حَيۡثُ سَكَنتُم مِّن وُجۡدِكُمۡ وَلَا تُضَآرُّوهُنَّ لِتُضَيِّقُواْ عَلَيۡهِنَّۚ وَإِن كُنَّ أُوْلَٰتِ حَمۡلٖ فَأَنفِقُواْ عَلَيۡهِنَّ حَتَّىٰ يَضَعۡنَ حَمۡلَهُنَّۚ فَإِنۡ أَرۡضَعۡنَ لَكُمۡ فَـَٔاتُوهُنَّ أُجُورَهُنَّ وَأۡتَمِرُواْ بَيۡنَكُم بِمَعۡرُوفٖۖ وَإِن تَعَاسَرۡتُمۡ فَسَتُرۡضِعُ لَهُۥٓ أُخۡرَىٰ",
    translation:
      "Lodge them [in a section] of where you dwell out of your means and do not harm them in order to oppress them. And if they should be pregnant, then spend on them until they give birth. And if they breastfeed for you, then give them their payment and confer among yourselves in the acceptable way; but if you are in discord, then there may breastfeed for the father another woman",
    normalizedText:
      "اسكنوهن من حيث سكنتم من وجدكم ولا تضاروهن لتضيقوا عليهن وان كن اولت حمل فانفقوا عليهن حتى يضعن حملهن فان ارضعن لكم فاتوهن اجورهن واتمروا بينكم بمعروف وان تعاسرتم فسترضع له اخرى",
  },
  {
    verseId: 6,
    name: "الطلاق",
    surahId: 65,
    text: "لِيُنفِقۡ ذُو سَعَةٖ مِّن سَعَتِهِۦۖ وَمَن قُدِرَ عَلَيۡهِ رِزۡقُهُۥ فَلۡيُنفِقۡ مِمَّآ ءَاتَىٰهُ ٱللَّهُۚ لَا يُكَلِّفُ ٱللَّهُ نَفۡسًا إِلَّا مَآ ءَاتَىٰهَاۚ سَيَجۡعَلُ ٱللَّهُ بَعۡدَ عُسۡرٖ يُسۡرٗا",
    translation:
      "Let a man of wealth spend from his wealth, and he whose provision is restricted - let him spend from what Allah has given him. Allah does not charge a soul except [according to] what He has given it. Allah will bring about, after hardship, ease",
    normalizedText:
      "لينفق ذو سعة من سعته ومن قدر عليه رزقه فلينفق مما ءاتىه الله لا يكلف الله نفسا الا ما ءاتىها سيجعل الله بعد عسر يسرا",
  },
  {
    verseId: 7,
    name: "الطلاق",
    surahId: 65,
    text: "وَكَأَيِّن مِّن قَرۡيَةٍ عَتَتۡ عَنۡ أَمۡرِ رَبِّهَا وَرُسُلِهِۦ فَحَاسَبۡنَٰهَا حِسَابٗا شَدِيدٗا وَعَذَّبۡنَٰهَا عَذَابٗا نُّكۡرٗا",
    translation:
      "And how many a city was insolent toward the command of its Lord and His messengers, so We took it to severe account and punished it with a terrible punishment",
    normalizedText:
      "وكاين من قرية عتت عن امر ربها ورسله فحاسبنها حسابا شديدا وعذبنها عذابا نكرا",
  },
  {
    verseId: 8,
    name: "الطلاق",
    surahId: 65,
    text: "فَذَاقَتۡ وَبَالَ أَمۡرِهَا وَكَانَ عَٰقِبَةُ أَمۡرِهَا خُسۡرًا",
    translation:
      "And it tasted the bad consequence of its affair, and the outcome of its affair was loss",
    normalizedText: "فذاقت وبال امرها وكان عقبة امرها خسرا",
  },
  {
    verseId: 9,
    name: "الطلاق",
    surahId: 65,
    text: "أَعَدَّ ٱللَّهُ لَهُمۡ عَذَابٗا شَدِيدٗاۖ فَٱتَّقُواْ ٱللَّهَ يَـٰٓأُوْلِي ٱلۡأَلۡبَٰبِ ٱلَّذِينَ ءَامَنُواْۚ قَدۡ أَنزَلَ ٱللَّهُ إِلَيۡكُمۡ ذِكۡرٗا",
    translation:
      "Allah has prepared for them a severe punishment; so fear Allah, O you of understanding who have believed. Allah has sent down to you the Qur'an",
    normalizedText:
      "اعد الله لهم عذابا شديدا فاتقوا الله ياولي الالبب الذين ءامنوا قد انزل الله اليكم ذكرا",
  },
  {
    verseId: 10,
    name: "الطلاق",
    surahId: 65,
    text: "رَّسُولٗا يَتۡلُواْ عَلَيۡكُمۡ ءَايَٰتِ ٱللَّهِ مُبَيِّنَٰتٖ لِّيُخۡرِجَ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ مِنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِۚ وَمَن يُؤۡمِنۢ بِٱللَّهِ وَيَعۡمَلۡ صَٰلِحٗا يُدۡخِلۡهُ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدٗاۖ قَدۡ أَحۡسَنَ ٱللَّهُ لَهُۥ رِزۡقًا",
    translation:
      "[He sent] a Messenger [Muhammad] reciting to you the distinct verses of Allah that He may bring out those who believe and do righteous deeds from darknesses into the light. And whoever believes in Allah and does righteousness - He will admit him into gardens beneath which rivers flow to abide therein forever. Allah will have perfected for him a provision",
    normalizedText:
      "رسولا يتلوا عليكم ءايت الله مبينت ليخرج الذين ءامنوا وعملوا الصلحت من الظلمت الى النور ومن يامن بالله ويعمل صلحا يدخله جنت تجري من تحتها الانهر خلدين فيها ابدا قد احسن الله له رزقا",
  },
  {
    verseId: 11,
    name: "الطلاق",
    surahId: 65,
    text: "ٱللَّهُ ٱلَّذِي خَلَقَ سَبۡعَ سَمَٰوَٰتٖ وَمِنَ ٱلۡأَرۡضِ مِثۡلَهُنَّۖ يَتَنَزَّلُ ٱلۡأَمۡرُ بَيۡنَهُنَّ لِتَعۡلَمُوٓاْ أَنَّ ٱللَّهَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ وَأَنَّ ٱللَّهَ قَدۡ أَحَاطَ بِكُلِّ شَيۡءٍ عِلۡمَۢا",
    translation:
      "It is Allah who has created seven heavens and of the earth, the like of them. [His] command descends among them so you may know that Allah is over all things competent and that Allah has encompassed all things in knowledge",
    normalizedText:
      "الله الذي خلق سبع سموت ومن الارض مثلهن يتنزل الامر بينهن لتعلموا ان الله على كل شيء قدير وان الله قد احاط بكل شيء علما",
  },
  {
    verseId: 0,
    name: "التحريم",
    surahId: 66,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ لِمَ تُحَرِّمُ مَآ أَحَلَّ ٱللَّهُ لَكَۖ تَبۡتَغِي مَرۡضَاتَ أَزۡوَٰجِكَۚ وَٱللَّهُ غَفُورٞ رَّحِيمٞ",
    translation:
      "O Prophet, why do you prohibit [yourself from] what Allah has made lawful for you, seeking the approval of your wives? And Allah is Forgiving and Merciful",
    normalizedText:
      "يايها النبي لم تحرم ما احل الله لك تبتغي مرضات ازوجك والله غفور رحيم",
  },
  {
    verseId: 1,
    name: "التحريم",
    surahId: 66,
    text: "قَدۡ فَرَضَ ٱللَّهُ لَكُمۡ تَحِلَّةَ أَيۡمَٰنِكُمۡۚ وَٱللَّهُ مَوۡلَىٰكُمۡۖ وَهُوَ ٱلۡعَلِيمُ ٱلۡحَكِيمُ",
    translation:
      "Allah has already ordained for you [Muslims] the dissolution of your oaths. And Allah is your protector, and He is the Knowing, the Wise",
    normalizedText:
      "قد فرض الله لكم تحلة ايمنكم والله مولىكم وهو العليم الحكيم",
  },
  {
    verseId: 2,
    name: "التحريم",
    surahId: 66,
    text: "وَإِذۡ أَسَرَّ ٱلنَّبِيُّ إِلَىٰ بَعۡضِ أَزۡوَٰجِهِۦ حَدِيثٗا فَلَمَّا نَبَّأَتۡ بِهِۦ وَأَظۡهَرَهُ ٱللَّهُ عَلَيۡهِ عَرَّفَ بَعۡضَهُۥ وَأَعۡرَضَ عَنۢ بَعۡضٖۖ فَلَمَّا نَبَّأَهَا بِهِۦ قَالَتۡ مَنۡ أَنۢبَأَكَ هَٰذَاۖ قَالَ نَبَّأَنِيَ ٱلۡعَلِيمُ ٱلۡخَبِيرُ",
    translation:
      'And [remember] when the Prophet confided to one of his wives a statement; and when she informed [another] of it and Allah showed it to him, he made known part of it and ignored a part. And when he informed her about it, she said, "Who told you this?" He said, "I was informed by the Knowing, the Acquainted',
    normalizedText:
      "واذ اسر النبي الى بعض ازوجه حديثا فلما نبات به واظهره الله عليه عرف بعضه واعرض عن بعض فلما نباها به قالت من انباك هذا قال نباني العليم الخبير",
  },
  {
    verseId: 3,
    name: "التحريم",
    surahId: 66,
    text: "إِن تَتُوبَآ إِلَى ٱللَّهِ فَقَدۡ صَغَتۡ قُلُوبُكُمَاۖ وَإِن تَظَٰهَرَا عَلَيۡهِ فَإِنَّ ٱللَّهَ هُوَ مَوۡلَىٰهُ وَجِبۡرِيلُ وَصَٰلِحُ ٱلۡمُؤۡمِنِينَۖ وَٱلۡمَلَـٰٓئِكَةُ بَعۡدَ ذَٰلِكَ ظَهِيرٌ",
    translation:
      "If you two [wives] repent to Allah, [it is best], for your hearts have deviated. But if you cooperate against him - then indeed Allah is his protector, and Gabriel and the righteous of the believers and the angels, moreover, are [his] assistants",
    normalizedText:
      "ان تتوبا الى الله فقد صغت قلوبكما وان تظهرا عليه فان الله هو مولىه وجبريل وصلح المامنين والملاكة بعد ذلك ظهير",
  },
  {
    verseId: 4,
    name: "التحريم",
    surahId: 66,
    text: "عَسَىٰ رَبُّهُۥٓ إِن طَلَّقَكُنَّ أَن يُبۡدِلَهُۥٓ أَزۡوَٰجًا خَيۡرٗا مِّنكُنَّ مُسۡلِمَٰتٖ مُّؤۡمِنَٰتٖ قَٰنِتَٰتٖ تَـٰٓئِبَٰتٍ عَٰبِدَٰتٖ سَـٰٓئِحَٰتٖ ثَيِّبَٰتٖ وَأَبۡكَارٗا",
    translation:
      "Perhaps his Lord, if he divorced you [all], would substitute for him wives better than you - submitting [to Allah], believing, devoutly obedient, repentant, worshipping, and traveling - [ones] previously married and virgins",
    normalizedText:
      "عسى ربه ان طلقكن ان يبدله ازوجا خيرا منكن مسلمت مامنت قنتت تابت عبدت ساحت ثيبت وابكارا",
  },
  {
    verseId: 5,
    name: "التحريم",
    surahId: 66,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ قُوٓاْ أَنفُسَكُمۡ وَأَهۡلِيكُمۡ نَارٗا وَقُودُهَا ٱلنَّاسُ وَٱلۡحِجَارَةُ عَلَيۡهَا مَلَـٰٓئِكَةٌ غِلَاظٞ شِدَادٞ لَّا يَعۡصُونَ ٱللَّهَ مَآ أَمَرَهُمۡ وَيَفۡعَلُونَ مَا يُؤۡمَرُونَ",
    translation:
      "O you who have believed, protect yourselves and your families from a Fire whose fuel is people and stones, over which are [appointed] angels, harsh and severe; they do not disobey Allah in what He commands them but do what they are commanded",
    normalizedText:
      "يايها الذين ءامنوا قوا انفسكم واهليكم نارا وقودها الناس والحجارة عليها ملاكة غلاظ شداد لا يعصون الله ما امرهم ويفعلون ما يامرون",
  },
  {
    verseId: 6,
    name: "التحريم",
    surahId: 66,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ كَفَرُواْ لَا تَعۡتَذِرُواْ ٱلۡيَوۡمَۖ إِنَّمَا تُجۡزَوۡنَ مَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      "O you who have disbelieved, make no excuses that Day. You will only be recompensed for what you used to do",
    normalizedText:
      "يايها الذين كفروا لا تعتذروا اليوم انما تجزون ما كنتم تعملون",
  },
  {
    verseId: 7,
    name: "التحريم",
    surahId: 66,
    text: "يَـٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُواْ تُوبُوٓاْ إِلَى ٱللَّهِ تَوۡبَةٗ نَّصُوحًا عَسَىٰ رَبُّكُمۡ أَن يُكَفِّرَ عَنكُمۡ سَيِّـَٔاتِكُمۡ وَيُدۡخِلَكُمۡ جَنَّـٰتٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ يَوۡمَ لَا يُخۡزِي ٱللَّهُ ٱلنَّبِيَّ وَٱلَّذِينَ ءَامَنُواْ مَعَهُۥۖ نُورُهُمۡ يَسۡعَىٰ بَيۡنَ أَيۡدِيهِمۡ وَبِأَيۡمَٰنِهِمۡ يَقُولُونَ رَبَّنَآ أَتۡمِمۡ لَنَا نُورَنَا وَٱغۡفِرۡ لَنَآۖ إِنَّكَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٞ",
    translation:
      'O you who have believed, repent to Allah with sincere repentance. Perhaps your Lord will remove from you your misdeeds and admit you into gardens beneath which rivers flow [on] the Day when Allah will not disgrace the Prophet and those who believed with him. Their light will proceed before them and on their right; they will say, "Our Lord, perfect for us our light and forgive us. Indeed, You are over all things competent',
    normalizedText:
      "يايها الذين ءامنوا توبوا الى الله توبة نصوحا عسى ربكم ان يكفر عنكم سياتكم ويدخلكم جنت تجري من تحتها الانهر يوم لا يخزي الله النبي والذين ءامنوا معه نورهم يسعى بين ايديهم وبايمنهم يقولون ربنا اتمم لنا نورنا واغفر لنا انك على كل شيء قدير",
  },
  {
    verseId: 8,
    name: "التحريم",
    surahId: 66,
    text: "يَـٰٓأَيُّهَا ٱلنَّبِيُّ جَٰهِدِ ٱلۡكُفَّارَ وَٱلۡمُنَٰفِقِينَ وَٱغۡلُظۡ عَلَيۡهِمۡۚ وَمَأۡوَىٰهُمۡ جَهَنَّمُۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "O Prophet, strive against the disbelievers and the hypocrites and be harsh upon them. And their refuge is Hell, and wretched is the destination",
    normalizedText:
      "يايها النبي جهد الكفار والمنفقين واغلظ عليهم وماوىهم جهنم وباس المصير",
  },
  {
    verseId: 9,
    name: "التحريم",
    surahId: 66,
    text: "ضَرَبَ ٱللَّهُ مَثَلٗا لِّلَّذِينَ كَفَرُواْ ٱمۡرَأَتَ نُوحٖ وَٱمۡرَأَتَ لُوطٖۖ كَانَتَا تَحۡتَ عَبۡدَيۡنِ مِنۡ عِبَادِنَا صَٰلِحَيۡنِ فَخَانَتَاهُمَا فَلَمۡ يُغۡنِيَا عَنۡهُمَا مِنَ ٱللَّهِ شَيۡـٔٗا وَقِيلَ ٱدۡخُلَا ٱلنَّارَ مَعَ ٱلدَّـٰخِلِينَ",
    translation:
      'Allah presents an example of those who disbelieved: the wife of Noah and the wife of Lot. They were under two of Our righteous servants but betrayed them, so those prophets did not avail them from Allah at all, and it was said, "Enter the Fire with those who enter',
    normalizedText:
      "ضرب الله مثلا للذين كفروا امرات نوح وامرات لوط كانتا تحت عبدين من عبادنا صلحين فخانتاهما فلم يغنيا عنهما من الله شيا وقيل ادخلا النار مع الدخلين",
  },
  {
    verseId: 10,
    name: "التحريم",
    surahId: 66,
    text: "وَضَرَبَ ٱللَّهُ مَثَلٗا لِّلَّذِينَ ءَامَنُواْ ٱمۡرَأَتَ فِرۡعَوۡنَ إِذۡ قَالَتۡ رَبِّ ٱبۡنِ لِي عِندَكَ بَيۡتٗا فِي ٱلۡجَنَّةِ وَنَجِّنِي مِن فِرۡعَوۡنَ وَعَمَلِهِۦ وَنَجِّنِي مِنَ ٱلۡقَوۡمِ ٱلظَّـٰلِمِينَ",
    translation:
      'And Allah presents an example of those who believed: the wife of Pharaoh, when she said, "My Lord, build for me near You a house in Paradise and save me from Pharaoh and his deeds and save me from the wrongdoing people',
    normalizedText:
      "وضرب الله مثلا للذين ءامنوا امرات فرعون اذ قالت رب ابن لي عندك بيتا في الجنة ونجني من فرعون وعمله ونجني من القوم الظلمين",
  },
  {
    verseId: 11,
    name: "التحريم",
    surahId: 66,
    text: "وَمَرۡيَمَ ٱبۡنَتَ عِمۡرَٰنَ ٱلَّتِيٓ أَحۡصَنَتۡ فَرۡجَهَا فَنَفَخۡنَا فِيهِ مِن رُّوحِنَا وَصَدَّقَتۡ بِكَلِمَٰتِ رَبِّهَا وَكُتُبِهِۦ وَكَانَتۡ مِنَ ٱلۡقَٰنِتِينَ",
    translation:
      "And [the example of] Mary, the daughter of 'Imran, who guarded her chastity, so We blew into [her garment] through Our angel, and she believed in the words of her Lord and His scriptures and was of the devoutly obedient",
    normalizedText:
      "ومريم ابنت عمرن التي احصنت فرجها فنفخنا فيه من روحنا وصدقت بكلمت ربها وكتبه وكانت من القنتين",
  },
  {
    verseId: 0,
    name: "الملك",
    surahId: 67,
    text: "تَبَٰرَكَ ٱلَّذِي بِيَدِهِ ٱلۡمُلۡكُ وَهُوَ عَلَىٰ كُلِّ شَيۡءٖ قَدِيرٌ",
    translation:
      "Blessed is He in whose hand is dominion, and He is over all things competent",
    normalizedText: "تبرك الذي بيده الملك وهو على كل شيء قدير",
  },
  {
    verseId: 1,
    name: "الملك",
    surahId: 67,
    text: "ٱلَّذِي خَلَقَ ٱلۡمَوۡتَ وَٱلۡحَيَوٰةَ لِيَبۡلُوَكُمۡ أَيُّكُمۡ أَحۡسَنُ عَمَلٗاۚ وَهُوَ ٱلۡعَزِيزُ ٱلۡغَفُورُ",
    translation:
      "[He] who created death and life to test you [as to] which of you is best in deed - and He is the Exalted in Might, the Forgiving",
    normalizedText:
      "الذي خلق الموت والحيوة ليبلوكم ايكم احسن عملا وهو العزيز الغفور",
  },
  {
    verseId: 2,
    name: "الملك",
    surahId: 67,
    text: "ٱلَّذِي خَلَقَ سَبۡعَ سَمَٰوَٰتٖ طِبَاقٗاۖ مَّا تَرَىٰ فِي خَلۡقِ ٱلرَّحۡمَٰنِ مِن تَفَٰوُتٖۖ فَٱرۡجِعِ ٱلۡبَصَرَ هَلۡ تَرَىٰ مِن فُطُورٖ",
    translation:
      "[And] who created seven heavens in layers. You do not see in the creation of the Most Merciful any inconsistency. So return [your] vision [to the sky]; do you see any breaks",
    normalizedText:
      "الذي خلق سبع سموت طباقا ما ترى في خلق الرحمن من تفوت فارجع البصر هل ترى من فطور",
  },
  {
    verseId: 3,
    name: "الملك",
    surahId: 67,
    text: "ثُمَّ ٱرۡجِعِ ٱلۡبَصَرَ كَرَّتَيۡنِ يَنقَلِبۡ إِلَيۡكَ ٱلۡبَصَرُ خَاسِئٗا وَهُوَ حَسِيرٞ",
    translation:
      "Then return [your] vision twice again. [Your] vision will return to you humbled while it is fatigued",
    normalizedText: "ثم ارجع البصر كرتين ينقلب اليك البصر خاساا وهو حسير",
  },
  {
    verseId: 4,
    name: "الملك",
    surahId: 67,
    text: "وَلَقَدۡ زَيَّنَّا ٱلسَّمَآءَ ٱلدُّنۡيَا بِمَصَٰبِيحَ وَجَعَلۡنَٰهَا رُجُومٗا لِّلشَّيَٰطِينِۖ وَأَعۡتَدۡنَا لَهُمۡ عَذَابَ ٱلسَّعِيرِ",
    translation:
      "And We have certainly beautified the nearest heaven with stars and have made [from] them what is thrown at the devils and have prepared for them the punishment of the Blaze",
    normalizedText:
      "ولقد زينا السماء الدنيا بمصبيح وجعلنها رجوما للشيطين واعتدنا لهم عذاب السعير",
  },
  {
    verseId: 5,
    name: "الملك",
    surahId: 67,
    text: "وَلِلَّذِينَ كَفَرُواْ بِرَبِّهِمۡ عَذَابُ جَهَنَّمَۖ وَبِئۡسَ ٱلۡمَصِيرُ",
    translation:
      "And for those who disbelieved in their Lord is the punishment of Hell, and wretched is the destination",
    normalizedText: "وللذين كفروا بربهم عذاب جهنم وباس المصير",
  },
  {
    verseId: 6,
    name: "الملك",
    surahId: 67,
    text: "إِذَآ أُلۡقُواْ فِيهَا سَمِعُواْ لَهَا شَهِيقٗا وَهِيَ تَفُورُ",
    translation:
      "When they are thrown into it, they hear from it a [dreadful] inhaling while it boils up",
    normalizedText: "اذا القوا فيها سمعوا لها شهيقا وهي تفور",
  },
  {
    verseId: 7,
    name: "الملك",
    surahId: 67,
    text: "تَكَادُ تَمَيَّزُ مِنَ ٱلۡغَيۡظِۖ كُلَّمَآ أُلۡقِيَ فِيهَا فَوۡجٞ سَأَلَهُمۡ خَزَنَتُهَآ أَلَمۡ يَأۡتِكُمۡ نَذِيرٞ",
    translation:
      'It almost bursts with rage. Every time a company is thrown into it, its keepers ask them, "Did there not come to you a warner',
    normalizedText:
      "تكاد تميز من الغيظ كلما القي فيها فوج سالهم خزنتها الم ياتكم نذير",
  },
  {
    verseId: 8,
    name: "الملك",
    surahId: 67,
    text: "قَالُواْ بَلَىٰ قَدۡ جَآءَنَا نَذِيرٞ فَكَذَّبۡنَا وَقُلۡنَا مَا نَزَّلَ ٱللَّهُ مِن شَيۡءٍ إِنۡ أَنتُمۡ إِلَّا فِي ضَلَٰلٖ كَبِيرٖ",
    translation: `They will say," Yes, a warner had come to us, but we denied and said, 'Allah has not sent down anything. You are not but in great error`,
    normalizedText:
      "قالوا بلى قد جاءنا نذير فكذبنا وقلنا ما نزل الله من شيء ان انتم الا في ضلل كبير",
  },
  {
    verseId: 9,
    name: "الملك",
    surahId: 67,
    text: "وَقَالُواْ لَوۡ كُنَّا نَسۡمَعُ أَوۡ نَعۡقِلُ مَا كُنَّا فِيٓ أَصۡحَٰبِ ٱلسَّعِيرِ",
    translation:
      'And they will say, "If only we had been listening or reasoning, we would not be among the companions of the Blaze',
    normalizedText: "وقالوا لو كنا نسمع او نعقل ما كنا في اصحب السعير",
  },
  {
    verseId: 10,
    name: "الملك",
    surahId: 67,
    text: "فَٱعۡتَرَفُواْ بِذَنۢبِهِمۡ فَسُحۡقٗا لِّأَصۡحَٰبِ ٱلسَّعِيرِ",
    translation:
      "And they will admit their sin, so [it is] alienation for the companions of the Blaze",
    normalizedText: "فاعترفوا بذنبهم فسحقا لاصحب السعير",
  },
  {
    verseId: 11,
    name: "الملك",
    surahId: 67,
    text: "إِنَّ ٱلَّذِينَ يَخۡشَوۡنَ رَبَّهُم بِٱلۡغَيۡبِ لَهُم مَّغۡفِرَةٞ وَأَجۡرٞ كَبِيرٞ",
    translation:
      "Indeed, those who fear their Lord unseen will have forgiveness and great reward",
    normalizedText: "ان الذين يخشون ربهم بالغيب لهم مغفرة واجر كبير",
  },
  {
    verseId: 12,
    name: "الملك",
    surahId: 67,
    text: "وَأَسِرُّواْ قَوۡلَكُمۡ أَوِ ٱجۡهَرُواْ بِهِۦٓۖ إِنَّهُۥ عَلِيمُۢ بِذَاتِ ٱلصُّدُورِ",
    translation:
      "And conceal your speech or publicize it; indeed, He is Knowing of that within the breasts",
    normalizedText: "واسروا قولكم او اجهروا به انه عليم بذات الصدور",
  },
  {
    verseId: 13,
    name: "الملك",
    surahId: 67,
    text: "أَلَا يَعۡلَمُ مَنۡ خَلَقَ وَهُوَ ٱللَّطِيفُ ٱلۡخَبِيرُ",
    translation:
      "Does He who created not know, while He is the Subtle, the Acquainted",
    normalizedText: "الا يعلم من خلق وهو اللطيف الخبير",
  },
  {
    verseId: 14,
    name: "الملك",
    surahId: 67,
    text: "هُوَ ٱلَّذِي جَعَلَ لَكُمُ ٱلۡأَرۡضَ ذَلُولٗا فَٱمۡشُواْ فِي مَنَاكِبِهَا وَكُلُواْ مِن رِّزۡقِهِۦۖ وَإِلَيۡهِ ٱلنُّشُورُ",
    translation:
      "It is He who made the earth tame for you - so walk among its slopes and eat of His provision - and to Him is the resurrection",
    normalizedText:
      "هو الذي جعل لكم الارض ذلولا فامشوا في مناكبها وكلوا من رزقه واليه النشور",
  },
  {
    verseId: 15,
    name: "الملك",
    surahId: 67,
    text: "ءَأَمِنتُم مَّن فِي ٱلسَّمَآءِ أَن يَخۡسِفَ بِكُمُ ٱلۡأَرۡضَ فَإِذَا هِيَ تَمُورُ",
    translation:
      "Do you feel secure that He who [holds authority] in the heaven would not cause the earth to swallow you and suddenly it would sway",
    normalizedText: "ءامنتم من في السماء ان يخسف بكم الارض فاذا هي تمور",
  },
  {
    verseId: 16,
    name: "الملك",
    surahId: 67,
    text: "أَمۡ أَمِنتُم مَّن فِي ٱلسَّمَآءِ أَن يُرۡسِلَ عَلَيۡكُمۡ حَاصِبٗاۖ فَسَتَعۡلَمُونَ كَيۡفَ نَذِيرِ",
    translation:
      "Or do you feel secure that He who [holds authority] in the heaven would not send against you a storm of stones? Then you would know how [severe] was My warning",
    normalizedText:
      "ام امنتم من في السماء ان يرسل عليكم حاصبا فستعلمون كيف نذير",
  },
  {
    verseId: 17,
    name: "الملك",
    surahId: 67,
    text: "وَلَقَدۡ كَذَّبَ ٱلَّذِينَ مِن قَبۡلِهِمۡ فَكَيۡفَ كَانَ نَكِيرِ",
    translation:
      "And already had those before them denied, and how [terrible] was My reproach",
    normalizedText: "ولقد كذب الذين من قبلهم فكيف كان نكير",
  },
  {
    verseId: 18,
    name: "الملك",
    surahId: 67,
    text: "أَوَلَمۡ يَرَوۡاْ إِلَى ٱلطَّيۡرِ فَوۡقَهُمۡ صَـٰٓفَّـٰتٖ وَيَقۡبِضۡنَۚ مَا يُمۡسِكُهُنَّ إِلَّا ٱلرَّحۡمَٰنُۚ إِنَّهُۥ بِكُلِّ شَيۡءِۭ بَصِيرٌ",
    translation:
      "Do they not see the birds above them with wings outspread and [sometimes] folded in? None holds them [aloft] except the Most Merciful. Indeed He is, of all things, Seeing",
    normalizedText:
      "اولم يروا الى الطير فوقهم صفت ويقبضن ما يمسكهن الا الرحمن انه بكل شيء بصير",
  },
  {
    verseId: 19,
    name: "الملك",
    surahId: 67,
    text: "أَمَّنۡ هَٰذَا ٱلَّذِي هُوَ جُندٞ لَّكُمۡ يَنصُرُكُم مِّن دُونِ ٱلرَّحۡمَٰنِۚ إِنِ ٱلۡكَٰفِرُونَ إِلَّا فِي غُرُورٍ",
    translation:
      "Or who is it that could be an army for you to aid you other than the Most Merciful? The disbelievers are not but in delusion",
    normalizedText:
      "امن هذا الذي هو جند لكم ينصركم من دون الرحمن ان الكفرون الا في غرور",
  },
  {
    verseId: 20,
    name: "الملك",
    surahId: 67,
    text: "أَمَّنۡ هَٰذَا ٱلَّذِي يَرۡزُقُكُمۡ إِنۡ أَمۡسَكَ رِزۡقَهُۥۚ بَل لَّجُّواْ فِي عُتُوّٖ وَنُفُورٍ",
    translation:
      "Or who is it that could provide for you if He withheld His provision? But they have persisted in insolence and aversion",
    normalizedText: "امن هذا الذي يرزقكم ان امسك رزقه بل لجوا في عتو ونفور",
  },
  {
    verseId: 21,
    name: "الملك",
    surahId: 67,
    text: "أَفَمَن يَمۡشِي مُكِبًّا عَلَىٰ وَجۡهِهِۦٓ أَهۡدَىٰٓ أَمَّن يَمۡشِي سَوِيًّا عَلَىٰ صِرَٰطٖ مُّسۡتَقِيمٖ",
    translation:
      "Then is one who walks fallen on his face better guided or one who walks erect on a straight path",
    normalizedText: "افمن يمشي مكبا على وجهه اهدى امن يمشي سويا على صرط مستقيم",
  },
  {
    verseId: 22,
    name: "الملك",
    surahId: 67,
    text: "قُلۡ هُوَ ٱلَّذِيٓ أَنشَأَكُمۡ وَجَعَلَ لَكُمُ ٱلسَّمۡعَ وَٱلۡأَبۡصَٰرَ وَٱلۡأَفۡـِٔدَةَۚ قَلِيلٗا مَّا تَشۡكُرُونَ",
    translation:
      'Say, "It is He who has produced you and made for you hearing and vision and hearts; little are you grateful',
    normalizedText:
      "قل هو الذي انشاكم وجعل لكم السمع والابصر والافدة قليلا ما تشكرون",
  },
  {
    verseId: 23,
    name: "الملك",
    surahId: 67,
    text: "قُلۡ هُوَ ٱلَّذِي ذَرَأَكُمۡ فِي ٱلۡأَرۡضِ وَإِلَيۡهِ تُحۡشَرُونَ",
    translation:
      'Say, "It is He who has multiplied you throughout the earth, and to Him you will be gathered',
    normalizedText: "قل هو الذي ذراكم في الارض واليه تحشرون",
  },
  {
    verseId: 24,
    name: "الملك",
    surahId: 67,
    text: "وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلۡوَعۡدُ إِن كُنتُمۡ صَٰدِقِينَ",
    translation:
      'And they say, "When is this promise, if you should be truthful',
    normalizedText: "ويقولون متى هذا الوعد ان كنتم صدقين",
  },
  {
    verseId: 25,
    name: "الملك",
    surahId: 67,
    text: "قُلۡ إِنَّمَا ٱلۡعِلۡمُ عِندَ ٱللَّهِ وَإِنَّمَآ أَنَا۠ نَذِيرٞ مُّبِينٞ",
    translation:
      'Say, "The knowledge is only with Allah, and I am only a clear warner',
    normalizedText: "قل انما العلم عند الله وانما انا نذير مبين",
  },
  {
    verseId: 26,
    name: "الملك",
    surahId: 67,
    text: "فَلَمَّا رَأَوۡهُ زُلۡفَةٗ سِيٓـَٔتۡ وُجُوهُ ٱلَّذِينَ كَفَرُواْ وَقِيلَ هَٰذَا ٱلَّذِي كُنتُم بِهِۦ تَدَّعُونَ",
    translation:
      'But when they see it approaching, the faces of those who disbelieve will be distressed, and it will be said, "This is that for which you used to call',
    normalizedText:
      "فلما راوه زلفة سيت وجوه الذين كفروا وقيل هذا الذي كنتم به تدعون",
  },
  {
    verseId: 27,
    name: "الملك",
    surahId: 67,
    text: "قُلۡ أَرَءَيۡتُمۡ إِنۡ أَهۡلَكَنِيَ ٱللَّهُ وَمَن مَّعِيَ أَوۡ رَحِمَنَا فَمَن يُجِيرُ ٱلۡكَٰفِرِينَ مِنۡ عَذَابٍ أَلِيمٖ",
    translation:
      'Say, [O Muhammad], "Have you considered: whether Allah should cause my death and those with me or have mercy upon us, who can protect the disbelievers from a painful punishment',
    normalizedText:
      "قل ارءيتم ان اهلكني الله ومن معي او رحمنا فمن يجير الكفرين من عذاب اليم",
  },
  {
    verseId: 28,
    name: "الملك",
    surahId: 67,
    text: "قُلۡ هُوَ ٱلرَّحۡمَٰنُ ءَامَنَّا بِهِۦ وَعَلَيۡهِ تَوَكَّلۡنَاۖ فَسَتَعۡلَمُونَ مَنۡ هُوَ فِي ضَلَٰلٖ مُّبِينٖ",
    translation:
      'Say, "He is the Most Merciful; we have believed in Him, and upon Him we have relied. And you will [come to] know who it is that is in clear error',
    normalizedText:
      "قل هو الرحمن ءامنا به وعليه توكلنا فستعلمون من هو في ضلل مبين",
  },
  {
    verseId: 29,
    name: "الملك",
    surahId: 67,
    text: "قُلۡ أَرَءَيۡتُمۡ إِنۡ أَصۡبَحَ مَآؤُكُمۡ غَوۡرٗا فَمَن يَأۡتِيكُم بِمَآءٖ مَّعِينِۭ",
    translation:
      'Say, "Have you considered: if your water was to become sunken [into the earth], then who could bring you flowing water',
    normalizedText: "قل ارءيتم ان اصبح مااكم غورا فمن ياتيكم بماء معين",
  },
  {
    verseId: 0,
    name: "القلم",
    surahId: 68,
    text: "نٓۚ وَٱلۡقَلَمِ وَمَا يَسۡطُرُونَ",
    translation: "Nun. By the pen and what they inscribe",
    normalizedText: "ن والقلم وما يسطرون",
  },
  {
    verseId: 1,
    name: "القلم",
    surahId: 68,
    text: "مَآ أَنتَ بِنِعۡمَةِ رَبِّكَ بِمَجۡنُونٖ",
    translation:
      "You are not, [O Muhammad], by the favor of your Lord, a madman",
    normalizedText: "ما انت بنعمة ربك بمجنون",
  },
  {
    verseId: 2,
    name: "القلم",
    surahId: 68,
    text: "وَإِنَّ لَكَ لَأَجۡرًا غَيۡرَ مَمۡنُونٖ",
    translation: "And indeed, for you is a reward uninterrupted",
    normalizedText: "وان لك لاجرا غير ممنون",
  },
  {
    verseId: 3,
    name: "القلم",
    surahId: 68,
    text: "وَإِنَّكَ لَعَلَىٰ خُلُقٍ عَظِيمٖ",
    translation: "And indeed, you are of a great moral character",
    normalizedText: "وانك لعلى خلق عظيم",
  },
  {
    verseId: 4,
    name: "القلم",
    surahId: 68,
    text: "فَسَتُبۡصِرُ وَيُبۡصِرُونَ",
    translation: "So you will see and they will see",
    normalizedText: "فستبصر ويبصرون",
  },
  {
    verseId: 5,
    name: "القلم",
    surahId: 68,
    text: "بِأَييِّكُمُ ٱلۡمَفۡتُونُ",
    translation: "Which of you is the afflicted [by a devil]",
    normalizedText: "باييكم المفتون",
  },
  {
    verseId: 6,
    name: "القلم",
    surahId: 68,
    text: "إِنَّ رَبَّكَ هُوَ أَعۡلَمُ بِمَن ضَلَّ عَن سَبِيلِهِۦ وَهُوَ أَعۡلَمُ بِٱلۡمُهۡتَدِينَ",
    translation:
      "Indeed, your Lord is most knowing of who has gone astray from His way, and He is most knowing of the [rightly] guided",
    normalizedText: "ان ربك هو اعلم بمن ضل عن سبيله وهو اعلم بالمهتدين",
  },
  {
    verseId: 7,
    name: "القلم",
    surahId: 68,
    text: "فَلَا تُطِعِ ٱلۡمُكَذِّبِينَ",
    translation: "Then do not obey the deniers",
    normalizedText: "فلا تطع المكذبين",
  },
  {
    verseId: 8,
    name: "القلم",
    surahId: 68,
    text: "وَدُّواْ لَوۡ تُدۡهِنُ فَيُدۡهِنُونَ",
    translation:
      "They wish that you would soften [in your position], so they would soften [toward you]",
    normalizedText: "ودوا لو تدهن فيدهنون",
  },
  {
    verseId: 9,
    name: "القلم",
    surahId: 68,
    text: "وَلَا تُطِعۡ كُلَّ حَلَّافٖ مَّهِينٍ",
    translation: "And do not obey every worthless habitual swearer",
    normalizedText: "ولا تطع كل حلاف مهين",
  },
  {
    verseId: 10,
    name: "القلم",
    surahId: 68,
    text: "هَمَّازٖ مَّشَّآءِۭ بِنَمِيمٖ",
    translation: "[And] scorner, going about with malicious gossip",
    normalizedText: "هماز مشاء بنميم",
  },
  {
    verseId: 11,
    name: "القلم",
    surahId: 68,
    text: "مَّنَّاعٖ لِّلۡخَيۡرِ مُعۡتَدٍ أَثِيمٍ",
    translation: "A preventer of good, transgressing and sinful",
    normalizedText: "مناع للخير معتد اثيم",
  },
  {
    verseId: 12,
    name: "القلم",
    surahId: 68,
    text: "عُتُلِّۭ بَعۡدَ ذَٰلِكَ زَنِيمٍ",
    translation: "Cruel, moreover, and an illegitimate pretender",
    normalizedText: "عتل بعد ذلك زنيم",
  },
  {
    verseId: 13,
    name: "القلم",
    surahId: 68,
    text: "أَن كَانَ ذَا مَالٖ وَبَنِينَ",
    translation: "Because he is a possessor of wealth and children",
    normalizedText: "ان كان ذا مال وبنين",
  },
  {
    verseId: 14,
    name: "القلم",
    surahId: 68,
    text: "إِذَا تُتۡلَىٰ عَلَيۡهِ ءَايَٰتُنَا قَالَ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      'When Our verses are recited to him, he says, "Legends of the former peoples',
    normalizedText: "اذا تتلى عليه ءايتنا قال اسطير الاولين",
  },
  {
    verseId: 15,
    name: "القلم",
    surahId: 68,
    text: "سَنَسِمُهُۥ عَلَى ٱلۡخُرۡطُومِ",
    translation: "We will brand him upon the snout",
    normalizedText: "سنسمه على الخرطوم",
  },
  {
    verseId: 16,
    name: "القلم",
    surahId: 68,
    text: "إِنَّا بَلَوۡنَٰهُمۡ كَمَا بَلَوۡنَآ أَصۡحَٰبَ ٱلۡجَنَّةِ إِذۡ أَقۡسَمُواْ لَيَصۡرِمُنَّهَا مُصۡبِحِينَ",
    translation:
      "Indeed, We have tried them as We tried the companions of the garden, when they swore to cut its fruit in the [early] morning",
    normalizedText: "انا بلونهم كما بلونا اصحب الجنة اذ اقسموا ليصرمنها مصبحين",
  },
  {
    verseId: 17,
    name: "القلم",
    surahId: 68,
    text: "وَلَا يَسۡتَثۡنُونَ",
    translation: "Without making exception",
    normalizedText: "ولا يستثنون",
  },
  {
    verseId: 18,
    name: "القلم",
    surahId: 68,
    text: "فَطَافَ عَلَيۡهَا طَآئِفٞ مِّن رَّبِّكَ وَهُمۡ نَآئِمُونَ",
    translation:
      "So there came upon the garden an affliction from your Lord while they were asleep",
    normalizedText: "فطاف عليها طااف من ربك وهم ناامون",
  },
  {
    verseId: 19,
    name: "القلم",
    surahId: 68,
    text: "فَأَصۡبَحَتۡ كَٱلصَّرِيمِ",
    translation: "And it became as though reaped",
    normalizedText: "فاصبحت كالصريم",
  },
  {
    verseId: 20,
    name: "القلم",
    surahId: 68,
    text: "فَتَنَادَوۡاْ مُصۡبِحِينَ",
    translation: "And they called one another at morning",
    normalizedText: "فتنادوا مصبحين",
  },
  {
    verseId: 21,
    name: "القلم",
    surahId: 68,
    text: "أَنِ ٱغۡدُواْ عَلَىٰ حَرۡثِكُمۡ إِن كُنتُمۡ صَٰرِمِينَ",
    translation: '[Saying], "Go early to your crop if you would cut the fruit',
    normalizedText: "ان اغدوا على حرثكم ان كنتم صرمين",
  },
  {
    verseId: 22,
    name: "القلم",
    surahId: 68,
    text: "فَٱنطَلَقُواْ وَهُمۡ يَتَخَٰفَتُونَ",
    translation: "So they set out, while lowering their voices",
    normalizedText: "فانطلقوا وهم يتخفتون",
  },
  {
    verseId: 23,
    name: "القلم",
    surahId: 68,
    text: "أَن لَّا يَدۡخُلَنَّهَا ٱلۡيَوۡمَ عَلَيۡكُم مِّسۡكِينٞ",
    translation:
      '[Saying], "There will surely not enter it today upon you [any] poor person',
    normalizedText: "ان لا يدخلنها اليوم عليكم مسكين",
  },
  {
    verseId: 24,
    name: "القلم",
    surahId: 68,
    text: "وَغَدَوۡاْ عَلَىٰ حَرۡدٖ قَٰدِرِينَ",
    translation:
      "And they went early in determination, [assuming themselves] able",
    normalizedText: "وغدوا على حرد قدرين",
  },
  {
    verseId: 25,
    name: "القلم",
    surahId: 68,
    text: "فَلَمَّا رَأَوۡهَا قَالُوٓاْ إِنَّا لَضَآلُّونَ",
    translation: 'But when they saw it, they said, "Indeed, we are lost',
    normalizedText: "فلما راوها قالوا انا لضالون",
  },
  {
    verseId: 26,
    name: "القلم",
    surahId: 68,
    text: "بَلۡ نَحۡنُ مَحۡرُومُونَ",
    translation: "Rather, we have been deprived",
    normalizedText: "بل نحن محرومون",
  },
  {
    verseId: 27,
    name: "القلم",
    surahId: 68,
    text: "قَالَ أَوۡسَطُهُمۡ أَلَمۡ أَقُل لَّكُمۡ لَوۡلَا تُسَبِّحُونَ",
    translation: `The most moderate of them said, "Did I not say to you, 'Why do you not exalt [Allah]`,
    normalizedText: "قال اوسطهم الم اقل لكم لولا تسبحون",
  },
  {
    verseId: 28,
    name: "القلم",
    surahId: 68,
    text: "قَالُواْ سُبۡحَٰنَ رَبِّنَآ إِنَّا كُنَّا ظَٰلِمِينَ",
    translation: 'They said, "Exalted is our Lord! Indeed, we were wrongdoers',
    normalizedText: "قالوا سبحن ربنا انا كنا ظلمين",
  },
  {
    verseId: 29,
    name: "القلم",
    surahId: 68,
    text: "فَأَقۡبَلَ بَعۡضُهُمۡ عَلَىٰ بَعۡضٖ يَتَلَٰوَمُونَ",
    translation: "Then they approached one another, blaming each other",
    normalizedText: "فاقبل بعضهم على بعض يتلومون",
  },
  {
    verseId: 30,
    name: "القلم",
    surahId: 68,
    text: "قَالُواْ يَٰوَيۡلَنَآ إِنَّا كُنَّا طَٰغِينَ",
    translation: 'They said, "O woe to us; indeed we were transgressors',
    normalizedText: "قالوا يويلنا انا كنا طغين",
  },
  {
    verseId: 31,
    name: "القلم",
    surahId: 68,
    text: "عَسَىٰ رَبُّنَآ أَن يُبۡدِلَنَا خَيۡرٗا مِّنۡهَآ إِنَّآ إِلَىٰ رَبِّنَا رَٰغِبُونَ",
    translation:
      "Perhaps our Lord will substitute for us [one] better than it. Indeed, we are toward our Lord desirous",
    normalizedText: "عسى ربنا ان يبدلنا خيرا منها انا الى ربنا رغبون",
  },
  {
    verseId: 32,
    name: "القلم",
    surahId: 68,
    text: "كَذَٰلِكَ ٱلۡعَذَابُۖ وَلَعَذَابُ ٱلۡأٓخِرَةِ أَكۡبَرُۚ لَوۡ كَانُواْ يَعۡلَمُونَ",
    translation:
      "Such is the punishment [of this world]. And the punishment of the Hereafter is greater, if they only knew",
    normalizedText: "كذلك العذاب ولعذاب الاخرة اكبر لو كانوا يعلمون",
  },
  {
    verseId: 33,
    name: "القلم",
    surahId: 68,
    text: "إِنَّ لِلۡمُتَّقِينَ عِندَ رَبِّهِمۡ جَنَّـٰتِ ٱلنَّعِيمِ",
    translation:
      "Indeed, for the righteous with their Lord are the Gardens of Pleasure",
    normalizedText: "ان للمتقين عند ربهم جنت النعيم",
  },
  {
    verseId: 34,
    name: "القلم",
    surahId: 68,
    text: "أَفَنَجۡعَلُ ٱلۡمُسۡلِمِينَ كَٱلۡمُجۡرِمِينَ",
    translation: "Then will We treat the Muslims like the criminals",
    normalizedText: "افنجعل المسلمين كالمجرمين",
  },
  {
    verseId: 35,
    name: "القلم",
    surahId: 68,
    text: "مَا لَكُمۡ كَيۡفَ تَحۡكُمُونَ",
    translation: "What is [the matter] with you? How do you judge",
    normalizedText: "ما لكم كيف تحكمون",
  },
  {
    verseId: 36,
    name: "القلم",
    surahId: 68,
    text: "أَمۡ لَكُمۡ كِتَٰبٞ فِيهِ تَدۡرُسُونَ",
    translation: "Or do you have a scripture in which you learn",
    normalizedText: "ام لكم كتب فيه تدرسون",
  },
  {
    verseId: 37,
    name: "القلم",
    surahId: 68,
    text: "إِنَّ لَكُمۡ فِيهِ لَمَا تَخَيَّرُونَ",
    translation: "That indeed for you is whatever you choose",
    normalizedText: "ان لكم فيه لما تخيرون",
  },
  {
    verseId: 38,
    name: "القلم",
    surahId: 68,
    text: "أَمۡ لَكُمۡ أَيۡمَٰنٌ عَلَيۡنَا بَٰلِغَةٌ إِلَىٰ يَوۡمِ ٱلۡقِيَٰمَةِ إِنَّ لَكُمۡ لَمَا تَحۡكُمُونَ",
    translation:
      "Or do you have oaths [binding] upon Us, extending until the Day of Resurrection, that indeed for you is whatever you judge",
    normalizedText: "ام لكم ايمن علينا بلغة الى يوم القيمة ان لكم لما تحكمون",
  },
  {
    verseId: 39,
    name: "القلم",
    surahId: 68,
    text: "سَلۡهُمۡ أَيُّهُم بِذَٰلِكَ زَعِيمٌ",
    translation: "Ask them which of them, for that [claim], is responsible",
    normalizedText: "سلهم ايهم بذلك زعيم",
  },
  {
    verseId: 40,
    name: "القلم",
    surahId: 68,
    text: "أَمۡ لَهُمۡ شُرَكَآءُ فَلۡيَأۡتُواْ بِشُرَكَآئِهِمۡ إِن كَانُواْ صَٰدِقِينَ",
    translation:
      "Or do they have partners? Then let them bring their partners, if they should be truthful",
    normalizedText: "ام لهم شركاء فلياتوا بشركااهم ان كانوا صدقين",
  },
  {
    verseId: 41,
    name: "القلم",
    surahId: 68,
    text: "يَوۡمَ يُكۡشَفُ عَن سَاقٖ وَيُدۡعَوۡنَ إِلَى ٱلسُّجُودِ فَلَا يَسۡتَطِيعُونَ",
    translation:
      "The Day the shin will be uncovered and they are invited to prostration but the disbelievers will not be able",
    normalizedText: "يوم يكشف عن ساق ويدعون الى السجود فلا يستطيعون",
  },
  {
    verseId: 42,
    name: "القلم",
    surahId: 68,
    text: "خَٰشِعَةً أَبۡصَٰرُهُمۡ تَرۡهَقُهُمۡ ذِلَّةٞۖ وَقَدۡ كَانُواْ يُدۡعَوۡنَ إِلَى ٱلسُّجُودِ وَهُمۡ سَٰلِمُونَ",
    translation:
      "Their eyes humbled, humiliation will cover them. And they used to be invited to prostration while they were sound",
    normalizedText:
      "خشعة ابصرهم ترهقهم ذلة وقد كانوا يدعون الى السجود وهم سلمون",
  },
  {
    verseId: 43,
    name: "القلم",
    surahId: 68,
    text: "فَذَرۡنِي وَمَن يُكَذِّبُ بِهَٰذَا ٱلۡحَدِيثِۖ سَنَسۡتَدۡرِجُهُم مِّنۡ حَيۡثُ لَا يَعۡلَمُونَ",
    translation:
      "So leave Me, [O Muhammad], with [the matter of] whoever denies the Qur'an. We will progressively lead them [to punishment] from where they do not know",
    normalizedText: "فذرني ومن يكذب بهذا الحديث سنستدرجهم من حيث لا يعلمون",
  },
  {
    verseId: 44,
    name: "القلم",
    surahId: 68,
    text: "وَأُمۡلِي لَهُمۡۚ إِنَّ كَيۡدِي مَتِينٌ",
    translation: "And I will give them time. Indeed, My plan is firm",
    normalizedText: "واملي لهم ان كيدي متين",
  },
  {
    verseId: 45,
    name: "القلم",
    surahId: 68,
    text: "أَمۡ تَسۡـَٔلُهُمۡ أَجۡرٗا فَهُم مِّن مَّغۡرَمٖ مُّثۡقَلُونَ",
    translation:
      "Or do you ask of them a payment, so they are by debt burdened down",
    normalizedText: "ام تسلهم اجرا فهم من مغرم مثقلون",
  },
  {
    verseId: 46,
    name: "القلم",
    surahId: 68,
    text: "أَمۡ عِندَهُمُ ٱلۡغَيۡبُ فَهُمۡ يَكۡتُبُونَ",
    translation:
      "Or have they [knowledge of] the unseen, so they write [it] down",
    normalizedText: "ام عندهم الغيب فهم يكتبون",
  },
  {
    verseId: 47,
    name: "القلم",
    surahId: 68,
    text: "فَٱصۡبِرۡ لِحُكۡمِ رَبِّكَ وَلَا تَكُن كَصَاحِبِ ٱلۡحُوتِ إِذۡ نَادَىٰ وَهُوَ مَكۡظُومٞ",
    translation:
      "Then be patient for the decision of your Lord, [O Muhammad], and be not like the companion of the fish when he called out while he was distressed",
    normalizedText: "فاصبر لحكم ربك ولا تكن كصاحب الحوت اذ نادى وهو مكظوم",
  },
  {
    verseId: 48,
    name: "القلم",
    surahId: 68,
    text: "لَّوۡلَآ أَن تَدَٰرَكَهُۥ نِعۡمَةٞ مِّن رَّبِّهِۦ لَنُبِذَ بِٱلۡعَرَآءِ وَهُوَ مَذۡمُومٞ",
    translation:
      "If not that a favor from his Lord overtook him, he would have been thrown onto the naked shore while he was censured",
    normalizedText: "لولا ان تدركه نعمة من ربه لنبذ بالعراء وهو مذموم",
  },
  {
    verseId: 49,
    name: "القلم",
    surahId: 68,
    text: "فَٱجۡتَبَٰهُ رَبُّهُۥ فَجَعَلَهُۥ مِنَ ٱلصَّـٰلِحِينَ",
    translation: "And his Lord chose him and made him of the righteous",
    normalizedText: "فاجتبه ربه فجعله من الصلحين",
  },
  {
    verseId: 50,
    name: "القلم",
    surahId: 68,
    text: "وَإِن يَكَادُ ٱلَّذِينَ كَفَرُواْ لَيُزۡلِقُونَكَ بِأَبۡصَٰرِهِمۡ لَمَّا سَمِعُواْ ٱلذِّكۡرَ وَيَقُولُونَ إِنَّهُۥ لَمَجۡنُونٞ",
    translation:
      'And indeed, those who disbelieve would almost make you slip with their eyes when they hear the message, and they say, "Indeed, he is mad',
    normalizedText:
      "وان يكاد الذين كفروا ليزلقونك بابصرهم لما سمعوا الذكر ويقولون انه لمجنون",
  },
  {
    verseId: 51,
    name: "القلم",
    surahId: 68,
    text: "وَمَا هُوَ إِلَّا ذِكۡرٞ لِّلۡعَٰلَمِينَ",
    translation: "But it is not except a reminder to the worlds",
    normalizedText: "وما هو الا ذكر للعلمين",
  },
  {
    verseId: 0,
    name: "الحاقة",
    surahId: 69,
    text: "ٱلۡحَآقَّةُ",
    translation: "The Inevitable Reality",
    normalizedText: "الحاقة",
  },
  {
    verseId: 1,
    name: "الحاقة",
    surahId: 69,
    text: "مَا ٱلۡحَآقَّةُ",
    translation: "What is the Inevitable Reality",
    normalizedText: "ما الحاقة",
  },
  {
    verseId: 2,
    name: "الحاقة",
    surahId: 69,
    text: "وَمَآ أَدۡرَىٰكَ مَا ٱلۡحَآقَّةُ",
    translation: "And what can make you know what is the Inevitable Reality",
    normalizedText: "وما ادرىك ما الحاقة",
  },
  {
    verseId: 3,
    name: "الحاقة",
    surahId: 69,
    text: "كَذَّبَتۡ ثَمُودُ وَعَادُۢ بِٱلۡقَارِعَةِ",
    translation: "Thamud and 'Aad denied the Striking Calamity",
    normalizedText: "كذبت ثمود وعاد بالقارعة",
  },
  {
    verseId: 4,
    name: "الحاقة",
    surahId: 69,
    text: "فَأَمَّا ثَمُودُ فَأُهۡلِكُواْ بِٱلطَّاغِيَةِ",
    translation:
      "So as for Thamud, they were destroyed by the overpowering [blast]",
    normalizedText: "فاما ثمود فاهلكوا بالطاغية",
  },
  {
    verseId: 5,
    name: "الحاقة",
    surahId: 69,
    text: "وَأَمَّا عَادٞ فَأُهۡلِكُواْ بِرِيحٖ صَرۡصَرٍ عَاتِيَةٖ",
    translation:
      "And as for 'Aad, they were destroyed by a screaming, violent wind",
    normalizedText: "واما عاد فاهلكوا بريح صرصر عاتية",
  },
  {
    verseId: 6,
    name: "الحاقة",
    surahId: 69,
    text: "سَخَّرَهَا عَلَيۡهِمۡ سَبۡعَ لَيَالٖ وَثَمَٰنِيَةَ أَيَّامٍ حُسُومٗاۖ فَتَرَى ٱلۡقَوۡمَ فِيهَا صَرۡعَىٰ كَأَنَّهُمۡ أَعۡجَازُ نَخۡلٍ خَاوِيَةٖ",
    translation:
      "Which Allah imposed upon them for seven nights and eight days in succession, so you would see the people therein fallen as if they were hollow trunks of palm trees",
    normalizedText:
      "سخرها عليهم سبع ليال وثمنية ايام حسوما فترى القوم فيها صرعى كانهم اعجاز نخل خاوية",
  },
  {
    verseId: 7,
    name: "الحاقة",
    surahId: 69,
    text: "فَهَلۡ تَرَىٰ لَهُم مِّنۢ بَاقِيَةٖ",
    translation: "Then do you see of them any remains",
    normalizedText: "فهل ترى لهم من باقية",
  },
  {
    verseId: 8,
    name: "الحاقة",
    surahId: 69,
    text: "وَجَآءَ فِرۡعَوۡنُ وَمَن قَبۡلَهُۥ وَٱلۡمُؤۡتَفِكَٰتُ بِٱلۡخَاطِئَةِ",
    translation:
      "And there came Pharaoh and those before him and the overturned cities with sin",
    normalizedText: "وجاء فرعون ومن قبله والماتفكت بالخاطاة",
  },
  {
    verseId: 9,
    name: "الحاقة",
    surahId: 69,
    text: "فَعَصَوۡاْ رَسُولَ رَبِّهِمۡ فَأَخَذَهُمۡ أَخۡذَةٗ رَّابِيَةً",
    translation:
      "And they disobeyed the messenger of their Lord, so He seized them with a seizure exceeding [in severity]",
    normalizedText: "فعصوا رسول ربهم فاخذهم اخذة رابية",
  },
  {
    verseId: 10,
    name: "الحاقة",
    surahId: 69,
    text: "إِنَّا لَمَّا طَغَا ٱلۡمَآءُ حَمَلۡنَٰكُمۡ فِي ٱلۡجَارِيَةِ",
    translation:
      "Indeed, when the water overflowed, We carried your ancestors in the sailing ship",
    normalizedText: "انا لما طغا الماء حملنكم في الجارية",
  },
  {
    verseId: 11,
    name: "الحاقة",
    surahId: 69,
    text: "لِنَجۡعَلَهَا لَكُمۡ تَذۡكِرَةٗ وَتَعِيَهَآ أُذُنٞ وَٰعِيَةٞ",
    translation:
      "That We might make it for you a reminder and [that] a conscious ear would be conscious of it",
    normalizedText: "لنجعلها لكم تذكرة وتعيها اذن وعية",
  },
  {
    verseId: 12,
    name: "الحاقة",
    surahId: 69,
    text: "فَإِذَا نُفِخَ فِي ٱلصُّورِ نَفۡخَةٞ وَٰحِدَةٞ",
    translation: "Then when the Horn is blown with one blast",
    normalizedText: "فاذا نفخ في الصور نفخة وحدة",
  },
  {
    verseId: 13,
    name: "الحاقة",
    surahId: 69,
    text: "وَحُمِلَتِ ٱلۡأَرۡضُ وَٱلۡجِبَالُ فَدُكَّتَا دَكَّةٗ وَٰحِدَةٗ",
    translation:
      "And the earth and the mountains are lifted and leveled with one blow",
    normalizedText: "وحملت الارض والجبال فدكتا دكة وحدة",
  },
  {
    verseId: 14,
    name: "الحاقة",
    surahId: 69,
    text: "فَيَوۡمَئِذٖ وَقَعَتِ ٱلۡوَاقِعَةُ",
    translation: "Then on that Day, the Resurrection will occur",
    normalizedText: "فيوماذ وقعت الواقعة",
  },
  {
    verseId: 15,
    name: "الحاقة",
    surahId: 69,
    text: "وَٱنشَقَّتِ ٱلسَّمَآءُ فَهِيَ يَوۡمَئِذٖ وَاهِيَةٞ",
    translation: "And the heaven will split [open], for that Day it is infirm",
    normalizedText: "وانشقت السماء فهي يوماذ واهية",
  },
  {
    verseId: 16,
    name: "الحاقة",
    surahId: 69,
    text: "وَٱلۡمَلَكُ عَلَىٰٓ أَرۡجَآئِهَاۚ وَيَحۡمِلُ عَرۡشَ رَبِّكَ فَوۡقَهُمۡ يَوۡمَئِذٖ ثَمَٰنِيَةٞ",
    translation:
      "And the angels are at its edges. And there will bear the Throne of your Lord above them, that Day, eight [of them]",
    normalizedText: "والملك على ارجااها ويحمل عرش ربك فوقهم يوماذ ثمنية",
  },
  {
    verseId: 17,
    name: "الحاقة",
    surahId: 69,
    text: "يَوۡمَئِذٖ تُعۡرَضُونَ لَا تَخۡفَىٰ مِنكُمۡ خَافِيَةٞ",
    translation:
      "That Day, you will be exhibited [for judgement]; not hidden among you is anything concealed",
    normalizedText: "يوماذ تعرضون لا تخفى منكم خافية",
  },
  {
    verseId: 18,
    name: "الحاقة",
    surahId: 69,
    text: "فَأَمَّا مَنۡ أُوتِيَ كِتَٰبَهُۥ بِيَمِينِهِۦ فَيَقُولُ هَآؤُمُ ٱقۡرَءُواْ كِتَٰبِيَهۡ",
    translation:
      'So as for he who is given his record in his right hand, he will say, "Here, read my record',
    normalizedText: "فاما من اوتي كتبه بيمينه فيقول هاام اقرءوا كتبيه",
  },
  {
    verseId: 19,
    name: "الحاقة",
    surahId: 69,
    text: "إِنِّي ظَنَنتُ أَنِّي مُلَٰقٍ حِسَابِيَهۡ",
    translation: "Indeed, I was certain that I would be meeting my account",
    normalizedText: "اني ظننت اني ملق حسابيه",
  },
  {
    verseId: 20,
    name: "الحاقة",
    surahId: 69,
    text: "فَهُوَ فِي عِيشَةٖ رَّاضِيَةٖ",
    translation: "So he will be in a pleasant life",
    normalizedText: "فهو في عيشة راضية",
  },
  {
    verseId: 21,
    name: "الحاقة",
    surahId: 69,
    text: "فِي جَنَّةٍ عَالِيَةٖ",
    translation: "In an elevated garden",
    normalizedText: "في جنة عالية",
  },
  {
    verseId: 22,
    name: "الحاقة",
    surahId: 69,
    text: "قُطُوفُهَا دَانِيَةٞ",
    translation: "Its [fruit] to be picked hanging near",
    normalizedText: "قطوفها دانية",
  },
  {
    verseId: 23,
    name: "الحاقة",
    surahId: 69,
    text: "كُلُواْ وَٱشۡرَبُواْ هَنِيٓـَٔۢا بِمَآ أَسۡلَفۡتُمۡ فِي ٱلۡأَيَّامِ ٱلۡخَالِيَةِ",
    translation:
      '[They will be told], "Eat and drink in satisfaction for what you put forth in the days past',
    normalizedText: "كلوا واشربوا هنيا بما اسلفتم في الايام الخالية",
  },
  {
    verseId: 24,
    name: "الحاقة",
    surahId: 69,
    text: "وَأَمَّا مَنۡ أُوتِيَ كِتَٰبَهُۥ بِشِمَالِهِۦ فَيَقُولُ يَٰلَيۡتَنِي لَمۡ أُوتَ كِتَٰبِيَهۡ",
    translation:
      'But as for he who is given his record in his left hand, he will say, "Oh, I wish I had not been given my record',
    normalizedText: "واما من اوتي كتبه بشماله فيقول يليتني لم اوت كتبيه",
  },
  {
    verseId: 25,
    name: "الحاقة",
    surahId: 69,
    text: "وَلَمۡ أَدۡرِ مَا حِسَابِيَهۡ",
    translation: "And had not known what is my account",
    normalizedText: "ولم ادر ما حسابيه",
  },
  {
    verseId: 26,
    name: "الحاقة",
    surahId: 69,
    text: "يَٰلَيۡتَهَا كَانَتِ ٱلۡقَاضِيَةَ",
    translation: "I wish my death had been the decisive one",
    normalizedText: "يليتها كانت القاضية",
  },
  {
    verseId: 27,
    name: "الحاقة",
    surahId: 69,
    text: "مَآ أَغۡنَىٰ عَنِّي مَالِيَهۡۜ",
    translation: "My wealth has not availed me",
    normalizedText: "ما اغنى عني ماليه",
  },
  {
    verseId: 28,
    name: "الحاقة",
    surahId: 69,
    text: "هَلَكَ عَنِّي سُلۡطَٰنِيَهۡ",
    translation: "Gone from me is my authority",
    normalizedText: "هلك عني سلطنيه",
  },
  {
    verseId: 29,
    name: "الحاقة",
    surahId: 69,
    text: "خُذُوهُ فَغُلُّوهُ",
    translation: '[Allah will say], "Seize him and shackle him',
    normalizedText: "خذوه فغلوه",
  },
  {
    verseId: 30,
    name: "الحاقة",
    surahId: 69,
    text: "ثُمَّ ٱلۡجَحِيمَ صَلُّوهُ",
    translation: "Then into Hellfire drive him",
    normalizedText: "ثم الجحيم صلوه",
  },
  {
    verseId: 31,
    name: "الحاقة",
    surahId: 69,
    text: "ثُمَّ فِي سِلۡسِلَةٖ ذَرۡعُهَا سَبۡعُونَ ذِرَاعٗا فَٱسۡلُكُوهُ",
    translation: "Then into a chain whose length is seventy cubits insert him",
    normalizedText: "ثم في سلسلة ذرعها سبعون ذراعا فاسلكوه",
  },
  {
    verseId: 32,
    name: "الحاقة",
    surahId: 69,
    text: "إِنَّهُۥ كَانَ لَا يُؤۡمِنُ بِٱللَّهِ ٱلۡعَظِيمِ",
    translation: "Indeed, he did not used to believe in Allah, the Most Great",
    normalizedText: "انه كان لا يامن بالله العظيم",
  },
  {
    verseId: 33,
    name: "الحاقة",
    surahId: 69,
    text: "وَلَا يَحُضُّ عَلَىٰ طَعَامِ ٱلۡمِسۡكِينِ",
    translation: "Nor did he encourage the feeding of the poor",
    normalizedText: "ولا يحض على طعام المسكين",
  },
  {
    verseId: 34,
    name: "الحاقة",
    surahId: 69,
    text: "فَلَيۡسَ لَهُ ٱلۡيَوۡمَ هَٰهُنَا حَمِيمٞ",
    translation: "So there is not for him here this Day any devoted friend",
    normalizedText: "فليس له اليوم ههنا حميم",
  },
  {
    verseId: 35,
    name: "الحاقة",
    surahId: 69,
    text: "وَلَا طَعَامٌ إِلَّا مِنۡ غِسۡلِينٖ",
    translation: "Nor any food except from the discharge of wounds",
    normalizedText: "ولا طعام الا من غسلين",
  },
  {
    verseId: 36,
    name: "الحاقة",
    surahId: 69,
    text: "لَّا يَأۡكُلُهُۥٓ إِلَّا ٱلۡخَٰطِـُٔونَ",
    translation: "None will eat it except the sinners",
    normalizedText: "لا ياكله الا الخطون",
  },
  {
    verseId: 37,
    name: "الحاقة",
    surahId: 69,
    text: "فَلَآ أُقۡسِمُ بِمَا تُبۡصِرُونَ",
    translation: "So I swear by what you see",
    normalizedText: "فلا اقسم بما تبصرون",
  },
  {
    verseId: 38,
    name: "الحاقة",
    surahId: 69,
    text: "وَمَا لَا تُبۡصِرُونَ",
    translation: "And what you do not see",
    normalizedText: "وما لا تبصرون",
  },
  {
    verseId: 39,
    name: "الحاقة",
    surahId: 69,
    text: "إِنَّهُۥ لَقَوۡلُ رَسُولٖ كَرِيمٖ",
    translation: "[That] indeed, the Qur'an is the word of a noble Messenger",
    normalizedText: "انه لقول رسول كريم",
  },
  {
    verseId: 40,
    name: "الحاقة",
    surahId: 69,
    text: "وَمَا هُوَ بِقَوۡلِ شَاعِرٖۚ قَلِيلٗا مَّا تُؤۡمِنُونَ",
    translation: "And it is not the word of a poet; little do you believe",
    normalizedText: "وما هو بقول شاعر قليلا ما تامنون",
  },
  {
    verseId: 41,
    name: "الحاقة",
    surahId: 69,
    text: "وَلَا بِقَوۡلِ كَاهِنٖۚ قَلِيلٗا مَّا تَذَكَّرُونَ",
    translation: "Nor the word of a soothsayer; little do you remember",
    normalizedText: "ولا بقول كاهن قليلا ما تذكرون",
  },
  {
    verseId: 42,
    name: "الحاقة",
    surahId: 69,
    text: "تَنزِيلٞ مِّن رَّبِّ ٱلۡعَٰلَمِينَ",
    translation: "[It is] a revelation from the Lord of the worlds",
    normalizedText: "تنزيل من رب العلمين",
  },
  {
    verseId: 43,
    name: "الحاقة",
    surahId: 69,
    text: "وَلَوۡ تَقَوَّلَ عَلَيۡنَا بَعۡضَ ٱلۡأَقَاوِيلِ",
    translation: "And if Muhammad had made up about Us some [false] sayings",
    normalizedText: "ولو تقول علينا بعض الاقاويل",
  },
  {
    verseId: 44,
    name: "الحاقة",
    surahId: 69,
    text: "لَأَخَذۡنَا مِنۡهُ بِٱلۡيَمِينِ",
    translation: "We would have seized him by the right hand",
    normalizedText: "لاخذنا منه باليمين",
  },
  {
    verseId: 45,
    name: "الحاقة",
    surahId: 69,
    text: "ثُمَّ لَقَطَعۡنَا مِنۡهُ ٱلۡوَتِينَ",
    translation: "Then We would have cut from him the aorta",
    normalizedText: "ثم لقطعنا منه الوتين",
  },
  {
    verseId: 46,
    name: "الحاقة",
    surahId: 69,
    text: "فَمَا مِنكُم مِّنۡ أَحَدٍ عَنۡهُ حَٰجِزِينَ",
    translation: "And there is no one of you who could prevent [Us] from him",
    normalizedText: "فما منكم من احد عنه حجزين",
  },
  {
    verseId: 47,
    name: "الحاقة",
    surahId: 69,
    text: "وَإِنَّهُۥ لَتَذۡكِرَةٞ لِّلۡمُتَّقِينَ",
    translation: "And indeed, the Qur'an is a reminder for the righteous",
    normalizedText: "وانه لتذكرة للمتقين",
  },
  {
    verseId: 48,
    name: "الحاقة",
    surahId: 69,
    text: "وَإِنَّا لَنَعۡلَمُ أَنَّ مِنكُم مُّكَذِّبِينَ",
    translation: "And indeed, We know that among you are deniers",
    normalizedText: "وانا لنعلم ان منكم مكذبين",
  },
  {
    verseId: 49,
    name: "الحاقة",
    surahId: 69,
    text: "وَإِنَّهُۥ لَحَسۡرَةٌ عَلَى ٱلۡكَٰفِرِينَ",
    translation:
      "And indeed, it will be [a cause of] regret upon the disbelievers",
    normalizedText: "وانه لحسرة على الكفرين",
  },
  {
    verseId: 50,
    name: "الحاقة",
    surahId: 69,
    text: "وَإِنَّهُۥ لَحَقُّ ٱلۡيَقِينِ",
    translation: "And indeed, it is the truth of certainty",
    normalizedText: "وانه لحق اليقين",
  },
  {
    verseId: 51,
    name: "الحاقة",
    surahId: 69,
    text: "فَسَبِّحۡ بِٱسۡمِ رَبِّكَ ٱلۡعَظِيمِ",
    translation: "So exalt the name of your Lord, the Most Great",
    normalizedText: "فسبح باسم ربك العظيم",
  },
  {
    verseId: 0,
    name: "المعارج",
    surahId: 70,
    text: "سَأَلَ سَآئِلُۢ بِعَذَابٖ وَاقِعٖ",
    translation: "A supplicant asked for a punishment bound to happen",
    normalizedText: "سال ساال بعذاب واقع",
  },
  {
    verseId: 1,
    name: "المعارج",
    surahId: 70,
    text: "لِّلۡكَٰفِرِينَ لَيۡسَ لَهُۥ دَافِعٞ",
    translation: "To the disbelievers; of it there is no preventer",
    normalizedText: "للكفرين ليس له دافع",
  },
  {
    verseId: 2,
    name: "المعارج",
    surahId: 70,
    text: "مِّنَ ٱللَّهِ ذِي ٱلۡمَعَارِجِ",
    translation: "[It is] from Allah, owner of the ways of ascent",
    normalizedText: "من الله ذي المعارج",
  },
  {
    verseId: 3,
    name: "المعارج",
    surahId: 70,
    text: "تَعۡرُجُ ٱلۡمَلَـٰٓئِكَةُ وَٱلرُّوحُ إِلَيۡهِ فِي يَوۡمٖ كَانَ مِقۡدَارُهُۥ خَمۡسِينَ أَلۡفَ سَنَةٖ",
    translation:
      "The angels and the Spirit will ascend to Him during a Day the extent of which is fifty thousand years",
    normalizedText: "تعرج الملاكة والروح اليه في يوم كان مقداره خمسين الف سنة",
  },
  {
    verseId: 4,
    name: "المعارج",
    surahId: 70,
    text: "فَٱصۡبِرۡ صَبۡرٗا جَمِيلًا",
    translation: "So be patient with gracious patience",
    normalizedText: "فاصبر صبرا جميلا",
  },
  {
    verseId: 5,
    name: "المعارج",
    surahId: 70,
    text: "إِنَّهُمۡ يَرَوۡنَهُۥ بَعِيدٗا",
    translation: "Indeed, they see it [as] distant",
    normalizedText: "انهم يرونه بعيدا",
  },
  {
    verseId: 6,
    name: "المعارج",
    surahId: 70,
    text: "وَنَرَىٰهُ قَرِيبٗا",
    translation: "But We see it [as] near",
    normalizedText: "ونرىه قريبا",
  },
  {
    verseId: 7,
    name: "المعارج",
    surahId: 70,
    text: "يَوۡمَ تَكُونُ ٱلسَّمَآءُ كَٱلۡمُهۡلِ",
    translation: "On the Day the sky will be like murky oil",
    normalizedText: "يوم تكون السماء كالمهل",
  },
  {
    verseId: 8,
    name: "المعارج",
    surahId: 70,
    text: "وَتَكُونُ ٱلۡجِبَالُ كَٱلۡعِهۡنِ",
    translation: "And the mountains will be like wool",
    normalizedText: "وتكون الجبال كالعهن",
  },
  {
    verseId: 9,
    name: "المعارج",
    surahId: 70,
    text: "وَلَا يَسۡـَٔلُ حَمِيمٌ حَمِيمٗا",
    translation: "And no friend will ask [anything of] a friend",
    normalizedText: "ولا يسل حميم حميما",
  },
  {
    verseId: 10,
    name: "المعارج",
    surahId: 70,
    text: "يُبَصَّرُونَهُمۡۚ يَوَدُّ ٱلۡمُجۡرِمُ لَوۡ يَفۡتَدِي مِنۡ عَذَابِ يَوۡمِئِذِۭ بِبَنِيهِ",
    translation:
      "They will be shown each other. The criminal will wish that he could be ransomed from the punishment of that Day by his children",
    normalizedText: "يبصرونهم يود المجرم لو يفتدي من عذاب يوماذ ببنيه",
  },
  {
    verseId: 11,
    name: "المعارج",
    surahId: 70,
    text: "وَصَٰحِبَتِهِۦ وَأَخِيهِ",
    translation: "And his wife and his brother",
    normalizedText: "وصحبته واخيه",
  },
  {
    verseId: 12,
    name: "المعارج",
    surahId: 70,
    text: "وَفَصِيلَتِهِ ٱلَّتِي تُـٔۡوِيهِ",
    translation: "And his nearest kindred who shelter him",
    normalizedText: "وفصيلته التي تويه",
  },
  {
    verseId: 13,
    name: "المعارج",
    surahId: 70,
    text: "وَمَن فِي ٱلۡأَرۡضِ جَمِيعٗا ثُمَّ يُنجِيهِ",
    translation: "And whoever is on earth entirely [so] then it could save him",
    normalizedText: "ومن في الارض جميعا ثم ينجيه",
  },
  {
    verseId: 14,
    name: "المعارج",
    surahId: 70,
    text: "كَلَّآۖ إِنَّهَا لَظَىٰ",
    translation: "No! Indeed, it is the Flame [of Hell]",
    normalizedText: "كلا انها لظى",
  },
  {
    verseId: 15,
    name: "المعارج",
    surahId: 70,
    text: "نَزَّاعَةٗ لِّلشَّوَىٰ",
    translation: "A remover of exteriors",
    normalizedText: "نزاعة للشوى",
  },
  {
    verseId: 16,
    name: "المعارج",
    surahId: 70,
    text: "تَدۡعُواْ مَنۡ أَدۡبَرَ وَتَوَلَّىٰ",
    translation:
      "It invites he who turned his back [on truth] and went away [from obedience]",
    normalizedText: "تدعوا من ادبر وتولى",
  },
  {
    verseId: 17,
    name: "المعارج",
    surahId: 70,
    text: "وَجَمَعَ فَأَوۡعَىٰٓ",
    translation: "And collected [wealth] and hoarded",
    normalizedText: "وجمع فاوعى",
  },
  {
    verseId: 18,
    name: "المعارج",
    surahId: 70,
    text: "۞إِنَّ ٱلۡإِنسَٰنَ خُلِقَ هَلُوعًا",
    translation: "Indeed, mankind was created anxious",
    normalizedText: "۞ان الانسن خلق هلوعا",
  },
  {
    verseId: 19,
    name: "المعارج",
    surahId: 70,
    text: "إِذَا مَسَّهُ ٱلشَّرُّ جَزُوعٗا",
    translation: "When evil touches him, impatient",
    normalizedText: "اذا مسه الشر جزوعا",
  },
  {
    verseId: 20,
    name: "المعارج",
    surahId: 70,
    text: "وَإِذَا مَسَّهُ ٱلۡخَيۡرُ مَنُوعًا",
    translation: "And when good touches him, withholding [of it]",
    normalizedText: "واذا مسه الخير منوعا",
  },
  {
    verseId: 21,
    name: "المعارج",
    surahId: 70,
    text: "إِلَّا ٱلۡمُصَلِّينَ",
    translation: "Except the observers of prayer",
    normalizedText: "الا المصلين",
  },
  {
    verseId: 22,
    name: "المعارج",
    surahId: 70,
    text: "ٱلَّذِينَ هُمۡ عَلَىٰ صَلَاتِهِمۡ دَآئِمُونَ",
    translation: "Those who are constant in their prayer",
    normalizedText: "الذين هم على صلاتهم داامون",
  },
  {
    verseId: 23,
    name: "المعارج",
    surahId: 70,
    text: "وَٱلَّذِينَ فِيٓ أَمۡوَٰلِهِمۡ حَقّٞ مَّعۡلُومٞ",
    translation: "And those within whose wealth is a known right",
    normalizedText: "والذين في امولهم حق معلوم",
  },
  {
    verseId: 24,
    name: "المعارج",
    surahId: 70,
    text: "لِّلسَّآئِلِ وَٱلۡمَحۡرُومِ",
    translation: "For the petitioner and the deprived",
    normalizedText: "للساال والمحروم",
  },
  {
    verseId: 25,
    name: "المعارج",
    surahId: 70,
    text: "وَٱلَّذِينَ يُصَدِّقُونَ بِيَوۡمِ ٱلدِّينِ",
    translation: "And those who believe in the Day of Recompense",
    normalizedText: "والذين يصدقون بيوم الدين",
  },
  {
    verseId: 26,
    name: "المعارج",
    surahId: 70,
    text: "وَٱلَّذِينَ هُم مِّنۡ عَذَابِ رَبِّهِم مُّشۡفِقُونَ",
    translation: "And those who are fearful of the punishment of their Lord",
    normalizedText: "والذين هم من عذاب ربهم مشفقون",
  },
  {
    verseId: 27,
    name: "المعارج",
    surahId: 70,
    text: "إِنَّ عَذَابَ رَبِّهِمۡ غَيۡرُ مَأۡمُونٖ",
    translation:
      "Indeed, the punishment of their Lord is not that from which one is safe",
    normalizedText: "ان عذاب ربهم غير مامون",
  },
  {
    verseId: 28,
    name: "المعارج",
    surahId: 70,
    text: "وَٱلَّذِينَ هُمۡ لِفُرُوجِهِمۡ حَٰفِظُونَ",
    translation: "And those who guard their private parts",
    normalizedText: "والذين هم لفروجهم حفظون",
  },
  {
    verseId: 29,
    name: "المعارج",
    surahId: 70,
    text: "إِلَّا عَلَىٰٓ أَزۡوَٰجِهِمۡ أَوۡ مَا مَلَكَتۡ أَيۡمَٰنُهُمۡ فَإِنَّهُمۡ غَيۡرُ مَلُومِينَ",
    translation:
      "Except from their wives or those their right hands possess, for indeed, they are not to be blamed",
    normalizedText: "الا على ازوجهم او ما ملكت ايمنهم فانهم غير ملومين",
  },
  {
    verseId: 30,
    name: "المعارج",
    surahId: 70,
    text: "فَمَنِ ٱبۡتَغَىٰ وَرَآءَ ذَٰلِكَ فَأُوْلَـٰٓئِكَ هُمُ ٱلۡعَادُونَ",
    translation:
      "But whoever seeks beyond that, then they are the transgressors",
    normalizedText: "فمن ابتغى وراء ذلك فاولاك هم العادون",
  },
  {
    verseId: 31,
    name: "المعارج",
    surahId: 70,
    text: "وَٱلَّذِينَ هُمۡ لِأَمَٰنَٰتِهِمۡ وَعَهۡدِهِمۡ رَٰعُونَ",
    translation: "And those who are to their trusts and promises attentive",
    normalizedText: "والذين هم لامنتهم وعهدهم رعون",
  },
  {
    verseId: 32,
    name: "المعارج",
    surahId: 70,
    text: "وَٱلَّذِينَ هُم بِشَهَٰدَٰتِهِمۡ قَآئِمُونَ",
    translation: "And those who are in their testimonies upright",
    normalizedText: "والذين هم بشهدتهم قاامون",
  },
  {
    verseId: 33,
    name: "المعارج",
    surahId: 70,
    text: "وَٱلَّذِينَ هُمۡ عَلَىٰ صَلَاتِهِمۡ يُحَافِظُونَ",
    translation: "And those who [carefully] maintain their prayer",
    normalizedText: "والذين هم على صلاتهم يحافظون",
  },
  {
    verseId: 34,
    name: "المعارج",
    surahId: 70,
    text: "أُوْلَـٰٓئِكَ فِي جَنَّـٰتٖ مُّكۡرَمُونَ",
    translation: "They will be in gardens, honored",
    normalizedText: "اولاك في جنت مكرمون",
  },
  {
    verseId: 35,
    name: "المعارج",
    surahId: 70,
    text: "فَمَالِ ٱلَّذِينَ كَفَرُواْ قِبَلَكَ مُهۡطِعِينَ",
    translation:
      "So what is [the matter] with those who disbelieve, hastening [from] before you, [O Muhammad]",
    normalizedText: "فمال الذين كفروا قبلك مهطعين",
  },
  {
    verseId: 36,
    name: "المعارج",
    surahId: 70,
    text: "عَنِ ٱلۡيَمِينِ وَعَنِ ٱلشِّمَالِ عِزِينَ",
    translation: "[To sit] on [your] right and [your] left in separate groups",
    normalizedText: "عن اليمين وعن الشمال عزين",
  },
  {
    verseId: 37,
    name: "المعارج",
    surahId: 70,
    text: "أَيَطۡمَعُ كُلُّ ٱمۡرِيٕٖ مِّنۡهُمۡ أَن يُدۡخَلَ جَنَّةَ نَعِيمٖ",
    translation:
      "Does every person among them aspire to enter a garden of pleasure",
    normalizedText: "ايطمع كل امري منهم ان يدخل جنة نعيم",
  },
  {
    verseId: 38,
    name: "المعارج",
    surahId: 70,
    text: "كَلَّآۖ إِنَّا خَلَقۡنَٰهُم مِّمَّا يَعۡلَمُونَ",
    translation: "No! Indeed, We have created them from that which they know",
    normalizedText: "كلا انا خلقنهم مما يعلمون",
  },
  {
    verseId: 39,
    name: "المعارج",
    surahId: 70,
    text: "فَلَآ أُقۡسِمُ بِرَبِّ ٱلۡمَشَٰرِقِ وَٱلۡمَغَٰرِبِ إِنَّا لَقَٰدِرُونَ",
    translation:
      "So I swear by the Lord of [all] risings and settings that indeed We are able",
    normalizedText: "فلا اقسم برب المشرق والمغرب انا لقدرون",
  },
  {
    verseId: 40,
    name: "المعارج",
    surahId: 70,
    text: "عَلَىٰٓ أَن نُّبَدِّلَ خَيۡرٗا مِّنۡهُمۡ وَمَا نَحۡنُ بِمَسۡبُوقِينَ",
    translation:
      "To replace them with better than them; and We are not to be outdone",
    normalizedText: "على ان نبدل خيرا منهم وما نحن بمسبوقين",
  },
  {
    verseId: 41,
    name: "المعارج",
    surahId: 70,
    text: "فَذَرۡهُمۡ يَخُوضُواْ وَيَلۡعَبُواْ حَتَّىٰ يُلَٰقُواْ يَوۡمَهُمُ ٱلَّذِي يُوعَدُونَ",
    translation:
      "So leave them to converse vainly and amuse themselves until they meet their Day which they are promised",
    normalizedText: "فذرهم يخوضوا ويلعبوا حتى يلقوا يومهم الذي يوعدون",
  },
  {
    verseId: 42,
    name: "المعارج",
    surahId: 70,
    text: "يَوۡمَ يَخۡرُجُونَ مِنَ ٱلۡأَجۡدَاثِ سِرَاعٗا كَأَنَّهُمۡ إِلَىٰ نُصُبٖ يُوفِضُونَ",
    translation:
      "The Day they will emerge from the graves rapidly as if they were, toward an erected idol, hastening",
    normalizedText: "يوم يخرجون من الاجداث سراعا كانهم الى نصب يوفضون",
  },
  {
    verseId: 43,
    name: "المعارج",
    surahId: 70,
    text: "خَٰشِعَةً أَبۡصَٰرُهُمۡ تَرۡهَقُهُمۡ ذِلَّةٞۚ ذَٰلِكَ ٱلۡيَوۡمُ ٱلَّذِي كَانُواْ يُوعَدُونَ",
    translation:
      "Their eyes humbled, humiliation will cover them. That is the Day which they had been promised",
    normalizedText: "خشعة ابصرهم ترهقهم ذلة ذلك اليوم الذي كانوا يوعدون",
  },
  {
    verseId: 0,
    name: "نوح",
    surahId: 71,
    text: "إِنَّآ أَرۡسَلۡنَا نُوحًا إِلَىٰ قَوۡمِهِۦٓ أَنۡ أَنذِرۡ قَوۡمَكَ مِن قَبۡلِ أَن يَأۡتِيَهُمۡ عَذَابٌ أَلِيمٞ",
    translation:
      'Indeed, We sent Noah to his people, [saying], "Warn your people before there comes to them a painful punishment',
    normalizedText:
      "انا ارسلنا نوحا الى قومه ان انذر قومك من قبل ان ياتيهم عذاب اليم",
  },
  {
    verseId: 1,
    name: "نوح",
    surahId: 71,
    text: "قَالَ يَٰقَوۡمِ إِنِّي لَكُمۡ نَذِيرٞ مُّبِينٌ",
    translation: 'He said, "O my people, indeed I am to you a clear warner',
    normalizedText: "قال يقوم اني لكم نذير مبين",
  },
  {
    verseId: 2,
    name: "نوح",
    surahId: 71,
    text: "أَنِ ٱعۡبُدُواْ ٱللَّهَ وَٱتَّقُوهُ وَأَطِيعُونِ",
    translation: "[Saying], 'Worship Allah, fear Him and obey me",
    normalizedText: "ان اعبدوا الله واتقوه واطيعون",
  },
  {
    verseId: 3,
    name: "نوح",
    surahId: 71,
    text: "يَغۡفِرۡ لَكُم مِّن ذُنُوبِكُمۡ وَيُؤَخِّرۡكُمۡ إِلَىٰٓ أَجَلٖ مُّسَمًّىۚ إِنَّ أَجَلَ ٱللَّهِ إِذَا جَآءَ لَا يُؤَخَّرُۚ لَوۡ كُنتُمۡ تَعۡلَمُونَ",
    translation:
      "Allah will forgive you of your sins and delay you for a specified term. Indeed, the time [set by] Allah, when it comes, will not be delayed, if you only knew",
    normalizedText:
      "يغفر لكم من ذنوبكم وياخركم الى اجل مسمى ان اجل الله اذا جاء لا ياخر لو كنتم تعلمون",
  },
  {
    verseId: 4,
    name: "نوح",
    surahId: 71,
    text: "قَالَ رَبِّ إِنِّي دَعَوۡتُ قَوۡمِي لَيۡلٗا وَنَهَارٗا",
    translation:
      'He said, "My Lord, indeed I invited my people [to truth] night and day',
    normalizedText: "قال رب اني دعوت قومي ليلا ونهارا",
  },
  {
    verseId: 5,
    name: "نوح",
    surahId: 71,
    text: "فَلَمۡ يَزِدۡهُمۡ دُعَآءِيٓ إِلَّا فِرَارٗا",
    translation: "But my invitation increased them not except in flight",
    normalizedText: "فلم يزدهم دعاءي الا فرارا",
  },
  {
    verseId: 6,
    name: "نوح",
    surahId: 71,
    text: "وَإِنِّي كُلَّمَا دَعَوۡتُهُمۡ لِتَغۡفِرَ لَهُمۡ جَعَلُوٓاْ أَصَٰبِعَهُمۡ فِيٓ ءَاذَانِهِمۡ وَٱسۡتَغۡشَوۡاْ ثِيَابَهُمۡ وَأَصَرُّواْ وَٱسۡتَكۡبَرُواْ ٱسۡتِكۡبَارٗا",
    translation:
      "And indeed, every time I invited them that You may forgive them, they put their fingers in their ears, covered themselves with their garments, persisted, and were arrogant with [great] arrogance",
    normalizedText:
      "واني كلما دعوتهم لتغفر لهم جعلوا اصبعهم في ءاذانهم واستغشوا ثيابهم واصروا واستكبروا استكبارا",
  },
  {
    verseId: 7,
    name: "نوح",
    surahId: 71,
    text: "ثُمَّ إِنِّي دَعَوۡتُهُمۡ جِهَارٗا",
    translation: "Then I invited them publicly",
    normalizedText: "ثم اني دعوتهم جهارا",
  },
  {
    verseId: 8,
    name: "نوح",
    surahId: 71,
    text: "ثُمَّ إِنِّيٓ أَعۡلَنتُ لَهُمۡ وَأَسۡرَرۡتُ لَهُمۡ إِسۡرَارٗا",
    translation:
      "Then I announced to them and [also] confided to them secretly",
    normalizedText: "ثم اني اعلنت لهم واسررت لهم اسرارا",
  },
  {
    verseId: 9,
    name: "نوح",
    surahId: 71,
    text: "فَقُلۡتُ ٱسۡتَغۡفِرُواْ رَبَّكُمۡ إِنَّهُۥ كَانَ غَفَّارٗا",
    translation:
      "And said, 'Ask forgiveness of your Lord. Indeed, He is ever a Perpetual Forgiver",
    normalizedText: "فقلت استغفروا ربكم انه كان غفارا",
  },
  {
    verseId: 10,
    name: "نوح",
    surahId: 71,
    text: "يُرۡسِلِ ٱلسَّمَآءَ عَلَيۡكُم مِّدۡرَارٗا",
    translation:
      "He will send [rain from] the sky upon you in [continuing] showers",
    normalizedText: "يرسل السماء عليكم مدرارا",
  },
  {
    verseId: 11,
    name: "نوح",
    surahId: 71,
    text: "وَيُمۡدِدۡكُم بِأَمۡوَٰلٖ وَبَنِينَ وَيَجۡعَل لَّكُمۡ جَنَّـٰتٖ وَيَجۡعَل لَّكُمۡ أَنۡهَٰرٗا",
    translation:
      "And give you increase in wealth and children and provide for you gardens and provide for you rivers",
    normalizedText: "ويمددكم بامول وبنين ويجعل لكم جنت ويجعل لكم انهرا",
  },
  {
    verseId: 12,
    name: "نوح",
    surahId: 71,
    text: "مَّا لَكُمۡ لَا تَرۡجُونَ لِلَّهِ وَقَارٗا",
    translation:
      "What is [the matter] with you that you do not attribute to Allah [due] grandeur",
    normalizedText: "ما لكم لا ترجون لله وقارا",
  },
  {
    verseId: 13,
    name: "نوح",
    surahId: 71,
    text: "وَقَدۡ خَلَقَكُمۡ أَطۡوَارًا",
    translation: "While He has created you in stages",
    normalizedText: "وقد خلقكم اطوارا",
  },
  {
    verseId: 14,
    name: "نوح",
    surahId: 71,
    text: "أَلَمۡ تَرَوۡاْ كَيۡفَ خَلَقَ ٱللَّهُ سَبۡعَ سَمَٰوَٰتٖ طِبَاقٗا",
    translation:
      "Do you not consider how Allah has created seven heavens in layers",
    normalizedText: "الم تروا كيف خلق الله سبع سموت طباقا",
  },
  {
    verseId: 15,
    name: "نوح",
    surahId: 71,
    text: "وَجَعَلَ ٱلۡقَمَرَ فِيهِنَّ نُورٗا وَجَعَلَ ٱلشَّمۡسَ سِرَاجٗا",
    translation:
      "And made the moon therein a [reflected] light and made the sun a burning lamp",
    normalizedText: "وجعل القمر فيهن نورا وجعل الشمس سراجا",
  },
  {
    verseId: 16,
    name: "نوح",
    surahId: 71,
    text: "وَٱللَّهُ أَنۢبَتَكُم مِّنَ ٱلۡأَرۡضِ نَبَاتٗا",
    translation:
      "And Allah has caused you to grow from the earth a [progressive] growth",
    normalizedText: "والله انبتكم من الارض نباتا",
  },
  {
    verseId: 17,
    name: "نوح",
    surahId: 71,
    text: "ثُمَّ يُعِيدُكُمۡ فِيهَا وَيُخۡرِجُكُمۡ إِخۡرَاجٗا",
    translation:
      "Then He will return you into it and extract you [another] extraction",
    normalizedText: "ثم يعيدكم فيها ويخرجكم اخراجا",
  },
  {
    verseId: 18,
    name: "نوح",
    surahId: 71,
    text: "وَٱللَّهُ جَعَلَ لَكُمُ ٱلۡأَرۡضَ بِسَاطٗا",
    translation: "And Allah has made for you the earth an expanse",
    normalizedText: "والله جعل لكم الارض بساطا",
  },
  {
    verseId: 19,
    name: "نوح",
    surahId: 71,
    text: "لِّتَسۡلُكُواْ مِنۡهَا سُبُلٗا فِجَاجٗا",
    translation: "That you may follow therein roads of passage",
    normalizedText: "لتسلكوا منها سبلا فجاجا",
  },
  {
    verseId: 20,
    name: "نوح",
    surahId: 71,
    text: "قَالَ نُوحٞ رَّبِّ إِنَّهُمۡ عَصَوۡنِي وَٱتَّبَعُواْ مَن لَّمۡ يَزِدۡهُ مَالُهُۥ وَوَلَدُهُۥٓ إِلَّا خَسَارٗا",
    translation:
      'Noah said, "My Lord, indeed they have disobeyed me and followed him whose wealth and children will not increase him except in loss',
    normalizedText:
      "قال نوح رب انهم عصوني واتبعوا من لم يزده ماله وولده الا خسارا",
  },
  {
    verseId: 21,
    name: "نوح",
    surahId: 71,
    text: "وَمَكَرُواْ مَكۡرٗا كُبَّارٗا",
    translation: "And they conspired an immense conspiracy",
    normalizedText: "ومكروا مكرا كبارا",
  },
  {
    verseId: 22,
    name: "نوح",
    surahId: 71,
    text: "وَقَالُواْ لَا تَذَرُنَّ ءَالِهَتَكُمۡ وَلَا تَذَرُنَّ وَدّٗا وَلَا سُوَاعٗا وَلَا يَغُوثَ وَيَعُوقَ وَنَسۡرٗا",
    translation:
      "And said, 'Never leave your gods and never leave Wadd or Suwa' or Yaghuth and Ya'uq and Nasr",
    normalizedText:
      "وقالوا لا تذرن ءالهتكم ولا تذرن ودا ولا سواعا ولا يغوث ويعوق ونسرا",
  },
  {
    verseId: 23,
    name: "نوح",
    surahId: 71,
    text: "وَقَدۡ أَضَلُّواْ كَثِيرٗاۖ وَلَا تَزِدِ ٱلظَّـٰلِمِينَ إِلَّا ضَلَٰلٗا",
    translation:
      "And already they have misled many. And, [my Lord], do not increase the wrongdoers except in error",
    normalizedText: "وقد اضلوا كثيرا ولا تزد الظلمين الا ضللا",
  },
  {
    verseId: 24,
    name: "نوح",
    surahId: 71,
    text: "مِّمَّا خَطِيٓـَٰٔتِهِمۡ أُغۡرِقُواْ فَأُدۡخِلُواْ نَارٗا فَلَمۡ يَجِدُواْ لَهُم مِّن دُونِ ٱللَّهِ أَنصَارٗا",
    translation:
      "Because of their sins they were drowned and put into the Fire, and they found not for themselves besides Allah [any] helpers",
    normalizedText:
      "مما خطيتهم اغرقوا فادخلوا نارا فلم يجدوا لهم من دون الله انصارا",
  },
  {
    verseId: 25,
    name: "نوح",
    surahId: 71,
    text: "وَقَالَ نُوحٞ رَّبِّ لَا تَذَرۡ عَلَى ٱلۡأَرۡضِ مِنَ ٱلۡكَٰفِرِينَ دَيَّارًا",
    translation:
      'And Noah said, "My Lord, do not leave upon the earth from among the disbelievers an inhabitant',
    normalizedText: "وقال نوح رب لا تذر على الارض من الكفرين ديارا",
  },
  {
    verseId: 26,
    name: "نوح",
    surahId: 71,
    text: "إِنَّكَ إِن تَذَرۡهُمۡ يُضِلُّواْ عِبَادَكَ وَلَا يَلِدُوٓاْ إِلَّا فَاجِرٗا كَفَّارٗا",
    translation:
      "Indeed, if You leave them, they will mislead Your servants and not beget except [every] wicked one and [confirmed] disbeliever",
    normalizedText: "انك ان تذرهم يضلوا عبادك ولا يلدوا الا فاجرا كفارا",
  },
  {
    verseId: 27,
    name: "نوح",
    surahId: 71,
    text: "رَّبِّ ٱغۡفِرۡ لِي وَلِوَٰلِدَيَّ وَلِمَن دَخَلَ بَيۡتِيَ مُؤۡمِنٗا وَلِلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِۖ وَلَا تَزِدِ ٱلظَّـٰلِمِينَ إِلَّا تَبَارَۢا",
    translation:
      "My Lord, forgive me and my parents and whoever enters my house a believer and the believing men and believing women. And do not increase the wrongdoers except in destruction",
    normalizedText:
      "رب اغفر لي ولولدي ولمن دخل بيتي مامنا وللمامنين والمامنت ولا تزد الظلمين الا تبارا",
  },
  {
    verseId: 0,
    name: "الجن",
    surahId: 72,
    text: "قُلۡ أُوحِيَ إِلَيَّ أَنَّهُ ٱسۡتَمَعَ نَفَرٞ مِّنَ ٱلۡجِنِّ فَقَالُوٓاْ إِنَّا سَمِعۡنَا قُرۡءَانًا عَجَبٗا",
    translation: `Say, [O Muhammad], "It has been revealed to me that a group of the jinn listened and said, 'Indeed, we have heard an amazing Qur'an`,
    normalizedText:
      "قل اوحي الي انه استمع نفر من الجن فقالوا انا سمعنا قرءانا عجبا",
  },
  {
    verseId: 1,
    name: "الجن",
    surahId: 72,
    text: "يَهۡدِيٓ إِلَى ٱلرُّشۡدِ فَـَٔامَنَّا بِهِۦۖ وَلَن نُّشۡرِكَ بِرَبِّنَآ أَحَدٗا",
    translation:
      "It guides to the right course, and we have believed in it. And we will never associate with our Lord anyone",
    normalizedText: "يهدي الى الرشد فامنا به ولن نشرك بربنا احدا",
  },
  {
    verseId: 2,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّهُۥ تَعَٰلَىٰ جَدُّ رَبِّنَا مَا ٱتَّخَذَ صَٰحِبَةٗ وَلَا وَلَدٗا",
    translation:
      "And [it teaches] that exalted is the nobleness of our Lord; He has not taken a wife or a son",
    normalizedText: "وانه تعلى جد ربنا ما اتخذ صحبة ولا ولدا",
  },
  {
    verseId: 3,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّهُۥ كَانَ يَقُولُ سَفِيهُنَا عَلَى ٱللَّهِ شَطَطٗا",
    translation:
      "And that our foolish one has been saying about Allah an excessive transgression",
    normalizedText: "وانه كان يقول سفيهنا على الله شططا",
  },
  {
    verseId: 4,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا ظَنَنَّآ أَن لَّن تَقُولَ ٱلۡإِنسُ وَٱلۡجِنُّ عَلَى ٱللَّهِ كَذِبٗا",
    translation:
      "And we had thought that mankind and the jinn would never speak about Allah a lie",
    normalizedText: "وانا ظننا ان لن تقول الانس والجن على الله كذبا",
  },
  {
    verseId: 5,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّهُۥ كَانَ رِجَالٞ مِّنَ ٱلۡإِنسِ يَعُوذُونَ بِرِجَالٖ مِّنَ ٱلۡجِنِّ فَزَادُوهُمۡ رَهَقٗا",
    translation:
      "And there were men from mankind who sought refuge in men from the jinn, so they [only] increased them in burden",
    normalizedText: "وانه كان رجال من الانس يعوذون برجال من الجن فزادوهم رهقا",
  },
  {
    verseId: 6,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّهُمۡ ظَنُّواْ كَمَا ظَنَنتُمۡ أَن لَّن يَبۡعَثَ ٱللَّهُ أَحَدٗا",
    translation:
      "And they had thought, as you thought, that Allah would never send anyone [as a messenger]",
    normalizedText: "وانهم ظنوا كما ظننتم ان لن يبعث الله احدا",
  },
  {
    verseId: 7,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا لَمَسۡنَا ٱلسَّمَآءَ فَوَجَدۡنَٰهَا مُلِئَتۡ حَرَسٗا شَدِيدٗا وَشُهُبٗا",
    translation:
      "And we have sought [to reach] the heaven but found it filled with powerful guards and burning flames",
    normalizedText: "وانا لمسنا السماء فوجدنها ملات حرسا شديدا وشهبا",
  },
  {
    verseId: 8,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا كُنَّا نَقۡعُدُ مِنۡهَا مَقَٰعِدَ لِلسَّمۡعِۖ فَمَن يَسۡتَمِعِ ٱلۡأٓنَ يَجِدۡ لَهُۥ شِهَابٗا رَّصَدٗا",
    translation:
      "And we used to sit therein in positions for hearing, but whoever listens now will find a burning flame lying in wait for him",
    normalizedText:
      "وانا كنا نقعد منها مقعد للسمع فمن يستمع الان يجد له شهابا رصدا",
  },
  {
    verseId: 9,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا لَا نَدۡرِيٓ أَشَرٌّ أُرِيدَ بِمَن فِي ٱلۡأَرۡضِ أَمۡ أَرَادَ بِهِمۡ رَبُّهُمۡ رَشَدٗا",
    translation:
      "And we do not know [therefore] whether evil is intended for those on earth or whether their Lord intends for them a right course",
    normalizedText: "وانا لا ندري اشر اريد بمن في الارض ام اراد بهم ربهم رشدا",
  },
  {
    verseId: 10,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا مِنَّا ٱلصَّـٰلِحُونَ وَمِنَّا دُونَ ذَٰلِكَۖ كُنَّا طَرَآئِقَ قِدَدٗا",
    translation:
      "And among us are the righteous, and among us are [others] not so; we were [of] divided ways",
    normalizedText: "وانا منا الصلحون ومنا دون ذلك كنا طرااق قددا",
  },
  {
    verseId: 11,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا ظَنَنَّآ أَن لَّن نُّعۡجِزَ ٱللَّهَ فِي ٱلۡأَرۡضِ وَلَن نُّعۡجِزَهُۥ هَرَبٗا",
    translation:
      "And we have become certain that we will never cause failure to Allah upon earth, nor can we escape Him by flight",
    normalizedText: "وانا ظننا ان لن نعجز الله في الارض ولن نعجزه هربا",
  },
  {
    verseId: 12,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا لَمَّا سَمِعۡنَا ٱلۡهُدَىٰٓ ءَامَنَّا بِهِۦۖ فَمَن يُؤۡمِنۢ بِرَبِّهِۦ فَلَا يَخَافُ بَخۡسٗا وَلَا رَهَقٗا",
    translation:
      "And when we heard the guidance, we believed in it. And whoever believes in his Lord will not fear deprivation or burden",
    normalizedText:
      "وانا لما سمعنا الهدى ءامنا به فمن يامن بربه فلا يخاف بخسا ولا رهقا",
  },
  {
    verseId: 13,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّا مِنَّا ٱلۡمُسۡلِمُونَ وَمِنَّا ٱلۡقَٰسِطُونَۖ فَمَنۡ أَسۡلَمَ فَأُوْلَـٰٓئِكَ تَحَرَّوۡاْ رَشَدٗا",
    translation:
      "And among us are Muslims [in submission to Allah], and among us are the unjust. And whoever has become Muslim - those have sought out the right course",
    normalizedText: "وانا منا المسلمون ومنا القسطون فمن اسلم فاولاك تحروا رشدا",
  },
  {
    verseId: 14,
    name: "الجن",
    surahId: 72,
    text: "وَأَمَّا ٱلۡقَٰسِطُونَ فَكَانُواْ لِجَهَنَّمَ حَطَبٗا",
    translation: "But as for the unjust, they will be, for Hell, firewood",
    normalizedText: "واما القسطون فكانوا لجهنم حطبا",
  },
  {
    verseId: 15,
    name: "الجن",
    surahId: 72,
    text: "وَأَلَّوِ ٱسۡتَقَٰمُواْ عَلَى ٱلطَّرِيقَةِ لَأَسۡقَيۡنَٰهُم مَّآءً غَدَقٗا",
    translation:
      "And [Allah revealed] that if they had remained straight on the way, We would have given them abundant provision",
    normalizedText: "والو استقموا على الطريقة لاسقينهم ماء غدقا",
  },
  {
    verseId: 16,
    name: "الجن",
    surahId: 72,
    text: "لِّنَفۡتِنَهُمۡ فِيهِۚ وَمَن يُعۡرِضۡ عَن ذِكۡرِ رَبِّهِۦ يَسۡلُكۡهُ عَذَابٗا صَعَدٗا",
    translation:
      "So We might test them therein. And whoever turns away from the remembrance of his Lord He will put into arduous punishment",
    normalizedText: "لنفتنهم فيه ومن يعرض عن ذكر ربه يسلكه عذابا صعدا",
  },
  {
    verseId: 17,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّ ٱلۡمَسَٰجِدَ لِلَّهِ فَلَا تَدۡعُواْ مَعَ ٱللَّهِ أَحَدٗا",
    translation:
      "And [He revealed] that the masjids are for Allah, so do not invoke with Allah anyone",
    normalizedText: "وان المسجد لله فلا تدعوا مع الله احدا",
  },
  {
    verseId: 18,
    name: "الجن",
    surahId: 72,
    text: "وَأَنَّهُۥ لَمَّا قَامَ عَبۡدُ ٱللَّهِ يَدۡعُوهُ كَادُواْ يَكُونُونَ عَلَيۡهِ لِبَدٗا",
    translation:
      "And that when the Servant of Allah stood up supplicating Him, they almost became about him a compacted mass",
    normalizedText: "وانه لما قام عبد الله يدعوه كادوا يكونون عليه لبدا",
  },
  {
    verseId: 19,
    name: "الجن",
    surahId: 72,
    text: "قُلۡ إِنَّمَآ أَدۡعُواْ رَبِّي وَلَآ أُشۡرِكُ بِهِۦٓ أَحَدٗا",
    translation:
      'Say, [O Muhammad], "I only invoke my Lord and do not associate with Him anyone',
    normalizedText: "قل انما ادعوا ربي ولا اشرك به احدا",
  },
  {
    verseId: 20,
    name: "الجن",
    surahId: 72,
    text: "قُلۡ إِنِّي لَآ أَمۡلِكُ لَكُمۡ ضَرّٗا وَلَا رَشَدٗا",
    translation:
      'Say, "Indeed, I do not possess for you [the power of] harm or right direction',
    normalizedText: "قل اني لا املك لكم ضرا ولا رشدا",
  },
  {
    verseId: 21,
    name: "الجن",
    surahId: 72,
    text: "قُلۡ إِنِّي لَن يُجِيرَنِي مِنَ ٱللَّهِ أَحَدٞ وَلَنۡ أَجِدَ مِن دُونِهِۦ مُلۡتَحَدًا",
    translation:
      'Say, "Indeed, there will never protect me from Allah anyone [if I should disobey], nor will I find in other than Him a refuge',
    normalizedText: "قل اني لن يجيرني من الله احد ولن اجد من دونه ملتحدا",
  },
  {
    verseId: 22,
    name: "الجن",
    surahId: 72,
    text: "إِلَّا بَلَٰغٗا مِّنَ ٱللَّهِ وَرِسَٰلَٰتِهِۦۚ وَمَن يَعۡصِ ٱللَّهَ وَرَسُولَهُۥ فَإِنَّ لَهُۥ نَارَ جَهَنَّمَ خَٰلِدِينَ فِيهَآ أَبَدًا",
    translation:
      'But [I have for you] only notification from Allah, and His messages." And whoever disobeys Allah and His Messenger - then indeed, for him is the fire of Hell; they will abide therein forever',
    normalizedText:
      "الا بلغا من الله ورسلته ومن يعص الله ورسوله فان له نار جهنم خلدين فيها ابدا",
  },
  {
    verseId: 23,
    name: "الجن",
    surahId: 72,
    text: "حَتَّىٰٓ إِذَا رَأَوۡاْ مَا يُوعَدُونَ فَسَيَعۡلَمُونَ مَنۡ أَضۡعَفُ نَاصِرٗا وَأَقَلُّ عَدَدٗا",
    translation:
      "[The disbelievers continue] until, when they see that which they are promised, then they will know who is weaker in helpers and less in number",
    normalizedText: "حتى اذا راوا ما يوعدون فسيعلمون من اضعف ناصرا واقل عددا",
  },
  {
    verseId: 24,
    name: "الجن",
    surahId: 72,
    text: "قُلۡ إِنۡ أَدۡرِيٓ أَقَرِيبٞ مَّا تُوعَدُونَ أَمۡ يَجۡعَلُ لَهُۥ رَبِّيٓ أَمَدًا",
    translation:
      'Say, "I do not know if what you are promised is near or if my Lord will grant for it a [long] period',
    normalizedText: "قل ان ادري اقريب ما توعدون ام يجعل له ربي امدا",
  },
  {
    verseId: 25,
    name: "الجن",
    surahId: 72,
    text: "عَٰلِمُ ٱلۡغَيۡبِ فَلَا يُظۡهِرُ عَلَىٰ غَيۡبِهِۦٓ أَحَدًا",
    translation:
      "[He is] Knower of the unseen, and He does not disclose His [knowledge of the] unseen to anyone",
    normalizedText: "علم الغيب فلا يظهر على غيبه احدا",
  },
  {
    verseId: 26,
    name: "الجن",
    surahId: 72,
    text: "إِلَّا مَنِ ٱرۡتَضَىٰ مِن رَّسُولٖ فَإِنَّهُۥ يَسۡلُكُ مِنۢ بَيۡنِ يَدَيۡهِ وَمِنۡ خَلۡفِهِۦ رَصَدٗا",
    translation:
      "Except whom He has approved of messengers, and indeed, He sends before each messenger and behind him observers",
    normalizedText: "الا من ارتضى من رسول فانه يسلك من بين يديه ومن خلفه رصدا",
  },
  {
    verseId: 27,
    name: "الجن",
    surahId: 72,
    text: "لِّيَعۡلَمَ أَن قَدۡ أَبۡلَغُواْ رِسَٰلَٰتِ رَبِّهِمۡ وَأَحَاطَ بِمَا لَدَيۡهِمۡ وَأَحۡصَىٰ كُلَّ شَيۡءٍ عَدَدَۢا",
    translation:
      "That he may know that they have conveyed the messages of their Lord; and He has encompassed whatever is with them and has enumerated all things in number",
    normalizedText:
      "ليعلم ان قد ابلغوا رسلت ربهم واحاط بما لديهم واحصى كل شيء عددا",
  },
  {
    verseId: 0,
    name: "المزمل",
    surahId: 73,
    text: "يَـٰٓأَيُّهَا ٱلۡمُزَّمِّلُ",
    translation: "O you who wraps himself [in clothing]",
    normalizedText: "يايها المزمل",
  },
  {
    verseId: 1,
    name: "المزمل",
    surahId: 73,
    text: "قُمِ ٱلَّيۡلَ إِلَّا قَلِيلٗا",
    translation: "Arise [to pray] the night, except for a little",
    normalizedText: "قم اليل الا قليلا",
  },
  {
    verseId: 2,
    name: "المزمل",
    surahId: 73,
    text: "نِّصۡفَهُۥٓ أَوِ ٱنقُصۡ مِنۡهُ قَلِيلًا",
    translation: "Half of it - or subtract from it a little",
    normalizedText: "نصفه او انقص منه قليلا",
  },
  {
    verseId: 3,
    name: "المزمل",
    surahId: 73,
    text: "أَوۡ زِدۡ عَلَيۡهِ وَرَتِّلِ ٱلۡقُرۡءَانَ تَرۡتِيلًا",
    translation: "Or add to it, and recite the Qur'an with measured recitation",
    normalizedText: "او زد عليه ورتل القرءان ترتيلا",
  },
  {
    verseId: 4,
    name: "المزمل",
    surahId: 73,
    text: "إِنَّا سَنُلۡقِي عَلَيۡكَ قَوۡلٗا ثَقِيلًا",
    translation: "Indeed, We will cast upon you a heavy word",
    normalizedText: "انا سنلقي عليك قولا ثقيلا",
  },
  {
    verseId: 5,
    name: "المزمل",
    surahId: 73,
    text: "إِنَّ نَاشِئَةَ ٱلَّيۡلِ هِيَ أَشَدُّ وَطۡـٔٗا وَأَقۡوَمُ قِيلًا",
    translation:
      "Indeed, the hours of the night are more effective for concurrence [of heart and tongue] and more suitable for words",
    normalizedText: "ان ناشاة اليل هي اشد وطا واقوم قيلا",
  },
  {
    verseId: 6,
    name: "المزمل",
    surahId: 73,
    text: "إِنَّ لَكَ فِي ٱلنَّهَارِ سَبۡحٗا طَوِيلٗا",
    translation: "Indeed, for you by day is prolonged occupation",
    normalizedText: "ان لك في النهار سبحا طويلا",
  },
  {
    verseId: 7,
    name: "المزمل",
    surahId: 73,
    text: "وَٱذۡكُرِ ٱسۡمَ رَبِّكَ وَتَبَتَّلۡ إِلَيۡهِ تَبۡتِيلٗا",
    translation:
      "And remember the name of your Lord and devote yourself to Him with [complete] devotion",
    normalizedText: "واذكر اسم ربك وتبتل اليه تبتيلا",
  },
  {
    verseId: 8,
    name: "المزمل",
    surahId: 73,
    text: "رَّبُّ ٱلۡمَشۡرِقِ وَٱلۡمَغۡرِبِ لَآ إِلَٰهَ إِلَّا هُوَ فَٱتَّخِذۡهُ وَكِيلٗا",
    translation:
      "[He is] the Lord of the East and the West; there is no deity except Him, so take Him as Disposer of [your] affairs",
    normalizedText: "رب المشرق والمغرب لا اله الا هو فاتخذه وكيلا",
  },
  {
    verseId: 9,
    name: "المزمل",
    surahId: 73,
    text: "وَٱصۡبِرۡ عَلَىٰ مَا يَقُولُونَ وَٱهۡجُرۡهُمۡ هَجۡرٗا جَمِيلٗا",
    translation:
      "And be patient over what they say and avoid them with gracious avoidance",
    normalizedText: "واصبر على ما يقولون واهجرهم هجرا جميلا",
  },
  {
    verseId: 10,
    name: "المزمل",
    surahId: 73,
    text: "وَذَرۡنِي وَٱلۡمُكَذِّبِينَ أُوْلِي ٱلنَّعۡمَةِ وَمَهِّلۡهُمۡ قَلِيلًا",
    translation:
      "And leave Me with [the matter of] the deniers, those of ease [in life], and allow them respite a little",
    normalizedText: "وذرني والمكذبين اولي النعمة ومهلهم قليلا",
  },
  {
    verseId: 11,
    name: "المزمل",
    surahId: 73,
    text: "إِنَّ لَدَيۡنَآ أَنكَالٗا وَجَحِيمٗا",
    translation: "Indeed, with Us [for them] are shackles and burning fire",
    normalizedText: "ان لدينا انكالا وجحيما",
  },
  {
    verseId: 12,
    name: "المزمل",
    surahId: 73,
    text: "وَطَعَامٗا ذَا غُصَّةٖ وَعَذَابًا أَلِيمٗا",
    translation: "And food that chokes and a painful punishment",
    normalizedText: "وطعاما ذا غصة وعذابا اليما",
  },
  {
    verseId: 13,
    name: "المزمل",
    surahId: 73,
    text: "يَوۡمَ تَرۡجُفُ ٱلۡأَرۡضُ وَٱلۡجِبَالُ وَكَانَتِ ٱلۡجِبَالُ كَثِيبٗا مَّهِيلًا",
    translation:
      "On the Day the earth and the mountains will convulse and the mountains will become a heap of sand pouring down",
    normalizedText: "يوم ترجف الارض والجبال وكانت الجبال كثيبا مهيلا",
  },
  {
    verseId: 14,
    name: "المزمل",
    surahId: 73,
    text: "إِنَّآ أَرۡسَلۡنَآ إِلَيۡكُمۡ رَسُولٗا شَٰهِدًا عَلَيۡكُمۡ كَمَآ أَرۡسَلۡنَآ إِلَىٰ فِرۡعَوۡنَ رَسُولٗا",
    translation:
      "Indeed, We have sent to you a Messenger as a witness upon you just as We sent to Pharaoh a messenger",
    normalizedText:
      "انا ارسلنا اليكم رسولا شهدا عليكم كما ارسلنا الى فرعون رسولا",
  },
  {
    verseId: 15,
    name: "المزمل",
    surahId: 73,
    text: "فَعَصَىٰ فِرۡعَوۡنُ ٱلرَّسُولَ فَأَخَذۡنَٰهُ أَخۡذٗا وَبِيلٗا",
    translation:
      "But Pharaoh disobeyed the messenger, so We seized him with a ruinous seizure",
    normalizedText: "فعصى فرعون الرسول فاخذنه اخذا وبيلا",
  },
  {
    verseId: 16,
    name: "المزمل",
    surahId: 73,
    text: "فَكَيۡفَ تَتَّقُونَ إِن كَفَرۡتُمۡ يَوۡمٗا يَجۡعَلُ ٱلۡوِلۡدَٰنَ شِيبًا",
    translation:
      "Then how can you fear, if you disbelieve, a Day that will make the children white- haired",
    normalizedText: "فكيف تتقون ان كفرتم يوما يجعل الولدن شيبا",
  },
  {
    verseId: 17,
    name: "المزمل",
    surahId: 73,
    text: "ٱلسَّمَآءُ مُنفَطِرُۢ بِهِۦۚ كَانَ وَعۡدُهُۥ مَفۡعُولًا",
    translation:
      "The heaven will break apart therefrom; ever is His promise fulfilled",
    normalizedText: "السماء منفطر به كان وعده مفعولا",
  },
  {
    verseId: 18,
    name: "المزمل",
    surahId: 73,
    text: "إِنَّ هَٰذِهِۦ تَذۡكِرَةٞۖ فَمَن شَآءَ ٱتَّخَذَ إِلَىٰ رَبِّهِۦ سَبِيلًا",
    translation:
      "Indeed, this is a reminder, so whoever wills may take to his Lord a way",
    normalizedText: "ان هذه تذكرة فمن شاء اتخذ الى ربه سبيلا",
  },
  {
    verseId: 19,
    name: "المزمل",
    surahId: 73,
    text: "۞إِنَّ رَبَّكَ يَعۡلَمُ أَنَّكَ تَقُومُ أَدۡنَىٰ مِن ثُلُثَيِ ٱلَّيۡلِ وَنِصۡفَهُۥ وَثُلُثَهُۥ وَطَآئِفَةٞ مِّنَ ٱلَّذِينَ مَعَكَۚ وَٱللَّهُ يُقَدِّرُ ٱلَّيۡلَ وَٱلنَّهَارَۚ عَلِمَ أَن لَّن تُحۡصُوهُ فَتَابَ عَلَيۡكُمۡۖ فَٱقۡرَءُواْ مَا تَيَسَّرَ مِنَ ٱلۡقُرۡءَانِۚ عَلِمَ أَن سَيَكُونُ مِنكُم مَّرۡضَىٰ وَءَاخَرُونَ يَضۡرِبُونَ فِي ٱلۡأَرۡضِ يَبۡتَغُونَ مِن فَضۡلِ ٱللَّهِ وَءَاخَرُونَ يُقَٰتِلُونَ فِي سَبِيلِ ٱللَّهِۖ فَٱقۡرَءُواْ مَا تَيَسَّرَ مِنۡهُۚ وَأَقِيمُواْ ٱلصَّلَوٰةَ وَءَاتُواْ ٱلزَّكَوٰةَ وَأَقۡرِضُواْ ٱللَّهَ قَرۡضًا حَسَنٗاۚ وَمَا تُقَدِّمُواْ لِأَنفُسِكُم مِّنۡ خَيۡرٖ تَجِدُوهُ عِندَ ٱللَّهِ هُوَ خَيۡرٗا وَأَعۡظَمَ أَجۡرٗاۚ وَٱسۡتَغۡفِرُواْ ٱللَّهَۖ إِنَّ ٱللَّهَ غَفُورٞ رَّحِيمُۢ",
    translation:
      "Indeed, your Lord knows, [O Muhammad], that you stand [in prayer] almost two thirds of the night or half of it or a third of it, and [so do] a group of those with you. And Allah determines [the extent of] the night and the day. He has known that you [Muslims] will not be able to do it and has turned to you in forgiveness, so recite what is easy [for you] of the Qur'an. He has known that there will be among you those who are ill and others traveling throughout the land seeking [something] of the bounty of Allah and others fighting for the cause of Allah. So recite what is easy from it and establish prayer and give zakah and loan Allah a goodly loan. And whatever good you put forward for yourselves - you will find it with Allah. It is better and greater in reward. And seek forgiveness of Allah. Indeed, Allah is Forgiving and Merciful",
    normalizedText:
      "۞ان ربك يعلم انك تقوم ادنى من ثلثي اليل ونصفه وثلثه وطاافة من الذين معك والله يقدر اليل والنهار علم ان لن تحصوه فتاب عليكم فاقرءوا ما تيسر من القرءان علم ان سيكون منكم مرضى وءاخرون يضربون في الارض يبتغون من فضل الله وءاخرون يقتلون في سبيل الله فاقرءوا ما تيسر منه واقيموا الصلوة وءاتوا الزكوة واقرضوا الله قرضا حسنا وما تقدموا لانفسكم من خير تجدوه عند الله هو خيرا واعظم اجرا واستغفروا الله ان الله غفور رحيم",
  },
  {
    verseId: 0,
    name: "المدثر",
    surahId: 74,
    text: "يَـٰٓأَيُّهَا ٱلۡمُدَّثِّرُ",
    translation: "O you who covers himself [with a garment]",
    normalizedText: "يايها المدثر",
  },
  {
    verseId: 1,
    name: "المدثر",
    surahId: 74,
    text: "قُمۡ فَأَنذِرۡ",
    translation: "Arise and warn",
    normalizedText: "قم فانذر",
  },
  {
    verseId: 2,
    name: "المدثر",
    surahId: 74,
    text: "وَرَبَّكَ فَكَبِّرۡ",
    translation: "And your Lord glorify",
    normalizedText: "وربك فكبر",
  },
  {
    verseId: 3,
    name: "المدثر",
    surahId: 74,
    text: "وَثِيَابَكَ فَطَهِّرۡ",
    translation: "And your clothing purify",
    normalizedText: "وثيابك فطهر",
  },
  {
    verseId: 4,
    name: "المدثر",
    surahId: 74,
    text: "وَٱلرُّجۡزَ فَٱهۡجُرۡ",
    translation: "And uncleanliness avoid",
    normalizedText: "والرجز فاهجر",
  },
  {
    verseId: 5,
    name: "المدثر",
    surahId: 74,
    text: "وَلَا تَمۡنُن تَسۡتَكۡثِرُ",
    translation: "And do not confer favor to acquire more",
    normalizedText: "ولا تمنن تستكثر",
  },
  {
    verseId: 6,
    name: "المدثر",
    surahId: 74,
    text: "وَلِرَبِّكَ فَٱصۡبِرۡ",
    translation: "But for your Lord be patient",
    normalizedText: "ولربك فاصبر",
  },
  {
    verseId: 7,
    name: "المدثر",
    surahId: 74,
    text: "فَإِذَا نُقِرَ فِي ٱلنَّاقُورِ",
    translation: "And when the trumpet is blown",
    normalizedText: "فاذا نقر في الناقور",
  },
  {
    verseId: 8,
    name: "المدثر",
    surahId: 74,
    text: "فَذَٰلِكَ يَوۡمَئِذٖ يَوۡمٌ عَسِيرٌ",
    translation: "That Day will be a difficult day",
    normalizedText: "فذلك يوماذ يوم عسير",
  },
  {
    verseId: 9,
    name: "المدثر",
    surahId: 74,
    text: "عَلَى ٱلۡكَٰفِرِينَ غَيۡرُ يَسِيرٖ",
    translation: "For the disbelievers - not easy",
    normalizedText: "على الكفرين غير يسير",
  },
  {
    verseId: 10,
    name: "المدثر",
    surahId: 74,
    text: "ذَرۡنِي وَمَنۡ خَلَقۡتُ وَحِيدٗا",
    translation: "Leave Me with the one I created alone",
    normalizedText: "ذرني ومن خلقت وحيدا",
  },
  {
    verseId: 11,
    name: "المدثر",
    surahId: 74,
    text: "وَجَعَلۡتُ لَهُۥ مَالٗا مَّمۡدُودٗا",
    translation: "And to whom I granted extensive wealth",
    normalizedText: "وجعلت له مالا ممدودا",
  },
  {
    verseId: 12,
    name: "المدثر",
    surahId: 74,
    text: "وَبَنِينَ شُهُودٗا",
    translation: "And children present [with him]",
    normalizedText: "وبنين شهودا",
  },
  {
    verseId: 13,
    name: "المدثر",
    surahId: 74,
    text: "وَمَهَّدتُّ لَهُۥ تَمۡهِيدٗا",
    translation: "And spread [everything] before him, easing [his life]",
    normalizedText: "ومهدت له تمهيدا",
  },
  {
    verseId: 14,
    name: "المدثر",
    surahId: 74,
    text: "ثُمَّ يَطۡمَعُ أَنۡ أَزِيدَ",
    translation: "Then he desires that I should add more",
    normalizedText: "ثم يطمع ان ازيد",
  },
  {
    verseId: 15,
    name: "المدثر",
    surahId: 74,
    text: "كَلَّآۖ إِنَّهُۥ كَانَ لِأٓيَٰتِنَا عَنِيدٗا",
    translation: "No! Indeed, he has been toward Our verses obstinate",
    normalizedText: "كلا انه كان لايتنا عنيدا",
  },
  {
    verseId: 16,
    name: "المدثر",
    surahId: 74,
    text: "سَأُرۡهِقُهُۥ صَعُودًا",
    translation: "I will cover him with arduous torment",
    normalizedText: "سارهقه صعودا",
  },
  {
    verseId: 17,
    name: "المدثر",
    surahId: 74,
    text: "إِنَّهُۥ فَكَّرَ وَقَدَّرَ",
    translation: "Indeed, he thought and deliberated",
    normalizedText: "انه فكر وقدر",
  },
  {
    verseId: 18,
    name: "المدثر",
    surahId: 74,
    text: "فَقُتِلَ كَيۡفَ قَدَّرَ",
    translation: "So may he be destroyed [for] how he deliberated",
    normalizedText: "فقتل كيف قدر",
  },
  {
    verseId: 19,
    name: "المدثر",
    surahId: 74,
    text: "ثُمَّ قُتِلَ كَيۡفَ قَدَّرَ",
    translation: "Then may he be destroyed [for] how he deliberated",
    normalizedText: "ثم قتل كيف قدر",
  },
  {
    verseId: 20,
    name: "المدثر",
    surahId: 74,
    text: "ثُمَّ نَظَرَ",
    translation: "Then he considered [again]",
    normalizedText: "ثم نظر",
  },
  {
    verseId: 21,
    name: "المدثر",
    surahId: 74,
    text: "ثُمَّ عَبَسَ وَبَسَرَ",
    translation: "Then he frowned and scowled",
    normalizedText: "ثم عبس وبسر",
  },
  {
    verseId: 22,
    name: "المدثر",
    surahId: 74,
    text: "ثُمَّ أَدۡبَرَ وَٱسۡتَكۡبَرَ",
    translation: "Then he turned back and was arrogant",
    normalizedText: "ثم ادبر واستكبر",
  },
  {
    verseId: 23,
    name: "المدثر",
    surahId: 74,
    text: "فَقَالَ إِنۡ هَٰذَآ إِلَّا سِحۡرٞ يُؤۡثَرُ",
    translation: 'And said, "This is not but magic imitated [from others]',
    normalizedText: "فقال ان هذا الا سحر ياثر",
  },
  {
    verseId: 24,
    name: "المدثر",
    surahId: 74,
    text: "إِنۡ هَٰذَآ إِلَّا قَوۡلُ ٱلۡبَشَرِ",
    translation: "This is not but the word of a human being",
    normalizedText: "ان هذا الا قول البشر",
  },
  {
    verseId: 25,
    name: "المدثر",
    surahId: 74,
    text: "سَأُصۡلِيهِ سَقَرَ",
    translation: "I will drive him into Saqar",
    normalizedText: "ساصليه سقر",
  },
  {
    verseId: 26,
    name: "المدثر",
    surahId: 74,
    text: "وَمَآ أَدۡرَىٰكَ مَا سَقَرُ",
    translation: "And what can make you know what is Saqar",
    normalizedText: "وما ادرىك ما سقر",
  },
  {
    verseId: 27,
    name: "المدثر",
    surahId: 74,
    text: "لَا تُبۡقِي وَلَا تَذَرُ",
    translation: "It lets nothing remain and leaves nothing [unburned]",
    normalizedText: "لا تبقي ولا تذر",
  },
  {
    verseId: 28,
    name: "المدثر",
    surahId: 74,
    text: "لَوَّاحَةٞ لِّلۡبَشَرِ",
    translation: "Blackening the skins",
    normalizedText: "لواحة للبشر",
  },
  {
    verseId: 29,
    name: "المدثر",
    surahId: 74,
    text: "عَلَيۡهَا تِسۡعَةَ عَشَرَ",
    translation: "Over it are nineteen [angels]",
    normalizedText: "عليها تسعة عشر",
  },
  {
    verseId: 30,
    name: "المدثر",
    surahId: 74,
    text: "وَمَا جَعَلۡنَآ أَصۡحَٰبَ ٱلنَّارِ إِلَّا مَلَـٰٓئِكَةٗۖ وَمَا جَعَلۡنَا عِدَّتَهُمۡ إِلَّا فِتۡنَةٗ لِّلَّذِينَ كَفَرُواْ لِيَسۡتَيۡقِنَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ وَيَزۡدَادَ ٱلَّذِينَ ءَامَنُوٓاْ إِيمَٰنٗا وَلَا يَرۡتَابَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ وَٱلۡمُؤۡمِنُونَ وَلِيَقُولَ ٱلَّذِينَ فِي قُلُوبِهِم مَّرَضٞ وَٱلۡكَٰفِرُونَ مَاذَآ أَرَادَ ٱللَّهُ بِهَٰذَا مَثَلٗاۚ كَذَٰلِكَ يُضِلُّ ٱللَّهُ مَن يَشَآءُ وَيَهۡدِي مَن يَشَآءُۚ وَمَا يَعۡلَمُ جُنُودَ رَبِّكَ إِلَّا هُوَۚ وَمَا هِيَ إِلَّا ذِكۡرَىٰ لِلۡبَشَرِ",
    translation:
      'And We have not made the keepers of the Fire except angels. And We have not made their number except as a trial for those who disbelieve - that those who were given the Scripture will be convinced and those who have believed will increase in faith and those who were given the Scripture and the believers will not doubt and that those in whose hearts is hypocrisy and the disbelievers will say, "What does Allah intend by this as an example?" Thus does Allah leave astray whom He wills and guides whom He wills. And none knows the soldiers of your Lord except Him. And mention of the Fire is not but a reminder to humanity',
    normalizedText:
      "وما جعلنا اصحب النار الا ملاكة وما جعلنا عدتهم الا فتنة للذين كفروا ليستيقن الذين اوتوا الكتب ويزداد الذين ءامنوا ايمنا ولا يرتاب الذين اوتوا الكتب والمامنون وليقول الذين في قلوبهم مرض والكفرون ماذا اراد الله بهذا مثلا كذلك يضل الله من يشاء ويهدي من يشاء وما يعلم جنود ربك الا هو وما هي الا ذكرى للبشر",
  },
  {
    verseId: 31,
    name: "المدثر",
    surahId: 74,
    text: "كَلَّا وَٱلۡقَمَرِ",
    translation: "No! By the moon",
    normalizedText: "كلا والقمر",
  },
  {
    verseId: 32,
    name: "المدثر",
    surahId: 74,
    text: "وَٱلَّيۡلِ إِذۡ أَدۡبَرَ",
    translation: "And [by] the night when it departs",
    normalizedText: "واليل اذ ادبر",
  },
  {
    verseId: 33,
    name: "المدثر",
    surahId: 74,
    text: "وَٱلصُّبۡحِ إِذَآ أَسۡفَرَ",
    translation: "And [by] the morning when it brightens",
    normalizedText: "والصبح اذا اسفر",
  },
  {
    verseId: 34,
    name: "المدثر",
    surahId: 74,
    text: "إِنَّهَا لَإِحۡدَى ٱلۡكُبَرِ",
    translation: "Indeed, the Fire is of the greatest [afflictions]",
    normalizedText: "انها لاحدى الكبر",
  },
  {
    verseId: 35,
    name: "المدثر",
    surahId: 74,
    text: "نَذِيرٗا لِّلۡبَشَرِ",
    translation: "As a warning to humanity",
    normalizedText: "نذيرا للبشر",
  },
  {
    verseId: 36,
    name: "المدثر",
    surahId: 74,
    text: "لِمَن شَآءَ مِنكُمۡ أَن يَتَقَدَّمَ أَوۡ يَتَأَخَّرَ",
    translation: "To whoever wills among you to proceed or stay behind",
    normalizedText: "لمن شاء منكم ان يتقدم او يتاخر",
  },
  {
    verseId: 37,
    name: "المدثر",
    surahId: 74,
    text: "كُلُّ نَفۡسِۭ بِمَا كَسَبَتۡ رَهِينَةٌ",
    translation: "Every soul, for what it has earned, will be retained",
    normalizedText: "كل نفس بما كسبت رهينة",
  },
  {
    verseId: 38,
    name: "المدثر",
    surahId: 74,
    text: "إِلَّآ أَصۡحَٰبَ ٱلۡيَمِينِ",
    translation: "Except the companions of the right",
    normalizedText: "الا اصحب اليمين",
  },
  {
    verseId: 39,
    name: "المدثر",
    surahId: 74,
    text: "فِي جَنَّـٰتٖ يَتَسَآءَلُونَ",
    translation: "[Who will be] in gardens, questioning each other",
    normalizedText: "في جنت يتساءلون",
  },
  {
    verseId: 40,
    name: "المدثر",
    surahId: 74,
    text: "عَنِ ٱلۡمُجۡرِمِينَ",
    translation: "About the criminals",
    normalizedText: "عن المجرمين",
  },
  {
    verseId: 41,
    name: "المدثر",
    surahId: 74,
    text: "مَا سَلَكَكُمۡ فِي سَقَرَ",
    translation: '[And asking them], "What put you into Saqar',
    normalizedText: "ما سلككم في سقر",
  },
  {
    verseId: 42,
    name: "المدثر",
    surahId: 74,
    text: "قَالُواْ لَمۡ نَكُ مِنَ ٱلۡمُصَلِّينَ",
    translation: 'They will say, "We were not of those who prayed',
    normalizedText: "قالوا لم نك من المصلين",
  },
  {
    verseId: 43,
    name: "المدثر",
    surahId: 74,
    text: "وَلَمۡ نَكُ نُطۡعِمُ ٱلۡمِسۡكِينَ",
    translation: "Nor did we used to feed the poor",
    normalizedText: "ولم نك نطعم المسكين",
  },
  {
    verseId: 44,
    name: "المدثر",
    surahId: 74,
    text: "وَكُنَّا نَخُوضُ مَعَ ٱلۡخَآئِضِينَ",
    translation:
      "And we used to enter into vain discourse with those who engaged [in it]",
    normalizedText: "وكنا نخوض مع الخااضين",
  },
  {
    verseId: 45,
    name: "المدثر",
    surahId: 74,
    text: "وَكُنَّا نُكَذِّبُ بِيَوۡمِ ٱلدِّينِ",
    translation: "And we used to deny the Day of Recompense",
    normalizedText: "وكنا نكذب بيوم الدين",
  },
  {
    verseId: 46,
    name: "المدثر",
    surahId: 74,
    text: "حَتَّىٰٓ أَتَىٰنَا ٱلۡيَقِينُ",
    translation: "Until there came to us the certainty",
    normalizedText: "حتى اتىنا اليقين",
  },
  {
    verseId: 47,
    name: "المدثر",
    surahId: 74,
    text: "فَمَا تَنفَعُهُمۡ شَفَٰعَةُ ٱلشَّـٰفِعِينَ",
    translation:
      "So there will not benefit them the intercession of [any] intercessors",
    normalizedText: "فما تنفعهم شفعة الشفعين",
  },
  {
    verseId: 48,
    name: "المدثر",
    surahId: 74,
    text: "فَمَا لَهُمۡ عَنِ ٱلتَّذۡكِرَةِ مُعۡرِضِينَ",
    translation:
      "Then what is [the matter] with them that they are, from the reminder, turning away",
    normalizedText: "فما لهم عن التذكرة معرضين",
  },
  {
    verseId: 49,
    name: "المدثر",
    surahId: 74,
    text: "كَأَنَّهُمۡ حُمُرٞ مُّسۡتَنفِرَةٞ",
    translation: "As if they were alarmed donkeys",
    normalizedText: "كانهم حمر مستنفرة",
  },
  {
    verseId: 50,
    name: "المدثر",
    surahId: 74,
    text: "فَرَّتۡ مِن قَسۡوَرَةِۭ",
    translation: "Fleeing from a lion",
    normalizedText: "فرت من قسورة",
  },
  {
    verseId: 51,
    name: "المدثر",
    surahId: 74,
    text: "بَلۡ يُرِيدُ كُلُّ ٱمۡرِيٕٖ مِّنۡهُمۡ أَن يُؤۡتَىٰ صُحُفٗا مُّنَشَّرَةٗ",
    translation:
      "Rather, every person among them desires that he would be given scriptures spread about",
    normalizedText: "بل يريد كل امري منهم ان ياتى صحفا منشرة",
  },
  {
    verseId: 52,
    name: "المدثر",
    surahId: 74,
    text: "كَلَّاۖ بَل لَّا يَخَافُونَ ٱلۡأٓخِرَةَ",
    translation: "No! But they do not fear the Hereafter",
    normalizedText: "كلا بل لا يخافون الاخرة",
  },
  {
    verseId: 53,
    name: "المدثر",
    surahId: 74,
    text: "كَلَّآ إِنَّهُۥ تَذۡكِرَةٞ",
    translation: "No! Indeed, the Qur'an is a reminder",
    normalizedText: "كلا انه تذكرة",
  },
  {
    verseId: 54,
    name: "المدثر",
    surahId: 74,
    text: "فَمَن شَآءَ ذَكَرَهُۥ",
    translation: "Then whoever wills will remember it",
    normalizedText: "فمن شاء ذكره",
  },
  {
    verseId: 55,
    name: "المدثر",
    surahId: 74,
    text: "وَمَا يَذۡكُرُونَ إِلَّآ أَن يَشَآءَ ٱللَّهُۚ هُوَ أَهۡلُ ٱلتَّقۡوَىٰ وَأَهۡلُ ٱلۡمَغۡفِرَةِ",
    translation:
      "And they will not remember except that Allah wills. He is worthy of fear and adequate for [granting] forgiveness",
    normalizedText: "وما يذكرون الا ان يشاء الله هو اهل التقوى واهل المغفرة",
  },
  {
    verseId: 0,
    name: "القيامة",
    surahId: 75,
    text: "لَآ أُقۡسِمُ بِيَوۡمِ ٱلۡقِيَٰمَةِ",
    translation: "I swear by the Day of Resurrection",
    normalizedText: "لا اقسم بيوم القيمة",
  },
  {
    verseId: 1,
    name: "القيامة",
    surahId: 75,
    text: "وَلَآ أُقۡسِمُ بِٱلنَّفۡسِ ٱللَّوَّامَةِ",
    translation:
      "And I swear by the reproaching soul [to the certainty of resurrection]",
    normalizedText: "ولا اقسم بالنفس اللوامة",
  },
  {
    verseId: 2,
    name: "القيامة",
    surahId: 75,
    text: "أَيَحۡسَبُ ٱلۡإِنسَٰنُ أَلَّن نَّجۡمَعَ عِظَامَهُۥ",
    translation: "Does man think that We will not assemble his bones",
    normalizedText: "ايحسب الانسن الن نجمع عظامه",
  },
  {
    verseId: 3,
    name: "القيامة",
    surahId: 75,
    text: "بَلَىٰ قَٰدِرِينَ عَلَىٰٓ أَن نُّسَوِّيَ بَنَانَهُۥ",
    translation: "Yes. [We are] Able [even] to proportion his fingertips",
    normalizedText: "بلى قدرين على ان نسوي بنانه",
  },
  {
    verseId: 4,
    name: "القيامة",
    surahId: 75,
    text: "بَلۡ يُرِيدُ ٱلۡإِنسَٰنُ لِيَفۡجُرَ أَمَامَهُۥ",
    translation: "But man desires to continue in sin",
    normalizedText: "بل يريد الانسن ليفجر امامه",
  },
  {
    verseId: 5,
    name: "القيامة",
    surahId: 75,
    text: "يَسۡـَٔلُ أَيَّانَ يَوۡمُ ٱلۡقِيَٰمَةِ",
    translation: 'He asks, "When is the Day of Resurrection',
    normalizedText: "يسل ايان يوم القيمة",
  },
  {
    verseId: 6,
    name: "القيامة",
    surahId: 75,
    text: "فَإِذَا بَرِقَ ٱلۡبَصَرُ",
    translation: "So when vision is dazzled",
    normalizedText: "فاذا برق البصر",
  },
  {
    verseId: 7,
    name: "القيامة",
    surahId: 75,
    text: "وَخَسَفَ ٱلۡقَمَرُ",
    translation: "And the moon darkens",
    normalizedText: "وخسف القمر",
  },
  {
    verseId: 8,
    name: "القيامة",
    surahId: 75,
    text: "وَجُمِعَ ٱلشَّمۡسُ وَٱلۡقَمَرُ",
    translation: "And the sun and the moon are joined",
    normalizedText: "وجمع الشمس والقمر",
  },
  {
    verseId: 9,
    name: "القيامة",
    surahId: 75,
    text: "يَقُولُ ٱلۡإِنسَٰنُ يَوۡمَئِذٍ أَيۡنَ ٱلۡمَفَرُّ",
    translation: 'Man will say on that Day, "Where is the [place of] escape',
    normalizedText: "يقول الانسن يوماذ اين المفر",
  },
  {
    verseId: 10,
    name: "القيامة",
    surahId: 75,
    text: "كَلَّا لَا وَزَرَ",
    translation: "No! There is no refuge",
    normalizedText: "كلا لا وزر",
  },
  {
    verseId: 11,
    name: "القيامة",
    surahId: 75,
    text: "إِلَىٰ رَبِّكَ يَوۡمَئِذٍ ٱلۡمُسۡتَقَرُّ",
    translation: "To your Lord, that Day, is the [place of] permanence",
    normalizedText: "الى ربك يوماذ المستقر",
  },
  {
    verseId: 12,
    name: "القيامة",
    surahId: 75,
    text: "يُنَبَّؤُاْ ٱلۡإِنسَٰنُ يَوۡمَئِذِۭ بِمَا قَدَّمَ وَأَخَّرَ",
    translation:
      "Man will be informed that Day of what he sent ahead and kept back",
    normalizedText: "ينباا الانسن يوماذ بما قدم واخر",
  },
  {
    verseId: 13,
    name: "القيامة",
    surahId: 75,
    text: "بَلِ ٱلۡإِنسَٰنُ عَلَىٰ نَفۡسِهِۦ بَصِيرَةٞ",
    translation: "Rather, man, against himself, will be a witness",
    normalizedText: "بل الانسن على نفسه بصيرة",
  },
  {
    verseId: 14,
    name: "القيامة",
    surahId: 75,
    text: "وَلَوۡ أَلۡقَىٰ مَعَاذِيرَهُۥ",
    translation: "Even if he presents his excuses",
    normalizedText: "ولو القى معاذيره",
  },
  {
    verseId: 15,
    name: "القيامة",
    surahId: 75,
    text: "لَا تُحَرِّكۡ بِهِۦ لِسَانَكَ لِتَعۡجَلَ بِهِۦٓ",
    translation:
      "Move not your tongue with it, [O Muhammad], to hasten with recitation of the Qur'an",
    normalizedText: "لا تحرك به لسانك لتعجل به",
  },
  {
    verseId: 16,
    name: "القيامة",
    surahId: 75,
    text: "إِنَّ عَلَيۡنَا جَمۡعَهُۥ وَقُرۡءَانَهُۥ",
    translation:
      "Indeed, upon Us is its collection [in your heart] and [to make possible] its recitation",
    normalizedText: "ان علينا جمعه وقرءانه",
  },
  {
    verseId: 17,
    name: "القيامة",
    surahId: 75,
    text: "فَإِذَا قَرَأۡنَٰهُ فَٱتَّبِعۡ قُرۡءَانَهُۥ",
    translation:
      "So when We have recited it [through Gabriel], then follow its recitation",
    normalizedText: "فاذا قرانه فاتبع قرءانه",
  },
  {
    verseId: 18,
    name: "القيامة",
    surahId: 75,
    text: "ثُمَّ إِنَّ عَلَيۡنَا بَيَانَهُۥ",
    translation: "Then upon Us is its clarification [to you]",
    normalizedText: "ثم ان علينا بيانه",
  },
  {
    verseId: 19,
    name: "القيامة",
    surahId: 75,
    text: "كَلَّا بَلۡ تُحِبُّونَ ٱلۡعَاجِلَةَ",
    translation: "No! But you love the immediate",
    normalizedText: "كلا بل تحبون العاجلة",
  },
  {
    verseId: 20,
    name: "القيامة",
    surahId: 75,
    text: "وَتَذَرُونَ ٱلۡأٓخِرَةَ",
    translation: "And leave the Hereafter",
    normalizedText: "وتذرون الاخرة",
  },
  {
    verseId: 21,
    name: "القيامة",
    surahId: 75,
    text: "وُجُوهٞ يَوۡمَئِذٖ نَّاضِرَةٌ",
    translation: "[Some] faces, that Day, will be radiant",
    normalizedText: "وجوه يوماذ ناضرة",
  },
  {
    verseId: 22,
    name: "القيامة",
    surahId: 75,
    text: "إِلَىٰ رَبِّهَا نَاظِرَةٞ",
    translation: "Looking at their Lord",
    normalizedText: "الى ربها ناظرة",
  },
  {
    verseId: 23,
    name: "القيامة",
    surahId: 75,
    text: "وَوُجُوهٞ يَوۡمَئِذِۭ بَاسِرَةٞ",
    translation: "And [some] faces, that Day, will be contorted",
    normalizedText: "ووجوه يوماذ باسرة",
  },
  {
    verseId: 24,
    name: "القيامة",
    surahId: 75,
    text: "تَظُنُّ أَن يُفۡعَلَ بِهَا فَاقِرَةٞ",
    translation:
      "Expecting that there will be done to them [something] backbreaking",
    normalizedText: "تظن ان يفعل بها فاقرة",
  },
  {
    verseId: 25,
    name: "القيامة",
    surahId: 75,
    text: "كَلَّآ إِذَا بَلَغَتِ ٱلتَّرَاقِيَ",
    translation: "No! When the soul has reached the collar bones",
    normalizedText: "كلا اذا بلغت التراقي",
  },
  {
    verseId: 26,
    name: "القيامة",
    surahId: 75,
    text: "وَقِيلَ مَنۡۜ رَاقٖ",
    translation: 'And it is said, "Who will cure [him]',
    normalizedText: "وقيل من راق",
  },
  {
    verseId: 27,
    name: "القيامة",
    surahId: 75,
    text: "وَظَنَّ أَنَّهُ ٱلۡفِرَاقُ",
    translation:
      "And the dying one is certain that it is the [time of] separation",
    normalizedText: "وظن انه الفراق",
  },
  {
    verseId: 28,
    name: "القيامة",
    surahId: 75,
    text: "وَٱلۡتَفَّتِ ٱلسَّاقُ بِٱلسَّاقِ",
    translation: "And the leg is wound about the leg",
    normalizedText: "والتفت الساق بالساق",
  },
  {
    verseId: 29,
    name: "القيامة",
    surahId: 75,
    text: "إِلَىٰ رَبِّكَ يَوۡمَئِذٍ ٱلۡمَسَاقُ",
    translation: "To your Lord, that Day, will be the procession",
    normalizedText: "الى ربك يوماذ المساق",
  },
  {
    verseId: 30,
    name: "القيامة",
    surahId: 75,
    text: "فَلَا صَدَّقَ وَلَا صَلَّىٰ",
    translation: "And the disbeliever had not believed, nor had he prayed",
    normalizedText: "فلا صدق ولا صلى",
  },
  {
    verseId: 31,
    name: "القيامة",
    surahId: 75,
    text: "وَلَٰكِن كَذَّبَ وَتَوَلَّىٰ",
    translation: "But [instead], he denied and turned away",
    normalizedText: "ولكن كذب وتولى",
  },
  {
    verseId: 32,
    name: "القيامة",
    surahId: 75,
    text: "ثُمَّ ذَهَبَ إِلَىٰٓ أَهۡلِهِۦ يَتَمَطَّىٰٓ",
    translation: "And then he went to his people, swaggering [in pride]",
    normalizedText: "ثم ذهب الى اهله يتمطى",
  },
  {
    verseId: 33,
    name: "القيامة",
    surahId: 75,
    text: "أَوۡلَىٰ لَكَ فَأَوۡلَىٰ",
    translation: "Woe to you, and woe",
    normalizedText: "اولى لك فاولى",
  },
  {
    verseId: 34,
    name: "القيامة",
    surahId: 75,
    text: "ثُمَّ أَوۡلَىٰ لَكَ فَأَوۡلَىٰٓ",
    translation: "Then woe to you, and woe",
    normalizedText: "ثم اولى لك فاولى",
  },
  {
    verseId: 35,
    name: "القيامة",
    surahId: 75,
    text: "أَيَحۡسَبُ ٱلۡإِنسَٰنُ أَن يُتۡرَكَ سُدًى",
    translation: "Does man think that he will be left neglected",
    normalizedText: "ايحسب الانسن ان يترك سدى",
  },
  {
    verseId: 36,
    name: "القيامة",
    surahId: 75,
    text: "أَلَمۡ يَكُ نُطۡفَةٗ مِّن مَّنِيّٖ يُمۡنَىٰ",
    translation: "Had he not been a sperm from semen emitted",
    normalizedText: "الم يك نطفة من مني يمنى",
  },
  {
    verseId: 37,
    name: "القيامة",
    surahId: 75,
    text: "ثُمَّ كَانَ عَلَقَةٗ فَخَلَقَ فَسَوَّىٰ",
    translation:
      "Then he was a clinging clot, and [Allah] created [his form] and proportioned [him]",
    normalizedText: "ثم كان علقة فخلق فسوى",
  },
  {
    verseId: 38,
    name: "القيامة",
    surahId: 75,
    text: "فَجَعَلَ مِنۡهُ ٱلزَّوۡجَيۡنِ ٱلذَّكَرَ وَٱلۡأُنثَىٰٓ",
    translation: "And made of him two mates, the male and the female",
    normalizedText: "فجعل منه الزوجين الذكر والانثى",
  },
  {
    verseId: 39,
    name: "القيامة",
    surahId: 75,
    text: "أَلَيۡسَ ذَٰلِكَ بِقَٰدِرٍ عَلَىٰٓ أَن يُحۡـِۧيَ ٱلۡمَوۡتَىٰ",
    translation: "Is not that [Creator] Able to give life to the dead",
    normalizedText: "اليس ذلك بقدر على ان يحي الموتى",
  },
  {
    verseId: 0,
    name: "الانسان",
    surahId: 76,
    text: "هَلۡ أَتَىٰ عَلَى ٱلۡإِنسَٰنِ حِينٞ مِّنَ ٱلدَّهۡرِ لَمۡ يَكُن شَيۡـٔٗا مَّذۡكُورًا",
    translation:
      "Has there [not] come upon man a period of time when he was not a thing [even] mentioned",
    normalizedText: "هل اتى على الانسن حين من الدهر لم يكن شيا مذكورا",
  },
  {
    verseId: 1,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّا خَلَقۡنَا ٱلۡإِنسَٰنَ مِن نُّطۡفَةٍ أَمۡشَاجٖ نَّبۡتَلِيهِ فَجَعَلۡنَٰهُ سَمِيعَۢا بَصِيرًا",
    translation:
      "Indeed, We created man from a sperm-drop mixture that We may try him; and We made him hearing and seeing",
    normalizedText: "انا خلقنا الانسن من نطفة امشاج نبتليه فجعلنه سميعا بصيرا",
  },
  {
    verseId: 2,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّا هَدَيۡنَٰهُ ٱلسَّبِيلَ إِمَّا شَاكِرٗا وَإِمَّا كَفُورًا",
    translation:
      "Indeed, We guided him to the way, be he grateful or be he ungrateful",
    normalizedText: "انا هدينه السبيل اما شاكرا واما كفورا",
  },
  {
    verseId: 3,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّآ أَعۡتَدۡنَا لِلۡكَٰفِرِينَ سَلَٰسِلَاْ وَأَغۡلَٰلٗا وَسَعِيرًا",
    translation:
      "Indeed, We have prepared for the disbelievers chains and shackles and a blaze",
    normalizedText: "انا اعتدنا للكفرين سلسلا واغللا وسعيرا",
  },
  {
    verseId: 4,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّ ٱلۡأَبۡرَارَ يَشۡرَبُونَ مِن كَأۡسٖ كَانَ مِزَاجُهَا كَافُورًا",
    translation:
      "Indeed, the righteous will drink from a cup [of wine] whose mixture is of Kafur",
    normalizedText: "ان الابرار يشربون من كاس كان مزاجها كافورا",
  },
  {
    verseId: 5,
    name: "الانسان",
    surahId: 76,
    text: "عَيۡنٗا يَشۡرَبُ بِهَا عِبَادُ ٱللَّهِ يُفَجِّرُونَهَا تَفۡجِيرٗا",
    translation:
      "A spring of which the [righteous] servants of Allah will drink; they will make it gush forth in force [and abundance]",
    normalizedText: "عينا يشرب بها عباد الله يفجرونها تفجيرا",
  },
  {
    verseId: 6,
    name: "الانسان",
    surahId: 76,
    text: "يُوفُونَ بِٱلنَّذۡرِ وَيَخَافُونَ يَوۡمٗا كَانَ شَرُّهُۥ مُسۡتَطِيرٗا",
    translation:
      "They [are those who] fulfill [their] vows and fear a Day whose evil will be widespread",
    normalizedText: "يوفون بالنذر ويخافون يوما كان شره مستطيرا",
  },
  {
    verseId: 7,
    name: "الانسان",
    surahId: 76,
    text: "وَيُطۡعِمُونَ ٱلطَّعَامَ عَلَىٰ حُبِّهِۦ مِسۡكِينٗا وَيَتِيمٗا وَأَسِيرًا",
    translation:
      "And they give food in spite of love for it to the needy, the orphan, and the captive",
    normalizedText: "ويطعمون الطعام على حبه مسكينا ويتيما واسيرا",
  },
  {
    verseId: 8,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّمَا نُطۡعِمُكُمۡ لِوَجۡهِ ٱللَّهِ لَا نُرِيدُ مِنكُمۡ جَزَآءٗ وَلَا شُكُورًا",
    translation:
      '[Saying], "We feed you only for the countenance of Allah. We wish not from you reward or gratitude',
    normalizedText: "انما نطعمكم لوجه الله لا نريد منكم جزاء ولا شكورا",
  },
  {
    verseId: 9,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّا نَخَافُ مِن رَّبِّنَا يَوۡمًا عَبُوسٗا قَمۡطَرِيرٗا",
    translation: "Indeed, We fear from our Lord a Day austere and distressful",
    normalizedText: "انا نخاف من ربنا يوما عبوسا قمطريرا",
  },
  {
    verseId: 10,
    name: "الانسان",
    surahId: 76,
    text: "فَوَقَىٰهُمُ ٱللَّهُ شَرَّ ذَٰلِكَ ٱلۡيَوۡمِ وَلَقَّىٰهُمۡ نَضۡرَةٗ وَسُرُورٗا",
    translation:
      "So Allah will protect them from the evil of that Day and give them radiance and happiness",
    normalizedText: "فوقىهم الله شر ذلك اليوم ولقىهم نضرة وسرورا",
  },
  {
    verseId: 11,
    name: "الانسان",
    surahId: 76,
    text: "وَجَزَىٰهُم بِمَا صَبَرُواْ جَنَّةٗ وَحَرِيرٗا",
    translation:
      "And will reward them for what they patiently endured [with] a garden [in Paradise] and silk [garments]",
    normalizedText: "وجزىهم بما صبروا جنة وحريرا",
  },
  {
    verseId: 12,
    name: "الانسان",
    surahId: 76,
    text: "مُّتَّكِـِٔينَ فِيهَا عَلَى ٱلۡأَرَآئِكِۖ لَا يَرَوۡنَ فِيهَا شَمۡسٗا وَلَا زَمۡهَرِيرٗا",
    translation:
      "[They will be] reclining therein on adorned couches. They will not see therein any [burning] sun or [freezing] cold",
    normalizedText: "متكين فيها على الارااك لا يرون فيها شمسا ولا زمهريرا",
  },
  {
    verseId: 13,
    name: "الانسان",
    surahId: 76,
    text: "وَدَانِيَةً عَلَيۡهِمۡ ظِلَٰلُهَا وَذُلِّلَتۡ قُطُوفُهَا تَذۡلِيلٗا",
    translation:
      "And near above them are its shades, and its [fruit] to be picked will be lowered in compliance",
    normalizedText: "ودانية عليهم ظللها وذللت قطوفها تذليلا",
  },
  {
    verseId: 14,
    name: "الانسان",
    surahId: 76,
    text: "وَيُطَافُ عَلَيۡهِم بِـَٔانِيَةٖ مِّن فِضَّةٖ وَأَكۡوَابٖ كَانَتۡ قَوَارِيرَا۠",
    translation:
      "And there will be circulated among them vessels of silver and cups having been [created] clear [as glass]",
    normalizedText: "ويطاف عليهم بانية من فضة واكواب كانت قواريرا",
  },
  {
    verseId: 15,
    name: "الانسان",
    surahId: 76,
    text: "قَوَارِيرَاْ مِن فِضَّةٖ قَدَّرُوهَا تَقۡدِيرٗا",
    translation:
      "Clear glasses [made] from silver of which they have determined the measure",
    normalizedText: "قواريرا من فضة قدروها تقديرا",
  },
  {
    verseId: 16,
    name: "الانسان",
    surahId: 76,
    text: "وَيُسۡقَوۡنَ فِيهَا كَأۡسٗا كَانَ مِزَاجُهَا زَنجَبِيلًا",
    translation:
      "And they will be given to drink a cup [of wine] whose mixture is of ginger",
    normalizedText: "ويسقون فيها كاسا كان مزاجها زنجبيلا",
  },
  {
    verseId: 17,
    name: "الانسان",
    surahId: 76,
    text: "عَيۡنٗا فِيهَا تُسَمَّىٰ سَلۡسَبِيلٗا",
    translation: "[From] a fountain within Paradise named Salsabeel",
    normalizedText: "عينا فيها تسمى سلسبيلا",
  },
  {
    verseId: 18,
    name: "الانسان",
    surahId: 76,
    text: "۞وَيَطُوفُ عَلَيۡهِمۡ وِلۡدَٰنٞ مُّخَلَّدُونَ إِذَا رَأَيۡتَهُمۡ حَسِبۡتَهُمۡ لُؤۡلُؤٗا مَّنثُورٗا",
    translation:
      "There will circulate among them young boys made eternal. When you see them, you would think them [as beautiful as] scattered pearls",
    normalizedText: "۞ويطوف عليهم ولدن مخلدون اذا رايتهم حسبتهم لالاا منثورا",
  },
  {
    verseId: 19,
    name: "الانسان",
    surahId: 76,
    text: "وَإِذَا رَأَيۡتَ ثَمَّ رَأَيۡتَ نَعِيمٗا وَمُلۡكٗا كَبِيرًا",
    translation:
      "And when you look there [in Paradise], you will see pleasure and great dominion",
    normalizedText: "واذا رايت ثم رايت نعيما وملكا كبيرا",
  },
  {
    verseId: 20,
    name: "الانسان",
    surahId: 76,
    text: "عَٰلِيَهُمۡ ثِيَابُ سُندُسٍ خُضۡرٞ وَإِسۡتَبۡرَقٞۖ وَحُلُّوٓاْ أَسَاوِرَ مِن فِضَّةٖ وَسَقَىٰهُمۡ رَبُّهُمۡ شَرَابٗا طَهُورًا",
    translation:
      "Upon the inhabitants will be green garments of fine silk and brocade. And they will be adorned with bracelets of silver, and their Lord will give them a purifying drink",
    normalizedText:
      "عليهم ثياب سندس خضر واستبرق وحلوا اساور من فضة وسقىهم ربهم شرابا طهورا",
  },
  {
    verseId: 21,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّ هَٰذَا كَانَ لَكُمۡ جَزَآءٗ وَكَانَ سَعۡيُكُم مَّشۡكُورًا",
    translation:
      '[And it will be said], "Indeed, this is for you a reward, and your effort has been appreciated',
    normalizedText: "ان هذا كان لكم جزاء وكان سعيكم مشكورا",
  },
  {
    verseId: 22,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّا نَحۡنُ نَزَّلۡنَا عَلَيۡكَ ٱلۡقُرۡءَانَ تَنزِيلٗا",
    translation:
      "Indeed, it is We who have sent down to you, [O Muhammad], the Qur'an progressively",
    normalizedText: "انا نحن نزلنا عليك القرءان تنزيلا",
  },
  {
    verseId: 23,
    name: "الانسان",
    surahId: 76,
    text: "فَٱصۡبِرۡ لِحُكۡمِ رَبِّكَ وَلَا تُطِعۡ مِنۡهُمۡ ءَاثِمًا أَوۡ كَفُورٗا",
    translation:
      "So be patient for the decision of your Lord and do not obey from among them a sinner or ungrateful [disbeliever]",
    normalizedText: "فاصبر لحكم ربك ولا تطع منهم ءاثما او كفورا",
  },
  {
    verseId: 24,
    name: "الانسان",
    surahId: 76,
    text: "وَٱذۡكُرِ ٱسۡمَ رَبِّكَ بُكۡرَةٗ وَأَصِيلٗا",
    translation:
      "And mention the name of your Lord [in prayer] morning and evening",
    normalizedText: "واذكر اسم ربك بكرة واصيلا",
  },
  {
    verseId: 25,
    name: "الانسان",
    surahId: 76,
    text: "وَمِنَ ٱلَّيۡلِ فَٱسۡجُدۡ لَهُۥ وَسَبِّحۡهُ لَيۡلٗا طَوِيلًا",
    translation:
      "And during the night prostrate to Him and exalt Him a long [part of the] night",
    normalizedText: "ومن اليل فاسجد له وسبحه ليلا طويلا",
  },
  {
    verseId: 26,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّ هَـٰٓؤُلَآءِ يُحِبُّونَ ٱلۡعَاجِلَةَ وَيَذَرُونَ وَرَآءَهُمۡ يَوۡمٗا ثَقِيلٗا",
    translation:
      "Indeed, these [disbelievers] love the immediate and leave behind them a grave Day",
    normalizedText: "ان هالاء يحبون العاجلة ويذرون وراءهم يوما ثقيلا",
  },
  {
    verseId: 27,
    name: "الانسان",
    surahId: 76,
    text: "نَّحۡنُ خَلَقۡنَٰهُمۡ وَشَدَدۡنَآ أَسۡرَهُمۡۖ وَإِذَا شِئۡنَا بَدَّلۡنَآ أَمۡثَٰلَهُمۡ تَبۡدِيلًا",
    translation:
      "We have created them and strengthened their forms, and when We will, We can change their likenesses with [complete] alteration",
    normalizedText: "نحن خلقنهم وشددنا اسرهم واذا شانا بدلنا امثلهم تبديلا",
  },
  {
    verseId: 28,
    name: "الانسان",
    surahId: 76,
    text: "إِنَّ هَٰذِهِۦ تَذۡكِرَةٞۖ فَمَن شَآءَ ٱتَّخَذَ إِلَىٰ رَبِّهِۦ سَبِيلٗا",
    translation:
      "Indeed, this is a reminder, so he who wills may take to his Lord a way",
    normalizedText: "ان هذه تذكرة فمن شاء اتخذ الى ربه سبيلا",
  },
  {
    verseId: 29,
    name: "الانسان",
    surahId: 76,
    text: "وَمَا تَشَآءُونَ إِلَّآ أَن يَشَآءَ ٱللَّهُۚ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمٗا",
    translation:
      "And you do not will except that Allah wills. Indeed, Allah is ever Knowing and Wise",
    normalizedText: "وما تشاءون الا ان يشاء الله ان الله كان عليما حكيما",
  },
  {
    verseId: 30,
    name: "الانسان",
    surahId: 76,
    text: "يُدۡخِلُ مَن يَشَآءُ فِي رَحۡمَتِهِۦۚ وَٱلظَّـٰلِمِينَ أَعَدَّ لَهُمۡ عَذَابًا أَلِيمَۢا",
    translation:
      "He admits whom He wills into His mercy; but the wrongdoers - He has prepared for them a painful punishment",
    normalizedText: "يدخل من يشاء في رحمته والظلمين اعد لهم عذابا اليما",
  },
  {
    verseId: 0,
    name: "المرسلات",
    surahId: 77,
    text: "وَٱلۡمُرۡسَلَٰتِ عُرۡفٗا",
    translation: "By those [winds] sent forth in gusts",
    normalizedText: "والمرسلت عرفا",
  },
  {
    verseId: 1,
    name: "المرسلات",
    surahId: 77,
    text: "فَٱلۡعَٰصِفَٰتِ عَصۡفٗا",
    translation: "And the winds that blow violently",
    normalizedText: "فالعصفت عصفا",
  },
  {
    verseId: 2,
    name: "المرسلات",
    surahId: 77,
    text: "وَٱلنَّـٰشِرَٰتِ نَشۡرٗا",
    translation: "And [by] the winds that spread [clouds]",
    normalizedText: "والنشرت نشرا",
  },
  {
    verseId: 3,
    name: "المرسلات",
    surahId: 77,
    text: "فَٱلۡفَٰرِقَٰتِ فَرۡقٗا",
    translation: "And those [angels] who bring criterion",
    normalizedText: "فالفرقت فرقا",
  },
  {
    verseId: 4,
    name: "المرسلات",
    surahId: 77,
    text: "فَٱلۡمُلۡقِيَٰتِ ذِكۡرًا",
    translation: "And those [angels] who deliver a message",
    normalizedText: "فالملقيت ذكرا",
  },
  {
    verseId: 5,
    name: "المرسلات",
    surahId: 77,
    text: "عُذۡرًا أَوۡ نُذۡرًا",
    translation: "As justification or warning",
    normalizedText: "عذرا او نذرا",
  },
  {
    verseId: 6,
    name: "المرسلات",
    surahId: 77,
    text: "إِنَّمَا تُوعَدُونَ لَوَٰقِعٞ",
    translation: "Indeed, what you are promised is to occur",
    normalizedText: "انما توعدون لوقع",
  },
  {
    verseId: 7,
    name: "المرسلات",
    surahId: 77,
    text: "فَإِذَا ٱلنُّجُومُ طُمِسَتۡ",
    translation: "So when the stars are obliterated",
    normalizedText: "فاذا النجوم طمست",
  },
  {
    verseId: 8,
    name: "المرسلات",
    surahId: 77,
    text: "وَإِذَا ٱلسَّمَآءُ فُرِجَتۡ",
    translation: "And when the heaven is opened",
    normalizedText: "واذا السماء فرجت",
  },
  {
    verseId: 9,
    name: "المرسلات",
    surahId: 77,
    text: "وَإِذَا ٱلۡجِبَالُ نُسِفَتۡ",
    translation: "And when the mountains are blown away",
    normalizedText: "واذا الجبال نسفت",
  },
  {
    verseId: 10,
    name: "المرسلات",
    surahId: 77,
    text: "وَإِذَا ٱلرُّسُلُ أُقِّتَتۡ",
    translation: "And when the messengers' time has come",
    normalizedText: "واذا الرسل اقتت",
  },
  {
    verseId: 11,
    name: "المرسلات",
    surahId: 77,
    text: "لِأَيِّ يَوۡمٍ أُجِّلَتۡ",
    translation: "For what Day was it postponed",
    normalizedText: "لاي يوم اجلت",
  },
  {
    verseId: 12,
    name: "المرسلات",
    surahId: 77,
    text: "لِيَوۡمِ ٱلۡفَصۡلِ",
    translation: "For the Day of Judgement",
    normalizedText: "ليوم الفصل",
  },
  {
    verseId: 13,
    name: "المرسلات",
    surahId: 77,
    text: "وَمَآ أَدۡرَىٰكَ مَا يَوۡمُ ٱلۡفَصۡلِ",
    translation: "And what can make you know what is the Day of Judgement",
    normalizedText: "وما ادرىك ما يوم الفصل",
  },
  {
    verseId: 14,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 15,
    name: "المرسلات",
    surahId: 77,
    text: "أَلَمۡ نُهۡلِكِ ٱلۡأَوَّلِينَ",
    translation: "Did We not destroy the former peoples",
    normalizedText: "الم نهلك الاولين",
  },
  {
    verseId: 16,
    name: "المرسلات",
    surahId: 77,
    text: "ثُمَّ نُتۡبِعُهُمُ ٱلۡأٓخِرِينَ",
    translation: "Then We will follow them with the later ones",
    normalizedText: "ثم نتبعهم الاخرين",
  },
  {
    verseId: 17,
    name: "المرسلات",
    surahId: 77,
    text: "كَذَٰلِكَ نَفۡعَلُ بِٱلۡمُجۡرِمِينَ",
    translation: "Thus do We deal with the criminals",
    normalizedText: "كذلك نفعل بالمجرمين",
  },
  {
    verseId: 18,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 19,
    name: "المرسلات",
    surahId: 77,
    text: "أَلَمۡ نَخۡلُقكُّم مِّن مَّآءٖ مَّهِينٖ",
    translation: "Did We not create you from a liquid disdained",
    normalizedText: "الم نخلقكم من ماء مهين",
  },
  {
    verseId: 20,
    name: "المرسلات",
    surahId: 77,
    text: "فَجَعَلۡنَٰهُ فِي قَرَارٖ مَّكِينٍ",
    translation: "And We placed it in a firm lodging",
    normalizedText: "فجعلنه في قرار مكين",
  },
  {
    verseId: 21,
    name: "المرسلات",
    surahId: 77,
    text: "إِلَىٰ قَدَرٖ مَّعۡلُومٖ",
    translation: "For a known extent",
    normalizedText: "الى قدر معلوم",
  },
  {
    verseId: 22,
    name: "المرسلات",
    surahId: 77,
    text: "فَقَدَرۡنَا فَنِعۡمَ ٱلۡقَٰدِرُونَ",
    translation: "And We determined [it], and excellent [are We] to determine",
    normalizedText: "فقدرنا فنعم القدرون",
  },
  {
    verseId: 23,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 24,
    name: "المرسلات",
    surahId: 77,
    text: "أَلَمۡ نَجۡعَلِ ٱلۡأَرۡضَ كِفَاتًا",
    translation: "Have We not made the earth a container",
    normalizedText: "الم نجعل الارض كفاتا",
  },
  {
    verseId: 25,
    name: "المرسلات",
    surahId: 77,
    text: "أَحۡيَآءٗ وَأَمۡوَٰتٗا",
    translation: "Of the living and the dead",
    normalizedText: "احياء واموتا",
  },
  {
    verseId: 26,
    name: "المرسلات",
    surahId: 77,
    text: "وَجَعَلۡنَا فِيهَا رَوَٰسِيَ شَٰمِخَٰتٖ وَأَسۡقَيۡنَٰكُم مَّآءٗ فُرَاتٗا",
    translation:
      "And We placed therein lofty, firmly set mountains and have given you to drink sweet water",
    normalizedText: "وجعلنا فيها روسي شمخت واسقينكم ماء فراتا",
  },
  {
    verseId: 27,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 28,
    name: "المرسلات",
    surahId: 77,
    text: "ٱنطَلِقُوٓاْ إِلَىٰ مَا كُنتُم بِهِۦ تُكَذِّبُونَ",
    translation: '[They will be told], "Proceed to that which you used to deny',
    normalizedText: "انطلقوا الى ما كنتم به تكذبون",
  },
  {
    verseId: 29,
    name: "المرسلات",
    surahId: 77,
    text: "ٱنطَلِقُوٓاْ إِلَىٰ ظِلّٖ ذِي ثَلَٰثِ شُعَبٖ",
    translation: "Proceed to a shadow [of smoke] having three columns",
    normalizedText: "انطلقوا الى ظل ذي ثلث شعب",
  },
  {
    verseId: 30,
    name: "المرسلات",
    surahId: 77,
    text: "لَّا ظَلِيلٖ وَلَا يُغۡنِي مِنَ ٱللَّهَبِ",
    translation:
      "[But having] no cool shade and availing not against the flame",
    normalizedText: "لا ظليل ولا يغني من اللهب",
  },
  {
    verseId: 31,
    name: "المرسلات",
    surahId: 77,
    text: "إِنَّهَا تَرۡمِي بِشَرَرٖ كَٱلۡقَصۡرِ",
    translation: "Indeed, it throws sparks [as huge] as a fortress",
    normalizedText: "انها ترمي بشرر كالقصر",
  },
  {
    verseId: 32,
    name: "المرسلات",
    surahId: 77,
    text: "كَأَنَّهُۥ جِمَٰلَتٞ صُفۡرٞ",
    translation: "As if they were yellowish [black] camels",
    normalizedText: "كانه جملت صفر",
  },
  {
    verseId: 33,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 34,
    name: "المرسلات",
    surahId: 77,
    text: "هَٰذَا يَوۡمُ لَا يَنطِقُونَ",
    translation: "This is a Day they will not speak",
    normalizedText: "هذا يوم لا ينطقون",
  },
  {
    verseId: 35,
    name: "المرسلات",
    surahId: 77,
    text: "وَلَا يُؤۡذَنُ لَهُمۡ فَيَعۡتَذِرُونَ",
    translation: "Nor will it be permitted for them to make an excuse",
    normalizedText: "ولا ياذن لهم فيعتذرون",
  },
  {
    verseId: 36,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 37,
    name: "المرسلات",
    surahId: 77,
    text: "هَٰذَا يَوۡمُ ٱلۡفَصۡلِۖ جَمَعۡنَٰكُمۡ وَٱلۡأَوَّلِينَ",
    translation:
      "This is the Day of Judgement; We will have assembled you and the former peoples",
    normalizedText: "هذا يوم الفصل جمعنكم والاولين",
  },
  {
    verseId: 38,
    name: "المرسلات",
    surahId: 77,
    text: "فَإِن كَانَ لَكُمۡ كَيۡدٞ فَكِيدُونِ",
    translation: "So if you have a plan, then plan against Me",
    normalizedText: "فان كان لكم كيد فكيدون",
  },
  {
    verseId: 39,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 40,
    name: "المرسلات",
    surahId: 77,
    text: "إِنَّ ٱلۡمُتَّقِينَ فِي ظِلَٰلٖ وَعُيُونٖ",
    translation: "Indeed, the righteous will be among shades and springs",
    normalizedText: "ان المتقين في ظلل وعيون",
  },
  {
    verseId: 41,
    name: "المرسلات",
    surahId: 77,
    text: "وَفَوَٰكِهَ مِمَّا يَشۡتَهُونَ",
    translation: "And fruits from whatever they desire",
    normalizedText: "وفوكه مما يشتهون",
  },
  {
    verseId: 42,
    name: "المرسلات",
    surahId: 77,
    text: "كُلُواْ وَٱشۡرَبُواْ هَنِيٓـَٔۢا بِمَا كُنتُمۡ تَعۡمَلُونَ",
    translation:
      '[Being told], "Eat and drink in satisfaction for what you used to do',
    normalizedText: "كلوا واشربوا هنيا بما كنتم تعملون",
  },
  {
    verseId: 43,
    name: "المرسلات",
    surahId: 77,
    text: "إِنَّا كَذَٰلِكَ نَجۡزِي ٱلۡمُحۡسِنِينَ",
    translation: "Indeed, We thus reward the doers of good",
    normalizedText: "انا كذلك نجزي المحسنين",
  },
  {
    verseId: 44,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 45,
    name: "المرسلات",
    surahId: 77,
    text: "كُلُواْ وَتَمَتَّعُواْ قَلِيلًا إِنَّكُم مُّجۡرِمُونَ",
    translation:
      "[O disbelievers], eat and enjoy yourselves a little; indeed, you are criminals",
    normalizedText: "كلوا وتمتعوا قليلا انكم مجرمون",
  },
  {
    verseId: 46,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 47,
    name: "المرسلات",
    surahId: 77,
    text: "وَإِذَا قِيلَ لَهُمُ ٱرۡكَعُواْ لَا يَرۡكَعُونَ",
    translation:
      'And when it is said to them, "Bow [in prayer]," they do not bow',
    normalizedText: "واذا قيل لهم اركعوا لا يركعون",
  },
  {
    verseId: 48,
    name: "المرسلات",
    surahId: 77,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 49,
    name: "المرسلات",
    surahId: 77,
    text: "فَبِأَيِّ حَدِيثِۭ بَعۡدَهُۥ يُؤۡمِنُونَ",
    translation: "Then in what statement after the Qur'an will they believe",
    normalizedText: "فباي حديث بعده يامنون",
  },
  {
    verseId: 0,
    name: "النبإ",
    surahId: 78,
    text: "عَمَّ يَتَسَآءَلُونَ",
    translation: "About what are they asking one another",
    normalizedText: "عم يتساءلون",
  },
  {
    verseId: 1,
    name: "النبإ",
    surahId: 78,
    text: "عَنِ ٱلنَّبَإِ ٱلۡعَظِيمِ",
    translation: "About the great news",
    normalizedText: "عن النبا العظيم",
  },
  {
    verseId: 2,
    name: "النبإ",
    surahId: 78,
    text: "ٱلَّذِي هُمۡ فِيهِ مُخۡتَلِفُونَ",
    translation: "That over which they are in disagreement",
    normalizedText: "الذي هم فيه مختلفون",
  },
  {
    verseId: 3,
    name: "النبإ",
    surahId: 78,
    text: "كَلَّا سَيَعۡلَمُونَ",
    translation: "No! They are going to know",
    normalizedText: "كلا سيعلمون",
  },
  {
    verseId: 4,
    name: "النبإ",
    surahId: 78,
    text: "ثُمَّ كَلَّا سَيَعۡلَمُونَ",
    translation: "Then, no! They are going to know",
    normalizedText: "ثم كلا سيعلمون",
  },
  {
    verseId: 5,
    name: "النبإ",
    surahId: 78,
    text: "أَلَمۡ نَجۡعَلِ ٱلۡأَرۡضَ مِهَٰدٗا",
    translation: "Have We not made the earth a resting place",
    normalizedText: "الم نجعل الارض مهدا",
  },
  {
    verseId: 6,
    name: "النبإ",
    surahId: 78,
    text: "وَٱلۡجِبَالَ أَوۡتَادٗا",
    translation: "And the mountains as stakes",
    normalizedText: "والجبال اوتادا",
  },
  {
    verseId: 7,
    name: "النبإ",
    surahId: 78,
    text: "وَخَلَقۡنَٰكُمۡ أَزۡوَٰجٗا",
    translation: "And We created you in pairs",
    normalizedText: "وخلقنكم ازوجا",
  },
  {
    verseId: 8,
    name: "النبإ",
    surahId: 78,
    text: "وَجَعَلۡنَا نَوۡمَكُمۡ سُبَاتٗا",
    translation: "And made your sleep [a means for] rest",
    normalizedText: "وجعلنا نومكم سباتا",
  },
  {
    verseId: 9,
    name: "النبإ",
    surahId: 78,
    text: "وَجَعَلۡنَا ٱلَّيۡلَ لِبَاسٗا",
    translation: "And made the night as clothing",
    normalizedText: "وجعلنا اليل لباسا",
  },
  {
    verseId: 10,
    name: "النبإ",
    surahId: 78,
    text: "وَجَعَلۡنَا ٱلنَّهَارَ مَعَاشٗا",
    translation: "And made the day for livelihood",
    normalizedText: "وجعلنا النهار معاشا",
  },
  {
    verseId: 11,
    name: "النبإ",
    surahId: 78,
    text: "وَبَنَيۡنَا فَوۡقَكُمۡ سَبۡعٗا شِدَادٗا",
    translation: "And constructed above you seven strong [heavens]",
    normalizedText: "وبنينا فوقكم سبعا شدادا",
  },
  {
    verseId: 12,
    name: "النبإ",
    surahId: 78,
    text: "وَجَعَلۡنَا سِرَاجٗا وَهَّاجٗا",
    translation: "And made [therein] a burning lamp",
    normalizedText: "وجعلنا سراجا وهاجا",
  },
  {
    verseId: 13,
    name: "النبإ",
    surahId: 78,
    text: "وَأَنزَلۡنَا مِنَ ٱلۡمُعۡصِرَٰتِ مَآءٗ ثَجَّاجٗا",
    translation: "And sent down, from the rain clouds, pouring water",
    normalizedText: "وانزلنا من المعصرت ماء ثجاجا",
  },
  {
    verseId: 14,
    name: "النبإ",
    surahId: 78,
    text: "لِّنُخۡرِجَ بِهِۦ حَبّٗا وَنَبَاتٗا",
    translation: "That We may bring forth thereby grain and vegetation",
    normalizedText: "لنخرج به حبا ونباتا",
  },
  {
    verseId: 15,
    name: "النبإ",
    surahId: 78,
    text: "وَجَنَّـٰتٍ أَلۡفَافًا",
    translation: "And gardens of entwined growth",
    normalizedText: "وجنت الفافا",
  },
  {
    verseId: 16,
    name: "النبإ",
    surahId: 78,
    text: "إِنَّ يَوۡمَ ٱلۡفَصۡلِ كَانَ مِيقَٰتٗا",
    translation: "Indeed, the Day of Judgement is an appointed time",
    normalizedText: "ان يوم الفصل كان ميقتا",
  },
  {
    verseId: 17,
    name: "النبإ",
    surahId: 78,
    text: "يَوۡمَ يُنفَخُ فِي ٱلصُّورِ فَتَأۡتُونَ أَفۡوَاجٗا",
    translation:
      "The Day the Horn is blown and you will come forth in multitudes",
    normalizedText: "يوم ينفخ في الصور فتاتون افواجا",
  },
  {
    verseId: 18,
    name: "النبإ",
    surahId: 78,
    text: "وَفُتِحَتِ ٱلسَّمَآءُ فَكَانَتۡ أَبۡوَٰبٗا",
    translation: "And the heaven is opened and will become gateways",
    normalizedText: "وفتحت السماء فكانت ابوبا",
  },
  {
    verseId: 19,
    name: "النبإ",
    surahId: 78,
    text: "وَسُيِّرَتِ ٱلۡجِبَالُ فَكَانَتۡ سَرَابًا",
    translation: "And the mountains are removed and will be [but] a mirage",
    normalizedText: "وسيرت الجبال فكانت سرابا",
  },
  {
    verseId: 20,
    name: "النبإ",
    surahId: 78,
    text: "إِنَّ جَهَنَّمَ كَانَتۡ مِرۡصَادٗا",
    translation: "Indeed, Hell has been lying in wait",
    normalizedText: "ان جهنم كانت مرصادا",
  },
  {
    verseId: 21,
    name: "النبإ",
    surahId: 78,
    text: "لِّلطَّـٰغِينَ مَـَٔابٗا",
    translation: "For the transgressors, a place of return",
    normalizedText: "للطغين مابا",
  },
  {
    verseId: 22,
    name: "النبإ",
    surahId: 78,
    text: "لَّـٰبِثِينَ فِيهَآ أَحۡقَابٗا",
    translation: "In which they will remain for ages [unending]",
    normalizedText: "لبثين فيها احقابا",
  },
  {
    verseId: 23,
    name: "النبإ",
    surahId: 78,
    text: "لَّا يَذُوقُونَ فِيهَا بَرۡدٗا وَلَا شَرَابًا",
    translation: "They will not taste therein [any] coolness or drink",
    normalizedText: "لا يذوقون فيها بردا ولا شرابا",
  },
  {
    verseId: 24,
    name: "النبإ",
    surahId: 78,
    text: "إِلَّا حَمِيمٗا وَغَسَّاقٗا",
    translation: "Except scalding water and [foul] purulence",
    normalizedText: "الا حميما وغساقا",
  },
  {
    verseId: 25,
    name: "النبإ",
    surahId: 78,
    text: "جَزَآءٗ وِفَاقًا",
    translation: "An appropriate recompense",
    normalizedText: "جزاء وفاقا",
  },
  {
    verseId: 26,
    name: "النبإ",
    surahId: 78,
    text: "إِنَّهُمۡ كَانُواْ لَا يَرۡجُونَ حِسَابٗا",
    translation: "Indeed, they were not expecting an account",
    normalizedText: "انهم كانوا لا يرجون حسابا",
  },
  {
    verseId: 27,
    name: "النبإ",
    surahId: 78,
    text: "وَكَذَّبُواْ بِـَٔايَٰتِنَا كِذَّابٗا",
    translation: "And denied Our verses with [emphatic] denial",
    normalizedText: "وكذبوا بايتنا كذابا",
  },
  {
    verseId: 28,
    name: "النبإ",
    surahId: 78,
    text: "وَكُلَّ شَيۡءٍ أَحۡصَيۡنَٰهُ كِتَٰبٗا",
    translation: "But all things We have enumerated in writing",
    normalizedText: "وكل شيء احصينه كتبا",
  },
  {
    verseId: 29,
    name: "النبإ",
    surahId: 78,
    text: "فَذُوقُواْ فَلَن نَّزِيدَكُمۡ إِلَّا عَذَابًا",
    translation:
      "So taste [the penalty], and never will We increase you except in torment",
    normalizedText: "فذوقوا فلن نزيدكم الا عذابا",
  },
  {
    verseId: 30,
    name: "النبإ",
    surahId: 78,
    text: "إِنَّ لِلۡمُتَّقِينَ مَفَازًا",
    translation: "Indeed, for the righteous is attainment",
    normalizedText: "ان للمتقين مفازا",
  },
  {
    verseId: 31,
    name: "النبإ",
    surahId: 78,
    text: "حَدَآئِقَ وَأَعۡنَٰبٗا",
    translation: "Gardens and grapevines",
    normalizedText: "حدااق واعنبا",
  },
  {
    verseId: 32,
    name: "النبإ",
    surahId: 78,
    text: "وَكَوَاعِبَ أَتۡرَابٗا",
    translation: "And full-breasted [companions] of equal age",
    normalizedText: "وكواعب اترابا",
  },
  {
    verseId: 33,
    name: "النبإ",
    surahId: 78,
    text: "وَكَأۡسٗا دِهَاقٗا",
    translation: "And a full cup",
    normalizedText: "وكاسا دهاقا",
  },
  {
    verseId: 34,
    name: "النبإ",
    surahId: 78,
    text: "لَّا يَسۡمَعُونَ فِيهَا لَغۡوٗا وَلَا كِذَّـٰبٗا",
    translation: "No ill speech will they hear therein or any falsehood",
    normalizedText: "لا يسمعون فيها لغوا ولا كذبا",
  },
  {
    verseId: 35,
    name: "النبإ",
    surahId: 78,
    text: "جَزَآءٗ مِّن رَّبِّكَ عَطَآءً حِسَابٗا",
    translation:
      "[As] reward from your Lord, [a generous] gift [made due by] account",
    normalizedText: "جزاء من ربك عطاء حسابا",
  },
  {
    verseId: 36,
    name: "النبإ",
    surahId: 78,
    text: "رَّبِّ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِ وَمَا بَيۡنَهُمَا ٱلرَّحۡمَٰنِۖ لَا يَمۡلِكُونَ مِنۡهُ خِطَابٗا",
    translation:
      "[From] the Lord of the heavens and the earth and whatever is between them, the Most Merciful. They possess not from Him [authority for] speech",
    normalizedText: "رب السموت والارض وما بينهما الرحمن لا يملكون منه خطابا",
  },
  {
    verseId: 37,
    name: "النبإ",
    surahId: 78,
    text: "يَوۡمَ يَقُومُ ٱلرُّوحُ وَٱلۡمَلَـٰٓئِكَةُ صَفّٗاۖ لَّا يَتَكَلَّمُونَ إِلَّا مَنۡ أَذِنَ لَهُ ٱلرَّحۡمَٰنُ وَقَالَ صَوَابٗا",
    translation:
      "The Day that the Spirit and the angels will stand in rows, they will not speak except for one whom the Most Merciful permits, and he will say what is correct",
    normalizedText:
      "يوم يقوم الروح والملاكة صفا لا يتكلمون الا من اذن له الرحمن وقال صوابا",
  },
  {
    verseId: 38,
    name: "النبإ",
    surahId: 78,
    text: "ذَٰلِكَ ٱلۡيَوۡمُ ٱلۡحَقُّۖ فَمَن شَآءَ ٱتَّخَذَ إِلَىٰ رَبِّهِۦ مَـَٔابًا",
    translation:
      "That is the True Day; so he who wills may take to his Lord a [way of] return",
    normalizedText: "ذلك اليوم الحق فمن شاء اتخذ الى ربه مابا",
  },
  {
    verseId: 39,
    name: "النبإ",
    surahId: 78,
    text: "إِنَّآ أَنذَرۡنَٰكُمۡ عَذَابٗا قَرِيبٗا يَوۡمَ يَنظُرُ ٱلۡمَرۡءُ مَا قَدَّمَتۡ يَدَاهُ وَيَقُولُ ٱلۡكَافِرُ يَٰلَيۡتَنِي كُنتُ تُرَٰبَۢا",
    translation:
      'Indeed, We have warned you of a near punishment on the Day when a man will observe what his hands have put forth and the disbeliever will say, "Oh, I wish that I were dust',
    normalizedText:
      "انا انذرنكم عذابا قريبا يوم ينظر المرء ما قدمت يداه ويقول الكافر يليتني كنت تربا",
  },
  {
    verseId: 0,
    name: "النازعات",
    surahId: 79,
    text: "وَٱلنَّـٰزِعَٰتِ غَرۡقٗا",
    translation: "By those [angels] who extract with violence",
    normalizedText: "والنزعت غرقا",
  },
  {
    verseId: 1,
    name: "النازعات",
    surahId: 79,
    text: "وَٱلنَّـٰشِطَٰتِ نَشۡطٗا",
    translation: "And [by] those who remove with ease",
    normalizedText: "والنشطت نشطا",
  },
  {
    verseId: 2,
    name: "النازعات",
    surahId: 79,
    text: "وَٱلسَّـٰبِحَٰتِ سَبۡحٗا",
    translation: "And [by] those who glide [as if] swimming",
    normalizedText: "والسبحت سبحا",
  },
  {
    verseId: 3,
    name: "النازعات",
    surahId: 79,
    text: "فَٱلسَّـٰبِقَٰتِ سَبۡقٗا",
    translation: "And those who race each other in a race",
    normalizedText: "فالسبقت سبقا",
  },
  {
    verseId: 4,
    name: "النازعات",
    surahId: 79,
    text: "فَٱلۡمُدَبِّرَٰتِ أَمۡرٗا",
    translation: "And those who arrange [each] matter",
    normalizedText: "فالمدبرت امرا",
  },
  {
    verseId: 5,
    name: "النازعات",
    surahId: 79,
    text: "يَوۡمَ تَرۡجُفُ ٱلرَّاجِفَةُ",
    translation: "On the Day the blast [of the Horn] will convulse [creation]",
    normalizedText: "يوم ترجف الراجفة",
  },
  {
    verseId: 6,
    name: "النازعات",
    surahId: 79,
    text: "تَتۡبَعُهَا ٱلرَّادِفَةُ",
    translation: "There will follow it the subsequent [one]",
    normalizedText: "تتبعها الرادفة",
  },
  {
    verseId: 7,
    name: "النازعات",
    surahId: 79,
    text: "قُلُوبٞ يَوۡمَئِذٖ وَاجِفَةٌ",
    translation: "Hearts, that Day, will tremble",
    normalizedText: "قلوب يوماذ واجفة",
  },
  {
    verseId: 8,
    name: "النازعات",
    surahId: 79,
    text: "أَبۡصَٰرُهَا خَٰشِعَةٞ",
    translation: "Their eyes humbled",
    normalizedText: "ابصرها خشعة",
  },
  {
    verseId: 9,
    name: "النازعات",
    surahId: 79,
    text: "يَقُولُونَ أَءِنَّا لَمَرۡدُودُونَ فِي ٱلۡحَافِرَةِ",
    translation:
      'They are [presently] saying, "Will we indeed be returned to [our] former state [of life]',
    normalizedText: "يقولون اءنا لمردودون في الحافرة",
  },
  {
    verseId: 10,
    name: "النازعات",
    surahId: 79,
    text: "أَءِذَا كُنَّا عِظَٰمٗا نَّخِرَةٗ",
    translation: "Even if we should be decayed bones",
    normalizedText: "اءذا كنا عظما نخرة",
  },
  {
    verseId: 11,
    name: "النازعات",
    surahId: 79,
    text: "قَالُواْ تِلۡكَ إِذٗا كَرَّةٌ خَاسِرَةٞ",
    translation: 'They say, "That, then, would be a losing return',
    normalizedText: "قالوا تلك اذا كرة خاسرة",
  },
  {
    verseId: 12,
    name: "النازعات",
    surahId: 79,
    text: "فَإِنَّمَا هِيَ زَجۡرَةٞ وَٰحِدَةٞ",
    translation: "Indeed, it will be but one shout",
    normalizedText: "فانما هي زجرة وحدة",
  },
  {
    verseId: 13,
    name: "النازعات",
    surahId: 79,
    text: "فَإِذَا هُم بِٱلسَّاهِرَةِ",
    translation: "And suddenly they will be [alert] upon the earth's surface",
    normalizedText: "فاذا هم بالساهرة",
  },
  {
    verseId: 14,
    name: "النازعات",
    surahId: 79,
    text: "هَلۡ أَتَىٰكَ حَدِيثُ مُوسَىٰٓ",
    translation: "Has there reached you the story of Moses",
    normalizedText: "هل اتىك حديث موسى",
  },
  {
    verseId: 15,
    name: "النازعات",
    surahId: 79,
    text: "إِذۡ نَادَىٰهُ رَبُّهُۥ بِٱلۡوَادِ ٱلۡمُقَدَّسِ طُوًى",
    translation: "When his Lord called to him in the sacred valley of Tuwa",
    normalizedText: "اذ نادىه ربه بالواد المقدس طوى",
  },
  {
    verseId: 16,
    name: "النازعات",
    surahId: 79,
    text: "ٱذۡهَبۡ إِلَىٰ فِرۡعَوۡنَ إِنَّهُۥ طَغَىٰ",
    translation: "Go to Pharaoh. Indeed, he has transgressed",
    normalizedText: "اذهب الى فرعون انه طغى",
  },
  {
    verseId: 17,
    name: "النازعات",
    surahId: 79,
    text: "فَقُلۡ هَل لَّكَ إِلَىٰٓ أَن تَزَكَّىٰ",
    translation: "And say to him, 'Would you [be willing to] purify yourself",
    normalizedText: "فقل هل لك الى ان تزكى",
  },
  {
    verseId: 18,
    name: "النازعات",
    surahId: 79,
    text: "وَأَهۡدِيَكَ إِلَىٰ رَبِّكَ فَتَخۡشَىٰ",
    translation: "And let me guide you to your Lord so you would fear [Him]",
    normalizedText: "واهديك الى ربك فتخشى",
  },
  {
    verseId: 19,
    name: "النازعات",
    surahId: 79,
    text: "فَأَرَىٰهُ ٱلۡأٓيَةَ ٱلۡكُبۡرَىٰ",
    translation: "And he showed him the greatest sign",
    normalizedText: "فارىه الاية الكبرى",
  },
  {
    verseId: 20,
    name: "النازعات",
    surahId: 79,
    text: "فَكَذَّبَ وَعَصَىٰ",
    translation: "But Pharaoh denied and disobeyed",
    normalizedText: "فكذب وعصى",
  },
  {
    verseId: 21,
    name: "النازعات",
    surahId: 79,
    text: "ثُمَّ أَدۡبَرَ يَسۡعَىٰ",
    translation: "Then he turned his back, striving",
    normalizedText: "ثم ادبر يسعى",
  },
  {
    verseId: 22,
    name: "النازعات",
    surahId: 79,
    text: "فَحَشَرَ فَنَادَىٰ",
    translation: "And he gathered [his people] and called out",
    normalizedText: "فحشر فنادى",
  },
  {
    verseId: 23,
    name: "النازعات",
    surahId: 79,
    text: "فَقَالَ أَنَا۠ رَبُّكُمُ ٱلۡأَعۡلَىٰ",
    translation: 'And said, "I am your most exalted lord',
    normalizedText: "فقال انا ربكم الاعلى",
  },
  {
    verseId: 24,
    name: "النازعات",
    surahId: 79,
    text: "فَأَخَذَهُ ٱللَّهُ نَكَالَ ٱلۡأٓخِرَةِ وَٱلۡأُولَىٰٓ",
    translation:
      "So Allah seized him in exemplary punishment for the last and the first [transgression]",
    normalizedText: "فاخذه الله نكال الاخرة والاولى",
  },
  {
    verseId: 25,
    name: "النازعات",
    surahId: 79,
    text: "إِنَّ فِي ذَٰلِكَ لَعِبۡرَةٗ لِّمَن يَخۡشَىٰٓ",
    translation: "Indeed in that is a warning for whoever would fear [Allah]",
    normalizedText: "ان في ذلك لعبرة لمن يخشى",
  },
  {
    verseId: 26,
    name: "النازعات",
    surahId: 79,
    text: "ءَأَنتُمۡ أَشَدُّ خَلۡقًا أَمِ ٱلسَّمَآءُۚ بَنَىٰهَا",
    translation:
      "Are you a more difficult creation or is the heaven? Allah constructed it",
    normalizedText: "ءانتم اشد خلقا ام السماء بنىها",
  },
  {
    verseId: 27,
    name: "النازعات",
    surahId: 79,
    text: "رَفَعَ سَمۡكَهَا فَسَوَّىٰهَا",
    translation: "He raised its ceiling and proportioned it",
    normalizedText: "رفع سمكها فسوىها",
  },
  {
    verseId: 28,
    name: "النازعات",
    surahId: 79,
    text: "وَأَغۡطَشَ لَيۡلَهَا وَأَخۡرَجَ ضُحَىٰهَا",
    translation: "And He darkened its night and extracted its brightness",
    normalizedText: "واغطش ليلها واخرج ضحىها",
  },
  {
    verseId: 29,
    name: "النازعات",
    surahId: 79,
    text: "وَٱلۡأَرۡضَ بَعۡدَ ذَٰلِكَ دَحَىٰهَآ",
    translation: "And after that He spread the earth",
    normalizedText: "والارض بعد ذلك دحىها",
  },
  {
    verseId: 30,
    name: "النازعات",
    surahId: 79,
    text: "أَخۡرَجَ مِنۡهَا مَآءَهَا وَمَرۡعَىٰهَا",
    translation: "He extracted from it its water and its pasture",
    normalizedText: "اخرج منها ماءها ومرعىها",
  },
  {
    verseId: 31,
    name: "النازعات",
    surahId: 79,
    text: "وَٱلۡجِبَالَ أَرۡسَىٰهَا",
    translation: "And the mountains He set firmly",
    normalizedText: "والجبال ارسىها",
  },
  {
    verseId: 32,
    name: "النازعات",
    surahId: 79,
    text: "مَتَٰعٗا لَّكُمۡ وَلِأَنۡعَٰمِكُمۡ",
    translation: "As provision for you and your grazing livestock",
    normalizedText: "متعا لكم ولانعمكم",
  },
  {
    verseId: 33,
    name: "النازعات",
    surahId: 79,
    text: "فَإِذَا جَآءَتِ ٱلطَّآمَّةُ ٱلۡكُبۡرَىٰ",
    translation: "But when there comes the greatest Overwhelming Calamity",
    normalizedText: "فاذا جاءت الطامة الكبرى",
  },
  {
    verseId: 34,
    name: "النازعات",
    surahId: 79,
    text: "يَوۡمَ يَتَذَكَّرُ ٱلۡإِنسَٰنُ مَا سَعَىٰ",
    translation: "The Day when man will remember that for which he strove",
    normalizedText: "يوم يتذكر الانسن ما سعى",
  },
  {
    verseId: 35,
    name: "النازعات",
    surahId: 79,
    text: "وَبُرِّزَتِ ٱلۡجَحِيمُ لِمَن يَرَىٰ",
    translation: "And Hellfire will be exposed for [all] those who see",
    normalizedText: "وبرزت الجحيم لمن يرى",
  },
  {
    verseId: 36,
    name: "النازعات",
    surahId: 79,
    text: "فَأَمَّا مَن طَغَىٰ",
    translation: "So as for he who transgressed",
    normalizedText: "فاما من طغى",
  },
  {
    verseId: 37,
    name: "النازعات",
    surahId: 79,
    text: "وَءَاثَرَ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا",
    translation: "And preferred the life of the world",
    normalizedText: "وءاثر الحيوة الدنيا",
  },
  {
    verseId: 38,
    name: "النازعات",
    surahId: 79,
    text: "فَإِنَّ ٱلۡجَحِيمَ هِيَ ٱلۡمَأۡوَىٰ",
    translation: "Then indeed, Hellfire will be [his] refuge",
    normalizedText: "فان الجحيم هي الماوى",
  },
  {
    verseId: 39,
    name: "النازعات",
    surahId: 79,
    text: "وَأَمَّا مَنۡ خَافَ مَقَامَ رَبِّهِۦ وَنَهَى ٱلنَّفۡسَ عَنِ ٱلۡهَوَىٰ",
    translation:
      "But as for he who feared the position of his Lord and prevented the soul from [unlawful] inclination",
    normalizedText: "واما من خاف مقام ربه ونهى النفس عن الهوى",
  },
  {
    verseId: 40,
    name: "النازعات",
    surahId: 79,
    text: "فَإِنَّ ٱلۡجَنَّةَ هِيَ ٱلۡمَأۡوَىٰ",
    translation: "Then indeed, Paradise will be [his] refuge",
    normalizedText: "فان الجنة هي الماوى",
  },
  {
    verseId: 41,
    name: "النازعات",
    surahId: 79,
    text: "يَسۡـَٔلُونَكَ عَنِ ٱلسَّاعَةِ أَيَّانَ مُرۡسَىٰهَا",
    translation:
      "They ask you, [O Muhammad], about the Hour: when is its arrival",
    normalizedText: "يسلونك عن الساعة ايان مرسىها",
  },
  {
    verseId: 42,
    name: "النازعات",
    surahId: 79,
    text: "فِيمَ أَنتَ مِن ذِكۡرَىٰهَآ",
    translation: "In what [position] are you that you should mention it",
    normalizedText: "فيم انت من ذكرىها",
  },
  {
    verseId: 43,
    name: "النازعات",
    surahId: 79,
    text: "إِلَىٰ رَبِّكَ مُنتَهَىٰهَآ",
    translation: "To your Lord is its finality",
    normalizedText: "الى ربك منتهىها",
  },
  {
    verseId: 44,
    name: "النازعات",
    surahId: 79,
    text: "إِنَّمَآ أَنتَ مُنذِرُ مَن يَخۡشَىٰهَا",
    translation: "You are only a warner for those who fear it",
    normalizedText: "انما انت منذر من يخشىها",
  },
  {
    verseId: 45,
    name: "النازعات",
    surahId: 79,
    text: "كَأَنَّهُمۡ يَوۡمَ يَرَوۡنَهَا لَمۡ يَلۡبَثُوٓاْ إِلَّا عَشِيَّةً أَوۡ ضُحَىٰهَا",
    translation:
      "It will be, on the Day they see it, as though they had not remained [in the world] except for an afternoon or a morning thereof",
    normalizedText: "كانهم يوم يرونها لم يلبثوا الا عشية او ضحىها",
  },
  {
    verseId: 0,
    name: "عبس",
    surahId: 80,
    text: "عَبَسَ وَتَوَلَّىٰٓ",
    translation: "The Prophet frowned and turned away",
    normalizedText: "عبس وتولى",
  },
  {
    verseId: 1,
    name: "عبس",
    surahId: 80,
    text: "أَن جَآءَهُ ٱلۡأَعۡمَىٰ",
    translation: "Because there came to him the blind man, [interrupting]",
    normalizedText: "ان جاءه الاعمى",
  },
  {
    verseId: 2,
    name: "عبس",
    surahId: 80,
    text: "وَمَا يُدۡرِيكَ لَعَلَّهُۥ يَزَّكَّىٰٓ",
    translation:
      "But what would make you perceive, [O Muhammad], that perhaps he might be purified",
    normalizedText: "وما يدريك لعله يزكى",
  },
  {
    verseId: 3,
    name: "عبس",
    surahId: 80,
    text: "أَوۡ يَذَّكَّرُ فَتَنفَعَهُ ٱلذِّكۡرَىٰٓ",
    translation: "Or be reminded and the remembrance would benefit him",
    normalizedText: "او يذكر فتنفعه الذكرى",
  },
  {
    verseId: 4,
    name: "عبس",
    surahId: 80,
    text: "أَمَّا مَنِ ٱسۡتَغۡنَىٰ",
    translation: "As for he who thinks himself without need",
    normalizedText: "اما من استغنى",
  },
  {
    verseId: 5,
    name: "عبس",
    surahId: 80,
    text: "فَأَنتَ لَهُۥ تَصَدَّىٰ",
    translation: "To him you give attention",
    normalizedText: "فانت له تصدى",
  },
  {
    verseId: 6,
    name: "عبس",
    surahId: 80,
    text: "وَمَا عَلَيۡكَ أَلَّا يَزَّكَّىٰ",
    translation: "And not upon you [is any blame] if he will not be purified",
    normalizedText: "وما عليك الا يزكى",
  },
  {
    verseId: 7,
    name: "عبس",
    surahId: 80,
    text: "وَأَمَّا مَن جَآءَكَ يَسۡعَىٰ",
    translation: "But as for he who came to you striving [for knowledge]",
    normalizedText: "واما من جاءك يسعى",
  },
  {
    verseId: 8,
    name: "عبس",
    surahId: 80,
    text: "وَهُوَ يَخۡشَىٰ",
    translation: "While he fears [Allah]",
    normalizedText: "وهو يخشى",
  },
  {
    verseId: 9,
    name: "عبس",
    surahId: 80,
    text: "فَأَنتَ عَنۡهُ تَلَهَّىٰ",
    translation: "From him you are distracted",
    normalizedText: "فانت عنه تلهى",
  },
  {
    verseId: 10,
    name: "عبس",
    surahId: 80,
    text: "كَلَّآ إِنَّهَا تَذۡكِرَةٞ",
    translation: "No! Indeed, these verses are a reminder",
    normalizedText: "كلا انها تذكرة",
  },
  {
    verseId: 11,
    name: "عبس",
    surahId: 80,
    text: "فَمَن شَآءَ ذَكَرَهُۥ",
    translation: "So whoever wills may remember it",
    normalizedText: "فمن شاء ذكره",
  },
  {
    verseId: 12,
    name: "عبس",
    surahId: 80,
    text: "فِي صُحُفٖ مُّكَرَّمَةٖ",
    translation: "[It is recorded] in honored sheets",
    normalizedText: "في صحف مكرمة",
  },
  {
    verseId: 13,
    name: "عبس",
    surahId: 80,
    text: "مَّرۡفُوعَةٖ مُّطَهَّرَةِۭ",
    translation: "Exalted and purified",
    normalizedText: "مرفوعة مطهرة",
  },
  {
    verseId: 14,
    name: "عبس",
    surahId: 80,
    text: "بِأَيۡدِي سَفَرَةٖ",
    translation: "[Carried] by the hands of messenger-angels",
    normalizedText: "بايدي سفرة",
  },
  {
    verseId: 15,
    name: "عبس",
    surahId: 80,
    text: "كِرَامِۭ بَرَرَةٖ",
    translation: "Noble and dutiful",
    normalizedText: "كرام بررة",
  },
  {
    verseId: 16,
    name: "عبس",
    surahId: 80,
    text: "قُتِلَ ٱلۡإِنسَٰنُ مَآ أَكۡفَرَهُۥ",
    translation: "Cursed is man; how disbelieving is he",
    normalizedText: "قتل الانسن ما اكفره",
  },
  {
    verseId: 17,
    name: "عبس",
    surahId: 80,
    text: "مِنۡ أَيِّ شَيۡءٍ خَلَقَهُۥ",
    translation: "From what substance did He create him",
    normalizedText: "من اي شيء خلقه",
  },
  {
    verseId: 18,
    name: "عبس",
    surahId: 80,
    text: "مِن نُّطۡفَةٍ خَلَقَهُۥ فَقَدَّرَهُۥ",
    translation: "From a sperm-drop He created him and destined for him",
    normalizedText: "من نطفة خلقه فقدره",
  },
  {
    verseId: 19,
    name: "عبس",
    surahId: 80,
    text: "ثُمَّ ٱلسَّبِيلَ يَسَّرَهُۥ",
    translation: "Then He eased the way for him",
    normalizedText: "ثم السبيل يسره",
  },
  {
    verseId: 20,
    name: "عبس",
    surahId: 80,
    text: "ثُمَّ أَمَاتَهُۥ فَأَقۡبَرَهُۥ",
    translation: "Then He causes his death and provides a grave for him",
    normalizedText: "ثم اماته فاقبره",
  },
  {
    verseId: 21,
    name: "عبس",
    surahId: 80,
    text: "ثُمَّ إِذَا شَآءَ أَنشَرَهُۥ",
    translation: "Then when He wills, He will resurrect him",
    normalizedText: "ثم اذا شاء انشره",
  },
  {
    verseId: 22,
    name: "عبس",
    surahId: 80,
    text: "كَلَّا لَمَّا يَقۡضِ مَآ أَمَرَهُۥ",
    translation: "No! Man has not yet accomplished what He commanded him",
    normalizedText: "كلا لما يقض ما امره",
  },
  {
    verseId: 23,
    name: "عبس",
    surahId: 80,
    text: "فَلۡيَنظُرِ ٱلۡإِنسَٰنُ إِلَىٰ طَعَامِهِۦٓ",
    translation: "Then let mankind look at his food",
    normalizedText: "فلينظر الانسن الى طعامه",
  },
  {
    verseId: 24,
    name: "عبس",
    surahId: 80,
    text: "أَنَّا صَبَبۡنَا ٱلۡمَآءَ صَبّٗا",
    translation: "How We poured down water in torrents",
    normalizedText: "انا صببنا الماء صبا",
  },
  {
    verseId: 25,
    name: "عبس",
    surahId: 80,
    text: "ثُمَّ شَقَقۡنَا ٱلۡأَرۡضَ شَقّٗا",
    translation: "Then We broke open the earth, splitting [it with sprouts]",
    normalizedText: "ثم شققنا الارض شقا",
  },
  {
    verseId: 26,
    name: "عبس",
    surahId: 80,
    text: "فَأَنۢبَتۡنَا فِيهَا حَبّٗا",
    translation: "And caused to grow within it grain",
    normalizedText: "فانبتنا فيها حبا",
  },
  {
    verseId: 27,
    name: "عبس",
    surahId: 80,
    text: "وَعِنَبٗا وَقَضۡبٗا",
    translation: "And grapes and herbage",
    normalizedText: "وعنبا وقضبا",
  },
  {
    verseId: 28,
    name: "عبس",
    surahId: 80,
    text: "وَزَيۡتُونٗا وَنَخۡلٗا",
    translation: "And olive and palm trees",
    normalizedText: "وزيتونا ونخلا",
  },
  {
    verseId: 29,
    name: "عبس",
    surahId: 80,
    text: "وَحَدَآئِقَ غُلۡبٗا",
    translation: "And gardens of dense shrubbery",
    normalizedText: "وحدااق غلبا",
  },
  {
    verseId: 30,
    name: "عبس",
    surahId: 80,
    text: "وَفَٰكِهَةٗ وَأَبّٗا",
    translation: "And fruit and grass",
    normalizedText: "وفكهة وابا",
  },
  {
    verseId: 31,
    name: "عبس",
    surahId: 80,
    text: "مَّتَٰعٗا لَّكُمۡ وَلِأَنۡعَٰمِكُمۡ",
    translation: "[As] enjoyment for you and your grazing livestock",
    normalizedText: "متعا لكم ولانعمكم",
  },
  {
    verseId: 32,
    name: "عبس",
    surahId: 80,
    text: "فَإِذَا جَآءَتِ ٱلصَّآخَّةُ",
    translation: "But when there comes the Deafening Blast",
    normalizedText: "فاذا جاءت الصاخة",
  },
  {
    verseId: 33,
    name: "عبس",
    surahId: 80,
    text: "يَوۡمَ يَفِرُّ ٱلۡمَرۡءُ مِنۡ أَخِيهِ",
    translation: "On the Day a man will flee from his brother",
    normalizedText: "يوم يفر المرء من اخيه",
  },
  {
    verseId: 34,
    name: "عبس",
    surahId: 80,
    text: "وَأُمِّهِۦ وَأَبِيهِ",
    translation: "And his mother and his father",
    normalizedText: "وامه وابيه",
  },
  {
    verseId: 35,
    name: "عبس",
    surahId: 80,
    text: "وَصَٰحِبَتِهِۦ وَبَنِيهِ",
    translation: "And his wife and his children",
    normalizedText: "وصحبته وبنيه",
  },
  {
    verseId: 36,
    name: "عبس",
    surahId: 80,
    text: "لِكُلِّ ٱمۡرِيٕٖ مِّنۡهُمۡ يَوۡمَئِذٖ شَأۡنٞ يُغۡنِيهِ",
    translation: "For every man, that Day, will be a matter adequate for him",
    normalizedText: "لكل امري منهم يوماذ شان يغنيه",
  },
  {
    verseId: 37,
    name: "عبس",
    surahId: 80,
    text: "وُجُوهٞ يَوۡمَئِذٖ مُّسۡفِرَةٞ",
    translation: "[Some] faces, that Day, will be bright",
    normalizedText: "وجوه يوماذ مسفرة",
  },
  {
    verseId: 38,
    name: "عبس",
    surahId: 80,
    text: "ضَاحِكَةٞ مُّسۡتَبۡشِرَةٞ",
    translation: "Laughing, rejoicing at good news",
    normalizedText: "ضاحكة مستبشرة",
  },
  {
    verseId: 39,
    name: "عبس",
    surahId: 80,
    text: "وَوُجُوهٞ يَوۡمَئِذٍ عَلَيۡهَا غَبَرَةٞ",
    translation: "And [other] faces, that Day, will have upon them dust",
    normalizedText: "ووجوه يوماذ عليها غبرة",
  },
  {
    verseId: 40,
    name: "عبس",
    surahId: 80,
    text: "تَرۡهَقُهَا قَتَرَةٌ",
    translation: "Blackness will cover them",
    normalizedText: "ترهقها قترة",
  },
  {
    verseId: 41,
    name: "عبس",
    surahId: 80,
    text: "أُوْلَـٰٓئِكَ هُمُ ٱلۡكَفَرَةُ ٱلۡفَجَرَةُ",
    translation: "Those are the disbelievers, the wicked ones",
    normalizedText: "اولاك هم الكفرة الفجرة",
  },
  {
    verseId: 0,
    name: "التكوير",
    surahId: 81,
    text: "إِذَا ٱلشَّمۡسُ كُوِّرَتۡ",
    translation: "When the sun is wrapped up [in darkness]",
    normalizedText: "اذا الشمس كورت",
  },
  {
    verseId: 1,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلنُّجُومُ ٱنكَدَرَتۡ",
    translation: "And when the stars fall, dispersing",
    normalizedText: "واذا النجوم انكدرت",
  },
  {
    verseId: 2,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلۡجِبَالُ سُيِّرَتۡ",
    translation: "And when the mountains are removed",
    normalizedText: "واذا الجبال سيرت",
  },
  {
    verseId: 3,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلۡعِشَارُ عُطِّلَتۡ",
    translation: "And when full-term she-camels are neglected",
    normalizedText: "واذا العشار عطلت",
  },
  {
    verseId: 4,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلۡوُحُوشُ حُشِرَتۡ",
    translation: "And when the wild beasts are gathered",
    normalizedText: "واذا الوحوش حشرت",
  },
  {
    verseId: 5,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلۡبِحَارُ سُجِّرَتۡ",
    translation: "And when the seas are filled with flame",
    normalizedText: "واذا البحار سجرت",
  },
  {
    verseId: 6,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلنُّفُوسُ زُوِّجَتۡ",
    translation: "And when the souls are paired",
    normalizedText: "واذا النفوس زوجت",
  },
  {
    verseId: 7,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلۡمَوۡءُۥدَةُ سُئِلَتۡ",
    translation: "And when the girl [who was] buried alive is asked",
    normalizedText: "واذا الموءدة سالت",
  },
  {
    verseId: 8,
    name: "التكوير",
    surahId: 81,
    text: "بِأَيِّ ذَنۢبٖ قُتِلَتۡ",
    translation: "For what sin she was killed",
    normalizedText: "باي ذنب قتلت",
  },
  {
    verseId: 9,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلصُّحُفُ نُشِرَتۡ",
    translation: "And when the pages are made public",
    normalizedText: "واذا الصحف نشرت",
  },
  {
    verseId: 10,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلسَّمَآءُ كُشِطَتۡ",
    translation: "And when the sky is stripped away",
    normalizedText: "واذا السماء كشطت",
  },
  {
    verseId: 11,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلۡجَحِيمُ سُعِّرَتۡ",
    translation: "And when Hellfire is set ablaze",
    normalizedText: "واذا الجحيم سعرت",
  },
  {
    verseId: 12,
    name: "التكوير",
    surahId: 81,
    text: "وَإِذَا ٱلۡجَنَّةُ أُزۡلِفَتۡ",
    translation: "And when Paradise is brought near",
    normalizedText: "واذا الجنة ازلفت",
  },
  {
    verseId: 13,
    name: "التكوير",
    surahId: 81,
    text: "عَلِمَتۡ نَفۡسٞ مَّآ أَحۡضَرَتۡ",
    translation: "A soul will [then] know what it has brought [with it]",
    normalizedText: "علمت نفس ما احضرت",
  },
  {
    verseId: 14,
    name: "التكوير",
    surahId: 81,
    text: "فَلَآ أُقۡسِمُ بِٱلۡخُنَّسِ",
    translation: "So I swear by the retreating stars",
    normalizedText: "فلا اقسم بالخنس",
  },
  {
    verseId: 15,
    name: "التكوير",
    surahId: 81,
    text: "ٱلۡجَوَارِ ٱلۡكُنَّسِ",
    translation: "Those that run [their courses] and disappear",
    normalizedText: "الجوار الكنس",
  },
  {
    verseId: 16,
    name: "التكوير",
    surahId: 81,
    text: "وَٱلَّيۡلِ إِذَا عَسۡعَسَ",
    translation: "And by the night as it closes in",
    normalizedText: "واليل اذا عسعس",
  },
  {
    verseId: 17,
    name: "التكوير",
    surahId: 81,
    text: "وَٱلصُّبۡحِ إِذَا تَنَفَّسَ",
    translation: "And by the dawn when it breathes",
    normalizedText: "والصبح اذا تنفس",
  },
  {
    verseId: 18,
    name: "التكوير",
    surahId: 81,
    text: "إِنَّهُۥ لَقَوۡلُ رَسُولٖ كَرِيمٖ",
    translation:
      "[That] indeed, the Qur'an is a word [conveyed by] a noble messenger",
    normalizedText: "انه لقول رسول كريم",
  },
  {
    verseId: 19,
    name: "التكوير",
    surahId: 81,
    text: "ذِي قُوَّةٍ عِندَ ذِي ٱلۡعَرۡشِ مَكِينٖ",
    translation:
      "[Who is] possessed of power and with the Owner of the Throne, secure [in position]",
    normalizedText: "ذي قوة عند ذي العرش مكين",
  },
  {
    verseId: 20,
    name: "التكوير",
    surahId: 81,
    text: "مُّطَاعٖ ثَمَّ أَمِينٖ",
    translation: "Obeyed there [in the heavens] and trustworthy",
    normalizedText: "مطاع ثم امين",
  },
  {
    verseId: 21,
    name: "التكوير",
    surahId: 81,
    text: "وَمَا صَاحِبُكُم بِمَجۡنُونٖ",
    translation: "And your companion is not [at all] mad",
    normalizedText: "وما صاحبكم بمجنون",
  },
  {
    verseId: 22,
    name: "التكوير",
    surahId: 81,
    text: "وَلَقَدۡ رَءَاهُ بِٱلۡأُفُقِ ٱلۡمُبِينِ",
    translation: "And he has already seen Gabriel in the clear horizon",
    normalizedText: "ولقد رءاه بالافق المبين",
  },
  {
    verseId: 23,
    name: "التكوير",
    surahId: 81,
    text: "وَمَا هُوَ عَلَى ٱلۡغَيۡبِ بِضَنِينٖ",
    translation:
      "And Muhammad is not a withholder of [knowledge of] the unseen",
    normalizedText: "وما هو على الغيب بضنين",
  },
  {
    verseId: 24,
    name: "التكوير",
    surahId: 81,
    text: "وَمَا هُوَ بِقَوۡلِ شَيۡطَٰنٖ رَّجِيمٖ",
    translation:
      "And the Qur'an is not the word of a devil, expelled [from the heavens]",
    normalizedText: "وما هو بقول شيطن رجيم",
  },
  {
    verseId: 25,
    name: "التكوير",
    surahId: 81,
    text: "فَأَيۡنَ تَذۡهَبُونَ",
    translation: "So where are you going",
    normalizedText: "فاين تذهبون",
  },
  {
    verseId: 26,
    name: "التكوير",
    surahId: 81,
    text: "إِنۡ هُوَ إِلَّا ذِكۡرٞ لِّلۡعَٰلَمِينَ",
    translation: "It is not except a reminder to the worlds",
    normalizedText: "ان هو الا ذكر للعلمين",
  },
  {
    verseId: 27,
    name: "التكوير",
    surahId: 81,
    text: "لِمَن شَآءَ مِنكُمۡ أَن يَسۡتَقِيمَ",
    translation: "For whoever wills among you to take a right course",
    normalizedText: "لمن شاء منكم ان يستقيم",
  },
  {
    verseId: 28,
    name: "التكوير",
    surahId: 81,
    text: "وَمَا تَشَآءُونَ إِلَّآ أَن يَشَآءَ ٱللَّهُ رَبُّ ٱلۡعَٰلَمِينَ",
    translation:
      "And you do not will except that Allah wills - Lord of the worlds",
    normalizedText: "وما تشاءون الا ان يشاء الله رب العلمين",
  },
  {
    verseId: 0,
    name: "الإنفطار",
    surahId: 82,
    text: "إِذَا ٱلسَّمَآءُ ٱنفَطَرَتۡ",
    translation: "When the sky breaks apart",
    normalizedText: "اذا السماء انفطرت",
  },
  {
    verseId: 1,
    name: "الإنفطار",
    surahId: 82,
    text: "وَإِذَا ٱلۡكَوَاكِبُ ٱنتَثَرَتۡ",
    translation: "And when the stars fall, scattering",
    normalizedText: "واذا الكواكب انتثرت",
  },
  {
    verseId: 2,
    name: "الإنفطار",
    surahId: 82,
    text: "وَإِذَا ٱلۡبِحَارُ فُجِّرَتۡ",
    translation: "And when the seas are erupted",
    normalizedText: "واذا البحار فجرت",
  },
  {
    verseId: 3,
    name: "الإنفطار",
    surahId: 82,
    text: "وَإِذَا ٱلۡقُبُورُ بُعۡثِرَتۡ",
    translation: "And when the [contents of] graves are scattered",
    normalizedText: "واذا القبور بعثرت",
  },
  {
    verseId: 4,
    name: "الإنفطار",
    surahId: 82,
    text: "عَلِمَتۡ نَفۡسٞ مَّا قَدَّمَتۡ وَأَخَّرَتۡ",
    translation: "A soul will [then] know what it has put forth and kept back",
    normalizedText: "علمت نفس ما قدمت واخرت",
  },
  {
    verseId: 5,
    name: "الإنفطار",
    surahId: 82,
    text: "يَـٰٓأَيُّهَا ٱلۡإِنسَٰنُ مَا غَرَّكَ بِرَبِّكَ ٱلۡكَرِيمِ",
    translation:
      "O mankind, what has deceived you concerning your Lord, the Generous",
    normalizedText: "يايها الانسن ما غرك بربك الكريم",
  },
  {
    verseId: 6,
    name: "الإنفطار",
    surahId: 82,
    text: "ٱلَّذِي خَلَقَكَ فَسَوَّىٰكَ فَعَدَلَكَ",
    translation: "Who created you, proportioned you, and balanced you",
    normalizedText: "الذي خلقك فسوىك فعدلك",
  },
  {
    verseId: 7,
    name: "الإنفطار",
    surahId: 82,
    text: "فِيٓ أَيِّ صُورَةٖ مَّا شَآءَ رَكَّبَكَ",
    translation: "In whatever form He willed has He assembled you",
    normalizedText: "في اي صورة ما شاء ركبك",
  },
  {
    verseId: 8,
    name: "الإنفطار",
    surahId: 82,
    text: "كَلَّا بَلۡ تُكَذِّبُونَ بِٱلدِّينِ",
    translation: "No! But you deny the Recompense",
    normalizedText: "كلا بل تكذبون بالدين",
  },
  {
    verseId: 9,
    name: "الإنفطار",
    surahId: 82,
    text: "وَإِنَّ عَلَيۡكُمۡ لَحَٰفِظِينَ",
    translation: "And indeed, [appointed] over you are keepers",
    normalizedText: "وان عليكم لحفظين",
  },
  {
    verseId: 10,
    name: "الإنفطار",
    surahId: 82,
    text: "كِرَامٗا كَٰتِبِينَ",
    translation: "Noble and recording",
    normalizedText: "كراما كتبين",
  },
  {
    verseId: 11,
    name: "الإنفطار",
    surahId: 82,
    text: "يَعۡلَمُونَ مَا تَفۡعَلُونَ",
    translation: "They know whatever you do",
    normalizedText: "يعلمون ما تفعلون",
  },
  {
    verseId: 12,
    name: "الإنفطار",
    surahId: 82,
    text: "إِنَّ ٱلۡأَبۡرَارَ لَفِي نَعِيمٖ",
    translation: "Indeed, the righteous will be in pleasure",
    normalizedText: "ان الابرار لفي نعيم",
  },
  {
    verseId: 13,
    name: "الإنفطار",
    surahId: 82,
    text: "وَإِنَّ ٱلۡفُجَّارَ لَفِي جَحِيمٖ",
    translation: "And indeed, the wicked will be in Hellfire",
    normalizedText: "وان الفجار لفي جحيم",
  },
  {
    verseId: 14,
    name: "الإنفطار",
    surahId: 82,
    text: "يَصۡلَوۡنَهَا يَوۡمَ ٱلدِّينِ",
    translation: "They will [enter to] burn therein on the Day of Recompense",
    normalizedText: "يصلونها يوم الدين",
  },
  {
    verseId: 15,
    name: "الإنفطار",
    surahId: 82,
    text: "وَمَا هُمۡ عَنۡهَا بِغَآئِبِينَ",
    translation: "And never therefrom will they be absent",
    normalizedText: "وما هم عنها بغاابين",
  },
  {
    verseId: 16,
    name: "الإنفطار",
    surahId: 82,
    text: "وَمَآ أَدۡرَىٰكَ مَا يَوۡمُ ٱلدِّينِ",
    translation: "And what can make you know what is the Day of Recompense",
    normalizedText: "وما ادرىك ما يوم الدين",
  },
  {
    verseId: 17,
    name: "الإنفطار",
    surahId: 82,
    text: "ثُمَّ مَآ أَدۡرَىٰكَ مَا يَوۡمُ ٱلدِّينِ",
    translation: "Then, what can make you know what is the Day of Recompense",
    normalizedText: "ثم ما ادرىك ما يوم الدين",
  },
  {
    verseId: 18,
    name: "الإنفطار",
    surahId: 82,
    text: "يَوۡمَ لَا تَمۡلِكُ نَفۡسٞ لِّنَفۡسٖ شَيۡـٔٗاۖ وَٱلۡأَمۡرُ يَوۡمَئِذٖ لِّلَّهِ",
    translation:
      "It is the Day when a soul will not possess for another soul [power to do] a thing; and the command, that Day, is [entirely] with Allah",
    normalizedText: "يوم لا تملك نفس لنفس شيا والامر يوماذ لله",
  },
  {
    verseId: 0,
    name: "المطففين",
    surahId: 83,
    text: "وَيۡلٞ لِّلۡمُطَفِّفِينَ",
    translation: "Woe to those who give less [than due]",
    normalizedText: "ويل للمطففين",
  },
  {
    verseId: 1,
    name: "المطففين",
    surahId: 83,
    text: "ٱلَّذِينَ إِذَا ٱكۡتَالُواْ عَلَى ٱلنَّاسِ يَسۡتَوۡفُونَ",
    translation: "Who, when they take a measure from people, take in full",
    normalizedText: "الذين اذا اكتالوا على الناس يستوفون",
  },
  {
    verseId: 2,
    name: "المطففين",
    surahId: 83,
    text: "وَإِذَا كَالُوهُمۡ أَو وَّزَنُوهُمۡ يُخۡسِرُونَ",
    translation:
      "But if they give by measure or by weight to them, they cause loss",
    normalizedText: "واذا كالوهم او وزنوهم يخسرون",
  },
  {
    verseId: 3,
    name: "المطففين",
    surahId: 83,
    text: "أَلَا يَظُنُّ أُوْلَـٰٓئِكَ أَنَّهُم مَّبۡعُوثُونَ",
    translation: "Do they not think that they will be resurrected",
    normalizedText: "الا يظن اولاك انهم مبعوثون",
  },
  {
    verseId: 4,
    name: "المطففين",
    surahId: 83,
    text: "لِيَوۡمٍ عَظِيمٖ",
    translation: "For a tremendous Day",
    normalizedText: "ليوم عظيم",
  },
  {
    verseId: 5,
    name: "المطففين",
    surahId: 83,
    text: "يَوۡمَ يَقُومُ ٱلنَّاسُ لِرَبِّ ٱلۡعَٰلَمِينَ",
    translation:
      "The Day when mankind will stand before the Lord of the worlds",
    normalizedText: "يوم يقوم الناس لرب العلمين",
  },
  {
    verseId: 6,
    name: "المطففين",
    surahId: 83,
    text: "كَلَّآ إِنَّ كِتَٰبَ ٱلۡفُجَّارِ لَفِي سِجِّينٖ",
    translation: "No! Indeed, the record of the wicked is in sijjeen",
    normalizedText: "كلا ان كتب الفجار لفي سجين",
  },
  {
    verseId: 7,
    name: "المطففين",
    surahId: 83,
    text: "وَمَآ أَدۡرَىٰكَ مَا سِجِّينٞ",
    translation: "And what can make you know what is sijjeen",
    normalizedText: "وما ادرىك ما سجين",
  },
  {
    verseId: 8,
    name: "المطففين",
    surahId: 83,
    text: "كِتَٰبٞ مَّرۡقُومٞ",
    translation: "It is [their destination recorded in] a register inscribed",
    normalizedText: "كتب مرقوم",
  },
  {
    verseId: 9,
    name: "المطففين",
    surahId: 83,
    text: "وَيۡلٞ يَوۡمَئِذٖ لِّلۡمُكَذِّبِينَ",
    translation: "Woe, that Day, to the deniers",
    normalizedText: "ويل يوماذ للمكذبين",
  },
  {
    verseId: 10,
    name: "المطففين",
    surahId: 83,
    text: "ٱلَّذِينَ يُكَذِّبُونَ بِيَوۡمِ ٱلدِّينِ",
    translation: "Who deny the Day of Recompense",
    normalizedText: "الذين يكذبون بيوم الدين",
  },
  {
    verseId: 11,
    name: "المطففين",
    surahId: 83,
    text: "وَمَا يُكَذِّبُ بِهِۦٓ إِلَّا كُلُّ مُعۡتَدٍ أَثِيمٍ",
    translation: "And none deny it except every sinful transgressor",
    normalizedText: "وما يكذب به الا كل معتد اثيم",
  },
  {
    verseId: 12,
    name: "المطففين",
    surahId: 83,
    text: "إِذَا تُتۡلَىٰ عَلَيۡهِ ءَايَٰتُنَا قَالَ أَسَٰطِيرُ ٱلۡأَوَّلِينَ",
    translation:
      'When Our verses are recited to him, he says, "Legends of the former peoples',
    normalizedText: "اذا تتلى عليه ءايتنا قال اسطير الاولين",
  },
  {
    verseId: 13,
    name: "المطففين",
    surahId: 83,
    text: "كَلَّاۖ بَلۡۜ رَانَ عَلَىٰ قُلُوبِهِم مَّا كَانُواْ يَكۡسِبُونَ",
    translation:
      "No! Rather, the stain has covered their hearts of that which they were earning",
    normalizedText: "كلا بل ران على قلوبهم ما كانوا يكسبون",
  },
  {
    verseId: 14,
    name: "المطففين",
    surahId: 83,
    text: "كَلَّآ إِنَّهُمۡ عَن رَّبِّهِمۡ يَوۡمَئِذٖ لَّمَحۡجُوبُونَ",
    translation:
      "No! Indeed, from their Lord, that Day, they will be partitioned",
    normalizedText: "كلا انهم عن ربهم يوماذ لمحجوبون",
  },
  {
    verseId: 15,
    name: "المطففين",
    surahId: 83,
    text: "ثُمَّ إِنَّهُمۡ لَصَالُواْ ٱلۡجَحِيمِ",
    translation: "Then indeed, they will [enter and] burn in Hellfire",
    normalizedText: "ثم انهم لصالوا الجحيم",
  },
  {
    verseId: 16,
    name: "المطففين",
    surahId: 83,
    text: "ثُمَّ يُقَالُ هَٰذَا ٱلَّذِي كُنتُم بِهِۦ تُكَذِّبُونَ",
    translation:
      'Then it will be said [to them], "This is what you used to deny',
    normalizedText: "ثم يقال هذا الذي كنتم به تكذبون",
  },
  {
    verseId: 17,
    name: "المطففين",
    surahId: 83,
    text: "كَلَّآ إِنَّ كِتَٰبَ ٱلۡأَبۡرَارِ لَفِي عِلِّيِّينَ",
    translation: "No! Indeed, the record of the righteous is in 'illiyyun",
    normalizedText: "كلا ان كتب الابرار لفي عليين",
  },
  {
    verseId: 18,
    name: "المطففين",
    surahId: 83,
    text: "وَمَآ أَدۡرَىٰكَ مَا عِلِّيُّونَ",
    translation: "And what can make you know what is 'illiyyun",
    normalizedText: "وما ادرىك ما عليون",
  },
  {
    verseId: 19,
    name: "المطففين",
    surahId: 83,
    text: "كِتَٰبٞ مَّرۡقُومٞ",
    translation: "It is [their destination recorded in] a register inscribed",
    normalizedText: "كتب مرقوم",
  },
  {
    verseId: 20,
    name: "المطففين",
    surahId: 83,
    text: "يَشۡهَدُهُ ٱلۡمُقَرَّبُونَ",
    translation: "Which is witnessed by those brought near [to Allah]",
    normalizedText: "يشهده المقربون",
  },
  {
    verseId: 21,
    name: "المطففين",
    surahId: 83,
    text: "إِنَّ ٱلۡأَبۡرَارَ لَفِي نَعِيمٍ",
    translation: "Indeed, the righteous will be in pleasure",
    normalizedText: "ان الابرار لفي نعيم",
  },
  {
    verseId: 22,
    name: "المطففين",
    surahId: 83,
    text: "عَلَى ٱلۡأَرَآئِكِ يَنظُرُونَ",
    translation: "On adorned couches, observing",
    normalizedText: "على الارااك ينظرون",
  },
  {
    verseId: 23,
    name: "المطففين",
    surahId: 83,
    text: "تَعۡرِفُ فِي وُجُوهِهِمۡ نَضۡرَةَ ٱلنَّعِيمِ",
    translation: "You will recognize in their faces the radiance of pleasure",
    normalizedText: "تعرف في وجوههم نضرة النعيم",
  },
  {
    verseId: 24,
    name: "المطففين",
    surahId: 83,
    text: "يُسۡقَوۡنَ مِن رَّحِيقٖ مَّخۡتُومٍ",
    translation: "They will be given to drink [pure] wine [which was] sealed",
    normalizedText: "يسقون من رحيق مختوم",
  },
  {
    verseId: 25,
    name: "المطففين",
    surahId: 83,
    text: "خِتَٰمُهُۥ مِسۡكٞۚ وَفِي ذَٰلِكَ فَلۡيَتَنَافَسِ ٱلۡمُتَنَٰفِسُونَ",
    translation:
      "The last of it is musk. So for this let the competitors compete",
    normalizedText: "ختمه مسك وفي ذلك فليتنافس المتنفسون",
  },
  {
    verseId: 26,
    name: "المطففين",
    surahId: 83,
    text: "وَمِزَاجُهُۥ مِن تَسۡنِيمٍ",
    translation: "And its mixture is of Tasneem",
    normalizedText: "ومزاجه من تسنيم",
  },
  {
    verseId: 27,
    name: "المطففين",
    surahId: 83,
    text: "عَيۡنٗا يَشۡرَبُ بِهَا ٱلۡمُقَرَّبُونَ",
    translation: "A spring from which those near [to Allah] drink",
    normalizedText: "عينا يشرب بها المقربون",
  },
  {
    verseId: 28,
    name: "المطففين",
    surahId: 83,
    text: "إِنَّ ٱلَّذِينَ أَجۡرَمُواْ كَانُواْ مِنَ ٱلَّذِينَ ءَامَنُواْ يَضۡحَكُونَ",
    translation:
      "Indeed, those who committed crimes used to laugh at those who believed",
    normalizedText: "ان الذين اجرموا كانوا من الذين ءامنوا يضحكون",
  },
  {
    verseId: 29,
    name: "المطففين",
    surahId: 83,
    text: "وَإِذَا مَرُّواْ بِهِمۡ يَتَغَامَزُونَ",
    translation:
      "And when they passed by them, they would exchange derisive glances",
    normalizedText: "واذا مروا بهم يتغامزون",
  },
  {
    verseId: 30,
    name: "المطففين",
    surahId: 83,
    text: "وَإِذَا ٱنقَلَبُوٓاْ إِلَىٰٓ أَهۡلِهِمُ ٱنقَلَبُواْ فَكِهِينَ",
    translation:
      "And when they returned to their people, they would return jesting",
    normalizedText: "واذا انقلبوا الى اهلهم انقلبوا فكهين",
  },
  {
    verseId: 31,
    name: "المطففين",
    surahId: 83,
    text: "وَإِذَا رَأَوۡهُمۡ قَالُوٓاْ إِنَّ هَـٰٓؤُلَآءِ لَضَآلُّونَ",
    translation:
      'And when they saw them, they would say, "Indeed, those are truly lost',
    normalizedText: "واذا راوهم قالوا ان هالاء لضالون",
  },
  {
    verseId: 32,
    name: "المطففين",
    surahId: 83,
    text: "وَمَآ أُرۡسِلُواْ عَلَيۡهِمۡ حَٰفِظِينَ",
    translation: "But they had not been sent as guardians over them",
    normalizedText: "وما ارسلوا عليهم حفظين",
  },
  {
    verseId: 33,
    name: "المطففين",
    surahId: 83,
    text: "فَٱلۡيَوۡمَ ٱلَّذِينَ ءَامَنُواْ مِنَ ٱلۡكُفَّارِ يَضۡحَكُونَ",
    translation: "So Today those who believed are laughing at the disbelievers",
    normalizedText: "فاليوم الذين ءامنوا من الكفار يضحكون",
  },
  {
    verseId: 34,
    name: "المطففين",
    surahId: 83,
    text: "عَلَى ٱلۡأَرَآئِكِ يَنظُرُونَ",
    translation: "On adorned couches, observing",
    normalizedText: "على الارااك ينظرون",
  },
  {
    verseId: 35,
    name: "المطففين",
    surahId: 83,
    text: "هَلۡ ثُوِّبَ ٱلۡكُفَّارُ مَا كَانُواْ يَفۡعَلُونَ",
    translation:
      "Have the disbelievers [not] been rewarded [this Day] for what they used to do",
    normalizedText: "هل ثوب الكفار ما كانوا يفعلون",
  },
  {
    verseId: 0,
    name: "الإنشقاق",
    surahId: 84,
    text: "إِذَا ٱلسَّمَآءُ ٱنشَقَّتۡ",
    translation: "When the sky has split [open]",
    normalizedText: "اذا السماء انشقت",
  },
  {
    verseId: 1,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَأَذِنَتۡ لِرَبِّهَا وَحُقَّتۡ",
    translation: "And has responded to its Lord and was obligated [to do so]",
    normalizedText: "واذنت لربها وحقت",
  },
  {
    verseId: 2,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَإِذَا ٱلۡأَرۡضُ مُدَّتۡ",
    translation: "And when the earth has been extended",
    normalizedText: "واذا الارض مدت",
  },
  {
    verseId: 3,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَأَلۡقَتۡ مَا فِيهَا وَتَخَلَّتۡ",
    translation: "And has cast out that within it and relinquished [it]",
    normalizedText: "والقت ما فيها وتخلت",
  },
  {
    verseId: 4,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَأَذِنَتۡ لِرَبِّهَا وَحُقَّتۡ",
    translation: "And has responded to its Lord and was obligated [to do so]",
    normalizedText: "واذنت لربها وحقت",
  },
  {
    verseId: 5,
    name: "الإنشقاق",
    surahId: 84,
    text: "يَـٰٓأَيُّهَا ٱلۡإِنسَٰنُ إِنَّكَ كَادِحٌ إِلَىٰ رَبِّكَ كَدۡحٗا فَمُلَٰقِيهِ",
    translation:
      "O mankind, indeed you are laboring toward your Lord with [great] exertion and will meet it",
    normalizedText: "يايها الانسن انك كادح الى ربك كدحا فملقيه",
  },
  {
    verseId: 6,
    name: "الإنشقاق",
    surahId: 84,
    text: "فَأَمَّا مَنۡ أُوتِيَ كِتَٰبَهُۥ بِيَمِينِهِۦ",
    translation: "Then as for he who is given his record in his right hand",
    normalizedText: "فاما من اوتي كتبه بيمينه",
  },
  {
    verseId: 7,
    name: "الإنشقاق",
    surahId: 84,
    text: "فَسَوۡفَ يُحَاسَبُ حِسَابٗا يَسِيرٗا",
    translation: "He will be judged with an easy account",
    normalizedText: "فسوف يحاسب حسابا يسيرا",
  },
  {
    verseId: 8,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَيَنقَلِبُ إِلَىٰٓ أَهۡلِهِۦ مَسۡرُورٗا",
    translation: "And return to his people in happiness",
    normalizedText: "وينقلب الى اهله مسرورا",
  },
  {
    verseId: 9,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَأَمَّا مَنۡ أُوتِيَ كِتَٰبَهُۥ وَرَآءَ ظَهۡرِهِۦ",
    translation: "But as for he who is given his record behind his back",
    normalizedText: "واما من اوتي كتبه وراء ظهره",
  },
  {
    verseId: 10,
    name: "الإنشقاق",
    surahId: 84,
    text: "فَسَوۡفَ يَدۡعُواْ ثُبُورٗا",
    translation: "He will cry out for destruction",
    normalizedText: "فسوف يدعوا ثبورا",
  },
  {
    verseId: 11,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَيَصۡلَىٰ سَعِيرًا",
    translation: "And [enter to] burn in a Blaze",
    normalizedText: "ويصلى سعيرا",
  },
  {
    verseId: 12,
    name: "الإنشقاق",
    surahId: 84,
    text: "إِنَّهُۥ كَانَ فِيٓ أَهۡلِهِۦ مَسۡرُورًا",
    translation: "Indeed, he had [once] been among his people in happiness",
    normalizedText: "انه كان في اهله مسرورا",
  },
  {
    verseId: 13,
    name: "الإنشقاق",
    surahId: 84,
    text: "إِنَّهُۥ ظَنَّ أَن لَّن يَحُورَ",
    translation: "Indeed, he had thought he would never return [to Allah]",
    normalizedText: "انه ظن ان لن يحور",
  },
  {
    verseId: 14,
    name: "الإنشقاق",
    surahId: 84,
    text: "بَلَىٰٓۚ إِنَّ رَبَّهُۥ كَانَ بِهِۦ بَصِيرٗا",
    translation: "But yes! Indeed, his Lord was ever of him, Seeing",
    normalizedText: "بلى ان ربه كان به بصيرا",
  },
  {
    verseId: 15,
    name: "الإنشقاق",
    surahId: 84,
    text: "فَلَآ أُقۡسِمُ بِٱلشَّفَقِ",
    translation: "So I swear by the twilight glow",
    normalizedText: "فلا اقسم بالشفق",
  },
  {
    verseId: 16,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَٱلَّيۡلِ وَمَا وَسَقَ",
    translation: "And [by] the night and what it envelops",
    normalizedText: "واليل وما وسق",
  },
  {
    verseId: 17,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَٱلۡقَمَرِ إِذَا ٱتَّسَقَ",
    translation: "And [by] the moon when it becomes full",
    normalizedText: "والقمر اذا اتسق",
  },
  {
    verseId: 18,
    name: "الإنشقاق",
    surahId: 84,
    text: "لَتَرۡكَبُنَّ طَبَقًا عَن طَبَقٖ",
    translation: "[That] you will surely experience state after state",
    normalizedText: "لتركبن طبقا عن طبق",
  },
  {
    verseId: 19,
    name: "الإنشقاق",
    surahId: 84,
    text: "فَمَا لَهُمۡ لَا يُؤۡمِنُونَ",
    translation: "So what is [the matter] with them [that] they do not believe",
    normalizedText: "فما لهم لا يامنون",
  },
  {
    verseId: 20,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَإِذَا قُرِئَ عَلَيۡهِمُ ٱلۡقُرۡءَانُ لَا يَسۡجُدُونَۤ۩",
    translation:
      "And when the Qur'an is recited to them, they do not prostrate [to Allah]",
    normalizedText: "واذا قرا عليهم القرءان لا يسجدون۩",
  },
  {
    verseId: 21,
    name: "الإنشقاق",
    surahId: 84,
    text: "بَلِ ٱلَّذِينَ كَفَرُواْ يُكَذِّبُونَ",
    translation: "But those who have disbelieved deny",
    normalizedText: "بل الذين كفروا يكذبون",
  },
  {
    verseId: 22,
    name: "الإنشقاق",
    surahId: 84,
    text: "وَٱللَّهُ أَعۡلَمُ بِمَا يُوعُونَ",
    translation:
      "And Allah is most knowing of what they keep within themselves",
    normalizedText: "والله اعلم بما يوعون",
  },
  {
    verseId: 23,
    name: "الإنشقاق",
    surahId: 84,
    text: "فَبَشِّرۡهُم بِعَذَابٍ أَلِيمٍ",
    translation: "So give them tidings of a painful punishment",
    normalizedText: "فبشرهم بعذاب اليم",
  },
  {
    verseId: 24,
    name: "الإنشقاق",
    surahId: 84,
    text: "إِلَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَهُمۡ أَجۡرٌ غَيۡرُ مَمۡنُونِۭ",
    translation:
      "Except for those who believe and do righteous deeds. For them is a reward uninterrupted",
    normalizedText: "الا الذين ءامنوا وعملوا الصلحت لهم اجر غير ممنون",
  },
  {
    verseId: 0,
    name: "البروج",
    surahId: 85,
    text: "وَٱلسَّمَآءِ ذَاتِ ٱلۡبُرُوجِ",
    translation: "By the sky containing great stars",
    normalizedText: "والسماء ذات البروج",
  },
  {
    verseId: 1,
    name: "البروج",
    surahId: 85,
    text: "وَٱلۡيَوۡمِ ٱلۡمَوۡعُودِ",
    translation: "And [by] the promised Day",
    normalizedText: "واليوم الموعود",
  },
  {
    verseId: 2,
    name: "البروج",
    surahId: 85,
    text: "وَشَاهِدٖ وَمَشۡهُودٖ",
    translation: "And [by] the witness and what is witnessed",
    normalizedText: "وشاهد ومشهود",
  },
  {
    verseId: 3,
    name: "البروج",
    surahId: 85,
    text: "قُتِلَ أَصۡحَٰبُ ٱلۡأُخۡدُودِ",
    translation: "Cursed were the companions of the trench",
    normalizedText: "قتل اصحب الاخدود",
  },
  {
    verseId: 4,
    name: "البروج",
    surahId: 85,
    text: "ٱلنَّارِ ذَاتِ ٱلۡوَقُودِ",
    translation: "[Containing] the fire full of fuel",
    normalizedText: "النار ذات الوقود",
  },
  {
    verseId: 5,
    name: "البروج",
    surahId: 85,
    text: "إِذۡ هُمۡ عَلَيۡهَا قُعُودٞ",
    translation: "When they were sitting near it",
    normalizedText: "اذ هم عليها قعود",
  },
  {
    verseId: 6,
    name: "البروج",
    surahId: 85,
    text: "وَهُمۡ عَلَىٰ مَا يَفۡعَلُونَ بِٱلۡمُؤۡمِنِينَ شُهُودٞ",
    translation:
      "And they, to what they were doing against the believers, were witnesses",
    normalizedText: "وهم على ما يفعلون بالمامنين شهود",
  },
  {
    verseId: 7,
    name: "البروج",
    surahId: 85,
    text: "وَمَا نَقَمُواْ مِنۡهُمۡ إِلَّآ أَن يُؤۡمِنُواْ بِٱللَّهِ ٱلۡعَزِيزِ ٱلۡحَمِيدِ",
    translation:
      "And they resented them not except because they believed in Allah, the Exalted in Might, the Praiseworthy",
    normalizedText: "وما نقموا منهم الا ان يامنوا بالله العزيز الحميد",
  },
  {
    verseId: 8,
    name: "البروج",
    surahId: 85,
    text: "ٱلَّذِي لَهُۥ مُلۡكُ ٱلسَّمَٰوَٰتِ وَٱلۡأَرۡضِۚ وَٱللَّهُ عَلَىٰ كُلِّ شَيۡءٖ شَهِيدٌ",
    translation:
      "To whom belongs the dominion of the heavens and the earth. And Allah, over all things, is Witness",
    normalizedText: "الذي له ملك السموت والارض والله على كل شيء شهيد",
  },
  {
    verseId: 9,
    name: "البروج",
    surahId: 85,
    text: "إِنَّ ٱلَّذِينَ فَتَنُواْ ٱلۡمُؤۡمِنِينَ وَٱلۡمُؤۡمِنَٰتِ ثُمَّ لَمۡ يَتُوبُواْ فَلَهُمۡ عَذَابُ جَهَنَّمَ وَلَهُمۡ عَذَابُ ٱلۡحَرِيقِ",
    translation:
      "Indeed, those who have tortured the believing men and believing women and then have not repented will have the punishment of Hell, and they will have the punishment of the Burning Fire",
    normalizedText:
      "ان الذين فتنوا المامنين والمامنت ثم لم يتوبوا فلهم عذاب جهنم ولهم عذاب الحريق",
  },
  {
    verseId: 10,
    name: "البروج",
    surahId: 85,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ لَهُمۡ جَنَّـٰتٞ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُۚ ذَٰلِكَ ٱلۡفَوۡزُ ٱلۡكَبِيرُ",
    translation:
      "Indeed, those who have believed and done righteous deeds will have gardens beneath which rivers flow. That is the great attainment",
    normalizedText:
      "ان الذين ءامنوا وعملوا الصلحت لهم جنت تجري من تحتها الانهر ذلك الفوز الكبير",
  },
  {
    verseId: 11,
    name: "البروج",
    surahId: 85,
    text: "إِنَّ بَطۡشَ رَبِّكَ لَشَدِيدٌ",
    translation: "Indeed, the vengeance of your Lord is severe",
    normalizedText: "ان بطش ربك لشديد",
  },
  {
    verseId: 12,
    name: "البروج",
    surahId: 85,
    text: "إِنَّهُۥ هُوَ يُبۡدِئُ وَيُعِيدُ",
    translation: "Indeed, it is He who originates [creation] and repeats",
    normalizedText: "انه هو يبدا ويعيد",
  },
  {
    verseId: 13,
    name: "البروج",
    surahId: 85,
    text: "وَهُوَ ٱلۡغَفُورُ ٱلۡوَدُودُ",
    translation: "And He is the Forgiving, the Affectionate",
    normalizedText: "وهو الغفور الودود",
  },
  {
    verseId: 14,
    name: "البروج",
    surahId: 85,
    text: "ذُو ٱلۡعَرۡشِ ٱلۡمَجِيدُ",
    translation: "Honorable Owner of the Throne",
    normalizedText: "ذو العرش المجيد",
  },
  {
    verseId: 15,
    name: "البروج",
    surahId: 85,
    text: "فَعَّالٞ لِّمَا يُرِيدُ",
    translation: "Effecter of what He intends",
    normalizedText: "فعال لما يريد",
  },
  {
    verseId: 16,
    name: "البروج",
    surahId: 85,
    text: "هَلۡ أَتَىٰكَ حَدِيثُ ٱلۡجُنُودِ",
    translation: "Has there reached you the story of the soldiers",
    normalizedText: "هل اتىك حديث الجنود",
  },
  {
    verseId: 17,
    name: "البروج",
    surahId: 85,
    text: "فِرۡعَوۡنَ وَثَمُودَ",
    translation: "[Those of] Pharaoh and Thamud",
    normalizedText: "فرعون وثمود",
  },
  {
    verseId: 18,
    name: "البروج",
    surahId: 85,
    text: "بَلِ ٱلَّذِينَ كَفَرُواْ فِي تَكۡذِيبٖ",
    translation: "But they who disbelieve are in [persistent] denial",
    normalizedText: "بل الذين كفروا في تكذيب",
  },
  {
    verseId: 19,
    name: "البروج",
    surahId: 85,
    text: "وَٱللَّهُ مِن وَرَآئِهِم مُّحِيطُۢ",
    translation: "While Allah encompasses them from behind",
    normalizedText: "والله من ورااهم محيط",
  },
  {
    verseId: 20,
    name: "البروج",
    surahId: 85,
    text: "بَلۡ هُوَ قُرۡءَانٞ مَّجِيدٞ",
    translation: "But this is an honored Qur'an",
    normalizedText: "بل هو قرءان مجيد",
  },
  {
    verseId: 21,
    name: "البروج",
    surahId: 85,
    text: "فِي لَوۡحٖ مَّحۡفُوظِۭ",
    translation: "[Inscribed] in a Preserved Slate",
    normalizedText: "في لوح محفوظ",
  },
  {
    verseId: 0,
    name: "الطارق",
    surahId: 86,
    text: "وَٱلسَّمَآءِ وَٱلطَّارِقِ",
    translation: "By the sky and the night comer",
    normalizedText: "والسماء والطارق",
  },
  {
    verseId: 1,
    name: "الطارق",
    surahId: 86,
    text: "وَمَآ أَدۡرَىٰكَ مَا ٱلطَّارِقُ",
    translation: "And what can make you know what is the night comer",
    normalizedText: "وما ادرىك ما الطارق",
  },
  {
    verseId: 2,
    name: "الطارق",
    surahId: 86,
    text: "ٱلنَّجۡمُ ٱلثَّاقِبُ",
    translation: "It is the piercing star",
    normalizedText: "النجم الثاقب",
  },
  {
    verseId: 3,
    name: "الطارق",
    surahId: 86,
    text: "إِن كُلُّ نَفۡسٖ لَّمَّا عَلَيۡهَا حَافِظٞ",
    translation: "There is no soul but that it has over it a protector",
    normalizedText: "ان كل نفس لما عليها حافظ",
  },
  {
    verseId: 4,
    name: "الطارق",
    surahId: 86,
    text: "فَلۡيَنظُرِ ٱلۡإِنسَٰنُ مِمَّ خُلِقَ",
    translation: "So let man observe from what he was created",
    normalizedText: "فلينظر الانسن مم خلق",
  },
  {
    verseId: 5,
    name: "الطارق",
    surahId: 86,
    text: "خُلِقَ مِن مَّآءٖ دَافِقٖ",
    translation: "He was created from a fluid, ejected",
    normalizedText: "خلق من ماء دافق",
  },
  {
    verseId: 6,
    name: "الطارق",
    surahId: 86,
    text: "يَخۡرُجُ مِنۢ بَيۡنِ ٱلصُّلۡبِ وَٱلتَّرَآئِبِ",
    translation: "Emerging from between the backbone and the ribs",
    normalizedText: "يخرج من بين الصلب والترااب",
  },
  {
    verseId: 7,
    name: "الطارق",
    surahId: 86,
    text: "إِنَّهُۥ عَلَىٰ رَجۡعِهِۦ لَقَادِرٞ",
    translation: "Indeed, Allah, to return him [to life], is Able",
    normalizedText: "انه على رجعه لقادر",
  },
  {
    verseId: 8,
    name: "الطارق",
    surahId: 86,
    text: "يَوۡمَ تُبۡلَى ٱلسَّرَآئِرُ",
    translation: "The Day when secrets will be put on trial",
    normalizedText: "يوم تبلى السراار",
  },
  {
    verseId: 9,
    name: "الطارق",
    surahId: 86,
    text: "فَمَا لَهُۥ مِن قُوَّةٖ وَلَا نَاصِرٖ",
    translation: "Then man will have no power or any helper",
    normalizedText: "فما له من قوة ولا ناصر",
  },
  {
    verseId: 10,
    name: "الطارق",
    surahId: 86,
    text: "وَٱلسَّمَآءِ ذَاتِ ٱلرَّجۡعِ",
    translation: "By the sky which returns [rain]",
    normalizedText: "والسماء ذات الرجع",
  },
  {
    verseId: 11,
    name: "الطارق",
    surahId: 86,
    text: "وَٱلۡأَرۡضِ ذَاتِ ٱلصَّدۡعِ",
    translation: "And [by] the earth which cracks open",
    normalizedText: "والارض ذات الصدع",
  },
  {
    verseId: 12,
    name: "الطارق",
    surahId: 86,
    text: "إِنَّهُۥ لَقَوۡلٞ فَصۡلٞ",
    translation: "Indeed, the Qur'an is a decisive statement",
    normalizedText: "انه لقول فصل",
  },
  {
    verseId: 13,
    name: "الطارق",
    surahId: 86,
    text: "وَمَا هُوَ بِٱلۡهَزۡلِ",
    translation: "And it is not amusement",
    normalizedText: "وما هو بالهزل",
  },
  {
    verseId: 14,
    name: "الطارق",
    surahId: 86,
    text: "إِنَّهُمۡ يَكِيدُونَ كَيۡدٗا",
    translation: "Indeed, they are planning a plan",
    normalizedText: "انهم يكيدون كيدا",
  },
  {
    verseId: 15,
    name: "الطارق",
    surahId: 86,
    text: "وَأَكِيدُ كَيۡدٗا",
    translation: "But I am planning a plan",
    normalizedText: "واكيد كيدا",
  },
  {
    verseId: 16,
    name: "الطارق",
    surahId: 86,
    text: "فَمَهِّلِ ٱلۡكَٰفِرِينَ أَمۡهِلۡهُمۡ رُوَيۡدَۢا",
    translation: "So allow time for the disbelievers. Leave them awhile",
    normalizedText: "فمهل الكفرين امهلهم رويدا",
  },
  {
    verseId: 0,
    name: "الأعلى",
    surahId: 87,
    text: "سَبِّحِ ٱسۡمَ رَبِّكَ ٱلۡأَعۡلَى",
    translation: "Exalt the name of your Lord, the Most High",
    normalizedText: "سبح اسم ربك الاعلى",
  },
  {
    verseId: 1,
    name: "الأعلى",
    surahId: 87,
    text: "ٱلَّذِي خَلَقَ فَسَوَّىٰ",
    translation: "Who created and proportioned",
    normalizedText: "الذي خلق فسوى",
  },
  {
    verseId: 2,
    name: "الأعلى",
    surahId: 87,
    text: "وَٱلَّذِي قَدَّرَ فَهَدَىٰ",
    translation: "And who destined and [then] guided",
    normalizedText: "والذي قدر فهدى",
  },
  {
    verseId: 3,
    name: "الأعلى",
    surahId: 87,
    text: "وَٱلَّذِيٓ أَخۡرَجَ ٱلۡمَرۡعَىٰ",
    translation: "And who brings out the pasture",
    normalizedText: "والذي اخرج المرعى",
  },
  {
    verseId: 4,
    name: "الأعلى",
    surahId: 87,
    text: "فَجَعَلَهُۥ غُثَآءً أَحۡوَىٰ",
    translation: "And [then] makes it black stubble",
    normalizedText: "فجعله غثاء احوى",
  },
  {
    verseId: 5,
    name: "الأعلى",
    surahId: 87,
    text: "سَنُقۡرِئُكَ فَلَا تَنسَىٰٓ",
    translation:
      "We will make you recite, [O Muhammad], and you will not forget",
    normalizedText: "سنقراك فلا تنسى",
  },
  {
    verseId: 6,
    name: "الأعلى",
    surahId: 87,
    text: "إِلَّا مَا شَآءَ ٱللَّهُۚ إِنَّهُۥ يَعۡلَمُ ٱلۡجَهۡرَ وَمَا يَخۡفَىٰ",
    translation:
      "Except what Allah should will. Indeed, He knows what is declared and what is hidden",
    normalizedText: "الا ما شاء الله انه يعلم الجهر وما يخفى",
  },
  {
    verseId: 7,
    name: "الأعلى",
    surahId: 87,
    text: "وَنُيَسِّرُكَ لِلۡيُسۡرَىٰ",
    translation: "And We will ease you toward ease",
    normalizedText: "ونيسرك لليسرى",
  },
  {
    verseId: 8,
    name: "الأعلى",
    surahId: 87,
    text: "فَذَكِّرۡ إِن نَّفَعَتِ ٱلذِّكۡرَىٰ",
    translation: "So remind, if the reminder should benefit",
    normalizedText: "فذكر ان نفعت الذكرى",
  },
  {
    verseId: 9,
    name: "الأعلى",
    surahId: 87,
    text: "سَيَذَّكَّرُ مَن يَخۡشَىٰ",
    translation: "He who fears [Allah] will be reminded",
    normalizedText: "سيذكر من يخشى",
  },
  {
    verseId: 10,
    name: "الأعلى",
    surahId: 87,
    text: "وَيَتَجَنَّبُهَا ٱلۡأَشۡقَى",
    translation: "But the wretched one will avoid it",
    normalizedText: "ويتجنبها الاشقى",
  },
  {
    verseId: 11,
    name: "الأعلى",
    surahId: 87,
    text: "ٱلَّذِي يَصۡلَى ٱلنَّارَ ٱلۡكُبۡرَىٰ",
    translation: "[He] who will [enter and] burn in the greatest Fire",
    normalizedText: "الذي يصلى النار الكبرى",
  },
  {
    verseId: 12,
    name: "الأعلى",
    surahId: 87,
    text: "ثُمَّ لَا يَمُوتُ فِيهَا وَلَا يَحۡيَىٰ",
    translation: "Neither dying therein nor living",
    normalizedText: "ثم لا يموت فيها ولا يحيى",
  },
  {
    verseId: 13,
    name: "الأعلى",
    surahId: 87,
    text: "قَدۡ أَفۡلَحَ مَن تَزَكَّىٰ",
    translation: "He has certainly succeeded who purifies himself",
    normalizedText: "قد افلح من تزكى",
  },
  {
    verseId: 14,
    name: "الأعلى",
    surahId: 87,
    text: "وَذَكَرَ ٱسۡمَ رَبِّهِۦ فَصَلَّىٰ",
    translation: "And mentions the name of his Lord and prays",
    normalizedText: "وذكر اسم ربه فصلى",
  },
  {
    verseId: 15,
    name: "الأعلى",
    surahId: 87,
    text: "بَلۡ تُؤۡثِرُونَ ٱلۡحَيَوٰةَ ٱلدُّنۡيَا",
    translation: "But you prefer the worldly life",
    normalizedText: "بل تاثرون الحيوة الدنيا",
  },
  {
    verseId: 16,
    name: "الأعلى",
    surahId: 87,
    text: "وَٱلۡأٓخِرَةُ خَيۡرٞ وَأَبۡقَىٰٓ",
    translation: "While the Hereafter is better and more enduring",
    normalizedText: "والاخرة خير وابقى",
  },
  {
    verseId: 17,
    name: "الأعلى",
    surahId: 87,
    text: "إِنَّ هَٰذَا لَفِي ٱلصُّحُفِ ٱلۡأُولَىٰ",
    translation: "Indeed, this is in the former scriptures",
    normalizedText: "ان هذا لفي الصحف الاولى",
  },
  {
    verseId: 18,
    name: "الأعلى",
    surahId: 87,
    text: "صُحُفِ إِبۡرَٰهِيمَ وَمُوسَىٰ",
    translation: "The scriptures of Abraham and Moses",
    normalizedText: "صحف ابرهيم وموسى",
  },
  {
    verseId: 0,
    name: "الغاشية",
    surahId: 88,
    text: "هَلۡ أَتَىٰكَ حَدِيثُ ٱلۡغَٰشِيَةِ",
    translation: "Has there reached you the report of the Overwhelming [event]",
    normalizedText: "هل اتىك حديث الغشية",
  },
  {
    verseId: 1,
    name: "الغاشية",
    surahId: 88,
    text: "وُجُوهٞ يَوۡمَئِذٍ خَٰشِعَةٌ",
    translation: "[Some] faces, that Day, will be humbled",
    normalizedText: "وجوه يوماذ خشعة",
  },
  {
    verseId: 2,
    name: "الغاشية",
    surahId: 88,
    text: "عَامِلَةٞ نَّاصِبَةٞ",
    translation: "Working [hard] and exhausted",
    normalizedText: "عاملة ناصبة",
  },
  {
    verseId: 3,
    name: "الغاشية",
    surahId: 88,
    text: "تَصۡلَىٰ نَارًا حَامِيَةٗ",
    translation: "They will [enter to] burn in an intensely hot Fire",
    normalizedText: "تصلى نارا حامية",
  },
  {
    verseId: 4,
    name: "الغاشية",
    surahId: 88,
    text: "تُسۡقَىٰ مِنۡ عَيۡنٍ ءَانِيَةٖ",
    translation: "They will be given drink from a boiling spring",
    normalizedText: "تسقى من عين ءانية",
  },
  {
    verseId: 5,
    name: "الغاشية",
    surahId: 88,
    text: "لَّيۡسَ لَهُمۡ طَعَامٌ إِلَّا مِن ضَرِيعٖ",
    translation:
      "For them there will be no food except from a poisonous, thorny plant",
    normalizedText: "ليس لهم طعام الا من ضريع",
  },
  {
    verseId: 6,
    name: "الغاشية",
    surahId: 88,
    text: "لَّا يُسۡمِنُ وَلَا يُغۡنِي مِن جُوعٖ",
    translation: "Which neither nourishes nor avails against hunger",
    normalizedText: "لا يسمن ولا يغني من جوع",
  },
  {
    verseId: 7,
    name: "الغاشية",
    surahId: 88,
    text: "وُجُوهٞ يَوۡمَئِذٖ نَّاعِمَةٞ",
    translation: "[Other] faces, that Day, will show pleasure",
    normalizedText: "وجوه يوماذ ناعمة",
  },
  {
    verseId: 8,
    name: "الغاشية",
    surahId: 88,
    text: "لِّسَعۡيِهَا رَاضِيَةٞ",
    translation: "With their effort [they are] satisfied",
    normalizedText: "لسعيها راضية",
  },
  {
    verseId: 9,
    name: "الغاشية",
    surahId: 88,
    text: "فِي جَنَّةٍ عَالِيَةٖ",
    translation: "In an elevated garden",
    normalizedText: "في جنة عالية",
  },
  {
    verseId: 10,
    name: "الغاشية",
    surahId: 88,
    text: "لَّا تَسۡمَعُ فِيهَا لَٰغِيَةٗ",
    translation: "Wherein they will hear no unsuitable speech",
    normalizedText: "لا تسمع فيها لغية",
  },
  {
    verseId: 11,
    name: "الغاشية",
    surahId: 88,
    text: "فِيهَا عَيۡنٞ جَارِيَةٞ",
    translation: "Within it is a flowing spring",
    normalizedText: "فيها عين جارية",
  },
  {
    verseId: 12,
    name: "الغاشية",
    surahId: 88,
    text: "فِيهَا سُرُرٞ مَّرۡفُوعَةٞ",
    translation: "Within it are couches raised high",
    normalizedText: "فيها سرر مرفوعة",
  },
  {
    verseId: 13,
    name: "الغاشية",
    surahId: 88,
    text: "وَأَكۡوَابٞ مَّوۡضُوعَةٞ",
    translation: "And cups put in place",
    normalizedText: "واكواب موضوعة",
  },
  {
    verseId: 14,
    name: "الغاشية",
    surahId: 88,
    text: "وَنَمَارِقُ مَصۡفُوفَةٞ",
    translation: "And cushions lined up",
    normalizedText: "ونمارق مصفوفة",
  },
  {
    verseId: 15,
    name: "الغاشية",
    surahId: 88,
    text: "وَزَرَابِيُّ مَبۡثُوثَةٌ",
    translation: "And carpets spread around",
    normalizedText: "وزرابي مبثوثة",
  },
  {
    verseId: 16,
    name: "الغاشية",
    surahId: 88,
    text: "أَفَلَا يَنظُرُونَ إِلَى ٱلۡإِبِلِ كَيۡفَ خُلِقَتۡ",
    translation: "Then do they not look at the camels - how they are created",
    normalizedText: "افلا ينظرون الى الابل كيف خلقت",
  },
  {
    verseId: 17,
    name: "الغاشية",
    surahId: 88,
    text: "وَإِلَى ٱلسَّمَآءِ كَيۡفَ رُفِعَتۡ",
    translation: "And at the sky - how it is raised",
    normalizedText: "والى السماء كيف رفعت",
  },
  {
    verseId: 18,
    name: "الغاشية",
    surahId: 88,
    text: "وَإِلَى ٱلۡجِبَالِ كَيۡفَ نُصِبَتۡ",
    translation: "And at the mountains - how they are erected",
    normalizedText: "والى الجبال كيف نصبت",
  },
  {
    verseId: 19,
    name: "الغاشية",
    surahId: 88,
    text: "وَإِلَى ٱلۡأَرۡضِ كَيۡفَ سُطِحَتۡ",
    translation: "And at the earth - how it is spread out",
    normalizedText: "والى الارض كيف سطحت",
  },
  {
    verseId: 20,
    name: "الغاشية",
    surahId: 88,
    text: "فَذَكِّرۡ إِنَّمَآ أَنتَ مُذَكِّرٞ",
    translation: "So remind, [O Muhammad]; you are only a reminder",
    normalizedText: "فذكر انما انت مذكر",
  },
  {
    verseId: 21,
    name: "الغاشية",
    surahId: 88,
    text: "لَّسۡتَ عَلَيۡهِم بِمُصَيۡطِرٍ",
    translation: "You are not over them a controller",
    normalizedText: "لست عليهم بمصيطر",
  },
  {
    verseId: 22,
    name: "الغاشية",
    surahId: 88,
    text: "إِلَّا مَن تَوَلَّىٰ وَكَفَرَ",
    translation: "However, he who turns away and disbelieves",
    normalizedText: "الا من تولى وكفر",
  },
  {
    verseId: 23,
    name: "الغاشية",
    surahId: 88,
    text: "فَيُعَذِّبُهُ ٱللَّهُ ٱلۡعَذَابَ ٱلۡأَكۡبَرَ",
    translation: "Then Allah will punish him with the greatest punishment",
    normalizedText: "فيعذبه الله العذاب الاكبر",
  },
  {
    verseId: 24,
    name: "الغاشية",
    surahId: 88,
    text: "إِنَّ إِلَيۡنَآ إِيَابَهُمۡ",
    translation: "Indeed, to Us is their return",
    normalizedText: "ان الينا ايابهم",
  },
  {
    verseId: 25,
    name: "الغاشية",
    surahId: 88,
    text: "ثُمَّ إِنَّ عَلَيۡنَا حِسَابَهُم",
    translation: "Then indeed, upon Us is their account",
    normalizedText: "ثم ان علينا حسابهم",
  },
  {
    verseId: 0,
    name: "الفجر",
    surahId: 89,
    text: "وَٱلۡفَجۡرِ",
    translation: "By the dawn",
    normalizedText: "والفجر",
  },
  {
    verseId: 1,
    name: "الفجر",
    surahId: 89,
    text: "وَلَيَالٍ عَشۡرٖ",
    translation: "And [by] ten nights",
    normalizedText: "وليال عشر",
  },
  {
    verseId: 2,
    name: "الفجر",
    surahId: 89,
    text: "وَٱلشَّفۡعِ وَٱلۡوَتۡرِ",
    translation: "And [by] the even [number] and the odd",
    normalizedText: "والشفع والوتر",
  },
  {
    verseId: 3,
    name: "الفجر",
    surahId: 89,
    text: "وَٱلَّيۡلِ إِذَا يَسۡرِ",
    translation: "And [by] the night when it passes",
    normalizedText: "واليل اذا يسر",
  },
  {
    verseId: 4,
    name: "الفجر",
    surahId: 89,
    text: "هَلۡ فِي ذَٰلِكَ قَسَمٞ لِّذِي حِجۡرٍ",
    translation:
      "Is there [not] in [all] that an oath [sufficient] for one of perception",
    normalizedText: "هل في ذلك قسم لذي حجر",
  },
  {
    verseId: 5,
    name: "الفجر",
    surahId: 89,
    text: "أَلَمۡ تَرَ كَيۡفَ فَعَلَ رَبُّكَ بِعَادٍ",
    translation: "Have you not considered how your Lord dealt with 'Aad",
    normalizedText: "الم تر كيف فعل ربك بعاد",
  },
  {
    verseId: 6,
    name: "الفجر",
    surahId: 89,
    text: "إِرَمَ ذَاتِ ٱلۡعِمَادِ",
    translation: "[With] Iram - who had lofty pillars",
    normalizedText: "ارم ذات العماد",
  },
  {
    verseId: 7,
    name: "الفجر",
    surahId: 89,
    text: "ٱلَّتِي لَمۡ يُخۡلَقۡ مِثۡلُهَا فِي ٱلۡبِلَٰدِ",
    translation: "The likes of whom had never been created in the land",
    normalizedText: "التي لم يخلق مثلها في البلد",
  },
  {
    verseId: 8,
    name: "الفجر",
    surahId: 89,
    text: "وَثَمُودَ ٱلَّذِينَ جَابُواْ ٱلصَّخۡرَ بِٱلۡوَادِ",
    translation: "And [with] Thamud, who carved out the rocks in the valley",
    normalizedText: "وثمود الذين جابوا الصخر بالواد",
  },
  {
    verseId: 9,
    name: "الفجر",
    surahId: 89,
    text: "وَفِرۡعَوۡنَ ذِي ٱلۡأَوۡتَادِ",
    translation: "And [with] Pharaoh, owner of the stakes",
    normalizedText: "وفرعون ذي الاوتاد",
  },
  {
    verseId: 10,
    name: "الفجر",
    surahId: 89,
    text: "ٱلَّذِينَ طَغَوۡاْ فِي ٱلۡبِلَٰدِ",
    translation: "[All of] whom oppressed within the lands",
    normalizedText: "الذين طغوا في البلد",
  },
  {
    verseId: 11,
    name: "الفجر",
    surahId: 89,
    text: "فَأَكۡثَرُواْ فِيهَا ٱلۡفَسَادَ",
    translation: "And increased therein the corruption",
    normalizedText: "فاكثروا فيها الفساد",
  },
  {
    verseId: 12,
    name: "الفجر",
    surahId: 89,
    text: "فَصَبَّ عَلَيۡهِمۡ رَبُّكَ سَوۡطَ عَذَابٍ",
    translation: "So your Lord poured upon them a scourge of punishment",
    normalizedText: "فصب عليهم ربك سوط عذاب",
  },
  {
    verseId: 13,
    name: "الفجر",
    surahId: 89,
    text: "إِنَّ رَبَّكَ لَبِٱلۡمِرۡصَادِ",
    translation: "Indeed, your Lord is in observation",
    normalizedText: "ان ربك لبالمرصاد",
  },
  {
    verseId: 14,
    name: "الفجر",
    surahId: 89,
    text: "فَأَمَّا ٱلۡإِنسَٰنُ إِذَا مَا ٱبۡتَلَىٰهُ رَبُّهُۥ فَأَكۡرَمَهُۥ وَنَعَّمَهُۥ فَيَقُولُ رَبِّيٓ أَكۡرَمَنِ",
    translation:
      'And as for man, when his Lord tries him and [thus] is generous to him and favors him, he says, "My Lord has honored me',
    normalizedText:
      "فاما الانسن اذا ما ابتلىه ربه فاكرمه ونعمه فيقول ربي اكرمن",
  },
  {
    verseId: 15,
    name: "الفجر",
    surahId: 89,
    text: "وَأَمَّآ إِذَا مَا ٱبۡتَلَىٰهُ فَقَدَرَ عَلَيۡهِ رِزۡقَهُۥ فَيَقُولُ رَبِّيٓ أَهَٰنَنِ",
    translation:
      'But when He tries him and restricts his provision, he says, "My Lord has humiliated me',
    normalizedText: "واما اذا ما ابتلىه فقدر عليه رزقه فيقول ربي اهنن",
  },
  {
    verseId: 16,
    name: "الفجر",
    surahId: 89,
    text: "كَلَّاۖ بَل لَّا تُكۡرِمُونَ ٱلۡيَتِيمَ",
    translation: "No! But you do not honor the orphan",
    normalizedText: "كلا بل لا تكرمون اليتيم",
  },
  {
    verseId: 17,
    name: "الفجر",
    surahId: 89,
    text: "وَلَا تَحَـٰٓضُّونَ عَلَىٰ طَعَامِ ٱلۡمِسۡكِينِ",
    translation: "And you do not encourage one another to feed the poor",
    normalizedText: "ولا تحضون على طعام المسكين",
  },
  {
    verseId: 18,
    name: "الفجر",
    surahId: 89,
    text: "وَتَأۡكُلُونَ ٱلتُّرَاثَ أَكۡلٗا لَّمّٗا",
    translation: "And you consume inheritance, devouring [it] altogether",
    normalizedText: "وتاكلون التراث اكلا لما",
  },
  {
    verseId: 19,
    name: "الفجر",
    surahId: 89,
    text: "وَتُحِبُّونَ ٱلۡمَالَ حُبّٗا جَمّٗا",
    translation: "And you love wealth with immense love",
    normalizedText: "وتحبون المال حبا جما",
  },
  {
    verseId: 20,
    name: "الفجر",
    surahId: 89,
    text: "كَلَّآۖ إِذَا دُكَّتِ ٱلۡأَرۡضُ دَكّٗا دَكّٗا",
    translation: "No! When the earth has been leveled - pounded and crushed",
    normalizedText: "كلا اذا دكت الارض دكا دكا",
  },
  {
    verseId: 21,
    name: "الفجر",
    surahId: 89,
    text: "وَجَآءَ رَبُّكَ وَٱلۡمَلَكُ صَفّٗا صَفّٗا",
    translation: "And your Lord has come and the angels, rank upon rank",
    normalizedText: "وجاء ربك والملك صفا صفا",
  },
  {
    verseId: 22,
    name: "الفجر",
    surahId: 89,
    text: "وَجِاْيٓءَ يَوۡمَئِذِۭ بِجَهَنَّمَۚ يَوۡمَئِذٖ يَتَذَكَّرُ ٱلۡإِنسَٰنُ وَأَنَّىٰ لَهُ ٱلذِّكۡرَىٰ",
    translation:
      "And brought [within view], that Day, is Hell - that Day, man will remember, but what good to him will be the remembrance",
    normalizedText: "وجايء يوماذ بجهنم يوماذ يتذكر الانسن وانى له الذكرى",
  },
  {
    verseId: 23,
    name: "الفجر",
    surahId: 89,
    text: "يَقُولُ يَٰلَيۡتَنِي قَدَّمۡتُ لِحَيَاتِي",
    translation:
      'He will say, "Oh, I wish I had sent ahead [some good] for my life',
    normalizedText: "يقول يليتني قدمت لحياتي",
  },
  {
    verseId: 24,
    name: "الفجر",
    surahId: 89,
    text: "فَيَوۡمَئِذٖ لَّا يُعَذِّبُ عَذَابَهُۥٓ أَحَدٞ",
    translation:
      "So on that Day, none will punish [as severely] as His punishment",
    normalizedText: "فيوماذ لا يعذب عذابه احد",
  },
  {
    verseId: 25,
    name: "الفجر",
    surahId: 89,
    text: "وَلَا يُوثِقُ وَثَاقَهُۥٓ أَحَدٞ",
    translation:
      "And none will bind [as severely] as His binding [of the evildoers]",
    normalizedText: "ولا يوثق وثاقه احد",
  },
  {
    verseId: 26,
    name: "الفجر",
    surahId: 89,
    text: "يَـٰٓأَيَّتُهَا ٱلنَّفۡسُ ٱلۡمُطۡمَئِنَّةُ",
    translation: '[To the righteous it will be said], "O reassured soul',
    normalizedText: "يايتها النفس المطمانة",
  },
  {
    verseId: 27,
    name: "الفجر",
    surahId: 89,
    text: "ٱرۡجِعِيٓ إِلَىٰ رَبِّكِ رَاضِيَةٗ مَّرۡضِيَّةٗ",
    translation: "Return to your Lord, well-pleased and pleasing [to Him]",
    normalizedText: "ارجعي الى ربك راضية مرضية",
  },
  {
    verseId: 28,
    name: "الفجر",
    surahId: 89,
    text: "فَٱدۡخُلِي فِي عِبَٰدِي",
    translation: "And enter among My [righteous] servants",
    normalizedText: "فادخلي في عبدي",
  },
  {
    verseId: 29,
    name: "الفجر",
    surahId: 89,
    text: "وَٱدۡخُلِي جَنَّتِي",
    translation: "And enter My Paradise",
    normalizedText: "وادخلي جنتي",
  },
  {
    verseId: 0,
    name: "البلد",
    surahId: 90,
    text: "لَآ أُقۡسِمُ بِهَٰذَا ٱلۡبَلَدِ",
    translation: "I swear by this city, Makkah",
    normalizedText: "لا اقسم بهذا البلد",
  },
  {
    verseId: 1,
    name: "البلد",
    surahId: 90,
    text: "وَأَنتَ حِلُّۢ بِهَٰذَا ٱلۡبَلَدِ",
    translation: "And you, [O Muhammad], are free of restriction in this city",
    normalizedText: "وانت حل بهذا البلد",
  },
  {
    verseId: 2,
    name: "البلد",
    surahId: 90,
    text: "وَوَالِدٖ وَمَا وَلَدَ",
    translation: "And [by] the father and that which was born [of him]",
    normalizedText: "ووالد وما ولد",
  },
  {
    verseId: 3,
    name: "البلد",
    surahId: 90,
    text: "لَقَدۡ خَلَقۡنَا ٱلۡإِنسَٰنَ فِي كَبَدٍ",
    translation: "We have certainly created man into hardship",
    normalizedText: "لقد خلقنا الانسن في كبد",
  },
  {
    verseId: 4,
    name: "البلد",
    surahId: 90,
    text: "أَيَحۡسَبُ أَن لَّن يَقۡدِرَ عَلَيۡهِ أَحَدٞ",
    translation: "Does he think that never will anyone overcome him",
    normalizedText: "ايحسب ان لن يقدر عليه احد",
  },
  {
    verseId: 5,
    name: "البلد",
    surahId: 90,
    text: "يَقُولُ أَهۡلَكۡتُ مَالٗا لُّبَدًا",
    translation: 'He says, "I have spent wealth in abundance',
    normalizedText: "يقول اهلكت مالا لبدا",
  },
  {
    verseId: 6,
    name: "البلد",
    surahId: 90,
    text: "أَيَحۡسَبُ أَن لَّمۡ يَرَهُۥٓ أَحَدٌ",
    translation: "Does he think that no one has seen him",
    normalizedText: "ايحسب ان لم يره احد",
  },
  {
    verseId: 7,
    name: "البلد",
    surahId: 90,
    text: "أَلَمۡ نَجۡعَل لَّهُۥ عَيۡنَيۡنِ",
    translation: "Have We not made for him two eyes",
    normalizedText: "الم نجعل له عينين",
  },
  {
    verseId: 8,
    name: "البلد",
    surahId: 90,
    text: "وَلِسَانٗا وَشَفَتَيۡنِ",
    translation: "And a tongue and two lips",
    normalizedText: "ولسانا وشفتين",
  },
  {
    verseId: 9,
    name: "البلد",
    surahId: 90,
    text: "وَهَدَيۡنَٰهُ ٱلنَّجۡدَيۡنِ",
    translation: "And have shown him the two ways",
    normalizedText: "وهدينه النجدين",
  },
  {
    verseId: 10,
    name: "البلد",
    surahId: 90,
    text: "فَلَا ٱقۡتَحَمَ ٱلۡعَقَبَةَ",
    translation: "But he has not broken through the difficult pass",
    normalizedText: "فلا اقتحم العقبة",
  },
  {
    verseId: 11,
    name: "البلد",
    surahId: 90,
    text: "وَمَآ أَدۡرَىٰكَ مَا ٱلۡعَقَبَةُ",
    translation:
      "And what can make you know what is [breaking through] the difficult pass",
    normalizedText: "وما ادرىك ما العقبة",
  },
  {
    verseId: 12,
    name: "البلد",
    surahId: 90,
    text: "فَكُّ رَقَبَةٍ",
    translation: "It is the freeing of a slave",
    normalizedText: "فك رقبة",
  },
  {
    verseId: 13,
    name: "البلد",
    surahId: 90,
    text: "أَوۡ إِطۡعَٰمٞ فِي يَوۡمٖ ذِي مَسۡغَبَةٖ",
    translation: "Or feeding on a day of severe hunger",
    normalizedText: "او اطعم في يوم ذي مسغبة",
  },
  {
    verseId: 14,
    name: "البلد",
    surahId: 90,
    text: "يَتِيمٗا ذَا مَقۡرَبَةٍ",
    translation: "An orphan of near relationship",
    normalizedText: "يتيما ذا مقربة",
  },
  {
    verseId: 15,
    name: "البلد",
    surahId: 90,
    text: "أَوۡ مِسۡكِينٗا ذَا مَتۡرَبَةٖ",
    translation: "Or a needy person in misery",
    normalizedText: "او مسكينا ذا متربة",
  },
  {
    verseId: 16,
    name: "البلد",
    surahId: 90,
    text: "ثُمَّ كَانَ مِنَ ٱلَّذِينَ ءَامَنُواْ وَتَوَاصَوۡاْ بِٱلصَّبۡرِ وَتَوَاصَوۡاْ بِٱلۡمَرۡحَمَةِ",
    translation:
      "And then being among those who believed and advised one another to patience and advised one another to compassion",
    normalizedText: "ثم كان من الذين ءامنوا وتواصوا بالصبر وتواصوا بالمرحمة",
  },
  {
    verseId: 17,
    name: "البلد",
    surahId: 90,
    text: "أُوْلَـٰٓئِكَ أَصۡحَٰبُ ٱلۡمَيۡمَنَةِ",
    translation: "Those are the companions of the right",
    normalizedText: "اولاك اصحب الميمنة",
  },
  {
    verseId: 18,
    name: "البلد",
    surahId: 90,
    text: "وَٱلَّذِينَ كَفَرُواْ بِـَٔايَٰتِنَا هُمۡ أَصۡحَٰبُ ٱلۡمَشۡـَٔمَةِ",
    translation:
      "But they who disbelieved in Our signs - those are the companions of the left",
    normalizedText: "والذين كفروا بايتنا هم اصحب المشمة",
  },
  {
    verseId: 19,
    name: "البلد",
    surahId: 90,
    text: "عَلَيۡهِمۡ نَارٞ مُّؤۡصَدَةُۢ",
    translation: "Over them will be fire closed in",
    normalizedText: "عليهم نار ماصدة",
  },
  {
    verseId: 0,
    name: "الشمس",
    surahId: 91,
    text: "وَٱلشَّمۡسِ وَضُحَىٰهَا",
    translation: "By the sun and its brightness",
    normalizedText: "والشمس وضحىها",
  },
  {
    verseId: 1,
    name: "الشمس",
    surahId: 91,
    text: "وَٱلۡقَمَرِ إِذَا تَلَىٰهَا",
    translation: "And [by] the moon when it follows it",
    normalizedText: "والقمر اذا تلىها",
  },
  {
    verseId: 2,
    name: "الشمس",
    surahId: 91,
    text: "وَٱلنَّهَارِ إِذَا جَلَّىٰهَا",
    translation: "And [by] the day when it displays it",
    normalizedText: "والنهار اذا جلىها",
  },
  {
    verseId: 3,
    name: "الشمس",
    surahId: 91,
    text: "وَٱلَّيۡلِ إِذَا يَغۡشَىٰهَا",
    translation: "And [by] the night when it covers it",
    normalizedText: "واليل اذا يغشىها",
  },
  {
    verseId: 4,
    name: "الشمس",
    surahId: 91,
    text: "وَٱلسَّمَآءِ وَمَا بَنَىٰهَا",
    translation: "And [by] the sky and He who constructed it",
    normalizedText: "والسماء وما بنىها",
  },
  {
    verseId: 5,
    name: "الشمس",
    surahId: 91,
    text: "وَٱلۡأَرۡضِ وَمَا طَحَىٰهَا",
    translation: "And [by] the earth and He who spread it",
    normalizedText: "والارض وما طحىها",
  },
  {
    verseId: 6,
    name: "الشمس",
    surahId: 91,
    text: "وَنَفۡسٖ وَمَا سَوَّىٰهَا",
    translation: "And [by] the soul and He who proportioned it",
    normalizedText: "ونفس وما سوىها",
  },
  {
    verseId: 7,
    name: "الشمس",
    surahId: 91,
    text: "فَأَلۡهَمَهَا فُجُورَهَا وَتَقۡوَىٰهَا",
    translation:
      "And inspired it [with discernment of] its wickedness and its righteousness",
    normalizedText: "فالهمها فجورها وتقوىها",
  },
  {
    verseId: 8,
    name: "الشمس",
    surahId: 91,
    text: "قَدۡ أَفۡلَحَ مَن زَكَّىٰهَا",
    translation: "He has succeeded who purifies it",
    normalizedText: "قد افلح من زكىها",
  },
  {
    verseId: 9,
    name: "الشمس",
    surahId: 91,
    text: "وَقَدۡ خَابَ مَن دَسَّىٰهَا",
    translation: "And he has failed who instills it [with corruption]",
    normalizedText: "وقد خاب من دسىها",
  },
  {
    verseId: 10,
    name: "الشمس",
    surahId: 91,
    text: "كَذَّبَتۡ ثَمُودُ بِطَغۡوَىٰهَآ",
    translation:
      "Thamud denied [their prophet] by reason of their transgression",
    normalizedText: "كذبت ثمود بطغوىها",
  },
  {
    verseId: 11,
    name: "الشمس",
    surahId: 91,
    text: "إِذِ ٱنۢبَعَثَ أَشۡقَىٰهَا",
    translation: "When the most wretched of them was sent forth",
    normalizedText: "اذ انبعث اشقىها",
  },
  {
    verseId: 12,
    name: "الشمس",
    surahId: 91,
    text: "فَقَالَ لَهُمۡ رَسُولُ ٱللَّهِ نَاقَةَ ٱللَّهِ وَسُقۡيَٰهَا",
    translation:
      'And the messenger of Allah [Salih] said to them, "[Do not harm] the she-camel of Allah or [prevent her from] her drink',
    normalizedText: "فقال لهم رسول الله ناقة الله وسقيها",
  },
  {
    verseId: 13,
    name: "الشمس",
    surahId: 91,
    text: "فَكَذَّبُوهُ فَعَقَرُوهَا فَدَمۡدَمَ عَلَيۡهِمۡ رَبُّهُم بِذَنۢبِهِمۡ فَسَوَّىٰهَا",
    translation:
      "But they denied him and hamstrung her. So their Lord brought down upon them destruction for their sin and made it equal [upon all of them]",
    normalizedText: "فكذبوه فعقروها فدمدم عليهم ربهم بذنبهم فسوىها",
  },
  {
    verseId: 14,
    name: "الشمس",
    surahId: 91,
    text: "وَلَا يَخَافُ عُقۡبَٰهَا",
    translation: "And He does not fear the consequence thereof",
    normalizedText: "ولا يخاف عقبها",
  },
  {
    verseId: 0,
    name: "الليل",
    surahId: 92,
    text: "وَٱلَّيۡلِ إِذَا يَغۡشَىٰ",
    translation: "By the night when it covers",
    normalizedText: "واليل اذا يغشى",
  },
  {
    verseId: 1,
    name: "الليل",
    surahId: 92,
    text: "وَٱلنَّهَارِ إِذَا تَجَلَّىٰ",
    translation: "And [by] the day when it appears",
    normalizedText: "والنهار اذا تجلى",
  },
  {
    verseId: 2,
    name: "الليل",
    surahId: 92,
    text: "وَمَا خَلَقَ ٱلذَّكَرَ وَٱلۡأُنثَىٰٓ",
    translation: "And [by] He who created the male and female",
    normalizedText: "وما خلق الذكر والانثى",
  },
  {
    verseId: 3,
    name: "الليل",
    surahId: 92,
    text: "إِنَّ سَعۡيَكُمۡ لَشَتَّىٰ",
    translation: "Indeed, your efforts are diverse",
    normalizedText: "ان سعيكم لشتى",
  },
  {
    verseId: 4,
    name: "الليل",
    surahId: 92,
    text: "فَأَمَّا مَنۡ أَعۡطَىٰ وَٱتَّقَىٰ",
    translation: "As for he who gives and fears Allah",
    normalizedText: "فاما من اعطى واتقى",
  },
  {
    verseId: 5,
    name: "الليل",
    surahId: 92,
    text: "وَصَدَّقَ بِٱلۡحُسۡنَىٰ",
    translation: "And believes in the best [reward]",
    normalizedText: "وصدق بالحسنى",
  },
  {
    verseId: 6,
    name: "الليل",
    surahId: 92,
    text: "فَسَنُيَسِّرُهُۥ لِلۡيُسۡرَىٰ",
    translation: "We will ease him toward ease",
    normalizedText: "فسنيسره لليسرى",
  },
  {
    verseId: 7,
    name: "الليل",
    surahId: 92,
    text: "وَأَمَّا مَنۢ بَخِلَ وَٱسۡتَغۡنَىٰ",
    translation:
      "But as for he who withholds and considers himself free of need",
    normalizedText: "واما من بخل واستغنى",
  },
  {
    verseId: 8,
    name: "الليل",
    surahId: 92,
    text: "وَكَذَّبَ بِٱلۡحُسۡنَىٰ",
    translation: "And denies the best [reward]",
    normalizedText: "وكذب بالحسنى",
  },
  {
    verseId: 9,
    name: "الليل",
    surahId: 92,
    text: "فَسَنُيَسِّرُهُۥ لِلۡعُسۡرَىٰ",
    translation: "We will ease him toward difficulty",
    normalizedText: "فسنيسره للعسرى",
  },
  {
    verseId: 10,
    name: "الليل",
    surahId: 92,
    text: "وَمَا يُغۡنِي عَنۡهُ مَالُهُۥٓ إِذَا تَرَدَّىٰٓ",
    translation: "And what will his wealth avail him when he falls",
    normalizedText: "وما يغني عنه ماله اذا تردى",
  },
  {
    verseId: 11,
    name: "الليل",
    surahId: 92,
    text: "إِنَّ عَلَيۡنَا لَلۡهُدَىٰ",
    translation: "Indeed, [incumbent] upon Us is guidance",
    normalizedText: "ان علينا للهدى",
  },
  {
    verseId: 12,
    name: "الليل",
    surahId: 92,
    text: "وَإِنَّ لَنَا لَلۡأٓخِرَةَ وَٱلۡأُولَىٰ",
    translation: "And indeed, to Us belongs the Hereafter and the first [life]",
    normalizedText: "وان لنا للاخرة والاولى",
  },
  {
    verseId: 13,
    name: "الليل",
    surahId: 92,
    text: "فَأَنذَرۡتُكُمۡ نَارٗا تَلَظَّىٰ",
    translation: "So I have warned you of a Fire which is blazing",
    normalizedText: "فانذرتكم نارا تلظى",
  },
  {
    verseId: 14,
    name: "الليل",
    surahId: 92,
    text: "لَا يَصۡلَىٰهَآ إِلَّا ٱلۡأَشۡقَى",
    translation:
      "None will [enter to] burn therein except the most wretched one",
    normalizedText: "لا يصلىها الا الاشقى",
  },
  {
    verseId: 15,
    name: "الليل",
    surahId: 92,
    text: "ٱلَّذِي كَذَّبَ وَتَوَلَّىٰ",
    translation: "Who had denied and turned away",
    normalizedText: "الذي كذب وتولى",
  },
  {
    verseId: 16,
    name: "الليل",
    surahId: 92,
    text: "وَسَيُجَنَّبُهَا ٱلۡأَتۡقَى",
    translation: "But the righteous one will avoid it",
    normalizedText: "وسيجنبها الاتقى",
  },
  {
    verseId: 17,
    name: "الليل",
    surahId: 92,
    text: "ٱلَّذِي يُؤۡتِي مَالَهُۥ يَتَزَكَّىٰ",
    translation: "[He] who gives [from] his wealth to purify himself",
    normalizedText: "الذي ياتي ماله يتزكى",
  },
  {
    verseId: 18,
    name: "الليل",
    surahId: 92,
    text: "وَمَا لِأَحَدٍ عِندَهُۥ مِن نِّعۡمَةٖ تُجۡزَىٰٓ",
    translation:
      "And not [giving] for anyone who has [done him] a favor to be rewarded",
    normalizedText: "وما لاحد عنده من نعمة تجزى",
  },
  {
    verseId: 19,
    name: "الليل",
    surahId: 92,
    text: "إِلَّا ٱبۡتِغَآءَ وَجۡهِ رَبِّهِ ٱلۡأَعۡلَىٰ",
    translation: "But only seeking the countenance of his Lord, Most High",
    normalizedText: "الا ابتغاء وجه ربه الاعلى",
  },
  {
    verseId: 20,
    name: "الليل",
    surahId: 92,
    text: "وَلَسَوۡفَ يَرۡضَىٰ",
    translation: "And he is going to be satisfied",
    normalizedText: "ولسوف يرضى",
  },
  {
    verseId: 0,
    name: "الضحى",
    surahId: 93,
    text: "وَٱلضُّحَىٰ",
    translation: "By the morning brightness",
    normalizedText: "والضحى",
  },
  {
    verseId: 1,
    name: "الضحى",
    surahId: 93,
    text: "وَٱلَّيۡلِ إِذَا سَجَىٰ",
    translation: "And [by] the night when it covers with darkness",
    normalizedText: "واليل اذا سجى",
  },
  {
    verseId: 2,
    name: "الضحى",
    surahId: 93,
    text: "مَا وَدَّعَكَ رَبُّكَ وَمَا قَلَىٰ",
    translation:
      "Your Lord has not taken leave of you, [O Muhammad], nor has He detested [you]",
    normalizedText: "ما ودعك ربك وما قلى",
  },
  {
    verseId: 3,
    name: "الضحى",
    surahId: 93,
    text: "وَلَلۡأٓخِرَةُ خَيۡرٞ لَّكَ مِنَ ٱلۡأُولَىٰ",
    translation: "And the Hereafter is better for you than the first [life]",
    normalizedText: "وللاخرة خير لك من الاولى",
  },
  {
    verseId: 4,
    name: "الضحى",
    surahId: 93,
    text: "وَلَسَوۡفَ يُعۡطِيكَ رَبُّكَ فَتَرۡضَىٰٓ",
    translation:
      "And your Lord is going to give you, and you will be satisfied",
    normalizedText: "ولسوف يعطيك ربك فترضى",
  },
  {
    verseId: 5,
    name: "الضحى",
    surahId: 93,
    text: "أَلَمۡ يَجِدۡكَ يَتِيمٗا فَـَٔاوَىٰ",
    translation: "Did He not find you an orphan and give [you] refuge",
    normalizedText: "الم يجدك يتيما فاوى",
  },
  {
    verseId: 6,
    name: "الضحى",
    surahId: 93,
    text: "وَوَجَدَكَ ضَآلّٗا فَهَدَىٰ",
    translation: "And He found you lost and guided [you]",
    normalizedText: "ووجدك ضالا فهدى",
  },
  {
    verseId: 7,
    name: "الضحى",
    surahId: 93,
    text: "وَوَجَدَكَ عَآئِلٗا فَأَغۡنَىٰ",
    translation: "And He found you poor and made [you] self-sufficient",
    normalizedText: "ووجدك عاالا فاغنى",
  },
  {
    verseId: 8,
    name: "الضحى",
    surahId: 93,
    text: "فَأَمَّا ٱلۡيَتِيمَ فَلَا تَقۡهَرۡ",
    translation: "So as for the orphan, do not oppress [him]",
    normalizedText: "فاما اليتيم فلا تقهر",
  },
  {
    verseId: 9,
    name: "الضحى",
    surahId: 93,
    text: "وَأَمَّا ٱلسَّآئِلَ فَلَا تَنۡهَرۡ",
    translation: "And as for the petitioner, do not repel [him]",
    normalizedText: "واما الساال فلا تنهر",
  },
  {
    verseId: 10,
    name: "الضحى",
    surahId: 93,
    text: "وَأَمَّا بِنِعۡمَةِ رَبِّكَ فَحَدِّثۡ",
    translation: "But as for the favor of your Lord, report [it]",
    normalizedText: "واما بنعمة ربك فحدث",
  },
  {
    verseId: 0,
    name: "الشرح",
    surahId: 94,
    text: "أَلَمۡ نَشۡرَحۡ لَكَ صَدۡرَكَ",
    translation: "Did We not expand for you, [O Muhammad], your breast",
    normalizedText: "الم نشرح لك صدرك",
  },
  {
    verseId: 1,
    name: "الشرح",
    surahId: 94,
    text: "وَوَضَعۡنَا عَنكَ وِزۡرَكَ",
    translation: "And We removed from you your burden",
    normalizedText: "ووضعنا عنك وزرك",
  },
  {
    verseId: 2,
    name: "الشرح",
    surahId: 94,
    text: "ٱلَّذِيٓ أَنقَضَ ظَهۡرَكَ",
    translation: "Which had weighed upon your back",
    normalizedText: "الذي انقض ظهرك",
  },
  {
    verseId: 3,
    name: "الشرح",
    surahId: 94,
    text: "وَرَفَعۡنَا لَكَ ذِكۡرَكَ",
    translation: "And raised high for you your repute",
    normalizedText: "ورفعنا لك ذكرك",
  },
  {
    verseId: 4,
    name: "الشرح",
    surahId: 94,
    text: "فَإِنَّ مَعَ ٱلۡعُسۡرِ يُسۡرًا",
    translation: "For indeed, with hardship [will be] ease",
    normalizedText: "فان مع العسر يسرا",
  },
  {
    verseId: 5,
    name: "الشرح",
    surahId: 94,
    text: "إِنَّ مَعَ ٱلۡعُسۡرِ يُسۡرٗا",
    translation: "Indeed, with hardship [will be] ease",
    normalizedText: "ان مع العسر يسرا",
  },
  {
    verseId: 6,
    name: "الشرح",
    surahId: 94,
    text: "فَإِذَا فَرَغۡتَ فَٱنصَبۡ",
    translation:
      "So when you have finished [your duties], then stand up [for worship]",
    normalizedText: "فاذا فرغت فانصب",
  },
  {
    verseId: 7,
    name: "الشرح",
    surahId: 94,
    text: "وَإِلَىٰ رَبِّكَ فَٱرۡغَب",
    translation: "And to your Lord direct [your] longing",
    normalizedText: "والى ربك فارغب",
  },
  {
    verseId: 0,
    name: "التين",
    surahId: 95,
    text: "وَٱلتِّينِ وَٱلزَّيۡتُونِ",
    translation: "By the fig and the olive",
    normalizedText: "والتين والزيتون",
  },
  {
    verseId: 1,
    name: "التين",
    surahId: 95,
    text: "وَطُورِ سِينِينَ",
    translation: "And [by] Mount Sinai",
    normalizedText: "وطور سينين",
  },
  {
    verseId: 2,
    name: "التين",
    surahId: 95,
    text: "وَهَٰذَا ٱلۡبَلَدِ ٱلۡأَمِينِ",
    translation: "And [by] this secure city [Makkah]",
    normalizedText: "وهذا البلد الامين",
  },
  {
    verseId: 3,
    name: "التين",
    surahId: 95,
    text: "لَقَدۡ خَلَقۡنَا ٱلۡإِنسَٰنَ فِيٓ أَحۡسَنِ تَقۡوِيمٖ",
    translation: "We have certainly created man in the best of stature",
    normalizedText: "لقد خلقنا الانسن في احسن تقويم",
  },
  {
    verseId: 4,
    name: "التين",
    surahId: 95,
    text: "ثُمَّ رَدَدۡنَٰهُ أَسۡفَلَ سَٰفِلِينَ",
    translation: "Then We return him to the lowest of the low",
    normalizedText: "ثم رددنه اسفل سفلين",
  },
  {
    verseId: 5,
    name: "التين",
    surahId: 95,
    text: "إِلَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ فَلَهُمۡ أَجۡرٌ غَيۡرُ مَمۡنُونٖ",
    translation:
      "Except for those who believe and do righteous deeds, for they will have a reward uninterrupted",
    normalizedText: "الا الذين ءامنوا وعملوا الصلحت فلهم اجر غير ممنون",
  },
  {
    verseId: 6,
    name: "التين",
    surahId: 95,
    text: "فَمَا يُكَذِّبُكَ بَعۡدُ بِٱلدِّينِ",
    translation: "So what yet causes you to deny the Recompense",
    normalizedText: "فما يكذبك بعد بالدين",
  },
  {
    verseId: 7,
    name: "التين",
    surahId: 95,
    text: "أَلَيۡسَ ٱللَّهُ بِأَحۡكَمِ ٱلۡحَٰكِمِينَ",
    translation: "Is not Allah the most just of judges",
    normalizedText: "اليس الله باحكم الحكمين",
  },
  {
    verseId: 0,
    name: "العلق",
    surahId: 96,
    text: "ٱقۡرَأۡ بِٱسۡمِ رَبِّكَ ٱلَّذِي خَلَقَ",
    translation: "Recite in the name of your Lord who created",
    normalizedText: "اقرا باسم ربك الذي خلق",
  },
  {
    verseId: 1,
    name: "العلق",
    surahId: 96,
    text: "خَلَقَ ٱلۡإِنسَٰنَ مِنۡ عَلَقٍ",
    translation: "Created man from a clinging substance",
    normalizedText: "خلق الانسن من علق",
  },
  {
    verseId: 2,
    name: "العلق",
    surahId: 96,
    text: "ٱقۡرَأۡ وَرَبُّكَ ٱلۡأَكۡرَمُ",
    translation: "Recite, and your Lord is the most Generous",
    normalizedText: "اقرا وربك الاكرم",
  },
  {
    verseId: 3,
    name: "العلق",
    surahId: 96,
    text: "ٱلَّذِي عَلَّمَ بِٱلۡقَلَمِ",
    translation: "Who taught by the pen",
    normalizedText: "الذي علم بالقلم",
  },
  {
    verseId: 4,
    name: "العلق",
    surahId: 96,
    text: "عَلَّمَ ٱلۡإِنسَٰنَ مَا لَمۡ يَعۡلَمۡ",
    translation: "Taught man that which he knew not",
    normalizedText: "علم الانسن ما لم يعلم",
  },
  {
    verseId: 5,
    name: "العلق",
    surahId: 96,
    text: "كَلَّآ إِنَّ ٱلۡإِنسَٰنَ لَيَطۡغَىٰٓ",
    translation: "No! [But] indeed, man transgresses",
    normalizedText: "كلا ان الانسن ليطغى",
  },
  {
    verseId: 6,
    name: "العلق",
    surahId: 96,
    text: "أَن رَّءَاهُ ٱسۡتَغۡنَىٰٓ",
    translation: "Because he sees himself self-sufficient",
    normalizedText: "ان رءاه استغنى",
  },
  {
    verseId: 7,
    name: "العلق",
    surahId: 96,
    text: "إِنَّ إِلَىٰ رَبِّكَ ٱلرُّجۡعَىٰٓ",
    translation: "Indeed, to your Lord is the return",
    normalizedText: "ان الى ربك الرجعى",
  },
  {
    verseId: 8,
    name: "العلق",
    surahId: 96,
    text: "أَرَءَيۡتَ ٱلَّذِي يَنۡهَىٰ",
    translation: "Have you seen the one who forbids",
    normalizedText: "ارءيت الذي ينهى",
  },
  {
    verseId: 9,
    name: "العلق",
    surahId: 96,
    text: "عَبۡدًا إِذَا صَلَّىٰٓ",
    translation: "A servant when he prays",
    normalizedText: "عبدا اذا صلى",
  },
  {
    verseId: 10,
    name: "العلق",
    surahId: 96,
    text: "أَرَءَيۡتَ إِن كَانَ عَلَى ٱلۡهُدَىٰٓ",
    translation: "Have you seen if he is upon guidance",
    normalizedText: "ارءيت ان كان على الهدى",
  },
  {
    verseId: 11,
    name: "العلق",
    surahId: 96,
    text: "أَوۡ أَمَرَ بِٱلتَّقۡوَىٰٓ",
    translation: "Or enjoins righteousness",
    normalizedText: "او امر بالتقوى",
  },
  {
    verseId: 12,
    name: "العلق",
    surahId: 96,
    text: "أَرَءَيۡتَ إِن كَذَّبَ وَتَوَلَّىٰٓ",
    translation: "Have you seen if he denies and turns away",
    normalizedText: "ارءيت ان كذب وتولى",
  },
  {
    verseId: 13,
    name: "العلق",
    surahId: 96,
    text: "أَلَمۡ يَعۡلَم بِأَنَّ ٱللَّهَ يَرَىٰ",
    translation: "Does he not know that Allah sees",
    normalizedText: "الم يعلم بان الله يرى",
  },
  {
    verseId: 14,
    name: "العلق",
    surahId: 96,
    text: "كَلَّا لَئِن لَّمۡ يَنتَهِ لَنَسۡفَعَۢا بِٱلنَّاصِيَةِ",
    translation:
      "No! If he does not desist, We will surely drag him by the forelock",
    normalizedText: "كلا لان لم ينته لنسفعا بالناصية",
  },
  {
    verseId: 15,
    name: "العلق",
    surahId: 96,
    text: "نَاصِيَةٖ كَٰذِبَةٍ خَاطِئَةٖ",
    translation: "A lying, sinning forelock",
    normalizedText: "ناصية كذبة خاطاة",
  },
  {
    verseId: 16,
    name: "العلق",
    surahId: 96,
    text: "فَلۡيَدۡعُ نَادِيَهُۥ",
    translation: "Then let him call his associates",
    normalizedText: "فليدع ناديه",
  },
  {
    verseId: 17,
    name: "العلق",
    surahId: 96,
    text: "سَنَدۡعُ ٱلزَّبَانِيَةَ",
    translation: "We will call the angels of Hell",
    normalizedText: "سندع الزبانية",
  },
  {
    verseId: 18,
    name: "العلق",
    surahId: 96,
    text: "كَلَّا لَا تُطِعۡهُ وَٱسۡجُدۡۤ وَٱقۡتَرِب۩",
    translation: "No! Do not obey him. But prostrate and draw near [to Allah]",
    normalizedText: "كلا لا تطعه واسجد واقترب۩",
  },
  {
    verseId: 0,
    name: "القدر",
    surahId: 97,
    text: "إِنَّآ أَنزَلۡنَٰهُ فِي لَيۡلَةِ ٱلۡقَدۡرِ",
    translation: "Indeed, We sent the Qur'an down during the Night of Decree",
    normalizedText: "انا انزلنه في ليلة القدر",
  },
  {
    verseId: 1,
    name: "القدر",
    surahId: 97,
    text: "وَمَآ أَدۡرَىٰكَ مَا لَيۡلَةُ ٱلۡقَدۡرِ",
    translation: "And what can make you know what is the Night of Decree",
    normalizedText: "وما ادرىك ما ليلة القدر",
  },
  {
    verseId: 2,
    name: "القدر",
    surahId: 97,
    text: "لَيۡلَةُ ٱلۡقَدۡرِ خَيۡرٞ مِّنۡ أَلۡفِ شَهۡرٖ",
    translation: "The Night of Decree is better than a thousand months",
    normalizedText: "ليلة القدر خير من الف شهر",
  },
  {
    verseId: 3,
    name: "القدر",
    surahId: 97,
    text: "تَنَزَّلُ ٱلۡمَلَـٰٓئِكَةُ وَٱلرُّوحُ فِيهَا بِإِذۡنِ رَبِّهِم مِّن كُلِّ أَمۡرٖ",
    translation:
      "The angels and the Spirit descend therein by permission of their Lord for every matter",
    normalizedText: "تنزل الملاكة والروح فيها باذن ربهم من كل امر",
  },
  {
    verseId: 4,
    name: "القدر",
    surahId: 97,
    text: "سَلَٰمٌ هِيَ حَتَّىٰ مَطۡلَعِ ٱلۡفَجۡرِ",
    translation: "Peace it is until the emergence of dawn",
    normalizedText: "سلم هي حتى مطلع الفجر",
  },
  {
    verseId: 0,
    name: "البينة",
    surahId: 98,
    text: "لَمۡ يَكُنِ ٱلَّذِينَ كَفَرُواْ مِنۡ أَهۡلِ ٱلۡكِتَٰبِ وَٱلۡمُشۡرِكِينَ مُنفَكِّينَ حَتَّىٰ تَأۡتِيَهُمُ ٱلۡبَيِّنَةُ",
    translation:
      "Those who disbelieved among the People of the Scripture and the polytheists were not to be parted [from misbelief] until there came to them clear evidence",
    normalizedText:
      "لم يكن الذين كفروا من اهل الكتب والمشركين منفكين حتى تاتيهم البينة",
  },
  {
    verseId: 1,
    name: "البينة",
    surahId: 98,
    text: "رَسُولٞ مِّنَ ٱللَّهِ يَتۡلُواْ صُحُفٗا مُّطَهَّرَةٗ",
    translation: "A Messenger from Allah, reciting purified scriptures",
    normalizedText: "رسول من الله يتلوا صحفا مطهرة",
  },
  {
    verseId: 2,
    name: "البينة",
    surahId: 98,
    text: "فِيهَا كُتُبٞ قَيِّمَةٞ",
    translation: "Within which are correct writings",
    normalizedText: "فيها كتب قيمة",
  },
  {
    verseId: 3,
    name: "البينة",
    surahId: 98,
    text: "وَمَا تَفَرَّقَ ٱلَّذِينَ أُوتُواْ ٱلۡكِتَٰبَ إِلَّا مِنۢ بَعۡدِ مَا جَآءَتۡهُمُ ٱلۡبَيِّنَةُ",
    translation:
      "Nor did those who were given the Scripture become divided until after there had come to them clear evidence",
    normalizedText: "وما تفرق الذين اوتوا الكتب الا من بعد ما جاءتهم البينة",
  },
  {
    verseId: 4,
    name: "البينة",
    surahId: 98,
    text: "وَمَآ أُمِرُوٓاْ إِلَّا لِيَعۡبُدُواْ ٱللَّهَ مُخۡلِصِينَ لَهُ ٱلدِّينَ حُنَفَآءَ وَيُقِيمُواْ ٱلصَّلَوٰةَ وَيُؤۡتُواْ ٱلزَّكَوٰةَۚ وَذَٰلِكَ دِينُ ٱلۡقَيِّمَةِ",
    translation:
      "And they were not commanded except to worship Allah, [being] sincere to Him in religion, inclining to truth, and to establish prayer and to give zakah. And that is the correct religion",
    normalizedText:
      "وما امروا الا ليعبدوا الله مخلصين له الدين حنفاء ويقيموا الصلوة وياتوا الزكوة وذلك دين القيمة",
  },
  {
    verseId: 5,
    name: "البينة",
    surahId: 98,
    text: "إِنَّ ٱلَّذِينَ كَفَرُواْ مِنۡ أَهۡلِ ٱلۡكِتَٰبِ وَٱلۡمُشۡرِكِينَ فِي نَارِ جَهَنَّمَ خَٰلِدِينَ فِيهَآۚ أُوْلَـٰٓئِكَ هُمۡ شَرُّ ٱلۡبَرِيَّةِ",
    translation:
      "Indeed, they who disbelieved among the People of the Scripture and the polytheists will be in the fire of Hell, abiding eternally therein. Those are the worst of creatures",
    normalizedText:
      "ان الذين كفروا من اهل الكتب والمشركين في نار جهنم خلدين فيها اولاك هم شر البرية",
  },
  {
    verseId: 6,
    name: "البينة",
    surahId: 98,
    text: "إِنَّ ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ أُوْلَـٰٓئِكَ هُمۡ خَيۡرُ ٱلۡبَرِيَّةِ",
    translation:
      "Indeed, they who have believed and done righteous deeds - those are the best of creatures",
    normalizedText: "ان الذين ءامنوا وعملوا الصلحت اولاك هم خير البرية",
  },
  {
    verseId: 7,
    name: "البينة",
    surahId: 98,
    text: "جَزَآؤُهُمۡ عِندَ رَبِّهِمۡ جَنَّـٰتُ عَدۡنٖ تَجۡرِي مِن تَحۡتِهَا ٱلۡأَنۡهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدٗاۖ رَّضِيَ ٱللَّهُ عَنۡهُمۡ وَرَضُواْ عَنۡهُۚ ذَٰلِكَ لِمَنۡ خَشِيَ رَبَّهُۥ",
    translation:
      "Their reward with Allah will be gardens of perpetual residence beneath which rivers flow, wherein they will abide forever, Allah being pleased with them and they with Him. That is for whoever has feared his Lord",
    normalizedText:
      "جزااهم عند ربهم جنت عدن تجري من تحتها الانهر خلدين فيها ابدا رضي الله عنهم ورضوا عنه ذلك لمن خشي ربه",
  },
  {
    verseId: 0,
    name: "الزلزلة",
    surahId: 99,
    text: "إِذَا زُلۡزِلَتِ ٱلۡأَرۡضُ زِلۡزَالَهَا",
    translation: "When the earth is shaken with its [final] earthquake",
    normalizedText: "اذا زلزلت الارض زلزالها",
  },
  {
    verseId: 1,
    name: "الزلزلة",
    surahId: 99,
    text: "وَأَخۡرَجَتِ ٱلۡأَرۡضُ أَثۡقَالَهَا",
    translation: "And the earth discharges its burdens",
    normalizedText: "واخرجت الارض اثقالها",
  },
  {
    verseId: 2,
    name: "الزلزلة",
    surahId: 99,
    text: "وَقَالَ ٱلۡإِنسَٰنُ مَا لَهَا",
    translation: 'And man says, "What is [wrong] with it',
    normalizedText: "وقال الانسن ما لها",
  },
  {
    verseId: 3,
    name: "الزلزلة",
    surahId: 99,
    text: "يَوۡمَئِذٖ تُحَدِّثُ أَخۡبَارَهَا",
    translation: "That Day, it will report its news",
    normalizedText: "يوماذ تحدث اخبارها",
  },
  {
    verseId: 4,
    name: "الزلزلة",
    surahId: 99,
    text: "بِأَنَّ رَبَّكَ أَوۡحَىٰ لَهَا",
    translation: "Because your Lord has commanded it",
    normalizedText: "بان ربك اوحى لها",
  },
  {
    verseId: 5,
    name: "الزلزلة",
    surahId: 99,
    text: "يَوۡمَئِذٖ يَصۡدُرُ ٱلنَّاسُ أَشۡتَاتٗا لِّيُرَوۡاْ أَعۡمَٰلَهُمۡ",
    translation:
      "That Day, the people will depart separated [into categories] to be shown [the result of] their deeds",
    normalizedText: "يوماذ يصدر الناس اشتاتا ليروا اعملهم",
  },
  {
    verseId: 6,
    name: "الزلزلة",
    surahId: 99,
    text: "فَمَن يَعۡمَلۡ مِثۡقَالَ ذَرَّةٍ خَيۡرٗا يَرَهُۥ",
    translation: "So whoever does an atom's weight of good will see it",
    normalizedText: "فمن يعمل مثقال ذرة خيرا يره",
  },
  {
    verseId: 7,
    name: "الزلزلة",
    surahId: 99,
    text: "وَمَن يَعۡمَلۡ مِثۡقَالَ ذَرَّةٖ شَرّٗا يَرَهُۥ",
    translation: "And whoever does an atom's weight of evil will see it",
    normalizedText: "ومن يعمل مثقال ذرة شرا يره",
  },
  {
    verseId: 0,
    name: "العاديات",
    surahId: 100,
    text: "وَٱلۡعَٰدِيَٰتِ ضَبۡحٗا",
    translation: "By the racers, panting",
    normalizedText: "والعديت ضبحا",
  },
  {
    verseId: 1,
    name: "العاديات",
    surahId: 100,
    text: "فَٱلۡمُورِيَٰتِ قَدۡحٗا",
    translation: "And the producers of sparks [when] striking",
    normalizedText: "فالموريت قدحا",
  },
  {
    verseId: 2,
    name: "العاديات",
    surahId: 100,
    text: "فَٱلۡمُغِيرَٰتِ صُبۡحٗا",
    translation: "And the chargers at dawn",
    normalizedText: "فالمغيرت صبحا",
  },
  {
    verseId: 3,
    name: "العاديات",
    surahId: 100,
    text: "فَأَثَرۡنَ بِهِۦ نَقۡعٗا",
    translation: "Stirring up thereby [clouds of] dust",
    normalizedText: "فاثرن به نقعا",
  },
  {
    verseId: 4,
    name: "العاديات",
    surahId: 100,
    text: "فَوَسَطۡنَ بِهِۦ جَمۡعًا",
    translation: "Arriving thereby in the center collectively",
    normalizedText: "فوسطن به جمعا",
  },
  {
    verseId: 5,
    name: "العاديات",
    surahId: 100,
    text: "إِنَّ ٱلۡإِنسَٰنَ لِرَبِّهِۦ لَكَنُودٞ",
    translation: "Indeed mankind, to his Lord, is ungrateful",
    normalizedText: "ان الانسن لربه لكنود",
  },
  {
    verseId: 6,
    name: "العاديات",
    surahId: 100,
    text: "وَإِنَّهُۥ عَلَىٰ ذَٰلِكَ لَشَهِيدٞ",
    translation: "And indeed, he is to that a witness",
    normalizedText: "وانه على ذلك لشهيد",
  },
  {
    verseId: 7,
    name: "العاديات",
    surahId: 100,
    text: "وَإِنَّهُۥ لِحُبِّ ٱلۡخَيۡرِ لَشَدِيدٌ",
    translation: "And indeed he is, in love of wealth, intense",
    normalizedText: "وانه لحب الخير لشديد",
  },
  {
    verseId: 8,
    name: "العاديات",
    surahId: 100,
    text: "۞أَفَلَا يَعۡلَمُ إِذَا بُعۡثِرَ مَا فِي ٱلۡقُبُورِ",
    translation:
      "But does he not know that when the contents of the graves are scattered",
    normalizedText: "۞افلا يعلم اذا بعثر ما في القبور",
  },
  {
    verseId: 9,
    name: "العاديات",
    surahId: 100,
    text: "وَحُصِّلَ مَا فِي ٱلصُّدُورِ",
    translation: "And that within the breasts is obtained",
    normalizedText: "وحصل ما في الصدور",
  },
  {
    verseId: 10,
    name: "العاديات",
    surahId: 100,
    text: "إِنَّ رَبَّهُم بِهِمۡ يَوۡمَئِذٖ لَّخَبِيرُۢ",
    translation:
      "Indeed, their Lord with them, that Day, is [fully] Acquainted",
    normalizedText: "ان ربهم بهم يوماذ لخبير",
  },
  {
    verseId: 0,
    name: "القارعة",
    surahId: 101,
    text: "ٱلۡقَارِعَةُ",
    translation: "The Striking Calamity",
    normalizedText: "القارعة",
  },
  {
    verseId: 1,
    name: "القارعة",
    surahId: 101,
    text: "مَا ٱلۡقَارِعَةُ",
    translation: "What is the Striking Calamity",
    normalizedText: "ما القارعة",
  },
  {
    verseId: 2,
    name: "القارعة",
    surahId: 101,
    text: "وَمَآ أَدۡرَىٰكَ مَا ٱلۡقَارِعَةُ",
    translation: "And what can make you know what is the Striking Calamity",
    normalizedText: "وما ادرىك ما القارعة",
  },
  {
    verseId: 3,
    name: "القارعة",
    surahId: 101,
    text: "يَوۡمَ يَكُونُ ٱلنَّاسُ كَٱلۡفَرَاشِ ٱلۡمَبۡثُوثِ",
    translation: "It is the Day when people will be like moths, dispersed",
    normalizedText: "يوم يكون الناس كالفراش المبثوث",
  },
  {
    verseId: 4,
    name: "القارعة",
    surahId: 101,
    text: "وَتَكُونُ ٱلۡجِبَالُ كَٱلۡعِهۡنِ ٱلۡمَنفُوشِ",
    translation: "And the mountains will be like wool, fluffed up",
    normalizedText: "وتكون الجبال كالعهن المنفوش",
  },
  {
    verseId: 5,
    name: "القارعة",
    surahId: 101,
    text: "فَأَمَّا مَن ثَقُلَتۡ مَوَٰزِينُهُۥ",
    translation: "Then as for one whose scales are heavy [with good deeds]",
    normalizedText: "فاما من ثقلت موزينه",
  },
  {
    verseId: 6,
    name: "القارعة",
    surahId: 101,
    text: "فَهُوَ فِي عِيشَةٖ رَّاضِيَةٖ",
    translation: "He will be in a pleasant life",
    normalizedText: "فهو في عيشة راضية",
  },
  {
    verseId: 7,
    name: "القارعة",
    surahId: 101,
    text: "وَأَمَّا مَنۡ خَفَّتۡ مَوَٰزِينُهُۥ",
    translation: "But as for one whose scales are light",
    normalizedText: "واما من خفت موزينه",
  },
  {
    verseId: 8,
    name: "القارعة",
    surahId: 101,
    text: "فَأُمُّهُۥ هَاوِيَةٞ",
    translation: "His refuge will be an abyss",
    normalizedText: "فامه هاوية",
  },
  {
    verseId: 9,
    name: "القارعة",
    surahId: 101,
    text: "وَمَآ أَدۡرَىٰكَ مَا هِيَهۡ",
    translation: "And what can make you know what that is",
    normalizedText: "وما ادرىك ما هيه",
  },
  {
    verseId: 10,
    name: "القارعة",
    surahId: 101,
    text: "نَارٌ حَامِيَةُۢ",
    translation: "It is a Fire, intensely hot",
    normalizedText: "نار حامية",
  },
  {
    verseId: 0,
    name: "التكاثر",
    surahId: 102,
    text: "أَلۡهَىٰكُمُ ٱلتَّكَاثُرُ",
    translation: "Competition in [worldly] increase diverts you",
    normalizedText: "الهىكم التكاثر",
  },
  {
    verseId: 1,
    name: "التكاثر",
    surahId: 102,
    text: "حَتَّىٰ زُرۡتُمُ ٱلۡمَقَابِرَ",
    translation: "Until you visit the graveyards",
    normalizedText: "حتى زرتم المقابر",
  },
  {
    verseId: 2,
    name: "التكاثر",
    surahId: 102,
    text: "كَلَّا سَوۡفَ تَعۡلَمُونَ",
    translation: "No! You are going to know",
    normalizedText: "كلا سوف تعلمون",
  },
  {
    verseId: 3,
    name: "التكاثر",
    surahId: 102,
    text: "ثُمَّ كَلَّا سَوۡفَ تَعۡلَمُونَ",
    translation: "Then no! You are going to know",
    normalizedText: "ثم كلا سوف تعلمون",
  },
  {
    verseId: 4,
    name: "التكاثر",
    surahId: 102,
    text: "كَلَّا لَوۡ تَعۡلَمُونَ عِلۡمَ ٱلۡيَقِينِ",
    translation: "No! If you only knew with knowledge of certainty",
    normalizedText: "كلا لو تعلمون علم اليقين",
  },
  {
    verseId: 5,
    name: "التكاثر",
    surahId: 102,
    text: "لَتَرَوُنَّ ٱلۡجَحِيمَ",
    translation: "You will surely see the Hellfire",
    normalizedText: "لترون الجحيم",
  },
  {
    verseId: 6,
    name: "التكاثر",
    surahId: 102,
    text: "ثُمَّ لَتَرَوُنَّهَا عَيۡنَ ٱلۡيَقِينِ",
    translation: "Then you will surely see it with the eye of certainty",
    normalizedText: "ثم لترونها عين اليقين",
  },
  {
    verseId: 7,
    name: "التكاثر",
    surahId: 102,
    text: "ثُمَّ لَتُسۡـَٔلُنَّ يَوۡمَئِذٍ عَنِ ٱلنَّعِيمِ",
    translation: "Then you will surely be asked that Day about pleasure",
    normalizedText: "ثم لتسلن يوماذ عن النعيم",
  },
  {
    verseId: 0,
    name: "العصر",
    surahId: 103,
    text: "وَٱلۡعَصۡرِ",
    translation: "By time",
    normalizedText: "والعصر",
  },
  {
    verseId: 1,
    name: "العصر",
    surahId: 103,
    text: "إِنَّ ٱلۡإِنسَٰنَ لَفِي خُسۡرٍ",
    translation: "Indeed, mankind is in loss",
    normalizedText: "ان الانسن لفي خسر",
  },
  {
    verseId: 2,
    name: "العصر",
    surahId: 103,
    text: "إِلَّا ٱلَّذِينَ ءَامَنُواْ وَعَمِلُواْ ٱلصَّـٰلِحَٰتِ وَتَوَاصَوۡاْ بِٱلۡحَقِّ وَتَوَاصَوۡاْ بِٱلصَّبۡرِ",
    translation:
      "Except for those who have believed and done righteous deeds and advised each other to truth and advised each other to patience",
    normalizedText:
      "الا الذين ءامنوا وعملوا الصلحت وتواصوا بالحق وتواصوا بالصبر",
  },
  {
    verseId: 0,
    name: "الهمزة",
    surahId: 104,
    text: "وَيۡلٞ لِّكُلِّ هُمَزَةٖ لُّمَزَةٍ",
    translation: "Woe to every scorner and mocker",
    normalizedText: "ويل لكل همزة لمزة",
  },
  {
    verseId: 1,
    name: "الهمزة",
    surahId: 104,
    text: "ٱلَّذِي جَمَعَ مَالٗا وَعَدَّدَهُۥ",
    translation: "Who collects wealth and [continuously] counts it",
    normalizedText: "الذي جمع مالا وعدده",
  },
  {
    verseId: 2,
    name: "الهمزة",
    surahId: 104,
    text: "يَحۡسَبُ أَنَّ مَالَهُۥٓ أَخۡلَدَهُۥ",
    translation: "He thinks that his wealth will make him immortal",
    normalizedText: "يحسب ان ماله اخلده",
  },
  {
    verseId: 3,
    name: "الهمزة",
    surahId: 104,
    text: "كَلَّاۖ لَيُنۢبَذَنَّ فِي ٱلۡحُطَمَةِ",
    translation: "No! He will surely be thrown into the Crusher",
    normalizedText: "كلا لينبذن في الحطمة",
  },
  {
    verseId: 4,
    name: "الهمزة",
    surahId: 104,
    text: "وَمَآ أَدۡرَىٰكَ مَا ٱلۡحُطَمَةُ",
    translation: "And what can make you know what is the Crusher",
    normalizedText: "وما ادرىك ما الحطمة",
  },
  {
    verseId: 5,
    name: "الهمزة",
    surahId: 104,
    text: "نَارُ ٱللَّهِ ٱلۡمُوقَدَةُ",
    translation: "It is the fire of Allah, [eternally] fueled",
    normalizedText: "نار الله الموقدة",
  },
  {
    verseId: 6,
    name: "الهمزة",
    surahId: 104,
    text: "ٱلَّتِي تَطَّلِعُ عَلَى ٱلۡأَفۡـِٔدَةِ",
    translation: "Which mounts directed at the hearts",
    normalizedText: "التي تطلع على الافدة",
  },
  {
    verseId: 7,
    name: "الهمزة",
    surahId: 104,
    text: "إِنَّهَا عَلَيۡهِم مُّؤۡصَدَةٞ",
    translation: "Indeed, Hellfire will be closed down upon them",
    normalizedText: "انها عليهم ماصدة",
  },
  {
    verseId: 8,
    name: "الهمزة",
    surahId: 104,
    text: "فِي عَمَدٖ مُّمَدَّدَةِۭ",
    translation: "In extended columns",
    normalizedText: "في عمد ممددة",
  },
  {
    verseId: 0,
    name: "الفيل",
    surahId: 105,
    text: "أَلَمۡ تَرَ كَيۡفَ فَعَلَ رَبُّكَ بِأَصۡحَٰبِ ٱلۡفِيلِ",
    translation:
      "Have you not considered, [O Muhammad], how your Lord dealt with the companions of the elephant",
    normalizedText: "الم تر كيف فعل ربك باصحب الفيل",
  },
  {
    verseId: 1,
    name: "الفيل",
    surahId: 105,
    text: "أَلَمۡ يَجۡعَلۡ كَيۡدَهُمۡ فِي تَضۡلِيلٖ",
    translation: "Did He not make their plan into misguidance",
    normalizedText: "الم يجعل كيدهم في تضليل",
  },
  {
    verseId: 2,
    name: "الفيل",
    surahId: 105,
    text: "وَأَرۡسَلَ عَلَيۡهِمۡ طَيۡرًا أَبَابِيلَ",
    translation: "And He sent against them birds in flocks",
    normalizedText: "وارسل عليهم طيرا ابابيل",
  },
  {
    verseId: 3,
    name: "الفيل",
    surahId: 105,
    text: "تَرۡمِيهِم بِحِجَارَةٖ مِّن سِجِّيلٖ",
    translation: "Striking them with stones of hard clay",
    normalizedText: "ترميهم بحجارة من سجيل",
  },
  {
    verseId: 4,
    name: "الفيل",
    surahId: 105,
    text: "فَجَعَلَهُمۡ كَعَصۡفٖ مَّأۡكُولِۭ",
    translation: "And He made them like eaten straw",
    normalizedText: "فجعلهم كعصف ماكول",
  },
  {
    verseId: 0,
    name: "قريش",
    surahId: 106,
    text: "لِإِيلَٰفِ قُرَيۡشٍ",
    translation: "For the accustomed security of the Quraysh",
    normalizedText: "لايلف قريش",
  },
  {
    verseId: 1,
    name: "قريش",
    surahId: 106,
    text: "إِۦلَٰفِهِمۡ رِحۡلَةَ ٱلشِّتَآءِ وَٱلصَّيۡفِ",
    translation:
      "Their accustomed security [in] the caravan of winter and summer",
    normalizedText: "الفهم رحلة الشتاء والصيف",
  },
  {
    verseId: 2,
    name: "قريش",
    surahId: 106,
    text: "فَلۡيَعۡبُدُواْ رَبَّ هَٰذَا ٱلۡبَيۡتِ",
    translation: "Let them worship the Lord of this House",
    normalizedText: "فليعبدوا رب هذا البيت",
  },
  {
    verseId: 3,
    name: "قريش",
    surahId: 106,
    text: "ٱلَّذِيٓ أَطۡعَمَهُم مِّن جُوعٖ وَءَامَنَهُم مِّنۡ خَوۡفِۭ",
    translation:
      "Who has fed them, [saving them] from hunger and made them safe, [saving them] from fear",
    normalizedText: "الذي اطعمهم من جوع وءامنهم من خوف",
  },
  {
    verseId: 0,
    name: "الماعون",
    surahId: 107,
    text: "أَرَءَيۡتَ ٱلَّذِي يُكَذِّبُ بِٱلدِّينِ",
    translation: "Have you seen the one who denies the Recompense",
    normalizedText: "ارءيت الذي يكذب بالدين",
  },
  {
    verseId: 1,
    name: "الماعون",
    surahId: 107,
    text: "فَذَٰلِكَ ٱلَّذِي يَدُعُّ ٱلۡيَتِيمَ",
    translation: "For that is the one who drives away the orphan",
    normalizedText: "فذلك الذي يدع اليتيم",
  },
  {
    verseId: 2,
    name: "الماعون",
    surahId: 107,
    text: "وَلَا يَحُضُّ عَلَىٰ طَعَامِ ٱلۡمِسۡكِينِ",
    translation: "And does not encourage the feeding of the poor",
    normalizedText: "ولا يحض على طعام المسكين",
  },
  {
    verseId: 3,
    name: "الماعون",
    surahId: 107,
    text: "فَوَيۡلٞ لِّلۡمُصَلِّينَ",
    translation: "So woe to those who pray",
    normalizedText: "فويل للمصلين",
  },
  {
    verseId: 4,
    name: "الماعون",
    surahId: 107,
    text: "ٱلَّذِينَ هُمۡ عَن صَلَاتِهِمۡ سَاهُونَ",
    translation: "[But] who are heedless of their prayer",
    normalizedText: "الذين هم عن صلاتهم ساهون",
  },
  {
    verseId: 5,
    name: "الماعون",
    surahId: 107,
    text: "ٱلَّذِينَ هُمۡ يُرَآءُونَ",
    translation: "Those who make show [of their deeds]",
    normalizedText: "الذين هم يراءون",
  },
  {
    verseId: 6,
    name: "الماعون",
    surahId: 107,
    text: "وَيَمۡنَعُونَ ٱلۡمَاعُونَ",
    translation: "And withhold [simple] assistance",
    normalizedText: "ويمنعون الماعون",
  },
  {
    verseId: 0,
    name: "الكوثر",
    surahId: 108,
    text: "إِنَّآ أَعۡطَيۡنَٰكَ ٱلۡكَوۡثَرَ",
    translation: "Indeed, We have granted you, [O Muhammad], al-Kawthar",
    normalizedText: "انا اعطينك الكوثر",
  },
  {
    verseId: 1,
    name: "الكوثر",
    surahId: 108,
    text: "فَصَلِّ لِرَبِّكَ وَٱنۡحَرۡ",
    translation: "So pray to your Lord and sacrifice [to Him alone]",
    normalizedText: "فصل لربك وانحر",
  },
  {
    verseId: 2,
    name: "الكوثر",
    surahId: 108,
    text: "إِنَّ شَانِئَكَ هُوَ ٱلۡأَبۡتَرُ",
    translation: "Indeed, your enemy is the one cut off",
    normalizedText: "ان شاناك هو الابتر",
  },
  {
    verseId: 0,
    name: "الكافرون",
    surahId: 109,
    text: "قُلۡ يَـٰٓأَيُّهَا ٱلۡكَٰفِرُونَ",
    translation: 'Say, "O disbelievers',
    normalizedText: "قل يايها الكفرون",
  },
  {
    verseId: 1,
    name: "الكافرون",
    surahId: 109,
    text: "لَآ أَعۡبُدُ مَا تَعۡبُدُونَ",
    translation: "I do not worship what you worship",
    normalizedText: "لا اعبد ما تعبدون",
  },
  {
    verseId: 2,
    name: "الكافرون",
    surahId: 109,
    text: "وَلَآ أَنتُمۡ عَٰبِدُونَ مَآ أَعۡبُدُ",
    translation: "Nor are you worshippers of what I worship",
    normalizedText: "ولا انتم عبدون ما اعبد",
  },
  {
    verseId: 3,
    name: "الكافرون",
    surahId: 109,
    text: "وَلَآ أَنَا۠ عَابِدٞ مَّا عَبَدتُّمۡ",
    translation: "Nor will I be a worshipper of what you worship",
    normalizedText: "ولا انا عابد ما عبدتم",
  },
  {
    verseId: 4,
    name: "الكافرون",
    surahId: 109,
    text: "وَلَآ أَنتُمۡ عَٰبِدُونَ مَآ أَعۡبُدُ",
    translation: "Nor will you be worshippers of what I worship",
    normalizedText: "ولا انتم عبدون ما اعبد",
  },
  {
    verseId: 5,
    name: "الكافرون",
    surahId: 109,
    text: "لَكُمۡ دِينُكُمۡ وَلِيَ دِينِ",
    translation: "For you is your religion, and for me is my religion",
    normalizedText: "لكم دينكم ولي دين",
  },
  {
    verseId: 0,
    name: "النصر",
    surahId: 110,
    text: "إِذَا جَآءَ نَصۡرُ ٱللَّهِ وَٱلۡفَتۡحُ",
    translation: "When the victory of Allah has come and the conquest",
    normalizedText: "اذا جاء نصر الله والفتح",
  },
  {
    verseId: 1,
    name: "النصر",
    surahId: 110,
    text: "وَرَأَيۡتَ ٱلنَّاسَ يَدۡخُلُونَ فِي دِينِ ٱللَّهِ أَفۡوَاجٗا",
    translation:
      "And you see the people entering into the religion of Allah in multitudes",
    normalizedText: "ورايت الناس يدخلون في دين الله افواجا",
  },
  {
    verseId: 2,
    name: "النصر",
    surahId: 110,
    text: "فَسَبِّحۡ بِحَمۡدِ رَبِّكَ وَٱسۡتَغۡفِرۡهُۚ إِنَّهُۥ كَانَ تَوَّابَۢا",
    translation:
      "Then exalt [Him] with praise of your Lord and ask forgiveness of Him. Indeed, He is ever Accepting of repentance",
    normalizedText: "فسبح بحمد ربك واستغفره انه كان توابا",
  },
  {
    verseId: 0,
    name: "المسد",
    surahId: 111,
    text: "تَبَّتۡ يَدَآ أَبِي لَهَبٖ وَتَبَّ",
    translation: "May the hands of Abu Lahab be ruined, and ruined is he",
    normalizedText: "تبت يدا ابي لهب وتب",
  },
  {
    verseId: 1,
    name: "المسد",
    surahId: 111,
    text: "مَآ أَغۡنَىٰ عَنۡهُ مَالُهُۥ وَمَا كَسَبَ",
    translation: "His wealth will not avail him or that which he gained",
    normalizedText: "ما اغنى عنه ماله وما كسب",
  },
  {
    verseId: 2,
    name: "المسد",
    surahId: 111,
    text: "سَيَصۡلَىٰ نَارٗا ذَاتَ لَهَبٖ",
    translation: "He will [enter to] burn in a Fire of [blazing] flame",
    normalizedText: "سيصلى نارا ذات لهب",
  },
  {
    verseId: 3,
    name: "المسد",
    surahId: 111,
    text: "وَٱمۡرَأَتُهُۥ حَمَّالَةَ ٱلۡحَطَبِ",
    translation: "And his wife [as well] - the carrier of firewood",
    normalizedText: "وامراته حمالة الحطب",
  },
  {
    verseId: 4,
    name: "المسد",
    surahId: 111,
    text: "فِي جِيدِهَا حَبۡلٞ مِّن مَّسَدِۭ",
    translation: "Around her neck is a rope of [twisted] fiber",
    normalizedText: "في جيدها حبل من مسد",
  },
  {
    verseId: 0,
    name: "الإخلاص",
    surahId: 112,
    text: "قُلۡ هُوَ ٱللَّهُ أَحَدٌ",
    translation: 'Say, "He is Allah, [who is] One',
    normalizedText: "قل هو الله احد",
  },
  {
    verseId: 1,
    name: "الإخلاص",
    surahId: 112,
    text: "ٱللَّهُ ٱلصَّمَدُ",
    translation: "Allah, the Eternal Refuge",
    normalizedText: "الله الصمد",
  },
  {
    verseId: 2,
    name: "الإخلاص",
    surahId: 112,
    text: "لَمۡ يَلِدۡ وَلَمۡ يُولَدۡ",
    translation: "He neither begets nor is born",
    normalizedText: "لم يلد ولم يولد",
  },
  {
    verseId: 3,
    name: "الإخلاص",
    surahId: 112,
    text: "وَلَمۡ يَكُن لَّهُۥ كُفُوًا أَحَدُۢ",
    translation: "Nor is there to Him any equivalent",
    normalizedText: "ولم يكن له كفوا احد",
  },
  {
    verseId: 0,
    name: "الفلق",
    surahId: 113,
    text: "قُلۡ أَعُوذُ بِرَبِّ ٱلۡفَلَقِ",
    translation: 'Say, "I seek refuge in the Lord of daybreak',
    normalizedText: "قل اعوذ برب الفلق",
  },
  {
    verseId: 1,
    name: "الفلق",
    surahId: 113,
    text: "مِن شَرِّ مَا خَلَقَ",
    translation: "From the evil of that which He created",
    normalizedText: "من شر ما خلق",
  },
  {
    verseId: 2,
    name: "الفلق",
    surahId: 113,
    text: "وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ",
    translation: "And from the evil of darkness when it settles",
    normalizedText: "ومن شر غاسق اذا وقب",
  },
  {
    verseId: 3,
    name: "الفلق",
    surahId: 113,
    text: "وَمِن شَرِّ ٱلنَّفَّـٰثَٰتِ فِي ٱلۡعُقَدِ",
    translation: "And from the evil of the blowers in knots",
    normalizedText: "ومن شر النفثت في العقد",
  },
  {
    verseId: 4,
    name: "الفلق",
    surahId: 113,
    text: "وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ",
    translation: "And from the evil of an envier when he envies",
    normalizedText: "ومن شر حاسد اذا حسد",
  },
  {
    verseId: 0,
    name: "الناس",
    surahId: 114,
    text: "قُلۡ أَعُوذُ بِرَبِّ ٱلنَّاسِ",
    translation: 'Say, "I seek refuge in the Lord of mankind',
    normalizedText: "قل اعوذ برب الناس",
  },
  {
    verseId: 1,
    name: "الناس",
    surahId: 114,
    text: "مَلِكِ ٱلنَّاسِ",
    translation: "The Sovereign of mankind",
    normalizedText: "ملك الناس",
  },
  {
    verseId: 2,
    name: "الناس",
    surahId: 114,
    text: "إِلَٰهِ ٱلنَّاسِ",
    translation: "The God of mankind",
    normalizedText: "اله الناس",
  },
  {
    verseId: 3,
    name: "الناس",
    surahId: 114,
    text: "مِن شَرِّ ٱلۡوَسۡوَاسِ ٱلۡخَنَّاسِ",
    translation: "From the evil of the retreating whisperer",
    normalizedText: "من شر الوسواس الخناس",
  },
  {
    verseId: 4,
    name: "الناس",
    surahId: 114,
    text: "ٱلَّذِي يُوَسۡوِسُ فِي صُدُورِ ٱلنَّاسِ",
    translation: "Who whispers [evil] into the breasts of mankind",
    normalizedText: "الذي يوسوس في صدور الناس",
  },
  {
    verseId: 5,
    name: "الناس",
    surahId: 114,
    text: "مِنَ ٱلۡجِنَّةِ وَٱلنَّاسِ",
    translation: "From among the jinn and mankind",
    normalizedText: "من الجنة والناس",
  },
];
